
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiread9a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiread9a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("jDfxe", function(module, exports) {

$parcel$export(module.exports, "ConfirmProvider", () => $e4adb5c56cde0dad$export$2245215e6bd26540);
$parcel$export(module.exports, "useConfirm", () => $e4adb5c56cde0dad$export$bf4da147a5964edb);

var $acw62 = parcelRequire("acw62");

var $03kOd = parcelRequire("03kOd");

var $4LdGL = parcelRequire("4LdGL");

var $hHAIz = parcelRequire("hHAIz");

var $23H42 = parcelRequire("23H42");

var $9cB5k = parcelRequire("9cB5k");

var $6hSWk = parcelRequire("6hSWk");

var $kZugz = parcelRequire("kZugz");

var $jzib7 = parcelRequire("jzib7");

var $js9Z9 = parcelRequire("js9Z9");
function $e4adb5c56cde0dad$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e4adb5c56cde0dad$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e4adb5c56cde0dad$var$_defineProperty(e, r, t) {
    return (r = $e4adb5c56cde0dad$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $e4adb5c56cde0dad$var$_extends() {
    return $e4adb5c56cde0dad$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e4adb5c56cde0dad$var$_extends.apply(null, arguments);
}
function $e4adb5c56cde0dad$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = true, o = false;
        try {
            if (i = (t = t.call(r)).next, 0 === l) ;
            else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = true, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e4adb5c56cde0dad$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e4adb5c56cde0dad$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e4adb5c56cde0dad$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e4adb5c56cde0dad$var$ownKeys(Object(t), true).forEach(function(r) {
            $e4adb5c56cde0dad$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e4adb5c56cde0dad$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e4adb5c56cde0dad$var$_slicedToArray(r, e) {
    return $e4adb5c56cde0dad$var$_arrayWithHoles(r) || $e4adb5c56cde0dad$var$_iterableToArrayLimit(r, e) || $e4adb5c56cde0dad$var$_unsupportedIterableToArray(r, e) || $e4adb5c56cde0dad$var$_nonIterableRest();
}
function $e4adb5c56cde0dad$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (undefined !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e4adb5c56cde0dad$var$_toPropertyKey(t) {
    var i = $e4adb5c56cde0dad$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e4adb5c56cde0dad$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e4adb5c56cde0dad$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e4adb5c56cde0dad$var$_arrayLikeToArray(r, a) : undefined;
    }
}
var $e4adb5c56cde0dad$var$ConfirmContext = /*#__PURE__*/ (0, $acw62.createContext)({
    confirmBase: function confirmBase() {
        throw new Error("Missing ConfirmProvider");
    },
    closeOnParentUnmount: function closeOnParentUnmount() {}
});
var $e4adb5c56cde0dad$var$ConfirmationDialog = function ConfirmationDialog(_ref) {
    var open = _ref.open, options = _ref.options, onCancel = _ref.onCancel, onConfirm = _ref.onConfirm, onClose = _ref.onClose;
    var title = options.title, description = options.description, content = options.content, confirmationText = options.confirmationText, cancellationText = options.cancellationText, dialogProps = options.dialogProps, dialogActionsProps = options.dialogActionsProps, confirmationButtonProps = options.confirmationButtonProps, cancellationButtonProps = options.cancellationButtonProps, titleProps = options.titleProps, contentProps = options.contentProps, allowClose = options.allowClose, confirmationKeyword = options.confirmationKeyword, confirmationKeywordTextFieldProps = options.confirmationKeywordTextFieldProps, hideCancelButton = options.hideCancelButton, buttonOrder = options.buttonOrder, acknowledgement = options.acknowledgement, acknowledgementFormControlLabelProps = options.acknowledgementFormControlLabelProps, acknowledgementCheckboxProps = options.acknowledgementCheckboxProps;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(""), _React$useState2 = $e4adb5c56cde0dad$var$_slicedToArray(_React$useState, 2), confirmationKeywordValue = _React$useState2[0], setConfirmationKeywordValue = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false), _React$useState4 = $e4adb5c56cde0dad$var$_slicedToArray(_React$useState3, 2), isAcknowledged = _React$useState4[0], setIsAcknowledged = _React$useState4[1];
    var confirmationButtonDisabled = Boolean(confirmationKeyword && confirmationKeywordValue !== confirmationKeyword || acknowledgement && !isAcknowledged);
    var acknowledgeCheckbox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, acknowledgement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $js9Z9.default), $e4adb5c56cde0dad$var$_extends({}, acknowledgementFormControlLabelProps, {
        control: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jzib7.default), $e4adb5c56cde0dad$var$_extends({}, acknowledgementCheckboxProps, {
            value: isAcknowledged,
            onChange: function onChange(_, value) {
                return setIsAcknowledged(value);
            }
        })),
        label: acknowledgement
    })));
    var confirmationContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, confirmationKeyword && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kZugz.default), $e4adb5c56cde0dad$var$_extends({
        onChange: function onChange(e) {
            return setConfirmationKeywordValue(e.target.value);
        },
        value: confirmationKeywordValue,
        fullWidth: true
    }, confirmationKeywordTextFieldProps)));
    var dialogActions = buttonOrder.map(function(buttonType) {
        if (buttonType === "cancel") return !hideCancelButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03kOd.default), $e4adb5c56cde0dad$var$_extends({
            key: "cancel"
        }, cancellationButtonProps, {
            onClick: onCancel
        }), cancellationText);
        if (buttonType === "confirm") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $03kOd.default), $e4adb5c56cde0dad$var$_extends({
            key: "confirm",
            color: "primary",
            disabled: confirmationButtonDisabled
        }, confirmationButtonProps, {
            onClick: onConfirm
        }), confirmationText);
        throw new Error("Supported button types are only \"confirm\" and \"cancel\", got: ".concat(buttonType));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4LdGL.default), $e4adb5c56cde0dad$var$_extends({
        fullWidth: true
    }, dialogProps, {
        open: open,
        onClose: allowClose ? onClose : null
    }), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6hSWk.default), titleProps, title), content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $23H42.default), contentProps, content, confirmationContent, acknowledgeCheckbox) : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $23H42.default), contentProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9cB5k.default), null, description), confirmationContent, acknowledgeCheckbox) : (confirmationKeyword || acknowledgeCheckbox) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $23H42.default), contentProps, confirmationContent, acknowledgeCheckbox), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hHAIz.default), dialogActionsProps, dialogActions));
};
var $e4adb5c56cde0dad$var$DEFAULT_OPTIONS = {
    title: "Are you sure?",
    description: "",
    content: null,
    confirmationText: "Ok",
    cancellationText: "Cancel",
    dialogProps: {},
    dialogActionsProps: {},
    confirmationButtonProps: {},
    cancellationButtonProps: {},
    titleProps: {},
    contentProps: {},
    allowClose: true,
    confirmationKeywordTextFieldProps: {},
    hideCancelButton: false,
    buttonOrder: [
        "cancel",
        "confirm"
    ],
    acknowledgement: false,
    acknowledgementFormControlLabelProps: {},
    acknowledgementCheckboxProps: {}
};
var $e4adb5c56cde0dad$var$buildOptions = function buildOptions(defaultOptions, options) {
    var dialogProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.dialogProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.dialogProps), options.dialogProps || {});
    var dialogActionsProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.dialogActionsProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.dialogActionsProps), options.dialogActionsProps || {});
    var confirmationButtonProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.confirmationButtonProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.confirmationButtonProps), options.confirmationButtonProps || {});
    var cancellationButtonProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.cancellationButtonProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.cancellationButtonProps), options.cancellationButtonProps || {});
    var titleProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.titleProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.titleProps), options.titleProps || {});
    var contentProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.contentProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.contentProps), options.contentProps || {});
    var confirmationKeywordTextFieldProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.confirmationKeywordTextFieldProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.confirmationKeywordTextFieldProps), options.confirmationKeywordTextFieldProps || {});
    var acknowledgementFormControlLabelProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.acknowledgementFormControlLabelProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.acknowledgementFormControlLabelProps), options.acknowledgementFormControlLabelProps || {});
    var acknowledgementCheckboxProps = $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, defaultOptions.acknowledgementCheckboxProps || $e4adb5c56cde0dad$var$DEFAULT_OPTIONS.acknowledgementCheckboxProps), options.acknowledgementCheckboxProps || {});
    return $e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2($e4adb5c56cde0dad$var$_objectSpread2({}, $e4adb5c56cde0dad$var$DEFAULT_OPTIONS), defaultOptions), options), {}, {
        dialogProps: dialogProps,
        dialogActionsProps: dialogActionsProps,
        confirmationButtonProps: confirmationButtonProps,
        cancellationButtonProps: cancellationButtonProps,
        titleProps: titleProps,
        contentProps: contentProps,
        confirmationKeywordTextFieldProps: confirmationKeywordTextFieldProps,
        acknowledgementFormControlLabelProps: acknowledgementFormControlLabelProps,
        acknowledgementCheckboxProps: acknowledgementCheckboxProps
    });
};
var $e4adb5c56cde0dad$export$715f9d76bb8c1fea;
var $e4adb5c56cde0dad$export$2245215e6bd26540 = function ConfirmProvider(_ref) {
    var children = _ref.children, _ref$defaultOptions = _ref.defaultOptions, defaultOptions = _ref$defaultOptions === undefined ? {} : _ref$defaultOptions, _ref$useLegacyReturn = _ref.useLegacyReturn, useLegacyReturn = _ref$useLegacyReturn === undefined ? false : _ref$useLegacyReturn;
    // State that we clear on close (to avoid dangling references to resolve and
    // reject). If this is null, the dialog is closed.
    var _useState = (0, $acw62.useState)(null), _useState2 = $e4adb5c56cde0dad$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    // Options for rendering the dialog, which aren't reset on close so that we
    // keep rendering the same modal during close animation
    var _useState3 = (0, $acw62.useState)({}), _useState4 = $e4adb5c56cde0dad$var$_slicedToArray(_useState3, 2), options = _useState4[0], setOptions = _useState4[1];
    var _useState5 = (0, $acw62.useState)(0), _useState6 = $e4adb5c56cde0dad$var$_slicedToArray(_useState5, 2), key = _useState6[0], setKey = _useState6[1];
    var confirmBase = (0, $acw62.useCallback)(function(parentId) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var promise = new Promise(function(resolve, _reject) {
            setKey(function(key) {
                return key + 1;
            });
            setOptions(options);
            setState({
                resolve: resolve,
                parentId: parentId
            });
        });
        // Converts the promise into the legacy promise from v3
        if (useLegacyReturn) return new Promise(function(resolve, reject) {
            promise.then(function(_ref2) {
                var confirmed = _ref2.confirmed, reason = _ref2.reason;
                if (confirmed === true && reason === "confirm") resolve();
                if (confirmed === false && reason === "cancel") reject();
            });
        });
        return promise;
    }, [
        useLegacyReturn
    ]);
    var closeOnParentUnmount = (0, $acw62.useCallback)(function(parentId) {
        setState(function(state) {
            if (state && state.parentId === parentId) {
                state && state.resolve({
                    confirmed: false,
                    reason: "unmount"
                });
                return null;
            } else return state;
        });
    }, []);
    var handleClose = (0, $acw62.useCallback)(function() {
        setState(function(state) {
            state && state.resolve({
                confirmed: false,
                reason: "natural"
            });
            return null;
        });
    }, []);
    var handleCancel = (0, $acw62.useCallback)(function() {
        setState(function(state) {
            state && state.resolve({
                confirmed: false,
                reason: "cancel"
            });
            return null;
        });
    }, []);
    var handleConfirm = (0, $acw62.useCallback)(function() {
        setState(function(state) {
            state && state.resolve({
                confirmed: true,
                reason: "confirm"
            });
            return null;
        });
    }, []);
    $e4adb5c56cde0dad$export$715f9d76bb8c1fea = (0, $acw62.useCallback)(function(options) {
        return confirmBase("global", options);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4adb5c56cde0dad$var$ConfirmContext.Provider, {
        value: {
            confirmBase: confirmBase,
            closeOnParentUnmount: closeOnParentUnmount
        }
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e4adb5c56cde0dad$var$ConfirmationDialog, {
        key: key,
        open: state !== null,
        options: $e4adb5c56cde0dad$var$buildOptions(defaultOptions, options !== null && options !== undefined ? options : {}),
        onClose: handleClose,
        onCancel: handleCancel,
        onConfirm: handleConfirm
    }));
};
var $e4adb5c56cde0dad$var$idCounter = 0;
var $e4adb5c56cde0dad$var$useConfirmId = function useConfirmId() {
    var id = (0, $acw62.useMemo)(function() {
        return $e4adb5c56cde0dad$var$idCounter++;
    }, []);
    return "confirm-".concat(id);
};
var $e4adb5c56cde0dad$export$bf4da147a5964edb = function useConfirm() {
    var parentId = $e4adb5c56cde0dad$var$useConfirmId();
    var _useContext = (0, $acw62.useContext)($e4adb5c56cde0dad$var$ConfirmContext), confirmBase = _useContext.confirmBase, closeOnParentUnmount = _useContext.closeOnParentUnmount;
    var confirm = (0, $acw62.useCallback)(function(options) {
        return confirmBase(parentId, options);
    }, [
        parentId
    ]);
    // When the component calling useConfirm is unmounted, we automatically
    // close the associated confirmation dialog. Note that we use a
    // unique id per each useConfirm usage, so that we don't close the
    // dialog when an unrelated component unmounts
    (0, $acw62.useEffect)(function() {
        return function() {
            closeOnParentUnmount(parentId);
        };
    }, [
        parentId
    ]);
    return confirm;
};

});
parcelRegister("03kOd", function(module, exports) {

$parcel$export(module.exports, "default", () => $00a06c270f3ebd57$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4FZD0 = parcelRequire("4FZD0");

var $8Indx = parcelRequire("8Indx");

var $70SAr = parcelRequire("70SAr");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $2TZUE = parcelRequire("2TZUE");

var $4mI0b = parcelRequire("4mI0b");

var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $2qneh = parcelRequire("2qneh");

var $238Rl = parcelRequire("238Rl");

var $hbLi5 = parcelRequire("hbLi5");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $00a06c270f3ebd57$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $3AM7p.default)(color)}`,
            `size${(0, $3AM7p.default)(size)}`,
            `${variant}Size${(0, $3AM7p.default)(size)}`,
            `color${(0, $3AM7p.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $3AM7p.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $3AM7p.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $3AM7p.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $2qneh.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $00a06c270f3ebd57$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $00a06c270f3ebd57$var$ButtonRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3AM7p.default)(ownerState.color)}`],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $2qneh.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $2qneh.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $2qneh.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $2qneh.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $2qneh.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $2qneh.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $2qneh.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $00a06c270f3ebd57$var$ButtonStartIcon = (0, $1Ikg4.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonEndIcon = (0, $1Ikg4.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIndicator = (0, $1Ikg4.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder = (0, $1Ikg4.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $00a06c270f3ebd57$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $238Rl.default));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $hbLi5.default));
    const resolvedProps = (0, $4FZD0.default)(contextProps, inProps);
    const props = (0, $2nO41.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $70SAr.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $00a06c270f3ebd57$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($00a06c270f3ebd57$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($00a06c270f3ebd57$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $00a06c270f3ebd57$export$2e2bcd8739ae039 = $00a06c270f3ebd57$var$Button;

});
parcelRegister("9QePP", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});

parcelRegister("4FZD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $367acbd429e20ec9$export$2e2bcd8739ae039);

var $9QePP = parcelRequire("9QePP");
function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $9QePP.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});

parcelRegister("8Indx", function(module, exports) {

$parcel$export(module.exports, "default", () => $65847140631d74af$export$2e2bcd8739ae039);
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("70SAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51b2e046136200b6$export$2e2bcd8739ae039);

var $auC0X = parcelRequire("auC0X");
'use client';
var $51b2e046136200b6$export$2e2bcd8739ae039 = (0, $auC0X.default);

});
parcelRegister("auC0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a3a319e7e555608$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $7a3a319e7e555608$var$safeReact = {
    ...$acw62
};
const $7a3a319e7e555608$var$maybeReactUseId = $7a3a319e7e555608$var$safeReact.useId;
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}

});


parcelRegister("aXkRG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9f996b464e1691$export$2e2bcd8739ae039);

var $9HGIl = parcelRequire("9HGIl");
const $7f9f996b464e1691$var$rootShouldForwardProp = (prop)=>(0, $9HGIl.default)(prop) && prop !== 'classes';
var $7f9f996b464e1691$export$2e2bcd8739ae039 = $7f9f996b464e1691$var$rootShouldForwardProp;

});
parcelRegister("9HGIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7109435727661db9$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $7109435727661db9$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $7109435727661db9$export$2e2bcd8739ae039 = $7109435727661db9$var$slotShouldForwardProp;

});


parcelRegister("1Ikg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f99d5fb06222df$export$2e2bcd8739ae039);

var $dgmWB = parcelRequire("dgmWB");

var $e7sAA = parcelRequire("e7sAA");

var $bXtHQ = parcelRequire("bXtHQ");

var $aXkRG = parcelRequire("aXkRG");

'use client';
const $13f99d5fb06222df$var$styled = (0, $dgmWB.default)({
    themeId: (0, $bXtHQ.default),
    defaultTheme: $e7sAA.default,
    rootShouldForwardProp: $aXkRG.default
});
var $13f99d5fb06222df$export$2e2bcd8739ae039 = $13f99d5fb06222df$var$styled;

});
parcelRegister("dgmWB", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $9a7e913a82f46e5c$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $9a7e913a82f46e5c$export$2e2bcd8739ae039);

var $8TaLX = parcelRequire("8TaLX");

var $3z1Ay = parcelRequire("3z1Ay");

var $gxvzd = parcelRequire("gxvzd");

var $eWm0o = parcelRequire("eWm0o");

var $6o2lr = parcelRequire("6o2lr");

var $9dZwz = parcelRequire("9dZwz");

var $aFFCY = parcelRequire("aFFCY");
const $9a7e913a82f46e5c$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $9a7e913a82f46e5c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $9a7e913a82f46e5c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $9a7e913a82f46e5c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9a7e913a82f46e5c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9a7e913a82f46e5c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9a7e913a82f46e5c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $8TaLX.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $9a7e913a82f46e5c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $8TaLX.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $8TaLX.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $9a7e913a82f46e5c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $8TaLX.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $8TaLX.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $9a7e913a82f46e5c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9a7e913a82f46e5c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $8TaLX.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $9dZwz.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9a7e913a82f46e5c$var$defaultOverridesResolver($9a7e913a82f46e5c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9a7e913a82f46e5c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9a7e913a82f46e5c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $8TaLX.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $9a7e913a82f46e5c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $3z1Ay.isPlainObject)(style)) {
                const serialized = (0, $aFFCY.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $9a7e913a82f46e5c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $9a7e913a82f46e5c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9a7e913a82f46e5c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9a7e913a82f46e5c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $9dZwz.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9a7e913a82f46e5c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $gxvzd.default)(componentSlot || '')}`;
    return `Styled(${(0, $eWm0o.default)(tag)})`;
}
function $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9a7e913a82f46e5c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9a7e913a82f46e5c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9a7e913a82f46e5c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("8TaLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $678bd0f6619332de$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_mutateStyles", () => $678bd0f6619332de$export$592c7226e4cb0171);
$parcel$export(module.exports, "internal_serializeStyles", () => $678bd0f6619332de$export$13a2d3ef13012b32);
/**
 * @mui/styled-engine v7.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1Bnx5 = parcelRequire("1Bnx5");

var $jk4Cs = parcelRequire("jk4Cs");

var $8zogs = parcelRequire("8zogs");
var $k7M2x = parcelRequire("k7M2x");


var $f5O3L = parcelRequire("f5O3L");
'use client';
function $678bd0f6619332de$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $1Bnx5.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $678bd0f6619332de$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $678bd0f6619332de$var$wrapper = [];
function $678bd0f6619332de$export$13a2d3ef13012b32(styles) {
    $678bd0f6619332de$var$wrapper[0] = styles;
    return (0, $jk4Cs.serializeStyles)($678bd0f6619332de$var$wrapper);
}

});
parcelRegister("1Bnx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $12ab803fa905d303$export$2e2bcd8739ae039);
parcelRequire("fsVeJ");
parcelRequire("acw62");
parcelRequire("gd942");

var $8jRlF = parcelRequire("8jRlF");

parcelRequire("2Hahg");
parcelRequire("cqnxX");
parcelRequire("2cQcJ");
var $12ab803fa905d303$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $12ab803fa905d303$var$newStyled = (0, $8jRlF.default).bind();
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $12ab803fa905d303$var$newStyled[tagName] = $12ab803fa905d303$var$newStyled(tagName);
});
var $12ab803fa905d303$export$2e2bcd8739ae039 = $12ab803fa905d303$var$newStyled;

});
parcelRegister("fsVeJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b425de8cd413f5b0$export$2e2bcd8739ae039);
function $b425de8cd413f5b0$export$2e2bcd8739ae039() {
    $b425de8cd413f5b0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b425de8cd413f5b0$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$var$isPropValid = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = $bcd4e42ca4163639$var$isPropValid;

});
parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$var$memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $6bb1e54ce1bc6efa$export$2e2bcd8739ae039 = $6bb1e54ce1bc6efa$var$memoize;

});


parcelRegister("8jRlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $60e97af874e8cdaa$export$2e2bcd8739ae039);

var $fsVeJ = parcelRequire("fsVeJ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
parcelRequire("8zogs");
var $k7M2x = parcelRequire("k7M2x");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$var$createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $k7M2x.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = (0, $acw62.useContext)((0, $k7M2x.T));
            }
            if (typeof props.className === 'string') className = (0, $2Hahg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $cqnxX.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ (0, $acw62.createElement)(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $fsVeJ.default)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = $60e97af874e8cdaa$var$createStyled;

});
parcelRegister("8zogs", function(module, exports) {

$parcel$export(module.exports, "Global", () => $63d46a01db878c10$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $63d46a01db878c10$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $63d46a01db878c10$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("k7M2x")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("k7M2x")).w);

var $acw62 = parcelRequire("acw62");
parcelRequire("lDTld");

var $k7M2x = parcelRequire("k7M2x");
parcelRequire("8sAjZ");
parcelRequire("iq6RI");
parcelRequire("9ORqK");


var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $63d46a01db878c10$var$pkg = {
    name: "@emotion/react",
    version: "11.10.6",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.js",
        "macro.d.ts",
        "macro.js.flow"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.10.6",
        "@emotion/cache": "^11.10.5",
        "@emotion/serialize": "^1.1.1",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
        "@emotion/utils": "^1.2.0",
        "@emotion/weak-memoize": "^0.3.0",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.10.6",
        "@emotion/css-prettifier": "1.1.1",
        "@emotion/server": "11.10.0",
        "@emotion/styled": "11.10.6",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": "./macro.js"
            }
        }
    }
};
var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $k7M2x.h).call(props, 'css')) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $k7M2x.E);
    createElementArgArray[1] = (0, $k7M2x.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $63d46a01db878c10$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $k7M2x.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cqnxX.serializeStyles)([
        styles
    ], undefined, (0, $acw62.useContext)((0, $k7M2x.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = (0, $acw62.useRef)();
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2cQcJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $2Hahg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cqnxX.serializeStyles)(args);
}
var $63d46a01db878c10$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $2Hahg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)var res = (0, $2Hahg.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $k7M2x.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cqnxX.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $2Hahg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: (0, $acw62.useContext)((0, $k7M2x.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d46a01db878c10$var$isBrowser, $63d46a01db878c10$var$isTestEnv, $63d46a01db878c10$var$globalContext, $63d46a01db878c10$var$globalKey;

});
parcelRegister("lDTld", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc182b1f84212d3f$export$2e2bcd8739ae039);

var $eKcB0 = parcelRequire("eKcB0");

var $l1TOA = parcelRequire("l1TOA");
var $8609H = parcelRequire("8609H");
var $4IiZl = parcelRequire("4IiZl");
var $jWFyL = parcelRequire("jWFyL");
var $fWft0 = parcelRequire("fWft0");
var $chXnR = parcelRequire("chXnR");
parcelRequire("iq6RI");
parcelRequire("9ffXE");
var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $l1TOA.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $l1TOA.token)(character)) break;
        (0, $l1TOA.next)();
    }
    return (0, $l1TOA.slice)(begin, (0, $l1TOA.position));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $l1TOA.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $l1TOA.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $l1TOA.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $l1TOA.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $l1TOA.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $8609H.from)(character);
    }
    while (character = (0, $l1TOA.next)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $l1TOA.dealloc)($fc182b1f84212d3f$var$toRules((0, $l1TOA.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $fc182b1f84212d3f$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $fc182b1f84212d3f$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($fc182b1f84212d3f$var$ignoreFlag) > -1;
};
var $fc182b1f84212d3f$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($fc182b1f84212d3f$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $fc182b1f84212d3f$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $fc182b1f84212d3f$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$fc182b1f84212d3f$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $fc182b1f84212d3f$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $fc182b1f84212d3f$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$fc182b1f84212d3f$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    } else if ($fc182b1f84212d3f$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $fc182b1f84212d3f$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $8609H.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $jWFyL.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $jWFyL.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MOZ) + value + (0, $jWFyL.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + value + value;
        // order
        case 6165:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $jWFyL.WEBKIT) + value + (0, $8609H.replace)(value, /(\w+).+(:[^]+)/, (0, $jWFyL.WEBKIT) + 'box-$1$2' + (0, $jWFyL.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-item-' + (0, $8609H.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-line-pack' + (0, $8609H.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $jWFyL.WEBKIT) + 'box-' + (0, $8609H.replace)(value, '-grow', '') + (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $jWFyL.WEBKIT) + (0, $8609H.replace)(value, /([^-])(transform)/g, '$1' + (0, $jWFyL.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $8609H.replace)((0, $8609H.replace)((0, $8609H.replace)(value, /(zoom-|grab)/, (0, $jWFyL.WEBKIT) + '$1'), /(image-set)/, (0, $jWFyL.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8609H.replace)(value, /(image-set\([^]*)/, (0, $jWFyL.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $8609H.replace)((0, $8609H.replace)(value, /(.+:)(flex-)?(.*)/, (0, $jWFyL.WEBKIT) + 'box-pack:$3' + (0, $jWFyL.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $jWFyL.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8609H.replace)(value, /(.+)-inline(.+)/, (0, $jWFyL.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8609H.strlen)(value) - 1 - length > 6) switch((0, $8609H.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8609H.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8609H.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $jWFyL.WEBKIT) + '$2-$3' + '$1' + (0, $jWFyL.MOZ) + ((0, $8609H.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8609H.indexof)(value, 'stretch') ? $fc182b1f84212d3f$var$prefix((0, $8609H.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $8609H.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $8609H.charat)(value, (0, $8609H.strlen)(value) - 3 - (~(0, $8609H.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $8609H.replace)(value, ':', ':' + (0, $jWFyL.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $8609H.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $jWFyL.WEBKIT) + ((0, $8609H.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $jWFyL.WEBKIT) + '$2$3' + '$1' + (0, $jWFyL.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $8609H.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $jWFyL.DECLARATION:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $jWFyL.KEYFRAMES:
                return (0, $chXnR.serialize)([
                    (0, $l1TOA.copy)(element, {
                        value: (0, $8609H.replace)(element.value, '@', '@' + (0, $jWFyL.WEBKIT))
                    })
                ], callback);
            case 0, $jWFyL.RULESET:
                if (element.length) return (0, $8609H.combine)(element.props, function(value) {
                    switch((0, $8609H.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $chXnR.serialize)([
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(read-\w+)/, ':' + (0, $jWFyL.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $chXnR.serialize)([
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, ':' + (0, $jWFyL.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, ':' + (0, $jWFyL.MOZ) + '$1')
                                    ]
                                }),
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, (0, $jWFyL.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$var$createCache = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $chXnR.stringify),
        (0, $fWft0.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $fWft0.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $chXnR.serialize)((0, $4IiZl.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $eKcB0.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = $fc182b1f84212d3f$var$createCache;

});
parcelRegister("eKcB0", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $abbf21dc6f14b965$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $abbf21dc6f14b965$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $abbf21dc6f14b965$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $abbf21dc6f14b965$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($abbf21dc6f14b965$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $abbf21dc6f14b965$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("l1TOA", function(module, exports) {

$parcel$export(module.exports, "position", () => $f4f4fca9115ed8bd$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $f4f4fca9115ed8bd$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $f4f4fca9115ed8bd$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $f4f4fca9115ed8bd$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $f4f4fca9115ed8bd$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $f4f4fca9115ed8bd$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $f4f4fca9115ed8bd$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $f4f4fca9115ed8bd$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $f4f4fca9115ed8bd$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $f4f4fca9115ed8bd$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $f4f4fca9115ed8bd$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $f4f4fca9115ed8bd$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $f4f4fca9115ed8bd$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $f4f4fca9115ed8bd$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $f4f4fca9115ed8bd$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $f4f4fca9115ed8bd$export$4254d4e2b3745c4c);

var $8609H = parcelRequire("8609H");
var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $8609H.assign)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $8609H.charat)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $8609H.charat)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $8609H.charat)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $8609H.substr)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $8609H.strlen)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $8609H.trim)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $8609H.append)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $8609H.append)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $8609H.append)((0, $8609H.from)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $8609H.from)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

});
parcelRegister("8609H", function(module, exports) {

$parcel$export(module.exports, "abs", () => $5e4f012072913cb4$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $5e4f012072913cb4$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $5e4f012072913cb4$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $5e4f012072913cb4$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $5e4f012072913cb4$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $5e4f012072913cb4$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $5e4f012072913cb4$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $5e4f012072913cb4$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $5e4f012072913cb4$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $5e4f012072913cb4$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $5e4f012072913cb4$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $5e4f012072913cb4$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $5e4f012072913cb4$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $5e4f012072913cb4$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("4IiZl", function(module, exports) {

$parcel$export(module.exports, "compile", () => $36ea00327b41abe1$export$ef7acd7185315e22);

var $jWFyL = parcelRequire("jWFyL");

var $8609H = parcelRequire("8609H");

var $l1TOA = parcelRequire("l1TOA");
function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $l1TOA.dealloc)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $l1TOA.alloc)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $l1TOA.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $8609H.charat)(characters, length - 1) == 58) {
                if ((0, $8609H.indexof)(characters += (0, $8609H.replace)((0, $l1TOA.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $l1TOA.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $l1TOA.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $l1TOA.escaping)((0, $l1TOA.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $l1TOA.peek)()){
                case 42:
                case 47:
                    (0, $8609H.append)($36ea00327b41abe1$export$4a34f930e789283c((0, $l1TOA.commenter)((0, $l1TOA.next)(), (0, $l1TOA.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $8609H.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (property > 0 && (0, $8609H.strlen)(characters) - length) (0, $8609H.append)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $8609H.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $8609H.append)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $8609H.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d m s
                            case 100:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $8609H.append)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $8609H.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $l1TOA.prev)() == 125) continue;
            }
            switch(characters += (0, $8609H.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $8609H.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $l1TOA.peek)() === 45) characters += (0, $l1TOA.delimit)((0, $l1TOA.next)());
                    atrule = (0, $l1TOA.peek)(), offset = length = (0, $8609H.strlen)(type = characters += (0, $l1TOA.identifier)((0, $l1TOA.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $8609H.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $8609H.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $8609H.substr)(value, post + 1, post = (0, $8609H.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $8609H.trim)(j > 0 ? rule[x] + ' ' + y : (0, $8609H.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $l1TOA.node)(value, root, parent, offset === 0 ? (0, $jWFyL.RULESET) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $l1TOA.node)(value, root, parent, (0, $jWFyL.COMMENT), (0, $8609H.from)((0, $l1TOA.char)()), (0, $8609H.substr)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $l1TOA.node)(value, root, parent, (0, $jWFyL.DECLARATION), (0, $8609H.substr)(value, 0, length), (0, $8609H.substr)(value, length + 1, -1), length);
}

});
parcelRegister("jWFyL", function(module, exports) {

$parcel$export(module.exports, "MS", () => $e853ac0080e24cb4$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $e853ac0080e24cb4$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $e853ac0080e24cb4$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $e853ac0080e24cb4$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $e853ac0080e24cb4$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $e853ac0080e24cb4$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $e853ac0080e24cb4$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $e853ac0080e24cb4$export$b44a8529a35fcb60);
var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';

});


parcelRegister("fWft0", function(module, exports) {

$parcel$export(module.exports, "middleware", () => $b9a8452e0aabfcf6$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $b9a8452e0aabfcf6$export$38bcb760f1d4871c);

var $jWFyL = parcelRequire("jWFyL");

var $8609H = parcelRequire("8609H");

var $l1TOA = parcelRequire("l1TOA");

var $chXnR = parcelRequire("chXnR");

var $gkGIy = parcelRequire("gkGIy");
function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $8609H.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $jWFyL.DECLARATION:
                element.return = (0, $gkGIy.prefix)(element.value, element.length, children);
                return;
            case 0, $jWFyL.KEYFRAMES:
                return (0, $chXnR.serialize)([
                    (0, $l1TOA.copy)(element, {
                        value: (0, $8609H.replace)(element.value, '@', '@' + (0, $jWFyL.WEBKIT))
                    })
                ], callback);
            case 0, $jWFyL.RULESET:
                if (element.length) return (0, $8609H.combine)(element.props, function(value) {
                    switch((0, $8609H.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $chXnR.serialize)([
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(read-\w+)/, ':' + (0, $jWFyL.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $chXnR.serialize)([
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, ':' + (0, $jWFyL.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, ':' + (0, $jWFyL.MOZ) + '$1')
                                    ]
                                }),
                                (0, $l1TOA.copy)(element, {
                                    props: [
                                        (0, $8609H.replace)(value, /:(plac\w+)/, (0, $jWFyL.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $jWFyL.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $8609H.combine)((0, $l1TOA.tokenize)(value), function(value, index, children) {
                    switch((0, $8609H.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $8609H.substr)(value, 1, (0, $8609H.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $8609H.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $8609H.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $8609H.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("chXnR", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $8f2522f8594faa86$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $8f2522f8594faa86$export$fac44ee5b035f737);

var $jWFyL = parcelRequire("jWFyL");

var $8609H = parcelRequire("8609H");
function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $8609H.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $jWFyL.IMPORT:
        case 0, $jWFyL.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $jWFyL.COMMENT:
            return '';
        case 0, $jWFyL.KEYFRAMES:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $jWFyL.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $8609H.strlen)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("gkGIy", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $be3fa667258f7944$export$82e9f45cca5ba907);

var $jWFyL = parcelRequire("jWFyL");

var $8609H = parcelRequire("8609H");
function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $8609H.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $jWFyL.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $jWFyL.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $jWFyL.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MOZ) + value + (0, $jWFyL.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $8609H.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + value + value;
        // order
        case 6165:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $jWFyL.WEBKIT) + value + (0, $8609H.replace)(value, /(\w+).+(:[^]+)/, (0, $jWFyL.WEBKIT) + 'box-$1$2' + (0, $jWFyL.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-item-' + (0, $8609H.replace)(value, /flex-|-self/g, '') + (!(0, $8609H.match)(value, /flex-|baseline/) ? (0, $jWFyL.MS) + 'grid-row-' + (0, $8609H.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + 'flex-line-pack' + (0, $8609H.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $jWFyL.WEBKIT) + 'box-' + (0, $8609H.replace)(value, '-grow', '') + (0, $jWFyL.WEBKIT) + value + (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $jWFyL.WEBKIT) + (0, $8609H.replace)(value, /([^-])(transform)/g, '$1' + (0, $jWFyL.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $8609H.replace)((0, $8609H.replace)((0, $8609H.replace)(value, /(zoom-|grab)/, (0, $jWFyL.WEBKIT) + '$1'), /(image-set)/, (0, $jWFyL.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $8609H.replace)(value, /(image-set\([^]*)/, (0, $jWFyL.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $8609H.replace)((0, $8609H.replace)(value, /(.+:)(flex-)?(.*)/, (0, $jWFyL.WEBKIT) + 'box-pack:$3' + (0, $jWFyL.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $jWFyL.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $8609H.match)(value, /flex-|baseline/)) return (0, $jWFyL.MS) + 'grid-column-align' + (0, $8609H.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $jWFyL.MS) + (0, $8609H.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $8609H.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $8609H.indexof)(value + (children = children[length].value), 'span') ? value : (0, $jWFyL.MS) + (0, $8609H.replace)(value, '-start', '') + value + (0, $jWFyL.MS) + 'grid-row-span:' + (~(0, $8609H.indexof)(children, 'span') ? (0, $8609H.match)(children, /\d+/) : +(0, $8609H.match)(children, /\d+/) - +(0, $8609H.match)(value, /\d+/)) + ';';
            return (0, $jWFyL.MS) + (0, $8609H.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $8609H.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $jWFyL.MS) + (0, $8609H.replace)((0, $8609H.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $8609H.replace)(value, /(.+)-inline(.+)/, (0, $jWFyL.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $8609H.strlen)(value) - 1 - length > 6) switch((0, $8609H.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $8609H.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $8609H.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $jWFyL.WEBKIT) + '$2-$3' + '$1' + (0, $jWFyL.MOZ) + ((0, $8609H.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $8609H.indexof)(value, 'stretch') ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $8609H.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $8609H.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $jWFyL.MS) + a + ':' + b + f + (c ? (0, $jWFyL.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $8609H.charat)(value, length + 6) === 121) return (0, $8609H.replace)(value, ':', ':' + (0, $jWFyL.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $8609H.charat)(value, (0, $8609H.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $8609H.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $jWFyL.WEBKIT) + ((0, $8609H.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $jWFyL.WEBKIT) + '$2$3' + '$1' + (0, $jWFyL.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $8609H.replace)(value, ':', ':' + (0, $jWFyL.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $8609H.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = $d68ffb0773f38e18$var$weakMemoize;

});


parcelRegister("k7M2x", function(module, exports) {

$parcel$export(module.exports, "h", () => $ea69b9ccc73b096b$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $ea69b9ccc73b096b$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $ea69b9ccc73b096b$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $ea69b9ccc73b096b$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $lDTld = parcelRequire("lDTld");

var $8sAjZ = parcelRequire("8sAjZ");

var $iq6RI = parcelRequire("iq6RI");

var $kKN31 = parcelRequire("kKN31");

var $2Hahg = parcelRequire("2Hahg");

var $cqnxX = parcelRequire("cqnxX");

var $2cQcJ = parcelRequire("2cQcJ");
var $ea69b9ccc73b096b$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $ea69b9ccc73b096b$var$EmotionCacheContext = /* #__PURE__ */ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $lDTld.default)({
    key: 'css'
}) : null);
var $ea69b9ccc73b096b$export$e7094788287c5e9b = $ea69b9ccc73b096b$var$EmotionCacheContext.Provider;
var $ea69b9ccc73b096b$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
};
var $ea69b9ccc73b096b$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($ea69b9ccc73b096b$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $ea69b9ccc73b096b$export$971d5caa766a69d7 = /* #__PURE__ */ (0, $acw62.createContext)({});
var $ea69b9ccc73b096b$export$3b14a55fb2447963 = function useTheme() {
    return (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
};
var $ea69b9ccc73b096b$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8sAjZ.default)({}, outerTheme, theme);
};
var $ea69b9ccc73b096b$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $ea69b9ccc73b096b$var$getTheme(outerTheme, theme);
    });
});
var $ea69b9ccc73b096b$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $ea69b9ccc73b096b$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $ea69b9ccc73b096b$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7);
        return /*#__PURE__*/ (0, $acw62.createElement)(Component, (0, $8sAjZ.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $kKN31.default)(WithTheme, Component);
}
var $ea69b9ccc73b096b$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $ea69b9ccc73b096b$var$getLastPart(match[1]);
    return undefined;
};
var $ea69b9ccc73b096b$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $ea69b9ccc73b096b$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $ea69b9ccc73b096b$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $ea69b9ccc73b096b$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($ea69b9ccc73b096b$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $ea69b9ccc73b096b$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $ea69b9ccc73b096b$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $ea69b9ccc73b096b$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $ea69b9ccc73b096b$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$ea69b9ccc73b096b$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $ea69b9ccc73b096b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $2Hahg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2cQcJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $2Hahg.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $ea69b9ccc73b096b$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $ea69b9ccc73b096b$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$ea69b9ccc73b096b$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $2Hahg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cqnxX.serializeStyles)(registeredStyles, undefined, (0, $acw62.useContext)($ea69b9ccc73b096b$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($ea69b9ccc73b096b$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $ea69b9ccc73b096b$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)($ea69b9ccc73b096b$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ (0, $acw62.createElement)(WrappedComponent, newProps));
});

});
parcelRegister("8sAjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $628d1cf039ec98d7$export$2e2bcd8739ae039);
function $628d1cf039ec98d7$export$2e2bcd8739ae039() {
    $628d1cf039ec98d7$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $628d1cf039ec98d7$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("kKN31", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1be2661c8fac766$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$var$hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};
var $f1be2661c8fac766$export$2e2bcd8739ae039 = $f1be2661c8fac766$var$hoistNonReactStatics;

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("2Hahg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $1f6791d0a193b918$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $1f6791d0a193b918$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $1f6791d0a193b918$export$6f077d94b33a01aa);
var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cqnxX", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $90ba2da1f62e5f1b$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $90ba2da1f62e5f1b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $90ba2da1f62e5f1b$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $90ba2da1f62e5f1b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $90ba2da1f62e5f1b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $90ba2da1f62e5f1b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $90ba2da1f62e5f1b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $90ba2da1f62e5f1b$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $90ba2da1f62e5f1b$var$isCustomProperty(styleName) ? styleName : styleName.replace($90ba2da1f62e5f1b$var$hyphenateRegex, '-$&').toLowerCase();
});
var $90ba2da1f62e5f1b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($90ba2da1f62e5f1b$var$animationRegex, function(match, p1, p2) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$90ba2da1f62e5f1b$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $90ba2da1f62e5f1b$var$contentValuePattern, $90ba2da1f62e5f1b$var$contentValues, $90ba2da1f62e5f1b$var$oldProcessStyleValue, $90ba2da1f62e5f1b$var$msPattern, $90ba2da1f62e5f1b$var$hyphenPattern, $90ba2da1f62e5f1b$var$hyphenatedCache;
var $90ba2da1f62e5f1b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $90ba2da1f62e5f1b$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $90ba2da1f62e5f1b$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $90ba2da1f62e5f1b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $90ba2da1f62e5f1b$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $90ba2da1f62e5f1b$var$cursor;
                var result = interpolation(mergedProps);
                $90ba2da1f62e5f1b$var$cursor = previousCursor;
                return $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $90ba2da1f62e5f1b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($90ba2da1f62e5f1b$var$isProcessableValue(value)) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($90ba2da1f62e5f1b$var$isProcessableValue(value[_i])) string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + $90ba2da1f62e5f1b$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $90ba2da1f62e5f1b$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $90ba2da1f62e5f1b$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $90ba2da1f62e5f1b$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $90ba2da1f62e5f1b$var$cursor;
var $90ba2da1f62e5f1b$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $90ba2da1f62e5f1b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $90ba2da1f62e5f1b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $90ba2da1f62e5f1b$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $90ba2da1f62e5f1b$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $90ba2da1f62e5f1b$var$cursor
    };
};

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $3629985b3ecf741f$export$2e2bcd8739ae039 = $3629985b3ecf741f$var$murmur2;

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $936be3b045ab836e$export$2e2bcd8739ae039 = $936be3b045ab836e$var$unitlessKeys;

});


parcelRegister("2cQcJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $19b532704a3a90e7$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $19b532704a3a90e7$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || (0, $acw62.useLayoutEffect);

});





parcelRegister("jk4Cs", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $e11377e40c120d9b$export$6321afa313b251b5);

var $gfaow = parcelRequire("gfaow");

var $dFwYp = parcelRequire("dFwYp");

var $gP9xJ = parcelRequire("gP9xJ");
var $e11377e40c120d9b$var$isDevelopment = false;
var $e11377e40c120d9b$var$hyphenateRegex = /[A-Z]|^ms/g;
var $e11377e40c120d9b$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $e11377e40c120d9b$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $e11377e40c120d9b$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $e11377e40c120d9b$var$processStyleName = /* #__PURE__ */ (0, $gP9xJ.default)(function(styleName) {
    return $e11377e40c120d9b$var$isCustomProperty(styleName) ? styleName : styleName.replace($e11377e40c120d9b$var$hyphenateRegex, '-$&').toLowerCase();
});
var $e11377e40c120d9b$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($e11377e40c120d9b$var$animationRegex, function(match, p1, p2) {
                $e11377e40c120d9b$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $e11377e40c120d9b$var$cursor
                };
                return p1;
            });
    }
    if ((0, $dFwYp.default)[key] !== 1 && !$e11377e40c120d9b$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $e11377e40c120d9b$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $e11377e40c120d9b$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $e11377e40c120d9b$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $e11377e40c120d9b$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $e11377e40c120d9b$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $e11377e40c120d9b$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $e11377e40c120d9b$var$cursor;
                var result = interpolation(mergedProps);
                $e11377e40c120d9b$var$cursor = previousCursor;
                return $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $e11377e40c120d9b$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($e11377e40c120d9b$var$isProcessableValue(asString)) string += $e11377e40c120d9b$var$processStyleName(key) + ":" + $e11377e40c120d9b$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $e11377e40c120d9b$var$isDevelopment) throw new Error($e11377e40c120d9b$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($e11377e40c120d9b$var$isProcessableValue(value[_i])) string += $e11377e40c120d9b$var$processStyleName(key) + ":" + $e11377e40c120d9b$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $e11377e40c120d9b$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $e11377e40c120d9b$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $e11377e40c120d9b$var$cursor;
function $e11377e40c120d9b$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $e11377e40c120d9b$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $e11377e40c120d9b$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $e11377e40c120d9b$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $e11377e40c120d9b$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $gfaow.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $e11377e40c120d9b$var$cursor
    };
}

});
parcelRegister("gfaow", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd361c3039671a94$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $bd361c3039671a94$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("dFwYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f38ae7eb73da667$export$2e2bcd8739ae039);
var $9f38ae7eb73da667$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("gP9xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f8cfd5e85c6f30$export$2e2bcd8739ae039);
function $c3f8cfd5e85c6f30$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("f5O3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $afce2778e79e00d1$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $8zogs = parcelRequire("8zogs");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $afce2778e79e00d1$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $afce2778e79e00d1$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($afce2778e79e00d1$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8zogs.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("3z1Ay", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $2985df77ba145d35$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $2985df77ba145d35$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $19Aa2 = parcelRequire("19Aa2");
function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $19Aa2.isValidElementType)(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $19Aa2.isValidElementType)(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("19Aa2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gijsP"));

});
parcelRegister("gijsP", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $bdcd6ced2cdccd72$export$a7c73072b1a182ae, (v) => $bdcd6ced2cdccd72$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bdcd6ced2cdccd72$export$9f27bc3417b4524d, (v) => $bdcd6ced2cdccd72$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac, (v) => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35, (v) => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bdcd6ced2cdccd72$export$ffb0004e005737fa, (v) => $bdcd6ced2cdccd72$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bdcd6ced2cdccd72$export$b624eff549462981, (v) => $bdcd6ced2cdccd72$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bdcd6ced2cdccd72$export$7897aa7841a5380c, (v) => $bdcd6ced2cdccd72$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bdcd6ced2cdccd72$export$602eac185826482c, (v) => $bdcd6ced2cdccd72$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bdcd6ced2cdccd72$export$e2c29f18771995cb, (v) => $bdcd6ced2cdccd72$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bdcd6ced2cdccd72$export$5f8d39834fd61797, (v) => $bdcd6ced2cdccd72$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5, (v) => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $bdcd6ced2cdccd72$export$998bcd577473dd93, (v) => $bdcd6ced2cdccd72$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bdcd6ced2cdccd72$export$b706b080d889d2c9, (v) => $bdcd6ced2cdccd72$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bdcd6ced2cdccd72$export$5be5a87408f70ddc, (v) => $bdcd6ced2cdccd72$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d, (v) => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bdcd6ced2cdccd72$export$455c2e768291efa6, (v) => $bdcd6ced2cdccd72$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bdcd6ced2cdccd72$export$9522e17588c12572, (v) => $bdcd6ced2cdccd72$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bdcd6ced2cdccd72$export$2110ac352bb060b9, (v) => $bdcd6ced2cdccd72$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bdcd6ced2cdccd72$export$56885ab8b9c456ab, (v) => $bdcd6ced2cdccd72$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de, (v) => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bdcd6ced2cdccd72$export$b82d16f27459e05a, (v) => $bdcd6ced2cdccd72$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bdcd6ced2cdccd72$export$522c17b4f5e123e8, (v) => $bdcd6ced2cdccd72$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6, (v) => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $bdcd6ced2cdccd72$export$3d6c20d97e46b957, (v) => $bdcd6ced2cdccd72$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $bdcd6ced2cdccd72$export$9b621391a187a31a, (v) => $bdcd6ced2cdccd72$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f, (v) => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bdcd6ced2cdccd72$export$a7c73072b1a182ae;
var $bdcd6ced2cdccd72$export$9f27bc3417b4524d;
var $bdcd6ced2cdccd72$export$db77ccec0bb4ccac;
var $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35;
var $bdcd6ced2cdccd72$export$ffb0004e005737fa;
var $bdcd6ced2cdccd72$export$b624eff549462981;
var $bdcd6ced2cdccd72$export$7897aa7841a5380c;
var $bdcd6ced2cdccd72$export$602eac185826482c;
var $bdcd6ced2cdccd72$export$e2c29f18771995cb;
var $bdcd6ced2cdccd72$export$5f8d39834fd61797;
var $bdcd6ced2cdccd72$export$74bf444e3cd11ea5;
var $bdcd6ced2cdccd72$export$998bcd577473dd93;
var $bdcd6ced2cdccd72$export$b706b080d889d2c9;
var $bdcd6ced2cdccd72$export$5be5a87408f70ddc;
var $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d;
var $bdcd6ced2cdccd72$export$455c2e768291efa6;
var $bdcd6ced2cdccd72$export$9522e17588c12572;
var $bdcd6ced2cdccd72$export$2110ac352bb060b9;
var $bdcd6ced2cdccd72$export$56885ab8b9c456ab;
var $bdcd6ced2cdccd72$export$d927fcb6adf8f9de;
var $bdcd6ced2cdccd72$export$b82d16f27459e05a;
var $bdcd6ced2cdccd72$export$522c17b4f5e123e8;
var $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6;
var $bdcd6ced2cdccd72$export$3d6c20d97e46b957;
var $bdcd6ced2cdccd72$export$9b621391a187a31a;
var $bdcd6ced2cdccd72$export$f5bbd400c2f4426f;
"use strict";
var $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bdcd6ced2cdccd72$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE:
                                return object;
                            case $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$bdcd6ced2cdccd72$export$a7c73072b1a182ae = $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
$bdcd6ced2cdccd72$export$9f27bc3417b4524d = $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
$bdcd6ced2cdccd72$export$db77ccec0bb4ccac = $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
$bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
$bdcd6ced2cdccd72$export$ffb0004e005737fa = $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
$bdcd6ced2cdccd72$export$b624eff549462981 = $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
$bdcd6ced2cdccd72$export$7897aa7841a5380c = $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
$bdcd6ced2cdccd72$export$602eac185826482c = $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
$bdcd6ced2cdccd72$export$e2c29f18771995cb = $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
$bdcd6ced2cdccd72$export$5f8d39834fd61797 = $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
$bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
$bdcd6ced2cdccd72$export$998bcd577473dd93 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
$bdcd6ced2cdccd72$export$b706b080d889d2c9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
};
$bdcd6ced2cdccd72$export$5be5a87408f70ddc = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
};
$bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
};
$bdcd6ced2cdccd72$export$455c2e768291efa6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
};
$bdcd6ced2cdccd72$export$9522e17588c12572 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
};
$bdcd6ced2cdccd72$export$2110ac352bb060b9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
};
$bdcd6ced2cdccd72$export$56885ab8b9c456ab = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
};
$bdcd6ced2cdccd72$export$d927fcb6adf8f9de = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
};
$bdcd6ced2cdccd72$export$b82d16f27459e05a = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
};
$bdcd6ced2cdccd72$export$522c17b4f5e123e8 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
};
$bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
};
$bdcd6ced2cdccd72$export$3d6c20d97e46b957 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
};
$bdcd6ced2cdccd72$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE || type === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE || type === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$bdcd6ced2cdccd72$export$f5bbd400c2f4426f = $bdcd6ced2cdccd72$var$typeOf;

});



parcelRegister("gxvzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a836f2f53d8f74$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");
function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $cpmCj.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("cpmCj", function(module, exports) {

$parcel$export(module.exports, "default", () => $90895d1859655b11$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("eWm0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae078d4716220a63$export$2e2bcd8739ae039);

var $19Aa2 = parcelRequire("19Aa2");
function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $19Aa2.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $19Aa2.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("6o2lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a66cd95e497efc7$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $aGAln = parcelRequire("aGAln");

var $cvKfd = parcelRequire("cvKfd");

var $bVuw0 = parcelRequire("bVuw0");

var $2GcsG = parcelRequire("2GcsG");

var $9dZwz = parcelRequire("9dZwz");

var $kOOck = parcelRequire("kOOck");

var $2UDLz = parcelRequire("2UDLz");
function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $aGAln.default)(breakpointsInput);
    const spacing = (0, $2GcsG.default)(spacingInput);
    let muiTheme = (0, $3z1Ay.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $bVuw0.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $cvKfd.default)(muiTheme);
    muiTheme.applyStyles = (0, $2UDLz.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;

});
parcelRegister("aGAln", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c7a04bfefec7c88$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7c7a04bfefec7c88$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7c7a04bfefec7c88$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7c7a04bfefec7c88$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7c7a04bfefec7c88$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("cvKfd", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $91bc4077911678f2$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $91bc4077911678f2$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $91bc4077911678f2$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $91bc4077911678f2$export$2e2bcd8739ae039);

function $91bc4077911678f2$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $91bc4077911678f2$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $91bc4077911678f2$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $91bc4077911678f2$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});

parcelRegister("bVuw0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aecb04a157fa644$export$2e2bcd8739ae039);
const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;

});

parcelRegister("2GcsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f392ba2ebd18096$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");
function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $7kpn1.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("7kpn1", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $555e14aafbcd0190$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $555e14aafbcd0190$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $555e14aafbcd0190$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $555e14aafbcd0190$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $555e14aafbcd0190$export$6f98e8eaf0be1996);


var $82aMg = parcelRequire("82aMg");

var $ii7BS = parcelRequire("ii7BS");

var $jIr7d = parcelRequire("jIr7d");

var $hjkc5 = parcelRequire("hjkc5");
const $555e14aafbcd0190$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $555e14aafbcd0190$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $555e14aafbcd0190$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $555e14aafbcd0190$var$getCssProperties = (0, $hjkc5.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($555e14aafbcd0190$var$aliases[prop]) prop = $555e14aafbcd0190$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $555e14aafbcd0190$var$properties[a];
    const direction = $555e14aafbcd0190$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $555e14aafbcd0190$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $555e14aafbcd0190$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $555e14aafbcd0190$var$spacingKeys = [
    ...$555e14aafbcd0190$export$aab52a0dde05ad8a,
    ...$555e14aafbcd0190$export$f8397d44f03ab6ad
];
function $555e14aafbcd0190$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ii7BS.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $555e14aafbcd0190$export$1def6f833384e3d1(theme) {
    return $555e14aafbcd0190$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $555e14aafbcd0190$var$getCssProperties(prop);
    const styleFromPropValue = $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $555e14aafbcd0190$var$style(props, keys) {
    const transformer = $555e14aafbcd0190$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $jIr7d.default), {});
}
function $555e14aafbcd0190$export$7ede87f9b603dd3c(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$aab52a0dde05ad8a);
}
$555e14aafbcd0190$export$7ede87f9b603dd3c.propTypes = {};
$555e14aafbcd0190$export$7ede87f9b603dd3c.filterProps = $555e14aafbcd0190$export$aab52a0dde05ad8a;
function $555e14aafbcd0190$export$6f98e8eaf0be1996(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$f8397d44f03ab6ad);
}
$555e14aafbcd0190$export$6f98e8eaf0be1996.propTypes = {};
$555e14aafbcd0190$export$6f98e8eaf0be1996.filterProps = $555e14aafbcd0190$export$f8397d44f03ab6ad;
function $555e14aafbcd0190$var$spacing(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$var$spacingKeys);
}
$555e14aafbcd0190$var$spacing.propTypes = {};
$555e14aafbcd0190$var$spacing.filterProps = $555e14aafbcd0190$var$spacingKeys;
var $555e14aafbcd0190$export$2e2bcd8739ae039 = $555e14aafbcd0190$var$spacing;

});
parcelRegister("82aMg", function(module, exports) {

$parcel$export(module.exports, "values", () => $5d96decff5ccffcb$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $5d96decff5ccffcb$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $5d96decff5ccffcb$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $5d96decff5ccffcb$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $5d96decff5ccffcb$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $5d96decff5ccffcb$export$980e6a259d807490);


var $3z1Ay = parcelRequire("3z1Ay");

var $jIr7d = parcelRequire("jIr7d");

var $cvKfd = parcelRequire("cvKfd");
const $5d96decff5ccffcb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $5d96decff5ccffcb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$5d96decff5ccffcb$export$68c286be0e7e55b7[key]}px)`
};
const $5d96decff5ccffcb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $5d96decff5ccffcb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $5d96decff5ccffcb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $cvKfd.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $cvKfd.getContainerQuery)(theme.containerQueries ? theme : $5d96decff5ccffcb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $5d96decff5ccffcb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $5d96decff5ccffcb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $jIr7d.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $5d96decff5ccffcb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $5d96decff5ccffcb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3z1Ay.default)(prev, next), {});
    return $5d96decff5ccffcb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $5d96decff5ccffcb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $5d96decff5ccffcb$export$2e2bcd8739ae039 = $5d96decff5ccffcb$var$breakpoints;

});
parcelRegister("jIr7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a728ecb1a1c3c0$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $e5a728ecb1a1c3c0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3z1Ay.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e5a728ecb1a1c3c0$export$2e2bcd8739ae039 = $e5a728ecb1a1c3c0$var$merge;

});


parcelRegister("ii7BS", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $d50fcf9a3ec00b94$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $d50fcf9a3ec00b94$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");


var $82aMg = parcelRequire("82aMg");
function $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d50fcf9a3ec00b94$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d50fcf9a3ec00b94$export$2e2bcd8739ae039 = $d50fcf9a3ec00b94$var$style;

});

parcelRegister("hjkc5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9a3e017c1fe4096$export$2e2bcd8739ae039);
function $c9a3e017c1fe4096$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("9dZwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b750d631801d296$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");

var $jIr7d = parcelRequire("jIr7d");

var $ii7BS = parcelRequire("ii7BS");

var $82aMg = parcelRequire("82aMg");

var $cvKfd = parcelRequire("cvKfd");

var $kOOck = parcelRequire("kOOck");
function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $ii7BS.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $ii7BS.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $ii7BS.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $gxvzd.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $kOOck.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $82aMg.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $82aMg.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $jIr7d.default)(css, breakpointsValues);
                        }
                    } else css = (0, $jIr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $cvKfd.sortContainerQueries)(theme, (0, $82aMg.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $cvKfd.sortContainerQueries)(theme, (0, $82aMg.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;

});
parcelRegister("kOOck", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27f6a6c429b3415$export$2e2bcd8739ae039);

var $7kpn1 = parcelRequire("7kpn1");

var $gIpS2 = parcelRequire("gIpS2");

var $f70is = parcelRequire("f70is");

var $f9Ko1 = parcelRequire("f9Ko1");

var $8j2JW = parcelRequire("8j2JW");
const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $gIpS2.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $gIpS2.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $f9Ko1.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $f9Ko1.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $7kpn1.padding)
    },
    pt: {
        style: (0, $7kpn1.padding)
    },
    pr: {
        style: (0, $7kpn1.padding)
    },
    pb: {
        style: (0, $7kpn1.padding)
    },
    pl: {
        style: (0, $7kpn1.padding)
    },
    px: {
        style: (0, $7kpn1.padding)
    },
    py: {
        style: (0, $7kpn1.padding)
    },
    padding: {
        style: (0, $7kpn1.padding)
    },
    paddingTop: {
        style: (0, $7kpn1.padding)
    },
    paddingRight: {
        style: (0, $7kpn1.padding)
    },
    paddingBottom: {
        style: (0, $7kpn1.padding)
    },
    paddingLeft: {
        style: (0, $7kpn1.padding)
    },
    paddingX: {
        style: (0, $7kpn1.padding)
    },
    paddingY: {
        style: (0, $7kpn1.padding)
    },
    paddingInline: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineStart: {
        style: (0, $7kpn1.padding)
    },
    paddingInlineEnd: {
        style: (0, $7kpn1.padding)
    },
    paddingBlock: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockStart: {
        style: (0, $7kpn1.padding)
    },
    paddingBlockEnd: {
        style: (0, $7kpn1.padding)
    },
    m: {
        style: (0, $7kpn1.margin)
    },
    mt: {
        style: (0, $7kpn1.margin)
    },
    mr: {
        style: (0, $7kpn1.margin)
    },
    mb: {
        style: (0, $7kpn1.margin)
    },
    ml: {
        style: (0, $7kpn1.margin)
    },
    mx: {
        style: (0, $7kpn1.margin)
    },
    my: {
        style: (0, $7kpn1.margin)
    },
    margin: {
        style: (0, $7kpn1.margin)
    },
    marginTop: {
        style: (0, $7kpn1.margin)
    },
    marginRight: {
        style: (0, $7kpn1.margin)
    },
    marginBottom: {
        style: (0, $7kpn1.margin)
    },
    marginLeft: {
        style: (0, $7kpn1.margin)
    },
    marginX: {
        style: (0, $7kpn1.margin)
    },
    marginY: {
        style: (0, $7kpn1.margin)
    },
    marginInline: {
        style: (0, $7kpn1.margin)
    },
    marginInlineStart: {
        style: (0, $7kpn1.margin)
    },
    marginInlineEnd: {
        style: (0, $7kpn1.margin)
    },
    marginBlock: {
        style: (0, $7kpn1.margin)
    },
    marginBlockStart: {
        style: (0, $7kpn1.margin)
    },
    marginBlockEnd: {
        style: (0, $7kpn1.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $f70is.gap)
    },
    rowGap: {
        style: (0, $f70is.rowGap)
    },
    columnGap: {
        style: (0, $f70is.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxWidth: {
        style: (0, $8j2JW.maxWidth)
    },
    minWidth: {
        transform: (0, $8j2JW.sizingTransform)
    },
    height: {
        transform: (0, $8j2JW.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    minHeight: {
        transform: (0, $8j2JW.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;

});
parcelRegister("gIpS2", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $c2b4d2c425fe2f29$export$7a57f79000377ca2);


var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");
function $c2b4d2c425fe2f29$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c2b4d2c425fe2f29$var$createBorderStyle(prop, transform) {
    return (0, $ii7BS.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c2b4d2c425fe2f29$export$1edee58a52776cd9 = $c2b4d2c425fe2f29$var$createBorderStyle('border', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$f9a7b6bd24892946 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTop', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$5abca33e6be905d2 = $c2b4d2c425fe2f29$var$createBorderStyle('borderRight', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e2ce9f12a980a822 = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottom', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$47658cca1a909427 = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeft', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e7fb0694ba2404fc = $c2b4d2c425fe2f29$var$createBorderStyle('borderColor');
const $c2b4d2c425fe2f29$export$126a92c968acdb85 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTopColor');
const $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e = $c2b4d2c425fe2f29$var$createBorderStyle('borderRightColor');
const $c2b4d2c425fe2f29$export$340b0327727f6d1a = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottomColor');
const $c2b4d2c425fe2f29$export$60beef91a985b4bf = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeftColor');
const $c2b4d2c425fe2f29$export$f9258c55612cbed7 = $c2b4d2c425fe2f29$var$createBorderStyle('outline', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$621fe586efeb64b9 = $c2b4d2c425fe2f29$var$createBorderStyle('outlineColor');
const $c2b4d2c425fe2f29$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.propTypes = {};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c2b4d2c425fe2f29$var$borders = (0, $hIpso.default)($c2b4d2c425fe2f29$export$1edee58a52776cd9, $c2b4d2c425fe2f29$export$f9a7b6bd24892946, $c2b4d2c425fe2f29$export$5abca33e6be905d2, $c2b4d2c425fe2f29$export$e2ce9f12a980a822, $c2b4d2c425fe2f29$export$47658cca1a909427, $c2b4d2c425fe2f29$export$e7fb0694ba2404fc, $c2b4d2c425fe2f29$export$126a92c968acdb85, $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e, $c2b4d2c425fe2f29$export$340b0327727f6d1a, $c2b4d2c425fe2f29$export$60beef91a985b4bf, $c2b4d2c425fe2f29$export$7a57f79000377ca2, $c2b4d2c425fe2f29$export$f9258c55612cbed7, $c2b4d2c425fe2f29$export$621fe586efeb64b9);
var $c2b4d2c425fe2f29$export$2e2bcd8739ae039 = $c2b4d2c425fe2f29$var$borders;

});
parcelRegister("hIpso", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5a4af256600fcc$export$2e2bcd8739ae039);

var $jIr7d = parcelRequire("jIr7d");
function $ce5a4af256600fcc$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $jIr7d.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ce5a4af256600fcc$export$2e2bcd8739ae039 = $ce5a4af256600fcc$var$compose;

});


parcelRegister("f70is", function(module, exports) {

$parcel$export(module.exports, "gap", () => $b007bd6739310ca0$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $b007bd6739310ca0$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $b007bd6739310ca0$export$8a833ffa5f5dbeda);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $7kpn1 = parcelRequire("7kpn1");

var $82aMg = parcelRequire("82aMg");

const $b007bd6739310ca0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$5df9adcb0db95e1e.propTypes = {};
$b007bd6739310ca0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $b007bd6739310ca0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$ec60d70ff941a580.propTypes = {};
$b007bd6739310ca0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $b007bd6739310ca0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $7kpn1.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $7kpn1.getValue)(transformer, propValue)
            });
        return (0, $82aMg.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.propTypes = {};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $b007bd6739310ca0$export$baf44164ca3a34e8 = (0, $ii7BS.default)({
    prop: 'gridColumn'
});
const $b007bd6739310ca0$export$8f7213a1cd01e832 = (0, $ii7BS.default)({
    prop: 'gridRow'
});
const $b007bd6739310ca0$export$b0e0abbc49ba668 = (0, $ii7BS.default)({
    prop: 'gridAutoFlow'
});
const $b007bd6739310ca0$export$bcd8b929d4b4142 = (0, $ii7BS.default)({
    prop: 'gridAutoColumns'
});
const $b007bd6739310ca0$export$e5039a674e14c828 = (0, $ii7BS.default)({
    prop: 'gridAutoRows'
});
const $b007bd6739310ca0$export$42bd9088661ffb03 = (0, $ii7BS.default)({
    prop: 'gridTemplateColumns'
});
const $b007bd6739310ca0$export$920682ae05b999bc = (0, $ii7BS.default)({
    prop: 'gridTemplateRows'
});
const $b007bd6739310ca0$export$1b88fbdd482fd33a = (0, $ii7BS.default)({
    prop: 'gridTemplateAreas'
});
const $b007bd6739310ca0$export$bdb486e40d52d26f = (0, $ii7BS.default)({
    prop: 'gridArea'
});
const $b007bd6739310ca0$var$grid = (0, $hIpso.default)($b007bd6739310ca0$export$5df9adcb0db95e1e, $b007bd6739310ca0$export$ec60d70ff941a580, $b007bd6739310ca0$export$8a833ffa5f5dbeda, $b007bd6739310ca0$export$baf44164ca3a34e8, $b007bd6739310ca0$export$8f7213a1cd01e832, $b007bd6739310ca0$export$b0e0abbc49ba668, $b007bd6739310ca0$export$bcd8b929d4b4142, $b007bd6739310ca0$export$e5039a674e14c828, $b007bd6739310ca0$export$42bd9088661ffb03, $b007bd6739310ca0$export$920682ae05b999bc, $b007bd6739310ca0$export$1b88fbdd482fd33a, $b007bd6739310ca0$export$bdb486e40d52d26f);
var $b007bd6739310ca0$export$2e2bcd8739ae039 = $b007bd6739310ca0$var$grid;

});

parcelRegister("f9Ko1", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $b08badac1d124df3$export$dbaffd4420ea0ac6);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");
function $b08badac1d124df3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b08badac1d124df3$export$35e9368ef982300f = (0, $ii7BS.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$2506f56c10355b33 = (0, $ii7BS.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$8c5a050822fd698c = (0, $ii7BS.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$var$palette = (0, $hIpso.default)($b08badac1d124df3$export$35e9368ef982300f, $b08badac1d124df3$export$2506f56c10355b33, $b08badac1d124df3$export$8c5a050822fd698c);
var $b08badac1d124df3$export$2e2bcd8739ae039 = $b08badac1d124df3$var$palette;

});

parcelRegister("8j2JW", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $60c239303eb89b20$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $60c239303eb89b20$export$488fda99655ff65a);

var $ii7BS = parcelRequire("ii7BS");

var $hIpso = parcelRequire("hIpso");

var $82aMg = parcelRequire("82aMg");
function $60c239303eb89b20$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $60c239303eb89b20$export$7e3df82ee760448c = (0, $ii7BS.default)({
    prop: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $82aMg.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $60c239303eb89b20$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $82aMg.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$60c239303eb89b20$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $60c239303eb89b20$export$ee148fbbe8357dd2 = (0, $ii7BS.default)({
    prop: 'minWidth',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ac607276a8fe9f0a = (0, $ii7BS.default)({
    prop: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$dc0d8bd0b94f8570 = (0, $ii7BS.default)({
    prop: 'maxHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$a43cf604e12f3b17 = (0, $ii7BS.default)({
    prop: 'minHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ffed9f14fb65e276 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$905076ed6620e671 = (0, $ii7BS.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$6ccc93f785106a58 = (0, $ii7BS.default)({
    prop: 'boxSizing'
});
const $60c239303eb89b20$var$sizing = (0, $hIpso.default)($60c239303eb89b20$export$7e3df82ee760448c, $60c239303eb89b20$export$488fda99655ff65a, $60c239303eb89b20$export$ee148fbbe8357dd2, $60c239303eb89b20$export$ac607276a8fe9f0a, $60c239303eb89b20$export$dc0d8bd0b94f8570, $60c239303eb89b20$export$a43cf604e12f3b17, $60c239303eb89b20$export$6ccc93f785106a58);
var $60c239303eb89b20$export$2e2bcd8739ae039 = $60c239303eb89b20$var$sizing;

});



parcelRegister("2UDLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21efa8802134c535$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("aFFCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4e0616915ca3a0$export$2e2bcd8739ae039);

var $8TaLX = parcelRequire("8TaLX");
function $7c4e0616915ca3a0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $8TaLX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $8TaLX.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("e7sAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a477e5500cafdc51$export$2e2bcd8739ae039);

var $2rLZY = parcelRequire("2rLZY");
'use client';
const $a477e5500cafdc51$var$defaultTheme = (0, $2rLZY.default)();
var $a477e5500cafdc51$export$2e2bcd8739ae039 = $a477e5500cafdc51$var$defaultTheme;

});
parcelRegister("2rLZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8355eadf532640$export$2e2bcd8739ae039);

var $7vaTq = parcelRequire("7vaTq");

var $evvmv = parcelRequire("evvmv");

var $hzFb6 = parcelRequire("hzFb6");
// eslint-disable-next-line consistent-return
function $1c8355eadf532640$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $7vaTq.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $1c8355eadf532640$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $hzFb6.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $hzFb6.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $evvmv.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("7vaTq", function(module, exports) {

$parcel$export(module.exports, "light", () => $5763e0c539a251df$export$a43af521ac8c3202);
$parcel$export(module.exports, "dark", () => $5763e0c539a251df$export$55ce6f3a06c59543);
$parcel$export(module.exports, "default", () => $5763e0c539a251df$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $aSEG4 = parcelRequire("aSEG4");

var $i9Iyg = parcelRequire("i9Iyg");

var $lbPfT = parcelRequire("lbPfT");

var $k3E08 = parcelRequire("k3E08");

var $7hly1 = parcelRequire("7hly1");

var $2XYar = parcelRequire("2XYar");

var $hxoZM = parcelRequire("hxoZM");

var $3Bwcf = parcelRequire("3Bwcf");

var $6TWA2 = parcelRequire("6TWA2");
function $5763e0c539a251df$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $i9Iyg.default).white,
            default: (0, $i9Iyg.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $5763e0c539a251df$export$a43af521ac8c3202 = $5763e0c539a251df$var$getLight();
function $5763e0c539a251df$var$getDark() {
    return {
        text: {
            primary: (0, $i9Iyg.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $i9Iyg.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $5763e0c539a251df$export$55ce6f3a06c59543 = $5763e0c539a251df$var$getDark();
function $5763e0c539a251df$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aSEG4.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aSEG4.darken)(intent.main, tonalOffsetDark);
    }
}
function $5763e0c539a251df$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $5763e0c539a251df$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hxoZM.default)[200],
        light: (0, $hxoZM.default)[50],
        dark: (0, $hxoZM.default)[400]
    };
    return {
        main: (0, $hxoZM.default)[700],
        light: (0, $hxoZM.default)[400],
        dark: (0, $hxoZM.default)[800]
    };
}
function $5763e0c539a251df$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $k3E08.default)[200],
        light: (0, $k3E08.default)[50],
        dark: (0, $k3E08.default)[400]
    };
    return {
        main: (0, $k3E08.default)[500],
        light: (0, $k3E08.default)[300],
        dark: (0, $k3E08.default)[700]
    };
}
function $5763e0c539a251df$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7hly1.default)[500],
        light: (0, $7hly1.default)[300],
        dark: (0, $7hly1.default)[700]
    };
    return {
        main: (0, $7hly1.default)[700],
        light: (0, $7hly1.default)[400],
        dark: (0, $7hly1.default)[800]
    };
}
function $5763e0c539a251df$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3Bwcf.default)[400],
        light: (0, $3Bwcf.default)[300],
        dark: (0, $3Bwcf.default)[700]
    };
    return {
        main: (0, $3Bwcf.default)[700],
        light: (0, $3Bwcf.default)[500],
        dark: (0, $3Bwcf.default)[900]
    };
}
function $5763e0c539a251df$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $6TWA2.default)[400],
        light: (0, $6TWA2.default)[300],
        dark: (0, $6TWA2.default)[700]
    };
    return {
        main: (0, $6TWA2.default)[800],
        light: (0, $6TWA2.default)[500],
        dark: (0, $6TWA2.default)[900]
    };
}
function $5763e0c539a251df$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2XYar.default)[400],
        light: (0, $2XYar.default)[300],
        dark: (0, $2XYar.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $2XYar.default)[500],
        dark: (0, $2XYar.default)[900]
    };
}
function $5763e0c539a251df$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $5763e0c539a251df$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $5763e0c539a251df$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5763e0c539a251df$var$getDefaultSecondary(mode);
    const error = palette.error || $5763e0c539a251df$var$getDefaultError(mode);
    const info = palette.info || $5763e0c539a251df$var$getDefaultInfo(mode);
    const success = palette.success || $5763e0c539a251df$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5763e0c539a251df$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $5763e0c539a251df$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $aSEG4.getContrastRatio)(background, $5763e0c539a251df$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5763e0c539a251df$export$55ce6f3a06c59543.text.primary : $5763e0c539a251df$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $cpmCj.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $cpmCj.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $5763e0c539a251df$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $5763e0c539a251df$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $5763e0c539a251df$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $5763e0c539a251df$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $5763e0c539a251df$var$getLight();
    else if (mode === 'dark') modeHydrated = $5763e0c539a251df$var$getDark();
    const paletteOutput = (0, $3z1Ay.default)({
        // A collection of common colors.
        common: {
            ...(0, $i9Iyg.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $lbPfT.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("aSEG4", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", () => $7ebe803ced17df29$export$427365fc3db6fc5e);
$parcel$export(module.exports, "hslToRgb", () => $7ebe803ced17df29$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getContrastRatio", () => $7ebe803ced17df29$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $7ebe803ced17df29$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "private_safeAlpha", () => $7ebe803ced17df29$export$34109543fc7f43f8);
$parcel$export(module.exports, "darken", () => $7ebe803ced17df29$export$4b073707ff63303);
$parcel$export(module.exports, "private_safeDarken", () => $7ebe803ced17df29$export$eaaef2dca3e9e512);
$parcel$export(module.exports, "lighten", () => $7ebe803ced17df29$export$c0816ed86df316af);
$parcel$export(module.exports, "private_safeLighten", () => $7ebe803ced17df29$export$aeeda94ef1d01275);
$parcel$export(module.exports, "emphasize", () => $7ebe803ced17df29$export$e665714f76e581fd);
$parcel$export(module.exports, "private_safeEmphasize", () => $7ebe803ced17df29$export$11bb74ba10c85505);

var $cpmCj = parcelRequire("cpmCj");

var $1jJMI = parcelRequire("1jJMI");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7ebe803ced17df29$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $1jJMI.default)(value, min, max);
}
function $7ebe803ced17df29$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7ebe803ced17df29$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $7ebe803ced17df29$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $cpmCj.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $cpmCj.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $7ebe803ced17df29$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $7ebe803ced17df29$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $7ebe803ced17df29$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $7ebe803ced17df29$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $7ebe803ced17df29$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $7ebe803ced17df29$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $7ebe803ced17df29$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$7ebe803ced17df29$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $7ebe803ced17df29$export$29fb7152bd3f781a(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7ebe803ced17df29$export$c852d90bf7403b62(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7ebe803ced17df29$export$d061e26956a60b0a(foreground, background) {
    const lumA = $7ebe803ced17df29$export$c852d90bf7403b62(foreground);
    const lumB = $7ebe803ced17df29$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    value = $7ebe803ced17df29$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $7ebe803ced17df29$export$c852d90bf7403b62(color) > 0.5 ? $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) : $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
}
function $7ebe803ced17df29$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7ebe803ced17df29$export$677b39864803984e(background);
    const overlayColor = $7ebe803ced17df29$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("1jJMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5b14b581d98cb8$export$2e2bcd8739ae039);
function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;

});


parcelRegister("i9Iyg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37ba043b695a86b$export$2e2bcd8739ae039);
const $d37ba043b695a86b$var$common = {
    black: '#000',
    white: '#fff'
};
var $d37ba043b695a86b$export$2e2bcd8739ae039 = $d37ba043b695a86b$var$common;

});

parcelRegister("lbPfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d26248a242c674$export$2e2bcd8739ae039);
const $f6d26248a242c674$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $f6d26248a242c674$export$2e2bcd8739ae039 = $f6d26248a242c674$var$grey;

});

parcelRegister("k3E08", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9a31dd7cc73b986$export$2e2bcd8739ae039);
const $e9a31dd7cc73b986$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $e9a31dd7cc73b986$export$2e2bcd8739ae039 = $e9a31dd7cc73b986$var$purple;

});

parcelRegister("7hly1", function(module, exports) {

$parcel$export(module.exports, "default", () => $54cad5d9f2acbb0d$export$2e2bcd8739ae039);
const $54cad5d9f2acbb0d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $54cad5d9f2acbb0d$export$2e2bcd8739ae039 = $54cad5d9f2acbb0d$var$red;

});

parcelRegister("2XYar", function(module, exports) {

$parcel$export(module.exports, "default", () => $228fc37206d3e0db$export$2e2bcd8739ae039);
const $228fc37206d3e0db$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $228fc37206d3e0db$export$2e2bcd8739ae039 = $228fc37206d3e0db$var$orange;

});

parcelRegister("hxoZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc48e8508d197286$export$2e2bcd8739ae039);
const $cc48e8508d197286$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $cc48e8508d197286$export$2e2bcd8739ae039 = $cc48e8508d197286$var$blue;

});

parcelRegister("3Bwcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $29fdcd59f703e693$export$2e2bcd8739ae039);
const $29fdcd59f703e693$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $29fdcd59f703e693$export$2e2bcd8739ae039 = $29fdcd59f703e693$var$lightBlue;

});

parcelRegister("6TWA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $506551f203a25923$export$2e2bcd8739ae039);
const $506551f203a25923$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $506551f203a25923$export$2e2bcd8739ae039 = $506551f203a25923$var$green;

});


parcelRegister("evvmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8fc49caae8a6210$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $2GcsG = parcelRequire("2GcsG");
var $fOmBr = parcelRequire("fOmBr");

var $7kpn1 = parcelRequire("7kpn1");

var $3sIPp = parcelRequire("3sIPp");
var $6UPjt = parcelRequire("6UPjt");
var $8OyjJ = parcelRequire("8OyjJ");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $aSEG4 = parcelRequire("aSEG4");

var $hzFb6 = parcelRequire("hzFb6");

var $g36bN = parcelRequire("g36bN");

var $4FYYQ = parcelRequire("4FYYQ");

var $5vv6f = parcelRequire("5vv6f");

var $1QHdd = parcelRequire("1QHdd");

var $7vaTq = parcelRequire("7vaTq");
function $a8fc49caae8a6210$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $a8fc49caae8a6210$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $a8fc49caae8a6210$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $aSEG4.hslToRgb)(color);
}
function $a8fc49caae8a6210$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $aSEG4.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $a8fc49caae8a6210$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $a8fc49caae8a6210$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $a8fc49caae8a6210$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $fOmBr.default)(cssVarPrefix);
function $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $g36bN.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $hzFb6.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $g36bN.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $g36bN.getOverlays)(mode)
    };
    return muiTheme;
}
function $a8fc49caae8a6210$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $4FYYQ.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $a8fc49caae8a6210$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $cpmCj.default)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $8OyjJ.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $a8fc49caae8a6210$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#fff');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#000');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $aSEG4.private_safeAlpha)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $aSEG4.private_safeDarken)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $aSEG4.private_safeLighten)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $a8fc49caae8a6210$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', colorMix((0, $aSEG4.private_safeDarken), palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', colorMix((0, $aSEG4.private_safeDarken), palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', colorMix((0, $aSEG4.private_safeDarken), palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', colorMix((0, $aSEG4.private_safeDarken), palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $aSEG4.private_safeLighten), palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $aSEG4.private_safeLighten), palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $aSEG4.private_safeLighten), palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $aSEG4.private_safeLighten), palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $aSEG4.private_safeLighten), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $aSEG4.private_safeLighten), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $aSEG4.private_safeLighten), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $aSEG4.private_safeLighten), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $aSEG4.private_safeLighten), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $aSEG4.private_safeLighten), palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $aSEG4.private_safeAlpha), palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $aSEG4.private_safeLighten), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $aSEG4.private_safeLighten), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $aSEG4.private_safeLighten), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $aSEG4.private_safeLighten), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', colorMix((0, $aSEG4.private_safeLighten), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $aSEG4.private_safeLighten), palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $aSEG4.private_safeDarken), palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $aSEG4.private_safeEmphasize)(palette.background.default, 0.8);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>colorSpace ? (0, $7vaTq.dark).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aSEG4.private_safeEmphasize)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $aSEG4.private_safeLighten), palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', colorMix((0, $aSEG4.private_safeLighten), colorMix((0, $aSEG4.private_safeAlpha), palette.divider, 1), 0.88));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', colorMix((0, $aSEG4.private_safeAlpha), palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', colorMix((0, $aSEG4.private_safeLighten), palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', colorMix((0, $aSEG4.private_safeLighten), palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', colorMix((0, $aSEG4.private_safeLighten), palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', colorMix((0, $aSEG4.private_safeLighten), palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $aSEG4.private_safeDarken), palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $aSEG4.private_safeDarken), palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $aSEG4.private_safeDarken), palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $aSEG4.private_safeDarken), palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $aSEG4.private_safeDarken), palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $aSEG4.private_safeDarken), palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $aSEG4.private_safeDarken), palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $aSEG4.private_safeDarken), palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $aSEG4.private_safeDarken), palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $aSEG4.private_safeDarken), palette.warning.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $aSEG4.private_safeAlpha), palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $aSEG4.private_safeDarken), palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $aSEG4.private_safeDarken), palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $aSEG4.private_safeDarken), palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $aSEG4.private_safeDarken), palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', colorMix((0, $aSEG4.private_safeDarken), palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $aSEG4.private_safeDarken), palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $aSEG4.private_safeLighten), palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $aSEG4.private_safeEmphasize)(palette.background.default, 0.98);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>colorSpace ? (0, $7vaTq.light).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $aSEG4.private_safeEmphasize)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.primary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.secondary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.error.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.info.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.success.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $aSEG4.private_safeDarken), palette.warning.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', colorMix((0, $aSEG4.private_safeDarken), colorMix((0, $aSEG4.private_safeAlpha), palette.divider, 1), 0.68));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', colorMix((0, $aSEG4.private_safeAlpha), palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'paper');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'background');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'onBackground');
        $a8fc49caae8a6210$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $a8fc49caae8a6210$var$setColor(palette[color], 'mainChannel', (0, $aSEG4.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.main)));
                if (colors.light) $a8fc49caae8a6210$var$setColor(palette[color], 'lightChannel', (0, $aSEG4.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.light)));
                if (colors.dark) $a8fc49caae8a6210$var$setColor(palette[color], 'darkChannel', (0, $aSEG4.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.dark)));
                if (colors.contrastText) $a8fc49caae8a6210$var$setColor(palette[color], 'contrastTextChannel', (0, $aSEG4.private_safeColorChannel)($a8fc49caae8a6210$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'primary');
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $5vv6f.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $6UPjt.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $2GcsG.default)(input.spacing, (0, $7kpn1.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $3sIPp.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $1QHdd.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fOmBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b82d0f0117f79ef3$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b82d0f0117f79ef3$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("3sIPp", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", () => $2856c28c5d84ba80$export$858538ff6c0d421d);
/* eslint-disable import/prefer-default-export */ function $2856c28c5d84ba80$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("6UPjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $508fc6c60afa1bca$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $3JNYS = parcelRequire("3JNYS");
function $508fc6c60afa1bca$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3JNYS.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3JNYS.default)(scheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3JNYS.default)(defaultScheme, parserConfig);
        themeVars = (0, $3z1Ay.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3z1Ay.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $508fc6c60afa1bca$export$2e2bcd8739ae039 = $508fc6c60afa1bca$var$prepareCssVars;

});
parcelRegister("3JNYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b8c5837678016ea$export$2e2bcd8739ae039);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2b8c5837678016ea$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $2b8c5837678016ea$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $2b8c5837678016ea$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $2b8c5837678016ea$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2b8c5837678016ea$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $2b8c5837678016ea$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $2b8c5837678016ea$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $2b8c5837678016ea$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("8OyjJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $66ad9cf01c4526b5$export$2e2bcd8739ae039);
function $66ad9cf01c4526b5$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("hzFb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccb5a5a44382729b$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $3z1Ay = parcelRequire("3z1Ay");

var $9dZwz = parcelRequire("9dZwz");
var $kOOck = parcelRequire("kOOck");

var $6o2lr = parcelRequire("6o2lr");

var $aSEG4 = parcelRequire("aSEG4");


var $4BnQk = parcelRequire("4BnQk");

var $7vaTq = parcelRequire("7vaTq");

var $b1ZjZ = parcelRequire("b1ZjZ");

var $86vDZ = parcelRequire("86vDZ");

var $frp52 = parcelRequire("frp52");

var $8YN2e = parcelRequire("8YN2e");

var $1QHdd = parcelRequire("1QHdd");
function $ccb5a5a44382729b$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $ccb5a5a44382729b$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $ccb5a5a44382729b$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $aSEG4.alpha)(color, $ccb5a5a44382729b$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$ccb5a5a44382729b$var$coefficientToPercentage(coefficient)})`;
            return (0, $aSEG4.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$ccb5a5a44382729b$var$coefficientToPercentage(coefficient)})`;
            return (0, $aSEG4.darken)(color, coefficient);
        }
    });
}
function $ccb5a5a44382729b$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $cpmCj.default)(20));
    const palette = (0, $7vaTq.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $6o2lr.default)(options);
    let muiTheme = (0, $3z1Ay.default)(systemTheme, {
        mixins: (0, $4BnQk.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $86vDZ.default).slice(),
        typography: (0, $b1ZjZ.default)(palette, typographyInput),
        transitions: (0, $frp52.default)(transitionsInput),
        zIndex: {
            ...(0, $8YN2e.default)
        }
    });
    muiTheme = (0, $3z1Ay.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3z1Ay.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $kOOck.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9dZwz.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $1QHdd.stringifyTheme); // for Pigment CSS integration
    $ccb5a5a44382729b$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $ccb5a5a44382729b$export$2e2bcd8739ae039 = $ccb5a5a44382729b$var$createThemeNoVars;

});
parcelRegister("4BnQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $359d1cd3c99dce0c$export$2e2bcd8739ae039);
function $359d1cd3c99dce0c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("b1ZjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $807f5ad944800d5b$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");
function $807f5ad944800d5b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $807f5ad944800d5b$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $807f5ad944800d5b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $807f5ad944800d5b$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $807f5ad944800d5b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $807f5ad944800d5b$var$defaultFontFamily ? {
                letterSpacing: `${$807f5ad944800d5b$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $807f5ad944800d5b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $807f5ad944800d5b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3z1Ay.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("86vDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e676e189e322653$export$2e2bcd8739ae039);
const $5e676e189e322653$var$shadowKeyUmbraOpacity = 0.2;
const $5e676e189e322653$var$shadowKeyPenumbraOpacity = 0.14;
const $5e676e189e322653$var$shadowAmbientShadowOpacity = 0.12;
function $5e676e189e322653$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$5e676e189e322653$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $5e676e189e322653$var$shadows = [
    'none',
    $5e676e189e322653$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $5e676e189e322653$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $5e676e189e322653$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $5e676e189e322653$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $5e676e189e322653$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $5e676e189e322653$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $5e676e189e322653$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $5e676e189e322653$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $5e676e189e322653$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $5e676e189e322653$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $5e676e189e322653$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $5e676e189e322653$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $5e676e189e322653$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $5e676e189e322653$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $5e676e189e322653$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $5e676e189e322653$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $5e676e189e322653$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $5e676e189e322653$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $5e676e189e322653$export$2e2bcd8739ae039 = $5e676e189e322653$var$shadows;

});

parcelRegister("frp52", function(module, exports) {

$parcel$export(module.exports, "duration", () => $b3dcd50dcf07bac9$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $b3dcd50dcf07bac9$export$2e2bcd8739ae039);
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $b3dcd50dcf07bac9$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b3dcd50dcf07bac9$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3dcd50dcf07bac9$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3dcd50dcf07bac9$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $b3dcd50dcf07bac9$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$b3dcd50dcf07bac9$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$b3dcd50dcf07bac9$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b3dcd50dcf07bac9$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b3dcd50dcf07bac9$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $b3dcd50dcf07bac9$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("8YN2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $6899f6a23f8dea0a$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $6899f6a23f8dea0a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $6899f6a23f8dea0a$export$2e2bcd8739ae039 = $6899f6a23f8dea0a$var$zIndex;

});

parcelRegister("1QHdd", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", () => $158c2acb0a4a3031$export$32c2afa5f91892aa);
/* eslint-disable import/prefer-default-export */ 
var $3z1Ay = parcelRequire("3z1Ay");
function $158c2acb0a4a3031$var$isSerializable(val) {
    return (0, $3z1Ay.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $158c2acb0a4a3031$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$158c2acb0a4a3031$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $3z1Ay.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("g36bN", function(module, exports) {

$parcel$export(module.exports, "getOpacity", () => $baf1ba368e53b158$export$c85e0347fceb69ba);
$parcel$export(module.exports, "getOverlays", () => $baf1ba368e53b158$export$dd191566510330d3);
$parcel$export(module.exports, "default", () => $baf1ba368e53b158$export$2e2bcd8739ae039);

var $7vaTq = parcelRequire("7vaTq");

var $4WC2G = parcelRequire("4WC2G");
const $baf1ba368e53b158$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $4WC2G.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $baf1ba368e53b158$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $baf1ba368e53b158$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $baf1ba368e53b158$var$defaultDarkOverlays : [];
}
function $baf1ba368e53b158$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $7vaTq.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$baf1ba368e53b158$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $baf1ba368e53b158$export$dd191566510330d3(palette.mode),
        ...other
    };
}

});
parcelRegister("4WC2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $399a169bab06dc0f$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $399a169bab06dc0f$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("4FYYQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $367a4b35286320ec$export$2e2bcd8739ae039);
function $367a4b35286320ec$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("5vv6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $4027f8c8ae6e8b1d$export$2e2bcd8739ae039);

var $kuJ5Y = parcelRequire("kuJ5Y");
var $4027f8c8ae6e8b1d$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $kuJ5Y.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("kuJ5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeb996f5fdb0285b$export$2e2bcd8739ae039);
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $eeb996f5fdb0285b$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $eeb996f5fdb0285b$export$2e2bcd8739ae039 = $eeb996f5fdb0285b$var$excludeVariablesFromRoot;

});





parcelRegister("bXtHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b4c3f6e5c407120$export$2e2bcd8739ae039);
var $8b4c3f6e5c407120$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("lwQO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fac58cb18f36893e$export$2e2bcd8739ae039);

var $jgzqq = parcelRequire("jgzqq");
const $fac58cb18f36893e$var$memoTheme = (0, $jgzqq.default);
var $fac58cb18f36893e$export$2e2bcd8739ae039 = $fac58cb18f36893e$var$memoTheme;

});
parcelRegister("jgzqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06afda6b2197864$export$2e2bcd8739ae039);

var $aFFCY = parcelRequire("aFFCY");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e06afda6b2197864$var$arg = {
    theme: undefined
};
function $e06afda6b2197864$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e06afda6b2197864$var$arg.theme = props.theme;
            value = (0, $aFFCY.default)(styleFn($e06afda6b2197864$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("2nO41", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $1bc4906ad0338fb8$export$2440da353cedad43);
parcelRequire("acw62");


var $aMyfV = parcelRequire("aMyfV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $1bc4906ad0338fb8$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aMyfV.default), {
        ...props
    });
}
var $1bc4906ad0338fb8$export$2e2bcd8739ae039 = $1bc4906ad0338fb8$var$DefaultPropsProvider;
function $1bc4906ad0338fb8$export$2440da353cedad43(params) {
    return (0, $aMyfV.useDefaultProps)(params);
}

});
parcelRegister("aMyfV", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $7d98f590ab80e73c$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $7d98f590ab80e73c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $4FZD0 = parcelRequire("4FZD0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $4FZD0.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $4FZD0.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;

});


parcelRegister("2TZUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d0be68de155ec6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $52FI1 = parcelRequire("52FI1");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $Uq4Et = parcelRequire("Uq4Et");

var $74Rxa = parcelRequire("74Rxa");

var $eS6LY = parcelRequire("eS6LY");

var $koF5D = parcelRequire("koF5D");

var $lHJjy = parcelRequire("lHJjy");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $21d0be68de155ec6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $lHJjy.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $21d0be68de155ec6$export$7ec0dcc5e3cdcd36 = (0, $1Ikg4.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $lHJjy.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $21d0be68de155ec6$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $acw62.useRef(null);
    const ripple = (0, $eS6LY.default)();
    const handleRippleRef = (0, $Uq4Et.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $52FI1.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $74Rxa.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $52FI1.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $74Rxa.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $74Rxa.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $Uq4Et.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $21d0be68de155ec6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($21d0be68de155ec6$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $koF5D.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $21d0be68de155ec6$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $74Rxa.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $21d0be68de155ec6$export$2e2bcd8739ae039 = $21d0be68de155ec6$var$ButtonBase;

});
parcelRegister("52FI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3abd7e3358fc5f35$export$2e2bcd8739ae039);
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3abd7e3358fc5f35$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("Uq4Et", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9974d6176bfa01$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");
'use client';
var $0a9974d6176bfa01$export$2e2bcd8739ae039 = (0, $3qSdM.default);

});
parcelRegister("3qSdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fddc0219860a83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("74Rxa", function(module, exports) {

$parcel$export(module.exports, "default", () => $52726edc538865d0$export$2e2bcd8739ae039);

var $13KXh = parcelRequire("13KXh");
'use client';
var $52726edc538865d0$export$2e2bcd8739ae039 = (0, $13KXh.default);

});
parcelRegister("13KXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5a7e8ccbc07697$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $eEJPp.default)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;

});
parcelRegister("eEJPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab859a020ad749e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;

});



parcelRegister("eS6LY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $iYIN2 = parcelRequire("iYIN2");
'use client';
class $ad3b5cbf2e7edbd2$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $ad3b5cbf2e7edbd2$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $iYIN2.default)($ad3b5cbf2e7edbd2$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $ad3b5cbf2e7edbd2$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039() {
    return $ad3b5cbf2e7edbd2$export$f5de0641c7db4154.use();
}
function $ad3b5cbf2e7edbd2$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("iYIN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd1092ee97d527c8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("koF5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed95ec2260a9d464$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $jEvxL = parcelRequire("jEvxL");

var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");

var $8zogs = parcelRequire("8zogs");
var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $1YYoB = parcelRequire("1YYoB");

var $9M1XX = parcelRequire("9M1XX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ed95ec2260a9d464$var$DURATION = 550;
const $ed95ec2260a9d464$export$95d0c9356b2231a3 = 80;
const $ed95ec2260a9d464$var$enterKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $ed95ec2260a9d464$var$exitKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $ed95ec2260a9d464$var$pulsateKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $ed95ec2260a9d464$export$f6b7418508c72c25 = (0, $1Ikg4.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $ed95ec2260a9d464$export$676cfe7b12693c4b = (0, $1Ikg4.default)((0, $1YYoB.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $9M1XX.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$ed95ec2260a9d464$var$enterKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $9M1XX.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $9M1XX.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $9M1XX.default).childLeaving} {
    opacity: 0;
    animation-name: ${$ed95ec2260a9d464$var$exitKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $9M1XX.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$ed95ec2260a9d464$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $ed95ec2260a9d464$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $lHOu3.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $9QePP.default)(classes.ripple, (0, $9M1XX.default).ripple),
                        rippleVisible: (0, $9QePP.default)(classes.rippleVisible, (0, $9M1XX.default).rippleVisible),
                        ripplePulsate: (0, $9QePP.default)(classes.ripplePulsate, (0, $9M1XX.default).ripplePulsate),
                        child: (0, $9QePP.default)(classes.child, (0, $9M1XX.default).child),
                        childLeaving: (0, $9QePP.default)(classes.childLeaving, (0, $9M1XX.default).childLeaving),
                        childPulsate: (0, $9QePP.default)(classes.childPulsate, (0, $9M1XX.default).childPulsate)
                    },
                    timeout: $ed95ec2260a9d464$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($ed95ec2260a9d464$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ed95ec2260a9d464$export$f6b7418508c72c25, {
        className: (0, $9QePP.default)((0, $9M1XX.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jEvxL.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $ed95ec2260a9d464$export$2e2bcd8739ae039 = $ed95ec2260a9d464$var$TouchRipple;

});
parcelRegister("jEvxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ea38a8b431e8fc$export$2e2bcd8739ae039);

var $beKAS = parcelRequire("beKAS");

var $4GYug = parcelRequire("4GYug");

var $hKEWj = parcelRequire("hKEWj");

var $a0qps = parcelRequire("a0qps");


var $acw62 = parcelRequire("acw62");

var $6xlZQ = parcelRequire("6xlZQ");

var $n2pn1 = parcelRequire("n2pn1");
var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $a0qps.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $hKEWj.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $n2pn1.getInitialChildMapping)(nextProps, handleExited) : (0, $n2pn1.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $n2pn1.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $4GYug.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $beKAS.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;

});
parcelRegister("beKAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $021c7856fd446737$export$2e2bcd8739ae039);
function $021c7856fd446737$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4GYug", function(module, exports) {

$parcel$export(module.exports, "default", () => $36aa01289d8055dd$export$2e2bcd8739ae039);
function $36aa01289d8055dd$export$2e2bcd8739ae039() {
    $36aa01289d8055dd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36aa01289d8055dd$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("hKEWj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec67d431a0ce96e$export$2e2bcd8739ae039);
function $cec67d431a0ce96e$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("a0qps", function(module, exports) {

$parcel$export(module.exports, "default", () => $748e63dc9f7e9476$export$2e2bcd8739ae039);

var $37SZh = parcelRequire("37SZh");
function $748e63dc9f7e9476$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $37SZh.default)(subClass, superClass);
}

});
parcelRegister("37SZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $246cade9405c4e05$export$2e2bcd8739ae039);
function $246cade9405c4e05$export$2e2bcd8739ae039(o, p) {
    $246cade9405c4e05$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $246cade9405c4e05$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("n2pn1", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $04540450bf60efa1$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $04540450bf60efa1$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $04540450bf60efa1$export$36fd1af28d383ec0);

var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("lHOu3", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $fcd4c6205d65c7df$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $fcd4c6205d65c7df$export$2e2bcd8739ae039);

var $iYIN2 = parcelRequire("iYIN2");

var $dOphX = parcelRequire("dOphX");
'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $iYIN2.default)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $dOphX.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("dOphX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0e38fa988f617e0$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("1YYoB", function(module, exports) {

$parcel$export(module.exports, "default", () => $171a3e689242bc25$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $171a3e689242bc25$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $9QePP.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $9QePP.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $171a3e689242bc25$export$2e2bcd8739ae039 = $171a3e689242bc25$var$Ripple;

});

parcelRegister("9M1XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71da1f2c906d4bee$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $71da1f2c906d4bee$export$b464606f735ab902(slot) {
    return (0, $4Cod0.default)('MuiTouchRipple', slot);
}
const $71da1f2c906d4bee$var$touchRippleClasses = (0, $beCSm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $71da1f2c906d4bee$export$2e2bcd8739ae039 = $71da1f2c906d4bee$var$touchRippleClasses;

});
parcelRegister("beCSm", function(module, exports) {

$parcel$export(module.exports, "default", () => $82df286c368a2a01$export$2e2bcd8739ae039);

var $4Cod0 = parcelRequire("4Cod0");
function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4Cod0.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4Cod0", function(module, exports) {

$parcel$export(module.exports, "default", () => $35cd7d64717698f7$export$2e2bcd8739ae039);

var $bnost = parcelRequire("bnost");
const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $bnost.default).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("bnost", function(module, exports) {

$parcel$export(module.exports, "default", () => $8484d09248d25570$export$2e2bcd8739ae039);
const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;

});





parcelRegister("lHJjy", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $fcd0c39d812092df$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $fcd0c39d812092df$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fcd0c39d812092df$export$fccb0498dcd99783(slot) {
    return (0, $4Cod0.default)('MuiButtonBase', slot);
}
const $fcd0c39d812092df$var$buttonBaseClasses = (0, $beCSm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $fcd0c39d812092df$export$2e2bcd8739ae039 = $fcd0c39d812092df$var$buttonBaseClasses;

});


parcelRegister("4mI0b", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db5964c492ae2d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $8zogs = parcelRequire("8zogs");
var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $lLd7d = parcelRequire("lLd7d");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $32db5964c492ae2d$var$SIZE = 44;
const $32db5964c492ae2d$var$circularRotateKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $32db5964c492ae2d$var$circularDashKeyframe = (0, $8zogs.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $32db5964c492ae2d$var$rotateAnimation = typeof $32db5964c492ae2d$var$circularRotateKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $32db5964c492ae2d$var$dashAnimation = typeof $32db5964c492ae2d$var$circularDashKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $32db5964c492ae2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $3AM7p.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $3AM7p.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $lLd7d.getCircularProgressUtilityClass), classes);
};
const $32db5964c492ae2d$var$CircularProgressRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $32db5964c492ae2d$var$rotateAnimation || {
                    animation: `${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $32db5964c492ae2d$var$CircularProgressSVG = (0, $1Ikg4.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $32db5964c492ae2d$var$CircularProgressCircle = (0, $1Ikg4.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $32db5964c492ae2d$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $32db5964c492ae2d$var$CircularProgressTrack = (0, $1Ikg4.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $lwQO9.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $32db5964c492ae2d$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $32db5964c492ae2d$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($32db5964c492ae2d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($32db5964c492ae2d$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE} ${$32db5964c492ae2d$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $32db5964c492ae2d$var$SIZE,
                    cy: $32db5964c492ae2d$var$SIZE,
                    r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($32db5964c492ae2d$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $32db5964c492ae2d$var$SIZE,
                    cy: $32db5964c492ae2d$var$SIZE,
                    r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $32db5964c492ae2d$export$2e2bcd8739ae039 = $32db5964c492ae2d$var$CircularProgress;

});
parcelRegister("3AM7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $29da0f32997f4b8c$export$2e2bcd8739ae039);

var $gxvzd = parcelRequire("gxvzd");
var $29da0f32997f4b8c$export$2e2bcd8739ae039 = (0, $gxvzd.default);

});

parcelRegister("dn5bM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc172c5d9139290$export$2e2bcd8739ae039);
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $9bc172c5d9139290$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $9bc172c5d9139290$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$9bc172c5d9139290$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $9bc172c5d9139290$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $9bc172c5d9139290$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("lLd7d", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $fd7829380e349eb6$export$29cad1383b3f235d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $fd7829380e349eb6$export$29cad1383b3f235d(slot) {
    return (0, $4Cod0.default)('MuiCircularProgress', slot);
}
const $fd7829380e349eb6$var$circularProgressClasses = (0, $beCSm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $fd7829380e349eb6$export$2e2bcd8739ae039 = $fd7829380e349eb6$var$circularProgressClasses;

});


parcelRegister("2qneh", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $1c400751848b9b57$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $1c400751848b9b57$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $1c400751848b9b57$export$5a6f9035944c8119(slot) {
    return (0, $4Cod0.default)('MuiButton', slot);
}
const $1c400751848b9b57$var$buttonClasses = (0, $beCSm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $1c400751848b9b57$export$2e2bcd8739ae039 = $1c400751848b9b57$var$buttonClasses;

});

parcelRegister("238Rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $17e2bbdd939aa1be$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $17e2bbdd939aa1be$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $17e2bbdd939aa1be$export$2e2bcd8739ae039 = $17e2bbdd939aa1be$var$ButtonGroupContext;

});

parcelRegister("hbLi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c83825b43ed55336$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c83825b43ed55336$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c83825b43ed55336$export$2e2bcd8739ae039 = $c83825b43ed55336$var$ButtonGroupButtonContext;

});


parcelRegister("4LdGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $37762b86c13fe370$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $3AM7p = parcelRequire("3AM7p");

var $6Kj4z = parcelRequire("6Kj4z");

var $fanil = parcelRequire("fanil");

var $gc70Y = parcelRequire("gc70Y");

var $bnRzB = parcelRequire("bnRzB");

var $lNw9h = parcelRequire("lNw9h");

var $bPMNu = parcelRequire("bPMNu");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $37762b86c13fe370$var$DialogBackdrop = (0, $1Ikg4.default)((0, $bPMNu.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $37762b86c13fe370$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $3AM7p.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $3AM7p.default)(scroll)}`,
            `paperWidth${(0, $3AM7p.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bnRzB.getDialogUtilityClass), classes);
};
const $37762b86c13fe370$var$DialogRoot = (0, $1Ikg4.default)((0, $6Kj4z.default), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $37762b86c13fe370$var$DialogContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $3AM7p.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $37762b86c13fe370$var$DialogPaper = (0, $1Ikg4.default)((0, $gc70Y.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $3AM7p.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $3AM7p.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $bnRzB.default).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $bnRzB.default).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $bnRzB.default).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $37762b86c13fe370$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $b7Ol4.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $gc70Y.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $fanil.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $37762b86c13fe370$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $auC0X.default)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        elementType: $37762b86c13fe370$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $3fDLr.default)('backdrop', {
        elementType: $37762b86c13fe370$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $3fDLr.default)('paper', {
        elementType: $37762b86c13fe370$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $3fDLr.default)('container', {
        elementType: $37762b86c13fe370$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $3fDLr.default)('transition', {
        elementType: (0, $fanil.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lNw9h.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $37762b86c13fe370$export$2e2bcd8739ae039 = $37762b86c13fe370$var$Dialog;

});
parcelRegister("6Kj4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e95d56438178f01$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $3x66i = parcelRequire("3x66i");

var $8GoiI = parcelRequire("8GoiI");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $bPMNu = parcelRequire("bPMNu");

var $i4raB = parcelRequire("i4raB");

var $dzFb0 = parcelRequire("dzFb0");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4e95d56438178f01$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dzFb0.getModalUtilityClass), classes);
};
const $4e95d56438178f01$var$ModalRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4e95d56438178f01$var$ModalBackdrop = (0, $1Ikg4.default)((0, $bPMNu.default), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4e95d56438178f01$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4e95d56438178f01$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $i4raB.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4e95d56438178f01$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        elementType: $4e95d56438178f01$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $3fDLr.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $9QePP.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8GoiI.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3x66i.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4e95d56438178f01$export$2e2bcd8739ae039 = $4e95d56438178f01$var$Modal;

});
parcelRegister("3x66i", function(module, exports) {

$parcel$export(module.exports, "default", () => $29292f9ac60f4a63$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $3qSdM = parcelRequire("3qSdM");

var $6zeBo = parcelRequire("6zeBo");

var $2xc7G = parcelRequire("2xc7G");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $29292f9ac60f4a63$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $29292f9ac60f4a63$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $29292f9ac60f4a63$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $29292f9ac60f4a63$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $29292f9ac60f4a63$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($29292f9ac60f4a63$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $29292f9ac60f4a63$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $29292f9ac60f4a63$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $29292f9ac60f4a63$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $29292f9ac60f4a63$var$defaultGetTabbable, isEnabled: isEnabled = $29292f9ac60f4a63$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $6zeBo.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $29292f9ac60f4a63$export$2e2bcd8739ae039 = $29292f9ac60f4a63$var$FocusTrap;

});
parcelRegister("6zeBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8156a231c9130b$export$2e2bcd8739ae039);
function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("2xc7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d88113360503233$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});


parcelRegister("8GoiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $652518a1db38c266$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");


var $eEJPp = parcelRequire("eEJPp");

var $3qSdM = parcelRequire("3qSdM");

var $hervl = parcelRequire("hervl");

var $2xc7G = parcelRequire("2xc7G");


'use client';
function $652518a1db38c266$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $652518a1db38c266$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $3qSdM.default)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $2xc7G.default)(children) : null, forwardedRef);
    (0, $eEJPp.default)(()=>{
        if (!disablePortal) setMountNode($652518a1db38c266$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $eEJPp.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $hervl.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $hervl.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode;
});
var $652518a1db38c266$export$2e2bcd8739ae039 = $652518a1db38c266$var$Portal;

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});

parcelRegister("hervl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8b9145416f64bb2$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("bPMNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $89da4f4236459888$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $3fDLr = parcelRequire("3fDLr");

var $fanil = parcelRequire("fanil");

var $bVwty = parcelRequire("bVwty");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $89da4f4236459888$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bVwty.getBackdropUtilityClass), classes);
};
const $89da4f4236459888$var$BackdropRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $89da4f4236459888$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $89da4f4236459888$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $3fDLr.default)('root', {
        elementType: $89da4f4236459888$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $3fDLr.default)('transition', {
        elementType: (0, $fanil.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $89da4f4236459888$export$2e2bcd8739ae039 = $89da4f4236459888$var$Backdrop;

});
parcelRegister("3fDLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e19e282016bf82$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $8bslU = parcelRequire("8bslU");

var $1ESci = parcelRequire("1ESci");
'use client';
function $25e19e282016bf82$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $8bslU.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $1ESci.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $gEUd4.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("gEUd4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20bfbd9e98e2eff$export$2e2bcd8739ae039);

var $awhpc = parcelRequire("awhpc");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $awhpc.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;

});
parcelRegister("awhpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a8a64e8a5211ee5$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;

});


parcelRegister("8bslU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f5557fdc8e8d8fa$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;

});

parcelRegister("1ESci", function(module, exports) {

$parcel$export(module.exports, "default", () => $135391549c807611$export$2e2bcd8739ae039);

var $9QePP = parcelRequire("9QePP");

var $f56pe = parcelRequire("f56pe");

var $5nUQA = parcelRequire("5nUQA");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $9QePP.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f56pe.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $5nUQA.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $5nUQA.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $9QePP.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;

});
parcelRegister("f56pe", function(module, exports) {

$parcel$export(module.exports, "default", () => $afac4abdaa8d83ea$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;

});

parcelRegister("5nUQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebb326a10a78a15$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;

});



parcelRegister("fanil", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a9dc0bcc2977a8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $1mPeS = parcelRequire("1mPeS");


var $2xc7G = parcelRequire("2xc7G");

var $b7Ol4 = parcelRequire("b7Ol4");

var $MCL1V = parcelRequire("MCL1V");

var $Uq4Et = parcelRequire("Uq4Et");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b0a9dc0bcc2977a8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b0a9dc0bcc2977a8$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $b7Ol4.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $Uq4Et.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $MCL1V.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$b0a9dc0bcc2977a8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $b0a9dc0bcc2977a8$export$2e2bcd8739ae039 = $b0a9dc0bcc2977a8$var$Fade;

});
parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $beKAS = parcelRequire("beKAS");

var $a0qps = parcelRequire("a0qps");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");


var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $a0qps.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $beKAS.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("b7Ol4", function(module, exports) {

$parcel$export(module.exports, "default", () => $81976569638fc3b7$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $eM1DJ = parcelRequire("eM1DJ");

var $e7sAA = parcelRequire("e7sAA");

var $bXtHQ = parcelRequire("bXtHQ");
'use client';
function $81976569638fc3b7$export$2e2bcd8739ae039() {
    const theme = (0, $eM1DJ.default)((0, $e7sAA.default));
    return theme[0, $bXtHQ.default] || theme;
}

});
parcelRegister("eM1DJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac16d208682bdb3f$export$2e2bcd8739ae039);

var $6o2lr = parcelRequire("6o2lr");

var $g6Om4 = parcelRequire("g6Om4");
'use client';
const $ac16d208682bdb3f$export$35e57303dbd8a66 = (0, $6o2lr.default)();
function $ac16d208682bdb3f$var$useTheme(defaultTheme = $ac16d208682bdb3f$export$35e57303dbd8a66) {
    return (0, $g6Om4.default)(defaultTheme);
}
var $ac16d208682bdb3f$export$2e2bcd8739ae039 = $ac16d208682bdb3f$var$useTheme;

});
parcelRegister("g6Om4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bba4444e1ea571ca$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
parcelRequire("8zogs");
var $k7M2x = parcelRequire("k7M2x");
'use client';
function $bba4444e1ea571ca$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bba4444e1ea571ca$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $k7M2x.T));
    return !contextTheme || $bba4444e1ea571ca$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bba4444e1ea571ca$export$2e2bcd8739ae039 = $bba4444e1ea571ca$var$useTheme;

});



parcelRegister("MCL1V", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $09228c405c75d141$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $09228c405c75d141$export$8cb1e9b404609ae9);
const $09228c405c75d141$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $09228c405c75d141$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("bVwty", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $8aee358ee862b8d1$export$9927a91fd93152bd);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8aee358ee862b8d1$export$9927a91fd93152bd(slot) {
    return (0, $4Cod0.default)('MuiBackdrop', slot);
}
const $8aee358ee862b8d1$var$backdropClasses = (0, $beCSm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $8aee358ee862b8d1$export$2e2bcd8739ae039 = $8aee358ee862b8d1$var$backdropClasses;

});


parcelRegister("i4raB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27dad1a2ce77a45$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");

var $3qSdM = parcelRequire("3qSdM");

var $13KXh = parcelRequire("13KXh");

var $hPGQj = parcelRequire("hPGQj");

var $f56pe = parcelRequire("f56pe");

var $gwIIM = parcelRequire("gwIIM");
'use client';
function $d27dad1a2ce77a45$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $d27dad1a2ce77a45$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $d27dad1a2ce77a45$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $d27dad1a2ce77a45$var$manager = new (0, $gwIIM.ModalManager)();
function $d27dad1a2ce77a45$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $d27dad1a2ce77a45$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $6zeBo.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $d27dad1a2ce77a45$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $13KXh.default)(()=>{
        const resolvedContainer = $d27dad1a2ce77a45$var$getContainer(container) || getDoc().body;
        $d27dad1a2ce77a45$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$d27dad1a2ce77a45$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $13KXh.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $gwIIM.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        $d27dad1a2ce77a45$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $f56pe.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $hPGQj.default)(handleEnter, children?.props.onEnter ?? $d27dad1a2ce77a45$var$noop),
            onExited: (0, $hPGQj.default)(handleExited, children?.props.onExited ?? $d27dad1a2ce77a45$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $d27dad1a2ce77a45$export$2e2bcd8739ae039 = $d27dad1a2ce77a45$var$useModal;

});
parcelRegister("hPGQj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("gwIIM", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $c082533c6a49e8e9$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $c082533c6a49e8e9$export$ce11c4ecd08cea67);

var $9KvVX = parcelRequire("9KvVX");

var $6zeBo = parcelRequire("6zeBo");

var $aF4kJ = parcelRequire("aF4kJ");
// Is a vertical scrollbar displayed?
function $c082533c6a49e8e9$var$isOverflowing(container) {
    const doc = (0, $6zeBo.default)(container);
    if (doc.body === container) return (0, $9KvVX.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $c082533c6a49e8e9$var$getPaddingRight(element) {
    return parseInt((0, $9KvVX.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $c082533c6a49e8e9$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide);
    });
}
function $c082533c6a49e8e9$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $c082533c6a49e8e9$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($c082533c6a49e8e9$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $aF4kJ.default)((0, $9KvVX.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $6zeBo.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $6zeBo.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9KvVX.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $c082533c6a49e8e9$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $c082533c6a49e8e9$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $c082533c6a49e8e9$var$getHiddenSiblings(container);
        $c082533c6a49e8e9$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $c082533c6a49e8e9$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $c082533c6a49e8e9$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});
parcelRegister("9KvVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $71912e551e227707$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $6zeBo.default)(node);
    return doc.defaultView || window;
}

});

parcelRegister("aF4kJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0200cab69b9251c8$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});



parcelRegister("dzFb0", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $9e1e7c05d81416a0$export$67960e22b12a638d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9e1e7c05d81416a0$export$67960e22b12a638d(slot) {
    return (0, $4Cod0.default)('MuiModal', slot);
}
const $9e1e7c05d81416a0$var$modalClasses = (0, $beCSm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $9e1e7c05d81416a0$export$2e2bcd8739ae039 = $9e1e7c05d81416a0$var$modalClasses;

});


parcelRegister("gc70Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca3355350079f94$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $aSEG4 = parcelRequire("aSEG4");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $4WC2G = parcelRequire("4WC2G");

var $7Yqdf = parcelRequire("7Yqdf");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bca3355350079f94$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7Yqdf.getPaperUtilityClass), classes);
};
const $bca3355350079f94$var$PaperRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $bca3355350079f94$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $b7Ol4.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $bca3355350079f94$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bca3355350079f94$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $aSEG4.alpha)('#fff', (0, $4WC2G.default)(elevation))}, ${(0, $aSEG4.alpha)('#fff', (0, $4WC2G.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $bca3355350079f94$export$2e2bcd8739ae039 = $bca3355350079f94$var$Paper;

});
parcelRegister("7Yqdf", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $5ce2784ff2666cf4$export$29cdb466b9b6f20b);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $5ce2784ff2666cf4$export$29cdb466b9b6f20b(slot) {
    return (0, $4Cod0.default)('MuiPaper', slot);
}
const $5ce2784ff2666cf4$var$paperClasses = (0, $beCSm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $5ce2784ff2666cf4$export$2e2bcd8739ae039 = $5ce2784ff2666cf4$var$paperClasses;

});


parcelRegister("bnRzB", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", () => $849b663ea7e799fa$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $849b663ea7e799fa$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $849b663ea7e799fa$export$2177af0aa15c34c2(slot) {
    return (0, $4Cod0.default)('MuiDialog', slot);
}
const $849b663ea7e799fa$var$dialogClasses = (0, $beCSm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $849b663ea7e799fa$export$2e2bcd8739ae039 = $849b663ea7e799fa$var$dialogClasses;

});

parcelRegister("lNw9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde71ca8ed33ed16$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
const $fde71ca8ed33ed16$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $fde71ca8ed33ed16$export$2e2bcd8739ae039 = $fde71ca8ed33ed16$var$DialogContext;

});


parcelRegister("hHAIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce32ef3e14a19991$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $3ky2s = parcelRequire("3ky2s");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ce32ef3e14a19991$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3ky2s.getDialogActionsUtilityClass), classes);
};
const $ce32ef3e14a19991$var$DialogActionsRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $ce32ef3e14a19991$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $ce32ef3e14a19991$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ce32ef3e14a19991$var$DialogActionsRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ce32ef3e14a19991$export$2e2bcd8739ae039 = $ce32ef3e14a19991$var$DialogActions;

});
parcelRegister("3ky2s", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", () => $26cda4b569d13e19$export$5e57a444791c63be);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $26cda4b569d13e19$export$5e57a444791c63be(slot) {
    return (0, $4Cod0.default)('MuiDialogActions', slot);
}
const $26cda4b569d13e19$var$dialogActionsClasses = (0, $beCSm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $26cda4b569d13e19$export$2e2bcd8739ae039 = $26cda4b569d13e19$var$dialogActionsClasses;

});


parcelRegister("23H42", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fd443c9302d537$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $eRPjK = parcelRequire("eRPjK");

var $i4HmE = parcelRequire("i4HmE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $17fd443c9302d537$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $eRPjK.getDialogContentUtilityClass), classes);
};
const $17fd443c9302d537$var$DialogContentRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $i4HmE.default).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $17fd443c9302d537$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $17fd443c9302d537$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($17fd443c9302d537$var$DialogContentRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $17fd443c9302d537$export$2e2bcd8739ae039 = $17fd443c9302d537$var$DialogContent;

});
parcelRegister("eRPjK", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", () => $ad2dd284aafca16e$export$61b0ee1f05fb344e);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ad2dd284aafca16e$export$61b0ee1f05fb344e(slot) {
    return (0, $4Cod0.default)('MuiDialogContent', slot);
}
const $ad2dd284aafca16e$var$dialogContentClasses = (0, $beCSm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $ad2dd284aafca16e$export$2e2bcd8739ae039 = $ad2dd284aafca16e$var$dialogContentClasses;

});

parcelRegister("i4HmE", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", () => $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088);
$parcel$export(module.exports, "default", () => $d28a3cfcf0fa99af$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088(slot) {
    return (0, $4Cod0.default)('MuiDialogTitle', slot);
}
const $d28a3cfcf0fa99af$var$dialogTitleClasses = (0, $beCSm.default)('MuiDialogTitle', [
    'root'
]);
var $d28a3cfcf0fa99af$export$2e2bcd8739ae039 = $d28a3cfcf0fa99af$var$dialogTitleClasses;

});


parcelRegister("9cB5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b3200515d476ef1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $7X4mk = parcelRequire("7X4mk");

var $eJxbv = parcelRequire("eJxbv");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6b3200515d476ef1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $eJxbv.getDialogContentTextUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $6b3200515d476ef1$var$DialogContentTextRoot = (0, $1Ikg4.default)((0, $7X4mk.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $6b3200515d476ef1$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $6b3200515d476ef1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6b3200515d476ef1$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $6b3200515d476ef1$export$2e2bcd8739ae039 = $6b3200515d476ef1$var$DialogContentText;

});
parcelRegister("7X4mk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ca16cb6e72a53f1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acXqa = parcelRequire("acXqa");
var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $9uy85 = parcelRequire("9uy85");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5ca16cb6e72a53f1$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $5ca16cb6e72a53f1$var$extendSxProp = (0, $acXqa.internal_createExtendSxProp)();
const $5ca16cb6e72a53f1$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $3AM7p.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9uy85.getTypographyUtilityClass), classes);
};
const $5ca16cb6e72a53f1$export$140e2f5526d3cad8 = (0, $1Ikg4.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $3AM7p.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $3AM7p.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $5ca16cb6e72a53f1$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $5ca16cb6e72a53f1$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$5ca16cb6e72a53f1$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $5ca16cb6e72a53f1$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $5ca16cb6e72a53f1$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $5ca16cb6e72a53f1$var$defaultVariantMapping[variant]) || 'span';
    const classes = $5ca16cb6e72a53f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5ca16cb6e72a53f1$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $5ca16cb6e72a53f1$export$2e2bcd8739ae039 = $5ca16cb6e72a53f1$var$Typography;

});
parcelRegister("acXqa", function(module, exports) {

$parcel$export(module.exports, "globalCss", () => $76e91e24afb64923$export$db53682eef82cc11);
$parcel$export(module.exports, "internal_createExtendSxProp", () => $76e91e24afb64923$export$7e7f5719ff4debb1);
parcelRequire("acw62");

var $hcz0Q = parcelRequire("hcz0Q");

var $b7Ol4 = parcelRequire("b7Ol4");

var $aMUpj = parcelRequire("aMUpj");

var $ayMG0 = parcelRequire("ayMG0");

var $8zogs = parcelRequire("8zogs");

var $1Ikg4 = parcelRequire("1Ikg4");
function $76e91e24afb64923$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)((0, $aMUpj.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $76e91e24afb64923$export$7e7f5719ff4debb1() {
    return 0, $hcz0Q.default;
}

});
parcelRegister("hcz0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85eb76b78f8a14c$export$2e2bcd8739ae039);

var $3z1Ay = parcelRequire("3z1Ay");

var $kOOck = parcelRequire("kOOck");
const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $kOOck.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3z1Ay.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});

parcelRegister("aMUpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7daa246831c829f7$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $92iK7 = parcelRequire("92iK7");

var $e7sAA = parcelRequire("e7sAA");

var $bXtHQ = parcelRequire("bXtHQ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7daa246831c829f7$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), {
        ...props,
        defaultTheme: (0, $e7sAA.default),
        themeId: (0, $bXtHQ.default)
    });
}
var $7daa246831c829f7$export$2e2bcd8739ae039 = $7daa246831c829f7$var$GlobalStyles;

});
parcelRegister("92iK7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6942d6ec85232a9d$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $f5O3L = parcelRequire("f5O3L");
var $8TaLX = parcelRequire("8TaLX");

var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6942d6ec85232a9d$var$wrapGlobalLayer(styles) {
    const serialized = (0, $8TaLX.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $eM1DJ.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $6942d6ec85232a9d$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5O3L.default), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;

});



parcelRegister("9uy85", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $6e9163c6dd169139$export$24c1f8f60cbac79e);
$parcel$export(module.exports, "default", () => $6e9163c6dd169139$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e9163c6dd169139$export$24c1f8f60cbac79e(slot) {
    return (0, $4Cod0.default)('MuiTypography', slot);
}
const $6e9163c6dd169139$var$typographyClasses = (0, $beCSm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $6e9163c6dd169139$export$2e2bcd8739ae039 = $6e9163c6dd169139$var$typographyClasses;

});


parcelRegister("eJxbv", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", () => $ab9f026bf6924669$export$d9c6dc45f75b0e4f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ab9f026bf6924669$export$d9c6dc45f75b0e4f(slot) {
    return (0, $4Cod0.default)('MuiDialogContentText', slot);
}
const $ab9f026bf6924669$var$dialogContentTextClasses = (0, $beCSm.default)('MuiDialogContentText', [
    'root'
]);
var $ab9f026bf6924669$export$2e2bcd8739ae039 = $ab9f026bf6924669$var$dialogContentTextClasses;

});


parcelRegister("6hSWk", function(module, exports) {

$parcel$export(module.exports, "default", () => $493ef287866e3611$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $7X4mk = parcelRequire("7X4mk");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $i4HmE = parcelRequire("i4HmE");

var $lNw9h = parcelRequire("lNw9h");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $493ef287866e3611$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $i4HmE.getDialogTitleUtilityClass), classes);
};
const $493ef287866e3611$var$DialogTitleRoot = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $493ef287866e3611$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $493ef287866e3611$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $lNw9h.default));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($493ef287866e3611$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $493ef287866e3611$export$2e2bcd8739ae039 = $493ef287866e3611$var$DialogTitle;

});

parcelRegister("kZugz", function(module, exports) {

$parcel$export(module.exports, "default", () => $f480fb6201951027$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $4Kd7x = parcelRequire("4Kd7x");

var $2Rzrn = parcelRequire("2Rzrn");

var $lR7xM = parcelRequire("lR7xM");

var $6jNiK = parcelRequire("6jNiK");

var $bJgPp = parcelRequire("bJgPp");

var $cEXvm = parcelRequire("cEXvm");

var $1GEFm = parcelRequire("1GEFm");

var $jQbb4 = parcelRequire("jQbb4");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f480fb6201951027$var$variantComponent = {
    standard: (0, $4Kd7x.default),
    filled: (0, $2Rzrn.default),
    outlined: (0, $lR7xM.default)
};
const $f480fb6201951027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $jQbb4.getTextFieldUtilityClass), classes);
};
const $f480fb6201951027$var$TextFieldRoot = (0, $1Ikg4.default)((0, $bJgPp.default), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $f480fb6201951027$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $f480fb6201951027$var$useUtilityClasses(ownerState);
    const id = (0, $auC0X.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $f480fb6201951027$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $3fDLr.default)('root', {
        elementType: $f480fb6201951027$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $3fDLr.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $3fDLr.default)('inputLabel', {
        elementType: (0, $6jNiK.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $3fDLr.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $3fDLr.default)('formHelperText', {
        elementType: (0, $cEXvm.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $3fDLr.default)('select', {
        elementType: (0, $1GEFm.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $ayMG0.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $ayMG0.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $f480fb6201951027$export$2e2bcd8739ae039 = $f480fb6201951027$var$TextField;

});
parcelRegister("4Kd7x", function(module, exports) {

$parcel$export(module.exports, "default", () => $3745a2c6ea1264ac$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $3z1Ay = parcelRequire("3z1Ay");


var $b4YYn = parcelRequire("b4YYn");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $6IfCx = parcelRequire("6IfCx");

var $b4YYn = parcelRequire("b4YYn");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3745a2c6ea1264ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $6IfCx.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $3745a2c6ea1264ac$var$InputRoot = (0, $1Ikg4.default)((0, $b4YYn.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $b4YYn.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $6IfCx.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $6IfCx.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $6IfCx.default).disabled}, .${(0, $6IfCx.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $6IfCx.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $3745a2c6ea1264ac$var$InputInput = (0, $1Ikg4.default)((0, $b4YYn.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $b4YYn.inputOverridesResolver)
})({});
const $3745a2c6ea1264ac$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $3745a2c6ea1264ac$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $3745a2c6ea1264ac$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $3745a2c6ea1264ac$var$InputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4YYn.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$3745a2c6ea1264ac$var$Input.muiName = 'Input';
var $3745a2c6ea1264ac$export$2e2bcd8739ae039 = $3745a2c6ea1264ac$var$Input;

});
parcelRegister("b4YYn", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $810f5d6293d4467f$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $810f5d6293d4467f$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $810f5d6293d4467f$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseInput", () => $810f5d6293d4467f$export$ee10465db6ff6017);
$parcel$export(module.exports, "default", () => $810f5d6293d4467f$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $awhpc = parcelRequire("awhpc");

var $3LZcp = parcelRequire("3LZcp");

var $35nZB = parcelRequire("35nZB");

var $gVfKL = parcelRequire("gVfKL");

var $4tNJx = parcelRequire("4tNJx");

var $acXqa = parcelRequire("acXqa");
var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $Uq4Et = parcelRequire("Uq4Et");

var $9mcVc = parcelRequire("9mcVc");

var $gn9Oa = parcelRequire("gn9Oa");

var $7AXM0 = parcelRequire("7AXM0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $810f5d6293d4467f$var$_InputGlobalStyles;
const $810f5d6293d4467f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $810f5d6293d4467f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $810f5d6293d4467f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3AM7p.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $3AM7p.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7AXM0.getInputBaseUtilityClass), classes);
};
const $810f5d6293d4467f$export$298a043133d72a38 = (0, $1Ikg4.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $810f5d6293d4467f$export$965edad20a84fa75
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $7AXM0.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $810f5d6293d4467f$export$ee10465db6ff6017 = (0, $1Ikg4.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $810f5d6293d4467f$export$cf507b112810e72d
})((0, $lwQO9.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $7AXM0.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $7AXM0.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $810f5d6293d4467f$var$InputGlobalStyles = (0, $acXqa.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $810f5d6293d4467f$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $Uq4Et.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $gn9Oa.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $9mcVc.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $cpmCj.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $3LZcp.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $810f5d6293d4467f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $810f5d6293d4467f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $810f5d6293d4467f$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $810f5d6293d4467f$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($810f5d6293d4467f$var$_InputGlobalStyles || ($810f5d6293d4467f$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($810f5d6293d4467f$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $awhpc.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $9QePP.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gVfKL.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $awhpc.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $9QePP.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $810f5d6293d4467f$export$2e2bcd8739ae039 = $810f5d6293d4467f$var$InputBase;

});
parcelRegister("3LZcp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf53bc833721b52$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $aJ8G8 = parcelRequire("aJ8G8");

var $3qSdM = parcelRequire("3qSdM");

var $eEJPp = parcelRequire("eEJPp");

var $13KXh = parcelRequire("13KXh");

var $9KvVX = parcelRequire("9KvVX");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2bf53bc833721b52$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $2bf53bc833721b52$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $2bf53bc833721b52$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $2bf53bc833721b52$var$isEmpty(obj) {
    return $2bf53bc833721b52$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $2bf53bc833721b52$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingBottom) + $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingTop);
        const border = $2bf53bc833721b52$var$getStyleValue(computedStyle.borderBottomWidth) + $2bf53bc833721b52$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $13KXh.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $eEJPp.default)(()=>{
        const debouncedHandleResize = (0, $aJ8G8.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $9KvVX.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $eEJPp.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$2bf53bc833721b52$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $2bf53bc833721b52$export$2e2bcd8739ae039 = $2bf53bc833721b52$var$TextareaAutosize;

});
parcelRegister("aJ8G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf4d6c2077a48de$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("35nZB", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f47324c549140d$export$2e2bcd8739ae039);
function $23f47324c549140d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("gVfKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c51e307705f35677$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c51e307705f35677$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c51e307705f35677$export$2e2bcd8739ae039 = $c51e307705f35677$var$FormControlContext;

});

parcelRegister("4tNJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $343072e2ec7ced8d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $gVfKL = parcelRequire("gVfKL");
'use client';
function $343072e2ec7ced8d$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $gVfKL.default));
}

});

parcelRegister("9mcVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d0031115bbee1bb$export$2e2bcd8739ae039);

var $eEJPp = parcelRequire("eEJPp");
'use client';
var $6d0031115bbee1bb$export$2e2bcd8739ae039 = (0, $eEJPp.default);

});

parcelRegister("gn9Oa", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $beb6670688e6a4c6$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $beb6670688e6a4c6$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $beb6670688e6a4c6$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $beb6670688e6a4c6$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($beb6670688e6a4c6$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $beb6670688e6a4c6$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $beb6670688e6a4c6$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("7AXM0", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $587a42eced554844$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $587a42eced554844$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $587a42eced554844$export$ef57d5c8ca2278f6(slot) {
    return (0, $4Cod0.default)('MuiInputBase', slot);
}
const $587a42eced554844$var$inputBaseClasses = (0, $beCSm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $587a42eced554844$export$2e2bcd8739ae039 = $587a42eced554844$var$inputBaseClasses;

});


parcelRegister("6IfCx", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $4e32f80fb9096d1f$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $4e32f80fb9096d1f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $7AXM0 = parcelRequire("7AXM0");
function $4e32f80fb9096d1f$export$cdb270390122322b(slot) {
    return (0, $4Cod0.default)('MuiInput', slot);
}
const $4e32f80fb9096d1f$var$inputClasses = {
    ...(0, $7AXM0.default),
    ...(0, $beCSm.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $4e32f80fb9096d1f$export$2e2bcd8739ae039 = $4e32f80fb9096d1f$var$inputClasses;

});


parcelRegister("2Rzrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $215c05c02ba2f8f4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $3z1Ay = parcelRequire("3z1Ay");



var $8Indx = parcelRequire("8Indx");

var $b4YYn = parcelRequire("b4YYn");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $7RNFG = parcelRequire("7RNFG");

var $b4YYn = parcelRequire("b4YYn");

var $3AM7p = parcelRequire("3AM7p");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $215c05c02ba2f8f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $3AM7p.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $7RNFG.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $215c05c02ba2f8f4$var$FilledInputRoot = (0, $1Ikg4.default)((0, $b4YYn.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $b4YYn.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $7RNFG.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $7RNFG.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $7RNFG.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $7RNFG.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $7RNFG.default).disabled}, .${(0, $7RNFG.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $7RNFG.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $215c05c02ba2f8f4$var$FilledInputInput = (0, $1Ikg4.default)((0, $b4YYn.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $b4YYn.inputOverridesResolver)
})((0, $lwQO9.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $215c05c02ba2f8f4$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $215c05c02ba2f8f4$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $3z1Ay.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $215c05c02ba2f8f4$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $215c05c02ba2f8f4$var$FilledInputInput;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4YYn.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$215c05c02ba2f8f4$var$FilledInput.muiName = 'Input';
var $215c05c02ba2f8f4$export$2e2bcd8739ae039 = $215c05c02ba2f8f4$var$FilledInput;

});
parcelRegister("7RNFG", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $5ba40350513245a8$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $5ba40350513245a8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $7AXM0 = parcelRequire("7AXM0");
function $5ba40350513245a8$export$3331e419f1a48437(slot) {
    return (0, $4Cod0.default)('MuiFilledInput', slot);
}
const $5ba40350513245a8$var$filledInputClasses = {
    ...(0, $7AXM0.default),
    ...(0, $beCSm.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $5ba40350513245a8$export$2e2bcd8739ae039 = $5ba40350513245a8$var$filledInputClasses;

});


parcelRegister("lR7xM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe946640f9150f45$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $cpsNX = parcelRequire("cpsNX");

var $4tNJx = parcelRequire("4tNJx");

var $35nZB = parcelRequire("35nZB");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $8As5D = parcelRequire("8As5D");

var $b4YYn = parcelRequire("b4YYn");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $fe946640f9150f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $8As5D.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $fe946640f9150f45$var$OutlinedInputRoot = (0, $1Ikg4.default)((0, $b4YYn.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $b4YYn.rootOverridesResolver)
})((0, $lwQO9.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $8As5D.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $8As5D.default).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $8As5D.default).focused} .${(0, $8As5D.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $8As5D.default).focused} .${(0, $8As5D.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $8As5D.default).error} .${(0, $8As5D.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $8As5D.default).disabled} .${(0, $8As5D.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $fe946640f9150f45$var$NotchedOutlineRoot = (0, $1Ikg4.default)((0, $cpsNX.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $lwQO9.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $fe946640f9150f45$var$OutlinedInputInput = (0, $1Ikg4.default)((0, $b4YYn.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $b4YYn.inputOverridesResolver)
})((0, $lwQO9.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $fe946640f9150f45$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $fe946640f9150f45$var$useUtilityClasses(props);
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $fe946640f9150f45$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $fe946640f9150f45$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $3fDLr.default)('notchedOutline', {
        elementType: $fe946640f9150f45$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4YYn.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$fe946640f9150f45$var$OutlinedInput.muiName = 'Input';
var $fe946640f9150f45$export$2e2bcd8739ae039 = $fe946640f9150f45$var$OutlinedInput;

});
parcelRegister("cpsNX", function(module, exports) {

$parcel$export(module.exports, "default", () => $908e29d7221628c4$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $908e29d7221628c4$var$_span;
const $908e29d7221628c4$var$NotchedOutlineRoot = (0, $1Ikg4.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $aXkRG.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $908e29d7221628c4$var$NotchedOutlineLegend = (0, $1Ikg4.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $aXkRG.default)
})((0, $lwQO9.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $908e29d7221628c4$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($908e29d7221628c4$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: label
            }) : $908e29d7221628c4$var$_span || ($908e29d7221628c4$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("8As5D", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $64077992b1d8b572$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $64077992b1d8b572$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $7AXM0 = parcelRequire("7AXM0");
function $64077992b1d8b572$export$89922944c7227687(slot) {
    return (0, $4Cod0.default)('MuiOutlinedInput', slot);
}
const $64077992b1d8b572$var$outlinedInputClasses = {
    ...(0, $7AXM0.default),
    ...(0, $beCSm.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $64077992b1d8b572$export$2e2bcd8739ae039 = $64077992b1d8b572$var$outlinedInputClasses;

});


parcelRegister("6jNiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $499ac2a9f7a67cb8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");

var $35nZB = parcelRequire("35nZB");

var $4tNJx = parcelRequire("4tNJx");

var $iP0QO = parcelRequire("iP0QO");
var $kT1dW = parcelRequire("kT1dW");

var $3AM7p = parcelRequire("3AM7p");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $9TXlR = parcelRequire("9TXlR");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $499ac2a9f7a67cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $3AM7p.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $9TXlR.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $499ac2a9f7a67cb8$var$InputLabelRoot = (0, $1Ikg4.default)((0, $iP0QO.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $kT1dW.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $499ac2a9f7a67cb8$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $499ac2a9f7a67cb8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($499ac2a9f7a67cb8$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $499ac2a9f7a67cb8$export$2e2bcd8739ae039 = $499ac2a9f7a67cb8$var$InputLabel;

});
parcelRegister("iP0QO", function(module, exports) {

$parcel$export(module.exports, "default", () => $db3da65b5688c8f8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $35nZB = parcelRequire("35nZB");

var $4tNJx = parcelRequire("4tNJx");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $kT1dW = parcelRequire("kT1dW");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $db3da65b5688c8f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3AM7p.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kT1dW.getFormLabelUtilityClasses), classes);
};
const $db3da65b5688c8f8$export$aa5bc7f8a4705b27 = (0, $1Ikg4.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $kT1dW.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $kT1dW.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $kT1dW.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $db3da65b5688c8f8$var$AsteriskComponent = (0, $1Ikg4.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $lwQO9.default)(({ theme: theme })=>({
        [`&.${(0, $kT1dW.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $db3da65b5688c8f8$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $db3da65b5688c8f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $ayMG0.jsxs)($db3da65b5688c8f8$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $db3da65b5688c8f8$export$2e2bcd8739ae039 = $db3da65b5688c8f8$var$FormLabel;

});
parcelRegister("kT1dW", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $f349e4b76c0b885d$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $f349e4b76c0b885d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f349e4b76c0b885d$export$f7d501e40371cd17(slot) {
    return (0, $4Cod0.default)('MuiFormLabel', slot);
}
const $f349e4b76c0b885d$var$formLabelClasses = (0, $beCSm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $f349e4b76c0b885d$export$2e2bcd8739ae039 = $f349e4b76c0b885d$var$formLabelClasses;

});


parcelRegister("9TXlR", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $73574a1c301dedd6$export$c1c4b4545ad2ea5f);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $73574a1c301dedd6$export$c1c4b4545ad2ea5f(slot) {
    return (0, $4Cod0.default)('MuiInputLabel', slot);
}
const $73574a1c301dedd6$var$inputLabelClasses = (0, $beCSm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $73574a1c301dedd6$export$2e2bcd8739ae039 = $73574a1c301dedd6$var$inputLabelClasses;

});


parcelRegister("bJgPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $88a0f3656f701f08$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $gn9Oa = parcelRequire("gn9Oa");

var $3AM7p = parcelRequire("3AM7p");

var $e03L8 = parcelRequire("e03L8");

var $gVfKL = parcelRequire("gVfKL");

var $dz2MM = parcelRequire("dz2MM");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $88a0f3656f701f08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $3AM7p.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $dz2MM.getFormControlUtilityClasses), classes);
};
const $88a0f3656f701f08$var$FormControlRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $3AM7p.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $88a0f3656f701f08$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $88a0f3656f701f08$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $e03L8.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $e03L8.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $gn9Oa.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $e03L8.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $gn9Oa.isFilled)(child.props, true) || (0, $gn9Oa.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $acw62.useRef(false);
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gVfKL.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($88a0f3656f701f08$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $88a0f3656f701f08$export$2e2bcd8739ae039 = $88a0f3656f701f08$var$FormControl;

});
parcelRegister("e03L8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a313fb4a2074834f$export$2e2bcd8739ae039);

var $4NpFa = parcelRequire("4NpFa");
var $a313fb4a2074834f$export$2e2bcd8739ae039 = (0, $4NpFa.default);

});
parcelRegister("4NpFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $37dfa52af4926933$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("dz2MM", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $9e00b477c7793448$export$149c8b8bab2289d1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9e00b477c7793448$export$149c8b8bab2289d1(slot) {
    return (0, $4Cod0.default)('MuiFormControl', slot);
}
const $9e00b477c7793448$var$formControlClasses = (0, $beCSm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $9e00b477c7793448$export$2e2bcd8739ae039 = $9e00b477c7793448$var$formControlClasses;

});


parcelRegister("cEXvm", function(module, exports) {

$parcel$export(module.exports, "default", () => $937760e70ffc7914$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $35nZB = parcelRequire("35nZB");

var $4tNJx = parcelRequire("4tNJx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $giqiP = parcelRequire("giqiP");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $937760e70ffc7914$var$_span;
const $937760e70ffc7914$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $3AM7p.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $giqiP.getFormHelperTextUtilityClasses), classes);
};
const $937760e70ffc7914$var$FormHelperTextRoot = (0, $1Ikg4.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $giqiP.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $giqiP.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $937760e70ffc7914$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $937760e70ffc7914$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($937760e70ffc7914$var$FormHelperTextRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $937760e70ffc7914$var$_span || ($937760e70ffc7914$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $937760e70ffc7914$export$2e2bcd8739ae039 = $937760e70ffc7914$var$FormHelperText;

});
parcelRegister("giqiP", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $bdd2baf6568f6f86$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $bdd2baf6568f6f86$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $bdd2baf6568f6f86$export$a394fa61b1d583a9(slot) {
    return (0, $4Cod0.default)('MuiFormHelperText', slot);
}
const $bdd2baf6568f6f86$var$formHelperTextClasses = (0, $beCSm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $bdd2baf6568f6f86$export$2e2bcd8739ae039 = $bdd2baf6568f6f86$var$formHelperTextClasses;

});


parcelRegister("1GEFm", function(module, exports) {

$parcel$export(module.exports, "default", () => $13a94221f14f71e8$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $8Indx = parcelRequire("8Indx");

var $2xc7G = parcelRequire("2xc7G");

var $1bxSt = parcelRequire("1bxSt");

var $35nZB = parcelRequire("35nZB");

var $4tNJx = parcelRequire("4tNJx");

var $eVyXG = parcelRequire("eVyXG");

var $4Kd7x = parcelRequire("4Kd7x");

var $72ZSK = parcelRequire("72ZSK");

var $2Rzrn = parcelRequire("2Rzrn");

var $lR7xM = parcelRequire("lR7xM");

var $2nO41 = parcelRequire("2nO41");

var $Uq4Et = parcelRequire("Uq4Et");

var $1Ikg4 = parcelRequire("1Ikg4");

var $aXkRG = parcelRequire("aXkRG");

var $4PDYV = parcelRequire("4PDYV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $13a94221f14f71e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $4PDYV.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $13a94221f14f71e8$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) && prop !== 'variant'
};
const $13a94221f14f71e8$var$StyledInput = (0, $1Ikg4.default)((0, $4Kd7x.default), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledOutlinedInput = (0, $1Ikg4.default)((0, $lR7xM.default), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledFilledInput = (0, $1Ikg4.default)((0, $2Rzrn.default), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $eVyXG.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $72ZSK.default) : (0, $1bxSt.default);
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $13a94221f14f71e8$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $ayMG0.jsx)($13a94221f14f71e8$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $Uq4Et.default)(ref, (0, $2xc7G.default)(InputComponent));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $3z1Ay.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $9QePP.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$13a94221f14f71e8$var$Select.muiName = 'Select';
var $13a94221f14f71e8$export$2e2bcd8739ae039 = $13a94221f14f71e8$var$Select;

});
parcelRegister("1bxSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dd118e425182cac$export$2e2bcd8739ae039);

var $cpmCj = parcelRequire("cpmCj");

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");


var $cm0la = parcelRequire("cm0la");

var $3AM7p = parcelRequire("3AM7p");

var $b9dK6 = parcelRequire("b9dK6");

var $72ZSK = parcelRequire("72ZSK");

var $gn9Oa = parcelRequire("gn9Oa");

var $1Ikg4 = parcelRequire("1Ikg4");

var $9HGIl = parcelRequire("9HGIl");

var $Uq4Et = parcelRequire("Uq4Et");

var $5csPv = parcelRequire("5csPv");

var $4PDYV = parcelRequire("4PDYV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0dd118e425182cac$var$_span;
const $0dd118e425182cac$var$SelectSelect = (0, $1Ikg4.default)((0, $72ZSK.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $4PDYV.default).select}`]: styles.select
            },
            {
                [`&.${(0, $4PDYV.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $4PDYV.default).error}`]: styles.error
            },
            {
                [`&.${(0, $4PDYV.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $4PDYV.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $0dd118e425182cac$var$SelectIcon = (0, $1Ikg4.default)((0, $72ZSK.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $0dd118e425182cac$var$SelectNativeInput = (0, $1Ikg4.default)('input', {
    shouldForwardProp: (prop)=>(0, $9HGIl.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $0dd118e425182cac$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0dd118e425182cac$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $0dd118e425182cac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $3AM7p.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4PDYV.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $0dd118e425182cac$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $5csPv.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $5csPv.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $Uq4Et.default)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $cm0la.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $gn9Oa.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $cpmCj.default)(2));
            selected = value.some((v)=>$0dd118e425182cac$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0dd118e425182cac$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $0dd118e425182cac$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $auC0X.default)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $9QePP.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0dd118e425182cac$var$isEmpty(display) ? $0dd118e425182cac$var$_span || ($0dd118e425182cac$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($0dd118e425182cac$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9dK6.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $0dd118e425182cac$export$2e2bcd8739ae039 = $0dd118e425182cac$var$SelectInput;

});
parcelRegister("cm0la", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039);

var $6zeBo = parcelRequire("6zeBo");
var $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039 = (0, $6zeBo.default);

});

parcelRegister("b9dK6", function(module, exports) {

$parcel$export(module.exports, "default", () => $81db31f1007c14e1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");


var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $aGlmr = parcelRequire("aGlmr");

var $lYlV3 = parcelRequire("lYlV3");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $kwcso = parcelRequire("kwcso");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $81db31f1007c14e1$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $81db31f1007c14e1$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $81db31f1007c14e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $kwcso.getMenuUtilityClass), classes);
};
const $81db31f1007c14e1$var$MenuRoot = (0, $1Ikg4.default)((0, $lYlV3.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $81db31f1007c14e1$export$4f7c51a5920c9f33 = (0, $1Ikg4.default)((0, $lYlV3.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $81db31f1007c14e1$var$MenuMenuList = (0, $1Ikg4.default)((0, $aGlmr.default), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $81db31f1007c14e1$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $81db31f1007c14e1$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $eD6Co.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $3fDLr.default)('paper', {
        className: classes.paper,
        elementType: $81db31f1007c14e1$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $3fDLr.default)('list', {
        className: (0, $9QePP.default)(classes.list, MenuListProps.className),
        elementType: $81db31f1007c14e1$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81db31f1007c14e1$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $81db31f1007c14e1$var$RTL_ORIGIN : $81db31f1007c14e1$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $81db31f1007c14e1$export$2e2bcd8739ae039 = $81db31f1007c14e1$var$Menu;

});
parcelRegister("58lXc", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $3bcebab40d8ce666$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $3bcebab40d8ce666$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value ?? false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;

});

parcelRegister("eD6Co", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa69d7725f45330b$export$2e2bcd8739ae039);

var $3qSdM = parcelRequire("3qSdM");

var $gEUd4 = parcelRequire("gEUd4");

var $1ESci = parcelRequire("1ESci");

var $8bslU = parcelRequire("8bslU");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $8bslU.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $1ESci.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $3qSdM.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $gEUd4.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;

});

parcelRegister("aGlmr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c6e657321c9c45b$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $cm0la = parcelRequire("cm0la");

var $iFUDK = parcelRequire("iFUDK");

var $9uCgS = parcelRequire("9uCgS");

var $Uq4Et = parcelRequire("Uq4Et");

var $9mcVc = parcelRequire("9mcVc");

var $bstJo = parcelRequire("bstJo");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $7c6e657321c9c45b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $7c6e657321c9c45b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $7c6e657321c9c45b$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $9mcVc.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $9uCgS.default)((0, $bstJo.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $cm0la.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $7c6e657321c9c45b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $7c6e657321c9c45b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $Uq4Et.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iFUDK.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $7c6e657321c9c45b$export$2e2bcd8739ae039 = $7c6e657321c9c45b$var$MenuList;

});
parcelRegister("iFUDK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d987fddc25cef197$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $hAwwT = parcelRequire("hAwwT");

var $2LtAi = parcelRequire("2LtAi");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d987fddc25cef197$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2LtAi.getListUtilityClass), classes);
};
const $d987fddc25cef197$var$ListRoot = (0, $1Ikg4.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $d987fddc25cef197$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $d987fddc25cef197$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAwwT.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($d987fddc25cef197$var$ListRoot, {
            as: component,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $d987fddc25cef197$export$2e2bcd8739ae039 = $d987fddc25cef197$var$List;

});
parcelRegister("hAwwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdf08267bdb07b4$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $ccdf08267bdb07b4$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $ccdf08267bdb07b4$export$2e2bcd8739ae039 = $ccdf08267bdb07b4$var$ListContext;

});

parcelRegister("2LtAi", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $2036eb6d4835ac15$export$c6bd6795ed6e3203);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2036eb6d4835ac15$export$c6bd6795ed6e3203(slot) {
    return (0, $4Cod0.default)('MuiList', slot);
}
const $2036eb6d4835ac15$var$listClasses = (0, $beCSm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $2036eb6d4835ac15$export$2e2bcd8739ae039 = $2036eb6d4835ac15$var$listClasses;

});


parcelRegister("9uCgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e949a478f594883$export$2e2bcd8739ae039);

var $aF4kJ = parcelRequire("aF4kJ");
var $6e949a478f594883$export$2e2bcd8739ae039 = (0, $aF4kJ.default);

});

parcelRegister("bstJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $85795f3c4e07aecf$export$2e2bcd8739ae039);

var $9KvVX = parcelRequire("9KvVX");
var $85795f3c4e07aecf$export$2e2bcd8739ae039 = (0, $9KvVX.default);

});


parcelRegister("lYlV3", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $0420c70951dd1796$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $0420c70951dd1796$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");






var $awhpc = parcelRequire("awhpc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $bfMaC = parcelRequire("bfMaC");

var $cm0la = parcelRequire("cm0la");

var $bstJo = parcelRequire("bstJo");

var $7LOKt = parcelRequire("7LOKt");

var $6Kj4z = parcelRequire("6Kj4z");

var $gc70Y = parcelRequire("gc70Y");

var $ikd3w = parcelRequire("ikd3w");

var $3fDLr = parcelRequire("3fDLr");

var $fJCuc = parcelRequire("fJCuc");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0420c70951dd1796$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $0420c70951dd1796$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $0420c70951dd1796$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $0420c70951dd1796$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $0420c70951dd1796$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ikd3w.getPopoverUtilityClass), classes);
};
const $0420c70951dd1796$export$bcce13685275fc99 = (0, $1Ikg4.default)((0, $6Kj4z.default), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $0420c70951dd1796$export$821346c38a2d9390 = (0, $1Ikg4.default)((0, $gc70Y.default), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0420c70951dd1796$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $acw62.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $0420c70951dd1796$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $0420c70951dd1796$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $cm0la.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0420c70951dd1796$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0420c70951dd1796$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $0420c70951dd1796$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0420c70951dd1796$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $bstJo.default)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $bfMaC.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $bstJo.default)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $3fDLr.default)('transition', {
        elementType: (0, $7LOKt.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $cm0la.default)($0420c70951dd1796$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $3fDLr.default)('root', {
        ref: ref,
        elementType: $0420c70951dd1796$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $fJCuc.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $3fDLr.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $0420c70951dd1796$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $awhpc.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $0420c70951dd1796$export$2e2bcd8739ae039 = $0420c70951dd1796$var$Popover;

});
parcelRegister("bfMaC", function(module, exports) {

$parcel$export(module.exports, "default", () => $83167607eb9ed060$export$2e2bcd8739ae039);

var $aJ8G8 = parcelRequire("aJ8G8");
var $83167607eb9ed060$export$2e2bcd8739ae039 = (0, $aJ8G8.default);

});

parcelRegister("7LOKt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a8449c70e836e71$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $lHOu3 = parcelRequire("lHOu3");


var $2xc7G = parcelRequire("2xc7G");

var $1mPeS = parcelRequire("1mPeS");

var $b7Ol4 = parcelRequire("b7Ol4");

var $MCL1V = parcelRequire("MCL1V");

var $Uq4Et = parcelRequire("Uq4Et");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $5a8449c70e836e71$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $5a8449c70e836e71$var$styles = {
    entering: {
        opacity: 1,
        transform: $5a8449c70e836e71$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $5a8449c70e836e71$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5a8449c70e836e71$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const timer = (0, $lHOu3.default)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $b7Ol4.default)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $Uq4Et.default)(nodeRef, (0, $2xc7G.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $MCL1V.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: $5a8449c70e836e71$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $5a8449c70e836e71$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $5a8449c70e836e71$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5a8449c70e836e71$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($5a8449c70e836e71$var$Grow) $5a8449c70e836e71$var$Grow.muiSupportAuto = true;
var $5a8449c70e836e71$export$2e2bcd8739ae039 = $5a8449c70e836e71$var$Grow;

});

parcelRegister("ikd3w", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $d57438dc3523b8a0$export$88f455dd56c95edb);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d57438dc3523b8a0$export$88f455dd56c95edb(slot) {
    return (0, $4Cod0.default)('MuiPopover', slot);
}
const $d57438dc3523b8a0$var$popoverClasses = (0, $beCSm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $d57438dc3523b8a0$export$2e2bcd8739ae039 = $d57438dc3523b8a0$var$popoverClasses;

});

parcelRegister("fJCuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b748e9827e4898eb$export$2e2bcd8739ae039);

var $9QePP = parcelRequire("9QePP");
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b748e9827e4898eb$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b748e9827e4898eb$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b748e9827e4898eb$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $9QePP.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $9QePP.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("kwcso", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $ef00757e7f408a3f$export$2cf86a63a84fe23d);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ef00757e7f408a3f$export$2cf86a63a84fe23d(slot) {
    return (0, $4Cod0.default)('MuiMenu', slot);
}
const $ef00757e7f408a3f$var$menuClasses = (0, $beCSm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $ef00757e7f408a3f$export$2e2bcd8739ae039 = $ef00757e7f408a3f$var$menuClasses;

});


parcelRegister("72ZSK", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", () => $5218b8cdffce5874$export$50b3545a8ccd87af);
$parcel$export(module.exports, "StyledSelectIcon", () => $5218b8cdffce5874$export$7dd4d92f143902e3);
$parcel$export(module.exports, "default", () => $5218b8cdffce5874$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $hUQcT = parcelRequire("hUQcT");

var $1Ikg4 = parcelRequire("1Ikg4");

var $aXkRG = parcelRequire("aXkRG");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5218b8cdffce5874$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $3AM7p.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $hUQcT.getNativeSelectUtilityClasses), classes);
};
const $5218b8cdffce5874$export$50b3545a8ccd87af = (0, $1Ikg4.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $hUQcT.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectSelect = (0, $1Ikg4.default)($5218b8cdffce5874$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $aXkRG.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $hUQcT.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $5218b8cdffce5874$export$7dd4d92f143902e3 = (0, $1Ikg4.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $hUQcT.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectIcon = (0, $1Ikg4.default)($5218b8cdffce5874$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $3AM7p.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $5218b8cdffce5874$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $5218b8cdffce5874$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $9QePP.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($5218b8cdffce5874$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $5218b8cdffce5874$export$2e2bcd8739ae039 = $5218b8cdffce5874$var$NativeSelectInput;

});
parcelRegister("hUQcT", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $d0b029d306802dc1$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $d0b029d306802dc1$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d0b029d306802dc1$export$1ee13051fd9e2ab5(slot) {
    return (0, $4Cod0.default)('MuiNativeSelect', slot);
}
const $d0b029d306802dc1$var$nativeSelectClasses = (0, $beCSm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d0b029d306802dc1$export$2e2bcd8739ae039 = $d0b029d306802dc1$var$nativeSelectClasses;

});


parcelRegister("5csPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c946fbcfb716a43$export$2e2bcd8739ae039);

var $agZ85 = parcelRequire("agZ85");
'use client';
var $3c946fbcfb716a43$export$2e2bcd8739ae039 = (0, $agZ85.default);

});
parcelRegister("agZ85", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aad105771eb889$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("4PDYV", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $384af05952ac69db$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $384af05952ac69db$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $384af05952ac69db$export$2c0c1ee5a3392e(slot) {
    return (0, $4Cod0.default)('MuiSelect', slot);
}
const $384af05952ac69db$var$selectClasses = (0, $beCSm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $384af05952ac69db$export$2e2bcd8739ae039 = $384af05952ac69db$var$selectClasses;

});


parcelRegister("eVyXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade182381ccbdcec$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $ade182381ccbdcec$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});
parcelRegister("42zF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f130330883526cb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $2f130330883526cb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $2VxZV.default).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}

});
parcelRegister("2VxZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $221b46e996ce82df$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $6LnsB = parcelRequire("6LnsB");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $221b46e996ce82df$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $3AM7p.default)(color)}`,
            `fontSize${(0, $3AM7p.default)(fontSize)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6LnsB.getSvgIconUtilityClass), classes);
};
const $221b46e996ce82df$var$SvgIconRoot = (0, $1Ikg4.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            styles[`fontSize${(0, $3AM7p.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $221b46e996ce82df$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $221b46e996ce82df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($221b46e996ce82df$var$SvgIconRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$221b46e996ce82df$var$SvgIcon.muiName = 'SvgIcon';
var $221b46e996ce82df$export$2e2bcd8739ae039 = $221b46e996ce82df$var$SvgIcon;

});
parcelRegister("6LnsB", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $4ec9549e6ca0a145$export$c7c50641356bdfa5);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ec9549e6ca0a145$export$c7c50641356bdfa5(slot) {
    return (0, $4Cod0.default)('MuiSvgIcon', slot);
}
const $4ec9549e6ca0a145$var$svgIconClasses = (0, $beCSm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $4ec9549e6ca0a145$export$2e2bcd8739ae039 = $4ec9549e6ca0a145$var$svgIconClasses;

});





parcelRegister("jQbb4", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $e71b8b43f7b2f425$export$c1bdcbaf0596aeda);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $e71b8b43f7b2f425$export$c1bdcbaf0596aeda(slot) {
    return (0, $4Cod0.default)('MuiTextField', slot);
}
const $e71b8b43f7b2f425$var$textFieldClasses = (0, $beCSm.default)('MuiTextField', [
    'root'
]);
var $e71b8b43f7b2f425$export$2e2bcd8739ae039 = $e71b8b43f7b2f425$var$textFieldClasses;

});


parcelRegister("jzib7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3ef6305be93c7af$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $iN2NM = parcelRequire("iN2NM");

var $ctEfn = parcelRequire("ctEfn");

var $1H47E = parcelRequire("1H47E");

var $5EDk8 = parcelRequire("5EDk8");

var $3AM7p = parcelRequire("3AM7p");

var $aXkRG = parcelRequire("aXkRG");

var $8GNyN = parcelRequire("8GNyN");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $fJCuc = parcelRequire("fJCuc");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e3ef6305be93c7af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $3AM7p.default)(color)}`,
            `size${(0, $3AM7p.default)(size)}`
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $8GNyN.getCheckboxUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $e3ef6305be93c7af$var$CheckboxRoot = (0, $1Ikg4.default)((0, $iN2NM.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $8GNyN.default).checked}, &.${(0, $8GNyN.default).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $8GNyN.default).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $e3ef6305be93c7af$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1H47E.default), {});
const $e3ef6305be93c7af$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ctEfn.default), {});
const $e3ef6305be93c7af$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5EDk8.default), {});
const $e3ef6305be93c7af$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $e3ef6305be93c7af$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $e3ef6305be93c7af$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $e3ef6305be93c7af$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $e3ef6305be93c7af$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        elementType: $e3ef6305be93c7af$var$CheckboxRoot,
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $fJCuc.default)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $e3ef6305be93c7af$export$2e2bcd8739ae039 = $e3ef6305be93c7af$var$Checkbox;

});
parcelRegister("iN2NM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dadefa050dca578a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $5csPv = parcelRequire("5csPv");

var $4tNJx = parcelRequire("4tNJx");

var $2TZUE = parcelRequire("2TZUE");

var $HyNeS = parcelRequire("HyNeS");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dadefa050dca578a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $3AM7p.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $HyNeS.getSwitchBaseUtilityClass), classes);
};
const $dadefa050dca578a$var$SwitchBaseRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $dadefa050dca578a$var$SwitchBaseInput = (0, $1Ikg4.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $aXkRG.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $dadefa050dca578a$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $5csPv.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $4tNJx.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $dadefa050dca578a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        elementType: $dadefa050dca578a$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $3fDLr.default)('input', {
        ref: inputRef,
        elementType: $dadefa050dca578a$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $dadefa050dca578a$export$2e2bcd8739ae039 = $dadefa050dca578a$var$SwitchBase;

});
parcelRegister("HyNeS", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $082f01778759dbca$export$baa0faa0c7ad8085);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $082f01778759dbca$export$baa0faa0c7ad8085(slot) {
    return (0, $4Cod0.default)('PrivateSwitchBase', slot);
}
const $082f01778759dbca$var$switchBaseClasses = (0, $beCSm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $082f01778759dbca$export$2e2bcd8739ae039 = $082f01778759dbca$var$switchBaseClasses;

});


parcelRegister("ctEfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $915769b4d8e5eccb$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $915769b4d8e5eccb$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("1H47E", function(module, exports) {

$parcel$export(module.exports, "default", () => $13bd0137e91b5d2a$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $13bd0137e91b5d2a$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("5EDk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $41df310c6674b6f6$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $41df310c6674b6f6$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("8GNyN", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $6538b097db044083$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $6538b097db044083$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6538b097db044083$export$6c57c6e16b4063b(slot) {
    return (0, $4Cod0.default)('MuiCheckbox', slot);
}
const $6538b097db044083$var$checkboxClasses = (0, $beCSm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6538b097db044083$export$2e2bcd8739ae039 = $6538b097db044083$var$checkboxClasses;

});


parcelRegister("js9Z9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29860be68ec3320$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $4tNJx = parcelRequire("4tNJx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $7X4mk = parcelRequire("7X4mk");

var $3AM7p = parcelRequire("3AM7p");

var $6qzAc = parcelRequire("6qzAc");

var $35nZB = parcelRequire("35nZB");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e29860be68ec3320$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $3AM7p.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6qzAc.getFormControlLabelUtilityClasses), classes);
};
const $e29860be68ec3320$export$1b479270917a5676 = (0, $1Ikg4.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6qzAc.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $3AM7p.default)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $6qzAc.default).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $6qzAc.default).label}`]: {
            [`&.${(0, $6qzAc.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $e29860be68ec3320$var$AsteriskComponent = (0, $1Ikg4.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $lwQO9.default)(({ theme: theme })=>({
        [`&.${(0, $6qzAc.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $e29860be68ec3320$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $e29860be68ec3320$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $3fDLr.default)('typography', {
        elementType: (0, $7X4mk.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $7X4mk.default) && !disableTypography) label = /*#__PURE__*/ (0, $ayMG0.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $9QePP.default)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e29860be68ec3320$export$1b479270917a5676, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($e29860be68ec3320$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $e29860be68ec3320$export$2e2bcd8739ae039 = $e29860be68ec3320$var$FormControlLabel;

});
parcelRegister("6qzAc", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $4ae0c5c6bd551796$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $4ae0c5c6bd551796$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $4ae0c5c6bd551796$export$717666c39ec07e12(slot) {
    return (0, $4Cod0.default)('MuiFormControlLabel', slot);
}
const $4ae0c5c6bd551796$var$formControlLabelClasses = (0, $beCSm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $4ae0c5c6bd551796$export$2e2bcd8739ae039 = $4ae0c5c6bd551796$var$formControlLabelClasses;

});



parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("2CcMD", function(module, exports) {

$parcel$export(module.exports, "endOfDay", () => $3a979b41ec74cff7$export$eb9a03f0e9aa6cea);

var $9Jots = parcelRequire("9Jots");
function $3a979b41ec74cff7$export$eb9a03f0e9aa6cea(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$3a979b41ec74cff7$export$2e2bcd8739ae039 = $3a979b41ec74cff7$export$eb9a03f0e9aa6cea;

});
parcelRegister("9Jots", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $77dc29417ac8d032$export$e67a095c620b86fe);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $77dc29417ac8d032$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$77dc29417ac8d032$export$2e2bcd8739ae039 = $77dc29417ac8d032$export$e67a095c620b86fe;

});


parcelRegister("g04kv", function(module, exports) {

$parcel$export(module.exports, "startOfDay", () => $08eadd31071dba99$export$63fa379ae8a9ba2);

var $9Jots = parcelRequire("9Jots");
function $08eadd31071dba99$export$63fa379ae8a9ba2(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$08eadd31071dba99$export$2e2bcd8739ae039 = $08eadd31071dba99$export$63fa379ae8a9ba2;

});

parcelRegister("7pTac", function(module, exports) {

$parcel$export(module.exports, "default", () => $5665a8818306a5ca$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $202BL = parcelRequire("202BL");

var $3wBTA = parcelRequire("3wBTA");
function $5665a8818306a5ca$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $7WQrb.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $7WQrb.__rest)(nextProps, [
        "values"
    ]);
    return (0, $3wBTA.shallowEqual)(nextValues, values) && (0, $3wBTA.shallowEqual)(otherProps, nextOtherProps);
}
function $5665a8818306a5ca$var$FormattedMessage(props) {
    var intl = (0, $202BL.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $acw62.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $acw62.createElement(Component, null, $acw62.Children.toArray(nodes));
    return $acw62.createElement($acw62.Fragment, null, nodes);
}
$5665a8818306a5ca$var$FormattedMessage.displayName = 'FormattedMessage';
var $5665a8818306a5ca$var$MemoizedFormattedMessage = $acw62.memo($5665a8818306a5ca$var$FormattedMessage, $5665a8818306a5ca$var$areEqual);
$5665a8818306a5ca$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $5665a8818306a5ca$export$2e2bcd8739ae039 = $5665a8818306a5ca$var$MemoizedFormattedMessage;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("202BL", function(module, exports) {

$parcel$export(module.exports, "default", () => $174d9ac429a8b478$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jjpyU = parcelRequire("jjpyU");

var $3wBTA = parcelRequire("3wBTA");
function $174d9ac429a8b478$export$2e2bcd8739ae039() {
    var intl = $acw62.useContext((0, $jjpyU.Context));
    (0, $3wBTA.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("jjpyU", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $e0f39ec61dff1544$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $e0f39ec61dff1544$export$841858b892ce1f4c);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $9ORqK = parcelRequire("9ORqK");

var $3wBTA = parcelRequire("3wBTA");
function $e0f39ec61dff1544$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $e0f39ec61dff1544$var$IntlContext = typeof window !== 'undefined' ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $acw62.createContext(null)) : $acw62.createContext(null);
var $e0f39ec61dff1544$var$IntlConsumer = $e0f39ec61dff1544$var$IntlContext.Consumer, $e0f39ec61dff1544$var$IntlProvider = $e0f39ec61dff1544$var$IntlContext.Provider;
var $e0f39ec61dff1544$export$2881499e37b75b9a = $e0f39ec61dff1544$var$IntlProvider;
var $e0f39ec61dff1544$export$841858b892ce1f4c = $e0f39ec61dff1544$var$IntlContext;
function $e0f39ec61dff1544$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $acw62.createElement($e0f39ec61dff1544$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $3wBTA.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $acw62.createElement(WrappedComponent, (0, $7WQrb.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($e0f39ec61dff1544$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))($acw62.forwardRef(function(props, ref) {
        return $acw62.createElement(WithIntl, (0, $7WQrb.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(WithIntl, WrappedComponent);
}

});
parcelRegister("3wBTA", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", () => $2911c18a2024d56a$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $2911c18a2024d56a$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $2911c18a2024d56a$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $2911c18a2024d56a$export$d36bdfa510afb180);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $bKEJm = parcelRequire("bKEJm");

var $bwSsz = parcelRequire("bwSsz");
function $2911c18a2024d56a$export$45c4bbf6e55bba1f(intl) {
    (0, $bKEJm.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $2911c18a2024d56a$export$b52f8d6fc0d47415 = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $bwSsz.DEFAULT_INTL_CONFIG)), {
    textComponent: $acw62.Fragment
});
function $2911c18a2024d56a$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($acw62.Children.toArray(parts));
    };
}
function $2911c18a2024d56a$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("bKEJm", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $88e395d91e1e295b$export$f5708dca728d7177);
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $88e395d91e1e295b$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $88e395d91e1e295b$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $88e395d91e1e295b$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $88e395d91e1e295b$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $88e395d91e1e295b$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $88e395d91e1e295b$export$3fae2929ed23c202(map, pl, field) {
    return $88e395d91e1e295b$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $88e395d91e1e295b$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $88e395d91e1e295b$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $88e395d91e1e295b$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $88e395d91e1e295b$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $88e395d91e1e295b$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("bwSsz", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $864ced6e9596b36d$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $864ced6e9596b36d$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $864ced6e9596b36d$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $864ced6e9596b36d$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $864ced6e9596b36d$export$4ee1db8ce44a209b);

var $7WQrb = parcelRequire("7WQrb");

var $8KDXU = parcelRequire("8KDXU");

var $cimWX = parcelRequire("cimWX");

var $8Zim7 = parcelRequire("8Zim7");
function $864ced6e9596b36d$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $864ced6e9596b36d$var$defaultErrorHandler = function(error) {};
var $864ced6e9596b36d$var$defaultWarnHandler = function(warning) {};
var $864ced6e9596b36d$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $864ced6e9596b36d$var$defaultErrorHandler,
    onWarn: $864ced6e9596b36d$var$defaultWarnHandler
};
function $864ced6e9596b36d$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $864ced6e9596b36d$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $864ced6e9596b36d$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $864ced6e9596b36d$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $cimWX.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $cimWX.strategies).variadic
    });
    var getNumberFormat = (0, $cimWX.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.number),
        strategy: (0, $cimWX.strategies).variadic
    });
    var getPluralRules = (0, $cimWX.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $7WQrb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $cimWX.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $cimWX.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $8KDXU.IntlMessageFormat)(message, locales, overrideFormats, (0, $7WQrb.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.message),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $cimWX.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $cimWX.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.list),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getDisplayNames: (0, $cimWX.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $864ced6e9596b36d$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $cimWX.strategies).variadic
        })
    };
}
function $864ced6e9596b36d$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $8Zim7.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("8KDXU", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $65f19ee2190344e6$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $7WQrb = parcelRequire("7WQrb");

var $fFbHU = parcelRequire("fFbHU");

var $cimWX = parcelRequire("cimWX");

var $eoUSZ = parcelRequire("eoUSZ");
// -- MessageFormat --------------------------------------------------------
function $65f19ee2190344e6$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $65f19ee2190344e6$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $65f19ee2190344e6$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $7WQrb.__assign)({}, defaultConfig));
}
function $65f19ee2190344e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $65f19ee2190344e6$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $cimWX.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.number),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getDateTimeFormat: (0, $cimWX.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $cimWX.strategies).variadic
        }),
        getPluralRules: (0, $cimWX.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $7WQrb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $65f19ee2190344e6$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $cimWX.strategies).variadic
        })
    };
}
var $65f19ee2190344e6$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $eoUSZ.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $eoUSZ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $7WQrb.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $65f19ee2190344e6$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $65f19ee2190344e6$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $fFbHU.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("fFbHU", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("jLdHn")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("jLdHn")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("jLdHn")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("jLdHn")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("jLdHn")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("jLdHn")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("jLdHn")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("jLdHn")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("jLdHn")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("jLdHn")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("jLdHn")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("jLdHn")).TYPE);

$parcel$export(module.exports, "parse", () => $b673c42291cd7fb6$export$98e6a39c04603d36);

var $7WQrb = parcelRequire("7WQrb");

var $6z8Hv = parcelRequire("6z8Hv");

var $8jO5A = parcelRequire("8jO5A");

var $jLdHn = parcelRequire("jLdHn");
function $b673c42291cd7fb6$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jLdHn.isSelectElement)(el) || (0, $jLdHn.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $b673c42291cd7fb6$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jLdHn.isNumberElement)(el) && (0, $jLdHn.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jLdHn.isDateElement)(el) || (0, $jLdHn.isTimeElement)(el)) && (0, $jLdHn.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jLdHn.isTagElement)(el)) $b673c42291cd7fb6$var$pruneLocation(el.children);
    });
}
function $b673c42291cd7fb6$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $7WQrb.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $8jO5A.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $6z8Hv.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $b673c42291cd7fb6$var$pruneLocation(result.val);
    return result.val;
}
var $b673c42291cd7fb6$export$d3c1bfa0f7d806e9 = (0, $8jO5A.Parser);

});
parcelRegister("6z8Hv", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $4c7cc2bf81666647$export$896afd8541959ee5);
var $4c7cc2bf81666647$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($4c7cc2bf81666647$export$896afd8541959ee5 || ($4c7cc2bf81666647$export$896afd8541959ee5 = {}));

});

parcelRegister("8jO5A", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $60e6f3ba709db920$export$7acfa6ed01010e37);

var $7WQrb = parcelRequire("7WQrb");

var $6z8Hv = parcelRequire("6z8Hv");

var $jLdHn = parcelRequire("jLdHn");

var $bTwG4 = parcelRequire("bTwG4");
parcelRequire("1TlWL");
var $JriS2 = parcelRequire("JriS2");
var $8YjFP = parcelRequire("8YjFP");

var $2V8Zg = parcelRequire("2V8Zg");
var $60e6f3ba709db920$var$_a;
var $60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $bTwG4.SPACE_SEPARATOR_REGEX).source, "*"));
var $60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $bTwG4.SPACE_SEPARATOR_REGEX).source, "*$"));
function $60e6f3ba709db920$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $60e6f3ba709db920$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $60e6f3ba709db920$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $60e6f3ba709db920$var$hasNativeFromEntries = !!Object.fromEntries;
var $60e6f3ba709db920$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $60e6f3ba709db920$var$hasTrimStart = !!String.prototype.trimStart;
var $60e6f3ba709db920$var$hasTrimEnd = !!String.prototype.trimEnd;
var $60e6f3ba709db920$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $60e6f3ba709db920$var$isSafeInteger = $60e6f3ba709db920$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $60e6f3ba709db920$var$re = $60e6f3ba709db920$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = (($60e6f3ba709db920$var$_a = $60e6f3ba709db920$var$re.exec('a')) === null || $60e6f3ba709db920$var$_a === void 0 ? void 0 : $60e6f3ba709db920$var$_a[0]) === 'a';
} catch (_) {
    $60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $60e6f3ba709db920$var$startsWith = $60e6f3ba709db920$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $60e6f3ba709db920$var$fromCodePoint = $60e6f3ba709db920$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $60e6f3ba709db920$var$fromEntries = // native
$60e6f3ba709db920$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $60e6f3ba709db920$var$codePointAt = $60e6f3ba709db920$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $60e6f3ba709db920$var$trimStart = $60e6f3ba709db920$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $60e6f3ba709db920$var$trimEnd = $60e6f3ba709db920$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($60e6f3ba709db920$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $60e6f3ba709db920$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $60e6f3ba709db920$var$matchIdentifierAtIndex;
if ($60e6f3ba709db920$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1 = $60e6f3ba709db920$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $60e6f3ba709db920$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$60e6f3ba709db920$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $60e6f3ba709db920$var$codePointAt(s, index);
        if (c === undefined || $60e6f3ba709db920$var$_isWhiteSpace(c) || $60e6f3ba709db920$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, match);
};
var $60e6f3ba709db920$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jLdHn.TYPE).pound,
                    location: $60e6f3ba709db920$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $6z8Hv.ErrorKind).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $60e6f3ba709db920$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $jLdHn.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$60e6f3ba709db920$var$_isAlpha(this.char())) return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $6z8Hv.ErrorKind).UNMATCHED_CLOSING_TAG, $60e6f3ba709db920$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jLdHn.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $6z8Hv.ErrorKind).UNCLOSED_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $6z8Hv.ErrorKind).INVALID_TAG, $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $60e6f3ba709db920$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $60e6f3ba709db920$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jLdHn.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$60e6f3ba709db920$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $60e6f3ba709db920$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $60e6f3ba709db920$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $6z8Hv.ErrorKind).EMPTY_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $6z8Hv.ErrorKind).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jLdHn.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $6z8Hv.ErrorKind).MALFORMED_ARGUMENT, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $60e6f3ba709db920$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $60e6f3ba709db920$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $60e6f3ba709db920$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $60e6f3ba709db920$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $60e6f3ba709db920$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jLdHn.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $6z8Hv.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $2V8Zg.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jLdHn.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $JriS2.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $jLdHn.TYPE).date : (0, $jLdHn.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $jLdHn.TYPE).number : argType === 'date' ? (0, $jLdHn.TYPE).date : (0, $jLdHn.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $60e6f3ba709db920$var$createLocation(typeEndPosition_1, (0, $7WQrb.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $6z8Hv.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $jLdHn.TYPE).select,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jLdHn.TYPE).plural,
                        value: value,
                        options: $60e6f3ba709db920$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $6z8Hv.ErrorKind).INVALID_ARGUMENT_TYPE, $60e6f3ba709db920$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $6z8Hv.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $6z8Hv.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $60e6f3ba709db920$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $8YjFP.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $6z8Hv.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jLdHn.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $8YjFP.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $6z8Hv.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $60e6f3ba709db920$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $6z8Hv.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $6z8Hv.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $60e6f3ba709db920$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $6z8Hv.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $6z8Hv.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $6z8Hv.ErrorKind).MISSING_OTHER_CLAUSE, $60e6f3ba709db920$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $60e6f3ba709db920$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$60e6f3ba709db920$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $60e6f3ba709db920$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($60e6f3ba709db920$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $60e6f3ba709db920$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $60e6f3ba709db920$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $60e6f3ba709db920$var$_isAlphaOrSlash(codepoint) {
    return $60e6f3ba709db920$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $60e6f3ba709db920$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $60e6f3ba709db920$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jLdHn", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $e62d085b79ea4606$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $e62d085b79ea4606$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $e62d085b79ea4606$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $e62d085b79ea4606$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $e62d085b79ea4606$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $e62d085b79ea4606$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $e62d085b79ea4606$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $e62d085b79ea4606$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $e62d085b79ea4606$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $e62d085b79ea4606$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $e62d085b79ea4606$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $e62d085b79ea4606$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $e62d085b79ea4606$export$7680c41f1a55f4cf);
var $e62d085b79ea4606$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e62d085b79ea4606$export$b87f371cbc396fcf || ($e62d085b79ea4606$export$b87f371cbc396fcf = {}));
var $e62d085b79ea4606$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e62d085b79ea4606$export$906452485466fa53 || ($e62d085b79ea4606$export$906452485466fa53 = {}));
function $e62d085b79ea4606$export$cfa10c5697238752(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.literal;
}
function $e62d085b79ea4606$export$4f55724281bdfaf9(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.argument;
}
function $e62d085b79ea4606$export$e11187b219e191e1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.number;
}
function $e62d085b79ea4606$export$32d811605da75f40(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.date;
}
function $e62d085b79ea4606$export$34ec46f596b1702f(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.time;
}
function $e62d085b79ea4606$export$dcfe1c11d168b5a1(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.select;
}
function $e62d085b79ea4606$export$6c796d116f0a4fbc(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.plural;
}
function $e62d085b79ea4606$export$c0ece297bdd0c082(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.pound;
}
function $e62d085b79ea4606$export$5c83de34745812b(el) {
    return el.type === $e62d085b79ea4606$export$b87f371cbc396fcf.tag;
}
function $e62d085b79ea4606$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $e62d085b79ea4606$export$906452485466fa53.number);
}
function $e62d085b79ea4606$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $e62d085b79ea4606$export$906452485466fa53.dateTime);
}
function $e62d085b79ea4606$export$f0ac572c1121c662(value) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e62d085b79ea4606$export$425e864b0ba114f1(value, style) {
    return {
        type: $e62d085b79ea4606$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("bTwG4", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $8a8e2dd39f8c2b53$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $8a8e2dd39f8c2b53$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $8a8e2dd39f8c2b53$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("1TlWL", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("JriS2")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("8YjFP")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("8YjFP")).parseNumberSkeletonFromString);
parcelRequire("JriS2");
parcelRequire("8YjFP");

});
parcelRegister("JriS2", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $088961f6a5934025$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $088961f6a5934025$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $088961f6a5934025$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($088961f6a5934025$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("8YjFP", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $68833020532266e2$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $68833020532266e2$export$47c6f8480bda3e11);

var $7WQrb = parcelRequire("7WQrb");

var $4SzKr = parcelRequire("4SzKr");
function $68833020532266e2$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $4SzKr.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $68833020532266e2$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $68833020532266e2$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $68833020532266e2$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $68833020532266e2$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $68833020532266e2$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $68833020532266e2$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $68833020532266e2$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $68833020532266e2$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $68833020532266e2$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $68833020532266e2$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, all), $68833020532266e2$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($68833020532266e2$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($68833020532266e2$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($68833020532266e2$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($68833020532266e2$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($68833020532266e2$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), $68833020532266e2$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $68833020532266e2$var$parseSign(token.stem);
        if (signOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $68833020532266e2$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("4SzKr", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $38d7ef65502c3cf1$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $38d7ef65502c3cf1$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("2V8Zg", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $2207e049a5272320$export$29c5368be8904d27);

var $dawKT = parcelRequire("dawKT");
function $2207e049a5272320$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $2207e049a5272320$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $dawKT.timeData)[regionTag || ''] || (0, $dawKT.timeData)[languageTag || ''] || (0, $dawKT.timeData)["".concat(languageTag, "-001")] || (0, $dawKT.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("dawKT", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $99659e106fc3b209$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $99659e106fc3b209$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

});




parcelRegister("cimWX", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $8f38f7d77b1e84b6$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $8f38f7d77b1e84b6$export$c5491a8691a23b9e);
//
// Main
//
function $8f38f7d77b1e84b6$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $8f38f7d77b1e84b6$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $8f38f7d77b1e84b6$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $8f38f7d77b1e84b6$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $8f38f7d77b1e84b6$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $8f38f7d77b1e84b6$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $8f38f7d77b1e84b6$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $8f38f7d77b1e84b6$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $8f38f7d77b1e84b6$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $8f38f7d77b1e84b6$var$monadic : $8f38f7d77b1e84b6$var$variadic;
    return $8f38f7d77b1e84b6$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyVariadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$variadic, options.cache.create(), options.serializer);
}
function $8f38f7d77b1e84b6$var$strategyMonadic(fn, options) {
    return $8f38f7d77b1e84b6$var$assemble(fn, this, $8f38f7d77b1e84b6$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $8f38f7d77b1e84b6$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $8f38f7d77b1e84b6$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $8f38f7d77b1e84b6$var$ObjectWithoutPrototypeCache();
    }
};
var $8f38f7d77b1e84b6$export$c5491a8691a23b9e = {
    variadic: $8f38f7d77b1e84b6$var$strategyVariadic,
    monadic: $8f38f7d77b1e84b6$var$strategyMonadic
};

});

parcelRegister("eoUSZ", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $a7bf6eec6df43b65$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $a7bf6eec6df43b65$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $a7bf6eec6df43b65$export$275d4a3bb5f66fda);
parcelRequire("fFbHU");
var $jLdHn = parcelRequire("jLdHn");

var $fm6Ot = parcelRequire("fm6Ot");
var $a7bf6eec6df43b65$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($a7bf6eec6df43b65$export$49694c2877b44c57 || ($a7bf6eec6df43b65$export$49694c2877b44c57 = {}));
function $a7bf6eec6df43b65$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal || part.type !== $a7bf6eec6df43b65$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $a7bf6eec6df43b65$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $a7bf6eec6df43b65$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jLdHn.isLiteralElement)(els[0])) return [
        {
            type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jLdHn.isLiteralElement)(el)) {
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jLdHn.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $fm6Ot.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jLdHn.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jLdHn.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $jLdHn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $jLdHn.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $jLdHn.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $a7bf6eec6df43b65$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLdHn.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$a7bf6eec6df43b65$export$df0c12a2d414a163(formatFn)) throw new (0, $fm6Ot.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $a7bf6eec6df43b65$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $a7bf6eec6df43b65$export$49694c2877b44c57.literal : $a7bf6eec6df43b65$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jLdHn.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $fm6Ot.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jLdHn.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $fm6Ot.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fm6Ot.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $fm6Ot.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $a7bf6eec6df43b65$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $a7bf6eec6df43b65$var$mergeLiteral(result);
}

});
parcelRegister("fm6Ot", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $b2de32051be1701b$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $b2de32051be1701b$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $b2de32051be1701b$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $b2de32051be1701b$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $b2de32051be1701b$export$8bfc137e4d23fdf0);

var $7WQrb = parcelRequire("7WQrb");
var $b2de32051be1701b$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b2de32051be1701b$export$d4e71bc0b80dc0fb || ($b2de32051be1701b$export$d4e71bc0b80dc0fb = {}));
var $b2de32051be1701b$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b2de32051be1701b$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b2de32051be1701b$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b2de32051be1701b$export$7369836851cc1329);
var $b2de32051be1701b$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b2de32051be1701b$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b2de32051be1701b$export$7369836851cc1329);

});



parcelRegister("8Zim7", function(module, exports) {

$parcel$export(module.exports, "IntlErrorCode", () => $68b242487880b508$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $68b242487880b508$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $68b242487880b508$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $68b242487880b508$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $68b242487880b508$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $68b242487880b508$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $68b242487880b508$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $68b242487880b508$export$2ddcb436d0aa3688);

var $7WQrb = parcelRequire("7WQrb");
var $68b242487880b508$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($68b242487880b508$export$557d6acb76e8a244 || ($68b242487880b508$export$557d6acb76e8a244 = {}));
var $68b242487880b508$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $68b242487880b508$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $68b242487880b508$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($68b242487880b508$export$c016d36112f6ddf8);
var $68b242487880b508$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($68b242487880b508$export$e3b7eee1dbc44895);
var $68b242487880b508$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $68b242487880b508$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($68b242487880b508$export$c016d36112f6ddf8);

});






parcelRegister("dHW62", function(module, exports) {

$parcel$export(module.exports, "paths", () => $155cd4757147cec6$export$595447059867920);
$parcel$export(module.exports, "links", () => $155cd4757147cec6$export$463d32b91de8b4d);
const $155cd4757147cec6$export$595447059867920 = {
    home: '',
    photovoltaics: 'fotovoltaicka-elektrarna',
    ems: 'ems',
    boiler: 'bojler',
    grid: 'distribucni-sit',
    heatPump: 'tepelne-cerpadlo',
    statistics: 'statistiky',
    settings: 'nastaveni',
    spot: 'spot',
    plug: 'plug',
    relay: 'relay',
    energyMeters: 'elektromery',
    product_test: 'product-test',
    thermostat: 'thermostat',
    protocol: 'protokol',
    wallbox: 'wallbox',
    wallboxList: 'wallbox/seznam',
    rfidCards: 'rfid-cards',
    wind: 'vetrna-elektrarna',
    devHomepage: 'dev',
    network: 'dev/network',
    deltaGreen: 'dev/delta-green',
    electree: 'dev/electree',
    energomachine: 'dev/energomachine',
    mqttCloud: 'dev/mqtt-cloud',
    mqttBroker: 'dev/mqtt-broker',
    shellies: 'dev/shellies',
    azRouters: 'dev/az-routers',
    scripts: 'dev/scripts',
    bezDodavatele: 'dev/bez-dodavatele',
    preFlexibility: 'dev/pre-flexibility',
    enerco: 'dev/enerco',
    devCloudPlugs: 'dev/zasuvky-cloud',
    devSubscriptions: 'dev/predplatne',
    expertService: 'expert-service',
    expertServiceNetwork: 'expert-service/network',
    emsService: 'ems-service',
    appMessages: 'zpravy',
    cloudPlugs: 'zasuvky-cloud',
    auditLog: 'audit-log',
    devAppMessages: 'dev/zpravy',
    devStatusLog: 'dev/status-log',
    devInverterConfig: 'dev/konfigurace-stridacu',
    customPage: 'custom/:tabUrl',
    reports: 'reporty',
    reportDetail: 'reporty/:month'
};
const $155cd4757147cec6$export$463d32b91de8b4d = {
    home: '/',
    photovoltaics: '/fotovoltaicka-elektrarna',
    ems: '/ems',
    boiler: '/bojler',
    grid: '/distribucni-sit',
    heatPump: '/tepelne-cerpadlo',
    statistics: '/statistiky',
    settings: '/nastaveni',
    spot: '/spot',
    plug: '/plug',
    relay: '/relay',
    energyMeters: '/elektromery',
    product_test: '/product-test',
    thermostat: '/thermostat',
    protocol: '/protokol',
    wallbox: '/wallbox',
    wallboxList: '/wallbox/seznam',
    rfidCards: '/rfid-cards',
    wind: '/vetrna-elektrarna',
    appMessages: '/zpravy',
    cloudPlugs: '/zasuvky-cloud',
    devHomepage: '/dev',
    expertService: '/expert-service',
    exportServiceNetwork: '/expert-service/network',
    emsService: '/ems-service',
    auditLog: '/audit-log',
    devStatusLog: '/dev/status-log',
    devInverterConfig: '/dev/konfigurace-stridacu',
    customPage: '/custom/:tabUrl',
    reports: '/reporty',
    reportDetail: '/reporty/:month'
};

});

parcelRegister("bd9zl", function(module, exports) {

$parcel$export(module.exports, "defineMessages", () => $829854cdbad94a80$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $829854cdbad94a80$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $829854cdbad94a80$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedTime", () => $829854cdbad94a80$export$5b390a54f8a846f7);
$parcel$export(module.exports, "FormattedNumber", () => $829854cdbad94a80$export$db80edc1e6b2f63d);

var $i9SP6 = parcelRequire("i9SP6");


var $202BL = parcelRequire("202BL");

var $ezTXF = parcelRequire("ezTXF");



var $7pTac = parcelRequire("7pTac");


function $829854cdbad94a80$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $829854cdbad94a80$export$747d244ee58120dd(msg) {
    return msg;
}
var $829854cdbad94a80$export$40ae3194919d16b = (0, $i9SP6.createFormattedComponent)('formatDate');
var $829854cdbad94a80$export$5b390a54f8a846f7 = (0, $i9SP6.createFormattedComponent)('formatTime');
var $829854cdbad94a80$export$db80edc1e6b2f63d = (0, $i9SP6.createFormattedComponent)('formatNumber');
var $829854cdbad94a80$export$f52b44e459e6e71d = (0, $i9SP6.createFormattedComponent)('formatList');
var $829854cdbad94a80$export$c2336ea5aaab92fa = (0, $i9SP6.createFormattedComponent)('formatDisplayName');
var $829854cdbad94a80$export$7fdc7d2c91ce149b = (0, $i9SP6.createFormattedDateTimePartsComponent)('formatDate');
var $829854cdbad94a80$export$ec35873761676c2a = (0, $i9SP6.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("i9SP6", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $d3839801219fd2c6$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $d3839801219fd2c6$export$b37e14176d001dec);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $202BL = parcelRequire("202BL");
var $d3839801219fd2c6$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($d3839801219fd2c6$var$DisplayName || ($d3839801219fd2c6$var$DisplayName = {}));
var $d3839801219fd2c6$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($d3839801219fd2c6$var$DisplayNameParts || ($d3839801219fd2c6$var$DisplayNameParts = {}));
var $d3839801219fd2c6$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $202BL.default)();
    var value = props.value, children = props.children, formatProps = (0, $7WQrb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$d3839801219fd2c6$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $d3839801219fd2c6$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $202BL.default)();
    var value = props.value, children = props.children, formatProps = (0, $7WQrb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$d3839801219fd2c6$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $d3839801219fd2c6$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $202BL.default)();
        var value = props.value, children = props.children, formatProps = (0, $7WQrb.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $d3839801219fd2c6$var$DisplayNameParts[name];
    return ComponentParts;
}
function $d3839801219fd2c6$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $202BL.default)();
        var value = props.value, children = props.children, formatProps = (0, $7WQrb.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $acw62.Fragment;
        return $acw62.createElement(Text, null, formattedValue);
    };
    Component.displayName = $d3839801219fd2c6$var$DisplayName[name];
    return Component;
}

});

parcelRegister("ezTXF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9cfbe53a9cbd404$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $jjpyU = parcelRequire("jjpyU");

var $3wBTA = parcelRequire("3wBTA");

var $iz64E = parcelRequire("iz64E");
var $bwSsz = parcelRequire("bwSsz");
var $kOomu = parcelRequire("kOomu");

var $eoUSZ = parcelRequire("eoUSZ");
function $a9cfbe53a9cbd404$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $a9cfbe53a9cbd404$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $eoUSZ.isFormatXMLElementFn)(v) ? (0, $3wBTA.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $a9cfbe53a9cbd404$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $a9cfbe53a9cbd404$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $kOomu.formatMessage).apply(void 0, (0, $7WQrb.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $acw62.Children.toArray(chunks);
    return chunks;
};
var $a9cfbe53a9cbd404$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $7WQrb.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $a9cfbe53a9cbd404$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $iz64E.createIntl)((0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $3wBTA.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $a9cfbe53a9cbd404$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $a9cfbe53a9cbd404$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $a9cfbe53a9cbd404$var$IntlProvider = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $bwSsz.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $a9cfbe53a9cbd404$export$7e4cbedfdd7b4c0d($a9cfbe53a9cbd404$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $a9cfbe53a9cbd404$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $a9cfbe53a9cbd404$var$processIntlConfig(props);
        if (!(0, $3wBTA.shallowEqual)(prevConfig, config)) return {
            intl: $a9cfbe53a9cbd404$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $3wBTA.invariantIntlContext)(this.state.intl);
        return $acw62.createElement((0, $jjpyU.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $3wBTA.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($acw62.PureComponent);
var $a9cfbe53a9cbd404$export$2e2bcd8739ae039 = $a9cfbe53a9cbd404$var$IntlProvider;

});
parcelRegister("iz64E", function(module, exports) {

$parcel$export(module.exports, "createIntl", () => $d840350b98d505a5$export$7e4cbedfdd7b4c0d);

var $7WQrb = parcelRequire("7WQrb");

var $bwSsz = parcelRequire("bwSsz");

var $8Zim7 = parcelRequire("8Zim7");

var $lzbNs = parcelRequire("lzbNs");

var $6kGVk = parcelRequire("6kGVk");

var $7Fb99 = parcelRequire("7Fb99");

var $4aEyp = parcelRequire("4aEyp");

var $kOomu = parcelRequire("kOomu");

var $a7CPN = parcelRequire("a7CPN");

var $aLQ3f = parcelRequire("aLQ3f");
function $d840350b98d505a5$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $d840350b98d505a5$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $d840350b98d505a5$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $d840350b98d505a5$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $bwSsz.createFormatters)(cache);
    var resolvedConfig = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $bwSsz.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $8Zim7.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $8Zim7.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $8Zim7.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $d840350b98d505a5$var$verifyConfigMessages(resolvedConfig);
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $lzbNs.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $lzbNs.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $6kGVk.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $7Fb99.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $7Fb99.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $7Fb99.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $7Fb99.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $7Fb99.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $4aEyp.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $kOomu.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $kOomu.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $a7CPN.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $a7CPN.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $aLQ3f.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("lzbNs", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $fb36046a05d8490c$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $fb36046a05d8490c$export$6871080848f10b2f);

var $bwSsz = parcelRequire("bwSsz");

var $8Zim7 = parcelRequire("8Zim7");
var $fb36046a05d8490c$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $fb36046a05d8490c$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $bwSsz.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $bwSsz.filterProps)(options, $fb36046a05d8490c$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $fb36046a05d8490c$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fb36046a05d8490c$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $fb36046a05d8490c$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $fb36046a05d8490c$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

});

parcelRegister("6kGVk", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", () => $49c5e80e1e37b1ef$export$b4ea3b48dcf921f6);

var $bwSsz = parcelRequire("bwSsz");

var $fm6Ot = parcelRequire("fm6Ot");

var $8Zim7 = parcelRequire("8Zim7");
var $49c5e80e1e37b1ef$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $49c5e80e1e37b1ef$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $bwSsz.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $bwSsz.filterProps)(options, $49c5e80e1e37b1ef$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $49c5e80e1e37b1ef$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $fm6Ot.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $fm6Ot.ErrorCode).MISSING_INTL_API));
    try {
        return $49c5e80e1e37b1ef$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("7Fb99", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $017098cf53bbcffc$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $017098cf53bbcffc$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $017098cf53bbcffc$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $017098cf53bbcffc$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $017098cf53bbcffc$export$af6e5d7a5c73edeb);

var $7WQrb = parcelRequire("7WQrb");

var $bwSsz = parcelRequire("bwSsz");

var $8Zim7 = parcelRequire("8Zim7");
var $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $017098cf53bbcffc$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $bwSsz.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $bwSsz.filterProps)(options, $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $017098cf53bbcffc$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $017098cf53bbcffc$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $017098cf53bbcffc$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $bwSsz.filterProps)(options, $017098cf53bbcffc$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $017098cf53bbcffc$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $017098cf53bbcffc$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $017098cf53bbcffc$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

});

parcelRegister("4aEyp", function(module, exports) {

$parcel$export(module.exports, "formatPlural", () => $30978dc1b9a7c40c$export$bbbd05c900f3568d);

var $bwSsz = parcelRequire("bwSsz");

var $8Zim7 = parcelRequire("8Zim7");

var $fm6Ot = parcelRequire("fm6Ot");
var $30978dc1b9a7c40c$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $30978dc1b9a7c40c$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $fm6Ot.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $fm6Ot.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bwSsz.filterProps)(options, $30978dc1b9a7c40c$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $8Zim7.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("kOomu", function(module, exports) {

$parcel$export(module.exports, "formatMessage", () => $f26b5fe94260a5e5$export$25868d1e8e76735f);

var $7WQrb = parcelRequire("7WQrb");

var $bKEJm = parcelRequire("bKEJm");

var $8KDXU = parcelRequire("8KDXU");

var $8Zim7 = parcelRequire("8Zim7");
parcelRequire("fFbHU");
var $jLdHn = parcelRequire("jLdHn");
function $f26b5fe94260a5e5$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $7WQrb.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $f26b5fe94260a5e5$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $8KDXU.IntlMessageFormat).formats;
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, mfFormats), f1), {
        date: $f26b5fe94260a5e5$var$deepMergeOptions($f26b5fe94260a5e5$var$setTimeZoneInOptions(mfFormats.date, timeZone), $f26b5fe94260a5e5$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $f26b5fe94260a5e5$var$deepMergeOptions($f26b5fe94260a5e5$var$setTimeZoneInOptions(mfFormats.time, timeZone), $f26b5fe94260a5e5$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $f26b5fe94260a5e5$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $bKEJm.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $jLdHn.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, defaultRichTextElements), values || {});
    formats = $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $f26b5fe94260a5e5$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $8Zim7.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $8Zim7.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $7WQrb.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $8Zim7.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $8Zim7.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("a7CPN", function(module, exports) {

$parcel$export(module.exports, "formatList", () => $75e8ae8ff5953bf1$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $75e8ae8ff5953bf1$export$6f284aad1934db69);

var $7WQrb = parcelRequire("7WQrb");

var $bwSsz = parcelRequire("bwSsz");

var $fm6Ot = parcelRequire("fm6Ot");

var $8Zim7 = parcelRequire("8Zim7");
var $75e8ae8ff5953bf1$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $75e8ae8ff5953bf1$var$now = Date.now();
function $75e8ae8ff5953bf1$var$generateToken(i) {
    return "".concat($75e8ae8ff5953bf1$var$now, "_").concat(i, "_").concat($75e8ae8ff5953bf1$var$now);
}
function $75e8ae8ff5953bf1$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $75e8ae8ff5953bf1$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $75e8ae8ff5953bf1$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $fm6Ot.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $fm6Ot.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bwSsz.filterProps)(options, $75e8ae8ff5953bf1$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $75e8ae8ff5953bf1$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("aLQ3f", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", () => $7d76ab7739f3ed5e$export$62fe1a4d9e891fa2);

var $bwSsz = parcelRequire("bwSsz");

var $fm6Ot = parcelRequire("fm6Ot");

var $8Zim7 = parcelRequire("8Zim7");
var $7d76ab7739f3ed5e$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $7d76ab7739f3ed5e$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $fm6Ot.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $fm6Ot.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $bwSsz.filterProps)(options, $7d76ab7739f3ed5e$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $8Zim7.IntlError)((0, $8Zim7.IntlErrorCode).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

});




parcelRegister("klPA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed0dc78f73685bb9$export$2e2bcd8739ae039);

var $69Exs = parcelRequire("69Exs");


var $bnost = parcelRequire("bnost");

var $2rLZY = parcelRequire("2rLZY");

var $bXtHQ = parcelRequire("bXtHQ");

var $eYZ6X = parcelRequire("eYZ6X");
'use client';
const $ed0dc78f73685bb9$var$defaultTheme = (0, $2rLZY.default)();
const $ed0dc78f73685bb9$var$Box = (0, $69Exs.default)({
    themeId: (0, $bXtHQ.default),
    defaultTheme: $ed0dc78f73685bb9$var$defaultTheme,
    defaultClassName: (0, $eYZ6X.default).root,
    generateClassName: (0, $bnost.default).generate
});
var $ed0dc78f73685bb9$export$2e2bcd8739ae039 = $ed0dc78f73685bb9$var$Box;

});
parcelRegister("69Exs", function(module, exports) {

$parcel$export(module.exports, "default", () => $47b3077c5e8d33a3$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $8TaLX = parcelRequire("8TaLX");

var $9dZwz = parcelRequire("9dZwz");
var $hcz0Q = parcelRequire("hcz0Q");

var $eM1DJ = parcelRequire("eM1DJ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $47b3077c5e8d33a3$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $8TaLX.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $9dZwz.default));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $eM1DJ.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $hcz0Q.default)(inProps);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $9QePP.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});

parcelRegister("eYZ6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae8612b04aef23cf$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");
const $ae8612b04aef23cf$var$boxClasses = (0, $beCSm.default)('MuiBox', [
    'root'
]);
var $ae8612b04aef23cf$export$2e2bcd8739ae039 = $ae8612b04aef23cf$var$boxClasses;

});


parcelRegister("gJm6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e2000df495a70f$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $1m26d = parcelRequire("1m26d");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c2e2000df495a70f$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1m26d.getDividerUtilityClass), classes);
};
const $c2e2000df495a70f$var$DividerRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$DividerWrapper = (0, $1Ikg4.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $c2e2000df495a70f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c2e2000df495a70f$var$DividerRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($c2e2000df495a70f$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($c2e2000df495a70f$var$Divider) $c2e2000df495a70f$var$Divider.muiSkipListHighlight = true;
var $c2e2000df495a70f$export$2e2bcd8739ae039 = $c2e2000df495a70f$var$Divider;

});
parcelRegister("1m26d", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $0fc9796113f6362d$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $0fc9796113f6362d$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0fc9796113f6362d$export$46f01d01378ec5a2(slot) {
    return (0, $4Cod0.default)('MuiDivider', slot);
}
const $0fc9796113f6362d$var$dividerClasses = (0, $beCSm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $0fc9796113f6362d$export$2e2bcd8739ae039 = $0fc9796113f6362d$var$dividerClasses;

});


parcelRegister("2lSXC", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $70ff1c18f2d90dc1$export$2105062e25df4afe);
$parcel$export(module.exports, "useDispatch", () => $70ff1c18f2d90dc1$export$8ad76b76a4c905f8);
parcelRequire("jHTLJ");
var $8PZ7r = parcelRequire("8PZ7r");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");
const $70ff1c18f2d90dc1$export$2105062e25df4afe = (selector, equalityFn)=>(0, $iD0SF.useSelector)(selector, equalityFn ?? (0, $8PZ7r.default));
const $70ff1c18f2d90dc1$export$8ad76b76a4c905f8 = ()=>(0, $2OPjR.useDispatch)();

});
parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("8PZ7r")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hfliI = parcelRequire("hfliI");

var $9b0Yv = parcelRequire("9b0Yv");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");

var $iD0SF = parcelRequire("iD0SF");

var $iStRg = parcelRequire("iStRg");
parcelRequire("gCPmi");
(0, $iD0SF.initializeUseSelector)((0, $9b0Yv.useSyncExternalStoreWithSelector));
(0, $iStRg.initializeConnect)((0, $hfliI.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("30Ie1"));

});
parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
'use strict';

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});


parcelRegister("9b0Yv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6VZtt"));

});
parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
'use strict';

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);

var $1u0KT = parcelRequire("1u0KT");

});

parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
let $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
const $f9089991fdc24c9c$export$4b9874722d0da7bc = (newBatch)=>$f9089991fdc24c9c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = ()=>$f9089991fdc24c9c$var$batch;

});

parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", () => $d8fc8d639f906efc$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $d8fc8d639f906efc$export$2105062e25df4afe);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
let $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = (0, $i41js.notInitialized);
const $d8fc8d639f906efc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector = fn;
};
const $d8fc8d639f906efc$var$refEquality = (a, b)=>a === b;
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : ()=>(0, $acw62.useContext)(context);
    return function useSelector(selector, equalityFn = $d8fc8d639f906efc$var$refEquality) {
        const { store: store, subscription: subscription, getServerState: getServerState } = useReduxContext();
        const selectedState = $d8fc8d639f906efc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$c1275ca9a6fd3ec5() {
    const contextValue = (0, $acw62.useContext)((0, $7iEsg.ReactReduxContext));
    return contextValue;
}

});
parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
const $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});


parcelRegister("i41js", function(module, exports) {

$parcel$export(module.exports, "notInitialized", () => $d2699e687deeb28e$export$20656a4825650bd0);
const $d2699e687deeb28e$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("iStRg", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", () => $dbe46e5c642d971b$export$36d45daa6a4925b8);

var $cW6CV = parcelRequire("cW6CV");

var $7sasy = parcelRequire("7sasy");

var $9ORqK = parcelRequire("9ORqK");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $40Fxm = parcelRequire("40Fxm");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("7CByU");

var $7iEsg = parcelRequire("7iEsg");

var $i41js = parcelRequire("i41js");
const $dbe46e5c642d971b$var$_excluded = [
    "reactReduxForwardedRef"
];
let $dbe46e5c642d971b$var$useSyncExternalStore = (0, $i41js.notInitialized);
const $dbe46e5c642d971b$export$36d45daa6a4925b8 = (fn)=>{
    $dbe46e5c642d971b$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $dbe46e5c642d971b$var$EMPTY_ARRAY = [
    null,
    0
];
const $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $dbe46e5c642d971b$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $dbe46e5c642d971b$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $dbe46e5c642d971b$var$initStateUpdates = ()=>$dbe46e5c642d971b$var$EMPTY_ARRAY;
function $dbe46e5c642d971b$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $dbe46e5c642d971b$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $dbe46e5c642d971b$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $dbe46e5c642d971b$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8PZ7r.default), areStatePropsEqual: areStatePropsEqual = (0, $8PZ7r.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8PZ7r.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $7iEsg.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $kSE8V.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $ih4tx.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $7EQ16.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $acw62.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $7sasy.default)(props, $dbe46e5c642d971b$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $acw62.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $acw62.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $40Fxm.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $acw62.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $dbe46e5c642d971b$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $acw62.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $cW6CV.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $acw62.useRef)();
            const lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $acw62.useRef)();
            const renderIsScheduled = (0, $acw62.useRef)(false);
            const isProcessingDispatch = (0, $acw62.useRef)(false);
            const isMounted = (0, $acw62.useRef)(false);
            const latestSubscriptionCallbackError = (0, $acw62.useRef)();
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $acw62.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $acw62.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $dbe46e5c642d971b$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $dbe46e5c642d971b$var$useIsomorphicLayoutEffectWithArgs($dbe46e5c642d971b$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $dbe46e5c642d971b$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $acw62.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $cW6CV.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $acw62.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $cW6CV.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $dbe46e5c642d971b$export$2e2bcd8739ae039 = $dbe46e5c642d971b$var$connect;

});
parcelRegister("cW6CV", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b00ac47015ebe8$export$2e2bcd8739ae039);
function $96b00ac47015ebe8$export$2e2bcd8739ae039() {
    $96b00ac47015ebe8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b00ac47015ebe8$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("7sasy", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d342fca7c55ee7$export$2e2bcd8739ae039);
function $56d342fca7c55ee7$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("cfvvO", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cgj07"));

});
parcelRegister("cgj07", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $8ed5b7d8837dad8a$export$a7c73072b1a182ae, (v) => $8ed5b7d8837dad8a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $8ed5b7d8837dad8a$export$9f27bc3417b4524d, (v) => $8ed5b7d8837dad8a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac, (v) => $8ed5b7d8837dad8a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35, (v) => $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $8ed5b7d8837dad8a$export$ffb0004e005737fa, (v) => $8ed5b7d8837dad8a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $8ed5b7d8837dad8a$export$b624eff549462981, (v) => $8ed5b7d8837dad8a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $8ed5b7d8837dad8a$export$7897aa7841a5380c, (v) => $8ed5b7d8837dad8a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $8ed5b7d8837dad8a$export$602eac185826482c, (v) => $8ed5b7d8837dad8a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $8ed5b7d8837dad8a$export$e2c29f18771995cb, (v) => $8ed5b7d8837dad8a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $8ed5b7d8837dad8a$export$5f8d39834fd61797, (v) => $8ed5b7d8837dad8a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5, (v) => $8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $8ed5b7d8837dad8a$export$998bcd577473dd93, (v) => $8ed5b7d8837dad8a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $8ed5b7d8837dad8a$export$92387174baf9b227, (v) => $8ed5b7d8837dad8a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $8ed5b7d8837dad8a$export$ec112efeb987d9c6, (v) => $8ed5b7d8837dad8a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $8ed5b7d8837dad8a$export$b706b080d889d2c9, (v) => $8ed5b7d8837dad8a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $8ed5b7d8837dad8a$export$5be5a87408f70ddc, (v) => $8ed5b7d8837dad8a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d, (v) => $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $8ed5b7d8837dad8a$export$455c2e768291efa6, (v) => $8ed5b7d8837dad8a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $8ed5b7d8837dad8a$export$9522e17588c12572, (v) => $8ed5b7d8837dad8a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $8ed5b7d8837dad8a$export$2110ac352bb060b9, (v) => $8ed5b7d8837dad8a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $8ed5b7d8837dad8a$export$56885ab8b9c456ab, (v) => $8ed5b7d8837dad8a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de, (v) => $8ed5b7d8837dad8a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $8ed5b7d8837dad8a$export$b82d16f27459e05a, (v) => $8ed5b7d8837dad8a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $8ed5b7d8837dad8a$export$522c17b4f5e123e8, (v) => $8ed5b7d8837dad8a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6, (v) => $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $8ed5b7d8837dad8a$export$3d6c20d97e46b957, (v) => $8ed5b7d8837dad8a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $8ed5b7d8837dad8a$export$9b621391a187a31a, (v) => $8ed5b7d8837dad8a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f, (v) => $8ed5b7d8837dad8a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8ed5b7d8837dad8a$export$a7c73072b1a182ae;
var $8ed5b7d8837dad8a$export$9f27bc3417b4524d;
var $8ed5b7d8837dad8a$export$db77ccec0bb4ccac;
var $8ed5b7d8837dad8a$export$8392c0c9d3dcbd35;
var $8ed5b7d8837dad8a$export$ffb0004e005737fa;
var $8ed5b7d8837dad8a$export$b624eff549462981;
var $8ed5b7d8837dad8a$export$7897aa7841a5380c;
var $8ed5b7d8837dad8a$export$602eac185826482c;
var $8ed5b7d8837dad8a$export$e2c29f18771995cb;
var $8ed5b7d8837dad8a$export$5f8d39834fd61797;
var $8ed5b7d8837dad8a$export$74bf444e3cd11ea5;
var $8ed5b7d8837dad8a$export$998bcd577473dd93;
var $8ed5b7d8837dad8a$export$92387174baf9b227;
var $8ed5b7d8837dad8a$export$ec112efeb987d9c6;
var $8ed5b7d8837dad8a$export$b706b080d889d2c9;
var $8ed5b7d8837dad8a$export$5be5a87408f70ddc;
var $8ed5b7d8837dad8a$export$45a5e7f76e0caa8d;
var $8ed5b7d8837dad8a$export$455c2e768291efa6;
var $8ed5b7d8837dad8a$export$9522e17588c12572;
var $8ed5b7d8837dad8a$export$2110ac352bb060b9;
var $8ed5b7d8837dad8a$export$56885ab8b9c456ab;
var $8ed5b7d8837dad8a$export$d927fcb6adf8f9de;
var $8ed5b7d8837dad8a$export$b82d16f27459e05a;
var $8ed5b7d8837dad8a$export$522c17b4f5e123e8;
var $8ed5b7d8837dad8a$export$1aabd8a0274ecfd6;
var $8ed5b7d8837dad8a$export$3d6c20d97e46b957;
var $8ed5b7d8837dad8a$export$9b621391a187a31a;
var $8ed5b7d8837dad8a$export$f5bbd400c2f4426f;
'use strict';
var $8ed5b7d8837dad8a$var$b = Symbol.for("react.element"), $8ed5b7d8837dad8a$var$c = Symbol.for("react.portal"), $8ed5b7d8837dad8a$var$d = Symbol.for("react.fragment"), $8ed5b7d8837dad8a$var$e = Symbol.for("react.strict_mode"), $8ed5b7d8837dad8a$var$f = Symbol.for("react.profiler"), $8ed5b7d8837dad8a$var$g = Symbol.for("react.provider"), $8ed5b7d8837dad8a$var$h = Symbol.for("react.context"), $8ed5b7d8837dad8a$var$k = Symbol.for("react.server_context"), $8ed5b7d8837dad8a$var$l = Symbol.for("react.forward_ref"), $8ed5b7d8837dad8a$var$m = Symbol.for("react.suspense"), $8ed5b7d8837dad8a$var$n = Symbol.for("react.suspense_list"), $8ed5b7d8837dad8a$var$p = Symbol.for("react.memo"), $8ed5b7d8837dad8a$var$q = Symbol.for("react.lazy"), $8ed5b7d8837dad8a$var$t = Symbol.for("react.offscreen"), $8ed5b7d8837dad8a$var$u;
$8ed5b7d8837dad8a$var$u = Symbol.for("react.module.reference");
function $8ed5b7d8837dad8a$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $8ed5b7d8837dad8a$var$b:
                switch(a = a.type, a){
                    case $8ed5b7d8837dad8a$var$d:
                    case $8ed5b7d8837dad8a$var$f:
                    case $8ed5b7d8837dad8a$var$e:
                    case $8ed5b7d8837dad8a$var$m:
                    case $8ed5b7d8837dad8a$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $8ed5b7d8837dad8a$var$k:
                            case $8ed5b7d8837dad8a$var$h:
                            case $8ed5b7d8837dad8a$var$l:
                            case $8ed5b7d8837dad8a$var$q:
                            case $8ed5b7d8837dad8a$var$p:
                            case $8ed5b7d8837dad8a$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $8ed5b7d8837dad8a$var$c:
                return r;
        }
    }
}
$8ed5b7d8837dad8a$export$a7c73072b1a182ae = $8ed5b7d8837dad8a$var$h;
$8ed5b7d8837dad8a$export$9f27bc3417b4524d = $8ed5b7d8837dad8a$var$g;
$8ed5b7d8837dad8a$export$db77ccec0bb4ccac = $8ed5b7d8837dad8a$var$b;
$8ed5b7d8837dad8a$export$8392c0c9d3dcbd35 = $8ed5b7d8837dad8a$var$l;
$8ed5b7d8837dad8a$export$ffb0004e005737fa = $8ed5b7d8837dad8a$var$d;
$8ed5b7d8837dad8a$export$b624eff549462981 = $8ed5b7d8837dad8a$var$q;
$8ed5b7d8837dad8a$export$7897aa7841a5380c = $8ed5b7d8837dad8a$var$p;
$8ed5b7d8837dad8a$export$602eac185826482c = $8ed5b7d8837dad8a$var$c;
$8ed5b7d8837dad8a$export$e2c29f18771995cb = $8ed5b7d8837dad8a$var$f;
$8ed5b7d8837dad8a$export$5f8d39834fd61797 = $8ed5b7d8837dad8a$var$e;
$8ed5b7d8837dad8a$export$74bf444e3cd11ea5 = $8ed5b7d8837dad8a$var$m;
$8ed5b7d8837dad8a$export$998bcd577473dd93 = $8ed5b7d8837dad8a$var$n;
$8ed5b7d8837dad8a$export$92387174baf9b227 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$ec112efeb987d9c6 = function() {
    return !1;
};
$8ed5b7d8837dad8a$export$b706b080d889d2c9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$h;
};
$8ed5b7d8837dad8a$export$5be5a87408f70ddc = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$g;
};
$8ed5b7d8837dad8a$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8ed5b7d8837dad8a$var$b;
};
$8ed5b7d8837dad8a$export$455c2e768291efa6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$l;
};
$8ed5b7d8837dad8a$export$9522e17588c12572 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$d;
};
$8ed5b7d8837dad8a$export$2110ac352bb060b9 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$q;
};
$8ed5b7d8837dad8a$export$56885ab8b9c456ab = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$p;
};
$8ed5b7d8837dad8a$export$d927fcb6adf8f9de = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$c;
};
$8ed5b7d8837dad8a$export$b82d16f27459e05a = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$f;
};
$8ed5b7d8837dad8a$export$522c17b4f5e123e8 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$e;
};
$8ed5b7d8837dad8a$export$1aabd8a0274ecfd6 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$m;
};
$8ed5b7d8837dad8a$export$3d6c20d97e46b957 = function(a) {
    return $8ed5b7d8837dad8a$var$v(a) === $8ed5b7d8837dad8a$var$n;
};
$8ed5b7d8837dad8a$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $8ed5b7d8837dad8a$var$d || a === $8ed5b7d8837dad8a$var$f || a === $8ed5b7d8837dad8a$var$e || a === $8ed5b7d8837dad8a$var$m || a === $8ed5b7d8837dad8a$var$n || a === $8ed5b7d8837dad8a$var$t || "object" === typeof a && null !== a && (a.$$typeof === $8ed5b7d8837dad8a$var$q || a.$$typeof === $8ed5b7d8837dad8a$var$p || a.$$typeof === $8ed5b7d8837dad8a$var$g || a.$$typeof === $8ed5b7d8837dad8a$var$h || a.$$typeof === $8ed5b7d8837dad8a$var$l || a.$$typeof === $8ed5b7d8837dad8a$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$8ed5b7d8837dad8a$export$f5bbd400c2f4426f = $8ed5b7d8837dad8a$var$v;

});


parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $7sasy = parcelRequire("7sasy");
parcelRequire("d6Wo0");
const $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $7sasy.default)(_ref, $2eb761e6a8ffbe36$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $7CByU.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98b92028b84cbd13$var$verify(mapStateToProps, 'mapStateToProps');
    $98b92028b84cbd13$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $98b92028b84cbd13$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $d4dd493c66c4df43$export$b69a785ceac019a6);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $d4dd493c66c4df43$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>(0, $96XmR.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $kC3dh.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);
parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("kC3dh", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", () => $f019d9508e58fcb7$export$19ef7b929f7e2559);
function $f019d9508e58fcb7$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", () => $f337fd5395077a96$export$e00e93951827eda7);

var $3TktP = parcelRequire("3TktP");

var $kC3dh = parcelRequire("kC3dh");
function $f337fd5395077a96$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $kC3dh.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", () => $59349e43bbd01749$export$17457cf6fa742f84);

var $cW6CV = parcelRequire("cW6CV");
parcelRequire("jKoYp");

var $kC3dh = parcelRequire("kC3dh");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $cW6CV.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$59349e43bbd01749$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : (0, $kC3dh.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    const batch = (0, $lnBci.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $de1db2bafb2c3b5a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $de1db2bafb2c3b5a$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
const $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = $7a11fbbe9e9ac5f8$export$71594e8a50f746f4 ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});

parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
$parcel$export(module.exports, "shallowEqual", () => (parcelRequire("8PZ7r")).default);

var $4hUQH = parcelRequire("4hUQH");

var $iStRg = parcelRequire("iStRg");

var $7iEsg = parcelRequire("7iEsg");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");
parcelRequire("gKObn");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider({ store: store, context: context, children: children, serverState: serverState }) {
    const contextValue = (0, $acw62.useMemo)(()=>{
        const subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, $acw62.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $7iEsg.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});

parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $20d80f3cecee513e$export$8ad76b76a4c905f8);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context = (0, $7iEsg.ReactReduxContext)) {
    const useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context = (0, $7iEsg.ReactReduxContext)) {
    const useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : ()=>(0, $acw62.useContext)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});


parcelRegister("gKObn", function(module, exports) {

});




parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("u24M4", function(module, exports) {

$parcel$export(module.exports, "default", () => $05a469b554e6dcda$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $70SAr = parcelRequire("70SAr");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $2TZUE = parcelRequire("2TZUE");

var $4mI0b = parcelRequire("4mI0b");

var $3AM7p = parcelRequire("3AM7p");

var $70CeG = parcelRequire("70CeG");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $05a469b554e6dcda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $3AM7p.default)(color)}`,
            edge && `edge${(0, $3AM7p.default)(edge)}`,
            `size${(0, $3AM7p.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $70CeG.getIconButtonUtilityClass), classes);
};
const $05a469b554e6dcda$var$IconButtonRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $3AM7p.default)(ownerState.edge)}`],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $lwQO9.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $70CeG.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $70CeG.default).loading}`]: {
            color: 'transparent'
        }
    })));
const $05a469b554e6dcda$var$IconButtonLoadingIndicator = (0, $1Ikg4.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $05a469b554e6dcda$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $70SAr.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $05a469b554e6dcda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($05a469b554e6dcda$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $9QePP.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($05a469b554e6dcda$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $05a469b554e6dcda$export$2e2bcd8739ae039 = $05a469b554e6dcda$var$IconButton;

});
parcelRegister("70CeG", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $51a63158336e7c66$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $51a63158336e7c66$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $51a63158336e7c66$export$5e8702d71474f093(slot) {
    return (0, $4Cod0.default)('MuiIconButton', slot);
}
const $51a63158336e7c66$var$iconButtonClasses = (0, $beCSm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $51a63158336e7c66$export$2e2bcd8739ae039 = $51a63158336e7c66$var$iconButtonClasses;

});


parcelRegister("ngrp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $045ee6ef181778c1$export$2e2bcd8739ae039);


var $isyt6 = parcelRequire("isyt6");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");
'use client';
const $045ee6ef181778c1$var$Stack = (0, $isyt6.default)({
    createStyledComponent: (0, $1Ikg4.default)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $2nO41.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $045ee6ef181778c1$export$2e2bcd8739ae039 = $045ee6ef181778c1$var$Stack;

});
parcelRegister("isyt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70594339ba23534$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $3z1Ay = parcelRequire("3z1Ay");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $dxMBG = parcelRequire("dxMBG");

var $dFNG2 = parcelRequire("dFNG2");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $82aMg = parcelRequire("82aMg");

var $7kpn1 = parcelRequire("7kpn1");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d70594339ba23534$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $d70594339ba23534$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $d70594339ba23534$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $d70594339ba23534$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $d70594339ba23534$var$joinChildren(children, separator) {
    const childrenArray = $acw62.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $acw62.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $d70594339ba23534$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $d70594339ba23534$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $82aMg.handleBreakpoints)({
            theme: theme
        }, (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $7kpn1.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $82aMg.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $7kpn1.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$d70594339ba23534$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $7kpn1.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $82aMg.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $d70594339ba23534$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $d70594339ba23534$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $d70594339ba23534$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($d70594339ba23534$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = props;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: divider ? $d70594339ba23534$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});
parcelRegister("dxMBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dc40fba00dc8e3b$export$2e2bcd8739ae039);

var $dgmWB = parcelRequire("dgmWB");
const $9dc40fba00dc8e3b$var$styled = (0, $dgmWB.default)();
var $9dc40fba00dc8e3b$export$2e2bcd8739ae039 = $9dc40fba00dc8e3b$var$styled;

});

parcelRegister("dFNG2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f45a3834bb6880f$export$2e2bcd8739ae039);

var $cfUWu = parcelRequire("cfUWu");

var $eM1DJ = parcelRequire("eM1DJ");
'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $eM1DJ.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $cfUWu.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("cfUWu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ec30e4d54713c84$export$2e2bcd8739ae039);

var $4FZD0 = parcelRequire("4FZD0");
function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4FZD0.default)(theme.components[name].defaultProps, props);
}

});




parcelRegister("8ni7a", function(module, exports) {

$parcel$export(module.exports, "Inverter", () => $0c9c9e998227c8c4$export$691cb552608215a8);
$parcel$export(module.exports, "OemDistribution", () => $0c9c9e998227c8c4$export$ea1917bbdb770236);
$parcel$export(module.exports, "License", () => $0c9c9e998227c8c4$export$1944193dc26cf6ac);
$parcel$export(module.exports, "HeatPump", () => $0c9c9e998227c8c4$export$9cdbc5cab505edcf);
$parcel$export(module.exports, "HeatPumpStatus", () => $0c9c9e998227c8c4$export$4fc0a743e5056a4c);
$parcel$export(module.exports, "HeatPumpInfoStatus", () => $0c9c9e998227c8c4$export$fb234e084d360923);
$parcel$export(module.exports, "SmartMeterStatus", () => $0c9c9e998227c8c4$export$ac14b3a4af826e75);
$parcel$export(module.exports, "HeatWaterStatus", () => $0c9c9e998227c8c4$export$7999ee7136e469fe);
$parcel$export(module.exports, "PhotovoltaicStatus", () => $0c9c9e998227c8c4$export$10e07a02adb6be5f);
$parcel$export(module.exports, "PlugStatus", () => $0c9c9e998227c8c4$export$aff158898a6cecdc);
$parcel$export(module.exports, "SpotBatteryStatus", () => $0c9c9e998227c8c4$export$b124cc3183018989);
$parcel$export(module.exports, "SpotBatteryDischargeToGridStatus", () => $0c9c9e998227c8c4$export$23bfd5455dd49b93);
$parcel$export(module.exports, "SpotBatteryDischargeToHomeStatus", () => $0c9c9e998227c8c4$export$304e05239d7522f3);
$parcel$export(module.exports, "SpotBatteryChargeFromGridStatus", () => $0c9c9e998227c8c4$export$a5b2ae7021bbe205);
$parcel$export(module.exports, "SpotHeatPumpStatus", () => $0c9c9e998227c8c4$export$1dabf181f4ffb9bd);
$parcel$export(module.exports, "SpotHeatWaterStatus", () => $0c9c9e998227c8c4$export$16428e8d29b2abfe);
$parcel$export(module.exports, "SpotSmartMeterStatus", () => $0c9c9e998227c8c4$export$52e4717d0bbf68a1);
$parcel$export(module.exports, "WallboxStatus", () => $0c9c9e998227c8c4$export$44af608131b65ba8);
$parcel$export(module.exports, "WallboxSubStatus", () => $0c9c9e998227c8c4$export$6ad89e5ca8b5004f);
$parcel$export(module.exports, "AzRouter", () => $0c9c9e998227c8c4$export$4bc2de66308e93fe);
$parcel$export(module.exports, "Wallbox", () => $0c9c9e998227c8c4$export$3c4a512d8d27eaad);
$parcel$export(module.exports, "WindStatus", () => $0c9c9e998227c8c4$export$c76166a807e39b4d);
$parcel$export(module.exports, "HeatWater", () => $0c9c9e998227c8c4$export$a2a142ef3657a90a);
$parcel$export(module.exports, "AppUiVariant", () => $0c9c9e998227c8c4$export$1330a38be592e6b4);
$parcel$export(module.exports, "Board", () => $0c9c9e998227c8c4$export$dc537a3a3893548e);
$parcel$export(module.exports, "RelayControl", () => $0c9c9e998227c8c4$export$4cec9f647a7eeb51);
$parcel$export(module.exports, "StatsMetric", () => $0c9c9e998227c8c4$export$93bd02dbf778472a);
$parcel$export(module.exports, "SpotPriceLevel", () => $0c9c9e998227c8c4$export$eb972e27a035057);
$parcel$export(module.exports, "HpLevel", () => $0c9c9e998227c8c4$export$70a4665a3cd548c3);
$parcel$export(module.exports, "ThermostatFlexibilityLevel", () => $0c9c9e998227c8c4$export$6406951cc1e3e150);
$parcel$export(module.exports, "ThermostatLevel", () => $0c9c9e998227c8c4$export$ca0f4a13aed8bd2b);
$parcel$export(module.exports, "FlexibilityCommandBattery", () => $0c9c9e998227c8c4$export$a0b1b81b0c644d3f);
$parcel$export(module.exports, "EnergomachineBatteryMode", () => $0c9c9e998227c8c4$export$94d9caf932148732);
$parcel$export(module.exports, "FlexibilityCommandPv", () => $0c9c9e998227c8c4$export$33374d1a3daf0940);
$parcel$export(module.exports, "ConnectionType", () => $0c9c9e998227c8c4$export$3157d57b4135e3bc);
$parcel$export(module.exports, "NetworkType", () => $0c9c9e998227c8c4$export$4a868a35d3b57055);
$parcel$export(module.exports, "boardsWithInternalNetwork", () => $0c9c9e998227c8c4$export$72b8626c7e89fedc);
$parcel$export(module.exports, "invertersSupportingRS485", () => $0c9c9e998227c8c4$export$d1a3133394f93793);
$parcel$export(module.exports, "MqttCloudDeviceType", () => $0c9c9e998227c8c4$export$ba3d09ecfd0a8c33);
$parcel$export(module.exports, "GridMeteringMode", () => $0c9c9e998227c8c4$export$f9c95d1e3007df4f);
$parcel$export(module.exports, "HDOMode", () => $0c9c9e998227c8c4$export$50dde76027f3032d);
$parcel$export(module.exports, "SolaxEMS1000InverterName", () => $0c9c9e998227c8c4$export$2f9399cd3544300);
$parcel$export(module.exports, "SolaxEMS1000PROInverterName", () => $0c9c9e998227c8c4$export$b77714901b25c3d9);
$parcel$export(module.exports, "SolaxMode", () => $0c9c9e998227c8c4$export$153c5eb5035851f5);
$parcel$export(module.exports, "InverterPowerControl", () => $0c9c9e998227c8c4$export$babf5a06f43ca0db);
$parcel$export(module.exports, "DesBatteryStatus", () => $0c9c9e998227c8c4$export$9804536dfa2a8548);
$parcel$export(module.exports, "AppMessageType", () => (parcelRequire("8z3TB")).AppMessageType);
$parcel$export(module.exports, "SpotPricePeriod", () => (parcelRequire("6uJ19")).SpotPricePeriod);
$parcel$export(module.exports, "SpotRegion", () => (parcelRequire("6uJ19")).SpotRegion);
$parcel$export(module.exports, "Currency", () => (parcelRequire("6uJ19")).Currency);
$parcel$export(module.exports, "FlexibilityCommandType", () => (parcelRequire("dKB2I")).FlexibilityCommandType);

var $8z3TB = parcelRequire("8z3TB");

var $6uJ19 = parcelRequire("6uJ19");

var $dKB2I = parcelRequire("dKB2I");
var $0c9c9e998227c8c4$export$691cb552608215a8 = /*#__PURE__*/ function(Inverter) {
    Inverter[Inverter["GoodWe"] = 1] = "GoodWe";
    Inverter[Inverter["Solax"] = 2] = "Solax";
    Inverter[Inverter["Sofarsolar"] = 3] = "Sofarsolar";
    Inverter[Inverter["SolaxGrid"] = 4] = "SolaxGrid";
    Inverter[Inverter["GoodWeGrid"] = 5] = "GoodWeGrid";
    Inverter["Next"] = "next";
    Inverter["GoodWeNext"] = "good-we";
    Inverter["GoodWeGridNext"] = "good-we-grid";
    Inverter["SolaxNext"] = "solax";
    Inverter["SolaxEMS1000"] = "solax-ems1000";
    Inverter["SolaxEMS1000PRO"] = "solax-ems1000pro";
    Inverter["SolaxMICGrid"] = "solax-mic-grid";
    Inverter["SolaxMEGAGrid"] = "solax-mega-grid";
    Inverter["Victron"] = "victron";
    Inverter["SofarSolarRS485"] = "sofar-solar-rs485";
    Inverter["Solinteg"] = "solinteg";
    Inverter["Shellies"] = "shellies";
    Inverter["ShelliesExternal"] = "shellies-external";
    Inverter["Hes"] = "hes";
    Inverter["ThreeMarPLC"] = "3mar-plc";
    Inverter["Sermatec"] = "sermatec";
    Inverter["Deye"] = "deye";
    Inverter["DeyeHV"] = "deye-hv";
    Inverter["Wattsonic"] = "wattsonic";
    Inverter["Fronius"] = "fronius";
    Inverter["FroniusGrid"] = "fronius-grid";
    Inverter["FroniusVerto"] = "fronius-verto";
    Inverter["SolarEdgeGrid"] = "solar-edge-grid";
    Inverter["SmaGrid"] = "sma-grid";
    Inverter["AzRouter"] = "az-router";
    Inverter["DesBatteryContainer"] = "des-battery-container";
    Inverter["None"] = "none";
    return Inverter;
}({});
var $0c9c9e998227c8c4$export$ea1917bbdb770236 = /*#__PURE__*/ function(OemDistribution) {
    OemDistribution[OemDistribution["Infigy"] = 1] = "Infigy";
    OemDistribution[OemDistribution["DZD"] = 2] = "DZD";
    OemDistribution["Solidsun"] = "solidsun";
    return OemDistribution;
}({});
var $0c9c9e998227c8c4$export$1944193dc26cf6ac = /*#__PURE__*/ function(License) {
    License[License["Basic"] = 1] = "Basic";
    License[License["HW"] = 2] = "HW";
    License[License["SMART"] = 3] = "SMART";
    License[License["PLAY"] = 4] = "PLAY";
    License[License["INDUSTRIAL"] = 5] = "INDUSTRIAL";
    return License;
}({});
var $0c9c9e998227c8c4$export$9cdbc5cab505edcf = /*#__PURE__*/ function(HeatPump) {
    HeatPump[HeatPump["Ecoone"] = 1] = "Ecoone";
    HeatPump[HeatPump["Nibe"] = 2] = "Nibe";
    HeatPump[HeatPump["NibeF"] = 3] = "NibeF";
    HeatPump[HeatPump["Acond"] = 4] = "Acond";
    return HeatPump;
}({});
var $0c9c9e998227c8c4$export$4fc0a743e5056a4c = /*#__PURE__*/ function(HeatPumpStatus) {
    HeatPumpStatus["Heating"] = "heating";
    HeatPumpStatus["HotWater"] = "hot-water";
    HeatPumpStatus["Cooling"] = "cooling";
    HeatPumpStatus["Pool"] = "pool";
    HeatPumpStatus["Inactive"] = "inactive";
    HeatPumpStatus["NotConnected"] = "not-connected";
    HeatPumpStatus["CompressorBlocked"] = "compressor-blocked";
    HeatPumpStatus["NotLicensed"] = "not-licensed";
    return HeatPumpStatus;
}({});
var $0c9c9e998227c8c4$export$fb234e084d360923 = /*#__PURE__*/ function(HeatPumpInfoStatus) {
    HeatPumpInfoStatus["None"] = "none";
    HeatPumpInfoStatus["ConsumptionRise"] = "consumption-rise";
    HeatPumpInfoStatus["ConsumptionPostpone"] = "consumption-postpone";
    HeatPumpInfoStatus["ConsumptionWithFlexibility"] = "consumption-with-flexibility";
    HeatPumpInfoStatus["NibeNotWritable"] = "nibe-not-writable";
    return HeatPumpInfoStatus;
}({});
var $0c9c9e998227c8c4$export$ac14b3a4af826e75 = /*#__PURE__*/ function(SmartMeterStatus) {
    SmartMeterStatus["None"] = "none";
    SmartMeterStatus["Consumption"] = "consumption";
    SmartMeterStatus["Overflow"] = "overflow";
    SmartMeterStatus["OverflowLimited"] = "overflow-limited";
    SmartMeterStatus["MaxLoad"] = "max-load";
    SmartMeterStatus["Shortage"] = "shortage";
    return SmartMeterStatus;
}({});
var $0c9c9e998227c8c4$export$7999ee7136e469fe = /*#__PURE__*/ function(HeatWaterStatus) {
    HeatWaterStatus["Stop"] = "stop";
    HeatWaterStatus["Legionella"] = "legionella";
    HeatWaterStatus["Heating"] = "heating";
    HeatWaterStatus["Flexibility"] = "flexibility";
    HeatWaterStatus["SpotHeating"] = "spot-heating";
    HeatWaterStatus["NotConnected"] = "not-connected";
    HeatWaterStatus["Overload"] = "overload";
    HeatWaterStatus["StopSell"] = "stop-sell";
    HeatWaterStatus["StopHDO"] = "stop-hdo";
    HeatWaterStatus["StopSOC"] = "stop-soc";
    HeatWaterStatus["HWError"] = "hw-error";
    HeatWaterStatus["TempError"] = "temp-error";
    HeatWaterStatus["InverterError"] = "inverter-error";
    HeatWaterStatus["SmartMeterError"] = "smart-meter-error";
    HeatWaterStatus["PVHeating"] = "pv-heating";
    HeatWaterStatus["NotLicensed"] = "not-licensed";
    HeatWaterStatus["Off"] = "off";
    return HeatWaterStatus;
}({});
var $0c9c9e998227c8c4$export$10e07a02adb6be5f = /*#__PURE__*/ function(PhotovoltaicStatus) {
    PhotovoltaicStatus["Standby"] = "stand-by-mode";
    PhotovoltaicStatus["Production"] = "production";
    PhotovoltaicStatus["StartUp"] = "start-up-mode";
    PhotovoltaicStatus["Discharging"] = "discharging";
    PhotovoltaicStatus["SpotCharging"] = "spot-charging";
    PhotovoltaicStatus["ManualCharging"] = "manual-charging";
    PhotovoltaicStatus["ManualDischarging"] = "manual-discharging";
    PhotovoltaicStatus["SpotStopDischarging"] = "spot-stop-discharging";
    PhotovoltaicStatus["FlexibilityCharging"] = "flexibility-charging";
    PhotovoltaicStatus["FlexibilityDischarging"] = "flexibility-discharging";
    PhotovoltaicStatus["FlexibilityFeedInPriority"] = "flexibility-feed-in-priority";
    PhotovoltaicStatus["FlexibilityDoNotDischarge"] = "flexibility-do-not-discharge";
    PhotovoltaicStatus["FlexibilityBatteryStop"] = "flexibility-battery-stop";
    PhotovoltaicStatus["FlexibilityOverflowRestricted"] = "flexibility-overflow-restricted";
    PhotovoltaicStatus["FeedInPriority"] = "feed-in-priority";
    PhotovoltaicStatus["PlanCharge"] = "plan-charge";
    PhotovoltaicStatus["PlanDischarge"] = "plan-discharge";
    PhotovoltaicStatus["NotConnected"] = "not-connected";
    PhotovoltaicStatus["Idle"] = "idle-mode";
    PhotovoltaicStatus["SellBatteryEnergy"] = "sell-battery-energy";
    PhotovoltaicStatus["NotLicensed"] = "fve-control-not-licensed";
    PhotovoltaicStatus["NoneInverter"] = "inverter-type-not-set";
    PhotovoltaicStatus["DistributionLimit"] = "distribution-limit";
    PhotovoltaicStatus["ForcedOverflow"] = "forced-overflow";
    PhotovoltaicStatus["StopDischargingComponents"] = "stop-discharging-components";
    PhotovoltaicStatus["DischargeBlockedByHDO"] = "discharge-blocked-by-hdo";
    PhotovoltaicStatus["DischargeBlockedByComponents"] = "discharge-blocked-by-components";
    return PhotovoltaicStatus;
}({});
var $0c9c9e998227c8c4$export$aff158898a6cecdc = /*#__PURE__*/ function(PlugStatus) {
    PlugStatus["STOP"] = "stop";
    PlugStatus["BatteryControl"] = "battery-control";
    PlugStatus["SpotControl"] = "spot-control";
    PlugStatus["TimeControl"] = "time-control";
    PlugStatus["OverflowControl"] = "overflow-control";
    PlugStatus["ManualControl"] = "manual-control";
    PlugStatus["NotConnected"] = "not-connected";
    PlugStatus["NotActive"] = "not-active";
    return PlugStatus;
}({});
var $0c9c9e998227c8c4$export$b124cc3183018989 = /*#__PURE__*/ function(SpotBatteryStatus) {
    SpotBatteryStatus["FlexibilityPV"] = "flexibility-pv";
    SpotBatteryStatus["FlexibilitySpot"] = "flexibility-spot";
    SpotBatteryStatus["NoData"] = "no-data";
    SpotBatteryStatus["SpotNotLicensed"] = "spot-not-licensed";
    return SpotBatteryStatus;
}({});
var $0c9c9e998227c8c4$export$23bfd5455dd49b93 = /*#__PURE__*/ function(SpotBatteryDischargeToGridStatus) {
    SpotBatteryDischargeToGridStatus["SpotNotActive"] = "spot-not-active";
    SpotBatteryDischargeToGridStatus["BatteryDischargingNotActive"] = "battery-discharging-not-active";
    SpotBatteryDischargeToGridStatus["MinPriceNotReached"] = "min-price-not-reached";
    SpotBatteryDischargeToGridStatus["NotEnoughBatteryEnergy"] = "not-enough-battery-energy";
    SpotBatteryDischargeToGridStatus["BatteryDischargingPlanned"] = "battery-discharging-planned";
    return SpotBatteryDischargeToGridStatus;
}({});
var $0c9c9e998227c8c4$export$304e05239d7522f3 = /*#__PURE__*/ function(SpotBatteryDischargeToHomeStatus) {
    SpotBatteryDischargeToHomeStatus["AutomaticDischargeMode"] = "automatic-discharge-mode";
    SpotBatteryDischargeToHomeStatus["HighPriceDischargeMode"] = "high-price-discharge-mode";
    SpotBatteryDischargeToHomeStatus["MediumAndHighPriceDischargeMode"] = "medium-and-high-price-discharge-mode";
    SpotBatteryDischargeToHomeStatus["NotControlled"] = "not-controlled";
    return SpotBatteryDischargeToHomeStatus;
}({});
var $0c9c9e998227c8c4$export$a5b2ae7021bbe205 = /*#__PURE__*/ function(SpotBatteryChargeFromGridStatus) {
    SpotBatteryChargeFromGridStatus["SpotNotActive"] = "spot-not-active";
    SpotBatteryChargeFromGridStatus["BatteryChargingNotActive"] = "battery-charging-not-active";
    SpotBatteryChargeFromGridStatus["PriceDifferenceTooLow"] = "price-difference-too-low";
    SpotBatteryChargeFromGridStatus["EnoughPVEnergy"] = "enough-pv-energy";
    SpotBatteryChargeFromGridStatus["BatteryChargingPlanned"] = "battery-charging-planned";
    return SpotBatteryChargeFromGridStatus;
}({});
var $0c9c9e998227c8c4$export$1dabf181f4ffb9bd = /*#__PURE__*/ function(SpotHeatPumpStatus) {
    SpotHeatPumpStatus["FlexibilityPV"] = "flexibility-pv";
    SpotHeatPumpStatus["FlexibilitySpot"] = "flexibility-spot";
    SpotHeatPumpStatus["NoData"] = "no-data";
    SpotHeatPumpStatus["SpotNotLicensed"] = "spot-not-licensed";
    return SpotHeatPumpStatus;
}({});
var $0c9c9e998227c8c4$export$16428e8d29b2abfe = /*#__PURE__*/ function(SpotHeatWaterStatus) {
    SpotHeatWaterStatus["FlexibilityPV"] = "flexibility-pv";
    SpotHeatWaterStatus["FlexibilitySpot"] = "flexibility-spot";
    SpotHeatWaterStatus["NoData"] = "no-data";
    SpotHeatWaterStatus["SpotNotLicensed"] = "spot-not-licensed";
    return SpotHeatWaterStatus;
}({});
var $0c9c9e998227c8c4$export$52e4717d0bbf68a1 = /*#__PURE__*/ function(SpotSmartMeterStatus) {
    SpotSmartMeterStatus["NoData"] = "no-data";
    SpotSmartMeterStatus["SpotNotLicensed"] = "spot-not-licensed";
    SpotSmartMeterStatus["WithoutReduction"] = "without-reduction";
    SpotSmartMeterStatus["OverflowFlexibilitySell"] = "overflow-flexibility-sell";
    SpotSmartMeterStatus["OverflowDisabled"] = "overflow-disabled";
    SpotSmartMeterStatus["OverflowLimited"] = "overflow-limited";
    return SpotSmartMeterStatus;
}({});
var $0c9c9e998227c8c4$export$44af608131b65ba8 = /*#__PURE__*/ function(WallboxStatus) {
    WallboxStatus["NotConnected"] = "not-connected";
    WallboxStatus["Off"] = "off";
    WallboxStatus["Normal"] = "normal";
    WallboxStatus["CarNotConnected"] = "car-not-connected";
    WallboxStatus["Ready"] = "ready";
    WallboxStatus["Charging"] = "charging";
    WallboxStatus["ChargingWithVentilation"] = "charging-with-ventilation";
    WallboxStatus["Error"] = "error";
    return WallboxStatus;
}({});
var $0c9c9e998227c8c4$export$6ad89e5ca8b5004f = /*#__PURE__*/ function(WallboxSubStatus) {
    WallboxSubStatus["None"] = "none";
    WallboxSubStatus["BasicEnergy"] = "basic-energy";
    WallboxSubStatus["BatteryWaiting"] = "battery-waiting";
    WallboxSubStatus["Battery"] = "battery";
    WallboxSubStatus["Photovoltaics"] = "photovoltaics";
    WallboxSubStatus["Spot"] = "spot";
    WallboxSubStatus["SpotMid"] = "spot-mid";
    WallboxSubStatus["SpotHigh"] = "spot-high";
    WallboxSubStatus["Auto"] = "auto";
    WallboxSubStatus["HDOBlock"] = "hdo-block";
    WallboxSubStatus["BatteryFast"] = "battery-fast";
    WallboxSubStatus["Schedule"] = "schedule";
    WallboxSubStatus["NoCharging"] = "no-charging";
    return WallboxSubStatus;
}({});
var $0c9c9e998227c8c4$export$8a7488af19135f9e = /*#__PURE__*/ function(RfidReader) {
    RfidReader["Inveo"] = "inveo";
    return RfidReader;
}({});
var $0c9c9e998227c8c4$export$4bc2de66308e93fe = /*#__PURE__*/ function(AzRouter) {
    AzRouter["V1"] = "v1";
    return AzRouter;
}({});
var $0c9c9e998227c8c4$export$3c4a512d8d27eaad = /*#__PURE__*/ function(Wallbox) {
    Wallbox[Wallbox["None"] = 0] = "None";
    Wallbox[Wallbox["Solax"] = 1] = "Solax";
    Wallbox[Wallbox["EvMate"] = 2] = "EvMate";
    Wallbox[Wallbox["MyBox"] = 3] = "MyBox";
    Wallbox[Wallbox["VictronEvCharger"] = 4] = "VictronEvCharger";
    Wallbox[Wallbox["SolaxEvCharger"] = 5] = "SolaxEvCharger";
    Wallbox["Olife"] = "olife";
    Wallbox["GoodweEvCharger"] = "goodwe";
    Wallbox["Alfen"] = "alfen";
    Wallbox["Ecovolter"] = "ecovolter";
    Wallbox["Next"] = "next";
    Wallbox["AzRouter"] = "az-router";
    return Wallbox;
}({});
var $0c9c9e998227c8c4$export$c76166a807e39b4d = /*#__PURE__*/ function(WindStatus) {
    WindStatus["Production"] = "production";
    WindStatus["Stop"] = "stop";
    WindStatus["Unavailable"] = "unavailable";
    return WindStatus;
}({});
var $0c9c9e998227c8c4$export$a2a142ef3657a90a = /*#__PURE__*/ function(HeatWater) {
    HeatWater[HeatWater["Proportional"] = 1] = "Proportional";
    HeatWater[HeatWater["Digital"] = 2] = "Digital";
    return HeatWater;
}({});
var $0c9c9e998227c8c4$export$d35b5cb6d204f057 = /*#__PURE__*/ function(FlexibilityType) {
    FlexibilityType[FlexibilityType["Stop"] = 1] = "Stop";
    FlexibilityType[FlexibilityType["Up"] = 2] = "Up";
    FlexibilityType[FlexibilityType["Down"] = 3] = "Down";
    return FlexibilityType;
}({});
var $0c9c9e998227c8c4$export$1330a38be592e6b4 = /*#__PURE__*/ function(AppUiVariant) {
    AppUiVariant["Default"] = "default";
    AppUiVariant["Ryse"] = "ryse";
    AppUiVariant["Innogy"] = "innogy";
    AppUiVariant["Solidsun"] = "solidsun";
    return AppUiVariant;
}({});
var $0c9c9e998227c8c4$export$dc537a3a3893548e = /*#__PURE__*/ function(Board) {
    Board["V1"] = "v1";
    Board["V2"] = "v2";
    Board["Play"] = "play";
    Board["SunBerry"] = "sunberry";
    return Board;
}({});
var $0c9c9e998227c8c4$export$4cec9f647a7eeb51 = /*#__PURE__*/ function(RelayControl) {
    RelayControl["None"] = "none";
    RelayControl["Plug1"] = "plug1";
    RelayControl["Plug2"] = "plug2";
    RelayControl["Plug3"] = "plug3";
    RelayControl["Plug4"] = "plug4";
    RelayControl["SpotLow"] = "spot-low";
    RelayControl["SpotHi"] = "spot-hi";
    RelayControl["SpotMi"] = "spot-mi";
    RelayControl["SpotNegative"] = "spot-negative";
    RelayControl["SpotPriceBelow"] = "spot-price-below";
    RelayControl["SpotPriceAbove"] = "spot-price-above";
    RelayControl["SpotHi15M"] = "spot-hi-15m";
    RelayControl["SpotMi15M"] = "spot-mi-15m";
    RelayControl["SpotLow15M"] = "spot-low-15m";
    RelayControl["SpotNegative15M"] = "spot-negative-15m";
    RelayControl["SpotPriceBelow15M"] = "spot-price-below-15m";
    RelayControl["SpotPriceAbove15M"] = "spot-price-above-15m";
    RelayControl["HDO"] = "hdo";
    RelayControl["BatteryFull"] = "battery-full";
    RelayControl["BatteryLow"] = "battery-low";
    RelayControl["BatteryBelowSOC"] = "battery-below-soc";
    RelayControl["HeatWaterMaxTemp"] = "heat-water-max-temp";
    RelayControl["HeatWaterAboveTemp"] = "heat-water-above-temp";
    RelayControl["HeatWaterBelowTemp"] = "heat-water-below-temp";
    RelayControl["Thermostat1"] = "thermostat1";
    RelayControl["Thermostat2"] = "thermostat2";
    RelayControl["Thermostat3"] = "thermostat3";
    RelayControl["Thermostat4"] = "thermostat4";
    RelayControl["SpotBatteryDischarge"] = "spot-battery-discharge";
    RelayControl["SpotStopAccumulation"] = "spot-stop-accumulation";
    RelayControl["Active"] = "active";
    return RelayControl;
}({});
var $0c9c9e998227c8c4$export$fa5f90bfb4dbdbcd = /*#__PURE__*/ function(Operator) {
    Operator["None"] = "none";
    Operator["And"] = "and";
    Operator["Or"] = "or";
    Operator["AndNot"] = "andNot";
    Operator["OrNot"] = "orNot";
    return Operator;
}({});
var $0c9c9e998227c8c4$export$93bd02dbf778472a = /*#__PURE__*/ function(StatsMetric) {
    StatsMetric["PV_POWER_GRAPH"] = "pv-power-graph";
    StatsMetric["PV_POWER_STRING_GRAPH"] = "pv-power-string-graph";
    StatsMetric["HW_POWER_GRAPH"] = "hw-power-graph";
    StatsMetric["HW_POWER_PHASE_GRAPH"] = "hw-power-phase-graph";
    StatsMetric["HP_CONSUMED_GRAPH"] = "hp-consumed-graph";
    StatsMetric["EM_CONSUMED_GRAPH"] = "em-consumed-graph";
    StatsMetric["EM_CONSUMED_PHASE_GRAPH"] = "em-consumed-phase-graph";
    StatsMetric["EM_OVERFLOW_GRAPH"] = "em-overflow-graph";
    StatsMetric["EM_OVERFLOW_PHASE_GRAPH"] = "em-overflow-phase-graph";
    StatsMetric["PL_POWER_GRAPH"] = "pl-power-graph";
    StatsMetric["WB_CONSUMED_GRAPH"] = "wb-consumed-graph";
    StatsMetric["PV_BATTERY_SOC_GRAPH"] = "pv-battery-soc-graph";
    StatsMetric["PV_BATTERY_CHARGE_GRAPH"] = "pv-battery-charge-graph";
    StatsMetric["PV_BATTERY_DISCHARGE_GRAPH"] = "pv-battery-discharge-graph";
    StatsMetric["HW_TEMP_GRAPH"] = "hw-temp-graph";
    StatsMetric["THERMOSTAT_TEMP_GRAPH"] = "thermostat-temp-graph";
    StatsMetric["OUTDOOR_TEMP_GRAPH"] = "outdoor-temp-graph";
    StatsMetric["WIND_POWER_GRAPH"] = "wind-power-graph";
    StatsMetric["WIND_BATTERY_CHARGE_POWER_GRAPH"] = "wind-battery-charge-power-graph";
    StatsMetric["WIND_SPEED_GRAPH"] = "wind-speed-graph";
    StatsMetric["WIND_LOAD_CURRENT_GRAPH"] = "wind-load-current-graph";
    StatsMetric["HOME_CONSUMPTION"] = "home-consumption";
    StatsMetric["EM_METER_POWER_GRAPH"] = "em-meter-power-graph";
    StatsMetric["EM_METER_POWER_PHASE_GRAPH"] = "em-meter-power-phase-graph";
    return StatsMetric;
}({});
var $0c9c9e998227c8c4$export$eb972e27a035057 = /*#__PURE__*/ function(SpotPriceLevel) {
    SpotPriceLevel["Low"] = "low";
    SpotPriceLevel["Mid"] = "middle";
    SpotPriceLevel["Hi"] = "hi";
    return SpotPriceLevel;
}({});
var $0c9c9e998227c8c4$export$70a4665a3cd548c3 = /*#__PURE__*/ function(HpLevel) {
    HpLevel["Increase"] = "increase";
    HpLevel["Normal"] = "normal";
    HpLevel["Reduction"] = "reduction";
    return HpLevel;
}({});
var $0c9c9e998227c8c4$export$6406951cc1e3e150 = /*#__PURE__*/ function(ThermostatFlexibilityLevel) {
    ThermostatFlexibilityLevel["IncreasePv"] = "Flxibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle fotovoltaiky";
    ThermostatFlexibilityLevel["IncreaseSpot"] = "Flexibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle SPOTU";
    ThermostatFlexibilityLevel["Normal"] = "Norm\xe1ln\xed";
    ThermostatFlexibilityLevel["ReductionSpot"] = "Flexibilita vyu\u017Eita pro sn\xed\u017Een\xed teploty dle SPOTU";
    return ThermostatFlexibilityLevel;
}({});
var $0c9c9e998227c8c4$export$ca0f4a13aed8bd2b = /*#__PURE__*/ function(ThermostatLevel) {
    ThermostatLevel["Deactivated"] = "Neaktivn\xed";
    ThermostatLevel["Heating"] = "Vyt\xe1p\u011Bn\xed";
    ThermostatLevel["Cooling"] = "Chlazen\xed";
    ThermostatLevel["StandBy"] = "StandBy";
    ThermostatLevel["TempErr"] = "Chyba teploty";
    return ThermostatLevel;
}({});
var $0c9c9e998227c8c4$export$9f4884d231dd556 = /*#__PURE__*/ function(LicenseExtension) {
    LicenseExtension["Hw"] = "hw";
    LicenseExtension["Thermostat"] = "thermostat";
    return LicenseExtension;
}({});
var $0c9c9e998227c8c4$export$a0b1b81b0c644d3f = /*#__PURE__*/ function(FlexibilityCommandBattery) {
    FlexibilityCommandBattery["Default"] = "default";
    FlexibilityCommandBattery["ChargeFromGrid"] = "charge_from_grid";
    FlexibilityCommandBattery["DoNotCharge"] = "do_not_charge";
    FlexibilityCommandBattery["DoNotDischarge"] = "do_not_discharge";
    FlexibilityCommandBattery["DischargeToGrid"] = "discharge_to_grid";
    FlexibilityCommandBattery["Stop"] = "stop";
    return FlexibilityCommandBattery;
}({});
var $0c9c9e998227c8c4$export$94d9caf932148732 = /*#__PURE__*/ function(EnergomachineBatteryMode) {
    EnergomachineBatteryMode["Auto"] = "AUTO";
    EnergomachineBatteryMode["Stop"] = "OFF";
    EnergomachineBatteryMode["ManualIn"] = "MANUAL_IN";
    EnergomachineBatteryMode["ManualOut"] = "MANUAL_OUT";
    EnergomachineBatteryMode["DischargeDisabled"] = "DISCHARGE_DISABLED";
    EnergomachineBatteryMode["ChargeDisabled"] = "CHARGE_DISABLED";
    return EnergomachineBatteryMode;
}({});
var $0c9c9e998227c8c4$export$33374d1a3daf0940 = /*#__PURE__*/ function(FlexibilityCommandPv) {
    FlexibilityCommandPv["Unrestricted"] = "unrestricted";
    FlexibilityCommandPv["FullyRestricted"] = "fully_restricted";
    FlexibilityCommandPv["RestrictedToHousehold"] = "restricted_to_household";
    FlexibilityCommandPv["ForcedOverflow"] = "forced_overflow";
    return FlexibilityCommandPv;
}({});
var $0c9c9e998227c8c4$export$3157d57b4135e3bc = /*#__PURE__*/ function(ConnectionType) {
    ConnectionType["ModbusTCP"] = "modbus-tcp";
    ConnectionType["RS485"] = "rs485";
    return ConnectionType;
}({});
var $0c9c9e998227c8c4$export$4a868a35d3b57055 = /*#__PURE__*/ function(NetworkType) {
    NetworkType["External"] = "external";
    NetworkType["Internal"] = "internal";
    NetworkType["Custom"] = "custom";
    return NetworkType;
}({});
const $0c9c9e998227c8c4$export$72b8626c7e89fedc = [
    "v2"
];
const $0c9c9e998227c8c4$export$d1a3133394f93793 = [
    2,
    "solax-mic-grid",
    "solax-mega-grid",
    1,
    "good-we",
    "solax",
    "good-we-grid",
    "deye",
    "deye-hv",
    "solinteg",
    "wattsonic",
    "sermatec",
    "des-battery-container"
];
var $0c9c9e998227c8c4$export$ba3d09ecfd0a8c33 = /*#__PURE__*/ function(MqttCloudDeviceType) {
    MqttCloudDeviceType["ShellyPlusPlugS"] = "shelly-plus-plug-s";
    MqttCloudDeviceType["ShellyPlusPlugSGen3"] = "shelly-plus-plug-s-gen3";
    MqttCloudDeviceType["ShellyPlugMGen3"] = "shelly-plug-m-gen3";
    MqttCloudDeviceType["Shelly1PMGen3"] = "shelly-1pm-gen3";
    MqttCloudDeviceType["Shelly1PMGen4"] = "shelly-1pm-gen4";
    MqttCloudDeviceType["ShellyPlus1PM"] = "shelly-plus-1pm";
    MqttCloudDeviceType["ShellyPro1PM"] = "shelly-pro-1pm";
    MqttCloudDeviceType["ShellyPro1PMGen3"] = "shelly-pro-1pm-gen3";
    MqttCloudDeviceType["ShellyPro3EM"] = "shelly-pro-3-em";
    return MqttCloudDeviceType;
}({});
var $0c9c9e998227c8c4$export$39c93abe8201475e = /*#__PURE__*/ function(OverflowLimitType) {
    OverflowLimitType["None"] = "none";
    OverflowLimitType["ExportLimit"] = "export-limit";
    OverflowLimitType["SpotLimit"] = "spot-limit";
    OverflowLimitType["FlexibilityLimit"] = "flexibility-limit";
    return OverflowLimitType;
}({});
var $0c9c9e998227c8c4$export$f9c95d1e3007df4f = /*#__PURE__*/ function(GridMeteringMode) {
    GridMeteringMode["PerPhase"] = "per-phase";
    GridMeteringMode["Sum"] = "sum";
    return GridMeteringMode;
}({});
var $0c9c9e998227c8c4$export$af1a35fc19131459 = /*#__PURE__*/ function(GraphControlMode) {
    GraphControlMode["Photovoltaic"] = "photovoltaic";
    GraphControlMode["Grid"] = "grid";
    GraphControlMode["Spot"] = "spot";
    GraphControlMode["Flexibility"] = "flexibility";
    GraphControlMode["Error"] = "error";
    return GraphControlMode;
}({});
var $0c9c9e998227c8c4$export$c37e1773b2f1864d = /*#__PURE__*/ function(PlugActiveCondition) {
    PlugActiveCondition["Off"] = "off";
    PlugActiveCondition["Manual"] = "manual";
    PlugActiveCondition["Time"] = "time";
    PlugActiveCondition["Battery"] = "battery";
    PlugActiveCondition["Overflow"] = "overflow";
    PlugActiveCondition["Spot"] = "spot";
    PlugActiveCondition["Error"] = "error";
    return PlugActiveCondition;
}({});
var $0c9c9e998227c8c4$export$50dde76027f3032d = /*#__PURE__*/ function(HDOMode) {
    HDOMode[HDOMode["Regular"] = 1] = "Regular";
    HDOMode[HDOMode["Weekend"] = 2] = "Weekend";
    return HDOMode;
}({});
var $0c9c9e998227c8c4$export$2f9399cd3544300 = /*#__PURE__*/ function(SolaxEMS1000InverterName) {
    SolaxEMS1000InverterName[SolaxEMS1000InverterName["NotConnected"] = 0] = "NotConnected";
    SolaxEMS1000InverterName[SolaxEMS1000InverterName["TRENE100KI"] = 1] = "TRENE100KI";
    SolaxEMS1000InverterName[SolaxEMS1000InverterName["AELIO"] = 2] = "AELIO";
    SolaxEMS1000InverterName[SolaxEMS1000InverterName["TRENE100K"] = 3] = "TRENE100K";
    SolaxEMS1000InverterName[SolaxEMS1000InverterName["TRENE125K"] = 4] = "TRENE125K";
    return SolaxEMS1000InverterName;
}({});
var $0c9c9e998227c8c4$export$b77714901b25c3d9 = /*#__PURE__*/ function(SolaxEMS1000PROInverterName) {
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["NotConnected"] = 0] = "NotConnected";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["TRENE1"] = 1] = "TRENE1";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["AELIO"] = 2] = "AELIO";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["TRENE100K"] = 3] = "TRENE100K";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["TRENE125K"] = 4] = "TRENE125K";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["X3PROG2"] = 16] = "X3PROG2";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["X3FORTH"] = 100] = "X3FORTH";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["X3MGAG2"] = 101] = "X3MGAG2";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["X3GRAND"] = 104] = "X3GRAND";
    SolaxEMS1000PROInverterName[SolaxEMS1000PROInverterName["X3FORTHPLUS"] = 105] = "X3FORTHPLUS";
    return SolaxEMS1000PROInverterName;
}({});
var $0c9c9e998227c8c4$export$153c5eb5035851f5 = /*#__PURE__*/ function(SolaxMode) {
    SolaxMode[SolaxMode["SelfUse"] = 1] = "SelfUse";
    SolaxMode[SolaxMode["FeedIn"] = 2] = "FeedIn";
    SolaxMode[SolaxMode["Backup"] = 3] = "Backup";
    SolaxMode[SolaxMode["Manual"] = 4] = "Manual";
    SolaxMode[SolaxMode["PeakShaving"] = 5] = "PeakShaving";
    return SolaxMode;
}({});
var $0c9c9e998227c8c4$export$babf5a06f43ca0db = /*#__PURE__*/ function(InverterPowerControl) {
    InverterPowerControl[InverterPowerControl["Proportional"] = 1] = "Proportional";
    InverterPowerControl[InverterPowerControl["Fixed"] = 2] = "Fixed";
    return InverterPowerControl;
}({});
var $0c9c9e998227c8c4$export$ef2ca816f076b073 = /*#__PURE__*/ function(InverterControlMode) {
    InverterControlMode["DischargingToGrid"] = "discharging-to-grid";
    InverterControlMode["ChargingFromGrid"] = "charging-from-grid";
    InverterControlMode["StopCharging"] = "stop-charging";
    InverterControlMode["StopDischarging"] = "stop-discharging";
    InverterControlMode["StopOverflow"] = "stop-overflow";
    return InverterControlMode;
}({});
var $0c9c9e998227c8c4$export$9804536dfa2a8548 = /*#__PURE__*/ function(DesBatteryStatus) {
    DesBatteryStatus["NONE"] = "none";
    DesBatteryStatus["RUN"] = "run";
    DesBatteryStatus["OFF"] = "off";
    DesBatteryStatus["SLEEP"] = "sleep";
    DesBatteryStatus["ERROR"] = "error";
    return DesBatteryStatus;
}({});

});
parcelRegister("8z3TB", function(module, exports) {

$parcel$export(module.exports, "AppMessageType", () => $3b740c152b16e518$export$3785888c1b0931fa);
var $3b740c152b16e518$export$3785888c1b0931fa = /*#__PURE__*/ function(AppMessageType) {
    AppMessageType["Test"] = "test";
    AppMessageType["SpotNegativePriceStart"] = "spot-negative-price-start";
    AppMessageType["SpotNegativePriceStop"] = "spot-negative-price-stop";
    AppMessageType["UtilityLossStart"] = "utility-loss-start";
    AppMessageType["UtilityLossStop"] = "utility-loss-stop";
    AppMessageType["InverterProductionMWH"] = "inverter-production-mwh";
    AppMessageType["InverterDisconnected"] = "inverter-disconnected";
    AppMessageType["InverterConnected"] = "inverter-connected";
    AppMessageType["HeatWaterMaxTemperature"] = "heat-water-max-temperature";
    AppMessageType["WallboxStartCharging"] = "wallbox-start-charging";
    AppMessageType["WallboxStopCharging"] = "wallbox-stop-charging";
    AppMessageType["HomeLimitExceeded"] = "home-limit-exceeded";
    AppMessageType["HeatWaterLimitExceeded"] = "heat-water-limit-exceeded";
    AppMessageType["HeatPumpLimitExceeded"] = "heat-pump-limit-exceeded";
    AppMessageType["WallboxLimitExceeded"] = "wallbox-limit-exceeded";
    AppMessageType["SpotStartDischargingBattery"] = "spot-start-discharging-battery";
    AppMessageType["SpotStopDischargingBattery"] = "spot-stop-discharging-battery";
    AppMessageType["SpotStartChargingBattery"] = "spot-start-charging-battery";
    AppMessageType["SpotStopChargingBattery"] = "spot-stop-charging-battery";
    AppMessageType["SpotDailySummary"] = "spot-daily-summary";
    AppMessageType["BatteryMaxSOC"] = "battery-max-soc";
    AppMessageType["BatteryMinSOC"] = "battery-min-soc";
    AppMessageType["SpotDailyPrediction"] = "spot-daily-prediction";
    return AppMessageType;
}({});

});

parcelRegister("6uJ19", function(module, exports) {

$parcel$export(module.exports, "SpotPricePeriod", () => $45e7e010e3bd7239$export$faba01fadc6b166c);
$parcel$export(module.exports, "SpotRegion", () => $45e7e010e3bd7239$export$daca3f75877207ea);
$parcel$export(module.exports, "Currency", () => $45e7e010e3bd7239$export$b733e092f9f44b2c);
var $45e7e010e3bd7239$export$faba01fadc6b166c = /*#__PURE__*/ function(SpotPricePeriod) {
    SpotPricePeriod["60M"] = "60M";
    SpotPricePeriod["15M"] = "15M";
    return SpotPricePeriod;
}({});
var $45e7e010e3bd7239$export$daca3f75877207ea = /*#__PURE__*/ function(SpotRegion) {
    SpotRegion["CZ"] = "CZ";
    SpotRegion["NL"] = "NL";
    SpotRegion["SK"] = "SK";
    return SpotRegion;
}({});
var $45e7e010e3bd7239$export$b733e092f9f44b2c = /*#__PURE__*/ function(Currency) {
    Currency["CZK"] = "CZK";
    Currency["EUR"] = "EUR";
    return Currency;
}({});
const $45e7e010e3bd7239$export$88d35abb69338e9e = {
    ["CZ"]: "CZK",
    ["NL"]: "EUR",
    ["SK"]: "EUR"
};

});

parcelRegister("dKB2I", function(module, exports) {

$parcel$export(module.exports, "FlexibilityCommandType", () => $7541fd38778b8cea$export$a3a625a5b78ecda6);
var $7541fd38778b8cea$export$a3a625a5b78ecda6 = /*#__PURE__*/ function(FlexibilityCommandType) {
    FlexibilityCommandType["DeltaGreenBusinessFlexibility"] = "business-flexibility";
    FlexibilityCommandType["PreFlexibility"] = "pre-flexibility";
    FlexibilityCommandType["BezDodavatele"] = "bez-dodavatele";
    FlexibilityCommandType["Electree"] = "electree";
    FlexibilityCommandType["Energomachine"] = "energomachine";
    return FlexibilityCommandType;
}({});

});


parcelRegister("iD7Z3", function(module, exports) {

$parcel$export(module.exports, "colors", () => $c5f1e52ad8872cab$export$8f45430ccf837300);
$parcel$export(module.exports, "darkColors", () => $c5f1e52ad8872cab$export$abadeef2f905fad3);

var $8ni7a = parcelRequire("8ni7a");

var $3OncY = parcelRequire("3OncY");
const $c5f1e52ad8872cab$export$58d4b1376cd417a3 = '#FF9B3D';
const $c5f1e52ad8872cab$var$defaultVariantColors = {
    brightOrange: $c5f1e52ad8872cab$export$58d4b1376cd417a3
};
const $c5f1e52ad8872cab$var$ryseVariantColors = {
    blumine: '#1D5D74'
};
const $c5f1e52ad8872cab$var$solidsunVariantColors = {
    guardsmanRed: '#d40000'
};
const $c5f1e52ad8872cab$var$currentVariantColors = {
    [(0, $8ni7a.AppUiVariant).Default]: {
        primary: $c5f1e52ad8872cab$var$defaultVariantColors.brightOrange
    },
    [(0, $8ni7a.AppUiVariant).Ryse]: {
        primary: $c5f1e52ad8872cab$var$ryseVariantColors.blumine
    },
    [(0, $8ni7a.AppUiVariant).Innogy]: {
        primary: $c5f1e52ad8872cab$var$defaultVariantColors.brightOrange
    },
    [(0, $8ni7a.AppUiVariant).Solidsun]: {
        primary: $c5f1e52ad8872cab$var$solidsunVariantColors.guardsmanRed,
        richBlack: '#000d20'
    }
};
const $c5f1e52ad8872cab$export$8f45430ccf837300 = {
    lightBlue: '#F4F8FC',
    richBlack: '#071326',
    darkBlue: '#3E6879',
    dodgerBlue: '#3DA7FF',
    white: '#fff',
    brightOrange: $c5f1e52ad8872cab$export$58d4b1376cd417a3,
    ...$c5f1e52ad8872cab$var$currentVariantColors[0, $3OncY.APP_UI_VARIANT]
};
const $c5f1e52ad8872cab$export$abadeef2f905fad3 = {
    background: '#121212',
    paper: '#2c2c2c',
    richBlack: '#e4e4e4',
    darkBlue: '#a8c5d1',
    lightBlue: '#2a2a2a'
};

});
parcelRegister("3OncY", function(module, exports) {

$parcel$export(module.exports, "IS_DEMO", () => $9d936a2aecb96285$export$d52b4733fa835d39);
$parcel$export(module.exports, "IS_SOLIDSUN", () => $9d936a2aecb96285$export$1f32e72564320591);
$parcel$export(module.exports, "APP_UI_VARIANT", () => $9d936a2aecb96285$export$ca282f2deb2b92f4);

var $8ni7a = parcelRequire("8ni7a");
const $9d936a2aecb96285$export$d52b4733fa835d39 = Boolean("true");
const $9d936a2aecb96285$export$a64cab9ae17fe3b7 = window.location.host.includes('dzd');
const $9d936a2aecb96285$export$1f32e72564320591 = window.location.host.includes('solidsun');
const $9d936a2aecb96285$export$ca282f2deb2b92f4 = window.__APP_CONFIG__.APP_UI_VARIANT ?? ($9d936a2aecb96285$export$1f32e72564320591 ? (0, $8ni7a.AppUiVariant).Solidsun : (0, $8ni7a.AppUiVariant).Default);

});


parcelRegister("gEsja", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f657281bee3142$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $2TZUE = parcelRequire("2TZUE");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");


var $fpPf0 = parcelRequire("fpPf0");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c1f657281bee3142$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $3AM7p.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fpPf0.getTabUtilityClass), classes);
};
const $c1f657281bee3142$var$TabRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $3AM7p.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $fpPf0.default).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $fpPf0.default).icon}`]: styles.icon
            }
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $fpPf0.default).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $fpPf0.default).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $fpPf0.default).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $fpPf0.default).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $fpPf0.default).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $fpPf0.default).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $fpPf0.default).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $fpPf0.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $fpPf0.default).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $fpPf0.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $c1f657281bee3142$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $c1f657281bee3142$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c1f657281bee3142$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $c1f657281bee3142$export$2e2bcd8739ae039 = $c1f657281bee3142$var$Tab;

});
parcelRegister("fpPf0", function(module, exports) {

$parcel$export(module.exports, "getTabUtilityClass", () => $b390f03b616903a9$export$72aef224d6115253);
$parcel$export(module.exports, "default", () => $b390f03b616903a9$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b390f03b616903a9$export$72aef224d6115253(slot) {
    return (0, $4Cod0.default)('MuiTab', slot);
}
const $b390f03b616903a9$var$tabClasses = (0, $beCSm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $b390f03b616903a9$export$2e2bcd8739ae039 = $b390f03b616903a9$var$tabClasses;

});


parcelRegister("eVI4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $ade8931e75b51e59$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $bfMaC = parcelRequire("bfMaC");

var $boNdd = parcelRequire("boNdd");

var $2yxXl = parcelRequire("2yxXl");

var $j1f6o = parcelRequire("j1f6o");

var $74Rxa = parcelRequire("74Rxa");

var $6jOpZ = parcelRequire("6jOpZ");

var $cm0la = parcelRequire("cm0la");

var $bstJo = parcelRequire("bstJo");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ade8931e75b51e59$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $ade8931e75b51e59$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $ade8931e75b51e59$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $ade8931e75b51e59$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6jOpZ.getTabsUtilityClass), classes);
};
const $ade8931e75b51e59$var$TabsRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6jOpZ.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $6jOpZ.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $6jOpZ.default).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScroller = (0, $1Ikg4.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $ade8931e75b51e59$var$List = (0, $1Ikg4.default)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $ade8931e75b51e59$var$TabsIndicator = (0, $1Ikg4.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScrollbarSize = (0, $1Ikg4.default)((0, $2yxXl.default))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $ade8931e75b51e59$var$defaultIndicatorStyle = {};
let $ade8931e75b51e59$var$warnedOnceTabPresent = false;
const $ade8931e75b51e59$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $b7Ol4.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $ade8931e75b51e59$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $eD6Co.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($ade8931e75b51e59$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $74Rxa.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $boNdd.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $3fDLr.default)('scrollbar', {
        className: (0, $9QePP.default)(classes.scrollableX, classes.hideScrollbar),
        elementType: $ade8931e75b51e59$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $3fDLr.default)('scrollButtons', {
        className: (0, $9QePP.default)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $j1f6o.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $ayMG0.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $74Rxa.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $74Rxa.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $bfMaC.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $bstJo.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($ade8931e75b51e59$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $3fDLr.default)('indicator', {
        className: (0, $9QePP.default)(classes.indicator, TabIndicatorProps.className),
        elementType: $ade8931e75b51e59$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $ayMG0.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $cm0la.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $ade8931e75b51e59$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $3fDLr.default)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $ade8931e75b51e59$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $3fDLr.default)('list', {
        ref: tabListRef,
        className: (0, $9QePP.default)(classes.list, classes.flexContainer),
        elementType: $ade8931e75b51e59$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $ayMG0.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $ade8931e75b51e59$export$2e2bcd8739ae039 = $ade8931e75b51e59$var$Tabs;

});
parcelRegister("boNdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c81c1996222460$export$2e2bcd8739ae039);
function $84c81c1996222460$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $84c81c1996222460$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $84c81c1996222460$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("2yxXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc918b66cbea078$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $bfMaC = parcelRequire("bfMaC");

var $bstJo = parcelRequire("bstJo");
var $9mcVc = parcelRequire("9mcVc");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $1dc918b66cbea078$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $1dc918b66cbea078$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $9mcVc.default)(()=>{
        const handleResize = (0, $bfMaC.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $bstJo.default)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: $1dc918b66cbea078$var$styles,
        ...other,
        ref: nodeRef
    });
}

});

parcelRegister("j1f6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd89d34ceba12c96$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $iGfch = parcelRequire("iGfch");

var $iDHCu = parcelRequire("iDHCu");

var $2TZUE = parcelRequire("2TZUE");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $anwLo = parcelRequire("anwLo");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $dd89d34ceba12c96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $anwLo.getTabScrollButtonUtilityClass), classes);
};
const $dd89d34ceba12c96$var$TabScrollButtonRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $anwLo.default).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $dd89d34ceba12c96$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $58lXc.useRtl)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $dd89d34ceba12c96$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $iGfch.default);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $iDHCu.default);
    const startButtonIconProps = (0, $eD6Co.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $eD6Co.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($dd89d34ceba12c96$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $ayMG0.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $dd89d34ceba12c96$export$2e2bcd8739ae039 = $dd89d34ceba12c96$var$TabScrollButton;

});
parcelRegister("iGfch", function(module, exports) {

$parcel$export(module.exports, "default", () => $d997f00fcbb3883b$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d997f00fcbb3883b$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("iDHCu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91db4839e2bc3bb$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $d91db4839e2bc3bb$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("anwLo", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", () => $78e5777b5eeee81f$export$34861783d3c2eef8);
$parcel$export(module.exports, "default", () => $78e5777b5eeee81f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $78e5777b5eeee81f$export$34861783d3c2eef8(slot) {
    return (0, $4Cod0.default)('MuiTabScrollButton', slot);
}
const $78e5777b5eeee81f$var$tabScrollButtonClasses = (0, $beCSm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $78e5777b5eeee81f$export$2e2bcd8739ae039 = $78e5777b5eeee81f$var$tabScrollButtonClasses;

});


parcelRegister("6jOpZ", function(module, exports) {

$parcel$export(module.exports, "getTabsUtilityClass", () => $499ba0703d8ef45f$export$cdd93bd054dec359);
$parcel$export(module.exports, "default", () => $499ba0703d8ef45f$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $499ba0703d8ef45f$export$cdd93bd054dec359(slot) {
    return (0, $4Cod0.default)('MuiTabs', slot);
}
const $499ba0703d8ef45f$var$tabsClasses = (0, $beCSm.default)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $499ba0703d8ef45f$export$2e2bcd8739ae039 = $499ba0703d8ef45f$var$tabsClasses;

});


parcelRegister("cW890", function(module, exports) {
$parcel$export(module.exports, "Board", () => (parcelRequire("8ni7a")).Board);
$parcel$export(module.exports, "DesBatteryStatus", () => (parcelRequire("8ni7a")).DesBatteryStatus);
$parcel$export(module.exports, "EnergomachineBatteryMode", () => (parcelRequire("8ni7a")).EnergomachineBatteryMode);
$parcel$export(module.exports, "FlexibilityCommandType", () => (parcelRequire("dKB2I")).FlexibilityCommandType);
$parcel$export(module.exports, "GridMeteringMode", () => (parcelRequire("8ni7a")).GridMeteringMode);
$parcel$export(module.exports, "HDOMode", () => (parcelRequire("8ni7a")).HDOMode);
$parcel$export(module.exports, "HeatWater", () => (parcelRequire("8ni7a")).HeatWater);
$parcel$export(module.exports, "Inverter", () => (parcelRequire("8ni7a")).Inverter);
$parcel$export(module.exports, "InverterPowerControl", () => (parcelRequire("8ni7a")).InverterPowerControl);
$parcel$export(module.exports, "License", () => (parcelRequire("8ni7a")).License);
$parcel$export(module.exports, "MqttCloudDeviceType", () => (parcelRequire("8ni7a")).MqttCloudDeviceType);
$parcel$export(module.exports, "OemDistribution", () => (parcelRequire("8ni7a")).OemDistribution);
$parcel$export(module.exports, "RelayControl", () => (parcelRequire("8ni7a")).RelayControl);
$parcel$export(module.exports, "SolaxEMS1000InverterName", () => (parcelRequire("8ni7a")).SolaxEMS1000InverterName);
$parcel$export(module.exports, "SolaxEMS1000PROInverterName", () => (parcelRequire("8ni7a")).SolaxEMS1000PROInverterName);
$parcel$export(module.exports, "SolaxMode", () => (parcelRequire("8ni7a")).SolaxMode);
$parcel$export(module.exports, "SpotPricePeriod", () => (parcelRequire("6uJ19")).SpotPricePeriod);
$parcel$export(module.exports, "SpotRegion", () => (parcelRequire("6uJ19")).SpotRegion);
$parcel$export(module.exports, "Wallbox", () => (parcelRequire("8ni7a")).Wallbox);
parcelRequire("8ni7a");

});

parcelRegister("8cmfY", function(module, exports) {
$parcel$export(module.exports, "Group", () => (parcelRequire("hDcyd")).Group);
parcelRequire("hDcyd");

});
parcelRegister("hDcyd", function(module, exports) {

$parcel$export(module.exports, "Group", () => $c4cdb461c29b1787$export$eb2fcfdbd7ba97d4);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $91vj1 = parcelRequire("91vj1");
var $1DAbm = parcelRequire("1DAbm");
var $dYv7f = parcelRequire("dYv7f");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $bCDrB = parcelRequire("bCDrB");

var $a8gr9 = parcelRequire("a8gr9");

var $aZOrF = parcelRequire("aZOrF");

var $exNvH = parcelRequire("exNvH");

var $50BRD = parcelRequire("50BRD");
const $c4cdb461c29b1787$export$eb2fcfdbd7ba97d4 = ({ title: title, to: to, help: help, children: children, visibility: visibility, layout: layout = 'none', collapsible: collapsible, id: id, plus: plus, sx: sx = {} })=>{
    const [collapsed, setCollapsed] = (0, $acw62.useState)(false);
    if (!(0, $bCDrB.useVisibility)(visibility)) return null;
    const content = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            layout === 'none' && children,
            layout === 'scrollable' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    width: '100%',
                    maxWidth: {
                        xs: '100%',
                        lg: 1200
                    },
                    display: 'flex',
                    overflow: 'auto',
                    px: {
                        xs: 2,
                        sm: 3
                    },
                    pb: 1,
                    mx: {
                        xs: 0,
                        lg: 'auto'
                    }
                },
                children: children
            }),
            layout === 'grid' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dYv7f.default), {
                    container: true,
                    spacing: 2,
                    children: children
                })
            }),
            layout === 'list' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
                    spacing: 2,
                    children: children
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            py: 1,
            ...sx
        },
        id: id,
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    mb: 1
                },
                className: "group__title",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                        variant: "h2",
                        children: [
                            title,
                            plus && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                                sx: {
                                    ml: 1
                                }
                            })
                        ]
                    }),
                    help && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                        ...help
                    }),
                    collapsible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: ()=>setCollapsed(!collapsed),
                        sx: {
                            ml: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exNvH.ChevronRight), {
                            sx: {
                                transform: `rotate(${collapsed ? '-' : ''}90deg)`,
                                transition: 'ease-in-out 200ms transform'
                            }
                        })
                    }),
                    to ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        sx: {
                            ml: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8gr9.ArrowRight), {
                            sx: {
                                fontSize: 20,
                                color: 'text.primary'
                            }
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            height: 36
                        }
                    })
                ]
            }),
            collapsible ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                in: collapsed,
                children: content
            }) : content
        ]
    });
};

});
parcelRegister("91vj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $691c7db844a32c8c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $1mPeS = parcelRequire("1mPeS");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $frp52 = parcelRequire("frp52");

var $MCL1V = parcelRequire("MCL1V");

var $Uq4Et = parcelRequire("Uq4Et");

var $iuv9Y = parcelRequire("iuv9Y");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $691c7db844a32c8c$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iuv9Y.getCollapseUtilityClass), classes);
};
const $691c7db844a32c8c$var$CollapseRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $691c7db844a32c8c$var$CollapseWrapper = (0, $1Ikg4.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $691c7db844a32c8c$var$CollapseWrapperInner = (0, $1Ikg4.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $691c7db844a32c8c$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $frp52.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $1mPeS.default), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $691c7db844a32c8c$var$useUtilityClasses(ownerState);
    const theme = (0, $b7Ol4.default)();
    const timer = (0, $lHOu3.default)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $Uq4Et.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $MCL1V.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseRoot, {
                as: component,
                className: (0, $9QePP.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($691c7db844a32c8c$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($691c7db844a32c8c$var$Collapse) $691c7db844a32c8c$var$Collapse.muiSupportAuto = true;
var $691c7db844a32c8c$export$2e2bcd8739ae039 = $691c7db844a32c8c$var$Collapse;

});
parcelRegister("iuv9Y", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", () => $d763330bc495c775$export$5162da8f798e0959);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d763330bc495c775$export$5162da8f798e0959(slot) {
    return (0, $4Cod0.default)('MuiCollapse', slot);
}
const $d763330bc495c775$var$collapseClasses = (0, $beCSm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $d763330bc495c775$export$2e2bcd8739ae039 = $d763330bc495c775$var$collapseClasses;

});


parcelRegister("1DAbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $13157ffc893b45e9$export$2e2bcd8739ae039);


var $duAgF = parcelRequire("duAgF");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");
'use client';
const $13157ffc893b45e9$var$Container = (0, $duAgF.default)({
    createStyledComponent: (0, $1Ikg4.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $3AM7p.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $2nO41.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $13157ffc893b45e9$export$2e2bcd8739ae039 = $13157ffc893b45e9$var$Container;

});
parcelRegister("duAgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2a35bf051ea407$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $dFNG2 = parcelRequire("dFNG2");

var $dxMBG = parcelRequire("dxMBG");

var $6o2lr = parcelRequire("6o2lr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9d2a35bf051ea407$var$defaultTheme = (0, $6o2lr.default)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $gxvzd.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $dFNG2.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $4Cod0.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $gxvzd.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});


parcelRegister("dYv7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2c903eb2263b589$export$2e2bcd8739ae039);


var $9LTUh = parcelRequire("9LTUh");


var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $b7Ol4 = parcelRequire("b7Ol4");
'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $a2c903eb2263b589$var$Grid = (0, $9LTUh.default)({
    createStyledComponent: (0, $1Ikg4.default)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $2nO41.useDefaultProps)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $b7Ol4.default
});
var $a2c903eb2263b589$export$2e2bcd8739ae039 = $a2c903eb2263b589$var$Grid;

});
parcelRegister("9LTUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d3dec7f204ed17$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $4NpFa = parcelRequire("4NpFa");

var $4Cod0 = parcelRequire("4Cod0");

var $8Indx = parcelRequire("8Indx");

var $dxMBG = parcelRequire("dxMBG");

var $dFNG2 = parcelRequire("dFNG2");

var $eM1DJ = parcelRequire("eM1DJ");

var $hcz0Q = parcelRequire("hcz0Q");

var $6o2lr = parcelRequire("6o2lr");

var $4bdSG = parcelRequire("4bdSG");

var $4GQYq = parcelRequire("4GQYq");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $71d3dec7f204ed17$var$defaultTheme = (0, $6o2lr.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $71d3dec7f204ed17$var$defaultCreateStyledComponent = (0, $dxMBG.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $71d3dec7f204ed17$var$useThemePropsDefault(props) {
    return (0, $dFNG2.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $71d3dec7f204ed17$var$defaultTheme
    });
}
function $71d3dec7f204ed17$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $71d3dec7f204ed17$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $71d3dec7f204ed17$var$useThemePropsDefault, useTheme: useTheme = (0, $eM1DJ.default), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $4bdSG.generateDirectionClasses)(direction),
                ...(0, $4bdSG.generateSizeClassNames)(size),
                ...container ? (0, $4bdSG.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $8Indx.default)(slots, (slot)=>(0, $4Cod0.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $4bdSG.generateGridColumnsStyles), (0, $4bdSG.generateGridColumnSpacingStyles), (0, $4bdSG.generateGridRowSpacingStyles), (0, $4bdSG.generateGridSizeStyles), (0, $4bdSG.generateGridDirectionStyles), (0, $4bdSG.generateGridStyles), (0, $4bdSG.generateGridOffsetStyles));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $hcz0Q.default)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $4GQYq.default)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $4NpFa.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("4bdSG", function(module, exports) {

$parcel$export(module.exports, "generateGridSizeStyles", () => $30b2f4f9de1f3c09$export$84053369756c53db);
$parcel$export(module.exports, "generateGridOffsetStyles", () => $30b2f4f9de1f3c09$export$c1d4f281314969c2);
$parcel$export(module.exports, "generateGridColumnsStyles", () => $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06);
$parcel$export(module.exports, "generateGridRowSpacingStyles", () => $30b2f4f9de1f3c09$export$68c4dad72dd49c74);
$parcel$export(module.exports, "generateGridColumnSpacingStyles", () => $30b2f4f9de1f3c09$export$a89c28919b8e3bb5);
$parcel$export(module.exports, "generateGridDirectionStyles", () => $30b2f4f9de1f3c09$export$2a0a3c01032b3f4);
$parcel$export(module.exports, "generateGridStyles", () => $30b2f4f9de1f3c09$export$810b8c3ab5d46bf);
$parcel$export(module.exports, "generateSizeClassNames", () => $30b2f4f9de1f3c09$export$e2d1175061442d38);
$parcel$export(module.exports, "generateSpacingClassNames", () => $30b2f4f9de1f3c09$export$6c7087d27c3329d3);
$parcel$export(module.exports, "generateDirectionClasses", () => $30b2f4f9de1f3c09$export$a7c8efbe2b138a60);

var $8O0b3 = parcelRequire("8O0b3");
function $30b2f4f9de1f3c09$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $30b2f4f9de1f3c09$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $30b2f4f9de1f3c09$var$selfColumnsVar = '--Grid-columns';
const $30b2f4f9de1f3c09$var$parentColumnsVar = '--Grid-parent-columns';
const $30b2f4f9de1f3c09$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - (var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - ${value}) * (var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) / var(${$30b2f4f9de1f3c09$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) + var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$30b2f4f9de1f3c09$var$selfColumnsVar]: 12
    };
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$selfColumnsVar]: columns,
            '> *': {
                [$30b2f4f9de1f3c09$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $8O0b3.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')}) var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')})`
        }
    };
};
const $30b2f4f9de1f3c09$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $30b2f4f9de1f3c09$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $30b2f4f9de1f3c09$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};

});
parcelRegister("8O0b3", function(module, exports) {

$parcel$export(module.exports, "traverseBreakpoints", () => $6693217541d03f3f$export$e04173f1577f18b7);
const $6693217541d03f3f$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $6693217541d03f3f$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6693217541d03f3f$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};

});


parcelRegister("4GQYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a42d20d006905e$export$2e2bcd8739ae039);
const $36a42d20d006905e$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $36a42d20d006905e$var$warnedAboutProps = [];
function $36a42d20d006905e$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

});



parcelRegister("bCDrB", function(module, exports) {

$parcel$export(module.exports, "useVisibility", () => $64ae440a82e8a6ed$export$83920e874200e13a);

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");
const $64ae440a82e8a6ed$export$83920e874200e13a = (options = {})=>{
    const visibilityValue = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        const variableIds = ('variableId' in options ? [
            options.variableId
        ] : 'variableIds' in options ? options.variableIds : []).map((v)=>typeof v === 'string' ? {
                variableId: v,
                reversed: false
            } : {
                reversed: false,
                ...v
            });
        if (!variableIds.length) return undefined;
        return variableIds.reduce((acc, { variableId: variableId, reversed: reversed })=>{
            const value = Boolean((0, $f1q41.get)(variables, variableId));
            return acc && (reversed ? !value : value);
        }, true);
    });
    if (typeof visibilityValue === 'undefined') return true;
    return Boolean(visibilityValue);
};

});

parcelRegister("a8gr9", function(module, exports) {

$parcel$export(module.exports, "ArrowRight", () => $d00db86d08278647$export$acad20503ad73ac1);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $d00db86d08278647$export$acad20503ad73ac1 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 20 20",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M12.025 4.94165L17.0834 9.99998L12.025 15.0583",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.91669 10H16.9417",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });

});

parcelRegister("aZOrF", function(module, exports) {

$parcel$export(module.exports, "HelpButton", () => $5ac0a12317e11299$export$78bddedbcf2939ac);

var $ayMG0 = parcelRequire("ayMG0");

var $12gtR = parcelRequire("12gtR");

var $jDfxe = parcelRequire("jDfxe");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $8kk5d = parcelRequire("8kk5d");
const $5ac0a12317e11299$export$78bddedbcf2939ac = ({ variant: variant = 'tooltip', content: content, title: title })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const openDialog = ()=>{
        confirm({
            title: title,
            description: content,
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "close",
                defaultMessage: "Zav\u0159\xedt"
            }),
            hideCancelButton: true
        }).then(()=>{
        // noop
        }).catch(()=>{
        // noop
        });
    };
    if (variant === 'tooltip') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: content,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kk5d.Help), {
            sx: {
                fontSize: 13,
                ml: 0.75
            }
        })
    });
    if (variant === 'dialog') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8kk5d.Help), {
        sx: {
            fontSize: 13,
            ml: 0.75
        },
        onClick: openDialog
    });
    return null;
};

});
parcelRegister("12gtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c12c30993373593$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $lHOu3 = parcelRequire("lHOu3");


var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $52FI1 = parcelRequire("52FI1");

var $2xc7G = parcelRequire("2xc7G");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $7LOKt = parcelRequire("7LOKt");

var $iyxBj = parcelRequire("iyxBj");

var $74Rxa = parcelRequire("74Rxa");

var $Uq4Et = parcelRequire("Uq4Et");

var $70SAr = parcelRequire("70SAr");

var $5csPv = parcelRequire("5csPv");

var $3fDLr = parcelRequire("3fDLr");

var $9g7tT = parcelRequire("9g7tT");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $0c12c30993373593$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $0c12c30993373593$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $3AM7p.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9g7tT.getTooltipUtilityClass), classes);
};
const $0c12c30993373593$var$TooltipPopper = (0, $1Ikg4.default)((0, $iyxBj.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $9g7tT.default).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $9g7tT.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $9g7tT.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $9g7tT.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $9g7tT.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $9g7tT.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $9g7tT.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $9g7tT.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $0c12c30993373593$var$TooltipTooltip = (0, $1Ikg4.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $3AM7p.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $9g7tT.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $9g7tT.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $9g7tT.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $9g7tT.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$0c12c30993373593$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $9g7tT.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $0c12c30993373593$var$TooltipArrow = (0, $1Ikg4.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $lwQO9.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $0c12c30993373593$var$hystersisOpen = false;
const $0c12c30993373593$var$hystersisTimer = new (0, $lHOu3.Timeout)();
let $0c12c30993373593$var$cursorPosition = {
    x: 0,
    y: 0
};
function $0c12c30993373593$export$b9ee5a7ace0541f8() {
    $0c12c30993373593$var$hystersisOpen = false;
    $0c12c30993373593$var$hystersisTimer.clear();
}
function $0c12c30993373593$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $0c12c30993373593$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $b7Ol4.default)();
    const isRtl = (0, $58lXc.useRtl)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $lHOu3.default)();
    const enterTimer = (0, $lHOu3.default)();
    const leaveTimer = (0, $lHOu3.default)();
    const touchTimer = (0, $lHOu3.default)();
    const [openState, setOpenState] = (0, $5csPv.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $70SAr.default)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $74Rxa.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $0c12c30993373593$var$hystersisTimer.clear();
        $0c12c30993373593$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $74Rxa.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $0c12c30993373593$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $0c12c30993373593$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $0c12c30993373593$var$hystersisOpen && enterNextDelay) enterTimer.start($0c12c30993373593$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $52FI1.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $Uq4Et.default)((0, $2xc7G.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $0c12c30993373593$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $9QePP.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $0c12c30993373593$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $0c12c30993373593$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $0c12c30993373593$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $0c12c30993373593$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $acw62.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $0c12c30993373593$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $3fDLr.default)('popper', {
        elementType: $0c12c30993373593$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $3fDLr.default)('transition', {
        elementType: (0, $7LOKt.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $3fDLr.default)('tooltip', {
        elementType: $0c12c30993373593$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $3fDLr.default)('arrow', {
        elementType: $0c12c30993373593$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $ayMG0.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $iyxBj.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $0c12c30993373593$var$cursorPosition.y,
                            left: $0c12c30993373593$var$cursorPosition.x,
                            right: $0c12c30993373593$var$cursorPosition.x,
                            bottom: $0c12c30993373593$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $ayMG0.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $ayMG0.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $0c12c30993373593$export$2e2bcd8739ae039 = $0c12c30993373593$var$Tooltip;

});
parcelRegister("iyxBj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d825775ecf14115c$export$2e2bcd8739ae039);

var $58lXc = parcelRequire("58lXc");




var $acw62 = parcelRequire("acw62");

var $hQZDt = parcelRequire("hQZDt");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d825775ecf14115c$var$PopperRoot = (0, $1Ikg4.default)((0, $hQZDt.default), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $d825775ecf14115c$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $58lXc.useRtl)();
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d825775ecf14115c$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $d825775ecf14115c$export$2e2bcd8739ae039 = $d825775ecf14115c$var$Popper;

});
parcelRegister("hQZDt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cff71a91c86529eb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");

var $eEJPp = parcelRequire("eEJPp");

var $3qSdM = parcelRequire("3qSdM");




var $3tUi5 = parcelRequire("3tUi5");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $8GoiI = parcelRequire("8GoiI");

var $degVd = parcelRequire("degVd");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cff71a91c86529eb$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $cff71a91c86529eb$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $cff71a91c86529eb$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $cff71a91c86529eb$var$isVirtualElement(element) {
    return !$cff71a91c86529eb$var$isHTMLElement(element);
}
const $cff71a91c86529eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $degVd.getPopperUtilityClass), classes);
};
const $cff71a91c86529eb$var$defaultPopperOptions = {};
const $cff71a91c86529eb$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $3qSdM.default)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $3qSdM.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $eEJPp.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $cff71a91c86529eb$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($cff71a91c86529eb$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($cff71a91c86529eb$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $eEJPp.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $3tUi5.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $cff71a91c86529eb$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $cff71a91c86529eb$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $cff71a91c86529eb$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $cff71a91c86529eb$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $cff71a91c86529eb$var$isHTMLElement(resolvedAnchorEl) ? (0, $6zeBo.default)(resolvedAnchorEl).body : (0, $6zeBo.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8GoiI.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cff71a91c86529eb$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $cff71a91c86529eb$export$2e2bcd8739ae039 = $cff71a91c86529eb$var$Popper;

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === 'html' || (0, $oKPBf.default)(offsetParent) === 'body' && (0, $huVQQ.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === 'rtl') x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === 'x' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== 'number' ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === 'y' ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("degVd", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $9a19b57a2f88339a$export$1b69b6cd0fa638a1);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9a19b57a2f88339a$export$1b69b6cd0fa638a1(slot) {
    return (0, $4Cod0.default)('MuiPopper', slot);
}
const $9a19b57a2f88339a$var$popperClasses = (0, $beCSm.default)('MuiPopper', [
    'root'
]);
var $9a19b57a2f88339a$export$2e2bcd8739ae039 = $9a19b57a2f88339a$var$popperClasses;

});



parcelRegister("9g7tT", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $6bdb694b99441ccf$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $6bdb694b99441ccf$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6bdb694b99441ccf$export$837848f5f6cee923(slot) {
    return (0, $4Cod0.default)('MuiTooltip', slot);
}
const $6bdb694b99441ccf$var$tooltipClasses = (0, $beCSm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $6bdb694b99441ccf$export$2e2bcd8739ae039 = $6bdb694b99441ccf$var$tooltipClasses;

});


parcelRegister("8kk5d", function(module, exports) {

$parcel$export(module.exports, "Help", () => $dfb3f9265f68e8fa$export$1be7516c0280bee8);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $dfb3f9265f68e8fa$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 14 14",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.40497 8.27337H7.52497V8.06749C7.52497 7.10396 8.92497 7.14514 8.92497 5.76161C8.92497 4.79808 8.23321 4.14749 7.03086 4.14749C5.83674 4.14749 5.07086 4.78985 5.07086 6.03337V6.1322H6.15791V6.03337C6.15791 5.5969 6.40497 5.11926 7.01439 5.11926C7.59909 5.11926 7.79674 5.58043 7.79674 5.8769C7.79674 6.70867 6.40497 6.66749 6.40497 8.05926V8.27337ZM6.95674 10.1593C7.30262 10.1593 7.59086 9.90396 7.59086 9.52514C7.59086 9.14632 7.30262 8.89102 6.95674 8.89102C6.61086 8.89102 6.32262 9.14632 6.32262 9.52514C6.32262 9.90396 6.61086 10.1593 6.95674 10.1593Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("circle", {
                cx: "7",
                cy: "7",
                r: "6.5",
                stroke: "currentColor"
            })
        ]
    }));
$dfb3f9265f68e8fa$export$1be7516c0280bee8.displayName = 'Help';

});


parcelRegister("exNvH", function(module, exports) {

$parcel$export(module.exports, "ChevronRight", () => $0c62795bb8dc69e7$export$6172d85aadfc9b96);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $0c62795bb8dc69e7$export$6172d85aadfc9b96 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 6 10",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M1 1L5 5L0.999999 9",
            stroke: "currentColor",
            strokeLinecap: "round"
        })
    });

});

parcelRegister("50BRD", function(module, exports) {

$parcel$export(module.exports, "Plus", () => $d3ac61a949fa0d94$export$2d9ac7aa84f97a08);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");

var $iD7Z3 = parcelRequire("iD7Z3");
const $d3ac61a949fa0d94$export$2d9ac7aa84f97a08 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 16 16",
        ...props,
        sx: {
            fill: 'none',
            fontSize: '1rem',
            ...sx || {}
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                width: "16",
                height: "16",
                rx: "4",
                fill: (0, $iD7Z3.colors).richBlack
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "2",
                y: "7",
                width: "12",
                height: "2",
                rx: "1",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                x: "5.97327",
                y: "13.7352",
                width: "12",
                height: "2",
                rx: "1",
                transform: "rotate(-80 5.97327 13.7352)",
                fill: "white"
            })
        ]
    }));
$d3ac61a949fa0d94$export$2d9ac7aa84f97a08.displayName = 'Plus';

});



parcelRegister("jrrQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e276246268a3078e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $iN2NM = parcelRequire("iN2NM");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3HXWC = parcelRequire("3HXWC");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e276246268a3078e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $3AM7p.default)(edge)}`,
            `size${(0, $3AM7p.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $3AM7p.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $3HXWC.getSwitchUtilityClass), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $e276246268a3078e$var$SwitchRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $3AM7p.default)(ownerState.edge)}`],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $3HXWC.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $3HXWC.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $3HXWC.default).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $e276246268a3078e$var$SwitchSwitchBase = (0, $1Ikg4.default)((0, $iN2NM.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $3HXWC.default).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3HXWC.default).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $3HXWC.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $3HXWC.default).checked} + .${(0, $3HXWC.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $3HXWC.default).disabled} + .${(0, $3HXWC.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $3HXWC.default).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $lwQO9.default)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3HXWC.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $3HXWC.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $3HXWC.default).checked} + .${(0, $3HXWC.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $e276246268a3078e$var$SwitchTrack = (0, $1Ikg4.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $lwQO9.default)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $e276246268a3078e$var$SwitchThumb = (0, $1Ikg4.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $lwQO9.default)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $e276246268a3078e$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $e276246268a3078e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $e276246268a3078e$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $3fDLr.default)('thumb', {
        className: classes.thumb,
        elementType: $e276246268a3078e$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $3fDLr.default)('track', {
        className: classes.track,
        elementType: $e276246268a3078e$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($e276246268a3078e$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: {
                        role: 'switch'
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $e276246268a3078e$export$2e2bcd8739ae039 = $e276246268a3078e$var$Switch;

});
parcelRegister("3HXWC", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", () => $2b33e2f571fef2d8$export$39f6debbec19b3ba);
$parcel$export(module.exports, "default", () => $2b33e2f571fef2d8$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2b33e2f571fef2d8$export$39f6debbec19b3ba(slot) {
    return (0, $4Cod0.default)('MuiSwitch', slot);
}
const $2b33e2f571fef2d8$var$switchClasses = (0, $beCSm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $2b33e2f571fef2d8$export$2e2bcd8739ae039 = $2b33e2f571fef2d8$var$switchClasses;

});


parcelRegister("7pMmM", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $0cedf3d452514bda$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $0cedf3d452514bda$export$2e2bcd8739ae039 = fn;

});

parcelRegister("iH29s", function(module, exports) {

$parcel$export(module.exports, "trpc", () => $df33b2ba6f5fa2b8$export$26420885829a1061);
$parcel$export(module.exports, "TrpcProvider", () => $df33b2ba6f5fa2b8$export$8794a15d5619d61d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1h30h = parcelRequire("1h30h");

var $3ePi6 = parcelRequire("3ePi6");
var $2EXpz = parcelRequire("2EXpz");

var $deXeR = parcelRequire("deXeR");
parcelRequire("cX54e");
var $h5AIr = parcelRequire("h5AIr");
const $df33b2ba6f5fa2b8$export$26420885829a1061 = (0, $1h30h.createTRPCReact)();
const $df33b2ba6f5fa2b8$export$8794a15d5619d61d = ({ children: children })=>{
    const [queryClient] = (0, $acw62.useState)(()=>{
        const client = new (0, $3ePi6.QueryClient)();
        return client;
    });
    const [trpcClient] = (0, $acw62.useState)(()=>{
        const links = [
            (0, $h5AIr.httpBatchLink)({
                url: '/core/trpc',
                headers: ()=>({
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        Pragma: 'no-cache',
                        Expires: '0'
                    })
            })
        ];
        return $df33b2ba6f5fa2b8$export$26420885829a1061.createClient({
            links: links
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($df33b2ba6f5fa2b8$export$26420885829a1061.Provider, {
        client: trpcClient,
        queryClient: queryClient,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2EXpz.QueryClientProvider), {
            client: queryClient,
            children: [
                children,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $deXeR.ReactQueryDevtools), {
                    initialIsOpen: false
                })
            ]
        })
    });
};

});
parcelRegister("1h30h", function(module, exports) {

$parcel$export(module.exports, "createTRPCReact", () => $a66adb8f715d774e$export$26eab98846025320);
parcelRequire("cX54e");

var $lVRg0 = parcelRequire("lVRg0");
parcelRequire("276dz");
var $llFhu = parcelRequire("llFhu");

var $acw62 = parcelRequire("acw62");

parcelRequire("ii04n");
/**
 * @internal
 */ function $a66adb8f715d774e$var$createHooksInternalProxy(trpc) {
    return (0, $llFhu.c)((key)=>{
        if (key === 'useContext') return ()=>{
            const context = trpc.useContext();
            // create a stable reference of the utils context
            return (0, $acw62.useMemo)(()=>{
                return (0, $lVRg0.a)(context);
            }, [
                context
            ]);
        };
        if (trpc.hasOwnProperty(key)) return trpc[key];
        return (0, $lVRg0.b)(key, trpc);
    });
}
function $a66adb8f715d774e$export$26eab98846025320(opts) {
    const hooks = (0, $lVRg0.c)(opts);
    const proxy = $a66adb8f715d774e$var$createHooksInternalProxy(hooks);
    return proxy;
}
// interop:
/**
 * @deprecated use `createTRPCReact` instead
 */ function $a66adb8f715d774e$export$f6be52d17773fe89(opts) {
    const trpc = (0, $lVRg0.c)(opts);
    const proxy = $a66adb8f715d774e$var$createHooksInternalProxy(trpc);
    return {
        ...trpc,
        proxy: proxy
    };
}

});
parcelRegister("cX54e", function(module, exports) {

$parcel$export(module.exports, "createTRPCClient", () => $138964854a115163$export$b2acd49cd3814618);
$parcel$export(module.exports, "createTRPCClientProxy", () => $138964854a115163$export$a66136bdbd4ef050);
$parcel$export(module.exports, "httpBatchLink", () => (parcelRequire("h5AIr")).httpBatchLink);

var $5Ic56 = parcelRequire("5Ic56");

var $dxr6w = parcelRequire("dxr6w");

var $4OziX = parcelRequire("4OziX");
parcelRequire("276dz");
var $llFhu = parcelRequire("llFhu");

var $8NlHQ = parcelRequire("8NlHQ");

var $h5AIr = parcelRequire("h5AIr");

var $kkI5j = parcelRequire("kkI5j");

var $4vmeb = parcelRequire("4vmeb");

var $3RqaU = parcelRequire("3RqaU");
class $138964854a115163$var$TRPCUntypedClient {
    $request({ type: type, input: input, path: path, context: context = {} }) {
        const chain$ = (0, $4OziX.c)({
            links: this.links,
            op: {
                id: ++this.requestId,
                type: type,
                path: path,
                input: input,
                context: context
            }
        });
        return chain$.pipe((0, $5Ic56.share)());
    }
    requestAsPromise(opts) {
        const req$ = this.$request(opts);
        const { promise: promise, abort: abort } = (0, $5Ic56.observableToPromise)(req$);
        const abortablePromise = new Promise((resolve, reject)=>{
            opts.signal?.addEventListener('abort', abort);
            promise.then((envelope)=>{
                resolve(envelope.result.data);
            }).catch((err)=>{
                reject((0, $dxr6w.T).from(err));
            });
        });
        return abortablePromise;
    }
    query(path, input, opts) {
        return this.requestAsPromise({
            type: 'query',
            path: path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    mutation(path, input, opts) {
        return this.requestAsPromise({
            type: 'mutation',
            path: path,
            input: input,
            context: opts?.context,
            signal: opts?.signal
        });
    }
    subscription(path, input, opts) {
        const observable$ = this.$request({
            type: 'subscription',
            path: path,
            input: input,
            context: opts?.context
        });
        return observable$.subscribe({
            next (envelope) {
                if (envelope.result.type === 'started') opts.onStarted?.();
                else if (envelope.result.type === 'stopped') opts.onStopped?.();
                else opts.onData?.(envelope.result.data);
            },
            error (err) {
                opts.onError?.(err);
            },
            complete () {
                opts.onComplete?.();
            }
        });
    }
    constructor(opts){
        this.requestId = 0;
        const combinedTransformer = (()=>{
            const transformer = opts.transformer;
            if (!transformer) return {
                input: {
                    serialize: (data)=>data,
                    deserialize: (data)=>data
                },
                output: {
                    serialize: (data)=>data,
                    deserialize: (data)=>data
                }
            };
            if ('input' in transformer) return opts.transformer;
            return {
                input: transformer,
                output: transformer
            };
        })();
        this.runtime = {
            transformer: {
                serialize: (data)=>combinedTransformer.input.serialize(data),
                deserialize: (data)=>combinedTransformer.output.deserialize(data)
            },
            combinedTransformer: combinedTransformer
        };
        // Initialize the links
        this.links = opts.links.map((link)=>link(this.runtime));
    }
}
function $138964854a115163$export$3f94c4551b43e9f9(opts) {
    const client = new $138964854a115163$var$TRPCUntypedClient(opts);
    return client;
}
/**
 * @deprecated use `createTRPCProxyClient` instead
 */ function $138964854a115163$export$b2acd49cd3814618(opts) {
    const client = new $138964854a115163$var$TRPCUntypedClient(opts);
    return client;
}
const $138964854a115163$var$clientCallTypeMap = {
    query: 'query',
    mutate: 'mutation',
    subscribe: 'subscription'
};
/** @internal */ const $138964854a115163$export$fb09c8ac507dc94d = (clientCallType)=>{
    return $138964854a115163$var$clientCallTypeMap[clientCallType];
};
/**
 * @deprecated use `createTRPCProxyClient` instead
 * @internal
 */ function $138964854a115163$export$a66136bdbd4ef050(client) {
    return (0, $llFhu.c)((key)=>{
        if (client.hasOwnProperty(key)) return client[key];
        return (0, $llFhu.a)(({ path: path, args: args })=>{
            const pathCopy = [
                key,
                ...path
            ];
            const procedureType = $138964854a115163$export$fb09c8ac507dc94d(pathCopy.pop());
            const fullPath = pathCopy.join('.');
            return client[procedureType](fullPath, ...args);
        });
    });
}
function $138964854a115163$export$29b633cf6ed54809(opts) {
    const client = new $138964854a115163$var$TRPCUntypedClient(opts);
    const proxy = $138964854a115163$export$a66136bdbd4ef050(client);
    return proxy;
}
const $138964854a115163$var$getBody = (opts)=>{
    if (!('input' in opts)) return undefined;
    if (!(opts.input instanceof FormData)) throw new Error('Input is not FormData');
    return opts.input;
};
const $138964854a115163$var$formDataRequester = (opts)=>{
    if (opts.type !== 'mutation') // TODO(?) handle formdata queries
    throw new Error('We only handle mutations with formdata');
    return (0, $8NlHQ.h)({
        ...opts,
        getUrl () {
            return `${opts.url}/${opts.path}`;
        },
        getBody: $138964854a115163$var$getBody
    });
};
const $138964854a115163$export$4e7fd0d93e18bb17 = (0, $kkI5j.httpLinkFactory)({
    requester: $138964854a115163$var$formDataRequester
});

});
parcelRegister("5Ic56", function(module, exports) {

$parcel$export(module.exports, "share", () => $5b760bfacc7a28c3$export$ed80d9de1d9df928);
$parcel$export(module.exports, "tap", () => $5b760bfacc7a28c3$export$3f23594af5f37336);
$parcel$export(module.exports, "observableToPromise", () => $5b760bfacc7a28c3$export$391d300976c8872e);
$parcel$export(module.exports, "observable", () => (parcelRequire("4OGSE")).o);

var $4OGSE = parcelRequire("4OGSE");
function $5b760bfacc7a28c3$export$ed80d9de1d9df928(_opts) {
    return (originalObserver)=>{
        let refCount = 0;
        let subscription = null;
        const observers = [];
        function startIfNeeded() {
            if (subscription) return;
            subscription = originalObserver.subscribe({
                next (value) {
                    for (const observer of observers)observer.next?.(value);
                },
                error (error) {
                    for (const observer of observers)observer.error?.(error);
                },
                complete () {
                    for (const observer of observers)observer.complete?.();
                }
            });
        }
        function resetIfNeeded() {
            // "resetOnRefCountZero"
            if (refCount === 0 && subscription) {
                const _sub = subscription;
                subscription = null;
                _sub.unsubscribe();
            }
        }
        return {
            subscribe (observer) {
                refCount++;
                observers.push(observer);
                startIfNeeded();
                return {
                    unsubscribe () {
                        refCount--;
                        resetIfNeeded();
                        const index = observers.findIndex((v)=>v === observer);
                        if (index > -1) observers.splice(index, 1);
                    }
                };
            }
        };
    };
}
function $5b760bfacc7a28c3$export$871de8747c9eaa88(project) {
    return (originalObserver)=>{
        return {
            subscribe (observer) {
                let index = 0;
                const subscription = originalObserver.subscribe({
                    next (value) {
                        observer.next?.(project(value, index++));
                    },
                    error (error) {
                        observer.error?.(error);
                    },
                    complete () {
                        observer.complete?.();
                    }
                });
                return subscription;
            }
        };
    };
}
function $5b760bfacc7a28c3$export$3f23594af5f37336(observer) {
    return (originalObserver)=>{
        return {
            subscribe (observer2) {
                return originalObserver.subscribe({
                    next (v) {
                        observer.next?.(v);
                        observer2.next?.(v);
                    },
                    error (v) {
                        observer.error?.(v);
                        observer2.error?.(v);
                    },
                    complete () {
                        observer.complete?.();
                        observer2.complete?.();
                    }
                });
            }
        };
    };
}
class $5b760bfacc7a28c3$var$ObservableAbortError extends Error {
    constructor(message){
        super(message);
        this.name = 'ObservableAbortError';
        Object.setPrototypeOf(this, $5b760bfacc7a28c3$var$ObservableAbortError.prototype);
    }
}
/** @internal */ function $5b760bfacc7a28c3$export$391d300976c8872e(observable) {
    let abort;
    const promise = new Promise((resolve, reject)=>{
        let isDone = false;
        function onDone() {
            if (isDone) return;
            isDone = true;
            reject(new $5b760bfacc7a28c3$var$ObservableAbortError('This operation was aborted.'));
            obs$.unsubscribe();
        }
        const obs$ = observable.subscribe({
            next (data) {
                isDone = true;
                resolve(data);
                onDone();
            },
            error (data) {
                isDone = true;
                reject(data);
                onDone();
            },
            complete () {
                isDone = true;
                onDone();
            }
        });
        abort = onDone;
    });
    return {
        promise: promise,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        abort: abort
    };
}

});
parcelRegister("4OGSE", function(module, exports) {

$parcel$export(module.exports, "o", () => $77877be69032f8b5$export$ae1af26003f05816);
function $77877be69032f8b5$var$identity(x) {
    return x;
}
/** @internal */ function $77877be69032f8b5$var$pipeFromArray(fns) {
    if (fns.length === 0) return $77877be69032f8b5$var$identity;
    if (fns.length === 1) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fns[0];
    return function piped(input) {
        return fns.reduce((prev, fn)=>fn(prev), input);
    };
}
function $77877be69032f8b5$export$23f2a1d2818174ef(x) {
    return typeof x === 'object' && x !== null && 'subscribe' in x;
}
function $77877be69032f8b5$export$ae1af26003f05816(subscribe) {
    const self = {
        subscribe (observer) {
            let teardownRef = null;
            let isDone = false;
            let unsubscribed = false;
            let teardownImmediately = false;
            function unsubscribe() {
                if (teardownRef === null) {
                    teardownImmediately = true;
                    return;
                }
                if (unsubscribed) return;
                unsubscribed = true;
                if (typeof teardownRef === 'function') teardownRef();
                else if (teardownRef) teardownRef.unsubscribe();
            }
            teardownRef = subscribe({
                next (value) {
                    if (isDone) return;
                    observer.next?.(value);
                },
                error (err) {
                    if (isDone) return;
                    isDone = true;
                    observer.error?.(err);
                    unsubscribe();
                },
                complete () {
                    if (isDone) return;
                    isDone = true;
                    observer.complete?.();
                    unsubscribe();
                }
            });
            if (teardownImmediately) unsubscribe();
            return {
                unsubscribe: unsubscribe
            };
        },
        pipe (...operations) {
            return $77877be69032f8b5$var$pipeFromArray(operations)(self);
        }
    };
    return self;
}

});


parcelRegister("dxr6w", function(module, exports) {

$parcel$export(module.exports, "T", () => $0802d86f4ccfbaac$export$971d5caa766a69d7);
$parcel$export(module.exports, "t", () => $0802d86f4ccfbaac$export$625550452a3fa3ec);
class $0802d86f4ccfbaac$export$971d5caa766a69d7 extends Error {
    static from(cause, opts = {}) {
        if (!(cause instanceof Error)) return new $0802d86f4ccfbaac$export$971d5caa766a69d7(cause.error.message ?? '', {
            ...opts,
            cause: undefined,
            result: cause
        });
        if (cause.name === 'TRPCClientError') return cause;
        return new $0802d86f4ccfbaac$export$971d5caa766a69d7(cause.message, {
            ...opts,
            cause: cause,
            result: null
        });
    }
    constructor(message, opts){
        const cause = opts?.cause;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore https://github.com/tc39/proposal-error-cause
        super(message, {
            cause: cause
        });
        this.meta = opts?.meta;
        this.cause = cause;
        this.shape = opts?.result?.error;
        this.data = opts?.result?.error.data;
        this.name = 'TRPCClientError';
        Object.setPrototypeOf(this, $0802d86f4ccfbaac$export$971d5caa766a69d7.prototype);
    }
}
function $0802d86f4ccfbaac$var$isObject(value) {
    // check that value is object
    return !!value && !Array.isArray(value) && typeof value === 'object';
}
// FIXME:
// - the generics here are probably unnecessary
// - the RPC-spec could probably be simplified to combine HTTP + WS
/** @internal */ function $0802d86f4ccfbaac$var$transformResultInner(response, runtime) {
    if ('error' in response) {
        const error = runtime.transformer.deserialize(response.error);
        return {
            ok: false,
            error: {
                ...response,
                error: error
            }
        };
    }
    const result = {
        ...response.result,
        ...(!response.result.type || response.result.type === 'data') && {
            type: 'data',
            data: runtime.transformer.deserialize(response.result.data)
        }
    };
    return {
        ok: true,
        result: result
    };
}
/**
 * Transforms and validates that the result is a valid TRPCResponse
 * @internal
 */ function $0802d86f4ccfbaac$export$625550452a3fa3ec(response, runtime) {
    let result;
    try {
        // Use the data transformers on the JSON-response
        result = $0802d86f4ccfbaac$var$transformResultInner(response, runtime);
    } catch (err) {
        throw new $0802d86f4ccfbaac$export$971d5caa766a69d7('Unable to transform response from server');
    }
    // check that output of the transformers is a valid TRPCResponse
    if (!result.ok && (!$0802d86f4ccfbaac$var$isObject(result.error.error) || typeof result.error.error.code !== 'number')) throw new $0802d86f4ccfbaac$export$971d5caa766a69d7('Badly formatted response from server');
    if (result.ok && !$0802d86f4ccfbaac$var$isObject(result.result)) throw new $0802d86f4ccfbaac$export$971d5caa766a69d7('Badly formatted response from server');
    return result;
}

});

parcelRegister("4OziX", function(module, exports) {

$parcel$export(module.exports, "c", () => $78a2faf2a30aefc8$export$db3b6bfb95261072);
parcelRequire("5Ic56");
var $4OGSE = parcelRequire("4OGSE");
/** @internal */ function $78a2faf2a30aefc8$export$db3b6bfb95261072(opts) {
    return (0, $4OGSE.o)((observer)=>{
        function execute(index = 0, op = opts.op) {
            const next = opts.links[index];
            if (!next) throw new Error('No more links to execute - did you forget to add an ending link?');
            const subscription = next({
                op: op,
                next (nextOp) {
                    const nextObserver = execute(index + 1, nextOp);
                    return nextObserver;
                }
            });
            return subscription;
        }
        const obs$ = execute();
        return obs$.subscribe(observer);
    });
}
function $78a2faf2a30aefc8$var$asArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $78a2faf2a30aefc8$export$2408f22a0fab9ae5(opts) {
    return (runtime)=>{
        const yes = $78a2faf2a30aefc8$var$asArray(opts.true).map((link)=>link(runtime));
        const no = $78a2faf2a30aefc8$var$asArray(opts.false).map((link)=>link(runtime));
        return (props)=>{
            return (0, $4OGSE.o)((observer)=>{
                const links = opts.condition(props.op) ? yes : no;
                return $78a2faf2a30aefc8$export$db3b6bfb95261072({
                    op: props.op,
                    links: links
                }).subscribe(observer);
            });
        };
    };
}

});

parcelRegister("276dz", function(module, exports) {

$parcel$export(module.exports, "createFlatProxy", () => (parcelRequire("llFhu")).c);
$parcel$export(module.exports, "createRecursiveProxy", () => (parcelRequire("llFhu")).a);

var $llFhu = parcelRequire("llFhu");

var $iUkIe = parcelRequire("iUkIe");
parcelRequire("53UbX");

});
parcelRegister("llFhu", function(module, exports) {

$parcel$export(module.exports, "g", () => $ebb45cc62c0f600e$export$39b482c5e57630a8);
$parcel$export(module.exports, "a", () => $ebb45cc62c0f600e$export$407448d2b89b1813);
$parcel$export(module.exports, "c", () => $ebb45cc62c0f600e$export$db3b6bfb95261072);

var $53UbX = parcelRequire("53UbX");
const $ebb45cc62c0f600e$export$971d5caa766a69d7 = (0, $53UbX.i)((0, $53UbX.T));
const $ebb45cc62c0f600e$var$JSONRPC2_TO_HTTP_CODE = {
    PARSE_ERROR: 400,
    BAD_REQUEST: 400,
    NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    TIMEOUT: 408,
    CONFLICT: 409,
    CLIENT_CLOSED_REQUEST: 499,
    PRECONDITION_FAILED: 412,
    PAYLOAD_TOO_LARGE: 413,
    METHOD_NOT_SUPPORTED: 405,
    UNPROCESSABLE_CONTENT: 422,
    TOO_MANY_REQUESTS: 429
};
function $ebb45cc62c0f600e$var$getStatusCodeFromKey(code) {
    return $ebb45cc62c0f600e$var$JSONRPC2_TO_HTTP_CODE[code] ?? 500;
}
function $ebb45cc62c0f600e$export$8b22cf2602fb60ce(json) {
    const arr = Array.isArray(json) ? json : [
        json
    ];
    const httpStatuses = new Set(arr.map((res)=>{
        if ('error' in res) {
            const data = res.error.data;
            if (typeof data.httpStatus === 'number') return data.httpStatus;
            const code = $ebb45cc62c0f600e$export$971d5caa766a69d7[res.error.code];
            return $ebb45cc62c0f600e$var$getStatusCodeFromKey(code);
        }
        return 200;
    }));
    if (httpStatuses.size !== 1) return 207;
    const httpStatus = httpStatuses.values().next().value;
    return httpStatus;
}
function $ebb45cc62c0f600e$export$39b482c5e57630a8(error) {
    const { code: code } = error;
    return $ebb45cc62c0f600e$var$getStatusCodeFromKey(code);
}
const $ebb45cc62c0f600e$var$noop = ()=>{
// noop
};
function $ebb45cc62c0f600e$var$createInnerProxy(callback, path) {
    const proxy = new Proxy($ebb45cc62c0f600e$var$noop, {
        get (_obj, key) {
            if (typeof key !== 'string' || key === 'then') // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return $ebb45cc62c0f600e$var$createInnerProxy(callback, [
                ...path,
                key
            ]);
        },
        apply (_1, _2, args) {
            const isApply = path[path.length - 1] === 'apply';
            return callback({
                args: isApply ? args.length >= 2 ? args[1] : [] : args,
                path: isApply ? path.slice(0, -1) : path
            });
        }
    });
    return proxy;
}
/**
 * Creates a proxy that calls the callback with the path and arguments
 *
 * @internal
 */ const $ebb45cc62c0f600e$export$407448d2b89b1813 = (callback)=>$ebb45cc62c0f600e$var$createInnerProxy(callback, []);
/**
 * Used in place of `new Proxy` where each handler will map 1 level deep to another value.
 *
 * @internal
 */ const $ebb45cc62c0f600e$export$db3b6bfb95261072 = (callback)=>{
    return new Proxy($ebb45cc62c0f600e$var$noop, {
        get (_obj, name) {
            if (typeof name !== 'string' || name === 'then') // special case for if the proxy is accidentally treated
            // like a PromiseLike (like in `Promise.resolve(proxy)`)
            return undefined;
            return callback(name);
        }
    });
};

});
parcelRegister("53UbX", function(module, exports) {

$parcel$export(module.exports, "i", () => $7305c1ca53b89ada$export$23f2a1d2818174ef);
$parcel$export(module.exports, "T", () => $7305c1ca53b89ada$export$971d5caa766a69d7);
/**
 * @internal
 */ function $7305c1ca53b89ada$export$23f2a1d2818174ef(obj) {
    const newObj = Object.create(null);
    for(const key in obj){
        const v = obj[key];
        newObj[v] = key;
    }
    return newObj;
}
// reference: https://www.jsonrpc.org/specification
/**
 * JSON-RPC 2.0 Error codes
 *
 * `-32000` to `-32099` are reserved for implementation-defined server-errors.
 * For tRPC we're copying the last digits of HTTP 4XX errors.
 */ const $7305c1ca53b89ada$export$971d5caa766a69d7 = {
    /**
   * Invalid JSON was received by the server.
   * An error occurred on the server while parsing the JSON text.
   */ PARSE_ERROR: -32700,
    /**
   * The JSON sent is not a valid Request object.
   */ BAD_REQUEST: -32600,
    /**
   * Internal JSON-RPC error.
   */ INTERNAL_SERVER_ERROR: -32603,
    // Implementation specific errors
    UNAUTHORIZED: -32001,
    FORBIDDEN: -32003,
    NOT_FOUND: -32004,
    METHOD_NOT_SUPPORTED: -32005,
    TIMEOUT: -32008,
    CONFLICT: -32009,
    PRECONDITION_FAILED: -32012,
    PAYLOAD_TOO_LARGE: -32013,
    UNPROCESSABLE_CONTENT: -32022,
    TOO_MANY_REQUESTS: -32029,
    CLIENT_CLOSED_REQUEST: -32099
};
const $7305c1ca53b89ada$export$407448d2b89b1813 = $7305c1ca53b89ada$export$23f2a1d2818174ef($7305c1ca53b89ada$export$971d5caa766a69d7);

});


parcelRegister("iUkIe", function(module, exports) {

var $llFhu = parcelRequire("llFhu");

var $53UbX = parcelRequire("53UbX");
/**
 * @internal
 */ function $902fbfb7a6d010b0$export$39b482c5e57630a8(opts) {
    const { path: path, error: error, config: config } = opts;
    const { code: code } = opts.error;
    const shape = {
        message: error.message,
        code: (0, $53UbX.T)[code],
        data: {
            code: code,
            httpStatus: (0, $llFhu.g)(error)
        }
    };
    if (config.isDev && typeof opts.error.stack === 'string') shape.data.stack = opts.error.stack;
    if (typeof path === 'string') shape.data.path = path;
    return config.errorFormatter({
        ...opts,
        shape: shape
    });
}
function $902fbfb7a6d010b0$var$transformTRPCResponseItem(config, item) {
    if ('error' in item) return {
        ...item,
        error: config.transformer.output.serialize(item.error)
    };
    if ('data' in item.result) return {
        ...item,
        result: {
            ...item.result,
            data: config.transformer.output.serialize(item.result.data)
        }
    };
    return item;
}
/**
 * Takes a unserialized `TRPCResponse` and serializes it with the router's transformers
 **/ function $902fbfb7a6d010b0$export$625550452a3fa3ec(config, itemOrItems) {
    return Array.isArray(itemOrItems) ? itemOrItems.map((item)=>$902fbfb7a6d010b0$var$transformTRPCResponseItem(config, item)) : $902fbfb7a6d010b0$var$transformTRPCResponseItem(config, itemOrItems);
}

});


parcelRegister("8NlHQ", function(module, exports) {

$parcel$export(module.exports, "r", () => $f3cb08ae11511374$export$43caf9889c228507);
$parcel$export(module.exports, "a", () => $f3cb08ae11511374$export$407448d2b89b1813);
$parcel$export(module.exports, "j", () => $f3cb08ae11511374$export$35e795649ee09318);
$parcel$export(module.exports, "h", () => $f3cb08ae11511374$export$dda1d9f60106f0e9);
const $f3cb08ae11511374$var$isFunction = (fn)=>typeof fn === 'function';
function $f3cb08ae11511374$var$_bind(fn, thisArg) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return $f3cb08ae11511374$var$isFunction(fn.bind) ? fn.bind(thisArg) : fn;
}
function $f3cb08ae11511374$export$39b482c5e57630a8(customFetchImpl) {
    if (customFetchImpl) return customFetchImpl;
    if (typeof window !== 'undefined' && $f3cb08ae11511374$var$isFunction(window.fetch)) return $f3cb08ae11511374$var$_bind(window.fetch, window);
    if (typeof globalThis !== 'undefined' && $f3cb08ae11511374$var$isFunction(globalThis.fetch)) return $f3cb08ae11511374$var$_bind(globalThis.fetch, globalThis);
    throw new Error('No fetch implementation found');
}
function $f3cb08ae11511374$var$getAbortController(customAbortControllerImpl) {
    if (customAbortControllerImpl) return customAbortControllerImpl;
    if (typeof window !== 'undefined' && window.AbortController) return window.AbortController;
    if (typeof globalThis !== 'undefined' && globalThis.AbortController) return globalThis.AbortController;
    return null;
}
function $f3cb08ae11511374$export$43caf9889c228507(opts) {
    return {
        url: opts.url,
        fetch: $f3cb08ae11511374$export$39b482c5e57630a8(opts.fetch),
        AbortController: $f3cb08ae11511374$var$getAbortController(opts.AbortController)
    };
}
// https://github.com/trpc/trpc/pull/669
function $f3cb08ae11511374$var$arrayToDict(array) {
    const dict = {};
    for(let index = 0; index < array.length; index++){
        const element = array[index];
        dict[index] = element;
    }
    return dict;
}
const $f3cb08ae11511374$var$METHOD = {
    query: 'GET',
    mutation: 'POST'
};
function $f3cb08ae11511374$var$getInput(opts) {
    return 'input' in opts ? opts.runtime.transformer.serialize(opts.input) : $f3cb08ae11511374$var$arrayToDict(opts.inputs.map((_input)=>opts.runtime.transformer.serialize(_input)));
}
const $f3cb08ae11511374$export$407448d2b89b1813 = (opts)=>{
    let url = opts.url + '/' + opts.path;
    const queryParts = [];
    if ('inputs' in opts) queryParts.push('batch=1');
    if (opts.type === 'query') {
        const input = $f3cb08ae11511374$var$getInput(opts);
        if (input !== undefined) queryParts.push(`input=${encodeURIComponent(JSON.stringify(input))}`);
    }
    if (queryParts.length) url += '?' + queryParts.join('&');
    return url;
};
const $f3cb08ae11511374$var$getBody = (opts)=>{
    if (opts.type === 'query') return undefined;
    const input = $f3cb08ae11511374$var$getInput(opts);
    return input !== undefined ? JSON.stringify(input) : undefined;
};
const $f3cb08ae11511374$export$35e795649ee09318 = (opts)=>{
    return $f3cb08ae11511374$export$dda1d9f60106f0e9({
        ...opts,
        contentTypeHeader: 'application/json',
        getUrl: $f3cb08ae11511374$export$407448d2b89b1813,
        getBody: $f3cb08ae11511374$var$getBody
    });
};
function $f3cb08ae11511374$export$dda1d9f60106f0e9(opts) {
    const { type: type } = opts;
    const ac = opts.AbortController ? new opts.AbortController() : null;
    const promise = new Promise((resolve, reject)=>{
        const url = opts.getUrl(opts);
        const body = opts.getBody(opts);
        const meta = {};
        Promise.resolve(opts.headers()).then((headers)=>{
            /* istanbul ignore if -- @preserve */ if (type === 'subscription') throw new Error('Subscriptions should use wsLink');
            return opts.fetch(url, {
                method: $f3cb08ae11511374$var$METHOD[type],
                signal: ac?.signal,
                body: body,
                headers: {
                    ...opts.contentTypeHeader ? {
                        'content-type': opts.contentTypeHeader
                    } : {},
                    ...headers
                }
            });
        }).then((_res)=>{
            meta.response = _res;
            return _res.json();
        }).then((json)=>{
            resolve({
                json: json,
                meta: meta
            });
        }).catch(reject);
    });
    const cancel = ()=>{
        ac?.abort();
    };
    return {
        promise: promise,
        cancel: cancel
    };
}

});

parcelRegister("h5AIr", function(module, exports) {

$parcel$export(module.exports, "httpBatchLink", () => $9e8bcf451bff3383$export$5b913342393f3ee0);
parcelRequire("5Ic56");
var $4OGSE = parcelRequire("4OGSE");

var $dxr6w = parcelRequire("dxr6w");

var $8NlHQ = parcelRequire("8NlHQ");
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /**
 * A function that should never be called unless we messed something up.
 */ const $9e8bcf451bff3383$var$throwFatalError = ()=>{
    throw new Error('Something went wrong. Please submit an issue at https://github.com/trpc/trpc/issues/new');
};
/**
 * Dataloader that's very inspired by https://github.com/graphql/dataloader
 * Less configuration, no caching, and allows you to cancel requests
 * When cancelling a single fetch the whole batch will be cancelled only when _all_ items are cancelled
 */ function $9e8bcf451bff3383$var$dataLoader(batchLoader) {
    let pendingItems = null;
    let dispatchTimer = null;
    const destroyTimerAndPendingItems = ()=>{
        clearTimeout(dispatchTimer);
        dispatchTimer = null;
        pendingItems = null;
    };
    /**
   * Iterate through the items and split them into groups based on the `batchLoader`'s validate function
   */ function groupItems(items) {
        const groupedItems = [
            []
        ];
        let index = 0;
        while(true){
            const item = items[index];
            if (!item) break;
            const lastGroup = groupedItems[groupedItems.length - 1];
            if (item.aborted) {
                // Item was aborted before it was dispatched
                item.reject(new Error('Aborted'));
                index++;
                continue;
            }
            const isValid = batchLoader.validate(lastGroup.concat(item).map((it)=>it.key));
            if (isValid) {
                lastGroup.push(item);
                index++;
                continue;
            }
            if (lastGroup.length === 0) {
                item.reject(new Error('Input is too big for a single dispatch'));
                index++;
                continue;
            }
            // Create new group, next iteration will try to add the item to that
            groupedItems.push([]);
        }
        return groupedItems;
    }
    function dispatch() {
        const groupedItems = groupItems(pendingItems);
        destroyTimerAndPendingItems();
        // Create batches for each group of items
        for (const items of groupedItems){
            if (!items.length) continue;
            const batch = {
                items: items,
                cancel: $9e8bcf451bff3383$var$throwFatalError
            };
            for (const item of items)item.batch = batch;
            const { promise: promise, cancel: cancel } = batchLoader.fetch(batch.items.map((_item)=>_item.key));
            batch.cancel = cancel;
            promise.then((result)=>{
                for(let i = 0; i < result.length; i++){
                    const value = result[i];
                    const item = batch.items[i];
                    item.resolve(value);
                    item.batch = null;
                }
            }).catch((cause)=>{
                for (const item of batch.items){
                    item.reject(cause);
                    item.batch = null;
                }
            });
        }
    }
    function load(key) {
        const item = {
            aborted: false,
            key: key,
            batch: null,
            resolve: $9e8bcf451bff3383$var$throwFatalError,
            reject: $9e8bcf451bff3383$var$throwFatalError
        };
        const promise = new Promise((resolve, reject)=>{
            item.reject = reject;
            item.resolve = resolve;
            if (!pendingItems) pendingItems = [];
            pendingItems.push(item);
        });
        if (!dispatchTimer) dispatchTimer = setTimeout(dispatch);
        const cancel = ()=>{
            item.aborted = true;
            if (item.batch?.items.every((item)=>item.aborted)) {
                // All items in the batch have been cancelled
                item.batch.cancel();
                item.batch = null;
            }
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }
    return {
        load: load
    };
}
function $9e8bcf451bff3383$export$5b913342393f3ee0(opts) {
    const resolvedOpts = (0, $8NlHQ.r)(opts);
    // initialized config
    return (runtime)=>{
        const maxURLLength = opts.maxURLLength || Infinity;
        const batchLoader = (type)=>{
            const validate = (batchOps)=>{
                if (maxURLLength === Infinity) // escape hatch for quick calcs
                return true;
                const path = batchOps.map((op)=>op.path).join(',');
                const inputs = batchOps.map((op)=>op.input);
                const url = (0, $8NlHQ.a)({
                    ...resolvedOpts,
                    runtime: runtime,
                    type: type,
                    path: path,
                    inputs: inputs
                });
                return url.length <= maxURLLength;
            };
            const fetch = (batchOps)=>{
                const path = batchOps.map((op)=>op.path).join(',');
                const inputs = batchOps.map((op)=>op.input);
                const { promise: promise, cancel: cancel } = (0, $8NlHQ.j)({
                    ...resolvedOpts,
                    runtime: runtime,
                    type: type,
                    path: path,
                    inputs: inputs,
                    headers () {
                        if (!opts.headers) return {};
                        if (typeof opts.headers === 'function') return opts.headers({
                            opList: batchOps
                        });
                        return opts.headers;
                    }
                });
                return {
                    promise: promise.then((res)=>{
                        const resJSON = Array.isArray(res.json) ? res.json : batchOps.map(()=>res.json);
                        const result = resJSON.map((item)=>({
                                meta: res.meta,
                                json: item
                            }));
                        return result;
                    }),
                    cancel: cancel
                };
            };
            return {
                validate: validate,
                fetch: fetch
            };
        };
        const query = $9e8bcf451bff3383$var$dataLoader(batchLoader('query'));
        const mutation = $9e8bcf451bff3383$var$dataLoader(batchLoader('mutation'));
        const subscription = $9e8bcf451bff3383$var$dataLoader(batchLoader('subscription'));
        const loaders = {
            query: query,
            subscription: subscription,
            mutation: mutation
        };
        return ({ op: op })=>{
            return (0, $4OGSE.o)((observer)=>{
                const loader = loaders[op.type];
                const { promise: promise, cancel: cancel } = loader.load(op);
                promise.then((res)=>{
                    const transformed = (0, $dxr6w.t)(res.json, runtime);
                    if (!transformed.ok) {
                        observer.error((0, $dxr6w.T).from(transformed.error, {
                            meta: res.meta
                        }));
                        return;
                    }
                    observer.next({
                        context: res.meta,
                        result: transformed.result
                    });
                    observer.complete();
                }).catch((err)=>observer.error((0, $dxr6w.T).from(err)));
                return ()=>{
                    cancel();
                };
            });
        };
    };
}

});

parcelRegister("kkI5j", function(module, exports) {

$parcel$export(module.exports, "httpLinkFactory", () => $95f97718cd657035$export$404a788fcf5149fa);
parcelRequire("5Ic56");
var $4OGSE = parcelRequire("4OGSE");

var $dxr6w = parcelRequire("dxr6w");

var $8NlHQ = parcelRequire("8NlHQ");
function $95f97718cd657035$export$404a788fcf5149fa(factoryOpts) {
    return (opts)=>{
        const resolvedOpts = (0, $8NlHQ.r)(opts);
        return (runtime)=>({ op: op })=>(0, $4OGSE.o)((observer)=>{
                    const { path: path, input: input, type: type } = op;
                    const { promise: promise, cancel: cancel } = factoryOpts.requester({
                        ...resolvedOpts,
                        runtime: runtime,
                        type: type,
                        path: path,
                        input: input,
                        headers () {
                            if (!opts.headers) return {};
                            if (typeof opts.headers === 'function') return opts.headers({
                                op: op
                            });
                            return opts.headers;
                        }
                    });
                    promise.then((res)=>{
                        const transformed = (0, $dxr6w.t)(res.json, runtime);
                        if (!transformed.ok) {
                            observer.error((0, $dxr6w.T).from(transformed.error, {
                                meta: res.meta
                            }));
                            return;
                        }
                        observer.next({
                            context: res.meta,
                            result: transformed.result
                        });
                        observer.complete();
                    }).catch((cause)=>observer.error((0, $dxr6w.T).from(cause)));
                    return ()=>{
                        cancel();
                    };
                });
    };
}
const $95f97718cd657035$export$9b6146f3c3e2c24a = $95f97718cd657035$export$404a788fcf5149fa({
    requester: (0, $8NlHQ.j)
});

});

parcelRegister("4vmeb", function(module, exports) {
parcelRequire("5Ic56");
var $4OGSE = parcelRequire("4OGSE");
var $5Ic56 = parcelRequire("5Ic56");
/// <reference lib="dom.iterable" />
const $95d6e96d0c252ba2$var$palette = {
    query: [
        '72e3ff',
        '3fb0d8'
    ],
    mutation: [
        'c5a3fc',
        '904dfc'
    ],
    subscription: [
        'ff49e1',
        'd83fbe'
    ]
};
function $95d6e96d0c252ba2$var$isFormData(value) {
    if (typeof FormData === 'undefined') // FormData is not supported
    return false;
    return value instanceof FormData;
}
// maybe this should be moved to it's own package
const $95d6e96d0c252ba2$var$defaultLogger = (c = console)=>(props)=>{
        const { direction: direction, type: type, path: path, context: context, id: id } = props;
        const [light, dark] = $95d6e96d0c252ba2$var$palette[type];
        const rawInput = props.input;
        const input = $95d6e96d0c252ba2$var$isFormData(rawInput) ? Object.fromEntries(rawInput) : rawInput;
        const css = `
    background-color: #${direction === 'up' ? light : dark}; 
    color: ${direction === 'up' ? 'black' : 'white'};
    padding: 2px;
  `;
        const parts = [
            '%c',
            direction === 'up' ? '>>' : '<<',
            type,
            `#${id}`,
            `%c${path}%c`,
            '%O'
        ];
        const args = [
            css,
            `${css}; font-weight: bold;`,
            `${css}; font-weight: normal;`
        ];
        if (props.direction === 'up') args.push({
            input: input,
            context: context
        });
        else args.push({
            input: input,
            result: props.result,
            elapsedMs: props.elapsedMs,
            context: context
        });
        const fn = props.direction === 'down' && props.result && (props.result instanceof Error || 'error' in props.result.result) ? 'error' : 'log';
        c[fn].apply(null, [
            parts.join(' ')
        ].concat(args));
    };
function $95d6e96d0c252ba2$export$6c4954c1f47de3ce(opts = {}) {
    const { enabled: enabled = ()=>true } = opts;
    const { logger: logger = $95d6e96d0c252ba2$var$defaultLogger(opts.console) } = opts;
    return ()=>{
        return ({ op: op, next: next })=>{
            return (0, $4OGSE.o)((observer)=>{
                // ->
                enabled({
                    ...op,
                    direction: 'up'
                }) && logger({
                    ...op,
                    direction: 'up'
                });
                const requestStartTime = Date.now();
                function logResult(result) {
                    const elapsedMs = Date.now() - requestStartTime;
                    enabled({
                        ...op,
                        direction: 'down',
                        result: result
                    }) && logger({
                        ...op,
                        direction: 'down',
                        elapsedMs: elapsedMs,
                        result: result
                    });
                }
                return next(op).pipe((0, $5Ic56.tap)({
                    next (result) {
                        logResult(result);
                    },
                    error (result) {
                        logResult(result);
                    }
                })).subscribe(observer);
            });
        };
    };
}

});

parcelRegister("3RqaU", function(module, exports) {
parcelRequire("5Ic56");
var $4OGSE = parcelRequire("4OGSE");

var $dxr6w = parcelRequire("dxr6w");
/* istanbul ignore next -- @preserve */ const $392a0797f5ebf75c$var$retryDelay = (attemptIndex)=>attemptIndex === 0 ? 0 : Math.min(1000 * 2 ** attemptIndex, 30000);
function $392a0797f5ebf75c$export$345df463fed6e4eb(opts) {
    const { url: url, WebSocket: WebSocketImpl = WebSocket, retryDelayMs: retryDelayFn = $392a0797f5ebf75c$var$retryDelay, onOpen: onOpen, onClose: onClose } = opts;
    /* istanbul ignore next -- @preserve */ if (!WebSocketImpl) throw new Error("No WebSocket implementation found - you probably don't want to use this on the server, but if you do you need to pass a `WebSocket`-ponyfill");
    /**
   * outgoing messages buffer whilst not open
   */ let outgoing = [];
    const pendingRequests = Object.create(null);
    let connectAttempt = 0;
    let dispatchTimer = null;
    let connectTimer = null;
    let activeConnection = createWS();
    let state = 'connecting';
    /**
   * tries to send the list of messages
   */ function dispatch() {
        if (state !== 'open' || dispatchTimer) return;
        dispatchTimer = setTimeout(()=>{
            dispatchTimer = null;
            if (outgoing.length === 1) // single send
            activeConnection.send(JSON.stringify(outgoing.pop()));
            else // batch send
            activeConnection.send(JSON.stringify(outgoing));
            // clear
            outgoing = [];
        });
    }
    function tryReconnect() {
        if (connectTimer || state === 'closed') return;
        const timeout = retryDelayFn(connectAttempt++);
        reconnectInMs(timeout);
    }
    function reconnect() {
        state = 'connecting';
        const oldConnection = activeConnection;
        activeConnection = createWS();
        closeIfNoPending(oldConnection);
    }
    function reconnectInMs(ms) {
        if (connectTimer) return;
        state = 'connecting';
        connectTimer = setTimeout(reconnect, ms);
    }
    function closeIfNoPending(conn) {
        // disconnect as soon as there are are no pending result
        const hasPendingRequests = Object.values(pendingRequests).some((p)=>p.ws === conn);
        if (!hasPendingRequests) conn.close();
    }
    function closeActiveSubscriptions() {
        Object.values(pendingRequests).forEach((req)=>{
            if (req.type === 'subscription') req.callbacks.complete();
        });
    }
    function resumeSubscriptionOnReconnect(req) {
        if (outgoing.some((r)=>r.id === req.op.id)) return;
        request(req.op, req.callbacks);
    }
    function createWS() {
        const urlString = typeof url === 'function' ? url() : url;
        const conn = new WebSocketImpl(urlString);
        clearTimeout(connectTimer);
        connectTimer = null;
        conn.addEventListener('open', ()=>{
            /* istanbul ignore next -- @preserve */ if (conn !== activeConnection) return;
            connectAttempt = 0;
            state = 'open';
            onOpen?.();
            dispatch();
        });
        conn.addEventListener('error', ()=>{
            if (conn === activeConnection) tryReconnect();
        });
        const handleIncomingRequest = (req)=>{
            if (req.method === 'reconnect' && conn === activeConnection) {
                if (state === 'open') onClose?.();
                reconnect();
                // notify subscribers
                for (const pendingReq of Object.values(pendingRequests))if (pendingReq.type === 'subscription') resumeSubscriptionOnReconnect(pendingReq);
            }
        };
        const handleIncomingResponse = (data)=>{
            const req = data.id !== null && pendingRequests[data.id];
            if (!req) // do something?
            return;
            req.callbacks.next?.(data);
            if (req.ws !== activeConnection && conn === activeConnection) {
                const oldWs = req.ws;
                // gracefully replace old connection with this
                req.ws = activeConnection;
                closeIfNoPending(oldWs);
            }
            if ('result' in data && data.result.type === 'stopped' && conn === activeConnection) req.callbacks.complete();
        };
        conn.addEventListener('message', ({ data: data })=>{
            const msg = JSON.parse(data);
            if ('method' in msg) handleIncomingRequest(msg);
            else handleIncomingResponse(msg);
            if (conn !== activeConnection || state === 'closed') // when receiving a message, we close old connection that has no pending requests
            closeIfNoPending(conn);
        });
        conn.addEventListener('close', ({ code: code })=>{
            if (state === 'open') onClose?.({
                code: code
            });
            if (activeConnection === conn) // connection might have been replaced already
            tryReconnect();
            for (const [key, req] of Object.entries(pendingRequests)){
                if (req.ws !== conn) continue;
                if (state === 'closed') {
                    // If the connection was closed, we just call `complete()` on the request
                    delete pendingRequests[key];
                    req.callbacks.complete?.();
                    continue;
                }
                // The connection was closed either unexpectedly or because of a reconnect
                if (req.type === 'subscription') // Subscriptions will resume after we've reconnected
                resumeSubscriptionOnReconnect(req);
                else {
                    // Queries and mutations will error if interrupted
                    delete pendingRequests[key];
                    req.callbacks.error?.((0, $dxr6w.T).from(new $392a0797f5ebf75c$var$TRPCWebSocketClosedError('WebSocket closed prematurely')));
                }
            }
        });
        return conn;
    }
    function request(op, callbacks) {
        const { type: type, input: input, path: path, id: id } = op;
        const envelope = {
            id: id,
            method: type,
            params: {
                input: input,
                path: path
            }
        };
        pendingRequests[id] = {
            ws: activeConnection,
            type: type,
            callbacks: callbacks,
            op: op
        };
        // enqueue message
        outgoing.push(envelope);
        dispatch();
        return ()=>{
            const callbacks = pendingRequests[id]?.callbacks;
            delete pendingRequests[id];
            outgoing = outgoing.filter((msg)=>msg.id !== id);
            callbacks?.complete?.();
            if (activeConnection.readyState === WebSocketImpl.OPEN && op.type === 'subscription') {
                outgoing.push({
                    id: id,
                    method: 'subscription.stop'
                });
                dispatch();
            }
        };
    }
    return {
        close: ()=>{
            state = 'closed';
            onClose?.();
            closeActiveSubscriptions();
            closeIfNoPending(activeConnection);
            clearTimeout(connectTimer);
            connectTimer = null;
        },
        request: request,
        getConnection () {
            return activeConnection;
        }
    };
}
class $392a0797f5ebf75c$var$TRPCWebSocketClosedError extends Error {
    constructor(message){
        super(message);
        this.name = 'TRPCWebSocketClosedError';
        Object.setPrototypeOf(this, $392a0797f5ebf75c$var$TRPCWebSocketClosedError.prototype);
    }
}
function $392a0797f5ebf75c$export$31d1274c8c32ef82(opts) {
    return (runtime)=>{
        const { client: client } = opts;
        return ({ op: op })=>{
            return (0, $4OGSE.o)((observer)=>{
                const { type: type, path: path, id: id, context: context } = op;
                const input = runtime.transformer.serialize(op.input);
                const unsub = client.request({
                    type: type,
                    path: path,
                    input: input,
                    id: id,
                    context: context
                }, {
                    error (err) {
                        observer.error(err);
                        unsub();
                    },
                    complete () {
                        observer.complete();
                    },
                    next (message) {
                        const transformed = (0, $dxr6w.t)(message, runtime);
                        if (!transformed.ok) {
                            observer.error((0, $dxr6w.T).from(transformed.error));
                            return;
                        }
                        observer.next({
                            result: transformed.result
                        });
                        if (op.type !== 'subscription') {
                            // if it isn't a subscription we don't care about next response
                            unsub();
                            observer.complete();
                        }
                    }
                });
                return ()=>{
                    unsub();
                };
            });
        };
    };
}

});


parcelRegister("lVRg0", function(module, exports) {

$parcel$export(module.exports, "b", () => $f0591d4cdbcd7301$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "a", () => $f0591d4cdbcd7301$export$407448d2b89b1813);
$parcel$export(module.exports, "c", () => $f0591d4cdbcd7301$export$db3b6bfb95261072);
parcelRequire("276dz");
var $llFhu = parcelRequire("llFhu");

var $ii04n = parcelRequire("ii04n");

var $cX54e = parcelRequire("cX54e");

var $2m1Ye = parcelRequire("2m1Ye");
var $6FXEj = parcelRequire("6FXEj");
var $bUh7d = parcelRequire("bUh7d");
var $2o9As = parcelRequire("2o9As");
var $gGkal = parcelRequire("gGkal");
var $2EXpz = parcelRequire("2EXpz");

var $acw62 = parcelRequire("acw62");
/**
 * We treat `undefined` as an input the same as omitting an `input`
 * https://github.com/trpc/trpc/issues/2290
 */ function $f0591d4cdbcd7301$var$getQueryKeyInternal(path, input) {
    if (path.length) return input === undefined ? [
        path
    ] : [
        path,
        input
    ];
    return [];
}
/**
 * Method to extract the query key for a procedure
 * @param procedureOrRouter - procedure or AnyRouter
 * @param input - input to procedureOrRouter
 * @param type - defaults to `any`
 * @link https://trpc.io/docs/getQueryKey
 */ function $f0591d4cdbcd7301$export$39b482c5e57630a8(..._params) {
    const [procedureOrRouter, input, type] = _params;
    // @ts-expect-error - we don't expose _def on the type layer
    const path = procedureOrRouter._def().path;
    const dotPath = path.join('.');
    const queryKey = (0, $ii04n.g)($f0591d4cdbcd7301$var$getQueryKeyInternal(dotPath, input), type ?? 'any');
    return queryKey;
}
/**
 * Create proxy for decorating procedures
 * @internal
 */ function $f0591d4cdbcd7301$export$8b22cf2602fb60ce(name, hooks) {
    return (0, $llFhu.a)((opts)=>{
        const args = opts.args;
        const pathCopy = [
            name,
            ...opts.path
        ];
        // The last arg is for instance `.useMutation` or `.useQuery()`
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastArg = pathCopy.pop();
        // The `path` ends up being something like `post.byId`
        const path = pathCopy.join('.');
        if (lastArg === 'useMutation') return hooks[lastArg](path, ...args);
        const [input, ...rest] = args;
        const queryKey = $f0591d4cdbcd7301$var$getQueryKeyInternal(path, input);
        // Expose queryKey helper
        if (lastArg === 'getQueryKey') return (0, $ii04n.g)(queryKey, rest[0] ?? 'any');
        if (lastArg === '_def') return {
            path: pathCopy
        };
        if (lastArg.startsWith('useSuspense')) {
            const opts1 = rest[0] || {};
            const fn = lastArg === 'useSuspenseQuery' ? 'useQuery' : 'useInfiniteQuery';
            const result = hooks[fn](queryKey, {
                ...opts1,
                suspense: true,
                enabled: true
            });
            return [
                result.data,
                result
            ];
        }
        return hooks[lastArg](queryKey, ...rest);
    });
}
const $f0591d4cdbcd7301$export$dda1d9f60106f0e9 = [
    'client',
    'ssrContext',
    'ssrState',
    'abortOnUnmount'
];
const $f0591d4cdbcd7301$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $acw62.createContext)(null);
/**
 * @internal
 */ function $f0591d4cdbcd7301$export$407448d2b89b1813(context) {
    return (0, $llFhu.c)((key)=>{
        const contextName = key;
        if (contextName === 'client') return (0, $cX54e.createTRPCClientProxy)(context.client);
        if ($f0591d4cdbcd7301$export$dda1d9f60106f0e9.includes(contextName)) return context[contextName];
        return (0, $llFhu.a)(({ path: path, args: args })=>{
            const pathCopy = [
                key,
                ...path
            ];
            const utilName = pathCopy.pop();
            const fullPath = pathCopy.join('.');
            const getOpts = (name)=>{
                if ([
                    'setData',
                    'setInfiniteData'
                ].includes(name)) {
                    const [input, updater, ...rest] = args;
                    const queryKey = $f0591d4cdbcd7301$var$getQueryKeyInternal(fullPath, input);
                    return {
                        queryKey: queryKey,
                        updater: updater,
                        rest: rest
                    };
                }
                const [input1, ...rest1] = args;
                const queryKey1 = $f0591d4cdbcd7301$var$getQueryKeyInternal(fullPath, input1);
                return {
                    queryKey: queryKey1,
                    rest: rest1
                };
            };
            const { queryKey: queryKey, rest: rest, updater: updater } = getOpts(utilName);
            const contextMap = {
                fetch: ()=>context.fetchQuery(queryKey, ...rest),
                fetchInfinite: ()=>context.fetchInfiniteQuery(queryKey, ...rest),
                prefetch: ()=>context.prefetchQuery(queryKey, ...rest),
                prefetchInfinite: ()=>context.prefetchInfiniteQuery(queryKey, ...rest),
                ensureData: ()=>context.ensureQueryData(queryKey, ...rest),
                invalidate: ()=>context.invalidateQueries(queryKey, ...rest),
                reset: ()=>context.resetQueries(queryKey, ...rest),
                refetch: ()=>context.refetchQueries(queryKey, ...rest),
                cancel: ()=>context.cancelQuery(queryKey, ...rest),
                setData: ()=>context.setQueryData(queryKey, updater, ...rest),
                setInfiniteData: ()=>context.setInfiniteQueryData(queryKey, updater, ...rest),
                getData: ()=>context.getQueryData(queryKey),
                getInfiniteData: ()=>context.getInfiniteQueryData(queryKey)
            };
            return contextMap[utilName]();
        });
    });
}
/**
 * Create proxy for `useQueries` options
 * @internal
 */ function $f0591d4cdbcd7301$export$f1e1789686576879(client) {
    return (0, $llFhu.a)((opts)=>{
        const path = opts.path.join('.');
        const [input, ...rest] = opts.args;
        const queryKey = $f0591d4cdbcd7301$var$getQueryKeyInternal(path, input);
        const options = {
            queryKey: queryKey,
            queryFn: ()=>{
                return client.query(path, input);
            },
            ...rest[0]
        };
        return options;
    });
}
function $f0591d4cdbcd7301$export$4368d992c4eafac0(pathAndInput, opts) {
    const [path, input] = pathAndInput;
    return [
        path,
        input,
        opts?.trpc
    ];
}
/**
 * Makes a stable reference of the `trpc` prop
 */ function $f0591d4cdbcd7301$var$useHookResult(value) {
    const ref = (0, $acw62.useRef)(value);
    ref.current.path = value.path;
    return ref.current;
}
/**
 * @internal
 */ function $f0591d4cdbcd7301$export$2d1720544b23b823(config) {
    const mutationSuccessOverride = (config?.overrides ?? config?.unstable_overrides)?.useMutation?.onSuccess ?? ((options)=>options.originalFn());
    const Context = config?.context ?? $f0591d4cdbcd7301$export$971d5caa766a69d7;
    const ReactQueryContext = config?.reactQueryContext;
    const createClient = (opts)=>{
        return (0, $cX54e.createTRPCClient)(opts);
    };
    const TRPCProvider = (props)=>{
        const { abortOnUnmount: abortOnUnmount = false, client: client, queryClient: queryClient, ssrContext: ssrContext } = props;
        const [ssrState, setSSRState] = (0, $acw62.useState)(props.ssrState ?? false);
        (0, $acw62.useEffect)(()=>{
            // Only updating state to `mounted` if we are using SSR.
            // This makes it so we don't have an unnecessary re-render when opting out of SSR.
            setSSRState((state)=>state ? 'mounted' : false);
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: {
                abortOnUnmount: abortOnUnmount,
                queryClient: queryClient,
                client: client,
                ssrContext: ssrContext || null,
                ssrState: ssrState,
                fetchQuery: (0, $acw62.useCallback)((pathAndInput, opts)=>{
                    return queryClient.fetchQuery({
                        ...opts,
                        queryKey: (0, $ii04n.g)(pathAndInput, 'query'),
                        queryFn: ()=>client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0(pathAndInput, opts))
                    });
                }, [
                    client,
                    queryClient
                ]),
                fetchInfiniteQuery: (0, $acw62.useCallback)((pathAndInput, opts)=>{
                    return queryClient.fetchInfiniteQuery({
                        ...opts,
                        queryKey: (0, $ii04n.g)(pathAndInput, 'infinite'),
                        queryFn: ({ pageParam: pageParam })=>{
                            const [path, input] = pathAndInput;
                            const actualInput = {
                                ...input,
                                cursor: pageParam
                            };
                            return client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0([
                                path,
                                actualInput
                            ], opts));
                        }
                    });
                }, [
                    client,
                    queryClient
                ]),
                prefetchQuery: (0, $acw62.useCallback)((pathAndInput, opts)=>{
                    return queryClient.prefetchQuery({
                        ...opts,
                        queryKey: (0, $ii04n.g)(pathAndInput, 'query'),
                        queryFn: ()=>client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0(pathAndInput, opts))
                    });
                }, [
                    client,
                    queryClient
                ]),
                prefetchInfiniteQuery: (0, $acw62.useCallback)((pathAndInput, opts)=>{
                    return queryClient.prefetchInfiniteQuery({
                        ...opts,
                        queryKey: (0, $ii04n.g)(pathAndInput, 'infinite'),
                        queryFn: ({ pageParam: pageParam })=>{
                            const [path, input] = pathAndInput;
                            const actualInput = {
                                ...input,
                                cursor: pageParam
                            };
                            return client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0([
                                path,
                                actualInput
                            ], opts));
                        }
                    });
                }, [
                    client,
                    queryClient
                ]),
                ensureQueryData: (0, $acw62.useCallback)((pathAndInput, opts)=>{
                    return queryClient.ensureQueryData({
                        ...opts,
                        queryKey: (0, $ii04n.g)(pathAndInput, 'query'),
                        queryFn: ()=>client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0(pathAndInput, opts))
                    });
                }, [
                    client,
                    queryClient
                ]),
                invalidateQueries: (0, $acw62.useCallback)((queryKey, filters, options)=>{
                    return queryClient.invalidateQueries({
                        ...filters,
                        queryKey: (0, $ii04n.g)(queryKey, 'any')
                    }, options);
                }, [
                    queryClient
                ]),
                resetQueries: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, filters, options] = args;
                    return queryClient.resetQueries({
                        ...filters,
                        queryKey: (0, $ii04n.g)(queryKey, 'any')
                    }, options);
                }, [
                    queryClient
                ]),
                refetchQueries: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, filters, options] = args;
                    return queryClient.refetchQueries({
                        ...filters,
                        queryKey: (0, $ii04n.g)(queryKey, 'any')
                    }, options);
                }, [
                    queryClient
                ]),
                cancelQuery: (0, $acw62.useCallback)((pathAndInput)=>{
                    return queryClient.cancelQueries({
                        queryKey: (0, $ii04n.g)(pathAndInput, 'any')
                    });
                }, [
                    queryClient
                ]),
                setQueryData: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.setQueryData((0, $ii04n.g)(queryKey, 'query'), ...rest);
                }, [
                    queryClient
                ]),
                getQueryData: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.getQueryData((0, $ii04n.g)(queryKey, 'query'), ...rest);
                }, [
                    queryClient
                ]),
                setInfiniteQueryData: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.setQueryData((0, $ii04n.g)(queryKey, 'infinite'), ...rest);
                }, [
                    queryClient
                ]),
                getInfiniteQueryData: (0, $acw62.useCallback)((...args)=>{
                    const [queryKey, ...rest] = args;
                    return queryClient.getQueryData((0, $ii04n.g)(queryKey, 'infinite'), ...rest);
                }, [
                    queryClient
                ])
            }
        }, props.children);
    };
    function useContext() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext(Context);
    }
    /**
   * Hack to make sure errors return `status`='error` when doing SSR
   * @link https://github.com/trpc/trpc/pull/1645
   */ function useSSRQueryOptionsIfNeeded(pathAndInput, type, opts) {
        const { queryClient: queryClient, ssrState: ssrState } = useContext();
        return ssrState && ssrState !== 'mounted' && queryClient.getQueryCache().find((0, $ii04n.g)(pathAndInput, type))?.state.status === 'error' ? {
            retryOnMount: false,
            ...opts
        } : opts;
    }
    function useQuery$1(pathAndInput, opts) {
        const context = useContext();
        if (!context) throw new Error('Unable to retrieve application context. Did you forget to wrap your App inside `withTRPC` HoC?');
        const { abortOnUnmount: abortOnUnmount, client: client, ssrState: ssrState, queryClient: queryClient, prefetchQuery: prefetchQuery } = context;
        if (typeof window === 'undefined' && ssrState === 'prepass' && opts?.trpc?.ssr !== false && opts?.enabled !== false && !queryClient.getQueryCache().find((0, $ii04n.g)(pathAndInput, 'query'))) prefetchQuery(pathAndInput, opts);
        const ssrOpts = useSSRQueryOptionsIfNeeded(pathAndInput, 'query', opts);
        const shouldAbortOnUnmount = opts?.trpc?.abortOnUnmount ?? config?.abortOnUnmount ?? abortOnUnmount;
        const hook = (0, $gGkal.useQuery)({
            ...ssrOpts,
            queryKey: (0, $ii04n.g)(pathAndInput, 'query'),
            queryFn: (queryFunctionContext)=>{
                const actualOpts = {
                    ...ssrOpts,
                    trpc: {
                        ...ssrOpts?.trpc,
                        ...shouldAbortOnUnmount ? {
                            signal: queryFunctionContext.signal
                        } : {}
                    }
                };
                return client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0(pathAndInput, actualOpts));
            },
            context: ReactQueryContext
        });
        hook.trpc = $f0591d4cdbcd7301$var$useHookResult({
            path: pathAndInput[0]
        });
        return hook;
    }
    function useMutation$1(path, opts) {
        const { client: client } = useContext();
        const queryClient = (0, $2EXpz.useQueryClient)({
            context: ReactQueryContext
        });
        const actualPath = Array.isArray(path) ? path[0] : path;
        const hook = (0, $bUh7d.useMutation)({
            ...opts,
            mutationKey: [
                actualPath.split('.')
            ],
            mutationFn: (input)=>{
                return client.mutation(...$f0591d4cdbcd7301$export$4368d992c4eafac0([
                    actualPath,
                    input
                ], opts));
            },
            context: ReactQueryContext,
            onSuccess (...args) {
                const originalFn = ()=>opts?.onSuccess?.(...args);
                return mutationSuccessOverride({
                    originalFn: originalFn,
                    queryClient: queryClient,
                    meta: opts?.meta ?? {}
                });
            }
        });
        hook.trpc = $f0591d4cdbcd7301$var$useHookResult({
            path: actualPath
        });
        return hook;
    }
    /* istanbul ignore next -- @preserve */ function useSubscription(pathAndInput, opts) {
        const enabled = opts?.enabled ?? true;
        const queryKey = (0, $2m1Ye.hashQueryKey)(pathAndInput);
        const { client: client } = useContext();
        const optsRef = (0, $acw62.useRef)(opts);
        optsRef.current = opts;
        return (0, $acw62.useEffect)(()=>{
            if (!enabled) return;
            const [path, input] = pathAndInput;
            let isStopped = false;
            const subscription = client.subscription(path, input ?? undefined, {
                onStarted: ()=>{
                    if (!isStopped) optsRef.current.onStarted?.();
                },
                onData: (data)=>{
                    if (!isStopped) // FIXME this shouldn't be needed as both should be `unknown` in next major
                    optsRef.current.onData(data);
                },
                onError: (err)=>{
                    if (!isStopped) optsRef.current.onError?.(err);
                }
            });
            return ()=>{
                isStopped = true;
                subscription.unsubscribe();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            queryKey,
            enabled
        ]);
    }
    function useInfiniteQuery$1(pathAndInput, opts) {
        const [path, input] = pathAndInput;
        const { client: client, ssrState: ssrState, prefetchInfiniteQuery: prefetchInfiniteQuery, queryClient: queryClient, abortOnUnmount: abortOnUnmount } = useContext();
        if (typeof window === 'undefined' && ssrState === 'prepass' && opts?.trpc?.ssr !== false && opts?.enabled !== false && !queryClient.getQueryCache().find((0, $ii04n.g)(pathAndInput, 'infinite'))) prefetchInfiniteQuery(pathAndInput, opts);
        const ssrOpts = useSSRQueryOptionsIfNeeded(pathAndInput, 'infinite', opts);
        // request option should take priority over global
        const shouldAbortOnUnmount = opts?.trpc?.abortOnUnmount ?? abortOnUnmount;
        const hook = (0, $6FXEj.useInfiniteQuery)({
            ...ssrOpts,
            queryKey: (0, $ii04n.g)(pathAndInput, 'infinite'),
            queryFn: (queryFunctionContext)=>{
                const actualOpts = {
                    ...ssrOpts,
                    trpc: {
                        ...ssrOpts?.trpc,
                        ...shouldAbortOnUnmount ? {
                            signal: queryFunctionContext.signal
                        } : {}
                    }
                };
                const actualInput = {
                    ...input ?? {},
                    cursor: queryFunctionContext.pageParam ?? opts?.initialCursor
                };
                // FIXME as any shouldn't be needed as client should be untyped too
                return client.query(...$f0591d4cdbcd7301$export$4368d992c4eafac0([
                    path,
                    actualInput
                ], actualOpts));
            },
            context: ReactQueryContext
        });
        hook.trpc = $f0591d4cdbcd7301$var$useHookResult({
            path: path
        });
        return hook;
    }
    const useQueries$1 = (queriesCallback, context)=>{
        const { ssrState: ssrState, queryClient: queryClient, prefetchQuery: prefetchQuery, client: client } = useContext();
        const proxy = $f0591d4cdbcd7301$export$f1e1789686576879(client);
        const queries = queriesCallback(proxy);
        if (typeof window === 'undefined' && ssrState === 'prepass') for (const query of queries){
            const queryOption = query;
            if (queryOption.trpc?.ssr !== false && !queryClient.getQueryCache().find((0, $ii04n.g)(queryOption.queryKey, 'query'))) prefetchQuery(queryOption.queryKey, queryOption);
        }
        return (0, $2o9As.useQueries)({
            queries: queries.map((query)=>({
                    ...query,
                    queryKey: (0, $ii04n.g)(query.queryKey, 'query')
                })),
            context: context
        });
    };
    const useDehydratedState = (client, trpcState)=>{
        const transformed = (0, $acw62.useMemo)(()=>{
            if (!trpcState) return trpcState;
            return client.runtime.transformer.deserialize(trpcState);
        }, [
            trpcState,
            client
        ]);
        return transformed;
    };
    return {
        Provider: TRPCProvider,
        createClient: createClient,
        useContext: useContext,
        useQuery: useQuery$1,
        useQueries: useQueries$1,
        useMutation: useMutation$1,
        useSubscription: useSubscription,
        useDehydratedState: useDehydratedState,
        useInfiniteQuery: useInfiniteQuery$1
    };
}
/**
 * Create strongly typed react hooks
 * @internal
 * @deprecated
 */ function $f0591d4cdbcd7301$export$db3b6bfb95261072(config) {
    return $f0591d4cdbcd7301$export$2d1720544b23b823(config);
}

});
parcelRegister("ii04n", function(module, exports) {

$parcel$export(module.exports, "g", () => $4c3059bdadccb5ad$export$39b482c5e57630a8);
/**
 * To allow easy interactions with groups of related queries, such as
 * invalidating all queries of a router, we use an array as the path when
 * storing in tanstack query. This function converts from the `.` separated
 * path passed around internally by both the legacy and proxy implementation.
 * https://github.com/trpc/trpc/issues/2611
 **/ function $4c3059bdadccb5ad$export$39b482c5e57630a8(queryKey, type) {
    const queryKeyArrayed = Array.isArray(queryKey) ? queryKey : [
        queryKey
    ];
    const [path, input] = queryKeyArrayed;
    const arrayPath = typeof path !== 'string' || path === '' ? [] : path.split('.');
    // Construct a query key that is easy to destructure and flexible for
    // partial selecting etc.
    // https://github.com/trpc/trpc/issues/3128
    if (!input && (!type || type === 'any')) // we don't want nested array if path is empty, i.e. `[]` instead of `[[]]`
    return arrayPath.length ? [
        arrayPath
    ] : [];
    return [
        arrayPath,
        {
            ...typeof input !== 'undefined' && {
                input: input
            },
            ...type && type !== 'any' && {
                type: type
            }
        }
    ];
}

});

parcelRegister("2m1Ye", function(module, exports) {

$parcel$export(module.exports, "isServer", () => $701564ddc3b1d1fd$export$6acf61af03e62db);
$parcel$export(module.exports, "noop", () => $701564ddc3b1d1fd$export$8793edee2d425525);
$parcel$export(module.exports, "functionalUpdate", () => $701564ddc3b1d1fd$export$7f095f455ad5af3f);
$parcel$export(module.exports, "isValidTimeout", () => $701564ddc3b1d1fd$export$e539f754e934e270);
$parcel$export(module.exports, "difference", () => $701564ddc3b1d1fd$export$acaf96a27438246b);
$parcel$export(module.exports, "replaceAt", () => $701564ddc3b1d1fd$export$224e3b7078227b8a);
$parcel$export(module.exports, "timeUntilStale", () => $701564ddc3b1d1fd$export$811b83d62bcf47f0);
$parcel$export(module.exports, "parseQueryArgs", () => $701564ddc3b1d1fd$export$8a11fbc2c8ea08fd);
$parcel$export(module.exports, "parseMutationArgs", () => $701564ddc3b1d1fd$export$b646c531ea475334);
$parcel$export(module.exports, "parseFilterArgs", () => $701564ddc3b1d1fd$export$18e8f4b987e6c111);
$parcel$export(module.exports, "matchQuery", () => $701564ddc3b1d1fd$export$c5d1efe363797780);
$parcel$export(module.exports, "hashQueryKeyByOptions", () => $701564ddc3b1d1fd$export$cc90ca97bc0d73fd);
$parcel$export(module.exports, "partialMatchKey", () => $701564ddc3b1d1fd$export$2f07189bb9fa26a7);
$parcel$export(module.exports, "matchMutation", () => $701564ddc3b1d1fd$export$a1ea5fb559f63ae3);
$parcel$export(module.exports, "hashQueryKey", () => $701564ddc3b1d1fd$export$5fcb678681417b54);
$parcel$export(module.exports, "shallowEqualObjects", () => $701564ddc3b1d1fd$export$3e67810a3f0e9f1c);
$parcel$export(module.exports, "sleep", () => $701564ddc3b1d1fd$export$e772c8ff12451969);
$parcel$export(module.exports, "scheduleMicrotask", () => $701564ddc3b1d1fd$export$4304cb76768ca134);
$parcel$export(module.exports, "getAbortController", () => $701564ddc3b1d1fd$export$382ca5d13a8f252c);
$parcel$export(module.exports, "replaceData", () => $701564ddc3b1d1fd$export$17619bac5b909b23);
// TYPES
// UTILS
const $701564ddc3b1d1fd$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $701564ddc3b1d1fd$export$8793edee2d425525() {
    return undefined;
}
function $701564ddc3b1d1fd$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $701564ddc3b1d1fd$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $701564ddc3b1d1fd$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>array2.indexOf(x) === -1);
}
function $701564ddc3b1d1fd$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $701564ddc3b1d1fd$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $701564ddc3b1d1fd$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$701564ddc3b1d1fd$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $701564ddc3b1d1fd$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($701564ddc3b1d1fd$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $701564ddc3b1d1fd$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $701564ddc3b1d1fd$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $701564ddc3b1d1fd$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $701564ddc3b1d1fd$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $701564ddc3b1d1fd$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($701564ddc3b1d1fd$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $701564ddc3b1d1fd$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$701564ddc3b1d1fd$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $701564ddc3b1d1fd$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($701564ddc3b1d1fd$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($701564ddc3b1d1fd$export$5fcb678681417b54(mutation.options.mutationKey) !== $701564ddc3b1d1fd$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$701564ddc3b1d1fd$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $701564ddc3b1d1fd$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $701564ddc3b1d1fd$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $701564ddc3b1d1fd$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$701564ddc3b1d1fd$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $701564ddc3b1d1fd$export$2f07189bb9fa26a7(a, b) {
    return $701564ddc3b1d1fd$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $701564ddc3b1d1fd$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$701564ddc3b1d1fd$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $701564ddc3b1d1fd$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $701564ddc3b1d1fd$export$7a8558113332b71e(a) && $701564ddc3b1d1fd$export$7a8558113332b71e(b);
    if (array || $701564ddc3b1d1fd$export$53b83ca8eaab0383(a) && $701564ddc3b1d1fd$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $701564ddc3b1d1fd$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $701564ddc3b1d1fd$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $701564ddc3b1d1fd$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $701564ddc3b1d1fd$export$53b83ca8eaab0383(o) {
    if (!$701564ddc3b1d1fd$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$701564ddc3b1d1fd$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $701564ddc3b1d1fd$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $701564ddc3b1d1fd$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $701564ddc3b1d1fd$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $701564ddc3b1d1fd$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $701564ddc3b1d1fd$export$4304cb76768ca134(callback) {
    $701564ddc3b1d1fd$export$e772c8ff12451969(0).then(callback);
}
function $701564ddc3b1d1fd$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $701564ddc3b1d1fd$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $701564ddc3b1d1fd$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("6FXEj", function(module, exports) {

$parcel$export(module.exports, "useInfiniteQuery", () => $ef24d8b5cd9436a6$export$bdc59d3c1a6569aa);

var $4RVb6 = parcelRequire("4RVb6");
var $2m1Ye = parcelRequire("2m1Ye");

var $hi2ri = parcelRequire("hi2ri");
'use client';
function $ef24d8b5cd9436a6$export$bdc59d3c1a6569aa(arg1, arg2, arg3) {
    const options = (0, $2m1Ye.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $hi2ri.useBaseQuery)(options, (0, $4RVb6.InfiniteQueryObserver));
}

});
parcelRegister("4RVb6", function(module, exports) {

$parcel$export(module.exports, "InfiniteQueryObserver", () => $cc0436fae3af65ed$export$85d960eb3ab339c8);

var $cnQDF = parcelRequire("cnQDF");

var $5QdqP = parcelRequire("5QdqP");
class $cc0436fae3af65ed$export$85d960eb3ab339c8 extends (0, $cnQDF.QueryObserver) {
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options, notifyOptions) {
        super.setOptions({
            ...options,
            behavior: (0, $5QdqP.infiniteQueryBehavior)()
        }, notifyOptions);
    }
    getOptimisticResult(options) {
        options.behavior = (0, $5QdqP.infiniteQueryBehavior)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: 'forward',
                    pageParam: pageParam
                }
            }
        });
    }
    fetchPreviousPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: 'backward',
                    pageParam: pageParam
                }
            }
        });
    }
    createResult(query, options) {
        var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;
        const { state: state } = query;
        const result = super.createResult(query, options);
        const { isFetching: isFetching, isRefetching: isRefetching } = result;
        const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
        const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
        return {
            ...result,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $5QdqP.hasNextPage)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $5QdqP.hasPreviousPage)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: isFetchingNextPage,
            isFetchingPreviousPage: isFetchingPreviousPage,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        };
    }
}

});
parcelRegister("cnQDF", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", () => $0cb2d4c7897fbdd6$export$a06cf8c0066f0d4c);

var $2m1Ye = parcelRequire("2m1Ye");

var $3eYBn = parcelRequire("3eYBn");

var $bLCnn = parcelRequire("bLCnn");

var $eklm2 = parcelRequire("eklm2");

var $40nk7 = parcelRequire("40nk7");
class $0cb2d4c7897fbdd6$export$a06cf8c0066f0d4c extends (0, $eklm2.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($0cb2d4c7897fbdd6$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $0cb2d4c7897fbdd6$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $0cb2d4c7897fbdd6$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $2m1Ye.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $0cb2d4c7897fbdd6$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        return this.createResult(query, options);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $2m1Ye.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $2m1Ye.isServer) || this.currentResult.isStale || !(0, $2m1Ye.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $2m1Ye.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $2m1Ye.isServer) || this.options.enabled === false || !(0, $2m1Ye.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $bLCnn.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $0cb2d4c7897fbdd6$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $0cb2d4c7897fbdd6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $40nk7.canFetch)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $2m1Ye.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $2m1Ye.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $0cb2d4c7897fbdd6$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $2m1Ye.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            if (notifyOnChangeProps === 'all' || !notifyOnChangeProps && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangeProps != null ? notifyOnChangeProps : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $40nk7.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $3eYBn.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
}
function $0cb2d4c7897fbdd6$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $0cb2d4c7897fbdd6$var$shouldFetchOnMount(query, options) {
    return $0cb2d4c7897fbdd6$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $0cb2d4c7897fbdd6$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $0cb2d4c7897fbdd6$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $0cb2d4c7897fbdd6$var$isStale(query, options);
    }
    return false;
}
function $0cb2d4c7897fbdd6$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $0cb2d4c7897fbdd6$var$isStale(query, options);
}
function $0cb2d4c7897fbdd6$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

});
parcelRegister("3eYBn", function(module, exports) {

$parcel$export(module.exports, "notifyManager", () => $c6b49d29c3de91fc$export$520687f44db6e1ab);

var $2m1Ye = parcelRequire("2m1Ye");
function $c6b49d29c3de91fc$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $2m1Ye.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $2m1Ye.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $c6b49d29c3de91fc$export$520687f44db6e1ab = $c6b49d29c3de91fc$export$316a8efd03cd1458();

});

parcelRegister("bLCnn", function(module, exports) {

$parcel$export(module.exports, "focusManager", () => $ce1e3ac9b20a41cc$export$6bf54661be5b02cf);

var $eklm2 = parcelRequire("eklm2");

var $2m1Ye = parcelRequire("2m1Ye");
class $ce1e3ac9b20a41cc$export$86f1af424b2ca4de extends (0, $eklm2.Subscribable) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $2m1Ye.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
}
const $ce1e3ac9b20a41cc$export$6bf54661be5b02cf = new $ce1e3ac9b20a41cc$export$86f1af424b2ca4de();

});
parcelRegister("eklm2", function(module, exports) {

$parcel$export(module.exports, "Subscribable", () => $1e9df3007496b64f$export$d26086b469ecdbcc);
class $1e9df3007496b64f$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}

});


parcelRegister("40nk7", function(module, exports) {

$parcel$export(module.exports, "canFetch", () => $0e8cb0b286ff9380$export$61b92f63f30245cf);
$parcel$export(module.exports, "isCancelledError", () => $0e8cb0b286ff9380$export$986cc6445c1d323);
$parcel$export(module.exports, "createRetryer", () => $0e8cb0b286ff9380$export$2cbd00fe8a2c8d85);

var $bLCnn = parcelRequire("bLCnn");

var $6wgcO = parcelRequire("6wgcO");

var $2m1Ye = parcelRequire("2m1Ye");
function $0e8cb0b286ff9380$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $0e8cb0b286ff9380$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $6wgcO.onlineManager).isOnline() : true;
}
class $0e8cb0b286ff9380$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $0e8cb0b286ff9380$export$986cc6445c1d323(value) {
    return value instanceof $0e8cb0b286ff9380$export$a8430ed4188f35a9;
}
function $0e8cb0b286ff9380$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $0e8cb0b286ff9380$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $bLCnn.focusManager).isFocused() || config.networkMode !== 'always' && !(0, $6wgcO.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $0e8cb0b286ff9380$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $2m1Ye.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($0e8cb0b286ff9380$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("6wgcO", function(module, exports) {

$parcel$export(module.exports, "onlineManager", () => $2e8e2a668fc3132b$export$b113e788b2dd3fdc);

var $eklm2 = parcelRequire("eklm2");

var $2m1Ye = parcelRequire("2m1Ye");
class $2e8e2a668fc3132b$export$58774fb55d5ff7fc extends (0, $eklm2.Subscribable) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $2m1Ye.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
}
const $2e8e2a668fc3132b$export$b113e788b2dd3fdc = new $2e8e2a668fc3132b$export$58774fb55d5ff7fc();

});



parcelRegister("5QdqP", function(module, exports) {

$parcel$export(module.exports, "infiniteQueryBehavior", () => $4a7b5f8a0cdbeb89$export$84470d1367601e8d);
$parcel$export(module.exports, "hasNextPage", () => $4a7b5f8a0cdbeb89$export$b9c88add8b8b5e6a);
$parcel$export(module.exports, "hasPreviousPage", () => $4a7b5f8a0cdbeb89$export$db1663b730a8e6e4);
function $4a7b5f8a0cdbeb89$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject('Missing queryFn'));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $4a7b5f8a0cdbeb89$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $4a7b5f8a0cdbeb89$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $4a7b5f8a0cdbeb89$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $4a7b5f8a0cdbeb89$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $4a7b5f8a0cdbeb89$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $4a7b5f8a0cdbeb89$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $4a7b5f8a0cdbeb89$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $4a7b5f8a0cdbeb89$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $4a7b5f8a0cdbeb89$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}

});


parcelRegister("hi2ri", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", () => $c481189c43edbbaf$export$fff0865807e996c5);

var $acw62 = parcelRequire("acw62");

var $4v7G7 = parcelRequire("4v7G7");

var $3eYBn = parcelRequire("3eYBn");

var $iJ17x = parcelRequire("iJ17x");

var $2EXpz = parcelRequire("2EXpz");

var $juRHw = parcelRequire("juRHw");

var $aKNbo = parcelRequire("aKNbo");

var $cCwUq = parcelRequire("cCwUq");
'use client';
function $c481189c43edbbaf$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $2EXpz.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $juRHw.useIsRestoring)();
    const errorResetBoundary = (0, $iJ17x.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $3eYBn.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $3eYBn.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $3eYBn.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $cCwUq.ensureStaleTime)(defaultedOptions);
    (0, $aKNbo.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $aKNbo.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $4v7G7.useSyncExternalStore)($acw62.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, $3eYBn.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $cCwUq.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $cCwUq.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $aKNbo.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("4v7G7", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $62344a41d0dce6cd$export$306c0aa65ff9ec16);

var $hfliI = parcelRequire("hfliI");
'use client';
const $62344a41d0dce6cd$export$306c0aa65ff9ec16 = (0, $hfliI.useSyncExternalStore);

});

parcelRegister("iJ17x", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", () => $04549392f387e8c8$export$50dfac555130cafd);

var $acw62 = parcelRequire("acw62");
'use client';
function $04549392f387e8c8$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $04549392f387e8c8$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $acw62.createContext($04549392f387e8c8$var$createValue()); // HOOK
const $04549392f387e8c8$export$50dfac555130cafd = ()=>$acw62.useContext($04549392f387e8c8$var$QueryErrorResetBoundaryContext); // COMPONENT
const $04549392f387e8c8$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$04549392f387e8c8$var$createValue());
    return /*#__PURE__*/ $acw62.createElement($04549392f387e8c8$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

});

parcelRegister("2EXpz", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", () => $ddc9533bb4173188$export$22e77b9572c4fded);
$parcel$export(module.exports, "QueryClientProvider", () => $ddc9533bb4173188$export$45604f0cc8ae667b);

var $acw62 = parcelRequire("acw62");
'use client';
const $ddc9533bb4173188$export$2fba198b5b2e37fa = /*#__PURE__*/ $acw62.createContext(undefined);
const $ddc9533bb4173188$var$QueryClientSharingContext = /*#__PURE__*/ $acw62.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $ddc9533bb4173188$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $ddc9533bb4173188$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $ddc9533bb4173188$export$2fba198b5b2e37fa;
}
const $ddc9533bb4173188$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $acw62.useContext($ddc9533bb4173188$var$getQueryClientContext(context, $acw62.useContext($ddc9533bb4173188$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $ddc9533bb4173188$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $ddc9533bb4173188$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $acw62.createElement($ddc9533bb4173188$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("juRHw", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", () => $6dce971ca589e30b$export$4da0178d6b5f553);

var $acw62 = parcelRequire("acw62");
'use client';
const $6dce971ca589e30b$var$IsRestoringContext = /*#__PURE__*/ $acw62.createContext(false);
const $6dce971ca589e30b$export$4da0178d6b5f553 = ()=>$acw62.useContext($6dce971ca589e30b$var$IsRestoringContext);
const $6dce971ca589e30b$export$593807d4e94f9621 = $6dce971ca589e30b$var$IsRestoringContext.Provider;

});

parcelRegister("aKNbo", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", () => $193a51973ba7137e$export$ae8adb3de3d77633);
$parcel$export(module.exports, "useClearResetErrorBoundary", () => $193a51973ba7137e$export$b2b17ca3a1fb0229);
$parcel$export(module.exports, "getHasError", () => $193a51973ba7137e$export$1fbcf724762d607);

var $acw62 = parcelRequire("acw62");

var $kUj6z = parcelRequire("kUj6z");
'use client';
const $193a51973ba7137e$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $193a51973ba7137e$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $193a51973ba7137e$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $kUj6z.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("kUj6z", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", () => $067709c92343007f$export$2072f68e6c3507cf);
function $067709c92343007f$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("cCwUq", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", () => $296901e0e95ef725$export$2c40a591ad2dafb1);
$parcel$export(module.exports, "willFetch", () => $296901e0e95ef725$export$e0a3f29513afe430);
$parcel$export(module.exports, "shouldSuspend", () => $296901e0e95ef725$export$88d3586dfed64df9);
$parcel$export(module.exports, "fetchOptimistic", () => $296901e0e95ef725$export$defdc11a9c9acfcf);
const $296901e0e95ef725$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
    }
};
const $296901e0e95ef725$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $296901e0e95ef725$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $296901e0e95ef725$export$e0a3f29513afe430(result, isRestoring);
const $296901e0e95ef725$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("bUh7d", function(module, exports) {

$parcel$export(module.exports, "useMutation", () => $ac8d25f147cb3331$export$609860bf8b0084c);

var $acw62 = parcelRequire("acw62");

var $4v7G7 = parcelRequire("4v7G7");

var $5ov9n = parcelRequire("5ov9n");
var $3eYBn = parcelRequire("3eYBn");
var $2m1Ye = parcelRequire("2m1Ye");

var $2EXpz = parcelRequire("2EXpz");

var $kUj6z = parcelRequire("kUj6z");
'use client';
function $ac8d25f147cb3331$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $2m1Ye.parseMutationArgs)(arg1, arg2, arg3);
    const queryClient = (0, $2EXpz.useQueryClient)({
        context: options.context
    });
    const [observer] = $acw62.useState(()=>new (0, $5ov9n.MutationObserver)(queryClient, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $4v7G7.useSyncExternalStore)($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $3eYBn.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($ac8d25f147cb3331$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $kUj6z.shouldThrowError)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $ac8d25f147cb3331$var$noop() {}

});
parcelRegister("5ov9n", function(module, exports) {

$parcel$export(module.exports, "MutationObserver", () => $bd4d03fbfdc84484$export$d3c1860ee66f291a);

var $23c67 = parcelRequire("23c67");

var $3eYBn = parcelRequire("3eYBn");

var $eklm2 = parcelRequire("eklm2");

var $2m1Ye = parcelRequire("2m1Ye");
// CLASS
class $bd4d03fbfdc84484$export$d3c1860ee66f291a extends (0, $eklm2.Subscribable) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $2m1Ye.shallowEqualObjects)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: 'observerOptionsUpdated',
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $23c67.getDefaultState)();
        const result = {
            ...state,
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $3eYBn.notifyManager).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}

});
parcelRegister("23c67", function(module, exports) {

$parcel$export(module.exports, "Mutation", () => $c30d8fb4a9a4cf0b$export$17b8b19c814bcf56);
$parcel$export(module.exports, "getDefaultState", () => $c30d8fb4a9a4cf0b$export$a1659b54bac3252a);

var $eNzdB = parcelRequire("eNzdB");

var $3eYBn = parcelRequire("3eYBn");

var $e55Tq = parcelRequire("e55Tq");

var $40nk7 = parcelRequire("40nk7");
// CLASS
class $c30d8fb4a9a4cf0b$export$17b8b19c814bcf56 extends (0, $e55Tq.Removable) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $eNzdB.defaultLogger);
        this.observers = [];
        this.state = config.state || $c30d8fb4a9a4cf0b$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $40nk7.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $40nk7.canFetch)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $3eYBn.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $c30d8fb4a9a4cf0b$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}

});
parcelRegister("eNzdB", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", () => $ac2ab06ae9d894d5$export$1cf3d545f2d4635c);
const $ac2ab06ae9d894d5$export$1cf3d545f2d4635c = console;

});

parcelRegister("e55Tq", function(module, exports) {

$parcel$export(module.exports, "Removable", () => $ad019f463efb928e$export$e09608847fcc8c59);

var $2m1Ye = parcelRequire("2m1Ye");
class $ad019f463efb928e$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $2m1Ye.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $2m1Ye.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});




parcelRegister("2o9As", function(module, exports) {

$parcel$export(module.exports, "useQueries", () => $5e3cb655ac3c9c3d$export$408667c6c87da1e5);

var $acw62 = parcelRequire("acw62");

var $4v7G7 = parcelRequire("4v7G7");

var $3eYBn = parcelRequire("3eYBn");
var $7vubz = parcelRequire("7vubz");

var $2EXpz = parcelRequire("2EXpz");

var $juRHw = parcelRequire("juRHw");

var $iJ17x = parcelRequire("iJ17x");

var $aKNbo = parcelRequire("aKNbo");

var $cCwUq = parcelRequire("cCwUq");
'use client';
// - `context` is omitted as it is passed as a root-level option to `useQueries` instead.
function $5e3cb655ac3c9c3d$export$408667c6c87da1e5({ queries: queries, context: context }) {
    const queryClient = (0, $2EXpz.useQueryClient)({
        context: context
    });
    const isRestoring = (0, $juRHw.useIsRestoring)();
    const errorResetBoundary = (0, $iJ17x.useQueryErrorResetBoundary)();
    const defaultedQueries = $acw62.useMemo(()=>queries.map((options)=>{
            const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure the results are already in fetching state before subscribing or updating options
            defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic';
            return defaultedOptions;
        }), [
        queries,
        queryClient,
        isRestoring
    ]);
    defaultedQueries.forEach((query)=>{
        (0, $cCwUq.ensureStaleTime)(query);
        (0, $aKNbo.ensurePreventErrorBoundaryRetry)(query, errorResetBoundary);
    });
    (0, $aKNbo.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new (0, $7vubz.QueriesObserver)(queryClient, defaultedQueries));
    const optimisticResult = observer.getOptimisticResult(defaultedQueries);
    (0, $4v7G7.useSyncExternalStore)($acw62.useCallback((onStoreChange)=>isRestoring ? ()=>undefined : observer.subscribe((0, $3eYBn.notifyManager).batchCalls(onStoreChange)), [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setQueries(defaultedQueries, {
            listeners: false
        });
    }, [
        defaultedQueries,
        observer
    ]);
    const shouldAtLeastOneSuspend = optimisticResult.some((result, index)=>(0, $cCwUq.shouldSuspend)(defaultedQueries[index], result, isRestoring));
    const suspensePromises = shouldAtLeastOneSuspend ? optimisticResult.flatMap((result, index)=>{
        const options = defaultedQueries[index];
        const queryObserver = observer.getObservers()[index];
        if (options && queryObserver) {
            if ((0, $cCwUq.shouldSuspend)(options, result, isRestoring)) return (0, $cCwUq.fetchOptimistic)(options, queryObserver, errorResetBoundary);
            else if ((0, $cCwUq.willFetch)(result, isRestoring)) (0, $cCwUq.fetchOptimistic)(options, queryObserver, errorResetBoundary);
        }
        return [];
    }) : [];
    if (suspensePromises.length > 0) throw Promise.all(suspensePromises);
    const observerQueries = observer.getQueries();
    const firstSingleResultWhichShouldThrow = optimisticResult.find((result, index)=>{
        var _defaultedQueries$ind, _defaultedQueries$ind2;
        return (0, $aKNbo.getHasError)({
            result: result,
            errorResetBoundary: errorResetBoundary,
            useErrorBoundary: (_defaultedQueries$ind = (_defaultedQueries$ind2 = defaultedQueries[index]) == null ? void 0 : _defaultedQueries$ind2.useErrorBoundary) != null ? _defaultedQueries$ind : false,
            query: observerQueries[index]
        });
    });
    if (firstSingleResultWhichShouldThrow != null && firstSingleResultWhichShouldThrow.error) throw firstSingleResultWhichShouldThrow.error;
    return optimisticResult;
}

});
parcelRegister("7vubz", function(module, exports) {

$parcel$export(module.exports, "QueriesObserver", () => $1548a7d5c2ed10f0$export$15352e437905ad4c);

var $2m1Ye = parcelRequire("2m1Ye");

var $3eYBn = parcelRequire("3eYBn");

var $cnQDF = parcelRequire("cnQDF");

var $eklm2 = parcelRequire("eklm2");
class $1548a7d5c2ed10f0$export$15352e437905ad4c extends (0, $eklm2.Subscribable) {
    constructor(client, queries){
        super();
        this.client = client;
        this.queries = [];
        this.result = [];
        this.observers = [];
        this.observersMap = {};
        if (queries) this.setQueries(queries);
    }
    onSubscribe() {
        if (this.listeners.size === 1) this.observers.forEach((observer)=>{
            observer.subscribe((result)=>{
                this.onUpdate(observer, result);
            });
        });
    }
    onUnsubscribe() {
        if (!this.listeners.size) this.destroy();
    }
    destroy() {
        this.listeners = new Set();
        this.observers.forEach((observer)=>{
            observer.destroy();
        });
    }
    setQueries(queries, notifyOptions) {
        this.queries = queries;
        (0, $3eYBn.notifyManager).batch(()=>{
            const prevObservers = this.observers;
            const newObserverMatches = this.findMatchingObservers(this.queries); // set options for the new observers to notify of changes
            newObserverMatches.forEach((match)=>match.observer.setOptions(match.defaultedQueryOptions, notifyOptions));
            const newObservers = newObserverMatches.map((match)=>match.observer);
            const newObserversMap = Object.fromEntries(newObservers.map((observer)=>[
                    observer.options.queryHash,
                    observer
                ]));
            const newResult = newObservers.map((observer)=>observer.getCurrentResult());
            const hasIndexChange = newObservers.some((observer, index)=>observer !== prevObservers[index]);
            if (prevObservers.length === newObservers.length && !hasIndexChange) return;
            this.observers = newObservers;
            this.observersMap = newObserversMap;
            this.result = newResult;
            if (!this.hasListeners()) return;
            (0, $2m1Ye.difference)(prevObservers, newObservers).forEach((observer)=>{
                observer.destroy();
            });
            (0, $2m1Ye.difference)(newObservers, prevObservers).forEach((observer)=>{
                observer.subscribe((result)=>{
                    this.onUpdate(observer, result);
                });
            });
            this.notify();
        });
    }
    getCurrentResult() {
        return this.result;
    }
    getQueries() {
        return this.observers.map((observer)=>observer.getCurrentQuery());
    }
    getObservers() {
        return this.observers;
    }
    getOptimisticResult(queries) {
        return this.findMatchingObservers(queries).map((match)=>match.observer.getOptimisticResult(match.defaultedQueryOptions));
    }
    findMatchingObservers(queries) {
        const prevObservers = this.observers;
        const prevObserversMap = new Map(prevObservers.map((observer)=>[
                observer.options.queryHash,
                observer
            ]));
        const defaultedQueryOptions = queries.map((options)=>this.client.defaultQueryOptions(options));
        const matchingObservers = defaultedQueryOptions.flatMap((defaultedOptions)=>{
            const match = prevObserversMap.get(defaultedOptions.queryHash);
            if (match != null) return [
                {
                    defaultedQueryOptions: defaultedOptions,
                    observer: match
                }
            ];
            return [];
        });
        const matchedQueryHashes = new Set(matchingObservers.map((match)=>match.defaultedQueryOptions.queryHash));
        const unmatchedQueries = defaultedQueryOptions.filter((defaultedOptions)=>!matchedQueryHashes.has(defaultedOptions.queryHash));
        const matchingObserversSet = new Set(matchingObservers.map((match)=>match.observer));
        const unmatchedObservers = prevObservers.filter((prevObserver)=>!matchingObserversSet.has(prevObserver));
        const getObserver = (options)=>{
            const defaultedOptions = this.client.defaultQueryOptions(options);
            const currentObserver = this.observersMap[defaultedOptions.queryHash];
            return currentObserver != null ? currentObserver : new (0, $cnQDF.QueryObserver)(this.client, defaultedOptions);
        };
        const newOrReusedObservers = unmatchedQueries.map((options, index)=>{
            if (options.keepPreviousData) {
                // return previous data from one of the observers that no longer match
                const previouslyUsedObserver = unmatchedObservers[index];
                if (previouslyUsedObserver !== undefined) return {
                    defaultedQueryOptions: options,
                    observer: previouslyUsedObserver
                };
            }
            return {
                defaultedQueryOptions: options,
                observer: getObserver(options)
            };
        });
        const sortMatchesByOrderOfQueries = (a, b)=>defaultedQueryOptions.indexOf(a.defaultedQueryOptions) - defaultedQueryOptions.indexOf(b.defaultedQueryOptions);
        return matchingObservers.concat(newOrReusedObservers).sort(sortMatchesByOrderOfQueries);
    }
    onUpdate(observer, result) {
        const index = this.observers.indexOf(observer);
        if (index !== -1) {
            this.result = (0, $2m1Ye.replaceAt)(this.result, index, result);
            this.notify();
        }
    }
    notify() {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(this.result);
            });
        });
    }
}

});


parcelRegister("gGkal", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $af49e2d6e59c83b1$export$dd0a697e1782aedd);

var $2m1Ye = parcelRequire("2m1Ye");
var $cnQDF = parcelRequire("cnQDF");

var $hi2ri = parcelRequire("hi2ri");
'use client';
function $af49e2d6e59c83b1$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $2m1Ye.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $hi2ri.useBaseQuery)(parsedOptions, (0, $cnQDF.QueryObserver));
}

});



parcelRegister("3ePi6", function(module, exports) {

$parcel$export(module.exports, "QueryClient", () => $d63994b572b2ee10$export$405d0624ed55a03f);

var $2m1Ye = parcelRequire("2m1Ye");

var $5TEhM = parcelRequire("5TEhM");

var $detEY = parcelRequire("detEY");

var $bLCnn = parcelRequire("bLCnn");

var $6wgcO = parcelRequire("6wgcO");

var $3eYBn = parcelRequire("3eYBn");

var $5QdqP = parcelRequire("5QdqP");

var $eNzdB = parcelRequire("eNzdB");
// CLASS
class $d63994b572b2ee10$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $5TEhM.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, $detEY.MutationCache)();
        this.logger = config.logger || (0, $eNzdB.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $bLCnn.focusManager).subscribe(()=>{
            if ((0, $bLCnn.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6wgcO.onlineManager).subscribe(()=>{
            if ((0, $6wgcO.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $2m1Ye.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $2m1Ye.functionalUpdate)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $2m1Ye.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $3eYBn.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $3eYBn.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $3eYBn.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $3eYBn.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $2m1Ye.noop)).catch((0, $2m1Ye.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $3eYBn.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $3eYBn.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $2m1Ye.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $2m1Ye.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $2m1Ye.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $2m1Ye.noop)).catch((0, $2m1Ye.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $2m1Ye.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $5QdqP.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $2m1Ye.noop)).catch((0, $2m1Ye.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $2m1Ye.hashQueryKey)(queryKey) === (0, $2m1Ye.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $2m1Ye.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $2m1Ye.hashQueryKey)(mutationKey) === (0, $2m1Ye.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $2m1Ye.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $2m1Ye.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}

});
parcelRegister("5TEhM", function(module, exports) {

$parcel$export(module.exports, "QueryCache", () => $0fd43d0fa78ddd68$export$5dde0cd941da8468);

var $2m1Ye = parcelRequire("2m1Ye");

var $kKwmp = parcelRequire("kKwmp");

var $3eYBn = parcelRequire("3eYBn");

var $eklm2 = parcelRequire("eklm2");
// CLASS
class $0fd43d0fa78ddd68$export$5dde0cd941da8468 extends (0, $eklm2.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $2m1Ye.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $kKwmp.Query)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $2m1Ye.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $2m1Ye.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $2m1Ye.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}

});
parcelRegister("kKwmp", function(module, exports) {

$parcel$export(module.exports, "Query", () => $3a142b6aafd3691d$export$62297b13309008b2);

var $2m1Ye = parcelRequire("2m1Ye");

var $eNzdB = parcelRequire("eNzdB");

var $3eYBn = parcelRequire("3eYBn");

var $40nk7 = parcelRequire("40nk7");

var $e55Tq = parcelRequire("e55Tq");
// CLASS
class $3a142b6aafd3691d$export$62297b13309008b2 extends (0, $e55Tq.Removable) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $eNzdB.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $3a142b6aafd3691d$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $2m1Ye.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $2m1Ye.noop)).catch((0, $2m1Ye.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $2m1Ye.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        Array.isArray(this.options.queryKey);
        const abortController = (0, $2m1Ye.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject('Missing queryFn');
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $40nk7.isCancelledError)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $40nk7.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $40nk7.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $40nk7.canFetch)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $40nk7.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $3eYBn.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
}
function $3a142b6aafd3691d$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}

});


parcelRegister("detEY", function(module, exports) {

$parcel$export(module.exports, "MutationCache", () => $ed06f4d97adfb155$export$1fcfd9a244434844);

var $3eYBn = parcelRequire("3eYBn");

var $23c67 = parcelRequire("23c67");

var $2m1Ye = parcelRequire("2m1Ye");

var $eklm2 = parcelRequire("eklm2");
// CLASS
class $ed06f4d97adfb155$export$1fcfd9a244434844 extends (0, $eklm2.Subscribable) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $23c67.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $2m1Ye.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $2m1Ye.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $3eYBn.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $3eYBn.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $2m1Ye.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}

});


parcelRegister("deXeR", function(module, exports) {

$parcel$export(module.exports, "ReactQueryDevtools", () => $58b160831c4afa41$export$fd1469cb3147d866);

'use client';
const $58b160831c4afa41$export$fd1469cb3147d866 = function() {
    return null;
};
const $58b160831c4afa41$export$6d64409a8b475869 = function() {
    return null;
};

});


parcelRegister("OLlTf", function(module, exports) {

$parcel$export(module.exports, "InverterTypeSelect", () => $ca091f3496e3b4e6$export$bd106f852fbc25e0);
$parcel$export(module.exports, "inverterMapping", () => $ca091f3496e3b4e6$export$6025f944a187d60d);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $7pTac = parcelRequire("7pTac");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $9iEAl = parcelRequire("9iEAl");

var $5R532 = parcelRequire("5R532");

var $8BMis = parcelRequire("8BMis");

var $8ni7a = parcelRequire("8ni7a");
const $ca091f3496e3b4e6$var$defaultModbusAddress = '100.100.1.100';
const $ca091f3496e3b4e6$var$defaultModbusPort = 502;
const $ca091f3496e3b4e6$var$defaultLegacyModbusConfig = {
    MODBUS_TEST_ADDRESS: $ca091f3496e3b4e6$var$defaultModbusAddress,
    MODBUS_TEST_PORT: $ca091f3496e3b4e6$var$defaultModbusPort
};
var $ca091f3496e3b4e6$var$ConnectionType = /*#__PURE__*/ function(ConnectionType) {
    ConnectionType["ModbusTCP"] = "modbus-tcp";
    ConnectionType["RS485"] = "rs485";
    return ConnectionType;
}($ca091f3496e3b4e6$var$ConnectionType || {});
const $ca091f3496e3b4e6$export$bd106f852fbc25e0 = ()=>{
    const [wizardOpen, setWizardOpen] = (0, $acw62.useState)(false);
    const [board, boardRS485, boardRS485Host, boardRS485Port, legacyModbusAddress, inverterType, inverterConfig, legacyInverters, ems] = (0, $2lSXC.useSelector)((s)=>[
            s.variables.BOARD,
            s.variables.BOARD_RS485,
            s.variables.BOARD_RS485_HOST,
            s.variables.BOARD_RS485_PORT,
            s.variables.MODBUS_TEST_ADDRESS,
            s.variables.PV_INVERTER_TYPE,
            s.variables.INVERTER_CONFIG,
            s.variables.LEGACY_INVERTERS,
            s.variables.EMS
        ]);
    const selectValue = (0, $2lSXC.useSelector)((s)=>{
        const inverterType = s.variables.PV_INVERTER_TYPE;
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig);
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Victron) return (0, $8ni7a.Inverter).Victron;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SofarSolarRS485) return (0, $8ni7a.Inverter).SofarSolarRS485;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).DesBatteryContainer) return (0, $8ni7a.Inverter).DesBatteryContainer;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Hes) return (0, $8ni7a.Inverter).Hes;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).GoodWeNext) return (0, $8ni7a.Inverter).GoodWeNext;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).GoodWeGridNext) return (0, $8ni7a.Inverter).GoodWeGridNext;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolaxMICGrid) return (0, $8ni7a.Inverter).SolaxMICGrid;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolaxMEGAGrid) return (0, $8ni7a.Inverter).SolaxMEGAGrid;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolaxNext) return (0, $8ni7a.Inverter).SolaxNext;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolaxEMS1000) return (0, $8ni7a.Inverter).SolaxEMS1000;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolaxEMS1000PRO) return (0, $8ni7a.Inverter).SolaxEMS1000PRO;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Solinteg) return (0, $8ni7a.Inverter).Solinteg;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Deye) return (0, $8ni7a.Inverter).Deye;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).DeyeHV) return (0, $8ni7a.Inverter).DeyeHV;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Wattsonic) return (0, $8ni7a.Inverter).Wattsonic;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Fronius) return (0, $8ni7a.Inverter).Fronius;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).FroniusGrid) return (0, $8ni7a.Inverter).FroniusGrid;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SmaGrid) return (0, $8ni7a.Inverter).SmaGrid;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).FroniusVerto) return (0, $8ni7a.Inverter).FroniusVerto;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).SolarEdgeGrid) return (0, $8ni7a.Inverter).SolarEdgeGrid;
        if (inverterType === (0, $8ni7a.Inverter).Next && inverterConfigArray.length === 1 && inverterConfigArray[0].type === (0, $8ni7a.Inverter).Sermatec) return (0, $8ni7a.Inverter).Sermatec;
        return inverterType;
    });
    const dispatch = (0, $2lSXC.useDispatch)();
    const handleChange = (e)=>{
        const newInverterType = e.target.value;
        if (newInverterType === (0, $8ni7a.Inverter).Victron) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    victron: {
                        type: (0, $8ni7a.Inverter).Victron,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SofarSolarRS485) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    sofarSolar: {
                        type: (0, $8ni7a.Inverter).SofarSolarRS485
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).DesBatteryContainer) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    desBatteryContainer: {
                        type: (0, $8ni7a.Inverter).DesBatteryContainer,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Hes) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    hes: {
                        type: (0, $8ni7a.Inverter).Hes
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Solinteg) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solinteg: {
                        type: (0, $8ni7a.Inverter).Solinteg,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).GoodWeNext) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    goodWe: {
                        type: (0, $8ni7a.Inverter).GoodWeNext,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolaxNext) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solax: {
                        type: (0, $8ni7a.Inverter).SolaxNext,
                        address: '100.100.1.100',
                        port: 502,
                        master: true
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolaxEMS1000) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solaxEMS1000: {
                        type: (0, $8ni7a.Inverter).SolaxEMS1000,
                        address: '100.100.1.100',
                        port: 502,
                        inverters: [
                            {}
                        ],
                        batteryCount: 1
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolaxEMS1000PRO) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solaxEMS1000PRO: {
                        type: (0, $8ni7a.Inverter).SolaxEMS1000PRO,
                        address: '100.100.1.100',
                        port: 502,
                        inverters: [
                            {}
                        ],
                        batteryCount: 1
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Deye) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    deye: {
                        type: (0, $8ni7a.Inverter).Deye,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).DeyeHV) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    deyeHV: {
                        type: (0, $8ni7a.Inverter).DeyeHV,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).GoodWeGridNext) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    goodWeGrid: {
                        type: (0, $8ni7a.Inverter).GoodWeGridNext,
                        address: '100.100.1.100',
                        port: 502,
                        nominalPower: 10
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolaxMICGrid) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solaxMICGrid: {
                        type: (0, $8ni7a.Inverter).SolaxMICGrid,
                        address: '100.100.1.100',
                        port: 502,
                        nominalPower: 10,
                        maxPowerPercentage: 100
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolaxMEGAGrid) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solaxMEGAGrid: {
                        type: (0, $8ni7a.Inverter).SolaxMEGAGrid,
                        address: '100.100.1.100',
                        port: 502,
                        master: true
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Wattsonic) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    wattsonic: {
                        type: (0, $8ni7a.Inverter).Wattsonic,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Fronius) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    fronius: {
                        type: (0, $8ni7a.Inverter).Fronius,
                        address: '100.100.1.100',
                        port: 502,
                        master: true
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).FroniusGrid) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    froniusGrid: {
                        type: (0, $8ni7a.Inverter).FroniusGrid,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SmaGrid) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    smaGrid: {
                        type: (0, $8ni7a.Inverter).SmaGrid,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).FroniusVerto) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    froniusVerto: {
                        type: (0, $8ni7a.Inverter).FroniusVerto,
                        address: '100.100.1.100',
                        port: 502,
                        master: true
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).SolarEdgeGrid) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    solarEdgeGrid: {
                        type: (0, $8ni7a.Inverter).SolarEdgeGrid,
                        address: '100.100.1.100',
                        port: 1502,
                        nominalPower: 10
                    }
                }
            }));
            return;
        }
        if (newInverterType === (0, $8ni7a.Inverter).Sermatec) {
            dispatch((0, $1Jwr0.variablesChange)({
                PV_INVERTER_TYPE: (0, $8ni7a.Inverter).Next,
                INVERTER_CONFIG: {
                    sermatec: {
                        type: (0, $8ni7a.Inverter).Sermatec,
                        address: '100.100.1.100',
                        port: 502
                    }
                }
            }));
            return;
        }
        dispatch((0, $1Jwr0.variablesChange)({
            PV_INVERTER_TYPE: newInverterType,
            INVERTER_CONFIG: {},
            ...$ca091f3496e3b4e6$var$defaultLegacyModbusConfig
        }));
    };
    const connectionTypeVisible = ![
        (0, $8ni7a.Inverter).SofarSolarRS485,
        (0, $8ni7a.Inverter).Hes,
        (0, $8ni7a.Inverter).Next,
        (0, $8ni7a.Inverter).None,
        (0, $8ni7a.Inverter).SolaxGrid,
        (0, $8ni7a.Inverter).GoodWeGrid
    ].includes(selectValue);
    const rs485Supported = boardRS485 && [
        (0, $8ni7a.Inverter).Solax,
        (0, $8ni7a.Inverter).SolaxMICGrid,
        (0, $8ni7a.Inverter).SolaxMEGAGrid,
        (0, $8ni7a.Inverter).GoodWe,
        (0, $8ni7a.Inverter).GoodWeNext,
        (0, $8ni7a.Inverter).SolaxNext,
        (0, $8ni7a.Inverter).GoodWeGridNext,
        (0, $8ni7a.Inverter).Solinteg,
        (0, $8ni7a.Inverter).Deye,
        (0, $8ni7a.Inverter).DeyeHV,
        (0, $8ni7a.Inverter).Wattsonic,
        (0, $8ni7a.Inverter).Fronius,
        (0, $8ni7a.Inverter).FroniusGrid,
        (0, $8ni7a.Inverter).FroniusVerto,
        (0, $8ni7a.Inverter).Sermatec,
        (0, $8ni7a.Inverter).DesBatteryContainer
    ].includes(selectValue);
    const showLegacyInverters = legacyInverters || selectValue === (0, $8ni7a.Inverter).GoodWeGrid || selectValue === (0, $8ni7a.Inverter).SolaxGrid || selectValue === (0, $8ni7a.Inverter).Sofarsolar;
    [
        (0, $8ni7a.Inverter).Solax,
        (0, $8ni7a.Inverter).SolaxMICGrid,
        (0, $8ni7a.Inverter).SolaxMEGAGrid,
        (0, $8ni7a.Inverter).GoodWe,
        (0, $8ni7a.Inverter).GoodWeNext,
        (0, $8ni7a.Inverter).SolaxNext,
        (0, $8ni7a.Inverter).GoodWeGridNext,
        (0, $8ni7a.Inverter).Solinteg,
        (0, $8ni7a.Inverter).Deye,
        (0, $8ni7a.Inverter).Wattsonic,
        (0, $8ni7a.Inverter).Hes,
        (0, $8ni7a.Inverter).Fronius,
        (0, $8ni7a.Inverter).FroniusGrid,
        (0, $8ni7a.Inverter).FroniusVerto,
        (0, $8ni7a.Inverter).SolarEdgeGrid,
        (0, $8ni7a.Inverter).Sermatec
    ].includes(selectValue);
    [
        (0, $8ni7a.Inverter).Solax,
        (0, $8ni7a.Inverter).SolaxMICGrid,
        (0, $8ni7a.Inverter).SolaxMEGAGrid,
        (0, $8ni7a.Inverter).GoodWe,
        (0, $8ni7a.Inverter).GoodWeNext,
        (0, $8ni7a.Inverter).SolaxNext,
        (0, $8ni7a.Inverter).GoodWeGridNext,
        (0, $8ni7a.Inverter).Solinteg,
        (0, $8ni7a.Inverter).Deye,
        (0, $8ni7a.Inverter).Wattsonic,
        (0, $8ni7a.Inverter).Hes,
        (0, $8ni7a.Inverter).Fronius,
        (0, $8ni7a.Inverter).FroniusGrid,
        (0, $8ni7a.Inverter).FroniusVerto,
        (0, $8ni7a.Inverter).SolarEdgeGrid,
        (0, $8ni7a.Inverter).Sermatec
    ].includes(selectValue);
    const inverterTypeSelect = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "inverter-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.inverter_type.label",
                    defaultMessage: "St\u0159\xedda\u010D"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: selectValue,
                onChange: handleChange,
                labelId: "inverter-type-label",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.inverter_type.label",
                    defaultMessage: "St\u0159\xedda\u010D"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWe,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.good_we",
                            defaultMessage: "GoodWe"
                        })
                    }, (0, $8ni7a.Inverter).GoodWe),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWeNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.good_we_next",
                            defaultMessage: "GoodWeNext"
                        })
                    }, (0, $8ni7a.Inverter).GoodWeNext),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_next",
                            defaultMessage: "SolaxNext"
                        })
                    }, (0, $8ni7a.Inverter).SolaxNext),
                    ems && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: (0, $8ni7a.Inverter).SolaxEMS1000,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "inverter.solax_ems1000",
                                    defaultMessage: "Solax EMS1000"
                                })
                            }, (0, $8ni7a.Inverter).SolaxEMS1000),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: (0, $8ni7a.Inverter).SolaxEMS1000PRO,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "inverter.solax_ems1000pro",
                                    defaultMessage: "Solax EMS1000PRO"
                                })
                            }, (0, $8ni7a.Inverter).SolaxEMS1000PRO)
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWeGridNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.good_we_grid_next",
                            defaultMessage: "GoodWe s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).GoodWeGridNext),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Solax,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax",
                            defaultMessage: "Solax"
                        })
                    }, (0, $8ni7a.Inverter).Solax),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxMEGAGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_mega_grid",
                            defaultMessage: "Solax MEGA/FORTH s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolaxMEGAGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxMICGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_mic_grid",
                            defaultMessage: "Solax MIC s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolaxMICGrid),
                    showLegacyInverters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Sofarsolar,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sofar_solar",
                            defaultMessage: "Sofarsolar"
                        })
                    }, (0, $8ni7a.Inverter).Sofarsolar),
                    showLegacyInverters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_grid",
                            defaultMessage: "Solax s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolaxGrid),
                    showLegacyInverters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWeGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.goodwe_grid",
                            defaultMessage: "Goodwe s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).GoodWeGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Victron,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.victron",
                            defaultMessage: "Victron"
                        })
                    }, (0, $8ni7a.Inverter).Victron),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Solinteg,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solinteg",
                            defaultMessage: "Solinteg"
                        })
                    }, (0, $8ni7a.Inverter).Solinteg),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Deye,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.deye",
                            defaultMessage: "Deye LV"
                        })
                    }, (0, $8ni7a.Inverter).Deye),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).DeyeHV,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.deye_hv",
                            defaultMessage: "Deye HV"
                        })
                    }, (0, $8ni7a.Inverter).DeyeHV),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Wattsonic,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.wattsonic",
                            defaultMessage: "Wattsonic"
                        })
                    }, (0, $8ni7a.Inverter).Wattsonic),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Fronius,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius",
                            defaultMessage: "Fronius SYMO GEN24"
                        })
                    }, (0, $8ni7a.Inverter).Fronius),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).FroniusGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius_grid",
                            defaultMessage: "Fronius SYMO s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).FroniusGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SmaGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sma_grid",
                            defaultMessage: "SMA s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SmaGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).FroniusVerto,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius_verto",
                            defaultMessage: "Fronius Verto"
                        })
                    }, (0, $8ni7a.Inverter).FroniusVerto),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolarEdgeGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solar_edge_grid",
                            defaultMessage: "SolarEdge s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolarEdgeGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Sermatec,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sermatec",
                            defaultMessage: "Sermatec"
                        })
                    }, (0, $8ni7a.Inverter).Sermatec),
                    boardRS485 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SofarSolarRS485,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sofar_solar_rs485",
                            defaultMessage: "SofarSolar RS485"
                        })
                    }, (0, $8ni7a.Inverter).SofarSolarRS485),
                    boardRS485 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).DesBatteryContainer,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.des_battery_container",
                            defaultMessage: "DES - kontejnerov\xe9 \xfalo\u017Ei\u0161t\u011B"
                        })
                    }, (0, $8ni7a.Inverter).DesBatteryContainer),
                    boardRS485 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Hes,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.hes",
                            defaultMessage: "HES"
                        })
                    }, (0, $8ni7a.Inverter).Hes),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Next,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.next",
                            defaultMessage: "V\xedce st\u0159\xedda\u010D\u016F"
                        })
                    }, (0, $8ni7a.Inverter).Next),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).None,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.none",
                            defaultMessage: "\u017D\xe1dn\xfd"
                        })
                    }, (0, $8ni7a.Inverter).None)
                ]
            })
        ]
    });
    const connectionTypeValue = (0, $2lSXC.useSelector)(({ variables: { PV_INVERTER_TYPE: PV_INVERTER_TYPE, MODBUS_TEST_ADDRESS: MODBUS_TEST_ADDRESS, MODBUS_TEST_PORT: MODBUS_TEST_PORT, INVERTER_CONFIG: INVERTER_CONFIG, BOARD_RS485_HOST: BOARD_RS485_HOST, BOARD_RS485_PORT: BOARD_RS485_PORT } })=>{
        if (PV_INVERTER_TYPE === (0, $8ni7a.Inverter).Next) {
            const inverterConfigArray = Object.values(INVERTER_CONFIG);
            if (!inverterConfigArray.length) return "modbus-tcp";
            const inverter = inverterConfigArray[0];
            if (inverter.type === (0, $8ni7a.Inverter).SofarSolarRS485 || inverter.type === (0, $8ni7a.Inverter).Hes) return "rs485";
            if (inverter.type === (0, $8ni7a.Inverter).Shellies) return "modbus-tcp";
            // eslint-disable-next-line
            // @ts-ignore
            return inverterConfigArray[0].address === BOARD_RS485_HOST && // eslint-disable-next-line
            // @ts-ignore
            inverterConfigArray[0].port === BOARD_RS485_PORT ? "rs485" : "modbus-tcp";
        } else return MODBUS_TEST_ADDRESS === BOARD_RS485_HOST && MODBUS_TEST_PORT === BOARD_RS485_PORT ? "rs485" : "modbus-tcp";
    });
    const handleConnectionTypeChange = (e)=>{
        const value = e.target.value;
        if (value === "rs485" && inverterType !== (0, $8ni7a.Inverter).Next) dispatch((0, $1Jwr0.variablesChange)({
            MODBUS_TEST_ADDRESS: boardRS485Host,
            MODBUS_TEST_PORT: boardRS485Port
        }));
        else if (value === "modbus-tcp" && inverterType !== (0, $8ni7a.Inverter).Next) dispatch((0, $1Jwr0.variablesChange)($ca091f3496e3b4e6$var$defaultLegacyModbusConfig));
        else if (value === "rs485" && inverterType === (0, $8ni7a.Inverter).Next) {
            const firstInverterKey = (0, $f1q41.first)(Object.keys(inverterConfig));
            dispatch((0, $1Jwr0.variablesChange)({
                [`INVERTER_CONFIG.${firstInverterKey}.address`]: boardRS485Host,
                [`INVERTER_CONFIG.${firstInverterKey}.port`]: boardRS485Port
            }));
        } else if (value === "modbus-tcp" && inverterType === (0, $8ni7a.Inverter).Next) {
            const firstInverterKey = (0, $f1q41.first)(Object.keys(inverterConfig));
            dispatch((0, $1Jwr0.variablesChange)({
                [`INVERTER_CONFIG.${firstInverterKey}.address`]: $ca091f3496e3b4e6$var$defaultModbusAddress,
                [`INVERTER_CONFIG.${firstInverterKey}.port`]: $ca091f3496e3b4e6$var$defaultModbusPort
            }));
        }
    };
    const connectionTypeSelect = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        sx: {
            width: 130
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "connection-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.connection_type",
                    defaultMessage: "P\u0159ipojen\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: connectionTypeValue,
                onChange: handleConnectionTypeChange,
                labelId: "connection-type-label",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.connection_type",
                    defaultMessage: "P\u0159ipojen\xed"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: "modbus-tcp",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.modbus_tcp",
                            defaultMessage: "LAN/WiFi"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: "rs485",
                        disabled: !rs485Supported,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.rs485",
                            defaultMessage: "RS485"
                        })
                    })
                ]
            })
        ]
    });
    const legacyModbusAddressLabel = connectionTypeVisible ? connectionTypeValue === "modbus-tcp" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
        variant: "subtitle2",
        sx: {
            mt: 0.5,
            textAlign: 'right'
        },
        children: legacyModbusAddress
    }) : null;
    const wizardInverterInfo = $ca091f3496e3b4e6$var$useWizardInverterInfo();
    const wizardBox = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 0.75,
        children: [
            inverterType !== (0, $8ni7a.Inverter).None && wizardInverterInfo,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                variant: inverterType === (0, $8ni7a.Inverter).None ? 'contained' : 'outlined',
                size: "small",
                onClick: ()=>setWizardOpen(true),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "inverter_wizard.open",
                    defaultMessage: "Naj\xedt st\u0159\xedda\u010D"
                })
            })
        ]
    });
    const wizard = board === (0, $8ni7a.Board).Play || board === (0, $8ni7a.Board).V2 ? wizardBox : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.docs.service_settings_inverter.title",
                    defaultMessage: "N\xe1vod na p\u0159ipojen\xed st\u0159\xedda\u010De"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.docs.service_settings_inverter.subtitle",
                    defaultMessage: "Dokumentace, postupy a dal\u0161\xed informace"
                }),
                fullWidth: true,
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        pl: 0.25
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        href: "https://infigy.cz/app-redirect/service-settings-inverter",
                        target: "_blank",
                        sx: {
                            textWrap: 'nowrap'
                        },
                        size: "small",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.docs.service_settings_inverter.button",
                            defaultMessage: "P\u0159ej\xedt na wiki"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                control: wizard || /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    sx: {
                        my: -0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                            gap: 0.5,
                            children: [
                                inverterTypeSelect,
                                connectionTypeVisible && connectionTypeSelect
                            ]
                        }),
                        legacyModbusAddressLabel
                    ]
                }),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.inverter_type",
                    defaultMessage: "Typ st\u0159\xedda\u010De"
                }),
                visibility: {
                    variableId: 'PV_INSTALL'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8BMis.InverterWizard), {
                open: wizardOpen,
                onClose: ()=>setWizardOpen(false)
            })
        ]
    });
};
const $ca091f3496e3b4e6$var$useWizardInverterInfo = ()=>{
    const [inverterType, legacyModbusAddress, inverterConfig] = (0, $2lSXC.useSelector)((s)=>[
            s.variables.PV_INVERTER_TYPE,
            s.variables.MODBUS_TEST_ADDRESS,
            s.variables.INVERTER_CONFIG
        ]);
    if (inverterType !== (0, $8ni7a.Inverter).Next) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            $ca091f3496e3b4e6$export$6025f944a187d60d[inverterType],
            ", ",
            legacyModbusAddress
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            '& span:not(:last-child):after': {
                content: '", "'
            }
        },
        children: Object.values(inverterConfig).map(({ type: type }, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: $ca091f3496e3b4e6$export$6025f944a187d60d[type]
            }, index);
        })
    });
};
const $ca091f3496e3b4e6$export$6025f944a187d60d = {
    [(0, $8ni7a.Inverter).GoodWe]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.good_we",
        defaultMessage: "GoodWe"
    }),
    [(0, $8ni7a.Inverter).GoodWeNext]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.good_we_next",
        defaultMessage: "GoodWe"
    }),
    [(0, $8ni7a.Inverter).Solax]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax",
        defaultMessage: "Solax"
    }),
    [(0, $8ni7a.Inverter).SolaxNext]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax",
        defaultMessage: "Solax"
    }),
    [(0, $8ni7a.Inverter).SolaxEMS1000]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax_ems1000",
        defaultMessage: "Solax EMS1000"
    }),
    [(0, $8ni7a.Inverter).SolaxEMS1000PRO]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax_ems1000pro",
        defaultMessage: "Solax EMS1000PRO"
    }),
    [(0, $8ni7a.Inverter).Sofarsolar]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.sofar_solar",
        defaultMessage: "Sofarsolar"
    }),
    [(0, $8ni7a.Inverter).SolaxGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax_grid",
        defaultMessage: "Solax s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).SolaxMICGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax_mic_grid",
        defaultMessage: "Solax MIC s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).SolaxMEGAGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solax_mega_grid",
        defaultMessage: "Solax MEGA/FORTH s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).GoodWeGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.goodwe_grid",
        defaultMessage: "Goodwe s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).GoodWeGridNext]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.good_we_grid_next",
        defaultMessage: "GoodWeNext s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).Victron]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.victron",
        defaultMessage: "Victron"
    }),
    [(0, $8ni7a.Inverter).Solinteg]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solinteg",
        defaultMessage: "Solinteg"
    }),
    [(0, $8ni7a.Inverter).Wattsonic]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.wattsonic",
        defaultMessage: "Wattsonic"
    }),
    [(0, $8ni7a.Inverter).SofarSolarRS485]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.sofar_solar_rs485",
        defaultMessage: "SofarSolar RS485"
    }),
    [(0, $8ni7a.Inverter).DesBatteryContainer]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.des_battery_container",
        defaultMessage: "DES - kontejnerov\xe9 \xfalo\u017Ei\u0161t\u011B"
    }),
    [(0, $8ni7a.Inverter).Hes]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.hes",
        defaultMessage: "HES"
    }),
    [(0, $8ni7a.Inverter).Next]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.next",
        defaultMessage: "V\xedce st\u0159\xedda\u010D\u016F"
    }),
    [(0, $8ni7a.Inverter).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.none",
        defaultMessage: "\u017D\xe1dn\xfd"
    }),
    [(0, $8ni7a.Inverter).Shellies]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.shellies",
        defaultMessage: "Shellies"
    }),
    [(0, $8ni7a.Inverter).ShelliesExternal]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.shellies_external",
        defaultMessage: "Shellies External"
    }),
    [(0, $8ni7a.Inverter).ThreeMarPLC]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.3mar_plc",
        defaultMessage: "3Mar PLC"
    }),
    [(0, $8ni7a.Inverter).Sermatec]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.sermatec",
        defaultMessage: "Sermatec"
    }),
    [(0, $8ni7a.Inverter).FroniusGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.fronius_grid",
        defaultMessage: "Fronius SYMO s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).SmaGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.sma_grid",
        defaultMessage: "SMA s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).Fronius]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.fronius",
        defaultMessage: "Fronius SYMO GEN24"
    }),
    [(0, $8ni7a.Inverter).FroniusVerto]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.fronius_verto",
        defaultMessage: "Fronius Verto"
    }),
    [(0, $8ni7a.Inverter).Deye]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.deye",
        defaultMessage: "Deye LV"
    }),
    [(0, $8ni7a.Inverter).DeyeHV]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.deye_hv",
        defaultMessage: "Deye HV"
    }),
    [(0, $8ni7a.Inverter).SolarEdgeGrid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.solar_edge_grid",
        defaultMessage: "SolarEdge s\xed\u0165ov\xfd"
    }),
    [(0, $8ni7a.Inverter).AzRouter]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "inverter.az_router",
        defaultMessage: "AzRouter elektrom\u011Br"
    })
};

});
parcelRegister("5WsCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $45389177b9c2b08c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $hAwwT = parcelRequire("hAwwT");

var $2TZUE = parcelRequire("2TZUE");

var $9mcVc = parcelRequire("9mcVc");

var $Uq4Et = parcelRequire("Uq4Et");

var $1m26d = parcelRequire("1m26d");

var $bwxl4 = parcelRequire("bwxl4");

var $cmqCd = parcelRequire("cmqCd");

var $77qZh = parcelRequire("77qZh");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $45389177b9c2b08c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $45389177b9c2b08c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $77qZh.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $45389177b9c2b08c$var$MenuItemRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $45389177b9c2b08c$export$4334bb34c76fef24
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $77qZh.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $77qZh.default).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $77qZh.default).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $77qZh.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $77qZh.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $1m26d.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $1m26d.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $cmqCd.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $cmqCd.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $bwxl4.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $bwxl4.default).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $45389177b9c2b08c$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $acw62.useContext((0, $hAwwT.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $9mcVc.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $45389177b9c2b08c$var$useUtilityClasses(props);
    const handleRef = (0, $Uq4Et.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAwwT.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($45389177b9c2b08c$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $9QePP.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $45389177b9c2b08c$export$2e2bcd8739ae039 = $45389177b9c2b08c$var$MenuItem;

});
parcelRegister("bwxl4", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $863c8b42c24a5d20$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $863c8b42c24a5d20$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $863c8b42c24a5d20$export$81478e24460c57f2(slot) {
    return (0, $4Cod0.default)('MuiListItemIcon', slot);
}
const $863c8b42c24a5d20$var$listItemIconClasses = (0, $beCSm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $863c8b42c24a5d20$export$2e2bcd8739ae039 = $863c8b42c24a5d20$var$listItemIconClasses;

});

parcelRegister("cmqCd", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $8ffc2f5b8ea69aff$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $8ffc2f5b8ea69aff$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $8ffc2f5b8ea69aff$export$1061006a0db3aeb5(slot) {
    return (0, $4Cod0.default)('MuiListItemText', slot);
}
const $8ffc2f5b8ea69aff$var$listItemTextClasses = (0, $beCSm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $8ffc2f5b8ea69aff$export$2e2bcd8739ae039 = $8ffc2f5b8ea69aff$var$listItemTextClasses;

});

parcelRegister("77qZh", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $52ee1ef7b0f3c27a$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $52ee1ef7b0f3c27a$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $52ee1ef7b0f3c27a$export$515f8c67b5305377(slot) {
    return (0, $4Cod0.default)('MuiMenuItem', slot);
}
const $52ee1ef7b0f3c27a$var$menuItemClasses = (0, $beCSm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $52ee1ef7b0f3c27a$export$2e2bcd8739ae039 = $52ee1ef7b0f3c27a$var$menuItemClasses;

});


parcelRegister("cdz9f", function(module, exports) {

$parcel$export(module.exports, "connectedSet", () => (parcelRequire("cMZil")).connectedSet);
$parcel$export(module.exports, "variablesSet", () => (parcelRequire("1Jwr0")).variablesSet);
$parcel$export(module.exports, "variablesSnapshot", () => (parcelRequire("1Jwr0")).variablesSnapshot);
$parcel$export(module.exports, "variablesChange", () => (parcelRequire("1Jwr0")).variablesChange);

var $cMZil = parcelRequire("cMZil");

var $1Jwr0 = parcelRequire("1Jwr0");

});
parcelRegister("cMZil", function(module, exports) {

$parcel$export(module.exports, "connectedSlice", () => $3a375bdbfc1d5d50$export$c4e885c26228c027);
$parcel$export(module.exports, "connectedSet", () => $3a375bdbfc1d5d50$export$a476fec0dd63d11e);

var $a1McR = parcelRequire("a1McR");
const $3a375bdbfc1d5d50$export$c4e885c26228c027 = (0, $a1McR.createSlice)({
    name: 'connected',
    initialState: false,
    reducers: {
        connectedSet: (_, { payload: connected })=>connected
    }
});
const { connectedSet: $3a375bdbfc1d5d50$export$a476fec0dd63d11e } = $3a375bdbfc1d5d50$export$c4e885c26228c027.actions;

});
parcelRegister("a1McR", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $74cf642ba7fa99c2$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "createAsyncThunk", () => $74cf642ba7fa99c2$export$6abd22dc03e5063f);

var $7pMmM = parcelRequire("7pMmM");

var $eShmq = parcelRequire("eShmq");

var $d4Xgy = parcelRequire("d4Xgy");

var $eNuyV = parcelRequire("eNuyV");
var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $d4Xgy.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $7pMmM.isDraft)(value) ? (0, $7pMmM.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $eShmq.compose;
    return (0, $eShmq.compose).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $7pMmM.isDraftable)(val) ? (0, $7pMmM.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = true;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $eNuyV.default));
        else middlewareArray.push((0, $eNuyV.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = true;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $eShmq.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $eShmq.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $eShmq.compose);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var storeEnhancers = [
        middlewareEnhancer
    ];
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(storeEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $eShmq.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$var$isFSA(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $7pMmM.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $7pMmM.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $7pMmM.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$var$isFSA(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $7pMmM.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $7pMmM.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $7pMmM.enableES5)();

});
parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $jklp3 = parcelRequire("jklp3");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($ad4393542232627c$var$isDate(val)) return 'date';
    if ($ad4393542232627c$var$isError(val)) return 'error';
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(1));
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error($ad4393542232627c$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($ad4393542232627c$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($ad4393542232627c$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $ad4393542232627c$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($ad4393542232627c$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($ad4393542232627c$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($ad4393542232627c$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $jklp3.default)((0, $jklp3.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("jklp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1207cc9d7a6d905$export$2e2bcd8739ae039);

var $d1jo0 = parcelRequire("d1jo0");
function $e1207cc9d7a6d905$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e1207cc9d7a6d905$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e1207cc9d7a6d905$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $d1jo0.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e1207cc9d7a6d905$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

});
parcelRegister("d1jo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $97aa68119c366027$export$2e2bcd8739ae039);

var $dT3xD = parcelRequire("dT3xD");
function $97aa68119c366027$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $dT3xD.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("dT3xD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c328b502fbd558$export$2e2bcd8739ae039);

var $5CNLf = parcelRequire("5CNLf");

var $i1Vs1 = parcelRequire("i1Vs1");
function $a1c328b502fbd558$export$2e2bcd8739ae039(arg) {
    var key = (0, $i1Vs1.default)(arg, "string");
    return (0, $5CNLf.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("5CNLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $418719de264d51d0$export$2e2bcd8739ae039);
function $418719de264d51d0$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $418719de264d51d0$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $418719de264d51d0$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("i1Vs1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d204e28e0a824f6e$export$2e2bcd8739ae039);

var $5CNLf = parcelRequire("5CNLf");
function $d204e28e0a824f6e$export$2e2bcd8739ae039(input, hint) {
    if ((0, $5CNLf.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $5CNLf.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});





parcelRegister("d4Xgy", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $02750ef3da3a77b9$export$595d22ed68ca2841);

var $bAIdI = parcelRequire("bAIdI");
function $02750ef3da3a77b9$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $02750ef3da3a77b9$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $02750ef3da3a77b9$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $02750ef3da3a77b9$export$595d22ed68ca2841 = /* #__PURE__ */ $02750ef3da3a77b9$export$5943f4447f6ef248((0, $bAIdI.defaultMemoize));
var $02750ef3da3a77b9$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $02750ef3da3a77b9$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("bAIdI", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $87055bbb4a8296e9$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $87055bbb4a8296e9$var$NOT_FOUND = 'NOT_FOUND';
function $87055bbb4a8296e9$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $87055bbb4a8296e9$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $87055bbb4a8296e9$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $87055bbb4a8296e9$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $87055bbb4a8296e9$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $87055bbb4a8296e9$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $87055bbb4a8296e9$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $87055bbb4a8296e9$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $87055bbb4a8296e9$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $87055bbb4a8296e9$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $87055bbb4a8296e9$var$createSingletonCache(comparator) : $87055bbb4a8296e9$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $87055bbb4a8296e9$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("eNuyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5d5956ce0b399b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;

});



parcelRegister("1Jwr0", function(module, exports) {

$parcel$export(module.exports, "variablesChange", () => $ffe3cbd599386cb1$export$69fee1db42aff7f6);
$parcel$export(module.exports, "variablesSlice", () => $ffe3cbd599386cb1$export$b684f50c722ed9c0);
$parcel$export(module.exports, "variablesSnapshot", () => $ffe3cbd599386cb1$export$6298420bdecc0a53);
$parcel$export(module.exports, "variablesSet", () => $ffe3cbd599386cb1$export$47703bf8238d94c3);

var $a1McR = parcelRequire("a1McR");

var $f1q41 = parcelRequire("f1q41");

var $24LEk = parcelRequire("24LEk");

var $3OncY = parcelRequire("3OncY");

var $1FyMI = parcelRequire("1FyMI");
const $ffe3cbd599386cb1$export$69fee1db42aff7f6 = (0, $a1McR.createAsyncThunk)('variables/change', async (payload)=>{
    (0, $24LEk.socket).emit('store:set', {
        payload: payload
    });
});
const $ffe3cbd599386cb1$var$initialState = (0, $3OncY.IS_DEMO) ? {
    ...(0, $1FyMI.demoInitialStore),
    PREMIUM: !(0, $3OncY.IS_SOLIDSUN)
} : {};
const $ffe3cbd599386cb1$export$b684f50c722ed9c0 = (0, $a1McR.createSlice)({
    name: 'variables',
    initialState: $ffe3cbd599386cb1$var$initialState,
    reducers: {
        variablesSnapshot: (_, { payload: payload })=>payload,
        variablesSet: (state, { payload: payload })=>Object.entries(payload).forEach(([path, value])=>(0, $f1q41.set)(state, path, value))
    },
    extraReducers (builder) {
        builder.addCase($ffe3cbd599386cb1$export$69fee1db42aff7f6.pending, (state, { meta: { arg: arg } })=>{
            const newState = (0, $f1q41.cloneDeep)(state);
            Object.entries(arg).forEach(([path, value])=>(0, $f1q41.set)(newState, path, value));
            return newState;
        });
    }
});
const { variablesSnapshot: $ffe3cbd599386cb1$export$6298420bdecc0a53, variablesSet: $ffe3cbd599386cb1$export$47703bf8238d94c3 } = $ffe3cbd599386cb1$export$b684f50c722ed9c0.actions;

});
parcelRegister("24LEk", function(module, exports) {

$parcel$export(module.exports, "socket", () => $4a9968327b966ba6$export$4f55ed1789bc2dcb);

var $7etJZ = parcelRequire("7etJZ");

var $73MNt = parcelRequire("73MNt");

var $3OncY = parcelRequire("3OncY");
const $4a9968327b966ba6$export$4f55ed1789bc2dcb = !(0, $3OncY.IS_DEMO) ? (0, $73MNt.default)({
    path: '/core/socket.io'
}).connect() : new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ)))();

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("73MNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $523eaa49d3f99bf8$export$841407ceb083bd74);

var $kATNo = parcelRequire("kATNo");

var $fL4YY = parcelRequire("fL4YY");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");
/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $kATNo.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $fL4YY.Manager)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $fL4YY.Manager)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $fL4YY.Manager,
    Socket: $lGX0c.Socket,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});

});
parcelRegister("kATNo", function(module, exports) {

$parcel$export(module.exports, "url", () => $efe27346e00da8a8$export$128fa18b7194ef);
parcelRequire("1XKMK");
var $l7wSz = parcelRequire("l7wSz");
function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $l7wSz.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

});
parcelRegister("1XKMK", function(module, exports) {

$parcel$export(module.exports, "Socket", () => (parcelRequire("al9N3")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("5vwdc")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("l7wSz")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("cFgwF")).nextTick);

var $al9N3 = parcelRequire("al9N3");

var $6opKi = parcelRequire("6opKi");

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $l7wSz = parcelRequire("l7wSz");

var $cFgwF = parcelRequire("cFgwF");
const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $al9N3.Socket).protocol;

});
parcelRegister("al9N3", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $787375aed2c43820$export$4798917dbf149b79);

var $gEtm1 = parcelRequire("gEtm1");

var $5vwdc = parcelRequire("5vwdc");

var $2buxl = parcelRequire("2buxl");

var $l7wSz = parcelRequire("l7wSz");

var $687to = parcelRequire("687to");

var $CnWUo = parcelRequire("CnWUo");
class $787375aed2c43820$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $l7wSz.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $l7wSz.parse)(opts.host).host;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: true
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $2buxl.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $CnWUo.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts.transportOptions[name], this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        });
        return new (0, $gEtm1.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.resetPingTimeout();
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $5vwdc.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $787375aed2c43820$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$787375aed2c43820$export$4798917dbf149b79.protocol = (0, $CnWUo.protocol);

});
parcelRegister("gEtm1", function(module, exports) {

$parcel$export(module.exports, "transports", () => $c1f726e793763466$export$46dec00755c1153b);

var $7pvuz = parcelRequire("7pvuz");

var $dhyBt = parcelRequire("dhyBt");
const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $dhyBt.WS),
    polling: (0, $7pvuz.Polling)
};

});
parcelRegister("7pvuz", function(module, exports) {

$parcel$export(module.exports, "Polling", () => $56534be56e5aa809$export$265ee5eefd4c309b);

var $6opKi = parcelRequire("6opKi");

var $e3yjg = parcelRequire("e3yjg");

var $2buxl = parcelRequire("2buxl");

var $CnWUo = parcelRequire("CnWUo");

var $lB1J3 = parcelRequire("lB1J3");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");

var $3kfWP = parcelRequire("3kfWP");
function $56534be56e5aa809$var$empty() {}
const $56534be56e5aa809$var$hasXHR2 = function() {
    const xhr = new (0, $lB1J3.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $6opKi.Transport) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
            this.xs = opts.secure !== isSSL;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $56534be56e5aa809$var$hasXHR2 && !forceBase64;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $CnWUo.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $CnWUo.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "https" : "http";
        let port = "";
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        // avoid port if default for schema
        if (this.opts.port && ("https" === schema && Number(this.opts.port) !== 443 || "http" === schema && Number(this.opts.port) !== 80)) port = ":" + this.opts.port;
        const encodedQuery = (0, $2buxl.encode)(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            xs: this.xs
        }, this.opts);
        return new $56534be56e5aa809$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $56534be56e5aa809$export$7fa6c5b6f8193917 extends (0, $687to.Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.async = false !== opts.async;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        const opts = (0, $5vwdc.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        opts.xscheme = !!this.opts.xs;
        const xhr = this.xhr = new (0, $lB1J3.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, this.async);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount++;
            $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $56534be56e5aa809$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $56534be56e5aa809$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
}
$56534be56e5aa809$export$7fa6c5b6f8193917.requestsCount = 0;
$56534be56e5aa809$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $56534be56e5aa809$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $3kfWP.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $56534be56e5aa809$var$unloadHandler, false);
    }
}
function $56534be56e5aa809$var$unloadHandler() {
    for(let i in $56534be56e5aa809$export$7fa6c5b6f8193917.requests)if ($56534be56e5aa809$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $56534be56e5aa809$export$7fa6c5b6f8193917.requests[i].abort();
}

});
parcelRegister("6opKi", function(module, exports) {

$parcel$export(module.exports, "Transport", () => $4a78f487f5bb98d8$export$86495b081fef8e52);
parcelRequire("CnWUo");
var $ezyGD = parcelRequire("ezyGD");

var $687to = parcelRequire("687to");

var $5vwdc = parcelRequire("5vwdc");
class $4a78f487f5bb98d8$var$TransportError extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $687to.Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$var$TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $ezyGD.default)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
}

});
parcelRegister("CnWUo", function(module, exports) {

$parcel$export(module.exports, "encodePayload", () => $0736208648dc8bae$export$144d64fe58dad441);
$parcel$export(module.exports, "decodePayload", () => $0736208648dc8bae$export$d10cc2e7f7566a2d);
$parcel$export(module.exports, "protocol", () => $0736208648dc8bae$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("bRHuL")).default);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("ezyGD")).default);

var $bRHuL = parcelRequire("bRHuL");

var $ezyGD = parcelRequire("ezyGD");
const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $bRHuL.default)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $ezyGD.default)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;

});
parcelRegister("bRHuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3662315a48cdbd$export$2e2bcd8739ae039);

var $fsDlh = parcelRequire("fsDlh");
const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$var$encodePacket = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $fsDlh.PACKET_TYPES)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
var $8a3662315a48cdbd$export$2e2bcd8739ae039 = $8a3662315a48cdbd$var$encodePacket;

});
parcelRegister("fsDlh", function(module, exports) {

$parcel$export(module.exports, "PACKET_TYPES", () => $b417fd17fc84e4e3$export$c169aefb7330cccb);
$parcel$export(module.exports, "PACKET_TYPES_REVERSE", () => $b417fd17fc84e4e3$export$47791e8004edd485);
$parcel$export(module.exports, "ERROR_PACKET", () => $b417fd17fc84e4e3$export$c718b5840781f8a7);
const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};

});


parcelRegister("ezyGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9bf3da28855a34f$export$2e2bcd8739ae039);

var $fsDlh = parcelRequire("fsDlh");

var $aVEkU = parcelRequire("aVEkU");
const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$var$decodePacket = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $fsDlh.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $fsDlh.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $fsDlh.PACKET_TYPES_REVERSE)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $aVEkU.decode)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            return data instanceof ArrayBuffer ? new Blob([
                data
            ]) : data;
        case "arraybuffer":
        default:
            return data; // assuming the data is already an ArrayBuffer
    }
};
var $a9bf3da28855a34f$export$2e2bcd8739ae039 = $a9bf3da28855a34f$var$decodePacket;

});
parcelRegister("aVEkU", function(module, exports) {

$parcel$export(module.exports, "decode", () => $7f4e842ae29bcbc5$export$2f872c0f2117be69);
// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};

});



parcelRegister("687to", function(module, exports) {

$parcel$export(module.exports, "Emitter", () => $8ff0082eecb39b62$export$4293555f241ae35a);
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $8ff0082eecb39b62$export$4293555f241ae35a(obj) {
    if (obj) return $8ff0082eecb39b62$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $8ff0082eecb39b62$var$mixin(obj) {
    for(var key in $8ff0082eecb39b62$export$4293555f241ae35a.prototype)obj[key] = $8ff0082eecb39b62$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.on = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.off = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeListener = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeAllListeners = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$8ff0082eecb39b62$export$4293555f241ae35a.prototype.emitReserved = $8ff0082eecb39b62$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $8ff0082eecb39b62$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("5vwdc", function(module, exports) {

$parcel$export(module.exports, "pick", () => $4028d5a20a4526d1$export$357523c63a2253b9);
$parcel$export(module.exports, "installTimerFunctions", () => $4028d5a20a4526d1$export$2f67576668b97183);
$parcel$export(module.exports, "byteLength", () => $4028d5a20a4526d1$export$a48f0734ac7c2329);

var $3kfWP = parcelRequire("3kfWP");
function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $3kfWP.globalThisShim).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $3kfWP.globalThisShim).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $3kfWP.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $3kfWP.globalThisShim).setTimeout.bind((0, $3kfWP.globalThisShim));
        obj.clearTimeoutFn = (0, $3kfWP.globalThisShim).clearTimeout.bind((0, $3kfWP.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}

});
parcelRegister("3kfWP", function(module, exports) {

$parcel$export(module.exports, "globalThisShim", () => $26bf9c4279db2ef0$export$394f9358f6231289);
const $26bf9c4279db2ef0$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();

});



parcelRegister("e3yjg", function(module, exports) {

$parcel$export(module.exports, "yeast", () => $a3bbf5b17719daf1$export$5bb64b92cb4135a);
// imported from https://github.com/unshiftio/yeast
'use strict';
const $a3bbf5b17719daf1$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $a3bbf5b17719daf1$var$length = 64, $a3bbf5b17719daf1$var$map = {};
let $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$i = 0, $a3bbf5b17719daf1$var$prev;
function $a3bbf5b17719daf1$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $a3bbf5b17719daf1$var$alphabet[num % $a3bbf5b17719daf1$var$length] + encoded;
        num = Math.floor(num / $a3bbf5b17719daf1$var$length);
    }while (num > 0);
    return encoded;
}
function $a3bbf5b17719daf1$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($a3bbf5b17719daf1$var$i = 0; $a3bbf5b17719daf1$var$i < str.length; $a3bbf5b17719daf1$var$i++)decoded = decoded * $a3bbf5b17719daf1$var$length + $a3bbf5b17719daf1$var$map[str.charAt($a3bbf5b17719daf1$var$i)];
    return decoded;
}
function $a3bbf5b17719daf1$export$5bb64b92cb4135a() {
    const now = $a3bbf5b17719daf1$export$c564cdbbe6da493(+new Date());
    if (now !== $a3bbf5b17719daf1$var$prev) return $a3bbf5b17719daf1$var$seed = 0, $a3bbf5b17719daf1$var$prev = now;
    return now + '.' + $a3bbf5b17719daf1$export$c564cdbbe6da493($a3bbf5b17719daf1$var$seed++);
}
//
// Map each character to its index.
//
for(; $a3bbf5b17719daf1$var$i < $a3bbf5b17719daf1$var$length; $a3bbf5b17719daf1$var$i++)$a3bbf5b17719daf1$var$map[$a3bbf5b17719daf1$var$alphabet[$a3bbf5b17719daf1$var$i]] = $a3bbf5b17719daf1$var$i;

});

parcelRegister("2buxl", function(module, exports) {

$parcel$export(module.exports, "encode", () => $19744bce3c183d10$export$c564cdbbe6da493);
$parcel$export(module.exports, "decode", () => $19744bce3c183d10$export$2f872c0f2117be69);
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

});

parcelRegister("lB1J3", function(module, exports) {

$parcel$export(module.exports, "XHR", () => $fb8e645f3bad3d56$export$a2d42eb087c10497);
// browser shim for xmlhttprequest module

var $kxvpX = parcelRequire("kxvpX");

var $3kfWP = parcelRequire("3kfWP");
function $fb8e645f3bad3d56$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $kxvpX.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $3kfWP.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}

});
parcelRegister("kxvpX", function(module, exports) {

$parcel$export(module.exports, "hasCORS", () => $ef3f42a25dd224af$export$5235bbd4a1ef06e);
// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;

});



parcelRegister("dhyBt", function(module, exports) {

$parcel$export(module.exports, "WS", () => $9ab7b46a38551fa4$export$911baa0677ac404c);

var $6opKi = parcelRequire("6opKi");

var $2buxl = parcelRequire("2buxl");

var $e3yjg = parcelRequire("e3yjg");

var $5vwdc = parcelRequire("5vwdc");

var $cFgwF = parcelRequire("cFgwF");
parcelRequire("CnWUo");
var $bRHuL = parcelRequire("bRHuL");

var $6ZWSX = parcelRequire("6ZWSX");
var $9ab7b46a38551fa4$require$Buffer = $6ZWSX.Buffer;
// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$911baa0677ac404c extends (0, $6opKi.Transport) {
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $5vwdc.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $cFgwF.usingBrowserWebSocket) && !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new (0, $cFgwF.WebSocket)(uri, protocols) : new (0, $cFgwF.WebSocket)(uri) : new (0, $cFgwF.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType || (0, $cFgwF.defaultBinaryType);
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $bRHuL.default)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $cFgwF.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $9ab7b46a38551fa4$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $cFgwF.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $cFgwF.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "wss" : "ws";
        let port = "";
        // avoid port if default for schema
        if (this.opts.port && ("wss" === schema && Number(this.opts.port) !== 443 || "ws" === schema && Number(this.opts.port) !== 80)) port = ":" + this.opts.port;
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $e3yjg.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        const encodedQuery = (0, $2buxl.encode)(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $cFgwF.WebSocket);
    }
}

});
parcelRegister("cFgwF", function(module, exports) {

$parcel$export(module.exports, "nextTick", () => $93862213c34af1ff$export$bdd553fddd433dcb);
$parcel$export(module.exports, "WebSocket", () => $93862213c34af1ff$export$3909fb301d3dc8c9);
$parcel$export(module.exports, "usingBrowserWebSocket", () => $93862213c34af1ff$export$3407ba5dfb7a683d);
$parcel$export(module.exports, "defaultBinaryType", () => $93862213c34af1ff$export$790dcbc41e2d75d5);

var $3kfWP = parcelRequire("3kfWP");
const $93862213c34af1ff$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $93862213c34af1ff$export$3909fb301d3dc8c9 = (0, $3kfWP.globalThisShim).WebSocket || (0, $3kfWP.globalThisShim).MozWebSocket;
const $93862213c34af1ff$export$3407ba5dfb7a683d = true;
const $93862213c34af1ff$export$790dcbc41e2d75d5 = "arraybuffer";

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("l7wSz", function(module, exports) {

$parcel$export(module.exports, "parse", () => $f603c1892ffe9e8b$export$98e6a39c04603d36);
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}

});




parcelRegister("fL4YY", function(module, exports) {

$parcel$export(module.exports, "Manager", () => $b78f1c3cb524f77d$export$d0d38e7dec7a1a61);
parcelRequire("1XKMK");
var $5vwdc = parcelRequire("5vwdc");
var $cFgwF = parcelRequire("cFgwF");
var $al9N3 = parcelRequire("al9N3");

var $lGX0c = parcelRequire("lGX0c");

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $5pEXn = parcelRequire("5pEXn");

var $687to = parcelRequire("687to");
class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $687to.Emitter) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $5vwdc.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $5pEXn.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $2BjQv;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $al9N3.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $vPX8d.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        // emit `error`
        const errorSub = (0, $vPX8d.on)(socket, "error", (err)=>{
            self.cleanup();
            self._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            self.maybeReconnectOnOpen();
        });
        if (false !== this._timeout) {
            const timeout = this._timeout;
            if (timeout === 0) openSubDestroy(); // prevents a race condition with the 'open' event
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                socket.close();
                // @ts-ignore
                socket.emit("error", new Error("timeout"));
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $vPX8d.on)(socket, "ping", this.onping.bind(this)), (0, $vPX8d.on)(socket, "data", this.ondata.bind(this)), (0, $vPX8d.on)(socket, "error", this.onerror.bind(this)), (0, $vPX8d.on)(socket, "close", this.onclose.bind(this)), (0, $vPX8d.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $cFgwF.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $lGX0c.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

});
parcelRegister("lGX0c", function(module, exports) {

$parcel$export(module.exports, "Socket", () => $fcab49da21a6222a$export$4798917dbf149b79);

var $2BjQv = parcelRequire("2BjQv");

var $vPX8d = parcelRequire("vPX8d");

var $687to = parcelRequire("687to");
/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $687to.Emitter) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $vPX8d.on)(io, "open", this.onopen.bind(this)),
            (0, $vPX8d.on)(io, "packet", this.onpacket.bind(this)),
            (0, $vPX8d.on)(io, "error", this.onerror.bind(this)),
            (0, $vPX8d.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $2BjQv.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        // the timeout flag is optional
        const withErr = this.flags.timeout !== undefined || this._opts.ackTimeout !== undefined;
        return new Promise((resolve, reject)=>{
            args.push((arg1, arg2)=>{
                if (withErr) return arg1 ? reject(arg1) : resolve(arg2);
                else return resolve(arg1);
            });
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $2BjQv.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $2BjQv.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $2BjQv.PacketType).EVENT:
            case (0, $2BjQv.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $2BjQv.PacketType).ACK:
            case (0, $2BjQv.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $2BjQv.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $2BjQv.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $2BjQv.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $2BjQv.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}

});
parcelRegister("2BjQv", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export(module.exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export(module.exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

var $687to = parcelRequire("687to");

var $8URBv = parcelRequire("8URBv");

var $eGKCF = parcelRequire("eGKCF");
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $eGKCF.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $8URBv.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $687to.Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $eGKCF.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return typeof payload === "object";
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || typeof payload === "object";
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && payload.length > 0;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $8URBv.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

});
parcelRegister("8URBv", function(module, exports) {

$parcel$export(module.exports, "deconstructPacket", () => $67dd224d5a131c9e$export$ac2edb9eb7af56f6);
$parcel$export(module.exports, "reconstructPacket", () => $67dd224d5a131c9e$export$a00da3b1ec037a04);

var $eGKCF = parcelRequire("eGKCF");
function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $eGKCF.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}

});
parcelRegister("eGKCF", function(module, exports) {

$parcel$export(module.exports, "isBinary", () => $ab192732c3780e48$export$37488ff1135b1696);
$parcel$export(module.exports, "hasBinary", () => $ab192732c3780e48$export$5234c529abdb5610);
const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}

});



parcelRegister("vPX8d", function(module, exports) {

$parcel$export(module.exports, "on", () => $05fb321879039179$export$af631764ddc44097);
function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

});


parcelRegister("5pEXn", function(module, exports) {

$parcel$export(module.exports, "Backoff", () => $3f0f0eae169725b6$export$2d38012449449c89);
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};

});




parcelRegister("1FyMI", function(module, exports) {

$parcel$export(module.exports, "demoInitialStore", () => $a4af54c3cd000569$export$462c9e1fbffdc07c);

var $bK8XO = parcelRequire("bK8XO");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");
// Local calendar date, matching how the client derives "today" and "tomorrow"
// (date-fns formatISO on a local Date). toISOString() would give the UTC date,
// which is the previous day between midnight and 02:00 CEST — enough to make the
// spot page treat today's prices as some other day's.
const $a4af54c3cd000569$var$toIsoDate = (date)=>[
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
    ].join('-');
const $a4af54c3cd000569$var$isoToday = $a4af54c3cd000569$var$toIsoDate(new Date());
// setDate() rolls the month/year over for us and stays on the local calendar.
const $a4af54c3cd000569$var$isoTomorrow = $a4af54c3cd000569$var$toIsoDate((()=>{
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
})());
// Low-tariff (HDO) windows the demo device is wired for, as seconds from
// midnight: high tariff during the 7:00-9:00 morning peak, low tariff for the
// rest of the day. Same shape the store holds them in below.
const $a4af54c3cd000569$var$hdoOn = [
    true,
    true,
    false,
    false,
    false,
    false
];
const $a4af54c3cd000569$var$hdoTimeStart = [
    0,
    32400,
    0,
    0,
    0,
    0
];
const $a4af54c3cd000569$var$hdoTimeStop = [
    25200,
    86400,
    0,
    0,
    0,
    0
];
const $a4af54c3cd000569$var$priceDistributionLow = 1.0;
const $a4af54c3cd000569$var$priceDistributionHi = 1.5;
// Distribution surcharge for the period starting at `seconds`: the low rate
// inside an HDO window, the high rate outside it. Mirrors getDistribution() in
// modules/spot/spot-prices.ts, which a real device re-runs on every price fetch.
// The demo store never runs that code, so the with-distribution arrays are
// derived from the base prices here instead of being written out by hand - the
// hand-written 15M pair had drifted into being identical to the base prices, so
// the distribution-only chart view showed a flat zero for today.
const $a4af54c3cd000569$var$distributionAt = (seconds)=>$a4af54c3cd000569$var$hdoOn.some((on, i)=>on && seconds >= $a4af54c3cd000569$var$hdoTimeStart[i] && seconds < $a4af54c3cd000569$var$hdoTimeStop[i]) ? $a4af54c3cd000569$var$priceDistributionLow : $a4af54c3cd000569$var$priceDistributionHi;
const $a4af54c3cd000569$var$round = (value)=>Math.round(value * 1e7) / 1e7;
const $a4af54c3cd000569$var$hourlyDistribution = Array.from({
    length: 24
}, (_, hour)=>$a4af54c3cd000569$var$distributionAt(hour * 3600));
const $a4af54c3cd000569$var$withDistribution60M = (prices)=>prices.map((price, hour)=>$a4af54c3cd000569$var$round(price + $a4af54c3cd000569$var$distributionAt(hour * 3600)));
const $a4af54c3cd000569$var$withDistribution15M = (prices)=>prices.map((price, period)=>$a4af54c3cd000569$var$round(price + $a4af54c3cd000569$var$distributionAt(period * 900)));
const $a4af54c3cd000569$var$spotHoursPrice = [
    2.64,
    2.53,
    2.28,
    1.27,
    2.24,
    2.46,
    2.84,
    3.71,
    3.58,
    2.34,
    1.98,
    1.2,
    0.4,
    -0.84,
    1.11,
    1.78,
    2.02,
    2.43,
    3.34,
    5.42,
    6.53,
    4.59,
    3.33,
    2.72
];
const $a4af54c3cd000569$var$spot15MPrice = [
    2.4257244,
    2.2290572,
    2.1122252,
    2.1351048,
    2.313517,
    2.2217552,
    2.0732812,
    2.0163256,
    2.109061,
    2.0842342,
    2.1258556,
    2.1993624,
    2.2176174,
    2.1993624,
    2.1993624,
    2.1755092,
    2.183298,
    2.2463386,
    2.274573,
    2.2801712,
    2.1063836,
    2.2059342,
    2.3680386,
    2.7470124,
    2.3349362,
    2.907413,
    3.3117004,
    4.1808818,
    4.111756,
    4.81932,
    4.570078,
    4.003443,
    4.608779,
    3.703331,
    2.818572,
    2.223459,
    2.9814066,
    2.7197516,
    2.2353856,
    1.8028638,
    2.4763516,
    2.431566,
    2.0856946,
    1.891218,
    2.2585086,
    2.0501582,
    1.807245,
    1.6702108,
    1.7758464,
    1.6276158,
    1.6159326,
    1.6096042,
    1.4720832,
    1.529769,
    1.5716338,
    1.6105778,
    1.5777188,
    1.7096416,
    1.8907312,
    2.0613546,
    1.578449,
    1.8907312,
    2.1896264,
    2.488765,
    1.9050918,
    1.9856572,
    2.3181416,
    2.5552132,
    1.9737306,
    2.6644998,
    3.3192458,
    4.1969462,
    3.1318278,
    3.672906,
    4.3478542,
    5.69556,
    5.6811994,
    5.2394284,
    4.1368264,
    3.2674016,
    3.7644244,
    3.2231028,
    2.7720826,
    2.5364714,
    2.7910678,
    2.6099782,
    2.2923412,
    2.2156702,
    2.7075816,
    2.5243014,
    2.3996806,
    2.0942136,
    2.6075442,
    2.356112,
    1.9467132,
    1.6828676
];
// Tomorrow gets its own curve so stepping a day forward shows something other
// than a copy of today. Real CZ day-ahead prices (2026-04-30), taken from the
// newest spot_summaries snapshot in demo/db.sqlite — which the demo API shifts
// onto tomorrow's date anyway, so the two agree. Each hourly value is the mean
// of that hour's four quarters, as it is on a real device.
const $a4af54c3cd000569$var$spotHoursPriceTomorrow = [
    2.6259698,
    2.5725776,
    2.5264994,
    2.5694082,
    2.6822876,
    2.9363272,
    3.2210856,
    2.975579,
    2.4667684,
    1.1582938,
    0.0058512,
    -0.06095,
    -0.3283986,
    -0.671669,
    -0.513199,
    -0.1969904,
    0.0446154,
    0.9725182,
    2.5216234,
    3.5438768,
    4.1572776,
    3.208408,
    2.9480296,
    2.720808
];
const $a4af54c3cd000569$var$spot15MPriceTomorrow = [
    2.7386054,
    2.5954948,
    2.5993956,
    2.5701396,
    2.5606314,
    2.5481976,
    2.5618504,
    2.619631,
    2.592813,
    2.506264,
    2.4991938,
    2.5077268,
    2.5462472,
    2.558681,
    2.565995,
    2.6067096,
    2.5384456,
    2.6191434,
    2.7515268,
    2.819547,
    2.7376302,
    2.8497782,
    2.9994714,
    3.1581852,
    2.8363692,
    3.4044232,
    3.4568402,
    3.1869536,
    3.588736,
    3.1445324,
    2.8100388,
    2.3590088,
    3.2630192,
    2.9614386,
    2.3967978,
    1.2455742,
    2.7859026,
    1.4893742,
    0.3574108,
    0.0002438,
    0.0485162,
    0,
    0,
    -0.0251114,
    0.0019504,
    -0.0114586,
    -0.0636318,
    -0.1704162,
    -0.148718,
    -0.2918286,
    -0.3647248,
    -0.5085668,
    -0.5468434,
    -0.6307106,
    -0.7282306,
    -0.7811352,
    -0.6597228,
    -0.530265,
    -0.4880876,
    -0.3744768,
    -0.3530224,
    -0.248676,
    -0.1531064,
    -0.0326692,
    -0.0970324,
    0.008533,
    0.035351,
    0.2318538,
    -0.0102396,
    0.1479866,
    1.4498786,
    2.3024472,
    1.1585376,
    2.490417,
    2.9507114,
    3.4865838,
    2.8076008,
    3.1467266,
    3.6921072,
    4.5290726,
    4.2972188,
    4.423751,
    4.1740998,
    3.7340408,
    4.0912078,
    3.3785804,
    2.8453898,
    2.5186978,
    3.3110478,
    3.0123928,
    2.7898034,
    2.6783868,
    2.9173108,
    2.7651796,
    2.622069,
    2.5784288
];
const $a4af54c3cd000569$export$462c9e1fbffdc07c = {
    DEVICE_ID: 'DEMO',
    BOARD: (0, $8ni7a.Board).V2,
    // Derived from the board the same way store/init.ts does it, so the demo can
    // never drift out of sync with a real v2 device. Settings reads
    // NETWORK_CAPABILITIES.managedNetwork unguarded, so leaving it out crashes
    // the whole /nastaveni page.
    NETWORK_CAPABILITIES: (0, $bK8XO.getNetworkCapabilities)((0, $8ni7a.Board).V2),
    BOARD_NETWORK: true,
    BOARD_RS485: true,
    BOARD_RS485_HOST: 'localhost',
    BOARD_RS485_PORT: 502,
    VERSION: {},
    SERVICE_ACTIVE: false,
    SERVICE_PASSWORD: '',
    APP_UI_VARIANT: (0, $8ni7a.AppUiVariant).Default,
    EM_ENERGY_CONSUMED_TOTAL: 2950.1,
    EM_ENERGY_CONSUMED_TODAY: 0.3,
    EM_ENERGY_CONSUMED_YEAR: 235.1,
    EM_ENERGY_OVERFLOW_TOTAL: 291.0,
    EM_ENERGY_OVERFLOW_TODAY: 0,
    EM_ENERGY_OVERFLOW_YEAR: 12.5,
    EM_INFO_Consumption: [
        0.8,
        1.2,
        0.3
    ],
    HW_ON: true,
    HW_INSTALL: true,
    HW_TEMP_ENABLED: true,
    HW_CAPACITY: 250,
    HW_TEMP: 45.2,
    HW_SET_TEMP: 20,
    HW_MAX_TEMP_EK: 65,
    HW_SPOT_TEMP_EK: 55,
    HW_HYST: 4,
    PHASE_3_FVE: true,
    HW_EK_NOMINAL: 1,
    HW_ACTUAL_POWER: 0,
    HW_BATTERY_PRIO: true,
    //HW_MAX_
    HW_ERR: false,
    HW_ERR_RESET_TIME: 5400000,
    HW_ERR_RESET: false,
    ERR_RESET: false,
    com_index: 0,
    HW_INFO: {
        Status: (0, $8ni7a.HeatWaterStatus).PVHeating,
        Err: false,
        Err_info: '',
        Surplus: true,
        Consumption: [
            0.8,
            1.2,
            0.3
        ]
    },
    PV_ENERGY_PRODUCED_TOTAL: 9537,
    PV_ENERGY_PRODUCED_TODAY: 42.1,
    PV_ENERGY_PRODUCED_YEAR: 3729,
    EM_ACTUAL_LOAD: [
        0,
        0,
        0
    ],
    EM_ACTUAL_LOAD_MAX: 0,
    EM_LOAD_MAX: 90,
    EM_MAX_CURRENT: 25,
    EM_INFO: {
        Status: (0, $8ni7a.SmartMeterStatus).Consumption,
        Err: false,
        Err_info: '',
        Surplus: false,
        Consumption: [
            0.1,
            0,
            0
        ]
    },
    HOME_ACTUAL_POWER: 1.8,
    PV_NOMINAL: 10,
    PV_BAT_NOMINAL: 10,
    PV_INSTALL: true,
    PV_BATTERY: true,
    PV_INVERTER_TYPE: (0, $8ni7a.Inverter).GoodWe,
    PV_EM_OFFSET: -1,
    PV_OVERFLOW: true,
    PV_ACTUAL_POWER: 9.8,
    PV_ACTUAL_POWER_STRING: [
        4.3,
        4.5,
        1.0
    ],
    PV_ACTUAL_POWER_STRING_V: true,
    PV_SOC_MIN_FINAL: 20,
    PV_SOC_SET_MIN: 20,
    PV_SOC_SET_UTILITY_LOST: 10,
    PV_OFFSET_SOC_HW_PRIO: 90,
    PV_cnt_com_ok: 0,
    PV_cnt_com_err: 0,
    PV_cnt_com_write: 0,
    PV_com_ok: false,
    SOC_AUTO: true,
    PV_ACTUAL_SOC: 91,
    PV_ACTUAL_POWER_BATTERY: -1.4,
    PV_OVERFLOW_MAX_VALUE: 0,
    UTILITY_LOSS: false,
    set_overflow: 0,
    set_SOC: 0,
    set_SOC1: 0,
    HOME_ENERGY_CONSUMED_TODAY: 5.9,
    INVERTER_STATUS: 0,
    PWM_test: 0,
    PWM_f: 5,
    PWM_pulse_time: 10,
    PWM_pulse_time_real: 0,
    PV_INFO: {
        Status: (0, $8ni7a.PhotovoltaicStatus).Production,
        Err: false,
        Err_info: '',
        Surplus: false,
        Consumption: [
            0,
            0,
            0
        ]
    },
    PV_POWER_GRAPH: {
        Day: [
            0,
            0
        ],
        Week: [
            0,
            0
        ],
        Year: [
            0,
            0
        ],
        Total: 0,
        Last_Total: 0
    },
    HW_POWER_GRAPH: {
        Day: [
            0,
            0
        ],
        Week: [
            0,
            0
        ],
        Year: [
            0,
            0
        ],
        Total: 0,
        Last_Total: 0
    },
    EM_CONSUMED_GRAPH: {
        Day: [
            0,
            0
        ],
        Week: [
            0,
            0
        ],
        Year: [
            0,
            0
        ],
        Total: 0,
        Last_Total: 0
    },
    EM_OVERFLOW_GRAPH: {
        Day: [
            0,
            0
        ],
        Week: [
            0,
            0
        ],
        Year: [
            0,
            0
        ],
        Total: 0,
        Last_Total: 0
    },
    HP_CONSUMED_GRAPH: {
        Day: [
            0,
            0
        ],
        Week: [
            0,
            0
        ],
        Year: [
            0,
            0
        ],
        Total: 0,
        Last_Total: 0
    },
    TEMP: [],
    TEMP_IDS: [],
    HP_INFO: {
        Status: (0, $8ni7a.HeatPumpStatus).Heating,
        Err: false,
        Err_info: '',
        Surplus: false,
        Consumption: [
            0,
            0,
            0
        ]
    },
    HP_NOMINAL: 5,
    HP_PV_STABILITY: 40,
    HP_FLEXIBILITY_ON: false,
    HP_FLEXIBILITY: false,
    HP_PRIORITY: true,
    HP_ENERGY_CONSUMED_YEAR: 995,
    HP_ENERGY_CONSUMED_TODAY: 7.1,
    HP_ENERGY_CONSUMED_TOTAL: 2019,
    HP_ECOONE_API_IP: '',
    HP_cnt_com_ok: 0,
    HP_cnt_com_err: 0,
    HP_com_ok: true,
    HP_ACTUAL_POWER: 2.8,
    HP_IN: 0,
    HP_ENABLED: true,
    HP_TYPE: 1,
    HP_TEMP: 43.1,
    OUTDOOR_TEMP: 11.2,
    HW_SOC_STOP: 20,
    HW_SOC_STOP_UTILITY: 80,
    HP_EQUITHERMAL_CORRECTION: 0.5,
    HP_INFO_Status: '',
    HP_FLEXI_ROOM: true,
    HP_FLEXI_HW: true,
    HP_FLEXI_COOL: true,
    HP_FLEXI_AN: true,
    HP_ROOM_TEMP: 21.3,
    HP_ROOM_ON: true,
    HP_ROOM_TEMP_V: true,
    HP_ROOM_SET_TEMP_MIN: 21,
    HP_ROOM_SET_TEMP_MAX: 22,
    HP_ROOM_SET_FLEXI_TEMP: 0.8,
    HP_HW_TEMP: 45.1,
    HP_HW_ON: true,
    HP_HW_TEMP_V: true,
    HP_HW_SET_TEMP: 45,
    HP_HW_SET_FLEXI_TEMP: 5,
    AT_H: 0,
    uptime: 0,
    RELAY_INSTALL: true,
    RELAY_ENABLED: [
        true,
        true,
        true,
        true
    ],
    RELAY_NAME: [
        "Rel\xe9 1",
        "Rel\xe9 2",
        "Rel\xe9 3",
        "Rel\xe9 4"
    ],
    RELAY_CONTROL_TYPE: [
        [
            'spot-hi',
            'hdo',
            'plug2',
            'plug3'
        ],
        [
            'none',
            'none',
            'none',
            'none'
        ]
    ],
    RELAY_OUTPUT: [
        true,
        false,
        true,
        false
    ],
    RELAY_USER_ADVANCED_CONTROL: true,
    SP_INSTALL: true,
    SP_ON: true,
    SP_USER_ADVANCED_CONTROL: true,
    SP_DISCHARGE_TO_GRID_SER: true,
    SP_DISCHARGE_TO_GRID: true,
    SP_OVERFLOW_OPTIMALIZATION: true,
    SP_HOURS_PRICE: [
        ...$a4af54c3cd000569$var$spotHoursPrice
    ],
    SP_HOURS_PRICE_DATE: $a4af54c3cd000569$var$isoToday,
    SP_ACTUAL_PRICE: 0,
    SP_ACTUAL_PRICE_LOW: false,
    SP_ACTUAL_PRICE_HI: false,
    SP_PV_RADIATION_DATE: $a4af54c3cd000569$var$isoToday,
    SP_LATITUDE: 50.09,
    SP_LONGITUDE: 14.42,
    SP_LOW_PRICE: 2.0,
    SP_HI_PRICE: 2.8,
    SP_PV_RADIATION: [
        0,
        0
    ],
    SP_FORECAST_PV: 65,
    SP_FORECAST_HOME_CONSUMPTIN: 31,
    SP_FORECAST_HOME_CONSUMPTIN_PV: 17,
    SP_FORECAST_BATTERY_CONSUMPTIN: 7.8,
    SP_FORECAST_HW_CONSUMPTIN: 7.1,
    SP_FORECAST_HP_CONSUMPTIN: 13.2,
    SP_FORECAST_PV_DEBREEFING: 1,
    SP_HP_STATUS: (0, $8ni7a.SpotHeatPumpStatus).FlexibilitySpot,
    SP_HW_STATUS: (0, $8ni7a.SpotHeatWaterStatus).FlexibilityPV,
    SP_BAT_STATUS: (0, $8ni7a.SpotBatteryStatus).FlexibilityPV,
    SP_EM_STATUS: (0, $8ni7a.SpotSmartMeterStatus).OverflowFlexibilitySell,
    SP_HP: false,
    SP_HW: false,
    SP_BAT: false,
    SP_EM: false,
    SP_HP_NOW_INCREASE: false,
    SP_HP_NOW_REDUCE: false,
    PV_BATTERY_CONTROL: true,
    PV_OVERFLOW_CONTROL: true,
    SP_BATTERY_CONTROL_SERVICE: true,
    SP_BATTERY_CONTROL_CUSTOMER: true,
    SP_BATTERY_STOP_DISCHARGE_LOW_PRICE: true,
    SP_BATTERY_STOP_DISCHARGE_MIDDLE_PRICE: false,
    SP_PRICE_ONLY_VIEW: true,
    SP_HOURS_PRICE_DISTRIBUTION: $a4af54c3cd000569$var$hourlyDistribution,
    SP_HOURS_PRICE_WITH_DISTRIBUTION: $a4af54c3cd000569$var$withDistribution60M($a4af54c3cd000569$var$spotHoursPrice),
    shelly_cnt_com_ok: [
        0,
        0,
        0
    ],
    shelly_cnt_com_err: [
        0,
        0,
        0
    ],
    shelly_com_ok: [
        false,
        false,
        false
    ],
    PL_IP: [
        '100.100.1.51',
        '100.100.1.52',
        '100.100.1.53'
    ],
    PL_ON: [
        true,
        false,
        false
    ],
    PL_INSTALL: true,
    PL_INSTALL_I: [
        true,
        false,
        false
    ],
    PL_CONSUMPTIN: [
        0.2,
        0,
        0
    ],
    PL_NUMBER: 1,
    PL_ENERGY_CONSUMPTIN_TODAY: [
        1.1,
        0,
        0
    ],
    PL_ENERGY_CONSUMPTIN_YEAR: [
        7.12,
        0,
        0
    ],
    PL_BAT: [
        true,
        false,
        false
    ],
    PL_BAT_START: [
        90,
        90,
        90
    ],
    PL_BAT_STOP: [
        80,
        80,
        80
    ],
    PL_SPOT: [
        false,
        false,
        false
    ],
    PL_SPOT_LOW: [
        false,
        false,
        false
    ],
    PL_SPOT_HI: [
        false,
        false,
        false
    ],
    PL_SPOT_MI: [
        false,
        false,
        false
    ],
    PL_TIME: [
        false,
        false,
        false
    ],
    PL_TIME_START: [
        0,
        0,
        0
    ],
    PL_TIME_STOP: [
        0,
        0,
        0
    ],
    PL_OVERFLOW: [
        false,
        true,
        true
    ],
    PL_OVERFLOW_START_POWER: [
        -3,
        -6,
        -6
    ],
    PL_OVERFLOW_STOP_POWER: [
        0.1,
        -3.1,
        -3.1
    ],
    PL_OVERFLOW_TON: [
        60,
        120,
        180
    ],
    PL_OVERFLOW_CONSUMPTION: [
        3.0,
        2.8,
        2.8
    ],
    PL_STATUSLED: true,
    PL_LED: false,
    PL_INFO: [
        {
            Status: (0, $8ni7a.PlugStatus).BatteryControl,
            Err: false,
            Err_info: '',
            Surplus: false,
            Consumption: [
                0,
                0,
                0
            ]
        },
        {
            Status: (0, $8ni7a.PlugStatus).NotActive,
            Err: false,
            Err_info: '',
            Surplus: false,
            Consumption: [
                0,
                0,
                0
            ]
        },
        {
            Status: (0, $8ni7a.PlugStatus).NotActive,
            Err: false,
            Err_info: '',
            Surplus: false,
            Consumption: [
                0,
                0,
                0
            ]
        }
    ],
    //Animation value
    anim_EM_Consumption: [
        0.1,
        0,
        0
    ],
    anim_PV_ACTUAL_POWER: 9.8,
    anim_HW_ACTUAL_POWER: 2.3,
    anim_PV_ACTUAL_POWER_BATTERY: -1.4,
    anim_HOME_ACTUAL_POWER: 1,
    anim_HP_ACTUAL_POWER: 1.8,
    animation_time_response: 3000,
    anim_WB_ACTUAL_POWER: 4.2,
    test_persisted: false,
    test_hours: 0,
    MODBUS_TEST_ADDRESS: '100.100.1.100',
    MODBUS_TEST_PORT: 502,
    CUSTOMER: "Tom\xe1\u0161 Super",
    //Err list
    ERR_LIST: [
        '',
        '',
        ''
    ],
    // new statistics
    NEW_PL_ENERGY_PRODUCED_TOTAL: 0,
    HW_ENERGY_PRODUCED_TOTAL: 157.0,
    PL_ENERGY_PRODUCED_TOTAL: 0,
    WB_MAX_CURRENT_NONE_MODE: 16,
    WB_MAX_CURRENT_SPOT: 16,
    WB_MAX_CURRENT_BATTERY: 16,
    WB_MAX_CURRENT: 8,
    WB_IP_ADRESS: '100.100.1.120',
    WB_IP_PORT: 8000,
    WB_INSTALL: true,
    WB_ON: true,
    WB_cnt_com_ok: 0,
    WB_cnt_com_err: 0,
    WB_cnt_com_write: 0,
    WB_com_ok: false,
    WB_ACTUAL_POWER: 4.2,
    WB_STATE: 1,
    WB_INSTALL_V: false,
    WB_INFO: {
        Status: (0, $8ni7a.WallboxStatus).Charging,
        Err: false,
        Err_info: '',
        Surplus: false,
        Consumption: [
            0,
            0,
            0
        ]
    },
    NEW_WB_ENERGY_CONSUMPTION_TOTAL: 7351,
    STATS_WB_ENERGY_CONSUMPTION_TOTAL: 7351,
    WB_ENERGY_CONSUMPTION_YEAR: 471,
    WB_ENERGY_CONSUMPTION_TODAY: 10,
    WB_CAR_CONNECT: true,
    WB_MODE_PV: false,
    WB_MODE_SPOT: true,
    WB_MODE_AUTO: false,
    WB_MODE_NONE: false,
    WB_MIN_CHARGE_ENERGY: 5,
    WB_SPOT_MI_STOP: false,
    WB_SPOT_HI_STOP: true,
    WB_ENERGY_CONSUMPTION_NOW: 3,
    WB_BAT_STOP: 80,
    WB_BAT_START: 95,
    WB_TIME_OF_DISCONNECT: 25200,
    LICENSE_STATUS: 'SMART',
    SP_DISCHARGE_TO_GRID_MIN_PRICE: 5.0,
    SP_DISCHARGE_ALL_TO_GRID_MIN_PRICE: 10.0,
    SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC: 40,
    SP_MIN_SPOT_DIFFERENCE_PRICE: 2.0,
    SP_ENERGY_FOR_SALE: 3.5,
    SP_PRICE_OFFSET_OVERFLOW: 0.5,
    PRICE_DISTRIBUTION_LOW: $a4af54c3cd000569$var$priceDistributionLow,
    PRICE_DISTRIBUTION_HI: $a4af54c3cd000569$var$priceDistributionHi,
    PRICE_DISTRIBUTION: 0.3,
    HDO_ON: $a4af54c3cd000569$var$hdoOn,
    HDO_TIME_START: $a4af54c3cd000569$var$hdoTimeStart,
    HDO_TIME_STOP: $a4af54c3cd000569$var$hdoTimeStop,
    HDO: false,
    EM_INSTALL: true,
    SP_BATTERY_DISCHARGE_TABLE: [
        true,
        true,
        true,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true
    ],
    SP_BATTERY_GRID_CHARGE_TABLE: [
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    SP_BATTERY_GRID_DISCHARGE_TABLE: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        true,
        false,
        false,
        false
    ],
    SP_OVERFLOW_TABLE: [
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        false,
        false,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
    ],
    SP_HW_GRID_HEAT_TABLE: [
        false,
        false,
        false,
        true,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    SP_HP_TABLE: [
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Increase,
        (0, $8ni7a.HpLevel).Normal,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Reduction,
        (0, $8ni7a.HpLevel).Normal
    ],
    SP_PRICE_LEVEL: [
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Mid
    ],
    STATS_EM_ENERGY_CONSUMED_TODAY: 0.3,
    STATS_EM_ENERGY_OVERFLOW_TODAY: 8.3,
    STATS_PV_ENERGY_PRODUCED_TODAY: 41.2,
    STATS_HOME_ENERGY_CONSUMED_TODAY: 5.9,
    STATS_HW_ENERGY_PRODUCED_TODAY: 10.1,
    STATS_HP_ENERGY_CONSUMED_TODAY: 7.1,
    STATS_WB_ENERGY_CONSUMPTION_TODAY: 10.0,
    STATS_EM_ENERGY_CONSUMED_YEAR: 235.1,
    STATS_EM_ENERGY_OVERFLOW_YEAR: 12.5,
    STATS_PV_ENERGY_PRODUCED_YEAR: 3729,
    STATS_HW_ENERGY_PRODUCED_YEAR: 157.0,
    STATS_HP_ENERGY_CONSUMED_YEAR: 995,
    STATS_WB_ENERGY_CONSUMPTION_YEAR: 471,
    PREMIUM: true,
    INITIAL_WIZARD_COMPLETED_AT: '2026-01-01T00:00:00.000Z',
    SPOT_WIZARD_COMPLETED_AT: '2026-01-01T00:00:00.000Z',
    INVERTER_POWER: 10,
    PV_BATTERY_POWER_PERCENT: 100,
    HW_ABOVE_TEMP_RELAY: [
        40,
        40,
        40,
        40
    ],
    HW_ABOVE_TEMP_RELAY_HYST: [
        4,
        4,
        4,
        4
    ],
    HW_BELOW_TEMP_RELAY: [
        40,
        40,
        40,
        40
    ],
    HW_BELOW_TEMP_RELAY_HYST: [
        4,
        4,
        4,
        4
    ],
    BAT_BELOW_SOC_RELAY: [
        20,
        20,
        20,
        20
    ],
    BAT_BELOW_SOC_RELAY_HYST: [
        5,
        5,
        5,
        5
    ],
    BAT_ABOVE_SOC_RELAY: [
        95,
        95,
        95,
        95
    ],
    BAT_ABOVE_SOC_RELAY_HYST: [
        5,
        5,
        5,
        5
    ],
    SPOT_PRICE_ABOVE_RELAY: [
        5,
        5,
        5,
        5
    ],
    SPOT_PRICE_BELOW_RELAY: [
        0,
        0,
        0,
        0
    ],
    SPOT_PRICE_ABOVE_RELAY_15MIN: [
        5,
        5,
        5,
        5
    ],
    SPOT_PRICE_BELOW_RELAY_15MIN: [
        0,
        0,
        0,
        0
    ],
    PV_BATTERY_CHARGING_POWER: 5,
    PV_BATTERY_DISCHARGING_POWER: 5,
    PL_SPOT_LOW_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_HI_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_MI_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_NEG_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SP_PRICE_PERIOD: [
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M'],
        (0, $6uJ19.SpotPricePeriod)['60M']
    ],
    OEM_DISTRIBUTION: (0, $8ni7a.OemDistribution).Infigy,
    LICENSE: (0, $8ni7a.License).SMART,
    TEST_INFO_LABEL: [
        "Netestov\xe1no",
        "Netestov\xe1no",
        "Netestov\xe1no",
        "Netestov\xe1no",
        "Netestov\xe1no",
        "Netestov\xe1no"
    ],
    PRODUCT_TESTER: '',
    CUSTOMER_EMAIL: '',
    SERVICE_EMAIL: '',
    SERVICER: '',
    SP_HP_NOW_REDUCE_ON: false,
    SP_HP_NOW_INCREASE_ON: false,
    SERIAL_NUMBER: '',
    PL_LED_BAT: false,
    PL_LED_OVER: false,
    SERIAL_NUMBER_SWITCHBOARD: '',
    PL_NAME: [
        "Z\xe1suvka 1",
        "Z\xe1suvka 2",
        "Z\xe1suvka 3",
        "Z\xe1suvka 4",
        "Z\xe1suvka 5",
        "Z\xe1suvka 6",
        "Z\xe1suvka 7",
        "Z\xe1suvka 8",
        "Z\xe1suvka 9"
    ],
    LOGIN_LIST: [
        '',
        '',
        ''
    ],
    PHASE_3_HW: true,
    HW_LEGIONELLA_ON: false,
    HW_LEGIONELLA_TEMP: 60,
    HW_LEGIONELLA_LAST_TIME: '2026-01-01T00:00:00.000Z',
    HP_HW_MAX_SET_TEMP: 53,
    PL_SHELLY_HW_PLUG: false,
    INVERTER_CONFIG: {},
    INVERTER_STATS_PERSISTED: {},
    WB_CLIENT_ID: 1,
    WB_TYPE: (0, $8ni7a.Wallbox).Solax,
    WB_ACTUAL_POWER_TOTAL: 0,
    SP_PRICE_BELOW_PLUG_VALUE: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    SP_PRICE_ABOVE_PLUG_VALUE: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    SP_PRICE_BELOW_PLUG_15MIN_VALUE: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    SP_PRICE_ABOVE_PLUG_15MIN_VALUE: [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    WB_ENERGY_CONSUMPTION_TOTAL: 0,
    EM_METERS_CONFIG: {},
    WIND_BATTERY_CHARGE_TOTAL: 0,
    HDO_MODE: 1,
    HDO_WEEKEND: false,
    HDO_ON_WEEKEND: [
        false,
        false,
        false,
        false,
        false,
        false
    ],
    HDO_TIME_START_WEEKEND: [
        0,
        0,
        0,
        0,
        0,
        0
    ],
    HDO_TIME_STOP_WEEKEND: [
        0,
        0,
        0,
        0,
        0,
        0
    ],
    HW_HDO: false,
    SP_CHARGE_BATTERY_FINAL_SOC_MAX: 95,
    DELTA_GREEN_API_ENABLED: false,
    DELTA_GREEN_BATTERY_MAX_POWER_IN: 0,
    DELTA_GREEN_BATTERY_MAX_POWER_OUT: 0,
    DELTA_GREEN_PV_ORIENTATION: 0,
    WIND_INSTALL: false,
    WIND_PRODUCED_TOTAL: 0,
    WIND_PRODUCED_TODAY: 0,
    WIND_PRODUCED_YEAR: 0,
    HW_CONTROL_TYPE: (0, $8ni7a.HeatWater).Proportional,
    PV_SOC_SET_UTILITY_LOST_V: true,
    PV_STRING_NUMBER: 2,
    PL_MORE_PLUGS: false,
    PL_MORE_PLUGS_NUMBER: 3,
    SP_HW_K: 1.5,
    HW_ERR_POWER_ENABLED: true,
    WB_MODE_PV2: false,
    WB_MODE_PV2_3A: true,
    WB_MODE_PV2_6A: true,
    HP_ROOM_COOL_ON: false,
    EAN_PURCHASE: 0,
    PV_SOLAX_EXTERNAL_PV: false,
    PV_SOFAR_EXTERNAL_PV: false,
    SP_BATTERY_STOP_DISCHARGE_AUTO: false,
    SP_BATTERY_STOP_DISCHARGE_AUTO_DEV: false,
    HW_SPOT_HI_STOP: false,
    HW_SPOT_MI_STOP: false,
    SP_BATTERY_K: 1.0,
    APP_UI_CUSTOM_TABS: [],
    HP_SOC_STOP: 30,
    MQTT_CLOUD_ENABLED: false,
    MQTT_CLOUD_DEVICES: [],
    MQTT_BROKER_ENABLED: false,
    PLC_CONFIG: {
        enabled: false,
        ipAddress: '192.168.100.100',
        username: 'user',
        password: 'pass',
        pollInterval: 1000,
        gridMetrics: {
            enabled: false,
            direction: 'read'
        },
        pvMetrics: {
            enabled: false,
            direction: 'read'
        },
        kgjMetrics: {
            enabled: false,
            direction: 'disabled'
        }
    },
    APP_MESSAGES_DEV: false,
    CLOUD_PLUGS_BATTERY_CONTROLLED: false,
    CLOUD_PLUGS_BATTERY_START: 90,
    CLOUD_PLUGS_BATTERY_STOP: 70,
    CLOUD_PLUGS_TIME_CONTROLLED: false,
    CLOUD_PLUGS_TIME_START: 0,
    CLOUD_PLUGS_TIME_STOP: 0,
    CLOUD_PLUGS_OVERFLOW_CONTROLLED: false,
    CLOUD_PLUGS_OVERFLOW_START_POWER: -0.5,
    CLOUD_PLUGS_OVERFLOW_STOP_POWER: 0.1,
    CLOUD_PLUGS_PV_POWER_CONTROLLED: false,
    CLOUD_PLUGS_PV_POWER_START_POWER: 1.5,
    CLOUD_PLUGS_PV_POWER_STOP_POWER: 0.5,
    CLOUD_PLUGS_CONTROL_CONDITION: 'or',
    CLOUD_PLUGS_LED_MODE_SWITCH: true,
    CLOUD_PLUGS_LED_MODE_BATTERY: false,
    CLOUD_PLUGS_LED_MODE_OVERFLOW: false,
    PL_SPOT_NEG: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_BELOW_PLUG: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_ABOVE_PLUG: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_BELOW_PLUG_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    PL_SPOT_ABOVE_PLUG_15MIN: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    THERMOSTAT_INSTALL: false,
    NUMBER_OF_THERMOSTATS: 1,
    THERMOSTAT_SETTINGS: [
        {
            setTemp: 20,
            flexibilityTemp: 0.5,
            pvFlexibilityActiveSet: false,
            spFlexibilityActiveUpSet: false,
            spFlexibilityActiveDownSet: false,
            on: false,
            name: ''
        }
    ],
    THERMOSTAT_HYSTERESIS: 0.5,
    THERMOSTAT_HP_CONSUMPTION: 4,
    THERMOSTAT_HP_BLOCKED: false,
    WB_MAX_CURRENT_BATTERY_AUTO: false,
    WB_HP_PRIORITY: false,
    HP_SOC_STOP_UTILITY: 0,
    SP_PRICE_PERIOD: (0, $6uJ19.SpotPricePeriod)['15M'],
    SP_HOURS_PRICE_TOMORROW: [
        ...$a4af54c3cd000569$var$spotHoursPriceTomorrow
    ],
    SP_HOURS_PRICE_WITH_DISTRIBUTION_TOMORROW: $a4af54c3cd000569$var$withDistribution60M($a4af54c3cd000569$var$spotHoursPriceTomorrow),
    SP_HOURS_PRICE_TOMORROW_DATE: $a4af54c3cd000569$var$isoTomorrow,
    SP_15M_PRICE: [
        ...$a4af54c3cd000569$var$spot15MPrice
    ],
    SP_15M_PRICE_TOMORROW: [
        ...$a4af54c3cd000569$var$spot15MPriceTomorrow
    ],
    SP_15M_PRICE_WITH_DISTRIBUTION_TOMORROW: $a4af54c3cd000569$var$withDistribution15M($a4af54c3cd000569$var$spot15MPriceTomorrow),
    SP_15M_PRICE_TOMORROW_DATE: $a4af54c3cd000569$var$isoTomorrow,
    HW_SHELLIES: false,
    HW_SHELLIES_ID: '',
    PV_ACTIVE_POWER_CONTROL: false,
    PV_ACTIVE_POWER_NOMINAL: 5,
    TOWN_CODE: 554782,
    BEZ_DODAVATELE_API_ENABLED: false,
    OFFSET_FOR_NOT_OVERFLOW: 90,
    OFFSET_FOR_OVERFLOW: 30,
    DEV_GOODWE_NEXT_VISIBLE: false,
    DEV_SOLAX_NEXT_VISIBLE: false,
    DEV_VERTO_VISIBLE: false,
    LEGACY_INVERTERS: false,
    DEV_HOME_CONSUMPTION_GRAPH: false,
    NOTIF_SPOT_NEGATIVE_ENABLE: false,
    NOTIF_UTILITY_LOSS_ENABLE: false,
    NOTIF_PV_PRODUCTION_MWH_ENABLE: false,
    NOTIF_INVERTER_DISCONNECTED_ENABLE: false,
    NOTIF_HEAT_WATER_MAX_TEMP_ENABLE: false,
    NOTIF_WALLBOX_CHARGING_ENABLE: false,
    NOTIF_LIMIT_HOME_ENABLE: false,
    NOTIF_LIMIT_HOME_VALUE: 10,
    NOTIF_LIMIT_HEAT_WATER_ENABLE: false,
    NOTIF_LIMIT_HEAT_WATER_VALUE: 6,
    NOTIF_LIMIT_HEAT_PUMP_ENABLE: false,
    NOTIF_LIMIT_HEAT_PUMP_VALUE: 10,
    NOTIF_LIMIT_WALLBOX_ENABLE: false,
    NOTIF_LIMIT_WALLBOX_VALUE: 10,
    NOTIF_SPOT_DISCHARGING_BATTERY_ENABLE: false,
    NOTIF_SPOT_CHARGING_BATTERY_ENABLE: false,
    NOTIF_SPOT_DAILY_SUMMARY_ENABLE: false,
    NOTIF_SPOT_DAILY_PREDICTION_ENABLE: false,
    NOTIF_BATTERY_MAX_SOC_ENABLE: false,
    NOTIF_BATTERY_MAX_SOC_VALUE: 90,
    NOTIF_BATTERY_MIN_SOC_ENABLE: false,
    NOTIF_BATTERY_MIN_SOC_VALUE: 10,
    PREMIUM_BANNER_HIDDEN_PERMANENTLY: false,
    PREMIUM_BANNER_HIDDEN_AT: undefined,
    DEV_PREMIUM_OVERRIDE: undefined,
    OFFSET_ON_GRID: 10,
    WB_MODE_NONE_HDO: false,
    SP_15M_PRICE_WITH_DISTRIBUTION: $a4af54c3cd000569$var$withDistribution15M($a4af54c3cd000569$var$spot15MPrice),
    SP_PRICE_HYSTERESIS: 0.15,
    SOLIDSUN_KZ_API_ENABLED: false,
    SOLIDSUN_OP_NUMBER: '',
    SP_REGION: (0, $6uJ19.SpotRegion).CZ,
    CURRENCY: (0, $6uJ19.Currency).CZK,
    PV_OFFSET_SOC_HP_PRIO: 85,
    INITIAL_WIZARD_BANNER_HIDDEN_PERMANENTLY: false,
    EMS: false,
    PV_INSTALL_V1: true,
    SP_INSTALL_V1: true,
    PL_INSTALL_V1: true,
    HW_INSTALL_V1: true,
    WB_INSTALL_V1: true,
    HP_ENABLED_V1: true,
    // 15M battery discharge table (96 quarters) - discharge blocked at Low price (SP_BATTERY_STOP_DISCHARGE_LOW_PRICE=true)
    SP_BATTERY_DISCHARGE_TABLE_15M: [
        // 00:00-05:59 (indices 0-23) - Mid prices, discharge allowed
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 06:00-08:59 (indices 24-35) - Hi prices, discharge allowed
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 09:00-09:59 (indices 36-39) - Mixed, slot 39 is Low
        true,
        true,
        true,
        false,
        // 10:00-11:29 (indices 40-45) - Mid prices
        true,
        true,
        true,
        true,
        true,
        true,
        // 11:30-14:59 (indices 46-59) - Low prices, discharge blocked
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        // 15:00-15:29 (indices 60-61) - Low still
        false,
        false,
        // 15:30-17:14 (indices 62-68) - Mid prices, discharge allowed
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 17:15-20:44 (indices 69-82) - Hi prices, discharge allowed
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 20:45-23:44 (indices 83-94) - Mid prices, discharge allowed
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 23:45-23:59 (index 95) - Low
        false
    ],
    // 15M battery grid charge table (96 quarters) - cheapest window ~11:45-14:15
    SP_BATTERY_GRID_CHARGE_TABLE_15M: [
        // 00:00-11:44 (indices 0-46) - not in charge window
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        // 11:45-14:00 (indices 47-56) - cheapest window, charge from grid
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 14:15-23:59 (indices 57-95)
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    // 15M battery grid discharge table (96 quarters) - most expensive window after 15:00, only if price > 5.0
    SP_BATTERY_GRID_DISCHARGE_TABLE_15M: [
        // 00:00-18:44 (indices 0-74) - not in discharge window or price too low
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        // 18:45-19:29 (indices 75-77) - peak prices >5 CZK, discharge to grid
        true,
        true,
        true,
        // 19:30-23:59 (indices 78-95)
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    // 15M overflow table (96 quarters) - all prices above SP_PRICE_OFFSET_OVERFLOW (0.5 CZK)
    SP_OVERFLOW_15M_TABLE: [
        // All 15M prices are ≥1.47 CZK, well above 0.5 threshold → always allow overflow
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        true
    ],
    // 15M hot water grid heat table (96 quarters) - cheapest 8 quarters before 19:00
    SP_HW_GRID_HEAT_TABLE_15M: [
        // 00:00-12:29 (indices 0-49) - not in cheapest slots
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        // 12:30-14:00 (indices 50-56) - cheapest slots for HW heating
        true,
        true,
        true,
        true,
        true,
        true,
        true,
        // 14:15 (index 57)
        false,
        false,
        false,
        // 15:00 (index 60) - another cheap slot
        true,
        // 15:15-23:59 (indices 61-95) - not cheapest
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ],
    // 15M price level table (96 quarters) - with hysteresis (Low<1.85, Mid, Hi>2.95)
    SP_PRICE_15M_LEVEL: [
        // 00:00-05:59 (indices 0-23) - Mid range prices ~2.0-2.3
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 06:00-06:29 (indices 24-25) - rising, still Mid
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 06:30-08:59 (indices 26-35) - Hi prices (3.3-4.8)
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 09:00-09:44 (indices 36-38) - dropping
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 09:45 (index 39) - 1.80, drops to Low
        (0, $8ni7a.SpotPriceLevel).Low,
        // 10:00-10:14 (indices 40-41) - 2.48/2.43, back to Mid
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 10:15-10:59 (indices 42-43) - Mid
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 11:00-11:29 (indices 44-45) - Mid
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 11:30-14:59 (indices 46-59) - Low prices (1.47-1.81)
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        // 15:00-15:29 (indices 60-61) - still Low (1.58, 1.89)
        (0, $8ni7a.SpotPriceLevel).Low,
        (0, $8ni7a.SpotPriceLevel).Low,
        // 15:30-17:14 (indices 62-68) - Mid (2.19-2.56)
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 17:15-20:44 (indices 69-82) - Hi prices (2.66-5.70)
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        (0, $8ni7a.SpotPriceLevel).Hi,
        // 20:45-23:44 (indices 83-94) - Mid prices (2.22-2.79)
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        (0, $8ni7a.SpotPriceLevel).Mid,
        // 23:45-23:59 (index 95) - Low (1.68)
        (0, $8ni7a.SpotPriceLevel).Low
    ]
};

});
parcelRegister("bK8XO", function(module, exports) {

$parcel$export(module.exports, "getNetworkCapabilities", () => $7ef0fca6d05f360d$export$df0bb3f71ddfd311);

var $8ni7a = parcelRequire("8ni7a");
function $7ef0fca6d05f360d$export$df0bb3f71ddfd311(board) {
    const managed = board === (0, $8ni7a.Board).V2 || board === (0, $8ni7a.Board).Play;
    const hostWan = managed || board === (0, $8ni7a.Board).SunBerry;
    return {
        managedNetwork: managed,
        wanAddress: hostWan ? 'host' : board === (0, $8ni7a.Board).V1 ? 'mikrotik' : false,
        wanMac: hostWan,
        internalNetwork: managed || board === (0, $8ni7a.Board).V1
    };
}

});




parcelRegister("9iEAl", function(module, exports) {

$parcel$export(module.exports, "ControlBox", () => $b43a8059350b1e2c$export$a72b869850756453);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $bCDrB = parcelRequire("bCDrB");
const $b43a8059350b1e2c$export$a72b869850756453 = ({ title: title, subtitle: subtitle, fullWidth: fullWidth, size: size = 'normal', visibility: visibility, control: control, ...props })=>{
    if (!(0, $bCDrB.useVisibility)(visibility)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        ...props,
        sx: {
            height: size === 'tall' ? 100 : 'auto',
            width: fullWidth ? '100%' : 240,
            minWidth: fullWidth ? '100%' : 240,
            display: 'flex',
            flexDirection: 'column',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                direction: "row",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        sx: {
                            mr: 'auto'
                        },
                        children: title
                    }),
                    control
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h5",
                sx: {
                    mt: size === 'tall' ? 'auto' : 0,
                    color: 'primary.main'
                },
                children: subtitle
            })
        ]
    });
};

});

parcelRegister("5R532", function(module, exports) {

$parcel$export(module.exports, "Row", () => $1381ccd1142c98c0$export$b59bdbef9ce70de2);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ngrp2 = parcelRequire("ngrp2");
const $1381ccd1142c98c0$export$b59bdbef9ce70de2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
        direction: "row",
        alignItems: "center",
        ...props,
        ref: ref,
        children: props.children
    });
});
$1381ccd1142c98c0$export$b59bdbef9ce70de2.displayName = 'Row';

});

parcelRegister("8BMis", function(module, exports) {

$parcel$export(module.exports, "InverterWizard", () => $337ccc623d0210cd$export$c4c6daa80a616aad);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $1sDFO = parcelRequire("1sDFO");
var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $91vj1 = parcelRequire("91vj1");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $js9Z9 = parcelRequire("js9Z9");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");

var $iH29s = parcelRequire("iH29s");

var $2lSXC = parcelRequire("2lSXC");

var $8ni7a = parcelRequire("8ni7a");

var $72ymL = parcelRequire("72ymL");

var $1jRjh = parcelRequire("1jRjh");

var $aky4s = parcelRequire("aky4s");

var $8Ivki = parcelRequire("8Ivki");

var $3iuBa = parcelRequire("3iuBa");

var $fMVHp = parcelRequire("fMVHp");

var $5uhCp = parcelRequire("5uhCp");
var $NDEo7 = parcelRequire("NDEo7");
const $337ccc623d0210cd$var$invertersRequiringNominalPower = [
    (0, $8ni7a.Inverter).SolarEdgeGrid,
    (0, $8ni7a.Inverter).GoodWeGridNext,
    (0, $8ni7a.Inverter).SolaxMICGrid
];
const $337ccc623d0210cd$export$c4c6daa80a616aad = ({ open: open, onClose: onClose })=>{
    const [board, inverterConfig] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.BOARD,
            variables.INVERTER_CONFIG
        ]);
    const internalNetworkSupported = (0, $8ni7a.boardsWithInternalNetwork).includes(board);
    const defaultNetworkType = internalNetworkSupported ? (0, $8ni7a.NetworkType).Internal : (0, $8ni7a.NetworkType).External;
    const defaultDeviceIpAddress = internalNetworkSupported ? '100.100.1.100' : undefined;
    const [inverterType, setInverterType] = (0, $acw62.useState)((0, $8ni7a.Inverter).SolaxNext);
    const [connectionType, setConnectionType] = (0, $acw62.useState)((0, $8ni7a.ConnectionType).ModbusTCP);
    const [networkType, setNetworkType] = (0, $acw62.useState)(defaultNetworkType);
    const [multipleInverters, setMultipleInverters] = (0, $acw62.useState)(false);
    const [internalNetworkDevice, setInternalNetworkDevice] = (0, $acw62.useState)();
    const [deviceIpAddress, setDeviceIpAddress] = (0, $acw62.useState)(defaultDeviceIpAddress); // custom network
    const [deviceMac, setDeviceMac] = (0, $acw62.useState)(); // external network
    const [nominalPower, setNominalPower] = (0, $acw62.useState)('');
    const [submitError, setSubmitError] = (0, $acw62.useState)(undefined);
    const [submitErrorDetails, setSubmitErrorDetails] = (0, $acw62.useState)(false);
    const [showValidationErrors, setShowValidationErrors] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setDeviceIpAddress(defaultDeviceIpAddress);
    }, [
        defaultDeviceIpAddress
    ]);
    const wizardDisabledMultipleInvertersOrEMS = Object.keys(inverterConfig).length > 1 || Object.values(inverterConfig).some(({ type: type })=>[
            false
        ].includes(type)); // to be implemented in EMS1000 branch
    const connectionTypeVisible = ![
        (0, $8ni7a.Inverter).None,
        (0, $8ni7a.Inverter).SofarSolarRS485,
        (0, $8ni7a.Inverter).Hes
    ].includes(inverterType);
    const rs485Supported = (0, $8ni7a.invertersSupportingRS485).includes(inverterType);
    const networkTypeSelectVisible = connectionType !== (0, $8ni7a.ConnectionType).RS485 && inverterType !== (0, $8ni7a.Inverter).SofarSolarRS485 && // exception for "only RS485" Sofar
    inverterType !== (0, $8ni7a.Inverter).Hes && // exception for "only RS485" HES
    inverterType !== (0, $8ni7a.Inverter).None;
    const { mutate: mutate, isLoading: isLoading } = (0, $iH29s.trpc).inverter.wizardSubmit.useMutation({
        onMutate () {
            setSubmitError(undefined);
            setSubmitErrorDetails(false);
        },
        onSuccess () {
            onClose();
        },
        onError (error) {
            setSubmitError(error.message);
        }
    });
    const submitDisabled = isLoading || multipleInverters || wizardDisabledMultipleInvertersOrEMS;
    const nominalPowerRequired = $337ccc623d0210cd$var$invertersRequiringNominalPower.includes(inverterType);
    const nominalPowerValue = nominalPower.trim() === '' ? undefined : Number(nominalPower);
    const nominalPowerValid = nominalPowerValue !== undefined && !Number.isNaN(nominalPowerValue);
    const handleSubmit = ()=>{
        setShowValidationErrors(true);
        if (connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && networkType === (0, $8ni7a.NetworkType).Custom && !deviceIpAddress && inverterType !== (0, $8ni7a.Inverter).None) return;
        if (connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && networkType === (0, $8ni7a.NetworkType).Internal && !internalNetworkDevice && inverterType !== (0, $8ni7a.Inverter).None) return;
        if (connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && networkType === (0, $8ni7a.NetworkType).External && !deviceMac && inverterType !== (0, $8ni7a.Inverter).None) return;
        if (nominalPowerRequired && !nominalPowerValid) return;
        mutate({
            inverterType: inverterType,
            connectionType: connectionType,
            networkType: networkType,
            deviceMac: deviceMac,
            deviceIpAddress: deviceIpAddress,
            internalNetworkDevice: internalNetworkDevice,
            nominalPower: nominalPowerRequired ? nominalPowerValue : undefined
        });
    };
    const wizardForm = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2.5,
        sx: {
            py: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $72ymL.InverterTypeSelect), {
                value: inverterType,
                onChange: (type)=>{
                    setInverterType(type);
                    setNominalPower('');
                    setShowValidationErrors(false);
                    if (type === (0, $8ni7a.Inverter).SofarSolarRS485 || type === (0, $8ni7a.Inverter).Hes) return setConnectionType((0, $8ni7a.ConnectionType).RS485);
                    setConnectionType((0, $8ni7a.ConnectionType).ModbusTCP);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fMVHp.InverterParameters), {
                inverterType: inverterType,
                nominalPower: nominalPower,
                onNominalPowerChange: setNominalPower,
                showErrors: showValidationErrors
            }),
            connectionTypeVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1jRjh.ConnectionTypeSelect), {
                value: connectionType,
                onChange: setConnectionType,
                rs485Supported: rs485Supported
            }),
            networkTypeSelectVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aky4s.NetworkTypeSelect), {
                value: networkType,
                onChange: (value)=>{
                    setDeviceMac(undefined);
                    setDeviceIpAddress(defaultDeviceIpAddress);
                    setNetworkType(value);
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                    checked: multipleInverters,
                    onChange: (e)=>setMultipleInverters(e.target.checked)
                }),
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "inverter_wizard.multiple_inverters.label",
                    defaultMessage: "V\xedce st\u0159\xedda\u010D\u016F"
                }),
                sx: {
                    mt: -1
                }
            }),
            connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && !multipleInverters && networkType === (0, $8ni7a.NetworkType).External && networkTypeSelectVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8Ivki.ExternalNetworkHostsScan), {
                value: deviceMac,
                onChange: setDeviceMac
            }),
            connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && !multipleInverters && networkType === (0, $8ni7a.NetworkType).Internal && networkTypeSelectVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3iuBa.InternalNetworkHosts), {
                value: internalNetworkDevice,
                onChange: setInternalNetworkDevice
            }),
            connectionType === (0, $8ni7a.ConnectionType).ModbusTCP && !multipleInverters && networkType === (0, $8ni7a.NetworkType).Custom && networkTypeSelectVisible && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter_wizard.custom_device_ip_address.input",
                            defaultMessage: "IP adresa st\u0159\xedda\u010De"
                        }),
                        value: deviceIpAddress,
                        onChange: (e)=>setDeviceIpAddress(e.target.value),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                        icon: false,
                        color: "warning",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter_wizard.custom_device_ip_address.alert",
                            defaultMessage: "Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa st\u0159\xedda\u010De nebude m\u011Bnit (nap\u0159. kdy\u017E st\u0159\xedda\u010D vyu\u017E\xedv\xe1 adresu z DHCP)."
                        })
                    })
                ]
            }),
            multipleInverters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                    icon: false,
                    color: "warning",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "inverter_wizard.multiple_inverters.alert",
                        defaultMessage: "Pro nastaven\xed v\xedce st\u0159\xedda\u010D\u016F pros\xedm kontaktujte linku podpory. Kontakt najdete v technick\xe9 wiki Infigy."
                    })
                })
            }),
            submitError && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1sDFO.default), {
                severity: "error",
                icon: false,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "inverter_wizard.submit_error",
                        defaultMessage: "Nastala chyba p\u0159i ukl\xe1d\xe1n\xed nastaven\xed st\u0159\xedda\u010De. Zkuste to pros\xedm znovu."
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        size: "small",
                        onClick: ()=>setSubmitErrorDetails((prev)=>!prev),
                        sx: {
                            ml: 0.25
                        },
                        children: submitErrorDetails ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5uhCp.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NDEo7.default), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                        in: submitErrorDetails,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                pt: 2
                            },
                            children: submitError
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "inverter_wizard.title",
                    defaultMessage: "Pr\u016Fvodce p\u0159ipojen\xedm st\u0159\xedda\u010De"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                children: wizardDisabledMultipleInvertersOrEMS ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                    icon: false,
                    color: "warning",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "inverter_wizard.multiple_inverters_or_ems.alert",
                        defaultMessage: "V\xe1\u0161 syst\xe9m ji\u017E obsahuje nastaven\xed pro v\xedce st\u0159\xedda\u010D\u016F nebo EMS. Tento pr\u016Fvodce je ur\u010Den pouze pro nastaven\xed jednoho st\u0159\xedda\u010De. Pro zm\u011Bnu nastaven\xed st\u0159\xedda\u010D\u016F nebo EMS pros\xedm kontaktujte podporu."
                    })
                }) : wizardForm
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter_wizard.cancel",
                            defaultMessage: "Zru\u0161it"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        disabled: submitDisabled,
                        onClick: handleSubmit,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter_wizard.save",
                            defaultMessage: "Ulo\u017Eit"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1sDFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $11072e450c597f96$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3fDLr = parcelRequire("3fDLr");

var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $gc70Y = parcelRequire("gc70Y");

var $3QANG = parcelRequire("3QANG");

var $u24M4 = parcelRequire("u24M4");

var $6RnaS = parcelRequire("6RnaS");

var $hqgPn = parcelRequire("hqgPn");

var $9QX79 = parcelRequire("9QX79");

var $aNBoS = parcelRequire("aNBoS");

var $alqNg = parcelRequire("alqNg");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $11072e450c597f96$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3AM7p.default)(color || severity)}`,
            `${variant}${(0, $3AM7p.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3QANG.getAlertUtilityClass), classes);
};
const $11072e450c597f96$var$AlertRoot = (0, $1Ikg4.default)((0, $gc70Y.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $3AM7p.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $3QANG.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $3QANG.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $11072e450c597f96$var$AlertIcon = (0, $1Ikg4.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $11072e450c597f96$var$AlertMessage = (0, $1Ikg4.default)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $11072e450c597f96$var$AlertAction = (0, $1Ikg4.default)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $11072e450c597f96$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6RnaS.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hqgPn.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9QX79.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aNBoS.default), {
        fontSize: "inherit"
    })
};
const $11072e450c597f96$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $11072e450c597f96$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $11072e450c597f96$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $11072e450c597f96$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $3fDLr.default)('icon', {
        className: classes.icon,
        elementType: $11072e450c597f96$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $3fDLr.default)('message', {
        className: classes.message,
        elementType: $11072e450c597f96$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $3fDLr.default)('action', {
        className: classes.action,
        elementType: $11072e450c597f96$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $3fDLr.default)('closeButton', {
        elementType: (0, $u24M4.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $3fDLr.default)('closeIcon', {
        elementType: (0, $alqNg.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $11072e450c597f96$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $ayMG0.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $11072e450c597f96$export$2e2bcd8739ae039 = $11072e450c597f96$var$Alert;

});
parcelRegister("3QANG", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", () => $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3);
$parcel$export(module.exports, "default", () => $2cd2c63af2aa1e89$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3(slot) {
    return (0, $4Cod0.default)('MuiAlert', slot);
}
const $2cd2c63af2aa1e89$var$alertClasses = (0, $beCSm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $2cd2c63af2aa1e89$export$2e2bcd8739ae039 = $2cd2c63af2aa1e89$var$alertClasses;

});

parcelRegister("6RnaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe9ab3ffea456b8$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $4fe9ab3ffea456b8$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("hqgPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf1eafd8571d91c$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $caf1eafd8571d91c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("9QX79", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c6d34894446252$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $72c6d34894446252$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("aNBoS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcb7ddf91c6cf94$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $7dcb7ddf91c6cf94$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("alqNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7880a6389ac08655$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $7880a6389ac08655$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});


parcelRegister("72ymL", function(module, exports) {

$parcel$export(module.exports, "InverterTypeSelect", () => $b6d6bae0dd34df90$export$bd106f852fbc25e0);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $2lSXC = parcelRequire("2lSXC");
const $b6d6bae0dd34df90$export$bd106f852fbc25e0 = ({ value: value, onChange: onChange })=>{
    const [legacyInverters, boardRS485, license] = (0, $2lSXC.useSelector)((s)=>[
            s.variables.LEGACY_INVERTERS,
            s.variables.BOARD_RS485,
            s.variables.LICENSE
        ]);
    const showLegacyInverters = legacyInverters || value === (0, $8ni7a.Inverter).GoodWeGridNext;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "inverter-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.inverter_type.label",
                    defaultMessage: "St\u0159\xedda\u010D"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                labelId: "inverter-type-label",
                size: "medium",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.inverter_type.label",
                    defaultMessage: "St\u0159\xedda\u010D"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWeNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.good_we",
                            defaultMessage: "GoodWe"
                        })
                    }, (0, $8ni7a.Inverter).GoodWeNext),
                    showLegacyInverters && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).GoodWeGridNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.good_we_grid_next",
                            defaultMessage: "GoodWe s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).GoodWeGridNext),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax",
                            defaultMessage: "Solax"
                        })
                    }, (0, $8ni7a.Inverter).SolaxNext),
                    license === (0, $8ni7a.License).INDUSTRIAL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxEMS1000,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_ems1000",
                            defaultMessage: "Solax EMS1000"
                        })
                    }, (0, $8ni7a.Inverter).SolaxEMS1000),
                    license === (0, $8ni7a.License).INDUSTRIAL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxEMS1000PRO,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_ems1000pro",
                            defaultMessage: "Solax EMS1000PRO"
                        })
                    }, (0, $8ni7a.Inverter).SolaxEMS1000PRO),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxMICGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_mic_grid",
                            defaultMessage: "Solax MIC s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolaxMICGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolaxMEGAGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solax_mega_grid",
                            defaultMessage: "Solax MEGA/FORTH s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolaxMEGAGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Victron,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.victron",
                            defaultMessage: "Victron"
                        })
                    }, (0, $8ni7a.Inverter).Victron),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Solinteg,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solinteg",
                            defaultMessage: "Solinteg"
                        })
                    }, (0, $8ni7a.Inverter).Solinteg),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Deye,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.deye",
                            defaultMessage: "Deye LV"
                        })
                    }, (0, $8ni7a.Inverter).Deye),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).DeyeHV,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.deye_hv",
                            defaultMessage: "Deye HV"
                        })
                    }, (0, $8ni7a.Inverter).DeyeHV),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Wattsonic,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.wattsonic",
                            defaultMessage: "Wattsonic"
                        })
                    }, (0, $8ni7a.Inverter).Wattsonic),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SofarSolarRS485,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sofar_solar_rs485",
                            defaultMessage: "SofarSolar RS485"
                        })
                    }, (0, $8ni7a.Inverter).SofarSolarRS485),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).DesBatteryContainer,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.des_battery_container",
                            defaultMessage: "DES - kontejnerov\xe9 \xfalo\u017Ei\u0161t\u011B"
                        })
                    }, (0, $8ni7a.Inverter).DesBatteryContainer),
                    boardRS485 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Hes,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.hes",
                            defaultMessage: "HES - bateriov\xe9 \xfalo\u017Ei\u0161t\u011B"
                        })
                    }, (0, $8ni7a.Inverter).Hes),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Fronius,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius",
                            defaultMessage: "Fronius SYMO GEN24"
                        })
                    }, (0, $8ni7a.Inverter).Fronius),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).FroniusGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius_grid",
                            defaultMessage: "Fronius SYMO s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).FroniusGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).FroniusVerto,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.fronius_verto",
                            defaultMessage: "Fronius Verto"
                        })
                    }, (0, $8ni7a.Inverter).FroniusVerto),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SmaGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sma_grid",
                            defaultMessage: "SMA s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SmaGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).SolarEdgeGrid,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.solar_edge_grid",
                            defaultMessage: "SolarEdge s\xed\u0165ov\xfd"
                        })
                    }, (0, $8ni7a.Inverter).SolarEdgeGrid),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).Sermatec,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.sermatec",
                            defaultMessage: "Sermatec"
                        })
                    }, (0, $8ni7a.Inverter).Sermatec),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Inverter).None,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter.none",
                            defaultMessage: "\u017D\xe1dn\xfd"
                        })
                    }, (0, $8ni7a.Inverter).None)
                ]
            })
        ]
    });
};

});

parcelRegister("1jRjh", function(module, exports) {

$parcel$export(module.exports, "ConnectionTypeSelect", () => $2fedaccf8f27f8c1$export$2f07416fce94d5f);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $8ni7a = parcelRequire("8ni7a");
const $2fedaccf8f27f8c1$export$2f07416fce94d5f = ({ value: value, onChange: onChange, rs485Supported: rs485Supported })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "connection-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.connection_type",
                    defaultMessage: "P\u0159ipojen\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                labelId: "connection-type-label",
                size: "medium",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.connection_type",
                    defaultMessage: "P\u0159ipojen\xed"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.ConnectionType).ModbusTCP,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.modbus_tcp",
                            defaultMessage: "LAN/WiFi"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.ConnectionType).RS485,
                        disabled: !rs485Supported,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.rs485",
                            defaultMessage: "RS485"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("aky4s", function(module, exports) {

$parcel$export(module.exports, "NetworkTypeSelect", () => $7927922bb3bbe83c$export$609732559c14af26);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
const $7927922bb3bbe83c$export$609732559c14af26 = ({ value: value, onChange: onChange })=>{
    const [board] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.BOARD
        ]);
    const internalNetworkSupported = (0, $8ni7a.boardsWithInternalNetwork).includes(board);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "network-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network_type",
                    defaultMessage: "S\xed\u0165"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                labelId: "network-type-label",
                size: "medium",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network_type",
                    defaultMessage: "S\xed\u0165"
                }),
                children: [
                    internalNetworkSupported && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.NetworkType).Internal,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.network_type.internal",
                            defaultMessage: "Intern\xed s\xed\u0165 Infigy"
                        })
                    }),
                    !internalNetworkSupported && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.NetworkType).External,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.network_type.external",
                            defaultMessage: "M\xedstn\xed s\xed\u0165 (z\xe1kazn\xedka)"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.NetworkType).Custom,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.network_type.custom",
                            defaultMessage: "Ru\u010Dn\xed nastaven\xed adresy"
                        })
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("8Ivki", function(module, exports) {

$parcel$export(module.exports, "ExternalNetworkHostsScan", () => $07fe4484de9659a8$export$afbfedb8396bd06c);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kTmdn = parcelRequire("kTmdn");
const $07fe4484de9659a8$export$afbfedb8396bd06c = ({ value: value, onChange: onChange })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kTmdn.ModbusHostsScan), {
        value: value,
        onSelect: (host)=>onChange(host?.mac)
    });

});
parcelRegister("kTmdn", function(module, exports) {

$parcel$export(module.exports, "ModbusHostsScan", () => $10af2e30ebbb7acb$export$7952b01164d6bd0a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $4mI0b = parcelRequire("4mI0b");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $12gtR = parcelRequire("12gtR");
var $7X4mk = parcelRequire("7X4mk");

var $8jEZ1 = parcelRequire("8jEZ1");
var $drUoC = parcelRequire("drUoC");
var $d2pCU = parcelRequire("d2pCU");

var $iH29s = parcelRequire("iH29s");

var $5tslE = parcelRequire("5tslE");
const $10af2e30ebbb7acb$export$7952b01164d6bd0a = ({ port: port, value: value, onSelect: onSelect, showVendor: showVendor })=>{
    const { mutate: mutate, isLoading: isLoading, data: data, isError: isError } = (0, $iH29s.trpc).network.scanHosts.useMutation();
    const handleScan = ()=>{
        mutate(port ? {
            port: port
        } : {});
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            !isLoading && !data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                onClick: handleScan,
                size: "large",
                variant: "contained",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "inverter_wizard.scan",
                    defaultMessage: "Naj\xedt st\u0159\xedda\u010D na s\xedti"
                })
            }),
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                sx: {
                    alignItems: 'center',
                    my: 2
                },
                gap: 1.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        color: "primary",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "inverter_wizard.scanning",
                            defaultMessage: "Hled\xe1m st\u0159\xedda\u010D na s\xedti"
                        })
                    })
                ]
            }),
            isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                sx: {
                    my: 2,
                    color: 'error.main'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "network.scan.error",
                    defaultMessage: "Skenov\xe1n\xed s\xedt\u011B se nezda\u0159ilo"
                })
            }),
            data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                firstLineBold: true,
                lastColBold: false,
                firstColBold: false,
                tableSx: {
                    '& tr td:first-child': {
                        paddingLeft: 0
                    },
                    '& tr td:last-child': {
                        paddingRight: 0
                    }
                },
                rows: [
                    [
                        'IP adresa',
                        'MAC adresa',
                        ...showVendor ? [
                            "V\xfdrobce"
                        ] : [],
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "inverter_wizard.scan",
                                defaultMessage: "Naj\xedt st\u0159\xedda\u010D na s\xedti"
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                onClick: handleScan,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2pCU.default), {})
                            })
                        }, 3)
                    ],
                    ...data.map((host)=>{
                        const { ipv4: ipv4, mac: mac, vendor: vendor } = host;
                        const selected = Boolean(value) && value === mac;
                        return [
                            ipv4,
                            mac,
                            ...showVendor ? [
                                vendor ?? '---'
                            ] : [],
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drUoC.default), {}),
                                    checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8jEZ1.default), {}),
                                    checked: selected,
                                    onChange: ()=>onSelect(selected ? undefined : host)
                                })
                            }, 3)
                        ];
                    })
                ],
                sx: {
                    py: 0,
                    px: 0
                }
            })
        ]
    });
};

});
parcelRegister("8jEZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $60dfe379c95a55e9$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $60dfe379c95a55e9$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonChecked');

});

parcelRegister("drUoC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca98b13a64a254a$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $9ca98b13a64a254a$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), 'RadioButtonUnchecked');

});

parcelRegister("d2pCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $97df573039475d38$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $97df573039475d38$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');

});

parcelRegister("5tslE", function(module, exports) {

$parcel$export(module.exports, "SimpleTable", () => $08c706648e2263f5$export$3fe48f9151d0ecc2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gc70Y = parcelRequire("gc70Y");
var $kEl45 = parcelRequire("kEl45");
var $aoDit = parcelRequire("aoDit");
var $h14u2 = parcelRequire("h14u2");
var $1a8Bz = parcelRequire("1a8Bz");
var $aP8Ul = parcelRequire("aP8Ul");
var $7X4mk = parcelRequire("7X4mk");

var $fK5g3 = parcelRequire("fK5g3");
const $08c706648e2263f5$export$3fe48f9151d0ecc2 = ({ rows: rows, elevation: elevation, firstColBold: firstColBold, lastColBold: lastColBold, firstLineBold: firstLineBold, sx: sx = {}, title: title, tableSx: tableSx = {}, footer: footer, noPaper: noPaper })=>{
    const visibleRows = rows.filter((0, $fK5g3.notNullish));
    const columnCount = Math.max(1, ...visibleRows.map((row)=>Array.isArray(row) ? row.length : 1));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1a8Bz.default), {
        component: noPaper ? 'div' : (0, $gc70Y.default),
        elevation: elevation || 0,
        sx: {
            py: 2,
            ...sx
        },
        children: [
            title && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                sx: {
                    mb: 2
                },
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kEl45.default), {
                size: "small",
                sx: {
                    ...tableSx
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aoDit.default), {
                    children: visibleRows.map((row, i)=>!Array.isArray(row) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aP8Ul.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h14u2.default), {
                                colSpan: columnCount,
                                sx: {
                                    ...row.sx
                                },
                                children: row.fullWidth
                            })
                        }, i) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aP8Ul.default), {
                            sx: firstLineBold && i === 0 ? {
                                '& td': {
                                    fontWeight: 700
                                }
                            } : {},
                            children: row.map((content, ii)=>{
                                const sx = ii === row.length - 1 ? {
                                    textAlign: 'right',
                                    fontWeight: lastColBold ? 700 : 400
                                } : ii === 0 ? {
                                    fontWeight: firstColBold ? 700 : 400
                                } : {};
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $h14u2.default), {
                                    sx: sx,
                                    children: content
                                }, ii);
                            })
                        }, i))
                })
            }),
            footer
        ]
    });
};

});
parcelRegister("kEl45", function(module, exports) {

$parcel$export(module.exports, "default", () => $f087e22488590525$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $8hAtx = parcelRequire("8hAtx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $8EuzD = parcelRequire("8EuzD");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f087e22488590525$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8EuzD.getTableUtilityClass), classes);
};
const $f087e22488590525$var$TableRoot = (0, $1Ikg4.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $f087e22488590525$var$defaultComponent = 'table';
const $f087e22488590525$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $f087e22488590525$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $f087e22488590525$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8hAtx.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f087e22488590525$var$TableRoot, {
            as: component,
            role: component === $f087e22488590525$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $9QePP.default)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $f087e22488590525$export$2e2bcd8739ae039 = $f087e22488590525$var$Table;

});
parcelRegister("8hAtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c3485b4f38191$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $607c3485b4f38191$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $607c3485b4f38191$export$2e2bcd8739ae039 = $607c3485b4f38191$var$TableContext;

});

parcelRegister("8EuzD", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", () => $64c9c67b6531c050$export$315cb19215f77ce0);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $64c9c67b6531c050$export$315cb19215f77ce0(slot) {
    return (0, $4Cod0.default)('MuiTable', slot);
}
const $64c9c67b6531c050$var$tableClasses = (0, $beCSm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $64c9c67b6531c050$export$2e2bcd8739ae039 = $64c9c67b6531c050$var$tableClasses;

});


parcelRegister("aoDit", function(module, exports) {

$parcel$export(module.exports, "default", () => $791aa0d72f2174bf$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $7HWqc = parcelRequire("7HWqc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $5Pa70 = parcelRequire("5Pa70");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $791aa0d72f2174bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5Pa70.getTableBodyUtilityClass), classes);
};
const $791aa0d72f2174bf$var$TableBodyRoot = (0, $1Ikg4.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $791aa0d72f2174bf$var$tablelvl2 = {
    variant: 'body'
};
const $791aa0d72f2174bf$var$defaultComponent = 'tbody';
const $791aa0d72f2174bf$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $791aa0d72f2174bf$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $791aa0d72f2174bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7HWqc.default).Provider, {
        value: $791aa0d72f2174bf$var$tablelvl2,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($791aa0d72f2174bf$var$TableBodyRoot, {
            className: (0, $9QePP.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $791aa0d72f2174bf$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $791aa0d72f2174bf$export$2e2bcd8739ae039 = $791aa0d72f2174bf$var$TableBody;

});
parcelRegister("7HWqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c9ddddb511cdd6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $59c9ddddb511cdd6$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $59c9ddddb511cdd6$export$2e2bcd8739ae039 = $59c9ddddb511cdd6$var$Tablelvl2Context;

});

parcelRegister("5Pa70", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", () => $43d98f398793ab7d$export$98bd2a9b566ec665);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $43d98f398793ab7d$export$98bd2a9b566ec665(slot) {
    return (0, $4Cod0.default)('MuiTableBody', slot);
}
const $43d98f398793ab7d$var$tableBodyClasses = (0, $beCSm.default)('MuiTableBody', [
    'root'
]);
var $43d98f398793ab7d$export$2e2bcd8739ae039 = $43d98f398793ab7d$var$tableBodyClasses;

});


parcelRegister("h14u2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c63602040c542751$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $8hAtx = parcelRequire("8hAtx");

var $7HWqc = parcelRequire("7HWqc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $1j59r = parcelRequire("1j59r");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c63602040c542751$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $3AM7p.default)(align)}`,
            padding !== 'normal' && `padding${(0, $3AM7p.default)(padding)}`,
            `size${(0, $3AM7p.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1j59r.getTableCellUtilityClass), classes);
};
const $c63602040c542751$var$TableCellRoot = (0, $1Ikg4.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $3AM7p.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $3AM7p.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $1j59r.default).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $c63602040c542751$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $acw62.useContext((0, $8hAtx.default));
    const tablelvl2 = $acw62.useContext((0, $7HWqc.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $c63602040c542751$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c63602040c542751$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $c63602040c542751$export$2e2bcd8739ae039 = $c63602040c542751$var$TableCell;

});
parcelRegister("1j59r", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $0f3b8fb4e961edd5$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $0f3b8fb4e961edd5$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $0f3b8fb4e961edd5$export$33a0f07a16a10b1b(slot) {
    return (0, $4Cod0.default)('MuiTableCell', slot);
}
const $0f3b8fb4e961edd5$var$tableCellClasses = (0, $beCSm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $0f3b8fb4e961edd5$export$2e2bcd8739ae039 = $0f3b8fb4e961edd5$var$tableCellClasses;

});


parcelRegister("1a8Bz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d8d66642fc2c080$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $9WQ8y = parcelRequire("9WQ8y");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0d8d66642fc2c080$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9WQ8y.getTableContainerUtilityClass), classes);
};
const $0d8d66642fc2c080$var$TableContainerRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $0d8d66642fc2c080$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $0d8d66642fc2c080$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0d8d66642fc2c080$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $0d8d66642fc2c080$export$2e2bcd8739ae039 = $0d8d66642fc2c080$var$TableContainer;

});
parcelRegister("9WQ8y", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", () => $73e1f9234e51787e$export$eed427986a7abdf9);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $73e1f9234e51787e$export$eed427986a7abdf9(slot) {
    return (0, $4Cod0.default)('MuiTableContainer', slot);
}
const $73e1f9234e51787e$var$tableContainerClasses = (0, $beCSm.default)('MuiTableContainer', [
    'root'
]);
var $73e1f9234e51787e$export$2e2bcd8739ae039 = $73e1f9234e51787e$var$tableContainerClasses;

});


parcelRegister("aP8Ul", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1593b31b92bf3c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $7HWqc = parcelRequire("7HWqc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $iVkTI = parcelRequire("iVkTI");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7e1593b31b92bf3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $iVkTI.getTableRowUtilityClass), classes);
};
const $7e1593b31b92bf3c$var$TableRowRoot = (0, $1Ikg4.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $iVkTI.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $iVkTI.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $7e1593b31b92bf3c$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $7e1593b31b92bf3c$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $7e1593b31b92bf3c$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $acw62.useContext((0, $7HWqc.default));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $7e1593b31b92bf3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7e1593b31b92bf3c$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        role: component === $7e1593b31b92bf3c$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $7e1593b31b92bf3c$export$2e2bcd8739ae039 = $7e1593b31b92bf3c$var$TableRow;

});
parcelRegister("iVkTI", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", () => $dc6dc2b9872aeb3e$export$ba0a6d6c28940107);
$parcel$export(module.exports, "default", () => $dc6dc2b9872aeb3e$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $dc6dc2b9872aeb3e$export$ba0a6d6c28940107(slot) {
    return (0, $4Cod0.default)('MuiTableRow', slot);
}
const $dc6dc2b9872aeb3e$var$tableRowClasses = (0, $beCSm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $dc6dc2b9872aeb3e$export$2e2bcd8739ae039 = $dc6dc2b9872aeb3e$var$tableRowClasses;

});


parcelRegister("fK5g3", function(module, exports) {

$parcel$export(module.exports, "notNullish", () => $28770b279d7ab5b1$export$aedb69ff3e31596c);
$parcel$export(module.exports, "jsonParseSafe", () => $28770b279d7ab5b1$export$b4ff986ecbd5f7f2);
const $28770b279d7ab5b1$export$aedb69ff3e31596c = (x)=>x !== null && x !== undefined;
const $28770b279d7ab5b1$export$b4ff986ecbd5f7f2 = (text)=>{
    try {
        return JSON.parse(text);
    } catch (err) {
        return;
    }
};

});




parcelRegister("3iuBa", function(module, exports) {

$parcel$export(module.exports, "InternalNetworkHosts", () => $139150984ff826dc$export$f0200ef2a705f955);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i88ph = parcelRequire("i88ph");

var $iH29s = parcelRequire("iH29s");

var $2lSXC = parcelRequire("2lSXC");
const $139150984ff826dc$export$f0200ef2a705f955 = ({ value: value, onChange: onChange })=>{
    const managedNetwork = (0, $2lSXC.useSelector)((s)=>s.variables.NETWORK_CAPABILITIES.managedNetwork);
    const getData = (0, $iH29s.trpc).network.get.useQuery(undefined, {
        refetchInterval: 5000,
        enabled: managedNetwork
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i88ph.NetworkHostsTable), {
        variant: "select",
        value: value,
        onChange: onChange,
        paperSx: {
            p: 0
        },
        getData: getData
    });
};

});
parcelRegister("i88ph", function(module, exports) {

$parcel$export(module.exports, "NetworkHostsTable", () => $a0d1b56c649939ae$export$e0c564d5467b2793);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $jzib7 = parcelRequire("jzib7");
var $4mI0b = parcelRequire("4mI0b");
var $u24M4 = parcelRequire("u24M4");
var $12gtR = parcelRequire("12gtR");
var $7X4mk = parcelRequire("7X4mk");

var $fJkax = parcelRequire("fJkax");
var $2ezFV = parcelRequire("2ezFV");
var $8jEZ1 = parcelRequire("8jEZ1");
var $drUoC = parcelRequire("drUoC");
var $ayNNK = parcelRequire("ayNNK");
var $47i2D = parcelRequire("47i2D");
var $9L1ax = parcelRequire("9L1ax");

var $5R532 = parcelRequire("5R532");

var $5tslE = parcelRequire("5tslE");

var $eFnWR = parcelRequire("eFnWR");

var $2lSXC = parcelRequire("2lSXC");
const $a0d1b56c649939ae$export$e0c564d5467b2793 = ({ variant: variant = 'default', paperSx: paperSx, value: value, onChange: onChange, getData: { data: data, isLoading: isLoading, isError: isError } })=>{
    const [managedNetwork, inverterAddress, inverterConfig, heatPumpAddress] = (0, $2lSXC.useSelector)((s)=>[
            s.variables.NETWORK_CAPABILITIES.managedNetwork,
            s.variables.MODBUS_TEST_ADDRESS,
            s.variables.INVERTER_CONFIG,
            s.variables.HP_ECOONE_API_IP
        ]);
    const { onDhcpHostRemove: onDhcpHostRemove } = (0, $eFnWR.useRemoveDhcpHost)();
    const { onMakeDhcpLeaseStatic: onMakeDhcpLeaseStatic } = (0, $eFnWR.useMakeDhcpLeaseStatic)();
    if (!managedNetwork) return null;
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
        sx: {
            mx: 'auto',
            display: 'block',
            mt: 2,
            mb: 2
        }
    });
    if (isError) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
        variant: "h3",
        sx: {
            textAlign: 'center',
            my: 2,
            color: 'error.main'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "network.summary.error",
            defaultMessage: "Chyba p\u0159i na\u010D\xedt\xe1n\xed"
        })
    });
    if (!data?.summary) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
        rows: [
            [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "network.summary.name",
                    defaultMessage: "Jm\xe9no"
                }, 0),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "network.summary.mac",
                    defaultMessage: "MAC"
                }, 0),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "network.summary.address",
                    defaultMessage: "IP adresa"
                }, 0),
                ''
            ],
            ...Object.entries(data.summary).map(([mac, item])=>{
                if (!item) return [];
                const { dhcpHost: dhcpHost, dhcpLease: dhcpLease, wifiConnected: wifiConnected, neighbor: neighbor } = item;
                const address = dhcpHost?.address ?? dhcpLease?.ip ?? neighbor?.address;
                const isInverter = inverterAddress === address || Object.values(inverterConfig).some((inverter)=>'address' in inverter && inverter.address === address);
                const isHeatPump = heatPumpAddress === address;
                return [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                        gap: 0.25,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: (dhcpHost?.name ?? dhcpLease?.name) || '---'
                            }),
                            wifiConnected ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: `WiFi: ${wifiConnected.txBitrate} - ${wifiConnected.rxBitrate}`,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47i2D.default), {})
                                })
                            }) : dhcpLease ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "network.summary.not_connected",
                                    defaultMessage: "Nen\xed p\u0159ipojeno"
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9L1ax.default), {})
                                })
                            }),
                            isInverter && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "network.summary.inverter",
                                    defaultMessage: "St\u0159\xedda\u010D"
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayNNK.default), {})
                                })
                            }),
                            isHeatPump && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "network.summary.heat_pump",
                                    defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                                }),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fJkax.default), {})
                                })
                            })
                        ]
                    }, 0),
                    mac,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                        gap: 0.25,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: address
                            }),
                            variant === 'default' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                children: dhcpHost ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "network.summary.dhcp_host_exists",
                                        defaultMessage: "Adresa zafixov\xe1na na DHCP. Kliknut\xedm odfixovat."
                                    }),
                                    onClick: ()=>onDhcpHostRemove(dhcpHost.index),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ezFV.default), {
                                            sx: {
                                                color: 'success.main'
                                            }
                                        })
                                    })
                                }) : dhcpLease ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "network.summary.no_dhcp_host",
                                        defaultMessage: "Dynamick\xe1 adresa na DHCP. Kliknut\xedm zafixovat."
                                    }),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                        size: "small",
                                        onClick: ()=>onMakeDhcpLeaseStatic({
                                                address: dhcpLease.ip,
                                                mac: dhcpLease.mac,
                                                name: dhcpLease.name
                                            }),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ezFV.default), {})
                                    })
                                }) : null
                            })
                        ]
                    }, 2),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                        children: variant === 'select' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $drUoC.default), {}),
                            checkedIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8jEZ1.default), {}),
                            checked: (0, $f1q41.isEqual)({
                                mac: mac,
                                ip: address
                            }, value),
                            onChange: ()=>{
                                if (onChange && address) onChange({
                                    mac: mac,
                                    ip: address
                                });
                            }
                        })
                    }, 3)
                ];
            })
        ],
        firstLineBold: true,
        lastColBold: false,
        sx: paperSx
    });
};

});
parcelRegister("fJkax", function(module, exports) {

$parcel$export(module.exports, "default", () => $b73ab423ed14ff20$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b73ab423ed14ff20$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-6.25 4.08c.82.12 1.57.44 2.2.91l-2.2 2.2zm-1.5 0v3.11l-2.2-2.2c.63-.47 1.38-.79 2.2-.91M7.99 9.05l2.2 2.2H7.08c.12-.82.44-1.57.91-2.2m-.91 3.7h3.11l-2.2 2.2c-.47-.63-.79-1.38-.91-2.2m4.17 4.17c-.82-.12-1.57-.44-2.2-.91l2.2-2.2zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m.75 3.92v-3.11l2.2 2.2c-.63.47-1.38.79-2.2.91m3.26-1.97-2.2-2.2h3.11c-.12.82-.44 1.57-.91 2.2m-2.2-3.7 2.2-2.2c.47.64.79 1.39.91 2.2z"
}), 'HeatPump');

});

parcelRegister("2ezFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a088feeeb2e2883$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1a088feeeb2e2883$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    fillRule: "evenodd",
    d: "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3"
}), 'PushPin');

});

parcelRegister("ayNNK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b03b5dfac45c0ed$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7b03b5dfac45c0ed$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3.33 16H11v-3H4zM13 16h7.67L20 13h-7zm8.11 2H13v4h9zM2 22h9v-4H2.89zm9-14h2v3h-2zm4.7644-.7948 1.4143-1.4142L19.3 7.9123l-1.4142 1.4142zm-11.0596.7076 2.1213-2.1213 1.4143 1.4142L6.119 9.327zM3 2h3v2H3zm15 0h3v2h-3zm-6 5c2.76 0 5-2.24 5-5H7c0 2.76 2.24 5 5 5"
}), 'SolarPower');

});

parcelRegister("47i2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ff5cf8820a8ac7e$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $2ff5cf8820a8ac7e$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m1 9 2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9m8 8 3 3 3-3c-1.65-1.66-4.34-1.66-6 0m-4-4 2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13"
}), 'Wifi');

});

parcelRegister("9L1ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $71a968f880237298$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $71a968f880237298$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7zm-4 4c-1.29-1.29-2.84-2.13-4.49-2.56l3.53 3.53zM2 3.05 5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24C7.81 10.89 6.27 11.73 5 13v.01L6.99 15c1.36-1.36 3.14-2.04 4.92-2.06L18.98 20l1.27-1.26L3.29 1.79zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0"
}), 'WifiOff');

});

parcelRegister("eFnWR", function(module, exports) {

$parcel$export(module.exports, "useRemoveDhcpHost", () => $3fed3da8e8f9c158$export$edbf9a3765d4b638);
$parcel$export(module.exports, "useMakeDhcpLeaseStatic", () => $3fed3da8e8f9c158$export$9b82ebcaaee25d2e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $jDfxe = parcelRequire("jDfxe");

var $iH29s = parcelRequire("iH29s");
const $3fed3da8e8f9c158$export$edbf9a3765d4b638 = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const utils = (0, $iH29s.trpc).useContext();
    const { mutateAsync: removeHost } = (0, $iH29s.trpc).removeDhcpHost.useMutation({
        onSuccess () {
            utils.network.get.invalidate();
        }
    });
    const onDhcpHostRemove = (index)=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_hosts.remove.confirm.title",
                defaultMessage: "Opravdu chcete odfixovat adresu DHCP hosta?"
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_hosts.remove.confirm",
                defaultMessage: "Smazat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_hosts.remove.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            return removeHost({
                index: index
            });
        }).catch(()=>{
        // noop
        });
    };
    return {
        onDhcpHostRemove: onDhcpHostRemove
    };
};
const $3fed3da8e8f9c158$export$9b82ebcaaee25d2e = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const utils = (0, $iH29s.trpc).useContext();
    const { mutateAsync: addDhcpHost } = (0, $iH29s.trpc).addDhcpHost.useMutation({
        onSuccess () {
            utils.network.get.invalidate();
        }
    });
    const onMakeDhcpLeaseStatic = ({ address: address, mac: mac, name: name })=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_leases.make_static.confirm.title",
                defaultMessage: "Opravdu chcete zafixovat adresu DHCP hosta?"
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_leases.make_static.confirm",
                defaultMessage: "P\u0159idat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "dhcp_leases.make_static.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            return addDhcpHost({
                address: address,
                mac: mac,
                name: name
            });
        }).catch(()=>{
        // noop
        });
    };
    return {
        onMakeDhcpLeaseStatic: onMakeDhcpLeaseStatic
    };
};

});



parcelRegister("fMVHp", function(module, exports) {

$parcel$export(module.exports, "InverterParameters", () => $74ce75c37fabeb91$export$bb35c3ea34c1f8fa);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $1n3A4 = parcelRequire("1n3A4");
var $kZugz = parcelRequire("kZugz");
const $74ce75c37fabeb91$var$invertersRequiringNominalPower = [
    (0, $8ni7a.Inverter).SolarEdgeGrid,
    (0, $8ni7a.Inverter).GoodWeGridNext,
    (0, $8ni7a.Inverter).SolaxMICGrid
];
const $74ce75c37fabeb91$export$bb35c3ea34c1f8fa = ({ inverterType: inverterType, nominalPower: nominalPower, onNominalPowerChange: onNominalPowerChange, showErrors: showErrors = false })=>{
    if (!$74ce75c37fabeb91$var$invertersRequiringNominalPower.includes(inverterType)) return null;
    const nominalPowerNumber = nominalPower.trim() === '' ? undefined : Number(nominalPower);
    const nominalPowerInvalid = nominalPowerNumber === undefined || Number.isNaN(nominalPowerNumber);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "inverter_wizard.nominal_power",
            defaultMessage: "Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De"
        }),
        type: "number",
        value: nominalPower,
        onChange: (e)=>onNominalPowerChange(e.target.value),
        fullWidth: true,
        required: true,
        error: showErrors && nominalPowerInvalid,
        helperText: showErrors && nominalPowerInvalid ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "inverter_wizard.nominal_power.validation",
            defaultMessage: "Zadejte nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De v kW."
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "inverter_wizard.nominal_power.helper",
            defaultMessage: "Rozsah: 1 a\u017E 100 kW"
        }),
        inputProps: {
            min: 1,
            max: 100,
            step: 1
        },
        InputProps: {
            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1n3A4.default), {
                position: "end",
                children: "kW"
            })
        }
    });
};

});
parcelRegister("1n3A4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ffab78552448ba6$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $3AM7p = parcelRequire("3AM7p");

var $7X4mk = parcelRequire("7X4mk");

var $gVfKL = parcelRequire("gVfKL");

var $4tNJx = parcelRequire("4tNJx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $j9A7b = parcelRequire("j9A7b");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $0ffab78552448ba6$var$_span;
const $0ffab78552448ba6$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $3AM7p.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $0ffab78552448ba6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $3AM7p.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $3AM7p.default)(size)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $j9A7b.getInputAdornmentUtilityClass), classes);
};
const $0ffab78552448ba6$var$InputAdornmentRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $0ffab78552448ba6$var$overridesResolver
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $j9A7b.default).positionStart}&:not(.${(0, $j9A7b.default).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $0ffab78552448ba6$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $0ffab78552448ba6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gVfKL.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0ffab78552448ba6$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $9QePP.default)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $0ffab78552448ba6$var$_span || ($0ffab78552448ba6$var$_span = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $0ffab78552448ba6$export$2e2bcd8739ae039 = $0ffab78552448ba6$var$InputAdornment;

});
parcelRegister("j9A7b", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $df1adf37dbd0f6dd$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $df1adf37dbd0f6dd$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $df1adf37dbd0f6dd$export$4b135a4b3a6c4550(slot) {
    return (0, $4Cod0.default)('MuiInputAdornment', slot);
}
const $df1adf37dbd0f6dd$var$inputAdornmentClasses = (0, $beCSm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $df1adf37dbd0f6dd$export$2e2bcd8739ae039 = $df1adf37dbd0f6dd$var$inputAdornmentClasses;

});



parcelRegister("5uhCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fed6bc25c5eb7cb$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3fed6bc25c5eb7cb$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

});

parcelRegister("NDEo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0953557707017bc5$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0953557707017bc5$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});



parcelRegister("2zDt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
$parcel$export(module.exports, "z", () => $9ee9c7b494d01fc9$export$2e2bcd8739ae039);
var $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($9ee9c7b494d01fc9$export$7debb50ef11d5e0b || ($9ee9c7b494d01fc9$export$7debb50ef11d5e0b = {}));
var $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 || ($9ee9c7b494d01fc9$export$4aa2142c225fd5c7 = {}));
const $9ee9c7b494d01fc9$export$5716da67bfaa244d = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $9ee9c7b494d01fc9$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined;
        case "string":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan : $9ee9c7b494d01fc9$export$5716da67bfaa244d.number;
        case "boolean":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean;
        case "function":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.function;
        case "bigint":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.array;
            if (data === null) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $9ee9c7b494d01fc9$export$5716da67bfaa244d.date;
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.object;
        default:
            return $9ee9c7b494d01fc9$export$5716da67bfaa244d.unknown;
    }
};
const $9ee9c7b494d01fc9$export$5ba560653e4a1035 = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $9ee9c7b494d01fc9$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $9ee9c7b494d01fc9$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$9ee9c7b494d01fc9$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues);
    return error;
};
const $9ee9c7b494d01fc9$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $9ee9c7b494d01fc9$var$overrideErrorMap = $9ee9c7b494d01fc9$export$341b0b6e0a6f5099;
function $9ee9c7b494d01fc9$export$1097a8289cfd22d7(map) {
    $9ee9c7b494d01fc9$var$overrideErrorMap = map;
}
function $9ee9c7b494d01fc9$export$32f27c719778d4c4() {
    return $9ee9c7b494d01fc9$var$overrideErrorMap;
}
const $9ee9c7b494d01fc9$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $9ee9c7b494d01fc9$export$1526d2e05f74572 = [];
function $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $9ee9c7b494d01fc9$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
            $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $9ee9c7b494d01fc9$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $9ee9c7b494d01fc9$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $9ee9c7b494d01fc9$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $9ee9c7b494d01fc9$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $9ee9c7b494d01fc9$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $9ee9c7b494d01fc9$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $9ee9c7b494d01fc9$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($9ee9c7b494d01fc9$var$errorUtil || ($9ee9c7b494d01fc9$var$errorUtil = {}));
class $9ee9c7b494d01fc9$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $9ee9c7b494d01fc9$var$handleResult = (ctx, result)=>{
    if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $9ee9c7b494d01fc9$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $9ee9c7b494d01fc9$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $9ee9c7b494d01fc9$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $9ee9c7b494d01fc9$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            schema: this,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $9ee9c7b494d01fc9$export$66b0c798a395271f({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
            ...$9ee9c7b494d01fc9$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $9ee9c7b494d01fc9$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $9ee9c7b494d01fc9$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $9ee9c7b494d01fc9$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $9ee9c7b494d01fc9$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $9ee9c7b494d01fc9$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $9ee9c7b494d01fc9$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $9ee9c7b494d01fc9$var$emojiRegex;
const $9ee9c7b494d01fc9$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $9ee9c7b494d01fc9$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $9ee9c7b494d01fc9$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $9ee9c7b494d01fc9$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $9ee9c7b494d01fc9$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $9ee9c7b494d01fc9$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $9ee9c7b494d01fc9$export$1230eb29b8d3b502 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$9ee9c7b494d01fc9$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$9ee9c7b494d01fc9$var$emojiRegex) $9ee9c7b494d01fc9$var$emojiRegex = new RegExp($9ee9c7b494d01fc9$var$_emojiRegex, "u");
                if (!$9ee9c7b494d01fc9$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$9ee9c7b494d01fc9$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$9ee9c7b494d01fc9$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$9ee9c7b494d01fc9$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$9ee9c7b494d01fc9$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $9ee9c7b494d01fc9$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$9ee9c7b494d01fc9$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_string,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$9ee9c7b494d01fc9$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $9ee9c7b494d01fc9$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$1230eb29b8d3b502({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $9ee9c7b494d01fc9$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $9ee9c7b494d01fc9$export$5b070a55c0c43e09 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($9ee9c7b494d01fc9$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$5b070a55c0c43e09({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$67d741fd70ff98f4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $9ee9c7b494d01fc9$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $9ee9c7b494d01fc9$export$67d741fd70ff98f4({
        checks: [],
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$723d146f80596191 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$723d146f80596191.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$723d146f80596191({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e974be33bdc55521 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_date
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const status = new $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$9ee9c7b494d01fc9$export$e974be33bdc55521.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDate,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bcc3b40f6b638044 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$bcc3b40f6b638044.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$bcc3b40f6b638044({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSymbol,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$4e780e961c30340d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$4e780e961c30340d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$4e780e961c30340d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUndefined,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a96281f914484f2d extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$a96281f914484f2d.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$a96281f914484f2d({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNull,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodAny,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$ef3b1bb1630977ae extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$ef3b1bb1630977ae({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnknown,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
            code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
            expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
    }
}
$9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNever,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7d39f5df85f21031 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
}
$9ee9c7b494d01fc9$export$7d39f5df85f21031.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$7d39f5df85f21031({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodVoid,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7acfc3e64785411 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big : $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$7acfc3e64785411.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodArray,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$deepPartialify(schema) {
    if (schema instanceof $9ee9c7b494d01fc9$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(fieldSchema));
        }
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $9ee9c7b494d01fc9$export$7acfc3e64785411) return new $9ee9c7b494d01fc9$export$7acfc3e64785411({
        ...schema._def,
        type: $9ee9c7b494d01fc9$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8) return $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$aaac0b8b429cef5) return $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create($9ee9c7b494d01fc9$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3) return $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$9ee9c7b494d01fc9$var$deepPartialify(item)));
    else return schema;
}
class $9ee9c7b494d01fc9$export$736315c5b55efbad extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                        code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $9ee9c7b494d01fc9$var$errorUtil.errToObj;
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $9ee9c7b494d01fc9$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $9ee9c7b494d01fc9$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $9ee9c7b494d01fc9$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $9ee9c7b494d01fc9$var$createZodEnum($9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$9ee9c7b494d01fc9$export$736315c5b55efbad.create = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $9ee9c7b494d01fc9$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create(),
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodObject,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a8b236cb5070a311 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(result.ctx.common.issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $9ee9c7b494d01fc9$export$f98dac4b251ab333(issues));
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$9ee9c7b494d01fc9$export$a8b236cb5070a311.create = (types, params)=>{
    return new $9ee9c7b494d01fc9$export$a8b236cb5070a311({
        options: types,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodUnion,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $9ee9c7b494d01fc9$var$getDiscriminator = (type)=>{
    if (type instanceof $9ee9c7b494d01fc9$export$378d0cfce37406e6) return $9ee9c7b494d01fc9$var$getDiscriminator(type.schema);
    else if (type instanceof $9ee9c7b494d01fc9$export$a60af00cc0ce2582) return $9ee9c7b494d01fc9$var$getDiscriminator(type.innerType());
    else if (type instanceof $9ee9c7b494d01fc9$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $9ee9c7b494d01fc9$export$bb19b37874861e7e) return $9ee9c7b494d01fc9$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $9ee9c7b494d01fc9$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $9ee9c7b494d01fc9$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $9ee9c7b494d01fc9$export$5ef2424805ac76a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $9ee9c7b494d01fc9$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $9ee9c7b494d01fc9$export$5ef2424805ac76a3({
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
function $9ee9c7b494d01fc9$var$mergeValues(a, b) {
    const aType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(a);
    const bType = $9ee9c7b494d01fc9$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
        const bKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $9ee9c7b494d01fc9$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && bType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $9ee9c7b494d01fc9$export$c02deaf0bb5203d4 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($9ee9c7b494d01fc9$export$afa861e3c5730743(parsedLeft) || $9ee9c7b494d01fc9$export$afa861e3c5730743(parsedRight)) return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            const merged = $9ee9c7b494d01fc9$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            }
            if ($9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedLeft) || $9ee9c7b494d01fc9$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $9ee9c7b494d01fc9$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodIntersection,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.array) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a2acc09968cb4b7f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.object) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $9ee9c7b494d01fc9$export$19342e026b58ebb7) return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(third)
        });
        return new $9ee9c7b494d01fc9$export$a2acc09968cb4b7f({
            keyType: $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodRecord,
            ...$9ee9c7b494d01fc9$var$processCreateParams(second)
        });
    }
}
class $9ee9c7b494d01fc9$export$163b6a2b712d9542 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.map) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$9ee9c7b494d01fc9$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodMap,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$977057706f816712 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.set) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $9ee9c7b494d01fc9$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $9ee9c7b494d01fc9$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $9ee9c7b494d01fc9$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$9ee9c7b494d01fc9$export$977057706f816712.create = (valueType, params)=>{
    return new $9ee9c7b494d01fc9$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodSet,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$d4602ba55673f53c extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.function) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $9ee9c7b494d01fc9$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $9ee9c7b494d01fc9$export$32f27c719778d4c4(),
                    $9ee9c7b494d01fc9$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $9ee9c7b494d01fc9$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $9ee9c7b494d01fc9$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $9ee9c7b494d01fc9$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            args: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create(items).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $9ee9c7b494d01fc9$export$d4602ba55673f53c({
            args: args ? args : $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create([]).rest($9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create()),
            returns: returns || $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create(),
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodFunction,
            ...$9ee9c7b494d01fc9$var$processCreateParams(params)
        });
    }
}
class $9ee9c7b494d01fc9$export$378d0cfce37406e6 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$9ee9c7b494d01fc9$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $9ee9c7b494d01fc9$export$378d0cfce37406e6({
        getter: getter,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLazy,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$7e44096782a165d3 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$9ee9c7b494d01fc9$export$7e44096782a165d3.create = (value, params)=>{
    return new $9ee9c7b494d01fc9$export$7e44096782a165d3({
        value: value,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodLiteral,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
function $9ee9c7b494d01fc9$var$createZodEnum(values, params) {
    return new $9ee9c7b494d01fc9$export$d325d1f0e1c20179({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
}
class $9ee9c7b494d01fc9$export$d325d1f0e1c20179 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$9ee9c7b494d01fc9$export$d325d1f0e1c20179.create = $9ee9c7b494d01fc9$var$createZodEnum;
class $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.string && ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.number) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                expected: $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNativeEnum,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$3f196b0127d6e50a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$9ee9c7b494d01fc9$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $9ee9c7b494d01fc9$export$3f196b0127d6e50a({
        type: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPromise,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$a60af00cc0ce2582 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$9ee9c7b494d01fc9$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $9ee9c7b494d01fc9$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
$9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $9ee9c7b494d01fc9$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodEffects,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aa56fec1e9d629b8 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodOptional,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$aaac0b8b429cef5 extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.null) return $9ee9c7b494d01fc9$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNullable,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$bb19b37874861e7e extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $9ee9c7b494d01fc9$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$bb19b37874861e7e.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$bb19b37874861e7e({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$75a44ec6249ac76b extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $9ee9c7b494d01fc9$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$9ee9c7b494d01fc9$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
class $9ee9c7b494d01fc9$export$26ccfa0145e8511f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $9ee9c7b494d01fc9$export$db7caee60e5d514d(ctx, {
                code: $9ee9c7b494d01fc9$export$5ba560653e4a1035.invalid_type,
                expected: $9ee9c7b494d01fc9$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$9ee9c7b494d01fc9$export$26ccfa0145e8511f.create = (params)=>{
    return new $9ee9c7b494d01fc9$export$26ccfa0145e8511f({
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodNaN,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $9ee9c7b494d01fc9$export$66b0c798a395271f extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $9ee9c7b494d01fc9$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a extends $9ee9c7b494d01fc9$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($9ee9c7b494d01fc9$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$9ee9c7b494d01fc9$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $9ee9c7b494d01fc9$export$558106ce543bd011.ZodReadonly,
        ...$9ee9c7b494d01fc9$var$processCreateParams(params)
    });
};
const $9ee9c7b494d01fc9$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create();
};
const $9ee9c7b494d01fc9$export$1ee8ee30835eab8b = {
    object: $9ee9c7b494d01fc9$export$736315c5b55efbad.lazycreate
};
var $9ee9c7b494d01fc9$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($9ee9c7b494d01fc9$export$558106ce543bd011 || ($9ee9c7b494d01fc9$export$558106ce543bd011 = {}));
const $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$9ee9c7b494d01fc9$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $9ee9c7b494d01fc9$export$22b082955e083ec3 = $9ee9c7b494d01fc9$export$1230eb29b8d3b502.create;
const $9ee9c7b494d01fc9$export$98e628dec113755e = $9ee9c7b494d01fc9$export$5b070a55c0c43e09.create;
const $9ee9c7b494d01fc9$export$9e06de0973666692 = $9ee9c7b494d01fc9$export$26ccfa0145e8511f.create;
const $9ee9c7b494d01fc9$export$a0f65b52274bcc00 = $9ee9c7b494d01fc9$export$67d741fd70ff98f4.create;
const $9ee9c7b494d01fc9$export$4a21f16c33752377 = $9ee9c7b494d01fc9$export$723d146f80596191.create;
const $9ee9c7b494d01fc9$export$324d90190a8b822a = $9ee9c7b494d01fc9$export$e974be33bdc55521.create;
const $9ee9c7b494d01fc9$export$8f701197936bc2a6 = $9ee9c7b494d01fc9$export$bcc3b40f6b638044.create;
const $9ee9c7b494d01fc9$export$1db45310990710a5 = $9ee9c7b494d01fc9$export$4e780e961c30340d.create;
const $9ee9c7b494d01fc9$export$7b1b591b262c240 = $9ee9c7b494d01fc9$export$a96281f914484f2d.create;
const $9ee9c7b494d01fc9$export$4154a199d7d90455 = $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb.create;
const $9ee9c7b494d01fc9$export$19282c40b967aec6 = $9ee9c7b494d01fc9$export$ef3b1bb1630977ae.create;
const $9ee9c7b494d01fc9$export$b3e22bcfd64c1022 = $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5.create;
const $9ee9c7b494d01fc9$export$490e536ee7389aeb = $9ee9c7b494d01fc9$export$7d39f5df85f21031.create;
const $9ee9c7b494d01fc9$export$2f23118c22fb2630 = $9ee9c7b494d01fc9$export$7acfc3e64785411.create;
const $9ee9c7b494d01fc9$export$be5493f9613cbbe = $9ee9c7b494d01fc9$export$736315c5b55efbad.create;
const $9ee9c7b494d01fc9$export$8fb0df5f40d0b477 = $9ee9c7b494d01fc9$export$736315c5b55efbad.strictCreate;
const $9ee9c7b494d01fc9$export$971dd5b0dfd021b6 = $9ee9c7b494d01fc9$export$a8b236cb5070a311.create;
const $9ee9c7b494d01fc9$export$4b888e40c4ee26dd = $9ee9c7b494d01fc9$export$5ef2424805ac76a3.create;
const $9ee9c7b494d01fc9$export$bc86dfbf7795668c = $9ee9c7b494d01fc9$export$c02deaf0bb5203d4.create;
const $9ee9c7b494d01fc9$export$65e3907585753458 = $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3.create;
const $9ee9c7b494d01fc9$export$e5185e241753e543 = $9ee9c7b494d01fc9$export$a2acc09968cb4b7f.create;
const $9ee9c7b494d01fc9$export$871de8747c9eaa88 = $9ee9c7b494d01fc9$export$163b6a2b712d9542.create;
const $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be = $9ee9c7b494d01fc9$export$977057706f816712.create;
const $9ee9c7b494d01fc9$export$44e51c8aac7c2deb = $9ee9c7b494d01fc9$export$d4602ba55673f53c.create;
const $9ee9c7b494d01fc9$export$488013bae63b21da = $9ee9c7b494d01fc9$export$378d0cfce37406e6.create;
const $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0 = $9ee9c7b494d01fc9$export$7e44096782a165d3.create;
const $9ee9c7b494d01fc9$export$78a99c8d44d72635 = $9ee9c7b494d01fc9$export$d325d1f0e1c20179.create;
const $9ee9c7b494d01fc9$export$6fe7eca19ebe5199 = $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56.create;
const $9ee9c7b494d01fc9$export$c957ef27a0ebfd4 = $9ee9c7b494d01fc9$export$3f196b0127d6e50a.create;
const $9ee9c7b494d01fc9$export$dc573d8a6576cdb3 = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.create;
const $9ee9c7b494d01fc9$export$516e28dec6a4b6d4 = $9ee9c7b494d01fc9$export$aa56fec1e9d629b8.create;
const $9ee9c7b494d01fc9$export$133fc36489ac9add = $9ee9c7b494d01fc9$export$aaac0b8b429cef5.create;
const $9ee9c7b494d01fc9$export$fc37fe19dfda43ee = $9ee9c7b494d01fc9$export$a60af00cc0ce2582.createWithPreprocess;
const $9ee9c7b494d01fc9$export$43f28b24e1eb8181 = $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da.create;
const $9ee9c7b494d01fc9$export$3b3d07727c5b702c = ()=>$9ee9c7b494d01fc9$export$22b082955e083ec3().optional();
const $9ee9c7b494d01fc9$export$eb150471a61fced6 = ()=>$9ee9c7b494d01fc9$export$98e628dec113755e().optional();
const $9ee9c7b494d01fc9$export$269251733cdcbbf1 = ()=>$9ee9c7b494d01fc9$export$4a21f16c33752377().optional();
const $9ee9c7b494d01fc9$export$8c14e57e778d3873 = {
    string: (arg)=>$9ee9c7b494d01fc9$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$9ee9c7b494d01fc9$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$9ee9c7b494d01fc9$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$9ee9c7b494d01fc9$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$9ee9c7b494d01fc9$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $9ee9c7b494d01fc9$export$96c94437c95d7862 = $9ee9c7b494d01fc9$export$9a105a556e65c2c0;
var $9ee9c7b494d01fc9$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $9ee9c7b494d01fc9$export$341b0b6e0a6f5099,
    setErrorMap: $9ee9c7b494d01fc9$export$1097a8289cfd22d7,
    getErrorMap: $9ee9c7b494d01fc9$export$32f27c719778d4c4,
    makeIssue: $9ee9c7b494d01fc9$export$244a85fde9c419ed,
    EMPTY_PATH: $9ee9c7b494d01fc9$export$1526d2e05f74572,
    addIssueToContext: $9ee9c7b494d01fc9$export$db7caee60e5d514d,
    ParseStatus: $9ee9c7b494d01fc9$export$5b20a5c3d05c1f6f,
    INVALID: $9ee9c7b494d01fc9$export$9a105a556e65c2c0,
    DIRTY: $9ee9c7b494d01fc9$export$325a211da9693fcf,
    OK: $9ee9c7b494d01fc9$export$c6813a8d51f77eaf,
    isAborted: $9ee9c7b494d01fc9$export$afa861e3c5730743,
    isDirty: $9ee9c7b494d01fc9$export$910b6cdd390341b3,
    isValid: $9ee9c7b494d01fc9$export$1ea939691cdc45b8,
    isAsync: $9ee9c7b494d01fc9$export$aefee5ebe1dcfd9e,
    get util () {
        return $9ee9c7b494d01fc9$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $9ee9c7b494d01fc9$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $9ee9c7b494d01fc9$export$5716da67bfaa244d,
    getParsedType: $9ee9c7b494d01fc9$export$3e9057828ebd5c7a,
    ZodType: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodString: $9ee9c7b494d01fc9$export$1230eb29b8d3b502,
    ZodNumber: $9ee9c7b494d01fc9$export$5b070a55c0c43e09,
    ZodBigInt: $9ee9c7b494d01fc9$export$67d741fd70ff98f4,
    ZodBoolean: $9ee9c7b494d01fc9$export$723d146f80596191,
    ZodDate: $9ee9c7b494d01fc9$export$e974be33bdc55521,
    ZodSymbol: $9ee9c7b494d01fc9$export$bcc3b40f6b638044,
    ZodUndefined: $9ee9c7b494d01fc9$export$4e780e961c30340d,
    ZodNull: $9ee9c7b494d01fc9$export$a96281f914484f2d,
    ZodAny: $9ee9c7b494d01fc9$export$b9d1edb536b4e4eb,
    ZodUnknown: $9ee9c7b494d01fc9$export$ef3b1bb1630977ae,
    ZodNever: $9ee9c7b494d01fc9$export$1e576a20c3ce9fb5,
    ZodVoid: $9ee9c7b494d01fc9$export$7d39f5df85f21031,
    ZodArray: $9ee9c7b494d01fc9$export$7acfc3e64785411,
    ZodObject: $9ee9c7b494d01fc9$export$736315c5b55efbad,
    ZodUnion: $9ee9c7b494d01fc9$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $9ee9c7b494d01fc9$export$5ef2424805ac76a3,
    ZodIntersection: $9ee9c7b494d01fc9$export$c02deaf0bb5203d4,
    ZodTuple: $9ee9c7b494d01fc9$export$e2a18bb771d8e6a3,
    ZodRecord: $9ee9c7b494d01fc9$export$a2acc09968cb4b7f,
    ZodMap: $9ee9c7b494d01fc9$export$163b6a2b712d9542,
    ZodSet: $9ee9c7b494d01fc9$export$977057706f816712,
    ZodFunction: $9ee9c7b494d01fc9$export$d4602ba55673f53c,
    ZodLazy: $9ee9c7b494d01fc9$export$378d0cfce37406e6,
    ZodLiteral: $9ee9c7b494d01fc9$export$7e44096782a165d3,
    ZodEnum: $9ee9c7b494d01fc9$export$d325d1f0e1c20179,
    ZodNativeEnum: $9ee9c7b494d01fc9$export$370b2e8d6d6f5c56,
    ZodPromise: $9ee9c7b494d01fc9$export$3f196b0127d6e50a,
    ZodEffects: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodTransformer: $9ee9c7b494d01fc9$export$a60af00cc0ce2582,
    ZodOptional: $9ee9c7b494d01fc9$export$aa56fec1e9d629b8,
    ZodNullable: $9ee9c7b494d01fc9$export$aaac0b8b429cef5,
    ZodDefault: $9ee9c7b494d01fc9$export$bb19b37874861e7e,
    ZodCatch: $9ee9c7b494d01fc9$export$75a44ec6249ac76b,
    ZodNaN: $9ee9c7b494d01fc9$export$26ccfa0145e8511f,
    BRAND: $9ee9c7b494d01fc9$export$cf2deea74cde46b4,
    ZodBranded: $9ee9c7b494d01fc9$export$66b0c798a395271f,
    ZodPipeline: $9ee9c7b494d01fc9$export$a3c3ef8a0e95c6da,
    ZodReadonly: $9ee9c7b494d01fc9$export$5d1f7ef05c4e493a,
    custom: $9ee9c7b494d01fc9$export$4c00f665f0d4b443,
    Schema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    ZodSchema: $9ee9c7b494d01fc9$export$19342e026b58ebb7,
    late: $9ee9c7b494d01fc9$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $9ee9c7b494d01fc9$export$558106ce543bd011;
    },
    coerce: $9ee9c7b494d01fc9$export$8c14e57e778d3873,
    any: $9ee9c7b494d01fc9$export$4154a199d7d90455,
    array: $9ee9c7b494d01fc9$export$2f23118c22fb2630,
    bigint: $9ee9c7b494d01fc9$export$a0f65b52274bcc00,
    boolean: $9ee9c7b494d01fc9$export$4a21f16c33752377,
    date: $9ee9c7b494d01fc9$export$324d90190a8b822a,
    discriminatedUnion: $9ee9c7b494d01fc9$export$4b888e40c4ee26dd,
    effect: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    'enum': $9ee9c7b494d01fc9$export$78a99c8d44d72635,
    'function': $9ee9c7b494d01fc9$export$44e51c8aac7c2deb,
    'instanceof': $9ee9c7b494d01fc9$export$3d916e7c22dbd8b5,
    intersection: $9ee9c7b494d01fc9$export$bc86dfbf7795668c,
    lazy: $9ee9c7b494d01fc9$export$488013bae63b21da,
    literal: $9ee9c7b494d01fc9$export$c8ec6e1ec9fefcb0,
    map: $9ee9c7b494d01fc9$export$871de8747c9eaa88,
    nan: $9ee9c7b494d01fc9$export$9e06de0973666692,
    nativeEnum: $9ee9c7b494d01fc9$export$6fe7eca19ebe5199,
    never: $9ee9c7b494d01fc9$export$b3e22bcfd64c1022,
    'null': $9ee9c7b494d01fc9$export$7b1b591b262c240,
    nullable: $9ee9c7b494d01fc9$export$133fc36489ac9add,
    number: $9ee9c7b494d01fc9$export$98e628dec113755e,
    object: $9ee9c7b494d01fc9$export$be5493f9613cbbe,
    oboolean: $9ee9c7b494d01fc9$export$269251733cdcbbf1,
    onumber: $9ee9c7b494d01fc9$export$eb150471a61fced6,
    optional: $9ee9c7b494d01fc9$export$516e28dec6a4b6d4,
    ostring: $9ee9c7b494d01fc9$export$3b3d07727c5b702c,
    pipeline: $9ee9c7b494d01fc9$export$43f28b24e1eb8181,
    preprocess: $9ee9c7b494d01fc9$export$fc37fe19dfda43ee,
    promise: $9ee9c7b494d01fc9$export$c957ef27a0ebfd4,
    record: $9ee9c7b494d01fc9$export$e5185e241753e543,
    set: $9ee9c7b494d01fc9$export$adaa4cf7ef1b65be,
    strictObject: $9ee9c7b494d01fc9$export$8fb0df5f40d0b477,
    string: $9ee9c7b494d01fc9$export$22b082955e083ec3,
    symbol: $9ee9c7b494d01fc9$export$8f701197936bc2a6,
    transformer: $9ee9c7b494d01fc9$export$dc573d8a6576cdb3,
    tuple: $9ee9c7b494d01fc9$export$65e3907585753458,
    'undefined': $9ee9c7b494d01fc9$export$1db45310990710a5,
    union: $9ee9c7b494d01fc9$export$971dd5b0dfd021b6,
    unknown: $9ee9c7b494d01fc9$export$19282c40b967aec6,
    'void': $9ee9c7b494d01fc9$export$490e536ee7389aeb,
    NEVER: $9ee9c7b494d01fc9$export$96c94437c95d7862,
    ZodIssueCode: $9ee9c7b494d01fc9$export$5ba560653e4a1035,
    quotelessJson: $9ee9c7b494d01fc9$export$913eddeaf297cfea,
    ZodError: $9ee9c7b494d01fc9$export$f98dac4b251ab333
});

});

parcelRegister("f4Eh3", function(module, exports) {

$parcel$export(module.exports, "add", () => $e3ff25af357d41d7$export$e16d8520af44a096);

var $7S0ew = parcelRequire("7S0ew");

var $5BFw5 = parcelRequire("5BFw5");

var $bXANJ = parcelRequire("bXANJ");

var $9Jots = parcelRequire("9Jots");
function $e3ff25af357d41d7$export$e16d8520af44a096(date, duration) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $9Jots.toDate)(date);
    const dateWithMonths = months || years ? (0, $5BFw5.addMonths)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $7S0ew.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    const finalDate = (0, $bXANJ.constructFrom)(date, dateWithDays.getTime() + msToAdd);
    return finalDate;
}
var // Fallback for modularized imports:
$e3ff25af357d41d7$export$2e2bcd8739ae039 = $e3ff25af357d41d7$export$e16d8520af44a096;

});
parcelRegister("7S0ew", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $43c6d634ecd98fac$export$dd412b56f1e4d8aa);

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $43c6d634ecd98fac$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $9Jots.toDate)(date);
    if (isNaN(amount)) return (0, $bXANJ.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$43c6d634ecd98fac$export$2e2bcd8739ae039 = $43c6d634ecd98fac$export$dd412b56f1e4d8aa;

});
parcelRegister("bXANJ", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $9e6f0c9ad494c17a$export$ead8a1812b171991);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $9e6f0c9ad494c17a$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$9e6f0c9ad494c17a$export$2e2bcd8739ae039 = $9e6f0c9ad494c17a$export$ead8a1812b171991;

});


parcelRegister("5BFw5", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $99f40034f45b9aea$export$17c93e242b2d3a22);

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $99f40034f45b9aea$export$17c93e242b2d3a22(date, amount) {
    const _date = (0, $9Jots.toDate)(date);
    if (isNaN(amount)) return (0, $bXANJ.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $bXANJ.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$99f40034f45b9aea$export$2e2bcd8739ae039 = $99f40034f45b9aea$export$17c93e242b2d3a22;

});


parcelRegister("2u93q", function(module, exports) {

$parcel$export(module.exports, "fontFamily", () => $db8160037892f54e$export$a5975749f0374264);
$parcel$export(module.exports, "getTypography", () => $db8160037892f54e$export$8e1cf7949e53b977);

var $2zDt6 = parcelRequire("2zDt6");



var $bwB5b = parcelRequire("bwB5b");

var $fK5g3 = parcelRequire("fK5g3");
const $db8160037892f54e$var$mobile = 'sm';
const $db8160037892f54e$var$readabilityMode = $db8160037892f54e$var$getReadabilityMode();
const $db8160037892f54e$export$a5975749f0374264 = '"Poppins", sans-serif';
const $db8160037892f54e$export$8e1cf7949e53b977 = (theme)=>{
    return {
        fontFamily: $db8160037892f54e$export$a5975749f0374264,
        fontSize: 10,
        allVariants: {
            // default
            letterSpacing: '0.025rem'
        },
        h1: {
            fontSize: 20,
            fontWeight: 600,
            lineHeight: '24px',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 24,
                lineHeight: '36px'
            }
        },
        h2: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '20px',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 20,
                lineHeight: '30px'
            }
        },
        h3: {
            // sub headline
            fontSize: $db8160037892f54e$var$readabilityMode === (0, $bwB5b.ReadabilityMode).Large ? 14 : 14,
            fontWeight: 600,
            lineHeight: '22px',
            letterSpacing: '0.005rem',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 16,
                lineHeight: '24px'
            }
        },
        h4: {
            // small sub headline
            fontSize: 12,
            fontWeight: 600,
            lineHeight: '18px',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 16,
                lineHeight: '24px'
            }
        },
        h5: {
            // normal headline
            fontSize: 12,
            lineHeight: '18px',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 14,
                lineHeight: '20px'
            }
        },
        body1: {
            fontSize: $db8160037892f54e$var$readabilityMode === (0, $bwB5b.ReadabilityMode).Large ? 13 : 10,
            lineHeight: '1.5',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 14,
                lineHeight: '20px',
                letterSpacing: '0.005rem'
            }
        },
        body2: {
            // text highlight
            fontSize: $db8160037892f54e$var$readabilityMode === (0, $bwB5b.ReadabilityMode).Large ? 13 : 10,
            fontWeight: 600,
            lineHeight: '1.5',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 14,
                lineHeight: '20px',
                letterSpacing: '0.005rem'
            }
        },
        button: {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: '18px',
            // desktop
            [theme.breakpoints.up($db8160037892f54e$var$mobile)]: {
                fontSize: 14,
                lineHeight: '22px',
                letterSpacing: '0.005rem'
            }
        }
    };
};
function $db8160037892f54e$var$getReadabilityMode() {
    if ('localStorage' in window) {
        const value = localStorage.getItem('readabilityMode');
        const parsed = (0, $2zDt6.z).nativeEnum((0, $bwB5b.ReadabilityMode)).safeParse((0, $fK5g3.jsonParseSafe)(value ?? ''));
        if (parsed.success) return parsed.data;
    }
    return (0, $bwB5b.ReadabilityMode).Default;
}

});
parcelRegister("bwB5b", function(module, exports) {

$parcel$export(module.exports, "ReadabilityMode", () => $2440bf42a9ccfd1d$export$1f3b791264295e46);
var $2440bf42a9ccfd1d$export$1f3b791264295e46 = /*#__PURE__*/ function(ReadabilityMode) {
    ReadabilityMode["Default"] = "default";
    ReadabilityMode["Large"] = "large";
    return ReadabilityMode;
}({});

});


parcelRegister("JYcZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a2e84130921e51$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $aH9IB = parcelRequire("aH9IB");

var $Uq4Et = parcelRequire("Uq4Et");


var $3AM7p = parcelRequire("3AM7p");

var $2TZUE = parcelRequire("2TZUE");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $4wGo0 = parcelRequire("4wGo0");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $08a2e84130921e51$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $3AM7p.default)(size)}`,
            `color${(0, $3AM7p.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $3AM7p.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $3AM7p.default)(color)}`,
            `${variant}${(0, $3AM7p.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $3AM7p.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $3AM7p.default)(size)}`,
            `avatarColor${(0, $3AM7p.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $3AM7p.default)(size)}`,
            `iconColor${(0, $3AM7p.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $3AM7p.default)(size)}`,
            `deleteIconColor${(0, $3AM7p.default)(color)}`,
            `deleteIcon${(0, $3AM7p.default)(variant)}Color${(0, $3AM7p.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4wGo0.getChipUtilityClass), classes);
};
const $08a2e84130921e51$var$ChipRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $4wGo0.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $4wGo0.default).avatar}`]: styles[`avatar${(0, $3AM7p.default)(size)}`]
            },
            {
                [`& .${(0, $4wGo0.default).avatar}`]: styles[`avatarColor${(0, $3AM7p.default)(color)}`]
            },
            {
                [`& .${(0, $4wGo0.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $4wGo0.default).icon}`]: styles[`icon${(0, $3AM7p.default)(size)}`]
            },
            {
                [`& .${(0, $4wGo0.default).icon}`]: styles[`iconColor${(0, $3AM7p.default)(iconColor)}`]
            },
            {
                [`& .${(0, $4wGo0.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $4wGo0.default).deleteIcon}`]: styles[`deleteIcon${(0, $3AM7p.default)(size)}`]
            },
            {
                [`& .${(0, $4wGo0.default).deleteIcon}`]: styles[`deleteIconColor${(0, $3AM7p.default)(color)}`]
            },
            {
                [`& .${(0, $4wGo0.default).deleteIcon}`]: styles[`deleteIcon${(0, $3AM7p.default)(variant)}Color${(0, $3AM7p.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $3AM7p.default)(size)}`],
            styles[`color${(0, $3AM7p.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $3AM7p.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $3AM7p.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $3AM7p.default)(color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $4wGo0.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $4wGo0.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $4wGo0.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $4wGo0.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $4wGo0.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $4wGo0.default).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $4wGo0.default).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $4wGo0.default).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $4wGo0.default).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $4wGo0.default).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $4wGo0.default).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $4wGo0.default).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $4wGo0.default).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $4wGo0.default).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${(0, $4wGo0.default).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $4wGo0.default).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $4wGo0.default).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $4wGo0.default).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $4wGo0.default).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $4wGo0.default).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $4wGo0.default).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $4wGo0.default).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $4wGo0.default).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $4wGo0.default).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${(0, $4wGo0.default).clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${(0, $4wGo0.default).focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${(0, $4wGo0.default).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $08a2e84130921e51$var$ChipLabel = (0, $1Ikg4.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $3AM7p.default)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $08a2e84130921e51$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $08a2e84130921e51$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $Uq4Et.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $08a2e84130921e51$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $08a2e84130921e51$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $2TZUE.default) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $08a2e84130921e51$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $2TZUE.default) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $9QePP.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aH9IB.default), {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $9QePP.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $9QePP.default)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $3fDLr.default)('root', {
        elementType: $08a2e84130921e51$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $3fDLr.default)('label', {
        elementType: $08a2e84130921e51$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $ayMG0.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $08a2e84130921e51$export$2e2bcd8739ae039 = $08a2e84130921e51$var$Chip;

});
parcelRegister("aH9IB", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c95756399850c64$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $7c95756399850c64$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("4wGo0", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", () => $34bb079dc5960b54$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $34bb079dc5960b54$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $34bb079dc5960b54$export$31444911e4ee6fdd(slot) {
    return (0, $4Cod0.default)('MuiChip', slot);
}
const $34bb079dc5960b54$var$chipClasses = (0, $beCSm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $34bb079dc5960b54$export$2e2bcd8739ae039 = $34bb079dc5960b54$var$chipClasses;

});


parcelRegister("mjyu0", function(module, exports) {

$parcel$export(module.exports, "useResponsiveContainerContext", () => $0431397098acacbe$export$4ec9972d4f677af6);
$parcel$export(module.exports, "ResponsiveContainer", () => $0431397098acacbe$export$e60a4704009a0009);

var $9QePP = parcelRequire("9QePP");

var $acw62 = parcelRequire("acw62");

var $jfJlM = parcelRequire("jfJlM");

var $3FiDp = parcelRequire("3FiDp");

var $12Fpa = parcelRequire("12Fpa");

var $4YdE5 = parcelRequire("4YdE5");

var $iMnqX = parcelRequire("iMnqX");
var $0431397098acacbe$var$_excluded = [
    "aspect",
    "initialDimension",
    "width",
    "height",
    "minWidth",
    "minHeight",
    "maxHeight",
    "children",
    "debounce",
    "id",
    "className",
    "onResize",
    "style"
];
function $0431397098acacbe$var$_extends() {
    return $0431397098acacbe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0431397098acacbe$var$_extends.apply(null, arguments);
}
function $0431397098acacbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0431397098acacbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0431397098acacbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0431397098acacbe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0431397098acacbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0431397098acacbe$var$_defineProperty(e, r, t) {
    return (r = $0431397098acacbe$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0431397098acacbe$var$_toPropertyKey(t) {
    var i = $0431397098acacbe$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0431397098acacbe$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0431397098acacbe$var$_slicedToArray(r, e) {
    return $0431397098acacbe$var$_arrayWithHoles(r) || $0431397098acacbe$var$_iterableToArrayLimit(r, e) || $0431397098acacbe$var$_unsupportedIterableToArray(r, e) || $0431397098acacbe$var$_nonIterableRest();
}
function $0431397098acacbe$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0431397098acacbe$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0431397098acacbe$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0431397098acacbe$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0431397098acacbe$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0431397098acacbe$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0431397098acacbe$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $0431397098acacbe$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0431397098acacbe$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0431397098acacbe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0431397098acacbe$var$ResponsiveContainerContext = /*#__PURE__*/ (0, $acw62.createContext)((0, $4YdE5.defaultResponsiveContainerProps).initialDimension);
function $0431397098acacbe$var$isAcceptableSize(size) {
    return (0, $iMnqX.isPositiveNumber)(size.width) && (0, $iMnqX.isPositiveNumber)(size.height);
}
function $0431397098acacbe$var$ResponsiveContainerContextProvider(_ref) {
    var children = _ref.children, width = _ref.width, height = _ref.height;
    var size = (0, $acw62.useMemo)(()=>({
            width: width,
            height: height
        }), [
        width,
        height
    ]);
    if (!$0431397098acacbe$var$isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var $0431397098acacbe$export$4ec9972d4f677af6 = ()=>(0, $acw62.useContext)($0431397098acacbe$var$ResponsiveContainerContext);
var $0431397098acacbe$var$SizeDetectorContainer = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref2, ref)=>{
    var aspect = _ref2.aspect, _ref2$initialDimensio = _ref2.initialDimension, initialDimension = _ref2$initialDimensio === void 0 ? (0, $4YdE5.defaultResponsiveContainerProps).initialDimension : _ref2$initialDimensio, width = _ref2.width, height = _ref2.height, _ref2$minWidth = _ref2.minWidth, minWidth = _ref2$minWidth === void 0 ? (0, $4YdE5.defaultResponsiveContainerProps).minWidth : _ref2$minWidth, minHeight = _ref2.minHeight, maxHeight = _ref2.maxHeight, children = _ref2.children, _ref2$debounce = _ref2.debounce, debounce = _ref2$debounce === void 0 ? (0, $4YdE5.defaultResponsiveContainerProps).debounce : _ref2$debounce, id = _ref2.id, className = _ref2.className, onResize = _ref2.onResize, _ref2$style = _ref2.style, style = _ref2$style === void 0 ? {} : _ref2$style, others = $0431397098acacbe$var$_objectWithoutProperties(_ref2, $0431397098acacbe$var$_excluded);
    var containerRef = (0, $acw62.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, $acw62.useRef)();
    onResizeRef.current = onResize;
    (0, $acw62.useImperativeHandle)(ref, ()=>containerRef.current);
    var _useState = (0, $acw62.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $0431397098acacbe$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, $3FiDp.noop;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var entry = entries[0];
            if (entry == null) return;
            var _entry$contentRect = entry.contentRect, containerWidth = _entry$contentRect.width, containerHeight = _entry$contentRect.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, $jfJlM.throttle)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
    (0, $12Fpa.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var _calculateChartDimens = (0, $4YdE5.calculateChartDimensions)(containerWidth, containerHeight, {
        width: width,
        height: height,
        aspect: aspect,
        maxHeight: maxHeight
    }), calculatedWidth = _calculateChartDimens.calculatedWidth, calculatedHeight = _calculateChartDimens.calculatedHeight;
    (0, $12Fpa.warn)(containerWidth < 0 || containerHeight < 0 || calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ $acw62.createElement("div", $0431397098acacbe$var$_extends({
        id: id ? "".concat(id) : undefined,
        className: (0, $9QePP.clsx)('recharts-responsive-container', className),
        style: $0431397098acacbe$var$_objectSpread($0431397098acacbe$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, others), /*#__PURE__*/ $acw62.createElement("div", {
        style: (0, $4YdE5.getInnerDivStyle)({
            width: width,
            height: height
        })
    }, /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var $0431397098acacbe$export$e60a4704009a0009 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var responsiveContainerContext = $0431397098acacbe$export$4ec9972d4f677af6();
    if ((0, $iMnqX.isPositiveNumber)(responsiveContainerContext.width) && (0, $iMnqX.isPositiveNumber)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var _getDefaultWidthAndHe = (0, $4YdE5.getDefaultWidthAndHeight)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    }), width = _getDefaultWidthAndHe.width, height = _getDefaultWidthAndHe.height;
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var _calculateChartDimens2 = (0, $4YdE5.calculateChartDimensions)(undefined, undefined, {
        width: width,
        height: height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    }), calculatedWidth = _calculateChartDimens2.calculatedWidth, calculatedHeight = _calculateChartDimens2.calculatedHeight;
    if ((0, $3FiDp.isNumber)(calculatedWidth) && (0, $3FiDp.isNumber)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ $acw62.createElement($0431397098acacbe$var$SizeDetectorContainer, $0431397098acacbe$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});

});
parcelRegister("jfJlM", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $c0b5cefaf5627cc3$export$de363e709c412c8a);

var $5OEV1 = parcelRequire("5OEV1");
//#region src/compat/function/throttle.ts
/**
* Creates a throttled function that only invokes the provided function at most once
* per every `throttleMs` milliseconds. Subsequent calls to the throttled function
* within the wait time will not trigger the execution of the original function.
*
* @template F - The type of function.
* @param func - The function to throttle.
* @param throttleMs - The number of milliseconds to throttle executions to.
* @param options - The options object
* @param options.signal - An optional AbortSignal to cancel the throttled function.
* @param options.leading - If `true`, the function will be invoked on the leading edge of the timeout.
* @param options.trailing - If `true`, the function will be invoked on the trailing edge of the timeout.
* @returns A new throttled function that accepts the same parameters as the original function.
*
* @example
* const throttledFunction = throttle(() => {
*   console.log('Function executed');
* }, 1000);
*
* // Will log 'Function executed' immediately
* throttledFunction();
*
* // Will not log anything as it is within the throttle time
* throttledFunction();
*
* // After 1 second
* setTimeout(() => {
*   throttledFunction(); // Will log 'Function executed'
* }, 1000);
*/ function $c0b5cefaf5627cc3$export$de363e709c412c8a(func, throttleMs = 0, options = {}) {
    const { leading: leading = true, trailing: trailing = true } = options;
    return (0, $5OEV1.debounce)(func, throttleMs, {
        leading: leading,
        maxWait: throttleMs,
        trailing: trailing
    });
}

});
parcelRegister("5OEV1", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $2bdccb83d6cee874$export$61fc7d43ac8f84b0);

var $d0mTa = parcelRequire("d0mTa");
//#region src/compat/function/debounce.ts
function $2bdccb83d6cee874$export$61fc7d43ac8f84b0(func, debounceMs = 0, options = {}) {
    if (typeof options !== "object") options = {};
    const { leading: leading = false, trailing: trailing = true, maxWait: maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = "leading";
    if (trailing) edges[1] = "trailing";
    let result = void 0;
    let pendingAt = null;
    const _debounced = (0, $d0mTa.debounce)(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges: edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}

});
parcelRegister("d0mTa", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $417cf59ef9cba5d7$export$61fc7d43ac8f84b0);
//#region src/function/debounce.ts
/**
* Creates a debounced function that delays invoking the provided function until after `debounceMs` milliseconds
* have elapsed since the last time the debounced function was invoked. The debounced function also has a `cancel`
* method to cancel any pending execution.
*
* @template F - The type of function.
* @param func - The function to debounce.
* @param debounceMs - The number of milliseconds to delay.
* @param options - The options object
* @param options.signal - An optional AbortSignal to cancel the debounced function.
* @param options.edges - An optional array specifying whether the function should be invoked on the leading edge, trailing edge, or both.
* @returns A new debounced function with a `cancel` method.
*
* @example
* const debouncedFunction = debounce(() => {
*   console.log('Function executed');
* }, 1000);
*
* // Will log 'Function executed' after 1 second if not called again in that time
* debouncedFunction();
*
* // Will not log anything as the previous call is canceled
* debouncedFunction.cancel();
*
* // With AbortSignal
* const controller = new AbortController();
* const signal = controller.signal;
* const debouncedWithSignal = debounce(() => {
*  console.log('Function executed');
* }, 1000, { signal });
*
* debouncedWithSignal();
*
* // Will cancel the debounced function call
* controller.abort();
*/ function $417cf59ef9cba5d7$export$61fc7d43ac8f84b0(func, debounceMs, { signal: signal, edges: edges } = {}) {
    let pendingThis = void 0;
    let pendingArgs = null;
    const leading = edges != null && edges.includes("leading");
    const trailing = edges == null || edges.includes("trailing");
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = void 0;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = void 0;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener("abort", cancel, {
        once: true
    });
    return debounced;
}

});



parcelRegister("3FiDp", function(module, exports) {

$parcel$export(module.exports, "mathSign", () => $2ab3a7e25c8aba74$export$9d334328eb75e624);
$parcel$export(module.exports, "isNan", () => $2ab3a7e25c8aba74$export$e426a261f3212d7d);
$parcel$export(module.exports, "isPercent", () => $2ab3a7e25c8aba74$export$e50269385c77c348);
$parcel$export(module.exports, "isNumber", () => $2ab3a7e25c8aba74$export$7e4aa119212bc614);
$parcel$export(module.exports, "isNumOrStr", () => $2ab3a7e25c8aba74$export$402a499e1ea44294);
$parcel$export(module.exports, "uniqueId", () => $2ab3a7e25c8aba74$export$8b15d37bc3f197d4);
$parcel$export(module.exports, "getPercentValue", () => $2ab3a7e25c8aba74$export$476354dbf49bdff6);
$parcel$export(module.exports, "hasDuplicate", () => $2ab3a7e25c8aba74$export$732baf6a98f122);
$parcel$export(module.exports, "interpolate", () => $2ab3a7e25c8aba74$export$89e29e4ab65e70a9);
$parcel$export(module.exports, "findEntryInArray", () => $2ab3a7e25c8aba74$export$66950d3869f5cc67);
$parcel$export(module.exports, "isNullish", () => $2ab3a7e25c8aba74$export$b931b78cbb3caf86);
$parcel$export(module.exports, "upperFirst", () => $2ab3a7e25c8aba74$export$3061f22cd819074d);
$parcel$export(module.exports, "isNotNil", () => $2ab3a7e25c8aba74$export$7e515ab5fbd92bef);
$parcel$export(module.exports, "noop", () => $2ab3a7e25c8aba74$export$8793edee2d425525);

var $iqxMM = parcelRequire("iqxMM");

var $erqUX = parcelRequire("erqUX");
var $2ab3a7e25c8aba74$export$9d334328eb75e624 = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $2ab3a7e25c8aba74$export$e426a261f3212d7d = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var $2ab3a7e25c8aba74$export$e50269385c77c348 = (value)=>typeof value === 'string' && value.length > 1 && value.indexOf('%') === value.length - 1;
var $2ab3a7e25c8aba74$export$7e4aa119212bc614 = (value)=>(typeof value === 'number' || value instanceof Number) && !$2ab3a7e25c8aba74$export$e426a261f3212d7d(value);
var $2ab3a7e25c8aba74$export$402a499e1ea44294 = (value)=>$2ab3a7e25c8aba74$export$7e4aa119212bc614(value) || typeof value === 'string';
var $2ab3a7e25c8aba74$var$idCounter = 0;
var $2ab3a7e25c8aba74$export$8b15d37bc3f197d4 = (prefix)=>{
    var id = ++$2ab3a7e25c8aba74$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $2ab3a7e25c8aba74$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$2ab3a7e25c8aba74$export$7e4aa119212bc614(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if ($2ab3a7e25c8aba74$export$e50269385c77c348(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ($2ab3a7e25c8aba74$export$e426a261f3212d7d(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var $2ab3a7e25c8aba74$export$732baf6a98f122 = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[String(ary[i])]) cache[String(ary[i])] = true;
        else return true;
    }
    return false;
};
function $2ab3a7e25c8aba74$export$89e29e4ab65e70a9(start, end, animationElapsedTime) {
    if ($2ab3a7e25c8aba74$export$7e4aa119212bc614(start) && $2ab3a7e25c8aba74$export$7e4aa119212bc614(end)) return (0, $erqUX.round)(start + animationElapsedTime * (end - start));
    return end;
}
function $2ab3a7e25c8aba74$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, $iqxMM.get)(entry, specifiedKey)) === specifiedValue);
}
var $2ab3a7e25c8aba74$export$484982720961754e = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        var _data$i, _data$i2;
        xcurrent = ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.cx) || 0;
        ycurrent = ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.cy) || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $2ab3a7e25c8aba74$export$b931b78cbb3caf86 = (value)=>{
    return value === null || typeof value === 'undefined';
};
var $2ab3a7e25c8aba74$export$3061f22cd819074d = (value)=>{
    if ($2ab3a7e25c8aba74$export$b931b78cbb3caf86(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function $2ab3a7e25c8aba74$export$7e515ab5fbd92bef(value) {
    return value != null;
}
function $2ab3a7e25c8aba74$export$8793edee2d425525() {}

});
parcelRegister("iqxMM", function(module, exports) {

$parcel$export(module.exports, "get", () => $940d3c993e8966b6$export$3988ae62b71be9a3);

var $9SPew = parcelRequire("9SPew");

var $HRXCf = parcelRequire("HRXCf");

var $fjtRE = parcelRequire("fjtRE");

var $hSotO = parcelRequire("hSotO");
//#region src/compat/object/get.ts
/**
* Retrieves the value at a given path from an object. If the resolved value is undefined, the defaultValue is returned instead.
*
* @param object - The object to query.
* @param path - The path of the property to get.
* @param [defaultValue] - The value returned if the resolved value is undefined.
* @returns Returns the resolved value.
*
* @example
* const object = { a: { b: { c: 1 } } };
* get(object, 'a.b.c');
* // => 1
*
* get(object, ['a', 'b', 'c']);
* // => 1
*
* get(object, 'a.b.d', 'default');
* // => 'default'
*/ function $940d3c993e8966b6$export$3988ae62b71be9a3(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case "string":
            {
                if ((0, $9SPew.isUnsafeProperty)(path)) return defaultValue;
                const result = object[path];
                if (result === void 0) {
                    if ((0, $HRXCf.isDeepKey)(path) && !Object.hasOwn(object, path)) return $940d3c993e8966b6$export$3988ae62b71be9a3(object, (0, $hSotO.toPath)(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case "number":
        case "symbol":
            {
                if (typeof path === "number") path = (0, $fjtRE.toKey)(path);
                const result = object[path];
                if (result === void 0) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return $940d3c993e8966b6$var$getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = "-0";
                else path = String(path);
                if ((0, $9SPew.isUnsafeProperty)(path)) return defaultValue;
                const result = object[path];
                if (result === void 0) return defaultValue;
                return result;
            }
    }
}
function $940d3c993e8966b6$var$getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if ((0, $9SPew.isUnsafeProperty)(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === void 0) return defaultValue;
    return current;
}

});
parcelRegister("9SPew", function(module, exports) {

$parcel$export(module.exports, "isUnsafeProperty", () => $6fdacd64d4e689f6$export$1511747d5f3dab08);
//#region src/_internal/isUnsafeProperty.ts
/**
* Checks if a property key is unsafe to access or copy directly.
*
* This function is used in functions like `get`, `unset`, and `merge` to prevent
* prototype pollution attacks by identifying `__proto__`, which modifies the object's
* prototype chain. `constructor` and `prototype` stay accessible here because lodash
* keeps reads of them unrestricted; write paths use `isUnsafeToWriteProperty` instead,
* which also blocks those keys.
*
* @param key - The property key to check
* @returns `true` if the property is unsafe to access directly, `false` otherwise
* @internal
*/ function $6fdacd64d4e689f6$export$1511747d5f3dab08(key) {
    return key === "__proto__";
}

});

parcelRegister("HRXCf", function(module, exports) {

$parcel$export(module.exports, "isDeepKey", () => $cefe50cda6cd1628$export$88ed3a5a87f128f0);
//#region src/compat/_internal/isDeepKey.ts
/** Matches any deep property path. Examples: `a.b`, `a[0]`, `a["b"]` */ const $cefe50cda6cd1628$var$regexIsDeepProp = /\.|(\[(?:[^[\]]*|(["'])(?:(?!\2)[^\\]|\\.)*?\2)\])/;
/**
* Checks if a given key is a deep key.
*
* A deep key is a string that contains a dot (.) or square brackets with a property accessor.
*
* @param {PropertyKey} key - The key to check.
* @returns {boolean} - Returns true if the key is a deep key, otherwise false.
*
* Examples:
*
* isDeepKey('a.b') // true
* isDeepKey('a[b]') // true
* isDeepKey('a') // false
* isDeepKey(123) // false
* isDeepKey('a.b.c') // true
* isDeepKey('a[b][c]') // true
* isDeepKey('a.') // false
* isDeepKey('.a') // false
* isDeepKey('a[b') // false
* isDeepKey('a]b]') // false
* isDeepKey('a][b') // false
* isDeepKey('') // false
* isDeepKey('a[0]') // true
*
*/ function $cefe50cda6cd1628$export$88ed3a5a87f128f0(key) {
    switch(typeof key){
        case "number":
        case "symbol":
            return false;
        case "string":
            if (key === "" || key.startsWith(".") || key.endsWith(".")) return false;
            return $cefe50cda6cd1628$var$regexIsDeepProp.test(key);
        default:
            return false;
    }
}

});

parcelRegister("fjtRE", function(module, exports) {

$parcel$export(module.exports, "toKey", () => $ce97a964bddd572b$export$c0d0115e766e14c3);
//#region src/compat/_internal/toKey.ts
/**
* Converts `value` to a string key if it's not a string or symbol.
*
* @private
* @param {unknown} value The value to inspect.
* @returns {string|symbol} Returns the key.
*/ function $ce97a964bddd572b$export$c0d0115e766e14c3(value) {
    if (typeof value === "string" || typeof value === "symbol") return value;
    if (Object.is(value?.valueOf?.(), -0)) return "-0";
    return String(value);
}

});

parcelRegister("hSotO", function(module, exports) {

$parcel$export(module.exports, "toPath", () => $e950d09f8af551a1$export$440836a238ff8548);

var $fjtRE = parcelRequire("fjtRE");

var $kQJTf = parcelRequire("kQJTf");
//#region src/compat/util/toPath.ts
/**
* Converts a deep key string into an array of path segments.
*
* This function takes a string representing a deep key (e.g., 'a.b.c' or 'a[b][c]') and breaks it down into an array of strings, each representing a segment of the path.
*
* @param deepKey - The deep key string to convert.
* @returns An array of strings, each representing a segment of the path.
*
* Examples:
*
* toPath('a.b.c') // Returns ['a', 'b', 'c']
* toPath('a[b][c]') // Returns ['a', 'b', 'c']
* toPath('.a.b.c') // Returns ['', 'a', 'b', 'c']
* toPath('a["b.c"].d') // Returns ['a', 'b.c', 'd']
* toPath('') // Returns []
* toPath('.a[b].c.d[e]["f.g"].h') // Returns ['', 'a', 'b', 'c', 'd', 'e', 'f.g', 'h']
*/ function $e950d09f8af551a1$export$440836a238ff8548(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map((0, $fjtRE.toKey));
    if (typeof deepKey === "symbol") return [
        deepKey
    ];
    deepKey = (0, $kQJTf.toString)(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = "";
    let quoteChar = "";
    let bracket = false;
    let bracketHadQuote = false;
    const bracketNumberRegex = /^-?\d+(?:\.\d+)?$/;
    if (deepKey.charCodeAt(0) === 46) result.push("");
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === "\\" && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = "";
            else key += char;
        } else if (bracket) {
            if (char === "\"" || char === "'") {
                quoteChar = char;
                bracketHadQuote = true;
            } else if (char === "]") {
                bracket = false;
                if (!bracketHadQuote && key.includes(".") && !bracketNumberRegex.test(key)) {
                    const segments = key.split(".");
                    for(let i = 0; i < segments.length; i++)if (segments[i] !== "") result.push(segments[i]);
                } else result.push(key);
                key = "";
            } else key += char;
        } else if (char === "[") {
            bracket = true;
            bracketHadQuote = false;
            if (key) {
                result.push(key);
                key = "";
            }
        } else if (char === ".") {
            if (key) {
                result.push(key);
                key = "";
            }
            const next = deepKey[index + 1];
            if (next === void 0 || next === ".") result.push("");
        } else key += char;
        index++;
    }
    if (key) result.push(key);
    return result;
}

});
parcelRegister("kQJTf", function(module, exports) {

$parcel$export(module.exports, "toString", () => $0dff09d3b29c73a1$export$f84e8e69fd4488a5);
//#region src/compat/util/toString.ts
/**
* Converts `value` to a string.
*
* An empty string is returned for `null` and `undefined` values.
* The sign of `-0` is preserved.
*
* @param value - The value to convert.
* @returns Returns the converted string.
*
* @example
* toString(null) // returns ''
* toString(undefined) // returns ''
* toString(-0) // returns '-0'
* toString([1, 2, -0]) // returns '1,2,-0'
* toString([Symbol('a'), Symbol('b')]) // returns 'Symbol(a),Symbol(b)'
*/ function $0dff09d3b29c73a1$export$f84e8e69fd4488a5(value) {
    if (value == null) return "";
    return $0dff09d3b29c73a1$var$baseToString(value);
}
function $0dff09d3b29c73a1$var$baseToString(value) {
    if (typeof value === "string") return value;
    if (Array.isArray(value)) return value.map($0dff09d3b29c73a1$var$baseToString).join(",");
    const result = String(value);
    if (result === "0" && Object.is(Number(value), -0)) return "-0";
    return result;
}

});



parcelRegister("erqUX", function(module, exports) {

$parcel$export(module.exports, "round", () => $a838779be6c997fd$export$2077e0241d6afd3c);
$parcel$export(module.exports, "roundTemplateLiteral", () => $a838779be6c997fd$export$f8a24ecc3d6c26c3);
// if you go lower than 3, wild wild things happen during rendering
var $a838779be6c997fd$var$defaultRoundPrecision = 4;
function $a838779be6c997fd$export$2077e0241d6afd3c(num) {
    var roundPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a838779be6c997fd$var$defaultRoundPrecision;
    var factor = 10 ** roundPrecision;
    var rounded = Math.round(num * factor) / factor;
    if (Object.is(rounded, -0)) return 0;
    return rounded;
}
function $a838779be6c997fd$export$f8a24ecc3d6c26c3(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    return strings.reduce((result, string, i)=>{
        var value = values[i - 1];
        if (typeof value === 'string') return result + value + string;
        if (value !== undefined) return result + $a838779be6c997fd$export$2077e0241d6afd3c(value) + string;
        return result + string;
    }, '');
}

});


parcelRegister("12Fpa", function(module, exports) {

$parcel$export(module.exports, "warn", () => $0c26188443d0bc67$export$c106dd0671a0fc2d);
/* eslint no-console: 0 */ var $0c26188443d0bc67$var$isDev = true;
var $0c26188443d0bc67$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($0c26188443d0bc67$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};

});

parcelRegister("4YdE5", function(module, exports) {

$parcel$export(module.exports, "defaultResponsiveContainerProps", () => $39e759c44f5dbc32$export$5beeeca5506dd945);
$parcel$export(module.exports, "calculateChartDimensions", () => $39e759c44f5dbc32$export$83d33ab1950e2a9);
$parcel$export(module.exports, "getInnerDivStyle", () => $39e759c44f5dbc32$export$d36bc8432d8d3f9d);
$parcel$export(module.exports, "getDefaultWidthAndHeight", () => $39e759c44f5dbc32$export$f717eb32fd8d3af5);

var $3FiDp = parcelRequire("3FiDp");
var $39e759c44f5dbc32$export$5beeeca5506dd945 = {
    width: '100%',
    height: '100%',
    debounce: 0,
    minWidth: 0,
    initialDimension: {
        width: -1,
        height: -1
    }
};
var $39e759c44f5dbc32$export$83d33ab1950e2a9 = (containerWidth, containerHeight, props)=>{
    var _props$width = props.width, width = _props$width === void 0 ? $39e759c44f5dbc32$export$5beeeca5506dd945.width : _props$width, _props$height = props.height, height = _props$height === void 0 ? $39e759c44f5dbc32$export$5beeeca5506dd945.height : _props$height, aspect = props.aspect, maxHeight = props.maxHeight;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, $3FiDp.isPercent)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, $3FiDp.isPercent)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth: calculatedWidth,
        calculatedHeight: calculatedHeight
    };
};
var $39e759c44f5dbc32$var$bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var $39e759c44f5dbc32$var$overflowX = {
    width: 0,
    overflowX: 'visible'
};
var $39e759c44f5dbc32$var$overflowY = {
    height: 0,
    overflowY: 'visible'
};
var $39e759c44f5dbc32$var$noStyle = {};
var $39e759c44f5dbc32$export$d36bc8432d8d3f9d = (props)=>{
    var width = props.width, height = props.height;
    var isWidthPercent = (0, $3FiDp.isPercent)(width);
    var isHeightPercent = (0, $3FiDp.isPercent)(height);
    if (isWidthPercent && isHeightPercent) return $39e759c44f5dbc32$var$bothOverflow;
    if (isWidthPercent) return $39e759c44f5dbc32$var$overflowX;
    if (isHeightPercent) return $39e759c44f5dbc32$var$overflowY;
    return $39e759c44f5dbc32$var$noStyle;
};
function $39e759c44f5dbc32$export$f717eb32fd8d3af5(_ref) {
    var width = _ref.width, height = _ref.height, aspect = _ref.aspect;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = $39e759c44f5dbc32$export$5beeeca5506dd945.width;
        calculatedHeight = $39e759c44f5dbc32$export$5beeeca5506dd945.height;
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : $39e759c44f5dbc32$export$5beeeca5506dd945.width;
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : $39e759c44f5dbc32$export$5beeeca5506dd945.height;
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}

});

parcelRegister("iMnqX", function(module, exports) {

$parcel$export(module.exports, "isWellBehavedNumber", () => $dabee322b52312f4$export$f8a8fc612ced9bb0);
$parcel$export(module.exports, "isPositiveNumber", () => $dabee322b52312f4$export$5374bb854d0e41c8);
function $dabee322b52312f4$export$f8a8fc612ced9bb0(n) {
    return Number.isFinite(n);
}
function $dabee322b52312f4$export$5374bb854d0e41c8(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}

});


parcelRegister("hnYfM", function(module, exports) {

$parcel$export(module.exports, "isToday", () => $36d0fca4a40aa9b2$export$629b0a497aa65267);

var $c50C8 = parcelRequire("c50C8");

var $8AHLd = parcelRequire("8AHLd");
function $36d0fca4a40aa9b2$export$629b0a497aa65267(date) {
    return (0, $8AHLd.isSameDay)(date, (0, $c50C8.constructNow)(date));
}
var // Fallback for modularized imports:
$36d0fca4a40aa9b2$export$2e2bcd8739ae039 = $36d0fca4a40aa9b2$export$629b0a497aa65267;

});
parcelRegister("c50C8", function(module, exports) {

$parcel$export(module.exports, "constructNow", () => $a146c3e31d4b204d$export$18c3c6510fb97afc);

var $bXANJ = parcelRequire("bXANJ");
function $a146c3e31d4b204d$export$18c3c6510fb97afc(date) {
    return (0, $bXANJ.constructFrom)(date, Date.now());
}
var // Fallback for modularized imports:
$a146c3e31d4b204d$export$2e2bcd8739ae039 = $a146c3e31d4b204d$export$18c3c6510fb97afc;

});

parcelRegister("8AHLd", function(module, exports) {

$parcel$export(module.exports, "isSameDay", () => $fc0b49ce51db4bd5$export$ea39ec197993aef0);

var $g04kv = parcelRequire("g04kv");
function $fc0b49ce51db4bd5$export$ea39ec197993aef0(dateLeft, dateRight) {
    const dateLeftStartOfDay = (0, $g04kv.startOfDay)(dateLeft);
    const dateRightStartOfDay = (0, $g04kv.startOfDay)(dateRight);
    return +dateLeftStartOfDay === +dateRightStartOfDay;
}
var // Fallback for modularized imports:
$fc0b49ce51db4bd5$export$2e2bcd8739ae039 = $fc0b49ce51db4bd5$export$ea39ec197993aef0;

});


parcelRegister("djmpM", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b0e6fd5d31b1b95$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}

});

parcelRegister("2PduQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ead04f3e1b7da9$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $20ead04f3e1b7da9$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');

});

parcelRegister("cDXfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $934716524eb29958$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $934716524eb29958$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

});

parcelRegister("7EU6W", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $5937cb4c69015f83$export$bf730a2d8bf68b42, (v) => $5937cb4c69015f83$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5937cb4c69015f83$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $dFWNz = parcelRequire("dFWNz");
function $5937cb4c69015f83$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5937cb4c69015f83$var$objectIs = "function" === typeof Object.is ? Object.is : $5937cb4c69015f83$var$is, $5937cb4c69015f83$var$useSyncExternalStore = $dFWNz.useSyncExternalStore, $5937cb4c69015f83$var$useRef = $acw62.useRef, $5937cb4c69015f83$var$useEffect = $acw62.useEffect, $5937cb4c69015f83$var$useMemo = $acw62.useMemo, $5937cb4c69015f83$var$useDebugValue = $acw62.useDebugValue;
$5937cb4c69015f83$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $5937cb4c69015f83$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $5937cb4c69015f83$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($5937cb4c69015f83$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $5937cb4c69015f83$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $5937cb4c69015f83$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $5937cb4c69015f83$var$useDebugValue(value);
    return value;
};

});
parcelRegister("dFWNz", function(module, exports) {
'use strict';

module.exports = (parcelRequire("b0miH"));

});
parcelRegister("b0miH", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $8030fe3dbf47f1d1$export$306c0aa65ff9ec16, (v) => $8030fe3dbf47f1d1$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8030fe3dbf47f1d1$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $8030fe3dbf47f1d1$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8030fe3dbf47f1d1$var$objectIs = "function" === typeof Object.is ? Object.is : $8030fe3dbf47f1d1$var$is, $8030fe3dbf47f1d1$var$useState = $acw62.useState, $8030fe3dbf47f1d1$var$useEffect = $acw62.useEffect, $8030fe3dbf47f1d1$var$useLayoutEffect = $acw62.useLayoutEffect, $8030fe3dbf47f1d1$var$useDebugValue = $acw62.useDebugValue;
function $8030fe3dbf47f1d1$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $8030fe3dbf47f1d1$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $8030fe3dbf47f1d1$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $8030fe3dbf47f1d1$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $8030fe3dbf47f1d1$var$useEffect(function() {
        $8030fe3dbf47f1d1$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $8030fe3dbf47f1d1$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $8030fe3dbf47f1d1$var$useDebugValue(value);
    return value;
}
function $8030fe3dbf47f1d1$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8030fe3dbf47f1d1$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8030fe3dbf47f1d1$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $8030fe3dbf47f1d1$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $8030fe3dbf47f1d1$var$useSyncExternalStore$1 : $8030fe3dbf47f1d1$var$useSyncExternalStore$2;
$8030fe3dbf47f1d1$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $8030fe3dbf47f1d1$var$shim;

});



parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $6b3372b60d35b33f$export$998bcd577473dd93, (v) => $6b3372b60d35b33f$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $6b3372b60d35b33f$export$3d6c20d97e46b957, (v) => $6b3372b60d35b33f$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$998bcd577473dd93;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$3d6c20d97e46b957;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = Symbol.for("react.element"), $6b3372b60d35b33f$var$c = Symbol.for("react.portal"), $6b3372b60d35b33f$var$d = Symbol.for("react.fragment"), $6b3372b60d35b33f$var$e = Symbol.for("react.strict_mode"), $6b3372b60d35b33f$var$f = Symbol.for("react.profiler"), $6b3372b60d35b33f$var$g = Symbol.for("react.provider"), $6b3372b60d35b33f$var$h = Symbol.for("react.context"), $6b3372b60d35b33f$var$k = Symbol.for("react.server_context"), $6b3372b60d35b33f$var$l = Symbol.for("react.forward_ref"), $6b3372b60d35b33f$var$m = Symbol.for("react.suspense"), $6b3372b60d35b33f$var$n = Symbol.for("react.suspense_list"), $6b3372b60d35b33f$var$p = Symbol.for("react.memo"), $6b3372b60d35b33f$var$q = Symbol.for("react.lazy"), $6b3372b60d35b33f$var$t = Symbol.for("react.offscreen"), $6b3372b60d35b33f$var$u;
$6b3372b60d35b33f$var$u = Symbol.for("react.module.reference");
function $6b3372b60d35b33f$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $6b3372b60d35b33f$var$b:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$d:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$h:
                            case $6b3372b60d35b33f$var$l:
                            case $6b3372b60d35b33f$var$q:
                            case $6b3372b60d35b33f$var$p:
                            case $6b3372b60d35b33f$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $6b3372b60d35b33f$var$c:
                return r;
        }
    }
}
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$b;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$q;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$998bcd577473dd93 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$92387174baf9b227 = function() {
    return !1;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = function() {
    return !1;
};
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$b;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$q;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$m;
};
$6b3372b60d35b33f$export$3d6c20d97e46b957 = function(a) {
    return $6b3372b60d35b33f$var$v(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$d || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$n || a === $6b3372b60d35b33f$var$t || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$q || a.$$typeof === $6b3372b60d35b33f$var$p || a.$$typeof === $6b3372b60d35b33f$var$g || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$l || a.$$typeof === $6b3372b60d35b33f$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$v;

});

parcelRegister("bYoiY", function(module, exports) {

$parcel$export(module.exports, "Color", () => Color);
$parcel$export(module.exports, "darker", () => darker);
$parcel$export(module.exports, "brighter", () => brighter);
$parcel$export(module.exports, "default", () => color);
$parcel$export(module.exports, "hslConvert", () => hslConvert);
$parcel$export(module.exports, "Rgb", () => Rgb);
$parcel$export(module.exports, "rgbConvert", () => rgbConvert);
$parcel$export(module.exports, "rgb", () => rgb);
$parcel$export(module.exports, "hsl", () => hsl);

var $bfWFq = parcelRequire("bfWFq");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $bfWFq.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Rgb, rgb, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $bfWFq.default)(Hsl, hsl, (0, $bfWFq.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("bfWFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $831e9a7deaab9d1d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "extend", () => $831e9a7deaab9d1d$export$8b58be045bf06082);
function $831e9a7deaab9d1d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $831e9a7deaab9d1d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("jMohy", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $e66555f2a7e5653b$export$bf730a2d8bf68b42, (v) => $e66555f2a7e5653b$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e66555f2a7e5653b$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $e66555f2a7e5653b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $e66555f2a7e5653b$var$objectIs = "function" === typeof Object.is ? Object.is : $e66555f2a7e5653b$var$is, $e66555f2a7e5653b$var$useSyncExternalStore = $acw62.useSyncExternalStore, $e66555f2a7e5653b$var$useRef = $acw62.useRef, $e66555f2a7e5653b$var$useEffect = $acw62.useEffect, $e66555f2a7e5653b$var$useMemo = $acw62.useMemo, $e66555f2a7e5653b$var$useDebugValue = $acw62.useDebugValue;
$e66555f2a7e5653b$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $e66555f2a7e5653b$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $e66555f2a7e5653b$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($e66555f2a7e5653b$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $e66555f2a7e5653b$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $e66555f2a7e5653b$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $e66555f2a7e5653b$var$useDebugValue(value);
    return value;
};

});

parcelRegister("bIbT7", function(module, exports) {

$parcel$export(module.exports, "arrayTooltipSearcher", () => $886d067545e9f9a0$export$3d996ff386c7802d);
$parcel$export(module.exports, "optionsReducer", () => $886d067545e9f9a0$export$81a3ba457dd82bec);
$parcel$export(module.exports, "createEventEmitter", () => $886d067545e9f9a0$export$abfecd6a8e6070c1);

var $jDald = parcelRequire("jDald");

var $3FiDp = parcelRequire("3FiDp");
var $886d067545e9f9a0$export$3d996ff386c7802d = (data, strIndex)=>{
    if (!strIndex) return undefined;
    if (!Array.isArray(data)) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, $3FiDp.isNan)(numIndex)) return undefined;
    return data[numIndex];
};
var $886d067545e9f9a0$var$initialState = {
    chartName: '',
    tooltipPayloadSearcher: ()=>undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var $886d067545e9f9a0$var$optionsSlice = (0, $jDald.createSlice)({
    name: 'options',
    initialState: $886d067545e9f9a0$var$initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var $886d067545e9f9a0$export$81a3ba457dd82bec = $886d067545e9f9a0$var$optionsSlice.reducer;
var $886d067545e9f9a0$export$abfecd6a8e6070c1 = $886d067545e9f9a0$var$optionsSlice.actions.createEventEmitter;

});
parcelRegister("jDald", function(module, exports) {

$parcel$export(module.exports, "createAction", () => $395a21819ed91e51$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "prepareAutoBatched", () => $395a21819ed91e51$export$39fcd5145ec5e4e2);
$parcel$export(module.exports, "autoBatchEnhancer", () => $395a21819ed91e51$export$676277d7dca0f396);
$parcel$export(module.exports, "configureStore", () => $395a21819ed91e51$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $395a21819ed91e51$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "createListenerMiddleware", () => $395a21819ed91e51$export$1228acebbbcb485b);
$parcel$export(module.exports, "current", () => (parcelRequire("83c4x")).current);
// src/index.ts

var $k62I6 = parcelRequire("k62I6");

var $83c4x = parcelRequire("83c4x");

var $hzYeg = parcelRequire("hzYeg");

var $gP4IM = parcelRequire("gP4IM");
// src/createDraftSafeSelector.ts
var $395a21819ed91e51$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $hzYeg.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $83c4x.isDraft)(value) ? (0, $83c4x.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $395a21819ed91e51$export$a5d3c27355e35910 = /* @__PURE__ */ $395a21819ed91e51$export$aab6de9e3dbb1473((0, $hzYeg.weakMapMemoize));
// src/devtoolsExtension.ts
var $395a21819ed91e51$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $k62I6.compose;
    return (0, $k62I6.compose).apply(null, arguments);
};
var $395a21819ed91e51$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $395a21819ed91e51$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $395a21819ed91e51$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($395a21819ed91e51$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $k62I6.isAction)(action) && action.type === type;
    return actionCreator;
}
function $395a21819ed91e51$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $395a21819ed91e51$var$hasMatchFunction(action);
}
function $395a21819ed91e51$export$ebd532f9034651f3(action) {
    return (0, $k62I6.isAction)(action) && Object.keys(action).every($395a21819ed91e51$var$isValidKey);
}
function $395a21819ed91e51$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $395a21819ed91e51$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $395a21819ed91e51$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $395a21819ed91e51$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $395a21819ed91e51$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $395a21819ed91e51$var$freezeDraftable(val) {
    return (0, $83c4x.isDraftable)(val) ? (0, $83c4x.produce)(val, ()=>{}) : val;
}
function $395a21819ed91e51$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $395a21819ed91e51$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $395a21819ed91e51$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $395a21819ed91e51$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $395a21819ed91e51$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $395a21819ed91e51$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $395a21819ed91e51$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $395a21819ed91e51$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $395a21819ed91e51$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $395a21819ed91e51$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $395a21819ed91e51$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $k62I6.isPlainObject)(val);
}
function $395a21819ed91e51$export$ada5dca0b571bc7(value, path = "", isSerializable = $395a21819ed91e51$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $395a21819ed91e51$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $395a21819ed91e51$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $395a21819ed91e51$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$395a21819ed91e51$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $395a21819ed91e51$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $395a21819ed91e51$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $395a21819ed91e51$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $395a21819ed91e51$export$1908877435b1d5e9();
        if (thunk) {
            if ($395a21819ed91e51$var$isBoolean(thunk)) middlewareArray.push((0, $gP4IM.thunk));
            else middlewareArray.push((0, $gP4IM.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $395a21819ed91e51$export$8fb31c0f05df007b = "RTK_autoBatch";
var $395a21819ed91e51$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$395a21819ed91e51$export$8fb31c0f05df007b]: true
            }
        });
var $395a21819ed91e51$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $395a21819ed91e51$var$createRafWithFallbackTimer = (raf, timeout)=>{
    return (notify)=>{
        let called = false;
        const callback = ()=>{
            if (called) return;
            called = true;
            cancelAnimationFrame(rafId);
            clearTimeout(timerId);
            notify();
        };
        const rafId = raf(callback);
        const timerId = setTimeout(callback, timeout);
    };
};
var $395a21819ed91e51$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? $395a21819ed91e51$var$createRafWithFallbackTimer(window.requestAnimationFrame, 100) : $395a21819ed91e51$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $395a21819ed91e51$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$395a21819ed91e51$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $395a21819ed91e51$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $395a21819ed91e51$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($395a21819ed91e51$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $395a21819ed91e51$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $395a21819ed91e51$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $k62I6.isPlainObject)(reducer)) rootReducer = (0, $k62I6.combineReducers)(reducer);
    else throw new Error($395a21819ed91e51$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $k62I6.compose);
    if (devTools) finalCompose = $395a21819ed91e51$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $k62I6.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $395a21819ed91e51$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $k62I6.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $395a21819ed91e51$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($395a21819ed91e51$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($395a21819ed91e51$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $395a21819ed91e51$var$isStateFunction(x) {
    return typeof x === "function";
}
function $395a21819ed91e51$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $395a21819ed91e51$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($395a21819ed91e51$var$isStateFunction(initialState)) getInitialState = ()=>$395a21819ed91e51$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $395a21819ed91e51$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $83c4x.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $83c4x.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $83c4x.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $395a21819ed91e51$var$matches = (matcher, action)=>{
    if ($395a21819ed91e51$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $395a21819ed91e51$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$395a21819ed91e51$var$matches(matcher, action));
    };
}
function $395a21819ed91e51$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$395a21819ed91e51$var$matches(matcher, action));
    };
}
function $395a21819ed91e51$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $395a21819ed91e51$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $395a21819ed91e51$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$395a21819ed91e51$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$395a21819ed91e51$var$isAsyncThunkArray(asyncThunks)) return $395a21819ed91e51$export$872dec21e9a69476()(asyncThunks[0]);
    return $395a21819ed91e51$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $395a21819ed91e51$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$395a21819ed91e51$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$395a21819ed91e51$var$isAsyncThunkArray(asyncThunks)) return $395a21819ed91e51$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $395a21819ed91e51$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $395a21819ed91e51$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $395a21819ed91e51$export$9dd1fb32974da385($395a21819ed91e51$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$395a21819ed91e51$var$isAsyncThunkArray(asyncThunks)) return $395a21819ed91e51$export$fcc3388fb56de601()(asyncThunks[0]);
    return $395a21819ed91e51$export$9dd1fb32974da385($395a21819ed91e51$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $395a21819ed91e51$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$395a21819ed91e51$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$395a21819ed91e51$var$isAsyncThunkArray(asyncThunks)) return $395a21819ed91e51$export$1da80a6ef1307441()(asyncThunks[0]);
    return $395a21819ed91e51$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $395a21819ed91e51$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$395a21819ed91e51$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$395a21819ed91e51$var$isAsyncThunkArray(asyncThunks)) return $395a21819ed91e51$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $395a21819ed91e51$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $395a21819ed91e51$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $395a21819ed91e51$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $395a21819ed91e51$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $395a21819ed91e51$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $395a21819ed91e51$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    payload;
    meta;
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $395a21819ed91e51$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    payload;
    meta;
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $395a21819ed91e51$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $395a21819ed91e51$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $395a21819ed91e51$var$externalAbortMessage = "External signal was aborted";
var $395a21819ed91e51$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $395a21819ed91e51$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $395a21819ed91e51$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $395a21819ed91e51$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $395a21819ed91e51$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $395a21819ed91e51$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($395a21819ed91e51$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($395a21819ed91e51$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($395a21819ed91e51$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $395a21819ed91e51$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $395a21819ed91e51$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $395a21819ed91e51$var$RejectWithValue) throw result;
                                if (result instanceof $395a21819ed91e51$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $395a21819ed91e51$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($395a21819ed91e51$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $395a21819ed91e51$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $395a21819ed91e51$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $395a21819ed91e51$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $395a21819ed91e51$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $395a21819ed91e51$export$343355ed40c51c46 = {
    [$395a21819ed91e51$var$asyncThunkSymbol]: $395a21819ed91e51$export$6abd22dc03e5063f
};
var $395a21819ed91e51$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($395a21819ed91e51$export$23a094319a4b586 || {});
function $395a21819ed91e51$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $395a21819ed91e51$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$395a21819ed91e51$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($395a21819ed91e51$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($395a21819ed91e51$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($395a21819ed91e51$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($395a21819ed91e51$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $395a21819ed91e51$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($395a21819ed91e51$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $395a21819ed91e51$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $395a21819ed91e51$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $395a21819ed91e51$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $395a21819ed91e51$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $395a21819ed91e51$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $395a21819ed91e51$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $395a21819ed91e51$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    const map = {};
                    for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $395a21819ed91e51$var$wrapSelector(selector, selectState, ()=>$395a21819ed91e51$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $395a21819ed91e51$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $395a21819ed91e51$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $395a21819ed91e51$export$affdea4146de9cf5();
function $395a21819ed91e51$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $395a21819ed91e51$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$395a21819ed91e51$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($395a21819ed91e51$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $395a21819ed91e51$export$309c7a02b0b0bc62(type, prepareCallback) : $395a21819ed91e51$export$309c7a02b0b0bc62(type));
}
function $395a21819ed91e51$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $395a21819ed91e51$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $395a21819ed91e51$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($395a21819ed91e51$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $395a21819ed91e51$var$noop,
        pending: pending || $395a21819ed91e51$var$noop,
        rejected: rejected || $395a21819ed91e51$var$noop,
        settled: settled || $395a21819ed91e51$var$noop
    });
}
function $395a21819ed91e51$var$noop() {}
// src/entities/entity_state.ts
function $395a21819ed91e51$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $395a21819ed91e51$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($395a21819ed91e51$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $395a21819ed91e51$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $395a21819ed91e51$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $395a21819ed91e51$var$isDraftTyped = (0, $83c4x.isDraft);
function $395a21819ed91e51$var$createSingleArgumentStateOperator(mutator) {
    const operator = $395a21819ed91e51$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $395a21819ed91e51$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $395a21819ed91e51$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($395a21819ed91e51$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $83c4x.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $395a21819ed91e51$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $395a21819ed91e51$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $395a21819ed91e51$var$getCurrent(value) {
    return (0, $83c4x.isDraft)(value) ? (0, $83c4x.current)(value) : value;
}
function $395a21819ed91e51$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $395a21819ed91e51$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $395a21819ed91e51$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $395a21819ed91e51$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $395a21819ed91e51$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $395a21819ed91e51$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $395a21819ed91e51$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id]?.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$395a21819ed91e51$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $395a21819ed91e51$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $395a21819ed91e51$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $395a21819ed91e51$var$createStateOperator(addOneMutably),
        addMany: $395a21819ed91e51$var$createStateOperator(addManyMutably),
        setOne: $395a21819ed91e51$var$createStateOperator(setOneMutably),
        setMany: $395a21819ed91e51$var$createStateOperator(setManyMutably),
        setAll: $395a21819ed91e51$var$createStateOperator(setAllMutably),
        updateOne: $395a21819ed91e51$var$createStateOperator(updateOneMutably),
        updateMany: $395a21819ed91e51$var$createStateOperator(updateManyMutably),
        upsertOne: $395a21819ed91e51$var$createStateOperator(upsertOneMutably),
        upsertMany: $395a21819ed91e51$var$createStateOperator(upsertManyMutably),
        removeOne: $395a21819ed91e51$var$createStateOperator(removeOneMutably),
        removeMany: $395a21819ed91e51$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $395a21819ed91e51$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $395a21819ed91e51$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $395a21819ed91e51$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $395a21819ed91e51$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $395a21819ed91e51$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds ?? $395a21819ed91e51$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $395a21819ed91e51$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $395a21819ed91e51$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $395a21819ed91e51$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $395a21819ed91e51$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $395a21819ed91e51$var$getCurrent(state.entities);
        const currentIds = $395a21819ed91e51$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $395a21819ed91e51$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $395a21819ed91e51$var$createStateOperator(addOneMutably),
        updateOne: $395a21819ed91e51$var$createStateOperator(updateOneMutably),
        upsertOne: $395a21819ed91e51$var$createStateOperator(upsertOneMutably),
        setOne: $395a21819ed91e51$var$createStateOperator(setOneMutably),
        setMany: $395a21819ed91e51$var$createStateOperator(setManyMutably),
        setAll: $395a21819ed91e51$var$createStateOperator(setAllMutably),
        addMany: $395a21819ed91e51$var$createStateOperator(addManyMutably),
        updateMany: $395a21819ed91e51$var$createStateOperator(updateManyMutably),
        upsertMany: $395a21819ed91e51$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $395a21819ed91e51$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $395a21819ed91e51$var$createSortedStateAdapter(selectId, sortComparer) : $395a21819ed91e51$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $395a21819ed91e51$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $395a21819ed91e51$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $395a21819ed91e51$var$task = "task";
var $395a21819ed91e51$var$listener = "listener";
var $395a21819ed91e51$var$completed = "completed";
var $395a21819ed91e51$var$cancelled = "cancelled";
var $395a21819ed91e51$var$taskCancelled = `task-${$395a21819ed91e51$var$cancelled}`;
var $395a21819ed91e51$var$taskCompleted = `task-${$395a21819ed91e51$var$completed}`;
var $395a21819ed91e51$var$listenerCancelled = `${$395a21819ed91e51$var$listener}-${$395a21819ed91e51$var$cancelled}`;
var $395a21819ed91e51$var$listenerCompleted = `${$395a21819ed91e51$var$listener}-${$395a21819ed91e51$var$completed}`;
var $395a21819ed91e51$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$395a21819ed91e51$var$task} ${$395a21819ed91e51$var$cancelled} (reason: ${code})`;
    }
    code;
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $395a21819ed91e51$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($395a21819ed91e51$export$378fa86b259c0280(32));
};
var $395a21819ed91e51$var$noop2 = ()=>{};
var $395a21819ed91e51$var$catchRejection = (promise, onError = $395a21819ed91e51$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $395a21819ed91e51$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $395a21819ed91e51$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $395a21819ed91e51$export$cb1bdac908fed7f(signal.reason);
};
function $395a21819ed91e51$var$raceWithSignal(signal, promise) {
    let cleanup = $395a21819ed91e51$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $395a21819ed91e51$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $395a21819ed91e51$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $395a21819ed91e51$var$noop2;
    });
}
var $395a21819ed91e51$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $395a21819ed91e51$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $395a21819ed91e51$var$createPause = (signal)=>{
    return (promise)=>{
        return $395a21819ed91e51$var$catchRejection($395a21819ed91e51$var$raceWithSignal(signal, promise).then((output)=>{
            $395a21819ed91e51$var$validateActive(signal);
            return output;
        }));
    };
};
var $395a21819ed91e51$var$createDelay = (signal)=>{
    const pause = $395a21819ed91e51$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $395a21819ed91e51$var$assign } = Object;
var $395a21819ed91e51$var$INTERNAL_NIL_TOKEN = {};
var $395a21819ed91e51$var$alm = "listenerMiddleware";
var $395a21819ed91e51$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$395a21819ed91e51$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $395a21819ed91e51$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $395a21819ed91e51$var$runTask(async ()=>{
            $395a21819ed91e51$var$validateActive(parentAbortSignal);
            $395a21819ed91e51$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $395a21819ed91e51$var$createPause(childAbortController.signal),
                delay: $395a21819ed91e51$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $395a21819ed91e51$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($395a21819ed91e51$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($395a21819ed91e51$var$noop2));
        return {
            result: $395a21819ed91e51$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($395a21819ed91e51$var$taskCancelled);
            }
        };
    };
};
var $395a21819ed91e51$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $395a21819ed91e51$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $395a21819ed91e51$var$raceWithSignal(signal, Promise.race(promises));
            $395a21819ed91e51$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$395a21819ed91e51$var$catchRejection(take(predicate, timeout));
};
var $395a21819ed91e51$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $395a21819ed91e51$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($395a21819ed91e51$export$378fa86b259c0280(21));
    $395a21819ed91e51$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $395a21819ed91e51$var$createListenerEntry = /* @__PURE__ */ $395a21819ed91e51$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $395a21819ed91e51$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $395a21819ed91e51$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($395a21819ed91e51$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$395a21819ed91e51$var$createListenerEntry
});
var $395a21819ed91e51$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $395a21819ed91e51$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $395a21819ed91e51$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($395a21819ed91e51$var$listenerCancelled);
    });
};
var $395a21819ed91e51$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$395a21819ed91e51$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $395a21819ed91e51$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $395a21819ed91e51$export$f03a6b845d3fb58b = /* @__PURE__ */ $395a21819ed91e51$var$assign(/* @__PURE__ */ $395a21819ed91e51$export$309c7a02b0b0bc62(`${$395a21819ed91e51$var$alm}/add`), {
    withTypes: ()=>$395a21819ed91e51$export$f03a6b845d3fb58b
});
var $395a21819ed91e51$export$b1b8022855fb2b71 = /* @__PURE__ */ $395a21819ed91e51$export$309c7a02b0b0bc62(`${$395a21819ed91e51$var$alm}/removeAll`);
var $395a21819ed91e51$export$b03e9483f936dccb = /* @__PURE__ */ $395a21819ed91e51$var$assign(/* @__PURE__ */ $395a21819ed91e51$export$309c7a02b0b0bc62(`${$395a21819ed91e51$var$alm}/remove`), {
    withTypes: ()=>$395a21819ed91e51$export$b03e9483f936dccb
});
var $395a21819ed91e51$var$defaultErrorHandler = (...args)=>{
    console.error(`${$395a21819ed91e51$var$alm}/error`, ...args);
};
var $395a21819ed91e51$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $395a21819ed91e51$var$defaultErrorHandler } = middlewareOptions;
    $395a21819ed91e51$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $395a21819ed91e51$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        const entry = $395a21819ed91e51$var$findListenerEntry(listenerMap, options) ?? $395a21819ed91e51$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $395a21819ed91e51$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $395a21819ed91e51$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $395a21819ed91e51$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $395a21819ed91e51$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $395a21819ed91e51$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $395a21819ed91e51$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $395a21819ed91e51$var$createDelay(internalTaskController.signal),
                pause: $395a21819ed91e51$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $395a21819ed91e51$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($395a21819ed91e51$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($395a21819ed91e51$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $395a21819ed91e51$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $395a21819ed91e51$export$cb1bdac908fed7f)) $395a21819ed91e51$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($395a21819ed91e51$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $395a21819ed91e51$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $k62I6.isAction)(action)) return next(action);
                if ($395a21819ed91e51$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($395a21819ed91e51$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($395a21819ed91e51$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $395a21819ed91e51$var$INTERNAL_NIL_TOKEN) throw new Error($395a21819ed91e51$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $395a21819ed91e51$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $395a21819ed91e51$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $395a21819ed91e51$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $395a21819ed91e51$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $395a21819ed91e51$export$4bb1606a79445586 = ()=>{
    const instanceId = $395a21819ed91e51$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($395a21819ed91e51$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $395a21819ed91e51$var$getOrInsertComputed(middlewareMap, middleware2, $395a21819ed91e51$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$395a21819ed91e51$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $k62I6.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $395a21819ed91e51$export$9dd1fb32974da385(withMiddleware, $395a21819ed91e51$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $395a21819ed91e51$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $395a21819ed91e51$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$395a21819ed91e51$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $395a21819ed91e51$var$ORIGINAL_STATE = /* @__PURE__ */ Symbol.for("rtk-state-proxy-original");
var $395a21819ed91e51$var$isStateProxy = (value)=>!!value && !!value[$395a21819ed91e51$var$ORIGINAL_STATE];
var $395a21819ed91e51$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $395a21819ed91e51$var$createStateProxy = (state, reducerMap, initialStateCache)=>$395a21819ed91e51$var$getOrInsertComputed($395a21819ed91e51$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $395a21819ed91e51$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $395a21819ed91e51$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($395a21819ed91e51$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $395a21819ed91e51$var$original = (state)=>{
    if (!$395a21819ed91e51$var$isStateProxy(state)) throw new Error($395a21819ed91e51$export$378fa86b259c0280(25));
    return state[$395a21819ed91e51$var$ORIGINAL_STATE];
};
var $395a21819ed91e51$var$emptyObject = {};
var $395a21819ed91e51$var$noopReducer = (state = $395a21819ed91e51$var$emptyObject)=>state;
function $395a21819ed91e51$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($395a21819ed91e51$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $k62I6.combineReducers)(reducerMap) : $395a21819ed91e51$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($395a21819ed91e51$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $395a21819ed91e51$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $395a21819ed91e51$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("k62I6", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $69d89bbac1c11feb$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $69d89bbac1c11feb$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $69d89bbac1c11feb$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $69d89bbac1c11feb$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $69d89bbac1c11feb$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $69d89bbac1c11feb$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $69d89bbac1c11feb$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $69d89bbac1c11feb$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $69d89bbac1c11feb$var$symbol_observable_default = $69d89bbac1c11feb$var$$$observable;
// src/utils/actionTypes.ts
var $69d89bbac1c11feb$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $69d89bbac1c11feb$var$ActionTypes = {
    INIT: `@@redux/INIT${$69d89bbac1c11feb$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$69d89bbac1c11feb$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$69d89bbac1c11feb$var$randomString()}`
};
var $69d89bbac1c11feb$export$4219e499db7ca678 = $69d89bbac1c11feb$var$ActionTypes;
// src/utils/isPlainObject.ts
function $69d89bbac1c11feb$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $69d89bbac1c11feb$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($69d89bbac1c11feb$var$isDate(val)) return "date";
    if ($69d89bbac1c11feb$var$isError(val)) return "error";
    const constructorName = $69d89bbac1c11feb$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $69d89bbac1c11feb$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $69d89bbac1c11feb$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $69d89bbac1c11feb$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $69d89bbac1c11feb$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $69d89bbac1c11feb$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(1));
        return enhancer($69d89bbac1c11feb$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$69d89bbac1c11feb$export$53b83ca8eaab0383(action)) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $69d89bbac1c11feb$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$69d89bbac1c11feb$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $69d89bbac1c11feb$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$69d89bbac1c11feb$var$symbol_observable_default]: observable
    };
    return store;
}
function $69d89bbac1c11feb$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $69d89bbac1c11feb$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $69d89bbac1c11feb$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $69d89bbac1c11feb$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $69d89bbac1c11feb$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$69d89bbac1c11feb$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$69d89bbac1c11feb$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $69d89bbac1c11feb$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $69d89bbac1c11feb$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $69d89bbac1c11feb$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $69d89bbac1c11feb$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(13));
    });
}
function $69d89bbac1c11feb$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $69d89bbac1c11feb$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $69d89bbac1c11feb$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $69d89bbac1c11feb$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $69d89bbac1c11feb$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $69d89bbac1c11feb$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $69d89bbac1c11feb$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $69d89bbac1c11feb$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($69d89bbac1c11feb$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $69d89bbac1c11feb$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $69d89bbac1c11feb$export$b956e38827fca970(action) {
    return $69d89bbac1c11feb$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("83c4x", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $ba7613f01b95f65e$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $ba7613f01b95f65e$export$16e3aed3edb85946);
$parcel$export(module.exports, "current", () => $ba7613f01b95f65e$export$97aac956da55dae9);
$parcel$export(module.exports, "produce", () => $ba7613f01b95f65e$export$b46cabe22e78bc00);
$parcel$export(module.exports, "castDraft", () => $ba7613f01b95f65e$export$c05b21e3257751e5);
// src/utils/env.ts
var $ba7613f01b95f65e$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $ba7613f01b95f65e$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $ba7613f01b95f65e$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $ba7613f01b95f65e$var$errors = [];
function $ba7613f01b95f65e$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $ba7613f01b95f65e$var$O = Object;
var $ba7613f01b95f65e$var$getPrototypeOf = $ba7613f01b95f65e$var$O.getPrototypeOf;
var $ba7613f01b95f65e$var$CONSTRUCTOR = "constructor";
var $ba7613f01b95f65e$var$PROTOTYPE = "prototype";
var $ba7613f01b95f65e$var$CONFIGURABLE = "configurable";
var $ba7613f01b95f65e$var$ENUMERABLE = "enumerable";
var $ba7613f01b95f65e$var$WRITABLE = "writable";
var $ba7613f01b95f65e$var$VALUE = "value";
var $ba7613f01b95f65e$export$541ac630993a4c84 = (value)=>!!value && !!value[$ba7613f01b95f65e$var$DRAFT_STATE];
function $ba7613f01b95f65e$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $ba7613f01b95f65e$var$isPlainObject(value) || $ba7613f01b95f65e$var$isArray(value) || !!value[$ba7613f01b95f65e$export$6ee2082928bcb0ee] || !!value[$ba7613f01b95f65e$var$CONSTRUCTOR]?.[$ba7613f01b95f65e$export$6ee2082928bcb0ee] || $ba7613f01b95f65e$var$isMap(value) || $ba7613f01b95f65e$var$isSet(value);
}
var $ba7613f01b95f65e$var$objectCtorString = $ba7613f01b95f65e$var$O[$ba7613f01b95f65e$var$PROTOTYPE][$ba7613f01b95f65e$var$CONSTRUCTOR].toString();
var $ba7613f01b95f65e$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $ba7613f01b95f65e$var$isPlainObject(value) {
    if (!value || !$ba7613f01b95f65e$var$isObjectish(value)) return false;
    const proto = $ba7613f01b95f65e$var$getPrototypeOf(value);
    if (proto === null || proto === $ba7613f01b95f65e$var$O[$ba7613f01b95f65e$var$PROTOTYPE]) return true;
    const Ctor = $ba7613f01b95f65e$var$O.hasOwnProperty.call(proto, $ba7613f01b95f65e$var$CONSTRUCTOR) && proto[$ba7613f01b95f65e$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$ba7613f01b95f65e$var$isFunction(Ctor)) return false;
    let ctorString = $ba7613f01b95f65e$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $ba7613f01b95f65e$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $ba7613f01b95f65e$var$objectCtorString;
}
function $ba7613f01b95f65e$export$22e8af3f75a010e3(value) {
    if (!$ba7613f01b95f65e$export$541ac630993a4c84(value)) $ba7613f01b95f65e$var$die(15, value);
    return value[$ba7613f01b95f65e$var$DRAFT_STATE].base_;
}
function $ba7613f01b95f65e$var$each(obj, iter, strict = true) {
    if ($ba7613f01b95f65e$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $ba7613f01b95f65e$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $ba7613f01b95f65e$var$getArchtype(thing) {
    const state = thing[$ba7613f01b95f65e$var$DRAFT_STATE];
    return state ? state.type_ : $ba7613f01b95f65e$var$isArray(thing) ? 1 /* Array */  : $ba7613f01b95f65e$var$isMap(thing) ? 2 /* Map */  : $ba7613f01b95f65e$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $ba7613f01b95f65e$var$has = (thing, prop, type = $ba7613f01b95f65e$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $ba7613f01b95f65e$var$O[$ba7613f01b95f65e$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $ba7613f01b95f65e$var$get = (thing, prop, type = $ba7613f01b95f65e$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $ba7613f01b95f65e$var$set = (thing, propOrOldValue, value, type = $ba7613f01b95f65e$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $ba7613f01b95f65e$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $ba7613f01b95f65e$var$isArray = Array.isArray;
var $ba7613f01b95f65e$var$isMap = (target)=>target instanceof Map;
var $ba7613f01b95f65e$var$isSet = (target)=>target instanceof Set;
var $ba7613f01b95f65e$var$isObjectish = (target)=>typeof target === "object";
var $ba7613f01b95f65e$var$isFunction = (target)=>typeof target === "function";
var $ba7613f01b95f65e$var$isBoolean = (target)=>typeof target === "boolean";
function $ba7613f01b95f65e$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $ba7613f01b95f65e$var$getProxyDraft = (value)=>{
    if (!$ba7613f01b95f65e$var$isObjectish(value)) return null;
    return value?.[$ba7613f01b95f65e$var$DRAFT_STATE];
};
var $ba7613f01b95f65e$var$latest = (state)=>state.copy_ || state.base_;
var $ba7613f01b95f65e$var$getValue = (value)=>{
    const proxyDraft = $ba7613f01b95f65e$var$getProxyDraft(value);
    return proxyDraft ? $ba7613f01b95f65e$var$getFinalValue(proxyDraft) : value;
};
var $ba7613f01b95f65e$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $ba7613f01b95f65e$var$shallowCopy(base, strict) {
    if ($ba7613f01b95f65e$var$isMap(base)) return new Map(base);
    if ($ba7613f01b95f65e$var$isSet(base)) return new Set(base);
    if ($ba7613f01b95f65e$var$isArray(base)) return Array[$ba7613f01b95f65e$var$PROTOTYPE].slice.call(base);
    const isPlain = $ba7613f01b95f65e$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $ba7613f01b95f65e$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$ba7613f01b95f65e$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$ba7613f01b95f65e$var$WRITABLE] === false) {
                desc[$ba7613f01b95f65e$var$WRITABLE] = true;
                desc[$ba7613f01b95f65e$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$ba7613f01b95f65e$var$CONFIGURABLE]: true,
                [$ba7613f01b95f65e$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$ba7613f01b95f65e$var$ENUMERABLE]: desc[$ba7613f01b95f65e$var$ENUMERABLE],
                [$ba7613f01b95f65e$var$VALUE]: base[key]
            };
        }
        return $ba7613f01b95f65e$var$O.create($ba7613f01b95f65e$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $ba7613f01b95f65e$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $ba7613f01b95f65e$var$O.create(proto);
        return $ba7613f01b95f65e$var$O.assign(obj, base);
    }
}
function $ba7613f01b95f65e$export$792f3d81ea979f55(obj, deep = false) {
    if ($ba7613f01b95f65e$var$isFrozen(obj) || $ba7613f01b95f65e$export$541ac630993a4c84(obj) || !$ba7613f01b95f65e$export$16e3aed3edb85946(obj)) return obj;
    if ($ba7613f01b95f65e$var$getArchtype(obj) > 1) $ba7613f01b95f65e$var$O.defineProperties(obj, {
        set: $ba7613f01b95f65e$var$dontMutateMethodOverride,
        add: $ba7613f01b95f65e$var$dontMutateMethodOverride,
        clear: $ba7613f01b95f65e$var$dontMutateMethodOverride,
        delete: $ba7613f01b95f65e$var$dontMutateMethodOverride
    });
    $ba7613f01b95f65e$var$O.freeze(obj);
    if (deep) $ba7613f01b95f65e$var$each(obj, (_key, value)=>{
        $ba7613f01b95f65e$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $ba7613f01b95f65e$var$dontMutateFrozenCollections() {
    $ba7613f01b95f65e$var$die(2);
}
var $ba7613f01b95f65e$var$dontMutateMethodOverride = {
    [$ba7613f01b95f65e$var$VALUE]: $ba7613f01b95f65e$var$dontMutateFrozenCollections
};
function $ba7613f01b95f65e$var$isFrozen(obj) {
    if (obj === null || !$ba7613f01b95f65e$var$isObjectish(obj)) return true;
    return $ba7613f01b95f65e$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $ba7613f01b95f65e$var$PluginMapSet = "MapSet";
var $ba7613f01b95f65e$var$PluginPatches = "Patches";
var $ba7613f01b95f65e$var$PluginArrayMethods = "ArrayMethods";
var $ba7613f01b95f65e$var$plugins = {};
function $ba7613f01b95f65e$var$getPlugin(pluginKey) {
    const plugin = $ba7613f01b95f65e$var$plugins[pluginKey];
    if (!plugin) $ba7613f01b95f65e$var$die(0, pluginKey);
    return plugin;
}
var $ba7613f01b95f65e$var$isPluginLoaded = (pluginKey)=>!!$ba7613f01b95f65e$var$plugins[pluginKey];
function $ba7613f01b95f65e$var$loadPlugin(pluginKey, implementation) {
    if (!$ba7613f01b95f65e$var$plugins[pluginKey]) $ba7613f01b95f65e$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $ba7613f01b95f65e$var$currentScope;
var $ba7613f01b95f65e$var$getCurrentScope = ()=>$ba7613f01b95f65e$var$currentScope;
var $ba7613f01b95f65e$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $ba7613f01b95f65e$var$isPluginLoaded($ba7613f01b95f65e$var$PluginMapSet) ? $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $ba7613f01b95f65e$var$isPluginLoaded($ba7613f01b95f65e$var$PluginArrayMethods) ? $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginArrayMethods) : void 0
    });
function $ba7613f01b95f65e$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $ba7613f01b95f65e$var$revokeScope(scope) {
    $ba7613f01b95f65e$var$leaveScope(scope);
    scope.drafts_.forEach($ba7613f01b95f65e$var$revokeDraft);
    scope.drafts_ = null;
}
function $ba7613f01b95f65e$var$leaveScope(scope) {
    if (scope === $ba7613f01b95f65e$var$currentScope) $ba7613f01b95f65e$var$currentScope = scope.parent_;
}
var $ba7613f01b95f65e$var$enterScope = (immer2)=>$ba7613f01b95f65e$var$currentScope = $ba7613f01b95f65e$var$createScope($ba7613f01b95f65e$var$currentScope, immer2);
function $ba7613f01b95f65e$var$revokeDraft(draft) {
    const state = draft[$ba7613f01b95f65e$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $ba7613f01b95f65e$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$ba7613f01b95f65e$var$DRAFT_STATE].modified_) {
            $ba7613f01b95f65e$var$revokeScope(scope);
            $ba7613f01b95f65e$var$die(4);
        }
        if ($ba7613f01b95f65e$export$16e3aed3edb85946(result)) result = $ba7613f01b95f65e$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$ba7613f01b95f65e$var$DRAFT_STATE].base_, result, scope);
    } else result = $ba7613f01b95f65e$var$finalize(scope, baseDraft);
    $ba7613f01b95f65e$var$maybeFreeze(scope, result, true);
    $ba7613f01b95f65e$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $ba7613f01b95f65e$export$45b790e32b2810ee ? result : void 0;
}
function $ba7613f01b95f65e$var$finalize(rootScope, value) {
    if ($ba7613f01b95f65e$var$isFrozen(value)) return value;
    const state = value[$ba7613f01b95f65e$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $ba7613f01b95f65e$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$ba7613f01b95f65e$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $ba7613f01b95f65e$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $ba7613f01b95f65e$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $ba7613f01b95f65e$export$792f3d81ea979f55(value, deep);
}
function $ba7613f01b95f65e$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $ba7613f01b95f65e$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $ba7613f01b95f65e$var$EMPTY_LOCATIONS_RESULT = [];
function $ba7613f01b95f65e$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $ba7613f01b95f65e$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $ba7613f01b95f65e$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $ba7613f01b95f65e$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $ba7613f01b95f65e$var$each(parentCopy, (key, value)=>{
            if ($ba7613f01b95f65e$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $ba7613f01b95f65e$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$ba7613f01b95f65e$var$set(parentCopy, location, finalizedValue, parentType);
}
function $ba7613f01b95f65e$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$ba7613f01b95f65e$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $ba7613f01b95f65e$var$getFinalValue(state);
        $ba7613f01b95f65e$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $ba7613f01b95f65e$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $ba7613f01b95f65e$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $ba7613f01b95f65e$var$markStateFinalized(state);
    }
}
function $ba7613f01b95f65e$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($ba7613f01b95f65e$export$541ac630993a4c84(value)) {
        const state = value[$ba7613f01b95f65e$var$DRAFT_STATE];
        if ($ba7613f01b95f65e$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $ba7613f01b95f65e$var$prepareCopy(target);
            const finalizedValue = $ba7613f01b95f65e$var$getFinalValue(state);
            $ba7613f01b95f65e$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($ba7613f01b95f65e$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $ba7613f01b95f65e$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $ba7613f01b95f65e$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($ba7613f01b95f65e$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $ba7613f01b95f65e$var$handleValue($ba7613f01b95f65e$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $ba7613f01b95f65e$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($ba7613f01b95f65e$export$541ac630993a4c84(target) || handledSet.has(target) || !$ba7613f01b95f65e$export$16e3aed3edb85946(target) || $ba7613f01b95f65e$var$isFrozen(target)) return target;
    handledSet.add(target);
    $ba7613f01b95f65e$var$each(target, (key, value)=>{
        if ($ba7613f01b95f65e$export$541ac630993a4c84(value)) {
            const state = value[$ba7613f01b95f65e$var$DRAFT_STATE];
            if ($ba7613f01b95f65e$var$isSameScope(state, rootScope)) {
                const updatedValue = $ba7613f01b95f65e$var$getFinalValue(state);
                $ba7613f01b95f65e$var$set(target, key, updatedValue, target.type_);
                $ba7613f01b95f65e$var$markStateFinalized(state);
            }
        } else if ($ba7613f01b95f65e$export$16e3aed3edb85946(value)) $ba7613f01b95f65e$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $ba7613f01b95f65e$var$createProxyProxy(base, parent) {
    const baseIsArray = $ba7613f01b95f65e$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $ba7613f01b95f65e$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $ba7613f01b95f65e$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $ba7613f01b95f65e$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $ba7613f01b95f65e$var$objectTraps = {
    get (state, prop) {
        if (prop === $ba7613f01b95f65e$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $ba7613f01b95f65e$var$latest(state);
        if (!$ba7613f01b95f65e$var$has(source, prop, state.type_)) return $ba7613f01b95f65e$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$ba7613f01b95f65e$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $ba7613f01b95f65e$var$isArrayIndex(prop)) return value;
        if (value === $ba7613f01b95f65e$var$peek(state.base_, prop) || $ba7613f01b95f65e$var$isRelocatedBaseRef(state, prop, value)) {
            $ba7613f01b95f65e$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $ba7613f01b95f65e$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $ba7613f01b95f65e$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($ba7613f01b95f65e$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $ba7613f01b95f65e$var$getDescriptorFromProto($ba7613f01b95f65e$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $ba7613f01b95f65e$var$peek($ba7613f01b95f65e$var$latest(state), prop);
            const currentState = current2?.[$ba7613f01b95f65e$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($ba7613f01b95f65e$var$is(value, current2) && (value !== void 0 || $ba7613f01b95f65e$var$has(state.base_, prop, state.type_))) return true;
            $ba7613f01b95f65e$var$prepareCopy(state);
            $ba7613f01b95f65e$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || $ba7613f01b95f65e$var$has(state.copy_, prop, state.type_)) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $ba7613f01b95f65e$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $ba7613f01b95f65e$var$prepareCopy(state);
        if ($ba7613f01b95f65e$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $ba7613f01b95f65e$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $ba7613f01b95f65e$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$ba7613f01b95f65e$var$WRITABLE]: true,
            [$ba7613f01b95f65e$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$ba7613f01b95f65e$var$ENUMERABLE]: desc[$ba7613f01b95f65e$var$ENUMERABLE],
            [$ba7613f01b95f65e$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $ba7613f01b95f65e$var$die(11);
    },
    getPrototypeOf (state) {
        return $ba7613f01b95f65e$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $ba7613f01b95f65e$var$die(12);
    }
};
var $ba7613f01b95f65e$var$arrayTraps = {};
for(let key in $ba7613f01b95f65e$var$objectTraps){
    let fn = $ba7613f01b95f65e$var$objectTraps[key];
    $ba7613f01b95f65e$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$ba7613f01b95f65e$var$arrayTraps.deleteProperty = function(state, prop) {
    return $ba7613f01b95f65e$var$arrayTraps.set.call(this, state, prop, void 0);
};
$ba7613f01b95f65e$var$arrayTraps.set = function(state, prop, value) {
    return $ba7613f01b95f65e$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $ba7613f01b95f65e$var$peek(draft, prop) {
    const state = draft[$ba7613f01b95f65e$var$DRAFT_STATE];
    const source = state ? $ba7613f01b95f65e$var$latest(state) : draft;
    return source[prop];
}
function $ba7613f01b95f65e$var$isRelocatedBaseRef(state, prop, value) {
    if (state.type_ !== 1 /* Array */  || !state.allIndicesReassigned_ || state.assigned_?.get(prop) || !$ba7613f01b95f65e$export$16e3aed3edb85946(value) || value[$ba7613f01b95f65e$var$DRAFT_STATE]) return false;
    return state.baseRefs_.has(value);
}
function $ba7613f01b95f65e$var$readPropFromProto(state, source, prop) {
    const desc = $ba7613f01b95f65e$var$getDescriptorFromProto(source, prop);
    return desc ? $ba7613f01b95f65e$var$VALUE in desc ? desc[$ba7613f01b95f65e$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $ba7613f01b95f65e$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $ba7613f01b95f65e$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $ba7613f01b95f65e$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $ba7613f01b95f65e$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $ba7613f01b95f65e$var$markChanged(state.parent_);
    }
}
function $ba7613f01b95f65e$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $ba7613f01b95f65e$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $ba7613f01b95f65e$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($ba7613f01b95f65e$var$isFunction(base) && !$ba7613f01b95f65e$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$ba7613f01b95f65e$var$isFunction(recipe)) $ba7613f01b95f65e$var$die(6);
            if (patchListener !== void 0 && !$ba7613f01b95f65e$var$isFunction(patchListener)) $ba7613f01b95f65e$var$die(7);
            let result;
            if ($ba7613f01b95f65e$export$16e3aed3edb85946(base)) {
                const scope = $ba7613f01b95f65e$var$enterScope(this);
                const proxy = $ba7613f01b95f65e$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $ba7613f01b95f65e$var$revokeScope(scope);
                    else $ba7613f01b95f65e$var$leaveScope(scope);
                }
                $ba7613f01b95f65e$var$usePatchesInScope(scope, patchListener);
                return $ba7613f01b95f65e$var$processResult(result, scope);
            } else if (!base || !$ba7613f01b95f65e$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $ba7613f01b95f65e$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $ba7613f01b95f65e$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $ba7613f01b95f65e$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($ba7613f01b95f65e$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($ba7613f01b95f65e$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($ba7613f01b95f65e$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($ba7613f01b95f65e$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$ba7613f01b95f65e$export$16e3aed3edb85946(base)) $ba7613f01b95f65e$var$die(8);
        if ($ba7613f01b95f65e$export$541ac630993a4c84(base)) base = $ba7613f01b95f65e$export$97aac956da55dae9(base);
        const scope = $ba7613f01b95f65e$var$enterScope(this);
        const proxy = $ba7613f01b95f65e$var$createProxy(scope, base, void 0);
        proxy[$ba7613f01b95f65e$var$DRAFT_STATE].isManual_ = true;
        $ba7613f01b95f65e$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$ba7613f01b95f65e$var$DRAFT_STATE];
        if (!state || !state.isManual_) $ba7613f01b95f65e$var$die(9);
        const { scope_: scope } = state;
        $ba7613f01b95f65e$var$usePatchesInScope(scope, patchListener);
        return $ba7613f01b95f65e$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginPatches).applyPatches_;
        if ($ba7613f01b95f65e$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $ba7613f01b95f65e$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $ba7613f01b95f65e$var$isMap(value) ? $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginMapSet).proxyMap_(value, parent) : $ba7613f01b95f65e$var$isSet(value) ? $ba7613f01b95f65e$var$getPlugin($ba7613f01b95f65e$var$PluginMapSet).proxySet_(value, parent) : $ba7613f01b95f65e$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $ba7613f01b95f65e$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $ba7613f01b95f65e$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $ba7613f01b95f65e$export$97aac956da55dae9(value) {
    if (!$ba7613f01b95f65e$export$541ac630993a4c84(value)) $ba7613f01b95f65e$var$die(10, value);
    return $ba7613f01b95f65e$var$currentImpl(value);
}
function $ba7613f01b95f65e$var$currentImpl(value) {
    if (!$ba7613f01b95f65e$export$16e3aed3edb85946(value) || $ba7613f01b95f65e$var$isFrozen(value)) return value;
    const state = value[$ba7613f01b95f65e$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $ba7613f01b95f65e$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $ba7613f01b95f65e$var$shallowCopy(value, true);
    $ba7613f01b95f65e$var$each(copy, (key, childValue)=>{
        $ba7613f01b95f65e$var$set(copy, key, $ba7613f01b95f65e$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $ba7613f01b95f65e$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $ba7613f01b95f65e$var$getProxyDraft($ba7613f01b95f65e$var$get(parentCopy, state.key_));
            const valueAtKey = $ba7613f01b95f65e$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $ba7613f01b95f65e$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $ba7613f01b95f65e$var$get(current2, key);
            if (!$ba7613f01b95f65e$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$ba7613f01b95f65e$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $ba7613f01b95f65e$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $ba7613f01b95f65e$var$get(base_, key, type_);
            const value = $ba7613f01b95f65e$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $ba7613f01b95f65e$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $ba7613f01b95f65e$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $ba7613f01b95f65e$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $ba7613f01b95f65e$var$CONSTRUCTOR)) $ba7613f01b95f65e$var$die(errorOffset + 3);
                if ($ba7613f01b95f65e$var$isFunction(base) && p === $ba7613f01b95f65e$var$PROTOTYPE) $ba7613f01b95f65e$var$die(errorOffset + 3);
                base = $ba7613f01b95f65e$var$get(base, p);
                if (base === null || !$ba7613f01b95f65e$var$isObjectish(base)) $ba7613f01b95f65e$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $ba7613f01b95f65e$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $ba7613f01b95f65e$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $ba7613f01b95f65e$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$ba7613f01b95f65e$export$16e3aed3edb85946(obj)) return obj;
        if ($ba7613f01b95f65e$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($ba7613f01b95f65e$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($ba7613f01b95f65e$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($ba7613f01b95f65e$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($ba7613f01b95f65e$var$has(obj, $ba7613f01b95f65e$export$6ee2082928bcb0ee)) cloned[$ba7613f01b95f65e$export$6ee2082928bcb0ee] = obj[$ba7613f01b95f65e$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($ba7613f01b95f65e$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $ba7613f01b95f65e$var$loadPlugin($ba7613f01b95f65e$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
var $ba7613f01b95f65e$var$_globalIterator = globalThis.Iterator;
var $ba7613f01b95f65e$var$hasIteratorFrom = typeof $ba7613f01b95f65e$var$_globalIterator?.from === "function";
function $ba7613f01b95f65e$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$ba7613f01b95f65e$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $ba7613f01b95f65e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $ba7613f01b95f65e$var$latest(this[$ba7613f01b95f65e$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $ba7613f01b95f65e$var$latest(this[$ba7613f01b95f65e$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$ba7613f01b95f65e$var$latest(state).has(key) || $ba7613f01b95f65e$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $ba7613f01b95f65e$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $ba7613f01b95f65e$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $ba7613f01b95f65e$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($ba7613f01b95f65e$var$latest(state).size) {
                prepareMapCopy(state);
                $ba7613f01b95f65e$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $ba7613f01b95f65e$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            $ba7613f01b95f65e$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $ba7613f01b95f65e$var$latest(state).get(key);
            if (state.finalized_ || !$ba7613f01b95f65e$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $ba7613f01b95f65e$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $ba7613f01b95f65e$var$latest(this[$ba7613f01b95f65e$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            });
        }
        entries() {
            const iterator = this.keys();
            return iteratorFrom({
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            });
        }
        [($ba7613f01b95f65e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function iteratorFrom(iterable) {
        if ($ba7613f01b95f65e$var$hasIteratorFrom) return $ba7613f01b95f65e$var$_globalIterator.from(iterable);
        const iterator = {
            ...iterable,
            [Symbol.iterator]: ()=>iterator
        };
        return iterator;
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$ba7613f01b95f65e$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$ba7613f01b95f65e$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $ba7613f01b95f65e$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $ba7613f01b95f65e$var$latest(this[$ba7613f01b95f65e$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $ba7613f01b95f65e$var$markChanged(state);
                state.copy_.add(value);
                $ba7613f01b95f65e$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $ba7613f01b95f65e$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($ba7613f01b95f65e$var$latest(state).size) {
                prepareSetCopy(state);
                $ba7613f01b95f65e$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$ba7613f01b95f65e$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($ba7613f01b95f65e$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$ba7613f01b95f65e$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($ba7613f01b95f65e$export$16e3aed3edb85946(value)) {
                    const draft = $ba7613f01b95f65e$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $ba7613f01b95f65e$var$die(3, JSON.stringify($ba7613f01b95f65e$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($ba7613f01b95f65e$var$getValue(value));
            });
        }
    }
    $ba7613f01b95f65e$var$loadPlugin($ba7613f01b95f65e$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $ba7613f01b95f65e$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $ba7613f01b95f65e$var$prepareCopy(state);
        const result = operation();
        markArrayChanged(state, markLength);
        return result;
    }
    function markArrayChanged(state, markLength = true) {
        $ba7613f01b95f65e$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
        state.baseRefs_ = new Set(state.base_);
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = "" + (startIndex + i);
            state.assigned_.set(index, true);
            $ba7613f01b95f65e$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        const isInsert = method === "push" || method === "unshift";
        if (isInsert ? args.length === 0 : $ba7613f01b95f65e$var$latest(state).length === 0) return isInsert ? $ba7613f01b95f65e$var$latest(state).length : void 0;
        $ba7613f01b95f65e$var$prepareCopy(state);
        const lengthBefore = state.copy_.length;
        const result = state.copy_[method](...args);
        markArrayChanged(state);
        if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
        if (method === "push") handleInsertedValues(state, lengthBefore, args);
        else if (method === "unshift") handleInsertedValues(state, 0, args);
        return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
    }
    function handleReorderingOperation(state, method, args) {
        if ($ba7613f01b95f65e$var$latest(state).length <= 1) return state.draft_;
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const insertCount = args.length > 2 ? args.length - 2 : 0;
                        if (insertCount === 0) {
                            const length = $ba7613f01b95f65e$var$latest(state).length;
                            if (args.length === 0 || normalizeSliceIndex(args[0] ?? 0, length) === length || args.length > 1 && !(args[1] >= 1)) return [];
                        }
                        $ba7613f01b95f65e$var$prepareCopy(state);
                        const res = state.copy_.splice(...args);
                        if (res.length === 0 && insertCount === 0) return res;
                        markArrayChanged(state);
                        markAllIndicesReassigned(state);
                        if (insertCount > 0) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $ba7613f01b95f65e$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $ba7613f01b95f65e$var$loadPlugin($ba7613f01b95f65e$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $ba7613f01b95f65e$var$immer = new $ba7613f01b95f65e$export$aaadc6ff0f822719();
var $ba7613f01b95f65e$export$b46cabe22e78bc00 = $ba7613f01b95f65e$var$immer.produce;
var $ba7613f01b95f65e$export$4da66d41c9492c78 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.produceWithPatches.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$573f26f60825c493 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.setAutoFreeze.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$333ce65961cbe047 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.setUseStrictShallowCopy.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$1045b3be3904c489 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.setUseStrictIteration.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.applyPatches.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$3c3214997190395f = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.createDraft.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$c60f5e69c521b528 = /* @__PURE__ */ $ba7613f01b95f65e$var$immer.finishDraft.bind($ba7613f01b95f65e$var$immer);
var $ba7613f01b95f65e$export$c05b21e3257751e5 = (value)=>value;
var $ba7613f01b95f65e$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("hzYeg", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $24754ce48eac1c1e$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $24754ce48eac1c1e$export$5943f4447f6ef248);
// src/devModeChecks/cacheSizeCheck.ts
var $24754ce48eac1c1e$var$CACHE_SIZE_CHECK_THRESHOLD = 1e3;
var $24754ce48eac1c1e$var$runCacheSizeCheck = (cacheSize, funcName)=>{
    let stack = void 0;
    try {
        throw new Error();
    } catch (e) {
        ({ stack: stack } = e);
    }
    console.warn(`A function memoized with weakMapMemoize${funcName ? ` (\`${funcName}\`)` : ""} has seen over ${cacheSize} distinct values for the same primitive argument position.
Results keyed by primitive arguments are held strongly and are only released by \`clearCache()\`, so this cache will keep growing for as long as the function keeps seeing new values.
If it is called with ever-changing primitives (ids, offsets, timestamps), pass the \`maxSize\` option to bound the cache, switch to \`lruMemoize\`, or call \`.clearCache()\` at a suitable point.
See https://reselect.js.org/api/development-only-checks#cachesizecheck for details.`, {
        stack: stack
    });
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $24754ce48eac1c1e$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once",
    cacheSizeCheck: "once"
};
var $24754ce48eac1c1e$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($24754ce48eac1c1e$var$globalDevModeChecks, devModeChecks);
};
// src/weakMapMemoize.ts
var $24754ce48eac1c1e$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $24754ce48eac1c1e$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $24754ce48eac1c1e$var$StrongRef : WeakRef;
var $24754ce48eac1c1e$var$Ref = /* @__PURE__ */ $24754ce48eac1c1e$var$getWeakRef();
var $24754ce48eac1c1e$var$UNTERMINATED = 0;
var $24754ce48eac1c1e$var$TERMINATED = 1;
function $24754ce48eac1c1e$var$createCacheNode() {
    return {
        s: $24754ce48eac1c1e$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $24754ce48eac1c1e$var$maybeDeref(r) {
    if (r instanceof $24754ce48eac1c1e$var$Ref) return r.deref();
    return r;
}
function $24754ce48eac1c1e$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $24754ce48eac1c1e$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck, maxSize: maxSize } = options;
    const useGenerations = maxSize !== void 0;
    if (useGenerations && (!Number.isInteger(maxSize) || maxSize < 1)) throw new TypeError(`maxSize must be a positive integer, received: ${maxSize}`);
    let prevNode = null;
    let insertionCount = 0;
    let lastResult;
    let resultsCount = 0;
    let hasWarnedAboutCacheSize = false;
    function maybeFlipGenerations() {
        if (insertionCount >= maxSize) {
            prevNode = fnNode;
            fnNode = $24754ce48eac1c1e$var$createCacheNode();
            insertionCount = 0;
        }
    }
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $24754ce48eac1c1e$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $24754ce48eac1c1e$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                    insertionCount++;
                } else cacheNode = primitiveNode;
            }
        }
        if (cacheNode.s === $24754ce48eac1c1e$var$TERMINATED) return cacheNode.v;
        if (prevNode !== null) {
            let prevCacheNode = prevNode;
            for(let i = 0, l = length; i < l; i++){
                const arg = arguments[i];
                let next;
                if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                    const prevObjectCache = prevCacheNode.o;
                    next = prevObjectCache !== null ? prevObjectCache.get(arg) : void 0;
                } else {
                    const prevPrimitiveCache = prevCacheNode.p;
                    next = prevPrimitiveCache !== null ? prevPrimitiveCache.get(arg) : void 0;
                }
                if (next === void 0) {
                    prevCacheNode = null;
                    break;
                }
                prevCacheNode = next;
            }
            if (prevCacheNode !== null && prevCacheNode.s === $24754ce48eac1c1e$var$TERMINATED) {
                const promotedNode = cacheNode;
                promotedNode.s = $24754ce48eac1c1e$var$TERMINATED;
                promotedNode.v = prevCacheNode.v;
                maybeFlipGenerations();
                return prevCacheNode.v;
            }
        }
        const terminatedNode = cacheNode;
        let result = func.apply(null, arguments);
        resultsCount++;
        if (resultEqualityCheck) {
            const lastResultValue = $24754ce48eac1c1e$var$maybeDeref(lastResult);
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? /* @__PURE__ */ new $24754ce48eac1c1e$var$Ref(result) : result;
        }
        terminatedNode.s = $24754ce48eac1c1e$var$TERMINATED;
        terminatedNode.v = result;
        if (useGenerations) maybeFlipGenerations();
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $24754ce48eac1c1e$var$createCacheNode();
        prevNode = null;
        insertionCount = 0;
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/devModeChecks/identityFunctionCheck.ts
var $24754ce48eac1c1e$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $24754ce48eac1c1e$var$withoutResultEqualityCheck = (option)=>{
    if (option === null || typeof option !== "object" || !("resultEqualityCheck" in option)) return option;
    const optionCopy = {
        ...option
    };
    delete optionCopy.resultEqualityCheck;
    return optionCopy;
};
var $24754ce48eac1c1e$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const probeMemoizeOptions = [];
    const { length: length } = memoizeOptions;
    for(let i = 0; i < length; i++)probeMemoizeOptions.push($24754ce48eac1c1e$var$withoutResultEqualityCheck(memoizeOptions[i]));
    const createAnEmptyObject = memoize(()=>({}), ...probeMemoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/utils.ts
var $24754ce48eac1c1e$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $24754ce48eac1c1e$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $24754ce48eac1c1e$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $24754ce48eac1c1e$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $24754ce48eac1c1e$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $24754ce48eac1c1e$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $24754ce48eac1c1e$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $24754ce48eac1c1e$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
// src/createSelectorCreator.ts
function $24754ce48eac1c1e$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $24754ce48eac1c1e$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $24754ce48eac1c1e$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $24754ce48eac1c1e$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $24754ce48eac1c1e$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $24754ce48eac1c1e$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const { length: length } = dependencies;
            const inputSelectorResults = new Array(length);
            for(let i = 0; i < length; i++)inputSelectorResults[i] = dependencies[i].apply(null, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $24754ce48eac1c1e$export$595d22ed68ca2841 = /* @__PURE__ */ $24754ce48eac1c1e$export$5943f4447f6ef248($24754ce48eac1c1e$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $24754ce48eac1c1e$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $24754ce48eac1c1e$export$595d22ed68ca2841)=>{
    $24754ce48eac1c1e$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$24754ce48eac1c1e$export$75979cfcd91bf38f
});
// src/lruMemoize.ts
function $24754ce48eac1c1e$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $24754ce48eac1c1e$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        findMatchingEntry (value, resultEqualityCheck) {
            const current = entry;
            return current !== void 0 && resultEqualityCheck(current.value, value) ? current : void 0;
        },
        clear () {
            entry = void 0;
        }
    };
}
function $24754ce48eac1c1e$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(entry.key, key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $24754ce48eac1c1e$var$NOT_FOUND;
    }
    function put(key, value) {
        entries.unshift({
            key: key,
            value: value
        });
        if (entries.length > maxSize) entries.pop();
    }
    function findMatchingEntry(value, resultEqualityCheck) {
        const currentEntries = entries;
        const { length: length } = currentEntries;
        for(let i = 0; i < length; i++){
            const entry = currentEntries[i];
            if (resultEqualityCheck(entry.value, value)) return entry;
        }
        return void 0;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        findMatchingEntry: findMatchingEntry,
        clear: clear
    };
}
var $24754ce48eac1c1e$export$3f025202a230c6dd = (a, b)=>a === b;
function $24754ce48eac1c1e$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $24754ce48eac1c1e$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $24754ce48eac1c1e$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $24754ce48eac1c1e$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $24754ce48eac1c1e$var$createSingletonCache(comparator) : $24754ce48eac1c1e$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $24754ce48eac1c1e$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const matchingEntry = cache.findMatchingEntry(value, resultEqualityCheck);
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}

});

parcelRegister("gP4IM", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $e47c072c64e91a75$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $e47c072c64e91a75$export$16d06542a1949d9e);
// src/index.ts
function $e47c072c64e91a75$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $e47c072c64e91a75$export$dd164f5517779f15 = $e47c072c64e91a75$var$createThunkMiddleware();
var $e47c072c64e91a75$export$16d06542a1949d9e = $e47c072c64e91a75$var$createThunkMiddleware;

});



parcelRegister("fC5w9", function(module, exports) {

$parcel$export(module.exports, "CartesianChart", () => $b5deaf479b23783f$export$855bb85b2910abc9);

var $acw62 = parcelRequire("acw62");

var $idHPp = parcelRequire("idHPp");

var $1SwgK = parcelRequire("1SwgK");

var $f5A9j = parcelRequire("f5A9j");

var $iWBQe = parcelRequire("iWBQe");

var $bHRfD = parcelRequire("bHRfD");

var $iz2Aq = parcelRequire("iz2Aq");

var $cd9rh = parcelRequire("cd9rh");

var $j6mdh = parcelRequire("j6mdh");
function $b5deaf479b23783f$var$_extends() {
    return $b5deaf479b23783f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b5deaf479b23783f$var$_extends.apply(null, arguments);
}
function $b5deaf479b23783f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5deaf479b23783f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5deaf479b23783f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b5deaf479b23783f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5deaf479b23783f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b5deaf479b23783f$var$_defineProperty(e, r, t) {
    return (r = $b5deaf479b23783f$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b5deaf479b23783f$var$_toPropertyKey(t) {
    var i = $b5deaf479b23783f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b5deaf479b23783f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b5deaf479b23783f$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $b5deaf479b23783f$export$2663cf0965a16cf2 = $b5deaf479b23783f$var$_objectSpread({
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    layout: 'horizontal',
    margin: $b5deaf479b23783f$var$defaultMargin,
    responsive: false,
    reverseStackOrder: false,
    stackOffset: 'none',
    syncMethod: 'index'
}, (0, $j6mdh.initialEventSettingsState));
var $b5deaf479b23783f$export$855bb85b2910abc9 = /*#__PURE__*/ (0, $acw62.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, $cd9rh.resolveDefaultProps)(props.categoricalChartProps, $b5deaf479b23783f$export$2663cf0965a16cf2);
    var chartName = props.chartName, defaultTooltipEventType = props.defaultTooltipEventType, validateTooltipEventTypes = props.validateTooltipEventTypes, tooltipPayloadSearcher = props.tooltipPayloadSearcher, categoricalChartProps = props.categoricalChartProps;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $acw62.createElement((0, $idHPp.RechartsStoreProvider), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ $acw62.createElement((0, $1SwgK.ChartDataContextProvider), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ $acw62.createElement((0, $f5A9j.ReportMainChartProps), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ $acw62.createElement((0, $bHRfD.ReportEventSettings), {
        throttleDelay: rootChartProps.throttleDelay,
        throttledEvents: rootChartProps.throttledEvents
    }), /*#__PURE__*/ $acw62.createElement((0, $iWBQe.ReportChartProps), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ $acw62.createElement((0, $iz2Aq.CategoricalChart), $b5deaf479b23783f$var$_extends({}, rootChartProps, {
        ref: ref
    })));
});

});
parcelRegister("idHPp", function(module, exports) {

$parcel$export(module.exports, "RechartsStoreProvider", () => $d43b7042472c8a15$export$debe87639f2707f9);

var $acw62 = parcelRequire("acw62");

var $5GDiJ = parcelRequire("5GDiJ");

var $5w6fw = parcelRequire("5w6fw");

var $3X9hg = parcelRequire("3X9hg");

var $5WKOf = parcelRequire("5WKOf");
function $d43b7042472c8a15$export$debe87639f2707f9(_ref) {
    var preloadedState = _ref.preloadedState, children = _ref.children, reduxStoreName = _ref.reduxStoreName;
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, $acw62.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, $5w6fw.createRechartsStore)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, $5WKOf.RechartsReduxContext);
    return /*#__PURE__*/ $acw62.createElement((0, $5GDiJ.Provider), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}

});
parcelRegister("5GDiJ", function(module, exports) {

$parcel$export(module.exports, "shallowEqual", () => $8fe6756fc00adb68$export$d36bdfa510afb180);
$parcel$export(module.exports, "Provider", () => $8fe6756fc00adb68$export$2881499e37b75b9a);
// src/utils/react.ts

var $acw62 = parcelRequire("acw62");

var $kv7uE = parcelRequire("kv7uE");
// src/utils/react-is.ts
var $8fe6756fc00adb68$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $8fe6756fc00adb68$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($8fe6756fc00adb68$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $8fe6756fc00adb68$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $8fe6756fc00adb68$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $8fe6756fc00adb68$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $8fe6756fc00adb68$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $8fe6756fc00adb68$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $8fe6756fc00adb68$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $8fe6756fc00adb68$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $8fe6756fc00adb68$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $8fe6756fc00adb68$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $8fe6756fc00adb68$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $8fe6756fc00adb68$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $8fe6756fc00adb68$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $8fe6756fc00adb68$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $8fe6756fc00adb68$var$ForwardRef = $8fe6756fc00adb68$var$REACT_FORWARD_REF_TYPE;
var $8fe6756fc00adb68$var$Memo = $8fe6756fc00adb68$var$REACT_MEMO_TYPE;
function $8fe6756fc00adb68$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $8fe6756fc00adb68$var$REACT_FRAGMENT_TYPE || type === $8fe6756fc00adb68$var$REACT_PROFILER_TYPE || type === $8fe6756fc00adb68$var$REACT_STRICT_MODE_TYPE || type === $8fe6756fc00adb68$var$REACT_SUSPENSE_TYPE || type === $8fe6756fc00adb68$var$REACT_SUSPENSE_LIST_TYPE || type === $8fe6756fc00adb68$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $8fe6756fc00adb68$var$REACT_LAZY_TYPE || type.$$typeof === $8fe6756fc00adb68$var$REACT_MEMO_TYPE || type.$$typeof === $8fe6756fc00adb68$var$REACT_CONTEXT_TYPE || type.$$typeof === $8fe6756fc00adb68$var$REACT_CONSUMER_TYPE || type.$$typeof === $8fe6756fc00adb68$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $8fe6756fc00adb68$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $8fe6756fc00adb68$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $8fe6756fc00adb68$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $8fe6756fc00adb68$var$REACT_FRAGMENT_TYPE:
                    case $8fe6756fc00adb68$var$REACT_PROFILER_TYPE:
                    case $8fe6756fc00adb68$var$REACT_STRICT_MODE_TYPE:
                    case $8fe6756fc00adb68$var$REACT_SUSPENSE_TYPE:
                    case $8fe6756fc00adb68$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $8fe6756fc00adb68$var$REACT_CONTEXT_TYPE:
                            case $8fe6756fc00adb68$var$REACT_FORWARD_REF_TYPE:
                            case $8fe6756fc00adb68$var$REACT_LAZY_TYPE:
                            case $8fe6756fc00adb68$var$REACT_MEMO_TYPE:
                                return object;
                            case $8fe6756fc00adb68$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $8fe6756fc00adb68$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $8fe6756fc00adb68$var$isContextConsumer(object) {
    return $8fe6756fc00adb68$var$IS_REACT_19 ? $8fe6756fc00adb68$var$typeOf(object) === $8fe6756fc00adb68$var$REACT_CONSUMER_TYPE : $8fe6756fc00adb68$var$typeOf(object) === $8fe6756fc00adb68$var$REACT_CONTEXT_TYPE;
}
function $8fe6756fc00adb68$var$isMemo(object) {
    return $8fe6756fc00adb68$var$typeOf(object) === $8fe6756fc00adb68$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $8fe6756fc00adb68$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $8fe6756fc00adb68$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $8fe6756fc00adb68$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $8fe6756fc00adb68$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $8fe6756fc00adb68$var$verify(mapStateToProps, "mapStateToProps");
    $8fe6756fc00adb68$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $8fe6756fc00adb68$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $8fe6756fc00adb68$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $8fe6756fc00adb68$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $8fe6756fc00adb68$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $8fe6756fc00adb68$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $8fe6756fc00adb68$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $8fe6756fc00adb68$var$verifyPlainObject(value, displayName, methodName) {
    if (!$8fe6756fc00adb68$var$isPlainObject(value)) $8fe6756fc00adb68$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $8fe6756fc00adb68$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $8fe6756fc00adb68$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $8fe6756fc00adb68$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $8fe6756fc00adb68$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $8fe6756fc00adb68$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $8fe6756fc00adb68$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $8fe6756fc00adb68$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $8fe6756fc00adb68$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $8fe6756fc00adb68$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $8fe6756fc00adb68$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $8fe6756fc00adb68$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $8fe6756fc00adb68$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $8fe6756fc00adb68$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $8fe6756fc00adb68$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $8fe6756fc00adb68$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $8fe6756fc00adb68$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $8fe6756fc00adb68$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $8fe6756fc00adb68$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $8fe6756fc00adb68$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$8fe6756fc00adb68$var$defaultMergeProps : typeof mergeProps === "function" ? $8fe6756fc00adb68$var$wrapMergePropsFunc(mergeProps) : $8fe6756fc00adb68$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $8fe6756fc00adb68$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $8fe6756fc00adb68$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $8fe6756fc00adb68$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $8fe6756fc00adb68$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $8fe6756fc00adb68$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $8fe6756fc00adb68$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $8fe6756fc00adb68$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $8fe6756fc00adb68$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $8fe6756fc00adb68$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $8fe6756fc00adb68$var$isDOM = /* @__PURE__ */ $8fe6756fc00adb68$var$canUseDOM();
var $8fe6756fc00adb68$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $8fe6756fc00adb68$var$isReactNative = /* @__PURE__ */ $8fe6756fc00adb68$var$isRunningInReactNative();
var $8fe6756fc00adb68$var$getUseIsomorphicLayoutEffect = ()=>$8fe6756fc00adb68$var$isDOM || $8fe6756fc00adb68$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $8fe6756fc00adb68$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $8fe6756fc00adb68$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $8fe6756fc00adb68$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $8fe6756fc00adb68$export$d36bdfa510afb180(objA, objB) {
    if ($8fe6756fc00adb68$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$8fe6756fc00adb68$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $8fe6756fc00adb68$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $8fe6756fc00adb68$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $8fe6756fc00adb68$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $8fe6756fc00adb68$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $8fe6756fc00adb68$var$TYPE_STATICS = {
    [$8fe6756fc00adb68$var$ForwardRef]: $8fe6756fc00adb68$var$FORWARD_REF_STATICS,
    [$8fe6756fc00adb68$var$Memo]: $8fe6756fc00adb68$var$MEMO_STATICS
};
function $8fe6756fc00adb68$var$getStatics(component) {
    if ($8fe6756fc00adb68$var$isMemo(component)) return $8fe6756fc00adb68$var$MEMO_STATICS;
    return $8fe6756fc00adb68$var$TYPE_STATICS[component["$$typeof"]] || $8fe6756fc00adb68$var$REACT_STATICS;
}
var $8fe6756fc00adb68$var$defineProperty = Object.defineProperty;
var $8fe6756fc00adb68$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $8fe6756fc00adb68$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $8fe6756fc00adb68$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8fe6756fc00adb68$var$getPrototypeOf = Object.getPrototypeOf;
var $8fe6756fc00adb68$var$objectPrototype = Object.prototype;
function $8fe6756fc00adb68$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($8fe6756fc00adb68$var$objectPrototype) {
            const inheritedComponent = $8fe6756fc00adb68$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $8fe6756fc00adb68$var$objectPrototype) $8fe6756fc00adb68$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $8fe6756fc00adb68$var$getOwnPropertyNames(sourceComponent);
        if ($8fe6756fc00adb68$var$getOwnPropertySymbols) keys = keys.concat($8fe6756fc00adb68$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $8fe6756fc00adb68$var$getStatics(targetComponent);
        const sourceStatics = $8fe6756fc00adb68$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$8fe6756fc00adb68$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $8fe6756fc00adb68$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $8fe6756fc00adb68$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $8fe6756fc00adb68$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $8fe6756fc00adb68$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $8fe6756fc00adb68$var$getContext() {
    if (!$acw62.createContext) return {};
    const contextMap = $8fe6756fc00adb68$var$gT[$8fe6756fc00adb68$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $8fe6756fc00adb68$export$cc80c08dc91f1c00 = /* @__PURE__ */ $8fe6756fc00adb68$var$getContext();
// src/components/connect.tsx
var $8fe6756fc00adb68$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $8fe6756fc00adb68$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $8fe6756fc00adb68$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $8fe6756fc00adb68$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $8fe6756fc00adb68$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $8fe6756fc00adb68$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $8fe6756fc00adb68$var$strictEqual(a, b) {
    return a === b;
}
var $8fe6756fc00adb68$var$hasWarnedAboutDeprecatedPureOption = false;
function $8fe6756fc00adb68$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $8fe6756fc00adb68$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $8fe6756fc00adb68$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $8fe6756fc00adb68$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $8fe6756fc00adb68$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $8fe6756fc00adb68$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $8fe6756fc00adb68$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $8fe6756fc00adb68$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $8fe6756fc00adb68$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext?.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $8fe6756fc00adb68$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $8fe6756fc00adb68$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $8fe6756fc00adb68$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $8fe6756fc00adb68$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $8fe6756fc00adb68$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $8fe6756fc00adb68$var$useIsomorphicLayoutEffectWithArgs($8fe6756fc00adb68$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $8fe6756fc00adb68$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $8fe6756fc00adb68$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $8fe6756fc00adb68$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $8fe6756fc00adb68$export$64605811ab45167f = $8fe6756fc00adb68$var$_connect;
var $8fe6756fc00adb68$export$8807b5ba46f9d0b7 = $8fe6756fc00adb68$var$_connect;
// src/components/Provider.tsx
function $8fe6756fc00adb68$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $8fe6756fc00adb68$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $8fe6756fc00adb68$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $8fe6756fc00adb68$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $8fe6756fc00adb68$export$2881499e37b75b9a = $8fe6756fc00adb68$var$Provider;
// src/hooks/useReduxContext.ts
function $8fe6756fc00adb68$var$createReduxContextHook(context = $8fe6756fc00adb68$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $8fe6756fc00adb68$var$useReduxContext = /* @__PURE__ */ $8fe6756fc00adb68$var$createReduxContextHook();
// src/hooks/useStore.ts
function $8fe6756fc00adb68$export$671dba69185d0304(context = $8fe6756fc00adb68$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $8fe6756fc00adb68$export$cc80c08dc91f1c00 ? $8fe6756fc00adb68$var$useReduxContext : // @ts-ignore
    $8fe6756fc00adb68$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $8fe6756fc00adb68$export$6ccbb43953eebf8 = /* @__PURE__ */ $8fe6756fc00adb68$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $8fe6756fc00adb68$export$bc9b55530897c558(context = $8fe6756fc00adb68$export$cc80c08dc91f1c00) {
    const useStore2 = context === $8fe6756fc00adb68$export$cc80c08dc91f1c00 ? $8fe6756fc00adb68$export$6ccbb43953eebf8 : $8fe6756fc00adb68$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $8fe6756fc00adb68$export$8ad76b76a4c905f8 = /* @__PURE__ */ $8fe6756fc00adb68$export$bc9b55530897c558();
var $8fe6756fc00adb68$var$refEquality = (a, b)=>a === b;
function $8fe6756fc00adb68$export$2b53f90d2bd1cbfb(context = $8fe6756fc00adb68$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $8fe6756fc00adb68$export$cc80c08dc91f1c00 ? $8fe6756fc00adb68$var$useReduxContext : $8fe6756fc00adb68$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $8fe6756fc00adb68$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $kv7uE.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $8fe6756fc00adb68$export$2105062e25df4afe = /* @__PURE__ */ $8fe6756fc00adb68$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $8fe6756fc00adb68$export$712ea50be43a7858 = $8fe6756fc00adb68$var$defaultNoopBatch;

});
parcelRegister("kv7uE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jMohy"));

});


parcelRegister("5w6fw", function(module, exports) {

$parcel$export(module.exports, "createRechartsStore", () => $4044c9e072e449ea$export$a4383593d58e8efa);

var $jDald = parcelRequire("jDald");
var $k62I6 = parcelRequire("k62I6");

var $bIbT7 = parcelRequire("bIbT7");

var $58RF9 = parcelRequire("58RF9");

var $6G94s = parcelRequire("6G94s");

var $3OKeX = parcelRequire("3OKeX");

var $48PAd = parcelRequire("48PAd");

var $95Fms = parcelRequire("95Fms");

var $214LY = parcelRequire("214LY");

var $a0t9F = parcelRequire("a0t9F");

var $3PuQ3 = parcelRequire("3PuQ3");

var $gPow5 = parcelRequire("gPow5");

var $sP5sX = parcelRequire("sP5sX");

var $et7NI = parcelRequire("et7NI");

var $a5RMg = parcelRequire("a5RMg");

var $i8m83 = parcelRequire("i8m83");

var $9xSsq = parcelRequire("9xSsq");

var $acoL1 = parcelRequire("acoL1");

var $1PNrQ = parcelRequire("1PNrQ");

var $dx7pp = parcelRequire("dx7pp");

var $apNs5 = parcelRequire("apNs5");

var $3Zyvz = parcelRequire("3Zyvz");

var $j6mdh = parcelRequire("j6mdh");

var $47yFs = parcelRequire("47yFs");
var $4044c9e072e449ea$var$rootReducer = (0, $k62I6.combineReducers)({
    brush: (0, $gPow5.brushReducer),
    cartesianAxis: (0, $214LY.cartesianAxisReducer),
    chartData: (0, $6G94s.chartDataReducer),
    errorBars: (0, $dx7pp.errorBarReducer),
    eventSettings: (0, $j6mdh.eventSettingsReducer),
    graphicalItems: (0, $a0t9F.graphicalItemsReducer),
    layout: (0, $3OKeX.chartLayoutReducer),
    legend: (0, $sP5sX.legendReducer),
    options: (0, $bIbT7.optionsReducer),
    polarAxis: (0, $a5RMg.polarAxisReducer),
    polarOptions: (0, $i8m83.polarOptionsReducer),
    referenceElements: (0, $3PuQ3.referenceElementsReducer),
    renderedTicks: (0, $47yFs.renderedTicksReducer),
    rootProps: (0, $et7NI.rootPropsReducer),
    tooltip: (0, $58RF9.tooltipReducer),
    zIndex: (0, $3Zyvz.zIndexReducer)
});
var $4044c9e072e449ea$export$a4383593d58e8efa = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, $jDald.configureStore)({
        reducer: $4044c9e072e449ea$var$rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, $48PAd.mouseClickMiddleware).middleware,
                (0, $48PAd.mouseMoveMiddleware).middleware,
                (0, $9xSsq.keyboardEventsMiddleware).middleware,
                (0, $acoL1.externalEventsMiddleware).middleware,
                (0, $1PNrQ.touchEventMiddleware).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, $jDald.autoBatchEnhancer)({
                type: 'raf'
            }));
        },
        devTools: (0, $apNs5.Global).devToolsEnabled && {
            serialize: {
                replacer: (0, $95Fms.reduxDevtoolsJsonStringifyReplacer)
            },
            name: "recharts-".concat(chartName)
        }
    });
};

});
parcelRegister("58RF9", function(module, exports) {

$parcel$export(module.exports, "noInteraction", () => $3be7536b77e1512b$export$66f2ad380b6acece);
$parcel$export(module.exports, "addTooltipEntrySettings", () => $3be7536b77e1512b$export$2eaa1babb4725485);
$parcel$export(module.exports, "replaceTooltipEntrySettings", () => $3be7536b77e1512b$export$7333cdb61d5073d3);
$parcel$export(module.exports, "removeTooltipEntrySettings", () => $3be7536b77e1512b$export$29793cde90169929);
$parcel$export(module.exports, "setTooltipSettingsState", () => $3be7536b77e1512b$export$8d517a53c4528750);
$parcel$export(module.exports, "setActiveMouseOverItemIndex", () => $3be7536b77e1512b$export$c78abbb2450f6b44);
$parcel$export(module.exports, "mouseLeaveItem", () => $3be7536b77e1512b$export$68742311289b8f85);
$parcel$export(module.exports, "mouseLeaveChart", () => $3be7536b77e1512b$export$73879bed3f2eef71);
$parcel$export(module.exports, "setActiveClickItemIndex", () => $3be7536b77e1512b$export$99be2464250d8cae);
$parcel$export(module.exports, "setMouseOverAxisIndex", () => $3be7536b77e1512b$export$a7277636863fc703);
$parcel$export(module.exports, "setMouseClickAxisIndex", () => $3be7536b77e1512b$export$d2b1af5c3a560528);
$parcel$export(module.exports, "setSyncInteraction", () => $3be7536b77e1512b$export$f2efc99b98e50938);
$parcel$export(module.exports, "setKeyboardInteraction", () => $3be7536b77e1512b$export$820c94985c9eba3f);
$parcel$export(module.exports, "tooltipReducer", () => $3be7536b77e1512b$export$cadd4678b967dba6);

var $jDald = parcelRequire("jDald");
var $83c4x = parcelRequire("83c4x");

var $83c4x = parcelRequire("83c4x");
var $3be7536b77e1512b$export$66f2ad380b6acece = {
    active: false,
    index: null,
    dataKey: undefined,
    graphicalItemId: undefined,
    coordinate: undefined
};
var $3be7536b77e1512b$export$d4c72bab9d6cc13a = {
    itemInteraction: {
        click: $3be7536b77e1512b$export$66f2ad380b6acece,
        hover: $3be7536b77e1512b$export$66f2ad380b6acece
    },
    axisInteraction: {
        click: $3be7536b77e1512b$export$66f2ad380b6acece,
        hover: $3be7536b77e1512b$export$66f2ad380b6acece
    },
    keyboardInteraction: $3be7536b77e1512b$export$66f2ad380b6acece,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined,
        graphicalItemId: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
/**
 * This is the event we get when user is interacting with a specific graphical item.
 */ /**
 * Keyboard interaction payload has no graphical item ID,
 * and no dataKey, because keyboard interaction is always
 * with the whole chart, not with a specific graphical item.
 */ var $3be7536b77e1512b$var$tooltipSlice = (0, $jDald.createSlice)({
    name: 'tooltip',
    initialState: $3be7536b77e1512b$export$d4c72bab9d6cc13a,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, $83c4x.castDraft)(action.payload));
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var _action$payload = action.payload, prev = _action$payload.prev, next = _action$payload.next;
                var index = (0, $83c4x.current)(state).tooltipItemPayloads.indexOf((0, $83c4x.castDraft)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, $83c4x.castDraft)(next);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, $83c4x.current)(state).tooltipItemPayloads.indexOf((0, $83c4x.castDraft)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.syncInteraction.sourceViewBox = undefined;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
        }
    }
});
var $3be7536b77e1512b$var$_tooltipSlice$actions = $3be7536b77e1512b$var$tooltipSlice.actions, $3be7536b77e1512b$export$2eaa1babb4725485 = $3be7536b77e1512b$var$_tooltipSlice$actions.addTooltipEntrySettings, $3be7536b77e1512b$export$7333cdb61d5073d3 = $3be7536b77e1512b$var$_tooltipSlice$actions.replaceTooltipEntrySettings, $3be7536b77e1512b$export$29793cde90169929 = $3be7536b77e1512b$var$_tooltipSlice$actions.removeTooltipEntrySettings, $3be7536b77e1512b$export$8d517a53c4528750 = $3be7536b77e1512b$var$_tooltipSlice$actions.setTooltipSettingsState, $3be7536b77e1512b$export$c78abbb2450f6b44 = $3be7536b77e1512b$var$_tooltipSlice$actions.setActiveMouseOverItemIndex, $3be7536b77e1512b$export$68742311289b8f85 = $3be7536b77e1512b$var$_tooltipSlice$actions.mouseLeaveItem, $3be7536b77e1512b$export$73879bed3f2eef71 = $3be7536b77e1512b$var$_tooltipSlice$actions.mouseLeaveChart, $3be7536b77e1512b$export$99be2464250d8cae = $3be7536b77e1512b$var$_tooltipSlice$actions.setActiveClickItemIndex, $3be7536b77e1512b$export$a7277636863fc703 = $3be7536b77e1512b$var$_tooltipSlice$actions.setMouseOverAxisIndex, $3be7536b77e1512b$export$d2b1af5c3a560528 = $3be7536b77e1512b$var$_tooltipSlice$actions.setMouseClickAxisIndex, $3be7536b77e1512b$export$f2efc99b98e50938 = $3be7536b77e1512b$var$_tooltipSlice$actions.setSyncInteraction, $3be7536b77e1512b$export$820c94985c9eba3f = $3be7536b77e1512b$var$_tooltipSlice$actions.setKeyboardInteraction;
var $3be7536b77e1512b$export$cadd4678b967dba6 = $3be7536b77e1512b$var$tooltipSlice.reducer;

});

parcelRegister("6G94s", function(module, exports) {

$parcel$export(module.exports, "setChartData", () => $4dcdb3a18a3e2ca4$export$624c47d88733f253);
$parcel$export(module.exports, "setDataStartEndIndexes", () => $4dcdb3a18a3e2ca4$export$427d605cc4e3bbdd);
$parcel$export(module.exports, "setComputedData", () => $4dcdb3a18a3e2ca4$export$9b2e7f4962514250);
$parcel$export(module.exports, "chartDataReducer", () => $4dcdb3a18a3e2ca4$export$52973ca5fce0a5d5);

var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");
var $4dcdb3a18a3e2ca4$export$7285b50bc333b067 = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var $4dcdb3a18a3e2ca4$var$chartDataSlice = (0, $jDald.createSlice)({
    name: 'chartData',
    initialState: $4dcdb3a18a3e2ca4$export$7285b50bc333b067,
    reducers: {
        setChartData (state, action) {
            state.chartData = (0, $83c4x.castDraft)(action.payload);
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var _action$payload = action.payload, startIndex = _action$payload.startIndex, endIndex = _action$payload.endIndex;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var $4dcdb3a18a3e2ca4$var$_chartDataSlice$actio = $4dcdb3a18a3e2ca4$var$chartDataSlice.actions, $4dcdb3a18a3e2ca4$export$624c47d88733f253 = $4dcdb3a18a3e2ca4$var$_chartDataSlice$actio.setChartData, $4dcdb3a18a3e2ca4$export$427d605cc4e3bbdd = $4dcdb3a18a3e2ca4$var$_chartDataSlice$actio.setDataStartEndIndexes, $4dcdb3a18a3e2ca4$export$9b2e7f4962514250 = $4dcdb3a18a3e2ca4$var$_chartDataSlice$actio.setComputedData;
var $4dcdb3a18a3e2ca4$export$52973ca5fce0a5d5 = $4dcdb3a18a3e2ca4$var$chartDataSlice.reducer;

});

parcelRegister("3OKeX", function(module, exports) {

$parcel$export(module.exports, "setMargin", () => $2c79e8f39a8896b6$export$3f8f25b83912855f);
$parcel$export(module.exports, "setLayout", () => $2c79e8f39a8896b6$export$e8437af1f2483b8e);
$parcel$export(module.exports, "setChartSize", () => $2c79e8f39a8896b6$export$136b7feefeae481a);
$parcel$export(module.exports, "setScale", () => $2c79e8f39a8896b6$export$4dc523f7f9b3edd6);
$parcel$export(module.exports, "chartLayoutReducer", () => $2c79e8f39a8896b6$export$701395c4acfabc85);

var $jDald = parcelRequire("jDald");
var $2c79e8f39a8896b6$var$initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var $2c79e8f39a8896b6$var$chartLayoutSlice = (0, $jDald.createSlice)({
    name: 'chartLayout',
    initialState: $2c79e8f39a8896b6$var$initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var $2c79e8f39a8896b6$var$_chartLayoutSlice$act = $2c79e8f39a8896b6$var$chartLayoutSlice.actions, $2c79e8f39a8896b6$export$3f8f25b83912855f = $2c79e8f39a8896b6$var$_chartLayoutSlice$act.setMargin, $2c79e8f39a8896b6$export$e8437af1f2483b8e = $2c79e8f39a8896b6$var$_chartLayoutSlice$act.setLayout, $2c79e8f39a8896b6$export$136b7feefeae481a = $2c79e8f39a8896b6$var$_chartLayoutSlice$act.setChartSize, $2c79e8f39a8896b6$export$4dc523f7f9b3edd6 = $2c79e8f39a8896b6$var$_chartLayoutSlice$act.setScale;
var $2c79e8f39a8896b6$export$701395c4acfabc85 = $2c79e8f39a8896b6$var$chartLayoutSlice.reducer;

});

parcelRegister("48PAd", function(module, exports) {

$parcel$export(module.exports, "mouseClickAction", () => $303fec236f990197$export$f06e14b484aecafc);
$parcel$export(module.exports, "mouseClickMiddleware", () => $303fec236f990197$export$fb3df626ae9864a);
$parcel$export(module.exports, "mouseMoveAction", () => $303fec236f990197$export$f9de213dbfb2e32c);
$parcel$export(module.exports, "mouseMoveMiddleware", () => $303fec236f990197$export$b7e1b38eb227944a);

var $jDald = parcelRequire("jDald");

var $58RF9 = parcelRequire("58RF9");

var $6fQDv = parcelRequire("6fQDv");

var $2Ron6 = parcelRequire("2Ron6");

var $grYi3 = parcelRequire("grYi3");
var $303fec236f990197$export$f06e14b484aecafc = (0, $jDald.createAction)('mouseClick');
var $303fec236f990197$export$fb3df626ae9864a = (0, $jDald.createListenerMiddleware)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
$303fec236f990197$export$fb3df626ae9864a.startListening({
    actionCreator: $303fec236f990197$export$f06e14b484aecafc,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, $6fQDv.selectActivePropsFromChartPointer)(listenerApi.getState(), (0, $grYi3.getRelativeCoordinate)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $58RF9.setMouseClickAxisIndex)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var $303fec236f990197$export$f9de213dbfb2e32c = (0, $jDald.createAction)('mouseMove');
var $303fec236f990197$export$b7e1b38eb227944a = (0, $jDald.createListenerMiddleware)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var $303fec236f990197$var$rafId = null;
var $303fec236f990197$var$timeoutId = null;
var $303fec236f990197$var$latestChartPointer = null;
$303fec236f990197$export$b7e1b38eb227944a.startListening({
    actionCreator: $303fec236f990197$export$f9de213dbfb2e32c,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var state = listenerApi.getState();
        var _state$eventSettings = state.eventSettings, throttleDelay = _state$eventSettings.throttleDelay, throttledEvents = _state$eventSettings.throttledEvents;
        var isThrottled = throttledEvents === 'all' || (throttledEvents === null || throttledEvents === void 0 ? void 0 : throttledEvents.includes('mousemove'));
        // Cancel any pending execution
        if ($303fec236f990197$var$rafId !== null) {
            cancelAnimationFrame($303fec236f990197$var$rafId);
            $303fec236f990197$var$rafId = null;
        }
        if ($303fec236f990197$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($303fec236f990197$var$timeoutId);
            $303fec236f990197$var$timeoutId = null;
        }
        /*
     * Here it is important to resolve the chart pointer _before_ the callback,
     * because once we leave the current event loop, the mousePointer event object will lose
     * reference to currentTarget which getRelativeCoordinate uses.
     */ $303fec236f990197$var$latestChartPointer = (0, $grYi3.getRelativeCoordinate)(mousePointer);
        var callback = ()=>{
            /*
       * Here we read a fresh state again inside the callback to ensure we have the latest state values
       * after any potential actions that may have been dispatched between the original event and this callback.
       */ var currentState = listenerApi.getState();
            var tooltipEventType = (0, $2Ron6.selectTooltipEventType)(currentState, currentState.tooltip.settings.shared);
            if (!$303fec236f990197$var$latestChartPointer) {
                $303fec236f990197$var$rafId = null;
                $303fec236f990197$var$timeoutId = null;
                return;
            }
            /*
       * This functionality only applies to charts that have axes.
       * Graphical items have its own mouse events handling mechanism where they attach events directly to the items.
       */ if (tooltipEventType === 'axis') {
                var activeProps = (0, $6fQDv.selectActivePropsFromChartPointer)(currentState, $303fec236f990197$var$latestChartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $58RF9.setMouseOverAxisIndex)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, $58RF9.mouseLeaveChart)());
            }
            $303fec236f990197$var$rafId = null;
            $303fec236f990197$var$timeoutId = null;
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $303fec236f990197$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($303fec236f990197$var$timeoutId === null) $303fec236f990197$var$timeoutId = setTimeout(callback, throttleDelay);
        }
    }
});

});
parcelRegister("6fQDv", function(module, exports) {

$parcel$export(module.exports, "selectActivePropsFromChartPointer", () => $48dcf93c036bf043$export$2cfb761a54690867);

var $b0nKR = parcelRequire("b0nKR");

var $jHn5r = parcelRequire("jHn5r");

var $71i43 = parcelRequire("71i43");

var $lnFga = parcelRequire("lnFga");

var $72R3N = parcelRequire("72R3N");

var $7bJlR = parcelRequire("7bJlR");

var $4NxAS = parcelRequire("4NxAS");
var $48dcf93c036bf043$var$pickChartPointer = (_state, chartPointer)=>chartPointer;
var $48dcf93c036bf043$export$2cfb761a54690867 = (0, $b0nKR.createSelector)([
    $48dcf93c036bf043$var$pickChartPointer,
    (0, $jHn5r.selectChartLayout),
    (0, $7bJlR.selectPolarViewBox),
    (0, $4NxAS.selectTooltipAxisType),
    (0, $71i43.selectTooltipAxisRangeWithReverse),
    (0, $71i43.selectTooltipAxisTicks),
    (0, $72R3N.selectOrderedTooltipTicks),
    (0, $lnFga.selectChartOffsetInternal)
], (0, $72R3N.combineActiveProps));

});
parcelRegister("b0nKR", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $310dad19a2812331$export$595d22ed68ca2841);
// src/devModeChecks/identityFunctionCheck.ts
var $310dad19a2812331$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $310dad19a2812331$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $310dad19a2812331$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $310dad19a2812331$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($310dad19a2812331$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $310dad19a2812331$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $310dad19a2812331$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $310dad19a2812331$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $310dad19a2812331$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $310dad19a2812331$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $310dad19a2812331$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $310dad19a2812331$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $310dad19a2812331$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $310dad19a2812331$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$310dad19a2812331$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $310dad19a2812331$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $310dad19a2812331$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $310dad19a2812331$var$$REVISION = 0;
var $310dad19a2812331$var$CURRENT_TRACKER = null;
var $310dad19a2812331$var$Cell = class {
    revision = $310dad19a2812331$var$$REVISION;
    _value;
    _lastValue;
    _isEqual = $310dad19a2812331$var$tripleEq;
    constructor(initialValue, isEqual = $310dad19a2812331$var$tripleEq){
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $310dad19a2812331$var$CURRENT_TRACKER?.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$310dad19a2812331$var$$REVISION;
    }
};
function $310dad19a2812331$var$tripleEq(a, b) {
    return a === b;
}
var $310dad19a2812331$var$TrackingCache = class {
    _cachedValue;
    _cachedRevision = -1;
    _deps = [];
    hits = 0;
    fn;
    constructor(fn){
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $310dad19a2812331$var$CURRENT_TRACKER;
            $310dad19a2812331$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $310dad19a2812331$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $310dad19a2812331$var$CURRENT_TRACKER?.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $310dad19a2812331$var$getValue(cell) {
    if (!(cell instanceof $310dad19a2812331$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $310dad19a2812331$var$setValue(storage, value) {
    if (!(storage instanceof $310dad19a2812331$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $310dad19a2812331$var$createCell(initialValue, isEqual = $310dad19a2812331$var$tripleEq) {
    return new $310dad19a2812331$var$Cell(initialValue, isEqual);
}
function $310dad19a2812331$var$createCache(fn) {
    $310dad19a2812331$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $310dad19a2812331$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $310dad19a2812331$var$neverEq = (a, b)=>false;
function $310dad19a2812331$var$createTag() {
    return $310dad19a2812331$var$createCell(null, $310dad19a2812331$var$neverEq);
}
function $310dad19a2812331$var$dirtyTag(tag, value) {
    $310dad19a2812331$var$setValue(tag, value);
}
var $310dad19a2812331$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $310dad19a2812331$var$createTag();
    $310dad19a2812331$var$getValue(tag);
};
var $310dad19a2812331$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $310dad19a2812331$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $310dad19a2812331$var$nextId = 0;
var $310dad19a2812331$var$proto = /* @__PURE__ */ Object.getPrototypeOf({});
var $310dad19a2812331$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy(this, $310dad19a2812331$var$objectProxyHandler);
    tag = $310dad19a2812331$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $310dad19a2812331$var$nextId++;
};
var $310dad19a2812331$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $310dad19a2812331$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $310dad19a2812331$var$createNode(childValue);
                if (childNode.tag) $310dad19a2812331$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $310dad19a2812331$var$createTag();
                    tag.value = childValue;
                }
                $310dad19a2812331$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $310dad19a2812331$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $310dad19a2812331$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy([
        this
    ], $310dad19a2812331$var$arrayProxyHandler);
    tag = $310dad19a2812331$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $310dad19a2812331$var$nextId++;
};
var $310dad19a2812331$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $310dad19a2812331$var$consumeCollection(node);
        return $310dad19a2812331$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $310dad19a2812331$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $310dad19a2812331$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $310dad19a2812331$var$objectProxyHandler.has(node, prop);
    }
};
function $310dad19a2812331$var$createNode(value) {
    if (Array.isArray(value)) return new $310dad19a2812331$var$ArrayTreeNode(value);
    return new $310dad19a2812331$var$ObjectTreeNode(value);
}
function $310dad19a2812331$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $310dad19a2812331$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $310dad19a2812331$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $310dad19a2812331$var$dirtyCollection(node);
            $310dad19a2812331$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $310dad19a2812331$var$updateNode(childNode, newChildValue);
        else {
            $310dad19a2812331$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $310dad19a2812331$var$deleteNode(node) {
    if (node.tag) $310dad19a2812331$var$dirtyTag(node.tag, null);
    $310dad19a2812331$var$dirtyCollection(node);
    for(const key in node.tags)$310dad19a2812331$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$310dad19a2812331$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $310dad19a2812331$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $310dad19a2812331$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $310dad19a2812331$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $310dad19a2812331$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $310dad19a2812331$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $310dad19a2812331$export$3f025202a230c6dd = (a, b)=>a === b;
function $310dad19a2812331$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $310dad19a2812331$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $310dad19a2812331$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $310dad19a2812331$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $310dad19a2812331$var$createSingletonCache(comparator) : $310dad19a2812331$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $310dad19a2812331$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $310dad19a2812331$export$c8f9cf88d9fdee55(func) {
    const node = $310dad19a2812331$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $310dad19a2812331$var$createCacheKeyComparator($310dad19a2812331$export$3f025202a230c6dd);
    const cache = $310dad19a2812331$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $310dad19a2812331$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $310dad19a2812331$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $310dad19a2812331$var$getWeakRef = ()=>typeof WeakRef === "undefined" ? $310dad19a2812331$var$StrongRef : WeakRef;
var $310dad19a2812331$var$Ref = /* @__PURE__ */ $310dad19a2812331$var$getWeakRef();
var $310dad19a2812331$var$UNTERMINATED = 0;
var $310dad19a2812331$var$TERMINATED = 1;
function $310dad19a2812331$var$createCacheNode() {
    return {
        s: $310dad19a2812331$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $310dad19a2812331$var$maybeDeref(r) {
    if (r instanceof $310dad19a2812331$var$Ref) return r.deref();
    return r;
}
function $310dad19a2812331$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $310dad19a2812331$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $310dad19a2812331$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $310dad19a2812331$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $310dad19a2812331$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = $310dad19a2812331$var$maybeDeref(lastResult);
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? /* @__PURE__ */ new $310dad19a2812331$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $310dad19a2812331$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $310dad19a2812331$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $310dad19a2812331$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $310dad19a2812331$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $310dad19a2812331$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [] } = combinedOptions;
        const finalMemoizeOptions = $310dad19a2812331$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $310dad19a2812331$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $310dad19a2812331$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $310dad19a2812331$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $310dad19a2812331$export$595d22ed68ca2841 = /* @__PURE__ */ $310dad19a2812331$export$5943f4447f6ef248($310dad19a2812331$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $310dad19a2812331$export$75979cfcd91bf38f = /* @__PURE__ */ Object.assign((inputSelectorsObject, selectorCreator = $310dad19a2812331$export$595d22ed68ca2841)=>{
    $310dad19a2812331$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$310dad19a2812331$export$75979cfcd91bf38f
});

});

parcelRegister("jHn5r", function(module, exports) {

$parcel$export(module.exports, "useViewBox", () => $e573f10901a87cfb$export$76b29bb074e0c45a);
$parcel$export(module.exports, "useOffsetInternal", () => $e573f10901a87cfb$export$10605f61bef2858a);
$parcel$export(module.exports, "useChartWidth", () => $e573f10901a87cfb$export$8854f7ece606854b);
$parcel$export(module.exports, "useChartHeight", () => $e573f10901a87cfb$export$369ae257969c6f9f);
$parcel$export(module.exports, "selectChartLayout", () => $e573f10901a87cfb$export$8426b6d9af801dee);
$parcel$export(module.exports, "useChartLayout", () => $e573f10901a87cfb$export$970c79ecc7081cc);
$parcel$export(module.exports, "useCartesianChartLayout", () => $e573f10901a87cfb$export$c9942bdfc7f2781c);
$parcel$export(module.exports, "selectPolarChartLayout", () => $e573f10901a87cfb$export$d7a0004f3c7f5ca0);
$parcel$export(module.exports, "usePolarChartLayout", () => $e573f10901a87cfb$export$a5f9dd11254d5e7e);
$parcel$export(module.exports, "useIsInChartContext", () => $e573f10901a87cfb$export$a3faf3c7b8f19073);
$parcel$export(module.exports, "ReportChartSize", () => $e573f10901a87cfb$export$80ea82e77fb424e1);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $3OKeX = parcelRequire("3OKeX");

var $lnFga = parcelRequire("lnFga");

var $V5fxS = parcelRequire("V5fxS");

var $3X9hg = parcelRequire("3X9hg");

var $3o7wy = parcelRequire("3o7wy");

var $mjyu0 = parcelRequire("mjyu0");

var $iMnqX = parcelRequire("iMnqX");
var $e573f10901a87cfb$export$76b29bb074e0c45a = ()=>{
    var _useAppSelector;
    var panorama = (0, $3X9hg.useIsPanorama)();
    var rootViewBox = (0, $bqlEl.useAppSelector)((0, $lnFga.selectChartViewBox));
    var brushDimensions = (0, $bqlEl.useAppSelector)((0, $3o7wy.selectBrushDimensions));
    var brushPadding = (_useAppSelector = (0, $bqlEl.useAppSelector)((0, $3o7wy.selectBrushSettings))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var $e573f10901a87cfb$var$manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var $e573f10901a87cfb$export$10605f61bef2858a = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, $bqlEl.useAppSelector)((0, $lnFga.selectChartOffsetInternal))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : $e573f10901a87cfb$var$manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var $e573f10901a87cfb$export$8854f7ece606854b = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $V5fxS.selectChartWidth));
};
var $e573f10901a87cfb$export$369ae257969c6f9f = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $V5fxS.selectChartHeight));
};
var $e573f10901a87cfb$export$58ac794108fd8ca = ()=>{
    return (0, $bqlEl.useAppSelector)((state)=>state.layout.margin);
};
var $e573f10901a87cfb$export$8426b6d9af801dee = (state)=>state.layout.layoutType;
var $e573f10901a87cfb$export$970c79ecc7081cc = ()=>(0, $bqlEl.useAppSelector)($e573f10901a87cfb$export$8426b6d9af801dee);
var $e573f10901a87cfb$export$c9942bdfc7f2781c = ()=>{
    var layout = $e573f10901a87cfb$export$970c79ecc7081cc();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var $e573f10901a87cfb$export$d7a0004f3c7f5ca0 = (state)=>{
    var layout = state.layout.layoutType;
    if (layout === 'centric' || layout === 'radial') return layout;
    return undefined;
};
var $e573f10901a87cfb$export$a5f9dd11254d5e7e = ()=>{
    return (0, $bqlEl.useAppSelector)($e573f10901a87cfb$export$d7a0004f3c7f5ca0);
};
var $e573f10901a87cfb$export$a3faf3c7b8f19073 = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = $e573f10901a87cfb$export$970c79ecc7081cc();
    return layout !== undefined;
};
var $e573f10901a87cfb$export$80ea82e77fb424e1 = (props)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $3X9hg.useIsPanorama)();
    var widthFromProps = props.width, heightFromProps = props.height;
    var responsiveContainerCalculations = (0, $mjyu0.useResponsiveContainerContext)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, $acw62.useEffect)(()=>{
        if (!isPanorama && (0, $iMnqX.isPositiveNumber)(width) && (0, $iMnqX.isPositiveNumber)(height)) dispatch((0, $3OKeX.setChartSize)({
            width: width,
            height: height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var $e573f10901a87cfb$export$19a41f515e2a12ff = (_ref)=>{
    var margin = _ref.margin;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $3OKeX.setMargin)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};

});
parcelRegister("bqlEl", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", () => $8512ea9be24774fb$export$f51d452c10d5b956);
$parcel$export(module.exports, "useAppSelector", () => $8512ea9be24774fb$export$a7347740d65f620b);

var $5ec4p = parcelRequire("5ec4p");

var $acw62 = parcelRequire("acw62");

var $5WKOf = parcelRequire("5WKOf");
var $8512ea9be24774fb$var$noopDispatch = (a)=>a;
var $8512ea9be24774fb$export$f51d452c10d5b956 = ()=>{
    var context = (0, $acw62.useContext)((0, $5WKOf.RechartsReduxContext));
    if (context) return context.store.dispatch;
    return $8512ea9be24774fb$var$noopDispatch;
};
var $8512ea9be24774fb$var$noop = ()=>{};
var $8512ea9be24774fb$var$addNestedSubNoop = ()=>$8512ea9be24774fb$var$noop;
var $8512ea9be24774fb$var$refEquality = (a, b)=>a === b;
function $8512ea9be24774fb$export$a7347740d65f620b(selector) {
    var context = (0, $acw62.useContext)((0, $5WKOf.RechartsReduxContext));
    var outOfContextSelector = (0, $acw62.useMemo)(()=>{
        if (!context) return $8512ea9be24774fb$var$noop;
        return (state)=>{
            if (state == null) return undefined;
            return selector(state);
        };
    }, [
        context,
        selector
    ]);
    return (0, $5ec4p.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : $8512ea9be24774fb$var$addNestedSubNoop, context ? context.store.getState : $8512ea9be24774fb$var$noop, context ? context.store.getState : $8512ea9be24774fb$var$noop, outOfContextSelector, $8512ea9be24774fb$var$refEquality);
}

});
parcelRegister("5ec4p", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7EU6W"));

});

parcelRegister("5WKOf", function(module, exports) {

$parcel$export(module.exports, "RechartsReduxContext", () => $4546adee7e5b0920$export$876ef70bc88b13cb);

var $acw62 = parcelRequire("acw62");
var $4546adee7e5b0920$export$876ef70bc88b13cb = /*#__PURE__*/ (0, $acw62.createContext)(null);

});


parcelRegister("lnFga", function(module, exports) {

$parcel$export(module.exports, "selectChartOffsetInternal", () => $f90bc049d1e95f26$export$1e34c8efb0bc9b3b);
$parcel$export(module.exports, "selectChartViewBox", () => $f90bc049d1e95f26$export$fb5e3eb7f8167ce7);
$parcel$export(module.exports, "selectAxisViewBox", () => $f90bc049d1e95f26$export$32c8e778bac69ce4);

var $b0nKR = parcelRequire("b0nKR");

var $e3Mzr = parcelRequire("e3Mzr");

var $hBeJX = parcelRequire("hBeJX");

var $V5fxS = parcelRequire("V5fxS");

var $8fDe7 = parcelRequire("8fDe7");

var $lcI2N = parcelRequire("lcI2N");
function $f90bc049d1e95f26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f90bc049d1e95f26$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f90bc049d1e95f26$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f90bc049d1e95f26$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f90bc049d1e95f26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f90bc049d1e95f26$var$_defineProperty(e, r, t) {
    return (r = $f90bc049d1e95f26$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f90bc049d1e95f26$var$_toPropertyKey(t) {
    var i = $f90bc049d1e95f26$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f90bc049d1e95f26$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f90bc049d1e95f26$export$2d0a7adecb2afc9c = (state)=>state.brush.height;
function $f90bc049d1e95f26$export$72db07ad44daf749(state) {
    var yAxes = (0, $8fDe7.selectAllYAxes)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $lcI2N.DEFAULT_Y_AXIS_WIDTH);
            return result + width;
        }
        return result;
    }, 0);
}
function $f90bc049d1e95f26$export$9e22282539e03a5a(state) {
    var yAxes = (0, $8fDe7.selectAllYAxes)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, $lcI2N.DEFAULT_Y_AXIS_WIDTH);
            return result + width;
        }
        return result;
    }, 0);
}
function $f90bc049d1e95f26$export$eabd2db032aa5573(state) {
    var xAxes = (0, $8fDe7.selectAllXAxes)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) {
            var height = typeof entry.height === 'number' ? entry.height : (0, $lcI2N.DEFAULT_X_AXIS_HEIGHT);
            return result + height;
        }
        return result;
    }, 0);
}
function $f90bc049d1e95f26$export$c93fa683ef9b4701(state) {
    var xAxes = (0, $8fDe7.selectAllXAxes)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) {
            var height = typeof entry.height === 'number' ? entry.height : (0, $lcI2N.DEFAULT_X_AXIS_HEIGHT);
            return result + height;
        }
        return result;
    }, 0);
}
var $f90bc049d1e95f26$export$1e34c8efb0bc9b3b = (0, $b0nKR.createSelector)([
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight),
    (0, $V5fxS.selectMargin),
    $f90bc049d1e95f26$export$2d0a7adecb2afc9c,
    $f90bc049d1e95f26$export$72db07ad44daf749,
    $f90bc049d1e95f26$export$9e22282539e03a5a,
    $f90bc049d1e95f26$export$eabd2db032aa5573,
    $f90bc049d1e95f26$export$c93fa683ef9b4701,
    (0, $e3Mzr.selectLegendSettings),
    (0, $e3Mzr.selectLegendSize)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = $f90bc049d1e95f26$var$_objectSpread($f90bc049d1e95f26$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, $hBeJX.appendOffsetOfLegend)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return $f90bc049d1e95f26$var$_objectSpread($f90bc049d1e95f26$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var $f90bc049d1e95f26$export$fb5e3eb7f8167ce7 = (0, $b0nKR.createSelector)($f90bc049d1e95f26$export$1e34c8efb0bc9b3b, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var $f90bc049d1e95f26$export$32c8e778bac69ce4 = (0, $b0nKR.createSelector)((0, $V5fxS.selectChartWidth), (0, $V5fxS.selectChartHeight), (width, height)=>({
        x: 0,
        y: 0,
        width: width,
        height: height
    }));

});
parcelRegister("e3Mzr", function(module, exports) {

$parcel$export(module.exports, "selectLegendSettings", () => $a3c7059a0e295f7c$export$1d27a9e667f67593);
$parcel$export(module.exports, "selectLegendSize", () => $a3c7059a0e295f7c$export$c9c2b00a34f852e5);

var $b0nKR = parcelRequire("b0nKR");

var $bat1Y = parcelRequire("bat1Y");
var $a3c7059a0e295f7c$export$1d27a9e667f67593 = (state)=>state.legend.settings;
var $a3c7059a0e295f7c$export$c9c2b00a34f852e5 = (state)=>state.legend.size;
var $a3c7059a0e295f7c$var$selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var $a3c7059a0e295f7c$export$9a6de64b691a7304 = (0, $b0nKR.createSelector)([
    $a3c7059a0e295f7c$var$selectAllLegendPayload2DArray,
    $a3c7059a0e295f7c$export$1d27a9e667f67593
], (payloads, _ref)=>{
    var itemSorter = _ref.itemSorter;
    var flat = payloads.flat(1);
    return itemSorter ? (0, $bat1Y.sortBy)(flat, itemSorter) : flat;
});

});
parcelRegister("bat1Y", function(module, exports) {

$parcel$export(module.exports, "sortBy", () => $34e651a413560756$export$b035e44d7bb4278f);

var $8raxw = parcelRequire("8raxw");

var $1fg27 = parcelRequire("1fg27");

var $fKWco = parcelRequire("fKWco");
//#region src/compat/array/sortBy.ts
function $34e651a413560756$export$b035e44d7bb4278f(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && (0, $1fg27.isIterateeCall)(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && (0, $1fg27.isIterateeCall)(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return (0, $fKWco.orderBy)(collection, (0, $8raxw.flatten)(criteria), [
        "asc"
    ]);
}

});
parcelRegister("8raxw", function(module, exports) {

$parcel$export(module.exports, "flatten", () => $d4808a015175b412$export$bffa455ba8c619a6);
//#region src/array/flatten.ts
/**
* Flattens an array up to the specified depth.
*
* @template T - The type of elements within the array.
* @template D - The depth to which the array should be flattened.
* @param arr - The array to flatten.
* @param depth - The depth level specifying how deep a nested array structure should be flattened. Defaults to 1.
* @returns A new array that has been flattened.
*
* @example
* const arr = flatten([1, [2, 3], [4, [5, 6]]], 1);
* // Returns: [1, 2, 3, 4, [5, 6]]
*
* const arr = flatten([1, [2, 3], [4, [5, 6]]], 2);
* // Returns: [1, 2, 3, 4, 5, 6]
*/ function $d4808a015175b412$export$bffa455ba8c619a6(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}

});

parcelRegister("1fg27", function(module, exports) {

$parcel$export(module.exports, "isIterateeCall", () => $f75af03f8d234010$export$3063275d2c2bc620);

var $9j8Ey = parcelRequire("9j8Ey");

var $6aWEd = parcelRequire("6aWEd");

var $7OJrq = parcelRequire("7OJrq");

var $ea0n3 = parcelRequire("ea0n3");
//#region src/compat/_internal/isIterateeCall.ts
function $f75af03f8d234010$export$3063275d2c2bc620(value, index, object) {
    if (!(0, $7OJrq.isObject)(object)) return false;
    if (typeof index === "number" && (0, $6aWEd.isArrayLike)(object) && (0, $ea0n3.isIndex)(index) && index < object.length || typeof index === "string" && index in object) return (0, $9j8Ey.eq)(object[index], value);
    return false;
}

});
parcelRegister("9j8Ey", function(module, exports) {

$parcel$export(module.exports, "eq", () => $28c544e7cc98f99f$export$9663ddc1cf085b32);
//#region src/compat/util/eq.ts
/**
* Performs a `SameValueZero` comparison between two values to determine if they are equivalent.
*
* @param value The value to compare.
* @param other The other value to compare.
* @returns Returns `true` if the values are equivalent, else `false`.
*
* @example
* eq(1, 1); // true
* eq(0, -0); // true
* eq(NaN, NaN); // true
* eq('a', Object('a')); // false
*/ function $28c544e7cc98f99f$export$9663ddc1cf085b32(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}

});

parcelRegister("6aWEd", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $0521e023144d0e02$export$1e2f57719e155213);

var $fBxMk = parcelRequire("fBxMk");
//#region src/compat/predicate/isArrayLike.ts
/**
* Checks if `value` is array-like.
*
* @param value The value to check.
* @returns Returns `true` if `value` is array-like, else `false`.
*
* @example
* isArrayLike([1, 2, 3]); // true
* isArrayLike('abc'); // true
* isArrayLike({ 0: 'a', length: 1 }); // true
* isArrayLike({}); // false
* isArrayLike(null); // false
* isArrayLike(undefined); // false
*/ function $0521e023144d0e02$export$1e2f57719e155213(value) {
    return value != null && typeof value !== "function" && (0, $fBxMk.isLength)(value.length);
}

});
parcelRegister("fBxMk", function(module, exports) {

$parcel$export(module.exports, "isLength", () => $6d59df0e25679312$export$38db3d147cb3433);
//#region src/predicate/isLength.ts
/**
* Checks if a given value is a valid length.
*
* A valid length is of type `number`, is a non-negative integer, and is less than or equal to
* JavaScript's maximum safe integer (`Number.MAX_SAFE_INTEGER`).
* It returns `true` if the value is a valid length, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the
* argument to a valid length (`number`).
*
* @param value The value to check.
* @returns Returns `true` if `value` is a valid length, else `false`.
*
* @example
* isLength(0); // true
* isLength(42); // true
* isLength(-1); // false
* isLength(1.5); // false
* isLength(Number.MAX_SAFE_INTEGER); // true
* isLength(Number.MAX_SAFE_INTEGER + 1); // false
*/ function $6d59df0e25679312$export$38db3d147cb3433(value) {
    return Number.isSafeInteger(value) && value >= 0;
}

});


parcelRegister("7OJrq", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $7a97b120683fabf6$export$a6cdc56e425d0d0a);
//#region src/compat/predicate/isObject.ts
/**
* Checks if the given value is an object. An object is a value that is
* not a primitive type (string, number, boolean, symbol, null, or undefined).
*
* This function tests whether the provided value is an object or not.
* It returns `true` if the value is an object, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an object value.
*
* @param value - The value to check if it is an object.
* @returns `true` if the value is an object, `false` otherwise.
*
* @example
* const value1 = {};
* const value2 = [1, 2, 3];
* const value3 = () => {};
* const value4 = null;
*
* console.log(isObject(value1)); // true
* console.log(isObject(value2)); // true
* console.log(isObject(value3)); // true
* console.log(isObject(value4)); // false
*/ function $7a97b120683fabf6$export$a6cdc56e425d0d0a(value) {
    return value !== null && (typeof value === "object" || typeof value === "function");
}

});

parcelRegister("ea0n3", function(module, exports) {

$parcel$export(module.exports, "isIndex", () => $162f0f28880c2aa5$export$ba3dc792055c2f45);
//#region src/compat/_internal/isIndex.ts
const $162f0f28880c2aa5$var$IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function $162f0f28880c2aa5$export$ba3dc792055c2f45(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case "number":
            return Number.isInteger(value) && value >= 0 && value < length;
        case "symbol":
            return false;
        case "string":
            return $162f0f28880c2aa5$var$IS_UNSIGNED_INTEGER.test(value);
    }
}

});


parcelRegister("fKWco", function(module, exports) {

$parcel$export(module.exports, "orderBy", () => $a8df5f5a083bf071$export$f18af21d6f4dafd8);

var $6aWEd = parcelRequire("6aWEd");

var $hSotO = parcelRequire("hSotO");

var $6sYnD = parcelRequire("6sYnD");

var $l7XNg = parcelRequire("l7XNg");
//#region src/compat/array/orderBy.ts
/**
* Sorts an array of objects based on multiple properties and their corresponding order directions.
*
* This function takes an array of objects, an array of criteria to sort by, and an array of order directions.
* It returns the sorted array, ordering by each key according to its corresponding direction ('asc' for ascending or 'desc' for descending).
* If values for a key are equal, it moves to the next key to determine the order.
*
* @template T - The type of elements in the array.
* @param collection - The array of objects to be sorted.
* @param criteria - An array of criteria (property names or property paths or custom key functions) to sort by.
* @param orders - An array of order directions ('asc' for ascending or 'desc' for descending).
* @param [guard] Enables use as an iteratee for methods like `_.reduce`.
* @returns The sorted array.
*
* @example
* // Sort an array of objects by 'user' in ascending order and 'age' in descending order.
* const users = [
*   { user: 'fred', age: 48 },
*   { user: 'barney', age: 34 },
*   { user: 'fred', age: 40 },
*   { user: 'barney', age: 36 },
* ];
* const result = orderBy(users, ['user', (item) => item.age], ['asc', 'desc']);
* // result will be:
* // [
* //   { user: 'barney', age: 36 },
* //   { user: 'barney', age: 34 },
* //   { user: 'fred', age: 48 },
* //   { user: 'fred', age: 40 },
* // ]
*/ function $a8df5f5a083bf071$export$f18af21d6f4dafd8(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? void 0 : orders;
    if (!Array.isArray(collection)) collection = (0, $6aWEd.isArrayLike)(collection) ? Array.from(collection) : Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        let index = 0;
        for(; index < path.length && target != null; ++index)target = target[path[index]];
        return index > 0 && index === path.length ? target : void 0;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (criterion == null) return object;
        if (object == null) return;
        if (typeof criterion === "object" && "key" in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === "function") return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        return object[criterion];
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === "function" || Array.isArray(criterion) || (0, $l7XNg.isKey)(criterion)) return criterion;
        return {
            key: criterion,
            path: (0, $hSotO.toPath)(criterion)
        };
    });
    return collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        })).slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = (0, $6sYnD.compareValues)(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}

});
parcelRegister("6sYnD", function(module, exports) {

$parcel$export(module.exports, "compareValues", () => $093d314ced167cda$export$6ab1df3197f7c641);
//#region src/compat/_internal/compareValues.ts
function $093d314ced167cda$var$getPriority(a) {
    if (typeof a === "symbol") return 1;
    if (a === null) return 2;
    if (a === void 0) return 3;
    if (a !== a) return 4;
    return 0;
}
const $093d314ced167cda$export$6ab1df3197f7c641 = (a, b, order)=>{
    if (a !== b) {
        const aPriority = $093d314ced167cda$var$getPriority(a);
        const bPriority = $093d314ced167cda$var$getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === "desc" ? 1 : -1;
            if (a > b) return order === "desc" ? -1 : 1;
        }
        return order === "desc" ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};

});

parcelRegister("l7XNg", function(module, exports) {

$parcel$export(module.exports, "isKey", () => $cfc217be5874d5be$export$863054953f77118);

var $79zhJ = parcelRequire("79zhJ");
//#region src/compat/_internal/isKey.ts
/**  Matches any deep property path. (e.g. `a.b[0].c`)*/ const $cfc217be5874d5be$var$regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
/**  Matches any word character (alphanumeric & underscore).*/ const $cfc217be5874d5be$var$regexIsPlainProp = /^\w*$/;
/**
* Checks if `value` is a property name and not a property path. (It's ok that the `value` is not in the keys of the `object`)
* @param {unknown} value The value to check.
* @param {unknown} object The object to query.
* @returns {boolean} Returns `true` if `value` is a property name, else `false`.
*
* @example
* isKey('a', { a: 1 });
* // => true
*
* isKey('a.b', { a: { b: 2 } });
* // => false
*/ function $cfc217be5874d5be$export$863054953f77118(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === "number" || typeof value === "boolean" || value == null || (0, $79zhJ.isSymbol)(value)) return true;
    return typeof value === "string" && ($cfc217be5874d5be$var$regexIsPlainProp.test(value) || !$cfc217be5874d5be$var$regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}

});
parcelRegister("79zhJ", function(module, exports) {

$parcel$export(module.exports, "isSymbol", () => $80af8a860ecf7627$export$a244864fd9645c7f);
//#region src/compat/predicate/isSymbol.ts
/**
* Check whether a value is a symbol.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `symbol`.
*
* @param value The value to check.
* @returns Returns `true` if `value` is a symbol, else `false`.
* @example
* isSymbol(Symbol.iterator);
* // => true
*
* isSymbol('abc');
* // => false
*/ function $80af8a860ecf7627$export$a244864fd9645c7f(value) {
    return typeof value === "symbol" || value instanceof Symbol;
}

});





parcelRegister("hBeJX", function(module, exports) {

$parcel$export(module.exports, "getValueByDataKey", () => $cd015374923bb5c7$export$f97fc4a450f29a);
$parcel$export(module.exports, "appendOffsetOfLegend", () => $cd015374923bb5c7$export$3a657a8c9f789617);
$parcel$export(module.exports, "isCategoricalAxis", () => $cd015374923bb5c7$export$9fc1baaa6c6368b);
$parcel$export(module.exports, "getCoordinatesOfGrid", () => $cd015374923bb5c7$export$846dc5ac5fecff74);
$parcel$export(module.exports, "getTicksOfAxis", () => $cd015374923bb5c7$export$c829ee42daf7f66d);
$parcel$export(module.exports, "truncateByDomain", () => $cd015374923bb5c7$export$c7ec0fa96d0c462e);
$parcel$export(module.exports, "getStackedData", () => $cd015374923bb5c7$export$c2170542cfc0177c);
$parcel$export(module.exports, "getNormalizedStackId", () => $cd015374923bb5c7$export$f0871da41ca7fc82);
$parcel$export(module.exports, "getCateCoordinateOfLine", () => $cd015374923bb5c7$export$6e87f3defb83c3f);
$parcel$export(module.exports, "getCateCoordinateOfBar", () => $cd015374923bb5c7$export$8abb9e87422f3a0c);
$parcel$export(module.exports, "getBaseValueOfBar", () => $cd015374923bb5c7$export$54f3200dd4a8a235);
$parcel$export(module.exports, "getDomainOfStackGroups", () => $cd015374923bb5c7$export$26522b779eb5497c);
$parcel$export(module.exports, "MIN_VALUE_REG", () => $cd015374923bb5c7$export$75a7b23ff266dfa1);
$parcel$export(module.exports, "MAX_VALUE_REG", () => $cd015374923bb5c7$export$19c111ec8ad6c644);
$parcel$export(module.exports, "getBandSizeOfAxis", () => $cd015374923bb5c7$export$212ec45c42fe68a7);
$parcel$export(module.exports, "getTooltipEntry", () => $cd015374923bb5c7$export$3c1b390368bb3561);
$parcel$export(module.exports, "getTooltipNameProp", () => $cd015374923bb5c7$export$d3207de44081d2b3);
$parcel$export(module.exports, "calculateCartesianTooltipPos", () => $cd015374923bb5c7$export$f29fac779ccd75bc);
$parcel$export(module.exports, "calculatePolarTooltipPos", () => $cd015374923bb5c7$export$fb2b0f76aa25d837);

var $bat1Y = parcelRequire("bat1Y");

var $iqxMM = parcelRequire("iqxMM");
parcelRequire("5Dy28");
var $9WbuT = parcelRequire("9WbuT");
var $6YXkO = parcelRequire("6YXkO");
var $h1A7q = parcelRequire("h1A7q");
var $cOCCM = parcelRequire("cOCCM");
var $lXa0k = parcelRequire("lXa0k");
var $8y1Jf = parcelRequire("8y1Jf");

var $3FiDp = parcelRequire("3FiDp");

var $gDbhy = parcelRequire("gDbhy");

var $iMnqX = parcelRequire("iMnqX");

var $ibeE1 = parcelRequire("ibeE1");
function $cd015374923bb5c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd015374923bb5c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd015374923bb5c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cd015374923bb5c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd015374923bb5c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cd015374923bb5c7$var$_defineProperty(e, r, t) {
    return (r = $cd015374923bb5c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $cd015374923bb5c7$var$_toPropertyKey(t) {
    var i = $cd015374923bb5c7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $cd015374923bb5c7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cd015374923bb5c7$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, $3FiDp.isNullish)(obj) || (0, $3FiDp.isNullish)(dataKey)) return defaultValue;
    if ((0, $3FiDp.isNumOrStr)(dataKey)) return (0, $iqxMM.get)(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var $cd015374923bb5c7$export$3a657a8c9f789617 = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var boxWidth = legendSize.width, boxHeight = legendSize.height;
        var align = legendSettings.align, verticalAlign = legendSettings.verticalAlign, layout = legendSettings.layout, position = legendSettings.position, _legendSettings$offse = legendSettings.offset, legendOffset = _legendSettings$offse === void 0 ? 0 : _legendSettings$offse;
        if (position != null) {
            // Position-based legends are absolutely placed. They only move the plot area if they are positioned outside.
            if ((0, $ibeE1.isOutsidePosition)(position)) {
                if (position === 'top' && (0, $3FiDp.isNumber)(offset.top)) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
                    top: offset.top + (boxHeight || 0) + legendOffset
                });
                if (position === 'bottom' && (0, $3FiDp.isNumber)(offset.bottom)) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
                    bottom: offset.bottom + (boxHeight || 0) + legendOffset
                });
                if (position === 'left' && (0, $3FiDp.isNumber)(offset.left)) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
                    left: offset.left + (boxWidth || 0) + legendOffset
                });
                if (position === 'right' && (0, $3FiDp.isNumber)(offset.right)) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
                    right: offset.right + (boxWidth || 0) + legendOffset
                });
            }
            return offset;
        }
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $3FiDp.isNumber)(offset[align])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $3FiDp.isNumber)(offset[verticalAlign])) return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var $cd015374923bb5c7$export$9fc1baaa6c6368b = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var $cd015374923bb5c7$export$846dc5ac5fecff74 = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cd015374923bb5c7$export$c829ee42daf7f66d = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range, scale = axis.scale, realScaleType = axis.realScaleType, isCategorical = axis.isCategorical, categoricalDomain = axis.categoricalDomain, tickCount = axis.tickCount, ticks = axis.ticks, niceTicks = axis.niceTicks, axisType = axis.axisType;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, $3FiDp.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            var scaled = scale.map(scaleContent);
            if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scaled + offset,
                value: entry,
                offset: offset,
                index: index
            };
        }).filter((0, $3FiDp.isNotNil));
        return result;
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    // For type='number' with niceTicks available, skip this branch so ticks are evenly spaced (GitHub issue #4271)
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
};
var $cd015374923bb5c7$export$c7ec0fa96d0c462e = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, $3FiDp.isNumber)(domain[0]) || !(0, $3FiDp.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $3FiDp.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $3FiDp.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cd015374923bb5c7$export$3104c513558164c1 = (series)=>{
    var _series$;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var series1 = col[1];
            var series0 = col[0];
            var value = (0, $3FiDp.isNan)(series1) ? series0 : series1;
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = negative;
                negative += value;
                col[1] = negative;
            }
        }
    }
};
var $cd015374923bb5c7$export$9f2c6ead70935022 = (series)=>{
    var _series$2;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var value = (0, $3FiDp.isNan)(col[1]) ? col[0] : col[1];
            if (value >= 0) {
                col[0] = positive;
                positive += value;
                col[1] = positive;
            } else {
                col[0] = 0;
                col[1] = 0;
            }
        }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cd015374923bb5c7$var$STACK_OFFSET_MAP = {
    sign: $cd015374923bb5c7$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $6YXkO.default),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $h1A7q.default),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $cOCCM.default),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $lXa0k.default),
    positive: $cd015374923bb5c7$export$9f2c6ead70935022
};
var $cd015374923bb5c7$export$c2170542cfc0177c = (data, dataKeys, offsetType)=>{
    var _STACK_OFFSET_MAP$off;
    var offsetAccessor = (_STACK_OFFSET_MAP$off = $cd015374923bb5c7$var$STACK_OFFSET_MAP[offsetType]) !== null && _STACK_OFFSET_MAP$off !== void 0 ? _STACK_OFFSET_MAP$off : (0, $h1A7q.default);
    var stack = (0, $9WbuT.default)().keys(dataKeys).value((d, key)=>Number($cd015374923bb5c7$export$f97fc4a450f29a(d, key, 0))).order((0, $8y1Jf.default))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    var result = stack(data);
    // Post-process ranged data: if value is an array of two numbers, use them directly without stacking
    result.forEach((series, seriesIndex)=>{
        series.forEach((point, pointIndex)=>{
            var value = $cd015374923bb5c7$export$f97fc4a450f29a(data[pointIndex], dataKeys[seriesIndex], 0);
            if (Array.isArray(value) && value.length === 2 && (0, $3FiDp.isNumber)(value[0]) && (0, $3FiDp.isNumber)(value[1])) {
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[0] = value[0];
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[1] = value[1];
            }
        });
    });
    return result;
};
function $cd015374923bb5c7$export$f0871da41ca7fc82(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function $cd015374923bb5c7$export$6e87f3defb83c3f(_ref) {
    var axis = _ref.axis, ticks = _ref.ticks, bandSize = _ref.bandSize, entry = _ref.entry, index = _ref.index, dataKey = _ref.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, $3FiDp.isNullish)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $3FiDp.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks !== null && ticks !== void 0 && ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, !(0, $3FiDp.isNullish)(dataKey) ? dataKey : axis.dataKey);
    var scaled = axis.scale.map(value);
    if (!(0, $3FiDp.isNumber)(scaled)) return null;
    return scaled;
}
var $cd015374923bb5c7$export$8abb9e87422f3a0c = (_ref2)=>{
    var axis = _ref2.axis, ticks = _ref2.ticks, offset = _ref2.offset, bandSize = _ref2.bandSize, entry = _ref2.entry, index = _ref2.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    // getValueByDataKey does not validate the output type
    var value = $cd015374923bb5c7$export$f97fc4a450f29a(entry, axis.dataKey, axis.scale.domain()[index]);
    if ((0, $3FiDp.isNullish)(value)) return null;
    var scaled = axis.scale.map(value);
    if (!(0, $3FiDp.isNumber)(scaled)) return null;
    return scaled - bandSize / 2 + offset;
};
var $cd015374923bb5c7$export$54f3200dd4a8a235 = (_ref3)=>{
    var numericAxis = _ref3.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cd015374923bb5c7$var$getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, $3FiDp.isNumber));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var $cd015374923bb5c7$var$makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var $cd015374923bb5c7$export$26522b779eb5497c = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null || Object.keys(stackGroups).length === 0) return undefined;
    return $cd015374923bb5c7$var$makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        if (!group) return result;
        var stackedData = group.stackedData;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, $gDbhy.getSliced)(entry, startIndex, endIndex);
            var s = $cd015374923bb5c7$var$getDomainOfSingle(sliced);
            if (!(0, $iMnqX.isWellBehavedNumber)(s[0]) || !(0, $iMnqX.isWellBehavedNumber)(s[1])) return res;
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var $cd015374923bb5c7$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cd015374923bb5c7$export$212ec45c42fe68a7 = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, $bat1Y.sortBy)(ticks, (o)=>o.coordinate);
        // Collect the pixel gaps between adjacent category positions and track the
        // widest one.
        var gaps = [];
        var maxGap = 0;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var _orderedTicks$i, _orderedTicks;
            var gap = (((_orderedTicks$i = orderedTicks[i]) === null || _orderedTicks$i === void 0 ? void 0 : _orderedTicks$i.coordinate) || 0) - (((_orderedTicks = orderedTicks[i - 1]) === null || _orderedTicks === void 0 ? void 0 : _orderedTicks.coordinate) || 0);
            gaps.push(gap);
            maxGap = Math.max(gap, maxGap);
        }
        // High-precision float values can place two ticks at (almost) the same pixel,
        // producing a spurious sub-pixel gap. Such near-coincident positions are the
        // same category slot for rendering purposes and must not define the band
        // size, otherwise every bar collapses to ~0px wide (issue #4043). Ignore gaps
        // that are a negligible fraction of the widest gap so a single near-duplicate
        // value cannot dictate the spacing.
        var minMeaningfulGap = maxGap * 1e-4;
        var bandSize = Infinity;
        for (var _gap of gaps)if (_gap > minMeaningfulGap) bandSize = Math.min(_gap, bandSize);
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function $cd015374923bb5c7$export$3c1b390368bb3561(_ref4) {
    var tooltipEntrySettings = _ref4.tooltipEntrySettings, dataKey = _ref4.dataKey, payload = _ref4.payload, value = _ref4.value, name = _ref4.name;
    return $cd015374923bb5c7$var$_objectSpread($cd015374923bb5c7$var$_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey: dataKey,
        payload: payload,
        value: value,
        name: name
    });
}
function $cd015374923bb5c7$export$d3207de44081d2b3(nameFromItem, dataKey) {
    if (nameFromItem != null) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var $cd015374923bb5c7$export$f29fac779ccd75bc = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.relativeX;
    if (layout === 'vertical') return coordinate.relativeY;
    return undefined;
};
var $cd015374923bb5c7$export$fb2b0f76aa25d837 = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};

});
parcelRegister("5Dy28", function(module, exports) {

$parcel$export(module.exports, "area", () => (parcelRequire("fEwLW")).default);
$parcel$export(module.exports, "curveBasis", () => (parcelRequire("6QL1t")).default);
$parcel$export(module.exports, "curveBasisClosed", () => (parcelRequire("2515N")).default);
$parcel$export(module.exports, "curveBasisOpen", () => (parcelRequire("e1bEB")).default);
$parcel$export(module.exports, "curveBumpX", () => (parcelRequire("gpIrV")).bumpX);
$parcel$export(module.exports, "curveBumpY", () => (parcelRequire("gpIrV")).bumpY);
$parcel$export(module.exports, "curveLinear", () => (parcelRequire("gEcf1")).default);
$parcel$export(module.exports, "curveLinearClosed", () => (parcelRequire("4CT3t")).default);
$parcel$export(module.exports, "curveMonotoneX", () => (parcelRequire("hp3ls")).monotoneX);
$parcel$export(module.exports, "curveMonotoneY", () => (parcelRequire("hp3ls")).monotoneY);
$parcel$export(module.exports, "curveNatural", () => (parcelRequire("kjPWc")).default);
$parcel$export(module.exports, "curveStep", () => (parcelRequire("1zRZO")).default);
$parcel$export(module.exports, "curveStepAfter", () => (parcelRequire("1zRZO")).stepAfter);
$parcel$export(module.exports, "curveStepBefore", () => (parcelRequire("1zRZO")).stepBefore);
$parcel$export(module.exports, "line", () => (parcelRequire("5ti2H")).default);
$parcel$export(module.exports, "stack", () => (parcelRequire("9WbuT")).default);
$parcel$export(module.exports, "stackOffsetExpand", () => (parcelRequire("6YXkO")).default);
$parcel$export(module.exports, "stackOffsetNone", () => (parcelRequire("h1A7q")).default);
$parcel$export(module.exports, "stackOffsetSilhouette", () => (parcelRequire("cOCCM")).default);
$parcel$export(module.exports, "stackOffsetWiggle", () => (parcelRequire("lXa0k")).default);
$parcel$export(module.exports, "stackOrderNone", () => (parcelRequire("8y1Jf")).default);
// `victory-vendor/d3-shape` (ESM)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our ESM package uses the underlying installed dependencies of `node_modules/d3-shape`

var $fEwLW = parcelRequire("fEwLW");
var $6QL1t = parcelRequire("6QL1t");
var $2515N = parcelRequire("2515N");
var $e1bEB = parcelRequire("e1bEB");
var $gpIrV = parcelRequire("gpIrV");
var $gEcf1 = parcelRequire("gEcf1");
var $4CT3t = parcelRequire("4CT3t");
var $hp3ls = parcelRequire("hp3ls");
var $kjPWc = parcelRequire("kjPWc");
var $1zRZO = parcelRequire("1zRZO");
var $5ti2H = parcelRequire("5ti2H");
var $9WbuT = parcelRequire("9WbuT");
var $6YXkO = parcelRequire("6YXkO");
var $h1A7q = parcelRequire("h1A7q");
var $cOCCM = parcelRequire("cOCCM");
var $lXa0k = parcelRequire("lXa0k");
var $8y1Jf = parcelRequire("8y1Jf");

});
parcelRegister("fEwLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b654034e6c52569c$export$2e2bcd8739ae039);

var $fh6WC = parcelRequire("fh6WC");

var $7HXTO = parcelRequire("7HXTO");

var $gEcf1 = parcelRequire("gEcf1");

var $5ti2H = parcelRequire("5ti2H");

var $7UVQV = parcelRequire("7UVQV");

var $kfOCT = parcelRequire("kfOCT");
function $b654034e6c52569c$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $7HXTO.default)(true), context = null, curve = (0, $gEcf1.default), output = null, path = (0, $7UVQV.withPath)(area);
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $kfOCT.x) : (0, $7HXTO.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $7HXTO.default)(0) : (0, $7HXTO.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $kfOCT.y) : (0, $7HXTO.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $fh6WC.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $5ti2H.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7HXTO.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("fh6WC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1edd492c2923d6f$export$2e2bcd8739ae039);
var $b1edd492c2923d6f$export$58adb3bec8346d0f = Array.prototype.slice;
function $b1edd492c2923d6f$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("7HXTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $59cb0344df9474fa$export$2e2bcd8739ae039);
function $59cb0344df9474fa$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("gEcf1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1e9e09d9174b864$export$2e2bcd8739ae039);
function $c1e9e09d9174b864$var$Linear(context) {
    this._context = context;
}
$c1e9e09d9174b864$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1e9e09d9174b864$export$2e2bcd8739ae039(context) {
    return new $c1e9e09d9174b864$var$Linear(context);
}

});

parcelRegister("5ti2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fbda81220c6ea9c$export$2e2bcd8739ae039);

var $fh6WC = parcelRequire("fh6WC");

var $7HXTO = parcelRequire("7HXTO");

var $gEcf1 = parcelRequire("gEcf1");

var $7UVQV = parcelRequire("7UVQV");

var $kfOCT = parcelRequire("kfOCT");
function $3fbda81220c6ea9c$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $7HXTO.default)(true), context = null, curve = (0, $gEcf1.default), output = null, path = (0, $7UVQV.withPath)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $kfOCT.x) : (0, $7HXTO.default)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $kfOCT.y) : (0, $7HXTO.default)(y);
    function line(data) {
        var i, n = (data = (0, $fh6WC.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7HXTO.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("7UVQV", function(module, exports) {

$parcel$export(module.exports, "withPath", () => $5c3aa3aea2c844cf$export$fb6e83118a5dcd45);

var $hl2Bj = parcelRequire("hl2Bj");
function $5c3aa3aea2c844cf$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $hl2Bj.Path)(digits);
}

});
parcelRegister("hl2Bj", function(module, exports) {

$parcel$export(module.exports, "Path", () => $c9f66a4d1c06b373$export$4b2950bdac9b6ee9);
const $c9f66a4d1c06b373$var$pi = Math.PI, $c9f66a4d1c06b373$var$tau = 2 * $c9f66a4d1c06b373$var$pi, $c9f66a4d1c06b373$var$epsilon = 1e-6, $c9f66a4d1c06b373$var$tauEpsilon = $c9f66a4d1c06b373$var$tau - $c9f66a4d1c06b373$var$epsilon;
function $c9f66a4d1c06b373$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $c9f66a4d1c06b373$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $c9f66a4d1c06b373$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $c9f66a4d1c06b373$export$4b2950bdac9b6ee9 {
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $c9f66a4d1c06b373$var$append : $c9f66a4d1c06b373$var$appendRound(digits);
    }
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $c9f66a4d1c06b373$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $c9f66a4d1c06b373$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($c9f66a4d1c06b373$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $c9f66a4d1c06b373$var$epsilon || Math.abs(this._y1 - y0) > $c9f66a4d1c06b373$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $c9f66a4d1c06b373$var$tau + $c9f66a4d1c06b373$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $c9f66a4d1c06b373$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $c9f66a4d1c06b373$var$epsilon) this._append`A${r},${r},0,${+(da >= $c9f66a4d1c06b373$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
}
function $c9f66a4d1c06b373$export$bb654e07daaf8c3a() {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$c9f66a4d1c06b373$export$bb654e07daaf8c3a.prototype = $c9f66a4d1c06b373$export$4b2950bdac9b6ee9.prototype;
function $c9f66a4d1c06b373$export$e181c6ece8d9cc5f(digits = 3) {
    return new $c9f66a4d1c06b373$export$4b2950bdac9b6ee9(+digits);
}

});


parcelRegister("kfOCT", function(module, exports) {

$parcel$export(module.exports, "x", () => $ebec7ab58e49c436$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $ebec7ab58e49c436$export$4a5767248b18ef41);
function $ebec7ab58e49c436$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $ebec7ab58e49c436$export$4a5767248b18ef41(p) {
    return p[1];
}

});



parcelRegister("6QL1t", function(module, exports) {

$parcel$export(module.exports, "point", () => $4fcc1327a5d07e55$export$105684a3041cb6f3);
$parcel$export(module.exports, "default", () => $4fcc1327a5d07e55$export$2e2bcd8739ae039);
function $4fcc1327a5d07e55$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $4fcc1327a5d07e55$export$957f7263e89bedd2(context) {
    this._context = context;
}
$4fcc1327a5d07e55$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $4fcc1327a5d07e55$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4fcc1327a5d07e55$export$2e2bcd8739ae039(context) {
    return new $4fcc1327a5d07e55$export$957f7263e89bedd2(context);
}

});

parcelRegister("2515N", function(module, exports) {

$parcel$export(module.exports, "default", () => $183ce554afe8c6f0$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");

var $6QL1t = parcelRequire("6QL1t");
function $183ce554afe8c6f0$var$BasisClosed(context) {
    this._context = context;
}
$183ce554afe8c6f0$var$BasisClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $183ce554afe8c6f0$export$2e2bcd8739ae039(context) {
    return new $183ce554afe8c6f0$var$BasisClosed(context);
}

});
parcelRegister("9R4F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $72ccadd7b0a5f010$export$2e2bcd8739ae039);
function $72ccadd7b0a5f010$export$2e2bcd8739ae039() {}

});


parcelRegister("e1bEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a34a32e088f640bf$export$2e2bcd8739ae039);

var $6QL1t = parcelRequire("6QL1t");
function $a34a32e088f640bf$var$BasisOpen(context) {
    this._context = context;
}
$a34a32e088f640bf$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $6QL1t.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $a34a32e088f640bf$export$2e2bcd8739ae039(context) {
    return new $a34a32e088f640bf$var$BasisOpen(context);
}

});

parcelRegister("gpIrV", function(module, exports) {

$parcel$export(module.exports, "bumpX", () => $bf3175dc82ec4a49$export$2c099b5096f70ce6);
$parcel$export(module.exports, "bumpY", () => $bf3175dc82ec4a49$export$908da9dfa54cbed6);

var $c0euB = parcelRequire("c0euB");
class $bf3175dc82ec4a49$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $bf3175dc82ec4a49$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point === 0) this._point = 1;
        else {
            const p0 = (0, $c0euB.default)(this._x0, this._y0);
            const p1 = (0, $c0euB.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $c0euB.default)(x, this._y0);
            const p3 = (0, $c0euB.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
        this._x0 = x, this._y0 = y;
    }
}
function $bf3175dc82ec4a49$export$2c099b5096f70ce6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, true);
}
function $bf3175dc82ec4a49$export$908da9dfa54cbed6(context) {
    return new $bf3175dc82ec4a49$var$Bump(context, false);
}
function $bf3175dc82ec4a49$export$8c82a77a5061b331(context) {
    return new $bf3175dc82ec4a49$var$BumpRadial(context);
}

});
parcelRegister("c0euB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd0ba086b92e84b$export$2e2bcd8739ae039);
function $8bd0ba086b92e84b$export$2e2bcd8739ae039(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});


parcelRegister("4CT3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $35e56ad4997e8f65$export$2e2bcd8739ae039);

var $9R4F2 = parcelRequire("9R4F2");
function $35e56ad4997e8f65$var$LinearClosed(context) {
    this._context = context;
}
$35e56ad4997e8f65$var$LinearClosed.prototype = {
    areaStart: (0, $9R4F2.default),
    areaEnd: (0, $9R4F2.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $35e56ad4997e8f65$export$2e2bcd8739ae039(context) {
    return new $35e56ad4997e8f65$var$LinearClosed(context);
}

});

parcelRegister("hp3ls", function(module, exports) {

$parcel$export(module.exports, "monotoneX", () => $cab75dc01e66b193$export$99563b5420dbdc55);
$parcel$export(module.exports, "monotoneY", () => $cab75dc01e66b193$export$8b5360456d6bdb88);
function $cab75dc01e66b193$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cab75dc01e66b193$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cab75dc01e66b193$var$sign(s0) + $cab75dc01e66b193$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cab75dc01e66b193$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cab75dc01e66b193$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cab75dc01e66b193$var$MonotoneX(context) {
    this._context = context;
}
$cab75dc01e66b193$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cab75dc01e66b193$var$point(this, this._t0, $cab75dc01e66b193$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cab75dc01e66b193$var$point(this, $cab75dc01e66b193$var$slope2(this, t1 = $cab75dc01e66b193$var$slope3(this, x, y)), t1);
                break;
            default:
                $cab75dc01e66b193$var$point(this, this._t0, t1 = $cab75dc01e66b193$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cab75dc01e66b193$var$MonotoneY(context) {
    this._context = new $cab75dc01e66b193$var$ReflectContext(context);
}
($cab75dc01e66b193$var$MonotoneY.prototype = Object.create($cab75dc01e66b193$var$MonotoneX.prototype)).point = function(x, y) {
    $cab75dc01e66b193$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cab75dc01e66b193$var$ReflectContext(context) {
    this._context = context;
}
$cab75dc01e66b193$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cab75dc01e66b193$export$99563b5420dbdc55(context) {
    return new $cab75dc01e66b193$var$MonotoneX(context);
}
function $cab75dc01e66b193$export$8b5360456d6bdb88(context) {
    return new $cab75dc01e66b193$var$MonotoneY(context);
}

});

parcelRegister("kjPWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaddebfc9069a1b$export$2e2bcd8739ae039);
function $ecaddebfc9069a1b$var$Natural(context) {
    this._context = context;
}
$ecaddebfc9069a1b$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ecaddebfc9069a1b$var$controlPoints(x), py = $ecaddebfc9069a1b$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ecaddebfc9069a1b$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ecaddebfc9069a1b$export$2e2bcd8739ae039(context) {
    return new $ecaddebfc9069a1b$var$Natural(context);
}

});

parcelRegister("1zRZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1262f1c88e9696b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "stepBefore", () => $1262f1c88e9696b5$export$10eafa5b7478b343);
$parcel$export(module.exports, "stepAfter", () => $1262f1c88e9696b5$export$793b3db073781cbb);
function $1262f1c88e9696b5$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$1262f1c88e9696b5$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $1262f1c88e9696b5$export$2e2bcd8739ae039(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0.5);
}
function $1262f1c88e9696b5$export$10eafa5b7478b343(context) {
    return new $1262f1c88e9696b5$var$Step(context, 0);
}
function $1262f1c88e9696b5$export$793b3db073781cbb(context) {
    return new $1262f1c88e9696b5$var$Step(context, 1);
}

});

parcelRegister("9WbuT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c272f50974b1c6$export$2e2bcd8739ae039);

var $fh6WC = parcelRequire("fh6WC");

var $7HXTO = parcelRequire("7HXTO");

var $h1A7q = parcelRequire("h1A7q");

var $8y1Jf = parcelRequire("8y1Jf");
function $73c272f50974b1c6$var$stackValue(d, key) {
    return d[key];
}
function $73c272f50974b1c6$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $73c272f50974b1c6$export$2e2bcd8739ae039() {
    var keys = (0, $7HXTO.default)([]), order = (0, $8y1Jf.default), offset = (0, $h1A7q.default), value = $73c272f50974b1c6$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $73c272f50974b1c6$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $fh6WC.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $7HXTO.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $7HXTO.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $8y1Jf.default) : typeof _ === "function" ? _ : (0, $7HXTO.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $h1A7q.default) : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("h1A7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c64e8c12a3952a1f$export$2e2bcd8739ae039);
function $c64e8c12a3952a1f$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("8y1Jf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6392d700c6254b89$export$2e2bcd8739ae039);
function $6392d700c6254b89$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("6YXkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $51565f53ec41433e$export$2e2bcd8739ae039);

var $h1A7q = parcelRequire("h1A7q");
function $51565f53ec41433e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $h1A7q.default)(series, order);
}

});

parcelRegister("cOCCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $95481d90954f4963$export$2e2bcd8739ae039);

var $h1A7q = parcelRequire("h1A7q");
function $95481d90954f4963$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $h1A7q.default)(series, order);
}

});

parcelRegister("lXa0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb6de494d457d9e$export$2e2bcd8739ae039);

var $h1A7q = parcelRequire("h1A7q");
function $ffb6de494d457d9e$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $h1A7q.default)(series, order);
}

});


parcelRegister("gDbhy", function(module, exports) {

$parcel$export(module.exports, "getSliced", () => $c1b90a42ae6f9682$export$238176e5211cdc1a);
function $c1b90a42ae6f9682$export$238176e5211cdc1a(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}

});

parcelRegister("ibeE1", function(module, exports) {

$parcel$export(module.exports, "getCartesianPosition", () => $d3c49d2682758394$export$524d3fb4d123c796);
$parcel$export(module.exports, "isOutsidePosition", () => $d3c49d2682758394$export$be8317e17236ae83);

var $3FiDp = parcelRequire("3FiDp");

var $ha3DD = parcelRequire("ha3DD");
function $d3c49d2682758394$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d3c49d2682758394$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d3c49d2682758394$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d3c49d2682758394$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d3c49d2682758394$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d3c49d2682758394$var$_defineProperty(e, r, t) {
    return (r = $d3c49d2682758394$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d3c49d2682758394$var$_toPropertyKey(t) {
    var i = $d3c49d2682758394$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d3c49d2682758394$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d3c49d2682758394$export$524d3fb4d123c796 = (options)=>{
    var viewBox = options.viewBox, position = options.position, _options$offset = options.offset, offset = _options$offset === void 0 ? 0 : _options$offset, parentViewBoxFromOptions = options.parentViewBox, clamp = options.clamp;
    var _cartesianViewBoxToTr = (0, $ha3DD.cartesianViewBoxToTrapezoid)(viewBox), x = _cartesianViewBoxToTr.x, y = _cartesianViewBoxToTr.y, height = _cartesianViewBoxToTr.height, upperWidth = _cartesianViewBoxToTr.upperWidth, lowerWidth = _cartesianViewBoxToTr.lowerWidth;
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    // We assume parentViewBox is generic if provided.
    // The user has asserted that parentViewBox will be CartesianViewBoxRequired if present.
    var parentViewBox = parentViewBoxFromOptions;
    if (position === 'top') {
        var result = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        if (clamp && parentViewBox) {
            result.height = Math.max(y - parentViewBox.y, 0);
            result.width = upperWidth;
        }
        return result;
    }
    if (position === 'bottom') {
        var _result = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            horizontalAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        if (clamp && parentViewBox) {
            _result.height = Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0);
            _result.width = lowerWidth;
        }
        return _result;
    }
    if (position === 'left') {
        var _result2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result2.width = Math.max(_result2.x - parentViewBox.x, 0);
            _result2.height = height;
        }
        return _result2;
    }
    if (position === 'right') {
        var _result3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            horizontalAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        if (clamp && parentViewBox) {
            _result3.width = Math.max(parentViewBox.x + parentViewBox.width - _result3.x, 0);
            _result3.height = height;
        }
        return _result3;
    }
    var sizeAttrs = clamp && parentViewBox ? {
        width: midHeightWidth,
        height: height
    } : {};
    if (position === 'insideLeft') return $d3c49d2682758394$var$_objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $d3c49d2682758394$var$_objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        horizontalAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $d3c49d2682758394$var$_objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $d3c49d2682758394$var$_objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        horizontalAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, $3FiDp.isNumber)(position.x) || (0, $3FiDp.isPercent)(position.x)) && ((0, $3FiDp.isNumber)(position.y) || (0, $3FiDp.isPercent)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return $d3c49d2682758394$var$_objectSpread({
        x: x + (0, $3FiDp.getPercentValue)(position.x, midHeightWidth),
        y: y + (0, $3FiDp.getPercentValue)(position.y, height),
        horizontalAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $d3c49d2682758394$var$_objectSpread({
        x: centerX,
        y: y + height / 2,
        horizontalAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $d3c49d2682758394$var$absolutePositions = [
    'top',
    'left',
    'right',
    'bottom'
];
function $d3c49d2682758394$export$be8317e17236ae83(position) {
    if (position == null) return false;
    if (typeof position === 'object') return true;
    return $d3c49d2682758394$var$absolutePositions.includes(position);
}

});
parcelRegister("ha3DD", function(module, exports) {

$parcel$export(module.exports, "cartesianViewBoxToTrapezoid", () => $c7e63154f7ceb9ed$export$94a03fc5d61f2504);
function $c7e63154f7ceb9ed$export$94a03fc5d61f2504(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}

});



parcelRegister("V5fxS", function(module, exports) {

$parcel$export(module.exports, "selectChartWidth", () => $0ab9657931cbbb24$export$771ef0ac044f724d);
$parcel$export(module.exports, "selectChartHeight", () => $0ab9657931cbbb24$export$5856a7d94c109505);
$parcel$export(module.exports, "selectContainerScale", () => $0ab9657931cbbb24$export$317b55dda5fb5617);
$parcel$export(module.exports, "selectMargin", () => $0ab9657931cbbb24$export$aa3aa1fbf76377f0);
var $0ab9657931cbbb24$export$771ef0ac044f724d = (state)=>state.layout.width;
var $0ab9657931cbbb24$export$5856a7d94c109505 = (state)=>state.layout.height;
var $0ab9657931cbbb24$export$317b55dda5fb5617 = (state)=>state.layout.scale;
var $0ab9657931cbbb24$export$aa3aa1fbf76377f0 = (state)=>state.layout.margin;

});

parcelRegister("8fDe7", function(module, exports) {

$parcel$export(module.exports, "selectAllXAxes", () => $601e2713d7fc7a32$export$bd320344232f30af);
$parcel$export(module.exports, "selectAllYAxes", () => $601e2713d7fc7a32$export$e22adabb0128cf25);

var $b0nKR = parcelRequire("b0nKR");
var $601e2713d7fc7a32$export$bd320344232f30af = (0, $b0nKR.createSelector)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var $601e2713d7fc7a32$export$e22adabb0128cf25 = (0, $b0nKR.createSelector)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});

});

parcelRegister("lcI2N", function(module, exports) {

$parcel$export(module.exports, "DATA_ITEM_INDEX_ATTRIBUTE_NAME", () => $f6fce23ac63eec53$export$c0f3d78d63b3e065);
$parcel$export(module.exports, "DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME", () => $f6fce23ac63eec53$export$5c80c48c1d137460);
$parcel$export(module.exports, "DEFAULT_Y_AXIS_WIDTH", () => $f6fce23ac63eec53$export$fb6ee82c8ee2faf8);
$parcel$export(module.exports, "DEFAULT_X_AXIS_HEIGHT", () => $f6fce23ac63eec53$export$45282e20cb965f6a);
var $f6fce23ac63eec53$export$db34c3e22d611955 = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var $f6fce23ac63eec53$export$c0f3d78d63b3e065 = 'data-recharts-item-index';
var $f6fce23ac63eec53$export$5c80c48c1d137460 = 'data-recharts-item-id';
var $f6fce23ac63eec53$export$fb6ee82c8ee2faf8 = 60;
var $f6fce23ac63eec53$export$45282e20cb965f6a = 30;

});


parcelRegister("3X9hg", function(module, exports) {

$parcel$export(module.exports, "useIsPanorama", () => $2e0e14143329e31b$export$4b0c59f8845ba920);

var $acw62 = parcelRequire("acw62");
var $2e0e14143329e31b$var$PanoramaContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $2e0e14143329e31b$export$4b0c59f8845ba920 = ()=>(0, $acw62.useContext)($2e0e14143329e31b$var$PanoramaContext) != null;
var $2e0e14143329e31b$export$415fcedf1e191db0 = (_ref)=>{
    var children = _ref.children;
    return /*#__PURE__*/ $acw62.createElement($2e0e14143329e31b$var$PanoramaContext.Provider, {
        value: true
    }, children);
};

});

parcelRegister("3o7wy", function(module, exports) {

$parcel$export(module.exports, "selectBrushSettings", () => $2779731b2b31d554$export$5ba94b496f8dc52e);
$parcel$export(module.exports, "selectBrushDimensions", () => $2779731b2b31d554$export$3b81e97eae001823);

var $b0nKR = parcelRequire("b0nKR");

var $lnFga = parcelRequire("lnFga");

var $V5fxS = parcelRequire("V5fxS");

var $3FiDp = parcelRequire("3FiDp");
var $2779731b2b31d554$export$5ba94b496f8dc52e = (state)=>state.brush;
var $2779731b2b31d554$export$3b81e97eae001823 = (0, $b0nKR.createSelector)([
    $2779731b2b31d554$export$5ba94b496f8dc52e,
    (0, $lnFga.selectChartOffsetInternal),
    (0, $V5fxS.selectMargin)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, $3FiDp.isNumber)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, $3FiDp.isNumber)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, $3FiDp.isNumber)(brushSettings.width) ? brushSettings.width : offset.width
    }));

});


parcelRegister("71i43", function(module, exports) {

$parcel$export(module.exports, "selectAllGraphicalItemsSettings", () => $51c6a3a12cea9b0d$export$645965005f643e6f);
$parcel$export(module.exports, "selectTooltipDisplayedData", () => $51c6a3a12cea9b0d$export$5a8beccc8250d20e);
$parcel$export(module.exports, "selectTooltipAxisDomain", () => $51c6a3a12cea9b0d$export$76f7a1975f60ccf1);
$parcel$export(module.exports, "selectTooltipAxisRangeWithReverse", () => $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3);
$parcel$export(module.exports, "selectTooltipAxisScale", () => $51c6a3a12cea9b0d$export$cdeccbbdd343ae59);
$parcel$export(module.exports, "selectTooltipAxisTicks", () => $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a);
$parcel$export(module.exports, "selectActiveTooltipIndex", () => $51c6a3a12cea9b0d$export$8b2762260f5891c9);
$parcel$export(module.exports, "selectActiveLabel", () => $51c6a3a12cea9b0d$export$400c35cc3b9a0487);
$parcel$export(module.exports, "selectActiveTooltipDataKey", () => $51c6a3a12cea9b0d$export$999f7a7ced063fab);
$parcel$export(module.exports, "selectActiveTooltipGraphicalItemId", () => $51c6a3a12cea9b0d$export$3bddf33d79812741);
$parcel$export(module.exports, "selectActiveTooltipCoordinate", () => $51c6a3a12cea9b0d$export$90c565a5b196e427);
$parcel$export(module.exports, "selectIsTooltipActive", () => $51c6a3a12cea9b0d$export$c8884ed37796034a);
$parcel$export(module.exports, "selectActiveTooltipDataPoints", () => $51c6a3a12cea9b0d$export$1a5b9bd341ad5f0e);

var $b0nKR = parcelRequire("b0nKR");

var $99P3O = parcelRequire("99P3O");

var $jHn5r = parcelRequire("jHn5r");

var $hBeJX = parcelRequire("hBeJX");

var $i2WC7 = parcelRequire("i2WC7");

var $iYis8 = parcelRequire("iYis8");

var $3FiDp = parcelRequire("3FiDp");

var $2yfvu = parcelRequire("2yfvu");

var $2Ron6 = parcelRequire("2Ron6");

var $564ve = parcelRequire("564ve");

var $khQco = parcelRequire("khQco");

var $5fR7X = parcelRequire("5fR7X");

var $czuyh = parcelRequire("czuyh");

var $5zpLv = parcelRequire("5zpLv");

var $V5fxS = parcelRequire("V5fxS");

var $lnFga = parcelRequire("lnFga");

var $aoaNY = parcelRequire("aoaNY");

var $4cwIx = parcelRequire("4cwIx");

var $ao1Kf = parcelRequire("ao1Kf");

var $72sMT = parcelRequire("72sMT");

var $hgR6r = parcelRequire("hgR6r");

var $4NxAS = parcelRequire("4NxAS");

var $599vZ = parcelRequire("599vZ");

var $9fXTm = parcelRequire("9fXTm");

var $agTdp = parcelRequire("agTdp");

var $2a4jF = parcelRequire("2a4jF");

var $ouh0N = parcelRequire("ouh0N");

var $eBpK5 = parcelRequire("eBpK5");

var $iMnqX = parcelRequire("iMnqX");

var $5dTrd = parcelRequire("5dTrd");

var $l1Iwr = parcelRequire("l1Iwr");
var $51c6a3a12cea9b0d$export$221021c57c593b2 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    (0, $99P3O.selectHasBar),
    (0, $iYis8.selectChartName)
], (0, $5dTrd.combineRealScaleType));
var $51c6a3a12cea9b0d$export$4751149f4d54cbbf = (0, $b0nKR.createSelector)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var $51c6a3a12cea9b0d$var$selectTooltipAxisPredicate = (0, $b0nKR.createSelector)([
    (0, $4NxAS.selectTooltipAxisType),
    (0, $hgR6r.selectTooltipAxisId)
], (0, $99P3O.itemAxisPredicate));
var $51c6a3a12cea9b0d$export$645965005f643e6f = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$4751149f4d54cbbf,
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$var$selectTooltipAxisPredicate
], (0, $99P3O.combineGraphicalItemsSettings), {
    memoizeOptions: {
        resultEqualityCheck: (0, $ouh0N.emptyArraysAreEqualCheck)
    }
});
var $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItemsSettings = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $9fXTm.isStacked)));
var $51c6a3a12cea9b0d$export$b3f948fbed0299f1 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (0, $99P3O.combineGraphicalItemsData), {
    memoizeOptions: {
        resultEqualityCheck: (0, $ouh0N.emptyArraysAreEqualCheck)
    }
});
var $51c6a3a12cea9b0d$var$selectAnyTooltipItemUsesChartData = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (items)=>items.some((item)=>!item.data));
var $51c6a3a12cea9b0d$export$5a8beccc8250d20e = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$b3f948fbed0299f1,
    (0, $i2WC7.selectChartDataWithIndexes)
], (0, $99P3O.combineDisplayedData));
var $51c6a3a12cea9b0d$var$selectTooltipStackedData = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItemsSettings,
    (0, $i2WC7.selectChartDataWithIndexes),
    (0, $99P3O.selectTooltipAxis)
], (0, $599vZ.combineDisplayedStackedData));
var $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$export$645965005f643e6f,
    (0, $i2WC7.selectChartDataWithIndexes),
    $51c6a3a12cea9b0d$var$selectAnyTooltipItemUsesChartData,
    $51c6a3a12cea9b0d$export$b3f948fbed0299f1
], (0, $99P3O.combineAllAppliedValues));
var $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis)
], (0, $99P3O.getDomainDefinition));
var $51c6a3a12cea9b0d$var$selectTooltipDataOverflow = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis)
], (axisSettings)=>axisSettings.allowDataOverflow);
var $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition,
    $51c6a3a12cea9b0d$var$selectTooltipDataOverflow
], (0, $agTdp.numericalDomainSpecifiedWithoutRequiringData));
var $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItems = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (graphicalItems)=>graphicalItems.filter((0, $9fXTm.isStacked)));
var $51c6a3a12cea9b0d$var$selectTooltipStackGroups = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipStackedData,
    $51c6a3a12cea9b0d$var$selectAllStackedGraphicalItems,
    (0, $iYis8.selectStackOffsetType),
    (0, $iYis8.selectReverseStackOrder)
], (0, $99P3O.combineStackGroups));
var $51c6a3a12cea9b0d$var$selectTooltipDomainOfStackGroups = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipStackGroups,
    (0, $i2WC7.selectChartDataWithIndexes),
    (0, $4NxAS.selectTooltipAxisType),
    $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences
], (0, $99P3O.combineDomainOfStackGroups));
var $51c6a3a12cea9b0d$var$selectTooltipItemsSettingsExceptStacked = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$645965005f643e6f
], (0, $99P3O.filterGraphicalNotStackedItems));
var $51c6a3a12cea9b0d$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$var$selectTooltipItemsSettingsExceptStacked,
    (0, $99P3O.selectAllErrorBarSettings),
    (0, $4NxAS.selectTooltipAxisType),
    (0, $i2WC7.selectChartDataSliceWithIndexes)
], (0, $99P3O.combineDomainOfAllAppliedNumericalValuesIncludingErrorValues), {
    memoizeOptions: {
        resultEqualityCheck: (0, $2a4jF.numberDomainEqualityCheck)
    }
});
var $51c6a3a12cea9b0d$var$selectReferenceDotsByTooltipAxis = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectReferenceDots),
    (0, $4NxAS.selectTooltipAxisType),
    (0, $hgR6r.selectTooltipAxisId)
], (0, $99P3O.filterReferenceElements));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceDotsDomain = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectReferenceDotsByTooltipAxis,
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineDotsDomain));
var $51c6a3a12cea9b0d$var$selectReferenceAreasByTooltipAxis = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectReferenceAreas),
    (0, $4NxAS.selectTooltipAxisType),
    (0, $hgR6r.selectTooltipAxisId)
], (0, $99P3O.filterReferenceElements));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceAreasDomain = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectReferenceAreasByTooltipAxis,
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineAreasDomain));
var $51c6a3a12cea9b0d$var$selectReferenceLinesByTooltipAxis = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectReferenceLines),
    (0, $4NxAS.selectTooltipAxisType),
    (0, $hgR6r.selectTooltipAxisId)
], (0, $99P3O.filterReferenceElements));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceLinesDomain = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectReferenceLinesByTooltipAxis,
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineLinesDomain));
var $51c6a3a12cea9b0d$var$selectTooltipReferenceElementsDomain = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipReferenceDotsDomain,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceLinesDomain,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceAreasDomain
], (0, $99P3O.mergeDomains));
var $51c6a3a12cea9b0d$var$selectTooltipNumericalDomain = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$var$selectTooltipAxisDomainDefinition,
    $51c6a3a12cea9b0d$var$selectTooltipDomainFromUserPreferences,
    $51c6a3a12cea9b0d$var$selectTooltipDomainOfStackGroups,
    $51c6a3a12cea9b0d$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $51c6a3a12cea9b0d$var$selectTooltipReferenceElementsDomain,
    (0, $jHn5r.selectChartLayout),
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineNumericalDomain));
var $51c6a3a12cea9b0d$export$76f7a1975f60ccf1 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    (0, $jHn5r.selectChartLayout),
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $iYis8.selectStackOffsetType),
    (0, $4NxAS.selectTooltipAxisType),
    $51c6a3a12cea9b0d$var$selectTooltipNumericalDomain
], (0, $99P3O.combineAxisDomain));
var $51c6a3a12cea9b0d$var$selectTooltipNiceTicks = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1,
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$export$221021c57c593b2
], (0, $99P3O.combineNiceTicks));
var $51c6a3a12cea9b0d$export$90be38154e4228b2 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1,
    $51c6a3a12cea9b0d$var$selectTooltipNiceTicks,
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineAxisDomainWithNiceTicks));
var $51c6a3a12cea9b0d$var$selectTooltipAxisRange = (state)=>{
    var axisType = (0, $4NxAS.selectTooltipAxisType)(state);
    var axisId = (0, $hgR6r.selectTooltipAxisId)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, $99P3O.selectAxisRange)(state, axisType, axisId, isPanorama);
};
var $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$var$selectTooltipAxisRange
], (0, $2yfvu.combineAxisRangeWithReverse));
var $51c6a3a12cea9b0d$var$selectTooltipConfiguredScale = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$export$221021c57c593b2,
    $51c6a3a12cea9b0d$export$90be38154e4228b2,
    $51c6a3a12cea9b0d$export$cf4d6dfce3a76af3
], (0, $l1Iwr.combineConfiguredScale));
var $51c6a3a12cea9b0d$export$cdeccbbdd343ae59 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipConfiguredScale
], (0, $eBpK5.rechartsScaleFactory));
var $51c6a3a12cea9b0d$var$selectTooltipDuplicateDomain = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $99P3O.selectTooltipAxis),
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineDuplicateDomain));
var $51c6a3a12cea9b0d$export$f7665d13a99c934c = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $51c6a3a12cea9b0d$var$selectAllTooltipAppliedValues,
    (0, $99P3O.selectTooltipAxis),
    (0, $4NxAS.selectTooltipAxisType)
], (0, $99P3O.combineCategoricalDomain));
var $51c6a3a12cea9b0d$var$combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var type = axis.type;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $3FiDp.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as an index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
};
var $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    (0, $99P3O.selectTooltipAxis),
    $51c6a3a12cea9b0d$export$221021c57c593b2,
    $51c6a3a12cea9b0d$export$cdeccbbdd343ae59,
    $51c6a3a12cea9b0d$var$selectTooltipAxisRange,
    $51c6a3a12cea9b0d$var$selectTooltipDuplicateDomain,
    $51c6a3a12cea9b0d$export$f7665d13a99c934c,
    (0, $4NxAS.selectTooltipAxisType)
], $51c6a3a12cea9b0d$var$combineTicksOfTooltipAxis);
var $51c6a3a12cea9b0d$var$selectTooltipEventType = (0, $b0nKR.createSelector)([
    (0, $2Ron6.selectDefaultTooltipEventType),
    (0, $2Ron6.selectValidateTooltipEventTypes),
    (0, $khQco.selectTooltipSettings)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, $2Ron6.combineTooltipEventType)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var $51c6a3a12cea9b0d$var$selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var $51c6a3a12cea9b0d$var$selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var $51c6a3a12cea9b0d$var$selectTooltipInteractionState = (0, $b0nKR.createSelector)([
    (0, $ao1Kf.selectTooltipState),
    $51c6a3a12cea9b0d$var$selectTooltipEventType,
    $51c6a3a12cea9b0d$var$selectTooltipTrigger,
    $51c6a3a12cea9b0d$var$selectDefaultIndex
], (0, $5fR7X.combineTooltipInteractionState));
var $51c6a3a12cea9b0d$export$8b2762260f5891c9 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState,
    $51c6a3a12cea9b0d$export$5a8beccc8250d20e,
    (0, $99P3O.selectTooltipAxisDataKey),
    $51c6a3a12cea9b0d$export$76f7a1975f60ccf1
], (0, $czuyh.combineActiveTooltipIndex));
var $51c6a3a12cea9b0d$export$400c35cc3b9a0487 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a,
    $51c6a3a12cea9b0d$export$8b2762260f5891c9
], (0, $564ve.combineActiveLabel));
var $51c6a3a12cea9b0d$export$999f7a7ced063fab = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var $51c6a3a12cea9b0d$export$3bddf33d79812741 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.graphicalItemId;
});
var $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations = (0, $b0nKR.createSelector)([
    (0, $ao1Kf.selectTooltipState),
    $51c6a3a12cea9b0d$var$selectTooltipEventType,
    $51c6a3a12cea9b0d$var$selectTooltipTrigger,
    $51c6a3a12cea9b0d$var$selectDefaultIndex
], (0, $aoaNY.combineTooltipPayloadConfigurations));
var $51c6a3a12cea9b0d$var$selectTooltipCoordinateForDefaultIndex = (0, $b0nKR.createSelector)([
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight),
    (0, $jHn5r.selectChartLayout),
    (0, $lnFga.selectChartOffsetInternal),
    $51c6a3a12cea9b0d$export$ffe0e60f8c88c05a,
    $51c6a3a12cea9b0d$var$selectDefaultIndex,
    $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations
], (0, $5zpLv.combineCoordinateForDefaultIndex));
var $51c6a3a12cea9b0d$export$90c565a5b196e427 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState,
    $51c6a3a12cea9b0d$var$selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var $51c6a3a12cea9b0d$export$c8884ed37796034a = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipInteractionState
], (tooltipInteractionState)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState === null || tooltipInteractionState === void 0 ? void 0 : tooltipInteractionState.active) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : false;
});
var $51c6a3a12cea9b0d$export$a2bb5be6e87cbb86 = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$var$selectTooltipPayloadConfigurations,
    $51c6a3a12cea9b0d$export$8b2762260f5891c9,
    (0, $i2WC7.selectChartDataWithIndexes),
    (0, $99P3O.selectTooltipAxisDataKey),
    $51c6a3a12cea9b0d$export$400c35cc3b9a0487,
    (0, $4cwIx.selectTooltipPayloadSearcher),
    $51c6a3a12cea9b0d$var$selectTooltipEventType
], (0, $72sMT.combineTooltipPayload));
var $51c6a3a12cea9b0d$export$1a5b9bd341ad5f0e = (0, $b0nKR.createSelector)([
    $51c6a3a12cea9b0d$export$a2bb5be6e87cbb86
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});

});
parcelRegister("99P3O", function(module, exports) {

$parcel$export(module.exports, "implicitXAxis", () => $6aac8fe27ae10a7b$export$21aec091b6ac8422);
$parcel$export(module.exports, "selectXAxisSettingsNoDefaults", () => $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5);
$parcel$export(module.exports, "selectXAxisSettings", () => $6aac8fe27ae10a7b$export$d6895d8ddb4cee5);
$parcel$export(module.exports, "implicitYAxis", () => $6aac8fe27ae10a7b$export$397148de2ecdec3c);
$parcel$export(module.exports, "selectYAxisSettingsNoDefaults", () => $6aac8fe27ae10a7b$export$d0970661da76c14c);
$parcel$export(module.exports, "selectYAxisSettings", () => $6aac8fe27ae10a7b$export$1f472705a332f1c9);
$parcel$export(module.exports, "selectBaseAxis", () => $6aac8fe27ae10a7b$export$fc14c3706e09c50c);
$parcel$export(module.exports, "selectRenderableAxisSettings", () => $6aac8fe27ae10a7b$export$f5176fa96b596697);
$parcel$export(module.exports, "selectHasBar", () => $6aac8fe27ae10a7b$export$1c7798b82c8010cd);
$parcel$export(module.exports, "itemAxisPredicate", () => $6aac8fe27ae10a7b$export$a3923f321c6572c3);
$parcel$export(module.exports, "selectUnfilteredCartesianItems", () => $6aac8fe27ae10a7b$export$f67c737adf41a3af);
$parcel$export(module.exports, "combineGraphicalItemsSettings", () => $6aac8fe27ae10a7b$export$ad35679ce4582010);
$parcel$export(module.exports, "filterGraphicalNotStackedItems", () => $6aac8fe27ae10a7b$export$a61da86823382adc);
$parcel$export(module.exports, "combineGraphicalItemsData", () => $6aac8fe27ae10a7b$export$d945cee965d266f0);
$parcel$export(module.exports, "combineDisplayedData", () => $6aac8fe27ae10a7b$export$c2c6d012cffe2c75);
$parcel$export(module.exports, "combineAppliedValues", () => $6aac8fe27ae10a7b$export$3051da2013ba9cfe);
$parcel$export(module.exports, "combineAllAppliedValues", () => $6aac8fe27ae10a7b$export$48831dc762d7b6ad);
$parcel$export(module.exports, "selectTooltipAxis", () => $6aac8fe27ae10a7b$export$27d9004292294cd7);
$parcel$export(module.exports, "selectTooltipAxisDataKey", () => $6aac8fe27ae10a7b$export$bf8397fefbaa3617);
$parcel$export(module.exports, "combineStackGroups", () => $6aac8fe27ae10a7b$export$9312914d13496409);
$parcel$export(module.exports, "selectStackGroups", () => $6aac8fe27ae10a7b$export$af2278e5e47fc440);
$parcel$export(module.exports, "combineDomainOfStackGroups", () => $6aac8fe27ae10a7b$export$3286b8ea6ff06720);
$parcel$export(module.exports, "getDomainDefinition", () => $6aac8fe27ae10a7b$export$2e6262b6c952ab02);
$parcel$export(module.exports, "selectDomainDefinition", () => $6aac8fe27ae10a7b$export$5d46410c3f089eb2);
$parcel$export(module.exports, "selectDomainFromUserPreference", () => $6aac8fe27ae10a7b$export$c21dc69ecce61f8a);
$parcel$export(module.exports, "selectAllErrorBarSettings", () => $6aac8fe27ae10a7b$export$9429ab4550237b6d);
$parcel$export(module.exports, "mergeDomains", () => $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d);
$parcel$export(module.exports, "combineDomainOfAllAppliedNumericalValuesIncludingErrorValues", () => $6aac8fe27ae10a7b$export$df56c8e9a3e45e65);
$parcel$export(module.exports, "selectReferenceDots", () => $6aac8fe27ae10a7b$export$71580de5ed38161a);
$parcel$export(module.exports, "filterReferenceElements", () => $6aac8fe27ae10a7b$export$2829d12117d2002f);
$parcel$export(module.exports, "selectReferenceAreas", () => $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6);
$parcel$export(module.exports, "selectReferenceLines", () => $6aac8fe27ae10a7b$export$8fe2a49ce63c5348);
$parcel$export(module.exports, "combineDotsDomain", () => $6aac8fe27ae10a7b$export$5da0b79fd816ec4b);
$parcel$export(module.exports, "combineAreasDomain", () => $6aac8fe27ae10a7b$export$7b27918cf5e1fc19);
$parcel$export(module.exports, "combineLinesDomain", () => $6aac8fe27ae10a7b$export$f1d17aebd11953eb);
$parcel$export(module.exports, "combineNumericalDomain", () => $6aac8fe27ae10a7b$export$b9eca0fd568f66a4);
$parcel$export(module.exports, "combineAxisDomain", () => $6aac8fe27ae10a7b$export$70e6ef68424edf74);
$parcel$export(module.exports, "selectAxisDomain", () => $6aac8fe27ae10a7b$export$4fc5ecb5227dd744);
$parcel$export(module.exports, "selectRealScaleType", () => $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7);
$parcel$export(module.exports, "combineNiceTicks", () => $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c);
$parcel$export(module.exports, "combineAxisDomainWithNiceTicks", () => $6aac8fe27ae10a7b$export$3a4530026b1860ff);
$parcel$export(module.exports, "selectXAxisRange", () => $6aac8fe27ae10a7b$export$ad97ad38bffcee71);
$parcel$export(module.exports, "selectYAxisRange", () => $6aac8fe27ae10a7b$export$e20c6b0368220a6a);
$parcel$export(module.exports, "selectAxisRange", () => $6aac8fe27ae10a7b$export$3506ed461810cc8f);
$parcel$export(module.exports, "combineCategoricalDomain", () => $6aac8fe27ae10a7b$export$911ef47868c9ab07);
$parcel$export(module.exports, "selectAxisScale", () => $6aac8fe27ae10a7b$export$22e8e5f8924724ea);
$parcel$export(module.exports, "selectAxisInverseScale", () => $6aac8fe27ae10a7b$export$657c51a9a0740206);
$parcel$export(module.exports, "selectAxisInverseDataSnapScale", () => $6aac8fe27ae10a7b$export$ddc8d5321a023350);
$parcel$export(module.exports, "selectXAxisSize", () => $6aac8fe27ae10a7b$export$50d4085c87c19b12);
$parcel$export(module.exports, "selectXAxisPosition", () => $6aac8fe27ae10a7b$export$92fdc590d2371053);
$parcel$export(module.exports, "selectYAxisPosition", () => $6aac8fe27ae10a7b$export$e67a320452ebcaef);
$parcel$export(module.exports, "selectYAxisSize", () => $6aac8fe27ae10a7b$export$249bec756af8ac39);
$parcel$export(module.exports, "selectCartesianAxisSize", () => $6aac8fe27ae10a7b$export$6d6e642aa7a0ae10);
$parcel$export(module.exports, "combineDuplicateDomain", () => $6aac8fe27ae10a7b$export$bb1ebf56a37bd899);
$parcel$export(module.exports, "selectAxisPropsNeededForCartesianGridTicksGenerator", () => $6aac8fe27ae10a7b$export$45cd57660792dd31);
$parcel$export(module.exports, "selectTicksOfAxis", () => $6aac8fe27ae10a7b$export$f0d85e8287c47657);
$parcel$export(module.exports, "selectTicksOfGraphicalItem", () => $6aac8fe27ae10a7b$export$b894cb5d8586b43d);
$parcel$export(module.exports, "selectAxisWithScale", () => $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7);
$parcel$export(module.exports, "selectChartDirection", () => $6aac8fe27ae10a7b$export$430d623a94added7);
$parcel$export(module.exports, "selectRenderedTicksOfAxis", () => $6aac8fe27ae10a7b$export$9cc7232c10fac9e);
$parcel$export(module.exports, "selectAxisInverseTickSnapScale", () => $6aac8fe27ae10a7b$export$767aec070f996e73);

var $b0nKR = parcelRequire("b0nKR");

var $9TtvW = parcelRequire("9TtvW");

var $jHn5r = parcelRequire("jHn5r");

var $hBeJX = parcelRequire("hBeJX");

var $i2WC7 = parcelRequire("i2WC7");

var $agTdp = parcelRequire("agTdp");

var $3FiDp = parcelRequire("3FiDp");

var $iMnqX = parcelRequire("iMnqX");

var $9TVxJ = parcelRequire("9TVxJ");

var $V5fxS = parcelRequire("V5fxS");

var $8fDe7 = parcelRequire("8fDe7");

var $lnFga = parcelRequire("lnFga");

var $3o7wy = parcelRequire("3o7wy");

var $iYis8 = parcelRequire("iYis8");

var $7bJlR = parcelRequire("7bJlR");

var $fU6gH = parcelRequire("fU6gH");

var $8VTts = parcelRequire("8VTts");

var $2yfvu = parcelRequire("2yfvu");

var $lcI2N = parcelRequire("lcI2N");

var $hcIzl = parcelRequire("hcIzl");

var $599vZ = parcelRequire("599vZ");

var $9fXTm = parcelRequire("9fXTm");

var $2a4jF = parcelRequire("2a4jF");

var $ouh0N = parcelRequire("ouh0N");

var $4NxAS = parcelRequire("4NxAS");

var $hgR6r = parcelRequire("hgR6r");

var $eBpK5 = parcelRequire("eBpK5");

var $9hA9H = parcelRequire("9hA9H");

var $l1Iwr = parcelRequire("l1Iwr");

var $5dTrd = parcelRequire("5dTrd");

var $gYUxO = parcelRequire("gYUxO");

var $dPWwa = parcelRequire("dPWwa");
function $6aac8fe27ae10a7b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6aac8fe27ae10a7b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6aac8fe27ae10a7b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6aac8fe27ae10a7b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6aac8fe27ae10a7b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6aac8fe27ae10a7b$var$_defineProperty(e, r, t) {
    return (r = $6aac8fe27ae10a7b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6aac8fe27ae10a7b$var$_toPropertyKey(t) {
    var i = $6aac8fe27ae10a7b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6aac8fe27ae10a7b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6aac8fe27ae10a7b$var$_slicedToArray(r, e) {
    return $6aac8fe27ae10a7b$var$_arrayWithHoles(r) || $6aac8fe27ae10a7b$var$_iterableToArrayLimit(r, e) || $6aac8fe27ae10a7b$var$_unsupportedIterableToArray(r, e) || $6aac8fe27ae10a7b$var$_nonIterableRest();
}
function $6aac8fe27ae10a7b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6aac8fe27ae10a7b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6aac8fe27ae10a7b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6aac8fe27ae10a7b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6aac8fe27ae10a7b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6aac8fe27ae10a7b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $6aac8fe27ae10a7b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $6aac8fe27ae10a7b$export$a012a4dce80491c2 = [
    0,
    'auto'
];
var $6aac8fe27ae10a7b$export$21aec091b6ac8422 = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined,
    niceTicks: 'auto'
};
var $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5 = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var $6aac8fe27ae10a7b$export$d6895d8ddb4cee5 = (state, axisId)=>{
    var axis = $6aac8fe27ae10a7b$export$8079b33b4a6a2ac5(state, axisId);
    if (axis == null) return $6aac8fe27ae10a7b$export$21aec091b6ac8422;
    return axis;
};
var $6aac8fe27ae10a7b$export$397148de2ecdec3c = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: $6aac8fe27ae10a7b$export$a012a4dce80491c2,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    niceTicks: 'auto',
    width: (0, $lcI2N.DEFAULT_Y_AXIS_WIDTH)
};
var $6aac8fe27ae10a7b$export$d0970661da76c14c = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var $6aac8fe27ae10a7b$export$1f472705a332f1c9 = (state, axisId)=>{
    var axis = $6aac8fe27ae10a7b$export$d0970661da76c14c(state, axisId);
    if (axis == null) return $6aac8fe27ae10a7b$export$397148de2ecdec3c;
    return axis;
};
var $6aac8fe27ae10a7b$export$73a439a535d82503 = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var $6aac8fe27ae10a7b$export$26eadf639b453d0f = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return $6aac8fe27ae10a7b$export$73a439a535d82503;
    return axis;
};
var $6aac8fe27ae10a7b$export$fc14c3706e09c50c = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        case 'zAxis':
            return $6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId);
        case 'angleAxis':
            return (0, $7bJlR.selectAngleAxis)(state, axisId);
        case 'radiusAxis':
            return (0, $7bJlR.selectRadiusAxis)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$var$selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$export$f5176fa96b596697 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
        case 'angleAxis':
            return (0, $7bJlR.selectAngleAxis)(state, axisId);
        case 'radiusAxis':
            return (0, $7bJlR.selectRadiusAxis)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var $6aac8fe27ae10a7b$export$1c7798b82c8010cd = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function $6aac8fe27ae10a7b$export$a3923f321c6572c3(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var $6aac8fe27ae10a7b$export$f67c737adf41a3af = (state)=>state.graphicalItems.cartesianItems;
var $6aac8fe27ae10a7b$var$selectAxisPredicate = (0, $b0nKR.createSelector)([
    (0, $fU6gH.pickAxisType),
    (0, $8VTts.pickAxisId)
], $6aac8fe27ae10a7b$export$a3923f321c6572c3);
var $6aac8fe27ae10a7b$export$ad35679ce4582010 = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var $6aac8fe27ae10a7b$export$533d13f911334c9d = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$f67c737adf41a3af,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$var$selectAxisPredicate
], $6aac8fe27ae10a7b$export$ad35679ce4582010, {
    memoizeOptions: {
        resultEqualityCheck: (0, $ouh0N.emptyArraysAreEqualCheck)
    }
});
var $6aac8fe27ae10a7b$export$58ad06f71246a0da = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, $9fXTm.isStacked));
});
var $6aac8fe27ae10a7b$export$a61da86823382adc = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var $6aac8fe27ae10a7b$var$selectCartesianItemsSettingsExceptStacked = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], $6aac8fe27ae10a7b$export$a61da86823382adc);
var $6aac8fe27ae10a7b$export$d945cee965d266f0 = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var $6aac8fe27ae10a7b$export$19d147541685480 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], (items)=>items.some((item)=>!item.data));
var $6aac8fe27ae10a7b$export$f2151bebfd9ae457 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d
], $6aac8fe27ae10a7b$export$d945cee965d266f0, {
    memoizeOptions: {
        resultEqualityCheck: (0, $ouh0N.emptyArraysAreEqualCheck)
    }
});
var $6aac8fe27ae10a7b$export$c2c6d012cffe2c75 = (graphicalItemsData, _ref)=>{
    var _ref$chartData = _ref.chartData, chartData = _ref$chartData === void 0 ? [] : _ref$chartData, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var $6aac8fe27ae10a7b$export$6099ba314905f0c4 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$f2151bebfd9ae457,
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition4)
], $6aac8fe27ae10a7b$export$c2c6d012cffe2c75);
var $6aac8fe27ae10a7b$export$3051da2013ba9cfe = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $hBeJX.getValueByDataKey)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, $hBeJX.getValueByDataKey)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var $6aac8fe27ae10a7b$export$48831dc762d7b6ad = (displayedData, axisSettings, items, _ref2, anyItemUsesChartData, graphicalItemsData)=>{
    var _ref2$chartData = _ref2.chartData, chartData = _ref2$chartData === void 0 ? [] : _ref2$chartData, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var appliedValues = $6aac8fe27ae10a7b$export$3051da2013ba9cfe(displayedData, axisSettings, items);
    if (anyItemUsesChartData && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null && graphicalItemsData.length > 0) {
        var chartDataSlice = chartData.slice(dataStartIndex, dataEndIndex + 1);
        var chartAppliedValues = chartDataSlice.map((item)=>({
                value: (0, $hBeJX.getValueByDataKey)(item, axisSettings.dataKey)
            })).filter((av)=>av.value != null);
        return [
            ...chartAppliedValues,
            ...appliedValues
        ];
    }
    return appliedValues;
};
var $6aac8fe27ae10a7b$export$9cea618b690f07b7 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$533d13f911334c9d,
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition4),
    $6aac8fe27ae10a7b$export$19d147541685480,
    $6aac8fe27ae10a7b$export$f2151bebfd9ae457
], $6aac8fe27ae10a7b$export$48831dc762d7b6ad);
function $6aac8fe27ae10a7b$var$makeNumber(val) {
    if ((0, $3FiDp.isNumOrStr)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, $iMnqX.isWellBehavedNumber)(n)) return n;
    }
    return undefined;
}
function $6aac8fe27ae10a7b$var$makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            $6aac8fe27ae10a7b$var$makeNumber(val[0]),
            $6aac8fe27ae10a7b$var$makeNumber(val[1])
        ];
        if ((0, $agTdp.isWellFormedNumberDomain)(attempt)) return attempt;
        return undefined;
    }
    var n = $6aac8fe27ae10a7b$var$makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function $6aac8fe27ae10a7b$var$onlyAllowNumbers(data) {
    return data.map($6aac8fe27ae10a7b$var$makeNumber).filter((0, $3FiDp.isNotNil));
}
function $6aac8fe27ae10a7b$var$sortBy(a, b) {
    var aNum = $6aac8fe27ae10a7b$var$makeNumber(a);
    var bNum = $6aac8fe27ae10a7b$var$makeNumber(b);
    if (aNum == null && bNum == null) return 0;
    if (aNum == null) return -1;
    if (bNum == null) return 1;
    return aNum - bNum;
}
var $6aac8fe27ae10a7b$export$23eb57bf0bace166 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$9cea618b690f07b7
], (appliedData)=>{
    return appliedData === null || appliedData === void 0 ? void 0 : appliedData.map((item)=>item.value).sort($6aac8fe27ae10a7b$var$sortBy);
});
function $6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
function $6aac8fe27ae10a7b$export$25971beae035f58a(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars) return [];
    if (!relevantErrorBars.length) return [];
    var appliedNumericValue;
    if (typeof appliedValue === 'number' && !(0, $3FiDp.isNan)(appliedValue)) appliedNumericValue = appliedValue;
    else if (Array.isArray(appliedValue)) {
        var numericRangeValues = $6aac8fe27ae10a7b$var$onlyAllowNumbers(appliedValue);
        if (numericRangeValues.length > 0) appliedNumericValue = Math.max(...numericRangeValues);
    }
    if (appliedNumericValue == null) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, $hBeJX.getValueByDataKey)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) {
            var _errorValue = $6aac8fe27ae10a7b$var$_slicedToArray(errorValue, 2);
            lowBound = _errorValue[0];
            highBound = _errorValue[1];
        } else lowBound = highBound = errorValue;
        if (!(0, $iMnqX.isWellBehavedNumber)(lowBound) || !(0, $iMnqX.isWellBehavedNumber)(highBound)) return undefined;
        return [
            appliedNumericValue - lowBound,
            appliedNumericValue + highBound
        ];
    }));
}
var $6aac8fe27ae10a7b$export$27d9004292294cd7 = (state)=>{
    var axisType = (0, $4NxAS.selectTooltipAxisType)(state);
    var axisId = (0, $hgR6r.selectTooltipAxisId)(state);
    return $6aac8fe27ae10a7b$export$f5176fa96b596697(state, axisType, axisId);
};
var $6aac8fe27ae10a7b$export$bf8397fefbaa3617 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$27d9004292294cd7
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var $6aac8fe27ae10a7b$export$b329ef9482661e60 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$58ad06f71246a0da,
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition4),
    $6aac8fe27ae10a7b$export$27d9004292294cd7
], (0, $599vZ.combineDisplayedStackedData));
var $6aac8fe27ae10a7b$export$9312914d13496409 = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        var stack = acc[item.stackId];
        if (stack == null) stack = [];
        stack.push(item);
        acc[item.stackId] = stack;
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref3)=>{
        var _ref4 = $6aac8fe27ae10a7b$var$_slicedToArray(_ref3, 2), stackId = _ref4[0], graphicalItems = _ref4[1];
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, $hcIzl.getStackSeriesIdentifier));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, $hBeJX.getStackedData)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var $6aac8fe27ae10a7b$export$af2278e5e47fc440 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$b329ef9482661e60,
    $6aac8fe27ae10a7b$export$58ad06f71246a0da,
    (0, $iYis8.selectStackOffsetType),
    (0, $iYis8.selectReverseStackOrder)
], $6aac8fe27ae10a7b$export$9312914d13496409);
var $6aac8fe27ae10a7b$export$3286b8ea6ff06720 = (stackGroups, _ref5, axisType, domainFromUserPreference)=>{
    var dataStartIndex = _ref5.dataStartIndex, dataEndIndex = _ref5.dataEndIndex;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    return (0, $hBeJX.getDomainOfStackGroups)(stackGroups, dataStartIndex, dataEndIndex);
};
var $6aac8fe27ae10a7b$var$selectAllowsDataOverflow = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c
], (axisSettings)=>axisSettings.allowDataOverflow);
var $6aac8fe27ae10a7b$export$2e6262b6c952ab02 = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return $6aac8fe27ae10a7b$export$a012a4dce80491c2;
    if (axisSettings.domain != null) return axisSettings.domain;
    if ('ticks' in axisSettings && axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = $6aac8fe27ae10a7b$var$onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : $6aac8fe27ae10a7b$export$a012a4dce80491c2;
};
var $6aac8fe27ae10a7b$export$5d46410c3f089eb2 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c
], $6aac8fe27ae10a7b$export$2e6262b6c952ab02);
var $6aac8fe27ae10a7b$export$c21dc69ecce61f8a = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$5d46410c3f089eb2,
    $6aac8fe27ae10a7b$var$selectAllowsDataOverflow
], (0, $agTdp.numericalDomainSpecifiedWithoutRequiringData));
var $6aac8fe27ae10a7b$export$969bc8d84122c036 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$af2278e5e47fc440,
    (0, $i2WC7.selectChartDataWithIndexes),
    (0, $fU6gH.pickAxisType),
    $6aac8fe27ae10a7b$export$c21dc69ecce61f8a
], $6aac8fe27ae10a7b$export$3286b8ea6ff06720, {
    memoizeOptions: {
        resultEqualityCheck: (0, $2a4jF.numberDomainEqualityCheck)
    }
});
var $6aac8fe27ae10a7b$export$9429ab4550237b6d = (state)=>state.errorBars;
var $6aac8fe27ae10a7b$var$combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return $6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, e);
    });
};
var $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var $6aac8fe27ae10a7b$export$df56c8e9a3e45e65 = function combineDomainOfAllAppliedNumericalValuesIncludingErrorValues(displayedData, axisSettings, items, errorBars, axisType) {
    var chartDataSlice = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
    var lowerEnd, upperEnd;
    if (items.length > 0) /*
     * Iterate item-first so each item can use its own `data` prop when present,
     * falling back to the chart-level data slice for items that rely on it.
     * This ensures that mixing items with and without own data (e.g. Bar reading
     * chart-level data alongside a Scatter with its own outlier data) produces a
     * domain that covers all values from all sources.
     */ items.forEach((item)=>{
        var _errorBars$item$id;
        var itemData = item.data != null ? [
            ...item.data
        ] : chartDataSlice;
        var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>$6aac8fe27ae10a7b$export$8b0eb5a8c39b724f(axisType, errorBar));
        itemData.forEach((entry)=>{
            var _axisSettings$dataKey;
            var valueByDataKey = (0, $hBeJX.getValueByDataKey)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = $6aac8fe27ae10a7b$export$25971beae035f58a(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = $6aac8fe27ae10a7b$var$makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null && items.length === 0) // When there are no items, fall back to the displayed data (chart-level or graphical item data).
    displayedData.forEach((item)=>{
        var dataValueDomain = $6aac8fe27ae10a7b$var$makeDomain((0, $hBeJX.getValueByDataKey)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, $iMnqX.isWellBehavedNumber)(lowerEnd) && (0, $iMnqX.isWellBehavedNumber)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var $6aac8fe27ae10a7b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$var$selectCartesianItemsSettingsExceptStacked,
    $6aac8fe27ae10a7b$export$9429ab4550237b6d,
    (0, $fU6gH.pickAxisType),
    (0, $i2WC7.selectChartDataSliceIfNotInPanorama)
], $6aac8fe27ae10a7b$export$df56c8e9a3e45e65, {
    memoizeOptions: {
        resultEqualityCheck: (0, $2a4jF.numberDomainEqualityCheck)
    }
});
function $6aac8fe27ae10a7b$var$onlyAllowNumbersAndStringsAndDates(item) {
    var value = item.value;
    if ((0, $3FiDp.isNumOrStr)(value) || value instanceof Date) return value;
    return undefined;
}
var $6aac8fe27ae10a7b$var$computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map($6aac8fe27ae10a7b$var$onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, $3FiDp.hasDuplicate)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, $9TtvW.range)(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var $6aac8fe27ae10a7b$export$71580de5ed38161a = (state)=>state.referenceElements.dots;
var $6aac8fe27ae10a7b$export$2829d12117d2002f = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var $6aac8fe27ae10a7b$export$dc267b7b9026caca = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$71580de5ed38161a,
    (0, $fU6gH.pickAxisType),
    (0, $8VTts.pickAxisId)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6 = (state)=>state.referenceElements.areas;
var $6aac8fe27ae10a7b$export$699de899b7bc81a9 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$c7e152cb7f10c1a6,
    (0, $fU6gH.pickAxisType),
    (0, $8VTts.pickAxisId)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$8fe2a49ce63c5348 = (state)=>state.referenceElements.lines;
var $6aac8fe27ae10a7b$export$29b80feb73eec2b3 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$8fe2a49ce63c5348,
    (0, $fU6gH.pickAxisType),
    (0, $8VTts.pickAxisId)
], $6aac8fe27ae10a7b$export$2829d12117d2002f);
var $6aac8fe27ae10a7b$export$5da0b79fd816ec4b = (dots, axisType)=>{
    if (dots == null) return undefined;
    var allCoords = $6aac8fe27ae10a7b$var$onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceDotsDomain = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$dc267b7b9026caca, (0, $fU6gH.pickAxisType), $6aac8fe27ae10a7b$export$5da0b79fd816ec4b);
var $6aac8fe27ae10a7b$export$7b27918cf5e1fc19 = (areas, axisType)=>{
    if (areas == null) return undefined;
    var allCoords = $6aac8fe27ae10a7b$var$onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceAreasDomain = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$699de899b7bc81a9,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$7b27918cf5e1fc19);
function $6aac8fe27ae10a7b$var$extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return $6aac8fe27ae10a7b$var$onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(segmentCoordinates);
}
function $6aac8fe27ae10a7b$var$extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return $6aac8fe27ae10a7b$var$onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return $6aac8fe27ae10a7b$var$onlyAllowNumbers(segmentCoordinates);
}
var $6aac8fe27ae10a7b$export$f1d17aebd11953eb = (lines, axisType)=>{
    if (lines == null) return undefined;
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? $6aac8fe27ae10a7b$var$extractXCoordinates(line) : $6aac8fe27ae10a7b$var$extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var $6aac8fe27ae10a7b$var$selectReferenceLinesDomain = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$29b80feb73eec2b3,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$f1d17aebd11953eb);
var $6aac8fe27ae10a7b$var$selectReferenceElementsDomain = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$var$selectReferenceDotsDomain, $6aac8fe27ae10a7b$var$selectReferenceLinesDomain, $6aac8fe27ae10a7b$var$selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(dotsDomain, areasDomain, linesDomain);
});
var $6aac8fe27ae10a7b$export$b9eca0fd568f66a4 = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType, numericTicksDomain)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : $6aac8fe27ae10a7b$export$9c8185c6eda0fb0d(referenceElementsDomain, dataAndErrorBarsDomain);
    var parsedDomain = (0, $agTdp.parseNumericalUserDomain)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
    if (parsedDomain != null) return parsedDomain;
    /*
   * https://github.com/recharts/recharts/issues/7362
   * The user-provided domain could not be resolved without data - it's a function
   * bound or one of 'auto'/'dataMin'/'dataMax' - and there is no data domain to
   * resolve it from: empty or all-null data, and no domain-extending reference
   * elements (only reference dots/lines/areas with ifOverflow="extendDomain"
   * contribute to mergedDomains). If the
   * axis opted into data overflow and supplied an explicit numeric `ticks` array,
   * fall back to the ticks' [min, max] extent so the explicit tick ladder still
   * renders, mirroring what a literal numeric domain already does.
   */ if (axisSettings.allowDataOverflow && mergedDomains == null && numericTicksDomain != null) return numericTicksDomain;
    return parsedDomain;
};
var $6aac8fe27ae10a7b$export$3853101c1665d077 = (axisSettings)=>{
    if (axisSettings == null || axisSettings.type !== 'number' || !('ticks' in axisSettings) || axisSettings.ticks == null) return undefined;
    var numericTicks = $6aac8fe27ae10a7b$var$onlyAllowNumbers(axisSettings.ticks);
    if (numericTicks.length === 0) return undefined;
    return [
        Math.min(...numericTicks),
        Math.max(...numericTicks)
    ];
};
var $6aac8fe27ae10a7b$export$bfd66b8ab0608a11 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c
], $6aac8fe27ae10a7b$export$3853101c1665d077, {
    memoizeOptions: {
        resultEqualityCheck: (0, $2a4jF.numberDomainEqualityCheck)
    }
});
var $6aac8fe27ae10a7b$export$2a64502fccb4dfa6 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$5d46410c3f089eb2,
    $6aac8fe27ae10a7b$export$c21dc69ecce61f8a,
    $6aac8fe27ae10a7b$export$969bc8d84122c036,
    $6aac8fe27ae10a7b$var$selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    $6aac8fe27ae10a7b$var$selectReferenceElementsDomain,
    (0, $jHn5r.selectChartLayout),
    (0, $fU6gH.pickAxisType),
    $6aac8fe27ae10a7b$export$bfd66b8ab0608a11
], $6aac8fe27ae10a7b$export$b9eca0fd568f66a4, {
    memoizeOptions: {
        resultEqualityCheck: (0, $2a4jF.numberDomainEqualityCheck)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var $6aac8fe27ae10a7b$var$expandDomain = [
    0,
    1
];
var $6aac8fe27ae10a7b$export$70e6ef68424edf74 = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var dataKey = axisSettings.dataKey, type = axisSettings.type;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, $9TtvW.range)(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return $6aac8fe27ae10a7b$var$computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand' && !isCategorical) return $6aac8fe27ae10a7b$var$expandDomain;
    return numericalDomain;
};
var $6aac8fe27ae10a7b$export$4fc5ecb5227dd744 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$export$6099ba314905f0c4,
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    (0, $iYis8.selectStackOffsetType),
    (0, $fU6gH.pickAxisType),
    $6aac8fe27ae10a7b$export$2a64502fccb4dfa6
], $6aac8fe27ae10a7b$export$70e6ef68424edf74);
var $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$1c7798b82c8010cd,
    (0, $iYis8.selectChartName)
], (0, $5dTrd.combineRealScaleType));
var $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c = (axisDomain, axisSettings, realScaleType)=>{
    var niceTicks = axisSettings.niceTicks;
    if (niceTicks === 'none') return undefined;
    var domainDefinition = $6aac8fe27ae10a7b$export$2e6262b6c952ab02(axisSettings);
    var hasDomainAutoKeyword = Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto');
    if ((niceTicks === 'snap125' || niceTicks === 'adaptive') && axisSettings != null && axisSettings.tickCount && (0, $agTdp.isWellFormedNumberDomain)(axisDomain)) {
        if (hasDomainAutoKeyword) return (0, $9TVxJ.getNiceTickValues)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, niceTicks);
        if (axisSettings.type === 'number') return (0, $9TVxJ.getTickValuesFixedDomain)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, niceTicks);
    }
    if (niceTicks === 'auto' && realScaleType === 'linear' && axisSettings != null && axisSettings.tickCount) {
        // Current magic-selector behaviour: apply nice ticks when the domain contains
        // an 'auto' keyword (may extend the domain), or for any fixed number-type axis.
        // Always uses the space-efficient algorithm (adaptive).
        if (hasDomainAutoKeyword && (0, $agTdp.isWellFormedNumberDomain)(axisDomain)) return (0, $9TVxJ.getNiceTickValues)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, 'adaptive');
        if (axisSettings.type === 'number' && (0, $agTdp.isWellFormedNumberDomain)(axisDomain)) return (0, $9TVxJ.getTickValuesFixedDomain)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals, 'adaptive');
    }
    return undefined;
};
var $6aac8fe27ae10a7b$export$2efb9b5d95659d33 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7
], $6aac8fe27ae10a7b$export$aa1ef6c8f610e48c);
var $6aac8fe27ae10a7b$export$3a4530026b1860ff = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, $agTdp.isWellFormedNumberDomain)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var _niceTicks$, _niceTicks;
        var minFromDomain = domain[0];
        var minFromTicks = (_niceTicks$ = niceTicks[0]) !== null && _niceTicks$ !== void 0 ? _niceTicks$ : 0;
        var maxFromDomain = domain[1];
        var maxFromTicks = (_niceTicks = niceTicks[niceTicks.length - 1]) !== null && _niceTicks !== void 0 ? _niceTicks : 0;
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var $6aac8fe27ae10a7b$export$af7761c6ea30fae4 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$3a4530026b1860ff);
var $6aac8fe27ae10a7b$export$a1013ea99dfe6af9 = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$9cea618b690f07b7, $6aac8fe27ae10a7b$export$fc14c3706e09c50c, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from($6aac8fe27ae10a7b$var$onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    var first = sortedValues[0];
    var last = sortedValues[sortedValues.length - 1];
    if (first == null || last == null) return Infinity;
    var diff = last - first;
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var curr = sortedValues[i];
        var next = sortedValues[i + 1];
        if (curr == null || next == null) continue;
        var distance = next - curr;
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var $6aac8fe27ae10a7b$var$selectCalculatedPadding = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$a1013ea99dfe6af9, (0, $jHn5r.selectChartLayout), (0, $iYis8.selectBarCategoryGap), (0, $lnFga.selectChartOffsetInternal), (_1, _2, _3, _4, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, $iMnqX.isWellBehavedNumber)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, $3FiDp.getPercentValue)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var $6aac8fe27ae10a7b$export$29cb35c3432eef0e = (state, axisId, isPanorama)=>{
    var xAxisSettings = $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return $6aac8fe27ae10a7b$var$selectCalculatedPadding(state, 'xAxis', axisId, isPanorama, xAxisSettings.padding);
};
var $6aac8fe27ae10a7b$export$689bf02345b2d857 = (state, axisId, isPanorama)=>{
    var yAxisSettings = $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return $6aac8fe27ae10a7b$var$selectCalculatedPadding(state, 'yAxis', axisId, isPanorama, yAxisSettings.padding);
};
var $6aac8fe27ae10a7b$var$selectXAxisPadding = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$d6895d8ddb4cee5, $6aac8fe27ae10a7b$export$29cb35c3432eef0e, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var padding = xAxisSettings.padding;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var $6aac8fe27ae10a7b$var$selectYAxisPadding = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$1f472705a332f1c9, $6aac8fe27ae10a7b$export$689bf02345b2d857, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var padding = yAxisSettings.padding;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var $6aac8fe27ae10a7b$export$ad97ad38bffcee71 = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal),
    $6aac8fe27ae10a7b$var$selectXAxisPadding,
    (0, $3o7wy.selectBrushDimensions),
    (0, $3o7wy.selectBrushSettings),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref6, isPanorama)=>{
    var brushPadding = _ref6.padding;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var $6aac8fe27ae10a7b$export$e20c6b0368220a6a = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal),
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$var$selectYAxisPadding,
    (0, $3o7wy.selectBrushDimensions),
    (0, $3o7wy.selectBrushSettings),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref7, isPanorama)=>{
    var brushPadding = _ref7.padding;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var $6aac8fe27ae10a7b$export$3506ed461810cc8f = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$ad97ad38bffcee71(state, axisId, isPanorama);
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$e20c6b0368220a6a(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = $6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, $7bJlR.selectAngleAxisRange)(state);
        case 'radiusAxis':
            return (0, $7bJlR.selectRadiusAxisRange)(state, axisId);
        default:
            return undefined;
    }
};
var $6aac8fe27ae10a7b$export$d6d5faff23feedea = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f
], (0, $2yfvu.combineAxisRangeWithReverse));
var $6aac8fe27ae10a7b$export$18099cdfb97d7dcd = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$af7761c6ea30fae4
], (0, $9hA9H.combineCheckedDomain));
var $6aac8fe27ae10a7b$var$selectConfiguredScale = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$18099cdfb97d7dcd,
    $6aac8fe27ae10a7b$export$d6d5faff23feedea
], (0, $l1Iwr.combineConfiguredScale));
var $6aac8fe27ae10a7b$export$911ef47868c9ab07 = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var type = axis.type, scale = axis.scale;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var $6aac8fe27ae10a7b$export$a6a79e7a5412631c = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$911ef47868c9ab07);
var $6aac8fe27ae10a7b$export$22e8e5f8924724ea = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$var$selectConfiguredScale
], (0, $eBpK5.rechartsScaleFactory));
var $6aac8fe27ae10a7b$export$657c51a9a0740206 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$var$selectConfiguredScale
], (0, $dPWwa.combineInverseScaleFunction));
var $6aac8fe27ae10a7b$export$ddc8d5321a023350 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$var$selectConfiguredScale,
    $6aac8fe27ae10a7b$export$23eb57bf0bace166
], (0, $gYUxO.createCategoricalInverse));
var $6aac8fe27ae10a7b$export$565b9812b1d7c04f = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$533d13f911334c9d,
    $6aac8fe27ae10a7b$export$9429ab4550237b6d,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$var$combineRelevantErrorBarSettings);
function $6aac8fe27ae10a7b$var$compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var $6aac8fe27ae10a7b$var$pickAxisOrientation = (_state, orientation)=>orientation;
var $6aac8fe27ae10a7b$var$pickMirror = (_state, _orientation, mirror)=>mirror;
var $6aac8fe27ae10a7b$var$selectAllXAxesWithOffsetType = (0, $b0nKR.createSelector)((0, $8fDe7.selectAllXAxes), $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($6aac8fe27ae10a7b$var$compareIds));
var $6aac8fe27ae10a7b$var$selectAllYAxesWithOffsetType = (0, $b0nKR.createSelector)((0, $8fDe7.selectAllYAxes), $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort($6aac8fe27ae10a7b$var$compareIds));
var $6aac8fe27ae10a7b$var$getXAxisSize = (offset, axisSettings)=>{
    var height = typeof axisSettings.height === 'number' ? axisSettings.height : (0, $lcI2N.DEFAULT_X_AXIS_HEIGHT);
    return {
        width: offset.width,
        height: height
    };
};
var $6aac8fe27ae10a7b$var$getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $lcI2N.DEFAULT_Y_AXIS_WIDTH);
    return {
        width: width,
        height: offset.height
    };
};
var $6aac8fe27ae10a7b$export$50d4085c87c19b12 = (0, $b0nKR.createSelector)((0, $lnFga.selectChartOffsetInternal), $6aac8fe27ae10a7b$export$d6895d8ddb4cee5, $6aac8fe27ae10a7b$var$getXAxisSize);
var $6aac8fe27ae10a7b$var$combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var $6aac8fe27ae10a7b$var$combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var $6aac8fe27ae10a7b$export$6cb04966ad155e81 = (0, $b0nKR.createSelector)((0, $V5fxS.selectChartHeight), (0, $lnFga.selectChartOffsetInternal), $6aac8fe27ae10a7b$var$selectAllXAxesWithOffsetType, $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $6aac8fe27ae10a7b$var$getXAxisSize(offset, axis);
        if (position == null) position = $6aac8fe27ae10a7b$var$combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var $6aac8fe27ae10a7b$export$edba808018e1c207 = (0, $b0nKR.createSelector)((0, $V5fxS.selectChartWidth), (0, $lnFga.selectChartOffsetInternal), $6aac8fe27ae10a7b$var$selectAllYAxesWithOffsetType, $6aac8fe27ae10a7b$var$pickAxisOrientation, $6aac8fe27ae10a7b$var$pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = $6aac8fe27ae10a7b$var$getYAxisSize(offset, axis);
        if (position == null) position = $6aac8fe27ae10a7b$var$combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var $6aac8fe27ae10a7b$var$selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $6aac8fe27ae10a7b$export$d6895d8ddb4cee5(state, axisId);
    if (axisSettings == null) return undefined;
    return $6aac8fe27ae10a7b$export$6cb04966ad155e81(state, axisSettings.orientation, axisSettings.mirror);
};
var $6aac8fe27ae10a7b$export$92fdc590d2371053 = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal),
    $6aac8fe27ae10a7b$export$d6895d8ddb4cee5,
    $6aac8fe27ae10a7b$var$selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var $6aac8fe27ae10a7b$var$selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = $6aac8fe27ae10a7b$export$1f472705a332f1c9(state, axisId);
    if (axisSettings == null) return undefined;
    return $6aac8fe27ae10a7b$export$edba808018e1c207(state, axisSettings.orientation, axisSettings.mirror);
};
var $6aac8fe27ae10a7b$export$e67a320452ebcaef = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal),
    $6aac8fe27ae10a7b$export$1f472705a332f1c9,
    $6aac8fe27ae10a7b$var$selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var $6aac8fe27ae10a7b$export$249bec756af8ac39 = (0, $b0nKR.createSelector)((0, $lnFga.selectChartOffsetInternal), $6aac8fe27ae10a7b$export$1f472705a332f1c9, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, $lcI2N.DEFAULT_Y_AXIS_WIDTH);
    return {
        width: width,
        height: offset.height
    };
});
var $6aac8fe27ae10a7b$export$6d6e642aa7a0ae10 = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return $6aac8fe27ae10a7b$export$50d4085c87c19b12(state, axisId).width;
        case 'yAxis':
            return $6aac8fe27ae10a7b$export$249bec756af8ac39(state, axisId).height;
        default:
            return undefined;
    }
};
var $6aac8fe27ae10a7b$export$bb1ebf56a37bd899 = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var allowDuplicatedCategory = axis.allowDuplicatedCategory, type = axis.type, dataKey = axis.dataKey;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    var validData = allData.filter((v)=>v != null);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, $3FiDp.hasDuplicate)(validData)) return allData;
    return undefined;
};
var $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$export$9cea618b690f07b7,
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$bb1ebf56a37bd899);
var $6aac8fe27ae10a7b$export$45cd57660792dd31 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$var$selectCartesianAxisSettings,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    (0, $fU6gH.pickAxisType)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType: axisType,
        categoricalDomain: categoricalDomain,
        duplicateDomain: duplicateDomain,
        isCategorical: isCategorical,
        niceTicks: niceTicks,
        range: axisRange,
        realScaleType: realScaleType,
        scale: scale
    };
});
var $6aac8fe27ae10a7b$export$d033262fd214bffb = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    var type = axis.type, ticks = axis.ticks, tickCount = axis.tickCount;
    var offsetForBand = // @ts-expect-error This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, $3FiDp.mathSign)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) return ticksOrNiceTicks.map((entry, index)=>{
        var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
        var scaled = scale.map(scaleContent);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            index: index,
            coordinate: scaled + offset,
            value: entry,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    // When axis is a categorical axis, but the type of axis is not number and scale is not "auto"
    // For type='number' with linear scale (where niceTicks are available), skip this branch
    // so ticks are evenly spaced instead of placed at data positions (GitHub issue #4271)
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use Date as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
};
var $6aac8fe27ae10a7b$export$f0d85e8287c47657 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$2efb9b5d95659d33,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$d033262fd214bffb);
var $6aac8fe27ae10a7b$export$453d0e9212f0369b = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, $hBeJX.isCategoricalAxis)(layout, axisType);
    var tickCount = axis.tickCount;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, $3FiDp.mathSign)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    if (scale.ticks) return scale.ticks(tickCount).map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            value: entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>{
        var scaled = scale.map(entry);
        if (!(0, $iMnqX.isWellBehavedNumber)(scaled)) return null;
        return {
            coordinate: scaled + offset,
            // @ts-expect-error can't use unknown as index
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    }).filter((0, $3FiDp.isNotNil));
};
var $6aac8fe27ae10a7b$export$b894cb5d8586b43d = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $6aac8fe27ae10a7b$export$f5176fa96b596697,
    $6aac8fe27ae10a7b$export$22e8e5f8924724ea,
    $6aac8fe27ae10a7b$export$3506ed461810cc8f,
    $6aac8fe27ae10a7b$export$4fc6aadcd9e9157c,
    $6aac8fe27ae10a7b$export$a6a79e7a5412631c,
    (0, $fU6gH.pickAxisType)
], $6aac8fe27ae10a7b$export$453d0e9212f0369b);
var $6aac8fe27ae10a7b$export$db36c2f3bfe5c9d7 = (0, $b0nKR.createSelector)($6aac8fe27ae10a7b$export$fc14c3706e09c50c, $6aac8fe27ae10a7b$export$22e8e5f8924724ea, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $6aac8fe27ae10a7b$var$_objectSpread($6aac8fe27ae10a7b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $6aac8fe27ae10a7b$var$selectZAxisConfiguredScale = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$fc14c3706e09c50c,
    $6aac8fe27ae10a7b$export$a1a58ca78bb13ce7,
    $6aac8fe27ae10a7b$export$4fc5ecb5227dd744,
    $6aac8fe27ae10a7b$export$d6d5faff23feedea
], (0, $l1Iwr.combineConfiguredScale));
var $6aac8fe27ae10a7b$var$selectZAxisScale = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$var$selectZAxisConfiguredScale
], (0, $eBpK5.rechartsScaleFactory));
var $6aac8fe27ae10a7b$export$4dab5213d1420bb3 = (0, $b0nKR.createSelector)((state, _axisType, axisId)=>$6aac8fe27ae10a7b$export$26eadf639b453d0f(state, axisId), $6aac8fe27ae10a7b$var$selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return $6aac8fe27ae10a7b$var$_objectSpread($6aac8fe27ae10a7b$var$_objectSpread({}, axis), {}, {
        scale: scale
    });
});
var $6aac8fe27ae10a7b$export$430d623a94added7 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    (0, $8fDe7.selectAllXAxes),
    (0, $8fDe7.selectAllYAxes)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});
var $6aac8fe27ae10a7b$export$9cc7232c10fac9e = (state, axisType, axisId)=>{
    var _state$renderedTicks$;
    return (_state$renderedTicks$ = state.renderedTicks[axisType]) === null || _state$renderedTicks$ === void 0 ? void 0 : _state$renderedTicks$[axisId];
};
var $6aac8fe27ae10a7b$export$767aec070f996e73 = (0, $b0nKR.createSelector)([
    $6aac8fe27ae10a7b$export$9cc7232c10fac9e
], (ticks)=>{
    if (!ticks || ticks.length === 0) return undefined;
    return (pixelValue)=>{
        var _closestTick;
        // Find the tick with the closest coordinate to pixelValue
        var minDistance = Infinity;
        var closestTick = ticks[0];
        for (var tick of ticks){
            var distance = Math.abs(tick.coordinate - pixelValue);
            if (distance < minDistance) {
                minDistance = distance;
                closestTick = tick;
            }
        }
        return (_closestTick = closestTick) === null || _closestTick === void 0 ? void 0 : _closestTick.value;
    };
});

});
parcelRegister("9TtvW", function(module, exports) {

$parcel$export(module.exports, "range", () => $836344bbefec89e3$export$d02631cccf789723);

var $etH7D = parcelRequire("etH7D");

var $1fg27 = parcelRequire("1fg27");
//#region src/compat/math/range.ts
/**
* Returns an array of numbers from `start` (inclusive) to `end` (exclusive), incrementing by `step`.
*
* @param start - The starting number of the range (inclusive).
* @param end - The end number of the range (exclusive).
* @param step - The step value for the range.
* @returns An array of numbers from `start` (inclusive) to `end` (exclusive) with the specified `step`.
*
* @example
* // Returns [0, 1, 2, 3]
* range(4);
*
* @example
* // Returns [0, -1, -2, -3]
* range(0, -4, -1);
*/ function $836344bbefec89e3$export$d02631cccf789723(start, end, step) {
    if (step && typeof step !== "number" && (0, $1fg27.isIterateeCall)(start, end, step)) end = step = void 0;
    start = (0, $etH7D.toFinite)(start);
    if (end === void 0) {
        end = start;
        start = 0;
    } else end = (0, $etH7D.toFinite)(end);
    step = step === void 0 ? start < end ? 1 : -1 : (0, $etH7D.toFinite)(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}

});
parcelRegister("etH7D", function(module, exports) {

$parcel$export(module.exports, "toFinite", () => $f61b78fbdcf13def$export$7109d1a0d57e8f54);

var $ei4e6 = parcelRequire("ei4e6");
//#region src/compat/util/toFinite.ts
/**
* Converts `value` to a finite number.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toFinite(3.2); // => 3.2
* toFinite(Number.MIN_VALUE); // => 5e-324
* toFinite(Infinity); // => 1.7976931348623157e+308
* toFinite('3.2'); // => 3.2
* toFinite(Symbol.iterator); // => 0
* toFinite(NaN); // => 0
*/ function $f61b78fbdcf13def$export$7109d1a0d57e8f54(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $ei4e6.toNumber)(value);
    if (value === Infinity || value === -Infinity) return (value < 0 ? -1 : 1) * Number.MAX_VALUE;
    return value === value ? value : 0;
}

});
parcelRegister("ei4e6", function(module, exports) {

$parcel$export(module.exports, "toNumber", () => $48aba1e1a2d35d40$export$a0a81dc3380ce7d3);

var $79zhJ = parcelRequire("79zhJ");
//#region src/compat/util/toNumber.ts
/**
* Converts `value` to a number.
*
* Unlike `Number()`, this function returns `NaN` for symbols.
*
* @param value - The value to convert.
* @returns Returns the number.
*
* @example
* toNumber(3.2); // => 3.2
* toNumber(Number.MIN_VALUE); // => 5e-324
* toNumber(Infinity); // => Infinity
* toNumber('3.2'); // => 3.2
* toNumber(Symbol.iterator); // => NaN
* toNumber(NaN); // => NaN
*/ function $48aba1e1a2d35d40$export$a0a81dc3380ce7d3(value) {
    if ((0, $79zhJ.isSymbol)(value)) return NaN;
    return Number(value);
}

});



parcelRegister("i2WC7", function(module, exports) {

$parcel$export(module.exports, "selectChartDataWithIndexes", () => $d235e165ed12974e$export$519edd692222520);
$parcel$export(module.exports, "selectChartDataAndAlwaysIgnoreIndexes", () => $d235e165ed12974e$export$3b10e41b7db2c36);
$parcel$export(module.exports, "selectChartDataWithIndexesIfNotInPanoramaPosition4", () => $d235e165ed12974e$export$fe05134c2701d897);
$parcel$export(module.exports, "selectChartDataWithIndexesIfNotInPanoramaPosition3", () => $d235e165ed12974e$export$46bf9459876c0e0c);
$parcel$export(module.exports, "selectChartDataSliceIfNotInPanorama", () => $d235e165ed12974e$export$7a294fd94385f1e2);
$parcel$export(module.exports, "selectChartDataSliceIgnoringIndexes", () => $d235e165ed12974e$export$e6f0a66ed1f5780f);
$parcel$export(module.exports, "selectChartDataSliceWithIndexes", () => $d235e165ed12974e$export$562e7f818eadc746);

var $b0nKR = parcelRequire("b0nKR");
var $d235e165ed12974e$export$519edd692222520 = (state)=>state.chartData;
var $d235e165ed12974e$export$3b10e41b7db2c36 = (0, $b0nKR.createSelector)([
    $d235e165ed12974e$export$519edd692222520
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex: dataEndIndex,
        dataStartIndex: 0
    };
});
var $d235e165ed12974e$export$fe05134c2701d897 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return $d235e165ed12974e$export$3b10e41b7db2c36(state);
    return $d235e165ed12974e$export$519edd692222520(state);
};
var $d235e165ed12974e$export$46bf9459876c0e0c = (state, _unused1, isPanorama)=>{
    if (isPanorama) return $d235e165ed12974e$export$3b10e41b7db2c36(state);
    return $d235e165ed12974e$export$519edd692222520(state);
};
var $d235e165ed12974e$export$7a294fd94385f1e2 = (0, $b0nKR.createSelector)([
    $d235e165ed12974e$export$fe05134c2701d897
], (_ref)=>{
    var chartData = _ref.chartData, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});
var $d235e165ed12974e$export$e6f0a66ed1f5780f = (0, $b0nKR.createSelector)([
    $d235e165ed12974e$export$3b10e41b7db2c36
], (_ref2)=>{
    var chartData = _ref2.chartData, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});
var $d235e165ed12974e$export$562e7f818eadc746 = (0, $b0nKR.createSelector)([
    $d235e165ed12974e$export$519edd692222520
], (_ref3)=>{
    var chartData = _ref3.chartData, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    return chartData != null ? chartData.slice(dataStartIndex, dataEndIndex + 1) : [];
});

});

parcelRegister("agTdp", function(module, exports) {

$parcel$export(module.exports, "isWellFormedNumberDomain", () => $77a63a99eb6fec8b$export$ba29b24e2a92eb58);
$parcel$export(module.exports, "numericalDomainSpecifiedWithoutRequiringData", () => $77a63a99eb6fec8b$export$fcbf88d4627b24df);
$parcel$export(module.exports, "parseNumericalUserDomain", () => $77a63a99eb6fec8b$export$3f87aa7a53437a70);

var $hBeJX = parcelRequire("hBeJX");

var $3FiDp = parcelRequire("3FiDp");

var $iMnqX = parcelRequire("iMnqX");
function $77a63a99eb6fec8b$var$_slicedToArray(r, e) {
    return $77a63a99eb6fec8b$var$_arrayWithHoles(r) || $77a63a99eb6fec8b$var$_iterableToArrayLimit(r, e) || $77a63a99eb6fec8b$var$_unsupportedIterableToArray(r, e) || $77a63a99eb6fec8b$var$_nonIterableRest();
}
function $77a63a99eb6fec8b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $77a63a99eb6fec8b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $77a63a99eb6fec8b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $77a63a99eb6fec8b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $77a63a99eb6fec8b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $77a63a99eb6fec8b$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $77a63a99eb6fec8b$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $77a63a99eb6fec8b$export$ba29b24e2a92eb58(v) {
    if (Array.isArray(v) && v.length === 2) {
        var _v = $77a63a99eb6fec8b$var$_slicedToArray(v, 2), min = _v[0], max = _v[1];
        if ((0, $iMnqX.isWellBehavedNumber)(min) && (0, $iMnqX.isWellBehavedNumber)(max)) return true;
    }
    return false;
}
function $77a63a99eb6fec8b$export$15a9d37c57dafeb9(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function $77a63a99eb6fec8b$export$fcbf88d4627b24df(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var _userDomain = $77a63a99eb6fec8b$var$_slicedToArray(userDomain, 2), providedMin = _userDomain[0], providedMax = _userDomain[1];
        var finalMin, finalMax;
        if ((0, $iMnqX.isWellBehavedNumber)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, $iMnqX.isWellBehavedNumber)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(candidate)) return candidate;
    }
    return undefined;
}
function $77a63a99eb6fec8b$export$3f87aa7a53437a70(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(result)) return $77a63a99eb6fec8b$export$15a9d37c57dafeb9(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var _userDomain2 = $77a63a99eb6fec8b$var$_slicedToArray(userDomain, 2), providedMin = _userDomain2[0], providedMax = _userDomain2[1];
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, $3FiDp.isNumber)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, $hBeJX.MIN_VALUE_REG).test(providedMin)) {
            var match = (0, $hBeJX.MIN_VALUE_REG).exec(providedMin);
            if (match == null || match[1] == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, $3FiDp.isNumber)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, $hBeJX.MAX_VALUE_REG).test(providedMax)) {
            var _match = (0, $hBeJX.MAX_VALUE_REG).exec(providedMax);
            if (_match == null || _match[1] == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if ($77a63a99eb6fec8b$export$ba29b24e2a92eb58(candidate)) {
            if (dataDomain == null) return candidate;
            return $77a63a99eb6fec8b$export$15a9d37c57dafeb9(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}

});

parcelRegister("9TVxJ", function(module, exports) {

$parcel$export(module.exports, "getNiceTickValues", () => $7355e2f233c5e6b9$export$b84e75ccbfe6a612);
$parcel$export(module.exports, "getTickValuesFixedDomain", () => $7355e2f233c5e6b9$export$e9d28da780436e98);

var $1O1BY = parcelRequire("1O1BY");

var $dhAKd = parcelRequire("dhAKd");
function $7355e2f233c5e6b9$var$_slicedToArray(r, e) {
    return $7355e2f233c5e6b9$var$_arrayWithHoles(r) || $7355e2f233c5e6b9$var$_iterableToArrayLimit(r, e) || $7355e2f233c5e6b9$var$_unsupportedIterableToArray(r, e) || $7355e2f233c5e6b9$var$_nonIterableRest();
}
function $7355e2f233c5e6b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7355e2f233c5e6b9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7355e2f233c5e6b9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7355e2f233c5e6b9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7355e2f233c5e6b9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7355e2f233c5e6b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7355e2f233c5e6b9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13 = (_ref)=>{
    var _ref2 = $7355e2f233c5e6b9$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max;
    // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
};
var $7355e2f233c5e6b9$export$2e59d63884599fab = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0);
    var digitCount = (0, $dhAKd.getDigitCount)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(formatStep.toNumber()) : new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.ceil(formatStep.toNumber()));
};
var $7355e2f233c5e6b9$export$2247094b407efa80 = (roughStep, allowDecimals, correctionFactor)=>{
    var _NICE_STEPS$niceIdx;
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0);
    var NICE_STEPS = [
        1,
        2,
        2.5,
        5
    ];
    var roughNum = roughStep.toNumber();
    var exponent = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(roughNum).abs().log(10).toNumber());
    var magnitude = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(10).pow(exponent);
    // normalized is in the range [1, 10)
    var normalized = roughStep.div(magnitude).toNumber();
    // Find the smallest nice step >= normalized (ceiling)
    var niceIdx = NICE_STEPS.findIndex((s)=>s >= normalized - 1e-10);
    if (niceIdx === -1) {
        // normalized > 5 (e.g. 7.3), move to next order of magnitude
        magnitude = magnitude.mul(10);
        niceIdx = 0;
    }
    // Apply correction factor by stepping through the nice number sequence
    niceIdx += correctionFactor;
    if (niceIdx >= NICE_STEPS.length) {
        var extraMag = Math.floor(niceIdx / NICE_STEPS.length);
        niceIdx %= NICE_STEPS.length;
        magnitude = magnitude.mul(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(10).pow(extraMag));
    }
    var niceStep = (_NICE_STEPS$niceIdx = NICE_STEPS[niceIdx]) !== null && _NICE_STEPS$niceIdx !== void 0 ? _NICE_STEPS$niceIdx : 1;
    var formatStep = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(niceStep).mul(magnitude);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.ceil(formatStep.toNumber()));
};
var $7355e2f233c5e6b9$export$8913aec4ff751b4d = (value, tickCount, allowDecimals)=>{
    var step = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(1);
    // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(10).pow((0, $dhAKd.getDigitCount)(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var ticks = [];
    for(var i = 0; i < tickCount; i++)ticks.push(middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(i - middleIndex).mul(step)).toNumber());
    return ticks;
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var $7355e2f233c5e6b9$export$ca78fcd978995194 = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var stepFn = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : $7355e2f233c5e6b9$export$2e59d63884599fab;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0)
    };
    // The step which is easy to understand between two ticks
    var step = stepFn(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $7355e2f233c5e6b9$export$ca78fcd978995194(min, max, tickCount, allowDecimals, correctionFactor + 1, stepFn);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(upCount).mul(step))
    };
};
var $7355e2f233c5e6b9$export$b84e75ccbfe6a612 = function getNiceTickValues(_ref3) {
    var _ref4 = $7355e2f233c5e6b9$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var niceTicksMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'auto';
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]), _getValidInterval2 = $7355e2f233c5e6b9$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...Array(tickCount - 1).fill(Infinity)
        ] : [
            ...Array(tickCount - 1).fill(-Infinity),
            cormax
        ];
        return min > max ? _values.reverse() : _values;
    }
    if (cormin === cormax) return $7355e2f233c5e6b9$export$8913aec4ff751b4d(cormin, tickCount, allowDecimals);
    var stepFn = niceTicksMode === 'snap125' ? $7355e2f233c5e6b9$export$2247094b407efa80 : $7355e2f233c5e6b9$export$2e59d63884599fab;
    // Get the step between two ticks
    var _calculateStep2 = $7355e2f233c5e6b9$export$ca78fcd978995194(cormin, cormax, count, allowDecimals, 0, stepFn), step = _calculateStep2.step, tickMin = _calculateStep2.tickMin, tickMax = _calculateStep2.tickMax;
    var values = (0, $dhAKd.rangeStep)(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(0.1).mul(step)), step);
    return min > max ? values.reverse() : values;
};
var $7355e2f233c5e6b9$export$e9d28da780436e98 = function getTickValuesFixedDomain(_ref5, tickCount) {
    var _ref6 = $7355e2f233c5e6b9$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var niceTicksMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'auto';
    // More than two ticks should be return
    var _getValidInterval3 = $7355e2f233c5e6b9$export$9fcf9e98b0fc6c13([
        min,
        max
    ]), _getValidInterval4 = $7355e2f233c5e6b9$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var stepFn = niceTicksMode === 'snap125' ? $7355e2f233c5e6b9$export$2247094b407efa80 : $7355e2f233c5e6b9$export$2e59d63884599fab;
    var count = Math.max(tickCount, 2);
    var step = stepFn(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, $dhAKd.rangeStep)(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(cormax), step),
        cormax
    ];
    if (allowDecimals === false) {
        /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     * The domain boundary (cormax) is appended after the rangeStep values. When
     * cormax rounds down to the same integer as the last rangeStep value, we end up
     * with a duplicate trailing tick. Remove it.
     */ values = values.map((value)=>Math.round(value));
        var last = values.length - 1;
        if (last > 0 && values[last] === values[last - 1]) values = values.slice(0, last);
    }
    return min > max ? values.reverse() : values;
};

});
parcelRegister("1O1BY", function(module, exports) {
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});

parcelRegister("dhAKd", function(module, exports) {

$parcel$export(module.exports, "getDigitCount", () => $9ab95d9069174a61$export$c21fa0a8c666ce01);
$parcel$export(module.exports, "rangeStep", () => $9ab95d9069174a61$export$85207d4610782ccb);
/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ 
var $1O1BY = parcelRequire("1O1BY");
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function $9ab95d9069174a61$export$c21fa0a8c666ce01(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function $9ab95d9069174a61$export$85207d4610782ccb(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($1O1BY)))(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}

});


parcelRegister("iYis8", function(module, exports) {

$parcel$export(module.exports, "selectRootMaxBarSize", () => $dcfc24e85ad2aefd$export$db43f3089e0ec1e9);
$parcel$export(module.exports, "selectBarGap", () => $dcfc24e85ad2aefd$export$9b8e3d53e72fb7a8);
$parcel$export(module.exports, "selectBarCategoryGap", () => $dcfc24e85ad2aefd$export$a73f9d39b015942a);
$parcel$export(module.exports, "selectRootBarSize", () => $dcfc24e85ad2aefd$export$be00206a4a82272f);
$parcel$export(module.exports, "selectStackOffsetType", () => $dcfc24e85ad2aefd$export$73aff39176364def);
$parcel$export(module.exports, "selectReverseStackOrder", () => $dcfc24e85ad2aefd$export$ec830dc49707c6da);
$parcel$export(module.exports, "selectChartName", () => $dcfc24e85ad2aefd$export$3247769c9dbde559);
$parcel$export(module.exports, "selectSyncId", () => $dcfc24e85ad2aefd$export$d3b88e5c88540018);
$parcel$export(module.exports, "selectSyncMethod", () => $dcfc24e85ad2aefd$export$f3cbf53653105e96);
$parcel$export(module.exports, "selectEventEmitter", () => $dcfc24e85ad2aefd$export$b89defd58e84e980);
$parcel$export(module.exports, "selectChartBaseValue", () => $dcfc24e85ad2aefd$export$a1ad1f48be8d5def);
var $dcfc24e85ad2aefd$export$db43f3089e0ec1e9 = (state)=>state.rootProps.maxBarSize;
var $dcfc24e85ad2aefd$export$9b8e3d53e72fb7a8 = (state)=>state.rootProps.barGap;
var $dcfc24e85ad2aefd$export$a73f9d39b015942a = (state)=>state.rootProps.barCategoryGap;
var $dcfc24e85ad2aefd$export$be00206a4a82272f = (state)=>state.rootProps.barSize;
var $dcfc24e85ad2aefd$export$73aff39176364def = (state)=>state.rootProps.stackOffset;
var $dcfc24e85ad2aefd$export$ec830dc49707c6da = (state)=>state.rootProps.reverseStackOrder;
var $dcfc24e85ad2aefd$export$3247769c9dbde559 = (state)=>state.options.chartName;
var $dcfc24e85ad2aefd$export$d3b88e5c88540018 = (state)=>state.rootProps.syncId;
var $dcfc24e85ad2aefd$export$f3cbf53653105e96 = (state)=>state.rootProps.syncMethod;
var $dcfc24e85ad2aefd$export$b89defd58e84e980 = (state)=>state.options.eventEmitter;
var $dcfc24e85ad2aefd$export$a1ad1f48be8d5def = (state)=>state.rootProps.baseValue;

});

parcelRegister("7bJlR", function(module, exports) {

$parcel$export(module.exports, "selectAngleAxis", () => $53bcbd5d17089da8$export$2d9ff7eb66def0da);
$parcel$export(module.exports, "selectRadiusAxis", () => $53bcbd5d17089da8$export$74b0499accddabe1);
$parcel$export(module.exports, "selectAngleAxisRange", () => $53bcbd5d17089da8$export$d00c8e94622c940);
$parcel$export(module.exports, "selectRadiusAxisRange", () => $53bcbd5d17089da8$export$e13d847e4d4f833f);
$parcel$export(module.exports, "selectPolarViewBox", () => $53bcbd5d17089da8$export$57f4101c1e20bd95);

var $b0nKR = parcelRequire("b0nKR");

var $V5fxS = parcelRequire("V5fxS");

var $lnFga = parcelRequire("lnFga");

var $1l5bp = parcelRequire("1l5bp");

var $3FiDp = parcelRequire("3FiDp");

var $3fo93 = parcelRequire("3fo93");

var $7yNfU = parcelRequire("7yNfU");

var $2yfvu = parcelRequire("2yfvu");

var $jHn5r = parcelRequire("jHn5r");

var $kh3bM = parcelRequire("kh3bM");
function $53bcbd5d17089da8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53bcbd5d17089da8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53bcbd5d17089da8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $53bcbd5d17089da8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53bcbd5d17089da8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $53bcbd5d17089da8$var$_defineProperty(e, r, t) {
    return (r = $53bcbd5d17089da8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $53bcbd5d17089da8$var$_toPropertyKey(t) {
    var i = $53bcbd5d17089da8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $53bcbd5d17089da8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $53bcbd5d17089da8$export$7489bacc62c76b42 = {
    allowDataOverflow: (0, $3fo93.defaultPolarAngleAxisProps).allowDataOverflow,
    allowDecimals: (0, $3fo93.defaultPolarAngleAxisProps).allowDecimals,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, $3fo93.defaultPolarAngleAxisProps).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, $3fo93.defaultPolarAngleAxisProps).reversed,
    scale: (0, $3fo93.defaultPolarAngleAxisProps).scale,
    tick: (0, $3fo93.defaultPolarAngleAxisProps).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, $3fo93.defaultPolarAngleAxisProps).type,
    unit: undefined,
    niceTicks: 'auto'
};
var $53bcbd5d17089da8$export$31037ebc9a4d24a3 = {
    allowDataOverflow: (0, $7yNfU.defaultPolarRadiusAxisProps).allowDataOverflow,
    allowDecimals: (0, $7yNfU.defaultPolarRadiusAxisProps).allowDecimals,
    allowDuplicatedCategory: (0, $7yNfU.defaultPolarRadiusAxisProps).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, $7yNfU.defaultPolarRadiusAxisProps).radiusAxisId,
    includeHidden: (0, $7yNfU.defaultPolarRadiusAxisProps).includeHidden,
    name: undefined,
    reversed: (0, $7yNfU.defaultPolarRadiusAxisProps).reversed,
    scale: (0, $7yNfU.defaultPolarRadiusAxisProps).scale,
    tick: (0, $7yNfU.defaultPolarRadiusAxisProps).tick,
    tickCount: (0, $7yNfU.defaultPolarRadiusAxisProps).tickCount,
    ticks: undefined,
    type: (0, $7yNfU.defaultPolarRadiusAxisProps).type,
    unit: undefined,
    niceTicks: 'auto'
};
var $53bcbd5d17089da8$var$selectAngleAxisNoDefaults = (state, angleAxisId)=>{
    if (angleAxisId == null) return undefined;
    return state.polarAxis.angleAxis[angleAxisId];
};
var $53bcbd5d17089da8$export$2d9ff7eb66def0da = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$var$selectAngleAxisNoDefaults,
    (0, $jHn5r.selectPolarChartLayout)
], (angleAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa;
    if (angleAxisSettings != null) return angleAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa = (0, $kh3bM.getAxisTypeBasedOnLayout)(layout, 'angleAxis', $53bcbd5d17089da8$export$7489bacc62c76b42.type)) !== null && _getAxisTypeBasedOnLa !== void 0 ? _getAxisTypeBasedOnLa : 'category';
    return $53bcbd5d17089da8$var$_objectSpread($53bcbd5d17089da8$var$_objectSpread({}, $53bcbd5d17089da8$export$7489bacc62c76b42), {}, {
        type: evaluatedType
    });
});
var $53bcbd5d17089da8$var$selectRadiusAxisNoDefaults = (state, radiusAxisId)=>{
    return state.polarAxis.radiusAxis[radiusAxisId];
};
var $53bcbd5d17089da8$export$74b0499accddabe1 = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$var$selectRadiusAxisNoDefaults,
    (0, $jHn5r.selectPolarChartLayout)
], (radiusAxisSettings, layout)=>{
    var _getAxisTypeBasedOnLa2;
    if (radiusAxisSettings != null) return radiusAxisSettings;
    var evaluatedType = (_getAxisTypeBasedOnLa2 = (0, $kh3bM.getAxisTypeBasedOnLayout)(layout, 'radiusAxis', $53bcbd5d17089da8$export$31037ebc9a4d24a3.type)) !== null && _getAxisTypeBasedOnLa2 !== void 0 ? _getAxisTypeBasedOnLa2 : 'category';
    return $53bcbd5d17089da8$var$_objectSpread($53bcbd5d17089da8$var$_objectSpread({}, $53bcbd5d17089da8$export$31037ebc9a4d24a3), {}, {
        type: evaluatedType
    });
});
var $53bcbd5d17089da8$export$a743f010244424e8 = (state)=>state.polarOptions;
var $53bcbd5d17089da8$export$53b653c1c5d6829b = (0, $b0nKR.createSelector)([
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight),
    (0, $lnFga.selectChartOffsetInternal)
], (0, $1l5bp.getMaxRadius));
var $53bcbd5d17089da8$var$selectInnerRadius = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $3FiDp.getPercentValue)(polarChartOptions.innerRadius, maxRadius, 0);
});
var $53bcbd5d17089da8$export$32a1ec2f6eaad494 = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$export$53b653c1c5d6829b
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, $3FiDp.getPercentValue)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var $53bcbd5d17089da8$var$combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var startAngle = polarOptions.startAngle, endAngle = polarOptions.endAngle;
    return [
        startAngle,
        endAngle
    ];
};
var $53bcbd5d17089da8$export$d00c8e94622c940 = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$a743f010244424e8
], $53bcbd5d17089da8$var$combineAngleAxisRange);
var $53bcbd5d17089da8$export$15ccd32b0dd865d2 = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$2d9ff7eb66def0da,
    $53bcbd5d17089da8$export$d00c8e94622c940
], (0, $2yfvu.combineAxisRangeWithReverse));
var $53bcbd5d17089da8$export$e13d847e4d4f833f = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$53b653c1c5d6829b,
    $53bcbd5d17089da8$var$selectInnerRadius,
    $53bcbd5d17089da8$export$32a1ec2f6eaad494
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var $53bcbd5d17089da8$export$2b324c38f06972bb = (0, $b0nKR.createSelector)([
    $53bcbd5d17089da8$export$74b0499accddabe1,
    $53bcbd5d17089da8$export$e13d847e4d4f833f
], (0, $2yfvu.combineAxisRangeWithReverse));
var $53bcbd5d17089da8$export$57f4101c1e20bd95 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $53bcbd5d17089da8$export$a743f010244424e8,
    $53bcbd5d17089da8$var$selectInnerRadius,
    $53bcbd5d17089da8$export$32a1ec2f6eaad494,
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var cx = polarOptions.cx, cy = polarOptions.cy, startAngle = polarOptions.startAngle, endAngle = polarOptions.endAngle;
    return {
        cx: (0, $3FiDp.getPercentValue)(cx, width, width / 2),
        cy: (0, $3FiDp.getPercentValue)(cy, height, height / 2),
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});

});
parcelRegister("1l5bp", function(module, exports) {

$parcel$export(module.exports, "RADIAN", () => $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3);
$parcel$export(module.exports, "polarToCartesian", () => $0f9bc5dd76ad1109$export$5c9a959bb3fc7749);
$parcel$export(module.exports, "getMaxRadius", () => $0f9bc5dd76ad1109$export$ad5c48602371adfa);
$parcel$export(module.exports, "inRangeOfSector", () => $0f9bc5dd76ad1109$export$e85a2bf8cd31c504);
function $0f9bc5dd76ad1109$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f9bc5dd76ad1109$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f9bc5dd76ad1109$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0f9bc5dd76ad1109$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f9bc5dd76ad1109$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0f9bc5dd76ad1109$var$_defineProperty(e, r, t) {
    return (r = $0f9bc5dd76ad1109$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0f9bc5dd76ad1109$var$_toPropertyKey(t) {
    var i = $0f9bc5dd76ad1109$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0f9bc5dd76ad1109$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0f9bc5dd76ad1109$export$4f2c4f194778dcbb = (angle)=>angle * Math.PI / 180;
var $0f9bc5dd76ad1109$export$1c20e104e3e29a0a = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var $0f9bc5dd76ad1109$export$5c9a959bb3fc7749 = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0f9bc5dd76ad1109$export$d74e8f7e9cc3fed3 * angle) * radius
    });
var $0f9bc5dd76ad1109$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0f9bc5dd76ad1109$var$distanceBetweenPoints = (point, anotherPoint)=>{
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var $0f9bc5dd76ad1109$var$getAngleOfPoint = (_ref, _ref2)=>{
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $0f9bc5dd76ad1109$var$distanceBetweenPoints({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0f9bc5dd76ad1109$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0f9bc5dd76ad1109$var$formatAngleOfSector = (_ref3)=>{
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0f9bc5dd76ad1109$var$reverseFormatAngleOfSector = (angle, _ref4)=>{
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0f9bc5dd76ad1109$export$e85a2bf8cd31c504 = (_ref5, viewBox)=>{
    var x = _ref5.relativeX, y = _ref5.relativeY;
    var _getAngleOfPoint = $0f9bc5dd76ad1109$var$getAngleOfPoint({
        x: x,
        y: y
    }, viewBox), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = viewBox.innerRadius, outerRadius = viewBox.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var _formatAngleOfSector = $0f9bc5dd76ad1109$var$formatAngleOfSector(viewBox), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0f9bc5dd76ad1109$var$_objectSpread($0f9bc5dd76ad1109$var$_objectSpread({}, viewBox), {}, {
        radius: radius,
        angle: $0f9bc5dd76ad1109$var$reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};

});

parcelRegister("3fo93", function(module, exports) {

$parcel$export(module.exports, "defaultPolarAngleAxisProps", () => $25d580895de704c0$export$969183d9e860c26e);

var $gKNgz = parcelRequire("gKNgz");
var $25d580895de704c0$export$969183d9e860c26e = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    allowDataOverflow: false,
    angle: 0,
    angleAxisId: 0,
    axisLine: true,
    axisLineType: 'polygon',
    cx: 0,
    cy: 0,
    hide: false,
    includeHidden: false,
    label: false,
    niceTicks: 'auto',
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'auto',
    zIndex: (0, $gKNgz.DefaultZIndexes).axis
};

});
parcelRegister("gKNgz", function(module, exports) {

$parcel$export(module.exports, "DefaultZIndexes", () => $c327287477e919da$export$96df16b28aa32702);
/**
 * A collection of all default zIndex values used by Recharts.
 *
 * You can reuse these, or you can define your own.
 */ var $c327287477e919da$export$96df16b28aa32702 = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};

});


parcelRegister("7yNfU", function(module, exports) {

$parcel$export(module.exports, "defaultPolarRadiusAxisProps", () => $5811ea86e36cf7be$export$1a08e61551a7e57d);

var $gKNgz = parcelRequire("gKNgz");
var $5811ea86e36cf7be$export$1a08e61551a7e57d = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    includeHidden: false,
    hide: false,
    niceTicks: 'auto',
    label: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    tickLine: true,
    type: 'auto',
    zIndex: (0, $gKNgz.DefaultZIndexes).axis
};

});

parcelRegister("2yfvu", function(module, exports) {

$parcel$export(module.exports, "combineAxisRangeWithReverse", () => $1dbac917d7459aa2$export$3f7e30291950e694);
var $1dbac917d7459aa2$export$3f7e30291950e694 = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};

});

parcelRegister("kh3bM", function(module, exports) {

$parcel$export(module.exports, "getAxisTypeBasedOnLayout", () => $ec27de6f1bfb1a1f$export$c71ab14baba33626);

var $hBeJX = parcelRequire("hBeJX");
function $ec27de6f1bfb1a1f$export$c71ab14baba33626(layout, axisType, axisDomainType) {
    if (axisDomainType !== 'auto') return axisDomainType;
    if (layout == null) return undefined;
    return (0, $hBeJX.isCategoricalAxis)(layout, axisType) ? 'category' : 'number';
}

});


parcelRegister("fU6gH", function(module, exports) {

$parcel$export(module.exports, "pickAxisType", () => $b940f2b84cdec1f7$export$8a7d579879340d98);
var $b940f2b84cdec1f7$export$8a7d579879340d98 = (_state, axisType)=>axisType;

});

parcelRegister("8VTts", function(module, exports) {

$parcel$export(module.exports, "pickAxisId", () => $680eada126f0aa15$export$6a2efa106dc9c8f6);
var $680eada126f0aa15$export$6a2efa106dc9c8f6 = (_state, _axisType, axisId)=>axisId;

});

parcelRegister("hcIzl", function(module, exports) {

$parcel$export(module.exports, "getStackSeriesIdentifier", () => $c86621286e2c8ba6$export$58b095b87bc46727);
/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ function $c86621286e2c8ba6$export$58b095b87bc46727(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}

});

parcelRegister("599vZ", function(module, exports) {

$parcel$export(module.exports, "combineDisplayedStackedData", () => $3bf52c7ae65ae57f$export$ae6c77e7720cddf9);

var $hcIzl = parcelRequire("hcIzl");

var $hBeJX = parcelRequire("hBeJX");
function $3bf52c7ae65ae57f$export$ae6c77e7720cddf9(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var _ref$chartData = _ref.chartData, chartData = _ref$chartData === void 0 ? [] : _ref$chartData;
    var allowDuplicatedCategory = tooltipAxisSettings.allowDuplicatedCategory, tooltipDataKey = tooltipAxisSettings.dataKey;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, $hcIzl.getStackSeriesIdentifier)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, $hBeJX.getValueByDataKey)(entry, tooltipDataKey, null));
            var numericValue = (0, $hBeJX.getValueByDataKey)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}

});

parcelRegister("9fXTm", function(module, exports) {

$parcel$export(module.exports, "isStacked", () => $6bd3f90b40714619$export$2335dd91cc88053e);
/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ function $6bd3f90b40714619$export$2335dd91cc88053e(graphicalItem) {
    return 'stackId' in graphicalItem && graphicalItem.stackId != null && graphicalItem.dataKey != null;
}

});

parcelRegister("2a4jF", function(module, exports) {

$parcel$export(module.exports, "numberDomainEqualityCheck", () => $192fdd139bcf9f78$export$45c01007b107f1a6);
var $192fdd139bcf9f78$export$45c01007b107f1a6 = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};

});

parcelRegister("ouh0N", function(module, exports) {

$parcel$export(module.exports, "emptyArraysAreEqualCheck", () => $0499b9ab63ed35d4$export$dcc34c4213e7f4c);
$parcel$export(module.exports, "arrayContentsAreEqualCheck", () => $0499b9ab63ed35d4$export$4f42c64323a69d96);
/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ function $0499b9ab63ed35d4$export$dcc34c4213e7f4c(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function $0499b9ab63ed35d4$export$4f42c64323a69d96(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}

});

parcelRegister("4NxAS", function(module, exports) {

$parcel$export(module.exports, "selectTooltipAxisType", () => $37e5cc0fa883575c$export$898d3dfd98fb482);

var $jHn5r = parcelRequire("jHn5r");
var $37e5cc0fa883575c$export$898d3dfd98fb482 = (state)=>{
    var layout = (0, $jHn5r.selectChartLayout)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};

});

parcelRegister("hgR6r", function(module, exports) {

$parcel$export(module.exports, "selectTooltipAxisId", () => $c92d1f706423a70a$export$eeffdb10daff095d);
var $c92d1f706423a70a$export$eeffdb10daff095d = (state)=>state.tooltip.settings.axisId;

});

parcelRegister("eBpK5", function(module, exports) {

$parcel$export(module.exports, "rechartsScaleFactory", () => $aa187d4cf30aa84e$export$5501a52df751e5ca);
/**
 * This is internal representation of scale used in Recharts.
 * Users will provide CustomScaleDefinition or a string, which we will parse into RechartsScale.
 * Most importantly, RechartsScale is fully immutable - there are no setters that mutate the scale in place.
 * This is important for React integration - if the scale changes, we want to trigger re-renders.
 * Mutating the scale in place would not trigger re-renders, leading to stale UI.
 */ /**
 * Position within a band for banded scales.
 * In scales that are not banded, this parameter is ignored.
 *
 * @inline
 */ function $aa187d4cf30aa84e$export$5501a52df751e5ca(d3Scale) {
    if (d3Scale == null) return undefined;
    var ticksFn = d3Scale.ticks;
    var bandwidthFn = d3Scale.bandwidth;
    var d3Range = d3Scale.range();
    var range = [
        Math.min(...d3Range),
        Math.max(...d3Range)
    ];
    return {
        domain: ()=>d3Scale.domain(),
        range: function(_range) {
            function range() {
                return _range.apply(this, arguments);
            }
            range.toString = function() {
                return _range.toString();
            };
            return range;
        }(()=>range),
        rangeMin: ()=>range[0],
        rangeMax: ()=>range[1],
        isInRange (value) {
            var first = range[0];
            var last = range[1];
            return first <= last ? value >= first && value <= last : value >= last && value <= first;
        },
        bandwidth: bandwidthFn ? ()=>bandwidthFn.call(d3Scale) : undefined,
        ticks: ticksFn ? (count)=>ticksFn.call(d3Scale, count) : undefined,
        map: (input, options)=>{
            var baseValue = d3Scale(input);
            if (baseValue == null) return undefined;
            if (d3Scale.bandwidth && options !== null && options !== void 0 && options.position) {
                var bandWidth = d3Scale.bandwidth();
                switch(options.position){
                    case 'middle':
                        baseValue += bandWidth / 2;
                        break;
                    case 'end':
                        baseValue += bandWidth;
                        break;
                    default:
                        break;
                }
            }
            return baseValue;
        }
    };
}

});

parcelRegister("9hA9H", function(module, exports) {

$parcel$export(module.exports, "combineCheckedDomain", () => $6c21bf4d095d2d4f$export$cd6ce636c480934e);

var $agTdp = parcelRequire("agTdp");

var $iMnqX = parcelRequire("iMnqX");
var $6c21bf4d095d2d4f$export$cd6ce636c480934e = (realScaleType, axisDomain)=>{
    if (axisDomain == null) return undefined;
    switch(realScaleType){
        case 'linear':
            /*
         * linear scale only reads the first two numbers in the domain, and ignores everything else.
         * So if it happens that someone somehow gave us a bigger domain,
         * let's pick the min and max from it.
         */ if (!(0, $agTdp.isWellFormedNumberDomain)(axisDomain)) {
                var min, max;
                for(var i = 0; i < axisDomain.length; i++){
                    var value = axisDomain[i];
                    if (!(0, $iMnqX.isWellBehavedNumber)(value)) continue;
                    if (min === undefined || value < min) min = value;
                    if (max === undefined || value > max) max = value;
                }
                if (min !== undefined && max !== undefined) return [
                    min,
                    max
                ];
                return undefined;
            }
            return axisDomain;
        default:
            return axisDomain;
    }
};

});

parcelRegister("l1Iwr", function(module, exports) {

$parcel$export(module.exports, "combineConfiguredScale", () => $f4ec3a2911930a05$export$24f70d56c780d8f0);

var $eHAj8 = parcelRequire("eHAj8");

var $3FiDp = parcelRequire("3FiDp");
function $f4ec3a2911930a05$var$getD3ScaleFromType(realScaleType) {
    var scales = $eHAj8;
    if (realScaleType in scales && typeof scales[realScaleType] === 'function') return scales[realScaleType]();
    var name = "scale".concat((0, $3FiDp.upperFirst)(realScaleType));
    if (name in scales && typeof scales[name] === 'function') return scales[name]();
    return undefined;
}
function $f4ec3a2911930a05$export$b5d21797d2d3275f(scale, axisDomain, axisRange) {
    if (typeof scale === 'function') return scale.copy().domain(axisDomain).range(axisRange);
    if (scale == null) return undefined;
    var d3ScaleFunction = $f4ec3a2911930a05$var$getD3ScaleFromType(scale);
    if (d3ScaleFunction == null) return undefined;
    d3ScaleFunction.domain(axisDomain).range(axisRange);
    return d3ScaleFunction;
}
function $f4ec3a2911930a05$export$24f70d56c780d8f0(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') return $f4ec3a2911930a05$export$b5d21797d2d3275f(axis.scale, axisDomain, axisRange);
    return $f4ec3a2911930a05$export$b5d21797d2d3275f(realScaleType, axisDomain, axisRange);
}

});
parcelRegister("eHAj8", function(module, exports) {
// `victory-vendor/d3-scale` (ESM)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our ESM package uses the underlying installed dependencies of `node_modules/d3-scale`

var $lkHQY = parcelRequire("lkHQY");
$parcel$exportWildcard(module.exports, $lkHQY);

});
parcelRegister("lkHQY", function(module, exports) {

$parcel$export(module.exports, "scaleBand", () => (parcelRequire("gEnYl")).default);
$parcel$export(module.exports, "scalePoint", () => (parcelRequire("gEnYl")).point);
$parcel$export(module.exports, "scaleIdentity", () => (parcelRequire("iYj4F")).default);
$parcel$export(module.exports, "scaleLinear", () => (parcelRequire("iOlPi")).default);
$parcel$export(module.exports, "scaleLog", () => (parcelRequire("7TrsU")).default);
$parcel$export(module.exports, "scaleSymlog", () => (parcelRequire("ht0x4")).default);
$parcel$export(module.exports, "scaleOrdinal", () => (parcelRequire("4PqgM")).default);
$parcel$export(module.exports, "scaleImplicit", () => (parcelRequire("4PqgM")).implicit);
$parcel$export(module.exports, "scalePow", () => (parcelRequire("iFFhE")).default);
$parcel$export(module.exports, "scaleSqrt", () => (parcelRequire("iFFhE")).sqrt);
$parcel$export(module.exports, "scaleRadial", () => (parcelRequire("8DrTh")).default);
$parcel$export(module.exports, "scaleQuantile", () => (parcelRequire("cTbvO")).default);
$parcel$export(module.exports, "scaleQuantize", () => (parcelRequire("ekSyn")).default);
$parcel$export(module.exports, "scaleThreshold", () => (parcelRequire("b1bfu")).default);
$parcel$export(module.exports, "scaleTime", () => (parcelRequire("48U7R")).default);
$parcel$export(module.exports, "scaleUtc", () => (parcelRequire("l1Ebe")).default);
$parcel$export(module.exports, "scaleSequential", () => (parcelRequire("lrv5b")).default);
$parcel$export(module.exports, "scaleSequentialLog", () => (parcelRequire("lrv5b")).sequentialLog);
$parcel$export(module.exports, "scaleSequentialPow", () => (parcelRequire("lrv5b")).sequentialPow);
$parcel$export(module.exports, "scaleSequentialSqrt", () => (parcelRequire("lrv5b")).sequentialSqrt);
$parcel$export(module.exports, "scaleSequentialSymlog", () => (parcelRequire("lrv5b")).sequentialSymlog);
$parcel$export(module.exports, "scaleSequentialQuantile", () => (parcelRequire("77K6z")).default);
$parcel$export(module.exports, "scaleDiverging", () => (parcelRequire("2dSUq")).default);
$parcel$export(module.exports, "scaleDivergingLog", () => (parcelRequire("2dSUq")).divergingLog);
$parcel$export(module.exports, "scaleDivergingPow", () => (parcelRequire("2dSUq")).divergingPow);
$parcel$export(module.exports, "scaleDivergingSqrt", () => (parcelRequire("2dSUq")).divergingSqrt);
$parcel$export(module.exports, "scaleDivergingSymlog", () => (parcelRequire("2dSUq")).divergingSymlog);
$parcel$export(module.exports, "tickFormat", () => (parcelRequire("fabdk")).default);

var $gEnYl = parcelRequire("gEnYl");

var $iYj4F = parcelRequire("iYj4F");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $ht0x4 = parcelRequire("ht0x4");

var $4PqgM = parcelRequire("4PqgM");

var $iFFhE = parcelRequire("iFFhE");

var $8DrTh = parcelRequire("8DrTh");

var $cTbvO = parcelRequire("cTbvO");

var $ekSyn = parcelRequire("ekSyn");

var $b1bfu = parcelRequire("b1bfu");

var $48U7R = parcelRequire("48U7R");

var $l1Ebe = parcelRequire("l1Ebe");

var $lrv5b = parcelRequire("lrv5b");

var $77K6z = parcelRequire("77K6z");

var $2dSUq = parcelRequire("2dSUq");

var $fabdk = parcelRequire("fabdk");

});
parcelRegister("gEnYl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f2fa2a7653ca3a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "point", () => $c1f2fa2a7653ca3a$export$105684a3041cb6f3);

var $8oHIF = parcelRequire("8oHIF");

var $7QzZn = parcelRequire("7QzZn");

var $4PqgM = parcelRequire("4PqgM");
function $c1f2fa2a7653ca3a$export$2e2bcd8739ae039() {
    var scale = (0, $4PqgM.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $8oHIF.default)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $7QzZn.initRange).apply(rescale(), arguments);
}
function $c1f2fa2a7653ca3a$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $c1f2fa2a7653ca3a$var$pointish(copy());
    };
    return scale;
}
function $c1f2fa2a7653ca3a$export$105684a3041cb6f3() {
    return $c1f2fa2a7653ca3a$var$pointish($c1f2fa2a7653ca3a$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("8oHIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d27a61db04c1a6$export$2e2bcd8739ae039);
function $61d27a61db04c1a6$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("7QzZn", function(module, exports) {

$parcel$export(module.exports, "initRange", () => $5b694e64f5326630$export$23c7bb9e6558da2a);
$parcel$export(module.exports, "initInterpolator", () => $5b694e64f5326630$export$7d6b419e59e83f3d);
function $5b694e64f5326630$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $5b694e64f5326630$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("4PqgM", function(module, exports) {

$parcel$export(module.exports, "implicit", () => $38404d762c7ac827$export$e4f898ab14d9d460);
$parcel$export(module.exports, "default", () => $38404d762c7ac827$export$2e2bcd8739ae039);

var $4ePtk = parcelRequire("4ePtk");

var $7QzZn = parcelRequire("7QzZn");
const $38404d762c7ac827$export$e4f898ab14d9d460 = Symbol("implicit");
function $38404d762c7ac827$export$2e2bcd8739ae039() {
    var index = new (0, $4ePtk.InternMap)(), domain = [], range = [], unknown = $38404d762c7ac827$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $38404d762c7ac827$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $4ePtk.InternMap)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $38404d762c7ac827$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("4ePtk", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $3160658555deb5c9$export$dcc6fb7d82b5bc7b);
class $3160658555deb5c9$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($3160658555deb5c9$var$intern_get(this, key));
    }
    has(key) {
        return super.has($3160658555deb5c9$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($3160658555deb5c9$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, key));
    }
}
class $3160658555deb5c9$export$55278c3294239828 extends Set {
    constructor(values, key = $3160658555deb5c9$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($3160658555deb5c9$var$intern_get(this, value));
    }
    add(value) {
        return super.add($3160658555deb5c9$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($3160658555deb5c9$var$intern_delete(this, value));
    }
}
function $3160658555deb5c9$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $3160658555deb5c9$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $3160658555deb5c9$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $3160658555deb5c9$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});



parcelRegister("iYj4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcfca0550ace1fe6$export$2e2bcd8739ae039);

var $iOlPi = parcelRequire("iOlPi");

var $9krIo = parcelRequire("9krIo");
function $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $9krIo.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcfca0550ace1fe6$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $9krIo.default)) : [
        0,
        1
    ];
    return (0, $iOlPi.linearish)(scale);
}

});
parcelRegister("iOlPi", function(module, exports) {

$parcel$export(module.exports, "linearish", () => $db1dd3c66a0cbf94$export$16a5d4b4a61a274d);
$parcel$export(module.exports, "default", () => $db1dd3c66a0cbf94$export$2e2bcd8739ae039);

var $aE6k7 = parcelRequire("aE6k7");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $fabdk = parcelRequire("fabdk");
function $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $aE6k7.default)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $fabdk.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $aE6k7.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $db1dd3c66a0cbf94$export$2e2bcd8739ae039() {
    var scale = (0, $f6dVf.default)();
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $db1dd3c66a0cbf94$export$2e2bcd8739ae039());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return $db1dd3c66a0cbf94$export$16a5d4b4a61a274d(scale);
}

});
parcelRegister("aE6k7", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c028b8201e48c5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "tickIncrement", () => $7c028b8201e48c5a$export$bc64d00cc98e7e95);
$parcel$export(module.exports, "tickStep", () => $7c028b8201e48c5a$export$81087d9b915d4ede);
const $7c028b8201e48c5a$var$e10 = Math.sqrt(50), $7c028b8201e48c5a$var$e5 = Math.sqrt(10), $7c028b8201e48c5a$var$e2 = Math.sqrt(2);
function $7c028b8201e48c5a$var$tickSpec(start, stop, count) {
    const step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= $7c028b8201e48c5a$var$e10 ? 10 : error >= $7c028b8201e48c5a$var$e5 ? 5 : error >= $7c028b8201e48c5a$var$e2 ? 2 : 1;
    let i1, i2, inc;
    if (power < 0) {
        inc = Math.pow(10, -power) / factor;
        i1 = Math.round(start * inc);
        i2 = Math.round(stop * inc);
        if (i1 / inc < start) ++i1;
        if (i2 / inc > stop) --i2;
        inc = -inc;
    } else {
        inc = Math.pow(10, power) * factor;
        i1 = Math.round(start / inc);
        i2 = Math.round(stop / inc);
        if (i1 * inc < start) ++i1;
        if (i2 * inc > stop) --i2;
    }
    if (i2 < i1 && 0.5 <= count && count < 2) return $7c028b8201e48c5a$var$tickSpec(start, stop, count * 2);
    return [
        i1,
        i2,
        inc
    ];
}
function $7c028b8201e48c5a$export$2e2bcd8739ae039(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    if (!(count > 0)) return [];
    if (start === stop) return [
        start
    ];
    const reverse = stop < start, [i1, i2, inc] = reverse ? $7c028b8201e48c5a$var$tickSpec(stop, start, count) : $7c028b8201e48c5a$var$tickSpec(start, stop, count);
    if (!(i2 >= i1)) return [];
    const n = i2 - i1 + 1, ticks = new Array(n);
    if (reverse) {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i2 - i) * inc;
    } else {
        if (inc < 0) for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) / -inc;
        else for(let i = 0; i < n; ++i)ticks[i] = (i1 + i) * inc;
    }
    return ticks;
}
function $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    return $7c028b8201e48c5a$var$tickSpec(start, stop, count)[2];
}
function $7c028b8201e48c5a$export$81087d9b915d4ede(start, stop, count) {
    stop = +stop, start = +start, count = +count;
    const reverse = stop < start, inc = reverse ? $7c028b8201e48c5a$export$bc64d00cc98e7e95(stop, start, count) : $7c028b8201e48c5a$export$bc64d00cc98e7e95(start, stop, count);
    return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}

});

parcelRegister("f6dVf", function(module, exports) {

$parcel$export(module.exports, "identity", () => $afe237385175446a$export$f0954fd7d5368655);
$parcel$export(module.exports, "copy", () => $afe237385175446a$export$784d13d8ee351f07);
$parcel$export(module.exports, "transformer", () => $afe237385175446a$export$6b468dcfb64c653c);
$parcel$export(module.exports, "default", () => $afe237385175446a$export$2e2bcd8739ae039);

var $ekiL6 = parcelRequire("ekiL6");

var $bi4KR = parcelRequire("bi4KR");
var $gnkFs = parcelRequire("gnkFs");
var $gzbhl = parcelRequire("gzbhl");

var $ePWrs = parcelRequire("ePWrs");

var $9krIo = parcelRequire("9krIo");
var $afe237385175446a$var$unit = [
    0,
    1
];
function $afe237385175446a$export$f0954fd7d5368655(x) {
    return x;
}
function $afe237385175446a$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $ePWrs.default)(isNaN(b) ? NaN : 0.5);
}
function $afe237385175446a$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $afe237385175446a$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $afe237385175446a$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $afe237385175446a$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $afe237385175446a$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $afe237385175446a$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $ekiL6.default)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $afe237385175446a$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $afe237385175446a$export$6b468dcfb64c653c() {
    var domain = $afe237385175446a$var$unit, range = $afe237385175446a$var$unit, interpolate = (0, $bi4KR.default), transform, untransform, unknown, clamp = $afe237385175446a$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $afe237385175446a$export$f0954fd7d5368655) clamp = $afe237385175446a$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $afe237385175446a$var$polymap : $afe237385175446a$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $gnkFs.default))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $9krIo.default)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $gzbhl.default), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $afe237385175446a$export$f0954fd7d5368655, rescale()) : clamp !== $afe237385175446a$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $afe237385175446a$export$2e2bcd8739ae039() {
    return $afe237385175446a$export$6b468dcfb64c653c()($afe237385175446a$export$f0954fd7d5368655, $afe237385175446a$export$f0954fd7d5368655);
}

});
parcelRegister("ekiL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6e17c0ec55d7735$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");

var $W4CTv = parcelRequire("W4CTv");

var $7EiNs = parcelRequire("7EiNs");
const $a6e17c0ec55d7735$var$ascendingBisect = (0, $W4CTv.default)((0, $8zdji.default));
const $a6e17c0ec55d7735$export$4d945ad3ad5751b0 = $a6e17c0ec55d7735$var$ascendingBisect.right;
const $a6e17c0ec55d7735$export$df7d25c84ebd12a5 = $a6e17c0ec55d7735$var$ascendingBisect.left;
const $a6e17c0ec55d7735$export$c1cb828b1117c77b = (0, $W4CTv.default)((0, $7EiNs.default)).center;
var $a6e17c0ec55d7735$export$2e2bcd8739ae039 = $a6e17c0ec55d7735$export$4d945ad3ad5751b0;

});
parcelRegister("8zdji", function(module, exports) {

$parcel$export(module.exports, "default", () => $63cbeabc75241824$export$2e2bcd8739ae039);
function $63cbeabc75241824$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("W4CTv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ae9019609d046a1$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");

var $5303J = parcelRequire("5303J");
function $0ae9019609d046a1$export$2e2bcd8739ae039(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = (0, $8zdji.default);
        compare2 = (d, x)=>(0, $8zdji.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === (0, $8zdji.default) || f === (0, $5303J.default) ? f : $0ae9019609d046a1$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $0ae9019609d046a1$var$zero() {
    return 0;
}

});
parcelRegister("5303J", function(module, exports) {

$parcel$export(module.exports, "default", () => $3acd474ceacf8a38$export$2e2bcd8739ae039);
function $3acd474ceacf8a38$export$2e2bcd8739ae039(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("7EiNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $591ad978f2ce6133$export$2e2bcd8739ae039);
$parcel$export(module.exports, "numbers", () => $591ad978f2ce6133$export$1f6c9cc012ebacae);
function $591ad978f2ce6133$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $591ad978f2ce6133$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("bi4KR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8385105b4986daed$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $jUrtA = parcelRequire("jUrtA");

var $34d8K = parcelRequire("34d8K");

var $xcrgO = parcelRequire("xcrgO");

var $gnkFs = parcelRequire("gnkFs");

var $hNADL = parcelRequire("hNADL");

var $aPLyh = parcelRequire("aPLyh");

var $amdqR = parcelRequire("amdqR");

var $aE1fz = parcelRequire("aE1fz");
function $8385105b4986daed$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $amdqR.default)(b) : (t === "number" ? (0, $gnkFs.default) : t === "string" ? (c = (0, $bYoiY.default)(b)) ? (b = c, $jUrtA.default) : (0, $aPLyh.default) : b instanceof (0, $bYoiY.default) ? (0, $jUrtA.default) : b instanceof Date ? (0, $xcrgO.default) : (0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : Array.isArray(b) ? (0, $34d8K.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $hNADL.default) : (0, $gnkFs.default))(a, b);
}

});
parcelRegister("jUrtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e88f7f6ed95eef$export$2e2bcd8739ae039);

var $bYoiY = parcelRequire("bYoiY");

var $j0bQ2 = parcelRequire("j0bQ2");

var $8XYWK = parcelRequire("8XYWK");

var $75Lq4 = parcelRequire("75Lq4");
var $e7e88f7f6ed95eef$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $75Lq4.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $bYoiY.rgb)(start)).r, (end = (0, $bYoiY.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $75Lq4.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $e7e88f7f6ed95eef$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $bYoiY.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $e7e88f7f6ed95eef$export$2c0e28f2e2852d3f = $e7e88f7f6ed95eef$var$rgbSpline((0, $j0bQ2.default));
var $e7e88f7f6ed95eef$export$53d5214f625ccd4c = $e7e88f7f6ed95eef$var$rgbSpline((0, $8XYWK.default));

});
parcelRegister("j0bQ2", function(module, exports) {

$parcel$export(module.exports, "basis", () => $dd5733431a2d0880$export$4e41033bfeec1a4c);
$parcel$export(module.exports, "default", () => $dd5733431a2d0880$export$2e2bcd8739ae039);
function $dd5733431a2d0880$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $dd5733431a2d0880$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $dd5733431a2d0880$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("8XYWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $68731c1c421d9916$export$2e2bcd8739ae039);

var $j0bQ2 = parcelRequire("j0bQ2");
function $68731c1c421d9916$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $j0bQ2.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("75Lq4", function(module, exports) {

$parcel$export(module.exports, "gamma", () => $529dc8928f6a4077$export$a7ebe8cc6aaf8d37);
$parcel$export(module.exports, "default", () => $529dc8928f6a4077$export$2e2bcd8739ae039);

var $amdqR = parcelRequire("amdqR");
function $529dc8928f6a4077$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $529dc8928f6a4077$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $529dc8928f6a4077$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}
function $529dc8928f6a4077$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $529dc8928f6a4077$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $529dc8928f6a4077$var$exponential(a, b, y) : (0, $amdqR.default)(isNaN(a) ? b : a);
    };
}
function $529dc8928f6a4077$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $529dc8928f6a4077$var$linear(a, d) : (0, $amdqR.default)(isNaN(a) ? b : a);
}

});
parcelRegister("amdqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $78a660cd70c52f6f$export$2e2bcd8739ae039);
var $78a660cd70c52f6f$export$2e2bcd8739ae039 = (x)=>()=>x;

});



parcelRegister("34d8K", function(module, exports) {

$parcel$export(module.exports, "genericArray", () => $23bbf03008765dcc$export$15d09067c6a5ee49);

var $bi4KR = parcelRequire("bi4KR");

var $aE1fz = parcelRequire("aE1fz");
function $23bbf03008765dcc$export$2e2bcd8739ae039(a, b) {
    return ((0, $aE1fz.isNumberArray)(b) ? (0, $aE1fz.default) : $23bbf03008765dcc$export$15d09067c6a5ee49)(a, b);
}
function $23bbf03008765dcc$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $bi4KR.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("aE1fz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isNumberArray", () => $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8);
function $7bfe9c15ff8ebf5c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $7bfe9c15ff8ebf5c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("xcrgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $063cbb46f86ba478$export$2e2bcd8739ae039);
function $063cbb46f86ba478$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("gnkFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bebed377ddb9d3af$export$2e2bcd8739ae039);
function $bebed377ddb9d3af$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("hNADL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf536f4647e343d9$export$2e2bcd8739ae039);

var $bi4KR = parcelRequire("bi4KR");
function $cf536f4647e343d9$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $bi4KR.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("aPLyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $020916edd93bff72$export$2e2bcd8739ae039);

var $gnkFs = parcelRequire("gnkFs");
var $020916edd93bff72$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $020916edd93bff72$var$reB = new RegExp($020916edd93bff72$var$reA.source, "g");
function $020916edd93bff72$var$zero(b) {
    return function() {
        return b;
    };
}
function $020916edd93bff72$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $020916edd93bff72$export$2e2bcd8739ae039(a, b) {
    var bi = $020916edd93bff72$var$reA.lastIndex = $020916edd93bff72$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $020916edd93bff72$var$reA.exec(a)) && (bm = $020916edd93bff72$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $gnkFs.default)(am, bm)
            });
        }
        bi = $020916edd93bff72$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $020916edd93bff72$var$one(q[0].x) : $020916edd93bff72$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("gzbhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f8a9efb1caa699$export$2e2bcd8739ae039);
function $c0f8a9efb1caa699$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("ePWrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd329741cbdf381$export$2e2bcd8739ae039);
function $acd329741cbdf381$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9krIo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cab7aea8ef8b40b$export$2e2bcd8739ae039);
function $6cab7aea8ef8b40b$export$2e2bcd8739ae039(x) {
    return +x;
}

});


parcelRegister("fabdk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a07d06c8b316c1$export$2e2bcd8739ae039);

var $aE6k7 = parcelRequire("aE6k7");

var $7gBNf = parcelRequire("7gBNf");
var $ikvwP = parcelRequire("ikvwP");
var $l1vM3 = parcelRequire("l1vM3");
var $1TXup = parcelRequire("1TXup");
var $i4t6x = parcelRequire("i4t6x");
function $b0a07d06c8b316c1$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $aE6k7.tickStep)(start, stop, count), precision;
    specifier = (0, $ikvwP.default)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1TXup.default)(step, value))) specifier.precision = precision;
            return (0, $7gBNf.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $i4t6x.default)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $l1vM3.default)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7gBNf.format)(specifier);
}

});
parcelRegister("7gBNf", function(module, exports) {

$parcel$export(module.exports, "format", () => $54a757fa53542946$export$d9468344d3651243);
$parcel$export(module.exports, "formatPrefix", () => $54a757fa53542946$export$8d85692a469dde6f);

var $jYBVj = parcelRequire("jYBVj");
var $54a757fa53542946$var$locale;
var $54a757fa53542946$export$d9468344d3651243;
var $54a757fa53542946$export$8d85692a469dde6f;
$54a757fa53542946$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $54a757fa53542946$export$2e2bcd8739ae039(definition) {
    $54a757fa53542946$var$locale = (0, $jYBVj.default)(definition);
    $54a757fa53542946$export$d9468344d3651243 = $54a757fa53542946$var$locale.format;
    $54a757fa53542946$export$8d85692a469dde6f = $54a757fa53542946$var$locale.formatPrefix;
    return $54a757fa53542946$var$locale;
}

});
parcelRegister("jYBVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8b109bb95cf9845$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");

var $l0OJc = parcelRequire("l0OJc");

var $cRZ1i = parcelRequire("cRZ1i");

var $ikvwP = parcelRequire("ikvwP");

var $j0yhO = parcelRequire("j0yhO");

var $kGAxb = parcelRequire("kGAxb");

var $lPyuV = parcelRequire("lPyuV");

var $2nOSB = parcelRequire("2nOSB");
var $e8b109bb95cf9845$var$map = Array.prototype.map, $e8b109bb95cf9845$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $e8b109bb95cf9845$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $2nOSB.default) : (0, $l0OJc.default)($e8b109bb95cf9845$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $2nOSB.default) : (0, $cRZ1i.default)($e8b109bb95cf9845$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $ikvwP.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $kGAxb.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $kGAxb.default)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $j0yhO.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $e8b109bb95cf9845$var$prefixes[8 + (0, $lPyuV.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $ikvwP.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $e8b109bb95cf9845$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("1QDsO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1589426e0436f502$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $1589426e0436f502$export$2e2bcd8739ae039(x) {
    return x = (0, $1fLhe.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("1fLhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "formatDecimalParts", () => $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5);
function $0e9bdd5fefd6a5f6$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0e9bdd5fefd6a5f6$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("l0OJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c0f29ad920aaa1$export$2e2bcd8739ae039);
function $f4c0f29ad920aaa1$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("cRZ1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e9c493347f9308$export$2e2bcd8739ae039);
function $95e9c493347f9308$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("ikvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5828d241e6c1f75$export$2e2bcd8739ae039);
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d5828d241e6c1f75$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d5828d241e6c1f75$export$2e2bcd8739ae039(specifier) {
    if (!(match = $d5828d241e6c1f75$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d5828d241e6c1f75$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d5828d241e6c1f75$export$2e2bcd8739ae039.prototype = $d5828d241e6c1f75$export$963aac351db36ed4.prototype; // instanceof
function $d5828d241e6c1f75$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d5828d241e6c1f75$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("j0yhO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd689cef4c920567$export$2e2bcd8739ae039);
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $dd689cef4c920567$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("kGAxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e2e7837f70dba5$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");

var $lPyuV = parcelRequire("lPyuV");

var $5YhaN = parcelRequire("5YhaN");
var $03e2e7837f70dba5$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $1fLhe.default),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $5YhaN.default)(x * 100, p),
    "r": (0, $5YhaN.default),
    "s": (0, $lPyuV.default),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

});
parcelRegister("lPyuV", function(module, exports) {

$parcel$export(module.exports, "prefixExponent", () => $fe491ef31c379765$export$6863724d9a42263);
$parcel$export(module.exports, "default", () => $fe491ef31c379765$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
var $fe491ef31c379765$export$6863724d9a42263;
function $fe491ef31c379765$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($fe491ef31c379765$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $1fLhe.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("5YhaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $458fe095863893c0$export$2e2bcd8739ae039);

var $1fLhe = parcelRequire("1fLhe");
function $458fe095863893c0$export$2e2bcd8739ae039(x, p) {
    var d = (0, $1fLhe.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("2nOSB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bc532601db445af$export$2e2bcd8739ae039);
function $1bc532601db445af$export$2e2bcd8739ae039(x) {
    return x;
}

});



parcelRegister("l1vM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e256a3cb9c44da$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $f4e256a3cb9c44da$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("1TXup", function(module, exports) {

$parcel$export(module.exports, "default", () => $162912dc121d0934$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $162912dc121d0934$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1QDsO.default)(value) / 3))) * 3 - (0, $1QDsO.default)(Math.abs(step)));
}

});

parcelRegister("i4t6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27f2d3c2137f747$export$2e2bcd8739ae039);

var $1QDsO = parcelRequire("1QDsO");
function $d27f2d3c2137f747$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1QDsO.default)(max) - (0, $1QDsO.default)(step)) + 1;
}

});




parcelRegister("7TrsU", function(module, exports) {

$parcel$export(module.exports, "loggish", () => $5bf2f979a0299157$export$860836db074028f0);
$parcel$export(module.exports, "default", () => $5bf2f979a0299157$export$2e2bcd8739ae039);

var $aE6k7 = parcelRequire("aE6k7");

var $7gBNf = parcelRequire("7gBNf");
var $ikvwP = parcelRequire("ikvwP");

var $13gv1 = parcelRequire("13gv1");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $5bf2f979a0299157$var$transformLog(x) {
    return Math.log(x);
}
function $5bf2f979a0299157$var$transformExp(x) {
    return Math.exp(x);
}
function $5bf2f979a0299157$var$transformLogn(x) {
    return -Math.log(-x);
}
function $5bf2f979a0299157$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $5bf2f979a0299157$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $5bf2f979a0299157$var$powp(base) {
    return base === 10 ? $5bf2f979a0299157$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $5bf2f979a0299157$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $5bf2f979a0299157$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $5bf2f979a0299157$export$860836db074028f0(transform) {
    const scale = transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $5bf2f979a0299157$var$logp(base), pows = $5bf2f979a0299157$var$powp(base);
        if (domain()[0] < 0) {
            logs = $5bf2f979a0299157$var$reflect(logs), pows = $5bf2f979a0299157$var$reflect(pows);
            transform($5bf2f979a0299157$var$transformLogn, $5bf2f979a0299157$var$transformExpn);
        } else transform($5bf2f979a0299157$var$transformLog, $5bf2f979a0299157$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $aE6k7.default)(u, v, n);
        } else z = (0, $aE6k7.default)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $ikvwP.default)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $7gBNf.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $13gv1.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $5bf2f979a0299157$export$2e2bcd8739ae039() {
    const scale = $5bf2f979a0299157$export$860836db074028f0((0, $f6dVf.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $f6dVf.copy)(scale, $5bf2f979a0299157$export$2e2bcd8739ae039()).base(scale.base());
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}

});
parcelRegister("13gv1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c42deabcdb569d9$export$2e2bcd8739ae039);
function $0c42deabcdb569d9$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("ht0x4", function(module, exports) {

$parcel$export(module.exports, "symlogish", () => $cb758ed0dff37844$export$4602684e614eba38);
$parcel$export(module.exports, "default", () => $cb758ed0dff37844$export$2e2bcd8739ae039);

var $iOlPi = parcelRequire("iOlPi");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $cb758ed0dff37844$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $cb758ed0dff37844$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $cb758ed0dff37844$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($cb758ed0dff37844$var$transformSymlog(c), $cb758ed0dff37844$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($cb758ed0dff37844$var$transformSymlog(c = +_), $cb758ed0dff37844$var$transformSymexp(c)) : c;
    };
    return (0, $iOlPi.linearish)(scale);
}
function $cb758ed0dff37844$export$2e2bcd8739ae039() {
    var scale = $cb758ed0dff37844$export$4602684e614eba38((0, $f6dVf.transformer)());
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $cb758ed0dff37844$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});

parcelRegister("iFFhE", function(module, exports) {

$parcel$export(module.exports, "powish", () => $d97c146f4f811488$export$34695211ec403a46);
$parcel$export(module.exports, "default", () => $d97c146f4f811488$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sqrt", () => $d97c146f4f811488$export$eba8049fb5020b81);

var $iOlPi = parcelRequire("iOlPi");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $d97c146f4f811488$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $d97c146f4f811488$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $d97c146f4f811488$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $d97c146f4f811488$export$34695211ec403a46(transform) {
    var scale = transform((0, $f6dVf.identity), (0, $f6dVf.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $f6dVf.identity), (0, $f6dVf.identity)) : exponent === 0.5 ? transform($d97c146f4f811488$var$transformSqrt, $d97c146f4f811488$var$transformSquare) : transform($d97c146f4f811488$var$transformPow(exponent), $d97c146f4f811488$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $iOlPi.linearish)(scale);
}
function $d97c146f4f811488$export$2e2bcd8739ae039() {
    var scale = $d97c146f4f811488$export$34695211ec403a46((0, $f6dVf.transformer)());
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $d97c146f4f811488$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return scale;
}
function $d97c146f4f811488$export$eba8049fb5020b81() {
    return $d97c146f4f811488$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("8DrTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $649799b8497b3636$export$2e2bcd8739ae039);

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $iOlPi = parcelRequire("iOlPi");

var $9krIo = parcelRequire("9krIo");
function $649799b8497b3636$var$square(x) {
    return Math.sign(x) * x * x;
}
function $649799b8497b3636$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $649799b8497b3636$export$2e2bcd8739ae039() {
    var squared = (0, $f6dVf.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $649799b8497b3636$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($649799b8497b3636$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $9krIo.default))).map($649799b8497b3636$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $649799b8497b3636$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $7QzZn.initRange).apply(scale, arguments);
    return (0, $iOlPi.linearish)(scale);
}

});

parcelRegister("cTbvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $96238d247b54f1ee$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");
var $ekiL6 = parcelRequire("ekiL6");
var $30TGf = parcelRequire("30TGf");

var $7QzZn = parcelRequire("7QzZn");
function $96238d247b54f1ee$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $30TGf.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $ekiL6.default)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8zdji.default));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $96238d247b54f1ee$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});
parcelRegister("30TGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $231c9024a6754413$export$2e2bcd8739ae039);
$parcel$export(module.exports, "quantileSorted", () => $231c9024a6754413$export$f924a6cad778dddb);

var $7MbYq = parcelRequire("7MbYq");

var $5e5SY = parcelRequire("5e5SY");

var $fzQB8 = parcelRequire("fzQB8");

var $9H4TW = parcelRequire("9H4TW");

var $8M5Om = parcelRequire("8M5Om");

var $7EiNs = parcelRequire("7EiNs");

var $5iL7S = parcelRequire("5iL7S");

var $ll76u = parcelRequire("ll76u");
function $231c9024a6754413$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $7EiNs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $fzQB8.default)(values);
    if (p >= 1) return (0, $7MbYq.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $7MbYq.default)((0, $8M5Om.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $fzQB8.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f924a6cad778dddb(values, p, valueof = (0, $7EiNs.default)) {
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}
function $231c9024a6754413$export$f1fcc854ecc6ce55(values, p, valueof) {
    values = Float64Array.from((0, $7EiNs.numbers)(values, valueof));
    if (!(n = values.length) || isNaN(p = +p)) return;
    if (p <= 0 || n < 2) return (0, $9H4TW.default)(values);
    if (p >= 1) return (0, $5e5SY.default)(values);
    var n, i = Math.floor((n - 1) * p), order = (i, j)=>(0, $5iL7S.ascendingDefined)(values[i], values[j]), index = (0, $8M5Om.default)(Uint32Array.from(values, (_, i)=>i), i, 0, n - 1, order);
    return (0, $ll76u.default)(index.subarray(0, i + 1), (i)=>values[i]);
}

});
parcelRegister("7MbYq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a964dca3df4eea7$export$2e2bcd8739ae039);
function $5a964dca3df4eea7$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5e5SY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ce2d353ce06f740$export$2e2bcd8739ae039);
function $3ce2d353ce06f740$export$2e2bcd8739ae039(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("fzQB8", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ed355deaa9e190$export$2e2bcd8739ae039);
function $02ed355deaa9e190$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("9H4TW", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ebee7adc32f27f$export$2e2bcd8739ae039);
function $70ebee7adc32f27f$export$2e2bcd8739ae039(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("8M5Om", function(module, exports) {

$parcel$export(module.exports, "default", () => $6637506e64922c38$export$2e2bcd8739ae039);

var $5iL7S = parcelRequire("5iL7S");
function $6637506e64922c38$export$2e2bcd8739ae039(array, k, left = 0, right = Infinity, compare) {
    k = Math.floor(k);
    left = Math.floor(Math.max(0, left));
    right = Math.floor(Math.min(array.length - 1, right));
    if (!(left <= k && k <= right)) return array;
    compare = compare === undefined ? (0, $5iL7S.ascendingDefined) : (0, $5iL7S.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $6637506e64922c38$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $6637506e64922c38$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $6637506e64922c38$var$swap(array, left, right);
        while(i < j){
            $6637506e64922c38$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $6637506e64922c38$var$swap(array, left, j);
        else ++j, $6637506e64922c38$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $6637506e64922c38$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});
parcelRegister("5iL7S", function(module, exports) {

$parcel$export(module.exports, "ascendingDefined", () => $3dc3306e587e145d$export$686e14b8469efec4);
$parcel$export(module.exports, "compareDefined", () => $3dc3306e587e145d$export$5708b2c031939e56);

var $8zdji = parcelRequire("8zdji");

var $a3ID3 = parcelRequire("a3ID3");
function $3dc3306e587e145d$export$2e2bcd8739ae039(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$3dc3306e587e145d$export$686e14b8469efec4(f[i], f[j]));
        }
        return (0, $a3ID3.default)(values, index);
    }
    return values.sort($3dc3306e587e145d$export$5708b2c031939e56(f));
}
function $3dc3306e587e145d$export$5708b2c031939e56(compare = (0, $8zdji.default)) {
    if (compare === (0, $8zdji.default)) return $3dc3306e587e145d$export$686e14b8469efec4;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $3dc3306e587e145d$export$686e14b8469efec4(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("a3ID3", function(module, exports) {

$parcel$export(module.exports, "default", () => $752ccd95a674b233$export$2e2bcd8739ae039);
function $752ccd95a674b233$export$2e2bcd8739ae039(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("ll76u", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89111cbb3c9d70b$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");
function $f89111cbb3c9d70b$export$2e2bcd8739ae039(values, compare = (0, $8zdji.default)) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $8zdji.default)(value, maxValue) > 0 : (0, $8zdji.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});



parcelRegister("ekSyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6fd4026648153e5$export$2e2bcd8739ae039);

var $ekiL6 = parcelRequire("ekiL6");

var $iOlPi = parcelRequire("iOlPi");

var $7QzZn = parcelRequire("7QzZn");
function $a6fd4026648153e5$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $ekiL6.default)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $a6fd4026648153e5$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply((0, $iOlPi.linearish)(scale), arguments);
}

});

parcelRegister("b1bfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8058838348a44fed$export$2e2bcd8739ae039);

var $ekiL6 = parcelRequire("ekiL6");

var $7QzZn = parcelRequire("7QzZn");
function $8058838348a44fed$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $ekiL6.default)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $8058838348a44fed$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $7QzZn.initRange).apply(scale, arguments);
}

});

parcelRegister("48U7R", function(module, exports) {

$parcel$export(module.exports, "calendar", () => $304372357472b2a4$export$56bbcdb8aca31149);
$parcel$export(module.exports, "default", () => $304372357472b2a4$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $cKbL9 = parcelRequire("cKbL9");
var $3wXBo = parcelRequire("3wXBo");
var $gyimR = parcelRequire("gyimR");
var $6gR0W = parcelRequire("6gR0W");
var $nRuo6 = parcelRequire("nRuo6");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");

var $UutV9 = parcelRequire("UutV9");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $13gv1 = parcelRequire("13gv1");
function $304372357472b2a4$var$date(t) {
    return new Date(t);
}
function $304372357472b2a4$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $f6dVf.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $304372357472b2a4$var$number)) : domain().map($304372357472b2a4$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $13gv1.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $f6dVf.copy)(scale, $304372357472b2a4$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $304372357472b2a4$export$2e2bcd8739ae039() {
    return (0, $7QzZn.initRange).apply($304372357472b2a4$export$56bbcdb8aca31149((0, $nRuo6.timeTicks), (0, $nRuo6.timeTickInterval), (0, $j0Fj9.timeYear), (0, $gyimR.timeMonth), (0, $aW15j.timeSunday), (0, $72rFk.timeDay), (0, $cKbL9.timeHour), (0, $3wXBo.timeMinute), (0, $6gR0W.second), (0, $UutV9.timeFormat)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("72rFk", function(module, exports) {

$parcel$export(module.exports, "timeDay", () => $51fe2e20810fcb40$export$8888529b966033e5);
$parcel$export(module.exports, "utcDay", () => $51fe2e20810fcb40$export$c8cbc42cefd47140);
$parcel$export(module.exports, "unixDay", () => $51fe2e20810fcb40$export$fb065be2d7ea4a71);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $51fe2e20810fcb40$export$8888529b966033e5 = (0, $kOu3f.timeInterval)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationDay), (date)=>date.getDate() - 1);
const $51fe2e20810fcb40$export$6657a54f3034cf45 = $51fe2e20810fcb40$export$8888529b966033e5.range;
const $51fe2e20810fcb40$export$c8cbc42cefd47140 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationDay);
}, (date)=>{
    return date.getUTCDate() - 1;
});
const $51fe2e20810fcb40$export$d277e198508549a1 = $51fe2e20810fcb40$export$c8cbc42cefd47140.range;
const $51fe2e20810fcb40$export$fb065be2d7ea4a71 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCDate(date.getUTCDate() + step);
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationDay);
}, (date)=>{
    return Math.floor(date / (0, $dXf4A.durationDay));
});
const $51fe2e20810fcb40$export$a491caaf5e9481aa = $51fe2e20810fcb40$export$fb065be2d7ea4a71.range;

});
parcelRegister("kOu3f", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => $f26fc9b6912de968$export$1a539c8b2950ab40);
const $f26fc9b6912de968$var$t0 = new Date, $f26fc9b6912de968$var$t1 = new Date;
function $f26fc9b6912de968$export$1a539c8b2950ab40(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = (date)=>{
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = (date)=>{
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = (date)=>{
        const d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = (date, step)=>{
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = (start, stop, step)=>{
        const range = [];
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        let previous;
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = (test)=>{
        return $f26fc9b6912de968$export$1a539c8b2950ab40((date)=>{
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, (date, step)=>{
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = (start, end)=>{
            $f26fc9b6912de968$var$t0.setTime(+start), $f26fc9b6912de968$var$t1.setTime(+end);
            floori($f26fc9b6912de968$var$t0), floori($f26fc9b6912de968$var$t1);
            return Math.floor(count($f26fc9b6912de968$var$t0, $f26fc9b6912de968$var$t1));
        };
        interval.every = (step)=>{
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? (d)=>field(d) % step === 0 : (d)=>interval.count(0, d) % step === 0);
        };
    }
    return interval;
}

});

parcelRegister("dXf4A", function(module, exports) {

$parcel$export(module.exports, "durationSecond", () => $a28c7a35eadfe1f6$export$79ef0e34099623dc);
$parcel$export(module.exports, "durationMinute", () => $a28c7a35eadfe1f6$export$683905d551c33fa9);
$parcel$export(module.exports, "durationHour", () => $a28c7a35eadfe1f6$export$4157bf0c8e241659);
$parcel$export(module.exports, "durationDay", () => $a28c7a35eadfe1f6$export$353686095f4fbf45);
$parcel$export(module.exports, "durationWeek", () => $a28c7a35eadfe1f6$export$c241eb88520d5016);
$parcel$export(module.exports, "durationMonth", () => $a28c7a35eadfe1f6$export$ab95684df7020b26);
$parcel$export(module.exports, "durationYear", () => $a28c7a35eadfe1f6$export$61f8ee2d834c6959);
const $a28c7a35eadfe1f6$export$79ef0e34099623dc = 1000;
const $a28c7a35eadfe1f6$export$683905d551c33fa9 = $a28c7a35eadfe1f6$export$79ef0e34099623dc * 60;
const $a28c7a35eadfe1f6$export$4157bf0c8e241659 = $a28c7a35eadfe1f6$export$683905d551c33fa9 * 60;
const $a28c7a35eadfe1f6$export$353686095f4fbf45 = $a28c7a35eadfe1f6$export$4157bf0c8e241659 * 24;
const $a28c7a35eadfe1f6$export$c241eb88520d5016 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 7;
const $a28c7a35eadfe1f6$export$ab95684df7020b26 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 30;
const $a28c7a35eadfe1f6$export$61f8ee2d834c6959 = $a28c7a35eadfe1f6$export$353686095f4fbf45 * 365;

});


parcelRegister("cKbL9", function(module, exports) {

$parcel$export(module.exports, "timeHour", () => $9472e71f07850dab$export$46c68a5833bc315b);
$parcel$export(module.exports, "utcHour", () => $9472e71f07850dab$export$31f6f2b3c63ac75e);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $9472e71f07850dab$export$46c68a5833bc315b = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond) - date.getMinutes() * (0, $dXf4A.durationMinute));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationHour);
}, (date)=>{
    return date.getHours();
});
const $9472e71f07850dab$export$fb843f9087cd5235 = $9472e71f07850dab$export$46c68a5833bc315b.range;
const $9472e71f07850dab$export$31f6f2b3c63ac75e = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCMinutes(0, 0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationHour));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationHour);
}, (date)=>{
    return date.getUTCHours();
});
const $9472e71f07850dab$export$6e7a76cd5f50b719 = $9472e71f07850dab$export$31f6f2b3c63ac75e.range;

});

parcelRegister("3wXBo", function(module, exports) {

$parcel$export(module.exports, "timeMinute", () => $292297f992a3b17e$export$a7e4c34a52f0576);
$parcel$export(module.exports, "utcMinute", () => $292297f992a3b17e$export$efe6712d6003761b);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $292297f992a3b17e$export$a7e4c34a52f0576 = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $dXf4A.durationSecond));
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationMinute);
}, (date)=>{
    return date.getMinutes();
});
const $292297f992a3b17e$export$186d65358374c0a2 = $292297f992a3b17e$export$a7e4c34a52f0576.range;
const $292297f992a3b17e$export$efe6712d6003761b = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCSeconds(0, 0);
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationMinute));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationMinute);
}, (date)=>{
    return date.getUTCMinutes();
});
const $292297f992a3b17e$export$cedd563624e8ee50 = $292297f992a3b17e$export$efe6712d6003761b.range;

});

parcelRegister("gyimR", function(module, exports) {

$parcel$export(module.exports, "timeMonth", () => $031c190f93ea3efa$export$7e1084fb688591c1);
$parcel$export(module.exports, "utcMonth", () => $031c190f93ea3efa$export$cd49b3d2bcfe50d5);

var $kOu3f = parcelRequire("kOu3f");
const $031c190f93ea3efa$export$7e1084fb688591c1 = (0, $kOu3f.timeInterval)((date)=>{
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setMonth(date.getMonth() + step);
}, (start, end)=>{
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, (date)=>{
    return date.getMonth();
});
const $031c190f93ea3efa$export$3e24aa839cd0f1c4 = $031c190f93ea3efa$export$7e1084fb688591c1.range;
const $031c190f93ea3efa$export$cd49b3d2bcfe50d5 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCMonth(date.getUTCMonth() + step);
}, (start, end)=>{
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, (date)=>{
    return date.getUTCMonth();
});
const $031c190f93ea3efa$export$49159f585997498 = $031c190f93ea3efa$export$cd49b3d2bcfe50d5.range;

});

parcelRegister("6gR0W", function(module, exports) {

$parcel$export(module.exports, "second", () => $490d5c36270b8fcb$export$3d3c77ce7df7d30d);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
const $490d5c36270b8fcb$export$3d3c77ce7df7d30d = (0, $kOu3f.timeInterval)((date)=>{
    date.setTime(date - date.getMilliseconds());
}, (date, step)=>{
    date.setTime(+date + step * (0, $dXf4A.durationSecond));
}, (start, end)=>{
    return (end - start) / (0, $dXf4A.durationSecond);
}, (date)=>{
    return date.getUTCSeconds();
});
const $490d5c36270b8fcb$export$4792e48abc550fa1 = $490d5c36270b8fcb$export$3d3c77ce7df7d30d.range;

});

parcelRegister("nRuo6", function(module, exports) {

$parcel$export(module.exports, "utcTicks", () => $047ba3ec3f41562e$export$826ba5ae907e9767);
$parcel$export(module.exports, "utcTickInterval", () => $047ba3ec3f41562e$export$6262d8d056ea44c4);
$parcel$export(module.exports, "timeTicks", () => $047ba3ec3f41562e$export$60c76498552d28a6);
$parcel$export(module.exports, "timeTickInterval", () => $047ba3ec3f41562e$export$69511150134dd174);

var $W4CTv = parcelRequire("W4CTv");
var $aE6k7 = parcelRequire("aE6k7");

var $dXf4A = parcelRequire("dXf4A");

var $asZKP = parcelRequire("asZKP");

var $6gR0W = parcelRequire("6gR0W");

var $3wXBo = parcelRequire("3wXBo");

var $cKbL9 = parcelRequire("cKbL9");

var $72rFk = parcelRequire("72rFk");

var $aW15j = parcelRequire("aW15j");

var $gyimR = parcelRequire("gyimR");

var $j0Fj9 = parcelRequire("j0Fj9");
function $047ba3ec3f41562e$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $6gR0W.second),
            1,
            (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            5,
            5 * (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            15,
            15 * (0, $dXf4A.durationSecond)
        ],
        [
            (0, $6gR0W.second),
            30,
            30 * (0, $dXf4A.durationSecond)
        ],
        [
            minute,
            1,
            (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            5,
            5 * (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            15,
            15 * (0, $dXf4A.durationMinute)
        ],
        [
            minute,
            30,
            30 * (0, $dXf4A.durationMinute)
        ],
        [
            hour,
            1,
            (0, $dXf4A.durationHour)
        ],
        [
            hour,
            3,
            3 * (0, $dXf4A.durationHour)
        ],
        [
            hour,
            6,
            6 * (0, $dXf4A.durationHour)
        ],
        [
            hour,
            12,
            12 * (0, $dXf4A.durationHour)
        ],
        [
            day,
            1,
            (0, $dXf4A.durationDay)
        ],
        [
            day,
            2,
            2 * (0, $dXf4A.durationDay)
        ],
        [
            week,
            1,
            (0, $dXf4A.durationWeek)
        ],
        [
            month,
            1,
            (0, $dXf4A.durationMonth)
        ],
        [
            month,
            3,
            3 * (0, $dXf4A.durationMonth)
        ],
        [
            year,
            1,
            (0, $dXf4A.durationYear)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $W4CTv.default)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $aE6k7.tickStep)(start / (0, $dXf4A.durationYear), stop / (0, $dXf4A.durationYear), count));
        if (i === 0) return (0, $asZKP.millisecond).every(Math.max((0, $aE6k7.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$047ba3ec3f41562e$export$826ba5ae907e9767, $047ba3ec3f41562e$export$6262d8d056ea44c4] = $047ba3ec3f41562e$var$ticker((0, $j0Fj9.utcYear), (0, $gyimR.utcMonth), (0, $aW15j.utcSunday), (0, $72rFk.unixDay), (0, $cKbL9.utcHour), (0, $3wXBo.utcMinute));
const [$047ba3ec3f41562e$export$60c76498552d28a6, $047ba3ec3f41562e$export$69511150134dd174] = $047ba3ec3f41562e$var$ticker((0, $j0Fj9.timeYear), (0, $gyimR.timeMonth), (0, $aW15j.timeSunday), (0, $72rFk.timeDay), (0, $cKbL9.timeHour), (0, $3wXBo.timeMinute));

});
parcelRegister("asZKP", function(module, exports) {

$parcel$export(module.exports, "millisecond", () => $79ec6c01997bf022$export$edc5e5cb87280477);

var $kOu3f = parcelRequire("kOu3f");
const $79ec6c01997bf022$export$edc5e5cb87280477 = (0, $kOu3f.timeInterval)(()=>{
// noop
}, (date, step)=>{
    date.setTime(+date + step);
}, (start, end)=>{
    return end - start;
});
// An optimized implementation for this simple case.
$79ec6c01997bf022$export$edc5e5cb87280477.every = (k)=>{
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $79ec6c01997bf022$export$edc5e5cb87280477;
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setTime(Math.floor(date / k) * k);
    }, (date, step)=>{
        date.setTime(+date + step * k);
    }, (start, end)=>{
        return (end - start) / k;
    });
};
const $79ec6c01997bf022$export$9a27fac83d67afd3 = $79ec6c01997bf022$export$edc5e5cb87280477.range;

});

parcelRegister("aW15j", function(module, exports) {

$parcel$export(module.exports, "timeSunday", () => $7f6029921eecd017$export$22ee6205b762968c);
$parcel$export(module.exports, "timeMonday", () => $7f6029921eecd017$export$e79bbe0177cf1b01);
$parcel$export(module.exports, "timeThursday", () => $7f6029921eecd017$export$608689422d5cf9f4);
$parcel$export(module.exports, "utcSunday", () => $7f6029921eecd017$export$4898b06303a92011);
$parcel$export(module.exports, "utcMonday", () => $7f6029921eecd017$export$9cfc53b9cfafd080);
$parcel$export(module.exports, "utcThursday", () => $7f6029921eecd017$export$1db08111baec2f53);

var $kOu3f = parcelRequire("kOu3f");

var $dXf4A = parcelRequire("dXf4A");
function $7f6029921eecd017$var$timeWeekday(i) {
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setDate(date.getDate() + step * 7);
    }, (start, end)=>{
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $dXf4A.durationMinute)) / (0, $dXf4A.durationWeek);
    });
}
const $7f6029921eecd017$export$22ee6205b762968c = $7f6029921eecd017$var$timeWeekday(0);
const $7f6029921eecd017$export$e79bbe0177cf1b01 = $7f6029921eecd017$var$timeWeekday(1);
const $7f6029921eecd017$export$57c0658c29f77708 = $7f6029921eecd017$var$timeWeekday(2);
const $7f6029921eecd017$export$3fbeef226c256e43 = $7f6029921eecd017$var$timeWeekday(3);
const $7f6029921eecd017$export$608689422d5cf9f4 = $7f6029921eecd017$var$timeWeekday(4);
const $7f6029921eecd017$export$548e5227aa183dca = $7f6029921eecd017$var$timeWeekday(5);
const $7f6029921eecd017$export$c56a3ad248908e19 = $7f6029921eecd017$var$timeWeekday(6);
const $7f6029921eecd017$export$eac514c8a8674eba = $7f6029921eecd017$export$22ee6205b762968c.range;
const $7f6029921eecd017$export$f7219b1481948356 = $7f6029921eecd017$export$e79bbe0177cf1b01.range;
const $7f6029921eecd017$export$77e22b12c5bed05b = $7f6029921eecd017$export$57c0658c29f77708.range;
const $7f6029921eecd017$export$b85d407a471809e8 = $7f6029921eecd017$export$3fbeef226c256e43.range;
const $7f6029921eecd017$export$c1bc1c49254c8855 = $7f6029921eecd017$export$608689422d5cf9f4.range;
const $7f6029921eecd017$export$3691a1557fff46f1 = $7f6029921eecd017$export$548e5227aa183dca.range;
const $7f6029921eecd017$export$b755452d02cba8d2 = $7f6029921eecd017$export$c56a3ad248908e19.range;
function $7f6029921eecd017$var$utcWeekday(i) {
    return (0, $kOu3f.timeInterval)((date)=>{
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, (start, end)=>{
        return (end - start) / (0, $dXf4A.durationWeek);
    });
}
const $7f6029921eecd017$export$4898b06303a92011 = $7f6029921eecd017$var$utcWeekday(0);
const $7f6029921eecd017$export$9cfc53b9cfafd080 = $7f6029921eecd017$var$utcWeekday(1);
const $7f6029921eecd017$export$2a6d545f77eceb15 = $7f6029921eecd017$var$utcWeekday(2);
const $7f6029921eecd017$export$a5c25d8ed64433c4 = $7f6029921eecd017$var$utcWeekday(3);
const $7f6029921eecd017$export$1db08111baec2f53 = $7f6029921eecd017$var$utcWeekday(4);
const $7f6029921eecd017$export$29265e34dd5921f7 = $7f6029921eecd017$var$utcWeekday(5);
const $7f6029921eecd017$export$85b74dad05049604 = $7f6029921eecd017$var$utcWeekday(6);
const $7f6029921eecd017$export$6f3e1c2b0f7d7880 = $7f6029921eecd017$export$4898b06303a92011.range;
const $7f6029921eecd017$export$1d2d8b858bb366f9 = $7f6029921eecd017$export$9cfc53b9cfafd080.range;
const $7f6029921eecd017$export$1d5f6785fc7f30f8 = $7f6029921eecd017$export$2a6d545f77eceb15.range;
const $7f6029921eecd017$export$7a75faf0e37ef4af = $7f6029921eecd017$export$a5c25d8ed64433c4.range;
const $7f6029921eecd017$export$417eb959611b2f2f = $7f6029921eecd017$export$1db08111baec2f53.range;
const $7f6029921eecd017$export$59d308db7af08c64 = $7f6029921eecd017$export$29265e34dd5921f7.range;
const $7f6029921eecd017$export$a124108a0a7f34c8 = $7f6029921eecd017$export$85b74dad05049604.range;

});

parcelRegister("j0Fj9", function(module, exports) {

$parcel$export(module.exports, "timeYear", () => $dd6e0f506bfbbd03$export$cd17cfe45df0c046);
$parcel$export(module.exports, "utcYear", () => $dd6e0f506bfbbd03$export$d5c3802e389714c4);

var $kOu3f = parcelRequire("kOu3f");
const $dd6e0f506bfbbd03$export$cd17cfe45df0c046 = (0, $kOu3f.timeInterval)((date)=>{
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setFullYear(date.getFullYear() + step);
}, (start, end)=>{
    return end.getFullYear() - start.getFullYear();
}, (date)=>{
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$cd17cfe45df0c046.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.timeInterval)((date)=>{
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setFullYear(date.getFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$69a4e90dd2cc3bd1 = $dd6e0f506bfbbd03$export$cd17cfe45df0c046.range;
const $dd6e0f506bfbbd03$export$d5c3802e389714c4 = (0, $kOu3f.timeInterval)((date)=>{
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, (date, step)=>{
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, (start, end)=>{
    return end.getUTCFullYear() - start.getUTCFullYear();
}, (date)=>{
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$dd6e0f506bfbbd03$export$d5c3802e389714c4.every = (k)=>{
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $kOu3f.timeInterval)((date)=>{
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, (date, step)=>{
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
const $dd6e0f506bfbbd03$export$3e24d311e17f5802 = $dd6e0f506bfbbd03$export$d5c3802e389714c4.range;

});


parcelRegister("UutV9", function(module, exports) {

$parcel$export(module.exports, "timeFormat", () => $0a9ce0165786feda$export$94f4d87fad5dcf9a);
$parcel$export(module.exports, "utcFormat", () => $0a9ce0165786feda$export$1a08fe38f63ebbbb);

var $61I4u = parcelRequire("61I4u");
var $0a9ce0165786feda$var$locale;
var $0a9ce0165786feda$export$94f4d87fad5dcf9a;
var $0a9ce0165786feda$export$32b9cd16e1b8c8d2;
var $0a9ce0165786feda$export$1a08fe38f63ebbbb;
var $0a9ce0165786feda$export$3edae9cf8e233729;
$0a9ce0165786feda$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $0a9ce0165786feda$export$2e2bcd8739ae039(definition) {
    $0a9ce0165786feda$var$locale = (0, $61I4u.default)(definition);
    $0a9ce0165786feda$export$94f4d87fad5dcf9a = $0a9ce0165786feda$var$locale.format;
    $0a9ce0165786feda$export$32b9cd16e1b8c8d2 = $0a9ce0165786feda$var$locale.parse;
    $0a9ce0165786feda$export$1a08fe38f63ebbbb = $0a9ce0165786feda$var$locale.utcFormat;
    $0a9ce0165786feda$export$3edae9cf8e233729 = $0a9ce0165786feda$var$locale.utcParse;
    return $0a9ce0165786feda$var$locale;
}

});
parcelRegister("61I4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $463505b9d968caf4$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");
function $463505b9d968caf4$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $463505b9d968caf4$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $463505b9d968caf4$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $463505b9d968caf4$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $463505b9d968caf4$var$formatRe(locale_periods), periodLookup = $463505b9d968caf4$var$formatLookup(locale_periods), weekdayRe = $463505b9d968caf4$var$formatRe(locale_weekdays), weekdayLookup = $463505b9d968caf4$var$formatLookup(locale_weekdays), shortWeekdayRe = $463505b9d968caf4$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $463505b9d968caf4$var$formatLookup(locale_shortWeekdays), monthRe = $463505b9d968caf4$var$formatRe(locale_months), monthLookup = $463505b9d968caf4$var$formatLookup(locale_months), shortMonthRe = $463505b9d968caf4$var$formatRe(locale_shortMonths), shortMonthLookup = $463505b9d968caf4$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatDayOfMonth,
        "e": $463505b9d968caf4$var$formatDayOfMonth,
        "f": $463505b9d968caf4$var$formatMicroseconds,
        "g": $463505b9d968caf4$var$formatYearISO,
        "G": $463505b9d968caf4$var$formatFullYearISO,
        "H": $463505b9d968caf4$var$formatHour24,
        "I": $463505b9d968caf4$var$formatHour12,
        "j": $463505b9d968caf4$var$formatDayOfYear,
        "L": $463505b9d968caf4$var$formatMilliseconds,
        "m": $463505b9d968caf4$var$formatMonthNumber,
        "M": $463505b9d968caf4$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatSeconds,
        "u": $463505b9d968caf4$var$formatWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatWeekNumberISO,
        "w": $463505b9d968caf4$var$formatWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatYear,
        "Y": $463505b9d968caf4$var$formatFullYear,
        "Z": $463505b9d968caf4$var$formatZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "e": $463505b9d968caf4$var$formatUTCDayOfMonth,
        "f": $463505b9d968caf4$var$formatUTCMicroseconds,
        "g": $463505b9d968caf4$var$formatUTCYearISO,
        "G": $463505b9d968caf4$var$formatUTCFullYearISO,
        "H": $463505b9d968caf4$var$formatUTCHour24,
        "I": $463505b9d968caf4$var$formatUTCHour12,
        "j": $463505b9d968caf4$var$formatUTCDayOfYear,
        "L": $463505b9d968caf4$var$formatUTCMilliseconds,
        "m": $463505b9d968caf4$var$formatUTCMonthNumber,
        "M": $463505b9d968caf4$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $463505b9d968caf4$var$formatUnixTimestamp,
        "s": $463505b9d968caf4$var$formatUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$formatUTCSeconds,
        "u": $463505b9d968caf4$var$formatUTCWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$formatUTCWeekNumberSunday,
        "V": $463505b9d968caf4$var$formatUTCWeekNumberISO,
        "w": $463505b9d968caf4$var$formatUTCWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $463505b9d968caf4$var$formatUTCYear,
        "Y": $463505b9d968caf4$var$formatUTCFullYear,
        "Z": $463505b9d968caf4$var$formatUTCZone,
        "%": $463505b9d968caf4$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $463505b9d968caf4$var$parseDayOfMonth,
        "e": $463505b9d968caf4$var$parseDayOfMonth,
        "f": $463505b9d968caf4$var$parseMicroseconds,
        "g": $463505b9d968caf4$var$parseYear,
        "G": $463505b9d968caf4$var$parseFullYear,
        "H": $463505b9d968caf4$var$parseHour24,
        "I": $463505b9d968caf4$var$parseHour24,
        "j": $463505b9d968caf4$var$parseDayOfYear,
        "L": $463505b9d968caf4$var$parseMilliseconds,
        "m": $463505b9d968caf4$var$parseMonthNumber,
        "M": $463505b9d968caf4$var$parseMinutes,
        "p": parsePeriod,
        "q": $463505b9d968caf4$var$parseQuarter,
        "Q": $463505b9d968caf4$var$parseUnixTimestamp,
        "s": $463505b9d968caf4$var$parseUnixTimestampSeconds,
        "S": $463505b9d968caf4$var$parseSeconds,
        "u": $463505b9d968caf4$var$parseWeekdayNumberMonday,
        "U": $463505b9d968caf4$var$parseWeekNumberSunday,
        "V": $463505b9d968caf4$var$parseWeekNumberISO,
        "w": $463505b9d968caf4$var$parseWeekdayNumberSunday,
        "W": $463505b9d968caf4$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $463505b9d968caf4$var$parseYear,
        "Y": $463505b9d968caf4$var$parseFullYear,
        "Z": $463505b9d968caf4$var$parseZone,
        "%": $463505b9d968caf4$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $463505b9d968caf4$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $463505b9d968caf4$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $aW15j.utcMonday).ceil(week) : (0, $aW15j.utcMonday)(week);
                    week = (0, $72rFk.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $aW15j.timeMonday).ceil(week) : (0, $aW15j.timeMonday)(week);
                    week = (0, $72rFk.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $463505b9d968caf4$var$utcDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getUTCDay() : $463505b9d968caf4$var$localDate($463505b9d968caf4$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $463505b9d968caf4$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $463505b9d968caf4$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $463505b9d968caf4$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $463505b9d968caf4$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $463505b9d968caf4$var$numberRe = /^\s*\d+/, $463505b9d968caf4$var$percentRe = /^%/, $463505b9d968caf4$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $463505b9d968caf4$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $463505b9d968caf4$var$requote(s) {
    return s.replace($463505b9d968caf4$var$requoteRe, "\\$&");
}
function $463505b9d968caf4$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($463505b9d968caf4$var$requote).join("|") + ")", "i");
}
function $463505b9d968caf4$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $463505b9d968caf4$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberSunday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberISO(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseWeekNumberMonday(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseFullYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseQuarter(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMonthNumber(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfMonth(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseDayOfYear(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseHour24(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMinutes(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMilliseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseMicroseconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseLiteralPercent(d, string, i) {
    var n = $463505b9d968caf4$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $463505b9d968caf4$var$parseUnixTimestamp(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $463505b9d968caf4$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $463505b9d968caf4$var$formatDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getDate(), p, 2);
}
function $463505b9d968caf4$var$formatHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours(), p, 2);
}
function $463505b9d968caf4$var$formatHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $72rFk.timeDay).count((0, $j0Fj9.timeYear)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $463505b9d968caf4$var$formatWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.timeSunday).count((0, $j0Fj9.timeYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $aW15j.timeThursday)(d) : (0, $aW15j.timeThursday).ceil(d);
}
function $463505b9d968caf4$var$formatWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad((0, $aW15j.timeThursday).count((0, $j0Fj9.timeYear)(d), d) + ((0, $j0Fj9.timeYear)(d).getDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $463505b9d968caf4$var$formatWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.timeMonday).count((0, $j0Fj9.timeYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatYearISO(d, p) {
    d = $463505b9d968caf4$var$dISO(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $aW15j.timeThursday)(d) : (0, $aW15j.timeThursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $463505b9d968caf4$var$pad(z / 60 | 0, "0", 2) + $463505b9d968caf4$var$pad(z % 60, "0", 2);
}
function $463505b9d968caf4$var$formatUTCDayOfMonth(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCDate(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour24(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours(), p, 2);
}
function $463505b9d968caf4$var$formatUTCHour12(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $463505b9d968caf4$var$formatUTCDayOfYear(d, p) {
    return $463505b9d968caf4$var$pad(1 + (0, $72rFk.utcDay).count((0, $j0Fj9.utcYear)(d), d), p, 3);
}
function $463505b9d968caf4$var$formatUTCMilliseconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $463505b9d968caf4$var$formatUTCMicroseconds(d, p) {
    return $463505b9d968caf4$var$formatUTCMilliseconds(d, p) + "000";
}
function $463505b9d968caf4$var$formatUTCMonthNumber(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $463505b9d968caf4$var$formatUTCMinutes(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCMinutes(), p, 2);
}
function $463505b9d968caf4$var$formatUTCSeconds(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCSeconds(), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $463505b9d968caf4$var$formatUTCWeekNumberSunday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.utcSunday).count((0, $j0Fj9.utcYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $aW15j.utcThursday)(d) : (0, $aW15j.utcThursday).ceil(d);
}
function $463505b9d968caf4$var$formatUTCWeekNumberISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad((0, $aW15j.utcThursday).count((0, $j0Fj9.utcYear)(d), d) + ((0, $j0Fj9.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $463505b9d968caf4$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $463505b9d968caf4$var$formatUTCWeekNumberMonday(d, p) {
    return $463505b9d968caf4$var$pad((0, $aW15j.utcMonday).count((0, $j0Fj9.utcYear)(d) - 1, d), p, 2);
}
function $463505b9d968caf4$var$formatUTCYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCYearISO(d, p) {
    d = $463505b9d968caf4$var$UTCdISO(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $463505b9d968caf4$var$formatUTCFullYear(d, p) {
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $aW15j.utcThursday)(d) : (0, $aW15j.utcThursday).ceil(d);
    return $463505b9d968caf4$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $463505b9d968caf4$var$formatUTCZone() {
    return "+0000";
}
function $463505b9d968caf4$var$formatLiteralPercent() {
    return "%";
}
function $463505b9d968caf4$var$formatUnixTimestamp(d) {
    return +d;
}
function $463505b9d968caf4$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});



parcelRegister("l1Ebe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e8dbe80a3143de$export$2e2bcd8739ae039);

var $72rFk = parcelRequire("72rFk");
var $cKbL9 = parcelRequire("cKbL9");
var $3wXBo = parcelRequire("3wXBo");
var $gyimR = parcelRequire("gyimR");
var $6gR0W = parcelRequire("6gR0W");
var $nRuo6 = parcelRequire("nRuo6");
var $aW15j = parcelRequire("aW15j");
var $j0Fj9 = parcelRequire("j0Fj9");

var $UutV9 = parcelRequire("UutV9");

var $48U7R = parcelRequire("48U7R");

var $7QzZn = parcelRequire("7QzZn");
function $f4e8dbe80a3143de$export$2e2bcd8739ae039() {
    return (0, $7QzZn.initRange).apply((0, $48U7R.calendar)((0, $nRuo6.utcTicks), (0, $nRuo6.utcTickInterval), (0, $j0Fj9.utcYear), (0, $gyimR.utcMonth), (0, $aW15j.utcSunday), (0, $72rFk.utcDay), (0, $cKbL9.utcHour), (0, $3wXBo.utcMinute), (0, $6gR0W.second), (0, $UutV9.utcFormat)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("lrv5b", function(module, exports) {

$parcel$export(module.exports, "copy", () => $f9c43af42f8b19e4$export$784d13d8ee351f07);
$parcel$export(module.exports, "default", () => $f9c43af42f8b19e4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "sequentialLog", () => $f9c43af42f8b19e4$export$6843e08bf2ff981f);
$parcel$export(module.exports, "sequentialSymlog", () => $f9c43af42f8b19e4$export$9d4af4de62c81941);
$parcel$export(module.exports, "sequentialPow", () => $f9c43af42f8b19e4$export$de9f78581b4f2405);
$parcel$export(module.exports, "sequentialSqrt", () => $f9c43af42f8b19e4$export$413d935127ed466e);

var $bi4KR = parcelRequire("bi4KR");
var $gzbhl = parcelRequire("gzbhl");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $ht0x4 = parcelRequire("ht0x4");

var $iFFhE = parcelRequire("iFFhE");
function $f9c43af42f8b19e4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $f6dVf.identity), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $bi4KR.default));
    scale.rangeRound = range((0, $gzbhl.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $f9c43af42f8b19e4$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $f9c43af42f8b19e4$export$2e2bcd8739ae039() {
    var scale = (0, $iOlPi.linearish)($f9c43af42f8b19e4$var$transformer()((0, $f6dVf.identity)));
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$2e2bcd8739ae039());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$6843e08bf2ff981f() {
    var scale = (0, $7TrsU.loggish)($f9c43af42f8b19e4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$9d4af4de62c81941() {
    var scale = (0, $ht0x4.symlogish)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$de9f78581b4f2405() {
    var scale = (0, $iFFhE.powish)($f9c43af42f8b19e4$var$transformer());
    scale.copy = function() {
        return $f9c43af42f8b19e4$export$784d13d8ee351f07(scale, $f9c43af42f8b19e4$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $f9c43af42f8b19e4$export$413d935127ed466e() {
    return $f9c43af42f8b19e4$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("77K6z", function(module, exports) {

$parcel$export(module.exports, "default", () => $52fcf35202383c14$export$2e2bcd8739ae039);

var $8zdji = parcelRequire("8zdji");
var $ekiL6 = parcelRequire("ekiL6");
var $30TGf = parcelRequire("30TGf");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");
function $52fcf35202383c14$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $f6dVf.identity);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $ekiL6.default)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $8zdji.default));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $30TGf.default)(domain, i / n));
    };
    scale.copy = function() {
        return $52fcf35202383c14$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}

});

parcelRegister("2dSUq", function(module, exports) {

$parcel$export(module.exports, "default", () => $19e76371916c670d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "divergingLog", () => $19e76371916c670d$export$5f0266a9159c47fb);
$parcel$export(module.exports, "divergingSymlog", () => $19e76371916c670d$export$50b3da713cf557c6);
$parcel$export(module.exports, "divergingPow", () => $19e76371916c670d$export$d6cedcc63bf26e7e);
$parcel$export(module.exports, "divergingSqrt", () => $19e76371916c670d$export$33ddefb5c4ab9e9c);

var $bi4KR = parcelRequire("bi4KR");
var $gzbhl = parcelRequire("gzbhl");
var $3fZH9 = parcelRequire("3fZH9");

var $f6dVf = parcelRequire("f6dVf");

var $7QzZn = parcelRequire("7QzZn");

var $iOlPi = parcelRequire("iOlPi");

var $7TrsU = parcelRequire("7TrsU");

var $lrv5b = parcelRequire("lrv5b");

var $ht0x4 = parcelRequire("ht0x4");

var $iFFhE = parcelRequire("iFFhE");
function $19e76371916c670d$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $f6dVf.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $3fZH9.default)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $bi4KR.default));
    scale.rangeRound = range((0, $gzbhl.default));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $19e76371916c670d$export$2e2bcd8739ae039() {
    var scale = (0, $iOlPi.linearish)($19e76371916c670d$var$transformer()((0, $f6dVf.identity)));
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$2e2bcd8739ae039());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$5f0266a9159c47fb() {
    var scale = (0, $7TrsU.loggish)($19e76371916c670d$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$50b3da713cf557c6() {
    var scale = (0, $ht0x4.symlogish)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$d6cedcc63bf26e7e() {
    var scale = (0, $iFFhE.powish)($19e76371916c670d$var$transformer());
    scale.copy = function() {
        return (0, $lrv5b.copy)(scale, $19e76371916c670d$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $7QzZn.initInterpolator).apply(scale, arguments);
}
function $19e76371916c670d$export$33ddefb5c4ab9e9c() {
    return $19e76371916c670d$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}

});
parcelRegister("3fZH9", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f2a121ae5a240e$export$2e2bcd8739ae039);

var $bi4KR = parcelRequire("bi4KR");
function $25f2a121ae5a240e$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $bi4KR.default);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});





parcelRegister("5dTrd", function(module, exports) {

$parcel$export(module.exports, "combineRealScaleType", () => $3cd92b7f0d5f8a3a$export$bebec32544750591);

var $eHAj8 = parcelRequire("eHAj8");

var $3FiDp = parcelRequire("3FiDp");
function $3cd92b7f0d5f8a3a$var$getD3ScaleName(name) {
    return "scale".concat((0, $3FiDp.upperFirst)(name));
}
function $3cd92b7f0d5f8a3a$var$isSupportedScaleName(name) {
    return $3cd92b7f0d5f8a3a$var$getD3ScaleName(name) in $eHAj8;
}
var $3cd92b7f0d5f8a3a$export$bebec32544750591 = (axisConfig, hasBar, chartType)=>{
    if (axisConfig == null) return undefined;
    var scale = axisConfig.scale, type = axisConfig.type;
    if (scale === 'auto') {
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') return $3cd92b7f0d5f8a3a$var$isSupportedScaleName(scale) ? scale : 'point';
    return undefined;
};

});

parcelRegister("gYUxO", function(module, exports) {

$parcel$export(module.exports, "createCategoricalInverse", () => $c5ce1c7c085c33c8$export$e954f4783a2f3ac0);
/**
 * Binary search to find the index where x would fit in array a.
 * Works for arrays that are sorted both ascending and descending.
 *
 * Unlike d3.bisect, this implementation handles both ascending and descending arrays.
 *
 * @param haystack Sorted array of numbers
 * @param needle Number to find the insertion index for
 * @returns Index where x would fit in array a
 */ function $c5ce1c7c085c33c8$export$a668c821d9678ea6(haystack, needle) {
    var lo = 0;
    var hi = haystack.length;
    var ascending = haystack[0] < haystack[haystack.length - 1];
    while(lo < hi){
        var mid = Math.floor((lo + hi) / 2);
        if (ascending ? haystack[mid] < needle : haystack[mid] > needle) lo = mid + 1;
        else hi = mid;
    }
    return lo;
}
function $c5ce1c7c085c33c8$export$e954f4783a2f3ac0(scale, allDataPointsOnAxis) {
    if (!scale) return undefined;
    var domain = allDataPointsOnAxis !== null && allDataPointsOnAxis !== void 0 ? allDataPointsOnAxis : scale.domain();
    // Build an array of pixel positions for each domain value
    // @ts-expect-error we're attempting to scale unknown without having guarantee that it is a Domain type
    var pixelPositions = domain.map((d)=>{
        var _scale;
        return (_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0;
    });
    var range = scale.range();
    if (domain.length === 0 || range.length < 2) return undefined;
    return (pixelValue)=>{
        var _pixelPositions, _pixelPositions$index;
        // Find the closest domain value using bisect
        var index = $c5ce1c7c085c33c8$export$a668c821d9678ea6(pixelPositions, pixelValue);
        // Clamp to valid range
        if (index <= 0) return domain[0];
        if (index >= domain.length) return domain[domain.length - 1];
        // Check which neighbor is closer
        var leftPixel = (_pixelPositions = pixelPositions[index - 1]) !== null && _pixelPositions !== void 0 ? _pixelPositions : 0;
        var rightPixel = (_pixelPositions$index = pixelPositions[index]) !== null && _pixelPositions$index !== void 0 ? _pixelPositions$index : 0;
        if (Math.abs(pixelValue - leftPixel) <= Math.abs(pixelValue - rightPixel)) return domain[index - 1];
        return domain[index];
    };
}

});

parcelRegister("dPWwa", function(module, exports) {

$parcel$export(module.exports, "combineInverseScaleFunction", () => $a12d6e2ee266731a$export$757040754bd60df5);

var $gYUxO = parcelRequire("gYUxO");
function $a12d6e2ee266731a$export$757040754bd60df5(configuredScale) {
    if (configuredScale == null) return undefined;
    if ('invert' in configuredScale && typeof configuredScale.invert === 'function') return configuredScale.invert.bind(configuredScale);
    return (0, $gYUxO.createCategoricalInverse)(configuredScale, undefined);
}

});


parcelRegister("2Ron6", function(module, exports) {

$parcel$export(module.exports, "selectDefaultTooltipEventType", () => $21536fb21082ce97$export$877d2dd8db5f51fd);
$parcel$export(module.exports, "selectValidateTooltipEventTypes", () => $21536fb21082ce97$export$7f95a7e594fa7911);
$parcel$export(module.exports, "combineTooltipEventType", () => $21536fb21082ce97$export$d419a1f58b445a8f);
$parcel$export(module.exports, "selectTooltipEventType", () => $21536fb21082ce97$export$53af65c2db668fac);
$parcel$export(module.exports, "useTooltipEventType", () => $21536fb21082ce97$export$7ac1fe18a92be318);

var $bqlEl = parcelRequire("bqlEl");
var $21536fb21082ce97$export$877d2dd8db5f51fd = (state)=>state.options.defaultTooltipEventType;
var $21536fb21082ce97$export$7f95a7e594fa7911 = (state)=>state.options.validateTooltipEventTypes;
function $21536fb21082ce97$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function $21536fb21082ce97$export$53af65c2db668fac(state, shared) {
    var defaultTooltipEventType = $21536fb21082ce97$export$877d2dd8db5f51fd(state);
    var validateTooltipEventTypes = $21536fb21082ce97$export$7f95a7e594fa7911(state);
    return $21536fb21082ce97$export$d419a1f58b445a8f(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function $21536fb21082ce97$export$7ac1fe18a92be318(shared) {
    return (0, $bqlEl.useAppSelector)((state)=>$21536fb21082ce97$export$53af65c2db668fac(state, shared));
}

});

parcelRegister("564ve", function(module, exports) {

$parcel$export(module.exports, "combineActiveLabel", () => $3b61016ee0a2b578$export$3213c4688ceb4c80);

var $3FiDp = parcelRequire("3FiDp");
var $3b61016ee0a2b578$export$3213c4688ceb4c80 = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, $3FiDp.isNan)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};

});

parcelRegister("khQco", function(module, exports) {

$parcel$export(module.exports, "selectTooltipSettings", () => $ec4de2c43a3d7eef$export$26d1e95fb7dea02);
var $ec4de2c43a3d7eef$export$26d1e95fb7dea02 = (state)=>state.tooltip.settings;

});

parcelRegister("5fR7X", function(module, exports) {

$parcel$export(module.exports, "combineTooltipInteractionState", () => $3d3790706a3050f8$export$d759c39cacfacf6a);

var $58RF9 = parcelRequire("58RF9");
function $3d3790706a3050f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d3790706a3050f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d3790706a3050f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3d3790706a3050f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d3790706a3050f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3d3790706a3050f8$var$_defineProperty(e, r, t) {
    return (r = $3d3790706a3050f8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d3790706a3050f8$var$_toPropertyKey(t) {
    var i = $3d3790706a3050f8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d3790706a3050f8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3d3790706a3050f8$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function $3d3790706a3050f8$var$hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var $3d3790706a3050f8$export$d759c39cacfacf6a = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, $58RF9.noInteraction;
    var appropriateMouseInteraction = $3d3790706a3050f8$var$chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, $58RF9.noInteraction;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if ($3d3790706a3050f8$var$hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return $3d3790706a3050f8$var$_objectSpread($3d3790706a3050f8$var$_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex,
        graphicalItemId: undefined
    };
    return $3d3790706a3050f8$var$_objectSpread($3d3790706a3050f8$var$_objectSpread({}, (0, $58RF9.noInteraction)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};

});

parcelRegister("czuyh", function(module, exports) {

$parcel$export(module.exports, "combineActiveTooltipIndex", () => $927073e84a89ab02$export$32df4b03a0962e46);

var $iMnqX = parcelRequire("iMnqX");

var $hBeJX = parcelRequire("hBeJX");

var $agTdp = parcelRequire("agTdp");
function $927073e84a89ab02$var$toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function $927073e84a89ab02$var$isValueWithinNumberDomain(value, domain) {
    var numericValue = $927073e84a89ab02$var$toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function $927073e84a89ab02$var$isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, $hBeJX.getValueByDataKey)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, $agTdp.isWellFormedNumberDomain)(domain)) return true;
    return $927073e84a89ab02$var$isValueWithinNumberDomain(value, domain);
}
var $927073e84a89ab02$export$32df4b03a0962e46 = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, $iMnqX.isWellBehavedNumber)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!$927073e84a89ab02$var$isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};

});

parcelRegister("5zpLv", function(module, exports) {

$parcel$export(module.exports, "combineCoordinateForDefaultIndex", () => $40e435146911cfcc$export$c2cbc37a7546bbd0);
var $40e435146911cfcc$export$c2cbc37a7546bbd0 = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations)=>{
    if (defaultIndex == null) return undefined;
    /*
   * With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display.
   * Maybe one day we could add new prop `activeGraphicalItemId` to the chart to help with that.
   * Until then, we choose the first one.
   */ var firstConfiguration = tooltipConfigurations[0];
    var maybePosition = firstConfiguration === null || firstConfiguration === void 0 ? void 0 : firstConfiguration.getPosition(defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};

});

parcelRegister("aoaNY", function(module, exports) {

$parcel$export(module.exports, "combineTooltipPayloadConfigurations", () => $790486f25cd906b4$export$45044aaa79c0cddb);
var $790486f25cd906b4$export$45044aaa79c0cddb = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByGraphicalItemId;
    if (trigger === 'hover') filterByGraphicalItemId = tooltipState.itemInteraction.hover.graphicalItemId;
    else filterByGraphicalItemId = tooltipState.itemInteraction.click.graphicalItemId;
    if (tooltipState.syncInteraction.active && filterByGraphicalItemId == null) /*
     * When a tooltip is synchronised from another chart, the local itemInteraction
     * has no graphicalItemId because the user hasn't hovered over this chart.
     * In that case we show all tooltip items so the receiving chart can display
     * its own data at the synced index — matching the behaviour of axis-type tooltips.
     */ return tooltipState.tooltipItemPayloads;
    if (filterByGraphicalItemId == null && (defaultIndex != null || tooltipState.keyboardInteraction.active)) {
        /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ var firstItemPayload = tooltipState.tooltipItemPayloads[0];
        if (firstItemPayload != null) return [
            firstItemPayload
        ];
        return [];
    }
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.graphicalItemId) === filterByGraphicalItemId;
    });
};

});

parcelRegister("4cwIx", function(module, exports) {

$parcel$export(module.exports, "selectTooltipPayloadSearcher", () => $30f1a9633819407c$export$6ae1ee94e6fa88a7);
var $30f1a9633819407c$export$6ae1ee94e6fa88a7 = (state)=>state.options.tooltipPayloadSearcher;

});

parcelRegister("ao1Kf", function(module, exports) {

$parcel$export(module.exports, "selectTooltipState", () => $78fd7fcb0d81609e$export$703b585bc92b5bae);
var $78fd7fcb0d81609e$export$703b585bc92b5bae = (state)=>state.tooltip;

});

parcelRegister("72sMT", function(module, exports) {

$parcel$export(module.exports, "combineTooltipPayload", () => $51ff0ceee53f8296$export$e50d50655fe0e7ab);

var $3FiDp = parcelRequire("3FiDp");

var $hBeJX = parcelRequire("hBeJX");

var $gDbhy = parcelRequire("gDbhy");
function $51ff0ceee53f8296$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $51ff0ceee53f8296$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $51ff0ceee53f8296$var$ownKeys(Object(t), !0).forEach(function(r) {
            $51ff0ceee53f8296$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $51ff0ceee53f8296$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $51ff0ceee53f8296$var$_defineProperty(e, r, t) {
    return (r = $51ff0ceee53f8296$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $51ff0ceee53f8296$var$_toPropertyKey(t) {
    var i = $51ff0ceee53f8296$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $51ff0ceee53f8296$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $51ff0ceee53f8296$var$parseName(value) {
    if (typeof value === 'string' || typeof value === 'number') return value;
    return undefined;
}
function $51ff0ceee53f8296$var$parseUnit(value) {
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    return undefined;
}
function $51ff0ceee53f8296$var$parseDataKey(value) {
    if (typeof value === 'string' || typeof value === 'number') return value;
    if (typeof value === 'function') return (obj)=>value(obj);
    return undefined;
}
function $51ff0ceee53f8296$var$parseColor(value) {
    if (typeof value === 'string') return value;
    return undefined;
}
function $51ff0ceee53f8296$var$parseTooltipPayloadItem(item) {
    if (item == null || typeof item !== 'object') return undefined;
    var name = 'name' in item ? $51ff0ceee53f8296$var$parseName(item.name) : undefined;
    var unit = 'unit' in item ? $51ff0ceee53f8296$var$parseUnit(item.unit) : undefined;
    var dataKey = 'dataKey' in item ? $51ff0ceee53f8296$var$parseDataKey(item.dataKey) : undefined;
    var payload = 'payload' in item ? item.payload : undefined;
    var color = 'color' in item ? $51ff0ceee53f8296$var$parseColor(item.color) : undefined;
    var fill = 'fill' in item ? $51ff0ceee53f8296$var$parseColor(item.fill) : undefined;
    return {
        name: name,
        unit: unit,
        dataKey: dataKey,
        payload: payload,
        color: color,
        fill: fill
    };
}
function $51ff0ceee53f8296$var$selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var $51ff0ceee53f8296$export$e50d50655fe0e7ab = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var chartData = chartDataState.chartData, computedData = chartDataState.computedData, dataStartIndex = chartDataState.dataStartIndex, dataEndIndex = chartDataState.dataEndIndex;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var dataDefinedOnItem = _ref.dataDefinedOnItem, settings = _ref.settings;
        var finalData = $51ff0ceee53f8296$var$selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, $gDbhy.getSliced)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') {
            tooltipPayload = (0, $3FiDp.findEntryInArray)(sliced, tooltipAxisDataKey, activeLabel);
            /*
       * When allowDuplicatedCategory is false and there are duplicate category values
       * in the data, findEntryInArray returns only the first matching entry.
       * If the user hovers over a bar that corresponds to a later duplicate,
       * the activeIndex provides the correct position. We fall back to the index-based
       * search when the label-based search returns undefined, which can happen
       * when the activeLabel does not precisely match any data entry (e.g., due to
       * type coercion differences between tick values and data values).
       */ if (tooltipPayload == null) tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        } else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var _parsedItem$color, _parsedItem$fill;
            var parsedItem = $51ff0ceee53f8296$var$parseTooltipPayloadItem(item);
            var itemName = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.name;
            var itemDataKey = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.dataKey;
            var itemPayload = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.payload;
            var newSettings = $51ff0ceee53f8296$var$_objectSpread($51ff0ceee53f8296$var$_objectSpread({}, settings), {}, {
                name: itemName,
                unit: parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.unit,
                // Preserve item-level color/fill from graphical items.
                color: (_parsedItem$color = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.color) !== null && _parsedItem$color !== void 0 ? _parsedItem$color : settings === null || settings === void 0 ? void 0 : settings.color,
                fill: (_parsedItem$fill = parsedItem === null || parsedItem === void 0 ? void 0 : parsedItem.fill) !== null && _parsedItem$fill !== void 0 ? _parsedItem$fill : settings === null || settings === void 0 ? void 0 : settings.fill
            });
            agg.push((0, $hBeJX.getTooltipEntry)({
                tooltipEntrySettings: newSettings,
                dataKey: itemDataKey,
                payload: itemPayload,
                value: (0, $hBeJX.getValueByDataKey)(itemPayload, itemDataKey),
                name: itemName == null ? undefined : String(itemName)
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, $hBeJX.getTooltipEntry)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // getValueByDataKey does not validate the output type
                value: (0, $hBeJX.getValueByDataKey)(tooltipPayload, finalDataKey),
                // getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, $hBeJX.getValueByDataKey)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};

});


parcelRegister("72R3N", function(module, exports) {

$parcel$export(module.exports, "useChartName", () => $5211e0f48c9883fe$export$ed30b3372172c46c);
$parcel$export(module.exports, "selectOrderedTooltipTicks", () => $5211e0f48c9883fe$export$e133bec3c93a9247);
$parcel$export(module.exports, "selectTooltipDataKey", () => $5211e0f48c9883fe$export$faa2b8b92235e5bd);
$parcel$export(module.exports, "selectCoordinateForDefaultIndex", () => $5211e0f48c9883fe$export$7dbe424d18defe7d);
$parcel$export(module.exports, "selectActiveCoordinate", () => $5211e0f48c9883fe$export$392a0083df9bfd7c);
$parcel$export(module.exports, "selectActiveLabel", () => $5211e0f48c9883fe$export$400c35cc3b9a0487);
$parcel$export(module.exports, "selectTooltipPayload", () => $5211e0f48c9883fe$export$529676bfdba08611);
$parcel$export(module.exports, "selectIsTooltipActive", () => $5211e0f48c9883fe$export$c8884ed37796034a);
$parcel$export(module.exports, "combineActiveProps", () => $5211e0f48c9883fe$export$e1c9f959fffb37b4);

var $b0nKR = parcelRequire("b0nKR");

var $bat1Y = parcelRequire("bat1Y");

var $bqlEl = parcelRequire("bqlEl");

var $hBeJX = parcelRequire("hBeJX");

var $i2WC7 = parcelRequire("i2WC7");

var $71i43 = parcelRequire("71i43");

var $99P3O = parcelRequire("99P3O");

var $iYis8 = parcelRequire("iYis8");

var $jHn5r = parcelRequire("jHn5r");

var $lnFga = parcelRequire("lnFga");

var $V5fxS = parcelRequire("V5fxS");

var $564ve = parcelRequire("564ve");

var $5fR7X = parcelRequire("5fR7X");

var $czuyh = parcelRequire("czuyh");

var $5zpLv = parcelRequire("5zpLv");

var $aoaNY = parcelRequire("aoaNY");

var $4cwIx = parcelRequire("4cwIx");

var $ao1Kf = parcelRequire("ao1Kf");

var $72sMT = parcelRequire("72sMT");

var $inDEk = parcelRequire("inDEk");

var $1l5bp = parcelRequire("1l5bp");
var $5211e0f48c9883fe$export$ed30b3372172c46c = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $iYis8.selectChartName));
};
var $5211e0f48c9883fe$var$pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var $5211e0f48c9883fe$var$pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var $5211e0f48c9883fe$var$pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var $5211e0f48c9883fe$export$e133bec3c93a9247 = (0, $b0nKR.createSelector)((0, $71i43.selectTooltipAxisTicks), (ticks)=>(0, $bat1Y.sortBy)(ticks, (o)=>o.coordinate));
var $5211e0f48c9883fe$export$1288ff5c64c4ac42 = (0, $b0nKR.createSelector)([
    (0, $ao1Kf.selectTooltipState),
    $5211e0f48c9883fe$var$pickTooltipEventType,
    $5211e0f48c9883fe$var$pickTrigger,
    $5211e0f48c9883fe$var$pickDefaultIndex
], (0, $5fR7X.combineTooltipInteractionState));
var $5211e0f48c9883fe$export$95fb15d7bb7a8a94 = (0, $b0nKR.createSelector)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    (0, $71i43.selectTooltipDisplayedData),
    (0, $99P3O.selectTooltipAxisDataKey),
    (0, $71i43.selectTooltipAxisDomain)
], (0, $czuyh.combineActiveTooltipIndex));
var $5211e0f48c9883fe$export$faa2b8b92235e5bd = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, $ao1Kf.selectTooltipState)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var $5211e0f48c9883fe$export$8ff07a725463bd5 = (0, $b0nKR.createSelector)([
    (0, $ao1Kf.selectTooltipState),
    $5211e0f48c9883fe$var$pickTooltipEventType,
    $5211e0f48c9883fe$var$pickTrigger,
    $5211e0f48c9883fe$var$pickDefaultIndex
], (0, $aoaNY.combineTooltipPayloadConfigurations));
var $5211e0f48c9883fe$export$7dbe424d18defe7d = (0, $b0nKR.createSelector)([
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight),
    (0, $jHn5r.selectChartLayout),
    (0, $lnFga.selectChartOffsetInternal),
    (0, $71i43.selectTooltipAxisTicks),
    $5211e0f48c9883fe$var$pickDefaultIndex,
    $5211e0f48c9883fe$export$8ff07a725463bd5
], (0, $5zpLv.combineCoordinateForDefaultIndex));
var $5211e0f48c9883fe$export$392a0083df9bfd7c = (0, $b0nKR.createSelector)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    $5211e0f48c9883fe$export$7dbe424d18defe7d
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var $5211e0f48c9883fe$export$400c35cc3b9a0487 = (0, $b0nKR.createSelector)([
    (0, $71i43.selectTooltipAxisTicks),
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94
], (0, $564ve.combineActiveLabel));
var $5211e0f48c9883fe$export$529676bfdba08611 = (0, $b0nKR.createSelector)([
    $5211e0f48c9883fe$export$8ff07a725463bd5,
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94,
    (0, $i2WC7.selectChartDataWithIndexes),
    (0, $99P3O.selectTooltipAxisDataKey),
    $5211e0f48c9883fe$export$400c35cc3b9a0487,
    (0, $4cwIx.selectTooltipPayloadSearcher),
    $5211e0f48c9883fe$var$pickTooltipEventType
], (0, $72sMT.combineTooltipPayload));
var $5211e0f48c9883fe$export$c8884ed37796034a = (0, $b0nKR.createSelector)([
    $5211e0f48c9883fe$export$1288ff5c64c4ac42,
    $5211e0f48c9883fe$export$95fb15d7bb7a8a94
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex: activeIndex
    };
});
var $5211e0f48c9883fe$var$combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, $inDEk.isInCartesianRange)(chartEvent, offset)) return undefined;
    var pos = (0, $hBeJX.calculateCartesianTooltipPos)(chartEvent, layout);
    var activeIndex = (0, $inDEk.calculateActiveTickIndex)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $inDEk.getActiveCartesianCoordinate)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5211e0f48c9883fe$var$combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, $1l5bp.inRangeOfSector)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, $hBeJX.calculatePolarTooltipPos)(rangeObj, layout);
    var activeIndex = (0, $inDEk.calculateActiveTickIndex)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, $inDEk.getActivePolarCoordinate)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate: activeCoordinate
    };
};
var $5211e0f48c9883fe$export$e1c9f959fffb37b4 = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return $5211e0f48c9883fe$var$combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return $5211e0f48c9883fe$var$combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};

});
parcelRegister("inDEk", function(module, exports) {

$parcel$export(module.exports, "getActiveCartesianCoordinate", () => $d619218d8fdf3f2a$export$cfad5721ad1fe55);
$parcel$export(module.exports, "getActivePolarCoordinate", () => $d619218d8fdf3f2a$export$6bc723868198544);
$parcel$export(module.exports, "isInCartesianRange", () => $d619218d8fdf3f2a$export$215f974420919247);
$parcel$export(module.exports, "calculateActiveTickIndex", () => $d619218d8fdf3f2a$export$3071d39cc844078e);

var $1l5bp = parcelRequire("1l5bp");

var $3FiDp = parcelRequire("3FiDp");
function $d619218d8fdf3f2a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d619218d8fdf3f2a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d619218d8fdf3f2a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d619218d8fdf3f2a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d619218d8fdf3f2a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d619218d8fdf3f2a$var$_defineProperty(e, r, t) {
    return (r = $d619218d8fdf3f2a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d619218d8fdf3f2a$var$_toPropertyKey(t) {
    var i = $d619218d8fdf3f2a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d619218d8fdf3f2a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d619218d8fdf3f2a$export$cfad5721ad1fe55 = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.relativeY
        };
        if (layout === 'vertical') return {
            x: pointer.relativeX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var $d619218d8fdf3f2a$export$6bc723868198544 = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread({}, rangeObj), (0, $1l5bp.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread($d619218d8fdf3f2a$var$_objectSpread({}, rangeObj), (0, $1l5bp.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function $d619218d8fdf3f2a$export$215f974420919247(pointer, offset) {
    var x = pointer.relativeX, y = pointer.relativeY;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var $d619218d8fdf3f2a$export$3071d39cc844078e = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) {
        // ticks are distributed in a circle
        var span = range[1] - range[0];
        /*
     * Tick coordinates can be shifted outside of the range (e.g. by the band offset
     * that tooltip ticks receive), so both the coordinate and the intervals live
     * modulo the full circle. Testing the coordinate shifted by a whole turn in both
     * directions closes the wrap-around gap where no interval matched
     * and the active index came back as -1.
     * https://github.com/recharts/recharts/issues/5099
     */ var isInside = (lowerLimit, upperLimit, inclusiveLower)=>[
                coordinate,
                coordinate + span,
                coordinate - span
            ].some((c)=>(inclusiveLower ? c >= lowerLimit : c > lowerLimit) && c <= upperLimit);
        for(var i = 0; i < len; i++){
            var _unsortedTicks, _unsortedTicks2, _unsortedTicks$i, _unsortedTicks$, _unsortedTicks3;
            var before = i > 0 ? (_unsortedTicks = unsortedTicks[i - 1]) === null || _unsortedTicks === void 0 ? void 0 : _unsortedTicks.coordinate : (_unsortedTicks2 = unsortedTicks[len - 1]) === null || _unsortedTicks2 === void 0 ? void 0 : _unsortedTicks2.coordinate;
            var cur = (_unsortedTicks$i = unsortedTicks[i]) === null || _unsortedTicks$i === void 0 ? void 0 : _unsortedTicks$i.coordinate;
            var after = i >= len - 1 ? (_unsortedTicks$ = unsortedTicks[0]) === null || _unsortedTicks$ === void 0 ? void 0 : _unsortedTicks$.coordinate : (_unsortedTicks3 = unsortedTicks[i + 1]) === null || _unsortedTicks3 === void 0 ? void 0 : _unsortedTicks3.coordinate;
            var sameDirectionCoord = void 0;
            if (before == null || cur == null || after == null) continue;
            if ((0, $3FiDp.mathSign)(cur - before) !== (0, $3FiDp.mathSign)(after - cur)) {
                var diffInterval = [];
                if ((0, $3FiDp.mathSign)(after - cur) === (0, $3FiDp.mathSign)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (isInside(sameInterval[0], sameInterval[1], false) || isInside(diffInterval[0], diffInterval[1], true)) {
                    var _unsortedTicks$i2;
                    return (_unsortedTicks$i2 = unsortedTicks[i]) === null || _unsortedTicks$i2 === void 0 ? void 0 : _unsortedTicks$i2.index;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (isInside((minValue + cur) / 2, (maxValue + cur) / 2, false)) {
                    var _unsortedTicks$i3;
                    return (_unsortedTicks$i3 = unsortedTicks[i]) === null || _unsortedTicks$i3 === void 0 ? void 0 : _unsortedTicks$i3.index;
                }
            }
        }
    } else if (ticks) // ticks are distributed in a single direction
    for(var _i = 0; _i < len; _i++){
        var curr = ticks[_i];
        if (curr == null) continue;
        var next = ticks[_i + 1];
        var prev = ticks[_i - 1];
        if (_i === 0 && next != null && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
        if (_i === len - 1 && prev != null && coordinate > (curr.coordinate + prev.coordinate) / 2) return curr.index;
        if (_i > 0 && _i < len - 1 && prev != null && next != null && coordinate > (curr.coordinate + prev.coordinate) / 2 && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
    }
    return -1;
};

});



parcelRegister("grYi3", function(module, exports) {

$parcel$export(module.exports, "getRelativeCoordinate", () => $bf9def577fdd8810$export$4f29f8e5290cb0bb);
/**
 * Type guard to check if the pointer event is from an SVG element.
 */ function $bf9def577fdd8810$var$isSvgPointer(pointer) {
    return 'getBBox' in pointer.currentTarget && typeof pointer.currentTarget.getBBox === 'function';
}
function $bf9def577fdd8810$export$4f29f8e5290cb0bb(event) {
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX, scaleY;
    if ($bf9def577fdd8810$var$isSvgPointer(event)) {
        // For SVG elements, use getBBox() to get the intrinsic size in SVG coordinates
        var bbox = event.currentTarget.getBBox();
        scaleX = bbox.width > 0 ? rect.width / bbox.width : 1;
        scaleY = bbox.height > 0 ? rect.height / bbox.height : 1;
    } else {
        // For HTML elements, use offsetWidth/offsetHeight
        var element = event.currentTarget;
        scaleX = element.offsetWidth > 0 ? rect.width / element.offsetWidth : 1;
        scaleY = element.offsetHeight > 0 ? rect.height / element.offsetHeight : 1;
    }
    var getCoordinates = (clientX, clientY)=>({
            /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ relativeX: Math.round((clientX - rect.left) / scaleX),
            relativeY: Math.round((clientY - rect.top) / scaleY)
        });
    if ('touches' in event) return Array.from(event.touches).map((touch)=>getCoordinates(touch.clientX, touch.clientY));
    return getCoordinates(event.clientX, event.clientY);
}

});


parcelRegister("95Fms", function(module, exports) {

$parcel$export(module.exports, "reduxDevtoolsJsonStringifyReplacer", () => $69e4aa2369c694bd$export$b5f053baf756345f);
function $69e4aa2369c694bd$export$b5f053baf756345f(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}

});

parcelRegister("214LY", function(module, exports) {

$parcel$export(module.exports, "defaultAxisId", () => $177f608375879b5a$export$e43f7367e579f53d);
$parcel$export(module.exports, "addXAxis", () => $177f608375879b5a$export$add6226ad7812fc8);
$parcel$export(module.exports, "replaceXAxis", () => $177f608375879b5a$export$40aac341c282a543);
$parcel$export(module.exports, "removeXAxis", () => $177f608375879b5a$export$f408189458c6a79b);
$parcel$export(module.exports, "addYAxis", () => $177f608375879b5a$export$4ed10a19d7febea1);
$parcel$export(module.exports, "replaceYAxis", () => $177f608375879b5a$export$58b7fa4a7d4572f6);
$parcel$export(module.exports, "removeYAxis", () => $177f608375879b5a$export$79db5e9bd25f14c4);
$parcel$export(module.exports, "updateYAxisWidth", () => $177f608375879b5a$export$6e42dbbf4e5a5faa);
$parcel$export(module.exports, "updateXAxisHeight", () => $177f608375879b5a$export$8d2a54a9a85ffb1b);
$parcel$export(module.exports, "cartesianAxisReducer", () => $177f608375879b5a$export$c8ae79f5f6ae07c6);

var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");
function $177f608375879b5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $177f608375879b5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $177f608375879b5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $177f608375879b5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $177f608375879b5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $177f608375879b5a$var$_defineProperty(e, r, t) {
    return (r = $177f608375879b5a$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $177f608375879b5a$var$_toPropertyKey(t) {
    var i = $177f608375879b5a$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $177f608375879b5a$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $177f608375879b5a$export$e43f7367e579f53d = 0;
/**
 * Properties shared in X, Y, and Z axes.
 * User defined axis settings, coming from props.
 */ /**
 * Controls how Recharts calculates "nice" tick values for numerical axes.
 *
 * - `'none'`: Recharts does not apply any tick-rounding algorithm; tick positions are
 *   determined entirely by d3, evenly spaced but not rounded to human-friendly numbers.
 *   There is no domain-extension logic applied in this mode.
 *
 * - `'auto'` *(default)*: Recharts automatically decides whether and how to apply tick
 *   niceties based on the domain definition. When the domain contains an `'auto'` keyword,
 *   Recharts uses the `'adaptive'` algorithm and may extend the domain slightly to
 *   produce clean tick labels. Otherwise, it applies the same algorithm while keeping
 *   ticks within the fixed domain. This mirrors the default behavior from Recharts v2.
 *
 * - `'adaptive'`: Always applies the space-efficient algorithm (`getAdaptiveStep`),
 *   which fills the available range as densely as possible while still rounding steps
 *   to reasonable numbers (e.g. 10, 20, 25). May produce less "round-looking" labels
 *   than `'snap125'`, but wastes less space. The domain-extension logic still applies
 *   when the domain contains an `'auto'` keyword.
 *
 * - `'snap125'`: Always applies the round-numbers algorithm (`getSnap125Step`), which
 *   snaps step sizes to values from the set {1, 2, 2.5, 5} × 10ⁿ. Produces very
 *   human-friendly labels (e.g. 0, 5, 10, 15, 20) but may leave blank space at the
 *   edges of the chart. The domain-extension logic still applies when the domain
 *   contains an `'auto'` keyword.
 *
 * @see {@link https://recharts.github.io/guide/axisTicks/}
 * @inline
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var $177f608375879b5a$var$initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var $177f608375879b5a$var$cartesianAxisSlice = (0, $jDald.createSlice)({
    name: 'cartesianAxis',
    initialState: $177f608375879b5a$var$initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, $83c4x.castDraft)(action.payload);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var _action$payload = action.payload, prev = _action$payload.prev, next = _action$payload.next;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, $83c4x.castDraft)(next);
                }
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, $83c4x.castDraft)(action.payload);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var _action$payload2 = action.payload, prev = _action$payload2.prev, next = _action$payload2.next;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, $83c4x.castDraft)(next);
                }
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, $83c4x.castDraft)(action.payload);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var _action$payload3 = action.payload, prev = _action$payload3.prev, next = _action$payload3.next;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, $83c4x.castDraft)(next);
                }
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        updateYAxisWidth (state, action) {
            var _action$payload4 = action.payload, id = _action$payload4.id, width = _action$payload4.width;
            var axis = state.yAxis[id];
            if (axis) {
                var _history$;
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - ((_history$ = history[0]) !== null && _history$ !== void 0 ? _history$ : 0)) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = $177f608375879b5a$var$_objectSpread($177f608375879b5a$var$_objectSpread({}, axis), {}, {
                    width: width,
                    widthHistory: newHistory
                });
            }
        },
        updateXAxisHeight (state, action) {
            var _action$payload5 = action.payload, id = _action$payload5.id, height = _action$payload5.height;
            var axis = state.xAxis[id];
            if (axis) {
                var _history$2;
                var history = axis.heightHistory || [];
                // An oscillation is detected when the new height is the same as the height before the last one.
                // This is a simple A -> B -> A pattern. If the next height is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && height === history[1] && height !== axis.height && Math.abs(height - ((_history$2 = history[0]) !== null && _history$2 !== void 0 ? _history$2 : 0)) <= 1) return;
                var newHistory = [
                    ...history,
                    height
                ].slice(-3);
                state.xAxis[id] = $177f608375879b5a$var$_objectSpread($177f608375879b5a$var$_objectSpread({}, axis), {}, {
                    height: height,
                    heightHistory: newHistory
                });
            }
        }
    }
});
var $177f608375879b5a$var$_cartesianAxisSlice$a = $177f608375879b5a$var$cartesianAxisSlice.actions, $177f608375879b5a$export$add6226ad7812fc8 = $177f608375879b5a$var$_cartesianAxisSlice$a.addXAxis, $177f608375879b5a$export$40aac341c282a543 = $177f608375879b5a$var$_cartesianAxisSlice$a.replaceXAxis, $177f608375879b5a$export$f408189458c6a79b = $177f608375879b5a$var$_cartesianAxisSlice$a.removeXAxis, $177f608375879b5a$export$4ed10a19d7febea1 = $177f608375879b5a$var$_cartesianAxisSlice$a.addYAxis, $177f608375879b5a$export$58b7fa4a7d4572f6 = $177f608375879b5a$var$_cartesianAxisSlice$a.replaceYAxis, $177f608375879b5a$export$79db5e9bd25f14c4 = $177f608375879b5a$var$_cartesianAxisSlice$a.removeYAxis, $177f608375879b5a$export$1c8a1319a1571880 = $177f608375879b5a$var$_cartesianAxisSlice$a.addZAxis, $177f608375879b5a$export$ad147e7505520476 = $177f608375879b5a$var$_cartesianAxisSlice$a.replaceZAxis, $177f608375879b5a$export$d823f07ec1da7041 = $177f608375879b5a$var$_cartesianAxisSlice$a.removeZAxis, $177f608375879b5a$export$6e42dbbf4e5a5faa = $177f608375879b5a$var$_cartesianAxisSlice$a.updateYAxisWidth, $177f608375879b5a$export$8d2a54a9a85ffb1b = $177f608375879b5a$var$_cartesianAxisSlice$a.updateXAxisHeight;
var $177f608375879b5a$export$c8ae79f5f6ae07c6 = $177f608375879b5a$var$cartesianAxisSlice.reducer;

});

parcelRegister("a0t9F", function(module, exports) {

$parcel$export(module.exports, "addCartesianGraphicalItem", () => $7490850bee546723$export$3f947cc833f5129c);
$parcel$export(module.exports, "replaceCartesianGraphicalItem", () => $7490850bee546723$export$5e4d82f2e2775795);
$parcel$export(module.exports, "removeCartesianGraphicalItem", () => $7490850bee546723$export$cc47a48755a91e1a);
$parcel$export(module.exports, "addPolarGraphicalItem", () => $7490850bee546723$export$468d47d44d0e088f);
$parcel$export(module.exports, "removePolarGraphicalItem", () => $7490850bee546723$export$77442a5b47e92750);
$parcel$export(module.exports, "replacePolarGraphicalItem", () => $7490850bee546723$export$bf660020894c8833);
$parcel$export(module.exports, "graphicalItemsReducer", () => $7490850bee546723$export$183eecd5cb7dbb38);

var $jDald = parcelRequire("jDald");
var $83c4x = parcelRequire("83c4x");

var $83c4x = parcelRequire("83c4x");
/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var $7490850bee546723$var$initialState = {
    cartesianItems: [],
    polarItems: []
};
var $7490850bee546723$var$graphicalItemsSlice = (0, $jDald.createSlice)({
    name: 'graphicalItems',
    initialState: $7490850bee546723$var$initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, $83c4x.castDraft)(action.payload));
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var _action$payload = action.payload, prev = _action$payload.prev, next = _action$payload.next;
                var index = (0, $83c4x.current)(state).cartesianItems.indexOf((0, $83c4x.castDraft)(prev));
                if (index > -1) state.cartesianItems[index] = (0, $83c4x.castDraft)(next);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, $83c4x.current)(state).cartesianItems.indexOf((0, $83c4x.castDraft)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, $83c4x.castDraft)(action.payload));
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, $83c4x.current)(state).polarItems.indexOf((0, $83c4x.castDraft)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replacePolarGraphicalItem: {
            reducer (state, action) {
                var _action$payload2 = action.payload, prev = _action$payload2.prev, next = _action$payload2.next;
                var index = (0, $83c4x.current)(state).polarItems.indexOf((0, $83c4x.castDraft)(prev));
                if (index > -1) state.polarItems[index] = (0, $83c4x.castDraft)(next);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        }
    }
});
var $7490850bee546723$var$_graphicalItemsSlice$ = $7490850bee546723$var$graphicalItemsSlice.actions, $7490850bee546723$export$3f947cc833f5129c = $7490850bee546723$var$_graphicalItemsSlice$.addCartesianGraphicalItem, $7490850bee546723$export$5e4d82f2e2775795 = $7490850bee546723$var$_graphicalItemsSlice$.replaceCartesianGraphicalItem, $7490850bee546723$export$cc47a48755a91e1a = $7490850bee546723$var$_graphicalItemsSlice$.removeCartesianGraphicalItem, $7490850bee546723$export$468d47d44d0e088f = $7490850bee546723$var$_graphicalItemsSlice$.addPolarGraphicalItem, $7490850bee546723$export$77442a5b47e92750 = $7490850bee546723$var$_graphicalItemsSlice$.removePolarGraphicalItem, $7490850bee546723$export$bf660020894c8833 = $7490850bee546723$var$_graphicalItemsSlice$.replacePolarGraphicalItem;
var $7490850bee546723$export$183eecd5cb7dbb38 = $7490850bee546723$var$graphicalItemsSlice.reducer;

});

parcelRegister("3PuQ3", function(module, exports) {

$parcel$export(module.exports, "referenceElementsReducer", () => $2c9e0e659123dd04$export$f30a87c263d1acf8);

var $jDald = parcelRequire("jDald");
var $83c4x = parcelRequire("83c4x");

var $83c4x = parcelRequire("83c4x");
var $2c9e0e659123dd04$var$initialState = {
    dots: [],
    areas: [],
    lines: []
};
var $2c9e0e659123dd04$export$cbde679baaad2c79 = (0, $jDald.createSlice)({
    name: 'referenceElements',
    initialState: $2c9e0e659123dd04$var$initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, $83c4x.current)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, $83c4x.current)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, $83c4x.castDraft)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, $83c4x.current)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var $2c9e0e659123dd04$var$_referenceElementsSli = $2c9e0e659123dd04$export$cbde679baaad2c79.actions, $2c9e0e659123dd04$export$9be8ef3add1f8c1e = $2c9e0e659123dd04$var$_referenceElementsSli.addDot, $2c9e0e659123dd04$export$57ff7495ce685163 = $2c9e0e659123dd04$var$_referenceElementsSli.removeDot, $2c9e0e659123dd04$export$d604a18565cfc1b3 = $2c9e0e659123dd04$var$_referenceElementsSli.addArea, $2c9e0e659123dd04$export$a8da2ad4123475fe = $2c9e0e659123dd04$var$_referenceElementsSli.removeArea, $2c9e0e659123dd04$export$a9ce8e8146745e3e = $2c9e0e659123dd04$var$_referenceElementsSli.addLine, $2c9e0e659123dd04$export$fd7919a5491769ec = $2c9e0e659123dd04$var$_referenceElementsSli.removeLine;
var $2c9e0e659123dd04$export$f30a87c263d1acf8 = $2c9e0e659123dd04$export$cbde679baaad2c79.reducer;

});

parcelRegister("gPow5", function(module, exports) {

$parcel$export(module.exports, "brushReducer", () => $c4046d366b5068fc$export$b8c9ca32ee9dbf92);

var $jDald = parcelRequire("jDald");
/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var $c4046d366b5068fc$var$initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var $c4046d366b5068fc$export$d64e835ef4b0c23a = (0, $jDald.createSlice)({
    name: 'brush',
    initialState: $c4046d366b5068fc$var$initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return $c4046d366b5068fc$var$initialState;
            return action.payload;
        }
    }
});
var $c4046d366b5068fc$export$1860ec7d971c6a5b = $c4046d366b5068fc$export$d64e835ef4b0c23a.actions.setBrushSettings;
var $c4046d366b5068fc$export$b8c9ca32ee9dbf92 = $c4046d366b5068fc$export$d64e835ef4b0c23a.reducer;

});

parcelRegister("sP5sX", function(module, exports) {

$parcel$export(module.exports, "addLegendPayload", () => $056a3e7c624b08cd$export$236fd33b6ffe3f4b);
$parcel$export(module.exports, "replaceLegendPayload", () => $056a3e7c624b08cd$export$379d42d798953c3d);
$parcel$export(module.exports, "removeLegendPayload", () => $056a3e7c624b08cd$export$337e5f2bb3b9e128);
$parcel$export(module.exports, "legendReducer", () => $056a3e7c624b08cd$export$8d8dfb8d5acf8179);

var $jDald = parcelRequire("jDald");
var $83c4x = parcelRequire("83c4x");

var $83c4x = parcelRequire("83c4x");
/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var $056a3e7c624b08cd$var$initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        itemSorter: 'value',
        position: undefined,
        offset: 0
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var $056a3e7c624b08cd$var$legendSlice = (0, $jDald.createSlice)({
    name: 'legend',
    initialState: $056a3e7c624b08cd$var$initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
            state.settings.position = action.payload.position;
            state.settings.offset = action.payload.offset;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, $83c4x.castDraft)(action.payload));
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var _action$payload = action.payload, prev = _action$payload.prev, next = _action$payload.next;
                var index = (0, $83c4x.current)(state).payload.indexOf((0, $83c4x.castDraft)(prev));
                if (index > -1) state.payload[index] = (0, $83c4x.castDraft)(next);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, $83c4x.current)(state).payload.indexOf((0, $83c4x.castDraft)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        }
    }
});
var $056a3e7c624b08cd$var$_legendSlice$actions = $056a3e7c624b08cd$var$legendSlice.actions, $056a3e7c624b08cd$export$f9ba9ab9b90c340e = $056a3e7c624b08cd$var$_legendSlice$actions.setLegendSize, $056a3e7c624b08cd$export$a1a647a9c0dcc839 = $056a3e7c624b08cd$var$_legendSlice$actions.setLegendSettings, $056a3e7c624b08cd$export$236fd33b6ffe3f4b = $056a3e7c624b08cd$var$_legendSlice$actions.addLegendPayload, $056a3e7c624b08cd$export$379d42d798953c3d = $056a3e7c624b08cd$var$_legendSlice$actions.replaceLegendPayload, $056a3e7c624b08cd$export$337e5f2bb3b9e128 = $056a3e7c624b08cd$var$_legendSlice$actions.removeLegendPayload;
var $056a3e7c624b08cd$export$8d8dfb8d5acf8179 = $056a3e7c624b08cd$var$legendSlice.reducer;

});

parcelRegister("et7NI", function(module, exports) {

$parcel$export(module.exports, "rootPropsReducer", () => $a889d3323d3ea0c2$export$291d6468e221147e);
$parcel$export(module.exports, "updateOptions", () => $a889d3323d3ea0c2$export$c6fe4049d20353ac);

var $jDald = parcelRequire("jDald");
var $a889d3323d3ea0c2$export$d4c72bab9d6cc13a = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var $a889d3323d3ea0c2$var$rootPropsSlice = (0, $jDald.createSlice)({
    name: 'rootProps',
    initialState: $a889d3323d3ea0c2$export$d4c72bab9d6cc13a,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : $a889d3323d3ea0c2$export$d4c72bab9d6cc13a.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var $a889d3323d3ea0c2$export$291d6468e221147e = $a889d3323d3ea0c2$var$rootPropsSlice.reducer;
var $a889d3323d3ea0c2$export$c6fe4049d20353ac = $a889d3323d3ea0c2$var$rootPropsSlice.actions.updateOptions;

});

parcelRegister("a5RMg", function(module, exports) {

$parcel$export(module.exports, "polarAxisReducer", () => $75941617e5c22485$export$97e65520f1278b5);

var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");
var $75941617e5c22485$var$initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var $75941617e5c22485$var$polarAxisSlice = (0, $jDald.createSlice)({
    name: 'polarAxis',
    initialState: $75941617e5c22485$var$initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, $83c4x.castDraft)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, $83c4x.castDraft)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var $75941617e5c22485$var$_polarAxisSlice$actio = $75941617e5c22485$var$polarAxisSlice.actions, $75941617e5c22485$export$3555d359361c9fe3 = $75941617e5c22485$var$_polarAxisSlice$actio.addRadiusAxis, $75941617e5c22485$export$104b2ce9f0baf86f = $75941617e5c22485$var$_polarAxisSlice$actio.removeRadiusAxis, $75941617e5c22485$export$bf871b0db8674238 = $75941617e5c22485$var$_polarAxisSlice$actio.addAngleAxis, $75941617e5c22485$export$d540ed209cfbb147 = $75941617e5c22485$var$_polarAxisSlice$actio.removeAngleAxis;
var $75941617e5c22485$export$97e65520f1278b5 = $75941617e5c22485$var$polarAxisSlice.reducer;

});

parcelRegister("i8m83", function(module, exports) {

$parcel$export(module.exports, "updatePolarOptions", () => $d33a23b3ebfb586d$export$5dfe4dcb848af93f);
$parcel$export(module.exports, "polarOptionsReducer", () => $d33a23b3ebfb586d$export$8d4054f1936f7f4d);

var $jDald = parcelRequire("jDald");
var $d33a23b3ebfb586d$var$initialState = null;
var $d33a23b3ebfb586d$var$reducers = {
    updatePolarOptions: (state, action)=>{
        if (state === null) return action.payload;
        state.startAngle = action.payload.startAngle;
        state.endAngle = action.payload.endAngle;
        state.cx = action.payload.cx;
        state.cy = action.payload.cy;
        state.innerRadius = action.payload.innerRadius;
        state.outerRadius = action.payload.outerRadius;
        return state;
    }
};
var $d33a23b3ebfb586d$var$polarOptionsSlice = (0, $jDald.createSlice)({
    name: 'polarOptions',
    initialState: $d33a23b3ebfb586d$var$initialState,
    reducers: $d33a23b3ebfb586d$var$reducers
});
var $d33a23b3ebfb586d$export$5dfe4dcb848af93f = $d33a23b3ebfb586d$var$polarOptionsSlice.actions.updatePolarOptions;
var $d33a23b3ebfb586d$export$8d4054f1936f7f4d = $d33a23b3ebfb586d$var$polarOptionsSlice.reducer;

});

parcelRegister("9xSsq", function(module, exports) {

$parcel$export(module.exports, "keyDownAction", () => $6f317037c3555952$export$4839538efb7414c);
$parcel$export(module.exports, "focusAction", () => $6f317037c3555952$export$d95192eee5865567);
$parcel$export(module.exports, "blurAction", () => $6f317037c3555952$export$af52bfdff6fb5bd7);
$parcel$export(module.exports, "keyboardEventsMiddleware", () => $6f317037c3555952$export$b4d762ee62ea3f99);

var $jDald = parcelRequire("jDald");

var $58RF9 = parcelRequire("58RF9");

var $71i43 = parcelRequire("71i43");

var $72R3N = parcelRequire("72R3N");

var $99P3O = parcelRequire("99P3O");

var $czuyh = parcelRequire("czuyh");

var $2Ron6 = parcelRequire("2Ron6");
var $6f317037c3555952$export$4839538efb7414c = (0, $jDald.createAction)('keyDown');
var $6f317037c3555952$export$d95192eee5865567 = (0, $jDald.createAction)('focus');
var $6f317037c3555952$export$af52bfdff6fb5bd7 = (0, $jDald.createAction)('blur');
var $6f317037c3555952$export$b4d762ee62ea3f99 = (0, $jDald.createListenerMiddleware)();
var $6f317037c3555952$var$rafId = null;
var $6f317037c3555952$var$timeoutId = null;
var $6f317037c3555952$var$latestKeyboardActionPayload = null;
$6f317037c3555952$export$b4d762ee62ea3f99.startListening({
    actionCreator: $6f317037c3555952$export$4839538efb7414c,
    effect: (action, listenerApi)=>{
        $6f317037c3555952$var$latestKeyboardActionPayload = action.payload;
        if ($6f317037c3555952$var$rafId !== null) {
            cancelAnimationFrame($6f317037c3555952$var$rafId);
            $6f317037c3555952$var$rafId = null;
        }
        var state = listenerApi.getState();
        var _state$eventSettings = state.eventSettings, throttleDelay = _state$eventSettings.throttleDelay, throttledEvents = _state$eventSettings.throttledEvents;
        var isThrottled = throttledEvents === 'all' || throttledEvents.includes('keydown');
        if ($6f317037c3555952$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($6f317037c3555952$var$timeoutId);
            $6f317037c3555952$var$timeoutId = null;
        }
        var callback = ()=>{
            try {
                var currentState = listenerApi.getState();
                var accessibilityLayerIsActive = currentState.rootProps.accessibilityLayer !== false;
                if (!accessibilityLayerIsActive) return;
                var keyboardInteraction = currentState.tooltip.keyboardInteraction;
                var key = $6f317037c3555952$var$latestKeyboardActionPayload;
                if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
                // TODO this is lacking index for charts that do not support numeric indexes
                var resolvedIndex = (0, $czuyh.combineActiveTooltipIndex)(keyboardInteraction, (0, $71i43.selectTooltipDisplayedData)(currentState), (0, $99P3O.selectTooltipAxisDataKey)(currentState), (0, $71i43.selectTooltipAxisDomain)(currentState));
                var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
                var isOutsideDomain = !Number.isFinite(currentIndex) || currentIndex < 0;
                var tooltipTicks = (0, $71i43.selectTooltipAxisTicks)(currentState);
                var displayedData = (0, $71i43.selectTooltipDisplayedData)(currentState);
                var tooltipEventType = (0, $2Ron6.selectTooltipEventType)(currentState, currentState.tooltip.settings.shared);
                if (key === 'Enter') {
                    if (isOutsideDomain) return;
                    var _coordinate = (0, $72R3N.selectCoordinateForDefaultIndex)(currentState, tooltipEventType, 'hover', String(keyboardInteraction.index));
                    listenerApi.dispatch((0, $58RF9.setKeyboardInteraction)({
                        active: !keyboardInteraction.active,
                        activeIndex: keyboardInteraction.index,
                        activeCoordinate: _coordinate
                    }));
                    return;
                }
                var direction = (0, $99P3O.selectChartDirection)(currentState);
                var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
                var movement = key === 'ArrowRight' ? 1 : -1;
                var nextIndex;
                if (isOutsideDomain) {
                    var axisDataKey = (0, $99P3O.selectTooltipAxisDataKey)(currentState);
                    var domain = (0, $71i43.selectTooltipAxisDomain)(currentState);
                    var effectiveMovement = movement * directionMultiplier;
                    // Build a minimal TooltipInteractionState for the candidate-index check.
                    var mkInteraction = (i)=>({
                            active: false,
                            index: String(i),
                            dataKey: undefined,
                            graphicalItemId: undefined,
                            coordinate: undefined
                        });
                    nextIndex = -1;
                    if (effectiveMovement > 0) {
                        for(var i = 0; i < displayedData.length; i++)if ((0, $czuyh.combineActiveTooltipIndex)(mkInteraction(i), displayedData, axisDataKey, domain) != null) {
                            nextIndex = i;
                            break;
                        }
                    } else {
                        for(var _i = displayedData.length - 1; _i >= 0; _i--)if ((0, $czuyh.combineActiveTooltipIndex)(mkInteraction(_i), displayedData, axisDataKey, domain) != null) {
                            nextIndex = _i;
                            break;
                        }
                    }
                    if (nextIndex < 0) return;
                } else {
                    nextIndex = currentIndex + movement * directionMultiplier;
                    var dataLength = (tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks.length) || displayedData.length;
                    if (dataLength === 0 || nextIndex >= dataLength || nextIndex < 0) return;
                }
                var coordinate = (0, $72R3N.selectCoordinateForDefaultIndex)(currentState, tooltipEventType, 'hover', String(nextIndex));
                listenerApi.dispatch((0, $58RF9.setKeyboardInteraction)({
                    active: true,
                    activeIndex: nextIndex.toString(),
                    activeCoordinate: coordinate
                }));
            } finally{
                $6f317037c3555952$var$rafId = null;
                $6f317037c3555952$var$timeoutId = null;
            }
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $6f317037c3555952$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($6f317037c3555952$var$timeoutId === null) {
                callback();
                $6f317037c3555952$var$latestKeyboardActionPayload = null;
                $6f317037c3555952$var$timeoutId = setTimeout(()=>{
                    if ($6f317037c3555952$var$latestKeyboardActionPayload) callback();
                    else {
                        $6f317037c3555952$var$timeoutId = null;
                        $6f317037c3555952$var$rafId = null;
                    }
                }, throttleDelay);
            }
        }
    }
});
$6f317037c3555952$export$b4d762ee62ea3f99.startListening({
    actionCreator: $6f317037c3555952$export$d95192eee5865567,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var keyboardInteraction = state.tooltip.keyboardInteraction;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var tooltipEventType = (0, $2Ron6.selectTooltipEventType)(state, state.tooltip.settings.shared);
            var coordinate = (0, $72R3N.selectCoordinateForDefaultIndex)(state, tooltipEventType, 'hover', String(nextIndex));
            listenerApi.dispatch((0, $58RF9.setKeyboardInteraction)({
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});
$6f317037c3555952$export$b4d762ee62ea3f99.startListening({
    actionCreator: $6f317037c3555952$export$af52bfdff6fb5bd7,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var keyboardInteraction = state.tooltip.keyboardInteraction;
        if (keyboardInteraction.active) listenerApi.dispatch((0, $58RF9.setKeyboardInteraction)({
            active: false,
            activeIndex: keyboardInteraction.index,
            activeCoordinate: keyboardInteraction.coordinate
        }));
    }
});

});

parcelRegister("acoL1", function(module, exports) {

$parcel$export(module.exports, "externalEventAction", () => $76ce3aa82d5f6fc2$export$1d0268b9f89859f0);
$parcel$export(module.exports, "externalEventsMiddleware", () => $76ce3aa82d5f6fc2$export$3c5d447f046d0ec3);

var $jDald = parcelRequire("jDald");

var $71i43 = parcelRequire("71i43");

var $lqNsR = parcelRequire("lqNsR");
var $76ce3aa82d5f6fc2$export$1d0268b9f89859f0 = (0, $jDald.createAction)('externalEvent');
var $76ce3aa82d5f6fc2$export$3c5d447f046d0ec3 = (0, $jDald.createListenerMiddleware)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var $76ce3aa82d5f6fc2$var$rafIdMap = new Map();
var $76ce3aa82d5f6fc2$var$timeoutIdMap = new Map();
var $76ce3aa82d5f6fc2$var$latestEventMap = new Map();
$76ce3aa82d5f6fc2$export$3c5d447f046d0ec3.startListening({
    actionCreator: $76ce3aa82d5f6fc2$export$1d0268b9f89859f0,
    effect: (action, listenerApi)=>{
        var _action$payload = action.payload, handler = _action$payload.handler, reactEvent = _action$payload.reactEvent;
        if (handler == null) return;
        var eventType = reactEvent.type;
        var eventProxy = (0, $lqNsR.createEventProxy)(reactEvent);
        $76ce3aa82d5f6fc2$var$latestEventMap.set(eventType, {
            handler: handler,
            reactEvent: eventProxy
        });
        // Cancel any pending execution for this event type
        var existingRafId = $76ce3aa82d5f6fc2$var$rafIdMap.get(eventType);
        if (existingRafId !== undefined) {
            cancelAnimationFrame(existingRafId);
            $76ce3aa82d5f6fc2$var$rafIdMap.delete(eventType);
        }
        var state = listenerApi.getState();
        var _state$eventSettings = state.eventSettings, throttleDelay = _state$eventSettings.throttleDelay, throttledEvents = _state$eventSettings.throttledEvents;
        /*
     * reactEvent.type gives us the event type as a string, e.g., 'click', 'mousemove', etc.
     * which is the same as the names used in throttledEvents array
     * but that array is strictly typed as ReadonlyArray<keyof GlobalEventHandlersEventMap> | 'all' | undefined
     * so that we can have relevant autocomplete and type checking elsewhere.
     * This makes TypeScript panic because it refuses to call .includes() on ReadonlyArray<keyof GlobalEventHandlersEventMap>
     * with a string argument.
     * To satisfy TypeScript, we need to explicitly typecast throttledEvents here.
     */ var eventListAsString = throttledEvents;
        // Check if this event type should be throttled
        // throttledEvents can be 'all' or an array of event names
        var isThrottled = eventListAsString === 'all' || (eventListAsString === null || eventListAsString === void 0 ? void 0 : eventListAsString.includes(eventType));
        var existingTimeoutId = $76ce3aa82d5f6fc2$var$timeoutIdMap.get(eventType);
        if (existingTimeoutId !== undefined && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout(existingTimeoutId);
            $76ce3aa82d5f6fc2$var$timeoutIdMap.delete(eventType);
        }
        var callback = ()=>{
            var latestAction = $76ce3aa82d5f6fc2$var$latestEventMap.get(eventType);
            try {
                if (!latestAction) // This happens if the event was consumed by the leading edge and no new event came in
                return;
                var latestHandler = latestAction.handler, latestEvent = latestAction.reactEvent;
                var currentState = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, $71i43.selectActiveTooltipCoordinate)(currentState),
                    activeDataKey: (0, $71i43.selectActiveTooltipDataKey)(currentState),
                    activeIndex: (0, $71i43.selectActiveTooltipIndex)(currentState),
                    activeLabel: (0, $71i43.selectActiveLabel)(currentState),
                    activeTooltipIndex: (0, $71i43.selectActiveTooltipIndex)(currentState),
                    isTooltipActive: (0, $71i43.selectIsTooltipActive)(currentState)
                };
                if (latestHandler) latestHandler(nextState, latestEvent);
            } finally{
                $76ce3aa82d5f6fc2$var$rafIdMap.delete(eventType);
                $76ce3aa82d5f6fc2$var$timeoutIdMap.delete(eventType);
                $76ce3aa82d5f6fc2$var$latestEventMap.delete(eventType);
            }
        };
        if (!isThrottled) {
            // Execute immediately
            callback();
            return;
        }
        if (throttleDelay === 'raf') {
            var rafId = requestAnimationFrame(callback);
            $76ce3aa82d5f6fc2$var$rafIdMap.set(eventType, rafId);
        } else if (typeof throttleDelay === 'number') {
            if (!$76ce3aa82d5f6fc2$var$timeoutIdMap.has(eventType)) {
                /*
         * Leading edge execution - execute immediately on the first event
         * and then start the cooldown period to throttle subsequent events.
         */ callback();
                // Start cooldown
                var timeoutId = setTimeout(callback, throttleDelay);
                $76ce3aa82d5f6fc2$var$timeoutIdMap.set(eventType, timeoutId);
            }
        } else // Should not happen based on type, but fallback to immediate
        callback();
    }
});

});
parcelRegister("lqNsR", function(module, exports) {

$parcel$export(module.exports, "createEventProxy", () => $f9a2654c9e31aa1e$export$5c057f9c005183bb);
function $f9a2654c9e31aa1e$export$5c057f9c005183bb(reactEvent) {
    reactEvent.persist();
    var currentTarget = reactEvent.currentTarget;
    return new Proxy(reactEvent, {
        get: (target, prop)=>{
            if (prop === 'currentTarget') return currentTarget;
            var value = Reflect.get(target, prop);
            if (typeof value === 'function') return value.bind(target);
            return value;
        }
    });
}

});


parcelRegister("1PNrQ", function(module, exports) {

$parcel$export(module.exports, "touchEventAction", () => $1560e93fcb4e9208$export$ba46b5fda0e2985f);
$parcel$export(module.exports, "touchEventMiddleware", () => $1560e93fcb4e9208$export$923ceddc5a79736a);

var $jDald = parcelRequire("jDald");

var $58RF9 = parcelRequire("58RF9");

var $6fQDv = parcelRequire("6fQDv");

var $grYi3 = parcelRequire("grYi3");

var $2Ron6 = parcelRequire("2Ron6");

var $lcI2N = parcelRequire("lcI2N");

var $ctGWH = parcelRequire("ctGWH");

var $71i43 = parcelRequire("71i43");

var $lqNsR = parcelRequire("lqNsR");
var $1560e93fcb4e9208$export$ba46b5fda0e2985f = (0, $jDald.createAction)('touchMove');
var $1560e93fcb4e9208$export$923ceddc5a79736a = (0, $jDald.createListenerMiddleware)();
var $1560e93fcb4e9208$var$rafId = null;
var $1560e93fcb4e9208$var$timeoutId = null;
var $1560e93fcb4e9208$var$latestChartPointers = null;
var $1560e93fcb4e9208$var$latestTouchEvent = null;
$1560e93fcb4e9208$export$923ceddc5a79736a.startListening({
    actionCreator: $1560e93fcb4e9208$export$ba46b5fda0e2985f,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        $1560e93fcb4e9208$var$latestTouchEvent = (0, $lqNsR.createEventProxy)(touchEvent);
        var state = listenerApi.getState();
        var _state$eventSettings = state.eventSettings, throttleDelay = _state$eventSettings.throttleDelay, throttledEvents = _state$eventSettings.throttledEvents;
        var isThrottled = throttledEvents === 'all' || throttledEvents.includes('touchmove');
        if ($1560e93fcb4e9208$var$rafId !== null) {
            cancelAnimationFrame($1560e93fcb4e9208$var$rafId);
            $1560e93fcb4e9208$var$rafId = null;
        }
        if ($1560e93fcb4e9208$var$timeoutId !== null && (typeof throttleDelay !== 'number' || !isThrottled)) {
            clearTimeout($1560e93fcb4e9208$var$timeoutId);
            $1560e93fcb4e9208$var$timeoutId = null;
        }
        $1560e93fcb4e9208$var$latestChartPointers = Array.from(touchEvent.touches).map((touch)=>(0, $grYi3.getRelativeCoordinate)({
                clientX: touch.clientX,
                clientY: touch.clientY,
                currentTarget: touchEvent.currentTarget
            }));
        var callback = ()=>{
            if ($1560e93fcb4e9208$var$latestTouchEvent == null) return;
            var currentState = listenerApi.getState();
            var tooltipEventType = (0, $2Ron6.selectTooltipEventType)(currentState, currentState.tooltip.settings.shared);
            if (tooltipEventType === 'axis') {
                var _latestChartPointers;
                var latestTouchPointer = (_latestChartPointers = $1560e93fcb4e9208$var$latestChartPointers) === null || _latestChartPointers === void 0 ? void 0 : _latestChartPointers[0];
                if (latestTouchPointer == null) {
                    $1560e93fcb4e9208$var$rafId = null;
                    $1560e93fcb4e9208$var$timeoutId = null;
                    return;
                }
                var activeProps = (0, $6fQDv.selectActivePropsFromChartPointer)(currentState, latestTouchPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, $58RF9.setMouseOverAxisIndex)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
            } else if (tooltipEventType === 'item') {
                var _target$getAttribute;
                var touch = $1560e93fcb4e9208$var$latestTouchEvent.touches[0];
                if (document.elementFromPoint == null || touch == null) return;
                var target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (!target || !target.getAttribute) return;
                var itemIndex = target.getAttribute((0, $lcI2N.DATA_ITEM_INDEX_ATTRIBUTE_NAME));
                var graphicalItemId = (_target$getAttribute = target.getAttribute((0, $lcI2N.DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
                var settings = (0, $71i43.selectAllGraphicalItemsSettings)(currentState).find((item)=>item.id === graphicalItemId);
                if (itemIndex == null || settings == null || graphicalItemId == null) return;
                var dataKey = settings.dataKey;
                var coordinate = (0, $ctGWH.selectTooltipCoordinate)(currentState, itemIndex, graphicalItemId);
                listenerApi.dispatch((0, $58RF9.setActiveMouseOverItemIndex)({
                    activeDataKey: dataKey,
                    activeIndex: itemIndex,
                    activeCoordinate: coordinate,
                    activeGraphicalItemId: graphicalItemId
                }));
            }
            $1560e93fcb4e9208$var$rafId = null;
            $1560e93fcb4e9208$var$timeoutId = null;
        };
        if (!isThrottled) {
            callback();
            return;
        }
        if (throttleDelay === 'raf') $1560e93fcb4e9208$var$rafId = requestAnimationFrame(callback);
        else if (typeof throttleDelay === 'number') {
            if ($1560e93fcb4e9208$var$timeoutId === null) {
                callback();
                $1560e93fcb4e9208$var$latestTouchEvent = null;
                $1560e93fcb4e9208$var$timeoutId = setTimeout(()=>{
                    if ($1560e93fcb4e9208$var$latestTouchEvent) callback();
                    else {
                        $1560e93fcb4e9208$var$timeoutId = null;
                        $1560e93fcb4e9208$var$rafId = null;
                    }
                }, throttleDelay);
            }
        }
    }
});

});
parcelRegister("ctGWH", function(module, exports) {

$parcel$export(module.exports, "selectTooltipCoordinate", () => $915981a107e1f6e9$export$4e32c9da1f3ea7ce);

var $b0nKR = parcelRequire("b0nKR");

var $ao1Kf = parcelRequire("ao1Kf");
var $915981a107e1f6e9$var$selectAllTooltipPayloadConfiguration = (0, $b0nKR.createSelector)([
    (0, $ao1Kf.selectTooltipState)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var $915981a107e1f6e9$export$4e32c9da1f3ea7ce = (0, $b0nKR.createSelector)([
    $915981a107e1f6e9$var$selectAllTooltipPayloadConfiguration,
    (_state, tooltipIndex)=>tooltipIndex,
    (_state, _tooltipIndex, graphicalItemId)=>graphicalItemId
], (allTooltipConfigurations, tooltipIndex, graphicalItemId)=>{
    if (tooltipIndex == null) return undefined;
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.graphicalItemId === graphicalItemId;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var getPosition = mostRelevantTooltipConfiguration.getPosition;
    if (getPosition == null) return undefined;
    return getPosition(tooltipIndex);
});

});


parcelRegister("dx7pp", function(module, exports) {

$parcel$export(module.exports, "addErrorBar", () => $9da41aabd5381b30$export$155912f95c88abac);
$parcel$export(module.exports, "replaceErrorBar", () => $9da41aabd5381b30$export$f1ebd3b9f70a9f5f);
$parcel$export(module.exports, "removeErrorBar", () => $9da41aabd5381b30$export$b0d2fb6a7d9d3b45);
$parcel$export(module.exports, "errorBarReducer", () => $9da41aabd5381b30$export$6dda85fa3c67ca19);

var $jDald = parcelRequire("jDald");
/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var $9da41aabd5381b30$var$initialState = {};
var $9da41aabd5381b30$var$errorBarSlice = (0, $jDald.createSlice)({
    name: 'errorBars',
    initialState: $9da41aabd5381b30$var$initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var _action$payload = action.payload, itemId = _action$payload.itemId, errorBar = _action$payload.errorBar;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var _action$payload2 = action.payload, itemId = _action$payload2.itemId, prev = _action$payload2.prev, next = _action$payload2.next;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var _action$payload3 = action.payload, itemId = _action$payload3.itemId, errorBar = _action$payload3.errorBar;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var $9da41aabd5381b30$var$_errorBarSlice$action = $9da41aabd5381b30$var$errorBarSlice.actions, $9da41aabd5381b30$export$155912f95c88abac = $9da41aabd5381b30$var$_errorBarSlice$action.addErrorBar, $9da41aabd5381b30$export$f1ebd3b9f70a9f5f = $9da41aabd5381b30$var$_errorBarSlice$action.replaceErrorBar, $9da41aabd5381b30$export$b0d2fb6a7d9d3b45 = $9da41aabd5381b30$var$_errorBarSlice$action.removeErrorBar;
var $9da41aabd5381b30$export$6dda85fa3c67ca19 = $9da41aabd5381b30$var$errorBarSlice.reducer;

});

parcelRegister("apNs5", function(module, exports) {

$parcel$export(module.exports, "Global", () => $795299547b24e258$export$98f03c5d19621d70);
var $795299547b24e258$var$parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var $795299547b24e258$export$98f03c5d19621d70 = {
    devToolsEnabled: true,
    isSsr: $795299547b24e258$var$parseIsSsrByDefault()
};

});

parcelRegister("3Zyvz", function(module, exports) {

$parcel$export(module.exports, "registerZIndexPortal", () => $2e81d63b6460b61d$export$8fe155db96cddace);
$parcel$export(module.exports, "unregisterZIndexPortal", () => $2e81d63b6460b61d$export$230718bd38635ccb);
$parcel$export(module.exports, "registerZIndexPortalElement", () => $2e81d63b6460b61d$export$2e6026208075bd4f);
$parcel$export(module.exports, "unregisterZIndexPortalElement", () => $2e81d63b6460b61d$export$b735943939e8125);
$parcel$export(module.exports, "zIndexReducer", () => $2e81d63b6460b61d$export$a34096cdea3a022a);

var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");

var $gKNgz = parcelRequire("gKNgz");
function $2e81d63b6460b61d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e81d63b6460b61d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e81d63b6460b61d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e81d63b6460b61d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e81d63b6460b61d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e81d63b6460b61d$var$_defineProperty(e, r, t) {
    return (r = $2e81d63b6460b61d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2e81d63b6460b61d$var$_toPropertyKey(t) {
    var i = $2e81d63b6460b61d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2e81d63b6460b61d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2e81d63b6460b61d$var$seed = {};
var $2e81d63b6460b61d$var$initialState = {
    zIndexMap: Object.values((0, $gKNgz.DefaultZIndexes)).reduce((acc, current)=>$2e81d63b6460b61d$var$_objectSpread($2e81d63b6460b61d$var$_objectSpread({}, acc), {}, {
            [current]: {
                element: undefined,
                panoramaElement: undefined,
                consumers: 0
            }
        }), $2e81d63b6460b61d$var$seed)
};
var $2e81d63b6460b61d$var$defaultZIndexSet = new Set(Object.values((0, $gKNgz.DefaultZIndexes)));
function $2e81d63b6460b61d$var$isDefaultZIndex(zIndex) {
    return $2e81d63b6460b61d$var$defaultZIndexSet.has(zIndex);
}
var $2e81d63b6460b61d$var$zIndexSlice = (0, $jDald.createSlice)({
    name: 'zIndex',
    initialState: $2e81d63b6460b61d$var$initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var zIndex = action.payload.zIndex;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    element: undefined,
                    panoramaElement: undefined
                };
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var zIndex = action.payload.zIndex;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !$2e81d63b6460b61d$var$isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        registerZIndexPortalElement: {
            reducer: (state, action)=>{
                var _action$payload = action.payload, zIndex = _action$payload.zIndex, element = _action$payload.element, isPanorama = _action$payload.isPanorama;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElement = (0, $83c4x.castDraft)(element);
                    else state.zIndexMap[zIndex].element = (0, $83c4x.castDraft)(element);
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    element: isPanorama ? undefined : (0, $83c4x.castDraft)(element),
                    panoramaElement: isPanorama ? (0, $83c4x.castDraft)(element) : undefined
                };
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        },
        unregisterZIndexPortalElement: {
            reducer: (state, action)=>{
                var zIndex = action.payload.zIndex;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElement = undefined;
                    else state.zIndexMap[zIndex].element = undefined;
                }
            },
            prepare: (0, $jDald.prepareAutoBatched)()
        }
    }
});
var $2e81d63b6460b61d$var$_zIndexSlice$actions = $2e81d63b6460b61d$var$zIndexSlice.actions, $2e81d63b6460b61d$export$8fe155db96cddace = $2e81d63b6460b61d$var$_zIndexSlice$actions.registerZIndexPortal, $2e81d63b6460b61d$export$230718bd38635ccb = $2e81d63b6460b61d$var$_zIndexSlice$actions.unregisterZIndexPortal, $2e81d63b6460b61d$export$2e6026208075bd4f = $2e81d63b6460b61d$var$_zIndexSlice$actions.registerZIndexPortalElement, $2e81d63b6460b61d$export$b735943939e8125 = $2e81d63b6460b61d$var$_zIndexSlice$actions.unregisterZIndexPortalElement;
var $2e81d63b6460b61d$export$a34096cdea3a022a = $2e81d63b6460b61d$var$zIndexSlice.reducer;

});

parcelRegister("j6mdh", function(module, exports) {

$parcel$export(module.exports, "initialEventSettingsState", () => $de7fceeccbb0f221$export$b8b957c7b621f147);
$parcel$export(module.exports, "setEventSettings", () => $de7fceeccbb0f221$export$ebdc8cd28e946f60);
$parcel$export(module.exports, "eventSettingsReducer", () => $de7fceeccbb0f221$export$8631319549a0b15);

var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");
var $de7fceeccbb0f221$export$b8b957c7b621f147 = {
    throttleDelay: 'raf',
    throttledEvents: [
        'mousemove',
        'touchmove',
        'pointermove',
        'scroll',
        'wheel'
    ]
};
var $de7fceeccbb0f221$var$eventSettingsSlice = (0, $jDald.createSlice)({
    name: 'eventSettings',
    initialState: $de7fceeccbb0f221$export$b8b957c7b621f147,
    reducers: {
        setEventSettings: (state, action)=>{
            if (action.payload.throttleDelay != null) state.throttleDelay = action.payload.throttleDelay;
            if (action.payload.throttledEvents != null) state.throttledEvents = (0, $83c4x.castDraft)(action.payload.throttledEvents);
        }
    }
});
var $de7fceeccbb0f221$export$ebdc8cd28e946f60 = $de7fceeccbb0f221$var$eventSettingsSlice.actions.setEventSettings;
var $de7fceeccbb0f221$export$8631319549a0b15 = $de7fceeccbb0f221$var$eventSettingsSlice.reducer;

});

parcelRegister("47yFs", function(module, exports) {

$parcel$export(module.exports, "setRenderedTicks", () => $3002b52b177bd9ac$export$9b96437af9e57ebe);
$parcel$export(module.exports, "removeRenderedTicks", () => $3002b52b177bd9ac$export$d8f6326ec092e260);
$parcel$export(module.exports, "renderedTicksReducer", () => $3002b52b177bd9ac$export$596b92009d4d7ccc);
/**
 * @fileOverview this stores actually rendered ticks.
 *
 * What we do is that we have the domain -> ticks mapping in the cartesianSlice,
 * which is fine but the result then goes to CartesianAxis where we use DOM measurement
 * to decide which ticks to actually render.
 *
 * This renderedTickSlice stores those actually rendered ticks so that we can return them from a hook later.
 */ 
var $jDald = parcelRequire("jDald");

var $83c4x = parcelRequire("83c4x");
var $3002b52b177bd9ac$var$initialState = {
    xAxis: {},
    yAxis: {}
};
var $3002b52b177bd9ac$export$f4a9a56f402a7d3b = (0, $jDald.createSlice)({
    name: 'renderedTicks',
    initialState: $3002b52b177bd9ac$var$initialState,
    reducers: {
        setRenderedTicks: (state, action)=>{
            var _action$payload = action.payload, axisType = _action$payload.axisType, axisId = _action$payload.axisId, ticks = _action$payload.ticks;
            state[axisType][axisId] = (0, $83c4x.castDraft)(ticks);
        },
        removeRenderedTicks: (state, action)=>{
            var _action$payload2 = action.payload, axisType = _action$payload2.axisType, axisId = _action$payload2.axisId;
            delete state[axisType][axisId];
        }
    }
});
var $3002b52b177bd9ac$var$_renderedTicksSlice$a = $3002b52b177bd9ac$export$f4a9a56f402a7d3b.actions, $3002b52b177bd9ac$export$9b96437af9e57ebe = $3002b52b177bd9ac$var$_renderedTicksSlice$a.setRenderedTicks, $3002b52b177bd9ac$export$d8f6326ec092e260 = $3002b52b177bd9ac$var$_renderedTicksSlice$a.removeRenderedTicks;
var $3002b52b177bd9ac$export$596b92009d4d7ccc = $3002b52b177bd9ac$export$f4a9a56f402a7d3b.reducer;

});



parcelRegister("1SwgK", function(module, exports) {

$parcel$export(module.exports, "ChartDataContextProvider", () => $15e3dd90a1832e09$export$2100a1dedbca0238);

var $acw62 = parcelRequire("acw62");

var $6G94s = parcelRequire("6G94s");

var $bqlEl = parcelRequire("bqlEl");

var $3X9hg = parcelRequire("3X9hg");
var $15e3dd90a1832e09$export$2100a1dedbca0238 = (props)=>{
    var chartData = props.chartData;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    (0, $acw62.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, $6G94s.setChartData)(chartData));
        return ()=>{
            dispatch((0, $6G94s.setChartData)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var $15e3dd90a1832e09$export$91a155b0e28498ba = (props)=>{
    var computedData = props.computedData;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $6G94s.setComputedData)(computedData));
        return ()=>{
            dispatch((0, $6G94s.setChartData)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var $15e3dd90a1832e09$var$selectChartData = (state)=>state.chartData.chartData;
var $15e3dd90a1832e09$export$551a2a6f7431b8ad = ()=>(0, $bqlEl.useAppSelector)($15e3dd90a1832e09$var$selectChartData);
var $15e3dd90a1832e09$var$selectDataIndex = (state)=>{
    var _state$chartData = state.chartData, dataStartIndex = _state$chartData.dataStartIndex, dataEndIndex = _state$chartData.dataEndIndex;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var $15e3dd90a1832e09$export$824568c74ea1faec = ()=>{
    return (0, $bqlEl.useAppSelector)($15e3dd90a1832e09$var$selectDataIndex);
};

});

parcelRegister("f5A9j", function(module, exports) {

$parcel$export(module.exports, "ReportMainChartProps", () => $afc35d1bda6a54e7$export$6faeaad6e02c2e9d);

var $acw62 = parcelRequire("acw62");

var $3X9hg = parcelRequire("3X9hg");

var $3OKeX = parcelRequire("3OKeX");

var $bqlEl = parcelRequire("bqlEl");

var $biEKl = parcelRequire("biEKl");
/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function $afc35d1bda6a54e7$var$ReportMainChartPropsImpl(_ref) {
    var layout = _ref.layout, margin = _ref.margin;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, $3X9hg.useIsPanorama)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, $acw62.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, $3OKeX.setLayout)(layout));
            dispatch((0, $3OKeX.setMargin)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var $afc35d1bda6a54e7$export$6faeaad6e02c2e9d = /*#__PURE__*/ (0, $acw62.memo)($afc35d1bda6a54e7$var$ReportMainChartPropsImpl, (0, $biEKl.propsAreEqual));

});
parcelRegister("biEKl", function(module, exports) {

$parcel$export(module.exports, "propsAreEqual", () => $83a0fb8931561019$export$b8f09df787c278d9);

var $5GDiJ = parcelRequire("5GDiJ");
var $83a0fb8931561019$var$propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle',
    // radius can be an array of 4 numbers, easy to compare shallowly
    'radius',
    'throttledEvents'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function $83a0fb8931561019$var$sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function $83a0fb8931561019$export$b8f09df787c278d9(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if ($83a0fb8931561019$var$propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, $5GDiJ.shallowEqual)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!$83a0fb8931561019$var$sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}

});


parcelRegister("iWBQe", function(module, exports) {

$parcel$export(module.exports, "ReportChartProps", () => $dcaaff4a864a6bc4$export$6fabfb9ba230d12b);

var $acw62 = parcelRequire("acw62");

var $et7NI = parcelRequire("et7NI");

var $bqlEl = parcelRequire("bqlEl");
function $dcaaff4a864a6bc4$export$6fabfb9ba230d12b(props) {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $et7NI.updateOptions)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}

});

parcelRegister("bHRfD", function(module, exports) {

$parcel$export(module.exports, "ReportEventSettings", () => $885d0474a5023e1e$export$dcb02be33c78f8ab);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $j6mdh = parcelRequire("j6mdh");

var $biEKl = parcelRequire("biEKl");
var $885d0474a5023e1e$var$ReportEventSettingsImpl = (props)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $j6mdh.setEventSettings)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
};
var $885d0474a5023e1e$export$dcb02be33c78f8ab = /*#__PURE__*/ (0, $acw62.memo)($885d0474a5023e1e$var$ReportEventSettingsImpl, (0, $biEKl.propsAreEqual));

});

parcelRegister("iz2Aq", function(module, exports) {

$parcel$export(module.exports, "CategoricalChart", () => $d83d807ecbeb257e$export$d49e03133b3316a9);

var $acw62 = parcelRequire("acw62");

var $dVqFZ = parcelRequire("dVqFZ");

var $6cs9F = parcelRequire("6cs9F");

var $5KP13 = parcelRequire("5KP13");

var $4M6vj = parcelRequire("4M6vj");

var $jHn5r = parcelRequire("jHn5r");
var $d83d807ecbeb257e$var$_excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function $d83d807ecbeb257e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d83d807ecbeb257e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $d83d807ecbeb257e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d83d807ecbeb257e$export$d49e03133b3316a9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = props.width, height = props.height, responsive = props.responsive, children = props.children, className = props.className, style = props.style, compact = props.compact, title = props.title, desc = props.desc, others = $d83d807ecbeb257e$var$_objectWithoutProperties(props, $d83d807ecbeb257e$var$_excluded);
    var attrs = (0, $4M6vj.svgPropertiesNoEvents)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $jHn5r.ReportChartSize), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement((0, $dVqFZ.RootSurface), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ $acw62.createElement((0, $6cs9F.RechartsWrapper), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ $acw62.createElement((0, $dVqFZ.RootSurface), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ $acw62.createElement((0, $5KP13.ClipPathProvider), null, children)));
});

});
parcelRegister("dVqFZ", function(module, exports) {

$parcel$export(module.exports, "RootSurface", () => $a2354a93b9e04e81$export$b6c051d2e0bcd3e9);

var $acw62 = parcelRequire("acw62");

var $jHn5r = parcelRequire("jHn5r");

var $7D9a6 = parcelRequire("7D9a6");

var $3X9hg = parcelRequire("3X9hg");

var $gsj4I = parcelRequire("gsj4I");

var $bqlEl = parcelRequire("bqlEl");

var $3o7wy = parcelRequire("3o7wy");

var $iMnqX = parcelRequire("iMnqX");

var $gLMgP = parcelRequire("gLMgP");
var $a2354a93b9e04e81$var$_excluded = [
    "children"
];
function $a2354a93b9e04e81$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a2354a93b9e04e81$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a2354a93b9e04e81$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $a2354a93b9e04e81$var$_extends() {
    return $a2354a93b9e04e81$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a2354a93b9e04e81$var$_extends.apply(null, arguments);
}
var $a2354a93b9e04e81$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var $a2354a93b9e04e81$var$MainChartSurface = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = (0, $jHn5r.useChartWidth)();
    var height = (0, $jHn5r.useChartHeight)();
    var hasAccessibilityLayer = (0, $7D9a6.useAccessibilityLayer)();
    if (!(0, $iMnqX.isPositiveNumber)(width) || !(0, $iMnqX.isPositiveNumber)(height)) return null;
    var children = props.children, otherAttributes = props.otherAttributes, title = props.title, desc = props.desc;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $gsj4I.Surface), $a2354a93b9e04e81$var$_extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: $a2354a93b9e04e81$var$FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var $a2354a93b9e04e81$var$BrushPanoramaSurface = (_ref)=>{
    var children = _ref.children;
    var brushDimensions = (0, $bqlEl.useAppSelector)((0, $3o7wy.selectBrushDimensions));
    if (!brushDimensions) return null;
    var width = brushDimensions.width, height = brushDimensions.height, y = brushDimensions.y, x = brushDimensions.x;
    return /*#__PURE__*/ $acw62.createElement((0, $gsj4I.Surface), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var $a2354a93b9e04e81$export$b6c051d2e0bcd3e9 = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref2, ref)=>{
    var children = _ref2.children, rest = $a2354a93b9e04e81$var$_objectWithoutProperties(_ref2, $a2354a93b9e04e81$var$_excluded);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    if (isPanorama) return /*#__PURE__*/ $acw62.createElement($a2354a93b9e04e81$var$BrushPanoramaSurface, null, /*#__PURE__*/ $acw62.createElement((0, $gLMgP.AllZIndexPortals), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ $acw62.createElement($a2354a93b9e04e81$var$MainChartSurface, $a2354a93b9e04e81$var$_extends({
        ref: ref
    }, rest), /*#__PURE__*/ $acw62.createElement((0, $gLMgP.AllZIndexPortals), {
        isPanorama: false
    }, children));
});

});
parcelRegister("7D9a6", function(module, exports) {

$parcel$export(module.exports, "useAccessibilityLayer", () => $58e3484536fdae50$export$276788f18f24cad3);

var $bqlEl = parcelRequire("bqlEl");
var $58e3484536fdae50$export$276788f18f24cad3 = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $bqlEl.useAppSelector)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};

});

parcelRegister("gsj4I", function(module, exports) {

$parcel$export(module.exports, "Surface", () => $bfae0ec07b91e499$export$7b92b459e668cb21);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $lTk0V = parcelRequire("lTk0V");
var $bfae0ec07b91e499$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $bfae0ec07b91e499$var$_extends() {
    return $bfae0ec07b91e499$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bfae0ec07b91e499$var$_extends.apply(null, arguments);
}
function $bfae0ec07b91e499$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bfae0ec07b91e499$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bfae0ec07b91e499$export$7b92b459e668cb21 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $bfae0ec07b91e499$var$_objectWithoutProperties(props, $bfae0ec07b91e499$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $9QePP.clsx)('recharts-surface', className);
    return /*#__PURE__*/ $acw62.createElement("svg", $bfae0ec07b91e499$var$_extends({}, (0, $lTk0V.svgPropertiesAndEvents)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ $acw62.createElement("title", null, title), /*#__PURE__*/ $acw62.createElement("desc", null, desc), children);
});

});
parcelRegister("lTk0V", function(module, exports) {

$parcel$export(module.exports, "svgPropertiesAndEvents", () => $fefe4263beb558e0$export$67f8fc03e57e2747);
$parcel$export(module.exports, "svgPropertiesAndEventsFromUnknown", () => $fefe4263beb558e0$export$87ef3d7bc7cd0706);

var $acw62 = parcelRequire("acw62");

var $2632D = parcelRequire("2632D");

var $4M6vj = parcelRequire("4M6vj");
function $fefe4263beb558e0$export$67f8fc03e57e2747(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, $4M6vj.isSvgElementPropKey)(key) || (0, $4M6vj.isDataAttribute)(key) || (0, $2632D.isEventKey)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $fefe4263beb558e0$export$87ef3d7bc7cd0706(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return $fefe4263beb558e0$export$67f8fc03e57e2747(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return $fefe4263beb558e0$export$67f8fc03e57e2747(input);
    return null;
}

});
parcelRegister("2632D", function(module, exports) {

$parcel$export(module.exports, "isEventKey", () => $186e804a234e7960$export$7d045284457d8577);
var $186e804a234e7960$var$EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function $186e804a234e7960$export$7d045284457d8577(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = $186e804a234e7960$var$EventKeys;
    return allowedEventKeys.includes(key);
}

});

parcelRegister("4M6vj", function(module, exports) {

$parcel$export(module.exports, "isSvgElementPropKey", () => $37a0b0a95f0e25bf$export$b73d29c2a6d3ff97);
$parcel$export(module.exports, "isDataAttribute", () => $37a0b0a95f0e25bf$export$904e03d0a8b085df);
$parcel$export(module.exports, "svgPropertiesNoEvents", () => $37a0b0a95f0e25bf$export$8b56257912140094);
$parcel$export(module.exports, "svgPropertiesNoEventsFromUnknown", () => $37a0b0a95f0e25bf$export$6d5921c09aa671a9);

var $acw62 = parcelRequire("acw62");
var $37a0b0a95f0e25bf$var$SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $37a0b0a95f0e25bf$var$SVGElementPropKeySet = new Set($37a0b0a95f0e25bf$var$SVGElementPropKeys);
function $37a0b0a95f0e25bf$export$b73d29c2a6d3ff97(key) {
    if (typeof key !== 'string') return false;
    return $37a0b0a95f0e25bf$var$SVGElementPropKeySet.has(key);
}
function $37a0b0a95f0e25bf$export$904e03d0a8b085df(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function $37a0b0a95f0e25bf$export$8b56257912140094(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ($37a0b0a95f0e25bf$export$b73d29c2a6d3ff97(key) || $37a0b0a95f0e25bf$export$904e03d0a8b085df(key)) result[key] = obj[key];
        }
    }
    return result;
}
function $37a0b0a95f0e25bf$export$6d5921c09aa671a9(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return $37a0b0a95f0e25bf$export$8b56257912140094(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return $37a0b0a95f0e25bf$export$8b56257912140094(input);
    return null;
}

});



parcelRegister("gLMgP", function(module, exports) {

$parcel$export(module.exports, "AllZIndexPortals", () => $c3567a9b07e71565$export$7a76624f8e4da531);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $3Zyvz = parcelRequire("3Zyvz");

var $89RSB = parcelRequire("89RSB");
function $c3567a9b07e71565$var$ZIndexSvgPortal(_ref) {
    var zIndex = _ref.zIndex, isPanorama = _ref.isPanorama;
    var ref = (0, $acw62.useRef)(null);
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useLayoutEffect)(()=>{
        if (ref.current) dispatch((0, $3Zyvz.registerZIndexPortalElement)({
            zIndex: zIndex,
            element: ref.current,
            isPanorama: isPanorama
        }));
        return ()=>{
            dispatch((0, $3Zyvz.unregisterZIndexPortalElement)({
                zIndex: zIndex,
                isPanorama: isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        isPanorama
    ]);
    // these g elements should not be tabbable
    return /*#__PURE__*/ $acw62.createElement("g", {
        tabIndex: -1,
        ref: ref,
        className: "recharts-zIndex-layer_".concat(zIndex)
    });
}
function $c3567a9b07e71565$export$7a76624f8e4da531(_ref2) {
    var children = _ref2.children, isPanorama = _ref2.isPanorama;
    var allRegisteredZIndexes = (0, $bqlEl.useAppSelector)((0, $89RSB.selectAllRegisteredZIndexes));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ $acw62.createElement($c3567a9b07e71565$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ $acw62.createElement($c3567a9b07e71565$var$ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}

});
parcelRegister("89RSB", function(module, exports) {

$parcel$export(module.exports, "selectZIndexPortalElement", () => $5f08f563d5a1ffa5$export$30b3c9504f8bc181);
$parcel$export(module.exports, "selectAllRegisteredZIndexes", () => $5f08f563d5a1ffa5$export$7967bffce127e19c);

var $b0nKR = parcelRequire("b0nKR");

var $ouh0N = parcelRequire("ouh0N");

var $gKNgz = parcelRequire("gKNgz");
var $5f08f563d5a1ffa5$export$30b3c9504f8bc181 = (0, $b0nKR.createSelector)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElement;
    return entry.element;
});
var $5f08f563d5a1ffa5$export$7967bffce127e19c = (0, $b0nKR.createSelector)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, $gKNgz.DefaultZIndexes)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, $ouh0N.arrayContentsAreEqualCheck)
    }
});

});



parcelRegister("6cs9F", function(module, exports) {

$parcel$export(module.exports, "RechartsWrapper", () => $4839b40e60bab7c7$export$81bb7974a33f88b);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $58RF9 = parcelRequire("58RF9");

var $bqlEl = parcelRequire("bqlEl");

var $48PAd = parcelRequire("48PAd");

var $eJ4rF = parcelRequire("eJ4rF");

var $9xSsq = parcelRequire("9xSsq");

var $kDpkS = parcelRequire("kDpkS");

var $acoL1 = parcelRequire("acoL1");

var $1PNrQ = parcelRequire("1PNrQ");

var $aQa9C = parcelRequire("aQa9C");

var $1rnEq = parcelRequire("1rnEq");

var $jHn5r = parcelRequire("jHn5r");

var $mjyu0 = parcelRequire("mjyu0");
function $4839b40e60bab7c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4839b40e60bab7c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4839b40e60bab7c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4839b40e60bab7c7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4839b40e60bab7c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4839b40e60bab7c7$var$_defineProperty(e, r, t) {
    return (r = $4839b40e60bab7c7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4839b40e60bab7c7$var$_toPropertyKey(t) {
    var i = $4839b40e60bab7c7$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4839b40e60bab7c7$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4839b40e60bab7c7$var$_extends() {
    return $4839b40e60bab7c7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4839b40e60bab7c7$var$_extends.apply(null, arguments);
}
function $4839b40e60bab7c7$var$_slicedToArray(r, e) {
    return $4839b40e60bab7c7$var$_arrayWithHoles(r) || $4839b40e60bab7c7$var$_iterableToArrayLimit(r, e) || $4839b40e60bab7c7$var$_unsupportedIterableToArray(r, e) || $4839b40e60bab7c7$var$_nonIterableRest();
}
function $4839b40e60bab7c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4839b40e60bab7c7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $4839b40e60bab7c7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $4839b40e60bab7c7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $4839b40e60bab7c7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $4839b40e60bab7c7$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4839b40e60bab7c7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $4839b40e60bab7c7$var$EventSynchronizer = ()=>{
    (0, $eJ4rF.useSynchronisedEventsFromOtherCharts)();
    return null;
};
function $4839b40e60bab7c7$var$getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var $4839b40e60bab7c7$var$ResponsiveDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)({
        containerWidth: $4839b40e60bab7c7$var$getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: $4839b40e60bab7c7$var$getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    }), _useState2 = $4839b40e60bab7c7$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $acw62.useCallback)((node)=>{
        // 1. First, call the external ref if it was provided
        if (typeof ref === 'function') ref(node);
        // 2. Disconnect any previously active ResizeObserver instance to prevent memory leaks
        if (observerRef.current != null) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        // 3. Initiate a new ResizeObserver on the valid DOM node
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var _node$getBoundingClie = node.getBoundingClientRect(), containerWidth = _node$getBoundingClie.width, containerHeight = _node$getBoundingClie.height;
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var entry = entries[0];
                if (entry == null) return;
                var _entry$contentRect = entry.contentRect, width = _entry$contentRect.width, height = _entry$contentRect.height;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $jHn5r.ReportChartSize), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: innerRef
    }, props)));
});
var $4839b40e60bab7c7$var$ReadSizeOnceDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = props.width, height = props.height;
    var _useState3 = (0, $acw62.useState)({
        containerWidth: $4839b40e60bab7c7$var$getNumberOrZero(width),
        containerHeight: $4839b40e60bab7c7$var$getNumberOrZero(height)
    }), _useState4 = $4839b40e60bab7c7$var$_slicedToArray(_useState3, 2), sizes = _useState4[0], setSizes = _useState4[1];
    var setContainerSize = (0, $acw62.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, $acw62.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var _node$getBoundingClie2 = node.getBoundingClientRect(), containerWidth = _node$getBoundingClie2.width, containerHeight = _node$getBoundingClie2.height;
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $jHn5r.ReportChartSize), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: innerRef
    }, props)));
});
var $4839b40e60bab7c7$var$StaticDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = props.width, height = props.height;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $jHn5r.ReportChartSize), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: ref
    }, props)));
});
var $4839b40e60bab7c7$var$NonResponsiveDiv = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var width = props.width, height = props.height;
    // When width or height are percentages or CSS short names, read size from DOM once
    if (typeof width === 'string' || typeof height === 'string') return /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$ReadSizeOnceDiv, $4839b40e60bab7c7$var$_extends({}, props, {
        ref: ref
    }));
    // When both are numbers, use them directly
    if (typeof width === 'number' && typeof height === 'number') return /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$StaticDiv, $4839b40e60bab7c7$var$_extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
    // When width/height are undefined, render wrapper div without reporting size
    // This results in no SVG being rendered (intentional for backwards compatibility)
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $jHn5r.ReportChartSize), {
        width: width,
        height: height
    }), /*#__PURE__*/ $acw62.createElement("div", $4839b40e60bab7c7$var$_extends({
        ref: ref
    }, props)));
});
function $4839b40e60bab7c7$var$getWrapperDivComponent(responsive) {
    return responsive ? $4839b40e60bab7c7$var$ResponsiveDiv : $4839b40e60bab7c7$var$NonResponsiveDiv;
}
var $4839b40e60bab7c7$export$81bb7974a33f88b = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var children = props.children, className = props.className, heightFromProps = props.height, onClick = props.onClick, onContextMenu = props.onContextMenu, onDoubleClick = props.onDoubleClick, onMouseDown = props.onMouseDown, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseMove = props.onMouseMove, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, style = props.style, widthFromProps = props.width, responsive = props.responsive, _props$dispatchTouchE = props.dispatchTouchEvents, dispatchTouchEvents = _props$dispatchTouchE === void 0 ? true : _props$dispatchTouchE;
    var containerRef = (0, $acw62.useRef)(null);
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var _useState5 = (0, $acw62.useState)(null), _useState6 = $4839b40e60bab7c7$var$_slicedToArray(_useState5, 2), tooltipPortal = _useState6[0], setTooltipPortal = _useState6[1];
    var _useState7 = (0, $acw62.useState)(null), _useState8 = $4839b40e60bab7c7$var$_slicedToArray(_useState7, 2), legendPortal = _useState8[0], setLegendPortal = _useState8[1];
    var setScaleRef = (0, $kDpkS.useReportScale)();
    var responsiveContainerCalculations = (0, $mjyu0.useResponsiveContainerContext)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, $acw62.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $48PAd.mouseClickAction)(e));
        dispatch((0, $acoL1.externalEventAction)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $48PAd.mouseMoveAction)(e));
        dispatch((0, $acoL1.externalEventAction)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $58RF9.mouseLeaveChart)());
        dispatch((0, $acoL1.externalEventAction)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $48PAd.mouseMoveAction)(e));
        dispatch((0, $acoL1.externalEventAction)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, $acw62.useCallback)(()=>{
        dispatch((0, $9xSsq.focusAction)());
    }, [
        dispatch
    ]);
    var onBlur = (0, $acw62.useCallback)(()=>{
        dispatch((0, $9xSsq.blurAction)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $9xSsq.keyDownAction)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, $acw62.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, $1PNrQ.touchEventAction)(e));
        dispatch((0, $acoL1.externalEventAction)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, $acw62.useCallback)((e)=>{
        dispatch((0, $acoL1.externalEventAction)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = $4839b40e60bab7c7$var$getWrapperDivComponent(responsive);
    return /*#__PURE__*/ $acw62.createElement((0, $aQa9C.TooltipPortalContext).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ $acw62.createElement((0, $1rnEq.LegendPortalContext).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ $acw62.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, $9QePP.clsx)('recharts-wrapper', className),
        style: $4839b40e60bab7c7$var$_objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ $acw62.createElement($4839b40e60bab7c7$var$EventSynchronizer, null), children)));
});

});
parcelRegister("eJ4rF", function(module, exports) {

$parcel$export(module.exports, "useSynchronisedEventsFromOtherCharts", () => $ab88b765f694b562$export$3a6efefeed76accf);
$parcel$export(module.exports, "useTooltipChartSynchronisation", () => $ab88b765f694b562$export$21f8394fb189b529);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $iYis8 = parcelRequire("iYis8");

var $g7Jrw = parcelRequire("g7Jrw");

var $bIbT7 = parcelRequire("bIbT7");

var $58RF9 = parcelRequire("58RF9");

var $72R3N = parcelRequire("72R3N");

var $71i43 = parcelRequire("71i43");

var $1Q3ef = parcelRequire("1Q3ef");

var $jHn5r = parcelRequire("jHn5r");

var $6G94s = parcelRequire("6G94s");

var $3FiDp = parcelRequire("3FiDp");
var $ab88b765f694b562$var$_excluded = [
    "x",
    "y"
];
function $ab88b765f694b562$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ab88b765f694b562$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ab88b765f694b562$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ab88b765f694b562$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ab88b765f694b562$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ab88b765f694b562$var$_defineProperty(e, r, t) {
    return (r = $ab88b765f694b562$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ab88b765f694b562$var$_toPropertyKey(t) {
    var i = $ab88b765f694b562$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ab88b765f694b562$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ab88b765f694b562$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ab88b765f694b562$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ab88b765f694b562$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Listens for tooltip sync events from other charts and dispatches the appropriate
 * sync interaction state based on the current chart's syncMethod.
 *
 * Handles three sync methods:
 * - 'index': passes through the tooltip index with coordinate scaling between chart viewBoxes
 * - 'value': matches the incoming label against this chart's axis ticks by string comparison
 * - function: delegates tick resolution to a user-provided callback
 *
 * When a synced label has no matching tick (e.g. sparse chart), the tooltip is hidden
 * but sourceViewBox is preserved to prevent counter-emission cascades.
 */ function $ab88b765f694b562$var$useTooltipSyncEventsListener() {
    var mySyncId = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncId));
    var myEventEmitter = (0, $bqlEl.useAppSelector)((0, $iYis8.selectEventEmitter));
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var syncMethod = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncMethod));
    var tooltipTicks = (0, $bqlEl.useAppSelector)((0, $71i43.selectTooltipAxisTicks));
    var layout = (0, $jHn5r.useChartLayout)();
    var viewBox = (0, $jHn5r.useViewBox)();
    var className = (0, $bqlEl.useAppSelector)((state)=>state.rootProps.className);
    (0, $acw62.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $3FiDp.noop;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            /*
       * Handle source chart deactivation (mouseLeave) for ALL sync methods.
       * This must be checked before any syncMethod-specific logic to ensure
       * sourceViewBox is cleared, which allows isReceivingSynchronisation
       * to become false and lets the normal emission flow resume.
       */ if (action.payload.active === false) {
                dispatch((0, $58RF9.setSyncInteraction)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, _x = _action$payload$coord.x, _y = _action$payload$coord.y, otherCoordinateProps = $ab88b765f694b562$var$_objectWithoutProperties(_action$payload$coord, $ab88b765f694b562$var$_excluded);
                    var _action$payload$sourc = action.payload.sourceViewBox, sourceX = _action$payload$sourc.x, sourceY = _action$payload$sourc.y, sourceWidth = _action$payload$sourc.width, sourceHeight = _action$payload$sourc.height;
                    var scaledCoordinate = $ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch($ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, action), {}, {
                        payload: $ab88b765f694b562$var$_objectSpread($ab88b765f694b562$var$_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var coordinate = action.payload.coordinate;
            if (coordinate == null || viewBox == null) {
                dispatch((0, $58RF9.setSyncInteraction)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            if (activeTick == null) {
                /*
         * The label from the source chart doesn't match any tick in this chart.
         * This happens when synced charts have different data arrays
         * (e.g., one chart has 3 data points while another has 252).
         *
         * We set active: false so the tooltip hides (correct — no data for this date),
         * but we keep sourceViewBox set to signal that we're still receiving sync events.
         * The emission guard in useTooltipChartSynchronisation checks sourceViewBox
         * (not active) to decide whether to suppress outgoing sync events.
         * Without this, the chart would emit a counter-sync event with active: false,
         * cascading to clear tooltips on ALL other synced charts.
         */ dispatch((0, $58RF9.setSyncInteraction)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: action.payload.sourceViewBox,
                    graphicalItemId: undefined
                }));
                return;
            }
            var x = coordinate.x, y = coordinate.y;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, $58RF9.setSyncInteraction)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox,
                graphicalItemId: action.payload.graphicalItemId
            });
            dispatch(syncAction);
        };
        (0, $g7Jrw.eventCenter).on((0, $g7Jrw.TOOLTIP_SYNC_EVENT), listener);
        return ()=>{
            (0, $g7Jrw.eventCenter).off((0, $g7Jrw.TOOLTIP_SYNC_EVENT), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
/**
 * Listens for brush sync events from other charts and updates this chart's
 * data start/end indexes to match, keeping brush positions synchronised.
 */ function $ab88b765f694b562$var$useBrushSyncEventsListener() {
    var mySyncId = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncId));
    var myEventEmitter = (0, $bqlEl.useAppSelector)((0, $iYis8.selectEventEmitter));
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, $3FiDp.noop;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, $6G94s.setDataStartEndIndexes)(action));
        };
        (0, $g7Jrw.eventCenter).on((0, $g7Jrw.BRUSH_SYNC_EVENT), listener);
        return ()=>{
            (0, $g7Jrw.eventCenter).off((0, $g7Jrw.BRUSH_SYNC_EVENT), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function $ab88b765f694b562$export$3a6efefeed76accf() {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $bIbT7.createEventEmitter)());
    }, [
        dispatch
    ]);
    $ab88b765f694b562$var$useTooltipSyncEventsListener();
    $ab88b765f694b562$var$useBrushSyncEventsListener();
}
function $ab88b765f694b562$export$21f8394fb189b529(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, $bqlEl.useAppSelector)((state)=>(0, $72R3N.selectTooltipDataKey)(state, tooltipEventType, trigger));
    var activeGraphicalItemId = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipGraphicalItemId));
    var eventEmitterSymbol = (0, $bqlEl.useAppSelector)((0, $iYis8.selectEventEmitter));
    var syncId = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncId));
    var syncMethod = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncMethod));
    var tooltipState = (0, $bqlEl.useAppSelector)((0, $1Q3ef.selectSynchronisedTooltipState));
    /*
   * Use sourceViewBox (not active) to determine if we're receiving sync events.
   * sourceViewBox is set whenever another chart sends a sync event to us — even when
   * our own tooltip is inactive (because the label didn't match our data).
   * This prevents charts with sparse data from emitting counter-sync events
   * that would clear tooltips on all other synced charts.
   */ var isReceivingSynchronisation = (tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.sourceViewBox) != null;
    var viewBox = (0, $jHn5r.useViewBox)();
    (0, $acw62.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart is currently receiving synchronisation events from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops and cascading tooltip clears.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, $58RF9.setSyncInteraction)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox,
            graphicalItemId: activeGraphicalItemId
        });
        (0, $g7Jrw.eventCenter).emit((0, $g7Jrw.TOOLTIP_SYNC_EVENT), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeGraphicalItemId,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function $ab88b765f694b562$export$d3c93a99675de51f() {
    var syncId = (0, $bqlEl.useAppSelector)((0, $iYis8.selectSyncId));
    var eventEmitterSymbol = (0, $bqlEl.useAppSelector)((0, $iYis8.selectEventEmitter));
    var brushStartIndex = (0, $bqlEl.useAppSelector)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, $bqlEl.useAppSelector)((state)=>state.chartData.dataEndIndex);
    (0, $acw62.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, $g7Jrw.eventCenter).emit((0, $g7Jrw.BRUSH_SYNC_EVENT), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}

});
parcelRegister("g7Jrw", function(module, exports) {

$parcel$export(module.exports, "eventCenter", () => $bbd08cd38300f8df$export$9bcdfe5f29bb33);
$parcel$export(module.exports, "TOOLTIP_SYNC_EVENT", () => $bbd08cd38300f8df$export$e2631176295fd79b);
$parcel$export(module.exports, "BRUSH_SYNC_EVENT", () => $bbd08cd38300f8df$export$5069141294af4ee8);

var $1jgjz = parcelRequire("1jgjz");
var $bbd08cd38300f8df$export$9bcdfe5f29bb33 = new (0, $1jgjz.default)();
var $bbd08cd38300f8df$export$e2631176295fd79b = 'recharts.syncEvent.tooltip';
var $bbd08cd38300f8df$export$5069141294af4ee8 = 'recharts.syncEvent.brush';

});
parcelRegister("1jgjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $70aaa28ae275c84c$export$2e2bcd8739ae039);

var $3vRz3 = parcelRequire("3vRz3");
var $70aaa28ae275c84c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)));

});
parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});



parcelRegister("1Q3ef", function(module, exports) {

$parcel$export(module.exports, "selectSynchronisedTooltipState", () => $156d26eca16ead28$export$54e3aed0d8d4a717);
function $156d26eca16ead28$export$54e3aed0d8d4a717(state) {
    return state.tooltip.syncInteraction;
}

});


parcelRegister("kDpkS", function(module, exports) {

$parcel$export(module.exports, "useReportScale", () => $f05b1a56072a2a66$export$20f53c2c914d2da0);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $V5fxS = parcelRequire("V5fxS");

var $3OKeX = parcelRequire("3OKeX");

var $iMnqX = parcelRequire("iMnqX");
function $f05b1a56072a2a66$var$_slicedToArray(r, e) {
    return $f05b1a56072a2a66$var$_arrayWithHoles(r) || $f05b1a56072a2a66$var$_iterableToArrayLimit(r, e) || $f05b1a56072a2a66$var$_unsupportedIterableToArray(r, e) || $f05b1a56072a2a66$var$_nonIterableRest();
}
function $f05b1a56072a2a66$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f05b1a56072a2a66$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f05b1a56072a2a66$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f05b1a56072a2a66$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f05b1a56072a2a66$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $f05b1a56072a2a66$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f05b1a56072a2a66$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $f05b1a56072a2a66$export$20f53c2c914d2da0() {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var _useState = (0, $acw62.useState)(null), _useState2 = $f05b1a56072a2a66$var$_slicedToArray(_useState, 2), ref = _useState2[0], setRef = _useState2[1];
    var scale = (0, $bqlEl.useAppSelector)((0, $V5fxS.selectContainerScale));
    (0, $acw62.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, $iMnqX.isWellBehavedNumber)(newScale) && newScale !== scale) dispatch((0, $3OKeX.setScale)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}

});

parcelRegister("aQa9C", function(module, exports) {

$parcel$export(module.exports, "TooltipPortalContext", () => $7e46a321e54335ab$export$cf22c67346dd99a4);
$parcel$export(module.exports, "useTooltipPortal", () => $7e46a321e54335ab$export$2842d70d9d62127a);

var $acw62 = parcelRequire("acw62");
var $7e46a321e54335ab$export$cf22c67346dd99a4 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $7e46a321e54335ab$export$2842d70d9d62127a = ()=>(0, $acw62.useContext)($7e46a321e54335ab$export$cf22c67346dd99a4);

});

parcelRegister("1rnEq", function(module, exports) {

$parcel$export(module.exports, "LegendPortalContext", () => $10caa8aee2f82bd9$export$63a23315bebc1b2);

var $acw62 = parcelRequire("acw62");
var $10caa8aee2f82bd9$export$63a23315bebc1b2 = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $10caa8aee2f82bd9$export$36ebc0838785d4af = ()=>(0, $acw62.useContext)($10caa8aee2f82bd9$export$63a23315bebc1b2);

});


parcelRegister("5KP13", function(module, exports) {

$parcel$export(module.exports, "ClipPathProvider", () => $0114c9960f9c8c96$export$8b42b9b49a38ca72);

var $acw62 = parcelRequire("acw62");

var $3FiDp = parcelRequire("3FiDp");

var $5IafS = parcelRequire("5IafS");
function $0114c9960f9c8c96$var$_slicedToArray(r, e) {
    return $0114c9960f9c8c96$var$_arrayWithHoles(r) || $0114c9960f9c8c96$var$_iterableToArrayLimit(r, e) || $0114c9960f9c8c96$var$_unsupportedIterableToArray(r, e) || $0114c9960f9c8c96$var$_nonIterableRest();
}
function $0114c9960f9c8c96$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0114c9960f9c8c96$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $0114c9960f9c8c96$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $0114c9960f9c8c96$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $0114c9960f9c8c96$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $0114c9960f9c8c96$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0114c9960f9c8c96$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $0114c9960f9c8c96$var$ClipPathIdContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $0114c9960f9c8c96$export$8b42b9b49a38ca72 = (_ref)=>{
    var children = _ref.children;
    var _useState = (0, $acw62.useState)("".concat((0, $3FiDp.uniqueId)('recharts'), "-clip")), _useState2 = $0114c9960f9c8c96$var$_slicedToArray(_useState, 1), clipPathId = _useState2[0];
    var plotArea = (0, $5IafS.usePlotArea)();
    if (plotArea == null) return null;
    var x = plotArea.x, y = plotArea.y, width = plotArea.width, height = plotArea.height;
    return /*#__PURE__*/ $acw62.createElement($0114c9960f9c8c96$var$ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var $0114c9960f9c8c96$export$71e825c43eae6ca6 = ()=>{
    return (0, $acw62.useContext)($0114c9960f9c8c96$var$ClipPathIdContext);
};

});
parcelRegister("5IafS", function(module, exports) {

$parcel$export(module.exports, "usePlotArea", () => $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c);
$parcel$export(module.exports, "useActiveTooltipDataPoints", () => $42890447eb7e6cfe$export$a5935a9f8709ac28);

var $214LY = parcelRequire("214LY");

var $99P3O = parcelRequire("99P3O");

var $bqlEl = parcelRequire("bqlEl");

var $3X9hg = parcelRequire("3X9hg");

var $71i43 = parcelRequire("71i43");

var $iPzPU = parcelRequire("iPzPU");

var $hOCZ5 = parcelRequire("hOCZ5");
var $42890447eb7e6cfe$export$5acf30f46eb8262f = (xAxisId)=>{
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$db526816f6980005 = (yAxisId)=>{
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$19e28dcc217b2190 = function useXAxisScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var scale = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisScale)(state, 'xAxis', xAxisId, isPanorama));
    return scale === null || scale === void 0 ? void 0 : scale.map;
};
var $42890447eb7e6cfe$export$ec25c907e4f5439d = function useYAxisScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var scale = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisScale)(state, 'yAxis', yAxisId, isPanorama));
    return scale === null || scale === void 0 ? void 0 : scale.map;
};
var $42890447eb7e6cfe$export$fd3d11ca2ad63a3f = function useXAxisInverseScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseScale)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$96c080ead68608cb = function useXAxisInverseDataSnapScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseDataSnapScale)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$51280985698120cd = function useXAxisInverseTickSnapScale() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseTickSnapScale)(state, 'xAxis', xAxisId));
};
var $42890447eb7e6cfe$export$e507e736eefa0bae = function useYAxisInverseScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseScale)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$d13c0d73d999f5c9 = function useYAxisInverseDataSnapScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseDataSnapScale)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$c7e1bd05a239c2a7 = function useYAxisInverseTickSnapScale() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisInverseTickSnapScale)(state, 'yAxis', yAxisId));
};
var $42890447eb7e6cfe$export$eb960b8a53294a1c = function useXAxisTicks() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectRenderedTicksOfAxis)(state, 'xAxis', xAxisId));
};
var $42890447eb7e6cfe$export$df446d79e69ba5d3 = function useYAxisTicks() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectRenderedTicksOfAxis)(state, 'yAxis', yAxisId));
};
var $42890447eb7e6cfe$export$9f4a01b20b9d273d = function useCartesianScale(dataPoint) {
    var xAxisId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $214LY.defaultAxisId);
    var yAxisId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $214LY.defaultAxisId);
    var xScale = $42890447eb7e6cfe$export$19e28dcc217b2190(xAxisId);
    var yScale = $42890447eb7e6cfe$export$ec25c907e4f5439d(yAxisId);
    if (xScale == null || yScale == null) return undefined;
    var pixelX = xScale(dataPoint.x);
    var pixelY = yScale(dataPoint.y);
    if (pixelX == null || pixelY == null) return undefined;
    return {
        x: pixelX,
        y: pixelY
    };
};
var $42890447eb7e6cfe$export$44023ffa3b5a8134 = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveLabel));
};
var $42890447eb7e6cfe$export$99e5207fa7e69f17 = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $iPzPU.selectChartOffset));
};
var $42890447eb7e6cfe$export$f1ef8efc9ef6fe0c = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $hOCZ5.selectPlotArea));
};
var $42890447eb7e6cfe$export$a5935a9f8709ac28 = ()=>{
    return (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipDataPoints));
};
var $42890447eb7e6cfe$export$fef606eda509da71 = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisDomain)(state, 'xAxis', xAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$530156bda5a6e0b8 = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $214LY.defaultAxisId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisDomain)(state, 'yAxis', yAxisId, isPanorama));
};
var $42890447eb7e6cfe$export$664a603ccf171b5e = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, $bqlEl.useAppSelector)((0, $71i43.selectIsTooltipActive))) !== null && _useAppSelector !== void 0 ? _useAppSelector : false;
};
var $42890447eb7e6cfe$export$c6c562f11dfccde2 = ()=>{
    var coordinate = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipCoordinate));
    if (coordinate == null) return undefined;
    return {
        x: coordinate.x,
        y: coordinate.y
    };
};

});
parcelRegister("iPzPU", function(module, exports) {

$parcel$export(module.exports, "selectChartOffset", () => $db58c9c4dbfd259c$export$623d7e312118b313);

var $b0nKR = parcelRequire("b0nKR");

var $lnFga = parcelRequire("lnFga");
var $db58c9c4dbfd259c$export$623d7e312118b313 = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});

});

parcelRegister("hOCZ5", function(module, exports) {

$parcel$export(module.exports, "selectPlotArea", () => $cf85589f32ad71bb$export$8a921ed356911d9a);

var $b0nKR = parcelRequire("b0nKR");

var $iPzPU = parcelRequire("iPzPU");

var $V5fxS = parcelRequire("V5fxS");
var $cf85589f32ad71bb$export$8a921ed356911d9a = (0, $b0nKR.createSelector)([
    (0, $iPzPU.selectChartOffset),
    (0, $V5fxS.selectChartWidth),
    (0, $V5fxS.selectChartHeight)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});

});




parcelRegister("cd9rh", function(module, exports) {

$parcel$export(module.exports, "resolveDefaultProps", () => $8e3e05537b79f9d5$export$45004cc70a390ee8);
function $8e3e05537b79f9d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e3e05537b79f9d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e3e05537b79f9d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e3e05537b79f9d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e3e05537b79f9d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e3e05537b79f9d5$var$_defineProperty(e, r, t) {
    return (r = $8e3e05537b79f9d5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8e3e05537b79f9d5$var$_toPropertyKey(t) {
    var i = $8e3e05537b79f9d5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8e3e05537b79f9d5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e3e05537b79f9d5$export$45004cc70a390ee8(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = $8e3e05537b79f9d5$var$_objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
} /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ 

});


parcelRegister("kan35", function(module, exports) {

$parcel$export(module.exports, "CartesianGrid", () => $eae69ed53f30e7ce$export$6440e27b9f186856);

var $acw62 = parcelRequire("acw62");

var $12Fpa = parcelRequire("12Fpa");

var $3FiDp = parcelRequire("3FiDp");

var $hBeJX = parcelRequire("hBeJX");

var $7zopS = parcelRequire("7zopS");

var $381Oh = parcelRequire("381Oh");

var $jHn5r = parcelRequire("jHn5r");

var $99P3O = parcelRequire("99P3O");

var $bqlEl = parcelRequire("bqlEl");

var $3X9hg = parcelRequire("3X9hg");

var $cd9rh = parcelRequire("cd9rh");

var $4M6vj = parcelRequire("4M6vj");

var $iMnqX = parcelRequire("iMnqX");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $02A9Z = parcelRequire("02A9Z");
var $eae69ed53f30e7ce$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $eae69ed53f30e7ce$var$_excluded2 = [
    "offset"
], $eae69ed53f30e7ce$var$_excluded3 = [
    "xAxisId",
    "yAxisId"
], $eae69ed53f30e7ce$var$_excluded4 = [
    "xAxisId",
    "yAxisId"
];
function $eae69ed53f30e7ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eae69ed53f30e7ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eae69ed53f30e7ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eae69ed53f30e7ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eae69ed53f30e7ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eae69ed53f30e7ce$var$_defineProperty(e, r, t) {
    return (r = $eae69ed53f30e7ce$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $eae69ed53f30e7ce$var$_toPropertyKey(t) {
    var i = $eae69ed53f30e7ce$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $eae69ed53f30e7ce$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eae69ed53f30e7ce$var$_extends() {
    return $eae69ed53f30e7ce$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $eae69ed53f30e7ce$var$_extends.apply(null, arguments);
}
function $eae69ed53f30e7ce$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $eae69ed53f30e7ce$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ // We exclude strokeDasharray here because Recharts allows array of numbers while DOM does not
var $eae69ed53f30e7ce$var$Background = (props)=>{
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ $acw62.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $eae69ed53f30e7ce$var$LineItem(_ref) {
    var option = _ref.option, lineItemProps = _ref.lineItemProps;
    var lineItem;
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ $acw62.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var x1 = lineItemProps.x1, y1 = lineItemProps.y1, x2 = lineItemProps.x2, y2 = lineItemProps.y2, key = lineItemProps.key, others = $eae69ed53f30e7ce$var$_objectWithoutProperties(lineItemProps, $eae69ed53f30e7ce$var$_excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, $4M6vj.svgPropertiesNoEvents)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, __ = _ref2.offset, restOfFilteredProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(_ref2, $eae69ed53f30e7ce$var$_excluded2);
        var strokeDasharray = Array.isArray(restOfFilteredProps.strokeDasharray) ? restOfFilteredProps.strokeDasharray.join(',') : restOfFilteredProps.strokeDasharray;
        lineItem = /*#__PURE__*/ $acw62.createElement("line", $eae69ed53f30e7ce$var$_extends({}, restOfFilteredProps, {
            strokeDasharray: strokeDasharray,
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $eae69ed53f30e7ce$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var xAxisId = props.xAxisId, yAxisId = props.yAxisId, otherLineItemProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var xAxisId = props.xAxisId, yAxisId = props.yAxisId, otherLineItemProps = $eae69ed53f30e7ce$var$_objectWithoutProperties(props, $eae69ed53f30e7ce$var$_excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $eae69ed53f30e7ce$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var nextPoint = roundedSortedHorizontalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineHeight = lastStripe ? y + height - entry : nextPoint - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ $acw62.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $eae69ed53f30e7ce$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var nextPoint = roundedSortedVerticalPoints[i + 1];
        var lastStripe = nextPoint == null;
        var lineWidth = lastStripe ? x + width - entry : nextPoint - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ $acw62.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var xAxis = _ref3.xAxis, width = _ref3.width, height = _ref3.height, offset = _ref3.offset;
    return (0, $hBeJX.getCoordinatesOfGrid)((0, $7zopS.getTicks)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $381Oh.defaultCartesianAxisProps)), xAxis), {}, {
        ticks: (0, $hBeJX.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var yAxis = _ref4.yAxis, width = _ref4.width, height = _ref4.height, offset = _ref4.offset;
    return (0, $hBeJX.getCoordinatesOfGrid)((0, $7zopS.getTicks)($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $381Oh.defaultCartesianAxisProps)), yAxis), {}, {
        ticks: (0, $hBeJX.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $eae69ed53f30e7ce$export$58f1dfa394f98e54 = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, $gKNgz.DefaultZIndexes).grid
};
function $eae69ed53f30e7ce$export$6440e27b9f186856(props) {
    var _propsIncludingDefaul, _propsIncludingDefaul2, _propsIncludingDefaul3, _propsIncludingDefaul4, _propsIncludingDefaul5, _propsIncludingDefaul6;
    var chartWidth = (0, $jHn5r.useChartWidth)();
    var chartHeight = (0, $jHn5r.useChartHeight)();
    var offset = (0, $jHn5r.useOffsetInternal)();
    var propsIncludingDefaults = $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, (0, $cd9rh.resolveDefaultProps)(props, $eae69ed53f30e7ce$export$58f1dfa394f98e54)), {}, {
        x: (0, $3FiDp.isNumber)(props.x) ? props.x : offset.left,
        y: (0, $3FiDp.isNumber)(props.y) ? props.y : offset.top,
        width: (0, $3FiDp.isNumber)(props.width) ? props.width : offset.width,
        height: (0, $3FiDp.isNumber)(props.height) ? props.height : offset.height
    });
    var xAxisId = propsIncludingDefaults.xAxisId, yAxisId = propsIncludingDefaults.yAxisId, x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var xAxis = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisPropsNeededForCartesianGridTicksGenerator)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectAxisPropsNeededForCartesianGridTicksGenerator)(state, 'yAxis', yAxisId, isPanorama));
    var theme = (0, $02A9Z.useRechartsTheme)();
    var themeProps = {
        stroke: (_propsIncludingDefaul = propsIncludingDefaults.stroke) !== null && _propsIncludingDefaul !== void 0 ? _propsIncludingDefaul : theme.grid.stroke,
        strokeWidth: (_propsIncludingDefaul2 = propsIncludingDefaults.strokeWidth) !== null && _propsIncludingDefaul2 !== void 0 ? _propsIncludingDefaul2 : theme.grid.strokeWidth,
        strokeOpacity: (_propsIncludingDefaul3 = propsIncludingDefaults.strokeOpacity) !== null && _propsIncludingDefaul3 !== void 0 ? _propsIncludingDefaul3 : theme.grid.strokeOpacity,
        strokeDasharray: (_propsIncludingDefaul4 = propsIncludingDefaults.strokeDasharray) !== null && _propsIncludingDefaul4 !== void 0 ? _propsIncludingDefaul4 : theme.grid.strokeDasharray
    };
    if (!(0, $iMnqX.isPositiveNumber)(width) || !(0, $iMnqX.isPositiveNumber)(height) || !(0, $3FiDp.isNumber)(x) || !(0, $3FiDp.isNumber)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $eae69ed53f30e7ce$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $12Fpa.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $eae69ed53f30e7ce$var$_objectSpread($eae69ed53f30e7ce$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $12Fpa.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$Background, {
        fill: (_propsIncludingDefaul5 = propsIncludingDefaults.fill) !== null && _propsIncludingDefaul5 !== void 0 ? _propsIncludingDefaul5 : theme.grid.fill,
        fillOpacity: (_propsIncludingDefaul6 = propsIncludingDefaults.fillOpacity) !== null && _propsIncludingDefaul6 !== void 0 ? _propsIncludingDefaul6 : theme.grid.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$HorizontalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$VerticalStripes, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$HorizontalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, themeProps, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ $acw62.createElement($eae69ed53f30e7ce$var$VerticalGridLines, $eae69ed53f30e7ce$var$_extends({}, propsIncludingDefaults, themeProps, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
$eae69ed53f30e7ce$export$6440e27b9f186856.displayName = 'CartesianGrid';

});
parcelRegister("7zopS", function(module, exports) {

$parcel$export(module.exports, "getTicks", () => $582ebde04d312f24$export$3d27d42b1034de5c);

var $3FiDp = parcelRequire("3FiDp");

var $5CMYc = parcelRequire("5CMYc");

var $apNs5 = parcelRequire("apNs5");

var $2cAJw = parcelRequire("2cAJw");

var $hmSbZ = parcelRequire("hmSbZ");
function $582ebde04d312f24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $582ebde04d312f24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $582ebde04d312f24$var$ownKeys(Object(t), !0).forEach(function(r) {
            $582ebde04d312f24$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $582ebde04d312f24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $582ebde04d312f24$var$_defineProperty(e, r, t) {
    return (r = $582ebde04d312f24$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $582ebde04d312f24$var$_toPropertyKey(t) {
    var i = $582ebde04d312f24$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $582ebde04d312f24$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $2cAJw.isVisible)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--){
        if (_loop(i)) continue;
    }
    return result;
}
function $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        if (tail != null) {
            var tailSize = getTickSize(tail, len - 1);
            var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
            result[len - 1] = tail = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
            });
            if (tail.tickCoord != null) {
                var isTailShow = (0, $2cAJw.isVisible)(sign, tail.tickCoord, ()=>tailSize, start, end);
                if (isTailShow) {
                    end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                    result[len - 1] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, tail), {}, {
                        isShow: true
                    });
                }
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var initialEntry = result[i];
        if (initialEntry == null) return 1; // continue
        var entry = initialEntry;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(initialEntry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, $2cAJw.isVisible)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = $582ebde04d312f24$var$_objectSpread($582ebde04d312f24$var$_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++){
        if (_loop2(i)) continue;
    }
    return result;
}
function $582ebde04d312f24$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $3FiDp.isNumber)(interval) || (0, $apNs5.Global).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, $2cAJw.getNumberIntervalTicks)(ticks, (0, $3FiDp.isNumber)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $5CMYc.getStringSize)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $2cAJw.getAngledTickWidth)((0, $5CMYc.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $5CMYc.getStringSize)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var tick0 = ticks[0];
    var tick1 = ticks[1];
    var sign = ticks.length >= 2 && tick0 != null && tick1 != null ? (0, $3FiDp.mathSign)(tick1.coordinate - tick0.coordinate) : 1;
    var boundaries = (0, $2cAJw.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $hmSbZ.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'equidistantPreserveEnd') return (0, $hmSbZ.getEquidistantPreserveEndTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $582ebde04d312f24$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $582ebde04d312f24$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}

});
parcelRegister("5CMYc", function(module, exports) {

$parcel$export(module.exports, "getStringSize", () => $41867cca6cb93873$export$e5560531f057ad5d);

var $apNs5 = parcelRequire("apNs5");

var $37WTv = parcelRequire("37WTv");
function $41867cca6cb93873$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41867cca6cb93873$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41867cca6cb93873$var$ownKeys(Object(t), !0).forEach(function(r) {
            $41867cca6cb93873$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41867cca6cb93873$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $41867cca6cb93873$var$_defineProperty(e, r, t) {
    return (r = $41867cca6cb93873$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $41867cca6cb93873$var$_toPropertyKey(t) {
    var i = $41867cca6cb93873$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $41867cca6cb93873$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $41867cca6cb93873$var$defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var $41867cca6cb93873$var$currentConfig = $41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$defaultConfig);
var $41867cca6cb93873$var$stringCache = new (0, $37WTv.LRUCache)($41867cca6cb93873$var$currentConfig.cacheSize);
var $41867cca6cb93873$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $41867cca6cb93873$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $41867cca6cb93873$var$createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var $41867cca6cb93873$var$measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById($41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $41867cca6cb93873$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, $41867cca6cb93873$var$SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $41867cca6cb93873$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $apNs5.Global).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!$41867cca6cb93873$var$currentConfig.enableCache) return $41867cca6cb93873$var$measureTextWithDOM(text, style);
    var cacheKey = $41867cca6cb93873$var$createCacheKey(text, style);
    var cachedResult = $41867cca6cb93873$var$stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = $41867cca6cb93873$var$measureTextWithDOM(text, style);
    // Store in LRU cache
    $41867cca6cb93873$var$stringCache.set(cacheKey, result);
    return result;
};
var $41867cca6cb93873$export$24830ea431eb8e34 = (config)=>{
    var newConfig = $41867cca6cb93873$var$_objectSpread($41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$currentConfig), config);
    if (newConfig.cacheSize !== $41867cca6cb93873$var$currentConfig.cacheSize) $41867cca6cb93873$var$stringCache = new (0, $37WTv.LRUCache)(newConfig.cacheSize);
    $41867cca6cb93873$var$currentConfig = newConfig;
};
var $41867cca6cb93873$export$1340d8ffb2cb9b2 = ()=>$41867cca6cb93873$var$_objectSpread({}, $41867cca6cb93873$var$currentConfig);
var $41867cca6cb93873$export$dbfda59986504510 = ()=>{
    $41867cca6cb93873$var$stringCache.clear();
};
var $41867cca6cb93873$export$5941b2b80425c12f = ()=>({
        size: $41867cca6cb93873$var$stringCache.size(),
        maxSize: $41867cca6cb93873$var$currentConfig.cacheSize
    });

});
parcelRegister("37WTv", function(module, exports) {

$parcel$export(module.exports, "LRUCache", () => $246fb5b10438d867$export$182500e6725aad9a);
function $246fb5b10438d867$var$_defineProperty(e, r, t) {
    return (r = $246fb5b10438d867$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $246fb5b10438d867$var$_toPropertyKey(t) {
    var i = $246fb5b10438d867$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $246fb5b10438d867$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $246fb5b10438d867$export$182500e6725aad9a {
    constructor(maxSize){
        $246fb5b10438d867$var$_defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}

});


parcelRegister("2cAJw", function(module, exports) {

$parcel$export(module.exports, "getAngledTickWidth", () => $19a932367b9d461a$export$a1966f4ad955c82b);
$parcel$export(module.exports, "getTickBoundaries", () => $19a932367b9d461a$export$a257eb8806d5033d);
$parcel$export(module.exports, "isVisible", () => $19a932367b9d461a$export$795910f5f15a9633);
$parcel$export(module.exports, "getNumberIntervalTicks", () => $19a932367b9d461a$export$beeebbe3ff1b306b);

var $aMYtS = parcelRequire("aMYtS");

var $iQ5A3 = parcelRequire("iQ5A3");
function $19a932367b9d461a$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $aMYtS.getAngledRectangleWidth)(size, angle);
}
function $19a932367b9d461a$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $19a932367b9d461a$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $19a932367b9d461a$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $iQ5A3.getEveryNth)(ticks, interval + 1);
}

});
parcelRegister("aMYtS", function(module, exports) {

$parcel$export(module.exports, "getAngledRectangleWidth", () => $7dad4d5151ba4a01$export$3ee78d51cffc2b68);
var $7dad4d5151ba4a01$export$c7964a5b9439ae62 = (_ref, _ref2)=>{
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $7dad4d5151ba4a01$export$6df2062b9e15eec0 = (_ref3)=>{
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $7dad4d5151ba4a01$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
function $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $7dad4d5151ba4a01$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref4) {
    var width = _ref4.width, height = _ref4.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $7dad4d5151ba4a01$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

});

parcelRegister("iQ5A3", function(module, exports) {

$parcel$export(module.exports, "getEveryNth", () => $db7169829440b476$export$c0c2f0af9f98bc62);
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ function $db7169829440b476$export$c0c2f0af9f98bc62(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        var item = array[i];
        if (item !== undefined) result.push(item);
    }
    return result;
}

});


parcelRegister("hmSbZ", function(module, exports) {

$parcel$export(module.exports, "getEquidistantTicks", () => $ca4e8736ea4f469e$export$77bf2ab5711b7f99);
$parcel$export(module.exports, "getEquidistantPreserveEndTicks", () => $ca4e8736ea4f469e$export$635ece29a4bbdfac);

var $2cAJw = parcelRequire("2cAJw");

var $iQ5A3 = parcelRequire("iQ5A3");
function $ca4e8736ea4f469e$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $iQ5A3.getEveryNth)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $2cAJw.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}
function $ca4e8736ea4f469e$export$635ece29a4bbdfac(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    // Reworked logic for getEquidistantPreserveEndTicks
    var result = (ticks || []).slice();
    var len = result.length;
    if (len === 0) return [];
    var initialStart = boundaries.start, end = boundaries.end;
    // Start with stepsize = 1 (every tick) up to the maximum possible stepsize (len)
    for(var stepsize = 1; stepsize <= len; stepsize++){
        // 1. Calculate the offset so the last tick (index len - 1) is always included in the sequence.
        var offset = (len - 1) % stepsize;
        var start = initialStart; // `start` tracks the coordinate of the last successfully drawn tick + gap
        var ok = true;
        // 2. Iterate through the end-anchored sequence: offset, offset + stepsize, ..., len - 1
        var _loop2 = function _loop2() {
            var entry = ticks[index];
            if (entry == null) return 0; // continue
            var i = index;
            var size;
            // Use a function to get size, as in the original code
            var getSize = ()=>{
                if (size === undefined) size = getTickSize(entry, i);
                return size;
            };
            var tickCoord = entry.coordinate;
            // 3. Apply visibility logic (including the first tick special case)
            // The reviewer says *not* to unconditionally bypass checks for the last tick.
            var isShow = index === offset || (0, $2cAJw.isVisible)(sign, tickCoord, getSize, start, end);
            if (!isShow) {
                // If any tick in this end-anchored sequence fails visibility/collision,
                // reject this stepsize and move to the next iteration (larger stepsize).
                ok = false;
                return 1; // break
            }
            // 4. If showable, update the 'start' coordinate for the next collision check
            if (isShow) start = tickCoord + sign * (getSize() / 2 + minTickGap);
        }, _ret2;
        for(var index = offset; index < len; index += stepsize){
            _ret2 = _loop2();
            if (_ret2 === 0) continue;
            if (_ret2 === 1) break;
        }
        // 5. If the entire sequence for this stepsize passed the visibility check, return the result
        if (ok) {
            // Build the final result array explicitly using the validated stepsize and offset.
            var finalTicks = [];
            for(var _index = offset; _index < len; _index += stepsize){
                var tick = ticks[_index];
                if (tick != null) finalTicks.push(tick);
            }
            return finalTicks;
        }
    }
    // If no stepsize works (this shouldn't happen unless minTickGap is huge), return an empty array.
    return [];
}

});


parcelRegister("381Oh", function(module, exports) {

$parcel$export(module.exports, "defaultCartesianAxisProps", () => $247385db510d7b7c$export$179c35154a9748c0);
$parcel$export(module.exports, "CartesianAxis", () => $247385db510d7b7c$export$bdd99f2cdf352bae);

var $acw62 = parcelRequire("acw62");

var $iqxMM = parcelRequire("iqxMM");

var $hirkU = parcelRequire("hirkU");

var $9QePP = parcelRequire("9QePP");

var $lIF05 = parcelRequire("lIF05");

var $cU1wp = parcelRequire("cU1wp");

var $ahoy0 = parcelRequire("ahoy0");

var $3FiDp = parcelRequire("3FiDp");

var $cpMpC = parcelRequire("cpMpC");

var $7zopS = parcelRequire("7zopS");

var $4M6vj = parcelRequire("4M6vj");

var $79xA0 = parcelRequire("79xA0");

var $biEmp = parcelRequire("biEmp");

var $cd9rh = parcelRequire("cd9rh");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $1RPR5 = parcelRequire("1RPR5");

var $47yFs = parcelRequire("47yFs");

var $bqlEl = parcelRequire("bqlEl");
var $247385db510d7b7c$var$_excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType",
    "axisId"
];
function $247385db510d7b7c$var$_slicedToArray(r, e) {
    return $247385db510d7b7c$var$_arrayWithHoles(r) || $247385db510d7b7c$var$_iterableToArrayLimit(r, e) || $247385db510d7b7c$var$_unsupportedIterableToArray(r, e) || $247385db510d7b7c$var$_nonIterableRest();
}
function $247385db510d7b7c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $247385db510d7b7c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $247385db510d7b7c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $247385db510d7b7c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $247385db510d7b7c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $247385db510d7b7c$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $247385db510d7b7c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $247385db510d7b7c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $247385db510d7b7c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $247385db510d7b7c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $247385db510d7b7c$var$_extends() {
    return $247385db510d7b7c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $247385db510d7b7c$var$_extends.apply(null, arguments);
}
function $247385db510d7b7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $247385db510d7b7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $247385db510d7b7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $247385db510d7b7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $247385db510d7b7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $247385db510d7b7c$var$_defineProperty(e, r, t) {
    return (r = $247385db510d7b7c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $247385db510d7b7c$var$_toPropertyKey(t) {
    var i = $247385db510d7b7c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $247385db510d7b7c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $247385db510d7b7c$export$179c35154a9748c0 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, $gKNgz.DefaultZIndexes).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function $247385db510d7b7c$var$AxisLine(axisLineProps) {
    var x = axisLineProps.x, y = axisLineProps.y, width = axisLineProps.width, height = axisLineProps.height, orientation = axisLineProps.orientation, mirror = axisLineProps.mirror, axisLine = axisLineProps.axisLine, otherSvgProps = axisLineProps.otherSvgProps;
    if (!axisLine) return null;
    var props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, otherSvgProps), (0, $4M6vj.svgPropertiesNoEvents)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ $acw62.createElement("line", $247385db510d7b7c$var$_extends({}, props, {
        className: (0, $9QePP.clsx)('recharts-cartesian-axis-line', (0, $iqxMM.get)(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function $247385db510d7b7c$var$getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, $3FiDp.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function $247385db510d7b7c$var$getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function $247385db510d7b7c$var$getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function $247385db510d7b7c$var$TickItem(props) {
    var option = props.option, tickProps = props.tickProps, value = props.value;
    var tickItem;
    var combinedClassName = (0, $9QePP.clsx)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ $acw62.cloneElement(option, $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, $9QePP.clsx)(className, (0, $1RPR5.getClassNameFromUnknown)(option));
        tickItem = /*#__PURE__*/ $acw62.createElement((0, $cU1wp.Text), $247385db510d7b7c$var$_extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
function $247385db510d7b7c$var$RenderedTicksReporter(_ref) {
    var ticks = _ref.ticks, axisType = _ref.axisType, axisId = _ref.axisId;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    /*
   * The ticks array gets a new identity on every render even when its contents are unchanged.
   * If we dispatched on every identity change, then every parent re-render would trigger
   * a store update from a passive effect. Under rapid external updates (e.g. a slider
   * driving chart data), those nested dispatches can trip React's update depth limit.
   * https://github.com/recharts/recharts/issues/7563
   */ var lastDispatchedTicksRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (axisId == null || axisType == null) return;
        // Filter out irrelevant internal properties before exposing externally
        var tickItems = ticks.map((tick)=>({
                value: tick.value,
                coordinate: tick.coordinate,
                offset: tick.offset,
                index: tick.index
            }));
        var last = lastDispatchedTicksRef.current;
        if (last != null && last.axisId === axisId && last.axisType === axisType && (0, $hirkU.isEqual)(last.ticks, tickItems)) return;
        lastDispatchedTicksRef.current = {
            ticks: tickItems,
            axisId: axisId,
            axisType: axisType
        };
        dispatch((0, $47yFs.setRenderedTicks)({
            ticks: tickItems,
            axisId: axisId,
            axisType: axisType
        }));
    }, [
        dispatch,
        ticks,
        axisId,
        axisType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (axisId == null || axisType == null) return 0, $3FiDp.noop;
        return ()=>{
            dispatch((0, $47yFs.removeRenderedTicks)({
                axisId: axisId,
                axisType: axisType
            }));
        };
    }, [
        dispatch,
        axisId,
        axisType
    ]);
    return null;
}
var $247385db510d7b7c$var$Ticks = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var _props$ticks = props.ticks, ticks = _props$ticks === void 0 ? [] : _props$ticks, tick = props.tick, tickLine = props.tickLine, stroke = props.stroke, tickFormatter = props.tickFormatter, unit = props.unit, padding = props.padding, tickTextProps = props.tickTextProps, orientation = props.orientation, mirror = props.mirror, x = props.x, y = props.y, width = props.width, height = props.height, tickSize = props.tickSize, tickMargin = props.tickMargin, fontSize = props.fontSize, letterSpacing = props.letterSpacing, getTicksConfig = props.getTicksConfig, events = props.events, axisType = props.axisType, axisId = props.axisId;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, $7zopS.getTicks)($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, getTicksConfig), {}, {
        ticks: ticks
    }), fontSize, letterSpacing);
    var axisProps = (0, $4M6vj.svgPropertiesNoEvents)(getTicksConfig);
    var customTickProps = (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(tick);
    // Use user-provided textAnchor if available, otherwise calculate from orientation/mirror
    var textAnchor = (0, $cU1wp.isValidTextAnchor)(axisProps.textAnchor) ? axisProps.textAnchor : $247385db510d7b7c$var$getTickTextAnchor(orientation, mirror);
    var verticalAnchor = $247385db510d7b7c$var$getTickVerticalAnchor(orientation, mirror);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>$247385db510d7b7c$var$_objectSpread({
            entry: entry
        }, $247385db510d7b7c$var$getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref2)=>{
        var entry = _ref2.entry, lineCoord = _ref2.line;
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ $acw62.createElement("line", $247385db510d7b7c$var$_extends({}, tickLineProps, lineCoord, {
            className: (0, $9QePP.clsx)('recharts-cartesian-axis-tick-line', (0, $iqxMM.get)(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref3, i)=>{
        var _ref4, _tickTextProps$angle;
        var entry = _ref3.entry, tickCoord = _ref3.tick;
        // @ts-expect-error we're not checking that padding and orientation types are in sync
        var tickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({
            verticalAnchor: verticalAnchor
        }, axisProps), {}, {
            textAnchor: textAnchor,
            stroke: 'none',
            fill: stroke
        }, tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter: tickFormatter,
            padding: padding
        }, tickTextProps), {}, {
            angle: (_ref4 = (_tickTextProps$angle = tickTextProps === null || tickTextProps === void 0 ? void 0 : tickTextProps.angle) !== null && _tickTextProps$angle !== void 0 ? _tickTextProps$angle : axisProps.angle) !== null && _ref4 !== void 0 ? _ref4 : 0
        });
        // @ts-expect-error customTickProps is contributing unknown props which we don't type properly
        var finalTickProps = $247385db510d7b7c$var$_objectSpread($247385db510d7b7c$var$_objectSpread({}, tickProps), customTickProps);
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), $247385db510d7b7c$var$_extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, $cpMpC.adaptEventsOfChild)(events, entry, i)), tick && /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$TickItem, {
            option: tick,
            tickProps: finalTickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$RenderedTicksReporter, {
        ticks: finalTicks,
        axisId: axisId,
        axisType: axisType
    }), tickLabels.length > 0 && /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: (0, $gKNgz.DefaultZIndexes).label
    }, /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ $acw62.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var $247385db510d7b7c$var$CartesianAxisComponent = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var axisLine = props.axisLine, width = props.width, height = props.height, className = props.className, hide = props.hide, ticks = props.ticks, axisType = props.axisType, axisId = props.axisId, rest = $247385db510d7b7c$var$_objectWithoutProperties(props, $247385db510d7b7c$var$_excluded);
    var _useState = (0, $acw62.useState)(''), _useState2 = $247385db510d7b7c$var$_slicedToArray(_useState, 2), fontSize = _useState2[0], setFontSize = _useState2[1];
    var _useState3 = (0, $acw62.useState)(''), _useState4 = $247385db510d7b7c$var$_slicedToArray(_useState3, 2), letterSpacing = _useState4[0], setLetterSpacing = _useState4[1];
    var tickRefs = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, $79xA0.getCalculatedYAxisWidth)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            },
            getCalculatedHeight: ()=>{
                var _props$labelRef2;
                return (0, $biEmp.getCalculatedXAxisHeight)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef2 = props.labelRef) === null || _props$labelRef2 === void 0 ? void 0 : _props$labelRef2.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, $acw62.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: (0, $9QePP.clsx)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, $4M6vj.svgPropertiesNoEvents)(props)
    }), /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y,
        axisId: axisId
    }), /*#__PURE__*/ $acw62.createElement((0, $ahoy0.CartesianLabelContextProvider), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ $acw62.createElement((0, $ahoy0.CartesianLabelFromLabelProp), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var $247385db510d7b7c$export$bdd99f2cdf352bae = /*#__PURE__*/ $acw62.forwardRef((outsideProps, ref)=>{
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $247385db510d7b7c$export$179c35154a9748c0);
    return /*#__PURE__*/ $acw62.createElement($247385db510d7b7c$var$CartesianAxisComponent, $247385db510d7b7c$var$_extends({}, props, {
        ref: ref
    }));
});
$247385db510d7b7c$export$bdd99f2cdf352bae.displayName = 'CartesianAxis';

});
parcelRegister("hirkU", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $ace0b762e7abd4fb$export$248d38f6296296c5);

var $lyHZu = parcelRequire("lyHZu");

var $62DIU = parcelRequire("62DIU");
//#region src/predicate/isEqual.ts
/**
* Checks if two values are equal, including support for `Date`, `RegExp`, and deep object comparison.
*
* @param a - The first value to compare.
* @param b - The second value to compare.
* @returns `true` if the values are equal, otherwise `false`.
*
* @example
* isEqual(1, 1); // true
* isEqual({ a: 1 }, { a: 1 }); // true
* isEqual(/abc/g, /abc/g); // true
* isEqual(new Date('2020-01-01'), new Date('2020-01-01')); // true
* isEqual([1, 2, 3], [1, 2, 3]); // true
*/ function $ace0b762e7abd4fb$export$248d38f6296296c5(a, b) {
    return (0, $62DIU.isEqualWith)(a, b, (0, $lyHZu.noop));
}

});
parcelRegister("lyHZu", function(module, exports) {

$parcel$export(module.exports, "noop", () => $c88572f2bc32da23$export$8793edee2d425525);
//#region src/function/noop.ts
/**
* A no-operation function that does nothing.
* This can be used as a placeholder or default function.
*
* @example
* noop(); // Does nothing
*
* @returns This function does not return anything.
*/ function $c88572f2bc32da23$export$8793edee2d425525() {}

});

parcelRegister("62DIU", function(module, exports) {

$parcel$export(module.exports, "isEqualWith", () => $f3a265cf69dc7a4f$export$dfce45ad55c48ab1);

var $lPtAH = parcelRequire("lPtAH");

var $4Xffk = parcelRequire("4Xffk");

var $ckydW = parcelRequire("ckydW");

var $b9Ta2 = parcelRequire("b9Ta2");

var $tJPKC = parcelRequire("tJPKC");

var $9j8Ey = parcelRequire("9j8Ey");
//#region src/predicate/isEqualWith.ts
/**
* Compares two values for equality using a custom comparison function.
*
* The custom function allows for fine-tuned control over the comparison process. If it returns a boolean, that result determines the equality. If it returns undefined, the function falls back to the default equality comparison.
*
* This function also uses the custom equality function to compare values inside objects,
* arrays, maps, sets, and other complex structures, ensuring a deep comparison.
*
* This approach provides flexibility in handling complex comparisons while maintaining efficient default behavior for simpler cases.
*
* The custom comparison function can take up to six parameters:
* - `x`: The value from the first object `a`.
* - `y`: The value from the second object `b`.
* - `property`: The property key used to get `x` and `y`.
* - `xParent`: The parent of the first value `x`.
* - `yParent`: The parent of the second value `y`.
* - `stack`: An internal stack (Map) to handle circular references.
*
* @param a - The first value to compare.
* @param b - The second value to compare.
* @param areValuesEqual - A function to customize the comparison.
*   If it returns a boolean, that result will be used. If it returns undefined,
*   the default equality comparison will be used.
* @returns `true` if the values are equal according to the customizer, otherwise `false`.
*
* @example
* const customizer = (a, b) => {
*   if (typeof a === 'string' && typeof b === 'string') {
*     return a.toLowerCase() === b.toLowerCase();
*   }
* };
* isEqualWith('Hello', 'hello', customizer); // true
* isEqualWith({ a: 'Hello' }, { a: 'hello' }, customizer); // true
* isEqualWith([1, 2, 3], [1, 2, 3], customizer); // true
*/ function $f3a265cf69dc7a4f$export$dfce45ad55c48ab1(a, b, areValuesEqual) {
    return $f3a265cf69dc7a4f$var$isEqualWithImpl(a, b, void 0, void 0, void 0, void 0, areValuesEqual);
}
function $f3a265cf69dc7a4f$var$isEqualWithImpl(a, b, property, aParent, bParent, stack, areValuesEqual) {
    const result = areValuesEqual(a, b, property, aParent, bParent, stack);
    if (result !== void 0) return result;
    if (typeof a === typeof b) switch(typeof a){
        case "bigint":
        case "string":
        case "boolean":
        case "symbol":
        case "undefined":
            return a === b;
        case "number":
            return a === b || Object.is(a, b);
        case "function":
            return a === b;
        case "object":
            return $f3a265cf69dc7a4f$var$areObjectsEqual(a, b, stack, areValuesEqual);
    }
    return $f3a265cf69dc7a4f$var$areObjectsEqual(a, b, stack, areValuesEqual);
}
function $f3a265cf69dc7a4f$var$areObjectsEqual(a, b, stack, areValuesEqual) {
    if (Object.is(a, b)) return true;
    let aTag = (0, $4Xffk.getTag)(a);
    let bTag = (0, $4Xffk.getTag)(b);
    if (aTag === "[object Arguments]") aTag = (0, $ckydW.objectTag);
    if (bTag === "[object Arguments]") bTag = (0, $ckydW.objectTag);
    if (aTag !== bTag) return false;
    switch(aTag){
        case 0, $ckydW.stringTag:
            return a.toString() === b.toString();
        case 0, $ckydW.numberTag:
            return (0, $9j8Ey.eq)(a.valueOf(), b.valueOf());
        case 0, $ckydW.booleanTag:
        case 0, $ckydW.dateTag:
        case 0, $ckydW.symbolTag:
            return Object.is(a.valueOf(), b.valueOf());
        case 0, $ckydW.regexpTag:
            return a.source === b.source && a.flags === b.flags;
        case 0, $ckydW.functionTag:
            return a === b;
    }
    stack = stack ?? /* @__PURE__ */ new Map();
    const aStack = stack.get(a);
    const bStack = stack.get(b);
    if (aStack != null && bStack != null) return aStack === b;
    stack.set(a, b);
    stack.set(b, a);
    try {
        switch(aTag){
            case 0, $ckydW.mapTag:
                if (a.size !== b.size) return false;
                for (const [key, value] of a.entries())if (!b.has(key) || !$f3a265cf69dc7a4f$var$isEqualWithImpl(value, b.get(key), key, a, b, stack, areValuesEqual)) return false;
                return true;
            case 0, $ckydW.setTag:
                {
                    if (a.size !== b.size) return false;
                    const aValues = Array.from(a.values());
                    const bValues = Array.from(b.values());
                    for(let i = 0; i < aValues.length; i++){
                        const aValue = aValues[i];
                        const index = bValues.findIndex((bValue)=>{
                            return $f3a265cf69dc7a4f$var$isEqualWithImpl(aValue, bValue, void 0, a, b, stack, areValuesEqual);
                        });
                        if (index === -1) return false;
                        bValues.splice(index, 1);
                    }
                    return true;
                }
            case 0, $ckydW.arrayTag:
            case 0, $ckydW.uint8ArrayTag:
            case 0, $ckydW.uint8ClampedArrayTag:
            case 0, $ckydW.uint16ArrayTag:
            case 0, $ckydW.uint32ArrayTag:
            case 0, $ckydW.bigUint64ArrayTag:
            case 0, $ckydW.int8ArrayTag:
            case 0, $ckydW.int16ArrayTag:
            case 0, $ckydW.int32ArrayTag:
            case 0, $ckydW.bigInt64ArrayTag:
            case 0, $ckydW.float32ArrayTag:
            case 0, $ckydW.float64ArrayTag:
                if ((0, $b9Ta2.isBuffer)(a) !== (0, $b9Ta2.isBuffer)(b)) return false;
                if (a.length !== b.length) return false;
                for(let i = 0; i < a.length; i++)if (!$f3a265cf69dc7a4f$var$isEqualWithImpl(a[i], b[i], i, a, b, stack, areValuesEqual)) return false;
                return true;
            case 0, $ckydW.arrayBufferTag:
                if (a.byteLength !== b.byteLength) return false;
                return $f3a265cf69dc7a4f$var$areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
            case 0, $ckydW.dataViewTag:
                if (a.byteLength !== b.byteLength || a.byteOffset !== b.byteOffset) return false;
                return $f3a265cf69dc7a4f$var$areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
            case 0, $ckydW.errorTag:
                return a.name === b.name && a.message === b.message;
            case 0, $ckydW.objectTag:
                {
                    if (!($f3a265cf69dc7a4f$var$areObjectsEqual(a.constructor, b.constructor, stack, areValuesEqual) || (0, $tJPKC.isPlainObject)(a) && (0, $tJPKC.isPlainObject)(b))) return false;
                    const aKeys = [
                        ...Object.keys(a),
                        ...(0, $lPtAH.getSymbols)(a)
                    ];
                    const bKeys = [
                        ...Object.keys(b),
                        ...(0, $lPtAH.getSymbols)(b)
                    ];
                    if (aKeys.length !== bKeys.length) return false;
                    for(let i = 0; i < aKeys.length; i++){
                        const propKey = aKeys[i];
                        const aProp = a[propKey];
                        if (!Object.hasOwn(b, propKey)) return false;
                        const bProp = b[propKey];
                        if (!$f3a265cf69dc7a4f$var$isEqualWithImpl(aProp, bProp, propKey, a, b, stack, areValuesEqual)) return false;
                    }
                    return true;
                }
            default:
                return false;
        }
    } finally{
        stack.delete(a);
        stack.delete(b);
    }
}

});
parcelRegister("lPtAH", function(module, exports) {

$parcel$export(module.exports, "getSymbols", () => $f9f351cb60ddafcf$export$35a4784e7aa54e28);
//#region src/compat/_internal/getSymbols.ts
function $f9f351cb60ddafcf$export$35a4784e7aa54e28(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}

});

parcelRegister("4Xffk", function(module, exports) {

$parcel$export(module.exports, "getTag", () => $d237e49a20620547$export$dad497fe1f6e27c0);
//#region src/compat/_internal/getTag.ts
/**
* Gets the `toStringTag` of `value`.
*
* @private
* @param {T} value The value to query.
* @returns {string} Returns the `Object.prototype.toString.call` result.
*/ function $d237e49a20620547$export$dad497fe1f6e27c0(value) {
    if (value == null) return value === void 0 ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}

});

parcelRegister("ckydW", function(module, exports) {

$parcel$export(module.exports, "regexpTag", () => $bb9f78070345768b$export$d26ba21661f22e80);
$parcel$export(module.exports, "stringTag", () => $bb9f78070345768b$export$3901fe85d07ea884);
$parcel$export(module.exports, "numberTag", () => $bb9f78070345768b$export$bf8ee812b24655d4);
$parcel$export(module.exports, "booleanTag", () => $bb9f78070345768b$export$9edaefd43909686f);
$parcel$export(module.exports, "argumentsTag", () => $bb9f78070345768b$export$5893fc07141a22f5);
$parcel$export(module.exports, "symbolTag", () => $bb9f78070345768b$export$683991a64c0554af);
$parcel$export(module.exports, "dateTag", () => $bb9f78070345768b$export$6db2fef2b8581597);
$parcel$export(module.exports, "mapTag", () => $bb9f78070345768b$export$75d37f0b54c48ce9);
$parcel$export(module.exports, "setTag", () => $bb9f78070345768b$export$a37d07ee78eb4569);
$parcel$export(module.exports, "arrayTag", () => $bb9f78070345768b$export$30c5ab3238b83eeb);
$parcel$export(module.exports, "functionTag", () => $bb9f78070345768b$export$efb7244c657e09d9);
$parcel$export(module.exports, "arrayBufferTag", () => $bb9f78070345768b$export$2e30fbc9f2b7b0ee);
$parcel$export(module.exports, "objectTag", () => $bb9f78070345768b$export$bc65e3276850bd77);
$parcel$export(module.exports, "errorTag", () => $bb9f78070345768b$export$22cd55b42946d950);
$parcel$export(module.exports, "dataViewTag", () => $bb9f78070345768b$export$da14abe8375f47ee);
$parcel$export(module.exports, "uint8ArrayTag", () => $bb9f78070345768b$export$c2cc0c112205cb31);
$parcel$export(module.exports, "uint8ClampedArrayTag", () => $bb9f78070345768b$export$512ff6aab0cdbe50);
$parcel$export(module.exports, "uint16ArrayTag", () => $bb9f78070345768b$export$4e4c26804f20e52f);
$parcel$export(module.exports, "uint32ArrayTag", () => $bb9f78070345768b$export$f5d2c16049863c6c);
$parcel$export(module.exports, "bigUint64ArrayTag", () => $bb9f78070345768b$export$f9d61a38957fda15);
$parcel$export(module.exports, "int8ArrayTag", () => $bb9f78070345768b$export$91c7bbbd3303f2e7);
$parcel$export(module.exports, "int16ArrayTag", () => $bb9f78070345768b$export$72d152e068382569);
$parcel$export(module.exports, "int32ArrayTag", () => $bb9f78070345768b$export$222c6a8899454b8e);
$parcel$export(module.exports, "bigInt64ArrayTag", () => $bb9f78070345768b$export$16916807c04c97d7);
$parcel$export(module.exports, "float32ArrayTag", () => $bb9f78070345768b$export$6acb72c43d6c58de);
$parcel$export(module.exports, "float64ArrayTag", () => $bb9f78070345768b$export$64993ccc604584f0);
//#region src/compat/_internal/tags.ts
const $bb9f78070345768b$export$d26ba21661f22e80 = "[object RegExp]";
const $bb9f78070345768b$export$3901fe85d07ea884 = "[object String]";
const $bb9f78070345768b$export$bf8ee812b24655d4 = "[object Number]";
const $bb9f78070345768b$export$9edaefd43909686f = "[object Boolean]";
const $bb9f78070345768b$export$5893fc07141a22f5 = "[object Arguments]";
const $bb9f78070345768b$export$683991a64c0554af = "[object Symbol]";
const $bb9f78070345768b$export$6db2fef2b8581597 = "[object Date]";
const $bb9f78070345768b$export$75d37f0b54c48ce9 = "[object Map]";
const $bb9f78070345768b$export$a37d07ee78eb4569 = "[object Set]";
const $bb9f78070345768b$export$30c5ab3238b83eeb = "[object Array]";
const $bb9f78070345768b$export$efb7244c657e09d9 = "[object Function]";
const $bb9f78070345768b$export$2e30fbc9f2b7b0ee = "[object ArrayBuffer]";
const $bb9f78070345768b$export$bc65e3276850bd77 = "[object Object]";
const $bb9f78070345768b$export$22cd55b42946d950 = "[object Error]";
const $bb9f78070345768b$export$da14abe8375f47ee = "[object DataView]";
const $bb9f78070345768b$export$c2cc0c112205cb31 = "[object Uint8Array]";
const $bb9f78070345768b$export$512ff6aab0cdbe50 = "[object Uint8ClampedArray]";
const $bb9f78070345768b$export$4e4c26804f20e52f = "[object Uint16Array]";
const $bb9f78070345768b$export$f5d2c16049863c6c = "[object Uint32Array]";
const $bb9f78070345768b$export$f9d61a38957fda15 = "[object BigUint64Array]";
const $bb9f78070345768b$export$91c7bbbd3303f2e7 = "[object Int8Array]";
const $bb9f78070345768b$export$72d152e068382569 = "[object Int16Array]";
const $bb9f78070345768b$export$222c6a8899454b8e = "[object Int32Array]";
const $bb9f78070345768b$export$16916807c04c97d7 = "[object BigInt64Array]";
const $bb9f78070345768b$export$6acb72c43d6c58de = "[object Float32Array]";
const $bb9f78070345768b$export$64993ccc604584f0 = "[object Float64Array]";

});

parcelRegister("b9Ta2", function(module, exports) {

$parcel$export(module.exports, "isBuffer", () => $d932339da7885796$export$a7884ebc965f8f54);

var $fSutb = parcelRequire("fSutb");
//#region src/predicate/isBuffer.ts
/**
* Checks if the given value is a Buffer instance.
*
* This function tests whether the provided value is an instance of Buffer.
* It returns `true` if the value is a Buffer, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to `Buffer`.
*
* @param x - The value to check if it is a Buffer.
* @returns Returns `true` if `x` is a Buffer, else `false`.
*
* @example
* const buffer = Buffer.from("test");
* console.log(isBuffer(buffer)); // true
*
* const notBuffer = "not a buffer";
* console.log(isBuffer(notBuffer)); // false
*/ function $d932339da7885796$export$a7884ebc965f8f54(x) {
    return typeof (0, $fSutb.globalThis_).Buffer !== "undefined" && (0, $fSutb.globalThis_).Buffer.isBuffer(x);
}

});
parcelRegister("fSutb", function(module, exports) {

$parcel$export(module.exports, "globalThis_", () => $07d9e9403cb5ee3e$export$5bd27d02d683fc4f);
//#region src/_internal/globalThis.ts
const $07d9e9403cb5ee3e$export$5bd27d02d683fc4f = typeof globalThis === "object" && globalThis || typeof window === "object" && window || typeof self === "object" && self || typeof $parcel$global === "object" && $parcel$global || function() {
    return this;
}();

});


parcelRegister("tJPKC", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $269f8af39558d29a$export$53b83ca8eaab0383);
//#region src/predicate/isPlainObject.ts
/**
* Checks if a given value is a plain object.
*
* @param value - The value to check.
* @returns True if the value is a plain object, otherwise false.
*
* @example
* ```typescript
* // ✅👇 True
*
* isPlainObject({ });                       // ✅
* isPlainObject({ key: 'value' });          // ✅
* isPlainObject({ key: new Date() });       // ✅
* isPlainObject(new Object());              // ✅
* isPlainObject(Object.create(null));       // ✅
* isPlainObject({ nested: { key: true} });  // ✅
* isPlainObject(new Proxy({}, {}));         // ✅
* isPlainObject({ [Symbol('tag')]: 'A' });  // ✅
*
* // ✅👇 (cross-realms, node context, workers, ...)
* const runInNewContext = await import('node:vm').then(
*     (mod) => mod.runInNewContext
* );
* isPlainObject(runInNewContext('({})'));   // ✅
*
* // ❌👇 False
*
* class Test { };
* isPlainObject(new Test())           // ❌
* isPlainObject(10);                  // ❌
* isPlainObject(null);                // ❌
* isPlainObject('hello');             // ❌
* isPlainObject([]);                  // ❌
* isPlainObject(new Date());          // ❌
* isPlainObject(new Uint8Array([1])); // ❌
* isPlainObject(Buffer.from('ABC'));  // ❌
* isPlainObject(Promise.resolve({})); // ❌
* isPlainObject(Object.create({}));   // ❌
* isPlainObject(new (class Cls {}));  // ❌
* isPlainObject(globalThis);          // ❌,
* ```
*/ function $269f8af39558d29a$export$53b83ca8eaab0383(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (!(proto === null || proto === Object.prototype || Object.getPrototypeOf(proto) === null)) return false;
    return Object.prototype.toString.call(value) === "[object Object]";
}

});



parcelRegister("lIF05", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $04149ae279e74c50$export$936d0764594b6eb3);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $lTk0V = parcelRequire("lTk0V");
var $04149ae279e74c50$var$_excluded = [
    "children",
    "className"
];
function $04149ae279e74c50$var$_extends() {
    return $04149ae279e74c50$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $04149ae279e74c50$var$_extends.apply(null, arguments);
}
function $04149ae279e74c50$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $04149ae279e74c50$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $04149ae279e74c50$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $04149ae279e74c50$export$936d0764594b6eb3 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    var children = props.children, className = props.className, others = $04149ae279e74c50$var$_objectWithoutProperties(props, $04149ae279e74c50$var$_excluded);
    var layerClass = (0, $9QePP.clsx)('recharts-layer', className);
    return /*#__PURE__*/ $acw62.createElement("g", $04149ae279e74c50$var$_extends({
        className: layerClass
    }, (0, $lTk0V.svgPropertiesAndEvents)(others), {
        ref: ref
    }), children);
});

});

parcelRegister("cU1wp", function(module, exports) {

$parcel$export(module.exports, "isValidTextAnchor", () => $964be52cc11879b4$export$ae5e6c08954aa63c);
$parcel$export(module.exports, "isRenderableText", () => $964be52cc11879b4$export$16c73a52b3ef3edd);
$parcel$export(module.exports, "Text", () => $964be52cc11879b4$export$5f1af8db9871e1d6);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $3FiDp = parcelRequire("3FiDp");

var $apNs5 = parcelRequire("apNs5");

var $5CMYc = parcelRequire("5CMYc");

var $7Iamf = parcelRequire("7Iamf");

var $lTk0V = parcelRequire("lTk0V");

var $cd9rh = parcelRequire("cd9rh");

var $iMnqX = parcelRequire("iMnqX");
var $964be52cc11879b4$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], $964be52cc11879b4$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $964be52cc11879b4$var$_extends() {
    return $964be52cc11879b4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $964be52cc11879b4$var$_extends.apply(null, arguments);
}
function $964be52cc11879b4$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $964be52cc11879b4$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $964be52cc11879b4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $964be52cc11879b4$var$_slicedToArray(r, e) {
    return $964be52cc11879b4$var$_arrayWithHoles(r) || $964be52cc11879b4$var$_iterableToArrayLimit(r, e) || $964be52cc11879b4$var$_unsupportedIterableToArray(r, e) || $964be52cc11879b4$var$_nonIterableRest();
}
function $964be52cc11879b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $964be52cc11879b4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $964be52cc11879b4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $964be52cc11879b4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $964be52cc11879b4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $964be52cc11879b4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $964be52cc11879b4$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $964be52cc11879b4$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $964be52cc11879b4$var$calculateWordWidths = (_ref)=>{
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, $3FiDp.isNullish)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($964be52cc11879b4$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word: word,
                width: (0, $5CMYc.getStringSize)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, $5CMYc.getStringSize)('\u00A0', style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function $964be52cc11879b4$export$ae5e6c08954aa63c(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
function $964be52cc11879b4$export$16c73a52b3ef3edd(val) {
    return (0, $3FiDp.isNullish)(val) || typeof val === 'string' || typeof val === 'number' || typeof val === 'boolean';
}
var $964be52cc11879b4$var$calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var word = _ref2.word, width = _ref2.width;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width: width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var $964be52cc11879b4$var$findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var $964be52cc11879b4$var$suffix = "\u2026";
var $964be52cc11879b4$var$checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = $964be52cc11879b4$var$calculateWordWidths({
        breakAll: breakAll,
        style: style,
        children: tempText + $964be52cc11879b4$var$suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = $964be52cc11879b4$var$calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || $964be52cc11879b4$var$findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var $964be52cc11879b4$var$calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var maxLines = _ref3.maxLines, children = _ref3.children, style = _ref3.style, breakAll = _ref3.breakAll;
    var shouldLimitLines = (0, $3FiDp.isNumber)(maxLines);
    var text = String(children);
    var originalResult = $964be52cc11879b4$var$calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || $964be52cc11879b4$var$findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = $964be52cc11879b4$var$checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit), _checkOverflow2 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = $964be52cc11879b4$var$checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit), _checkOverflow4 = $964be52cc11879b4$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $964be52cc11879b4$var$getWordsWithoutCalculate = (children)=>{
    var words = !(0, $3FiDp.isNullish)(children) ? children.toString().split($964be52cc11879b4$var$BREAKING_SPACES) : [];
    return [
        {
            words: words,
            width: undefined
        }
    ];
};
var $964be52cc11879b4$export$86ba3bfd091ebe4f = (_ref4)=>{
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $apNs5.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $964be52cc11879b4$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
        return $964be52cc11879b4$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return $964be52cc11879b4$var$getWordsWithoutCalculate(children);
};
var $964be52cc11879b4$var$DEFAULT_FILL = '#808080';
var $964be52cc11879b4$export$beb103ac5cf1498b = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: $964be52cc11879b4$var$DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var $964be52cc11879b4$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $acw62.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps = (0, $cd9rh.resolveDefaultProps)(outsideProps, $964be52cc11879b4$export$beb103ac5cf1498b), propsX = _resolveDefaultProps.x, propsY = _resolveDefaultProps.y, lineHeight = _resolveDefaultProps.lineHeight, capHeight = _resolveDefaultProps.capHeight, fill = _resolveDefaultProps.fill, scaleToFit = _resolveDefaultProps.scaleToFit, textAnchor = _resolveDefaultProps.textAnchor, verticalAnchor = _resolveDefaultProps.verticalAnchor, props = $964be52cc11879b4$var$_objectWithoutProperties(_resolveDefaultProps, $964be52cc11879b4$var$_excluded);
    var wordsByLines = (0, $acw62.useMemo)(()=>{
        return $964be52cc11879b4$export$86ba3bfd091ebe4f({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $964be52cc11879b4$var$_objectWithoutProperties(props, $964be52cc11879b4$var$_excluded2);
    if (!(0, $3FiDp.isNumOrStr)(propsX) || !(0, $3FiDp.isNumOrStr)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, $3FiDp.isNumber)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, $3FiDp.isNumber)(dy) ? dy : 0);
    if (!(0, $iMnqX.isWellBehavedNumber)(x) || !(0, $iMnqX.isWellBehavedNumber)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $7Iamf.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $7Iamf.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $7Iamf.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    var firstLine = wordsByLines[0];
    if (scaleToFit && firstLine != null) {
        var lineWidth = firstLine.width;
        var width = props.width;
        transforms.push("scale(".concat((0, $3FiDp.isNumber)(width) && (0, $3FiDp.isNumber)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ $acw62.createElement("text", $964be52cc11879b4$var$_extends({}, (0, $lTk0V.svgPropertiesAndEvents)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, $9QePP.clsx)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $964be52cc11879b4$var$DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        $acw62.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
$964be52cc11879b4$export$5f1af8db9871e1d6.displayName = 'Text';

});
parcelRegister("7Iamf", function(module, exports) {

$parcel$export(module.exports, "reduceCSSCalc", () => $59d4ad4b8fae5b14$export$254eac204f89fd7d);

var $3FiDp = parcelRequire("3FiDp");
var $59d4ad4b8fae5b14$var$_DecimalCSS;
function $59d4ad4b8fae5b14$var$_slicedToArray(r, e) {
    return $59d4ad4b8fae5b14$var$_arrayWithHoles(r) || $59d4ad4b8fae5b14$var$_iterableToArrayLimit(r, e) || $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(r, e) || $59d4ad4b8fae5b14$var$_nonIterableRest();
}
function $59d4ad4b8fae5b14$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59d4ad4b8fae5b14$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $59d4ad4b8fae5b14$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $59d4ad4b8fae5b14$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $59d4ad4b8fae5b14$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $59d4ad4b8fae5b14$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $59d4ad4b8fae5b14$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $59d4ad4b8fae5b14$var$_defineProperty(e, r, t) {
    return (r = $59d4ad4b8fae5b14$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $59d4ad4b8fae5b14$var$_toPropertyKey(t) {
    var i = $59d4ad4b8fae5b14$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $59d4ad4b8fae5b14$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX = /^(px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q)$/;
var $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $59d4ad4b8fae5b14$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS = [
    'cm',
    'mm',
    'pt',
    'pc',
    'in',
    'Q',
    'px'
];
function $59d4ad4b8fae5b14$var$isSupportedUnit(unit) {
    return $59d4ad4b8fae5b14$var$FIXED_CSS_LENGTH_UNITS.includes(unit);
}
var $59d4ad4b8fae5b14$var$STR_NAN = 'NaN';
function $59d4ad4b8fae5b14$var$convertToPx(value, unit) {
    return value * $59d4ad4b8fae5b14$var$CONVERSION_RATES[unit];
}
class $59d4ad4b8fae5b14$var$DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var _ref = (_NUM_SPLIT_REGEX$exec = $59d4ad4b8fae5b14$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
        if (numStr == null) return $59d4ad4b8fae5b14$var$DecimalCSS.NaN;
        return new $59d4ad4b8fae5b14$var$DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, $3FiDp.isNan)(num)) this.unit = '';
        if (unit !== '' && !$59d4ad4b8fae5b14$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($59d4ad4b8fae5b14$var$isSupportedUnit(unit)) {
            this.num = $59d4ad4b8fae5b14$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new $59d4ad4b8fae5b14$var$DecimalCSS(NaN, '');
        return new $59d4ad4b8fae5b14$var$DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, $3FiDp.isNan)(this.num);
    }
}
$59d4ad4b8fae5b14$var$_DecimalCSS = $59d4ad4b8fae5b14$var$DecimalCSS;
$59d4ad4b8fae5b14$var$_defineProperty($59d4ad4b8fae5b14$var$DecimalCSS, "NaN", new $59d4ad4b8fae5b14$var$_DecimalCSS(NaN, ''));
function $59d4ad4b8fae5b14$var$calculateArithmetic(expr) {
    if (expr == null || expr.includes($59d4ad4b8fae5b14$var$STR_NAN)) return $59d4ad4b8fae5b14$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $59d4ad4b8fae5b14$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $59d4ad4b8fae5b14$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $59d4ad4b8fae5b14$var$STR_NAN;
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $59d4ad4b8fae5b14$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $59d4ad4b8fae5b14$var$calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = $59d4ad4b8fae5b14$var$PARENTHESES_REGEX.exec(newExpr)) != null){
        var _match = match, _match2 = $59d4ad4b8fae5b14$var$_slicedToArray(_match, 2), parentheticalExpression = _match2[1];
        newExpr = newExpr.replace($59d4ad4b8fae5b14$var$PARENTHESES_REGEX, $59d4ad4b8fae5b14$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $59d4ad4b8fae5b14$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $59d4ad4b8fae5b14$var$calculateParentheses(newExpr);
    newExpr = $59d4ad4b8fae5b14$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression) {
    try {
        return $59d4ad4b8fae5b14$var$evaluateExpression(expression);
    } catch (_unused) {
        return $59d4ad4b8fae5b14$var$STR_NAN;
    }
}
function $59d4ad4b8fae5b14$export$254eac204f89fd7d(expression) {
    var result = $59d4ad4b8fae5b14$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $59d4ad4b8fae5b14$var$STR_NAN) return '';
    return result;
}

});


parcelRegister("ahoy0", function(module, exports) {

$parcel$export(module.exports, "CartesianLabelContextProvider", () => $77be8884b5ec622c$export$3b4df77eaec10b03);
$parcel$export(module.exports, "PolarLabelContextProvider", () => $77be8884b5ec622c$export$cd0d7ffccbd95e6d);
$parcel$export(module.exports, "isLabelContentAFunction", () => $77be8884b5ec622c$export$96a48941c06f377f);
$parcel$export(module.exports, "Label", () => $77be8884b5ec622c$export$b04be29aa201d4f5);
$parcel$export(module.exports, "CartesianLabelFromLabelProp", () => $77be8884b5ec622c$export$3c82c3a3704539d8);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $cU1wp = parcelRequire("cU1wp");

var $3FiDp = parcelRequire("3FiDp");

var $1l5bp = parcelRequire("1l5bp");

var $jHn5r = parcelRequire("jHn5r");

var $bqlEl = parcelRequire("bqlEl");

var $7bJlR = parcelRequire("7bJlR");

var $cd9rh = parcelRequire("cd9rh");

var $lTk0V = parcelRequire("lTk0V");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $ibeE1 = parcelRequire("ibeE1");

var $ha3DD = parcelRequire("ha3DD");
var $77be8884b5ec622c$var$_excluded = [
    "labelRef"
], $77be8884b5ec622c$var$_excluded2 = [
    "content"
];
function $77be8884b5ec622c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $77be8884b5ec622c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $77be8884b5ec622c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77be8884b5ec622c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77be8884b5ec622c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77be8884b5ec622c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77be8884b5ec622c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77be8884b5ec622c$var$_defineProperty(e, r, t) {
    return (r = $77be8884b5ec622c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $77be8884b5ec622c$var$_toPropertyKey(t) {
    var i = $77be8884b5ec622c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $77be8884b5ec622c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $77be8884b5ec622c$var$_extends() {
    return $77be8884b5ec622c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77be8884b5ec622c$var$_extends.apply(null, arguments);
}
/**
 * @inline
 */ /**
 * @inline
 */ /**
 * @inline
 */ var $77be8884b5ec622c$var$CartesianLabelContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $77be8884b5ec622c$export$3b4df77eaec10b03 = (_ref)=>{
    var x = _ref.x, y = _ref.y, upperWidth = _ref.upperWidth, lowerWidth = _ref.lowerWidth, width = _ref.width, height = _ref.height, children = _ref.children;
    var viewBox = (0, $acw62.useMemo)(()=>({
            x: x,
            y: y,
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            width: width,
            height: height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$var$CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $77be8884b5ec622c$var$useCartesianLabelContext = ()=>{
    var labelChildContext = (0, $acw62.useContext)($77be8884b5ec622c$var$CartesianLabelContext);
    var chartContext = (0, $jHn5r.useViewBox)();
    return labelChildContext || (chartContext ? (0, $ha3DD.cartesianViewBoxToTrapezoid)(chartContext) : undefined);
};
var $77be8884b5ec622c$var$PolarLabelContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
var $77be8884b5ec622c$export$cd0d7ffccbd95e6d = (_ref2)=>{
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle, clockWise = _ref2.clockWise, children = _ref2.children;
    var viewBox = (0, $acw62.useMemo)(()=>({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle,
            clockWise: clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$var$PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var $77be8884b5ec622c$export$6f334acae8be4776 = ()=>{
    var labelChildContext = (0, $acw62.useContext)($77be8884b5ec622c$var$PolarLabelContext);
    var chartContext = (0, $bqlEl.useAppSelector)((0, $7bJlR.selectPolarViewBox));
    return labelChildContext || chartContext;
};
var $77be8884b5ec622c$var$getLabel = (props)=>{
    var value = props.value, formatter = props.formatter;
    var label = (0, $3FiDp.isNullish)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var $77be8884b5ec622c$export$96a48941c06f377f = (content)=>{
    return content != null && typeof content === 'function';
};
var $77be8884b5ec622c$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $3FiDp.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $77be8884b5ec622c$var$renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var offset = labelProps.offset, className = labelProps.className;
    var cx = viewBox.cx, cy = viewBox.cy, innerRadius = viewBox.innerRadius, outerRadius = viewBox.outerRadius, startAngle = viewBox.startAngle, endAngle = viewBox.endAngle, clockWise = viewBox.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $77be8884b5ec622c$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $1l5bp.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, $1l5bp.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, $3FiDp.isNullish)(labelProps.id) ? (0, $3FiDp.uniqueId)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ $acw62.createElement("text", $77be8884b5ec622c$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $9QePP.clsx)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ $acw62.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $77be8884b5ec622c$var$getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var cx = viewBox.cx, cy = viewBox.cy, innerRadius = viewBox.innerRadius, outerRadius = viewBox.outerRadius, startAngle = viewBox.startAngle, endAngle = viewBox.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $1l5bp.polarToCartesian)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $1l5bp.polarToCartesian)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $77be8884b5ec622c$var$isPolar = (viewBox)=>viewBox != null && 'cx' in viewBox && (0, $3FiDp.isNumber)(viewBox.cx);
var $77be8884b5ec622c$export$b1c389a57ef19225 = {
    angle: 0,
    offset: 5,
    zIndex: (0, $gKNgz.DefaultZIndexes).label,
    position: 'middle',
    textBreakAll: false
};
function $77be8884b5ec622c$var$polarViewBoxToTrapezoid(viewBox) {
    if (!$77be8884b5ec622c$var$isPolar(viewBox)) return viewBox;
    var cx = viewBox.cx, cy = viewBox.cy, outerRadius = viewBox.outerRadius;
    var diameter = outerRadius * 2;
    return {
        x: cx - outerRadius,
        y: cy - outerRadius,
        width: diameter,
        upperWidth: diameter,
        lowerWidth: diameter,
        height: diameter
    };
}
function $77be8884b5ec622c$export$b04be29aa201d4f5(outerProps) {
    var _positionAttrs, _positionAttrs2;
    var props = (0, $cd9rh.resolveDefaultProps)(outerProps, $77be8884b5ec622c$export$b1c389a57ef19225);
    var viewBoxFromProps = props.viewBox, parentViewBox = props.parentViewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll, labelRef = props.labelRef;
    var polarViewBox = $77be8884b5ec622c$export$6f334acae8be4776();
    var cartesianViewBox = $77be8884b5ec622c$var$useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if ($77be8884b5ec622c$var$isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, $ha3DD.cartesianViewBoxToTrapezoid)(viewBoxFromProps);
    var cartesianBox = $77be8884b5ec622c$var$polarViewBoxToTrapezoid(viewBox);
    if (!viewBox || (0, $3FiDp.isNullish)(value) && (0, $3FiDp.isNullish)(children) && !/*#__PURE__*/ (0, $acw62.isValidElement)(content) && typeof content !== 'function') return null;
    // TODO: Generic Polar Hook
    var isRadialPolarLabel = $77be8884b5ec622c$var$isPolar(viewBox) && (position === 'insideStart' || position === 'insideEnd' || position === 'end');
    if ($77be8884b5ec622c$var$isPolar(viewBox)) {
        if (!isRadialPolarLabel) positionAttrs = $77be8884b5ec622c$var$getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else if (cartesianBox) {
        var cartesianResult = (0, $ibeE1.getCartesianPosition)({
            viewBox: cartesianBox,
            position: position,
            offset: props.offset,
            parentViewBox: $77be8884b5ec622c$var$isPolar(parentViewBox) ? undefined : parentViewBox,
            clamp: true
        });
        positionAttrs = $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({
            x: cartesianResult.x,
            y: cartesianResult.y,
            textAnchor: cartesianResult.horizontalAnchor,
            verticalAnchor: cartesianResult.verticalAnchor
        }, cartesianResult.width !== undefined ? {
            width: cartesianResult.width
        } : {}), cartesianResult.height !== undefined ? {
            height: cartesianResult.height
        } : {});
    }
    /*
   * Custom content receives the computed x and y too, so that custom labels
   * can be positioned the same way the built-in Text label is. Explicitly
   * passed props win over the computed values. We deliberately forward only
   * x and y (not the anchors): a custom label that spreads its props into a
   * nested Label would otherwise have that Label's own computed anchors
   * overridden by the inherited ones.
   * https://github.com/recharts/recharts/issues/5067
   */ var propsWithViewBox = $77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread($77be8884b5ec622c$var$_objectSpread({}, ((_positionAttrs = positionAttrs) === null || _positionAttrs === void 0 ? void 0 : _positionAttrs.x) !== undefined ? {
        x: positionAttrs.x
    } : {}), ((_positionAttrs2 = positionAttrs) === null || _positionAttrs2 === void 0 ? void 0 : _positionAttrs2.y) !== undefined ? {
        y: positionAttrs.y
    } : {}), props), {}, {
        viewBox: viewBox
    });
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(content)) {
        var _ = propsWithViewBox.labelRef, propsWithoutLabelRef = $77be8884b5ec622c$var$_objectWithoutProperties(propsWithViewBox, $77be8884b5ec622c$var$_excluded);
        return /*#__PURE__*/ (0, $acw62.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        var _2 = propsWithViewBox.content, propsForContent = $77be8884b5ec622c$var$_objectWithoutProperties(propsWithViewBox, $77be8884b5ec622c$var$_excluded2);
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, $acw62.createElement)(content, propsForContent);
        if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) return label;
    } else label = $77be8884b5ec622c$var$getLabel(props);
    var attrs = (0, $lTk0V.svgPropertiesAndEvents)(props);
    if (isRadialPolarLabel && $77be8884b5ec622c$var$isPolar(viewBox)) return $77be8884b5ec622c$var$renderRadialLabel(props, position, label, attrs, viewBox);
    if (positionAttrs == null) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $cU1wp.Text), $77be8884b5ec622c$var$_extends({
        ref: labelRef,
        className: (0, $9QePP.clsx)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, $cU1wp.isValidTextAnchor)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
$77be8884b5ec622c$export$b04be29aa201d4f5.displayName = 'Label';
var $77be8884b5ec622c$var$parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox: viewBox,
        labelRef: labelRef
    };
    if (label === true) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, $3FiDp.isNumOrStr)(label)) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(label)) {
        if (label.type === $77be8884b5ec622c$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $acw62.cloneElement)(label, $77be8884b5ec622c$var$_objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if ($77be8884b5ec622c$export$96a48941c06f377f(label)) return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ $acw62.createElement($77be8884b5ec622c$export$b04be29aa201d4f5, $77be8884b5ec622c$var$_extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function $77be8884b5ec622c$export$3c82c3a3704539d8(_ref3) {
    var label = _ref3.label, labelRef = _ref3.labelRef;
    var viewBox = $77be8884b5ec622c$var$useCartesianLabelContext();
    return $77be8884b5ec622c$var$parseLabel(label, viewBox, labelRef) || null;
}
function $77be8884b5ec622c$export$24b42d9a68417c83(_ref4) {
    var label = _ref4.label;
    var viewBox = $77be8884b5ec622c$export$6f334acae8be4776();
    return $77be8884b5ec622c$var$parseLabel(label, viewBox) || null;
}

});
parcelRegister("cbiWq", function(module, exports) {

$parcel$export(module.exports, "ZIndexLayer", () => $8de5347dd9805c3d$export$b37befaf92aba9f1);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $bqlEl = parcelRequire("bqlEl");

var $89RSB = parcelRequire("89RSB");

var $3Zyvz = parcelRequire("3Zyvz");

var $jHn5r = parcelRequire("jHn5r");

var $3X9hg = parcelRequire("3X9hg");
function $8de5347dd9805c3d$export$b37befaf92aba9f1(_ref) {
    var zIndex = _ref.zIndex, children = _ref.children;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, $jHn5r.useIsInChartContext)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    /**
   * When zIndex changes, the new portal element is not immediately available because
   * it requires a full render cycle through AllZIndexPortals → ZIndexSvgPortal.
   * During this transition we keep rendering into the previous portal element
   * to avoid an unmount/remount cycle that would cause children to briefly disappear.
   *
   * `registeredZIndexesRef` tracks every zIndex we have registered so that
   * we can defer unregistration of old values until the new portal is ready.
   * `lastPortalElementRef` caches the most recent valid portal DOM node.
   */ var lastPortalElementRef = (0, $acw62.useRef)(undefined);
    var registeredZIndexesRef = (0, $acw62.useRef)(new Set());
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var portalElement = (0, $bqlEl.useAppSelector)((state)=>(0, $89RSB.selectZIndexPortalElement)(state, zIndex, isPanorama));
    /*
   * Lifecycle effect — handles both registration and deferred cleanup.
   *
   * Registration: when zIndex changes we register the new value WITHOUT
   * immediately unregistering the old one. This keeps the old <g> element
   * alive in the DOM so `lastPortalElementRef` remains a valid render target.
   *
   * Deferred cleanup: once `portalElement` for the *new* zIndex becomes
   * available we unregister every stale zIndex that is no longer needed.
   */ (0, $acw62.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) {
            // Portal rendering was disabled — clean up any stale registrations
            var registered = registeredZIndexesRef.current;
            registered.forEach((z)=>{
                dispatch((0, $3Zyvz.unregisterZIndexPortal)({
                    zIndex: z
                }));
            });
            registered.clear();
            lastPortalElementRef.current = undefined;
            return;
        }
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ // Register the current zIndex (idempotent — skips if already registered)
        if (!registeredZIndexesRef.current.has(zIndex)) {
            dispatch((0, $3Zyvz.registerZIndexPortal)({
                zIndex: zIndex
            }));
            registeredZIndexesRef.current.add(zIndex);
        }
        // When the new portal element is ready, retire old zIndex registrations
        if (portalElement) {
            lastPortalElementRef.current = portalElement;
            var _registered = registeredZIndexesRef.current;
            _registered.forEach((z)=>{
                if (z !== zIndex) {
                    dispatch((0, $3Zyvz.unregisterZIndexPortal)({
                        zIndex: z
                    }));
                    _registered.delete(z);
                }
            });
        }
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal,
        portalElement
    ]);
    // Unmount-only cleanup — unregister everything when the component is removed
    (0, $acw62.useLayoutEffect)(()=>{
        var registered = registeredZIndexesRef.current;
        return ()=>{
            registered.forEach((z)=>{
                dispatch((0, $3Zyvz.unregisterZIndexPortal)({
                    zIndex: z
                }));
            });
            registered.clear();
        };
    }, [
        dispatch
    ]);
    if (!shouldRenderInPortal) return children;
    // Prefer the current portal; fall back to the cached one during transitions
    var targetElement = portalElement !== null && portalElement !== void 0 ? portalElement : lastPortalElementRef.current;
    if (!targetElement) // Very first render — no portal has ever been registered yet
    return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, targetElement);
}

});


parcelRegister("cpMpC", function(module, exports) {

$parcel$export(module.exports, "isPolarCoordinate", () => $909d5f835f4e917b$export$b8cdb4ab1d25db49);
$parcel$export(module.exports, "adaptEventHandlers", () => $909d5f835f4e917b$export$7c4c290a4a9c1b1e);
$parcel$export(module.exports, "adaptEventsOfChild", () => $909d5f835f4e917b$export$ca62be0d67a3158c);

var $acw62 = parcelRequire("acw62");

var $2632D = parcelRequire("2632D");
var $909d5f835f4e917b$export$b8cdb4ab1d25db49 = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var $909d5f835f4e917b$export$7c4c290a4a9c1b1e = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, $2632D.isEventKey)(key) && typeof inputProps[key] === 'function') out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var $909d5f835f4e917b$var$getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var $909d5f835f4e917b$export$ca62be0d67a3158c = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, $2632D.isEventKey)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $909d5f835f4e917b$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var $909d5f835f4e917b$export$d307f5934e447d0e = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};

});

parcelRegister("79xA0", function(module, exports) {

$parcel$export(module.exports, "getCalculatedYAxisWidth", () => $53536bea4cb8dced$export$b70f70a4fdbed242);
/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var $53536bea4cb8dced$export$b70f70a4fdbed242 = (_ref)=>{
    var ticks = _ref.ticks, label = _ref.label, _ref$labelGapWithTick = _ref.labelGapWithTick, labelGapWithTick = _ref$labelGapWithTick === void 0 ? 5 : _ref$labelGapWithTick, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 0 : _ref$tickSize, _ref$tickMargin = _ref.tickMargin, tickMargin = _ref$tickMargin === void 0 ? 0 : _ref$tickMargin;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};

});

parcelRegister("biEmp", function(module, exports) {

$parcel$export(module.exports, "getCalculatedXAxisHeight", () => $83a0aee9e8287901$export$aea478299ba98f04);
/**
 * Calculates the height of the X-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated height of the X-axis.
 */ var $83a0aee9e8287901$export$aea478299ba98f04 = (_ref)=>{
    var ticks = _ref.ticks, label = _ref.label, _ref$labelGapWithTick = _ref.labelGapWithTick, labelGapWithTick = _ref$labelGapWithTick === void 0 ? 5 : _ref$labelGapWithTick, _ref$tickSize = _ref.tickSize, tickSize = _ref$tickSize === void 0 ? 0 : _ref$tickSize, _ref$tickMargin = _ref.tickMargin, tickMargin = _ref$tickMargin === void 0 ? 0 : _ref$tickMargin;
    // find the max height of the tick labels
    var maxTickHeight = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.height > maxTickHeight) maxTickHeight = bbox.height;
            }
        });
        // calculate height of the axis label
        var labelHeight = label ? label.getBoundingClientRect().height : 0;
        var tickHeight = tickSize + tickMargin;
        // calculate the updated height of the x-axis
        var updatedXAxisHeight = maxTickHeight + tickHeight + labelHeight + (label ? labelGapWithTick : 0);
        return Math.round(updatedXAxisHeight);
    }
    return 0;
};

});

parcelRegister("1RPR5", function(module, exports) {

$parcel$export(module.exports, "getClassNameFromUnknown", () => $15c2f7112dc9bdea$export$154498af6dc3c303);
function $15c2f7112dc9bdea$export$154498af6dc3c303(u) {
    if (u && typeof u === 'object' && 'className' in u && typeof u.className === 'string') return u.className;
    return '';
}

});


parcelRegister("02A9Z", function(module, exports) {

$parcel$export(module.exports, "useRechartsTheme", () => $007c3cb0825af3b9$export$c74dbaafdb9fb0bb);

var $acw62 = parcelRequire("acw62");

var $3yRfD = parcelRequire("3yRfD");
var $007c3cb0825af3b9$var$RechartsThemeContext = /*#__PURE__*/ (0, $acw62.createContext)((0, $3yRfD.legacyTheme));
var $007c3cb0825af3b9$export$d482ff783f2aacb9 = $007c3cb0825af3b9$var$RechartsThemeContext.Provider;
var $007c3cb0825af3b9$export$c74dbaafdb9fb0bb = ()=>(0, $acw62.useContext)($007c3cb0825af3b9$var$RechartsThemeContext);

});
parcelRegister("3yRfD", function(module, exports) {

$parcel$export(module.exports, "legacyTheme", () => $297ddaa28c6ad35e$export$7132e4bb2707de3c);
/**
 * This is the theme as was the default in 2.x and 3.x branches.
 *
 * It's not very consistent, colors are all over the place and overall exists only for backwards compatibility.
 * Prefer to use either {@link lightTheme} or {@link darkTheme} instead.
 *
 * @deprecated
 * @experimental
 */ var $297ddaa28c6ad35e$export$7132e4bb2707de3c = {
    grid: {
        stroke: '#ccc',
        fill: 'none'
    }
};

});



parcelRegister("4jZOw", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $3258e2bab55a6a07$export$28c660c63b792dea);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $gxuLa = parcelRequire("gxuLa");

var $3C2Za = parcelRequire("3C2Za");

var $1C3xM = parcelRequire("1C3xM");

var $jHn5r = parcelRequire("jHn5r");

var $7D9a6 = parcelRequire("7D9a6");

var $84bJN = parcelRequire("84bJN");

var $iq83J = parcelRequire("iq83J");

var $72R3N = parcelRequire("72R3N");

var $aQa9C = parcelRequire("aQa9C");

var $bqlEl = parcelRequire("bqlEl");

var $58RF9 = parcelRequire("58RF9");

var $eJ4rF = parcelRequire("eJ4rF");

var $2Ron6 = parcelRequire("2Ron6");

var $cd9rh = parcelRequire("cd9rh");
function $3258e2bab55a6a07$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3258e2bab55a6a07$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3258e2bab55a6a07$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3258e2bab55a6a07$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3258e2bab55a6a07$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3258e2bab55a6a07$var$_defineProperty(e, r, t) {
    return (r = $3258e2bab55a6a07$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3258e2bab55a6a07$var$_toPropertyKey(t) {
    var i = $3258e2bab55a6a07$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3258e2bab55a6a07$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $3258e2bab55a6a07$var$_slicedToArray(r, e) {
    return $3258e2bab55a6a07$var$_arrayWithHoles(r) || $3258e2bab55a6a07$var$_iterableToArrayLimit(r, e) || $3258e2bab55a6a07$var$_unsupportedIterableToArray(r, e) || $3258e2bab55a6a07$var$_nonIterableRest();
}
function $3258e2bab55a6a07$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3258e2bab55a6a07$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3258e2bab55a6a07$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3258e2bab55a6a07$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3258e2bab55a6a07$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3258e2bab55a6a07$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3258e2bab55a6a07$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $3258e2bab55a6a07$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $3258e2bab55a6a07$var$renderContent(content, props) {
    if (/*#__PURE__*/ $acw62.isValidElement(content)) return /*#__PURE__*/ $acw62.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ $acw62.createElement(content, props);
    return /*#__PURE__*/ $acw62.createElement((0, $gxuLa.DefaultTooltipContent), props);
}
var $3258e2bab55a6a07$var$emptyPayload = [];
var $3258e2bab55a6a07$export$3e858c907a5012de = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    includeHidden: false,
    isAnimationActive: 'auto',
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function $3258e2bab55a6a07$export$28c660c63b792dea(outsideProps) {
    var _useAppSelector, _ref2;
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $3258e2bab55a6a07$export$3e858c907a5012de);
    var activeFromProps = props.active, allowEscapeViewBox = props.allowEscapeViewBox, animationDuration = props.animationDuration, animationEasing = props.animationEasing, content = props.content, filterNull = props.filterNull, isAnimationActive = props.isAnimationActive, offset = props.offset, payloadUniqBy = props.payloadUniqBy, position = props.position, reverseDirection = props.reverseDirection, useTranslate3d = props.useTranslate3d, wrapperStyle = props.wrapperStyle, cursor = props.cursor, shared = props.shared, trigger = props.trigger, defaultIndex = props.defaultIndex, portalFromProps = props.portal, axisId = props.axisId;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $58RF9.setTooltipSettingsState)({
            shared: shared,
            trigger: trigger,
            axisId: axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, $jHn5r.useViewBox)();
    var accessibilityLayer = (0, $7D9a6.useAccessibilityLayer)();
    var tooltipEventType = (0, $2Ron6.useTooltipEventType)(shared);
    var _ref = (_useAppSelector = (0, $bqlEl.useAppSelector)((state)=>(0, $72R3N.selectIsTooltipActive)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {}, activeIndex = _ref.activeIndex, isActive = _ref.isActive;
    var payloadFromRedux = (0, $bqlEl.useAppSelector)((state)=>(0, $72R3N.selectTooltipPayload)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, $bqlEl.useAppSelector)((state)=>(0, $72R3N.selectActiveLabel)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, $bqlEl.useAppSelector)((state)=>(0, $72R3N.selectActiveCoordinate)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, $aQa9C.useTooltipPortal)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref2 = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref2 !== void 0 ? _ref2 : false;
    var _useElementOffset = (0, $84bJN.useElementOffset)([
        payload,
        finalIsActive
    ]), _useElementOffset2 = $3258e2bab55a6a07$var$_slicedToArray(_useElementOffset, 2), lastBoundingBox = _useElementOffset2[0], updateBoundingBox = _useElementOffset2[1];
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, $eJ4rF.useTooltipChartSynchronisation)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : $3258e2bab55a6a07$var$emptyPayload;
    if (!finalIsActive) finalPayload = $3258e2bab55a6a07$var$emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, $1C3xM.getUniqPayload)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, $3258e2bab55a6a07$var$defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipContentProps = $3258e2bab55a6a07$var$_objectSpread($3258e2bab55a6a07$var$_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex: activeIndex,
        coordinate: coordinate,
        accessibilityLayer: accessibilityLayer
    });
    var tooltipElement = /*#__PURE__*/ $acw62.createElement((0, $3C2Za.TooltipBoundingBox), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, $3258e2bab55a6a07$var$renderContent(content, tooltipContentProps));
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ (0, $1u0KT.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ $acw62.createElement((0, $iq83J.Cursor), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}

});
parcelRegister("gxuLa", function(module, exports) {

$parcel$export(module.exports, "DefaultTooltipContent", () => $c0a796aac01127ca$export$6fe33945eebf9ac8);

var $acw62 = parcelRequire("acw62");

var $bat1Y = parcelRequire("bat1Y");

var $9QePP = parcelRequire("9QePP");

var $3FiDp = parcelRequire("3FiDp");
function $c0a796aac01127ca$var$_extends() {
    return $c0a796aac01127ca$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c0a796aac01127ca$var$_extends.apply(null, arguments);
}
function $c0a796aac01127ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0a796aac01127ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0a796aac01127ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0a796aac01127ca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0a796aac01127ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0a796aac01127ca$var$_defineProperty(e, r, t) {
    return (r = $c0a796aac01127ca$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c0a796aac01127ca$var$_toPropertyKey(t) {
    var i = $c0a796aac01127ca$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c0a796aac01127ca$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c0a796aac01127ca$var$_slicedToArray(r, e) {
    return $c0a796aac01127ca$var$_arrayWithHoles(r) || $c0a796aac01127ca$var$_iterableToArrayLimit(r, e) || $c0a796aac01127ca$var$_unsupportedIterableToArray(r, e) || $c0a796aac01127ca$var$_nonIterableRest();
}
function $c0a796aac01127ca$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c0a796aac01127ca$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c0a796aac01127ca$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c0a796aac01127ca$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c0a796aac01127ca$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $c0a796aac01127ca$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c0a796aac01127ca$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $c0a796aac01127ca$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $3FiDp.isNumOrStr)(value[0]) && (0, $3FiDp.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
var $c0a796aac01127ca$export$b002681d77efe9ac = {
    separator: ' : ',
    contentStyle: {
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    },
    itemStyle: {
        display: 'block',
        paddingTop: 4,
        paddingBottom: 4,
        color: '#000'
    },
    labelStyle: {},
    accessibilityLayer: false
};
function $c0a796aac01127ca$var$lodashLikeSortBy(array, itemSorter) {
    if (itemSorter == null) return array;
    // @ts-expect-error sortBy types somehow are returning a number type.
    return (0, $bat1Y.sortBy)(array, itemSorter);
}
var $c0a796aac01127ca$export$6fe33945eebf9ac8 = (props)=>{
    var _props$separator = props.separator, separator = _props$separator === void 0 ? $c0a796aac01127ca$export$b002681d77efe9ac.separator : _props$separator, contentStyle = props.contentStyle, itemStyle = props.itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? $c0a796aac01127ca$export$b002681d77efe9ac.labelStyle : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? $c0a796aac01127ca$export$b002681d77efe9ac.accessibilityLayer : _props$accessibilityL;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var sortedPayload = $c0a796aac01127ca$var$lodashLikeSortBy(payload, itemSorter);
            var items = sortedPayload.map((entry, i)=>{
                if (!entry || entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || $c0a796aac01127ca$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $c0a796aac01127ca$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = $c0a796aac01127ca$var$_objectSpread($c0a796aac01127ca$var$_objectSpread({}, $c0a796aac01127ca$export$b002681d77efe9ac.itemStyle), {}, {
                    color: entry.color || $c0a796aac01127ca$export$b002681d77efe9ac.itemStyle.color
                }, itemStyle);
                return /*#__PURE__*/ $acw62.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $3FiDp.isNumOrStr)(finalName) ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $3FiDp.isNumOrStr)(finalName) ? /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ $acw62.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ $acw62.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $c0a796aac01127ca$var$_objectSpread($c0a796aac01127ca$var$_objectSpread({}, $c0a796aac01127ca$export$b002681d77efe9ac.contentStyle), contentStyle);
    var finalLabelStyle = $c0a796aac01127ca$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, $3FiDp.isNullish)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $9QePP.clsx)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $9QePP.clsx)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ $acw62.createElement("div", $c0a796aac01127ca$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ $acw62.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ $acw62.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

});

parcelRegister("3C2Za", function(module, exports) {

$parcel$export(module.exports, "TooltipBoundingBox", () => $2a173c9072cdf4ec$export$9e6cee7b86551b9c);

var $acw62 = parcelRequire("acw62");

var $4lPG4 = parcelRequire("4lPG4");

var $caA7u = parcelRequire("caA7u");
function $2a173c9072cdf4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a173c9072cdf4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a173c9072cdf4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a173c9072cdf4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a173c9072cdf4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a173c9072cdf4ec$var$_defineProperty(e, r, t) {
    return (r = $2a173c9072cdf4ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a173c9072cdf4ec$var$_toPropertyKey(t) {
    var i = $2a173c9072cdf4ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2a173c9072cdf4ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a173c9072cdf4ec$var$_slicedToArray(r, e) {
    return $2a173c9072cdf4ec$var$_arrayWithHoles(r) || $2a173c9072cdf4ec$var$_iterableToArrayLimit(r, e) || $2a173c9072cdf4ec$var$_unsupportedIterableToArray(r, e) || $2a173c9072cdf4ec$var$_nonIterableRest();
}
function $2a173c9072cdf4ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a173c9072cdf4ec$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2a173c9072cdf4ec$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2a173c9072cdf4ec$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $2a173c9072cdf4ec$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $2a173c9072cdf4ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a173c9072cdf4ec$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $2a173c9072cdf4ec$var$resolveTransitionProperty(args) {
    if (args.prefersReducedMotion && args.isAnimationActive === 'auto') return undefined;
    if (args.isAnimationActive && args.active) {
        var easing = typeof args.animationEasing === 'string' ? args.animationEasing : 'ease';
        return "transform ".concat(args.animationDuration, "ms ").concat(easing);
    }
    return undefined;
}
function $2a173c9072cdf4ec$var$TooltipBoundingBoxImpl(props) {
    var _props$coordinate3, _props$coordinate4, _props$coordinate$x2, _props$coordinate5, _props$coordinate$y2, _props$coordinate6;
    var prefersReducedMotion = (0, $caA7u.usePrefersReducedMotion)();
    var _React$useState = $acw62.useState(()=>({
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        })), _React$useState2 = $2a173c9072cdf4ec$var$_slicedToArray(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    $acw62.useEffect(()=>{
        var handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                var _props$coordinate$x, _props$coordinate, _props$coordinate$y, _props$coordinate2;
                setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_props$coordinate$x = (_props$coordinate = props.coordinate) === null || _props$coordinate === void 0 ? void 0 : _props$coordinate.x) !== null && _props$coordinate$x !== void 0 ? _props$coordinate$x : 0,
                        y: (_props$coordinate$y = (_props$coordinate2 = props.coordinate) === null || _props$coordinate2 === void 0 ? void 0 : _props$coordinate2.y) !== null && _props$coordinate$y !== void 0 ? _props$coordinate$y : 0
                    }
                });
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        (_props$coordinate3 = props.coordinate) === null || _props$coordinate3 === void 0 ? void 0 : _props$coordinate3.x,
        (_props$coordinate4 = props.coordinate) === null || _props$coordinate4 === void 0 ? void 0 : _props$coordinate4.y
    ]);
    if (state.dismissed && (((_props$coordinate$x2 = (_props$coordinate5 = props.coordinate) === null || _props$coordinate5 === void 0 ? void 0 : _props$coordinate5.x) !== null && _props$coordinate$x2 !== void 0 ? _props$coordinate$x2 : 0) !== state.dismissedAtCoordinate.x || ((_props$coordinate$y2 = (_props$coordinate6 = props.coordinate) === null || _props$coordinate6 === void 0 ? void 0 : _props$coordinate6.y) !== null && _props$coordinate$y2 !== void 0 ? _props$coordinate$y2 : 0) !== state.dismissedAtCoordinate.y)) setState($2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({}, state), {}, {
        dismissed: false
    }));
    var _getTooltipTranslate = (0, $4lPG4.getTooltipTranslate)({
        allowEscapeViewBox: props.allowEscapeViewBox,
        coordinate: props.coordinate,
        offsetLeft: typeof props.offset === 'number' ? props.offset : props.offset.x,
        offsetTop: typeof props.offset === 'number' ? props.offset : props.offset.y,
        position: props.position,
        reverseDirection: props.reverseDirection,
        tooltipBox: props.lastBoundingBox,
        useTranslate3d: props.useTranslate3d,
        viewBox: props.viewBox
    }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
    var positionStyle = props.hasPortalFromProps ? {} : $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({
        transition: $2a173c9072cdf4ec$var$resolveTransitionProperty({
            prefersReducedMotion: prefersReducedMotion,
            isAnimationActive: props.isAnimationActive,
            active: props.active,
            animationDuration: props.animationDuration,
            animationEasing: props.animationEasing
        })
    }, cssProperties), {}, {
        pointerEvents: 'none',
        position: 'absolute',
        top: 0,
        left: 0
    });
    var outerStyle = $2a173c9072cdf4ec$var$_objectSpread($2a173c9072cdf4ec$var$_objectSpread({}, positionStyle), {}, {
        visibility: !state.dismissed && props.active && props.hasPayload ? 'visible' : 'hidden'
    }, props.wrapperStyle);
    return /*#__PURE__*/ $acw62.createElement("div", {
        // @ts-expect-error TypeScript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
        xmlns: "http://www.w3.org/1999/xhtml",
        tabIndex: -1,
        className: cssClasses,
        style: outerStyle,
        ref: props.innerRef
    }, props.children);
}
var $2a173c9072cdf4ec$export$9e6cee7b86551b9c = /*#__PURE__*/ $acw62.memo($2a173c9072cdf4ec$var$TooltipBoundingBoxImpl);

});
parcelRegister("4lPG4", function(module, exports) {

$parcel$export(module.exports, "getTooltipTranslate", () => $32b135afcb061cab$export$25e3b0ae21503056);

var $9QePP = parcelRequire("9QePP");

var $3FiDp = parcelRequire("3FiDp");
var $32b135afcb061cab$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $32b135afcb061cab$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $32b135afcb061cab$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $9QePP.clsx)($32b135afcb061cab$var$CSS_CLASS_PREFIX, {
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-right")]: (0, $3FiDp.isNumber)(translateX) && coordinate && (0, $3FiDp.isNumber)(coordinate.x) && translateX >= coordinate.x,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-left")]: (0, $3FiDp.isNumber)(translateX) && coordinate && (0, $3FiDp.isNumber)(coordinate.x) && translateX < coordinate.x,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-bottom")]: (0, $3FiDp.isNumber)(translateY) && coordinate && (0, $3FiDp.isNumber)(coordinate.y) && translateY >= coordinate.y,
        ["".concat($32b135afcb061cab$var$CSS_CLASS_PREFIX, "-top")]: (0, $3FiDp.isNumber)(translateY) && coordinate && (0, $3FiDp.isNumber)(coordinate.y) && translateY < coordinate.y
    });
}
function $32b135afcb061cab$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offset = _ref2.offset, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $3FiDp.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offset > 0 ? offset : 0);
    var positive = coordinate[key] + offset;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function $32b135afcb061cab$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $32b135afcb061cab$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTop = _ref4.offsetTop, offsetLeft = _ref4.offsetLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox && tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offset: offsetLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $32b135afcb061cab$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offset: offsetTop,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $32b135afcb061cab$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $32b135afcb061cab$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $32b135afcb061cab$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}

});

parcelRegister("caA7u", function(module, exports) {

$parcel$export(module.exports, "usePrefersReducedMotion", () => $8dc26fde11ecc9f6$export$c170580b40c8999d);

var $acw62 = parcelRequire("acw62");

var $apNs5 = parcelRequire("apNs5");
function $8dc26fde11ecc9f6$var$_slicedToArray(r, e) {
    return $8dc26fde11ecc9f6$var$_arrayWithHoles(r) || $8dc26fde11ecc9f6$var$_iterableToArrayLimit(r, e) || $8dc26fde11ecc9f6$var$_unsupportedIterableToArray(r, e) || $8dc26fde11ecc9f6$var$_nonIterableRest();
}
function $8dc26fde11ecc9f6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8dc26fde11ecc9f6$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8dc26fde11ecc9f6$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8dc26fde11ecc9f6$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8dc26fde11ecc9f6$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8dc26fde11ecc9f6$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8dc26fde11ecc9f6$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $8dc26fde11ecc9f6$export$c170580b40c8999d() {
    var _useState = (0, $acw62.useState)(()=>{
        if ((0, $apNs5.Global).isSsr) return false;
        if (!window.matchMedia) return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }), _useState2 = $8dc26fde11ecc9f6$var$_slicedToArray(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $acw62.useEffect)(()=>{
        if (!window.matchMedia) return;
        var mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        var handleChange = ()=>{
            setPrefersReducedMotion(mediaQuery.matches);
        };
        mediaQuery.addEventListener('change', handleChange);
        // eslint-disable-next-line consistent-return
        return ()=>{
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, []);
    return prefersReducedMotion;
}

});


parcelRegister("1C3xM", function(module, exports) {

$parcel$export(module.exports, "getUniqPayload", () => $12cc16c3e91089ee$export$b67e33c2fb1535fa);

var $7OgaI = parcelRequire("7OgaI");
function $12cc16c3e91089ee$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, $7OgaI.uniqBy)(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, $7OgaI.uniqBy)(payload, option);
    return payload;
}

});
parcelRegister("7OgaI", function(module, exports) {

$parcel$export(module.exports, "uniqBy", () => $3a284250820f2ce2$export$da805ba9431c7107);

var $9RLY8 = parcelRequire("9RLY8");

var $dq6CL = parcelRequire("dq6CL");

var $d7LVb = parcelRequire("d7LVb");

var $6aWEd = parcelRequire("6aWEd");

var $hTzly = parcelRequire("hTzly");

var $8GKE1 = parcelRequire("8GKE1");
//#region src/compat/array/uniqBy.ts
function $3a284250820f2ce2$export$da805ba9431c7107(array, iteratee$1 = (0, $d7LVb.identity)) {
    if (!(0, $6aWEd.isArrayLike)(array)) return [];
    return (0, $9RLY8.uniqBy)(Array.from(array), (0, $dq6CL.ary)((0, $hTzly.iteratee)(iteratee$1), 1)).map((0, $8GKE1.normalizeZero));
}

});
parcelRegister("9RLY8", function(module, exports) {

$parcel$export(module.exports, "uniqBy", () => $dace29ae14a73ca9$export$da805ba9431c7107);
//#region src/array/uniqBy.ts
/**
* Returns a new array containing only the unique elements from the original array,
* based on the values returned by the mapper function.
*
* When duplicates are found, the first occurrence is kept and the rest are discarded.
*
* @template T - The type of elements in the array.
* @template U - The type of mapped elements.
* @param arr - The array to process.
* @param mapper - The function used to convert the array elements.
* @returns A new array containing only the unique elements from the original array, based on the values returned by the mapper function.
*
* @example
* ```ts
* uniqBy([1.2, 1.5, 2.1, 3.2, 5.7, 5.3, 7.19], Math.floor);
* // [1.2, 2.1, 3.2, 5.7, 7.19]
* ```
*
* @example
* const array = [
*   { category: 'fruit', name: 'apple' },
*   { category: 'fruit', name: 'banana' },
*   { category: 'vegetable', name: 'carrot' },
* ];
* uniqBy(array, item => item.category).length
* // 2
* ```
*/ function $dace29ae14a73ca9$export$da805ba9431c7107(arr, mapper) {
    const map = /* @__PURE__ */ new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item, i, arr);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}

});

parcelRegister("dq6CL", function(module, exports) {

$parcel$export(module.exports, "ary", () => $e235426debe60c76$export$24730179a5f99706);
//#region src/function/ary.ts
/**
* Creates a function that invokes func, with up to n arguments, ignoring any additional arguments.
*
* @template F - The type of the function.
* @param func - The function to cap arguments for.
* @param n - The arity cap.
* @returns Returns the new capped function.
*
* @example
* function fn(a: number, b: number, c: number) {
*   return Array.from(arguments);
* }
*
* ary(fn, 0)(1, 2, 3) // []
* ary(fn, 1)(1, 2, 3) // [1]
* ary(fn, 2)(1, 2, 3) // [1, 2]
* ary(fn, 3)(1, 2, 3) // [1, 2, 3]
*/ function $e235426debe60c76$export$24730179a5f99706(func, n) {
    return function(...args) {
        return func.apply(this, args.slice(0, n));
    };
}

});

parcelRegister("d7LVb", function(module, exports) {

$parcel$export(module.exports, "identity", () => $958ae3471d3719b3$export$f0954fd7d5368655);
//#region src/function/identity.ts
/**
* Returns the input value unchanged.
*
* @template T - The type of the input value.
* @param x - The value to be returned.
* @returns The input value.
*
* @example
* // Returns 5
* identity(5);
*
* @example
* // Returns 'hello'
* identity('hello');
*
* @example
* // Returns { key: 'value' }
* identity({ key: 'value' });
*/ function $958ae3471d3719b3$export$f0954fd7d5368655(x) {
    return x;
}

});

parcelRegister("hTzly", function(module, exports) {

$parcel$export(module.exports, "iteratee", () => $6cbc4f20163e3226$export$e6b1ca5afaaa20ac);

var $d7LVb = parcelRequire("d7LVb");

var $8ogc4 = parcelRequire("8ogc4");

var $hWBrP = parcelRequire("hWBrP");

var $hVHPO = parcelRequire("hVHPO");
//#region src/compat/util/iteratee.ts
/**
* Creates a function that returns a value from an element in a collection.
*
* You can call `iteratee` with the following types of arguments:
*
* - **Function**: Returns the function as-is, which will be called with the element from the collection.
* - **Property name**: Returns the value of the specified property from the element.
* - **Property-value pair**: Returns a boolean indicating whether the element's property matches the given value.
* - **Partial object**: Returns a boolean indicating whether the element matches the properties of the partial object.
*
* If you don't provide any arguments or pass `null`, this function will return a function that simply returns its input unchanged.
*
* @param value - The value to convert to an iteratee.
* @returns Returns the new iteratee function.
* @example
* const func = iteratee();
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [{ a: 1 }, { a: 2 }, { a: 3 }]
*
* const func = iteratee((object) => object.a);
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [1, 2, 3]
*
* const func = iteratee('a');
* [{ a: 1 }, { a: 2 }, { a: 3 }].map(func) // => [1, 2, 3]
*
* const func = iteratee({ a: 1 });
* [{ a: 1 }, { a: 2 }, { a: 3 }].find(func) // => { a: 1 }
*
* const func = iteratee(['a', 1]);
* [{ a: 1 }, { a: 2 }, { a: 3 }].find(func) // => { a: 1 }
*/ function $6cbc4f20163e3226$export$e6b1ca5afaaa20ac(value) {
    if (value == null) return 0, $d7LVb.identity;
    switch(typeof value){
        case "function":
            return value;
        case "object":
            if (Array.isArray(value) && value.length === 2) return (0, $hVHPO.matchesProperty)(value[0], value[1]);
            return (0, $hWBrP.matches)(value);
        default:
            return (0, $8ogc4.property)(value);
    }
}

});
parcelRegister("8ogc4", function(module, exports) {

$parcel$export(module.exports, "property", () => $b68961ae48049348$export$d541bacb2bda4494);

var $iqxMM = parcelRequire("iqxMM");
//#region src/compat/object/property.ts
/**
* Creates a function that returns the value at a given path of an object.
*
* @template T - The type of object.
* @template R - The type of the value to return.
* @param path - The path of the property to get.
* @returns Returns a new function that takes an object and returns the value at the specified path.
*
* @example
* const getObjectValue = property('a.b.c');
* const result = getObjectValue({ a: { b: { c: 3 } } });
* console.log(result); // => 3
*
* @example
* const getObjectValue = property(['a', 'b', 'c']);
* const result = getObjectValue({ a: { b: { c: 3 } } });
* console.log(result); // => 3
*/ function $b68961ae48049348$export$d541bacb2bda4494(path) {
    return function(object) {
        return (0, $iqxMM.get)(object, path);
    };
}

});

parcelRegister("hWBrP", function(module, exports) {

$parcel$export(module.exports, "matches", () => $96d0b38c2184cc39$export$de994efd351b291c);

var $gFmDc = parcelRequire("gFmDc");

var $ewpCy = parcelRequire("ewpCy");
//#region src/compat/predicate/matches.ts
/**
* Creates a function that performs a deep comparison between a given target and the source object.
*
* @template T
* @template V
* @param source - The source object to create the matcher from.
* @returns Returns a function that takes a target object and returns `true` if the target matches the source, otherwise `false`.
*
* @example
* // Basic usage
* const matcher = matches({ a: 1, b: 2 });
* matcher({ a: 1, b: 2, c: 3 }); // true
* matcher({ a: 1, c: 3 }); // false
*
* @example
* // Matching arrays
* const arrayMatcher = matches([1, 2, 3]);
* arrayMatcher([1, 2, 3, 4]); // true
* arrayMatcher([4, 5, 6]); // false
*
* @example
* // Matching objects with nested structures
* const nestedMatcher = matches({ a: { b: 2 } });
* nestedMatcher({ a: { b: 2, c: 3 } }); // true
* nestedMatcher({ a: { c: 3 } }); // false
*/ function $96d0b38c2184cc39$export$de994efd351b291c(source) {
    source = (0, $gFmDc.cloneDeep)(source);
    return (target)=>{
        return (0, $ewpCy.isMatch)(target, source);
    };
}

});
parcelRegister("gFmDc", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $e64bba283a54ad54$export$629a2bd3f5a49ecc);

var $cscvQ = parcelRequire("cscvQ");
//#region src/object/cloneDeep.ts
/**
* Creates a deep clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeep(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = cloneDeep(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an array with nested objects
* const arr = [1, { a: 1 }, [1, 2, 3]];
* const clonedArr = cloneDeep(arr);
* arr[1].a = 2;
* console.log(arr); // [1, { a: 2 }, [1, 2, 3]]
* console.log(clonedArr); // [1, { a: 1 }, [1, 2, 3]]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = cloneDeep(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an object with nested objects
* const obj = { a: 1, b: { c: 1 } };
* const clonedObj = cloneDeep(obj);
* obj.b.c = 2;
* console.log(obj); // { a: 1, b: { c: 2 } }
* console.log(clonedObj); // { a: 1, b: { c: 1 } }
* console.log(clonedObj === obj); // false
*/ function $e64bba283a54ad54$export$629a2bd3f5a49ecc(obj) {
    return (0, $cscvQ.cloneDeepWithImpl)(obj, void 0, obj, /* @__PURE__ */ new Map(), void 0);
}

});
parcelRegister("cscvQ", function(module, exports) {

$parcel$export(module.exports, "cloneDeepWith", () => $bd5ff1d3437df767$export$684657552801b6ad);
$parcel$export(module.exports, "cloneDeepWithImpl", () => $bd5ff1d3437df767$export$c02997b71e1192aa);
$parcel$export(module.exports, "copyProperties", () => $bd5ff1d3437df767$export$65cf5700d290d9fa);

var $z2Z7K = parcelRequire("z2Z7K");

var $84O0U = parcelRequire("84O0U");

var $lPtAH = parcelRequire("lPtAH");

var $4Xffk = parcelRequire("4Xffk");

var $ckydW = parcelRequire("ckydW");

var $b9Ta2 = parcelRequire("b9Ta2");
//#region src/object/cloneDeepWith.ts
/**
* Deeply clones the given object.
*
* You can customize the deep cloning process using the `cloneValue` function.
* The function takes the current value `value`, the property name `key`, and the entire object `obj` as arguments.
* If the function returns a value, that value is used;
* if it returns `undefined`, the default cloning method is used.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @param [cloneValue] - A function to customize the cloning process.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeepWith(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an object with a customizer
* const obj = { a: 1, b: 2 };
* const clonedObj = cloneDeepWith(obj, (value) => {
*   if (typeof value === 'number') {
*     return value * 2; // Double the number
*   }
* });
* console.log(clonedObj); // { a: 2, b: 4 }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an array with a customizer
* const arr = [1, 2, 3];
* const clonedArr = cloneDeepWith(arr, (value) => {
*   if (typeof value === 'number') {
*     return value + 1; // Increment each number
*   }
* });
* console.log(clonedArr); // [2, 3, 4]
* console.log(clonedArr === arr); // false
*/ function $bd5ff1d3437df767$export$684657552801b6ad(obj, cloneValue) {
    return $bd5ff1d3437df767$export$c02997b71e1192aa(obj, void 0, obj, /* @__PURE__ */ new Map(), cloneValue);
}
function $bd5ff1d3437df767$export$c02997b71e1192aa(valueToClone, keyToClone, objectToClone, stack = /* @__PURE__ */ new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== void 0) return cloned;
    if ((0, $z2Z7K.isPrimitive)(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $bd5ff1d3437df767$export$c02997b71e1192aa(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, "index")) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, "input")) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = /* @__PURE__ */ new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, $bd5ff1d3437df767$export$c02997b71e1192aa(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = /* @__PURE__ */ new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add($bd5ff1d3437df767$export$c02997b71e1192aa(value, void 0, objectToClone, stack, cloneValue));
        return result;
    }
    if ((0, $b9Ta2.isBuffer)(valueToClone)) return valueToClone.subarray();
    if ((0, $84O0U.isTypedArray)(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = $bd5ff1d3437df767$export$c02997b71e1192aa(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== "undefined" && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== "undefined" && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== "undefined" && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = structuredClone(valueToClone);
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        result.constructor = valueToClone.constructor;
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === "object" && $bd5ff1d3437df767$var$isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        $bd5ff1d3437df767$export$65cf5700d290d9fa(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function $bd5ff1d3437df767$export$65cf5700d290d9fa(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...(0, $lPtAH.getSymbols)(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = $bd5ff1d3437df767$export$c02997b71e1192aa(source[key], key, objectToClone, stack, cloneValue);
    }
}
function $bd5ff1d3437df767$var$isCloneableObject(object) {
    switch((0, $4Xffk.getTag)(object)){
        case 0, $ckydW.argumentsTag:
        case 0, $ckydW.arrayTag:
        case 0, $ckydW.arrayBufferTag:
        case 0, $ckydW.dataViewTag:
        case 0, $ckydW.booleanTag:
        case 0, $ckydW.dateTag:
        case 0, $ckydW.float32ArrayTag:
        case 0, $ckydW.float64ArrayTag:
        case 0, $ckydW.int8ArrayTag:
        case 0, $ckydW.int16ArrayTag:
        case 0, $ckydW.int32ArrayTag:
        case 0, $ckydW.mapTag:
        case 0, $ckydW.numberTag:
        case 0, $ckydW.objectTag:
        case 0, $ckydW.regexpTag:
        case 0, $ckydW.setTag:
        case 0, $ckydW.stringTag:
        case 0, $ckydW.symbolTag:
        case 0, $ckydW.uint8ArrayTag:
        case 0, $ckydW.uint8ClampedArrayTag:
        case 0, $ckydW.uint16ArrayTag:
        case 0, $ckydW.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}

});
parcelRegister("z2Z7K", function(module, exports) {

$parcel$export(module.exports, "isPrimitive", () => $88cdc6f569b9e11d$export$c3825b437cbdea5c);
//#region src/predicate/isPrimitive.ts
/**
* Checks whether a value is a JavaScript primitive.
* JavaScript primitives include null, undefined, strings, numbers, booleans, symbols, and bigints.
*
* @param value The value to check.
* @returns Returns true if `value` is a primitive, false otherwise.
*
* @example
* isPrimitive(null); // true
* isPrimitive(undefined); // true
* isPrimitive('123'); // true
* isPrimitive(false); // true
* isPrimitive(true); // true
* isPrimitive(Symbol('a')); // true
* isPrimitive(123n); // true
* isPrimitive({}); // false
* isPrimitive(new Date()); // false
* isPrimitive(new Map()); // false
* isPrimitive(new Set()); // false
* isPrimitive([1, 2, 3]); // false
*/ function $88cdc6f569b9e11d$export$c3825b437cbdea5c(value) {
    return value == null || typeof value !== "object" && typeof value !== "function";
}

});

parcelRegister("84O0U", function(module, exports) {

$parcel$export(module.exports, "isTypedArray", () => $683aa1a97b552066$export$b119cc7e1840e59c);
//#region src/predicate/isTypedArray.ts
/**
* Checks if a value is a TypedArray.
* @param x The value to check.
* @returns Returns true if `x` is a TypedArray, false otherwise.
*
* @example
* const arr = new Uint8Array([1, 2, 3]);
* isTypedArray(arr); // true
*
* const regularArray = [1, 2, 3];
* isTypedArray(regularArray); // false
*
* const buffer = new ArrayBuffer(16);
* isTypedArray(buffer); // false
*/ function $683aa1a97b552066$export$b119cc7e1840e59c(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});



parcelRegister("ewpCy", function(module, exports) {

$parcel$export(module.exports, "isMatch", () => $0f8a656c4c5321ee$export$b74c33566721f70f);

var $6RFsT = parcelRequire("6RFsT");
//#region src/compat/predicate/isMatch.ts
/**
* Checks if the target matches the source by comparing their structures and values.
* This function supports deep comparison for objects, arrays, maps, and sets.
*
* @param target - The target value to match against.
* @param source - The source value to match with.
* @returns Returns `true` if the target matches the source, otherwise `false`.
*
* @example
* // Basic usage
* isMatch({ a: 1, b: 2 }, { a: 1 }); // true
*
* @example
* // Matching arrays
* isMatch([1, 2, 3], [1, 2, 3]); // true
*
* @example
* // Matching maps
* const targetMap = new Map([['key1', 'value1'], ['key2', 'value2']]);
* const sourceMap = new Map([['key1', 'value1']]);
* isMatch(targetMap, sourceMap); // true
*
* @example
* // Matching sets
* const targetSet = new Set([1, 2, 3]);
* const sourceSet = new Set([1, 2]);
* isMatch(targetSet, sourceSet); // true
*/ function $0f8a656c4c5321ee$export$b74c33566721f70f(target, source) {
    return (0, $6RFsT.isMatchWith)(target, source, ()=>void 0);
}

});
parcelRegister("6RFsT", function(module, exports) {

$parcel$export(module.exports, "isMatchWith", () => $f49e4238a5f461ed$export$4a897dfaa5ec0c53);

var $z2Z7K = parcelRequire("z2Z7K");

var $4Xffk = parcelRequire("4Xffk");


var $9j8Ey = parcelRequire("9j8Ey");

var $7OJrq = parcelRequire("7OJrq");
//#region src/compat/predicate/isMatchWith.ts
/**
* Performs a deep comparison between a target value and a source pattern to determine if they match,
* using a custom comparison function for fine-grained control over the matching logic.
*
* This function recursively traverses both values, calling the custom compare function for each
* property/element pair. If the compare function returns a boolean, that result is used directly.
* If it returns undefined, the default matching behavior continues recursively.
*
* The matching behavior varies by data type:
* - **Objects**: Matches if all properties in the source exist in the target and match
* - **Arrays**: Matches if all elements in the source array can be found in the target array (order-independent)
* - **Maps**: Matches if all key-value pairs in the source Map exist and match in the target Map
* - **Sets**: Matches if all elements in the source Set can be found in the target Set
* - **Functions**: Matches using strict equality, or object comparison if the function has properties
* - **Primitives**: Matches using strict equality
*
* Special cases:
* - Empty arrays, Maps, and Sets always match any target
* - An empty object matches any target at the top level, but at nested levels it only matches object targets
* - `null` and `undefined` source values have specific matching rules
* - Circular references are handled using an internal stack to prevent infinite recursion
*
* @param target - The value to be tested for matching
* @param source - The pattern/template to match against
* @param [compare] - Optional custom comparison function that receives:
*   - `objValue` - The value from the target at the current path
*   - `srcValue` - The value from the source at the current path
*   - `key` - The property key or array index being compared
*   - `object` - The parent object/array from the target
*   - `source` - The parent object/array from the source
*   - `stack` - Internal Map used for circular reference detection
*   Should return `true` for a match, `false` for no match, or `undefined` to continue with default behavior
*
* @returns `true` if the target matches the source pattern, `false` otherwise
*
* @example
* // Basic matching without custom comparator
* isMatchWith({ a: 1, b: 2 }, { a: 1 }); // true
* isMatchWith([1, 2, 3], [1, 3]); // true
*
* @example
* // Custom comparison for case-insensitive string matching
* const caseInsensitiveCompare = (objVal, srcVal) => {
*   if (typeof objVal === 'string' && typeof srcVal === 'string') {
*     return objVal.toLowerCase() === srcVal.toLowerCase();
*   }
*   return undefined; // Use default behavior for non-strings
* };
*
* isMatchWith(
*   { name: 'JOHN', age: 30 },
*   { name: 'john' },
*   caseInsensitiveCompare
* ); // true
*
* @example
* // Custom comparison for range matching
* const rangeCompare = (objVal, srcVal, key) => {
*   if (key === 'age' && typeof srcVal === 'object' && srcVal.min !== undefined) {
*     return objVal >= srcVal.min && objVal <= srcVal.max;
*   }
*   return undefined;
* };
*
* isMatchWith(
*   { name: 'John', age: 25 },
*   { age: { min: 18, max: 30 } },
*   rangeCompare
* ); // true
*/ function $f49e4238a5f461ed$export$4a897dfaa5ec0c53(target, source, compare) {
    if (typeof compare !== "function") return $f49e4238a5f461ed$export$4a897dfaa5ec0c53(target, source, ()=>void 0);
    return $f49e4238a5f461ed$var$isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== void 0) return Boolean(isEqual);
        return $f49e4238a5f461ed$var$isMatchWithInternal(objValue, srcValue, doesMatch, stack, false);
    }, /* @__PURE__ */ new Map(), true);
}
function $f49e4238a5f461ed$var$isMatchWithInternal(target, source, compare, stack, isRoot = false) {
    if (source === target) return true;
    switch(typeof source){
        case "object":
            return $f49e4238a5f461ed$var$isObjectMatch(target, source, compare, stack, isRoot);
        case "function":
            if (Object.keys(source).length > 0) return $f49e4238a5f461ed$var$isMatchWithInternal(target, {
                ...source
            }, compare, stack, isRoot);
            return (0, $9j8Ey.eq)(target, source);
        default:
            if (!(0, $7OJrq.isObject)(target)) return (0, $9j8Ey.eq)(target, source);
            if (isRoot) {
                if (typeof source === "string") return source === "";
                return true;
            }
            return (0, $9j8Ey.eq)(target, source);
    }
}
function $f49e4238a5f461ed$var$isObjectMatch(target, source, compare, stack, isRoot = false) {
    if (source == null) return true;
    if (Array.isArray(source)) return $f49e4238a5f461ed$var$isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return $f49e4238a5f461ed$var$isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return $f49e4238a5f461ed$var$isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null) return isRoot && keys.length === 0;
    if (isRoot) {
        if ((0, $z2Z7K.isPrimitive)(target)) target = Object(target);
    } else {
        const tag = (0, $4Xffk.getTag)(target);
        if (tag !== "[object Object]" && tag !== "[object Arguments]") return false;
    }
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!(key in target)) return false;
            if (source[key] === void 0 && target[key] !== void 0) return false;
            if (source[key] === null && target[key] !== null) return false;
            if (!compare(target[key], source[key], key, target, source, stack)) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function $f49e4238a5f461ed$var$isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries())if (compare(target.get(key), sourceValue, key, target, source, stack) === false) return false;
    return true;
}
function $f49e4238a5f461ed$var$isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = /* @__PURE__ */ new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            if (compare(targetItem, sourceItem, i, target, source, stack)) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function $f49e4238a5f461ed$var$isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return $f49e4238a5f461ed$var$isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}

});



parcelRegister("hVHPO", function(module, exports) {

$parcel$export(module.exports, "matchesProperty", () => $c5ba6e4952b7d61a$export$d3e698d53f63efcd);

var $fjtRE = parcelRequire("fjtRE");

var $iqxMM = parcelRequire("iqxMM");

var $ewpCy = parcelRequire("ewpCy");

var $kV4N2 = parcelRequire("kV4N2");

var $8AIrA = parcelRequire("8AIrA");
//#region src/compat/predicate/matchesProperty.ts
/**
* Creates a function that checks if a given target object matches a specific property value.
*
* The returned function takes a target object and determines if the property at the
* specified path within the target object is equal to the given value.
*
* @param property - The property path to check within the target object.
*     This can be a single property key or an array of property keys.
* @param source - The value to compare against the property value in the target object.
*
* @returns A function that takes a target object and returns
*     `true` if the property value at the given path in the target object matches the provided value,
*     otherwise returns `false`.
*
* @example
* // Using a single property key
* const checkName = matchesProperty('name', 'Alice');
* console.log(checkName({ name: 'Alice' })); // true
* console.log(checkName({ name: 'Bob' })); // false
*
* // Using an array of property keys
* const checkNested = matchesProperty(['address', 'city'], 'New York');
* console.log(checkNested({ address: { city: 'New York' } })); // true
* console.log(checkNested({ address: { city: 'Los Angeles' } })); // false
*/ function $c5ba6e4952b7d61a$export$d3e698d53f63efcd(property, source) {
    switch(typeof property){
        case "object":
            if (Object.is(property?.valueOf(), -0)) property = "-0";
            break;
        case "number":
            property = (0, $fjtRE.toKey)(property);
            break;
    }
    source = (0, $kV4N2.cloneDeep)(source);
    return function(target) {
        const result = (0, $iqxMM.get)(target, property);
        if (result === void 0) return (0, $8AIrA.has)(target, property);
        if (source === void 0) return result === void 0;
        return (0, $ewpCy.isMatch)(result, source);
    };
}

});
parcelRegister("kV4N2", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $c822db068fa6ae25$export$629a2bd3f5a49ecc);

var $1N7UW = parcelRequire("1N7UW");
//#region src/compat/object/cloneDeep.ts
/**
* Creates a deep clone of the given object.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = clone(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an array
* const arr = [1, 2, 3];
* const clonedArr = cloneDeep(arr);
* console.log(clonedArr); // [1, 2, 3]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an array with nested objects
* const arr = [1, { a: 1 }, [1, 2, 3]];
* const clonedArr = cloneDeep(arr);
* arr[1].a = 2;
* console.log(arr); // [1, { a: 2 }, [1, 2, 3]]
* console.log(clonedArr); // [1, { a: 1 }, [1, 2, 3]]
* console.log(clonedArr === arr); // false
*
* @example
* // Clone an object
* const obj = { a: 1, b: 'es-toolkit', c: [1, 2, 3] };
* const clonedObj = cloneDeep(obj);
* console.log(clonedObj); // { a: 1, b: 'es-toolkit', c: [1, 2, 3] }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an object with nested objects
* const obj = { a: 1, b: { c: 1 } };
* const clonedObj = cloneDeep(obj);
* obj.b.c = 2;
* console.log(obj); // { a: 1, b: { c: 2 } }
* console.log(clonedObj); // { a: 1, b: { c: 1 } }
* console.log(clonedObj === obj); // false
*/ function $c822db068fa6ae25$export$629a2bd3f5a49ecc(obj) {
    return (0, $1N7UW.cloneDeepWith)(obj);
}

});
parcelRegister("1N7UW", function(module, exports) {

$parcel$export(module.exports, "cloneDeepWith", () => $4a232c0d2b34349b$export$684657552801b6ad);

var $4Xffk = parcelRequire("4Xffk");

var $ckydW = parcelRequire("ckydW");

var $cscvQ = parcelRequire("cscvQ");
//#region src/compat/object/cloneDeepWith.ts
/**
* Creates a deep clone of the given object using a customizer function.
*
* @template T - The type of the object.
* @param obj - The object to clone.
* @param [cloneValue] - A function to customize the cloning process.
* @returns A deep clone of the given object.
*
* @example
* // Clone a primitive value
* const num = 29;
* const clonedNum = cloneDeepWith(num);
* console.log(clonedNum); // 29
* console.log(clonedNum === num); // true
*
* @example
* // Clone an object with a customizer
* const obj = { a: 1, b: 2 };
* const clonedObj = cloneDeepWith(obj, (value) => {
*   if (typeof value === 'number') {
*     return value * 2; // Double the number
*   }
* });
* console.log(clonedObj); // { a: 2, b: 4 }
* console.log(clonedObj === obj); // false
*
* @example
* // Clone an array with a customizer
* const arr = [1, 2, 3];
* const clonedArr = cloneDeepWith(arr, (value) => {
*   if (typeof value === 'number') {
*     return value + 1; // Increment each number
*   }
* });
* console.log(clonedArr); // [2, 3, 4]
* console.log(clonedArr === arr); // false
*/ function $4a232c0d2b34349b$export$684657552801b6ad(obj, customizer) {
    return (0, $cscvQ.cloneDeepWith)(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== void 0) return cloned;
        if (typeof obj !== "object") return;
        if ((0, $4Xffk.getTag)(obj) === "[object Object]" && typeof obj.constructor !== "function") {
            const result = {};
            stack.set(obj, result);
            (0, $cscvQ.copyProperties)(result, obj, object, stack);
            return result;
        }
        switch(Object.prototype.toString.call(obj)){
            case 0, $ckydW.numberTag:
            case 0, $ckydW.stringTag:
            case 0, $ckydW.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    (0, $cscvQ.copyProperties)(result, obj);
                    return result;
                }
            case 0, $ckydW.argumentsTag:
                {
                    const result = {};
                    (0, $cscvQ.copyProperties)(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return;
        }
    });
}

});


parcelRegister("8AIrA", function(module, exports) {

$parcel$export(module.exports, "has", () => $a5b8296c3f01b0d2$export$a4f4bb6b1453fff5);

var $HRXCf = parcelRequire("HRXCf");

var $hSotO = parcelRequire("hSotO");

var $ea0n3 = parcelRequire("ea0n3");

var $dckhC = parcelRequire("dckhC");
//#region src/compat/object/has.ts
/**
* Checks if a given path exists within an object.
*
* You can provide the path as a single property key, an array of property keys,
* or a string representing a deep path.
*
* If the path is an index and the object is an array or an arguments object, the function will verify
* if the index is valid and within the bounds of the array or arguments object, even if the array or
* arguments object is sparse (i.e., not all indexes are defined).
*
* @param object - The object to query.
* @param path - The path to check. This can be a single property key,
*        an array of property keys, or a string representing a deep path.
* @returns Returns `true` if the path exists in the object, `false` otherwise.
*
* @example
*
* const obj = { a: { b: { c: 3 } } };
*
* has(obj, 'a'); // true
* has(obj, ['a', 'b']); // true
* has(obj, ['a', 'b', 'c']); // true
* has(obj, 'a.b.c'); // true
* has(obj, 'a.b.d'); // false
* has(obj, ['a', 'b', 'c', 'd']); // false
* has([], 0); // false
* has([1, 2, 3], 2); // true
* has([1, 2, 3], 5); // false
*/ function $a5b8296c3f01b0d2$export$a4f4bb6b1453fff5(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === "string" && (0, $HRXCf.isDeepKey)(path) && !(path in Object(object))) resolvedPath = (0, $hSotO.toPath)(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            if (!((Array.isArray(current) || (0, $dckhC.isArguments)(current)) && (0, $ea0n3.isIndex)(key) && key < current.length)) return false;
        }
        current = current[key];
    }
    return true;
}

});
parcelRegister("dckhC", function(module, exports) {

$parcel$export(module.exports, "isArguments", () => $ef819e2f3a9b8879$export$dbbb9d8cd6fff001);

var $4Xffk = parcelRequire("4Xffk");
//#region src/compat/predicate/isArguments.ts
/**
* Checks if the given value is an arguments object.
*
* This function tests whether the provided value is an arguments object or not.
* It returns `true` if the value is an arguments object, and `false` otherwise.
*
* This function can also serve as a type predicate in TypeScript, narrowing the type of the argument to an arguments object.
*
* @param value - The value to test if it is an arguments object.
* @returns `true` if the value is an arguments, `false` otherwise.
*
* @example
* const args = (function() { return arguments; })();
* const strictArgs = (function() { 'use strict'; return arguments; })();
* const value = [1, 2, 3];
*
* console.log(isArguments(args)); // true
* console.log(isArguments(strictArgs)); // true
* console.log(isArguments(value)); // false
*/ function $ef819e2f3a9b8879$export$dbbb9d8cd6fff001(value) {
    return value !== null && typeof value === "object" && (0, $4Xffk.getTag)(value) === "[object Arguments]";
}

});




parcelRegister("8GKE1", function(module, exports) {

$parcel$export(module.exports, "normalizeZero", () => $f4798d4515a30eab$export$7718de76cb1729bc);
//#region src/compat/_internal/normalizeZero.ts
/**
* Normalizes `-0` to `0` to match Lodash, which normalizes `-0` to `+0` in the
* results of functions like `uniq`, `union`, and `difference`.
*
* @param value - The value to normalize.
* @returns The value with `-0` normalized to `0`.
*/ function $f4798d4515a30eab$export$7718de76cb1729bc(value) {
    return value === 0 ? 0 : value;
}

});



parcelRegister("84bJN", function(module, exports) {

$parcel$export(module.exports, "useElementOffset", () => $5df7cd4fc39ce268$export$35f58fcda6094144);

var $acw62 = parcelRequire("acw62");
function $5df7cd4fc39ce268$var$_slicedToArray(r, e) {
    return $5df7cd4fc39ce268$var$_arrayWithHoles(r) || $5df7cd4fc39ce268$var$_iterableToArrayLimit(r, e) || $5df7cd4fc39ce268$var$_unsupportedIterableToArray(r, e) || $5df7cd4fc39ce268$var$_nonIterableRest();
}
function $5df7cd4fc39ce268$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5df7cd4fc39ce268$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5df7cd4fc39ce268$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5df7cd4fc39ce268$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5df7cd4fc39ce268$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5df7cd4fc39ce268$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $5df7cd4fc39ce268$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $5df7cd4fc39ce268$var$EPS = 1;
/**
 * Stores the dimensions and position of a DOM element as returned by `getBoundingClientRect()`.
 *
 * Values are viewport-relative and may be fractional (subpixel precision).
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect}
 */ /**
 * Callback ref setter returned by {@link useElementOffset}.
 *
 * Pass this to a DOM element's `ref` prop to start observing its layout.
 *
 * @param node - the DOM element to observe, or `null` when the element unmounts
 */ /**
 * Checks whether two ElementOffset values differ by more than `EPS` (1px) in any dimension.
 *
 * @param a - the first ElementOffset to compare
 * @param b - the second ElementOffset to compare
 * @returns true if any dimension differs by more than 1px
 */ function $5df7cd4fc39ce268$var$hasSignificantChange(a, b) {
    return Math.abs(a.height - b.height) > $5df7cd4fc39ce268$var$EPS || Math.abs(a.left - b.left) > $5df7cd4fc39ce268$var$EPS || Math.abs(a.top - b.top) > $5df7cd4fc39ce268$var$EPS || Math.abs(a.width - b.width) > $5df7cd4fc39ce268$var$EPS;
}
/**
 * Reads the current bounding box of a DOM element using `getBoundingClientRect()`.
 *
 * @param node - the DOM element to measure
 * @returns an ElementOffset with the element's current dimensions and viewport-relative position
 */ function $5df7cd4fc39ce268$var$readElementOffset(node) {
    var rect = node.getBoundingClientRect();
    return {
        height: rect.height,
        left: rect.left,
        top: rect.top,
        width: rect.width
    };
}
function $5df7cd4fc39ce268$export$35f58fcda6094144() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var _useState = (0, $acw62.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    }), _useState2 = $5df7cd4fc39ce268$var$_slicedToArray(_useState, 2), lastBoundingBox = _useState2[0], setLastBoundingBox = _useState2[1];
    var observerRef = (0, $acw62.useRef)(null);
    var lastBoundingBoxRef = (0, $acw62.useRef)(lastBoundingBox);
    lastBoundingBoxRef.current = lastBoundingBox;
    var updateBoundingBox = (0, $acw62.useCallback)((node)=>{
        // Disconnect any previously active ResizeObserver
        if (observerRef.current != null) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (node != null) {
            // Measure immediately on ref attach
            var box = $5df7cd4fc39ce268$var$readElementOffset(node);
            if ($5df7cd4fc39ce268$var$hasSignificantChange(box, lastBoundingBoxRef.current)) setLastBoundingBox(box);
            // Set up ResizeObserver for future size changes
            if (typeof ResizeObserver !== 'undefined') {
                var observer = new ResizeObserver(()=>{
                    var newBox = $5df7cd4fc39ce268$var$readElementOffset(node);
                    if ($5df7cd4fc39ce268$var$hasSignificantChange(newBox, lastBoundingBoxRef.current)) setLastBoundingBox(newBox);
                });
                observer.observe(node);
                observerRef.current = observer;
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...extraDependencies
    ]);
    // Cleanup on unmount
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            var _observerRef$current;
            (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 || _observerRef$current.disconnect();
        };
    }, []);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}

});

parcelRegister("iq83J", function(module, exports) {

$parcel$export(module.exports, "Cursor", () => $d690e81478a10d12$export$b6a79797ad180576);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $cpMpC = parcelRequire("cpMpC");

var $f2bYI = parcelRequire("f2bYI");

var $3GoXm = parcelRequire("3GoXm");

var $lpdtS = parcelRequire("lpdtS");

var $9HjDY = parcelRequire("9HjDY");

var $42cds = parcelRequire("42cds");

var $4zntx = parcelRequire("4zntx");

var $a01al = parcelRequire("a01al");

var $jHn5r = parcelRequire("jHn5r");

var $3S4Ih = parcelRequire("3S4Ih");

var $72R3N = parcelRequire("72R3N");

var $4M6vj = parcelRequire("4M6vj");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");
function $d690e81478a10d12$var$_extends() {
    return $d690e81478a10d12$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d690e81478a10d12$var$_extends.apply(null, arguments);
}
function $d690e81478a10d12$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d690e81478a10d12$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d690e81478a10d12$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d690e81478a10d12$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d690e81478a10d12$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d690e81478a10d12$var$_defineProperty(e, r, t) {
    return (r = $d690e81478a10d12$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $d690e81478a10d12$var$_toPropertyKey(t) {
    var i = $d690e81478a10d12$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $d690e81478a10d12$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function $d690e81478a10d12$var$RenderCursor(_ref) {
    var cursor = _ref.cursor, cursorComp = _ref.cursorComp, cursorProps = _ref.cursorProps;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(cursor)) return /*#__PURE__*/ (0, $acw62.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, $acw62.createElement)(cursorComp, cursorProps);
}
function $d690e81478a10d12$export$3ea3a57cbaeb6b4e(props) {
    var _props$zIndex;
    var coordinate = props.coordinate, payload = props.payload, index = props.index, offset = props.offset, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, cursor = props.cursor, tooltipEventType = props.tooltipEventType, chartName = props.chartName;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $3GoXm.Cross);
        preferredZIndex = (0, $gKNgz.DefaultZIndexes).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, $lpdtS.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $9HjDY.Rectangle);
        preferredZIndex = (0, $gKNgz.DefaultZIndexes).cursorRectangle;
    } else if (layout === 'radial' && (0, $cpMpC.isPolarCoordinate)(activeCoordinate)) {
        var _getRadialCursorPoint = (0, $42cds.getRadialCursorPoints)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $4zntx.Sector);
        preferredZIndex = (0, $gKNgz.DefaultZIndexes).cursorLine;
    } else {
        restProps = {
            points: (0, $a01al.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $f2bYI.Curve);
        preferredZIndex = (0, $gKNgz.DefaultZIndexes).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = $d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread($d690e81478a10d12$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $9QePP.clsx)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ $acw62.createElement($d690e81478a10d12$var$RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function $d690e81478a10d12$export$b6a79797ad180576(props) {
    var tooltipAxisBandSize = (0, $3S4Ih.useTooltipAxisBandSize)();
    var offset = (0, $jHn5r.useOffsetInternal)();
    var layout = (0, $jHn5r.useChartLayout)();
    var chartName = (0, $72R3N.useChartName)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ $acw62.createElement($d690e81478a10d12$export$3ea3a57cbaeb6b4e, $d690e81478a10d12$var$_extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}

});
parcelRegister("f2bYI", function(module, exports) {

$parcel$export(module.exports, "Curve", () => $af2055905739b7f2$export$b0e83c3ef8d2db1);

var $acw62 = parcelRequire("acw62");
parcelRequire("5Dy28");
var $fEwLW = parcelRequire("fEwLW");
var $6QL1t = parcelRequire("6QL1t");
var $2515N = parcelRequire("2515N");
var $e1bEB = parcelRequire("e1bEB");
var $gpIrV = parcelRequire("gpIrV");
var $gEcf1 = parcelRequire("gEcf1");
var $4CT3t = parcelRequire("4CT3t");
var $hp3ls = parcelRequire("hp3ls");
var $kjPWc = parcelRequire("kjPWc");
var $1zRZO = parcelRequire("1zRZO");
var $5ti2H = parcelRequire("5ti2H");

var $9QePP = parcelRequire("9QePP");

var $cpMpC = parcelRequire("cpMpC");

var $3FiDp = parcelRequire("3FiDp");

var $iMnqX = parcelRequire("iMnqX");

var $4M6vj = parcelRequire("4M6vj");

var $jHn5r = parcelRequire("jHn5r");
function $af2055905739b7f2$var$_extends() {
    return $af2055905739b7f2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af2055905739b7f2$var$_extends.apply(null, arguments);
}
function $af2055905739b7f2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $af2055905739b7f2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $af2055905739b7f2$var$ownKeys(Object(t), !0).forEach(function(r) {
            $af2055905739b7f2$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $af2055905739b7f2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $af2055905739b7f2$var$_defineProperty(e, r, t) {
    return (r = $af2055905739b7f2$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $af2055905739b7f2$var$_toPropertyKey(t) {
    var i = $af2055905739b7f2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $af2055905739b7f2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $af2055905739b7f2$var$CURVE_FACTORIES = {
    curveBasisClosed: $2515N.default,
    curveBasisOpen: $e1bEB.default,
    curveBasis: $6QL1t.default,
    curveBumpX: $gpIrV.bumpX,
    curveBumpY: $gpIrV.bumpY,
    curveLinearClosed: $4CT3t.default,
    curveLinear: $gEcf1.default,
    curveMonotoneX: $hp3ls.monotoneX,
    curveMonotoneY: $hp3ls.monotoneY,
    curveNatural: $kjPWc.default,
    curveStep: $1zRZO.default,
    curveStepAfter: $1zRZO.stepAfter,
    curveStepBefore: $1zRZO.stepBefore
};
/**
 * @inline
 */ /**
 * @inline
 */ var $af2055905739b7f2$var$defined = (p)=>(0, $iMnqX.isWellBehavedNumber)(p.x) && (0, $iMnqX.isWellBehavedNumber)(p.y);
var $af2055905739b7f2$var$areaDefined = (d)=>d.base != null && $af2055905739b7f2$var$defined(d.base) && $af2055905739b7f2$var$defined(d);
var $af2055905739b7f2$var$getX = (p)=>p.x;
var $af2055905739b7f2$var$getY = (p)=>p.y;
var $af2055905739b7f2$var$getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, $3FiDp.upperFirst)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) {
        var factory = $af2055905739b7f2$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
        if (factory) return factory;
    }
    return $af2055905739b7f2$var$CURVE_FACTORIES[name] || (0, $gEcf1.default);
};
var $af2055905739b7f2$export$4ad7f9093e086ed7 = {
    connectNulls: false,
    type: 'linear'
};
var $af2055905739b7f2$export$2aa3fd96c49a84a8 = (_ref)=>{
    var _ref$type = _ref.type, type = _ref$type === void 0 ? $af2055905739b7f2$export$4ad7f9093e086ed7.type : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? $af2055905739b7f2$export$4ad7f9093e086ed7.connectNulls : _ref$connectNulls;
    var curveFactory = $af2055905739b7f2$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter($af2055905739b7f2$var$defined) : points;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var _lineFunction;
        var areaPoints = points.map((entry, index)=>$af2055905739b7f2$var$_objectSpread($af2055905739b7f2$var$_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') _lineFunction = (0, $fEwLW.default)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0((d)=>d.base.x);
        else _lineFunction = (0, $fEwLW.default)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not, and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
        var _nullableLineFunction = _lineFunction.defined($af2055905739b7f2$var$areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter($af2055905739b7f2$var$areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    var lineFunction;
    if (layout === 'vertical' && (0, $3FiDp.isNumber)(baseLine)) lineFunction = (0, $fEwLW.default)().y($af2055905739b7f2$var$getY).x1($af2055905739b7f2$var$getX).x0(baseLine);
    else if ((0, $3FiDp.isNumber)(baseLine)) lineFunction = (0, $fEwLW.default)().x($af2055905739b7f2$var$getX).y1($af2055905739b7f2$var$getY).y0(baseLine);
    else lineFunction = (0, $5ti2H.default)().x($af2055905739b7f2$var$getX).y($af2055905739b7f2$var$getY);
    // @ts-expect-error the defined call changes the generic type internally but d3 types don't reflect that
    var nullableLineFunction = lineFunction.defined($af2055905739b7f2$var$defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var $af2055905739b7f2$export$b0e83c3ef8d2db1 = (props)=>{
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    var layout = (0, $jHn5r.useChartLayout)();
    if ((!points || !points.length) && !path) return null;
    var getPathInput = {
        type: props.type,
        points: props.points,
        baseLine: props.baseLine,
        layout: props.layout || layout,
        connectNulls: props.connectNulls
    };
    var realPath = points && points.length ? $af2055905739b7f2$export$2aa3fd96c49a84a8(getPathInput) : path;
    return /*#__PURE__*/ $acw62.createElement("path", $af2055905739b7f2$var$_extends({}, (0, $4M6vj.svgPropertiesNoEvents)(props), (0, $cpMpC.adaptEventHandlers)(props), {
        className: (0, $9QePP.clsx)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};

});

parcelRegister("3GoXm", function(module, exports) {

$parcel$export(module.exports, "Cross", () => $2ae8a72d4579aba0$export$3c877bb842c36952);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $3FiDp = parcelRequire("3FiDp");

var $lTk0V = parcelRequire("lTk0V");
var $2ae8a72d4579aba0$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $2ae8a72d4579aba0$var$_extends() {
    return $2ae8a72d4579aba0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ae8a72d4579aba0$var$_extends.apply(null, arguments);
}
function $2ae8a72d4579aba0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ae8a72d4579aba0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ae8a72d4579aba0$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2ae8a72d4579aba0$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ae8a72d4579aba0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2ae8a72d4579aba0$var$_defineProperty(e, r, t) {
    return (r = $2ae8a72d4579aba0$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2ae8a72d4579aba0$var$_toPropertyKey(t) {
    var i = $2ae8a72d4579aba0$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2ae8a72d4579aba0$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2ae8a72d4579aba0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2ae8a72d4579aba0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2ae8a72d4579aba0$var$getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $2ae8a72d4579aba0$export$3c877bb842c36952 = (_ref)=>{
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $2ae8a72d4579aba0$var$_objectWithoutProperties(_ref, $2ae8a72d4579aba0$var$_excluded);
    var props = $2ae8a72d4579aba0$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $3FiDp.isNumber)(x) || !(0, $3FiDp.isNumber)(y) || !(0, $3FiDp.isNumber)(width) || !(0, $3FiDp.isNumber)(height) || !(0, $3FiDp.isNumber)(top) || !(0, $3FiDp.isNumber)(left)) return null;
    return /*#__PURE__*/ $acw62.createElement("path", $2ae8a72d4579aba0$var$_extends({}, (0, $lTk0V.svgPropertiesAndEvents)(props), {
        className: (0, $9QePP.clsx)('recharts-cross', className),
        d: $2ae8a72d4579aba0$var$getPath(x, y, width, height, top, left)
    }));
};

});

parcelRegister("lpdtS", function(module, exports) {

$parcel$export(module.exports, "getCursorRectangle", () => $f95663c86cd8230d$export$f84ec1ecc69a13c9);
function $f95663c86cd8230d$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}

});

parcelRegister("9HjDY", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $70f75e095c9bb92d$export$4617fb02663045ef);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $cd9rh = parcelRequire("cd9rh");

var $62gKq = parcelRequire("62gKq");

var $3FiDp = parcelRequire("3FiDp");

var $9NuBN = parcelRequire("9NuBN");

var $2t5bf = parcelRequire("2t5bf");

var $lTk0V = parcelRequire("lTk0V");

var $erqUX = parcelRequire("erqUX");
var $70f75e095c9bb92d$var$_excluded = [
    "radius"
], $70f75e095c9bb92d$var$_excluded2 = [
    "radius"
];
var $70f75e095c9bb92d$var$_templateObject, $70f75e095c9bb92d$var$_templateObject2, $70f75e095c9bb92d$var$_templateObject3, $70f75e095c9bb92d$var$_templateObject4, $70f75e095c9bb92d$var$_templateObject5, $70f75e095c9bb92d$var$_templateObject6, $70f75e095c9bb92d$var$_templateObject7, $70f75e095c9bb92d$var$_templateObject8, $70f75e095c9bb92d$var$_templateObject9, $70f75e095c9bb92d$var$_templateObject0;
function $70f75e095c9bb92d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70f75e095c9bb92d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70f75e095c9bb92d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $70f75e095c9bb92d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70f75e095c9bb92d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70f75e095c9bb92d$var$_defineProperty(e, r, t) {
    return (r = $70f75e095c9bb92d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $70f75e095c9bb92d$var$_toPropertyKey(t) {
    var i = $70f75e095c9bb92d$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $70f75e095c9bb92d$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $70f75e095c9bb92d$var$_extends() {
    return $70f75e095c9bb92d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $70f75e095c9bb92d$var$_extends.apply(null, arguments);
}
function $70f75e095c9bb92d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $70f75e095c9bb92d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $70f75e095c9bb92d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $70f75e095c9bb92d$var$_slicedToArray(r, e) {
    return $70f75e095c9bb92d$var$_arrayWithHoles(r) || $70f75e095c9bb92d$var$_iterableToArrayLimit(r, e) || $70f75e095c9bb92d$var$_unsupportedIterableToArray(r, e) || $70f75e095c9bb92d$var$_nonIterableRest();
}
function $70f75e095c9bb92d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70f75e095c9bb92d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $70f75e095c9bb92d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $70f75e095c9bb92d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $70f75e095c9bb92d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $70f75e095c9bb92d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $70f75e095c9bb92d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $70f75e095c9bb92d$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
/**
 * @inline
 */ var $70f75e095c9bb92d$var$getRectanglePath = (x, y, width, height, radius)=>{
    var roundedWidth = (0, $erqUX.round)(width);
    var roundedHeight = (0, $erqUX.round)(height);
    var maxRadius = Math.min(Math.abs(roundedWidth) / 2, Math.abs(roundedHeight) / 2);
    var ySign = roundedHeight >= 0 ? 1 : -1;
    var xSign = roundedWidth >= 0 ? 1 : -1;
    var clockWise = roundedHeight >= 0 && roundedWidth >= 0 || roundedHeight < 0 && roundedWidth < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && Array.isArray(radius)) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++){
            var _radius$i;
            var r = (_radius$i = radius[i]) !== null && _radius$i !== void 0 ? _radius$i : 0;
            newRadius[i] = r > maxRadius ? maxRadius : r;
        }
        path = (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject || ($70f75e095c9bb92d$var$_templateObject = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "M",
            ",",
            ""
        ])), x, y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject2 || ($70f75e095c9bb92d$var$_templateObject2 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",",
            ",",
            ""
        ])), newRadius[0], newRadius[0], clockWise, x + xSign * newRadius[0], y);
        path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject3 || ($70f75e095c9bb92d$var$_templateObject3 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width - xSign * newRadius[1], y);
        if (newRadius[1] > 0) path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject4 || ($70f75e095c9bb92d$var$_templateObject4 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[1], newRadius[1], clockWise, x + width, y + ySign * newRadius[1]);
        path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject5 || ($70f75e095c9bb92d$var$_templateObject5 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width, y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject6 || ($70f75e095c9bb92d$var$_templateObject6 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[2], newRadius[2], clockWise, x + width - xSign * newRadius[2], y + height);
        path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject7 || ($70f75e095c9bb92d$var$_templateObject7 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + xSign * newRadius[3], y + height);
        if (newRadius[3] > 0) path += (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject8 || ($70f75e095c9bb92d$var$_templateObject8 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[3], newRadius[3], clockWise, x, y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject9 || ($70f75e095c9bb92d$var$_templateObject9 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            " Z"
        ])), x, y + ySign * _newRadius, _newRadius, _newRadius, clockWise, x + xSign * _newRadius, y, x + width - xSign * _newRadius, y, _newRadius, _newRadius, clockWise, x + width, y + ySign * _newRadius, x + width, y + height - ySign * _newRadius, _newRadius, _newRadius, clockWise, x + width - xSign * _newRadius, y + height, x + xSign * _newRadius, y + height, _newRadius, _newRadius, clockWise, x, y + height - ySign * _newRadius);
    } else path = (0, $erqUX.roundTemplateLiteral)($70f75e095c9bb92d$var$_templateObject0 || ($70f75e095c9bb92d$var$_templateObject0 = $70f75e095c9bb92d$var$_taggedTemplateLiteral([
        "M ",
        ",",
        " h ",
        " v ",
        " h ",
        " Z"
    ])), x, y, width, height, -width);
    return path;
};
var $70f75e095c9bb92d$export$90e429de6eb3e62f = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $70f75e095c9bb92d$export$4617fb02663045ef = (rectangleProps)=>{
    var props = (0, $cd9rh.resolveDefaultProps)(rectangleProps, $70f75e095c9bb92d$export$90e429de6eb3e62f);
    var pathRef = (0, $acw62.useRef)(null);
    var _useState = (0, $acw62.useState)(-1), _useState2 = $70f75e095c9bb92d$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $acw62.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    var prevWidthRef = (0, $acw62.useRef)(width);
    var prevHeightRef = (0, $acw62.useRef)(height);
    var prevXRef = (0, $acw62.useRef)(x);
    var prevYRef = (0, $acw62.useRef)(y);
    var animationIdInput = (0, $acw62.useMemo)(()=>({
            x: x,
            y: y,
            width: width,
            height: height,
            radius: radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, $9NuBN.useAnimationId)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $9QePP.clsx)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, $lTk0V.svgPropertiesAndEvents)(props), _ = _svgPropertiesAndEven.radius, otherPathProps = $70f75e095c9bb92d$var$_objectWithoutProperties(_svgPropertiesAndEven, $70f75e095c9bb92d$var$_excluded);
        return /*#__PURE__*/ $acw62.createElement("path", $70f75e095c9bb92d$var$_extends({}, otherPathProps, {
            x: (0, $erqUX.round)(x),
            y: (0, $erqUX.round)(y),
            width: (0, $erqUX.round)(width),
            height: (0, $erqUX.round)(height),
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px ").concat(totalLength, "px");
    var transition = (0, $2t5bf.getTransitionVal)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : $70f75e095c9bb92d$export$90e429de6eb3e62f.animationEasing);
    return /*#__PURE__*/ $acw62.createElement((0, $62gKq.JavascriptAnimate), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (animationElapsedTime)=>{
        var currWidth = (0, $3FiDp.interpolate)(prevWidth, width, animationElapsedTime);
        var currHeight = (0, $3FiDp.interpolate)(prevHeight, height, animationElapsedTime);
        var currX = (0, $3FiDp.interpolate)(prevX, x, animationElapsedTime);
        var currY = (0, $3FiDp.interpolate)(prevY, y, animationElapsedTime);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (animationElapsedTime > 0) animationStyle = {
            transition: transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, $lTk0V.svgPropertiesAndEvents)(props), _ = _svgPropertiesAndEven2.radius, otherPathProps = $70f75e095c9bb92d$var$_objectWithoutProperties(_svgPropertiesAndEven2, $70f75e095c9bb92d$var$_excluded2);
        return /*#__PURE__*/ $acw62.createElement("path", $70f75e095c9bb92d$var$_extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: $70f75e095c9bb92d$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: $70f75e095c9bb92d$var$_objectSpread($70f75e095c9bb92d$var$_objectSpread({}, animationStyle), props.style)
        }));
    });
};

});
parcelRegister("62gKq", function(module, exports) {

$parcel$export(module.exports, "JavascriptAnimate", () => $464febc3f716710f$export$5d41821894c47c52);

var $acw62 = parcelRequire("acw62");

var $3FiDp = parcelRequire("3FiDp");

var $cd9rh = parcelRequire("cd9rh");

var $aTx8d = parcelRequire("aTx8d");

var $4xC3v = parcelRequire("4xC3v");

var $apNs5 = parcelRequire("apNs5");

var $caA7u = parcelRequire("caA7u");

var $l8v4E = parcelRequire("l8v4E");

var $h2iMT = parcelRequire("h2iMT");
function $464febc3f716710f$var$_slicedToArray(r, e) {
    return $464febc3f716710f$var$_arrayWithHoles(r) || $464febc3f716710f$var$_iterableToArrayLimit(r, e) || $464febc3f716710f$var$_unsupportedIterableToArray(r, e) || $464febc3f716710f$var$_nonIterableRest();
}
function $464febc3f716710f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $464febc3f716710f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $464febc3f716710f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $464febc3f716710f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $464febc3f716710f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $464febc3f716710f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $464febc3f716710f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $464febc3f716710f$var$defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var $464febc3f716710f$var$from = 0;
var $464febc3f716710f$var$to = 1;
function $464febc3f716710f$export$5d41821894c47c52(outsideProps) {
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $464febc3f716710f$var$defaultJavascriptAnimateProps);
    var animationId = props.animationId, isActiveProp = props.isActive, canBegin = props.canBegin, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart, children = props.children;
    var prefersReducedMotion = (0, $caA7u.usePrefersReducedMotion)();
    var isActive = isActiveProp === 'auto' ? !(0, $apNs5.Global).isSsr && !prefersReducedMotion : isActiveProp;
    var animationController = (0, $4xC3v.useAnimationController)(props.animationController);
    var _useState = (0, $acw62.useState)(isActive ? $464febc3f716710f$var$from : $464febc3f716710f$var$to), _useState2 = $464febc3f716710f$var$_slicedToArray(_useState, 2), style = _useState2[0], setStyle = _useState2[1];
    (0, $acw62.useEffect)(()=>{
        if (!isActive) setStyle($464febc3f716710f$var$to);
    }, [
        isActive
    ]);
    (0, $acw62.useEffect)(()=>{
        var easingFunction = (0, $aTx8d.createEasingFunction)(easing);
        if (!isActive || !canBegin || easingFunction == null) return 0, $3FiDp.noop;
        var timeoutController = new (0, $h2iMT.RequestAnimationFrameTimeoutController)();
        var animation = new (0, $l8v4E.JavascriptAnimation)({
            animationId: animationId,
            easing: easingFunction,
            animationDuration: duration,
            animationBegin: begin,
            onAnimationStart: onAnimationStart,
            onAnimationEnd: onAnimationEnd,
            from: $464febc3f716710f$var$from,
            to: $464febc3f716710f$var$to
        });
        return animationController(timeoutController, animation, setStyle);
    }, [
        animationController,
        animationId,
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd
    ]);
    return children(Number(style));
}

});
parcelRegister("aTx8d", function(module, exports) {

$parcel$export(module.exports, "createEasingFunction", () => $7ee8bda874947449$export$a31f8c98a8d327f6);
var $7ee8bda874947449$export$73dea3ad38069b0e = 1e-4;
var $7ee8bda874947449$var$cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var $7ee8bda874947449$var$evaluatePolynomial = (params, animationElapsedTime)=>params.map((param, i)=>param * animationElapsedTime ** i).reduce((pre, curr)=>pre + curr);
var $7ee8bda874947449$var$cubicBezier = (c1, c2)=>(animationElapsedTime)=>{
        var params = $7ee8bda874947449$var$cubicBezierFactor(c1, c2);
        return $7ee8bda874947449$var$evaluatePolynomial(params, animationElapsedTime);
    };
var $7ee8bda874947449$var$derivativeCubicBezier = (c1, c2)=>(animationElapsedTime)=>{
        var params = $7ee8bda874947449$var$cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return $7ee8bda874947449$var$evaluatePolynomial(newParams, animationElapsedTime);
    };
var $7ee8bda874947449$var$parseCubicBezier = (easing)=>{
    var _easingParts$;
    var easingParts = easing.split('(');
    if (easingParts.length !== 2 || easingParts[0] !== 'cubic-bezier') return null;
    var numbers = (_easingParts$ = easingParts[1]) === null || _easingParts$ === void 0 || (_easingParts$ = _easingParts$.split(')')[0]) === null || _easingParts$ === void 0 ? void 0 : _easingParts$.split(',');
    if (numbers == null || numbers.length !== 4) return null;
    var coords = numbers.map((x)=>parseFloat(x));
    return [
        coords[0],
        coords[1],
        coords[2],
        coords[3]
    ];
};
var $7ee8bda874947449$var$getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var easing = $7ee8bda874947449$var$parseCubicBezier(args[0]);
            if (easing) return easing;
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var $7ee8bda874947449$var$createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = $7ee8bda874947449$var$cubicBezier(x1, x2);
    var curveY = $7ee8bda874947449$var$cubicBezier(y1, y2);
    var derCurveX = $7ee8bda874947449$var$derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_animationElapsedTime)=>{
        var animationElapsedTime = _animationElapsedTime > 1 ? 1 : _animationElapsedTime;
        var x = animationElapsedTime;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - animationElapsedTime;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - animationElapsedTime) < $7ee8bda874947449$export$73dea3ad38069b0e || derVal < $7ee8bda874947449$export$73dea3ad38069b0e) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $7ee8bda874947449$export$56c51296f72f0592 = function configBezier() {
    return $7ee8bda874947449$var$createBezierEasing(...$7ee8bda874947449$var$getBezierCoordinates(...arguments));
};
var $7ee8bda874947449$export$94f3388918f77906 = function createSpringEasing() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 16.67 : _config$dt;
    var destX = 1;
    var positions = [
        0
    ];
    var currX = 0;
    var currV = 0;
    // Safety valve to prevent accidental infinite loops if physics config is extreme
    var maxIterations = 10000;
    var iterations = 0;
    // 1. Run the simulation until the spring completely stops moving
    while(iterations < maxIterations){
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        currV += (FSpring - FDamping) * dt / 1000;
        currX += currV * dt / 1000;
        positions.push(currX);
        // Stop only when position is essentially at 1.0 AND bounce velocity has died down
        if (Math.abs(currX - destX) < $7ee8bda874947449$export$73dea3ad38069b0e && Math.abs(currV) < $7ee8bda874947449$export$73dea3ad38069b0e) break;
        iterations++;
    }
    // Force the absolute final element to be exactly 1.0 for a perfect finish
    positions[positions.length - 1] = destX;
    var maxIndex = positions.length - 1;
    // 2. The ultra-smooth runtime function mapping your 0..1 progress
    return (t)=>{
        var _positions$index, _positions, _positions$index2;
        if (t <= 0) return 0;
        if (t >= 1) return destX;
        // Scale t (0..1) proportionally across our entire pre-calculated array
        var exactFrame = t * maxIndex;
        var index = Math.floor(exactFrame);
        var fraction = exactFrame - index;
        // Blend between the two closest frames
        return ((_positions$index = positions[index]) !== null && _positions$index !== void 0 ? _positions$index : 0) + (((_positions = positions[index + 1]) !== null && _positions !== void 0 ? _positions : 0) - ((_positions$index2 = positions[index]) !== null && _positions$index2 !== void 0 ? _positions$index2 : 0)) * fraction;
    };
};
var $7ee8bda874947449$export$a31f8c98a8d327f6 = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $7ee8bda874947449$export$56c51296f72f0592(easing);
        case 'spring':
            return $7ee8bda874947449$export$94f3388918f77906();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $7ee8bda874947449$export$56c51296f72f0592(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};

});

parcelRegister("4xC3v", function(module, exports) {

$parcel$export(module.exports, "useAnimationController", () => $34e7c387fdf55dd3$export$ee94dd081d01ef3);

var $acw62 = parcelRequire("acw62");

var $g8SFg = parcelRequire("g8SFg");
var $34e7c387fdf55dd3$var$AnimationControllerContext = /*#__PURE__*/ (0, $acw62.createContext)((0, $g8SFg.animationControllerImpl));
var $34e7c387fdf55dd3$export$b10c5b12aa53dc58 = $34e7c387fdf55dd3$var$AnimationControllerContext.Provider;
function $34e7c387fdf55dd3$export$ee94dd081d01ef3(animationControllerFromProps) {
    var animationControllerFromContext = (0, $acw62.useContext)($34e7c387fdf55dd3$var$AnimationControllerContext);
    return (0, $acw62.useMemo)(()=>animationControllerFromProps !== null && animationControllerFromProps !== void 0 ? animationControllerFromProps : animationControllerFromContext, [
        animationControllerFromProps,
        animationControllerFromContext
    ]);
}

});
parcelRegister("g8SFg", function(module, exports) {

$parcel$export(module.exports, "animationControllerImpl", () => $bc07cbed459f63ca$export$13b4efe34b66d101);
/**
 * JavaScript animations require trigger and repaint as soon as possible,
 * so this class uses the timeoutController to trigger updates as quickly as the controller allows.
 *
 * JavaScript animation progress is represented as a stream of values. The exact type depends on the animationHandle type.
 * Each individual consumer is then responsible for mapping those values onto a React component.
 */ var $bc07cbed459f63ca$export$13b4efe34b66d101 = (timeoutController, animationHandle, listener)=>{
    var cancellable;
    var nextUpdate = (now)=>{
        var timeRemaining = animationHandle.tick(now);
        if (animationHandle.getState() === 'active') {
            listener(animationHandle.getInterpolated());
            if (animationHandle.getProgress() === 1) {
                animationHandle.complete();
                cancellable = undefined;
                return;
            }
            cancellable = timeoutController.setTimeout(nextUpdate, timeRemaining);
            return;
        }
        cancellable = timeoutController.setTimeout(nextUpdate, timeRemaining);
    };
    cancellable = timeoutController.setTimeout(nextUpdate, 0);
    return ()=>{
        var _cancellable;
        return (_cancellable = cancellable) === null || _cancellable === void 0 ? void 0 : _cancellable();
    };
};

});


parcelRegister("l8v4E", function(module, exports) {

$parcel$export(module.exports, "JavascriptAnimation", () => $f63272fcb75960bc$export$95c69054b1ce0d0);

var $3FiDp = parcelRequire("3FiDp");
function $f63272fcb75960bc$var$_defineProperty(e, r, t) {
    return (r = $f63272fcb75960bc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f63272fcb75960bc$var$_toPropertyKey(t) {
    var i = $f63272fcb75960bc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f63272fcb75960bc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f63272fcb75960bc$var$INIT = 'init';
var $f63272fcb75960bc$var$PENDING = 'pending';
var $f63272fcb75960bc$var$ACTIVE = 'active';
var $f63272fcb75960bc$var$COMPLETED = 'completed';
function $f63272fcb75960bc$var$duration(time) {
    return Math.max(0, time);
}
class $f63272fcb75960bc$var$RechartsAnimation {
    /**
   * Returns the absolute time after the animationBegin delay has been completed,
   * and when the animationDuration started ticking.
   */ getAnimationStartedTime() {
        return this.animationStartedTime;
    }
    /**
   * Returns the absolute time of when the animation began - now it will wait for {animationBegin} ms before the transition starts
   */ getBeginStartedTime() {
        return this.beginStartedTime;
    }
    constructor(param){
        var _param$onAnimationSta;
        $f63272fcb75960bc$var$_defineProperty(this, "state", $f63272fcb75960bc$var$INIT);
        this.animationId = param.animationId;
        this.onAnimationEnd = param.onAnimationEnd;
        this.animationDuration = $f63272fcb75960bc$var$duration(param.animationDuration);
        this.animationBegin = $f63272fcb75960bc$var$duration(param.animationBegin);
        this.progress = 0;
        this.from = param.from;
        this.to = param.to;
        this.easing = param.easing;
        // Mimic what the previous animationManager was doing - call onAnimationStart immediately and synchronously
        (_param$onAnimationSta = param.onAnimationStart) === null || _param$onAnimationSta === void 0 || _param$onAnimationSta.call(param);
    }
    /**
   * Returns the state machine current state
   * - `init`:       animation had just been created. It immediately calls `onAnimationStart`
   * - `pending`:    animation is now paused for `animationBegin` milliseconds until the transition begins
   * - `active`:     animation is transitioning items on screen
   * - `completed`:  animation has completed its transition and executed `onAnimationEnd`.
   *                 This state is final and the animation is no longer allowed to transition to other states.
   */ getState() {
        return this.state;
    }
    /**
   * Returns the easing input or function
   */ getEasing() {
        return this.easing;
    }
    /**
   * Returns the configuration - the duration of the transition.
   * Does not change in time, does not change when state changes, this is a static value.
   */ getAnimationDuration() {
        return this.animationDuration;
    }
    /**
   * Sets the current time of the animation. The animation sets its internal state and progress accordingly.
   * This is current, absolute time; not additive!
   * This allows you to essentially "travel back in time" based on the value you pass in here.
   *
   * Returns the (relative) time remaining until the current activity is over.
   * Meaning: if the state is in a middle of a delay, returns the time left until the delay is finished.
   * If the state is in the middle of a transition, returns time left until that transition is complete.
   * This is useful because it's the same number you can take and put into setTimeout(fn, X)
   * as that's how much time we need to wait until the next state transition happens.
   */ tick(now) {
        if (this.getState() === $f63272fcb75960bc$var$INIT) {
            this.state = $f63272fcb75960bc$var$PENDING;
            this.beginStartedTime = now;
            return this.animationBegin;
        }
        if (this.getState() === $f63272fcb75960bc$var$PENDING) {
            if (this.beginStartedTime == null) throw new Error();
            var _timeElapsed = now - this.beginStartedTime;
            if (_timeElapsed >= this.animationBegin) {
                this.state = $f63272fcb75960bc$var$ACTIVE;
                this.animationStartedTime = now;
                // The state flipped just now so the elapsed time is zero
                return this.nextAnimationUpdate(0);
            }
            return $f63272fcb75960bc$var$duration(this.animationBegin - _timeElapsed);
        }
        if (this.getState() === $f63272fcb75960bc$var$ACTIVE) {
            if (this.animationStartedTime == null) throw new Error();
            var _timeElapsed2 = now - this.animationStartedTime;
            this.setProgress(_timeElapsed2 / this.animationDuration);
            return this.nextAnimationUpdate(_timeElapsed2);
        }
        // state === COMPLETED, nothing interesting is going to happen
        return 0;
    }
    setProgress(newProgress) {
        this.progress = Math.min(1, Math.max(0, newProgress));
    }
    /**
   * Returns an abstract "progress" which is number between 0 and 1 which shows the distance of transition.
   * This progress depends on the animation state:
   * - `init`: 0
   * - `pending`: 0
   * - `active`: transitioning between [0, 1] based on the time elapsed
   * - `completed`: 1
   *
   * The progress is hard-capped to be between 0 and 1 (inclusive) to avoid overshooting caused by coarse timers.
   * For this reason, the easing function must be applied _after_ this animation state,
   * so that one has a chance to construct dynamic "overshoot" animations.
   *
   * The progress is linear with time.
   * If you wish for easing, use `getInterpolated()` instead.
   */ getProgress() {
        return this.progress;
    }
    /**
   * Completes the animation. Completed animation:
   * - cannot be manipulated anymore
   * - its progress is set to 1
   * - tick function doesn't do anything
   * - getState() always returns 'completed'
   */ complete() {
        this.progress = 1;
        if (this.state === 'active') {
            var _this$onAnimationEnd;
            // Do not call callbacks if the animation was interrupted before it even started!
            (_this$onAnimationEnd = this.onAnimationEnd) === null || _this$onAnimationEnd === void 0 || _this$onAnimationEnd.call(this);
        }
        this.state = $f63272fcb75960bc$var$COMPLETED;
    }
    /**
   * Returns the starting value of the animation.
   * Does not include progress, easing, interpolation, none of that - just the static starting value
   */ getFrom() {
        return this.from;
    }
    /**
   * Returns the end value of the animation.
   * Does not include progress, easing, interpolation, none of that - just the static end value
   */ getTo() {
        return this.to;
    }
    /**
   * Unique identifier of an animation
   */ getAnimationId() {
        return this.animationId;
    }
    /**
   * Returns the configuration - the duration of delay in between animation initialization, and transition.
   * Does not change in time, does not change when state changes, this is a static value.
   */ getAnimationBegin() {
        return this.animationBegin;
    }
}
class $f63272fcb75960bc$export$95c69054b1ce0d0 extends $f63272fcb75960bc$var$RechartsAnimation {
    // eslint-disable-next-line class-methods-use-this
    nextAnimationUpdate() {
        /*
     * JavaScript-based animations have to update as soon as possible,
     * so we return 0 here to indicate that the next update should be scheduled immediately
     * and it should trigger render on every occasion.
     */ return 0;
    }
    /**
   * Returns value of the animation after its easing function had been applied.
   * This value, unlike getProgress(), can escape the [0..1] range
   * because this is entirely within the easing function control. Spring typically does this.
   */ getInterpolated() {
        return this.easing((0, $3FiDp.interpolate)(this.getFrom(), this.getTo(), this.getProgress()));
    }
}
class $f63272fcb75960bc$export$da79ff0cadb5494 extends $f63272fcb75960bc$var$RechartsAnimation {
    nextAnimationUpdate(timeElapsed) {
        /**
     * CSS transitions do not need DOM updates past the initial render
     * so here we just instruct the controller to wait until the animation duration is over.
     */ return $f63272fcb75960bc$var$duration(this.animationDuration - timeElapsed);
    }
    /**
   * Returns the final value of the animation (the `to`).
   *
   * CSS transitions leave both interpolation and easing to the browser,
   * so all we need to do here is return the final state
   * and let browser handle the rest.
   */ getInterpolated() {
        return this.getTo();
    }
} /**
 * Recharts animation state machine.
 *
 * Possible transitions are:
 * - `init`: starting state - `onAnimationStart` executes
 * - `init` to `pending` - `animationBegin` duration begins
 * - `pending` to `active` - `animationDuration` duration begins, timer ticks decide the progress
 * - `active` to `completed` - `onAnimationEnd` executes
 *
 * The state always moves in this direction, cannot move backwards.
 *
 * The animation queue is static and consists of four elements:
 * - `onAnimationStart`: function that is called when the animation is created
 * - `animationBegin`: delay between `onAnimationStart` and the transition
 * - the transition itself, takes `animationDuration` ms to finish
 * - `onAnimationEnd`: function that is called when the animation is moving from `active` to `completed`
 *
 * @see {@link https://recharts.github.io/en-US/guide/animations/ Animation guide}
 *
 * @since 3.9
 */ 

});

parcelRegister("h2iMT", function(module, exports) {

$parcel$export(module.exports, "RequestAnimationFrameTimeoutController", () => $c671326bd558adef$export$fa255b8f41b568c2);
/**
 * Callback type for the timeout function.
 * Receives current time as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 *
 * @since 3.9
 */ /**
 * TimeoutController is responsible for controlling the movement of time.
 * Think of it as a clock.
 *
 * Recharts default implementation uses requestAnimationFrame which works great in a browser.
 * You may choose to override this which is especially useful if you want to control animations.
 *
 * Why would you want to do this?
 * - unit tests
 * - animations based on something other than time: UI controls, page scroll, mouse movement ...
 *
 * @see {@link https://recharts.github.io/en-US/guide/animations/ Animation guide}
 *
 * @since 3.9
 */ class $c671326bd558adef$export$fa255b8f41b568c2 {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}

});


parcelRegister("9NuBN", function(module, exports) {

$parcel$export(module.exports, "useAnimationId", () => $72206edefbff003d$export$e1042b2944b80b7f);

var $acw62 = parcelRequire("acw62");

var $3FiDp = parcelRequire("3FiDp");
function $72206edefbff003d$export$e1042b2944b80b7f(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, $acw62.useRef)((0, $3FiDp.uniqueId)(prefix));
    var prevProps = (0, $acw62.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, $3FiDp.uniqueId)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}

});

parcelRegister("2t5bf", function(module, exports) {

$parcel$export(module.exports, "getTransitionVal", () => $1cc24ee9ad4a37a9$export$1594c78389ee3429);
/*
 * @description: convert camel case to dash case
 * string => string
 */ var $1cc24ee9ad4a37a9$export$51610fddbf64bc9d = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var $1cc24ee9ad4a37a9$export$1594c78389ee3429 = (props, duration, easing)=>props.map((prop)=>"".concat($1cc24ee9ad4a37a9$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing)).join(',');

});


parcelRegister("42cds", function(module, exports) {

$parcel$export(module.exports, "getRadialCursorPoints", () => $2f00d3350e823531$export$ad661ef85a042a4f);

var $1l5bp = parcelRequire("1l5bp");
function $2f00d3350e823531$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $1l5bp.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, $1l5bp.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}

});

parcelRegister("4zntx", function(module, exports) {

$parcel$export(module.exports, "Sector", () => $353ca4069312fa59$export$e98c2c7eb2b14f45);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1l5bp = parcelRequire("1l5bp");

var $3FiDp = parcelRequire("3FiDp");

var $cd9rh = parcelRequire("cd9rh");

var $lTk0V = parcelRequire("lTk0V");

var $erqUX = parcelRequire("erqUX");
var $353ca4069312fa59$var$_templateObject, $353ca4069312fa59$var$_templateObject2, $353ca4069312fa59$var$_templateObject3, $353ca4069312fa59$var$_templateObject4, $353ca4069312fa59$var$_templateObject5, $353ca4069312fa59$var$_templateObject6, $353ca4069312fa59$var$_templateObject7;
function $353ca4069312fa59$var$_extends() {
    return $353ca4069312fa59$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $353ca4069312fa59$var$_extends.apply(null, arguments);
}
function $353ca4069312fa59$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $353ca4069312fa59$var$getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $3FiDp.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $353ca4069312fa59$var$getTangentCircle = (_ref)=>{
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $1l5bp.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $1l5bp.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $1l5bp.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $1l5bp.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, $1l5bp.RADIAN)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $353ca4069312fa59$var$getSectorPath = (_ref2)=>{
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $353ca4069312fa59$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $1l5bp.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $1l5bp.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject || ($353ca4069312fa59$var$_templateObject = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A ",
        ",",
        ",0,\n    ",
        ",",
        ",\n    ",
        ",",
        "\n  "
    ])), outerStartPoint.x, outerStartPoint.y, outerRadius, outerRadius, +(Math.abs(angle) > 180), +(startAngle > tempEndAngle), outerEndPoint.x, outerEndPoint.y);
    if (innerRadius > 0) {
        var innerStartPoint = (0, $1l5bp.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $1l5bp.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject2 || ($353ca4069312fa59$var$_templateObject2 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "L ",
            ",",
            "\n            A ",
            ",",
            ",0,\n            ",
            ",",
            ",\n            ",
            ",",
            " Z"
        ])), innerEndPoint.x, innerEndPoint.y, innerRadius, innerRadius, +(Math.abs(angle) > 180), +(startAngle <= tempEndAngle), innerStartPoint.x, innerStartPoint.y);
    } else path += (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject3 || ($353ca4069312fa59$var$_templateObject3 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), cx, cy);
    return path;
};
var $353ca4069312fa59$var$getSectorWithCorner = (_ref3)=>{
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $3FiDp.mathSign)(endAngle - startAngle);
    var _getTangentCircle = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $353ca4069312fa59$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject4 || ($353ca4069312fa59$var$_templateObject4 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "M ",
            ",",
            "\n        a",
            ",",
            ",0,0,1,",
            ",0\n        a",
            ",",
            ",0,0,1,",
            ",0\n      "
        ])), solt.x, solt.y, cornerRadius, cornerRadius, cornerRadius * 2, cornerRadius, cornerRadius, -cornerRadius * 2);
        return $353ca4069312fa59$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject5 || ($353ca4069312fa59$var$_templateObject5 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,",
        ",",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n  "
    ])), solt.x, solt.y, cornerRadius, cornerRadius, +(sign < 0), soct.x, soct.y, outerRadius, outerRadius, +(outerArcAngle > 180), +(sign < 0), eoct.x, eoct.y, cornerRadius, cornerRadius, +(sign < 0), eolt.x, eolt.y);
    if (innerRadius > 0) {
        var _getTangentCircle3 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $353ca4069312fa59$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject6 || ($353ca4069312fa59$var$_templateObject6 = $353ca4069312fa59$var$_taggedTemplateLiteral([
            "L",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,",
            ",",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "Z"
        ])), eilt.x, eilt.y, cornerRadius, cornerRadius, +(sign < 0), eict.x, eict.y, innerRadius, innerRadius, +(innerArcAngle > 180), +(sign > 0), sict.x, sict.y, cornerRadius, cornerRadius, +(sign < 0), silt.x, silt.y);
    } else path += (0, $erqUX.roundTemplateLiteral)($353ca4069312fa59$var$_templateObject7 || ($353ca4069312fa59$var$_templateObject7 = $353ca4069312fa59$var$_taggedTemplateLiteral([
        "L",
        ",",
        "Z"
    ])), cx, cy);
    return path;
};
var $353ca4069312fa59$export$1d63e9c2e020b2a7 = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $353ca4069312fa59$export$e98c2c7eb2b14f45 = (sectorProps)=>{
    var props = (0, $cd9rh.resolveDefaultProps)(sectorProps, $353ca4069312fa59$export$1d63e9c2e020b2a7);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $9QePP.clsx)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $3FiDp.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $353ca4069312fa59$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $353ca4069312fa59$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ $acw62.createElement("path", $353ca4069312fa59$var$_extends({}, (0, $lTk0V.svgPropertiesAndEvents)(props), {
        className: layerClass,
        d: path
    }));
};

});

parcelRegister("a01al", function(module, exports) {

$parcel$export(module.exports, "getCursorPoints", () => $747acf019ef7786e$export$56e1305620ce5745);

var $1l5bp = parcelRequire("1l5bp");

var $cpMpC = parcelRequire("cpMpC");

var $42cds = parcelRequire("42cds");
function $747acf019ef7786e$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, $cpMpC.isPolarCoordinate)(activeCoordinate)) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $1l5bp.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $1l5bp.polarToCartesian)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, $42cds.getRadialCursorPoints)(activeCoordinate);
    }
    return undefined;
}

});

parcelRegister("3S4Ih", function(module, exports) {

$parcel$export(module.exports, "useTooltipAxisBandSize", () => $2d1a122fcf18b245$export$fd17f57c33e9d17e);

var $bqlEl = parcelRequire("bqlEl");

var $hBeJX = parcelRequire("hBeJX");

var $99P3O = parcelRequire("99P3O");

var $71i43 = parcelRequire("71i43");
function $2d1a122fcf18b245$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d1a122fcf18b245$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d1a122fcf18b245$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2d1a122fcf18b245$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d1a122fcf18b245$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2d1a122fcf18b245$var$_defineProperty(e, r, t) {
    return (r = $2d1a122fcf18b245$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2d1a122fcf18b245$var$_toPropertyKey(t) {
    var i = $2d1a122fcf18b245$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2d1a122fcf18b245$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2d1a122fcf18b245$export$952de9be87065336 = ()=>(0, $bqlEl.useAppSelector)((0, $99P3O.selectTooltipAxis));
var $2d1a122fcf18b245$export$fd17f57c33e9d17e = ()=>{
    var tooltipAxis = $2d1a122fcf18b245$export$952de9be87065336();
    var tooltipTicks = (0, $bqlEl.useAppSelector)((0, $71i43.selectTooltipAxisTicks));
    var tooltipAxisScale = (0, $bqlEl.useAppSelector)((0, $71i43.selectTooltipAxisScale));
    if (!tooltipAxis || !tooltipAxisScale) return (0, $hBeJX.getBandSizeOfAxis)(undefined, tooltipTicks);
    return (0, $hBeJX.getBandSizeOfAxis)($2d1a122fcf18b245$var$_objectSpread($2d1a122fcf18b245$var$_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};

});



parcelRegister("kMGAE", function(module, exports) {

$parcel$export(module.exports, "XAxis", () => $f21953d5ea7d4fb8$export$ea77231de273b52d);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $381Oh = parcelRequire("381Oh");

var $bqlEl = parcelRequire("bqlEl");

var $214LY = parcelRequire("214LY");

var $99P3O = parcelRequire("99P3O");

var $lnFga = parcelRequire("lnFga");

var $3X9hg = parcelRequire("3X9hg");

var $ahoy0 = parcelRequire("ahoy0");

var $cd9rh = parcelRequire("cd9rh");

var $g1Aw8 = parcelRequire("g1Aw8");

var $jHn5r = parcelRequire("jHn5r");

var $kh3bM = parcelRequire("kh3bM");
var $f21953d5ea7d4fb8$var$_excluded = [
    "type"
], $f21953d5ea7d4fb8$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $f21953d5ea7d4fb8$var$_excluded3 = [
    "id",
    "scale"
];
function $f21953d5ea7d4fb8$var$_extends() {
    return $f21953d5ea7d4fb8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f21953d5ea7d4fb8$var$_extends.apply(null, arguments);
}
function $f21953d5ea7d4fb8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f21953d5ea7d4fb8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f21953d5ea7d4fb8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f21953d5ea7d4fb8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f21953d5ea7d4fb8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f21953d5ea7d4fb8$var$_defineProperty(e, r, t) {
    return (r = $f21953d5ea7d4fb8$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f21953d5ea7d4fb8$var$_toPropertyKey(t) {
    var i = $f21953d5ea7d4fb8$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f21953d5ea7d4fb8$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f21953d5ea7d4fb8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f21953d5ea7d4fb8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f21953d5ea7d4fb8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $f21953d5ea7d4fb8$var$SetXAxisSettings(props) {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    var layout = (0, $jHn5r.useCartesianChartLayout)();
    var typeFromProps = props.type, restProps = $f21953d5ea7d4fb8$var$_objectWithoutProperties(props, $f21953d5ea7d4fb8$var$_excluded);
    var evaluatedType = (0, $kh3bM.getAxisTypeBasedOnLayout)(layout, 'xAxis', typeFromProps);
    var settings = (0, $acw62.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $f21953d5ea7d4fb8$var$_objectSpread($f21953d5ea7d4fb8$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        restProps,
        evaluatedType
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $214LY.addXAxis)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $214LY.replaceXAxis)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $214LY.removeXAxis)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var $f21953d5ea7d4fb8$var$XAxisImpl = (props)=>{
    var xAxisId = props.xAxisId, className = props.className, height = props.height, label = props.label;
    var cartesianAxisRef = (0, $acw62.useRef)(null);
    var labelRef = (0, $acw62.useRef)(null);
    var viewBox = (0, $bqlEl.useAppSelector)((0, $lnFga.selectAxisViewBox));
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var axisType = 'xAxis';
    var cartesianTickItems = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectTicksOfAxis)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectXAxisSize)(state, xAxisId));
    var position = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectXAxisPosition)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectXAxisSettingsNoDefaults)(state, xAxisId));
    (0, $acw62.useLayoutEffect)(()=>{
        // No dynamic height calculation is done when height !== 'auto'
        // or when a function/react element is used for label
        if (height !== 'auto' || !axisSize || (0, $ahoy0.isLabelContentAFunction)(label) || /*#__PURE__*/ (0, $acw62.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedXAxisHeight = axisComponent.getCalculatedHeight();
        // if the height has changed, dispatch an action to update the height
        if (Math.round(axisSize.height) !== Math.round(updatedXAxisHeight)) dispatch((0, $214LY.updateXAxisHeight)({
            id: xAxisId,
            height: updatedXAxisHeight
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        xAxisId,
        height,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var dangerouslySetInnerHTML = props.dangerouslySetInnerHTML, ticks = props.ticks, del = props.scale, allOtherProps = $f21953d5ea7d4fb8$var$_objectWithoutProperties(props, $f21953d5ea7d4fb8$var$_excluded2);
    var id = synchronizedSettings.id, del2 = synchronizedSettings.scale, restSynchronizedSettings = $f21953d5ea7d4fb8$var$_objectWithoutProperties(synchronizedSettings, $f21953d5ea7d4fb8$var$_excluded3);
    return /*#__PURE__*/ $acw62.createElement((0, $381Oh.CartesianAxis), $f21953d5ea7d4fb8$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $9QePP.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType,
        axisId: xAxisId
    }));
};
var $f21953d5ea7d4fb8$export$bf921d6fd02045a0 = {
    allowDataOverflow: (0, $99P3O.implicitXAxis).allowDataOverflow,
    allowDecimals: (0, $99P3O.implicitXAxis).allowDecimals,
    allowDuplicatedCategory: (0, $99P3O.implicitXAxis).allowDuplicatedCategory,
    angle: (0, $99P3O.implicitXAxis).angle,
    axisLine: (0, $381Oh.defaultCartesianAxisProps).axisLine,
    height: (0, $99P3O.implicitXAxis).height,
    hide: false,
    includeHidden: (0, $99P3O.implicitXAxis).includeHidden,
    interval: (0, $99P3O.implicitXAxis).interval,
    label: false,
    minTickGap: (0, $99P3O.implicitXAxis).minTickGap,
    mirror: (0, $99P3O.implicitXAxis).mirror,
    orientation: (0, $99P3O.implicitXAxis).orientation,
    padding: (0, $99P3O.implicitXAxis).padding,
    reversed: (0, $99P3O.implicitXAxis).reversed,
    scale: (0, $99P3O.implicitXAxis).scale,
    tick: (0, $99P3O.implicitXAxis).tick,
    tickCount: (0, $99P3O.implicitXAxis).tickCount,
    tickLine: (0, $381Oh.defaultCartesianAxisProps).tickLine,
    tickSize: (0, $381Oh.defaultCartesianAxisProps).tickSize,
    type: (0, $99P3O.implicitXAxis).type,
    niceTicks: (0, $99P3O.implicitXAxis).niceTicks,
    xAxisId: 0
};
var $f21953d5ea7d4fb8$var$XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $f21953d5ea7d4fb8$export$bf921d6fd02045a0);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit,
        niceTicks: props.niceTicks
    }), /*#__PURE__*/ $acw62.createElement($f21953d5ea7d4fb8$var$XAxisImpl, props));
};
var $f21953d5ea7d4fb8$export$ea77231de273b52d = /*#__PURE__*/ $acw62.memo($f21953d5ea7d4fb8$var$XAxisSettingsDispatcher, (0, $g1Aw8.axisPropsAreEqual));
// @ts-expect-error we need to set the displayName for debugging purposes
$f21953d5ea7d4fb8$export$ea77231de273b52d.displayName = 'XAxis';

});
parcelRegister("g1Aw8", function(module, exports) {

$parcel$export(module.exports, "axisPropsAreEqual", () => $baa910eb7a58f9d8$export$a803260e379f3736);

var $biEKl = parcelRequire("biEKl");
var $baa910eb7a58f9d8$var$_excluded = [
    "domain",
    "range"
], $baa910eb7a58f9d8$var$_excluded2 = [
    "domain",
    "range"
];
function $baa910eb7a58f9d8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $baa910eb7a58f9d8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $baa910eb7a58f9d8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $baa910eb7a58f9d8$var$shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function $baa910eb7a58f9d8$export$a803260e379f3736(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var prevDomain = prevProps.domain, prevRange = prevProps.range, prevRest = $baa910eb7a58f9d8$var$_objectWithoutProperties(prevProps, $baa910eb7a58f9d8$var$_excluded);
    var nextDomain = nextProps.domain, nextRange = nextProps.range, nextRest = $baa910eb7a58f9d8$var$_objectWithoutProperties(nextProps, $baa910eb7a58f9d8$var$_excluded2);
    if (!$baa910eb7a58f9d8$var$shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!$baa910eb7a58f9d8$var$shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, $biEKl.propsAreEqual)(prevRest, nextRest);
}

});


parcelRegister("1dtDd", function(module, exports) {

$parcel$export(module.exports, "YAxis", () => $0e2dfd8b3bfb4506$export$f96c4024c52de8f4);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $381Oh = parcelRequire("381Oh");

var $214LY = parcelRequire("214LY");

var $bqlEl = parcelRequire("bqlEl");

var $99P3O = parcelRequire("99P3O");

var $lnFga = parcelRequire("lnFga");

var $3X9hg = parcelRequire("3X9hg");

var $ahoy0 = parcelRequire("ahoy0");

var $cd9rh = parcelRequire("cd9rh");

var $g1Aw8 = parcelRequire("g1Aw8");

var $jHn5r = parcelRequire("jHn5r");

var $kh3bM = parcelRequire("kh3bM");
var $0e2dfd8b3bfb4506$var$_excluded = [
    "type"
], $0e2dfd8b3bfb4506$var$_excluded2 = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], $0e2dfd8b3bfb4506$var$_excluded3 = [
    "id",
    "scale"
];
function $0e2dfd8b3bfb4506$var$_extends() {
    return $0e2dfd8b3bfb4506$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e2dfd8b3bfb4506$var$_extends.apply(null, arguments);
}
function $0e2dfd8b3bfb4506$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e2dfd8b3bfb4506$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e2dfd8b3bfb4506$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0e2dfd8b3bfb4506$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e2dfd8b3bfb4506$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0e2dfd8b3bfb4506$var$_defineProperty(e, r, t) {
    return (r = $0e2dfd8b3bfb4506$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0e2dfd8b3bfb4506$var$_toPropertyKey(t) {
    var i = $0e2dfd8b3bfb4506$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0e2dfd8b3bfb4506$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0e2dfd8b3bfb4506$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0e2dfd8b3bfb4506$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0e2dfd8b3bfb4506$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $0e2dfd8b3bfb4506$var$SetYAxisSettings(props) {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    var layout = (0, $jHn5r.useCartesianChartLayout)();
    var typeFromProps = props.type, restProps = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(props, $0e2dfd8b3bfb4506$var$_excluded);
    var evaluatedType = (0, $kh3bM.getAxisTypeBasedOnLayout)(layout, 'yAxis', typeFromProps);
    var settings = (0, $acw62.useMemo)(()=>{
        if (evaluatedType == null) return undefined;
        return $0e2dfd8b3bfb4506$var$_objectSpread($0e2dfd8b3bfb4506$var$_objectSpread({}, restProps), {}, {
            type: evaluatedType
        });
    }, [
        evaluatedType,
        restProps
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        if (settings == null) return;
        if (prevSettingsRef.current === null) dispatch((0, $214LY.addYAxis)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, $214LY.replaceYAxis)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $214LY.removeYAxis)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $0e2dfd8b3bfb4506$var$YAxisImpl(props) {
    var yAxisId = props.yAxisId, className = props.className, width = props.width, label = props.label;
    var cartesianAxisRef = (0, $acw62.useRef)(null);
    var labelRef = (0, $acw62.useRef)(null);
    var viewBox = (0, $bqlEl.useAppSelector)((0, $lnFga.selectAxisViewBox));
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var axisType = 'yAxis';
    var axisSize = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectYAxisSize)(state, yAxisId));
    var position = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectYAxisPosition)(state, yAxisId));
    var cartesianTickItems = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectTicksOfAxis)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectYAxisSettingsNoDefaults)(state, yAxisId));
    (0, $acw62.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, $ahoy0.isLabelContentAFunction)(label) || /*#__PURE__*/ (0, $acw62.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, $214LY.updateYAxisWidth)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var dangerouslySetInnerHTML = props.dangerouslySetInnerHTML, ticks = props.ticks, del = props.scale, allOtherProps = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(props, $0e2dfd8b3bfb4506$var$_excluded2);
    var id = synchronizedSettings.id, del2 = synchronizedSettings.scale, restSynchronizedSettings = $0e2dfd8b3bfb4506$var$_objectWithoutProperties(synchronizedSettings, $0e2dfd8b3bfb4506$var$_excluded3);
    return /*#__PURE__*/ $acw62.createElement((0, $381Oh.CartesianAxis), $0e2dfd8b3bfb4506$var$_extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width: width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, $9QePP.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType,
        axisId: yAxisId
    }));
}
var $0e2dfd8b3bfb4506$export$299ffbfed5267dce = {
    allowDataOverflow: (0, $99P3O.implicitYAxis).allowDataOverflow,
    allowDecimals: (0, $99P3O.implicitYAxis).allowDecimals,
    allowDuplicatedCategory: (0, $99P3O.implicitYAxis).allowDuplicatedCategory,
    angle: (0, $99P3O.implicitYAxis).angle,
    axisLine: (0, $381Oh.defaultCartesianAxisProps).axisLine,
    hide: false,
    includeHidden: (0, $99P3O.implicitYAxis).includeHidden,
    interval: (0, $99P3O.implicitYAxis).interval,
    label: false,
    minTickGap: (0, $99P3O.implicitYAxis).minTickGap,
    mirror: (0, $99P3O.implicitYAxis).mirror,
    orientation: (0, $99P3O.implicitYAxis).orientation,
    padding: (0, $99P3O.implicitYAxis).padding,
    reversed: (0, $99P3O.implicitYAxis).reversed,
    scale: (0, $99P3O.implicitYAxis).scale,
    tick: (0, $99P3O.implicitYAxis).tick,
    tickCount: (0, $99P3O.implicitYAxis).tickCount,
    tickLine: (0, $381Oh.defaultCartesianAxisProps).tickLine,
    tickSize: (0, $381Oh.defaultCartesianAxisProps).tickSize,
    type: (0, $99P3O.implicitYAxis).type,
    niceTicks: (0, $99P3O.implicitYAxis).niceTicks,
    width: (0, $99P3O.implicitYAxis).width,
    yAxisId: 0
};
var $0e2dfd8b3bfb4506$var$YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $0e2dfd8b3bfb4506$export$299ffbfed5267dce);
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        niceTicks: props.niceTicks
    }), /*#__PURE__*/ $acw62.createElement($0e2dfd8b3bfb4506$var$YAxisImpl, props));
};
var $0e2dfd8b3bfb4506$export$f96c4024c52de8f4 = /*#__PURE__*/ $acw62.memo($0e2dfd8b3bfb4506$var$YAxisSettingsDispatcher, (0, $g1Aw8.axisPropsAreEqual));
// @ts-expect-error we need to set the displayName for debugging purposes
$0e2dfd8b3bfb4506$export$f96c4024c52de8f4.displayName = 'YAxis';

});

parcelRegister("ko6Bk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed7b2b659b749647$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ed7b2b659b749647$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

});

parcelRegister("4WLS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a1b6ae48c4cf7c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $jLeQy = parcelRequire("jLeQy");

var $8zogs = parcelRequire("8zogs");
var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $fRuoN = parcelRequire("fRuoN");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $39a1b6ae48c4cf7c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $fRuoN.getSkeletonUtilityClass), classes);
};
const $39a1b6ae48c4cf7c$var$pulseKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $39a1b6ae48c4cf7c$var$waveKeyframe = (0, $8zogs.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $39a1b6ae48c4cf7c$var$pulseAnimation = typeof $39a1b6ae48c4cf7c$var$pulseKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$39a1b6ae48c4cf7c$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $39a1b6ae48c4cf7c$var$waveAnimation = typeof $39a1b6ae48c4cf7c$var$waveKeyframe !== 'string' ? (0, $8zogs.css)`
        &::after {
          animation: ${$39a1b6ae48c4cf7c$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $39a1b6ae48c4cf7c$var$SkeletonRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    const radiusUnit = (0, $jLeQy.getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $jLeQy.toUnitless)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $39a1b6ae48c4cf7c$var$pulseAnimation || {
                    animation: `${$39a1b6ae48c4cf7c$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $39a1b6ae48c4cf7c$var$waveAnimation || {
                    '&::after': {
                        animation: `${$39a1b6ae48c4cf7c$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $39a1b6ae48c4cf7c$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $39a1b6ae48c4cf7c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($39a1b6ae48c4cf7c$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $39a1b6ae48c4cf7c$export$2e2bcd8739ae039 = $39a1b6ae48c4cf7c$var$Skeleton;

});
parcelRegister("jLeQy", function(module, exports) {

$parcel$export(module.exports, "getUnit", () => $e62dec54699515d7$export$65f2564e9a9b9222);
$parcel$export(module.exports, "toUnitless", () => $e62dec54699515d7$export$8af1d214c6c2f0f1);
function $e62dec54699515d7$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $e62dec54699515d7$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $e62dec54699515d7$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $e62dec54699515d7$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $e62dec54699515d7$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length) * $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length) * $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $e62dec54699515d7$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $e62dec54699515d7$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $e62dec54699515d7$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});

parcelRegister("fRuoN", function(module, exports) {

$parcel$export(module.exports, "getSkeletonUtilityClass", () => $b8c362dd35eec98c$export$c987db9fc844f86);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $b8c362dd35eec98c$export$c987db9fc844f86(slot) {
    return (0, $4Cod0.default)('MuiSkeleton', slot);
}
const $b8c362dd35eec98c$var$skeletonClasses = (0, $beCSm.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $b8c362dd35eec98c$export$2e2bcd8739ae039 = $b8c362dd35eec98c$var$skeletonClasses;

});


parcelRegister("22i8b", function(module, exports) {

$parcel$export(module.exports, "get", () => $0d70f179cf56e662$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $0d70f179cf56e662$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "useFormContext", () => $0d70f179cf56e662$export$4d957a5e1be13b03);
$parcel$export(module.exports, "FormProvider", () => $0d70f179cf56e662$export$8ce1ff4f94d08846);
$parcel$export(module.exports, "useController", () => $0d70f179cf56e662$export$e8c786024a2b0a79);
$parcel$export(module.exports, "Controller", () => $0d70f179cf56e662$export$bd0bf19f25da8474);
$parcel$export(module.exports, "appendErrors", () => $0d70f179cf56e662$export$b196c2a4f765bd30);
$parcel$export(module.exports, "useForm", () => $0d70f179cf56e662$export$87c0cf8eb5a167e0);

var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === 'object';
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $0d70f179cf56e662$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = $0d70f179cf56e662$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__') return;
        object[key] = newValue;
        object = object[key];
    }
    return object;
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $0d70f179cf56e662$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $0d70f179cf56e662$var$shouldSubscribeByName(_name.current, value1.name, exact) && $0d70f179cf56e662$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === 'string';
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    _name.current = name;
    $0d70f179cf56e662$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($0d70f179cf56e662$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) control._updateDisabledField({
            disabled: disabled,
            fields: control._fields,
            name: name,
            value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)._f.value
        });
    }, [
        disabled,
        name,
        control
    ]);
    return {
        field: {
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $0d70f179cf56e662$var$getEventValue(event),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $0d70f179cf56e662$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((elm)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }, [
                control._fields,
                name
            ])
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($0d70f179cf56e662$var$isObjectType(obj[key])) {
        const nested = $0d70f179cf56e662$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $0d70f179cf56e662$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $0d70f179cf56e662$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(action, {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) {
                if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === 'file';
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === 'function';
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMessage = (value1)=>$0d70f179cf56e662$var$isString(value1);
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === 'radio';
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === '' ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getValidateError(result, ref, type = 'validate') {
    if ($0d70f179cf56e662$var$isMessage(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isMessage) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $0d70f179cf56e662$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $0d70f179cf56e662$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._updateValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($0d70f179cf56e662$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $0d70f179cf56e662$var$isObject(data[key]) && !$0d70f179cf56e662$var$objectHasFunction(data[key])) {
            if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $0d70f179cf56e662$var$markFieldsDirty(data[key], []) : {
                ...$0d70f179cf56e662$var$markFieldsDirty(data[key])
            };
            else $0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $0d70f179cf56e662$var$getDirtyFields = (defaultValues, formValues)=>$0d70f179cf56e662$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $0d70f179cf56e662$var$markFieldsDirty(formValues));
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $0d70f179cf56e662$var$ASYNC_FUNCTION = 'AsyncFunction';
var $0d70f179cf56e662$var$hasPromiseValidation = (fieldReference)=>(!fieldReference || !fieldReference.validate) && !!($0d70f179cf56e662$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION || $0d70f179cf56e662$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION));
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$var$createFormControl(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $0d70f179cf56e662$var$createSubject(),
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (!props.disabled && (_proxyFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!props.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !props.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!props.disabled) {
            const disabledField = !!($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name) && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f && $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)._f.disabled);
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = disabledField || $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!(!disabledField && $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name));
                isCurrentFieldPristine || disabledField ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _executeSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $0d70f179cf56e662$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                !$0d70f179cf56e662$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!props.disabled && (name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? '' : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $0d70f179cf56e662$var$isObject(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: _state.mount ? name : undefined,
            values: {
                ..._formValues
            }
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $0d70f179cf56e662$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $0d70f179cf56e662$var$deepEqual(fieldValue, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid) {
                    if (props.mode === 'onBlur') {
                        if (isBlurEvent) _updateValid();
                    } else _updateValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const _updateDisabledField = ({ disabled: disabled, name: name, field: field, fields: fields, value: value1 })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled) && _state.mount || !!disabled) {
            const inputValue = disabled ? undefined : $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$var$getFieldValue(field ? field._f : $0d70f179cf56e662$export$3988ae62b71be9a3(fields, name)._f) : value1;
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, inputValue);
            updateTouchAndDirty(name, inputValue, false, false, true);
        }
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled) || $0d70f179cf56e662$var$isBoolean(props.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _updateDisabledField({
            field: field,
            disabled: $0d70f179cf56e662$var$isBoolean(options.disabled) ? options.disabled : props.disabled,
            name: name,
            value: options.value
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || props.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $0d70f179cf56e662$var$unset(_formState.errors, 'root');
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _updateDisabledField: _updateDisabledField,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            _setErrors: _setErrors,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$0d70f179cf56e662$var$createFormControl(props),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($0d70f179cf56e662$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) control._setErrors(props.errors);
    }, [
        props.errors,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.values.next({
            values: control._getWatch()
        });
    }, [
        props.shouldUnregister,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (_formControl.current) _formControl.current.watch = _formControl.current.watch.bind({});
    }, [
        formState
    ]);
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("3s7Tn", function(module, exports) {

$parcel$export(module.exports, "zodResolver", () => $0591fe66d7f046a7$export$66b7b5879c70f722);

var $cu2ur = parcelRequire("cu2ur");

var $22i8b = parcelRequire("22i8b");
var $0591fe66d7f046a7$var$n = function(r, e) {
    for(var n = {}; r.length;){
        var t = r[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(e) {
            return e.errors.forEach(function(e) {
                return r.push(e);
            });
        }), e) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $22i8b.appendErrors)(a, e, n, s, f ? [].concat(f, t.message) : t.message);
        }
        r.shift();
    }
    return n;
}, $0591fe66d7f046a7$export$66b7b5879c70f722 = function(o, t, s) {
    return void 0 === s && (s = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(e, n) {
                try {
                    var a = Promise.resolve(o["sync" === s.mode ? "parse" : "parseAsync"](i, t)).then(function(e) {
                        return u.shouldUseNativeValidation && (0, $cu2ur.validateFieldsNatively)({}, u), {
                            errors: {},
                            values: s.raw ? i : e
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                if (function(r) {
                    return Array.isArray(null == r ? void 0 : r.errors);
                }(r)) return {
                    values: {},
                    errors: (0, $cu2ur.toNestErrors)($0591fe66d7f046a7$var$n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};

});
parcelRegister("cu2ur", function(module, exports) {

$parcel$export(module.exports, "validateFieldsNatively", () => $629af589066638cc$export$6bd436d70894afff);
$parcel$export(module.exports, "toNestErrors", () => $629af589066638cc$export$f0545b73a179e3a2);

var $22i8b = parcelRequire("22i8b");
const $629af589066638cc$var$s = (e, s, o)=>{
    if (e && "reportValidity" in e) {
        const r = (0, $22i8b.get)(o, s);
        e.setCustomValidity(r && r.message || ""), e.reportValidity();
    }
}, $629af589066638cc$export$6bd436d70894afff = (t, e)=>{
    for(const o in e.fields){
        const r = e.fields[o];
        r && r.ref && "reportValidity" in r.ref ? $629af589066638cc$var$s(r.ref, o, t) : r.refs && r.refs.forEach((e)=>$629af589066638cc$var$s(e, o, t));
    }
}, $629af589066638cc$export$f0545b73a179e3a2 = (s, r)=>{
    r.shouldUseNativeValidation && $629af589066638cc$export$6bd436d70894afff(s, r);
    const f = {};
    for(const o in s){
        const n = (0, $22i8b.get)(r.fields, o), a = Object.assign(s[o] || {}, {
            ref: n && n.ref
        });
        if ($629af589066638cc$var$i(r.names || Object.keys(s), o)) {
            const s = Object.assign({}, (0, $22i8b.get)(f, o));
            (0, $22i8b.set)(s, "root", a), (0, $22i8b.set)(f, o, s);
        } else (0, $22i8b.set)(f, o, a);
    }
    return f;
}, $629af589066638cc$var$i = (t, e)=>t.some((t)=>t.startsWith(e + "."));

});


parcelRegister("e3HVo", function(module, exports) {

$parcel$export(module.exports, "FormTextField", () => $e7ae7ca49ce67742$export$a1957630cac59836);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $22i8b = parcelRequire("22i8b");

var $kZugz = parcelRequire("kZugz");
const $e7ae7ca49ce67742$export$a1957630cac59836 = ({ name: name, ...textFieldProps })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
        name: name,
        render: ({ field: { value: value, ...field }, fieldState: { error: error } })=>{
            let helperText;
            if (Array.isArray(error) && error.length) {
                // eslint-disable-next-line
                // @ts-ignore
                const firstErrorMessage = error.find((e)=>e?.message);
                if (firstErrorMessage?.message) helperText = firstErrorMessage.message;
            } else if (error?.message) helperText = error.message;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                ...textFieldProps,
                ...field,
                value: value ?? '',
                error: Boolean(error),
                helperText: helperText
            });
        }
    });
};

});

parcelRegister("9iE6L", function(module, exports) {

$parcel$export(module.exports, "FormattedDateTime", () => $92140d018676ee6d$export$d275c5eeba29af75);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
const $92140d018676ee6d$export$d275c5eeba29af75 = ({ value: value, hour: hour = '2-digit', minute: minute = '2-digit', second: second = '2-digit' })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                value: value
            }),
            ' ',
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                value: value,
                hour: hour,
                minute: minute,
                second: second
            })
        ]
    });
};

});

parcelRegister("hAiFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd4473bf517ef36$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ccd4473bf517ef36$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');

});

parcelRegister("29Lk4", function(module, exports) {

$parcel$export(module.exports, "WifiApPassphraseEdit", () => $09a3761345bd80e6$export$fcdafcf4c428e210);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $u24M4 = parcelRequire("u24M4");
var $kZugz = parcelRequire("kZugz");

var $jDfxe = parcelRequire("jDfxe");

var $iH29s = parcelRequire("iH29s");

var $hAiFn = parcelRequire("hAiFn");

var $5R532 = parcelRequire("5R532");

var $2lSXC = parcelRequire("2lSXC");
const $09a3761345bd80e6$export$fcdafcf4c428e210 = ()=>{
    const managedNetwork = (0, $2lSXC.useSelector)((s)=>s.variables.NETWORK_CAPABILITIES.managedNetwork);
    const confirm = (0, $jDfxe.useConfirm)();
    const passphrase = (0, $acw62.useRef)('');
    const utils = (0, $iH29s.trpc).useContext();
    const setPassphraseMutation = (0, $iH29s.trpc).setWifiPassphrase.useMutation({
        onSuccess: ()=>{
            utils.network.get.invalidate();
        }
    });
    const { data: data } = (0, $iH29s.trpc).network.get.useQuery(undefined, {
        refetchInterval: 5000,
        enabled: managedNetwork
    });
    const onPassphraseEditClick = ()=>{
        passphrase.current = data?.wifiApConfig?.passphrase ?? '';
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wifi_ap_config.passphrase_change.confirm.title",
                defaultMessage: "Zm\u011Bna hesla k WiFi"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                    defaultValue: data?.wifiApConfig?.passphrase ?? '',
                    onChange: (e)=>{
                        passphrase.current = e.target.value;
                    },
                    size: "small",
                    sx: {
                        my: 1
                    },
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "wifi_ap_config.passphrase_change.confirm.passphrase",
                        defaultMessage: "Heslo"
                    })
                })
            })
        }).then(()=>{
            setPassphraseMutation.mutate({
                passphrase: passphrase.current
            });
        }, ()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: data && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
            gap: 1,
            justifyContent: "flex-end",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: data.wifiApConfig?.passphrase
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    onClick: onPassphraseEditClick,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {})
                })
            ]
        })
    });
};

});

parcelRegister("iQxou", function(module, exports) {

$parcel$export(module.exports, "default", () => $db86fcacc6287e65$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");



var $8Indx = parcelRequire("8Indx");

var $7IYS5 = parcelRequire("7IYS5");

var $iyxBj = parcelRequire("iyxBj");

var $5P5S6 = parcelRequire("5P5S6");

var $gc70Y = parcelRequire("gc70Y");

var $u24M4 = parcelRequire("u24M4");

var $JYcZH = parcelRequire("JYcZH");

var $6IfCx = parcelRequire("6IfCx");

var $7AXM0 = parcelRequire("7AXM0");

var $8As5D = parcelRequire("8As5D");

var $7RNFG = parcelRequire("7RNFG");

var $alqNg = parcelRequire("alqNg");

var $eVyXG = parcelRequire("eVyXG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $ae3H3 = parcelRequire("ae3H3");

var $3AM7p = parcelRequire("3AM7p");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $db86fcacc6287e65$var$_ClearIcon, $db86fcacc6287e65$var$_ArrowDropDownIcon;
const $db86fcacc6287e65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $3AM7p.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ae3H3.getAutocompleteUtilityClass), classes);
};
const $db86fcacc6287e65$var$AutocompleteRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $ae3H3.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $ae3H3.default).tag}`]: styles[`tagSize${(0, $3AM7p.default)(size)}`]
            },
            {
                [`& .${(0, $ae3H3.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $ae3H3.default).input}`]: styles.input
            },
            {
                [`& .${(0, $ae3H3.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $ae3H3.default).focused} .${(0, $ae3H3.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $ae3H3.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $ae3H3.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $ae3H3.default).inputRoot}`]: {
        [`.${(0, $ae3H3.default).hasPopupIcon}&, .${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $ae3H3.default).hasPopupIcon}.${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $ae3H3.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $6IfCx.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $6IfCx.default).root}.${(0, $7AXM0.default).sizeSmall}`]: {
        [`& .${(0, $6IfCx.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $8As5D.default).root}`]: {
        padding: 9,
        [`.${(0, $ae3H3.default).hasPopupIcon}&, .${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $ae3H3.default).hasPopupIcon}.${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $ae3H3.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $ae3H3.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $8As5D.default).root}.${(0, $7AXM0.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $ae3H3.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $7RNFG.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $ae3H3.default).hasPopupIcon}&, .${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $ae3H3.default).hasPopupIcon}.${(0, $ae3H3.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $7RNFG.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $ae3H3.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $7RNFG.default).root}.${(0, $7AXM0.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $7RNFG.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $7AXM0.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $7RNFG.default).root}.${(0, $7AXM0.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $ae3H3.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $7RNFG.default).root}.${(0, $7AXM0.default).hiddenLabel}.${(0, $7AXM0.default).sizeSmall}`]: {
        [`& .${(0, $ae3H3.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $ae3H3.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $ae3H3.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $ae3H3.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $ae3H3.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $db86fcacc6287e65$var$AutocompleteEndAdornment = (0, $1Ikg4.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $db86fcacc6287e65$var$AutocompleteClearIndicator = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $db86fcacc6287e65$var$AutocompletePopupIndicator = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $db86fcacc6287e65$var$AutocompletePopper = (0, $1Ikg4.default)((0, $iyxBj.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $ae3H3.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $db86fcacc6287e65$var$AutocompletePaper = (0, $1Ikg4.default)((0, $gc70Y.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $db86fcacc6287e65$var$AutocompleteLoading = (0, $1Ikg4.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $db86fcacc6287e65$var$AutocompleteNoOptions = (0, $1Ikg4.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $db86fcacc6287e65$var$AutocompleteListbox = (0, $1Ikg4.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $lwQO9.default)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $ae3H3.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $ae3H3.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $ae3H3.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${(0, $ae3H3.default).focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $ae3H3.default).focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $db86fcacc6287e65$var$AutocompleteGroupLabel = (0, $1Ikg4.default)((0, $5P5S6.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $lwQO9.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $db86fcacc6287e65$var$AutocompleteGroupUl = (0, $1Ikg4.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${(0, $ae3H3.default).option}`]: {
        paddingLeft: 24
    }
});
const $db86fcacc6287e65$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $db86fcacc6287e65$var$_ClearIcon || ($db86fcacc6287e65$var$_ClearIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $alqNg.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $db86fcacc6287e65$var$_ArrowDropDownIcon || ($db86fcacc6287e65$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVyXG.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $7IYS5.default)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $db86fcacc6287e65$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $3fDLr.default)('listbox', {
        elementType: $db86fcacc6287e65$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $3fDLr.default)('paper', {
        elementType: (0, $gc70Y.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $3fDLr.default)('popper', {
        elementType: (0, $iyxBj.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $9QePP.default)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $ayMG0.jsxs)($db86fcacc6287e65$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $9QePP.default)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $9QePP.default)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($db86fcacc6287e65$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($db86fcacc6287e65$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $db86fcacc6287e65$export$2e2bcd8739ae039 = $db86fcacc6287e65$var$Autocomplete;

});
parcelRegister("7IYS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fbdc39f1f5d354$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $hervl = parcelRequire("hervl");

var $13KXh = parcelRequire("13KXh");

var $agZ85 = parcelRequire("agZ85");

var $auC0X = parcelRequire("auC0X");

var $9D07P = parcelRequire("9D07P");
'use client';
function $59fbdc39f1f5d354$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $59fbdc39f1f5d354$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $59fbdc39f1f5d354$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $59fbdc39f1f5d354$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $59fbdc39f1f5d354$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $59fbdc39f1f5d354$var$defaultFilterOptions = $59fbdc39f1f5d354$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $59fbdc39f1f5d354$var$pageSize = 5;
const $59fbdc39f1f5d354$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $59fbdc39f1f5d354$var$MULTIPLE_DEFAULT_VALUE = [];
function $59fbdc39f1f5d354$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $59fbdc39f1f5d354$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $59fbdc39f1f5d354$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $59fbdc39f1f5d354$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $59fbdc39f1f5d354$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $auC0X.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedItem, setFocusedItem] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $acw62.useRef($59fbdc39f1f5d354$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $agZ85.default)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $59fbdc39f1f5d354$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $agZ85.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $9D07P.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $13KXh.default)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $13KXh.default)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $13KXh.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$59fbdc39f1f5d354$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$59fbdc39f1f5d354$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $13KXh.default)((node)=>{
        (0, $hervl.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        if (focusedItem === -1) {
            if (inputValue === '' && direction === 'previous') nextItem = value.length - 1;
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$59fbdc39f1f5d354$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $59fbdc39f1f5d354$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    if (!multiple && renderValue) focusItem(0);
                    else handleFocusItem(event, 'previous');
                    break;
                case 'ArrowRight':
                    if (!multiple && renderValue) focusItem(-1);
                    else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $59fbdc39f1f5d354$export$2e2bcd8739ae039 = $59fbdc39f1f5d354$var$useAutocomplete;

});
parcelRegister("9D07P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7027da6f4b17de9d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
'use client';
function $7027da6f4b17de9d$var$usePreviousProps(value) {
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;

});


parcelRegister("5P5S6", function(module, exports) {

$parcel$export(module.exports, "default", () => $43d645228959d4db$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $9wn9a = parcelRequire("9wn9a");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $43d645228959d4db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $3AM7p.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9wn9a.getListSubheaderUtilityClass), classes);
};
const $43d645228959d4db$var$ListSubheaderRoot = (0, $1Ikg4.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $43d645228959d4db$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $43d645228959d4db$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($43d645228959d4db$var$ListSubheaderRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($43d645228959d4db$var$ListSubheader) $43d645228959d4db$var$ListSubheader.muiSkipListHighlight = true;
var $43d645228959d4db$export$2e2bcd8739ae039 = $43d645228959d4db$var$ListSubheader;

});
parcelRegister("9wn9a", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $6ee90eb78ea2438c$export$6816d4fc0981ec7);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6ee90eb78ea2438c$export$6816d4fc0981ec7(slot) {
    return (0, $4Cod0.default)('MuiListSubheader', slot);
}
const $6ee90eb78ea2438c$var$listSubheaderClasses = (0, $beCSm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $6ee90eb78ea2438c$export$2e2bcd8739ae039 = $6ee90eb78ea2438c$var$listSubheaderClasses;

});


parcelRegister("ae3H3", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $771e13a664558c82$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $771e13a664558c82$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $771e13a664558c82$export$8ee01529667e66d9(slot) {
    return (0, $4Cod0.default)('MuiAutocomplete', slot);
}
const $771e13a664558c82$var$autocompleteClasses = (0, $beCSm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $771e13a664558c82$export$2e2bcd8739ae039 = $771e13a664558c82$var$autocompleteClasses;

});


parcelRegister("lluj3", function(module, exports) {

$parcel$export(module.exports, "computeLinePoints", () => $f8a3115883abd1dc$export$bfbd9a993cf94d79);
$parcel$export(module.exports, "Line", () => $f8a3115883abd1dc$export$17d680238e50603e);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $lIF05 = parcelRequire("lIF05");

var $cdvPg = parcelRequire("cdvPg");

var $gs1ok = parcelRequire("gs1ok");

var $bJtQU = parcelRequire("bJtQU");

var $9qtrE = parcelRequire("9qtrE");

var $3FiDp = parcelRequire("3FiDp");

var $02Ymo = parcelRequire("02Ymo");

var $hBeJX = parcelRequire("hBeJX");

var $CpNo3 = parcelRequire("CpNo3");

var $2C2Dz = parcelRequire("2C2Dz");

var $kCoA9 = parcelRequire("kCoA9");

var $j0wOw = parcelRequire("j0wOw");

var $jHn5r = parcelRequire("jHn5r");

var $3X9hg = parcelRequire("3X9hg");

var $awoRF = parcelRequire("awoRF");

var $bqlEl = parcelRequire("bqlEl");

var $ckb0X = parcelRequire("ckb0X");

var $eHwNv = parcelRequire("eHwNv");

var $dujP6 = parcelRequire("dujP6");

var $cd9rh = parcelRequire("cd9rh");

var $5IafS = parcelRequire("5IafS");

var $jhZFb = parcelRequire("jhZFb");

var $aPPc1 = parcelRequire("aPPc1");

var $4M6vj = parcelRequire("4M6vj");

var $lTk0V = parcelRequire("lTk0V");

var $lT2y6 = parcelRequire("lT2y6");

var $63Kel = parcelRequire("63Kel");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $biEKl = parcelRequire("biEKl");
var $f8a3115883abd1dc$var$_excluded = [
    "id"
], $f8a3115883abd1dc$var$_excluded2 = [
    "type",
    "layout",
    "connectNulls",
    "needClip",
    "shape",
    "strokeDasharray"
], $f8a3115883abd1dc$var$_excluded3 = [
    "activeDot",
    "animateNewValues",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "hide",
    "isAnimationActive",
    "label",
    "legendType",
    "xAxisId",
    "yAxisId",
    "id"
];
function $f8a3115883abd1dc$var$_extends() {
    return $f8a3115883abd1dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8a3115883abd1dc$var$_extends.apply(null, arguments);
}
function $f8a3115883abd1dc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f8a3115883abd1dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $f8a3115883abd1dc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f8a3115883abd1dc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f8a3115883abd1dc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f8a3115883abd1dc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f8a3115883abd1dc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f8a3115883abd1dc$var$_defineProperty(e, r, t) {
    return (r = $f8a3115883abd1dc$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f8a3115883abd1dc$var$_toPropertyKey(t) {
    var i = $f8a3115883abd1dc$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f8a3115883abd1dc$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ function $f8a3115883abd1dc$var$getTotalLength(mainCurve) {
    try {
        return mainCurve && mainCurve.getTotalLength && mainCurve.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
/**
 * Compute the average x-shift between matched pairs (prev → next).
 * This tells us the overall direction and magnitude of the data movement.
 */ function $f8a3115883abd1dc$var$averageShift(items) {
    var total = 0;
    var count = 0;
    for (var item of items)if (item.status === 'matched' && item.prev.x != null && item.next.x != null) {
        total += item.next.x - item.prev.x;
        count++;
    }
    return count > 0 ? total / count : 0;
}
var $f8a3115883abd1dc$var$defaultLineAnimateItems = (items, animationElapsedTime)=>{
    if (items == null) // First render: return empty, stroke-dasharray handles the reveal
    return [];
    // At animationElapsedTime=1 return only the non-removed items
    if (animationElapsedTime === 1) return items.flatMap((item)=>item.status === 'removed' ? [] : [
            item.next
        ]);
    var shift = $f8a3115883abd1dc$var$averageShift(items);
    var result = [];
    for (var item of items){
        if (item.status === 'matched') result.push($f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, item.next), {}, {
            x: (0, $3FiDp.interpolate)(item.prev.x, item.next.x, animationElapsedTime),
            y: (0, $3FiDp.interpolate)(item.prev.y, item.next.y, animationElapsedTime)
        }));
        else if (item.status === 'added') {
            if (item.next.x != null) {
                // Extrapolate entry position: the point starts where it "would have been"
                var entryX = item.next.x - shift;
                result.push($f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, item.next), {}, {
                    x: (0, $3FiDp.interpolate)(entryX, item.next.x, animationElapsedTime),
                    y: item.next.y
                }));
            } else result.push(item.next);
        } else if (item.status === 'removed') {
            if (item.prev.x != null) {
                var exitX = item.prev.x + shift;
                result.push($f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, item.prev), {}, {
                    x: (0, $3FiDp.interpolate)(item.prev.x, exitX, animationElapsedTime),
                    y: item.prev.y
                }));
            }
        }
    }
    return result;
};
var $f8a3115883abd1dc$export$ab40e5efc5c9973f = {
    activeDot: true,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    animationInterpolateFn: $f8a3115883abd1dc$var$defaultLineAnimateItems,
    animationMatchBy: (0, $dujP6.matchByIndex),
    connectNulls: false,
    dot: true,
    fill: '#fff',
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'line',
    shape: (0, $cdvPg.LineDrawShape),
    stroke: '#3182bd',
    strokeWidth: 1,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $gKNgz.DefaultZIndexes).line,
    type: 'linear'
};
/**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ var $f8a3115883abd1dc$var$computeLegendPayloadFromAreaData = (props)=>{
    var dataKey = props.dataKey, name = props.name, stroke = props.stroke, legendType = props.legendType, hide = props.hide;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: stroke,
            value: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            payload: props
        }
    ];
};
var $f8a3115883abd1dc$var$SetLineTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var dataKey = _ref.dataKey, data = _ref.data, stroke = _ref.stroke, strokeWidth = _ref.strokeWidth, fill = _ref.fill, name = _ref.name, hide = _ref.hide, unit = _ref.unit, formatter = _ref.formatter, tooltipType = _ref.tooltipType, id = _ref.id;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        getPosition: (0, $3FiDp.noop),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: stroke,
            unit: unit,
            formatter: formatter,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $2C2Dz.SetTooltipEntrySettings), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $f8a3115883abd1dc$var$LineDotsWrapper(_ref2) {
    var clipPathId = _ref2.clipPathId, points = _ref2.points, props = _ref2.props;
    var dot = props.dot, dataKey = props.dataKey, needClip = props.needClip;
    /*
   * Exclude ID from the props passed to the Dots component
   * because then the ID would be applied to multiple dots, and it would no longer be unique.
   */ var id = props.id, propsWithoutId = $f8a3115883abd1dc$var$_objectWithoutProperties(props, $f8a3115883abd1dc$var$_excluded);
    var lineProps = (0, $4M6vj.svgPropertiesNoEvents)(propsWithoutId);
    return /*#__PURE__*/ $acw62.createElement((0, $9qtrE.Dots), {
        points: points,
        dot: dot,
        className: "recharts-line-dots",
        dotClassName: "recharts-line-dot",
        dataKey: dataKey,
        baseProps: lineProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $f8a3115883abd1dc$var$LineLabelListProvider(_ref3) {
    var showLabels = _ref3.showLabels, children = _ref3.children, points = _ref3.points;
    var labelListEntries = (0, $acw62.useMemo)(()=>{
        return points === null || points === void 0 ? void 0 : points.map((point)=>{
            var _point$x, _point$y;
            var viewBox = {
                x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
                y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
                width: 0,
                lowerWidth: 0,
                upperWidth: 0,
                height: 0
            };
            return $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, viewBox), {}, {
                value: point.value,
                payload: point.payload,
                viewBox: viewBox,
                /*
         * Line is not passing parentViewBox to the LabelList so the labels can escape - looks like a bug, should we pass parentViewBox?
         * Or should this just be the root chart viewBox?
         */ parentViewBox: undefined,
                fill: undefined
            });
        });
    }, [
        points
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $bJtQU.CartesianLabelListContextProvider), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $f8a3115883abd1dc$var$StaticCurve(_ref4) {
    var clipPathId = _ref4.clipPathId, pathRef = _ref4.pathRef, points = _ref4.points, props = _ref4.props, animationElapsedTime = _ref4.animationElapsedTime, isAnimating = _ref4.isAnimating, isEntrance = _ref4.isEntrance, visibleLength = _ref4.visibleLength;
    var type = props.type, layout = props.layout, connectNulls = props.connectNulls, needClip = props.needClip, shape = props.shape, strokeDasharray = props.strokeDasharray, others = $f8a3115883abd1dc$var$_objectWithoutProperties(props, $f8a3115883abd1dc$var$_excluded2);
    var curveProps = $f8a3115883abd1dc$var$_objectSpread($f8a3115883abd1dc$var$_objectSpread({}, (0, $lTk0V.svgPropertiesAndEvents)(others)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined,
        points: points,
        type: type,
        layout: layout,
        connectNulls: connectNulls,
        strokeDasharray: strokeDasharray !== null && strokeDasharray !== void 0 ? strokeDasharray : props.strokeDasharray,
        pathRef: pathRef,
        animationElapsedTime: animationElapsedTime,
        isAnimating: isAnimating,
        isEntrance: props.animateNewValues ? isEntrance : false,
        visibleLength: visibleLength
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $acw62.createElement((0, $63Kel.Shape), {
        option: shape,
        DefaultShape: $f8a3115883abd1dc$export$ab40e5efc5c9973f.shape,
        shapeProps: curveProps
    }), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineDotsWrapper, {
        points: points,
        clipPathId: clipPathId,
        props: props
    }));
}
function $f8a3115883abd1dc$var$CurveWithAnimation(_ref5) {
    var clipPathId = _ref5.clipPathId, props = _ref5.props, pathRef = _ref5.pathRef, previousPointsRef = _ref5.previousPointsRef;
    var points = props.points, isAnimationActive = props.isAnimationActive, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, animationMatchBy = props.animationMatchBy, animationInterpolateFn = props.animationInterpolateFn, layout = props.layout;
    var totalLength = $f8a3115883abd1dc$var$getTotalLength(pathRef.current);
    var _useAnimationCallback = (0, $eHwNv.useAnimationCallbacks)(props.onAnimationStart, props.onAnimationEnd), isAnimating = _useAnimationCallback.isAnimating, handleAnimationStart = _useAnimationCallback.handleAnimationStart, handleAnimationEnd = _useAnimationCallback.handleAnimationEnd;
    var showLabels = !isAnimating;
    var getVisibleLength = (0, $gs1ok.useAnimatedLineLength)(points);
    // Guard for totalLength: don't update previousPointsRef before SVG path is measured
    var shouldUpdatePreviousRef = (0, $acw62.useCallback)((animationElapsedTime)=>animationElapsedTime > 0 && totalLength > 0, [
        totalLength
    ]);
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineLabelListProvider, {
        points: points,
        showLabels: showLabels
    }, props.children, /*#__PURE__*/ $acw62.createElement((0, $eHwNv.AnimatedItems), {
        animationInput: points,
        animationIdPrefix: "recharts-line-",
        items: points,
        previousItemsRef: previousPointsRef,
        isAnimationActive: isAnimationActive,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        animationInterpolateFn: animationInterpolateFn,
        animationMatchBy: animationMatchBy,
        shouldUpdatePreviousRef: shouldUpdatePreviousRef,
        layout: layout
    }, (stepData, animationElapsedTime, isEntrance)=>{
        var animationActive = isAnimating || animationElapsedTime < 1;
        var visibleLength = animationActive ? getVisibleLength(animationElapsedTime, totalLength) : null;
        return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$StaticCurve, {
            props: props,
            points: stepData,
            clipPathId: clipPathId,
            pathRef: pathRef,
            animationElapsedTime: animationElapsedTime,
            isAnimating: animationActive,
            isEntrance: isEntrance,
            visibleLength: visibleLength
        });
    }), /*#__PURE__*/ $acw62.createElement((0, $bJtQU.LabelListFromLabelProp), {
        label: props.label
    }));
}
function $f8a3115883abd1dc$var$RenderCurve(_ref6) {
    var clipPathId = _ref6.clipPathId, props = _ref6.props;
    var previousPointsRef = (0, $acw62.useRef)(null);
    var pathRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$CurveWithAnimation, {
        props: props,
        clipPathId: clipPathId,
        previousPointsRef: previousPointsRef,
        pathRef: pathRef
    });
}
var $f8a3115883abd1dc$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    var _dataPoint$x, _dataPoint$y;
    return {
        x: (_dataPoint$x = dataPoint.x) !== null && _dataPoint$x !== void 0 ? _dataPoint$x : undefined,
        y: (_dataPoint$y = dataPoint.y) !== null && _dataPoint$y !== void 0 ? _dataPoint$y : undefined,
        value: dataPoint.value,
        // getValueByDataKey does not validate the output type
        errorVal: (0, $hBeJX.getValueByDataKey)(dataPoint.payload, dataKey)
    };
};
// eslint-disable-next-line react/prefer-stateless-function
class $f8a3115883abd1dc$var$LineWithState extends (0, $acw62.Component) {
    render() {
        var _this$props = this.props, hide = _this$props.hide, dot = _this$props.dot, points = _this$props.points, className = _this$props.className, xAxisId = _this$props.xAxisId, yAxisId = _this$props.yAxisId, top = _this$props.top, left = _this$props.left, width = _this$props.width, height = _this$props.height, id = _this$props.id, needClip = _this$props.needClip, zIndex = _this$props.zIndex;
        if (hide) return null;
        var layerClass = (0, $9QePP.clsx)('recharts-line', className);
        var clipPathId = id;
        var _getRadiusAndStrokeWi = (0, $lT2y6.getRadiusAndStrokeWidthFromDot)(dot), r = _getRadiusAndStrokeWi.r, strokeWidth = _getRadiusAndStrokeWi.strokeWidth;
        var clipDot = (0, $02Ymo.isClipDot)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
            zIndex: zIndex
        }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $j0wOw.GraphicalItemClipPath), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $acw62.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $acw62.createElement((0, $kCoA9.SetErrorBarContext), {
            xAxisId: xAxisId,
            yAxisId: yAxisId,
            data: points,
            dataPointFormatter: $f8a3115883abd1dc$var$errorBarDataPointFormatter,
            errorBarOffset: 0
        }, /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$RenderCurve, {
            props: this.props,
            clipPathId: clipPathId
        }))), /*#__PURE__*/ $acw62.createElement((0, $CpNo3.ActivePoints), {
            activeDot: this.props.activeDot,
            points: points,
            mainColor: this.props.stroke,
            itemDataKey: this.props.dataKey,
            clipPath: activePointsClipPath
        }));
    }
}
function $f8a3115883abd1dc$var$LineImpl(props) {
    var _resolveDefaultProps = (0, $cd9rh.resolveDefaultProps)(props, $f8a3115883abd1dc$export$ab40e5efc5c9973f), activeDot = _resolveDefaultProps.activeDot, animateNewValues = _resolveDefaultProps.animateNewValues, animationBegin = _resolveDefaultProps.animationBegin, animationDuration = _resolveDefaultProps.animationDuration, animationEasing = _resolveDefaultProps.animationEasing, connectNulls = _resolveDefaultProps.connectNulls, dot = _resolveDefaultProps.dot, hide = _resolveDefaultProps.hide, isAnimationActive = _resolveDefaultProps.isAnimationActive, label = _resolveDefaultProps.label, legendType = _resolveDefaultProps.legendType, xAxisId = _resolveDefaultProps.xAxisId, yAxisId = _resolveDefaultProps.yAxisId, id = _resolveDefaultProps.id, everythingElse = $f8a3115883abd1dc$var$_objectWithoutProperties(_resolveDefaultProps, $f8a3115883abd1dc$var$_excluded3);
    var _useNeedsClip = (0, $j0wOw.useNeedsClip)(xAxisId, yAxisId), needClip = _useNeedsClip.needClip;
    var plotArea = (0, $5IafS.usePlotArea)();
    var layout = (0, $jHn5r.useChartLayout)();
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var points = (0, $bqlEl.useAppSelector)((state)=>(0, $awoRF.selectLinePoints)(state, xAxisId, yAxisId, isPanorama, id));
    if (layout !== 'horizontal' && layout !== 'vertical' || points == null || plotArea == null) // Cannot render Line in an unsupported layout
    return null;
    var height = plotArea.height, width = plotArea.width, left = plotArea.x, top = plotArea.y;
    return /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineWithState, $f8a3115883abd1dc$var$_extends({}, everythingElse, {
        id: id,
        connectNulls: connectNulls,
        dot: dot,
        activeDot: activeDot,
        animateNewValues: animateNewValues,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        label: label,
        legendType: legendType,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        points: points,
        layout: layout,
        height: height,
        width: width,
        left: left,
        top: top,
        needClip: needClip
    }));
}
function $f8a3115883abd1dc$export$bfbd9a993cf94d79(_ref7) {
    var layout = _ref7.layout, xAxis = _ref7.xAxis, yAxis = _ref7.yAxis, xAxisTicks = _ref7.xAxisTicks, yAxisTicks = _ref7.yAxisTicks, dataKey = _ref7.dataKey, bandSize = _ref7.bandSize, displayedData = _ref7.displayedData;
    return displayedData.map((entry, index)=>{
        // getValueByDataKey does not validate the output type
        var value = (0, $hBeJX.getValueByDataKey)(entry, dataKey);
        if (layout === 'horizontal') {
            var _x = (0, $hBeJX.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            });
            var _y = (0, $3FiDp.isNullish)(value) ? null : yAxis.scale.map(value);
            return {
                x: _x,
                y: _y !== null && _y !== void 0 ? _y : null,
                value: value,
                payload: entry
            };
        }
        var x = (0, $3FiDp.isNullish)(value) ? null : xAxis.scale.map(value);
        var y = (0, $hBeJX.getCateCoordinateOfLine)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: bandSize,
            entry: entry,
            index: index
        });
        if (x == null || y == null) return null;
        return {
            x: x,
            y: y,
            value: value,
            payload: entry
        };
    }).filter(Boolean);
}
function $f8a3115883abd1dc$var$LineFn(outsideProps) {
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $f8a3115883abd1dc$export$ab40e5efc5c9973f);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    return /*#__PURE__*/ $acw62.createElement((0, $jhZFb.RegisterGraphicalItemId), {
        id: props.id,
        type: "line"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $ckb0X.SetLegendPayload), {
            legendPayload: $f8a3115883abd1dc$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$SetLineTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            formatter: props.formatter,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $aPPc1.SetCartesianGraphicalItem), {
            type: "line",
            id: id,
            data: props.data,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            hide: props.hide,
            isPanorama: isPanorama
        }), /*#__PURE__*/ $acw62.createElement($f8a3115883abd1dc$var$LineImpl, $f8a3115883abd1dc$var$_extends({}, props, {
            id: id
        }))));
}
var $f8a3115883abd1dc$export$17d680238e50603e = /*#__PURE__*/ $acw62.memo($f8a3115883abd1dc$var$LineFn, (0, $biEKl.propsAreEqual));
// @ts-expect-error we need to set the displayName for debugging purposes
$f8a3115883abd1dc$export$17d680238e50603e.displayName = 'Line';

});
parcelRegister("cdvPg", function(module, exports) {

$parcel$export(module.exports, "LineDrawShape", () => $8e4f62e140d2fa83$export$4e284198d85256ea);

var $acw62 = parcelRequire("acw62");

var $f2bYI = parcelRequire("f2bYI");
var $8e4f62e140d2fa83$var$_excluded = [
    "animationElapsedTime",
    "isAnimating",
    "isEntrance",
    "visibleLength",
    "strokeDasharray",
    "connectNulls"
];
function $8e4f62e140d2fa83$var$_extends() {
    return $8e4f62e140d2fa83$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8e4f62e140d2fa83$var$_extends.apply(null, arguments);
}
function $8e4f62e140d2fa83$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8e4f62e140d2fa83$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $8e4f62e140d2fa83$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Reads the total length of an SVG path element, returning 0 if the element
 * is null or the measurement fails (e.g. in JSDOM).
 */ function $8e4f62e140d2fa83$var$getTotalLength(path) {
    try {
        return path && path.getTotalLength && path.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
/**
 * Generates a simple stroke-dasharray string for animating a line draw effect.
 *
 * Uses `totalLength` as the gap (instead of `totalLength - length`) to prevent a floating-point
 * precision artifact: when fractional dash and gap values are serialized to a string attribute
 * and reparsed by the SVG renderer, their sum can differ from the actual path length by a ULP,
 * causing the dasharray pattern to repeat and render a phantom dot at the path endpoint
 * with round or square strokeLinecap.
 *
 * @param totalLength The total length of the SVG path
 * @param length The currently visible portion of the path
 * @returns A stroke-dasharray string like "50px 200px"
 */ function $8e4f62e140d2fa83$var$generateSimpleStrokeDasharray(totalLength, length) {
    return "".concat(length, "px ").concat(totalLength, "px");
}
/**
 * Normalizes a dash pattern to the even-length sequence used by SVG renderers.
 * Odd-length stroke-dasharray values repeat once, so "5" behaves like "5 5".
 *
 * @param lines Array of dash/gap lengths to repeat
 * @returns An even-length dash pattern
 */ function $8e4f62e140d2fa83$var$normalizeDashPattern(lines) {
    return lines.length % 2 !== 0 ? [
        ...lines,
        ...lines
    ] : lines;
}
/**
 * Repeats a dash pattern array a given number of times.
 *
 * @param lines Array of dash/gap lengths to repeat
 * @param count Number of times to repeat the pattern
 * @returns A new array with the pattern repeated `count` times
 */ function $8e4f62e140d2fa83$var$repeat(lines, count) {
    var result = [];
    for(var i = 0; i < count; ++i)result.push(...lines);
    return result;
}
/**
 * Computes a stroke-dasharray string for animating a custom-dashed line draw effect.
 *
 * Given a user-specified dash pattern (e.g. `"7,3"`), this function builds a dasharray
 * that reveals exactly `length` pixels of that pattern, followed by a gap of `totalLength`
 * to hide the remainder of the path.
 *
 * Like {@link generateSimpleStrokeDasharray}, the trailing gap uses `totalLength` rather than
 * `totalLength - length` to avoid floating-point precision artifacts with round/square strokeLinecap.
 *
 * @param length The currently visible portion of the path
 * @param totalLength The total length of the SVG path
 * @param lines The user-specified dash pattern as an array of numbers (e.g. [7, 3])
 * @returns A stroke-dasharray string incorporating the custom dash pattern
 */ function $8e4f62e140d2fa83$var$getStrokeDasharray(length, totalLength, lines) {
    var normalizedLines = $8e4f62e140d2fa83$var$normalizeDashPattern(lines);
    var lineLength = normalizedLines.reduce((pre, next)=>pre + next, 0);
    // if lineLength is 0 return the default when no strokeDasharray is provided
    if (!lineLength) return $8e4f62e140d2fa83$var$generateSimpleStrokeDasharray(totalLength, length);
    var count = Math.floor(length / lineLength);
    var remainLength = length % lineLength;
    var remainLines = [];
    for(var i = 0, sum = 0; i < normalizedLines.length; sum += (_normalizedLines$i = normalizedLines[i]) !== null && _normalizedLines$i !== void 0 ? _normalizedLines$i : 0, ++i){
        var _normalizedLines$i;
        var lineValue = normalizedLines[i];
        if (lineValue != null && sum + lineValue > remainLength) {
            remainLines = [
                ...normalizedLines.slice(0, i),
                remainLength - sum
            ];
            break;
        }
    }
    var emptyLines = remainLines.length % 2 === 0 ? [
        0,
        totalLength
    ] : [
        totalLength
    ];
    return [
        ...$8e4f62e140d2fa83$var$repeat(normalizedLines, count),
        ...remainLines,
        ...emptyLines
    ].map((line)=>"".concat(line, "px")).join(', ');
}
/**
 * Computes the animated stroke-dasharray for a line's entrance animation.
 *
 * @param userStrokeDasharray The user-specified stroke-dasharray (e.g. "5,3"), if any
 * @param totalLength Total SVG path length
 * @param visibleLength How much of the path should be visible
 * @returns A stroke-dasharray string for the current animation frame
 */ function $8e4f62e140d2fa83$var$computeAnimatedStrokeDasharray(userStrokeDasharray, totalLength, visibleLength) {
    if (userStrokeDasharray) {
        var lines = "".concat(userStrokeDasharray).split(/[,\s]+/gim).map((num)=>parseFloat(num));
        return $8e4f62e140d2fa83$var$getStrokeDasharray(visibleLength, totalLength, lines);
    }
    return $8e4f62e140d2fa83$var$generateSimpleStrokeDasharray(totalLength, visibleLength);
}
function $8e4f62e140d2fa83$export$4e284198d85256ea(props) {
    var _animationElapsedTime = props.animationElapsedTime, isAnimating = props.isAnimating, isEntrance = props.isEntrance, visibleLength = props.visibleLength, userStrokeDasharray = props.strokeDasharray, connectNulls = props.connectNulls, curveProps = $8e4f62e140d2fa83$var$_objectWithoutProperties(props, $8e4f62e140d2fa83$var$_excluded);
    var finalConnectNulls = connectNulls !== null && connectNulls !== void 0 ? connectNulls : false;
    var strokeDasharray;
    if (visibleLength != null) {
        var _pathRef$current;
        var pathRef = curveProps.pathRef;
        var totalLength = $8e4f62e140d2fa83$var$getTotalLength((_pathRef$current = pathRef === null || pathRef === void 0 ? void 0 : pathRef.current) !== null && _pathRef$current !== void 0 ? _pathRef$current : null);
        strokeDasharray = $8e4f62e140d2fa83$var$computeAnimatedStrokeDasharray(userStrokeDasharray, totalLength, visibleLength);
    } else if (userStrokeDasharray != null) strokeDasharray = String(userStrokeDasharray);
    return /*#__PURE__*/ $acw62.createElement((0, $f2bYI.Curve), $8e4f62e140d2fa83$var$_extends({}, curveProps, {
        connectNulls: finalConnectNulls,
        strokeDasharray: strokeDasharray
    }));
}

});

parcelRegister("gs1ok", function(module, exports) {

$parcel$export(module.exports, "useAnimatedLineLength", () => $bfa057291c855c8d$export$60cdaa46146ddc46);

var $acw62 = parcelRequire("acw62");

var $erqUX = parcelRequire("erqUX");
function $bfa057291c855c8d$export$60cdaa46146ddc46(points) {
    var startingLengthRef = (0, $acw62.useRef)(0);
    var maxAnimatedLengthRef = (0, $acw62.useRef)(0);
    var reachedFullRef = (0, $acw62.useRef)(false);
    var prevPointsRef = (0, $acw62.useRef)(points);
    if (prevPointsRef.current !== points) {
        startingLengthRef.current = maxAnimatedLengthRef.current;
        prevPointsRef.current = points;
    }
    // The callback is stable (never changes identity) because it only reads from refs.
    // This avoids triggering unnecessary re-renders in consumers.
    return (0, $acw62.useCallback)((animationElapsedTime, totalLength)=>{
        if (reachedFullRef.current) return null;
        var visibleLength = Math.min((0, $erqUX.round)(startingLengthRef.current + animationElapsedTime * totalLength), totalLength);
        if (animationElapsedTime > 0 && totalLength > 0) {
            maxAnimatedLengthRef.current = Math.max(maxAnimatedLengthRef.current, visibleLength);
            if (visibleLength >= totalLength) {
                reachedFullRef.current = true;
                return null;
            }
        }
        return visibleLength;
    }, []);
}

});

parcelRegister("bJtQU", function(module, exports) {

$parcel$export(module.exports, "CartesianLabelListContextProvider", () => $88ab0dba0fc78576$export$64e384eac5db53f7);
$parcel$export(module.exports, "PolarLabelListContextProvider", () => $88ab0dba0fc78576$export$38a852d7976af0fe);
$parcel$export(module.exports, "LabelList", () => $88ab0dba0fc78576$export$835fcf23ab7bf88);
$parcel$export(module.exports, "LabelListFromLabelProp", () => $88ab0dba0fc78576$export$9a402bc8de2b410e);

var $acw62 = parcelRequire("acw62");

var $ahoy0 = parcelRequire("ahoy0");

var $lIF05 = parcelRequire("lIF05");

var $hBeJX = parcelRequire("hBeJX");

var $3FiDp = parcelRequire("3FiDp");

var $lTk0V = parcelRequire("lTk0V");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $cU1wp = parcelRequire("cU1wp");
var $88ab0dba0fc78576$var$_excluded = [
    "valueAccessor"
], $88ab0dba0fc78576$var$_excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function $88ab0dba0fc78576$var$_extends() {
    return $88ab0dba0fc78576$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $88ab0dba0fc78576$var$_extends.apply(null, arguments);
}
function $88ab0dba0fc78576$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $88ab0dba0fc78576$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 *
 * @inline
 */ var $88ab0dba0fc78576$var$defaultAccessor = (entry)=>{
    var val = Array.isArray(entry.value) ? entry.value[entry.value.length - 1] : entry.value;
    if ((0, $cU1wp.isRenderableText)(val)) return val;
    return undefined;
};
var $88ab0dba0fc78576$var$CartesianLabelListContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $88ab0dba0fc78576$export$64e384eac5db53f7 = $88ab0dba0fc78576$var$CartesianLabelListContext.Provider;
var $88ab0dba0fc78576$var$PolarLabelListContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $88ab0dba0fc78576$export$38a852d7976af0fe = $88ab0dba0fc78576$var$PolarLabelListContext.Provider;
function $88ab0dba0fc78576$var$useCartesianLabelListContext() {
    return (0, $acw62.useContext)($88ab0dba0fc78576$var$CartesianLabelListContext);
}
function $88ab0dba0fc78576$var$usePolarLabelListContext() {
    return (0, $acw62.useContext)($88ab0dba0fc78576$var$PolarLabelListContext);
}
function $88ab0dba0fc78576$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $88ab0dba0fc78576$var$defaultAccessor : _ref$valueAccessor, restProps = $88ab0dba0fc78576$var$_objectWithoutProperties(_ref, $88ab0dba0fc78576$var$_excluded);
    var dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, zIndex = restProps.zIndex, others = $88ab0dba0fc78576$var$_objectWithoutProperties(restProps, $88ab0dba0fc78576$var$_excluded2);
    var cartesianData = $88ab0dba0fc78576$var$useCartesianLabelListContext();
    var polarData = $88ab0dba0fc78576$var$usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, $gKNgz.DefaultZIndexes).label
    }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, $3FiDp.isNullish)(dataKey) ? valueAccessor(entry, index) : (0, $hBeJX.getValueByDataKey)(entry.payload, dataKey);
        var idProps = (0, $3FiDp.isNullish)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ $acw62.createElement((0, $ahoy0.Label), $88ab0dba0fc78576$var$_extends({
            key: "label-".concat(index)
        }, (0, $lTk0V.svgPropertiesAndEvents)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
$88ab0dba0fc78576$export$835fcf23ab7bf88.displayName = 'LabelList';
function $88ab0dba0fc78576$export$9a402bc8de2b410e(_ref2) {
    var label = _ref2.label;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ $acw62.isValidElement(label) || (0, $ahoy0.isLabelContentAFunction)(label)) return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ $acw62.createElement($88ab0dba0fc78576$export$835fcf23ab7bf88, $88ab0dba0fc78576$var$_extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}

});

parcelRegister("9qtrE", function(module, exports) {

$parcel$export(module.exports, "Dots", () => $6dcd61e97c26c79c$export$8da50d3722682be0);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $2ifNc = parcelRequire("2ifNc");

var $lIF05 = parcelRequire("lIF05");

var $02Ymo = parcelRequire("02Ymo");

var $lTk0V = parcelRequire("lTk0V");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");
var $6dcd61e97c26c79c$var$_excluded = [
    "points"
];
function $6dcd61e97c26c79c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6dcd61e97c26c79c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6dcd61e97c26c79c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6dcd61e97c26c79c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6dcd61e97c26c79c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6dcd61e97c26c79c$var$_defineProperty(e, r, t) {
    return (r = $6dcd61e97c26c79c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6dcd61e97c26c79c$var$_toPropertyKey(t) {
    var i = $6dcd61e97c26c79c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6dcd61e97c26c79c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $6dcd61e97c26c79c$var$_extends() {
    return $6dcd61e97c26c79c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6dcd61e97c26c79c$var$_extends.apply(null, arguments);
}
function $6dcd61e97c26c79c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6dcd61e97c26c79c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6dcd61e97c26c79c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $6dcd61e97c26c79c$var$DotItem(_ref) {
    var option = _ref.option, dotProps = _ref.dotProps, className = _ref.className;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) // @ts-expect-error we can't type check element cloning properly
    return /*#__PURE__*/ (0, $acw62.cloneElement)(option, dotProps);
    if (typeof option === 'function') return option(dotProps);
    var finalClassName = (0, $9QePP.clsx)(className, typeof option !== 'boolean' ? option.className : '');
    var _ref2 = dotProps !== null && dotProps !== void 0 ? dotProps : {}, points = _ref2.points, props = $6dcd61e97c26c79c$var$_objectWithoutProperties(_ref2, $6dcd61e97c26c79c$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $2ifNc.Dot), $6dcd61e97c26c79c$var$_extends({}, props, {
        className: finalClassName
    }));
}
function $6dcd61e97c26c79c$var$shouldRenderDots(points, dot) {
    if (points == null) return false;
    if (dot) return true;
    return points.length === 1;
}
function $6dcd61e97c26c79c$export$8da50d3722682be0(_ref3) {
    var points = _ref3.points, dot = _ref3.dot, className = _ref3.className, dotClassName = _ref3.dotClassName, dataKey = _ref3.dataKey, baseProps = _ref3.baseProps, needClip = _ref3.needClip, clipPathId = _ref3.clipPathId, _ref3$zIndex = _ref3.zIndex, zIndex = _ref3$zIndex === void 0 ? (0, $gKNgz.DefaultZIndexes).scatter : _ref3$zIndex;
    if (!$6dcd61e97c26c79c$var$shouldRenderDots(points, dot)) return null;
    var clipDot = (0, $02Ymo.isClipDot)(dot);
    var customDotProps = (0, $lTk0V.svgPropertiesAndEventsFromUnknown)(dot);
    var dots = points.map((entry, i)=>{
        var _entry$x, _entry$y;
        var dotProps = $6dcd61e97c26c79c$var$_objectSpread($6dcd61e97c26c79c$var$_objectSpread($6dcd61e97c26c79c$var$_objectSpread({
            r: 3
        }, baseProps), customDotProps), {}, {
            index: i,
            cx: (_entry$x = entry.x) !== null && _entry$x !== void 0 ? _entry$x : undefined,
            cy: (_entry$y = entry.y) !== null && _entry$y !== void 0 ? _entry$y : undefined,
            dataKey: dataKey,
            value: entry.value,
            payload: entry.payload,
            points: points
        });
        return /*#__PURE__*/ $acw62.createElement($6dcd61e97c26c79c$var$DotItem, {
            key: "dot-".concat(i),
            option: dot,
            dotProps: dotProps,
            className: dotClassName
        });
    });
    var layerProps = {};
    if (needClip && clipPathId != null) layerProps.clipPath = "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")");
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: zIndex
    }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), $6dcd61e97c26c79c$var$_extends({
        className: className
    }, layerProps), dots));
}

});
parcelRegister("2ifNc", function(module, exports) {

$parcel$export(module.exports, "Dot", () => $1ab98349969d46e2$export$d046b3c4a416f60d);

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $cpMpC = parcelRequire("cpMpC");

var $4M6vj = parcelRequire("4M6vj");

var $3FiDp = parcelRequire("3FiDp");
function $1ab98349969d46e2$var$_extends() {
    return $1ab98349969d46e2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1ab98349969d46e2$var$_extends.apply(null, arguments);
}
var $1ab98349969d46e2$export$d046b3c4a416f60d = (props)=>{
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $9QePP.clsx)('recharts-dot', className);
    if ((0, $3FiDp.isNumber)(cx) && (0, $3FiDp.isNumber)(cy) && (0, $3FiDp.isNumber)(r)) return /*#__PURE__*/ $acw62.createElement("circle", $1ab98349969d46e2$var$_extends({}, (0, $4M6vj.svgPropertiesNoEvents)(props), (0, $cpMpC.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

});

parcelRegister("02Ymo", function(module, exports) {

$parcel$export(module.exports, "findAllByType", () => $008f02516c156322$export$fdd5e64c0e8495bb);
$parcel$export(module.exports, "isClipDot", () => $008f02516c156322$export$28c0c718114c1a2e);

var $iqxMM = parcelRequire("iqxMM");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $3FiDp = parcelRequire("3FiDp");
var $008f02516c156322$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $008f02516c156322$export$be63e0664592e141 = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $008f02516c156322$var$lastChildren = null;
var $008f02516c156322$var$lastResult = null;
var $008f02516c156322$export$45b10814cc054894 = (children)=>{
    if (children === $008f02516c156322$var$lastChildren && Array.isArray($008f02516c156322$var$lastResult)) return $008f02516c156322$var$lastResult;
    var result = [];
    (0, $acw62.Children).forEach(children, (child)=>{
        if ((0, $3FiDp.isNullish)(child)) return;
        if ((0, $4jPKB.isFragment)(child)) result = result.concat($008f02516c156322$export$45b10814cc054894(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $008f02516c156322$var$lastResult = result;
    $008f02516c156322$var$lastChildren = children;
    return result;
};
function $008f02516c156322$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>$008f02516c156322$export$be63e0664592e141(t));
    else types = [
        $008f02516c156322$export$be63e0664592e141(type)
    ];
    $008f02516c156322$export$45b10814cc054894(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, $iqxMM.get)(child, 'type.displayName') || (0, $iqxMM.get)(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var $008f02516c156322$export$28c0c718114c1a2e = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});



parcelRegister("CpNo3", function(module, exports) {

$parcel$export(module.exports, "ActivePoints", () => $07378f2fb606b4ec$export$dd2d3dc8acd956aa);

var $acw62 = parcelRequire("acw62");

var $cpMpC = parcelRequire("cpMpC");

var $2ifNc = parcelRequire("2ifNc");

var $lIF05 = parcelRequire("lIF05");

var $bqlEl = parcelRequire("bqlEl");

var $71i43 = parcelRequire("71i43");

var $5IafS = parcelRequire("5IafS");

var $3FiDp = parcelRequire("3FiDp");

var $4M6vj = parcelRequire("4M6vj");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");
function $07378f2fb606b4ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07378f2fb606b4ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07378f2fb606b4ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $07378f2fb606b4ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07378f2fb606b4ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07378f2fb606b4ec$var$_defineProperty(e, r, t) {
    return (r = $07378f2fb606b4ec$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $07378f2fb606b4ec$var$_toPropertyKey(t) {
    var i = $07378f2fb606b4ec$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $07378f2fb606b4ec$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $07378f2fb606b4ec$var$ActivePoint = (_ref)=>{
    var point = _ref.point, childIndex = _ref.childIndex, mainColor = _ref.mainColor, activeDot = _ref.activeDot, dataKey = _ref.dataKey, clipPath = _ref.clipPath;
    if (activeDot === false || point.x == null || point.y == null) return null;
    var dotPropsTyped = {
        index: childIndex,
        dataKey: dataKey,
        cx: point.x,
        cy: point.y,
        r: 4,
        fill: mainColor !== null && mainColor !== void 0 ? mainColor : 'none',
        strokeWidth: 2,
        stroke: '#fff',
        payload: point.payload,
        value: point.value
    };
    // @ts-expect-error svgPropertiesNoEventsFromUnknown(activeDot) is contributing unknown props
    var dotProps = $07378f2fb606b4ec$var$_objectSpread($07378f2fb606b4ec$var$_objectSpread($07378f2fb606b4ec$var$_objectSpread({}, dotPropsTyped), (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(activeDot)), (0, $cpMpC.adaptEventHandlers)(activeDot));
    var dot;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(activeDot)) // @ts-expect-error we're improperly typing events
    dot = /*#__PURE__*/ (0, $acw62.cloneElement)(activeDot, dotProps);
    else if (typeof activeDot === 'function') dot = activeDot(dotProps);
    else dot = /*#__PURE__*/ $acw62.createElement((0, $2ifNc.Dot), dotProps);
    return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: "recharts-active-dot",
        clipPath: clipPath
    }, dot);
};
function $07378f2fb606b4ec$export$dd2d3dc8acd956aa(_ref2) {
    var points = _ref2.points, mainColor = _ref2.mainColor, activeDot = _ref2.activeDot, itemDataKey = _ref2.itemDataKey, clipPath = _ref2.clipPath, _ref2$zIndex = _ref2.zIndex, zIndex = _ref2$zIndex === void 0 ? (0, $gKNgz.DefaultZIndexes).activeDot : _ref2$zIndex;
    var activeTooltipIndex = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipIndex));
    var activeDataPoints = (0, $5IafS.useActiveTooltipDataPoints)();
    if (points == null || activeDataPoints == null) return null;
    var activePoint = points.find((p)=>activeDataPoints.includes(p.payload));
    if ((0, $3FiDp.isNullish)(activePoint)) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: zIndex
    }, /*#__PURE__*/ $acw62.createElement($07378f2fb606b4ec$var$ActivePoint, {
        point: activePoint,
        childIndex: Number(activeTooltipIndex),
        mainColor: mainColor,
        dataKey: itemDataKey,
        activeDot: activeDot,
        clipPath: clipPath
    }));
}

});

parcelRegister("2C2Dz", function(module, exports) {

$parcel$export(module.exports, "SetTooltipEntrySettings", () => $1e712d1b3a15e741$export$7fa09c17ce18f3e8);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $58RF9 = parcelRequire("58RF9");

var $3X9hg = parcelRequire("3X9hg");
function $1e712d1b3a15e741$export$7fa09c17ce18f3e8(_ref) {
    var tooltipEntrySettings = _ref.tooltipEntrySettings;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var prevSettingsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, $58RF9.addTooltipEntrySettings)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, $58RF9.replaceTooltipEntrySettings)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, $58RF9.removeTooltipEntrySettings)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}

});

parcelRegister("kCoA9", function(module, exports) {

$parcel$export(module.exports, "SetErrorBarContext", () => $f02a6cc200a05058$export$fcd6ba6fb4bc66e7);

var $acw62 = parcelRequire("acw62");

var $dx7pp = parcelRequire("dx7pp");

var $bqlEl = parcelRequire("bqlEl");

var $jhZFb = parcelRequire("jhZFb");
var $f02a6cc200a05058$var$_excluded = [
    "children"
];
function $f02a6cc200a05058$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f02a6cc200a05058$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f02a6cc200a05058$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f02a6cc200a05058$var$initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var $f02a6cc200a05058$var$ErrorBarContext = /*#__PURE__*/ (0, $acw62.createContext)($f02a6cc200a05058$var$initialContextState);
function $f02a6cc200a05058$export$fcd6ba6fb4bc66e7(props) {
    var children = props.children, rest = $f02a6cc200a05058$var$_objectWithoutProperties(props, $f02a6cc200a05058$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement($f02a6cc200a05058$var$ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var $f02a6cc200a05058$export$ce29452bff119c97 = ()=>(0, $acw62.useContext)($f02a6cc200a05058$var$ErrorBarContext);
function $f02a6cc200a05058$export$18dc5be7c8cb3008(props) {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var graphicalItemId = (0, $jhZFb.useGraphicalItemId)();
    var prevPropsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, $dx7pp.addErrorBar)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, $dx7pp.replaceErrorBar)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, $dx7pp.removeErrorBar)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}

});
parcelRegister("jhZFb", function(module, exports) {

$parcel$export(module.exports, "RegisterGraphicalItemId", () => $e0af6fe07417fba6$export$8c2f307ff93f02ba);
$parcel$export(module.exports, "useGraphicalItemId", () => $e0af6fe07417fba6$export$e24f341c4ff41691);

var $acw62 = parcelRequire("acw62");

var $66VW2 = parcelRequire("66VW2");
var $e0af6fe07417fba6$var$GraphicalItemIdContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $e0af6fe07417fba6$export$8c2f307ff93f02ba = (_ref)=>{
    var id = _ref.id, type = _ref.type, children = _ref.children;
    var resolvedId = (0, $66VW2.useUniqueId)("recharts-".concat(type), id);
    return /*#__PURE__*/ $acw62.createElement($e0af6fe07417fba6$var$GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function $e0af6fe07417fba6$export$e24f341c4ff41691() {
    return (0, $acw62.useContext)($e0af6fe07417fba6$var$GraphicalItemIdContext);
}

});
parcelRegister("66VW2", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $47303e546b24d86f$export$c485849f2e393253);

var $d70Dn = parcelRequire("d70Dn");
function $47303e546b24d86f$export$c485849f2e393253(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, $d70Dn.useId)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
} /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ 

});
parcelRegister("d70Dn", function(module, exports) {

$parcel$export(module.exports, "useId", () => $98bc6bba54b726bd$export$f680877a34711e37);

var $acw62 = parcelRequire("acw62");

var $3FiDp = parcelRequire("3FiDp");
var $98bc6bba54b726bd$var$_ref;
function $98bc6bba54b726bd$var$_slicedToArray(r, e) {
    return $98bc6bba54b726bd$var$_arrayWithHoles(r) || $98bc6bba54b726bd$var$_iterableToArrayLimit(r, e) || $98bc6bba54b726bd$var$_unsupportedIterableToArray(r, e) || $98bc6bba54b726bd$var$_nonIterableRest();
}
function $98bc6bba54b726bd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $98bc6bba54b726bd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $98bc6bba54b726bd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $98bc6bba54b726bd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $98bc6bba54b726bd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $98bc6bba54b726bd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $98bc6bba54b726bd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $98bc6bba54b726bd$export$bf86633db292cdb4 = ()=>{
    var _React$useState = $acw62.useState(()=>(0, $3FiDp.uniqueId)('uid-')), _React$useState2 = $98bc6bba54b726bd$var$_slicedToArray(_React$useState, 1), id = _React$useState2[0];
    return id;
};
var $98bc6bba54b726bd$export$f680877a34711e37 = ($98bc6bba54b726bd$var$_ref = $acw62['useId'.toString()]) !== null && $98bc6bba54b726bd$var$_ref !== void 0 ? $98bc6bba54b726bd$var$_ref : $98bc6bba54b726bd$export$bf86633db292cdb4;

});




parcelRegister("j0wOw", function(module, exports) {

$parcel$export(module.exports, "useNeedsClip", () => $dd677892692406d2$export$79e142f66441c204);
$parcel$export(module.exports, "GraphicalItemClipPath", () => $dd677892692406d2$export$d65f7a7dd82fbb63);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $99P3O = parcelRequire("99P3O");

var $5IafS = parcelRequire("5IafS");
function $dd677892692406d2$export$79e142f66441c204(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectXAxisSettings)(state, xAxisId));
    var yAxis = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectYAxisSettings)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, $99P3O.implicitXAxis).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, $99P3O.implicitYAxis).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip: needClip,
        needClipX: needClipX,
        needClipY: needClipY
    };
}
function $dd677892692406d2$export$d65f7a7dd82fbb63(_ref) {
    var xAxisId = _ref.xAxisId, yAxisId = _ref.yAxisId, clipPathId = _ref.clipPathId;
    var plotArea = (0, $5IafS.usePlotArea)();
    var _useNeedsClip = $dd677892692406d2$export$79e142f66441c204(xAxisId, yAxisId), needClipX = _useNeedsClip.needClipX, needClipY = _useNeedsClip.needClipY, needClip = _useNeedsClip.needClip;
    var xAxisRange = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectXAxisRange)(state, xAxisId, false));
    var yAxisRange = (0, $bqlEl.useAppSelector)((state)=>(0, $99P3O.selectYAxisRange)(state, yAxisId, false));
    if (!needClip || !plotArea) return null;
    var x = plotArea.x, y = plotArea.y, width = plotArea.width, height = plotArea.height;
    var clipX = needClipX && xAxisRange ? Math.min(xAxisRange[0], xAxisRange[1]) : x - width / 2;
    var clipY = needClipY && yAxisRange ? Math.min(yAxisRange[0], yAxisRange[1]) : y - height / 2;
    var clipWidth = needClipX && xAxisRange ? Math.abs(xAxisRange[1] - xAxisRange[0]) : width * 2;
    var clipHeight = needClipY && yAxisRange ? Math.abs(yAxisRange[1] - yAxisRange[0]) : height * 2;
    return /*#__PURE__*/ $acw62.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ $acw62.createElement("rect", {
        x: clipX,
        y: clipY,
        width: clipWidth,
        height: clipHeight
    }));
}

});

parcelRegister("awoRF", function(module, exports) {

$parcel$export(module.exports, "selectLinePoints", () => $7a902e28b5b16ff9$export$3eaebea0f6c183c0);

var $b0nKR = parcelRequire("b0nKR");

var $lluj3 = parcelRequire("lluj3");

var $i2WC7 = parcelRequire("i2WC7");

var $jHn5r = parcelRequire("jHn5r");

var $99P3O = parcelRequire("99P3O");

var $hBeJX = parcelRequire("hBeJX");
var $7a902e28b5b16ff9$var$selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, $99P3O.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, $99P3O.selectTicksOfGraphicalItem)(state, 'xAxis', xAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, $99P3O.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, $99P3O.selectTicksOfGraphicalItem)(state, 'yAxis', yAxisId, isPanorama);
var $7a902e28b5b16ff9$var$selectBandSize = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $7a902e28b5b16ff9$var$selectXAxisWithScale,
    $7a902e28b5b16ff9$var$selectYAxisWithScale,
    $7a902e28b5b16ff9$var$selectXAxisTicks,
    $7a902e28b5b16ff9$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $hBeJX.isCategoricalAxis)(layout, 'xAxis')) return (0, $hBeJX.getBandSizeOfAxis)(xAxis, xAxisTicks, false);
    return (0, $hBeJX.getBandSizeOfAxis)(yAxis, yAxisTicks, false);
});
var $7a902e28b5b16ff9$var$pickLineId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
function $7a902e28b5b16ff9$var$isLineSettings(item) {
    return item.type === 'line';
}
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * So here instead of reading the dataKey from the props, we always read it from the state.
 */ var $7a902e28b5b16ff9$var$selectSynchronisedLineSettings = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectUnfilteredCartesianItems),
    $7a902e28b5b16ff9$var$pickLineId
], (graphicalItems, id)=>graphicalItems.filter($7a902e28b5b16ff9$var$isLineSettings).find((x)=>x.id === id));
var $7a902e28b5b16ff9$export$3eaebea0f6c183c0 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $7a902e28b5b16ff9$var$selectXAxisWithScale,
    $7a902e28b5b16ff9$var$selectYAxisWithScale,
    $7a902e28b5b16ff9$var$selectXAxisTicks,
    $7a902e28b5b16ff9$var$selectYAxisTicks,
    $7a902e28b5b16ff9$var$selectSynchronisedLineSettings,
    $7a902e28b5b16ff9$var$selectBandSize,
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition4)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, lineSettings, bandSize, _ref)=>{
    var chartData = _ref.chartData, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    if (lineSettings == null || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null || layout !== 'horizontal' && layout !== 'vertical') return undefined;
    var dataKey = lineSettings.dataKey, data = lineSettings.data;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $lluj3.computeLinePoints)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataKey: dataKey,
        bandSize: bandSize,
        displayedData: displayedData
    });
});

});

parcelRegister("ckb0X", function(module, exports) {

$parcel$export(module.exports, "SetLegendPayload", () => $8f8fe5838f5f31a4$export$34b61b169492c008);
$parcel$export(module.exports, "SetPolarLegendPayload", () => $8f8fe5838f5f31a4$export$eb937fedea4aab3a);

var $acw62 = parcelRequire("acw62");

var $3X9hg = parcelRequire("3X9hg");

var $jHn5r = parcelRequire("jHn5r");

var $bqlEl = parcelRequire("bqlEl");

var $sP5sX = parcelRequire("sP5sX");
function $8f8fe5838f5f31a4$export$34b61b169492c008(_ref) {
    var legendPayload = _ref.legendPayload;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var prevPayloadRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, $sP5sX.addLegendPayload)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $sP5sX.replaceLegendPayload)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $sP5sX.removeLegendPayload)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function $8f8fe5838f5f31a4$export$eb937fedea4aab3a(_ref2) {
    var legendPayload = _ref2.legendPayload;
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var layout = (0, $bqlEl.useAppSelector)((0, $jHn5r.selectChartLayout));
    var prevPayloadRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, $sP5sX.addLegendPayload)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, $sP5sX.replaceLegendPayload)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, $sP5sX.removeLegendPayload)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}

});

parcelRegister("eHwNv", function(module, exports) {

$parcel$export(module.exports, "useAnimationCallbacks", () => $ab3e85c2408be497$export$b3a23bf3cc62dcfa);
$parcel$export(module.exports, "AnimatedItems", () => $ab3e85c2408be497$export$832e542ad7c5d3c4);

var $acw62 = parcelRequire("acw62");

var $62gKq = parcelRequire("62gKq");

var $9NuBN = parcelRequire("9NuBN");

var $dujP6 = parcelRequire("dujP6");

var $cdyCS = parcelRequire("cdyCS");
function $ab3e85c2408be497$var$_slicedToArray(r, e) {
    return $ab3e85c2408be497$var$_arrayWithHoles(r) || $ab3e85c2408be497$var$_iterableToArrayLimit(r, e) || $ab3e85c2408be497$var$_unsupportedIterableToArray(r, e) || $ab3e85c2408be497$var$_nonIterableRest();
}
function $ab3e85c2408be497$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ab3e85c2408be497$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ab3e85c2408be497$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ab3e85c2408be497$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ab3e85c2408be497$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $ab3e85c2408be497$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ab3e85c2408be497$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $ab3e85c2408be497$export$b3a23bf3cc62dcfa(onAnimationStart, onAnimationEnd) {
    var _useState = (0, $acw62.useState)(false), _useState2 = $ab3e85c2408be497$var$_slicedToArray(_useState, 2), isAnimating = _useState2[0], setIsAnimating = _useState2[1];
    var handleAnimationStart = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    var handleAnimationEnd = (0, $acw62.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    return {
        isAnimating: isAnimating,
        handleAnimationStart: handleAnimationStart,
        handleAnimationEnd: handleAnimationEnd
    };
}
function $ab3e85c2408be497$export$832e542ad7c5d3c4(props) {
    var _animationStartItems$;
    var animationInput = props.animationInput, animationIdPrefix = props.animationIdPrefix, items = props.items, previousItemsRef = props.previousItemsRef, isAnimationActive = props.isAnimationActive, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, animationInterpolateFn = props.animationInterpolateFn, animationMatchBy = props.animationMatchBy, shouldUpdatePreviousRef = props.shouldUpdatePreviousRef, children = props.children, layout = props.layout;
    var animationId = (0, $9NuBN.useAnimationId)(animationInput, animationIdPrefix);
    var animationStartItems = (0, $cdyCS.useAnimationStartSnapshot)(animationId, previousItemsRef);
    var rawPrevItems = (_animationStartItems$ = animationStartItems.startValue) !== null && _animationStartItems$ !== void 0 ? _animationStartItems$ : null;
    var animationItems = (0, $dujP6.matchAnimationItems)(rawPrevItems, items, animationMatchBy !== null && animationMatchBy !== void 0 ? animationMatchBy : (0, $dujP6.matchByIndex));
    return /*#__PURE__*/ $acw62.createElement((0, $62gKq.JavascriptAnimate), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: onAnimationEnd,
        onAnimationStart: onAnimationStart,
        key: animationId
    }, (animationElapsedTime)=>{
        var isEntrance = rawPrevItems == null;
        var stepData = items == null ? items : animationInterpolateFn(animationItems, animationElapsedTime, layout);
        var canUpdate = shouldUpdatePreviousRef ? shouldUpdatePreviousRef(animationElapsedTime) : animationElapsedTime > 0;
        animationStartItems.syncStepValue(stepData, animationElapsedTime, canUpdate);
        if (stepData == null) return null;
        return children(stepData, animationElapsedTime, isEntrance);
    });
}

});
parcelRegister("dujP6", function(module, exports) {

$parcel$export(module.exports, "matchByIndex", () => $9d1d742e915c37df$export$ab9105e4a084a44a);
$parcel$export(module.exports, "matchAppend", () => $9d1d742e915c37df$export$4b464c12f7151efc);
$parcel$export(module.exports, "matchAnimationItems", () => $9d1d742e915c37df$export$9c7dd57d6f54836f);

var $hBeJX = parcelRequire("hBeJX");
function $9d1d742e915c37df$var$_slicedToArray(r, e) {
    return $9d1d742e915c37df$var$_arrayWithHoles(r) || $9d1d742e915c37df$var$_iterableToArrayLimit(r, e) || $9d1d742e915c37df$var$_unsupportedIterableToArray(r, e) || $9d1d742e915c37df$var$_nonIterableRest();
}
function $9d1d742e915c37df$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9d1d742e915c37df$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9d1d742e915c37df$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9d1d742e915c37df$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9d1d742e915c37df$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9d1d742e915c37df$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9d1d742e915c37df$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $9d1d742e915c37df$export$ab9105e4a084a44a = 'index';
var $9d1d742e915c37df$export$4b464c12f7151efc = 'append';
function $9d1d742e915c37df$export$791aec617d538c24(dataKey) {
    return (item)=>{
        if (item.payload == null || typeof item.payload !== 'object') return null;
        var value = (0, $hBeJX.getValueByDataKey)(item.payload, dataKey);
        if (value == null) return null;
        if (typeof value === 'string' || typeof value === 'number') return value;
        return JSON.stringify(value);
    };
}
function $9d1d742e915c37df$var$tagAlignedItems(alignedPrevItems, nextItems) {
    var removedPrevItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var tagged = [];
    /*
   * We put removed points at the start because we assume that a typical chart animates right-to-left
   * and the removed points will disappear from the left edge and outside the plot area.
   * If you chart behaves differently you may want to customize your matching function.
   */ for (var prev of removedPrevItems)tagged.push({
        status: 'removed',
        prev: prev
    });
    for(var i = 0; i < nextItems.length; i++){
        // This function intentionally pairs by array index. The strategy-specific functions above are
        // responsible for producing an alignedPrevItems array whose indices already correspond to nextItems.
        var _prev = alignedPrevItems[i];
        var next = nextItems[i];
        if (_prev != null) tagged.push({
            status: 'matched',
            prev: _prev,
            next: next
        });
        else tagged.push({
            status: 'added',
            next: next
        });
    }
    return tagged;
}
function $9d1d742e915c37df$var$matchByIndexImpl(prevItems, nextItems) {
    var factor = prevItems.length / nextItems.length;
    var alignedPrevItems = nextItems.map((_, i)=>prevItems[Math.floor(i * factor)]);
    return $9d1d742e915c37df$var$tagAlignedItems(alignedPrevItems, nextItems);
}
function $9d1d742e915c37df$var$matchAppendImpl(prevItems, nextItems) {
    var alignedPrevItems = nextItems.map((_, i)=>prevItems[i]);
    return $9d1d742e915c37df$var$tagAlignedItems(alignedPrevItems, nextItems);
}
function $9d1d742e915c37df$var$buildPrevKeyMap(prevItems, matchBy) {
    var prevMap = new Map();
    for(var i = 0; i < prevItems.length; i++){
        var _item = prevItems[i];
        if (_item == null) continue;
        var key = matchBy(_item, i);
        if (key != null && !prevMap.has(key)) prevMap.set(key, _item);
    }
    return prevMap;
}
/**
 * Match previous items to next items by key, and include removed items explicitly.
 *
 * @internal
 */ function $9d1d742e915c37df$var$matchByKey(prevItems, nextItems, matchBy) {
    var prevMap = $9d1d742e915c37df$var$buildPrevKeyMap(prevItems, matchBy);
    // Track which prev keys were matched
    var matchedKeys = new Set();
    var alignedPrevItems = nextItems.map((next, i)=>{
        var key = matchBy(next, i);
        if (key != null) {
            var prev = prevMap.get(key);
            if (prev !== undefined) {
                matchedKeys.add(key);
                return prev;
            }
        }
        return undefined;
    });
    // Removed = prev items whose keys were not matched to any next item
    var removedPrevItems = [];
    for (var _ref3 of prevMap){
        var _ref2 = $9d1d742e915c37df$var$_slicedToArray(_ref3, 2);
        var key = _ref2[0];
        var _item2 = _ref2[1];
        if (!matchedKeys.has(key)) removedPrevItems.push(_item2);
    }
    return $9d1d742e915c37df$var$tagAlignedItems(alignedPrevItems, nextItems, removedPrevItems);
}
function $9d1d742e915c37df$export$9c7dd57d6f54836f(prevItems, nextItems, matchBy) {
    if (nextItems == null) return null;
    if (prevItems == null) return nextItems.map((next)=>({
            status: 'added',
            next: next
        }));
    if (matchBy === $9d1d742e915c37df$export$ab9105e4a084a44a) return $9d1d742e915c37df$var$matchByIndexImpl(prevItems, nextItems);
    if (matchBy === $9d1d742e915c37df$export$4b464c12f7151efc) return $9d1d742e915c37df$var$matchAppendImpl(prevItems, nextItems);
    return $9d1d742e915c37df$var$matchByKey(prevItems, nextItems, matchBy);
}

});

parcelRegister("cdyCS", function(module, exports) {

$parcel$export(module.exports, "useAnimationStartSnapshot", () => $8e518ef24f977523$export$f8367c7ba0b70deb);

var $acw62 = parcelRequire("acw62");
function $8e518ef24f977523$export$f8367c7ba0b70deb(animationInput, previousValueRef) {
    /*
   * Stores the identity of the animation cycle we are currently serving.
   * As soon as this changes, we know we need a brand new frozen snapshot.
   */ var previousAnimationInputRef = (0, $acw62.useRef)(animationInput);
    /*
   * Frozen start-of-cycle value used for interpolation.
   * This is the value callers should match against for the whole duration of the
   * current animation, even if the live ref is updated many times afterward.
   */ var startValueRef = (0, $acw62.useRef)(previousValueRef.current);
    /*
   * Prevents us from writing back into the live ref until the new animation has
   * actually rendered its own animationElapsedTime=0 frame. This avoids "pre-start" renders from
   * accidentally rebasing the next animation onto already-shifted geometry.
   */ var isReadyToCommitRef = (0, $acw62.useRef)(true);
    if (previousAnimationInputRef.current !== animationInput) {
        // New animation cycle: capture exactly one frozen starting snapshot.
        previousAnimationInputRef.current = animationInput;
        startValueRef.current = previousValueRef.current;
        // Writes stay blocked until the new cycle acknowledges its animationElapsedTime=0 frame.
        isReadyToCommitRef.current = false;
    }
    var syncStepValue = (0, $acw62.useCallback)(function(stepValue, animationElapsedTime) {
        var canCommit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        if (animationElapsedTime === 0) {
            /*
       * animationElapsedTime=0 is the handshake that says: "the new animation has now rendered its
       * own starting frame". We do not write anything yet; we only allow later
       * in-flight frames to be committed safely.
       */ isReadyToCommitRef.current = true;
            return;
        }
        if (animationElapsedTime === 1) // Keep the frozen snapshot aligned with the fully completed geometry.
        startValueRef.current = stepValue;
        if (animationElapsedTime > 0 && isReadyToCommitRef.current && canCommit) /*
       * Commit the latest visible frame so a future interruption can resume from
       * exactly what the user saw on screen most recently.
       */ // eslint-disable-next-line no-param-reassign
        previousValueRef.current = stepValue;
    }, [
        previousValueRef
    ]);
    return {
        startValue: startValueRef.current,
        syncStepValue: syncStepValue
    };
}

});


parcelRegister("aPPc1", function(module, exports) {

$parcel$export(module.exports, "SetCartesianGraphicalItem", () => $7e3660a50bf15c81$export$b600bf9c1966a9c2);
$parcel$export(module.exports, "SetPolarGraphicalItem", () => $7e3660a50bf15c81$export$8d7124402ca6b71c);

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $a0t9F = parcelRequire("a0t9F");
var $7e3660a50bf15c81$var$SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var prevPropsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $a0t9F.addCartesianGraphicalItem)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $a0t9F.replaceCartesianGraphicalItem)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $a0t9F.removeCartesianGraphicalItem)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $7e3660a50bf15c81$export$b600bf9c1966a9c2 = /*#__PURE__*/ (0, $acw62.memo)($7e3660a50bf15c81$var$SetCartesianGraphicalItemImpl);
var $7e3660a50bf15c81$var$SetPolarGraphicalItemImpl = (props)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    var prevPropsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, $a0t9F.addPolarGraphicalItem)(props));
        else if (prevPropsRef.current !== props) dispatch((0, $a0t9F.replacePolarGraphicalItem)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, $a0t9F.removePolarGraphicalItem)(prevPropsRef.current));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var $7e3660a50bf15c81$export$8d7124402ca6b71c = /*#__PURE__*/ (0, $acw62.memo)($7e3660a50bf15c81$var$SetPolarGraphicalItemImpl);

});

parcelRegister("lT2y6", function(module, exports) {

$parcel$export(module.exports, "getRadiusAndStrokeWidthFromDot", () => $fef0b63aa3904588$export$af45be059e20a9dd);

var $4M6vj = parcelRequire("4M6vj");
function $fef0b63aa3904588$export$af45be059e20a9dd(dot) {
    var props = (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(dot);
    var defaultR = 3;
    var defaultStrokeWidth = 2;
    if (props != null) {
        var r = props.r, strokeWidth = props.strokeWidth;
        var realR = Number(r);
        var realStrokeWidth = Number(strokeWidth);
        if (Number.isNaN(realR) || realR < 0) realR = defaultR;
        if (Number.isNaN(realStrokeWidth) || realStrokeWidth < 0) realStrokeWidth = defaultStrokeWidth;
        return {
            r: realR,
            strokeWidth: realStrokeWidth
        };
    }
    return {
        r: defaultR,
        strokeWidth: defaultStrokeWidth
    };
}

});

parcelRegister("63Kel", function(module, exports) {

$parcel$export(module.exports, "Shape", () => $4696e249b64cd95e$export$6428a7f2611ef1fa);

var $acw62 = parcelRequire("acw62");

var $lIF05 = parcelRequire("lIF05");
function $4696e249b64cd95e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4696e249b64cd95e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4696e249b64cd95e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4696e249b64cd95e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4696e249b64cd95e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4696e249b64cd95e$var$_defineProperty(e, r, t) {
    return (r = $4696e249b64cd95e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4696e249b64cd95e$var$_toPropertyKey(t) {
    var i = $4696e249b64cd95e$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4696e249b64cd95e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * The concrete default shape is supplied by the caller so this helper does not
 * import unrelated shapes and accidentally couple bundles together.
 */ function $4696e249b64cd95e$var$mergeShapeProps(option, props) {
    return $4696e249b64cd95e$var$_objectSpread($4696e249b64cd95e$var$_objectSpread({}, props), option);
}
function $4696e249b64cd95e$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) return option.props;
    return option;
}
function $4696e249b64cd95e$var$renderWithShapeElement(option, props) {
    return /*#__PURE__*/ (0, $acw62.cloneElement)(option, $4696e249b64cd95e$var$mergeShapeProps($4696e249b64cd95e$export$33c4f706a443da24(option), props));
}
function $4696e249b64cd95e$var$getShapeIndex(shapeProps) {
    if (!('index' in shapeProps)) return undefined;
    var index = shapeProps.index;
    return typeof index === 'number' || typeof index === 'string' ? index : undefined;
}
function $4696e249b64cd95e$var$isActiveShape(shapeProps) {
    return 'isActive' in shapeProps && shapeProps.isActive === true;
}
function $4696e249b64cd95e$export$6428a7f2611ef1fa(_ref) {
    var option = _ref.option, DefaultShape = _ref.DefaultShape, shapeProps = _ref.shapeProps, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? 'recharts-active-shape' : _ref$activeClassName, _ref$inActiveClassNam = _ref.inActiveClassName, inActiveClassName = _ref$inActiveClassNam === void 0 ? 'recharts-shape' : _ref$inActiveClassNam;
    var index = $4696e249b64cd95e$var$getShapeIndex(shapeProps);
    var shape;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(option)) shape = $4696e249b64cd95e$var$renderWithShapeElement(option, shapeProps);
    else if (option === DefaultShape) shape = /*#__PURE__*/ $acw62.createElement(DefaultShape, shapeProps);
    else if (typeof option === 'function') shape = option(shapeProps, index);
    else if (typeof option === 'object') shape = /*#__PURE__*/ $acw62.createElement(DefaultShape, $4696e249b64cd95e$var$mergeShapeProps(option, shapeProps));
    else shape = /*#__PURE__*/ $acw62.createElement(DefaultShape, shapeProps);
    if ($4696e249b64cd95e$var$isActiveShape(shapeProps)) return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: activeClassName
    }, shape);
    return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: inActiveClassName
    }, shape);
}

});


parcelRegister("2NSFW", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $4e72bcaf1a93f559$export$2dc68d50d56fbbd);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1E2Ix = parcelRequire("1E2Ix");
var $7X4mk = parcelRequire("7X4mk");

var $f6Tww = parcelRequire("f6Tww");
const $4e72bcaf1a93f559$export$2dc68d50d56fbbd = ({ items: items })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1E2Ix.default), {
        "aria-label": "breadcrumb",
        children: items.map((item, index)=>{
            if (!item.to) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                sx: {
                    color: 'text.primary'
                },
                children: item.label
            }, index);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.Link), {
                underline: "hover",
                color: "inherit",
                to: item.to,
                children: item.label
            }, index);
        })
    });
};

});
parcelRegister("1E2Ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $132ba27a5c58a248$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");



var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $7X4mk = parcelRequire("7X4mk");

var $dvibx = parcelRequire("dvibx");

var $keSbo = parcelRequire("keSbo");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $132ba27a5c58a248$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $keSbo.getBreadcrumbsUtilityClass), classes);
};
const $132ba27a5c58a248$var$BreadcrumbsRoot = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $keSbo.default).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $132ba27a5c58a248$var$BreadcrumbsOl = (0, $1Ikg4.default)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol'
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $132ba27a5c58a248$var$BreadcrumbsSeparator = (0, $1Ikg4.default)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator'
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $132ba27a5c58a248$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $ayMG0.jsx)($132ba27a5c58a248$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $132ba27a5c58a248$var$Breadcrumbs = /*#__PURE__*/ $acw62.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/', ...other } = props;
    const [expanded, setExpanded] = $acw62.useState(false);
    const ownerState = {
        ...props,
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    };
    const classes = $132ba27a5c58a248$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $eD6Co.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $acw62.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dvibx.default), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $acw62.Children.toArray(children).filter((child)=>{
        return /*#__PURE__*/ $acw62.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $ayMG0.jsx)($132ba27a5c58a248$var$BreadcrumbsRoot, {
        ref: ref,
        component: component,
        color: "textSecondary",
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($132ba27a5c58a248$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $132ba27a5c58a248$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    });
});
var $132ba27a5c58a248$export$2e2bcd8739ae039 = $132ba27a5c58a248$var$Breadcrumbs;

});
parcelRegister("dvibx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4c46c578340d3c$export$2e2bcd8739ae039);
parcelRequire("acw62");


var $aSEG4 = parcelRequire("aSEG4");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $lStv4 = parcelRequire("lStv4");

var $2TZUE = parcelRequire("2TZUE");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9d4c46c578340d3c$var$BreadcrumbCollapsedButton = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiBreadcrumbCollapsed'
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`,
        ...theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[100],
            color: theme.palette.grey[700]
        } : {
            backgroundColor: theme.palette.grey[700],
            color: theme.palette.grey[100]
        },
        borderRadius: 2,
        '&:hover, &:focus': {
            ...theme.palette.mode === 'light' ? {
                backgroundColor: theme.palette.grey[200]
            } : {
                backgroundColor: theme.palette.grey[600]
            }
        },
        '&:active': {
            boxShadow: theme.shadows[0],
            ...theme.palette.mode === 'light' ? {
                backgroundColor: (0, $aSEG4.emphasize)(theme.palette.grey[200], 0.12)
            } : {
                backgroundColor: (0, $aSEG4.emphasize)(theme.palette.grey[600], 0.12)
            }
        }
    })));
const $9d4c46c578340d3c$var$BreadcrumbCollapsedIcon = (0, $1Ikg4.default)((0, $lStv4.default))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $9d4c46c578340d3c$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, ...otherProps } = props;
    const ownerState = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9d4c46c578340d3c$var$BreadcrumbCollapsedButton, {
            focusRipple: true,
            ...otherProps,
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9d4c46c578340d3c$var$BreadcrumbCollapsedIcon, {
                as: slots.CollapsedIcon,
                ownerState: ownerState,
                ...slotProps.collapsedIcon
            })
        })
    });
}
var $9d4c46c578340d3c$export$2e2bcd8739ae039 = $9d4c46c578340d3c$var$BreadcrumbCollapsed;

});
parcelRegister("lStv4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed5863cf1f56120$export$2e2bcd8739ae039);
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $fed5863cf1f56120$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

});


parcelRegister("keSbo", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbsUtilityClass", () => $ebbf2508ce61eddf$export$17261110b18c8084);
$parcel$export(module.exports, "default", () => $ebbf2508ce61eddf$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $ebbf2508ce61eddf$export$17261110b18c8084(slot) {
    return (0, $4Cod0.default)('MuiBreadcrumbs', slot);
}
const $ebbf2508ce61eddf$var$breadcrumbsClasses = (0, $beCSm.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $ebbf2508ce61eddf$export$2e2bcd8739ae039 = $ebbf2508ce61eddf$var$breadcrumbsClasses;

});


parcelRegister("f6Tww", function(module, exports) {

$parcel$export(module.exports, "LinkComponent", () => $b449b86935bae46f$export$8c0773eab230d49e);
$parcel$export(module.exports, "Link", () => $b449b86935bae46f$export$a6c7ac8248d6e38a);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $fNkZ4 = parcelRequire("fNkZ4");
const $b449b86935bae46f$export$8c0773eab230d49e = /*#__PURE__*/ (0, $acw62.forwardRef)(({ href: href, ...props }, ref)=>// eslint-disable-next-line react/prop-types
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
        ...props,
        to: href || props.to,
        ref: ref
    }));
$b449b86935bae46f$export$8c0773eab230d49e.displayName = 'LinkComponent';
const $b449b86935bae46f$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $acw62.forwardRef)(function Link(props, ref) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNkZ4.default), {
        ...props,
        component: (0, $lzNIT.Link),
        ref: ref
    });
});

});
parcelRegister("lzNIT", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $040dbb9c344a508d$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $040dbb9c344a508d$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("aphAM")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("aphAM")).useNavigate);
/**
 * React Router DOM v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $2vsP7 = parcelRequire("2vsP7");
var $aphAM = parcelRequire("aphAM");

var $2vsP7 = parcelRequire("2vsP7");
function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $040dbb9c344a508d$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $040dbb9c344a508d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $2vsP7.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $aphAM.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $2vsP7.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $aphAM.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2vsP7.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $aphAM.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref4, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2vsP7.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        }
    } // Rendered into <a href> for relative URLs
    let href = (0, $aphAM.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref5, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $aphAM.useLocation)();
    let routerState = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
        ref: ref
    }));
});
const $040dbb9c344a508d$var$FormImpl = /*#__PURE__*/ $acw62.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref6, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterContext));
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $aphAM.UNSAFE_DataRouterStateContext));
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $aphAM.useNavigate)();
    let location = (0, $aphAM.useLocation)();
    let path = (0, $aphAM.useResolvedPath)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2vsP7.createPath)(location) === (0, $2vsP7.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $aphAM.useLocation)();
    let searchParams = $acw62.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $aphAM.useNavigate)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    return $040dbb9c344a508d$var$useSubmitImpl();
}
function $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $040dbb9c344a508d$export$89a6bd6db0d97c56();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $aphAM.UNSAFE_NavigationContext));
    let routeContext = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !routeContext && (0, $2vsP7.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $aphAM.useResolvedPath)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $aphAM.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $2vsP7.createPath)(path);
}
function $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$FormImpl, $040dbb9c344a508d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $040dbb9c344a508d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let route = $acw62.useContext((0, $aphAM.UNSAFE_RouteContext));
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $2vsP7.UNSAFE_invariant)(false);
    let [fetcherKey] = $acw62.useState(()=>String(++$040dbb9c344a508d$var$fetcherId));
    let [Form] = $acw62.useState(()=>{
        !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
        return $040dbb9c344a508d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $acw62.useState(()=>(href)=>{
            !router && (0, $2vsP7.UNSAFE_invariant)(false);
            !routeId && (0, $2vsP7.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $040dbb9c344a508d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $acw62.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $aphAM.useLocation)();
    let matches = (0, $aphAM.useMatches)();
    let navigation = (0, $aphAM.useNavigation)(); // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $aphAM.unstable_useBlocker)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});
parcelRegister("2vsP7", function(module, exports) {

$parcel$export(module.exports, "Action", () => $1d34d5c4a288b213$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $1d34d5c4a288b213$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "createPath", () => $1d34d5c4a288b213$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $1d34d5c4a288b213$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $1d34d5c4a288b213$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $1d34d5c4a288b213$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $1d34d5c4a288b213$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $1d34d5c4a288b213$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $1d34d5c4a288b213$export$b69e3301ce081aa3);
$parcel$export(module.exports, "joinPaths", () => $1d34d5c4a288b213$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $1d34d5c4a288b213$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", () => $1d34d5c4a288b213$export$90ba53ce1c7fdff2);
$parcel$export(module.exports, "resolveTo", () => $1d34d5c4a288b213$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $1d34d5c4a288b213$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "ErrorResponse", () => $1d34d5c4a288b213$export$acf1a680051f5031);
$parcel$export(module.exports, "isRouteErrorResponse", () => $1d34d5c4a288b213$export$972111febbeef05b);
$parcel$export(module.exports, "createRouter", () => $1d34d5c4a288b213$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, detectErrorBoundary, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                hasErrorBoundary: detectErrorBoundary(route),
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, {
                id: id,
                hasErrorBoundary: detectErrorBoundary(route),
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, detectErrorBoundary, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $1d34d5c4a288b213$var$safelyDecodeURI(pathname));
    return matches;
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:\w+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Missing \":" + key + "\" param");
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $1d34d5c4a288b213$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $1d34d5c4a288b213$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $1d34d5c4a288b213$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, "The value for the URL param \"" + paramName + "\" will not be decoded because" + (" the string \"" + value + "\" is a malformed URL segment. This is probably") + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $1d34d5c4a288b213$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $1d34d5c4a288b213$var$isServer = !$1d34d5c4a288b213$var$isBrowser;
const $1d34d5c4a288b213$var$defaultDetectErrorBoundary = (route)=>Boolean(route.hasErrorBoundary); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let detectErrorBoundary = init.detectErrorBoundary || $1d34d5c4a288b213$var$defaultDetectErrorBoundary; // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, detectErrorBoundary, undefined, manifest);
    let inFlightDataRoutes; // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_normalizeFormMethod: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(to, future, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $1d34d5c4a288b213$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($1d34d5c4a288b213$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $1d34d5c4a288b213$var$normalizeNavigateOptions(href, future, opts, true);
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $1d34d5c4a288b213$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, detectErrorBoundary, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $1d34d5c4a288b213$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, init.basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($1d34d5c4a288b213$var$_extends({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $1d34d5c4a288b213$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, detectErrorBoundary, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, $1d34d5c4a288b213$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $1d34d5c4a288b213$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, init.basename || "/") == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, router.basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, manifest, detectErrorBoundary, router.basename);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$1d34d5c4a288b213$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let detectErrorBoundary = (opts == null ? void 0 : opts.detectErrorBoundary) || $1d34d5c4a288b213$var$defaultDetectErrorBoundary;
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, detectErrorBoundary, undefined, manifest);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error && !$1d34d5c4a288b213$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(to, future, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: future.v7_normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $1d34d5c4a288b213$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    let searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push($1d34d5c4a288b213$var$_extends({
                key: key
            }, f, {
                matches: null,
                match: null
            }));
            return;
        }
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push($1d34d5c4a288b213$var$_extends({
                key: key,
                matches: fetcherMatches,
                match: fetcherMatch
            }, f));
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (shouldRevalidate) revalidatingFetchers.push($1d34d5c4a288b213$var$_extends({
            key: key,
            matches: fetcherMatches,
            match: fetcherMatch
        }, f));
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, detectErrorBoundary, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to detectErrorBoundary
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided
        // `detectErrorBoundary` function to set the `hasErrorBoundary` route
        // property since the logic will differ between frameworks.
        hasErrorBoundary: detectErrorBoundary($1d34d5c4a288b213$var$_extends({}, routeToUpdate)),
        lazy: undefined
    });
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: request.method,
                    pathname: new URL(request.url).pathname,
                    routeId: match.route.id
                });
                else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else {
            $1d34d5c4a288b213$export$3e9cee6b33872309(handler, "Could not find the " + type + " to run on the \"" + match.route.id + "\" route");
            result = await runHandler(handler);
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $1d34d5c4a288b213$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $1d34d5c4a288b213$export$3e9cee6b33872309($1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $1d34d5c4a288b213$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $1d34d5c4a288b213$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $1d34d5c4a288b213$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return result;
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $1d34d5c4a288b213$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

});

parcelRegister("aphAM", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $7939e29d663dd3ed$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $7939e29d663dd3ed$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $7939e29d663dd3ed$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $7939e29d663dd3ed$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $7939e29d663dd3ed$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $7939e29d663dd3ed$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $7939e29d663dd3ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $7939e29d663dd3ed$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $7939e29d663dd3ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useRoutes", () => $7939e29d663dd3ed$export$5d3fca4a98652595);
$parcel$export(module.exports, "useNavigation", () => $7939e29d663dd3ed$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $7939e29d663dd3ed$export$2378eb7f5ff86053);
$parcel$export(module.exports, "unstable_useBlocker", () => $7939e29d663dd3ed$export$2af03a1de5c0910);
$parcel$export(module.exports, "Router", () => $7939e29d663dd3ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $7939e29d663dd3ed$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Outlet", () => $7939e29d663dd3ed$export$910ae8079b2c2852);
$parcel$export(module.exports, "UNSAFE_detectErrorBoundary", () => $7939e29d663dd3ed$export$48907b48b599f040);
/**
 * React Router v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2vsP7 = parcelRequire("2vsP7");

var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $7939e29d663dd3ed$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $7939e29d663dd3ed$var$is = typeof Object.is === "function" ? Object.is : $7939e29d663dd3ed$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $7939e29d663dd3ed$var$useState, useEffect: $7939e29d663dd3ed$var$useEffect, useLayoutEffect: $7939e29d663dd3ed$var$useLayoutEffect, useDebugValue: $7939e29d663dd3ed$var$useDebugValue } = $acw62;
let $7939e29d663dd3ed$var$didWarnOld18Alpha = false;
let $7939e29d663dd3ed$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $7939e29d663dd3ed$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $7939e29d663dd3ed$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $7939e29d663dd3ed$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $7939e29d663dd3ed$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($7939e29d663dd3ed$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $7939e29d663dd3ed$var$useDebugValue(value);
    return value;
}
function $7939e29d663dd3ed$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$7939e29d663dd3ed$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $7939e29d663dd3ed$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $7939e29d663dd3ed$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $7939e29d663dd3ed$var$isServerEnvironment = !$7939e29d663dd3ed$var$canUseDOM;
const $7939e29d663dd3ed$var$shim = $7939e29d663dd3ed$var$isServerEnvironment ? $7939e29d663dd3ed$var$useSyncExternalStore$1 : $7939e29d663dd3ed$var$useSyncExternalStore$2;
const $7939e29d663dd3ed$var$useSyncExternalStore = "useSyncExternalStore" in $acw62 ? ((module)=>module.useSyncExternalStore)($acw62) : $7939e29d663dd3ed$var$shim;
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: []
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $2vsP7.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2vsP7.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2vsP7.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $acw62.useMemo(()=>(0, $2vsP7.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let dataRouterStateContext = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2vsP7.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2vsP7.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2vsP7.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2vsP7.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2vsP7.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $2vsP7.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2vsP7.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) {
            if (match.route.ErrorBoundary) errorElement = /*#__PURE__*/ $acw62.createElement(match.route.ErrorBoundary, null);
            else if (match.route.errorElement) errorElement = match.route.errorElement;
            else errorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children = outlet;
            if (error) children = errorElement;
            else if (match.route.Component) children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($7939e29d663dd3ed$var$DataRouterHook || ($7939e29d663dd3ed$var$DataRouterHook = {}));
var $7939e29d663dd3ed$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($7939e29d663dd3ed$var$DataRouterStateHook || ($7939e29d663dd3ed$var$DataRouterStateHook = {}));
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $2vsP7.UNSAFE_invariant)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $2vsP7.UNSAFE_invariant)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return route;
}
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2vsP7.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $2vsP7.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $acw62.useState(()=>String(++$7939e29d663dd3ed$var$blockerId));
    let blockerFunction = $acw62.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $acw62.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    let getState = $acw62.useCallback(()=>router.state, [
        router
    ]); // Sync router state to our component state to force re-renders
    let state = $7939e29d663dd3ed$var$useSyncExternalStore(router.subscribe, getState, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    getState);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2vsP7.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false);
    let dataRouterState = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    $acw62.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $2vsP7.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2vsP7.Action).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $2vsP7.UNSAFE_invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2vsP7.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $2vsP7.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $7939e29d663dd3ed$export$16da398f5434bdec(children);
    return $7939e29d663dd3ed$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($7939e29d663dd3ed$var$AwaitRenderStatus || ($7939e29d663dd3ed$var$AwaitRenderStatus = {}));
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $2vsP7.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $2vsP7.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $2vsP7.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$48907b48b599f040(route) {
    // there if you change this
    return Boolean(route.ErrorBoundary) || Boolean(route.errorElement);
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $2vsP7.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $2vsP7.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        detectErrorBoundary: $7939e29d663dd3ed$export$48907b48b599f040
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////

});


parcelRegister("fNkZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7fbb59cc24be7e9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $52FI1 = parcelRequire("52FI1");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $7X4mk = parcelRequire("7X4mk");

var $bHzsg = parcelRequire("bHzsg");

var $eR1of = parcelRequire("eR1of");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b7fbb59cc24be7e9$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $b7fbb59cc24be7e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $3AM7p.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bHzsg.getLinkUtilityClass), classes);
};
const $b7fbb59cc24be7e9$var$LinkRoot = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $3AM7p.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $bHzsg.default).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $b7fbb59cc24be7e9$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $b7Ol4.default)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $52FI1.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $52FI1.default)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $b7fbb59cc24be7e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b7fbb59cc24be7e9$var$LinkRoot, {
        color: color,
        className: (0, $9QePP.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$b7fbb59cc24be7e9$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$b7fbb59cc24be7e9$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $eR1of.default)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $b7fbb59cc24be7e9$export$2e2bcd8739ae039 = $b7fbb59cc24be7e9$var$Link;

});
parcelRegister("bHzsg", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", () => $884f3676036e9695$export$d6efab9620b78fec);
$parcel$export(module.exports, "default", () => $884f3676036e9695$export$2e2bcd8739ae039);

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $884f3676036e9695$export$d6efab9620b78fec(slot) {
    return (0, $4Cod0.default)('MuiLink', slot);
}
const $884f3676036e9695$var$linkClasses = (0, $beCSm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $884f3676036e9695$export$2e2bcd8739ae039 = $884f3676036e9695$var$linkClasses;

});

parcelRegister("eR1of", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad0717f3ca2b2499$export$2e2bcd8739ae039);

var $ii7BS = parcelRequire("ii7BS");

var $aSEG4 = parcelRequire("aSEG4");
const $ad0717f3ca2b2499$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $ii7BS.getPath)(theme, `palette.${transformedColor}.main`) || (0, $ii7BS.getPath)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $ii7BS.getPath)(theme, `palette.${transformedColor}.main`, false) || (0, $ii7BS.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $ii7BS.getPath)(theme, `palette.${transformedColor}.mainChannel`) || (0, $ii7BS.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $aSEG4.alpha)(color, 0.4);
};
var $ad0717f3ca2b2499$export$2e2bcd8739ae039 = $ad0717f3ca2b2499$var$getTextDecoration;

});




parcelRegister("8YLZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $689927f0df05e8fa$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $689927f0df05e8fa$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');

});

parcelRegister("1Qxqo", function(module, exports) {
module.exports = import("35NFB").then(()=>parcelRequire('gEuex'));

});

parcelRegister("kwTO3", function(module, exports) {

$parcel$export(module.exports, "ServiceAccessInput", () => $4f2cc805d03eb456$export$6aafc8dc190ad73f);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $gpaJb = parcelRequire("gpaJb");
const $4f2cc805d03eb456$export$6aafc8dc190ad73f = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "expertService.password",
            defaultMessage: "P\u0159\xedstup do servisu"
        }),
        inputVariableId: "SERVICE_PASSWORD",
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "expertService.password.label",
            defaultMessage: "Heslo"
        }),
        fullWidth: true
    });
};

});
parcelRegister("gpaJb", function(module, exports) {

$parcel$export(module.exports, "InputBox", () => $45a13af6f33cd49c$export$5ac7b85d728a3568);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $i51gj = parcelRequire("i51gj");

var $f1q41 = parcelRequire("f1q41");

var $kZugz = parcelRequire("kZugz");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $9iEAl = parcelRequire("9iEAl");
const $45a13af6f33cd49c$export$5ac7b85d728a3568 = ({ inputVariableId: inputVariableId, placeholder: placeholder, label: label, schema: schema, inputWidth: inputWidth = 170, type: type, ...props })=>{
    const storeValue = (0, $2lSXC.useSelector)((s)=>inputVariableId ? (0, (/*@__PURE__*/$parcel$interopDefault($i51gj)))(s.variables, inputVariableId) : undefined);
    const dispatch = (0, $2lSXC.useDispatch)();
    const [value, setValue] = (0, $acw62.useState)(storeValue || '');
    const [error, setError] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setValue(storeValue);
        setError(undefined);
    }, [
        storeValue
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!schema) {
            setError(undefined);
            return;
        }
        const parsed = schema.safeParse(value);
        if (!parsed.success) {
            setError((0, $f1q41.first)(parsed.error.issues));
            return;
        }
        setValue(parsed.data);
        setError(undefined);
    }, [
        value,
        schema
    ]);
    const submit = ()=>{
        if (schema && error) return;
        dispatch((0, $1Jwr0.variablesChange)({
            [inputVariableId]: value
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
            value: value,
            onChange: (e)=>{
                setValue(e.target.value);
            },
            onKeyPress: (e)=>{
                if (e.key === 'Enter') submit();
            },
            onBlur: submit,
            sx: {
                ml: 'auto',
                width: inputWidth
            },
            placeholder: placeholder,
            label: label,
            type: type,
            size: "small",
            error: Boolean(error),
            helperText: error?.message
        }),
        ...props
    });
};

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});
parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});




parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});


parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});


parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});





parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $9dr3u(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});





parcelRegister("48lZm", function(module, exports) {
module.exports = import("efKUa").then(()=>parcelRequire('gfCpL'));

});

parcelRegister("eJaQo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab8dae130526a9ed$export$2e2bcd8739ae039);

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ab8dae130526a9ed$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("GJmNl", function(module, exports) {
module.exports = import("fXZli").then(()=>parcelRequire('7gG9C'));

});

parcelRegister("iUHwh", function(module, exports) {
module.exports = import("fKl50").then(()=>parcelRequire('cfhBn'));

});

parcelRegister("l2unc", function(module, exports) {
module.exports = import("9Thqk").then(()=>parcelRequire('hleKd'));

});


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");

var $jDfxe = parcelRequire("jDfxe");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $acw62 = parcelRequire("acw62");


var $dFNG2 = parcelRequire("dFNG2");

var $e7sAA = parcelRequire("e7sAA");

var $bXtHQ = parcelRequire("bXtHQ");
'use client';
function $90952e82d066041a$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $dFNG2.default)({
        props: props,
        name: name,
        defaultTheme: $e7sAA.default,
        themeId: (0, $bXtHQ.default)
    });
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $b713746033a911a9$var$_excluded = [
    "localeText"
];
const $b713746033a911a9$export$41298298dbe382b = /*#__PURE__*/ $acw62.createContext(null);
const $b713746033a911a9$export$544976378534cf9 = $b713746033a911a9$export$41298298dbe382b;
const $b713746033a911a9$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(inProps, $b713746033a911a9$var$_excluded);
    const { adapter: parentAdapter, localeText: parentLocaleText } = $acw62.useContext($b713746033a911a9$export$41298298dbe382b) ?? {
        utils: undefined,
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = $acw62.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = $acw62.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = $acw62.useMemo(()=>{
        return {
            utils: adapter,
            adapter: adapter,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b713746033a911a9$export$41298298dbe382b.Provider, {
        value: contextValue,
        children: children
    });
};



var $7S0ew = parcelRequire("7S0ew");

var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $4e48e89beadf9b6b$export$baf757aaf0c95c94(date, amount) {
    const timestamp = +(0, $9Jots.toDate)(date);
    return (0, $bXANJ.constructFrom)(date, timestamp + amount);
}
var // Fallback for modularized imports:
$4e48e89beadf9b6b$export$2e2bcd8739ae039 = $4e48e89beadf9b6b$export$baf757aaf0c95c94;


function $a0c5e89fec7150ea$export$3cb31b0df13be68(date, amount) {
    return (0, $4e48e89beadf9b6b$export$baf757aaf0c95c94)(date, amount * 1000);
}
var // Fallback for modularized imports:
$a0c5e89fec7150ea$export$2e2bcd8739ae039 = $a0c5e89fec7150ea$export$3cb31b0df13be68;



/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $e24aa25ccaa7cb1c$export$dfd9b671c89acc8e = 7;
const $e24aa25ccaa7cb1c$export$3913210603d8e9ae = 365.2425;
const $e24aa25ccaa7cb1c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $e24aa25ccaa7cb1c$export$4dec998e48f9c246 = -$e24aa25ccaa7cb1c$export$81caae6e1cc7a622;
const $e24aa25ccaa7cb1c$export$4fad13613e88edc8 = 604800000;
const $e24aa25ccaa7cb1c$export$b76b1809a2898f9a = 86400000;
const $e24aa25ccaa7cb1c$export$91246f0b9bd9beff = 60000;
const $e24aa25ccaa7cb1c$export$7f72910d6dfd237a = 3600000;
const $e24aa25ccaa7cb1c$export$397c2d5776aa9055 = 1000;
const $e24aa25ccaa7cb1c$export$3633035e63cee86a = 525600;
const $e24aa25ccaa7cb1c$export$ab7da2ccd1075c38 = 43200;
const $e24aa25ccaa7cb1c$export$2423174df8cd3cd2 = 1440;
const $e24aa25ccaa7cb1c$export$f2f5ae5a8e2d8f9f = 60;
const $e24aa25ccaa7cb1c$export$3c58128db900d44e = 3;
const $e24aa25ccaa7cb1c$export$80d7e435f744f319 = 12;
const $e24aa25ccaa7cb1c$export$4db7641526e3241f = 4;
const $e24aa25ccaa7cb1c$export$698aec755e92c695 = 3600;
const $e24aa25ccaa7cb1c$export$a77c1a7ebebe2a5a = 60;
const $e24aa25ccaa7cb1c$export$815a9362476d2fe3 = $e24aa25ccaa7cb1c$export$698aec755e92c695 * 24;
const $e24aa25ccaa7cb1c$export$34804a017b31e2fe = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * 7;
const $e24aa25ccaa7cb1c$export$7271e9e3478110d1 = $e24aa25ccaa7cb1c$export$815a9362476d2fe3 * $e24aa25ccaa7cb1c$export$3913210603d8e9ae;
const $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb = $e24aa25ccaa7cb1c$export$7271e9e3478110d1 / 12;
const $e24aa25ccaa7cb1c$export$be1dccf2de902d31 = $e24aa25ccaa7cb1c$export$8e6600bbdee7dabb * 3;


function $3652e7106c1f3d0e$export$2287e3d29250119e(date, amount) {
    return (0, $4e48e89beadf9b6b$export$baf757aaf0c95c94)(date, amount * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff));
}
var // Fallback for modularized imports:
$3652e7106c1f3d0e$export$2e2bcd8739ae039 = $3652e7106c1f3d0e$export$2287e3d29250119e;




function $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6(date, amount) {
    return (0, $4e48e89beadf9b6b$export$baf757aaf0c95c94)(date, amount * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a));
}
var // Fallback for modularized imports:
$ad7d7a6c940573d9$export$2e2bcd8739ae039 = $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6;



var $7S0ew = parcelRequire("7S0ew");
function $3506675759da9be2$export$ef501a2bb4f3ee6b(date, amount) {
    const days = amount * 7;
    return (0, $7S0ew.addDays)(date, days);
}
var // Fallback for modularized imports:
$3506675759da9be2$export$2e2bcd8739ae039 = $3506675759da9be2$export$ef501a2bb4f3ee6b;



var $5BFw5 = parcelRequire("5BFw5");

var $5BFw5 = parcelRequire("5BFw5");
function $dab9374b7fb99d73$export$3d83eec43f4ea476(date, amount) {
    return (0, $5BFw5.addMonths)(date, amount * 12);
}
var // Fallback for modularized imports:
$dab9374b7fb99d73$export$2e2bcd8739ae039 = $dab9374b7fb99d73$export$3d83eec43f4ea476;



var $2CcMD = parcelRequire("2CcMD");

var $9Jots = parcelRequire("9Jots");
let $6525066f50a2904f$var$defaultOptions = {};
function $6525066f50a2904f$export$430a3269e24b912e() {
    return $6525066f50a2904f$var$defaultOptions;
}
function $6525066f50a2904f$export$95365be1b0704abc(newOptions) {
    $6525066f50a2904f$var$defaultOptions = newOptions;
}


function $42ecbba5934145fb$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9Jots.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$42ecbba5934145fb$export$2e2bcd8739ae039 = $42ecbba5934145fb$export$ef8b6d9133084f4e;



var $9Jots = parcelRequire("9Jots");
function $9805f8396c527015$export$8b7aa55c66d5569e(date) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$9805f8396c527015$export$2e2bcd8739ae039 = $9805f8396c527015$export$8b7aa55c66d5569e;


const $e53a64e8b1fa0c80$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $e53a64e8b1fa0c80$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $e53a64e8b1fa0c80$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $82aa69c14702147f$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $6c77c8df84810c56$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $6c77c8df84810c56$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $6c77c8df84810c56$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $6c77c8df84810c56$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $6c77c8df84810c56$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $1fab2cf05b8cccda$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $1fab2cf05b8cccda$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$1fab2cf05b8cccda$var$formatRelativeLocale[token];


/* eslint-disable no-unused-vars */ /**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $b12404f6dcad3401$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $54b33a47c5274498$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $54b33a47c5274498$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $54b33a47c5274498$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $54b33a47c5274498$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $54b33a47c5274498$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $54b33a47c5274498$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $54b33a47c5274498$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $54b33a47c5274498$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $54b33a47c5274498$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $54b33a47c5274498$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $54b33a47c5274498$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $89a828c41b7e1bc3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $89a828c41b7e1bc3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $89a828c41b7e1bc3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $89a828c41b7e1bc3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $89a828c41b7e1bc3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern = /\d+/i;
const $6a38ab3f2b32c4bb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $6a38ab3f2b32c4bb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $6a38ab3f2b32c4bb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $6a38ab3f2b32c4bb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $6a38ab3f2b32c4bb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $6a38ab3f2b32c4bb$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $6a38ab3f2b32c4bb$var$matchOrdinalNumberPattern,
        parsePattern: $6a38ab3f2b32c4bb$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $6a38ab3f2b32c4bb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6a38ab3f2b32c4bb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $f45f4bcf38c4ce94$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $e53a64e8b1fa0c80$export$2c14ff85d6318973),
    formatLong: (0, $6c77c8df84810c56$export$cbf60ecb96cbb82f),
    formatRelative: (0, $1fab2cf05b8cccda$export$8fbbfd65594f46a0),
    localize: (0, $54b33a47c5274498$export$b3bd0bc58e36cd63),
    match: (0, $6a38ab3f2b32c4bb$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$f45f4bcf38c4ce94$export$2e2bcd8739ae039 = $f45f4bcf38c4ce94$export$137380d9ce54f7f;





var $g04kv = parcelRequire("g04kv");

var $9Jots = parcelRequire("9Jots");
function $39c386bf2b2d4be8$export$113002b5eff6e430(date) {
    const _date = (0, $9Jots.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


function $30481ff49751e85f$export$4a02e9c37dab4871(dateLeft, dateRight) {
    const startOfDayLeft = (0, $g04kv.startOfDay)(dateLeft);
    const startOfDayRight = (0, $g04kv.startOfDay)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / (0, $e24aa25ccaa7cb1c$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$30481ff49751e85f$export$2e2bcd8739ae039 = $30481ff49751e85f$export$4a02e9c37dab4871;



var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $acbc1d0003a51961$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $9Jots.toDate)(date);
    const _date = (0, $bXANJ.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$acbc1d0003a51961$export$2e2bcd8739ae039 = $acbc1d0003a51961$export$f91e89d3d0406102;



var $9Jots = parcelRequire("9Jots");
function $4312ea6469709b9b$export$d3b42cd8452deec(date) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = (0, $30481ff49751e85f$export$4a02e9c37dab4871)(_date, (0, $acbc1d0003a51961$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$4312ea6469709b9b$export$2e2bcd8739ae039 = $4312ea6469709b9b$export$d3b42cd8452deec;




var $9Jots = parcelRequire("9Jots");

function $a6b650558c0d274a$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9Jots.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$a6b650558c0d274a$export$2e2bcd8739ae039 = $a6b650558c0d274a$export$42c81a444fbfb5d4;


function $80ab7b76dc31fb87$export$6173213f95a4431e(date) {
    return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$80ab7b76dc31fb87$export$2e2bcd8739ae039 = $80ab7b76dc31fb87$export$6173213f95a4431e;



var $bXANJ = parcelRequire("bXANJ");


var $9Jots = parcelRequire("9Jots");
function $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc(date) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$a5b0ea7a35e081a3$export$2e2bcd8739ae039 = $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc;




var $bXANJ = parcelRequire("bXANJ");
function $00ea35cfe8164ea9$export$236bdfa374eb69a9(date) {
    const year = (0, $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $bXANJ.constructFrom)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$00ea35cfe8164ea9$export$2e2bcd8739ae039 = $00ea35cfe8164ea9$export$236bdfa374eb69a9;



var $9Jots = parcelRequire("9Jots");
function $7e3321a3fdd64965$export$7cabdc5698b63e2f(date) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = +(0, $80ab7b76dc31fb87$export$6173213f95a4431e)(_date) - +(0, $00ea35cfe8164ea9$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $e24aa25ccaa7cb1c$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$7e3321a3fdd64965$export$2e2bcd8739ae039 = $7e3321a3fdd64965$export$7cabdc5698b63e2f;






var $bXANJ = parcelRequire("bXANJ");

var $bXANJ = parcelRequire("bXANJ");


var $9Jots = parcelRequire("9Jots");

function $2a4c9a3ae7bb29a5$export$12d572480ceb6e58(date, options) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $bXANJ.constructFrom)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $bXANJ.constructFrom)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$2a4c9a3ae7bb29a5$export$2e2bcd8739ae039 = $2a4c9a3ae7bb29a5$export$12d572480ceb6e58;




function $ef995389f8e20dbc$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $2a4c9a3ae7bb29a5$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $bXANJ.constructFrom)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ef995389f8e20dbc$export$2e2bcd8739ae039 = $ef995389f8e20dbc$export$bb7b45bb8e74da0f;



var $9Jots = parcelRequire("9Jots");
function $ea960e7aff37061d$export$efe19b760242b2fc(date, options) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = +(0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(_date, options) - +(0, $ef995389f8e20dbc$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $e24aa25ccaa7cb1c$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$ea960e7aff37061d$export$2e2bcd8739ae039 = $ea960e7aff37061d$export$efe19b760242b2fc;



function $3f6840376f7c8255$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $aed2876e10bb3b8a$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $3f6840376f7c8255$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $2733e62ab452f32f$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $2733e62ab452f32f$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $2a4c9a3ae7bb29a5$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $a5b0ea7a35e081a3$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $ea960e7aff37061d$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $7e3321a3fdd64965$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $4312ea6469709b9b$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2733e62ab452f32f$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $aed2876e10bb3b8a$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2733e62ab452f32f$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2733e62ab452f32f$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $3f6840376f7c8255$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $2733e62ab452f32f$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $3f6840376f7c8255$export$c8306e720e213c0f)(minutes, 2);
}
function $2733e62ab452f32f$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $3f6840376f7c8255$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $2733e62ab452f32f$var$formatTimezone(offset, delimiter);
}
function $2733e62ab452f32f$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $3d9918f67aabe98a$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $3d9918f67aabe98a$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $3d9918f67aabe98a$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3d9918f67aabe98a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3d9918f67aabe98a$var$timeLongFormatter(timePattern, formatLong));
};
const $3d9918f67aabe98a$export$70cc8fd02856fd58 = {
    p: $3d9918f67aabe98a$var$timeLongFormatter,
    P: $3d9918f67aabe98a$var$dateTimeLongFormatter
};


const $8680c08594a744bc$var$dayOfYearTokenRE = /^D+$/;
const $8680c08594a744bc$var$weekYearTokenRE = /^Y+$/;
const $8680c08594a744bc$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $8680c08594a744bc$export$c6cc36aa33304772(token) {
    return $8680c08594a744bc$var$dayOfYearTokenRE.test(token);
}
function $8680c08594a744bc$export$c6b49d6dceb604a1(token) {
    return $8680c08594a744bc$var$weekYearTokenRE.test(token);
}
function $8680c08594a744bc$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $8680c08594a744bc$var$message(token, format, input);
    console.warn(_message);
    if ($8680c08594a744bc$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $8680c08594a744bc$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $ccbd6968dbb36c3b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$ccbd6968dbb36c3b$export$2e2bcd8739ae039 = $ccbd6968dbb36c3b$export$871608497c498473;



var $9Jots = parcelRequire("9Jots");
function $ae5dedc3e6bc7894$export$1ea939691cdc45b8(date) {
    if (!(0, $ccbd6968dbb36c3b$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $9Jots.toDate)(date);
    return !isNaN(Number(_date));
}
var // Fallback for modularized imports:
$ae5dedc3e6bc7894$export$2e2bcd8739ae039 = $ae5dedc3e6bc7894$export$1ea939691cdc45b8;



var $9Jots = parcelRequire("9Jots");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $4d82c4193dc87874$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $4d82c4193dc87874$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $4d82c4193dc87874$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $4d82c4193dc87874$var$doubleQuoteRegExp = /''/g;
const $4d82c4193dc87874$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4d82c4193dc87874$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $f45f4bcf38c4ce94$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $9Jots.toDate)(date);
    if (!(0, $ae5dedc3e6bc7894$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($4d82c4193dc87874$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $3d9918f67aabe98a$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4d82c4193dc87874$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $4d82c4193dc87874$var$cleanEscapedString(substring)
        };
        if ((0, $2733e62ab452f32f$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($4d82c4193dc87874$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $8680c08594a744bc$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $8680c08594a744bc$export$c6cc36aa33304772)(token)) (0, $8680c08594a744bc$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $2733e62ab452f32f$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $4d82c4193dc87874$var$cleanEscapedString(input) {
    const matched = input.match($4d82c4193dc87874$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4d82c4193dc87874$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$4d82c4193dc87874$export$2e2bcd8739ae039 = $4d82c4193dc87874$export$d9468344d3651243;



var $9Jots = parcelRequire("9Jots");
function $3f8a5ebc3455d87a$export$aa350b96d91cd94(date) {
    const _date = (0, $9Jots.toDate)(date);
    const dayOfMonth = _date.getDate();
    return dayOfMonth;
}
var // Fallback for modularized imports:
$3f8a5ebc3455d87a$export$2e2bcd8739ae039 = $3f8a5ebc3455d87a$export$aa350b96d91cd94;



var $9Jots = parcelRequire("9Jots");

var $bXANJ = parcelRequire("bXANJ");
function $6426978377a12ea3$export$f645ddd439eb259d(date) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $bXANJ.constructFrom)(date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$6426978377a12ea3$export$2e2bcd8739ae039 = $6426978377a12ea3$export$f645ddd439eb259d;



var $9Jots = parcelRequire("9Jots");
function $1ff66dc2b59a546c$export$257b40f71c07d58f(date) {
    const _date = (0, $9Jots.toDate)(date);
    const hours = _date.getHours();
    return hours;
}
var // Fallback for modularized imports:
$1ff66dc2b59a546c$export$2e2bcd8739ae039 = $1ff66dc2b59a546c$export$257b40f71c07d58f;



var $9Jots = parcelRequire("9Jots");
function $01a43f855df1317a$export$b7f1bc3ea3ac4145(date) {
    const _date = (0, $9Jots.toDate)(date);
    const minutes = _date.getMinutes();
    return minutes;
}
var // Fallback for modularized imports:
$01a43f855df1317a$export$2e2bcd8739ae039 = $01a43f855df1317a$export$b7f1bc3ea3ac4145;



var $9Jots = parcelRequire("9Jots");
function $1a40515a6ec8db9f$export$6ce1b5acc29cb53b(date) {
    const _date = (0, $9Jots.toDate)(date);
    const month = _date.getMonth();
    return month;
}
var // Fallback for modularized imports:
$1a40515a6ec8db9f$export$2e2bcd8739ae039 = $1a40515a6ec8db9f$export$6ce1b5acc29cb53b;



var $9Jots = parcelRequire("9Jots");
function $f4bc34478ece4393$export$5e9417507ff28427(date) {
    const _date = (0, $9Jots.toDate)(date);
    const seconds = _date.getSeconds();
    return seconds;
}
var // Fallback for modularized imports:
$f4bc34478ece4393$export$2e2bcd8739ae039 = $f4bc34478ece4393$export$5e9417507ff28427;



var $9Jots = parcelRequire("9Jots");
function $d63543457f1346ed$export$b8e4380f312797af(date) {
    const _date = (0, $9Jots.toDate)(date);
    const milliseconds = _date.getMilliseconds();
    return milliseconds;
}
var // Fallback for modularized imports:
$d63543457f1346ed$export$2e2bcd8739ae039 = $d63543457f1346ed$export$b8e4380f312797af;




var $9Jots = parcelRequire("9Jots");
function $9c94d29d67e98e4a$export$5846dc2d57a5c860(date) {
    return (0, $9Jots.toDate)(date).getFullYear();
}
var // Fallback for modularized imports:
$9c94d29d67e98e4a$export$2e2bcd8739ae039 = $9c94d29d67e98e4a$export$5846dc2d57a5c860;



var $9Jots = parcelRequire("9Jots");
function $d324d09d698e9d12$export$e4de839670987035(date, dateToCompare) {
    const _date = (0, $9Jots.toDate)(date);
    const _dateToCompare = (0, $9Jots.toDate)(dateToCompare);
    return _date.getTime() > _dateToCompare.getTime();
}
var // Fallback for modularized imports:
$d324d09d698e9d12$export$2e2bcd8739ae039 = $d324d09d698e9d12$export$e4de839670987035;



var $9Jots = parcelRequire("9Jots");
function $16b6b9a14647dbb1$export$5c007e10c6929c95(date, dateToCompare) {
    const _date = (0, $9Jots.toDate)(date);
    const _dateToCompare = (0, $9Jots.toDate)(dateToCompare);
    return +_date < +_dateToCompare;
}
var // Fallback for modularized imports:
$16b6b9a14647dbb1$export$2e2bcd8739ae039 = $16b6b9a14647dbb1$export$5c007e10c6929c95;



var $9Jots = parcelRequire("9Jots");
function $c19e420d1229a25d$export$248d38f6296296c5(leftDate, rightDate) {
    const _dateLeft = (0, $9Jots.toDate)(leftDate);
    const _dateRight = (0, $9Jots.toDate)(rightDate);
    return +_dateLeft === +_dateRight;
}
var // Fallback for modularized imports:
$c19e420d1229a25d$export$2e2bcd8739ae039 = $c19e420d1229a25d$export$248d38f6296296c5;



var $8AHLd = parcelRequire("8AHLd");

var $9Jots = parcelRequire("9Jots");
function $98c35832c39d3eb3$export$5841f9eb9773f25f(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear();
}
var // Fallback for modularized imports:
$98c35832c39d3eb3$export$2e2bcd8739ae039 = $98c35832c39d3eb3$export$5841f9eb9773f25f;



var $9Jots = parcelRequire("9Jots");
function $0b324b26c46cd5d7$export$a18c89cbd24170ff(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    return _dateLeft.getFullYear() === _dateRight.getFullYear() && _dateLeft.getMonth() === _dateRight.getMonth();
}
var // Fallback for modularized imports:
$0b324b26c46cd5d7$export$2e2bcd8739ae039 = $0b324b26c46cd5d7$export$a18c89cbd24170ff;



var $9Jots = parcelRequire("9Jots");
function $8cb46f6104f2827d$export$24f91f68e7c9d9d5(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setMinutes(0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$8cb46f6104f2827d$export$2e2bcd8739ae039 = $8cb46f6104f2827d$export$24f91f68e7c9d9d5;


function $c0cb95a92713ce3e$export$f9f3a94a0371013(dateLeft, dateRight) {
    const dateLeftStartOfHour = (0, $8cb46f6104f2827d$export$24f91f68e7c9d9d5)(dateLeft);
    const dateRightStartOfHour = (0, $8cb46f6104f2827d$export$24f91f68e7c9d9d5)(dateRight);
    return +dateLeftStartOfHour === +dateRightStartOfHour;
}
var // Fallback for modularized imports:
$c0cb95a92713ce3e$export$2e2bcd8739ae039 = $c0cb95a92713ce3e$export$f9f3a94a0371013;




var $bXANJ = parcelRequire("bXANJ");

function $f988ef9426e5bd9d$export$430a3269e24b912e() {
    return Object.assign({}, (0, $6525066f50a2904f$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$f988ef9426e5bd9d$export$2e2bcd8739ae039 = $f988ef9426e5bd9d$export$430a3269e24b912e;




var $9Jots = parcelRequire("9Jots");



var $bXANJ = parcelRequire("bXANJ");
function $7dd1a06e27f02315$export$9cb09a71b7d66923(fromDate, constructor) {
    const date = constructor instanceof Date ? (0, $bXANJ.constructFrom)(constructor, 0) : new constructor(0);
    date.setFullYear(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate());
    date.setHours(fromDate.getHours(), fromDate.getMinutes(), fromDate.getSeconds(), fromDate.getMilliseconds());
    return date;
}
var // Fallback for modularized imports:
$7dd1a06e27f02315$export$2e2bcd8739ae039 = $7dd1a06e27f02315$export$9cb09a71b7d66923;



var $bXANJ = parcelRequire("bXANJ");
const $a6541b40943909d5$var$TIMEZONE_UNIT_PRIORITY = 10;
class $a6541b40943909d5$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $a6541b40943909d5$export$9a09e32dd4990fd5 extends $a6541b40943909d5$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $a6541b40943909d5$export$5aaf7ff7f09ea4ee extends $a6541b40943909d5$export$81d53e3678089a6 {
    priority = $a6541b40943909d5$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $bXANJ.constructFrom)(date, (0, $7dd1a06e27f02315$export$9cb09a71b7d66923)(date, Date));
    }
}


class $9de5fd3136696063$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $a6541b40943909d5$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $5f111202ec2b3c58$export$8e5a1d3f85a9688 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $ba8e12b41494ecfc$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $ba8e12b41494ecfc$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $4554650926fba5e9$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $4554650926fba5e9$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4554650926fba5e9$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff) + seconds * (0, $e24aa25ccaa7cb1c$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4554650926fba5e9$export$d931c43c4608a164(dateString) {
    return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $4554650926fba5e9$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $4554650926fba5e9$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $4554650926fba5e9$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $4554650926fba5e9$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $4554650926fba5e9$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $4554650926fba5e9$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $38ddfa0bdba9fd91$export$48d352de7cd4a988 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $4554650926fba5e9$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $d87a3190295f92fd$export$b8ef38dfcf05d5db extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $2a4c9a3ae7bb29a5$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $4554650926fba5e9$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




var $bXANJ = parcelRequire("bXANJ");


class $4a0994229342c57c$export$951d1df011fde06f extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $4554650926fba5e9$export$2c9307b2e29c533c)(4, dateString);
        return (0, $4554650926fba5e9$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $bXANJ.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $80ab7b76dc31fb87$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $fecdfc8d3425f3ba$export$bad9d2ea38e8f1a extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $4554650926fba5e9$export$2c9307b2e29c533c)(4, dateString);
        return (0, $4554650926fba5e9$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d9d5a4715cdbb604$export$5cb0f701186dde1d extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $559bdf3c6c672152$export$300c0c2990e20e6d extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $9522b47788df1453$export$400dd8b40ef138a3 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $45a8b848b67eaa04$export$1d7eaa53eaa5deba extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




var $9Jots = parcelRequire("9Jots");
function $73f6504c786eb18a$export$4b3066ce4afafd88(date, week, options) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = (0, $ea960e7aff37061d$export$efe19b760242b2fc)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$73f6504c786eb18a$export$2e2bcd8739ae039 = $73f6504c786eb18a$export$4b3066ce4afafd88;






class $a54f214b462e91cf$export$c4005ffc174e07c0 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)((0, $73f6504c786eb18a$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




var $9Jots = parcelRequire("9Jots");
function $4f0a213e16142aad$export$6542bebf6be94082(date, week) {
    const _date = (0, $9Jots.toDate)(date);
    const diff = (0, $7e3321a3fdd64965$export$7cabdc5698b63e2f)(_date) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$4f0a213e16142aad$export$2e2bcd8739ae039 = $4f0a213e16142aad$export$6542bebf6be94082;






class $2852cb8241169a99$export$6fc8dbedd560a6af extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $80ab7b76dc31fb87$export$6173213f95a4431e)((0, $4f0a213e16142aad$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $0ca6c704cbf7920a$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $0ca6c704cbf7920a$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $0ca6c704cbf7920a$export$e8d4b28a20981dd2 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $4554650926fba5e9$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $0ca6c704cbf7920a$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $0ca6c704cbf7920a$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $bf8b36b91ffc6451$export$6cfe0d613455f615 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $4554650926fba5e9$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}



var $7S0ew = parcelRequire("7S0ew");

var $9Jots = parcelRequire("9Jots");

function $6ed9fc48623fdb57$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $6525066f50a2904f$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $9Jots.toDate)(date);
    const currentDay = _date.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $7S0ew.addDays)(_date, diff);
}
var // Fallback for modularized imports:
$6ed9fc48623fdb57$export$2e2bcd8739ae039 = $6ed9fc48623fdb57$export$b04fdcda82decc6c;



class $138ddbbe4167e3fb$export$1b03c8b76262f7bd extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $6ed9fc48623fdb57$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $3f23edf697c101e4$export$44d1c127ab42c480 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $6ed9fc48623fdb57$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $40b3cd2004e288ff$export$e447a647caaaec1d extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $6ed9fc48623fdb57$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}



var $7S0ew = parcelRequire("7S0ew");

var $9Jots = parcelRequire("9Jots");
function $3e99db726559d10a$export$c514f4c1a8ed5e9e(date) {
    const _date = (0, $9Jots.toDate)(date);
    let day = _date.getDay();
    if (day === 0) day = 7;
    return day;
}
var // Fallback for modularized imports:
$3e99db726559d10a$export$2e2bcd8739ae039 = $3e99db726559d10a$export$c514f4c1a8ed5e9e;



var $9Jots = parcelRequire("9Jots");
function $2f2f8827652e508b$export$1fd9df65adb0d1aa(date, day) {
    const _date = (0, $9Jots.toDate)(date);
    const currentDay = (0, $3e99db726559d10a$export$c514f4c1a8ed5e9e)(_date);
    const diff = day - currentDay;
    return (0, $7S0ew.addDays)(_date, diff);
}
var // Fallback for modularized imports:
$2f2f8827652e508b$export$2e2bcd8739ae039 = $2f2f8827652e508b$export$1fd9df65adb0d1aa;




class $197d9bf1f14fe68e$export$693fb1e525095b2a extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $4554650926fba5e9$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $2f2f8827652e508b$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $5eb904285e68af22$export$8d1e08492351df91 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $4554650926fba5e9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $f86ef63ca1585998$export$73ca2bd0a17d273 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $4554650926fba5e9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $d7f01735be20c075$export$bb9212adf05373db extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $4554650926fba5e9$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $713504864853228d$export$8a04050a727a1756 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $fb7b0ef04c2a47f4$export$e56f4dea2c3e56dd extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $1cf9442915fcc118$export$cbbe855312f87d77 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $72365b7e1e6b4114$export$6008046d2b34b6a5 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $12a7f5f85baf983f$export$2b52670d9e2be53 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $8efb79a8694691d1$export$94d46d540cf1366a extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $4554650926fba5e9$export$cc7cc9e2a3ff9388)((0, $ba8e12b41494ecfc$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $ad4a67189c58c53b$export$b8e6f8b2d70893b1 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $4554650926fba5e9$export$4f84e3a82c7b538)((0, $4554650926fba5e9$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}



var $bXANJ = parcelRequire("bXANJ");




class $f2901f847532d53b$export$104d901d49fea29b extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $bXANJ.constructFrom)(date, date.getTime() - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}



var $bXANJ = parcelRequire("bXANJ");




class $1566332accba0274$export$12910e5204b52b9 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $4554650926fba5e9$export$6497f4c0ecdfba8e)((0, $ba8e12b41494ecfc$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $bXANJ.constructFrom)(date, date.getTime() - (0, $39c386bf2b2d4be8$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}



var $bXANJ = parcelRequire("bXANJ");


class $4bca580080f4a1b2$export$2cd8bf877a05e96 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $4554650926fba5e9$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $bXANJ.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}



var $bXANJ = parcelRequire("bXANJ");


class $4c21700c371c8bc2$export$6d8f69c6906d6368 extends (0, $9de5fd3136696063$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $4554650926fba5e9$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $bXANJ.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $bc4a7177bad243e4$export$19131010e7fd8373 = {
    G: new (0, $5f111202ec2b3c58$export$8e5a1d3f85a9688)(),
    y: new (0, $38ddfa0bdba9fd91$export$48d352de7cd4a988)(),
    Y: new (0, $d87a3190295f92fd$export$b8ef38dfcf05d5db)(),
    R: new (0, $4a0994229342c57c$export$951d1df011fde06f)(),
    u: new (0, $fecdfc8d3425f3ba$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d9d5a4715cdbb604$export$5cb0f701186dde1d)(),
    q: new (0, $559bdf3c6c672152$export$300c0c2990e20e6d)(),
    M: new (0, $9522b47788df1453$export$400dd8b40ef138a3)(),
    L: new (0, $45a8b848b67eaa04$export$1d7eaa53eaa5deba)(),
    w: new (0, $a54f214b462e91cf$export$c4005ffc174e07c0)(),
    I: new (0, $2852cb8241169a99$export$6fc8dbedd560a6af)(),
    d: new (0, $0ca6c704cbf7920a$export$e8d4b28a20981dd2)(),
    D: new (0, $bf8b36b91ffc6451$export$6cfe0d613455f615)(),
    E: new (0, $138ddbbe4167e3fb$export$1b03c8b76262f7bd)(),
    e: new (0, $3f23edf697c101e4$export$44d1c127ab42c480)(),
    c: new (0, $40b3cd2004e288ff$export$e447a647caaaec1d)(),
    i: new (0, $197d9bf1f14fe68e$export$693fb1e525095b2a)(),
    a: new (0, $5eb904285e68af22$export$8d1e08492351df91)(),
    b: new (0, $f86ef63ca1585998$export$73ca2bd0a17d273)(),
    B: new (0, $d7f01735be20c075$export$bb9212adf05373db)(),
    h: new (0, $713504864853228d$export$8a04050a727a1756)(),
    H: new (0, $fb7b0ef04c2a47f4$export$e56f4dea2c3e56dd)(),
    K: new (0, $1cf9442915fcc118$export$cbbe855312f87d77)(),
    k: new (0, $72365b7e1e6b4114$export$6008046d2b34b6a5)(),
    m: new (0, $12a7f5f85baf983f$export$2b52670d9e2be53)(),
    s: new (0, $8efb79a8694691d1$export$94d46d540cf1366a)(),
    S: new (0, $ad4a67189c58c53b$export$b8e6f8b2d70893b1)(),
    X: new (0, $f2901f847532d53b$export$104d901d49fea29b)(),
    x: new (0, $1566332accba0274$export$12910e5204b52b9)(),
    t: new (0, $4bca580080f4a1b2$export$2cd8bf877a05e96)(),
    T: new (0, $4c21700c371c8bc2$export$6d8f69c6906d6368)()
};



/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $6f5a94e8046c18ec$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $6f5a94e8046c18ec$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $6f5a94e8046c18ec$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $6f5a94e8046c18ec$var$doubleQuoteRegExp = /''/g;
const $6f5a94e8046c18ec$var$notWhitespaceRegExp = /\S/;
const $6f5a94e8046c18ec$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $6f5a94e8046c18ec$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const defaultOptions = (0, $f988ef9426e5bd9d$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $f45f4bcf38c4ce94$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (formatStr === "") {
        if (dateStr === "") return (0, $9Jots.toDate)(referenceDate);
        else return (0, $bXANJ.constructFrom)(referenceDate, NaN);
    }
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    const setters = [
        new (0, $a6541b40943909d5$export$5aaf7ff7f09ea4ee)()
    ];
    const tokens = formatStr.match($6f5a94e8046c18ec$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $3d9918f67aabe98a$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $3d9918f67aabe98a$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($6f5a94e8046c18ec$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $8680c08594a744bc$export$c6b49d6dceb604a1)(token)) (0, $8680c08594a744bc$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $8680c08594a744bc$export$c6cc36aa33304772)(token)) (0, $8680c08594a744bc$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $bc4a7177bad243e4$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return (0, $bXANJ.constructFrom)(referenceDate, NaN);
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($6f5a94e8046c18ec$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $6f5a94e8046c18ec$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return (0, $bXANJ.constructFrom)(referenceDate, NaN);
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $6f5a94e8046c18ec$var$notWhitespaceRegExp.test(dateStr)) return (0, $bXANJ.constructFrom)(referenceDate, NaN);
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $9Jots.toDate)(referenceDate);
    if (isNaN(date.getTime())) return (0, $bXANJ.constructFrom)(referenceDate, NaN);
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return (0, $bXANJ.constructFrom)(referenceDate, NaN);
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return (0, $bXANJ.constructFrom)(referenceDate, date);
}
function $6f5a94e8046c18ec$var$cleanEscapedString(input) {
    return input.match($6f5a94e8046c18ec$var$escapedStringRegExp)[1].replace($6f5a94e8046c18ec$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$6f5a94e8046c18ec$export$2e2bcd8739ae039 = $6f5a94e8046c18ec$export$98e6a39c04603d36;



var $9Jots = parcelRequire("9Jots");
function $79e00e235299cf75$export$566174fa40823587(date, dayOfMonth) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setDate(dayOfMonth);
    return _date;
}
var // Fallback for modularized imports:
$79e00e235299cf75$export$2e2bcd8739ae039 = $79e00e235299cf75$export$566174fa40823587;



var $9Jots = parcelRequire("9Jots");
function $e5c3607919027123$export$f86b797a4659b781(date, hours) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$e5c3607919027123$export$2e2bcd8739ae039 = $e5c3607919027123$export$f86b797a4659b781;



var $9Jots = parcelRequire("9Jots");
function $62c092380e7b2f83$export$ad569bf1c79ea89d(date, minutes) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setMinutes(minutes);
    return _date;
}
var // Fallback for modularized imports:
$62c092380e7b2f83$export$2e2bcd8739ae039 = $62c092380e7b2f83$export$ad569bf1c79ea89d;



var $bXANJ = parcelRequire("bXANJ");


var $9Jots = parcelRequire("9Jots");
function $65e569ba6cad5488$export$63264690f8e36790(date, month) {
    const _date = (0, $9Jots.toDate)(date);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const dateWithDesiredMonth = (0, $bXANJ.constructFrom)(date, 0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $6426978377a12ea3$export$f645ddd439eb259d)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$65e569ba6cad5488$export$2e2bcd8739ae039 = $65e569ba6cad5488$export$63264690f8e36790;



var $9Jots = parcelRequire("9Jots");
function $d52dfecdf18f320c$export$aec44746644cbf43(date, seconds) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$d52dfecdf18f320c$export$2e2bcd8739ae039 = $d52dfecdf18f320c$export$aec44746644cbf43;



var $9Jots = parcelRequire("9Jots");
function $9a166a830be01935$export$de5664029b35e06d(date, milliseconds) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setMilliseconds(milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$9a166a830be01935$export$2e2bcd8739ae039 = $9a166a830be01935$export$de5664029b35e06d;



var $bXANJ = parcelRequire("bXANJ");

var $9Jots = parcelRequire("9Jots");
function $2a0c0cbedac389e0$export$a8408b6c5639cab7(date, year) {
    const _date = (0, $9Jots.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $bXANJ.constructFrom)(date, NaN);
    _date.setFullYear(year);
    return _date;
}
var // Fallback for modularized imports:
$2a0c0cbedac389e0$export$2e2bcd8739ae039 = $2a0c0cbedac389e0$export$a8408b6c5639cab7;



var $g04kv = parcelRequire("g04kv");

var $9Jots = parcelRequire("9Jots");
function $e1db2803651e4352$export$a5a3b454ada2268e(date) {
    const _date = (0, $9Jots.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$e1db2803651e4352$export$2e2bcd8739ae039 = $e1db2803651e4352$export$a5a3b454ada2268e;



var $9Jots = parcelRequire("9Jots");
function $32e1fec708db8003$export$a2258d9c4118825c(date) {
    const _date = (0, $9Jots.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$32e1fec708db8003$export$2e2bcd8739ae039 = $32e1fec708db8003$export$a2258d9c4118825c;





var $9Jots = parcelRequire("9Jots");
function $23f5a16e52362739$export$d7deef7a3738e19d(date, interval) {
    const time = +(0, $9Jots.toDate)(date);
    const [startTime, endTime] = [
        +(0, $9Jots.toDate)(interval.start),
        +(0, $9Jots.toDate)(interval.end)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$23f5a16e52362739$export$2e2bcd8739ae039 = $23f5a16e52362739$export$d7deef7a3738e19d;




const $ff3d867ec0a13b51$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // eslint-disable-next-line id-denylist
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $ff3d867ec0a13b51$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    dayOfMonthFull: 'do',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
class $ff3d867ec0a13b51$export$e330e9acbbe873f1 {
    isMUIAdapter = true;
    isTimezoneCompatible = false;
    formatTokenMap = (()=>$ff3d867ec0a13b51$var$formatTokenMap)();
    escapedCharacters = {
        start: "'",
        end: "'"
    };
    constructor(props){
        const { locale: locale, formats: formats, longFormatters: longFormatters, lib: lib } = props;
        this.locale = locale;
        this.formats = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $ff3d867ec0a13b51$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
        this.lib = lib || 'date-fns';
    }
    date = (value)=>{
        if (typeof value === 'undefined') return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    getInvalidDate = ()=>new Date('Invalid Date');
    getTimezone = ()=>{
        return 'default';
    };
    setTimezone = (value)=>{
        return value;
    };
    toJsDate = (value)=>{
        return value;
    };
    getCurrentLocaleCode = ()=>{
        // `code` is undefined only in `date-fns` types, but all locales have it
        return this.locale.code;
    };
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    is12HourCycleInCurrentLocale = ()=>{
        return /a/.test(this.locale.formatLong.time({
            width: 'short'
        }));
    };
    expandFormat = (format)=>{
        const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
        // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
        return format.match(longFormatRegexp).map((token)=>{
            const firstCharacter = token[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                const longFormatter = this.longFormatters[firstCharacter];
                return longFormatter(token, this.locale.formatLong);
            }
            return token;
        }).join('');
    };
    formatNumber = (numberToFormat)=>{
        return numberToFormat;
    };
    getDayOfWeek = (value)=>{
        return value.getDay() + 1;
    };
}


class $cf2ede53d164004b$export$81f56c0329a1921d extends (0, $ff3d867ec0a13b51$export$e330e9acbbe873f1) {
    constructor({ locale: locale, formats: formats } = {}){
        /* v8 ignore stop */ super({
            locale: locale ?? (0, $f45f4bcf38c4ce94$export$137380d9ce54f7f),
            formats: formats,
            longFormatters: $3d9918f67aabe98a$export$70cc8fd02856fd58
        });
    }
    // TODO: explicit return types can be removed once there is only one date-fns version supported
    parse = (value, format)=>{
        if (value === '') return null;
        return (0, $6f5a94e8046c18ec$export$98e6a39c04603d36)(value, format, new Date(), {
            locale: this.locale
        });
    };
    isValid = (value)=>{
        if (value == null) return false;
        return (0, $ae5dedc3e6bc7894$export$1ea939691cdc45b8)(value);
    };
    format = (value, formatKey)=>{
        return this.formatByString(value, this.formats[formatKey]);
    };
    formatByString = (value, formatString)=>{
        return (0, $4d82c4193dc87874$export$d9468344d3651243)(value, formatString, {
            locale: this.locale
        });
    };
    isEqual = (value, comparing)=>{
        if (value === null && comparing === null) return true;
        if (value === null || comparing === null) return false;
        return (0, $c19e420d1229a25d$export$248d38f6296296c5)(value, comparing);
    };
    isSameYear = (value, comparing)=>{
        return (0, $98c35832c39d3eb3$export$5841f9eb9773f25f)(value, comparing);
    };
    isSameMonth = (value, comparing)=>{
        return (0, $0b324b26c46cd5d7$export$a18c89cbd24170ff)(value, comparing);
    };
    isSameDay = (value, comparing)=>{
        return (0, $8AHLd.isSameDay)(value, comparing);
    };
    isSameHour = (value, comparing)=>{
        return (0, $c0cb95a92713ce3e$export$f9f3a94a0371013)(value, comparing);
    };
    isAfter = (value, comparing)=>{
        return (0, $d324d09d698e9d12$export$e4de839670987035)(value, comparing);
    };
    isAfterYear = (value, comparing)=>{
        return (0, $d324d09d698e9d12$export$e4de839670987035)(value, (0, $9805f8396c527015$export$8b7aa55c66d5569e)(comparing));
    };
    isAfterDay = (value, comparing)=>{
        return (0, $d324d09d698e9d12$export$e4de839670987035)(value, (0, $2CcMD.endOfDay)(comparing));
    };
    isBefore = (value, comparing)=>{
        return (0, $16b6b9a14647dbb1$export$5c007e10c6929c95)(value, comparing);
    };
    isBeforeYear = (value, comparing)=>{
        return (0, $16b6b9a14647dbb1$export$5c007e10c6929c95)(value, this.startOfYear(comparing));
    };
    isBeforeDay = (value, comparing)=>{
        return (0, $16b6b9a14647dbb1$export$5c007e10c6929c95)(value, this.startOfDay(comparing));
    };
    isWithinRange = (value, [start, end])=>{
        return (0, $23f5a16e52362739$export$d7deef7a3738e19d)(value, {
            start: start,
            end: end
        });
    };
    startOfYear = (value)=>{
        return (0, $acbc1d0003a51961$export$f91e89d3d0406102)(value);
    };
    startOfMonth = (value)=>{
        return (0, $e1db2803651e4352$export$a5a3b454ada2268e)(value);
    };
    startOfWeek = (value)=>{
        return (0, $a6b650558c0d274a$export$42c81a444fbfb5d4)(value, {
            locale: this.locale
        });
    };
    startOfDay = (value)=>{
        return (0, $g04kv.startOfDay)(value);
    };
    endOfYear = (value)=>{
        return (0, $9805f8396c527015$export$8b7aa55c66d5569e)(value);
    };
    endOfMonth = (value)=>{
        return (0, $32e1fec708db8003$export$a2258d9c4118825c)(value);
    };
    endOfWeek = (value)=>{
        return (0, $42ecbba5934145fb$export$ef8b6d9133084f4e)(value, {
            locale: this.locale
        });
    };
    endOfDay = (value)=>{
        return (0, $2CcMD.endOfDay)(value);
    };
    addYears = (value, amount)=>{
        return (0, $dab9374b7fb99d73$export$3d83eec43f4ea476)(value, amount);
    };
    addMonths = (value, amount)=>{
        return (0, $5BFw5.addMonths)(value, amount);
    };
    addWeeks = (value, amount)=>{
        return (0, $3506675759da9be2$export$ef501a2bb4f3ee6b)(value, amount);
    };
    addDays = (value, amount)=>{
        return (0, $7S0ew.addDays)(value, amount);
    };
    addHours = (value, amount)=>{
        return (0, $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6)(value, amount);
    };
    addMinutes = (value, amount)=>{
        return (0, $3652e7106c1f3d0e$export$2287e3d29250119e)(value, amount);
    };
    addSeconds = (value, amount)=>{
        return (0, $a0c5e89fec7150ea$export$3cb31b0df13be68)(value, amount);
    };
    getYear = (value)=>{
        return (0, $9c94d29d67e98e4a$export$5846dc2d57a5c860)(value);
    };
    getMonth = (value)=>{
        return (0, $1a40515a6ec8db9f$export$6ce1b5acc29cb53b)(value);
    };
    getDate = (value)=>{
        return (0, $3f8a5ebc3455d87a$export$aa350b96d91cd94)(value);
    };
    getHours = (value)=>{
        return (0, $1ff66dc2b59a546c$export$257b40f71c07d58f)(value);
    };
    getMinutes = (value)=>{
        return (0, $01a43f855df1317a$export$b7f1bc3ea3ac4145)(value);
    };
    getSeconds = (value)=>{
        return (0, $f4bc34478ece4393$export$5e9417507ff28427)(value);
    };
    getMilliseconds = (value)=>{
        return (0, $d63543457f1346ed$export$b8e4380f312797af)(value);
    };
    setYear = (value, year)=>{
        return (0, $2a0c0cbedac389e0$export$a8408b6c5639cab7)(value, year);
    };
    setMonth = (value, month)=>{
        return (0, $65e569ba6cad5488$export$63264690f8e36790)(value, month);
    };
    setDate = (value, date)=>{
        return (0, $79e00e235299cf75$export$566174fa40823587)(value, date);
    };
    setHours = (value, hours)=>{
        return (0, $e5c3607919027123$export$f86b797a4659b781)(value, hours);
    };
    setMinutes = (value, minutes)=>{
        return (0, $62c092380e7b2f83$export$ad569bf1c79ea89d)(value, minutes);
    };
    setSeconds = (value, seconds)=>{
        return (0, $d52dfecdf18f320c$export$aec44746644cbf43)(value, seconds);
    };
    setMilliseconds = (value, milliseconds)=>{
        return (0, $9a166a830be01935$export$de5664029b35e06d)(value, milliseconds);
    };
    getDaysInMonth = (value)=>{
        return (0, $6426978377a12ea3$export$f645ddd439eb259d)(value);
    };
    getWeekArray = (value)=>{
        const start = this.startOfWeek(this.startOfMonth(value));
        const end = this.endOfWeek(this.endOfMonth(value));
        let count = 0;
        let current = start;
        const nestedWeeks = [];
        while(this.isBefore(current, end)){
            const weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = this.addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    getWeekNumber = (value)=>{
        return (0, $ea960e7aff37061d$export$efe19b760242b2fc)(value, {
            locale: this.locale
        });
    };
    getYearRange = ([start, end])=>{
        const startDate = this.startOfYear(start);
        const endDate = this.endOfYear(end);
        const years = [];
        let current = startDate;
        while(this.isBefore(current, endDate)){
            years.push(current);
            current = this.addYears(current, 1);
        }
        return years;
    };
}


const $832cbc53067f1899$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 sekundou",
            future: "za m\xe9n\u011B ne\u017E 1 sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "1 sekunda",
            past: "p\u0159ed 1 sekundou",
            future: "za 1 sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E 1 minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E 1 minutou",
            future: "za m\xe9n\u011B ne\u017E 1 minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "1 minuta",
            past: "p\u0159ed 1 minutou",
            future: "za 1 minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 hodinou",
            future: "p\u0159ibli\u017En\u011B za 1 hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "1 hodina",
            past: "p\u0159ed 1 hodinou",
            future: "za 1 hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "1 den",
            past: "p\u0159ed 1 dnem",
            future: "za 1 den"
        },
        few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za 1 t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "1 t\xfdden",
            past: "p\u0159ed 1 t\xfddnem",
            future: "za 1 t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "1 m\u011Bs\xedc",
            past: "p\u0159ed 1 m\u011Bs\xedcem",
            future: "za 1 m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B 1 rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed 1 rokem",
            future: "p\u0159ibli\u017En\u011B za 1 rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: "1 rok",
            past: "p\u0159ed 1 rokem",
            future: "za 1 rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E 1 rok",
            past: "p\u0159ed v\xedce ne\u017E 1 rokem",
            future: "za v\xedce ne\u017E 1 rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro 1 rok",
            past: "skoro p\u0159ed 1 rokem",
            future: "skoro za 1 rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
const $832cbc53067f1899$export$2c14ff85d6318973 = (token, count, options)=>{
    let pluralResult;
    const tokenValue = $832cbc53067f1899$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    const suffixExist = options?.addSuffix === true;
    const comparison = options?.comparison;
    let timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};



const $b8d522aeec33b4d8$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
const $b8d522aeec33b4d8$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
const $b8d522aeec33b4d8$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $b8d522aeec33b4d8$export$cbf60ecb96cbb82f = {
    date: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $b8d522aeec33b4d8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $b8d522aeec33b4d8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $82aa69c14702147f$export$38e44e97ce4dbb7d)({
        formats: $b8d522aeec33b4d8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $c47c5af80c1cee7f$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    "sobotu"
];
const $c47c5af80c1cee7f$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: (date)=>{
        const day = date.getDay();
        return "'v " + $c47c5af80c1cee7f$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
const $c47c5af80c1cee7f$export$8fbbfd65594f46a0 = (token, date)=>{
    const format = $c47c5af80c1cee7f$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};



const $e94763b17416ac90$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        "n. l."
    ],
    abbreviated: [
        "p\u0159. n. l.",
        "n. l."
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
const $e94763b17416ac90$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
const $e94763b17416ac90$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "b\u0159ezen",
        "duben",
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        "srpen",
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        "listopad",
        "prosinec"
    ]
};
const $e94763b17416ac90$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "b\u0159ezna",
        "dubna",
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        "srpna",
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        "listopadu",
        "prosince"
    ]
};
const $e94763b17416ac90$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
const $e94763b17416ac90$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $e94763b17416ac90$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
const $e94763b17416ac90$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    return number + ".";
};
const $e94763b17416ac90$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e94763b17416ac90$var$ordinalNumber,
    era: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e94763b17416ac90$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e94763b17416ac90$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e94763b17416ac90$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $e94763b17416ac90$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e94763b17416ac90$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $b12404f6dcad3401$export$63596d6ee8878b25)({
        values: $e94763b17416ac90$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e94763b17416ac90$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};




const $59ebdfd0604c25d1$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
const $59ebdfd0604c25d1$var$parseOrdinalNumberPattern = /\d+/i;
const $59ebdfd0604c25d1$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
const $59ebdfd0604c25d1$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
const $59ebdfd0604c25d1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
const $59ebdfd0604c25d1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $59ebdfd0604c25d1$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
const $59ebdfd0604c25d1$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
const $59ebdfd0604c25d1$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
const $59ebdfd0604c25d1$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
const $59ebdfd0604c25d1$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
const $59ebdfd0604c25d1$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
const $59ebdfd0604c25d1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $44f83ed6fd86b6bd$export$fdaf2fd6d7edde95)({
        matchPattern: $59ebdfd0604c25d1$var$matchOrdinalNumberPattern,
        parsePattern: $59ebdfd0604c25d1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $59ebdfd0604c25d1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $59ebdfd0604c25d1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $59ebdfd0604c25d1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $59ebdfd0604c25d1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $59ebdfd0604c25d1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $59ebdfd0604c25d1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $59ebdfd0604c25d1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $59ebdfd0604c25d1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $89a828c41b7e1bc3$export$1430a0f35710914d)({
        matchPatterns: $59ebdfd0604c25d1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $59ebdfd0604c25d1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $de8c05b32292e2b0$export$bde1ed0f60b38f2f = {
    code: "cs",
    formatDistance: (0, $832cbc53067f1899$export$2c14ff85d6318973),
    formatLong: (0, $b8d522aeec33b4d8$export$cbf60ecb96cbb82f),
    formatRelative: (0, $c47c5af80c1cee7f$export$8fbbfd65594f46a0),
    localize: (0, $e94763b17416ac90$export$b3bd0bc58e36cd63),
    match: (0, $59ebdfd0604c25d1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var // Fallback for modularized imports:
$de8c05b32292e2b0$export$2e2bcd8739ae039 = $de8c05b32292e2b0$export$bde1ed0f60b38f2f;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $7pTac = parcelRequire("7pTac");

var $dHW62 = parcelRequire("dHW62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4mI0b = parcelRequire("4mI0b");
const $f60f9ecdaa9a9208$export$3d2a8d7c47985b16 = (Component)=>function L(props) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
            fallback: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                sx: {
                    display: 'block',
                    mx: 'auto'
                }
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
                ...props
            })
        });
    };



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $jDfxe = parcelRequire("jDfxe");

var $aphAM = parcelRequire("aphAM");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $a1bba11514f5f326$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96M3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4z"
}), 'CloudOff');



var $klPA2 = parcelRequire("klPA2");
var $gJm6V = parcelRequire("gJm6V");
var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $1DAbm = parcelRequire("1DAbm");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");
var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $cfUWu = parcelRequire("cfUWu");

var $g6Om4 = parcelRequire("g6Om4");
'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $942f413c6b94358c$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $eEJPp.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $942f413c6b94358c$var$safeReact = {
    ...$acw62
};
const $942f413c6b94358c$var$maybeReactUseSyncExternalStore = $942f413c6b94358c$var$safeReact.useSyncExternalStore;
function $942f413c6b94358c$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $942f413c6b94358c$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $942f413c6b94358c$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $g6Om4.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $cfUWu.default)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $942f413c6b94358c$var$maybeReactUseSyncExternalStore !== undefined ? $942f413c6b94358c$var$useMediaQueryNew : $942f413c6b94358c$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $942f413c6b94358c$var$useMediaQuery = $942f413c6b94358c$export$96d7927a982220b5();
var $942f413c6b94358c$export$2e2bcd8739ae039 = $942f413c6b94358c$var$useMediaQuery;



var $bXtHQ = parcelRequire("bXtHQ");
const $4256528f2d3b21ab$var$useMediaQuery = (0, $942f413c6b94358c$export$96d7927a982220b5)({
    themeId: (0, $bXtHQ.default)
});
var $4256528f2d3b21ab$export$2e2bcd8739ae039 = $4256528f2d3b21ab$var$useMediaQuery;



var $dHW62 = parcelRequire("dHW62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $59284b1ac39b5c43$export$d9b273488cd8ce6f = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 16 16",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 3H14.75",
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 8H14.75",
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 13H14.75",
                stroke: "currentColor",
                strokeLinecap: "round"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $aa25f3d1279cf638$export$c72f6eaae7b9adff = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.8333 18.3334V9.16669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.8333 5.83335V1.66669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10 18.3334V14.1667",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10 10.8334V1.66669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.16669 18.3334V9.16669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.16669 5.83335V1.66669",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.5 9.16669H5.83333",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.1667 9.16669H17.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.33331 10.8333H11.6666",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $2VxZV = parcelRequire("2VxZV");

var $3OncY = parcelRequire("3OncY");

var $8ni7a = parcelRequire("8ni7a");
var $44d758d594decd86$exports = {};
$44d758d594decd86$exports = import.meta.resolve("30yKJ");


const $bfc71c5de3bf5456$var$ryseLogo = new URL($44d758d594decd86$exports);
const $bfc71c5de3bf5456$export$e6ff31bff12b7ff4 = ({ variant: variant, sx: sx = {} })=>{
    if ((0, $3OncY.APP_UI_VARIANT) === (0, $8ni7a.AppUiVariant).Ryse) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            ...sx,
            backgroundImage: `url('${$bfc71c5de3bf5456$var$ryseLogo.toString()}')`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            width: '1em',
            height: '1em'
        }
    });
    if ((0, $3OncY.APP_UI_VARIANT) === (0, $8ni7a.AppUiVariant).Solidsun) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 80 56",
        sx: {
            fill: 'none',
            width: '1.15em',
            height: '1.15em',
            ...sx,
            ...variant === 'animation' ? {
                mb: 0.25
            } : {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M33.6982 27.1512L41.9789 16.9277C42.7457 15.9802 43.8959 15.435 45.1099 15.435H64.4603C66.3886 15.435 68.1928 14.574 69.4106 13.0736L79.9993 0H56.9916C55.0632 0 53.2591 0.861051 52.0412 2.3613L43.7605 12.5848C42.9938 13.5324 41.8436 14.0814 40.6257 14.0814H21.2754C19.3472 14.0814 17.5429 14.9424 16.325 16.4463L5.74023 29.5125H28.7479C30.6761 29.5125 32.4804 28.6515 33.6982 27.1474V27.1512Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M46.2972 28.4314L38.0166 38.6548C37.2498 39.6024 36.0996 40.1476 34.8854 40.1476H15.5351C13.6069 40.1476 11.8027 41.0086 10.5848 42.5089L0 55.5788H23.0077C24.9359 55.5788 26.7401 54.7177 27.9581 53.2137L36.2386 42.9901C37.0055 42.0426 38.1557 41.4936 39.3734 41.4936H58.7239C60.6521 41.4936 62.4564 40.6326 63.6741 39.1287L74.259 26.0625H51.2514C49.3305 26.0625 47.5113 26.9273 46.3009 28.4276L46.2972 28.4314Z",
                fill: "#fff"
            })
        ]
    });
    if ((0, $3OncY.APP_UI_VARIANT) === (0, $8ni7a.AppUiVariant).Innogy && variant === 'header') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 42 143",
        sx: {
            width: '1.3em',
            height: '1.3em',
            ...sx ?? {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M32.4016 43.7592C34.857 42.8664 36.1963 42.6431 36.866 42.8664C37.0892 42.8664 37.0892 42.8664 37.3124 43.0896V43.536C37.0892 44.8753 35.5267 48.8933 26.1515 57.3756L24.3657 58.9381C26.1515 59.3845 27.714 60.0542 29.0533 60.9471L29.2765 60.7239C41.7768 49.1165 42 44.6521 42 43.0896C42 41.527 41.5536 40.1877 40.4375 39.2949C37.3124 36.1698 31.0623 38.8484 21.0174 43.3128C17.2227 45.0985 13.2048 46.8843 10.0797 47.7772C5.83858 49.1165 5.16892 48.4468 4.9457 48.4468C4.27605 48.0004 4.9457 46.2146 6.28502 43.7592C8.07076 40.8574 10.7494 37.2859 13.8744 33.9376L15.437 32.1519C13.8744 31.4822 12.5351 30.8126 11.1958 29.9197L10.0797 31.259C4.05283 38.402 -3.5366 47.5539 1.82064 52.2415C5.61536 55.5898 13.6512 52.0183 22.8032 48.0004C26.3747 46.2146 29.723 44.8753 32.4016 43.7592Z",
                fill: "#FFD700"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M21.0187 142.199C12.9829 142.199 6.28631 135.725 6.28631 127.466V73.2243C6.28631 65.1884 12.7597 58.4918 21.0187 58.4918C29.2778 58.4918 35.7512 64.9652 35.7512 73.2243V127.69C35.7512 135.725 29.0546 142.199 21.0187 142.199ZM21.0187 62.733C15.2151 62.733 10.5275 67.4206 10.5275 73.2243V127.69C10.5275 133.493 15.2151 138.181 21.0187 138.181C26.8224 138.181 31.51 133.493 31.51 127.69V73.2243C31.51 67.4206 26.8224 62.733 21.0187 62.733ZM21.0187 33.4913C11.8668 33.4913 4.27734 25.9019 4.27734 16.7499C4.27734 7.59798 11.8668 0.00854492 21.0187 0.00854492C30.1707 0.00854492 37.7601 7.59798 37.7601 16.7499C37.7601 25.9019 30.1707 33.4913 21.0187 33.4913ZM21.0187 4.2497C14.099 4.2497 8.5185 9.83016 8.5185 16.7499C8.5185 23.6697 14.099 29.2502 21.0187 29.2502C27.9385 29.2502 33.519 23.6697 33.519 16.7499C33.519 9.83016 27.9385 4.2497 21.0187 4.2497Z",
                fill: "white"
            })
        ]
    });
    if ((0, $3OncY.APP_UI_VARIANT) === (0, $8ni7a.AppUiVariant).Innogy && variant === 'animation') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 100 150",
        sx: {
            width: '1.7em',
            height: '1.7em',
            ...sx ?? {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.0071 127.89C13.3392 127.89 11.1716 128.89 9.67094 130.057C9.67094 128.89 9.17072 128.39 8.00353 128.39H7.50331C7.00309 128.39 6.66961 128.557 6.66961 129.057V142.896C6.66961 143.73 7.33657 144.064 8.17027 144.064C9.00398 144.064 9.67094 143.73 9.67094 142.896V134.059C9.67094 133.392 10.0044 132.725 10.5046 132.392C11.6718 131.558 13.3392 130.724 15.3401 130.724C18.3414 130.724 19.8421 132.392 19.8421 135.226V142.896C19.8421 143.73 20.5091 144.064 21.3428 144.064C22.1765 144.064 22.8434 143.73 22.8434 142.896V135.06C22.6767 130.224 20.3423 127.89 16.0071 127.89ZM2.00088 120.887C0.833702 120.887 0 121.72 0 122.888C0 124.055 0.833702 124.888 2.00088 124.888C3.16807 124.888 4.00177 124.055 4.00177 122.888C4.00177 121.72 3.16807 120.887 2.00088 120.887ZM2.00088 128.223C1.00044 128.223 0.500221 128.89 0.500221 129.891V142.563C0.500221 143.563 1.16718 144.23 2.00088 144.23C2.83458 144.23 3.50155 143.563 3.50155 142.563V129.891C3.50155 128.89 3.00133 128.223 2.00088 128.223ZM52.6899 127.89C47.6877 127.89 43.8527 131.391 43.8527 136.227C43.8527 141.062 47.6877 144.564 52.6899 144.564C57.6921 144.564 61.5272 141.062 61.5272 136.227C61.5272 131.391 57.6921 127.89 52.6899 127.89ZM52.6899 141.729C49.1884 141.729 46.6873 139.395 46.6873 136.227C46.6873 132.892 49.0216 130.558 52.6899 130.558C56.1915 130.558 58.5258 132.892 58.5258 136.227C58.5258 139.395 56.1915 141.729 52.6899 141.729ZM34.8487 127.89C32.1809 127.89 30.0133 128.89 28.5126 130.057C28.5126 128.89 28.0124 128.39 26.8452 128.39H26.345C25.8447 128.39 25.678 128.557 25.678 129.057V142.896C25.678 143.73 26.345 144.064 27.1787 144.064C28.0124 144.064 28.6793 143.73 28.6793 142.896V134.059C28.6793 133.392 29.0128 132.725 29.513 132.392C30.6802 131.558 32.3476 130.724 34.3485 130.724C37.3498 130.724 38.8505 132.392 38.8505 135.226V142.896C38.8505 143.73 39.5174 144.064 40.3512 144.064C41.1849 144.064 41.8518 143.73 41.8518 142.896V135.06C41.5183 130.224 39.184 127.89 34.8487 127.89ZM98.7103 128.39C97.5431 128.39 96.8761 128.724 96.5426 129.557L91.5404 140.562L86.3715 129.557C86.038 128.724 85.0375 128.39 84.0371 128.39C83.0367 128.39 82.5364 128.89 82.8699 129.557L89.5395 143.23C89.7063 143.563 89.7063 143.897 89.5395 144.23C88.7058 145.731 87.7054 147.065 86.2047 147.065C85.5378 147.065 85.0375 146.731 84.7041 146.565C84.5373 146.398 84.3706 146.231 84.0371 146.231C83.5369 146.231 82.7032 146.898 82.7032 147.899C82.7032 148.732 84.0371 149.9 86.2047 149.9C89.5395 149.9 91.3737 146.898 93.0411 143.563L99.8774 129.557C100.211 128.89 99.8774 128.39 98.7103 128.39ZM79.3684 128.39H79.0349C78.3679 128.39 77.5342 128.724 77.3675 129.891C76.0336 128.724 74.0327 127.89 72.0318 127.89C67.1963 127.89 63.8615 131.558 63.8615 136.06C63.8615 140.395 67.1963 143.897 72.0318 143.897C74.0327 143.897 75.8668 143.23 77.3675 142.063C77.3675 145.064 75.8668 147.232 72.0318 147.232C69.5307 147.232 67.8633 146.064 67.1963 145.398C67.0296 145.231 66.8629 145.064 66.5294 145.064C66.0292 145.064 65.1954 145.731 65.1954 146.898C65.1954 148.232 68.1968 149.9 71.8651 149.9C77.701 149.9 80.2021 146.565 80.2021 140.896V129.057C80.2021 128.557 79.8686 128.39 79.3684 128.39ZM77.2008 138.228C77.2008 138.728 77.034 139.228 76.5338 139.728C75.5334 140.729 73.6992 141.396 72.1985 141.396C68.8637 141.396 66.6961 139.228 66.6961 136.06C66.6961 132.892 68.8637 130.558 72.1985 130.558C73.8659 130.558 75.7001 131.225 76.7005 132.392C77.034 132.892 77.2008 133.225 77.2008 133.726V138.228Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M58.5237 32.6812C60.3579 32.0142 61.3583 31.8475 61.8585 32.0142C62.0253 32.0142 62.0253 32.0142 62.192 32.1809V32.5144C62.0253 33.5149 60.8581 36.5162 53.855 42.8523L52.5211 44.0195C53.855 44.353 55.0222 44.8532 56.0226 45.5202L56.1894 45.3534C65.5268 36.6829 65.6936 33.3481 65.6936 32.1809C65.6936 31.0138 65.3601 30.0133 64.5264 29.3464C62.192 27.012 57.5233 29.0129 50.02 32.3477C47.1854 33.6816 44.1841 35.0155 41.8497 35.6825C38.6816 36.6829 38.1814 36.1827 38.0147 36.1827C37.5144 35.8492 38.0147 34.5153 39.0151 32.6812C40.349 30.5135 42.3499 27.8457 44.6843 25.3446L45.8515 24.0107C44.6843 23.5104 43.6838 23.0102 42.6834 22.3433L41.8497 23.3437C37.3477 28.6794 31.6785 35.5157 35.6803 39.0173C38.5149 41.5184 44.5175 38.8506 51.3539 35.8492C54.0217 34.5153 56.5228 33.5149 58.5237 32.6812Z",
                fill: "#FFD700"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M50.0192 106.214C44.0165 106.214 39.0143 101.378 39.0143 95.2087V54.6908C39.0143 48.6882 43.8498 43.686 50.0192 43.686C56.1886 43.686 61.0241 48.5214 61.0241 54.6908V95.3755C61.0241 101.378 56.0218 106.214 50.0192 106.214ZM50.0192 46.854C45.6839 46.854 42.1824 50.3556 42.1824 54.6908V95.3755C42.1824 99.7107 45.6839 103.212 50.0192 103.212C54.3544 103.212 57.856 99.7107 57.856 95.3755V54.6908C57.856 50.3556 54.3544 46.854 50.0192 46.854ZM50.0192 25.011C43.1828 25.011 37.5137 19.3419 37.5137 12.5055C37.5137 5.66917 43.1828 0 50.0192 0C56.8555 0 62.5247 5.66917 62.5247 12.5055C62.5247 19.3419 56.8555 25.011 50.0192 25.011ZM50.0192 3.16807C44.8502 3.16807 40.6817 7.33657 40.6817 12.5055C40.6817 17.6745 44.8502 21.843 50.0192 21.843C55.1881 21.843 59.3566 17.6745 59.3566 12.5055C59.3566 7.33657 55.1881 3.16807 50.0192 3.16807Z",
                fill: "white"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 13 21",
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4 0H9V4H4V0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.33333 4V8.437V16.563H8.66667V8.437V4H13V21H9.53674e-07V4H4.33333Z",
                fill: "currentColor"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $a15bdaf959620886$export$62b5013c502ceb63 = ({ whiteBg: whiteBg = false, ...props })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 27 27",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.3964 14.6505C12.6145 14.8762 12.9035 15.0003 13.2143 15.0003H13.2197C13.5251 15.0003 13.8195 14.8762 14.0376 14.6505C14.4084 14.2669 14.4847 13.6689 14.2176 13.195L13.6887 12.2584C13.4924 11.9143 12.9417 11.9143 12.7454 12.2584L12.2165 13.195C11.9493 13.6632 12.0256 14.2669 12.3964 14.6505ZM13.2634 13.8494H13.1761V13.855H13.1652C13.1434 13.8268 13.138 13.793 13.1543 13.7648L13.2143 13.6576L13.2743 13.7648C13.2906 13.793 13.2852 13.8268 13.2634 13.8494Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 7.24999C8 7.85442 8.40764 8.3591 8.94872 8.47497V10.0001C8.68785 10.0001 8.47434 10.2251 8.47434 10.5001C8.47434 10.7751 8.68777 11.0001 8.94864 11.0001L8.94872 13C8.68785 13 8.47434 13.225 8.47434 13.5C8.47434 13.775 8.68777 14 8.94864 14L8.94872 16.0003C8.68785 16.0003 8.47424 16.2253 8.47424 16.5002C8.47424 16.7752 8.68768 17.0002 8.94855 17.0002L8.94872 18.5246C8.40764 18.6405 8 19.1452 8 19.7496C8 20.4396 8.53122 20.9996 9.18576 20.9996H17.249C17.9035 20.9996 18.4347 20.4396 18.4347 19.7496C18.4347 19.1453 18.0272 18.6407 17.4862 18.5247V17.0002C17.747 17.0001 17.9604 16.7752 17.9604 16.5002C17.9604 16.2253 17.747 16.0003 17.4862 16.0003V14C17.747 13.9999 17.9604 13.7749 17.9604 13.5C17.9604 13.225 17.747 13.0001 17.4862 13V11.0001C17.747 11 17.9604 10.775 17.9604 10.5001C17.9604 10.2251 17.747 10.0001 17.4862 10.0001V8.47492C18.0272 8.35896 18.4347 7.85434 18.4347 7.24999C18.4347 6.56 17.9035 6 17.249 6H9.18576C8.53122 6 8 6.56 8 7.24999ZM15.5888 16.0003H16.5376V14H15.5889C15.328 14 15.1146 13.775 15.1146 13.5C15.1146 13.225 15.328 13 15.5889 13H16.5376V11.0001H15.5889C15.328 11.0001 15.1146 10.7751 15.1146 10.5001C15.1146 10.2251 15.328 10.0001 15.5889 10.0001H16.5376V8.49999H9.89733V10.0001H10.8459C11.1067 10.0001 11.3202 10.2251 11.3202 10.5001C11.3202 10.7751 11.1067 11.0001 10.8459 11.0001H9.89733V13H10.8459C11.1067 13 11.3202 13.225 11.3202 13.5C11.3202 13.775 11.1067 14 10.8459 14H9.89733V16.0003H10.8458C11.1066 16.0003 11.3201 16.2253 11.3201 16.5002C11.3201 16.7752 11.1066 17.0002 10.8458 17.0002H9.89733V18.4996H16.5376V17.0002H15.5888C15.328 17.0002 15.1145 16.7752 15.1145 16.5002C15.1145 16.2253 15.328 16.0003 15.5888 16.0003ZM9.18576 7.49999H9.40482C9.41086 7.49975 9.41693 7.49963 9.42303 7.49963H17.0119C17.018 7.49963 17.0241 7.49975 17.0301 7.49999H17.249C17.3818 7.49999 17.4861 7.38999 17.4861 7.24999C17.4861 7.10999 17.3818 6.99999 17.249 6.99999H9.18576C9.05296 6.99999 8.94861 7.10999 8.94861 7.24999C8.94861 7.38999 9.05296 7.49999 9.18576 7.49999ZM8.94861 19.7496C8.94861 19.6096 9.05296 19.4996 9.18576 19.4996H17.249C17.3818 19.4996 17.4861 19.6096 17.4861 19.7496C17.4861 19.8896 17.3818 19.9996 17.249 19.9996H9.18576C9.05296 19.9996 8.94861 19.8896 8.94861 19.7496Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.3964 14.6505C12.6145 14.8762 12.9035 15.0003 13.2143 15.0003H13.2197C13.5251 15.0003 13.8195 14.8762 14.0376 14.6505C14.4084 14.2669 14.4847 13.6689 14.2176 13.195L13.6887 12.2584C13.4924 11.9143 12.9417 11.9143 12.7454 12.2584L12.2165 13.195C11.9493 13.6632 12.0256 14.2669 12.3964 14.6505ZM13.2634 13.8494H13.1761V13.855H13.1652C13.1434 13.8268 13.138 13.793 13.1543 13.7648L13.2143 13.6576L13.2743 13.7648C13.2906 13.793 13.2852 13.8268 13.2634 13.8494Z",
                stroke: whiteBg ? 'white' : 'transparent',
                strokeWidth: "0.326085"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 7.24999C8 7.85442 8.40764 8.3591 8.94872 8.47497V10.0001C8.68785 10.0001 8.47434 10.2251 8.47434 10.5001C8.47434 10.7751 8.68777 11.0001 8.94864 11.0001L8.94872 13C8.68785 13 8.47434 13.225 8.47434 13.5C8.47434 13.775 8.68777 14 8.94864 14L8.94872 16.0003C8.68785 16.0003 8.47424 16.2253 8.47424 16.5002C8.47424 16.7752 8.68768 17.0002 8.94855 17.0002L8.94872 18.5246C8.40764 18.6405 8 19.1452 8 19.7496C8 20.4396 8.53122 20.9996 9.18576 20.9996H17.249C17.9035 20.9996 18.4347 20.4396 18.4347 19.7496C18.4347 19.1453 18.0272 18.6407 17.4862 18.5247V17.0002C17.747 17.0001 17.9604 16.7752 17.9604 16.5002C17.9604 16.2253 17.747 16.0003 17.4862 16.0003V14C17.747 13.9999 17.9604 13.7749 17.9604 13.5C17.9604 13.225 17.747 13.0001 17.4862 13V11.0001C17.747 11 17.9604 10.775 17.9604 10.5001C17.9604 10.2251 17.747 10.0001 17.4862 10.0001V8.47492C18.0272 8.35896 18.4347 7.85434 18.4347 7.24999C18.4347 6.56 17.9035 6 17.249 6H9.18576C8.53122 6 8 6.56 8 7.24999ZM15.5888 16.0003H16.5376V14H15.5889C15.328 14 15.1146 13.775 15.1146 13.5C15.1146 13.225 15.328 13 15.5889 13H16.5376V11.0001H15.5889C15.328 11.0001 15.1146 10.7751 15.1146 10.5001C15.1146 10.2251 15.328 10.0001 15.5889 10.0001H16.5376V8.49999H9.89733V10.0001H10.8459C11.1067 10.0001 11.3202 10.2251 11.3202 10.5001C11.3202 10.7751 11.1067 11.0001 10.8459 11.0001H9.89733V13H10.8459C11.1067 13 11.3202 13.225 11.3202 13.5C11.3202 13.775 11.1067 14 10.8459 14H9.89733V16.0003H10.8458C11.1066 16.0003 11.3201 16.2253 11.3201 16.5002C11.3201 16.7752 11.1066 17.0002 10.8458 17.0002H9.89733V18.4996H16.5376V17.0002H15.5888C15.328 17.0002 15.1145 16.7752 15.1145 16.5002C15.1145 16.2253 15.328 16.0003 15.5888 16.0003ZM9.18576 7.49999H9.40482C9.41086 7.49975 9.41693 7.49963 9.42303 7.49963H17.0119C17.018 7.49963 17.0241 7.49975 17.0301 7.49999H17.249C17.3818 7.49999 17.4861 7.38999 17.4861 7.24999C17.4861 7.10999 17.3818 6.99999 17.249 6.99999H9.18576C9.05296 6.99999 8.94861 7.10999 8.94861 7.24999C8.94861 7.38999 9.05296 7.49999 9.18576 7.49999ZM8.94861 19.7496C8.94861 19.6096 9.05296 19.4996 9.18576 19.4996H17.249C17.3818 19.4996 17.4861 19.6096 17.4861 19.7496C17.4861 19.8896 17.3818 19.9996 17.249 19.9996H9.18576C9.05296 19.9996 8.94861 19.8896 8.94861 19.7496Z",
                stroke: whiteBg ? 'white' : 'transparent',
                strokeWidth: "0.326085"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $cf30d0b933cf609b$export$891c98057d1a9092 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 23 22",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.352 4.18909L7.53655 11.6256L10.5517 11.5859L9.77888 17.171L14.5944 9.73446L11.5792 9.7741L12.352 4.18909Z",
            stroke: "currentColor",
            strokeWidth: "0.6089",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $9982445a7b6402af$export$ffbcb0c0cfcdbf71 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 27 25",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.49571 6.30819C6.54819 6.12346 6.71276 6 6.88282 6H20.1129C20.287 6 20.4475 6.11948 20.4993 6.30585L22.9816 14.9749L22.9819 14.9758C23.0212 15.117 22.9944 15.2622 22.9215 15.3642C22.8434 15.4735 22.7236 15.5366 22.5949 15.5366H13.9087V18.131H15.1561C15.3754 18.131 15.5632 18.3174 15.5632 18.5653C15.5632 18.8131 15.3754 18.9995 15.1561 18.9995H13.5222L13.5153 18.9998L13.5016 19L13.488 18.9998L13.481 18.9995H11.8467C11.6275 18.9995 11.4396 18.8131 11.4396 18.5653C11.4396 18.3174 11.6275 18.131 11.8467 18.131H13.0945V15.5366H4.40818C4.28483 15.5366 4.15851 15.4718 4.08157 15.3642C4.00332 15.2548 3.97943 15.112 4.01834 14.9859L6.49571 6.30819ZM9.86871 6.86855H7.18932L6.19709 10.3304H9.13764L9.86871 6.86855ZM13.0945 6.86855H10.6025L10.6029 7.30236C10.603 7.33287 10.6 7.364 10.5935 7.3954L10.5933 7.39641L9.97096 10.3304H13.0945V6.86855ZM16.4014 6.86855H13.9087V10.3304H17.0329L16.4105 7.39641L16.4103 7.3954C16.4039 7.364 16.4008 7.33288 16.4009 7.30236L16.4014 6.86855ZM19.8064 6.86855H17.1348L17.8691 10.3304H20.7986L19.8064 6.86855ZM8.95423 11.1989H5.94815L4.95383 14.6681H8.22162L8.95423 11.1989ZM13.0945 11.1989H9.78672L9.05083 14.6681H13.0945V11.1989ZM17.2171 11.1989H13.9087V14.6681H17.953L17.2171 11.1989ZM21.0476 11.1989H18.0534L18.7893 14.6681H22.0419L21.0476 11.1989Z",
            fill: "currentColor"
        })
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $e906332a228bb47a$export$bac3506438e44f8d = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 15 19",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.6617 18.0023V7.37598",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M7.10411 18.0021V1",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M0.546438 18.0011V11.626",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $2496ca0e50773979$export$9cdbc5cab505edcf = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13.3 16H15.7C17.7 16 18.5 15.2 18.5 13.2V10.8C18.5 8.8 17.7 8 15.7 8H13.3C11.3 8 10.5 8.8 10.5 10.8V13.2C10.5 15.2 11.3 16 13.3 16Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17 20H7C3 20 2 19 2 15V9C2 5 3 4 7 4H17C21 4 22 5 22 9V15C22 19 21 20 17 20Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
const $2496ca0e50773979$export$f4abe450ecb60056 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.0553 8.73332H14.2639V5.93333H9.4028V8.73332H9.61196L9.61698 8.73332H14.0503L14.0553 8.73332ZM8.43058 8.9576V5.46667C8.43058 5.21 8.64933 5 8.91669 5H14.75C15.0174 5 15.2361 5.21 15.2361 5.46667V8.95737C16.3131 9.38229 17.0911 10.3678 17.1736 11.5331H17.1809C17.4482 11.5331 17.667 11.7431 17.667 11.9997C17.667 12.2564 17.4482 12.4664 17.1809 12.4664H17.1809V13.8669H17.1809C17.4482 13.8669 17.667 14.0769 17.667 14.3336C17.667 14.5902 17.4482 14.8002 17.1809 14.8002H17.1736C17.1041 15.7817 16.5412 16.6357 15.7218 17.1345V18.5333C15.7218 18.79 15.5031 19 15.2357 19H8.43016C8.1628 19 7.94405 18.79 7.94405 18.5333V17.1337C7.12543 16.6347 6.5631 15.7811 6.49369 14.8002H6.48611C6.21875 14.8002 6 14.5902 6 14.3336C6 14.0769 6.21875 13.8669 6.48611 13.8669H6.48644V12.4664H6.48611C6.21875 12.4664 6 12.2564 6 11.9997C6 11.7431 6.21875 11.5331 6.48611 11.5331H6.49369C6.57613 10.368 7.35391 9.38265 8.43058 8.9576ZM16.2086 13.8669H14.7503C14.483 13.8669 14.2642 14.0769 14.2642 14.3336C14.2642 14.5902 14.483 14.8002 14.7503 14.8002H16.1981C16.0904 15.8472 15.169 16.6666 14.0503 16.6666H9.61698C8.49828 16.6666 7.57687 15.8472 7.46917 14.8002H8.91666C9.18402 14.8002 9.40277 14.5902 9.40277 14.3336C9.40277 14.0769 9.18402 13.8669 8.91666 13.8669H7.45866V12.4664H8.91666C9.18402 12.4664 9.40277 12.2564 9.40277 11.9997C9.40277 11.7431 9.18402 11.5331 8.91666 11.5331H7.46917C7.57673 10.4873 8.49598 9.66869 9.6128 9.66666H14.0545C15.1713 9.66869 16.0906 10.4873 16.1981 11.5331H14.7503C14.483 11.5331 14.2642 11.7431 14.2642 11.9997C14.2642 12.2564 14.483 12.4664 14.7503 12.4664H16.2086V13.8669ZM14.0503 17.6H9.61698C9.37619 17.6 9.14163 17.5737 8.91627 17.524V18.0667H14.7496V17.5243C14.5247 17.5738 14.2906 17.6 14.0503 17.6ZM12.8059 7.80039H10.8614C10.5941 7.80039 10.3753 7.59039 10.3753 7.33373C10.3753 7.07706 10.5941 6.86706 10.8614 6.86706H12.8059C13.0732 6.86706 13.292 7.07706 13.292 7.33373C13.292 7.59039 13.0732 7.80039 12.8059 7.80039ZM10.6906 14.6922C11.0059 14.995 11.4181 15.1443 11.8305 15.1449L11.8281 15.1449H11.8329L11.8305 15.1449C12.2429 15.1443 12.6551 14.995 12.9704 14.6922C13.5197 14.1649 13.6024 13.3389 13.1649 12.7229C13.0336 12.5316 12.776 12.4662 12.5621 12.5596C12.4892 12.5922 12.426 12.5689 12.3968 12.5502C12.3677 12.5316 12.319 12.4896 12.319 12.4102V11.5282C12.319 11.3229 12.1732 11.1362 11.9642 11.0802C11.7552 11.0242 11.5315 11.1082 11.4197 11.2856L10.4961 12.7229C10.0635 13.3389 10.1413 14.1649 10.6906 14.6922ZM11.4901 12.9556L11.3128 13.2316C11.1281 13.4929 11.1621 13.8242 11.376 14.0342C11.619 14.2676 12.042 14.2676 12.285 14.0342C12.4309 13.8942 12.494 13.6982 12.4649 13.5116C12.2559 13.5116 12.0517 13.4509 11.867 13.3389C11.7079 13.2418 11.5776 13.1079 11.4901 12.9556Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14.2639 8.73332V8.91562H14.4462V8.73332H14.2639ZM14.0553 8.73332L14.0552 8.91562H14.0553V8.73332ZM14.2639 5.93333H14.4462V5.75104H14.2639V5.93333ZM9.4028 5.93333V5.75104H9.22051V5.93333H9.4028ZM9.4028 8.73332H9.22051V8.91562H9.4028V8.73332ZM9.61196 8.73332V8.91562H9.6121L9.61196 8.73332ZM9.61698 8.73332V8.55103H9.61685L9.61698 8.73332ZM14.0503 8.73332L14.0504 8.55103H14.0503V8.73332ZM8.43058 8.9576L8.49752 9.12716L8.61287 9.08162V8.9576H8.43058ZM15.2361 8.95737H15.0538V9.08141L15.1692 9.12694L15.2361 8.95737ZM17.1736 11.5331L16.9918 11.5459L17.0038 11.7154H17.1736V11.5331ZM17.1809 12.4664V12.2841H16.9986V12.4664H17.1809ZM17.1809 13.8669H16.9986V14.0492H17.1809V13.8669ZM17.1736 14.8002V14.6179H17.0038L16.9918 14.7874L17.1736 14.8002ZM15.7218 17.1345L15.627 16.9788L15.5395 17.0321V17.1345H15.7218ZM7.94405 17.1337H8.12635V17.0313L8.03893 16.978L7.94405 17.1337ZM6.49369 14.8002L6.67552 14.7874L6.66353 14.6179H6.49369V14.8002ZM6.48644 13.8669V14.0492H6.66873V13.8669H6.48644ZM6.48644 12.4664H6.66873V12.2841H6.48644V12.4664ZM6.49369 11.5331V11.7154H6.66353L6.67552 11.5459L6.49369 11.5331ZM16.2086 13.8669V14.0492H16.3909V13.8669H16.2086ZM16.1981 14.8002L16.3795 14.8189L16.4001 14.6179H16.1981V14.8002ZM7.46917 14.8002V14.6179H7.26717L7.28784 14.8189L7.46917 14.8002ZM7.45866 13.8669H7.27636V14.0492H7.45866V13.8669ZM7.45866 12.4664V12.2841H7.27636V12.4664H7.45866ZM7.46917 11.5331L7.28784 11.5144L7.26717 11.7154H7.46917V11.5331ZM9.6128 9.66666V9.48436L9.61247 9.48436L9.6128 9.66666ZM14.0545 9.66666L14.0548 9.48436H14.0545V9.66666ZM16.1981 11.5331V11.7154H16.4001L16.3795 11.5144L16.1981 11.5331ZM16.2086 12.4664H16.3909V12.2841H16.2086V12.4664ZM8.91627 17.524L8.95553 17.346L8.73398 17.2971V17.524H8.91627ZM8.91627 18.0667H8.73398V18.249H8.91627V18.0667ZM14.7496 18.0667V18.249H14.9319V18.0667H14.7496ZM14.7496 17.5243H14.9319V17.2976L14.7104 17.3463L14.7496 17.5243ZM10.6906 14.6922L10.5643 14.8237V14.8237L10.6906 14.6922ZM11.8281 15.1449L11.8279 14.9626L11.8281 15.3272V15.1449ZM11.8329 15.1449V15.3272L11.8331 14.9626L11.8329 15.1449ZM12.9704 14.6922L13.0967 14.8237V14.8237L12.9704 14.6922ZM13.1649 12.7229L13.0145 12.826L13.0163 12.8285L13.1649 12.7229ZM12.5621 12.5596L12.4892 12.3925L12.4876 12.3932L12.5621 12.5596ZM12.3968 12.5502L12.4951 12.3967L12.4951 12.3967L12.3968 12.5502ZM11.4197 11.2856L11.5731 11.3841L11.5739 11.3828L11.4197 11.2856ZM10.4961 12.7229L10.6454 12.8278L10.6495 12.8215L10.4961 12.7229ZM11.3128 13.2316L11.4618 13.3369L11.4662 13.3301L11.3128 13.2316ZM11.4901 12.9556L11.6482 12.8648L11.4988 12.6047L11.3367 12.8571L11.4901 12.9556ZM11.376 14.0342L11.2483 14.1643L11.2498 14.1657L11.376 14.0342ZM12.285 14.0342L12.1588 13.9027V13.9027L12.285 14.0342ZM12.4649 13.5116L12.645 13.4834L12.6209 13.3293H12.4649V13.5116ZM11.867 13.3389L11.7719 13.4945L11.7725 13.4948L11.867 13.3389ZM14.2639 8.55103H14.0553V8.91562H14.2639V8.55103ZM14.0816 5.93333V8.73332H14.4462V5.93333H14.0816ZM9.4028 6.11562H14.2639V5.75104H9.4028V6.11562ZM9.58509 8.73332V5.93333H9.22051V8.73332H9.58509ZM9.61196 8.55103H9.4028V8.91562H9.61196V8.55103ZM9.61685 8.55103L9.61182 8.55103L9.6121 8.91562L9.61712 8.91561L9.61685 8.55103ZM14.0503 8.55103H9.61698V8.91561H14.0503V8.55103ZM14.0555 8.55103L14.0504 8.55103L14.0502 8.91561L14.0552 8.91562L14.0555 8.55103ZM8.24829 5.46667V8.9576H8.61287V5.46667H8.24829ZM8.91669 4.81771C8.55574 4.81771 8.24829 5.10238 8.24829 5.46667H8.61287C8.61287 5.31762 8.74292 5.18229 8.91669 5.18229V4.81771ZM14.75 4.81771H8.91669V5.18229H14.75V4.81771ZM15.4184 5.46667C15.4184 5.10238 15.111 4.81771 14.75 4.81771V5.18229C14.9238 5.18229 15.0538 5.31762 15.0538 5.46667H15.4184ZM15.4184 8.95737V5.46667H15.0538V8.95737H15.4184ZM17.3554 11.5202C17.2677 10.2797 16.4402 9.23648 15.303 8.7878L15.1692 9.12694C16.186 9.5281 16.9146 10.4559 16.9918 11.5459L17.3554 11.5202ZM17.1809 11.3508H17.1736V11.7154H17.1809V11.3508ZM17.8493 11.9997C17.8493 11.6354 17.5418 11.3508 17.1809 11.3508V11.7154C17.3546 11.7154 17.4847 11.8507 17.4847 11.9997H17.8493ZM17.1809 12.6487C17.5418 12.6487 17.8493 12.364 17.8493 11.9997H17.4847C17.4847 12.1488 17.3546 12.2841 17.1809 12.2841V12.6487ZM17.1809 12.6487H17.1809V12.2841H17.1809V12.6487ZM17.3631 13.8669V12.4664H16.9986V13.8669H17.3631ZM17.1809 14.0492H17.1809V13.6846H17.1809V14.0492ZM17.1809 14.0492C17.3546 14.0492 17.4847 14.1845 17.4847 14.3336H17.8493C17.8493 13.9693 17.5418 13.6846 17.1809 13.6846V14.0492ZM17.4847 14.3336C17.4847 14.4826 17.3546 14.6179 17.1809 14.6179V14.9825C17.5418 14.9825 17.8493 14.6978 17.8493 14.3336H17.4847ZM17.1809 14.6179H17.1736V14.9825H17.1809V14.6179ZM15.8166 17.2902C16.6826 16.763 17.2815 15.8579 17.3554 14.8131L16.9918 14.7874C16.9268 15.7056 16.3998 16.5083 15.627 16.9788L15.8166 17.2902ZM15.9041 18.5333V17.1345H15.5395V18.5333H15.9041ZM15.2357 19.1823C15.5967 19.1823 15.9041 18.8976 15.9041 18.5333H15.5395C15.5395 18.6824 15.4095 18.8177 15.2357 18.8177V19.1823ZM8.43016 19.1823H15.2357V18.8177H8.43016V19.1823ZM7.76176 18.5333C7.76176 18.8976 8.06921 19.1823 8.43016 19.1823V18.8177C8.25639 18.8177 8.12635 18.6824 8.12635 18.5333H7.76176ZM7.76176 17.1337V18.5333H8.12635V17.1337H7.76176ZM6.31185 14.8131C6.38574 15.8572 6.98402 16.762 7.84918 17.2893L8.03893 16.978C7.26684 16.5074 6.74047 15.705 6.67552 14.7874L6.31185 14.8131ZM6.48611 14.9825H6.49369V14.6179H6.48611V14.9825ZM5.81771 14.3336C5.81771 14.6978 6.12516 14.9825 6.48611 14.9825V14.6179C6.31234 14.6179 6.18229 14.4826 6.18229 14.3336H5.81771ZM6.48611 13.6846C6.12516 13.6846 5.81771 13.9693 5.81771 14.3336H6.18229C6.18229 14.1845 6.31234 14.0492 6.48611 14.0492V13.6846ZM6.48644 13.6846H6.48611V14.0492H6.48644V13.6846ZM6.30415 12.4664V13.8669H6.66873V12.4664H6.30415ZM6.48611 12.6487H6.48644V12.2841H6.48611V12.6487ZM5.81771 11.9997C5.81771 12.364 6.12516 12.6487 6.48611 12.6487V12.2841C6.31234 12.2841 6.18229 12.1488 6.18229 11.9997H5.81771ZM6.48611 11.3508C6.12516 11.3508 5.81771 11.6354 5.81771 11.9997H6.18229C6.18229 11.8507 6.31234 11.7154 6.48611 11.7154V11.3508ZM6.49369 11.3508H6.48611V11.7154H6.49369V11.3508ZM8.36364 8.78805C7.22677 9.23687 6.39962 10.2799 6.31185 11.5202L6.67552 11.5459C6.75264 10.4561 7.48106 9.52844 8.49752 9.12716L8.36364 8.78805ZM14.7503 14.0492H16.2086V13.6846H14.7503V14.0492ZM14.4465 14.3336C14.4465 14.1845 14.5765 14.0492 14.7503 14.0492V13.6846C14.3894 13.6846 14.0819 13.9693 14.0819 14.3336H14.4465ZM14.7503 14.6179C14.5765 14.6179 14.4465 14.4826 14.4465 14.3336H14.0819C14.0819 14.6978 14.3894 14.9825 14.7503 14.9825V14.6179ZM16.1981 14.6179H14.7503V14.9825H16.1981V14.6179ZM14.0503 16.8489C15.2574 16.8489 16.2617 15.9638 16.3795 14.8189L16.0168 14.7816C15.9192 15.7307 15.0806 16.4843 14.0503 16.4843V16.8489ZM9.61698 16.8489H14.0503V16.4843H9.61698V16.8489ZM7.28784 14.8189C7.4056 15.9638 8.40986 16.8489 9.61698 16.8489V16.4843C8.58669 16.4843 7.74813 15.7307 7.65051 14.7816L7.28784 14.8189ZM8.91666 14.6179H7.46917V14.9825H8.91666V14.6179ZM9.22048 14.3336C9.22048 14.4826 9.09043 14.6179 8.91666 14.6179V14.9825C9.27761 14.9825 9.58506 14.6978 9.58506 14.3336H9.22048ZM8.91666 14.0492C9.09043 14.0492 9.22048 14.1845 9.22048 14.3336H9.58506C9.58506 13.9693 9.27761 13.6846 8.91666 13.6846V14.0492ZM7.45866 14.0492H8.91666V13.6846H7.45866V14.0492ZM7.27636 12.4664V13.8669H7.64095V12.4664H7.27636ZM8.91666 12.2841H7.45866V12.6487H8.91666V12.2841ZM9.22048 11.9997C9.22048 12.1488 9.09043 12.2841 8.91666 12.2841V12.6487C9.27761 12.6487 9.58506 12.364 9.58506 11.9997H9.22048ZM8.91666 11.7154C9.09043 11.7154 9.22048 11.8507 9.22048 11.9997H9.58506C9.58506 11.6354 9.27761 11.3508 8.91666 11.3508V11.7154ZM7.46917 11.7154H8.91666V11.3508H7.46917V11.7154ZM9.61247 9.48436C8.40737 9.48656 7.40545 10.3709 7.28784 11.5144L7.65051 11.5517C7.74801 10.6038 8.58459 9.85082 9.61314 9.84895L9.61247 9.48436ZM14.0545 9.48436H9.6128V9.84895H14.0545V9.48436ZM16.3795 11.5144C16.2618 10.3709 15.2599 9.48656 14.0548 9.48436L14.0542 9.84895C15.0827 9.85082 15.9193 10.6038 16.0168 11.5517L16.3795 11.5144ZM14.7503 11.7154H16.1981V11.3508H14.7503V11.7154ZM14.4465 11.9997C14.4465 11.8507 14.5765 11.7154 14.7503 11.7154V11.3508C14.3894 11.3508 14.0819 11.6354 14.0819 11.9997H14.4465ZM14.7503 12.2841C14.5766 12.2841 14.4465 12.1488 14.4465 11.9997H14.0819C14.0819 12.364 14.3894 12.6487 14.7503 12.6487V12.2841ZM16.2086 12.2841H14.7503V12.6487H16.2086V12.2841ZM16.3909 13.8669V12.4664H16.0263V13.8669H16.3909ZM9.61698 17.7823H14.0503V17.4177H9.61698V17.7823ZM8.87702 17.702C9.11519 17.7545 9.3629 17.7823 9.61698 17.7823V17.4177C9.38947 17.4177 9.16808 17.3929 8.95553 17.346L8.87702 17.702ZM9.09856 18.0667V17.524H8.73398V18.0667H9.09856ZM14.7496 17.8844H8.91627V18.249H14.7496V17.8844ZM14.5673 17.5243V18.0667H14.9319V17.5243H14.5673ZM14.0503 17.7823C14.3039 17.7823 14.5511 17.7547 14.7888 17.7024L14.7104 17.3463C14.4983 17.393 14.2773 17.4177 14.0503 17.4177V17.7823ZM10.8614 7.98268H12.8059V7.6181H10.8614V7.98268ZM10.193 7.33373C10.193 7.69801 10.5005 7.98268 10.8614 7.98268V7.6181C10.6876 7.6181 10.5576 7.48277 10.5576 7.33373H10.193ZM10.8614 6.68477C10.5005 6.68477 10.193 6.96944 10.193 7.33373H10.5576C10.5576 7.18468 10.6876 7.04935 10.8614 7.04935V6.68477ZM12.8059 6.68477H10.8614V7.04935H12.8059V6.68477ZM13.4743 7.33373C13.4743 6.96944 13.1668 6.68477 12.8059 6.68477V7.04935C12.9796 7.04935 13.1097 7.18468 13.1097 7.33373H13.4743ZM12.8059 7.98268C13.1668 7.98268 13.4743 7.69801 13.4743 7.33373H13.1097C13.1097 7.48277 12.9796 7.6181 12.8059 7.6181V7.98268ZM11.8308 14.9626C11.4618 14.9621 11.0958 14.8286 10.8168 14.5607L10.5643 14.8237C10.916 15.1614 11.3744 15.3265 11.8302 15.3272L11.8308 14.9626ZM11.8282 15.3272L11.8306 15.3272L11.8304 14.9626L11.8279 14.9626L11.8282 15.3272ZM11.8329 14.9626H11.8281V15.3272H11.8329V14.9626ZM11.8304 15.3272L11.8328 15.3272L11.8331 14.9626L11.8306 14.9626L11.8304 15.3272ZM12.8442 14.5607C12.5652 14.8286 12.1992 14.9621 11.8302 14.9626L11.8308 15.3272C12.2866 15.3265 12.745 15.1614 13.0967 14.8237L12.8442 14.5607ZM13.0163 12.8285C13.4006 13.3696 13.3294 14.0949 12.8442 14.5607L13.0967 14.8237C13.7101 14.2349 13.8042 13.3082 13.3135 12.6174L13.0163 12.8285ZM12.635 12.7267C12.7744 12.6658 12.9362 12.7117 13.0146 12.826L13.3152 12.6198C13.1311 12.3514 12.7776 12.2667 12.4892 12.3925L12.635 12.7267ZM12.2986 12.7038C12.3627 12.7448 12.4916 12.7909 12.6366 12.7259L12.4876 12.3932C12.4859 12.3939 12.4857 12.3938 12.4866 12.3937C12.4874 12.3936 12.4882 12.3936 12.4889 12.3937C12.4894 12.3938 12.4898 12.3939 12.4902 12.3941C12.4906 12.3942 12.4921 12.3948 12.4951 12.3967L12.2986 12.7038ZM12.1368 12.4102C12.1368 12.5783 12.2442 12.669 12.2986 12.7038L12.4951 12.3967C12.4945 12.3963 12.4943 12.3961 12.4944 12.3962C12.4945 12.3963 12.4955 12.3972 12.4967 12.399C12.4981 12.401 12.4995 12.4036 12.5004 12.4065C12.5014 12.4095 12.5013 12.4111 12.5013 12.4102H12.1368ZM12.1368 11.5282V12.4102H12.5013V11.5282H12.1368ZM11.917 11.2563C12.0503 11.292 12.1368 11.4095 12.1368 11.5282H12.5013C12.5013 11.2363 12.2961 10.9804 12.0114 10.9042L11.917 11.2563ZM11.5739 11.3828C11.6411 11.2763 11.7813 11.22 11.917 11.2563L12.0114 10.9042C11.729 10.8285 11.422 10.9402 11.2655 11.1884L11.5739 11.3828ZM10.6495 12.8215L11.5731 11.3841L11.2664 11.187L10.3428 12.6244L10.6495 12.8215ZM10.8168 14.5607C10.3323 14.0956 10.2644 13.37 10.6453 12.8277L10.347 12.6181C9.86255 13.3078 9.9502 14.2342 10.5643 14.8237L10.8168 14.5607ZM11.4662 13.3301L11.6435 13.0541L11.3367 12.8571L11.1594 13.133L11.4662 13.3301ZM11.5037 13.9042C11.3545 13.7577 11.3278 13.5262 11.4617 13.3368L11.1639 13.1264C10.9284 13.4596 10.9697 13.8908 11.2483 14.1643L11.5037 13.9042ZM12.1588 13.9027C11.9863 14.0683 11.6748 14.0683 11.5022 13.9027L11.2498 14.1657C11.5633 14.4668 12.0977 14.4668 12.4113 14.1657L12.1588 13.9027ZM12.2848 13.5397C12.3047 13.6674 12.2618 13.8038 12.1588 13.9027L12.4113 14.1657C12.5999 13.9847 12.6834 13.7291 12.645 13.4834L12.2848 13.5397ZM11.7725 13.4948C11.9833 13.6227 12.2199 13.6939 12.4649 13.6939V13.3293C12.2918 13.3293 12.12 13.2792 11.9615 13.183L11.7725 13.4948ZM11.332 13.0464C11.4352 13.2261 11.5876 13.3819 11.7719 13.4945L11.962 13.1833C11.8283 13.1016 11.7199 12.9898 11.6482 12.8648L11.332 13.0464Z",
                fill: "currentColor"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $5ca13d7071bdc09b$export$3c4a512d8d27eaad = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 16 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_273_35)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M7.81749 8.87106H7.41964V7.34417C7.41964 6.76353 7.12931 6.56998 6.95727 6.50547C6.78523 6.44095 6.44114 6.39794 6.05405 6.82805L3.96802 9.20439C3.62394 9.60224 3.72071 9.94632 3.77448 10.0646C3.82824 10.1936 4.02179 10.484 4.54867 10.484H4.94652V12.0108C4.94652 12.5915 5.23684 12.785 5.40888 12.8496C5.46265 12.8711 5.53792 12.8926 5.63469 12.8926C5.81749 12.8926 6.05405 12.8173 6.31211 12.527L8.39813 10.1506C8.75297 9.75278 8.6562 9.41944 8.59168 9.29041C8.53792 9.16138 8.34437 8.8603 7.81749 8.8603V8.87106ZM5.87125 11.6345V10.0323C5.87125 9.78503 5.66695 9.58073 5.41964 9.58073H4.87125L6.51641 7.72052V9.32267C6.51641 9.56998 6.72071 9.77428 6.96802 9.77428H7.51641L5.87125 11.6345Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M8.61258 1.9248H3.76312C3.52656 1.9248 3.33301 2.11835 3.33301 2.35491V4.37642C3.33301 4.61298 3.52656 4.80653 3.76312 4.80653H8.61258C8.84914 4.80653 9.04269 4.61298 9.04269 4.37642V2.35491C9.04269 2.11835 8.84914 1.9248 8.61258 1.9248ZM8.18247 3.94631H4.19322V2.78502H8.18247V3.94631Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M15.1828 3.93548L12.3333 1.94624L12.3656 0.473118C12.3656 0.354839 12.3226 0.236559 12.2366 0.139785C12.1505 0.0537634 12.0323 0 11.914 0H0.451613C0.333333 0 0.215054 0.0537634 0.129032 0.139785C0.0430108 0.225806 0 0.344086 0 0.462366L0.333333 14.7957C0.333333 15.043 0.537634 15.2473 0.784946 15.2473H4.98925C5.08602 17.8817 7.24731 20.0108 9.91398 20.0108C12.5806 20.0108 14.8602 17.7957 14.8602 15.0645V11.2688H15.086C15.2043 11.2688 15.3118 11.2258 15.3978 11.1398C15.4839 11.0538 15.5269 10.9462 15.5161 10.828L15.3656 4.29032C15.3656 4.15054 15.2903 4.02151 15.1828 3.94624V3.93548ZM14.5161 4.51613L14.6559 10.3979H14.129L13.2796 6.09678C13.2581 6.01075 13.2258 5.93548 13.1613 5.87097L12.2688 4.9785L12.3118 2.9785L14.5054 4.51613H14.5161ZM0.924731 0.913979H11.4516L11.1613 14.3333H1.23656L0.924731 0.913979ZM14.0108 15.0538C14.0108 17.3011 12.1828 19.1398 9.92473 19.1398C7.66667 19.1398 5.95699 17.4086 5.86022 15.2366H11.6022C11.8495 15.2366 12.0538 15.043 12.0538 14.7849L12.2473 6.15054L12.4624 6.37634L13.3548 10.9032C13.3979 11.1075 13.5699 11.2473 13.7742 11.2473H14V15.043L14.0108 15.0538Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_273_35",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "15.5269",
                        height: "20",
                        fill: "currentColor"
                    })
                })
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $c9756d985d035402$export$de16a60c2b9aa29e = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 15H18.5C20.43 15 22 16.57 22 18.5C22 20.43 20.43 22 18.5 22C16.57 22 15 20.43 15 18.5V18",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 12H18.5C20.42 12 22 10.43 22 8.5C22 6.58 20.42 5 18.5 5C16.58 5 15 6.57 15 8.5V9",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 9H9.31C10.8 9 12 7.79 12 6.31C12 4.82 10.79 3.62 9.31 3.62C7.82 3.62 6.62 4.83 6.62 6.31V6.69",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
$c9756d985d035402$export$de16a60c2b9aa29e.displayName = 'Wind';



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $9748beca3fc4505a$export$a72d32054f236c4 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z"
        })
    }));
$9748beca3fc4505a$export$a72d32054f236c4.displayName = 'Thermometer';



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $a39572a94ed76787$export$14834abbfce3b8cd = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 20 20",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.11035 17.7971C8.47155 18.4706 9.18229 18.9287 9.99999 18.9287C10.8177 18.9287 11.5284 18.4706 11.8897 17.7971",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M6.0892 2.69137C7.12643 1.65414 8.53321 1.07143 10.0001 1.07143C11.4669 1.07143 12.8737 1.65414 13.911 2.69137C14.9482 3.7286 15.5309 5.13538 15.5309 6.60226C15.5309 7.46534 15.6733 8.27634 15.8876 9.10587C15.9476 9.29366 16.0138 9.47086 16.0849 9.63803C16.4163 10.4177 17.3289 10.6837 18.0099 11.1878C19.0263 11.9403 18.8298 13.5503 17.9843 14.1754C17.9843 14.1754 16.6193 15.3571 10.0001 15.3571C3.38074 15.3571 2.01577 14.1754 2.01577 14.1754C1.17036 13.5503 0.973858 11.9403 1.99025 11.1878C2.67118 10.6837 3.58375 10.4178 3.91528 9.6381C4.24574 8.86095 4.46925 7.86681 4.46925 6.60226C4.46925 5.13538 5.05197 3.7286 6.0892 2.69137Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });



var $50BRD = parcelRequire("50BRD");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $9d053980c44327ec$export$883262dc952d8f59 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 25 24",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.209 2C13.5222 2 14.8226 2.25866 16.0358 2.76121C17.2491 3.26375 18.3515 4.00035 19.2801 4.92893C20.2086 5.85752 20.9452 6.95991 21.4478 8.17317C21.9503 9.38643 22.209 10.6868 22.209 12M12.209 2V12M12.209 2C6.68614 2 2.20898 6.47715 2.20898 12C2.20898 17.5228 6.68614 22 12.209 22C17.7318 22 22.209 17.5229 22.209 12M12.209 2C17.7318 2 22.209 6.47716 22.209 12M22.209 12L12.209 12M22.209 12C22.209 13.5781 21.8355 15.1338 21.119 16.5399C20.4026 17.946 19.3635 19.1626 18.0868 20.0902L12.209 12",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
$9d053980c44327ec$export$883262dc952d8f59.displayName = 'Reports';



var $2lSXC = parcelRequire("2lSXC");

var $f6Tww = parcelRequire("f6Tww");
const $1ca1419a345bb00d$export$8b251419efc915eb = ({ title: title, subtitle: subtitle, icon: icon, desktopNavToggle: desktopNavToggle, ...props })=>{
    const premium = (0, $2lSXC.useSelector)(({ variables: variables })=>(0, $f1q41.get)(variables, 'PREMIUM'));
    const md = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('md'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
        ...props,
        component: "header",
        sx: {
            display: 'flex',
            flexDirection: 'row',
            mb: 4,
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    width: 48,
                    height: 48,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'common.white',
                    mr: 3,
                    position: 'relative'
                },
                children: [
                    !icon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfc71c5de3bf5456$export$e6ff31bff12b7ff4), {
                        variant: "header",
                        sx: {
                            fontSize: 22,
                            mt: -0.25
                        }
                    }),
                    icon === 'boiler' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {
                        sx: {
                            fontSize: 40
                        }
                    }),
                    icon === 'electrical-grid' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {
                        sx: {
                            fontSize: 40
                        }
                    }),
                    icon === 'solar-panel' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {
                        sx: {
                            fontSize: 40
                        }
                    }),
                    icon === 'statistics' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e906332a228bb47a$export$bac3506438e44f8d), {
                        sx: {
                            fontSize: 20
                        }
                    }),
                    icon === 'settings' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa25f3d1279cf638$export$c72f6eaae7b9adff), {
                        sx: {
                            fontSize: 20
                        }
                    }),
                    icon === 'heat-pump' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {
                        sx: {
                            fontSize: 26
                        }
                    }),
                    icon === 'wallbox' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {
                        sx: {
                            fontSize: 28,
                            ml: 0.35,
                            mt: 0.25
                        }
                    }),
                    icon === 'wind' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {
                        sx: {
                            fontSize: 26
                        }
                    }),
                    icon === 'thermostat' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9748beca3fc4505a$export$a72d32054f236c4), {
                        sx: {
                            fontSize: 26
                        }
                    }),
                    icon === 'reports' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d053980c44327ec$export$883262dc952d8f59), {
                        sx: {
                            fontSize: 28,
                            ml: '2px'
                        }
                    }),
                    premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                        sx: {
                            position: 'absolute',
                            top: 0,
                            right: 0
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                sx: {
                    mt: 0.25
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h1",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h5",
                        color: "text.disabled",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    ml: 'auto',
                    '& .MuiSvgIcon-root': {
                        fontSize: 20
                    }
                },
                children: [
                    premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        to: (0, $dHW62.links).appMessages,
                        component: (0, $f6Tww.LinkComponent),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a39572a94ed76787$export$14834abbfce3b8cd), {})
                    }),
                    md ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: desktopNavToggle,
                        className: "desktop-nav-open",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59284b1ac39b5c43$export$d9b273488cd8ce6f), {})
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        to: (0, $dHW62.links).settings || '#',
                        component: (0, $f6Tww.LinkComponent),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa25f3d1279cf638$export$c72f6eaae7b9adff), {})
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $7pTac = parcelRequire("7pTac");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $klPA2 = parcelRequire("klPA2");
var $1DAbm = parcelRequire("1DAbm");
var $gJm6V = parcelRequire("gJm6V");
var $gEsja = parcelRequire("gEsja");
var $eVI4s = parcelRequire("eVI4s");

var $dHW62 = parcelRequire("dHW62");

var $2lSXC = parcelRequire("2lSXC");
const $c8a10aaf71cf6235$var$STORAGE_KEY = 'layout-mode';
/**
 * On first call, checks for `?layout=solidsun-iframe` in the URL
 * and persists the flag to sessionStorage so it survives in-app navigation.
 */ const $c8a10aaf71cf6235$var$init = ()=>{
    const params = new URLSearchParams(window.location.search);
    if (params.get('layout') === 'solidsun-iframe') sessionStorage.setItem($c8a10aaf71cf6235$var$STORAGE_KEY, 'solidsun-iframe');
};
$c8a10aaf71cf6235$var$init();
const $c8a10aaf71cf6235$export$77498849b0391674 = ()=>sessionStorage.getItem($c8a10aaf71cf6235$var$STORAGE_KEY) === 'solidsun-iframe';



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $8ni7a = parcelRequire("8ni7a");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
const $c921d87731d038a0$export$afd0895be3f7068a = {
    [(0, $8ni7a.SolaxMode).SelfUse]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "ems.inverter.mode.selfUse",
        defaultMessage: "Self use"
    }),
    [(0, $8ni7a.SolaxMode).FeedIn]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "ems.inverter.mode.feedIn",
        defaultMessage: "Feed-in"
    }),
    [(0, $8ni7a.SolaxMode).Backup]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "ems.inverter.mode.backup",
        defaultMessage: "Backup"
    }),
    [(0, $8ni7a.SolaxMode).Manual]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "ems.inverter.mode.manual",
        defaultMessage: "Manual"
    }),
    [(0, $8ni7a.SolaxMode).PeakShaving]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "ems.inverter.mode.peakShaving",
        defaultMessage: "Peak Shaving"
    })
};
const $c921d87731d038a0$export$baa07767715cb3f8 = (0, $bd9zl.defineMessages)({
    [(0, $8ni7a.SolaxEMS1000InverterName).NotConnected]: {
        id: 'ems.inverter.name.notConnected',
        defaultMessage: "Nep\u0159ipojeno"
    },
    [(0, $8ni7a.SolaxEMS1000InverterName).TRENE100KI]: {
        id: 'ems.inverter.name.trene100ki',
        defaultMessage: 'X3-TRENE-100KI'
    },
    [(0, $8ni7a.SolaxEMS1000InverterName).AELIO]: {
        id: 'ems.inverter.name.aelio',
        defaultMessage: 'X3-AELIO'
    },
    [(0, $8ni7a.SolaxEMS1000InverterName).TRENE100K]: {
        id: 'ems.inverter.name.trene100k',
        defaultMessage: 'X3-TRENE-100K'
    },
    [(0, $8ni7a.SolaxEMS1000InverterName).TRENE125K]: {
        id: 'ems.inverter.name.trene125k',
        defaultMessage: 'X3-TRENE-125K'
    }
});
const $c921d87731d038a0$export$9e535cf34b48ed91 = (0, $bd9zl.defineMessages)({
    [(0, $8ni7a.SolaxEMS1000PROInverterName).NotConnected]: {
        id: 'emsPro.inverter.name.notConnected',
        defaultMessage: "Nep\u0159ipojeno"
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).TRENE1]: {
        id: 'emsPro.inverter.name.trene1',
        defaultMessage: 'X3-TRENE-1'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).AELIO]: {
        id: 'emsPro.inverter.name.aelio',
        defaultMessage: 'X3-AELIO'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).TRENE100K]: {
        id: 'emsPro.inverter.name.trene100k',
        defaultMessage: 'X3-TRENE-100K'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).TRENE125K]: {
        id: 'emsPro.inverter.name.trene125k',
        defaultMessage: 'X3-TRENE-125K'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).X3PROG2]: {
        id: 'emsPro.inverter.name.x3prog2',
        defaultMessage: 'X3-PRO G2'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).X3FORTH]: {
        id: 'emsPro.inverter.name.x3forth',
        defaultMessage: 'X3-FORTH'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).X3MGAG2]: {
        id: 'emsPro.inverter.name.x3mgag2',
        defaultMessage: 'X3-MGA G2'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).X3GRAND]: {
        id: 'emsPro.inverter.name.x3grand',
        defaultMessage: 'X3-GRAND'
    },
    [(0, $8ni7a.SolaxEMS1000PROInverterName).X3FORTHPLUS]: {
        id: 'emsPro.inverter.name.x3forthplus',
        defaultMessage: 'X3-FORTH+'
    }
});
const $c921d87731d038a0$export$3ec460b98d9366d2 = {
    [(0, $8ni7a.Inverter).SolaxEMS1000]: $c921d87731d038a0$export$baa07767715cb3f8,
    [(0, $8ni7a.Inverter).SolaxEMS1000PRO]: $c921d87731d038a0$export$9e535cf34b48ed91
};
const $c921d87731d038a0$export$87817269cf0fc0d8 = ()=>{
    return (0, $2lSXC.useSelector)(({ variables: variables })=>{
        const hasEmsInverter = Object.values(variables.INVERTER_CONFIG ?? {}).some((config)=>[
                (0, $8ni7a.Inverter).SolaxEMS1000,
                (0, $8ni7a.Inverter).SolaxEMS1000PRO
            ].includes(config.type));
        return hasEmsInverter || variables.EMS;
    });
};


const $134ef85f0d499766$export$842a043d5fffb0e4 = ({ ...props })=>{
    const { pathname: pathname } = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const [hpEnabled, hwInstall, spInstall, plInstall, pvInstall, wbInstall, emInstall, windInstall, cloudPlugsInstall, thermInstall, relayInstall, customTabs, emMetersConfig] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            (0, $f1q41.get)(variables, 'HP_ENABLED'),
            (0, $f1q41.get)(variables, 'HW_INSTALL'),
            (0, $f1q41.get)(variables, 'SP_INSTALL'),
            (0, $f1q41.get)(variables, 'PL_INSTALL'),
            (0, $f1q41.get)(variables, 'PV_INSTALL'),
            (0, $f1q41.get)(variables, 'WB_INSTALL'),
            (0, $f1q41.get)(variables, 'EM_INSTALL'),
            (0, $f1q41.get)(variables, 'WIND_INSTALL'),
            (0, $f1q41.get)(variables, 'CLOUD_PLUGS_INSTALL'),
            (0, $f1q41.get)(variables, 'THERMOSTAT_INSTALL'),
            (0, $f1q41.get)(variables, 'RELAY_INSTALL') && (0, $f1q41.get)(variables, 'RELAY_USER_ADVANCED_CONTROL'),
            (0, $f1q41.get)(variables, 'APP_UI_CUSTOM_TABS') || [],
            (0, $f1q41.get)(variables, 'EM_METERS_CONFIG') || {}
        ]);
    const emsInstall = (0, $c921d87731d038a0$export$87817269cf0fc0d8)();
    const items = [
        {
            link: (0, $dHW62.links).home,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.home",
                defaultMessage: "Obecn\xe9"
            }),
            hidden: (0, $c8a10aaf71cf6235$export$77498849b0391674)()
        },
        {
            link: (0, $dHW62.links).photovoltaics,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.photovoltaics",
                defaultMessage: "Fotovoltaika"
            }),
            hidden: !pvInstall
        },
        {
            link: (0, $dHW62.links).ems,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.ems",
                defaultMessage: "EMS"
            }),
            hidden: !emsInstall
        },
        {
            link: (0, $dHW62.links).boiler,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.boiler",
                defaultMessage: "Bojler"
            }),
            hidden: !hwInstall
        },
        {
            link: (0, $dHW62.links).grid,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.grid",
                defaultMessage: "S\xed\u0165"
            }),
            hidden: !emInstall
        },
        {
            link: (0, $dHW62.links).heatPump,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.heatpump",
                defaultMessage: "Tepeln\xe9 \u010Derpadlo"
            }),
            hidden: !hpEnabled
        },
        {
            link: (0, $dHW62.links).wallbox,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.wallbox",
                defaultMessage: "Wallbox"
            }),
            hidden: !wbInstall
        },
        {
            link: (0, $dHW62.links).plug,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.plug",
                defaultMessage: "Z\xe1suvka"
            }),
            hidden: !plInstall
        },
        {
            link: (0, $dHW62.links).thermostat,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.thermostat",
                defaultMessage: "Termostat"
            }),
            hidden: !thermInstall
        },
        {
            link: (0, $dHW62.links).relay,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.relay",
                defaultMessage: "Rel\xe9"
            }),
            hidden: !relayInstall
        },
        {
            link: (0, $dHW62.links).energyMeters,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.energyMeters",
                defaultMessage: "Elektrom\u011Bry"
            }),
            hidden: Object.keys(emMetersConfig).length === 0
        },
        {
            link: (0, $dHW62.links).spot,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.spot",
                defaultMessage: "Spot"
            }),
            hidden: !spInstall
        },
        {
            link: (0, $dHW62.links).wind,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.wind",
                defaultMessage: "V\u011Btrn\xe1 elektr\xe1rna"
            }),
            hidden: !windInstall
        },
        {
            link: (0, $dHW62.links).cloudPlugs,
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.sec.cloud_plugs",
                defaultMessage: "Z\xe1suvky"
            }),
            hidden: !cloudPlugsInstall
        },
        ...customTabs.map(({ label: label, url: url })=>({
                link: (0, $dHW62.links).customPage.replace(':tabUrl', url),
                label: label,
                hidden: false
            }))
    ];
    const visibleItems = items.filter(({ hidden: hidden })=>!hidden);
    const tabsValue = items.find(({ link: link })=>link === pathname) ? pathname : false;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        component: "nav",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eVI4s.default), {
                    value: tabsValue,
                    onChange: (_e, link)=>navigate(link),
                    variant: "scrollable",
                    sx: {
                        mx: -1,
                        '&, & .MuiButtonBase-root': {
                            minHeight: 32
                        },
                        '& .MuiButtonBase-root': {
                            minWidth: 0,
                            px: 0,
                            mx: 1,
                            mr: {
                                xs: 1,
                                md: 6
                            },
                            textTransform: 'none',
                            '&:not(.Mui-selected)': {
                                fontWeight: 400
                            }
                        }
                    },
                    children: visibleItems.map(({ label: label, link: link })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $gEsja.default), {
                            label: label,
                            value: link,
                            sx: {
                                height: 20
                            }
                        }, link))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {})
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $klPA2 = parcelRequire("klPA2");
var $acw62 = parcelRequire("acw62");


var $6zeBo = parcelRequire("6zeBo");

var $3qSdM = parcelRequire("3qSdM");

var $13KXh = parcelRequire("13KXh");



var $2xc7G = parcelRequire("2xc7G");
'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $21498506e622538e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $21498506e622538e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $21498506e622538e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $3qSdM.default)((0, $2xc7G.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $21498506e622538e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $21498506e622538e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $21498506e622538e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.cloneElement(children, childrenProps);
}


var $1DAbm = parcelRequire("1DAbm");
var $u24M4 = parcelRequire("u24M4");
var $fNkZ4 = parcelRequire("fNkZ4");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $dHW62 = parcelRequire("dHW62");

var $iD7Z3 = parcelRequire("iD7Z3");

var $f6Tww = parcelRequire("f6Tww");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $901d845d68e55e9c$export$fe82a520fc33e5f4 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 18 18",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 1H7.22222V7.22222H1V1Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.7773 1H16.9996V7.22222H10.7773V1Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.7773 10.7773H16.9996V16.9996H10.7773V10.7773Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M1 10.7773H7.22222V16.9996H1V10.7773Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $d91f07c7ed3a6d8e$export$cad1a703886b4e3a = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15 12H3.62",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.85 8.6499L2.5 11.9999L5.85 15.3499",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $7f30deb19dfdb1c2$export$f39c2d165cd861fe = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 16 16",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "2.70711",
                y1: "3.00037",
                x2: "12.7279",
                y2: "13.0212",
                stroke: "currentColor",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "14.6716",
                y2: "-0.5",
                transform: "matrix(-0.707107 0.707107 0.707107 0.707107 13.8001 3.00037)",
                stroke: "currentColor",
                strokeLinecap: "round"
            })
        ]
    });




var $2lSXC = parcelRequire("2lSXC");


var $acw62 = parcelRequire("acw62");
const $e71db5cc6a7800fb$export$b1072f43c67b540c = ()=>{
    const portalActive = (0, $acw62.useMemo)(()=>{
        return document.cookie.includes('sb-auth-token=');
    }, []);
    return {
        portalActive: portalActive,
        handlePortalExit: ()=>{
            window.location.href = '/portal/exit';
        }
    };
};


const $495cc12358547d2f$export$dbe58ad728b89025 = ({ desktopIsOpen: desktopIsOpen, desktopClose: desktopClose, ...props })=>{
    const { pathname: pathname } = (0, $aphAM.useLocation)();
    const [appMessagesEnabled, premium] = (0, $2lSXC.useSelector)(({ variables: { APP_MESSAGES_DEV: APP_MESSAGES_DEV, PREMIUM: PREMIUM } })=>[
            APP_MESSAGES_DEV,
            PREMIUM
        ]);
    const md = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('md'));
    const { portalActive: portalActive, handlePortalExit: handlePortalExit } = (0, $e71db5cc6a7800fb$export$b1072f43c67b540c)();
    const handleClickAway = (e)=>{
        if (!(md && desktopIsOpen)) return;
        const target = e?.target;
        if (target && 'closest' in target && typeof target.closest === 'function' && target.closest('.desktop-nav-open') !== null) return;
        desktopClose();
    };
    const items = [
        {
            id: 'home',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.home",
                defaultMessage: "Dom\u016F"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $901d845d68e55e9c$export$fe82a520fc33e5f4), {}),
            link: (0, $dHW62.links).home,
            hidden: (0, $c8a10aaf71cf6235$export$77498849b0391674)()
        },
        {
            id: 'statistics',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.statistics",
                defaultMessage: "Statistiky"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e906332a228bb47a$export$bac3506438e44f8d), {}),
            link: (0, $dHW62.links).statistics
        },
        {
            id: 'reports',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.reports",
                defaultMessage: "Reporty"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d053980c44327ec$export$883262dc952d8f59), {}),
            link: (0, $dHW62.links).reports,
            hidden: !premium
        },
        {
            id: 'app-messages',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.app_messages",
                defaultMessage: "Zpr\xe1vy"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa25f3d1279cf638$export$c72f6eaae7b9adff), {}),
            link: (0, $dHW62.links).appMessages,
            hidden: !appMessagesEnabled
        },
        {
            id: 'settings',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.settings",
                defaultMessage: "Nastaven\xed"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa25f3d1279cf638$export$c72f6eaae7b9adff), {}),
            link: (0, $dHW62.links).settings
        },
        {
            id: 'logout',
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "nav.logout",
                defaultMessage: "Odhl\xe1sit se"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d91f07c7ed3a6d8e$export$cad1a703886b4e3a), {}),
            hidden: !portalActive,
            onClick: handlePortalExit
        }
    ];
    const dark = premium;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $21498506e622538e$export$58385c17fee43f89), {
                onClickAway: handleClickAway,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    ...props,
                    component: (0, $1DAbm.default),
                    sx: {
                        flexDirection: {
                            xs: 'row',
                            md: 'column'
                        },
                        justifyContent: {
                            xs: 'space-between',
                            md: 'flex-start'
                        },
                        position: 'fixed',
                        zIndex: 20,
                        left: {
                            xs: 0,
                            md: 'auto'
                        },
                        right: 0,
                        bottom: 0,
                        top: {
                            md: 0
                        },
                        bgcolor: (theme)=>theme.palette.mode === 'dark' ? 'background.paper' : dark ? (0, $iD7Z3.colors).richBlack : {
                                xs: 'common.white',
                                md: 'secondary.main'
                            },
                        pt: 0.75,
                        width: {
                            xs: '100%',
                            md: 320
                        },
                        boxShadow: {
                            md: '-11px 5px 44px rgba(62, 104, 121, 0.08)'
                        },
                        transform: {
                            md: desktopIsOpen ? 'translateX(0)' : 'translateX(100%)'
                        },
                        opacity: {
                            md: desktopIsOpen ? 1 : 0
                        },
                        transition: (t)=>t.transitions.create([
                                'transform',
                                'opacity'
                            ])
                    },
                    children: [
                        md && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                mt: 6,
                                mb: 6,
                                display: 'flex',
                                justifyContent: 'flex-end'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                onClick: desktopClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f30deb19dfdb1c2$export$f39c2d165cd861fe), {
                                    sx: {
                                        fontSize: 20
                                    }
                                })
                            })
                        }),
                        items.filter(({ hidden: hidden })=>!hidden).map(({ id: id, label: label, icon: icon, onClick: onClick, link: link })=>/*#__PURE__*/ (0, $ayMG0.jsx)($495cc12358547d2f$var$NavItem, {
                                label: label,
                                icon: icon,
                                active: link === pathname,
                                link: link,
                                dark: dark,
                                onClick: onClick
                            }, id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    height: {
                        xs: 120,
                        md: 0
                    }
                }
            })
        ]
    });
};
const $495cc12358547d2f$var$NavItem = ({ label: label, icon: icon, active: active, onClick: onClick, link: link, dark: dark })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNkZ4.default), {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            py: 1,
            cursor: 'pointer',
            mb: {
                md: 3
            },
            pr: {
                md: 1.5
            }
        },
        onClick: onClick,
        to: link || '#',
        component: (0, $f6Tww.LinkComponent),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                opacity: ({ palette: palette })=>palette.mode === 'dark' || dark || active ? 1 : 0.4,
                transition: 'ease-in-out 200ms opacity',
                '& .MuiSvgIcon-root': {
                    color: ({ palette: palette })=>palette.mode === 'dark' || dark ? active ? 'primary.main' : '#AEAEAE' : 'text.disabled'
                },
                '& .MuiSvgIcon-root path, & .MuiSvgIcon-root ellipse': {
                    strokeWidth: active ? 1.5 : undefined,
                    transition: 'ease-in-out 200ms stroke-width'
                },
                display: 'flex',
                flexDirection: {
                    xs: 'column',
                    md: 'row-reverse'
                },
                alignItems: 'center'
            },
            children: [
                icon,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        fontWeight: active ? 600 : 400,
                        transition: 'ease-in-out 200ms font-weight',
                        color: ({ palette: palette })=>palette.mode === 'dark' || dark ? active ? 'primary.main' : '#AEAEAE' : 'text.disabled',
                        mr: {
                            md: 4
                        }
                    },
                    children: label
                })
            ]
        })
    });
};




var $3OncY = parcelRequire("3OncY");
const $bf83a6995bdb44c9$export$1cd011aac104c991 = {
    confirmationButtonProps: {
        variant: 'contained',
        fullWidth: true
    },
    cancellationButtonProps: {
        variant: 'outlined',
        fullWidth: true
    },
    dialogActionsProps: {
        sx: {
            px: 3,
            pb: 3
        }
    },
    dialogProps: {
        maxWidth: 'xs'
    }
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $4mI0b = parcelRequire("4mI0b");
var $4LdGL = parcelRequire("4LdGL");
var $23H42 = parcelRequire("23H42");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $3c63abf5df8c37b2$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8z"
}), 'Update');



var $2lSXC = parcelRequire("2lSXC");

var $acw62 = parcelRequire("acw62");
function $529b0896e2af4a39$export$5fb7fe4703c2b18(dateTime, thresholdSeconds = 5) {
    const [isExpired, setIsExpired] = (0, $acw62.useState)(()=>{
        if (!dateTime) return false;
        const targetTime = new Date(dateTime).getTime() + thresholdSeconds * 1000;
        return targetTime - Date.now() <= 0;
    });
    (0, $acw62.useEffect)(()=>{
        if (!dateTime) {
            setIsExpired(false);
            return;
        }
        const targetTime = new Date(dateTime).getTime() + thresholdSeconds * 1000;
        const timeUntilExpiration = targetTime - Date.now();
        if (timeUntilExpiration <= 0) {
            setIsExpired(true);
            return;
        }
        setIsExpired(false);
        const timeoutId = setTimeout(()=>setIsExpired(true), timeUntilExpiration);
        return ()=>clearTimeout(timeoutId);
    }, [
        dateTime,
        thresholdSeconds
    ]);
    return isExpired;
}


const $53bca4870da0b7b6$export$d7cdb2ac78117072 = ()=>{
    const [updateStartedAt] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.APP_UPDATE_STARTED_AT ? new Date(variables.APP_UPDATE_STARTED_AT) : undefined
        ], (0, $f1q41.isEqual));
    const updateExpired = (0, $529b0896e2af4a39$export$5fb7fe4703c2b18)(updateStartedAt ?? new Date(0), 600 // 10 minutes
    );
    const isOpen = Boolean(updateStartedAt) && !updateExpired;
    const prevIsOpen = (0, $acw62.useRef)(isOpen);
    (0, $acw62.useEffect)(()=>{
        if (prevIsOpen.current && !isOpen) window.location.reload();
        prevIsOpen.current = isOpen;
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4LdGL.default), {
        open: isOpen,
        maxWidth: "sm",
        fullWidth: true,
        PaperProps: {
            sx: {
                borderRadius: 2
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 3,
                    py: 4
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        sx: {
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 80,
                                thickness: 2
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c63abf5df8c37b2$export$2e2bcd8739ae039), {
                                sx: {
                                    position: 'absolute',
                                    fontSize: 40,
                                    color: 'primary.main'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        sx: {
                            textAlign: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "h5",
                                fontWeight: "bold",
                                gutterBottom: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "app_update_overlay.title",
                                    defaultMessage: "Aktualizace prob\xedh\xe1"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "body1",
                                color: "text.secondary",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "app_update_overlay.subtitle",
                                    defaultMessage: "Pros\xedm vy\u010Dkejte. Po dokon\u010Den\xed aktualizace se aplikace restartuje a okno v prohl\xed\u017Ee\u010Di se automaticky obnov\xed"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $1DAbm = parcelRequire("1DAbm");
var $u24M4 = parcelRequire("u24M4");
var $7X4mk = parcelRequire("7X4mk");

var $dHW62 = parcelRequire("dHW62");




var $2lSXC = parcelRequire("2lSXC");

var $f6Tww = parcelRequire("f6Tww");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $a8gr9 = parcelRequire("a8gr9");
const $1a04729d5f79d9a6$export$e4c291d45fea4cd0 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8gr9.ArrowRight), {
        ...props,
        sx: {
            transform: 'rotate(-180deg)',
            ...props.sx || {}
        }
    });


const $77c0de0655c920ed$export$d2213875bf9dae65 = ({ title: title, goBack: goBack, desktopNavToggle: desktopNavToggle, ...props })=>{
    const premium = (0, $2lSXC.useSelector)(({ variables: variables })=>(0, $f1q41.get)(variables, 'PREMIUM'));
    const md = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('md'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
        ...props,
        component: "header",
        sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            mb: 4,
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                to: goBack,
                component: (0, $f6Tww.LinkComponent),
                sx: {
                    mr: 2,
                    '& .MuiSvgIcon-root': {
                        fontSize: 20
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a04729d5f79d9a6$export$e4c291d45fea4cd0), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h1",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    ml: 'auto',
                    '& .MuiSvgIcon-root': {
                        fontSize: 20
                    }
                },
                children: [
                    premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        to: (0, $dHW62.links).appMessages,
                        component: (0, $f6Tww.LinkComponent),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a39572a94ed76787$export$14834abbfce3b8cd), {})
                    }),
                    md ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: desktopNavToggle,
                        className: "desktop-nav-open",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59284b1ac39b5c43$export$d9b273488cd8ce6f), {})
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        to: (0, $dHW62.links).settings || '#',
                        component: (0, $f6Tww.LinkComponent),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa25f3d1279cf638$export$c72f6eaae7b9adff), {})
                    })
                ]
            })
        ]
    });
};


const $d9d25b1220fd88c5$export$93af822566053b3e = ({ title: title, icon: icon, variant: variant = 'default', goBack: goBack })=>{
    const [desktopNavIsOpen, setDesktopNavIsOpen] = (0, $acw62.useState)(false);
    const [connected, customer, pigpioInitError] = (0, $2lSXC.useSelector)(({ connected: connected, variables: { CUSTOMER: CUSTOMER, PIGPIO_INIT_ERROR: PIGPIO_INIT_ERROR } })=>[
            connected,
            CUSTOMER,
            PIGPIO_INIT_ERROR
        ]);
    const { portalActive: portalActive } = (0, $e71db5cc6a7800fb$export$b1072f43c67b540c)();
    (0, $acw62.useEffect)(()=>{
        if (0, $3OncY.IS_DEMO) document.title = "Infigy Demo | Tom\xe1\u0161 Super";
        else document.title = portalActive ? `Infigy | ${customer}` : 'Infigy';
    }, [
        portalActive,
        customer
    ]);
    const confirm = (0, $jDfxe.useConfirm)();
    (0, $acw62.useEffect)(()=>{
        if (pigpioInitError) confirm({
            titleProps: {
                variant: 'h3'
            },
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "layout.pigpio_init_error_dialog.title",
                defaultMessage: "Chyba p\u0159i spu\u0161t\u011Bn\xed aplikace"
            }),
            description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "layout.pigpio_init_error_dialog.description",
                defaultMessage: "Aplikace Infigy na za\u0159\xedzen\xed nenab\u011Bhla spr\xe1vn\u011B. Zkuste pros\xedm za\u0159\xedzen\xed restartovat a pokud probl\xe9m p\u0159etrv\xe1v\xe1, kontaktujte podporu."
            }),
            hideCancelButton: true,
            confirmationButtonProps: {
                variant: 'contained'
            },
            ...(0, $bf83a6995bdb44c9$export$1cd011aac104c991)
        });
    }, [
        pigpioInitError
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        component: "main",
        sx: {
            minHeight: '100vh',
            bgcolor: 'secondary.main',
            pt: 7
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $53bca4870da0b7b6$export$d7cdb2ac78117072), {}),
            variant === 'default' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ca1419a345bb00d$export$8b251419efc915eb), {
                title: title || /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "header.title",
                    defaultMessage: "Domovsk\xe1 str\xe1nka"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        customer,
                        ", ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                            value: new Date()
                        })
                    ]
                }),
                icon: icon,
                desktopNavToggle: ()=>setDesktopNavIsOpen(!desktopNavIsOpen)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77c0de0655c920ed$export$d2213875bf9dae65), {
                title: title,
                goBack: goBack,
                desktopNavToggle: ()=>setDesktopNavIsOpen(!desktopNavIsOpen)
            }),
            variant === 'default' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $134ef85f0d499766$export$842a043d5fffb0e4), {
                sx: {
                    mb: 3
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                sx: {
                    mb: 3
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Outlet), {}),
            !connected && !(0, $3OncY.IS_DEMO) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                sx: {
                    textAlign: 'center',
                    py: {
                        xs: 1,
                        sm: 2
                    },
                    pb: {
                        sm: 3
                    },
                    '& > *': {
                        verticalAlign: 'middle'
                    },
                    opacity: 0.6
                },
                variant: "body2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "layout.disconnected",
                            defaultMessage: "Odpojeno"
                        })
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a1bba11514f5f326$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $495cc12358547d2f$export$dbe58ad728b89025), {
                desktopIsOpen: desktopNavIsOpen,
                desktopClose: ()=>setDesktopNavIsOpen(false)
            })
        ]
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i51gj = parcelRequire("i51gj");

var $202BL = parcelRequire("202BL");

var $2lSXC = parcelRequire("2lSXC");
const $5617f62e0ff19c36$export$2d11abae75a67ab4 = {
    CZK: 1,
    EUR: 3
};
const $5617f62e0ff19c36$export$93ecdfe511e05807 = {
    CZK: 0.1,
    EUR: 0.005
};


const $0bb96e10f84c2def$var$customUnits = {
    'kilowatt-hour': (value)=>`${value} kWh`,
    'megawatt-hour': (value)=>`${value} MWh`,
    kilowatt: (value)=>`${value} kW`,
    'kilowatt-peak': (value)=>`${value} kWp`,
    'kilovoltampere-reactive': (value)=>`${value} kVAr`,
    kilovoltampere: (value)=>`${value} kVA`,
    ampere: (value)=>`${value} A`,
    litre: (value)=>`${value} l`,
    'meter-per-second': (value)=>`${value} m/s`,
    voltage: (value)=>`${value} V`,
    kilometer: (value)=>`${value} km`
};
const $0bb96e10f84c2def$var$isCustomUnit = (unit)=>unit in $0bb96e10f84c2def$var$customUnits;
const $0bb96e10f84c2def$export$5bd252c535c873db = ()=>{
    const { formatNumber: formatNumber } = (0, $202BL.default)();
    const defaultCurrency = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.CURRENCY);
    return (value, opts)=>{
        // adjust number value
        let adjustedValue = value;
        if (opts?.style === 'percent') adjustedValue = adjustedValue / 100;
        if (opts?.style === 'currency' && !opts.currency) {
            opts.currency = defaultCurrency;
            const fractionDigitsOffset = opts.fractionDigitsOffset || 0;
            opts.maximumFractionDigits = opts.maximumFractionDigits ?? (0, $5617f62e0ff19c36$export$2d11abae75a67ab4)[defaultCurrency] + fractionDigitsOffset;
            opts.minimumFractionDigits = opts.minimumFractionDigits ?? (0, $5617f62e0ff19c36$export$2d11abae75a67ab4)[defaultCurrency] + fractionDigitsOffset;
        }
        // adjust Int.formatNumber options
        const formatNumberOpts = {
            maximumFractionDigits: 2,
            ...opts || {}
        };
        const customUnit = formatNumberOpts?.style === 'unit' && formatNumberOpts.unit && $0bb96e10f84c2def$var$isCustomUnit(formatNumberOpts.unit) && formatNumberOpts.unit;
        if (customUnit) {
            formatNumberOpts.style = 'decimal';
            formatNumberOpts.unit = undefined;
        }
        let formatted = formatNumber(adjustedValue, formatNumberOpts);
        // format custom units
        if (customUnit) formatted = $0bb96e10f84c2def$var$customUnits[customUnit](formatted);
        return formatted;
    };
};



var $2lSXC = parcelRequire("2lSXC");
const $f7735bd41a453015$export$4894f0c76187fb2b = ({ variableId: variableId, opts: opts, fallbackValue: fallbackValue })=>{
    const value = (0, $2lSXC.useSelector)((s)=>(0, (/*@__PURE__*/$parcel$interopDefault($i51gj)))(s.variables, variableId));
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    if (typeof value === 'undefined') return fallbackValue !== undefined ? formatNumber(fallbackValue, opts) : null;
    if (typeof value === 'number') return formatNumber(value, opts);
    return String(value);
};
const $f7735bd41a453015$export$b7fe9082061cdb76 = ({ variableId: variableId, opts: opts, fallbackValue: fallbackValue })=>{
    const text = $f7735bd41a453015$export$4894f0c76187fb2b({
        variableId: variableId,
        opts: opts,
        fallbackValue: fallbackValue
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: text
    });
};



parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $gc70Y = parcelRequire("gc70Y");

var $2lSXC = parcelRequire("2lSXC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $f777c82437ec2b10$export$bd72f6a61c5669d6 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "-2 0 22 20",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M17.084 7.91699C18.334 7.91699 18.334 8.33366 18.334 9.16699V10.8337C18.334 11.667 18.334 12.0837 17.084 12.0837",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M5.31641 8.33301C5.59141 9.42467 5.59141 10.5747 5.31641 11.6663",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M8.23242 8.33301C8.50742 9.42467 8.50742 10.5747 8.23242 11.6663",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M11 8.33301C11.275 9.42467 11.275 10.5747 11 11.6663",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M10.8327 15.8337H5.83268C2.49935 15.8337 1.66602 15.0003 1.66602 11.667V8.33366C1.66602 5.00033 2.49935 4.16699 5.83268 4.16699H10.8327C14.166 4.16699 14.9993 5.00033 14.9993 8.33366V11.667C14.9993 15.0003 14.166 15.8337 10.8327 15.8337Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });






var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $fdd94ff560015fde$export$1027d4534a5ce60b = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "-5 -5 36 36",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2 22H22",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.94995 22L2.99995 9.96999C2.99995 9.35999 3.28995 8.78004 3.76995 8.40004L10.77 2.95003C11.49 2.39003 12.4999 2.39003 13.2299 2.95003L20.23 8.39003C20.72 8.77003 21 9.34999 21 9.96999V22",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M13 17H11C10.17 17 9.5 17.67 9.5 18.5V22H14.5V18.5C14.5 17.67 13.83 17 13 17Z",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M9.5 13.75H7.5C6.95 13.75 6.5 13.3 6.5 12.75V11.25C6.5 10.7 6.95 10.25 7.5 10.25H9.5C10.05 10.25 10.5 10.7 10.5 11.25V12.75C10.5 13.3 10.05 13.75 9.5 13.75Z",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M16.5 13.75H14.5C13.95 13.75 13.5 13.3 13.5 12.75V11.25C13.5 10.7 13.95 10.25 14.5 10.25H16.5C17.05 10.25 17.5 10.7 17.5 11.25V12.75C17.5 13.3 17.05 13.75 16.5 13.75Z",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M19.0001 7L18.9701 4H14.5701",
                stroke: "currentColor",
                strokeMiterlimit: "10",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
$fdd94ff560015fde$export$1027d4534a5ce60b.displayName = 'House';




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $c4e522d5d92ebef7$export$91030e912f5b0749 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.91533 0.963576C4.54471 0.31971 5.46105 0 6.7343 0H13.2652C14.5385 0 15.4548 0.31971 16.0842 0.963576C16.6881 1.58143 16.9214 2.39734 17.0739 3.12171L17.0741 3.12279L18.1254 8.15587C18.1683 8.36151 18.1163 8.57556 17.9839 8.73859C17.8514 8.90162 17.6525 8.99627 17.4424 8.99627H2.55713C2.34705 8.99627 2.14815 8.90162 2.01565 8.73859C1.88316 8.57556 1.83117 8.36151 1.87412 8.15587L2.92562 3.12171C3.07812 2.39734 3.31138 1.58143 3.91533 0.963576ZM4.29118 3.4092C4.29114 3.40936 4.29121 3.40903 4.29118 3.4092L3.41567 7.60078H16.5838L15.7083 3.4092C15.7083 3.40897 15.7084 3.40942 15.7083 3.4092C15.5632 2.71984 15.3916 2.25142 15.0863 1.93905C14.8062 1.65259 14.3085 1.39549 13.2652 1.39549H6.7343C5.69104 1.39549 5.19327 1.65259 4.91326 1.93905C4.60789 2.25144 4.43636 2.71974 4.29118 3.4092Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.92175 10.9032C1.92173 10.9034 1.92176 10.9031 1.92175 10.9032L1.40085 16.568L1.40072 16.5694C1.33831 17.2332 1.87384 17.8344 2.5946 17.8344H4.34362C4.75286 17.8344 4.83279 17.7475 4.83431 17.7458C4.86743 17.7144 4.90139 17.6574 5.00275 17.3533L5.18881 16.7951C5.1937 16.7804 5.19869 16.7654 5.20381 16.7499C5.30831 16.4344 5.464 15.9645 5.84067 15.6092C6.26696 15.2072 6.85675 15.0435 7.61837 15.0435H12.3817C13.1236 15.0435 13.7128 15.1822 14.1434 15.5797C14.5167 15.9243 14.6759 16.3949 14.7885 16.7281C14.7957 16.7494 14.8027 16.7702 14.8096 16.7903L14.8112 16.7951L14.9973 17.3533C15.0986 17.6574 15.1326 17.7144 15.1657 17.7458C15.1659 17.746 15.2437 17.8344 15.6564 17.8344H17.4054C18.1262 17.8344 18.6617 17.2332 18.5993 16.5694L18.0783 10.9032C18.0783 10.9029 18.0782 10.9026 18.0782 10.9023C18.0116 10.1895 17.9166 9.76832 17.6861 9.49502C17.4889 9.26123 17.0614 8.99632 15.9355 8.99632H4.06452C2.93863 8.99632 2.51112 9.26123 2.31393 9.49502C2.08337 9.76838 1.98832 10.1902 1.92175 10.9032ZM1.2472 8.59531C1.82684 7.90807 2.75295 7.60083 4.06452 7.60083H15.9355C17.2471 7.60083 18.1732 7.90807 18.7528 8.59531C19.299 9.24292 19.4041 10.0914 19.4677 10.7735L19.4678 10.7745L19.9887 16.4388C19.9887 16.4389 19.9887 16.4386 19.9887 16.4388C20.1307 17.9517 18.9173 19.2299 17.4054 19.2299H15.6564C15.0643 19.2299 14.57 19.1044 14.2051 18.758C13.8931 18.462 13.7646 18.0715 13.6877 17.8378C13.6827 17.8227 13.678 17.8083 13.6734 17.7946L13.4882 17.2389C13.3425 16.8125 13.2834 16.6849 13.1969 16.6051C13.1437 16.556 12.9794 16.4389 12.3817 16.4389H7.61837C7.04032 16.4389 6.86259 16.5636 6.79814 16.6244C6.7025 16.7146 6.64049 16.853 6.51269 17.2364L6.32663 17.7946C6.32206 17.8083 6.31732 17.8227 6.31236 17.8378C6.23541 18.0715 6.1069 18.462 5.79497 18.758C5.43004 19.1044 4.9357 19.2299 4.34362 19.2299H2.5946C1.08284 19.2299 -0.130479 17.9523 0.0112781 16.4396C0.0113031 16.4393 0.0112531 16.4398 0.0112781 16.4396L0.532293 10.7735C0.595963 10.0914 0.700984 9.24292 1.2472 8.59531Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.929688 5.50756C0.929688 5.12221 1.24208 4.80981 1.62743 4.80981H2.55776C2.94312 4.80981 3.25551 5.12221 3.25551 5.50756C3.25551 5.89292 2.94312 6.20531 2.55776 6.20531H1.62743C1.24208 6.20531 0.929688 5.89292 0.929688 5.50756Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7451 5.50756C16.7451 5.12221 17.0575 4.80981 17.4429 4.80981H18.3732C18.7585 4.80981 19.0709 5.12221 19.0709 5.50756C19.0709 5.89292 18.7585 6.20531 18.3732 6.20531H17.4429C17.0575 6.20531 16.7451 5.89292 16.7451 5.50756Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.0005 0.158203C10.3858 0.158203 10.6982 0.470595 10.6982 0.855949V2.71661C10.6982 3.10196 10.3858 3.41435 10.0005 3.41435C9.61513 3.41435 9.30273 3.10196 9.30273 2.71661V0.855949C9.30273 0.470595 9.61513 0.158203 10.0005 0.158203Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.90723 2.71655C7.90723 2.33119 8.21962 2.0188 8.60497 2.0188H11.396C11.7813 2.0188 12.0937 2.33119 12.0937 2.71655C12.0937 3.1019 11.7813 3.41429 11.396 3.41429H8.60497C8.21962 3.41429 7.90723 3.1019 7.90723 2.71655Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.7207 12.0198C3.7207 11.6344 4.03309 11.322 4.41845 11.322H7.20943C7.59479 11.322 7.90718 11.6344 7.90718 12.0198C7.90718 12.4051 7.59479 12.7175 7.20943 12.7175H4.41845C4.03309 12.7175 3.7207 12.4051 3.7207 12.0198Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0938 12.0198C12.0938 11.6344 12.4061 11.322 12.7915 11.322H15.5825C15.9678 11.322 16.2802 11.6344 16.2802 12.0198C16.2802 12.4051 15.9678 12.7175 15.5825 12.7175H12.7915C12.4061 12.7175 12.0938 12.4051 12.0938 12.0198Z",
                fill: "currentColor"
            })
        ]
    });




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $7X4mk = parcelRequire("7X4mk");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $bd12a6dc1f41e68e$export$8807d5fda232cef2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 16 6",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M0 3L5 5.88675L5 0.113248L0 3ZM4.5 3.5L16 3.5L16 2.5L4.5 2.5L4.5 3.5Z",
            fill: "currentColor"
        })
    });


const $e66af8bd612a8dde$export$a03717477f7c942f = ({ rotate: rotate, label: label, icon: icon, value: value, valueIsConsumption: valueIsConsumption })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const formattedValue = formatNumber(Math.abs(value), {
        style: 'unit',
        unit: 'kilowatt',
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    });
    const inactive = Math.round(value * 10) / 10 === 0;
    let isConsumption = value < 0;
    if (valueIsConsumption) isConsumption = !isConsumption;
    let alignItems = 'flex-start';
    const justifyContent = 'center';
    if (rotate === 0 || rotate === 180) alignItems = 'center';
    if (rotate > 180) alignItems = 'flex-end';
    const translateCompensation = Math.abs((rotate + 45) % 90 - 45) / 45;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            position: 'absolute',
            transform: `rotate(${rotate}deg)`,
            height: {
                xs: 340,
                sm: 370
            },
            width: 90
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        height: 90,
                        width: 55,
                        transform: `rotate(${-rotate}deg)`,
                        marginTop: {
                            xs: -translateCompensation,
                            sm: -translateCompensation * 2.5
                        },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: justifyContent,
                        alignItems: alignItems
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                '& .MuiSvgIcon-root': {
                                    fontSize: 40,
                                    color: 'primary.main'
                                }
                            },
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            component: "span",
                            sx: {
                                fontWeight: 600,
                                color: 'text.disabled'
                            },
                            children: label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            component: "span",
                            sx: {
                                color: 'text.disabled'
                            },
                            children: formattedValue
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        position: 'absolute',
                        top: 90,
                        left: 0,
                        right: 0,
                        textAlign: 'center'
                    },
                    children: !inactive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd12a6dc1f41e68e$export$8807d5fda232cef2), {
                        sx: {
                            color: 'primary.main',
                            transform: isConsumption ? 'rotate(90deg)' : 'rotate(-90deg)',
                            transition: 'transform ease-in-out 200ms'
                        }
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");


var $50BRD = parcelRequire("50BRD");

var $2lSXC = parcelRequire("2lSXC");
const $4906eb9f877d231e$export$58517bb1b373a54c = ({ children: children })=>{
    const premium = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.PREMIUM);
    const circleBorderSx = {
        position: 'absolute',
        borderStyle: 'solid',
        borderRadius: '50%',
        borderColor: 'primary.main'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            width: '100%',
            height: {
                xs: 340,
                sm: 370
            },
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
        },
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    width: 106,
                    height: 106,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bfc71c5de3bf5456$export$e6ff31bff12b7ff4), {
                        variant: "animation",
                        sx: {
                            fontSize: 40,
                            mb: 0.75,
                            color: 'common.white'
                        }
                    }),
                    premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                        sx: {
                            position: 'absolute',
                            top: 25,
                            right: 30,
                            zIndex: 10
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            inset: -8,
                            borderWidth: 3,
                            ...circleBorderSx,
                            animation: 'pulsing 2000ms ease-in-out infinite',
                            '@keyframes pulsing': {
                                '0%': {
                                    opacity: 0
                                },
                                '90%': {
                                    opacity: 1
                                },
                                '100%': {
                                    opacity: 0
                                }
                            },
                            '&:before': {
                                content: '" "',
                                inset: -10,
                                opacity: 0.6,
                                borderWidth: 1,
                                ...circleBorderSx
                            },
                            '&:after': {
                                content: '" "',
                                inset: -17,
                                borderWidth: 0.3,
                                opacity: 0.4,
                                ...circleBorderSx
                            }
                        }
                    })
                ]
            })
        ]
    });
};


const $ccd4aed76daaffff$export$c35d437ae5945fcd = ()=>{
    const [consumptionPhase1, consumptionPhase2, consumptionPhase3, pvActualPower, hwActualPower, pvActualPowerBattery, homeActualPower, hpActualPower, windPower, hpEnabled, pvInstalled, pvBattery, hwInstalled, wbCarConnect, wbActualPower, emInstalled, windInstalled] = (0, $2lSXC.useSelector)((s)=>[
            (0, $f1q41.get)(s.variables, 'anim_EM_Consumption[0]'),
            (0, $f1q41.get)(s.variables, 'anim_EM_Consumption[1]'),
            (0, $f1q41.get)(s.variables, 'anim_EM_Consumption[2]'),
            (0, $f1q41.get)(s.variables, 'anim_PV_ACTUAL_POWER'),
            (0, $f1q41.get)(s.variables, 'anim_HW_ACTUAL_POWER'),
            (0, $f1q41.get)(s.variables, 'anim_PV_ACTUAL_POWER_BATTERY'),
            (0, $f1q41.get)(s.variables, 'anim_HOME_ACTUAL_POWER'),
            (0, $f1q41.get)(s.variables, 'anim_HP_ACTUAL_POWER'),
            (0, $f1q41.get)(s.variables, 'anim_WIND_POWER'),
            (0, $f1q41.get)(s.variables, 'HP_ENABLED'),
            (0, $f1q41.get)(s.variables, 'PV_INSTALL'),
            (0, $f1q41.get)(s.variables, 'PV_BATTERY'),
            (0, $f1q41.get)(s.variables, 'HW_INSTALL'),
            (0, $f1q41.get)(s.variables, 'WB_CAR_CONNECT'),
            (0, $f1q41.get)(s.variables, 'anim_WB_ACTUAL_POWER'),
            (0, $f1q41.get)(s.variables, 'EM_INSTALL'),
            (0, $f1q41.get)(s.variables, 'WIND_INSTALL')
        ]);
    const consumption = (0, $f1q41.sum)([
        consumptionPhase1,
        consumptionPhase2,
        consumptionPhase3
    ]);
    const items = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.photovoltaics",
                defaultMessage: "FVE"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {
                sx: {
                    mx: -0.75,
                    mt: -1
                }
            }),
            value: pvActualPower,
            hidden: !pvInstalled
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.boiler",
                defaultMessage: "Bojler"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {
                whiteBg: true,
                sx: {
                    mx: -1.5,
                    mt: -1
                }
            }),
            value: hwActualPower,
            hidden: !hwInstalled,
            valueIsConsumption: true
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.battery",
                defaultMessage: "Baterie"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {
                sx: {
                    mx: -0.5,
                    mt: -1
                }
            }),
            value: pvActualPowerBattery,
            hidden: !pvBattery
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.electrical_grid",
                defaultMessage: "S\xed\u0165"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {
                sx: {
                    mx: -1.5,
                    mt: -1
                }
            }),
            value: consumption,
            hidden: !emInstalled
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.consumption",
                defaultMessage: "D\u016Fm"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdd94ff560015fde$export$1027d4534a5ce60b), {
                sx: {
                    mx: -1.5,
                    mt: -1
                }
            }),
            value: homeActualPower,
            valueIsConsumption: true,
            hidden: !emInstalled
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.hp",
                defaultMessage: "Tepelko"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {
                sx: {
                    mx: -1.5,
                    mt: -1,
                    width: 30
                }
            }),
            value: hpActualPower,
            valueIsConsumption: true,
            hidden: !hpEnabled
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.wallbox",
                defaultMessage: "Wallbox"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4e522d5d92ebef7$export$91030e912f5b0749), {
                sx: {
                    mx: 0,
                    mt: 0,
                    width: 24
                }
            }),
            value: wbActualPower,
            valueIsConsumption: true,
            hidden: !wbCarConnect
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "animation.wind",
                defaultMessage: "V\xedtr"
            }),
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {
                sx: {
                    mx: -1.5,
                    mt: -1,
                    width: 30
                }
            }),
            value: windPower,
            hidden: !windInstalled
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            px: 0.25
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4906eb9f877d231e$export$58517bb1b373a54c), {
            children: items.filter(({ hidden: hidden })=>!hidden).map((item, index, array)=>{
                const rotate = 360 / array.length * index;
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e66af8bd612a8dde$export$a03717477f7c942f), {
                    rotate: rotate,
                    ...item
                }, index);
            })
        })
    });
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i51gj = parcelRequire("i51gj");

var $jDfxe = parcelRequire("jDfxe");

var $7pTac = parcelRequire("7pTac");

var $jrrQL = parcelRequire("jrrQL");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $bCDrB = parcelRequire("bCDrB");

var $9iEAl = parcelRequire("9iEAl");
const $7d1de006908a8306$export$777b2856a792333e = ({ switchVariableId: switchVariableId, lock: lock, ...props })=>{
    const switchValue = (0, $2lSXC.useSelector)((s)=>switchVariableId ? (0, (/*@__PURE__*/$parcel$interopDefault($i51gj)))(s.variables, switchVariableId) : undefined);
    const dispatch = (0, $2lSXC.useDispatch)();
    const confirm = (0, $jDfxe.useConfirm)();
    const lockConditionMet = (0, $bCDrB.useVisibility)(lock?.when);
    const isLocked = lock !== undefined && lockConditionMet;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: switchVariableId && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jrrQL.default), {
                checked: Boolean(switchValue),
                onChange: (_e, v)=>{
                    if (isLocked) return confirm({
                        title: lock.title,
                        description: lock.description,
                        confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "close",
                            defaultMessage: "Zav\u0159\xedt"
                        }),
                        hideCancelButton: true
                    }).then(()=>{
                    // noop
                    }).catch(()=>{
                    // noop
                    });
                    dispatch((0, $1Jwr0.variablesChange)({
                        [switchVariableId]: Boolean(v)
                    }));
                }
            })
        }),
        ...props
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $91vj1 = parcelRequire("91vj1");
var $dYv7f = parcelRequire("dYv7f");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");

var $exNvH = parcelRequire("exNvH");

var $bCDrB = parcelRequire("bCDrB");
const $aa47be3f785df5ae$export$dd3ff450a300a06e = ({ type: type = 'column', icon: icon, title: title, value: value, gridItem: gridItem, expanded: expanded, visibility: visibility })=>{
    const isExpandable = Boolean(expanded);
    const [isExpanded, setIsExpanded] = (0, $acw62.useState)(false);
    if (!(0, $bCDrB.useVisibility)(visibility)) return null;
    const box = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            height: type === 'column' ? 150 : 'auto',
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                display: 'flex',
                flexDirection: type === 'column' ? 'column' : 'row',
                alignItems: type === 'column' ? 'flex-start' : 'center',
                height: '100%',
                width: '100%'
            },
            children: [
                icon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        borderRadius: 1,
                        bgcolor: 'primary.main',
                        color: 'common.white',
                        width: type === 'column' ? 32 : 40,
                        height: type === 'column' ? 32 : 40,
                        '& .MuiSvgIcon-root': {
                            fontSize: type === 'column' ? 24 : 32
                        },
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: type === 'column' ? 0 : 3
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        mt: type === 'column' ? 'auto' : 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "h3",
                            sx: {
                                maxWidth: type === 'column' ? 100 : '100%',
                                mb: type === 'column' ? 0.5 : 0.25
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled'
                            },
                            children: value
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                            in: isExpandable && isExpanded,
                            children: expanded
                        })
                    ]
                }),
                isExpandable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: ()=>setIsExpanded(!isExpanded),
                        sx: {
                            ml: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exNvH.ChevronRight), {
                            sx: {
                                transform: `rotate(${isExpanded ? '-' : ''}90deg)`,
                                transition: 'ease-in-out 200ms transform'
                            }
                        })
                    })
                })
            ]
        })
    });
    if (gridItem) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dYv7f.default), {
        ...gridItem,
        children: box
    });
    return box;
};











var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");

var $8ni7a = parcelRequire("8ni7a");
const $0866bf7fb82c359f$export$c8c02a74d96210d1 = ()=>{
    const [status, subStatus] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            (0, $f1q41.get)(variables, 'HP_INFO.Status'),
            (0, $f1q41.get)(variables, 'HP_INFO.SubStatus')
        ]);
    const statusMapping = {
        [(0, $8ni7a.HeatPumpStatus).Heating]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.heating",
            defaultMessage: "Vyt\xe1p\u011Bn\xed"
        }),
        [(0, $8ni7a.HeatPumpStatus).HotWater]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.hot_water",
            defaultMessage: "Oh\u0159ev tepl\xe9 vody"
        }),
        [(0, $8ni7a.HeatPumpStatus).Cooling]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.cooling",
            defaultMessage: "Chlazen\xed"
        }),
        [(0, $8ni7a.HeatPumpStatus).Pool]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.pool",
            defaultMessage: "Oh\u0159ev baz\xe9nu"
        }),
        [(0, $8ni7a.HeatPumpStatus).Inactive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.inactive",
            defaultMessage: "Neaktivn\xed"
        }),
        [(0, $8ni7a.HeatPumpStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.not_connected",
            defaultMessage: "Nelze nav\xe1zat spojen\xed"
        }),
        [(0, $8ni7a.HeatPumpStatus).CompressorBlocked]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.compressor_blocked",
            defaultMessage: "Blokace kompresoru, n\xedzk\xfd stav baterie"
        }),
        [(0, $8ni7a.HeatPumpStatus).NotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.status.not_licensed",
            defaultMessage: "Tepeln\xe9 \u010Derpadlo nen\xed licencovan\xe9"
        })
    };
    const subStatusMapping = {
        [(0, $8ni7a.HeatPumpInfoStatus).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.sub_status.none",
            defaultMessage: " "
        }),
        [(0, $8ni7a.HeatPumpInfoStatus).ConsumptionRise]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.sub_status.consumption_rise",
            defaultMessage: "p\u0159i zv\xfd\u0161en\xed spot\u0159eby"
        }),
        [(0, $8ni7a.HeatPumpInfoStatus).ConsumptionPostpone]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.sub_status.consumption_postpone",
            defaultMessage: "p\u0159i sn\xed\u017Een\xed spot\u0159eby"
        }),
        [(0, $8ni7a.HeatPumpInfoStatus).ConsumptionWithFlexibility]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.sub_status.consumption_with_flexibility",
            defaultMessage: "s flexibilitou"
        }),
        [(0, $8ni7a.HeatPumpInfoStatus).NibeNotWritable]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "hp.sub_status.nibe_not_writable",
            defaultMessage: "- do NIBE nelze zapisovat"
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            statusMapping[status],
            " ",
            subStatusMapping[subStatus]
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");

var $8ni7a = parcelRequire("8ni7a");
const $86275d5209b32b69$export$d39b7d88aba30ea1 = ()=>{
    const [status, subStatus] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            (0, $f1q41.get)(variables, 'WB_INFO.Status'),
            (0, $f1q41.get)(variables, 'WB_INFO.SubStatus')
        ]);
    const statusMapping = {
        [(0, $8ni7a.WallboxStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.not_connected",
            defaultMessage: "Nelze nav\xe1zat spojen\xed"
        }),
        [(0, $8ni7a.WallboxStatus).Off]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.off",
            defaultMessage: "Wallbox vypnut\xfd"
        }),
        [(0, $8ni7a.WallboxStatus).Normal]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.normal",
            defaultMessage: "B\u011B\u017En\xfd re\u017Eim"
        }),
        [(0, $8ni7a.WallboxStatus).CarNotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.car_not_connected",
            defaultMessage: "Auto nen\xed p\u0159ipojeno"
        }),
        [(0, $8ni7a.WallboxStatus).Ready]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.ready",
            defaultMessage: "P\u0159ipraveno k nab\xedjen\xed"
        }),
        [(0, $8ni7a.WallboxStatus).Charging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.charging",
            defaultMessage: "Nab\xedjen\xed"
        }),
        [(0, $8ni7a.WallboxStatus).ChargingWithVentilation]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.charging_with_ventilation",
            defaultMessage: "Nab\xedjen\xed auta s ventil\xe1torem"
        }),
        [(0, $8ni7a.WallboxStatus).Error]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.status.error",
            defaultMessage: "Chyba nab\xedjen\xed"
        })
    };
    const subStatusMapping = {
        [(0, $8ni7a.WallboxSubStatus).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.none",
            defaultMessage: " "
        }),
        [(0, $8ni7a.WallboxSubStatus).BasicEnergy]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.basic_energy",
            defaultMessage: "z\xe1kladn\xed energi\xed"
        }),
        [(0, $8ni7a.WallboxSubStatus).BatteryWaiting]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.battery_waiting",
            defaultMessage: ", \u010Dek\xe1n\xed na nab\xedt\xed baterie"
        }),
        [(0, $8ni7a.WallboxSubStatus).Battery]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.battery",
            defaultMessage: "podle baterie"
        }),
        [(0, $8ni7a.WallboxSubStatus).BatteryFast]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.battery_fast",
            defaultMessage: "p\u0159ednostn\u011B podle baterie"
        }),
        [(0, $8ni7a.WallboxSubStatus).Photovoltaics]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.photovoltaics",
            defaultMessage: "podle FVE"
        }),
        [(0, $8ni7a.WallboxSubStatus).Spot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.spot",
            defaultMessage: "podle SPOTU"
        }),
        [(0, $8ni7a.WallboxSubStatus).SpotMid]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.spot_mid",
            defaultMessage: ", je st\u0159edn\xed cena SPOTU"
        }),
        [(0, $8ni7a.WallboxSubStatus).SpotHigh]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.spot_high",
            defaultMessage: ", je vysok\xe1 cena SPOTU"
        }),
        [(0, $8ni7a.WallboxSubStatus).Auto]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.auto",
            defaultMessage: "podle auto. re\u017Eimu"
        }),
        [(0, $8ni7a.WallboxSubStatus).HDOBlock]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.hdo_block",
            defaultMessage: ", blokace HDO"
        }),
        [(0, $8ni7a.WallboxSubStatus).Schedule]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.schedule",
            defaultMessage: "podle pl\xe1nova\u010De"
        }),
        [(0, $8ni7a.WallboxSubStatus).NoCharging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "wallbox.sub_status.no_charging",
            defaultMessage: ", nab\xedjen\xed je zak\xe1z\xe1no"
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            statusMapping[status],
            " ",
            subStatusMapping[subStatus]
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
const $7df3f57d707c8835$var$mapping = {
    smartMeter: {
        [(0, $8ni7a.SmartMeterStatus).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.none",
            defaultMessage: " "
        }),
        [(0, $8ni7a.SmartMeterStatus).Consumption]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.consumption",
            defaultMessage: "B\u011B\u017En\xfd odb\u011Br domu"
        }),
        [(0, $8ni7a.SmartMeterStatus).Overflow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.overflow",
            defaultMessage: "P\u0159etok energie"
        }),
        [(0, $8ni7a.SmartMeterStatus).OverflowLimited]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.overflowLimited",
            defaultMessage: "P\u0159etok omezen z d\u016Fvodu z\xe1porn\xe9 ceny"
        }),
        [(0, $8ni7a.SmartMeterStatus).MaxLoad]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.maxLoad",
            defaultMessage: "Maxim\xe1ln\xed odb\u011Br domu"
        }),
        [(0, $8ni7a.SmartMeterStatus).Shortage]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.smartMeter.shortage",
            defaultMessage: "V\xfdpadek distribu\u010Dn\xed s\xedt\u011B"
        })
    },
    heatWater: {
        [(0, $8ni7a.HeatWaterStatus).Stop]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.stop",
            defaultMessage: "STOP"
        }),
        [(0, $8ni7a.HeatWaterStatus).Legionella]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.legionella",
            defaultMessage: "Sanace vody"
        }),
        [(0, $8ni7a.HeatWaterStatus).Heating]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.heating",
            defaultMessage: "Vyt\xe1p\u011Bn\xed tepl\xe9 vody"
        }),
        [(0, $8ni7a.HeatWaterStatus).Flexibility]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.flexibility",
            defaultMessage: "Flexibilita aktivn\xed, vyt\xe1p\u011Bn\xed tepl\xe9 vody"
        }),
        [(0, $8ni7a.HeatWaterStatus).SpotHeating]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.spotHeating",
            defaultMessage: "Vyt\xe1p\u011Bn\xed tepl\xe9 vody ze spotu"
        }),
        [(0, $8ni7a.HeatWaterStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.notConnected",
            defaultMessage: "Nelze nav\xe1zat spojen\xed"
        }),
        [(0, $8ni7a.HeatWaterStatus).Overload]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.overload",
            defaultMessage: "P\u0159et\xed\u017Een\xed s\xedt\u011B, vyt\xe1p\u011Bn\xed zastaveno"
        }),
        [(0, $8ni7a.HeatWaterStatus).StopSell]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.stopSell",
            defaultMessage: "P\u0159edeh\u0159ev blokov\xe1n, prodej energie"
        }),
        [(0, $8ni7a.HeatWaterStatus).StopHDO]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.stopHDO",
            defaultMessage: "Oh\u0159ev blokov\xe1n p\u0159i vysok\xe9m tarifu"
        }),
        [(0, $8ni7a.HeatWaterStatus).StopSOC]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.stopSOC",
            defaultMessage: "Blokace vyt\xe1p\u011Bn\xed, n\xedzk\xfd stav baterie"
        }),
        [(0, $8ni7a.HeatWaterStatus).HWError]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.hwError",
            defaultMessage: "Bojler je nah\u0159\xe1t\xfd nebo nedostupn\xfd"
        }),
        [(0, $8ni7a.HeatWaterStatus).TempError]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.tempError",
            defaultMessage: "Teplotn\xed \u010Didlo nen\xed dostupn\xe9"
        }),
        [(0, $8ni7a.HeatWaterStatus).InverterError]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.inverterError",
            defaultMessage: "P\u0159edeh\u0159ev bojleru neaktivn\xed, nen\xed dostupn\xfd st\u0159\xedda\u010D"
        }),
        [(0, $8ni7a.HeatWaterStatus).SmartMeterError]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.smartMeterError",
            defaultMessage: "P\u0159edeh\u0159ev bojleru neaktivn\xed, nen\xed dostupn\xfd elektrom\u011Br"
        }),
        [(0, $8ni7a.HeatWaterStatus).PVHeating]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.pvHeating",
            defaultMessage: "Vyt\xe1p\u011Bn\xed z p\u0159ebytk\u016F"
        }),
        [(0, $8ni7a.HeatWaterStatus).NotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.notLicensed",
            defaultMessage: "\u0158\xedzen\xed bojleru nen\xed licencovan\xe9"
        }),
        [(0, $8ni7a.HeatWaterStatus).Off]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.heatWater.off",
            defaultMessage: "Vypnuto"
        })
    },
    photovoltaic: {
        [(0, $8ni7a.PhotovoltaicStatus).Standby]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.standby",
            defaultMessage: "Stand-by re\u017Eim"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).Production]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.production",
            defaultMessage: "V\xfdroba energie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).StartUp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.startUp",
            defaultMessage: "Startovac\xed re\u017Eim"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).Discharging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.discharging",
            defaultMessage: "Vyb\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).SpotCharging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.spotCharging",
            defaultMessage: "Nab\xedjen\xed baterie ze spotu"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).ManualCharging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.manualCharging",
            defaultMessage: "Ru\u010Dn\xed nab\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).ManualDischarging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.manualDischarging",
            defaultMessage: "Ru\u010Dn\xed vyb\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).SpotStopDischarging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.spotStopDischarging",
            defaultMessage: "Zastaveno vyb\xedjen\xed, je n\xedzk\xe1 cena na spotu"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).DischargeBlockedByHDO]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.dischargeBlockedByHDO",
            defaultMessage: "Vyb\xedjen\xed baterie pozastaveno, aktivn\xed vysok\xfd tarif (HDO)"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).DischargeBlockedByComponents]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.dischargeBlockedByComponents",
            defaultMessage: "Vyb\xedjen\xed baterie pozastaveno kv\u016Fli spot\u0159eb\u011B vybran\xfdch technologi\xed"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityCharging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityCharging",
            defaultMessage: "Flexibilita aktivn\xed, nab\xedjen\xed baterie ze s\xedt\u011B"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityDischarging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityDischarging",
            defaultMessage: "Flexibilita aktivn\xed, vyb\xedjen\xed baterie do s\xedt\u011B"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityFeedInPriority]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityFeedInPriority",
            defaultMessage: "Flexibilita aktivn\xed, priorita p\u0159etoku do s\xedt\u011B"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityDoNotDischarge]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityDoNotDischarge",
            defaultMessage: "Flexibilita aktivn\xed, z\xe1kaz vyb\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityBatteryStop]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityBatteryStop",
            defaultMessage: "Flexibilita aktivn\xed, zastaveno vyb\xedjen\xed i nab\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FlexibilityOverflowRestricted]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.flexibilityOverflowRestricted",
            defaultMessage: "Flexibilita aktivn\xed, z\xe1kaz p\u0159etoku do s\xedt\u011B"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).FeedInPriority]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.feedInPriority",
            defaultMessage: "Priorita p\u0159etoku do s\xedt\u011B"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).PlanCharge]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.planCharge",
            defaultMessage: "Pl\xe1novan\xe9 nab\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).PlanDischarge]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.planDischarge",
            defaultMessage: "Pl\xe1novan\xe9 vyb\xedjen\xed baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.notConnected",
            defaultMessage: "Nelze nav\xe1zat spojen\xed"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).Idle]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.idle",
            defaultMessage: "Re\u017Eim sp\xe1nku"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).SellBatteryEnergy]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.sellBatteryEnergy",
            defaultMessage: "Prodej energie z baterie"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).NotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.notLicensed",
            defaultMessage: "\u0158\xedzen\xed FVE nen\xed licencovan\xe1"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).NoneInverter]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.noneInverter",
            defaultMessage: "Typ st\u0159\xedda\u010De nenastaven"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).DistributionLimit]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.distributionLimit",
            defaultMessage: "Distribuce omezuje v\xfdkon"
        }),
        [(0, $8ni7a.PhotovoltaicStatus).ForcedOverflow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.photovoltaic.forcedOverflow",
            defaultMessage: "Flexibilita aktivn\xed, vynucen\xfd p\u0159etok do s\xedt\u011B"
        })
    },
    wind: {
        [(0, $8ni7a.WindStatus).Production]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.wind.production",
            defaultMessage: "V\xfdroba energie"
        }),
        [(0, $8ni7a.WindStatus).Stop]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.wind.stop",
            defaultMessage: "STOP"
        }),
        [(0, $8ni7a.WindStatus).Unavailable]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.wind.unavailable",
            defaultMessage: "Za\u0159\xedzen\xed nen\xed dostupn\xe9"
        })
    },
    thermostat: {
        [(0, $8ni7a.ThermostatLevel).Deactivated]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostat.deactivated",
            defaultMessage: "Neaktivn\xed"
        }),
        [(0, $8ni7a.ThermostatLevel).Heating]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostat.heating",
            defaultMessage: "Vyt\xe1p\u011Bn\xed"
        }),
        [(0, $8ni7a.ThermostatLevel).Cooling]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostat.cooling",
            defaultMessage: "Chlazen\xed"
        }),
        [(0, $8ni7a.ThermostatLevel).StandBy]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostat.standby",
            defaultMessage: "Standby"
        }),
        [(0, $8ni7a.ThermostatLevel).TempErr]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostat.tempErr",
            defaultMessage: "Chyba Teploty"
        })
    },
    thermostatFlexibility: {
        [(0, $8ni7a.ThermostatFlexibilityLevel).IncreasePv]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostatFlexibility.increasePv",
            defaultMessage: "Flexibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle fotovoltaiky"
        }),
        [(0, $8ni7a.ThermostatFlexibilityLevel).IncreaseSpot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostatFlexibility.increaseSpot",
            defaultMessage: "Flexibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle SPOTU"
        }),
        [(0, $8ni7a.ThermostatFlexibilityLevel).Normal]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostatFlexibility.normal",
            defaultMessage: "Norm\xe1ln\xed"
        }),
        [(0, $8ni7a.ThermostatFlexibilityLevel).ReductionSpot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "level.thermostatFlexibility.reductionSpot",
            defaultMessage: "Flexibilita vyu\u017Eita pro sn\xed\u017Een\xed teploty dle SPOTU"
        })
    },
    plug: {
        [(0, $8ni7a.PlugStatus).STOP]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.stop",
            defaultMessage: "STOP"
        }),
        [(0, $8ni7a.PlugStatus).BatteryControl]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.batteryControl",
            defaultMessage: "Z\xe1suvka aktivn\xed podle baterie"
        }),
        [(0, $8ni7a.PlugStatus).SpotControl]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.spotControl",
            defaultMessage: "Z\xe1suvka aktivn\xed podle spotu"
        }),
        [(0, $8ni7a.PlugStatus).OverflowControl]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.overflowControl",
            defaultMessage: "Z\xe1suvka aktivn\xed podle p\u0159etoku"
        }),
        [(0, $8ni7a.PlugStatus).TimeControl]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.timeControl",
            defaultMessage: "Z\xe1suvka aktivn\xed podle \u010Dasu"
        }),
        [(0, $8ni7a.PlugStatus).ManualControl]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.manualControl",
            defaultMessage: "Z\xe1suvka aktivn\xed v manu\xe1ln\xedm m\xf3du"
        }),
        [(0, $8ni7a.PlugStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.notConnected",
            defaultMessage: "Z\xe1suvka nen\xed dostupn\xe1"
        }),
        [(0, $8ni7a.PlugStatus).NotActive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.plug.notActive",
            defaultMessage: "Z\xe1suvka neaktivn\xed"
        })
    },
    spotBattery: {
        [(0, $8ni7a.SpotBatteryStatus).FlexibilityPV]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBattery.flexibilityPV",
            defaultMessage: "Flexibilita vyu\u017Eita pro FVE"
        }),
        [(0, $8ni7a.SpotBatteryStatus).FlexibilitySpot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBattery.flexibilitySpot",
            defaultMessage: "Flexibilita vyu\u017Eita pro SPOT"
        }),
        [(0, $8ni7a.SpotBatteryStatus).NoData]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBattery.noData",
            defaultMessage: "Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data"
        }),
        [(0, $8ni7a.SpotBatteryStatus).SpotNotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBattery.spotNotLicensed",
            defaultMessage: "Spot nen\xed licencovan\xfd"
        })
    },
    spotHeatPump: {
        [(0, $8ni7a.SpotHeatPumpStatus).FlexibilityPV]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatPump.flexibilityPV",
            defaultMessage: "Flexibilita vyu\u017Eita pro FVE"
        }),
        [(0, $8ni7a.SpotHeatPumpStatus).FlexibilitySpot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatPump.flexibilitySpot",
            defaultMessage: "Flexibilita vyu\u017Eita pro SPOT"
        }),
        [(0, $8ni7a.SpotHeatPumpStatus).NoData]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatPump.noData",
            defaultMessage: "Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data"
        }),
        [(0, $8ni7a.SpotHeatPumpStatus).SpotNotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatPump.spotNotLicensed",
            defaultMessage: "Spot nen\xed licencovan\xfd"
        })
    },
    spotHeatWater: {
        [(0, $8ni7a.SpotHeatWaterStatus).FlexibilityPV]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatWater.flexibilityPV",
            defaultMessage: "Flexibilita vyu\u017Eita pro FVE"
        }),
        [(0, $8ni7a.SpotHeatWaterStatus).FlexibilitySpot]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatWater.flexibilitySpot",
            defaultMessage: "Flexibilita vyu\u017Eita pro SPOT"
        }),
        [(0, $8ni7a.SpotHeatWaterStatus).NoData]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatWater.noData",
            defaultMessage: "Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data"
        }),
        [(0, $8ni7a.SpotHeatWaterStatus).SpotNotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotHeatWater.spotNotLicensed",
            defaultMessage: "Spot nen\xed licencovan\xfd"
        })
    },
    spotSmartMeter: {
        [(0, $8ni7a.SpotSmartMeterStatus).NoData]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.noData",
            defaultMessage: "Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data"
        }),
        [(0, $8ni7a.SpotSmartMeterStatus).SpotNotLicensed]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.spotNotLicensed",
            defaultMessage: "Spot nen\xed licencovan\xfd"
        }),
        [(0, $8ni7a.SpotSmartMeterStatus).WithoutReduction]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.withoutReduction",
            defaultMessage: "Bez omezen\xed"
        }),
        [(0, $8ni7a.SpotSmartMeterStatus).OverflowFlexibilitySell]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.overflowFlexibilitySell",
            defaultMessage: "Optimalizace p\u0159etoku pro prodej"
        }),
        [(0, $8ni7a.SpotSmartMeterStatus).OverflowDisabled]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.overflowDisabled",
            defaultMessage: "Trval\xe9 omezen\xed p\u0159etoku"
        }),
        [(0, $8ni7a.SpotSmartMeterStatus).OverflowLimited]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotSmartMeter.overflowLimited",
            defaultMessage: "P\u0159etok omezen z d\u016Fvodu z\xe1porn\xe9 ceny"
        })
    },
    spotBatteryDischargeToGrid: {
        [(0, $8ni7a.SpotBatteryDischargeToGridStatus).SpotNotActive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToGrid.spotNotActive",
            defaultMessage: "Nen\xed aktivn\xed spotov\xe9 obchodov\xe1n\xed"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToGridStatus).BatteryDischargingNotActive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToGrid.batteryDischargingNotActive",
            defaultMessage: "Nen\xed aktivovan\xe9 vyb\xedjen\xed do s\xedt\u011B"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToGridStatus).MinPriceNotReached]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToGrid.minPriceNotReached",
            defaultMessage: "Dnes nen\xed spln\u011Bn\xe1 minim\xe1ln\xed cena pro prodej"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToGridStatus).NotEnoughBatteryEnergy]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy",
            defaultMessage: "Dnes se o\u010Dek\xe1v\xe1 vybit\xed baterie p\u0159es noc do vlastn\xed spot\u0159eby"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToGridStatus).BatteryDischargingPlanned]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToGrid.batteryDischargingPlanned",
            defaultMessage: "Dnes je vyb\xedjen\xed aktivn\xed"
        })
    },
    spotBatteryDischargeToHome: {
        [(0, $8ni7a.SpotBatteryDischargeToHomeStatus).AutomaticDischargeMode]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToHome.automaticDischargeMode",
            defaultMessage: "Automatick\xe9 vyb\xedjen\xed baterie dle kapacity"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToHomeStatus).HighPriceDischargeMode]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToHome.highPriceDischargeMode",
            defaultMessage: "Vyb\xedjen\xed baterie p\u0159i vysok\xe9 cen\u011B"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToHomeStatus).MediumAndHighPriceDischargeMode]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode",
            defaultMessage: "Vyb\xedjen\xed baterie p\u0159i st\u0159edn\xed a vysok\xe9 cen\u011B"
        }),
        [(0, $8ni7a.SpotBatteryDischargeToHomeStatus).NotControlled]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryDischargeToHome.notControlled",
            defaultMessage: "Vyb\xedjen\xed baterie nen\xed omezeno"
        })
    },
    spotBatteryChargeFromGrid: {
        [(0, $8ni7a.SpotBatteryChargeFromGridStatus).SpotNotActive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryChargeFromGrid.spotNotActive",
            defaultMessage: "Nen\xed aktivn\xed spotov\xe9 obchodov\xe1n\xed"
        }),
        [(0, $8ni7a.SpotBatteryChargeFromGridStatus).BatteryChargingNotActive]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryChargeFromGrid.batteryChargingNotActive",
            defaultMessage: "Nen\xed aktivovan\xe9 nab\xedjen\xed ze s\xedt\u011B"
        }),
        [(0, $8ni7a.SpotBatteryChargeFromGridStatus).PriceDifferenceTooLow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryChargeFromGrid.priceDifferenceTooLow",
            defaultMessage: "Dnes nen\xed spln\u011Bn\xfd minim\xe1ln\xed rozd\xedl ceny"
        }),
        [(0, $8ni7a.SpotBatteryChargeFromGridStatus).EnoughPVEnergy]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryChargeFromGrid.enoughPVEnergy",
            defaultMessage: "Dnes se o\u010Dek\xe1v\xe1 denn\xed p\u0159ebytek pro nabit\xed baterie"
        }),
        [(0, $8ni7a.SpotBatteryChargeFromGridStatus).BatteryChargingPlanned]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "status.spotBatteryChargeFromGrid.batteryChargingPlanned",
            defaultMessage: "Dnes je nab\xedjen\xed aktivn\xed"
        })
    }
};
const $7df3f57d707c8835$export$d8342fcb5c7ece7a = ({ type: type, index: index })=>{
    const statuses = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        return {
            wind: variables.WIND_STATUS,
            thermostat: (variables.THERMOSTAT_INFO || []).map((info)=>info.status)[index ?? 0],
            thermostatFlexibility: (variables.THERMOSTAT_INFO || []).map((info)=>info.statusFlexibility)[index ?? 0],
            smartMeter: variables.EM_INFO.Status,
            heatWater: variables.HW_INFO.Status,
            photovoltaic: variables.PV_INFO.Status,
            spotBattery: variables.SP_BAT_STATUS,
            spotBatteryDischargeToGrid: variables.SP_DISCHARGE_BATTERY_TO_GRID_STATUS,
            spotBatteryDischargeToHome: variables.SP_DISCHARGE_BATTERY_TO_HOME_STATUS,
            spotBatteryChargeFromGrid: variables.SP_CHARGE_BATTERY_FROM_GRID_STATUS,
            spotHeatWater: variables.SP_HW_STATUS,
            spotHeatPump: variables.SP_HP_STATUS,
            spotSmartMeter: variables.SP_EM_STATUS,
            plug: (variables.PL_INFO || []).map((info)=>info.Status)[index ?? 0]
        };
    });
    if (!(type in $7df3f57d707c8835$var$mapping)) return null;
    const messages = $7df3f57d707c8835$var$mapping[type];
    if (!(statuses[type] in messages)) return null;
    return messages[statuses[type]];
};



var $2lSXC = parcelRequire("2lSXC");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $9Jots = parcelRequire("9Jots");
function $beed7bfc27ef6789$export$86415ebf4eb36b8c(dateLeft, dateRight) {
    const _dateLeft = (0, $9Jots.toDate)(dateLeft);
    const _dateRight = (0, $9Jots.toDate)(dateRight);
    const sign = $beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $30481ff49751e85f$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($beed7bfc27ef6789$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $beed7bfc27ef6789$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
var // Fallback for modularized imports:
$beed7bfc27ef6789$export$2e2bcd8739ae039 = $beed7bfc27ef6789$export$86415ebf4eb36b8c;



var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $23H42 = parcelRequire("23H42");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $7pTac = parcelRequire("7pTac");

var $iH29s = parcelRequire("iH29s");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $u24M4 = parcelRequire("u24M4");
// src/use-snap-carousel.tsx

var $acw62 = parcelRequire("acw62");
var $f1c0929d6ff6c71f$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// src/use-snap-carousel.tsx
var $f1c0929d6ff6c71f$export$caa0bec8be7df58e = ({ axis: axis = "x", initialPages: initialPages = [] } = {})=>{
    const dimension = axis === "x" ? "width" : "height";
    const scrollDimension = axis === "x" ? "scrollWidth" : "scrollHeight";
    const clientDimension = axis === "x" ? "clientWidth" : "clientHeight";
    const nearSidePos = axis === "x" ? "left" : "top";
    const farSidePos = axis === "x" ? "right" : "bottom";
    const scrollPos = axis === "x" ? "scrollLeft" : "scrollTop";
    const [scrollEl, setScrollEl] = (0, $acw62.useState)(null);
    const [{ pages: pages, activePageIndex: activePageIndex }, setCarouselState] = (0, $acw62.useState)({
        pages: initialPages,
        activePageIndex: 0
    });
    const refreshActivePage = (0, $acw62.useCallback)((pages2)=>{
        if (!scrollEl) return;
        const hasScrolledToEnd = Math.floor(scrollEl[scrollDimension] - scrollEl[scrollPos]) <= scrollEl[clientDimension];
        if (hasScrolledToEnd) {
            setCarouselState({
                pages: pages2,
                activePageIndex: pages2.length - 1
            });
            return;
        }
        const items = Array.from(scrollEl.children);
        const scrollPort = scrollEl.getBoundingClientRect();
        const offsets = pages2.map((page)=>{
            const leadIndex = page[0];
            const leadEl = items[leadIndex];
            $f1c0929d6ff6c71f$var$assert(leadEl instanceof HTMLElement, "Expected HTMLElement");
            const scrollSpacing = $f1c0929d6ff6c71f$var$getEffectiveScrollSpacing(scrollEl, leadEl, nearSidePos);
            const rect = leadEl.getBoundingClientRect();
            const offset = rect[nearSidePos] - scrollPort[nearSidePos] - scrollSpacing;
            return Math.abs(offset);
        });
        const minOffset = Math.min(...offsets);
        const nextActivePageIndex = offsets.indexOf(minOffset);
        setCarouselState({
            pages: pages2,
            activePageIndex: nextActivePageIndex
        });
    }, [
        scrollEl,
        clientDimension,
        nearSidePos,
        scrollDimension,
        scrollPos
    ]);
    const refresh = (0, $acw62.useCallback)(()=>{
        if (!scrollEl) return;
        const items = Array.from(scrollEl.children);
        const scrollPort = scrollEl.getBoundingClientRect();
        let currPageStartPos;
        const pages2 = items.reduce((acc, item, i)=>{
            $f1c0929d6ff6c71f$var$assert(item instanceof HTMLElement, "Expected HTMLElement");
            const currPage = acc[acc.length - 1];
            const rect = $f1c0929d6ff6c71f$var$getOffsetRect(item, item.parentElement);
            if (!currPage || item.dataset.shouldSnap === "true" || rect[farSidePos] - currPageStartPos > Math.ceil(scrollPort[dimension])) {
                acc.push([
                    i
                ]);
                const scrollSpacing = $f1c0929d6ff6c71f$var$getEffectiveScrollSpacing(scrollEl, item, nearSidePos);
                currPageStartPos = rect[nearSidePos] - scrollSpacing;
            } else currPage.push(i);
            return acc;
        }, []);
        refreshActivePage(pages2);
    }, [
        refreshActivePage,
        scrollEl,
        dimension,
        farSidePos,
        nearSidePos
    ]);
    $f1c0929d6ff6c71f$var$useIsomorphicLayoutEffect(()=>{
        refresh();
    }, [
        refresh
    ]);
    (0, $acw62.useEffect)(()=>{
        const handle = ()=>{
            refresh();
        };
        window.addEventListener("resize", handle);
        window.addEventListener("orientationchange", handle);
        return ()=>{
            window.removeEventListener("resize", handle);
            window.removeEventListener("orientationchange", handle);
        };
    }, [
        refresh
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!scrollEl) return;
        const handle = ()=>{
            refreshActivePage(pages);
        };
        scrollEl.addEventListener("scroll", handle);
        return ()=>{
            scrollEl.removeEventListener("scroll", handle);
        };
    }, [
        refreshActivePage,
        pages,
        scrollEl
    ]);
    const handleGoTo = (index, opts)=>{
        if (!scrollEl) return;
        const page = pages[index];
        if (!page) return;
        const items = Array.from(scrollEl.children);
        const leadIndex = page[0];
        const leadEl = items[leadIndex];
        if (!(leadEl instanceof HTMLElement)) return;
        const scrollSpacing = $f1c0929d6ff6c71f$var$getEffectiveScrollSpacing(scrollEl, leadEl, nearSidePos);
        const behavior = (opts == null ? void 0 : opts.behavior) || "smooth";
        scrollEl.scrollTo({
            behavior: behavior,
            [nearSidePos]: $f1c0929d6ff6c71f$var$getOffsetRect(leadEl, leadEl.parentElement)[nearSidePos] - scrollSpacing
        });
    };
    const handlePrev = (opts)=>{
        handleGoTo(activePageIndex - 1, opts);
    };
    const handleNext = (opts)=>{
        handleGoTo(activePageIndex + 1, opts);
    };
    const snapPointIndexes = (0, $acw62.useMemo)(()=>new Set(pages.map((page)=>page[0])), [
        pages
    ]);
    const hasPrevPage = activePageIndex > 0;
    const hasNextPage = activePageIndex < pages.length - 1;
    return {
        hasPrevPage: hasPrevPage,
        hasNextPage: hasNextPage,
        prev: handlePrev,
        next: handleNext,
        goTo: handleGoTo,
        refresh: refresh,
        pages: pages,
        activePageIndex: activePageIndex,
        snapPointIndexes: snapPointIndexes,
        scrollRef: setScrollEl
    };
};
var $f1c0929d6ff6c71f$var$getOffsetRect = (el, relativeTo)=>{
    const rect = $f1c0929d6ff6c71f$var$_getOffsetRect(el);
    if (!relativeTo) return rect;
    const relativeRect = $f1c0929d6ff6c71f$var$_getOffsetRect(relativeTo);
    return {
        left: rect.left - relativeRect.left,
        top: rect.top - relativeRect.top,
        right: rect.right - relativeRect.left,
        bottom: rect.bottom - relativeRect.top,
        width: rect.width,
        height: rect.height
    };
};
var $f1c0929d6ff6c71f$var$_getOffsetRect = (el)=>{
    const rect = el.getBoundingClientRect();
    let scrollLeft = 0;
    let scrollTop = 0;
    let parentEl = el.parentElement;
    while(parentEl){
        scrollLeft += parentEl.scrollLeft;
        scrollTop += parentEl.scrollTop;
        parentEl = parentEl.parentElement;
    }
    const left = rect.left + scrollLeft;
    const top = rect.top + scrollTop;
    return {
        left: left,
        top: top,
        right: left + rect.width,
        bottom: top + rect.height,
        width: rect.width,
        height: rect.height
    };
};
var $f1c0929d6ff6c71f$var$getScrollPaddingUsedValue = (el, pos)=>{
    const style = window.getComputedStyle(el);
    const scrollPadding = style.getPropertyValue(`scroll-padding-${pos}`) || "0px";
    if (scrollPadding === "auto") return 0;
    const invalidMsg = `Unsupported scroll padding value, expected <length> or <percentage> value, received ${scrollPadding}`;
    if (scrollPadding.endsWith("px")) {
        const value = parseInt(scrollPadding);
        $f1c0929d6ff6c71f$var$assert(!Number.isNaN(value), invalidMsg);
        return value;
    }
    if (scrollPadding.endsWith("%")) {
        const value = parseInt(scrollPadding);
        $f1c0929d6ff6c71f$var$assert(!Number.isNaN(value), invalidMsg);
        return el.clientWidth / 100 * value;
    }
    throw new $f1c0929d6ff6c71f$var$RSCError(invalidMsg);
};
var $f1c0929d6ff6c71f$var$getScrollMarginUsedValue = (el, pos)=>{
    const style = window.getComputedStyle(el);
    const scrollMargin = style.getPropertyValue(`scroll-margin-${pos}`) || "0px";
    const invalidMsg = `Unsupported scroll margin value, expected <length> value, received ${scrollMargin}`;
    $f1c0929d6ff6c71f$var$assert(scrollMargin.endsWith("px"), invalidMsg);
    const value = parseInt(scrollMargin);
    $f1c0929d6ff6c71f$var$assert(!Number.isNaN(value), invalidMsg);
    return value;
};
var $f1c0929d6ff6c71f$var$getEffectiveScrollSpacing = (scrollEl, itemEl, pos)=>{
    const scrollPadding = $f1c0929d6ff6c71f$var$getScrollPaddingUsedValue(scrollEl, pos);
    const scrollMargin = $f1c0929d6ff6c71f$var$getScrollMarginUsedValue(itemEl, pos);
    const rect = $f1c0929d6ff6c71f$var$getOffsetRect(itemEl, itemEl.parentElement);
    return Math.min(scrollPadding + scrollMargin, rect[pos]);
};
function $f1c0929d6ff6c71f$var$assert(value, message) {
    if (value) return;
    throw new $f1c0929d6ff6c71f$var$RSCError(message);
}
var $f1c0929d6ff6c71f$var$RSCError = class extends Error {
    constructor(message){
        super(`[react-snap-carousel]: ${message}`);
    }
};



var $exNvH = parcelRequire("exNvH");
const $237759eeb6c05aa1$export$144901db2ea8e967 = ({ items: items, renderItem: renderItem, sx: sx })=>{
    const { scrollRef: scrollRef, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, prev: prev, next: next, snapPointIndexes: snapPointIndexes, activePageIndex: activePageIndex } = (0, $f1c0929d6ff6c71f$export$caa0bec8be7df58e)();
    const arrowInset = '0.5rem';
    const arrowSx = {
        position: 'absolute',
        top: 180,
        zIndex: 3,
        p: '1rem',
        fontSize: '0.5rem',
        color: 'primary.main'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            position: 'relative',
            mx: -3,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            ...sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    overflow: 'auto',
                    scrollSnapType: 'x mandatory',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    }
                },
                ref: scrollRef,
                children: items.map((item, i)=>renderItem({
                        item: item,
                        isSnapPoint: snapPointIndexes.has(i)
                    }))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                sx: {
                    left: arrowInset,
                    ...arrowSx
                },
                onClick: ()=>prev(),
                disabled: !hasPrevPage,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exNvH.ChevronRight), {
                    sx: {
                        transform: 'rotate(180deg)',
                        fontSize: '0.75rem'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                sx: {
                    right: arrowInset,
                    ...arrowSx
                },
                onClick: ()=>next(),
                disabled: !hasNextPage,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exNvH.ChevronRight), {
                    sx: {
                        fontSize: '0.75rem'
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '6px',
                    pt: {
                        sm: 4
                    },
                    mt: 'auto'
                },
                children: items.map((_item, i)=>{
                    const active = i === activePageIndex;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            height: '0.125rem',
                            width: active ? '3.75rem' : '0.5rem',
                            bgcolor: active ? 'primary.main' : 'grey.500',
                            borderRadius: 1,
                            transition: 'width 0.3s ease, background-color 0.3s ease'
                        }
                    }, i);
                })
            })
        ]
    });
};
const $237759eeb6c05aa1$export$42c20acb2971398c = ({ isSnapPoint: isSnapPoint, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            width: '100%',
            height: '100%',
            flexShrink: 0,
            scrollSnapAlign: isSnapPoint ? 'start' : 'none',
            px: 3
        },
        children: children
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $u24M4 = parcelRequire("u24M4");


var $iD7Z3 = parcelRequire("iD7Z3");
const $c106e9fba1393da0$export$fba2fb7cd781b7ac = ({ onClose: onClose, icon: icon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f30deb19dfdb1c2$export$f39c2d165cd861fe), {}) })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
        onClick: onClose,
        sx: {
            position: 'absolute',
            zIndex: 10,
            right: 8,
            top: 8,
            color: (0, $iD7Z3.colors).richBlack
        },
        children: icon
    });



var $1Bnx5 = parcelRequire("1Bnx5");
var $09a057cd117da772$exports = {};
$09a057cd117da772$exports = import.meta.resolve("XBVcL");


const $cf34ccb657881384$var$featureNotifications = new URL($09a057cd117da772$exports);
var $3e848e0c58911841$exports = {};
$3e848e0c58911841$exports = import.meta.resolve("5kuXG");


const $cf34ccb657881384$var$featureCharts = new URL($3e848e0c58911841$exports);
var $73aab061fefae561$exports = {};
$73aab061fefae561$exports = import.meta.resolve("aadKP");


const $cf34ccb657881384$var$featureSchedule = new URL($73aab061fefae561$exports);
var $b33a64330771f556$exports = {};
$b33a64330771f556$exports = import.meta.resolve("5GqSN");


const $cf34ccb657881384$var$featureSpot = new URL($b33a64330771f556$exports);
var $bc963cc875bb2ef3$exports = {};
$bc963cc875bb2ef3$exports = import.meta.resolve("hstr0");


const $cf34ccb657881384$var$featureReports = new URL($bc963cc875bb2ef3$exports);
const $cf34ccb657881384$var$FeaturesImageCarousel = (0, $1Bnx5.default)((0, $klPA2.default))`
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  animation: fadeImages 15s infinite;

  @keyframes fadeImages {
    0%,
    18% {
      background-image: url(${$cf34ccb657881384$var$featureNotifications.toString()});
      opacity: 1;
    }
    20% {
      background-image: url(${$cf34ccb657881384$var$featureCharts.toString()});
      opacity: 1;
    }
    21%,
    38% {
      background-image: url(${$cf34ccb657881384$var$featureCharts.toString()});
      opacity: 1;
    }
    40% {
      background-image: url(${$cf34ccb657881384$var$featureSchedule.toString()});
      opacity: 1;
    }
    41%,
    58% {
      background-image: url(${$cf34ccb657881384$var$featureSchedule.toString()});
      opacity: 1;
    }
    60% {
      background-image: url(${$cf34ccb657881384$var$featureSpot.toString()});
      opacity: 1;
    }
    61%,
    78% {
      background-image: url(${$cf34ccb657881384$var$featureSpot.toString()});
      opacity: 1;
    }
    80% {
      background-image: url(${$cf34ccb657881384$var$featureReports.toString()});
      opacity: 1;
    }
    81%,
    98% {
      background-image: url(${$cf34ccb657881384$var$featureReports.toString()});
      opacity: 1;
    }
    100% {
      background-image: url(${$cf34ccb657881384$var$featureNotifications.toString()});
      opacity: 1;
    }
  }
`;
const $cf34ccb657881384$export$ce1b70c41a3d2697 = ({ open: open, onClose: onClose })=>{
    const { mutateAsync: getSubscribeLink } = (0, $iH29s.trpc).subscriptions.getSubscribeLink.useMutation();
    const onSubscribe = async ()=>{
        try {
            const { link: link } = await getSubscribeLink({
                url: window.location.href
            });
            window.location.href = link;
        } catch (error) {
            alert("Do\u0161lo k chyb\u011B p\u0159i z\xedsk\xe1v\xe1n\xed odkazu na p\u0159edplatn\xe9. Zkuste to pros\xedm znovu pozd\u011Bji.");
        }
    };
    const items = [
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.notifications.title",
                defaultMessage: "Notifikace"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.notifications.subtitle",
                defaultMessage: "Z\xedsk\xe1vejte notifikace o z\xe1porn\xfdch cen\xe1ch, nabit\xe9 baterii a dal\u0161\xedch ud\xe1lostech"
            }),
            imageSrc: $cf34ccb657881384$var$featureNotifications.toString()
        },
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.charts.title",
                defaultMessage: "Detailn\xed grafy"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.charts.subtitle",
                defaultMessage: "Z\xedskejte mo\u017Enost sledovat v\xfdkon jednotliv\xfdch string\u016F, spot\u0159ebu dle f\xe1z\xed a dal\u0161\xed podrobn\xe9 informace."
            }),
            imageSrc: $cf34ccb657881384$var$featureCharts.toString()
        },
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.schedule.title",
                defaultMessage: "Vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1\u0159"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.schedule.subtitle",
                defaultMessage: "Napl\xe1nujte si ru\u010Dn\u011B nab\xedjen\xed \u010Di vyb\xedjen\xed baterie dle pot\u0159eby"
            }),
            imageSrc: $cf34ccb657881384$var$featureSchedule.toString()
        },
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.reports.title",
                defaultMessage: "Pokro\u010Dil\xe9 reporty"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.reports.subtitle",
                defaultMessage: "Detailn\xed m\u011Bs\xed\u010Dn\xed reporty, kter\xe9 v\xe1m poskytnou jasn\xfd obraz o v\xfdrob\u011B, spot\u0159eb\u011B a vyu\u017Eit\xed energie ve va\u0161\xed dom\xe1cnosti. V\u0161echny d\u016Fle\u017Eit\xe9 \xfadaje m\xe1te na jednom m\xedst\u011B - srozumiteln\u011B, p\u0159ehledn\u011B a dopln\u011Bn\xe9 grafy."
            }),
            imageSrc: $cf34ccb657881384$var$featureReports.toString(),
            imageSx: {}
        },
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.spot.title",
                defaultMessage: "Historie spotov\xfdch cen"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.spot.subtitle",
                defaultMessage: "Z\xedsktejte mo\u017Enost nahl\xe9dnout do historie spotov\xfdch cen a pl\xe1n\u016F, kter\xe9 Infigy v minulosti p\u0159ipravilo"
            }),
            imageSrc: $cf34ccb657881384$var$featureSpot.toString()
        },
        {
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.other_benefits.title",
                defaultMessage: "Dal\u0161\xed benefity p\u0159ijdou brzy"
            }),
            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "premium.dialog.other_benefits.subtitle",
                defaultMessage: "P\u0159ipravujeme spoustu dal\u0161\xedch benefit\u016F, kter\xe9 budeme postupn\u011B uvol\u0148ovat pro p\u0159edplatitele Infigy Plus"
            }),
            imageComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($cf34ccb657881384$var$FeaturesImageCarousel, {
                sx: {
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    width: '100%',
                    height: 300,
                    mt: 4,
                    mb: 3,
                    mx: 'auto'
                }
            })
        }
    ];
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('sm'));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
            open: open,
            onClose: onClose,
            fullScreen: !sm,
            slotProps: {
                paper: {
                    sx: {
                        bgcolor: 'secondary.main'
                    }
                }
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                    sx: {},
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $237759eeb6c05aa1$export$144901db2ea8e967), {
                        items: items,
                        sx: {
                            pt: {
                                xs: 1,
                                md: 0
                            }
                        },
                        renderItem: ({ item: item, isSnapPoint: isSnapPoint })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $237759eeb6c05aa1$export$42c20acb2971398c), {
                                isSnapPoint: isSnapPoint,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                        variant: "h2",
                                        sx: {
                                            textAlign: 'center',
                                            mt: 2
                                        },
                                        children: "Infigy Plus"
                                    }),
                                    item.imageComponent ? item.imageComponent : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                        sx: {
                                            backgroundImage: item.imageSrc ? `url('${item.imageSrc}')` : 'none',
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center center',
                                            width: '100%',
                                            height: 300,
                                            mt: 4,
                                            mb: 3,
                                            mx: 'auto',
                                            ...item.imageSx || {}
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                        sx: {
                                            maxWidth: 400,
                                            mx: 'auto'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                variant: "h3",
                                                sx: {
                                                    textAlign: 'center',
                                                    mb: 1.5
                                                },
                                                children: item.subtitle
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                variant: "body1",
                                                sx: {
                                                    textAlign: 'center'
                                                },
                                                children: item.content
                                            })
                                        ]
                                    })
                                ]
                            }, item.imageSrc)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
                    alignItems: "center",
                    sx: {
                        pt: 2,
                        pb: 2,
                        gap: {
                            xs: 0.5,
                            sm: 1.5
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            onClick: onSubscribe,
                            variant: "contained",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "premium.dialog.save",
                                defaultMessage: "P\u0159edplatit Infigy Plus"
                            })
                        })
                    })
                })
            ]
        })
    });
};
const $cf34ccb657881384$export$a6ec019a16d2835 = ()=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    return {
        dialog: /*#__PURE__*/ (0, $ayMG0.jsx)($cf34ccb657881384$export$ce1b70c41a3d2697, {
            open: open,
            onClose: ()=>setOpen(false)
        }),
        open: ()=>setOpen(true),
        close: ()=>setOpen(false),
        isOpen: open
    };
};



var $iH29s = parcelRequire("iH29s");

var $iD7Z3 = parcelRequire("iD7Z3");

parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");
var $2f7ece2e30c3d879$exports = {};
$2f7ece2e30c3d879$exports = import.meta.resolve("3TybX");


var $2a29fc0beb22b636$exports = {};
$2a29fc0beb22b636$exports = import.meta.resolve("lhA95");


const $f579057103a82b5f$export$6a4327ccdb5e4fea = ({ variant: variant = 'default', inactiveTitle: inactiveTitle, inactiveSubtitle: inactiveSubtitle })=>{
    const [premiumActive, devPremiumOverride, premiumBannerHiddenPermanently, premiumBannerHiddenAt, license] = (0, $2lSXC.useSelector)(({ variables: { PREMIUM: PREMIUM, DEV_PREMIUM_OVERRIDE: DEV_PREMIUM_OVERRIDE, PREMIUM_BANNER_HIDDEN_PERMANENTLY: PREMIUM_BANNER_HIDDEN_PERMANENTLY, PREMIUM_BANNER_HIDDEN_AT: PREMIUM_BANNER_HIDDEN_AT, LICENSE: LICENSE } })=>[
            PREMIUM,
            DEV_PREMIUM_OVERRIDE,
            PREMIUM_BANNER_HIDDEN_PERMANENTLY,
            PREMIUM_BANNER_HIDDEN_AT,
            LICENSE
        ]);
    const { dialog: dialog, open: open } = (0, $cf34ccb657881384$export$a6ec019a16d2835)();
    const { onHide: onHide, hideDialog: hideDialog } = $f579057103a82b5f$var$useHidePremiumBanner({
        openPremiumDialog: open
    });
    const { mutateAsync: getManagementLink } = (0, $iH29s.trpc).subscriptions.getManagementLink.useMutation();
    const onOpenManagement = async ()=>{
        try {
            const { link: link } = await getManagementLink({
                url: window.location.href
            });
            window.location.href = link;
        } catch (error) {
            alert("Do\u0161lo k chyb\u011B p\u0159i z\xedsk\xe1v\xe1n\xed odkazu na p\u0159edplatn\xe9. Zkuste to pros\xedm znovu pozd\u011Bji.");
        }
    };
    const activeContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "premium.banner.active.title",
                    defaultMessage: "Moje Infigy Plus"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    maxWidth: 400,
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "premium.banner.active.subtitle",
                    defaultMessage: "P\u0159edplatn\xe9 Infigy Plus je aktivn\xed. M\u016F\u017Eete si u\u017E\xedvat v\u0161ech vychyt\xe1vek, kter\xe9 jsou d\xedky n\u011Bmu v aplikaci nav\xedc."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                children: devPremiumOverride ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "premium.banner.active.dev_mode",
                        defaultMessage: "P\u0159edplatn\xe9 je aktivn\xed pro v\xfdvoj"
                    })
                }) : license === (0, $8ni7a.License).INDUSTRIAL ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    size: "small",
                    onClick: onOpenManagement,
                    sx: {
                        textTransform: 'none'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "premium.banner.active.button",
                        defaultMessage: "Spravovat p\u0159edplatn\xe9"
                    })
                })
            })
        ]
    });
    const inactiveContent = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                children: inactiveTitle ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "premium.banner.inactive.title",
                    defaultMessage: "Infigy Plus nen\xed aktivn\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                children: inactiveSubtitle ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "premium.banner.inactive.subtitle",
                    defaultMessage: "Posu\u0148te svou spr\xe1vu energi\xed na je\u0161t\u011B vy\u0161\u0161\xed \xfarove\u0148. S Infigy Plus dostanete dal\u0161\xed chytr\xe9 n\xe1stroje - detailn\xed grafy, okam\u017Eit\xe9 notifikace, vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1\u0159, p\u0159ehledn\xe9 reporty a dal\u0161\xed."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    size: "small",
                    onClick: open,
                    sx: {
                        textTransform: 'none'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "premium.banner.inactive.button",
                        defaultMessage: "Zjistit v\xedce"
                    })
                })
            })
        ]
    });
    const premiumBannerHiddenTemporarily = (0, $acw62.useMemo)(()=>{
        if (!premiumBannerHiddenAt) return false;
        return (0, $beed7bfc27ef6789$export$86415ebf4eb36b8c)(new Date(), new Date(premiumBannerHiddenAt)) < 7;
    }, [
        premiumBannerHiddenAt
    ]);
    if ((0, $c8a10aaf71cf6235$export$77498849b0391674)()) return null;
    if (variant !== 'settings' && (premiumActive || premiumBannerHiddenPermanently || premiumBannerHiddenTemporarily)) return null;
    const patternBg = premiumActive;
    const mockupBg = !patternBg;
    const patternBgSx = patternBg ? {
        backgroundImage: `url('${new URL($2f7ece2e30c3d879$exports).toString()}')`,
        backgroundPosition: 'top right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '200px auto'
    } : {};
    const mockupBgSx = mockupBg ? {
        display: 'grid',
        gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr 300px'
        },
        gridTemplateRows: {
            xs: '160px 1fr',
            sm: '1fr'
        },
        alignItems: 'center',
        p: 0
    } : {};
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
                    sx: {
                        bgcolor: (0, $iD7Z3.colors).richBlack,
                        color: (0, $iD7Z3.colors).white,
                        position: 'relative',
                        overflow: 'hidden',
                        ...patternBgSx,
                        ...mockupBgSx
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
                            gap: 1,
                            sx: {
                                ...mockupBg ? {
                                    p: 2
                                } : {
                                    p: 0
                                }
                            },
                            children: premiumActive ? activeContent : inactiveContent
                        }),
                        mockupBg ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                backgroundImage: `url(${new URL($2a29fc0beb22b636$exports).toString()})`,
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                width: '100%',
                                height: {
                                    xs: 160,
                                    sm: '100%'
                                },
                                order: {
                                    xs: '-1',
                                    sm: '0'
                                },
                                position: 'relative'
                            }
                        }) : null,
                        variant !== 'settings' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            sx: {
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                zIndex: 1,
                                color: (0, $iD7Z3.colors).white
                            },
                            onClick: onHide,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f30deb19dfdb1c2$export$f39c2d165cd861fe), {})
                        })
                    ]
                })
            }),
            dialog,
            hideDialog
        ]
    });
};
const $f579057103a82b5f$var$useHidePremiumBanner = ({ openPremiumDialog: openPremiumDialog })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const onClose = ()=>setOpen(false);
    const dispatch = (0, $2lSXC.useDispatch)();
    const showMore = ()=>{
        openPremiumDialog();
        onClose();
    };
    const showLater = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            PREMIUM_BANNER_HIDDEN_AT: new Date().toISOString()
        }));
        onClose();
    };
    const hidePermanently = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            PREMIUM_BANNER_HIDDEN_PERMANENTLY: true
        }));
        onClose();
    };
    const hideDialog = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "xs",
        slotProps: {
            paper: {
                sx: {
                    bgcolor: 'secondary.main'
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                variant: "h2",
                sx: {
                    textAlign: 'center',
                    py: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "premium.banner.hide.confirm",
                    defaultMessage: "Opravdu chcete skr\xfdt Infigy Plus?"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    sx: {
                        textAlign: 'center',
                        mt: 1
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "premium.banner.hide.confirm.description",
                        defaultMessage: "Kdykoliv m\u016F\u017Eete Infigy Plus znovu prozkoumat v nastaven\xed aplikace."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                sx: {
                    py: 2,
                    flexDirection: 'column',
                    gap: 1.5,
                    '& .MuiButton-root': {
                        width: 280
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: showMore,
                        color: "primary",
                        variant: "contained",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "premium.banner.hide.show_more",
                            defaultMessage: "Zjistit v\xedce"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: showLater,
                        color: "primary",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "premium.banner.hide.later",
                            defaultMessage: "P\u0159ipomenout pozd\u011Bji"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: hidePermanently,
                        variant: "text",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "premium.banner.hide.yes",
                            defaultMessage: "Skr\xfdt"
                        })
                    })
                ]
            })
        ]
    });
    return {
        onHide: ()=>setOpen(true),
        hideDialog: hideDialog
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $iD7Z3 = parcelRequire("iD7Z3");

parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aphAM = parcelRequire("aphAM");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $1DAbm = parcelRequire("1DAbm");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $8zogs = parcelRequire("8zogs");
var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $95ecb421de4cff36$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $4Cod0.default)('MuiLinearProgress', slot);
}
const $95ecb421de4cff36$var$linearProgressClasses = (0, $beCSm.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $95ecb421de4cff36$export$2e2bcd8739ae039 = $95ecb421de4cff36$var$linearProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $87e33f68a58c76cf$var$TRANSITION_DURATION = 4; // seconds
const $87e33f68a58c76cf$var$indeterminate1Keyframe = (0, $8zogs.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $87e33f68a58c76cf$var$indeterminate1Animation = typeof $87e33f68a58c76cf$var$indeterminate1Keyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$87e33f68a58c76cf$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $87e33f68a58c76cf$var$indeterminate2Keyframe = (0, $8zogs.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $87e33f68a58c76cf$var$indeterminate2Animation = typeof $87e33f68a58c76cf$var$indeterminate2Keyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$87e33f68a58c76cf$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $87e33f68a58c76cf$var$bufferKeyframe = (0, $8zogs.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $87e33f68a58c76cf$var$bufferAnimation = typeof $87e33f68a58c76cf$var$bufferKeyframe !== 'string' ? (0, $8zogs.css)`
        animation: ${$87e33f68a58c76cf$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $87e33f68a58c76cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3AM7p.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $3AM7p.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $3AM7p.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $3AM7p.default)(color)}`,
            variant === 'buffer' && `color${(0, $3AM7p.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $95ecb421de4cff36$export$bc8a6ea1eb17d7c6), classes);
};
const $87e33f68a58c76cf$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $87e33f68a58c76cf$var$LinearProgressRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $87e33f68a58c76cf$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $87e33f68a58c76cf$var$LinearProgressDashed = (0, $1Ikg4.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>{
                const backgroundColor = $87e33f68a58c76cf$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $87e33f68a58c76cf$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$87e33f68a58c76cf$var$bufferKeyframe} 3s infinite linear`
});
const $87e33f68a58c76cf$var$LinearProgressBar1 = (0, $1Ikg4.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $3AM7p.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $87e33f68a58c76cf$var$indeterminate1Animation || {
                    animation: `${$87e33f68a58c76cf$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $87e33f68a58c76cf$var$LinearProgressBar2 = (0, $1Ikg4.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $3AM7p.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $87e33f68a58c76cf$var$getColorShade(theme, color),
                        transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $87e33f68a58c76cf$var$indeterminate2Animation || {
                    animation: `${$87e33f68a58c76cf$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $87e33f68a58c76cf$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $87e33f68a58c76cf$var$useUtilityClasses(ownerState);
    const isRtl = (0, $58lXc.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($87e33f68a58c76cf$var$LinearProgressRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($87e33f68a58c76cf$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($87e33f68a58c76cf$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($87e33f68a58c76cf$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $87e33f68a58c76cf$export$2e2bcd8739ae039 = $87e33f68a58c76cf$var$LinearProgress;


var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $219448ca2dce677c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');



var $dHW62 = parcelRequire("dHW62");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gc70Y = parcelRequire("gc70Y");

var $iD7Z3 = parcelRequire("iD7Z3");
const $e99fd02064b63115$export$76fdec35fc38e508 = ({ children: children, sx: sx })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            p: 0,
            '& .MuiPaper-root': {
                boxShadow: 0,
                '&:not(:last-child)': {
                    pb: 0
                },
                '&:not(:last-child):after': {
                    content: '""',
                    display: 'block',
                    borderBottomStyle: 'solid',
                    borderBottomWidth: {
                        xs: 0.25,
                        md: 1
                    },
                    borderBottomColor: (0, $iD7Z3.colors).darkBlue,
                    opacity: {
                        xs: 0.4,
                        md: 0.2
                    },
                    mt: 2.5,
                    mb: 0.5
                }
            },
            ...sx ?? {}
        },
        children: children
    });
};



var $gpaJb = parcelRequire("gpaJb");

var $OLlTf = parcelRequire("OLlTf");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $ngrp2 = parcelRequire("ngrp2");

var $2lSXC = parcelRequire("2lSXC");

var $9iEAl = parcelRequire("9iEAl");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");

var $1sDFO = parcelRequire("1sDFO");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $js9Z9 = parcelRequire("js9Z9");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $8ni7a = parcelRequire("8ni7a");
const $f2ac45c474da7c89$export$a29d188ae7b63a77 = ({ value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "wallbox-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.wallbox_type.label",
                    defaultMessage: "Wallbox"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                labelId: "wallbox-type-label",
                size: "medium",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.wallbox_type.label",
                    defaultMessage: "Wallbox"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).Solax,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.solax",
                            defaultMessage: "Solax - komunikace p\u0159es st\u0159\xedda\u010D"
                        })
                    }, (0, $8ni7a.Wallbox).Solax),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).SolaxEvCharger,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.solax-ev-charger",
                            defaultMessage: "Solax - komunikace p\u0159es Infigy"
                        })
                    }, (0, $8ni7a.Wallbox).SolaxEvCharger),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).Olife,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.olife",
                            defaultMessage: "Olife"
                        })
                    }, (0, $8ni7a.Wallbox).Olife),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).GoodweEvCharger,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.goodwe-ev-charger",
                            defaultMessage: "Goodwe"
                        })
                    }, (0, $8ni7a.Wallbox).GoodweEvCharger),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).EvMate,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.evmate",
                            defaultMessage: "EVmate"
                        })
                    }, (0, $8ni7a.Wallbox).EvMate),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).VictronEvCharger,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.victron-ev-charger",
                            defaultMessage: "Victron EV Charger"
                        })
                    }, (0, $8ni7a.Wallbox).VictronEvCharger),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).Alfen,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.alfen",
                            defaultMessage: "Alfen"
                        })
                    }, (0, $8ni7a.Wallbox).Alfen),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).Ecovolter,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.ecovolter",
                            defaultMessage: "EcoVolter"
                        })
                    }, (0, $8ni7a.Wallbox).Ecovolter),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.Wallbox).None,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.none",
                            defaultMessage: "\u017D\xe1dn\xfd"
                        })
                    }, (0, $8ni7a.Wallbox).None)
                ]
            })
        ]
    });
};



var $iH29s = parcelRequire("iH29s");
const $a07f2bbbc4cb9809$export$6f6885827bdb01af = ({ open: open, onClose: onClose })=>{
    const wallboxTypeFromStore = (0, $2lSXC.useSelector)((s)=>s.variables.WB_TYPE);
    const wallboxConfigFromStore = (0, $2lSXC.useSelector)((s)=>s.variables.WALLBOX_CONFIG || {});
    const [wallboxType, setWallboxType] = (0, $acw62.useState)((0, $8ni7a.Wallbox).Solax);
    const [multipleWallboxes, setMultipleWallboxes] = (0, $acw62.useState)(false);
    const [submitError, setSubmitError] = (0, $acw62.useState)(undefined);
    const [submitErrorDetails, setSubmitErrorDetails] = (0, $acw62.useState)(false);
    const addressTypeVisible = wallboxType === (0, $8ni7a.Wallbox).VictronEvCharger || wallboxType === (0, $8ni7a.Wallbox).Alfen || wallboxType === (0, $8ni7a.Wallbox).EvMate || wallboxType === (0, $8ni7a.Wallbox).MyBox || wallboxType === (0, $8ni7a.Wallbox).GoodweEvCharger || wallboxType === (0, $8ni7a.Wallbox).Ecovolter;
    const defaultWallboxIpAddress = '100.100.1.120';
    const [wallboxIpAddress, setWallboxIpAddress] = (0, $acw62.useState)(defaultWallboxIpAddress);
    // Initialize form based on current config
    (0, $acw62.useEffect)(()=>{
        if (open) {
            // If WB_TYPE is Next and there are wallboxes in config, use first one's type
            if (wallboxTypeFromStore === (0, $8ni7a.Wallbox).Next && Object.keys(wallboxConfigFromStore).length > 0) {
                const firstWallbox = Object.values(wallboxConfigFromStore)[0];
                if (firstWallbox) {
                    setWallboxType(firstWallbox.type);
                    if ('address' in firstWallbox && firstWallbox.address) setWallboxIpAddress(firstWallbox.address);
                }
            } else if (wallboxTypeFromStore !== (0, $8ni7a.Wallbox).None) setWallboxType(wallboxTypeFromStore);
        }
    }, [
        open,
        wallboxTypeFromStore,
        wallboxConfigFromStore
    ]);
    const { mutate: mutate, isLoading: isLoading } = (0, $iH29s.trpc).wallbox.wizardSubmit.useMutation({
        onMutate () {
            setSubmitError(undefined);
            setSubmitErrorDetails(false);
        },
        onSuccess () {
            onClose();
        },
        onError (error) {
            setSubmitError(error.message);
        }
    });
    const submitDisabled = isLoading || multipleWallboxes;
    const handleSubmit = ()=>{
        if (multipleWallboxes) return;
        // Validate IP address if required
        if (addressTypeVisible && !wallboxIpAddress) {
            setSubmitError("IP adresa je povinn\xe1");
            return;
        }
        mutate({
            wallboxType: wallboxType,
            wallboxIpAddress: addressTypeVisible ? wallboxIpAddress : undefined
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox_wizard.title",
                    defaultMessage: "Nastaven\xed wallbox"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    gap: 2.5,
                    sx: {
                        py: 2
                    },
                    children: [
                        submitError && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1sDFO.default), {
                            severity: "error",
                            children: [
                                submitError,
                                submitErrorDetails && /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                    style: {
                                        fontSize: '0.8em',
                                        marginTop: 8
                                    },
                                    children: JSON.stringify(submitError, null, 2)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f2ac45c474da7c89$export$a29d188ae7b63a77), {
                            value: wallboxType,
                            onChange: (type)=>{
                                setWallboxType(type);
                                // Reset IP address when changing type
                                if (type !== (0, $8ni7a.Wallbox).VictronEvCharger && type !== (0, $8ni7a.Wallbox).Alfen && type !== (0, $8ni7a.Wallbox).EvMate && type !== (0, $8ni7a.Wallbox).MyBox && type !== (0, $8ni7a.Wallbox).GoodweEvCharger && type !== (0, $8ni7a.Wallbox).Ecovolter) setWallboxIpAddress(defaultWallboxIpAddress);
                            }
                        }),
                        addressTypeVisible && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_wizard.custom_device_ip_address.input",
                                        defaultMessage: "IP adresa wallboxu"
                                    }),
                                    value: wallboxIpAddress,
                                    onChange: (e)=>setWallboxIpAddress(e.target.value),
                                    fullWidth: true,
                                    required: true,
                                    error: addressTypeVisible && !wallboxIpAddress
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                                    icon: false,
                                    color: "warning",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_wizard.custom_device_ip_address.alert",
                                        defaultMessage: "Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa wallboxu nebude m\u011Bnit (nap\u0159. kdy\u017E wallbox vyu\u017E\xedv\xe1 adresu z DHCP)."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                                checked: multipleWallboxes,
                                onChange: (e)=>setMultipleWallboxes(e.target.checked)
                            }),
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "wallbox_wizard.multiple_wallboxes.label",
                                defaultMessage: "V\xedce wallbox\u016F"
                            }),
                            sx: {
                                mt: -1
                            }
                        }),
                        multipleWallboxes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                                icon: false,
                                color: "warning",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox_wizard.multiple_wallboxes.alert",
                                    defaultMessage: "Pro nastaven\xed v\xedce wallbox\u016F pros\xedm kontaktujte linku podpory. Kontakt najdete v technick\xe9 wiki Infigy."
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox_wizard.cancel",
                            defaultMessage: "Zru\u0161it"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        disabled: submitDisabled,
                        onClick: handleSubmit,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox_wizard.save",
                            defaultMessage: "Ulo\u017Eit"
                        })
                    })
                ]
            })
        ]
    });
};



var $8ni7a = parcelRequire("8ni7a");
const $7153b1eb2fa26705$export$a29d188ae7b63a77 = ()=>{
    const [wizardOpen, setWizardOpen] = (0, $acw62.useState)(false);
    const wallboxType = (0, $2lSXC.useSelector)((s)=>s.variables.WB_TYPE);
    const wizardWallboxInfo = $7153b1eb2fa26705$var$useWizardWallboxInfo();
    const wizardBox = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 0.75,
        children: [
            wallboxType !== (0, $8ni7a.Wallbox).None && wizardWallboxInfo,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                variant: wallboxType === (0, $8ni7a.Wallbox).None ? 'contained' : 'outlined',
                size: "small",
                onClick: ()=>setWizardOpen(true),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox_wizard.open",
                    defaultMessage: "Nastavit wallbox"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                control: wizardBox,
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.wallbox_type",
                    defaultMessage: "Typ wallbox"
                }),
                visibility: {
                    variableId: 'WB_INSTALL'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a07f2bbbc4cb9809$export$6f6885827bdb01af), {
                open: wizardOpen,
                onClose: ()=>setWizardOpen(false)
            })
        ]
    });
};
const $7153b1eb2fa26705$var$useWizardWallboxInfo = ()=>{
    const wallboxType = (0, $2lSXC.useSelector)((s)=>s.variables.WB_TYPE);
    const wallboxConfig = (0, $2lSXC.useSelector)((s)=>s.variables.WALLBOX_CONFIG || {});
    // If Next type and wallboxes in config, show all names separated by comma
    // Check both enum value and string value for compatibility
    if (wallboxType === (0, $8ni7a.Wallbox).Next && Object.keys(wallboxConfig).length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            '& span:not(:last-child):after': {
                content: '", "'
            }
        },
        children: Object.values(wallboxConfig).map((config, index)=>{
            const wallboxTypeValue = config.type;
            const mapped = $7153b1eb2fa26705$var$wallboxMapping[wallboxTypeValue];
            return mapped ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: mapped
            }, index) : null;
        })
    });
    // Fallback to regular mapping
    const mapped = $7153b1eb2fa26705$var$wallboxMapping[wallboxType];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        children: mapped || null
    });
};
const $7153b1eb2fa26705$var$wallboxMapping = {
    [(0, $8ni7a.Wallbox).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.none",
        defaultMessage: "\u017D\xe1dn\xfd"
    }),
    [(0, $8ni7a.Wallbox).Solax]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.solax",
        defaultMessage: "Solax"
    }),
    [(0, $8ni7a.Wallbox).SolaxEvCharger]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.solax-ev-charger",
        defaultMessage: "Solax - komunikace p\u0159es Infigy"
    }),
    [(0, $8ni7a.Wallbox).GoodweEvCharger]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.goodwe-ev-charger",
        defaultMessage: "Goodwe"
    }),
    [(0, $8ni7a.Wallbox).EvMate]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.evmate",
        defaultMessage: "EVmate"
    }),
    [(0, $8ni7a.Wallbox).VictronEvCharger]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.victron-ev-charger",
        defaultMessage: "Victron EV Charger"
    }),
    [(0, $8ni7a.Wallbox).Alfen]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.alfen",
        defaultMessage: "Alfen"
    }),
    [(0, $8ni7a.Wallbox).MyBox]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.mybox",
        defaultMessage: "MyBox"
    }),
    [(0, $8ni7a.Wallbox).Olife]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.olife",
        defaultMessage: "Olife"
    }),
    [(0, $8ni7a.Wallbox).Ecovolter]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.ecovolter",
        defaultMessage: "EcoVolter"
    }),
    [(0, $8ni7a.Wallbox).Next]: null,
    [(0, $8ni7a.Wallbox).AzRouter]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.az_router",
        defaultMessage: "AZ Router"
    })
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $gpaJb = parcelRequire("gpaJb");

var $2zDt6 = parcelRequire("2zDt6");
const $4c6625c87c7e6d95$export$37c8851fa259e26 = (numberSchema)=>(0, $2zDt6.z).preprocess((val)=>parseFloat(String(val).replace(',', '')), numberSchema);
const $4c6625c87c7e6d95$export$2308b12144296da2 = (0, $2zDt6.z).string().length(18, {
    message: "Neplatn\xfd form\xe1t EANu - mus\xed b\xfdt 18 \u010D\xedsel"
}).or((0, $2zDt6.z).string().length(0));
const $4c6625c87c7e6d95$export$2a4885432b9ae89 = (0, $2zDt6.z).string().email({
    message: "Neplatn\xfd form\xe1t emailu"
}).or((0, $2zDt6.z).string().length(0));


const $d4101366a11d69ee$export$32b907da6e4e6ad1 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer",
                    defaultMessage: "Jm\xe9no u\u017Eivatele"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer-subtitle",
                    defaultMessage: "Slou\u017E\xed k identifikaci instalace pro firmu i z\xe1kazn\xedka"
                }),
                inputVariableId: "CUSTOMER",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer.label",
                    defaultMessage: "Jm\xe9no"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer-email",
                    defaultMessage: "Email u\u017Eivatele"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer-email-subtitle",
                    defaultMessage: "Pokud nem\xe1 u\u017Eivatel zalo\u017Een \xfa\u010Det pod t\xedmto emailem, dojde k automatick\xe9mu vytvo\u0159en\xed \xfa\u010Dtu a odesl\xe1n\xed registra\u010Dn\xedho emailu"
                }),
                inputVariableId: "CUSTOMER_EMAIL",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.customer-email.label",
                    defaultMessage: "Email"
                }),
                schema: (0, $4c6625c87c7e6d95$export$2a4885432b9ae89),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.service-email",
                    defaultMessage: "Email servisn\xed firmy"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.service-email-subtitle",
                    defaultMessage: "Pro propojen\xed za\u0159\xedzen\xed s instala\u010Dn\xedm \xfa\u010Dtem je nutn\xe9 zadat email servisn\xed firmy, kter\xfd je ulo\u017Een v Partnersk\xe9 sekci aplikace"
                }),
                inputVariableId: "SERVICE_EMAIL",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.service-email.label",
                    defaultMessage: "Email"
                }),
                schema: (0, $4c6625c87c7e6d95$export$2a4885432b9ae89),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.servicer",
                    defaultMessage: "Jm\xe9no instala\u010Dn\xedho technika"
                }),
                inputVariableId: "SERVICER",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.servicer.label",
                    defaultMessage: "Jm\xe9no"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.solidsun_op",
                    defaultMessage: "SolidSun OP"
                }),
                inputVariableId: "SOLIDSUN_OP_NUMBER",
                visibility: {
                    variableId: 'SOLIDSUN_KZ_API_ENABLED'
                },
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.solidsun_op.label",
                    defaultMessage: "SolidSun OP"
                }),
                fullWidth: true
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $f4Eh3 = parcelRequire("f4Eh3");
var $g04kv = parcelRequire("g04kv");


var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");

var $eD6Co = parcelRequire("eD6Co");

var $awhpc = parcelRequire("awhpc");

var $acw62 = parcelRequire("acw62");

var $6zeBo = parcelRequire("6zeBo");

var $agZ85 = parcelRequire("agZ85");

var $eEJPp = parcelRequire("eEJPp");

var $13KXh = parcelRequire("13KXh");

var $3qSdM = parcelRequire("3qSdM");

var $52FI1 = parcelRequire("52FI1");
const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;



var $1jJMI = parcelRequire("1jJMI");

var $f56pe = parcelRequire("f56pe");
function $0ecb82c136d378f3$var$areArraysEqual(array1, array2, itemComparer = (a, b)=>a === b) {
    return array1.length === array2.length && array1.every((value, index)=>itemComparer(value, array2[index]));
}
var $0ecb82c136d378f3$export$2e2bcd8739ae039 = $0ecb82c136d378f3$var$areArraysEqual;


'use client';
const $07acb049b20deae8$var$INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function $07acb049b20deae8$var$getNewValue(currentValue, step, direction, min, max) {
    return direction === 1 ? Math.min(currentValue + step, max) : Math.max(currentValue - step, min);
}
function $07acb049b20deae8$var$asc(a, b) {
    return a - b;
}
function $07acb049b20deae8$var$findClosest(values, currentValue) {
    const { index: closestIndex } = values.reduce((acc, value, index)=>{
        const distance = Math.abs(currentValue - value);
        if (acc === null || distance < acc.distance || distance === acc.distance) return {
            distance: distance,
            index: index
        };
        return acc;
    }, null) ?? {};
    return closestIndex;
}
function $07acb049b20deae8$var$trackFinger(event, touchId) {
    // The event is TouchEvent
    if (touchId.current !== undefined && event.changedTouches) {
        const touchEvent = event;
        for(let i = 0; i < touchEvent.changedTouches.length; i += 1){
            const touch = touchEvent.changedTouches[i];
            if (touch.identifier === touchId.current) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    // The event is MouseEvent
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $07acb049b20deae8$export$83ce4bc8280540e6(value, min, max) {
    return (value - min) * 100 / (max - min);
}
function $07acb049b20deae8$var$percentToValue(percent, min, max) {
    return (max - min) * percent + min;
}
function $07acb049b20deae8$var$getDecimalPrecision(num) {
    // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
    // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
    if (Math.abs(num) < 1) {
        const parts = num.toExponential().split('e-');
        const matissaDecimalPart = parts[0].split('.')[1];
        return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
    }
    const decimalPart = num.toString().split('.')[1];
    return decimalPart ? decimalPart.length : 0;
}
function $07acb049b20deae8$var$roundValueToStep(value, step, min) {
    const nearest = Math.round((value - min) / step) * step + min;
    return Number(nearest.toFixed($07acb049b20deae8$var$getDecimalPrecision(step)));
}
function $07acb049b20deae8$var$setValueIndex({ values: values, newValue: newValue, index: index }) {
    const output = values.slice();
    output[index] = newValue;
    return output.sort($07acb049b20deae8$var$asc);
}
function $07acb049b20deae8$var$focusThumb({ sliderRef: sliderRef, activeIndex: activeIndex, setActive: setActive }) {
    const doc = (0, $6zeBo.default)(sliderRef.current);
    if (!sliderRef.current?.contains(doc.activeElement) || Number(doc?.activeElement?.getAttribute('data-index')) !== activeIndex) sliderRef.current?.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
    if (setActive) setActive(activeIndex);
}
function $07acb049b20deae8$var$areValuesEqual(newValue, oldValue) {
    if (typeof newValue === 'number' && typeof oldValue === 'number') return newValue === oldValue;
    if (typeof newValue === 'object' && typeof oldValue === 'object') return (0, $0ecb82c136d378f3$export$2e2bcd8739ae039)(newValue, oldValue);
    return false;
}
const $07acb049b20deae8$var$axisProps = {
    horizontal: {
        offset: (percent)=>({
                left: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    'horizontal-reverse': {
        offset: (percent)=>({
                right: `${percent}%`
            }),
        leap: (percent)=>({
                width: `${percent}%`
            })
    },
    vertical: {
        offset: (percent)=>({
                bottom: `${percent}%`
            }),
        leap: (percent)=>({
                height: `${percent}%`
            })
    }
};
const $07acb049b20deae8$export$544bf02140fa9a77 = (x)=>x;
// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
let $07acb049b20deae8$var$cachedSupportsTouchActionNone;
function $07acb049b20deae8$var$doesSupportTouchActionNone() {
    if ($07acb049b20deae8$var$cachedSupportsTouchActionNone === undefined) {
        if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') $07acb049b20deae8$var$cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
        else $07acb049b20deae8$var$cachedSupportsTouchActionNone = true;
    }
    return $07acb049b20deae8$var$cachedSupportsTouchActionNone;
}
function $07acb049b20deae8$export$56b2c08e277f365(parameters) {
    const { 'aria-labelledby': ariaLabelledby, defaultValue: defaultValue, disabled: disabled = false, disableSwap: disableSwap = false, isRtl: isRtl = false, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', rootRef: ref, scale: scale = $07acb049b20deae8$export$544bf02140fa9a77, step: step = 1, shiftStep: shiftStep = 10, tabIndex: tabIndex, value: valueProp } = parameters;
    const touchId = $acw62.useRef(undefined);
    // We can't use the :active browser pseudo-classes.
    // - The active state isn't triggered when clicking on the rail.
    // - The active state isn't transferred when inversing a range slider.
    const [active, setActive] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(-1);
    const [dragging, setDragging] = $acw62.useState(false);
    const moveCount = $acw62.useRef(0);
    // lastChangedValue is updated whenever onChange is triggered.
    const lastChangedValue = $acw62.useRef(null);
    const [valueDerived, setValueState] = (0, $agZ85.default)({
        controlled: valueProp,
        default: defaultValue ?? min,
        name: 'Slider'
    });
    const handleChange = onChange && ((event, value, thumbIndex)=>{
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        // @ts-ignore The nativeEvent is function, not object
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
            writable: true,
            value: {
                value: value,
                name: name
            }
        });
        lastChangedValue.current = value;
        onChange(clonedEvent, value, thumbIndex);
    });
    const range = Array.isArray(valueDerived);
    let values = range ? valueDerived.slice().sort($07acb049b20deae8$var$asc) : [
        valueDerived
    ];
    values = values.map((value)=>value == null ? min : (0, $1jJMI.default)(value, min, max));
    const marks = marksProp === true && step !== null ? [
        ...Array(Math.floor((max - min) / step) + 1)
    ].map((_, index)=>({
            value: min + step * index
        })) : marksProp || [];
    const marksValues = marks.map((mark)=>mark.value);
    const [focusedThumbIndex, setFocusedThumbIndex] = $acw62.useState(-1);
    const sliderRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, sliderRef);
    const createHandleHiddenInputFocus = (otherHandlers)=>(event)=>{
            const index = Number(event.currentTarget.getAttribute('data-index'));
            if ((0, $52FI1.default)(event.target)) setFocusedThumbIndex(index);
            setOpen(index);
            otherHandlers?.onFocus?.(event);
        };
    const createHandleHiddenInputBlur = (otherHandlers)=>(event)=>{
            if (!(0, $52FI1.default)(event.target)) setFocusedThumbIndex(-1);
            setOpen(-1);
            otherHandlers?.onBlur?.(event);
        };
    const changeValue = (event, valueInput)=>{
        const index = Number(event.currentTarget.getAttribute('data-index'));
        const value = values[index];
        const marksIndex = marksValues.indexOf(value);
        let newValue = valueInput;
        if (marks && step == null) {
            const maxMarksValue = marksValues[marksValues.length - 1];
            if (newValue >= maxMarksValue) newValue = maxMarksValue;
            else if (newValue <= marksValues[0]) newValue = marksValues[0];
            else newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        if (range) {
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
            const previousValue = newValue;
            newValue = $07acb049b20deae8$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: index
            });
            let activeIndex = index;
            // Potentially swap the index if needed.
            if (!disableSwap) activeIndex = newValue.indexOf(previousValue);
            $07acb049b20deae8$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex
            });
        }
        setValueState(newValue);
        setFocusedThumbIndex(index);
        if (handleChange && !$07acb049b20deae8$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, index);
        if (onChangeCommitted) onChangeCommitted(event, lastChangedValue.current ?? newValue);
    };
    const createHandleHiddenInputKeyDown = (otherHandlers)=>(event)=>{
            if ([
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'PageUp',
                'PageDown',
                'Home',
                'End'
            ].includes(event.key)) {
                event.preventDefault();
                const index = Number(event.currentTarget.getAttribute('data-index'));
                const value = values[index];
                let newValue = null;
                // Keys actions that change the value by more than the most granular `step`
                // value are only applied if the step not `null`.
                // When step is `null`, the `marks` prop is used instead to define valid values.
                if (step != null) {
                    const stepSize = event.shiftKey ? shiftStep : step;
                    switch(event.key){
                        case 'ArrowUp':
                            newValue = $07acb049b20deae8$var$getNewValue(value, stepSize, 1, min, max);
                            break;
                        case 'ArrowRight':
                            newValue = $07acb049b20deae8$var$getNewValue(value, stepSize, isRtl ? -1 : 1, min, max);
                            break;
                        case 'ArrowDown':
                            newValue = $07acb049b20deae8$var$getNewValue(value, stepSize, -1, min, max);
                            break;
                        case 'ArrowLeft':
                            newValue = $07acb049b20deae8$var$getNewValue(value, stepSize, isRtl ? 1 : -1, min, max);
                            break;
                        case 'PageUp':
                            newValue = $07acb049b20deae8$var$getNewValue(value, shiftStep, 1, min, max);
                            break;
                        case 'PageDown':
                            newValue = $07acb049b20deae8$var$getNewValue(value, shiftStep, -1, min, max);
                            break;
                        case 'Home':
                            newValue = min;
                            break;
                        case 'End':
                            newValue = max;
                            break;
                        default:
                            break;
                    }
                } else if (marks) {
                    const maxMarksValue = marksValues[marksValues.length - 1];
                    const currentMarkIndex = marksValues.indexOf(value);
                    const decrementKeys = [
                        isRtl ? 'ArrowRight' : 'ArrowLeft',
                        'ArrowDown',
                        'PageDown',
                        'Home'
                    ];
                    const incrementKeys = [
                        isRtl ? 'ArrowLeft' : 'ArrowRight',
                        'ArrowUp',
                        'PageUp',
                        'End'
                    ];
                    if (decrementKeys.includes(event.key)) {
                        if (currentMarkIndex === 0) newValue = marksValues[0];
                        else newValue = marksValues[currentMarkIndex - 1];
                    } else if (incrementKeys.includes(event.key)) {
                        if (currentMarkIndex === marksValues.length - 1) newValue = maxMarksValue;
                        else newValue = marksValues[currentMarkIndex + 1];
                    }
                }
                if (newValue != null) changeValue(event, newValue);
            }
            otherHandlers?.onKeyDown?.(event);
        };
    (0, $eEJPp.default)(()=>{
        if (disabled && sliderRef.current.contains(document.activeElement)) // This is necessary because Firefox and Safari will keep focus
        // on a disabled element:
        // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
        // @ts-ignore
        document.activeElement?.blur();
    }, [
        disabled
    ]);
    if (disabled && active !== -1) setActive(-1);
    if (disabled && focusedThumbIndex !== -1) setFocusedThumbIndex(-1);
    const createHandleHiddenInputChange = (otherHandlers)=>(event)=>{
            otherHandlers.onChange?.(event);
            // this handles value change by Pointer or Touch events
            // @ts-ignore
            changeValue(event, event.target.valueAsNumber);
        };
    const previousIndex = $acw62.useRef(undefined);
    let axis = orientation;
    if (isRtl && orientation === 'horizontal') axis += '-reverse';
    const getFingerNewValue = ({ finger: finger, move: move = false })=>{
        const { current: slider } = sliderRef;
        const { width: width, height: height, bottom: bottom, left: left } = slider.getBoundingClientRect();
        let percent;
        if (axis.startsWith('vertical')) percent = (bottom - finger.y) / height;
        else percent = (finger.x - left) / width;
        if (axis.includes('-reverse')) percent = 1 - percent;
        let newValue;
        newValue = $07acb049b20deae8$var$percentToValue(percent, min, max);
        if (step) newValue = $07acb049b20deae8$var$roundValueToStep(newValue, step, min);
        else {
            const closestIndex = $07acb049b20deae8$var$findClosest(marksValues, newValue);
            newValue = marksValues[closestIndex];
        }
        newValue = (0, $1jJMI.default)(newValue, min, max);
        let activeIndex = 0;
        if (range) {
            if (!move) activeIndex = $07acb049b20deae8$var$findClosest(values, newValue);
            else activeIndex = previousIndex.current;
            // Bound the new value to the thumb's neighbours.
            if (disableSwap) newValue = (0, $1jJMI.default)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
            const previousValue = newValue;
            newValue = $07acb049b20deae8$var$setValueIndex({
                values: values,
                newValue: newValue,
                index: activeIndex
            });
            // Potentially swap the index if needed.
            if (!(disableSwap && move)) {
                activeIndex = newValue.indexOf(previousValue);
                previousIndex.current = activeIndex;
            }
        }
        return {
            newValue: newValue,
            activeIndex: activeIndex
        };
    };
    const handleTouchMove = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $07acb049b20deae8$var$trackFinger(nativeEvent, touchId);
        if (!finger) return;
        moveCount.current += 1;
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        // @ts-ignore buttons doesn't not exists on touch event
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            handleTouchEnd(nativeEvent);
            return;
        }
        const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
            finger: finger,
            move: true
        });
        $07acb049b20deae8$var$focusThumb({
            sliderRef: sliderRef,
            activeIndex: activeIndex,
            setActive: setActive
        });
        setValueState(newValue);
        if (!dragging && moveCount.current > $07acb049b20deae8$var$INTENTIONAL_DRAG_COUNT_THRESHOLD) setDragging(true);
        if (handleChange && !$07acb049b20deae8$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
    });
    const handleTouchEnd = (0, $13KXh.default)((nativeEvent)=>{
        const finger = $07acb049b20deae8$var$trackFinger(nativeEvent, touchId);
        setDragging(false);
        if (!finger) return;
        const { newValue: newValue } = getFingerNewValue({
            finger: finger,
            move: true
        });
        setActive(-1);
        if (nativeEvent.type === 'touchend') setOpen(-1);
        if (onChangeCommitted) onChangeCommitted(nativeEvent, lastChangedValue.current ?? newValue);
        touchId.current = undefined;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
    });
    const handleTouchStart = (0, $13KXh.default)((nativeEvent)=>{
        if (disabled) return;
        // If touch-action: none; is not supported we need to prevent the scroll manually.
        if (!$07acb049b20deae8$var$doesSupportTouchActionNone()) nativeEvent.preventDefault();
        const touch = nativeEvent.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const finger = $07acb049b20deae8$var$trackFinger(nativeEvent, touchId);
        if (finger !== false) {
            const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                finger: finger
            });
            $07acb049b20deae8$var$focusThumb({
                sliderRef: sliderRef,
                activeIndex: activeIndex,
                setActive: setActive
            });
            setValueState(newValue);
            if (handleChange && !$07acb049b20deae8$var$areValuesEqual(newValue, valueDerived)) handleChange(nativeEvent, newValue, activeIndex);
        }
        moveCount.current = 0;
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.addEventListener('touchmove', handleTouchMove, {
            passive: true
        });
        doc.addEventListener('touchend', handleTouchEnd, {
            passive: true
        });
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $6zeBo.default)(sliderRef.current);
        doc.removeEventListener('mousemove', handleTouchMove);
        doc.removeEventListener('mouseup', handleTouchEnd);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
    }, [
        handleTouchEnd,
        handleTouchMove
    ]);
    $acw62.useEffect(()=>{
        const { current: slider } = sliderRef;
        slider.addEventListener('touchstart', handleTouchStart, {
            passive: $07acb049b20deae8$var$doesSupportTouchActionNone()
        });
        return ()=>{
            slider.removeEventListener('touchstart', handleTouchStart);
            stopListening();
        };
    }, [
        stopListening,
        handleTouchStart
    ]);
    $acw62.useEffect(()=>{
        if (disabled) stopListening();
    }, [
        disabled,
        stopListening
    ]);
    const createHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (disabled) return;
            if (event.defaultPrevented) return;
            // Only handle left clicks
            if (event.button !== 0) return;
            // Avoid text selection
            event.preventDefault();
            const finger = $07acb049b20deae8$var$trackFinger(event, touchId);
            if (finger !== false) {
                const { newValue: newValue, activeIndex: activeIndex } = getFingerNewValue({
                    finger: finger
                });
                $07acb049b20deae8$var$focusThumb({
                    sliderRef: sliderRef,
                    activeIndex: activeIndex,
                    setActive: setActive
                });
                setValueState(newValue);
                if (handleChange && !$07acb049b20deae8$var$areValuesEqual(newValue, valueDerived)) handleChange(event, newValue, activeIndex);
            }
            moveCount.current = 0;
            const doc = (0, $6zeBo.default)(sliderRef.current);
            doc.addEventListener('mousemove', handleTouchMove, {
                passive: true
            });
            doc.addEventListener('mouseup', handleTouchEnd);
        };
    const trackOffset = $07acb049b20deae8$export$83ce4bc8280540e6(range ? values[0] : min, min, max);
    const trackLeap = $07acb049b20deae8$export$83ce4bc8280540e6(values[values.length - 1], min, max) - trackOffset;
    const getRootProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseDown: createHandleMouseDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            ...externalProps,
            ref: handleRef,
            ...mergedEventHandlers
        };
    };
    const createHandleMouseOver = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseOver?.(event);
            const index = Number(event.currentTarget.getAttribute('data-index'));
            setOpen(index);
        };
    const createHandleMouseLeave = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseLeave?.(event);
            setOpen(-1);
        };
    const getThumbProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onMouseOver: createHandleMouseOver(externalHandlers || {}),
            onMouseLeave: createHandleMouseLeave(externalHandlers || {})
        };
        return {
            ...externalProps,
            ...externalHandlers,
            ...ownEventHandlers
        };
    };
    const getThumbStyle = (index)=>{
        return {
            // So the non active thumb doesn't show its label on hover.
            pointerEvents: active !== -1 && active !== index ? 'none' : undefined
        };
    };
    let cssWritingMode;
    if (orientation === 'vertical') cssWritingMode = isRtl ? 'vertical-rl' : 'vertical-lr';
    const getHiddenInputProps = (externalProps = {})=>{
        const externalHandlers = (0, $f56pe.default)(externalProps);
        const ownEventHandlers = {
            onChange: createHandleHiddenInputChange(externalHandlers || {}),
            onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
            onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
            onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
        };
        const mergedEventHandlers = {
            ...externalHandlers,
            ...ownEventHandlers
        };
        return {
            tabIndex: tabIndex,
            'aria-labelledby': ariaLabelledby,
            'aria-orientation': orientation,
            'aria-valuemax': scale(max),
            'aria-valuemin': scale(min),
            name: name,
            type: 'range',
            min: parameters.min,
            max: parameters.max,
            step: parameters.step === null && parameters.marks ? 'any' : parameters.step ?? undefined,
            disabled: disabled,
            ...externalProps,
            ...mergedEventHandlers,
            style: {
                ...(0, $0acaed42692b8720$export$2e2bcd8739ae039),
                direction: isRtl ? 'rtl' : 'ltr',
                // So that VoiceOver's focus indicator matches the thumb's dimensions
                width: '100%',
                height: '100%',
                writingMode: cssWritingMode
            }
        };
    };
    return {
        active: active,
        axis: axis,
        axisProps: $07acb049b20deae8$var$axisProps,
        dragging: dragging,
        focusedThumbIndex: focusedThumbIndex,
        getHiddenInputProps: getHiddenInputProps,
        getRootProps: getRootProps,
        getThumbProps: getThumbProps,
        marks: marks,
        open: open,
        range: range,
        rootRef: handleRef,
        trackLeap: trackLeap,
        trackOffset: trackOffset,
        values: values,
        getThumbStyle: getThumbStyle
    };
}



var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $9HGIl = parcelRequire("9HGIl");

var $awhpc = parcelRequire("awhpc");
const $c894de82be5ae426$var$shouldSpreadAdditionalProps = (Slot)=>{
    return !Slot || !(0, $awhpc.default)(Slot);
};
var $c894de82be5ae426$export$2e2bcd8739ae039 = $c894de82be5ae426$var$shouldSpreadAdditionalProps;



var $3AM7p = parcelRequire("3AM7p");

var $dn5bM = parcelRequire("dn5bM");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f2b5730c3e0ed208$export$9f59f2622d5cbc2a(slot) {
    return (0, $4Cod0.default)('MuiSlider', slot);
}
const $f2b5730c3e0ed208$var$sliderClasses = (0, $beCSm.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'thumbColorPrimary',
    'thumbColorSecondary',
    'thumbColorError',
    'thumbColorSuccess',
    'thumbColorInfo',
    'thumbColorWarning',
    'track',
    'trackInverted',
    'trackFalse',
    'thumbSizeSmall',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $f2b5730c3e0ed208$export$2e2bcd8739ae039 = $f2b5730c3e0ed208$var$sliderClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $befe87294a780766$var$useValueLabelClasses = (props)=>{
    const { open: open } = props;
    const utilityClasses = {
        offset: (0, $9QePP.default)(open && (0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).valueLabelOpen),
        circle: (0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).valueLabelCircle,
        label: (0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).valueLabelLabel
    };
    return utilityClasses;
};
function $befe87294a780766$export$2e2bcd8739ae039(props) {
    const { children: children, className: className, value: value } = props;
    const classes = $befe87294a780766$var$useValueLabelClasses(props);
    if (!children) return null;
    return /*#__PURE__*/ $acw62.cloneElement(children, {
        className: children.props.className
    }, /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            children.props.children,
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: (0, $9QePP.default)(classes.offset, className),
                "aria-hidden": true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: classes.circle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classes.label,
                        children: value
                    })
                })
            })
        ]
    }));
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $c1a1ed73f43ec083$var$Identity(x) {
    return x;
}
const $c1a1ed73f43ec083$export$c1a21b3b4da66aa1 = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            ownerState.marked && styles.marked,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.track === 'inverted' && styles.trackInverted,
            ownerState.track === false && styles.trackFalse
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        borderRadius: 12,
        boxSizing: 'content-box',
        display: 'inline-block',
        position: 'relative',
        cursor: 'pointer',
        touchAction: 'none',
        WebkitTapHighlightColor: 'transparent',
        '@media print': {
            colorAdjust: 'exact'
        },
        [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            cursor: 'default',
            color: (theme.vars || theme).palette.grey[400]
        },
        [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).dragging}`]: {
            [`& .${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).thumb}, & .${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).track}`]: {
                transition: 'none'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 4,
                    width: '100%',
                    padding: '13px 0',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '20px 0'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    size: 'small'
                },
                style: {
                    height: 2
                }
            },
            {
                props: {
                    orientation: 'horizontal',
                    marked: true
                },
                style: {
                    marginBottom: 20
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    width: 4,
                    padding: '0 13px',
                    // The primary input mechanism of the device includes a pointing device of limited accuracy.
                    '@media (pointer: coarse)': {
                        // Reach 42px touch target, about ~8mm on screen.
                        padding: '0 20px'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    width: 2
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    marked: true
                },
                style: {
                    marginRight: 44
                }
            }
        ]
    })));
const $c1a1ed73f43ec083$export$b02fde61a3559c2 = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'Rail'
})({
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    backgroundColor: 'currentColor',
    opacity: 0.38,
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: '100%',
                height: 'inherit',
                top: '50%',
                transform: 'translateY(-50%)'
            }
        },
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                height: '100%',
                width: 'inherit',
                left: '50%',
                transform: 'translateX(-50%)'
            }
        },
        {
            props: {
                track: 'inverted'
            },
            style: {
                opacity: 1
            }
        }
    ]
});
const $c1a1ed73f43ec083$export$105594979f116971 = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'Track'
})((0, $lwQO9.default)(({ theme: theme })=>{
    return {
        display: 'block',
        position: 'absolute',
        borderRadius: 'inherit',
        border: '1px solid currentColor',
        backgroundColor: 'currentColor',
        transition: theme.transitions.create([
            'left',
            'width',
            'bottom',
            'height'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    border: 'none'
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'inherit',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    width: 'inherit',
                    left: '50%',
                    transform: 'translateX(-50%)'
                }
            },
            {
                props: {
                    track: false
                },
                style: {
                    display: 'none'
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        track: 'inverted'
                    },
                    style: {
                        ...theme.vars ? {
                            backgroundColor: theme.vars.palette.Slider[`${color}Track`],
                            borderColor: theme.vars.palette.Slider[`${color}Track`]
                        } : {
                            backgroundColor: theme.lighten(theme.palette[color].main, 0.62),
                            borderColor: theme.lighten(theme.palette[color].main, 0.62),
                            ...theme.applyStyles('dark', {
                                backgroundColor: theme.darken(theme.palette[color].main, 0.5)
                            }),
                            ...theme.applyStyles('dark', {
                                borderColor: theme.darken(theme.palette[color].main, 0.5)
                            })
                        }
                    }
                }))
        ]
    };
}));
const $c1a1ed73f43ec083$export$2c1b491743890dec = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.thumb,
            styles[`thumbColor${(0, $3AM7p.default)(ownerState.color)}`],
            ownerState.size !== 'medium' && styles[`thumbSize${(0, $3AM7p.default)(ownerState.size)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 20,
        height: 20,
        boxSizing: 'border-box',
        borderRadius: '50%',
        outline: 0,
        backgroundColor: 'currentColor',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme.transitions.create([
            'box-shadow',
            'left',
            'bottom'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        '&::before': {
            position: 'absolute',
            content: '""',
            borderRadius: 'inherit',
            width: '100%',
            height: '100%',
            boxShadow: (theme.vars || theme).shadows[2]
        },
        '&::after': {
            position: 'absolute',
            content: '""',
            borderRadius: '50%',
            // 42px is the hit target
            width: 42,
            height: 42,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        },
        [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).disabled}`]: {
            '&:hover': {
                boxShadow: 'none'
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 12,
                    height: 12,
                    '&::before': {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 50%)'
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&:hover, &.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).focusVisible}`]: {
                            boxShadow: `0px 0px 0px 8px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`,
                            '@media (hover: none)': {
                                boxShadow: 'none'
                            }
                        },
                        [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).active}`]: {
                            boxShadow: `0px 0px 0px 14px ${theme.alpha((theme.vars || theme).palette[color].main, 0.16)}`
                        }
                    }
                }))
        ]
    })));
const $c1a1ed73f43ec083$export$6453176f504d54f0 = (0, $1Ikg4.default)((0, $befe87294a780766$export$2e2bcd8739ae039), {
    name: 'MuiSlider',
    slot: 'ValueLabel'
})((0, $lwQO9.default)(({ theme: theme })=>({
        zIndex: 1,
        whiteSpace: 'nowrap',
        ...theme.typography.body2,
        fontWeight: 500,
        transition: theme.transitions.create([
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        position: 'absolute',
        backgroundColor: (theme.vars || theme).palette.grey[600],
        borderRadius: 2,
        color: (theme.vars || theme).palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.25rem 0.75rem',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    transform: 'translateY(-100%) scale(0)',
                    top: '-10px',
                    transformOrigin: 'bottom center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, 50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        bottom: 0,
                        left: '50%'
                    },
                    [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-100%) scale(1)'
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    transform: 'translateY(-50%) scale(0)',
                    right: '30px',
                    top: '50%',
                    transformOrigin: 'right center',
                    '&::before': {
                        position: 'absolute',
                        content: '""',
                        width: 8,
                        height: 8,
                        transform: 'translate(-50%, -50%) rotate(45deg)',
                        backgroundColor: 'inherit',
                        right: -8,
                        top: '50%'
                    },
                    [`&.${(0, $f2b5730c3e0ed208$export$2e2bcd8739ae039).valueLabelOpen}`]: {
                        transform: 'translateY(-50%) scale(1)'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(12),
                    padding: '0.25rem 0.5rem'
                }
            },
            {
                props: {
                    orientation: 'vertical',
                    size: 'small'
                },
                style: {
                    right: '20px'
                }
            }
        ]
    })));
const $c1a1ed73f43ec083$export$6f85f6a3c5da6f62 = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'Mark',
    shouldForwardProp: (prop)=>(0, $9HGIl.default)(prop) && prop !== 'markActive',
    overridesResolver: (props, styles)=>{
        const { markActive: markActive } = props;
        return [
            styles.mark,
            markActive && styles.markActive
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        position: 'absolute',
        width: 2,
        height: 2,
        borderRadius: 1,
        backgroundColor: 'currentColor',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: '50%',
                    transform: 'translate(-1px, -50%)'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%, 1px)'
                }
            },
            {
                props: {
                    markActive: true
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.background.paper,
                    opacity: 0.8
                }
            }
        ]
    })));
const $c1a1ed73f43ec083$export$e6cd369965e5aa95 = (0, $1Ikg4.default)('span', {
    name: 'MuiSlider',
    slot: 'MarkLabel',
    shouldForwardProp: (prop)=>(0, $9HGIl.default)(prop) && prop !== 'markLabelActive'
})((0, $lwQO9.default)(({ theme: theme })=>({
        ...theme.typography.body2,
        color: (theme.vars || theme).palette.text.secondary,
        position: 'absolute',
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    top: 30,
                    transform: 'translateX(-50%)',
                    '@media (pointer: coarse)': {
                        top: 40
                    }
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    left: 36,
                    transform: 'translateY(50%)',
                    '@media (pointer: coarse)': {
                        left: 44
                    }
                }
            },
            {
                props: {
                    markLabelActive: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            }
        ]
    })));
const $c1a1ed73f43ec083$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dragging: dragging, marked: marked, orientation: orientation, track: track, classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            dragging && 'dragging',
            marked && 'marked',
            orientation === 'vertical' && 'vertical',
            track === 'inverted' && 'trackInverted',
            track === false && 'trackFalse',
            color && `color${(0, $3AM7p.default)(color)}`,
            size && `size${(0, $3AM7p.default)(size)}`
        ],
        rail: [
            'rail'
        ],
        track: [
            'track'
        ],
        mark: [
            'mark'
        ],
        markActive: [
            'markActive'
        ],
        markLabel: [
            'markLabel'
        ],
        markLabelActive: [
            'markLabelActive'
        ],
        valueLabel: [
            'valueLabel'
        ],
        thumb: [
            'thumb',
            disabled && 'disabled',
            size && `thumbSize${(0, $3AM7p.default)(size)}`,
            color && `thumbColor${(0, $3AM7p.default)(color)}`
        ],
        active: [
            'active'
        ],
        disabled: [
            'disabled'
        ],
        focusVisible: [
            'focusVisible'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f2b5730c3e0ed208$export$9f59f2622d5cbc2a), classes);
};
const $c1a1ed73f43ec083$var$Forward = ({ children: children })=>children;
const $c1a1ed73f43ec083$var$Slider = /*#__PURE__*/ $acw62.forwardRef(function Slider(inputProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inputProps,
        name: 'MuiSlider'
    });
    const isRtl = (0, $58lXc.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-valuetext': ariaValuetext, 'aria-labelledby': ariaLabelledby, component: // eslint-disable-next-line react/prop-types
    component = 'span', components: components = {}, componentsProps: componentsProps = {}, color: color = 'primary', classes: classesProp, className: className, disableSwap: disableSwap = false, disabled: disabled = false, getAriaLabel: getAriaLabel, getAriaValueText: getAriaValueText, marks: marksProp = false, max: max = 100, min: min = 0, name: name, onChange: onChange, onChangeCommitted: onChangeCommitted, orientation: orientation = 'horizontal', shiftStep: shiftStep = 10, size: size = 'medium', step: step = 1, scale: scale = $c1a1ed73f43ec083$var$Identity, slotProps: slotProps, slots: slots, tabIndex: tabIndex, track: track = 'normal', value: valueProp, valueLabelDisplay: valueLabelDisplay = 'off', valueLabelFormat: valueLabelFormat = $c1a1ed73f43ec083$var$Identity, ...other } = props;
    const ownerState = {
        ...props,
        isRtl: isRtl,
        max: max,
        min: min,
        classes: classesProp,
        disabled: disabled,
        disableSwap: disableSwap,
        orientation: orientation,
        marks: marksProp,
        color: color,
        size: size,
        step: step,
        shiftStep: shiftStep,
        scale: scale,
        track: track,
        valueLabelDisplay: valueLabelDisplay,
        valueLabelFormat: valueLabelFormat
    };
    const { axisProps: axisProps, getRootProps: getRootProps, getHiddenInputProps: getHiddenInputProps, getThumbProps: getThumbProps, open: open, active: active, axis: axis, focusedThumbIndex: focusedThumbIndex, range: range, dragging: dragging, marks: marks, values: values, trackOffset: trackOffset, trackLeap: trackLeap, getThumbStyle: getThumbStyle } = (0, $07acb049b20deae8$export$56b2c08e277f365)({
        ...ownerState,
        rootRef: ref
    });
    ownerState.marked = marks.length > 0 && marks.some((mark)=>mark.label);
    ownerState.dragging = dragging;
    ownerState.focusedThumbIndex = focusedThumbIndex;
    const classes = $c1a1ed73f43ec083$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = slots?.root ?? components.Root ?? $c1a1ed73f43ec083$export$c1a21b3b4da66aa1;
    const RailSlot = slots?.rail ?? components.Rail ?? $c1a1ed73f43ec083$export$b02fde61a3559c2;
    const TrackSlot = slots?.track ?? components.Track ?? $c1a1ed73f43ec083$export$105594979f116971;
    const ThumbSlot = slots?.thumb ?? components.Thumb ?? $c1a1ed73f43ec083$export$2c1b491743890dec;
    const ValueLabelSlot = slots?.valueLabel ?? components.ValueLabel ?? $c1a1ed73f43ec083$export$6453176f504d54f0;
    const MarkSlot = slots?.mark ?? components.Mark ?? $c1a1ed73f43ec083$export$6f85f6a3c5da6f62;
    const MarkLabelSlot = slots?.markLabel ?? components.MarkLabel ?? $c1a1ed73f43ec083$export$e6cd369965e5aa95;
    const InputSlot = slots?.input ?? components.Input ?? 'input';
    const rootSlotProps = slotProps?.root ?? componentsProps.root;
    const railSlotProps = slotProps?.rail ?? componentsProps.rail;
    const trackSlotProps = slotProps?.track ?? componentsProps.track;
    const thumbSlotProps = slotProps?.thumb ?? componentsProps.thumb;
    const valueLabelSlotProps = slotProps?.valueLabel ?? componentsProps.valueLabel;
    const markSlotProps = slotProps?.mark ?? componentsProps.mark;
    const markLabelSlotProps = slotProps?.markLabel ?? componentsProps.markLabel;
    const inputSlotProps = slotProps?.input ?? componentsProps.input;
    const rootProps = (0, $eD6Co.default)({
        elementType: RootSlot,
        getSlotProps: getRootProps,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ...(0, $c894de82be5ae426$export$2e2bcd8739ae039)(RootSlot) && {
                as: component
            }
        },
        ownerState: {
            ...ownerState,
            ...rootSlotProps?.ownerState
        },
        className: [
            classes.root,
            className
        ]
    });
    const railProps = (0, $eD6Co.default)({
        elementType: RailSlot,
        externalSlotProps: railSlotProps,
        ownerState: ownerState,
        className: classes.rail
    });
    const trackProps = (0, $eD6Co.default)({
        elementType: TrackSlot,
        externalSlotProps: trackSlotProps,
        additionalProps: {
            style: {
                ...axisProps[axis].offset(trackOffset),
                ...axisProps[axis].leap(trackLeap)
            }
        },
        ownerState: {
            ...ownerState,
            ...trackSlotProps?.ownerState
        },
        className: classes.track
    });
    const thumbProps = (0, $eD6Co.default)({
        elementType: ThumbSlot,
        getSlotProps: getThumbProps,
        externalSlotProps: thumbSlotProps,
        ownerState: {
            ...ownerState,
            ...thumbSlotProps?.ownerState
        },
        className: classes.thumb
    });
    const valueLabelProps = (0, $eD6Co.default)({
        elementType: ValueLabelSlot,
        externalSlotProps: valueLabelSlotProps,
        ownerState: {
            ...ownerState,
            ...valueLabelSlotProps?.ownerState
        },
        className: classes.valueLabel
    });
    const markProps = (0, $eD6Co.default)({
        elementType: MarkSlot,
        externalSlotProps: markSlotProps,
        ownerState: ownerState,
        className: classes.mark
    });
    const markLabelProps = (0, $eD6Co.default)({
        elementType: MarkLabelSlot,
        externalSlotProps: markLabelSlotProps,
        ownerState: ownerState,
        className: classes.markLabel
    });
    const inputSliderProps = (0, $eD6Co.default)({
        elementType: InputSlot,
        getSlotProps: getHiddenInputProps,
        externalSlotProps: inputSlotProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(RailSlot, {
                ...railProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(TrackSlot, {
                ...trackProps
            }),
            marks.filter((mark)=>mark.value >= min && mark.value <= max).map((mark, index)=>{
                const percent = (0, $07acb049b20deae8$export$83ce4bc8280540e6)(mark.value, min, max);
                const style = axisProps[axis].offset(percent);
                let markActive;
                if (track === false) markActive = values.includes(mark.value);
                else markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)(MarkSlot, {
                            "data-index": index,
                            ...markProps,
                            ...!(0, $awhpc.default)(MarkSlot) && {
                                markActive: markActive
                            },
                            style: {
                                ...style,
                                ...markProps.style
                            },
                            className: (0, $9QePP.default)(markProps.className, markActive && classes.markActive)
                        }),
                        mark.label != null ? /*#__PURE__*/ (0, $ayMG0.jsx)(MarkLabelSlot, {
                            "aria-hidden": true,
                            "data-index": index,
                            ...markLabelProps,
                            ...!(0, $awhpc.default)(MarkLabelSlot) && {
                                markLabelActive: markActive
                            },
                            style: {
                                ...style,
                                ...markLabelProps.style
                            },
                            className: (0, $9QePP.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
                            children: mark.label
                        }) : null
                    ]
                }, index);
            }),
            values.map((value, index)=>{
                const percent = (0, $07acb049b20deae8$export$83ce4bc8280540e6)(value, min, max);
                const style = axisProps[axis].offset(percent);
                const ValueLabelComponent = valueLabelDisplay === 'off' ? $c1a1ed73f43ec083$var$Forward : ValueLabelSlot;
                return /*#__PURE__*/ /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */ (0, $ayMG0.jsx)(ValueLabelComponent, {
                    ...!(0, $awhpc.default)(ValueLabelComponent) && {
                        valueLabelFormat: valueLabelFormat,
                        valueLabelDisplay: valueLabelDisplay,
                        value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
                        index: index,
                        open: open === index || active === index || valueLabelDisplay === 'on',
                        disabled: disabled
                    },
                    ...valueLabelProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ThumbSlot, {
                        "data-index": index,
                        ...thumbProps,
                        className: (0, $9QePP.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
                        style: {
                            ...style,
                            ...getThumbStyle(index),
                            ...thumbProps.style
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(InputSlot, {
                            "data-index": index,
                            "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
                            "aria-valuenow": scale(value),
                            "aria-labelledby": ariaLabelledby,
                            "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
                            value: values[index],
                            ...inputSliderProps
                        })
                    })
                }, index);
            })
        ]
    });
});
var $c1a1ed73f43ec083$export$2e2bcd8739ae039 = $c1a1ed73f43ec083$var$Slider;


var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $2u93q = parcelRequire("2u93q");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $2lSXC = parcelRequire("2lSXC");

var $bCDrB = parcelRequire("bCDrB");


const $ea1a6557faa30a5b$export$173ad7a557842909 = {
    mb: 1,
    pointerEvents: 'none',
    '& .MuiSlider-track': {
        border: 1,
        borderRadius: 0
    },
    '& .MuiSlider-rail': {
        borderRadius: 0
    },
    '&:not(.MuiSlider-trackInverted) .MuiSlider-rail': {
        bgcolor: (theme)=>theme.palette.mode === 'light' ? '#fbfcfe' : '#39393D',
        opacity: 1
    },
    '&.MuiSlider-trackInverted .MuiSlider-track': {
        borderColor: (theme)=>theme.palette.mode === 'light' ? '#fbfcfe' : '#39393D',
        bgcolor: (theme)=>theme.palette.mode === 'light' ? '#fbfcfe' : '#39393D'
    },
    '&.MuiSlider-trackInverted .MuiSlider-rail': {
        border: 1
    },
    '& .MuiSlider-thumb': {
        boxShadow: 'none',
        width: 18,
        height: 18,
        pointerEvents: 'all',
        '&:before': {
            boxShadow: 'none',
            width: 9,
            height: 9,
            bgcolor: 'common.white'
        }
    }
};
const $ea1a6557faa30a5b$var$buttonSx = {
    width: 28,
    height: 28,
    borderColor: 'text.disabled',
    borderWidth: 0.5,
    borderStyle: 'solid',
    borderRadius: 1,
    p: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 0.6,
    fontFamily: $2u93q.fontFamily
};
const $ea1a6557faa30a5b$export$14401a347825b9d1 = ({ type: type = 'numeric', title: title, subtitle: subtitle, variableId: variableId, opts: opts, visibility: visibility, min: minProp, max: maxProp, step: stepProp, track: track })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const value = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, variableId));
    const currency = (0, $2lSXC.useSelector)(({ variables: { CURRENCY: CURRENCY } })=>CURRENCY);
    const dispatch = (0, $2lSXC.useDispatch)();
    const [localValue, setLocalValue] = (0, $acw62.useState)(value);
    const getNumericStep = ()=>{
        if (opts?.style === 'currency') return (0, $5617f62e0ff19c36$export$93ecdfe511e05807)[currency];
        return undefined;
    };
    // Resolves a per-currency range prop (or plain number for non-currency sliders).
    const resolveProp = (prop)=>{
        if (prop == null) return undefined;
        if (opts?.style === 'currency') return prop[currency];
        return prop;
    };
    const typeMap = {
        numeric: {
            formatted: formatNumber(localValue, opts),
            min: resolveProp(minProp),
            max: resolveProp(maxProp),
            step: resolveProp(stepProp) ?? getNumericStep()
        },
        time: {
            formatted: (0, $4d82c4193dc87874$export$2e2bcd8739ae039)((0, $f4Eh3.add)((0, $g04kv.startOfDay)(new Date()), {
                seconds: localValue
            }), 'HH:mm'),
            min: minProp,
            max: maxProp ?? 86100,
            step: stepProp || 300
        },
        minutes: {
            formatted: `${Math.floor(localValue / 60)} min`,
            min: minProp,
            max: maxProp,
            step: stepProp || undefined
        }
    };
    const localFormattedValue = typeMap[type].formatted;
    const min = typeMap[type].min;
    const max = typeMap[type].max;
    const step = typeMap[type].step ?? 1;
    const handleChange = (v)=>{
        dispatch((0, $1Jwr0.variablesChange)({
            [variableId]: v
        }));
    };
    const onChangeCommitted = (v)=>{
        handleChange(v);
    };
    (0, $acw62.useEffect)(()=>{
        setLocalValue(value);
    }, [
        value
    ]);
    const decrease = ()=>{
        const minForButton = typeof min === 'number' ? min : 0;
        const newValue = value - step;
        if (newValue < minForButton) return;
        handleChange(newValue);
    };
    const increase = ()=>{
        const maxForButton = typeof max === 'number' ? max : 100;
        const newValue = value + step;
        if (newValue > maxForButton) return;
        handleChange(newValue);
    };
    if (!(0, $bCDrB.useVisibility)(visibility)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        children: localFormattedValue
                    })
                ]
            }),
            subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h5",
                sx: {
                    color: 'primary.main'
                },
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1a1ed73f43ec083$export$2e2bcd8739ae039), {
                value: localValue,
                onChange: (e, v)=>setLocalValue(v),
                onChangeCommitted: (e, v)=>onChangeCommitted(v),
                sx: $ea1a6557faa30a5b$export$173ad7a557842909,
                track: track,
                step: step,
                min: min,
                max: max
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                direction: "row",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        sx: $ea1a6557faa30a5b$var$buttonSx,
                        onClick: decrease,
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        sx: $ea1a6557faa30a5b$var$buttonSx,
                        onClick: increase,
                        children: "+"
                    })
                ]
            })
        ]
    });
};



var $2lSXC = parcelRequire("2lSXC");
const $1c4cdc7ff1541b41$export$6ebb4e06731ab0d9 = ()=>{
    const largeInstallation = (0, $2lSXC.useSelector)((s)=>s.variables.LARGE_INSTALLATION);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.utility.numberofphase",
                    defaultMessage: "T\u0159\xed-f\xe1zov\xe1 instalace"
                }),
                switchVariableId: "PHASE_3_FVE",
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.utility.settings.ampers",
                    defaultMessage: "Velikost jisti\u010De"
                }),
                variableId: "EM_MAX_CURRENT",
                opts: {
                    style: 'unit',
                    unit: 'ampere',
                    maximumFractionDigits: 0
                },
                min: 0,
                max: largeInstallation ? 2000 : 100,
                step: largeInstallation ? 5 : 1
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $fba062b26dc2f097$export$7b3f09138ef8bc19 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.PV.StringNumber",
            defaultMessage: "Po\u010Det string\u016F st\u0159\xedda\u010De"
        }),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.PV.StringNumber.subtitle",
            defaultMessage: "Po\u010Det string\u016F st\u0159\xedda\u010De zobrazovan\xfd v aplikaci na z\xe1lo\u017Ece FVE"
        }),
        variableId: "PV_STRING_NUMBER",
        visibility: {
            variableId: 'PV_ACTUAL_POWER_STRING_V'
        },
        opts: {
            maximumFractionDigits: 0
        },
        min: 1,
        max: 6
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");
const $a44aa4714e63a415$export$5f03a5ec016badda = ()=>{
    const largeInstallation = (0, $2lSXC.useSelector)((s)=>s.variables.LARGE_INSTALLATION);
    const sofar = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SofarSolarRS485;
    });
    const ems1000 = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000;
    });
    const ems1000pro = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000PRO;
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.batteryenabled",
                    defaultMessage: "Baterie nainstalov\xe1na"
                }),
                switchVariableId: "PV_BATTERY",
                visibility: {
                    variableIds: [
                        {
                            variableId: 'PV_ONGRID',
                            reversed: true
                        },
                        'PV_INSTALL'
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.batterynominal",
                    defaultMessage: "Nomin\xe1ln\xed kapacita baterie"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.batterynominal_sub",
                    defaultMessage: "Nutn\xe9 zadat pouze pro spotov\xe9 obchodov\xe1n\xed"
                }),
                variableId: "PV_BAT_NOMINAL",
                visibility: {
                    variableIds: [
                        {
                            variableId: 'PV_ONGRID',
                            reversed: true
                        },
                        'PV_INSTALL',
                        'PV_BATTERY'
                    ]
                },
                opts: {
                    style: 'unit',
                    unit: 'kilowatt-hour',
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 1
                },
                step: 1,
                min: 1,
                max: largeInstallation ? 2000 : 200
            }),
            ems1000 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.gridchargeenabled",
                    defaultMessage: "Nab\xedjen\xed baterie z distribu\u010Dn\xed s\xedt\u011B povoleno"
                }),
                switchVariableId: "EMS_GRID_CHARGE_ENABLE",
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                fullWidth: true
            }),
            (sofar || ems1000 || ems1000pro) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.photovoltaics.batterychargingpower",
                            defaultMessage: "Nab\xedjec\xed v\xfdkon baterie"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.photovoltaics.batterychargingpower_sub",
                            defaultMessage: "V\xfdkon pro manu\xe1ln\xed nab\xedjen\xed baterie a spotov\xe9 nab\xedjen\xed z distribu\u010Dn\xed s\xedt\u011B"
                        }),
                        variableId: "PV_BATTERY_CHARGING_POWER",
                        visibility: {
                            variableIds: [
                                {
                                    variableId: 'PV_ONGRID',
                                    reversed: true
                                },
                                'PV_INSTALL',
                                'PV_BATTERY'
                            ]
                        },
                        opts: {
                            style: 'unit',
                            unit: 'kilowatt',
                            maximumFractionDigits: 0
                        },
                        step: 1,
                        min: 1,
                        max: largeInstallation ? 200 : 20
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.photovoltaics.batterydischargingpower",
                            defaultMessage: "Vyb\xedjec\xed v\xfdkon baterie"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.photovoltaics.batterydischargingpower_sub",
                            defaultMessage: "V\xfdkon pro spotov\xe9 vyb\xedjen\xed baterie do distribu\u010Dn\xed s\xedt\u011B"
                        }),
                        variableId: "PV_BATTERY_DISCHARGING_POWER",
                        visibility: {
                            variableIds: [
                                {
                                    variableId: 'PV_ONGRID',
                                    reversed: true
                                },
                                'PV_INSTALL',
                                'PV_BATTERY'
                            ]
                        },
                        opts: {
                            style: 'unit',
                            unit: 'kilowatt',
                            maximumFractionDigits: 0
                        },
                        step: 1,
                        min: 1,
                        max: largeInstallation ? 200 : 20
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $aZOrF = parcelRequire("aZOrF");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
const $6342fbb618ee4f49$export$b0c19aa6a430c560 = ()=>{
    const fronius = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Fronius;
    });
    const largeInstallation = (0, $2lSXC.useSelector)((s)=>s.variables.LARGE_INSTALLATION);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.overflow",
                    defaultMessage: "P\u0159etok do s\xedt\u011B bez omezen\xed"
                }),
                switchVariableId: "PV_OVERFLOW",
                visibility: {
                    variableIds: [
                        {
                            variableId: 'PV_ONGRID',
                            reversed: true
                        },
                        'PV_INSTALL',
                        'PV_OVERFLOW_CONTROL'
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.photovoltaics.overflow.value",
                            defaultMessage: "Omezen\xed p\u0159etoku"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.photovoltaics.overflow.value",
                                defaultMessage: "Omezen\xed p\u0159etoku"
                            }),
                            content: fronius ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.photovoltaics.overflow_fronius.value.help",
                                defaultMessage: "Hodnota p\u0159etoku na stran\u011B Fronius st\u0159\xedda\u010De. Slou\u017E\xed jako informace Infigy pro spr\xe1vnou vizualizaci p\u0159etok\u016F."
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.photovoltaics.overflow.value.help",
                                defaultMessage: "Hodnota omezen\xed p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B. Tato hodnota se zap\xed\u0161e do st\u0159\xedda\u010De. Ve st\u0159\xedda\u010Di tuto hodnotu neupravujte. Omezen\xed p\u0159etoku je \u0159\xedzen\xe9 z Infigy. Zapsanou hodnotu si zkontrolujte ve st\u0159\xedda\u010Di."
                            })
                        })
                    ]
                }),
                variableId: "PV_OVERFLOW_MAX_VALUE",
                visibility: {
                    variableIds: [
                        {
                            variableId: 'PV_ONGRID',
                            reversed: true
                        },
                        'PV_INSTALL',
                        {
                            variableId: 'PV_OVERFLOW',
                            reversed: true
                        },
                        'PV_OVERFLOW_CONTROL'
                    ]
                },
                opts: {
                    style: 'unit',
                    unit: 'kilowatt',
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                },
                step: largeInstallation ? 1 : 0.1,
                min: 0,
                max: largeInstallation ? 200 : 60
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $2lSXC = parcelRequire("2lSXC");
const $6aaadd6817fa784e$export$a040df6eb068c6c9 = ()=>{
    const largeInstallation = (0, $2lSXC.useSelector)((s)=>s.variables.LARGE_INSTALLATION);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.photovoltaics.nominal",
            defaultMessage: "Nomin\xe1ln\xed v\xfdkon v panelech cel\xe9 elektr\xe1rny"
        }),
        variableId: "PV_NOMINAL",
        visibility: {
            variableId: 'PV_INSTALL'
        },
        opts: {
            style: 'unit',
            unit: 'kilowatt-peak',
            maximumFractionDigits: 0
        },
        min: 0.5,
        max: largeInstallation ? 2000 : 100,
        step: 1
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $i51gj = parcelRequire("i51gj");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $9iEAl = parcelRequire("9iEAl");
const $7026d47a00410215$export$ebde6d4e7862fe9d = ({ selectVariableId: selectVariableId, options: options, ...props })=>{
    const selectValue = (0, $2lSXC.useSelector)((s)=>selectVariableId ? (0, (/*@__PURE__*/$parcel$interopDefault($i51gj)))(s.variables, selectVariableId) : undefined);
    const dispatch = (0, $2lSXC.useDispatch)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
            value: selectValue,
            onChange: (e)=>{
                dispatch((0, $1Jwr0.variablesChange)({
                    [selectVariableId]: e.target.value
                }));
            },
            sx: {
                ml: 'auto'
            },
            children: options.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                    value: value,
                    children: label
                }, value))
        }),
        ...props
    });
};



var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");
const $da7e8a667ca6e3e6$export$f93868c14f0bb964 = ({ showShelliesControl: showShelliesControl = false })=>{
    const largeInstallation = (0, $2lSXC.useSelector)((s)=>s.variables.LARGE_INSTALLATION);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.enabled",
                    defaultMessage: "Topn\xe1 patrona nainstalov\xe1na"
                }),
                switchVariableId: "HW_INSTALL",
                fullWidth: true
            }),
            showShelliesControl && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.shellies",
                    defaultMessage: "Bojler je \u0159\xedzen skrze Shelly"
                }),
                fullWidth: true,
                visibility: {
                    variableId: 'HW_SHELLIES'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.3phase",
                    defaultMessage: "T\u0159\xed-f\xe1zov\xe1 patrona"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.3phase.subtitle",
                    defaultMessage: "Jedno-f\xe1zovou patronu zapojte na SSR v\xfdstup odpov\xeddaj\xedc\xed zvolen\xe9 f\xe1zi."
                }),
                switchVariableId: "PHASE_3_HW",
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.phase",
                    defaultMessage: "F\xe1ze patrony"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.phase.subtitle",
                    defaultMessage: "L1 = SSR v\xfdstup 1, L2 = SSR v\xfdstup 2, L3 = SSR v\xfdstup 3."
                }),
                selectVariableId: "HW_PHASE",
                options: [
                    {
                        value: 0,
                        label: 'L1'
                    },
                    {
                        value: 1,
                        label: 'L2'
                    },
                    {
                        value: 2,
                        label: 'L3'
                    }
                ],
                visibility: {
                    variableIds: [
                        'HW_INSTALL',
                        {
                            variableId: 'PHASE_3_HW',
                            reversed: true
                        }
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.temp_enabled",
                    defaultMessage: "Teplotn\xed \u010Didlo nainstalov\xe1no"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.temp_enabled.subtitle",
                    defaultMessage: "Bojler lze bez \u010Didla vyu\u017E\xedt pouze pro p\u0159ebytky"
                }),
                switchVariableId: "HW_TEMP_ENABLED",
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.nominal",
                    defaultMessage: "Nomin\xe1ln\xed p\u0159\xedkon"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.nominal.subtitle",
                    defaultMessage: "Nomin\xe1ln\xed p\u0159\xedkon pro 1 f\xe1zi elektrokotle"
                }),
                variableId: "HW_EK_NOMINAL",
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                opts: {
                    style: 'unit',
                    unit: 'kilowatt',
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                },
                step: largeInstallation ? 10 : 0.1,
                min: 0.2,
                max: largeInstallation ? 200 : 10
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.capacity",
                    defaultMessage: "Objem bojleru"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler.capacity_sub",
                    defaultMessage: "Nutn\xe9 zadat pouze pro spotov\xe9 obchodov\xe1n\xed"
                }),
                min: 20,
                max: largeInstallation ? 10000 : 1000,
                step: largeInstallation ? 50 : 1,
                variableId: "HW_CAPACITY",
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                opts: {
                    style: 'unit',
                    unit: 'litre',
                    maximumFractionDigits: 0
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $f43a5934aae8819d$export$ca67f46453ceea0d = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.spot.install",
            defaultMessage: "Spotov\xe9 obchodov\xe1n\xed aktivn\xed"
        }),
        switchVariableId: "SP_INSTALL",
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $c912a4a4aecd7f44$export$93dfdc1002311d10 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.wallbox.install",
            defaultMessage: "Wallbox aktivn\xed"
        }),
        switchVariableId: "WB_INSTALL",
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $gpaJb = parcelRequire("gpaJb");
const $e84bcf1fb32102d8$export$dd088f0d81500b74 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.latitude",
                    defaultMessage: "Zem\u011Bpisn\xe1 \u0161\xed\u0159ka"
                }),
                inputVariableId: "SP_LATITUDE",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.latitude.mess",
                    defaultMessage: "\u0160\xed\u0159ka"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.longitude",
                    defaultMessage: "Zem\u011Bpisn\xe1 d\xe9lka"
                }),
                inputVariableId: "SP_LONGITUDE",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.longitude.mess",
                    defaultMessage: "D\xe9lka"
                }),
                fullWidth: true
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $JYcZH = parcelRequire("JYcZH");

var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");
const $4faae2edb5297062$export$f7ab7423ce4b898e = ()=>{
    const [lastCommunicationAt, setLastCommunicationAt] = (0, $acw62.useState)(null);
    // trigger re-render every second
    const [, setTick] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        const interval = setInterval(()=>{
            setTick((t)=>t + 1);
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    const [communicationOkCount] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.PV_cnt_com_ok,
            variables.PV_INFO.Status
        ]);
    const lastCommunicationCountRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(communicationOkCount);
    (0, $acw62.useEffect)(()=>{
        if (communicationOkCount !== lastCommunicationCountRef.current) {
            setLastCommunicationAt(new Date());
            lastCommunicationCountRef.current = communicationOkCount;
        }
    }, [
        communicationOkCount
    ]);
    const communicationIsOk = lastCommunicationAt ? new Date().getTime() < lastCommunicationAt.getTime() + 10000 : false;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.inverter_communication_status",
            defaultMessage: "Komunikace se st\u0159\xedda\u010Dem"
        }),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.inverter_communication_status.subtitle",
            defaultMessage: "Nav\xe1z\xe1n\xed komunikace m\u016F\u017Ee trvat n\u011Bkolik des\xedtek vte\u0159in a\u017E p\xe1r minut"
        }),
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                children: communicationIsOk ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.inverter_communication_status.ok",
                    defaultMessage: "Komunikace nav\xe1z\xe1na{br}({count} \u010Dten\xed)",
                    values: {
                        count: communicationOkCount < 0 ? 0 : communicationOkCount,
                        br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                    }
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.inverter_communication_status.not_ok",
                    defaultMessage: "Nenav\xe1z\xe1na,{br}pokou\u0161\xedm se o spojen\xed...",
                    values: {
                        br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                    }
                })
            }),
            color: communicationIsOk ? 'success' : 'error',
            sx: {
                fontSize: '0.7rem',
                py: 0.5,
                height: 'auto',
                mb: {
                    xs: 1,
                    sm: 0
                },
                mt: -1
            },
            size: "medium"
        }),
        visibility: {
            variableId: 'PV_INSTALL'
        },
        fullWidth: true
    });
};



var $9iEAl = parcelRequire("9iEAl");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $4mI0b = parcelRequire("4mI0b");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8975383ad1dea524$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');



var $jDfxe = parcelRequire("jDfxe");

var $iH29s = parcelRequire("iH29s");

var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");

const $22ebae9741c9601a$export$5f7700ebf3ab7ed8 = ({ autoCheck: autoCheck = false })=>{
    const [updateRequestedAt] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.APP_UPDATE_REQUESTED_AT ? new Date(variables.APP_UPDATE_REQUESTED_AT) : undefined
        ], (0, $f1q41.isEqual));
    const updateRequestExpired = (0, $529b0896e2af4a39$export$5fb7fe4703c2b18)(updateRequestedAt ?? new Date(0), 300 // 5 minutes
    );
    const updateRequested = Boolean(updateRequestedAt) && !updateRequestExpired;
    const confirm = (0, $jDfxe.useConfirm)();
    const { mutate: checkUpdates, isLoading: isCheckingUpdates, data: checkUpdatesData } = (0, $iH29s.trpc).updates.check.useMutation();
    const { mutate: requestUpdate, isLoading: isRequesting, data: updateRequestData } = (0, $iH29s.trpc).updates.request.useMutation();
    const handleRequestUpdate = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.app_update.confirm.title",
                defaultMessage: "Spustit aktualizaci?"
            }),
            description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.app_update.confirm.description",
                defaultMessage: "Aktualizace m\u016F\u017Ee trvat n\u011Bkolik minut. B\u011Bhem aktualizace bude aplikace nedostupn\xe1 a n\xe1sledn\u011B se automaticky restartuje."
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.app_update.confirm.confirm",
                defaultMessage: "Aktualizovat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.app_update.confirm.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            requestUpdate();
        }).catch(()=>{
        // noop
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (autoCheck && !checkUpdatesData && !isCheckingUpdates) checkUpdates();
    }, [
        autoCheck
    ]);
    const content = !updateRequested ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        children: [
            !checkUpdatesData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                variant: "contained",
                onClick: ()=>checkUpdates(),
                disabled: isCheckingUpdates,
                startIcon: isCheckingUpdates ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                    size: 20
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c63abf5df8c37b2$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.app_update.check_button",
                    defaultMessage: "Zkontrolovat aktualizace"
                })
            }),
            checkUpdatesData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                children: 'error' in checkUpdatesData ? // failed to check updates
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: ()=>checkUpdates(),
                        disabled: isCheckingUpdates,
                        startIcon: isCheckingUpdates ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                            size: 20
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c63abf5df8c37b2$export$2e2bcd8739ae039), {}),
                        variant: "contained",
                        color: 'errorType' in checkUpdatesData && checkUpdatesData.errorType === 'network' ? 'warning' : 'error',
                        children: 'errorType' in checkUpdatesData && checkUpdatesData.errorType === 'network' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.app_update.error.no_internet",
                            defaultMessage: "Zkontrolujte s\xed\u0165ov\xe9 p\u0159ipojen\xed"
                        }) : checkUpdatesData.error
                    })
                }) : checkUpdatesData.updateAvailable ? // update available
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        updateRequestData?.success && // update requested
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "outlined",
                            disabled: true,
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 18
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.app_update.requested",
                                defaultMessage: "Aktualizace byla vy\u017E\xe1d\xe1na"
                            })
                        }),
                        updateRequestData?.error && // update request error
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            onClick: handleRequestUpdate,
                            disabled: isRequesting,
                            variant: "contained",
                            color: 'errorType' in updateRequestData && updateRequestData.errorType === 'network' ? 'warning' : 'error',
                            startIcon: isRequesting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 20
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c63abf5df8c37b2$export$2e2bcd8739ae039), {}),
                            children: 'errorType' in updateRequestData && updateRequestData.errorType === 'network' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.app_update.error.no_internet",
                                defaultMessage: "Zkontrolujte s\xed\u0165ov\xe9 p\u0159ipojen\xed"
                            }) : updateRequestData.error
                        }),
                        !updateRequestData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "contained",
                            onClick: handleRequestUpdate,
                            disabled: isRequesting,
                            startIcon: isRequesting ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 16
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c63abf5df8c37b2$export$2e2bcd8739ae039), {}),
                            color: "success",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.app_update.request_button",
                                defaultMessage: "Aktualizace je k dispozici"
                            })
                        })
                    ]
                }) : // up to date
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: ()=>checkUpdates(),
                    startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {}),
                    variant: "outlined",
                    color: "success",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.app_update.up_to_date",
                        defaultMessage: "Aplikace je aktu\xe1ln\xed"
                    })
                })
            })
        ]
    }) : // update requested and in progress
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
        variant: "outlined",
        disabled: true,
        startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
            size: 18
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.app_update.in_progress",
            defaultMessage: "Aktualizace prob\xedh\xe1"
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.app_update.title",
            defaultMessage: "Aktualizace aplikace"
        }),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.app_update.subtitle",
            defaultMessage: "Zkontrolujte dostupnost nov\xfdch verz\xed"
        }),
        fullWidth: true,
        control: content
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $2lSXC = parcelRequire("2lSXC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $03kOd = parcelRequire("03kOd");

var $9iEAl = parcelRequire("9iEAl");
const $f71ef2d47abf280a$export$5e37f977ae0514c2 = ({ buttonLabel: buttonLabel, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
            variant: "contained",
            children: buttonLabel
        }),
        ...props
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $4mI0b = parcelRequire("4mI0b");
var $91vj1 = parcelRequire("91vj1");
var $1DAbm = parcelRequire("1DAbm");
var $4LdGL = parcelRequire("4LdGL");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $b8d976dd8c0b005c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');


var $NDEo7 = parcelRequire("NDEo7");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");



// Actual consumption of the building — mirrors getHomeActualPower() in
// core/src/modules/heat_water/boiler-test.ts.
const $2cd327e5970cd381$var$useHomeActualPower = ()=>(0, $2lSXC.useSelector)((s)=>{
        const v = (path)=>Number((0, $f1q41.get)(s.variables, path)) || 0;
        return v('PV_ACTUAL_POWER_BATTERY') + (v('WIND_POWER') - v('WIND_RESISTOR_POWER')) - v('WB_ACTUAL_POWER') - v('HP_ACTUAL_POWER') + v('PV_ACTUAL_POWER') + v('EM_INFO.Consumption[0]') + v('EM_INFO.Consumption[1]') + v('EM_INFO.Consumption[2]');
    });
const $2cd327e5970cd381$export$eed389ff22efcb06 = ({ open: open, onClose: onClose, variant: variant = 'fullscreen' })=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const [step, setStep] = (0, $acw62.useState)('acknowledge');
    const inProgress = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_IN_PROGRESS);
    const phase3 = (0, $2lSXC.useSelector)((s)=>s.variables.PHASE_3_HW);
    const hwPhase = (0, $2lSXC.useSelector)((s)=>s.variables.HW_PHASE);
    const info = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_INFO);
    // Which phases the current run covers, read back from the results the core
    // writes — so every browser window renders the same run, whoever started it.
    const testedPhases = (phase3 ? [
        0,
        1,
        2
    ] : [
        hwPhase
    ]).filter((i)=>info[i] && !info[i].skipped);
    // On open, jump straight to the running step if a test is already in
    // progress (e.g. another user started it); otherwise start from the top.
    // Keyed on `open` only — later inProgress transitions are handled below.
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        setStep(inProgress ? 'running' : 'acknowledge');
    }, [
        open
    ]);
    // When the test finishes on the server, advance to the result step.
    const prevInProgress = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (prevInProgress.current && !inProgress && step === 'running') setStep('result');
        prevInProgress.current = inProgress;
    }, [
        inProgress,
        step
    ]);
    const handleStart = (phases)=>{
        // Clear any stale results from a previous run before starting.
        dispatch((0, $1Jwr0.variablesChange)({
            HW_SSR_TEST_PHASE: phase3 ? phases : [
                true,
                true,
                true
            ],
            HW_SSR_TEST_INFO: [],
            HW_SSR_TEST: true
        }));
        setStep('running');
    };
    const progress = step === 'acknowledge' ? 100 / 3 : step === 'running' ? 200 / 3 : 100;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullScreen: variant === 'fullscreen',
        slotProps: {
            paper: {
                sx: {
                    bgcolor: 'secondary.main'
                }
            }
        },
        fullWidth: true,
        maxWidth: variant === 'fullscreen' ? false : 'sm',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                sx: {
                    textAlign: 'center',
                    pt: 4,
                    pb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "h3",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "boiler_test_wizard.title",
                        defaultMessage: "Testov\xe1n\xed bojleru"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    px: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87e33f68a58c76cf$export$2e2bcd8739ae039), {
                    variant: "determinate",
                    value: progress
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    p: 0,
                    py: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column'
                    },
                    children: [
                        step === 'acknowledge' && /*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$AcknowledgeStep, {
                            onStart: handleStart
                        }),
                        step === 'running' && /*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$RunningStep, {
                            phases: testedPhases
                        }),
                        step === 'result' && /*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$ResultStep, {
                            phases: testedPhases,
                            onClose: onClose,
                            // Re-run exactly the phases the finished run covered.
                            onRerun: ()=>handleStart([
                                    0,
                                    1,
                                    2
                                ].map((i)=>testedPhases.includes(i)))
                        })
                    ]
                })
            })
        ]
    });
};
// Step 1: technician acknowledges the test conditions and the configuration.
const $2cd327e5970cd381$var$AcknowledgeStep = ({ onStart: onStart })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const [phase3, nominal] = (0, $2lSXC.useSelector)((s)=>[
            s.variables.PHASE_3_HW,
            s.variables.HW_EK_NOMINAL
        ]);
    const phaseCount = phase3 ? 3 : 1;
    const totalPower = nominal * phaseCount;
    const homeActualPower = $2cd327e5970cd381$var$useHomeActualPower();
    const [conditionConfirmed, setConditionConfirmed] = (0, $acw62.useState)(false);
    const [configConfirmed, setConfigConfirmed] = (0, $acw62.useState)(false);
    // The step is remounted every time the wizard opens, so every phase starts
    // selected.
    const [phases, setPhases] = (0, $acw62.useState)([
        true,
        true,
        true
    ]);
    const togglePhase = (index)=>setPhases((prev)=>prev.map((v, i)=>i === index ? !v : v));
    const anyPhaseSelected = !phase3 || phases.some(Boolean);
    const canStart = conditionConfirmed && configConfirmed && anyPhaseSelected;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_wizard.acknowledge.title",
                    defaultMessage: "Informace k testu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler_test_wizard.acknowledge.condition",
                                defaultMessage: "Pro spr\xe1vn\xfd test bojleru je nutn\xe9, aby byla spot\u0159eba v objektu konstantn\xed a nebo nulov\xe1. Jak\xe9koliv v\xfdkyvy ve spot\u0159eb\u011B mohou test ovlivnit. Aktu\xe1ln\xed spot\u0159eba objektu je {power}",
                                values: {
                                    power: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: formatNumber(homeActualPower, {
                                            style: 'unit',
                                            unit: 'kilowatt',
                                            maximumFractionDigits: 1
                                        })
                                    })
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$ConfirmRow, {
                        checked: conditionConfirmed,
                        onToggle: ()=>setConditionConfirmed((v)=>!v)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler_test_wizard.acknowledge.config",
                                defaultMessage: "Aktu\xe1ln\u011B je nastaven {phaseLabel} bojler o celkov\xe9 v\xfdkonu {power}. Tyto hodnoty mus\xed b\xfdt zadan\xe9 dle \u0161t\xedtku patrony.",
                                values: {
                                    phaseLabel: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: phase3 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "boiler_test_wizard.acknowledge.phase3",
                                            defaultMessage: "3-f\xe1zov\xfd"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "boiler_test_wizard.acknowledge.phase1",
                                            defaultMessage: "1-f\xe1zov\xfd"
                                        })
                                    }),
                                    power: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                        children: formatNumber(totalPower, {
                                            style: 'unit',
                                            unit: 'kilowatt',
                                            maximumFractionDigits: 1
                                        })
                                    })
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$ConfirmRow, {
                        checked: configConfirmed,
                        onToggle: ()=>setConfigConfirmed((v)=>!v)
                    })
                ]
            }),
            phase3 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler_test_wizard.acknowledge.phase_select",
                                defaultMessage: "Vyberte f\xe1ze, kter\xe9 se maj\xed otestovat. Neozna\u010Den\xe9 f\xe1ze budou p\u0159esko\u010Deny."
                            })
                        })
                    }),
                    [
                        0,
                        1,
                        2
                    ].map((index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$PhaseRow, {
                            phase: index,
                            checked: phases[index],
                            onToggle: ()=>togglePhase(index)
                        }, index)),
                    !anyPhaseSelected && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        sx: {
                            pt: 0
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body2",
                            color: "error",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler_test_wizard.acknowledge.phase_select_empty",
                                defaultMessage: "Vyberte alespo\u0148 jednu f\xe1zi."
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    py: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    disabled: !canStart,
                    onClick: ()=>onStart(phases),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "boiler_test_wizard.acknowledge.start",
                        defaultMessage: "Otestovat bojler"
                    })
                })
            })
        ]
    });
};
const $2cd327e5970cd381$var$ConfirmRow = ({ checked: checked, onToggle: onToggle })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        onClick: onToggle,
        sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            pt: 0,
            pb: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    opacity: 0.7
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_wizard.acknowledge.confirm",
                    defaultMessage: "Potvrzuji"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                checked: checked,
                readOnly: true,
                size: "large"
            })
        ]
    });
const $2cd327e5970cd381$var$PhaseRow = ({ phase: phase, checked: checked, onToggle: onToggle })=>// The Paper itself must stay a block element — ParentPaper injects an
    // `::after` divider that would otherwise become a flex item and push the
    // checkbox towards the middle of the row.
    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        onClick: onToggle,
        sx: {
            cursor: 'pointer',
            pt: 0,
            pb: 1
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        opacity: 0.7
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "boiler_test_wizard.acknowledge.phase_option",
                        defaultMessage: "{phase}. f\xe1ze",
                        values: {
                            phase: phase + 1
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                    checked: checked,
                    readOnly: true,
                    size: "large"
                })
            ]
        })
    });
// Step 2: live log of the running test, one card per phase.
const $2cd327e5970cd381$var$RunningStep = ({ phases: phases })=>{
    const info = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_INFO);
    const remaining = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_REMAINING_TIME);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_wizard.running.title",
                    defaultMessage: "Prob\xedh\xe1 test"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "body1",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler_test_wizard.running.remaining",
                                    defaultMessage: "Zb\xfdv\xe1 p\u0159ibli\u017En\u011B {seconds} s",
                                    values: {
                                        seconds: remaining
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            phases.map((phase)=>/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$PhaseLog, {
                    phase: phase,
                    entry: info[phase]
                }, phase))
        ]
    });
};
// A single line of the live phase log, with a status icon on the left.
const $2cd327e5970cd381$var$StepLine = ({ icon: icon, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    width: 20,
                    justifyContent: 'center'
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    opacity: 0.85
                },
                children: children
            })
        ]
    });
const $2cd327e5970cd381$var$doneIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
    color: "success",
    fontSize: "small"
});
const $2cd327e5970cd381$var$PhaseLog = ({ phase: phase, entry: entry })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    // Nothing logged yet for this phase.
    if (!entry) return null;
    const kw = (value)=>formatNumber(value, {
            style: 'unit',
            unit: 'kilowatt',
            maximumFractionDigits: 1
        });
    // Derive how far the phase has progressed from the fields populated so far.
    const baselineDone = entry.homeConsumption > 0;
    const activationDone = entry.ssrPower === 100 || entry.homeConsumptionNext > 0;
    const activeMeasureDone = entry.homeConsumptionNext > 0;
    const completed = !entry.inProgress;
    const lines = [];
    // 1. Reset consumption.
    lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
        icon: $2cd327e5970cd381$var$doneIcon,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler_test_wizard.running.reset",
            defaultMessage: "Nulov\xe1n\xed spot\u0159eby"
        })
    }, "reset"));
    // 2. Baseline consumption.
    if (baselineDone) lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
        icon: $2cd327e5970cd381$var$doneIcon,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler_test_wizard.running.before",
            defaultMessage: "Spot\u0159eba objektu p\u0159ed testem je {power}",
            values: {
                power: kw(entry.homeConsumption)
            }
        })
    }, "before"));
    // 3. Activate the boiler phase.
    if (activationDone) lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
        icon: $2cd327e5970cd381$var$doneIcon,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler_test_wizard.running.activate",
            defaultMessage: "Aktivace f\xe1ze bojleru"
        })
    }, "activate"));
    // 4. Consumption with the boiler running.
    if (activeMeasureDone) lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
        icon: $2cd327e5970cd381$var$doneIcon,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler_test_wizard.running.after",
            defaultMessage: "Spot\u0159eba objektu je {power}",
            values: {
                power: kw(entry.homeConsumptionNext)
            }
        })
    }, "after"));
    // 5-7. Evaluation, shown once the phase has finished.
    if (completed) {
        lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
            icon: entry.measurementUnstable ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                color: "error",
                fontSize: "small"
            }) : $2cd327e5970cd381$var$doneIcon,
            children: entry.measurementUnstable ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.running.unstable",
                defaultMessage: "M\u011B\u0159en\xed nebylo stabiln\xed"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.running.stable",
                defaultMessage: "Spot\u0159eba je stabiln\xed"
            })
        }, "stable"));
        lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
            icon: $2cd327e5970cd381$var$doneIcon,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.running.real_power",
                defaultMessage: "Odhadovan\xfd v\xfdkon bojleru je {power}",
                values: {
                    power: kw(entry.boilerRealPower)
                }
            })
        }, "real"));
        lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
            icon: entry.result ? $2cd327e5970cd381$var$doneIcon : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                color: "error",
                fontSize: "small"
            }),
            children: entry.result ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.running.result_ok",
                defaultMessage: "Test f\xe1ze je korektn\xed"
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.running.result_fail",
                defaultMessage: "Test f\xe1ze nen\xed korektn\xed"
            })
        }, "result"));
    } else // Still running — show that a measurement is in progress.
    lines.push(/*#__PURE__*/ (0, $ayMG0.jsx)($2cd327e5970cd381$var$StepLine, {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
            size: 16
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler_test_wizard.running.measuring",
            defaultMessage: "Prob\xedh\xe1 m\u011B\u0159en\xed\u2026"
        })
    }, "measuring"));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "h3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler_test_wizard.running.phase",
                                    defaultMessage: "Testuji f\xe1zi {phase}",
                                    values: {
                                        phase: phase + 1
                                    }
                                })
                            }),
                            entry.inProgress ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                                size: 16
                            }) : entry.result ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                color: "success",
                                fontSize: "small"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                                color: "error",
                                fontSize: "small"
                            })
                        ]
                    }),
                    lines
                ]
            })
        })
    });
};
// Step 3: result table.
const $2cd327e5970cd381$var$ResultStep = ({ phases: phaseIndexes, onClose: onClose, onRerun: onRerun })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const info = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_INFO);
    const [showDetail, setShowDetail] = (0, $acw62.useState)(false);
    const phases = phaseIndexes.map((i)=>info[i]).filter(Boolean);
    const passed = phases.length > 0 && phases.every((p)=>p.result);
    // Fixed value-column width so the detail and summary grids stay aligned.
    const gridColumns = `minmax(0, 1fr) repeat(${phases.length}, 64px)`;
    const kw = (value)=>formatNumber(value, {
            style: 'unit',
            unit: 'kilowatt',
            maximumFractionDigits: 1
        });
    const boolIcon = (value)=>value ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
            color: "success",
            fontSize: "small"
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
            color: "error",
            fontSize: "small"
        });
    const rows = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.set_power",
                defaultMessage: "Zadan\xfd v\xfdkon"
            }),
            values: phases.map((p)=>kw(p.setPower))
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.before",
                defaultMessage: "Spot\u0159eba objektu p\u0159ed aktivac\xed"
            }),
            values: phases.map((p)=>kw(p.homeConsumption))
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.after",
                defaultMessage: "Spot\u0159eba objektu po aktivaci"
            }),
            values: phases.map((p)=>kw(p.homeConsumptionNext))
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.stable",
                defaultMessage: "M\u011B\u0159en\xed bylo stabiln\xed"
            }),
            values: phases.map((p)=>boolIcon(!p.measurementUnstable))
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.correct",
                defaultMessage: "Spot\u0159eba bojleru korektn\xed"
            }),
            values: phases.map((p)=>boolIcon(p.result))
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "boiler_test_wizard.result.real_power",
                defaultMessage: "Odhadovan\xfd p\u0159\xedkon bojleru"
            }),
            values: phases.map((p)=>kw(p.boilerRealPower))
        }
    ];
    // Show the two summary rows by default; the rest is behind the collapse.
    const detailRows = rows.slice(0, rows.length - 2);
    const summaryRows = rows.slice(rows.length - 2);
    const phaseHeaderCells = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {}),
            phases.map((_, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "h5",
                    sx: {
                        textAlign: 'right'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "boiler_test_wizard.result.phase_header",
                        defaultMessage: "{phase}. f\xe1ze",
                        values: {
                            phase: phaseIndexes[i] + 1
                        }
                    })
                }, `h-${i}`))
        ]
    });
    const renderRow = (row, ri)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        fontWeight: 600
                    },
                    children: row.label
                }),
                row.values.map((value, ci)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center'
                        },
                        children: typeof value === 'string' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: value
                        }) : value
                    }, ci))
            ]
        }, ri);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_wizard.result.title",
                    defaultMessage: "V\xfdsledek testu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                        variant: "h3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "boiler_test_wizard.result.header",
                                            defaultMessage: "V\xfdsledek testu:"
                                        })
                                    }),
                                    passed ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8975383ad1dea524$export$2e2bcd8739ae039), {
                                        color: "success"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b8d976dd8c0b005c$export$2e2bcd8739ae039), {
                                        color: "error"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                sx: {
                                    display: 'grid',
                                    gridTemplateColumns: gridColumns,
                                    rowGap: 1.5,
                                    columnGap: 1,
                                    alignItems: 'center'
                                },
                                children: [
                                    phaseHeaderCells,
                                    summaryRows.map(renderRow)
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                variant: "text",
                                size: "small",
                                onClick: ()=>setShowDetail((v)=>!v),
                                endIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NDEo7.default), {
                                    sx: {
                                        transition: 'transform 0.2s',
                                        transform: showDetail ? 'rotate(180deg)' : 'none'
                                    }
                                }),
                                sx: {
                                    alignSelf: 'flex-start'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler_test_wizard.result.detail_toggle",
                                    defaultMessage: "Detail testu"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                                in: showDetail,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                    sx: {
                                        display: 'grid',
                                        gridTemplateColumns: gridColumns,
                                        rowGap: 1.5,
                                        columnGap: 1,
                                        alignItems: 'center'
                                    },
                                    children: detailRows.map(renderRow)
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "outlined",
                        onClick: onRerun,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler_test_wizard.result.rerun",
                            defaultMessage: "Spustit test znovu"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler_test_wizard.result.close",
                            defaultMessage: "Zav\u0159\xedt"
                        })
                    })
                ]
            })
        ]
    });
};


const $7f500361bb014857$export$2cddd0ae366a366c = ({ variant: variant })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const inProgress = (0, $2lSXC.useSelector)((s)=>s.variables.HW_SSR_TEST_IN_PROGRESS);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_trigger.title",
                    defaultMessage: "Test bojleru"
                }),
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_trigger.subtitle",
                    defaultMessage: "Ov\u011B\u0159\xed spr\xe1vn\xe9 zapojen\xed a zadan\xfd v\xfdkon patrony bojleru."
                }),
                buttonLabel: inProgress ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_trigger.button.running",
                    defaultMessage: "Test prob\xedh\xe1"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler_test_trigger.button",
                    defaultMessage: "Otestovat bojler"
                }),
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                onClick: ()=>setOpen(true),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2cd327e5970cd381$export$eed389ff22efcb06), {
                open: open,
                onClose: ()=>setOpen(false),
                variant: variant
            })
        ]
    });
};


var $ef1989c3b720beed$exports = {};
$ef1989c3b720beed$exports = import.meta.resolve("fsgpV");


const $4e114ecd9f3894d6$var$serviceMenuPathImage = new URL($ef1989c3b720beed$exports);
const $4e114ecd9f3894d6$var$TOTAL_STEPS = 11;
const $4e114ecd9f3894d6$export$b193ba724abb42ba = ()=>{
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const wizardState = location.state?.wizard;
    const open = wizardState?.open === true;
    const currentStep = wizardState?.step || 1;
    const handleOpen = ()=>{
        navigate(location.pathname + location.search, {
            state: {
                ...location.state,
                wizard: {
                    open: true,
                    step: 1
                }
            }
        });
    };
    const handleClose = ()=>{
        const newState = {
            ...location.state
        };
        delete newState.wizard;
        navigate(location.pathname + location.search, {
            state: newState
        });
    };
    const setCurrentStep = (step)=>{
        navigate(location.pathname + location.search, {
            state: {
                ...location.state,
                wizard: {
                    open: true,
                    step: step
                }
            }
        });
    };
    const dialog = /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$InitialWizardDialog, {
        open: open,
        onClose: handleClose,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep
    });
    return {
        dialog: dialog,
        open: handleOpen,
        close: handleClose
    };
};
const $4e114ecd9f3894d6$var$InitialWizardDialog = ({ open: open, onClose: onClose, currentStep: currentStep, setCurrentStep: setCurrentStep })=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const serviceActive = (0, $2lSXC.useSelector)((s)=>s.variables.SERVICE_ACTIVE);
    const location = (0, $aphAM.useLocation)();
    const prevPathnameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(location.pathname);
    (0, $acw62.useEffect)(()=>{
        if (open && location.pathname !== prevPathnameRef.current) onClose();
        prevPathnameRef.current = location.pathname;
    }, [
        location.pathname,
        open,
        onClose
    ]);
    const handleNext = ()=>{
        if (currentStep < $4e114ecd9f3894d6$var$TOTAL_STEPS) setCurrentStep(currentStep + 1);
        else {
            // Complete wizard
            dispatch((0, $1Jwr0.variablesChange)({
                INITIAL_WIZARD_COMPLETED_AT: new Date().toISOString()
            }));
            onClose();
        }
    };
    const handlePrev = ()=>{
        if (currentStep > 1) setCurrentStep(currentStep - 1);
        else onClose();
    };
    const progress = currentStep / $4e114ecd9f3894d6$var$TOTAL_STEPS * 100;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullScreen: true,
        slotProps: {
            paper: {
                sx: {
                    bgcolor: 'secondary.main'
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6hSWk.default), {
                sx: {
                    textAlign: 'center',
                    pt: 4,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.dialog.title",
                            defaultMessage: "Pr\u016Fvodce po\u010D\xe1te\u010Dn\xedm nastaven\xedm"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body2",
                        sx: {
                            mt: 1,
                            opacity: 0.7
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.dialog.step",
                            defaultMessage: "Krok {current} z {total}",
                            values: {
                                current: currentStep,
                                total: $4e114ecd9f3894d6$var$TOTAL_STEPS
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    px: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87e33f68a58c76cf$export$2e2bcd8739ae039), {
                    variant: "determinate",
                    value: progress
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    p: 0,
                    pt: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$WizardStep, {
                        step: currentStep
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                sx: {
                    justifyContent: 'space-between',
                    px: 3,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: handlePrev,
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.dialog.prev",
                            defaultMessage: "Zp\u011Bt"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: handleNext,
                        variant: "contained",
                        disabled: currentStep === 1 && !serviceActive,
                        children: currentStep === $4e114ecd9f3894d6$var$TOTAL_STEPS ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.dialog.finish",
                            defaultMessage: "Dokon\u010Dit"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.dialog.next",
                            defaultMessage: "Dal\u0161\xed"
                        })
                    })
                ]
            })
        ]
    });
};
const $4e114ecd9f3894d6$var$WizardStep = ({ step: step })=>{
    switch(step){
        case 1:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step1ServiceLogin, {});
        case 2:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step2AppUpdate, {});
        case 3:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step3Installation, {});
        case 4:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step4CircuitBreaker, {});
        case 5:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step5PVInverter, {});
        case 6:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step6PVDetails, {});
        case 7:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step7PVOverflow, {});
        case 8:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step8Boiler, {});
        case 9:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step9SpotPrices, {});
        case 10:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step10Wallbox, {});
        case 11:
            return /*#__PURE__*/ (0, $ayMG0.jsx)($4e114ecd9f3894d6$var$Step11Done, {});
        default:
            return null;
    }
};
// Step 1: Service Login
const $4e114ecd9f3894d6$var$Step1ServiceLogin = ()=>{
    const serviceActive = (0, $2lSXC.useSelector)((s)=>s.variables.SERVICE_ACTIVE);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                sx: {
                    textAlign: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step1.title",
                    defaultMessage: "P\u0159\xedstup do servisu"
                })
            }),
            serviceActive ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        textAlign: 'center'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "initial_wizard.step1.description.active",
                        defaultMessage: "V\xe1\u0161 p\u0159\xedstup do servisu je ji\u017E aktivn\xed. M\u016F\u017Eete pokra\u010Dovat na dal\u0161\xed krok."
                    })
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body1",
                        sx: {
                            textAlign: 'center',
                            py: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.step1.welcome",
                            defaultMessage: "V\xedtejte v \xfavodn\xedm nastaven\xed Infigy. Provedeme v\xe1s z\xe1kladn\xed konfigurac\xed va\u0161eho syst\xe9mu. Detailn\u011Bj\u0161\xed nastaven\xed pot\xe9 najdete v servisn\xedm menu."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.service.password",
                                    defaultMessage: "P\u0159\xedstup do servisu"
                                }),
                                inputVariableId: "SERVICE_PASSWORD",
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.service.password.label",
                                    defaultMessage: "Heslo"
                                }),
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body1",
                                    sx: {
                                        color: 'primary.main'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "initial_wizard.step1.password_info",
                                        defaultMessage: "Ka\u017Ed\xe1 firma m\xe1 vlastn\xed p\u0159\xedstupov\xe9 heslo do servisn\xedho menu. Heslo jste obdr\u017Eeli v emailov\xe9 komunikaci. M\u016F\u017Eete si jej tak\xe9 kdykoliv zobrazit v app.infigy.cz v partnersk\xe9 sekci."
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// Step 2: App Update
const $4e114ecd9f3894d6$var$Step2AppUpdate = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step2.title",
                    defaultMessage: "Aktualizace aplikace"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22ebae9741c9601a$export$5f7700ebf3ab7ed8), {
                        autoCheck: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'primary.main'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "initial_wizard.step_app_update.description",
                                defaultMessage: "V \u010Dase kdy bylo Infigy na cest\u011B k v\xe1m jsme mohli vydat nov\xe9 verze aplikace. Doporu\u010Dujeme p\u0159ed nastaven\xedm jednotku aktualizovat. Pokud ale nap\u0159\xedklad nen\xed dostupn\xfd internet, m\u016F\u017Eete aktualizaci p\u0159esko\u010Dit a prov\xe9st ji pozd\u011Bji v servisn\xedm menu, nebo v port\xe1lu."
                            })
                        })
                    })
                ]
            })
        ]
    });
};
// Step 3: Installation
const $4e114ecd9f3894d6$var$Step3Installation = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step3.title",
                    defaultMessage: "Instalace"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4101366a11d69ee$export$32b907da6e4e6ad1), {})
            })
        ]
    });
};
// Step 4: Circuit Breaker
const $4e114ecd9f3894d6$var$Step4CircuitBreaker = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step4.title",
                    defaultMessage: "Nastaven\xed hlavn\xedho jisti\u010De"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c4cdc7ff1541b41$export$6ebb4e06731ab0d9), {})
            })
        ]
    });
};
// Step 5: PV Inverter
const $4e114ecd9f3894d6$var$Step5PVInverter = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step5.title",
                    defaultMessage: "P\u0159ipojen\xed st\u0159\xedda\u010De"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OLlTf.InverterTypeSelect), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4faae2edb5297062$export$f7ab7423ce4b898e), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fba062b26dc2f097$export$7b3f09138ef8bc19), {})
                ]
            })
        ]
    });
};
// Step 6: PV Details
const $4e114ecd9f3894d6$var$Step6PVDetails = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step6.title",
                    defaultMessage: "Parametry st\u0159\xedda\u010De"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6aaadd6817fa784e$export$a040df6eb068c6c9), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44aa4714e63a415$export$5f03a5ec016badda), {})
            })
        ]
    });
};
// Step 7: PV Overflow
const $4e114ecd9f3894d6$var$Step7PVOverflow = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step7.title",
                    defaultMessage: "Omezen\xed p\u0159etoku"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6342fbb618ee4f49$export$b0c19aa6a430c560), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'primary.main'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "initial_wizard.step7.description",
                                defaultMessage: "Pokud je omezen p\u0159etok do s\xedt\u011B, dojde k p\u0159enesen\xed nastaven\xed do st\u0159\xedda\u010De. Omezov\xe1n\xed p\u0159etok\u016F zaji\u0161tuje st\u0159\xedda\u010D. Z\xe1pis a zm\u011Bnu hodnoty v\u0161ak \u0159\xedd\xed Infigy dle zadan\xe9 hodnoty v tomto poli. Neupravujte tedy omezen\xed p\u0159etoku ve st\u0159\xedda\u010Di. P\u0159i prvn\xedm nastaven\xed si zapsanou hodnotu zkontrolujte ve st\u0159\xedda\u010Di, zda se V\xe1m spr\xe1vn\u011B prom\xedtla z Infigy do st\u0159\xedda\u010De."
                            })
                        })
                    })
                ]
            })
        ]
    });
};
// Step 8: Boiler
const $4e114ecd9f3894d6$var$Step8Boiler = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step8.title",
                    defaultMessage: "Nastaven\xed bojleru"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da7e8a667ca6e3e6$export$f93868c14f0bb964), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f500361bb014857$export$2cddd0ae366a366c), {
                        variant: "dialog"
                    })
                ]
            })
        ]
    });
};
// Step 9: Spot Prices
const $4e114ecd9f3894d6$var$Step9SpotPrices = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step9.title",
                    defaultMessage: "Nastaven\xed spotov\xe9ho obchodov\xe1n\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f43a5934aae8819d$export$ca67f46453ceea0d), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84bcf1fb32102d8$export$dd088f0d81500b74), {})
                ]
            })
        ]
    });
};
// Step 10: Wallbox
const $4e114ecd9f3894d6$var$Step10Wallbox = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step10.title",
                    defaultMessage: "Nastaven\xed wallboxu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c912a4a4aecd7f44$export$93dfdc1002311d10), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7153b1eb2fa26705$export$a29d188ae7b63a77), {})
                ]
            })
        ]
    });
};
// Step 11: Done
const $4e114ecd9f3894d6$var$Step11Done = ()=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const navigate = (0, $aphAM.useNavigate)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                sx: {
                    textAlign: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.step11.title",
                    defaultMessage: "Hotovo"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                sx: {
                    mt: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "initial_wizard.step11.description",
                                defaultMessage: "Pro\u0161li jste z\xe1kladn\xed nastaven\xed Infigy. Ve\u0161ker\xe9 parametry lze upravit v servisn\xedm menu."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.step11.service_menu.title",
                            defaultMessage: "Servisn\xed menu"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.step11.service_menu.subtitle",
                            defaultMessage: "Nastaven\xed -> \xfapln\u011B dol\u016F -> P\u0159\xedstup do servisu"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            onClick: ()=>{
                                dispatch((0, $1Jwr0.variablesChange)({
                                    INITIAL_WIZARD_COMPLETED_AT: new Date().toISOString()
                                }));
                                navigate((0, $dHW62.links).settings, {
                                    state: {
                                        scroll: 'service'
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219448ca2dce677c$export$2e2bcd8739ae039), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            textAlign: 'center',
                            mt: 1,
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            component: "img",
                            src: $4e114ecd9f3894d6$var$serviceMenuPathImage.toString(),
                            alt: "",
                            sx: {
                                width: 260,
                                height: 'auto'
                            }
                        })
                    })
                ]
            })
        ]
    });
};


const $5c36b248b5436f55$export$c57337bf78256d68 = ({ variant: variant = 'default', sx: sx = {} })=>{
    const [wizardCompletedAt, bannerHiddenPermanently] = (0, $2lSXC.useSelector)(({ variables: { INITIAL_WIZARD_COMPLETED_AT: INITIAL_WIZARD_COMPLETED_AT, INITIAL_WIZARD_BANNER_HIDDEN_PERMANENTLY: INITIAL_WIZARD_BANNER_HIDDEN_PERMANENTLY } })=>[
            INITIAL_WIZARD_COMPLETED_AT,
            INITIAL_WIZARD_BANNER_HIDDEN_PERMANENTLY
        ]);
    const { dialog: dialog, open: open } = (0, $4e114ecd9f3894d6$export$b193ba724abb42ba)();
    const { onHide: onHide, hideDialog: hideDialog } = $5c36b248b5436f55$var$useHideWizardBanner({
        openWizardDialog: open
    });
    // Hide banner if:
    // - Wizard is completed
    // - Banner is hidden permanently and not in settings view
    if (variant !== 'settings' && (!!wizardCompletedAt || bannerHiddenPermanently)) return null;
    const content = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                sx: {
                    color: variant === 'settings' ? 'text.primary' : 'common.white'
                },
                children: wizardCompletedAt ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.banner.title.completed",
                    defaultMessage: "Proj\xedt po\u010D\xe1te\u010Dn\xed nastaven\xed"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.banner.title",
                    defaultMessage: "Dokon\u010Dete po\u010D\xe1te\u010Dn\xed nastaven\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    maxWidth: 400,
                    mb: 2,
                    color: variant === 'settings' ? 'text.primary' : 'common.white'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.banner.subtitle",
                    defaultMessage: "Pr\u016Fvodce v\xe1m pom\u016F\u017Ee nastavit z\xe1kladn\xed parametry va\u0161eho syst\xe9mu."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    size: "small",
                    onClick: open,
                    sx: {
                        textTransform: 'none'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "initial_wizard.banner.button",
                        defaultMessage: "Spustit pr\u016Fvodce"
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                sx: {
                    ...sx
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
                    sx: {
                        bgcolor: (theme)=>variant === 'settings' ? 'background.paper' : theme.palette.mode === 'light' ? 'text.disabled' : '#343e42',
                        color: (0, $iD7Z3.colors).white,
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
                            gap: 1,
                            children: content
                        }),
                        variant !== 'settings' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            sx: {
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                zIndex: 1,
                                color: (0, $iD7Z3.colors).white
                            },
                            onClick: onHide,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f30deb19dfdb1c2$export$f39c2d165cd861fe), {})
                        })
                    ]
                })
            }),
            dialog,
            hideDialog
        ]
    });
};
const $5c36b248b5436f55$var$useHideWizardBanner = ({ openWizardDialog: openWizardDialog })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const onClose = ()=>setOpen(false);
    const dispatch = (0, $2lSXC.useDispatch)();
    const showMore = ()=>{
        openWizardDialog();
        onClose();
    };
    const hidePermanently = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            INITIAL_WIZARD_BANNER_HIDDEN_PERMANENTLY: true
        }));
        onClose();
    };
    const hideDialog = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "xs",
        slotProps: {
            paper: {
                sx: {
                    bgcolor: 'secondary.main'
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                variant: "h2",
                sx: {
                    textAlign: 'center',
                    py: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "initial_wizard.banner.hide.confirm",
                    defaultMessage: "Opravdu chcete skr\xfdt pr\u016Fvodce?"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    sx: {
                        textAlign: 'center',
                        mt: 1
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "initial_wizard.banner.hide.confirm.description",
                        defaultMessage: "Pr\u016Fvodce m\u016F\u017Eete kdykoli znovu spustit v nastaven\xed aplikace."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                sx: {
                    py: 2,
                    flexDirection: 'column',
                    gap: 1.5,
                    '& .MuiButton-root': {
                        width: 280
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: showMore,
                        color: "primary",
                        variant: "contained",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.banner.hide.show_more",
                            defaultMessage: "Spustit pr\u016Fvodce"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: hidePermanently,
                        variant: "text",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "initial_wizard.banner.hide.yes",
                            defaultMessage: "Skr\xfdt"
                        })
                    })
                ]
            })
        ]
    });
    return {
        onHide: ()=>setOpen(true),
        hideDialog: hideDialog
    };
};


const $a0b46b89485c073d$var$Home = ()=>{
    const [ecooneHP, acondHP, nibeHP] = (0, $2lSXC.useSelector)(({ variables: { HP_TYPE: HP_TYPE } })=>[
            HP_TYPE === 1,
            HP_TYPE === 4,
            HP_TYPE === 2
        ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "homepage.statuses.title",
                    defaultMessage: "Re\u017Eimy aktivn\xedch komponent\u016F"
                }),
                help: {
                    variant: 'tooltip',
                    title: undefined,
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "homepage.statuses.tooltip",
                        defaultMessage: "Re\u017Eimy aktivn\xedch komponent\u016F"
                    })
                },
                layout: "scrollable",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'HW_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler.status.home",
                            defaultMessage: "Re\u017Eim bojleru"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "heatWater"
                        }),
                        switchVariableId: "HW_ON",
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'PV_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.status",
                            defaultMessage: "Re\u017Eim FVE"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "photovoltaic"
                        }),
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electrical_grid.status",
                            defaultMessage: "Stav distribu\u010Dn\xed s\xedt\u011B"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "smartMeter"
                        }),
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'HP_ENABLED'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.status",
                            defaultMessage: "Re\u017Eim tepelka"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0866bf7fb82c359f$export$c8c02a74d96210d1), {}),
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'WB_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.status.home",
                            defaultMessage: "Re\u017Eim wallboxu"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86275d5209b32b69$export$d39b7d88aba30ea1), {}),
                        switchVariableId: "WB_ON",
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'PL_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.status",
                            defaultMessage: "Re\u017Eim z\xe1suvky"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "plug",
                            index: 0
                        }),
                        switchVariableId: "PL_ON[0]",
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        visibility: {
                            variableId: 'WIND_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.status",
                            defaultMessage: "Re\u017Eim v\u011Btrn\xe9 elektr\xe1rny"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "wind"
                        }),
                        sx: {
                            mr: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c36b248b5436f55$export$c57337bf78256d68), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f579057103a82b5f$export$6a4327ccdb5e4fea), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "homepage.animation",
                    defaultMessage: "Aktu\xe1ln\u011B"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ccd4aed76daaffff$export$c35d437ae5945fcd), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "homepage.actual.title",
                    defaultMessage: " "
                }),
                layout: "grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        visibility: {
                            variableId: 'PV_BATTERY'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.actual.battery",
                            defaultMessage: "Stav baterie"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_ACTUAL_SOC",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                        gridItem: {
                            size: 6
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        visibility: {
                            variableId: 'THERMOSTAT_INSTALL'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.actual.thermostat",
                            defaultMessage: "Termostat"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "THERMOSTAT_INFO[0].actualTemp",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9748beca3fc4505a$export$a72d32054f236c4), {}),
                        gridItem: {
                            size: 6
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        visibility: {
                            variableIds: [
                                'HW_TEMP_ENABLED',
                                'HW_INSTALL'
                            ]
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.actual.boiler",
                            defaultMessage: "Bojler"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HW_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {}),
                        gridItem: {
                            size: 6
                        }
                    }),
                    (ecooneHP || acondHP || nibeHP) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        visibility: {
                            variableIds: [
                                'HP_ENABLED'
                            ]
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.actual.outdoor_temperature",
                            defaultMessage: "Venkovn\xed teplota"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "OUTDOOR_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9748beca3fc4505a$export$a72d32054f236c4), {}),
                        gridItem: {
                            size: 6
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "homepage.today.title",
                    defaultMessage: "Denn\xed statistika"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.photovoltaics",
                            defaultMessage: "V\xfdroba FVE"
                        }),
                        visibility: {
                            variableId: 'PV_INSTALL'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_PV_ENERGY_PRODUCED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.consumed_from_grid",
                            defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_EM_ENERGY_CONSUMED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        visibility: {
                            variableId: 'EM_INSTALL'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.overflow",
                            defaultMessage: "P\u0159etok do s\xedt\u011B"
                        }),
                        visibility: {
                            variableId: 'PV_INSTALL'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_EM_ENERGY_OVERFLOW_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.consumed",
                            defaultMessage: "Spot\u0159eba domu"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_HOME_ENERGY_CONSUMED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        visibility: {
                            variableId: 'EM_INSTALL'
                        },
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdd94ff560015fde$export$1027d4534a5ce60b), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.consumed_hw",
                            defaultMessage: "Tepl\xe1 voda"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_HW_ENERGY_PRODUCED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {}),
                        visibility: {
                            variableId: 'HW_INSTALL'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.consumed_hp",
                            defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_HP_ENERGY_CONSUMED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {}),
                        visibility: {
                            variableId: 'HP_ENABLED'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.consumed_WB",
                            defaultMessage: "Wallbox"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'STATS_WB_ENERGY_CONSUMPTION_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {
                            sx: {
                                width: 20
                            }
                        }),
                        visibility: {
                            variableId: 'WB_INSTALL'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "homepage.today.wind",
                            defaultMessage: "V\xfdroba v\u011Btrn\xe9 elektr\xe1rny"
                        }),
                        visibility: {
                            variableId: 'WIND_INSTALL'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: 'WIND_PRODUCED_TODAY',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {})
                    })
                ]
            })
        ]
    });
};
var $a0b46b89485c073d$export$2e2bcd8739ae039 = $a0b46b89485c073d$var$Home;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");





var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $202BL = parcelRequire("202BL");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $4mI0b = parcelRequire("4mI0b");
var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");

var $jDfxe = parcelRequire("jDfxe");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0885121e8393a5b8$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');



var $mjyu0 = parcelRequire("mjyu0");

var $iH29s = parcelRequire("iH29s");


var $bCDrB = parcelRequire("bCDrB");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $f4Eh3 = parcelRequire("f4Eh3");
var $2CcMD = parcelRequire("2CcMD");
var $hnYfM = parcelRequire("hnYfM");
var $g04kv = parcelRequire("g04kv");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $djmpM = parcelRequire("djmpM");

var $3AM7p = parcelRequire("3AM7p");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f71187894d79d79d$export$b85c003f960b1f3a(slot) {
    return (0, $4Cod0.default)('MuiButtonGroup', slot);
}
const $f71187894d79d79d$var$buttonGroupClasses = (0, $beCSm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $f71187894d79d79d$export$2e2bcd8739ae039 = $f71187894d79d79d$var$buttonGroupClasses;



var $238Rl = parcelRequire("238Rl");

var $hbLi5 = parcelRequire("hbLi5");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $5f8f3fc94b629807$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3AM7p.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3AM7p.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3AM7p.default)(ownerState.variant)}${(0, $3AM7p.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $3AM7p.default)(ownerState.variant)}${(0, $3AM7p.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $5f8f3fc94b629807$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $3AM7p.default)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $3AM7p.default)(orientation)}`,
            `grouped${(0, $3AM7p.default)(variant)}`,
            `grouped${(0, $3AM7p.default)(variant)}${(0, $3AM7p.default)(orientation)}`,
            `grouped${(0, $3AM7p.default)(variant)}${(0, $3AM7p.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f71187894d79d79d$export$b85c003f960b1f3a), classes);
};
const $5f8f3fc94b629807$var$ButtonGroupRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $5f8f3fc94b629807$var$overridesResolver
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $5f8f3fc94b629807$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $5f8f3fc94b629807$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $djmpM.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5f8f3fc94b629807$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $238Rl.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hbLi5.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $5f8f3fc94b629807$export$2e2bcd8739ae039 = $5f8f3fc94b629807$var$ButtonGroup;


var $u24M4 = parcelRequire("u24M4");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $9783e658684d505d$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 9h4v11H4zm12 4h4v7h-4zm-6-9h4v16h-4z"
}), 'BarChart');


var $2PduQ = parcelRequire("2PduQ");
var $cDXfy = parcelRequire("cDXfy");
var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bed1b9d1737b2367$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
}), 'ShowChart');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0f789d74a11cfb09$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M21 5.47 12 12 7.62 7.62 3 11V8.52L7.83 5l4.38 4.38L21 3zM21 15h-4.7l-4.17 3.34L6 12.41l-3 2.13V17l2.8-2 6.2 6 5-4h4z"
}), 'SsidChart');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $f436d97c54b51985$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M4 9h4v11H4zm0-5h4v4H4zm6 3h4v4h-4zm6 3h4v4h-4zm0 5h4v5h-4zm-6-3h4v8h-4z"
}), 'StackedBarChart');



var $2lSXC = parcelRequire("2lSXC");

var $5R532 = parcelRequire("5R532");

var $8ni7a = parcelRequire("8ni7a");
var $28b4cee73700460a$export$21eef29f47e43a9d = /*#__PURE__*/ function(StatisticsUnit) {
    StatisticsUnit["Kilowatt"] = "kilowatt";
    StatisticsUnit["Percent"] = "percent";
    StatisticsUnit["Celsius"] = "celsius";
    StatisticsUnit["MeterPerSecond"] = "meter-per-second";
    StatisticsUnit["Ampere"] = "ampere";
    return StatisticsUnit;
}({});
const $28b4cee73700460a$export$3bee075bfccd9aa1 = [
    'PV_POWER_GRAPH',
    'PV_POWER_STRING_GRAPH',
    'HW_POWER_GRAPH',
    'HW_POWER_PHASE_GRAPH',
    'HP_CONSUMED_GRAPH',
    'EM_CONSUMED_PHASE_GRAPH',
    'EM_CONSUMED_GRAPH',
    'EM_OVERFLOW_PHASE_GRAPH',
    'EM_OVERFLOW_GRAPH',
    'PL_POWER_GRAPH',
    'WB_CONSUMED_GRAPH',
    'PV_BATTERY_SOC_GRAPH',
    'PV_BATTERY_CHARGE_GRAPH',
    'PV_BATTERY_DISCHARGE_GRAPH',
    'HW_TEMP_GRAPH',
    'THERMOSTAT_TEMP_GRAPH',
    'OUTDOOR_TEMP_GRAPH',
    'WIND_POWER_GRAPH',
    'WIND_SPEED_GRAPH',
    'WIND_BATTERY_CHARGE_POWER_GRAPH',
    'WIND_LOAD_CURRENT_GRAPH',
    'HOME_CONSUMPTION',
    'EM_METER_POWER_GRAPH'
];
const $28b4cee73700460a$export$4a74961a3c9c97af = {
    PV_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PV_POWER_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).PV_POWER_STRING_GRAPH
    },
    PV_POWER_STRING_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PV_POWER_STRING_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).PV_POWER_STRING_GRAPH
    },
    HW_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).HW_POWER_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).HW_POWER_PHASE_GRAPH
    },
    HW_POWER_PHASE_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).HW_POWER_PHASE_GRAPH,
        unit: "kilowatt"
    },
    HP_CONSUMED_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).HP_CONSUMED_GRAPH,
        unit: "kilowatt"
    },
    EM_CONSUMED_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).EM_CONSUMED_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).EM_CONSUMED_PHASE_GRAPH
    },
    EM_CONSUMED_PHASE_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).EM_CONSUMED_PHASE_GRAPH,
        unit: "kilowatt"
    },
    EM_OVERFLOW_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).EM_OVERFLOW_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).EM_OVERFLOW_PHASE_GRAPH
    },
    EM_OVERFLOW_PHASE_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).EM_OVERFLOW_PHASE_GRAPH,
        unit: "kilowatt"
    },
    PL_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PL_POWER_GRAPH,
        unit: "kilowatt"
    },
    WB_CONSUMED_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).WB_CONSUMED_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).WB_CONSUMED_GRAPH
    },
    PV_BATTERY_SOC_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PV_BATTERY_SOC_GRAPH,
        unit: "percent"
    },
    PV_BATTERY_CHARGE_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PV_BATTERY_CHARGE_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).PV_BATTERY_CHARGE_GRAPH
    },
    PV_BATTERY_DISCHARGE_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).PV_BATTERY_DISCHARGE_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).PV_BATTERY_DISCHARGE_GRAPH
    },
    HW_TEMP_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).HW_TEMP_GRAPH,
        unit: "celsius"
    },
    THERMOSTAT_TEMP_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).THERMOSTAT_TEMP_GRAPH,
        unit: "celsius"
    },
    OUTDOOR_TEMP_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).OUTDOOR_TEMP_GRAPH,
        unit: "celsius"
    },
    WIND_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).WIND_POWER_GRAPH,
        unit: "kilowatt"
    },
    WIND_BATTERY_CHARGE_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).WIND_BATTERY_CHARGE_POWER_GRAPH,
        unit: "kilowatt"
    },
    WIND_SPEED_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).WIND_SPEED_GRAPH,
        unit: "meter-per-second"
    },
    WIND_LOAD_CURRENT_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).WIND_LOAD_CURRENT_GRAPH,
        unit: "ampere"
    },
    HOME_CONSUMPTION: {
        dbName: (0, $8ni7a.StatsMetric).HOME_CONSUMPTION,
        unit: "kilowatt"
    },
    EM_METER_POWER_GRAPH: {
        dbName: (0, $8ni7a.StatsMetric).EM_METER_POWER_GRAPH,
        unit: "kilowatt",
        subStats: (0, $8ni7a.StatsMetric).EM_METER_POWER_GRAPH
    }
};



var $50BRD = parcelRequire("50BRD");
var $9b560528a5f99400$export$585dc7a4228aacca = /*#__PURE__*/ function(Variant) {
    Variant["Line"] = "line";
    Variant["LineStacked"] = "line-stacked";
    Variant["Bar"] = "bar";
    Variant["BarStacked"] = "bar-stacked";
    return Variant;
}({});
var $9b560528a5f99400$export$9484bbecc3c49a2e = /*#__PURE__*/ function(Mode) {
    Mode["Day"] = "Day";
    Mode["Week"] = "Week";
    Mode["Year"] = "Year";
    return Mode;
}({});
var $9b560528a5f99400$export$b9601df20779e14a = /*#__PURE__*/ function(Aggregate) {
    Aggregate["Disabled"] = "Disabled";
    Aggregate["Hour"] = "Hour";
    Aggregate["Day"] = "Day";
    Aggregate["Month"] = "Month";
    return Aggregate;
}({});
const $9b560528a5f99400$export$163daf3316c6aaf8 = (options)=>{
    const [to, setTo] = (0, $acw62.useState)(new Date());
    const [mode, setMode] = (0, $acw62.useState)("Day");
    const [variant, setVariant] = (0, $acw62.useState)(options.initialVariant ?? "line");
    const { subStats: subStats } = options.variableId ? (0, $28b4cee73700460a$export$4a74961a3c9c97af)[options.variableId] : {
        subStats: undefined
    };
    const [premium] = (0, $2lSXC.useSelector)(({ variables: { PREMIUM: PREMIUM } })=>[
            PREMIUM
        ]);
    const showSubStats = premium && (options.parent || Boolean(subStats));
    const handleModeChange = (e)=>{
        setTo(new Date());
        setMode(e.target.value);
    };
    const handleVariantChange = (variant)=>{
        setVariant(variant);
    };
    const from = (0, $acw62.useMemo)(()=>{
        const today = (0, $hnYfM.isToday)(to);
        let newValue = to;
        if (mode === "Day") {
            newValue = (0, $g04kv.startOfDay)(to);
            if (today) newValue = (0, $f4Eh3.add)(to, {
                days: -1
            });
        } else if (mode === "Week") {
            newValue = (0, $f4Eh3.add)(to, {
                days: -7
            });
            if (today && [
                "bar",
                "bar-stacked"
            ].includes(variant)) newValue = (0, $g04kv.startOfDay)(newValue);
        } else if (mode === "Year") {
            newValue = (0, $f4Eh3.add)(to, {
                years: -1
            });
            if (today && [
                "bar",
                "bar-stacked"
            ].includes(variant)) newValue = (0, $g04kv.startOfDay)(newValue);
        }
        return newValue;
    }, [
        mode,
        to,
        variant
    ]);
    const onPrev = ()=>{
        const today = (0, $hnYfM.isToday)(to);
        let newValue = to;
        if (mode === "Day") {
            newValue = (0, $f4Eh3.add)(to, {
                days: -1
            });
            if (today) newValue = (0, $2CcMD.endOfDay)(newValue);
        }
        if (mode === "Week") {
            newValue = (0, $f4Eh3.add)(to, {
                days: -7
            });
            if (today) newValue = (0, $42ecbba5934145fb$export$ef8b6d9133084f4e)(newValue, {
                weekStartsOn: 1
            });
        }
        if (mode === "Year") {
            newValue = (0, $f4Eh3.add)(to, {
                years: -1
            });
            if (today) newValue = (0, $9805f8396c527015$export$8b7aa55c66d5569e)(newValue);
        }
        setTo(newValue);
    };
    const onNext = ()=>{
        let newValue = to;
        if (mode === "Day") {
            newValue = (0, $f4Eh3.add)(to, {
                days: 1
            });
            if ((0, $hnYfM.isToday)(newValue)) newValue = new Date();
        }
        if (mode === "Week") {
            newValue = (0, $f4Eh3.add)(to, {
                days: 7
            });
            if (newValue >= new Date()) newValue = new Date();
        }
        if (mode === "Year") {
            newValue = (0, $f4Eh3.add)(to, {
                years: 1
            });
            if (newValue >= new Date()) newValue = new Date();
        }
        setTo(newValue);
    };
    const nextDisabled = (0, $acw62.useMemo)(()=>{
        return to > (0, $g04kv.startOfDay)(new Date());
    }, [
        to,
        mode
    ]);
    const formattedRange = (0, $acw62.useMemo)(()=>{
        if (mode === "Day" && (0, $hnYfM.isToday)(to)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "chart.range.today",
            defaultMessage: "Posledn\xedch 24{nbsp}hodin",
            values: {
                nbsp: '\u00A0'
            }
        });
        if (mode === "Day") return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
            value: from,
            month: "short",
            day: "numeric"
        });
        if (mode === "Week" && (0, $hnYfM.isToday)(to)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "chart.range.this_week",
            defaultMessage: "Posledn\xed t\xfdden"
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        whiteSpace: 'nowrap'
                    },
                    component: "span",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                        value: from,
                        month: "short",
                        day: "numeric",
                        year: mode === "Year" ? 'numeric' : undefined
                    })
                }),
                ' - ',
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        whiteSpace: 'nowrap'
                    },
                    component: "span",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                        value: to,
                        month: "short",
                        day: "numeric",
                        year: mode === "Year" ? 'numeric' : undefined
                    })
                })
            ]
        });
    }, [
        from,
        to,
        mode
    ]);
    const chartVariantSelect = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5f8f3fc94b629807$export$2e2bcd8739ae039), {
        variant: "outlined",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                onClick: ()=>handleVariantChange("line"),
                variant: variant === "line" ? 'contained' : 'outlined',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bed1b9d1737b2367$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                onClick: ()=>handleVariantChange("bar"),
                variant: variant === "bar" ? 'contained' : 'outlined',
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9783e658684d505d$export$2e2bcd8739ae039), {})
            }),
            showSubStats && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03kOd.default), {
                        onClick: ()=>handleVariantChange("line-stacked"),
                        variant: variant === "line-stacked" ? 'contained' : 'outlined',
                        sx: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0f789d74a11cfb09$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                                sx: {
                                    position: 'absolute',
                                    top: -6,
                                    right: -6,
                                    zIndex: 10
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $03kOd.default), {
                        onClick: ()=>handleVariantChange("bar-stacked"),
                        variant: variant === "bar-stacked" ? 'contained' : 'outlined',
                        sx: {
                            position: 'relative'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f436d97c54b51985$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                                sx: {
                                    position: 'absolute',
                                    top: -6,
                                    right: -6,
                                    zIndex: 10
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return {
        mode: mode,
        setMode: setMode,
        from: from,
        to: to,
        variant: variant,
        filters: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
            sx: {
                flexWrap: showSubStats && options.parent ? {
                    xs: 'wrap',
                    sm: 'nowrap'
                } : 'nowrap'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                    value: mode,
                    onChange: handleModeChange,
                    sx: {
                        mr: 0.5
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                            value: "Day",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "charts.mode.day",
                                defaultMessage: "Den"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                            value: "Week",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "charts.mode.week",
                                defaultMessage: "T\xfdden"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                            value: "Year",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "charts.mode.year",
                                defaultMessage: "Rok"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    sx: {
                        '& svg': {
                            fontSize: 26
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2PduQ.default), {
                        onClick: onPrev
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        mx: 0.5
                    },
                    children: formattedRange
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    sx: {
                        '& svg': {
                            fontSize: 26
                        }
                    },
                    disabled: nextDisabled,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDXfy.default), {
                        onClick: onNext
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        display: {
                            xs: !options.parent ? 'none' : 'block',
                            md: 'block'
                        },
                        ml: 'auto',
                        mt: {
                            xs: showSubStats ? 1 : 0,
                            sm: 0
                        },
                        flexBasis: {
                            xs: showSubStats ? '100%' : 'auto',
                            sm: 'auto'
                        }
                    },
                    children: chartVariantSelect
                })
            ]
        }),
        footer: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                display: {
                    xs: 'block',
                    md: 'none'
                }
            },
            children: chartVariantSelect
        })
    };
};




var $5R532 = parcelRequire("5R532");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $lIF05 = parcelRequire("lIF05");
/**
 * Cell component used to define colors and styles of chart elements.
 *
 * This component is now deprecated and will be removed in Recharts 4.0.
 *
 * Please use the `shape` prop or `content` prop on the respective chart components
 * to customize the rendering of chart elements instead of using `Cell`.
 *
 * @see {@link https://recharts.github.io/en-US/guide/cell/ Guide: Migrate from Cell component to shape prop}
 *
 * @deprecated
 * @consumes CellReader
 */ var $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea = (_props)=>null;
$b43ffe30f81b14f2$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $bJtQU = parcelRequire("bJtQU");

var $3FiDp = parcelRequire("3FiDp");

var $02Ymo = parcelRequire("02Ymo");

var $hBeJX = parcelRequire("hBeJX");

var $cpMpC = parcelRequire("cpMpC");

var $acw62 = parcelRequire("acw62");
var $56cbf170ab4710bd$var$isProduction = true;
var $56cbf170ab4710bd$var$prefix = 'Invariant failed';
function $56cbf170ab4710bd$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($56cbf170ab4710bd$var$isProduction) throw new Error($56cbf170ab4710bd$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($56cbf170ab4710bd$var$prefix, ": ").concat(provided) : $56cbf170ab4710bd$var$prefix;
    throw new Error(value);
}



var $9HjDY = parcelRequire("9HjDY");

var $63Kel = parcelRequire("63Kel");

var $3FiDp = parcelRequire("3FiDp");
var $b5efd6b8794dbdeb$var$_excluded = [
    "option"
];
function $b5efd6b8794dbdeb$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b5efd6b8794dbdeb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b5efd6b8794dbdeb$export$f94f2603511acf72 = (0, $9HjDY.Rectangle);
function $b5efd6b8794dbdeb$export$f19074a6842f9217(_ref) {
    var option = _ref.option, shapeProps = $b5efd6b8794dbdeb$var$_objectWithoutProperties(_ref, $b5efd6b8794dbdeb$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $63Kel.Shape), {
        option: option,
        DefaultShape: $b5efd6b8794dbdeb$export$f94f2603511acf72,
        shapeProps: shapeProps,
        activeClassName: "recharts-active-bar",
        inActiveClassName: "recharts-inactive-bar"
    });
}
var $b5efd6b8794dbdeb$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return (value, index)=>{
        if ((0, $3FiDp.isNumber)(minPointSize)) return minPointSize;
        var isValueNumberOrNil = (0, $3FiDp.isNumber)(value) || (0, $3FiDp.isNullish)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $56cbf170ab4710bd$export$2e2bcd8739ae039)(false, "minPointSize callback function received a value with type of ".concat(typeof value, ". Currently only numbers or null/undefined are supported."));
        return defaultValue;
    };
};



var $bqlEl = parcelRequire("bqlEl");

var $58RF9 = parcelRequire("58RF9");
var $1d6cbb89ea2b356d$export$6162f642d41f88ea = (onMouseEnterFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    return (data, index)=>(event)=>{
            onMouseEnterFromProps === null || onMouseEnterFromProps === void 0 || onMouseEnterFromProps(data, index, event);
            dispatch((0, $58RF9.setActiveMouseOverItemIndex)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};
var $1d6cbb89ea2b356d$export$27cbf444bf0be2d0 = (onMouseLeaveFromProps)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    return (data, index)=>(event)=>{
            onMouseLeaveFromProps === null || onMouseLeaveFromProps === void 0 || onMouseLeaveFromProps(data, index, event);
            dispatch((0, $58RF9.mouseLeaveItem)());
        };
};
var $1d6cbb89ea2b356d$export$c9154937ad8393fc = (onMouseClickFromProps, dataKey, graphicalItemId)=>{
    var dispatch = (0, $bqlEl.useAppDispatch)();
    return (data, index)=>(event)=>{
            onMouseClickFromProps === null || onMouseClickFromProps === void 0 || onMouseClickFromProps(data, index, event);
            dispatch((0, $58RF9.setActiveClickItemIndex)({
                activeIndex: String(index),
                activeDataKey: dataKey,
                activeCoordinate: data.tooltipPosition,
                activeGraphicalItemId: graphicalItemId
            }));
        };
};



var $2C2Dz = parcelRequire("2C2Dz");

var $kCoA9 = parcelRequire("kCoA9");

var $j0wOw = parcelRequire("j0wOw");

var $jHn5r = parcelRequire("jHn5r");

var $b0nKR = parcelRequire("b0nKR");

var $99P3O = parcelRequire("99P3O");

var $3FiDp = parcelRequire("3FiDp");

var $hBeJX = parcelRequire("hBeJX");


var $jHn5r = parcelRequire("jHn5r");

var $i2WC7 = parcelRequire("i2WC7");

var $lnFga = parcelRequire("lnFga");

var $iYis8 = parcelRequire("iYis8");

var $9fXTm = parcelRequire("9fXTm");

var $3FiDp = parcelRequire("3FiDp");
function $245a14c08b4396b4$var$_slicedToArray(r, e) {
    return $245a14c08b4396b4$var$_arrayWithHoles(r) || $245a14c08b4396b4$var$_iterableToArrayLimit(r, e) || $245a14c08b4396b4$var$_unsupportedIterableToArray(r, e) || $245a14c08b4396b4$var$_nonIterableRest();
}
function $245a14c08b4396b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $245a14c08b4396b4$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $245a14c08b4396b4$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $245a14c08b4396b4$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $245a14c08b4396b4$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $245a14c08b4396b4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $245a14c08b4396b4$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $245a14c08b4396b4$var$getBarSize = (globalSize, totalSize, selfSize)=>{
    var barSize = selfSize !== null && selfSize !== void 0 ? selfSize : globalSize;
    if ((0, $3FiDp.isNullish)(barSize)) return undefined;
    return (0, $3FiDp.getPercentValue)(barSize, totalSize, 0);
};
var $245a14c08b4396b4$export$fa5aca2cbc42e692 = (allBars, globalSize, totalSize)=>{
    var initialValue = {};
    var stackedBars = allBars.filter((0, $9fXTm.isStacked));
    var unstackedBars = allBars.filter((b)=>b.stackId == null);
    var groupByStack = stackedBars.reduce((acc, bar)=>{
        var s = acc[bar.stackId];
        if (s == null) s = [];
        s.push(bar);
        acc[bar.stackId] = s;
        return acc;
    }, initialValue);
    var stackedSizeList = Object.entries(groupByStack).map((_ref)=>{
        var _bars$;
        var _ref2 = $245a14c08b4396b4$var$_slicedToArray(_ref, 2), stackId = _ref2[0], bars = _ref2[1];
        var dataKeys = bars.map((b)=>b.dataKey);
        var barSize = $245a14c08b4396b4$var$getBarSize(globalSize, totalSize, (_bars$ = bars[0]) === null || _bars$ === void 0 ? void 0 : _bars$.barSize);
        return {
            stackId: stackId,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    var unstackedSizeList = unstackedBars.map((b)=>{
        var dataKeys = [
            b.dataKey
        ].filter((dk)=>dk != null);
        var barSize = $245a14c08b4396b4$var$getBarSize(globalSize, totalSize, b.barSize);
        return {
            stackId: undefined,
            dataKeys: dataKeys,
            barSize: barSize
        };
    });
    return [
        ...stackedSizeList,
        ...unstackedSizeList
    ];
};



var $3FiDp = parcelRequire("3FiDp");

var $iMnqX = parcelRequire("iMnqX");
function $2a7e66941f072ae1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a7e66941f072ae1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a7e66941f072ae1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a7e66941f072ae1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a7e66941f072ae1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a7e66941f072ae1$var$_defineProperty(e, r, t) {
    return (r = $2a7e66941f072ae1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $2a7e66941f072ae1$var$_toPropertyKey(t) {
    var i = $2a7e66941f072ae1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $2a7e66941f072ae1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $2a7e66941f072ae1$var$getBarPositions(barGap, barCategoryGap, bandSize, sizeList, maxBarSize) {
    var _sizeList$;
    var len = sizeList.length;
    if (len < 1) return undefined;
    var realBarGap = (0, $3FiDp.getPercentValue)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether is barSize set by user
    // Okay but why does it check only for the first element? What if the first element is set but others are not?
    if ((0, $iMnqX.isWellBehavedNumber)((_sizeList$ = sizeList[0]) === null || _sizeList$ === void 0 ? void 0 : _sizeList$.barSize)) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce((res, entry)=>res + (entry.barSize || 0), 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = Math.round((bandSize - sum) / 2);
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce((res, entry)=>{
            var _entry$barSize;
            var newPosition = {
                stackId: entry.stackId,
                dataKeys: entry.dataKeys,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    size: useFull ? fullBarSize : (_entry$barSize = entry.barSize) !== null && _entry$barSize !== void 0 ? _entry$barSize : 0
                }
            };
            var newRes = [
                ...res,
                newPosition
            ];
            prev = newPosition.position;
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $3FiDp.getPercentValue)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize = Math.round(originalSize);
        var size = (0, $iMnqX.isWellBehavedNumber)(maxBarSize) ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce((res, entry, i)=>[
                ...res,
                {
                    stackId: entry.stackId,
                    dataKeys: entry.dataKeys,
                    position: {
                        offset: _offset + len * (originalSize - size) / 2 + (size + realBarGap) * i,
                        size: size
                    }
                }
            ], initialValue);
    }
    return result;
}
var $2a7e66941f072ae1$export$5068ec6da13c95bb = (sizeList, globalMaxBarSize, barGap, barCategoryGap, barBandSize, bandSize, childMaxBarSize)=>{
    var maxBarSize = (0, $3FiDp.isNullish)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var allBarPositions = $2a7e66941f072ae1$var$getBarPositions(barGap, barCategoryGap, barBandSize !== bandSize ? barBandSize : bandSize, sizeList, maxBarSize);
    if (barBandSize !== bandSize && allBarPositions != null) allBarPositions = allBarPositions.map((pos)=>$2a7e66941f072ae1$var$_objectSpread($2a7e66941f072ae1$var$_objectSpread({}, pos), {}, {
            position: $2a7e66941f072ae1$var$_objectSpread($2a7e66941f072ae1$var$_objectSpread({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
            })
        }));
    return allBarPositions;
};



var $hcIzl = parcelRequire("hcIzl");
var $ed174a0e62d48311$export$66625d959aa66f0f = (stackGroups, barSettings)=>{
    var stackSeriesIdentifier = (0, $hcIzl.getStackSeriesIdentifier)(barSettings);
    if (!stackGroups || stackSeriesIdentifier == null || barSettings == null) return undefined;
    var stackId = barSettings.stackId;
    if (stackId == null) return undefined;
    var stackGroup = stackGroups[stackId];
    if (!stackGroup) return undefined;
    var stackedData = stackGroup.stackedData;
    if (!stackedData) return undefined;
    return stackedData.find((sd)=>sd.key === stackSeriesIdentifier);
};



var $214LY = parcelRequire("214LY");
function $07dce3cd67839b77$export$eea16fee3026d9cf(state, id) {
    var _state$graphicalItems, _state$graphicalItems2;
    return (_state$graphicalItems = (_state$graphicalItems2 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems2 === void 0 ? void 0 : _state$graphicalItems2.xAxisId) !== null && _state$graphicalItems !== void 0 ? _state$graphicalItems : (0, $214LY.defaultAxisId);
}
function $07dce3cd67839b77$export$5babc813f7c13fff(state, id) {
    var _state$graphicalItems3, _state$graphicalItems4;
    return (_state$graphicalItems3 = (_state$graphicalItems4 = state.graphicalItems.cartesianItems.find((item)=>item.id === id)) === null || _state$graphicalItems4 === void 0 ? void 0 : _state$graphicalItems4.yAxisId) !== null && _state$graphicalItems3 !== void 0 ? _state$graphicalItems3 : (0, $214LY.defaultAxisId);
}


var $fe72261e429a4d95$export$77fea8543499527d = (allBarPositions, barSettings)=>{
    if (allBarPositions == null || barSettings == null) return undefined;
    var position = allBarPositions.find((p)=>p.stackId === barSettings.stackId && barSettings.dataKey != null && p.dataKeys.includes(barSettings.dataKey));
    if (position == null) return undefined;
    return position.position;
};


var $768c0ec0ed64a741$var$pickIsPanorama = (_state, _id, isPanorama)=>isPanorama;
var $768c0ec0ed64a741$var$pickBarId = (_state, id)=>id;
var $768c0ec0ed64a741$var$selectSynchronisedBarSettings = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectUnfilteredCartesianItems),
    $768c0ec0ed64a741$var$pickBarId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'bar').find((item)=>item.id === id));
var $768c0ec0ed64a741$export$50baca3091205310 = (0, $b0nKR.createSelector)([
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (barSettings)=>barSettings === null || barSettings === void 0 ? void 0 : barSettings.maxBarSize);
var $768c0ec0ed64a741$var$pickCells = (_state, _id, _isPanorama, cells)=>cells;
var $768c0ec0ed64a741$export$bf2e7c2f01f3feee = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    (0, $99P3O.selectUnfilteredCartesianItems),
    (0, $07dce3cd67839b77$export$eea16fee3026d9cf),
    (0, $07dce3cd67839b77$export$5babc813f7c13fff),
    $768c0ec0ed64a741$var$pickIsPanorama
], (layout, allItems, xAxisId, yAxisId, isPanorama)=>allItems.filter((i)=>{
        if (layout === 'horizontal') return i.xAxisId === xAxisId;
        return i.yAxisId === yAxisId;
    }).filter((i)=>i.isPanorama === isPanorama).filter((i)=>i.hide === false).filter((i)=>i.type === 'bar'));
var $768c0ec0ed64a741$var$selectBarStackGroups = (state, id, isPanorama)=>{
    var layout = (0, $jHn5r.selectChartLayout)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $99P3O.selectStackGroups)(state, 'yAxis', yAxisId, isPanorama);
    return (0, $99P3O.selectStackGroups)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$export$d463f1583eab6c4c = (state, id)=>{
    var layout = (0, $jHn5r.selectChartLayout)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    if (layout === 'horizontal') return (0, $99P3O.selectCartesianAxisSize)(state, 'xAxis', xAxisId);
    return (0, $99P3O.selectCartesianAxisSize)(state, 'yAxis', yAxisId);
};
var $768c0ec0ed64a741$export$2ef868bbad239fe0 = (0, $b0nKR.createSelector)([
    $768c0ec0ed64a741$export$bf2e7c2f01f3feee,
    (0, $iYis8.selectRootBarSize),
    $768c0ec0ed64a741$export$d463f1583eab6c4c
], (0, $245a14c08b4396b4$export$fa5aca2cbc42e692));
var $768c0ec0ed64a741$export$32ce49801f050c73 = (state, id, isPanorama)=>{
    var _ref, _getBandSizeOfAxis;
    var barSettings = $768c0ec0ed64a741$var$selectSynchronisedBarSettings(state, id);
    if (barSettings == null) return 0;
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return 0;
    var layout = (0, $jHn5r.selectChartLayout)(state);
    var globalMaxBarSize = (0, $iYis8.selectRootMaxBarSize)(state);
    var childMaxBarSize = barSettings.maxBarSize;
    var maxBarSize = (0, $3FiDp.isNullish)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $99P3O.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $99P3O.selectTicksOfGraphicalItem)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $99P3O.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $99P3O.selectTicksOfGraphicalItem)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (_ref = (_getBandSizeOfAxis = (0, $hBeJX.getBandSizeOfAxis)(axis, ticks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref !== void 0 ? _ref : 0;
};
var $768c0ec0ed64a741$export$bc27c715442861c7 = (state, id, isPanorama)=>{
    var layout = (0, $jHn5r.selectChartLayout)(state);
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (xAxisId == null || yAxisId == null) return undefined;
    var axis, ticks;
    if (layout === 'horizontal') {
        axis = (0, $99P3O.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama);
        ticks = (0, $99P3O.selectTicksOfGraphicalItem)(state, 'xAxis', xAxisId, isPanorama);
    } else {
        axis = (0, $99P3O.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama);
        ticks = (0, $99P3O.selectTicksOfGraphicalItem)(state, 'yAxis', yAxisId, isPanorama);
    }
    return (0, $hBeJX.getBandSizeOfAxis)(axis, ticks);
};
var $768c0ec0ed64a741$export$d5f086f9524dc338 = (0, $b0nKR.createSelector)([
    $768c0ec0ed64a741$export$2ef868bbad239fe0,
    (0, $iYis8.selectRootMaxBarSize),
    (0, $iYis8.selectBarGap),
    (0, $iYis8.selectBarCategoryGap),
    $768c0ec0ed64a741$export$32ce49801f050c73,
    $768c0ec0ed64a741$export$bc27c715442861c7,
    $768c0ec0ed64a741$export$50baca3091205310
], (0, $2a7e66941f072ae1$export$5068ec6da13c95bb));
var $768c0ec0ed64a741$var$selectXAxisWithScale = (state, id, isPanorama)=>{
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $99P3O.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectYAxisWithScale = (state, id, isPanorama)=>{
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $99P3O.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectXAxisTicks = (state, id, isPanorama)=>{
    var xAxisId = (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, id);
    if (xAxisId == null) return undefined;
    return (0, $99P3O.selectTicksOfGraphicalItem)(state, 'xAxis', xAxisId, isPanorama);
};
var $768c0ec0ed64a741$var$selectYAxisTicks = (state, id, isPanorama)=>{
    var yAxisId = (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, id);
    if (yAxisId == null) return undefined;
    return (0, $99P3O.selectTicksOfGraphicalItem)(state, 'yAxis', yAxisId, isPanorama);
};
var $768c0ec0ed64a741$export$713ac88b203ac3be = (0, $b0nKR.createSelector)([
    $768c0ec0ed64a741$export$d5f086f9524dc338,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (0, $fe72261e429a4d95$export$77fea8543499527d));
var $768c0ec0ed64a741$export$bb6e63f631e695ca = (0, $b0nKR.createSelector)([
    $768c0ec0ed64a741$var$selectBarStackGroups,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings
], (0, $ed174a0e62d48311$export$66625d959aa66f0f));
var $768c0ec0ed64a741$export$bb89ca2d15dbced9 = (0, $b0nKR.createSelector)([
    (0, $lnFga.selectChartOffsetInternal),
    (0, $lnFga.selectAxisViewBox),
    $768c0ec0ed64a741$var$selectXAxisWithScale,
    $768c0ec0ed64a741$var$selectYAxisWithScale,
    $768c0ec0ed64a741$var$selectXAxisTicks,
    $768c0ec0ed64a741$var$selectYAxisTicks,
    $768c0ec0ed64a741$export$713ac88b203ac3be,
    (0, $jHn5r.selectChartLayout),
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition3),
    $768c0ec0ed64a741$export$bc27c715442861c7,
    $768c0ec0ed64a741$export$bb6e63f631e695ca,
    $768c0ec0ed64a741$var$selectSynchronisedBarSettings,
    $768c0ec0ed64a741$var$pickCells
], (offset, axisViewBox, xAxis, yAxis, xAxisTicks, yAxisTicks, pos, layout, _ref2, bandSize, stackedData, barSettings, cells)=>{
    var chartData = _ref2.chartData, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    if (barSettings == null || pos == null || axisViewBox == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || bandSize == null) return undefined;
    var data = barSettings.data;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $e752e700473a8894$export$3b2ba7a38b022e)({
        layout: layout,
        barSettings: barSettings,
        pos: pos,
        parentViewBox: axisViewBox,
        bandSize: bandSize,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        stackedData: stackedData,
        displayedData: displayedData,
        offset: offset,
        cells: cells,
        dataStartIndex: dataStartIndex
    });
});



var $bqlEl = parcelRequire("bqlEl");

var $3X9hg = parcelRequire("3X9hg");

var $71i43 = parcelRequire("71i43");

var $ckb0X = parcelRequire("ckb0X");

var $cd9rh = parcelRequire("cd9rh");

var $jhZFb = parcelRequire("jhZFb");

var $aPPc1 = parcelRequire("aPPc1");

var $4M6vj = parcelRequire("4M6vj");

var $eHwNv = parcelRequire("eHwNv");

var $dujP6 = parcelRequire("dujP6");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $iMnqX = parcelRequire("iMnqX");
function $20d9e46a95ab88fd$export$384f306fbc0d3ce9(input, defaultZIndex) {
    if (input && typeof input === 'object' && 'zIndex' in input && typeof input.zIndex === 'number' && (0, $iMnqX.isWellBehavedNumber)(input.zIndex)) return input.zIndex;
    return defaultZIndex;
}



var $biEKl = parcelRequire("biEKl");

var $acw62 = parcelRequire("acw62");

var $hBeJX = parcelRequire("hBeJX");

var $66VW2 = parcelRequire("66VW2");

var $cd9rh = parcelRequire("cd9rh");

var $bqlEl = parcelRequire("bqlEl");

var $b0nKR = parcelRequire("b0nKR");

var $99P3O = parcelRequire("99P3O");

var $7f648dde7f9e015e$var$pickStackId = (state, stackId)=>stackId;
var $7f648dde7f9e015e$var$pickIsPanorama = (state, stackId, isPanorama)=>isPanorama;
var $7f648dde7f9e015e$export$7f05d1a8fbacd727 = (0, $b0nKR.createSelector)([
    $7f648dde7f9e015e$var$pickStackId,
    (0, $99P3O.selectUnfilteredCartesianItems),
    $7f648dde7f9e015e$var$pickIsPanorama
], (stackId, allItems, isPanorama)=>{
    return allItems.filter((i)=>i.type === 'bar').filter((i)=>i.stackId === stackId).filter((i)=>i.isPanorama === isPanorama).filter((i)=>!i.hide);
});
var $7f648dde7f9e015e$var$selectAllBarIdsInStack = (0, $b0nKR.createSelector)([
    $7f648dde7f9e015e$export$7f05d1a8fbacd727
], (allBars)=>{
    return allBars.map((bar)=>bar.id);
});
var $7f648dde7f9e015e$export$54063602295685e1 = (rect1, rect2)=>{
    if (!rect1) return rect2;
    if (!rect2) return rect1;
    var x = Math.min(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var y = Math.min(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var maxX = Math.max(rect1.x, rect1.x + rect1.width, rect2.x, rect2.x + rect2.width);
    var maxY = Math.max(rect1.y, rect1.y + rect1.height, rect2.y, rect2.y + rect2.height);
    var width = maxX - x;
    var height = maxY - y;
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
};
var $7f648dde7f9e015e$var$combineStackRects = (state, stackId, isPanorama)=>{
    var allBarIds = $7f648dde7f9e015e$var$selectAllBarIdsInStack(state, stackId, isPanorama);
    var stackRects = [];
    allBarIds.forEach((barId)=>{
        var rectangles = (0, $768c0ec0ed64a741$export$bb89ca2d15dbced9)(state, barId, isPanorama, undefined);
        rectangles === null || rectangles === void 0 || rectangles.forEach((rect)=>{
            var rectIndex = rect.originalDataIndex;
            stackRects[rectIndex] = $7f648dde7f9e015e$export$54063602295685e1(stackRects[rectIndex], rect);
        });
    });
    return stackRects;
};
var $7f648dde7f9e015e$export$7518e012f9c78033 = (0, $b0nKR.createSelector)([
    (state)=>state,
    $7f648dde7f9e015e$var$pickStackId,
    $7f648dde7f9e015e$var$pickIsPanorama
], $7f648dde7f9e015e$var$combineStackRects);



var $3X9hg = parcelRequire("3X9hg");

var $lIF05 = parcelRequire("lIF05");

var $9HjDY = parcelRequire("9HjDY");

var $biEKl = parcelRequire("biEKl");
var $b8a2be1f3c4055dc$var$_excluded = [
    "index"
];
function $b8a2be1f3c4055dc$var$_extends() {
    return $b8a2be1f3c4055dc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8a2be1f3c4055dc$var$_extends.apply(null, arguments);
}
function $b8a2be1f3c4055dc$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b8a2be1f3c4055dc$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b8a2be1f3c4055dc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b8a2be1f3c4055dc$var$BarStackContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
var $b8a2be1f3c4055dc$export$837efb24f50d011e = (childStackId)=>{
    var stackSettings = (0, $acw62.useContext)($b8a2be1f3c4055dc$var$BarStackContext);
    if (stackSettings != null) return stackSettings.stackId;
    if (childStackId == null) return undefined;
    return (0, $hBeJX.getNormalizedStackId)(childStackId);
};
var $b8a2be1f3c4055dc$export$49f633eb2d560a47 = {
    radius: 0
};
var $b8a2be1f3c4055dc$var$getClipPathId = (stackId, index)=>{
    return "recharts-bar-stack-clip-path-".concat(stackId, "-").concat(index);
};
var $b8a2be1f3c4055dc$export$7c5499b8b81f5acf = (index)=>{
    var barStackContext = (0, $acw62.useContext)($b8a2be1f3c4055dc$var$BarStackContext);
    if (barStackContext == null) return undefined;
    var stackId = barStackContext.stackId;
    return "url(#".concat($b8a2be1f3c4055dc$var$getClipPathId(stackId, index), ")");
};
var $b8a2be1f3c4055dc$export$6374d9b2eea9076f = (_ref)=>{
    var index = _ref.index, rest = $b8a2be1f3c4055dc$var$_objectWithoutProperties(_ref, $b8a2be1f3c4055dc$var$_excluded);
    var clipPathUrl = $b8a2be1f3c4055dc$export$7c5499b8b81f5acf(index);
    return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), $b8a2be1f3c4055dc$var$_extends({
        className: "recharts-bar-stack-layer",
        clipPath: clipPathUrl
    }, rest));
};
/**
 * This React component will render a clipPath that the individual bars in the stack will reference
 * to achieve rounded corners for the entire stack.
 */ var $b8a2be1f3c4055dc$var$BarStackClipPath = (_ref2)=>{
    var stackId = _ref2.stackId, radius = _ref2.radius;
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var positions = (0, $bqlEl.useAppSelector)((state)=>(0, $7f648dde7f9e015e$export$7518e012f9c78033)(state, stackId, isPanorama));
    if (positions == null || positions.length === 0) return null;
    /*
   * Render one clipPath per rectangle in the stack.
   * Each rectangle corresponds to one data entry in the chart.
   */ return /*#__PURE__*/ $acw62.createElement("defs", null, positions.map((pos, index)=>{
        if (pos == null) return null;
        var clipPathId = $b8a2be1f3c4055dc$var$getClipPathId(stackId, index);
        return /*#__PURE__*/ $acw62.createElement("clipPath", {
            key: clipPathId,
            id: clipPathId
        }, /*#__PURE__*/ $acw62.createElement((0, $9HjDY.Rectangle), {
            isAnimationActive: false,
            isUpdateAnimationActive: false,
            x: pos.x,
            y: pos.y,
            width: pos.width,
            height: pos.height,
            radius: radius
        }));
    }));
};
var $b8a2be1f3c4055dc$var$BarStackImpl = (props)=>{
    var resolvedStackId = (0, $66VW2.useUniqueId)('recharts-bar-stack', (0, $hBeJX.getNormalizedStackId)(props.stackId));
    var _resolveDefaultProps = (0, $cd9rh.resolveDefaultProps)(props, $b8a2be1f3c4055dc$export$49f633eb2d560a47), children = _resolveDefaultProps.children, radius = _resolveDefaultProps.radius;
    var context = (0, $acw62.useMemo)(()=>({
            stackId: resolvedStackId,
            radius: radius
        }), [
        resolvedStackId,
        radius
    ]);
    return /*#__PURE__*/ $acw62.createElement($b8a2be1f3c4055dc$var$BarStackContext.Provider, {
        value: context
    }, /*#__PURE__*/ $acw62.createElement($b8a2be1f3c4055dc$var$BarStackClipPath, {
        stackId: resolvedStackId,
        radius: radius
    }), children);
};
var $b8a2be1f3c4055dc$export$ebd6167c687e5b8b = /*#__PURE__*/ $acw62.memo($b8a2be1f3c4055dc$var$BarStackImpl, (0, $biEKl.propsAreEqual));


var $e752e700473a8894$var$_excluded = [
    "onMouseEnter",
    "onMouseLeave",
    "onClick"
], $e752e700473a8894$var$_excluded2 = [
    "value",
    "background",
    "tooltipPosition"
], $e752e700473a8894$var$_excluded3 = [
    "id"
], $e752e700473a8894$var$_excluded4 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
];
function $e752e700473a8894$var$_slicedToArray(r, e) {
    return $e752e700473a8894$var$_arrayWithHoles(r) || $e752e700473a8894$var$_iterableToArrayLimit(r, e) || $e752e700473a8894$var$_unsupportedIterableToArray(r, e) || $e752e700473a8894$var$_nonIterableRest();
}
function $e752e700473a8894$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e752e700473a8894$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e752e700473a8894$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e752e700473a8894$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e752e700473a8894$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $e752e700473a8894$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e752e700473a8894$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $e752e700473a8894$var$_extends() {
    return $e752e700473a8894$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e752e700473a8894$var$_extends.apply(null, arguments);
}
function $e752e700473a8894$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e752e700473a8894$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e752e700473a8894$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e752e700473a8894$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e752e700473a8894$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e752e700473a8894$var$_defineProperty(e, r, t) {
    return (r = $e752e700473a8894$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $e752e700473a8894$var$_toPropertyKey(t) {
    var i = $e752e700473a8894$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $e752e700473a8894$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e752e700473a8894$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e752e700473a8894$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e752e700473a8894$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e752e700473a8894$var$computeLegendPayloadFromBarData = (props)=>{
    var dataKey = props.dataKey, name = props.name, fill = props.fill, legendType = props.legendType, hide = props.hide;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: fill,
            value: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            payload: props
        }
    ];
};
var $e752e700473a8894$var$SetBarTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var dataKey = _ref.dataKey, stroke = _ref.stroke, strokeWidth = _ref.strokeWidth, fill = _ref.fill, name = _ref.name, hide = _ref.hide, unit = _ref.unit, formatter = _ref.formatter, tooltipType = _ref.tooltipType, id = _ref.id;
    var tooltipEntrySettings = {
        dataDefinedOnItem: undefined,
        getPosition: (0, $3FiDp.noop),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: unit,
            formatter: formatter,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $2C2Dz.SetTooltipEntrySettings), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $e752e700473a8894$var$BarBackground(props) {
    var activeIndex = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipIndex));
    var data = props.data, dataKey = props.dataKey, backgroundFromProps = props.background, allOtherBarProps = props.allOtherBarProps;
    var onMouseEnterFromProps = allOtherBarProps.onMouseEnter, onMouseLeaveFromProps = allOtherBarProps.onMouseLeave, onItemClickFromProps = allOtherBarProps.onClick, restOfAllOtherProps = $e752e700473a8894$var$_objectWithoutProperties(allOtherBarProps, $e752e700473a8894$var$_excluded);
    var onMouseEnterFromContext = (0, $1d6cbb89ea2b356d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, allOtherBarProps.id);
    var onMouseLeaveFromContext = (0, $1d6cbb89ea2b356d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $1d6cbb89ea2b356d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, allOtherBarProps.id);
    if (!backgroundFromProps || data == null) return null;
    var backgroundProps = (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(backgroundFromProps);
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: (0, $20d9e46a95ab88fd$export$384f306fbc0d3ce9)(backgroundFromProps, (0, $gKNgz.DefaultZIndexes).barBackground)
    }, data.map((entry, i)=>{
        var value = entry.value, backgroundFromDataEntry = entry.background, tooltipPosition = entry.tooltipPosition, rest = $e752e700473a8894$var$_objectWithoutProperties(entry, $e752e700473a8894$var$_excluded2);
        if (!backgroundFromDataEntry) return null;
        var onMouseEnter = onMouseEnterFromContext(entry, entry.originalDataIndex);
        var onMouseLeave = onMouseLeaveFromContext(entry, entry.originalDataIndex);
        var onClick = onClickFromContext(entry, entry.originalDataIndex);
        var barRectangleProps = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({
            option: backgroundFromProps,
            isActive: String(entry.originalDataIndex) === activeIndex
        }, rest), {}, {
            // @ts-expect-error backgroundProps is contributing unknown props
            fill: '#eee'
        }, backgroundFromDataEntry), backgroundProps), (0, $cpMpC.adaptEventsOfChild)(restOfAllOtherProps, entry, i)), {}, {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            dataKey: dataKey,
            index: i,
            className: 'recharts-bar-background-rectangle'
        });
        return /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({
            key: "background-bar-".concat(i)
        }, barRectangleProps));
    }));
}
function $e752e700473a8894$var$BarLabelListProvider(_ref2) {
    var showLabels = _ref2.showLabels, children = _ref2.children, rects = _ref2.rects;
    var labelListEntries = rects === null || rects === void 0 ? void 0 : rects.map((entry)=>{
        var viewBox = {
            x: entry.x,
            y: entry.y,
            width: entry.width,
            lowerWidth: entry.width,
            upperWidth: entry.width,
            height: entry.height
        };
        return $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, viewBox), {}, {
            value: entry.value,
            payload: entry.payload,
            parentViewBox: entry.parentViewBox,
            viewBox: viewBox,
            fill: entry.fill
        });
    });
    return /*#__PURE__*/ $acw62.createElement((0, $bJtQU.CartesianLabelListContextProvider), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $e752e700473a8894$var$BarRectangleWithActiveState(props) {
    var shape = props.shape, activeBar = props.activeBar, baseProps = props.baseProps, entry = props.entry, index = props.index, dataKey = props.dataKey;
    var activeIndex = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipIndex));
    var activeDataKey = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipDataKey));
    /*
   * Bars support stacking, meaning that there can be multiple bars at the same x value.
   * With Tooltip shared=false we only want to highlight the currently active Bar, not all.
   *
   * Also, if the tooltip is shared, we want to highlight all bars at the same x value
   * regardless of the dataKey.
   *
   * With shared Tooltip, the activeDataKey is undefined.
   *
   * We use entry.originalDataIndex to match against activeIndex because the render index parameter
   * is based on the filtered array, while activeIndex is based on the pre-filter displayed data slice.
   * When entries are filtered out (for example null/zero-dimension bars), these indices can differ.
   */ var isActive = activeBar && String(entry.originalDataIndex) === activeIndex && (activeDataKey == null || dataKey === activeDataKey);
    var isAnotherBarActive = activeIndex != null && (String(entry.originalDataIndex) !== activeIndex || activeDataKey != null && dataKey !== activeDataKey);
    var _useState = (0, $acw62.useState)(false), _useState2 = $e752e700473a8894$var$_slicedToArray(_useState, 2), stayInLayer = _useState2[0], setStayInLayer = _useState2[1];
    var _useState3 = (0, $acw62.useState)(false), _useState4 = $e752e700473a8894$var$_slicedToArray(_useState3, 2), hasMountedActive = _useState4[0], setHasMountedActive = _useState4[1];
    (0, $acw62.useEffect)(()=>{
        var rafId;
        if (isActive) {
            // 1. Enter the layer immediately
            setStayInLayer(true);
            // 2. Wait for the browser to paint the "inactive" state in the new layer,
            // then switch to active to trigger the CSS transition (width grow).
            rafId = requestAnimationFrame(()=>{
                setHasMountedActive(true);
            });
        } else {
            setHasMountedActive(false);
            if (isAnotherBarActive) setStayInLayer(false);
        }
        return ()=>{
            cancelAnimationFrame(rafId);
        };
    }, [
        isActive,
        isAnotherBarActive
    ]);
    var handleTransitionEnd = (0, $acw62.useCallback)(()=>{
        // 4. Leave the layer only when the exit transition finishes
        if (!isActive) setStayInLayer(false);
    }, [
        isActive
    ]);
    // Determine props:
    // - If entering (isActive=true) but not mounted yet (hasMountedActive=false), pass isActive=false (inactive size).
    // - If exiting (isActive=false), pass isActive=false (inactive size).
    var isVisuallyActive = isActive && hasMountedActive;
    // Render in ZIndexLayer if active OR if we are waiting for exit transition
    var shouldRenderInLayer = isActive || stayInLayer;
    var option;
    if (isActive) {
        if (activeBar === true) option = shape;
        else option = activeBar;
    } else option = shape;
    var content = /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: isVisuallyActive,
        option: option,
        index: index,
        dataKey: dataKey,
        animationElapsedTime: props.animationElapsedTime,
        isAnimating: props.isAnimating,
        isEntrance: props.isEntrance,
        onTransitionEnd: handleTransitionEnd
    }));
    if (shouldRenderInLayer) return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: (0, $gKNgz.DefaultZIndexes).activeBar
    }, /*#__PURE__*/ $acw62.createElement((0, $b8a2be1f3c4055dc$export$6374d9b2eea9076f), {
        index: entry.originalDataIndex
    }, content));
    return content;
}
function $e752e700473a8894$var$BarRectangleNeverActive(props) {
    var shape = props.shape, baseProps = props.baseProps, entry = props.entry, index = props.index, dataKey = props.dataKey;
    return /*#__PURE__*/ $acw62.createElement((0, $b5efd6b8794dbdeb$export$f19074a6842f9217), $e752e700473a8894$var$_extends({}, baseProps, {
        name: String(baseProps.name)
    }, entry, {
        isActive: false,
        option: shape,
        index: index,
        dataKey: dataKey,
        animationElapsedTime: props.animationElapsedTime,
        isAnimating: props.isAnimating,
        isEntrance: props.isEntrance
    }));
}
function $e752e700473a8894$var$BarRectangles(_ref3) {
    var _svgPropertiesNoEvent;
    var data = _ref3.data, props = _ref3.props, animationElapsedTime = _ref3.animationElapsedTime, isAnimating = _ref3.isAnimating, isEntrance = _ref3.isEntrance;
    var _ref4 = (_svgPropertiesNoEvent = (0, $4M6vj.svgPropertiesNoEvents)(props)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, id = _ref4.id, baseProps = $e752e700473a8894$var$_objectWithoutProperties(_ref4, $e752e700473a8894$var$_excluded3);
    var shape = props.shape, dataKey = props.dataKey, activeBar = props.activeBar;
    var onMouseEnterFromProps = props.onMouseEnter, onItemClickFromProps = props.onClick, onMouseLeaveFromProps = props.onMouseLeave, restOfAllOtherProps = $e752e700473a8894$var$_objectWithoutProperties(props, $e752e700473a8894$var$_excluded4);
    var onMouseEnterFromContext = (0, $1d6cbb89ea2b356d$export$6162f642d41f88ea)(onMouseEnterFromProps, dataKey, id);
    var onMouseLeaveFromContext = (0, $1d6cbb89ea2b356d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $1d6cbb89ea2b356d$export$c9154937ad8393fc)(onItemClickFromProps, dataKey, id);
    if (!data) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, data.map((entry, i)=>{
        return /*#__PURE__*/ $acw62.createElement((0, $b8a2be1f3c4055dc$export$6374d9b2eea9076f), $e752e700473a8894$var$_extends({
            index: entry.originalDataIndex,
            key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i),
            className: "recharts-bar-rectangle"
        }, (0, $cpMpC.adaptEventsOfChild)(restOfAllOtherProps, entry, i), {
            onMouseEnter: onMouseEnterFromContext(entry, entry.originalDataIndex),
            onMouseLeave: onMouseLeaveFromContext(entry, entry.originalDataIndex),
            onClick: onClickFromContext(entry, entry.originalDataIndex)
        }), activeBar ? /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarRectangleWithActiveState, {
            shape: shape,
            activeBar: activeBar,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating,
            isEntrance: isEntrance
        }) : /*#__PURE__*/ /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */ $acw62.createElement($e752e700473a8894$var$BarRectangleNeverActive, {
            shape: shape,
            baseProps: baseProps,
            entry: entry,
            index: i,
            dataKey: dataKey,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating,
            isEntrance: isEntrance
        }));
    }));
}
var $e752e700473a8894$var$defaultBarAnimateItems = (items, animationElapsedTime, layout)=>{
    if (items == null) return [];
    if (animationElapsedTime === 1) return items.flatMap((item)=>item.status === 'removed' ? [] : [
            item.next
        ]);
    return items.flatMap((item)=>{
        if (item.status === 'removed') {
            // animate removed items to 0 height/width respective of layout
            if (layout === 'horizontal') return [
                $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, item.prev), {}, {
                    height: (0, $3FiDp.interpolate)(item.prev.height, 0, animationElapsedTime),
                    y: (0, $3FiDp.interpolate)(item.prev.y, item.prev.y + item.prev.height, animationElapsedTime)
                })
            ];
            return [
                $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, item.prev), {}, {
                    width: (0, $3FiDp.interpolate)(item.prev.width, 0, animationElapsedTime)
                })
            ];
        }
        if (item.status === 'matched') return [
            $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, item.next), {}, {
                x: (0, $3FiDp.interpolate)(item.prev.x, item.next.x, animationElapsedTime),
                y: (0, $3FiDp.interpolate)(item.prev.y, item.next.y, animationElapsedTime),
                width: (0, $3FiDp.interpolate)(item.prev.width, item.next.width, animationElapsedTime),
                height: (0, $3FiDp.interpolate)(item.prev.height, item.next.height, animationElapsedTime)
            })
        ];
        // added
        var next = item.next;
        if (layout === 'horizontal') return [
            $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, next), {}, {
                height: (0, $3FiDp.interpolate)(0, next.height, animationElapsedTime),
                y: (0, $3FiDp.interpolate)(next.stackedBarStart, next.y, animationElapsedTime)
            })
        ];
        return [
            $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, next), {}, {
                width: (0, $3FiDp.interpolate)(0, next.width, animationElapsedTime),
                x: (0, $3FiDp.interpolate)(next.stackedBarStart, next.x, animationElapsedTime)
            })
        ];
    });
};
function $e752e700473a8894$var$RectanglesWithAnimation(_ref5) {
    var props = _ref5.props, previousRectanglesRef = _ref5.previousRectanglesRef;
    var data = props.data, isAnimationActive = props.isAnimationActive, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, animationInterpolateFn = props.animationInterpolateFn, layout = props.layout;
    var _useAnimationCallback = (0, $eHwNv.useAnimationCallbacks)(props.onAnimationStart, props.onAnimationEnd), isAnimating = _useAnimationCallback.isAnimating, handleAnimationStart = _useAnimationCallback.handleAnimationStart, handleAnimationEnd = _useAnimationCallback.handleAnimationEnd;
    return /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarLabelListProvider, {
        showLabels: !isAnimating,
        rects: data
    }, /*#__PURE__*/ $acw62.createElement((0, $eHwNv.AnimatedItems), {
        animationInput: data,
        animationIdPrefix: "recharts-bar-",
        items: data,
        previousItemsRef: previousRectanglesRef,
        isAnimationActive: isAnimationActive,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        animationInterpolateFn: animationInterpolateFn,
        animationMatchBy: props.animationMatchBy,
        layout: layout
    }, (stepData, animationElapsedTime, isEntrance)=>/*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), null, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarRectangles, {
            props: props,
            data: stepData,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating || animationElapsedTime < 1,
            isEntrance: isEntrance
        }))), /*#__PURE__*/ $acw62.createElement((0, $bJtQU.LabelListFromLabelProp), {
        label: props.label
    }), props.children);
}
function $e752e700473a8894$var$RenderRectangles(props) {
    var previousRectanglesRef = (0, $acw62.useRef)(null);
    return /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$RectanglesWithAnimation, {
        previousRectanglesRef: previousRectanglesRef,
        props: props
    });
}
var $e752e700473a8894$var$defaultMinPointSize = 0;
var $e752e700473a8894$var$errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    /**
   * if the value coming from `selectBarRectangles` is an array then this is a stacked bar chart.
   * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
   * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
    return {
        x: dataPoint.x,
        y: dataPoint.y,
        value: value,
        // getValueByDataKey does not validate the output type
        errorVal: (0, $hBeJX.getValueByDataKey)(dataPoint, dataKey)
    };
};
class $e752e700473a8894$var$BarWithState extends (0, $acw62.PureComponent) {
    render() {
        var _this$props = this.props, hide = _this$props.hide, data = _this$props.data, dataKey = _this$props.dataKey, className = _this$props.className, xAxisId = _this$props.xAxisId, yAxisId = _this$props.yAxisId, needClip = _this$props.needClip, background = _this$props.background, id = _this$props.id;
        if (hide || data == null) return null;
        var layerClass = (0, $9QePP.clsx)('recharts-bar', className);
        var clipPathId = id;
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            className: layerClass,
            id: id
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $j0wOw.GraphicalItemClipPath), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        })), /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            className: "recharts-bar-rectangles",
            clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
        }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarBackground, {
            data: data,
            dataKey: dataKey,
            background: background,
            allOtherBarProps: this.props
        }), /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$RenderRectangles, this.props)));
    }
}
var $e752e700473a8894$export$ae0fe71c3c345c68 = {
    activeBar: false,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease',
    animationInterpolateFn: $e752e700473a8894$var$defaultBarAnimateItems,
    animationMatchBy: (0, $dujP6.matchAppend),
    background: false,
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'rect',
    minPointSize: $e752e700473a8894$var$defaultMinPointSize,
    shape: (0, $b5efd6b8794dbdeb$export$f94f2603511acf72),
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $gKNgz.DefaultZIndexes).bar
};
function $e752e700473a8894$var$BarImpl(props) {
    var xAxisId = props.xAxisId, yAxisId = props.yAxisId, hide = props.hide, legendType = props.legendType, minPointSize = props.minPointSize, activeBar = props.activeBar, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, isAnimationActive = props.isAnimationActive;
    var _useNeedsClip = (0, $j0wOw.useNeedsClip)(xAxisId, yAxisId), needClip = _useNeedsClip.needClip;
    var layout = (0, $jHn5r.useChartLayout)();
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var cells = (0, $02Ymo.findAllByType)(props.children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea));
    var rects = (0, $bqlEl.useAppSelector)((state)=>(0, $768c0ec0ed64a741$export$bb89ca2d15dbced9)(state, props.id, isPanorama, cells));
    if (layout !== 'vertical' && layout !== 'horizontal') return null;
    var errorBarOffset;
    var firstDataPoint = rects === null || rects === void 0 ? void 0 : rects[0];
    if (firstDataPoint == null || firstDataPoint.height == null || firstDataPoint.width == null) errorBarOffset = 0;
    else errorBarOffset = layout === 'vertical' ? firstDataPoint.height / 2 : firstDataPoint.width / 2;
    return /*#__PURE__*/ $acw62.createElement((0, $kCoA9.SetErrorBarContext), {
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        data: rects,
        dataPointFormatter: $e752e700473a8894$var$errorBarDataPointFormatter,
        errorBarOffset: errorBarOffset
    }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarWithState, $e752e700473a8894$var$_extends({}, props, {
        layout: layout,
        needClip: needClip,
        data: rects,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        hide: hide,
        legendType: legendType,
        minPointSize: minPointSize,
        activeBar: activeBar,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive
    })));
}
function $e752e700473a8894$export$3b2ba7a38b022e(_ref6) {
    var layout = _ref6.layout, _ref6$barSettings = _ref6.barSettings, dataKey = _ref6$barSettings.dataKey, minPointSizeProp = _ref6$barSettings.minPointSize, hasCustomShape = _ref6$barSettings.hasCustomShape, pos = _ref6.pos, bandSize = _ref6.bandSize, xAxis = _ref6.xAxis, yAxis = _ref6.yAxis, xAxisTicks = _ref6.xAxisTicks, yAxisTicks = _ref6.yAxisTicks, stackedData = _ref6.stackedData, displayedData = _ref6.displayedData, offset = _ref6.offset, cells = _ref6.cells, parentViewBox = _ref6.parentViewBox, dataStartIndex = _ref6.dataStartIndex;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error this assumes that the domain is always numeric, but doesn't check for it
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $hBeJX.getBaseValueOfBar)({
        numericAxis: numericAxis
    });
    var stackedBarStart = numericAxis.scale.map(baseValue);
    return displayedData.map((entry, index)=>{
        var value, x, y, width, height, background;
        if (stackedData) {
            // Use dataStartIndex to access the correct element in the full stackedData array
            var untruncatedValue = stackedData[index + dataStartIndex];
            if (untruncatedValue == null) return null;
            value = (0, $hBeJX.truncateByDomain)(untruncatedValue, stackedDomain);
        } else {
            value = (0, $hBeJX.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $b5efd6b8794dbdeb$export$c20d73790de171f0)(minPointSizeProp, $e752e700473a8894$var$defaultMinPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref7;
            var baseValueScale = yAxis.scale.map(value[0]);
            var currentValueScale = yAxis.scale.map(value[1]);
            if (baseValueScale == null || currentValueScale == null) return null;
            x = (0, $hBeJX.getCateCoordinateOfBar)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref7 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref7 !== void 0 ? _ref7 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = (0, $3FiDp.isNan)(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: offset.top,
                width: width,
                height: offset.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $3FiDp.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _baseValueScale = xAxis.scale.map(value[0]);
            var _currentValueScale = xAxis.scale.map(value[1]);
            if (_baseValueScale == null || _currentValueScale == null) return null;
            x = _baseValueScale;
            y = (0, $hBeJX.getCateCoordinateOfBar)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: offset.left,
                y: y,
                width: offset.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $3FiDp.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        /*
     * Filter out 0-dimension rectangles early to avoid creating unnecessary component trees.
     * BarStack clip-paths use originalDataIndex, so sparse filtered arrays remain index-stable.
     * Bars with a custom shape are not filtered out: the custom renderer may still draw something
     * visible at zero-dimension positions (e.g. horizontal lines in a BoxPlot).
     */ if (x == null || y == null || width == null || height == null || !hasCustomShape && (width === 0 || height === 0)) return null;
        var barRectangleItem = $e752e700473a8894$var$_objectSpread($e752e700473a8894$var$_objectSpread({}, entry), {}, {
            stackedBarStart: stackedBarStart,
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background,
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            },
            parentViewBox: parentViewBox,
            originalDataIndex: index
        }, cells && cells[index] && cells[index].props);
        return barRectangleItem;
    }).filter(Boolean);
}
function $e752e700473a8894$var$BarFn(outsideProps) {
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $e752e700473a8894$export$ae0fe71c3c345c68);
    // stackId may arrive from props or from BarStack context
    var stackId = (0, $b8a2be1f3c4055dc$export$837efb24f50d011e)(props.stackId);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    // Report all props to Redux store first, before calling any hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $acw62.createElement((0, $jhZFb.RegisterGraphicalItemId), {
        id: props.id,
        type: "bar"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $ckb0X.SetLegendPayload), {
            legendPayload: $e752e700473a8894$var$computeLegendPayloadFromBarData(props)
        }), /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$SetBarTooltipEntrySettings, {
            dataKey: props.dataKey,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            formatter: props.formatter,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $aPPc1.SetCartesianGraphicalItem), {
            type: "bar",
            id: id,
            data: undefined,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            stackId: stackId,
            hide: props.hide,
            barSize: props.barSize,
            minPointSize: props.minPointSize,
            maxBarSize: props.maxBarSize,
            isPanorama: isPanorama,
            hasCustomShape: props.shape != null && props.shape !== (0, $b5efd6b8794dbdeb$export$f94f2603511acf72)
        }), /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
            zIndex: props.zIndex
        }, /*#__PURE__*/ $acw62.createElement($e752e700473a8894$var$BarImpl, $e752e700473a8894$var$_extends({}, props, {
            id: id
        })))));
}
var $e752e700473a8894$export$bbc6c6369b38e3d1 = /*#__PURE__*/ $acw62.memo($e752e700473a8894$var$BarFn, (0, $biEKl.propsAreEqual));
// @ts-expect-error we need to set the displayName for debugging purposes
$e752e700473a8894$export$bbc6c6369b38e3d1.displayName = 'Bar';


var $acw62 = parcelRequire("acw62");

var $bIbT7 = parcelRequire("bIbT7");

var $fC5w9 = parcelRequire("fC5w9");
var $74d07378047db57c$var$allowedTooltipTypes = [
    'axis',
    'item'
];
var $74d07378047db57c$export$94aefc399ef206a9 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $fC5w9.CartesianChart), {
        chartName: "BarChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $74d07378047db57c$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $bIbT7.arrayTooltipSearcher),
        categoricalChartProps: props,
        ref: ref
    });
});


var $kan35 = parcelRequire("kan35");
var $bJtQU = parcelRequire("bJtQU");
var $4jZOw = parcelRequire("4jZOw");
var $kMGAE = parcelRequire("kMGAE");
var $1dtDd = parcelRequire("1dtDd");


var $iD7Z3 = parcelRequire("iD7Z3");

var $2u93q = parcelRequire("2u93q");




var $iD7Z3 = parcelRequire("iD7Z3");
const $17d0a4576b439e8f$export$9a25ca3301c594da = (value, unit, mode, variant)=>{
    const getKilowatt = ()=>{
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year) return 'megawatt-hour';
        return variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).Bar || variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked ? 'kilowatt-hour' : 'kilowatt';
    };
    const mapping = {
        [(0, $28b4cee73700460a$export$21eef29f47e43a9d).Kilowatt]: {
            unit: getKilowatt(),
            style: 'unit',
            maximumFractionDigits: mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? 2 : 1,
            minimumFractionDigits: mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? 2 : 1
        },
        [(0, $28b4cee73700460a$export$21eef29f47e43a9d).Percent]: {
            style: 'percent',
            maximumFractionDigits: 0
        },
        [(0, $28b4cee73700460a$export$21eef29f47e43a9d).Celsius]: {
            unit: 'celsius',
            style: 'unit',
            maximumFractionDigits: 0
        },
        [(0, $28b4cee73700460a$export$21eef29f47e43a9d).MeterPerSecond]: {
            unit: 'meter-per-second',
            style: 'unit',
            maximumFractionDigits: 0
        },
        [(0, $28b4cee73700460a$export$21eef29f47e43a9d).Ampere]: {
            unit: 'ampere',
            style: 'unit',
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }
    };
    const opts = mapping[unit];
    const adjustedValue = opts.unit === 'megawatt-hour' ? value / 1000 : value;
    return [
        adjustedValue,
        opts
    ];
};
const $17d0a4576b439e8f$export$54ae311e84eed980 = (index, total)=>{
    const minOpacity = 0.2;
    const step = total > 1 ? (1 - minOpacity) / (total - 1) : 0;
    return $17d0a4576b439e8f$var$hexWithOpacity((0, $iD7Z3.colors).primary, 1 - index * step);
};
function $17d0a4576b439e8f$var$hexWithOpacity(hex, opacity) {
    hex = hex.replace('#', '');
    const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
    return `#${hex}${alpha}`;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $gJm6V = parcelRequire("gJm6V");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");
var $202BL = parcelRequire("202BL");

var $f1q41 = parcelRequire("f1q41");




var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");

const $4a50ccb595f2a6ce$export$9f95857259638e76 = ({ active: active, payload: payload, label: at, mode: mode, unit: unit, variant: variant, variableId: variableId, getSubStatsLabel: getSubStatsLabel })=>{
    const intl = (0, $202BL.default)();
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const [rfidCards] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.RFID_CARDS ?? {}
        ]);
    const subInverterNameMapping = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        const inverterConfig = variables.INVERTER_CONFIG;
        const inverterStats = variables.INVERTER_STATS;
        const mapping = {};
        for (const [key, config] of Object.entries(inverterConfig)){
            if (config.type !== (0, $8ni7a.Inverter).SolaxEMS1000 && config.type !== (0, $8ni7a.Inverter).SolaxEMS1000PRO) continue;
            const stats = inverterStats[key];
            for(let i = 0; i < (config?.inverters?.length ?? 0); i++){
                const detail = stats?.inverterDetail?.[i];
                mapping[`${key}||${i}`] = {
                    name: (0, $f1q41.get)((0, $c921d87731d038a0$export$3ec460b98d9366d2)[config.type], detail?.name ?? 0, (0, $bd9zl.defineMessage)({
                        id: 'ems.inverter.name.unknown',
                        defaultMessage: "Nezn\xe1m\xfd model"
                    }))
                };
            }
        }
        return mapping;
    }, (0, $f1q41.isEqual));
    if (!(active && payload && payload.length)) return null;
    const time = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
            value: at
        });
    const datetime = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                time(),
                " ",
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                    value: at
                })
            ]
        });
    const yearMonth = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
            value: at,
            year: "numeric",
            month: "long"
        });
    const labelMapping = {
        [(0, $9b560528a5f99400$export$585dc7a4228aacca).Line]: {
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year]: time
        },
        [(0, $9b560528a5f99400$export$585dc7a4228aacca).Bar]: {
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week]: time,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year]: yearMonth
        },
        [(0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked]: {
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year]: time
        },
        [(0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked]: {
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day]: datetime,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week]: time,
            [(0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year]: yearMonth
        }
    };
    const value = variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked || variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked ? (0, $f1q41.sumBy)(payload, 'value') : payload[0].value;
    const controlMode = payload[0].payload.controlMode;
    const activeCondition = payload[0].payload.activeCondition;
    const wallboxAuthorizationCards = payload[0].payload.wallboxAuthorizationCards;
    const subStats = Object.entries(payload[0].payload.subStats);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        sx: {
            bgcolor: (theme)=>theme.palette.mode === 'light' ? 'text.disabled' : '#343e42',
            color: 'common.white',
            borderRadius: 2,
            py: 1,
            px: {
                xs: 1.5,
                md: 2
            },
            outline: 'none'
        },
        children: [
            labelMapping[variant][mode](),
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            formatNumber(...(0, $17d0a4576b439e8f$export$9a25ca3301c594da)(value, unit, mode, variant)),
            controlMode && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                        sx: {
                            borderColor: 'white',
                            opacity: 0.5,
                            my: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "chart.tooltip.control_mode.title",
                            defaultMessage: "\u0158\xedzeno podle:"
                        })
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "chart.tooltip.control_mode.value",
                        defaultMessage: `{mode, select,
              photovoltaic {Fotovoltaika}
              grid {Distribu\u{10D}n\xed s\xed\u{165}}
              spot {Spot}
              flexibility {Flexibilita}
              error {Chyba}
              other {{mode}}
            }`,
                        values: {
                            mode: controlMode
                        }
                    })
                ]
            }),
            activeCondition && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                        sx: {
                            borderColor: 'white',
                            opacity: 0.5,
                            my: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "chart.tooltip.active_condition.title",
                            defaultMessage: "Aktu\xe1ln\xed re\u017Eim:"
                        })
                    }),
                    ' ',
                    (()=>{
                        const conditionMapping = {
                            off: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.off",
                                defaultMessage: "Vypnuto"
                            }),
                            manual: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.manual",
                                defaultMessage: "Manualn\xed"
                            }),
                            time: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.time",
                                defaultMessage: "\u010Casov\xfd"
                            }),
                            battery: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.battery",
                                defaultMessage: "Baterie"
                            }),
                            overflow: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.overflow",
                                defaultMessage: "P\u0159etok"
                            }),
                            spot: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.spot",
                                defaultMessage: "Spot"
                            }),
                            error: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.error",
                                defaultMessage: "Chyba"
                            }),
                            heating: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.heating",
                                defaultMessage: "Vyt\xe1p\u011Bn\xed"
                            }),
                            cooling: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.cooling",
                                defaultMessage: "Chlazen\xed"
                            }),
                            pool: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.pool",
                                defaultMessage: "Oh\u0159ev baz\xe9nu"
                            }),
                            inactive: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.inactive",
                                defaultMessage: "Neaktivn\xed"
                            }),
                            'not-connected': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.not-connected",
                                defaultMessage: "Nelze nav\xe1zat spojen\xed"
                            }),
                            'compressor-blocked': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.compressor-blocked",
                                defaultMessage: "Blokace kompresoru, n\xedzk\xfd stav baterie"
                            }),
                            'hot-water': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.hot-water",
                                defaultMessage: "Oh\u0159ev tepl\xe9 vody"
                            }),
                            'not-licensed': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "chart.tooltip.active_condition.value.not-licensed",
                                defaultMessage: "Nen\xed licencov\xe1no"
                            })
                        };
                        return conditionMapping[activeCondition];
                    })()
                ]
            }),
            wallboxAuthorizationCards && Object.keys(wallboxAuthorizationCards).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                        sx: {
                            borderColor: 'white',
                            opacity: 0.5,
                            my: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "chart.tooltip.wallbox_authorization_card_id.title",
                            defaultMessage: "Autoriza\u010Dn\xed karta:"
                        })
                    }),
                    ' ',
                    Object.entries(wallboxAuthorizationCards).map(([cardId, value])=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                cardId in rfidCards ? rfidCards[cardId].name : cardId,
                                ":",
                                ' ',
                                formatNumber(...(0, $17d0a4576b439e8f$export$9a25ca3301c594da)(value, unit, mode, variant))
                            ]
                        }, cardId))
                ]
            }),
            Boolean(subStats.length) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                sx: {
                    borderColor: 'white',
                    opacity: 0.5,
                    my: 0.5
                }
            }),
            subStats.map(([metric, value])=>{
                let label = getSubStatsLabel?.(metric) ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: (0, $f1q41.startCase)(metric)
                });
                const formattedValue = formatNumber(...(0, $17d0a4576b439e8f$export$9a25ca3301c594da)(value, unit, mode, variant));
                if ([
                    'EM_CONSUMED_GRAPH',
                    'EM_OVERFLOW_GRAPH',
                    'HW_POWER_GRAPH',
                    'HP_CONSUMED_GRAPH',
                    'EM_METER_POWER_GRAPH'
                ].includes(variableId)) {
                    let formattedMetricNumber = metric;
                    if (variableId === 'EM_METER_POWER_GRAPH') formattedMetricNumber = metric.split('-').slice(-1)[0];
                    label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: '"chart.tooltip.substat.phase"',
                        defaultMessage: "F\xe1ze {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}",
                        values: {
                            number: formattedMetricNumber
                        }
                    });
                }
                if ([
                    'PV_POWER_GRAPH'
                ].includes(variableId)) {
                    const parsedMetricString = /^(.*)-(\d*)$/.exec(metric);
                    const parsedMetricInverter = /^(.*)\|\|(\d*)$/.exec(metric);
                    if (parsedMetricString) {
                        const [, parsedInverterName, stringRawNumber] = parsedMetricString;
                        const stringNumber = Number(stringRawNumber) + 1;
                        let inverterName = parsedInverterName;
                        if (inverterName in subInverterNameMapping) inverterName = intl.formatMessage(subInverterNameMapping[inverterName].name);
                        else inverterName = (0, $f1q41.startCase)(inverterName);
                        label = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: '"chart.tooltip.substat.pv_string"',
                            defaultMessage: "{inverterName}, String {stringNumber}",
                            values: {
                                inverterName: inverterName,
                                stringNumber: stringNumber
                            }
                        });
                    } else if (parsedMetricInverter) {
                        if (metric in subInverterNameMapping) label = intl.formatMessage(subInverterNameMapping[metric].name);
                    }
                }
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                            children: [
                                label,
                                ":"
                            ]
                        }),
                        " ",
                        formattedValue,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                    ]
                });
            })
        ]
    });
};


const $b30f16719474c4de$export$99199eb0d2d4ab39 = ({ data: data, mode: mode, unit: unit, yAxisDomain: yAxisDomain, yAxisTickFormatter: yAxisTickFormatter, mobile: mobile, formatNumber: formatNumber, maxValue: maxValue, variant: variant, variableId: variableId, getSubStatsLabel: getSubStatsLabel })=>{
    const showBarLabelList = mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week;
    const tickWithFractionDigits = mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day && unit === (0, $28b4cee73700460a$export$21eef29f47e43a9d).Kilowatt;
    const tickUseMegawatt = mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year && unit === (0, $28b4cee73700460a$export$21eef29f47e43a9d).Kilowatt;
    const stacked = variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked && data.subStatsKeys.length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
        data: data.sortedData,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kan35.CartesianGrid), {
                strokeWidth: 0.25,
                stroke: (0, $iD7Z3.colors).darkBlue,
                strokeOpacity: 0.4,
                vertical: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jZOw.Tooltip), {
                content: // eslint-disable-next-line
                // @ts-ignore
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a50ccb595f2a6ce$export$9f95857259638e76), {
                    mode: mode,
                    unit: unit,
                    variant: variant,
                    variableId: variableId,
                    getSubStatsLabel: getSubStatsLabel
                }),
                cursor: {
                    fill: (0, $iD7Z3.colors).darkBlue,
                    opacity: 0.15
                }
            }),
            !stacked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                dataKey: "value",
                fill: (0, $iD7Z3.colors).primary,
                children: showBarLabelList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bJtQU.LabelList), {
                    dataKey: "value",
                    position: "insideBottom",
                    fontFamily: (0, $2u93q.fontFamily),
                    fill: (0, $iD7Z3.colors).white,
                    offset: 12,
                    formatter: (value)=>{
                        if (typeof value !== 'number') return '';
                        const [adjustedValue, opts] = (0, $17d0a4576b439e8f$export$9a25ca3301c594da)(value, unit, mode, (0, $9b560528a5f99400$export$585dc7a4228aacca).Bar);
                        if (mobile) {
                            opts.minimumFractionDigits = 0;
                            opts.maximumFractionDigits = 0;
                        }
                        return formatNumber(adjustedValue, opts);
                    }
                })
            }),
            stacked && data.subStatsKeys.map((key, index)=>{
                const color = (0, $17d0a4576b439e8f$export$54ae311e84eed980)(index, data.subStatsKeys.length);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                    dataKey: `subStats.${key}`,
                    name: "kW",
                    stackId: "1",
                    fill: `${color}`
                }, key);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMGAE.XAxis), {
                dataKey: "at",
                style: {
                    fontFamily: $2u93q.fontFamily,
                    color: (0, $iD7Z3.colors).darkBlue,
                    top: 20,
                    transform: 'translateY(8px)'
                },
                axisLine: false,
                tickLine: false,
                interval: $b30f16719474c4de$var$getTicksInterval(),
                tickFormatter: yAxisTickFormatter
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                width: $b30f16719474c4de$var$getYAxisWidth(mobile, maxValue, tickWithFractionDigits || tickUseMegawatt, tickUseMegawatt),
                style: {
                    fontFamily: $2u93q.fontFamily,
                    color: (0, $iD7Z3.colors).darkBlue,
                    transform: 'translateX(-6px)'
                },
                axisLine: false,
                tickLine: false,
                tickFormatter: (value)=>{
                    const fractionDigits = tickUseMegawatt ? 2 : tickWithFractionDigits ? 1 : 0;
                    const adjustedValue = tickUseMegawatt ? value / 1000 : value;
                    return formatNumber(adjustedValue, {
                        minimumFractionDigits: fractionDigits,
                        maximumFractionDigits: fractionDigits
                    });
                },
                domain: yAxisDomain
            })
        ]
    });
};
const $b30f16719474c4de$var$getYAxisWidth = (mobile, maxValue, tickWithFractionDigits, tickUseMegawatt)=>{
    if (!maxValue) return 30;
    const digits = $b30f16719474c4de$var$countDigits(maxValue * 1.1);
    const spaces = Math.floor(digits / 4);
    const baseWidth = 10;
    const digitWidth = mobile ? 7 : 9;
    const fractionDigitsWidth = mobile ? 8 : 10;
    const width = baseWidth + (digits + spaces + (tickUseMegawatt ? -1 : 0)) * digitWidth + (tickWithFractionDigits ? fractionDigitsWidth : 0);
    return width;
};
const $b30f16719474c4de$var$getTicksInterval = ()=>{
    return undefined;
};
function $b30f16719474c4de$var$countDigits(number) {
    if (number === 0) return 1;
    return Math.floor(Math.log10(Math.abs(number))) + 1;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $lIF05 = parcelRequire("lIF05");

var $bJtQU = parcelRequire("bJtQU");

var $9qtrE = parcelRequire("9qtrE");

var $3FiDp = parcelRequire("3FiDp");

var $hBeJX = parcelRequire("hBeJX");

var $02Ymo = parcelRequire("02Ymo");

var $CpNo3 = parcelRequire("CpNo3");

var $2C2Dz = parcelRequire("2C2Dz");

var $j0wOw = parcelRequire("j0wOw");

var $b0nKR = parcelRequire("b0nKR");


var $99P3O = parcelRequire("99P3O");

var $jHn5r = parcelRequire("jHn5r");

var $i2WC7 = parcelRequire("i2WC7");

var $hBeJX = parcelRequire("hBeJX");

var $3FiDp = parcelRequire("3FiDp");

var $hcIzl = parcelRequire("hcIzl");

var $iYis8 = parcelRequire("iYis8");

var $5fbeae2880aa4f3e$var$selectXAxisWithScale = (state, graphicalItemId, isPanorama)=>(0, $99P3O.selectAxisWithScale)(state, 'xAxis', (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectXAxisTicks = (state, graphicalItemId, isPanorama)=>(0, $99P3O.selectTicksOfGraphicalItem)(state, 'xAxis', (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectYAxisWithScale = (state, graphicalItemId, isPanorama)=>(0, $99P3O.selectAxisWithScale)(state, 'yAxis', (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectYAxisTicks = (state, graphicalItemId, isPanorama)=>(0, $99P3O.selectTicksOfGraphicalItem)(state, 'yAxis', (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$var$selectBandSize = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $5fbeae2880aa4f3e$var$selectXAxisWithScale,
    $5fbeae2880aa4f3e$var$selectYAxisWithScale,
    $5fbeae2880aa4f3e$var$selectXAxisTicks,
    $5fbeae2880aa4f3e$var$selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, $hBeJX.isCategoricalAxis)(layout, 'xAxis')) return (0, $hBeJX.getBandSizeOfAxis)(xAxis, xAxisTicks, false);
    return (0, $hBeJX.getBandSizeOfAxis)(yAxis, yAxisTicks, false);
});
var $5fbeae2880aa4f3e$var$pickAreaId = (_state, id)=>id;
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * A proper fix is to either move everything into the state, or read the dataKey always from props
 * - but this is a smaller change.
 */ var $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectUnfilteredCartesianItems),
    $5fbeae2880aa4f3e$var$pickAreaId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'area').find((item)=>item.id === id));
var $5fbeae2880aa4f3e$var$selectNumericalAxisType = (state)=>{
    var layout = (0, $jHn5r.selectChartLayout)(state);
    var isXAxisCategorical = (0, $hBeJX.isCategoricalAxis)(layout, 'xAxis');
    return isXAxisCategorical ? 'yAxis' : 'xAxis';
};
var $5fbeae2880aa4f3e$var$selectNumericalAxisIdFromGraphicalItemId = (state, graphicalItemId)=>{
    var axisType = $5fbeae2880aa4f3e$var$selectNumericalAxisType(state);
    if (axisType === 'yAxis') return (0, $07dce3cd67839b77$export$5babc813f7c13fff)(state, graphicalItemId);
    return (0, $07dce3cd67839b77$export$eea16fee3026d9cf)(state, graphicalItemId);
};
var $5fbeae2880aa4f3e$var$selectNumericalAxisStackGroups = (state, graphicalItemId, isPanorama)=>(0, $99P3O.selectStackGroups)(state, $5fbeae2880aa4f3e$var$selectNumericalAxisType(state), $5fbeae2880aa4f3e$var$selectNumericalAxisIdFromGraphicalItemId(state, graphicalItemId), isPanorama);
var $5fbeae2880aa4f3e$export$cc6a257c8cf034c2 = (0, $b0nKR.createSelector)([
    $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings,
    $5fbeae2880aa4f3e$var$selectNumericalAxisStackGroups
], (areaSettings, stackGroups)=>{
    var _stackGroups$stackId;
    if (areaSettings == null || stackGroups == null) return undefined;
    var stackId = areaSettings.stackId;
    var stackSeriesIdentifier = (0, $hcIzl.getStackSeriesIdentifier)(areaSettings);
    if (stackId == null || stackSeriesIdentifier == null) return undefined;
    var groups = (_stackGroups$stackId = stackGroups[stackId]) === null || _stackGroups$stackId === void 0 ? void 0 : _stackGroups$stackId.stackedData;
    var found = groups === null || groups === void 0 ? void 0 : groups.find((v)=>v.key === stackSeriesIdentifier);
    if (found == null) return undefined;
    return found.map((item)=>[
            item[0],
            item[1]
        ]);
});
/*
 * All dataKeys of the stack group that this graphical item belongs to.
 * computeArea needs them to tell apart data points where only this series is null
 * (rendered as zero contribution to keep the stack consistent)
 * from data points where the whole stack is null
 * (a break point that connectNulls may connect across).
 */ var $5fbeae2880aa4f3e$var$selectStackDataKeys = (0, $b0nKR.createSelector)([
    $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings,
    $5fbeae2880aa4f3e$var$selectNumericalAxisStackGroups
], (areaSettings, stackGroups)=>{
    if (areaSettings == null || areaSettings.stackId == null || stackGroups == null) return undefined;
    var group = stackGroups[areaSettings.stackId];
    if (group == null) return undefined;
    return group.graphicalItems.map((item)=>item.dataKey).filter((0, $3FiDp.isNotNil));
});
var $5fbeae2880aa4f3e$export$5f2090c2af7a0678 = (0, $b0nKR.createSelector)([
    (0, $jHn5r.selectChartLayout),
    $5fbeae2880aa4f3e$var$selectXAxisWithScale,
    $5fbeae2880aa4f3e$var$selectYAxisWithScale,
    $5fbeae2880aa4f3e$var$selectXAxisTicks,
    $5fbeae2880aa4f3e$var$selectYAxisTicks,
    $5fbeae2880aa4f3e$export$cc6a257c8cf034c2,
    (0, $i2WC7.selectChartDataWithIndexesIfNotInPanoramaPosition3),
    $5fbeae2880aa4f3e$var$selectBandSize,
    $5fbeae2880aa4f3e$var$selectSynchronisedAreaSettings,
    (0, $iYis8.selectChartBaseValue),
    $5fbeae2880aa4f3e$var$selectStackDataKeys
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, stackedData, _ref, bandSize, areaSettings, chartBaseValue, stackDataKeys)=>{
    var chartData = _ref.chartData, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    if (areaSettings == null || layout !== 'horizontal' && layout !== 'vertical' || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null) return undefined;
    var data = areaSettings.data;
    var displayedData;
    if (data && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, $551fcf7b84a33486$export$bb0068e0a912aef6)({
        layout: layout,
        xAxis: xAxis,
        yAxis: yAxis,
        xAxisTicks: xAxisTicks,
        yAxisTicks: yAxisTicks,
        dataStartIndex: dataStartIndex,
        areaSettings: areaSettings,
        stackedData: stackedData,
        displayedData: displayedData,
        chartBaseValue: chartBaseValue,
        bandSize: bandSize,
        stackDataKeys: stackDataKeys
    });
});



var $3X9hg = parcelRequire("3X9hg");

var $jHn5r = parcelRequire("jHn5r");

var $72R3N = parcelRequire("72R3N");

var $ckb0X = parcelRequire("ckb0X");

var $bqlEl = parcelRequire("bqlEl");

var $eHwNv = parcelRequire("eHwNv");

var $dujP6 = parcelRequire("dujP6");

var $cdyCS = parcelRequire("cdyCS");

var $cd9rh = parcelRequire("cd9rh");

var $5IafS = parcelRequire("5IafS");

var $jhZFb = parcelRequire("jhZFb");

var $aPPc1 = parcelRequire("aPPc1");

var $4M6vj = parcelRequire("4M6vj");

var $lT2y6 = parcelRequire("lT2y6");

var $lTk0V = parcelRequire("lTk0V");

var $63Kel = parcelRequire("63Kel");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $biEKl = parcelRequire("biEKl");

var $acw62 = parcelRequire("acw62");

var $3FiDp = parcelRequire("3FiDp");

var $f2bYI = parcelRequire("f2bYI");

var $iMnqX = parcelRequire("iMnqX");

var $lIF05 = parcelRequire("lIF05");

var $4M6vj = parcelRequire("4M6vj");

var $d70Dn = parcelRequire("d70Dn");
var $479b463c9360c840$var$_excluded = [
    "animationElapsedTime",
    "isAnimating",
    "isEntrance",
    "layout",
    "isRange",
    "stroke",
    "connectNulls"
], $479b463c9360c840$var$_excluded2 = [
    "id",
    "baseLine"
];
function $479b463c9360c840$var$_extends() {
    return $479b463c9360c840$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $479b463c9360c840$var$_extends.apply(null, arguments);
}
function $479b463c9360c840$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $479b463c9360c840$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $479b463c9360c840$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Props for the clip-path rect computation.
 * @internal
 */ function $479b463c9360c840$var$HorizontalClipRect(_ref) {
    var _points$, _points;
    var alpha = _ref.alpha, baseLine = _ref.baseLine, points = _ref.points, strokeWidth = _ref.strokeWidth;
    var startX = (_points$ = points[0]) === null || _points$ === void 0 ? void 0 : _points$.x;
    var endX = (_points = points[points.length - 1]) === null || _points === void 0 ? void 0 : _points.x;
    if (!(0, $iMnqX.isWellBehavedNumber)(startX) || !(0, $iMnqX.isWellBehavedNumber)(endX)) return null;
    var width = alpha * Math.abs(startX - endX);
    var maxY = Math.max(...points.map((entry)=>entry.y || 0));
    if ((0, $3FiDp.isNumber)(baseLine)) maxY = Math.max(baseLine, maxY);
    else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max(...baseLine.map((entry)=>entry.y || 0), maxY);
    if ((0, $3FiDp.isNumber)(maxY)) return /*#__PURE__*/ $acw62.createElement("rect", {
        x: startX < endX ? startX : startX - width,
        y: 0,
        width: width,
        height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
    });
    return null;
}
function $479b463c9360c840$var$VerticalClipRect(_ref2) {
    var _points$2, _points2;
    var alpha = _ref2.alpha, baseLine = _ref2.baseLine, points = _ref2.points, strokeWidth = _ref2.strokeWidth;
    var startY = (_points$2 = points[0]) === null || _points$2 === void 0 ? void 0 : _points$2.y;
    var endY = (_points2 = points[points.length - 1]) === null || _points2 === void 0 ? void 0 : _points2.y;
    if (!(0, $iMnqX.isWellBehavedNumber)(startY) || !(0, $iMnqX.isWellBehavedNumber)(endY)) return null;
    var height = alpha * Math.abs(startY - endY);
    var maxX = Math.max(...points.map((entry)=>entry.x || 0));
    if ((0, $3FiDp.isNumber)(baseLine)) maxX = Math.max(baseLine, maxX);
    else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max(...baseLine.map((entry)=>entry.x || 0), maxX);
    if ((0, $3FiDp.isNumber)(maxX)) return /*#__PURE__*/ $acw62.createElement("rect", {
        x: 0,
        y: startY < endY ? startY : startY - height,
        width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
        height: Math.floor(height)
    });
    return null;
}
function $479b463c9360c840$var$RevealClipRect(_ref3) {
    var alpha = _ref3.alpha, layout = _ref3.layout, points = _ref3.points, baseLine = _ref3.baseLine, strokeWidth = _ref3.strokeWidth;
    if (layout === 'vertical') return /*#__PURE__*/ $acw62.createElement($479b463c9360c840$var$VerticalClipRect, {
        alpha: alpha,
        points: points,
        baseLine: baseLine,
        strokeWidth: strokeWidth
    });
    return /*#__PURE__*/ $acw62.createElement($479b463c9360c840$var$HorizontalClipRect, {
        alpha: alpha,
        points: points,
        baseLine: baseLine,
        strokeWidth: strokeWidth
    });
}
function $479b463c9360c840$export$9e66d5566f671821(props) {
    var _props$animationElaps = props.animationElapsedTime, animationElapsedTime = _props$animationElaps === void 0 ? 1 : _props$animationElaps, _props$isAnimating = props.isAnimating, isAnimating = _props$isAnimating === void 0 ? false : _props$isAnimating, _props$isEntrance = props.isEntrance, isEntrance = _props$isEntrance === void 0 ? false : _props$isEntrance, layoutProp = props.layout, isRange = props.isRange, stroke = props.stroke, connectNulls = props.connectNulls, restProps = $479b463c9360c840$var$_objectWithoutProperties(props, $479b463c9360c840$var$_excluded);
    var layout = layoutProp === 'vertical' ? 'vertical' : 'horizontal';
    var finalConnectNulls = connectNulls !== null && connectNulls !== void 0 ? connectNulls : false;
    var clipId = (0, $d70Dn.useId)();
    var id = restProps.id, baseLine = restProps.baseLine, propsWithoutIdBaseline = $479b463c9360c840$var$_objectWithoutProperties(restProps, $479b463c9360c840$var$_excluded2);
    var strokeSvgProps = (0, $4M6vj.svgPropertiesNoEvents)(propsWithoutIdBaseline);
    var fillCurve = /*#__PURE__*/ $acw62.createElement((0, $f2bYI.Curve), $479b463c9360c840$var$_extends({}, restProps, {
        id: id,
        baseLine: baseLine,
        connectNulls: finalConnectNulls,
        stroke: "none",
        className: "recharts-area-area",
        layout: layout
    }));
    var strokeCurve = stroke !== 'none' && /*#__PURE__*/ $acw62.createElement((0, $f2bYI.Curve), $479b463c9360c840$var$_extends({}, strokeSvgProps, {
        className: "recharts-area-curve",
        layout: layout,
        type: restProps.type,
        connectNulls: finalConnectNulls,
        fill: "none",
        stroke: stroke,
        points: restProps.points
    }));
    var baselineCurve = stroke !== 'none' && isRange && Array.isArray(baseLine) && /*#__PURE__*/ $acw62.createElement((0, $f2bYI.Curve), $479b463c9360c840$var$_extends({}, strokeSvgProps, {
        className: "recharts-area-curve",
        layout: layout,
        type: restProps.type,
        connectNulls: finalConnectNulls,
        fill: "none",
        stroke: stroke,
        points: baseLine
    }));
    if (isEntrance && (isAnimating || animationElapsedTime < 1)) {
        var _restProps$points;
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), null, /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: clipId
        }, /*#__PURE__*/ $acw62.createElement($479b463c9360c840$var$RevealClipRect, {
            alpha: animationElapsedTime,
            points: (_restProps$points = restProps.points) !== null && _restProps$points !== void 0 ? _restProps$points : [],
            baseLine: baseLine,
            layout: layout,
            strokeWidth: restProps.strokeWidth
        }))), /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            clipPath: "url(#".concat(clipId, ")")
        }, fillCurve, strokeCurve, baselineCurve));
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, fillCurve, strokeCurve, baselineCurve);
}


var $551fcf7b84a33486$var$_excluded = [
    "id"
], $551fcf7b84a33486$var$_excluded2 = [
    "activeDot",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "fill",
    "fillOpacity",
    "hide",
    "isAnimationActive",
    "legendType",
    "stroke",
    "xAxisId",
    "yAxisId"
];
function $551fcf7b84a33486$var$_extends() {
    return $551fcf7b84a33486$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $551fcf7b84a33486$var$_extends.apply(null, arguments);
}
function $551fcf7b84a33486$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $551fcf7b84a33486$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $551fcf7b84a33486$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $551fcf7b84a33486$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $551fcf7b84a33486$var$ownKeys(Object(t), !0).forEach(function(r) {
            $551fcf7b84a33486$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $551fcf7b84a33486$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $551fcf7b84a33486$var$_defineProperty(e, r, t) {
    return (r = $551fcf7b84a33486$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $551fcf7b84a33486$var$_toPropertyKey(t) {
    var i = $551fcf7b84a33486$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $551fcf7b84a33486$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * @inline
 */ /**
 * Our base value array has payload in it, and we expose it externally too.
 */ /**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ var $551fcf7b84a33486$var$defaultAreaAnimateItems = (items, animationElapsedTime)=>{
    if (items == null) // First render: return items as-is, clip-path animation handles the reveal
    return [];
    if (animationElapsedTime === 1) return items.flatMap((item)=>item.status === 'removed' ? [] : [
            item.next
        ]);
    return items.flatMap((item)=>{
        if (item.status === 'matched') return [
            $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, item.next), {}, {
                x: (0, $3FiDp.interpolate)(item.prev.x, item.next.x, animationElapsedTime),
                y: (0, $3FiDp.interpolate)(item.prev.y, item.next.y, animationElapsedTime)
            })
        ];
        if (item.status === 'added') /*
       * Here we just return the final position without interpolating
       * so that we can allow the default initial animation that is done by clipPath in AreaRevealShape.
       * If you want your own custom animations then you may want to interpolate this one as well.
       */ return [
            item.next
        ];
        // removed: drop
        return [];
    });
};
var $551fcf7b84a33486$export$c2f93abcbcbe507c = {
    activeDot: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    animationMatchBy: (0, $dujP6.matchByIndex),
    animationInterpolateFn: $551fcf7b84a33486$var$defaultAreaAnimateItems,
    connectNulls: false,
    dot: false,
    fill: '#3182bd',
    fillOpacity: 0.6,
    hide: false,
    isAnimationActive: 'auto',
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    type: 'linear',
    label: false,
    shape: (0, $479b463c9360c840$export$9e66d5566f671821),
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, $gKNgz.DefaultZIndexes).area
};
/**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ function $551fcf7b84a33486$var$getLegendItemColor(stroke, fill) {
    return stroke && stroke !== 'none' ? stroke : fill;
}
var $551fcf7b84a33486$var$computeLegendPayloadFromAreaData = (props)=>{
    var dataKey = props.dataKey, name = props.name, stroke = props.stroke, fill = props.fill, legendType = props.legendType, hide = props.hide;
    return [
        {
            inactive: hide,
            dataKey: dataKey,
            type: legendType,
            color: $551fcf7b84a33486$var$getLegendItemColor(stroke, fill),
            value: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            payload: props
        }
    ];
};
var $551fcf7b84a33486$var$SetAreaTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var dataKey = _ref.dataKey, data = _ref.data, stroke = _ref.stroke, strokeWidth = _ref.strokeWidth, fill = _ref.fill, name = _ref.name, hide = _ref.hide, unit = _ref.unit, formatter = _ref.formatter, tooltipType = _ref.tooltipType, id = _ref.id;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        getPosition: (0, $3FiDp.noop),
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: undefined,
            name: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: $551fcf7b84a33486$var$getLegendItemColor(stroke, fill),
            unit: unit,
            formatter: formatter,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $2C2Dz.SetTooltipEntrySettings), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
function $551fcf7b84a33486$var$AreaDotsWrapper(_ref2) {
    var clipPathId = _ref2.clipPathId, points = _ref2.points, props = _ref2.props;
    var needClip = props.needClip, dot = props.dot, dataKey = props.dataKey;
    var areaProps = (0, $4M6vj.svgPropertiesNoEvents)(props);
    return /*#__PURE__*/ $acw62.createElement((0, $9qtrE.Dots), {
        points: points,
        dot: dot,
        className: "recharts-area-dots",
        dotClassName: "recharts-area-dot",
        dataKey: dataKey,
        baseProps: areaProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function $551fcf7b84a33486$var$AreaLabelListProvider(_ref3) {
    var showLabels = _ref3.showLabels, children = _ref3.children, points = _ref3.points;
    var labelListEntries = points.map((point)=>{
        var _point$x, _point$y;
        var viewBox = {
            x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
            y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
            width: 0,
            lowerWidth: 0,
            upperWidth: 0,
            height: 0
        };
        return $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, viewBox), {}, {
            value: point.value,
            payload: point.payload,
            parentViewBox: undefined,
            viewBox: viewBox,
            fill: undefined
        });
    });
    return /*#__PURE__*/ $acw62.createElement((0, $bJtQU.CartesianLabelListContextProvider), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function $551fcf7b84a33486$var$StaticArea(_ref4) {
    var points = _ref4.points, baseLine = _ref4.baseLine, needClip = _ref4.needClip, clipPathId = _ref4.clipPathId, props = _ref4.props, animationElapsedTime = _ref4.animationElapsedTime, isAnimating = _ref4.isAnimating, isEntrance = _ref4.isEntrance;
    var layout = props.layout, type = props.type, stroke = props.stroke, connectNulls = props.connectNulls, isRange = props.isRange, shape = props.shape;
    var id = props.id, propsWithoutId = $551fcf7b84a33486$var$_objectWithoutProperties(props, $551fcf7b84a33486$var$_excluded);
    var propsWithEvents = (0, $lTk0V.svgPropertiesAndEvents)(propsWithoutId);
    var curveProps = $551fcf7b84a33486$var$_objectSpread($551fcf7b84a33486$var$_objectSpread({}, propsWithEvents), {}, {
        id: id,
        points: points,
        connectNulls: connectNulls,
        type: type,
        baseLine: baseLine,
        layout: layout,
        stroke: stroke,
        isRange: isRange,
        animationElapsedTime: animationElapsedTime,
        isAnimating: isAnimating,
        isEntrance: isEntrance
    });
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined
    }, /*#__PURE__*/ $acw62.createElement((0, $63Kel.Shape), {
        option: shape,
        DefaultShape: $551fcf7b84a33486$export$c2f93abcbcbe507c.shape,
        shapeProps: curveProps
    })), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaDotsWrapper, {
        points: points,
        props: propsWithoutId,
        clipPathId: clipPathId
    }));
}
function $551fcf7b84a33486$var$interpolateScalarBaseLine(baseLine, prevBaseLine, animationElapsedTime) {
    if ((0, $3FiDp.isNumber)(baseLine)) {
        var previousNumberBaseLine = (0, $3FiDp.isNumber)(prevBaseLine) ? prevBaseLine : undefined;
        return (0, $3FiDp.interpolate)(previousNumberBaseLine, baseLine, animationElapsedTime);
    }
    if ((0, $3FiDp.isNullish)(baseLine) || (0, $3FiDp.isNan)(baseLine)) {
        var _previousNumberBaseLine = (0, $3FiDp.isNumber)(prevBaseLine) ? prevBaseLine : undefined;
        return (0, $3FiDp.interpolate)(_previousNumberBaseLine, 0, animationElapsedTime);
    }
    return baseLine;
}
function $551fcf7b84a33486$var$AreaWithAnimation(_ref5) {
    var needClip = _ref5.needClip, clipPathId = _ref5.clipPathId, props = _ref5.props, previousPointsRef = _ref5.previousPointsRef, previousBaselineRef = _ref5.previousBaselineRef;
    var points = props.points, baseLine = props.baseLine, isAnimationActive = props.isAnimationActive, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, animationMatchBy = props.animationMatchBy, animationInterpolateFn = props.animationInterpolateFn;
    var animationInput = (0, $acw62.useMemo)(()=>({
            points: points,
            baseLine: baseLine
        }), [
        points,
        baseLine
    ]);
    var baseLineAnimationState = (0, $cdyCS.useAnimationStartSnapshot)(animationInput, previousBaselineRef);
    var layout = (0, $jHn5r.useCartesianChartLayout)();
    var _useAnimationCallback = (0, $eHwNv.useAnimationCallbacks)(props.onAnimationStart, props.onAnimationEnd), isAnimating = _useAnimationCallback.isAnimating, handleAnimationStart = _useAnimationCallback.handleAnimationStart, handleAnimationEnd = _useAnimationCallback.handleAnimationEnd;
    var prevBaseLine = baseLineAnimationState.startValue;
    if (layout == null) return null;
    var baseLineAnimationItems;
    if (Array.isArray(baseLine) && Array.isArray(prevBaseLine)) baseLineAnimationItems = (0, $dujP6.matchAnimationItems)(prevBaseLine, baseLine, animationMatchBy);
    else if (Array.isArray(baseLine)) baseLineAnimationItems = (0, $dujP6.matchAnimationItems)(null, baseLine, animationMatchBy);
    else baseLineAnimationItems = null;
    return /*#__PURE__*/ $acw62.createElement((0, $eHwNv.AnimatedItems), {
        animationInput: animationInput,
        animationIdPrefix: "recharts-area-",
        items: points,
        previousItemsRef: previousPointsRef,
        isAnimationActive: isAnimationActive,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        animationInterpolateFn: animationInterpolateFn,
        animationMatchBy: animationMatchBy,
        layout: layout
    }, (stepPoints, animationElapsedTime, isEntrance)=>{
        var stepBaseLine;
        if (animationElapsedTime === 1) stepBaseLine = baseLine;
        else if (Array.isArray(baseLine)) stepBaseLine = animationInterpolateFn(baseLineAnimationItems, animationElapsedTime, layout);
        else stepBaseLine = isEntrance ? baseLine : $551fcf7b84a33486$var$interpolateScalarBaseLine(baseLine, prevBaseLine, animationElapsedTime);
        baseLineAnimationState.syncStepValue(stepBaseLine, animationElapsedTime);
        return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaLabelListProvider, {
            showLabels: !isAnimating,
            points: points
        }, props.children, /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$StaticArea, {
            points: stepPoints,
            baseLine: stepBaseLine,
            needClip: needClip,
            clipPathId: clipPathId,
            props: props,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating || animationElapsedTime < 1,
            isEntrance: isEntrance
        }), /*#__PURE__*/ $acw62.createElement((0, $bJtQU.LabelListFromLabelProp), {
            label: props.label
        }));
    });
}
/*
 * This component decides if the area should be animated or not.
 * It also holds the state of the animation.
 */ function $551fcf7b84a33486$var$RenderArea(_ref6) {
    var needClip = _ref6.needClip, clipPathId = _ref6.clipPathId, props = _ref6.props;
    /*
   * These two must be refs, not state!
   * Because we want to store the most recent shape of the animation in case we have to interrupt the animation;
   * that happens when user initiates another animation before the current one finishes.
   *
   * If this was a useState, then every step in the animation would trigger a re-render.
   * So, useRef it is.
   */ var previousPointsRef = (0, $acw62.useRef)(null);
    var previousBaselineRef = (0, $acw62.useRef)();
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaWithAnimation, {
        needClip: needClip,
        clipPathId: clipPathId,
        props: props,
        previousPointsRef: previousPointsRef,
        previousBaselineRef: previousBaselineRef
    });
}
class $551fcf7b84a33486$var$AreaWithState extends (0, $acw62.PureComponent) {
    render() {
        var _this$props = this.props, hide = _this$props.hide, dot = _this$props.dot, points = _this$props.points, className = _this$props.className, top = _this$props.top, left = _this$props.left, needClip = _this$props.needClip, xAxisId = _this$props.xAxisId, yAxisId = _this$props.yAxisId, width = _this$props.width, height = _this$props.height, id = _this$props.id, baseLine = _this$props.baseLine, zIndex = _this$props.zIndex;
        if (hide) return null;
        var layerClass = (0, $9QePP.clsx)('recharts-area', className);
        var clipPathId = id;
        var _getRadiusAndStrokeWi = (0, $lT2y6.getRadiusAndStrokeWidthFromDot)(dot), r = _getRadiusAndStrokeWi.r, strokeWidth = _getRadiusAndStrokeWi.strokeWidth;
        var clipDot = (0, $02Ymo.isClipDot)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
            zIndex: zIndex
        }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            className: layerClass
        }, needClip && /*#__PURE__*/ $acw62.createElement("defs", null, /*#__PURE__*/ $acw62.createElement((0, $j0wOw.GraphicalItemClipPath), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ $acw62.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ $acw62.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$RenderArea, {
            needClip: needClip,
            clipPathId: clipPathId,
            props: this.props
        })), /*#__PURE__*/ $acw62.createElement((0, $CpNo3.ActivePoints), {
            points: points,
            mainColor: $551fcf7b84a33486$var$getLegendItemColor(this.props.stroke, this.props.fill),
            itemDataKey: this.props.dataKey,
            activeDot: this.props.activeDot,
            clipPath: activePointsClipPath
        }), this.props.isRange && Array.isArray(baseLine) && /*#__PURE__*/ $acw62.createElement((0, $CpNo3.ActivePoints), {
            points: baseLine,
            mainColor: $551fcf7b84a33486$var$getLegendItemColor(this.props.stroke, this.props.fill),
            itemDataKey: this.props.dataKey,
            activeDot: this.props.activeDot,
            clipPath: activePointsClipPath
        }));
    }
}
function $551fcf7b84a33486$var$AreaImpl(props) {
    var _useAppSelector;
    var activeDot = props.activeDot, animationBegin = props.animationBegin, animationDuration = props.animationDuration, animationEasing = props.animationEasing, connectNulls = props.connectNulls, dot = props.dot, fill = props.fill, fillOpacity = props.fillOpacity, hide = props.hide, isAnimationActive = props.isAnimationActive, legendType = props.legendType, stroke = props.stroke, xAxisId = props.xAxisId, yAxisId = props.yAxisId, everythingElse = $551fcf7b84a33486$var$_objectWithoutProperties(props, $551fcf7b84a33486$var$_excluded2);
    var layout = (0, $jHn5r.useChartLayout)();
    var chartName = (0, $72R3N.useChartName)();
    var _useNeedsClip = (0, $j0wOw.useNeedsClip)(xAxisId, yAxisId), needClip = _useNeedsClip.needClip;
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    var _ref7 = (_useAppSelector = (0, $bqlEl.useAppSelector)((state)=>(0, $5fbeae2880aa4f3e$export$5f2090c2af7a0678)(state, props.id, isPanorama))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {}, points = _ref7.points, isRange = _ref7.isRange, baseLine = _ref7.baseLine;
    var plotArea = (0, $5IafS.usePlotArea)();
    if (layout !== 'horizontal' && layout !== 'vertical' || plotArea == null) // Can't render Area in an unsupported layout
    return null;
    if (chartName !== 'AreaChart' && chartName !== 'ComposedChart') // There is nothing stopping us from rendering Area in other charts, except for historical reasons. Do we want to allow that?
    return null;
    var height = plotArea.height, width = plotArea.width, left = plotArea.x, top = plotArea.y;
    if (!points || !points.length) return null;
    return /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaWithState, $551fcf7b84a33486$var$_extends({}, everythingElse, {
        activeDot: activeDot,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        baseLine: baseLine,
        connectNulls: connectNulls,
        dot: dot,
        fill: fill,
        fillOpacity: fillOpacity,
        height: height,
        hide: hide,
        layout: layout,
        isAnimationActive: isAnimationActive,
        isRange: isRange,
        legendType: legendType,
        needClip: needClip,
        points: points,
        stroke: stroke,
        width: width,
        left: left,
        top: top,
        xAxisId: xAxisId,
        yAxisId: yAxisId
    }));
}
var $551fcf7b84a33486$export$82ef48a36e8cf480 = (layout, chartBaseValue, itemBaseValue, xAxis, yAxis)=>{
    // The baseValue can be defined both on the AreaChart, and on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $3FiDp.isNumber)(baseValue)) return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    // @ts-expect-error d3scale .domain() returns unknown, Math.max expects number
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
};
function $551fcf7b84a33486$export$bb0068e0a912aef6(_ref8) {
    var _ref8$areaSettings = _ref8.areaSettings, connectNulls = _ref8$areaSettings.connectNulls, itemBaseValue = _ref8$areaSettings.baseValue, dataKey = _ref8$areaSettings.dataKey, stackedData = _ref8.stackedData, layout = _ref8.layout, chartBaseValue = _ref8.chartBaseValue, xAxis = _ref8.xAxis, yAxis = _ref8.yAxis, displayedData = _ref8.displayedData, dataStartIndex = _ref8.dataStartIndex, xAxisTicks = _ref8.xAxisTicks, yAxisTicks = _ref8.yAxisTicks, bandSize = _ref8.bandSize, stackDataKeys = _ref8.stackDataKeys;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $551fcf7b84a33486$export$82ef48a36e8cf480(layout, chartBaseValue, itemBaseValue, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map((entry, index)=>{
        var _valueAsArray$, _valueAsArray, _xAxis$scale$map;
        var valueAsArray;
        if (hasStack) valueAsArray = stackedData[dataStartIndex + index];
        else {
            var _rawValue = (0, $hBeJX.getValueByDataKey)(entry, dataKey);
            if (!Array.isArray(_rawValue)) valueAsArray = [
                baseValue,
                _rawValue
            ];
            else {
                valueAsArray = _rawValue;
                isRange = true;
            }
        }
        var value1 = (_valueAsArray$ = (_valueAsArray = valueAsArray) === null || _valueAsArray === void 0 ? void 0 : _valueAsArray[1]) !== null && _valueAsArray$ !== void 0 ? _valueAsArray$ : null;
        var rawValue = (0, $hBeJX.getValueByDataKey)(entry, dataKey);
        /*
     * A null in one series of a stack is rendered as zero contribution so the series above keep their offsets.
     * When every series in the stack is null, there is no offset to preserve,
     * so the point is a gap that connectNulls is allowed to connect across.
     */ var wholeStackIsNull = hasStack && rawValue == null && stackDataKeys != null && stackDataKeys.length > 0 && stackDataKeys.every((key)=>(0, $hBeJX.getValueByDataKey)(entry, key) == null);
        var isBreakPoint = value1 == null || hasStack && !connectNulls && rawValue == null || wholeStackIsNull;
        if (isHorizontalLayout) {
            var _yAxis$scale$map;
            return {
                x: (0, $hBeJX.getCateCoordinateOfLine)({
                    axis: xAxis,
                    ticks: xAxisTicks,
                    bandSize: bandSize,
                    entry: entry,
                    index: index
                }),
                y: isBreakPoint ? null : (_yAxis$scale$map = yAxis.scale.map(value1)) !== null && _yAxis$scale$map !== void 0 ? _yAxis$scale$map : null,
                value: valueAsArray,
                payload: entry
            };
        }
        return {
            x: isBreakPoint ? null : (_xAxis$scale$map = xAxis.scale.map(value1)) !== null && _xAxis$scale$map !== void 0 ? _xAxis$scale$map : null,
            y: (0, $hBeJX.getCateCoordinateOfLine)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: valueAsArray,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map((entry)=>{
        var _xAxis$scale$map2;
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) {
            var _yAxis$scale$map2;
            return {
                x: entry.x,
                y: x != null && entry.y != null ? (_yAxis$scale$map2 = yAxis.scale.map(x)) !== null && _yAxis$scale$map2 !== void 0 ? _yAxis$scale$map2 : null : null,
                payload: entry.payload
            };
        }
        return {
            x: x != null ? (_xAxis$scale$map2 = xAxis.scale.map(x)) !== null && _xAxis$scale$map2 !== void 0 ? _xAxis$scale$map2 : null : null,
            y: entry.y,
            payload: entry.payload
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale.map(baseValue) : xAxis.scale.map(baseValue);
    return {
        points: points,
        baseLine: baseLine !== null && baseLine !== void 0 ? baseLine : 0,
        isRange: isRange
    };
}
function $551fcf7b84a33486$var$AreaFn(outsideProps) {
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $551fcf7b84a33486$export$c2f93abcbcbe507c);
    var isPanorama = (0, $3X9hg.useIsPanorama)();
    // Report all props to Redux store first, before calling hooks, to avoid circular dependencies.
    return /*#__PURE__*/ $acw62.createElement((0, $jhZFb.RegisterGraphicalItemId), {
        id: props.id,
        type: "area"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $ckb0X.SetLegendPayload), {
            legendPayload: $551fcf7b84a33486$var$computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$SetAreaTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            formatter: props.formatter,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ $acw62.createElement((0, $aPPc1.SetCartesianGraphicalItem), {
            type: "area",
            id: id,
            data: props.data,
            dataKey: props.dataKey,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            stackId: (0, $hBeJX.getNormalizedStackId)(props.stackId),
            hide: props.hide,
            barSize: undefined,
            baseValue: props.baseValue,
            isPanorama: isPanorama,
            connectNulls: props.connectNulls
        }), /*#__PURE__*/ $acw62.createElement($551fcf7b84a33486$var$AreaImpl, $551fcf7b84a33486$var$_extends({}, props, {
            id: id
        }))));
}
var $551fcf7b84a33486$export$ea1a111407f37557 = /*#__PURE__*/ $acw62.memo($551fcf7b84a33486$var$AreaFn, (0, $biEKl.propsAreEqual));
// @ts-expect-error we need to set the displayName for debugging purposes
$551fcf7b84a33486$export$ea1a111407f37557.displayName = 'Area';


var $acw62 = parcelRequire("acw62");

var $bIbT7 = parcelRequire("bIbT7");

var $fC5w9 = parcelRequire("fC5w9");
var $40df630ec903a4ea$var$allowedTooltipTypes = [
    'axis'
];
var $40df630ec903a4ea$export$f510429275d6f1a8 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $fC5w9.CartesianChart), {
        chartName: "AreaChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $40df630ec903a4ea$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $bIbT7.arrayTooltipSearcher),
        categoricalChartProps: props,
        ref: ref
    });
});


var $kan35 = parcelRequire("kan35");
var $4jZOw = parcelRequire("4jZOw");
var $kMGAE = parcelRequire("kMGAE");
var $1dtDd = parcelRequire("1dtDd");


var $iD7Z3 = parcelRequire("iD7Z3");

var $2u93q = parcelRequire("2u93q");



const $b0583ad0380750d4$export$fb40769ec36ea484 = ({ data: data, mode: mode, unit: unit, yAxisDomain: yAxisDomain, yAxisTickFormatter: yAxisTickFormatter, mobile: mobile, formatNumber: formatNumber, variant: variant, variableId: variableId, getSubStatsLabel: getSubStatsLabel })=>{
    const stacked = variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked && data.subStatsKeys.length;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $40df630ec903a4ea$export$f510429275d6f1a8), {
        data: data.sortedData,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kan35.CartesianGrid), {
                strokeWidth: 0.25,
                stroke: (0, $iD7Z3.colors).darkBlue,
                strokeOpacity: 0.4,
                vertical: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMGAE.XAxis), {
                dataKey: "at",
                style: {
                    fontFamily: $2u93q.fontFamily,
                    color: (0, $iD7Z3.colors).darkBlue,
                    top: 20,
                    transform: 'translateY(8px)'
                },
                type: "number",
                scale: "time",
                domain: [
                    'dataMin',
                    'dataMax'
                ],
                axisLine: false,
                tickLine: false,
                interval: $b0583ad0380750d4$var$getTicksInterval(mode, data.sortedData),
                minTickGap: 30,
                tickFormatter: yAxisTickFormatter
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                width: $b0583ad0380750d4$var$getYAxisWidth(mobile, data.yAxisDomainMax || Math.max(...data.sortedData.map((d)=>d.value))),
                style: {
                    fontFamily: $2u93q.fontFamily,
                    color: (0, $iD7Z3.colors).darkBlue,
                    transform: 'translateX(-6px)'
                },
                axisLine: false,
                tickLine: false,
                tickFormatter: (value)=>{
                    const fractionDigits = unit === (0, $28b4cee73700460a$export$21eef29f47e43a9d).Kilowatt ? 1 : 0;
                    return formatNumber(value, {
                        minimumFractionDigits: fractionDigits,
                        maximumFractionDigits: fractionDigits
                    });
                },
                domain: yAxisDomain
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4jZOw.Tooltip), {
                content: // eslint-disable-next-line
                // @ts-ignore
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a50ccb595f2a6ce$export$9f95857259638e76), {
                    mode: mode,
                    unit: unit,
                    variant: variant,
                    variableId: variableId,
                    getSubStatsLabel: getSubStatsLabel
                })
            }),
            !stacked && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                dataKey: "value",
                name: "kW",
                fill: `${(0, $iD7Z3.colors).primary}33`,
                stroke: (0, $iD7Z3.colors).primary
            }),
            stacked && data.subStatsKeys.map((key, index)=>{
                const color = (0, $17d0a4576b439e8f$export$54ae311e84eed980)(index, data.subStatsKeys.length);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                    dataKey: `subStats.${key}`,
                    name: "kW",
                    stackId: "1",
                    fill: `${color}`,
                    stroke: color
                }, key);
            })
        ]
    });
};
const $b0583ad0380750d4$var$getYAxisWidth = (mobile, maxValue)=>{
    if (mobile) return maxValue > 8 ? 35 : 25;
    else return maxValue > 10 ? 45 : 35;
};
const $b0583ad0380750d4$var$getTicksInterval = (mode, sortedData)=>{
    if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day) return undefined;
    else if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week) return Math.round(sortedData.length / 7);
    else if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year) return undefined;
    return undefined;
};


const $1e060f302d532f11$export$2d8b3daa6660c458 = ({ variableId: variableId, variableSuffix: variableSuffix, yAxisDomainEndFrom: yAxisDomainEndFrom, getSubStatsLabel: getSubStatsLabel, groupSubStatsByInverter: groupSubStatsByInverter, visibility: visibility, initialVariant: initialVariant, options: propsOptions })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const { filters: filters, footer: footer, ...options } = (0, $9b560528a5f99400$export$163daf3316c6aaf8)({
        variableId: variableId,
        parent: false,
        initialVariant: initialVariant
    });
    const { mode: mode, from: from, to: to, variant: variant } = (0, $acw62.useMemo)(()=>{
        return propsOptions ?? options;
    }, [
        options,
        propsOptions
    ]);
    const { formatDate: formatDate, formatTime: formatTime } = (0, $202BL.default)();
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const { unit: unit } = (0, $28b4cee73700460a$export$4a74961a3c9c97af)[variableId];
    const mobile = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(({ breakpoints: breakpoints })=>breakpoints.down('sm'));
    const visible = (0, $bCDrB.useVisibility)(visibility);
    let aggregate = (0, $9b560528a5f99400$export$b9601df20779e14a).Disabled;
    if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year) aggregate = (0, $9b560528a5f99400$export$b9601df20779e14a).Hour;
    if ([
        (0, $9b560528a5f99400$export$585dc7a4228aacca).Bar,
        (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked
    ].includes(variant)) {
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day) aggregate = (0, $9b560528a5f99400$export$b9601df20779e14a).Hour;
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week) aggregate = (0, $9b560528a5f99400$export$b9601df20779e14a).Day;
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year) aggregate = (0, $9b560528a5f99400$export$b9601df20779e14a).Month;
    }
    const { data: rawData, isLoading: isLoading, isError: isError, error: error } = (0, $iH29s.trpc).getStats.useQuery({
        variableId: variableId,
        variableSuffix: variableSuffix,
        aggregate: aggregate,
        yAxisDomainEndFrom: yAxisDomainEndFrom,
        from: from.toISOString(),
        to: to.toISOString(),
        includeSubStats: [
            (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked,
            (0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked
        ].includes(variant)
    }, {
        enabled: visible,
        networkMode: 'always'
    });
    const data = (0, $acw62.useMemo)(()=>{
        if (!rawData || !groupSubStatsByInverter) return rawData;
        const subStatsKeys = (0, $f1q41.uniq)(rawData.subStatsKeys.map($1e060f302d532f11$var$stripStringIndex));
        const sortedData = rawData.sortedData.map((point)=>({
                ...point,
                subStats: Object.entries(point.subStats).reduce((acc, [key, value])=>{
                    const grouped = $1e060f302d532f11$var$stripStringIndex(key);
                    acc[grouped] = (acc[grouped] ?? 0) + (value ?? 0);
                    return acc;
                }, {})
            }));
        return {
            ...rawData,
            subStatsKeys: subStatsKeys,
            sortedData: sortedData
        };
    }, [
        rawData,
        groupSubStatsByInverter
    ]);
    const yAxisDomain = (0, $acw62.useMemo)(()=>{
        let min = 'auto';
        let max = typeof data?.yAxisDomainMax === 'number' ? data?.yAxisDomainMax : 'auto';
        if (unit === (0, $28b4cee73700460a$export$21eef29f47e43a9d).Percent) {
            min = 0;
            max = 100;
        }
        return [
            min,
            max
        ];
    }, [
        data,
        unit
    ]);
    const yAxisTickFormatter = (at)=>{
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Day) return formatTime(new Date(at));
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Week) return formatDate(new Date(at), {
            weekday: 'short'
        });
        if (mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year) return formatDate(new Date(at), {
            month: 'short'
        });
        return '';
    };
    const maxValue = (0, $acw62.useMemo)(()=>{
        if (yAxisDomain && typeof yAxisDomain[1] === 'number') return yAxisDomain[1];
        else if (data) return Math.max(...data.sortedData.map((item)=>item.value));
        return undefined;
    }, [
        data,
        yAxisDomain
    ]);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        sx: {
            p: 0,
            pt: 2,
            width: '100%',
            position: 'relative'
        },
        children: [
            !propsOptions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    pb: 2,
                    px: 2
                },
                children: filters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    pt: 0,
                    pb: 2,
                    px: 2,
                    height: 340,
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $mjyu0.ResponsiveContainer), {
                    width: "100%",
                    height: "100%",
                    children: data && (variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).Line || variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked) ? (0, $b0583ad0380750d4$export$fb40769ec36ea484)({
                        data: data,
                        mode: mode,
                        unit: unit,
                        yAxisDomain: yAxisDomain,
                        yAxisTickFormatter: yAxisTickFormatter,
                        mobile: mobile,
                        formatNumber: formatNumber,
                        maxValue: maxValue,
                        variant: variant,
                        variableId: variableId,
                        getSubStatsLabel: getSubStatsLabel
                    }) : data && (variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).Bar || variant === (0, $9b560528a5f99400$export$585dc7a4228aacca).BarStacked) ? (0, $b30f16719474c4de$export$99199eb0d2d4ab39)({
                        data: data,
                        mode: mode,
                        unit: unit,
                        yAxisDomain: yAxisDomain,
                        yAxisTickFormatter: yAxisTickFormatter,
                        mobile: mobile,
                        formatNumber: formatNumber,
                        maxValue: maxValue,
                        variant: variant,
                        variableId: variableId,
                        getSubStatsLabel: getSubStatsLabel
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                sx: {
                    pb: 1.5,
                    px: 2
                },
                children: [
                    !propsOptions && footer,
                    typeof data?.summary === 'number' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body2",
                        sx: {
                            ml: 'auto',
                            textAlign: 'right'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "charts.summary.value",
                            defaultMessage: "Celkem {value}",
                            values: {
                                value: formatNumber(mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? data.summary / 1000 : data.summary, {
                                    style: 'unit',
                                    unit: mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? 'megawatt-hour' : 'kilowatt-hour',
                                    maximumFractionDigits: mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? 2 : 1,
                                    minimumFractionDigits: mode === (0, $9b560528a5f99400$export$9484bbecc3c49a2e).Year ? 2 : 1
                                })
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: isLoading || isError ? 'flex' : 'none',
                    justifyContent: 'center',
                    alignItems: 'center',
                    pointerEvents: isLoading ? 'none' : 'auto'
                },
                onClick: ()=>{
                    if (isError) confirm({
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "charts.error.dialog.title",
                            defaultMessage: "P\u0159i na\u010D\xedt\xe1n\xed statistik do\u0161lo k chyb\u011B"
                        }),
                        description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                                children: JSON.stringify(error)
                            })
                        })
                    });
                },
                children: [
                    isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                        size: 22,
                        sx: {
                            animationDuration: '850ms',
                            display: 'block'
                        }
                    }),
                    isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0885121e8393a5b8$export$2e2bcd8739ae039), {
                        sx: {
                            fontSize: 22,
                            color: 'warning.main'
                        }
                    })
                ]
            })
        ]
    });
};
const $1e060f302d532f11$var$stripStringIndex = (key)=>{
    const lastDash = key.lastIndexOf('-');
    return lastDash === -1 ? key : key.slice(0, lastDash);
};







parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");

var $7X4mk = parcelRequire("7X4mk");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ko6Bk = parcelRequire("ko6Bk");
var $2PduQ = parcelRequire("2PduQ");
var $cDXfy = parcelRequire("cDXfy");

var $1sDFO = parcelRequire("1sDFO");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $9D07P = parcelRequire("9D07P");

var $8Indx = parcelRequire("8Indx");

var $9D07P = parcelRequire("9D07P");
'use client';
function $3932ee7923050386$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $9D07P.default)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $3932ee7923050386$export$2e2bcd8739ae039 = $3932ee7923050386$var$useBadge;



var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $2nO41 = parcelRequire("2nO41");

var $3AM7p = parcelRequire("3AM7p");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9030a949247111b3$export$aaccef17e6dab084(slot) {
    return (0, $4Cod0.default)('MuiBadge', slot);
}
const $9030a949247111b3$var$badgeClasses = (0, $beCSm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $9030a949247111b3$export$2e2bcd8739ae039 = $9030a949247111b3$var$badgeClasses;



var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f18835d59a9187d7$var$RADIUS_STANDARD = 10;
const $f18835d59a9187d7$var$RADIUS_DOT = 4;
const $f18835d59a9187d7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $3AM7p.default)(anchorOrigin.vertical)}${(0, $3AM7p.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $3AM7p.default)(anchorOrigin.vertical)}${(0, $3AM7p.default)(anchorOrigin.horizontal)}${(0, $3AM7p.default)(overlap)}`,
            `overlap${(0, $3AM7p.default)(overlap)}`,
            color !== 'default' && `color${(0, $3AM7p.default)(color)}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9030a949247111b3$export$aaccef17e6dab084), classes);
};
const $f18835d59a9187d7$var$BadgeRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $f18835d59a9187d7$var$BadgeBadge = (0, $1Ikg4.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $3AM7p.default)(ownerState.anchorOrigin.vertical)}${(0, $3AM7p.default)(ownerState.anchorOrigin.horizontal)}${(0, $3AM7p.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $3AM7p.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $f18835d59a9187d7$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $f18835d59a9187d7$var$RADIUS_STANDARD * 2,
        borderRadius: $f18835d59a9187d7$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $f18835d59a9187d7$var$RADIUS_DOT,
                    height: $f18835d59a9187d7$var$RADIUS_DOT * 2,
                    minWidth: $f18835d59a9187d7$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $f18835d59a9187d7$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $f18835d59a9187d7$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $3932ee7923050386$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $9D07P.default)({
        anchorOrigin: $f18835d59a9187d7$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $f18835d59a9187d7$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $f18835d59a9187d7$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $3fDLr.default)('root', {
        elementType: $f18835d59a9187d7$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $3fDLr.default)('badge', {
        elementType: $f18835d59a9187d7$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $ayMG0.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $f18835d59a9187d7$export$2e2bcd8739ae039 = $f18835d59a9187d7$var$Badge;


var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $1DAbm = parcelRequire("1DAbm");
var $js9Z9 = parcelRequire("js9Z9");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $4WLS9 = parcelRequire("4WLS9");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $5R532 = parcelRequire("5R532");

var $5BFw5 = parcelRequire("5BFw5");

var $iH29s = parcelRequire("iH29s");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $12gtR = parcelRequire("12gtR");

var $iH29s = parcelRequire("iH29s");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $f41233e5822e318b$export$99442c433de1441d = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 14 16",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9.66667 4.00004V3.46671C9.66667 2.71997 9.66667 2.3466 9.52134 2.06139C9.39351 1.8105 9.18954 1.60653 8.93865 1.4787C8.65344 1.33337 8.28007 1.33337 7.53333 1.33337H6.46667C5.71993 1.33337 5.34656 1.33337 5.06135 1.4787C4.81046 1.60653 4.60649 1.8105 4.47866 2.06139C4.33333 2.3466 4.33333 2.71997 4.33333 3.46671V4.00004M5.66667 7.66671V11M8.33333 7.66671V11M1 4.00004H13M11.6667 4.00004V11.4667C11.6667 12.5868 11.6667 13.1469 11.4487 13.5747C11.2569 13.951 10.951 14.257 10.5746 14.4487C10.1468 14.6667 9.58677 14.6667 8.46667 14.6667H5.53333C4.41323 14.6667 3.85318 14.6667 3.42535 14.4487C3.04903 14.257 2.74307 13.951 2.55132 13.5747C2.33333 13.1469 2.33333 12.5868 2.33333 11.4667V4.00004",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
$f41233e5822e318b$export$99442c433de1441d.displayName = 'Trash';



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $7X4mk = parcelRequire("7X4mk");

var $8AHLd = parcelRequire("8AHLd");
const $7f9b96df6ca0fa51$export$1e9a830f8372be05 = ({ schedule: schedule })=>{
    const { startAt: startAt, endAt: endAt, processed: processed, missed: missed } = schedule;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                sx: {
                    color: 'text.disabled'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                        value: startAt,
                        day: "numeric",
                        month: "short"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                        value: startAt
                    }),
                    " -",
                    ' ',
                    (0, $8AHLd.isSameDay)(new Date(startAt), new Date(endAt)) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                        value: endAt
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                                value: endAt,
                                day: "numeric",
                                month: "short"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                                value: endAt
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                sx: {
                    my: 0.25,
                    fontWeight: !processed && !missed ? 600 : undefined
                },
                children: [
                    schedule.type === 'battery-charge' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.battery_charge",
                        defaultMessage: "Nab\xedjen\xed baterie"
                    }),
                    schedule.type === 'battery-discharge' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.battery_discharge",
                        defaultMessage: "Vyb\xedjen\xed baterie"
                    }),
                    schedule.type === 'ev-charging' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.ev_charging",
                        defaultMessage: "Nab\xedjen\xed elektromobilu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                sx: {
                    color: 'text.disabled'
                },
                children: [
                    'targetSoc' in schedule && typeof schedule.targetSoc === 'number' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.target_soc",
                        defaultMessage: "C\xedlov\xe9 SOC: {targetSoc, number, percent}",
                        values: {
                            targetSoc: schedule.targetSoc / 100
                        }
                    }),
                    'chargingCurrent' in schedule && typeof schedule.chargingCurrent === 'number' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.charging_current",
                        defaultMessage: "Nab\xedjec\xed proud: {chargingCurrent} A",
                        values: {
                            chargingCurrent: schedule.chargingCurrent
                        }
                    })
                ]
            })
        ]
    });
};



const $ae059e450a971e93$export$77f55fb30b17425a = ({ schedule: schedule })=>{
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const utils = (0, $iH29s.trpc).useContext();
    const { mutate: remove } = (0, $iH29s.trpc).schedules.remove.useMutation({
        onSuccess: ()=>{
            utils.schedules.list.invalidate();
            setDialogOpen(false);
        },
        onError () {
            alert('Chyba');
        }
    });
    // Set on every occurrence of a series, whether or not it has materialized yet.
    const { parentId: parentId } = schedule;
    const handleRemoveOccurrence = ()=>{
        if (!parentId) return;
        remove({
            id: parentId,
            occurrenceAt: schedule.startAt
        });
    };
    const handleRemoveSeries = ()=>{
        if (!parentId) return;
        remove({
            id: parentId
        });
    };
    const handleRemove = ()=>{
        remove({
            id: schedule.id
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                title: "Smazat",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    onClick: ()=>setDialogOpen(true),
                    size: "small",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f41233e5822e318b$export$99442c433de1441d), {
                        sx: {
                            fontSize: '0.875rem'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
                open: dialogOpen,
                onClose: ()=>setDialogOpen(false),
                maxWidth: "xs",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                        onClose: ()=>setDialogOpen(false)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6hSWk.default), {
                        sx: {
                            textAlign: 'center',
                            mb: 1
                        },
                        typography: "h3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f41233e5822e318b$export$99442c433de1441d), {
                                sx: {
                                    color: 'primary.main',
                                    fontSize: '1.5rem'
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            parentId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.remove.recurring.title",
                                defaultMessage: "Smazat opakuj\xedc\xed se pl\xe1n"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.remove.confirm",
                                defaultMessage: "Opravdu chcete pl\xe1n smazat?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f9b96df6ca0fa51$export$1e9a830f8372be05), {
                                schedule: schedule
                            })
                        })
                    }),
                    parentId ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                        sx: {
                            px: 3,
                            pb: 3,
                            flexDirection: 'column',
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: handleRemoveOccurrence,
                                variant: "contained",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.remove.recurring.instance",
                                    defaultMessage: "Smazat pouze tento v\xfdskyt"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: handleRemoveSeries,
                                variant: "outlined",
                                fullWidth: true,
                                sx: {
                                    ml: '0 !important'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.remove.recurring.series",
                                    defaultMessage: "Smazat celou s\xe9rii"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: ()=>setDialogOpen(false),
                                variant: "outlined",
                                fullWidth: true,
                                sx: {
                                    ml: '0 !important'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.remove.no",
                                    defaultMessage: "Zru\u0161it"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                        sx: {
                            px: 3,
                            pb: 3,
                            flexDirection: 'row'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: ()=>setDialogOpen(false),
                                variant: "outlined",
                                fullWidth: true,
                                sx: {
                                    ml: '0 !important'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.remove.no",
                                    defaultMessage: "Zru\u0161it"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: handleRemove,
                                variant: "contained",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.remove.yes",
                                    defaultMessage: "Smazat"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $9Jots = parcelRequire("9Jots");

function $35c109f63bf894ff$export$3c826ac3ab9da76c(date, options) {
    const _date = (0, $9Jots.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getDate(), 2);
        const month = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getMonth() + 1, 2);
        const year = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getHours(), 2);
        const minute = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getMinutes(), 2);
        const second = (0, $3f6840376f7c8255$export$c8306e720e213c0f)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}
var // Fallback for modularized imports:
$35c109f63bf894ff$export$2e2bcd8739ae039 = $35c109f63bf894ff$export$3c826ac3ab9da76c;


function $b2d0c66f58a40ae9$export$4393d2ccbbedb219(argument, options) {
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $b2d0c66f58a40ae9$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $b2d0c66f58a40ae9$var$parseYear(dateStrings.date, additionalDigits);
        date = $b2d0c66f58a40ae9$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    const timestamp = date.getTime();
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $b2d0c66f58a40ae9$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b2d0c66f58a40ae9$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        const dirtyDate = new Date(timestamp + time);
        // JS parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        const result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
const $b2d0c66f58a40ae9$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $b2d0c66f58a40ae9$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $b2d0c66f58a40ae9$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $b2d0c66f58a40ae9$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b2d0c66f58a40ae9$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($b2d0c66f58a40ae9$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b2d0c66f58a40ae9$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $b2d0c66f58a40ae9$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b2d0c66f58a40ae9$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b2d0c66f58a40ae9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($b2d0c66f58a40ae9$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $b2d0c66f58a40ae9$var$parseDateUnit(captures[1]);
    const month = $b2d0c66f58a40ae9$var$parseDateUnit(captures[2]) - 1;
    const day = $b2d0c66f58a40ae9$var$parseDateUnit(captures[3]);
    const week = $b2d0c66f58a40ae9$var$parseDateUnit(captures[4]);
    const dayOfWeek = $b2d0c66f58a40ae9$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b2d0c66f58a40ae9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b2d0c66f58a40ae9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$b2d0c66f58a40ae9$var$validateDate(year, month, day) || !$b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b2d0c66f58a40ae9$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b2d0c66f58a40ae9$var$parseTime(timeString) {
    const captures = timeString.match($b2d0c66f58a40ae9$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[1]);
    const minutes = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[2]);
    const seconds = $b2d0c66f58a40ae9$var$parseTimeUnit(captures[3]);
    if (!$b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff) + seconds * 1000;
}
function $b2d0c66f58a40ae9$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $b2d0c66f58a40ae9$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($b2d0c66f58a40ae9$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b2d0c66f58a40ae9$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $e24aa25ccaa7cb1c$export$7f72910d6dfd237a) + minutes * (0, $e24aa25ccaa7cb1c$export$91246f0b9bd9beff));
}
function $b2d0c66f58a40ae9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $b2d0c66f58a40ae9$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b2d0c66f58a40ae9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b2d0c66f58a40ae9$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b2d0c66f58a40ae9$var$daysInMonths[month] || ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b2d0c66f58a40ae9$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b2d0c66f58a40ae9$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b2d0c66f58a40ae9$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b2d0c66f58a40ae9$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b2d0c66f58a40ae9$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$b2d0c66f58a40ae9$export$2e2bcd8739ae039 = $b2d0c66f58a40ae9$export$4393d2ccbbedb219;


function $b688cddfaeda0d8b$export$88436b756d94fab0(string) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(string)) return false;
    return (0, $ae5dedc3e6bc7894$export$1ea939691cdc45b8)((0, $b2d0c66f58a40ae9$export$4393d2ccbbedb219)(string));
}
function $b688cddfaeda0d8b$export$ea0a2d2ae29ba628(dateString) {
    if ($b688cddfaeda0d8b$export$88436b756d94fab0(dateString)) return dateString;
    throw new Error(`Invalid date ${dateString}`);
}
function $b688cddfaeda0d8b$export$1b417f4da593d319(date) {
    return (0, $35c109f63bf894ff$export$3c826ac3ab9da76c)(date, {
        representation: 'date'
    });
}
function $b688cddfaeda0d8b$export$37c1a059f405f87d() {
    return $b688cddfaeda0d8b$export$1b417f4da593d319(new Date());
}
function $b688cddfaeda0d8b$export$52508f29c3afdd33(string) {
    return (0, $b2d0c66f58a40ae9$export$4393d2ccbbedb219)(string);
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1sDFO = parcelRequire("1sDFO");
var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $91vj1 = parcelRequire("91vj1");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $js9Z9 = parcelRequire("js9Z9");
var $fNkZ4 = parcelRequire("fNkZ4");
var $5WsCn = parcelRequire("5WsCn");
var $ngrp2 = parcelRequire("ngrp2");
var $jrrQL = parcelRequire("jrrQL");
var $7X4mk = parcelRequire("7X4mk");

var $22i8b = parcelRequire("22i8b");
/* !
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 * Based on:
 * python-dateutil - Extensions to the standard Python datetime module.
 * Copyright (c) 2003-2011 - Gustavo Niemeyer <gustavo@niemeyer.net>
 * Copyright (c) 2012 - Tomi Pieviläinen <tomi.pievilainen@iki.fi>
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */ // =============================================================================
// Helper functions
// =============================================================================
// =============================================================================
// Weekday
// =============================================================================
var $47606afb7b57d36f$export$f1b46dc0618b220c = [
    'MO',
    'TU',
    'WE',
    'TH',
    'FR',
    'SA',
    'SU'
];
var $47606afb7b57d36f$export$94dd8a9f089c7f53 = /** @class */ function() {
    function Weekday(weekday, n) {
        if (n === 0) throw new Error("Can't create weekday with n == 0");
        this.weekday = weekday;
        this.n = n;
    }
    Weekday.fromStr = function(str) {
        return new Weekday($47606afb7b57d36f$export$f1b46dc0618b220c.indexOf(str));
    };
    // __call__ - Cannot call the object directly, do it through
    // e.g. RRule.TH.nth(-1) instead,
    Weekday.prototype.nth = function(n) {
        return this.n === n ? this : new Weekday(this.weekday, n);
    };
    // __eq__
    Weekday.prototype.equals = function(other) {
        return this.weekday === other.weekday && this.n === other.n;
    };
    // __repr__
    Weekday.prototype.toString = function() {
        var s = $47606afb7b57d36f$export$f1b46dc0618b220c[this.weekday];
        if (this.n) s = (this.n > 0 ? '+' : '') + String(this.n) + s;
        return s;
    };
    Weekday.prototype.getJsWeekday = function() {
        return this.weekday === 6 ? 0 : this.weekday + 1;
    };
    return Weekday;
}();


var $89dc652caabae9cf$export$ee27c052bca048fb = function(value) {
    return value !== null && value !== undefined;
};
var $89dc652caabae9cf$export$7e4aa119212bc614 = function(value) {
    return typeof value === 'number';
};
var $89dc652caabae9cf$export$f9326dee76b2106d = function(value) {
    return typeof value === 'string' && (0, $47606afb7b57d36f$export$f1b46dc0618b220c).includes(value);
};
var $89dc652caabae9cf$export$43bee75e5e14138e = Array.isArray;
var $89dc652caabae9cf$export$d02631cccf789723 = function(start, end) {
    if (end === void 0) end = start;
    if (arguments.length === 1) {
        end = start;
        start = 0;
    }
    var rang = [];
    for(var i = start; i < end; i++)rang.push(i);
    return rang;
};
var $89dc652caabae9cf$export$9cd59f9826255e47 = function(array) {
    return [].concat(array);
};
var $89dc652caabae9cf$export$76d90c956114f2c2 = function(value, times) {
    var i = 0;
    var array = [];
    if ($89dc652caabae9cf$export$43bee75e5e14138e(value)) for(; i < times; i++)array[i] = [].concat(value);
    else for(; i < times; i++)array[i] = value;
    return array;
};
var $89dc652caabae9cf$export$45b10814cc054894 = function(item) {
    if ($89dc652caabae9cf$export$43bee75e5e14138e(item)) return item;
    return [
        item
    ];
};
function $89dc652caabae9cf$export$36cf564d487b5178(item, targetLength, padString) {
    if (padString === void 0) padString = ' ';
    var str = String(item);
    targetLength = targetLength >> 0;
    if (str.length > targetLength) return String(str);
    targetLength = targetLength - str.length;
    if (targetLength > padString.length) padString += $89dc652caabae9cf$export$76d90c956114f2c2(padString, targetLength / padString.length);
    return padString.slice(0, targetLength) + String(str);
}
var $89dc652caabae9cf$export$65980d18b75784e2 = function(str, sep, num) {
    var splits = str.split(sep);
    return num ? splits.slice(0, num).concat([
        splits.slice(num).join(sep)
    ]) : splits;
};
var $89dc652caabae9cf$export$569bc7c4b94c73c8 = function(a, b) {
    var r = a % b;
    // If r and b differ in sign, add b to wrap the result to the correct sign.
    return r * b < 0 ? r + b : r;
};
var $89dc652caabae9cf$export$7cb533f05108f0eb = function(a, b) {
    return {
        div: Math.floor(a / b),
        mod: $89dc652caabae9cf$export$569bc7c4b94c73c8(a, b)
    };
};
var $89dc652caabae9cf$export$6e22c362a0406a2c = function(obj) {
    return !$89dc652caabae9cf$export$ee27c052bca048fb(obj) || obj.length === 0;
};
var $89dc652caabae9cf$export$b29ea735dcfba3c1 = function(obj) {
    return !$89dc652caabae9cf$export$6e22c362a0406a2c(obj);
};
var $89dc652caabae9cf$export$ee2e0f811dca1807 = function(arr, val) {
    return $89dc652caabae9cf$export$b29ea735dcfba3c1(arr) && arr.indexOf(val) !== -1;
};


var $4cf73d2382b09a20$export$7ba4466dbd0f07e1 = function(y, m, d, h, i, s) {
    if (h === void 0) h = 0;
    if (i === void 0) i = 0;
    if (s === void 0) s = 0;
    return new Date(Date.UTC(y, m - 1, d, h, i, s));
};
var $4cf73d2382b09a20$export$d54376159e08b33c = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $4cf73d2382b09a20$export$a97a1358cbb650ab = 86400000;
var $4cf73d2382b09a20$export$9d1fbb900e9d1ae5 = 9999;
var $4cf73d2382b09a20$export$fc0783a0b0d186d8 = $4cf73d2382b09a20$export$7ba4466dbd0f07e1(1970, 1, 1);
var $4cf73d2382b09a20$export$cf48b145d371639b = [
    6,
    0,
    1,
    2,
    3,
    4,
    5
];
var $4cf73d2382b09a20$export$6f157f7a2f040843 = function(date) {
    var dateNoTime = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    return Math.ceil((dateNoTime.valueOf() - new Date(date.getUTCFullYear(), 0, 1).valueOf()) / $4cf73d2382b09a20$export$a97a1358cbb650ab) + 1;
};
var $4cf73d2382b09a20$export$553d7fa8e3805fc0 = function(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
var $4cf73d2382b09a20$export$871608497c498473 = function(value) {
    return value instanceof Date;
};
var $4cf73d2382b09a20$export$c03bb0116ee09d4b = function(value) {
    return $4cf73d2382b09a20$export$871608497c498473(value) && !isNaN(value.getTime());
};
var $4cf73d2382b09a20$export$9047ae35a63b6344 = function(date) {
    return date.getTimezoneOffset() * 60000;
};
var $4cf73d2382b09a20$export$416492d1a5f46c79 = function(date1, date2) {
    // The number of milliseconds in one day
    // Convert both dates to milliseconds
    var date1ms = date1.getTime();
    var date2ms = date2.getTime();
    // Calculate the difference in milliseconds
    var differencems = date1ms - date2ms;
    // Convert back to days and return
    return Math.round(differencems / $4cf73d2382b09a20$export$a97a1358cbb650ab);
};
var $4cf73d2382b09a20$export$f2cd37d9f3227410 = function(date) {
    return $4cf73d2382b09a20$export$416492d1a5f46c79(date, $4cf73d2382b09a20$export$fc0783a0b0d186d8);
};
var $4cf73d2382b09a20$export$9ca7d52b87a6fe91 = function(ordinal) {
    return new Date($4cf73d2382b09a20$export$fc0783a0b0d186d8.getTime() + ordinal * $4cf73d2382b09a20$export$a97a1358cbb650ab);
};
var $4cf73d2382b09a20$export$214c174a056fc56f = function(date) {
    var month = date.getUTCMonth();
    return month === 1 && $4cf73d2382b09a20$export$553d7fa8e3805fc0(date.getUTCFullYear()) ? 29 : $4cf73d2382b09a20$export$d54376159e08b33c[month];
};
var $4cf73d2382b09a20$export$3cd955dfd2b0d79c = function(date) {
    return $4cf73d2382b09a20$export$cf48b145d371639b[date.getUTCDay()];
};
var $4cf73d2382b09a20$export$12f87b9998649ded = function(year, month) {
    var date = $4cf73d2382b09a20$export$7ba4466dbd0f07e1(year, month + 1, 1);
    return [
        $4cf73d2382b09a20$export$3cd955dfd2b0d79c(date),
        $4cf73d2382b09a20$export$214c174a056fc56f(date)
    ];
};
var $4cf73d2382b09a20$export$1be1fc439b849fdf = function(date, time) {
    time = time || date;
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds()));
};
var $4cf73d2382b09a20$export$9cd59f9826255e47 = function(date) {
    var dolly = new Date(date.getTime());
    return dolly;
};
var $4cf73d2382b09a20$export$b1159799e3bb6038 = function(dates) {
    var clones = [];
    for(var i = 0; i < dates.length; i++)clones.push($4cf73d2382b09a20$export$9cd59f9826255e47(dates[i]));
    return clones;
};
var $4cf73d2382b09a20$export$97db5808d8f88186 = function(dates) {
    dates.sort(function(a, b) {
        return a.getTime() - b.getTime();
    });
};
var $4cf73d2382b09a20$export$478f3a4b1337ed12 = function(time, utc) {
    if (utc === void 0) utc = true;
    var date = new Date(time);
    return [
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCFullYear().toString(), 4, '0'),
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCMonth() + 1, 2, '0'),
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCDate(), 2, '0'),
        'T',
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCHours(), 2, '0'),
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCMinutes(), 2, '0'),
        (0, $89dc652caabae9cf$export$36cf564d487b5178)(date.getUTCSeconds(), 2, '0'),
        utc ? 'Z' : ''
    ].join('');
};
var $4cf73d2382b09a20$export$1e820f1e902c56e0 = function(until) {
    var re = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/;
    var bits = re.exec(until);
    if (!bits) throw new Error("Invalid UNTIL value: ".concat(until));
    return new Date(Date.UTC(parseInt(bits[1], 10), parseInt(bits[2], 10) - 1, parseInt(bits[3], 10), parseInt(bits[5], 10) || 0, parseInt(bits[6], 10) || 0, parseInt(bits[7], 10) || 0));
};
var $4cf73d2382b09a20$var$dateTZtoISO8601 = function(date, timeZone) {
    // date format for sv-SE is almost ISO8601
    var dateStr = date.toLocaleString('sv-SE', {
        timeZone: timeZone
    });
    // '2023-02-07 10:41:36'
    return dateStr.replace(' ', 'T') + 'Z';
};
var $4cf73d2382b09a20$export$1c4495d1218e0ed2 = function(date, timeZone) {
    var localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Date constructor can only reliably parse dates in ISO8601 format
    var dateInLocalTZ = new Date($4cf73d2382b09a20$var$dateTZtoISO8601(date, localTimeZone));
    var dateInTargetTZ = new Date($4cf73d2382b09a20$var$dateTZtoISO8601(date, timeZone !== null && timeZone !== void 0 ? timeZone : 'UTC'));
    var tzOffset = dateInTargetTZ.getTime() - dateInLocalTZ.getTime();
    return new Date(date.getTime() - tzOffset);
};


/**
 * This class helps us to emulate python's generators, sorta.
 */ var $484bc730c1f73c01$var$IterResult = /** @class */ function() {
    function IterResult(method, args) {
        this.minDate = null;
        this.maxDate = null;
        this._result = [];
        this.total = 0;
        this.method = method;
        this.args = args;
        if (method === 'between') {
            this.maxDate = args.inc ? args.before : new Date(args.before.getTime() - 1);
            this.minDate = args.inc ? args.after : new Date(args.after.getTime() + 1);
        } else if (method === 'before') this.maxDate = args.inc ? args.dt : new Date(args.dt.getTime() - 1);
        else if (method === 'after') this.minDate = args.inc ? args.dt : new Date(args.dt.getTime() + 1);
    }
    /**
     * Possibly adds a date into the result.
     *
     * @param {Date} date - the date isn't necessarly added to the result
     * list (if it is too late/too early)
     * @return {Boolean} true if it makes sense to continue the iteration
     * false if we're done.
     */ IterResult.prototype.accept = function(date) {
        ++this.total;
        var tooEarly = this.minDate && date < this.minDate;
        var tooLate = this.maxDate && date > this.maxDate;
        if (this.method === 'between') {
            if (tooEarly) return true;
            if (tooLate) return false;
        } else if (this.method === 'before') {
            if (tooLate) return false;
        } else if (this.method === 'after') {
            if (tooEarly) return true;
            this.add(date);
            return false;
        }
        return this.add(date);
    };
    /**
     *
     * @param {Date} date that is part of the result.
     * @return {Boolean} whether we are interested in more values.
     */ IterResult.prototype.add = function(date) {
        this._result.push(date);
        return true;
    };
    /**
     * 'before' and 'after' return only one date, whereas 'all'
     * and 'between' an array.
     *
     * @return {Date,Array?}
     */ IterResult.prototype.getValue = function() {
        var res = this._result;
        switch(this.method){
            case 'all':
            case 'between':
                return res;
            case 'before':
            case 'after':
            default:
                return res.length ? res[res.length - 1] : null;
        }
    };
    IterResult.prototype.clone = function() {
        return new IterResult(this.method, this.args);
    };
    return IterResult;
}();
var $484bc730c1f73c01$export$2e2bcd8739ae039 = $484bc730c1f73c01$var$IterResult;



var $7WQrb = parcelRequire("7WQrb");

/**
 * IterResult subclass that calls a callback function on each add,
 * and stops iterating when the callback returns false.
 */ var $07dc35e4913bb777$var$CallbackIterResult = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(CallbackIterResult, _super);
    function CallbackIterResult(method, args, iterator) {
        var _this = _super.call(this, method, args) || this;
        _this.iterator = iterator;
        return _this;
    }
    CallbackIterResult.prototype.add = function(date) {
        if (this.iterator(date, this._result.length)) {
            this._result.push(date);
            return true;
        }
        return false;
    };
    return CallbackIterResult;
}((0, $484bc730c1f73c01$export$2e2bcd8739ae039));
var $07dc35e4913bb777$export$2e2bcd8739ae039 = $07dc35e4913bb777$var$CallbackIterResult;


// =============================================================================
// i18n
// =============================================================================
var $533f96da42e020f1$var$ENGLISH = {
    dayNames: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    tokens: {
        SKIP: /^[ \r\n\t]+|^\.$/,
        number: /^[1-9][0-9]*/,
        numberAsText: /^(one|two|three)/i,
        every: /^every/i,
        'day(s)': /^days?/i,
        'weekday(s)': /^weekdays?/i,
        'week(s)': /^weeks?/i,
        'hour(s)': /^hours?/i,
        'minute(s)': /^minutes?/i,
        'month(s)': /^months?/i,
        'year(s)': /^years?/i,
        on: /^(on|in)/i,
        at: /^(at)/i,
        the: /^the/i,
        first: /^first/i,
        second: /^second/i,
        third: /^third/i,
        nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
        last: /^last/i,
        for: /^for/i,
        'time(s)': /^times?/i,
        until: /^(un)?til/i,
        monday: /^mo(n(day)?)?/i,
        tuesday: /^tu(e(s(day)?)?)?/i,
        wednesday: /^we(d(n(esday)?)?)?/i,
        thursday: /^th(u(r(sday)?)?)?/i,
        friday: /^fr(i(day)?)?/i,
        saturday: /^sa(t(urday)?)?/i,
        sunday: /^su(n(day)?)?/i,
        january: /^jan(uary)?/i,
        february: /^feb(ruary)?/i,
        march: /^mar(ch)?/i,
        april: /^apr(il)?/i,
        may: /^may/i,
        june: /^june?/i,
        july: /^july?/i,
        august: /^aug(ust)?/i,
        september: /^sep(t(ember)?)?/i,
        october: /^oct(ober)?/i,
        november: /^nov(ember)?/i,
        december: /^dec(ember)?/i,
        comma: /^(,\s*|(and|or)\s*)+/i
    }
};
var $533f96da42e020f1$export$2e2bcd8739ae039 = $533f96da42e020f1$var$ENGLISH;




// =============================================================================
// Helper functions
// =============================================================================
/**
 * Return true if a value is in an array
 */ var $121c3552ced72bfd$var$contains = function(arr, val) {
    return arr.indexOf(val) !== -1;
};
var $121c3552ced72bfd$var$defaultGetText = function(id) {
    return id.toString();
};
var $121c3552ced72bfd$var$defaultDateFormatter = function(year, month, day) {
    return "".concat(month, " ").concat(day, ", ").concat(year);
};
/**
 *
 * @param {RRule} rrule
 * Optional:
 * @param {Function} gettext function
 * @param {Object} language definition
 * @constructor
 */ var $121c3552ced72bfd$var$ToText = /** @class */ function() {
    function ToText(rrule, gettext, language, dateFormatter) {
        if (gettext === void 0) gettext = $121c3552ced72bfd$var$defaultGetText;
        if (language === void 0) language = (0, $533f96da42e020f1$export$2e2bcd8739ae039);
        if (dateFormatter === void 0) dateFormatter = $121c3552ced72bfd$var$defaultDateFormatter;
        this.text = [];
        this.language = language || (0, $533f96da42e020f1$export$2e2bcd8739ae039);
        this.gettext = gettext;
        this.dateFormatter = dateFormatter;
        this.rrule = rrule;
        this.options = rrule.options;
        this.origOptions = rrule.origOptions;
        if (this.origOptions.bymonthday) {
            var bymonthday = [].concat(this.options.bymonthday);
            var bynmonthday = [].concat(this.options.bynmonthday);
            bymonthday.sort(function(a, b) {
                return a - b;
            });
            bynmonthday.sort(function(a, b) {
                return b - a;
            });
            // 1, 2, 3, .., -5, -4, -3, ..
            this.bymonthday = bymonthday.concat(bynmonthday);
            if (!this.bymonthday.length) this.bymonthday = null;
        }
        if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(this.origOptions.byweekday)) {
            var byweekday = !(0, $89dc652caabae9cf$export$43bee75e5e14138e)(this.origOptions.byweekday) ? [
                this.origOptions.byweekday
            ] : this.origOptions.byweekday;
            var days = String(byweekday);
            this.byweekday = {
                allWeeks: byweekday.filter(function(weekday) {
                    return !weekday.n;
                }),
                someWeeks: byweekday.filter(function(weekday) {
                    return Boolean(weekday.n);
                }),
                isWeekdays: days.indexOf('MO') !== -1 && days.indexOf('TU') !== -1 && days.indexOf('WE') !== -1 && days.indexOf('TH') !== -1 && days.indexOf('FR') !== -1 && days.indexOf('SA') === -1 && days.indexOf('SU') === -1,
                isEveryDay: days.indexOf('MO') !== -1 && days.indexOf('TU') !== -1 && days.indexOf('WE') !== -1 && days.indexOf('TH') !== -1 && days.indexOf('FR') !== -1 && days.indexOf('SA') !== -1 && days.indexOf('SU') !== -1
            };
            var sortWeekDays = function(a, b) {
                return a.weekday - b.weekday;
            };
            this.byweekday.allWeeks.sort(sortWeekDays);
            this.byweekday.someWeeks.sort(sortWeekDays);
            if (!this.byweekday.allWeeks.length) this.byweekday.allWeeks = null;
            if (!this.byweekday.someWeeks.length) this.byweekday.someWeeks = null;
        } else this.byweekday = null;
    }
    /**
     * Test whether the rrule can be fully converted to text.
     *
     * @param {RRule} rrule
     * @return {Boolean}
     */ ToText.isFullyConvertible = function(rrule) {
        var canConvert = true;
        if (!(rrule.options.freq in ToText.IMPLEMENTED)) return false;
        if (rrule.origOptions.until && rrule.origOptions.count) return false;
        for(var key in rrule.origOptions){
            if ($121c3552ced72bfd$var$contains([
                'dtstart',
                'tzid',
                'wkst',
                'freq'
            ], key)) return true;
            if (!$121c3552ced72bfd$var$contains(ToText.IMPLEMENTED[rrule.options.freq], key)) return false;
        }
        return canConvert;
    };
    ToText.prototype.isFullyConvertible = function() {
        return ToText.isFullyConvertible(this.rrule);
    };
    /**
     * Perform the conversion. Only some of the frequencies are supported.
     * If some of the rrule's options aren't supported, they'll
     * be omitted from the output an "(~ approximate)" will be appended.
     *
     * @return {*}
     */ ToText.prototype.toString = function() {
        var gettext = this.gettext;
        if (!(this.options.freq in ToText.IMPLEMENTED)) return gettext('RRule error: Unable to fully convert this rrule to text');
        this.text = [
            gettext('every')
        ];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this[(0, $e1d5d95ac5f1af89$export$4e942d157960251).FREQUENCIES[this.options.freq]]();
        if (this.options.until) {
            this.add(gettext('until'));
            var until = this.options.until;
            this.add(this.dateFormatter(until.getUTCFullYear(), this.language.monthNames[until.getUTCMonth()], until.getUTCDate()));
        } else if (this.options.count) this.add(gettext('for')).add(this.options.count.toString()).add(this.plural(this.options.count) ? gettext('times') : gettext('time'));
        if (!this.isFullyConvertible()) this.add(gettext('(~ approximate)'));
        return this.text.join('');
    };
    ToText.prototype.HOURLY = function() {
        var gettext = this.gettext;
        if (this.options.interval !== 1) this.add(this.options.interval.toString());
        this.add(this.plural(this.options.interval) ? gettext('hours') : gettext('hour'));
    };
    ToText.prototype.MINUTELY = function() {
        var gettext = this.gettext;
        if (this.options.interval !== 1) this.add(this.options.interval.toString());
        this.add(this.plural(this.options.interval) ? gettext('minutes') : gettext('minute'));
    };
    ToText.prototype.DAILY = function() {
        var gettext = this.gettext;
        if (this.options.interval !== 1) this.add(this.options.interval.toString());
        if (this.byweekday && this.byweekday.isWeekdays) this.add(this.plural(this.options.interval) ? gettext('weekdays') : gettext('weekday'));
        else this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
        if (this.origOptions.bymonth) {
            this.add(gettext('in'));
            this._bymonth();
        }
        if (this.bymonthday) this._bymonthday();
        else if (this.byweekday) this._byweekday();
        else if (this.origOptions.byhour) this._byhour();
    };
    ToText.prototype.WEEKLY = function() {
        var gettext = this.gettext;
        if (this.options.interval !== 1) this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? gettext('weeks') : gettext('week'));
        if (this.byweekday && this.byweekday.isWeekdays) {
            if (this.options.interval === 1) this.add(this.plural(this.options.interval) ? gettext('weekdays') : gettext('weekday'));
            else this.add(gettext('on')).add(gettext('weekdays'));
        } else if (this.byweekday && this.byweekday.isEveryDay) this.add(this.plural(this.options.interval) ? gettext('days') : gettext('day'));
        else {
            if (this.options.interval === 1) this.add(gettext('week'));
            if (this.origOptions.bymonth) {
                this.add(gettext('in'));
                this._bymonth();
            }
            if (this.bymonthday) this._bymonthday();
            else if (this.byweekday) this._byweekday();
            if (this.origOptions.byhour) this._byhour();
        }
    };
    ToText.prototype.MONTHLY = function() {
        var gettext = this.gettext;
        if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
                this.add(this.options.interval.toString()).add(gettext('months'));
                if (this.plural(this.options.interval)) this.add(gettext('in'));
            }
            this._bymonth();
        } else {
            if (this.options.interval !== 1) this.add(this.options.interval.toString());
            this.add(this.plural(this.options.interval) ? gettext('months') : gettext('month'));
        }
        if (this.bymonthday) this._bymonthday();
        else if (this.byweekday && this.byweekday.isWeekdays) this.add(gettext('on')).add(gettext('weekdays'));
        else if (this.byweekday) this._byweekday();
    };
    ToText.prototype.YEARLY = function() {
        var gettext = this.gettext;
        if (this.origOptions.bymonth) {
            if (this.options.interval !== 1) {
                this.add(this.options.interval.toString());
                this.add(gettext('years'));
            }
            this._bymonth();
        } else {
            if (this.options.interval !== 1) this.add(this.options.interval.toString());
            this.add(this.plural(this.options.interval) ? gettext('years') : gettext('year'));
        }
        if (this.bymonthday) this._bymonthday();
        else if (this.byweekday) this._byweekday();
        if (this.options.byyearday) this.add(gettext('on the')).add(this.list(this.options.byyearday, this.nth, gettext('and'))).add(gettext('day'));
        if (this.options.byweekno) this.add(gettext('in')).add(this.plural(this.options.byweekno.length) ? gettext('weeks') : gettext('week')).add(this.list(this.options.byweekno, undefined, gettext('and')));
    };
    ToText.prototype._bymonthday = function() {
        var gettext = this.gettext;
        if (this.byweekday && this.byweekday.allWeeks) this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext, gettext('or'))).add(gettext('the')).add(this.list(this.bymonthday, this.nth, gettext('or')));
        else this.add(gettext('on the')).add(this.list(this.bymonthday, this.nth, gettext('and')));
    // this.add(gettext('DAY'))
    };
    ToText.prototype._byweekday = function() {
        var gettext = this.gettext;
        if (this.byweekday.allWeeks && !this.byweekday.isWeekdays) this.add(gettext('on')).add(this.list(this.byweekday.allWeeks, this.weekdaytext));
        if (this.byweekday.someWeeks) {
            if (this.byweekday.allWeeks) this.add(gettext('and'));
            this.add(gettext('on the')).add(this.list(this.byweekday.someWeeks, this.weekdaytext, gettext('and')));
        }
    };
    ToText.prototype._byhour = function() {
        var gettext = this.gettext;
        this.add(gettext('at')).add(this.list(this.origOptions.byhour, undefined, gettext('and')));
    };
    ToText.prototype._bymonth = function() {
        this.add(this.list(this.options.bymonth, this.monthtext, this.gettext('and')));
    };
    ToText.prototype.nth = function(n) {
        n = parseInt(n.toString(), 10);
        var nth;
        var gettext = this.gettext;
        if (n === -1) return gettext('last');
        var npos = Math.abs(n);
        switch(npos){
            case 1:
            case 21:
            case 31:
                nth = npos + gettext('st');
                break;
            case 2:
            case 22:
                nth = npos + gettext('nd');
                break;
            case 3:
            case 23:
                nth = npos + gettext('rd');
                break;
            default:
                nth = npos + gettext('th');
        }
        return n < 0 ? nth + ' ' + gettext('last') : nth;
    };
    ToText.prototype.monthtext = function(m) {
        return this.language.monthNames[m - 1];
    };
    ToText.prototype.weekdaytext = function(wday) {
        var weekday = (0, $89dc652caabae9cf$export$7e4aa119212bc614)(wday) ? (wday + 1) % 7 : wday.getJsWeekday();
        return (wday.n ? this.nth(wday.n) + ' ' : '') + this.language.dayNames[weekday];
    };
    ToText.prototype.plural = function(n) {
        return n % 100 !== 1;
    };
    ToText.prototype.add = function(s) {
        this.text.push(' ');
        this.text.push(s);
        return this;
    };
    ToText.prototype.list = function(arr, callback, finalDelim, delim) {
        var _this = this;
        if (delim === void 0) delim = ',';
        if (!(0, $89dc652caabae9cf$export$43bee75e5e14138e)(arr)) arr = [
            arr
        ];
        var delimJoin = function(array, delimiter, finalDelimiter) {
            var list = '';
            for(var i = 0; i < array.length; i++){
                if (i !== 0) {
                    if (i === array.length - 1) list += ' ' + finalDelimiter + ' ';
                    else list += delimiter + ' ';
                }
                list += array[i];
            }
            return list;
        };
        callback = callback || function(o) {
            return o.toString();
        };
        var realCallback = function(arg) {
            return callback && callback.call(_this, arg);
        };
        if (finalDelim) return delimJoin(arr.map(realCallback), delim, finalDelim);
        else return arr.map(realCallback).join(delim + ' ');
    };
    return ToText;
}();
var $121c3552ced72bfd$export$2e2bcd8739ae039 = $121c3552ced72bfd$var$ToText;




// =============================================================================
// Parser
// =============================================================================
var $4aa79383bc87ad13$var$Parser = /** @class */ function() {
    function Parser(rules) {
        this.done = true;
        this.rules = rules;
    }
    Parser.prototype.start = function(text) {
        this.text = text;
        this.done = false;
        return this.nextSymbol();
    };
    Parser.prototype.isDone = function() {
        return this.done && this.symbol === null;
    };
    Parser.prototype.nextSymbol = function() {
        var best;
        var bestSymbol;
        this.symbol = null;
        this.value = null;
        do {
            if (this.done) return false;
            var rule = void 0;
            best = null;
            for(var name_1 in this.rules){
                rule = this.rules[name_1];
                var match = rule.exec(this.text);
                if (match) {
                    if (best === null || match[0].length > best[0].length) {
                        best = match;
                        bestSymbol = name_1;
                    }
                }
            }
            if (best != null) {
                this.text = this.text.substr(best[0].length);
                if (this.text === '') this.done = true;
            }
            if (best == null) {
                this.done = true;
                this.symbol = null;
                this.value = null;
                return;
            }
        }while (bestSymbol === 'SKIP');
        this.symbol = bestSymbol;
        this.value = best;
        return true;
    };
    Parser.prototype.accept = function(name) {
        if (this.symbol === name) {
            if (this.value) {
                var v = this.value;
                this.nextSymbol();
                return v;
            }
            this.nextSymbol();
            return true;
        }
        return false;
    };
    Parser.prototype.acceptNumber = function() {
        return this.accept('number');
    };
    Parser.prototype.expect = function(name) {
        if (this.accept(name)) return true;
        throw new Error('expected ' + name + ' but found ' + this.symbol);
    };
    return Parser;
}();
function $4aa79383bc87ad13$export$2e2bcd8739ae039(text, language) {
    if (language === void 0) language = (0, $533f96da42e020f1$export$2e2bcd8739ae039);
    var options = {};
    var ttr = new $4aa79383bc87ad13$var$Parser(language.tokens);
    if (!ttr.start(text)) return null;
    S();
    return options;
    function S() {
        // every [n]
        ttr.expect('every');
        var n = ttr.acceptNumber();
        if (n) options.interval = parseInt(n[0], 10);
        if (ttr.isDone()) throw new Error('Unexpected end');
        switch(ttr.symbol){
            case 'day(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).DAILY;
                if (ttr.nextSymbol()) {
                    AT();
                    F();
                }
                break;
            // FIXME Note: every 2 weekdays != every two weeks on weekdays.
            // DAILY on weekdays is not a valid rule
            case 'weekday(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).WEEKLY;
                options.byweekday = [
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).MO,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).TU,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).WE,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).TH,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).FR
                ];
                ttr.nextSymbol();
                AT();
                F();
                break;
            case 'week(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).WEEKLY;
                if (ttr.nextSymbol()) {
                    ON();
                    AT();
                    F();
                }
                break;
            case 'hour(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).HOURLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'minute(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).MINUTELY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'month(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).MONTHLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'year(s)':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).YEARLY;
                if (ttr.nextSymbol()) {
                    ON();
                    F();
                }
                break;
            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).WEEKLY;
                var key = ttr.symbol.substr(0, 2).toUpperCase();
                options.byweekday = [
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251)[key]
                ];
                if (!ttr.nextSymbol()) return;
                // TODO check for duplicates
                while(ttr.accept('comma')){
                    if (ttr.isDone()) throw new Error('Unexpected end');
                    var wkd = decodeWKD();
                    if (!wkd) throw new Error('Unexpected symbol ' + ttr.symbol + ', expected weekday');
                    options.byweekday.push((0, $e1d5d95ac5f1af89$export$4e942d157960251)[wkd]);
                    ttr.nextSymbol();
                }
                AT();
                MDAYs();
                F();
                break;
            case 'january':
            case 'february':
            case 'march':
            case 'april':
            case 'may':
            case 'june':
            case 'july':
            case 'august':
            case 'september':
            case 'october':
            case 'november':
            case 'december':
                options.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).YEARLY;
                options.bymonth = [
                    decodeM()
                ];
                if (!ttr.nextSymbol()) return;
                // TODO check for duplicates
                while(ttr.accept('comma')){
                    if (ttr.isDone()) throw new Error('Unexpected end');
                    var m = decodeM();
                    if (!m) throw new Error('Unexpected symbol ' + ttr.symbol + ', expected month');
                    options.bymonth.push(m);
                    ttr.nextSymbol();
                }
                ON();
                F();
                break;
            default:
                throw new Error('Unknown symbol');
        }
    }
    function ON() {
        var on = ttr.accept('on');
        var the = ttr.accept('the');
        if (!(on || the)) return;
        do {
            var nth = decodeNTH();
            var wkd = decodeWKD();
            var m = decodeM();
            // nth <weekday> | <weekday>
            if (nth) {
                // ttr.nextSymbol()
                if (wkd) {
                    ttr.nextSymbol();
                    if (!options.byweekday) options.byweekday = [];
                    options.byweekday.push((0, $e1d5d95ac5f1af89$export$4e942d157960251)[wkd].nth(nth));
                } else {
                    if (!options.bymonthday) options.bymonthday = [];
                    options.bymonthday.push(nth);
                    ttr.accept('day(s)');
                }
            } else if (wkd) {
                ttr.nextSymbol();
                if (!options.byweekday) options.byweekday = [];
                options.byweekday.push((0, $e1d5d95ac5f1af89$export$4e942d157960251)[wkd]);
            } else if (ttr.symbol === 'weekday(s)') {
                ttr.nextSymbol();
                if (!options.byweekday) options.byweekday = [
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).MO,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).TU,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).WE,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).TH,
                    (0, $e1d5d95ac5f1af89$export$4e942d157960251).FR
                ];
            } else if (ttr.symbol === 'week(s)') {
                ttr.nextSymbol();
                var n = ttr.acceptNumber();
                if (!n) throw new Error('Unexpected symbol ' + ttr.symbol + ', expected week number');
                options.byweekno = [
                    parseInt(n[0], 10)
                ];
                while(ttr.accept('comma')){
                    n = ttr.acceptNumber();
                    if (!n) throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
                    options.byweekno.push(parseInt(n[0], 10));
                }
            } else if (m) {
                ttr.nextSymbol();
                if (!options.bymonth) options.bymonth = [];
                options.bymonth.push(m);
            } else return;
        }while (ttr.accept('comma') || ttr.accept('the') || ttr.accept('on'));
    }
    function AT() {
        var at = ttr.accept('at');
        if (!at) return;
        do {
            var n = ttr.acceptNumber();
            if (!n) throw new Error('Unexpected symbol ' + ttr.symbol + ', expected hour');
            options.byhour = [
                parseInt(n[0], 10)
            ];
            while(ttr.accept('comma')){
                n = ttr.acceptNumber();
                if (!n) throw new Error('Unexpected symbol ' + ttr.symbol + '; expected hour');
                options.byhour.push(parseInt(n[0], 10));
            }
        }while (ttr.accept('comma') || ttr.accept('at'));
    }
    function decodeM() {
        switch(ttr.symbol){
            case 'january':
                return 1;
            case 'february':
                return 2;
            case 'march':
                return 3;
            case 'april':
                return 4;
            case 'may':
                return 5;
            case 'june':
                return 6;
            case 'july':
                return 7;
            case 'august':
                return 8;
            case 'september':
                return 9;
            case 'october':
                return 10;
            case 'november':
                return 11;
            case 'december':
                return 12;
            default:
                return false;
        }
    }
    function decodeWKD() {
        switch(ttr.symbol){
            case 'monday':
            case 'tuesday':
            case 'wednesday':
            case 'thursday':
            case 'friday':
            case 'saturday':
            case 'sunday':
                return ttr.symbol.substr(0, 2).toUpperCase();
            default:
                return false;
        }
    }
    function decodeNTH() {
        switch(ttr.symbol){
            case 'last':
                ttr.nextSymbol();
                return -1;
            case 'first':
                ttr.nextSymbol();
                return 1;
            case 'second':
                ttr.nextSymbol();
                return ttr.accept('last') ? -2 : 2;
            case 'third':
                ttr.nextSymbol();
                return ttr.accept('last') ? -3 : 3;
            case 'nth':
                var v = parseInt(ttr.value[1], 10);
                if (v < -366 || v > 366) throw new Error('Nth out of range: ' + v);
                ttr.nextSymbol();
                return ttr.accept('last') ? -v : v;
            default:
                return false;
        }
    }
    function MDAYs() {
        ttr.accept('on');
        ttr.accept('the');
        var nth = decodeNTH();
        if (!nth) return;
        options.bymonthday = [
            nth
        ];
        ttr.nextSymbol();
        while(ttr.accept('comma')){
            nth = decodeNTH();
            if (!nth) throw new Error('Unexpected symbol ' + ttr.symbol + '; expected monthday');
            options.bymonthday.push(nth);
            ttr.nextSymbol();
        }
    }
    function F() {
        if (ttr.symbol === 'until') {
            var date = Date.parse(ttr.text);
            if (!date) throw new Error('Cannot parse until date:' + ttr.text);
            options.until = new Date(date);
        } else if (ttr.accept('for')) {
            options.count = parseInt(ttr.value[0], 10);
            ttr.expect('number');
        // ttr.expect('times')
        }
    }
}



var $243d5af73caebe4d$export$44c95d3770756ed2;
(function(Frequency) {
    Frequency[Frequency["YEARLY"] = 0] = "YEARLY";
    Frequency[Frequency["MONTHLY"] = 1] = "MONTHLY";
    Frequency[Frequency["WEEKLY"] = 2] = "WEEKLY";
    Frequency[Frequency["DAILY"] = 3] = "DAILY";
    Frequency[Frequency["HOURLY"] = 4] = "HOURLY";
    Frequency[Frequency["MINUTELY"] = 5] = "MINUTELY";
    Frequency[Frequency["SECONDLY"] = 6] = "SECONDLY";
})($243d5af73caebe4d$export$44c95d3770756ed2 || ($243d5af73caebe4d$export$44c95d3770756ed2 = {}));
function $243d5af73caebe4d$export$5d09978a50c416fb(freq) {
    return freq < $243d5af73caebe4d$export$44c95d3770756ed2.HOURLY;
}



/* !
 * rrule.js - Library for working with recurrence rules for calendar dates.
 * https://github.com/jakubroztocil/rrule
 *
 * Copyright 2010, Jakub Roztocil and Lars Schoning
 * Licenced under the BSD licence.
 * https://github.com/jakubroztocil/rrule/blob/master/LICENCE
 *
 */ /**
 *
 * Implementation of RRule.fromText() and RRule::toText().
 *
 *
 * On the client side, this file needs to be included
 * when those functions are used.
 *
 */ // =============================================================================
// fromText
// =============================================================================
/**
 * Will be able to convert some of the below described rules from
 * text format to a rule object.
 *
 *
 * RULES
 *
 * Every ([n])
 * day(s)
 * | [weekday], ..., (and) [weekday]
 * | weekday(s)
 * | week(s)
 * | month(s)
 * | [month], ..., (and) [month]
 * | year(s)
 *
 *
 * Plus 0, 1, or multiple of these:
 *
 * on [weekday], ..., (or) [weekday] the [monthday], [monthday], ... (or) [monthday]
 *
 * on [weekday], ..., (and) [weekday]
 *
 * on the [monthday], [monthday], ... (and) [monthday] (day of the month)
 *
 * on the [nth-weekday], ..., (and) [nth-weekday] (of the month/year)
 *
 *
 * Plus 0 or 1 of these:
 *
 * for [n] time(s)
 *
 * until [date]
 *
 * Plus (.)
 *
 *
 * Definitely no supported for parsing:
 *
 * (for year):
 * in week(s) [n], ..., (and) [n]
 *
 * on the [yearday], ..., (and) [n] day of the year
 * on day [yearday], ..., (and) [n]
 *
 *
 * NON-TERMINALS
 *
 * [n]: 1, 2 ..., one, two, three ..
 * [month]: January, February, March, April, May, ... December
 * [weekday]: Monday, ... Sunday
 * [nth-weekday]: first [weekday], 2nd [weekday], ... last [weekday], ...
 * [monthday]: first, 1., 2., 1st, 2nd, second, ... 31st, last day, 2nd last day, ..
 * [date]:
 * - [month] (0-31(,) ([year])),
 * - (the) 0-31.(1-12.([year])),
 * - (the) 0-31/(1-12/([year])),
 * - [weekday]
 *
 * [year]: 0000, 0001, ... 01, 02, ..
 *
 * Definitely not supported for parsing:
 *
 * [yearday]: first, 1., 2., 1st, 2nd, second, ... 366th, last day, 2nd last day, ..
 *
 * @param {String} text
 * @return {Object, Boolean} the rule, or null.
 */ var $b64e311919e76d6b$export$7a77aeaf230ddfb9 = function(text, language) {
    if (language === void 0) language = (0, $533f96da42e020f1$export$2e2bcd8739ae039);
    return new (0, $e1d5d95ac5f1af89$export$4e942d157960251)((0, $4aa79383bc87ad13$export$2e2bcd8739ae039)(text, language) || undefined);
};
var $b64e311919e76d6b$var$common = [
    'count',
    'until',
    'interval',
    'byweekday',
    'bymonthday',
    'bymonth'
];
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED = [];
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).HOURLY] = $b64e311919e76d6b$var$common;
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).MINUTELY] = $b64e311919e76d6b$var$common;
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).DAILY] = [
    'byhour'
].concat($b64e311919e76d6b$var$common);
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY] = $b64e311919e76d6b$var$common;
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).MONTHLY] = $b64e311919e76d6b$var$common;
(0, $121c3552ced72bfd$export$2e2bcd8739ae039).IMPLEMENTED[(0, $243d5af73caebe4d$export$44c95d3770756ed2).YEARLY] = [
    'byweekno',
    'byyearday'
].concat($b64e311919e76d6b$var$common);
// =============================================================================
// Export
// =============================================================================
var $b64e311919e76d6b$export$598ff36d54604b81 = function(rrule, gettext, language, dateFormatter) {
    return new (0, $121c3552ced72bfd$export$2e2bcd8739ae039)(rrule, gettext, language, dateFormatter).toString();
};
var $b64e311919e76d6b$export$fb6015ad19349979 = (0, $121c3552ced72bfd$export$2e2bcd8739ae039).isFullyConvertible;




var $7WQrb = parcelRequire("7WQrb");






var $7WQrb = parcelRequire("7WQrb");



var $829a0d2a13d91e27$export$680ea196effce5f = /** @class */ function() {
    function Time(hour, minute, second, millisecond) {
        this.hour = hour;
        this.minute = minute;
        this.second = second;
        this.millisecond = millisecond || 0;
    }
    Time.prototype.getHours = function() {
        return this.hour;
    };
    Time.prototype.getMinutes = function() {
        return this.minute;
    };
    Time.prototype.getSeconds = function() {
        return this.second;
    };
    Time.prototype.getMilliseconds = function() {
        return this.millisecond;
    };
    Time.prototype.getTime = function() {
        return (this.hour * 3600 + this.minute * 60 + this.second) * 1000 + this.millisecond;
    };
    return Time;
}();
var $829a0d2a13d91e27$export$82f9ebd9adeba146 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(DateTime, _super);
    function DateTime(year, month, day, hour, minute, second, millisecond) {
        var _this = _super.call(this, hour, minute, second, millisecond) || this;
        _this.year = year;
        _this.month = month;
        _this.day = day;
        return _this;
    }
    DateTime.fromDate = function(date) {
        return new this(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.valueOf() % 1000);
    };
    DateTime.prototype.getWeekday = function() {
        return (0, $4cf73d2382b09a20$export$3cd955dfd2b0d79c)(new Date(this.getTime()));
    };
    DateTime.prototype.getTime = function() {
        return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    };
    DateTime.prototype.getDay = function() {
        return this.day;
    };
    DateTime.prototype.getMonth = function() {
        return this.month;
    };
    DateTime.prototype.getYear = function() {
        return this.year;
    };
    DateTime.prototype.addYears = function(years) {
        this.year += years;
    };
    DateTime.prototype.addMonths = function(months) {
        this.month += months;
        if (this.month > 12) {
            var yearDiv = Math.floor(this.month / 12);
            var monthMod = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(this.month, 12);
            this.month = monthMod;
            this.year += yearDiv;
            if (this.month === 0) {
                this.month = 12;
                --this.year;
            }
        }
    };
    DateTime.prototype.addWeekly = function(days, wkst) {
        if (wkst > this.getWeekday()) this.day += -(this.getWeekday() + 1 + (6 - wkst)) + days * 7;
        else this.day += -(this.getWeekday() - wkst) + days * 7;
        this.fixDay();
    };
    DateTime.prototype.addDaily = function(days) {
        this.day += days;
        this.fixDay();
    };
    DateTime.prototype.addHours = function(hours, filtered, byhour) {
        if (filtered) // Jump to one iteration before next day
        this.hour += Math.floor((23 - this.hour) / hours) * hours;
        for(;;){
            this.hour += hours;
            var _a = (0, $89dc652caabae9cf$export$7cb533f05108f0eb)(this.hour, 24), dayDiv = _a.div, hourMod = _a.mod;
            if (dayDiv) {
                this.hour = hourMod;
                this.addDaily(dayDiv);
            }
            if ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(byhour) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byhour, this.hour)) break;
        }
    };
    DateTime.prototype.addMinutes = function(minutes, filtered, byhour, byminute) {
        if (filtered) // Jump to one iteration before next day
        this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / minutes) * minutes;
        for(;;){
            this.minute += minutes;
            var _a = (0, $89dc652caabae9cf$export$7cb533f05108f0eb)(this.minute, 60), hourDiv = _a.div, minuteMod = _a.mod;
            if (hourDiv) {
                this.minute = minuteMod;
                this.addHours(hourDiv, false, byhour);
            }
            if (((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(byhour) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byhour, this.hour)) && ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(byminute) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byminute, this.minute))) break;
        }
    };
    DateTime.prototype.addSeconds = function(seconds, filtered, byhour, byminute, bysecond) {
        if (filtered) // Jump to one iteration before next day
        this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / seconds) * seconds;
        for(;;){
            this.second += seconds;
            var _a = (0, $89dc652caabae9cf$export$7cb533f05108f0eb)(this.second, 60), minuteDiv = _a.div, secondMod = _a.mod;
            if (minuteDiv) {
                this.second = secondMod;
                this.addMinutes(minuteDiv, false, byhour, byminute);
            }
            if (((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(byhour) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byhour, this.hour)) && ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(byminute) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byminute, this.minute)) && ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(bysecond) || (0, $89dc652caabae9cf$export$ee2e0f811dca1807)(bysecond, this.second))) break;
        }
    };
    DateTime.prototype.fixDay = function() {
        if (this.day <= 28) return;
        var daysinmonth = (0, $4cf73d2382b09a20$export$12f87b9998649ded)(this.year, this.month - 1)[1];
        if (this.day <= daysinmonth) return;
        while(this.day > daysinmonth){
            this.day -= daysinmonth;
            ++this.month;
            if (this.month === 13) {
                this.month = 1;
                ++this.year;
                if (this.year > (0, $4cf73d2382b09a20$export$9d1fbb900e9d1ae5)) return;
            }
            daysinmonth = (0, $4cf73d2382b09a20$export$12f87b9998649ded)(this.year, this.month - 1)[1];
        }
    };
    DateTime.prototype.add = function(options, filtered) {
        var freq = options.freq, interval = options.interval, wkst = options.wkst, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
        switch(freq){
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).YEARLY:
                return this.addYears(interval);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).MONTHLY:
                return this.addMonths(interval);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY:
                return this.addWeekly(interval, wkst);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).DAILY:
                return this.addDaily(interval);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).HOURLY:
                return this.addHours(interval, filtered, byhour);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).MINUTELY:
                return this.addMinutes(interval, filtered, byhour, byminute);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).SECONDLY:
                return this.addSeconds(interval, filtered, byhour, byminute, bysecond);
        }
    };
    return DateTime;
}($829a0d2a13d91e27$export$680ea196effce5f);


function $31d825003737e254$export$aeea68bb229a3a4d(options) {
    var invalid = [];
    var keys = Object.keys(options);
    // Shallow copy for options and origOptions and check for invalid
    for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
        var key = keys_1[_i];
        if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)((0, $e1d5d95ac5f1af89$export$d5755821cb579984), key)) invalid.push(key);
        if ((0, $4cf73d2382b09a20$export$871608497c498473)(options[key]) && !(0, $4cf73d2382b09a20$export$c03bb0116ee09d4b)(options[key])) invalid.push(key);
    }
    if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '));
    return (0, $7WQrb.__assign)({}, options);
}
function $31d825003737e254$export$49fe41a914eb071d(options) {
    var opts = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $e1d5d95ac5f1af89$export$93ca5d3f8675ae4c)), $31d825003737e254$export$aeea68bb229a3a4d(options));
    if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byeaster)) opts.freq = (0, $e1d5d95ac5f1af89$export$4e942d157960251).YEARLY;
    if (!((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.freq) && (0, $e1d5d95ac5f1af89$export$4e942d157960251).FREQUENCIES[opts.freq])) throw new Error("Invalid frequency: ".concat(opts.freq, " ").concat(options.freq));
    if (!opts.dtstart) opts.dtstart = new Date(new Date().setMilliseconds(0));
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.wkst)) opts.wkst = (0, $e1d5d95ac5f1af89$export$4e942d157960251).MO.weekday;
    else if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.wkst)) ;
    else opts.wkst = opts.wkst.weekday;
    if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.bysetpos)) {
        if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.bysetpos)) opts.bysetpos = [
            opts.bysetpos
        ];
        for(var i = 0; i < opts.bysetpos.length; i++){
            var v = opts.bysetpos[i];
            if (v === 0 || !(v >= -366 && v <= 366)) throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
        }
    }
    if (!(Boolean(opts.byweekno) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(opts.byweekno) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(opts.byyearday) || Boolean(opts.bymonthday) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(opts.bymonthday) || (0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byweekday) || (0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byeaster))) switch(opts.freq){
        case (0, $e1d5d95ac5f1af89$export$4e942d157960251).YEARLY:
            if (!opts.bymonth) opts.bymonth = opts.dtstart.getUTCMonth() + 1;
            opts.bymonthday = opts.dtstart.getUTCDate();
            break;
        case (0, $e1d5d95ac5f1af89$export$4e942d157960251).MONTHLY:
            opts.bymonthday = opts.dtstart.getUTCDate();
            break;
        case (0, $e1d5d95ac5f1af89$export$4e942d157960251).WEEKLY:
            opts.byweekday = [
                (0, $4cf73d2382b09a20$export$3cd955dfd2b0d79c)(opts.dtstart)
            ];
            break;
    }
    // bymonth
    if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.bymonth) && !(0, $89dc652caabae9cf$export$43bee75e5e14138e)(opts.bymonth)) opts.bymonth = [
        opts.bymonth
    ];
    // byyearday
    if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byyearday) && !(0, $89dc652caabae9cf$export$43bee75e5e14138e)(opts.byyearday) && (0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.byyearday)) opts.byyearday = [
        opts.byyearday
    ];
    // bymonthday
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.bymonthday)) {
        opts.bymonthday = [];
        opts.bynmonthday = [];
    } else if ((0, $89dc652caabae9cf$export$43bee75e5e14138e)(opts.bymonthday)) {
        var bymonthday = [];
        var bynmonthday = [];
        for(var i = 0; i < opts.bymonthday.length; i++){
            var v = opts.bymonthday[i];
            if (v > 0) bymonthday.push(v);
            else if (v < 0) bynmonthday.push(v);
        }
        opts.bymonthday = bymonthday;
        opts.bynmonthday = bynmonthday;
    } else if (opts.bymonthday < 0) {
        opts.bynmonthday = [
            opts.bymonthday
        ];
        opts.bymonthday = [];
    } else {
        opts.bynmonthday = [];
        opts.bymonthday = [
            opts.bymonthday
        ];
    }
    // byweekno
    if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byweekno) && !(0, $89dc652caabae9cf$export$43bee75e5e14138e)(opts.byweekno)) opts.byweekno = [
        opts.byweekno
    ];
    // byweekday / bynweekday
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byweekday)) opts.bynweekday = null;
    else if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.byweekday)) {
        opts.byweekday = [
            opts.byweekday
        ];
        opts.bynweekday = null;
    } else if ((0, $89dc652caabae9cf$export$f9326dee76b2106d)(opts.byweekday)) {
        opts.byweekday = [
            (0, $47606afb7b57d36f$export$94dd8a9f089c7f53).fromStr(opts.byweekday).weekday
        ];
        opts.bynweekday = null;
    } else if (opts.byweekday instanceof (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)) {
        if (!opts.byweekday.n || opts.freq > (0, $e1d5d95ac5f1af89$export$4e942d157960251).MONTHLY) {
            opts.byweekday = [
                opts.byweekday.weekday
            ];
            opts.bynweekday = null;
        } else {
            opts.bynweekday = [
                [
                    opts.byweekday.weekday,
                    opts.byweekday.n
                ]
            ];
            opts.byweekday = null;
        }
    } else {
        var byweekday = [];
        var bynweekday = [];
        for(var i = 0; i < opts.byweekday.length; i++){
            var wday = opts.byweekday[i];
            if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(wday)) {
                byweekday.push(wday);
                continue;
            } else if ((0, $89dc652caabae9cf$export$f9326dee76b2106d)(wday)) {
                byweekday.push((0, $47606afb7b57d36f$export$94dd8a9f089c7f53).fromStr(wday).weekday);
                continue;
            }
            if (!wday.n || opts.freq > (0, $e1d5d95ac5f1af89$export$4e942d157960251).MONTHLY) byweekday.push(wday.weekday);
            else bynweekday.push([
                wday.weekday,
                wday.n
            ]);
        }
        opts.byweekday = (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byweekday) ? byweekday : null;
        opts.bynweekday = (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bynweekday) ? bynweekday : null;
    }
    // byhour
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byhour)) opts.byhour = opts.freq < (0, $e1d5d95ac5f1af89$export$4e942d157960251).HOURLY ? [
        opts.dtstart.getUTCHours()
    ] : null;
    else if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.byhour)) opts.byhour = [
        opts.byhour
    ];
    // byminute
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.byminute)) opts.byminute = opts.freq < (0, $e1d5d95ac5f1af89$export$4e942d157960251).MINUTELY ? [
        opts.dtstart.getUTCMinutes()
    ] : null;
    else if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.byminute)) opts.byminute = [
        opts.byminute
    ];
    // bysecond
    if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(opts.bysecond)) opts.bysecond = opts.freq < (0, $e1d5d95ac5f1af89$export$4e942d157960251).SECONDLY ? [
        opts.dtstart.getUTCSeconds()
    ] : null;
    else if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(opts.bysecond)) opts.bysecond = [
        opts.bysecond
    ];
    return {
        parsedOptions: opts
    };
}
function $31d825003737e254$export$c4642b52a0dd14c8(opts) {
    var millisecondModulo = opts.dtstart.getTime() % 1000;
    if (!(0, $243d5af73caebe4d$export$5d09978a50c416fb)(opts.freq)) return [];
    var timeset = [];
    opts.byhour.forEach(function(hour) {
        opts.byminute.forEach(function(minute) {
            opts.bysecond.forEach(function(second) {
                timeset.push(new (0, $829a0d2a13d91e27$export$680ea196effce5f)(hour, minute, second, millisecondModulo));
            });
        });
    });
    return timeset;
}



var $7WQrb = parcelRequire("7WQrb");




function $abff7f9048c51f33$export$960addfb9e5a0cde(rfcString) {
    var options = rfcString.split('\n').map($abff7f9048c51f33$var$parseLine).filter(function(x) {
        return x !== null;
    });
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options[0]), options[1]);
}
function $abff7f9048c51f33$export$50f40aa3339c15e0(line) {
    var options = {};
    var dtstartWithZone = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(line);
    if (!dtstartWithZone) return options;
    var tzid = dtstartWithZone[1], dtstart = dtstartWithZone[2];
    if (tzid) options.tzid = tzid;
    options.dtstart = (0, $4cf73d2382b09a20$export$1e820f1e902c56e0)(dtstart);
    return options;
}
function $abff7f9048c51f33$var$parseLine(rfcString) {
    rfcString = rfcString.replace(/^\s+|\s+$/, '');
    if (!rfcString.length) return null;
    var header = /^([A-Z]+?)[:;]/.exec(rfcString.toUpperCase());
    if (!header) return $abff7f9048c51f33$var$parseRrule(rfcString);
    var key = header[1];
    switch(key.toUpperCase()){
        case 'RRULE':
        case 'EXRULE':
            return $abff7f9048c51f33$var$parseRrule(rfcString);
        case 'DTSTART':
            return $abff7f9048c51f33$export$50f40aa3339c15e0(rfcString);
        default:
            throw new Error("Unsupported RFC prop ".concat(key, " in ").concat(rfcString));
    }
}
function $abff7f9048c51f33$var$parseRrule(line) {
    var strippedLine = line.replace(/^RRULE:/i, '');
    var options = $abff7f9048c51f33$export$50f40aa3339c15e0(strippedLine);
    var attrs = line.replace(/^(?:RRULE|EXRULE):/i, '').split(';');
    attrs.forEach(function(attr) {
        var _a = attr.split('='), key = _a[0], value = _a[1];
        switch(key.toUpperCase()){
            case 'FREQ':
                options.freq = (0, $243d5af73caebe4d$export$44c95d3770756ed2)[value.toUpperCase()];
                break;
            case 'WKST':
                options.wkst = (0, $e1d5d95ac5f1af89$export$d3134eff2123aadb)[value.toUpperCase()];
                break;
            case 'COUNT':
            case 'INTERVAL':
            case 'BYSETPOS':
            case 'BYMONTH':
            case 'BYMONTHDAY':
            case 'BYYEARDAY':
            case 'BYWEEKNO':
            case 'BYHOUR':
            case 'BYMINUTE':
            case 'BYSECOND':
                var num = $abff7f9048c51f33$var$parseNumber(value);
                var optionKey = key.toLowerCase();
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                options[optionKey] = num;
                break;
            case 'BYWEEKDAY':
            case 'BYDAY':
                options.byweekday = $abff7f9048c51f33$var$parseWeekday(value);
                break;
            case 'DTSTART':
            case 'TZID':
                // for backwards compatibility
                var dtstart = $abff7f9048c51f33$export$50f40aa3339c15e0(line);
                options.tzid = dtstart.tzid;
                options.dtstart = dtstart.dtstart;
                break;
            case 'UNTIL':
                options.until = (0, $4cf73d2382b09a20$export$1e820f1e902c56e0)(value);
                break;
            case 'BYEASTER':
                options.byeaster = Number(value);
                break;
            default:
                throw new Error("Unknown RRULE property '" + key + "'");
        }
    });
    return options;
}
function $abff7f9048c51f33$var$parseNumber(value) {
    if (value.indexOf(',') !== -1) {
        var values = value.split(',');
        return values.map($abff7f9048c51f33$var$parseIndividualNumber);
    }
    return $abff7f9048c51f33$var$parseIndividualNumber(value);
}
function $abff7f9048c51f33$var$parseIndividualNumber(value) {
    if (/^[+-]?\d+$/.test(value)) return Number(value);
    return value;
}
function $abff7f9048c51f33$var$parseWeekday(value) {
    var days = value.split(',');
    return days.map(function(day) {
        if (day.length === 2) // MO, TU, ...
        return (0, $e1d5d95ac5f1af89$export$d3134eff2123aadb)[day]; // wday instanceof Weekday
        // -1MO, +3FR, 1SO, 13TU ...
        var parts = day.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
        if (!parts || parts.length < 3) throw new SyntaxError("Invalid weekday string: ".concat(day));
        var n = Number(parts[1]);
        var wdaypart = parts[2];
        var wday = (0, $e1d5d95ac5f1af89$export$d3134eff2123aadb)[wdaypart].weekday;
        return new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(wday, n);
    });
}







var $c8c618d49b808a34$export$8baceac99da2643b = /** @class */ function() {
    function DateWithZone(date, tzid) {
        if (isNaN(date.getTime())) throw new RangeError('Invalid date passed to DateWithZone');
        this.date = date;
        this.tzid = tzid;
    }
    Object.defineProperty(DateWithZone.prototype, "isUTC", {
        get: function() {
            return !this.tzid || this.tzid.toUpperCase() === 'UTC';
        },
        enumerable: false,
        configurable: true
    });
    DateWithZone.prototype.toString = function() {
        var datestr = (0, $4cf73d2382b09a20$export$478f3a4b1337ed12)(this.date.getTime(), this.isUTC);
        if (!this.isUTC) return ";TZID=".concat(this.tzid, ":").concat(datestr);
        return ":".concat(datestr);
    };
    DateWithZone.prototype.getTime = function() {
        return this.date.getTime();
    };
    DateWithZone.prototype.rezonedDate = function() {
        if (this.isUTC) return this.date;
        return (0, $4cf73d2382b09a20$export$1c4495d1218e0ed2)(this.date, this.tzid);
    };
    return DateWithZone;
}();


function $08f885112710e87a$export$d1a7f461af1bce85(options) {
    var rrule = [];
    var dtstart = '';
    var keys = Object.keys(options);
    var defaultKeys = Object.keys((0, $e1d5d95ac5f1af89$export$93ca5d3f8675ae4c));
    for(var i = 0; i < keys.length; i++){
        if (keys[i] === 'tzid') continue;
        if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(defaultKeys, keys[i])) continue;
        var key = keys[i].toUpperCase();
        var value = options[keys[i]];
        var outValue = '';
        if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(value) || (0, $89dc652caabae9cf$export$43bee75e5e14138e)(value) && !value.length) continue;
        switch(key){
            case 'FREQ':
                outValue = (0, $e1d5d95ac5f1af89$export$4e942d157960251).FREQUENCIES[options.freq];
                break;
            case 'WKST':
                if ((0, $89dc652caabae9cf$export$7e4aa119212bc614)(value)) outValue = new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(value).toString();
                else outValue = value.toString();
                break;
            case 'BYWEEKDAY':
                /*
                  NOTE: BYWEEKDAY is a special case.
                  RRule() deconstructs the rule.options.byweekday array
                  into an array of Weekday arguments.
                  On the other hand, rule.origOptions is an array of Weekdays.
                  We need to handle both cases here.
                  It might be worth change RRule to keep the Weekdays.
        
                  Also, BYWEEKDAY (used by RRule) vs. BYDAY (RFC)
        
                  */ key = 'BYDAY';
                outValue = (0, $89dc652caabae9cf$export$45b10814cc054894)(value).map(function(wday) {
                    if (wday instanceof (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)) return wday;
                    if ((0, $89dc652caabae9cf$export$43bee75e5e14138e)(wday)) return new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(wday[0], wday[1]);
                    return new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(wday);
                }).toString();
                break;
            case 'DTSTART':
                dtstart = $08f885112710e87a$var$buildDtstart(value, options.tzid);
                break;
            case 'UNTIL':
                outValue = (0, $4cf73d2382b09a20$export$478f3a4b1337ed12)(value, !options.tzid);
                break;
            default:
                if ((0, $89dc652caabae9cf$export$43bee75e5e14138e)(value)) {
                    var strValues = [];
                    for(var j = 0; j < value.length; j++)strValues[j] = String(value[j]);
                    outValue = strValues.toString();
                } else outValue = String(value);
        }
        if (outValue) rrule.push([
            key,
            outValue
        ]);
    }
    var rules = rrule.map(function(_a) {
        var key = _a[0], value = _a[1];
        return "".concat(key, "=").concat(value.toString());
    }).join(';');
    var ruleString = '';
    if (rules !== '') ruleString = "RRULE:".concat(rules);
    return [
        dtstart,
        ruleString
    ].filter(function(x) {
        return !!x;
    }).join('\n');
}
function $08f885112710e87a$var$buildDtstart(dtstart, tzid) {
    if (!dtstart) return '';
    return 'DTSTART' + new (0, $c8c618d49b808a34$export$8baceac99da2643b)(new Date(dtstart), tzid).toString();
}





function $eea6334ea136904c$var$argsMatch(left, right) {
    if (Array.isArray(left)) {
        if (!Array.isArray(right)) return false;
        if (left.length !== right.length) return false;
        return left.every(function(date, i) {
            return date.getTime() === right[i].getTime();
        });
    }
    if (left instanceof Date) return right instanceof Date && left.getTime() === right.getTime();
    return left === right;
}
var $eea6334ea136904c$export$94affb487e701bf2 = /** @class */ function() {
    function Cache() {
        this.all = false;
        this.before = [];
        this.after = [];
        this.between = [];
    }
    /**
     * @param {String} what - all/before/after/between
     * @param {Array,Date} value - an array of dates, one date, or null
     * @param {Object?} args - _iter arguments
     */ Cache.prototype._cacheAdd = function(what, value, args) {
        if (value) value = value instanceof Date ? (0, $4cf73d2382b09a20$export$9cd59f9826255e47)(value) : (0, $4cf73d2382b09a20$export$b1159799e3bb6038)(value);
        if (what === 'all') this.all = value;
        else {
            args._value = value;
            this[what].push(args);
        }
    };
    /**
     * @return false - not in the cache
     * @return null  - cached, but zero occurrences (before/after)
     * @return Date  - cached (before/after)
     * @return []    - cached, but zero occurrences (all/between)
     * @return [Date1, DateN] - cached (all/between)
     */ Cache.prototype._cacheGet = function(what, args) {
        var cached = false;
        var argsKeys = args ? Object.keys(args) : [];
        var findCacheDiff = function(item) {
            for(var i = 0; i < argsKeys.length; i++){
                var key = argsKeys[i];
                if (!$eea6334ea136904c$var$argsMatch(args[key], item[key])) return true;
            }
            return false;
        };
        var cachedObject = this[what];
        if (what === 'all') cached = this.all;
        else if ((0, $89dc652caabae9cf$export$43bee75e5e14138e)(cachedObject)) // Let's see whether we've already called the
        // 'what' method with the same 'args'
        for(var i = 0; i < cachedObject.length; i++){
            var item = cachedObject[i];
            if (argsKeys.length && findCacheDiff(item)) continue;
            cached = item._value;
            break;
        }
        if (!cached && this.all) {
            // Not in the cache, but we already know all the occurrences,
            // so we can find the correct dates from the cached ones.
            var iterResult = new (0, $484bc730c1f73c01$export$2e2bcd8739ae039)(what, args);
            for(var i = 0; i < this.all.length; i++){
                if (!iterResult.accept(this.all[i])) break;
            }
            cached = iterResult.getValue();
            this._cacheAdd(what, cached, args);
        }
        return (0, $89dc652caabae9cf$export$43bee75e5e14138e)(cached) ? (0, $4cf73d2382b09a20$export$b1159799e3bb6038)(cached) : cached instanceof Date ? (0, $4cf73d2382b09a20$export$9cd59f9826255e47)(cached) : cached;
    };
    return Cache;
}();








var $7WQrb = parcelRequire("7WQrb");



var $7WQrb = parcelRequire("7WQrb");

// =============================================================================
// Date masks
// =============================================================================
// Every mask is 7 days longer to handle cross-year weekly periods.
var $e22b3c5b046717e6$export$c5006c5d239e1eda = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $89dc652caabae9cf$export$76d90c956114f2c2)(1, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(2, 28), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(3, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(4, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(5, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(6, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(7, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(8, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(9, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(10, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(11, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(12, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(1, 7), true);
var $e22b3c5b046717e6$export$3464ee769a6045c4 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $89dc652caabae9cf$export$76d90c956114f2c2)(1, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(2, 29), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(3, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(4, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(5, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(6, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(7, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(8, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(9, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(10, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(11, 30), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(12, 31), true), (0, $89dc652caabae9cf$export$76d90c956114f2c2)(1, 7), true);
var $e22b3c5b046717e6$var$M28 = (0, $89dc652caabae9cf$export$d02631cccf789723)(1, 29);
var $e22b3c5b046717e6$var$M29 = (0, $89dc652caabae9cf$export$d02631cccf789723)(1, 30);
var $e22b3c5b046717e6$var$M30 = (0, $89dc652caabae9cf$export$d02631cccf789723)(1, 31);
var $e22b3c5b046717e6$var$M31 = (0, $89dc652caabae9cf$export$d02631cccf789723)(1, 32);
var $e22b3c5b046717e6$export$782a123e13b7b635 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M29, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M31.slice(0, 7), true);
var $e22b3c5b046717e6$export$cc84233aaf495bb9 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M28, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M30, true), $e22b3c5b046717e6$var$M31, true), $e22b3c5b046717e6$var$M31.slice(0, 7), true);
var $e22b3c5b046717e6$var$NM28 = (0, $89dc652caabae9cf$export$d02631cccf789723)(-28, 0);
var $e22b3c5b046717e6$var$NM29 = (0, $89dc652caabae9cf$export$d02631cccf789723)(-29, 0);
var $e22b3c5b046717e6$var$NM30 = (0, $89dc652caabae9cf$export$d02631cccf789723)(-30, 0);
var $e22b3c5b046717e6$var$NM31 = (0, $89dc652caabae9cf$export$d02631cccf789723)(-31, 0);
var $e22b3c5b046717e6$export$d39664dac426eae2 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM29, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM31.slice(0, 7), true);
var $e22b3c5b046717e6$export$db7b567cf202a0d7 = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM28, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM30, true), $e22b3c5b046717e6$var$NM31, true), $e22b3c5b046717e6$var$NM31.slice(0, 7), true);
var $e22b3c5b046717e6$export$49541bf804f4f7ea = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335,
    366
];
var $e22b3c5b046717e6$export$da0070dc1f9f624c = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334,
    365
];
var $e22b3c5b046717e6$export$f8a7f2f47145db59 = function() {
    var wdaymask = [];
    for(var i = 0; i < 55; i++)wdaymask = wdaymask.concat((0, $89dc652caabae9cf$export$d02631cccf789723)(7));
    return wdaymask;
}();


function $fd4138fbe587efcd$export$eca728367537c59e(year, options) {
    var firstyday = (0, $4cf73d2382b09a20$export$7ba4466dbd0f07e1)(year, 1, 1);
    var yearlen = (0, $4cf73d2382b09a20$export$553d7fa8e3805fc0)(year) ? 366 : 365;
    var nextyearlen = (0, $4cf73d2382b09a20$export$553d7fa8e3805fc0)(year + 1) ? 366 : 365;
    var yearordinal = (0, $4cf73d2382b09a20$export$f2cd37d9f3227410)(firstyday);
    var yearweekday = (0, $4cf73d2382b09a20$export$3cd955dfd2b0d79c)(firstyday);
    var result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
        yearlen: yearlen,
        nextyearlen: nextyearlen,
        yearordinal: yearordinal,
        yearweekday: yearweekday
    }, $fd4138fbe587efcd$var$baseYearMasks(year)), {
        wnomask: null
    });
    if ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(options.byweekno)) return result;
    result.wnomask = (0, $89dc652caabae9cf$export$76d90c956114f2c2)(0, yearlen + 7);
    var firstwkst;
    var wyearlen;
    var no1wkst = firstwkst = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(7 - yearweekday + options.wkst, 7);
    if (no1wkst >= 4) {
        no1wkst = 0;
        // Number of days in the year, plus the days we got
        // from last year.
        wyearlen = result.yearlen + (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(yearweekday - options.wkst, 7);
    } else // Number of days in the year, minus the days we
    // left in last year.
    wyearlen = yearlen - no1wkst;
    var div = Math.floor(wyearlen / 7);
    var mod = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(wyearlen, 7);
    var numweeks = Math.floor(div + mod / 4);
    for(var j = 0; j < options.byweekno.length; j++){
        var n = options.byweekno[j];
        if (n < 0) n += numweeks + 1;
        if (!(n > 0 && n <= numweeks)) continue;
        var i = void 0;
        if (n > 1) {
            i = no1wkst + (n - 1) * 7;
            if (no1wkst !== firstwkst) i -= 7 - firstwkst;
        } else i = no1wkst;
        for(var k = 0; k < 7; k++){
            result.wnomask[i] = 1;
            i++;
            if (result.wdaymask[i] === options.wkst) break;
        }
    }
    if ((0, $89dc652caabae9cf$export$ee2e0f811dca1807)(options.byweekno, 1)) {
        // Check week number 1 of next year as well
        // orig-TODO : Check -numweeks for next year.
        var i = no1wkst + numweeks * 7;
        if (no1wkst !== firstwkst) i -= 7 - firstwkst;
        if (i < yearlen) // If week starts in next year, we
        // don't care about it.
        for(var j = 0; j < 7; j++){
            result.wnomask[i] = 1;
            i += 1;
            if (result.wdaymask[i] === options.wkst) break;
        }
    }
    if (no1wkst) {
        // Check last week number of last year as
        // well. If no1wkst is 0, either the year
        // started on week start, or week number 1
        // got days from last year, so there are no
        // days from last year's last week number in
        // this year.
        var lnumweeks = void 0;
        if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(options.byweekno, -1)) {
            var lyearweekday = (0, $4cf73d2382b09a20$export$3cd955dfd2b0d79c)((0, $4cf73d2382b09a20$export$7ba4466dbd0f07e1)(year - 1, 1, 1));
            var lno1wkst = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(7 - lyearweekday.valueOf() + options.wkst, 7);
            var lyearlen = (0, $4cf73d2382b09a20$export$553d7fa8e3805fc0)(year - 1) ? 366 : 365;
            var weekst = void 0;
            if (lno1wkst >= 4) {
                lno1wkst = 0;
                weekst = lyearlen + (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(lyearweekday - options.wkst, 7);
            } else weekst = yearlen - no1wkst;
            lnumweeks = Math.floor(52 + (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(weekst, 7) / 4);
        } else lnumweeks = -1;
        if ((0, $89dc652caabae9cf$export$ee2e0f811dca1807)(options.byweekno, lnumweeks)) for(var i = 0; i < no1wkst; i++)result.wnomask[i] = 1;
    }
    return result;
}
function $fd4138fbe587efcd$var$baseYearMasks(year) {
    var yearlen = (0, $4cf73d2382b09a20$export$553d7fa8e3805fc0)(year) ? 366 : 365;
    var firstyday = (0, $4cf73d2382b09a20$export$7ba4466dbd0f07e1)(year, 1, 1);
    var wday = (0, $4cf73d2382b09a20$export$3cd955dfd2b0d79c)(firstyday);
    if (yearlen === 365) return {
        mmask: (0, $e22b3c5b046717e6$export$c5006c5d239e1eda),
        mdaymask: (0, $e22b3c5b046717e6$export$cc84233aaf495bb9),
        nmdaymask: (0, $e22b3c5b046717e6$export$db7b567cf202a0d7),
        wdaymask: (0, $e22b3c5b046717e6$export$f8a7f2f47145db59).slice(wday),
        mrange: (0, $e22b3c5b046717e6$export$da0070dc1f9f624c)
    };
    return {
        mmask: (0, $e22b3c5b046717e6$export$3464ee769a6045c4),
        mdaymask: (0, $e22b3c5b046717e6$export$782a123e13b7b635),
        nmdaymask: (0, $e22b3c5b046717e6$export$d39664dac426eae2),
        wdaymask: (0, $e22b3c5b046717e6$export$f8a7f2f47145db59).slice(wday),
        mrange: (0, $e22b3c5b046717e6$export$49541bf804f4f7ea)
    };
}




function $4d33e314b5cff33c$export$c0eb75a5c675031d(year, month, yearlen, mrange, wdaymask, options) {
    var result = {
        lastyear: year,
        lastmonth: month,
        nwdaymask: []
    };
    var ranges = [];
    if (options.freq === (0, $e1d5d95ac5f1af89$export$4e942d157960251).YEARLY) {
        if ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(options.bymonth)) ranges = [
            [
                0,
                yearlen
            ]
        ];
        else for(var j = 0; j < options.bymonth.length; j++){
            month = options.bymonth[j];
            ranges.push(mrange.slice(month - 1, month + 1));
        }
    } else if (options.freq === (0, $e1d5d95ac5f1af89$export$4e942d157960251).MONTHLY) ranges = [
        mrange.slice(month - 1, month + 1)
    ];
    if ((0, $89dc652caabae9cf$export$6e22c362a0406a2c)(ranges)) return result;
    // Weekly frequency won't get here, so we may not
    // care about cross-year weekly periods.
    result.nwdaymask = (0, $89dc652caabae9cf$export$76d90c956114f2c2)(0, yearlen);
    for(var j = 0; j < ranges.length; j++){
        var rang = ranges[j];
        var first = rang[0];
        var last = rang[1] - 1;
        for(var k = 0; k < options.bynweekday.length; k++){
            var i = void 0;
            var _a = options.bynweekday[k], wday = _a[0], n = _a[1];
            if (n < 0) {
                i = last + (n + 1) * 7;
                i -= (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(wdaymask[i] - wday, 7);
            } else {
                i = first + (n - 1) * 7;
                i += (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(7 - wdaymask[i] + wday, 7);
            }
            if (first <= i && i <= last) result.nwdaymask[i] = 1;
        }
    }
    return result;
}


function $2ace9ed2bd5ccbf5$export$443908f369ea7717(y, offset) {
    if (offset === void 0) offset = 0;
    var a = y % 19;
    var b = Math.floor(y / 100);
    var c = y % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = Math.floor(19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = Math.floor(32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = (h + l - 7 * m + 114) % 31 + 1;
    var date = Date.UTC(y, month - 1, day + offset);
    var yearStart = Date.UTC(y, 0, 1);
    return [
        Math.ceil((date - yearStart) / 86400000)
    ];
}




// =============================================================================
// Iterinfo
// =============================================================================
var $ec4172ae161c0db9$var$Iterinfo = /** @class */ function() {
    // eslint-disable-next-line no-empty-function
    function Iterinfo(options) {
        this.options = options;
    }
    Iterinfo.prototype.rebuild = function(year, month) {
        var options = this.options;
        if (year !== this.lastyear) this.yearinfo = (0, $fd4138fbe587efcd$export$eca728367537c59e)(year, options);
        if ((0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(options.bynweekday) && (month !== this.lastmonth || year !== this.lastyear)) {
            var _a = this.yearinfo, yearlen = _a.yearlen, mrange = _a.mrange, wdaymask = _a.wdaymask;
            this.monthinfo = (0, $4d33e314b5cff33c$export$c0eb75a5c675031d)(year, month, yearlen, mrange, wdaymask, options);
        }
        if ((0, $89dc652caabae9cf$export$ee27c052bca048fb)(options.byeaster)) this.eastermask = (0, $2ace9ed2bd5ccbf5$export$443908f369ea7717)(year, options.byeaster);
    };
    Object.defineProperty(Iterinfo.prototype, "lastyear", {
        get: function() {
            return this.monthinfo ? this.monthinfo.lastyear : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "lastmonth", {
        get: function() {
            return this.monthinfo ? this.monthinfo.lastmonth : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "yearlen", {
        get: function() {
            return this.yearinfo.yearlen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "yearordinal", {
        get: function() {
            return this.yearinfo.yearordinal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mrange", {
        get: function() {
            return this.yearinfo.mrange;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "wdaymask", {
        get: function() {
            return this.yearinfo.wdaymask;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mmask", {
        get: function() {
            return this.yearinfo.mmask;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "wnomask", {
        get: function() {
            return this.yearinfo.wnomask;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nwdaymask", {
        get: function() {
            return this.monthinfo ? this.monthinfo.nwdaymask : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nextyearlen", {
        get: function() {
            return this.yearinfo.nextyearlen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "mdaymask", {
        get: function() {
            return this.yearinfo.mdaymask;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Iterinfo.prototype, "nmdaymask", {
        get: function() {
            return this.yearinfo.nmdaymask;
        },
        enumerable: false,
        configurable: true
    });
    Iterinfo.prototype.ydayset = function() {
        return [
            (0, $89dc652caabae9cf$export$d02631cccf789723)(this.yearlen),
            0,
            this.yearlen
        ];
    };
    Iterinfo.prototype.mdayset = function(_, month) {
        var start = this.mrange[month - 1];
        var end = this.mrange[month];
        var set = (0, $89dc652caabae9cf$export$76d90c956114f2c2)(null, this.yearlen);
        for(var i = start; i < end; i++)set[i] = i;
        return [
            set,
            start,
            end
        ];
    };
    Iterinfo.prototype.wdayset = function(year, month, day) {
        // We need to handle cross-year weeks here.
        var set = (0, $89dc652caabae9cf$export$76d90c956114f2c2)(null, this.yearlen + 7);
        var i = (0, $4cf73d2382b09a20$export$f2cd37d9f3227410)((0, $4cf73d2382b09a20$export$7ba4466dbd0f07e1)(year, month, day)) - this.yearordinal;
        var start = i;
        for(var j = 0; j < 7; j++){
            set[i] = i;
            ++i;
            if (this.wdaymask[i] === this.options.wkst) break;
        }
        return [
            set,
            start,
            i
        ];
    };
    Iterinfo.prototype.ddayset = function(year, month, day) {
        var set = (0, $89dc652caabae9cf$export$76d90c956114f2c2)(null, this.yearlen);
        var i = (0, $4cf73d2382b09a20$export$f2cd37d9f3227410)((0, $4cf73d2382b09a20$export$7ba4466dbd0f07e1)(year, month, day)) - this.yearordinal;
        set[i] = i;
        return [
            set,
            i,
            i + 1
        ];
    };
    Iterinfo.prototype.htimeset = function(hour, _, second, millisecond) {
        var _this = this;
        var set = [];
        this.options.byminute.forEach(function(minute) {
            set = set.concat(_this.mtimeset(hour, minute, second, millisecond));
        });
        (0, $4cf73d2382b09a20$export$97db5808d8f88186)(set);
        return set;
    };
    Iterinfo.prototype.mtimeset = function(hour, minute, _, millisecond) {
        var set = this.options.bysecond.map(function(second) {
            return new (0, $829a0d2a13d91e27$export$680ea196effce5f)(hour, minute, second, millisecond);
        });
        (0, $4cf73d2382b09a20$export$97db5808d8f88186)(set);
        return set;
    };
    Iterinfo.prototype.stimeset = function(hour, minute, second, millisecond) {
        return [
            new (0, $829a0d2a13d91e27$export$680ea196effce5f)(hour, minute, second, millisecond)
        ];
    };
    Iterinfo.prototype.getdayset = function(freq) {
        switch(freq){
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).YEARLY:
                return this.ydayset.bind(this);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).MONTHLY:
                return this.mdayset.bind(this);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY:
                return this.wdayset.bind(this);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).DAILY:
                return this.ddayset.bind(this);
            default:
                return this.ddayset.bind(this);
        }
    };
    Iterinfo.prototype.gettimeset = function(freq) {
        switch(freq){
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).HOURLY:
                return this.htimeset.bind(this);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).MINUTELY:
                return this.mtimeset.bind(this);
            case (0, $243d5af73caebe4d$export$44c95d3770756ed2).SECONDLY:
                return this.stimeset.bind(this);
        }
    };
    return Iterinfo;
}();
var $ec4172ae161c0db9$export$2e2bcd8739ae039 = $ec4172ae161c0db9$var$Iterinfo;








function $4131b839a5504aec$export$c0f84614fdc2b889(bysetpos, timeset, start, end, ii, dayset) {
    var poslist = [];
    for(var j = 0; j < bysetpos.length; j++){
        var daypos = void 0;
        var timepos = void 0;
        var pos = bysetpos[j];
        if (pos < 0) {
            daypos = Math.floor(pos / timeset.length);
            timepos = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(pos, timeset.length);
        } else {
            daypos = Math.floor((pos - 1) / timeset.length);
            timepos = (0, $89dc652caabae9cf$export$569bc7c4b94c73c8)(pos - 1, timeset.length);
        }
        var tmp = [];
        for(var k = start; k < end; k++){
            var val = dayset[k];
            if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(val)) continue;
            tmp.push(val);
        }
        var i = void 0;
        if (daypos < 0) i = tmp.slice(daypos)[0];
        else i = tmp[daypos];
        var time = timeset[timepos];
        var date = (0, $4cf73d2382b09a20$export$9ca7d52b87a6fe91)(ii.yearordinal + i);
        var res = (0, $4cf73d2382b09a20$export$1be1fc439b849fdf)(date, time);
        // XXX: can this ever be in the array?
        // - compare the actual date instead?
        if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(poslist, res)) poslist.push(res);
    }
    (0, $4cf73d2382b09a20$export$97db5808d8f88186)(poslist);
    return poslist;
}



function $94a63e6fb9ed324e$export$c0bf298a2e425654(iterResult, options) {
    var dtstart = options.dtstart, freq = options.freq, interval = options.interval, until = options.until, bysetpos = options.bysetpos;
    var count = options.count;
    if (count === 0 || interval === 0) return $94a63e6fb9ed324e$var$emitResult(iterResult);
    var counterDate = (0, $829a0d2a13d91e27$export$82f9ebd9adeba146).fromDate(dtstart);
    var ii = new (0, $ec4172ae161c0db9$export$2e2bcd8739ae039)(options);
    ii.rebuild(counterDate.year, counterDate.month);
    var timeset = $94a63e6fb9ed324e$var$makeTimeset(ii, counterDate, options);
    for(;;){
        var _a = ii.getdayset(freq)(counterDate.year, counterDate.month, counterDate.day), dayset = _a[0], start = _a[1], end = _a[2];
        var filtered = $94a63e6fb9ed324e$var$removeFilteredDays(dayset, start, end, ii, options);
        if ((0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bysetpos)) {
            var poslist = (0, $4131b839a5504aec$export$c0f84614fdc2b889)(bysetpos, timeset, start, end, ii, dayset);
            for(var j = 0; j < poslist.length; j++){
                var res = poslist[j];
                if (until && res > until) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                if (res >= dtstart) {
                    var rezonedDate = $94a63e6fb9ed324e$var$rezoneIfNeeded(res, options);
                    if (!iterResult.accept(rezonedDate)) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                    if (count) {
                        --count;
                        if (!count) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                    }
                }
            }
        } else for(var j = start; j < end; j++){
            var currentDay = dayset[j];
            if (!(0, $89dc652caabae9cf$export$ee27c052bca048fb)(currentDay)) continue;
            var date = (0, $4cf73d2382b09a20$export$9ca7d52b87a6fe91)(ii.yearordinal + currentDay);
            for(var k = 0; k < timeset.length; k++){
                var time = timeset[k];
                var res = (0, $4cf73d2382b09a20$export$1be1fc439b849fdf)(date, time);
                if (until && res > until) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                if (res >= dtstart) {
                    var rezonedDate = $94a63e6fb9ed324e$var$rezoneIfNeeded(res, options);
                    if (!iterResult.accept(rezonedDate)) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                    if (count) {
                        --count;
                        if (!count) return $94a63e6fb9ed324e$var$emitResult(iterResult);
                    }
                }
            }
        }
        if (options.interval === 0) return $94a63e6fb9ed324e$var$emitResult(iterResult);
        // Handle frequency and interval
        counterDate.add(options, filtered);
        if (counterDate.year > (0, $4cf73d2382b09a20$export$9d1fbb900e9d1ae5)) return $94a63e6fb9ed324e$var$emitResult(iterResult);
        if (!(0, $243d5af73caebe4d$export$5d09978a50c416fb)(freq)) timeset = ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, 0);
        ii.rebuild(counterDate.year, counterDate.month);
    }
}
function $94a63e6fb9ed324e$var$isFiltered(ii, currentDay, options) {
    var bymonth = options.bymonth, byweekno = options.byweekno, byweekday = options.byweekday, byeaster = options.byeaster, bymonthday = options.bymonthday, bynmonthday = options.bynmonthday, byyearday = options.byyearday;
    return (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bymonth) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(bymonth, ii.mmask[currentDay]) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byweekno) && !ii.wnomask[currentDay] || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byweekday) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byweekday, ii.wdaymask[currentDay]) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(ii.nwdaymask) && !ii.nwdaymask[currentDay] || byeaster !== null && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(ii.eastermask, currentDay) || ((0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bymonthday) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bynmonthday)) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(bymonthday, ii.mdaymask[currentDay]) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(bynmonthday, ii.nmdaymask[currentDay]) || (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byyearday) && (currentDay < ii.yearlen && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byyearday, currentDay + 1) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byyearday, -ii.yearlen + currentDay) || currentDay >= ii.yearlen && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byyearday, currentDay + 1 - ii.yearlen) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byyearday, -ii.nextyearlen + currentDay - ii.yearlen));
}
function $94a63e6fb9ed324e$var$rezoneIfNeeded(date, options) {
    return new (0, $c8c618d49b808a34$export$8baceac99da2643b)(date, options.tzid).rezonedDate();
}
function $94a63e6fb9ed324e$var$emitResult(iterResult) {
    return iterResult.getValue();
}
function $94a63e6fb9ed324e$var$removeFilteredDays(dayset, start, end, ii, options) {
    var filtered = false;
    for(var dayCounter = start; dayCounter < end; dayCounter++){
        var currentDay = dayset[dayCounter];
        filtered = $94a63e6fb9ed324e$var$isFiltered(ii, currentDay, options);
        if (filtered) dayset[currentDay] = null;
    }
    return filtered;
}
function $94a63e6fb9ed324e$var$makeTimeset(ii, counterDate, options) {
    var freq = options.freq, byhour = options.byhour, byminute = options.byminute, bysecond = options.bysecond;
    if ((0, $243d5af73caebe4d$export$5d09978a50c416fb)(freq)) return (0, $31d825003737e254$export$c4642b52a0dd14c8)(options);
    if (freq >= (0, $e1d5d95ac5f1af89$export$4e942d157960251).HOURLY && (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byhour) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byhour, counterDate.hour) || freq >= (0, $e1d5d95ac5f1af89$export$4e942d157960251).MINUTELY && (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(byminute) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(byminute, counterDate.minute) || freq >= (0, $e1d5d95ac5f1af89$export$4e942d157960251).SECONDLY && (0, $89dc652caabae9cf$export$b29ea735dcfba3c1)(bysecond) && !(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(bysecond, counterDate.second)) return [];
    return ii.gettimeset(freq)(counterDate.hour, counterDate.minute, counterDate.second, counterDate.millisecond);
}


var $e1d5d95ac5f1af89$export$d3134eff2123aadb = {
    MO: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(0),
    TU: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(1),
    WE: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(2),
    TH: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(3),
    FR: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(4),
    SA: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(5),
    SU: new (0, $47606afb7b57d36f$export$94dd8a9f089c7f53)(6)
};
var $e1d5d95ac5f1af89$export$93ca5d3f8675ae4c = {
    freq: (0, $243d5af73caebe4d$export$44c95d3770756ed2).YEARLY,
    dtstart: null,
    interval: 1,
    wkst: $e1d5d95ac5f1af89$export$d3134eff2123aadb.MO,
    count: null,
    until: null,
    tzid: null,
    bysetpos: null,
    bymonth: null,
    bymonthday: null,
    bynmonthday: null,
    byyearday: null,
    byweekno: null,
    byweekday: null,
    bynweekday: null,
    byhour: null,
    byminute: null,
    bysecond: null,
    byeaster: null
};
var $e1d5d95ac5f1af89$export$d5755821cb579984 = Object.keys($e1d5d95ac5f1af89$export$93ca5d3f8675ae4c);
/**
 *
 * @param {Options?} options - see <http://labix.org/python-dateutil/#head-cf004ee9a75592797e076752b2a889c10f445418>
 * - The only required option is `freq`, one of RRule.YEARLY, RRule.MONTHLY, ...
 * @constructor
 */ var $e1d5d95ac5f1af89$export$4e942d157960251 = /** @class */ function() {
    function RRule(options, noCache) {
        if (options === void 0) options = {};
        if (noCache === void 0) noCache = false;
        // RFC string
        this._cache = noCache ? null : new (0, $eea6334ea136904c$export$94affb487e701bf2)();
        // used by toString()
        this.origOptions = (0, $31d825003737e254$export$aeea68bb229a3a4d)(options);
        var parsedOptions = (0, $31d825003737e254$export$49fe41a914eb071d)(options).parsedOptions;
        this.options = parsedOptions;
    }
    RRule.parseText = function(text, language) {
        return (0, $4aa79383bc87ad13$export$2e2bcd8739ae039)(text, language);
    };
    RRule.fromText = function(text, language) {
        return (0, $b64e311919e76d6b$export$7a77aeaf230ddfb9)(text, language);
    };
    RRule.fromString = function(str) {
        return new RRule(RRule.parseString(str) || undefined);
    };
    RRule.prototype._iter = function(iterResult) {
        return (0, $94a63e6fb9ed324e$export$c0bf298a2e425654)(iterResult, this.options);
    };
    RRule.prototype._cacheGet = function(what, args) {
        if (!this._cache) return false;
        return this._cache._cacheGet(what, args);
    };
    RRule.prototype._cacheAdd = function(what, value, args) {
        if (!this._cache) return;
        return this._cache._cacheAdd(what, value, args);
    };
    /**
     * @param {Function} iterator - optional function that will be called
     * on each date that is added. It can return false
     * to stop the iteration.
     * @return Array containing all recurrences.
     */ RRule.prototype.all = function(iterator) {
        if (iterator) return this._iter(new (0, $07dc35e4913bb777$export$2e2bcd8739ae039)('all', {}, iterator));
        var result = this._cacheGet('all');
        if (result === false) {
            result = this._iter(new (0, $484bc730c1f73c01$export$2e2bcd8739ae039)('all', {}));
            this._cacheAdd('all', result);
        }
        return result;
    };
    /**
     * Returns all the occurrences of the rrule between after and before.
     * The inc keyword defines what happens if after and/or before are
     * themselves occurrences. With inc == True, they will be included in the
     * list, if they are found in the recurrence set.
     *
     * @return Array
     */ RRule.prototype.between = function(after, before, inc, iterator) {
        if (inc === void 0) inc = false;
        if (!(0, $4cf73d2382b09a20$export$c03bb0116ee09d4b)(after) || !(0, $4cf73d2382b09a20$export$c03bb0116ee09d4b)(before)) throw new Error('Invalid date passed in to RRule.between');
        var args = {
            before: before,
            after: after,
            inc: inc
        };
        if (iterator) return this._iter(new (0, $07dc35e4913bb777$export$2e2bcd8739ae039)('between', args, iterator));
        var result = this._cacheGet('between', args);
        if (result === false) {
            result = this._iter(new (0, $484bc730c1f73c01$export$2e2bcd8739ae039)('between', args));
            this._cacheAdd('between', result, args);
        }
        return result;
    };
    /**
     * Returns the last recurrence before the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     *
     * @return Date or null
     */ RRule.prototype.before = function(dt, inc) {
        if (inc === void 0) inc = false;
        if (!(0, $4cf73d2382b09a20$export$c03bb0116ee09d4b)(dt)) throw new Error('Invalid date passed in to RRule.before');
        var args = {
            dt: dt,
            inc: inc
        };
        var result = this._cacheGet('before', args);
        if (result === false) {
            result = this._iter(new (0, $484bc730c1f73c01$export$2e2bcd8739ae039)('before', args));
            this._cacheAdd('before', result, args);
        }
        return result;
    };
    /**
     * Returns the first recurrence after the given datetime instance.
     * The inc keyword defines what happens if dt is an occurrence.
     * With inc == True, if dt itself is an occurrence, it will be returned.
     *
     * @return Date or null
     */ RRule.prototype.after = function(dt, inc) {
        if (inc === void 0) inc = false;
        if (!(0, $4cf73d2382b09a20$export$c03bb0116ee09d4b)(dt)) throw new Error('Invalid date passed in to RRule.after');
        var args = {
            dt: dt,
            inc: inc
        };
        var result = this._cacheGet('after', args);
        if (result === false) {
            result = this._iter(new (0, $484bc730c1f73c01$export$2e2bcd8739ae039)('after', args));
            this._cacheAdd('after', result, args);
        }
        return result;
    };
    /**
     * Returns the number of recurrences in this set. It will have go trough
     * the whole recurrence, if this hasn't been done before.
     */ RRule.prototype.count = function() {
        return this.all().length;
    };
    /**
     * Converts the rrule into its string representation
     *
     * @see <http://www.ietf.org/rfc/rfc2445.txt>
     * @return String
     */ RRule.prototype.toString = function() {
        return (0, $08f885112710e87a$export$d1a7f461af1bce85)(this.origOptions);
    };
    /**
     * Will convert all rules described in nlp:ToText
     * to text.
     */ RRule.prototype.toText = function(gettext, language, dateFormatter) {
        return (0, $b64e311919e76d6b$export$598ff36d54604b81)(this, gettext, language, dateFormatter);
    };
    RRule.prototype.isFullyConvertibleToText = function() {
        return (0, $b64e311919e76d6b$export$fb6015ad19349979)(this);
    };
    /**
     * @return a RRule instance with the same freq and options
     * as this one (cache is not cloned)
     */ RRule.prototype.clone = function() {
        return new RRule(this.origOptions);
    };
    // RRule class 'constants'
    RRule.FREQUENCIES = [
        'YEARLY',
        'MONTHLY',
        'WEEKLY',
        'DAILY',
        'HOURLY',
        'MINUTELY',
        'SECONDLY'
    ];
    RRule.YEARLY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).YEARLY;
    RRule.MONTHLY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).MONTHLY;
    RRule.WEEKLY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY;
    RRule.DAILY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).DAILY;
    RRule.HOURLY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).HOURLY;
    RRule.MINUTELY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).MINUTELY;
    RRule.SECONDLY = (0, $243d5af73caebe4d$export$44c95d3770756ed2).SECONDLY;
    RRule.MO = $e1d5d95ac5f1af89$export$d3134eff2123aadb.MO;
    RRule.TU = $e1d5d95ac5f1af89$export$d3134eff2123aadb.TU;
    RRule.WE = $e1d5d95ac5f1af89$export$d3134eff2123aadb.WE;
    RRule.TH = $e1d5d95ac5f1af89$export$d3134eff2123aadb.TH;
    RRule.FR = $e1d5d95ac5f1af89$export$d3134eff2123aadb.FR;
    RRule.SA = $e1d5d95ac5f1af89$export$d3134eff2123aadb.SA;
    RRule.SU = $e1d5d95ac5f1af89$export$d3134eff2123aadb.SU;
    RRule.parseString = (0, $abff7f9048c51f33$export$960addfb9e5a0cde);
    RRule.optionsToString = (0, $08f885112710e87a$export$d1a7f461af1bce85);
    return RRule;
}();



var $7WQrb = parcelRequire("7WQrb");






function $fd19d483241d109c$export$fd46609344feee67(iterResult, _rrule, _exrule, _rdate, _exdate, tzid) {
    var _exdateHash = {};
    var _accept = iterResult.accept;
    function evalExdate(after, before) {
        _exrule.forEach(function(rrule) {
            rrule.between(after, before, true).forEach(function(date) {
                _exdateHash[Number(date)] = true;
            });
        });
    }
    _exdate.forEach(function(date) {
        var zonedDate = new (0, $c8c618d49b808a34$export$8baceac99da2643b)(date, tzid).rezonedDate();
        _exdateHash[Number(zonedDate)] = true;
    });
    iterResult.accept = function(date) {
        var dt = Number(date);
        if (isNaN(dt)) return _accept.call(this, date);
        if (!_exdateHash[dt]) {
            evalExdate(new Date(dt - 1), new Date(dt + 1));
            if (!_exdateHash[dt]) {
                _exdateHash[dt] = true;
                return _accept.call(this, date);
            }
        }
        return true;
    };
    if (iterResult.method === 'between') {
        evalExdate(iterResult.args.after, iterResult.args.before);
        iterResult.accept = function(date) {
            var dt = Number(date);
            if (!_exdateHash[dt]) {
                _exdateHash[dt] = true;
                return _accept.call(this, date);
            }
            return true;
        };
    }
    for(var i = 0; i < _rdate.length; i++){
        var zonedDate = new (0, $c8c618d49b808a34$export$8baceac99da2643b)(_rdate[i], tzid).rezonedDate();
        if (!iterResult.accept(new Date(zonedDate.getTime()))) break;
    }
    _rrule.forEach(function(rrule) {
        (0, $94a63e6fb9ed324e$export$c0bf298a2e425654)(iterResult, rrule.options);
    });
    var res = iterResult._result;
    (0, $4cf73d2382b09a20$export$97db5808d8f88186)(res);
    switch(iterResult.method){
        case 'all':
        case 'between':
            return res;
        case 'before':
            return res.length && res[res.length - 1] || null;
        case 'after':
        default:
            return res.length && res[0] || null;
    }
}



var $7WQrb = parcelRequire("7WQrb");





/**
 * RRuleStr
 * To parse a set of rrule strings
 */ var $d6208ede2c4683f6$var$DEFAULT_OPTIONS = {
    dtstart: null,
    cache: false,
    unfold: false,
    forceset: false,
    compatible: false,
    tzid: null
};
function $d6208ede2c4683f6$export$20bebb8aee8dd3f5(s, options) {
    var rrulevals = [];
    var rdatevals = [];
    var exrulevals = [];
    var exdatevals = [];
    var parsedDtstart = (0, $abff7f9048c51f33$export$50f40aa3339c15e0)(s);
    var dtstart = parsedDtstart.dtstart;
    var tzid = parsedDtstart.tzid;
    var lines = $d6208ede2c4683f6$var$splitIntoLines(s, options.unfold);
    lines.forEach(function(line) {
        var _a;
        if (!line) return;
        var _b = $d6208ede2c4683f6$var$breakDownLine(line), name = _b.name, parms = _b.parms, value = _b.value;
        switch(name.toUpperCase()){
            case 'RRULE':
                if (parms.length) throw new Error("unsupported RRULE parm: ".concat(parms.join(',')));
                rrulevals.push((0, $abff7f9048c51f33$export$960addfb9e5a0cde)(line));
                break;
            case 'RDATE':
                var _c = (_a = /RDATE(?:;TZID=([^:=]+))?/i.exec(line)) !== null && _a !== void 0 ? _a : [], rdateTzid = _c[1];
                if (rdateTzid && !tzid) tzid = rdateTzid;
                rdatevals = rdatevals.concat($d6208ede2c4683f6$var$parseRDate(value, parms));
                break;
            case 'EXRULE':
                if (parms.length) throw new Error("unsupported EXRULE parm: ".concat(parms.join(',')));
                exrulevals.push((0, $abff7f9048c51f33$export$960addfb9e5a0cde)(value));
                break;
            case 'EXDATE':
                exdatevals = exdatevals.concat($d6208ede2c4683f6$var$parseRDate(value, parms));
                break;
            case 'DTSTART':
                break;
            default:
                throw new Error('unsupported property: ' + name);
        }
    });
    return {
        dtstart: dtstart,
        tzid: tzid,
        rrulevals: rrulevals,
        rdatevals: rdatevals,
        exrulevals: exrulevals,
        exdatevals: exdatevals
    };
}
function $d6208ede2c4683f6$var$buildRule(s, options) {
    var _a = $d6208ede2c4683f6$export$20bebb8aee8dd3f5(s, options), rrulevals = _a.rrulevals, rdatevals = _a.rdatevals, exrulevals = _a.exrulevals, exdatevals = _a.exdatevals, dtstart = _a.dtstart, tzid = _a.tzid;
    var noCache = options.cache === false;
    if (options.compatible) {
        options.forceset = true;
        options.unfold = true;
    }
    if (options.forceset || rrulevals.length > 1 || rdatevals.length || exrulevals.length || exdatevals.length) {
        var rset_1 = new (0, $6cf20782ecbf4eb3$export$46546bf41642e5dd)(noCache);
        rset_1.dtstart(dtstart);
        rset_1.tzid(tzid || undefined);
        rrulevals.forEach(function(val) {
            rset_1.rrule(new (0, $e1d5d95ac5f1af89$export$4e942d157960251)($d6208ede2c4683f6$var$groomRruleOptions(val, dtstart, tzid), noCache));
        });
        rdatevals.forEach(function(date) {
            rset_1.rdate(date);
        });
        exrulevals.forEach(function(val) {
            rset_1.exrule(new (0, $e1d5d95ac5f1af89$export$4e942d157960251)($d6208ede2c4683f6$var$groomRruleOptions(val, dtstart, tzid), noCache));
        });
        exdatevals.forEach(function(date) {
            rset_1.exdate(date);
        });
        if (options.compatible && options.dtstart) rset_1.rdate(dtstart);
        return rset_1;
    }
    var val = rrulevals[0] || {};
    return new (0, $e1d5d95ac5f1af89$export$4e942d157960251)($d6208ede2c4683f6$var$groomRruleOptions(val, val.dtstart || options.dtstart || dtstart, val.tzid || options.tzid || tzid), noCache);
}
function $d6208ede2c4683f6$export$fc5ce4cf349388d1(s, options) {
    if (options === void 0) options = {};
    return $d6208ede2c4683f6$var$buildRule(s, $d6208ede2c4683f6$var$initializeOptions(options));
}
function $d6208ede2c4683f6$var$groomRruleOptions(val, dtstart, tzid) {
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, val), {
        dtstart: dtstart,
        tzid: tzid
    });
}
function $d6208ede2c4683f6$var$initializeOptions(options) {
    var invalid = [];
    var keys = Object.keys(options);
    var defaultKeys = Object.keys($d6208ede2c4683f6$var$DEFAULT_OPTIONS);
    keys.forEach(function(key) {
        if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(defaultKeys, key)) invalid.push(key);
    });
    if (invalid.length) throw new Error('Invalid options: ' + invalid.join(', '));
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, $d6208ede2c4683f6$var$DEFAULT_OPTIONS), options);
}
function $d6208ede2c4683f6$var$extractName(line) {
    if (line.indexOf(':') === -1) return {
        name: 'RRULE',
        value: line
    };
    var _a = (0, $89dc652caabae9cf$export$65980d18b75784e2)(line, ':', 1), name = _a[0], value = _a[1];
    return {
        name: name,
        value: value
    };
}
function $d6208ede2c4683f6$var$breakDownLine(line) {
    var _a = $d6208ede2c4683f6$var$extractName(line), name = _a.name, value = _a.value;
    var parms = name.split(';');
    if (!parms) throw new Error('empty property name');
    return {
        name: parms[0].toUpperCase(),
        parms: parms.slice(1),
        value: value
    };
}
function $d6208ede2c4683f6$var$splitIntoLines(s, unfold) {
    if (unfold === void 0) unfold = false;
    s = s && s.trim();
    if (!s) throw new Error('Invalid empty string');
    // More info about 'unfold' option
    // Go head to http://www.ietf.org/rfc/rfc2445.txt
    if (!unfold) return s.split(/\s/);
    var lines = s.split('\n');
    var i = 0;
    while(i < lines.length){
        // TODO
        var line = lines[i] = lines[i].replace(/\s+$/g, '');
        if (!line) lines.splice(i, 1);
        else if (i > 0 && line[0] === ' ') {
            lines[i - 1] += line.slice(1);
            lines.splice(i, 1);
        } else i += 1;
    }
    return lines;
}
function $d6208ede2c4683f6$var$validateDateParm(parms) {
    parms.forEach(function(parm) {
        if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(parm)) throw new Error('unsupported RDATE/EXDATE parm: ' + parm);
    });
}
function $d6208ede2c4683f6$var$parseRDate(rdateval, parms) {
    $d6208ede2c4683f6$var$validateDateParm(parms);
    return rdateval.split(',').map(function(datestr) {
        return (0, $4cf73d2382b09a20$export$1e820f1e902c56e0)(datestr);
    });
}



function $6cf20782ecbf4eb3$var$createGetterSetter(fieldName) {
    var _this = this;
    return function(field) {
        if (field !== undefined) _this["_".concat(fieldName)] = field;
        if (_this["_".concat(fieldName)] !== undefined) return _this["_".concat(fieldName)];
        for(var i = 0; i < _this._rrule.length; i++){
            var field_1 = _this._rrule[i].origOptions[fieldName];
            if (field_1) return field_1;
        }
    };
}
var $6cf20782ecbf4eb3$export$46546bf41642e5dd = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(RRuleSet, _super);
    /**
     *
     * @param {Boolean?} noCache
     * The same stratagy as RRule on cache, default to false
     * @constructor
     */ function RRuleSet(noCache) {
        if (noCache === void 0) noCache = false;
        var _this = _super.call(this, {}, noCache) || this;
        _this.dtstart = $6cf20782ecbf4eb3$var$createGetterSetter.apply(_this, [
            'dtstart'
        ]);
        _this.tzid = $6cf20782ecbf4eb3$var$createGetterSetter.apply(_this, [
            'tzid'
        ]);
        _this._rrule = [];
        _this._rdate = [];
        _this._exrule = [];
        _this._exdate = [];
        return _this;
    }
    RRuleSet.prototype._iter = function(iterResult) {
        return (0, $fd19d483241d109c$export$fd46609344feee67)(iterResult, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    };
    /**
     * Adds an RRule to the set
     *
     * @param {RRule}
     */ RRuleSet.prototype.rrule = function(rrule) {
        $6cf20782ecbf4eb3$var$_addRule(rrule, this._rrule);
    };
    /**
     * Adds an EXRULE to the set
     *
     * @param {RRule}
     */ RRuleSet.prototype.exrule = function(rrule) {
        $6cf20782ecbf4eb3$var$_addRule(rrule, this._exrule);
    };
    /**
     * Adds an RDate to the set
     *
     * @param {Date}
     */ RRuleSet.prototype.rdate = function(date) {
        $6cf20782ecbf4eb3$var$_addDate(date, this._rdate);
    };
    /**
     * Adds an EXDATE to the set
     *
     * @param {Date}
     */ RRuleSet.prototype.exdate = function(date) {
        $6cf20782ecbf4eb3$var$_addDate(date, this._exdate);
    };
    /**
     * Get list of included rrules in this recurrence set.
     *
     * @return List of rrules
     */ RRuleSet.prototype.rrules = function() {
        return this._rrule.map(function(e) {
            return (0, $d6208ede2c4683f6$export$fc5ce4cf349388d1)(e.toString());
        });
    };
    /**
     * Get list of excluded rrules in this recurrence set.
     *
     * @return List of exrules
     */ RRuleSet.prototype.exrules = function() {
        return this._exrule.map(function(e) {
            return (0, $d6208ede2c4683f6$export$fc5ce4cf349388d1)(e.toString());
        });
    };
    /**
     * Get list of included datetimes in this recurrence set.
     *
     * @return List of rdates
     */ RRuleSet.prototype.rdates = function() {
        return this._rdate.map(function(e) {
            return new Date(e.getTime());
        });
    };
    /**
     * Get list of included datetimes in this recurrence set.
     *
     * @return List of exdates
     */ RRuleSet.prototype.exdates = function() {
        return this._exdate.map(function(e) {
            return new Date(e.getTime());
        });
    };
    RRuleSet.prototype.valueOf = function() {
        var result = [];
        if (!this._rrule.length && this._dtstart) result = result.concat((0, $08f885112710e87a$export$d1a7f461af1bce85)({
            dtstart: this._dtstart
        }));
        this._rrule.forEach(function(rrule) {
            result = result.concat(rrule.toString().split('\n'));
        });
        this._exrule.forEach(function(exrule) {
            result = result.concat(exrule.toString().split('\n').map(function(line) {
                return line.replace(/^RRULE:/, 'EXRULE:');
            }).filter(function(line) {
                return !/^DTSTART/.test(line);
            }));
        });
        if (this._rdate.length) result.push($6cf20782ecbf4eb3$var$rdatesToString('RDATE', this._rdate, this.tzid()));
        if (this._exdate.length) result.push($6cf20782ecbf4eb3$var$rdatesToString('EXDATE', this._exdate, this.tzid()));
        return result;
    };
    /**
     * to generate recurrence field such as:
     * DTSTART:19970902T010000Z
     * RRULE:FREQ=YEARLY;COUNT=2;BYDAY=TU
     * RRULE:FREQ=YEARLY;COUNT=1;BYDAY=TH
     */ RRuleSet.prototype.toString = function() {
        return this.valueOf().join('\n');
    };
    /**
     * Create a new RRuleSet Object completely base on current instance
     */ RRuleSet.prototype.clone = function() {
        var rrs = new RRuleSet(!!this._cache);
        this._rrule.forEach(function(rule) {
            return rrs.rrule(rule.clone());
        });
        this._exrule.forEach(function(rule) {
            return rrs.exrule(rule.clone());
        });
        this._rdate.forEach(function(date) {
            return rrs.rdate(new Date(date.getTime()));
        });
        this._exdate.forEach(function(date) {
            return rrs.exdate(new Date(date.getTime()));
        });
        return rrs;
    };
    return RRuleSet;
}((0, $e1d5d95ac5f1af89$export$4e942d157960251));
function $6cf20782ecbf4eb3$var$_addRule(rrule, collection) {
    if (!(rrule instanceof (0, $e1d5d95ac5f1af89$export$4e942d157960251))) throw new TypeError(String(rrule) + ' is not RRule instance');
    if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(collection.map(String), String(rrule))) collection.push(rrule);
}
function $6cf20782ecbf4eb3$var$_addDate(date, collection) {
    if (!(date instanceof Date)) throw new TypeError(String(date) + ' is not Date instance');
    if (!(0, $89dc652caabae9cf$export$ee2e0f811dca1807)(collection.map(Number), Number(date))) {
        collection.push(date);
        (0, $4cf73d2382b09a20$export$97db5808d8f88186)(collection);
    }
}
function $6cf20782ecbf4eb3$var$rdatesToString(param, rdates, tzid) {
    var isUTC = !tzid || tzid.toUpperCase() === 'UTC';
    var header = isUTC ? "".concat(param, ":") : "".concat(param, ";TZID=").concat(tzid, ":");
    var dateString = rdates.map(function(rdate) {
        return (0, $4cf73d2382b09a20$export$478f3a4b1337ed12)(rdate.valueOf(), isUTC);
    }).join(',');
    return "".concat(header).concat(dateString);
}









var $2zDt6 = parcelRequire("2zDt6");

var $3s7Tn = parcelRequire("3s7Tn");

var $f4Eh3 = parcelRequire("f4Eh3");
var $g04kv = parcelRequire("g04kv");


var $7pTac = parcelRequire("7pTac");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $22i8b = parcelRequire("22i8b");

var $kZugz = parcelRequire("kZugz");
const $9b2c8225b340b40e$export$ef9b1a59e592288f = ({ children: children, name: name, label: label, ...muiSelectProps })=>{
    const { field: field, fieldState: { error: error } } = (0, $22i8b.useController)({
        name: name
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
        fullWidth: true,
        select: true,
        ...muiSelectProps,
        label: label,
        error: Boolean(error),
        helperText: error?.message,
        ...field,
        value: field.value ?? '',
        children: children
    });
};



var $e3HVo = parcelRequire("e3HVo");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $22i8b = parcelRequire("22i8b");



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8bslU = parcelRequire("8bslU");

var $c9Z8w = parcelRequire("c9Z8w");
const $d29eef8283105e84$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
]);
var $d29eef8283105e84$export$2e2bcd8739ae039 = $d29eef8283105e84$var$refType;



var $gJm6V = parcelRequire("gJm6V");


const $38ae9feef3ab2fb0$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $38ae9feef3ab2fb0$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $b8d019f986eaf72a$export$a98b123b8f29e004 = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
const $b8d019f986eaf72a$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, adapter: adapter, timezone: timezone })=>{
    const today = $b8d019f986eaf72a$export$a98b123b8f29e004(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
const $b8d019f986eaf72a$export$36ca889e039badd5 = (adapter, value)=>!adapter.isValid(value) ? null : value;
const $b8d019f986eaf72a$export$eb73579ccade48fd = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
const $b8d019f986eaf72a$export$8fabf9a4cbada414 = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
const $b8d019f986eaf72a$export$62591b96a734eacd = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
const $b8d019f986eaf72a$export$1118e4272ea1e258 = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
const $b8d019f986eaf72a$export$fae94c0a662107ef = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
const $b8d019f986eaf72a$export$76f4ff1fc64d3035 = [
    'year',
    'month',
    'day'
];
const $b8d019f986eaf72a$export$b32dfef9f07dea64 = (view)=>$b8d019f986eaf72a$export$76f4ff1fc64d3035.includes(view);
const $b8d019f986eaf72a$export$bb1c921f313ec928 = (adapter, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $b8d019f986eaf72a$export$24c38139da66592d = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};



const $d83ac1c1cf9e346e$export$cf292de8b6883a7f = [
    'hours',
    'minutes',
    'seconds'
];
const $d83ac1c1cf9e346e$export$570ec1747e4b1938 = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const $d83ac1c1cf9e346e$export$8f04d380cefd5a0d = (view)=>$d83ac1c1cf9e346e$export$cf292de8b6883a7f.includes(view);
const $d83ac1c1cf9e346e$export$a3328136ac50623d = (view)=>$d83ac1c1cf9e346e$export$570ec1747e4b1938.includes(view);
const $d83ac1c1cf9e346e$export$c3352ead7b032236 = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
const $d83ac1c1cf9e346e$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $d83ac1c1cf9e346e$export$c368d4ff66779998 = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = $d83ac1c1cf9e346e$export$4159dc823695870e(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
const $d83ac1c1cf9e346e$export$888a1ce13aa61986 = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
const $d83ac1c1cf9e346e$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return $d83ac1c1cf9e346e$export$888a1ce13aa61986(dateLeft, adapter) > $d83ac1c1cf9e346e$export$888a1ce13aa61986(dateRight, adapter);
    };
const $d83ac1c1cf9e346e$export$3a6776b3863772fe = (adapter, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $66a7cb510b2c76f4$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $66a7cb510b2c76f4$var$roundDate = (adapter, granularity, date)=>{
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.year) return adapter.startOfYear(date);
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.month) return adapter.startOfMonth(date);
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $66a7cb510b2c76f4$export$6a31d56794238e4e = ({ props: props, adapter: adapter, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $66a7cb510b2c76f4$var$roundDate(adapter, granularity, (0, $b8d019f986eaf72a$export$1118e4272ea1e258)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.maxDate);
    const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};



const $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6 = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $4a0e020deed3b4b7$export$c65c7173f879039f = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
const $4a0e020deed3b4b7$export$3ee1e7e19c2b047a = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $4a0e020deed3b4b7$export$b918512475916205 = 's';
const $4a0e020deed3b4b7$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $4a0e020deed3b4b7$export$b42be9ae7016ef5d = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), $4a0e020deed3b4b7$export$b918512475916205);
    if (formattedZero === '0') return $4a0e020deed3b4b7$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), $4a0e020deed3b4b7$export$b918512475916205));
};
const $4a0e020deed3b4b7$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const $4a0e020deed3b4b7$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const $4a0e020deed3b4b7$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $4a0e020deed3b4b7$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $4a0e020deed3b4b7$export$713c6d756c12fc27 = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
const $4a0e020deed3b4b7$export$ef88db4bceade9fd = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $4a0e020deed3b4b7$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $4a0e020deed3b4b7$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $4a0e020deed3b4b7$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($4a0e020deed3b4b7$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $4a0e020deed3b4b7$export$2816862a602354ce = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
const $4a0e020deed3b4b7$var$isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const $4a0e020deed3b4b7$export$78b5830e2dd2de49 = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $4a0e020deed3b4b7$export$b0c1bfd065bfe742 = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($4a0e020deed3b4b7$export$85daa91f6c6e875f(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $4a0e020deed3b4b7$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const $4a0e020deed3b4b7$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $4a0e020deed3b4b7$export$85daa91f6c6e875f(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $4a0e020deed3b4b7$export$360600f456ea7d5f = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $4a0e020deed3b4b7$var$isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const hasMeridiem = $4a0e020deed3b4b7$export$7dd321105a319e8(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($4a0e020deed3b4b7$export$7dd321105a319e8(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $4a0e020deed3b4b7$var$warnedOnceInvalidSection = false;
const $4a0e020deed3b4b7$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $4a0e020deed3b4b7$var$transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = $4a0e020deed3b4b7$export$713c6d756c12fc27(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = adapter.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = adapter.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return adapter.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return adapter.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $4a0e020deed3b4b7$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $4a0e020deed3b4b7$export$6c6df982c77f60a9 = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$4a0e020deed3b4b7$var$reliableSectionModificationOrder[a.type] - $4a0e020deed3b4b7$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $4a0e020deed3b4b7$var$transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $4a0e020deed3b4b7$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes('android');
const $4a0e020deed3b4b7$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $4a0e020deed3b4b7$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};


const $235c2ad72f19522e$var$_excluded = [
    "value",
    "referenceDate"
];
const $235c2ad72f19522e$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $b8d019f986eaf72a$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $235c2ad72f19522e$var$_excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $66a7cb510b2c76f4$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $b8d019f986eaf72a$export$36ca889e039badd5),
    areValuesEqual: (0, $b8d019f986eaf72a$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const $235c2ad72f19522e$export$b602c94f557316b4 = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: (0, $4a0e020deed3b4b7$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $4a0e020deed3b4b7$export$7ffdf006c6dc825f),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
                value: ''
            }))
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $3qSdM = parcelRequire("3qSdM");

var $13KXh = parcelRequire("13KXh");

var $eEJPp = parcelRequire("eEJPp");


var $6zeBo = parcelRequire("6zeBo");
function $7c44784990d74e44$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $7c44784990d74e44$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $7c44784990d74e44$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $7c44784990d74e44$var$getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $7c44784990d74e44$var$getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
const $7c44784990d74e44$export$cd4e5573fbe2b576 = (node)=>{
    return $7c44784990d74e44$var$getActiveElementInternal((0, $6zeBo.default)(node));
};
const $7c44784990d74e44$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($7c44784990d74e44$export$cd4e5573fbe2b576(listElement));
};
const $7c44784990d74e44$export$9ae5b19305db48ce = '@media (pointer: fine)';
function $7c44784990d74e44$export$3da104473fe9d2e8(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}




var $acw62 = parcelRequire("acw62");
const $ddd12d3841a65e00$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $ddd12d3841a65e00$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $ddd12d3841a65e00$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $ddd12d3841a65e00$var$VALIDATION_PROP_NAMES = [
    ...$ddd12d3841a65e00$export$430d9fc64cf058d6,
    ...$ddd12d3841a65e00$export$fd5e0f8b4115a8c7,
    ...$ddd12d3841a65e00$export$1df62d3ba2121371
];
const $ddd12d3841a65e00$export$5890f750904acddb = (props)=>$ddd12d3841a65e00$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


'use client';
const $d87bf966383f793e$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
const $d87bf966383f793e$export$be857fabf132acea = (props, valueType)=>{
    return $acw62.useMemo(()=>{
        const forwardedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $d87bf966383f793e$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, $ddd12d3841a65e00$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === 'time') (0, $ddd12d3841a65e00$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, $ddd12d3841a65e00$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $ddd12d3841a65e00$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $ddd12d3841a65e00$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
}; /**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ 




var $13KXh = parcelRequire("13KXh");



var $acw62 = parcelRequire("acw62");

const $64a485abd5675192$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $0390a67dda8aa0eb$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $0390a67dda8aa0eb$export$1af4c7e47ad72f44 = $0390a67dda8aa0eb$var$enUSPickers;
const $0390a67dda8aa0eb$export$137380d9ce54f7f = (0, $64a485abd5675192$export$67c96d35a1b010b3)($0390a67dda8aa0eb$var$enUSPickers);



'use client';
const $75a4cb957586789c$export$4b5a24245de9f7f9 = ()=>{
    const localization = $acw62.useContext((0, $b713746033a911a9$export$41298298dbe382b));
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.adapter === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $0390a67dda8aa0eb$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $75a4cb957586789c$export$e5c01b0ea0b41b2b = ()=>$75a4cb957586789c$export$4b5a24245de9f7f9().adapter;


const $5fd1fe7e071df6b9$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $5fd1fe7e071df6b9$export$66d00048b8bb82f6 = ({ stateResponse: { localizedDigits: // States and derived states
localizedDigits, sectionsValueBoundaries: sectionsValueBoundaries, state: state, timezone: timezone, setCharacterQuery: // Methods to update the states
setCharacterQuery, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue } })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $4a0e020deed3b4b7$export$3ee1e7e19c2b047a)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $4a0e020deed3b4b7$export$2816862a602354ce)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue: queryValue, skipIfBelowMinimum: skipIfBelowMinimum, section: section })=>{
            const cleanQueryValue = (0, $4a0e020deed3b4b7$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $4a0e020deed3b4b7$export$ef88db4bceade9fd)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue: queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $4a0e020deed3b4b7$export$78b5830e2dd2de49)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4a0e020deed3b4b7$export$2816862a602354ce)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4a0e020deed3b4b7$export$c65c7173f879039f)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $4a0e020deed3b4b7$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    return (0, $13KXh.default)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, $4a0e020deed3b4b7$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $4a0e020deed3b4b7$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section: section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
}; /**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */  /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ 




var $acw62 = parcelRequire("acw62");

var $agZ85 = parcelRequire("agZ85");

var $lHOu3 = parcelRequire("lHOu3");

var $13KXh = parcelRequire("13KXh");

var $58lXc = parcelRequire("58lXc");

'use client';
const $66648da3b075d888$export$a795e6ca852975b9 = ()=>(0, $75a4cb957586789c$export$4b5a24245de9f7f9)().localeText;





const $2d53cb473eb5b582$var$expandFormat = ({ adapter: adapter, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const $2d53cb473eb5b582$var$getEscapedPartsFromFormat = ({ adapter: adapter, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $2d53cb473eb5b582$var$getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $2d53cb473eb5b582$var$createSection = ({ adapter: adapter, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6)(adapter, token);
    const hasLeadingZerosInFormat = (0, $4a0e020deed3b4b7$export$78b5830e2dd2de49)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $4a0e020deed3b4b7$export$80dbbc19eba82070)((0, $4a0e020deed3b4b7$export$713c6d756c12fc27)((0, $4a0e020deed3b4b7$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $2d53cb473eb5b582$var$getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $2d53cb473eb5b582$var$buildSections = (parameters)=>{
    const { adapter: adapter, expandedFormat: expandedFormat, escapedParts: escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($2d53cb473eb5b582$var$createSection((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $2d53cb473eb5b582$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $2d53cb473eb5b582$export$34084be60bfe3b3b = (parameters)=>{
    let expandedFormat = $2d53cb473eb5b582$var$expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $2d53cb473eb5b582$var$getEscapedPartsFromFormat((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat
    }));
    const sections = $2d53cb473eb5b582$var$buildSections((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $2d53cb473eb5b582$var$postProcessSections((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        sections: sections
    }));
};



var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

'use client';
function $3811c2c4b61492d0$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const previousValidationErrorRef = $acw62.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $acw62.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $13KXh.default)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}



var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $agZ85 = parcelRequire("agZ85");

const $f4770a33870ed562$export$ac06ac6808815c7c = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const [valueWithInputTimezone, setValue] = (0, $agZ85.default)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = $acw62.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, $13KXh.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = $acw62.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = $acw62.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, $13KXh.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};



'use client';
const $7a048fc6e80d7310$var$QUERY_LIFE_DURATION_MS = 5000;
const $7a048fc6e80d7310$export$4e8d6353e50062e7 = (parameters)=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const isRtl = (0, $58lXc.useRtl)();
    const { manager: { validator: validator, valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const valueRef = $acw62.useRef(value);
    $acw62.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError: hasValidationError } = (0, $3811c2c4b61492d0$export$87fe492f99f25a20)({
        props: internalPropsWithDefaults,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: internalPropsWithDefaults.onError
    });
    const error = $acw62.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (errorProp !== undefined) return errorProp;
        return hasValidationError;
    }, [
        hasValidationError,
        errorProp
    ]);
    const localizedDigits = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$b42be9ae7016ef5d)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$360600f456ea7d5f)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $acw62.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, $2d53cb473eb5b582$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, $4a0e020deed3b4b7$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format: format,
                isRtl: isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, $66a7cb510b2c76f4$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: value,
            adapter: adapter,
            props: internalPropsWithDefaults,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $agZ85.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = $acw62.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter: adapter,
                value: newValue,
                timezone: timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = $acw62.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, $lHOu3.default)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, $2d53cb473eb5b582$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $4a0e020deed3b4b7$export$6c6df982c77f60a9)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, $lHOu3.default)();
    const updateSectionValue = ({ section: section, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, $4a0e020deed3b4b7$export$b0c1bfd065bfe742)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, $4a0e020deed3b4b7$export$6c6df982c77f60a9)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `null`.
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, null));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    const setCharacterQuery = (0, $13KXh.default)((newCharacterQuery)=>{
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
        let sections;
        if (isActiveDateInvalid) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                lastExternalValue: value,
                sections: sections,
                sectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, $4a0e020deed3b4b7$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                lastSectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                sections: sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    $acw62.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, $lHOu3.default)();
    $acw62.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start($7a048fc6e80d7310$var$QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $acw62.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        activeSectionIndex: // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty: areAllSectionsEmpty,
        error: error,
        localizedDigits: localizedDigits,
        parsedSelectedSections: parsedSelectedSections,
        sectionOrder: sectionOrder,
        sectionsValueBoundaries: sectionsValueBoundaries,
        state: state,
        timezone: timezone,
        value: value,
        clearValue: // Methods to update the states
        clearValue,
        clearActiveSection: clearActiveSection,
        setCharacterQuery: setCharacterQuery,
        setSelectedSections: setSelectedSections,
        setTempAndroidValueStr: setTempAndroidValueStr,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        getSectionsFromValue: // Utilities methods
        getSectionsFromValue
    };
};




var $acw62 = parcelRequire("acw62");

var $3qSdM = parcelRequire("3qSdM");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $bc077554c64169c5$export$b72b8dade9393cd5 = /*#__PURE__*/ $acw62.createContext(null);
const $bc077554c64169c5$export$4495bebe53492ac8 = ()=>{
    const value = $acw62.useContext($bc077554c64169c5$export$b72b8dade9393cd5);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};


'use client';
const $38272c59950c5653$export$20c6f014e602a134 = ()=>$acw62.useContext((0, $bc077554c64169c5$export$b72b8dade9393cd5));



var $acw62 = parcelRequire("acw62");
'use client';
const $20b835eaf21df543$export$263a5df151942441 = /*#__PURE__*/ $acw62.createContext(null);
function $20b835eaf21df543$export$700ab01cf24fdb1() {
    return $acw62.useContext($20b835eaf21df543$export$263a5df151942441);
}


function $31671c418f538ceb$export$e2fe2bbcb0489bc7(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps: internalProps, skipContextFieldRefAssignment: skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const fieldPrivateContext = (0, $20b835eaf21df543$export$700ab01cf24fdb1)();
    const handleFieldRef = (0, $3qSdM.default)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = $acw62.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = $acw62.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}



var $6zeBo = parcelRequire("6zeBo");

function $0536e200dfbb7842$export$ce8bf2f461033ebb(parameters) {
    const { focused: focused, domGetters: domGetters, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, state: state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, $6zeBo.default)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}



var $13KXh = parcelRequire("13KXh");

var $lHOu3 = parcelRequire("lHOu3");

var $13KXh = parcelRequire("13KXh");


function $259504e265932f66$export$35b4b3d12d0cd3bd(parameters) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep: minutesStep, disabled: disabled, readOnly: readOnly }, stateResponse: { state: // States and derived states
    state, value: value, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone, sectionOrder: sectionOrder, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue } } = parameters;
    return (0, $13KXh.default)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = $259504e265932f66$var$adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function $259504e265932f66$var$getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function $259504e265932f66$var$adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = $259504e265932f66$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, $4a0e020deed3b4b7$export$ef88db4bceade9fd)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, $4a0e020deed3b4b7$export$7dd321105a319e8)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, $4a0e020deed3b4b7$export$3ee1e7e19c2b047a)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}




function $3deb6ecb213f842a$export$45510bb94d9a4b66(parameters) {
    const { manager: manager, focused: focused, setFocused: setFocused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, internalPropsWithDefaults: internalPropsWithDefaults, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionOrder: sectionOrder, state: state, clearValue: // Methods to update the states
    clearValue, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, $259504e265932f66$export$35b4b3d12d0cd3bd)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const containerClickTimeout = (0, $lHOu3.default)();
    const handleClick = (0, $13KXh.default)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, $13KXh.default)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, $13KXh.default)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, $13KXh.default)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, $13KXh.default)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}



var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");
function $73c4b20a15544393$export$9c7e79f1afdc4487(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, state: state, updateValueFromValueStr: // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, $13KXh.default)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $acw62.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}



var $acw62 = parcelRequire("acw62");
function $3e4c3a1655c6f6d0$export$b8da0597bcdfa361(parameters) {
    const { stateResponse: { setSelectedSections: // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled: disabled = false } } = parameters;
    const createHandleClick = $acw62.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $acw62.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}



var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");


function $90a949e99722d90f$export$ef10e76e860835f1(parameters) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { focused: focused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, state: state, value: value, clearActiveSection: // Methods to update the states
    clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $13KXh.default)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    const handleInput = (0, $13KXh.default)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, $13KXh.default)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, $13KXh.default)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, $13KXh.default)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = $acw62.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $acw62.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-readonly': readOnly,
            'aria-valuenow': $90a949e99722d90f$var$getSectionValueNow(section, adapter),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? $90a949e99722d90f$var$getSectionValueText(section, adapter) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            autoCapitalize: isEditable ? 'off' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function $90a949e99722d90f$var$getSectionValueText(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') {
                    const dateWithMonth = adapter.setMonth(adapter.date(), Number(section.value) - 1);
                    return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, 'month') : '';
                }
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            if (section.contentType === 'digit') {
                const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number(section.value));
                return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, 'dayOfMonthFull') : '';
            }
            return section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function $90a949e99722d90f$var$getSectionValueNow(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}


'use client';
const $6837d80005de3c6f$export$3b5f62b9baf9717e = (parameters)=>{
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $d87bf966383f793e$export$be857fabf132acea)(props, valueType);
    const internalPropsWithDefaults = (0, $31671c418f538ceb$export$e2fe2bbcb0489bc7)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable } = forwardedProps;
    const { disabled: disabled = false, readOnly: readOnly = false, autoFocus: autoFocus = false, focused: focusedProp, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = $acw62.useRef(null);
    const handleSectionListRef = (0, $3qSdM.default)(sectionListRefProp, sectionListRef);
    const domGetters = $acw62.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, $7a048fc6e80d7310$export$4e8d6353e50062e7)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, error: error, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, setSelectedSections: setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, $5fd1fe7e071df6b9$export$66d00048b8bb82f6)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = $acw62.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        $6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, $3deb6ecb213f842a$export$45510bb94d9a4b66)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        focused: focused,
        setFocused: setFocused,
        domGetters: domGetters
    });
    const hiddenInputProps = (0, $73c4b20a15544393$export$9c7e79f1afdc4487)({
        manager: manager,
        stateResponse: stateResponse
    });
    const createSectionContainerProps = (0, $3e4c3a1655c6f6d0$export$b8da0597bcdfa361)({
        stateResponse: stateResponse,
        internalPropsWithDefaults: internalPropsWithDefaults
    });
    const createSectionContentProps = (0, $90a949e99722d90f$export$ef10e76e860835f1)({
        manager: manager,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        internalPropsWithDefaults: internalPropsWithDefaults,
        domGetters: domGetters,
        focused: focused
    });
    const handleRootKeyDown = (0, $13KXh.default)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, $13KXh.default)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, $13KXh.default)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, $13KXh.default)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, $13KXh.default)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, $13KXh.default)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, $13KXh.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$6837d80005de3c6f$var$isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = $acw62.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    $acw62.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $eEJPp.default)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, $eEJPp.default)(()=>{
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    $acw62.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>$6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField: focusField,
            isFieldFocused: ()=>$6837d80005de3c6f$var$isFieldFocused(sectionListRef)
        }));
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements: elements,
        areAllSectionsEmpty: areAllSectionsEmpty,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
function $6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(sectionListRef.current?.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function $6837d80005de3c6f$var$isFieldFocused(sectionListRef) {
    const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(sectionListRef.current?.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}




var $acw62 = parcelRequire("acw62");

var $58lXc = parcelRequire("58lXc");

var $eEJPp = parcelRequire("eEJPp");

var $13KXh = parcelRequire("13KXh");

var $lHOu3 = parcelRequire("lHOu3");

var $3qSdM = parcelRequire("3qSdM");







'use client';
const $691502d482840442$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $691502d482840442$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $4a0e020deed3b4b7$export$85daa91f6c6e875f)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $691502d482840442$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $691502d482840442$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $691502d482840442$export$4995d3b7b56fcd3f = (parameters)=>{
    const isRtl = (0, $58lXc.useRtl)();
    const focusTimeout = (0, $lHOu3.default)();
    const selectionSyncTimeout = (0, $lHOu3.default)();
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $d87bf966383f793e$export$be857fabf132acea)(props, valueType);
    const internalPropsWithDefaults = (0, $31671c418f538ceb$export$e2fe2bbcb0489bc7)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly: readOnly = false, disabled: disabled = false, autoFocus: autoFocus = false, focused: focused, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(inputRefProp, inputRef);
    const stateResponse = (0, $7a048fc6e80d7310$export$4e8d6353e50062e7)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { activeSectionIndex: // States and derived states
    activeSectionIndex, areAllSectionsEmpty: areAllSectionsEmpty, error: error, localizedDigits: localizedDigits, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, getSectionsFromValue: // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, $5fd1fe7e071df6b9$export$66d00048b8bb82f6)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = $acw62.useMemo(()=>$691502d482840442$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, $13KXh.default)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $13KXh.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $13KXh.default)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $13KXh.default)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $13KXh.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $691502d482840442$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $691502d482840442$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $691502d482840442$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $691502d482840442$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $4a0e020deed3b4b7$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, $13KXh.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$691502d482840442$var$isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, $259504e265932f66$export$35b4b3d12d0cd3bd)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, $13KXh.default)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = $acw62.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $acw62.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $acw62.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $eEJPp.default)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = $acw62.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $acw62.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField: focusField,
            isFieldFocused: ()=>$691502d482840442$var$isFieldFocused(inputRef)
        }));
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, forwardedProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder: placeholder,
        inputMode: inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused: focused,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
function $691502d482840442$var$isFieldFocused(inputRef) {
    return inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current);
}



const $84499ee97b37b33a$export$294aa081a6c6f55d = (parameters)=>{
    const fieldPrivateContext = (0, $20b835eaf21df543$export$700ab01cf24fdb1)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $6837d80005de3c6f$export$3b5f62b9baf9717e) : (0, $691502d482840442$export$4995d3b7b56fcd3f);
    return useFieldTextField(parameters);
};




var $acw62 = parcelRequire("acw62");



const $cee5e9e903761e8a$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
$cee5e9e903761e8a$export$ffb3d0046ef3a2.valueManager = (0, $235c2ad72f19522e$export$2764b246aa3b75ba);




const $b40af713571103e3$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture } = props;
    const now = adapter.date(undefined, timezone);
    const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
$b40af713571103e3$export$7bd013ac69eb590c.valueManager = (0, $235c2ad72f19522e$export$2764b246aa3b75ba);



const $f8388c87d25dd2f9$export$ed94a8ff1f54c4f = ({ adapter: adapter, value: value, timezone: timezone, props: props })=>{
    const dateValidationResult = (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, $b40af713571103e3$export$7bd013ac69eb590c)({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
};
$f8388c87d25dd2f9$export$ed94a8ff1f54c4f.valueManager = (0, $235c2ad72f19522e$export$2764b246aa3b75ba);



var $acw62 = parcelRequire("acw62");

const $06e5a97a469e375c$export$7c38da3a2e90fa83 = ()=>(0, $75a4cb957586789c$export$4b5a24245de9f7f9)().defaultDates;
const $06e5a97a469e375c$export$3a404aece3dff2fa = (timezone)=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const now = $acw62.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};



'use client';
function $4b623420a46b7f1a$export$3950ff98d971ecb2(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $acw62.useMemo(()=>({
            valueType: 'date-time',
            validator: (0, $f8388c87d25dd2f9$export$ed94a8ff1f54c4f),
            internal_valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
            internal_fieldValueManager: (0, $235c2ad72f19522e$export$b602c94f557316b4),
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $4b623420a46b7f1a$var$useApplyDefaultValuesToDateTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $4b623420a46b7f1a$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $4b623420a46b7f1a$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    return $acw62.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $4b623420a46b7f1a$var$useApplyDefaultValuesToDateTimeFieldInternalProps(internalProps) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const validationProps = $4b623420a46b7f1a$export$eab0a403c82e1336(internalProps);
    const ampm = $acw62.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.keyboardDateTime12h : adapter.formats.keyboardDateTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function $4b623420a46b7f1a$export$eab0a403c82e1336(props) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const defaultDates = (0, $06e5a97a469e375c$export$7c38da3a2e90fa83)();
    return $acw62.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            // TODO: Explore if we can remove it from the public API
            disableIgnoringDatePartForTimeValidation: !!props.minDateTime || !!props.maxDateTime || !!props.disableFuture || !!props.disablePast,
            minDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.minDateTime ?? props.minDate, defaultDates.minDate),
            maxDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
            minTime: props.minDateTime ?? props.minTime,
            maxTime: props.maxDateTime ?? props.maxTime
        }), [
        props.minDateTime,
        props.maxDateTime,
        props.minTime,
        props.maxTime,
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}


'use client';
const $3746c0be64ddbae0$export$2c2e7f1ceedfa8fa = (props)=>{
    const manager = (0, $4b623420a46b7f1a$export$3950ff98d971ecb2)(props);
    return (0, $84499ee97b37b33a$export$294aa081a6c6f55d)({
        manager: manager,
        props: props
    });
};





var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $3qSdM = parcelRequire("3qSdM");

var $8bslU = parcelRequire("8bslU");

var $kZugz = parcelRequire("kZugz");

var $u24M4 = parcelRequire("u24M4");

var $1n3A4 = parcelRequire("1n3A4");
const $725dc7d66274f756$export$83d89fbfd8236492 = "7.3.4";
const $725dc7d66274f756$export$c7133ab33cb183d1 = Number("7");
const $725dc7d66274f756$export$b65c007c1e3a96bd = Number("3");
const $725dc7d66274f756$export$b76953f99ab2be78 = Number("4");
const $725dc7d66274f756$export$c7862566fc3cc35e = undefined;
var $725dc7d66274f756$export$2e2bcd8739ae039 = $725dc7d66274f756$export$83d89fbfd8236492;



var $eD6Co = parcelRequire("eD6Co");


var $acw62 = parcelRequire("acw62");

var $58lXc = parcelRequire("58lXc");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
'use client';
const $bbd57edb25eace5e$export$5e8d511415c09dec = /*#__PURE__*/ $acw62.createContext(()=>true);
function $bbd57edb25eace5e$export$52df06af7329e367() {
    return $acw62.useContext($bbd57edb25eace5e$export$5e8d511415c09dec);
}





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c33c428cfda4b7d5$export$d1dfa4910c58a4e = /*#__PURE__*/ $acw62.createContext(null);
const $c33c428cfda4b7d5$export$3a79edaa4b9c6a3e = /*#__PURE__*/ $acw62.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function $c33c428cfda4b7d5$export$aae9fbe9dd4050fa(props) {
    const { contextValue: contextValue, actionsContextValue: actionsContextValue, privateContextValue: privateContextValue, fieldPrivateContextValue: fieldPrivateContextValue, isValidContextValue: isValidContextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc077554c64169c5$export$b72b8dade9393cd5).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($c33c428cfda4b7d5$export$d1dfa4910c58a4e.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($c33c428cfda4b7d5$export$3a79edaa4b9c6a3e.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $20b835eaf21df543$export$263a5df151942441).Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bbd57edb25eace5e$export$5e8d511415c09dec).Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}


'use client';
const $a4bd2cc29c71e7d6$export$ceff2e8b47408642 = ()=>$acw62.useContext((0, $c33c428cfda4b7d5$export$3a79edaa4b9c6a3e));


function $99bc14e4e693dcb7$export$fe06f3f35a7c97cd(parameters) {
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const isRtl = (0, $58lXc.useRtl)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}




var $42zF9 = parcelRequire("42zF9");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $ef8448afaa732d42$export$ed0fe318cc298673 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $ef8448afaa732d42$export$8afed21ef5c2afa5 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $ef8448afaa732d42$export$9ca09caa9c849d9c = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $ef8448afaa732d42$export$5fda1783bb83f57b = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $ef8448afaa732d42$export$8099ab97743c966c = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $ef8448afaa732d42$export$90a8eab2a2411720 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $ef8448afaa732d42$export$7e95adcf912503e3 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $ef8448afaa732d42$export$cefbac224a47f32 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');






var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $1Ikg4 = parcelRequire("1Ikg4");


var $3qSdM = parcelRequire("3qSdM");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $6jNiK = parcelRequire("6jNiK");

var $cEXvm = parcelRequire("cEXvm");

var $bJgPp = parcelRequire("bJgPp");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $7fe03890faaa1098$export$d99678ed7aad1677(slot) {
    return (0, $4Cod0.default)('MuiPickersTextField', slot);
}
const $7fe03890faaa1098$export$284739773a7ae972 = (0, $beCSm.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);





var $acw62 = parcelRequire("acw62");


var $4tNJx = parcelRequire("4tNJx");

var $1Ikg4 = parcelRequire("1Ikg4");


var $8Indx = parcelRequire("8Indx");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $64a3e1d35e70fd8e$export$3821cb625ac26962(slot) {
    return (0, $4Cod0.default)('MuiPickersInputBase', slot);
}
const $64a3e1d35e70fd8e$export$f20b5ba262568322 = (0, $beCSm.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);


function $046b91bebd4eb52f$export$c0dd951a3959ac7f(slot) {
    return (0, $4Cod0.default)('MuiPickersOutlinedInput', slot);
}
const $046b91bebd4eb52f$export$a7da60486bcc91df = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));




parcelRequire("acw62");

var $1Ikg4 = parcelRequire("1Ikg4");

var $dgmWB = parcelRequire("dgmWB");

var $acw62 = parcelRequire("acw62");
'use client';
const $2e5837635cabff28$export$b7e46bfe0a5d9502 = /*#__PURE__*/ $acw62.createContext(null);
const $2e5837635cabff28$export$589d98a5b6c57f51 = ()=>{
    const value = $acw62.useContext($2e5837635cabff28$export$b7e46bfe0a5d9502);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};



var $ayMG0 = parcelRequire("ayMG0");
const $1e64c57782485ef2$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $1e64c57782485ef2$var$OutlineRoot = (0, $1Ikg4.default)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $1e64c57782485ef2$var$OutlineLabel = (0, $1Ikg4.default)('span')(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $1e64c57782485ef2$var$OutlineLegend = (0, $1Ikg4.default)('legend', {
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'notched'
})(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $1e64c57782485ef2$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1e64c57782485ef2$var$_excluded);
    const ownerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)($1e64c57782485ef2$var$OutlineRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1e64c57782485ef2$var$OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, $ayMG0.jsx)($1e64c57782485ef2$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $ayMG0.jsx)($1e64c57782485ef2$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}





var $acw62 = parcelRequire("acw62");


var $4tNJx = parcelRequire("4tNJx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $3qSdM = parcelRequire("3qSdM");


var $8Indx = parcelRequire("8Indx");

var $gxvzd = parcelRequire("gxvzd");

var $eD6Co = parcelRequire("eD6Co");





var $acw62 = parcelRequire("acw62");


var $eD6Co = parcelRequire("eD6Co");

var $8Indx = parcelRequire("8Indx");

var $3qSdM = parcelRequire("3qSdM");

var $1Ikg4 = parcelRequire("1Ikg4");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $ef78634a4721646b$export$f891a98d04ce6513(slot) {
    return (0, $4Cod0.default)('MuiPickersSectionList', slot);
}
const $ef78634a4721646b$export$8455939b33d2ee90 = (0, $beCSm.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $af9e880f422bb0e7$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const $af9e880f422bb0e7$export$4ee86b293725486c = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $af9e880f422bb0e7$export$30e7187e386feb4f = (0, $1Ikg4.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const $af9e880f422bb0e7$export$c403b59604f63120 = (0, $1Ikg4.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const $af9e880f422bb0e7$export$1f2c61561fe3d6 = (0, $1Ikg4.default)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const $af9e880f422bb0e7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $ef78634a4721646b$export$f891a98d04ce6513), classes);
};
function $af9e880f422bb0e7$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const Section = slots?.section ?? $af9e880f422bb0e7$export$30e7187e386feb4f;
    const sectionProps = (0, $eD6Co.default)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: ownerState
    });
    const SectionContent = slots?.sectionContent ?? $af9e880f422bb0e7$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $eD6Co.default)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? $af9e880f422bb0e7$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $eD6Co.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, $eD6Co.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(Section, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $ayMG0.jsx)(SectionSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $af9e880f422bb0e7$export$847fd4b97819700 = /*#__PURE__*/ $acw62.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $af9e880f422bb0e7$var$_excluded);
    const classes = $af9e880f422bb0e7$var$useUtilityClasses(classesProp);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $3qSdM.default)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $acw62.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, $ef78634a4721646b$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, $ef78634a4721646b$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $ef78634a4721646b$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $ef78634a4721646b$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $ef78634a4721646b$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $af9e880f422bb0e7$export$4ee86b293725486c;
    const rootProps = (0, $eD6Co.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Root, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($af9e880f422bb0e7$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a746f7ad5ddbedef$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const $a746f7ad5ddbedef$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $a746f7ad5ddbedef$export$ddc18880178d980e = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$a746f7ad5ddbedef$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $a746f7ad5ddbedef$export$52f3fbbfe9321824 = (0, $1Ikg4.default)((0, $af9e880f422bb0e7$export$4ee86b293725486c), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: true,
                    isLabelShrunk: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSection = (0, $1Ikg4.default)((0, $af9e880f422bb0e7$export$30e7187e386feb4f), {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSectionContent = (0, $1Ikg4.default)((0, $af9e880f422bb0e7$export$1f2c61561fe3d6), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSectionSeparator = (0, $1Ikg4.default)((0, $af9e880f422bb0e7$export$c403b59604f63120), {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseInput = (0, $1Ikg4.default)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $0acaed42692b8720$export$2e2bcd8739ae039)));
const $a746f7ad5ddbedef$var$PickersInputBaseActiveBar = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const $a746f7ad5ddbedef$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldReadOnly: isFieldReadOnly, hasFieldError: hasFieldError, inputSize: inputSize, isInputInFullWidth: isInputInFullWidth, inputColor: inputColor, hasStartAdornment: hasStartAdornment, hasEndAdornment: hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, $gxvzd.default)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $64a3e1d35e70fd8e$export$3821cb625ac26962), classes);
};
function $a746f7ad5ddbedef$var$resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function $a746f7ad5ddbedef$var$resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += $a746f7ad5ddbedef$var$resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += $a746f7ad5ddbedef$var$resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth: activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const $a746f7ad5ddbedef$export$ff827734ba831074 = /*#__PURE__*/ $acw62.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, onFocus: onFocus, onBlur: onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a746f7ad5ddbedef$var$_excluded);
    const ownerStateContext = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const rootRef = $acw62.useRef(null);
    const activeBarRef = $acw62.useRef(null);
    const sectionOffsetsRef = $acw62.useRef([]);
    const handleRootRef = (0, $3qSdM.default)(ref, rootRef);
    const handleInputRef = (0, $3qSdM.default)(inputProps?.ref, inputRef);
    const muiFormControl = (0, $4tNJx.default)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $acw62.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = $a746f7ad5ddbedef$var$useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || $a746f7ad5ddbedef$export$ddc18880178d980e;
    const inputRootProps = (0, $eD6Co.default)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $a746f7ad5ddbedef$export$52f3fbbfe9321824;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    $acw62.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth: activeBarWidth, sectionOffsets: sectionOffsets } = $a746f7ad5ddbedef$var$resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(InputRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $af9e880f422bb0e7$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $a746f7ad5ddbedef$var$PickersInputBaseSection,
                    sectionContent: $a746f7ad5ddbedef$var$PickersInputBaseSectionContent,
                    sectionSeparator: $a746f7ad5ddbedef$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.input, {
                        ownerState: ownerState
                    }),
                    sectionContent: {
                        className: (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ separatorPosition: separatorPosition })=>({
                            className: separatorPosition === 'before' ? (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionBefore : (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($a746f7ad5ddbedef$var$PickersInputBaseInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, $ayMG0.jsx)($a746f7ad5ddbedef$var$PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
const $5546139708981d3e$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const $5546139708981d3e$var$PickersOutlinedInputRoot = (0, $1Ikg4.default)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).focused} .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).error} .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).focused}:not(.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).error}) .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $5546139708981d3e$var$PickersOutlinedInputSectionsContainer = (0, $1Ikg4.default)((0, $a746f7ad5ddbedef$export$52f3fbbfe9321824), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $5546139708981d3e$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $046b91bebd4eb52f$export$c0dd951a3959ac7f), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $5546139708981d3e$export$44d4d00edb0c710f = /*#__PURE__*/ $acw62.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, classes: classesProp, notched: notched } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $5546139708981d3e$var$_excluded);
    const muiFormControl = (0, $4tNJx.default)();
    const classes = $5546139708981d3e$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $5546139708981d3e$var$PickersOutlinedInputRoot,
            input: $5546139708981d3e$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e64c57782485ef2$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$5546139708981d3e$export$44d4d00edb0c710f.muiName = 'Input';





var $acw62 = parcelRequire("acw62");


var $1Ikg4 = parcelRequire("1Ikg4");

var $dgmWB = parcelRequire("dgmWB");


var $8Indx = parcelRequire("8Indx");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $a7f921572f185f66$export$6cb188bdacb35d0e(slot) {
    return (0, $4Cod0.default)('MuiPickersFilledInput', slot);
}
const $a7f921572f185f66$export$3964d3188824d772 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));






var $ayMG0 = parcelRequire("ayMG0");
const $c00015b46befd213$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const $c00015b46befd213$var$PickersFilledInputRoot = (0, $1Ikg4.default)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}, .${(0, $a7f921572f185f66$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $c00015b46befd213$var$PickersFilledSectionsContainer = (0, $1Ikg4.default)((0, $a746f7ad5ddbedef$export$52f3fbbfe9321824), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $c00015b46befd213$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $a7f921572f185f66$export$6cb188bdacb35d0e), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $c00015b46befd213$export$8cc8c624890b5045 = /*#__PURE__*/ $acw62.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, hiddenLabel: hiddenLabel = false, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $c00015b46befd213$var$_excluded);
    const pickerTextFieldOwnerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $c00015b46befd213$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $c00015b46befd213$var$PickersFilledInputRoot,
            input: $c00015b46befd213$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            },
            input: {
                hiddenLabel: hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
$c00015b46befd213$export$8cc8c624890b5045.muiName = 'Input';





var $acw62 = parcelRequire("acw62");


var $1Ikg4 = parcelRequire("1Ikg4");

var $dgmWB = parcelRequire("dgmWB");


var $8Indx = parcelRequire("8Indx");


var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");

function $56d7847b44348f39$export$defbb17803ff7cff(slot) {
    return (0, $4Cod0.default)('MuiPickersFilledInput', slot);
}
const $56d7847b44348f39$export$f5c5ba079c8bb9dd = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $beCSm.default)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));






var $ayMG0 = parcelRequire("ayMG0");
const $9255c83398e974d0$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const $9255c83398e974d0$var$PickersInputRoot = (0, $1Ikg4.default)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).disabled}, .${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $9255c83398e974d0$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8Indx.default)(slots, (0, $56d7847b44348f39$export$defbb17803ff7cff), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $9255c83398e974d0$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $acw62.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9255c83398e974d0$var$_excluded);
    const pickerTextFieldOwnerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $9255c83398e974d0$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $9255c83398e974d0$var$PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
$9255c83398e974d0$export$7c4ebb2cfaf4f474.muiName = 'Input';





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e1cfb92b1b93cb9b$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const $e1cfb92b1b93cb9b$var$VARIANT_COMPONENT = {
    standard: (0, $9255c83398e974d0$export$7c4ebb2cfaf4f474),
    filled: (0, $c00015b46befd213$export$8cc8c624890b5045),
    outlined: (0, $5546139708981d3e$export$44d4d00edb0c710f)
};
const $e1cfb92b1b93cb9b$var$PickersTextFieldRoot = (0, $1Ikg4.default)((0, $bJgPp.default), {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const $e1cfb92b1b93cb9b$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldRequired: isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7fe03890faaa1098$export$d99678ed7aad1677), classes);
};
const $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d = /*#__PURE__*/ $acw62.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, classes: classesProp, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, hiddenLabel: hiddenLabel = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e1cfb92b1b93cb9b$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $3qSdM.default)(ref, rootRef);
    const id = (0, $auC0X.default)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(InputLabelProps?.shrink)
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label,
        InputLabelProps?.shrink
    ]);
    const classes = $e1cfb92b1b93cb9b$var$useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = $e1cfb92b1b93cb9b$var$VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2e5837635cabff28$export$b7e46bfe0a5d9502).Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($e1cfb92b1b93cb9b$var$PickersTextFieldRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: (0, $9QePP.default)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)(PickersInputComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cEXvm.default), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d2d3640b21a65392$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $d2d3640b21a65392$var$_excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $d2d3640b21a65392$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $d2d3640b21a65392$var$_excluded4 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded5 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded6 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded7 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded8 = [
    "InputProps",
    "inputProps"
];
const $d2d3640b21a65392$var$noop = ()=>{};
const $d2d3640b21a65392$export$d31e0c72c716cd73 = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $d2d3640b21a65392$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(fieldResponse, $d2d3640b21a65392$var$_excluded2);
        const mergedInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.input, InputProps) : $d2d3640b21a65392$var$noop;
        return {
            clearable: clearable,
            onClear: onClear,
            clearButtonPosition: clearButtonPosition,
            openPickerButtonPosition: openPickerButtonPosition,
            openPickerAriaLabel: openPickerAriaLabel,
            textFieldProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? {
                slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other?.slotProps, {
                    input: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(mergedInputProps, ownerState), {
                            readOnly: readOnly
                        })
                })
            } : {
                InputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                    readOnly: readOnly
                })
            })
        };
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(fieldResponse, $d2d3640b21a65392$var$_excluded3);
    const mergedInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.input, InputProps) : $d2d3640b21a65392$var$noop;
    const mergedHtmlInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.htmlInput ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.htmlInput, inputProps) : $d2d3640b21a65392$var$noop;
    return {
        clearable: clearable,
        onClear: onClear,
        clearButtonPosition: clearButtonPosition,
        openPickerButtonPosition: openPickerButtonPosition,
        openPickerAriaLabel: openPickerAriaLabel,
        textFieldProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && (other?.slotProps?.input || other?.slotProps?.htmlInput) ? {
            slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other?.slotProps, {
                input: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(mergedInputProps, ownerState), {
                        readOnly: readOnly
                    }),
                htmlInput: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(mergedHtmlInputProps, ownerState), {
                        inputMode: inputMode,
                        onPaste: onPaste,
                        onKeyDown: onKeyDown,
                        ref: inputRef
                    })
            })
        } : {
            InputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                readOnly: readOnly
            }),
            inputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputProps ?? {}, {
                inputMode: inputMode,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                ref: inputRef
            })
        })
    };
};
const $d2d3640b21a65392$export$f5bc58012fe60483 = /*#__PURE__*/ $acw62.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function $d2d3640b21a65392$export$f83254b974f9d6d3(props) {
    const { fieldResponse: fieldResponse, defaultOpenPickerIcon: defaultOpenPickerIcon } = props;
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const pickerFieldUIContext = $acw62.useContext($d2d3640b21a65392$export$f5bc58012fe60483);
    const { textFieldProps: textFieldProps, onClear: onClear, clearable: clearable, openPickerAriaLabel: openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = $d2d3640b21a65392$export$d31e0c72c716cd73(fieldResponse);
    const ownerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)(textFieldProps);
    const handleClickOpeningButton = (0, $13KXh.default)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? (0, $kZugz.default) : (0, $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d));
    const InputAdornment = pickerFieldUIContext.slots.inputAdornment ?? (0, $1n3A4.default);
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $d2d3640b21a65392$var$_excluded4);
    const _useSlotProps2 = (0, $eD6Co.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps2, $d2d3640b21a65392$var$_excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? (0, $u24M4.default);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, $eD6Co.default)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState: ownerState
    }), openPickerButtonProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps3, $d2d3640b21a65392$var$_excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, $eD6Co.default)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState: ownerState
    });
    const ClearButton = pickerFieldUIContext.slots.clearButton ?? (0, $u24M4.default);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, $eD6Co.default)({
        elementType: ClearButton,
        externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState: ownerState
    }), clearButtonProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps4, $d2d3640b21a65392$var$_excluded7);
    const ClearIcon = pickerFieldUIContext.slots.clearIcon ?? (0, $ef8448afaa732d42$export$cefbac224a47f32);
    const clearIconProps = (0, $eD6Co.default)({
        elementType: ClearIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    textFieldProps.ref = (0, $3qSdM.default)(textFieldProps.ref, pickerContext?.rootRef);
    const additionalTextFieldInputProps = {};
    const textFieldInputProps = (0, $8bslU.default)(((0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.input) ?? textFieldProps.InputProps, ownerState);
    if (pickerContext) additionalTextFieldInputProps.ref = pickerContext.triggerRef;
    if (!textFieldInputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) additionalTextFieldInputProps.startAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldInputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsxs)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(ClearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(ClearIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(OpenPickerIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        ]
    }));
    // handle the case of showing custom `inputAdornment` for Field components
    if (!additionalTextFieldInputProps?.endAdornment && !additionalTextFieldInputProps?.startAdornment && pickerFieldUIContext.slots.inputAdornment) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $ayMG0.jsx)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, endInputAdornmentProps));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    const resolvedTextFieldInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.input ? (0, $8bslU.default)($d2d3640b21a65392$export$b01d1e419b049226(textFieldInputProps, additionalTextFieldInputProps), ownerState) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, textFieldInputProps, additionalTextFieldInputProps);
    // We need to resolve the `inputProps` since we are messing with those props in this component.
    textFieldProps.inputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.htmlInput ? (0, $8bslU.default)(textFieldProps.slotProps.htmlInput, ownerState) : textFieldProps.inputProps;
    // Remove the `input` slotProps to avoid them overriding the manually resolved `InputProps`.
    // Relevant on `materialMajor >= 6` since `slotProps` would take precedence.
    delete textFieldProps?.slotProps?.input;
    if (fieldResponse.enableAccessibleFieldDOMStructure) // Remove the `slotProps` on `PickersTextField` as they are not supported.
    delete textFieldProps?.slotProps;
    return /*#__PURE__*/ (0, $ayMG0.jsx)(TextField, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, textFieldProps, {
        InputProps: resolvedTextFieldInputProps
    }));
}
function $d2d3640b21a65392$export$b01d1e419b049226(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(slotPropsB, ownerState), (0, $8bslU.default)(slotPropsA, ownerState));
    };
}
function $d2d3640b21a65392$export$fa1adc26aa0d007a(parameters) {
    const { ref: ref, externalForwardedProps: externalForwardedProps, slotProps: slotProps } = parameters;
    const pickerFieldUIContext = $acw62.useContext($d2d3640b21a65392$export$f5bc58012fe60483);
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const ownerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)(externalForwardedProps);
    const { InputProps: InputProps, inputProps: inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(externalForwardedProps, $d2d3640b21a65392$var$_excluded8);
    const textFieldProps = (0, $eD6Co.default)({
        elementType: (0, $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d),
        externalSlotProps: $d2d3640b21a65392$export$b01d1e419b049226(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref: ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function $d2d3640b21a65392$export$5a824d9f5f1d0778(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, inputRef: inputRef, children: children } = props;
    const contextValue = $acw62.useMemo(()=>({
            inputRef: inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d2d3640b21a65392$export$f5bc58012fe60483.Provider, {
        value: contextValue,
        children: children
    });
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f1f52b9c47331d57$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateTimeField](http://mui.com/x/react-date-pickers/date-time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateTimeField API](https://mui.com/x/api/date-pickers/date-time-field/)
 */ const $f1f52b9c47331d57$export$ae1ced156568f0b0 = /*#__PURE__*/ $acw62.forwardRef(function DateTimeField(inProps, inRef) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateTimeField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(themeProps, $f1f52b9c47331d57$var$_excluded);
    const textFieldProps = (0, $d2d3640b21a65392$export$fa1adc26aa0d007a)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $3746c0be64ddbae0$export$2c2e7f1ceedfa8fa)(textFieldProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2d3640b21a65392$export$5a824d9f5f1d0778), {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2d3640b21a65392$export$f83254b974f9d6d3), {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: (0, $ef8448afaa732d42$export$5fda1783bb83f57b)
        })
    });
});




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $gEsja = parcelRequire("gEsja");

var $eVI4s = parcelRequire("eVI4s");
var $6jOpZ = parcelRequire("6jOpZ");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");



var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $7e069655f50c1983$export$c994a6b377ce38df(slot) {
    return (0, $4Cod0.default)('MuiDateTimePickerTabs', slot);
}
const $7e069655f50c1983$export$a2a6922f6f97d267 = (0, $beCSm.default)('MuiDateTimePickerTabs', [
    'root'
]);






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7c1e9223e1262ef2$var$viewToTab = (view)=>{
    if ((0, $b8d019f986eaf72a$export$b32dfef9f07dea64)(view)) return 'date';
    return 'time';
};
const $7c1e9223e1262ef2$var$tabToView = (tab)=>{
    if (tab === 'date') return 'day';
    return 'hours';
};
const $7c1e9223e1262ef2$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $7e069655f50c1983$export$c994a6b377ce38df), classes);
};
const $7c1e9223e1262ef2$var$DateTimePickerTabsRoot = (0, $1Ikg4.default)((0, $eVI4s.default), {
    name: 'MuiDateTimePickerTabs',
    slot: 'Root'
})(({ theme: theme })=>({
        boxShadow: `0 -1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
        '&:last-child': {
            boxShadow: `0 1px 0 0 inset ${(theme.vars || theme).palette.divider}`,
            [`& .${(0, $6jOpZ.default).indicator}`]: {
                bottom: 'auto',
                top: 0
            }
        }
    }));
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DateTimePickerTabs API](https://mui.com/x/api/date-pickers/date-time-picker-tabs/)
 */ const $7c1e9223e1262ef2$export$95dfad4074502244 = function DateTimePickerTabs(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateTimePickerTabs'
    });
    const { dateIcon: dateIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef8448afaa732d42$export$90a8eab2a2411720), {}), timeIcon: timeIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef8448afaa732d42$export$7e95adcf912503e3), {}), hidden: hidden = typeof window === 'undefined' || window.innerHeight < 667, className: className, classes: classesProp, sx: sx } = props;
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { view: view, setView: setView } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const classes = $7c1e9223e1262ef2$var$useUtilityClasses(classesProp);
    const handleChange = (event, value)=>{
        setView($7c1e9223e1262ef2$var$tabToView(value));
    };
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7c1e9223e1262ef2$var$DateTimePickerTabsRoot, {
        ownerState: ownerState,
        variant: "fullWidth",
        value: $7c1e9223e1262ef2$var$viewToTab(view),
        onChange: handleChange,
        className: (0, $9QePP.default)(className, classes.root),
        sx: sx,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gEsja.default), {
                value: "date",
                "aria-label": translations.dateTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                    children: dateIcon
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gEsja.default), {
                value: "time",
                "aria-label": translations.timeTableLabel,
                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($acw62.Fragment, {
                    children: timeIcon
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $dgmWB = parcelRequire("dgmWB");



var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $7X4mk = parcelRequire("7X4mk");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $96492c9d07f47912$export$2aab7addfa1bc589(slot) {
    return (0, $4Cod0.default)('MuiPickersToolbarText', slot);
}
const $96492c9d07f47912$export$4ca7b92014bf2e56 = (0, $beCSm.default)('MuiPickersToolbarText', [
    'root'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $e087f7e58822bed9$var$_excluded = [
    "className",
    "classes",
    "selected",
    "value"
];
const $e087f7e58822bed9$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $96492c9d07f47912$export$2aab7addfa1bc589), classes);
};
const $e087f7e58822bed9$var$PickersToolbarTextRoot = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiPickersToolbarText',
    slot: 'Root'
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&[data-selected]`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $e087f7e58822bed9$export$2006bc630443fa2 = /*#__PURE__*/ $acw62.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className: className, classes: classesProp, selected: selected, value: value } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e087f7e58822bed9$var$_excluded);
    const classes = $e087f7e58822bed9$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e087f7e58822bed9$var$PickersToolbarTextRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        component: "span",
        ownerState: props
    }, selected && {
        'data-selected': true
    }, other, {
        children: value
    }));
});





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $7X4mk = parcelRequire("7X4mk");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $dgmWB = parcelRequire("dgmWB");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $cd064f23093812c7$export$b109c489973c3d80(slot) {
    return (0, $4Cod0.default)('MuiPickersToolbar', slot);
}
const $cd064f23093812c7$export$59f09e5e2b3d9913 = (0, $beCSm.default)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);




var $acw62 = parcelRequire("acw62");

var $58lXc = parcelRequire("58lXc");

function $7488814d8bbee125$export$52d82af37dec73b2() {
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const isRtl = (0, $58lXc.useRtl)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}



var $ayMG0 = parcelRequire("ayMG0");
const $f3ba643fb3747006$var$_excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const $f3ba643fb3747006$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cd064f23093812c7$export$b109c489973c3d80), classes);
};
const $f3ba643fb3747006$var$PickersToolbarRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $f3ba643fb3747006$var$PickersToolbarContent = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $f3ba643fb3747006$export$eb3c4d84783d6feb = /*#__PURE__*/ $acw62.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, classes: classesProp, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId, landscapeDirection: landscapeDirection } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $f3ba643fb3747006$var$_excluded);
    const ownerState = (0, $7488814d8bbee125$export$52d82af37dec73b2)();
    const classes = $f3ba643fb3747006$var$useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f3ba643fb3747006$var$PickersToolbarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($f3ba643fb3747006$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $03kOd = parcelRequire("03kOd");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");



var $ayMG0 = parcelRequire("ayMG0");
const $2502605abcd7a7fc$var$_excluded = [
    "align",
    "className",
    "classes",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $2502605abcd7a7fc$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cd064f23093812c7$export$b109c489973c3d80), classes);
};
const $2502605abcd7a7fc$var$PickersToolbarButtonRoot = (0, $1Ikg4.default)((0, $03kOd.default), {
    name: 'MuiPickersToolbarButton',
    slot: 'Root'
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $2502605abcd7a7fc$export$614ed940168c780c = /*#__PURE__*/ $acw62.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, classes: classesProp, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $2502605abcd7a7fc$var$_excluded);
    const classes = $2502605abcd7a7fc$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2502605abcd7a7fc$var$PickersToolbarButtonRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        variant: "text",
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: props
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e087f7e58822bed9$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});




var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $bafff989027d15da$export$c40f5731216f0c9d(slot) {
    return (0, $4Cod0.default)('MuiDateTimePickerToolbar', slot);
}
const $bafff989027d15da$export$82ac739c3153ffd4 = (0, $beCSm.default)('MuiDateTimePickerToolbar', [
    'root',
    'dateContainer',
    'timeContainer',
    'timeDigitsContainer',
    'separator',
    'timeLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);



var $acw62 = parcelRequire("acw62");


function $8992dd6789b4ad9e$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function $8992dd6789b4ad9e$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function $8992dd6789b4ad9e$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const cleanDate = $acw62.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, $d83ac1c1cf9e346e$export$c3352ead7b032236)(cleanDate, adapter);
    const handleMeridiemChange = $acw62.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, $d83ac1c1cf9e346e$export$c368d4ff66779998)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}


const $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0 = 36;
const $e7cd373dd46c88ee$export$dde58b009b497666 = 2;
const $e7cd373dd46c88ee$export$ee46b8a74d6c94d3 = 320;
const $e7cd373dd46c88ee$export$73724491020e90c7 = 280;
const $e7cd373dd46c88ee$export$f2fef360e2df0cb7 = 336;
const $e7cd373dd46c88ee$export$1c2eabda4acea0e4 = 232;
const $e7cd373dd46c88ee$export$a462ceb9cfdb5d71 = 48;








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ec02f6c08ff23e80$var$_excluded = [
    "ampm",
    "ampmInClock",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "className",
    "classes"
];
const $ec02f6c08ff23e80$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation, toolbarDirection: toolbarDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        dateContainer: [
            'dateContainer'
        ],
        timeContainer: [
            'timeContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        timeDigitsContainer: [
            'timeDigitsContainer',
            toolbarDirection === 'rtl' && 'timeLabelReverse'
        ],
        separator: [
            'separator'
        ],
        ampmSelection: [
            'ampmSelection',
            pickerOrientation === 'landscape' && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bafff989027d15da$export$c40f5731216f0c9d), classes);
};
const $ec02f6c08ff23e80$var$DateTimePickerToolbarRoot = (0, $1Ikg4.default)((0, $f3ba643fb3747006$export$eb3c4d84783d6feb), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})(({ theme: theme })=>({
        paddingLeft: 16,
        paddingRight: 16,
        justifyContent: 'space-around',
        position: 'relative',
        variants: [
            {
                props: {
                    toolbarVariant: 'desktop'
                },
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    [`& .${(0, $cd064f23093812c7$export$59f09e5e2b3d9913).content} .${(0, $96492c9d07f47912$export$4ca7b92014bf2e56).root}[data-selected]`]: {
                        color: (theme.vars || theme).palette.primary.main,
                        fontWeight: theme.typography.fontWeightBold
                    }
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'landscape'
                },
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    toolbarVariant: 'desktop',
                    pickerOrientation: 'portrait'
                },
                style: {
                    paddingLeft: 24,
                    paddingRight: 0
                }
            }
        ]
    }));
const $ec02f6c08ff23e80$var$DateTimePickerToolbarDateContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'DateContainer'
})({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
});
const $ec02f6c08ff23e80$var$DateTimePickerToolbarTimeContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeContainer',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    flexDirection: 'row',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop',
                pickerOrientation: 'portrait'
            },
            style: {
                gap: 9,
                marginRight: 4,
                alignSelf: 'flex-end'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop',
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ pickerOrientation: pickerOrientation, toolbarVariant: toolbarVariant, toolbarDirection: toolbarDirection })=>pickerOrientation === 'landscape' && toolbarVariant !== 'desktop' && toolbarDirection === 'rtl',
            style: {
                flexDirection: 'column-reverse'
            }
        }
    ]
});
const $ec02f6c08ff23e80$var$DateTimePickerToolbarTimeDigitsContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'TimeDigitsContainer',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    display: 'flex',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                gap: 1.5
            }
        }
    ]
});
const $ec02f6c08ff23e80$var$DateTimePickerToolbarSeparator = (0, $1Ikg4.default)((0, $e087f7e58822bed9$export$2006bc630443fa2), {
    name: 'MuiDateTimePickerToolbar',
    slot: 'Separator',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'toolbarVariant'
})({
    margin: '0 4px 0 2px',
    cursor: 'default',
    variants: [
        {
            props: {
                toolbarVariant: 'desktop'
            },
            style: {
                margin: 0
            }
        }
    ]
});
// Taken from TimePickerToolbar
const $ec02f6c08ff23e80$var$DateTimePickerToolbarAmPmSelection = (0, $1Ikg4.default)('div', {
    name: 'MuiDateTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $bafff989027d15da$export$82ac739c3153ffd4).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $bafff989027d15da$export$82ac739c3153ffd4).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${(0, $bafff989027d15da$export$82ac739c3153ffd4).ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                width: '100%'
            }
        }
    ]
});
const $ec02f6c08ff23e80$export$f8ba54f3ef59c5f6 = /*#__PURE__*/ $acw62.createContext(null);
function $ec02f6c08ff23e80$export$fe4ab7cbc0078243(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: inToolbarTitle, className: className, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ec02f6c08ff23e80$var$_excluded);
    const { value: valueContext, setValue: setValueContext, disabled: disabled, readOnly: readOnly, variant: variant, orientation: orientation, view: viewContext, setView: setViewContext, views: views } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const ownerState = (0, $7488814d8bbee125$export$52d82af37dec73b2)();
    const classes = $ec02f6c08ff23e80$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const overrides = $acw62.useContext($ec02f6c08ff23e80$export$f8ba54f3ef59c5f6);
    const value = overrides ? overrides.value : valueContext;
    const setValue = overrides ? overrides.setValue : setValueContext;
    const view = overrides ? overrides.view : viewContext;
    const setView = overrides ? overrides.setView : setViewContext;
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $8992dd6789b4ad9e$export$6aaabc31cb076d17)(value, ampm, (newValue)=>setValue(newValue, {
            changeImportance: 'set'
        }));
    const toolbarVariant = overrides?.forceDesktopVariant ? 'desktop' : variant;
    const isDesktop = toolbarVariant === 'desktop';
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const toolbarTitle = inToolbarTitle ?? translations.dateTimePickerToolbarTitle;
    const dateText = $acw62.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        if (toolbarFormat) return adapter.formatByString(value, toolbarFormat);
        return adapter.format(value, 'shortDate');
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter
    ]);
    const formatSection = (format, fallback)=>{
        if (!adapter.isValid(value)) return fallback;
        return adapter.format(value, format);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($ec02f6c08ff23e80$var$DateTimePickerToolbarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $9QePP.default)(classes.root, className),
        toolbarTitle: toolbarTitle,
        toolbarVariant: toolbarVariant
    }, other, {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($ec02f6c08ff23e80$var$DateTimePickerToolbarDateContainer, {
                className: classes.dateContainer,
                ownerState: ownerState,
                children: [
                    views.includes('year') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "subtitle1",
                        onClick: ()=>setView('year'),
                        selected: view === 'year',
                        value: formatSection('year', "\u2013")
                    }),
                    views.includes('day') && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: isDesktop ? 'h5' : 'h4',
                        onClick: ()=>setView('day'),
                        selected: view === 'day',
                        value: dateText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)($ec02f6c08ff23e80$var$DateTimePickerToolbarTimeContainer, {
                className: classes.timeContainer,
                ownerState: ownerState,
                toolbarVariant: toolbarVariant,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($ec02f6c08ff23e80$var$DateTimePickerToolbarTimeDigitsContainer, {
                        className: classes.timeDigitsContainer,
                        ownerState: ownerState,
                        toolbarVariant: toolbarVariant,
                        children: [
                            views.includes('hours') && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, $e7cd373dd46c88ee$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>setView('hours'),
                                        selected: view === 'hours',
                                        value: formatSection(ampm ? 'hours12h' : 'hours24h', '--')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($ec02f6c08ff23e80$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, $e7cd373dd46c88ee$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>setView('minutes'),
                                        selected: view === 'minutes' || !views.includes('minutes') && view === 'hours',
                                        value: formatSection('minutes', '--'),
                                        disabled: !views.includes('minutes')
                                    })
                                ]
                            }),
                            views.includes('seconds') && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($ec02f6c08ff23e80$var$DateTimePickerToolbarSeparator, {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        value: ":",
                                        className: classes.separator,
                                        ownerState: ownerState,
                                        toolbarVariant: toolbarVariant
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                                        variant: isDesktop ? 'h5' : 'h3',
                                        width: isDesktop && orientation === 'portrait' ? (0, $e7cd373dd46c88ee$export$a462ceb9cfdb5d71) : undefined,
                                        onClick: ()=>setView('seconds'),
                                        selected: view === 'seconds',
                                        value: formatSection('seconds', '--')
                                    })
                                ]
                            })
                        ]
                    }),
                    showAmPmControl && !isDesktop && /*#__PURE__*/ (0, $ayMG0.jsxs)($ec02f6c08ff23e80$var$DateTimePickerToolbarAmPmSelection, {
                        className: classes.ampmSelection,
                        ownerState: ownerState,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'am',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'am'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                                disabled: disabled
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                                variant: "subtitle2",
                                selected: meridiemMode === 'pm',
                                typographyClassName: classes.ampmLabel,
                                value: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'pm'),
                                onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                                disabled: disabled
                            })
                        ]
                    }),
                    ampm && isDesktop && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2502605abcd7a7fc$export$614ed940168c780c), {
                        variant: "h5",
                        onClick: ()=>setView('meridiem'),
                        selected: view === 'meridiem',
                        value: value && meridiemMode ? (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, meridiemMode) : '--',
                        width: (0, $e7cd373dd46c88ee$export$a462ceb9cfdb5d71)
                    })
                ]
            })
        ]
    }));
}







const $f933d5f81686c4e5$var$_excluded = [
    "views",
    "format"
];
const $f933d5f81686c4e5$export$ebf7b30b32db6f57 = (adapter, _ref, ignoreDateResolving)=>{
    let { views: views, format: format } = _ref, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $f933d5f81686c4e5$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else if ((0, $b8d019f986eaf72a$export$b32dfef9f07dea64)(view)) dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $d83ac1c1cf9e346e$export$3a6776b3863772fe)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const timeFormat = (0, $d83ac1c1cf9e346e$export$3a6776b3863772fe)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        views: timeViews
    }, other));
    const dateFormat = ignoreDateResolving ? adapter.formats.keyboardDate : (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $f933d5f81686c4e5$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $d83ac1c1cf9e346e$export$a3328136ac50623d)(view) || view === 'hours');
    return ampm ? [
        ...views,
        'meridiem'
    ] : views;
};
const $f933d5f81686c4e5$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>1440 / ((timeSteps.hours ?? 1) * (timeSteps.minutes ?? 5)) <= threshold;
function $f933d5f81686c4e5$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold ?? 24;
    const timeSteps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $f933d5f81686c4e5$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $f933d5f81686c4e5$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}



function $7376453e1bd5a1ce$export$6e4d96e87e6dc2d3(props, name) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $4b623420a46b7f1a$export$eab0a403c82e1336)(themeProps);
    const ampm = themeProps.ampm ?? adapter.is12HourCycleInCurrentLocale();
    const localeText = $acw62.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            dateTimePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const { openTo: openTo, views: defaultViews } = (0, $38ae9feef3ab2fb0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day',
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'day'
    });
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn, views: views, timeSteps: timeSteps } = (0, $f933d5f81686c4e5$export$e2d664f2dd4d34bc)({
        thresholdToRenderTimeInASingleColumn: themeProps.thresholdToRenderTimeInASingleColumn,
        ampm: ampm,
        timeSteps: themeProps.timeSteps,
        views: defaultViews
    });
    // Keep the original views for format calculation (before filtering)
    const viewsForFormatting = ampm ? [
        ...defaultViews,
        'meridiem'
    ] : defaultViews;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        timeSteps: timeSteps,
        openTo: openTo,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        views: views,
        viewsForFormatting: viewsForFormatting,
        ampm: ampm,
        localeText: localeText,
        orientation: themeProps.orientation ?? 'portrait',
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            toolbar: (0, $ec02f6c08ff23e80$export$fe4ab7cbc0078243),
            tabs: (0, $7c1e9223e1262ef2$export$95dfad4074502244)
        }, themeProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps.slotProps, {
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                ampm: ampm
            }, themeProps.slotProps?.toolbar)
        })
    });
}


parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $eD6Co = parcelRequire("eD6Co");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");

var $13KXh = parcelRequire("13KXh");


var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $acw62 = parcelRequire("acw62");


'use client';
const $80335e50844415f8$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useCallback((day)=>(0, $cee5e9e903761e8a$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};






'use client';
const $5efae1633883dea7$var$createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const $5efae1633883dea7$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onYearChange: onYearChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone, getCurrentMonthFromVisibleDate: getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const reducerFn = $acw62.useRef($5efae1633883dea7$var$createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = $acw62.useMemo(()=>{
        return (0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $acw62.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: adapter.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, $80335e50844415f8$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $acw62.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, $13KXh.default)(({ target: target, reason: reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                    adapter: adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast: disablePast,
                    disableFuture: disableFuture,
                    isDateDisabled: isDateDisabled,
                    timezone: timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month: month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation: skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = $acw62.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        setVisibleDate: setVisibleDate,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd
    };
};



parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $jEvxL = parcelRequire("jEvxL");

var $fanil = parcelRequire("fanil");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
const $9692949b07390f50$export$5b0bb0174eb448ca = (slot)=>(0, $4Cod0.default)('MuiPickersFadeTransitionGroup', slot);
const $9692949b07390f50$export$1461f245817ac559 = (0, $beCSm.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $9c2e6cdd3bb22caf$var$_excluded = [
    "children"
];
const $9c2e6cdd3bb22caf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $9692949b07390f50$export$5b0bb0174eb448ca), classes);
};
const $9c2e6cdd3bb22caf$var$PickersFadeTransitionGroupRoot = (0, $1Ikg4.default)((0, $jEvxL.default), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
function $9c2e6cdd3bb22caf$export$5262185daf493fee(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className: className, reduceAnimations: reduceAnimations, transKey: transKey, classes: classesProp } = props;
    const { children: children } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9c2e6cdd3bb22caf$var$_excluded);
    const classes = $9c2e6cdd3bb22caf$var$useUtilityClasses(classesProp);
    const theme = (0, $b7Ol4.default)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9c2e6cdd3bb22caf$var$PickersFadeTransitionGroupRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fanil.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $7X4mk = parcelRequire("7X4mk");

var $eD6Co = parcelRequire("eD6Co");

var $58lXc = parcelRequire("58lXc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $9QePP = parcelRequire("9QePP");



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $2TZUE = parcelRequire("2TZUE");

var $eEJPp = parcelRequire("eEJPp");

var $8Indx = parcelRequire("8Indx");

var $3qSdM = parcelRequire("3qSdM");

var $aSEG4 = parcelRequire("aSEG4");
var $1Ikg4 = parcelRequire("1Ikg4");



var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $df0c8e310c59ad79$export$4b25deb0350d3e53(slot) {
    return (0, $4Cod0.default)('MuiPickersDay', slot);
}
const $df0c8e310c59ad79$export$68b221ad3c35e288 = (0, $beCSm.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);




var $acw62 = parcelRequire("acw62");


function $0611e97a4959ebfc$export$250873c81c19b1fa(parameters) {
    const { disabled: disabled, selected: selected, today: today, outsideCurrentMonth: outsideCurrentMonth, day: day, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            day: day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $debdf8ecd16a24d2$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const $debdf8ecd16a24d2$var$useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected: isDaySelected, isDayDisabled: isDayDisabled, isDayCurrent: isDayCurrent, isDayOutsideMonth: isDayOutsideMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $df0c8e310c59ad79$export$4b25deb0350d3e53), classes);
};
const $debdf8ecd16a24d2$var$styleArg = ({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        height: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).disabled}:not(.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).disabled}&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $debdf8ecd16a24d2$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        !ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $debdf8ecd16a24d2$var$PickersDayRoot = (0, $1Ikg4.default)((0, $2TZUE.default), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $debdf8ecd16a24d2$var$overridesResolver
})($debdf8ecd16a24d2$var$styleArg);
const $debdf8ecd16a24d2$var$PickersDayFiller = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $debdf8ecd16a24d2$var$overridesResolver
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $debdf8ecd16a24d2$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $debdf8ecd16a24d2$var$noop = ()=>{};
const $debdf8ecd16a24d2$var$PickersDayRaw = /*#__PURE__*/ $acw62.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, classes: classesProp, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $debdf8ecd16a24d2$var$noop, onBlur: onBlur = $debdf8ecd16a24d2$var$noop, onKeyDown: onKeyDown = $debdf8ecd16a24d2$var$noop, onMouseDown: onMouseDown = $debdf8ecd16a24d2$var$noop, onMouseEnter: onMouseEnter = $debdf8ecd16a24d2$var$noop, children: children, day: day, selected: selected, disabled: disabled, today: today, outsideCurrentMonth: outsideCurrentMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $debdf8ecd16a24d2$var$_excluded);
    const ownerState = (0, $0611e97a4959ebfc$export$250873c81c19b1fa)({
        day: day,
        selected: selected,
        disabled: disabled,
        today: today,
        outsideCurrentMonth: outsideCurrentMonth,
        disableMargin: disableMargin,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const classes = $debdf8ecd16a24d2$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const ref = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $eEJPp.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $ayMG0.jsx)($debdf8ecd16a24d2$var$PickersDayFiller, {
        className: (0, $9QePP.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($debdf8ecd16a24d2$var$PickersDayRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $9QePP.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ?? adapter.format(day, 'dayOfMonth')
    }));
});
const $debdf8ecd16a24d2$export$d7378e6e864346fa = /*#__PURE__*/ $acw62.memo($debdf8ecd16a24d2$var$PickersDayRaw);








var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1Ikg4 = parcelRequire("1Ikg4");
var $b7Ol4 = parcelRequire("b7Ol4");

var $8Indx = parcelRequire("8Indx");

var $4GYug = parcelRequire("4GYug");

var $beKAS = parcelRequire("beKAS");

var $a0qps = parcelRequire("a0qps");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");


var $4NYRH = parcelRequire("4NYRH");
var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $a0qps.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $4NYRH.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $beKAS.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1mPeS.default), (0, $4GYug.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;


var $jEvxL = parcelRequire("jEvxL");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
const $3d4cac44a9271592$export$e98c1b6c3bbc3c59 = (slot)=>(0, $4Cod0.default)('MuiPickersSlideTransition', slot);
const $3d4cac44a9271592$export$d251a58673156a67 = (0, $beCSm.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);




var $ayMG0 = parcelRequire("ayMG0");
const $ef9c59b47aaa2788$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $ef9c59b47aaa2788$var$useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3d4cac44a9271592$export$e98c1b6c3bbc3c59), classes);
};
const $ef9c59b47aaa2788$var$PickersSlideTransitionRoot = (0, $1Ikg4.default)((0, $jEvxL.default), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $ef9c59b47aaa2788$export$e868fcc7557d3a06(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ef9c59b47aaa2788$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        slideDirection: slideDirection
    });
    const classes = $ef9c59b47aaa2788$var$useUtilityClasses(classesProp, ownerState);
    const theme = (0, $b7Ol4.default)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: (0, $9QePP.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ef9c59b47aaa2788$var$PickersSlideTransitionRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $acw62.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
const $4b3f532e169788fc$export$fbe827982a69894a = (slot)=>(0, $4Cod0.default)('MuiDayCalendar', slot);
const $4b3f532e169788fc$export$b3f91ee59da1294a = (0, $beCSm.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8b3294d04d14a0d3$var$_excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $8b3294d04d14a0d3$var$_excluded2 = [
    "ownerState"
];
const $8b3294d04d14a0d3$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $4b3f532e169788fc$export$fbe827982a69894a), classes);
};
const $8b3294d04d14a0d3$var$weeksContainerHeight = ((0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0) + (0, $e7cd373dd46c88ee$export$dde58b009b497666) * 2) * 6;
const $8b3294d04d14a0d3$var$PickersCalendarDayRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const $8b3294d04d14a0d3$var$PickersCalendarDayHeader = (0, $1Ikg4.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $8b3294d04d14a0d3$var$PickersCalendarWeekDayLabel = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $8b3294d04d14a0d3$var$PickersCalendarWeekNumberLabel = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const $8b3294d04d14a0d3$var$PickersCalendarWeekNumber = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        height: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $8b3294d04d14a0d3$var$PickersCalendarLoadingContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $8b3294d04d14a0d3$var$weeksContainerHeight
});
const $8b3294d04d14a0d3$var$PickersCalendarSlideTransition = (0, $1Ikg4.default)((0, $ef9c59b47aaa2788$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: $8b3294d04d14a0d3$var$weeksContainerHeight
});
const $8b3294d04d14a0d3$var$PickersCalendarWeekContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const $8b3294d04d14a0d3$var$PickersCalendarWeek = (0, $1Ikg4.default)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $8b3294d04d14a0d3$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusedDay: focusedDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $8b3294d04d14a0d3$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = $acw62.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = $acw62.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, $0611e97a4959ebfc$export$250873c81c19b1fa)({
        day: day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        disableHighlightToday: // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? (0, $debdf8ecd16a24d2$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            day: day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $8b3294d04d14a0d3$var$_excluded2);
    const isFirstVisibleCell = $acw62.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = $acw62.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Day, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $8b3294d04d14a0d3$export$8fb56b32a5df6314(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, classes: classesProp, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, timezone: timezone } = props;
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const classes = $8b3294d04d14a0d3$var$useUtilityClasses(classesProp);
    const isRtl = (0, $58lXc.useRtl)();
    const isDateDisabled = (0, $80335e50844415f8$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const handleDaySelect = (0, $13KXh.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, $13KXh.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $13KXh.default)((event, day)=>focusDay(day));
    const handleBlur = (0, $13KXh.default)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = $acw62.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $acw62.useMemo(()=>/*#__PURE__*/ $acw62.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = $acw62.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($8b3294d04d14a0d3$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($8b3294d04d14a0d3$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $b8d019f986eaf72a$export$24c38139da66592d)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarSlideTransition, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $9QePP.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)($8b3294d04d14a0d3$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8b3294d04d14a0d3$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $58lXc = parcelRequire("58lXc");

var $dgmWB = parcelRequire("dgmWB");

var $1Ikg4 = parcelRequire("1Ikg4");

var $agZ85 = parcelRequire("agZ85");

var $8Indx = parcelRequire("8Indx");

var $13KXh = parcelRequire("13KXh");



var $acw62 = parcelRequire("acw62");

var $aSEG4 = parcelRequire("aSEG4");
var $1Ikg4 = parcelRequire("1Ikg4");

var $eD6Co = parcelRequire("eD6Co");

var $8Indx = parcelRequire("8Indx");

var $eEJPp = parcelRequire("eEJPp");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $382e5932c87afd31$export$da0c97315339ebd9(slot) {
    return (0, $4Cod0.default)('MuiMonthCalendar', slot);
}
const $382e5932c87afd31$export$edf77d5566c7007c = (0, $beCSm.default)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $32226c2fe1be6a89$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $32226c2fe1be6a89$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $382e5932c87afd31$export$da0c97315339ebd9), classes);
};
const $32226c2fe1be6a89$var$DefaultMonthButton = (0, $1Ikg4.default)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $32226c2fe1be6a89$export$ca92875d3d780f06 = /*#__PURE__*/ $acw62.memo(function MonthCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $32226c2fe1be6a89$var$_excluded);
    const ref = $acw62.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = $32226c2fe1be6a89$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $eEJPp.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $32226c2fe1be6a89$var$DefaultMonthButton;
    const monthButtonProps = (0, $eD6Co.default)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(MonthButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, monthButtonProps));
});












var $acw62 = parcelRequire("acw62");





'use client';
function $53fd543f3597ad7b$export$6b73f8c5013b806e(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $acw62.useMemo(()=>({
            valueType: 'date',
            validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
            internal_valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
            internal_fieldValueManager: (0, $235c2ad72f19522e$export$b602c94f557316b4),
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $53fd543f3597ad7b$var$useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $53fd543f3597ad7b$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $53fd543f3597ad7b$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    return $acw62.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $53fd543f3597ad7b$var$useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const validationProps = $53fd543f3597ad7b$export$82ecc8c5f467152f(internalProps);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, internalProps, validationProps, {
            format: internalProps.format ?? adapter.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        adapter
    ]);
}
function $53fd543f3597ad7b$export$82ecc8c5f467152f(props) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const defaultDates = (0, $06e5a97a469e375c$export$7c38da3a2e90fa83)();
    return $acw62.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $bcb80215d92225f5$var$_excluded = [
    "autoFocus",
    "className",
    "currentMonth",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $bcb80215d92225f5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $382e5932c87afd31$export$da0c97315339ebd9), classes);
};
function $bcb80215d92225f5$export$5b6e066572408095(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const $bcb80215d92225f5$var$isSameMonth = (monthA, monthB, yearA, yearB, adapter)=>Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const $bcb80215d92225f5$var$MonthCalendarRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
const $bcb80215d92225f5$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $acw62.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $bcb80215d92225f5$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { autoFocus: autoFocus, className: className, currentMonth: currentMonth, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $bcb80215d92225f5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $58lXc.useRtl)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const referenceDate = $acw62.useMemo(()=>(0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $bcb80215d92225f5$var$useUtilityClasses(classesProp);
    const todayMonth = $acw62.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = $acw62.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = $acw62.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $agZ85.default)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $13KXh.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $acw62.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, $13KXh.default)((event, month)=>{
        if (readOnly) return;
        const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
        const newDate = adapter.setMonth(currentValue ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $13KXh.default)((month)=>{
        if (!isMonthDisabled(adapter.setMonth(value ?? currentMonth ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $13KXh.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $13KXh.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $13KXh.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bcb80215d92225f5$var$MonthCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, currentMonth ?? value ?? referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = $bcb80215d92225f5$var$isSameMonth(monthNumber, selectedMonth, month, value, adapter);
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32226c2fe1be6a89$export$ca92875d3d780f06), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": $bcb80215d92225f5$var$isSameMonth(monthNumber, todayMonth, month, now, adapter) ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});





var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $58lXc = parcelRequire("58lXc");

var $dgmWB = parcelRequire("dgmWB");

var $1Ikg4 = parcelRequire("1Ikg4");

var $3qSdM = parcelRequire("3qSdM");

var $8Indx = parcelRequire("8Indx");

var $agZ85 = parcelRequire("agZ85");

var $13KXh = parcelRequire("13KXh");



var $acw62 = parcelRequire("acw62");

var $aSEG4 = parcelRequire("aSEG4");
var $1Ikg4 = parcelRequire("1Ikg4");

var $eD6Co = parcelRequire("eD6Co");

var $8Indx = parcelRequire("8Indx");

var $eEJPp = parcelRequire("eEJPp");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $8113954354676ea0$export$4477acc520094dec(slot) {
    return (0, $4Cod0.default)('MuiYearCalendar', slot);
}
const $8113954354676ea0$export$e42d427cd9fe5fd7 = (0, $beCSm.default)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



var $ayMG0 = parcelRequire("ayMG0");
const $daf9ac3ae8412985$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $daf9ac3ae8412985$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8113954354676ea0$export$4477acc520094dec), classes);
};
const $daf9ac3ae8412985$var$DefaultYearButton = (0, $1Ikg4.default)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $daf9ac3ae8412985$export$cc9e2b0aa124cbe6 = /*#__PURE__*/ $acw62.memo(function YearCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $daf9ac3ae8412985$var$_excluded);
    const ref = $acw62.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = $daf9ac3ae8412985$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $eEJPp.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $daf9ac3ae8412985$var$DefaultYearButton;
    const yearButtonProps = (0, $eD6Co.default)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(YearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, yearButtonProps));
});












var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f8af41512995675d$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $f8af41512995675d$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $8113954354676ea0$export$4477acc520094dec), classes);
};
function $f8af41512995675d$var$useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const $f8af41512995675d$var$YearCalendarRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $dgmWB.shouldForwardProp)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    maxHeight: (0, $e7cd373dd46c88ee$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const $f8af41512995675d$var$YearCalendarButtonFiller = (0, $1Ikg4.default)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
const $f8af41512995675d$export$657f9200591b2b71 = /*#__PURE__*/ $acw62.forwardRef(function YearCalendar(inProps, ref) {
    const props = $f8af41512995675d$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $f8af41512995675d$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $58lXc.useRtl)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const referenceDate = $acw62.useMemo(()=>(0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $f8af41512995675d$var$useUtilityClasses(classesProp);
    const todayYear = $acw62.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = $acw62.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = $acw62.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $agZ85.default)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $13KXh.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $acw62.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, $13KXh.default)((event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $13KXh.default)((year)=>{
        if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $13KXh.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $13KXh.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $13KXh.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, scrollerRef);
    $acw62.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($f8af41512995675d$var$YearCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daf9ac3ae8412985$export$cc9e2b0aa124cbe6), {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($f8af41512995675d$var$YearCalendarButtonFiller, {}, index))
        ]
    }));
});




var $acw62 = parcelRequire("acw62");

var $13KXh = parcelRequire("13KXh");

var $agZ85 = parcelRequire("agZ85");

const $93c878f075509e16$export$c9a0b669a5b51c7d = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
function $93c878f075509e16$export$768f745bfa10c92a(parameters) {
    const { steps: steps, isViewMatchingStep: isViewMatchingStep, onStepChange: onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return $93c878f075509e16$export$c9a0b669a5b51c7d;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}


'use client';
let $30cf9c7f82fc091d$var$warnedOnceNotValidView = false;
function $30cf9c7f82fc091d$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, getStepNavigation: getStepNavigation }) {
    const previousOpenTo = $acw62.useRef(openTo);
    const previousViews = $acw62.useRef(views);
    const defaultView = $acw62.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $agZ85.default)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $acw62.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $agZ85.default)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView: setView,
        view: view,
        defaultView: defaultView.current,
        views: views
    }) : (0, $93c878f075509e16$export$c9a0b669a5b51c7d);
    $acw62.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $13KXh.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $13KXh.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $13KXh.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $13KXh.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, stepNavigation, {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    });
}





var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $fanil = parcelRequire("fanil");

var $1Ikg4 = parcelRequire("1Ikg4");

var $eD6Co = parcelRequire("eD6Co");

var $8Indx = parcelRequire("8Indx");

var $u24M4 = parcelRequire("u24M4");






var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $7X4mk = parcelRequire("7X4mk");

var $58lXc = parcelRequire("58lXc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $eD6Co = parcelRequire("eD6Co");

var $u24M4 = parcelRequire("u24M4");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $6a19e334ff9f8c78$export$cef978c25740de90(slot) {
    return (0, $4Cod0.default)('MuiPickersArrowSwitcher', slot);
}
const $6a19e334ff9f8c78$export$f8819209558cd362 = (0, $beCSm.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);




var $ayMG0 = parcelRequire("ayMG0");
const $e6440e639c149fbf$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], $e6440e639c149fbf$var$_excluded2 = [
    "ownerState"
], $e6440e639c149fbf$var$_excluded3 = [
    "ownerState"
];
const $e6440e639c149fbf$var$PickersArrowSwitcherRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const $e6440e639c149fbf$var$PickersArrowSwitcherSpacer = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $e6440e639c149fbf$var$PickersArrowSwitcherButton = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $e6440e639c149fbf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6a19e334ff9f8c78$export$cef978c25740de90), classes);
};
const $e6440e639c149fbf$export$597b7cbdb7b2a24c = /*#__PURE__*/ $acw62.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $58lXc.useRtl)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e6440e639c149fbf$var$_excluded);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const classes = $e6440e639c149fbf$var$useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $e6440e639c149fbf$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $eD6Co.default)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, $9QePP.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $e6440e639c149fbf$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $eD6Co.default)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, $9QePP.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $ef8448afaa732d42$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $e6440e639c149fbf$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $ef8448afaa732d42$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $eD6Co.default)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps2, $e6440e639c149fbf$var$_excluded3);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e6440e639c149fbf$var$PickersArrowSwitcherRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(PreviousIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($e6440e639c149fbf$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(NextIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $ayMG0.jsx)(LeftArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $ayMG0.jsx)(RightArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});




var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
const $31260ac424c24a7a$export$457ac4d3a1ad92b4 = (slot)=>(0, $4Cod0.default)('MuiPickersCalendarHeader', slot);
const $31260ac424c24a7a$export$63db7afb9247cb91 = (0, $beCSm.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d89bffda0f64a7a5$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], $d89bffda0f64a7a5$var$_excluded2 = [
    "ownerState"
];
const $d89bffda0f64a7a5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $31260ac424c24a7a$export$457ac4d3a1ad92b4), classes);
};
const $d89bffda0f64a7a5$var$PickersCalendarHeaderRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderLabelContainer = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $d89bffda0f64a7a5$var$PickersCalendarHeaderLabel = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewButton = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, $31260ac424c24a7a$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewIcon = (0, $1Ikg4.default)((0, $ef8448afaa732d42$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $d89bffda0f64a7a5$export$6801ffebb353f473 = /*#__PURE__*/ $acw62.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, classes: classesProp, timezone: timezone, format: format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d89bffda0f64a7a5$var$_excluded);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const classes = $d89bffda0f64a7a5$var$useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $eD6Co.default)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            view: view
        }),
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $d89bffda0f64a7a5$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, $8992dd6789b4ad9e$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $8992dd6789b4ad9e$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d89bffda0f64a7a5$var$PickersCalendarHeaderRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $9QePP.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($d89bffda0f64a7a5$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9c2e6cdd3bb22caf$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d89bffda0f64a7a5$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(SwitchViewIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fanil.default), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e6440e639c149fbf$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});




var $1Ikg4 = parcelRequire("1Ikg4");

const $88548032dcbf72cd$export$512b066b8abdfde4 = (0, $1Ikg4.default)('div')({
    overflow: 'hidden',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});



const $fb5fb152771bc52e$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $fb5fb152771bc52e$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $fb5fb152771bc52e$var$androidVersion = $fb5fb152771bc52e$var$mobileVersionMatches && $fb5fb152771bc52e$var$mobileVersionMatches[1] ? parseInt($fb5fb152771bc52e$var$mobileVersionMatches[1], 10) : null;
const $fb5fb152771bc52e$var$iOSVersion = $fb5fb152771bc52e$var$mobileVersionMatches && $fb5fb152771bc52e$var$mobileVersionMatches[2] ? parseInt($fb5fb152771bc52e$var$mobileVersionMatches[2], 10) : null;
const $fb5fb152771bc52e$export$7e3b2a595fb375e5 = $fb5fb152771bc52e$var$androidVersion && $fb5fb152771bc52e$var$androidVersion < 10 || $fb5fb152771bc52e$var$iOSVersion && $fb5fb152771bc52e$var$iOSVersion < 13 || false;
function $fb5fb152771bc52e$export$7e40eba507bb97c4(customReduceAnimations) {
    const prefersReduced = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)($fb5fb152771bc52e$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || $fb5fb152771bc52e$export$7e3b2a595fb375e5;
}



var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
const $5bfbcb5a53a6644f$export$da8c2318897a6672 = (slot)=>(0, $4Cod0.default)('MuiDateCalendar', slot);
const $5bfbcb5a53a6644f$export$d0237e2bb9598e8d = (0, $beCSm.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);









var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d3f0ed23ac3123aa$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $d3f0ed23ac3123aa$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $5bfbcb5a53a6644f$export$da8c2318897a6672), classes);
};
function $d3f0ed23ac3123aa$var$useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const reduceAnimations = (0, $fb5fb152771bc52e$export$7e40eba507bb97c4)(themeProps.reduceAnimations);
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: "..."
            }))
    });
}
const $d3f0ed23ac3123aa$var$DateCalendarRoot = (0, $1Ikg4.default)((0, $88548032dcbf72cd$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7)
});
const $d3f0ed23ac3123aa$var$DateCalendarViewTransitionContainer = (0, $1Ikg4.default)((0, $9c2e6cdd3bb22caf$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
const $d3f0ed23ac3123aa$export$68078fe5d2bf8909 = /*#__PURE__*/ $acw62.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const id = (0, $auC0X.default)();
    const props = $d3f0ed23ac3123aa$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d3f0ed23ac3123aa$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, setVisibleDate: setVisibleDate, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $5efae1633883dea7$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $d89bffda0f64a7a5$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $eD6Co.default)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: ownerState
    });
    const handleDateMonthChange = (0, $13KXh.default)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, $13KXh.default)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, $13KXh.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $acw62.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = $d3f0ed23ac3123aa$var$useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $acw62.useRef(view);
    $acw62.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $acw62.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($d3f0ed23ac3123aa$var$DateCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)(CalendarHeader, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d3f0ed23ac3123aa$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8af41512995675d$export$657f9200591b2b71), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bcb80215d92225f5$export$d7a7c85c0f5afc4a), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            currentMonth: calendarState.currentMonth,
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b3294d04d14a0d3$export$8fb56b32a5df6314), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
const $4f7c04d922b20a4c$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3f0ed23ac3123aa$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $b8d019f986eaf72a$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $b8d019f986eaf72a$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });






parcelRequire("acw62");

var $eD6Co = parcelRequire("eD6Co");



var $acw62 = parcelRequire("acw62");

var $eD6Co = parcelRequire("eD6Co");

var $7LOKt = parcelRequire("7LOKt");

var $fanil = parcelRequire("fanil");

var $gc70Y = parcelRequire("gc70Y");

var $iyxBj = parcelRequire("iyxBj");

var $3x66i = parcelRequire("3x66i");

var $3qSdM = parcelRequire("3qSdM");

var $13KXh = parcelRequire("13KXh");

var $6zeBo = parcelRequire("6zeBo");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $b7732b7b1a3865b1$export$13707a1542cd4ff5(slot) {
    return (0, $4Cod0.default)('MuiPickerPopper', slot);
}
const $b7732b7b1a3865b1$export$e7d83f8e0f3c53d3 = (0, $beCSm.default)('MuiPickerPopper', [
    'root',
    'paper'
]);






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $d41682fbe562e739$var$_excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $d41682fbe562e739$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $b7732b7b1a3865b1$export$13707a1542cd4ff5), classes);
};
const $d41682fbe562e739$var$PickerPopperRoot = (0, $1Ikg4.default)((0, $iyxBj.default), {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $d41682fbe562e739$var$PickerPopperPaper = (0, $1Ikg4.default)((0, $gc70Y.default), {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement: popperPlacement })=>new Set([
                    'top',
                    'top-start',
                    'top-end'
                ]).has(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $d41682fbe562e739$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $d41682fbe562e739$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $13KXh.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $6zeBo.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $d41682fbe562e739$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = (event)=>{
        // Ignore events handled by our internal components
        if (!event.defaultMuiPrevented) syntheticEventRef.current = true;
    };
    $acw62.useEffect(()=>{
        if (active) {
            const doc = (0, $6zeBo.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $acw62.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $6zeBo.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $d41682fbe562e739$var$PickerPopperPaperWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, ownerState: ownerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d41682fbe562e739$var$_excluded);
    const paperProps = (0, $eD6Co.default)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(PaperComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $d41682fbe562e739$export$ac84dff7cf037abd(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children: children, placement: placement = 'bottom-start', slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const { open: open, popupRef: popupRef, reduceAnimations: reduceAnimations } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { ownerState: pickerOwnerState, rootRefObject: rootRefObject } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { dismissViews: dismissViews, getCurrentViewMode: getCurrentViewMode, onPopperExited: onPopperExited, triggerElement: triggerElement, viewContainerRole: viewContainerRole } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    $acw62.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(rootRefObject.current);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode,
        rootRefObject
    ]);
    const classes = $d41682fbe562e739$var$useUtilityClasses(classesProp);
    const handleClickAway = (0, $13KXh.default)(()=>{
        if (viewContainerRole === 'tooltip') (0, $7c44784990d74e44$export$2e03bc8dde24716b)(()=>{
            if (rootRefObject.current?.contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(rootRefObject.current)) || popupRef.current?.contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(popupRef.current))) return;
            dismissViews();
        });
        else dismissViews();
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $d41682fbe562e739$var$useClickAwayListener(open, handleClickAway);
    const paperRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(paperRef, popupRef);
    const handlePaperRef = (0, $3qSdM.default)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $fanil.default) : (0, $7LOKt.default);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $3x66i.default);
    const Paper = slots?.desktopPaper ?? $d41682fbe562e739$var$PickerPopperPaper;
    const Popper = slots?.popper ?? $d41682fbe562e739$var$PickerPopperRoot;
    const popperProps = (0, $eD6Co.default)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open: open,
            placement: placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: pickerOwnerState
    });
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            popperPlacement: popperProps.placement
        }), [
        pickerOwnerState,
        popperProps.placement
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Popper, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)(FocusTrap, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(Transition, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, TransitionProps, slotProps?.desktopTransition, {
                    onExited: (event)=>{
                        onPopperExited?.();
                        slotProps?.desktopTransition?.onExited?.(event);
                        TransitionProps?.onExited?.();
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($d41682fbe562e739$var$PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $13KXh = parcelRequire("13KXh");

var $3qSdM = parcelRequire("3qSdM");

var $auC0X = parcelRequire("auC0X");





var $acw62 = parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

'use client';
function $dc73f3acfd5fdff0$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $dc73f3acfd5fdff0$export$550084c67147f6c4(views, customOrientation) {
    const [orientation, setOrientation] = $acw62.useState($dc73f3acfd5fdff0$var$getOrientation);
    (0, $eEJPp.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($dc73f3acfd5fdff0$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $7c44784990d74e44$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}




var $acw62 = parcelRequire("acw62");


var $13KXh = parcelRequire("13KXh");



'use client';
function $38c52d6ac7972c3f$export$475fd52a3cfe883b(parameters) {
    const { props: props, valueManager: valueManager, validator: validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange: onChange, referenceDate: referenceDate, timezone: timezoneProp, onAccept: onAccept, closeOnSelect: closeOnSelect, open: openProp, onOpen: onOpen, onClose: onClose } = props;
    const { current: defaultValue } = $acw62.useRef(defaultValueProp);
    const { current: isValueControlled } = $acw62.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = $acw62.useRef(openProp !== undefined);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone: timezone, value: value, handleValueChange: handleValueChange } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [state, setState] = $acw62.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $3811c2c4b61492d0$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: props.onError
    });
    const setOpen = (0, $13KXh.default)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, $13KXh.default)((newValue, options)=>{
        const { changeImportance: changeImportance = 'accept', skipPublicationIfPristine: skipPublicationIfPristine = false, validationError: validationError, shortcut: shortcut, shouldClose: shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, $13KXh.default)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $acw62.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = $acw62.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone: timezone,
        state: state,
        setValue: setValue,
        setValueFromView: setValueFromView,
        setOpen: setOpen,
        value: value,
        viewValue: viewValue
    };
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $eb07fb7878304460$var$_excluded = [
    "className",
    "sx"
];
const $eb07fb7878304460$export$fc3313977ac596c4 = ({ ref: ref, props: props, valueManager: valueManager, valueType: valueType, variant: variant, validator: validator, onPopperExited: onPopperExited, autoFocusView: autoFocusView, rendererInterceptor: RendererInterceptor, localeText: localeText, viewContainerRole: viewContainerRole, getStepNavigation: getStepNavigation })=>{
    const { views: // View props
    views, view: viewProp, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker: disableOpenPicker, closeOnSelect: closeOnSelect, disabled: // Form props
    disabled, readOnly: readOnly, formatDensity: // Field props
    formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, format: format, label: label, autoFocus: // Other props
    autoFocus, name: name } = props;
    const { className: className, sx: sx } = props, propsToForwardToView = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $eb07fb7878304460$var$_excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, $auC0X.default)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const reduceAnimations = (0, $fb5fb152771bc52e$export$7e40eba507bb97c4)(reduceAnimationsProp);
    const orientation = (0, $dc73f3acfd5fdff0$export$550084c67147f6c4)(views, orientationProp);
    const { current: initialView } = $acw62.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = $acw62.useState(null);
    const popupRef = $acw62.useRef(null);
    const fieldRef = $acw62.useRef(null);
    const rootRefObject = $acw62.useRef(null);
    const rootRef = (0, $3qSdM.default)(ref, rootRefObject);
    const { timezone: timezone, state: state, setOpen: setOpen, setValue: setValue, setValueFromView: setValueFromView, value: value, viewValue: viewValue } = (0, $38c52d6ac7972c3f$export$475fd52a3cfe883b)({
        props: props,
        valueManager: valueManager,
        validator: validator
    });
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView, goToNextStep: goToNextStep, hasNextStep: hasNextStep, hasSeveralSteps: hasSeveralSteps } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: viewProp,
        views: views,
        openTo: openTo,
        onChange: setValueFromView,
        onViewChange: onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation: getStepNavigation
    });
    const clearValue = (0, $13KXh.default)(()=>setValue(valueManager.emptyValue));
    const setValueToToday = (0, $13KXh.default)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType)));
    const acceptValueChanges = (0, $13KXh.default)(()=>setValue(value));
    const cancelValueChanges = (0, $13KXh.default)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true
        }));
    const dismissViews = (0, $13KXh.default)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true
        });
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup, timeViewsCount: timeViewsCount } = $acw62.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, $13KXh.default)(()=>currentViewMode);
    const [popperView, setPopperView] = $acw62.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $eEJPp.default)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $eEJPp.default)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = $acw62.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = $acw62.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, $13KXh.default)(goToNextStep);
    const defaultActionBarActions = $acw62.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = $acw62.useMemo(()=>({
            setValue: setValue,
            setOpen: setOpen,
            clearValue: clearValue,
            setValueToToday: setValueToToday,
            acceptValueChanges: acceptValueChanges,
            cancelValueChanges: cancelValueChanges,
            setView: setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionsContextValue, {
            value: value,
            timezone: timezone,
            open: state.open,
            views: views,
            view: popperView,
            initialView: initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant: variant,
            orientation: orientation,
            popupRef: popupRef,
            reduceAnimations: reduceAnimations,
            triggerRef: triggerRef,
            triggerStatus: triggerStatus,
            hasNextStep: hasNextStep,
            fieldFormat: format ?? '',
            name: name,
            label: label,
            rootSx: sx,
            rootRef: rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = $acw62.useMemo(()=>({
            dismissViews: dismissViews,
            ownerState: ownerState,
            hasUIView: hasUIView,
            getCurrentViewMode: getCurrentViewMode,
            rootRefObject: rootRefObject,
            labelId: labelId,
            triggerElement: triggerElement,
            viewContainerRole: viewContainerRole,
            defaultActionBarActions: defaultActionBarActions,
            onPopperExited: onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = $acw62.useMemo(()=>({
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            fieldRef: fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, propsToForwardToView, {
            views: views,
            timezone: timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount: timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView: focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, $ayMG0.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText: localeText,
            contextValue: contextValue,
            privateContextValue: privateContextValue,
            actionsContextValue: actionsContextValue,
            fieldPrivateContextValue: fieldPrivateContextValue,
            isValidContextValue: isValidContextValue
        },
        renderCurrentView: renderCurrentView,
        ownerState: ownerState
    };
};



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $155427cbf9212b77$export$1671c31de798d429(slot) {
    return (0, $4Cod0.default)('MuiPickersLayout', slot);
}
const $155427cbf9212b77$export$7a6dac186703fe4c = (0, $beCSm.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);





var $acw62 = parcelRequire("acw62");

var $eD6Co = parcelRequire("eD6Co");

var $8Indx = parcelRequire("8Indx");

var $58lXc = parcelRequire("58lXc");



var $acw62 = parcelRequire("acw62");


var $1Ikg4 = parcelRequire("1Ikg4");

var $03kOd = parcelRequire("03kOd");

var $hHAIz = parcelRequire("hHAIz");



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6693fe5c74d9d803$var$_excluded = [
    "actions"
];
const $6693fe5c74d9d803$var$PickersActionBarRoot = (0, $1Ikg4.default)((0, $hHAIz.default), {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $6693fe5c74d9d803$var$PickersActionBarComponent(props) {
    const { actions: actions } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $6693fe5c74d9d803$var$_excluded);
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { clearValue: clearValue, setValueToToday: setValueToToday, acceptValueChanges: acceptValueChanges, cancelValueChanges: cancelValueChanges, goToNextStep: goToNextStep, hasNextStep: hasNextStep } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6693fe5c74d9d803$var$PickersActionBarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}
const $6693fe5c74d9d803$export$72ffda3bb7ecf665 = /*#__PURE__*/ $acw62.memo($6693fe5c74d9d803$var$PickersActionBarComponent);





parcelRequire("acw62");

var $1Ikg4 = parcelRequire("1Ikg4");


var $iFUDK = parcelRequire("iFUDK");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");



var $awhpc = parcelRequire("awhpc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $e03L8 = parcelRequire("e03L8");

var $Uq4Et = parcelRequire("Uq4Et");

var $hAwwT = parcelRequire("hAwwT");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $f57d788b3d4818ce$export$5682c366c0c669d9(slot) {
    return (0, $4Cod0.default)('MuiListItem', slot);
}
const $f57d788b3d4818ce$var$listItemClasses = (0, $beCSm.default)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $f57d788b3d4818ce$export$2e2bcd8739ae039 = $f57d788b3d4818ce$var$listItemClasses;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $9ec0b6032559d604$export$c09531d8563c67a5(slot) {
    return (0, $4Cod0.default)('MuiListItemButton', slot);
}
const $9ec0b6032559d604$var$listItemButtonClasses = (0, $beCSm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $9ec0b6032559d604$export$2e2bcd8739ae039 = $9ec0b6032559d604$var$listItemButtonClasses;



var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $hAwwT = parcelRequire("hAwwT");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $6e4beb15e8922c23$export$ccdb26aeba48a86e(slot) {
    return (0, $4Cod0.default)('MuiListItemSecondaryAction', slot);
}
const $6e4beb15e8922c23$var$listItemSecondaryActionClasses = (0, $beCSm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $6e4beb15e8922c23$export$2e2bcd8739ae039 = $6e4beb15e8922c23$var$listItemSecondaryActionClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $220479a88558a65e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $6e4beb15e8922c23$export$ccdb26aeba48a86e), classes);
};
const $220479a88558a65e$var$ListItemSecondaryActionRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $220479a88558a65e$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $hAwwT.default));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $220479a88558a65e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($220479a88558a65e$var$ListItemSecondaryActionRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$220479a88558a65e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $220479a88558a65e$export$2e2bcd8739ae039 = $220479a88558a65e$var$ListItemSecondaryAction;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c1d275280a204574$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $c1d275280a204574$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f57d788b3d4818ce$export$5682c366c0c669d9), classes);
};
const $c1d275280a204574$export$aed538f7519abe89 = (0, $1Ikg4.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $c1d275280a204574$export$4334bb34c76fef24
})((0, $lwQO9.default)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $c1d275280a204574$var$ListItemContainer = (0, $1Ikg4.default)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $c1d275280a204574$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $acw62.useContext((0, $hAwwT.default));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $e03L8.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $c1d275280a204574$var$useUtilityClasses(ownerState);
    const handleRef = (0, $Uq4Et.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $c1d275280a204574$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $9QePP.default)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAwwT.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($c1d275280a204574$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $9QePP.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $awhpc.default)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAwwT.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $awhpc.default)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $220479a88558a65e$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $c1d275280a204574$export$2e2bcd8739ae039 = $c1d275280a204574$var$ListItem;



var $JYcZH = parcelRequire("JYcZH");


var $acw62 = parcelRequire("acw62");

'use client';
const $d6cf70c05c8e3b39$export$64b5b0e74c5c8445 = ()=>{
    const value = $acw62.useContext((0, $c33c428cfda4b7d5$export$d1dfa4910c58a4e));
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a2757c031fec5fda$var$_excluded = [
    "items",
    "changeImportance"
], $a2757c031fec5fda$var$_excluded2 = [
    "getValue"
];
const $a2757c031fec5fda$var$PickersShortcutsRoot = (0, $1Ikg4.default)((0, $iFUDK.default), {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $a2757c031fec5fda$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = 'accept' } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a2757c031fec5fda$var$_excluded);
    const { setValue: setValue } = (0, $d6cf70c05c8e3b39$export$64b5b0e74c5c8445)();
    const isValidValue = (0, $bbd57edb25eace5e$export$52df06af7329e367)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a2757c031fec5fda$var$_excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance: changeImportance,
                    shortcut: item
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a2757c031fec5fda$var$PickersShortcutsRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item))
            }, item.id ?? item.label);
        })
    }));
}





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $93d540a51b4256a1$var$_excluded = [
    "ownerState"
];
function $93d540a51b4256a1$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $93d540a51b4256a1$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $155427cbf9212b77$export$1671c31de798d429), classes);
};
const $93d540a51b4256a1$var$usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions: defaultActionBarActions } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { view: view } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const isRtl = (0, $58lXc.useRtl)();
    const { children: children, slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = $93d540a51b4256a1$var$useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $6693fe5c74d9d803$export$72ffda3bb7ecf665);
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState: ownerState
    }), actionBarProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $93d540a51b4256a1$var$_excluded);
    const actionBar = /*#__PURE__*/ (0, $ayMG0.jsx)(ActionBar, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $eD6Co.default)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState: ownerState
    });
    const toolbar = $93d540a51b4256a1$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $ayMG0.jsx)(Toolbar, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $ayMG0.jsx)(Tabs, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $a2757c031fec5fda$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $eD6Co.default)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState: ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $ayMG0.jsx)(Shortcuts, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            hasShortcuts: hasShortcuts
        })
    };
};
var $93d540a51b4256a1$export$2e2bcd8739ae039 = $93d540a51b4256a1$var$usePickerLayout;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c6a4a7c871810436$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $155427cbf9212b77$export$1671c31de798d429), classes);
};
const $c6a4a7c871810436$export$9a9363506c13836 = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const $c6a4a7c871810436$export$bc1494d918129235 = (0, $1Ikg4.default)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $c6a4a7c871810436$export$647f604ea2397c05 = /*#__PURE__*/ $acw62.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $93d540a51b4256a1$export$2e2bcd8739ae039)(props);
    const { orientation: orientation, variant: variant } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { sx: sx, className: className, classes: classesProp } = props;
    const classes = $c6a4a7c871810436$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c6a4a7c871810436$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsx)($c6a4a7c871810436$export$bc1494d918129235, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});




function $f154a91c12ef630c$export$57511d4166284144(parameters) {
    const { steps: steps } = parameters;
    return (0, $93c878f075509e16$export$768f745bfa10c92a)({
        steps: steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step: step, defaultView: defaultView, setView: setView, view: view, views: views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}



var $ayMG0 = parcelRequire("ayMG0");
const $921f50d8d6fdef68$var$_excluded = [
    "props",
    "steps"
], $921f50d8d6fdef68$var$_excluded2 = [
    "ownerState"
];
const $921f50d8d6fdef68$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $921f50d8d6fdef68$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $f154a91c12ef630c$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb07fb7878304460$export$fc3313977ac596c4)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $921f50d8d6fdef68$var$_excluded2);
    const Layout = slots.layout ?? (0, $c6a4a7c871810436$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c33c428cfda4b7d5$export$aae9fbe9dd4050fa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d41682fbe562e739$export$ac84dff7cf037abd), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $auC0X = parcelRequire("auC0X");








var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $c25eda3950c42327$export$148b188041a720e4(slot) {
    return (0, $4Cod0.default)('MuiTimeClock', slot);
}
const $c25eda3950c42327$export$191dec874db3257b = (0, $beCSm.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);




var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $u24M4 = parcelRequire("u24M4");

var $7X4mk = parcelRequire("7X4mk");

var $1Ikg4 = parcelRequire("1Ikg4");

var $eEJPp = parcelRequire("eEJPp");

var $8Indx = parcelRequire("8Indx");



var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");
const $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6 = 220;
const $f4bb1bb3f1c23d05$export$729c0e543e4dc21d = 36;
const $f4bb1bb3f1c23d05$var$clockCenter = {
    x: $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6 / 2,
    y: $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6 / 2
};
const $f4bb1bb3f1c23d05$var$baseClockPoint = {
    x: $f4bb1bb3f1c23d05$var$clockCenter.x,
    y: 0
};
const $f4bb1bb3f1c23d05$var$cx = $f4bb1bb3f1c23d05$var$baseClockPoint.x - $f4bb1bb3f1c23d05$var$clockCenter.x;
const $f4bb1bb3f1c23d05$var$cy = $f4bb1bb3f1c23d05$var$baseClockPoint.y - $f4bb1bb3f1c23d05$var$clockCenter.y;
const $f4bb1bb3f1c23d05$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $f4bb1bb3f1c23d05$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $f4bb1bb3f1c23d05$var$clockCenter.x;
    const y = offsetY - $f4bb1bb3f1c23d05$var$clockCenter.y;
    const atan = Math.atan2($f4bb1bb3f1c23d05$var$cx, $f4bb1bb3f1c23d05$var$cy) - Math.atan2(x, y);
    let deg = $f4bb1bb3f1c23d05$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $f4bb1bb3f1c23d05$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $f4bb1bb3f1c23d05$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $f4bb1bb3f1c23d05$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $f4bb1bb3f1c23d05$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6 / 2 - $f4bb1bb3f1c23d05$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $bda165300ebfe242$export$12faa62796978e2f(slot) {
    return (0, $4Cod0.default)('MuiClockPointer', slot);
}
const $bda165300ebfe242$export$64afeec9352615cb = (0, $beCSm.default)('MuiClockPointer', [
    'root',
    'thumb'
]);




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f95698f6901368ba$var$_excluded = [
    "className",
    "classes",
    "isBetweenTwoClockValues",
    "isInner",
    "type",
    "viewValue"
];
const $f95698f6901368ba$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bda165300ebfe242$export$12faa62796978e2f), classes);
};
const $f95698f6901368ba$var$ClockPointerRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root'
})(({ theme: theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    isClockPointerAnimated: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const $f95698f6901368ba$var$ClockPointerThumb = (0, $1Ikg4.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb'
})(({ theme: theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    isClockPointerBetweenTwoValues: false
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
function $f95698f6901368ba$export$f257f213e6c08f97(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, classes: classesProp, isBetweenTwoClockValues: isBetweenTwoClockValues, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $f95698f6901368ba$var$_excluded);
    const previousType = $acw62.useRef(type);
    $acw62.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isClockPointerAnimated: previousType.current !== type,
        isClockPointerBetweenTwoValues: isBetweenTwoClockValues
    });
    const classes = $f95698f6901368ba$var$useUtilityClasses(classesProp);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f95698f6901368ba$var$ClockPointerRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: getAngleStyle(),
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($f95698f6901368ba$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $296b71f80d72a83a$export$e44ecab24167799b(slot) {
    return (0, $4Cod0.default)('MuiClock', slot);
}
const $296b71f80d72a83a$export$4626e3a61e161c64 = (0, $beCSm.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText',
    'selected'
]);





var $ayMG0 = parcelRequire("ayMG0");
const $4a42c559a8325457$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton',
            ownerState.clockMeridiemMode === 'am' && 'selected'
        ],
        pmButton: [
            'pmButton',
            ownerState.clockMeridiemMode === 'pm' && 'selected'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $296b71f80d72a83a$export$e44ecab24167799b), classes);
};
const $4a42c559a8325457$var$ClockRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiClock',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $4a42c559a8325457$var$ClockClock = (0, $1Ikg4.default)('div', {
    name: 'MuiClock',
    slot: 'Clock'
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $4a42c559a8325457$var$ClockWrapper = (0, $1Ikg4.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper'
})({
    '&:focus': {
        outline: 'none'
    }
});
const $4a42c559a8325457$var$ClockSquareMask = (0, $1Ikg4.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask'
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                isClockDisabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const $4a42c559a8325457$var$ClockPin = (0, $1Ikg4.default)('div', {
    name: 'MuiClock',
    slot: 'Pin'
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $4a42c559a8325457$var$meridiemButtonCommonStyles = (theme, clockMeridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d),
        variants: [
            {
                props: {
                    clockMeridiemMode: clockMeridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const $4a42c559a8325457$var$ClockAmButton = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiClock',
    slot: 'AmButton'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $4a42c559a8325457$var$meridiemButtonCommonStyles(theme, 'am'), {
        // keeping it here to make TS happy
        position: 'absolute',
        left: 8
    }));
const $4a42c559a8325457$var$ClockPmButton = (0, $1Ikg4.default)((0, $u24M4.default), {
    name: 'MuiClock',
    slot: 'PmButton'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $4a42c559a8325457$var$meridiemButtonCommonStyles(theme, 'pm'), {
        // keeping it here to make TS happy
        position: 'absolute',
        right: 8
    }));
const $4a42c559a8325457$var$ClockMeridiemText = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiClock',
    slot: 'MeridiemText'
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
function $4a42c559a8325457$export$9735c82c4bae3302(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, viewRange: [minViewValue, maxViewValue], disabled: disabled = false, readOnly: readOnly, className: className, classes: classesProp } = props;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isClockDisabled: disabled,
        clockMeridiemMode: meridiemMode
    });
    const isMoving = $acw62.useRef(false);
    const classes = $4a42c559a8325457$var$useUtilityClasses(classesProp, ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $f4bb1bb3f1c23d05$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $f4bb1bb3f1c23d05$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
        event.preventDefault();
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const isPointerBetweenTwoClockValues = type === 'hours' ? false : viewValue % 5 !== 0;
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $acw62.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $eEJPp.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const clampValue = (newValue)=>Math.max(minViewValue, Math.min(maxViewValue, newValue));
    const circleValue = (newValue)=>(newValue + (maxViewValue + 1)) % (maxViewValue + 1);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // reset both hours and minutes
                handleValueChange(minViewValue, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(maxViewValue, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(circleValue(viewValue + keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(circleValue(viewValue - keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'PageUp':
                handleValueChange(clampValue(viewValue + 5), 'partial');
                event.preventDefault();
                break;
            case 'PageDown':
                handleValueChange(clampValue(viewValue - 5), 'partial');
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleValueChange(viewValue, 'finish');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4a42c559a8325457$var$ClockRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)($4a42c559a8325457$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: ownerState,
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f95698f6901368ba$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                isBetweenTwoClockValues: isPointerBetweenTwoClockValues
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value == null ? null : adapter.format(value, ampm ? 'fullTime12h' : 'fullTime24h')),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'am'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'pm'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($4a42c559a8325457$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("acw62");


parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");


var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $2bccf54016094d29$export$527226d166658911(slot) {
    return (0, $4Cod0.default)('MuiClockNumber', slot);
}
const $2bccf54016094d29$export$c8efb3a779c9844a = (0, $beCSm.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);




var $ayMG0 = parcelRequire("ayMG0");
const $60afa1510443ece3$var$_excluded = [
    "className",
    "classes",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $60afa1510443ece3$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root',
            ownerState.isClockNumberSelected && 'selected',
            ownerState.isClockNumberDisabled && 'disabled'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $2bccf54016094d29$export$527226d166658911), classes);
};
const $60afa1510443ece3$var$ClockNumberRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $2bccf54016094d29$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $2bccf54016094d29$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        height: (0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d),
        width: (0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d),
        position: 'absolute',
        left: `calc((100% - ${0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $2bccf54016094d29$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $2bccf54016094d29$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    isClockNumberInInnerRing: true
                },
                style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
function $60afa1510443ece3$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, classes: classesProp, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $60afa1510443ece3$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isClockNumberInInnerRing: inner,
        isClockNumberSelected: selected,
        isClockNumberDisabled: disabled
    });
    const classes = $60afa1510443ece3$var$useUtilityClasses(classesProp, ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6) - (0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($60afa1510443ece3$var$ClockNumberRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $9QePP.default)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $f4bb1bb3f1c23d05$export$8c8ec20d3854d7e6) - (0, $f4bb1bb3f1c23d05$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $ayMG0 = parcelRequire("ayMG0");
const $e83cedf906b74711$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, adapter: adapter })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = adapter.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $60afa1510443ece3$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $e83cedf906b74711$export$2c440057d7a731e4 = ({ adapter: adapter, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = adapter.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $60afa1510443ece3$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};





var $acw62 = parcelRequire("acw62");



const $fb3dc2f3afc3b6a4$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, adapter: adapter, props: props, timezone: timezone })=>{
    const referenceDate = $acw62.useMemo(()=>(0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $b8d019f986eaf72a$export$1118e4272ea1e258)(adapter, timezone, 'date')
        }), // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    [
        referenceDateProp,
        timezone
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $42464cec97ce20f2$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "timezone"
];
const $42464cec97ce20f2$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $c25eda3950c42327$export$148b188041a720e4), classes);
};
const $42464cec97ce20f2$var$TimeClockRoot = (0, $1Ikg4.default)((0, $88548032dcbf72cd$export$512b066b8abdfde4), {
    name: 'MuiTimeClock',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const $42464cec97ce20f2$var$TimeClockArrowSwitcher = (0, $1Ikg4.default)((0, $e6440e639c149fbf$export$597b7cbdb7b2a24c), {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher'
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $42464cec97ce20f2$var$TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
const $42464cec97ce20f2$export$7e96244e18c4be57 = /*#__PURE__*/ $acw62.forwardRef(function TimeClock(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $42464cec97ce20f2$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $42464cec97ce20f2$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $fb3dc2f3afc3b6a4$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const selectedId = (0, $auC0X.default)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $8992dd6789b4ad9e$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $acw62.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $d83ac1c1cf9e346e$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const viewProps = $acw62.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $d83ac1c1cf9e346e$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    const viewValue = adapter.getHours(valueOrReferenceDate);
                    let viewRange;
                    if (ampm) {
                        if (viewValue > 12) viewRange = [
                            12,
                            23
                        ];
                        else viewRange = [
                            0,
                            11
                        ];
                    } else viewRange = [
                        0,
                        23
                    ];
                    return {
                        onChange: handleHoursChange,
                        viewValue: viewValue,
                        children: (0, $e83cedf906b74711$export$10850582eda9a8c7)({
                            value: value,
                            adapter: adapter,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId: selectedId
                        }),
                        viewRange: viewRange
                    };
                }
            case 'minutes':
                {
                    const minutesValue = adapter.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $e83cedf906b74711$export$2c440057d7a731e4)({
                            adapter: adapter,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            case 'seconds':
                {
                    const secondsValue = adapter.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $e83cedf906b74711$export$2c440057d7a731e4)({
                            adapter: adapter,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId: selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        adapter,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const classes = $42464cec97ce20f2$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($42464cec97ce20f2$var$TimeClockRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4a42c559a8325457$export$9735c82c4bae3302), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $ayMG0.jsx)($42464cec97ce20f2$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $eD6Co = parcelRequire("eD6Co");

var $aSEG4 = parcelRequire("aSEG4");
var $1Ikg4 = parcelRequire("1Ikg4");

var $13KXh = parcelRequire("13KXh");

var $8Indx = parcelRequire("8Indx");

var $5WsCn = parcelRequire("5WsCn");

var $aGlmr = parcelRequire("aGlmr");

var $3qSdM = parcelRequire("3qSdM");

var $eEJPp = parcelRequire("eEJPp");





var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $74db108bb3744f9b$export$aeb645018b209578(slot) {
    return (0, $4Cod0.default)('MuiDigitalClock', slot);
}
const $74db108bb3744f9b$export$baf91642e79c8163 = (0, $beCSm.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);










var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $946a32d0e64bbb48$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $946a32d0e64bbb48$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $74db108bb3744f9b$export$aeb645018b209578), classes);
};
const $946a32d0e64bbb48$var$DigitalClockRoot = (0, $1Ikg4.default)((0, $88548032dcbf72cd$export$512b066b8abdfde4), {
    name: 'MuiDigitalClock',
    slot: 'Root'
})({
    overflowY: 'auto',
    width: '100%',
    scrollbarWidth: 'thin',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: (0, $e7cd373dd46c88ee$export$1c2eabda4acea0e4),
    variants: [
        {
            props: {
                hasDigitalClockAlreadyBeenRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const $946a32d0e64bbb48$var$DigitalClockList = (0, $1Ikg4.default)((0, $aGlmr.default), {
    name: 'MuiDigitalClock',
    slot: 'List'
})({
    padding: 0
});
const $946a32d0e64bbb48$export$d6868ddf09ba26ea = (0, $1Ikg4.default)((0, $5WsCn.default), {
    name: 'MuiDigitalClock',
    slot: 'Item',
    shouldForwardProp: (prop)=>prop !== 'itemValue' && prop !== 'formattedValue'
})(({ theme: theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $946a32d0e64bbb48$export$9a2b219a5b06deb7 = /*#__PURE__*/ $acw62.forwardRef(function DigitalClock(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const containerRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, containerRef);
    const listRef = $acw62.useRef(null);
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, views: views = [
        'hours'
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $946a32d0e64bbb48$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $946a32d0e64bbb48$var$useUtilityClasses(classesProp);
    const ClockItem = slots?.digitalClockItem ?? $946a32d0e64bbb48$export$d6868ddf09ba26ea;
    const clockItemProps = (0, $eD6Co.default)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState: ownerState,
        className: classes.item
    });
    const valueOrReferenceDate = (0, $fb3dc2f3afc3b6a4$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $13KXh.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $13KXh.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    (0, $eEJPp.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $acw62.useCallback((valueToCheck)=>{
        const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (adapter.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        adapter,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = $acw62.useMemo(()=>{
        const result = [];
        const startOfDay = adapter.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(adapter.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = adapter.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        adapter
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>adapter.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $7c44784990d74e44$export$4165ccf43f4d7767)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $7c44784990d74e44$export$4165ccf43f4d7767)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($946a32d0e64bbb48$var$DigitalClockRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($946a32d0e64bbb48$var$DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                const optionDisabled = isTimeDisabled(option);
                if (skipDisabled && optionDisabled) return null;
                const isSelected = adapter.isEqual(option, value);
                const formattedValue = adapter.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const isFocused = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0;
                const tabIndex = isFocused ? 0 : -1;
                return /*#__PURE__*/ (0, $ayMG0.jsx)(ClockItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || optionDisabled,
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex,
                    itemValue: option,
                    formattedValue: formattedValue
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $58lXc = parcelRequire("58lXc");

var $1Ikg4 = parcelRequire("1Ikg4");

var $13KXh = parcelRequire("13KXh");

var $8Indx = parcelRequire("8Indx");







var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $1f57d5fc01b33335$export$b828b7724b7b2890(slot) {
    return (0, $4Cod0.default)('MuiMultiSectionDigitalClock', slot);
}
const $1f57d5fc01b33335$export$f2277d947b8f7a8a = (0, $beCSm.default)('MuiMultiSectionDigitalClock', [
    'root'
]);





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");

var $aSEG4 = parcelRequire("aSEG4");
var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");

var $aGlmr = parcelRequire("aGlmr");

var $5WsCn = parcelRequire("5WsCn");

var $3qSdM = parcelRequire("3qSdM");

var $eEJPp = parcelRequire("eEJPp");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $3343ba577b7b0d6e$export$ab23463cad6963ff(slot) {
    return (0, $4Cod0.default)('MuiMultiSectionDigitalClockSection', slot);
}
const $3343ba577b7b0d6e$export$eaf2b63fa45eff23 = (0, $beCSm.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $876f7aee3745423a$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $876f7aee3745423a$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $3343ba577b7b0d6e$export$ab23463cad6963ff), classes);
};
const $876f7aee3745423a$var$MultiSectionDigitalClockSectionRoot = (0, $1Ikg4.default)((0, $aGlmr.default), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root'
})(({ theme: theme })=>({
        maxHeight: (0, $e7cd373dd46c88ee$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        variants: [
            {
                props: {
                    hasDigitalClockAlreadyBeenRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const $876f7aee3745423a$var$MultiSectionDigitalClockSectionItem = (0, $1Ikg4.default)((0, $5WsCn.default), {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item'
})(({ theme: theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: (0, $e7cd373dd46c88ee$export$a462ceb9cfdb5d71),
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aSEG4.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $876f7aee3745423a$export$f971f93dc8464c = /*#__PURE__*/ $acw62.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = $acw62.useRef(null);
    const handleRef = (0, $3qSdM.default)(ref, containerRef);
    const previousActive = $acw62.useRef(null);
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $876f7aee3745423a$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = $876f7aee3745423a$var$useUtilityClasses(classesProp);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? $876f7aee3745423a$var$MultiSectionDigitalClockSectionItem;
    (0, $eEJPp.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        const itemHeight = activeItem.offsetHeight;
        const containerHeight = containerRef.current.clientHeight;
        const scrollableHeight = containerRef.current.scrollHeight;
        // Calculate the ideal centered position
        const centeredPosition = offsetTop - containerHeight / 2 + itemHeight / 2;
        // Calculate the maximum scroll position that would show content at the bottom
        const maxScrollTop = scrollableHeight - containerHeight;
        // If centering would create empty space at the bottom, align the last items to the bottom instead
        const scrollPosition = Math.min(centeredPosition, maxScrollTop);
        // Ensure we don't scroll past the top
        containerRef.current.scrollTop = Math.max(0, scrollPosition);
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, $7c44784990d74e44$export$4165ccf43f4d7767)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, $7c44784990d74e44$export$4165ccf43f4d7767)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($876f7aee3745423a$var$MultiSectionDigitalClockSectionRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(DigitalClockSectionItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $bb114f9e78d272db$export$9101aa7ba362bb4e = ({ now: now, value: value, adapter: adapter, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep, valueOrReferenceDate: valueOrReferenceDate })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, adapter.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = adapter.format(adapter.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = adapter.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            isFocused: isFocused,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $bb114f9e78d272db$export$e7b56db95f8a7b9c = ({ value: value, adapter: adapter, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: adapter.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFocused: isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};








var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ac55733cf4a65981$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $ac55733cf4a65981$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $1f57d5fc01b33335$export$b828b7724b7b2890), classes);
};
const $ac55733cf4a65981$var$MultiSectionDigitalClockRoot = (0, $1Ikg4.default)((0, $88548032dcbf72cd$export$512b066b8abdfde4), {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root'
})(({ theme: theme })=>({
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $ac55733cf4a65981$export$c48dada788ff933b = /*#__PURE__*/ $acw62.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const isRtl = (0, $58lXc.useRtl)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm: ampm = adapter.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ac55733cf4a65981$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $fb3dc2f3afc3b6a4$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        adapter: adapter,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $13KXh.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $acw62.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $13KXh.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $8992dd6789b4ad9e$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = $acw62.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, $d83ac1c1cf9e346e$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $acw62.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $d83ac1c1cf9e346e$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, $bb114f9e78d272db$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        adapter: adapter,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate: valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, $bb114f9e78d272db$export$e7b56db95f8a7b9c)({
                        value: adapter.getMinutes(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>adapter.format(adapter.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, $bb114f9e78d272db$export$e7b56db95f8a7b9c)({
                        value: adapter.getSeconds(valueOrReferenceDate),
                        adapter: adapter,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>adapter.format(adapter.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'am');
                    const pmLabel = (0, $b8d019f986eaf72a$export$fae94c0a662107ef)(adapter, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        adapter,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = $acw62.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== 'meridiem');
        digitViews.reverse();
        if (views.includes('meridiem')) digitViews.push('meridiem');
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = $acw62.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const classes = $ac55733cf4a65981$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ac55733cf4a65981$var$MultiSectionDigitalClockRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $876f7aee3745423a$export$f971f93dc8464c), {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus || focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});




var $ayMG0 = parcelRequire("ayMG0");
const $fce3563426d1459d$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $42464cec97ce20f2$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $fce3563426d1459d$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $946a32d0e64bbb48$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $fce3563426d1459d$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, minutesStep: minutesStep, ampm: ampm, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac55733cf4a65981$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $d83ac1c1cf9e346e$export$a3328136ac50623d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });





var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $gJm6V = parcelRequire("gJm6V");



var $ayMG0 = parcelRequire("ayMG0");
/**
 * @ignore - internal component.
 */ const $2677faf45061babb$export$4066d2955a85e052 = /*#__PURE__*/ $acw62.forwardRef(function DesktopDateTimePickerLayout(props, ref) {
    const { toolbar: toolbar, tabs: tabs, content: content, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $93d540a51b4256a1$export$2e2bcd8739ae039)(props);
    const { orientation: orientation } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { sx: sx, className: className, classes: classes } = props;
    const isActionBarVisible = actionBar && (actionBar.props.actions?.length ?? 0) > 0;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c6a4a7c871810436$export$9a9363506c13836), {
        ref: ref,
        className: (0, $9QePP.default)((0, $155427cbf9212b77$export$7a6dac186703fe4c).root, classes?.root, className),
        sx: [
            {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).tabs}`]: {
                    gridRow: 4,
                    gridColumn: '1 / 4'
                },
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).actionBar}`]: {
                    gridRow: 5
                }
            },
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c6a4a7c871810436$export$bc1494d918129235), {
                className: (0, $9QePP.default)((0, $155427cbf9212b77$export$7a6dac186703fe4c).contentWrapper, classes?.contentWrapper),
                ownerState: ownerState,
                sx: {
                    display: 'grid'
                },
                children: [
                    content,
                    tabs,
                    isActionBarVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                        sx: {
                            gridRow: 3,
                            gridColumn: '1 / 4'
                        }
                    })
                ]
            }),
            actionBar
        ]
    });
});






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8789099066d2080f$var$_excluded = [
    "openTo",
    "focusedView",
    "timeViewsCount"
];
const $8789099066d2080f$var$rendererInterceptor = function RendererInterceptor(props) {
    const { viewRenderers: viewRenderers, popperView: popperView, rendererProps: rendererProps } = props;
    const { openTo: openTo, focusedView: focusedView, timeViewsCount: timeViewsCount } = rendererProps, otherProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(rendererProps, $8789099066d2080f$var$_excluded);
    const finalProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, otherProps, {
        // we control the focused view manually
        autoFocus: false,
        focusedView: null,
        sx: [
            {
                [`&.${(0, $1f57d5fc01b33335$export$f2277d947b8f7a8a).root}`]: {
                    borderBottom: 0
                },
                [`&.${(0, $1f57d5fc01b33335$export$f2277d947b8f7a8a).root}, .${(0, $3343ba577b7b0d6e$export$eaf2b63fa45eff23).root}, &.${(0, $74db108bb3744f9b$export$baf91642e79c8163).root}`]: {
                    maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7)
                }
            }
        ]
    });
    const isTimeViewActive = (0, $d83ac1c1cf9e346e$export$a3328136ac50623d)(popperView);
    const dateView = isTimeViewActive ? 'day' : popperView;
    const timeView = isTimeViewActive ? popperView : 'hours';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            viewRenderers[dateView]?.((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rendererProps, {
                view: !isTimeViewActive ? popperView : 'day',
                focusedView: focusedView && (0, $b8d019f986eaf72a$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
                views: rendererProps.views.filter((0, $b8d019f986eaf72a$export$b32dfef9f07dea64)),
                sx: [
                    {
                        gridColumn: 1
                    },
                    ...finalProps.sx
                ]
            })),
            timeViewsCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {
                        orientation: "vertical",
                        sx: {
                            gridColumn: 2
                        }
                    }),
                    viewRenderers[timeView]?.((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, finalProps, {
                        view: isTimeViewActive ? popperView : 'hours',
                        focusedView: focusedView && (0, $d83ac1c1cf9e346e$export$a3328136ac50623d)(focusedView) ? focusedView : null,
                        openTo: (0, $d83ac1c1cf9e346e$export$a3328136ac50623d)(openTo) ? openTo : 'hours',
                        views: rendererProps.views.filter((0, $d83ac1c1cf9e346e$export$a3328136ac50623d)),
                        sx: [
                            {
                                gridColumn: 3
                            },
                            ...finalProps.sx
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDateTimePicker API](https://mui.com/x/api/date-pickers/desktop-date-time-picker/)
 */ const $8789099066d2080f$export$74e5e82f1557571f = /*#__PURE__*/ $acw62.forwardRef(function DesktopDateTimePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $7376453e1bd5a1ce$export$6e4d96e87e6dc2d3)(inProps, 'MuiDesktopDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? (0, $fce3563426d1459d$export$a2917c76dc0aa7e) : (0, $fce3563426d1459d$export$48a290886291c531);
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? true;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $fce3563426d1459d$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the desktop variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $f933d5f81686c4e5$export$ebf7b30b32db6f57)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
            views: defaultizedProps.viewsForFormatting
        })),
        views: views,
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        ampmInClock: ampmInClock,
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $f1f52b9c47331d57$export$ae1ced156568f0b0),
            layout: (0, $2677faf45061babb$export$4066d2955a85e052)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: true,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.tabs)
        })
    });
    const { renderPicker: renderPicker } = (0, $921f50d8d6fdef68$export$b1b70bc56ac5be0e)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date-time',
        validator: (0, $f8388c87d25dd2f9$export$ed94a8ff1f54c4f),
        rendererInterceptor: $8789099066d2080f$var$rendererInterceptor,
        steps: null
    });
    return renderPicker();
});
$8789099066d2080f$export$74e5e82f1557571f.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeSteps.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeSteps.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};




var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8bslU = parcelRequire("8bslU");








parcelRequire("acw62");

var $eD6Co = parcelRequire("eD6Co");

parcelRequire("acw62");

var $23H42 = parcelRequire("23H42");

var $fanil = parcelRequire("fanil");

var $4LdGL = parcelRequire("4LdGL");
var $bnRzB = parcelRequire("bnRzB");

var $1Ikg4 = parcelRequire("1Ikg4");




var $ayMG0 = parcelRequire("ayMG0");
const $5205dd229acf7a16$var$PickersModalDialogRoot = (0, $1Ikg4.default)((0, $4LdGL.default))({
    [`& .${(0, $bnRzB.default).container}`]: {
        outline: 0
    },
    [`& .${(0, $bnRzB.default).paper}`]: {
        outline: 0,
        minWidth: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3)
    }
});
const $5205dd229acf7a16$var$PickersModalDialogContent = (0, $1Ikg4.default)((0, $23H42.default))({
    '&:first-of-type': {
        padding: 0
    }
});
function $5205dd229acf7a16$export$99f83c99e1491f77(props) {
    const { children: children, slots: slots, slotProps: slotProps } = props;
    const { open: open } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { dismissViews: dismissViews, onPopperExited: onPopperExited } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const Dialog = slots?.dialog ?? $5205dd229acf7a16$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $fanil.default);
    return /*#__PURE__*/ (0, $ayMG0.jsx)(Dialog, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($5205dd229acf7a16$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







var $ayMG0 = parcelRequire("ayMG0");
const $9c54f8e6b9d53c05$var$_excluded = [
    "props",
    "steps"
], $9c54f8e6b9d53c05$var$_excluded2 = [
    "ownerState"
];
const $9c54f8e6b9d53c05$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $9c54f8e6b9d53c05$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $f154a91c12ef630c$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb07fb7878304460$export$fc3313977ac596c4)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $eD6Co.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $9c54f8e6b9d53c05$var$_excluded2);
    const Layout = slots.layout ?? (0, $c6a4a7c871810436$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $c33c428cfda4b7d5$export$aae9fbe9dd4050fa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)(Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5205dd229acf7a16$export$99f83c99e1491f77), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(Layout, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};











'use client';
const $3418a62eacb851a4$var$STEPS = [
    {
        views: (0, $b8d019f986eaf72a$export$76f4ff1fc64d3035)
    },
    {
        views: (0, $d83ac1c1cf9e346e$export$cf292de8b6883a7f)
    }
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDateTimePicker API](https://mui.com/x/api/date-pickers/mobile-date-time-picker/)
 */ const $3418a62eacb851a4$export$5b4e219fe76d27da = /*#__PURE__*/ $acw62.forwardRef(function MobileDateTimePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date time pickers
    const defaultizedProps = (0, $7376453e1bd5a1ce$export$6e4d96e87e6dc2d3)(inProps, 'MuiMobileDateTimePicker');
    const renderTimeView = defaultizedProps.shouldRenderTimeInASingleColumn ? (0, $fce3563426d1459d$export$a2917c76dc0aa7e) : (0, $fce3563426d1459d$export$48a290886291c531);
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = viewRenderers.hours?.name === (0, $fce3563426d1459d$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? defaultizedProps.views.filter((view)=>view !== 'meridiem') : defaultizedProps.views;
    // Props with the default values specific to the mobile variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $f933d5f81686c4e5$export$ebf7b30b32db6f57)(adapter, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
            views: defaultizedProps.viewsForFormatting
        })),
        views: views,
        ampmInClock: ampmInClock,
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $f1f52b9c47331d57$export$ae1ced156568f0b0)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: false,
                ampmInClock: ampmInClock
            }, defaultizedProps.slotProps?.toolbar),
            tabs: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.tabs),
            layout: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps?.layout, {
                sx: (0, $7c44784990d74e44$export$3da104473fe9d2e8)([
                    {
                        [`& .${(0, $1f57d5fc01b33335$export$f2277d947b8f7a8a).root}`]: {
                            width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3)
                        },
                        [`& .${(0, $3343ba577b7b0d6e$export$eaf2b63fa45eff23).root}`]: {
                            flex: 1,
                            // account for the border on `MultiSectionDigitalClock`
                            maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7) - 1,
                            [`.${(0, $3343ba577b7b0d6e$export$eaf2b63fa45eff23).item}`]: {
                                width: 'auto'
                            }
                        },
                        [`& .${(0, $74db108bb3744f9b$export$baf91642e79c8163).root}`]: {
                            width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
                            maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7),
                            flex: 1,
                            [`.${(0, $74db108bb3744f9b$export$baf91642e79c8163).item}`]: {
                                justifyContent: 'center'
                            }
                        }
                    }
                ], defaultizedProps.slotProps?.layout?.sx)
            })
        })
    });
    const { renderPicker: renderPicker } = (0, $9c54f8e6b9d53c05$export$5ca0153a626a7dd7)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date-time',
        validator: (0, $f8388c87d25dd2f9$export$ed94a8ff1f54c4f),
        steps: $3418a62eacb851a4$var$STEPS
    });
    return renderPicker();
});
$3418a62eacb851a4$export$5b4e219fe76d27da.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */ maxDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */ minDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeSteps.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeSteps.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'meridiem',
        'minutes',
        'month',
        'seconds',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'hours',
        'minutes',
        'month',
        'seconds',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $de1ddfe5eee534cd$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DateTimePicker](https://mui.com/x/react-date-pickers/date-time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateTimePicker API](https://mui.com/x/api/date-pickers/date-time-picker/)
 */ const $de1ddfe5eee534cd$export$ccdfd7928785632e = /*#__PURE__*/ $acw62.forwardRef(function DateTimePicker(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateTimePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $7c44784990d74e44$export$9ae5b19305db48ce) } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $de1ddfe5eee534cd$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8789099066d2080f$export$74e5e82f1557571f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3418a62eacb851a4$export$5b4e219fe76d27da), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});


const $c48b1d46ae12e970$export$8f1389089219b7ae = ({ name: name, label: label, emptyValue: emptyValue, allowEmptyValue: allowEmptyValue, size: size })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
        name: name,
        render: ({ field: field, fieldState: fieldState })=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de1ddfe5eee534cd$export$ccdfd7928785632e), {
                openTo: "day",
                label: label,
                // eslint-disable-next-line
                // @ts-ignore
                minDateTime: (0, $3652e7106c1f3d0e$export$2287e3d29250119e)(new Date(), -6),
                slotProps: {
                    textField: {
                        fullWidth: true,
                        helperText: fieldState.error?.message,
                        error: Boolean(fieldState.error?.message),
                        size: size
                    },
                    field: {
                        clearable: false
                    }
                },
                value: field.value ? field.value : null,
                onChange: (value)=>{
                    if (!(0, $ae5dedc3e6bc7894$export$1ea939691cdc45b8)(value) && !allowEmptyValue) return;
                    field.onChange(value ? value : emptyValue);
                }
            });
        }
    });
};



var $iH29s = parcelRequire("iH29s");


var $9iE6L = parcelRequire("9iE6L");


/** Mirrors `core/src/modules/schedules/schedules.types.ts`. */ const $1e5a62547c9ca153$export$11d571b5a0339371 = [
    'battery-charge',
    'battery-discharge',
    'ev-charging'
];
const $1e5a62547c9ca153$export$95c8a2a9568804b4 = [
    'battery-charge',
    'battery-discharge'
];
const $1e5a62547c9ca153$export$bb0c8ebce24804d6 = [
    'ev-charging'
];
const $1e5a62547c9ca153$export$f4bdda00622a611b = 6;
const $1e5a62547c9ca153$export$67a6c18fcd0929ad = 32;


/** Formats a duration in minutes as "HH:mm". */ const $30a326a7235c8414$var$formatDuration = (minutes)=>(0, $4d82c4193dc87874$export$2e2bcd8739ae039)((0, $f4Eh3.add)((0, $g04kv.startOfDay)(new Date()), {
        minutes: minutes
    }), 'HH:mm');
const $30a326a7235c8414$export$7e12e67730c75a3d = (schema)=>(0, $2zDt6.z).preprocess((val)=>val ? parseFloat(String(val).replace(',', '')) : null, schema);
const $30a326a7235c8414$var$payload = (0, $2zDt6.z).discriminatedUnion('type', [
    (0, $2zDt6.z).object({
        type: (0, $2zDt6.z).literal('battery-charge'),
        targetSoc: $30a326a7235c8414$export$7e12e67730c75a3d((0, $2zDt6.z).number({
            invalid_type_error: "Mus\xed b\xfdt \u010D\xedslo",
            required_error: "Povinn\xe9 pole"
        }).min(10, {
            message: "Minim\xe1ln\xed hodnota je 10%"
        }).max(100, {
            message: "Maxim\xe1ln\xed hodnota je 100%"
        }).nullable())
    }),
    (0, $2zDt6.z).object({
        type: (0, $2zDt6.z).literal('battery-discharge'),
        targetSoc: $30a326a7235c8414$export$7e12e67730c75a3d((0, $2zDt6.z).number({
            invalid_type_error: "Mus\xed b\xfdt \u010D\xedslo",
            required_error: "Povinn\xe9 pole"
        }).min(10, {
            message: "Minim\xe1ln\xed hodnota je 10%"
        }).max(100, {
            message: "Maxim\xe1ln\xed hodnota je 100%"
        }).nullable())
    }),
    (0, $2zDt6.z).object({
        type: (0, $2zDt6.z).literal('ev-charging'),
        chargingCurrent: $30a326a7235c8414$export$7e12e67730c75a3d((0, $2zDt6.z).number({
            invalid_type_error: "Mus\xed b\xfdt \u010D\xedslo",
            required_error: "Povinn\xe9 pole"
        }).min((0, $1e5a62547c9ca153$export$f4bdda00622a611b), {
            message: `Minim\xe1ln\xed hodnota je ${(0, $1e5a62547c9ca153$export$f4bdda00622a611b)} A`
        }).max((0, $1e5a62547c9ca153$export$67a6c18fcd0929ad), {
            message: `Maxim\xe1ln\xed hodnota je ${(0, $1e5a62547c9ca153$export$67a6c18fcd0929ad)} A`
        }).nullable())
    })
]);
const $30a326a7235c8414$var$baseSchema = (0, $2zDt6.z).object({
    startAt: (0, $2zDt6.z).date({
        invalid_type_error: "Neplatn\xe9 datum"
    }),
    duration: (0, $2zDt6.z).number().min(1).optional(),
    recurring: (0, $2zDt6.z).object({
        frequency: (0, $2zDt6.z).number().min(0).max(3),
        interval: (0, $2zDt6.z).number().min(1).max(2).optional(),
        until: (0, $2zDt6.z).date().optional().nullable()
    }).or((0, $2zDt6.z).literal(false)),
    rruleString: (0, $2zDt6.z).string().optional()
});
const $30a326a7235c8414$var$schema = $30a326a7235c8414$var$baseSchema.and($30a326a7235c8414$var$payload);
const $30a326a7235c8414$var$defaultRecurring = {
    frequency: (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY,
    interval: 1,
    until: null
};
/** Pre-filled when the user opts into a current; same default as the wallbox. */ const $30a326a7235c8414$var$defaultChargingCurrent = 16;
const $30a326a7235c8414$var$getDefaultValues = (types)=>({
        type: types[0],
        targetSoc: null,
        startAt: (0, $8cb46f6104f2827d$export$24f91f68e7c9d9d5)((0, $ad7d7a6c940573d9$export$4a4306ad4fa0e5e6)(new Date(), 1)),
        duration: 180,
        recurring: false
    });
const $30a326a7235c8414$var$typeLabels = {
    'battery-charge': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "schedules.form.battery_charge",
        defaultMessage: "Nab\xedt\xed baterie"
    }),
    'battery-discharge': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "schedules.form.battery_discharge",
        defaultMessage: "Vybit\xed baterie"
    }),
    'ev-charging': /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "schedules.form.ev_charging",
        defaultMessage: "Nab\xedjen\xed elektromobilu"
    })
};
const $30a326a7235c8414$export$2f1773086cd9dcc2 = ({ open: open, onClose: onClose, types: types = (0, $1e5a62547c9ca153$export$11d571b5a0339371) })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const utils = (0, $iH29s.trpc).useContext();
    const { mutate: mutate, isLoading: isLoading } = (0, $iH29s.trpc).schedules.create.useMutation({
        onSuccess () {
            onClose();
            utils.schedules.list.invalidate();
        },
        onError () {
            alert('Chyba');
        }
    });
    const form = (0, $22i8b.useForm)({
        resolver: (0, $3s7Tn.zodResolver)($30a326a7235c8414$var$schema),
        defaultValues: $30a326a7235c8414$var$getDefaultValues(types)
    });
    (0, $acw62.useEffect)(()=>{
        form.reset($30a326a7235c8414$var$getDefaultValues(types));
    }, [
        open
    ]);
    const type = form.watch('type');
    const recurring = form.watch('recurring');
    // The photovoltaics page reuses this dialog for battery plans, so the
    // charging wording only applies when EV charging is the only action.
    const evOnly = types.length === 1 && types[0] === 'ev-charging';
    const onSubmit = (data)=>{
        mutate(data);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
            open: open,
            onClose: onClose,
            fullWidth: true,
            maxWidth: "sm",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                    variant: "h2",
                    children: evOnly ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.dialog.title.ev",
                        defaultMessage: "Vytvo\u0159it pl\xe1n nab\xedjen\xed"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.dialog.title",
                        defaultMessage: "Vytvo\u0159it pl\xe1n"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.FormProvider), {
                    ...form,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: form.handleSubmit(onSubmit),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                                    gap: 2,
                                    children: [
                                        types.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b2c8225b340b40e$export$ef9b1a59e592288f), {
                                            name: "type",
                                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "schedules.form.action",
                                                defaultMessage: "Akce"
                                            }),
                                            children: types.map((value)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                    value: value,
                                                    children: $30a326a7235c8414$var$typeLabels[value]
                                                }, value))
                                        }),
                                        [
                                            'battery-charge',
                                            'battery-discharge'
                                        ].includes(type) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3HVo.FormTextField), {
                                            name: "targetSoc",
                                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "schedules.form.target-soc",
                                                defaultMessage: "Cilov\xe9 SOC (voliteln\xe9)"
                                            }),
                                            size: "small"
                                        }),
                                        type === 'ev-charging' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
                                            name: "chargingCurrent",
                                            render: ({ field: field })=>{
                                                // Null means "leave the current to the active wallbox
                                                // mode"; the slider only appears once opted in.
                                                const enabled = field.value !== null && field.value !== undefined;
                                                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            sx: {
                                                                mb: enabled ? 1 : 0
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                                                                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                                                                        checked: enabled,
                                                                        onChange: (e)=>field.onChange(e.target.checked ? $30a326a7235c8414$var$defaultChargingCurrent : null)
                                                                    }),
                                                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                                        variant: "h3",
                                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                                            id: "schedules.form.charging-current",
                                                                            defaultMessage: "Nastavit nab\xedjec\xed proud"
                                                                        })
                                                                    }),
                                                                    sx: {
                                                                        ml: -1.25,
                                                                        mr: 0
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                                    variant: "h3",
                                                                    children: enabled ? formatNumber(Number(field.value), {
                                                                        style: 'unit',
                                                                        unit: 'ampere',
                                                                        maximumFractionDigits: 0
                                                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                                        id: "schedules.form.charging-current.auto",
                                                                        defaultMessage: "V\xfdchoz\xed"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        enabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                                            sx: {
                                                                px: 1
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1a1ed73f43ec083$export$2e2bcd8739ae039), {
                                                                value: Number(field.value),
                                                                onChange: (_, value)=>field.onChange(value),
                                                                min: (0, $1e5a62547c9ca153$export$f4bdda00622a611b),
                                                                max: (0, $1e5a62547c9ca153$export$67a6c18fcd0929ad),
                                                                step: 1,
                                                                sx: (0, $ea1a6557faa30a5b$export$173ad7a557842909)
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48b1d46ae12e970$export$8f1389089219b7ae), {
                                            name: "startAt",
                                            size: "small",
                                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "schedules.form.when",
                                                defaultMessage: "Kdy"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
                                            name: "duration",
                                            render: ({ field: field })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            sx: {
                                                                mb: 1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                                    variant: "h3",
                                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                                        id: "schedules.form.duration",
                                                                        defaultMessage: "D\xe9lka"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                                                    variant: "h3",
                                                                    children: $30a326a7235c8414$var$formatDuration(field.value ?? 0)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                                            sx: {
                                                                px: 1
                                                            },
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c1a1ed73f43ec083$export$2e2bcd8739ae039), {
                                                                value: field.value ?? 15,
                                                                onChange: (_, value)=>field.onChange(value),
                                                                min: 15,
                                                                max: 360,
                                                                step: 15,
                                                                sx: (0, $ea1a6557faa30a5b$export$173ad7a557842909)
                                                            })
                                                        })
                                                    ]
                                                })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
                                                name: "recurring",
                                                render: ({ field: { value: value } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                                                        sx: {
                                                            ml: 0
                                                        },
                                                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jrrQL.default), {
                                                            checked: Boolean(value),
                                                            onChange: (e)=>{
                                                                form.setValue('recurring', e.target.checked ? $30a326a7235c8414$var$defaultRecurring : false);
                                                            },
                                                            sx: {
                                                                mr: 0.75
                                                            }
                                                        }),
                                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                            id: "schedules.form.recurring",
                                                            defaultMessage: "Opakuj\xedc\xed se"
                                                        })
                                                    })
                                            })
                                        }),
                                        recurring && /*#__PURE__*/ (0, $ayMG0.jsx)($30a326a7235c8414$var$Recurring, {})
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hHAIz.default), {
                                sx: {
                                    px: 3,
                                    pb: 3
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    type: "submit",
                                    variant: "contained",
                                    fullWidth: true,
                                    disabled: isLoading,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "schedules.form.create",
                                        defaultMessage: "Vytvo\u0159it"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $30a326a7235c8414$var$PREVIEW_COUNT = 10;
/**
 * The server expands recurring rules on the wall clock, not on UTC, so that a
 * 10:00 series stays at 10:00 across a DST change. The preview has to use the
 * same two frames or it would advertise times the device will not run - see the
 * time-frame note in `schedules.repository.ts`.
 */ const $30a326a7235c8414$var$toFloating = (date)=>new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()));
const $30a326a7235c8414$var$fromFloating = (date)=>new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes());
const $30a326a7235c8414$var$Recurring = ()=>{
    const { watch: watch } = (0, $22i8b.useFormContext)();
    const [showPreview, setShowPreview] = (0, $acw62.useState)(false);
    const startAt = watch('startAt');
    const recurring = watch('recurring');
    const getOccurrences = ()=>{
        if (!recurring || recurring === false) return [];
        try {
            const rule = new (0, $e1d5d95ac5f1af89$export$4e942d157960251)({
                freq: recurring.frequency,
                dtstart: $30a326a7235c8414$var$toFloating(startAt),
                interval: recurring.interval || 1,
                until: recurring.until ? $30a326a7235c8414$var$toFloating(recurring.until) : undefined,
                count: recurring.until ? undefined : $30a326a7235c8414$var$PREVIEW_COUNT
            });
            return rule.all((_, i)=>i < $30a326a7235c8414$var$PREVIEW_COUNT).map($30a326a7235c8414$var$fromFloating);
        } catch (error) {
            console.error('Error generating occurrences:', error);
            return [];
        }
    };
    const occurrences = showPreview ? getOccurrences() : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9b2c8225b340b40e$export$ef9b1a59e592288f), {
                sx: {
                    mt: 1
                },
                name: "recurring.frequency",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "schedules.form.frequency",
                    defaultMessage: "Frekvence"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $243d5af73caebe4d$export$44c95d3770756ed2).DAILY,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.form.frequency.daily",
                            defaultMessage: "Denn\u011B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.form.frequency.weekly",
                            defaultMessage: "T\xfddn\u011B"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $243d5af73caebe4d$export$44c95d3770756ed2).MONTHLY,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.form.frequency.monthly",
                            defaultMessage: "M\u011Bs\xed\u010Dn\u011B"
                        })
                    })
                ]
            }),
            recurring.frequency === (0, $243d5af73caebe4d$export$44c95d3770756ed2).WEEKLY && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.Controller), {
                name: "recurring.interval",
                render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                        sx: {
                            ml: 0
                        },
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jrrQL.default), {
                            checked: value === 2,
                            onChange: (e)=>onChange(e.target.checked ? 2 : 1),
                            sx: {
                                mr: 0.75
                            }
                        }),
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.form.interval.biweekly",
                            defaultMessage: "Ka\u017Ed\xe9 2 t\xfddny"
                        })
                    })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c48b1d46ae12e970$export$8f1389089219b7ae), {
                name: "recurring.until",
                size: "small",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "schedules.form.until",
                    defaultMessage: "Opakovat do (voliteln\xe9)"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                in: showPreview,
                children: occurrences.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {},
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            color: "text.secondary",
                            sx: {
                                mb: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.form.preview.title",
                                defaultMessage: "Pl\xe1novan\xe1 spu\u0161t\u011Bn\xed ({count} n\xe1sleduj\xedc\xedch)",
                                values: {
                                    count: $30a326a7235c8414$var$PREVIEW_COUNT
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                            severity: "warning",
                            icon: false,
                            children: occurrences.map((date, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                                            value: date
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                    ]
                                }, index))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    mt: 0.25,
                    textAlign: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNkZ4.default), {
                    href: "#",
                    onClick: (e)=>{
                        e.preventDefault();
                        setShowPreview(!showPreview);
                    },
                    children: showPreview ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.form.preview.hide",
                        defaultMessage: "Skr\xfdt n\xe1hled"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "schedules.form.preview.show",
                        defaultMessage: "Zobrazit pl\xe1novan\xe9 v\xfdskyty"
                    })
                })
            })
        ]
    });
};



var $50BRD = parcelRequire("50BRD");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $0d4fbe4e47c14783$export$e1aef45b828286de = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 20 22",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
$0d4fbe4e47c14783$export$e1aef45b828286de.displayName = 'Calendar';



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $9b23a81019490641$export$8f9a3689a2631b79 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 20 22",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                clipPath: "url(#clip0_250_483)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M13 15C13 16.656 11.656 18 10 18C8.344 18 7.333 16.332 7.333 16.332M7.333 16.332H8.689M7.333 16.332V17.832M7 15C7 13.344 8.332 12 10 12C12.001 12 13 13.668 13 13.668M13 13.668V12.168M13 13.668H11.668",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_250_483",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "20",
                        height: "22",
                        fill: "white"
                    })
                })
            })
        ]
    }));
$9b23a81019490641$export$8f9a3689a2631b79.displayName = 'CalendarRecurring';




const $ddbf1ea2b354a30a$export$4d8c8cd2c300d546 = ({ types: types = (0, $1e5a62547c9ca153$export$11d571b5a0339371), title: title, description: description })=>{
    const [open, setOpen] = (0, $acw62.useState)(undefined);
    const [from, setFrom] = (0, $acw62.useState)((0, $e1db2803651e4352$export$a5a3b454ada2268e)(new Date()));
    const to = (0, $acw62.useMemo)(()=>(0, $32e1fec708db8003$export$a2258d9c4118825c)(from), [
        from
    ]);
    const [includeProcessed, setIncludeProcessed] = (0, $acw62.useState)(false);
    const onPrev = ()=>{
        setFrom((0, $e1db2803651e4352$export$a5a3b454ada2268e)((0, $5BFw5.addMonths)(from, -1)));
    };
    const onNext = ()=>{
        setFrom((0, $e1db2803651e4352$export$a5a3b454ada2268e)((0, $5BFw5.addMonths)(from, 1)));
    };
    const { data: schedules, isLoading: isLoading, isError: isError } = (0, $iH29s.trpc).schedules.list.useQuery({
        from: (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(from),
        to: (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(to),
        includeProcessed: includeProcessed,
        types: [
            ...types
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
        sx: {
            pt: 1,
            pb: 2
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                sx: {
                    mb: 0.5,
                    gap: 0.5
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                    variant: "h2",
                    children: [
                        title ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.title",
                            defaultMessage: "Pl\xe1nova\u010D"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50BRD.Plus), {
                            sx: {
                                ml: 1
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    mb: 1.25
                },
                children: description ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "schedules.description",
                    defaultMessage: "Napl\xe1nujte si vybit\xed nebo nabit\xed baterie podle pot\u0159eby."
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                        gap: 1,
                        sx: {
                            mb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                size: "small",
                                onClick: onPrev,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2PduQ.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                                    value: from,
                                    year: "numeric",
                                    month: "long"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                size: "small",
                                onClick: onNext,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDXfy.default), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: ()=>setOpen('new'),
                                variant: "outlined",
                                size: "small",
                                sx: {
                                    ml: 'auto'
                                },
                                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ko6Bk.default), {}),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.add",
                                    defaultMessage: "P\u0159idat pl\xe1n"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                        gap: 1,
                        sx: {
                            mb: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                flex: 1,
                                textAlign: 'right'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                                    checked: includeProcessed,
                                    onChange: (e)=>setIncludeProcessed(e.target.checked)
                                }),
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "schedules.show_processed",
                                    defaultMessage: "Zobrazit proveden\xe9"
                                }),
                                sx: {
                                    mr: 0,
                                    '& .MuiTypography-root': {
                                        fontSize: '0.7rem'
                                    }
                                }
                            })
                        })
                    }),
                    schedules && schedules.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ngrp2.default), {
                        sx: {
                            gap: 2
                        },
                        children: schedules.map((schedule)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)($ddbf1ea2b354a30a$var$ScheduleItem, {
                                schedule: schedule
                            }, schedule.id);
                        })
                    }) : !isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            p: 2,
                            textAlign: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.no_plans_found",
                            defaultMessage: "\u017D\xe1dn\xe9 pl\xe1ny nebyly nalezeny."
                        })
                    }) : null,
                    isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {})
                        ]
                    }),
                    isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                        severity: "error",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "schedules.loading.error",
                            defaultMessage: "Chyba p\u0159i na\u010D\xedt\xe1n\xed pl\xe1n\u016F"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30a326a7235c8414$export$2f1773086cd9dcc2), {
                open: Boolean(open),
                onClose: ()=>setOpen(undefined),
                types: types
            })
        ]
    });
};
const $ddbf1ea2b354a30a$var$ScheduleItem = ({ schedule: schedule })=>{
    const { id: id, active: active, processed: processed, missed: missed, parentId: parentId } = schedule;
    const status = missed ? 'missed' : processed ? 'processed' : active ? 'active' : 'scheduled';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
        sx: {
            alignItems: 'stretch',
            '&:not(:last-child)': {
                borderBottom: 'solid 1px #ECECEC',
                pb: 2
            }
        },
        gap: 1,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    mb: 'auto',
                    pr: {
                        xs: 1.25,
                        sm: 2.5
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f18835d59a9187d7$export$2e2bcd8739ae039), {
                    color: status === 'processed' ? undefined : status === 'missed' ? 'warning' : status === 'active' ? 'info' : 'primary',
                    variant: "dot",
                    children: parentId ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b23a81019490641$export$8f9a3689a2631b79), {
                        sx: {
                            fontSize: {
                                xs: '1.25rem',
                                sm: '1.5rem'
                            }
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d4fbe4e47c14783$export$e1aef45b828286de), {
                        sx: {
                            fontSize: {
                                xs: '1.25rem',
                                sm: '1.5rem'
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f9b96df6ca0fa51$export$1e9a830f8372be05), {
                    schedule: schedule
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                sx: {
                    textAlign: 'right'
                },
                children: [
                    status !== 'processed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae059e450a971e93$export$77f55fb30b17425a), {
                            schedule: schedule
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                        variant: "body1",
                        sx: {
                            mt: 'auto',
                            color: status === 'processed' ? undefined : status === 'missed' ? 'warning.main' : status === 'active' ? 'info.main' : 'primary.main'
                        },
                        children: [
                            status === 'processed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.processed",
                                defaultMessage: "Prob\u011Bhlo"
                            }),
                            status === 'missed' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.missed",
                                defaultMessage: "Neprob\u011Bhlo"
                            }),
                            status === 'active' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.running",
                                defaultMessage: "Prob\xedh\xe1"
                            }),
                            status === 'scheduled' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "schedules.scheduled",
                                defaultMessage: "Napl\xe1nov\xe1no"
                            })
                        ]
                    })
                ]
            })
        ]
    }, id);
};





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");
const $b74271eefec6f19e$export$cbbb458c2ee0aa50 = ()=>{
    const batteryStatus = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        const desBatteryContainerKey = Object.entries(variables.INVERTER_CONFIG ?? {}).find(([, config])=>config.type === (0, $8ni7a.Inverter).DesBatteryContainer)?.[0];
        if (!desBatteryContainerKey) return undefined;
        return (0, $f1q41.get)(variables, [
            'INVERTER_STATS',
            desBatteryContainerKey,
            'batteryStatus'
        ]);
    });
    const statusMapping = {
        [(0, $8ni7a.DesBatteryStatus).NONE]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "des_battery_container.status.none",
            defaultMessage: "Nezn\xe1m\xfd stav"
        }),
        [(0, $8ni7a.DesBatteryStatus).RUN]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "des_battery_container.status.run",
            defaultMessage: "B\u011B\u017En\xfd re\u017Eim"
        }),
        [(0, $8ni7a.DesBatteryStatus).OFF]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "des_battery_container.status.off",
            defaultMessage: "Vypnuto"
        }),
        [(0, $8ni7a.DesBatteryStatus).SLEEP]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "des_battery_container.status.sleep",
            defaultMessage: "Re\u017Eim sp\xe1nku"
        }),
        [(0, $8ni7a.DesBatteryStatus).ERROR]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "des_battery_container.status.error",
            defaultMessage: "Chyba"
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: statusMapping[batteryStatus ?? (0, $8ni7a.DesBatteryStatus).NONE]
    });
};


parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");
const $9a8a9338216d46d9$var$Photovoltaics = ()=>{
    const [premium, stringVisibility, string3, string4, string5, string6, wbBatteryModeActive] = (0, $2lSXC.useSelector)((s)=>[
            (0, $f1q41.get)(s.variables, 'PREMIUM'),
            (0, $f1q41.get)(s.variables, 'PV_ACTUAL_POWER_STRING_V'),
            (0, $f1q41.get)(s.variables, 'PV_STRING_NUMBER') > 2,
            (0, $f1q41.get)(s.variables, 'PV_STRING_NUMBER') > 3,
            (0, $f1q41.get)(s.variables, 'PV_STRING_NUMBER') > 4,
            (0, $f1q41.get)(s.variables, 'PV_STRING_NUMBER') > 5,
            Boolean((0, $f1q41.get)(s.variables, 'WB_MODE_PV') || (0, $f1q41.get)(s.variables, 'WB_MODE_PV_FAST'))
        ]);
    const emsInstall = (0, $c921d87731d038a0$export$87817269cf0fc0d8)();
    const desBatteryContainer = (0, $2lSXC.useSelector)(({ variables: variables })=>Object.values(variables.INVERTER_CONFIG ?? {}).some((config)=>config.type === (0, $8ni7a.Inverter).DesBatteryContainer));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.status",
                            defaultMessage: "Re\u017Eim FVE"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "photovoltaic"
                        }),
                        fullWidth: true
                    }),
                    desBatteryContainer && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.batteryStatus",
                            defaultMessage: "Stav BMS"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b74271eefec6f19e$export$cbbb458c2ee0aa50), {}),
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.statistics",
                    defaultMessage: "V\xfdkon elektr\xe1rny"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_POWER_GRAPH",
                    groupSubStatsByInverter: emsInstall
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.statisticsSoc",
                    defaultMessage: "\xdarove\u0148 nabit\xed baterie"
                }),
                visibility: {
                    variableId: 'PV_BATTERY'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_BATTERY_SOC_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.statistics.charge",
                    defaultMessage: "Nab\xedjen\xed baterie"
                }),
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'PREMIUM'
                    ]
                },
                plus: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_BATTERY_CHARGE_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.statistics.discharge",
                    defaultMessage: "Vyb\xedjen\xed baterie"
                }),
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'PREMIUM'
                    ]
                },
                plus: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_BATTERY_DISCHARGE_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.common.power",
                            defaultMessage: "Aktu\xe1ln\xed v\xfdkon"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_ACTUAL_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {}),
                        expanded: stringVisibility ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.string1",
                                    defaultMessage: "String 1:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "PV_ACTUAL_POWER_STRING[0]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.string2",
                                    defaultMessage: "String 2:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "PV_ACTUAL_POWER_STRING[1]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                string3 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "photovoltaics.common.string3",
                                            defaultMessage: "String 3:"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                            variableId: "PV_ACTUAL_POWER_STRING[2]",
                                            opts: {
                                                style: 'unit',
                                                unit: 'kilowatt',
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }
                                        })
                                    ]
                                }),
                                string4 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "photovoltaics.common.string4",
                                            defaultMessage: "String 4:"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                            variableId: "PV_ACTUAL_POWER_STRING[3]",
                                            opts: {
                                                style: 'unit',
                                                unit: 'kilowatt',
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }
                                        })
                                    ]
                                }),
                                string5 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "photovoltaics.common.string5",
                                            defaultMessage: "String 5:"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                            variableId: "PV_ACTUAL_POWER_STRING[4]",
                                            opts: {
                                                style: 'unit',
                                                unit: 'kilowatt',
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }
                                        })
                                    ]
                                }),
                                string6 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "photovoltaics.common.string6",
                                            defaultMessage: "String 6:"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                            variableId: "PV_ACTUAL_POWER_STRING[5]",
                                            opts: {
                                                style: 'unit',
                                                unit: 'kilowatt',
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }
                                        })
                                    ]
                                })
                            ]
                        }) : undefined
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.common.power_total",
                            defaultMessage: "Celkov\xe1 v\xfdroba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_ENERGY_PRODUCED_TOTAL",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed v\xfdroba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_PV_ENERGY_PRODUCED_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed v\xfdroba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_PV_ENERGY_PRODUCED_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.battery",
                    defaultMessage: "Baterie"
                }),
                visibility: {
                    variableId: 'PV_BATTERY'
                },
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery.battery_charged",
                            defaultMessage: "Nabit\xed baterie"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_ACTUAL_SOC",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                        visibility: {
                            variableId: 'PV_BATTERY'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery.battery_power",
                            defaultMessage: "V\xfdkon baterie"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_ACTUAL_POWER_BATTERY",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                minimumFractionDigits: 1,
                                maximumFractionDigits: 1,
                                signDisplay: 'exceptZero'
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                        visibility: {
                            variableId: 'PV_BATTERY'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery.soc_actual",
                            defaultMessage: "Vypo\u010Dten\xe9 minim\xe1ln\xed nabit\xed"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "PV_SOC_MIN_FINAL",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                        visibility: {
                            variableId: 'PV_BATTERY'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.battery_manual_charge",
                                    defaultMessage: "Manu\xe1ln\u011B nab\xedt baterii"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.battery_manual_charge_subtitle",
                                    defaultMessage: "Manu\xe1ln\xed nab\xedjen\xed baterie nabije baterii na c\xedlovou \xfarove\u0148 nabit\xed pokud nedojde k d\u0159\xedv\u011Bj\u0161\xedmu vypnut\xed u\u017Eivatelem."
                                }),
                                switchVariableId: "SP_BATTERY_MANUAL_CHARGE",
                                visibility: {
                                    variableIds: [
                                        'PV_BATTERY',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.common.battery_manual_charge_soc",
                                    defaultMessage: "C\xedlov\xe9 SOC pro manu\xe1ln\xed nab\xedjen\xed"
                                }),
                                variableId: "SP_BATTERY_MANUAL_CHARGE_SOC",
                                opts: {
                                    style: 'percent',
                                    maximumFractionDigits: 0
                                },
                                min: 20,
                                max: 100,
                                visibility: {
                                    variableIds: [
                                        'PV_BATTERY',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery.battery_manual_discharge",
                            defaultMessage: "Manu\xe1ln\u011B vyb\xedt baterii"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.common.battery_manual_discharge_subtitle",
                            defaultMessage: "Manu\xe1ln\xed vyb\xedjen\xed baterie vybije baterii na minim\xe1ln\xed \xfarove\u0148 nabit\xed pokud nedojde k d\u0159\xedv\u011Bj\u0161\xedmu vypnut\xed u\u017Eivatelem."
                        }),
                        switchVariableId: "SP_BATTERY_MANUAL_DISCHARGE",
                        visibility: {
                            variableIds: [
                                'PV_BATTERY',
                                'PV_BATTERY_CONTROL'
                            ]
                        },
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.battery_stop",
                    defaultMessage: "Blokace baterie"
                }),
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'BATTERY_DISCHARGE_BLOCKED_SETTINGS_VISIBLE'
                    ]
                },
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery_stop.hw",
                            defaultMessage: "Blokovat baterii p\u0159i provozu oh\u0159evu vody"
                        }),
                        switchVariableId: "PV_BATTERY_STOP_HW",
                        visibility: {
                            variableId: 'HW_INSTALL'
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery_stop.hp",
                            defaultMessage: "Blokovat baterii p\u0159i provozu tepeln\xe9ho \u010Derpadla"
                        }),
                        switchVariableId: "PV_BATTERY_STOP_HP",
                        visibility: {
                            variableId: 'HP_ENABLED'
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery_stop.wb",
                            defaultMessage: "Blokovat baterii p\u0159i provozu wallboxu"
                        }),
                        switchVariableId: "PV_BATTERY_STOP_WB",
                        visibility: {
                            variableId: 'WB_INSTALL'
                        },
                        lock: wbBatteryModeActive ? {
                            when: {},
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "photovoltaics.battery_stop.wb.lock_title",
                                defaultMessage: "Nastaven\xed nelze zm\u011Bnit"
                            }),
                            description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "photovoltaics.battery_stop.wb.lock_desc",
                                defaultMessage: "P\u0159i zapnut\xe9m re\u017Eimu nab\xedjen\xed wallboxu \u201ENab\xedjen\xed podle baterie\u201C nebo \u201EP\u0159ednostn\xed nab\xedjen\xed podle baterie\u201C nelze tuto blokaci zapnout. Pro zapnut\xed blokace nastavte jin\xfd re\u017Eim nab\xedjen\xed wallboxu."
                            })
                        } : undefined,
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "photovoltaics.battery_stop.hdo",
                            defaultMessage: "Vyb\xedjet baterii pouze p\u0159i n\xedzk\xe9m tarifu (HDO)"
                        }),
                        switchVariableId: "PV_BATTERY_STOP_HDO",
                        fullWidth: true
                    })
                ]
            }),
            premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddbf1ea2b354a30a$export$4d8c8cd2c300d546), {
                types: (0, $1e5a62547c9ca153$export$95c8a2a9568804b4)
            })
        ]
    });
};
var $9a8a9338216d46d9$export$2e2bcd8739ae039 = $9a8a9338216d46d9$var$Photovoltaics;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $7X4mk = parcelRequire("7X4mk");




var $9iEAl = parcelRequire("9iEAl");



parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");



var $8ni7a = parcelRequire("8ni7a");

const $a8d457b7c4fee4a3$var$Ems = ()=>{
    const [selectedInverterState, setSelectedInverterState] = (0, $acw62.useState)();
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const selectInverterOptions = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        return (0, $f1q41.chain)(Object.entries(variables.INVERTER_CONFIG)).filter(([_, { type: type }])=>{
            return [
                (0, $8ni7a.Inverter).SolaxEMS1000PRO,
                (0, $8ni7a.Inverter).SolaxEMS1000
            ].includes(type);
        }).map(([key, config])=>{
            if (config.type !== (0, $8ni7a.Inverter).SolaxEMS1000 && config.type !== (0, $8ni7a.Inverter).SolaxEMS1000PRO) throw new Error(`Unexpected inverter type: ${config.type}`);
            return new Array(config.inverters?.length ?? 0).fill(null).map((_, subInverterIndex)=>{
                const subInverter = variables.INVERTER_STATS[key].inverterDetail?.[subInverterIndex] ?? {
                    name: 0
                };
                return [
                    key,
                    subInverterIndex,
                    {
                        type: config.type,
                        subInverterName: subInverter.name
                    }
                ];
            });
        }).flatten().value();
    });
    const [selectedInverterType, selectedInverterMode, selectedInverterDetail, selectedInverterIndex, selectedSubInverterIndex] = (0, $2lSXC.useSelector)(({ variables: variables })=>{
        if (!selectInverterOptions.length) return [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ];
        const [key, subIndex] = selectedInverterState ?? selectInverterOptions[0];
        const detail = variables.INVERTER_STATS[key].inverterDetail?.[subIndex] ?? null;
        return [
            variables.INVERTER_CONFIG[key].type,
            variables.INVERTER_STATS[key].mode,
            detail,
            key,
            subIndex
        ];
    });
    if (!selectInverterOptions.length) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "ems.inverter",
                            defaultMessage: "M\u011Bni\u010D"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                            value: JSON.stringify([
                                selectedInverterIndex,
                                selectedSubInverterIndex
                            ]),
                            onChange: (e)=>setSelectedInverterState(JSON.parse(e.target.value)),
                            children: selectInverterOptions.map(([key, subIndex, { type: type, subInverterName: subInverterName }])=>{
                                const message = (0, $f1q41.get)((0, $c921d87731d038a0$export$3ec460b98d9366d2), [
                                    type,
                                    subInverterName
                                ]);
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                    value: JSON.stringify([
                                        key,
                                        subIndex
                                    ]),
                                    children: message ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        ...message
                                    }) : '---'
                                }, `${key}-${subIndex}`);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "photovoltaics.status",
                                    defaultMessage: "Re\u017Eim FVE"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                                    type: "photovoltaic"
                                }),
                                fullWidth: true
                            }),
                            typeof selectedInverterMode === 'number' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "ems.mode",
                                    defaultMessage: "Re\u017Eim EMS"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: (0, $f1q41.get)((0, $c921d87731d038a0$export$afd0895be3f7068a), selectedInverterMode, '---')
                                }),
                                fullWidth: true
                            })
                        ]
                    })
                ]
            }),
            selectedInverterType && selectedInverterDetail && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "ems.inverter.name",
                        defaultMessage: "N\xe1zev st\u0159\xedda\u010De"
                    }),
                    subtitle: (()=>{
                        const message = (0, $f1q41.get)((0, $c921d87731d038a0$export$3ec460b98d9366d2), [
                            selectedInverterType,
                            selectedInverterDetail?.name
                        ]);
                        return message ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            ...message
                        }) : '---';
                    })(),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "photovoltaics.statistics",
                    defaultMessage: "V\xfdkon elektr\xe1rny"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_POWER_STRING_GRAPH",
                    variableSuffix: `${selectedInverterIndex}||${selectedSubInverterIndex}`,
                    initialVariant: (0, $9b560528a5f99400$export$585dc7a4228aacca).LineStacked,
                    getSubStatsLabel: (key)=>{
                        const rawStringNumber = (0, $f1q41.last)(key.split('-'));
                        const stringNumber = Number(rawStringNumber);
                        return `String ${Number.isNaN(stringNumber) ? '-' : stringNumber + 1}`;
                    }
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "ems.details",
                    defaultMessage: "Parametry m\u011Bni\u010De"
                }),
                children: selectedInverterDetail && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems.power.total",
                                defaultMessage: "Celkov\xfd v\xfdkon"
                            }),
                            value: formatNumber((selectedInverterDetail.power ?? []).reduce((a, b)=>a + (b ?? 0), 0), {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {}),
                            expanded: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "body1",
                                sx: {
                                    color: 'text.disabled',
                                    mt: 1
                                },
                                children: Array.from({
                                    length: 6
                                }, (_, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "ems.power.index",
                                                defaultMessage: "V\xfdkon string {index}",
                                                values: {
                                                    index: i + 1
                                                }
                                            }),
                                            ":",
                                            ' ',
                                            formatNumber(selectedInverterDetail.power?.[i] ?? 0, {
                                                style: 'unit',
                                                unit: 'kilowatt',
                                                maximumFractionDigits: 2,
                                                minimumFractionDigits: 2
                                            }),
                                            i < 5 && /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                        ]
                                    }, i))
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems.activePower",
                                defaultMessage: "\u010Cinn\xfd v\xfdkon"
                            }),
                            value: formatNumber(selectedInverterDetail.activePower ?? 0, {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems.reactivePower",
                                defaultMessage: "Jalov\xfd v\xfdkon"
                            }),
                            value: formatNumber(selectedInverterDetail.reactivePower ?? 0, {
                                style: 'unit',
                                unit: 'kilovoltampere-reactive',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems.apparentPower",
                                defaultMessage: "Zd\xe1nliv\xfd v\xfdkon"
                            }),
                            value: formatNumber(selectedInverterDetail.apparentPower ?? 0, {
                                style: 'unit',
                                unit: 'kilovoltampere',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems.powerFactor",
                                defaultMessage: "\xda\u010Din\xedk"
                            }),
                            value: formatNumber(selectedInverterDetail.powerFactor ?? 0, {
                                style: undefined,
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                        })
                    ]
                })
            })
        ]
    });
};
var $a8d457b7c4fee4a3$export$2e2bcd8739ae039 = $a8d457b7c4fee4a3$var$Ems;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $f1q41 = parcelRequire("f1q41");




parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");




var $2lSXC = parcelRequire("2lSXC");

var $7X4mk = parcelRequire("7X4mk");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $b9b2f817f448d12b$export$efd0b5fc9ad4ae27 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler.settings.temp_spot",
            defaultMessage: "Teplota ze spotu pomoc\xed EK"
        }),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "boiler.settings.temp_spot.subtitle",
            defaultMessage: "P\u0159edeh\u0159\xedvac\xed teplota, kter\xe1 je pouze z n\xedzk\xe9 ceny"
        }),
        variableId: "HW_SPOT_TEMP_EK",
        visibility: {
            variableIds: [
                'SP_INSTALL',
                'HW_TEMP_ENABLED'
            ]
        },
        max: 85,
        opts: {
            style: 'unit',
            unit: 'celsius',
            maximumFractionDigits: 0
        }
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $bb0cc1e72fd5624c$export$f50acbe31a497670 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.settings.spot-mi",
                    defaultMessage: "Blokovat oh\u0159ev p\u0159i st\u0159edn\xed cen\u011B spotu"
                }),
                switchVariableId: "HW_SPOT_MI_STOP",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.settings.spot-hi",
                    defaultMessage: "Blokovat oh\u0159ev p\u0159i vysok\xe9 cen\u011B spotu"
                }),
                switchVariableId: "HW_SPOT_HI_STOP",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                fullWidth: true
            })
        ]
    });
};


const $6d492b63d6b61041$var$BoilerPage = ()=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const value = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.sum)([
            (0, $f1q41.get)(s.variables, 'HW_INFO.Consumption[0]'),
            (0, $f1q41.get)(s.variables, 'HW_INFO.Consumption[1]'),
            (0, $f1q41.get)(s.variables, 'HW_INFO.Consumption[2]')
        ]));
    const formattedValue = formatNumber(value, {
        style: 'unit',
        unit: 'kilowatt',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const value2 = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'HW_ENERGY_PRODUCED_TOTAL'));
    const formattedValue2 = formatNumber(value2, {
        style: 'unit',
        unit: 'kilowatt-hour',
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "boiler.status",
                        defaultMessage: "Re\u017Eim Bojleru"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                        type: "heatWater"
                    }),
                    switchVariableId: "HW_ON",
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.statistics",
                    defaultMessage: "V\xfdkon bojleru"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HW_POWER_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.statisticsTemp",
                    defaultMessage: "Teplota bojleru"
                }),
                visibility: {
                    variableId: 'HW_TEMP_ENABLED'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HW_TEMP_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler.common.temperature",
                            defaultMessage: "Aktu\xe1ln\xed teplota"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HW_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        visibility: {
                            variableId: 'HW_TEMP_ENABLED'
                        },
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler.common.power",
                            defaultMessage: "Aktu\xe1ln\xed odb\u011Br"
                        }),
                        value: formattedValue,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler.common.power.phase_1",
                                    defaultMessage: "F\xe1ze 1:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "HW_INFO.Consumption[0]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler.common.power.phase_2",
                                    defaultMessage: "F\xe1ze 2:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "HW_INFO.Consumption[1]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler.common.phase_3",
                                    defaultMessage: "F\xe1ze 3:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "HW_INFO.Consumption[2]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "boiler.common.total",
                            defaultMessage: "Celkov\xe1 spot\u0159eba"
                        }),
                        value: formattedValue2,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_HW_ENERGY_PRODUCED_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "boiler.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_HW_ENERGY_PRODUCED_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.settings",
                    defaultMessage: "Nastaven\xed"
                }),
                layout: "list",
                visibility: {
                    variableId: 'HW_TEMP_ENABLED'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.temp",
                                defaultMessage: "Nastaven\xe1 teplota"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.temp.subtitle",
                                defaultMessage: "B\u011B\u017En\xe1 teplota, kter\xe1 je k dispozici v\u017Edy"
                            }),
                            variableId: "HW_SET_TEMP",
                            visibility: {
                                variableId: 'HW_TEMP_ENABLED'
                            },
                            max: 85,
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.temp_ek",
                                defaultMessage: "Teplota z FVE pomoc\xed EK"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.temp_ek.subtitle",
                                defaultMessage: "P\u0159edeh\u0159\xedvac\xed teplota, kter\xe1 je pouze z p\u0159ebytk\u016F"
                            }),
                            variableId: "HW_MAX_TEMP_EK",
                            visibility: {
                                variableId: 'HW_TEMP_ENABLED'
                            },
                            max: 85,
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9b2f817f448d12b$export$efd0b5fc9ad4ae27), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "boiler.blocking",
                    defaultMessage: "Blokace oh\u0159evu"
                }),
                layout: "list",
                visibility: {
                    variableId: 'HW_TEMP_ENABLED'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.hdo",
                                defaultMessage: "\u0158\xedzen\xed b\u011B\u017En\xe9ho oh\u0159evu dle HDO \u010Das\u016F"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.hdo.subtitle",
                                defaultMessage: "\u010Casy pro HDO mus\xed b\xfdt nastaveny v obecn\xe9m nastaven\xed"
                            }),
                            switchVariableId: 'HW_HDO',
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb0cc1e72fd5624c$export$f50acbe31a497670), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.min_soc",
                                defaultMessage: "Blokace oh\u0159evu p\u0159i v\xfdpadku s\xedt\u011B"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.min_soc.subtitle",
                                defaultMessage: "Nabit\xed baterie, od kter\xe9ho dojde k blokaci oh\u0159evu p\u0159i v\xfdpadku s\xedt\u011B"
                            }),
                            variableId: "HW_SOC_STOP",
                            visibility: {
                                variableId: 'PV_BATTERY'
                            },
                            max: 100,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.min_soc_utility",
                                defaultMessage: "Blokace oh\u0159evu p\u0159i dostupn\xe9 s\xedti"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "boiler.settings.min_soc_utility.subtitle",
                                defaultMessage: "Nabit\xed baterie, od kter\xe9ho dojde k blokaci oh\u0159evu"
                            }),
                            variableId: "HW_SOC_STOP_UTILITY",
                            visibility: {
                                variableId: 'PV_BATTERY'
                            },
                            max: 100,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var $6d492b63d6b61041$export$2e2bcd8739ae039 = $6d492b63d6b61041$var$BoilerPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $7X4mk = parcelRequire("7X4mk");




parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");



var $2lSXC = parcelRequire("2lSXC");

const $e6ec973437282c75$export$1d65ff0960df1518 = [
    'PV_POWER_GRAPH',
    'PV_BATTERY_CHARGE_GRAPH',
    'PV_BATTERY_DISCHARGE_GRAPH',
    'HW_POWER_GRAPH',
    'HP_CONSUMED_GRAPH',
    'EM_CONSUMED_GRAPH',
    'EM_OVERFLOW_GRAPH',
    'PL_POWER_GRAPH',
    'HOME_CONSUMPTION'
];


const $1292f41821d95ba0$var$ElectricalGridPage = ()=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const value = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.sum)([
            (0, $f1q41.get)(s.variables, 'EM_INFO.Consumption[0]'),
            (0, $f1q41.get)(s.variables, 'EM_INFO.Consumption[1]'),
            (0, $f1q41.get)(s.variables, 'EM_INFO.Consumption[2]')
        ]));
    const formattedValue = formatNumber(value, {
        style: 'unit',
        unit: 'kilowatt',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
    const value2 = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'EM_ENERGY_CONSUMED_TOTAL'));
    const formattedValue2 = formatNumber(value2, {
        style: 'unit',
        unit: 'kilowatt-hour',
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    });
    const value3 = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'EM_ENERGY_OVERFLOW_TOTAL'));
    const formattedValue3 = formatNumber(value3, {
        style: 'unit',
        unit: 'kilowatt-hour',
        maximumFractionDigits: 1,
        minimumFractionDigits: 1
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "electrical_grid.status",
                        defaultMessage: "Stav distribu\u010Dn\xed s\xedt\u011B"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                        type: "smartMeter"
                    }),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "electrical_grid.statistics",
                    defaultMessage: "Statistiky n\xe1kupu"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "EM_CONSUMED_GRAPH",
                    yAxisDomainEndFrom: (0, $e6ec973437282c75$export$1d65ff0960df1518)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "electrical_grid.statistics_overflow",
                    defaultMessage: "Statistiky p\u0159etoku"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "EM_OVERFLOW_GRAPH",
                    yAxisDomainEndFrom: (0, $e6ec973437282c75$export$1d65ff0960df1518)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "electrical_grid.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electrical_grid.common.power",
                            defaultMessage: "Aktu\xe1ln\xed odb\u011Br"
                        }),
                        value: formattedValue,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.power.phase_1",
                                    defaultMessage: "F\xe1ze 1:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "EM_INFO.Consumption[0]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.power.phase_2",
                                    defaultMessage: "F\xe1ze 2:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "EM_INFO.Consumption[1]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.power.phase_3",
                                    defaultMessage: "F\xe1ze 3:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "EM_INFO.Consumption[2]",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electrical_grid.common.total_consumption",
                            defaultMessage: "Celkov\xfd odb\u011Br ze s\xedt\u011B"
                        }),
                        value: formattedValue2,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed odb\u011Br ze s\xedt\u011B:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_EM_ENERGY_CONSUMED_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed odb\u011Br ze s\xedt\u011B:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_EM_ENERGY_CONSUMED_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electrical_grid.common.overflow",
                            defaultMessage: "Celkov\xfd p\u0159etok do s\xedt\u011B"
                        }),
                        value: formattedValue3,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.overflow_today",
                                    defaultMessage: "Dne\u0161n\xed p\u0159etok do s\xedt\u011B:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_EM_ENERGY_OVERFLOW_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electrical_grid.common.overflow_year",
                                    defaultMessage: "Ro\u010Dn\xed p\u0159etok do s\xedt\u011B:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_EM_ENERGY_OVERFLOW_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $1292f41821d95ba0$export$2e2bcd8739ae039 = $1292f41821d95ba0$var$ElectricalGridPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $1DAbm = parcelRequire("1DAbm");

var $2lSXC = parcelRequire("2lSXC");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

const $66dcc2aa39db9b35$var$Statistics = ()=>{
    const { filters: filters, ...propsOptions } = (0, $9b560528a5f99400$export$163daf3316c6aaf8)({
        parent: true,
        variableId: undefined
    });
    const chartBoxProps = {
        options: propsOptions,
        yAxisDomainEndFrom: (0, $e6ec973437282c75$export$1d65ff0960df1518)
    };
    const [hpAcond, hpEcoone, hpEnabled, hpNibe] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.HP_ACOND,
            variables.HP_ECOONE,
            variables.HP_ENABLED,
            variables.HP_NIBE
        ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                children: filters
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'PV_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.photovoltaics.statistics",
                    defaultMessage: "V\xfdroba elektr\xe1rny"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_POWER_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'PV_BATTERY'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.battery.statistics",
                    defaultMessage: "\xdarove\u0148 nabit\xed baterie"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PV_BATTERY_SOC_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'HW_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.boiler.statistics",
                    defaultMessage: "Oh\u0159ev bojleru elektrokotlem"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HW_POWER_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'HP_ENABLED'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.heatpump.statistics",
                    defaultMessage: "Spot\u0159eba kompresoru"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HP_CONSUMED_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'PV_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.electrical_grid.statistics",
                    defaultMessage: "N\xe1kup z distribu\u010Dn\xed s\xedt\u011B"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "EM_CONSUMED_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'PV_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.electrical_grid.statistics_overflow",
                    defaultMessage: "P\u0159etok do distribu\u010Dn\xed s\xedt\u011B"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "EM_OVERFLOW_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableIds: [
                        'EM_INSTALL',
                        'DEV_HOME_CONSUMPTION_GRAPH'
                    ]
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.electrical_grid.statistics_house_consumption",
                    defaultMessage: "Spot\u0159eba objektu"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HOME_CONSUMPTION",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'PL_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.plug.statistics",
                    defaultMessage: "Spot\u0159eba z\xe1suvky"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PL_POWER_GRAPH",
                    ...chartBoxProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                visibility: {
                    variableId: 'WIND_INSTALL'
                },
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.wind.statistics",
                    defaultMessage: "V\xfdroba v\u011Btrn\xe9 elektr\xe1rny"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "WIND_POWER_GRAPH",
                    ...chartBoxProps
                })
            }),
            Boolean(hpEnabled && (hpAcond || hpEcoone || hpNibe)) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "statistics.outdoor_temperature.statistics",
                    defaultMessage: "Venkovn\xed teplota"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "OUTDOOR_TEMP_GRAPH",
                    ...chartBoxProps
                })
            })
        ]
    });
};
var $66dcc2aa39db9b35$export$2e2bcd8739ae039 = $66dcc2aa39db9b35$var$Statistics;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aphAM = parcelRequire("aphAM");

var $f1q41 = parcelRequire("f1q41");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2zDt6 = parcelRequire("2zDt6");

var $ezTXF = parcelRequire("ezTXF");
var $202BL = parcelRequire("202BL");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $1da81fd262ddec52$exports = {};
$1da81fd262ddec52$exports = JSON.parse('{"\\"chart.tooltip.substat.phase\\"":"F\xe1ze {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}","\\"chart.tooltip.substat.pv_string\\"":"{inverterName}, String {stringNumber}","animation.battery":"Baterie","animation.boiler":"Bojler","animation.consumption":"D\u016Fm","animation.electrical_grid":"S\xed\u0165","animation.hp":"Tepelko","animation.photovoltaics":"FVE","animation.wallbox":"Wallbox","animation.wind":"V\xedtr","app_messages.battery_max_soc":"Nabit\xed baterie na nastaven\xe9 maxim\xe1ln\xed SOC {maxSoc, number, ::.##}%","app_messages.battery_min_soc":"Vybit\xed baterie na nastaven\xe9 minim\xe1ln\xed SOC {minSoc, number, ::.##}%","app_messages.body.battery_max_soc":"Aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie je {currentSoc, number, ::.##}%.","app_messages.body.battery_min_soc":"Aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie je {currentSoc, number, ::.##}%.","app_messages.body.heat_pump_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla. Limit je {value, number, ::.##} kWh.","app_messages.body.heat_water_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit oh\u0159evu vody. Limit je {value, number, ::.##} kWh.","app_messages.body.heat_water_max_temperature":"Dnes ji\u017E do\u0161lo k nah\u0159\xe1t\xed bojleru na po\u017Eadovanou maxim\xe1ln\xed teplotu {maxTemperature, number, ::.##}\xb0C.","app_messages.body.home_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby dom\xe1cnosti. Limit je {value, number, ::.##} kWh.","app_messages.body.inverter_production_mwh":"Letos v\xe1m va\u0161e fotovoltaick\xe1 elektr\xe1rna ji\u017E vyrobila {inverterProductionValue, number, ::.##} MWh.","app_messages.body.spot_daily_prediction":"Denn\xed p\u0159edpov\u011B\u010F: {pvPrediction, select, true {V\xfdroba elektr\xe1rny: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {B\u011B\u017En\xe1 spot\u0159eba domu: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Dispozi\u010Dn\xed akumulace baterie: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Dispozi\u010Dn\xed akumulace bojleru: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Tepeln\xe9 \u010Derpadlo je {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Zb\xfdvaj\xedc\xed energie pro prodej p\u0159ebytk\u016F je {salePredictionValue, number, ::.##} kWh. } other {} }","app_messages.body.spot_daily_summary":"Dnes na spotu: {nothingToReport, select, true {Nen\xed nic v pl\xe1nu.} other { {energyForSale, select, true {V pl\xe1nu je rann\xed prodej do s\xedt\u011B. } other {} } {negativeIntervals, select, false {} other {Z\xe1porn\xe1 cena ({negativeIntervals}), p\u0159i kter\xe9 se omez\xed p\u0159etok. } } {chargingIntervals, select, false {} other {Pl\xe1n nab\xedjen\xed baterie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Pl\xe1n vyb\xedjen\xed baterie do s\xedt\u011B ({dischargingIntervals}). } } } }","app_messages.body.spot_negative_price_start":"Aktu\xe1ln\xed cena na spotu je po ode\u010Dten\xed provize z\xe1porn\xe1. Provize nastaven\xe1 v Infigy je ve v\xfd\u0161i {spotOffsetPrice, number, ::.##} K\u010D. Aktu\xe1ln\xed cena spotu je {spotNegativePrice, number, ::.##} K\u010D.","app_messages.body.spot_negative_price_stop":"Aktu\xe1ln\xed cena na spotu ji\u017E nen\xed z\xe1porn\xe1 a je ve v\xfd\u0161i {spotNegativePrice, number, ::.##} K\u010D. Provize je v Infigy nastaven\xe1 ve v\xfd\u0161i {spotOffsetPrice, number, ::.##} K\u010D","app_messages.body.wallbox_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit nab\xedjen\xed elektromobilu. Limit je {value, number, ::.##} kWh.","app_messages.body.wallbox_stop_charging":"V tomto cyklu bylo dod\xe1no {wallboxConsumptionCycleValue, number, ::.##} kWh energie.","app_messages.button":"Smazat","app_messages.cancel":"Zru\u0161it","app_messages.confirm":"Smazat","app_messages.confirm.title":"Opravdu chcete smazat v\u0161echny zpr\xe1vy?","app_messages.detail_dialog.close":"P\u0159e\u010Dteno","app_messages.heat_pump_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla","app_messages.heat_water_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit oh\u0159evu vody","app_messages.heat_water_max_temperature":"Dosa\u017Eena po\u017Eadovan\xe1 maxim\xe1ln\xed teplota vody","app_messages.home_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby dom\xe1cnosti","app_messages.inverter_connected":"Nav\xe1z\xe1n\xed komunikace se st\u0159\xedda\u010Dem","app_messages.inverter_disconnected":"Ztr\xe1ta komunikace se st\u0159\xedda\u010Dem","app_messages.inverter_production_mwh":"Miln\xedk ve v\xfdrob\u011B FVE","app_messages.load_more":"Na\u010D\xedst v\xedce","app_messages.no_messages":"Zat\xedm zde nejsou \u017E\xe1dn\xe9 notifikace","app_messages.spot_daily_prediction":"Denn\xed p\u0159edpov\u011B\u010F","app_messages.spot_daily_summary":"Denn\xed souhrn pl\xe1nu spotu","app_messages.spot_negative_price_start":"Cena spotu je z\xe1porn\xe1","app_messages.spot_negative_price_stop":"Cena spotu ji\u017E nen\xed z\xe1porn\xe1","app_messages.spot_start_charging_battery":"Za\u010Dalo nab\xedjen\xed baterie dle spotov\xe9 ceny","app_messages.spot_start_discharging_battery":"Za\u010Dalo vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny","app_messages.spot_stop_charging_battery":"Nab\xedjen\xed baterie dle spotov\xe9 ceny bylo ukon\u010Deno","app_messages.spot_stop_discharging_battery":"Vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny bylo ukon\u010Deno","app_messages.test":"Testovac\xed notifikace","app_messages.title":"Smazat v\u0161echny zpr\xe1vy","app_messages.utility_loss_start":"Zaznamenali jsme v\xfdpadek distribu\u010Dn\xed s\xedt\u011B","app_messages.utility_loss_stop":"V\xfdpadek distribu\u010Dn\xed s\xedt\u011B byl odstran\u011Bn","app_messages.wallbox_limit_exceeded":"Byl p\u0159ekro\u010Den dne\u0161n\xed limit nab\xedjen\xed elektromobilu","app_messages.wallbox_start_charging":"Za\u010Dalo nab\xedjen\xed elektromobilu","app_messages.wallbox_stop_charging":"Nab\xedjen\xed elektromobilu bylo ukon\u010Deno","app_update_overlay.subtitle":"Pros\xedm vy\u010Dkejte. Po dokon\u010Den\xed aktualizace se aplikace restartuje a okno v prohl\xed\u017Ee\u010Di se automaticky obnov\xed","app_update_overlay.title":"Aktualizace prob\xedh\xe1","audit_log.error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed","audit_log.item.author":"Autor","audit_log.item.date":"Datum","audit_log.item.payload":"Ud\xe1lost","audit_log.item.type":"Typ","audit_log.title":"Audit Log","audit_log_delete.button":"Smazat","audit_log_delete.cancel":"Zru\u0161it","audit_log_delete.confirm":"Smazat","audit_log_delete.confirm.title":"Opravdu chcete smazat v\u0161echny z\xe1znamy v audit logu?","audit_log_delete.title":"Smazat audit log","azRouters.add":"P\u0159idat nov\xfd AZ router","azRouters.addButton":"P\u0159idat","azRouters.clientId":"Modbus ID","azRouters.clientId.value":"Modbus ID: {id}","azRouters.counts":"OK {ok} / Chyb {err}","azRouters.empty":"Nejsou nakonfigurov\xe1ny \u017E\xe1dn\xe9 AZ routery","azRouters.name":"N\xe1zev","azRouters.status.error":"Chyba","azRouters.status.ok":"OK","azRouters.status.starting":"Spou\u0161t\xed se","azRouters.title":"AZ routery","bez_dodavatele.business_flexibility.title":"Obchodn\xed flexibilita","bez_dodavatele.enabled":"Integrace zapnuta","bez_dodavatele.region":"K\xf3d kraje","bez_dodavatele.title":"bezDodavatele","boiler.blocking":"Blokace oh\u0159evu","boiler.common":"Obecn\xe9 informace","boiler.common.phase_3":"F\xe1ze 3:","boiler.common.power":"Aktu\xe1ln\xed odb\u011Br","boiler.common.power.phase_1":"F\xe1ze 1:","boiler.common.power.phase_2":"F\xe1ze 2:","boiler.common.power_today":"Dne\u0161n\xed spot\u0159eba:","boiler.common.power_year":"Ro\u010Dn\xed spot\u0159eba:","boiler.common.temperature":"Aktu\xe1ln\xed teplota","boiler.common.total":"Celkov\xe1 spot\u0159eba","boiler.settings":"Nastaven\xed","boiler.settings.hdo":"\u0158\xedzen\xed b\u011B\u017En\xe9ho oh\u0159evu dle HDO \u010Das\u016F","boiler.settings.hdo.subtitle":"\u010Casy pro HDO mus\xed b\xfdt nastaveny v obecn\xe9m nastaven\xed","boiler.settings.min_soc":"Blokace oh\u0159evu p\u0159i v\xfdpadku s\xedt\u011B","boiler.settings.min_soc.subtitle":"Nabit\xed baterie, od kter\xe9ho dojde k blokaci oh\u0159evu p\u0159i v\xfdpadku s\xedt\u011B","boiler.settings.min_soc_utility":"Blokace oh\u0159evu p\u0159i dostupn\xe9 s\xedti","boiler.settings.min_soc_utility.subtitle":"Nabit\xed baterie, od kter\xe9ho dojde k blokaci oh\u0159evu","boiler.settings.spot-hi":"Blokovat oh\u0159ev p\u0159i vysok\xe9 cen\u011B spotu","boiler.settings.spot-mi":"Blokovat oh\u0159ev p\u0159i st\u0159edn\xed cen\u011B spotu","boiler.settings.temp":"Nastaven\xe1 teplota","boiler.settings.temp.subtitle":"B\u011B\u017En\xe1 teplota, kter\xe1 je k dispozici v\u017Edy","boiler.settings.temp_ek":"Teplota z FVE pomoc\xed EK","boiler.settings.temp_ek.subtitle":"P\u0159edeh\u0159\xedvac\xed teplota, kter\xe1 je pouze z p\u0159ebytk\u016F","boiler.settings.temp_spot":"Teplota ze spotu pomoc\xed EK","boiler.settings.temp_spot.subtitle":"P\u0159edeh\u0159\xedvac\xed teplota, kter\xe1 je pouze z n\xedzk\xe9 ceny","boiler.statistics":"V\xfdkon bojleru","boiler.statisticsTemp":"Teplota bojleru","boiler.status":"Re\u017Eim Bojleru","boiler.status.home":"Re\u017Eim bojleru","boiler_test_trigger.button":"Otestovat bojler","boiler_test_trigger.button.running":"Test prob\xedh\xe1","boiler_test_trigger.subtitle":"Ov\u011B\u0159\xed spr\xe1vn\xe9 zapojen\xed a zadan\xfd v\xfdkon patrony bojleru.","boiler_test_trigger.title":"Test bojleru","boiler_test_wizard.acknowledge.condition":"Pro spr\xe1vn\xfd test bojleru je nutn\xe9, aby byla spot\u0159eba v objektu konstantn\xed a nebo nulov\xe1. Jak\xe9koliv v\xfdkyvy ve spot\u0159eb\u011B mohou test ovlivnit. Aktu\xe1ln\xed spot\u0159eba objektu je {power}","boiler_test_wizard.acknowledge.config":"Aktu\xe1ln\u011B je nastaven {phaseLabel} bojler o celkov\xe9 v\xfdkonu {power}. Tyto hodnoty mus\xed b\xfdt zadan\xe9 dle \u0161t\xedtku patrony.","boiler_test_wizard.acknowledge.confirm":"Potvrzuji","boiler_test_wizard.acknowledge.phase1":"1-f\xe1zov\xfd","boiler_test_wizard.acknowledge.phase3":"3-f\xe1zov\xfd","boiler_test_wizard.acknowledge.phase_option":"{phase}. f\xe1ze","boiler_test_wizard.acknowledge.phase_select":"Vyberte f\xe1ze, kter\xe9 se maj\xed otestovat. Neozna\u010Den\xe9 f\xe1ze budou p\u0159esko\u010Deny.","boiler_test_wizard.acknowledge.phase_select_empty":"Vyberte alespo\u0148 jednu f\xe1zi.","boiler_test_wizard.acknowledge.start":"Otestovat bojler","boiler_test_wizard.acknowledge.title":"Informace k testu","boiler_test_wizard.result.after":"Spot\u0159eba objektu po aktivaci","boiler_test_wizard.result.before":"Spot\u0159eba objektu p\u0159ed aktivac\xed","boiler_test_wizard.result.close":"Zav\u0159\xedt","boiler_test_wizard.result.correct":"Spot\u0159eba bojleru korektn\xed","boiler_test_wizard.result.detail_toggle":"Detail testu","boiler_test_wizard.result.header":"V\xfdsledek testu:","boiler_test_wizard.result.phase_header":"{phase}. f\xe1ze","boiler_test_wizard.result.real_power":"Odhadovan\xfd p\u0159\xedkon bojleru","boiler_test_wizard.result.rerun":"Spustit test znovu","boiler_test_wizard.result.set_power":"Zadan\xfd v\xfdkon","boiler_test_wizard.result.stable":"M\u011B\u0159en\xed bylo stabiln\xed","boiler_test_wizard.result.title":"V\xfdsledek testu","boiler_test_wizard.running.activate":"Aktivace f\xe1ze bojleru","boiler_test_wizard.running.after":"Spot\u0159eba objektu je {power}","boiler_test_wizard.running.before":"Spot\u0159eba objektu p\u0159ed testem je {power}","boiler_test_wizard.running.measuring":"Prob\xedh\xe1 m\u011B\u0159en\xed\u2026","boiler_test_wizard.running.phase":"Testuji f\xe1zi {phase}","boiler_test_wizard.running.real_power":"Odhadovan\xfd v\xfdkon bojleru je {power}","boiler_test_wizard.running.remaining":"Zb\xfdv\xe1 p\u0159ibli\u017En\u011B {seconds} s","boiler_test_wizard.running.reset":"Nulov\xe1n\xed spot\u0159eby","boiler_test_wizard.running.result_fail":"Test f\xe1ze nen\xed korektn\xed","boiler_test_wizard.running.result_ok":"Test f\xe1ze je korektn\xed","boiler_test_wizard.running.stable":"Spot\u0159eba je stabiln\xed","boiler_test_wizard.running.title":"Prob\xedh\xe1 test","boiler_test_wizard.running.unstable":"M\u011B\u0159en\xed nebylo stabiln\xed","boiler_test_wizard.title":"Testov\xe1n\xed bojleru","cancel":"Zru\u0161it","chart.range.this_week":"Posledn\xed t\xfdden","chart.range.today":"Posledn\xedch 24{nbsp}hodin","chart.tooltip.active_condition.title":"Aktu\xe1ln\xed re\u017Eim:","chart.tooltip.active_condition.value.battery":"Baterie","chart.tooltip.active_condition.value.compressor-blocked":"Blokace kompresoru, n\xedzk\xfd stav baterie","chart.tooltip.active_condition.value.cooling":"Chlazen\xed","chart.tooltip.active_condition.value.error":"Chyba","chart.tooltip.active_condition.value.heating":"Vyt\xe1p\u011Bn\xed","chart.tooltip.active_condition.value.hot-water":"Oh\u0159ev tepl\xe9 vody","chart.tooltip.active_condition.value.inactive":"Neaktivn\xed","chart.tooltip.active_condition.value.manual":"Manualn\xed","chart.tooltip.active_condition.value.not-connected":"Nelze nav\xe1zat spojen\xed","chart.tooltip.active_condition.value.not-licensed":"Nen\xed licencov\xe1no","chart.tooltip.active_condition.value.off":"Vypnuto","chart.tooltip.active_condition.value.overflow":"P\u0159etok","chart.tooltip.active_condition.value.pool":"Oh\u0159ev baz\xe9nu","chart.tooltip.active_condition.value.spot":"Spot","chart.tooltip.active_condition.value.time":"\u010Casov\xfd","chart.tooltip.control_mode.title":"\u0158\xedzeno podle:","chart.tooltip.control_mode.value":"{mode, select, photovoltaic {Fotovoltaika} grid {Distribu\u010Dn\xed s\xed\u0165} spot {Spot} flexibility {Flexibilita} error {Chyba} other {{mode}} }","chart.tooltip.wallbox_authorization_card_id.title":"Autoriza\u010Dn\xed karta:","charts.error.dialog.title":"P\u0159i na\u010D\xedt\xe1n\xed statistik do\u0161lo k chyb\u011B","charts.mode.day":"Den","charts.mode.week":"T\xfdden","charts.mode.year":"Rok","charts.summary.value":"Celkem {value}","close":"Zav\u0159\xedt","cloud_plugs.bat":"\u0158\xedzen\xed podle baterie","cloud_plugs.battery.battery_start":"Zapnout p\u0159i nabit\xed","cloud_plugs.battery.battery_start.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se aktivuje z\xe1suvka","cloud_plugs.battery.battery_stop":"Vypnout p\u0159i nabit\xed","cloud_plugs.battery.battery_stop.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se vypne z\xe1suvka","cloud_plugs.battery.on":"Aktivn\xed","cloud_plugs.battery_charged":"Nabit\xed baterie","cloud_plugs.condition":"Podm\xednka","cloud_plugs.condition.and":"A","cloud_plugs.condition.or":"Nebo","cloud_plugs.led_mode.battery.subtitle":"Podsv\xedcen\xed aktivn\xed, pokud m\xe1 baterie alespo\u0148 95%","cloud_plugs.led_mode.battery.switch.title":"Podsv\xedcen\xed p\u0159i sepnut\xe9 z\xe1suvce","cloud_plugs.led_mode.battery.title":"Podsv\xedcen\xed p\u0159i nabit\xe9 baterii","cloud_plugs.led_mode.mode":"{mode, select, unknown {---} off {Vypnuto} switch {} power {Podle p\u0159\xedkonu} other {Nezn\xe1m\xfd}}","cloud_plugs.led_mode.overflow.subtitle":"Podsv\xedcen\xed aktivn\xed, pokud dojde ke stabiln\xedmu p\u0159etoku","cloud_plugs.led_mode.overflow.title":"Podsv\xedcen\xed p\u0159i p\u0159etoku","cloud_plugs.led_mode.switch.subtitle":"Podsv\xedcen\xed aktivn\xed, pokud je z\xe1suvka sepnut\xe1","cloud_plugs.led_mode.title":"LED signalizace","cloud_plugs.list.id":"ID","cloud_plugs.list.led_mode":"LED signalizace","cloud_plugs.list.online":"Online","cloud_plugs.list.relay":"Rel\xe9","cloud_plugs.list.title":"Status","cloud_plugs.overflow":"\u0158\xedzen\xed podle p\u0159etoku","cloud_plugs.overflow.help":"Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B.","cloud_plugs.overflow.on":"Aktivn\xed","cloud_plugs.overflow.startPower":"Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B","cloud_plugs.overflow.startPower.help":"Z\xe1suvka se zapne, pokud je p\u0159etok v nastaven\xe9 v\xfd\u0161i po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na - 1500W a zpo\u017Ed\u011Bn\xed zapnut\xed je 5 minut, tak z\xe1suvka sepne p\u0159i p\u0159etoku do s\xedt\u011B ve v\xfd\u0161i alespo\u0148 1500W po dobu 5 minut.","cloud_plugs.overflow.startPower.subtitle":"Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br","cloud_plugs.overflow.stopPower":"Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B","cloud_plugs.overflow.stopPower.help":"Z\xe1suvka se vypne, pokud je odb\u011Br vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na 100W a zpo\u017Ed\u011Bn\xed vypnut\xed je 5 minut, tak z\xe1suvka vypne p\u0159i odb\u011Bru ze s\xedt\u011B ve v\xfd\u0161i minim\xe1ln\u011B 100W po dobu 5 minut.","cloud_plugs.overflow.stopPower.subtitle":"Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br","cloud_plugs.pv_power":"\u0158\xedzen\xed podle v\xfdkonu FVE","cloud_plugs.pv_power.help":"Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m v\xfdkonu FVE.","cloud_plugs.pv_power.on":"Aktivn\xed","cloud_plugs.pv_power.startPower":"Zapnout p\u0159i v\xfdrob\u011B FVE","cloud_plugs.pv_power.startPower.help":"Z\xe1suvka se zapne, pokud je v\xfdkon FVE v\u011Bt\u0161\xed ne\u017E nastaven\xe1 hodnota. Pokud je hodnota nastavena na 1000W, tak se z\xe1suvka sepne p\u0159i v\xfdrob\u011B FVE ve v\xfd\u0161i alespo\u0148 1000W.","cloud_plugs.pv_power.stopPower":"Vypnout p\u0159i v\xfdrob\u011B FVE","cloud_plugs.pv_power.stopPower.help":"Z\xe1suvka se vypne, pokud je v\xfdkon FVE men\u0161\xed ne\u017E nastaven\xe1 hodnota. Pokud je hodnota nastavena na 500W, tak se z\xe1suvka vypne p\u0159i v\xfdrob\u011B FVE ni\u017E\u0161\xed ne\u017E 500W.","cloud_plugs.time":"\u0158\xedzen\xed podle \u010Dasu","cloud_plugs.time.on":"Aktivn\xed","cloud_plugs.title":"Z\xe1suvky","cloud_plugs.turn_off":"Vypnout","cloud_plugs.turn_on":"Zapnout","dark_mode.dark":"Tmav\xfd","dark_mode.light":"Sv\u011Btl\xfd","dark_mode.system":"System","delta_green.battery_max_power_in":"Maxim\xe1ln\xed v\xfdkon baterie IN (W)","delta_green.battery_max_power_out":"Maxim\xe1ln\xed v\xfdkon baterie OUT (W)","delta_green.business_flexibility.title":"Obchodn\xed flexibilita","delta_green.connected":"Stav","delta_green.enabled":"Integrace zapnuta","delta_green.last_messages":"Posledn\xed zpr\xe1vy","delta_green.last_messages.date":"\u010Cas","delta_green.last_messages.payload":"Zpr\xe1va","delta_green.last_messages.topic":"Topic","delta_green.pv_orientation":"Orientace fotovoltaiky","delta_green.title":"Delta Green","des_battery_container.status.error":"Chyba","des_battery_container.status.none":"Nezn\xe1m\xfd stav","des_battery_container.status.off":"Vypnuto","des_battery_container.status.run":"B\u011B\u017En\xfd re\u017Eim","des_battery_container.status.sleep":"Re\u017Eim sp\xe1nku","dev.cloud_plugs.mqtt_cloud.connected":"Stav MQTT Cloud p\u0159ipojen\xed","dev.cloud_plugs.title":"Cloudov\xe9 z\xe1suvky","dev.inverter_config.connection.lan":"LAN","dev.inverter_config.connection.rs485":"RS485","dev.inverter_config.connection.rs485_hint":"Adresa a port se p\u0159eb\xedraj\xed z desky ({host}:{port}).","dev.inverter_config.rename_warning":"P\u0159ejmenov\xe1n\xed kl\xed\u010De z \\"{from}\\" na \\"{to}\\" osi\u0159el\xed historick\xe1 data \u2014 statistiky i na\u010D\xedtanou vyrobenou energii, kter\xe9 jsou veden\xe9 pod p\u016Fvodn\xedm kl\xed\u010Dem.","dev.inverter_config.search.open":"Vyhledat st\u0159\xedda\u010D","dev.inverter_config.search.title":"Vyhledat st\u0159\xedda\u010D","dev.inverter_config.stats.all":"V\u0161e","dev.inverter_config.status.counts":"OK {ok} / Chyb {err}","dev.inverter_config.status.error":"Chyba","dev.inverter_config.status.ok":"OK","dev.inverter_config.status.starting":"Spou\u0161t\xed se","dev.inverter_config.title":"Konfigurace st\u0159\xedda\u010D\u016F","dev.link":"Dev","dev_app_messages.test_send":"Testovac\xed notifikace","dev_app_messages.test_send.button":"Odeslat","dev_homepage.app_messages.title":"Notifikace","dev_homepage.title":"V\xfdvojov\xe9 menu","dev_status_log.empty":"Zat\xedm \u017E\xe1dn\xe1 data","dev_status_log.error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed","dev_status_log.title":"Status log","dev_status_log.today":"Dnes","dhcp_host.address":"IP adresa","dhcp_host.create.title":"Nov\xfd DHCP host","dhcp_host.edit.title":"Upravit DHCP host","dhcp_host.mac":"MAC adresa","dhcp_host.name":"N\xe1zev","dhcp_hosts.remove.cancel":"Zru\u0161it","dhcp_hosts.remove.confirm":"Smazat","dhcp_hosts.remove.confirm.title":"Opravdu chcete odfixovat adresu DHCP hosta?","dhcp_leases.ip":"IP adresa","dhcp_leases.mac":"MAC adresa","dhcp_leases.make_static.cancel":"Zru\u0161it","dhcp_leases.make_static.confirm":"P\u0159idat","dhcp_leases.make_static.confirm.title":"Opravdu chcete zafixovat adresu DHCP hosta?","dhcp_leases.name":"Jm\xe9no","dhcp_leases.next_renewal":"Dal\u0161\xed obnoven\xed","dhcp_leases.title":"DHCP Leases","ean":"EAN","electree.business_flexibility.title":"Obchodn\xed flexibilita","electree.connected":"Stav","electree.enabled":"Integrace zapnuta","electree.last_messages":"Posledn\xed zpr\xe1vy","electree.last_messages.date":"\u010Cas","electree.last_messages.payload":"Zpr\xe1va","electree.last_messages.topic":"Topic","electree.title":"Electree","electrical_grid.common":"Obecn\xe9 informace","electrical_grid.common.overflow":"Celkov\xfd p\u0159etok do s\xedt\u011B","electrical_grid.common.overflow_today":"Dne\u0161n\xed p\u0159etok do s\xedt\u011B:","electrical_grid.common.overflow_year":"Ro\u010Dn\xed p\u0159etok do s\xedt\u011B:","electrical_grid.common.power":"Aktu\xe1ln\xed odb\u011Br","electrical_grid.common.power.phase_1":"F\xe1ze 1:","electrical_grid.common.power.phase_2":"F\xe1ze 2:","electrical_grid.common.power.phase_3":"F\xe1ze 3:","electrical_grid.common.power_today":"Dne\u0161n\xed odb\u011Br ze s\xedt\u011B:","electrical_grid.common.power_year":"Ro\u010Dn\xed odb\u011Br ze s\xedt\u011B:","electrical_grid.common.total_consumption":"Celkov\xfd odb\u011Br ze s\xedt\u011B","electrical_grid.statistics":"Statistiky n\xe1kupu","electrical_grid.statistics_overflow":"Statistiky p\u0159etoku","electrical_grid.status":"Stav distribu\u010Dn\xed s\xedt\u011B","ems.activePower":"\u010Cinn\xfd v\xfdkon","ems.apparentPower":"Zd\xe1nliv\xfd v\xfdkon","ems.details":"Parametry m\u011Bni\u010De","ems.inverter":"M\u011Bni\u010D","ems.inverter.mode.backup":"Backup","ems.inverter.mode.feedIn":"Feed-in","ems.inverter.mode.manual":"Manual","ems.inverter.mode.peakShaving":"Peak Shaving","ems.inverter.mode.selfUse":"Self use","ems.inverter.name":"N\xe1zev st\u0159\xedda\u010De","ems.inverter.name.aelio":"X3-AELIO","ems.inverter.name.notConnected":"Nep\u0159ipojeno","ems.inverter.name.trene100k":"X3-TRENE-100K","ems.inverter.name.trene100ki":"X3-TRENE-100KI","ems.inverter.name.trene125k":"X3-TRENE-125K","ems.inverter.name.unknown":"Nezn\xe1m\xfd model","ems.mode":"Re\u017Eim EMS","ems.power.index":"V\xfdkon string {index}","ems.power.total":"Celkov\xfd v\xfdkon","ems.powerFactor":"\xda\u010Din\xedk","ems.reactivePower":"Jalov\xfd v\xfdkon","emsPro.inverter.name.aelio":"X3-AELIO","emsPro.inverter.name.notConnected":"Nep\u0159ipojeno","emsPro.inverter.name.trene1":"X3-TRENE-1","emsPro.inverter.name.trene100k":"X3-TRENE-100K","emsPro.inverter.name.trene125k":"X3-TRENE-125K","emsPro.inverter.name.x3forth":"X3-FORTH","emsPro.inverter.name.x3forthplus":"X3-FORTH+","emsPro.inverter.name.x3grand":"X3-GRAND","emsPro.inverter.name.x3mgag2":"X3-MGA G2","emsPro.inverter.name.x3prog2":"X3-PRO G2","emsService.basicSettings":"Komunikace s RTU","emsService.direction.disabled":"Zak\xe1z\xe1no","emsService.direction.read":"\u010Cten\xed","emsService.direction.write":"Z\xe1pis","emsService.distributionMetrics":"Distribu\u010Dn\xed pokyny","emsService.distributionMetrics.diMapping":"Mapov\xe1n\xed vstup\u016F","emsService.distributionMetrics.enabled":"Povoleno \u010Dten\xed distribu\u010Dn\xedch pokyn\u016F","emsService.distributionMetrics.source":"Zdroj distribu\u010Dn\xedch pokyn\u016F","emsService.distributionMetrics.source.digitalInputs":"Digit\xe1ln\xed vstupy","emsService.distributionMetrics.source.plc":"Extern\xed PLC","emsService.enabled":"PLC Povoleno","emsService.energyMeters":"Elektrom\u011Bry (Shelly EM / PLC)","emsService.energyMeters.add":"P\u0159idat nov\xfd elektrom\u011Br","emsService.energyMeters.addButton":"P\u0159idat","emsService.energyMeters.azRouter":"AZ router","emsService.energyMeters.azRouter.empty":"\u017D\xe1dn\xe9 AZ routery","emsService.energyMeters.empty":"Nejsou nakonfigurov\xe1ny \u017E\xe1dn\xe9 elektrom\u011Bry","emsService.energyMeters.newMeter":"N\xe1zev","emsService.energyMeters.plcMetric":"PLC Metrika","emsService.energyMeters.plcMetric.grid":"Grid","emsService.energyMeters.plcMetric.kgj":"KGJ","emsService.energyMeters.plcMetric.pv":"FVE","emsService.energyMeters.shellyId":"Shelly ID","emsService.energyMeters.source":"Zdroj","emsService.energyMeters.source.azRouter":"AZ router","emsService.energyMeters.source.plc":"PLC","emsService.energyMeters.source.shelly":"Shelly","emsService.gridMetrics.enabled":"Povoleno \u010Dten\xed paty objektu","emsService.ipAddress":"IP Adresa","emsService.kgjMetrics.enabled":"Povoleno \u010Dten\xed z KGJ","emsService.metricsDirection":"Sm\u011Br","emsService.mqttBroker":"MQTT Broker (Shellies)","emsService.mqttBrokerEnabled":"MQTT Broker povolen","emsService.mqttBrokerStatus":"Stav MQTT Brokeru","emsService.notAvailable":"Funkce EMS nen\xed k dispozici","emsService.password":"Heslo","emsService.plcStatus":"Stav PLC komunikace","emsService.pollInterval":"Interval dotazov\xe1n\xed (ms)","emsService.pvMetrics.enabled":"Povoleno \u010Dten\xed z FVE","emsService.shelliesList":"P\u0159ipojen\xe1 Shelly za\u0159\xedzen\xed","emsService.username":"U\u017Eivatelsk\xe9 jm\xe9no","ems_service.link":"EMS Service","ems_service.title":"EMS Service","enerco.ean":"EAN","enerco.enabled":"Integrace zapnuta","enerco.prediction.disabled":"Integrace je vypnut\xe1.","enerco.prediction.title":"Predikce","enerco.title":"Enerco","energomachine.business_flexibility.title":"Obchodn\xed flexibilita","energomachine.connected":"Stav","energomachine.enabled":"Integrace zapnuta","energomachine.last_messages":"Posledn\xed zpr\xe1vy","energomachine.last_messages.date":"\u010Cas","energomachine.last_messages.payload":"Zpr\xe1va","energomachine.last_messages.topic":"Topic","energomachine.title":"Energomachine","energyMeters.actualPower":"Aktu\xe1ln\xed v\xfdkon","energyMeters.general":"Obecn\xe9 informace","energyMeters.meter":"Elektrom\u011Br","energyMeters.notConfigured":"Elektrom\u011Bry nejsou nakonfigurov\xe1ny. Pro nastaven\xed p\u0159ejd\u011Bte do servisn\xedho menu.","energyMeters.phase1":"F\xe1ze 1:","energyMeters.phase2":"F\xe1ze 2:","energyMeters.phase3":"F\xe1ze 3:","energyMeters.statistics":"Statistiky","energyMeters.todayEnergy":"Dne\u0161n\xed spot\u0159eba:","energyMeters.totalEnergy":"Celkov\xe1 spot\u0159eba","energyMeters.yearEnergy":"Ro\u010Dn\xed spot\u0159eba:","error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed reportu.","expertService.HP":"Tepeln\xe9 \u010Derpadlo","expertService.HP.CntComErr":"\u010C\xedta\u010D chybn\xfdch zpr\xe1v","expertService.HP.CntComOk":"\u010C\xedta\u010D validn\xedch zpr\xe1v","expertService.HP.IpAdr":"IP adresa tepeln\xe9ho \u010Derpadla","expertService.HP.maxTempHW":"Maxim\xe1ln\xed teplota tepl\xe9 vody pro T\u010C","expertService.HP.maxTempHW.subtitle":"Sou\u010Det flexibiln\xed + nastaven\xe9 teploty","expertService.HW":"Bojler","expertService.HW.HwBatteryPriority":"Procento nab\xedt\xed od kter\xe9ho m\xe1 v\u017Edy prioritu bojler","expertService.HW.HwErrEnabled":"Vyhodnocovat dostupnost bojleru","expertService.HW.HwResetErrorTime":"Prodleva pro reset chyby termostatu","expertService.HW.HwResetErrorTime.subtitle":"\u010Cas v minut\xe1ch po kter\xe9m se chyba termostatu resetuje a op\u011Bt se spust\xed oh\u0159ev vody","expertService.HW.LegionellaLastTime":"Posledn\xed dosa\u017Een\xed teploty legionelly","expertService.HW.TempId":"ID teplotn\xedho \u010Didla","expertService.HW.control":"Typ \u0159\xedzen\xed bojleru","expertService.HW.control.onoff":"On/Off","expertService.HW.control.proportional":"Plynul\xe9","expertService.HW.hysterezis":"Hystereze bojleru","expertService.HW.hysterezis.subtitle":"Hystereze je pouze pro b\u011B\u017En\xfd oh\u0159ev","expertService.HW.maxPower":"Maxim\xe1ln\xed v\xfdkon bojleru v procentech","expertService.HW.maxPower.subtitle":"Toto nastaven\xed je pouze pro plynul\xe9 \u0159\xedzen\xed bojleru a omezuje maxim\xe1ln\xed v\xfdkon patrony v procentech.","expertService.HW.offset":"Offset na f\xe1zi [W]","expertService.HW.offset.disabled-overflow":"Offset pro \u0159\xedzen\xed bojleru se zak\xe1zan\xfdm p\u0159etokem na f\xe1zi [W]","expertService.HW.offset.disabled-overflow.subtitle":"Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B p\u0159i omezen\xe9m st\u0159\xedda\u010Di","expertService.HW.offset.enabled-overflow":"Offset pro \u0159\xedzen\xed bojleru s povolen\xfdm p\u0159etokem na f\xe1zi [W]","expertService.HW.offset.enabled-overflow.subtitle":"Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B.","expertService.HW.offset.ongrid":"Offset pro \u0159\xedzen\xed bojleru pro s\xed\u0165ov\xe9 elektr\xe1rny [W]","expertService.HW.offset.ongrid.subtitle":"Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B.","expertService.PV":"Fotovoltaika","expertService.PV.BatteryPowerPercent":"V\xfdkon nab\xedjen\xed baterie v procentech","expertService.PV.CntComErr":"\u010C\xedta\u010D chybn\xfdch zpr\xe1v","expertService.PV.CntComOk":"\u010C\xedta\u010D validn\xedch zpr\xe1v","expertService.PV.ControlMeteringMode":"Zp\u016Fsob \u0159\xedzen\xed p\u0159ebytk\u016F","expertService.PV.ControlMeteringMode.perPhase":"F\xe1zov\xe9","expertService.PV.ControlMeteringMode.subtitle":"F\xe1zov\xe9 \u0159\xedzen\xed po\u010D\xedt\xe1 p\u0159ebytek pro \u0159\xedzen\xed technologi\xed z jednotliv\xfdch f\xe1z\xed. Sou\u010Dtov\xe9 \u0159\xedzen\xed pracuje se sou\u010Dtem v\u0161ech f\xe1z\xed.","expertService.PV.ControlMeteringMode.sum":"Sou\u010Dtov\xe9","expertService.PV.ExternalPv":"Extern\xed FVE p\u0159ipojen\xe1 skrze SOLAX Meter 2","expertService.PV.ExternalPvSofar":"Extern\xed FVE p\u0159ipojen\xe1 skrze SOFAR Meter 2","expertService.PV.IpAdr":"IP adresa st\u0159\xedda\u010De","expertService.PV.MeteringMode":"Zp\u016Fsob m\u011B\u0159en\xed distribuce","expertService.PV.MeteringMode.perPhase":"F\xe1zov\xe9","expertService.PV.MeteringMode.subtitle":"F\xe1zov\xe9 m\u011B\u0159en\xed (\u010CR) po\u010D\xedt\xe1 n\xe1kup i p\u0159etok na ka\u017Ed\xe9 f\xe1zi zvl\xe1\u0161\u0165. Sou\u010Dtov\xe9 m\u011B\u0159en\xed pracuje s v\xfdslednou bilanc\xed v\u0161ech f\xe1z\xed.","expertService.PV.MeteringMode.sum":"Sou\u010Dtov\xe9","expertService.PV.PowerControlType":"Typ \u0159\xedzen\xed v\xfdkonu s\xed\u0165ov\xfdch st\u0159\xedda\u010D\u016F","expertService.PV.PowerControlType.fixed":"Fixn\xed","expertService.PV.PowerControlType.proportional":"Plynul\xe9","expertService.PV.StringNumber":"Po\u010Det sting\u016F st\u0159\xedda\u010De","expertService.PV.StringNumber.subtitle":"Po\u010Det sting\u016F st\u0159\xedda\u010De zobrazovan\xfd v aplikaci na z\xe1lo\u017Ece FVE","expertService.PV.Versions":"Verze","expertService.SP":"Spot","expertService.SP.HwCoefficient":"Koeficiet odhadu energie do bojleru","expertService.SP.HwCoefficient.subtitle":"Koeficient odhadu mno\u017Estv\xed energie pro nabit\xed bojleru.","expertService.SP.batteryCoefficient":"Koeficiet odhadu \u010Dasu nab\xedjen\xed baterie","expertService.SP.batteryCoefficient.subtitle":"Koeficient odhadu \u010Dasu pro nab\xedjen\xed a vyb\xedjen\xed baterie","expertService.SP.minDifferenceBatterychargeFromGrid":"Minim\xe1ln\xed odhadovan\xe9 zv\xfd\u0161en\xed SOC pro vy\u010Dk\xe1n\xed baterie na FVE","expertService.SP.minDifferenceBatterychargeFromGrid.subtitle":"Pokud je odhad nabit\xed baterie pod touto hodnotou, m\u016F\u017Ee doj\xedt k nabit\xed baterie ze s\xedt\u011B.","expertService.WB":"Wallbox","expertService.WB.CntComErr":"\u010C\xedta\u010D chybn\xfdch zpr\xe1v","expertService.WB.CntComOk":"\u010C\xedta\u010D validn\xedch zpr\xe1v","expertService.WB.IpAdr":"IP adresa wallboxu","expertService.general":"Obecn\xe9 nastaven\xed","expertService.general.largeInstallation":"Velk\xe1 instalace","expertService.general.largeInstallation.subtitle":"Roz\u0161\xed\u0159\xed rozsahy hodnot pro velk\xe9 instalace","expertService.password":"P\u0159\xedstup do servisu","expertService.password.label":"Heslo","expert_service.app_messages":"Zpr\xe1vy","expert_service.audit_log":"Audit log","expert_service.error_list":"Seznam chyb","expert_service.link":"Expert Service","expert_service.network":"S\xed\u0165","expert_service.network.button":"P\u0159ej\xedt do nastaven\xed s\xedt\u011B","expert_service.network.link":"Si\u0165","expert_service.reports":"Reporty","expert_service.stats":"Statistiky","expert_service.title":"Service","expert_service.xyz":"Servis","header.title":"Domovsk\xe1 str\xe1nka","header.title.app_messages":"Zpr\xe1vy","header.title.audit_log":"Audit Log","header.title.boiler":"Bojler","header.title.cloud_plugs":"Z\xe1suvky","header.title.dev":"Nastaven\xed s\xedt\u011B","header.title.dev.app_messages":"Notifikace","header.title.dev.az_routers":"AZ routery","header.title.dev.bez_dodavatele":"bezDodavatele","header.title.dev.cloud_plugs":"Cloudov\xe9 z\xe1suvky","header.title.dev.delta_green":"Delta Green","header.title.dev.electree":"Electree","header.title.dev.enerco":"Enerco","header.title.dev.energomachine":"Energomachine","header.title.dev.inverter_config":"Konfigurace st\u0159\xedda\u010D\u016F","header.title.dev.mqtt_broker":"MQTT Broker","header.title.dev.mqtt_cloud":"MQTT Cloud","header.title.dev.pre_flexibility":"PRE Flexibilita","header.title.dev.scripts":"Scripty","header.title.dev.shellies":"Shellies","header.title.dev.status_log":"Status log","header.title.dev.subscriptions":"P\u0159edplatn\xe9","header.title.dev_homepage":"V\xfdvojov\xe9 menu","header.title.ems":"EMS","header.title.ems_service":"EMS Service","header.title.energyMeters":"Elektrom\u011Bry","header.title.expert_service":"Expert Service","header.title.expert_service.network":"Nastaven\xed s\xedt\u011B","header.title.grid":"Distribu\u010Dn\xed s\xed\u0165","header.title.heat_pump":"Tepeln\xe9 \u010Derpadlo","header.title.photovoltaics":"Fotovoltaika","header.title.plug":"Z\xe1suvka","header.title.relay":"Rel\xe9","header.title.reports":"Reporty","header.title.rfid_cards":"RFID karty","header.title.settings":"Nastaven\xed","header.title.spot":"Spot","header.title.statistics":"Statistiky","header.title.thermostat":"Termostat","header.title.wallbox":"Wallbox","header.title.wallbox_list":"Wallboxy","header.title.wind":"V\u011Btrn\xe1 elektr\xe1rna","heat_pump.HW":"Oh\u0159ev tepl\xe9 vody","heat_pump.HW.actual_temp":"Aktu\xe1ln\xed teplota n\xe1dr\u017Ee","heat_pump.HW.flexitemp":"Flexibiln\xed teplota","heat_pump.HW.flexitemp.subtitle":"Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t teplou vodu","heat_pump.HW.hysteresis":"Hystereze oh\u0159evu tepl\xe9 vody","heat_pump.HW.on":"Oh\u0159ev tepl\xe9 vody","heat_pump.HW.temp":"Po\u017Eadovan\xe1 teplota n\xe1dr\u017Ee","heat_pump.acond":"Acond","heat_pump.blocked":"Blokace kompresoru","heat_pump.blocked.min_soc":"Blokace kompresoru p\u0159i nedostupn\xe9 s\xedti","heat_pump.blocked.min_soc_utility":"Blokace kompresoru p\u0159i dostupn\xe9 s\xedti","heat_pump.blocked.subtitle":"Nabit\xed baterie, od kter\xe9ho dojde k blokaci kompresoru p\u0159i dostupn\xe9 s\xedti","heat_pump.common":"Obecn\xe9 informace","heat_pump.common.power":"Aktu\xe1ln\xed odb\u011Br","heat_pump.common.power_today":"Dne\u0161n\xed spot\u0159eba:","heat_pump.common.power_year":"Ro\u010Dn\xed spot\u0159eba:","heat_pump.common.temp":"V\xfdstupn\xed teplota tepeln\xe9ho \u010Derpadla","heat_pump.common.total":"Celkov\xe1 spot\u0159eba","heat_pump.ecoone":"Ecoone","heat_pump.flexi":"Flexibilita energie","heat_pump.flexi.flexi_on":"Re\u017Eim flexibility","heat_pump.flexi.flexi_on.subtitle":"Re\u017Eim aktivuje p\u0159edeh\u0159ev z p\u0159ebytkov\xe9 energie","heat_pump.flexi.pvstability":"Potenci\xe1l aktivace kompresoru","heat_pump.flexi_sp":"Flexibilita spot","heat_pump.flexi_sp.flexi_increase_on":"Zv\xfd\u0161en\xed spot\u0159eby","heat_pump.flexi_sp.flexi_increase_on.subtitle":"Re\u017Eim umo\u017En\xed zv\xfd\u0161en\xed spot\u0159eby p\u0159i n\xedzk\xe9 cen\u011B energie","heat_pump.flexi_sp.flexi_reduce_on":"Odlo\u017Een\xed spot\u0159eby","heat_pump.flexi_sp.flexi_reduce_on.subtitle":"Re\u017Eim umo\u017En\xed odlo\u017Een\xed spot\u0159eby p\u0159i vysok\xe9 cen\u011B energie","heat_pump.nibe":"Nibe","heat_pump.room":"Vyt\xe1p\u011Bn\xed","heat_pump.room.equithermalCorrection":"Posun topn\xe9 k\u0159ivky","heat_pump.room.flexitemp":"Flexibiln\xed teplota","heat_pump.room.flexitemp.subtitle":"Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t nebo p\u0159edchladit d\u016Fm","heat_pump.room.on":"Vyt\xe1p\u011Bn\xed","heat_pump.room.tem":"Po\u017Eadovan\xe1 teplota","heat_pump.room.temp":"Aktu\xe1ln\xed teplota m\xedstnosti","heat_pump.room.tempmax":"Po\u017Eadovan\xe1 teplota komfort","heat_pump.room.tempmin":"Po\u017Eadovan\xe1 teplota \xfatlum","heat_pump.room_cool.on":"Chlazen\xed","heat_pump.status":"Re\u017Eim tepelka","heat_pump_wizard.cancel":"Zru\u0161it","heat_pump_wizard.ip_address.alert":"Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa tepeln\xe9ho \u010Derpadla nebude m\u011Bnit (nap\u0159. kdy\u017E T\u010C vyu\u017E\xedv\xe1 adresu z DHCP).","heat_pump_wizard.ip_address.input":"IP adresa tepeln\xe9ho \u010Derpadla","heat_pump_wizard.open":"Nastavit typ T\u010C","heat_pump_wizard.save":"Ulo\u017Eit","heat_pump_wizard.title":"Nastaven\xed tepeln\xe9ho \u010Derpadla","heatpump.statistics":"Statistiky","heatpump.status":"Re\u017Eim tepelka","homepage.actual.battery":"Stav baterie","homepage.actual.boiler":"Bojler","homepage.actual.outdoor_temperature":"Venkovn\xed teplota","homepage.actual.thermostat":"Termostat","homepage.actual.title":"","homepage.animation":"Aktu\xe1ln\u011B","homepage.statuses.title":"Re\u017Eimy aktivn\xedch komponent\u016F","homepage.statuses.tooltip":"Re\u017Eimy aktivn\xedch komponent\u016F","homepage.today.consumed":"Spot\u0159eba domu","homepage.today.consumed_WB":"Wallbox","homepage.today.consumed_from_grid":"Spot\u0159eba ze s\xedt\u011B","homepage.today.consumed_hp":"Tepeln\xe9 \u010Derpadlo","homepage.today.consumed_hw":"Tepl\xe1 voda","homepage.today.overflow":"P\u0159etok do s\xedt\u011B","homepage.today.photovoltaics":"V\xfdroba FVE","homepage.today.title":"Denn\xed statistika","homepage.today.wind":"V\xfdroba v\u011Btrn\xe9 elektr\xe1rny","hp.status.compressor_blocked":"Blokace kompresoru, n\xedzk\xfd stav baterie","hp.status.cooling":"Chlazen\xed","hp.status.heating":"Vyt\xe1p\u011Bn\xed","hp.status.hot_water":"Oh\u0159ev tepl\xe9 vody","hp.status.inactive":"Neaktivn\xed","hp.status.not_connected":"Nelze nav\xe1zat spojen\xed","hp.status.not_licensed":"Tepeln\xe9 \u010Derpadlo nen\xed licencovan\xe9","hp.status.pool":"Oh\u0159ev baz\xe9nu","hp.sub_status.consumption_postpone":"p\u0159i sn\xed\u017Een\xed spot\u0159eby","hp.sub_status.consumption_rise":"p\u0159i zv\xfd\u0161en\xed spot\u0159eby","hp.sub_status.consumption_with_flexibility":"s flexibilitou","hp.sub_status.nibe_not_writable":"- do NIBE nelze zapisovat","hp.sub_status.none":"","initial_wizard.banner.button":"Spustit pr\u016Fvodce","initial_wizard.banner.hide.confirm":"Opravdu chcete skr\xfdt pr\u016Fvodce?","initial_wizard.banner.hide.confirm.description":"Pr\u016Fvodce m\u016F\u017Eete kdykoli znovu spustit v nastaven\xed aplikace.","initial_wizard.banner.hide.show_more":"Spustit pr\u016Fvodce","initial_wizard.banner.hide.yes":"Skr\xfdt","initial_wizard.banner.subtitle":"Pr\u016Fvodce v\xe1m pom\u016F\u017Ee nastavit z\xe1kladn\xed parametry va\u0161eho syst\xe9mu.","initial_wizard.banner.title":"Dokon\u010Dete po\u010D\xe1te\u010Dn\xed nastaven\xed","initial_wizard.banner.title.completed":"Proj\xedt po\u010D\xe1te\u010Dn\xed nastaven\xed","initial_wizard.dialog.finish":"Dokon\u010Dit","initial_wizard.dialog.next":"Dal\u0161\xed","initial_wizard.dialog.prev":"Zp\u011Bt","initial_wizard.dialog.step":"Krok {current} z {total}","initial_wizard.dialog.title":"Pr\u016Fvodce po\u010D\xe1te\u010Dn\xedm nastaven\xedm","initial_wizard.step1.description.active":"V\xe1\u0161 p\u0159\xedstup do servisu je ji\u017E aktivn\xed. M\u016F\u017Eete pokra\u010Dovat na dal\u0161\xed krok.","initial_wizard.step1.password_info":"Ka\u017Ed\xe1 firma m\xe1 vlastn\xed p\u0159\xedstupov\xe9 heslo do servisn\xedho menu. Heslo jste obdr\u017Eeli v emailov\xe9 komunikaci. M\u016F\u017Eete si jej tak\xe9 kdykoliv zobrazit v app.infigy.cz v partnersk\xe9 sekci.","initial_wizard.step1.title":"P\u0159\xedstup do servisu","initial_wizard.step1.welcome":"V\xedtejte v \xfavodn\xedm nastaven\xed Infigy. Provedeme v\xe1s z\xe1kladn\xed konfigurac\xed va\u0161eho syst\xe9mu. Detailn\u011Bj\u0161\xed nastaven\xed pot\xe9 najdete v servisn\xedm menu.","initial_wizard.step10.title":"Nastaven\xed wallboxu","initial_wizard.step11.description":"Pro\u0161li jste z\xe1kladn\xed nastaven\xed Infigy. Ve\u0161ker\xe9 parametry lze upravit v servisn\xedm menu.","initial_wizard.step11.service_menu.subtitle":"Nastaven\xed -> \xfapln\u011B dol\u016F -> P\u0159\xedstup do servisu","initial_wizard.step11.service_menu.title":"Servisn\xed menu","initial_wizard.step11.title":"Hotovo","initial_wizard.step2.title":"Aktualizace aplikace","initial_wizard.step3.title":"Instalace","initial_wizard.step4.title":"Nastaven\xed hlavn\xedho jisti\u010De","initial_wizard.step5.title":"P\u0159ipojen\xed st\u0159\xedda\u010De","initial_wizard.step6.title":"Parametry st\u0159\xedda\u010De","initial_wizard.step7.description":"Pokud je omezen p\u0159etok do s\xedt\u011B, dojde k p\u0159enesen\xed nastaven\xed do st\u0159\xedda\u010De. Omezov\xe1n\xed p\u0159etok\u016F zaji\u0161tuje st\u0159\xedda\u010D. Z\xe1pis a zm\u011Bnu hodnoty v\u0161ak \u0159\xedd\xed Infigy dle zadan\xe9 hodnoty v tomto poli. Neupravujte tedy omezen\xed p\u0159etoku ve st\u0159\xedda\u010Di. P\u0159i prvn\xedm nastaven\xed si zapsanou hodnotu zkontrolujte ve st\u0159\xedda\u010Di, zda se V\xe1m spr\xe1vn\u011B prom\xedtla z Infigy do st\u0159\xedda\u010De.","initial_wizard.step7.title":"Omezen\xed p\u0159etoku","initial_wizard.step8.title":"Nastaven\xed bojleru","initial_wizard.step9.title":"Nastaven\xed spotov\xe9ho obchodov\xe1n\xed","initial_wizard.step_app_update.description":"V \u010Dase kdy bylo Infigy na cest\u011B k v\xe1m jsme mohli vydat nov\xe9 verze aplikace. Doporu\u010Dujeme p\u0159ed nastaven\xedm jednotku aktualizovat. Pokud ale nap\u0159\xedklad nen\xed dostupn\xfd internet, m\u016F\u017Eete aktualizaci p\u0159esko\u010Dit a prov\xe9st ji pozd\u011Bji v servisn\xedm menu, nebo v port\xe1lu.","inverter.3mar_plc":"3Mar PLC","inverter.az_router":"AzRouter elektrom\u011Br","inverter.des_battery_container":"DES - kontejnerov\xe9 \xfalo\u017Ei\u0161t\u011B","inverter.deye":"Deye LV","inverter.deye_hv":"Deye HV","inverter.fronius":"Fronius SYMO GEN24","inverter.fronius_grid":"Fronius SYMO s\xed\u0165ov\xfd","inverter.fronius_verto":"Fronius Verto","inverter.good_we":"GoodWe","inverter.good_we_grid_next":"GoodWe s\xed\u0165ov\xfd","inverter.good_we_next":"GoodWe","inverter.goodwe_grid":"Goodwe s\xed\u0165ov\xfd","inverter.hes":"HES - bateriov\xe9 \xfalo\u017Ei\u0161t\u011B","inverter.next":"V\xedce st\u0159\xedda\u010D\u016F","inverter.none":"\u017D\xe1dn\xfd","inverter.sermatec":"Sermatec","inverter.shellies":"Shellies","inverter.shellies_external":"Shellies External","inverter.sma_grid":"SMA s\xed\u0165ov\xfd","inverter.sofar_solar":"Sofarsolar","inverter.sofar_solar_rs485":"SofarSolar RS485","inverter.solar_edge_grid":"SolarEdge s\xed\u0165ov\xfd","inverter.solax":"Solax","inverter.solax_ems1000":"Solax EMS1000","inverter.solax_ems1000pro":"Solax EMS1000PRO","inverter.solax_grid":"Solax s\xed\u0165ov\xfd","inverter.solax_mega_grid":"Solax MEGA/FORTH s\xed\u0165ov\xfd","inverter.solax_mic_grid":"Solax MIC s\xed\u0165ov\xfd","inverter.solax_next":"SolaxNext","inverter.solinteg":"Solinteg","inverter.victron":"Victron","inverter.wattsonic":"Wattsonic","inverter_wizard.cancel":"Zru\u0161it","inverter_wizard.custom_device_ip_address.alert":"Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa st\u0159\xedda\u010De nebude m\u011Bnit (nap\u0159. kdy\u017E st\u0159\xedda\u010D vyu\u017E\xedv\xe1 adresu z DHCP).","inverter_wizard.custom_device_ip_address.input":"IP adresa st\u0159\xedda\u010De","inverter_wizard.multiple_inverters.alert":"Pro nastaven\xed v\xedce st\u0159\xedda\u010D\u016F pros\xedm kontaktujte linku podpory. Kontakt najdete v technick\xe9 wiki Infigy.","inverter_wizard.multiple_inverters.label":"V\xedce st\u0159\xedda\u010D\u016F","inverter_wizard.multiple_inverters_or_ems.alert":"V\xe1\u0161 syst\xe9m ji\u017E obsahuje nastaven\xed pro v\xedce st\u0159\xedda\u010D\u016F nebo EMS. Tento pr\u016Fvodce je ur\u010Den pouze pro nastaven\xed jednoho st\u0159\xedda\u010De. Pro zm\u011Bnu nastaven\xed st\u0159\xedda\u010D\u016F nebo EMS pros\xedm kontaktujte podporu.","inverter_wizard.nominal_power":"Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De","inverter_wizard.nominal_power.helper":"Rozsah: 1 a\u017E 100 kW","inverter_wizard.nominal_power.validation":"Zadejte nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De v kW.","inverter_wizard.open":"Naj\xedt st\u0159\xedda\u010D","inverter_wizard.save":"Ulo\u017Eit","inverter_wizard.scan":"Naj\xedt st\u0159\xedda\u010D na s\xedti","inverter_wizard.scanning":"Hled\xe1m st\u0159\xedda\u010D na s\xedti","inverter_wizard.submit_error":"Nastala chyba p\u0159i ukl\xe1d\xe1n\xed nastaven\xed st\u0159\xedda\u010De. Zkuste to pros\xedm znovu.","inverter_wizard.title":"Pr\u016Fvodce p\u0159ipojen\xedm st\u0159\xedda\u010De","layout.disconnected":"Odpojeno","layout.pigpio_init_error_dialog.description":"Aplikace Infigy na za\u0159\xedzen\xed nenab\u011Bhla spr\xe1vn\u011B. Zkuste pros\xedm za\u0159\xedzen\xed restartovat a pokud probl\xe9m p\u0159etrv\xe1v\xe1, kontaktujte podporu.","layout.pigpio_init_error_dialog.title":"Chyba p\u0159i spu\u0161t\u011Bn\xed aplikace","level.thermostat.cooling":"Chlazen\xed","level.thermostat.deactivated":"Neaktivn\xed","level.thermostat.heating":"Vyt\xe1p\u011Bn\xed","level.thermostat.standby":"Standby","level.thermostat.tempErr":"Chyba Teploty","level.thermostatFlexibility.increasePv":"Flexibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle fotovoltaiky","level.thermostatFlexibility.increaseSpot":"Flexibilita vyu\u017Eita pro zv\xfd\u0161en\xed teploty dle SPOTU","level.thermostatFlexibility.normal":"Norm\xe1ln\xed","level.thermostatFlexibility.reductionSpot":"Flexibilita vyu\u017Eita pro sn\xed\u017Een\xed teploty dle SPOTU","mqtt_broker.connected_clients.title":"Clients","mqtt_broker.enabled":"Zapnuto","mqtt_broker.running":"Stav","mqtt_broker.title":"MQTT Broker","mqtt_cloud.connected":"Stav","mqtt_cloud.connected.offline":"Offline","mqtt_cloud.connected.online":"Online","mqtt_cloud.enabled":"Integrace zapnuta","mqtt_cloud.title":"MQTT Cloud","nav.app_messages":"Zpr\xe1vy","nav.home":"Dom\u016F","nav.logout":"Odhl\xe1sit se","nav.reports":"Reporty","nav.sec.boiler":"Bojler","nav.sec.cloud_plugs":"Z\xe1suvky","nav.sec.ems":"EMS","nav.sec.energyMeters":"Elektrom\u011Bry","nav.sec.grid":"S\xed\u0165","nav.sec.heatpump":"Tepeln\xe9 \u010Derpadlo","nav.sec.home":"Obecn\xe9","nav.sec.photovoltaics":"Fotovoltaika","nav.sec.plug":"Z\xe1suvka","nav.sec.relay":"Rel\xe9","nav.sec.spot":"Spot","nav.sec.thermostat":"Termostat","nav.sec.wallbox":"Wallbox","nav.sec.wind":"V\u011Btrn\xe1 elektr\xe1rna","nav.settings":"Nastaven\xed","nav.statistics":"Statistiky","network.ethernet_ports":"Ethernet porty","network.ethernet_ports.name":"LAN","network.ethernet_ports.status":"Status","network.ethernet_ports.status.down":"Neaktivn\xed","network.ethernet_ports.status.up":"Aktivn\xed","network.scan.error":"Skenov\xe1n\xed s\xedt\u011B se nezda\u0159ilo","network.summary.address":"IP adresa","network.summary.dhcp_host_exists":"Adresa zafixov\xe1na na DHCP. Kliknut\xedm odfixovat.","network.summary.error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed","network.summary.heat_pump":"Tepeln\xe9 \u010Derpadlo","network.summary.inverter":"St\u0159\xedda\u010D","network.summary.mac":"MAC","network.summary.name":"Jm\xe9no","network.summary.no_dhcp_host":"Dynamick\xe1 adresa na DHCP. Kliknut\xedm zafixovat.","network.summary.not_connected":"Nen\xed p\u0159ipojeno","network.title":"Obecn\xe9","network.wan_address":"WAN adresa","network_wan_edit.dialog.address":"IP adresa","network_wan_edit.dialog.close":"Zav\u0159\xedt","network_wan_edit.dialog.dns":"DNS server","network_wan_edit.dialog.gateway":"V\xfdchoz\xed br\xe1na","network_wan_edit.dialog.netmask":"Maska s\xedt\u011B","network_wan_edit.dialog.save":"Ulo\u017Eit","network_wan_edit.dialog.title":"Editace WAN adresy","nmap.empty":"Nic nenalezeno","nmap.error":"Sken se nezda\u0159il","nmap.loading":"Skenuji","nmap.output":"V\xfdstup","nmap.port":"Port","nmap.port.help":"Pr\xe1zdn\xe9 = jen hled\xe1n\xed za\u0159\xedzen\xed","nmap.range.external":"external \u2014 s\xed\u0165 z\xe1kazn\xedka","nmap.range.internal":"internal \u2014 intern\xed s\xed\u0165 Infigy","nmap.result.address":"IP adresa","nmap.result.mac":"MAC adresa","nmap.result.ports":"Porty","nmap.result.scanning":"Skenuji {target}, m\u016F\u017Ee to chv\xedli trvat\u2026","nmap.result.target":"Skenovan\xfd rozsah: {target}","nmap.result.vendor":"V\xfdrobce","nmap.start":"Spustit","nmap.target":"Adresa nebo rozsah","nmap.target.help":"Pojmenovan\xe1 s\xed\u0165 nebo IP / rozsah","nmap.title":"Sken port\u016F","photovoltaics.battery":"Baterie","photovoltaics.battery.battery_charged":"Nabit\xed baterie","photovoltaics.battery.battery_manual_discharge":"Manu\xe1ln\u011B vyb\xedt baterii","photovoltaics.battery.battery_power":"V\xfdkon baterie","photovoltaics.battery.soc_actual":"Vypo\u010Dten\xe9 minim\xe1ln\xed nabit\xed","photovoltaics.batteryStatus":"Stav BMS","photovoltaics.battery_stop":"Blokace baterie","photovoltaics.battery_stop.hdo":"Vyb\xedjet baterii pouze p\u0159i n\xedzk\xe9m tarifu (HDO)","photovoltaics.battery_stop.hp":"Blokovat baterii p\u0159i provozu tepeln\xe9ho \u010Derpadla","photovoltaics.battery_stop.hw":"Blokovat baterii p\u0159i provozu oh\u0159evu vody","photovoltaics.battery_stop.wb":"Blokovat baterii p\u0159i provozu wallboxu","photovoltaics.battery_stop.wb.lock_desc":"P\u0159i zapnut\xe9m re\u017Eimu nab\xedjen\xed wallboxu \u201ENab\xedjen\xed podle baterie\u201C nebo \u201EP\u0159ednostn\xed nab\xedjen\xed podle baterie\u201C nelze tuto blokaci zapnout. Pro zapnut\xed blokace nastavte jin\xfd re\u017Eim nab\xedjen\xed wallboxu.","photovoltaics.battery_stop.wb.lock_title":"Nastaven\xed nelze zm\u011Bnit","photovoltaics.common":"Obecn\xe9 informace","photovoltaics.common.battery_manual_charge":"Manu\xe1ln\u011B nab\xedt baterii","photovoltaics.common.battery_manual_charge_soc":"C\xedlov\xe9 SOC pro manu\xe1ln\xed nab\xedjen\xed","photovoltaics.common.battery_manual_charge_subtitle":"Manu\xe1ln\xed nab\xedjen\xed baterie nabije baterii na c\xedlovou \xfarove\u0148 nabit\xed pokud nedojde k d\u0159\xedv\u011Bj\u0161\xedmu vypnut\xed u\u017Eivatelem.","photovoltaics.common.battery_manual_discharge_subtitle":"Manu\xe1ln\xed vyb\xedjen\xed baterie vybije baterii na minim\xe1ln\xed \xfarove\u0148 nabit\xed pokud nedojde k d\u0159\xedv\u011Bj\u0161\xedmu vypnut\xed u\u017Eivatelem.","photovoltaics.common.power":"Aktu\xe1ln\xed v\xfdkon","photovoltaics.common.power_today":"Dne\u0161n\xed v\xfdroba:","photovoltaics.common.power_total":"Celkov\xe1 v\xfdroba","photovoltaics.common.power_year":"Ro\u010Dn\xed v\xfdroba:","photovoltaics.common.string1":"String 1:","photovoltaics.common.string2":"String 2:","photovoltaics.common.string3":"String 3:","photovoltaics.common.string4":"String 4:","photovoltaics.common.string5":"String 5:","photovoltaics.common.string6":"String 6:","photovoltaics.statistics":"V\xfdkon elektr\xe1rny","photovoltaics.statistics.charge":"Nab\xedjen\xed baterie","photovoltaics.statistics.discharge":"Vyb\xedjen\xed baterie","photovoltaics.statisticsSoc":"\xdarove\u0148 nabit\xed baterie","photovoltaics.status":"Re\u017Eim FVE","ping.address":"Adresa","ping.output":"V\xfdstup","ping.start":"Spustit","ping.stop":"Zastavit","ping.title":"Ping","plug.bat":"\u0158\xedzen\xed podle baterie","plug.bat.batterySart":"Zapnout p\u0159i nabit\xed","plug.bat.batterySart.help":"\xdarove\u0148 nabit\xed baterie, p\u0159i kter\xe9m se z\xe1suvka zapne. Aby k zapnut\xed do\u0161lo, mus\xed doj\xedt k p\u0159echodu nabit\xed baterie z nastaven\xe9ho stavu na vy\u0161\u0161\xed stav. Pokud je hodnota nastavena na 80%, tak z\xe1suvka sepne p\u0159i nabit\xed baterie ze 80% na 81%.","plug.bat.batterySart.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se aktivuje z\xe1suvka","plug.bat.batteryStop":"Vypnout p\u0159i nabit\xed","plug.bat.batteryStop.help":"\xdarove\u0148 nabit\xed baterie, p\u0159i kter\xe9m se z\xe1suvka vypne. Aby k vypnut\xed do\u0161lo, mus\xed doj\xedt k p\u0159echodu nabit\xed baterie z nastaven\xe9ho na ni\u017E\u0161\xed stav. Pokud je hodnota nastavena na 80%, tak z\xe1suvka vypne p\u0159i vybit\xed baterie ze 80% na 79%.","plug.bat.batteryStop.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se vypne z\xe1suvka","plug.bat.help":"Sp\xedn\xe1n\xed p\u0159i definovan\xe9 \xfarovni nabit\xed baterie. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed.","plug.bat.on":"Aktivn\xed","plug.main":"Obecn\xe9 informace","plug.main.consumption":"Aktu\xe1ln\xed spot\u0159eba","plug.main.power":"Celkov\xe1 spot\u0159eba","plug.main.power_today":"Dne\u0161n\xed spot\u0159eba:","plug.main.power_year":"Ro\u010Dn\xed spot\u0159eba:","plug.main.stat":"Statistiky","plug.overflow":"\u0158\xedzen\xed podle p\u0159etoku","plug.overflow.consumption":"Nastaven\xed odpov\xedd\xe1 spot\u0159ebi\u010Di s p\u0159\xedkonem","plug.overflow.help":"Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed.","plug.overflow.on":"Aktivn\xed","plug.overflow.startPower":"Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B","plug.overflow.startPower.help":"Z\xe1suvka se zapne, pokud je p\u0159etok v nastaven\xe9 v\xfd\u0161i po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na - 1500W a zpo\u017Ed\u011Bn\xed zapnut\xed je 5 minut, tak z\xe1suvka sepne p\u0159i p\u0159etoku do s\xedt\u011B ve v\xfd\u0161i alespo\u0148 1500W po dobu 5 minut.","plug.overflow.startPower.subtitle":"Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br","plug.overflow.stopPower":"Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B","plug.overflow.stopPower.help":"Z\xe1suvka se vypne, pokud je odb\u011Br vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na 100W a zpo\u017Ed\u011Bn\xed vypnut\xed je 5 minut, tak z\xe1suvka vypne p\u0159i odb\u011Bru ze s\xedt\u011B ve v\xfd\u0161i minim\xe1ln\u011B 100W po dobu 5 minut.","plug.overflow.stopPower.subtitle":"Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br","plug.overflow.time":"Zpo\u017Ed\u011Bn\xed zapnut\xed a vypnut\xed","plug.overflow.time.help":"Tento parametr slou\u017E\xed pro definici zpo\u017Ed\u011Bn\xed zapnut\xed a vypnut\xed z\xe1suvky p\u0159i definovan\xfdch p\u0159etoc\xedch/odb\u011Brech. Vhodn\xe9 pro nastaven\xed priority a eliminace \u010Dast\xe9ho sp\xedn\xe1n\xed z\xe1suvky. Zad\xe1vejte ve form\xe1tu HH:MM.","plug.plug":"Z\xe1suvka","plug.spot":"\u0158\xedzen\xed podle spotov\xe9 ceny","plug.spot.15m.period":"Perioda spotov\xe9 ceny","plug.spot.15m.period.subtitle":"15 minutov\xe9 intervaly","plug.spot.help":"Sp\xedn\xe1n\xed p\u0159i definovan\xe9 spotov\xe9 cen\u011B. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed.","plug.spot.on":"Aktivn\xed","plug.spot.period":"Perioda spotov\xe9 ceny","plug.spot.period.subtitle":"60 minutov\xe9 intervaly","plug.spot.price.period":"\u010Casov\xe9 rozli\u0161en\xed z\xe1suvky","plug.spot.spotHi":"Aktivovat p\u0159i vysok\xe9 cen\u011B","plug.spot.spotHi.help":"Z\xe1suvka se zapne, pokud je cena spotu na vysok\xe9 \xfarovni viz z\xe1lo\u017Eka Spot.","plug.spot.spotLow":"Aktivovat p\u0159i n\xedzk\xe9 cen\u011B","plug.spot.spotLow.help":"Z\xe1suvka se zapne, pokud je cena spotu na n\xedzk\xe9 \xfarovni viz z\xe1lo\u017Eka Spot.","plug.spot.spotMi":"Aktivovat p\u0159i st\u0159edn\xed cen\u011B","plug.spot.spotMi.help":"Z\xe1suvka se zapne, pokud je cena spotu na st\u0159edn\xed \xfarovni viz z\xe1lo\u017Eka Spot.","plug.spot.spot_above_price":"Aktivovat p\u0159i vy\u0161\u0161\xed ne\u017E nastaven\xe9 cen\u011B","plug.spot.spot_above_price.help":"Z\xe1suvka se aktivuje, pokud je cena spotu vy\u0161\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu.","plug.spot.spot_above_price.subtitle":"Pokud je cena spotu vy\u0161\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je ni\u017E\u0161\xed, dojde k rozepnut\xed.","plug.spot.spot_below_price":"Aktivovat p\u0159i ni\u017E\u0161\xed ne\u017E nastaven\xe9 cen\u011B","plug.spot.spot_below_price.help":"Z\xe1suvka se aktivuje, pokud je cena spotu ni\u017E\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu.","plug.spot.spot_below_price.subtitle":"Pokud je cena spotu ni\u017E\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je vy\u0161\u0161\xed, dojde k rozepnut\xed.","plug.spot.spot_neg":"Aktivovat p\u0159i z\xe1kazu p\u0159etok\u016F do s\xedt\u011B","plug.spot.spot_neg.help":"Z\xe1suvka se aktivuje, pokud je zak\xe1z\xe1n p\u0159etok do s\xedt\u011B viz pl\xe1n spotov\xe9ho obchodov\xe1n\xed.","plug.status":"Re\u017Eim z\xe1suvky","plug.summary.price":"Cena","plug.summary.price_level":"Hladina ceny","plug.summary.price_level_15m":"Hladina ceny 15m","plug.summary.switch":"Sepnut\xed z\xe1suvky","plug.summary.time":"\u010Cas","plug.time":"\u0158\xedzen\xed podle \u010Dasu","plug.time.help":"Sp\xedn\xe1n\xed p\u0159i definovan\xe9m \u010Dase. Lze kombinovat s ostatn\xedmi podm\xednkami dle baterie (mus\xed b\xfdt nainstalov\xe1na baterie), spotov\xe9 ceny (mus\xed b\xfdt povoleno spotov\xe9 obchodov\xe1n\xed) a p\u0159etoku (mus\xed b\xfdt povolen p\u0159etok do DS). P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed.","plug.time.on":"Aktivn\xed","plug.time.turn_off":"Vypnout v \u010Dase","plug.time.turn_off.help":"\u010Cas, ve kter\xe9m se z\xe1suvka vypne. Pokud je nastaveno na 12:00, tak se z\xe1suvka vypne p\u0159esn\u011B v nastaven\xfd \u010Das 12:00.","plug.time.turn_on":"Zapnout v \u010Dase","plug.time.turn_on.help":"\u010Cas, ve kter\xe9m se z\xe1suvka zapne. Pokud je nastaveno na 12:00, tak se z\xe1suvka zapne p\u0159esn\u011B v nastaven\xfd \u010Das 12:00.","plug.turn_off":"Vypnout","plug.turn_on":"Zapnout","pre_flexibility.business_flexibility.title":"Obchodn\xed flexibilita","pre_flexibility.enabled":"Integrace zapnuta","pre_flexibility.title":"PRE Flexibilita","premium.banner.active.button":"Spravovat p\u0159edplatn\xe9","premium.banner.active.dev_mode":"P\u0159edplatn\xe9 je aktivn\xed pro v\xfdvoj","premium.banner.active.subtitle":"P\u0159edplatn\xe9 Infigy Plus je aktivn\xed. M\u016F\u017Eete si u\u017E\xedvat v\u0161ech vychyt\xe1vek, kter\xe9 jsou d\xedky n\u011Bmu v aplikaci nav\xedc.","premium.banner.active.title":"Moje Infigy Plus","premium.banner.hide.confirm":"Opravdu chcete skr\xfdt Infigy Plus?","premium.banner.hide.confirm.description":"Kdykoliv m\u016F\u017Eete Infigy Plus znovu prozkoumat v nastaven\xed aplikace.","premium.banner.hide.later":"P\u0159ipomenout pozd\u011Bji","premium.banner.hide.show_more":"Zjistit v\xedce","premium.banner.hide.yes":"Skr\xfdt","premium.banner.inactive.button":"Zjistit v\xedce","premium.banner.inactive.subtitle":"Posu\u0148te svou spr\xe1vu energi\xed na je\u0161t\u011B vy\u0161\u0161\xed \xfarove\u0148. S Infigy Plus dostanete dal\u0161\xed chytr\xe9 n\xe1stroje - detailn\xed grafy, okam\u017Eit\xe9 notifikace, vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1\u0159, p\u0159ehledn\xe9 reporty a dal\u0161\xed.","premium.banner.inactive.title":"Infigy Plus nen\xed aktivn\xed","premium.dialog.charts.subtitle":"Z\xedskejte mo\u017Enost sledovat v\xfdkon jednotliv\xfdch string\u016F, spot\u0159ebu dle f\xe1z\xed a dal\u0161\xed podrobn\xe9 informace.","premium.dialog.charts.title":"Detailn\xed grafy","premium.dialog.notifications.subtitle":"Z\xedsk\xe1vejte notifikace o z\xe1porn\xfdch cen\xe1ch, nabit\xe9 baterii a dal\u0161\xedch ud\xe1lostech","premium.dialog.notifications.title":"Notifikace","premium.dialog.other_benefits.subtitle":"P\u0159ipravujeme spoustu dal\u0161\xedch benefit\u016F, kter\xe9 budeme postupn\u011B uvol\u0148ovat pro p\u0159edplatitele Infigy Plus","premium.dialog.other_benefits.title":"Dal\u0161\xed benefity p\u0159ijdou brzy","premium.dialog.reports.subtitle":"Detailn\xed m\u011Bs\xed\u010Dn\xed reporty, kter\xe9 v\xe1m poskytnou jasn\xfd obraz o v\xfdrob\u011B, spot\u0159eb\u011B a vyu\u017Eit\xed energie ve va\u0161\xed dom\xe1cnosti. V\u0161echny d\u016Fle\u017Eit\xe9 \xfadaje m\xe1te na jednom m\xedst\u011B - srozumiteln\u011B, p\u0159ehledn\u011B a dopln\u011Bn\xe9 grafy.","premium.dialog.reports.title":"Pokro\u010Dil\xe9 reporty","premium.dialog.save":"P\u0159edplatit Infigy Plus","premium.dialog.schedule.subtitle":"Napl\xe1nujte si ru\u010Dn\u011B nab\xedjen\xed \u010Di vyb\xedjen\xed baterie dle pot\u0159eby","premium.dialog.schedule.title":"Vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1\u0159","premium.dialog.spot.subtitle":"Z\xedsktejte mo\u017Enost nahl\xe9dnout do historie spotov\xfdch cen a pl\xe1n\u016F, kter\xe9 Infigy v minulosti p\u0159ipravilo","premium.dialog.spot.title":"Historie spotov\xfdch cen","protocol.settings":"Nastaven\xed","protocol.settings.Licence":"Licence","protocol.settings.distribution":"Distribuce","protocol.test":"Test za\u0159\xedzen\xed","protocol.test.internet-connect":"P\u0159ipojen\xed k internetu","protocol.test.inverter-connect":"P\u0159ipojen\xed st\u0159\xedda\u010De","protocol.test.phase_1":"Test 1. f\xe1ze","protocol.test.phase_2":"Test 2. f\xe1ze","protocol.test.phase_3":"Test 3. f\xe1ze","protocol.test.tester":"Za\u0159\xedzen\xed otestoval","relay.condition":"Podm\xednka sp\xedn\xe1n\xed","relay.main":"Obecn\xe9 informace","relay.name":"N\xe1zev rel\xe9","relay.spot.diagram":"Sp\xedn\xe1n\xed podle spotov\xe9 ceny","relay.status":"Sepnuto","relay.summary.switch":"Sepnut\xed rel\xe9","relay.title":"Rel\xe9","report.avg_day_chart.battery_soc":"Nabit\xed baterie","report.avg_day_chart.consumption":"Spot\u0159eba","report.avg_day_chart.grid":"Distribu\u010Dn\xed s\xed\u0165","report.avg_day_chart.pv_production":"V\xfdroba FVE","report.not_generated":"Vytvo\u0159it report kliknut\xedm","report_test.button":"Test","report_test.date":"M\u011Bs\xedc (nap\u0159. 2025-09)","report_test.generated":"Report vygenerov\xe1n","report_test.ok":"OK","report_test.test":"Test","reports.accumulation_increased":"Zv\xfd\u0161en\xed akumulace","reports.average_water_temperature":"Pr\u016Fm\u011Brn\xe1 teplota vody","reports.avg_day":"Pr\u016Fmern\xfd den","reports.battery":"Baterie","reports.boiler":"Bojler","reports.building_consumption":"Spot\u0159eba objektu","reports.disclaimer":"Uveden\xe9 hodnoty maj\xed pouze informativn\xed charakter a mohou se li\u0161it od ofici\xe1ln\xedch ode\u010Dt\u016F distributora.","reports.energy_estimate":"Odhad energi\xed bez \u0159\xedzen\xed","reports.estimated_water_amount":"Odhadovan\xe9 mno\u017Estv\xed vody","reports.grid_consumption":"Odb\u011Br ze s\xedt\u011B","reports.grid_consumption_hp":"Spot\u0159eba ze s\xedt\u011B","reports.grid_consumption_hw":"Spot\u0159eba ze s\xedt\u011B","reports.grid_consumption_wallbox":"Spot\u0159eba ze s\xedt\u011B","reports.heat_pump":"Tepeln\xe9 \u010Derpadlo","reports.household_consumption":"Spot\u0159eba dom\xe1cnosti","reports.info":"Obecn\xe9 info","reports.kilometers_driven":"Po\u010Det ujet\xfdch km","reports.kilometers_driven_from_sun":"Po\u010Det ujet\xfdch km ze slunce","reports.maximum_power":"Maxim\xe1ln\xed v\xfdkon","reports.monthly_consumption":"M\u011Bs\xed\u010Dn\xed spot\u0159eba","reports.monthly_production":"M\u011Bs\xed\u010Dn\xed v\xfdroba","reports.pv":"Fotovoltaick\xe1 elektr\xe1rna","reports.pv_consumption":"Spot\u0159eba z FVE","reports.pv_production":"V\xfdroba FVE","reports.regenerate_report":"Znovu vygenerovat report","reports.regenerate_report_confirm_title":"Znovu vygenerovat report?","reports.rfid_cards":"RFID karty","reports.self_consumption":"Vlastn\xed vyu\u017Eit\xed energie","reports.self_sufficiency":"Sob\u011Bsta\u010Dnost","reports.self_sufficient_days":"Po\u010Det sob\u011Bsta\u010Dn\xedch dn\xed","reports.share.description":"Vybran\xfd sn\xedmek m\u016F\u017Eete sd\xedlet s ostatn\xedmi.","reports.share.share":"Sd\xedlet report","reports.share.title":"Sd\xedlet report","reports.share_report":"Sd\xedlet report","reports.sold_to_distribution_grid":"Prod\xe1no do distribu\u010Dn\xed s\xedt\u011B","reports.stored_energy_from_grid":"Ulo\u017Een\xe1 energie ze s\xedt\u011B","reports.stored_energy_from_pv":"Ulo\u017Een\xe1 energie z FVE","reports.stored_energy_to_battery":"Ulo\u017Een\xe1 energie do baterie","reports.stored_energy_to_boiler":"Ulo\u017Een\xe1 energie do bojleru","reports.stored_energy_to_heat_pump":"Ulo\u017Een\xe1 energie do T\u010C","reports.stored_energy_to_wallbox":"Ulo\u017Een\xe1 energie do wallboxu","reports.total_overflow_to_grid":"Celkov\xfd p\u0159etok do s\xedt\u011B","reports.total_purchase_from_grid":"Celkov\xfd n\xe1kup ze s\xedt\u011B","reports.total_with_control":"Celkem s \u0159\xedzen\xedm","reports.total_without_control":"Celkem bez \u0159\xedzen\xed","reports.updated_at":"Vygenerov\xe1no {date}","reports.wallbox":"Wallbox","rfid_cards.col.consumption":"Spot\u0159eba","rfid_cards.col.created_at":"P\u0159id\xe1no","rfid_cards.col.id":"ID karty","rfid_cards.col.name":"N\xe1zev","rfid_cards.export":"Exportovat CSV","rfid_cards.from":"Od","rfid_cards.no_cards":"\u017D\xe1dn\xe9 karty nebyly p\u0159id\xe1ny","rfid_cards.title":"RFID karty","rfid_cards.to":"Do","save":"Ulo\u017Eit","schedules.add":"P\u0159idat pl\xe1n","schedules.battery_charge":"Nab\xedjen\xed baterie","schedules.battery_discharge":"Vyb\xedjen\xed baterie","schedules.charging_current":"Nab\xedjec\xed proud: {chargingCurrent} A","schedules.description":"Napl\xe1nujte si vybit\xed nebo nabit\xed baterie podle pot\u0159eby.","schedules.dialog.title":"Vytvo\u0159it pl\xe1n","schedules.dialog.title.ev":"Vytvo\u0159it pl\xe1n nab\xedjen\xed","schedules.ev_charging":"Nab\xedjen\xed elektromobilu","schedules.form.action":"Akce","schedules.form.battery_charge":"Nab\xedt\xed baterie","schedules.form.battery_discharge":"Vybit\xed baterie","schedules.form.charging-current":"Nastavit nab\xedjec\xed proud","schedules.form.charging-current.auto":"V\xfdchoz\xed","schedules.form.create":"Vytvo\u0159it","schedules.form.duration":"D\xe9lka","schedules.form.ev_charging":"Nab\xedjen\xed elektromobilu","schedules.form.frequency":"Frekvence","schedules.form.frequency.daily":"Denn\u011B","schedules.form.frequency.monthly":"M\u011Bs\xed\u010Dn\u011B","schedules.form.frequency.weekly":"T\xfddn\u011B","schedules.form.interval.biweekly":"Ka\u017Ed\xe9 2 t\xfddny","schedules.form.preview.hide":"Skr\xfdt n\xe1hled","schedules.form.preview.show":"Zobrazit pl\xe1novan\xe9 v\xfdskyty","schedules.form.preview.title":"Pl\xe1novan\xe1 spu\u0161t\u011Bn\xed ({count} n\xe1sleduj\xedc\xedch)","schedules.form.recurring":"Opakuj\xedc\xed se","schedules.form.target-soc":"Cilov\xe9 SOC (voliteln\xe9)","schedules.form.until":"Opakovat do (voliteln\xe9)","schedules.form.when":"Kdy","schedules.loading.error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed pl\xe1n\u016F","schedules.missed":"Neprob\u011Bhlo","schedules.no_plans_found":"\u017D\xe1dn\xe9 pl\xe1ny nebyly nalezeny.","schedules.processed":"Prob\u011Bhlo","schedules.remove.confirm":"Opravdu chcete pl\xe1n smazat?","schedules.remove.no":"Zru\u0161it","schedules.remove.recurring.instance":"Smazat pouze tento v\xfdskyt","schedules.remove.recurring.series":"Smazat celou s\xe9rii","schedules.remove.recurring.title":"Smazat opakuj\xedc\xed se pl\xe1n","schedules.remove.yes":"Smazat","schedules.running":"Prob\xedh\xe1","schedules.scheduled":"Napl\xe1nov\xe1no","schedules.show_processed":"Zobrazit proveden\xe9","schedules.target_soc":"C\xedlov\xe9 SOC: {targetSoc, number, percent}","schedules.title":"Pl\xe1nova\u010D","scripts.add":"Vytvo\u0159it","scripts.delete":"Smazat","scripts.edit":"Upravit","scripts.loading_error":"Chyba p\u0159i na\u010D\xedt\xe1n\xed script\u016F","scripts.title":"Scripty","settings.PV.NominalInverterPower":"Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De","settings.PV.NominalInverterPower.help":"Pro Solinteg, Wattsonic a Deye je toto d\u016Fle\u017Eit\xe9 pro spr\xe1vn\xfd v\xfdpo\u010Det p\u0159etok\u016F do s\xedt\u011B.","settings.PV.NominalInverterPower.subtitle":"Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De v kW, d\u016Fle\u017Eit\xfd pro v\xfdpo\u010Det % p\u0159etok\u016F do s\xedt\u011B.","settings.PV.StringNumber":"Po\u010Det string\u016F st\u0159\xedda\u010De","settings.PV.StringNumber.subtitle":"Po\u010Det string\u016F st\u0159\xedda\u010De zobrazovan\xfd v aplikaci na z\xe1lo\u017Ece FVE","settings.app_update":"Verze aplikace","settings.app_update.check_button":"Zkontrolovat aktualizace","settings.app_update.confirm.cancel":"Zru\u0161it","settings.app_update.confirm.confirm":"Aktualizovat","settings.app_update.confirm.description":"Aktualizace m\u016F\u017Ee trvat n\u011Bkolik minut. B\u011Bhem aktualizace bude aplikace nedostupn\xe1 a n\xe1sledn\u011B se automaticky restartuje.","settings.app_update.confirm.title":"Spustit aktualizaci?","settings.app_update.error.no_internet":"Zkontrolujte s\xed\u0165ov\xe9 p\u0159ipojen\xed","settings.app_update.in_progress":"Aktualizace prob\xedh\xe1","settings.app_update.request_button":"Aktualizace je k dispozici","settings.app_update.requested":"Aktualizace byla vy\u017E\xe1d\xe1na","settings.app_update.subtitle":"Zkontrolujte dostupnost nov\xfdch verz\xed","settings.app_update.title":"Aktualizace aplikace","settings.app_update.up_to_date":"Aplikace je aktu\xe1ln\xed","settings.boiler":"Bojler","settings.boiler.3phase":"T\u0159\xed-f\xe1zov\xe1 patrona","settings.boiler.3phase.subtitle":"Jedno-f\xe1zovou patronu zapojte na SSR v\xfdstup odpov\xeddaj\xedc\xed zvolen\xe9 f\xe1zi.","settings.boiler.HwBatteryPriority":"Procento nab\xedt\xed baterie od kter\xe9ho se za\u010Dne oh\u0159\xedvat bojler","settings.boiler.HwBatteryPriority.help":"Pokud je nabit\xed baterie ni\u017E\u0161\xed, ne\u017E tato hodnota, priorita akumulace energie je pln\u011B dostupna baterii. Pokud je nabit\xed baterie vy\u0161\u0161\xed, bojler za\u010D\xedn\xe1 p\u0159eb\xedrat prioritu a spou\u0161t\xed oh\u0159ev vody z p\u0159ebyte\u010Dn\xe9 energie FVE - \u010D\xe1st energie jde d\xe1le do baterie do jej\xedho dobit\xed.","settings.boiler.capacity":"Objem bojleru","settings.boiler.capacity_sub":"Nutn\xe9 zadat pouze pro spotov\xe9 obchodov\xe1n\xed","settings.boiler.enabled":"Topn\xe1 patrona nainstalov\xe1na","settings.boiler.nominal":"Nomin\xe1ln\xed p\u0159\xedkon","settings.boiler.nominal.subtitle":"Nomin\xe1ln\xed p\u0159\xedkon pro 1 f\xe1zi elektrokotle","settings.boiler.phase":"F\xe1ze patrony","settings.boiler.phase.subtitle":"L1 = SSR v\xfdstup 1, L2 = SSR v\xfdstup 2, L3 = SSR v\xfdstup 3.","settings.boiler.prio":"Priorita baterie","settings.boiler.prio.subtitle":"Pokud je ON, nejprve se nabij\xed baterie a n\xe1sledn\u011B bojler","settings.boiler.shellies":"Bojler je \u0159\xedzen skrze Shelly","settings.boiler.temp_enabled":"Teplotn\xed \u010Didlo nainstalov\xe1no","settings.boiler.temp_enabled.subtitle":"Bojler lze bez \u010Didla vyu\u017E\xedt pouze pro p\u0159ebytky","settings.device":"Za\u0159\xedzen\xed","settings.device.SN":"S\xe9riov\xe9 \u010D\xedslo","settings.device.id":"ID za\u0159\xedzen\xed","settings.device.license":"Licence za\u0159\xedzen\xed","settings.docs":"N\xe1vody a dal\u0161\xed podklady","settings.docs.service_settings_inverter.button":"P\u0159ej\xedt na wiki","settings.docs.service_settings_inverter.subtitle":"Dokumentace, postupy a dal\u0161\xed informace","settings.docs.service_settings_inverter.title":"N\xe1vod na p\u0159ipojen\xed st\u0159\xedda\u010De","settings.docs.tech_wiki.button":"P\u0159ej\xedt na wiki","settings.docs.tech_wiki.subtitle":"N\xe1vody, postupy a dal\u0161\xed informace","settings.docs.tech_wiki.title":"Technick\xe1 wiki","settings.docs.user_wiki.button":"P\u0159ej\xedt na wiki","settings.docs.user_wiki.subtitle":"N\xe1vody, postupy a dal\u0161\xed informace","settings.docs.user_wiki.title":"U\u017Eivatelsk\xe1 wiki","settings.hdo":"Nastaven\xed \u010Das\u016F HDO","settings.hdo.help":"Nastaven\xed \u010Das\u016F HDO pro v\xfdpo\u010Det cen elekt\u0159iny ve vysok\xe9m a n\xedzk\xe9m tarifu. N\xed\u017Ee je mo\u017En\xe9 zadat \u010Dasy platnosti n\xedzk\xe9ho tarifu.","settings.hdo.on1":"\u010Cas 1","settings.hdo.on2":"\u010Cas 2","settings.hdo.on3":"\u010Cas 3","settings.hdo.on4":"\u010Cas 4","settings.hdo.on5":"\u010Cas 5","settings.hdo.on6":"\u010Cas 6","settings.hdo.regular":"B\u011B\u017En\xfd pracovn\xed den","settings.hdo.start":"Zapnout","settings.hdo.stop":"Vypnout","settings.hdo.type":"Definovat \u010Dasy pro","settings.hdo.weekend":"V\xedkendov\xe9 \u010Dasy HDO","settings.heatpump":"Tepeln\xe9 \u010Derpadlo","settings.heatpump.HpBatteryPriority":"Procento nab\xedt\xed baterie od kter\xe9ho se zv\xfd\u0161\xed v\xfdkon tepeln\xe9ho \u010Derpadla","settings.heatpump.HpBatteryPriority.help":"Pokud je nabit\xed baterie ni\u017E\u0161\xed, ne\u017E tato hodnota, priorita akumulace energie je pln\u011B dostupna baterii. Pokud je nabit\xed baterie vy\u0161\u0161\xed, tepeln\xe9 \u010Derpadlo za\u010D\xedn\xe1 p\u0159eb\xedrat prioritu a spou\u0161t\xed oh\u0159ev vody z p\u0159ebyte\u010Dn\xe9 energie FVE - \u010D\xe1st energie jde d\xe1le do baterie do jej\xedho dobit\xed.","settings.heatpump.enabled":"Tepeln\xe9 \u010Derpadlo nainstalov\xe1no","settings.heatpump.flexiAN":"Flexibilita AN","settings.heatpump.flexiCool":"Flexibilita chlazen\xed","settings.heatpump.flexiHw":"Flexibilita tepl\xe9 vody","settings.heatpump.flexiRoom":"Flexibilita m\xedstnosti","settings.heatpump.hp_type":"Typ tepeln\xe9ho \u010Derpadla","settings.heatpump.nominal":"Nomin\xe1ln\xed p\u0159\xedkon","settings.heatpump.nominal1":"Nomin\xe1ln\xed p\u0159\xedkon","settings.heatpump.priority":"Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E baterie","settings.heatpump.priority-wb":"Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E wallbox","settings.heatwatter":"Bojler","settings.heatwatter.legionella":"Legionella","settings.heatwatter.legionella_temp":"Teplota sanace","settings.heatwatter.legionella_temp.subtitle":"Teplota na kterou se mus\xed minim\xe1ln\u011B 1x za 14 dn\xed bojler nah\u0159\xe1t","settings.inverter_communication_status":"Komunikace se st\u0159\xedda\u010Dem","settings.inverter_communication_status.not_ok":"Nenav\xe1z\xe1na,{br}pokou\u0161\xedm se o spojen\xed...","settings.inverter_communication_status.ok":"Komunikace nav\xe1z\xe1na{br}({count} \u010Dten\xed)","settings.inverter_communication_status.subtitle":"Nav\xe1z\xe1n\xed komunikace m\u016F\u017Ee trvat n\u011Bkolik des\xedtek vte\u0159in a\u017E p\xe1r minut","settings.notification":"Notifikace","settings.notification.battery_max_soc":"Maxim\xe1ln\xed SOC baterie","settings.notification.battery_max_soc.subtitle":"Notifikace se vygeneruje p\u0159i dosa\u017Een\xed nastaven\xe9ho maxim\xe1ln\xedho SOC baterie. Notifikace se vygeneruje pouze 1x denn\u011B.","settings.notification.battery_max_soc_value":"Maxim\xe1ln\xed SOC baterie pro notifikace","settings.notification.battery_max_soc_value.subtitle":"Nastavte SOC baterie, p\u0159i jeho\u017E dosa\u017Een\xed se vygeneruje notifikace.","settings.notification.battery_min_soc":"Minim\xe1ln\xed SOC baterie","settings.notification.battery_min_soc.subtitle":"Notifikace se vygeneruje p\u0159i poklesu SOC baterie na nastavenou minim\xe1ln\xed hodnotu. Notifikace se vygeneruje pouze 1x denn\u011B.","settings.notification.battery_min_soc_value":"Minim\xe1ln\xed SOC baterie pro notifikace","settings.notification.battery_min_soc_value.subtitle":"Nastavte SOC baterie. P\u0159i poklesu na tuto hodnotu se vygeneruje notifikace.","settings.notification.daily_prediction.subtitle":"Notifikace se vygeneruje ka\u017Ed\xfd den v 8:00","settings.notification.heat_pump_limit_exceeded":"P\u0159ekro\u010Den\xed limitu spot\u0159eby tepeln\xe9ho \u010Derpadla","settings.notification.heat_pump_limit_exceeded.subtitle":"Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu spot\u0159eby tepeln\xe9ho \u010Derpadla","settings.notification.heat_pump_limit_value":"Denn\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla pro notifikace","settings.notification.heat_pump_limit_value.subtitle":"Nastavte limit spot\u0159eby tepeln\xe9ho \u010Derpadla, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace.","settings.notification.heat_water_limit_exceeded":"P\u0159ekro\u010Den\xed limitu oh\u0159evu vody","settings.notification.heat_water_limit_exceeded.subtitle":"Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu oh\u0159evu vody","settings.notification.heat_water_limit_value":"Denn\xed limit oh\u0159evu vody pro notifikace","settings.notification.heat_water_limit_value.subtitle":"Nastavte limit oh\u0159evu vody, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace.","settings.notification.heat_water_max_temperature":"Dosa\u017Eena maxim\xe1ln\xed teplota vody v bojleru","settings.notification.heat_water_max_temperature.subtitle":"Notifikace se vygeneruje p\u0159i dosa\u017Een\xed po\u017Eadovan\xe9 maxim\xe1ln\xed teploty vody v bojleru z FV energie","settings.notification.home_consumption_limit_exceeded":"P\u0159ekro\u010Den\xed limitu spot\u0159eby dom\xe1cnosti","settings.notification.home_consumption_limit_exceeded.subtitle":"Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu spot\u0159eby dom\xe1cnosti","settings.notification.home_consumption_limit_value":"Denn\xed limit spot\u0159eby dom\xe1cnosti pro notifikace","settings.notification.home_consumption_limit_value.subtitle":"Nastavte limit spot\u0159eby dom\xe1cnosti, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace.","settings.notification.iverter_disconnected":"V\xfdpadek komunikace st\u0159\xedda\u010De","settings.notification.iverter_disconnected.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci v\xfdpadku komunikace se st\u0159\xedda\u010Dem","settings.notification.negative_spot":"Z\xe1porn\xe1 cena na spotu","settings.notification.negative_spot.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci z\xe1porn\xe9 ceny na spotu","settings.notification.pv_production_mwh":"Miln\xedk ve v\xfdrob\u011B FV energie","settings.notification.pv_production_mwh.subtitle":"Notifikace se vygeneruje pokud FVE vygeneruje MWh energie v dan\xe9m roce","settings.notification.spot_charging_battery":"Start a konec nab\xedjen\xed baterie dle spotov\xe9 ceny","settings.notification.spot_charging_battery.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci nab\xedjen\xed baterie dle spotov\xe9 ceny","settings.notification.spot_daily_prediction":"Denn\xed p\u0159edpov\u011B\u010F","settings.notification.spot_daily_summary":"Denn\xed souhrn pl\xe1nu spotu","settings.notification.spot_daily_summary.subtitle":"Notifikace se vygeneruje ka\u017Ed\xfd den v 8:00","settings.notification.spot_discharging_battery":"Start a konec vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny","settings.notification.spot_discharging_battery.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny","settings.notification.utility_loss":"V\xfdpadek distribu\u010Dn\xed s\xedt\u011B","settings.notification.utility_loss.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci v\xfdpadku distribu\u010Dn\xed s\xedt\u011B","settings.notification.wallbox_charging_start_stop":"Start a konec nab\xedjen\xed elektromobilu","settings.notification.wallbox_charging_start_stop.subtitle":"Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci nab\xedjen\xed elektromobilu","settings.notification.wallbox_limit_exceeded":"P\u0159ekro\u010Den\xed limitu nab\xedjen\xed elektromobilu","settings.notification.wallbox_limit_exceeded.subtitle":"Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu nab\xedjen\xed elektromobilu","settings.notification.wallbox_limit_value":"Denn\xed limit nab\xedjen\xed elektromobilu pro notifikace","settings.notification.wallbox_limit_value.subtitle":"Nastavte limit nab\xedjen\xed elektromobilu, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace.","settings.notification.webapp.subtitle":"Notifikace z Infigy m\u016F\u017Eete dost\xe1vat p\u0159es webovou aplikaci.","settings.notification.webapp.title":"Webov\xe1 aplikace","settings.other":"Ostatn\xed","settings.other.dark_mode":"Tmav\xfd re\u017Eim","settings.other.languate":"Jazyk","settings.other.overflow_fronius":"Maxim\xe1ln\xed p\u0159etok do s\xedt\u011B je omezov\xe1n na stran\u011B Fronius st\u0159\xedda\u010De","settings.other.overflow_fronius_subtitle":"Tato hodnota je stanovena distributorem. P\u0159ekro\u010Den\xed t\xe9to hodnoty m\u016F\u017Ee v\xe9st k finan\u010Dn\xedm postih\u016Fm ze strany distributora.","settings.other.overflow_settings":"Nastaven\xe1 hodnota p\u0159etok\u016F","settings.other.overflow_settings.help":"Jedn\xe1 se o servisn\u011B nastavenou hodnotu maxim\xe1ln\xedho p\u0159etoku. Tato hodnota je stanovena distributorem. P\u0159ekro\u010Den\xed t\xe9to hodnoty m\u016F\u017Ee v\xe9st k finan\u010Dn\xedm postih\u016Fm ze strany distributora.","settings.other.readability_mode":"Velikost p\xedsma","settings.photovoltaics":"Fotovoltaick\xe1 elektr\xe1rna","settings.photovoltaics.backup_enabled":"Backup povolen","settings.photovoltaics.backup_enabled.subtitle":"Informace o nastaven\xed re\u017Eimu backup st\u0159\xedda\u010De.","settings.photovoltaics.batterychargingpower":"Nab\xedjec\xed v\xfdkon baterie","settings.photovoltaics.batterychargingpower_sub":"V\xfdkon pro manu\xe1ln\xed nab\xedjen\xed baterie a spotov\xe9 nab\xedjen\xed z distribu\u010Dn\xed s\xedt\u011B","settings.photovoltaics.batterydischargingpower":"Vyb\xedjec\xed v\xfdkon baterie","settings.photovoltaics.batterydischargingpower_sub":"V\xfdkon pro spotov\xe9 vyb\xedjen\xed baterie do distribu\u010Dn\xed s\xedt\u011B","settings.photovoltaics.batteryenabled":"Baterie nainstalov\xe1na","settings.photovoltaics.batterynominal":"Nomin\xe1ln\xed kapacita baterie","settings.photovoltaics.batterynominal_sub":"Nutn\xe9 zadat pouze pro spotov\xe9 obchodov\xe1n\xed","settings.photovoltaics.enabled":"FVE nainstalov\xe1na","settings.photovoltaics.gridchargeenabled":"Nab\xedjen\xed baterie z distribu\u010Dn\xed s\xedt\u011B povoleno","settings.photovoltaics.inverters-adjust-power":"Aktu\xe1ln\xed v\xfdkon st\u0159\xedda\u010D\u016F","settings.photovoltaics.inverters-nominal":"Nomin\xe1ln\xed v\xfdkon \u0159iditeln\xfdch st\u0159\xedda\u010D\u016F","settings.photovoltaics.nominal":"Nomin\xe1ln\xed v\xfdkon v panelech cel\xe9 elektr\xe1rny","settings.photovoltaics.overflow":"P\u0159etok do s\xedt\u011B bez omezen\xed","settings.photovoltaics.overflow.value":"Omezen\xed p\u0159etoku","settings.photovoltaics.overflow.value.help":"Hodnota omezen\xed p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B. Tato hodnota se zap\xed\u0161e do st\u0159\xedda\u010De. Ve st\u0159\xedda\u010Di tuto hodnotu neupravujte. Omezen\xed p\u0159etoku je \u0159\xedzen\xe9 z Infigy. Zapsanou hodnotu si zkontrolujte ve st\u0159\xedda\u010Di.","settings.photovoltaics.overflow_fronius.value.help":"Hodnota p\u0159etoku na stran\u011B Fronius st\u0159\xedda\u010De. Slou\u017E\xed jako informace Infigy pro spr\xe1vnou vizualizaci p\u0159etok\u016F.","settings.photovoltaics.settings":"Baterie","settings.photovoltaics.settings.soc_actual":"Vypo\u010Dten\xe9 minim\xe1ln\xed nabit\xed","settings.photovoltaics.settings.soc_actual.help":"Tato hodnota je automaticky vypo\u010Dtena na z\xe1klad\u011B aktu\xe1ln\xedho stavu. Bu\u010F se \u0159\xedd\xed dle automatick\xe9ho \u0159\xedzen\xed nabit\xed podle ro\u010Dn\xedho obdob\xed, nebo dle manu\xe1ln\xedho nastaven\xed minim\xe1ln\xedho nabit\xed s DS a bez DS. Pokud je zde hodnota 100%, tak je vyb\xedjen\xed baterie zak\xe1zan\xe9, nap\u0159. dle spotov\xe9ho obchodov\xe1n\xed.","settings.photovoltaics.settings.soc_grid":"Minim\xe1ln\xed nabit\xed s DS","settings.photovoltaics.settings.soc_grid.help":"Touto hodnotou je mo\u017En\xe9 \u0159\xeddit minim\xe1ln\xed nabit\xed baterie v % SOC p\u0159i dostupn\xe9 distribu\u010Dn\xed s\xedti. U Solax v re\u017Eimu Backup je minim\xe1ln\xed nabit\xed baterie 15%.","settings.photovoltaics.settings.temp_ek":"Minim\xe1ln\xed nabit\xed bez DS","settings.photovoltaics.settings.temp_ek.help":"Touto hodnotou je mo\u017En\xe9 \u0159\xeddit minim\xe1ln\xed nabit\xed baterie v % SOC p\u0159i v\xfdpadku distribu\u010Dn\xed s\xedt\u011B.","settings.photovoltaics.unbalanced_enabled":"Asymetrie st\u0159\xedda\u010De","settings.photovoltaics.unbalanced_enabled.subtitle":"Informace o nastaven\xed re\u017Eimu asymetrie st\u0159\xedda\u010De.","settings.photovoltaics_auto_settings":"Automatick\xe9 \u0159\xedzen\xed nabit\xed","settings.photovoltaics_auto_settings.subtitle":"Automatick\xe1 regulace nabit\xed podle ro\u010Dn\xedho obdob\xed","settings.plug":"Z\xe1suvky","settings.plug.Led":"Trval\xe9 podsv\xedcen\xed","settings.plug.Led-batt":"Podsv\xedcen\xed p\u0159i nabit\xe9 baterii","settings.plug.Led-batt.subtitle":"Podsv\xedcen\xed aktivn\xed, pokud m\xe1 baterie alespo\u0148 95%","settings.plug.Led-over":"Podsv\xedcen\xed p\u0159i p\u0159etoku","settings.plug.enabled":"Z\xe1suvky nainstalov\xe1ny","settings.plug.enabled.subtitle":"Z\xe1suvky na lok\xe1ln\xed s\xedti","settings.plug.enabled2":"Druh\xe1 z\xe1suvka","settings.plug.enabled3":"T\u0159et\xed z\xe1suvka","settings.plug.ip1":"IP adresa prvn\xed z\xe1suvky","settings.plug.ip1.label":"IP 1","settings.plug.ip2":"IP adresa druh\xe9 z\xe1suvky","settings.plug.ip2.label":"IP 2","settings.plug.ip3":"IP adresa t\u0159et\xed z\xe1suvky","settings.plug.ip3.label":"IP 3","settings.plug.modulenabled":"Z\xe1suvky na modulu Shelly PRO 3","settings.plug.modulip":"IP adresa modulu","settings.plug.modulip.label":"IP Modulu","settings.plug.name1":"N\xe1zev z\xe1suvky 1","settings.plug.name1.label":"N\xe1zev","settings.plug.name2":"N\xe1zev z\xe1suvky 2","settings.plug.name2_label":"N\xe1zev","settings.plug.name3":"N\xe1zev z\xe1suvky 3","settings.plug.name3.label":"N\xe1zev","settings.plug.statusLed":"Signaliza\u010Dn\xed dioda","settings.readability_mode.default":"V\xfdchoz\xed","settings.readability_mode.large":"Velk\xe1","settings.relay.above_price_relay":"Cena spotu pro sepnut\xed rel\xe9","settings.relay.above_price_relay.subtitle":"P\u0159i cene spotu nad tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena ni\u017E\u0161\xed, dojde k rozepnut\xed rel\xe9.","settings.relay.above_price_relay_15m":"Cena spotu pro sepnut\xed rel\xe9 (15 min)","settings.relay.above_price_relay_15m.subtitle":"P\u0159i cene spotu nad tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena ni\u017E\u0161\xed, dojde k rozepnut\xed rel\xe9.","settings.relay.above_soc_relay":"Nabit\xed baterie pro sepnut\xed rel\xe9","settings.relay.above_soc_relay.subtitle":"P\u0159i nabit\xed baterie nad tuto hodnotu dojde k sepnut\xed rel\xe9","settings.relay.above_soc_relay_hyst":"Hystereze baterie pro rozepnut\xed rel\xe9","settings.relay.above_soc_relay_hyst.subtitle":"Pokud se nabit\xed baterie sn\xed\u017E\xed o tuto hodnotu pod nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9","settings.relay.below_price_relay":"Cena spotu pro sepnut\xed rel\xe9","settings.relay.below_price_relay.subtitle":"P\u0159i cene spotu pod tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena vy\u0161\u0161\xed, dojde k rozepnut\xed rel\xe9.","settings.relay.below_price_relay_15m":"Cena spotu pro sepnut\xed rel\xe9 (15 min)","settings.relay.below_price_relay_15m.subtitle":"P\u0159i cene spotu pod tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena vy\u0161\u0161\xed, dojde k rozepnut\xed rel\xe9.","settings.relay.below_soc_relay":"Nabit\xed baterie pro sepnut\xed rel\xe9","settings.relay.below_soc_relay.subtitle":"P\u0159i poklesu nabit\xed baterie pod tuto hodnotu dojde k sepnut\xed rel\xe9","settings.relay.below_soc_relay_hyst":"Hystereze baterie pro rozepnut\xed rel\xe9","settings.relay.below_soc_relay_hyst.subtitle":"Pokud se nabit\xed baterie zv\xfd\u0161\xed o tuto hodnotu nad nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9","settings.relay.enabled":"Rel\xe9 nainstalov\xe1ny","settings.relay.enabled.subtitle":"Integrovan\xe1 rel\xe9","settings.relay.item.enabled":"Rel\xe9 {index}","settings.relay.item.name":"Pojmenov\xe1n\xed rel\xe9","settings.relay.item.status":"Sepnuto","settings.relay.option":"Podm\xednka","settings.relay.temp_above_relay.subtitle":"P\u0159i teplot\u011B bojleru nad tuto hodnotu dojde k sepnut\xed rel\xe9","settings.relay.temp_above_relay_hyst.subtitle":"Pokud se teplota bojleru sn\xed\u017E\xed o tuto hodnotu pod nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9","settings.relay.temp_below_relay.subtitle":"P\u0159i teplot\u011B bojleru pod tuto hodnotu dojde k sepnut\xed rel\xe9","settings.relay.temp_below_relay_hyst":"Hystereze bojleru pro rozepnut\xed rel\xe9","settings.relay.temp_below_relay_hyst.subtitle":"Pokud se teplota bojleru zv\xfd\u0161\xed o tuto hodnotu nad nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9","settings.relay.temp_relay":"Teplota bojleru pro sepnut\xed rel\xe9","settings.relay.temp_relay_hyst":"Hystereze bojleru pro rozepnut\xed rel\xe9","settings.relay.type.Active":"Trvale sepnuto","settings.relay.type.HDO":"Zrcadlit HDO","settings.relay.type.batteryBelowSOC":"Nabit\xed baterie pod nastaven\xe9 SOC","settings.relay.type.batteryDischarge":"Vyb\xedjen\xed baterie do s\xedt\u011B","settings.relay.type.batteryFull":"Nabit\xed baterie nad nastaven\xe9 SOC","settings.relay.type.batteryLow":"Nabit\xed baterie pod nastaven\xe9 minimum","settings.relay.type.bojlerFull":"Bojler je t\xe9m\u011B\u0159 natopen\xfd","settings.relay.type.hdo":"Zrcadlit HDO","settings.relay.type.heatWaterAboveTemp":"Bojler je natopen\xfd nad nastavenou teplotu","settings.relay.type.heatWaterBelowTemp":"Bojler je natopen\xfd pod nastavenou teplotu","settings.relay.type.heatWaterMaxTemp":"Bojler je t\xe9m\u011B\u0159 natopen\xfd","settings.relay.type.heatWaterTemp":"Bojler je natopen\xfd nad nastavenou teplotu","settings.relay.type.none":"Nen\xed pou\u017Eito, trvale rozepnuto","settings.relay.type.plug1":"Z\xe1suvka 1","settings.relay.type.plug2":"Z\xe1suvka 2","settings.relay.type.plug3":"Z\xe1suvka 3","settings.relay.type.plug4":"Z\xe1suvka 4","settings.relay.type.spotBatteryDischarge":"Vyb\xedjen\xed baterie do s\xedt\u011B","settings.relay.type.spotHi":"Vysok\xe1 cena spotu (60 min)","settings.relay.type.spotHi15M":"Vysok\xe1 cena spotu (15 min)","settings.relay.type.spotLow":"N\xedzk\xe1 cena spotu (60 min)","settings.relay.type.spotLow15M":"N\xedzk\xe1 cena spotu (15 min)","settings.relay.type.spotMi":"St\u0159edn\xed cena spotu (60 min)","settings.relay.type.spotMi15M":"St\u0159edn\xed cena spotu (15 min)","settings.relay.type.spotNegative":"Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (60 min)","settings.relay.type.spotNegative15M":"Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (15 min)","settings.relay.type.spotPriceAbove":"Cena spotu nad nastavenou hodnotu (60 min)","settings.relay.type.spotPriceAbove15M":"Cena spotu nad nastavenou hodnotu (15 min)","settings.relay.type.spotPriceBelow":"Cena spotu pod nastavenou hodnotu (60 min)","settings.relay.type.spotPriceBelow15M":"Cena spotu pod nastavenou hodnotu (15 min)","settings.relay.type.spotStopAccumulation":"Akumulace zastavena, aktivn\xed prodej","settings.relay.type.stopAccumulation":"Akumulace zastavena, aktivn\xed prodej","settings.relay.type.thermostat1":"Termostat 1","settings.relay.type.thermostat2":"Termostat 2","settings.relay.type.thermostat3":"Termostat 3","settings.relay.type.thermostat4":"Termostat 4","settings.relay.user_advanced_control":"Zobrazit str\xe1nku s informacemi u\u017Eivateli","settings.relay.user_advanced_control.subtitle":"P\u0159i povolen\xed se objev\xed str\xe1nka v navigaci","settings.service":"Servis","settings.service.connection_type":"P\u0159ipojen\xed","settings.service.customer":"Jm\xe9no u\u017Eivatele","settings.service.customer-email":"Email u\u017Eivatele","settings.service.customer-email-subtitle":"Pokud nem\xe1 u\u017Eivatel zalo\u017Een \xfa\u010Det pod t\xedmto emailem, dojde k automatick\xe9mu vytvo\u0159en\xed \xfa\u010Dtu a odesl\xe1n\xed registra\u010Dn\xedho emailu","settings.service.customer-email.label":"Email","settings.service.customer-subtitle":"Slou\u017E\xed k identifikaci instalace pro firmu i z\xe1kazn\xedka","settings.service.customer.label":"Jm\xe9no","settings.service.exit":"Odhl\xe1sit ze servisu","settings.service.exit.button":"Odhl\xe1sit","settings.service.info":"Instalace","settings.service.inverter_type":"Typ st\u0159\xedda\u010De","settings.service.inverter_type.label":"St\u0159\xedda\u010D","settings.service.modbus_tcp":"LAN/WiFi","settings.service.network":"S\xed\u0165","settings.service.network.help.content":"V seznamu je mo\u017En\xe9 vid\u011Bt aktu\xe1ln\u011B p\u0159ipojen\xe1 za\u0159\xedzen\xed do s\xedt\u011B Infigy (WiFi nebo kabelem), jejich IP adresy, MAC adresy, atd. Pokud za\u0159\xedzen\xed pou\u017E\xedv\xe1 DHCP, je mo\u017En\xe9 kliknut\xedm na \u0161pendl\xedk a zafixovat IP adresu, kterou pak DHCP server v\u017Edy bude p\u0159i\u0159azovat - toto je vhodn\xe9 nap\u0159. pro st\u0159\xedda\u010D, tepeln\xe9 \u010Derpadlo, apod. Pokud za\u0159\xedzen\xed pou\u017E\xedv\xe1 statickou IP adresu, nemus\xed se zobrazovat spr\xe1vn\u011B.","settings.service.network.help.title":"Nastaven\xed s\xedt\u011B","settings.service.network.mac":"MAC adresa","settings.service.network.online.internet":"P\u0159\xedstup na internet","settings.service.network.online.internet.help":"P\u0159\xedstup na internet je pot\u0159eba pro vzd\xe1len\xfd p\u0159\xedstup, aktualizace syst\xe9mu, spotov\xe9 ceny a dal\u0161\xed funkce. Pro plnou funk\u010Dnost mus\xed b\xfdt v\u0161echny t\u0159i indik\xe1tory zelen\xe9.{br}{br}Prvn\xed indik\xe1tor zobrazuje dostupnost internetu (ping 8.8.8.8).{br}{br}Druh\xfd indik\xe1tor zobrazuje dostupnost internetu v\u010Detn\u011B DNS (ping infigy.cz).{br}{br}T\u0159et\xed indik\xe1tor zobrazuje p\u0159\xedstup k intern\xedm cloudov\xfdm slu\u017Eb\xe1m Infigy (dostupnost VPN).{br}{br}Pokud je s p\u0159ipojen\xedm probl\xe9m, zkontrolujte pros\xedm kabel, nebo kontaktujte spr\xe1vce s\xedt\u011B, jestli nem\xe1 m\xedstn\xed s\xed\u0165 restrikce na komunikaci do internetu.{br}{br}{wikiLink}","settings.service.network.online.internet.help.wikiLink":"V\xedce informac\xed v na\u0161\xed wiki.","settings.service.network.wan":"WAN adresa","settings.service.network.wifi_passphrase":"Heslo WiFi s\xedt\u011B","settings.service.network_type":"S\xed\u0165","settings.service.network_type.custom":"Ru\u010Dn\xed nastaven\xed adresy","settings.service.network_type.external":"M\xedstn\xed s\xed\u0165 (z\xe1kazn\xedka)","settings.service.network_type.internal":"Intern\xed s\xed\u0165 Infigy","settings.service.password":"P\u0159\xedstup do servisu","settings.service.password.label":"Heslo","settings.service.relay":"Rel\xe9","settings.service.reset":"Reset chyb","settings.service.reset.button":"Reset chyb","settings.service.rs485":"RS485","settings.service.service-email":"Email servisn\xed firmy","settings.service.service-email-subtitle":"Pro propojen\xed za\u0159\xedzen\xed s instala\u010Dn\xedm \xfa\u010Dtem je nutn\xe9 zadat email servisn\xed firmy, kter\xfd je ulo\u017Een v Partnersk\xe9 sekci aplikace","settings.service.service-email.label":"Email","settings.service.servicer":"Jm\xe9no instala\u010Dn\xedho technika","settings.service.servicer.label":"Jm\xe9no","settings.service.solidsun_op":"SolidSun OP","settings.service.solidsun_op.label":"SolidSun OP","settings.service.spot":"Spotov\xe9 obchodov\xe1n\xed","settings.service.tester.label":"Jm\xe9no testera","settings.service.thermostat":"Termostat","settings.service.town":"Lokalita (obec)","settings.service.version":"Verze aplikace","settings.service.wallbox_type":"Typ wallbox","settings.service.wallbox_type.label":"Wallbox","settings.spot":"Spot","settings.spot.battery.stop_discharge_auto":"Automatick\xe9 \u0159\xedzen\xed z\xe1kazu vyb\xedjen\xed","settings.spot.battery.stop_discharge_auto.help":"Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m automaticky bude \u0159\xeddit vyb\xedjen\xed baterie a povol\xed ho pouze p\u0159i nejvy\u0161\u0161\xedch denn\xedch cen\xe1ch na spotu.","settings.spot.battery.stop_discharge_auto.subtitle":"\u0158\xedzen\xed uschov\xe1 energii automaticky na nejdra\u017E\u0161\xed hodiny.","settings.spot.battery.stop_discharge_high_price":"Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 a st\u0159edn\xed cen\u011B","settings.spot.battery.stop_discharge_high_price.help":"Pokud zvol\xedte tuto mo\u017Enost, tak p\u0159i n\xedzk\xe9 a st\u0159edn\xed cen\u011B spotu se nebude vyu\u017E\xedvat energie z baterie. Syst\xe9m nebude baterii vyb\xedjet ani do spot\u0159eby objektu. Ta se vyu\u017Eije p\u0159i vy\u0161\u0161\xedch cen\xe1ch.","settings.spot.battery.stop_discharge_low_price":"Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 cen\u011B","settings.spot.battery.stop_discharge_low_price.help":"Pokud zvol\xedte tuto mo\u017Enost, tak p\u0159i n\xedzk\xe9 cen\u011B spotu se nebude vyu\u017E\xedvat energie z baterie. Syst\xe9m nebude baterii vyb\xedjet ani do spot\u0159eby objektu. Ta se vyu\u017Eije p\u0159i vy\u0161\u0161\xedch cen\xe1ch (st\u0159edn\xed a vysok\xe1 cena).","settings.spot.battery.stop_discharge_low_price.subtitle":"\u0158\xedzen\xed uschov\xe1 energii na st\u0159edn\xed a vysokou cenu energie","settings.spot.battery.stop_discharge_middle_price.subtitle":"\u0158\xedzen\xed uschov\xe1 energii na vysokou cenu energie","settings.spot.battery_all_overflow_price":"Minim\xe1ln\xed cena pro vyb\xedjen\xed cel\xe9 kapacity baterie do s\xedt\u011B","settings.spot.battery_all_overflow_price.help":"Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed kapacity baterie do s\xedt\u011B a\u017E do nastaven\xe9ho minim\xe1ln\xedho SOC. Znamen\xe1 to tedy, \u017Ee v baterii nebude uchov\xe1na energie pro no\u010Dn\xed a rann\xed spot\u0159ebu. Po vybit\xed baterie do s\xedt\u011B se bude pro spot\u0159ebu objektu nakupovat energie ze s\xedt\u011B","settings.spot.battery_all_overflow_price.subtitle":"Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed kapacity baterie do s\xedt\u011B a\u017E do nastaven\xe9ho minim\xe1ln\xedho SOC","settings.spot.battery_charge":"Povoleno nab\xedjen\xed baterie podle spotu","settings.spot.battery_charge.help":"Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje nab\xedjen\xed v dob\u011B nejni\u017E\u0161\xedch cen. Bere v potaz aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie a jej\xed kapacitu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nab\xedjen\xed tak, aby do\u0161lo k jej\xedmu nabit\xed za co nejni\u017E\u0161\xed cenu.","settings.spot.battery_charge.subtitle":"\u0158\xedzen\xed baterie podle spotu zv\xfd\u0161\xed amortizaci baterie","settings.spot.battery_max_soc":"Fin\xe1ln\xed SOC baterie","settings.spot.battery_max_soc.subtitle":"Maxim\xe1ln\xed nabit\xed baterie p\u0159i nab\xedjen\xed ze s\xedt\u011B","settings.spot.battery_overflow":"Povolit vyb\xedjen\xed baterie do s\xedt\u011B podle spotu","settings.spot.battery_overflow.help":"Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje vyb\xedjen\xed baterie do s\xedt\u011B v dob\u011B nejvy\u0161\u0161\xed denn\xed ceny a vybije jen tu energii, kter\xe1 nebude pot\u0159eba na b\u011B\u017Enou spot\u0159ebu objektu. Parametry n\xed\u017Ee je mo\u017En\xe9 definovat v\xfd\u0161i ceny pro vyb\xedt\xed cel\xe9 kapacity baterie a vyb\xedt\xed jen t\xe9 \u010D\xe1sti kapacity baterie, kter\xe1 nebude pot\u0159eba pro no\u010Dn\xed spot\u0159ebu.","settings.spot.battery_overflow.subtitle":"Umo\u017En\xed vyb\xedt nadbytek energie z baterie do s\xedt\u011B v nejv\xfdhodn\u011Bj\u0161\xed hodinu","settings.spot.battery_overflow_price":"Minim\xe1ln\xed cena pro vyb\xedjen\xed baterie do s\xedt\u011B","settings.spot.battery_overflow_price.help":"Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed pouze p\u0159ebyte\u010Dn\xe9 kapacity baterie do s\xedt\u011B. Znamen\xe1 to tedy, \u017Ee v baterii uchov\xe1v\xe1me energii pro no\u010Dn\xed a rann\xed spot\u0159ebu objektu. Nebude tedy doch\xe1zet k nakupov\xe1n\xed energie ze s\xedt\u011B","settings.spot.battery_overflow_price.subtitle":"Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed pouze p\u0159ebyte\u010Dn\xe9 kapacity baterie do s\xedt\u011B","settings.spot.battery_strategy":"Strategie spotov\xe9ho nab\xedjen\xed baterie","settings.spot.battery_strategy.help":"T\xedmto posuvn\xedkem m\u016F\u017Eete jednodu\u0161e nastavit preferenci vyu\u017Eit\xed baterie p\u0159i spotov\xe9m obchodov\xe1n\xed. Ni\u017E\u0161\xed hodnoty (od 20 %) znamenaj\xed men\u0161\xed cyklov\xe1n\xed baterie a tedy m\xe9n\u011B \u010Dast\xe9 nab\xedjen\xed/vyb\xedjen\xed za spotov\xe9 ceny. Vy\u0161\u0161\xed hodnoty (a\u017E do 70 %) zna\u010D\xed opak.","settings.spot.battery_strategy_service.subtitle":"Touto volbou povol\xedte koncov\xfdm u\u017Eivatel\u016Fm nastavit strategii baterie na z\xe1lo\u017Ece Spot","settings.spot.battery_strategy_user":"Umo\u017Enit nastaven\xed strategie baterie u\u017Eivatelem","settings.spot.battery_strategy_user.subtitle":"20 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro FVE. 70 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro Spot.","settings.spot.install":"Spotov\xe9 obchodov\xe1n\xed aktivn\xed","settings.spot.latitude":"Zem\u011Bpisn\xe1 \u0161\xed\u0159ka","settings.spot.latitude.mess":"\u0160\xed\u0159ka","settings.spot.longitude":"Zem\u011Bpisn\xe1 d\xe9lka","settings.spot.longitude.mess":"D\xe9lka","settings.spot.min_difference_price_charge_from_grid":"Minim\xe1ln\xed rozd\xedl ceny na spotu pro nab\xedjen\xed baterie ze s\xedt\u011B","settings.spot.min_difference_price_charge_from_grid.help":"T\xedmto parametrem je mo\u017En\xe9 \u0159\xeddit nab\xedjen\xed baterie ze spotu p\u0159i n\xedzk\xe9m rozd\xedlu mezi nejni\u017E\u0161\xed a nejvy\u0161\u0161\xed cenou. Pokud je parametr 2 K\u010D a rozd\xedl mezi nejvy\u0161\u0161\xed cenou (3 K\u010D) a nejni\u017E\u0161\xed cenou (1 K\u010D) spotu je ni\u017E\u0161\xed, tak se v tento den nab\xedjen\xed baterie ze s\xedt\u011B nenapl\xe1nuje. Tento parametr je mo\u017En\xe9 editovat jen v servisn\xedm menu.","settings.spot.min_difference_price_charge_from_grid.subtitle":"Minim\xe1ln\xed rozd\xedl ceny na spotu b\u011Bhem dne, aby mohlo doj\xedt k nab\xedjen\xed baterie ze s\xedt\u011B","settings.spot.overflow":"Povolit optimalizaci p\u0159etoku podle spotu","settings.spot.overflow.help":"Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m up\u0159ednostn\xed p\u0159etok do s\xedt\u011B p\u0159ed nab\xedjen\xedm baterie v dob\u011B vy\u0161\u0161\xedch a st\u0159edn\xedch spotov\xfdch cen. D\u011Bje se pouze v ro\u010Dn\xedch obdob\xedch, ve kter\xfdch p\u0159edpokl\xe1d\xe1me p\u0159ebytek energie z FVE a doch\xe1z\xed k tomu zpravidla r\xe1no. Optimalizace neprob\xedh\xe1 v n\xedzk\xfdch spotov\xfdch cen\xe1ch, kdy je prioritou nab\xedjen\xed baterie z FVE.","settings.spot.overflow.subtitle":"Umo\u017En\xed up\u0159ednostn\u011Bn\xed p\u0159etoku p\u0159ed akumulac\xed","settings.spot.overflow_offset":"Maxim\xe1ln\xed p\u0159etok p\u0159i z\xe1porn\xe9 cen\u011B","settings.spot.overflow_offset.help":"Hodnota ud\xe1v\xe1 p\u0159etok do distribu\u010Dn\xed s\xedt\u011B p\u0159i z\xe1porn\xe9 cen\u011B. Tuto funkci doporu\u010Dujeme vyu\u017E\xedvat v p\u0159\xedpad\u011B energetick\xe9 komunity.","settings.spot.overflow_offset.subtitle":"Hodnotu nen\xed mo\u017En\xe9 nastavit vy\u0161\u0161\xed ne\u017E maxim\xe1ln\xed p\u0159etok","settings.spot.price.period":"\u010Casov\xe9 rozli\u0161en\xed","settings.spot.price_above_price":"Nastaven\xe1 cena spotu","settings.spot.price_below":"Nastaven\xe1 cena spotu","settings.spot.price_distribution_hi":"Cena za distribuci ve vysok\xe9m tarifu","settings.spot.price_distribution_hi.help":"Cena za distribuci ve vysok\xe9m tarifu v k\u010D/kWh. Tato cena se p\u0159i\u010D\xedt\xe1 k cen\u011B spotu, pokud je aktivn\xed vysok\xfd tarif. Mus\xed b\xfdt nastaveny \u010Dasy HDO pro spr\xe1vn\xfd v\xfdpo\u010Det ceny ve vysok\xe9m a n\xedzk\xe9m tarifu. Tuto \u010D\xe1stku hledejte ve vy\xfa\u010Dtov\xe1n\xed za elekt\u0159inu.","settings.spot.price_distribution_low":"Cena za distribuci v n\xedzk\xe9m tarifu","settings.spot.price_distribution_low.help":"Cena za distribuci v n\xedzk\xe9m tarifu v k\u010D/kWh. Tato cena se p\u0159i\u010D\xedt\xe1 k cen\u011B spotu, pokud je aktivn\xed n\xedzk\xfd tarif. Mus\xed b\xfdt nastaveny \u010Dasy HDO pro spr\xe1vn\xfd v\xfdpo\u010Det ceny ve vysok\xe9m a n\xedzk\xe9m tarifu. Tuto \u010D\xe1stku hledejte ve vy\xfa\u010Dtov\xe1n\xed za elekt\u0159inu.","settings.spot.price_offset":"Cena pro z\xe1kaz p\u0159etok\u016F","settings.spot.price_offset.help":"Doporu\u010Dujeme nastavit minim\xe1ln\u011B ve v\xfd\u0161i provize/poplatku obchodn\xedkovi za prodej p\u0159etok\u016F do s\xedt\u011B.","settings.spot.price_offset.subtitle":"Minim\xe1ln\xed cena spotu, pod kterou se zakazuj\xed p\u0159etoky. Hodnota je porovn\xe1v\xe1na s denn\xedm trhem bez distribu\u010Dn\xed sazby.","settings.spot.region":"Region","settings.thermostat.hp-blocked":"Blokace tepeln\xe9ho \u010Derpadla","settings.thermostat.hysteresis":"Hystereze teploty","settings.thermostat.install":"Termostat aktivn\xed","settings.thermostat.name.label":"N\xe1zev","settings.thermostat.name1":"Pojmenov\xe1n\xed termostatu 1","settings.thermostat.name2":"Pojmenov\xe1n\xed termostatu 2","settings.thermostat.name3":"Pojmenov\xe1n\xed termostatu 3","settings.thermostat.name4":"Pojmenov\xe1n\xed termostatu 4","settings.thermostat.nominal":"Nomin\xe1ln\xed p\u0159\xedkon zdroje","settings.thermostat.number-of-thermostat":"Po\u010Det termostat\u016F","settings.utility":"Parametry domu","settings.utility.loadpercent":"Aktu\xe1ln\xed zat\xed\u017Een\xed jisti\u010De","settings.utility.numberofphase":"T\u0159\xed-f\xe1zov\xe1 instalace","settings.utility.settings.ampers":"Velikost jisti\u010De","settings.utility.settings.loadpercent":"Krizov\xe9 zat\xed\u017Een\xed","settings.utility.settings.loadpercent_max":"P\u0159i p\u0159ekro\u010Den\xed doch\xe1z\xed k omezov\xe1n\xed spot\u0159eby","settings.wallbox":"Wallbox","settings.wallbox.install":"Wallbox aktivn\xed","settings.wallbox.name":"N\xe1zev wallboxu {number}","settings.wallbox.spot":"Wallbox","shellies.list":"Shellies","shellies.mqtt_broker_running":"Stav MQTT Brokerka","shellies.settings":"Nastaven\xed","shellies.settings.boiler.active":"Bojler p\u0159ipojen\xfd p\u0159es Shellies","shellies.settings.boiler.id":"ID shellies","shellies.settings.boiler.id.label":"ID","shellies.title":"Shellies","spot.draft":"Re\u017Eimy pro dne\u0161ek","spot.draft.actualpricehi":"Aktu\xe1ln\xed cena je vysok\xe1, sni\u017E spot\u0159ebu","spot.draft.actualpricelow":"Aktu\xe1ln\xed cena je n\xedzk\xe1, zvy\u0161 spot\u0159ebu","spot.draft.hesLevel":"\xdarove\u0148 \u0159\xedzen\xed HES","spot.draft.hiprice":"Hranice sn\xed\u017Een\xe9ho odb\u011Bru","spot.draft.info":"Re\u017Eimy a doporu\u010Den\xed pro dne\u0161n\xed den","spot.draft.lowprice":"Hranice zv\xfd\u0161en\xe9ho odb\u011Bru","spot.draft.todaystatus_HP":"Akumulace tepelka","spot.draft.todaystatus_HW":"Akumulace bojleru","spot.draft.todaystatus_bat":"Akumulace baterie","spot.draft.todaystatus_em":"P\u0159etok","spot.flexibility":"Odhad flexibility pro dne\u0161ek","spot.prediction":"Odhady energi\xed pro dne\u0161ek","spot.prediction.battery":"Dispozi\u010Dn\xed akumulace baterie","spot.prediction.home":"B\u011B\u017En\xe1 spot\u0159eba objektu","spot.prediction.hp":"Tepeln\xe9 \u010Derpadlo","spot.prediction.hw":"Dispozi\u010Dn\xed akumulace bojleru","spot.prediction.pv":"V\xfdroba elektr\xe1rny","spot.prediction.sale":"Zb\xfdvaj\xedc\xed energie pro prodej p\u0159ebytk\u016F","spot.prediction.sale.help":"Zb\xfdvaj\xedc\xed pl\xe1novan\xe1 denn\xed v\xfd\u0161e p\u0159ebytk\u016F, kter\xe1 bude up\u0159ednostn\u011Bna jako p\u0159etok do s\xedt\u011B p\u0159ed akumulac\xed do baterie.","spot.price.period.15min":"15 min","spot.price.period.60min":"60 min","spot.region.cz":"CZ","spot.region.nl":"NL","spot.region.sk":"SK","spot.status":"Spotov\xe9 obchodov\xe1n\xed","spot.summary.battery_charge_from_grid":"Nab\xedjen\xed ze s\xedt\u011B","spot.summary.battery_charge_from_grid.help":"Nab\xedjen\xed baterie ze s\xedt\u011B dle spotu je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Nab\xedjen\xed baterie syst\xe9m napl\xe1nuje v dob\u011B n\xedzk\xfdch cen a bere v potaz aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie a jej\xed kapacitu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nab\xedjen\xed tak, aby do\u0161lo k jej\xedmu pln\xe9mu nabit\xed za co nejni\u017E\u0161\xed cenu.","spot.summary.battery_discharge":"Vyb\xedjen\xed baterie","spot.summary.battery_discharge.help":"Vyb\xedjen\xed baterie do objektu na spotu je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Vyb\xedjen\xed baterie se obvykle zakazuje v dob\u011B n\xedzk\xfdch cen, kdy je lep\u0161\xed br\xe1t energii ze s\xedt\u011B a v baterii ji uchovat na dra\u017E\u0161\xed \u010Dasy.","spot.summary.battery_discharge_to_grid":"Vyb\xedjen\xed do s\xedt\u011B","spot.summary.battery_discharge_to_grid.help":"Vyb\xedjen\xed baterie do s\xedt\u011B je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Vyb\xedjen\xed baterie do s\xedt\u011B ur\u010D\xed syst\xe9m v dob\u011B nejvy\u0161\u0161\xed denn\xed ceny a vybije jen tu energii, kter\xe1 nebude pot\u0159eba na b\u011B\u017Enou spot\u0159ebu objektu.","spot.summary.boiler":"Bojler","spot.summary.boiler.help":"Nah\u0159\xedv\xe1n\xed bojleru syst\xe9m napl\xe1nuje v dob\u011B n\xedzk\xfdch cen a bere v potaz aktu\xe1ln\xed teplotu vody v bojleru, jeho kapacitu a po\u017Eadovanou teplotu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nah\u0159\xedv\xe1n\xed tak, aby do\u0161lo k jeho nah\u0159\xe1t\xed.","spot.summary.heat_pump":"Tepeln\xe9 \u010Derpadlo","spot.summary.heat_pump.help":"Tepeln\xe9 \u010Derpadlo m\u016F\u017Ee b\u011B\u017Eet ve t\u0159ech re\u017Eimech: zv\xfd\u0161en\xfd v\xfdkon, b\u011B\u017En\xfd chod a omezen\xfd v\xfdkon. Zv\xfd\u0161en\xfd v\xfdkon se vyu\u017E\xedv\xe1 v dob\u011B n\xedzk\xfdch cen, b\u011B\u017En\xfd chod v dob\u011B st\u0159edn\xedch cen a omezen\xfd v\xfdkon v dob\u011B vysok\xfdch cen. Odlo\u017Een\xed spot\u0159eby \u010Di zv\xfd\u0161en\xed spot\u0159eby lze povolit v menu tepeln\xe9ho \u010Derpadla.","spot.summary.heat_pump_level.increase":"Z\xfd\u0161en\xfd v\xfdkon","spot.summary.heat_pump_level.normal":"B\u011B\u017En\xfd chod","spot.summary.heat_pump_level.reduction":"Omezen\xfd v\xfdkon","spot.summary.price":"Cena","spot.summary.price_buy":"Cena s distribuc\xed","spot.summary.price_distribution":"Distribuce","spot.summary.price_level":"Hladina ceny","spot.summary.price_level.help":"Infigy se\u0159ad\xed hodinov\xe9 ceny spotu od nejni\u017E\u0161\xed po nejvy\u0161\u0161\xed a rozd\u011Bl\xed je do t\u0159\xed \u010D\xe1st\xed, p\u0159ibli\u017En\u011B stejn\u011B velk\xfdch. Pokud hodinnov\xe9 ceny za\u010D\xednaj\xed na hodnot\u011B 3 K\u010D a kon\u010D\xed na hodnot\u011B 10 K\u010D, tak n\xedzk\xe1 cena m\u016F\u017Ee m\xedt roztpyl 3-6 K\u010D, st\u0159edn\xed 6-7 K\u010D a vysok\xe1 7-10 K\u010D. Rozptyl bude ka\u017Ed\xfd den jin\xfd, z\xe1le\u017E\xed na \u010Detnosti hodnot v dan\xe9 cenov\xe9 hladin\u011B.","spot.summary.price_level.hi":"Vysok\xe1 cena","spot.summary.price_level.low":"N\xedzk\xe1 cena","spot.summary.price_level.mid":"St\u0159edn\xed cena","spot.summary.price_level_15m":"Hladina ceny 15m","spot.summary.price_sell":"Cena bez distribuce","spot.summary.spotOverflow":"P\u0159etok do s\xedt\u011B","spot.summary.spotOverflow.allowed":"Povolen\xfd","spot.summary.spotOverflow.help":"Povolen\xed p\u0159etoku do s\xedt\u011B p\u0159i spotov\xe9m obchodov\xe1n\xed porovn\xe1v\xe1 cenu spotu v danou hodinu a pokud je ni\u017E\u0161\xed ne\u017E Cena pro z\xe1kaz p\u0159etok\u016F z nastaven\xed, tak syst\xe9m automaticky v danou hodinu p\u0159etok zak\xe1\u017Ee.","spot.summary.spotOverflow.restricted":"Omezen\xfd","spot.summary.state.active":"Aktivn\xed","spot.summary.state.inactive":"Neaktivn\xed","spot.summary.time":"\u010Cas","spot.user.parameters":"Parametry spotov\xe9ho obchodov\xe1n\xed","spot_wizard.banner.button":"Chci poradit","spot_wizard.banner.subtitle":"Pr\u016Fvodce v\xe1m pom\u016F\u017Ee s nastaven\xedm spotov\xe9ho obchodov\xe1n\xed.","spot_wizard.banner.title":"T\xe1pete? Porad\xedm V\xe1m","spot_wizard.battery_discharge.paragraph1":"Toto nastaven\xed zak\xe1\u017Ee vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 cen\u011B spotu. D\xedky tomu si uchov\xe1te energii pro vy\u0161\u0161\xed ceny dne.","spot_wizard.battery_discharge.paragraph2":"Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete z\xe1kaz deaktivovat.","spot_wizard.battery_discharge.title":"Vyb\xedjen\xed baterie do vlastn\xed spot\u0159eby","spot_wizard.battery_purchase.paragraph1":"Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny nab\xedt baterii z n\xedzk\xe9ho spotu.","spot_wizard.battery_purchase.paragraph2":"V\u011Bnujte pozornost nastaven\xed strategie. Pokud nastav\xedte 20%, Infigy bude sp\xed\u0161e \u010Dekat na fotovoltaiku. Naopak p\u0159i nastaven\xed 70% bude sp\xed\u0161e nakupovat na spotu. Doporu\u010Dujeme nastavit 25%.","spot_wizard.battery_purchase.paragraph3":"Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete nab\xedjen\xed deaktivovat.","spot_wizard.battery_purchase.title":"N\xe1kup energie do baterie","spot_wizard.boiler.paragraph1":"Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny oh\u0159\xe1t bojler z nejlevn\u011Bj\u0161\xedch cen dne do nastaven\xe9 teploty. Infigy st\xe1le udr\u017Euje z\xe1kladn\xed teplotu a vyu\u017E\xedv\xe1 nav\xfd\u0161en\xed teploty na teplotu ze spotu.","spot_wizard.boiler.paragraph2":"Z\xe1rove\u0148 je mo\u017En\xe9 blokovat oh\u0159ev p\u0159i st\u0159edn\xed a nebo vysok\xe9 cen\u011B.","spot_wizard.boiler.paragraph3":"Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete teplotu nastavit na 10\xb0C a deaktivovat blokaci oh\u0159evu.","spot_wizard.boiler.title":"Oh\u0159ev bojleru","spot_wizard.dialog.finish":"Dokon\u010Dit","spot_wizard.dialog.next":"Dal\u0161\xed","spot_wizard.dialog.prev":"Zp\u011Bt","spot_wizard.dialog.step":"Krok {current} z {total}","spot_wizard.dialog.title":"Pr\u016Fvodce nastaven\xedm spotu","spot_wizard.distribution_prices.title":"Zadejte cenu za distribuci v n\xedzk\xe9m a vysok\xe9m tarifu","spot_wizard.done.description":"Pro\u0161li jste nastaven\xed spotu. Ve\u0161ker\xe9 parametry lze upravit ve spodn\xed \u010D\xe1sti str\xe1nky Spot, kde m\u016F\u017Eete i op\u011Bt vyvolat tohoto pr\u016Fvodce.","spot_wizard.done.title":"Hotovo","spot_wizard.evening_peak_discharge.paragraph1":"Infigy automaticky odhadne spot\u0159ebu energie do rann\xedch hodin. Nadbytek m\u016F\u017Ee b\xfdt prod\xe1n za nejvy\u0161\u0161\xed cenu dne.","spot_wizard.evening_peak_discharge.paragraph2":"Pokud m\xe1te pouze n\xe1kup energie na spotu, m\u016F\u017Eete vyb\xedjen\xed deaktivovat.","spot_wizard.evening_peak_discharge.title":"Vyb\xedjen\xed baterie p\u0159i ve\u010Dern\xed \u0161pi\u010Dce","spot_wizard.general_settings.title":"Nejprve obecn\xe9 nastaven\xed","spot_wizard.hdo_times.title":"Nastaven\xed HDO \u010Das\u016F ur\u010D\xed obdob\xed n\xedzk\xe9ho tarifu","spot_wizard.heat_pump.paragraph1":"Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny navy\u0161ovat v\xfdkon tepeln\xe9ho \u010Derpadla p\u0159i n\xedzk\xe9 cen\u011B a naopak sni\u017Eovat v\xfdkon p\u0159i vysok\xe9 cen\u011B.","spot_wizard.heat_pump.paragraph2":"Pokud m\xe1te pouze prodej energie na spotu, odlo\u017Een\xed i v\xfd\u0161en\xed spot\u0159eby deaktivovat.","spot_wizard.heat_pump.title":"Tepeln\xe9 \u010Derpadlo","spot_wizard.info.button1":"Pro\u010D se mi dnes nenabila baterie ze spotu?","spot_wizard.info.button2":"Pro\u010D se mi dnes nevyb\xedjela baterie do spotu?","spot_wizard.info.button3":"Chci pomoc s nastaven\xedm","spot_wizard.info.help1.title":"Pro\u010D se mi dnes nenabila baterie ze spotu?","spot_wizard.info.help2.title":"Pro\u010D se mi dnes nevyb\xedjela baterie do spotu?","spot_wizard.info.title":"Informace ke spotu","spot_wizard.overflow_limit.paragraph1":"Pokud m\xe1te spot pouze pro n\xe1kup energie, m\u016F\u017Eete nastavit -10 K\u010D. P\u0159etok je omezen na maxim\xe1ln\xed velikost nastavenou servisn\xedm technikem.","spot_wizard.overflow_limit.paragraph2":"Pokud m\xe1te spot i pro prodej energie, je v\xfdhodn\xe9 zastavit akumulaci p\u0159i cen\u011B, kter\xe1 odpov\xedd\xe1 provizi Va\u0161eho dodavatele. Provize b\xfdv\xe1 nej\u010Dast\u011Bji 0.30 - 0.70 K\u010D/kWh.","spot_wizard.overflow_limit.title":"Omezen\xed p\u0159etoku do s\xedt\u011B","spot_wizard.preferential_sale.paragraph1":"Tato funkce umo\u017En\xed z\xe1kaz ukl\xe1d\xe1n\xed energie p\u0159i rann\xed \u0161pi\u010Dce. Dojde k deaktivaci nab\xedjen\xed baterie, bojleru a tepeln\xe9ho \u010Derpadla. Akumulace se aktivuje p\u0159i n\xedzk\xe9 cen\u011B nebo p\u0159i prod\xe1n\xed odhadovan\xe9ho p\u0159ebytku energie.","spot_wizard.preferential_sale.paragraph2":"Pokud m\xe1te pouze n\xe1kup energie na spotu, m\u016F\u017Eete funkci deaktivovat.","spot_wizard.preferential_sale.title":"P\u0159ednostn\xed prodej energie","statistics.battery.statistics":"\xdarove\u0148 nabit\xed baterie","statistics.boiler.statistics":"Oh\u0159ev bojleru elektrokotlem","statistics.electrical_grid.statistics":"N\xe1kup z distribu\u010Dn\xed s\xedt\u011B","statistics.electrical_grid.statistics_house_consumption":"Spot\u0159eba objektu","statistics.electrical_grid.statistics_overflow":"P\u0159etok do distribu\u010Dn\xed s\xedt\u011B","statistics.heatpump.statistics":"Spot\u0159eba kompresoru","statistics.outdoor_temperature.statistics":"Venkovn\xed teplota","statistics.photovoltaics.statistics":"V\xfdroba elektr\xe1rny","statistics.plug.statistics":"Spot\u0159eba z\xe1suvky","statistics.wind.statistics":"V\xfdroba v\u011Btrn\xe9 elektr\xe1rny","stats_delete.button":"Smazat","stats_delete.cancel":"Zru\u0161it","stats_delete.confirm":"Smazat","stats_delete.confirm.title":"Opravdu chcete smazat v\u0161echny statistiky?","stats_delete.title":"Smazat v\u0161echny statistiky","stats_export.button":"Export","stats_export.from":"Od","stats_export.metric":"Metrika","stats_export.title":"Exportovat statistiky","stats_export.to":"Od","status.heatWater.flexibility":"Flexibilita aktivn\xed, vyt\xe1p\u011Bn\xed tepl\xe9 vody","status.heatWater.heating":"Vyt\xe1p\u011Bn\xed tepl\xe9 vody","status.heatWater.hwError":"Bojler je nah\u0159\xe1t\xfd nebo nedostupn\xfd","status.heatWater.inverterError":"P\u0159edeh\u0159ev bojleru neaktivn\xed, nen\xed dostupn\xfd st\u0159\xedda\u010D","status.heatWater.legionella":"Sanace vody","status.heatWater.notConnected":"Nelze nav\xe1zat spojen\xed","status.heatWater.notLicensed":"\u0158\xedzen\xed bojleru nen\xed licencovan\xe9","status.heatWater.off":"Vypnuto","status.heatWater.overload":"P\u0159et\xed\u017Een\xed s\xedt\u011B, vyt\xe1p\u011Bn\xed zastaveno","status.heatWater.pvHeating":"Vyt\xe1p\u011Bn\xed z p\u0159ebytk\u016F","status.heatWater.smartMeterError":"P\u0159edeh\u0159ev bojleru neaktivn\xed, nen\xed dostupn\xfd elektrom\u011Br","status.heatWater.spotHeating":"Vyt\xe1p\u011Bn\xed tepl\xe9 vody ze spotu","status.heatWater.stop":"STOP","status.heatWater.stopHDO":"Oh\u0159ev blokov\xe1n p\u0159i vysok\xe9m tarifu","status.heatWater.stopSOC":"Blokace vyt\xe1p\u011Bn\xed, n\xedzk\xfd stav baterie","status.heatWater.stopSell":"P\u0159edeh\u0159ev blokov\xe1n, prodej energie","status.heatWater.tempError":"Teplotn\xed \u010Didlo nen\xed dostupn\xe9","status.photovoltaic.dischargeBlockedByComponents":"Vyb\xedjen\xed baterie pozastaveno kv\u016Fli spot\u0159eb\u011B vybran\xfdch technologi\xed","status.photovoltaic.dischargeBlockedByHDO":"Vyb\xedjen\xed baterie pozastaveno, aktivn\xed vysok\xfd tarif (HDO)","status.photovoltaic.discharging":"Vyb\xedjen\xed baterie","status.photovoltaic.distributionLimit":"Distribuce omezuje v\xfdkon","status.photovoltaic.feedInPriority":"Priorita p\u0159etoku do s\xedt\u011B","status.photovoltaic.flexibilityBatteryStop":"Flexibilita aktivn\xed, zastaveno vyb\xedjen\xed i nab\xedjen\xed baterie","status.photovoltaic.flexibilityCharging":"Flexibilita aktivn\xed, nab\xedjen\xed baterie ze s\xedt\u011B","status.photovoltaic.flexibilityDischarging":"Flexibilita aktivn\xed, vyb\xedjen\xed baterie do s\xedt\u011B","status.photovoltaic.flexibilityDoNotDischarge":"Flexibilita aktivn\xed, z\xe1kaz vyb\xedjen\xed baterie","status.photovoltaic.flexibilityFeedInPriority":"Flexibilita aktivn\xed, priorita p\u0159etoku do s\xedt\u011B","status.photovoltaic.flexibilityOverflowRestricted":"Flexibilita aktivn\xed, z\xe1kaz p\u0159etoku do s\xedt\u011B","status.photovoltaic.forcedOverflow":"Flexibilita aktivn\xed, vynucen\xfd p\u0159etok do s\xedt\u011B","status.photovoltaic.idle":"Re\u017Eim sp\xe1nku","status.photovoltaic.manualCharging":"Ru\u010Dn\xed nab\xedjen\xed baterie","status.photovoltaic.manualDischarging":"Ru\u010Dn\xed vyb\xedjen\xed baterie","status.photovoltaic.noneInverter":"Typ st\u0159\xedda\u010De nenastaven","status.photovoltaic.notConnected":"Nelze nav\xe1zat spojen\xed","status.photovoltaic.notLicensed":"\u0158\xedzen\xed FVE nen\xed licencovan\xe1","status.photovoltaic.planCharge":"Pl\xe1novan\xe9 nab\xedjen\xed baterie","status.photovoltaic.planDischarge":"Pl\xe1novan\xe9 vyb\xedjen\xed baterie","status.photovoltaic.production":"V\xfdroba energie","status.photovoltaic.sellBatteryEnergy":"Prodej energie z baterie","status.photovoltaic.spotCharging":"Nab\xedjen\xed baterie ze spotu","status.photovoltaic.spotStopDischarging":"Zastaveno vyb\xedjen\xed, je n\xedzk\xe1 cena na spotu","status.photovoltaic.standby":"Stand-by re\u017Eim","status.photovoltaic.startUp":"Startovac\xed re\u017Eim","status.plug.batteryControl":"Z\xe1suvka aktivn\xed podle baterie","status.plug.manualControl":"Z\xe1suvka aktivn\xed v manu\xe1ln\xedm m\xf3du","status.plug.notActive":"Z\xe1suvka neaktivn\xed","status.plug.notConnected":"Z\xe1suvka nen\xed dostupn\xe1","status.plug.overflowControl":"Z\xe1suvka aktivn\xed podle p\u0159etoku","status.plug.spotControl":"Z\xe1suvka aktivn\xed podle spotu","status.plug.stop":"STOP","status.plug.timeControl":"Z\xe1suvka aktivn\xed podle \u010Dasu","status.smartMeter.consumption":"B\u011B\u017En\xfd odb\u011Br domu","status.smartMeter.maxLoad":"Maxim\xe1ln\xed odb\u011Br domu","status.smartMeter.none":"","status.smartMeter.overflow":"P\u0159etok energie","status.smartMeter.overflowLimited":"P\u0159etok omezen z d\u016Fvodu z\xe1porn\xe9 ceny","status.smartMeter.shortage":"V\xfdpadek distribu\u010Dn\xed s\xedt\u011B","status.spotBattery.flexibilityPV":"Flexibilita vyu\u017Eita pro FVE","status.spotBattery.flexibilitySpot":"Flexibilita vyu\u017Eita pro SPOT","status.spotBattery.noData":"Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data","status.spotBattery.spotNotLicensed":"Spot nen\xed licencovan\xfd","status.spotBatteryChargeFromGrid.batteryChargingNotActive":"Nen\xed aktivovan\xe9 nab\xedjen\xed ze s\xedt\u011B","status.spotBatteryChargeFromGrid.batteryChargingPlanned":"Dnes je nab\xedjen\xed aktivn\xed","status.spotBatteryChargeFromGrid.enoughPVEnergy":"Dnes se o\u010Dek\xe1v\xe1 denn\xed p\u0159ebytek pro nabit\xed baterie","status.spotBatteryChargeFromGrid.priceDifferenceTooLow":"Dnes nen\xed spln\u011Bn\xfd minim\xe1ln\xed rozd\xedl ceny","status.spotBatteryChargeFromGrid.spotNotActive":"Nen\xed aktivn\xed spotov\xe9 obchodov\xe1n\xed","status.spotBatteryDischargeToGrid.batteryDischargingNotActive":"Nen\xed aktivovan\xe9 vyb\xedjen\xed do s\xedt\u011B","status.spotBatteryDischargeToGrid.batteryDischargingPlanned":"Dnes je vyb\xedjen\xed aktivn\xed","status.spotBatteryDischargeToGrid.minPriceNotReached":"Dnes nen\xed spln\u011Bn\xe1 minim\xe1ln\xed cena pro prodej","status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy":"Dnes se o\u010Dek\xe1v\xe1 vybit\xed baterie p\u0159es noc do vlastn\xed spot\u0159eby","status.spotBatteryDischargeToGrid.spotNotActive":"Nen\xed aktivn\xed spotov\xe9 obchodov\xe1n\xed","status.spotBatteryDischargeToHome.automaticDischargeMode":"Automatick\xe9 vyb\xedjen\xed baterie dle kapacity","status.spotBatteryDischargeToHome.highPriceDischargeMode":"Vyb\xedjen\xed baterie p\u0159i vysok\xe9 cen\u011B","status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode":"Vyb\xedjen\xed baterie p\u0159i st\u0159edn\xed a vysok\xe9 cen\u011B","status.spotBatteryDischargeToHome.notControlled":"Vyb\xedjen\xed baterie nen\xed omezeno","status.spotHeatPump.flexibilityPV":"Flexibilita vyu\u017Eita pro FVE","status.spotHeatPump.flexibilitySpot":"Flexibilita vyu\u017Eita pro SPOT","status.spotHeatPump.noData":"Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data","status.spotHeatPump.spotNotLicensed":"Spot nen\xed licencovan\xfd","status.spotHeatWater.flexibilityPV":"Flexibilita vyu\u017Eita pro FVE","status.spotHeatWater.flexibilitySpot":"Flexibilita vyu\u017Eita pro SPOT","status.spotHeatWater.noData":"Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data","status.spotHeatWater.spotNotLicensed":"Spot nen\xed licencovan\xfd","status.spotSmartMeter.noData":"Pro \u0159\xedzen\xed nejsou aktu\xe1ln\xed data","status.spotSmartMeter.overflowDisabled":"Trval\xe9 omezen\xed p\u0159etoku","status.spotSmartMeter.overflowFlexibilitySell":"Optimalizace p\u0159etoku pro prodej","status.spotSmartMeter.overflowLimited":"P\u0159etok omezen z d\u016Fvodu z\xe1porn\xe9 ceny","status.spotSmartMeter.spotNotLicensed":"Spot nen\xed licencovan\xfd","status.spotSmartMeter.withoutReduction":"Bez omezen\xed","status.wind.production":"V\xfdroba energie","status.wind.stop":"STOP","status.wind.unavailable":"Za\u0159\xedzen\xed nen\xed dostupn\xe9","subscriptions.fetch":"Aktualizovat p\u0159edplatn\xe9","subscriptions.fetch.button":"Aktualizovat p\u0159edplatn\xe9","subscriptions.last_fetch_at":"Posledn\xed aktualizace","subscriptions.premium_active":"Premium aktivn\xed","subscriptions.title":"P\u0159edplatn\xe9","test-product.app":"Aplikace","test-product.settings":"Nastaven\xed","test-product.settings.distribution":"Distribuce","test-product.settings.distribution.Dzd":"DZD","test-product.settings.distribution.Infigy":"Infigy","test-product.settings.distribution.solid_sun":"SolidSun","test-product.settings.license":"Licence","test-product.settings.license.HW":"HW","test-product.settings.license.Industrial":"Industrial","test-product.settings.license.Play":"PLAY","test-product.settings.license.Smart":"Smart","test-product.settings.license.basic":"Basic","test-product.test":"Test za\u0159\xedzen\xed","test-product.test.DC":"Kontrola DC obvodu","test-product.test.DC.subtitle":"Dota\u017Een\xed svorek, dimenze kabel\u016F","test-product.test.component":"Kontrola komponent\u016F","test-product.test.component.subtitle":"Je p\u0159ibaleno \u010Didlo, \u0161t\xedtky, ...?","test-product.test.electricmeter":"Kontrola elektrom\u011Bru","test-product.test.electricmeter.subtitle":"Kontrola osazen\xed elektrom\u011Bru pro st\u0159\xedda\u010D","test-product.test.internet-connect":"P\u0159ipojen\xed k internetu","test-product.test.inverter-connect":"P\u0159ipojen\xed st\u0159\xedda\u010De","test-product.test.license":"Licence","test-product.test.license-info":"Test skon\u010D\xed za:","test-product.test.phase_1":"Test 1. f\xe1ze","test-product.test.phase_2":"Test 2. f\xe1ze","test-product.test.phase_3":"Test 3. f\xe1ze","test-product.test.serialNumber":"V\xfdrobn\xed \u010D\xedslo jednotky","test-product.test.serialNumber.label":"S\xe9riov\xe9 \u010D\xedslo","test-product.test.serialNumber.subtitle":"Bez v\xfdrobn\xedho \u010D\xedsla nelze zadat jm\xe9no testera a aktivovat test","test-product.test.serialNumberSwitchboard":"V\xfdrobn\xed \u010D\xedslo rozvad\u011B\u010De","test-product.test.serialNumberSwitchboard.label":"S\xe9riov\xe9 \u010D\xedslo","test-product.test.serialNumberSwitchboard.subtitle":"Vyplnit v p\u0159\xedpad\u011B, \u017Ee je za\u0159\xedzen\xed v origin\xe1ln\xedm rozvad\u011B\u010Di","test-product.test.start":"Pokud je za\u0159\xedzen\xed p\u0159ipojeno","test-product.test.start.button":"Aktivovat test","test-product.test.switchboard":"Kontrola shody rozvad\u011B\u010De","test-product.test.switchboard.subtitle":"Kontrola dota\u017Een\xed svorek, um\xedst\u011Bn\xed komponent\u016F, spr\xe1vn\xe9 dimenze kabel\u016F","test-product.test.temp":"Teplotn\xed \u010Didlo","test-product.test.tester":"Za\u0159\xedzen\xed otestoval","test-product.test.tester.subtitle":"Bez jm\xe9na nelze aktivovat test","thermostat.general":"Spole\u010Dn\xe9 nastaven\xed","thermostat.general.cooling":"Chlazen\xed aktivn\xed","thermostat.general.cooling.pvstability":"Potenci\xe1l aktivace zdroje","thermostat.general.heating":"Vyt\xe1p\u011Bn\xed aktivn\xed","thermostat.range":"Termostat","thermostat.range.flexibility-temperature":"Flexibiln\xed teplota","thermostat.range.flexibility-temperature.subtitle":"Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t nebo p\u0159edchladit d\u016Fm","thermostat.range.flexibility_status":"Re\u017Eim flexibility termostatu","thermostat.range.on":"Termostat aktivn\xed","thermostat.range.on.subtitle":"Z\xe1kladn\xed teplota","thermostat.range.pv-flexibility":"\u0158\xedzen\xed podle fotovoltaiky","thermostat.range.set_temperature":"Nastaven\xe1 teplota","thermostat.range.sp-flexibility-down":"Odlo\u017Een\xed spot\u0159eby podle spotu","thermostat.range.sp-flexibility-up":"Zv\xfd\u0161en\xed spot\u0159eby podle spotu","thermostat.range.status":"Re\u017Eim termostatu","thermostat.range.temperature":"Aktu\xe1ln\xed teplota","thermostat.status":"Re\u017Eim termostatu","wallbox.3a.on":"M\xf3d 3A","wallbox.3a.on_sub":"Nab\xedjen\xed m\u016F\u017Ee br\xe1t 3A z distribu\u010Dn\xed s\xedt\u011B","wallbox.6a.on":"M\xf3d 6A","wallbox.6a.on_sub":"Nab\xedjen\xed lze pouze z FVE","wallbox.NO_CHARGE":"Nenab\xedjej","wallbox.NO_CHARGE.on_sub":"Nab\xedjen\xed je trvale blokov\xe1no, spust\xed jej pouze \u010Dasov\xfd pl\xe1n","wallbox.PV":"Nab\xedjen\xed podle baterie","wallbox.PV.batteryStart":"Zapnout p\u0159i nabit\xed","wallbox.PV.batteryStart.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se aktivuje nab\xedjen\xed","wallbox.PV.batteryStop":"Vypnout p\u0159i nabit\xed","wallbox.PV.batteryStop.subtitle":"Nabit\xed baterie p\u0159i kter\xe9m se vypne nab\xedjen\xed","wallbox.PV.on_sub":"Po dosa\u017Een\xed z\xe1kladn\xed energie dojde k nab\xedjen\xed pouze p\u0159i nabit\xe9 baterii","wallbox.PV2":"Nab\xedjen\xed podle FVE","wallbox.PV2.on_sub":"\u0158\xedzen\xed nab\xedjen\xed podle v\xfdkonu FVE","wallbox.PV_FAST":"P\u0159ednostn\xed nab\xedjen\xed podle baterie","wallbox.PV_FAST.batteryMinSoc":"Minim\xe1ln\xed rezerva baterie","wallbox.PV_FAST.batteryMinSoc.subtitle":"Baterie se kv\u016Fli nab\xedjen\xed automobilu nevybije pod tuto hodnotu. Dokud nen\xed hodnota p\u0159ekro\u010Dena, nab\xedjen\xed \u010Dek\xe1","wallbox.PV_FAST.on_sub":"Nab\xedjen\xed automobilu bude zcela prioritn\xed. Bude vyu\u017E\xedv\xe1na pouze energie z baterie nebo FVE","wallbox.SPOT":"Nab\xedjen\xed podle spotu","wallbox.SPOT.hi":"Blokovat nab\xedjen\xed p\u0159i vysok\xe9 cen\u011B","wallbox.SPOT.mi":"Blokovat nab\xedjen\xed p\u0159i st\u0159edn\xed cen\u011B","wallbox.SPOT.on_sub":"Po dosa\u017Een\xed z\xe1kladn\xed energie dojde k blokov\xe1n\xed p\u0159i vysok\xe9 cen\u011B spotu","wallbox.active":"{name}","wallbox.active.subtitle":"Aktivn\xed","wallbox.alfen":"Alfen","wallbox.authorization.status":"Autorizace","wallbox.authorization.status.authorized":"Autorizov\xe1no{cardInfo}","wallbox.authorization.status.denied":"Zam\xedtnuto{cardInfo}","wallbox.authorization.status.pending":"Nen\xed autorizov\xe1no","wallbox.authorization.status.unknown":"Nezn\xe1m\xfd stav","wallbox.az_router":"AZ Router","wallbox.common":"Obecn\xe9 informace","wallbox.common.power":"Aktu\xe1ln\xed spot\u0159eba","wallbox.common.power_today":"Dne\u0161n\xed spot\u0159eba:","wallbox.common.power_total":"Celkov\xe1 spot\u0159eba","wallbox.common.power_year":"Ro\u010Dn\xed spot\u0159eba:","wallbox.control":"Re\u017Eim nab\xedjen\xed","wallbox.ecovolter":"EcoVolter","wallbox.evmate":"EVmate","wallbox.fast-charge.energy":"Energie pro rychl\xe9 nabit\xed","wallbox.fast-charge.energy_actual":"Aktu\xe1ln\xed cyklus:","wallbox.fast-charge.energy_sub":"Energie, kter\xe1 je v\u017Edy co nejrychleji nabita. Po dosa\u017Een\xed t\xe9to hodnoty je nabit\xed \u0159\xedzeno jedn\xedm z re\u017Eim\u016F","wallbox.goodwe-ev-charger":"Goodwe","wallbox.inactive.subtitle":"Neaktivn\xed","wallbox.mode.pv.batteryStopConflict.description":"Pokud je zapnut\xe1 blokace baterie p\u0159i provozu wallboxu, nelze zapnout re\u017Eim \u201ENab\xedjen\xed podle baterie\u201C. Pro zapnut\xed re\u017Eimu \u201ENab\xedjen\xed podle baterie\u201C je nutn\xe9 nejprve vypnout blokaci baterie na str\xe1nce \u201EFotovoltaika\u201C.","wallbox.mode.pv.batteryStopConflict.title":"Re\u017Eim nelze zapnout","wallbox.mybox":"MyBox","wallbox.none":"\u017D\xe1dn\xfd","wallbox.nonemode":"B\u011B\u017En\xe9 nab\xedjen\xed","wallbox.nonemode.amper-auto":"Automatick\xe9 \u0159\xedzen\xed nab\xedjec\xedho proudu","wallbox.nonemode.amper-auto.subtitle":"\u0158\xedd\xed nab\xedjen\xed aby se minimalizovalo nab\xedjen\xed a vyb\xedjen\xed baterie","wallbox.nonemode.ampers":"Maxim\xe1ln\xed nab\xedjec\xed proud","wallbox.nonemode.hdo":"Nab\xedjen\xed pouze p\u0159i n\xedzk\xe9m tarifu","wallbox.nonemode.hdo_sub":"\u010Casy pro HDO mus\xed b\xfdt nastaveny v obecn\xe9m nastaven\xed","wallbox.nonemode.on_sub":"Auto se nab\xedj\xed co nejrychleji","wallbox.olife":"Olife","wallbox.other":"Ostatn\xed","wallbox.pv.ampers-auto":"Aktu\xe1ln\xed po\u017Eadovan\xfd nab\xedjec\xed proud","wallbox.schedules.description":"Napl\xe1nujte si nab\xedjen\xed elektromobilu podle pot\u0159eby.","wallbox.schedules.title":"Pl\xe1nova\u010D nab\xedjen\xed","wallbox.settings":"Nastaven\xed","wallbox.solax":"Solax - komunikace p\u0159es st\u0159\xedda\u010D","wallbox.solax-ev-charger":"Solax - komunikace p\u0159es Infigy","wallbox.statistics":"Statistiky","wallbox.status":"Re\u017Eim Wallboxu","wallbox.status.car_not_connected":"Auto nen\xed p\u0159ipojeno","wallbox.status.charging":"Nab\xedjen\xed","wallbox.status.charging_with_ventilation":"Nab\xedjen\xed auta s ventil\xe1torem","wallbox.status.error":"Chyba nab\xedjen\xed","wallbox.status.home":"Re\u017Eim wallboxu","wallbox.status.normal":"B\u011B\u017En\xfd re\u017Eim","wallbox.status.not_connected":"Nelze nav\xe1zat spojen\xed","wallbox.status.off":"Wallbox vypnut\xfd","wallbox.status.ready":"P\u0159ipraveno k nab\xedjen\xed","wallbox.sub_status.auto":"podle auto. re\u017Eimu","wallbox.sub_status.basic_energy":"z\xe1kladn\xed energi\xed","wallbox.sub_status.battery":"podle baterie","wallbox.sub_status.battery_fast":"p\u0159ednostn\u011B podle baterie","wallbox.sub_status.battery_waiting":", \u010Dek\xe1n\xed na nab\xedt\xed baterie","wallbox.sub_status.hdo_block":", blokace HDO","wallbox.sub_status.no_charging":", nab\xedjen\xed je zak\xe1z\xe1no","wallbox.sub_status.none":"","wallbox.sub_status.photovoltaics":"podle FVE","wallbox.sub_status.schedule":"podle pl\xe1nova\u010De","wallbox.sub_status.spot":"podle SPOTU","wallbox.sub_status.spot_high":", je vysok\xe1 cena SPOTU","wallbox.sub_status.spot_mid":", je st\u0159edn\xed cena SPOTU","wallbox.victron-ev-charger":"Victron EV Charger","wallbox.wallboxes.title":"Wallboxy","wallbox_rfid.add_button":"P\u0159idat RFID kartu","wallbox_rfid.delete.cancel":"Zru\u0161it","wallbox_rfid.delete.confirm":"Smazat","wallbox_rfid.delete.confirm.title":"Smazat kartu {name}?","wallbox_rfid.dialog.already_exists":"Karta {id} je ji\u017E ulo\u017Eena pod n\xe1zvem {name}.","wallbox_rfid.dialog.already_exists_hint":"P\u0159ilo\u017Ete jinou kartu nebo zav\u0159ete dialog.","wallbox_rfid.dialog.cancel":"Zru\u0161it","wallbox_rfid.dialog.name_label":"N\xe1zev karty","wallbox_rfid.dialog.save":"Ulo\u017Eit","wallbox_rfid.dialog.scanned_id":"ID karty: {id}","wallbox_rfid.dialog.title":"P\u0159idat RFID kartu","wallbox_rfid.dialog.waiting":"P\u0159ilo\u017Ete kartu ke \u010Dte\u010Dce\u2026","wallbox_rfid.edit.dialog.title":"Upravit RFID kartu","wallbox_wizard.cancel":"Zru\u0161it","wallbox_wizard.custom_device_ip_address.alert":"Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa wallboxu nebude m\u011Bnit (nap\u0159. kdy\u017E wallbox vyu\u017E\xedv\xe1 adresu z DHCP).","wallbox_wizard.custom_device_ip_address.input":"IP adresa wallboxu","wallbox_wizard.multiple_wallboxes.alert":"Pro nastaven\xed v\xedce wallbox\u016F pros\xedm kontaktujte linku podpory. Kontakt najdete v technick\xe9 wiki Infigy.","wallbox_wizard.multiple_wallboxes.label":"V\xedce wallbox\u016F","wallbox_wizard.open":"Nastavit wallbox","wallbox_wizard.save":"Ulo\u017Eit","wallbox_wizard.title":"Nastaven\xed wallbox","welcome.subtitle":"Aplikace pro dom\xe1c\xed a modern\xed energetiku na jednom m\xedst\u011B! Lorem ispum dolor sit anem","welcome.title":"V\xedtejte v Infigy!","wifi_ap_config.interface_block.confirm.confirmation_text":"{blocked, select, true {Zablokovat} other {Odblokovat}}","wifi_ap_config.interface_block.confirm.content":"Opravdu chcete {blocked, select, true {zablokovat} other {odblokovat}} WiFi?","wifi_ap_config.interface_block.confirm.title":"Zm\u011Bna stavu WiFi","wifi_ap_config.passphrase_change.confirm.passphrase":"Heslo","wifi_ap_config.passphrase_change.confirm.title":"Zm\u011Bna hesla k WiFi","wifi_ap_config.wifi_interface_blocked.button":"{blocked, select, true {Odblokovat} other {Zablokovat}}","wifi_ap_config.wifi_interface_blocked.title":"Stav WiFi","wifi_ap_config.wifi_interface_blocked.value":"{blocked, select, true {Zablokov\xe1n} other {Aktivn\xed}}","wind.common":"Obecn\xe9 informace","wind.common.battery_charged_total":"Celkem do baterie:","wind.common.battery_power":"V\xfdkon do baterie","wind.common.power":"Aktu\xe1ln\xed v\xfdkon","wind.common.power_today":"Dne\u0161n\xed v\xfdroba:","wind.common.power_total":"Celkov\xe1 v\xfdroba","wind.common.power_year":"Ro\u010Dn\xed v\xfdroba:","wind.common.resistor_power":"V\xfdkon do odporu","wind.statistics":"Statistiky","wind.statistics.power":"V\xfdkon v\u011Btrn\xe9 elektr\xe1rny","wind.statistics.wind_speed":"Rychlost v\u011Btru","wind.status":"Re\u017Eim v\u011Btrn\xe9 elektr\xe1rny"}');


var $20f706d5b1546263$exports = {};
$20f706d5b1546263$exports = JSON.parse('{"\\"chart.tooltip.substat.phase\\"":"Phase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}","\\"chart.tooltip.substat.pv_string\\"":"{inverterName}, String {stringNumber}","TEST":"XXX","animation.battery":"Battery","animation.boiler":"Boiler","animation.consumption":"House","animation.electrical_grid":"Grid","animation.hp":"Heat pump","animation.photovoltaics":"Photovoltaics","animation.wallbox":"Wallbox","animation.wind":"Wind","app_messages.battery_max_soc":"Charging battery to set maximum SOC {maxSoc, number, ::.##}%","app_messages.battery_min_soc":"Discharging battery to set minimum SOC {minSoc, number, ::.##}%","app_messages.body.battery_max_soc":"The current battery charge level is {currentSoc, number, ::.##}%.","app_messages.body.battery_min_soc":"The current battery charge level is {currentSoc, number, ::.##}%.","app_messages.body.heat_pump_limit_exceeded":"The heat pump consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.","app_messages.body.heat_water_limit_exceeded":"The heat water consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.","app_messages.body.heat_water_max_temperature":"Today the boiler has already reached the maximum temperature {maxTemperature, number, ::.##}\xb0C.","app_messages.body.home_limit_exceeded":"The home consumption limit has been exceeded. The set limit is {value, number, ::.##} kW.","app_messages.body.inverter_production_mwh":"Your photovoltaic plant has already produced {inverterProductionValue, number, ::.##} MWh this year.","app_messages.body.spot_daily_prediction":"Daily prediction: {pvPrediction, select, true {Photovoltaics production: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Home consumption: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Battery storage: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boiler storage: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Heat pump consumption: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Remaining energy for sale: {salePredictionValue, number, ::.##} kWh. } other {} }","app_messages.body.spot_daily_summary":"Today on the spot: {nothingToReport, select, true {Nothing is planned.} other { {energyForSale, select, true {The plan is to sell in the morning. } other {} } {negativeIntervals, select, false {} other {Negative price ({negativeIntervals}), which will reduce overflow. } } {chargingIntervals, select, false {} other {Battery charging plan ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Battery discharging plan ({dischargingIntervals}). } } } }","app_messages.body.spot_negative_price_start":"The current spot price is negative after deducting the commission. The commission set in Infigy is {spotOffsetPrice, number, ::.##} CZK. The current spot price is {spotNegativePrice, number, ::.##} CZK.","app_messages.body.spot_negative_price_stop":"The current spot price is no longer negative and is {spotNegativePrice, number, ::.##} CZK. The commission is set in Infigy at {spotOffsetPrice, number, ::.##} CZK","app_messages.body.wallbox_limit_exceeded":"The charging limit of the electric vehicle has been exceeded. The set limit is {value, number, ::.##} kW.","app_messages.body.wallbox_stop_charging":"In this cycle, {wallboxConsumptionCycleValue, number, ::.##} kWh of energy was added.","app_messages.button":"Delete all messages","app_messages.cancel":"Cancel","app_messages.confirm":"Delete all messages","app_messages.confirm.title":"Do you really want to delete all messages?","app_messages.detail_dialog.close":"Read","app_messages.heat_pump_limit_exceeded":"The heat pump consumption limit has been exceeded","app_messages.heat_water_limit_exceeded":"The heat water consumption limit has been exceeded","app_messages.heat_water_max_temperature":"The maximum temperature of the water has been reached","app_messages.home_limit_exceeded":"The home consumption limit has been exceeded","app_messages.inverter_connected":"Communication with the inverter has been established","app_messages.inverter_disconnected":"Communication with the inverter has been lost","app_messages.inverter_production_mwh":"PV production milestone","app_messages.load_more":"Load more","app_messages.no_messages":"There are no notifications here yet","app_messages.spot_battery_discharge":"Spot-based discharge plan is {spotDischargePlan}","app_messages.spot_daily_prediction":"Daily prediction","app_messages.spot_daily_summary":"Daily summary of the spot plan","app_messages.spot_negative_price_start":"The spot price is negative","app_messages.spot_negative_price_stop":"The spot price is no longer negative","app_messages.spot_start_charging_battery":"Battery charging according to the spot price has started","app_messages.spot_start_discharging_battery":"Battery discharging to the grid according to the spot price has started","app_messages.spot_stop_charging_battery":"Battery charging according to the spot price has been stopped","app_messages.spot_stop_discharging_battery":"Battery discharging to the grid according to the spot price has been stopped","app_messages.test":"Test notification","app_messages.title":"Delete all messages","app_messages.utility_loss_start":"We have detected a power outage","app_messages.utility_loss_stop":"The power outage has been resolved","app_messages.wallbox_limit_exceeded":"The charging limit of the electric vehicle has been exceeded","app_messages.wallbox_start_charging":"The electric vehicle charging has started","app_messages.wallbox_stop_charging":"The electric vehicle charging has been stopped","app_update_overlay.subtitle":"Please wait. After the update, the application will restart and the window in the browser will automatically refresh","app_update_overlay.title":"Update in progress","audit_log.error":"Error while loading","audit_log.item.author":"Author","audit_log.item.date":"Date","audit_log.item.payload":"Event","audit_log.item.type":"Type","audit_log.title":"Audit Log","audit_log_delete.button":"Delete","audit_log_delete.cancel":"Cancel","audit_log_delete.confirm":"Delete","audit_log_delete.confirm.title":"Do you really want to delete all records in the audit log?","audit_log_delete.title":"Delete audit log","azRouters.add":"Add new AZ router","azRouters.addButton":"Add","azRouters.clientId":"Modbus ID","azRouters.clientId.value":"Modbus ID: {id}","azRouters.counts":"OK {ok} / Error {err}","azRouters.empty":"No AZ routers configured","azRouters.name":"Name","azRouters.status.error":"Error","azRouters.status.ok":"OK","azRouters.status.starting":"Starting","azRouters.title":"AZ routers","bez_dodavatele.business_flexibility.title":"Business flexibility","bez_dodavatele.enabled":"Integration enabled","bez_dodavatele.region":"Region code","bez_dodavatele.title":"bezDodavatele","boiler.blocking":"Heating blockage","boiler.common":"General information","boiler.common.phase_3":"Phase 3:","boiler.common.power":"Total consumption","boiler.common.power.phase_1":"Phase 1:","boiler.common.power.phase_2":"Phase 2:","boiler.common.power_today":"Today\'s consumption:","boiler.common.power_year":"Annual consumption:","boiler.common.temperature":"Current temperature","boiler.common.total":"Total consumption","boiler.settings":"Settings","boiler.settings.hdo":"Turn off the regular heating in the high tariff","boiler.settings.hdo.subtitle":"Times for the high tariff must be set in the general settings","boiler.settings.min_soc":"Heating block","boiler.settings.min_soc.subtitle":"Battery charge level at which heating is blocked during a power outage","boiler.settings.min_soc_utility":"Heating block when the grid is available","boiler.settings.min_soc_utility.subtitle":"Battery charge level at which heating is blocked during a power outage","boiler.settings.spot-hi":"Block heating at high spot price","boiler.settings.spot-mi":"Block heating at medium spot price","boiler.settings.temp":"Set temperature","boiler.settings.temp.subtitle":"A common temperature that is always available","boiler.settings.temp_ek":"Temperature from photovoltaics using electric boiler","boiler.settings.temp_ek.subtitle":"Preheating temperature that is only for a low price","boiler.settings.temp_spot":"Temperature from the spot using electric boiler","boiler.settings.temp_spot.subtitle":"Preheating temperature that is only for a low price","boiler.statistics":"Statistics","boiler.statisticsTemp":"Boiler temperature","boiler.status":"Boiler mode","boiler.status.home":"Boiler mode","boiler_test_trigger.button":"Test boiler","boiler_test_trigger.button.running":"Test is running","boiler_test_trigger.subtitle":"Verifies the correct connection and the set power of the boiler.","boiler_test_trigger.title":"Test boiler","boiler_test_wizard.acknowledge.condition":"For a correct boiler test, the consumption in the object must be constant or zero. Any fluctuations in consumption can affect the test. The current consumption of the object is {power}","boiler_test_wizard.acknowledge.config":"Currently, the {phaseLabel} boiler is set with a total power of {power}. These values must be set according to the label of the boiler.","boiler_test_wizard.acknowledge.confirm":"Confirm","boiler_test_wizard.acknowledge.phase1":"1-phase","boiler_test_wizard.acknowledge.phase3":"3-phase","boiler_test_wizard.acknowledge.phase_option":"{phase}. phase","boiler_test_wizard.acknowledge.phase_select":"Select phases to test. Unmarked phases will be skipped.","boiler_test_wizard.acknowledge.phase_select_empty":"Select at least one phase.","boiler_test_wizard.acknowledge.start":"Test boiler","boiler_test_wizard.acknowledge.title":"Information for the test","boiler_test_wizard.result.after":"Consumption of the object after activation","boiler_test_wizard.result.before":"Consumption of the object before activation","boiler_test_wizard.result.close":"Close","boiler_test_wizard.result.correct":"Correct boiler consumption","boiler_test_wizard.result.detail_toggle":"Test detail","boiler_test_wizard.result.header":"Test result:","boiler_test_wizard.result.phase_header":"{phase}. phase","boiler_test_wizard.result.real_power":"Estimated boiler power","boiler_test_wizard.result.rerun":"Run test again","boiler_test_wizard.result.set_power":"Set power","boiler_test_wizard.result.stable":"Measurement was stable","boiler_test_wizard.result.title":"Test result","boiler_test_wizard.running.activate":"Activation of the boiler phase","boiler_test_wizard.running.after":"Consumption of the object is {power}","boiler_test_wizard.running.before":"Consumption of the object before the test is {power}","boiler_test_wizard.running.measuring":"Measurement is in progress\u2026","boiler_test_wizard.running.phase":"Testing phase {phase}","boiler_test_wizard.running.real_power":"Estimated boiler power is {power}","boiler_test_wizard.running.remaining":"Remaining approximately {seconds} s","boiler_test_wizard.running.reset":"Resetting consumption","boiler_test_wizard.running.result_fail":"Test phase is not correct","boiler_test_wizard.running.result_ok":"Test phase is correct","boiler_test_wizard.running.stable":"Consumption is stable","boiler_test_wizard.running.title":"Test is in progress","boiler_test_wizard.running.unstable":"Measurement was unstable","boiler_test_wizard.title":"Testing boiler","cancel":"Cancel","chart.range.this_week":"Last week","chart.range.today":"Last 24{nbsp}hours","chart.tooltip.active_condition.title":"Current mode:","chart.tooltip.active_condition.value.battery":"Battery","chart.tooltip.active_condition.value.compressor-blocked":"Compressor blocked, low battery level","chart.tooltip.active_condition.value.cooling":"Cooling","chart.tooltip.active_condition.value.error":"Error","chart.tooltip.active_condition.value.heating":"Heating","chart.tooltip.active_condition.value.hot-water":"Hot water heating","chart.tooltip.active_condition.value.inactive":"Inactive","chart.tooltip.active_condition.value.manual":"Manual","chart.tooltip.active_condition.value.not-connected":"Cannot establish connection","chart.tooltip.active_condition.value.not-licensed":"Not licensed","chart.tooltip.active_condition.value.off":"Off","chart.tooltip.active_condition.value.overflow":"Overflow","chart.tooltip.active_condition.value.pool":"Pool heating","chart.tooltip.active_condition.value.spot":"Spot","chart.tooltip.active_condition.value.time":"Time","chart.tooltip.control_mode.title":"Controlled by:","chart.tooltip.control_mode.value":"{mode, select, photovoltaic {Photovoltaics} grid {Grid} spot {Spot} flexibility {Flexibility} error {Error} other {{mode}} }","chart.tooltip.wallbox_authorization_card_id.title":"Authorization card:","charts.error.dialog.title":"An error occurred while loading the statistics","charts.mode.day":"Day","charts.mode.week":"Week","charts.mode.year":"Year","charts.summary.value":"Total {value}","close":"Close","cloud_plugs.bat":"Control by battery","cloud_plugs.battery.battery_start":"Turn on when charging","cloud_plugs.battery.battery_start.subtitle":"Battery charging which activates the outlet","cloud_plugs.battery.battery_stop":"Turn off when charging","cloud_plugs.battery.battery_stop.subtitle":"Charging the battery, which turns off the socket","cloud_plugs.battery.on":"Active","cloud_plugs.battery_charged":"Battery charged","cloud_plugs.condition":"Condition","cloud_plugs.condition.and":"And","cloud_plugs.condition.or":"Or","cloud_plugs.led_mode.battery.subtitle":"LED active if the battery is at least 95%","cloud_plugs.led_mode.battery.switch.title":"LED when the socket is switched on","cloud_plugs.led_mode.battery.title":"LED when the battery is charged","cloud_plugs.led_mode.mode":"{mode, select, unknown {---} off {Off} switch {} power {By power} other {Unknown}}","cloud_plugs.led_mode.overflow.subtitle":"LED active if stable overflow occurs","cloud_plugs.led_mode.overflow.title":"LED when overflow occurs","cloud_plugs.led_mode.switch.subtitle":"LED active if the socket is switched on","cloud_plugs.led_mode.title":"LED signaling","cloud_plugs.list.id":"ID","cloud_plugs.list.led_mode":"LED signaling","cloud_plugs.list.online":"Online","cloud_plugs.list.relay":"Relay","cloud_plugs.list.title":"Status","cloud_plugs.overflow":"Control by overflow","cloud_plugs.overflow.help":"Turning on the socket at a defined overflow to the grid.","cloud_plugs.overflow.on":"Active","cloud_plugs.overflow.startPower":"Turn on when consuming from the grid","cloud_plugs.overflow.startPower.help":"The socket turns on if the overflow is at the set level after a defined delay. If the value is set to - 1500W and the turn-on delay is 5 minutes, the socket turns on when the overflow into the network is at least 1500W for 5 minutes.","cloud_plugs.overflow.startPower.subtitle":"Negative value is overflow, positive value is consumption","cloud_plugs.overflow.stopPower":"Turn off when consuming from the grid","cloud_plugs.overflow.stopPower.help":"The socket turns off if the consumption is higher than the set level after a defined delay. If the value is set to 100W and the turn-off delay is 5 minutes, the socket turns off when the consumption from the network is at least 100W for 5 minutes.","cloud_plugs.overflow.stopPower.subtitle":"Negative value is overflow, positive value is consumption","cloud_plugs.pv_power":"Control by PV power","cloud_plugs.pv_power.help":"Turning on the socket at a defined PV power.","cloud_plugs.pv_power.on":"Active","cloud_plugs.pv_power.startPower":"Turn on when producing PV","cloud_plugs.pv_power.startPower.help":"The socket turns on if the PV power is greater than the set level. If the value is set to 1000W, the socket turns on when the PV power is at least 1000W.","cloud_plugs.pv_power.stopPower":"Turn off when producing PV","cloud_plugs.pv_power.stopPower.help":"The socket turns off if the PV power is less than the set level. If the value is set to 500W, the socket turns off when the PV power is less than 500W.","cloud_plugs.time":"Control by time","cloud_plugs.time.on":"Active","cloud_plugs.title":"Sockets","cloud_plugs.turn_off":"Turn off","cloud_plugs.turn_on":"Turn on","dark_mode.dark":"Dark","dark_mode.light":"Light","dark_mode.system":"System","delta_green.battery_max_power_in":"Maximum battery power IN (W)","delta_green.battery_max_power_out":"Maximum battery power OUT (W)","delta_green.business_flexibility.title":"Business flexibility","delta_green.connected":"Status","delta_green.enabled":"Integration enabled","delta_green.last_messages":"Last messages","delta_green.last_messages.date":"Time","delta_green.last_messages.payload":"Message","delta_green.last_messages.topic":"Topic","delta_green.pv_orientation":"Photovoltaic orientation","delta_green.title":"Delta Green","des_battery_container.status.error":"Error","des_battery_container.status.none":"Unknown status","des_battery_container.status.off":"Off","des_battery_container.status.run":"Normal mode","des_battery_container.status.sleep":"Sleep mode","dev.cloud_plugs.mqtt_cloud.connected":"MQTT Cloud connection status","dev.cloud_plugs.title":"Cloud sockets","dev.inverter_config.connection.lan":"LAN","dev.inverter_config.connection.rs485":"RS485","dev.inverter_config.connection.rs485_hint":"Address and port are taken from the board ({host}:{port}).","dev.inverter_config.rename_warning":"Renaming the key from \\"{from}\\" to \\"{to}\\" will orphan historical data \u2014 statistics and produced energy stored under the original key.","dev.inverter_config.search.open":"Search for inverter","dev.inverter_config.search.title":"Search for inverter","dev.inverter_config.stats.all":"All","dev.inverter_config.status.counts":"OK {ok} / Errors {err}","dev.inverter_config.status.error":"Error","dev.inverter_config.status.ok":"OK","dev.inverter_config.status.starting":"Starting","dev.inverter_config.title":"Inverter configuration","dev.link":"Dev","dev_app_messages.test_send":"Test notification","dev_app_messages.test_send.button":"Send","dev_homepage.app_messages.title":"Notifications","dev_homepage.title":"Development menu","dev_spot.summary.title":"Mode overview","dev_spot.title":"Spot (Development)","dev_status_log.empty":"No data yet","dev_status_log.error":"Error while loading","dev_status_log.title":"Status log","dev_status_log.today":"Today","dhcp_host.address":"IP address","dhcp_host.create.title":"New DHCP host","dhcp_host.edit.title":"Edit DHCP host","dhcp_host.mac":"MAC address","dhcp_host.name":"Name","dhcp_hosts.remove.cancel":"Cancel","dhcp_hosts.remove.confirm":"Delete","dhcp_hosts.remove.confirm.title":"Do you really want to unfix the DHCP host address?","dhcp_leases.ip":"IP address","dhcp_leases.mac":"MAC address","dhcp_leases.make_static.cancel":"Cancel","dhcp_leases.make_static.confirm":"Add","dhcp_leases.make_static.confirm.title":"Do you really want to fix the DHCP host address?","dhcp_leases.name":"Name","dhcp_leases.next_renewal":"Next renewal","dhcp_leases.title":"DHCP Leases","ean":"EAN","electree.business_flexibility.title":"Business flexibility","electree.connected":"Status","electree.enabled":"Integration enabled","electree.last_messages":"Last messages","electree.last_messages.date":"Time","electree.last_messages.payload":"Message","electree.last_messages.topic":"Topic","electree.title":"Electree","electrical_grid.common":"General information","electrical_grid.common.overflow":"Total flow to the grid","electrical_grid.common.overflow_today":"Today\'s overflow to the grid:","electrical_grid.common.overflow_year":"Annual overflow to the grid:","electrical_grid.common.power":"Total consumption from the grid","electrical_grid.common.power.phase_1":"Phase 1:","electrical_grid.common.power.phase_2":"Phase 2:","electrical_grid.common.power.phase_3":"Phase 3:","electrical_grid.common.power_today":"Today\'s consumption from the grid:","electrical_grid.common.power_year":"Annual consumption from the grid:","electrical_grid.common.total_consumption":"Total consumption from the grid","electrical_grid.statistics":"Purchase statistics","electrical_grid.statistics_overflow":"Overflow statistics","electrical_grid.status":"Status of the grid","ems.activePower":"Active power","ems.apparentPower":"Apparent power","ems.details":"Inverter parameters","ems.inverter":"Inverter","ems.inverter.index":"Inverter {index}","ems.inverter.mode.backup":"Backup","ems.inverter.mode.feedIn":"Feed-in","ems.inverter.mode.manual":"Manual","ems.inverter.mode.peakShaving":"Peak Shaving","ems.inverter.mode.selfUse":"Self use","ems.inverter.name":"Inverter name","ems.inverter.name.aelio":"X3-AELIO","ems.inverter.name.notConnected":"Not connected","ems.inverter.name.trene100k":"X3-TRENE-100K","ems.inverter.name.trene100ki":"X3-TRENE-100KI","ems.inverter.name.trene125k":"X3-TRENE-125K","ems.inverter.name.unknown":"Unknown model","ems.mode":"EMS mode","ems.power.index":"Power {index}","ems.power.total":"Total power","ems.powerFactor":"Power factor","ems.reactivePower":"Reactive power","ems.status":"Status","emsPro.inverter.name.aelio":"X3-AELIO","emsPro.inverter.name.notConnected":"Not connected","emsPro.inverter.name.trene1":"X3-TRENE-1","emsPro.inverter.name.trene100k":"X3-TRENE-100K","emsPro.inverter.name.trene125k":"X3-TRENE-125K","emsPro.inverter.name.x3forth":"X3-FORTH","emsPro.inverter.name.x3forthplus":"X3-FORTH+","emsPro.inverter.name.x3grand":"X3-GRAND","emsPro.inverter.name.x3mgag2":"X3-MGA G2","emsPro.inverter.name.x3prog2":"X3-PRO G2","emsService.basicSettings":"Basic Settings","emsService.direction.disabled":"Disabled","emsService.direction.read":"Read","emsService.direction.write":"Write","emsService.distributionMetrics":"Distribution Commands","emsService.distributionMetrics.diMapping":"Input mapping","emsService.distributionMetrics.enabled":"Enable reading distribution commands","emsService.distributionMetrics.source":"Distribution commands source","emsService.distributionMetrics.source.digitalInputs":"Digital Inputs","emsService.distributionMetrics.source.plc":"External PLC","emsService.enabled":"PLC Enabled","emsService.energyMeters":"Energy Meters","emsService.energyMeters.add":"Add new energy meter","emsService.energyMeters.addButton":"Add","emsService.energyMeters.azRouter":"AZ router","emsService.energyMeters.azRouter.empty":"No AZ routers configured","emsService.energyMeters.empty":"No energy meters configured","emsService.energyMeters.newMeter":"Name","emsService.energyMeters.plcMetric":"PLC Metric","emsService.energyMeters.plcMetric.grid":"Grid","emsService.energyMeters.plcMetric.kgj":"KGJ","emsService.energyMeters.plcMetric.pv":"PV","emsService.energyMeters.shellyId":"Shelly ID","emsService.energyMeters.source":"Source","emsService.energyMeters.source.azRouter":"AZ router","emsService.energyMeters.source.plc":"PLC","emsService.energyMeters.source.shelly":"Shelly","emsService.gridMetrics.enabled":"Grid metrics reading enabled","emsService.ipAddress":"IP Address","emsService.kgjMetrics":"KGJ Metrics","emsService.kgjMetrics.enabled":"KGJ metrics reading enabled","emsService.metricsDirection":"Direction","emsService.metricsEnabled":"Enabled","emsService.mqttBroker":"MQTT Broker (Shellies)","emsService.mqttBrokerEnabled":"MQTT Broker Enabled","emsService.mqttBrokerStatus":"MQTT Broker Status","emsService.notAvailable":"EMS feature is not available","emsService.password":"Password","emsService.plcStatus":"PLC Communication Status","emsService.pollInterval":"Poll Interval (ms)","emsService.pvMetrics":"PV Metrics","emsService.pvMetrics.enabled":"PV metrics reading enabled","emsService.pvMetrics.meterId":"Energy meter","emsService.pvMetrics.meterSource":"Data source","emsService.pvMetrics.meterSource.meter":"Energy meter","emsService.pvMetrics.meterSource.plc":"PLC","emsService.shelliesList":"Connected Shelly Devices","emsService.username":"Username","ems_service.link":"EMS Service","ems_service.title":"EMS Service","enerco.ean":"EAN","enerco.enabled":"Integration enabled","enerco.prediction.disabled":"Integration is disabled.","enerco.prediction.title":"Prediction","enerco.title":"Enerco","energomachine.business_flexibility.title":"Business flexibility","energomachine.connected":"Status","energomachine.enabled":"Integration enabled","energomachine.last_messages":"Last messages","energomachine.last_messages.date":"Time","energomachine.last_messages.payload":"Message","energomachine.last_messages.topic":"Topic","energomachine.title":"Energomachine","energyMeters.actualPower":"Actual power","energyMeters.general":"General Information","energyMeters.meter":"Energy Meter","energyMeters.notConfigured":"Energy meters are not configured. Go to service menu to set them up.","energyMeters.phase1":"Phase 1:","energyMeters.phase2":"Phase 2:","energyMeters.phase3":"Phase 3:","energyMeters.statistics":"Statistics","energyMeters.todayEnergy":"Today\'s consumption:","energyMeters.totalEnergy":"Total Consumption","energyMeters.yearEnergy":"Yearly consumption:","error":"Error loading report.","expertService.EM":"Energy Meters","expertService.EM.add":"Add","expertService.EM.empty":"No energy meters configured","expertService.EM.list":"Energy Meters Configuration","expertService.EM.name":"Name","expertService.EM.newMeter":"New meter","expertService.EM.shellyId":"Shelly ID","expertService.HP":"Heat pump","expertService.HP.CntComErr":"Error message counter","expertService.HP.CntComOk":"Valid message counter","expertService.HP.IpAdr":"Heat pump IP address","expertService.HP.maxTempHW":"Maximum temperature of hot water for the heat pump","expertService.HP.maxTempHW.subtitle":"Sum of flexible + set temperature","expertService.HW":"Hot water","expertService.HW.HwBatteryPriority":"Battery charge percentage at which the boiler always has priority","expertService.HW.HwErrEnabled":"Evaluate boiler availability","expertService.HW.HwResetErrorTime":"Delay for reset of thermostat error","expertService.HW.HwResetErrorTime.subtitle":"Time in minutes after which the thermostat error is reset and heating starts again","expertService.HW.LegionellaLastTime":"Last time legionella temperature was reached","expertService.HW.TempId":"Temperature sensor ID","expertService.HW.control":"Boiler control type","expertService.HW.control.onoff":"On/Off","expertService.HW.control.proportional":"Proportional","expertService.HW.hysterezis":"Hot water hysteresis","expertService.HW.hysterezis.subtitle":"Hysteresis is only for regular heating","expertService.HW.maxPower":"Maximum power of the boiler in percent","expertService.HW.maxPower.subtitle":"This setting is only for smooth control of the boiler and limits the maximum power of the burner in percent.","expertService.HW.offset":"Phase offset [W]","expertService.HW.offset.disabled-overflow":"Offset for controlling the boiler with disabled overflow on the phase [W]","expertService.HW.offset.disabled-overflow.subtitle":"Higher number allows the boiler to draw more energy from the grid when the overflow is disabled","expertService.HW.offset.enabled-overflow":"Offset for controlling the boiler with enabled overflow on the phase [W]","expertService.HW.offset.enabled-overflow.subtitle":"Higher number allows the boiler to draw more energy from the grid.","expertService.HW.offset.ongrid":"Offset for controlling the boiler with grid power [W]","expertService.HW.offset.ongrid.subtitle":"Higher number allows the boiler to draw more energy from the grid.","expertService.PV":"Photovoltaics","expertService.PV.BatteryPowerPercent":"Battery charging power in percent","expertService.PV.CntComErr":"Error message counter","expertService.PV.CntComOk":"Valid message counter","expertService.PV.ControlMeteringMode":"Surplus control method","expertService.PV.ControlMeteringMode.perPhase":"Per phase","expertService.PV.ControlMeteringMode.subtitle":"Per-phase control calculates the surplus for appliance control from individual phases. Summed control works with the sum of all phases.","expertService.PV.ControlMeteringMode.sum":"Summed","expertService.PV.ExternalPv":"External PV connected via SOLAX Meter 2","expertService.PV.ExternalPvSofar":"External PV connected via SOFAR Meter 2","expertService.PV.IpAdr":"Inverter IP address","expertService.PV.MeteringMode":"Grid metering method","expertService.PV.MeteringMode.perPhase":"Per phase","expertService.PV.MeteringMode.subtitle":"Per-phase metering (CZ) counts import and export on each phase separately. Summed metering works with the net balance of all phases.","expertService.PV.MeteringMode.sum":"Summed","expertService.PV.PowerControlType":"Power control type of the grid inverter","expertService.PV.PowerControlType.fixed":"Fixed","expertService.PV.PowerControlType.proportional":"Proportional","expertService.PV.StringNumber":"Number of strings of the inverter","expertService.PV.StringNumber.subtitle":"Number of strings of the inverter displayed in the application on the PV tab","expertService.PV.Versions":"Version","expertService.SP":"Spot","expertService.SP.HwCoefficient":"Boiler energy estimate coefficient","expertService.SP.HwCoefficient.subtitle":"Coefficient of estimated energy for charging the boiler.","expertService.SP.MinDifferencePriceChargeFromGrid":"Minimum spot price difference for grid battery charging","expertService.SP.batteryCoefficient":"Battery charging time estimate coefficient","expertService.SP.batteryCoefficient.subtitle":"Coefficient of estimated time for charging the battery","expertService.SP.minDifferenceBatterychargeFromGrid":"Minimum estimated SOC increase for waiting for PV","expertService.SP.minDifferenceBatterychargeFromGrid.subtitle":"If the estimated battery charge is below this value, the battery may be charged from the grid.","expertService.WB":"Wallbox","expertService.WB.CntComErr":"Error message counter","expertService.WB.CntComOk":"Valid message counter","expertService.WB.IpAdr":"Wallbox IP address","expertService.general":"General settings","expertService.general.largeInstallation":"Large installation","expertService.general.largeInstallation.subtitle":"Extends the range of values for large installations","expertService.password":"Service access","expertService.password.label":"Password","expert_service.app_messages":"Messages","expert_service.audit_log":"Audit Log","expert_service.error_list":"Error list","expert_service.link":"Expert Service","expert_service.network":"Network","expert_service.network.button":"Go to network settings","expert_service.network.link":"Network","expert_service.reports":"Reports","expert_service.stats":"Statistics","expert_service.title":"Service","expert_service.xyz":"Service","header.title":"Home page","header.title.app_messages":"Messages","header.title.audit_log":"Audit Log","header.title.boiler":"Boiler","header.title.cloud_plugs":"Sockets","header.title.dev":"Network Settings","header.title.dev.app_messages":"Notifications","header.title.dev.az_routers":"AZ routers","header.title.dev.bez_dodavatele":"bezDodavatele","header.title.dev.cloud_plugs":"Cloud sockets","header.title.dev.delta_green":"Delta Green","header.title.dev.electree":"Electree","header.title.dev.enerco":"Enerco","header.title.dev.energomachine":"Energomachine","header.title.dev.inverter_config":"Inverter configuration","header.title.dev.mqtt_broker":"MQTT Broker","header.title.dev.mqtt_cloud":"MQTT Cloud","header.title.dev.pre_flexibility":"PRE Flexibility","header.title.dev.scripts":"Scripts","header.title.dev.shellies":"Shellies","header.title.dev.spot":"Spot","header.title.dev.status_log":"Status log","header.title.dev.subscriptions":"Subscriptions","header.title.dev_homepage":"Development Menu","header.title.ems":"EMS","header.title.ems_service":"EMS Service","header.title.energyMeters":"Energy Meters","header.title.expert_service":"Expert Service","header.title.expert_service.network":"Network Settings","header.title.grid":"Grid","header.title.heat_pump":"Heat pump","header.title.photovoltaics":"Photovoltaics","header.title.plug":"Socket","header.title.relay":"Relay","header.title.reports":"Reports","header.title.rfid_cards":"RFID cards","header.title.settings":"Settings","header.title.spot":"Spot","header.title.statistics":"Statistics","header.title.thermostat":"Thermostat","header.title.wallbox":"Wallbox","header.title.wallbox_list":"Wallboxes","header.title.wind":"Wind turbine","heat_pump.HW":"Hot water heating","heat_pump.HW.actual_temp":"Current tank temperature","heat_pump.HW.flexitemp":"Flexible temperature","heat_pump.HW.flexitemp.subtitle":"Temperature by which the hot water can be preheated","heat_pump.HW.hysteresis":"Hysteresis of hot water heating","heat_pump.HW.on":"Hot water heating","heat_pump.HW.temp":"Desired boiler temperature","heat_pump.acond":"Acond","heat_pump.blocked":"Compressor blockage","heat_pump.blocked.min_soc":"Compressor blockage","heat_pump.blocked.min_soc_utility":"Compressor blockage when the grid is available","heat_pump.blocked.subtitle":"Battery charge level at which the compressor is blocked during a power outage","heat_pump.common":"General information","heat_pump.common.power":"Total consumption","heat_pump.common.power_today":"Today\'s consumption:","heat_pump.common.power_year":"Annual consumption:","heat_pump.common.temp":"Current temperature on the heat exchanger","heat_pump.common.total":"Total consumption","heat_pump.ecoone":"Ecoone","heat_pump.flexi":"Energy flexibility","heat_pump.flexi.flexi_on":"Flexibility mode","heat_pump.flexi.flexi_on.subtitle":"Mode activates preheating from excess energy","heat_pump.flexi.pvstability":"Compressor activation potential","heat_pump.flexi_sp":"Spot flexibility","heat_pump.flexi_sp.flexi_increase_on":"Increase consumption","heat_pump.flexi_sp.flexi_increase_on.subtitle":"Mode allows increasing consumption at low energy prices","heat_pump.flexi_sp.flexi_reduce_on":"Delay of consumption","heat_pump.flexi_sp.flexi_reduce_on.subtitle":"Mode allows postponing consumption at high energy prices","heat_pump.nibe":"Nibe","heat_pump.room":"Heating","heat_pump.room.equithermalCorrection":"Heating curve adjustment","heat_pump.room.flexitemp":"Flexible temperature","heat_pump.room.flexitemp.subtitle":"Temperature by which the house can be preheated or pre-cooled","heat_pump.room.on":"Heating","heat_pump.room.tem":"Desired temperature","heat_pump.room.temp":"Current room temperature","heat_pump.room.tempmax":"Desired comfort temperature","heat_pump.room.tempmin":"Desired attenuation temperature","heat_pump.room_cool.on":"Cooling","heat_pump.status":"Heat mode","heat_pump_wizard.cancel":"Cancel","heat_pump_wizard.ip_address.alert":"Please make sure that the IP address of the heat pump will not change (e.g. when the heat pump uses an address from DHCP).","heat_pump_wizard.ip_address.input":"IP address of the heat pump","heat_pump_wizard.open":"Set up the type of heat pump","heat_pump_wizard.save":"Save","heat_pump_wizard.title":"Settings of the heat pump","heatpump.statistics":"Statistics","heatpump.status":"Heat pump mode","home.premium.banner.inactive.subtitle":"Infigy Plus provides more detailed charts, monthly reports, notifications and much more.","home.premium.banner.inactive.title":"Do you want a better overview?","homepage.actual.battery":"Battery status","homepage.actual.boiler":"Boiler","homepage.actual.outdoor_temperature":"Outdoor temperature","homepage.actual.thermostat":"Thermostat","homepage.actual.title":"","homepage.animation":"Currently","homepage.statuses.title":"Active component modes","homepage.statuses.tooltip":"Active component modes","homepage.today.consumed":"House consumption","homepage.today.consumed_WB":"Wallbox","homepage.today.consumed_from_grid":"Consumption from the grid","homepage.today.consumed_hp":"Heat pump","homepage.today.consumed_hw":"Heat water","homepage.today.overflow":"Overflow to the grid","homepage.today.photovoltaics":"Photovoltaics production","homepage.today.title":"Daily statistics","homepage.today.wind":"Wind turbine production","hp.status.compressor_blocked":"Compressor blockage, low battery level","hp.status.cooling":"Cooling","hp.status.heating":"Heating","hp.status.hot_water":"Hot water heating","hp.status.inactive":"Inactive","hp.status.not_connected":"Cannot establish connection","hp.status.not_licensed":"Heat pump is not licensed","hp.status.pool":"Pool heating","hp.sub_status.consumption_postpone":"when consumption is reduced","hp.sub_status.consumption_rise":"when consumption is increased","hp.sub_status.consumption_with_flexibility":"with flexibility","hp.sub_status.nibe_not_writable":"- cannot write to NIBE","hp.sub_status.none":"","initial_wizard.banner.button":"Start wizard","initial_wizard.banner.hide.confirm":"Do you really want to hide the wizard?","initial_wizard.banner.hide.confirm.description":"You can restart the wizard at any time in the application settings.","initial_wizard.banner.hide.show_more":"Start wizard","initial_wizard.banner.hide.yes":"Hide","initial_wizard.banner.subtitle":"The wizard will help you set up the basic parameters of your system.","initial_wizard.banner.title":"Complete initial setup","initial_wizard.banner.title.completed":"Complete initial setup","initial_wizard.dialog.finish":"Finish","initial_wizard.dialog.next":"Next","initial_wizard.dialog.prev":"Back","initial_wizard.dialog.step":"Step {current} of {total}","initial_wizard.dialog.title":"Initial setup wizard","initial_wizard.step1.description.active":"Your access to the service is already active. You can proceed to the next step.","initial_wizard.step1.password_info":"Each company has its own access password to the service menu. You received the password in the email communication. You can also view it at any time in app.infigy.cz in the partner section.","initial_wizard.step1.title":"Access to the service","initial_wizard.step1.welcome":"Welcome to the initial setup of Infigy. We will guide you through the basic configuration of your system. Detailed settings can then be found in the service menu.","initial_wizard.step10.title":"Wallbox settings","initial_wizard.step11.description":"You have completed the basic setup of Infigy. All parameters can be edited in the service menu.","initial_wizard.step11.service_menu.subtitle":"Settings -> all the way down -> Access to the service","initial_wizard.step11.service_menu.title":"Service menu","initial_wizard.step11.title":"Done","initial_wizard.step2.title":"Application update","initial_wizard.step3.title":"Installation","initial_wizard.step4.title":"Main circuit breaker settings","initial_wizard.step5.title":"Inverter connection","initial_wizard.step6.title":"Inverter parameters","initial_wizard.step7.description":"If the overflow to the network is limited, the settings are transferred to the inverter. Limiting overflows ensures the inverter. However, Infigy controls the value according to the value set in this field. Do not modify the overflow limit in the inverter. When setting up for the first time, check the value written in the inverter to see if it is correctly transferred from Infigy to the inverter.","initial_wizard.step7.title":"Overflow limit","initial_wizard.step8.title":"Boiler settings","initial_wizard.step9.title":"Spot trading settings","initial_wizard.step_app_update.description":"At the time when Infigy was on its way to you, we could release new versions of the application. We recommend updating the unit before setting it up. However, if for example the internet is not available, you can skip the update and perform it later in the service menu, or in the portal.","inverter.3mar_plc":"3Mar PLC","inverter.az_router":"AzRouter energy meter","inverter.control.mode":"Inverter control","inverter.control.mode.chargingFromGrid":"Battery charging from grid","inverter.control.mode.dischargingToGrid":"Battery discharging to grid","inverter.control.mode.noneControl":"No control","inverter.control.mode.stopCharging":"Stop charging","inverter.control.mode.stopDischarging":"Stop discharging","inverter.control.mode.stopOverflow":"Stop overflow","inverter.des_battery_container":"DES - container storage","inverter.deye":"Deye LV","inverter.deye_hv":"Deye HV","inverter.fronius":"Fronius SYMO GEN24","inverter.fronius_grid":"Fronius SYMO grid","inverter.fronius_verto":"Fronius Verto","inverter.good_we":"GoodWe","inverter.good_we_grid_next":"GoodWe grid","inverter.good_we_next":"GoodWe","inverter.goodwe-Grid":"Goodwe grid tie","inverter.goodwe_grid":"Goodwe grid","inverter.hes":"HES - battery storage","inverter.next":"More inverters","inverter.none":"None","inverter.sermatec":"Sermatec","inverter.shellies":"Shellies","inverter.shellies_external":"Shellies External","inverter.sma_grid":"SMA grid","inverter.sofar_solar":"Sofarsolar","inverter.sofar_solar_rs485":"SofarSolar RS485","inverter.solar_edge_grid":"SolarEdge on-grid","inverter.solax":"Solax","inverter.solax-Grid":"Solax grid tie","inverter.solax_ems1000":"Solax EMS1000","inverter.solax_ems1000pro":"Solax EMS1000PRO","inverter.solax_grid":"Solax on-grid","inverter.solax_mega_grid":"Solax MEGA/FORTH on-grid","inverter.solax_mic_grid":"Solax MIC on-grid","inverter.solax_next":"SolaxNext","inverter.solinteg":"Solinteg","inverter.victron":"Victron","inverter.wattsonic":"Wattsonic","inverter_wizard.cancel":"Cancel","inverter_wizard.custom_device_ip_address.alert":"Please make sure that the inverter IP address will not change (e.g. when the inverter uses an address from DHCP).","inverter_wizard.custom_device_ip_address.input":"IP address of the inverter","inverter_wizard.multiple_inverters.alert":"Please contact the support line for setting up multiple inverters. Contact can be found in the technical wiki Infigy.","inverter_wizard.multiple_inverters.label":"Multiple inverters","inverter_wizard.multiple_inverters_or_ems.alert":"Your system already has settings for multiple inverters or EMS. This guide is intended only for setting up one inverter. For changes in the settings of inverters or EMS, please contact support.","inverter_wizard.nominal_power":"Nominal power of the inverter","inverter_wizard.nominal_power.helper":"Range: 1 to 100 kW","inverter_wizard.nominal_power.validation":"Enter the nominal power of the inverter in kW.","inverter_wizard.open":"Find inverter","inverter_wizard.save":"Save","inverter_wizard.scan":"Find inverter on the network","inverter_wizard.scanning":"Searching for inverter on the network","inverter_wizard.submit_error":"An error occurred while saving the inverter settings. Please try again.","inverter_wizard.title":"Inverter connection guide","layout.disconnected":"Disconnected","layout.pigpio_init_error_dialog.description":"The Infigy application did not start properly. Please restart the device and if the problem persists, contact support.","layout.pigpio_init_error_dialog.title":"Error when starting the application","level.thermostat.cooling":"Cooling","level.thermostat.deactivated":"Deactivated","level.thermostat.heating":"Heating","level.thermostat.standby":"Standby","level.thermostat.tempErr":"Temperature Error","level.thermostatFlexibility.increasePv":"Flexibility used to increase temperature according to photovoltaics","level.thermostatFlexibility.increaseSpot":"Flexibility used to increase temperature according to SPOT","level.thermostatFlexibility.normal":"Normal","level.thermostatFlexibility.reductionSpot":"Flexibility used to reduce temperature according to SPOT","mqtt_broker.connected_clients.title":"Clients","mqtt_broker.enabled":"Enabled","mqtt_broker.running":"Status","mqtt_broker.title":"MQTT Broker","mqtt_cloud.connected":"Status","mqtt_cloud.connected.offline":"Offline","mqtt_cloud.connected.online":"Online","mqtt_cloud.enabled":"Integration enabled","mqtt_cloud.title":"MQTT Cloud","nav.app_messages":"Messages","nav.home":"Home","nav.logout":"Log out","nav.reports":"Reports","nav.sec.boiler":"Boiler","nav.sec.cloud_plugs":"Sockets","nav.sec.ems":"EMS","nav.sec.energyMeters":"Energy Meters","nav.sec.grid":"Grid","nav.sec.heatpump":"Heat pump","nav.sec.home":"General","nav.sec.photovoltaics":"Photovoltaics","nav.sec.plug":"Socket","nav.sec.relay":"Relay","nav.sec.spot":"Spot","nav.sec.thermostat":"Thermostat","nav.sec.wallbox":"Wallbox","nav.sec.wind":"Wind turbine","nav.settings":"Settings","nav.statistics":"Statistics","network.ethernet_ports":"Ethernet ports","network.ethernet_ports.name":"LAN","network.ethernet_ports.status":"Status","network.ethernet_ports.status.down":"Inactive","network.ethernet_ports.status.up":"Active","network.scan.error":"Network scan failed","network.summary.address":"IP address","network.summary.dhcp_host_exists":"Address fixed on DHCP. Click to unfix.","network.summary.error":"Error when loading","network.summary.heat_pump":"Heat pump","network.summary.inverter":"Inverter","network.summary.mac":"MAC","network.summary.name":"Name","network.summary.no_dhcp_host":"Dynamic address on DHCP. Click to fix.","network.summary.not_connected":"Not connected","network.title":"General","network.wan_address":"WAN address","network_wan_edit.dialog.address":"IP address","network_wan_edit.dialog.close":"Close","network_wan_edit.dialog.dns":"DNS server","network_wan_edit.dialog.gateway":"Default gateway","network_wan_edit.dialog.netmask":"Network mask","network_wan_edit.dialog.save":"Save","network_wan_edit.dialog.title":"Edit WAN address","nmap.empty":"Nothing found","nmap.error":"Scan failed","nmap.host":"Address","nmap.loading":"Scanning","nmap.output":"Output","nmap.port":"Port","nmap.port.help":"Empty = only device search","nmap.range.external":"external \u2014 customer network","nmap.range.internal":"internal \u2014 Infigy network","nmap.result.address":"IP address","nmap.result.mac":"MAC address","nmap.result.ports":"Ports","nmap.result.scanning":"Scanning {target}, may take a while\u2026","nmap.result.target":"Scanned range: {target}","nmap.result.vendor":"Vendor","nmap.start":"Start","nmap.target":"Address or range","nmap.target.help":"Named network or IP / range","nmap.title":"Port scan","photovoltaics.battery":"Battery","photovoltaics.battery.battery_charged":"Battery charging","photovoltaics.battery.battery_manual_discharge":"Manually discharge battery","photovoltaics.battery.battery_power":"Battery power","photovoltaics.battery.soc_actual":"Calculated minimum charge","photovoltaics.batteryStatus":"BMS status","photovoltaics.battery_stop":"Battery blocking","photovoltaics.battery_stop.hdo":"Discharge battery only at low tariff (HDO)","photovoltaics.battery_stop.hp":"Block battery when operating the heat pump","photovoltaics.battery_stop.hw":"Block battery when operating the hot water heater","photovoltaics.battery_stop.wb":"Block battery when operating the wallbox","photovoltaics.battery_stop.wb.lock_desc":"When the wallbox charging mode \u201ECharge according to battery\u201C is enabled, this blocking cannot be enabled. After enabling the blocking, set another wallbox charging mode.","photovoltaics.battery_stop.wb.lock_title":"Setting cannot be changed","photovoltaics.common":"General information","photovoltaics.common.battery_charged":"Battery charging","photovoltaics.common.battery_manual_charge":"Charge the battery manually","photovoltaics.common.battery_manual_charge_soc":"Target SOC for manual charging","photovoltaics.common.battery_manual_charge_subtitle":"Manual charging of the battery will charge the battery to the target level of charge if it is not turned off earlier by the user.","photovoltaics.common.battery_manual_discharge":"Manually discharge the battery","photovoltaics.common.battery_manual_discharge_subtitle":"Manual discharging of the battery will discharge the battery to the minimum level of charge if it is not turned off earlier by the user.","photovoltaics.common.battery_power":"Battery performance","photovoltaics.common.power":"Current performance","photovoltaics.common.power_today":"Today\'s production:","photovoltaics.common.power_total":"Total production","photovoltaics.common.power_year":"Annual production:","photovoltaics.common.string1":"String 1:","photovoltaics.common.string2":"String 2:","photovoltaics.common.string3":"String 3:","photovoltaics.common.string4":"String 4:","photovoltaics.common.string5":"String 5:","photovoltaics.common.string6":"String 6:","photovoltaics.statistics":"Statistics","photovoltaics.statistics.charge":"Battery charging","photovoltaics.statistics.discharge":"Battery discharging","photovoltaics.statisticsSoc":"Battery level","photovoltaics.status":"Photovoltaics mode","ping.address":"Address","ping.output":"Output","ping.start":"Start","ping.stop":"Stop","ping.title":"Ping","plug.bat":"Control by battery","plug.bat.batterySart":"Turn on when charging","plug.bat.batterySart.help":"Battery level at which the socket turns on. For the socket to turn on, the battery level must change from the set state to a higher state. If the value is set to 80%, the socket turns on when the battery is charged from 80% to 81%.","plug.bat.batterySart.subtitle":"Battery charging which activates the outlet","plug.bat.batteryStop":"Turn off when charging","plug.bat.batteryStop.help":"Battery level at which the socket turns off. For the socket to turn off, the battery level must change from the set state to a lower state. If the value is set to 80%, the socket turns off when the battery is discharged from 80% to 79%.","plug.bat.batteryStop.subtitle":"Charging the battery, which turns off the socket","plug.bat.help":"Turning on at a defined battery level. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.","plug.bat.on":"Active","plug.main":"General information","plug.main.consumption":"Current consumption","plug.main.power":"total consumption","plug.main.power_today":"Today\'s consumption:","plug.main.power_year":"Annual consumption:","plug.main.stat":"Statistics","plug.overflow":"Control by overflow","plug.overflow.consumption":"Setting corresponds to a device with power consumption","plug.overflow.help":"Turning on the socket at a defined overflow into the distribution network. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.","plug.overflow.on":"Active","plug.overflow.startPower":"Turn on at grid consumption","plug.overflow.startPower.help":"The socket turns on if the overflow is at the set level after a defined delay. If the value is set to - 1500W and the turn-on delay is 5 minutes, the socket turns on when the overflow into the network is at least 1500W for 5 minutes.","plug.overflow.startPower.subtitle":"Negative value is overflow","plug.overflow.stopPower":"Turn off at grid consumption","plug.overflow.stopPower.help":"The socket turns off if the consumption is higher than the set level after a defined delay. If the value is set to 100W and the turn-off delay is 5 minutes, the socket turns off when the consumption from the network is at least 100W for 5 minutes.","plug.overflow.stopPower.subtitle":"Negative value is overflow, positive value is consumption","plug.overflow.time":"Turn on and off delay","plug.overflow.time.help":"This parameter is used to define the delay for turning on and off the socket at defined overflows/consumptions. Suitable for setting priority and elimination of frequent socket switching. Enter in the format HH:MM.","plug.plug":"Socket","plug.spot":"Control by spot price","plug.spot.15m.period":"Spot price period","plug.spot.15m.period.subtitle":"15 minute intervals","plug.spot.help":"Turning on at a defined spot price. Can be combined with a time condition. If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.","plug.spot.on":"Active","plug.spot.period":"Spot price period","plug.spot.period.subtitle":"60 minute intervals","plug.spot.price.period":"Socket time resolution","plug.spot.spotHi":"Activate at high price","plug.spot.spotHi.help":"The socket turns on if the spot price is at the high level (see the Spot tab).","plug.spot.spotLow":"Activate at a low price","plug.spot.spotLow.help":"The socket turns on if the spot price is at the low level (see the Spot tab).","plug.spot.spotMi":"Activate at mid price","plug.spot.spotMi.help":"The socket turns on if the spot price is at the middle level (see the Spot tab).","plug.spot.spot_above_price":"Activate at a higher price than the set price","plug.spot.spot_above_price.help":"The socket turns on if the spot price is higher or equal to the set spot price.","plug.spot.spot_above_price.subtitle":"The socket turns on if the spot price is higher or equal to the set spot price. If it is lower, the socket turns off.","plug.spot.spot_below_price":"Activate at a lower price than the set price","plug.spot.spot_below_price.help":"The socket turns on if the spot price is lower or equal to the set spot price.","plug.spot.spot_below_price.subtitle":"The socket turns on if the spot price is lower or equal to the set spot price. If it is higher, the socket turns off.","plug.spot.spot_neg":"Activate at negative price","plug.spot.spot_neg.help":"The socket turns on if the spot price is negative (see the Spot tab).","plug.status":"Socket mode","plug.summary.price":"Price","plug.summary.price_level":"Price level","plug.summary.price_level_15m":"Price level 15m","plug.summary.switch":"Socket switch","plug.summary.time":"Time","plug.time":"Control by time","plug.time.help":"Turning on at a defined time. Can be combined with other conditions depending on the battery (must be installed), spot price (must be allowed for spot trading) and overflow (must be allowed for overflow into the network). If one of the conditions for turning on is met, the socket turns on, and if one of the conditions for turning off is met, the socket turns off.","plug.time.on":"Active","plug.time.turn_off":"Turn off at a defined time","plug.time.turn_off.help":"Time at which the socket turns off. If set to 12:00, the socket turns off exactly at the set time 12:00.","plug.time.turn_on":"Turn on at a defined time","plug.time.turn_on.help":"Time at which the socket turns on. If set to 12:00, the socket turns on exactly at the set time 12:00.","plug.turn_off":"Turn off","plug.turn_on":"Turn on","pre_flexibility.business_flexibility.title":"Business flexibility","pre_flexibility.enabled":"Integration enabled","pre_flexibility.title":"PRE Flexibility","premium.banner.active.button":"Manage subscription","premium.banner.active.dev_mode":"Subscription is active for development","premium.banner.active.subtitle":"The Infigy Plus subscription is active. You can enjoy all the features that are extra in the application thanks to it.","premium.banner.active.title":"Subscription is active","premium.banner.hide.confirm":"Do you really want to hide Infigy Plus banner?","premium.banner.hide.confirm.description":"You can always view Infigy Plus again in the application settings.","premium.banner.hide.later":"Remind me later","premium.banner.hide.show_more":"Learn more","premium.banner.hide.yes":"Hide","premium.banner.inactive.button":"Learn more","premium.banner.inactive.subtitle":"Take your energy management to the next level. With Infigy Plus you get even more smart tools - detailed graphs, instant notifications, enhanced calendar, detailed reports and more.","premium.banner.inactive.title":"Infigy Plus is not active","premium.dialog.charts.subtitle":"Get the opportunity to track the performance of individual strings, consumption by phase and other detailed information.","premium.dialog.charts.title":"Detailed graphs","premium.dialog.close":"Close","premium.dialog.next.subtitle":"We are preparing a lot of additional benefits that we will gradually release for Infigy Plus subscribers","premium.dialog.next.title":"Additional benefits will soon arrive","premium.dialog.notifications.subtitle":"Get notifications about negative prices, charged battery and other events","premium.dialog.notifications.title":"Notifications","premium.dialog.other_benefits.subtitle":"We are preparing a lot of additional benefits that we will gradually release for Infigy Plus subscribers","premium.dialog.other_benefits.title":"Additional benefits will soon arrive","premium.dialog.reports.subtitle":"Detailed monthly reports that give you a clear picture of production, consumption and energy use in your household. All important data is in one place - clearly, clearly and supplemented by graphs.","premium.dialog.reports.title":"Advanced reports","premium.dialog.save":"Subscribe to Infigy Plus","premium.dialog.schedule.subtitle":"Schedule manually charging or discharging the battery as needed","premium.dialog.schedule.title":"Enhanced calendar","premium.dialog.spot.subtitle":"Get the opportunity to look into the history of spot prices and plans that Infigy prepared in the past","premium.dialog.spot.title":"History of spot prices","protocol.settings":"Settings","protocol.settings.Licence":"License","protocol.settings.distribution":"License","protocol.test":"Device test","protocol.test.internet-connect":"Internet connection","protocol.test.inverter-connect":"Connecting the inverter","protocol.test.phase_1":"Phase 1 test","protocol.test.phase_2":"Phase 2 test","protocol.test.phase_3":"Phase 3 test","protocol.test.tester":"Device tested by","relay.condition":"Turning on condition","relay.main":"General information","relay.name":"Relay name","relay.spot.diagram":"Control by spot price","relay.status":"Status","relay.summary.switch":"Relay switch","relay.title":"Relay","report.avg_day_chart.battery_soc":"Battery state of charge","report.avg_day_chart.consumption":"Consumption","report.avg_day_chart.grid":"Grid","report.avg_day_chart.pv_production":"PV production","report.not_generated":"Create report by clicking","report_test.button":"Test","report_test.date":"Month (e.g. 2025-09)","report_test.generated":"Report generated","report_test.ok":"OK","report_test.test":"Test","reports.accumulation_increased":"Accumulation increased","reports.average_water_temperature":"Average water temperature","reports.avg_day":"Average day","reports.battery":"Battery","reports.boiler":"Electric boiler","reports.building_consumption":"Building consumption","reports.disclaimer":"The values have only an informative character and may differ from the official readings of the distributor.","reports.energy_estimate":"Energy estimate without control","reports.estimated_water_amount":"Estimated water amount","reports.grid_consumption":"Grid consumption","reports.grid_consumption_hp":"Grid consumption for heat pump","reports.grid_consumption_hw":"Grid consumption for electric boiler","reports.grid_consumption_wallbox":"Grid consumption for wallbox","reports.heat_pump":"Heat pump","reports.household_consumption":"Household consumption","reports.info":"General information","reports.kilometers_driven":"Number of kilometers driven","reports.kilometers_driven_from_sun":"Number of kilometers driven from the sun","reports.maximum_power":"Maximum power","reports.monthly_consumption":"Monthly consumption","reports.monthly_production":"Monthly production","reports.pv":"Photovoltaic plant","reports.pv_consumption":"PV consumption","reports.pv_production":"PV production","reports.regenerate_report":"Regenerate report","reports.regenerate_report_confirm_title":"Regenerate report?","reports.rfid_cards":"RFID cards","reports.self_consumption":"Self-consumption","reports.self_sufficiency":"Self-sufficiency","reports.self_sufficient_days":"Number of self-sufficient days","reports.share.description":"You can share the selected screenshot with others.","reports.share.share":"Share report","reports.share.title":"Share report","reports.share_report":"Share report","reports.sold_to_distribution_grid":"Sold to grid","reports.stored_energy_from_grid":"Stored energy from grid","reports.stored_energy_from_pv":"Stored energy from PV","reports.stored_energy_to_battery":"Stored energy to battery","reports.stored_energy_to_boiler":"Stored energy to electric boiler","reports.stored_energy_to_heat_pump":"Stored energy to heat pump","reports.stored_energy_to_wallbox":"Stored energy to wallbox","reports.total_overflow_to_grid":"Total overflow to grid","reports.total_purchase_from_grid":"Total purchase from grid","reports.total_with_control":"Total with control","reports.total_without_control":"Total without control","reports.updated_at":"Generated {date}","reports.wallbox":"EV charging station (wallbox)","rfid_cards.col.consumption":"Consumption","rfid_cards.col.created_at":"Added","rfid_cards.col.id":"Card ID","rfid_cards.col.name":"Name","rfid_cards.export":"Export CSV","rfid_cards.from":"From","rfid_cards.no_cards":"No cards added","rfid_cards.title":"RFID cards","rfid_cards.to":"To","save":"Save","schedules.add":"Add schedule","schedules.add.tooltip":"Add","schedules.battery_charge":"Battery charging","schedules.battery_discharge":"Battery discharging","schedules.charging_current":"Charging current: {chargingCurrent} A","schedules.description":"Schedule manually charging or discharging the battery as needed.","schedules.dialog.title":"Scheduler","schedules.dialog.title.ev":"Create charging plan","schedules.ev_charging":"EV charging","schedules.form.action":"Action","schedules.form.battery_charge":"Charge battery","schedules.form.battery_discharge":"Discharge battery","schedules.form.charging-current":"Set charging current","schedules.form.charging-current.auto":"Default","schedules.form.close":"Close","schedules.form.create":"Create","schedules.form.duration":"Duration (minutes)","schedules.form.duration.120min":"2 hours","schedules.form.duration.180min":"3 hours","schedules.form.duration.240min":"4 hours","schedules.form.duration.300min":"5 hours","schedules.form.duration.360min":"6 hours","schedules.form.duration.60min":"1 hour","schedules.form.ev_charging":"EV charging","schedules.form.frequency":"Frequency  ","schedules.form.frequency.daily":"Daily","schedules.form.frequency.monthly":"Monthly","schedules.form.frequency.weekly":"Weekly","schedules.form.interval.biweekly":"Every 2 weeks","schedules.form.preview.hide":"Hide preview","schedules.form.preview.show":"Show scheduled occurrences","schedules.form.preview.title":"Scheduled starts ({count} following)","schedules.form.recurring":"Recurring","schedules.form.target-soc":"Target SOC (optional)","schedules.form.until":"Repeat until (optional)","schedules.form.when":"When","schedules.loading.error":"Error loading schedules","schedules.missed":"Missed","schedules.no_plans_found":"No plans found.","schedules.processed":"Processed","schedules.remove.confirm":"Do you really want to delete the plan?","schedules.remove.no":"Cancel","schedules.remove.recurring.instance":"Delete only this occurrence","schedules.remove.recurring.series":"Delete entire series","schedules.remove.recurring.title":"Delete recurring plan","schedules.remove.yes":"Delete","schedules.running":"Running","schedules.scheduled":"Scheduled","schedules.show_processed":"Show processed","schedules.target_soc":"Target SOC: {targetSoc, number, percent}","schedules.title":"Scheduler","scripts.add":"Create","scripts.delete":"Delete","scripts.edit":"Edit","scripts.loading_error":"Error loading scripts","scripts.title":"Scripts","settings.PV.NominalInverterPower":"Nominal inverter power","settings.PV.NominalInverterPower.help":"This is important for the correct % calculation of overflows for Solinteg, Wattsonic and Deye.","settings.PV.NominalInverterPower.subtitle":"Nominal inverter power in kW, important for the % calculation of overflows into the network.","settings.PV.StringNumber":"Number of inverter strings","settings.PV.StringNumber.subtitle":"Number of inverter strings displayed in the PV tab in the application","settings.app_update":"Application version","settings.app_update.check_button":"Check for updates","settings.app_update.confirm.cancel":"Cancel","settings.app_update.confirm.confirm":"Update","settings.app_update.confirm.description":"Update may take a few minutes. During the update, the application will be unavailable and will then automatically restart.","settings.app_update.confirm.title":"Start update?","settings.app_update.error.no_internet":"Check your internet connection","settings.app_update.in_progress":"Update in progress","settings.app_update.request_button":"Update is available","settings.app_update.requested":"Update was requested","settings.app_update.subtitle":"Check for new versions","settings.app_update.title":"Application update","settings.app_update.up_to_date":"Application is up to date","settings.boiler":"Electric boiler","settings.boiler.3phase":"Three-phase electric boiler","settings.boiler.3phase.subtitle":"Connect a single-phase electric boiler to the SSR output matching the selected phase.","settings.boiler.HwBatteryPriority":"Percentage of battery charging from which the boiler starts heating","settings.boiler.HwBatteryPriority.help":"If the battery charge is lower than this value, the energy accumulation priority is fully available to the battery. If the battery charge is higher, the boiler starts taking priority and starts heating the water from the excess energy of the PV - part of the energy goes further into the battery to be discharged.","settings.boiler.capacity":"Boiler volume","settings.boiler.capacity_sub":"Required for spot trading only","settings.boiler.enabled":"Electric boiler installed","settings.boiler.hysterezis":"Boiler hysteresis","settings.boiler.hysterezis.subtitle":"Hysteresis is only for regular heating","settings.boiler.nominal":"Rated power","settings.boiler.nominal.subtitle":"Nominal input for 1 phase of the electric boiler","settings.boiler.phase":"Boiler phase","settings.boiler.phase.subtitle":"L1 = SSR output 1, L2 = SSR output 2, L3 = SSR output 3.","settings.boiler.prio":"Battery priority","settings.boiler.prio.subtitle":"If ON, the battery is charged first, then the boiler","settings.boiler.shellies":"Boiler is controlled through Shelly","settings.boiler.temp_enabled":"Temperature sensor installed","settings.boiler.temp_enabled.subtitle":"The boiler can only be used for surpluses without a sensor","settings.device":"Device","settings.device.SN":"Serial number","settings.device.id":"Device ID","settings.device.license":"Device license","settings.docs":"Guides and other materials","settings.docs.service_settings_inverter.button":"Go to wiki","settings.docs.service_settings_inverter.subtitle":"Documentation, procedures, and other information","settings.docs.service_settings_inverter.title":"Guide on connecting the inverter","settings.docs.tech_wiki.button":"Go to wiki","settings.docs.tech_wiki.subtitle":"Guides, procedures, and other information","settings.docs.tech_wiki.title":"Technical wiki","settings.docs.user_wiki.button":"Go to wiki","settings.docs.user_wiki.subtitle":"Guides, procedures, and other information","settings.docs.user_wiki.title":"User wiki","settings.hdo":"Setting of remote time control system","settings.hdo.help":"Setting of HDO times for the calculation of electricity prices in the high and low tariff. Below you can set the times of the low tariff.","settings.hdo.on1":"Time 1","settings.hdo.on2":"Time 2","settings.hdo.on3":"Time 3","settings.hdo.on4":"Time 4","settings.hdo.on5":"Time 5","settings.hdo.on6":"Time 6","settings.hdo.regular":"Regular working day","settings.hdo.start":"Start","settings.hdo.stop":"Stop","settings.hdo.type":"Define times for","settings.hdo.weekend":"Weekend HDO times","settings.heatpump":"Installation","settings.heatpump.HpBatteryPriority":"Percentage of battery state of charge (SOC) from which the heat pump power increases","settings.heatpump.HpBatteryPriority.help":"If the battery charge is lower than this value, the energy accumulation priority is fully available to the battery. If the battery charge is higher, the heat pump starts taking priority and starts heating the water from the excess energy of the PV - part of the energy goes further into the battery to be discharged.","settings.heatpump.enabled":"Heat pump installed","settings.heatpump.flexiAN":"Accumulation tank\'s flexibility","settings.heatpump.flexiCool":"Cooling flexibility","settings.heatpump.flexiHw":"Hot water flexibility","settings.heatpump.flexiRoom":"Room flexibility","settings.heatpump.hp_type":"Type of heat pump","settings.heatpump.nominal":"Nominal input power","settings.heatpump.nominal1":"Nominal input power","settings.heatpump.priority":"The heat pump has a higher priority than the battery","settings.heatpump.priority-wb":"Heat pump has a higher priority than the wallbox","settings.heatwatter":"Boiler","settings.heatwatter.legionella":"Legionella","settings.heatwatter.legionella_temp":"Sanitation temperature","settings.heatwatter.legionella_temp.subtitle":"Temperature to which the boiler must be heated at least once every 14 days","settings.inverter_communication_status":"Inverter communication","settings.inverter_communication_status.not_ok":"Not connected,{br}trying to connect...","settings.inverter_communication_status.ok":"Communication established{br}({count} readings)","settings.inverter_communication_status.subtitle":"Establishing communication may take several tens of seconds to several minutes","settings.notification":"Notifications","settings.notification.application_settings":"Notifications - parameters","settings.notification.battery_max_soc":"Maximum SOC battery","settings.notification.battery_max_soc.subtitle":"Notification will be generated when the maximum SOC of the battery is reached. Notification will be generated only once a day.","settings.notification.battery_max_soc_value":"Maximum SOC battery for notifications","settings.notification.battery_max_soc_value.subtitle":"Set the SOC of the battery, at which a notification will be generated.","settings.notification.battery_min_soc":"Minimum SOC battery","settings.notification.battery_min_soc.subtitle":"Notification will be generated when the SOC of the battery drops to the set minimum value. Notification will be generated only once a day.","settings.notification.battery_min_soc_value":"Minimum SOC battery for notifications","settings.notification.battery_min_soc_value.subtitle":"Set the SOC of the battery, at which a notification will be generated.","settings.notification.daily_prediction.subtitle":"Notification will be generated every day at 8:00","settings.notification.description":"Permission to generate notifications that will be generated in the application","settings.notification.heat_pump_limit_exceeded":"Exceeding the limit of heat pump consumption","settings.notification.heat_pump_limit_exceeded.subtitle":"Notification will be generated when the limit of heat pump consumption is exceeded","settings.notification.heat_pump_limit_value":"Daily limit of heat pump consumption for notifications","settings.notification.heat_pump_limit_value.subtitle":"Set the limit of heat pump consumption, at which a notification will be generated.","settings.notification.heat_water_limit_exceeded":"Exceeding the limit of heating water","settings.notification.heat_water_limit_exceeded.subtitle":"Notification will be generated when the limit of heating water is exceeded","settings.notification.heat_water_limit_value":"Daily limit of heating water for notifications","settings.notification.heat_water_limit_value.subtitle":"Set the limit of heating water, at which a notification will be generated.","settings.notification.heat_water_max_temperature":"The maximum temperature of the water has been reached","settings.notification.heat_water_max_temperature.subtitle":"Notification will be generated when the maximum temperature of the water in the boiler from PV energy is reached","settings.notification.home_consumption_limit_exceeded":"Exceeding the limit of home consumption","settings.notification.home_consumption_limit_exceeded.subtitle":"Notification will be generated when the limit of home consumption is exceeded","settings.notification.home_consumption_limit_value":"Daily limit of home consumption for notifications","settings.notification.home_consumption_limit_value.subtitle":"Set the limit of home consumption, at which a notification will be generated.","settings.notification.iverter_disconnected":"Communication with the inverter has been lost","settings.notification.iverter_disconnected.subtitle":"Notification will be generated at the beginning and end of the communication loss with the inverter","settings.notification.negative_spot":"Negative price on the spot","settings.notification.negative_spot.subtitle":"Notification will be generated at the beginning and end of the negative price on the spot","settings.notification.pv_production_mwh":"PV production milestone","settings.notification.pv_production_mwh.subtitle":"Notification will be generated if the PV generates MWh of energy in the given year","settings.notification.spot_charging_battery":"Start and stop battery charging according to the spot price","settings.notification.spot_charging_battery.subtitle":"Notification will be generated at the beginning and end of the battery charging according to the spot price","settings.notification.spot_daily_prediction":"Daily prediction","settings.notification.spot_daily_summary":"Daily summary of the spot plan","settings.notification.spot_daily_summary.subtitle":"Notification will be generated every day at 8:00","settings.notification.spot_discharging_battery":"Start and stop battery discharging to the grid according to the spot price","settings.notification.spot_discharging_battery.subtitle":"Notification will be generated at the beginning and end of the battery discharging to the grid according to the spot price","settings.notification.utility_loss":"Grid outage","settings.notification.utility_loss.subtitle":"Notification will be generated at the beginning and end of the utility loss","settings.notification.wallbox_charging_start_stop":"Start and stop charging the electric vehicle","settings.notification.wallbox_charging_start_stop.subtitle":"Notification will be generated at the beginning and end of the electric vehicle charging","settings.notification.wallbox_limit_exceeded":"Exceeding the limit of charging the electric vehicle","settings.notification.wallbox_limit_exceeded.subtitle":"Notification will be generated when the limit of charging the electric vehicle is exceeded","settings.notification.wallbox_limit_value":"Daily limit of charging the electric vehicle for notifications","settings.notification.wallbox_limit_value.subtitle":"Set the limit of charging the electric vehicle, at which a notification will be generated.","settings.notification.webapp.subtitle":"You can receive notifications from Infigy via the web application.","settings.notification.webapp.title":"Web application","settings.other":"Other","settings.other.dark_mode":"Dark mode","settings.other.languate":"Language","settings.other.overflow_fronius":"Maximum overflow into the network is limited on the side of the Fronius inverter","settings.other.overflow_fronius_subtitle":"This value is set by the distributor. Exceeding this value may lead to financial penalties from the distributor.","settings.other.overflow_settings":"Set overflow value","settings.other.overflow_settings.help":"This is a service-set value of the maximum overflow. This value is set by the distributor. Exceeding this value may lead to financial penalties from the distributor.","settings.other.readability_mode":"Font size","settings.photovoltaics":"Photovoltaics","settings.photovoltaics.backup_enabled":"Backup enabled","settings.photovoltaics.backup_enabled.subtitle":"Information about the backup mode of the inverter.","settings.photovoltaics.batterychargingpower":"Battery charging power","settings.photovoltaics.batterychargingpower_sub":"Power for manual battery charging and spot charging from the grid","settings.photovoltaics.batterydischargingpower":"Battery discharging power","settings.photovoltaics.batterydischargingpower_sub":"Power for spot discharging of the battery to the grid","settings.photovoltaics.batteryenabled":"Battery installed","settings.photovoltaics.batterynominal":"Nominal battery capacity","settings.photovoltaics.batterynominal_sub":"Required for spot trading only","settings.photovoltaics.enabled":"Photovoltaics installed","settings.photovoltaics.gridchargeenabled":"Battery charging from the distribution grid enabled","settings.photovoltaics.inverters-adjust-power":"Current inverter power","settings.photovoltaics.inverters-nominal":"Nominal power of adjustable inverters","settings.photovoltaics.nominal":"Nominal power","settings.photovoltaics.overflow":"Unlimited grid overflow","settings.photovoltaics.overflow.value":"Overflow limitation","settings.photovoltaics.overflow.value.help":"Value of the maximum overflow into the network. This value is written to the inverter. Do not modify this value in the inverter. The overflow limitation is controlled by Infigy. Check the written value in the inverter.","settings.photovoltaics.overflow_fronius.value.help":"Value of the maximum overflow into the network on the side of the Fronius inverter. It is used as information for Infigy to correctly visualize overflows.","settings.photovoltaics.settings":"Battery","settings.photovoltaics.settings.soc_actual":"Calculated minimum charge","settings.photovoltaics.settings.soc_actual.help":"This value is automatically calculated based on the current state. It is either controlled by automatic charging according to the annual period, or by manual setting of the minimum charge with DS and without DS. If the value is 100%, then battery charging is prohibited, e.g. according to spot trading.","settings.photovoltaics.settings.soc_grid":"Minimum charge with DS","settings.photovoltaics.settings.soc_grid.help":"With this value, you can control the minimum charge of the battery in % SOC when the distribution network is available. In Solax in the Backup mode, the minimum charge of the battery is 15%.","settings.photovoltaics.settings.temp":"Minimum charge with Grid","settings.photovoltaics.settings.temp.help":"With this value, you can control the minimum charge of the battery in % SOC when the distribution network is available.","settings.photovoltaics.settings.temp_ek":"Minimum charge without Grid","settings.photovoltaics.settings.temp_ek.help":"With this value, you can control the minimum charge of the battery in % SOC when the distribution network is unavailable.","settings.photovoltaics.unbalanced_enabled":"Asymmetry of the inverter","settings.photovoltaics.unbalanced_enabled.subtitle":"Information about the asymmetry of the inverter.","settings.photovoltaics_auto_settings":"Automatic charge control","settings.photovoltaics_auto_settings.subtitle":"Automatic minimum SOC control according to the annual period","settings.plug":"Sockets","settings.plug.Led":"Permanent backlight","settings.plug.Led-batt":"Backlight when the battery is charged","settings.plug.Led-batt.subtitle":"Backlight active if the battery is at least 95%","settings.plug.Led-over":"Backlight during overflow","settings.plug.enabled":"Sockets installed","settings.plug.enabled.subtitle":"Sockets on the local network","settings.plug.enabled2":"Second socket","settings.plug.enabled3":"Third socket","settings.plug.ip1":"The IP address of the first socket","settings.plug.ip1.label":"IP 3","settings.plug.ip2":"The IP address of the second socket","settings.plug.ip2.label":"IP 2","settings.plug.ip3":"The IP address of the third socket","settings.plug.ip3.label":"IP 3","settings.plug.modulenabled":"Sockets on the module","settings.plug.modulip":"IP address of the module","settings.plug.modulip.label":"IP Module","settings.plug.name1":"Name of socket 1","settings.plug.name1.label":"Name","settings.plug.name2":"Name of socket 2","settings.plug.name2_label":"Name","settings.plug.name3":"Name of socket 3","settings.plug.name3.label":"Name","settings.plug.statusLed":"Signal diode","settings.readability_mode.default":"Default","settings.readability_mode.large":"Large","settings.relay":"Relay","settings.relay.0.enabled":"First relay","settings.relay.1.enabled":"Second relay","settings.relay.1.type":"Condition","settings.relay.1.type.HDO":"Mirror HDO","settings.relay.1.type.batteryfull":"Battery charged above 95%","settings.relay.1.type.batterylow":"Battery charged below set minimum","settings.relay.1.type.bojlerFull":"Boiler is almost heated","settings.relay.1.type.none":"Not used","settings.relay.1.type.plug1":"Socket 1","settings.relay.1.type.plug2":"Socket 2","settings.relay.1.type.plug3":"Socket 3","settings.relay.1.type.spotHi":"High spot price","settings.relay.1.type.spotLow":"Low spot price","settings.relay.1.type.spotMi":"Medium spot price","settings.relay.1.type.spotNegative":"Negative spot price","settings.relay.1.type.thermostat1":"Thermostat circuit 1","settings.relay.1.type.thermostat2":"Thermostat circuit 2","settings.relay.1.type.thermostat3":"Thermostat circuit 3","settings.relay.1.type.thermostat4":"Thermostat circuit 4","settings.relay.2.enabled":"Third relay","settings.relay.3.enabled":"Fourth relay","settings.relay.above_price_relay":"Spot price for the relay to activate","settings.relay.above_price_relay.subtitle":"If the spot price is higher than this value, the relay turns on. If it is lower, the relay turns off.","settings.relay.above_price_relay_15m":"Spot price for the relay to activate (15 min)","settings.relay.above_price_relay_15m.subtitle":"If the spot price is higher than this value, the relay turns on. If it is lower, the relay turns off.","settings.relay.above_soc_relay":"Battery charge for the relay to activate","settings.relay.above_soc_relay.subtitle":"If the battery charge is higher than this value, the relay turns on.","settings.relay.above_soc_relay_hyst":"Hysteresis of the battery SOC for the relay to deactivate","settings.relay.above_soc_relay_hyst.subtitle":"If the battery charge decreases by this value below the set activation value, the relay turns off.","settings.relay.below_price_relay":"Spot price for the relay to activate","settings.relay.below_price_relay.subtitle":"If the spot price is lower than this value, the relay turns on. If it is higher, the relay turns off.","settings.relay.below_price_relay_15m":"Spot price for the relay to activate (15 min)","settings.relay.below_price_relay_15m.subtitle":"If the spot price is lower than this value, the relay turns on. If it is higher, the relay turns off.","settings.relay.below_soc_relay":"Battery charge for the relay to activate","settings.relay.below_soc_relay.subtitle":"If the battery charge decreases by this value below the set activation value, the relay turns off.","settings.relay.below_soc_relay_hyst":"Hysteresis of the battery SOC for the relay to deactivate","settings.relay.below_soc_relay_hyst.subtitle":"If the battery charge increases by this value above the set activation value, the relay turns off.","settings.relay.enabled":"Relays installed","settings.relay.enabled.subtitle":"Integrated relays","settings.relay.item.enabled":"Relay {index}","settings.relay.item.name":"Relay name","settings.relay.item.status":"Status","settings.relay.option":"Condition","settings.relay.temp_above_relay.subtitle":"If the boiler temperature is higher than this value, the relay turns on.","settings.relay.temp_above_relay_hyst.subtitle":"If the boiler temperature decreases by this value below the set activation value, the relay turns off.","settings.relay.temp_below_relay.subtitle":"If the boiler temperature is lower than this value, the relay turns on.","settings.relay.temp_below_relay_hyst":"Hysteresis of the boiler \xb0C temperature for the relay to deactivate","settings.relay.temp_below_relay_hyst.subtitle":"If the boiler temperature increases by this value above the set activation value, the relay turns off.","settings.relay.temp_relay":"Boiler temperature for the relay to activate","settings.relay.temp_relay_hyst":"Hysteresis of the boiler \xb0C temperature for the relay to deactivate","settings.relay.type.Active":"Permanent on","settings.relay.type.HDO":"Mirror HDO","settings.relay.type.batteryBelowSOC":"Battery charge below the set SOC","settings.relay.type.batteryDischarge":"Battery discharging to the grid","settings.relay.type.batteryFull":"Battery charge above the set SOC","settings.relay.type.batteryLow":"Battery charge below the set minimum","settings.relay.type.bojlerFull":"Boiler is almost heated","settings.relay.type.hdo":"Mirror HDO","settings.relay.type.heatWaterAboveTemp":"Boiler is heated above the set temperature","settings.relay.type.heatWaterBelowTemp":"Boiler is heated below the set temperature","settings.relay.type.heatWaterMaxTemp":"Boiler is almost heated","settings.relay.type.heatWaterTemp":"Boiler is heated above the set temperature","settings.relay.type.none":"Not used, permanently off","settings.relay.type.plug1":"Socket 1","settings.relay.type.plug2":"Socket 2","settings.relay.type.plug3":"Socket 3","settings.relay.type.plug4":"Socket 4","settings.relay.type.spotBatteryDischarge":"Battery discharging to the grid","settings.relay.type.spotHi":"High spot price","settings.relay.type.spotHi15M":"High spot price (15 min)","settings.relay.type.spotLow":"Low spot price","settings.relay.type.spotLow15M":"Low spot price (15 min)","settings.relay.type.spotMi":"Medium spot price","settings.relay.type.spotMi15M":"Medium spot price (15 min)","settings.relay.type.spotNegative":"Limitation of overflows to the network","settings.relay.type.spotNegative15M":"Prohibition of overflows to the electrical grid (15 min)","settings.relay.type.spotPriceAbove":"Spot price above the set value","settings.relay.type.spotPriceAbove15M":"Spot price above the set value (15 min)","settings.relay.type.spotPriceBelow":"Spot price below the set value","settings.relay.type.spotPriceBelow15M":"Spot price below the set value (15 min)","settings.relay.type.spotStopAccumulation":"Accumulation stopped, active sale","settings.relay.type.stopAccumulation":"Accumulation stopped, active sale","settings.relay.type.thermostat1":"Thermostat 1","settings.relay.type.thermostat2":"Thermostat 2","settings.relay.type.thermostat3":"Thermostat 3","settings.relay.type.thermostat4":"Thermostat 4","settings.relay.user_advanced_control":"Show page with information for the user","settings.relay.user_advanced_control.subtitle":"When enabled, a page appears in the navigation","settings.service":"Service","settings.service.connection_type":"Connection","settings.service.customer":"Username","settings.service.customer-email":"User email","settings.service.customer-email-subtitle":"If the user does not have an account under this email, an account will be automatically created and a registration email will be sent","settings.service.customer-email.label":"E-mail","settings.service.customer-subtitle":"Used to identify the installation for the company and the customer","settings.service.customer.label":"Name","settings.service.exit":"Sign out of the service","settings.service.exit.button":"Log out","settings.service.info":"Installation","settings.service.inverter_type":"Inverter type","settings.service.inverter_type.label":"Inverter","settings.service.modbus_tcp":"LAN/WiFi","settings.service.network":"Network","settings.service.network.help.content":"The list shows devices currently connected to the Infigy network (WiFi or cable), their IP addresses, MAC addresses, etc. If a device uses DHCP, you can click on the pin to fix the IP address, which the DHCP server will always assign - this is useful for devices like inverters, heat pumps, etc. If a device uses a static IP address, it may not display correctly.","settings.service.network.help.title":"Network Settings","settings.service.network.mac":"MAC address","settings.service.network.online.internet":"Access to the internet","settings.service.network.online.internet.help":"Access to the internet is required for remote access, system updates, spot prices and other functions. For full functionality, all three indicators must be green.{br}{br}The first indicator shows the availability of the internet (ping 8.8.8.8).{br}{br}The second indicator shows the availability of the internet including DNS (ping infigy.cz).{br}{br}The third indicator shows access to the internal cloud services of Infigy (VPN availability).{br}{br}If there is a problem with the connection, please check the cable or contact the network administrator, if the local network has restrictions on communication to the internet.{br}{br}{wikiLink}","settings.service.network.online.internet.help.wikiLink":"More information in our wiki.","settings.service.network.online.portal":"Access to the Infigy portal","settings.service.network.wan":"WAN address","settings.service.network.wifi_passphrase":"WiFi Network Password","settings.service.network_type":"Network","settings.service.network_type.custom":"Manual address setting","settings.service.network_type.external":"Local network (customer)","settings.service.network_type.internal":"Internal Infigy network","settings.service.password":"Access to service","settings.service.password.label":"Password","settings.service.relay":"Relay","settings.service.reset":"Error reset","settings.service.reset.button":"Error reset","settings.service.rs485":"RS485","settings.service.service-email":"Service company email","settings.service.service-email-subtitle":"To link the device with the installation account, it is necessary to enter the service company\'s email, which is stored in the Partner section of the application","settings.service.service-email.label":"E-mail","settings.service.servicer":"Name of installer","settings.service.servicer.label":"Name","settings.service.solidsun_op":"SolidSun OP","settings.service.solidsun_op.label":"SolidSun OP","settings.service.spot":"Spot trading","settings.service.tester.label":"Name of tester","settings.service.thermostat":"Thermostat","settings.service.town":"Location (village)","settings.service.version":"Application version","settings.service.wallbox_type":"Wallbox type","settings.service.wallbox_type.label":"Wallbox","settings.spot":"Spot trading","settings.spot.battery":"Allowed battery charging by spot","settings.spot.battery.stop_discharge_auto":"Automatic discharge prohibition control","settings.spot.battery.stop_discharge_auto.help":"If you select this option, the system will automatically control the battery discharge and allow it only at the highest daily spot prices.","settings.spot.battery.stop_discharge_auto.subtitle":"Controlling the storage of energy automatically at the highest price","settings.spot.battery.stop_discharge_hi_price":"Prohibit battery discharge at low and medium prices","settings.spot.battery.stop_discharge_high_price":"Prohibit battery discharge at low and medium prices","settings.spot.battery.stop_discharge_high_price.help":"If you select this option, the system will not use energy from the battery at low and medium spot prices. The system will not discharge the battery. It will be used at higher prices.","settings.spot.battery.stop_discharge_low_price":"Prohibit battery discharge at low prices","settings.spot.battery.stop_discharge_low_price.help":"If you select this option, the system will not use energy from the battery at low spot prices. The system will not discharge the battery. It will be used at higher prices (medium and high price).","settings.spot.battery.stop_discharge_low_price.subtitle":"Controlling the storage of energy at medium and high price","settings.spot.battery.stop_discharge_middle_price.subtitle":"Controlling the storage of energy at high price","settings.spot.batteryAllOverflowPrice":"Minimum price for discharging the entire battery capacity","settings.spot.batteryOverflow":"Allow battery discharge to the grid according to spot prices","settings.spot.batteryOverflowPrice":"Minimum price for battery discharge","settings.spot.batterySale":"Allowed battery discharge to the grid according to spot prices","settings.spot.battery_all_overflow_price":"Minimum price for discharging the entire battery capacity","settings.spot.battery_all_overflow_price.help":"If the spot price is higher than this value, the battery capacity will be discharged to the grid up to the set minimum SOC. This means that the energy will not be stored in the battery for night and morning consumption. The energy will be purchased for the object\'s consumption from the grid after discharging the battery to the grid.","settings.spot.battery_all_overflow_price.subtitle":"The energy is stored in the battery for daily consumption","settings.spot.battery_charge":"Allowed battery charging by spot","settings.spot.battery_charge.help":"If you select this option, the system will schedule charging at the lowest prices. It takes into account the current level of battery charge and its capacity. Based on these parameters, it will select the charging duration to charge the battery at the lowest possible price.","settings.spot.battery_charge.subtitle":"Controlling the battery according to spot increases the battery depreciation","settings.spot.battery_max_soc":"Final SOC of the battery","settings.spot.battery_max_soc.subtitle":"Maximum charging of the battery when charging from the grid","settings.spot.battery_overflow":"Allow battery discharge to the grid according to spot prices","settings.spot.battery_overflow.help":"If you select this option, the system will schedule battery discharge to the grid at the highest daily price and discharge only the energy that is not needed for the daily consumption of the object. The parameters below can define the price for discharging the entire battery capacity and discharging only the part of the battery capacity that is not needed for night consumption.","settings.spot.battery_overflow.subtitle":"Allows discharging the excess energy in the battery to the grid in the most favorable hour","settings.spot.battery_overflow_price":"Minimum price for discharging the battery","settings.spot.battery_overflow_price.help":"If the spot price is higher than this value, the excess battery capacity will be discharged to the grid. This means that the energy will be stored in the battery for night and morning consumption. The energy will not be purchased for the object\'s consumption from the grid.","settings.spot.battery_overflow_price.subtitle":"The energy is stored in the battery for night consumption","settings.spot.battery_strategy":"Strategy for spot charging of the battery","settings.spot.battery_strategy.help":"With this slider, you can easily set the preference for using the battery in spot trading. Lower values (from 20 %) mean less battery cycling and therefore less frequent charging/discharging according to spot prices. Higher values (up to 70 %) mean the opposite.","settings.spot.battery_strategy_service.subtitle":"With this option, you allow the end users to set the battery strategy on the Spot tab","settings.spot.battery_strategy_user":"Allow setting the battery strategy by the user","settings.spot.battery_strategy_user.subtitle":"With this option, you allow the end users to set the battery strategy on the Spot tab","settings.spot.install":"Spot trading active","settings.spot.latitude":"Latitude","settings.spot.latitude.mess":"Width","settings.spot.longitude":"Longitude","settings.spot.longitude.mess":"Length","settings.spot.min_difference_price_charge_from_grid":"Minimum difference in spot price for charging the battery from the grid","settings.spot.min_difference_price_charge_from_grid.help":"With this parameter, you can control the battery charging from the spot at a low difference between the lowest and highest price. If the parameter is 2 CZK and the difference between the highest price (3 CZK) and the lowest price (1 CZK) of the spot is lower, then the battery charging from the spot is not scheduled.","settings.spot.min_difference_price_charge_from_grid.subtitle":"Minimum difference in spot price during the day, for the battery to be charged from the grid","settings.spot.overflow":"Allow overflow optimization according to spot prices","settings.spot.overflow.help":"If you select this option, the system prioritizes overflow to the grid before battery charging at higher and medium spot prices. This happens only in annual periods, in which we expect an excess of energy from PV and usually in the morning. Optimization does not take place at low spot prices, when the priority is charging the battery from PV.","settings.spot.overflow.subtitle":"Allows prioritizing overflow before accumulation","settings.spot.overflow_offset":"Maximum overflow at negative price","settings.spot.overflow_offset.help":"The value indicates the overflow to the distribution network at a negative price. We recommend using this function in the case of an energy community.","settings.spot.overflow_offset.subtitle":"The value cannot be set higher than the maximum overflow","settings.spot.price.period":"Time period","settings.spot.price_above_price":"Set spot price","settings.spot.price_below":"Set spot price","settings.spot.price_distribution_hi":"Price of the grid power at high tariff","settings.spot.price_distribution_hi.help":"Price of the grid power at high tariff per kWh. This price is added to the spot price, if the high tariff is active. The HDO times must be set for the correct calculation of the price in the high and low tariff. This amount can be found in the electricity bill.","settings.spot.price_distribution_low":"Price of the grid power at low tariff","settings.spot.price_distribution_low.help":"Price of the grid power at low tariff per kWh. This price is added to the spot price, if the low tariff is active. The HDO times must be set for the correct calculation of the price in the high and low tariff. This amount can be found in the electricity bill.","settings.spot.price_offset":"The price of prohibiting overflows","settings.spot.price_offset.help":"We recommend setting at least the commission/fee of the trader for selling overflows to the network.","settings.spot.price_offset.subtitle":"Minimum spot price, under which overflows are prohibited. The value is compared with the daily market without the distribution tariff.","settings.spot.region":"Region","settings.thermostat.hp-blocked":"Blocking of the heat pump","settings.thermostat.hysteresis":"Temperature hysteresis","settings.thermostat.install":"Thermostat active","settings.thermostat.name.label":"Name","settings.thermostat.name1":"Thermostat 1 name","settings.thermostat.name2":"Thermostat 2 name","settings.thermostat.name3":"Thermostat 3 name","settings.thermostat.name4":"Thermostat 4 name","settings.thermostat.nominal":"Nominal power of the source","settings.thermostat.number-of-thermostat":"Number of thermostats","settings.utility":"House parameters","settings.utility.loadpercent":"Current circuit breaker load","settings.utility.numberofphase":"Three-phase installation","settings.utility.settings.ampers":"Circuit breaker size","settings.utility.settings.loadpercent":"When exceeded, consumption is limited","settings.utility.settings.loadpercent_max":"When exceeded, consumption is limited","settings.wallbox":"Wallbox","settings.wallbox.install":"Wallbox active","settings.wallbox.name":"Name of the wallbox {number}","settings.wallbox.spot":"Wallbox","settings.wallbox.type":"Wallbox type","shellies.energyMeters":"Energy Meters","shellies.energyMeters.add":"Add","shellies.energyMeters.empty":"No energy meters configured","shellies.energyMeters.list":"Energy Meters Configuration","shellies.energyMeters.name":"Name","shellies.energyMeters.newMeter":"New meter","shellies.energyMeters.shellyId":"Shelly ID","shellies.list":"Shellies","shellies.mqtt_broker_running":"MQTT Broker status","shellies.settings":"Settings","shellies.settings.boiler.active":"Boiler connected via Shellies","shellies.settings.boiler.id":"ID of Shellies","shellies.settings.boiler.id.label":"ID","shellies.title":"Shellies","spot.chartview":"Display the price without the distribution fee","spot.draft":"Modes for today","spot.draft.actualpricehi":"The current price is high, reduce consumption","spot.draft.actualpricelow":"The current price is low, increase consumption","spot.draft.hesLevel":"Level of HES control","spot.draft.hiprice":"Limits of reduced consumption","spot.draft.info":"Modes and recommendations for today","spot.draft.lowprice":"The limit of increased consumption","spot.draft.todaystatus_HP":"Heat pump accumulation","spot.draft.todaystatus_HW":"Hot water accumulation","spot.draft.todaystatus_bat":"Battery accumulation","spot.draft.todaystatus_em":"Overflow","spot.explanation":"Explanation of modes","spot.explanation.battery_discharge_to_grid":"Discharging the battery to the grid","spot.explanation.battery_discharge_to_home":"Discharging the battery","spot.explanation.hw":"Charging the battery from the grid","spot.explanation.info":"Detailed explanation of modes for today","spot.flexibility":"Flexibility estimate for today","spot.prediction":"Consumption estimate for today","spot.prediction.bat":"Dispositional battery accumulation","spot.prediction.battery":"Dispositional battery accumulation","spot.prediction.home":"Normal consumption of the house","spot.prediction.hp":"Heat pump","spot.prediction.hw":"Dispositional hot water accumulation","spot.prediction.pv":"Photovoltaics production","spot.prediction.sale":"Energy for sale","spot.prediction.sale.help":"Remaining planned daily overflow, which will be prioritized as overflow to the grid before battery accumulation.","spot.price.period.15min":"15 min","spot.price.period.60min":"60 min","spot.region.cz":"CZ","spot.region.nl":"NL","spot.region.sk":"SK","spot.status":"Spot trading","spot.summary.battery_charge_from_grid":"Charging from the grid","spot.summary.battery_charge_from_grid.help":"Charging the battery from the grid according to the spot price can be enabled or disabled in the settings. The system schedules battery charging during low prices, considering the current battery level and its capacity. Based on these parameters, it determines the charging duration to charge the battery at the lowest cost.","spot.summary.battery_discharge":"Battery discharge","spot.summary.battery_discharge.help":"Discharging the battery to the house according to the spot price can be enabled or disabled in the settings. Discharging is usually disabled during low prices when it is better to use energy from the grid and save the battery for higher price periods.","spot.summary.battery_discharge_to_grid":"Discharge to the grid","spot.summary.battery_discharge_to_grid.help":"Discharging the battery to the grid can be enabled or disabled in the settings. The system schedules battery discharge to the grid during the highest daily prices, discharging only the energy that will not be needed for the house\'s regular consumption.","spot.summary.boiler":"Boiler","spot.summary.boiler.help":"The system schedules boiler heating during low prices, considering the current water temperature, boiler capacity, and desired temperature. Based on these parameters, it determines the heating duration to heat the boiler.","spot.summary.heat_pump":"Heat pump","spot.summary.heat_pump.help":"The heat pump can operate in three modes: increased performance, normal operation, and reduced performance. Increased performance is used during low prices, normal operation during medium prices, and reduced performance during high prices. Consumption delay or increase can be enabled in the heat pump menu.","spot.summary.heat_pump_level.increase":"Increased performance","spot.summary.heat_pump_level.normal":"Normal operation","spot.summary.heat_pump_level.reduction":"Reduced performance","spot.summary.price":"Price","spot.summary.price_buy":"Price with distribution","spot.summary.price_distribution":"Distribution","spot.summary.price_level":"Price level","spot.summary.price_level.help":"Infigy sorts hourly spot prices from lowest to highest and divides them into three approximately equal parts. If hourly prices range from 3 CZK to 10 CZK, the low price range might be 3-6 CZK, medium 6-7 CZK, and high 7-10 CZK. The range will vary daily, depending on the frequency of values in each price level.","spot.summary.price_level.hi":"High price","spot.summary.price_level.low":"Low price","spot.summary.price_level.mid":"Medium price","spot.summary.price_level_15m":"Price level 15m","spot.summary.price_sell":"Price without distribution","spot.summary.spotOverflow":"Overflow to the grid","spot.summary.spotOverflow.allowed":"Allowed","spot.summary.spotOverflow.help":"Allowing overflow to the grid during spot trading compares the spot price in a given hour and if it is lower than the price for prohibiting overflow from the settings, then the system automatically disables the overflow in that hour.","spot.summary.spotOverflow.restricted":"Restricted","spot.summary.state.active":"Active","spot.summary.state.inactive":"Inactive","spot.summary.time":"Time","spot.user.parameters":"Parameters of spot trading","spot_wizard.banner.button":"Want help? I can help you","spot_wizard.banner.subtitle":"The guide will help you set up spot trading.","spot_wizard.banner.title":"Need help? I can help you","spot_wizard.battery_discharge.paragraph1":"This setting disables battery discharge at low spot prices. This way you keep energy for higher prices during the day.","spot_wizard.battery_discharge.paragraph2":"If you only sell energy on the spot, you can disable the prohibition.","spot_wizard.battery_discharge.title":"Discharging the battery to your own consumption","spot_wizard.battery_purchase.paragraph1":"This setting allows charging the battery from the lowest spot price when the production is low.","spot_wizard.battery_purchase.paragraph2":"Pay attention to the strategy setting. If you set 20%, Infigy will mostly wait for photovoltaics. On the other hand, if you set 70%, Infigy will mostly buy on the spot. We recommend setting 25%.","spot_wizard.battery_purchase.paragraph3":"If you only sell energy on the spot, you can disable the charging.","spot_wizard.battery_purchase.title":"Buying energy into the battery","spot_wizard.boiler.paragraph1":"This setting allows heating the boiler from the lowest prices during the day to the set temperature. Infigy still maintains the basic temperature and uses the increase in temperature from the spot.","spot_wizard.boiler.paragraph2":"It is also possible to block heating at medium or high prices.","spot_wizard.boiler.paragraph3":"If you only sell energy on the spot, you can set the temperature to 10\xb0C and disable the heating block.","spot_wizard.boiler.title":"Heating the boiler","spot_wizard.dialog.finish":"Finish","spot_wizard.dialog.next":"Next","spot_wizard.dialog.prev":"Previous","spot_wizard.dialog.step":"Step {current} of {total}","spot_wizard.dialog.title":"Guide to setting up spot trading","spot_wizard.distribution_prices.title":"Enter the price for distribution in low and high price ranges","spot_wizard.done.description":"You have completed the spot trading settings. All parameters can be edited in the bottom part of the Spot page, where you can also call this guide again.","spot_wizard.done.title":"Done","spot_wizard.evening_peak_discharge.paragraph1":"Infigy automatically estimates the energy consumption in the morning hours. The excess can be sold at the highest price of the day.","spot_wizard.evening_peak_discharge.paragraph2":"If you only buy energy on the spot, you can disable the discharge.","spot_wizard.evening_peak_discharge.title":"Discharging the battery in the evening peak","spot_wizard.general_settings.title":"First general settings","spot_wizard.hdo_times.title":"Setting HDO times determines the low price period","spot_wizard.heat_pump.paragraph1":"This setting allows increasing the performance of the heat pump at low production and decreasing it at high prices.","spot_wizard.heat_pump.paragraph2":"If you only sell energy on the spot, you can disable the delay and increase of consumption.","spot_wizard.heat_pump.title":"Heat pump","spot_wizard.info.button1":"Why is my battery not charging from the spot today?","spot_wizard.info.button2":"Why is my battery not discharging to the spot today?","spot_wizard.info.button3":"I need help with setting up","spot_wizard.info.help1.title":"Why is my battery not charging from the spot today?","spot_wizard.info.help2.title":"Why is my battery not discharging to the spot today?","spot_wizard.info.title":"Information about spot trading","spot_wizard.overflow_limit.paragraph1":"If you have spot only for buying energy, you can set -10 K\u010D. Overflow is limited to the maximum size set by the service technician.","spot_wizard.overflow_limit.paragraph2":"If you have spot for selling energy, it is advantageous to stop accumulation at a price that corresponds to the commission of your supplier. The commission is usually 0.30 - 0.70 K\u010D/kWh.","spot_wizard.overflow_limit.title":"Limitation of overflow to the grid","spot_wizard.preferential_sale.paragraph1":"This function sets feed-in priority during the morning peak. Energy is preferentially sold to the grid instead of being stored in the battery, boiler, and heat pump. Accumulation is re-enabled at low prices or after selling the estimated surplus energy.","spot_wizard.preferential_sale.paragraph2":"If you only buy energy on the spot, you can disable the function.","spot_wizard.preferential_sale.title":"Preferential sale of energy","statistics.battery.statistics":"Level of battery charging","statistics.boiler.statistics":"Electric boiler heating","statistics.electrical_grid.statistics":"Purchase from a grid","statistics.electrical_grid.statistics_house_consumption":"Building consumption","statistics.electrical_grid.statistics_overflow":"Overflow to a grid ","statistics.heatpump.statistics":"Heat pump consumption","statistics.outdoor_temperature.statistics":"Outdoor temperature","statistics.photovoltaics.statistics":"Photovoltaics production","statistics.plug.statistics":"Socket consumption","statistics.wind.statistics":"Wind turbine production","stats_delete.button":"Delete","stats_delete.cancel":"Cancel","stats_delete.confirm":"Delete","stats_delete.confirm.title":"Do you really want to delete all statistics?","stats_delete.title":"Delete all statistics","stats_export.button":"Export","stats_export.from":"From","stats_export.metric":"Metric","stats_export.title":"Export statistics","stats_export.to":"To","status.heatWater.flexibility":"Flexibility active, heating of hot water","status.heatWater.heating":"Heating of hot water","status.heatWater.hwError":"The boiler is fully heated or not available","status.heatWater.inverterError":"Preheating is inactive, the inverter is not available","status.heatWater.legionella":"Sanitation of water, legionella","status.heatWater.notConnected":"Cannot establish connection","status.heatWater.notLicensed":"Boiler control is not licensed","status.heatWater.off":"Off","status.heatWater.overload":"Overload of the network, heating stopped","status.heatWater.pvHeating":"Heating from excess","status.heatWater.smartMeterError":"Preheating of the boiler is inactive, the electric meter is not available","status.heatWater.spotHeating":"Heating of hot water from the spot","status.heatWater.stop":"Stop","status.heatWater.stopHDO":"Heating blocked at high price","status.heatWater.stopSOC":"Heating blocked, low battery level","status.heatWater.stopSell":"Preheating blocked, sale of energy","status.heatWater.tempError":"Temperature sensor is not available","status.photovoltaic.dischargeBlockedByComponents":"Battery discharge paused due to consumption of selected technologies","status.photovoltaic.dischargeBlockedByHDO":"Battery discharge paused, high tariff active (HDO)","status.photovoltaic.discharging":"Discharging of the battery","status.photovoltaic.distributionLimit":"Distribution limits power","status.photovoltaic.feedInPriority":"Feed-in priority","status.photovoltaic.flexibilityBatteryStop":"Flexibility active, battery charging and discharging stopped","status.photovoltaic.flexibilityCharging":"Flexibility active, charging of the battery from the network","status.photovoltaic.flexibilityDischarging":"Flexibility active, discharging of the battery to the network","status.photovoltaic.flexibilityDoNotDischarge":"Flexibility active, prohibition of discharging the battery","status.photovoltaic.flexibilityFeedInPriority":"Flexibility active, priority of overflow to the network","status.photovoltaic.flexibilityOverflowRestricted":"Flexibility active, prohibition of overflow to the network","status.photovoltaic.forcedOverflow":"Flexibility active, forced overflow to the network","status.photovoltaic.idle":"Idle mode","status.photovoltaic.manualCharging":"Manual charging of the battery","status.photovoltaic.manualDischarging":"Manual discharging of the battery","status.photovoltaic.noOverflowLimit":"No overflow limit","status.photovoltaic.noneInverter":"Inverter type not set","status.photovoltaic.notConnected":"Cannot establish connection","status.photovoltaic.notLicensed":"PV control is not licensed","status.photovoltaic.planCharge":"Planned charging of the battery","status.photovoltaic.planDischarge":"Planned discharging of the battery","status.photovoltaic.production":"Production of energy","status.photovoltaic.sellBatteryEnergy":"Sale of energy from the battery","status.photovoltaic.spotCharging":"Charging of the battery from the spot","status.photovoltaic.spotStopDischarging":"Discharging stopped, low price on the spot","status.photovoltaic.standby":"Stand-by mode","status.photovoltaic.startUp":"Start-up mode","status.plug.batteryControl":"Socket active according to battery","status.plug.manualControl":"Socket active in manual mode","status.plug.notActive":"Socket inactive","status.plug.notConnected":"Cannot establish connection","status.plug.overflowControl":"Socket active according to overflow","status.plug.spotControl":"Socket active according to spot","status.plug.stop":"Stop","status.plug.timeControl":"Socket active according to time","status.smartMeter.consumption":"Normal consumption of the house","status.smartMeter.maxLoad":"Maximum consumption of the house","status.smartMeter.none":"","status.smartMeter.overflow":"Overflow energy to the grid","status.smartMeter.overflowLimited":"Overflow limited due to negative price","status.smartMeter.shortage":"Shortage of the distribution network","status.spotBattery.flexibilityPV":"Flexibility used for PV","status.spotBattery.flexibilitySpot":"Flexibility used for SPOT","status.spotBattery.noData":"No data for control","status.spotBattery.spotNotLicensed":"Spot is not licensed","status.spotBatteryChargeFromGrid.batteryChargingNotActive":"Charging from the grid is not active","status.spotBatteryChargeFromGrid.batteryChargingPlanned":"Today\'s charging is active","status.spotBatteryChargeFromGrid.enoughPVEnergy":"Today\'s expected daily surplus for charging the battery","status.spotBatteryChargeFromGrid.priceDifferenceTooLow":"Today\'s minimum price difference is not met","status.spotBatteryChargeFromGrid.spotNotActive":"Spot trading is not active","status.spotBatteryDischargeToGrid.batteryDischargingNotActive":"Discharging to the grid is not active","status.spotBatteryDischargeToGrid.batteryDischargingPlanned":"Today\'s discharging is active","status.spotBatteryDischargeToGrid.minPriceNotReached":"Today\'s minimum price for sale is not met","status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy":"Today\'s expected discharge of the battery through the night into own consumption","status.spotBatteryDischargeToGrid.spotNotActive":"Spot trading is not active","status.spotBatteryDischargeToHome.automaticDischargeMode":"Automatic discharging of the battery according to capacity","status.spotBatteryDischargeToHome.highPriceDischargeMode":"Discharging the battery at high price","status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode":"Discharging the battery at medium and high price","status.spotBatteryDischargeToHome.notControlled":"Discharging the battery is not limited","status.spotHeatPump.flexibilityPV":"Flexibility used for PV","status.spotHeatPump.flexibilitySpot":"Flexibility used for SPOT","status.spotHeatPump.noData":"No data for control","status.spotHeatPump.spotNotLicensed":"Spot is not licensed","status.spotHeatWater.flexibilityPV":"Flexibility used for PV","status.spotHeatWater.flexibilitySpot":"Flexibility used for SPOT","status.spotHeatWater.noData":"No data for control","status.spotHeatWater.spotNotLicensed":"Spot is not licensed","status.spotSmartMeter.noData":"No data for control","status.spotSmartMeter.overflowDisabled":"Permanent overflow limitation","status.spotSmartMeter.overflowFlexibilitySell":"Optimization of overflow for sale","status.spotSmartMeter.overflowLimited":"Overflow limited due to negative price","status.spotSmartMeter.spotNotLicensed":"Spot is not licensed","status.spotSmartMeter.withoutReduction":"Without limitation","status.wind.production":"Producing energy","status.wind.stop":"STOP","status.wind.unavailable":"Unavailable","subscriptions.fetch":"Update subscription","subscriptions.fetch.button":"Update subscription","subscriptions.last_fetch_at":"Last update","subscriptions.premium_active":"Premium active","subscriptions.title":"Subscription","test-product.app":"Application","test-product.settings":"Settings","test-product.settings.distribution":"Distribution","test-product.settings.distribution.Dzd":"DZD","test-product.settings.distribution.Infigy":"Infigy","test-product.settings.distribution.solid_sun":"SolidSun","test-product.settings.license":"License","test-product.settings.license.HW":"HW","test-product.settings.license.Industrial":"Industrial","test-product.settings.license.Play":"PLAY","test-product.settings.license.Smart":"Smart","test-product.settings.license.basic":"Basic","test-product.test":"Device test","test-product.test.DC":"Checking the DC circuit","test-product.test.DC.subtitle":"Connecting the terminals, cable dimensions","test-product.test.component":"Component inspection","test-product.test.component.subtitle":"Is a sensor, labels, ...?","test-product.test.electricmeter":"Checking the smartmeter","test-product.test.electricmeter.subtitle":"Checking the installation of the smartmeter for the inverter","test-product.test.internet-connect":"Internet connection","test-product.test.inverter-connect":"Connecting the inverter","test-product.test.license":"License","test-product.test.license-info":"License","test-product.test.phase_1":"Phase 1 test","test-product.test.phase_2":"Phase 2 test","test-product.test.phase_3":"Phase 3 test","test-product.test.serialNumber":"Serial number of the unit","test-product.test.serialNumber.label":"Serial number","test-product.test.serialNumber.subtitle":"Without a serial number, the name of the tester and the test cannot be entered","test-product.test.serialNumberSwitchboard":"Production number of the cabinet","test-product.test.serialNumberSwitchboard.label":"Serial number","test-product.test.serialNumberSwitchboard.subtitle":"Fill in case the device is in the original cabinet","test-product.test.start":"If the device is connected","test-product.test.start.button":"Activate the test","test-product.test.switchboard":"Checking the compliance of the cabinet","test-product.test.switchboard.subtitle":"Checking the connection of the terminals, the placement of the components, the correct cable dimensions","test-product.test.temp":"Temperature sensor","test-product.test.tester":"Device tested by","test-product.test.tester.subtitle":"Without a name, the test cannot be activated","thermostat.general":"General settings","thermostat.general.cooling":"Cooling active","thermostat.general.cooling.pvstability":"Potential activation of the source","thermostat.general.heating":"Heating active","thermostat.range":"Thermostat","thermostat.range.flexibility-temperature":"Flexible temperature","thermostat.range.flexibility-temperature.subtitle":"Temperature by which the house can be preheated or precooled","thermostat.range.flexibility_status":"Thermostat flexibility mode","thermostat.range.on":"Thermostat active","thermostat.range.on.subtitle":"Base temperature","thermostat.range.pv-flexibility":"Control by photovoltaics","thermostat.range.set_temperature":"Set temperature","thermostat.range.sp-flexibility-down":"Postpone consumption according to spot","thermostat.range.sp-flexibility-up":"Increase consumption according to spot","thermostat.range.status":"Thermostat flexibility mode","thermostat.range.temperature":"Set temperature","thermostat.statisticsTemp":"Thermostat temperature","thermostat.status":"Thermostat mode","wallbox.3a.on":"Mode 3A","wallbox.3a.on_sub":"Charging can draw 3A from the distribution network","wallbox.6a.on":"Mode 6A","wallbox.6a.on_sub":"Charging only from photovoltaics","wallbox.NO_CHARGE":"Do not charge","wallbox.NO_CHARGE.on_sub":"Charging is permanently blocked; only a schedule can start it","wallbox.PV":"Charging according to battery","wallbox.PV.batteryStart":"Turn on while fully charged","wallbox.PV.batteryStart.subtitle":"Start charging when the battery is charging","wallbox.PV.batteryStop":"Turn off while fully charged","wallbox.PV.batteryStop.subtitle":"Stop charging when the battery is charging","wallbox.PV.on":"Active","wallbox.PV.on_sub":"After reaching the baseline energy, charging will occur only when the battery is fully charged","wallbox.PV2":"Charging according to PV","wallbox.PV2.on":"Active","wallbox.PV2.on_sub":"Charging control according to PV performance","wallbox.PV_FAST":"Priority charging according to battery","wallbox.PV_FAST.batteryMinSoc":"Minimum battery reserve","wallbox.PV_FAST.batteryMinSoc.subtitle":"The battery will not be discharged below this value for car charging. Until this value is exceeded, charging waits","wallbox.PV_FAST.on_sub":"Car charging will have full priority. Only energy from the battery or PV will be used","wallbox.SPOT":"Charging according to spot prices","wallbox.SPOT.hi":"Prevent charging at high prices","wallbox.SPOT.mi":"Prevent charging at mid prices","wallbox.SPOT.on":"Active","wallbox.SPOT.on_sub":"After reaching the baseline energy, blocking will occur during high spot prices","wallbox.active":"{name}","wallbox.active.subtitle":"Active","wallbox.alfen":"Alfen","wallbox.authorization.status":"Authorization","wallbox.authorization.status.authorized":"Authorized{cardInfo}","wallbox.authorization.status.denied":"Denied{cardInfo}","wallbox.authorization.status.pending":"Not authorized","wallbox.authorization.status.unknown":"Unknown status","wallbox.az_router":"AZ Router","wallbox.common":"General information","wallbox.common.power":"Current consumption","wallbox.common.power_today":"Today\'s consumption:","wallbox.common.power_total":"Total consumption","wallbox.common.power_year":"Annual consumption:","wallbox.control":"Charging mode","wallbox.ecovolter":"EcoVolter","wallbox.evmate":"EVmate","wallbox.fast-charge":"Fast charging","wallbox.fast-charge.energy":"Energy for fast charging","wallbox.fast-charge.energy_actual":"Charged energy in the current cycle","wallbox.fast-charge.energy_sub":"Energy that is always charged as quickly as possible. After reaching this value, charging is controlled by one of the modes.","wallbox.goodwe-ev-charger":"Goodwe","wallbox.inactive.subtitle":"Inactive","wallbox.mode.pv.batteryStopConflict.description":"If the battery blocking is enabled when the wallbox is operating, the mode \u201ECharge according to battery\u201C cannot be enabled. To enable the mode \u201ECharge according to battery\u201C, you must first turn off the battery blocking on the \u201EPhotovoltaics\u201C page.","wallbox.mode.pv.batteryStopConflict.title":"Mode cannot be enabled","wallbox.mybox":"MyBox","wallbox.none":"None","wallbox.nonemode":"Regular charging","wallbox.nonemode.amper-auto":"Automatic control of the charging current","wallbox.nonemode.amper-auto.subtitle":"Controls charging to minimize charging and discharging of the battery","wallbox.nonemode.ampers":"Maximum charging current","wallbox.nonemode.hdo":"Charging only at low tariff","wallbox.nonemode.hdo_sub":"The HDO times must be set in the general settings","wallbox.nonemode.on":"Active","wallbox.nonemode.on_sub":"The car charges as quickly as possible","wallbox.olife":"Olife","wallbox.other":"Other","wallbox.pv.ampers-auto":"Current desired charging current","wallbox.schedules.description":"Schedule EV charging as needed.","wallbox.schedules.title":"Charging scheduler","wallbox.settings":"Settings","wallbox.solax":"Solax - communication via inverter","wallbox.solax-ev-charger":"Solax - communication via Infigy","wallbox.statistics":"Statistics","wallbox.status":"Wallbox mode","wallbox.status.car_not_connected":"Car not connected","wallbox.status.charging":"Charging","wallbox.status.charging_with_ventilation":"Charging with ventilation","wallbox.status.error":"Error","wallbox.status.home":"Wallbox mode","wallbox.status.normal":"Normal","wallbox.status.not_connected":"Cannot establish connection","wallbox.status.off":"Wallbox off","wallbox.status.ready":"Ready to charge","wallbox.sub_status.auto":"according to auto. mode","wallbox.sub_status.basic_energy":"basic energy","wallbox.sub_status.battery":"according to battery","wallbox.sub_status.battery_fast":"priority according to battery","wallbox.sub_status.battery_waiting":", waiting for battery charge","wallbox.sub_status.hdo_block":", HDO block","wallbox.sub_status.no_charging":", charging is disabled","wallbox.sub_status.none":"","wallbox.sub_status.photovoltaics":"according to PV","wallbox.sub_status.schedule":"according to scheduler","wallbox.sub_status.spot":"according to SPOT","wallbox.sub_status.spot_high":", high SPOT price","wallbox.sub_status.spot_mid":", medium SPOT price","wallbox.victron-ev-charger":"Victron EV Charger","wallbox.wallboxes.title":"Wallboxes","wallbox_rfid.add_button":"Add RFID card","wallbox_rfid.delete.cancel":"Cancel","wallbox_rfid.delete.confirm":"Delete","wallbox_rfid.delete.confirm.title":"Delete card {name}?","wallbox_rfid.dialog.already_exists":"Card {id} is already stored under the name {name}.","wallbox_rfid.dialog.already_exists_hint":"Please place another card or close the dialog.","wallbox_rfid.dialog.cancel":"Cancel","wallbox_rfid.dialog.name_label":"Name of the card","wallbox_rfid.dialog.save":"Save","wallbox_rfid.dialog.scanned_id":"Card ID: {id}","wallbox_rfid.dialog.title":"Add RFID card","wallbox_rfid.dialog.waiting":"Please place the card to the reader\u2026","wallbox_rfid.edit.dialog.title":"Edit RFID card","wallbox_wizard.cancel":"Cancel","wallbox_wizard.custom_device_ip_address.alert":"Please make sure that the wallbox IP address does not change (e.g. when the wallbox uses a DHCP address).","wallbox_wizard.custom_device_ip_address.input":"Wallbox IP address","wallbox_wizard.multiple_wallboxes.alert":"For the configuration of multiple wallboxes, please contact the support line. Contact can be found in the technical wiki Infigy.","wallbox_wizard.multiple_wallboxes.label":"Multiple wallboxes","wallbox_wizard.open":"Configure wallbox","wallbox_wizard.save":"Save","wallbox_wizard.title":"Wallbox configuration","welcome.subtitle":"Applications for domestic and modern energy in one place!","welcome.title":"Welcome to Infigy!","wifi_ap_config.interface_block.confirm.confirmation_text":"{blocked, select, true {Block} other {Unblock}}","wifi_ap_config.interface_block.confirm.content":"Do you really want to {blocked, select, true {block} other {unblock}} WiFi?","wifi_ap_config.interface_block.confirm.title":"Change WiFi Status","wifi_ap_config.passphrase_change.confirm.passphrase":"Password","wifi_ap_config.passphrase_change.confirm.title":"Change WiFi Password","wifi_ap_config.wifi_interface_blocked.button":"{blocked, select, true {Unblock} other {Block}}","wifi_ap_config.wifi_interface_blocked.title":"WiFi Status","wifi_ap_config.wifi_interface_blocked.value":"{blocked, select, true {Blocked} other {Active}}","wind.common":"General information","wind.common.battery_charged_total":"Total power to battery","wind.common.battery_current":"Battery current","wind.common.battery_power":"Battery power","wind.common.battery_voltage":"Battery voltage","wind.common.load_current":"Load current","wind.common.power":"Current wind power","wind.common.power_today":"Today\'s production:","wind.common.power_total":"Total production","wind.common.power_year":"Annual production:","wind.common.resistor_power":"Load current","wind.statistics":"Statistics","wind.statistics.battery_charge_power":"Battery power","wind.statistics.load_current":"Load current","wind.statistics.power":"Wind turbine power","wind.statistics.wind_speed":"Wind speed","wind.status":"Wind turbine mode"}');


var $0634569c145abc64$exports = {};
$0634569c145abc64$exports = JSON.parse('{"\\"chart.tooltip.substat.phase\\"":"Fase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}","\\"chart.tooltip.substat.pv_string\\"":"{inverterName}, String {stringNumber}","TEST":"XXX","animation.battery":"Batterij","animation.boiler":"Boiler","animation.consumption":"Huis","animation.electrical_grid":"Net","animation.hp":"Warmtepomp","animation.photovoltaics":"Fotovolta\xefsche","animation.wallbox":"Wallbox","animation.wind":"Wind","app_messages.battery_max_soc":"Batterij opladen om maximale SOC in te stellen {maxSoc, number, ::.##}%","app_messages.battery_min_soc":"Batterij ontladen om minimale SOC in te stellen {minSoc, number, ::.##}%","app_messages.body.battery_max_soc":"Het huidige laadniveau van de batterij is {currentSoc, number, ::.##}%.","app_messages.body.battery_min_soc":"Het huidige laadniveau van de batterij is {currentSoc, number, ::.##}%.","app_messages.body.heat_pump_limit_exceeded":"De verbruikslimiet van de warmtepomp is overschreden. De ingestelde limiet is {value, number, ::.##} kW.","app_messages.body.heat_water_limit_exceeded":"De limiet voor warmwaterverbruik is overschreden. De ingestelde limiet is {value, number, ::.##} kW.","app_messages.body.heat_water_max_temperature":"De boiler heeft vandaag al de maximale temperatuur van {maxTemperature, number, ::.##}\xb0C bereikt.","app_messages.body.home_limit_exceeded":"De verbruikslimiet van het huis is overschreden. De ingestelde limiet is {value, number, ::.##} kW.","app_messages.body.inverter_production_mwh":"Uw zonnepaneleninstallatie heeft al geproduceerd {inverterProductionValue, number, ::.##} MWh dit jaar.","app_messages.body.spot_daily_prediction":"Dagelijkse voorspelling: {pvPrediction, select, true {PV-productie: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Huisverbruik: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Batterijopslag: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boileropslag: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Warmtepompverbruik: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Resterende energie voor verkoop: {salePredictionValue, number, ::.##} kWh. } other {} }","app_messages.body.spot_daily_summary":"Vandaag op de spotmarkt: {nothingToReport, select, true {Er is niets gepland.} other { {energyForSale, select, true {Het plan is om in de ochtend te verkopen. } other {} } {negativeIntervals, select, false {} other {Negatieve prijs ({negativeIntervals}), wat de overloop zal verminderen. } } {chargingIntervals, select, false {} other {Plan voor batterijladen ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plan voor batterij ontladen ({dischargingIntervals}). } } } }","app_messages.body.spot_negative_price_start":"De huidige spotprijs is negatief na aftrek van de commissie. De commissie ingesteld in Infigy is {spotOffsetPrice, number, ::.##} CZK. De huidige spotprijs is {spotNegativePrice, number, ::.##} CZK.","app_messages.body.spot_negative_price_stop":"De huidige spotprijs is niet langer negatief en is {spotNegativePrice, number, ::.##} CZK. De commissie is in Infigy ingesteld op {spotOffsetPrice, number, ::.##} CZK","app_messages.body.wallbox_limit_exceeded":"De oplaadlimiet van het elektrische voertuig is overschreden. De ingestelde limiet is {value, number, ::.##} kW.","app_messages.body.wallbox_stop_charging":"In deze cyclus, {wallboxConsumptionCycleValue, number, ::.##} kWh energie is toegevoegd.","app_messages.button":"Alle berichten verwijderen","app_messages.cancel":"Annuleren","app_messages.confirm":"Alle berichten verwijderen","app_messages.confirm.title":"Wilt u echt alle berichten verwijderen?","app_messages.detail_dialog.close":"Lees","app_messages.heat_pump_limit_exceeded":"De limiet voor het verbruik van de warmtepomp is overschreden","app_messages.heat_water_limit_exceeded":"De limiet voor het warmwaterverbruik is overschreden","app_messages.heat_water_max_temperature":"De maximale temperatuur van het water is bereikt","app_messages.home_limit_exceeded":"De limiet voor het verbruik in huis is overschreden","app_messages.inverter_connected":"De communicatie met de omvormer is tot stand gebracht","app_messages.inverter_disconnected":"De communicatie met de omvormer is verbroken","app_messages.inverter_production_mwh":"Mijlpaal PV-productie","app_messages.load_more":"Meer laden","app_messages.no_messages":"Er zijn hier nog geen meldingen","app_messages.spot_battery_discharge":"Het spotgebaseerde afvoerplan is {spotDischargePlan}","app_messages.spot_daily_prediction":"Dagelijkse voorspelling","app_messages.spot_daily_summary":"Dagelijks overzicht van het spotplan","app_messages.spot_negative_price_start":"De spotprijs is negatief","app_messages.spot_negative_price_stop":"De spotprijs is niet langer negatief","app_messages.spot_start_charging_battery":"Het opladen van de batterij volgens de spotprijs is gestart","app_messages.spot_start_discharging_battery":"Het ontladen van de batterij naar het net volgens de spotprijs is gestart","app_messages.spot_stop_charging_battery":"Het opladen van de batterij volgens de spotprijs is gestopt","app_messages.spot_stop_discharging_battery":"Het ontladen van de batterij naar het net volgens de spotprijs is gestopt","app_messages.test":"Testmelding","app_messages.title":"Alle berichten verwijderen","app_messages.utility_loss_start":"We hebben een stroomstoring gedetecteerd","app_messages.utility_loss_stop":"De stroomstoring is verholpen","app_messages.wallbox_limit_exceeded":"De oplaadlimiet van het elektrische voertuig is overschreden","app_messages.wallbox_start_charging":"Het opladen van de elektrische auto is gestart","app_messages.wallbox_stop_charging":"Het opladen van de elektrische auto is gestopt","app_update_overlay.subtitle":"Even geduld. Na voltooiing van de update herstart de applicatie en wordt het browservenster automatisch vernieuwd","app_update_overlay.title":"Update wordt uitgevoerd","audit_log.error":"Fout tijdens het laden","audit_log.item.author":"Auteur","audit_log.item.date":"Datum","audit_log.item.payload":"Gebeurtenis","audit_log.item.type":"Type","audit_log.title":"Auditlogboek","audit_log_delete.button":"Verwijderen","audit_log_delete.cancel":"Annuleren","audit_log_delete.confirm":"Verwijderen","audit_log_delete.confirm.title":"Wilt u echt alle records in het auditlogboek verwijderen?","audit_log_delete.title":"Auditlogboek verwijderen","azRouters.add":"Nieuwe AZ router toevoegen","azRouters.addButton":"Toevoegen","azRouters.clientId":"Modbus-ID","azRouters.clientId.value":"Modbus-ID: {id}","azRouters.counts":"OK {ok} / Fout {err}","azRouters.empty":"Geen AZ routers geconfigureerd","azRouters.name":"Naam","azRouters.status.error":"Fout","azRouters.status.ok":"OK","azRouters.status.starting":"Starten","azRouters.title":"AZ routers","bez_dodavatele.business_flexibility.title":"Zakelijke flexibiliteit","bez_dodavatele.enabled":"Integratie ingeschakeld","bez_dodavatele.region":"Regiocode","bez_dodavatele.title":"bezDodavatele","boiler.blocking":"Verwarmingsblokkering","boiler.common":"Algemene informatie","boiler.common.phase_3":"Fase 3","boiler.common.power":"Totaal verbruik","boiler.common.power.phase_1":"Fase 1","boiler.common.power.phase_2":"Fase 2","boiler.common.power_today":"Huidig verbruik","boiler.common.power_year":"Jaarlijks verbruik","boiler.common.temperature":"Huidige temperatuur","boiler.common.total":"Totaal verbruik","boiler.settings":"Instellingen","boiler.settings.hdo":"Schakel de reguliere verwarming uit tijdens het hoge tarief","boiler.settings.hdo.subtitle":"Tijden voor het hoge tarief moeten worden ingesteld in de algemene instellingen","boiler.settings.min_soc":"Verwarmingsblok","boiler.settings.min_soc.subtitle":"Batterijladingsniveau waarbij de verwarming wordt geblokkeerd tijdens een stroomstoring","boiler.settings.min_soc_utility":"Verwarmingsblok wanneer het elektriciteitsnet beschikbaar is","boiler.settings.min_soc_utility.subtitle":"Batterijladingsniveau waarbij verwarming wordt geblokkeerd tijdens een stroomstoring","boiler.settings.spot-hi":"Verwarming blokkeren bij hoge spotprijs","boiler.settings.spot-mi":"Verwarming blokkeren bij gemiddelde spotprijs","boiler.settings.temp":"Ingestelde temperatuur","boiler.settings.temp.subtitle":"Een algemene temperatuur die altijd beschikbaar is","boiler.settings.temp_ek":"Temperatuur van fotovolta\xefsche energie met behulp van een elektrische boiler","boiler.settings.temp_ek.subtitle":"Voorverwarmingstemperatuur die alleen voor een lage prijs geldt","boiler.settings.temp_spot":"Temperatuur van de spot met elektrische boiler","boiler.settings.temp_spot.subtitle":"Voorverwarmingstemperatuur die alleen voor een lage prijs beschikbaar is","boiler.statistics":"Statistieken","boiler.statisticsTemp":"Boilertemperatuur","boiler.status":"Boilerstand","boiler.status.home":"Boilerstand","boiler_test_trigger.button":"Boiler testen","boiler_test_trigger.button.running":"Test wordt uitgevoerd","boiler_test_trigger.subtitle":"Controleert het juiste aansluiten en de ingestelde kracht van de boiler.","boiler_test_trigger.title":"Boiler testen","boiler_test_wizard.acknowledge.condition":"Voor een juiste boiler test is het noodzakelijk dat de verbruik in het object constant of nul is. Willekeurige schommelingen in het verbruik kunnen de test be\xefnvloeden. Het huidige verbruik van het object is {power}","boiler_test_wizard.acknowledge.config":"Het huidige {phaseLabel} boiler is ingesteld met een totale kracht van {power}. Deze waarden moeten worden ingesteld volgens het etiket van de boiler.","boiler_test_wizard.acknowledge.confirm":"Bevestigen","boiler_test_wizard.acknowledge.phase1":"1-fasig","boiler_test_wizard.acknowledge.phase3":"3-fasig","boiler_test_wizard.acknowledge.phase_option":"{phase}. fase","boiler_test_wizard.acknowledge.phase_select":"Selecteer de fasen die moeten worden getest. Niet geselecteerde fasen worden overgeslagen.","boiler_test_wizard.acknowledge.phase_select_empty":"Selecteer ten minste \xe9\xe9n fase.","boiler_test_wizard.acknowledge.start":"Boiler testen","boiler_test_wizard.acknowledge.title":"Informatie voor de test","boiler_test_wizard.result.after":"Verbruik van het object na activatie","boiler_test_wizard.result.before":"Verbruik van het object voor activatie","boiler_test_wizard.result.close":"Sluiten","boiler_test_wizard.result.correct":"Verbruik van de boiler correct","boiler_test_wizard.result.detail_toggle":"Detail test","boiler_test_wizard.result.header":"Testresultaat:","boiler_test_wizard.result.phase_header":"{phase}. fase","boiler_test_wizard.result.real_power":"Geschatte kracht van de boiler","boiler_test_wizard.result.rerun":"Test opnieuw starten","boiler_test_wizard.result.set_power":"Ingestelde kracht","boiler_test_wizard.result.stable":"Meting was stabiel","boiler_test_wizard.result.title":"Testresultaat","boiler_test_wizard.running.activate":"Activatie van de boilerfase","boiler_test_wizard.running.after":"Verbruik van het object is {power}","boiler_test_wizard.running.before":"Verbruik van het object voor de test is {power}","boiler_test_wizard.running.measuring":"Meting wordt uitgevoerd\u2026","boiler_test_wizard.running.phase":"Test de fase {phase}","boiler_test_wizard.running.real_power":"Geschatte kracht van de boiler is {power}","boiler_test_wizard.running.remaining":"Er blijft ongeveer {seconds} seconden over","boiler_test_wizard.running.reset":"Verbruik resetten","boiler_test_wizard.running.result_fail":"Testfase is niet correct","boiler_test_wizard.running.result_ok":"Testfase is correct","boiler_test_wizard.running.stable":"Verbruik was stabiel","boiler_test_wizard.running.title":"Test wordt uitgevoerd","boiler_test_wizard.running.unstable":"Meting was niet stabiel","boiler_test_wizard.title":"Boiler testen","cancel":"Annuleren","chart.range.this_week":"Afgelopen week","chart.range.today":"Laatste 24{nbsp}uur","chart.tooltip.active_condition.title":"Huidige modus","chart.tooltip.active_condition.value.battery":"Batterij","chart.tooltip.active_condition.value.compressor-blocked":"Compressor geblokkeerd, laag batterijniveau","chart.tooltip.active_condition.value.cooling":"Koeling","chart.tooltip.active_condition.value.error":"Fout","chart.tooltip.active_condition.value.heating":"Verwarming","chart.tooltip.active_condition.value.hot-water":"Warmwaterverwarming","chart.tooltip.active_condition.value.inactive":"Inactief","chart.tooltip.active_condition.value.manual":"Handmatig","chart.tooltip.active_condition.value.not-connected":"Kan geen verbinding maken","chart.tooltip.active_condition.value.not-licensed":"Geen licentie","chart.tooltip.active_condition.value.off":"Uit","chart.tooltip.active_condition.value.overflow":"Overloop","chart.tooltip.active_condition.value.pool":"Zwembadverwarming","chart.tooltip.active_condition.value.spot":"Spot","chart.tooltip.active_condition.value.time":"Tijd","chart.tooltip.control_mode.title":"Gecontroleerd door","chart.tooltip.control_mode.value":"{mode, select, photovoltaic {Photovoltaics} net {Grid} spot {Spot} flexibiliteit {Flexibility} fout {Error} other {{mode}} }","chart.tooltip.wallbox_authorization_card_id.title":"RFID-kaart:","charts.error.dialog.title":"Er is een fout opgetreden tijdens het laden van de statistieken","charts.mode.day":"Dag","charts.mode.week":"Week","charts.mode.year":"Jaar","charts.summary.value":"Totaal {value}","close":"Sluiten","cloud_plugs.bat":"Bediening via batterij","cloud_plugs.battery.battery_start":"Inschakelen tijdens het opladen","cloud_plugs.battery.battery_start.subtitle":"Batterij opladen waardoor het stopcontact wordt geactiveerd","cloud_plugs.battery.battery_stop":"Uitschakelen tijdens het opladen","cloud_plugs.battery.battery_stop.subtitle":"Batterij opladen, waardoor het stopcontact wordt uitgeschakeld","cloud_plugs.battery.on":"Actief","cloud_plugs.battery_charged":"Batterij opgeladen","cloud_plugs.condition":"Conditie","cloud_plugs.condition.and":"En","cloud_plugs.condition.or":"Of","cloud_plugs.led_mode.battery.subtitle":"LED actief als de batterij ten minste 95% is opgeladen","cloud_plugs.led_mode.battery.switch.title":"LED wanneer het stopcontact is ingeschakeld","cloud_plugs.led_mode.battery.title":"LED wanneer de batterij is opgeladen","cloud_plugs.led_mode.mode":"{mode, select, unknown {---} off {Uit} switch {Schakelaar} current {Door stroom} other {Onbekend}}","cloud_plugs.led_mode.overflow.subtitle":"LED actief bij stabiele overloop","cloud_plugs.led_mode.overflow.title":"LED wanneer overloop optreedt","cloud_plugs.led_mode.switch.subtitle":"LED actief als de aansluiting is ingeschakeld","cloud_plugs.led_mode.title":"LED-signalering","cloud_plugs.list.id":"ID","cloud_plugs.list.led_mode":"LED-signalering","cloud_plugs.list.online":"Online","cloud_plugs.list.relay":"Relais","cloud_plugs.list.title":"Status","cloud_plugs.overflow":"Bediening via overloop","cloud_plugs.overflow.help":"Het stopcontact inschakelen bij een gedefinieerde overloop naar het net.","cloud_plugs.overflow.on":"Actief","cloud_plugs.overflow.startPower":"Aanzetten bij verbruik uit het net","cloud_plugs.overflow.startPower.help":"Het stopcontact gaat aan als de overloop na een gedefinieerde vertraging op het ingestelde niveau is. Als de waarde op -1500W staat en de aanzetvertraging 5 minuten is, gaat het stopcontact aan wanneer de overloop naar het net minimaal 1500W is gedurende 5 minuten.","cloud_plugs.overflow.startPower.subtitle":"Negatieve waarde is overloop, positieve waarde is verbruik","cloud_plugs.overflow.stopPower":"Uitzetten bij verbruik uit het net","cloud_plugs.overflow.stopPower.help":"Het stopcontact gaat uit als het verbruik na een gedefinieerde vertraging hoger is dan het ingestelde niveau. Als de waarde op 100W staat en de uitzetvertraging 5 minuten is, gaat het stopcontact uit wanneer het verbruik uit het net minimaal 100W is gedurende 5 minuten.","cloud_plugs.overflow.stopPower.subtitle":"Negatieve waarde is overloop, positieve waarde is verbruik","cloud_plugs.pv_power":"Besturing op PV-vermogen","cloud_plugs.pv_power.help":"Het stopcontact inschakelen bij een gedefinieerd PV-vermogen.","cloud_plugs.pv_power.on":"Actief","cloud_plugs.pv_power.startPower":"Aanzetten bij PV-productie","cloud_plugs.pv_power.startPower.help":"Het stopcontact gaat aan als het PV-vermogen groter is dan het ingestelde niveau. Als de waarde op 1000W staat, gaat het stopcontact aan wanneer het PV-vermogen minimaal 1000W is.","cloud_plugs.pv_power.stopPower":"Uitzetten bij PV-productie","cloud_plugs.pv_power.stopPower.help":"Het stopcontact gaat uit als het PV-vermogen lager is dan het ingestelde niveau. Als de waarde op 500W staat, gaat het stopcontact uit wanneer het PV-vermogen minder dan 500W is.","cloud_plugs.time":"Tijdgestuurde bediening","cloud_plugs.time.on":"Actief","cloud_plugs.title":"Aansluitingen","cloud_plugs.turn_off":"Uitschakelen","cloud_plugs.turn_on":"Inschakelen","dark_mode.dark":"Donker","dark_mode.light":"Licht","dark_mode.system":"Systeem","delta_green.battery_max_power_in":"Maximaal batterijvermogen IN (W)","delta_green.battery_max_power_out":"Maximaal batterijvermogen OUT (W)","delta_green.business_flexibility.title":"Zakelijke flexibiliteit","delta_green.connected":"Status","delta_green.enabled":"Integratie ingeschakeld","delta_green.last_messages":"Laatste berichten","delta_green.last_messages.date":"Tijd","delta_green.last_messages.payload":"Bericht","delta_green.last_messages.topic":"Onderwerp","delta_green.pv_orientation":"Fotovolta\xefsche ori\xebntatie","delta_green.title":"Delta Green","des_battery_container.status.error":"Fout","des_battery_container.status.none":"Onbekende status","des_battery_container.status.off":"Uit","des_battery_container.status.run":"Normale modus","des_battery_container.status.sleep":"Slaapmodus","dev.cloud_plugs.mqtt_cloud.connected":"MQTT Cloud-verbindingsstatus","dev.cloud_plugs.title":"Cloud-sockets","dev.inverter_config.connection.lan":"LAN","dev.inverter_config.connection.rs485":"RS485","dev.inverter_config.connection.rs485_hint":"Adres en poort worden van het bord overgenomen ({host}:{port}).","dev.inverter_config.rename_warning":"Als u de sleutel van \\"{from}\\" naar \\"{to}\\" hernoemt, raken historische gegevens losgekoppeld \u2014 statistieken en opgewekte energie die onder de oorspronkelijke sleutel zijn opgeslagen.","dev.inverter_config.search.open":"Omvormer zoeken","dev.inverter_config.search.title":"Omvormer zoeken","dev.inverter_config.stats.all":"Alles","dev.inverter_config.status.counts":"OK {ok} / Fouten {err}","dev.inverter_config.status.error":"Fout","dev.inverter_config.status.ok":"OK","dev.inverter_config.status.starting":"Starten","dev.inverter_config.title":"Omvormerconfiguratie","dev.link":"Dev","dev_app_messages.test_send":"Testmelding","dev_app_messages.test_send.button":"Verzenden","dev_homepage.app_messages.title":"Meldingen","dev_homepage.title":"Ontwikkelingsmenu","dev_spot.summary.title":"Overzicht modi","dev_spot.title":"Spot (ontwikkeling)","dev_status_log.empty":"Er zijn nog geen gegevens","dev_status_log.error":"Fout bij laden","dev_status_log.title":"Status logboek","dev_status_log.today":"Vandaag","dhcp_host.address":"IP-adres","dhcp_host.create.title":"Nieuwe DHCP-host","dhcp_host.edit.title":"DHCP-host bewerken","dhcp_host.mac":"MAC-adres","dhcp_host.name":"Naam","dhcp_hosts.remove.cancel":"Annuleren","dhcp_hosts.remove.confirm":"Verwijderen","dhcp_hosts.remove.confirm.title":"Wilt u het DHCP-hostadres echt ongedaan maken?","dhcp_leases.ip":"IP-adres","dhcp_leases.mac":"MAC-adres","dhcp_leases.make_static.cancel":"Annuleren","dhcp_leases.make_static.confirm":"Toevoegen","dhcp_leases.make_static.confirm.title":"Wilt u het DHCP-hostadres echt vastleggen?","dhcp_leases.name":"Naam","dhcp_leases.next_renewal":"Volgende verlenging","dhcp_leases.title":"DHCP-leases","ean":"EAN","electree.business_flexibility.title":"Zakelijke flexibiliteit","electree.connected":"Status","electree.enabled":"Integratie ingeschakeld","electree.last_messages":"Laatste berichten","electree.last_messages.date":"Tijd","electree.last_messages.payload":"Bericht","electree.last_messages.topic":"Topic","electree.title":"Electree","electrical_grid.common":"Algemene informatie","electrical_grid.common.overflow":"Totale stroom naar het net","electrical_grid.common.overflow_today":"Overloop naar het net vandaag","electrical_grid.common.overflow_year":"Jaarlijkse overloop naar het net","electrical_grid.common.power":"Totaal verbruik uit het net","electrical_grid.common.power.phase_1":"Fase 1","electrical_grid.common.power.phase_2":"Fase 2","electrical_grid.common.power.phase_3":"Fase 3","electrical_grid.common.power_today":"Huidig verbruik uit het elektriciteitsnet","electrical_grid.common.power_year":"Jaarlijks verbruik van het elektriciteitsnet","electrical_grid.common.total_consumption":"Totaal verbruik van het elektriciteitsnet","electrical_grid.statistics":"Aankoopstatistieken","electrical_grid.statistics_overflow":"Overloopstatistieken","electrical_grid.status":"Status van het elektriciteitsnet","ems.activePower":"Actief vermogen","ems.apparentPower":"Schijnbaar vermogen","ems.details":"Omvormerparameters","ems.inverter":"Omvormer","ems.inverter.mode.backup":"Backup","ems.inverter.mode.feedIn":"Feed-in","ems.inverter.mode.manual":"Manual","ems.inverter.mode.peakShaving":"Peak Shaving","ems.inverter.mode.selfUse":"Self use","ems.inverter.name":"Naam van de inverter","ems.inverter.name.aelio":"X3-AELIO","ems.inverter.name.notConnected":"Niet verbonden","ems.inverter.name.trene100k":"X3-TRENE-100K","ems.inverter.name.trene100ki":"X3-TRENE-100KI","ems.inverter.name.trene125k":"X3-TRENE-125K","ems.inverter.name.unknown":"Onbekend model","ems.mode":"EMS modus","ems.power.index":"Kracht string {index}","ems.power.total":"Totale kracht","ems.powerFactor":"Vermogenfactor","ems.reactivePower":"Reactief vermogen","emsPro.inverter.name.aelio":"X3-AELIO","emsPro.inverter.name.notConnected":"Niet verbonden","emsPro.inverter.name.trene1":"X3-TRENE-1","emsPro.inverter.name.trene100k":"X3-TRENE-100K","emsPro.inverter.name.trene125k":"X3-TRENE-125K","emsPro.inverter.name.x3forth":"X3-FORTH","emsPro.inverter.name.x3forthplus":"X3-FORTH+","emsPro.inverter.name.x3grand":"X3-GRAND","emsPro.inverter.name.x3mgag2":"X3-MGA G2","emsPro.inverter.name.x3prog2":"X3-PRO G2","emsService.basicSettings":"Basisinstellingen","emsService.direction.disabled":"Uitgeschakeld","emsService.direction.read":"Lezen","emsService.direction.write":"Schrijven","emsService.distributionMetrics":"Distributie-opdrachten","emsService.distributionMetrics.diMapping":"Ingangsindeling","emsService.distributionMetrics.enabled":"Lezen van distributie-opdrachten inschakelen","emsService.distributionMetrics.source":"Bron van distributie-opdrachten","emsService.distributionMetrics.source.digitalInputs":"Digitale ingangen","emsService.distributionMetrics.source.plc":"Externe PLC","emsService.enabled":"PLC ingeschakeld","emsService.energyMeters":"Energiemeters","emsService.energyMeters.add":"Nieuwe energiemeter toevoegen","emsService.energyMeters.addButton":"Toevoegen","emsService.energyMeters.azRouter":"AZ router","emsService.energyMeters.azRouter.empty":"Geen AZ routers geconfigureerd","emsService.energyMeters.empty":"Geen energiemeters geconfigureerd","emsService.energyMeters.newMeter":"Naam","emsService.energyMeters.plcMetric":"PLC Metriek","emsService.energyMeters.plcMetric.grid":"Grid","emsService.energyMeters.plcMetric.kgj":"KGJ","emsService.energyMeters.plcMetric.pv":"PV","emsService.energyMeters.shellyId":"Shelly ID","emsService.energyMeters.source":"Bron","emsService.energyMeters.source.azRouter":"AZ router","emsService.energyMeters.source.plc":"PLC","emsService.energyMeters.source.shelly":"Shelly","emsService.gridMetrics":"Netwerkmetrieken","emsService.gridMetrics.enabled":"Grid-metrieken lezen ingeschakeld","emsService.ipAddress":"IP-adres","emsService.kgjMetrics":"KGJ-metrieken","emsService.kgjMetrics.enabled":"KGJ-metrieken lezen ingeschakeld","emsService.metricsDirection":"Richting","emsService.metricsEnabled":"Ingeschakeld","emsService.mqttBroker":"MQTT Broker (Shellies)","emsService.mqttBrokerEnabled":"MQTT Broker ingeschakeld","emsService.mqttBrokerStatus":"MQTT Broker Status","emsService.notAvailable":"EMS-functie is niet beschikbaar","emsService.password":"Wachtwoord","emsService.plcStatus":"PLC-communicatiestatus","emsService.pollInterval":"Interval polling (ms)","emsService.pvMetrics":"PV metriky","emsService.pvMetrics.enabled":"PV-metrieken lezen ingeschakeld","emsService.pvMetrics.meterId":"Energiemeter","emsService.pvMetrics.meterSource":"Gegevensbron","emsService.pvMetrics.meterSource.meter":"Energiemeter","emsService.pvMetrics.meterSource.plc":"PLC","emsService.shelliesList":"Verbonden Shelly apparaten","emsService.username":"Gebruikersnaam","ems_service.link":"EMS-service","ems_service.title":"EMS-service","enerco.ean":"EAN","enerco.enabled":"Integratie ingeschakeld","enerco.prediction.disabled":"Integratie is uitgeschakeld.","enerco.prediction.title":"Voorspelling","enerco.title":"Enerco","energomachine.business_flexibility.title":"Zakelijke flexibiliteit","energomachine.connected":"Status","energomachine.enabled":"Integratie ingeschakeld","energomachine.last_messages":"Laatste berichten","energomachine.last_messages.date":"Tijd","energomachine.last_messages.payload":"Bericht","energomachine.last_messages.topic":"Topic","energomachine.title":"Energomachine","energyMeters.actualPower":"Huidige vermogen","energyMeters.general":"Algemene informatie","energyMeters.meter":"Energiemeter","energyMeters.notConfigured":"Energiemeters zijn niet geconfigureerd. Ga naar het servismenu voor configuratie.","energyMeters.phase1":"Fase 1:","energyMeters.phase2":"Fase 2:","energyMeters.phase3":"Fase 3:","energyMeters.statistics":"Statistieken","energyMeters.todayEnergy":"Huidige verbruik:","energyMeters.totalEnergy":"Totaal verbruik","energyMeters.yearEnergy":"Jaarlijks verbruik:","error":"Fout bij het laden van het rapport.","expertService.HP":"Warmtepomp","expertService.HP.CntComErr":"Foutmeldingsteller","expertService.HP.CntComOk":"Teller voor geldige berichten","expertService.HP.IpAdr":"IP-adres warmtepomp","expertService.HP.maxTempHW":"Maximale temperatuur van warm water voor de warmtepomp","expertService.HP.maxTempHW.subtitle":"Som van flexibele + ingestelde temperatuur","expertService.HW":"Warm water","expertService.HW.HwBatteryPriority":"Batterijladingspercentage waarbij de boiler altijd voorrang heeft","expertService.HW.HwErrEnabled":"Beschikbaarheid van de boiler evalueren","expertService.HW.HwResetErrorTime":"Vertraging voor het resetten van de thermostaatfout","expertService.HW.HwResetErrorTime.subtitle":"Tijd in minuten waarna de thermostaatfout wordt gereset en de verwarming weer start","expertService.HW.LegionellaLastTime":"Laatste keer dat de legionellatemperatuur werd bereikt","expertService.HW.TempId":"ID temperatuursensor","expertService.HW.control":"Type boilerregeling","expertService.HW.control.onoff":"Aan/uit","expertService.HW.control.proportional":"Proportioneel","expertService.HW.hysterezis":"Hysterese warm water","expertService.HW.hysterezis.subtitle":"Hysterese is alleen voor reguliere verwarming","expertService.HW.maxPower":"Maximaal vermogen van de boiler in procenten","expertService.HW.maxPower.subtitle":"Deze instelling is alleen voor proportionele regeling van de boiler en beperkt het maximale vermogen van de brander in procenten.","expertService.HW.offset":"Faseverschuiving [W]","expertService.HW.offset.disabled-overflow":"Verschuiving voor het regelen van de ketel met uitgeschakelde overloop op de fase [W]","expertService.HW.offset.disabled-overflow.subtitle":"Een hoger getal zorgt ervoor dat de ketel meer energie uit het net kan halen wanneer de overloop is","expertService.HW.offset.enabled-overflow":"Verschuiving voor het regelen van de ketel met ingeschakelde overloop op de fase [W]","expertService.HW.offset.enabled-overflow.subtitle":"Hoe hoger het getal, hoe meer energie de ketel uit het net kan halen.","expertService.HW.offset.ongrid":"Offset voor het regelen van de ketel met netstroom [W]","expertService.HW.offset.ongrid.subtitle":"Hoe hoger het getal, hoe meer energie de ketel uit het net kan halen.","expertService.PV":"Fotovolta\xefsche","expertService.PV.BatteryPowerPercent":"Laadvermogen van de batterij in procenten","expertService.PV.CntComErr":"Foutmeldingsteller","expertService.PV.CntComOk":"Teller voor geldige meldingen","expertService.PV.ControlMeteringMode":"Regelmethode voor overschot","expertService.PV.ControlMeteringMode.perPhase":"Per fase","expertService.PV.ControlMeteringMode.subtitle":"Regeling per fase berekent het overschot voor de aansturing van apparaten per fase. Gesommeerde regeling werkt met de som van alle fasen.","expertService.PV.ControlMeteringMode.sum":"Gesommeerd","expertService.PV.ExternalPv":"Externe PV aangesloten via SOLAX Meter 2","expertService.PV.ExternalPvSofar":"Externe PV aangesloten via SOFAR Meter 2","expertService.PV.IpAdr":"IP-adres van de omvormer","expertService.PV.MeteringMode":"Meetmethode van het net","expertService.PV.MeteringMode.perPhase":"Per fase","expertService.PV.MeteringMode.subtitle":"Meting per fase telt afname en teruglevering per fase apart. Gesommeerde meting werkt met het saldo van alle fasen.","expertService.PV.MeteringMode.sum":"Gesommeerd","expertService.PV.PowerControlType":"Type vermogenregeling van de net-omvormer","expertService.PV.PowerControlType.fixed":"Vast","expertService.PV.PowerControlType.proportional":"Proportioneel","expertService.PV.StringNumber":"Aantal strings van de omvormer","expertService.PV.StringNumber.subtitle":"Aantal strings van de omvormer weergegeven in de applicatie op het tabblad PV","expertService.PV.Versions":"Versie","expertService.SP":"Spot","expertService.SP.HwCoefficient":"Schattingsco\xebffici\xebnt voor boilerenergie","expertService.SP.HwCoefficient.subtitle":"Co\xebffici\xebnt van de geschatte energie voor het opladen van de boiler.","expertService.SP.MinDifferencePriceChargeFromGrid":"Minimale spotprijsverschil voor het opladen van netbatterijen","expertService.SP.batteryCoefficient":"Schattingsco\xebffici\xebnt voor de oplaadtijd van de batterij","expertService.SP.batteryCoefficient.subtitle":"Co\xebffici\xebnt van geschatte tijd voor het opladen van de batterij","expertService.SP.minDifferenceBatterychargeFromGrid":"Minimale geschatte SOC-toename voor het wachten op PV","expertService.SP.minDifferenceBatterychargeFromGrid.subtitle":"Als de geschatte batterijlading onder deze waarde ligt, kan de batterij worden opgeladen via het elektriciteitsnet.","expertService.WB":"Wallbox","expertService.WB.CntComErr":"Foutmeldingsteller","expertService.WB.CntComOk":"Teller voor geldige berichten","expertService.WB.IpAdr":"IP-adres van de wallbox","expertService.general":"Algemene instellingen","expertService.general.largeInstallation":"Grote installatie","expertService.general.largeInstallation.subtitle":"Breidt het bereik van waarden uit voor grote installaties","expertService.password":"Toegang tot service","expertService.password.label":"Wachtwoord","expert_service.app_messages":"Berichten","expert_service.audit_log":"Auditlogboek","expert_service.error_list":"Foutenlijst","expert_service.link":"Expertdienst","expert_service.network":"Netwerk","expert_service.network.button":"Ga naar netwerkinstellingen","expert_service.network.link":"Netwerk","expert_service.reports":"Rapporten","expert_service.stats":"Statistieken","expert_service.title":"Service","expert_service.xyz":"Service","header.title":"Startpagina","header.title.app_messages":"Berichten","header.title.audit_log":"Auditlogboek","header.title.boiler":"Ketel","header.title.cloud_plugs":"Cloud-aansluitingen","header.title.dev":"Netwerkinstellingen","header.title.dev.app_messages":"Meldingen","header.title.dev.az_routers":"AZ routers","header.title.dev.bez_dodavatele":"bezDodavatele","header.title.dev.cloud_plugs":"Cloud-aansluitingen","header.title.dev.delta_green":"Delta Green","header.title.dev.electree":"Electree","header.title.dev.enerco":"Enerco","header.title.dev.energomachine":"Energomachine","header.title.dev.inverter_config":"Omvormerconfiguratie","header.title.dev.mqtt_broker":"MQTT-broker","header.title.dev.mqtt_cloud":"MQTT Cloud","header.title.dev.pre_flexibility":"PRE Flexibiliteit","header.title.dev.scripts":"Scripten","header.title.dev.shellies":"Shellies","header.title.dev.spot":"Spot","header.title.dev.status_log":"Status logboek","header.title.dev.subscriptions":"Abonnementen","header.title.dev_homepage":"Ontwikkelingsmenu","header.title.ems":"EMS","header.title.ems_service":"EMS Service","header.title.energyMeters":"Energiemeters","header.title.expert_service":"Expertservice","header.title.expert_service.network":"Netwerkinstellingen","header.title.grid":"Raster","header.title.heat_pump":"Warmtepomp","header.title.photovoltaics":"Fotovolta\xefsche","header.title.plug":"Stopcontact","header.title.relay":"Relais","header.title.reports":"Rapporten","header.title.rfid_cards":"RFID-kaarten","header.title.settings":"Instellingen","header.title.spot":"Spot","header.title.statistics":"Statistieken","header.title.thermostat":"Thermostaat","header.title.wallbox":"Wallbox","header.title.wallbox_list":"Wallboxen","header.title.wind":"Windturbine","heat_pump.HW":"Warmwaterverwarming","heat_pump.HW.actual_temp":"Huidige tanktemperatuur","heat_pump.HW.flexitemp":"Flexibele temperatuur","heat_pump.HW.flexitemp.subtitle":"Temperatuur waarmee het warm water kan worden voorverwarmd","heat_pump.HW.hysteresis":"Hysterese van warmwaterverwarming","heat_pump.HW.on":"Warmwaterverwarming","heat_pump.HW.temp":"Gewenste keteltemperatuur","heat_pump.acond":"Acond","heat_pump.blocked":"Compressorblokkering","heat_pump.blocked.min_soc":"Compressorblokkering","heat_pump.blocked.min_soc_utility":"Compressorblokkering wanneer het elektriciteitsnet beschikbaar is","heat_pump.blocked.subtitle":"Batterijladingsniveau waarbij de compressor wordt geblokkeerd tijdens een stroomstoring","heat_pump.common":"Algemene informatie","heat_pump.common.power":"Totaal verbruik","heat_pump.common.power_today":"Verbruik vandaag","heat_pump.common.power_year":"Jaarlijks verbruik","heat_pump.common.temp":"Huidige temperatuur op de warmtewisselaar","heat_pump.common.total":"Totaal verbruik","heat_pump.ecoone":"Ecoone","heat_pump.flexi":"Energetische flexibiliteit","heat_pump.flexi.flexi_on":"Flexibiliteit modus","heat_pump.flexi.flexi_on.subtitle":"Modus activeert voorverwarming op basis van overtollige energie","heat_pump.flexi.pvstability":"Compressoractiveringspotentieel","heat_pump.flexi_sp":"Spotflexibiliteit","heat_pump.flexi_sp.flexi_increase_on":"Verhoog verbruik","heat_pump.flexi_sp.flexi_increase_on.subtitle":"Modus maakt het mogelijk het verbruik te verhogen bij lage energieprijzen","heat_pump.flexi_sp.flexi_reduce_on":"Uitstel van verbruik","heat_pump.flexi_sp.flexi_reduce_on.subtitle":"Modus maakt het mogelijk om het verbruik uit te stellen bij hoge energieprijzen","heat_pump.nibe":"Nibe","heat_pump.room":"Verwarming","heat_pump.room.equithermalCorrection":"Aanpassing van de verwarmingscurve","heat_pump.room.flexitemp":"Flexibele temperatuur","heat_pump.room.flexitemp.subtitle":"Temperatuur waarmee het huis kan worden voorverwarmd of voorgekoeld","heat_pump.room.on":"Verwarming","heat_pump.room.tem":"Gewenste temperatuur","heat_pump.room.temp":"Huidige kamertemperatuur","heat_pump.room.tempmax":"Gewenste comforttemperatuur","heat_pump.room.tempmin":"Gewenste dempingstemperatuur","heat_pump.room_cool.on":"Koeling","heat_pump.status":"Verwarmingsmodus","heat_pump_wizard.cancel":"Annuleren","heat_pump_wizard.ip_address.alert":"Zorg ervoor dat het IP-adres van de warmtepomp niet verandert (bijvoorbeeld wanneer de warmtepomp een DHCP-adres gebruikt).","heat_pump_wizard.ip_address.input":"IP-adres warmtepomp","heat_pump_wizard.open":"Type warmtepomp instellen","heat_pump_wizard.save":"Opslaan","heat_pump_wizard.title":"Warmtepomp-instellingen","heatpump.statistics":"Statistieken","heatpump.status":"Warmtepompmodus","home.premium.banner.inactive.subtitle":"Infigy Plus biedt meer gedetailleerde grafieken, maandelijkse rapporten, meldingen en nog veel meer.","home.premium.banner.inactive.title":"Wilt u een beter overzicht?","homepage.actual.battery":"Batterijstatus","homepage.actual.boiler":"Boiler","homepage.actual.outdoor_temperature":"Buitentemperatuur","homepage.actual.thermostat":"Thermostaat","homepage.actual.title":"","homepage.animation":"Momenteel","homepage.statuses.title":"Actieve componentmodi","homepage.statuses.tooltip":"Actieve componentmodi","homepage.today.consumed":"Huisverbruik","homepage.today.consumed_WB":"Wallbox","homepage.today.consumed_from_grid":"Verbruik uit het elektriciteitsnet","homepage.today.consumed_hp":"Warmtepomp","homepage.today.consumed_hw":"Warm water","homepage.today.overflow":"Overstroom naar het net","homepage.today.photovoltaics":"Productie van fotovolta\xefsche energie","homepage.today.title":"Dagelijkse statistieken","homepage.today.wind":"Windenergieproductie","hp.status.compressor_blocked":"Compressorblokkering, laag batterijniveau","hp.status.cooling":"Koeling","hp.status.heating":"Verwarming","hp.status.hot_water":"Warmwaterverwarming","hp.status.inactive":"Inactief","hp.status.not_connected":"Kan geen verbinding maken","hp.status.not_licensed":"Warmtepomp heeft geen vergunning","hp.status.pool":"Zwembadverwarming","hp.sub_status.consumption_postpone":"wanneer het verbruik wordt verminderd","hp.sub_status.consumption_rise":"wanneer het verbruik wordt verhoogd","hp.sub_status.consumption_with_flexibility":"met flexibiliteit","hp.sub_status.nibe_not_writable":"- kan niet naar NIBE schrijven","hp.sub_status.none":"","initial_wizard.banner.button":"Wizard starten","initial_wizard.banner.hide.confirm":"Wilt u de wizard echt verbergen?","initial_wizard.banner.hide.confirm.description":"U kunt de wizard altijd opnieuw starten in de applicatie-instellingen.","initial_wizard.banner.hide.show_more":"Wizard starten","initial_wizard.banner.hide.yes":"Verbergen","initial_wizard.banner.subtitle":"De wizard helpt u bij het instellen van de basisparameters van uw systeem.","initial_wizard.banner.title":"Voltooi de eerste instellingen","initial_wizard.banner.title.completed":"Eerste instellingen doorlopen","initial_wizard.dialog.finish":"Voltooien","initial_wizard.dialog.next":"Volgende","initial_wizard.dialog.prev":"Terug","initial_wizard.dialog.step":"Stap {current} van {total}","initial_wizard.dialog.title":"Wizard eerste instellingen","initial_wizard.step1.description.active":"Uw toegang tot de service is al actief. U kunt doorgaan naar de volgende stap.","initial_wizard.step1.password_info":"Elk bedrijf heeft een eigen wachtwoord voor het servicemenu. U heeft het wachtwoord ontvangen per e-mail. U kunt het ook altijd bekijken op app.infigy.cz in het partnersgedeelte.","initial_wizard.step1.title":"Toegang tot de service","initial_wizard.step1.welcome":"Welkom bij de eerste instellingen van Infigy. We begeleiden u door de basisconfiguratie van uw systeem. Meer gedetailleerde instellingen vindt u daarna in het servicemenu.","initial_wizard.step10.title":"Wallbox-instellingen","initial_wizard.step11.description":"U heeft de basisinstellingen van Infigy doorlopen. Alle parameters kunnen worden aangepast in het servicemenu.","initial_wizard.step11.service_menu.subtitle":"Instellingen -> helemaal naar beneden -> Toegang tot de service","initial_wizard.step11.service_menu.title":"Servicemenu","initial_wizard.step11.title":"Klaar","initial_wizard.step2.title":"Applicatie-update","initial_wizard.step3.title":"Installatie","initial_wizard.step4.title":"Instelling hoofdschakelaar","initial_wizard.step5.title":"Omvormer aansluiten","initial_wizard.step6.title":"Omvormerparameters","initial_wizard.step7.description":"Als de overloop naar het net wordt beperkt, worden de instellingen naar de omvormer overgebracht. De omvormer zorgt voor de beperking van de overloop. Infigy regelt echter het schrijven en wijzigen van de waarde op basis van de ingevoerde waarde in dit veld. Wijzig daarom niet de overloopbeperking in de omvormer. Controleer bij de eerste installatie de geschreven waarde in de omvormer of deze correct van Infigy naar de omvormer is doorgevoerd.","initial_wizard.step7.title":"Overloopbeperking","initial_wizard.step8.title":"Boilerinstellingen","initial_wizard.step9.title":"Instellingen spot-handel","initial_wizard.step_app_update.description":"Terwijl Infigy onderweg naar u was, hebben we mogelijk nieuwe versies van de applicatie uitgebracht. We raden aan om de eenheid v\xf3\xf3r de installatie bij te werken. Als er bijvoorbeeld geen internet beschikbaar is, kunt u de update overslaan en later uitvoeren in het servicemenu of in de portal.","inverter.3mar_plc":"3Mar PLC","inverter.az_router":"AzRouter energiemeter","inverter.control.mode":"Omvormer besturing","inverter.control.mode.chargingFromGrid":"Batterij opladen vanuit net","inverter.control.mode.dischargingToGrid":"Batterij ontladen naar net","inverter.control.mode.noneControl":"Geen besturing","inverter.control.mode.stopCharging":"Stop met opladen","inverter.control.mode.stopDischarging":"Stop met ontladen","inverter.control.mode.stopOverflow":"Stop overstroom","inverter.des_battery_container":"DES - containeropslag","inverter.deye":"Deye LV","inverter.deye_hv":"Deye HV","inverter.fronius":"Fronius SYMO GEN24","inverter.fronius_grid":"Fronius SYMO net","inverter.fronius_verto":"Fronius Verto","inverter.good_we":"GoodWe","inverter.good_we_grid_next":"GoodWe net","inverter.good_we_next":"GoodWe","inverter.goodwe-Grid":"Goodwe-netkoppeling","inverter.goodwe_grid":"Goodwe net","inverter.hes":"HES - batterijopslag","inverter.next":"Meer omvormers","inverter.none":"Geen","inverter.sermatec":"Sermatec","inverter.shellies":"Shellies","inverter.shellies_external":"Shellies extern","inverter.sma_grid":"SMA net","inverter.sofar_solar":"Sofarsolar","inverter.sofar_solar_rs485":"SofarSolar RS485","inverter.solar_edge_grid":"SolarEdge netgekoppeld","inverter.solax":"Solax","inverter.solax-Grid":"Solax-netkoppeling","inverter.solax_ems1000":"Solax EMS1000","inverter.solax_ems1000pro":"Solax EMS1000PRO","inverter.solax_grid":"Solax netgekoppeld","inverter.solax_mega_grid":"Solax MEGA/FORTH netgekoppeld","inverter.solax_mic_grid":"Solax MIC op het net","inverter.solax_next":"SolaxNext","inverter.solinteg":"Solinteg","inverter.victron":"Victron","inverter.wattsonic":"Wattsonic","inverter_wizard.cancel":"Annuleren","inverter_wizard.custom_device_ip_address.alert":"Zorg ervoor dat het IP-adres van de omvormer niet verandert (bijvoorbeeld wanneer de omvormer een DHCP)","inverter_wizard.custom_device_ip_address.input":"IP-adres van de omvormer","inverter_wizard.multiple_inverters.alert":"Neem contact op met de helpdesk voor het instellen van meerdere omvormers. De contactgegevens vindt u in de","inverter_wizard.multiple_inverters.label":"Meerdere omvormers","inverter_wizard.multiple_inverters_or_ems.alert":"Uw systeem bevat al instellingen voor meerdere omvormers of EMS. Deze handleiding is alleen bedoeld voor het instellen van \xe9\xe9n omvormer. Neem voor wijzigingen in de instellingen van omvormers of EMS contact op met de ondersteuning.","inverter_wizard.nominal_power":"Nominale vermogen van de omvormer","inverter_wizard.nominal_power.helper":"Bereik: 1 tot 100 kW","inverter_wizard.nominal_power.validation":"Voer het nominale vermogen van de omvormer in kW in.","inverter_wizard.open":"Omvormer vinden","inverter_wizard.save":"Opslaan","inverter_wizard.scan":"Omvormer zoeken op het netwerk","inverter_wizard.scanning":"Zoeken naar omvormer op het netwerk","inverter_wizard.submit_error":"Er is een fout opgetreden tijdens het opslaan van de omvormerinstellingen. Probeer het opnieuw.","inverter_wizard.title":"Handleiding voor het aansluiten van de omvormer","layout.disconnected":"Verbinding verbroken","layout.pigpio_init_error_dialog.description":"De Infigy-applicatie is niet correct gestart. Start het apparaat opnieuw op en als het probleem zich blijft voordoen,","layout.pigpio_init_error_dialog.title":"Fout bij het starten van de applicatie","level.thermostat.cooling":"Koeling","level.thermostat.deactivated":"Gedeactiveerd","level.thermostat.heating":"Verwarming","level.thermostat.standby":"Stand-by","level.thermostat.tempErr":"Temperatuurfout","level.thermostatFlexibility.increasePv":"Flexibiliteit gebruikt om temperatuur te verhogen volgens fotovolta\xefsche energie","level.thermostatFlexibility.increaseSpot":"Flexibiliteit gebruikt om de temperatuur te verhogen volgens SPOT","level.thermostatFlexibility.normal":"Normaal","level.thermostatFlexibility.reductionSpot":"Flexibiliteit gebruikt om de temperatuur te verlagen op basis van SPOT","mqtt_broker.connected_clients.title":"Klanten","mqtt_broker.enabled":"Ingeschakeld","mqtt_broker.running":"Status","mqtt_broker.title":"MQTT-broker","mqtt_cloud.connected":"Status","mqtt_cloud.connected.offline":"Offline","mqtt_cloud.connected.online":"Online","mqtt_cloud.enabled":"Integratie ingeschakeld","mqtt_cloud.title":"MQTT Cloud","nav.app_messages":"Berichten","nav.home":"Startpagina","nav.logout":"Uitloggen","nav.reports":"Rapporten","nav.sec.boiler":"Boiler","nav.sec.cloud_plugs":"Aansluitingen","nav.sec.ems":"EMS","nav.sec.energyMeters":"Energiemeters","nav.sec.grid":"Netwerk","nav.sec.heatpump":"Warmtepomp","nav.sec.home":"Algemeen","nav.sec.photovoltaics":"Fotovolta\xefsche","nav.sec.plug":"Stopcontact","nav.sec.relay":"Relais","nav.sec.spot":"Spot","nav.sec.thermostat":"Thermostaat","nav.sec.wallbox":"Wallbox","nav.sec.wind":"Windturbine","nav.settings":"Instellingen","nav.statistics":"Statistieken","network.ethernet_ports":"Ethernetpoorten","network.ethernet_ports.name":"LAN","network.ethernet_ports.status":"Status","network.ethernet_ports.status.down":"Inactief","network.ethernet_ports.status.up":"Actief","network.scan.error":"Netwerkscan mislukt","network.summary.address":"IP-adres","network.summary.dhcp_host_exists":"Adres vastgelegd op DHCP. Klik om vastlegging ongedaan te maken.","network.summary.error":"Fout bij laden","network.summary.heat_pump":"Warmtepomp","network.summary.inverter":"Omvormer","network.summary.mac":"MAC","network.summary.name":"Naam","network.summary.no_dhcp_host":"Dynamisch adres op DHCP. Klik om te herstellen.","network.summary.not_connected":"Niet verbonden","network.title":"Algemeen","network.wan_address":"WAN-adres","network_wan_edit.dialog.address":"IP-adres","network_wan_edit.dialog.close":"Sluiten","network_wan_edit.dialog.dns":"DNS server","network_wan_edit.dialog.gateway":"Standaardgateway","network_wan_edit.dialog.netmask":"Netmasker","network_wan_edit.dialog.save":"Opslaan","network_wan_edit.dialog.title":"WAN-adres bewerken","nmap.empty":"Niets gevonden","nmap.error":"Scan is mislukt","nmap.host":"Adres","nmap.loading":"Scannen","nmap.output":"Uitvoer","nmap.port":"Poort","nmap.port.help":"Leeg = alleen zoeken naar apparaten","nmap.range.external":"external \u2014 klantnetwerk","nmap.range.internal":"internal \u2014 Infigy netwerk","nmap.result.address":"IP-adres","nmap.result.mac":"MAC-adres","nmap.result.ports":"Poorten","nmap.result.scanning":"Scannen {target}, dit kan even duren\u2026","nmap.result.target":"Gescand bereik: {target}","nmap.result.vendor":"Fabrikant","nmap.start":"Start","nmap.target":"Adres of bereik","nmap.target.help":"Naamgegeven netwerk of IP / bereik","nmap.title":"Poorten scannen","photovoltaics.battery":"Fotovolta\xefsche Accu","photovoltaics.battery.battery_charged":"Accu opladen","photovoltaics.battery.battery_manual_discharge":"Accu handmatig ontladen","photovoltaics.battery.battery_power":"Accu vermogen","photovoltaics.battery.soc_actual":"Gemeten minimale oplaadniveau","photovoltaics.batteryStatus":"BMS-status","photovoltaics.battery_stop":"Accu blokkering","photovoltaics.battery_stop.hdo":"Accu alleen ontladen bij laag tarief (HDO)","photovoltaics.battery_stop.hp":"Accu blokkeren bij warmtepomp gebruik","photovoltaics.battery_stop.hw":"Accu blokkeren bij warmtewater gebruik","photovoltaics.battery_stop.wb":"Accu blokkeren bij wallbox gebruik","photovoltaics.battery_stop.wb.lock_desc":"Wanneer de wallbox modus \u201EAccu opladen\u201C is ingeschakeld, kan deze blokkering niet worden ingeschakeld. Schakel de blokkering uit en stel een andere wallbox modus in.","photovoltaics.battery_stop.wb.lock_title":"Instelling kan niet worden gewijzigd","photovoltaics.common":"Algemene informatie","photovoltaics.common.battery_charged":"Batterij opladen","photovoltaics.common.battery_manual_charge":"Accu handmatig opladen","photovoltaics.common.battery_manual_charge_soc":"Doel-SOC voor handmatig opladen","photovoltaics.common.battery_manual_charge_subtitle":"Handmatig opladen van de batterij laadt de batterij op tot het doel-SOC, tenzij de gebruiker dit eerder uitschakelt.","photovoltaics.common.battery_manual_discharge":"De batterij handmatig ontladen","photovoltaics.common.battery_manual_discharge_subtitle":"Handmatig ontladen van de batterij ontlaadt de batterij tot het minimale SOC, tenzij de gebruiker dit eerder uitschakelt.","photovoltaics.common.battery_power":"Batterijprestaties","photovoltaics.common.power":"Huidige prestaties","photovoltaics.common.power_today":"Productie van vandaag","photovoltaics.common.power_total":"Totale productie","photovoltaics.common.power_year":"Jaarlijkse productie","photovoltaics.common.string1":"String 1","photovoltaics.common.string2":"String 2","photovoltaics.common.string3":"String 3","photovoltaics.common.string4":"String 4","photovoltaics.common.string5":"String 5","photovoltaics.common.string6":"String 6","photovoltaics.statistics":"Statistieken","photovoltaics.statistics.charge":"Batterij opladen","photovoltaics.statistics.discharge":"Batterij ontladen","photovoltaics.statisticsSoc":"Batterijniveau","photovoltaics.status":"Fotovolta\xefsche modus","ping.address":"Adres","ping.output":"Uitgang","ping.start":"Start","ping.stop":"Stop","ping.title":"Ping","plug.bat":"Bediening via batterij","plug.bat.batterySart":"Inschakelen tijdens het opladen","plug.bat.batterySart.help":"Batterijniveau waarbij het stopcontact wordt ingeschakeld. Om het stopcontact in te schakelen, moet het batterijniveau verandert van de ingestelde status naar een hogere status. Als de waarde is ingesteld op 80%, gaat het stopcontact aan wanneer de","plug.bat.batterySart.subtitle":"Batterij opladen waardoor het stopcontact wordt geactiveerd","plug.bat.batteryStop":"Uitschakelen tijdens het opladen\u201D","plug.bat.batteryStop.help":"Batterijniveau waarbij het stopcontact wordt uitgeschakeld. Om het stopcontact uit te schakelen, moet het batterijniveau veranderen van de ingestelde status naar een lagere status. Als de waarde is ingesteld op 80%, schakelt het stopcontact uit wanneer de","plug.bat.batteryStop.subtitle":"De batterij wordt opgeladen, waardoor het stopcontact wordt uitgeschakeld","plug.bat.help":"Inschakelen bij een bepaald batterijniveau. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van de voorwaarden voor inschakelen is vervuld, wordt het stopcontact ingeschakeld, en als een van de voorwaarden voor uitschakelen","plug.bat.on":"Actief","plug.main":"Algemene informatie","plug.main.consumption":"Huidig verbruik","plug.main.power":"Totaal verbruik","plug.main.power_today":"Huidig verbruik","plug.main.power_year":"Jaarlijks verbruik","plug.main.stat":"Statistieken","plug.overflow":"Controle door overloop","plug.overflow.consumption":"Instelling komt overeen met een apparaat met stroomverbruik","plug.overflow.help":"Het inschakelen van het stopcontact bij een gedefinieerde overstroming in het distributienetwerk. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van de voorwaarden voor inschakeling is voldaan, wordt het stopcontact ingeschakeld en als aan een van voorwaarden voor uitschakelen is vervuld, wordt de stopcontact uitgeschakeld.","plug.overflow.on":"Actief","plug.overflow.startPower":"Inschakelen bij netverbruik","plug.overflow.startPower.help":"Het stopcontact wordt ingeschakeld als de overloop na een gedefinieerde vertraging op het ingestelde niveau is. Als de waarde is ingesteld op -1500 W is ingesteld en de inschakelvertraging 5 minuten is, wordt de stopcontact ingeschakeld wanneer de overstroom naar hetnetwerk","plug.overflow.startPower.subtitle":"Negatieve waarde is overloop","plug.overflow.stopPower":"Uitschakelen bij netverbruik","plug.overflow.stopPower.help":"Het stopcontact schakelt uit als het verbruik na een bepaalde vertraging hoger is dan het ingestelde niveau. Als de waarde is ingesteld op 100 W en de uitschakelvertraging is 5 minuten, dan schakelt het stopcontact uit wanneer de","plug.overflow.stopPower.subtitle":"Negatieve waarde is overloop, positieve waarde is verbruik","plug.overflow.time":"In- en uitschakelvertraging","plug.overflow.time.help":"Deze parameter wordt gebruikt om de vertraging voor het in- en uitschakelen van het stopcontact bij gedefinieerde terug leveren/verbruiken. Geschikt voor het instellen van prioriteit en het elimineren van frequent schakelen van de stopcontacten.","plug.plug":"Stopcontact","plug.spot":"Regeling op basis van spotprijs","plug.spot.15m.period":"Spotprijsperiode","plug.spot.15m.period.subtitle":"15 minuten intervalen","plug.spot.help":"Inschakelen bij een bepaalde spotprijs. Kan worden gecombineerd met een tijdvoorwaarde. Als aan een van devoorwaarden voor inschakelen is vervuld, wordt de stopcontact ingeschakeld, en als aan een van de voorwaarden voor uitschakelen is","plug.spot.on":"Actief","plug.spot.period":"Spotprijsperiode","plug.spot.period.subtitle":"60 minuten intervalen","plug.spot.price.period":"Tijdsresolutie stopcontact","plug.spot.spotHi":"Activeren bij hoge prijs","plug.spot.spotHi.help":"De socket wordt ingeschakeld als de spotprijs op een hoog niveau staat (zie het tabblad Spot).","plug.spot.spotLow":"Activeren bij een lage prijs","plug.spot.spotLow.help":"De aansluiting wordt ingeschakeld als de spotprijs op een laag niveau ligt (zie het tabblad Spot).","plug.spot.spotMi":"Activeren bij gemiddelde prijs","plug.spot.spotMi.help":"De aansluiting wordt ingeschakeld als de spotprijs op een gemiddeld niveau ligt (zie het tabblad Spot).","plug.spot.spot_above_price":"Activeren bij een hogere prijs dan de ingestelde prijs","plug.spot.spot_above_price.help":"Het stopcontact wordt ingeschakeld als de spotprijs hoger is dan of gelijk is aan de ingestelde spotprijs.","plug.spot.spot_above_price.subtitle":"De aansluiting wordt ingeschakeld als de spotprijs hoger is dan of gelijk is aan de ingestelde spotprijs. Als deze lager is, wordt de","plug.spot.spot_below_price":"Activeren bij een lagere prijs dan de ingestelde prijs","plug.spot.spot_below_price.help":"De socket wordt ingeschakeld als de spotprijs lager is dan of gelijk is aan de ingestelde spotprijs.","plug.spot.spot_below_price.subtitle":"De aansluiting wordt ingeschakeld als de spotprijs lager is dan of gelijk is aan de ingestelde spotprijs. Als deze hoger is, wordt de","plug.spot.spot_neg":"Activeren bij negatieve prijs","plug.spot.spot_neg.help":"De socket wordt ingeschakeld als de spotprijs negatief is (zie het tabblad Spot).","plug.status":"Aansluitmodus","plug.summary.price":"Prijs","plug.summary.price_level":"Prijsniveau","plug.summary.price_level_15m":"Prijsniveau 15m","plug.summary.switch":"Stopcontact inschakelen","plug.summary.time":"Tijd","plug.time":"Regeling op basis van tijd","plug.time.help":"Inschakelen op een bepaald tijdstip. Kan worden gecombineerd met andere voorwaarden, afhankelijk van de batterij (moet zijn ge\xefnstalleerd), spotprijs (moet zijn toegestaan voor spot trading) en overflow (moet zijn toegestaan vooroverloop naar het netwerk). Als aan een van de voorwaarden voor inschakelen is voldaan, wordt het stopcontact ingeschakeld en","plug.time.on":"Actief","plug.time.turn_off":"Uitschakelen op een bepaald tijdstip","plug.time.turn_off.help":"Tijdstip waarop het stopcontact wordt uitgeschakeld. Als u 12:00 uur instelt, wordt het stopcontact precies op het ingestelde tijdstip uitgeschakeld","plug.time.turn_on":"Inschakelen op een bepaald tijdstip","plug.time.turn_on.help":"Tijdstip waarop het stopcontact wordt ingeschakeld. Als u 12:00 uur instelt, wordt het stopcontact precies op het ingestelde tijdstip ingeschakeld","plug.turn_off":"Uitschakelen","plug.turn_on":"Inschakelen","pre_flexibility.business_flexibility.title":"Zakelijke flexibiliteit","pre_flexibility.enabled":"Integratie ingeschakeld","pre_flexibility.title":"PRE Flexibiliteit","premium.banner.active.button":"Abonnement beheren","premium.banner.active.dev_mode":"Abonnement is actief voor ontwikkeling","premium.banner.active.subtitle":"Het Infigy Plus-abonnement is actief. U kunt genieten van alle extra functies in de","premium.banner.active.title":"Abonnement is actief","premium.banner.hide.confirm":"Wilt u de Infigy Plus-banner echt verbergen?\u201D","premium.banner.hide.confirm.description":"U kunt Infigy Plus altijd weer bekijken in de applicatie-instellingen.","premium.banner.hide.later":"Herinner me later","premium.banner.hide.show_more":"Meer informatie","premium.banner.hide.yes":"Verbergen","premium.banner.inactive.button":"Meer informatie","premium.banner.inactive.subtitle":"Til uw energiebeheer naar een hoger niveau. Met Infigy Plus krijgt u nog meer slimme tools -gedetailleerde grafieken, directe meldingen, een verbeterde kalender, gedetailleerde rapporten en nog veel meer.","premium.banner.inactive.title":"Infigy Plus is niet actief","premium.dialog.charts.subtitle":"Krijg de mogelijkheid om de prestaties van individuele strings, het verbruik per fase en","premium.dialog.charts.title":"Gedetailleerde grafieken","premium.dialog.close":"Sluiten","premium.dialog.next.subtitle":"We bereiden een heleboel extra voordelen voor die we geleidelijk aan zullen vrijgeven voor Infigy Plus","premium.dialog.next.title":"Extra voordelen komen er binnenkort aan","premium.dialog.notifications.subtitle":"Ontvang meldingen over negatieve prijzen, opgeladen batterijen en andere gebeurtenissen","premium.dialog.notifications.title":"Meldingen","premium.dialog.other_benefits.subtitle":"We bereiden een heleboel extra voordelen voor die we geleidelijk zullen vrijgeven voor Infigy Plus","premium.dialog.other_benefits.title":"Binnenkort komen er extra voordelen","premium.dialog.reports.subtitle":"Gedetailleerde maandelijkse rapporten die u een duidelijk beeld geven van de productie, het verbruik en het energiegebruik in uw huishouden. Alle belangrijke gegevens staan op \xe9\xe9n plek - overzichtelijk, duidelijk en aangevuld met grafieken.","premium.dialog.reports.title":"Geavanceerde rapporten","premium.dialog.save":"Abonneer u op Infigy Plus","premium.dialog.schedule.subtitle":"Plan handmatig het opladen of ontladen van de batterij naar behoefte","premium.dialog.schedule.title":"Verbeterde kalender","premium.dialog.spot.subtitle":"Bekijk de geschiedenis van spotprijzen en plannen die Infigy heeft opgesteld in de","premium.dialog.spot.title":"Geschiedenis van spotprijzen","protocol.settings":"Instellingen","protocol.settings.Licence":"Licentie","protocol.settings.distribution":"Licentie","protocol.test":"Apparaattest","protocol.test.internet-connect":"Internetverbinding","protocol.test.inverter-connect":"De omvormer aansluiten","protocol.test.phase_1":"Fase 1-test","protocol.test.phase_2":"Fase 2-test","protocol.test.phase_3":"Fase 3-test","protocol.test.tester":"Apparaat getest door","relay.condition":"Inschakelen voorwaarde","relay.main":"Algemene informatie","relay.name":"Naam relais","relay.spot.diagram":"Besturing op basis van spotprijs","relay.status":"Status","relay.summary.switch":"Relais inschakelen","relay.title":"Relais","report.avg_day_chart.battery_soc":"Laadstatus van de batterij","report.avg_day_chart.consumption":"Verbruik","report.avg_day_chart.grid":"Net","report.avg_day_chart.pv_production":"PV-productie","report.not_generated":"Maak rapport door te klikken","report_test.button":"Test","report_test.date":"Maand (bijv. 2025-09)","report_test.generated":"Rapport gegenereerd","report_test.ok":"OK","report_test.test":"Test","reports.accumulation_increased":"Accumulatie toegenomen","reports.average_water_temperature":"Gemiddelde watertemperatuur","reports.avg_day":"Gemiddelde dag","reports.battery":"Batterij","reports.boiler":"Elektrische boiler","reports.building_consumption":"Verbruik van het gebouw","reports.disclaimer":"De waarden zijn uitsluitend informatief en kunnen afwijken van de offici\xeble metingen van de","reports.energy_estimate":"Energie-inschatting zonder controle","reports.estimated_water_amount":"Geschatte waterhoeveelheid","reports.grid_consumption":"Netverbruik","reports.grid_consumption_hp":"Netverbruik voor warmtepomp","reports.grid_consumption_hw":"Netverbruik voor elektrische boiler","reports.grid_consumption_wallbox":"Netverbruik voor wallbox","reports.heat_pump":"Warmtepomp","reports.household_consumption":"Huishoudelijk verbruik","reports.info":"Algemene informatie","reports.kilometers_driven":"Aantal gereden kilometers","reports.kilometers_driven_from_sun":"Aantal kilometers gereden op zonne-energie","reports.maximum_power":"Maximaal vermogen","reports.monthly_consumption":"Maandelijks verbruik","reports.monthly_production":"Maandelijkse productie","reports.pv":"Fotovolta\xefsche installatie","reports.pv_consumption":"PV-verbruik","reports.pv_production":"PV-productie","reports.regenerate_report":"Rapport opnieuw genereren","reports.regenerate_report_confirm_title":"Rapport opnieuw genereren?","reports.rfid_cards":"RFID kaarten","reports.self_consumption":"Zelfverbruik","reports.self_sufficiency":"Zelfvoorziening","reports.self_sufficient_days":"Aantal zelfvoorzienende dagen","reports.share.description":"U kunt de geselecteerde schermafbeelding met anderen delen.","reports.share.share":"Rapport delen","reports.share.title":"Rapport delen","reports.share_report":"Rapport delen","reports.sold_to_distribution_grid":"Verkocht aan het net","reports.stored_energy_from_grid":"Opgeslagen energie uit het net","reports.stored_energy_from_pv":"Opgeslagen energie uit PV","reports.stored_energy_to_battery":"Opgeslagen energie naar batterij","reports.stored_energy_to_boiler":"Opgeslagen energie naar elektrische boiler","reports.stored_energy_to_heat_pump":"Opgeslagen energie naar warmtepomp","reports.stored_energy_to_wallbox":"Opgeslagen energie naar wallbox","reports.total_overflow_to_grid":"Totale overloop naar het net","reports.total_purchase_from_grid":"Totale aankoop van het net","reports.total_with_control":"Totaal met regeling","reports.total_without_control":"Totaal zonder regeling","reports.updated_at":"Gegenereerd op {date}","reports.wallbox":"EV-laadstation (wallbox)","rfid_cards.col.consumption":"Verbruik","rfid_cards.col.created_at":"Toegevoegd","rfid_cards.col.id":"Kaart-ID","rfid_cards.col.name":"Naam","rfid_cards.export":"Exporteer CSV","rfid_cards.from":"Van","rfid_cards.no_cards":"Geen kaarten toegevoegd.","rfid_cards.title":"RFID-kaarten","rfid_cards.to":"Naar","save":"Opslaan","schedules.add":"Plan toevoegen","schedules.add.tooltip":"Toevoegen","schedules.battery_charge":"Batterij opladen","schedules.battery_discharge":"Batterij ontladen","schedules.charging_current":"Oplaadstroom: {chargingCurrent} A","schedules.description":"Plan het handmatig opladen of ontladen van de batterij naar behoefte.","schedules.dialog.title":"Planner","schedules.dialog.title.ev":"EV-opladen plannen","schedules.ev_charging":"EV-opladen","schedules.form.action":"Actie","schedules.form.battery_charge":"Batterij opladen","schedules.form.battery_discharge":"Batterij ontladen","schedules.form.charging-current":"Stellen van de oplaadstroom","schedules.form.charging-current.auto":"Standaard","schedules.form.close":"Sluiten","schedules.form.create":"Aanmaken","schedules.form.duration":"Duur (minuten)","schedules.form.duration.120min":"2 uur","schedules.form.duration.180min":"3 uur","schedules.form.duration.240min":"4 uur","schedules.form.duration.300min":"5 uur","schedules.form.duration.360min":"6 uur","schedules.form.duration.60min":"1 uur","schedules.form.ev_charging":"EV-opladen","schedules.form.frequency":"Frequentie","schedules.form.frequency.daily":"Dagelijks","schedules.form.frequency.monthly":"Maandelijks","schedules.form.frequency.weekly":"Wekelijks","schedules.form.interval.biweekly":"Elke 2 weken","schedules.form.preview.hide":"Voorbeeld verbergen","schedules.form.preview.show":"Geplande voorkomens weergeven","schedules.form.preview.title":"Geplande starts ({count} volgende)","schedules.form.recurring":"Terugkerend","schedules.form.target-soc":"Doel-SOC (optioneel)","schedules.form.until":"Herhalen tot (optioneel)","schedules.form.when":"Wanneer","schedules.loading.error":"Fout bij het laden van schema\'s","schedules.missed":"Gemist","schedules.no_plans_found":"Geen plannen gevonden.","schedules.processed":"Verwerkt","schedules.remove.confirm":"Wilt u het plan echt verwijderen?","schedules.remove.no":"Annuleren","schedules.remove.recurring.instance":"Alleen dit voorkomen verwijderen","schedules.remove.recurring.series":"Hele reeks verwijderen","schedules.remove.recurring.title":"Terugkerend plan verwijderen","schedules.remove.yes":"Verwijderen","schedules.running":"Wordt uitgevoerd","schedules.scheduled":"Gepland","schedules.show_processed":"Verwerkt weergeven","schedules.target_soc":"Doel SOC: {targetSoc, number, percent}","schedules.title":"Planner","scripts.add":"Aanmaken","scripts.delete":"Verwijderen","scripts.edit":"Bewerken","scripts.loading_error":"Fout bij het laden van scripts","scripts.title":"Scripten","settings.PV.NominalInverterPower":"Nominaal vermogen omvormer","settings.PV.NominalInverterPower.help":"Dit is belangrijk voor de juiste %-berekening van terug leveren voor Solinteg, Wattsonic en Deye.","settings.PV.NominalInverterPower.subtitle":"Nominaal vermogen van de omvormer in kW, belangrijk voor de berekening van het percentage terug leveren naar het netwerk.","settings.PV.StringNumber":"Aantal omvormerstrings","settings.PV.StringNumber.subtitle":"Aantal omvormerstrings weergegeven in het tabblad PV in de applicatie","settings.app_update":"Applicatieversie","settings.app_update.check_button":"Updates controleren","settings.app_update.confirm.cancel":"Annuleren","settings.app_update.confirm.confirm":"Bijwerken","settings.app_update.confirm.description":"De update kan enkele minuten duren. Tijdens de update is de applicatie niet beschikbaar en wordt daarna automatisch herstart.","settings.app_update.confirm.title":"Update uitvoeren?","settings.app_update.error.no_internet":"Controleer de netwerkverbinding","settings.app_update.in_progress":"Update wordt uitgevoerd","settings.app_update.request_button":"Er is een update beschikbaar","settings.app_update.requested":"Update is aangevraagd","settings.app_update.subtitle":"Controleer op nieuwe versies","settings.app_update.title":"Applicatie-update","settings.app_update.up_to_date":"Applicatie is up-to-date","settings.boiler":"Boiler","settings.boiler.3phase":"Driefasige elektrische boiler","settings.boiler.3phase.subtitle":"Sluit een eenfasige elektrische boiler aan op de SSR-uitgang die overeenkomt met de geselecteerde fase.","settings.boiler.HwBatteryPriority":"Als de batterijlading lager is dan deze waarde, is de energieopslagprioriteit volledig beschikbaar voor","settings.boiler.HwBatteryPriority.help":"de batterij. Als de batterijlading hoger is, krijgt de boiler voorrang en begint deze het water te verwarmen met de overtollige energie van de PV - een deel van de energie gaat verder naar de batterij om te worden","settings.boiler.capacity":"Boilerinhoud","settings.boiler.capacity_sub":"Alleen vereist voor spot trading","settings.boiler.enabled":"Ge\xefnstalleerde elektrische boiler","settings.boiler.hysterezis":"Boilerhysterese","settings.boiler.hysterezis.subtitle":"Hysterese is alleen voor reguliere verwarming","settings.boiler.nominal":"Nominaal vermogen","settings.boiler.nominal.subtitle":"Nominaal vermogen voor 1 fase van de elektrische boiler","settings.boiler.phase":"Boilerfase","settings.boiler.phase.subtitle":"L1 = SSR-uitgang 1, L2 = SSR-uitgang 2, L3 = SSR-uitgang 3.","settings.boiler.prio":"Batterijprioriteit","settings.boiler.prio.subtitle":"Als deze optie is ingeschakeld, wordt eerst de batterij opgeladen en daarna de boiler","settings.boiler.shellies":"Boiler wordt aangestuurd via Shelly","settings.boiler.temp_enabled":"Temperatuursensor ge\xefnstalleerd","settings.boiler.temp_enabled.subtitle":"De boiler kan alleen worden gebruikt voor overschotten zonder sensor","settings.device":"Apparaat","settings.device.SN":"Serienummer","settings.device.id":"Apparaat-ID","settings.device.license":"Apparaatlicentie","settings.docs":"Handleidingen en ander materiaal","settings.docs.service_settings_inverter.button":"Ga naar wiki","settings.docs.service_settings_inverter.subtitle":"Handleidingen, procedures en andere informatie","settings.docs.service_settings_inverter.title":"Handleiding voor het aansluiten van de omvormer","settings.docs.tech_wiki.button":"Ga naar wiki","settings.docs.tech_wiki.subtitle":"Handleidingen, procedures en andere informatie","settings.docs.tech_wiki.title":"Technische wiki","settings.docs.user_wiki.button":"Ga naar wiki","settings.docs.user_wiki.subtitle":"Handleidingen, procedures en andere informatie","settings.docs.user_wiki.title":"Gebruikerswiki","settings.hdo":"Instelling van HDO tijden","settings.hdo.help":"Hieronder kunt u de tijden van het lage tarief instellen.","settings.hdo.on1":"Tijd 1","settings.hdo.on2":"Tijd 2","settings.hdo.on3":"Tijd 3","settings.hdo.on4":"Tijd 4","settings.hdo.on5":"Tijd 5","settings.hdo.on6":"Tijd 6","settings.hdo.regular":"Normale werkdag","settings.hdo.start":"Start","settings.hdo.stop":"Stop","settings.hdo.type":"Tijden defini\xebren voor","settings.hdo.weekend":"Weekend HDO-tijden","settings.heatpump":"Installatie","settings.heatpump.HpBatteryPriority":"Percentage van de batterijlading waarbij de warmtepomp begint met verwarmen","settings.heatpump.HpBatteryPriority.help":"Als de batterijlading lager is dan deze waarde, is de energieaccumulatieprioriteit volledig beschikbaar voor de batterij. Als de batterijlading hoger is, krijgt de warmtepomp voorrang en begint deze te verwarmenhet water verwarmen met de overtollige energie van de PV - een deel van de energie gaat verder naar de batterij om te worden","settings.heatpump.enabled":"Warmtepomp ge\xefnstalleerd","settings.heatpump.flexiAN":"Flexibiliteit van de accumulatietank","settings.heatpump.flexiCool":"Flexibiliteit van de koeling","settings.heatpump.flexiHw":"Flexibiliteit van warm water","settings.heatpump.flexiRoom":"Flexibiliteit van de ruimte","settings.heatpump.hp_type":"Type warmtepomp","settings.heatpump.nominal":"Nominaal ingangsvermogen","settings.heatpump.nominal1":"Nominaal ingangsvermogen","settings.heatpump.priority":"De warmtepomp heeft een hogere prioriteit dan de batterij","settings.heatpump.priority-wb":"Warmtepomp heeft een hogere prioriteit dan de wallbox","settings.heatwatter":"Boiler","settings.heatwatter.legionella":"Legionella","settings.heatwatter.legionella_temp":"Saneringstemperatuur","settings.heatwatter.legionella_temp.subtitle":"Temperatuur waartoe de boiler minstens eens per 14 dagen moet worden verwarmd","settings.inverter_communication_status":"Communicatie met omvormer","settings.inverter_communication_status.not_ok":"Niet verbonden,{br}verbinding wordt gemaakt...","settings.inverter_communication_status.ok":"Communicatie verbonden{br}({count} metingen)","settings.inverter_communication_status.subtitle":"Het tot stand brengen van de verbinding kan enkele tientallen seconden tot een paar minuten duren","settings.notification":"Meldingen","settings.notification.application_settings":"Meldingen - parameters","settings.notification.battery_max_soc":"Maximale SOC-batterij","settings.notification.battery_max_soc.subtitle":"Er wordt een melding gegenereerd wanneer de maximale SOC van de batterij is bereikt. De melding wordt slechts \xe9\xe9n keer per dag gegenereerd.","settings.notification.battery_max_soc_value":"Maximale SOC-batterij voor meldingen","settings.notification.battery_max_soc_value.subtitle":"Stel de SOC van de batterij in waarbij een melding wordt gegenereerd.","settings.notification.battery_min_soc":"Minimale SOC-batterij","settings.notification.battery_min_soc.subtitle":"Er wordt een melding gegenereerd wanneer de SOC van de batterij daalt tot de ingestelde minimumwaarde. Er wordt slechts \xe9\xe9n keer per dag een melding gegenereerd.","settings.notification.battery_min_soc_value":"Minimale SOC-batterij voor meldingen","settings.notification.battery_min_soc_value.subtitle":"Stel de SOC van de batterij in waarbij een melding wordt gegenereerd.","settings.notification.daily_prediction.subtitle":"Er wordt elke dag om 8:00 uur een melding gegenereerd","settings.notification.description":"Toestemming om meldingen te genereren die in de applicatie worden gegenereerd","settings.notification.heat_pump_limit_exceeded":"Overschrijding van de limiet voor het verbruik van de warmtepomp","settings.notification.heat_pump_limit_exceeded.subtitle":"Er wordt een melding gegenereerd wanneer de limiet van het warmtepompverbruik wordt overschreden","settings.notification.heat_pump_limit_value":"Dagelijkse limiet van het warmtepompverbruik voor meldingen","settings.notification.heat_pump_limit_value.subtitle":"Stel de limiet van het warmtepompverbruik in waarbij een melding wordt gegenereerd.","settings.notification.heat_water_limit_exceeded":"Overschrijding van de limiet voor verwarmingswater","settings.notification.heat_water_limit_exceeded.subtitle":"Er wordt een melding gegenereerd wanneer de limiet voor verwarmingswater wordt overschreden","settings.notification.heat_water_limit_value":"Dagelijkse limiet voor het verwarmen van water voor meldingen","settings.notification.heat_water_limit_value.subtitle":"Stel de limiet in voor het verwarmen van water, waarbij een melding wordt gegenereerd.","settings.notification.heat_water_max_temperature":"De maximale temperatuur van het water is bereikt","settings.notification.heat_water_max_temperature.subtitle":"Er wordt een melding gegenereerd wanneer de maximale temperatuur van het water in de boiler van PV","settings.notification.home_consumption_limit_exceeded":"Overschrijding van de limiet voor thuisverbruik","settings.notification.home_consumption_limit_exceeded.subtitle":"Er wordt een melding gegenereerd wanneer de limiet voor thuisverbruik wordt overschreden","settings.notification.home_consumption_limit_value":"Dagelijkse limiet van het huishoudelijk verbruik voor meldingen","settings.notification.home_consumption_limit_value.subtitle":"Stel de limiet voor het huishoudelijk verbruik in, waarbij een melding wordt gegenereerd.","settings.notification.iverter_disconnected":"De communicatie met de omvormer is verbroken","settings.notification.iverter_disconnected.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van het communicatieverlies met de","settings.notification.negative_spot":"Negatieve prijs op de spotmarkt","settings.notification.negative_spot.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van de negatieve prijs op de spotmarkt","settings.notification.pv_production_mwh":"Mijlpaal in de productie van fotovolta\xefsche energie","settings.notification.pv_production_mwh.subtitle":"Er wordt een melding gegenereerd als de PV in het betreffende jaar MWh aan energie opwekt","settings.notification.spot_charging_battery":"Start en stop het opladen van de batterij op basis van de spotprijs","settings.notification.spot_charging_battery.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van het opladen van de batterij op basis van de","settings.notification.spot_daily_prediction":"Dagelijkse voorspelling","settings.notification.spot_daily_summary":"Dagelijks overzicht van het spotplan","settings.notification.spot_daily_summary.subtitle":"Er wordt elke dag om 8:00 uur een melding gegenereerd.","settings.notification.spot_discharging_battery":"Start en stop het ontladen van de batterij naar het net op basis van de spotprijs","settings.notification.spot_discharging_battery.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van het ontladen van de batterij naar het net","settings.notification.utility_loss":"Stroomuitval","settings.notification.utility_loss.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van de stroomuitval","settings.notification.wallbox_charging_start_stop":"Start en stop het opladen van het elektrische voertuig.","settings.notification.wallbox_charging_start_stop.subtitle":"Er wordt een melding gegenereerd aan het begin en einde van het opladen van de elektrische auto","settings.notification.wallbox_limit_exceeded":"Overschrijding van de limiet voor het opladen van de elektrische auto","settings.notification.wallbox_limit_exceeded.subtitle":"Er wordt een melding gegenereerd wanneer de limiet voor het opladen van het elektrische voertuig wordt overschreden","settings.notification.wallbox_limit_value":"Dagelijkse limiet voor het opladen van de elektrische auto voor meldingen","settings.notification.wallbox_limit_value.subtitle":"Stel de limiet voor het opladen van de elektrische auto in, waarbij een melding wordt gegenereerd.","settings.notification.webapp.subtitle":"U kunt meldingen van Infigy ontvangen via de webapplicatie.","settings.notification.webapp.title":"Webapplicatie","settings.other":"Overige","settings.other.dark_mode":"Donker","settings.other.languate":"Taal","settings.other.overflow_fronius":"De maximale overstroom naar het netwerk wordt beperkt aan de kant van de Fronius-omvormer.","settings.other.overflow_fronius_subtitle":"Deze waarde wordt ingesteld door de distributeur. Overschrijding van deze waarde kan leiden tot financi\xeble sancties van de","settings.other.overflow_settings":"Overstroomwaarde instellen","settings.other.overflow_settings.help":"Dit is een door de service ingestelde waarde voor de maximale overstroom. Deze waarde wordt ingesteld door de distributeur. Overschrijdingdeze waarde kan leiden tot financi\xeble sancties van de distributeur.","settings.other.readability_mode":"Lettergrootte","settings.photovoltaics":"Fotovolta\xefsche","settings.photovoltaics.backup_enabled":"Back-up ingeschakeld","settings.photovoltaics.backup_enabled.subtitle":"Informatie over de back-upmodus van de omvormer.","settings.photovoltaics.batterychargingpower":"Laadvermogen van de accu","settings.photovoltaics.batterychargingpower_sub":"Vermogen voor handmatig opladen van de batterij en spotopladen vanuit het elektriciteitsnet","settings.photovoltaics.batterydischargingpower":"Batterijontladingsvermogen","settings.photovoltaics.batterydischargingpower_sub":"Vermogen voor het spotontladen van de batterij naar het elektriciteitsnet","settings.photovoltaics.batteryenabled":"Ge\xefnstalleerde batterij","settings.photovoltaics.batterynominal":"Nominale batterijcapaciteit","settings.photovoltaics.batterynominal_sub":"Alleen vereist voor spotverhandeling","settings.photovoltaics.enabled":"Ge\xefnstalleerde fotovolta\xefsche installatie","settings.photovoltaics.gridchargeenabled":"Laden van de batterij vanaf het distributienet ingeschakeld","settings.photovoltaics.inverters-adjust-power":"Huidig vermogen omvormer","settings.photovoltaics.inverters-nominal":"Nominaal vermogen van regelbare omvormers","settings.photovoltaics.nominal":"Nominaal vermogen","settings.photovoltaics.overflow":"Onbeperkte netoverloop","settings.photovoltaics.overflow.value":"Overstroombeperking","settings.photovoltaics.overflow.value.help":"Waarde van de maximale overstroom naar het net. Deze waarde wordt naar de omvormer geschreven. Wijzig deze waarde niet deze waarde in de omvormer niet wijzigen. De overstroombeperking wordt geregeld door Infigy. Controleer de ingestelde","settings.photovoltaics.overflow_fronius.value.help":"Waarde van de maximale overstroom naar het netwerk aan de kant van de Fronius-omvormer. Deze wordt gebruikt als informatie voor Infigy om terug leveren correct te visualiseren.","settings.photovoltaics.settings":"Batterij","settings.photovoltaics.settings.soc_actual":"Berekende minimale lading","settings.photovoltaics.settings.soc_actual.help":"Deze waarde wordt automatisch berekend op basis van de huidige staat. Het wordt beheerd door automatische laadregeling op basis van het jaarlijkse seizoen, of door handmatige instelling van de minimale lading met DS en zonder DS. Als de waarde 100% is, dan is het laden van de batterij verboden, bijvoorbeeld op basis van spotverhandeling.","settings.photovoltaics.settings.soc_grid":"Minimale oplaadniveau met DS","settings.photovoltaics.settings.soc_grid.help":"Met deze waarde kunt u het minimale oplaadniveau van de batterij in % SOC regelen wanneer de distributienetwerk beschikbaar is. In Solax in de Backup modus is het minimale oplaadniveau van de batterij 15%.","settings.photovoltaics.settings.temp":"Minimale lading met net","settings.photovoltaics.settings.temp.help":"Met deze waarde kunt u de minimale lading van de batterij in % SOC regelen wanneer de","settings.photovoltaics.settings.temp_ek":"Minimale oplaadniveau zonder net","settings.photovoltaics.settings.temp_ek.help":"Met deze waarde kunt u het minimale oplaadniveau van de batterij in % SOC regelen wanneer de","settings.photovoltaics.unbalanced_enabled":"Asymmetrie van de fotovolta\xefsche omvormer","settings.photovoltaics.unbalanced_enabled.subtitle":"Informatie over de asymmetrie van de fotovolta\xefsche omvormer.","settings.photovoltaics_auto_settings":"Automatische laadregeling","settings.photovoltaics_auto_settings.subtitle":"Automatische minimale SOC-regeling op basis van de jaarlijkse periode","settings.plug":"Aansluitingen","settings.plug.Led":"Permanente achtergrondverlichting","settings.plug.Led-batt":"Achtergrondverlichting wanneer de batterij wordt opgeladen","settings.plug.Led-batt.subtitle":"Achtergrondverlichting actief als de batterij ten minste 95% is","settings.plug.Led-over":"Achtergrondverlichting tijdens overloop","settings.plug.enabled":"Ge\xefnstalleerde stopcontacten","settings.plug.enabled.subtitle":"Aansluitingen op het lokale netwerk","settings.plug.enabled2":"Tweede stopcontact","settings.plug.enabled3":"Derde stopcontact","settings.plug.ip1":"Het IP-adres van de eerste socket","settings.plug.ip1.label":"IP 3","settings.plug.ip2":"Het IP-adres van de tweede socket","settings.plug.ip2.label":"IP 2","settings.plug.ip3":"Het IP-adres van de derde socket","settings.plug.ip3.label":"IP 3","settings.plug.modulenabled":"Sockets op de module","settings.plug.modulip":"IP-adres van de module","settings.plug.modulip.label":"IP-module","settings.plug.name1":"Naam van socket 1","settings.plug.name1.label":"Naam","settings.plug.name2":"Naam van socket 2","settings.plug.name2_label":"Naam","settings.plug.name3":"Naam van socket 3","settings.plug.name3.label":"Naam","settings.plug.statusLed":"Signaaldiode","settings.readability_mode.default":"Standaard","settings.readability_mode.large":"Groot","settings.relay":"Relais","settings.relay.0.enabled":"Eerste relais","settings.relay.1.enabled":"Tweede relais","settings.relay.1.type":"Voorwaarde","settings.relay.1.type.HDO":"Spiegel HDO","settings.relay.1.type.batteryfull":"Batterij meer dan 95% opgeladen","settings.relay.1.type.batterylow":"Batterij minder dan minimaal ingesteld opgeladen","settings.relay.1.type.bojlerFull":"Boiler is bijna opgewarmd","settings.relay.1.type.none":"Niet gebruikt","settings.relay.1.type.plug1":"Aansluiting 1","settings.relay.1.type.plug2":"Aansluiting 2","settings.relay.1.type.plug3":"Aansluiting 3","settings.relay.1.type.spotHi":"Hoge spotprijs","settings.relay.1.type.spotLow":"Lage spotprijs","settings.relay.1.type.spotMi":"Gemiddelde spotprijs","settings.relay.1.type.spotNegative":"Negatieve spotprijs","settings.relay.1.type.thermostat1":"Thermostaatcircuit 1","settings.relay.1.type.thermostat2":"Thermostaatcircuit 2","settings.relay.1.type.thermostat3":"Thermostaatcircuit 3","settings.relay.1.type.thermostat4":"Thermostaatcircuit 4","settings.relay.2.enabled":"Derde relais","settings.relay.3.enabled":"Vierde relais","settings.relay.above_price_relay":"Spotprijs voor activering van het relais","settings.relay.above_price_relay.subtitle":"Als de spotprijs hoger is dan deze waarde, wordt het relais ingeschakeld. Als deze lager is, wordt het relais uitgeschakeld.","settings.relay.above_price_relay_15m":"Spotprijs voor activering van het relais (15 min)","settings.relay.above_price_relay_15m.subtitle":"Als de spotprijs hoger is dan deze waarde, wordt het relais ingeschakeld. Als deze lager is, wordt het relais uitgeschakeld.","settings.relay.above_soc_relay":"Batterijlading voor het activeren van het relais","settings.relay.above_soc_relay.subtitle":"Als de batterijlading hoger is dan deze waarde, wordt het relais ingeschakeld.","settings.relay.above_soc_relay_hyst":"Hysterese van de SOC van de batterij voor het uitschakelen van het relais","settings.relay.above_soc_relay_hyst.subtitle":"Als de batterijlading met deze waarde onder de ingestelde activeringswaarde daalt, wordt het relais uitgeschakeld.","settings.relay.below_price_relay":"Spotprijs voor het activeren van het relais","settings.relay.below_price_relay.subtitle":"Als de spotprijs lager is dan deze waarde, wordt het relais ingeschakeld. Als deze hoger is, wordt het relais uitgeschakeld.","settings.relay.below_price_relay_15m":"Spotprijs voor activering van het relais (15 min)","settings.relay.below_price_relay_15m.subtitle":"Als de spotprijs lager is dan deze waarde, wordt het relais ingeschakeld. Als deze hoger is, wordt het relais uitgeschakeld.","settings.relay.below_soc_relay":"Batterijlading voor het activeren van het relais","settings.relay.below_soc_relay.subtitle":"Als de batterijlading met deze waarde onder de ingestelde activeringswaarde daalt, wordt het relais uitgeschakeld.","settings.relay.below_soc_relay_hyst":"Hysterese van de SOC van de batterij voor het uitschakelen van het relais","settings.relay.below_soc_relay_hyst.subtitle":"Als de batterijlading met deze waarde boven de ingestelde activeringswaarde stijgt, wordt het relais uitgeschakeld.","settings.relay.enabled":"Ge\xefnstalleerde relais","settings.relay.enabled.subtitle":"Ge\xefntegreerde relais","settings.relay.item.enabled":"Relais {index}","settings.relay.item.name":"Naam relais","settings.relay.item.status":"Status","settings.relay.option":"Voorwaarde","settings.relay.temp_above_relay.subtitle":"Als de keteltemperatuur hoger is dan deze waarde, wordt het relais ingeschakeld.","settings.relay.temp_above_relay_hyst.subtitle":"Als de keteltemperatuur met deze waarde onder de ingestelde activeringswaarde daalt, schakelt het relais uit.","settings.relay.temp_below_relay.subtitle":"Als de keteltemperatuur lager is dan deze waarde, schakelt het relais in.","settings.relay.temp_below_relay_hyst":"Hysterese van de keteltemperatuur in \xb0C voor het uitschakelen van het relais","settings.relay.temp_below_relay_hyst.subtitle":"Als de keteltemperatuur met deze waarde boven de ingestelde activeringswaarde stijgt, schakelt het relais uit","settings.relay.temp_relay":"Boiler temperatuur voor het relais om te activeren","settings.relay.temp_relay_hyst":"Hysterese van de keteltemperatuur \xb0C voor het uitschakelen van het relais","settings.relay.type.Active":"Permanent ingeschakeld","settings.relay.type.HDO":"Spiegel HDO","settings.relay.type.batteryBelowSOC":"Batterijlading onder de ingestelde SOC","settings.relay.type.batteryDischarge":"Batterij ontlaadt naar het net","settings.relay.type.batteryFull":"Batterijlading boven de ingestelde SOC","settings.relay.type.batteryLow":"Batterijlading onder het ingestelde minimum","settings.relay.type.bojlerFull":"De boiler is bijna opgewarmd","settings.relay.type.hdo":"Spiegel HDO","settings.relay.type.heatWaterAboveTemp":"Boiler is boven de ingestelde temperatuur verwarmd","settings.relay.type.heatWaterBelowTemp":"Boiler is onder de ingestelde temperatuur verwarmd","settings.relay.type.heatWaterMaxTemp":"Boiler is bijna opgewarmd","settings.relay.type.heatWaterTemp":"Boiler is boven de ingestelde temperatuur verwarmd","settings.relay.type.none":"Niet gebruikt, permanent uitgeschakeld","settings.relay.type.plug1":"Aansluiting 1","settings.relay.type.plug2":"Aansluiting 2","settings.relay.type.plug3":"Aansluiting 3","settings.relay.type.plug4":"Aansluiting 4","settings.relay.type.spotBatteryDischarge":"Batterij ontlaadt naar het net","settings.relay.type.spotHi":"Hoge spotprijs","settings.relay.type.spotHi15M":"Hoge spotprijs (15 min)","settings.relay.type.spotLow":"Lage spotprijs","settings.relay.type.spotLow15M":"Lage spotprijs (15 min)","settings.relay.type.spotMi":"Gemiddelde spotprijs","settings.relay.type.spotMi15M":"Gemiddelde spotprijs (15 min)","settings.relay.type.spotNegative":"Beperking van terug leveren naar het netwerk","settings.relay.type.spotNegative15M":"Verbod op teruglevering naar het netwerk (15 min)","settings.relay.type.spotPriceAbove":"Spotprijs boven de ingestelde waarde","settings.relay.type.spotPriceAbove15M":"Spotprijs boven de ingestelde waarde (15 min)","settings.relay.type.spotPriceBelow":"Spotprijs onder de ingestelde waarde","settings.relay.type.spotPriceBelow15M":"Spotprijs onder de ingestelde waarde (15 min)","settings.relay.type.spotStopAccumulation":"Accumulatie gestopt, actieve verkoop","settings.relay.type.stopAccumulation":"Accumulatie gestopt, actieve verkoop","settings.relay.type.thermostat1":"Thermostaat 1","settings.relay.type.thermostat2":"Thermostaat 2","settings.relay.type.thermostat3":"Thermostaat 3","settings.relay.type.thermostat4":"Thermostaat 4","settings.relay.user_advanced_control":"Pagina met informatie voor de gebruiker weergeven","settings.relay.user_advanced_control.subtitle":"Wanneer ingeschakeld, verschijnt er een pagina in de navigatie","settings.service":"Service","settings.service.connection_type":"Verbinding","settings.service.customer":"Gebruikersnaam","settings.service.customer-email":"E-mailadres van gebruiker","settings.service.customer-email-subtitle":"Als de gebruiker geen account heeft onder dit e-mailadres, wordt er automatisch een account aangemaakt en wordt er een registratiemail verzonden.","settings.service.customer-email.label":"E-mail","settings.service.customer-subtitle":"Wordt gebruikt om de installatie voor het bedrijf en de klant te identificeren","settings.service.customer.label":"Naam","settings.service.exit":"Uitloggen bij de dienst","settings.service.exit.button":"Uitloggen","settings.service.info":"Installatie","settings.service.inverter_type":"Type omvormer","settings.service.inverter_type.label":"Omvormer","settings.service.modbus_tcp":"LAN/WiFi","settings.service.network":"Netwerk","settings.service.network.help.content":"De lijst toont apparaten die momenteel zijn aangesloten op het Infigy-netwerk (WiFi of kabel), hun IP-adressen, MAC-adressen, enz. Als een apparaat DHCP gebruikt, kunt u op de pin klikken om het IP-adres vast te leggen dat de DHCP- server altijd zal toewijzen. Dit is handig voor apparaten zoals omvormers, warmtepompen, enz.","settings.service.network.help.title":"Netwerkinstellingen","settings.service.network.mac":"MAC-adres","settings.service.network.online.internet":"Toegang tot internet","settings.service.network.online.internet.help":"Toegang tot internet is vereist voor externe toegang, systeemupdates, spotprijzen en andere functies. Voor volledige functionaliteit moeten alle drie de indicatoren groen zijn.{br}{br}De eerste indicator toont de beschikbaarheid van internet (ping 8.8.8.8).{br}{br}De tweede indicator toont de beschikbaarheid van internet inclusief DNS (ping infigy.cz).{br}{br}De derde indicator toont de toegang tot de interne cloudservices van Infigy (beschikbaarheid van VPN).{br}{br}Als er een probleem is met de verbinding, controleer de kabel of neem contact op met de netwerkbeheerder, als de lokale netwerk beperkingen heeft op communicatie naar internet.{br}{br}{wikiLink}","settings.service.network.online.internet.help.wikiLink":"Meer informatie in onze wiki.","settings.service.network.online.portal":"Toegang tot het Infigy-portaal","settings.service.network.wan":"WAN-adres","settings.service.network.wifi_passphrase":"Wifi-netwerkwachtwoord","settings.service.network_type":"Netwerk","settings.service.network_type.custom":"Handmatige adresinstelling","settings.service.network_type.external":"Lokaal netwerk (klant)","settings.service.network_type.internal":"Intern Infigy-netwerk","settings.service.password":"Toegang tot service","settings.service.password.label":"Wachtwoord","settings.service.relay":"Relais","settings.service.reset":"Fout hersteld","settings.service.reset.button":"Fout herstellen","settings.service.rs485":"RS485","settings.service.service-email":"E-mailadres servicebedrijf","settings.service.service-email-subtitle":"Om het apparaat te koppelen aan het installatieaccount, moet u het e-mailadres van het servicebedrijf invoeren e-mailadres van het servicebedrijf invoeren, dat is opgeslagen in het gedeelte Partner van de applicatie.","settings.service.service-email.label":"E-mail","settings.service.servicer":"Naam van de installateur","settings.service.servicer.label":"Naam","settings.service.solidsun_op":"SolidSun OP","settings.service.solidsun_op.label":"SolidSun OP","settings.service.spot":"Spothandel","settings.service.tester.label":"Naam van tester","settings.service.thermostat":"Thermostaat","settings.service.town":"Locatie (dorp)","settings.service.version":"Versie van de applicatie","settings.service.wallbox_type":"Type wallbox","settings.service.wallbox_type.label":"Wallbox","settings.spot":"Spot handel","settings.spot.battery":"Batterij opladen per spot toegestaan","settings.spot.battery.stop_discharge_auto":"Automatische ontladingsbeperking","settings.spot.battery.stop_discharge_auto.help":"Als u deze optie selecteert, regelt het systeem automatisch de ontlading van de accu en staat het alleen bij de hoogste dagelijkse spotprijzen.","settings.spot.battery.stop_discharge_auto.subtitle":"Automatische controle van de opslag van energie tegen de hoogste prijs","settings.spot.battery.stop_discharge_hi_price":"Batterijontlading bij lage en gemiddelde prijzen verbieden","settings.spot.battery.stop_discharge_high_price":"Ontlading van de batterij bij lage en gemiddelde prijzen verbieden","settings.spot.battery.stop_discharge_high_price.help":"Als u deze optie selecteert, zal het systeem geen energie uit de batterij gebruiken bij lage en gemiddelde spotprijzen. Het systeem zal de batterij niet ontladen. Deze zal worden gebruikt bij hogere prijzen.","settings.spot.battery.stop_discharge_low_price":"Batterijontlading bij lage prijzen verbieden","settings.spot.battery.stop_discharge_low_price.help":"Als u deze optie selecteert, zal het systeem geen energie uit de batterij gebruiken bij lage spotprijzen. Het systeem zal de batterij niet ontladen. Deze zal worden gebruikt bij hogere prijzen (gemiddelde en hoge prijs).","settings.spot.battery.stop_discharge_low_price.subtitle":"Beheer van de opslag van energie bij gemiddelde en hoge prijzen","settings.spot.battery.stop_discharge_middle_price.subtitle":"Beheer van de opslag van energie bij hoge prijzen","settings.spot.batteryAllOverflowPrice":"Minimumprijs voor het ontladen van de volledige batterijcapaciteit","settings.spot.batteryOverflow":"Batterijontlading naar het net toestaan volgens spotprijzen","settings.spot.batteryOverflowPrice":"Minimumprijs voor het ontladen van de batterij","settings.spot.batterySale":"Toegestaan ontladen van batterij naar het net volgens spotprijzen","settings.spot.battery_all_overflow_price":"Minimumprijs voor het ontladen van de volledige batterijcapaciteit","settings.spot.battery_all_overflow_price.help":"Als de spotprijs hoger is dan deze waarde, wordt de batterijcapaciteit op het gunstigste moment naar het net ontladen tot het ingestelde minimale SOC. Dit betekent dat er geen energie in de batterij wordt opgeslagen voor nachtverbruik. Na ontlaad van de batterij naar het net wordt energie voor het object gekocht van het net","settings.spot.battery_all_overflow_price.subtitle":"De energie wordt opgeslagen in de batterij voor dagelijks verbruik","settings.spot.battery_charge":"Toegestaan opladen van de batterij per spot","settings.spot.battery_charge.help":"Als u deze optie selecteert, plant het systeem het opladen tegen de laagste prijzen. Het houdt rekening met het huidige laadniveau van de batterij en de capaciteit ervan. Op basis van deze parameters de oplaadtijd om de batterij tegen de laagst mogelijke prijs op te laden.","settings.spot.battery_charge.subtitle":"Het regelen van de batterij op basis van spotprijzen verhoogt de afschrijving van de batterij","settings.spot.battery_max_soc":"Eind-SOC van de batterij","settings.spot.battery_max_soc.subtitle":"Maximale lading van de batterij bij het opladen via het elektriciteitsnet","settings.spot.battery_overflow":"Batterijontlading naar het elektriciteitsnet toestaan op basis van spotprijzen","settings.spot.battery_overflow.help":"Als u deze optie selecteert, plant het systeem het ontladen van de batterij naar het elektriciteitsnet tegen de hoogste dagprijs en wordt alleen de energie ontladen die niet nodig is voor het dagelijkse verbruik van het object. Met de onderstaande parameters kunt u de prijs bepalen voor het ontladen van de volledige batterijcapaciteit en het ontladen alleen het deel van de batterijcapaciteit dat niet nodig is voor het nachtverbruik.","settings.spot.battery_overflow.subtitle":"Maakt het mogelijk om de overtollige energie in de batterij op het gunstigste moment naar het net te ontladen","settings.spot.battery_overflow_price":"Minimumprijs voor het ontladen van de batterij","settings.spot.battery_overflow_price.help":"Als de spotprijs hoger is dan deze waarde, wordt alleen de overtollige batterijcapaciteit naar het net ontladen. Dit betekent dat er energie in de batterij wordt opgeslagen voor nachtverbruik van het object. Er wordt dus geen energie van het net gekocht","settings.spot.battery_overflow_price.subtitle":"De energie wordt opgeslagen in de batterij voor nachtverbruik","settings.spot.battery_strategy":"Strategie voor spotladen van de batterij","settings.spot.battery_strategy.help":"Met deze schuifregelaar kunt u eenvoudig de voorkeur voor het gebruik van de batterij bij spot trading instellen. Lagere waarden (vanaf 20 %) betekenen minder batterijcycli en dus minder frequent laden/ontladen. volgens spotprijzen. Hogere waarden (tot 70 %) betekenen het tegenovergestelde.","settings.spot.battery_strategy_service.subtitle":"Met deze optie kunnen eindgebruikers de batterijstrategie instellen op het tabblad Spot","settings.spot.battery_strategy_user":"De gebruiker toestaan de batterijstrategie in te stellen","settings.spot.battery_strategy_user.subtitle":"Met deze optie kunt u eindgebruikers toestaan de batterijstrategie in te stellen op het tabblad Spot.","settings.spot.install":"Spot-handel actief","settings.spot.latitude":"Breedtegraad","settings.spot.latitude.mess":"Breedte","settings.spot.longitude":"Lengtegraad","settings.spot.longitude.mess":"Lengte","settings.spot.min_difference_price_charge_from_grid":"Minimaal verschil in spotprijs voor het opladen van de batterij vanuit het elektriciteitsnet","settings.spot.min_difference_price_charge_from_grid.help":"Met deze parameter kunt u het opladen van de batterij vanaf de spot regelen bij een laag verschil tussen de laagste en hoogste prijs. Als de parameter 2 CZK is en het verschil tussen de hoogste prijs (3 CZK) en de laagste prijs (1 CZK) van de spot lager is, dan wordt de batterij opgeladen","settings.spot.min_difference_price_charge_from_grid.subtitle":"Minimaal verschil in spotprijs gedurende de dag, om de batterij op te laden vanuit het elektriciteitsnet","settings.spot.overflow":"Optimalisatie van overloop op basis van spotprijzen toestaan","settings.spot.overflow.help":"Als u deze optie selecteert, geeft het systeem voorrang aan overloop naar het net boven het opladen van de batterij bij","settings.spot.overflow.subtitle":"Maakt het mogelijk om overloop voor prioriteit te geven voor accumulatie","settings.spot.overflow_offset":"Maximale overloop bij negatieve prijs","settings.spot.overflow_offset.help":"De waarde geeft de overloop naar het distributienetwerk bij een negatieve prijs aan. We raden aan deze functie te gebruiken in het geval van een energiegemeenschap.","settings.spot.overflow_offset.subtitle":"De waarde kan niet hoger worden ingesteld dan de maximale overloop","settings.spot.price.period":"Tijdsperiode","settings.spot.price_above_price":"Prijs van het netstroom bij hoog tarief per kWh. Deze prijs wordt opgeteld bij de spotprijs als het hoge tarief van kracht is. De HDO-tijden moeten worden ingesteld voor een correcte berekening van de prijs in het hoge en laag tarief. Dit bedrag staat vermeld op de elektriciteitsrekening.","settings.spot.price_below":"Prijs van het netstroomtarief bij laag tarief per kWh. Deze prijs wordt opgeteld bij de spotprijs als het lage tarief actief is. De HDO-tijden moeten worden ingesteld voor een correcte berekening van de prijs in het hoge en laag tarief. Dit bedrag staat vermeld op de elektriciteitsrekening.","settings.spot.price_distribution_hi":"Prijs van het netstroomtarief bij hoog tarief","settings.spot.price_distribution_hi.help":"Prijs van het netstroomtarief bij hoog tarief","settings.spot.price_distribution_low":"Prijs van het netstroomtarief bij laag tarief","settings.spot.price_distribution_low.help":"Prijs van het netstroomtarief bij laag tarief","settings.spot.price_offset":"De prijs voor het verbieden van terug leveren","settings.spot.price_offset.help":"Wij raden aan om ten minste de commissie/vergoeding van de handelaar voor de verkoop van stroomoverschotten in te stellen op de minimale spotprijs, waaronder de verkoop van overschotten verboden is.","settings.spot.price_offset.subtitle":"De waarde wordt vergeleken met de dagelijkse marktprijs zonder het distributietarief.","settings.spot.region":"Regio","settings.thermostat.hp-blocked":"Blokkering van de warmtepomp","settings.thermostat.hysteresis":"Temperatuurhysterese","settings.thermostat.install":"Thermostaat actief","settings.thermostat.name.label":"Naam","settings.thermostat.name1":"Naam thermostaat 1","settings.thermostat.name2":"Naam thermostaat 2","settings.thermostat.name3":"Naam thermostaat 3","settings.thermostat.name4":"Naam thermostaat 4","settings.thermostat.nominal":"Nominaal vermogen van de bron","settings.thermostat.number-of-thermostat":"Aantal thermostaten","settings.utility":"Huisparameters","settings.utility.loadpercent":"Huidige stroomonderbrekerbelasting","settings.utility.numberofphase":"Driefasige installatie","settings.utility.settings.ampers":"Grootte van de stroomonderbreker","settings.utility.settings.loadpercent":"Bij overschrijding wordt het verbruik beperkt","settings.utility.settings.loadpercent_max":"Bij overschrijding wordt het verbruik beperkt","settings.wallbox":"Wallboxen","settings.wallbox.install":"Wallbox actief","settings.wallbox.name":"Naam van de wallbox {number}","settings.wallbox.spot":"Wallboxen","settings.wallbox.type":"Type wallbox","shellies.list":"Shellies","shellies.mqtt_broker_running":"MQTT Broker-status","shellies.settings":"Instellingen","shellies.settings.boiler.active":"Boiler aangesloten via Shellies","shellies.settings.boiler.id":"ID van Shellies","shellies.settings.boiler.id.label":"ID","shellies.title":"Shellies","spot.chartview":"Prijs weergeven zonder distributiekosten","spot.draft":"Modi voor vandaag","spot.draft.actualpricehi":"De huidige prijs is hoog, verminder het verbruik","spot.draft.actualpricelow":"De huidige prijs is laag, verhoog het verbruik","spot.draft.hesLevel":"Niveau van HES-controle","spot.draft.hiprice":"Limieten van verminderd verbruik","spot.draft.info":"Modi en aanbevelingen voor vandaag","spot.draft.lowprice":"De limiet van verhoogd verbruik","spot.draft.todaystatus_HP":"Accumulatie van warmtepomp","spot.draft.todaystatus_HW":"Accumulatie van warmwater","spot.draft.todaystatus_bat":"Accumulatie van batterijen","spot.draft.todaystatus_em":"Overloop","spot.explanation":"Uitleg van modi","spot.explanation.battery_discharge_to_grid":"Batterij ontladen naar het net","spot.explanation.battery_discharge_to_home":"Batterij ontladen","spot.explanation.hw":"Batterij opladen van het net","spot.explanation.info":"Uitleg van modi voor vandaag","spot.flexibility":"Flexibiliteitsschatting voor vandaag","spot.prediction":"Schatting van het verbruik voor vandaag","spot.prediction.bat":"Dispositionele batterijaccumulatie","spot.prediction.battery":"Dispositionele batterijaccumulatie","spot.prediction.home":"Normaal verbruik van het huis","spot.prediction.hp":"Warmtepomp","spot.prediction.hw":"Dispositionele warmwateraccumulatie","spot.prediction.pv":"Productie van fotovolta\xefsche energie","spot.prediction.sale":"Energie voor verkoop","spot.prediction.sale.help":"Resterende geplande dagelijkse overloop, die prioriteit krijgt als overloop naar het net v\xf3\xf3r de batterij","spot.price.period.15min":"15 min","spot.price.period.60min":"60 min","spot.region.cz":"CZ","spot.region.nl":"NL","spot.region.sk":"SK","spot.status":"Spothandel","spot.summary.battery_charge_from_grid":"Opladen via het elektriciteitsnet","spot.summary.battery_charge_from_grid.help":"Het opladen van de accu via het elektriciteitsnet volgens de spotprijs kan in de instellingen worden in- of uitgeschakeld. Het systeem plant het opladen van de accu tijdens periodes met lage prijzen, rekening houdend met het huidige accuniveau niveau en capaciteit. Op basis van deze parameters bepaalt het de oplaadtijd om","spot.summary.battery_discharge":"Batterij ontladen","spot.summary.battery_discharge.help":"Het ontladen van de batterij naar het huis volgens de spotprijs kan worden in- of uitgeschakeld in de instellingen. Ontladen wordt meestal uitgeschakeld tijdens periodes met lage prijzen, wanneer het beter is om energie uit het net te gebruiken en de batterij te sparen voor periodes met hogere prijzen.","spot.summary.battery_discharge_to_grid":"Ontladen naar het elektriciteitsnet","spot.summary.battery_discharge_to_grid.help":"Het ontladen van de batterij naar het elektriciteitsnet kan worden ingeschakeld of uitgeschakeld in de instellingen. Het systeem plant het ontladen van de batterij naar het net tijdens de hoogste dagelijkse prijzen, waarbij alleen de energie wordt ontladen die niet nodig is voor het normale verbruik van het huis.","spot.summary.boiler":"Boiler","spot.summary.boiler.help":"Het systeem plant de verwarming van de boiler tijdens lage prijzen, rekening houdend met de huidige watertemperatuur temperatuur, de capaciteit van de boiler en de gewenste temperatuur. Op basis van deze parameters bepaalt het","spot.summary.heat_pump":"Warmtepomp","spot.summary.heat_pump.help":"De warmtepomp kan in drie modi werken: verhoogde prestaties, normaal bedrijf en verminderde prestaties. Verhoogde prestaties worden gebruikt tijdens lage prijzen, normaal bedrijf tijdens gemiddelde prijzen en verminderde prestaties tijdens hoge prijzen. Vertraging of toename van het verbruik kan","spot.summary.heat_pump_level.increase":"Verhoogde prestaties","spot.summary.heat_pump_level.normal":"Normaal bedrijf","spot.summary.heat_pump_level.reduction":"Verminderde prestaties","spot.summary.price":"Prijs","spot.summary.price_buy":"Prijs met distributie","spot.summary.price_distribution":"Distributie","spot.summary.price_level":"Prijsniveau","spot.summary.price_level.help":"Infigy sorteert de spotprijzen per uur van laag naar hoog en verdeelt ze in drie ongeveer gelijke delen. Als de uurtarieven vari\xebren van 3 CZK tot 10 CZK, kan het lage prijsbereik 3-6 CZK zijn, het gemiddelde 6-7 CZK en het hoge 7-10 CZK. Het bereik zal dagelijks vari\xebren, afhankelijk van de frequentie van","spot.summary.price_level.hi":"Hoge prijs","spot.summary.price_level.low":"Lage prijs","spot.summary.price_level.mid":"Gemiddelde prijs","spot.summary.price_level_15m":"Prijsniveau 15m","spot.summary.price_sell":"Prijs zonder distributie","spot.summary.spotOverflow":"Overloop naar het netwerk","spot.summary.spotOverflow.allowed":"Toegestaan","spot.summary.spotOverflow.help":"Door overloop naar het net toe te staan tijdens spot trading wordt de spotprijs in een bepaald uur vergeleken en als deze deze lager is dan de prijs voor het verbieden van overloop volgens de instellingen, dan zal het systeem automatisch","spot.summary.spotOverflow.restricted":"Beperkt","spot.summary.state.active":"Actief","spot.summary.state.inactive":"Inactief","spot.summary.time":"Tijd","spot.user.parameters":"Parameters van spot-handel","spot_wizard.banner.button":"Wil je hulp? Ik kan je helpen","spot_wizard.banner.subtitle":"De handleiding helpt je bij het instellen van spot trading.","spot_wizard.banner.title":"Wil je hulp? Ik kan je helpen","spot_wizard.battery_discharge.paragraph1":"Dit instellen verbiedt het ontladen van de batterij bij lage spotprijzen. Dit houdt energie over voor hogere prijzen tijdens de dag.","spot_wizard.battery_discharge.paragraph2":"Als je alleen energie verkoopt op de spot, kun je de verbod deactiveren.","spot_wizard.battery_discharge.title":"Ontladen van de batterij naar je eigen verbruik","spot_wizard.battery_purchase.paragraph1":"Dit instellen maakt het opladen van de batterij vanaf de laagste spotprijs mogelijk wanneer de productie laag is.","spot_wizard.battery_purchase.paragraph2":"Let op de strategie-instelling. Als je 20% instelt, zal Infigy voornamelijk wachten op fotovolta\xefsche energie. Anders zal Infigy voornamelijk kopen op de spot. We raden aan om 25% in te stellen.","spot_wizard.battery_purchase.paragraph3":"Als je alleen energie verkoopt op de spot, kun je het opladen deactiveren.","spot_wizard.battery_purchase.title":"Kopen van energie in de batterij","spot_wizard.boiler.paragraph1":"Dit instellen maakt het verwarmen van de boiler vanaf de laagste prijzen tijdens de dag naar de ingestelde temperatuur mogelijk. Infigy houdt de basis temperatuur bij en gebruikt de toename in temperatuur van de spot.","spot_wizard.boiler.paragraph2":"Het is ook mogelijk om de verwarming te blokkeren bij middel of hoge prijzen.","spot_wizard.boiler.paragraph3":"Als je alleen energie verkoopt op de spot, kun je de temperatuur instellen op 10\xb0C en de verwarming blokkeren.","spot_wizard.boiler.title":"Verwarmen van de boiler","spot_wizard.dialog.finish":"Voltooien","spot_wizard.dialog.next":"Volgende","spot_wizard.dialog.prev":"Vorige","spot_wizard.dialog.step":"Stap {current} van {total}","spot_wizard.dialog.title":"Handleiding voor het instellen van spot trading","spot_wizard.distribution_prices.title":"Voer de prijs in voor distributie in laag en hoog prijsbereiken","spot_wizard.done.description":"Je hebt het instellen van spot trading voltooid. Alle parameters kunnen worden bewerkt in de onderste delen van de Spot pagina, waar je ook deze handleiding opnieuw kunt aanroepen.","spot_wizard.done.title":"Voltooid","spot_wizard.evening_peak_discharge.paragraph1":"Infigy schat automatisch het verbruik van energie in de ochtenduren. Het overschot kan worden verkocht tegen de hoogste prijs van de dag.","spot_wizard.evening_peak_discharge.paragraph2":"Als je alleen energie kunt kopen op de spot, kun je het ontladen deactiveren.","spot_wizard.evening_peak_discharge.title":"Ontladen van de batterij in de avondpiek","spot_wizard.general_settings.title":"Eerste algemene instellingen","spot_wizard.hdo_times.title":"Instellen van HDO-tijden bepaalt het laag prijsbereik","spot_wizard.heat_pump.paragraph1":"Dit instellen maakt het verhogen van de prestaties van de warmtepomp bij laag productie en het verlagen van de prestaties bij hoge prijzen mogelijk.","spot_wizard.heat_pump.paragraph2":"Als je alleen energie verkoopt op de spot, kun je de vertraging en toename van het verbruik deactiveren.","spot_wizard.heat_pump.title":"Warmtepomp","spot_wizard.info.button1":"Waarom is mijn batterij niet vanaf de spot vandaag geladen?","spot_wizard.info.button2":"Waarom is mijn batterij niet naar de spot vandaag ontladen?","spot_wizard.info.button3":"Ik heb hulp nodig bij het instellen","spot_wizard.info.help1.title":"Waarom is mijn batterij niet vanaf de spot vandaag geladen?","spot_wizard.info.help2.title":"Waarom is mijn batterij niet naar de spot vandaag ontladen?","spot_wizard.info.title":"Informatie over spot trading","spot_wizard.overflow_limit.paragraph1":"Als je alleen energie kunt kopen op de spot, kun je -10 K\u010D instellen. Overstroming is beperkt tot de maximale grootte die is ingesteld door de service technicus.","spot_wizard.overflow_limit.paragraph2":"Als je ook energie kunt verkopen op de spot, is het voordelig om de accumulatie te stoppen bij een prijs die overeenkomt met de commissie van je leverancier. De commissie is meestal 0.30 - 0.70 EUR/kWh.","spot_wizard.overflow_limit.title":"Beperking van overstroming naar het net","spot_wizard.preferential_sale.paragraph1":"Deze functie stelt terugleverprioriteit in tijdens de ochtendpiek. Energie wordt bij voorkeur aan het net verkocht in plaats van opgeslagen in de batterij, boiler en warmtepomp. Accumulatie wordt opnieuw geactiveerd bij lage prijzen of na verkoop van het geschatte energie-overschot.","spot_wizard.preferential_sale.paragraph2":"Als je alleen energie kunt kopen op de spot, kun je de functie deactiveren.","spot_wizard.preferential_sale.title":"Voordelige verkoop van energie","statistics.battery.statistics":"Niveau van de batterijlaad","statistics.boiler.statistics":"Boilerverwarming met een elektrisch verwarmingselement","statistics.electrical_grid.statistics":"Aankoop van het net","statistics.electrical_grid.statistics_house_consumption":"Verbruik van het object","statistics.electrical_grid.statistics_overflow":"Overloop naar een net","statistics.heatpump.statistics":"Compressorverbruik","statistics.outdoor_temperature.statistics":"Buitentemperatuur","statistics.photovoltaics.statistics":"Productie van fotovolta\xefsche energie","statistics.plug.statistics":"Verbruik van stopcontacten","statistics.wind.statistics":"Productie van windturbines","stats_delete.button":"Verwijderen","stats_delete.cancel":"Annuleren","stats_delete.confirm":"Verwijderen","stats_delete.confirm.title":"Wilt u echt alle statistieken verwijderen?","stats_delete.title":"Alle statistieken verwijderen","stats_export.button":"Exporteren","stats_export.from":"Van","stats_export.metric":"Meting","stats_export.title":"Statistieken exporteren","stats_export.to":"Naar","status.heatWater.flexibility":"Flexibiliteit actief, verwarming van warm water","status.heatWater.heating":"Verwarming van warm water","status.heatWater.hwError":"De boiler is volledig verwarmd of niet beschikbaar","status.heatWater.inverterError":"Voorverwarming is inactief, de omvormer is niet beschikbaar","status.heatWater.legionella":"Waterzuivering, legionella","status.heatWater.notConnected":"Kan geen verbinding tot stand brengen","status.heatWater.notLicensed":"Boilerregeling heeft geen licentie","status.heatWater.off":"Uit","status.heatWater.overload":"Overbelasting van het netwerk, verwarming gestopt","status.heatWater.pvHeating":"Verwarming door overbelasting","status.heatWater.smartMeterError":"Voorverwarming van de boiler is inactief, de elektriciteitsmeter is niet beschikbaar","status.heatWater.spotHeating":"Verwarming van warm water vanaf de plek","status.heatWater.stop":"Stop","status.heatWater.stopHDO":"Verwarming geblokkeerd bij hoge prijs","status.heatWater.stopSOC":"Verwarming geblokkeerd, laag batterijniveau","status.heatWater.stopSell":"Voorverwarming geblokkeerd, verkoop van energie","status.heatWater.tempError":"Temperatuursensor is niet beschikbaar","status.photovoltaic.dischargeBlockedByComponents":"Ontladen van batterij gepauzeerd vanwege verbruik van geselecteerde technologie\xebn","status.photovoltaic.dischargeBlockedByHDO":"Ontladen van batterij gepauzeerd, hoog tarief actief (HDO)","status.photovoltaic.discharging":"Ontladen van de batterij","status.photovoltaic.distributionLimit":"Distributie beperkt vermogen","status.photovoltaic.feedInPriority":"Prioriteit voor teruglevering aan het net","status.photovoltaic.flexibilityBatteryStop":"Flexibiliteit actief, opladen en ontladen van de batterij gestopt","status.photovoltaic.flexibilityCharging":"Flexibiliteit actief, opladen van de batterij via het netwerk","status.photovoltaic.flexibilityDischarging":"Flexibiliteit actief, ontladen van de batterij naar het netwerk","status.photovoltaic.flexibilityDoNotDischarge":"Flexibiliteit actief, verbod op ontladen van de batterij","status.photovoltaic.flexibilityFeedInPriority":"Flexibiliteit actief, prioriteit van overstroming naar het netwerk","status.photovoltaic.flexibilityOverflowRestricted":"Flexibiliteit actief, verbod op overstroming naar het netwerk","status.photovoltaic.forcedOverflow":"Flexibiliteit actief, gedwongen overstroming naar het netwerk","status.photovoltaic.idle":"Stand-by modus","status.photovoltaic.manualCharging":"Handmatig opladen van de batterij","status.photovoltaic.manualDischarging":"Handmatig ontladen van de batterij","status.photovoltaic.noOverflowLimit":"Geen overlooplimiet","status.photovoltaic.noneInverter":"Omvormertype niet ingesteld","status.photovoltaic.notConnected":"Kan geen verbinding tot stand brengen","status.photovoltaic.notLicensed":"FVE-besturing heeft geen licentie","status.photovoltaic.planCharge":"Geplande lading van de accu","status.photovoltaic.planDischarge":"Geplande ontlading van de batterij","status.photovoltaic.production":"Productie van energie","status.photovoltaic.sellBatteryEnergy":"Verkoop van energie uit de batterij","status.photovoltaic.spotCharging":"Opladen van de batterij ter plaatse","status.photovoltaic.spotStopDischarging":"Ontladen gestopt, lage prijs ter plaatse","status.photovoltaic.standby":"Stand-by modus","status.photovoltaic.startUp":"Opstartmodus","status.plug.batteryControl":"Stopcontact actief volgens batterij","status.plug.manualControl":"Aansluiting actief in handmatige modus","status.plug.notActive":"Aansluiting inactief","status.plug.notConnected":"Kan geen verbinding tot stand brengen","status.plug.overflowControl":"Aansluiting actief volgens overloop","status.plug.spotControl":"Aansluiting actief volgens spot","status.plug.stop":"Stop","status.plug.timeControl":"Aansluiting actief volgens tijdstip","status.smartMeter.consumption":"Normaal verbruik van het huis","status.smartMeter.maxLoad":"Maximaal verbruik van het huis","status.smartMeter.none":"","status.smartMeter.overflow":"Overstroom van energie naar het net","status.smartMeter.overflowLimited":"Overstroom beperkt vanwege negatieve prijs","status.smartMeter.shortage":"Tekort van het distributienetwerk","status.spotBattery.flexibilityPV":"Flexibiliteit gebruikt voor PV","status.spotBattery.flexibilitySpot":"Flexibiliteit gebruikt voor SPOT","status.spotBattery.noData":"Geen gegevens voor controle","status.spotBattery.spotNotLicensed":"Spot heeft geen vergunning","status.spotBatteryChargeFromGrid.batteryChargingNotActive":"Opladen van de batterij van het net is inactief","status.spotBatteryChargeFromGrid.batteryChargingPlanned":"Opladen van de batterij van het net is actief","status.spotBatteryChargeFromGrid.enoughPVEnergy":"Vandaag wordt verwacht dat er een overvloed is voor het opladen van de batterij","status.spotBatteryChargeFromGrid.priceDifferenceTooLow":"Vandaag is de minimale prijsverschil niet bereikt","status.spotBatteryChargeFromGrid.spotNotActive":"Spothandel is inactief","status.spotBatteryDischargeToGrid.batteryDischargingNotActive":"Batterij ontladen naar het net is inactief","status.spotBatteryDischargeToGrid.batteryDischargingPlanned":"Batterij ontladen naar het net is actief","status.spotBatteryDischargeToGrid.minPriceNotReached":"Vandaag is de minimale prijs voor verkoop niet bereikt","status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy":"Vandaag wordt verwacht dat er een tekort is aan energie voor de eigen verbruik","status.spotBatteryDischargeToGrid.spotNotActive":"Spothandel is inactief","status.spotBatteryDischargeToHome.automaticDischargeMode":"Batterij ontladen volgens capaciteit","status.spotBatteryDischargeToHome.highPriceDischargeMode":"Batterij ontladen bij hoge prijs","status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode":"Batterij ontladen bij gemiddelde en hoge prijs","status.spotBatteryDischargeToHome.notControlled":"Batterij ontladen is niet beperkt","status.spotHeatPump.flexibilityPV":"Flexibiliteit gebruikt voor PV","status.spotHeatPump.flexibilitySpot":"Flexibiliteit gebruikt voor SPOT","status.spotHeatPump.noData":"Geen gegevens voor controle","status.spotHeatPump.spotNotLicensed":"Spot heeft geen licentie","status.spotHeatWater.flexibilityPV":"Flexibiliteit gebruikt voor PV","status.spotHeatWater.flexibilitySpot":"Flexibiliteit gebruikt voor SPOT","status.spotHeatWater.noData":"Geen gegevens voor controle","status.spotHeatWater.spotNotLicensed":"Spot heeft geen licentie","status.spotSmartMeter.noData":"Geen gegevens voor controle","status.spotSmartMeter.overflowDisabled":"Permanente overloopbeperking","status.spotSmartMeter.overflowFlexibilitySell":"Optimalisatie van overloop voor verkoop","status.spotSmartMeter.overflowLimited":"Overloop beperkt vanwege negatieve prijs","status.spotSmartMeter.spotNotLicensed":"Spot heeft geen licentie","status.spotSmartMeter.withoutReduction":"Zonder beperking","status.wind.production":"Energie produceren","status.wind.stop":"STOP","status.wind.unavailable":"Niet beschikbaar","subscriptions.fetch":"Abonnement bijwerken","subscriptions.fetch.button":"Abonnement bijwerken","subscriptions.last_fetch_at":"Laatste update","subscriptions.premium_active":"Premium actief","subscriptions.title":"Abonnement","test-product.app":"Applicatie","test-product.settings":"Instellingen","test-product.settings.distribution":"Distributie","test-product.settings.distribution.Dzd":"DZD","test-product.settings.distribution.Infigy":"Infigy","test-product.settings.distribution.solid_sun":"SolidSun","test-product.settings.license":"Licentie","test-product.settings.license.HW":"HW","test-product.settings.license.Industrial":"Industrial","test-product.settings.license.Play":"PLAY","test-product.settings.license.Smart":"Smart","test-product.settings.license.basic":"Basis","test-product.test":"Apparaattest","test-product.test.DC":"Controle van het gelijkstroomcircuit","test-product.test.DC.subtitle":"Aansluiten van de aansluitingen, kabelafmetingen","test-product.test.component":"Onderdeleninspectie","test-product.test.component.subtitle":"Is er een sensor, labels, ...?","test-product.test.electricmeter":"Controle van de smartmeter","test-product.test.electricmeter.subtitle":"Controle van de installatie van de smartmeter voor de omvormer","test-product.test.internet-connect":"Internetverbinding","test-product.test.inverter-connect":"De omvormer aansluiten","test-product.test.license":"Licentie","test-product.test.license-info":"Licentie","test-product.test.phase_1":"Fase 1-test","test-product.test.phase_2":"Fase 2-test","test-product.test.phase_3":"Fase 3-test","test-product.test.serialNumber":"Serienummer van het apparaat","test-product.test.serialNumber.label":"Serienummer","test-product.test.serialNumber.subtitle":"Zonder serienummer kunnen de naam van de tester en de test niet worden ingevoerd","test-product.test.serialNumberSwitchboard":"Productienummer van de kast","test-product.test.serialNumberSwitchboard.label":"Serienummer","test-product.test.serialNumberSwitchboard.subtitle":"Invullen als het apparaat zich in de originele kast bevindt","test-product.test.start":"Als het apparaat is aangesloten","test-product.test.start.button":"Activeer de test","test-product.test.switchboard":"Controle van de conformiteit van de kast","test-product.test.switchboard.subtitle":"Controleer de aansluiting van de aansluitklemmen, de plaatsing van de componenten en de juiste kabel","test-product.test.temp":"Temperatuursensor","test-product.test.tester":"Apparaat getest door","test-product.test.tester.subtitle":"Zonder naam kan de test niet worden geactiveerd","thermostat.general":"Algemene instellingen","thermostat.general.cooling":"Koeling actief","thermostat.general.cooling.pvstability":"Potentieel van de bron","thermostat.general.heating":"Verwarming actief","thermostat.range":"Thermostaat","thermostat.range.flexibility-temperature":"Flexibele temperatuur","thermostat.range.flexibility-temperature.subtitle":"Temperatuur waarmee het huis kan worden voorverwarmd of voorgekoeld","thermostat.range.flexibility_status":"Flexibele modus van de thermostaat","thermostat.range.on":"Thermostaat actief","thermostat.range.on.subtitle":"Basistemperatuur","thermostat.range.pv-flexibility":"Regeling door fotovolta\xefsche energie","thermostat.range.set_temperature":"Ingestelde temperatuur","thermostat.range.sp-flexibility-down":"Verbruik uitstellen op basis van spotprijs","thermostat.range.sp-flexibility-up":"Verbruik verhogen volgens spotprijs","thermostat.range.status":"Flexibele modus thermostaat","thermostat.range.temperature":"Ingestelde temperatuur","thermostat.statisticsTemp":"Thermostaattemperatuur","thermostat.status":"Thermostaatmodus","wallbox.3a.on":"Modus 3A","wallbox.3a.on_sub":"Het opladen kan 3A uit het distributienetwerk halen","wallbox.6a.on":"Modus 6A","wallbox.6a.on_sub":"Alleen opladen via fotovolta\xefsche energie","wallbox.NO_CHARGE":"Niet opladen","wallbox.NO_CHARGE.on_sub":"Opladen is permanent geblokkeerd; alleen een schema kan het starten","wallbox.PV":"Opladen volgens batterij","wallbox.PV.batteryStart":"Inschakelen wanneer volledig opgeladen","wallbox.PV.batteryStart.subtitle":"Begin met opladen wanneer de batterij wordt opgeladen","wallbox.PV.batteryStop":"Uitschakelen wanneer volledig opgeladen","wallbox.PV.batteryStop.subtitle":"Stop met opladen wanneer de batterij wordt opgeladen","wallbox.PV.on":"Actief","wallbox.PV.on_sub":"Nadat de basisenergie is bereikt, wordt er alleen opgeladen wanneer de batterij volledig is opgeladen","wallbox.PV2":"Opladen volgens PV","wallbox.PV2.on":"Actief","wallbox.PV2.on_sub":"Laadcontrole op basis van PV-prestaties","wallbox.PV_FAST":"Prioriteit opladen volgens batterij","wallbox.PV_FAST.batteryMinSoc":"Minimale batterijreserve","wallbox.PV_FAST.batteryMinSoc.subtitle":"De batterij wordt voor het opladen van de auto niet onder deze waarde ontladen. Totdat deze waarde is overschreden, wacht het opladen","wallbox.PV_FAST.on_sub":"Het opladen van de auto heeft volledige prioriteit. Alleen energie van de batterij of PV wordt gebruikt","wallbox.SPOT":"Opladen op basis van spotprijzen","wallbox.SPOT.hi":"Voorkom opladen tegen hoge prijzen","wallbox.SPOT.mi":"Opladen tegen gemiddelde prijzen voorkomen","wallbox.SPOT.on":"Actief","wallbox.SPOT.on_sub":"Na het bereiken van de basisenergie zal er blokkering optreden tijdens hoge spotprijzen","wallbox.active":"{name}","wallbox.active.subtitle":"Actief","wallbox.alfen":"Alfen","wallbox.authorization.status":"Autorisatie","wallbox.authorization.status.authorized":"Geautoriseerd{cardInfo}","wallbox.authorization.status.denied":"Afgewezen{cardInfo}","wallbox.authorization.status.pending":"Niet geautoriseerd","wallbox.authorization.status.unknown":"Onbekende status","wallbox.az_router":"AZ Router","wallbox.common":"Algemene informatie","wallbox.common.power":"Huidig verbruik","wallbox.common.power_today":"Huidig verbruik","wallbox.common.power_total":"Totaal verbruik","wallbox.common.power_year":"Jaarlijks verbruik","wallbox.control":"Laadmodus","wallbox.ecovolter":"EcoVolter","wallbox.evmate":"EVmate","wallbox.fast-charge":"Snel opladen","wallbox.fast-charge.energy":"Energie voor snel opladen","wallbox.fast-charge.energy_actual":"Opgeladen energie in de huidige cyclus","wallbox.fast-charge.energy_sub":"Energie die altijd zo snel mogelijk wordt opgeladen. Nadat deze waarde is bereikt, wordt het opladen","wallbox.goodwe-ev-charger":"Goodwe","wallbox.inactive.subtitle":"Inactief","wallbox.mode.pv.batteryStopConflict.description":"Wanneer de accu blokkering is ingeschakeld bij wallbox gebruik, kan de modus \u201EAccu opladen\u201C niet worden ingeschakeld. Schakel de blokkering uit en stel een andere wallbox modus in.","wallbox.mode.pv.batteryStopConflict.title":"Modus kan niet worden ingeschakeld","wallbox.mybox":"MyBox","wallbox.none":"Geen","wallbox.nonemode":"Normaal opladen","wallbox.nonemode.amper-auto":"Automatische regeling van de laadstroom","wallbox.nonemode.amper-auto.subtitle":"Regelt het opladen om het opladen en ontladen van de batterij te minimaliseren","wallbox.nonemode.ampers":"Maximale laadstroom","wallbox.nonemode.hdo":"Alleen opladen tegen laag tarief","wallbox.nonemode.hdo_sub":"De HDO-tijden moeten worden ingesteld in de algemene instellingen","wallbox.nonemode.on":"Actief","wallbox.nonemode.on_sub":"De auto laadt zo snel mogelijk op","wallbox.olife":"Olife","wallbox.other":"Andere","wallbox.pv.ampers-auto":"Gewenste laadstroom","wallbox.schedules.description":"Plan het opladen van de elektrische auto naar behoefte.","wallbox.schedules.title":"Oplaadplanner","wallbox.settings":"Instellingen","wallbox.solax":"Solax - communicatie via omvormer","wallbox.solax-ev-charger":"Solax - communicatie via Infigy","wallbox.statistics":"Statistieken","wallbox.status":"Wallbox modus","wallbox.status.car_not_connected":"Auto niet aangesloten","wallbox.status.charging":"Opladen","wallbox.status.charging_with_ventilation":"Opladen met ventilatie","wallbox.status.error":"Fout","wallbox.status.home":"Wallbox modus","wallbox.status.normal":"Normaal","wallbox.status.not_connected":"Kan geen verbinding maken","wallbox.status.off":"Wallbox uit","wallbox.status.ready":"Klaar om op te laden","wallbox.sub_status.auto":"volgens auto. modus","wallbox.sub_status.basic_energy":"basisenergie","wallbox.sub_status.battery":"volgens batterij","wallbox.sub_status.battery_fast":"prioriteit volgens batterij","wallbox.sub_status.battery_waiting":", wacht op batterijlading","wallbox.sub_status.hdo_block":", HDO-blok","wallbox.sub_status.no_charging":", opladen is uitgeschakeld","wallbox.sub_status.none":"","wallbox.sub_status.photovoltaics":"volgens FVE","wallbox.sub_status.schedule":"volgens planner","wallbox.sub_status.spot":"volgens SPOT","wallbox.sub_status.spot_high":", hoge SPOT-prijs","wallbox.sub_status.spot_mid":", gemiddelde SPOT-prijs","wallbox.victron-ev-charger":"Victron EV-lader","wallbox.wallboxes.title":"Wallboxen","wallbox_rfid.add_button":"RFID-kaart toevoegen","wallbox_rfid.delete.cancel":"Annuleren","wallbox_rfid.delete.confirm":"Verwijderen","wallbox_rfid.delete.confirm.title":"Kaart {name} verwijderen?","wallbox_rfid.dialog.already_exists":"Kaart {id} is al opgeslagen onder de naam {name}.","wallbox_rfid.dialog.already_exists_hint":"Plaats een andere kaart of sluit het dialoogvenster.","wallbox_rfid.dialog.cancel":"Annuleren","wallbox_rfid.dialog.name_label":"Naam van de kaart","wallbox_rfid.dialog.save":"Opslaan","wallbox_rfid.dialog.scanned_id":"Kaart-ID: {id}","wallbox_rfid.dialog.title":"RFID-kaart toevoegen","wallbox_rfid.dialog.waiting":"Plaats de kaart op de lezer\u2026","wallbox_rfid.edit.dialog.title":"RFID-kaart bewerken","wallbox_wizard.cancel":"Annuleren","wallbox_wizard.custom_device_ip_address.alert":"Zorg ervoor dat het IP-adres van de wallbox niet verandert (bijvoorbeeld wanneer de wallbox een DHCP)","wallbox_wizard.custom_device_ip_address.input":"IP-adres van de wallbox","wallbox_wizard.multiple_wallboxes.alert":"Voor meerdere wallboxen, neem contact op met de supportline. Contact kan worden gevonden in de technische wiki Infigy.","wallbox_wizard.multiple_wallboxes.label":"Meerdere wallboxen","wallbox_wizard.open":"Wallbox configureren","wallbox_wizard.save":"Opslaan","wallbox_wizard.title":"Wallbox-configuratie","welcome.subtitle":"Toepassingen voor huishoudelijke en moderne energie op \xe9\xe9n plek!","welcome.title":"Welkom bij Infigy!","wifi_ap_config.interface_block.confirm.confirmation_text":"{blocked, select, true {Block} other {Unblock}}","wifi_ap_config.interface_block.confirm.content":"Wilt u echt {blocked, select, true {block} other {unblock}} wifi?","wifi_ap_config.interface_block.confirm.title":"WiFi-status wijzigen","wifi_ap_config.passphrase_change.confirm.passphrase":"Wachtwoord","wifi_ap_config.passphrase_change.confirm.title":"WiFi-wachtwoord wijzigen","wifi_ap_config.wifi_interface_blocked.button":"{blocked, select, true {Unblock} other {Block}}","wifi_ap_config.wifi_interface_blocked.title":"WiFi-status","wifi_ap_config.wifi_interface_blocked.value":"{blocked, select, true {Blocked} other {Active}}","wind.common":"Algemene informatie","wind.common.battery_charged_total":"Totaal vermogen naar batterij","wind.common.battery_current":"Batterijstroom","wind.common.battery_power":"Batterijvermogen","wind.common.battery_voltage":"Batterijspanning","wind.common.load_current":"Belastingsstroom","wind.common.power":"Huidig windvermogen","wind.common.power_today":"De productie van vandaag","wind.common.power_total":"Totale productie","wind.common.power_year":"Jaarlijkse productie","wind.common.resistor_power":"Belastingsstroom","wind.statistics":"Statistieken","wind.statistics.battery_charge_power":"Batterijvermogen","wind.statistics.load_current":"Belastingsstroom","wind.statistics.power":"Vermogen windturbine","wind.statistics.wind_speed":"Windsnelheid","wind.status":"Windturbinemodus"}');


var $01039277edda919c$exports = {};
$01039277edda919c$exports = JSON.parse('{"\\"chart.tooltip.substat.phase\\"":"F\xe1ze {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}","\\"chart.tooltip.substat.pv_string\\"":"{inverterName}, String {stringNumber}","animation.battery":"Bat\xe9ria","animation.boiler":"Bojler","animation.consumption":"Dom","animation.electrical_grid":"Sie\u0165","animation.hp":"Tepelko","animation.photovoltaics":"FVE","animation.wallbox":"Wallbox","animation.wind":"V\xedtr","app_messages.battery_max_soc":"Nabitie bat\xe9rie na nastaven\xe9 maxim\xe1lne SOC {maxSoc, number, ::.##}%","app_messages.battery_min_soc":"Vybitie bat\xe9rie na nastaven\xe9 minim\xe1lne SOC {minSoc, number, ::.##}%","app_messages.body.battery_max_soc":"Aktu\xe1lna \xfarove\u0148 nabitia bat\xe9rie je {currentSoc, number, ::.##}%.","app_messages.body.battery_min_soc":"Aktu\xe1lna \xfarove\u0148 nabitia bat\xe9rie je {currentSoc, number, ::.##}%.","app_messages.body.heat_pump_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit spotreby tepeln\xe9ho \u010Derpadla. Limit je {value, number, ::.##} kWh.","app_messages.body.heat_water_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit ohrevu vody. Limit je {value, number, ::.##} kWh.","app_messages.body.heat_water_max_temperature":"Dnes u\u017E do\u0161lo k nahriatiu bojlera na po\u017Eadovan\xfa maxim\xe1lnu teplotu {maxTemperature, number, ::.##}\xb0C.","app_messages.body.home_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit spotreby dom\xe1cnosti. Limit je {value, number, ::.##} kWh.","app_messages.body.inverter_production_mwh":"Tento rok v\xe1m va\u0161a fotovoltaick\xe1 elektr\xe1rna u\u017E vyrobila {inverterProductionValue, number, ::.##} MWh.","app_messages.body.spot_daily_prediction":"Denn\xe1 predpove\u010F: {pvPrediction, select, true {V\xfdroba elektr\xe1rne: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Be\u017En\xe1 spotreba domu: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Dispozi\u010Dn\xe1 akumul\xe1cia bat\xe9rie: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Dispozi\u010Dn\xe1 akumul\xe1cia bojleru: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {Tepeln\xe9 \u010Derpadlo je {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Zost\xe1vaj\xfaca energia na predaj prebyto\u010Dkov je {salePredictionValue, number, ::.##} kWh. } other {} }","app_messages.body.spot_daily_summary":"Dnes na spotu: {nothingToReport, select, true {Nie je ni\u010D v pl\xe1ne.} other { {energyForSale, select, true {V pl\xe1ne je rannej predaj do siete. } other {} } {negativeIntervals, select, false {} other {Z\xe1porn\xe1 cena ({negativeIntervals}), pri ktorej sa obmedz\xed pretok. } } {chargingIntervals, select, false {} other {Pl\xe1n nab\xedjania bat\xe9rie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Pl\xe1n vyb\xedjania bat\xe9rie do siete ({dischargingIntervals}). } } } }","app_messages.body.spot_negative_price_start":"Aktu\xe1lna cena na spotu je po odpo\u010D\xedtan\xed prov\xedzie z\xe1porn\xe1. Prov\xedzia nastaven\xe1 v Infigy je vo v\xfd\u0161ke {spotOffsetPrice, number, ::.##} K\u010D. Aktu\xe1lna cena spotu je {spotNegativePrice, number, ::.##} K\u010D.","app_messages.body.spot_negative_price_stop":"Aktu\xe1lna cena na spotu u\u017E nie je z\xe1porn\xe1 a je vo v\xfd\u0161ke {spotNegativePrice, number, ::.##} K\u010D. Prov\xedzia je v Infigy nastaven\xe1 vo v\xfd\u0161ke {spotOffsetPrice, number, ::.##} K\u010D","app_messages.body.wallbox_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit nab\xedjania elektromobilu. Limit je {value, number, ::.##} kWh.","app_messages.body.wallbox_stop_charging":"V tomto cykle bolo dodan\xe9 {wallboxConsumptionCycleValue, number, ::.##} kWh energie.","app_messages.button":"Smaza\u0165","app_messages.cancel":"Zru\u0161i\u0165","app_messages.confirm":"Smaza\u0165","app_messages.confirm.title":"Naozaj chcete smaza\u0165 v\u0161etky spr\xe1vy?","app_messages.detail_dialog.close":"Pre\u010D\xedtan\xe9","app_messages.heat_pump_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit spotreby tepeln\xe9ho \u010Derpadla","app_messages.heat_water_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit ohrevu vody","app_messages.heat_water_max_temperature":"Dosiahnut\xe1 po\u017Eadovan\xe1 maxim\xe1lna teplota vody","app_messages.home_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit spotreby dom\xe1cnosti","app_messages.inverter_connected":"Nadviazanie komunik\xe1cie so strieda\u010Dom","app_messages.inverter_disconnected":"Strata komunik\xe1cie so strieda\u010Dom","app_messages.inverter_production_mwh":"M\xed\u013Enik vo v\xfdrobe FVE","app_messages.load_more":"Na\u010D\xedta\u0165 viac","app_messages.no_messages":"Zatia\u013E tu nie s\xfa \u017Eiadne notifik\xe1cie","app_messages.spot_daily_prediction":"Denn\xe1 predpove\u010F","app_messages.spot_daily_summary":"Denn\xfd s\xfahrn pl\xe1nu spotu","app_messages.spot_negative_price_start":"Cena spotu je z\xe1porn\xe1","app_messages.spot_negative_price_stop":"Cena spotu u\u017E nie je z\xe1porn\xe1","app_messages.spot_start_charging_battery":"Za\u010Dalo nab\xedjanie bat\xe9rie pod\u013Ea spotovej ceny","app_messages.spot_start_discharging_battery":"Za\u010Dalo vyb\xedjanie bat\xe9rie do siete pod\u013Ea spotovej ceny","app_messages.spot_stop_charging_battery":"Nab\xedjanie bat\xe9rie pod\u013Ea spotovej ceny bolo ukon\u010Den\xe9","app_messages.spot_stop_discharging_battery":"Vyb\xedjanie bat\xe9rie do siete pod\u013Ea spotovej ceny bolo ukon\u010Den\xe9","app_messages.test":"Testovacia notifik\xe1cia","app_messages.title":"Smaza\u0165 v\u0161etky spr\xe1vy","app_messages.utility_loss_start":"Zaznamenali sme v\xfdpadok distribu\u010Dnej siete","app_messages.utility_loss_stop":"V\xfdpadok distribu\u010Dnej siete bol odstr\xe1nen\xfd","app_messages.wallbox_limit_exceeded":"Bol prekro\u010Den\xfd dne\u0161n\xfd limit nab\xedjania elektromobilu","app_messages.wallbox_start_charging":"Za\u010Dalo nab\xedjania elektromobilu","app_messages.wallbox_stop_charging":"Nab\xedjanie elektromobilu bolo ukon\u010Den\xe9","app_update_overlay.subtitle":"Pros\xedm vy\u010Dkajte. Po dokon\u010Den\xed aktualiz\xe1cie sa aplik\xe1cia re\u0161tartuje a okno v prehliada\u010Di sa automaticky obnov\xed","app_update_overlay.title":"Aktualiz\xe1cia prebieha","audit_log.error":"Chyba pri na\u010D\xedtavan\xed","audit_log.item.author":"Autor","audit_log.item.date":"D\xe1tum","audit_log.item.payload":"Udalos\u0165","audit_log.item.type":"Typ","audit_log.title":"Audit Log","audit_log_delete.button":"Smaza\u0165","audit_log_delete.cancel":"Zru\u0161i\u0165","audit_log_delete.confirm":"Smaza\u0165","audit_log_delete.confirm.title":"Naozaj chcete smazat v\u0161etky z\xe1znamy v audit logu?","audit_log_delete.title":"Smaza\u0165 audit log","azRouters.add":"Pridajte nov\xfd AZ router","azRouters.addButton":"Pridajte","azRouters.clientId":"Modbus ID:","azRouters.clientId.value":"Modbus ID: {id}.","azRouters.counts":"OK {ok} / Chyba {err}","azRouters.empty":"Nejsou nakonfigurov\xe1ny \u017Eiadne AZ routery.","azRouters.name":"N\xe1zov","azRouters.status.error":"Chyba","azRouters.status.ok":"OK","azRouters.status.starting":"Sp\xfa\u0161\u0165a sa","azRouters.title":"AZ routery","bez_dodavatele.business_flexibility.title":"Obchodn\xe1 flexibilita","bez_dodavatele.enabled":"Integr\xe1cia zapnut\xe1","bez_dodavatele.region":"K\xf3d kraja","bez_dodavatele.title":"bezDodavatele","boiler.blocking":"Blok\xe1cia ohrevu","boiler.common":"V\u0161eobecn\xe9 inform\xe1cie","boiler.common.phase_3":"F\xe1ze 3:","boiler.common.power":"Aktu\xe1lny odber","boiler.common.power.phase_1":"F\xe1ze 1:","boiler.common.power.phase_2":"F\xe1ze 2:","boiler.common.power_today":"Dne\u0161n\xe1 spotreba:","boiler.common.power_year":"Ro\u010Dn\xe1 spotreba:","boiler.common.temperature":"Aktu\xe1lna teplota","boiler.common.total":"Celkov\xe1 spotreba","boiler.settings":"Nastavenie","boiler.settings.hdo":"Riadenie be\u017En\xe9ho ohrevu pod\u013Ea HDO \u010Dias","boiler.settings.hdo.subtitle":"\u010Casy pre HDO musia by\u0165 nastaven\xe9 v v\u0161eobecnom nastaven\xed","boiler.settings.min_soc":"Blok\xe1cia ohrevu pri v\xfdpadku siete","boiler.settings.min_soc.subtitle":"Nabitie bat\xe9rie, od ktor\xe9ho d\xf4jde k blok\xe1cii ohrevu pri v\xfdpadku siete","boiler.settings.min_soc_utility":"Blok\xe1cia ohrevu pri dostupnej sieti","boiler.settings.min_soc_utility.subtitle":"Nabitie bat\xe9rie, od ktor\xe9ho d\xf4jde k blok\xe1cii ohrevu","boiler.settings.spot-hi":"Blokova\u0165 ohrev pri vysokej cene spotu","boiler.settings.spot-mi":"Blokova\u0165 ohrev pri strednej cene spotu","boiler.settings.temp":"Nastaven\xe1 teplota","boiler.settings.temp.subtitle":"Be\u017En\xe1 teplota, ktor\xe1 je k dispoz\xedcii v\u017Edy","boiler.settings.temp_ek":"Teplota z FVE pomocou EK","boiler.settings.temp_ek.subtitle":"Predohrievac\xeda teplota, ktor\xe1 je len z prebyto\u010Dkov","boiler.settings.temp_spot":"Teplota zo spotu pomocou EK","boiler.settings.temp_spot.subtitle":"Predohrievac\xeda teplota, ktor\xe1 je len z n\xedzkej ceny","boiler.statistics":"V\xfdkon bojlera","boiler.statisticsTemp":"Teplota bojlera","boiler.status":"Re\u017Eim bojlera","boiler.status.home":"Re\u017Eim bojlera","boiler_test_trigger.button":"Otestova\u0165 bojler","boiler_test_trigger.button.running":"Test prebieha","boiler_test_trigger.subtitle":"Over\xed spr\xe1vne zapojenie a zadan\xfd v\xfdkon patrony bojlera.","boiler_test_trigger.title":"Testovanie bojlera","boiler_test_wizard.acknowledge.condition":"Pre spr\xe1vny test bojlera je nutn\xe9, aby bol spotreba v objekte kon\u0161tantn\xfd a alebo nulov\xfd. Ak\xe9ko\u013Evek v\xfdkyvy vo spotrebe m\xf4\u017Eu test ovplyvni\u0165. Aktu\xe1lny spotreba objektu je {power}","boiler_test_wizard.acknowledge.config":"Aktu\xe1lne je nastaven {phaseLabel} bojler o celkov\xe9 v\xfdkonu {power}. Tieto hodnoty musia by\u0165 zadan\xe9 dle \u0161t\xedtku patrony.","boiler_test_wizard.acknowledge.confirm":"Potvrdi\u0165","boiler_test_wizard.acknowledge.phase1":"1-f\xe1zov\xfd","boiler_test_wizard.acknowledge.phase3":"3-f\xe1zov\xfd","boiler_test_wizard.acknowledge.phase_option":"{phase}. f\xe1za","boiler_test_wizard.acknowledge.phase_select":"Vyberte f\xe1zy, ktor\xe9 sa maj\xfa otestova\u0165. Neozna\u010Den\xe9 f\xe1zy bud\xfa presko\u010Den\xe9.","boiler_test_wizard.acknowledge.phase_select_empty":"Vyberte aspo\u0148 jednu f\xe1zu.","boiler_test_wizard.acknowledge.start":"Otestova\u0165 bojler","boiler_test_wizard.acknowledge.title":"Inform\xe1cie k testu","boiler_test_wizard.result.after":"Spotreba objektu po aktiv\xe1cii","boiler_test_wizard.result.before":"Spotreba objektu pred aktiv\xe1ciou","boiler_test_wizard.result.close":"Zavrie\u0165","boiler_test_wizard.result.correct":"Spotreba bojlera je spr\xe1vna","boiler_test_wizard.result.detail_toggle":"Podrobn\xfd test","boiler_test_wizard.result.header":"V\xfdsledok testu:","boiler_test_wizard.result.phase_header":"{phase}. f\xe1ze","boiler_test_wizard.result.real_power":"Odhadovan\xfd v\xfdkon bojlera","boiler_test_wizard.result.rerun":"Spusti\u0165 test znova","boiler_test_wizard.result.set_power":"Zadan\xfd v\xfdkon","boiler_test_wizard.result.stable":"Merenie bolo stabiln\xe9","boiler_test_wizard.result.title":"V\xfdsledok testu","boiler_test_wizard.running.activate":"Aktiv\xe1cia f\xe1ze bojlera","boiler_test_wizard.running.after":"Spotreba objektu je {power}","boiler_test_wizard.running.before":"Spotreba objektu pred testom je {power}","boiler_test_wizard.running.measuring":"Prebieha meranie\u2026","boiler_test_wizard.running.phase":"Testujeme f\xe1zu {phase}","boiler_test_wizard.running.real_power":"Odhadovan\xfd v\xfdkon bojlera je {power}","boiler_test_wizard.running.remaining":"Zost\xe1va pribli\u017Ene {seconds} s","boiler_test_wizard.running.reset":"Nulovanie spotreby","boiler_test_wizard.running.result_fail":"Test f\xe1zy nie je spr\xe1vny","boiler_test_wizard.running.result_ok":"Test f\xe1zy je spr\xe1vny","boiler_test_wizard.running.stable":"Spotreba je stabiln\xe1","boiler_test_wizard.running.title":"Prebieha test","boiler_test_wizard.running.unstable":"Merenie nebolo stabiln\xe9","boiler_test_wizard.title":"Testovanie bojlera","cancel":"Zru\u0161i\u0165","chart.range.this_week":"Minul\xfd t\xfd\u017Ede\u0148","chart.range.today":"Posledn\xfdch 24{nbsp}hodin","chart.tooltip.active_condition.title":"Aktu\xe1lny re\u017Eim:","chart.tooltip.active_condition.value.battery":"Bat\xe9ria","chart.tooltip.active_condition.value.compressor-blocked":"Blok\xe1cia kompresora, n\xedzky stav bat\xe9rie","chart.tooltip.active_condition.value.cooling":"Chladenie","chart.tooltip.active_condition.value.error":"Chyba","chart.tooltip.active_condition.value.heating":"Vykurovanie","chart.tooltip.active_condition.value.hot-water":"Ohrev teplej vody","chart.tooltip.active_condition.value.inactive":"Neakt\xedvny","chart.tooltip.active_condition.value.manual":"Manu\xe1lny","chart.tooltip.active_condition.value.not-connected":"Nemo\u017Eno nadviaza\u0165 spojenie","chart.tooltip.active_condition.value.not-licensed":"Nie je licencovan\xe9","chart.tooltip.active_condition.value.off":"Vypnut\xe9","chart.tooltip.active_condition.value.overflow":"Pretok","chart.tooltip.active_condition.value.pool":"Ohrev baz\xe9na","chart.tooltip.active_condition.value.spot":"Spot","chart.tooltip.active_condition.value.time":"\u010Casov\xfd","chart.tooltip.control_mode.title":"Riaden\xe9 pod\u013Ea:","chart.tooltip.control_mode.value":"{mode, select, photovoltaic {Fotovoltaika} grid {Distribu\u010Dn\xe1 sie\u0165} spot {Spot} flexibility {Flexibilita} error {Chyba} other {{mode}} }","chart.tooltip.wallbox_authorization_card_id.title":"Autoriza\u010Dn\xe1 karta:","charts.error.dialog.title":"Pri na\u010D\xedtavan\xed \u0161tatist\xedk do\u0161lo k chybe","charts.mode.day":"Den","charts.mode.week":"T\xfdden","charts.mode.year":"Rok","charts.summary.value":"Celkom {value}","close":"Zavrie\u0165","cloud_plugs.bat":"Riadenie pod\u013Ea bat\xe9rie","cloud_plugs.battery.battery_start":"Zapn\xfa\u0165 pri nabit\xed","cloud_plugs.battery.battery_start.subtitle":"Nabitie bat\xe9rie, pri ktorom sa aktivuje z\xe1suvka","cloud_plugs.battery.battery_stop":"Vypn\xfa\u0165 pri nabit\xed","cloud_plugs.battery.battery_stop.subtitle":"Nabitie bat\xe9rie, pri ktorom sa vypne z\xe1suvka","cloud_plugs.battery.on":"Aktivn\xed","cloud_plugs.battery_charged":"Nabitie bat\xe9rie","cloud_plugs.condition":"Podm\xednka","cloud_plugs.condition.and":"A","cloud_plugs.condition.or":"Nebo","cloud_plugs.led_mode.battery.subtitle":"Podsvieten\xe9 akt\xedvne, ak m\xe1 bat\xe9ria aspo\u0148 95%","cloud_plugs.led_mode.battery.switch.title":"Podsvieten\xe9 pri sepnutej z\xe1suvke","cloud_plugs.led_mode.battery.title":"Podsvieten\xe9 pri nabitej bat\xe9rii","cloud_plugs.led_mode.mode":"{mode, select, unknown {---} off {Vypnut\xe9} switch {} power {Pod\u013Ea pr\xedkonu} other {Nezn\xe1my}}","cloud_plugs.led_mode.overflow.subtitle":"Podsvieten\xe9 akt\xedvne, ak d\xf4jde k stabiln\xe9mu pretoku","cloud_plugs.led_mode.overflow.title":"Podsvieten\xe9 pri pretoku","cloud_plugs.led_mode.switch.subtitle":"Podsvieten\xe9 akt\xedvne, ak je z\xe1suvka sepnut\xe1","cloud_plugs.led_mode.title":"LED signaliz\xe1cia","cloud_plugs.list.id":"ID","cloud_plugs.list.led_mode":"LED signaliz\xe1cia","cloud_plugs.list.online":"Online","cloud_plugs.list.relay":"Rel\xe9","cloud_plugs.list.title":"Status","cloud_plugs.overflow":"Riadenie pod\u013Ea pretoku","cloud_plugs.overflow.help":"Zap\xednanie z\xe1suvky pri definovanom pretoku do distribu\u010Dnej siete.","cloud_plugs.overflow.on":"Akt\xedvny","cloud_plugs.overflow.startPower":"Zapn\xfa\u0165 pri odbore zo siete","cloud_plugs.overflow.startPower.help":"Z\xe1suvka sa zapne, ak je pretok v nastavenej v\xfd\u0161ke po definovan\xfd interval oneskorenie. Ak je hodnota nastaven\xe1 na - 1500W a oneskorenie zapnut\xed je 5 minut, tak z\xe1suvka sepne pri pretoku do siete vo v\xfd\u0161ke alespo\u0148 1500W po dobu 5 minut.","cloud_plugs.overflow.startPower.subtitle":"Z\xe1porn\xe1 hodnota je pretok, kladn\xe1 hodnota je odber","cloud_plugs.overflow.stopPower":"Vypn\xfa\u0165 pri odberu zo siete","cloud_plugs.overflow.stopPower.help":"Z\xe1suvka sa vypne, ak je odber vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval oneskorenie. Ak je hodnota nastaven\xe1 na 100W a oneskorenie vypnut\xed je 5 minut, tak z\xe1suvka vypne pri odberu zo siete vo v\xfd\u0161ke minim\xe1lne 100W po dobu 5 minut.","cloud_plugs.overflow.stopPower.subtitle":"Z\xe1porn\xe1 hodnota je pretok, kladn\xe1 hodnota je odber","cloud_plugs.pv_power":"Riadenie pod\u013Ea v\xfdkonu FVE","cloud_plugs.pv_power.help":"Zap\xednanie z\xe1suvky pri definovanom v\xfdkone FVE.","cloud_plugs.pv_power.on":"Akt\xedvny","cloud_plugs.pv_power.startPower":"Zapn\xfa\u0165 pri v\xfdrobe FVE","cloud_plugs.pv_power.startPower.help":"Z\xe1suvka sa zapne, ak je v\xfdkon FVE v\xe4\u010D\u0161\xed ne\u017E nastaven\xe1 hodnota. Ak je hodnota nastaven\xe1 na 1000W, tak z\xe1suvka sepne pri v\xfdrobe FVE vo v\xfd\u0161ke alespo\u0148 1000W.","cloud_plugs.pv_power.stopPower":"Vypn\xfa\u0165 pri v\xfdrobe FVE","cloud_plugs.pv_power.stopPower.help":"Z\xe1suvka sa vypne, ak je v\xfdkon FVE men\u0161\xed ne\u017E nastaven\xe1 hodnota. Ak je hodnota nastaven\xe1 na 500W, tak z\xe1suvka vypne pri v\xfdrobe FVE ni\u017E\u0161ie ne\u017E 500W.","cloud_plugs.time":"Riadenie pod\u013Ea \u010Dasu","cloud_plugs.time.on":"Aktivn\xed","cloud_plugs.title":"Z\xe1suvky","cloud_plugs.turn_off":"Vypn\xfa\u0165","cloud_plugs.turn_on":"Zapn\xfa\u0165","dark_mode.dark":"Tmav\xfd","dark_mode.light":"Svetl\xfd","dark_mode.system":"Syst\xe9m","delta_green.battery_max_power_in":"Maxim\xe1lny v\xfdkon bat\xe9rie IN (W)","delta_green.battery_max_power_out":"Maxim\xe1lny v\xfdkon bat\xe9rie OUT (W)","delta_green.business_flexibility.title":"Obchodn\xe1 flexibilita","delta_green.connected":"Stav","delta_green.enabled":"Integr\xe1cia zapnut\xe1","delta_green.last_messages":"Posledn\xe9 spr\xe1vy","delta_green.last_messages.date":"\u010Cas","delta_green.last_messages.payload":"Spr\xe1va","delta_green.last_messages.topic":"Topic","delta_green.pv_orientation":"Orientace fotovoltaiky","delta_green.title":"Delta Green","des_battery_container.status.error":"Chyba","des_battery_container.status.none":"Nezn\xe1my stav","des_battery_container.status.off":"Vypnut\xe9","des_battery_container.status.run":"Be\u017En\xfd re\u017Eim","des_battery_container.status.sleep":"Re\u017Eim sp\xe1nku","dev.cloud_plugs.mqtt_cloud.connected":"Stav MQTT Cloud pripojenia","dev.cloud_plugs.title":"Cloudov\xe9 z\xe1suvky","dev.inverter_config.connection.lan":"LAN","dev.inverter_config.connection.rs485":"RS485","dev.inverter_config.connection.rs485_hint":"Adresa a port sa preberaj\xfa z dosky ({host}:{port}).","dev.inverter_config.rename_warning":"Premenovanie k\u013E\xfa\u010Da z \\"{from}\\" na \\"{to}\\" osirie historick\xe9 d\xe1ta \u2014 \u0161tatistiky aj na\u010D\xedtavan\xfa vyroben\xfa energiu, ktor\xe9 s\xfa veden\xe9 pod p\xf4vodn\xfdm k\u013E\xfa\u010Dom.","dev.inverter_config.search.open":"Vyh\u013Eada\u0165 strieda\u010D","dev.inverter_config.search.title":"Vyh\u013Eada\u0165 strieda\u010D","dev.inverter_config.stats.all":"V\u0161etko","dev.inverter_config.status.counts":"OK {ok} / Ch\xfdb {err}","dev.inverter_config.status.error":"Chyba","dev.inverter_config.status.ok":"OK","dev.inverter_config.status.starting":"Sp\xfa\u0161\u0165a sa","dev.inverter_config.title":"Konfigur\xe1cia strieda\u010Dov","dev.link":"Dev","dev_app_messages.test_send":"Testovacia notifik\xe1cia","dev_app_messages.test_send.button":"Odosla\u0165","dev_homepage.app_messages.title":"Notifikace","dev_homepage.title":"V\xfdvojov\xe9 menu","dev_status_log.empty":"Zatia\u013E \u017Eiadne d\xe1ta","dev_status_log.error":"Chyba pri na\u010D\xedtan\xed","dev_status_log.title":"Status log","dev_status_log.today":"Dnes","dhcp_host.address":"IP adresa","dhcp_host.create.title":"Nov\xfd DHCP host","dhcp_host.edit.title":"Upravi\u0165 DHCP host","dhcp_host.mac":"MAC adresa","dhcp_host.name":"N\xe1zov","dhcp_hosts.remove.cancel":"Zru\u0161i\u0165","dhcp_hosts.remove.confirm":"Smaza\u0165","dhcp_hosts.remove.confirm.title":"Naozaj chcete odfixovat adresu DHCP hosta?","dhcp_leases.ip":"IP adresa","dhcp_leases.mac":"MAC adresa","dhcp_leases.make_static.cancel":"Zru\u0161i\u0165","dhcp_leases.make_static.confirm":"Prida\u0165","dhcp_leases.make_static.confirm.title":"Naozaj chcete zafixovat adresu DHCP hosta?","dhcp_leases.name":"Meno","dhcp_leases.next_renewal":"\u010Eal\u0161ie obnovenie","dhcp_leases.title":"DHCP Leases","ean":"EAN","electree.business_flexibility.title":"Obchodn\xe1 flexibilita","electree.connected":"Stav pripojenia","electree.enabled":"Integr\xe1cia zapnut\xe1","electree.last_messages":"Posledn\xe9 spr\xe1vy","electree.last_messages.date":"\u010Cas spr\xe1vy","electree.last_messages.payload":"Spr\xe1va","electree.last_messages.topic":"T\xe9ma","electree.title":"Electree","electrical_grid.common":"V\u0161eobecn\xe9 inform\xe1cie","electrical_grid.common.overflow":"Celkov\xfd pretok do siete","electrical_grid.common.overflow_today":"Dne\u0161n\xfd pretok do siete:","electrical_grid.common.overflow_year":"Ro\u010Dn\xfd pretok do siete:","electrical_grid.common.power":"Aktu\xe1lny odber","electrical_grid.common.power.phase_1":"F\xe1ze 1:","electrical_grid.common.power.phase_2":"F\xe1ze 2:","electrical_grid.common.power.phase_3":"F\xe1ze 3:","electrical_grid.common.power_today":"Dne\u0161n\xfd odber zo siete:","electrical_grid.common.power_year":"Ro\u010Dn\xfd odber zo siete:","electrical_grid.common.total_consumption":"Celkov\xfd odber zo siete","electrical_grid.statistics":"\u0160tatistiky n\xe1kupu","electrical_grid.statistics_overflow":"\u0160tatistiky pretoku","electrical_grid.status":"Stav distribu\u010Dnej siete","ems.activePower":"\u010Cinn\xfd v\xfdkon","ems.apparentPower":"Zdanliv\xfd v\xfdkon","ems.details":"Parametre meni\u010Da","ems.inverter":"Meni\u010D","ems.inverter.mode.backup":"Backup","ems.inverter.mode.feedIn":"Feed-in","ems.inverter.mode.manual":"Manual","ems.inverter.mode.peakShaving":"Peak Shaving","ems.inverter.mode.selfUse":"Self use","ems.inverter.name":"N\xe1zov strieda\u010Da","ems.inverter.name.aelio":"X3-AELIO","ems.inverter.name.notConnected":"Nepripojen\xe9","ems.inverter.name.trene100k":"X3-TRENE-100K","ems.inverter.name.trene100ki":"X3-TRENE-100KI","ems.inverter.name.trene125k":"X3-TRENE-125K","ems.inverter.name.unknown":"Nezn\xe1my model","ems.mode":"Re\u017Eim EMS","ems.power.index":"V\xfdkon string {index}","ems.power.total":"Celkov\xfd v\xfdkon","ems.powerFactor":"\xda\u010Din\xedk","ems.reactivePower":"Jalov\xfd v\xfdkon","emsPro.inverter.name.aelio":"X3-AELIO","emsPro.inverter.name.notConnected":"Nepripojen\xe9","emsPro.inverter.name.trene1":"X3-TRENE-1","emsPro.inverter.name.trene100k":"X3-TRENE-100K","emsPro.inverter.name.trene125k":"X3-TRENE-125K","emsPro.inverter.name.x3forth":"X3-FORTH","emsPro.inverter.name.x3forthplus":"X3-FORTH+","emsPro.inverter.name.x3grand":"X3-GRAND","emsPro.inverter.name.x3mgag2":"X3-MGA G2","emsPro.inverter.name.x3prog2":"X3-PRO G2","emsService.basicSettings":"Z\xe1kladn\xe9 nastavenia","emsService.direction.disabled":"Zak\xe1zan\xe9","emsService.direction.read":"\u010C\xedtanie","emsService.direction.write":"Z\xe1pis","emsService.distributionMetrics":"Distribu\u010Dn\xe9 pokyny","emsService.distributionMetrics.diMapping":"Mapovanie vstupov","emsService.distributionMetrics.enabled":"Povolen\xe9 \u010D\xedtanie distribu\u010Dn\xfdch pokynov","emsService.distributionMetrics.source":"Zdroj distribu\u010Dn\xfdch pokynov","emsService.distributionMetrics.source.digitalInputs":"Digit\xe1lne vstupy","emsService.distributionMetrics.source.plc":"Extern\xe9 PLC","emsService.enabled":"PLC povolen\xfd","emsService.energyMeters":"Elektromery","emsService.energyMeters.add":"Prida\u0165 nov\xfd elektromer","emsService.energyMeters.addButton":"Prida\u0165","emsService.energyMeters.azRouter":"AZ router","emsService.energyMeters.azRouter.empty":"\u017Diadne AZ routery","emsService.energyMeters.empty":"Nie s\xfa nakonfigurovan\xe9 \u017Eiadne elektromery.","emsService.energyMeters.newMeter":"N\xe1zov","emsService.energyMeters.plcMetric":"PLC metrika","emsService.energyMeters.plcMetric.grid":"Sie\u0165","emsService.energyMeters.plcMetric.kgj":"KGJ","emsService.energyMeters.plcMetric.pv":"FVE","emsService.energyMeters.shellyId":"Shelly ID","emsService.energyMeters.source":"Zdroj","emsService.energyMeters.source.azRouter":"AZ router","emsService.energyMeters.source.plc":"PLC","emsService.energyMeters.source.shelly":"Shelly","emsService.gridMetrics":"Sie\u0165ov\xe9 metriky","emsService.gridMetrics.enabled":"Povolen\xe9 \u010D\xedtanie p\xe4ty objektu","emsService.ipAddress":"IP adresa","emsService.kgjMetrics":"Metriky KGJ","emsService.kgjMetrics.enabled":"Povolen\xe9 \u010D\xedtanie z KGJ","emsService.metricsDirection":"Smer","emsService.metricsEnabled":"Povolen\xe9","emsService.mqttBroker":"MQTT Broker (Shellies)","emsService.mqttBrokerEnabled":"MQTT Broker povolen\xfd","emsService.mqttBrokerStatus":"Stav MQTT Brokeru","emsService.notAvailable":"Funkcia EMS nie je dostupn\xe1","emsService.password":"Heslo","emsService.plcStatus":"Stav PLC komunik\xe1cie","emsService.pollInterval":"Interval dotazovania (ms)","emsService.pvMetrics":"PV metriky","emsService.pvMetrics.enabled":"Povolen\xe9 \u010D\xedtanie z FVE","emsService.pvMetrics.meterId":"Elektromer","emsService.pvMetrics.meterSource":"Zdroj d\xe1t","emsService.pvMetrics.meterSource.meter":"Elektromer","emsService.pvMetrics.meterSource.plc":"PLC","emsService.shelliesList":"Pripojen\xe9 Shelly zariadenia","emsService.username":"Pou\u017E\xedvate\u013Esk\xe9 meno","ems_service.link":"EMS slu\u017Eba","ems_service.title":"EMS slu\u017Eba","enerco.ean":"EAN","enerco.enabled":"Integr\xe1cia zapnut\xe1","enerco.prediction.disabled":"Integr\xe1cia je vypnut\xe1.","enerco.prediction.title":"Predikcia","enerco.title":"Enerco","energomachine.business_flexibility.title":"Obchodn\xe1 flexibilita","energomachine.connected":"Stav","energomachine.enabled":"Integr\xe1cia zapnut\xe1","energomachine.last_messages":"Posledn\xe9 spr\xe1vy","energomachine.last_messages.date":"\u010Cas","energomachine.last_messages.payload":"Zpr\xe1va","energomachine.last_messages.topic":"Topic","energomachine.title":"Energomachine","energyMeters.actualPower":"Aktu\xe1lny v\xfdkon","energyMeters.general":"Obecn\xe9 inform\xe1cie","energyMeters.meter":"Elektromer","energyMeters.notConfigured":"Elektromery nie s\xfa nakonfigurovan\xe9. Pre nastavenie prejdite do servisn\xe9ho menu.","energyMeters.phase1":"F\xe1za 1:","energyMeters.phase2":"F\xe1za 2:","energyMeters.phase3":"F\xe1za 3:","energyMeters.statistics":"\u0160tatistiky","energyMeters.todayEnergy":"Dne\u0161n\xfd odber:","energyMeters.totalEnergy":"Celkov\xfd odber","energyMeters.yearEnergy":"Ro\u010Dn\xfd odber:","error":"Chyba pri na\u010D\xedtavan\xed reportu.","expertService.HP":"Tepeln\xe9 \u010Derpadlo","expertService.HP.CntComErr":"Po\u010D\xedtadlo chybn\xfdch spr\xe1v","expertService.HP.CntComOk":"Po\u010D\xedtadlo platn\xfdch spr\xe1v","expertService.HP.IpAdr":"IP adresa tepeln\xe9ho \u010Derpadla","expertService.HP.maxTempHW":"Maxim\xe1lna teplota teplej vody pre T\u010C","expertService.HP.maxTempHW.subtitle":"S\xfa\u010Det flexibilnej + nastavenej teploty","expertService.HW":"Bojler","expertService.HW.HwBatteryPriority":"Percento nabitia, od ktor\xe9ho m\xe1 v\u017Edy prioritu bojler","expertService.HW.HwErrEnabled":"Vyhodnocova\u0165 dostupnos\u0165 bojlera","expertService.HW.HwResetErrorTime":"Oneskorenie pre reset chyby termostatu","expertService.HW.HwResetErrorTime.subtitle":"\u010Cas v min\xfatach, po ktorom sa chyba termostatu resetuje a op\xe4\u0165 sa spust\xed ohrev vody","expertService.HW.LegionellaLastTime":"Posledn\xe9 dosiahnutie teploty legionely","expertService.HW.TempId":"ID teplotn\xe9ho \u010Didla","expertService.HW.control":"Typ riadenia bojlera","expertService.HW.control.onoff":"On/Off","expertService.HW.control.proportional":"Plynul\xe9","expertService.HW.hysterezis":"Hystereza bojlera","expertService.HW.hysterezis.subtitle":"Hystereza je len pre be\u017En\xfd ohrev","expertService.HW.maxPower":"Maxim\xe1lny v\xfdkon bojlera v percent\xe1ch","expertService.HW.maxPower.subtitle":"Toto nastavenie je len pre pln\xe9 riadenie bojlera a obmedzuje maxim\xe1lny v\xfdkon hornej panelky v percent\xe1ch.","expertService.HW.offset":"Offset na f\xe1zu [W]","expertService.HW.offset.disabled-overflow":"Offset pre riadenie bojlera so zak\xe1zan\xfdm pretokom na f\xe1zu [W]","expertService.HW.offset.disabled-overflow.subtitle":"Vy\u0161\u0161ie \u010D\xedslo umo\u017En\xed bojleru odobera\u0165 viac energie zo siete pri obmedzenom strieda\u010Di","expertService.HW.offset.enabled-overflow":"Offset pre riadenie bojlera s povolen\xfdm pretokom na f\xe1zu [W]","expertService.HW.offset.enabled-overflow.subtitle":"Vy\u0161\u0161ie \u010D\xedslo umo\u017En\xed bojleru odobera\u0165 viac energie zo siete.","expertService.HW.offset.ongrid":"Offset pre riadenie bojlera pre sie\u0165ov\xe9 elektr\xe1rne [W]","expertService.HW.offset.ongrid.subtitle":"Vy\u0161\u0161ie \u010D\xedslo umo\u017En\xed bojleru odobera\u0165 viac energie zo siete.","expertService.PV":"Fotovoltaika","expertService.PV.BatteryPowerPercent":"V\xfdkon nab\xedjania bat\xe9rie v percent\xe1ch","expertService.PV.CntComErr":"Po\u010D\xedtadlo chybn\xfdch spr\xe1v","expertService.PV.CntComOk":"Po\u010D\xedtadlo platn\xfdch spr\xe1v","expertService.PV.ControlMeteringMode":"Sp\xf4sob riadenia prebytkov","expertService.PV.ControlMeteringMode.perPhase":"F\xe1zov\xe9","expertService.PV.ControlMeteringMode.subtitle":"F\xe1zov\xe9 riadenie po\u010D\xedta prebytok pre riadenie technol\xf3gi\xed z jednotliv\xfdch f\xe1z. S\xfa\u010Dtov\xe9 riadenie pracuje so s\xfa\u010Dtom v\u0161etk\xfdch f\xe1z.","expertService.PV.ControlMeteringMode.sum":"S\xfa\u010Dtov\xe9","expertService.PV.ExternalPv":"Extern\xe1 FVE pripojen\xe1 cez SOLAX Meter 2","expertService.PV.ExternalPvSofar":"Extern\xe1 FVE pripojen\xe1 cez SOFAR Meter 2","expertService.PV.IpAdr":"IP adresa strieda\u010Da","expertService.PV.MeteringMode":"Sp\xf4sob merania distrib\xfacie","expertService.PV.MeteringMode.perPhase":"F\xe1zov\xe9","expertService.PV.MeteringMode.subtitle":"F\xe1zov\xe9 meranie po\u010D\xedta n\xe1kup aj pretok na ka\u017Edej f\xe1ze zvl\xe1\u0161\u0165. S\xfa\u010Dtov\xe9 meranie pracuje s v\xfdslednou bilanciou v\u0161etk\xfdch f\xe1z.","expertService.PV.MeteringMode.sum":"S\xfa\u010Dtov\xe9","expertService.PV.PowerControlType":"Typ riadenia v\xfdkonu sie\u0165ov\xfdch strieda\u010Dov","expertService.PV.PowerControlType.fixed":"Fixn\xe9","expertService.PV.PowerControlType.proportional":"Plynul\xe9","expertService.PV.StringNumber":"Po\u010Det stringov strieda\u010Da","expertService.PV.StringNumber.subtitle":"Po\u010Det stringov strieda\u010Da zobrazovan\xfd v aplik\xe1cii na z\xe1lo\u017Eke FVE","expertService.PV.Versions":"Verzia","expertService.SP":"Spot","expertService.SP.HwCoefficient":"Koeficient odhadu energie do bojlera","expertService.SP.HwCoefficient.subtitle":"Koeficient odhadu mno\u017Estva energie na nabitie bojlera.","expertService.SP.batteryCoefficient":"Koeficient odhadu \u010Dasu nab\xedjania bat\xe9rie","expertService.SP.batteryCoefficient.subtitle":"Koeficient odhadu \u010Dasu na nabitie bat\xe9rie","expertService.SP.minDifferenceBatterychargeFromGrid":"Minim\xe1lne odhadovan\xe9 zv\xfd\u0161enie SOC pre vy\u010Dk\xe1vanie bat\xe9rie na FVE","expertService.SP.minDifferenceBatterychargeFromGrid.subtitle":"Ak je odhad nabitia bat\xe9rie pod touto hodnotou, m\xf4\u017Ee d\xf4js\u0165 k nabitiu bat\xe9rie zo siete.","expertService.WB":"Wallbox","expertService.WB.CntComErr":"Po\u010D\xedtadlo chybn\xfdch spr\xe1v","expertService.WB.CntComOk":"Po\u010D\xedtadlo platn\xfdch spr\xe1v","expertService.WB.IpAdr":"IP adresa wallboxu","expertService.general":"Obecn\xe9 nastavenie","expertService.general.largeInstallation":"Ve\u013Ek\xe1 instal\xe1cia","expertService.general.largeInstallation.subtitle":"Roz\u0161\xedri rozsahy hodn\xf4t pre ve\u013Ek\xe9 instal\xe1cie","expertService.password":"Pr\xedstup do servisu","expertService.password.label":"Heslo","expert_service.app_messages":"Zpr\xe1vy","expert_service.audit_log":"Audit log","expert_service.error_list":"Seznam chyb","expert_service.link":"Expert Service","expert_service.network":"Sie\u0165","expert_service.network.button":"Prejs\u0165 do nastavenia siete","expert_service.network.link":"Sie\u0165","expert_service.reports":"Reporty","expert_service.stats":"Statistiky","expert_service.title":"Service","expert_service.xyz":"Servis","header.title":"Domovsk\xe1 str\xe1nka","header.title.app_messages":"Zpr\xe1vy","header.title.audit_log":"Audit Log","header.title.boiler":"Bojler","header.title.cloud_plugs":"Z\xe1suvky","header.title.dev":"Nastavenie siete","header.title.dev.app_messages":"Notifikace","header.title.dev.az_routers":"AZ routery","header.title.dev.bez_dodavatele":"bezDodavatele","header.title.dev.cloud_plugs":"Cloudov\xe9 z\xe1suvky","header.title.dev.delta_green":"Delta Green","header.title.dev.electree":"Electree","header.title.dev.enerco":"Enerco","header.title.dev.energomachine":"Energomachine","header.title.dev.inverter_config":"Konfigur\xe1cia strieda\u010Dov","header.title.dev.mqtt_broker":"MQTT Broker","header.title.dev.mqtt_cloud":"MQTT Cloud","header.title.dev.pre_flexibility":"PRE Flexibilita","header.title.dev.scripts":"Scripty","header.title.dev.shellies":"Shellies","header.title.dev.status_log":"Status log","header.title.dev.subscriptions":"Predplatn\xe9","header.title.dev_homepage":"V\xfdvojov\xe9 menu","header.title.ems":"EMS","header.title.ems_service":"EMS Service","header.title.energyMeters":"Elektromery","header.title.expert_service":"Expert slu\u017Eba","header.title.expert_service.network":"Nastavenie siete","header.title.grid":"Distribu\u010Dn\xe1 sie\u0165","header.title.heat_pump":"Tepeln\xe9 \u010Derpadlo","header.title.photovoltaics":"Fotovoltaika","header.title.plug":"Z\xe1suvka","header.title.relay":"Rel\xe9","header.title.reports":"Reporty","header.title.rfid_cards":"RFID k\xe1rty","header.title.settings":"Nastavenie","header.title.spot":"Spot","header.title.statistics":"Statistiky","header.title.thermostat":"Termostat","header.title.wallbox":"Wallbox","header.title.wallbox_list":"Wallboxy","header.title.wind":"Vetern\xe1 elektr\xe1rna","heat_pump.HW":"Ohrev teplej vody","heat_pump.HW.actual_temp":"Aktu\xe1lna teplota n\xe1dr\u017Ee","heat_pump.HW.flexitemp":"Flexibiln\xe1 teplota","heat_pump.HW.flexitemp.subtitle":"Teplota, o ktor\xfa je mo\u017En\xe9 predohria\u0165 tepl\xfa vodu","heat_pump.HW.hysteresis":"Hystereza ohrevu teplej vody","heat_pump.HW.on":"Ohrev teplej vody","heat_pump.HW.temp":"Po\u017Eadovan\xe1 teplota n\xe1dr\u017Ee","heat_pump.acond":"Acond","heat_pump.blocked":"Blok\xe1cia kompresora","heat_pump.blocked.min_soc":"Blok\xe1cia kompresora pri nedostupnej sieti","heat_pump.blocked.min_soc_utility":"Blok\xe1cia kompresora pri dostupnej sieti","heat_pump.blocked.subtitle":"Nabitie bat\xe9rie, od ktor\xe9ho d\xf4jde k blok\xe1cii kompresoru pri dostupnej sieti","heat_pump.common":"V\u0161eobecn\xe9 inform\xe1cie","heat_pump.common.power":"Aktu\xe1lny odber","heat_pump.common.power_today":"Dne\u0161n\xe1 spotreba:","heat_pump.common.power_year":"Ro\u010Dn\xe1 spotreba:","heat_pump.common.temp":"V\xfdstupn\xe1 teplota tepeln\xe9ho \u010Derpadla","heat_pump.common.total":"Celkov\xe1 spotreba","heat_pump.ecoone":"Ecoone","heat_pump.flexi":"Flexibilita energie","heat_pump.flexi.flexi_on":"Re\u017Eim flexibility","heat_pump.flexi.flexi_on.subtitle":"Re\u017Eim aktivuje predohrev z prebyto\u010Dnej energie","heat_pump.flexi.pvstability":"Potenci\xe1l aktiv\xe1cie kompresora","heat_pump.flexi_sp":"Flexibilita spot","heat_pump.flexi_sp.flexi_increase_on":"Zv\xfd\u0161enie spotreby","heat_pump.flexi_sp.flexi_increase_on.subtitle":"Re\u017Eim umo\u017En\xed zv\xfd\u0161enie spotreby pri n\xedzkej cene energie","heat_pump.flexi_sp.flexi_reduce_on":"Odlo\u017Eenie spotreby","heat_pump.flexi_sp.flexi_reduce_on.subtitle":"Re\u017Eim umo\u017En\xed odlo\u017Eenie spotreby pri vysokej cene energie","heat_pump.nibe":"Nibe","heat_pump.room":"Vykurovanie","heat_pump.room.equithermalCorrection":"Posun vykurovacej krivky","heat_pump.room.flexitemp":"Flexibiln\xe1 teplota","heat_pump.room.flexitemp.subtitle":"Teplota, o ktor\xfa je mo\u017En\xe9 predohria\u0165 alebo predchladi\u0165 dom","heat_pump.room.on":"Vykurovanie","heat_pump.room.tem":"Po\u017Eadovan\xe1 teplota","heat_pump.room.temp":"Aktu\xe1lna teplota miestnosti","heat_pump.room.tempmax":"Po\u017Eadovan\xe1 teplota komfort","heat_pump.room.tempmin":"Po\u017Eadovan\xe1 teplota \xfatlum","heat_pump.room_cool.on":"Chladenie","heat_pump.status":"Re\u017Eim tepelka","heat_pump_wizard.cancel":"Zru\u0161i\u0165","heat_pump_wizard.ip_address.alert":"Uistite sa pros\xedm, \u017Ee IP adresa tepeln\xe9ho \u010Derpadla nebude meni\u0165 (napr. ke\u010F T\u010C pou\u017E\xedva adresu z DHCP).","heat_pump_wizard.ip_address.input":"IP adresa tepeln\xe9ho \u010Derpadla","heat_pump_wizard.open":"Nastavi\u0165 typ T\u010C","heat_pump_wizard.save":"Ulo\u017Ei\u0165","heat_pump_wizard.title":"Nastavenie tepeln\xe9ho \u010Derpadla","heatpump.statistics":"Statistiky","heatpump.status":"Re\u017Eim tepelka","home.premium.banner.inactive.subtitle":"Infigy Plus prin\xe1\u0161a detailnej\u0161ie grafy, mesa\u010Dn\xe9 reporty, notifik\xe1cie a mnoho \u010Fal\u0161ieho.","home.premium.banner.inactive.title":"Chcete e\u0161te lep\u0161\xed preh\u013Ead?","homepage.actual.battery":"Stav bat\xe9rie","homepage.actual.boiler":"Bojler","homepage.actual.outdoor_temperature":"Vonkaj\u0161ia teplota","homepage.actual.thermostat":"Thermostat","homepage.actual.title":"","homepage.animation":"Aktu\xe1lne","homepage.statuses.title":"Re\u017Eimy akt\xedvnych komponentov","homepage.statuses.tooltip":"Re\u017Eimy akt\xedvnych komponentov","homepage.today.consumed":"Spotreba domu","homepage.today.consumed_WB":"Wallbox","homepage.today.consumed_from_grid":"Spotreba zo siete","homepage.today.consumed_hp":"Tepeln\xe9 \u010Derpadlo","homepage.today.consumed_hw":"Tepl\xe1 voda","homepage.today.overflow":"Pretok do siete","homepage.today.photovoltaics":"V\xfdroba FVE","homepage.today.title":"Denn\xe1 \u0161tatistika","homepage.today.wind":"V\xfdroba vetern\xe9 elektr\xe1rne","hp.status.compressor_blocked":"Blok\xe1cia kompresora, n\xedzky stav bat\xe9rie","hp.status.cooling":"Chladenie","hp.status.heating":"Vykurovanie","hp.status.hot_water":"Ohrev teplej vody","hp.status.inactive":"Neakt\xedvny","hp.status.not_connected":"Nemo\u017Eno nadviaza\u0165 spojenie","hp.status.not_licensed":"Tepeln\xe9 \u010Derpadlo nie je licencovan\xe9","hp.status.pool":"Ohrev baz\xe9na","hp.sub_status.consumption_postpone":"pri zn\xed\u017Een\xed spotreby","hp.sub_status.consumption_rise":"pri zv\xfd\u0161en\xed spotreby","hp.sub_status.consumption_with_flexibility":"s flexibilitou","hp.sub_status.nibe_not_writable":"- do NIBE nie je mo\u017En\xe9 zapisova\u0165","hp.sub_status.none":"","initial_wizard.banner.button":"Spusti\u0165 sprievodca","initial_wizard.banner.hide.confirm":"Naozaj chcete skr\xfdt sprievodca?","initial_wizard.banner.hide.confirm.description":"Sprievodcu m\xf4\u017Eete kedyko\u013Evek znovu spusti\u0165 v nastaven\xed aplik\xe1cie.","initial_wizard.banner.hide.show_more":"Spusti\u0165 sprievodca","initial_wizard.banner.hide.yes":"Skr\xfdt","initial_wizard.banner.subtitle":"Sprievodca v\xe1m pom\xf4\u017Ee nastavi\u0165 z\xe1kladn\xe9 parametre v\xe1\u0161ho syst\xe9mu.","initial_wizard.banner.title":"Dokon\u010Dite po\u010Diato\u010Dn\xe9 nastavenie","initial_wizard.banner.title.completed":"Prejs\u0165 po\u010Diato\u010Dn\xe9 nastavenie","initial_wizard.dialog.finish":"Dokon\u010Dit","initial_wizard.dialog.next":"Dal\u0161\xed","initial_wizard.dialog.prev":"Sp\xe4\u0165","initial_wizard.dialog.step":"Krok {current} z {total}","initial_wizard.dialog.title":"Sprievodca po\u010Diato\u010Dn\xfdm nastaven\xedm","initial_wizard.step1.description.active":"V\xe1\u0161 pr\xedstup do servisu je u\u017E akt\xedvny. M\xf4\u017Eete pokra\u010Dovat na dal\u0161\xed krok.","initial_wizard.step1.password_info":"Ka\u017Ed\xe1 firma m\xe1 vlastn\xe9 pr\xedstupov\xe9 heslo do servisn\xe9ho menu. Heslo ste obdr\u017Eali v e-mailovej komunik\xe1cii. M\xf4\u017Eete si jej tak\xe9 kdykoliv zobrazit v app.infigy.cz v partnerskej sekcii.","initial_wizard.step1.title":"Pr\xedstup do servisu","initial_wizard.step1.welcome":"Vitajte v \xfavodnom nastaven\xed Infigy. Prevedieme v\xe1s z\xe1kladnou konfigur\xe1ciou v\xe1\u0161ho syst\xe9mu. Detailnej\u0161ie nastavenie potom n\xe1jdete v servisnom menu.","initial_wizard.step10.title":"Nastavenie wallboxu","initial_wizard.step11.description":"Pre\u0161li ste z\xe1kladn\xe9 nastavenie Infigy. V\u0161etky parametre mo\u017Eno upravi\u0165 v servisnom menu.","initial_wizard.step11.service_menu.subtitle":"Nastavenie -> \xfaplne dole -> Pr\xedstup do servisu","initial_wizard.step11.service_menu.title":"Servisn\xe9 menu","initial_wizard.step11.title":"Hotovo","initial_wizard.step2.title":"Aktualiz\xe1cia aplik\xe1cie","initial_wizard.step3.title":"In\u0161tal\xe1cia","initial_wizard.step4.title":"Nastavenie hlavn\xe9ho isti\u010Da","initial_wizard.step5.title":"Pripojenie strieda\u010Da","initial_wizard.step6.title":"Parametre strieda\u010Da","initial_wizard.step7.description":"Ak je obmedzen\xfd pretok do siete, d\xf4jde k preneseniu nastavenia do strieda\u010Da. Obmedzovanie pretokov zabezpe\u010Duje strieda\u010D. Z\xe1pis a zmenu hodnoty v\u0161ak riadi Infigy pod\u013Ea zadanej hodnoty v tomto poli. Neupravujte teda obmedzenie pretoku v strieda\u010Di. Pri prvom nastaven\xed si zap\xedsan\xfa hodnotu skontrolujte v strieda\u010Di, \u010Di sa v\xe1m spr\xe1vne premietla z Infigy do strieda\u010Da.","initial_wizard.step7.title":"Obmedzenie pretoku","initial_wizard.step8.title":"Nastavenie bojlera","initial_wizard.step9.title":"Nastavenie spotov\xe9ho obchodovania","initial_wizard.step_app_update.description":"V \u010Dase, ke\u010F bolo Infigy na ceste k v\xe1m, sme mohli vyda\u0165 nov\xe9 verzie aplik\xe1cie. Odpor\xfa\u010Dame pred nastaven\xedm jednotku aktualizova\u0165. Ak ale napr\xedklad nie je dostupn\xfd internet, m\xf4\u017Eete aktualiz\xe1ciu presko\u010Di\u0165 a vykona\u0165 ju nesk\xf4r v servisnom menu alebo v port\xe1li.","inverter.3mar_plc":"3Mar PLC","inverter.az_router":"AzRouter elektromer","inverter.control.mode":"Riadenie meni\u010Da","inverter.control.mode.chargingFromGrid":"Nab\xedjanie bat\xe9rie zo siete","inverter.control.mode.dischargingToGrid":"Vyb\xedjanie bat\xe9rie do siete","inverter.control.mode.noneControl":"Bez riadenia","inverter.control.mode.stopCharging":"Zastavenie nab\xedjania","inverter.control.mode.stopDischarging":"Zastavenie vyb\xedjania","inverter.control.mode.stopOverflow":"Zastavenie pretokov","inverter.des_battery_container":"DES - kontajnerov\xe9 \xfalo\u017Eisko","inverter.deye":"Deye LV","inverter.deye_hv":"Deye HV","inverter.fronius":"Fronius SYMO GEN24","inverter.fronius_grid":"Fronius SYMO sie\u0165ov\xfd","inverter.fronius_verto":"Fronius Verto","inverter.good_we":"GoodWe","inverter.good_we_grid_next":"GoodWe sie\u0165ov\xfd","inverter.good_we_next":"GoodWe","inverter.goodwe_grid":"Goodwe sie\u0165ov\xfd","inverter.hes":"HES - bat\xe9riov\xe9 \xfalo\u017Eisko","inverter.next":"Viac strieda\u010Dov","inverter.none":"\u017Diadny","inverter.sermatec":"Sermatec","inverter.shellies":"Shellies","inverter.shellies_external":"Shellies External","inverter.sma_grid":"SMA sie\u0165ov\xfd","inverter.sofar_solar":"Sofarsolar","inverter.sofar_solar_rs485":"SofarSolar RS485","inverter.solar_edge_grid":"SolarEdge s\xed\u0165ov\xfd","inverter.solax":"Solax","inverter.solax_ems1000":"Solax EMS1000","inverter.solax_ems1000pro":"Solax EMS1000PRO","inverter.solax_grid":"Solax s\xed\u0165ov\xfd","inverter.solax_mega_grid":"Solax MEGA/FORTH s\xed\u0165ov\xfd","inverter.solax_mic_grid":"Solax MIC s\xed\u0165ov\xfd","inverter.solax_next":"SolaxNext","inverter.solinteg":"Solinteg","inverter.victron":"Victron","inverter.wattsonic":"Wattsonic","inverter_wizard.cancel":"Zru\u0161i\u0165","inverter_wizard.custom_device_ip_address.alert":"Uistite sa pros\xedm, \u017Ee sa IP adresa strieda\u010Da nebude meni\u0165 (napr. ke\u010F strieda\u010D vyu\u017E\xedva adresu z DHCP).","inverter_wizard.custom_device_ip_address.input":"IP adresa strieda\u010Da","inverter_wizard.multiple_inverters.alert":"Pre nastavenie viacer\xfdch strieda\u010Dov pros\xedm kontaktujte linku podpory. Kontakt n\xe1jdete v technickej wiki Infigy.","inverter_wizard.multiple_inverters.label":"Viac strieda\u010Dov","inverter_wizard.multiple_inverters_or_ems.alert":"V\xe1\u0161 syst\xe9m u\u017E m\xe1 nastavenie pre viac strieda\u010Dov alebo EMS. Tento sprievodca je ur\u010Den\xfd len pre nastavenie jedn\xe9ho strieda\u010Da. Pre zmenu nastavenia strieda\u010Dov alebo EMS pros\xedm kontaktujte podporu.","inverter_wizard.nominal_power":"Nomin\xe1lny v\xfdkon strieda\u010Da","inverter_wizard.nominal_power.helper":"Rozsah: 1 a\u017E 100 kW","inverter_wizard.nominal_power.validation":"Zadajte nomin\xe1lny v\xfdkon strieda\u010Da v kW.","inverter_wizard.open":"N\xe1js\u0165 strieda\u010D","inverter_wizard.save":"Ulo\u017Ei\u0165","inverter_wizard.scan":"N\xe1js\u0165 strieda\u010D na sieti","inverter_wizard.scanning":"H\u013Ead\xe1m strieda\u010D v sieti","inverter_wizard.submit_error":"Nastala chyba pri ukladan\xed nastavenia strieda\u010Da. Sk\xfaste to pros\xedm znova.","inverter_wizard.title":"Sprievodca pripojen\xedm strieda\u010Da","layout.disconnected":"Odpojen\xe9","layout.pigpio_init_error_dialog.description":"Aplik\xe1cia Infigy na zariaden\xed nebe\u017Eala spr\xe1vne. Sk\xfaste pros\xedm zariadenie re\u0161tartova\u0165 a ak probl\xe9m pretrv\xe1va, kontaktujte podporu.","layout.pigpio_init_error_dialog.title":"Chyba pri spusten\xed aplik\xe1cie","level.thermostat.cooling":"Chladenie","level.thermostat.deactivated":"Neakt\xedvny","level.thermostat.heating":"Vykurovanie","level.thermostat.standby":"Standby","level.thermostat.tempErr":"Chyba teploty","level.thermostatFlexibility.increasePv":"Flexibilita vyu\u017Eita na zv\xfd\u0161enie teploty pod\u013Ea fotovoltaiky","level.thermostatFlexibility.increaseSpot":"Flexibilita vyu\u017Eita na zv\xfd\u0161enie teploty pod\u013Ea SPOTU","level.thermostatFlexibility.normal":"Norm\xe1ln\xed","level.thermostatFlexibility.reductionSpot":"Flexibilita vyu\u017Eita na zn\xed\u017Eenie teploty pod\u013Ea SPOTU","mqtt_broker.connected_clients.title":"Clients","mqtt_broker.enabled":"Zapnuto","mqtt_broker.running":"Stav","mqtt_broker.title":"MQTT Broker","mqtt_cloud.connected":"Stav","mqtt_cloud.connected.offline":"Offline","mqtt_cloud.connected.online":"Online","mqtt_cloud.enabled":"Integr\xe1cia zapnut\xe1","mqtt_cloud.title":"MQTT Cloud","nav.app_messages":"Zpr\xe1vy","nav.home":"Domov","nav.logout":"Odhl\xe1si\u0165 sa","nav.reports":"Reporty","nav.sec.boiler":"Bojler","nav.sec.cloud_plugs":"Z\xe1suvky","nav.sec.ems":"EMS","nav.sec.energyMeters":"Elektromery","nav.sec.grid":"Sie\u0165","nav.sec.heatpump":"Tepeln\xe9 \u010Derpadlo","nav.sec.home":"V\u0161eobecn\xe9","nav.sec.photovoltaics":"Fotovoltaika","nav.sec.plug":"Z\xe1suvka","nav.sec.relay":"Rel\xe9","nav.sec.spot":"Spot","nav.sec.thermostat":"Termostat","nav.sec.wallbox":"Wallbox","nav.sec.wind":"Vetern\xe1 elektr\xe1rna","nav.settings":"Nastavenie","nav.statistics":"Statistiky","network.ethernet_ports":"Ethernet porty","network.ethernet_ports.name":"LAN","network.ethernet_ports.status":"Status","network.ethernet_ports.status.down":"Neakt\xedvny","network.ethernet_ports.status.up":"Aktivn\xed","network.scan.error":"Skenovanie siete zlyhalo","network.summary.address":"IP adresa","network.summary.dhcp_host_exists":"Adresa zafixov\xe1na na DHCP. Kliknut\xedm odfixovat.","network.summary.error":"Chyba pri na\u010D\xedtavan\xed","network.summary.heat_pump":"Tepeln\xe9 \u010Derpadlo","network.summary.inverter":"Strieda\u010D","network.summary.mac":"MAC","network.summary.name":"Meno","network.summary.no_dhcp_host":"Dynamick\xe1 adresa na DHCP. Kliknut\xedm zafixovat.","network.summary.not_connected":"Nie je pripojen\xe9","network.title":"V\u0161eobecn\xe9","network.wan_address":"WAN adresa","network_wan_edit.dialog.address":"IP adresa","network_wan_edit.dialog.close":"Zavrie\u0165","network_wan_edit.dialog.dns":"DNS server","network_wan_edit.dialog.gateway":"V\xfdchodz\xed br\xe1na","network_wan_edit.dialog.netmask":"Maska siete","network_wan_edit.dialog.save":"Ulo\u017Ei\u0165","network_wan_edit.dialog.title":"\xdaprava WAN adresy","nmap.empty":"Nic nenalezeno","nmap.error":"Skenovanie zlyhalo","nmap.host":"Adresa","nmap.loading":"Skenujem","nmap.output":"V\xfdstup","nmap.port":"Port","nmap.port.help":"Pr\xe1zdne = len h\u013Eadanie zariadenia","nmap.range.external":"external \u2014 sie\u0165 z\xe1kazn\xedka","nmap.range.internal":"internal \u2014 intern\xe1 sie\u0165 Infigy","nmap.result.address":"IP adresa","nmap.result.mac":"MAC adresa","nmap.result.ports":"Porty","nmap.result.scanning":"Skenujeme {target}, m\xf4\u017Ee to chv\xed\u013Eu trva\u0165\u2026","nmap.result.target":"Skenovan\xfd rozsah: {target}","nmap.result.vendor":"V\xfdrobca","nmap.start":"Spusti\u0165","nmap.target":"Adresa alebo rozsah","nmap.target.help":"Pojmenovan\xe1 sie\u0165 alebo IP / rozsah","nmap.title":"Skenovanie portov","photovoltaics.battery":"Bat\xe9ria","photovoltaics.battery.battery_charged":"Nabitie bat\xe9rie","photovoltaics.battery.battery_manual_discharge":"Manu\xe1lne vyb\xedjanie bat\xe9rie","photovoltaics.battery.battery_power":"V\xfdkon bat\xe9rie","photovoltaics.battery.soc_actual":"Vypo\u010D\xedtan\xe9 minim\xe1lne nabitie","photovoltaics.batteryStatus":"Stav BMS","photovoltaics.battery_stop":"Blokovanie bat\xe9rie","photovoltaics.battery_stop.hdo":"Vyb\xedjanie baterie iba pri n\xedzkom tarife (HDO)","photovoltaics.battery_stop.hp":"Blokovanie baterie pri prov\xe1dzan\xed tepeln\xe9ho \u010Derpadla","photovoltaics.battery_stop.hw":"Blokovanie baterie pri prov\xe1dzan\xed ohrevu vody","photovoltaics.battery_stop.wb":"Blokovanie baterie pri prov\xe1dzan\xed wallboxu","photovoltaics.battery_stop.wb.lock_desc":"Pri zapnutom re\u017Eime nab\xedjania wallboxu \u201ENab\xedjanie pod\u013Ea bat\xe9rie\u201C nemo\u017Eno t\xfato blok\xe1ciu zapn\xfa\u0165. Po zapnut\xed blok\xe1cie nastavte in\xfd re\u017Eim nab\xedjania wallboxu.","photovoltaics.battery_stop.wb.lock_title":"Nastavenie nemo\u017Eno zmeni\u0165","photovoltaics.common":"V\u0161eobecn\xe9 inform\xe1cie","photovoltaics.common.battery_charged":"Nabitie bat\xe9rie","photovoltaics.common.battery_manual_charge":"Manu\xe1lne nab\xedjanie bat\xe9rie","photovoltaics.common.battery_manual_charge_soc":"Cie\u013Eov\xe9 nabitie pre manu\xe1lne nab\xedjanie","photovoltaics.common.battery_manual_charge_subtitle":"Manu\xe1lne nab\xedjanie baterie nabije bateriu na cie\u013Eov\xfa \xfarove\u0148 nabitia, ak sa nevypne sk\xf4r u\u017E\xedvate\u013Eom.","photovoltaics.common.battery_manual_discharge":"Manu\xe1lne vybit bat\xe9riu","photovoltaics.common.battery_manual_discharge_subtitle":"Manu\xe1lne vyb\xedjanie baterie vybije bateriu na minim\xe1lnu \xfarove\u0148 nabitia, ak sa nevypne sk\xf4r u\u017E\xedvate\u013Eom.","photovoltaics.common.battery_power":"V\xfdkon bat\xe9rie","photovoltaics.common.power":"Aktu\xe1lny v\xfdkon","photovoltaics.common.power_today":"Dne\u0161n\xe1 v\xfdroba:","photovoltaics.common.power_total":"Celkov\xe1 v\xfdroba","photovoltaics.common.power_year":"Ro\u010Dn\xe1 v\xfdroba:","photovoltaics.common.string1":"String 1:","photovoltaics.common.string2":"String 2:","photovoltaics.common.string3":"String 3:","photovoltaics.common.string4":"String 4:","photovoltaics.common.string5":"String 5:","photovoltaics.common.string6":"String 6:","photovoltaics.statistics":"V\xfdkon elektr\xe1rne","photovoltaics.statistics.charge":"Nab\xedjanie bat\xe9rie","photovoltaics.statistics.discharge":"Vyb\xedjen\xed bat\xe9rie","photovoltaics.statisticsSoc":"\xdarove\u0148 nabit\xed bat\xe9rie","photovoltaics.status":"Re\u017Eim FVE","ping.address":"Adresa","ping.output":"V\xfdstup","ping.start":"Spusti\u0165","ping.stop":"Zastavi\u0165","ping.title":"Ping","plug.bat":"Riadenie pod\u013Ea bat\xe9rie","plug.bat.batterySart":"Zapn\xfa\u0165 pri nabit\xed","plug.bat.batterySart.help":"\xdarove\u0148 nabit\xed bat\xe9rie, pri ktorom sa z\xe1suvka zapne. Aby k zapnut\xed do\u0161lo, mus\xed d\xf4js\u0165 k prechodu nabit\xed bat\xe9rie z nastaven\xe9ho stavu na vy\u0161\u0161\xed stav. Ak je hodnota nastaven\xe1 na 80%, tak z\xe1suvka sepne pri nabit\xed bat\xe9rie zo 80% na 81%.","plug.bat.batterySart.subtitle":"Nabitie bat\xe9rie, pri ktorom sa aktivuje z\xe1suvka","plug.bat.batteryStop":"Vypn\xfa\u0165 pri nabit\xed","plug.bat.batteryStop.help":"\xdarove\u0148 nabit\xed bat\xe9rie, pri ktorom sa z\xe1suvka vypne. Aby k vypnut\xed do\u0161lo, mus\xed d\xf4js\u0165 k prechodu nabit\xed bat\xe9rie z nastaven\xe9ho na ni\u017E\u0161\xed stav. Ak je hodnota nastaven\xe1 na 80%, tak z\xe1suvka vypne pri vybit\xed bat\xe9rie zo 80% na 79%.","plug.bat.batteryStop.subtitle":"Nabitie bat\xe9rie, pri ktorom sa vypne z\xe1suvka","plug.bat.help":"Sp\xednanie pri definovanej \xfarovni nabitia bat\xe9rie. Mo\u017Eno kombinova\u0165 s podmienkou \u010Dasu. Pri kombin\xe1cii podmienok sa z\xe1suvka zapne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na zapnutie a vypne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na vypnutie.","plug.bat.on":"Aktivn\xed","plug.main":"V\u0161eobecn\xe9 inform\xe1cie","plug.main.consumption":"Aktu\xe1lna spotreba","plug.main.power":"Celkov\xe1 spotreba","plug.main.power_today":"Dne\u0161n\xe1 spotreba:","plug.main.power_year":"Ro\u010Dn\xe1 spotreba:","plug.main.stat":"Statistiky","plug.overflow":"Riadenie pod\u013Ea pretoku","plug.overflow.consumption":"Nastavenie odpov\xedd\xe1 spotrebi\u010Du s pr\xedkonom","plug.overflow.help":"Zap\xednanie z\xe1suvky pri definovanom pretoku do distribu\u010Dnej siete. Mo\u017Eno kombinova\u0165 s podmienkou \u010Dasu. Pri kombin\xe1cii podmienok sa z\xe1suvka zapne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na zapnutie a vypne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na vypnutie.","plug.overflow.on":"Aktivn\xed","plug.overflow.startPower":"Zapn\xfa\u0165 pri odberu zo siete","plug.overflow.startPower.help":"Z\xe1suvka sa zapne, ak je pretok v nastavenej v\xfd\u0161ke po definovan\xfd interval oneskorenie. Ak je hodnota nastaven\xe1 na - 1500W a oneskorenie zapnut\xed je 5 minut, tak z\xe1suvka sepne pri pretoku do siete vo v\xfd\u0161ke alespo\u0148 1500W po dobu 5 minut.","plug.overflow.startPower.subtitle":"Z\xe1porn\xe1 hodnota je pretok, kladn\xe1 hodnota je odber","plug.overflow.stopPower":"Vypn\xfa\u0165 pri odberu zo siete","plug.overflow.stopPower.help":"Z\xe1suvka sa vypne, ak je odber vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval oneskorenie. Ak je hodnota nastaven\xe1 na 100W a oneskorenie vypnut\xed je 5 minut, tak z\xe1suvka vypne pri odberu zo siete vo v\xfd\u0161ke minim\xe1lne 100W po dobu 5 minut.","plug.overflow.stopPower.subtitle":"Z\xe1porn\xe1 hodnota je pretok, kladn\xe1 hodnota je odber","plug.overflow.time":"Oneskorenie zapnutia a vypnut\xed","plug.overflow.time.help":"Tento parametr sl\xfa\u017Ei na defin\xedciu oneskorenie zapnut\xed a vypnut\xed z\xe1suvky pri definovan\xfdch pretokoch/odberoch. Vhodn\xe9 pre nastavenie priority a elimin\xe1ciu \u010Dast\xe9ho sp\xedn\xe1n\xed z\xe1suvky. Zad\xe1vajte vo form\xe1te HH:MM.","plug.plug":"Z\xe1suvka","plug.spot":"Riadenie pod\u013Ea spotovej ceny","plug.spot.15m.period":"Perioda spotovej ceny","plug.spot.15m.period.subtitle":"15 min\xfatov\xe9 intervaly","plug.spot.help":"Sp\xednanie pri definovanej spotovej cene. Mo\u017Eno kombinova\u0165 s podmienkou \u010Dasu. Pri kombin\xe1cii podmienok sa z\xe1suvka zapne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na zapnutie a vypne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na vypnutie.","plug.spot.on":"Akt\xedvny","plug.spot.period":"Perioda spotovej ceny","plug.spot.period.subtitle":"60 min\xfatov\xe9 intervaly","plug.spot.price.period":"\u010Casov\xe9 rozl\xed\u0161enie z\xe1suvky","plug.spot.spotHi":"Aktivova\u0165 pri vysokej cene","plug.spot.spotHi.help":"Z\xe1suvka sa zapne, ak je cena spotu na vysok\xe9 \xfarovni pozri z\xe1lo\u017Eku Spot.","plug.spot.spotLow":"Aktivova\u0165 pri n\xedzkej cene spotu","plug.spot.spotLow.help":"Z\xe1suvka sa zapne, ak je cena spotu na n\xedzk\xe9 \xfarovni pozri z\xe1lo\u017Eku Spot.","plug.spot.spotMi":"Aktivova\u0165 pri strednej cene","plug.spot.spotMi.help":"Z\xe1suvka sa zapne, ak je cena spotu na strednej \xfarovni pozri z\xe1lo\u017Eku Spot.","plug.spot.spot_above_price":"Aktivova\u0165 pri vy\u0161\u0161ej ne\u017E nastavenej cene","plug.spot.spot_above_price.help":"Z\xe1suvka sa aktivuje, ak je cena spotu vy\u0161\u0161ia alebo rovn\xe1 nastavenej cene spotu.","plug.spot.spot_above_price.subtitle":"Ak je cena spotu vy\u0161\u0161\xed nebo rovna tejto hodnote, d\xf4jde k sepnutiu. Ak je ni\u017E\u0161\xed, d\xf4jde k rozepnutiu.","plug.spot.spot_below_price":"Aktivova\u0165 pri ni\u017E\u0161ej ne\u017E nastavenej cene","plug.spot.spot_below_price.help":"Z\xe1suvka sa aktivuje, ak je cena spotu ni\u017E\u0161ia alebo rovn\xe1 nastavenej cene spotu.","plug.spot.spot_below_price.subtitle":"Ak je cena spotu ni\u017E\u0161\xed nebo rovna tejto hodnote, d\xf4jde k sepnutiu. Ak je vy\u0161\u0161\xed, d\xf4jde k rozepnutiu.","plug.spot.spot_neg":"Aktivova\u0165 pri z\xe1kaze pretokov do siete","plug.spot.spot_neg.help":"Z\xe1suvka sa aktivuje, ak je zak\xe1zan\xfd pretok do siete pozri pl\xe1n spotov\xe9ho obchodov\xe1n\xed.","plug.status":"Re\u017Eim z\xe1suvky","plug.summary.price":"Cena","plug.summary.price_level":"Hladina ceny","plug.summary.price_level_15m":"Hladina ceny 15m","plug.summary.switch":"Sepnutie z\xe1suvky","plug.summary.time":"\u010Cas","plug.time":"Riadenie pod\u013Ea \u010Dasu","plug.time.help":"Sp\xednanie pri definovanom \u010Dase. Mo\u017Eno kombinova\u0165 s ostatn\xfdmi podmienkami pod\u013Ea bat\xe9rie (mus\xed by\u0165 nain\u0161talovan\xe1 bat\xe9ria), spotov\xe9 ceny (mus\xed by\u0165 povolen\xe9 spotov\xe9 obchodovanie) a pretoku (mus\xed by\u0165 povolen\xfd pretok do DS). Pri kombin\xe1cii podmienok sa z\xe1suvka zapne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na zapnutie a vypne, ak je splnen\xe1 aspo\u0148 jedna z podmienok na vypnutie.","plug.time.on":"Akt\xedvny","plug.time.turn_off":"Vypn\xfa\u0165 v \u010Dase","plug.time.turn_off.help":"\u010Cas, v ktorom sa z\xe1suvka vypne. Ak je nastaven\xe9 na 12:00, tak sa z\xe1suvka vypne presne v nastaven\xfd \u010Das 12:00.","plug.time.turn_on":"Zapn\xfa\u0165 v \u010Dase","plug.time.turn_on.help":"\u010Cas, v ktorom sa z\xe1suvka zapne. Ak je nastaven\xe9 na 12:00, tak sa z\xe1suvka zapne presne v nastaven\xfd \u010Das 12:00.","plug.turn_off":"Vypn\xfa\u0165","plug.turn_on":"Zapn\xfa\u0165","pre_flexibility.business_flexibility.title":"Obchodn\xe1 flexibilita","pre_flexibility.enabled":"Integr\xe1cia zapnut\xe1","pre_flexibility.title":"PRE Flexibilita","premium.banner.active.button":"Spravova\u0165 predplatn\xe9","premium.banner.active.dev_mode":"Predplatn\xe9 je akt\xedvne pre v\xfdvoj","premium.banner.active.subtitle":"Predplatn\xe9 Infigy Plus je akt\xedvne. M\xf4\u017Eete si u\u017E\xedva\u0165 v\u0161etky vychyt\xe1vky, ktor\xe9 s\xfa v\u010Faka nemu v aplik\xe1cii navy\u0161e.","premium.banner.active.title":"Moje Infigy Plus","premium.banner.hide.confirm":"Naozaj chcete skr\xfdt Infigy Plus?","premium.banner.hide.confirm.description":"Kedyko\u013Evek m\xf4\u017Eete Infigy Plus znovu presk\xfama\u0165 v nastaven\xed aplik\xe1cie.","premium.banner.hide.later":"Pripomen\xfa\u0165 nesk\xf4r","premium.banner.hide.show_more":"Zjistit v\xedce","premium.banner.hide.yes":"Skr\xfdt","premium.banner.inactive.button":"Zjistit v\xedce","premium.banner.inactive.subtitle":"Posu\u0148te svoju spr\xe1vu energi\xed na e\u0161te vy\u0161\u0161iu \xfarove\u0148. S Infigy Plus dostanete \u010Fal\u0161ie chytr\xe9 n\xe1stroje - detailn\xe9 grafy, okam\u017Eit\xe9 notifik\xe1cie, vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1r, preh\u013Eadn\xe9 reporty a \u010Fal\u0161ie.","premium.banner.inactive.title":"Infigy Plus nie je akt\xedvny","premium.dialog.charts.subtitle":"Z\xedskajte mo\u017Enos\u0165 sledova\u0165 v\xfdkon jednotliv\xfdch stringov, spotrebu pod\u013Ea f\xe1z a \u010Fal\u0161ie podrobn\xe9 inform\xe1cie.","premium.dialog.charts.title":"Detailn\xed grafy","premium.dialog.notifications.subtitle":"Z\xedskavajte notifik\xe1cie o z\xe1porn\xfdch cen\xe1ch, nabitej bat\xe9rii a \u010Fal\u0161\xedch udalostiach","premium.dialog.notifications.title":"Notifikace","premium.dialog.other_benefits.subtitle":"Pripravujeme mno\u017Estvo \u010Fal\u0161\xedch benefitov, ktor\xe9 budeme postupne uvo\u013E\u0148ova\u0165 pre predplatite\u013Eov Infigy Plus","premium.dialog.other_benefits.title":"\u010Eal\u0161ie benefity pr\xeddu \u010Doskoro","premium.dialog.reports.subtitle":"Detailn\xe9 mesa\u010Dn\xe9 reporty, ktor\xe9 v\xe1m poskytn\xfa jasn\xfd obraz o v\xfdrobe, spotrebe a vyu\u017Eit\xed energie vo va\u0161ej dom\xe1cnosti. V\u0161etky d\xf4le\u017Eit\xe9 \xfadaje m\xe1te na jednom mieste - zrozumite\u013Ene, preh\u013Eadne a doplnen\xe9 grafmi.","premium.dialog.reports.title":"Pokro\u010Dil\xe9 reporty","premium.dialog.save":"Predplati\u0165 Infigy Plus","premium.dialog.schedule.subtitle":"Napl\xe1nujte si ru\u010Dne nab\xedjanie \u010Di vyb\xedjanie bat\xe9rie pod\u013Ea potreby","premium.dialog.schedule.title":"Vylep\u0161en\xfd pl\xe1novac\xed kalend\xe1r","premium.dialog.spot.subtitle":"Z\xedskajte mo\u017Enos\u0165 nahliadnu\u0165 do hist\xf3rie spotov\xfdch cien a pl\xe1nov, ktor\xe9 Infigy v minulosti pripravilo","premium.dialog.spot.title":"Historie spotov\xfdch cen","protocol.settings":"Nastavenie","protocol.settings.Licence":"Licence","protocol.settings.distribution":"Distribuce","protocol.test":"Test zariadenia","protocol.test.internet-connect":"Pripojenie k internetu","protocol.test.inverter-connect":"Pripojenie strieda\u010Da","protocol.test.phase_1":"Test 1. f\xe1ze","protocol.test.phase_2":"Test 2. f\xe1ze","protocol.test.phase_3":"Test 3. f\xe1ze","protocol.test.tester":"Zariadenie otestoval","relay.condition":"Podm\xednka sp\xedn\xe1n\xed","relay.main":"V\u0161eobecn\xe9 inform\xe1cie","relay.name":"N\xe1zov rel\xe9","relay.spot.diagram":"Sp\xednanie pod\u013Ea spotovej ceny","relay.status":"Sepnuto","relay.summary.switch":"Sepnutie rel\xe9","relay.title":"Rel\xe9","report.avg_day_chart.battery_soc":"Nabitie bat\xe9rie","report.avg_day_chart.consumption":"Spotreba","report.avg_day_chart.grid":"Distribu\u010Dn\xe1 sie\u0165","report.avg_day_chart.pv_production":"V\xfdroba FVE","report.not_generated":"Vytvori\u0165 report kliknut\xedm","report_test.button":"Test","report_test.date":"Mesiac (napr. 2025-09)","report_test.generated":"Report vygenerov\xe1n","report_test.ok":"OK","report_test.test":"Test","reports.accumulation_increased":"Zv\xfd\u0161enie akumul\xe1cie","reports.average_water_temperature":"Priemern\xe1 teplota vody","reports.avg_day":"Priemern\xfd de\u0148","reports.battery":"Bat\xe9ria","reports.boiler":"Bojler","reports.building_consumption":"Spotreba objektu","reports.disclaimer":"Uveden\xe9 hodnoty maj\xfa len informativn\xfd charakter a m\xf4\u017Eu sa l\xed\u0161i\u0165 od ofici\xe1lnych od\u010D\xedtan\xed distrib\xfatora.","reports.energy_estimate":"Odhad energi\xed bez riadenia","reports.estimated_water_amount":"Odhadovan\xe9 mno\u017Estv\xed vody","reports.grid_consumption":"Odber zo siete","reports.grid_consumption_hp":"Spotreba zo siete","reports.grid_consumption_hw":"Spotreba zo siete","reports.grid_consumption_wallbox":"Spotreba zo siete","reports.heat_pump":"Tepeln\xe9 \u010Derpadlo","reports.household_consumption":"Spotreba dom\xe1cnosti","reports.info":"V\u0161eobecn\xe9 info","reports.kilometers_driven":"Po\u010Det ujet\xfdch km","reports.kilometers_driven_from_sun":"Po\u010Det ujet\xfdch km zo slnka","reports.maximum_power":"Maxim\xe1lny v\xfdkon","reports.monthly_consumption":"Mesa\u010Dn\xe1 spotreba","reports.monthly_production":"Mesa\u010Dn\xe1 v\xfdroba","reports.pv":"Fotovoltaick\xe1 elektr\xe1rna","reports.pv_consumption":"Spotreba z FVE","reports.pv_production":"V\xfdroba FVE","reports.regenerate_report":"Znovu vygenerovat report","reports.regenerate_report_confirm_title":"Znovu vygenerovat report?","reports.rfid_cards":"RFID k\xe1rty","reports.self_consumption":"Vlastn\xed vyu\u017Eit\xed energie","reports.self_sufficiency":"Sebesta\u010Dnos\u0165","reports.self_sufficient_days":"Po\u010Det sebesta\u010Dn\xfdch dn\xed","reports.share.description":"Vybran\xfd sn\xedmok m\xf4\u017Eete zdie\u013Ea\u0165 s ostatn\xfdmi.","reports.share.share":"Sd\xedlet report","reports.share.title":"Sd\xedlet report","reports.share_report":"Sd\xedlet report","reports.sold_to_distribution_grid":"Prod\xe1no do distribu\u010Dnej siete","reports.stored_energy_from_grid":"Ulo\u017Een\xe1 energie zo siete","reports.stored_energy_from_pv":"Ulo\u017Een\xe1 energie z FVE","reports.stored_energy_to_battery":"Ulo\u017Een\xe1 energie do bat\xe9rie","reports.stored_energy_to_boiler":"Ulo\u017Een\xe1 energie do bojleru","reports.stored_energy_to_heat_pump":"Ulo\u017Een\xe1 energie do T\u010C","reports.stored_energy_to_wallbox":"Ulo\u017Een\xe1 energie do wallboxu","reports.total_overflow_to_grid":"Celkov\xfd pretok do siete","reports.total_purchase_from_grid":"Celkov\xfd n\xe1kup zo siete","reports.total_with_control":"Celkom s riaden\xedm","reports.total_without_control":"Celkom bez riadenia","reports.updated_at":"Vygenerov\xe1no {date}","reports.wallbox":"Wallbox","rfid_cards.col.consumption":"Spotreba","rfid_cards.col.created_at":"Pridan\xe9","rfid_cards.col.id":"ID k\xe1rty","rfid_cards.col.name":"N\xe1zev","rfid_cards.export":"Exportova\u0165 CSV","rfid_cards.from":"Od","rfid_cards.no_cards":"\u017Diadne k\xe1rty neboli pridan\xe9.","rfid_cards.title":"RFID k\xe1rty","rfid_cards.to":"Do","save":"Ulo\u017Ei\u0165","schedules.add":"Prida\u0165 pl\xe1n","schedules.battery_charge":"Nab\xedjanie bat\xe9rie","schedules.battery_discharge":"Vyb\xedjanie bat\xe9rie","schedules.charging_current":"Nab\xedjac\xed pr\xfad: {chargingCurrent} A","schedules.description":"Napl\xe1nujte si vybitie alebo nabitie bat\xe9rie pod\u013Ea potreby.","schedules.dialog.title":"Vytvori\u0165 pl\xe1n","schedules.dialog.title.ev":"Vytvori\u0165 pl\xe1n nab\xedjania","schedules.ev_charging":"Nab\xedjanie elektromobilu","schedules.form.action":"Akcia","schedules.form.battery_charge":"Nab\xedt\xed bat\xe9rie","schedules.form.battery_discharge":"Vybitie bat\xe9rie","schedules.form.charging-current":"Nastavenie nab\xedjacieho pr\xfadu","schedules.form.charging-current.auto":"Predvolen\xe9","schedules.form.create":"Vytvori\u0165","schedules.form.duration":"D\u013A\u017Eka","schedules.form.duration.120min":"2 hodina","schedules.form.duration.180min":"3 hodiny","schedules.form.duration.240min":"4 hodiny","schedules.form.duration.300min":"5 hodin","schedules.form.duration.360min":"6 hodin","schedules.form.duration.60min":"1 hodina","schedules.form.ev_charging":"Nab\xedjanie elektromobilu","schedules.form.frequency":"Frekvencia","schedules.form.frequency.daily":"Denne","schedules.form.frequency.monthly":"Mesiacne","schedules.form.frequency.weekly":"T\xfd\u017Edenne","schedules.form.interval.biweekly":"Ka\u017Ed\xe9 2 t\xfd\u017Edne","schedules.form.preview.hide":"Skry\u0165 n\xe1h\u013Ead","schedules.form.preview.show":"Zobrazi\u0165 pl\xe1novan\xe9 v\xfdskyty","schedules.form.preview.title":"Pl\xe1novan\xe9 spustenia ({count} nasleduj\xfacich)","schedules.form.recurring":"Opakovanie","schedules.form.target-soc":"Cilov\xe9 SOC (volite\u013En\xe9)","schedules.form.until":"Opakova\u0165 do (volite\u013En\xe9)","schedules.form.when":"Kdy","schedules.loading.error":"Chyba pri na\u010D\xedtavan\xed pl\xe1nov","schedules.missed":"Neprebehlo","schedules.no_plans_found":"\u017Diadne pl\xe1ny neboli n\xe1jden\xe9.","schedules.processed":"Prebehlo","schedules.remove.confirm":"Naozaj chcete pl\xe1n vymaza\u0165?","schedules.remove.no":"Zru\u0161i\u0165","schedules.remove.recurring.instance":"Vymaza\u0165 len tento v\xfdskyt","schedules.remove.recurring.series":"Vymaza\u0165 cel\xfa s\xe9riu","schedules.remove.recurring.title":"Vymaza\u0165 opakovan\xfd pl\xe1n","schedules.remove.yes":"Vymaza\u0165","schedules.running":"Prebieha","schedules.scheduled":"Naplanovan\xe9","schedules.show_processed":"Zobrazi\u0165 prebehnut\xe9","schedules.target_soc":"C\xedlov\xe9 SOC: {targetSoc, number, percent}","schedules.title":"Pl\xe1nova\u010D","scripts.add":"Vytvori\u0165","scripts.delete":"Vymaza\u0165","scripts.edit":"Upravi\u0165","scripts.loading_error":"Chyba pri na\u010D\xedtavan\xed skriptov","scripts.title":"Skripty","settings.PV.NominalInverterPower":"Nomin\xe1lny v\xfdkon strieda\u010Da","settings.PV.NominalInverterPower.help":"Pre Solinteg, Wattsonic a Deye je toto d\xf4le\u017Eit\xe9 pre spr\xe1vny v\xfdpo\u010Det pretokov do siete.","settings.PV.NominalInverterPower.subtitle":"Nomin\xe1lny v\xfdkon strieda\u010Da v kW, d\xf4le\u017Eit\xfd pre v\xfdpo\u010Det % pretokov do siete.","settings.PV.StringNumber":"Po\u010Det stringov strieda\u010De","settings.PV.StringNumber.subtitle":"Po\u010Det stringov strieda\u010De zobrazovan\xfd v aplikaci na z\xe1lo\u017Eke FVE","settings.app_update":"Verzia aplik\xe1cie","settings.app_update.check_button":"Zkontrolovat aktualizace","settings.app_update.confirm.cancel":"Zru\u0161i\u0165","settings.app_update.confirm.confirm":"Aktualizovat","settings.app_update.confirm.description":"Aktualiz\xe1cia m\xf4\u017Ee trva\u0165 nieko\u013Eko min\xfat. Po\u010Das aktualiz\xe1cie bude aplik\xe1cia nedostupn\xe1 a n\xe1sledne sa automaticky re\u0161tartuje.","settings.app_update.confirm.title":"Spusti\u0165 aktualizaci?","settings.app_update.error.no_internet":"Zkontrolujte s\xed\u0165ov\xe9 pripojenia","settings.app_update.in_progress":"Aktualiz\xe1cia prebieha","settings.app_update.request_button":"Aktualizace je k dispozici","settings.app_update.requested":"Aktualizace byla vy\u017E\xe1d\xe1na","settings.app_update.subtitle":"Zkontrolujte dostupnost nov\xfdch verz\xed","settings.app_update.title":"Aktualiz\xe1cia aplik\xe1cie","settings.app_update.up_to_date":"Aplik\xe1cia je aktu\xe1lna","settings.boiler":"Bojler","settings.boiler.3phase":"Trojf\xe1zov\xe1 patrona","settings.boiler.3phase.subtitle":"Jedno-f\xe1zov\xfa patr\xf3nu zapojte na SSR v\xfdstup zodpovedaj\xfaci zvolenej f\xe1ze.","settings.boiler.HwBatteryPriority":"Procento nab\xedt\xed bat\xe9rie od ktor\xe9ho sa za\u010Dne ohrieva\u0165 bojler","settings.boiler.HwBatteryPriority.help":"Ak je nabitie bat\xe9rie ni\u017E\u0161ie ako t\xe1to hodnota, priorita akumul\xe1cie energie je plne dostupn\xe1 bat\xe9rii. Ak je nabitie bat\xe9rie vy\u0161\u0161ie, bojler za\u010D\xedna prebera\u0165 prioritu a sp\xfa\u0161\u0165a ohrev vody z prebyto\u010Dnej energie FVE - \u010Das\u0165 energie ide \u010Falej do bat\xe9rie do jej dobitia.","settings.boiler.capacity":"Objem bojleru","settings.boiler.capacity_sub":"Nutn\xe9 zada\u0165 len pre spotov\xe9 obchodovanie","settings.boiler.enabled":"Topn\xe1 patrona nainstalov\xe1na","settings.boiler.nominal":"Nomin\xe1lny pr\xedkon","settings.boiler.nominal.subtitle":"Nomin\xe1lny pr\xedkon pre 1 f\xe1zu elektrokotle","settings.boiler.phase":"F\xe1za patr\xf3ny","settings.boiler.phase.subtitle":"L1 = SSR v\xfdstup 1, L2 = SSR v\xfdstup 2, L3 = SSR v\xfdstup 3.","settings.boiler.prio":"Priorita bat\xe9rie","settings.boiler.prio.subtitle":"Ak je ON, najprv sa nabij\xfa bat\xe9rie a n\xe1sledne bojler","settings.boiler.shellies":"Bojler je riaden\xfd cez Shelly","settings.boiler.temp_enabled":"Teplotn\xed \u010Didlo nainstalov\xe1no","settings.boiler.temp_enabled.subtitle":"Bojler mo\u017Eno bez \u010Didla vyu\u017Ei\u0165 len pre prebytky","settings.device":"Zariadenie","settings.device.SN":"S\xe9riov\xe9 \u010D\xedslo","settings.device.id":"ID zariadenia","settings.device.license":"Licence zariadenia","settings.docs":"N\xe1vody a dal\u0161\xed podklady","settings.docs.service_settings_inverter.button":"Prejs\u0165 na wiki","settings.docs.service_settings_inverter.subtitle":"Dokument\xe1cia, postupy a \u010Fal\u0161ie inform\xe1cie","settings.docs.service_settings_inverter.title":"N\xe1vod na pripojenie strieda\u010Da","settings.docs.tech_wiki.button":"Prejs\u0165 na wiki","settings.docs.tech_wiki.subtitle":"N\xe1vody, postupy a dal\u0161\xed informace","settings.docs.tech_wiki.title":"Technick\xe1 wiki","settings.docs.user_wiki.button":"Prejs\u0165 na wiki","settings.docs.user_wiki.subtitle":"N\xe1vody, postupy a dal\u0161\xed informace","settings.docs.user_wiki.title":"U\u017Eivatelsk\xe1 wiki","settings.hdo":"Nastavenie \u010Dias HDO","settings.hdo.help":"Nastavenie \u010Dias HDO pre v\xfdpo\u010Det cien elektriny vo vysokom a n\xedzkom tarife. Ni\u017E\u0161ie je mo\u017En\xe9 zada\u0165 \u010Dasy platnosti n\xedzkeho tarifu.","settings.hdo.on1":"\u010Cas 1","settings.hdo.on2":"\u010Cas 2","settings.hdo.on3":"\u010Cas 3","settings.hdo.on4":"\u010Cas 4","settings.hdo.on5":"\u010Cas 5","settings.hdo.on6":"\u010Cas 6","settings.hdo.regular":"Be\u017En\xfd pracovn\xfd de\u0148","settings.hdo.start":"Zapn\xfa\u0165","settings.hdo.stop":"Vypn\xfa\u0165","settings.hdo.type":"Definovat \u010Dasy pro","settings.hdo.weekend":"V\xedkendov\xe9 \u010Dasy HDO","settings.heatpump":"Tepeln\xe9 \u010Derpadlo","settings.heatpump.HpBatteryPriority":"Percento nabitia bat\xe9rie, od ktor\xe9ho sa zv\xfd\u0161i v\xfdkon tepeln\xe9ho \u010Derpadla","settings.heatpump.HpBatteryPriority.help":"Ak je nabitie bat\xe9rie ni\u017E\u0161ie ako t\xe1to hodnota, priorita akumul\xe1cie energie je plne dostupn\xe1 bat\xe9rii. Ak je nabitie bat\xe9rie vy\u0161\u0161ie, tepeln\xe9 \u010Derpadlo za\u010D\xedna prebera\u0165 prioritu a sp\xfa\u0161\u0165a ohrev vody z prebyto\u010Dnej energie FVE - \u010Das\u0165 energie ide \u010Falej do bat\xe9rie do jej dobitia.","settings.heatpump.enabled":"Tepeln\xe9 \u010Derpadlo nainstalov\xe1no","settings.heatpump.flexiAN":"Flexibilita AN","settings.heatpump.flexiCool":"Flexibilita chlazen\xed","settings.heatpump.flexiHw":"Flexibilita teplej vody","settings.heatpump.flexiRoom":"Flexibilita miestnosti","settings.heatpump.hp_type":"Typ tepeln\xe9ho \u010Derpadla","settings.heatpump.nominal":"Nomin\xe1lny pr\xedkon","settings.heatpump.nominal1":"Nomin\xe1lny pr\xedkon","settings.heatpump.priority":"Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E bat\xe9rie","settings.heatpump.priority-wb":"Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E wallbox","settings.heatwatter":"Bojler","settings.heatwatter.legionella":"Legionella","settings.heatwatter.legionella_temp":"Teplota sanace","settings.heatwatter.legionella_temp.subtitle":"Teplota, na ktor\xfa sa mus\xed minim\xe1lne 1x za 14 dn\xed bojler nahria\u0165","settings.inverter_communication_status":"Komunik\xe1cia so strieda\u010Dom","settings.inverter_communication_status.not_ok":"Nenaviazan\xe9,{br}pok\xfa\u0161am sa o spojenie...","settings.inverter_communication_status.ok":"Komunikace nav\xe1z\xe1na{br}({count} \u010Dten\xed)","settings.inverter_communication_status.subtitle":"Nadviazanie komunik\xe1cie m\xf4\u017Ee trva\u0165 nieko\u013Eko desiatok sek\xfand a\u017E p\xe1r min\xfat","settings.notification":"Notifikace","settings.notification.battery_max_soc":"Maxim\xe1lne SOC bat\xe9rie","settings.notification.battery_max_soc.subtitle":"Notifik\xe1cia sa vygeneruje pri dosa\u017Een\xed nastaven\xe9ho maxim\xe1lneho SOC bat\xe9rie. Notifik\xe1cia sa vygeneruje len 1x denne.","settings.notification.battery_max_soc_value":"Maxim\xe1lne SOC bat\xe9rie pre notifik\xe1cie","settings.notification.battery_max_soc_value.subtitle":"Nastavte SOC bat\xe9rie, pri jeho dosiahnut\xed sa vygeneruje notifikace.","settings.notification.battery_min_soc":"Minim\xe1lne SOC bat\xe9rie","settings.notification.battery_min_soc.subtitle":"Notifik\xe1cia sa vygeneruje pri poklesu SOC bat\xe9rie na nastavenou minim\xe1lnu hodnotu. Notifik\xe1cia sa vygeneruje len 1x denne.","settings.notification.battery_min_soc_value":"Minim\xe1lne SOC bat\xe9rie pre notifik\xe1cie","settings.notification.battery_min_soc_value.subtitle":"Nastavte SOC bat\xe9rie. Pri poklese na t\xfato hodnotu sa vygeneruje notifik\xe1cia.","settings.notification.daily_prediction.subtitle":"Notifik\xe1cia sa vygeneruje ka\u017Ed\xfd de\u0148 v 8:00","settings.notification.heat_pump_limit_exceeded":"Prekro\u010Denie limitu spotreby tepeln\xe9ho \u010Derpadla.","settings.notification.heat_pump_limit_exceeded.subtitle":"Notifik\xe1cia sa vygeneruje pri prekro\u010Den\xed nastaven\xe9ho limitu spotreby tepeln\xe9ho \u010Derpadla","settings.notification.heat_pump_limit_value":"Denn\xfd limit spotreby tepeln\xe9ho \u010Derpadla pre notifik\xe1cie","settings.notification.heat_pump_limit_value.subtitle":"Nastavte limit spotreby tepeln\xe9ho \u010Derpadla, pri jeho prekro\u010Den\xed sa vygeneruje notifikace.","settings.notification.heat_water_limit_exceeded":"Prekro\u010Denie limitu ohrevu vody","settings.notification.heat_water_limit_exceeded.subtitle":"Notifik\xe1cia sa vygeneruje pri prekro\u010Den\xed nastaven\xe9ho limitu ohrevu vody","settings.notification.heat_water_limit_value":"Denn\xfd limit ohrevu vody pre notifik\xe1cie","settings.notification.heat_water_limit_value.subtitle":"Nastavte limit ohrevu vody, pri jeho prekro\u010Den\xed sa vygeneruje notifikace.","settings.notification.heat_water_max_temperature":"Dosa\u017Eena maxim\xe1lne teplota vody v bojleru","settings.notification.heat_water_max_temperature.subtitle":"Notifik\xe1cia sa vygeneruje pri dosa\u017Een\xed po\u017Eadovan\xe9 maxim\xe1lne teploty vody v bojleru z FV energie","settings.notification.home_consumption_limit_exceeded":"Prekro\u010Denie limitu spotreby dom\xe1cnosti","settings.notification.home_consumption_limit_exceeded.subtitle":"Notifik\xe1cia sa vygeneruje pri prekro\u010Den\xed nastaven\xe9ho limitu spotreby dom\xe1cnosti","settings.notification.home_consumption_limit_value":"Denn\xfd limit spotreby dom\xe1cnosti pre notifik\xe1cie","settings.notification.home_consumption_limit_value.subtitle":"Nastavte limit spotreby dom\xe1cnosti, pri jeho prekro\u010Den\xed sa vygeneruje notifikace.","settings.notification.iverter_disconnected":"V\xfdpadok komunik\xe1cie strieda\u010Da","settings.notification.iverter_disconnected.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci v\xfdpadku komunik\xe1cie so strieda\u010Dom","settings.notification.negative_spot":"Z\xe1porn\xe1 cena na spotu","settings.notification.negative_spot.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci z\xe1pornej ceny na spotu","settings.notification.pv_production_mwh":"M\xed\u013Enik vo v\xfdrobe FV energie","settings.notification.pv_production_mwh.subtitle":"Notifik\xe1cia sa vygeneruje ak FVE vygeneruje MWh energie v dan\xe9m roce","settings.notification.spot_charging_battery":"Za\u010Diatok a koniec nab\xedjania bat\xe9rie pod\u013Ea spotovej ceny","settings.notification.spot_charging_battery.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci nab\xedjania bat\xe9rie pod\u013Ea spotovej ceny","settings.notification.spot_daily_prediction":"Denn\xe1 predpove\u010F","settings.notification.spot_daily_summary":"Denn\xfd s\xfahrn pl\xe1nu spotu","settings.notification.spot_daily_summary.subtitle":"Notifik\xe1cia sa vygeneruje ka\u017Ed\xfd den v 8:00","settings.notification.spot_discharging_battery":"Za\u010Diatok a koniec vyb\xedjania bat\xe9rie do siete pod\u013Ea spotovej ceny","settings.notification.spot_discharging_battery.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci vyb\xedjania bat\xe9rie do siete pod\u013Ea spotovej ceny","settings.notification.utility_loss":"V\xfdpadek distribu\u010Dnej siete","settings.notification.utility_loss.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci v\xfdpadku distribu\u010Dnej siete","settings.notification.wallbox_charging_start_stop":"Za\u010Diatok a koniec nab\xedjania elektromobilu","settings.notification.wallbox_charging_start_stop.subtitle":"Notifik\xe1cia sa vygeneruje pri za\u010Diatku a konci nab\xedjania elektromobilu","settings.notification.wallbox_limit_exceeded":"Prekro\u010Denie limitu nab\xedjania elektromobilu","settings.notification.wallbox_limit_exceeded.subtitle":"Notifik\xe1cia sa vygeneruje pri prekro\u010Den\xed nastaven\xe9ho limitu nab\xedjania elektromobilu","settings.notification.wallbox_limit_value":"Denn\xfd limit nab\xedjania elektromobilu pre notifik\xe1cie","settings.notification.wallbox_limit_value.subtitle":"Nastavte limit nab\xedjania elektromobilu, pri jeho prekro\u010Den\xed sa vygeneruje notifikace.","settings.notification.webapp.subtitle":"Notifik\xe1cie z Infigy m\xf4\u017Eete dost\xe1va\u0165 cez webov\xfa aplik\xe1ciu.","settings.notification.webapp.title":"Webov\xe1 aplik\xe1cia","settings.other":"Ostatn\xed","settings.other.dark_mode":"Tmav\xfd re\u017Eim","settings.other.languate":"Jazyk","settings.other.overflow_fronius":"Maxim\xe1lny pretok do siete je obmedzovan\xfd na strane Fronius strieda\u010Da","settings.other.overflow_fronius_subtitle":"T\xe1to hodnota je stanoven\xe1 distrib\xfatorom. Prekro\u010Denie tejto hodnoty m\xf4\u017Ee vies\u0165 k finan\u010Dn\xfdm postihom zo strany distrib\xfatora.","settings.other.overflow_settings":"Nastaven\xe1 hodnota pretokov","settings.other.overflow_settings.help":"Ide o servisne nastaven\xfa hodnotu maxim\xe1lneho pretoku. T\xe1to hodnota je stanoven\xe1 distrib\xfatorom. Prekro\u010Denie tejto hodnoty m\xf4\u017Ee vies\u0165 k finan\u010Dn\xfdm postihom zo strany distrib\xfatora.","settings.other.readability_mode":"Velikost p\xedsma","settings.photovoltaics":"Fotovoltaick\xe1 elektr\xe1rna","settings.photovoltaics.backup_enabled":"Backup povolen","settings.photovoltaics.backup_enabled.subtitle":"Inform\xe1cie o nastaven\xed re\u017Eimu z\xe1lohy strieda\u010Da.","settings.photovoltaics.batterychargingpower":"Nab\xedjac\xed v\xfdkon bat\xe9rie","settings.photovoltaics.batterychargingpower_sub":"V\xfdkon pre manu\xe1lne nab\xedjanie bat\xe9rie a spotov\xe9 nab\xedjanie z distribu\u010Dnej siete","settings.photovoltaics.batterydischargingpower":"Vyb\xedjec\xed v\xfdkon bat\xe9rie","settings.photovoltaics.batterydischargingpower_sub":"V\xfdkon pre spotov\xe9 vyb\xedjanie bat\xe9rie do distribu\u010Dnej siete","settings.photovoltaics.batteryenabled":"Baterie nainstalov\xe1na","settings.photovoltaics.batterynominal":"Nomin\xe1lna kapacita bat\xe9rie","settings.photovoltaics.batterynominal_sub":"Nutn\xe9 zada\u0165 len pre spotov\xe9 obchodovanie","settings.photovoltaics.enabled":"FVE nainstalov\xe1na","settings.photovoltaics.gridchargeenabled":"Nab\xedjanie bat\xe9rie z distribu\u010Dnej siete povolen\xe9","settings.photovoltaics.inverters-adjust-power":"Aktu\xe1lny v\xfdkon strieda\u010Dov","settings.photovoltaics.inverters-nominal":"Nomin\xe1lny v\xfdkon riaden\xfdch strieda\u010Dov","settings.photovoltaics.nominal":"Nomin\xe1lny v\xfdkon v paneloch celej elektr\xe1rne","settings.photovoltaics.overflow":"Pretok do siete bez obmedzenia","settings.photovoltaics.overflow.value":"Obmedzenie pretoku","settings.photovoltaics.overflow.value.help":"Hodnota obmedzenia pretoku do distribu\u010Dnej siete. T\xe1to hodnota sa zap\xed\u0161e do strieda\u010Da. Vo strieda\u010Di t\xfato hodnotu neupravujte. Obmedzenie pretoku je riaden\xe9 z Infigy. Zap\xedsan\xfa hodnotu si skontrolujte vo strieda\u010Di.","settings.photovoltaics.overflow_fronius.value.help":"Hodnota pretoku na strane Fronius strieda\u010De. Sl\xfa\u017Ei ako inform\xe1cia Infigy pre spr\xe1vnu vizualiz\xe1ciu pretokov.","settings.photovoltaics.settings":"Bat\xe9ria","settings.photovoltaics.settings.soc_actual":"Vypo\u010Dten\xe9 minim\xe1lne nabit\xed","settings.photovoltaics.settings.soc_actual.help":"T\xe1to hodnota je automaticky vypo\u010D\xedtan\xe1 na z\xe1klade aktu\xe1lneho stavu. Bu\u010F sa riadi dle automatick\xe9ho nabitia pod\u013Ea ro\u010Dn\xe9ho obdobia, alebo dle manu\xe1lneho nastavenia minim\xe1lneho nabitia s DS a bez DS. Ak je t\xe1to hodnota 100%, tak je vyb\xedjanie baterie zak\xe1zan\xe9, napr. dle spotov\xe9ho obchodovania.","settings.photovoltaics.settings.soc_grid":"Minim\xe1lne nabitie s DS","settings.photovoltaics.settings.soc_grid.help":"Touto hodnotou je mo\u017En\xe9 riadi\u0165 minim\xe1lne nabitie bat\xe9rie v % SOC pri dostupnej distribu\u010Dnej sieti. U Solax v re\u017Eime Backup je minim\xe1lne nabitie bat\xe9rie 15%.","settings.photovoltaics.settings.temp":"Minim\xe1lne nabitie s DS","settings.photovoltaics.settings.temp.help":"Touto hodnotou je mo\u017En\xe9 riadi\u0165 minim\xe1lne nabitie bat\xe9rie v % SOC pri dostupnej distribu\u010Dnej sieti.","settings.photovoltaics.settings.temp_ek":"Minim\xe1lne nabitie bez DS","settings.photovoltaics.settings.temp_ek.help":"Touto hodnotou je mo\u017En\xe9 riadi\u0165 minim\xe1lne nabitie bat\xe9rie v % SOC pri v\xfdpadku distribu\u010Dnej siete.","settings.photovoltaics.unbalanced_enabled":"Asymetria strieda\u010Da","settings.photovoltaics.unbalanced_enabled.subtitle":"Inform\xe1cie o nastaven\xed re\u017Eimu asymetrie strieda\u010Da.","settings.photovoltaics_auto_settings":"Automatick\xe9 riadenie nabitia","settings.photovoltaics_auto_settings.subtitle":"Automatick\xe1 regul\xe1cia nabitia pod\u013Ea ro\u010Dn\xe9ho obdobia","settings.plug":"Z\xe1suvky","settings.plug.Led":"Trval\xe9 podsv\xedcen\xed","settings.plug.Led-batt":"Podsvieten\xe9 pri nabitej baterii","settings.plug.Led-batt.subtitle":"Podsvieten\xe9 akt\xedvne, ak m\xe1 bateria aspo\u0148 95%","settings.plug.Led-over":"Podsvieten\xe9 pri pretoku","settings.plug.enabled":"Z\xe1suvky nainstalov\xe1ny","settings.plug.enabled.subtitle":"Z\xe1suvky na lok\xe1lnej sieti","settings.plug.enabled2":"Druh\xe1 z\xe1suvka","settings.plug.enabled3":"Tretia z\xe1suvka","settings.plug.ip1":"IP adresa prvej z\xe1suvky","settings.plug.ip1.label":"IP 1","settings.plug.ip2":"IP adresa druhej z\xe1suvky","settings.plug.ip2.label":"IP 2","settings.plug.ip3":"IP adresa tretjej z\xe1suvky","settings.plug.ip3.label":"IP 3","settings.plug.modulenabled":"Z\xe1suvky na modulu Shelly PRO 3","settings.plug.modulip":"IP adresa modulu","settings.plug.modulip.label":"IP modulu","settings.plug.name1":"N\xe1zov prvej z\xe1suvky","settings.plug.name1.label":"N\xe1zov","settings.plug.name2":"N\xe1zov druhej z\xe1suvky","settings.plug.name2_label":"N\xe1zov","settings.plug.name3":"N\xe1zov tretjej z\xe1suvky","settings.plug.name3.label":"N\xe1zov","settings.plug.statusLed":"Signaliza\u010Dn\xe1 dioda","settings.readability_mode.default":"Predvolen\xe9","settings.readability_mode.large":"Velk\xe1","settings.relay.above_price_relay":"Cena spotu pre sepnutie rel\xe9","settings.relay.above_price_relay.subtitle":"Pri cene spotu nad tuto hodnotu d\xf4jde k sepnutiu rel\xe9. Ak je cena ni\u017E\u0161\xed, d\xf4jde k rozepnutiu rel\xe9.","settings.relay.above_price_relay_15m":"Cena spotu pre sepnutie rel\xe9 (15 min)","settings.relay.above_price_relay_15m.subtitle":"Pri cene spotu nad t\xfato hodnotu d\xf4jde k sepnutiu rel\xe9. Ak je cena ni\u017E\u0161ia, d\xf4jde k rozepnutiu rel\xe9.","settings.relay.above_soc_relay":"Nabitie bat\xe9rie pre sepnutie rel\xe9","settings.relay.above_soc_relay.subtitle":"Pri nabit\xed bat\xe9rie nad tuto hodnotu d\xf4jde k sepnutiu rel\xe9","settings.relay.above_soc_relay_hyst":"Hystereza bat\xe9rie pre rozepnutie rel\xe9","settings.relay.above_soc_relay_hyst.subtitle":"Ak sa nabitie bat\xe9rie zn\xed\u017Ei o t\xfato hodnotu pod nastaven\xfa pre sepnutie, d\xf4jde k rozepnutiu rel\xe9","settings.relay.below_price_relay":"Cena spotu pre sepnutie rel\xe9","settings.relay.below_price_relay.subtitle":"Pri cene spotu pod tuto hodnotu d\xf4jde k sepnutiu rel\xe9. Ak je cena vy\u0161\u0161\xed, d\xf4jde k rozepnutiu rel\xe9.","settings.relay.below_price_relay_15m":"Cena spotu pre sepnutie rel\xe9 (15 min)","settings.relay.below_price_relay_15m.subtitle":"Pri cene spotu pod t\xfato hodnotu d\xf4jde k sepnutiu rel\xe9. Ak je cena vy\u0161\u0161ia, d\xf4jde k rozepnutiu rel\xe9.","settings.relay.below_soc_relay":"Nabitie bat\xe9rie pre sepnutie rel\xe9","settings.relay.below_soc_relay.subtitle":"Pri poklese nabitia bat\xe9rie pod t\xfato hodnotu d\xf4jde k sepnutiu rel\xe9","settings.relay.below_soc_relay_hyst":"Hystereza bat\xe9rie pre rozepnutie rel\xe9","settings.relay.below_soc_relay_hyst.subtitle":"Ak sa nabitie bat\xe9rie zv\xfd\u0161i o t\xfato hodnotu nad nastaven\xfa pre sepnutie, d\xf4jde k rozepnutiu rel\xe9","settings.relay.enabled":"Rel\xe9 nainstalov\xe1ny","settings.relay.enabled.subtitle":"Integrovan\xe1 rel\xe9","settings.relay.item.enabled":"Rel\xe9 {index}","settings.relay.item.name":"Pojmenovanie rel\xe9","settings.relay.item.status":"Sepnuto","settings.relay.option":"Podmienka","settings.relay.temp_above_relay.subtitle":"Pri teplote bojleru nad tuto hodnotu d\xf4jde k sepnutiu rel\xe9","settings.relay.temp_above_relay_hyst.subtitle":"Ak sa teplota bojleru zn\xed\u017Ei o t\xfato hodnotu pod nastaven\xfa pre sepnutie, d\xf4jde k rozepnutiu rel\xe9","settings.relay.temp_below_relay.subtitle":"Pri teplote bojleru pod tuto hodnotu d\xf4jde k sepnutiu rel\xe9","settings.relay.temp_below_relay_hyst":"Hystereza bojlera pre rozepnutie rel\xe9","settings.relay.temp_below_relay_hyst.subtitle":"Ak sa teplota bojleru zv\xfd\u0161i o t\xfato hodnotu nad nastaven\xfa pre sepnutie, d\xf4jde k rozepnutiu rel\xe9","settings.relay.temp_relay":"Teplota bojlera pre sepnutie rel\xe9","settings.relay.temp_relay_hyst":"Hystereza bojlera pre rozepnutie rel\xe9","settings.relay.type.Active":"Trvalo zapnut\xe9","settings.relay.type.HDO":"Zrcadlit HDO","settings.relay.type.batteryBelowSOC":"Nabitie bat\xe9rie pod nastaven\xe9 SOC","settings.relay.type.batteryDischarge":"Vyb\xedjen\xed bat\xe9rie do siete","settings.relay.type.batteryFull":"Nabitie bat\xe9rie nad nastaven\xe9 SOC","settings.relay.type.batteryLow":"Nabitie bat\xe9rie pod nastaven\xe9 minimum","settings.relay.type.bojlerFull":"Bojler je takmer natopen\xfd","settings.relay.type.hdo":"Zrcadlit HDO","settings.relay.type.heatWaterAboveTemp":"Bojler je natopen\xfd nad nastaven\xfa teplotu","settings.relay.type.heatWaterBelowTemp":"Bojler je natopen\xfd pod nastaven\xfa teplotu","settings.relay.type.heatWaterMaxTemp":"Bojler je takmer natopen\xfd","settings.relay.type.heatWaterTemp":"Bojler je natopen\xfd nad nastaven\xfa teplotu","settings.relay.type.none":"Nie je pou\u017Eit\xe9, trvalo vypnut\xe9","settings.relay.type.plug1":"Z\xe1suvka 1","settings.relay.type.plug2":"Z\xe1suvka 2","settings.relay.type.plug3":"Z\xe1suvka 3","settings.relay.type.plug4":"Z\xe1suvka 4","settings.relay.type.spotBatteryDischarge":"Vyb\xedjen\xed bat\xe9rie do siete","settings.relay.type.spotHi":"Vysok\xe1 cena spotu (60 min)","settings.relay.type.spotHi15M":"Vysok\xe1 cena spotu (15 min)","settings.relay.type.spotLow":"N\xedzk\xe1 cena spotu (60 min)","settings.relay.type.spotLow15M":"N\xedzk\xe1 cena spotu (15 min)","settings.relay.type.spotMi":"Stredn\xe1 cena spotu (60 min)","settings.relay.type.spotMi15M":"Stredn\xe1 cena spotu (15 min)","settings.relay.type.spotNegative":"Z\xe1kaz pretokov do siete (60 min)","settings.relay.type.spotNegative15M":"Z\xe1kaz pretokov do siete (15 min)","settings.relay.type.spotPriceAbove":"Cena spotu nad nastaven\xfa hodnotu","settings.relay.type.spotPriceAbove15M":"Cena spotu nad nastaven\xfa hodnotu (15 min)","settings.relay.type.spotPriceBelow":"Cena spotu pod nastaven\xfa hodnotu","settings.relay.type.spotPriceBelow15M":"Cena spotu pod nastaven\xfa hodnotu (15 min)","settings.relay.type.spotStopAccumulation":"Akumul\xe1cia zastaven\xe1, akt\xedvny predaj","settings.relay.type.stopAccumulation":"Akumul\xe1cia zastaven\xe1, akt\xedvny predaj","settings.relay.type.thermostat1":"Termostat 1","settings.relay.type.thermostat2":"Termostat 2","settings.relay.type.thermostat3":"Termostat 3","settings.relay.type.thermostat4":"Termostat 4","settings.relay.user_advanced_control":"Zobrazi\u0165 str\xe1nku s inform\xe1ciami u\u017E\xedvate\u013Eovi","settings.relay.user_advanced_control.subtitle":"Pri povolen\xed sa zobraz\xed str\xe1nka v navigaci","settings.service":"Servis","settings.service.connection_type":"Pripojenie","settings.service.customer":"Meno u\u017E\xedvate\u013Ea","settings.service.customer-email":"Email u\u017E\xedvate\u013Ea","settings.service.customer-email-subtitle":"Ak nem\xe1 u\u017E\xedvate\u013E zalo\u017Een\xfd \xfa\u010Det pod t\xfdmto emailom, d\xf4jde k automatick\xe9mu vytvoreniu \xfa\u010Dtu a odoslaniu registra\u010Dn\xe9ho emailu","settings.service.customer-email.label":"Email","settings.service.customer-subtitle":"Sl\xfa\u017Ei k identifik\xe1cii in\u0161tal\xe1cie pre firmu a z\xe1kazn\xedka","settings.service.customer.label":"Meno","settings.service.exit":"Odhl\xe1si\u0165 zo servisu","settings.service.exit.button":"Odhl\xe1si\u0165","settings.service.info":"In\u0161tal\xe1cia","settings.service.inverter_type":"Typ strieda\u010De","settings.service.inverter_type.label":"Strieda\u010D","settings.service.modbus_tcp":"LAN/WiFi","settings.service.network":"Sie\u0165","settings.service.network.help.content":"V zozname je mo\u017En\xe9 vidie\u0165 aktu\xe1lne pripojen\xe9 zariadenia do siete Infigy (WiFi nebo kabelem), ich IP adresy, MAC adresy, atd. Ak zariadenie pou\u017E\xedva DHCP, je mo\u017En\xe9 kliknut\xedm na \u0161pendl\xedk a zafixovat IP adresu, ktor\xfa potom DHCP server v\u017Edy bude prira\u010Fova\u0165 - toto je vhodn\xe9 napr. pre strieda\u010D, tepeln\xe9 \u010Derpadlo, apod. Ak zariadenie pou\u017E\xedva statickou IP adresu, nemus\xed sa zobrazova\u0165 spr\xe1vne.","settings.service.network.help.title":"Nastavenie siete","settings.service.network.mac":"MAC adresa zariadenia","settings.service.network.online.internet":"Pr\xedstup na internet","settings.service.network.online.internet.help":"Pr\xedstup na internet je potrebn\xfd pre vzdialen\xfd pr\xedstup, aktualiz\xe1ciu syst\xe9mu, spotov\xe9 ceny a \u010Fal\u0161ie funkcie. Pre pln\xfa funk\u010Dnos\u0165 musia by\u0165 v\u0161etky tri indik\xe1tory zelen\xe9.{br}{br}Prv\xfd indik\xe1tor zobrazuje dostupnos\u0165 internetu (ping 8.8.8.8).{br}{br}Druh\xfd indik\xe1tor zobrazuje dostupnos\u0165 internetu vr\xe1tane DNS (ping infigy.cz).{br}{br}Tret\xed indik\xe1tor zobrazuje pr\xedstup k intern\xfdm cloudov\xfdm slu\u017Eb\xe1m Infigy (dostupnos\u0165 VPN).{br}{br}Ak je s pripojen\xedm probl\xe9m, skontrolujte pros\xedm k\xe1bel, alebo kontaktujte spr\xe1vcu siete, \u010Di nem\xe1 lok\xe1lnu sie\u0165 obmedzenia na komunik\xe1ciu do internetu.{br}{br}{wikiLink}","settings.service.network.online.internet.help.wikiLink":"Viac inform\xe1ci\xed v na\u0161ej wiki.","settings.service.network.online.portal":"Pr\xedstup na port\xe1l Infigy","settings.service.network.wan":"WAN adresa","settings.service.network.wifi_passphrase":"Heslo WiFi siete","settings.service.network_type":"Sie\u0165","settings.service.network_type.custom":"Ru\u010Dn\xed nastaven\xed adresy","settings.service.network_type.external":"M\xedstn\xed s\xed\u0165 (z\xe1kazn\xedka)","settings.service.network_type.internal":"Intern\xed s\xed\u0165 Infigy","settings.service.password":"Pr\xedstup do servisu","settings.service.password.label":"Heslo","settings.service.relay":"Rel\xe9","settings.service.reset":"Reset chyb","settings.service.reset.button":"Reset chyb","settings.service.rs485":"RS485","settings.service.service-email":"Email servisnej firmy","settings.service.service-email-subtitle":"Pre prepojenie zariadenia s in\u0161tal\xe1ciou je nutn\xe9 zadat email servisnej firmy, ktor\xfd je ulo\u017Een v Partnerskej sekcii aplik\xe1cie","settings.service.service-email.label":"Email","settings.service.servicer":"Meno in\u0161tal\xe1cie technika","settings.service.servicer.label":"Meno","settings.service.solidsun_op":"SolidSun OP","settings.service.solidsun_op.label":"SolidSun OP","settings.service.spot":"Spotov\xe9 obchodovanie","settings.service.tester.label":"Meno test\xe9ra","settings.service.thermostat":"Termostat","settings.service.town":"Lokalita (obec)","settings.service.version":"Verzia aplik\xe1cie","settings.service.wallbox_type":"Typ wallbox","settings.service.wallbox_type.label":"Wallbox","settings.spot":"Spot","settings.spot.battery.stop_discharge_auto":"Automatick\xe9 riadenie z\xe1kazu vyb\xedjania","settings.spot.battery.stop_discharge_auto.help":"Ak zvol\xedte tuto mo\u017Enost, tak syst\xe9m automaticky bude riadi\u0165 vyb\xedjanie bat\xe9rie a povol\xed ho iba pri najvy\u0161\u0161\xedch denn\xfdch cen\xe1ch na spotu.","settings.spot.battery.stop_discharge_auto.subtitle":"Riadenie uschov\xe1 energii automaticky na najdrah\u0161ie hodiny.","settings.spot.battery.stop_discharge_high_price":"Z\xe1kaz vyb\xedjania bat\xe9rie pri n\xedzkej a strednej cene","settings.spot.battery.stop_discharge_high_price.help":"Ak zvol\xedte t\xfato mo\u017Enos\u0165, tak pri n\xedzkej a strednej cene spotu sa nebude vyu\u017E\xedva\u0165 energia z bat\xe9rie. Syst\xe9m nebude bat\xe9riu vyb\xedja\u0165. T\xe1 sa vyu\u017Eije pri vy\u0161\u0161\xedch cen\xe1ch.","settings.spot.battery.stop_discharge_low_price":"Z\xe1kaz vyb\xedjania bat\xe9rie pri n\xedzkej cene","settings.spot.battery.stop_discharge_low_price.help":"Ak zvol\xedte t\xfato mo\u017Enos\u0165, tak pri n\xedzkej cene spotu sa nebude vyu\u017E\xedva\u0165 energia z bat\xe9rie. Syst\xe9m nebude bat\xe9riu vyb\xedja\u0165. T\xe1 sa vyu\u017Eije pri vy\u0161\u0161\xedch cen\xe1ch (stredn\xe1 a vysok\xe1 cena).","settings.spot.battery.stop_discharge_low_price.subtitle":"Riadenie uschov\xe1 energii na stredn\xfa a vysok\xfa cenu energie","settings.spot.battery.stop_discharge_middle_price.subtitle":"Riadenie uschov\xe1 energiu na vysok\xfa cenu energie","settings.spot.battery_all_overflow_price":"Minim\xe1lna cena pre vyb\xedjanie celej kapacity bat\xe9rie","settings.spot.battery_all_overflow_price.help":"Ak je cena spotu vy\u0161\u0161ia ne\u017E t\xe1to hodnota, dojde v t\xfdchto hodin\xe1ch k vyb\xedjaniu kapacity bat\xe9rie do siete a\u017E do nastaven\xe9ho minim\xe1lneho SOC. To znamen\xe1, \u017Ee v bat\xe9rii nebude uchov\xe1van\xe1 energia pre no\u010Dn\xfa a rann\xfa spotrebu. Po vybit\xed bat\xe9rie do siete sa bude pre spotrebu objektu nakupova\u0165 energia z siete","settings.spot.battery_all_overflow_price.subtitle":"V bat\xe9rii sa uchov\xe1 energie pre denn\xfa spotrebu","settings.spot.battery_charge":"Povolen\xe9 nab\xedjanie bat\xe9rie pod\u013Ea spotu","settings.spot.battery_charge.help":"Ak zvol\xedte t\xfato mo\u017Enos\u0165, tak syst\xe9m napl\xe1nuje nab\xedjanie v dobe najni\u017E\u0161\xedch cien. Berie do \xfavahy aktu\xe1lnu \xfarove\u0148 nabitia bat\xe9rie a jej kapacitu. Na z\xe1klade t\xfdchto parametrov zvol\xed d\u013A\u017Eku nab\xedjania tak, aby do\u0161lo k jej nabitiu za \u010Do najni\u017E\u0161iu cenu.","settings.spot.battery_charge.subtitle":"Riadenie bat\xe9rie pod\u013Ea spotu zv\xfd\u0161i amortiz\xe1ciu bat\xe9rie","settings.spot.battery_max_soc":"Fin\xe1lne SOC bat\xe9rie","settings.spot.battery_max_soc.subtitle":"Maxim\xe1lne nabitie bat\xe9rie pri nab\xedjan\xed zo siete","settings.spot.battery_overflow":"Povoli\u0165 vyb\xedjanie bat\xe9rie do siete pod\u013Ea spotu","settings.spot.battery_overflow.help":"Ak zvol\xedte t\xfato mo\u017Enos\u0165, tak syst\xe9m napl\xe1nuje vyb\xedjanie bat\xe9rie do siete v dobe najvy\u0161\u0161ej dennej ceny a vybije len t\xfa energiu, ktor\xe1 nebude potrebn\xe1 na be\u017En\xfa spotrebu objektu. Parametre ni\u017E\u0161ie je mo\u017En\xe9 definova\u0165 v\xfd\u0161ku ceny pre vybitie celej kapacity bat\xe9rie a vybitie len tej \u010Dasti kapacity bat\xe9rie, ktor\xe1 nebude potrebn\xe1 pre no\u010Dn\xfa spotrebu.","settings.spot.battery_overflow.subtitle":"Umo\u017En\xed vybi\u0165 nadbytok energie z bat\xe9rie do siete v najv\xfdhodnej\u0161iu hodinu","settings.spot.battery_overflow_price":"Minim\xe1lna cena pre vyb\xedjanie bat\xe9rie","settings.spot.battery_overflow_price.help":"Ak je cena spotu vy\u0161\u0161ia ne\u017E t\xe1to hodnota, dojde v t\xfdchto hodin\xe1ch k vyb\xedjaniu nadbyto\u010Dnej kapacity bat\xe9rie do siete. To znamen\xe1, \u017Ee v bat\xe9rii sa uchov\xe1va energia pre no\u010Dn\xfa a rann\xfa spotrebu objektu. Nebude teda doch\xe1dza\u0165 k nakupovaniu energie z siete","settings.spot.battery_overflow_price.subtitle":"V bat\xe9rii sa uchov\xe1 energie pre no\u010Dn\xfa spotrebu","settings.spot.battery_strategy":"Strat\xe9gia spotov\xe9ho nab\xedjania bat\xe9rie","settings.spot.battery_strategy.help":"T\xfdmto posuvn\xedkom m\xf4\u017Eete jednoducho nastavi\u0165 preferenciu vyu\u017Eitia bat\xe9rie pri spotovom obchodovan\xed. Ni\u017E\u0161ie hodnoty (od 20 %) znamenaj\xfa men\u0161ie cyklovanie bat\xe9rie a teda menej \u010Dast\xe9 nab\xedjanie/vyb\xedjanie za spotov\xe9 ceny. Vy\u0161\u0161ie hodnoty (a\u017E do 70 %) znamenaj\xfa opak.","settings.spot.battery_strategy_service.subtitle":"Touto vo\u013Ebou povol\xedte koncov\xfdm pou\u017E\xedvate\u013Eom nastavi\u0165 strat\xe9giu bat\xe9rie na z\xe1lo\u017Eke Spot","settings.spot.battery_strategy_user":"Umo\u017Eni\u0165 nastavenie strat\xe9gie bat\xe9rie pou\u017E\xedvate\u013Eom","settings.spot.battery_strategy_user.subtitle":"20 % = Sk\xf4r vyu\u017E\xedva\u0165 bat\xe9riu pre FVE. 70 % = Sk\xf4r vyu\u017E\xedva\u0165 bat\xe9riu pre Spot.","settings.spot.install":"Spotov\xe9 obchodovanie akt\xedvne","settings.spot.latitude":"Zemepisn\xe1 \u0161\xedrka","settings.spot.latitude.mess":"\u0160\xedrka","settings.spot.longitude":"Zemepisn\xe1 d\u013A\u017Eka","settings.spot.longitude.mess":"D\u013A\u017Eka","settings.spot.min_difference_price_charge_from_grid":"Minim\xe1lny rozdiel ceny na spotu pre nab\xedjanie bat\xe9rie zo siete","settings.spot.min_difference_price_charge_from_grid.help":"T\xfdmto parametrom je mo\u017En\xe9 riadi\u0165 nab\xedjanie bat\xe9rie zo spotu pri n\xedzkom rozdiele medzi najni\u017E\u0161ou a najvy\u0161\u0161ou cenou. Ak je parameter 2 K\u010D a rozdiel medzi najvy\u0161\u0161ou cenou (3 K\u010D) a najni\u017E\u0161ou cenou (1 K\u010D) spotu je ni\u017E\u0161\xed, tak sa ten de\u0148 nab\xedjanie bat\xe9rie zo siete nenapl\xe1nuje.","settings.spot.min_difference_price_charge_from_grid.subtitle":"Minim\xe1lny rozdiel ceny na spotu po\u010Das d\u0148a, aby mohlo d\xf4js\u0165 k nab\xedjaniu bat\xe9rie zo siete","settings.spot.overflow":"Povoli\u0165 optimaliz\xe1ciu pretoku pod\u013Ea spotu","settings.spot.overflow.help":"Ak zvol\xedte t\xfato mo\u017Enos\u0165, tak syst\xe9m uprednostn\xed pretok do siete pred nab\xedjan\xedm bat\xe9rie v dobe vy\u0161\u0161\xedch a stredn\xfdch spotov\xfdch cien. Deje sa len v ro\u010Dn\xfdch obdobiach, v ktor\xfdch predpoklad\xe1me prebytok energie z FVE a doch\xe1dza k tomu zvy\u010Dajne r\xe1no. Optimaliz\xe1cia neprebieha v n\xedzkej spotovej cene, ke\u010F je prioritou nab\xedjanie bat\xe9rie z FVE.","settings.spot.overflow.subtitle":"Umo\u017En\xed uprednostnenie pretoku pred akumul\xe1ciou","settings.spot.overflow_offset":"Maxim\xe1lny pretok pri z\xe1pornej cene","settings.spot.overflow_offset.help":"Hodnota ud\xe1va pretok do distribu\u010Dnej siete pri z\xe1pornej cene. T\xfato funkciu odpor\xfa\u010Dame vyu\u017E\xedva\u0165 v pr\xedpade energetick\xe9 komunity.","settings.spot.overflow_offset.subtitle":"Hodnotu nie je mo\u017En\xe9 nastavi\u0165 vy\u0161\u0161iu ako maxim\xe1lny pretok","settings.spot.price.period":"\u010Casov\xe9 rozli\u0161en\xed","settings.spot.price_above_price":"Nastaven\xe1 cena spotu","settings.spot.price_below":"Nastaven\xe1 cena spotu","settings.spot.price_distribution_hi":"Cena za distrib\xfaciu vo vysokom tarife","settings.spot.price_distribution_hi.help":"Cena za distrib\xfaciu vo vysokom tarife v k\u010D/kWh. T\xe1to cena sa pripo\u010D\xedtava k cene spotu, ak je akt\xedvny vysok\xfd tarif. Musia by\u0165 nastaven\xe9 \u010Dasy HDO pre spr\xe1vny v\xfdpo\u010Det ceny vo vysokom a n\xedzkom tarife. T\xfato sumu h\u013Eadajte vo vy\xfa\u010Dtovan\xed za elektrinu.","settings.spot.price_distribution_low":"Cena za distrib\xfaciu v n\xedzkom tarife","settings.spot.price_distribution_low.help":"Cena za distrib\xfaciu v n\xedzkom tarife v k\u010D/kWh. T\xe1to cena sa pripo\u010D\xedtava k cene spotu, ak je akt\xedvny n\xedzk\xfd tarif. Musia by\u0165 nastaven\xe9 \u010Dasy HDO pre spr\xe1vny v\xfdpo\u010Det ceny vo vysokom a n\xedzkom tarife. T\xfato sumu h\u013Eadajte vo vy\xfa\u010Dtovan\xed za elektrinu.","settings.spot.price_offset":"Cena pre z\xe1kaz pretokov","settings.spot.price_offset.help":"Odpor\xfa\u010Dame nastavi\u0165 minim\xe1lne vo v\xfd\u0161ke prov\xedzie/poplatku obchodn\xedkovi za predaj pretokov do siete.","settings.spot.price_offset.subtitle":"Minim\xe1lna cena spotu, pod ktorou sa zakazuj\xfa pretoky. Hodnota je porovn\xe1van\xe1 s denn\xfdm trhom bez distribu\u010Dnej sadzby.","settings.spot.region":"Region","settings.thermostat.hp-blocked":"Blok\xe1cia tepeln\xe9ho \u010Derpadla","settings.thermostat.hysteresis":"Hystereza teploty","settings.thermostat.install":"Termostat akt\xedvny","settings.thermostat.name.label":"N\xe1zov","settings.thermostat.name1":"Pomenovanie termostatu 1","settings.thermostat.name2":"Pomenovanie termostatu 2","settings.thermostat.name3":"Pomenovanie termostatu 3","settings.thermostat.name4":"Pomenovanie termostatu 4","settings.thermostat.nominal":"Nomin\xe1lny pr\xedkon zdroja","settings.thermostat.number-of-thermostat":"Po\u010Det termostatov","settings.utility":"Parametre domu","settings.utility.loadpercent":"Aktu\xe1lna zat\xed\u017Een\xed jisti\u010De","settings.utility.numberofphase":"Trojf\xe1zov\xe1 instalace","settings.utility.settings.ampers":"Velikost jisti\u010De","settings.utility.settings.loadpercent":"Krizov\xe9 zat\xed\u017Een\xed","settings.utility.settings.loadpercent_max":"Pri prekro\u010Den\xed doch\xe1dza k obmedzovaniu spotreby","settings.wallbox":"Wallbox","settings.wallbox.install":"Wallbox akt\xedvny","settings.wallbox.name":"N\xe1zov wallboxu {number}","settings.wallbox.spot":"Wallbox","shellies.list":"Shellies","shellies.mqtt_broker_running":"Stav MQTT Brokerka","shellies.settings":"Nastavenie","shellies.settings.boiler.active":"Bojler pripojen\xfd cez Shellies","shellies.settings.boiler.id":"ID shellies","shellies.settings.boiler.id.label":"ID","shellies.title":"Shellies","spot.chartview":"Zobrazi\u0165 cenu bez distribu\u010Dn\xe9ho poplatku","spot.draft":"Re\u017Eimy pre dne\u0161ok","spot.draft.actualpricehi":"Aktu\xe1lna cena je vysok\xe1, zni\u017E spotrebu","spot.draft.actualpricelow":"Aktu\xe1lna cena je n\xedzk\xe1, zvy\u0161 spotrebu","spot.draft.hesLevel":"\xdarove\u0148 riadenia HES","spot.draft.hiprice":"Hranice sn\xed\u017Een\xe9ho odberu","spot.draft.info":"Re\u017Eimy a odpor\xfa\u010Dania pre dne\u0161n\xfd de\u0148","spot.draft.lowprice":"Hranice zv\xfd\u0161en\xe9ho odberu","spot.draft.todaystatus_HP":"Akumul\xe1cia tepeln\xe9ho \u010Derpadla","spot.draft.todaystatus_HW":"Akumul\xe1cia teplej vody","spot.draft.todaystatus_bat":"Akumul\xe1cia bat\xe9rie","spot.draft.todaystatus_em":"Pretok","spot.explanation":"Vysvetlenie re\u017Eimov","spot.explanation.battery_discharge_to_grid":"Vyb\xedjanie bat\xe9rie do siete","spot.explanation.battery_discharge_to_home":"Vyb\xedjanie bat\xe9rie","spot.explanation.hw":"Nab\xedjanie bat\xe9rie zo siete","spot.explanation.info":"Detailn\xe9 vysvetlenie re\u017Eimov pre dne\u0161n\xfd de\u0148","spot.flexibility":"Odhad flexibility pre dne\u0161ek","spot.prediction":"Odhady energi\xed pre dne\u0161ek","spot.prediction.battery":"Dispozi\u010Dn\xe1 akumul\xe1cia bat\xe9rie","spot.prediction.home":"Be\u017En\xe1 spotreba objektu","spot.prediction.hp":"Tepeln\xe9 \u010Derpadlo","spot.prediction.hw":"Dispozi\u010Dn\xe1 akumul\xe1cia bojleru","spot.prediction.pv":"V\xfdroba elektr\xe1rne","spot.prediction.sale":"Zost\xe1vaj\xfaca energia na predaj prebyto\u010Dkov","spot.prediction.sale.help":"Zost\xe1vaj\xfaca pl\xe1novan\xe1 denn\xe1 v\xfd\u0161ka prebyto\u010Dkov, ktor\xe1 bude uprednostnen\xe1 ako pretok do siete pred akumul\xe1ciou do bat\xe9rie.","spot.price.period.15min":"15 min","spot.price.period.60min":"60 min","spot.region.cz":"CZ","spot.region.nl":"NL","spot.region.sk":"SK","spot.status":"Spotov\xe9 obchodov\xe1n\xed","spot.summary.battery_charge_from_grid":"Nab\xedjanie zo siete","spot.summary.battery_charge_from_grid.help":"Nab\xedjanie bat\xe9rie zo siete pod\u013Ea spotu je mo\u017En\xe9 zak\xe1za\u0165 \u010Di povoli\u0165. Mo\u017Eno tak urobi\u0165 v nastaven\xed. Nab\xedjanie bat\xe9rie syst\xe9m napl\xe1nuje v dobe n\xedzkych cien a berie do \xfavahy aktu\xe1lnu \xfarove\u0148 nabitia bat\xe9rie a jej kapacitu. Na z\xe1klade t\xfdchto parametrov zvol\xed d\u013A\u017Eku nab\xedjania tak, aby do\u0161lo k jej nabitiu za \u010Do najni\u017E\u0161iu cenu.","spot.summary.battery_discharge":"Vyb\xedjen\xed bat\xe9rie","spot.summary.battery_discharge.help":"Vyb\xedjanie bat\xe9rie do objektu na spotu je mo\u017En\xe9 zak\xe1za\u0165 \u010Di povoli\u0165. Mo\u017Eno tak urobi\u0165 v nastaven\xed. Vyb\xedjanie bat\xe9rie sa zvy\u010Dajne zakazuje v dobe n\xedzkych cien, ke\u010F je lep\u0161ie bra\u0165 energiu zo siete a v bat\xe9rii ju uchova\u0165 na drah\u0161ie \u010Dasy.","spot.summary.battery_discharge_to_grid":"Vyb\xedjen\xed do siete","spot.summary.battery_discharge_to_grid.help":"Vyb\xedjanie bat\xe9rie do siete je mo\u017En\xe9 zak\xe1za\u0165 \u010Di povoli\u0165. Mo\u017Eno tak urobi\u0165 v nastaven\xed. Vyb\xedjanie bat\xe9rie do siete ur\u010D\xed syst\xe9m v dobe najvy\u0161\u0161ej dennej ceny a vybije len t\xfa energiu, ktor\xe1 nebude potrebn\xe1 na be\u017En\xfa spotrebu objektu.","spot.summary.boiler":"Bojler","spot.summary.boiler.help":"Predohrievanie bojlera syst\xe9m napl\xe1nuje v dobe n\xedzkych cien a berie do \xfavahy aktu\xe1lnu teplotu vody v bojleri, jeho kapacitu a po\u017Eadovan\xfa teplotu. Na z\xe1klade t\xfdchto parametrov zvol\xed d\u013A\u017Eku predohrievania tak, aby do\u0161lo k jeho nahriatiu.","spot.summary.heat_pump":"Tepeln\xe9 \u010Derpadlo","spot.summary.heat_pump.help":"Tepeln\xe9 \u010Derpadlo m\xf4\u017Ee be\u017Ea\u0165 v troch re\u017Eimoch: zv\xfd\u0161en\xfd v\xfdkon, be\u017En\xfd chod a obmedzen\xfd v\xfdkon. Zv\xfd\u0161en\xfd v\xfdkon sa vyu\u017E\xedva v dobe n\xedzkych cien, be\u017En\xfd chod v dobe stredn\xfdch cien a obmedzen\xfd v\xfdkon v dobe vysok\xfdch cien. Odlo\u017Eenie spotreby \u010Di zv\xfd\u0161enie spotreby mo\u017Eno povoli\u0165 v menu tepeln\xe9ho \u010Derpadla.","spot.summary.heat_pump_level.increase":"Z\xfd\u0161en\xfd v\xfdkon","spot.summary.heat_pump_level.normal":"Be\u017En\xfd chod","spot.summary.heat_pump_level.reduction":"Omezen\xfd v\xfdkon","spot.summary.price":"Cena","spot.summary.price_buy":"Cena s distribu\u010Dnou","spot.summary.price_distribution":"Distribu\u010Dn\xe1","spot.summary.price_level":"\xdarove\u0148 ceny","spot.summary.price_level.help":"Infigy zorad\xed hodinov\xe9 ceny spotu od najni\u017E\u0161ej po najvy\u0161\u0161iu a rozdel\xed ich do troch \u010Dast\xed, pribli\u017Ene rovnako ve\u013Ek\xfdch. Ak hodinov\xe9 ceny za\u010D\xednaj\xfa na hodnote 3 K\u010D a kon\u010Dia na hodnote 10 K\u010D, tak n\xedzka cena m\xf4\u017Ee ma\u0165 rozptyl 3-6 K\u010D, stredn\xe1 6-7 K\u010D a vysok\xe1 7-10 K\u010D. Rozptyl bude ka\u017Ed\xfd de\u0148 in\xfd, z\xe1le\u017E\xed na po\u010Detnosti hodn\xf4t v danej \xfarovni ceny.","spot.summary.price_level.hi":"Vysok\xe1 cena","spot.summary.price_level.low":"N\xedzk\xe1 cena","spot.summary.price_level.mid":"Stredn\xe1 cena","spot.summary.price_level_15m":"Hladina ceny (15 min)","spot.summary.price_sell":"Cena bez distribu\u010Dnej","spot.summary.spotOverflow":"Pretok do distribu\u010Dnej siete.","spot.summary.spotOverflow.allowed":"Povolen\xe9","spot.summary.spotOverflow.help":"Povolenie pretoku do siete pri spotovom obchodovan\xed porovn\xe1va cenu spotu v dan\xfa hodinu a ak je ni\u017E\u0161ia ako Cena pre z\xe1kaz pretokov z nastavenia, tak syst\xe9m automaticky v dan\xfa hodinu pretok zak\xe1\u017Ee.","spot.summary.spotOverflow.restricted":"Omezen\xfd","spot.summary.state.active":"Akt\xedvne","spot.summary.state.inactive":"Neakt\xedvne","spot.summary.time":"\u010Cas","spot.user.parameters":"Parametre spotov\xe9ho obchodovania","spot_wizard.banner.button":"Potrebujete pomoc? M\xf4\u017Eem V\xe1m pom\xf4c\u0165","spot_wizard.banner.subtitle":"Sprievodca v\xe1m pom\xf4\u017Ee nastavi\u0165 spotov\xe9 obchodovanie","spot_wizard.banner.title":"Potrebujete pomoc? M\xf4\u017Eem V\xe1m pom\xf4c\u0165","spot_wizard.battery_discharge.paragraph1":"Toto nastavenie zak\xe1\u017Ee vyb\xedjanie baterie pri n\xedzkom tarife spotu. D\xedky tomu si uchov\xe1te energiu pre vy\u0161\u0161ie ceny d\u0148a.","spot_wizard.battery_discharge.paragraph2":"Ak m\xe1te len predaj energie na spotu, m\xf4\u017Eete z\xe1kaz deaktivova\u0165.","spot_wizard.battery_discharge.title":"Vyb\xedjanie baterie do vlastn\xe9ho spotrebn\xe9ho odboru","spot_wizard.battery_purchase.paragraph1":"Toto nastavenie umo\u017En\xed pri n\xedzkom v\xfdrobe elektr\xe1rne nab\xedt bateriu z n\xedzk\xe9ho tarife spotu.","spot_wizard.battery_purchase.paragraph2":"Venujte pozornos\u0165 nastaveniu strat\xe9gie. Ak nastav\xedte 20%, Infigy bude sp\xed\u0161e \u010Daka\u0165 na fotovoltaiku. Naopak pri nastaven\xed 70% bude sp\xed\u0161e nakupova\u0165 na spotu. Doporu\u010D\xedme nastavi\u0165 25%.","spot_wizard.battery_purchase.paragraph3":"Ak m\xe1te len predaj energie na spotu, m\xf4\u017Eete nab\xedjanie deaktivova\u0165.","spot_wizard.battery_purchase.title":"K\xfapa energie do bat\xe9rie","spot_wizard.boiler.paragraph1":"Toto nastavenie umo\u017En\xed pri n\xedzkom v\xfdrobe elektr\xe1rne ohrieva\u0165 bojler z najlacnej\u0161\xedch cen d\u0148a do nastavenej teploty. Infigy st\xe1le udr\u017Euje z\xe1kladn\xfa teplotu a vyu\u017E\xedva nav\xfd\u0161enie teploty na teplotu zo spotu.","spot_wizard.boiler.paragraph2":"Z\xe1rove\u0148 je mo\u017En\xe9 blokova\u0165 ohrev pri strednej a alebo vysok\xfdch cen\xe1ch.","spot_wizard.boiler.paragraph3":"Ak m\xe1te len predaj energie na spotu, m\xf4\u017Eete teplotu nastavi\u0165 na 10\xb0C a deaktivova\u0165 blok\xe1ciu ohrevu.","spot_wizard.boiler.title":"Ohrev bojleru","spot_wizard.dialog.finish":"Dokon\u010Di\u0165","spot_wizard.dialog.next":"\u010Eal\u0161\xed","spot_wizard.dialog.prev":"Sp\xe4\u0165","spot_wizard.dialog.step":"Krok {current} z {total}","spot_wizard.dialog.title":"Sprievodca nastaven\xedm spotu","spot_wizard.distribution_prices.title":"Zadajte cenu za distrib\xfaciu v n\xedzkom a vysokom tarife","spot_wizard.done.description":"Pre\u0161li ste nastaven\xedm spotu. V\u0161etky parametre je mo\u017En\xe9 upravi\u0165 v spodnej \u010Dasti str\xe1nky Spot, kde m\xf4\u017Eete tie\u017E op\xe4\u0165 vyvola\u0165 tohto sprievodcu.","spot_wizard.done.title":"Dokon\u010Den\xe9","spot_wizard.evening_peak_discharge.paragraph1":"Infigy automaticky odhadne spotrebu energie do rann\xfdch hod\xedn. Nadbytok m\xf4\u017Ee by\u0165 predajn\xfd za najvy\u0161\u0161iu cenu d\u0148a.","spot_wizard.evening_peak_discharge.paragraph2":"Ak m\xe1te len n\xe1kup energie na spotu, m\xf4\u017Eete vyb\xedjanie deaktivova\u0165.","spot_wizard.evening_peak_discharge.title":"Vyb\xedjanie bat\xe9rie pri ve\u010Dernom vrchu","spot_wizard.general_settings.title":"Najprv obecn\xe9 nastavenie","spot_wizard.hdo_times.title":"Nastavenie HDO \u010Dasov ur\u010D\xed obdobie n\xedzk\xe9ho tarifu","spot_wizard.heat_pump.paragraph1":"Toto nastavenie umo\u017En\xed pri n\xedzkom v\xfdrobe elektr\xe1rne navy\u0161ova\u0165 v\xfdkon tepeln\xe9ho \u010Derpadla pri n\xedzkom tarife a naopak zn\xed\u017Ei\u0165 v\xfdkon pri vysok\xfdch cen\xe1ch.","spot_wizard.heat_pump.paragraph2":"Ak m\xe1te len predaj energie na spotu, odlo\u017Eenie i zv\xfd\u0161enie spotreby deaktivova\u0165.","spot_wizard.heat_pump.title":"Tepeln\xe9 \u010Derpadlo","spot_wizard.info.button1":"Pre\u010Do nie je m\xf4j bat\xe9ria dnes nab\xedjan\xe1 zo spotu?","spot_wizard.info.button2":"Pre\u010Do nie je m\xf4j bat\xe9ria dnes vyb\xedjan\xe1 do spotu?","spot_wizard.info.button3":"Potrebujem pomoc s nastaven\xedm","spot_wizard.info.help1.title":"Pre\u010Do nie je m\xf4j bat\xe9ria dnes nab\xedjan\xe1 zo spotu?","spot_wizard.info.help2.title":"Pre\u010Do nie je m\xf4j bat\xe9ria dnes vyb\xedjan\xe1 do spotu?","spot_wizard.info.title":"Inform\xe1cie o spotovom obchodovan\xed","spot_wizard.overflow_limit.paragraph1":"Ak m\xe1te spot len pre n\xe1kup energie, m\xf4\u017Eete nastavi\u0165 -10 K\u010D. Pretok je obmedzen\xfd na maxim\xe1lnu ve\u013Ekos\u0165 nastaven\xfa servisn\xfdm technikom.","spot_wizard.overflow_limit.paragraph2":"Ak m\xe1te spot aj pre predaj energie, je v\xfdhodn\xe9 zastavi\u0165 akumul\xe1ciu pri cene, ktor\xe1 odpoved\xe1 prov\xedzii Va\u0161eho dod\xe1vate\u013Ea. Prov\xedzia je naj\u010Dastej\u0161ie 0.30 - 0.70 K\u010D/kWh.","spot_wizard.overflow_limit.title":"Omezenie pretoku do siete","spot_wizard.preferential_sale.paragraph1":"T\xe1to funkcia nastav\xed prioritu pretoku do siete po\u010Das rann\xe9ho vrcholu. Energia sa prednostne pred\xe1va do siete namiesto akumul\xe1cie do bat\xe9rie, bojlera a tepeln\xe9ho \u010Derpadla. Akumul\xe1cia sa znova aktivuje pri n\xedzkej cene alebo po predaji odhadovan\xe9ho nadbytku energie.","spot_wizard.preferential_sale.paragraph2":"Ak m\xe1te len n\xe1kup energie na spotu, m\xf4\u017Eete funkciu deaktivova\u0165.","spot_wizard.preferential_sale.title":"Prednostn\xfd predaj energie","statistics.battery.statistics":"\xdarove\u0148 nabitia bat\xe9rie","statistics.boiler.statistics":"Ohrev bojlera elektrokotlom","statistics.electrical_grid.statistics":"N\xe1kup z distribu\u010Dnej siete","statistics.electrical_grid.statistics_house_consumption":"Spotreba objektu","statistics.electrical_grid.statistics_overflow":"Pretok do distribu\u010Dnej siete","statistics.heatpump.statistics":"Spotreba kompresoru","statistics.outdoor_temperature.statistics":"Vonkaj\u0161ia teplota","statistics.photovoltaics.statistics":"V\xfdroba elektr\xe1rne","statistics.plug.statistics":"Spotreba z\xe1suvky","statistics.wind.statistics":"V\xfdroba vetern\xe9 elektr\xe1rne","stats_delete.button":"Smaza\u0165","stats_delete.cancel":"Zru\u0161i\u0165","stats_delete.confirm":"Smaza\u0165","stats_delete.confirm.title":"Naozaj chcete smazat v\u0161etky \u0161tatistiky?","stats_delete.title":"Smaza\u0165 v\u0161etky \u0161tatistiky","stats_export.button":"Export","stats_export.from":"Od","stats_export.metric":"Metrika","stats_export.title":"Exportovat statistiky","stats_export.to":"Od","status.heatWater.flexibility":"Flexibilita akt\xedvna, vykurovanie teplej vody","status.heatWater.heating":"Vykurovanie teplej vody","status.heatWater.hwError":"Bojler je nahriaty nebo nedostupn\xfd","status.heatWater.inverterError":"Predohrev bojlera neakt\xedvny, nie je dostupn\xfd strieda\u010D","status.heatWater.legionella":"Sanace vody","status.heatWater.notConnected":"Nemo\u017Eno nadviaza\u0165 spojenie","status.heatWater.notLicensed":"Riadenie bojlera nie je licencovan\xe9","status.heatWater.off":"Vypnut\xe9","status.heatWater.overload":"Pre\u0165a\u017Eenie siete, vykurovanie zastaven\xe9","status.heatWater.pvHeating":"Vykurovanie z prebyto\u010Dkov","status.heatWater.smartMeterError":"Predohrev bojlera neakt\xedvny, nie je dostupn\xfd elektromer","status.heatWater.spotHeating":"Vykurovanie teplej vody zo spotu","status.heatWater.stop":"STOP","status.heatWater.stopHDO":"Ohrev blokovan\xfd pri vysokom tarife","status.heatWater.stopSOC":"Blok\xe1cia vykurovania, n\xedzk\xfd stav bat\xe9rie","status.heatWater.stopSell":"Predohrev blokovan\xfd, predaj energie","status.heatWater.tempError":"Teplotn\xe9 \u010Didlo nie je dostupn\xe9","status.photovoltaic.dischargeBlockedByComponents":"Vyb\xedjanie baterie pozastaven\xe9 kv\xf4li spotrebe vybran\xfdch technol\xf3gi\xed","status.photovoltaic.dischargeBlockedByHDO":"Vyb\xedjanie baterie pozastaven\xe9, akt\xedvny vysok\xfd tarif (HDO)","status.photovoltaic.discharging":"Vyb\xedjanie bat\xe9rie","status.photovoltaic.distributionLimit":"Distribu\u010Dn\xe1 omezenie v\xfdkonu","status.photovoltaic.feedInPriority":"Priorita pretoku do siete","status.photovoltaic.flexibilityBatteryStop":"Flexibilita akt\xedvna, zastaven\xe9 vyb\xedjanie aj nab\xedjanie bat\xe9rie","status.photovoltaic.flexibilityCharging":"Flexibilita akt\xedvna, nab\xedjanie baterie zo siete","status.photovoltaic.flexibilityDischarging":"Flexibilita akt\xedvna, vyb\xedjanie baterie do siete","status.photovoltaic.flexibilityDoNotDischarge":"Flexibilita akt\xedvna, z\xe1kaz vyb\xedjania bat\xe9rie","status.photovoltaic.flexibilityFeedInPriority":"Flexibilita akt\xedvna, prednostn\xfd predaj energie do siete","status.photovoltaic.flexibilityOverflowRestricted":"Flexibilita akt\xedvna, z\xe1kaz pretoku do siete","status.photovoltaic.forcedOverflow":"Flexibilita akt\xedvna, vyn\xfaten\xfd pretok do siete","status.photovoltaic.idle":"Re\u017Eim sp\xe1nku","status.photovoltaic.manualCharging":"Ru\u010Dn\xe9 nab\xedjanie bat\xe9rie","status.photovoltaic.manualDischarging":"Ru\u010Dn\xe9 vyb\xedjanie bat\xe9rie","status.photovoltaic.noneInverter":"Typ strieda\u010Da nenastaven\xfd","status.photovoltaic.notConnected":"Nemo\u017Eno nadviaza\u0165 spojenie","status.photovoltaic.notLicensed":"Riadenie FVE nie je licencovan\xe9","status.photovoltaic.planCharge":"Pl\xe1novan\xe9 nab\xedjanie bat\xe9rie","status.photovoltaic.planDischarge":"Pl\xe1novan\xe9 vyb\xedjanie bat\xe9rie","status.photovoltaic.production":"V\xfdroba energie","status.photovoltaic.sellBatteryEnergy":"Predaj energie z bat\xe9rie","status.photovoltaic.spotCharging":"Nab\xedjanie baterie zo spotu","status.photovoltaic.spotStopDischarging":"Zastaven\xe9 vyb\xedjanie, je n\xedzk\xe1 cena na spotu","status.photovoltaic.standby":"Stand-by re\u017Eim","status.photovoltaic.startUp":"Startovac\xed re\u017Eim","status.plug.batteryControl":"Z\xe1suvka akt\xedvna pod\u013Ea bat\xe9rie","status.plug.manualControl":"Z\xe1suvka akt\xedvna v manu\xe1lnom m\xf3de","status.plug.notActive":"Z\xe1suvka neakt\xedvna","status.plug.notConnected":"Z\xe1suvka nie je dostupn\xe1","status.plug.overflowControl":"Z\xe1suvka akt\xedvna pod\u013Ea pretoku","status.plug.spotControl":"Z\xe1suvka akt\xedvna pod\u013Ea spotu","status.plug.stop":"STOP","status.plug.timeControl":"Z\xe1suvka akt\xedvna pod\u013Ea \u010Dasu","status.smartMeter.consumption":"Be\u017En\xfd odber domu","status.smartMeter.maxLoad":"Maxim\xe1lny odber domu","status.smartMeter.none":"","status.smartMeter.overflow":"Pretok energie","status.smartMeter.overflowLimited":"Pretok obmedzen\xfd z d\xf4vodu z\xe1pornej ceny","status.smartMeter.shortage":"V\xfdpadek distribu\u010Dnej siete","status.spotBattery.flexibilityPV":"Flexibilita vyu\u017Eita pre FVE","status.spotBattery.flexibilitySpot":"Flexibilita vyu\u017Eita pre SPOT","status.spotBattery.noData":"Pre riadenie nie s\xfa aktu\xe1lne d\xe1ta","status.spotBattery.spotNotLicensed":"Spot nie je licencovan\xfd","status.spotBatteryChargeFromGrid.batteryChargingNotActive":"Nen\xed aktivovan\xe9 nab\xedjanie z siete","status.spotBatteryChargeFromGrid.batteryChargingPlanned":"Dnes je nab\xedjanie akt\xedvne","status.spotBatteryChargeFromGrid.enoughPVEnergy":"Dnes sa o\u010Dak\xe1va denn\xfd prebytok pre nabitie bat\xe9rie","status.spotBatteryChargeFromGrid.priceDifferenceTooLow":"Dnes nie je splnen\xfd minim\xe1lny rozdiel ceny","status.spotBatteryChargeFromGrid.spotNotActive":"Nen\xed akt\xedvne spotov\xe9 obchodovanie","status.spotBatteryDischargeToGrid.batteryDischargingNotActive":"Nen\xed aktivovan\xe9 vyb\xedjanie do siete","status.spotBatteryDischargeToGrid.batteryDischargingPlanned":"Dnes je vyb\xedjanie akt\xedvne","status.spotBatteryDischargeToGrid.minPriceNotReached":"Dnes nie je splnen\xe1 minim\xe1lna cena pre predaj","status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy":"Dnes sa o\u010Dak\xe1va vybitie bat\xe9rie cez noc do vlastnej spotreby","status.spotBatteryDischargeToGrid.spotNotActive":"Nen\xed akt\xedvne spotov\xe9 obchodovanie","status.spotBatteryDischargeToHome.automaticDischargeMode":"Automatick\xe9 vyb\xedjanie bat\xe9rie dle kapacity","status.spotBatteryDischargeToHome.highPriceDischargeMode":"Vyb\xedjanie bat\xe9rie pri vysokej cene","status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode":"Vyb\xedjanie bat\xe9rie pri strednej a vysokej cene","status.spotBatteryDischargeToHome.notControlled":"Vyb\xedjanie bat\xe9rie nie je obmedzen\xe9","status.spotHeatPump.flexibilityPV":"Flexibilita vyu\u017Eit\xe1 pre FVE","status.spotHeatPump.flexibilitySpot":"Flexibilita vyu\u017Eit\xe1 pre SPOT","status.spotHeatPump.noData":"Pre riadenie nie s\xfa aktu\xe1lne d\xe1ta","status.spotHeatPump.spotNotLicensed":"Spot nie je licencovan\xfd","status.spotHeatWater.flexibilityPV":"Flexibilita vyu\u017Eit\xe1 pre FVE","status.spotHeatWater.flexibilitySpot":"Flexibilita vyu\u017Eit\xe1 pre SPOT","status.spotHeatWater.noData":"Pre riadenie nie s\xfa aktu\xe1lne d\xe1ta","status.spotHeatWater.spotNotLicensed":"Spot nie je licencovan\xfd","status.spotSmartMeter.noData":"Pre riadenie nie s\xfa aktu\xe1lne d\xe1ta","status.spotSmartMeter.overflowDisabled":"Trval\xe9 obmedzenia pretoku energie","status.spotSmartMeter.overflowFlexibilitySell":"Optimaliz\xe1cia pretoku pre predaj","status.spotSmartMeter.overflowLimited":"Pretok obmedzen\xfd z d\xf4vodu z\xe1pornej ceny","status.spotSmartMeter.spotNotLicensed":"Spot nie je licencovan\xfd","status.spotSmartMeter.withoutReduction":"Bez obmedzenia pretoku energie","status.wind.production":"V\xfdroba elektriny","status.wind.stop":"STOP","status.wind.unavailable":"Zariadenie nie je dostupn\xe9","subscriptions.fetch":"Aktualizova\u0165 predplatn\xe9","subscriptions.fetch.button":"Aktualizova\u0165 predplatn\xe9","subscriptions.last_fetch_at":"Posledn\xed aktualizace","subscriptions.premium_active":"Premium akt\xedvny","subscriptions.title":"Predplatn\xe9","test-product.app":"Aplik\xe1cia","test-product.settings":"Nastavenie aplik\xe1cie","test-product.settings.distribution":"Distrib\xfacia","test-product.settings.distribution.Dzd":"DZD","test-product.settings.distribution.Infigy":"Infigy","test-product.settings.distribution.solid_sun":"SolidSun","test-product.settings.license":"Licence","test-product.settings.license.HW":"HW","test-product.settings.license.Industrial":"Industrial","test-product.settings.license.Play":"PLAY","test-product.settings.license.Smart":"Smart","test-product.settings.license.basic":"Basic","test-product.test":"Test zariadenia","test-product.test.DC":"Kontrola DC obvodu","test-product.test.DC.subtitle":"Dota\u017Eenie svoriek, dimenzie k\xe1blov","test-product.test.component":"Kontrola komponentov","test-product.test.component.subtitle":"Je prilo\u017Een\xe9 \u010Didlo, \u0161t\xedtky, ...?","test-product.test.electricmeter":"Kontrola elektromera","test-product.test.electricmeter.subtitle":"Kontrola osadenia elektromera pre strieda\u010D","test-product.test.internet-connect":"Pripojenie k internetu","test-product.test.inverter-connect":"Pripojenie strieda\u010Da","test-product.test.license":"Licencia","test-product.test.license-info":"Test skon\u010D\xed za:","test-product.test.phase_1":"Test 1. f\xe1ze","test-product.test.phase_2":"Test 2. f\xe1ze","test-product.test.phase_3":"Test 3. f\xe1ze","test-product.test.serialNumber":"V\xfdrobn\xed \u010D\xedslo jednotky","test-product.test.serialNumber.label":"S\xe9riov\xe9 \u010D\xedslo","test-product.test.serialNumber.subtitle":"Bez v\xfdrobn\xe9ho \u010D\xedsla nemo\u017Eno zada\u0165 meno testera a aktivova\u0165 test","test-product.test.serialNumberSwitchboard":"V\xfdrobn\xe9 \u010D\xedslo rozv\xe1dza\u010Da","test-product.test.serialNumberSwitchboard.label":"S\xe9riov\xe9 \u010D\xedslo","test-product.test.serialNumberSwitchboard.subtitle":"Vyplni\u0165 v pr\xedpade, \u017Ee je zariadenie v origin\xe1lnom rozv\xe1dza\u010Di","test-product.test.start":"Ak je zariadenie pripojen\xe9","test-product.test.start.button":"Aktivovat test","test-product.test.switchboard":"Kontrola zhody rozv\xe1dza\u010Da","test-product.test.switchboard.subtitle":"Kontrola dota\u017Eenia svoriek, umiestnenia komponentov, spr\xe1vne dimenzie k\xe1blov","test-product.test.temp":"Teplotn\xed \u010Didlo","test-product.test.tester":"Zariadenie otestoval","test-product.test.tester.subtitle":"Bez mena nemo\u017Eno aktivova\u0165 test","thermostat.general":"Spole\u010Dn\xe9 nastaven\xed","thermostat.general.cooling":"Chladenie akt\xedvne","thermostat.general.cooling.pvstability":"Potenci\xe1l aktiv\xe1cie zdroja","thermostat.general.heating":"Vykurovanie akt\xedvne","thermostat.range":"Termostat","thermostat.range.flexibility-temperature":"Flexibiln\xe1 teplota","thermostat.range.flexibility-temperature.subtitle":"Teplota, o ktor\xfa je mo\u017En\xe9 predohria\u0165 alebo predchladi\u0165 dom","thermostat.range.flexibility_status":"Re\u017Eim flexibility termostatu","thermostat.range.on":"Termostat akt\xedvny","thermostat.range.on.subtitle":"Z\xe1kladn\xe1 teplota","thermostat.range.pv-flexibility":"Riadenie pod\u013Ea fotovoltaiky","thermostat.range.set_temperature":"Nastaven\xe1 teplota","thermostat.range.sp-flexibility-down":"Odlo\u017Eenie spotreby popod\u013Ea spotu","thermostat.range.sp-flexibility-up":"Zv\xfd\u0161enie spotreby popod\u013Ea spotu","thermostat.range.status":"Re\u017Eim termostatu","thermostat.range.temperature":"Aktu\xe1lna teplota","thermostat.statisticsTemp":"Teplota thermostatu","thermostat.status":"Re\u017Eim termostatu","wallbox.3a.on":"M\xf3d 3A","wallbox.3a.on_sub":"Nab\xedjanie m\xf4\u017Ee bra\u0165 3A z distribu\u010Dnej siete","wallbox.6a.on":"M\xf3d 6A","wallbox.6a.on_sub":"Nab\xedjanie len z FVE","wallbox.NO_CHARGE":"Nenab\xedjaj","wallbox.NO_CHARGE.on_sub":"Nab\xedjanie je trvalo blokovan\xe9, spust\xed ho iba \u010Dasov\xfd pl\xe1n","wallbox.PV":"Nab\xedjanie pod\u013Ea bat\xe9rie","wallbox.PV.batteryStart":"Zapn\xfa\u0165 pri nabit\xed","wallbox.PV.batteryStart.subtitle":"Nabitie bat\xe9rie, pri ktorom sa aktivuje nab\xedjanie","wallbox.PV.batteryStop":"Vypn\xfa\u0165 pri nabit\xed","wallbox.PV.batteryStop.subtitle":"Nabitie bat\xe9rie, pri ktorom sa vypne nab\xedjanie","wallbox.PV.on":"Aktivn\xed","wallbox.PV.on_sub":"Po dosiahnut\xed z\xe1kladnej energie d\xf4jde k nab\xedjaniu len pri nabitej bat\xe9rii","wallbox.PV2":"Nab\xedjanie pod\u013Ea FVE","wallbox.PV2.on":"Aktivn\xed","wallbox.PV2.on_sub":"Riadenie nab\xedjania pod\u013Ea v\xfdkonu FVE","wallbox.PV_FAST":"Prednostn\xe9 nab\xedjanie pod\u013Ea bat\xe9rie","wallbox.PV_FAST.batteryMinSoc":"Minim\xe1lna rezerva bat\xe9rie","wallbox.PV_FAST.batteryMinSoc.subtitle":"Bat\xe9ria sa kv\xf4li nab\xedjaniu automobilu nevybije pod t\xfato hodnotu. K\xfdm nie je hodnota prekro\u010Den\xe1, nab\xedjanie \u010Dak\xe1","wallbox.PV_FAST.on_sub":"Nab\xedjanie automobilu bude \xfaplne prioritn\xe9. Bude vyu\u017E\xedvan\xe1 iba energia z bat\xe9rie alebo FVE","wallbox.SPOT":"Nab\xedjanie pod\u013Ea spotu","wallbox.SPOT.hi":"Blokova\u0165 nab\xedjanie pri vysokej cene","wallbox.SPOT.mi":"Blokova\u0165 nab\xedjanie pri strednej cene","wallbox.SPOT.on":"Aktivn\xed","wallbox.SPOT.on_sub":"Po dosiahnut\xed z\xe1kladnej energie d\xf4jde k blokovaniu pri vysokej cene spotu","wallbox.active":"{name}","wallbox.active.subtitle":"Akt\xedvny","wallbox.alfen":"Alfen","wallbox.authorization.status":"Autoriz\xe1cia","wallbox.authorization.status.authorized":"Autorizovan\xe9{cardInfo}","wallbox.authorization.status.denied":"Odmietnut\xe9{cardInfo}","wallbox.authorization.status.pending":"Nie je autorizovan\xe9","wallbox.authorization.status.unknown":"Nezn\xe1my stav","wallbox.az_router":"AZ Router","wallbox.common":"Obecn\xe9 inform\xe1cie","wallbox.common.power":"Aktu\xe1lna spotreba","wallbox.common.power_today":"Dne\u0161n\xe1 spotreba:","wallbox.common.power_total":"Celkov\xe1 spotreba","wallbox.common.power_year":"Ro\u010Dn\xe1 spotreba:","wallbox.control":"Re\u017Eim nab\xedjania","wallbox.ecovolter":"EcoVolter","wallbox.evmate":"EVmate","wallbox.fast-charge":"R\xfdchle nabitie","wallbox.fast-charge.energy":"Energia pre r\xfdchle nabitie","wallbox.fast-charge.energy_actual":"Nab\xedjacia energia v aktu\xe1lnom cykle","wallbox.fast-charge.energy_sub":"Energia, ktor\xe1 je v\u017Edy \u010Do najr\xfdchlej\u0161ie nabit\xe1. Po dosiahnut\xed tejto hodnoty je nabitie riaden\xe9 jedn\xfdm z re\u017Eimov","wallbox.goodwe-ev-charger":"Goodwe","wallbox.inactive.subtitle":"Neakt\xedvny","wallbox.mode.pv.batteryStopConflict.description":"Ak je zapnut\xe1 blok\xe1cia bat\xe9rie pri prev\xe1dzke wallboxu, nie je mo\u017En\xe9 zapn\xfa\u0165 re\u017Eim \u201ENab\xedjanie pod\u013Ea bat\xe9rie\u201C. Pre zapnutie re\u017Eimu \u201ENab\xedjanie pod\u013Ea bat\xe9rie\u201C je nutn\xe9 najprv vypn\xfa\u0165 blok\xe1ciu bat\xe9rie na str\xe1nke \u201EFotovoltaika\u201C.","wallbox.mode.pv.batteryStopConflict.title":"Re\u017Eim nie je mo\u017En\xe9 zapn\xfa\u0165","wallbox.mybox":"MyBox","wallbox.none":"\u017Diadny","wallbox.nonemode":"Be\u017En\xe9 nab\xedjanie","wallbox.nonemode.amper-auto":"Automatick\xe9 riadenie nab\xedjacieho pr\xfadu","wallbox.nonemode.amper-auto.subtitle":"Riadi nab\xedjanie aby sa minimalizovalo nab\xedjanie a vyb\xedjanie bat\xe9rie","wallbox.nonemode.ampers":"Maxim\xe1lny nab\xedjac\xed pr\xfad","wallbox.nonemode.hdo":"Nab\xedjanie len pri n\xedzkom tarife","wallbox.nonemode.hdo_sub":"\u010Casy pre HDO musia by\u0165 nastaven\xe9 v v\u0161eobecnom nastaven\xed","wallbox.nonemode.on":"Aktivn\xed","wallbox.nonemode.on_sub":"Auto sa nab\xedja \u010Do najr\xfdchlej\u0161ie","wallbox.olife":"Olife","wallbox.other":"Ostatn\xe9","wallbox.pv.ampers-auto":"Aktu\xe1lny po\u017Eadovan\xfd nab\xedjac\xed pr\xfad","wallbox.schedules.description":"Napl\xe1nujte si nab\xedjanie elektromobilu pod\u013Ea potreby.","wallbox.schedules.title":"Pl\xe1nova\u010D nab\xedjania","wallbox.settings":"Nastavenie","wallbox.solax":"Solax - komunik\xe1cia cez strieda\u010D","wallbox.solax-ev-charger":"Solax - komunik\xe1cia cez Infigy","wallbox.statistics":"Statistiky","wallbox.status":"Re\u017Eim Wallboxu","wallbox.status.car_not_connected":"Auto nie je pripojen\xe9","wallbox.status.charging":"Nab\xedjanie","wallbox.status.charging_with_ventilation":"Nab\xedjanie auta s ventil\xe1torom","wallbox.status.error":"Chyba nab\xedjania","wallbox.status.home":"Re\u017Eim wallboxu","wallbox.status.normal":"Be\u017En\xfd re\u017Eim","wallbox.status.not_connected":"Nemo\u017Eno nadviaza\u0165 spojenie","wallbox.status.off":"Wallbox vypnut\xfd","wallbox.status.ready":"Pripraven\xe9 na nab\xedjanie","wallbox.sub_status.auto":"pod\u013Ea auto. re\u017Eimu","wallbox.sub_status.basic_energy":"z\xe1kladn\xed energi\xed","wallbox.sub_status.battery":"popod\u013Ea bat\xe9rie","wallbox.sub_status.battery_fast":"prednostne pod\u013Ea bat\xe9rie","wallbox.sub_status.battery_waiting":", \u010Dakanie na nabitie bat\xe9rie","wallbox.sub_status.hdo_block":", blok\xe1cia HDO","wallbox.sub_status.no_charging":", nab\xedjanie je zak\xe1zan\xe9","wallbox.sub_status.none":"","wallbox.sub_status.photovoltaics":"pod\u013Ea FVE","wallbox.sub_status.schedule":"pod\u013Ea pl\xe1nova\u010Da","wallbox.sub_status.spot":"pod\u013Ea SPOTU","wallbox.sub_status.spot_high":", je vysok\xe1 cena SPOTU","wallbox.sub_status.spot_mid":", je stredn\xe1 cena SPOTU","wallbox.victron-ev-charger":"Victron EV Charger","wallbox.wallboxes.title":"Wallboxy","wallbox_rfid.add_button":"Pridan\xe9 RFID k\xe1rty","wallbox_rfid.delete.cancel":"Zru\u0161i\u0165","wallbox_rfid.delete.confirm":"Zmaza\u0165","wallbox_rfid.delete.confirm.title":"Zmaza\u0165 k\xe1rty {name}?","wallbox_rfid.dialog.already_exists":"K\xe1rta {id} je u\u017E ulo\u017Een\xe1 pod n\xe1zvom {name}.","wallbox_rfid.dialog.already_exists_hint":"Pripnite \u010Fal\u0161iu k\xe1rdu alebo zavrite dial\xf3g.","wallbox_rfid.dialog.cancel":"Zru\u0161i\u0165","wallbox_rfid.dialog.name_label":"N\xe1zov k\xe1rty","wallbox_rfid.dialog.save":"Ulo\u017Ei\u0165","wallbox_rfid.dialog.scanned_id":"ID karty: {id}","wallbox_rfid.dialog.title":"Pridan\xe9 RFID k\xe1rty","wallbox_rfid.dialog.waiting":"Pripnite k\xe1rdu u k \u010Dte\u010Dke\u2026","wallbox_rfid.edit.dialog.title":"Upravi\u0165 RFID k\xe1rty","wallbox_wizard.cancel":"Zru\u0161i\u0165","wallbox_wizard.custom_device_ip_address.alert":"Uistite sa pros\xedm, \u017Ee sa IP adresa wallboxu nebude meni\u0165 (napr. ke\u010F wallbox vyu\u017E\xedva adresu z DHCP).","wallbox_wizard.custom_device_ip_address.input":"IP adresa wallboxu","wallbox_wizard.multiple_wallboxes.alert":"Pre nastavenie viac wallboxov pros\xedm kontaktujte linku podpory. Kontakt n\xe1jdete v technickej wiki Infigy.","wallbox_wizard.multiple_wallboxes.label":"Viac wallboxov","wallbox_wizard.open":"Nastavit wallbox","wallbox_wizard.save":"Ulo\u017Ei\u0165","wallbox_wizard.title":"Nastavenie wallbox","welcome.subtitle":"Aplik\xe1cia pre dom\xe1cu a modern\xfa energetiku na jednom mieste! Lorem ipsum dolor sit amet","welcome.title":"Vitajte v Infigy!","wifi_ap_config.interface_block.confirm.confirmation_text":"{blocked, select, true {Zablokova\u0165} other {Odblokova\u0165}}","wifi_ap_config.interface_block.confirm.content":"Naozaj chcete {blocked, select, true {zablokova\u0165} other {odblokova\u0165}} WiFi?","wifi_ap_config.interface_block.confirm.title":"Zmena stavu WiFi","wifi_ap_config.passphrase_change.confirm.passphrase":"Heslo","wifi_ap_config.passphrase_change.confirm.title":"Zmena hesla k WiFi","wifi_ap_config.wifi_interface_blocked.button":"{blocked, select, true {Odblokova\u0165} other {Zablokova\u0165}}","wifi_ap_config.wifi_interface_blocked.title":"Stav WiFi","wifi_ap_config.wifi_interface_blocked.value":"{blocked, select, true {Zablokovan\xfd} other {Akt\xedvny}}","wind.common":"V\u0161eobecn\xe9 inform\xe1cie","wind.common.battery_charged_total":"Celkom do bat\xe9rie:","wind.common.battery_power":"V\xfdkon do bat\xe9rie","wind.common.power":"Aktu\xe1lny v\xfdkon","wind.common.power_today":"Dne\u0161n\xe1 v\xfdroba:","wind.common.power_total":"Celkov\xe1 v\xfdroba","wind.common.power_year":"Ro\u010Dn\xe1 v\xfdroba:","wind.common.resistor_power":"V\xfdkon do odporu","wind.statistics":"Statistiky","wind.statistics.power":"V\xfdkon vetnej elektr\xe1rne","wind.statistics.wind_speed":"R\xfdchlos\u0165 vetra","wind.status":"Re\u017Eim vetnej elektr\xe1rne"}');


var $8706e59c939e4898$exports = {};
$8706e59c939e4898$exports = JSON.parse('{"\\"chart.tooltip.substat.phase\\"":"Phase {number, select, 0 {1} 1 {2} 2 {3} other {{number}}}","\\"chart.tooltip.substat.pv_string\\"":"{inverterName}, String {stringNumber}","TEST":"XXX","animation.battery":"Batterie","animation.boiler":"Boiler","animation.consumption":"Haus","animation.electrical_grid":"Netz","animation.hp":"W\xe4rmepumpe","animation.photovoltaics":"Photovoltaik","animation.wallbox":"Wallbox","animation.wind":"Wind","app_messages.battery_max_soc":"Batterie wird auf die eingestellte maximale SOC {maxSoc, number, ::.##}% geladen","app_messages.battery_min_soc":"Batterie wird auf die eingestellte minimale SOC {minSoc, number, ::.##}% entladen","app_messages.body.battery_max_soc":"Der aktuelle Batterieladestand betr\xe4gt {currentSoc, number, ::.##}%.","app_messages.body.battery_min_soc":"Der aktuelle Batterieladestand betr\xe4gt {currentSoc, number, ::.##}%.","app_messages.body.heat_pump_limit_exceeded":"Das Limit f\xfcr den W\xe4rmepumpenverbrauch wurde \xfcberschritten. Das eingestellte Limit betr\xe4gt {value, number, ::.##} kW.","app_messages.body.heat_water_limit_exceeded":"Das Limit f\xfcr den Warmwasserverbrauch wurde \xfcberschritten. Das eingestellte Limit betr\xe4gt {value, number, ::.##} kW.","app_messages.body.heat_water_max_temperature":"Heute hat der Boiler bereits die maximale Temperatur {maxTemperature, number, ::.##}\xb0C erreicht.","app_messages.body.home_limit_exceeded":"Das Limit f\xfcr den Hausverbrauch wurde \xfcberschritten. Das eingestellte Limit betr\xe4gt {value, number, ::.##} kW.","app_messages.body.inverter_production_mwh":"Ihre Photovoltaikanlage hat in diesem Jahr bereits {inverterProductionValue, number, ::.##} MWh erzeugt.","app_messages.body.spot_daily_prediction":"Tagesprognose: {pvPrediction, select, true {Photovoltaik-Erzeugung: {pvPredictionValue, number, ::.##} kWh. } other {} } {homePrediction, select, true {Hausverbrauch: {homePredictionValue, number, ::.##} kWh. } other {} } {batteryPrediction, select, true {Batteriespeicher: {batteryPredictionValue, number, ::.##} kWh. } other {} } {hwPrediction, select, true {Boilerspeicher: {hwPredictionValue, number, ::.##} kWh. } other {} } {hpPrediction, select, true {W\xe4rmepumpenverbrauch: {hpPredictionValue, number, ::.##} kWh. } other {} } {salePrediction, select, true {Verbleibende Energie zum Verkauf: {salePredictionValue, number, ::.##} kWh. } other {} }","app_messages.body.spot_daily_summary":"Heute am Spot: {nothingToReport, select, true {Nichts ist geplant.} other { {energyForSale, select, true {Der Plan sieht einen Verkauf am Morgen vor. } other {} } {negativeIntervals, select, false {} other {Negativer Preis ({negativeIntervals}), der den \xdcberschuss reduziert. } } {chargingIntervals, select, false {} other {Plan zum Laden der Batterie ({chargingIntervals}). } } {dischargingIntervals, select, false {} other {Plan zum Entladen der Batterie ({dischargingIntervals}). } } } }","app_messages.body.spot_negative_price_start":"Der aktuelle Spotpreis ist nach Abzug der Provision negativ. Die in Infigy eingestellte Provision betr\xe4gt {spotOffsetPrice, number, ::.##} CZK. Der aktuelle Spotpreis betr\xe4gt {spotNegativePrice, number, ::.##} CZK.","app_messages.body.spot_negative_price_stop":"Der aktuelle Spotpreis ist nicht mehr negativ und betr\xe4gt {spotNegativePrice, number, ::.##} CZK. Die Provision ist in Infigy auf {spotOffsetPrice, number, ::.##} CZK eingestellt","app_messages.body.wallbox_limit_exceeded":"Das Ladelimit des Elektrofahrzeugs wurde \xfcberschritten. Das eingestellte Limit betr\xe4gt {value, number, ::.##} kW.","app_messages.body.wallbox_stop_charging":"In diesem Zyklus wurden {wallboxConsumptionCycleValue, number, ::.##} kWh Energie hinzugef\xfcgt.","app_messages.button":"Alle Nachrichten l\xf6schen","app_messages.cancel":"Abbrechen","app_messages.confirm":"Alle Nachrichten l\xf6schen","app_messages.confirm.title":"M\xf6chten Sie wirklich alle Nachrichten l\xf6schen?","app_messages.detail_dialog.close":"Lesen","app_messages.heat_pump_limit_exceeded":"Das Limit f\xfcr den W\xe4rmepumpenverbrauch wurde \xfcberschritten","app_messages.heat_water_limit_exceeded":"Das Limit f\xfcr den Warmwasserverbrauch wurde \xfcberschritten","app_messages.heat_water_max_temperature":"Die maximale Wassertemperatur wurde erreicht","app_messages.home_limit_exceeded":"Das Limit f\xfcr den Hausverbrauch wurde \xfcberschritten","app_messages.inverter_connected":"Die Kommunikation mit dem Wechselrichter wurde hergestellt","app_messages.inverter_disconnected":"Die Kommunikation mit dem Wechselrichter wurde unterbrochen","app_messages.inverter_production_mwh":"PV-Erzeugungsmeilenstein","app_messages.load_more":"Mehr laden","app_messages.no_messages":"Es sind noch keine Benachrichtigungen vorhanden","app_messages.spot_battery_discharge":"Der spotbasierte Entladeplan ist {spotDischargePlan}","app_messages.spot_daily_prediction":"Tagesprognose","app_messages.spot_daily_summary":"Tageszusammenfassung des Spotplans","app_messages.spot_negative_price_start":"Der Spotpreis ist negativ","app_messages.spot_negative_price_stop":"Der Spotpreis ist nicht mehr negativ","app_messages.spot_start_charging_battery":"Das Laden der Batterie gem\xe4\xdf Spotpreis wurde gestartet","app_messages.spot_start_discharging_battery":"Das Entladen der Batterie ins Netz gem\xe4\xdf Spotpreis wurde gestartet","app_messages.spot_stop_charging_battery":"Das Laden der Batterie gem\xe4\xdf Spotpreis wurde gestoppt","app_messages.spot_stop_discharging_battery":"Das Entladen der Batterie ins Netz gem\xe4\xdf Spotpreis wurde gestoppt","app_messages.test":"Testbenachrichtigung","app_messages.title":"Alle Nachrichten l\xf6schen","app_messages.utility_loss_start":"Wir haben einen Stromausfall erkannt","app_messages.utility_loss_stop":"Der Stromausfall wurde behoben","app_messages.wallbox_limit_exceeded":"Das Ladelimit des Elektrofahrzeugs wurde \xfcberschritten","app_messages.wallbox_start_charging":"Das Laden des Elektrofahrzeugs wurde gestartet","app_messages.wallbox_stop_charging":"Das Laden des Elektrofahrzeugs wurde gestoppt","app_update_overlay.subtitle":"Bitte warten. Nach dem Update wird die Anwendung neu gestartet und das Fenster im Browser automatisch aktualisiert","app_update_overlay.title":"Update l\xe4uft","audit_log.error":"Fehler beim Laden","audit_log.item.author":"Autor","audit_log.item.date":"Datum","audit_log.item.payload":"Ereignis","audit_log.item.type":"Typ","audit_log.title":"Audit-Protokoll","audit_log_delete.button":"L\xf6schen","audit_log_delete.cancel":"Abbrechen","audit_log_delete.confirm":"L\xf6schen","audit_log_delete.confirm.title":"M\xf6chten Sie wirklich alle Eintr\xe4ge im Audit-Protokoll l\xf6schen?","audit_log_delete.title":"Audit-Protokoll l\xf6schen","azRouters.add":"Neuen AZ-Router hinzuf\xfcgen","azRouters.addButton":"Hinzuf\xfcgen","azRouters.clientId":"Modbus ID","azRouters.clientId.value":"Modbus ID: {id}","azRouters.counts":"OK {ok} / Fehler {err}","azRouters.empty":"Keine AZ-Router konfiguriert","azRouters.name":"Name","azRouters.status.error":"Fehler","azRouters.status.ok":"OK","azRouters.status.starting":"Wird gestartet","azRouters.title":"AZ-Router","bez_dodavatele.business_flexibility.title":"Gesch\xe4ftliche Flexibilit\xe4t","bez_dodavatele.enabled":"Integration aktiviert","bez_dodavatele.region":"Regionscode","bez_dodavatele.title":"bezDodavatele","boiler.blocking":"Heizsperre","boiler.common":"Allgemeine Informationen","boiler.common.phase_3":"Phase 3:","boiler.common.power":"Gesamtverbrauch","boiler.common.power.phase_1":"Phase 1:","boiler.common.power.phase_2":"Phase 2:","boiler.common.power_today":"Heutiger Verbrauch:","boiler.common.power_year":"Jahresverbrauch:","boiler.common.temperature":"Aktuelle Temperatur","boiler.common.total":"Gesamtverbrauch","boiler.settings":"Einstellungen","boiler.settings.hdo":"Regelheizung im Hochtarif ausschalten","boiler.settings.hdo.subtitle":"Die Zeiten f\xfcr den Hochtarif m\xfcssen in den allgemeinen Einstellungen festgelegt werden","boiler.settings.min_soc":"Heizsperre","boiler.settings.min_soc.subtitle":"Batterieladestand, bei dem die Heizung w\xe4hrend eines Stromausfalls gesperrt wird","boiler.settings.min_soc_utility":"Heizsperre bei verf\xfcgbarem Netz","boiler.settings.min_soc_utility.subtitle":"Batterieladestand, bei dem die Heizung w\xe4hrend eines Stromausfalls gesperrt wird","boiler.settings.spot-hi":"Heizung bei hohem Spotpreis sperren","boiler.settings.spot-mi":"Heizung bei mittlerem Spotpreis sperren","boiler.settings.temp":"Solltemperatur","boiler.settings.temp.subtitle":"Eine \xfcbliche Temperatur, die immer verf\xfcgbar ist","boiler.settings.temp_ek":"Temperatur aus Photovoltaik mit Elektroboiler","boiler.settings.temp_ek.subtitle":"Vorw\xe4rmtemperatur, die nur bei einem niedrigen Preis gilt","boiler.settings.temp_spot":"Temperatur vom Spot mit Elektroboiler","boiler.settings.temp_spot.subtitle":"Vorw\xe4rmtemperatur, die nur bei einem niedrigen Preis gilt","boiler.statistics":"Statistik","boiler.statisticsTemp":"Boilertemperatur","boiler.status":"Boilermodus","boiler.status.home":"Boilermodus","boiler_test_trigger.button":"Boiler testen","boiler_test_trigger.button.running":"Test l\xe4uft","boiler_test_trigger.subtitle":"\xdcberpr\xfcft den korrekten Anschluss und die eingestellte Leistung des Boilers.","boiler_test_trigger.title":"Boiler testen","boiler_test_wizard.acknowledge.condition":"F\xfcr einen korrekten Boilertest muss der Verbrauch im Objekt konstant oder null sein. Schwankungen im Verbrauch k\xf6nnen den Test beeinflussen. Der aktuelle Verbrauch des Objekts betr\xe4gt {power}","boiler_test_wizard.acknowledge.config":"Derzeit ist der {phaseLabel} Boiler mit einer Gesamtleistung von {power} eingestellt. Diese Werte m\xfcssen gem\xe4\xdf dem Typenschild des Boilers eingestellt werden.","boiler_test_wizard.acknowledge.confirm":"Best\xe4tigen","boiler_test_wizard.acknowledge.phase1":"1-phasig","boiler_test_wizard.acknowledge.phase3":"3-phasig","boiler_test_wizard.acknowledge.phase_option":"{phase}. Phase","boiler_test_wizard.acknowledge.phase_select":"W\xe4hlen Sie die zu testenden Phasen aus. Nicht markierte Phasen werden \xfcbersprungen.","boiler_test_wizard.acknowledge.phase_select_empty":"W\xe4hlen Sie mindestens eine Phase aus.","boiler_test_wizard.acknowledge.start":"Boiler testen","boiler_test_wizard.acknowledge.title":"Informationen zum Test","boiler_test_wizard.result.after":"Verbrauch des Objekts nach der Aktivierung","boiler_test_wizard.result.before":"Verbrauch des Objekts vor der Aktivierung","boiler_test_wizard.result.close":"Schlie\xdfen","boiler_test_wizard.result.correct":"Korrekter Boilerverbrauch","boiler_test_wizard.result.detail_toggle":"Testdetails","boiler_test_wizard.result.header":"Testergebnis:","boiler_test_wizard.result.phase_header":"{phase}. Phase","boiler_test_wizard.result.real_power":"Gesch\xe4tzte Boilerleistung","boiler_test_wizard.result.rerun":"Test erneut ausf\xfchren","boiler_test_wizard.result.set_power":"Eingestellte Leistung","boiler_test_wizard.result.stable":"Messung war stabil","boiler_test_wizard.result.title":"Testergebnis","boiler_test_wizard.running.activate":"Aktivierung der Boilerphase","boiler_test_wizard.running.after":"Verbrauch des Objekts betr\xe4gt {power}","boiler_test_wizard.running.before":"Verbrauch des Objekts vor dem Test betr\xe4gt {power}","boiler_test_wizard.running.measuring":"Messung l\xe4uft\u2026","boiler_test_wizard.running.phase":"Testphase {phase}","boiler_test_wizard.running.real_power":"Gesch\xe4tzte Boilerleistung betr\xe4gt {power}","boiler_test_wizard.running.remaining":"Noch ca. {seconds} s","boiler_test_wizard.running.reset":"Verbrauch wird zur\xfcckgesetzt","boiler_test_wizard.running.result_fail":"Testphase ist nicht korrekt","boiler_test_wizard.running.result_ok":"Testphase ist korrekt","boiler_test_wizard.running.stable":"Verbrauch ist stabil","boiler_test_wizard.running.title":"Test l\xe4uft","boiler_test_wizard.running.unstable":"Messung war instabil","boiler_test_wizard.title":"Boiler wird getestet","cancel":"Abbrechen","chart.range.this_week":"Letzte Woche","chart.range.today":"Letzte 24{nbsp}Stunden","chart.tooltip.active_condition.title":"Aktueller Modus:","chart.tooltip.active_condition.value.battery":"Batterie","chart.tooltip.active_condition.value.compressor-blocked":"Kompressor gesperrt, niedriger Batteriestand","chart.tooltip.active_condition.value.cooling":"K\xfchlung","chart.tooltip.active_condition.value.error":"Fehler","chart.tooltip.active_condition.value.heating":"Heizen","chart.tooltip.active_condition.value.hot-water":"Warmwasserbereitung","chart.tooltip.active_condition.value.inactive":"Inaktiv","chart.tooltip.active_condition.value.manual":"Manuell","chart.tooltip.active_condition.value.not-connected":"Verbindung kann nicht hergestellt werden","chart.tooltip.active_condition.value.not-licensed":"Nicht lizenziert","chart.tooltip.active_condition.value.off":"Aus","chart.tooltip.active_condition.value.overflow":"\xdcberschuss","chart.tooltip.active_condition.value.pool":"Poolheizung","chart.tooltip.active_condition.value.spot":"Spot","chart.tooltip.active_condition.value.time":"Zeit","chart.tooltip.control_mode.title":"Gesteuert durch:","chart.tooltip.control_mode.value":"{mode, select, photovoltaic {Photovoltaik} grid {Netz} spot {Spot} flexibility {Flexibilit\xe4t} error {Fehler} other {{mode}} }","chart.tooltip.wallbox_authorization_card_id.title":"Autorisierungskarte:","charts.error.dialog.title":"Beim Laden der Statistik ist ein Fehler aufgetreten","charts.mode.day":"Tag","charts.mode.week":"Woche","charts.mode.year":"Jahr","charts.summary.value":"Gesamt {value}","close":"Schlie\xdfen","cloud_plugs.bat":"Steuerung \xfcber Batterie","cloud_plugs.battery.battery_start":"Einschalten beim Laden","cloud_plugs.battery.battery_start.subtitle":"Batterieladung, die die Steckdose aktiviert","cloud_plugs.battery.battery_stop":"Ausschalten beim Laden","cloud_plugs.battery.battery_stop.subtitle":"Laden der Batterie, das die Steckdose ausschaltet","cloud_plugs.battery.on":"Aktiv","cloud_plugs.battery_charged":"Batterie geladen","cloud_plugs.condition":"Bedingung","cloud_plugs.condition.and":"Und","cloud_plugs.condition.or":"Oder","cloud_plugs.led_mode.battery.subtitle":"LED aktiv, wenn die Batterie mindestens 95% betr\xe4gt","cloud_plugs.led_mode.battery.switch.title":"LED bei eingeschalteter Steckdose","cloud_plugs.led_mode.battery.title":"LED bei geladener Batterie","cloud_plugs.led_mode.mode":"{mode, select, unknown {---} off {Aus} switch {} power {Nach Leistung} other {Unbekannt}}","cloud_plugs.led_mode.overflow.subtitle":"LED aktiv, wenn ein stabiler \xdcberschuss auftritt","cloud_plugs.led_mode.overflow.title":"LED bei \xdcberschuss","cloud_plugs.led_mode.switch.subtitle":"LED aktiv, wenn die Steckdose eingeschaltet ist","cloud_plugs.led_mode.title":"LED-Signalisierung","cloud_plugs.list.id":"ID","cloud_plugs.list.led_mode":"LED-Signalisierung","cloud_plugs.list.online":"Online","cloud_plugs.list.relay":"Relais","cloud_plugs.list.title":"Status","cloud_plugs.overflow":"Steuerung \xfcber \xdcberschuss","cloud_plugs.overflow.help":"Einschalten der Steckdose bei definiertem \xdcberschuss ins Netz.","cloud_plugs.overflow.on":"Aktiv","cloud_plugs.overflow.startPower":"Einschalten bei Netzbezug","cloud_plugs.overflow.startPower.help":"Die Steckdose schaltet sich ein, wenn der \xdcberschuss nach einer definierten Verz\xf6gerung das eingestellte Niveau erreicht. Wenn der Wert auf - 1500W und die Einschaltverz\xf6gerung auf 5 Minuten eingestellt ist, schaltet sich die Steckdose ein, wenn der \xdcberschuss ins Netz mindestens 5 Minuten lang 1500W betr\xe4gt.","cloud_plugs.overflow.startPower.subtitle":"Ein negativer Wert ist \xdcberschuss, ein positiver Wert ist Verbrauch","cloud_plugs.overflow.stopPower":"Ausschalten bei Netzbezug","cloud_plugs.overflow.stopPower.help":"Die Steckdose schaltet sich aus, wenn der Verbrauch nach einer definierten Verz\xf6gerung h\xf6her als das eingestellte Niveau ist. Wenn der Wert auf 100W und die Ausschaltverz\xf6gerung auf 5 Minuten eingestellt ist, schaltet sich die Steckdose aus, wenn der Verbrauch aus dem Netz mindestens 5 Minuten lang 100W betr\xe4gt.","cloud_plugs.overflow.stopPower.subtitle":"Ein negativer Wert ist \xdcberschuss, ein positiver Wert ist Verbrauch","cloud_plugs.pv_power":"Steuerung \xfcber PV-Leistung","cloud_plugs.pv_power.help":"Einschalten der Steckdose bei definierter PV-Leistung.","cloud_plugs.pv_power.on":"Aktiv","cloud_plugs.pv_power.startPower":"Einschalten bei PV-Erzeugung","cloud_plugs.pv_power.startPower.help":"Die Steckdose schaltet sich ein, wenn die PV-Leistung gr\xf6\xdfer als das eingestellte Niveau ist. Wenn der Wert auf 1000W eingestellt ist, schaltet sich die Steckdose ein, wenn die PV-Leistung mindestens 1000W betr\xe4gt.","cloud_plugs.pv_power.stopPower":"Ausschalten bei PV-Erzeugung","cloud_plugs.pv_power.stopPower.help":"Die Steckdose schaltet sich aus, wenn die PV-Leistung unter dem eingestellten Niveau liegt. Wenn der Wert auf 500W eingestellt ist, schaltet sich die Steckdose aus, wenn die PV-Leistung weniger als 500W betr\xe4gt.","cloud_plugs.time":"Steuerung nach Zeit","cloud_plugs.time.on":"Aktiv","cloud_plugs.title":"Steckdosen","cloud_plugs.turn_off":"Ausschalten","cloud_plugs.turn_on":"Einschalten","dark_mode.dark":"Dunkel","dark_mode.light":"Hell","dark_mode.system":"System","delta_green.battery_max_power_in":"Maximale Batterieleistung IN (W)","delta_green.battery_max_power_out":"Maximale Batterieleistung OUT (W)","delta_green.business_flexibility.title":"Gesch\xe4ftliche Flexibilit\xe4t","delta_green.connected":"Status","delta_green.enabled":"Integration aktiviert","delta_green.last_messages":"Letzte Nachrichten","delta_green.last_messages.date":"Zeit","delta_green.last_messages.payload":"Nachricht","delta_green.last_messages.topic":"Thema","delta_green.pv_orientation":"Photovoltaik-Ausrichtung","delta_green.title":"Delta Green","des_battery_container.status.error":"Fehler","des_battery_container.status.none":"Unbekannter Zustand","des_battery_container.status.off":"Aus","des_battery_container.status.run":"Normalbetrieb","des_battery_container.status.sleep":"Schlafmodus","dev.cloud_plugs.mqtt_cloud.connected":"MQTT-Cloud-Verbindungsstatus","dev.cloud_plugs.title":"Cloud-Steckdosen","dev.inverter_config.connection.lan":"LAN","dev.inverter_config.connection.rs485":"RS485","dev.inverter_config.connection.rs485_hint":"Adresse und Port werden von der Platine \xfcbernommen ({host}:{port}).","dev.inverter_config.rename_warning":"Das Umbenennen des Schl\xfcssels von \\"{from}\\" in \\"{to}\\" macht historische Daten verwaist \u2014 Statistiken und geladene erzeugte Energie, die unter dem urspr\xfcnglichen Schl\xfcssel gef\xfchrt werden.","dev.inverter_config.search.open":"Wechselrichter suchen","dev.inverter_config.search.title":"Wechselrichter suchen","dev.inverter_config.stats.all":"Alle","dev.inverter_config.status.counts":"OK {ok} / Fehler {err}","dev.inverter_config.status.error":"Fehler","dev.inverter_config.status.ok":"OK","dev.inverter_config.status.starting":"Wird gestartet","dev.inverter_config.title":"Wechselrichterkonfiguration","dev.link":"Dev","dev_app_messages.test_send":"Testbenachrichtigung","dev_app_messages.test_send.button":"Senden","dev_homepage.app_messages.title":"Benachrichtigungen","dev_homepage.title":"Entwicklungsmen\xfc","dev_spot.summary.title":"Modus\xfcbersicht","dev_spot.title":"Spot (Entwicklung)","dev_status_log.empty":"Noch keine Daten","dev_status_log.error":"Fehler beim Laden","dev_status_log.title":"Statusprotokoll","dev_status_log.today":"Heute","dhcp_host.address":"IP-Adresse","dhcp_host.create.title":"Neuer DHCP-Host","dhcp_host.edit.title":"DHCP-Host bearbeiten","dhcp_host.mac":"MAC-Adresse","dhcp_host.name":"Name","dhcp_hosts.remove.cancel":"Abbrechen","dhcp_hosts.remove.confirm":"L\xf6schen","dhcp_hosts.remove.confirm.title":"M\xf6chten Sie die feste DHCP-Hostadresse wirklich aufheben?","dhcp_leases.ip":"IP-Adresse","dhcp_leases.mac":"MAC-Adresse","dhcp_leases.make_static.cancel":"Abbrechen","dhcp_leases.make_static.confirm":"Hinzuf\xfcgen","dhcp_leases.make_static.confirm.title":"M\xf6chten Sie die DHCP-Hostadresse wirklich festlegen?","dhcp_leases.name":"Name","dhcp_leases.next_renewal":"N\xe4chste Verl\xe4ngerung","dhcp_leases.title":"DHCP-Leases","ean":"EAN","electree.business_flexibility.title":"Gesch\xe4ftliche Flexibilit\xe4t","electree.connected":"Status","electree.enabled":"Integration aktiviert","electree.last_messages":"Letzte Nachrichten","electree.last_messages.date":"Zeit","electree.last_messages.payload":"Nachricht","electree.last_messages.topic":"Thema","electree.title":"Electree","electrical_grid.common":"Allgemeine Informationen","electrical_grid.common.overflow":"Gesamtfluss ins Netz","electrical_grid.common.overflow_today":"Heutiger \xdcberschuss ins Netz:","electrical_grid.common.overflow_year":"J\xe4hrlicher \xdcberschuss ins Netz:","electrical_grid.common.power":"Gesamtverbrauch aus dem Netz","electrical_grid.common.power.phase_1":"Phase 1:","electrical_grid.common.power.phase_2":"Phase 2:","electrical_grid.common.power.phase_3":"Phase 3:","electrical_grid.common.power_today":"Heutiger Verbrauch aus dem Netz:","electrical_grid.common.power_year":"Jahresverbrauch aus dem Netz:","electrical_grid.common.total_consumption":"Gesamtverbrauch aus dem Netz","electrical_grid.statistics":"Bezugsstatistik","electrical_grid.statistics_overflow":"\xdcberschussstatistik","electrical_grid.status":"Netzstatus","ems.activePower":"Wirkleistung","ems.apparentPower":"Scheinleistung","ems.details":"Wechselrichterparameter","ems.inverter":"Wechselrichter","ems.inverter.index":"Wechselrichter {index}","ems.inverter.mode.backup":"Notstrom","ems.inverter.mode.feedIn":"Einspeisung","ems.inverter.mode.manual":"Manuell","ems.inverter.mode.peakShaving":"Spitzenlastkappung","ems.inverter.mode.selfUse":"Eigenverbrauch","ems.inverter.name":"Name des Wechselrichters","ems.inverter.name.aelio":"X3-AELIO","ems.inverter.name.notConnected":"Nicht verbunden","ems.inverter.name.trene100k":"X3-TRENE-100K","ems.inverter.name.trene100ki":"X3-TRENE-100KI","ems.inverter.name.trene125k":"X3-TRENE-125K","ems.inverter.name.unknown":"Unbekanntes Modell","ems.mode":"EMS-Modus","ems.power.index":"Leistung {index}","ems.power.total":"Gesamtleistung","ems.powerFactor":"Leistungsfaktor","ems.reactivePower":"Blindleistung","ems.status":"Status","emsPro.inverter.name.aelio":"X3-AELIO","emsPro.inverter.name.notConnected":"Nicht verbunden","emsPro.inverter.name.trene1":"X3-TRENE-1","emsPro.inverter.name.trene100k":"X3-TRENE-100K","emsPro.inverter.name.trene125k":"X3-TRENE-125K","emsPro.inverter.name.x3forth":"X3-FORTH","emsPro.inverter.name.x3forthplus":"X3-FORTH+","emsPro.inverter.name.x3grand":"X3-GRAND","emsPro.inverter.name.x3mgag2":"X3-MGA G2","emsPro.inverter.name.x3prog2":"X3-PRO G2","emsService.basicSettings":"Grundeinstellungen","emsService.direction.disabled":"Deaktiviert","emsService.direction.read":"Lesen","emsService.direction.write":"Schreiben","emsService.distributionMetrics":"Verteilnetzbefehle","emsService.distributionMetrics.diMapping":"Eingangszuordnung","emsService.distributionMetrics.enabled":"Lesen von Verteilnetzbefehlen aktivieren","emsService.distributionMetrics.source":"Quelle der Verteilnetzbefehle","emsService.distributionMetrics.source.digitalInputs":"Digitaleing\xe4nge","emsService.distributionMetrics.source.plc":"Externe PLC","emsService.enabled":"PLC aktiviert","emsService.energyMeters":"Energiez\xe4hler","emsService.energyMeters.add":"Neuen Energiez\xe4hler hinzuf\xfcgen","emsService.energyMeters.addButton":"Hinzuf\xfcgen","emsService.energyMeters.azRouter":"AZ-Router","emsService.energyMeters.azRouter.empty":"Keine AZ-Router konfiguriert","emsService.energyMeters.empty":"Keine Energiez\xe4hler konfiguriert","emsService.energyMeters.newMeter":"Name","emsService.energyMeters.plcMetric":"PLC-Metrik","emsService.energyMeters.plcMetric.grid":"Netz","emsService.energyMeters.plcMetric.kgj":"KGJ","emsService.energyMeters.plcMetric.pv":"PV","emsService.energyMeters.shellyId":"Shelly ID","emsService.energyMeters.source":"Quelle","emsService.energyMeters.source.azRouter":"AZ-Router","emsService.energyMeters.source.plc":"PLC","emsService.energyMeters.source.shelly":"Shelly","emsService.gridMetrics.enabled":"Lesen der Netzmetriken aktiviert","emsService.ipAddress":"IP-Adresse","emsService.kgjMetrics":"KGJ-Metriken","emsService.kgjMetrics.enabled":"Lesen der KGJ-Metriken aktiviert","emsService.metricsDirection":"Richtung","emsService.metricsEnabled":"Aktiviert","emsService.mqttBroker":"MQTT-Broker (Shellies)","emsService.mqttBrokerEnabled":"MQTT-Broker aktiviert","emsService.mqttBrokerStatus":"MQTT-Broker-Status","emsService.notAvailable":"Die EMS-Funktion ist nicht verf\xfcgbar","emsService.password":"Passwort","emsService.plcStatus":"PLC-Kommunikationsstatus","emsService.pollInterval":"Abfrageintervall (ms)","emsService.pvMetrics":"PV-Metriken","emsService.pvMetrics.enabled":"Lesen der PV-Metriken aktiviert","emsService.pvMetrics.meterId":"Energiez\xe4hler","emsService.pvMetrics.meterSource":"Datenquelle","emsService.pvMetrics.meterSource.meter":"Energiez\xe4hler","emsService.pvMetrics.meterSource.plc":"PLC","emsService.shelliesList":"Verbundene Shelly-Ger\xe4te","emsService.username":"Benutzername","ems_service.link":"EMS-Service","ems_service.title":"EMS-Service","enerco.ean":"EAN","enerco.enabled":"Integration aktiviert","enerco.prediction.disabled":"Die Integration ist deaktiviert.","enerco.prediction.title":"Prognose","enerco.title":"Enerco","energomachine.business_flexibility.title":"Gesch\xe4ftliche Flexibilit\xe4t","energomachine.connected":"Status","energomachine.enabled":"Integration aktiviert","energomachine.last_messages":"Letzte Nachrichten","energomachine.last_messages.date":"Zeit","energomachine.last_messages.payload":"Nachricht","energomachine.last_messages.topic":"Thema","energomachine.title":"Energomachine","energyMeters.actualPower":"Aktuelle Leistung","energyMeters.general":"Allgemeine Informationen","energyMeters.meter":"Energiez\xe4hler","energyMeters.notConfigured":"Energiez\xe4hler sind nicht konfiguriert. Gehen Sie zum Servicemen\xfc, um sie einzurichten.","energyMeters.phase1":"Phase 1:","energyMeters.phase2":"Phase 2:","energyMeters.phase3":"Phase 3:","energyMeters.statistics":"Statistik","energyMeters.todayEnergy":"Heutiger Verbrauch:","energyMeters.totalEnergy":"Gesamtverbrauch","energyMeters.yearEnergy":"Jahresverbrauch:","error":"Fehler beim Laden des Berichts.","expertService.EM":"Energiez\xe4hler","expertService.EM.add":"Hinzuf\xfcgen","expertService.EM.empty":"Keine Energiez\xe4hler konfiguriert","expertService.EM.list":"Konfiguration der Energiez\xe4hler","expertService.EM.name":"Name","expertService.EM.newMeter":"Neuer Z\xe4hler","expertService.EM.shellyId":"Shelly ID","expertService.HP":"W\xe4rmepumpe","expertService.HP.CntComErr":"Z\xe4hler f\xfcr Fehlernachrichten","expertService.HP.CntComOk":"Z\xe4hler f\xfcr g\xfcltige Nachrichten","expertService.HP.IpAdr":"IP-Adresse der W\xe4rmepumpe","expertService.HP.maxTempHW":"Maximale Warmwassertemperatur f\xfcr die W\xe4rmepumpe","expertService.HP.maxTempHW.subtitle":"Summe aus flexibler + eingestellter Temperatur","expertService.HW":"Warmwasser","expertService.HW.HwBatteryPriority":"Batterieladestand in Prozent, ab dem der Boiler immer Priorit\xe4t hat","expertService.HW.HwErrEnabled":"Verf\xfcgbarkeit des Boilers auswerten","expertService.HW.HwResetErrorTime":"Verz\xf6gerung f\xfcr das Zur\xfccksetzen des Thermostatfehlers","expertService.HW.HwResetErrorTime.subtitle":"Zeit in Minuten, nach der der Thermostatfehler zur\xfcckgesetzt wird und die Warmwasserbereitung erneut startet","expertService.HW.LegionellaLastTime":"Letztes Erreichen der Legionellentemperatur","expertService.HW.TempId":"ID des Temperatursensors","expertService.HW.control":"Steuerungstyp des Boilers","expertService.HW.control.onoff":"Ein/Aus","expertService.HW.control.proportional":"Proportional","expertService.HW.hysterezis":"Hysterese Warmwasser","expertService.HW.hysterezis.subtitle":"Die Hysterese gilt nur f\xfcr die regul\xe4re Warmwasserbereitung","expertService.HW.maxPower":"Maximale Leistung des Boilers in Prozent","expertService.HW.maxPower.subtitle":"Diese Einstellung gilt nur f\xfcr die stufenlose Steuerung des Boilers und begrenzt die maximale Leistung des Heizstabs in Prozent.","expertService.HW.offset":"Phasenoffset [W]","expertService.HW.offset.disabled-overflow":"Offset f\xfcr die Steuerung des Boilers bei deaktiviertem \xdcberschuss auf der Phase [W]","expertService.HW.offset.disabled-overflow.subtitle":"Ein h\xf6herer Wert erm\xf6glicht dem Boiler, mehr Energie aus dem Netz zu beziehen, wenn der \xdcberschuss deaktiviert ist","expertService.HW.offset.enabled-overflow":"Offset f\xfcr die Steuerung des Boilers bei aktiviertem \xdcberschuss auf der Phase [W]","expertService.HW.offset.enabled-overflow.subtitle":"Ein h\xf6herer Wert erm\xf6glicht dem Boiler, mehr Energie aus dem Netz zu beziehen.","expertService.HW.offset.ongrid":"Offset f\xfcr die Steuerung des Boilers mit Netzleistung [W]","expertService.HW.offset.ongrid.subtitle":"Ein h\xf6herer Wert erm\xf6glicht dem Boiler, mehr Energie aus dem Netz zu beziehen.","expertService.PV":"Photovoltaik","expertService.PV.BatteryPowerPercent":"Ladeleistung der Batterie in Prozent","expertService.PV.CntComErr":"Z\xe4hler f\xfcr Fehlernachrichten","expertService.PV.CntComOk":"Z\xe4hler f\xfcr g\xfcltige Nachrichten","expertService.PV.ControlMeteringMode":"Methode der \xdcberschussregelung","expertService.PV.ControlMeteringMode.perPhase":"Pro Phase","expertService.PV.ControlMeteringMode.subtitle":"Die phasenweise Regelung berechnet den \xdcberschuss f\xfcr die Ger\xe4testeuerung aus den einzelnen Phasen. Die Summenregelung arbeitet mit der Summe aller Phasen.","expertService.PV.ControlMeteringMode.sum":"Summiert","expertService.PV.ExternalPv":"Externe PV, angeschlossen \xfcber SOLAX Meter 2","expertService.PV.ExternalPvSofar":"Externe PV, angeschlossen \xfcber SOFAR Meter 2","expertService.PV.IpAdr":"IP-Adresse des Wechselrichters","expertService.PV.MeteringMode":"Messverfahren des Netzes","expertService.PV.MeteringMode.perPhase":"Pro Phase","expertService.PV.MeteringMode.subtitle":"Die phasenweise Z\xe4hlung (CZ) erfasst Bezug und Einspeisung auf jeder Phase getrennt. Die Summenz\xe4hlung arbeitet mit der Nettobilanz aller Phasen.","expertService.PV.MeteringMode.sum":"Summiert","expertService.PV.PowerControlType":"Leistungsregelungstyp des Netzwechselrichters","expertService.PV.PowerControlType.fixed":"Fest","expertService.PV.PowerControlType.proportional":"Proportional","expertService.PV.StringNumber":"Anzahl der Strings des Wechselrichters","expertService.PV.StringNumber.subtitle":"Anzahl der Strings des Wechselrichters, die in der Anwendung auf der PV-Registerkarte angezeigt werden","expertService.PV.Versions":"Version","expertService.SP":"Spot","expertService.SP.HwCoefficient":"Koeffizient f\xfcr die Energiesch\xe4tzung des Boilers","expertService.SP.HwCoefficient.subtitle":"Koeffizient der gesch\xe4tzten Energie zum Laden des Boilers.","expertService.SP.MinDifferencePriceChargeFromGrid":"Minimale Spotpreisdifferenz f\xfcr das Laden der Batterie aus dem Netz","expertService.SP.batteryCoefficient":"Koeffizient f\xfcr die Sch\xe4tzung der Batterieladezeit","expertService.SP.batteryCoefficient.subtitle":"Koeffizient der gesch\xe4tzten Zeit zum Laden der Batterie","expertService.SP.minDifferenceBatterychargeFromGrid":"Minimale gesch\xe4tzte SOC-Zunahme f\xfcr das Warten auf PV","expertService.SP.minDifferenceBatterychargeFromGrid.subtitle":"Wenn die gesch\xe4tzte Batterieladung unter diesem Wert liegt, kann die Batterie aus dem Netz geladen werden.","expertService.WB":"Wallbox","expertService.WB.CntComErr":"Z\xe4hler f\xfcr Fehlernachrichten","expertService.WB.CntComOk":"Z\xe4hler f\xfcr g\xfcltige Nachrichten","expertService.WB.IpAdr":"IP-Adresse der Wallbox","expertService.general":"Allgemeine Einstellungen","expertService.general.largeInstallation":"Gro\xdfe Installation","expertService.general.largeInstallation.subtitle":"Erweitert den Wertebereich f\xfcr gro\xdfe Installationen","expertService.password":"Servicezugang","expertService.password.label":"Passwort","expert_service.app_messages":"Nachrichten","expert_service.audit_log":"Audit-Protokoll","expert_service.error_list":"Fehlerliste","expert_service.link":"Experten-Service","expert_service.network":"Netzwerk","expert_service.network.button":"Zu den Netzwerkeinstellungen","expert_service.network.link":"Netzwerk","expert_service.reports":"Berichte","expert_service.stats":"Statistik","expert_service.title":"Service","expert_service.xyz":"Service","header.title":"Startseite","header.title.app_messages":"Nachrichten","header.title.audit_log":"Audit-Protokoll","header.title.boiler":"Boiler","header.title.cloud_plugs":"Steckdosen","header.title.dev":"Netzwerkeinstellungen","header.title.dev.app_messages":"Benachrichtigungen","header.title.dev.az_routers":"AZ-Router","header.title.dev.bez_dodavatele":"bezDodavatele","header.title.dev.cloud_plugs":"Cloud-Steckdosen","header.title.dev.delta_green":"Delta Green","header.title.dev.electree":"Electree","header.title.dev.enerco":"Enerco","header.title.dev.energomachine":"Energomachine","header.title.dev.inverter_config":"Wechselrichterkonfiguration","header.title.dev.mqtt_broker":"MQTT-Broker","header.title.dev.mqtt_cloud":"MQTT Cloud","header.title.dev.pre_flexibility":"PRE Flexibilit\xe4t","header.title.dev.scripts":"Skripte","header.title.dev.shellies":"Shellies","header.title.dev.spot":"Spot","header.title.dev.status_log":"Statusprotokoll","header.title.dev.subscriptions":"Abonnements","header.title.dev_homepage":"Entwicklungsmen\xfc","header.title.ems":"EMS","header.title.ems_service":"EMS-Service","header.title.energyMeters":"Energiez\xe4hler","header.title.expert_service":"Experten-Service","header.title.expert_service.network":"Netzwerkeinstellungen","header.title.grid":"Netz","header.title.heat_pump":"W\xe4rmepumpe","header.title.photovoltaics":"Photovoltaik","header.title.plug":"Steckdose","header.title.relay":"Relais","header.title.reports":"Berichte","header.title.rfid_cards":"RFID-Karten","header.title.settings":"Einstellungen","header.title.spot":"Spot","header.title.statistics":"Statistik","header.title.thermostat":"Thermostat","header.title.wallbox":"Wallbox","header.title.wallbox_list":"Wallboxen","header.title.wind":"Windkraftanlage","heat_pump.HW":"Warmwasserbereitung","heat_pump.HW.actual_temp":"Aktuelle Speichertemperatur","heat_pump.HW.flexitemp":"Flexible Temperatur","heat_pump.HW.flexitemp.subtitle":"Temperatur, um die das Warmwasser vorgeheizt werden kann","heat_pump.HW.hysteresis":"Hysterese der Warmwasserbereitung","heat_pump.HW.on":"Warmwasserbereitung","heat_pump.HW.temp":"Gew\xfcnschte Boilertemperatur","heat_pump.acond":"Acond","heat_pump.blocked":"Kompressorsperre","heat_pump.blocked.min_soc":"Kompressorsperre","heat_pump.blocked.min_soc_utility":"Kompressorsperre bei verf\xfcgbarem Netz","heat_pump.blocked.subtitle":"Batterieladestand, bei dem der Kompressor w\xe4hrend eines Stromausfalls gesperrt wird","heat_pump.common":"Allgemeine Informationen","heat_pump.common.power":"Gesamtverbrauch","heat_pump.common.power_today":"Heutiger Verbrauch:","heat_pump.common.power_year":"Jahresverbrauch:","heat_pump.common.temp":"Aktuelle Temperatur am W\xe4rmetauscher","heat_pump.common.total":"Gesamtverbrauch","heat_pump.ecoone":"Ecoone","heat_pump.flexi":"Energieflexibilit\xe4t","heat_pump.flexi.flexi_on":"Flexibilit\xe4tsmodus","heat_pump.flexi.flexi_on.subtitle":"Der Modus aktiviert das Vorheizen aus \xfcbersch\xfcssiger Energie","heat_pump.flexi.pvstability":"Potenzial f\xfcr die Kompressoraktivierung","heat_pump.flexi_sp":"Spotflexibilit\xe4t","heat_pump.flexi_sp.flexi_increase_on":"Verbrauch erh\xf6hen","heat_pump.flexi_sp.flexi_increase_on.subtitle":"Der Modus erm\xf6glicht eine Erh\xf6hung des Verbrauchs bei niedrigen Energiepreisen","heat_pump.flexi_sp.flexi_reduce_on":"Verbrauch verz\xf6gern","heat_pump.flexi_sp.flexi_reduce_on.subtitle":"Der Modus erm\xf6glicht ein Verschieben des Verbrauchs bei hohen Energiepreisen","heat_pump.nibe":"Nibe","heat_pump.room":"Heizung","heat_pump.room.equithermalCorrection":"Anpassung der Heizkurve","heat_pump.room.flexitemp":"Flexible Temperatur","heat_pump.room.flexitemp.subtitle":"Temperatur, um die das Haus vorgeheizt oder vorgek\xfchlt werden kann","heat_pump.room.on":"Heizung","heat_pump.room.tem":"Gew\xfcnschte Temperatur","heat_pump.room.temp":"Aktuelle Raumtemperatur","heat_pump.room.tempmax":"Gew\xfcnschte Komforttemperatur","heat_pump.room.tempmin":"Gew\xfcnschte Absenktemperatur","heat_pump.room_cool.on":"K\xfchlung","heat_pump.status":"Heizmodus","heat_pump_wizard.cancel":"Abbrechen","heat_pump_wizard.ip_address.alert":"Bitte stellen Sie sicher, dass sich die IP-Adresse der W\xe4rmepumpe nicht \xe4ndert (z. B. wenn die W\xe4rmepumpe eine Adresse von DHCP verwendet).","heat_pump_wizard.ip_address.input":"IP-Adresse der W\xe4rmepumpe","heat_pump_wizard.open":"Typ der W\xe4rmepumpe einrichten","heat_pump_wizard.save":"Speichern","heat_pump_wizard.title":"Einstellungen der W\xe4rmepumpe","heatpump.statistics":"Statistik","heatpump.status":"W\xe4rmepumpenmodus","home.premium.banner.inactive.subtitle":"Infigy Plus bietet detailliertere Diagramme, monatliche Berichte, Benachrichtigungen und vieles mehr.","home.premium.banner.inactive.title":"M\xf6chten Sie einen besseren \xdcberblick?","homepage.actual.battery":"Batteriestatus","homepage.actual.boiler":"Boiler","homepage.actual.outdoor_temperature":"Au\xdfentemperatur","homepage.actual.thermostat":"Thermostat","homepage.actual.title":"","homepage.animation":"Aktuell","homepage.statuses.title":"Aktive Komponentenmodi","homepage.statuses.tooltip":"Aktive Komponentenmodi","homepage.today.consumed":"Hausverbrauch","homepage.today.consumed_WB":"Wallbox","homepage.today.consumed_from_grid":"Verbrauch aus dem Netz","homepage.today.consumed_hp":"W\xe4rmepumpe","homepage.today.consumed_hw":"Warmwasser","homepage.today.overflow":"\xdcberschuss ins Netz","homepage.today.photovoltaics":"Photovoltaikerzeugung","homepage.today.title":"Tagesstatistik","homepage.today.wind":"Erzeugung der Windkraftanlage","hp.status.compressor_blocked":"Kompressorsperre, niedriger Batteriestand","hp.status.cooling":"K\xfchlung","hp.status.heating":"Heizung","hp.status.hot_water":"Warmwasserbereitung","hp.status.inactive":"Inaktiv","hp.status.not_connected":"Verbindung kann nicht hergestellt werden","hp.status.not_licensed":"W\xe4rmepumpe ist nicht lizenziert","hp.status.pool":"Poolheizung","hp.sub_status.consumption_postpone":"bei reduziertem Verbrauch","hp.sub_status.consumption_rise":"bei erh\xf6htem Verbrauch","hp.sub_status.consumption_with_flexibility":"mit Flexibilit\xe4t","hp.sub_status.nibe_not_writable":"- Schreiben auf NIBE nicht m\xf6glich","hp.sub_status.none":"","initial_wizard.banner.button":"Assistenten starten","initial_wizard.banner.hide.confirm":"M\xf6chten Sie den Assistenten wirklich ausblenden?","initial_wizard.banner.hide.confirm.description":"Sie k\xf6nnen den Assistenten jederzeit in den Anwendungseinstellungen erneut starten.","initial_wizard.banner.hide.show_more":"Assistenten starten","initial_wizard.banner.hide.yes":"Ausblenden","initial_wizard.banner.subtitle":"Der Assistent hilft Ihnen, die grundlegenden Parameter Ihres Systems einzurichten.","initial_wizard.banner.title":"Erstkonfiguration abschlie\xdfen","initial_wizard.banner.title.completed":"Erstkonfiguration abschlie\xdfen","initial_wizard.dialog.finish":"Fertigstellen","initial_wizard.dialog.next":"Weiter","initial_wizard.dialog.prev":"Zur\xfcck","initial_wizard.dialog.step":"Schritt {current} von {total}","initial_wizard.dialog.title":"Assistent f\xfcr die Erstkonfiguration","initial_wizard.step1.description.active":"Ihr Zugang zum Service ist bereits aktiv. Sie k\xf6nnen mit dem n\xe4chsten Schritt fortfahren.","initial_wizard.step1.password_info":"Jedes Unternehmen hat ein eigenes Zugangspasswort zum Servicemen\xfc. Sie haben das Passwort per E-Mail erhalten. Sie k\xf6nnen es auch jederzeit unter app.infigy.cz im Partnerbereich einsehen.","initial_wizard.step1.title":"Zugang zum Service","initial_wizard.step1.welcome":"Willkommen bei der Erstkonfiguration von Infigy. Wir f\xfchren Sie durch die Grundkonfiguration Ihres Systems. Detaillierte Einstellungen finden Sie anschlie\xdfend im Servicemen\xfc.","initial_wizard.step10.title":"Wallbox-Einstellungen","initial_wizard.step11.description":"Sie haben die Grundeinstellung von Infigy abgeschlossen. Alle Parameter k\xf6nnen im Servicemen\xfc bearbeitet werden.","initial_wizard.step11.service_menu.subtitle":"Einstellungen -> ganz nach unten -> Zugang zum Service","initial_wizard.step11.service_menu.title":"Servicemen\xfc","initial_wizard.step11.title":"Fertig","initial_wizard.step2.title":"Aktualisierung der Anwendung","initial_wizard.step3.title":"Installation","initial_wizard.step4.title":"Einstellungen des Hauptleistungsschalters","initial_wizard.step5.title":"Wechselrichteranschluss","initial_wizard.step6.title":"Wechselrichterparameter","initial_wizard.step7.description":"Wenn der \xdcberschuss ins Netz begrenzt ist, werden die Einstellungen an den Wechselrichter \xfcbertragen. Die Begrenzung der \xdcbersch\xfcsse \xfcbernimmt der Wechselrichter. Infigy steuert den Wert jedoch gem\xe4\xdf dem in diesem Feld festgelegten Wert. \xc4ndern Sie das \xdcberschusslimit nicht im Wechselrichter. Bei der Ersteinrichtung pr\xfcfen Sie den im Wechselrichter geschriebenen Wert, ob er korrekt von Infigy an den Wechselrichter \xfcbertragen wurde.","initial_wizard.step7.title":"\xdcberschusslimit","initial_wizard.step8.title":"Boiler-Einstellungen","initial_wizard.step9.title":"Einstellungen f\xfcr den Spot-Handel","initial_wizard.step_app_update.description":"W\xe4hrend Infigy zu Ihnen unterwegs war, konnten wir neue Versionen der Anwendung ver\xf6ffentlichen. Wir empfehlen, das Ger\xe4t vor der Einrichtung zu aktualisieren. Wenn jedoch beispielsweise kein Internet verf\xfcgbar ist, k\xf6nnen Sie die Aktualisierung \xfcberspringen und sie sp\xe4ter im Servicemen\xfc oder im Portal durchf\xfchren.","inverter.3mar_plc":"3Mar PLC","inverter.az_router":"AzRouter-Energiez\xe4hler","inverter.control.mode":"Wechselrichtersteuerung","inverter.control.mode.chargingFromGrid":"Laden der Batterie aus dem Netz","inverter.control.mode.dischargingToGrid":"Entladen der Batterie ins Netz","inverter.control.mode.noneControl":"Keine Steuerung","inverter.control.mode.stopCharging":"Laden stoppen","inverter.control.mode.stopDischarging":"Entladen stoppen","inverter.control.mode.stopOverflow":"\xdcberschuss stoppen","inverter.des_battery_container":"DES \u2013 Containerspeicher","inverter.deye":"Deye LV","inverter.deye_hv":"Deye HV","inverter.fronius":"Fronius SYMO GEN24","inverter.fronius_grid":"Fronius SYMO Netz","inverter.fronius_verto":"Fronius Verto","inverter.good_we":"GoodWe","inverter.good_we_grid_next":"GoodWe Netz","inverter.good_we_next":"GoodWe","inverter.goodwe-Grid":"Goodwe netzgekoppelt","inverter.goodwe_grid":"Goodwe Netz","inverter.hes":"HES \u2013 Batteriespeicher","inverter.next":"Weitere Wechselrichter","inverter.none":"Keine","inverter.sermatec":"Sermatec","inverter.shellies":"Shellies","inverter.shellies_external":"Shellies Extern","inverter.sma_grid":"SMA Netz","inverter.sofar_solar":"Sofarsolar","inverter.sofar_solar_rs485":"SofarSolar RS485","inverter.solar_edge_grid":"SolarEdge netzgekoppelt","inverter.solax":"Solax","inverter.solax-Grid":"Solax netzgekoppelt","inverter.solax_ems1000":"Solax EMS1000","inverter.solax_ems1000pro":"Solax EMS1000PRO","inverter.solax_grid":"Solax netzgekoppelt","inverter.solax_mega_grid":"Solax MEGA/FORTH netzgekoppelt","inverter.solax_mic_grid":"Solax MIC netzgekoppelt","inverter.solax_next":"SolaxNext","inverter.solinteg":"Solinteg","inverter.victron":"Victron","inverter.wattsonic":"Wattsonic","inverter_wizard.cancel":"Abbrechen","inverter_wizard.custom_device_ip_address.alert":"Bitte stellen Sie sicher, dass sich die IP-Adresse des Wechselrichters nicht \xe4ndert (z. B. wenn der Wechselrichter eine Adresse von DHCP verwendet).","inverter_wizard.custom_device_ip_address.input":"IP-Adresse des Wechselrichters","inverter_wizard.multiple_inverters.alert":"Bitte kontaktieren Sie die Support-Hotline f\xfcr die Einrichtung mehrerer Wechselrichter. Den Kontakt finden Sie im technischen Wiki von Infigy.","inverter_wizard.multiple_inverters.label":"Mehrere Wechselrichter","inverter_wizard.multiple_inverters_or_ems.alert":"Ihr System verf\xfcgt bereits \xfcber Einstellungen f\xfcr mehrere Wechselrichter oder EMS. Dieser Assistent ist nur f\xfcr die Einrichtung eines Wechselrichters vorgesehen. F\xfcr \xc4nderungen an den Einstellungen von Wechselrichtern oder EMS wenden Sie sich bitte an den Support.","inverter_wizard.nominal_power":"Nennleistung des Wechselrichters","inverter_wizard.nominal_power.helper":"Bereich: 1 bis 100 kW","inverter_wizard.nominal_power.validation":"Geben Sie die Nennleistung des Wechselrichters in kW ein.","inverter_wizard.open":"Wechselrichter finden","inverter_wizard.save":"Speichern","inverter_wizard.scan":"Wechselrichter im Netzwerk finden","inverter_wizard.scanning":"Suche nach Wechselrichter im Netzwerk","inverter_wizard.submit_error":"Beim Speichern der Wechselrichtereinstellungen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.","inverter_wizard.title":"Assistent zum Anschluss des Wechselrichters","layout.disconnected":"Getrennt","layout.pigpio_init_error_dialog.description":"Die Infigy-Anwendung wurde nicht korrekt gestartet. Bitte starten Sie das Ger\xe4t neu und kontaktieren Sie den Support, falls das Problem weiterhin besteht.","layout.pigpio_init_error_dialog.title":"Fehler beim Starten der Anwendung","level.thermostat.cooling":"K\xfchlung","level.thermostat.deactivated":"Deaktiviert","level.thermostat.heating":"Heizung","level.thermostat.standby":"Standby","level.thermostat.tempErr":"Temperaturfehler","level.thermostatFlexibility.increasePv":"Flexibilit\xe4t zur Temperaturerh\xf6hung gem\xe4\xdf Photovoltaik genutzt","level.thermostatFlexibility.increaseSpot":"Flexibilit\xe4t zur Temperaturerh\xf6hung gem\xe4\xdf SPOT genutzt","level.thermostatFlexibility.normal":"Normal","level.thermostatFlexibility.reductionSpot":"Flexibilit\xe4t zur Temperatursenkung gem\xe4\xdf SPOT genutzt","mqtt_broker.connected_clients.title":"Clients","mqtt_broker.enabled":"Aktiviert","mqtt_broker.running":"Status","mqtt_broker.title":"MQTT-Broker","mqtt_cloud.connected":"Status","mqtt_cloud.connected.offline":"Offline","mqtt_cloud.connected.online":"Online","mqtt_cloud.enabled":"Integration aktiviert","mqtt_cloud.title":"MQTT Cloud","nav.app_messages":"Nachrichten","nav.home":"Startseite","nav.logout":"Abmelden","nav.reports":"Berichte","nav.sec.boiler":"Boiler","nav.sec.cloud_plugs":"Steckdosen","nav.sec.ems":"EMS","nav.sec.energyMeters":"Energiez\xe4hler","nav.sec.grid":"Netz","nav.sec.heatpump":"W\xe4rmepumpe","nav.sec.home":"Allgemein","nav.sec.photovoltaics":"Photovoltaik","nav.sec.plug":"Steckdose","nav.sec.relay":"Relais","nav.sec.spot":"Spot","nav.sec.thermostat":"Thermostat","nav.sec.wallbox":"Wallbox","nav.sec.wind":"Windkraftanlage","nav.settings":"Einstellungen","nav.statistics":"Statistik","network.ethernet_ports":"Ethernet-Ports","network.ethernet_ports.name":"LAN","network.ethernet_ports.status":"Status","network.ethernet_ports.status.down":"Inaktiv","network.ethernet_ports.status.up":"Aktiv","network.scan.error":"Netzwerkscan fehlgeschlagen","network.summary.address":"IP-Adresse","network.summary.dhcp_host_exists":"Adresse auf DHCP festgesetzt. Klicken Sie, um die Festsetzung aufzuheben.","network.summary.error":"Fehler beim Laden","network.summary.heat_pump":"W\xe4rmepumpe","network.summary.inverter":"Wechselrichter","network.summary.mac":"MAC","network.summary.name":"Name","network.summary.no_dhcp_host":"Dynamische Adresse auf DHCP. Klicken Sie, um festzusetzen.","network.summary.not_connected":"Nicht verbunden","network.title":"Allgemein","network.wan_address":"WAN-Adresse","network_wan_edit.dialog.address":"IP-Adresse","network_wan_edit.dialog.close":"Schlie\xdfen","network_wan_edit.dialog.dns":"DNS-Server","network_wan_edit.dialog.gateway":"Standardgateway","network_wan_edit.dialog.netmask":"Netzmaske","network_wan_edit.dialog.save":"Speichern","network_wan_edit.dialog.title":"WAN-Adresse bearbeiten","nmap.empty":"Nichts gefunden","nmap.error":"Scan fehlgeschlagen","nmap.host":"Adresse","nmap.loading":"Scannen","nmap.output":"Ausgabe","nmap.port":"Port","nmap.port.help":"Leer = nur Ger\xe4tesuche","nmap.range.external":"extern \u2014 Kundennetzwerk","nmap.range.internal":"intern \u2014 Infigy-Netzwerk","nmap.result.address":"IP-Adresse","nmap.result.mac":"MAC-Adresse","nmap.result.ports":"Ports","nmap.result.scanning":"Scannen von {target}, dies kann eine Weile dauern\u2026","nmap.result.target":"Gescannter Bereich: {target}","nmap.result.vendor":"Hersteller","nmap.start":"Start","nmap.target":"Adresse oder Bereich","nmap.target.help":"Benanntes Netzwerk oder IP / Bereich","nmap.title":"Portscan","photovoltaics.battery":"Batterie","photovoltaics.battery.battery_charged":"Laden der Batterie","photovoltaics.battery.battery_manual_discharge":"Batterie manuell entladen","photovoltaics.battery.battery_power":"Batterieleistung","photovoltaics.battery.soc_actual":"Berechneter Mindestladestand","photovoltaics.batteryStatus":"BMS-Status","photovoltaics.battery_stop":"Batteriesperre","photovoltaics.battery_stop.hdo":"Batterie nur bei Niedertarif (HDO) entladen","photovoltaics.battery_stop.hp":"Batterie beim Betrieb der W\xe4rmepumpe sperren","photovoltaics.battery_stop.hw":"Batterie beim Betrieb der Warmwasserbereitung sperren","photovoltaics.battery_stop.wb":"Batterie beim Betrieb der Wallbox sperren","photovoltaics.battery_stop.wb.lock_desc":"Wenn der Wallbox-Lademodus \u201ELaden gem\xe4\xdf Batterie\u201C aktiviert ist, kann diese Sperre nicht aktiviert werden. Stellen Sie einen anderen Wallbox-Lademodus ein, um die Sperre zu aktivieren.","photovoltaics.battery_stop.wb.lock_title":"Einstellung kann nicht ge\xe4ndert werden","photovoltaics.common":"Allgemeine Informationen","photovoltaics.common.battery_charged":"Batterieladen","photovoltaics.common.battery_manual_charge":"Batterie manuell laden","photovoltaics.common.battery_manual_charge_soc":"Ziel-SOC f\xfcr manuelles Laden","photovoltaics.common.battery_manual_charge_subtitle":"Das manuelle Laden der Batterie l\xe4dt die Batterie auf den Zielladestand, sofern es nicht zuvor vom Benutzer ausgeschaltet wird.","photovoltaics.common.battery_manual_discharge":"Batterie manuell entladen","photovoltaics.common.battery_manual_discharge_subtitle":"Das manuelle Entladen der Batterie entl\xe4dt die Batterie auf den Mindestladestand, sofern es nicht zuvor vom Benutzer ausgeschaltet wird.","photovoltaics.common.battery_power":"Batterieleistung","photovoltaics.common.power":"Aktuelle Leistung","photovoltaics.common.power_today":"Heutige Erzeugung:","photovoltaics.common.power_total":"Gesamterzeugung","photovoltaics.common.power_year":"Jahreserzeugung:","photovoltaics.common.string1":"String 1:","photovoltaics.common.string2":"String 2:","photovoltaics.common.string3":"String 3:","photovoltaics.common.string4":"String 4:","photovoltaics.common.string5":"String 5:","photovoltaics.common.string6":"String 6:","photovoltaics.statistics":"Statistik","photovoltaics.statistics.charge":"Laden der Batterie","photovoltaics.statistics.discharge":"Entladen der Batterie","photovoltaics.statisticsSoc":"Batteriestand","photovoltaics.status":"Photovoltaikmodus","ping.address":"Adresse","ping.output":"Ausgabe","ping.start":"Start","ping.stop":"Stopp","ping.title":"Ping","plug.bat":"Steuerung nach Batterie","plug.bat.batterySart":"Einschalten beim Laden","plug.bat.batterySart.help":"Batteriestand, bei dem sich die Steckdose einschaltet. Damit sich die Steckdose einschaltet, muss der Batteriestand vom eingestellten Zustand in einen h\xf6heren Zustand wechseln. Ist der Wert auf 80 % gesetzt, schaltet sich die Steckdose ein, wenn die Batterie von 80 % auf 81 % geladen wird.","plug.bat.batterySart.subtitle":"Batterieladung, bei der sich die Steckdose aktiviert","plug.bat.batteryStop":"Ausschalten bei Ladezustand","plug.bat.batteryStop.help":"Batteriestand, bei dem sich die Steckdose ausschaltet. Damit sich die Steckdose ausschaltet, muss der Batteriestand vom eingestellten Zustand in einen niedrigeren Zustand wechseln. Ist der Wert auf 80 % gesetzt, schaltet sich die Steckdose aus, wenn die Batterie von 80 % auf 79 % entladen wird.","plug.bat.batteryStop.subtitle":"Batterieladung, bei der sich die Steckdose ausschaltet","plug.bat.help":"Einschalten bei einem festgelegten Batteriestand. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erf\xfcllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erf\xfcllt, schaltet sich die Steckdose aus.","plug.bat.on":"Aktiv","plug.main":"Allgemeine Informationen","plug.main.consumption":"Aktueller Verbrauch","plug.main.power":"Gesamtverbrauch","plug.main.power_today":"Heutiger Verbrauch:","plug.main.power_year":"Jahresverbrauch:","plug.main.stat":"Statistik","plug.overflow":"Steuerung nach \xdcberschuss","plug.overflow.consumption":"Die Einstellung entspricht einem Ger\xe4t mit Leistungsaufnahme","plug.overflow.help":"Einschalten der Steckdose bei einem festgelegten \xdcberschuss ins Verteilnetz. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erf\xfcllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erf\xfcllt, schaltet sich die Steckdose aus.","plug.overflow.on":"Aktiv","plug.overflow.startPower":"Einschalten bei Netzbezug","plug.overflow.startPower.help":"Die Steckdose schaltet sich ein, wenn der \xdcberschuss nach einer festgelegten Verz\xf6gerung das eingestellte Niveau erreicht. Ist der Wert auf - 1500W gesetzt und die Einschaltverz\xf6gerung betr\xe4gt 5 Minuten, schaltet sich die Steckdose ein, wenn der \xdcberschuss ins Netz mindestens 1500W f\xfcr 5 Minuten betr\xe4gt.","plug.overflow.startPower.subtitle":"Negativer Wert bedeutet \xdcberschuss","plug.overflow.stopPower":"Ausschalten bei Netzbezug","plug.overflow.stopPower.help":"Die Steckdose schaltet sich aus, wenn der Verbrauch nach einer festgelegten Verz\xf6gerung \xfcber dem eingestellten Niveau liegt. Ist der Wert auf 100W gesetzt und die Ausschaltverz\xf6gerung betr\xe4gt 5 Minuten, schaltet sich die Steckdose aus, wenn der Verbrauch aus dem Netz mindestens 100W f\xfcr 5 Minuten betr\xe4gt.","plug.overflow.stopPower.subtitle":"Negativer Wert bedeutet \xdcberschuss, positiver Wert bedeutet Verbrauch","plug.overflow.time":"Ein- und Ausschaltverz\xf6gerung","plug.overflow.time.help":"Dieser Parameter dient zur Festlegung der Verz\xf6gerung beim Ein- und Ausschalten der Steckdose bei definierten \xdcbersch\xfcssen/Verbr\xe4uchen. Geeignet zur Priorit\xe4tseinstellung und zur Vermeidung h\xe4ufigen Schaltens der Steckdose. Geben Sie das Format HH:MM ein.","plug.plug":"Steckdose","plug.spot":"Steuerung nach Spotpreis","plug.spot.15m.period":"Spotpreisperiode","plug.spot.15m.period.subtitle":"15-Minuten-Intervalle","plug.spot.help":"Einschalten bei einem festgelegten Spotpreis. Kann mit einer Zeitbedingung kombiniert werden. Ist eine der Bedingungen zum Einschalten erf\xfcllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erf\xfcllt, schaltet sich die Steckdose aus.","plug.spot.on":"Aktiv","plug.spot.period":"Spotpreisperiode","plug.spot.period.subtitle":"60-Minuten-Intervalle","plug.spot.price.period":"Zeitaufl\xf6sung der Steckdose","plug.spot.spotHi":"Bei hohem Preis aktivieren","plug.spot.spotHi.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem hohen Niveau liegt (siehe Registerkarte Spot).","plug.spot.spotLow":"Bei niedrigem Preis aktivieren","plug.spot.spotLow.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem niedrigen Niveau liegt (siehe Registerkarte Spot).","plug.spot.spotMi":"Bei mittlerem Preis aktivieren","plug.spot.spotMi.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis auf dem mittleren Niveau liegt (siehe Registerkarte Spot).","plug.spot.spot_above_price":"Bei einem h\xf6heren als dem festgelegten Preis aktivieren","plug.spot.spot_above_price.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis h\xf6her oder gleich dem festgelegten Spotpreis ist.","plug.spot.spot_above_price.subtitle":"Die Steckdose schaltet sich ein, wenn der Spotpreis h\xf6her oder gleich dem festgelegten Spotpreis ist. Ist er niedriger, schaltet sich die Steckdose aus.","plug.spot.spot_below_price":"Bei einem niedrigeren als dem festgelegten Preis aktivieren","plug.spot.spot_below_price.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis niedriger oder gleich dem festgelegten Spotpreis ist.","plug.spot.spot_below_price.subtitle":"Die Steckdose schaltet sich ein, wenn der Spotpreis niedriger oder gleich dem festgelegten Spotpreis ist. Ist er h\xf6her, schaltet sich die Steckdose aus.","plug.spot.spot_neg":"Bei negativem Preis aktivieren","plug.spot.spot_neg.help":"Die Steckdose schaltet sich ein, wenn der Spotpreis negativ ist (siehe Registerkarte Spot).","plug.status":"Steckdosenmodus","plug.summary.price":"Preis","plug.summary.price_level":"Preisniveau","plug.summary.price_level_15m":"Preisniveau 15 Min.","plug.summary.switch":"Steckdosenschalter","plug.summary.time":"Zeit","plug.time":"Steuerung nach Zeit","plug.time.help":"Einschalten zu einer festgelegten Zeit. Kann mit weiteren Bedingungen kombiniert werden, abh\xe4ngig von der Batterie (muss installiert sein), dem Spotpreis (Spothandel muss erlaubt sein) und dem \xdcberschuss (\xdcberschuss ins Netz muss erlaubt sein). Ist eine der Bedingungen zum Einschalten erf\xfcllt, schaltet sich die Steckdose ein; ist eine der Bedingungen zum Ausschalten erf\xfcllt, schaltet sich die Steckdose aus.","plug.time.on":"Aktiv","plug.time.turn_off":"Zu einer festgelegten Zeit ausschalten","plug.time.turn_off.help":"Zeit, zu der sich die Steckdose ausschaltet. Bei Einstellung auf 12:00 schaltet sich die Steckdose genau um 12:00 aus.","plug.time.turn_on":"Zu einer festgelegten Zeit einschalten","plug.time.turn_on.help":"Zeit, zu der sich die Steckdose einschaltet. Bei Einstellung auf 12:00 schaltet sich die Steckdose genau um 12:00 ein.","plug.turn_off":"Ausschalten","plug.turn_on":"Einschalten","pre_flexibility.business_flexibility.title":"Kommerzielle Flexibilit\xe4t","pre_flexibility.enabled":"Integration aktiviert","pre_flexibility.title":"PRE Flexibilit\xe4t","premium.banner.active.button":"Abonnement verwalten","premium.banner.active.dev_mode":"Abonnement ist f\xfcr die Entwicklung aktiv","premium.banner.active.subtitle":"Das Infigy-Plus-Abonnement ist aktiv. Sie k\xf6nnen alle zus\xe4tzlichen Funktionen der Anwendung nutzen.","premium.banner.active.title":"Abonnement ist aktiv","premium.banner.hide.confirm":"M\xf6chten Sie das Infigy-Plus-Banner wirklich ausblenden?","premium.banner.hide.confirm.description":"Sie k\xf6nnen Infigy Plus jederzeit wieder in den Anwendungseinstellungen anzeigen.","premium.banner.hide.later":"Sp\xe4ter erinnern","premium.banner.hide.show_more":"Mehr erfahren","premium.banner.hide.yes":"Ausblenden","premium.banner.inactive.button":"Mehr erfahren","premium.banner.inactive.subtitle":"Heben Sie Ihr Energiemanagement auf die n\xe4chste Stufe. Mit Infigy Plus erhalten Sie noch mehr intelligente Werkzeuge \u2013 detaillierte Diagramme, sofortige Benachrichtigungen, einen erweiterten Kalender, detaillierte Berichte und mehr.","premium.banner.inactive.title":"Infigy Plus ist nicht aktiv","premium.dialog.charts.subtitle":"Verfolgen Sie die Leistung einzelner Strings, den Verbrauch nach Phasen und weitere detaillierte Informationen.","premium.dialog.charts.title":"Detaillierte Diagramme","premium.dialog.close":"Schlie\xdfen","premium.dialog.next.subtitle":"Wir bereiten viele zus\xe4tzliche Vorteile vor, die wir schrittweise f\xfcr Infigy-Plus-Abonnenten freischalten","premium.dialog.next.title":"Weitere Vorteile folgen in K\xfcrze","premium.dialog.notifications.subtitle":"Erhalten Sie Benachrichtigungen zu negativen Preisen, geladener Batterie und weiteren Ereignissen","premium.dialog.notifications.title":"Benachrichtigungen","premium.dialog.other_benefits.subtitle":"Wir bereiten zahlreiche zus\xe4tzliche Vorteile vor, die wir nach und nach f\xfcr Infigy-Plus-Abonnenten bereitstellen","premium.dialog.other_benefits.title":"Weitere Vorteile folgen in K\xfcrze","premium.dialog.reports.subtitle":"Detaillierte monatliche Berichte, die Ihnen ein klares Bild von Erzeugung, Verbrauch und Energienutzung in Ihrem Haushalt geben. Alle wichtigen Daten sind an einem Ort \u2013 \xfcbersichtlich und durch Diagramme erg\xe4nzt.","premium.dialog.reports.title":"Erweiterte Berichte","premium.dialog.save":"Infigy Plus abonnieren","premium.dialog.schedule.subtitle":"Planen Sie das Laden oder Entladen der Batterie manuell nach Bedarf","premium.dialog.schedule.title":"Erweiterter Kalender","premium.dialog.spot.subtitle":"Sehen Sie die Historie der Spotpreise und der Pl\xe4ne ein, die Infigy in der Vergangenheit erstellt hat","premium.dialog.spot.title":"Historie der Spotpreise","protocol.settings":"Einstellungen","protocol.settings.Licence":"Lizenz","protocol.settings.distribution":"Lizenz","protocol.test":"Ger\xe4tetest","protocol.test.internet-connect":"Internetverbindung","protocol.test.inverter-connect":"Verbindung des Wechselrichters","protocol.test.phase_1":"Test Phase 1","protocol.test.phase_2":"Test Phase 2","protocol.test.phase_3":"Test Phase 3","protocol.test.tester":"Ger\xe4t getestet von","relay.condition":"Einschaltbedingung","relay.main":"Allgemeine Informationen","relay.name":"Name des Relais","relay.spot.diagram":"Steuerung nach Spotpreis","relay.status":"Status","relay.summary.switch":"Relaisschalter","relay.title":"Relais","report.avg_day_chart.battery_soc":"Ladezustand der Batterie","report.avg_day_chart.consumption":"Verbrauch","report.avg_day_chart.grid":"Netz","report.avg_day_chart.pv_production":"PV-Erzeugung","report.not_generated":"Bericht durch Klicken erstellen","report_test.button":"Test","report_test.date":"Monat (z. B. 2025-09)","report_test.generated":"Bericht erstellt","report_test.ok":"OK","report_test.test":"Test","reports.accumulation_increased":"Speicherung erh\xf6ht","reports.average_water_temperature":"Durchschnittliche Wassertemperatur","reports.avg_day":"Durchschnittlicher Tag","reports.battery":"Batterie","reports.boiler":"Elektroboiler","reports.building_consumption":"Geb\xe4udeverbrauch","reports.disclaimer":"Die Werte haben nur informativen Charakter und k\xf6nnen von den offiziellen Ablesungen des Netzbetreibers abweichen.","reports.energy_estimate":"Energiesch\xe4tzung ohne Steuerung","reports.estimated_water_amount":"Gesch\xe4tzte Wassermenge","reports.grid_consumption":"Netzverbrauch","reports.grid_consumption_hp":"Netzverbrauch f\xfcr W\xe4rmepumpe","reports.grid_consumption_hw":"Netzverbrauch f\xfcr Elektroboiler","reports.grid_consumption_wallbox":"Netzverbrauch f\xfcr Wallbox","reports.heat_pump":"W\xe4rmepumpe","reports.household_consumption":"Haushaltsverbrauch","reports.info":"Allgemeine Informationen","reports.kilometers_driven":"Anzahl der gefahrenen Kilometer","reports.kilometers_driven_from_sun":"Anzahl der mit Sonnenenergie gefahrenen Kilometer","reports.maximum_power":"Maximale Leistung","reports.monthly_consumption":"Monatlicher Verbrauch","reports.monthly_production":"Monatliche Erzeugung","reports.pv":"Photovoltaikanlage","reports.pv_consumption":"PV-Verbrauch","reports.pv_production":"PV-Erzeugung","reports.regenerate_report":"Bericht neu erstellen","reports.regenerate_report_confirm_title":"Bericht neu erstellen?","reports.rfid_cards":"RFID-Karten","reports.self_consumption":"Eigenverbrauch","reports.self_sufficiency":"Autarkie","reports.self_sufficient_days":"Anzahl der autarken Tage","reports.share.description":"Sie k\xf6nnen den ausgew\xe4hlten Screenshot mit anderen teilen.","reports.share.share":"Bericht teilen","reports.share.title":"Bericht teilen","reports.share_report":"Bericht teilen","reports.sold_to_distribution_grid":"Ins Netz verkauft","reports.stored_energy_from_grid":"Gespeicherte Energie aus dem Netz","reports.stored_energy_from_pv":"Gespeicherte Energie aus PV","reports.stored_energy_to_battery":"In der Batterie gespeicherte Energie","reports.stored_energy_to_boiler":"Im Elektroboiler gespeicherte Energie","reports.stored_energy_to_heat_pump":"In der W\xe4rmepumpe gespeicherte Energie","reports.stored_energy_to_wallbox":"In der Wallbox gespeicherte Energie","reports.total_overflow_to_grid":"Gesamter \xdcberschuss ins Netz","reports.total_purchase_from_grid":"Gesamter Bezug aus dem Netz","reports.total_with_control":"Gesamt mit Steuerung","reports.total_without_control":"Gesamt ohne Steuerung","reports.updated_at":"Erstellt {date}","reports.wallbox":"Ladestation f\xfcr Elektrofahrzeuge (Wallbox)","rfid_cards.col.consumption":"Verbrauch","rfid_cards.col.created_at":"Hinzugef\xfcgt","rfid_cards.col.id":"Karten-ID","rfid_cards.col.name":"Name","rfid_cards.export":"CSV exportieren","rfid_cards.from":"Von","rfid_cards.no_cards":"Keine Karten hinzugef\xfcgt","rfid_cards.title":"RFID-Karten","rfid_cards.to":"Bis","save":"Speichern","schedules.add":"Zeitplan hinzuf\xfcgen","schedules.add.tooltip":"Hinzuf\xfcgen","schedules.battery_charge":"Laden der Batterie","schedules.battery_discharge":"Entladen der Batterie","schedules.charging_current":"Ladestrom: {chargingCurrent} A","schedules.description":"Planen Sie das Laden oder Entladen der Batterie manuell nach Bedarf.","schedules.dialog.title":"Planer","schedules.dialog.title.ev":"Ladeplan erstellen","schedules.ev_charging":"Laden des Elektrofahrzeugs","schedules.form.action":"Aktion","schedules.form.battery_charge":"Batterie laden","schedules.form.battery_discharge":"Batterie entladen","schedules.form.charging-current":"Ladestrom einstellen","schedules.form.charging-current.auto":"Standard","schedules.form.close":"Schlie\xdfen","schedules.form.create":"Erstellen","schedules.form.duration":"Dauer (Minuten)","schedules.form.duration.120min":"2 Stunden","schedules.form.duration.180min":"3 Stunden","schedules.form.duration.240min":"4 Stunden","schedules.form.duration.300min":"5 Stunden","schedules.form.duration.360min":"6 Stunden","schedules.form.duration.60min":"1 Stunde","schedules.form.ev_charging":"Laden des Elektrofahrzeugs","schedules.form.frequency":"H\xe4ufigkeit","schedules.form.frequency.daily":"T\xe4glich","schedules.form.frequency.monthly":"Monatlich","schedules.form.frequency.weekly":"W\xf6chentlich","schedules.form.interval.biweekly":"Alle 2 Wochen","schedules.form.preview.hide":"Vorschau ausblenden","schedules.form.preview.show":"Geplante Termine anzeigen","schedules.form.preview.title":"Geplante Starts ({count} folgende)","schedules.form.recurring":"Wiederkehrend","schedules.form.target-soc":"Ziel-SOC (optional)","schedules.form.until":"Wiederholen bis (optional)","schedules.form.when":"Wann","schedules.loading.error":"Fehler beim Laden der Zeitpl\xe4ne","schedules.missed":"Verpasst","schedules.no_plans_found":"Keine Pl\xe4ne gefunden.","schedules.processed":"Verarbeitet","schedules.remove.confirm":"M\xf6chten Sie den Plan wirklich l\xf6schen?","schedules.remove.no":"Abbrechen","schedules.remove.recurring.instance":"Nur dieses Vorkommen l\xf6schen","schedules.remove.recurring.series":"Gesamte Serie l\xf6schen","schedules.remove.recurring.title":"Wiederkehrenden Plan l\xf6schen","schedules.remove.yes":"L\xf6schen","schedules.running":"L\xe4uft","schedules.scheduled":"Geplant","schedules.show_processed":"Verarbeitete anzeigen","schedules.target_soc":"Ziel-SOC: {targetSoc, number, percent}","schedules.title":"Planer","scripts.add":"Erstellen","scripts.delete":"L\xf6schen","scripts.edit":"Bearbeiten","scripts.loading_error":"Fehler beim Laden der Skripte","scripts.title":"Skripte","settings.PV.NominalInverterPower":"Nennleistung des Wechselrichters","settings.PV.NominalInverterPower.help":"Dies ist wichtig f\xfcr die korrekte %-Berechnung der \xdcbersch\xfcsse bei Solinteg, Wattsonic und Deye.","settings.PV.NominalInverterPower.subtitle":"Nennleistung des Wechselrichters in kW, wichtig f\xfcr die %-Berechnung der \xdcbersch\xfcsse ins Netz.","settings.PV.StringNumber":"Anzahl der Wechselrichter-Strings","settings.PV.StringNumber.subtitle":"Anzahl der Wechselrichter-Strings, die im PV-Tab der Anwendung angezeigt werden","settings.app_update":"Anwendungsversion","settings.app_update.check_button":"Nach Updates suchen","settings.app_update.confirm.cancel":"Abbrechen","settings.app_update.confirm.confirm":"Aktualisieren","settings.app_update.confirm.description":"Die Aktualisierung kann einige Minuten dauern. W\xe4hrend der Aktualisierung ist die Anwendung nicht verf\xfcgbar und startet anschlie\xdfend automatisch neu.","settings.app_update.confirm.title":"Aktualisierung starten?","settings.app_update.error.no_internet":"Pr\xfcfen Sie Ihre Internetverbindung","settings.app_update.in_progress":"Aktualisierung l\xe4uft","settings.app_update.request_button":"Aktualisierung verf\xfcgbar","settings.app_update.requested":"Aktualisierung wurde angefordert","settings.app_update.subtitle":"Nach neuen Versionen suchen","settings.app_update.title":"Aktualisierung der Anwendung","settings.app_update.up_to_date":"Die Anwendung ist aktuell","settings.boiler":"Elektroboiler","settings.boiler.3phase":"Dreiphasiger Elektroboiler","settings.boiler.3phase.subtitle":"Schlie\xdfen Sie einen einphasigen Elektroboiler an den SSR-Ausgang der gew\xe4hlten Phase an.","settings.boiler.HwBatteryPriority":"Prozentsatz der Batterieladung, ab dem der Boiler zu heizen beginnt","settings.boiler.HwBatteryPriority.help":"Wenn der Batterieladezustand niedriger als dieser Wert ist, steht die Priorit\xe4t der Energiespeicherung vollst\xe4ndig der Batterie zur Verf\xfcgung. Ist der Batterieladezustand h\xf6her, \xfcbernimmt der Boiler die Priorit\xe4t und beginnt, Wasser aus der \xfcbersch\xfcssigen PV-Energie zu erw\xe4rmen \u2013 ein Teil der Energie flie\xdft weiter in die Batterie, bis diese geladen ist.","settings.boiler.capacity":"Boilervolumen","settings.boiler.capacity_sub":"Nur f\xfcr den Spothandel erforderlich","settings.boiler.enabled":"Elektroboiler installiert","settings.boiler.hysterezis":"Boilerhysterese","settings.boiler.hysterezis.subtitle":"Die Hysterese gilt nur f\xfcr das regul\xe4re Heizen","settings.boiler.nominal":"Nennleistung","settings.boiler.nominal.subtitle":"Nennaufnahme f\xfcr 1 Phase des Elektroboilers","settings.boiler.phase":"Boilerphase","settings.boiler.phase.subtitle":"L1 = SSR-Ausgang 1, L2 = SSR-Ausgang 2, L3 = SSR-Ausgang 3.","settings.boiler.prio":"Batteriepriorit\xe4t","settings.boiler.prio.subtitle":"Wenn Ein, wird zuerst die Batterie geladen, anschlie\xdfend der Boiler","settings.boiler.shellies":"Der Boiler wird \xfcber Shelly gesteuert","settings.boiler.temp_enabled":"Temperatursensor installiert","settings.boiler.temp_enabled.subtitle":"Ohne Sensor kann der Boiler nur f\xfcr \xdcbersch\xfcsse genutzt werden","settings.device":"Ger\xe4t","settings.device.SN":"Seriennummer","settings.device.id":"Ger\xe4te-ID","settings.device.license":"Ger\xe4telizenz","settings.docs":"Anleitungen und weitere Materialien","settings.docs.service_settings_inverter.button":"Zur Wiki","settings.docs.service_settings_inverter.subtitle":"Dokumentation, Verfahren und weitere Informationen","settings.docs.service_settings_inverter.title":"Anleitung zum Anschluss des Wechselrichters","settings.docs.tech_wiki.button":"Zur Wiki","settings.docs.tech_wiki.subtitle":"Anleitungen, Verfahren und weitere Informationen","settings.docs.tech_wiki.title":"Technische Wiki","settings.docs.user_wiki.button":"Zur Wiki","settings.docs.user_wiki.subtitle":"Anleitungen, Verfahren und weitere Informationen","settings.docs.user_wiki.title":"Benutzer-Wiki","settings.hdo":"Einstellung der Rundsteuerung (HDO)","settings.hdo.help":"Einstellung der HDO-Zeiten f\xfcr die Berechnung der Strompreise im Hoch- und Niedertarif. Unten k\xf6nnen Sie die Zeiten des Niedertarifs festlegen.","settings.hdo.on1":"Zeit 1","settings.hdo.on2":"Zeit 2","settings.hdo.on3":"Zeit 3","settings.hdo.on4":"Zeit 4","settings.hdo.on5":"Zeit 5","settings.hdo.on6":"Zeit 6","settings.hdo.regular":"Regul\xe4rer Werktag","settings.hdo.start":"Start","settings.hdo.stop":"Stopp","settings.hdo.type":"Zeiten festlegen f\xfcr","settings.hdo.weekend":"HDO-Zeiten am Wochenende","settings.heatpump":"Installation","settings.heatpump.HpBatteryPriority":"Prozentsatz des Batterieladezustands (SOC), ab dem die Leistung der W\xe4rmepumpe erh\xf6ht wird","settings.heatpump.HpBatteryPriority.help":"Wenn der Batterieladezustand niedriger als dieser Wert ist, steht die Priorit\xe4t der Energiespeicherung vollst\xe4ndig der Batterie zur Verf\xfcgung. Ist der Batterieladezustand h\xf6her, \xfcbernimmt die W\xe4rmepumpe die Priorit\xe4t und beginnt, Wasser aus der \xfcbersch\xfcssigen PV-Energie zu erw\xe4rmen \u2013 ein Teil der Energie flie\xdft weiter in die Batterie, bis diese geladen ist.","settings.heatpump.enabled":"W\xe4rmepumpe installiert","settings.heatpump.flexiAN":"Flexibilit\xe4t des Pufferspeichers","settings.heatpump.flexiCool":"K\xfchlflexibilit\xe4t","settings.heatpump.flexiHw":"Warmwasserflexibilit\xe4t","settings.heatpump.flexiRoom":"Raumflexibilit\xe4t","settings.heatpump.hp_type":"Typ der W\xe4rmepumpe","settings.heatpump.nominal":"Nennaufnahmeleistung","settings.heatpump.nominal1":"Nennaufnahmeleistung","settings.heatpump.priority":"Die W\xe4rmepumpe hat eine h\xf6here Priorit\xe4t als die Batterie","settings.heatpump.priority-wb":"Die W\xe4rmepumpe hat eine h\xf6here Priorit\xe4t als die Wallbox","settings.heatwatter":"Boiler","settings.heatwatter.legionella":"Legionella","settings.heatwatter.legionella_temp":"Desinfektionstemperatur","settings.heatwatter.legionella_temp.subtitle":"Temperatur, auf die der Boiler mindestens einmal alle 14 Tage aufgeheizt werden muss","settings.inverter_communication_status":"Wechselrichterkommunikation","settings.inverter_communication_status.not_ok":"Nicht verbunden,{br}Verbindungsversuch...","settings.inverter_communication_status.ok":"Kommunikation hergestellt{br}({count} Ablesungen)","settings.inverter_communication_status.subtitle":"Der Aufbau der Kommunikation kann einige zehn Sekunden bis mehrere Minuten dauern","settings.notification":"Benachrichtigungen","settings.notification.application_settings":"Benachrichtigungen \u2013 Parameter","settings.notification.battery_max_soc":"Maximaler SOC der Batterie","settings.notification.battery_max_soc.subtitle":"Eine Benachrichtigung wird erzeugt, wenn der maximale SOC der Batterie erreicht wird. Die Benachrichtigung wird nur einmal t\xe4glich erzeugt.","settings.notification.battery_max_soc_value":"Maximaler SOC der Batterie f\xfcr Benachrichtigungen","settings.notification.battery_max_soc_value.subtitle":"Legen Sie den SOC der Batterie fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.battery_min_soc":"Minimaler SOC der Batterie","settings.notification.battery_min_soc.subtitle":"Eine Benachrichtigung wird erzeugt, wenn der SOC der Batterie auf den festgelegten Mindestwert f\xe4llt. Die Benachrichtigung wird nur einmal t\xe4glich erzeugt.","settings.notification.battery_min_soc_value":"Minimaler SOC der Batterie f\xfcr Benachrichtigungen","settings.notification.battery_min_soc_value.subtitle":"Legen Sie den SOC der Batterie fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.daily_prediction.subtitle":"Die Benachrichtigung wird jeden Tag um 8:00 erzeugt","settings.notification.description":"Berechtigung zum Erzeugen von Benachrichtigungen, die in der Anwendung generiert werden","settings.notification.heat_pump_limit_exceeded":"\xdcberschreitung des Limits f\xfcr den W\xe4rmepumpenverbrauch","settings.notification.heat_pump_limit_exceeded.subtitle":"Eine Benachrichtigung wird erzeugt, wenn das Limit f\xfcr den W\xe4rmepumpenverbrauch \xfcberschritten wird","settings.notification.heat_pump_limit_value":"Tageslimit des W\xe4rmepumpenverbrauchs f\xfcr Benachrichtigungen","settings.notification.heat_pump_limit_value.subtitle":"Legen Sie das Limit f\xfcr den W\xe4rmepumpenverbrauch fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.heat_water_limit_exceeded":"\xdcberschreitung des Limits f\xfcr die Warmwasserbereitung","settings.notification.heat_water_limit_exceeded.subtitle":"Eine Benachrichtigung wird erzeugt, wenn das Limit f\xfcr die Warmwasserbereitung \xfcberschritten wird","settings.notification.heat_water_limit_value":"Tageslimit der Warmwasserbereitung f\xfcr Benachrichtigungen","settings.notification.heat_water_limit_value.subtitle":"Legen Sie das Limit f\xfcr die Warmwasserbereitung fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.heat_water_max_temperature":"Die maximale Wassertemperatur wurde erreicht","settings.notification.heat_water_max_temperature.subtitle":"Eine Benachrichtigung wird erzeugt, wenn die maximale Temperatur des Wassers im Boiler aus PV-Energie erreicht wird","settings.notification.home_consumption_limit_exceeded":"\xdcberschreitung des Limits f\xfcr den Hausverbrauch","settings.notification.home_consumption_limit_exceeded.subtitle":"Eine Benachrichtigung wird erzeugt, wenn das Limit f\xfcr den Hausverbrauch \xfcberschritten wird","settings.notification.home_consumption_limit_value":"Tageslimit des Hausverbrauchs f\xfcr Benachrichtigungen","settings.notification.home_consumption_limit_value.subtitle":"Legen Sie das Limit f\xfcr den Hausverbrauch fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.iverter_disconnected":"Die Kommunikation mit dem Wechselrichter wurde unterbrochen","settings.notification.iverter_disconnected.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des Kommunikationsverlusts mit dem Wechselrichter erzeugt","settings.notification.negative_spot":"Negativer Preis am Spot","settings.notification.negative_spot.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des negativen Preises am Spot erzeugt","settings.notification.pv_production_mwh":"Meilenstein der PV-Erzeugung","settings.notification.pv_production_mwh.subtitle":"Eine Benachrichtigung wird erzeugt, wenn die PV im jeweiligen Jahr MWh Energie erzeugt","settings.notification.spot_charging_battery":"Start und Stopp des Batterieladens gem\xe4\xdf Spotpreis","settings.notification.spot_charging_battery.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des Batterieladens gem\xe4\xdf Spotpreis erzeugt","settings.notification.spot_daily_prediction":"T\xe4gliche Vorhersage","settings.notification.spot_daily_summary":"T\xe4gliche Zusammenfassung des Spotplans","settings.notification.spot_daily_summary.subtitle":"Die Benachrichtigung wird jeden Tag um 8:00 erzeugt","settings.notification.spot_discharging_battery":"Start und Stopp des Batterieentladens ins Netz gem\xe4\xdf Spotpreis","settings.notification.spot_discharging_battery.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des Batterieentladens ins Netz gem\xe4\xdf Spotpreis erzeugt","settings.notification.utility_loss":"Netzausfall","settings.notification.utility_loss.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des Netzausfalls erzeugt","settings.notification.wallbox_charging_start_stop":"Start und Stopp des Ladens des Elektrofahrzeugs","settings.notification.wallbox_charging_start_stop.subtitle":"Eine Benachrichtigung wird zu Beginn und am Ende des Ladens des Elektrofahrzeugs erzeugt","settings.notification.wallbox_limit_exceeded":"\xdcberschreitung des Limits f\xfcr das Laden des Elektrofahrzeugs","settings.notification.wallbox_limit_exceeded.subtitle":"Eine Benachrichtigung wird erzeugt, wenn das Limit f\xfcr das Laden des Elektrofahrzeugs \xfcberschritten wird","settings.notification.wallbox_limit_value":"Tageslimit f\xfcr das Laden des Elektrofahrzeugs f\xfcr Benachrichtigungen","settings.notification.wallbox_limit_value.subtitle":"Legen Sie das Limit f\xfcr das Laden des Elektrofahrzeugs fest, bei dem eine Benachrichtigung erzeugt wird.","settings.notification.webapp.subtitle":"Sie k\xf6nnen Benachrichtigungen von Infigy \xfcber die Webanwendung erhalten.","settings.notification.webapp.title":"Webanwendung","settings.other":"Sonstiges","settings.other.dark_mode":"Dunkelmodus","settings.other.languate":"Sprache","settings.other.overflow_fronius":"Der maximale \xdcberschuss ins Netz wird auf Seiten des Fronius-Wechselrichters begrenzt","settings.other.overflow_fronius_subtitle":"Dieser Wert wird vom Netzbetreiber festgelegt. Eine \xdcberschreitung kann zu finanziellen Strafen durch den Netzbetreiber f\xfchren.","settings.other.overflow_settings":"\xdcberschusswert festlegen","settings.other.overflow_settings.help":"Dies ist ein serviceseitig festgelegter Wert des maximalen \xdcberschusses. Dieser Wert wird vom Netzbetreiber festgelegt. Eine \xdcberschreitung kann zu finanziellen Strafen durch den Netzbetreiber f\xfchren.","settings.other.readability_mode":"Schriftgr\xf6\xdfe","settings.photovoltaics":"Photovoltaik","settings.photovoltaics.backup_enabled":"Backup aktiviert","settings.photovoltaics.backup_enabled.subtitle":"Informationen zum Backup-Modus des Wechselrichters.","settings.photovoltaics.batterychargingpower":"Ladeleistung der Batterie","settings.photovoltaics.batterychargingpower_sub":"Leistung f\xfcr manuelles Batterieladen und Spotladen aus dem Netz","settings.photovoltaics.batterydischargingpower":"Entladeleistung der Batterie","settings.photovoltaics.batterydischargingpower_sub":"Leistung f\xfcr das Spotentladen der Batterie ins Netz","settings.photovoltaics.batteryenabled":"Batterie installiert","settings.photovoltaics.batterynominal":"Nennkapazit\xe4t der Batterie","settings.photovoltaics.batterynominal_sub":"Nur f\xfcr den Spothandel erforderlich","settings.photovoltaics.enabled":"Photovoltaik installiert","settings.photovoltaics.gridchargeenabled":"Laden der Batterie aus dem Verteilnetz erlaubt","settings.photovoltaics.inverters-adjust-power":"Aktuelle Wechselrichterleistung","settings.photovoltaics.inverters-nominal":"Nennleistung der regelbaren Wechselrichter","settings.photovoltaics.nominal":"Nennleistung","settings.photovoltaics.overflow":"Unbegrenzter Netz\xfcberschuss","settings.photovoltaics.overflow.value":"\xdcberschussbegrenzung","settings.photovoltaics.overflow.value.help":"Wert des maximalen \xdcberschusses ins Netz. Dieser Wert wird in den Wechselrichter geschrieben. \xc4ndern Sie diesen Wert nicht im Wechselrichter. Die \xdcberschussbegrenzung wird von Infigy gesteuert. Pr\xfcfen Sie den geschriebenen Wert im Wechselrichter.","settings.photovoltaics.overflow_fronius.value.help":"Wert des maximalen \xdcberschusses ins Netz auf Seiten des Fronius-Wechselrichters. Dient Infigy als Information f\xfcr die korrekte Visualisierung der \xdcbersch\xfcsse.","settings.photovoltaics.settings":"Batterie","settings.photovoltaics.settings.soc_actual":"Berechnete Mindestladung","settings.photovoltaics.settings.soc_actual.help":"Dieser Wert wird automatisch anhand des aktuellen Zustands berechnet. Er wird entweder durch automatisches Laden gem\xe4\xdf der Jahreszeit oder durch manuelle Einstellung der Mindestladung mit und ohne Verteilnetz gesteuert. Bei einem Wert von 100 % ist das Entladen der Batterie untersagt, z. B. gem\xe4\xdf Spothandel.","settings.photovoltaics.settings.soc_grid":"Mindestladung mit Verteilnetz","settings.photovoltaics.settings.soc_grid.help":"Mit diesem Wert k\xf6nnen Sie die Mindestladung der Batterie in % SOC steuern, wenn das Verteilnetz verf\xfcgbar ist. Bei Solax im Backup-Modus betr\xe4gt die Mindestladung der Batterie 15 %.","settings.photovoltaics.settings.temp":"Minimale Ladung bei Netz","settings.photovoltaics.settings.temp.help":"Mit diesem Wert k\xf6nnen Sie die minimale Ladung der Batterie in % SOC steuern, wenn das Verteilnetz verf\xfcgbar ist.","settings.photovoltaics.settings.temp_ek":"Mindestladung ohne Netz","settings.photovoltaics.settings.temp_ek.help":"Mit diesem Wert k\xf6nnen Sie die Mindestladung der Batterie in % SOC steuern, wenn das Verteilnetz nicht verf\xfcgbar ist.","settings.photovoltaics.unbalanced_enabled":"Asymmetrie des Wechselrichters","settings.photovoltaics.unbalanced_enabled.subtitle":"Informationen zur Asymmetrie des Wechselrichters.","settings.photovoltaics_auto_settings":"Automatische Ladesteuerung","settings.photovoltaics_auto_settings.subtitle":"Automatische Regelung des Mindest-SOC gem\xe4\xdf der Jahreszeit","settings.plug":"Steckdosen","settings.plug.Led":"Dauerhafte Hintergrundbeleuchtung","settings.plug.Led-batt":"Hintergrundbeleuchtung bei geladener Batterie","settings.plug.Led-batt.subtitle":"Hintergrundbeleuchtung aktiv, wenn die Batterie mindestens 95 % hat","settings.plug.Led-over":"Hintergrundbeleuchtung bei \xdcberschuss","settings.plug.enabled":"Steckdosen installiert","settings.plug.enabled.subtitle":"Steckdosen im lokalen Netzwerk","settings.plug.enabled2":"Zweite Steckdose","settings.plug.enabled3":"Dritte Steckdose","settings.plug.ip1":"Die IP-Adresse der ersten Steckdose","settings.plug.ip1.label":"IP 3","settings.plug.ip2":"Die IP-Adresse der zweiten Steckdose","settings.plug.ip2.label":"IP 2","settings.plug.ip3":"Die IP-Adresse der dritten Steckdose","settings.plug.ip3.label":"IP 3","settings.plug.modulenabled":"Steckdosen am Modul","settings.plug.modulip":"IP-Adresse des Moduls","settings.plug.modulip.label":"IP-Modul","settings.plug.name1":"Name der Steckdose 1","settings.plug.name1.label":"Name","settings.plug.name2":"Name der Steckdose 2","settings.plug.name2_label":"Name","settings.plug.name3":"Name der Steckdose 3","settings.plug.name3.label":"Name","settings.plug.statusLed":"Signallediode","settings.readability_mode.default":"Standard","settings.readability_mode.large":"Gro\xdf","settings.relay":"Relais","settings.relay.0.enabled":"Erstes Relais","settings.relay.1.enabled":"Zweites Relais","settings.relay.1.type":"Bedingung","settings.relay.1.type.HDO":"HDO spiegeln","settings.relay.1.type.batteryfull":"Batterie \xfcber 95 % geladen","settings.relay.1.type.batterylow":"Batterie unter dem eingestellten Minimum geladen","settings.relay.1.type.bojlerFull":"Boiler ist fast aufgeheizt","settings.relay.1.type.none":"Nicht verwendet","settings.relay.1.type.plug1":"Steckdose 1","settings.relay.1.type.plug2":"Steckdose 2","settings.relay.1.type.plug3":"Steckdose 3","settings.relay.1.type.spotHi":"Hoher Spotpreis","settings.relay.1.type.spotLow":"Niedriger Spotpreis","settings.relay.1.type.spotMi":"Mittlerer Spotpreis","settings.relay.1.type.spotNegative":"Negativer Spotpreis","settings.relay.1.type.thermostat1":"Thermostatkreis 1","settings.relay.1.type.thermostat2":"Thermostatkreis 2","settings.relay.1.type.thermostat3":"Thermostatkreis 3","settings.relay.1.type.thermostat4":"Thermostatkreis 4","settings.relay.2.enabled":"Drittes Relais","settings.relay.3.enabled":"Viertes Relais","settings.relay.above_price_relay":"Spotpreis f\xfcr die Aktivierung des Relais","settings.relay.above_price_relay.subtitle":"Wenn der Spotpreis h\xf6her als dieser Wert ist, schaltet das Relais ein. Wenn er niedriger ist, schaltet das Relais aus.","settings.relay.above_price_relay_15m":"Spotpreis f\xfcr die Aktivierung des Relais (15 min)","settings.relay.above_price_relay_15m.subtitle":"Wenn der Spotpreis h\xf6her als dieser Wert ist, schaltet das Relais ein. Wenn er niedriger ist, schaltet das Relais aus.","settings.relay.above_soc_relay":"Batterieladung f\xfcr die Aktivierung des Relais","settings.relay.above_soc_relay.subtitle":"Wenn die Batterieladung h\xf6her als dieser Wert ist, schaltet das Relais ein.","settings.relay.above_soc_relay_hyst":"Hysterese des Batterie-SOC f\xfcr die Deaktivierung des Relais","settings.relay.above_soc_relay_hyst.subtitle":"Wenn die Batterieladung um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.","settings.relay.below_price_relay":"Spotpreis f\xfcr die Aktivierung des Relais","settings.relay.below_price_relay.subtitle":"Wenn der Spotpreis niedriger als dieser Wert ist, schaltet das Relais ein. Wenn er h\xf6her ist, schaltet das Relais aus.","settings.relay.below_price_relay_15m":"Spotpreis f\xfcr die Aktivierung des Relais (15 min)","settings.relay.below_price_relay_15m.subtitle":"Wenn der Spotpreis niedriger als dieser Wert ist, schaltet das Relais ein. Wenn er h\xf6her ist, schaltet das Relais aus.","settings.relay.below_soc_relay":"Batterieladung f\xfcr die Aktivierung des Relais","settings.relay.below_soc_relay.subtitle":"Wenn die Batterieladung um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.","settings.relay.below_soc_relay_hyst":"Hysterese des Batterie-SOC f\xfcr die Deaktivierung des Relais","settings.relay.below_soc_relay_hyst.subtitle":"Wenn die Batterieladung um diesen Wert \xfcber den eingestellten Aktivierungswert steigt, schaltet das Relais aus.","settings.relay.enabled":"Relais installiert","settings.relay.enabled.subtitle":"Integrierte Relais","settings.relay.item.enabled":"Relais {index}","settings.relay.item.name":"Relaisname","settings.relay.item.status":"Status","settings.relay.option":"Bedingung","settings.relay.temp_above_relay.subtitle":"Wenn die Boilertemperatur h\xf6her als dieser Wert ist, schaltet das Relais ein.","settings.relay.temp_above_relay_hyst.subtitle":"Wenn die Boilertemperatur um diesen Wert unter den eingestellten Aktivierungswert sinkt, schaltet das Relais aus.","settings.relay.temp_below_relay.subtitle":"Wenn die Boilertemperatur niedriger als dieser Wert ist, schaltet das Relais ein.","settings.relay.temp_below_relay_hyst":"Hysterese der Boilertemperatur in \xb0C f\xfcr die Deaktivierung des Relais","settings.relay.temp_below_relay_hyst.subtitle":"Wenn die Boilertemperatur um diesen Wert \xfcber den eingestellten Aktivierungswert steigt, schaltet das Relais aus.","settings.relay.temp_relay":"Boilertemperatur f\xfcr die Aktivierung des Relais","settings.relay.temp_relay_hyst":"Hysterese der Boilertemperatur in \xb0C f\xfcr die Deaktivierung des Relais","settings.relay.type.Active":"Dauerhaft ein","settings.relay.type.HDO":"HDO spiegeln","settings.relay.type.batteryBelowSOC":"Batterieladung unter dem eingestellten SOC","settings.relay.type.batteryDischarge":"Entladen der Batterie ins Netz","settings.relay.type.batteryFull":"Batterieladung \xfcber dem eingestellten SOC","settings.relay.type.batteryLow":"Batterieladung unter dem eingestellten Minimum","settings.relay.type.bojlerFull":"Boiler ist nahezu aufgeheizt","settings.relay.type.hdo":"HDO spiegeln","settings.relay.type.heatWaterAboveTemp":"Boiler ist \xfcber die eingestellte Temperatur aufgeheizt","settings.relay.type.heatWaterBelowTemp":"Boiler ist unter die eingestellte Temperatur aufgeheizt","settings.relay.type.heatWaterMaxTemp":"Boiler ist nahezu aufgeheizt","settings.relay.type.heatWaterTemp":"Boiler ist \xfcber die eingestellte Temperatur aufgeheizt","settings.relay.type.none":"Nicht verwendet, dauerhaft aus","settings.relay.type.plug1":"Steckdose 1","settings.relay.type.plug2":"Steckdose 2","settings.relay.type.plug3":"Steckdose 3","settings.relay.type.plug4":"Steckdose 4","settings.relay.type.spotBatteryDischarge":"Entladen der Batterie ins Netz","settings.relay.type.spotHi":"Hoher Spotpreis","settings.relay.type.spotHi15M":"Hoher Spotpreis (15 min)","settings.relay.type.spotLow":"Niedriger Spotpreis","settings.relay.type.spotLow15M":"Niedriger Spotpreis (15 min)","settings.relay.type.spotMi":"Mittlerer Spotpreis","settings.relay.type.spotMi15M":"Mittlerer Spotpreis (15 min)","settings.relay.type.spotNegative":"Begrenzung der \xdcbersch\xfcsse ins Netz","settings.relay.type.spotNegative15M":"Verbot von \xdcbersch\xfcssen ins Stromnetz (15 min)","settings.relay.type.spotPriceAbove":"Spotpreis \xfcber dem eingestellten Wert","settings.relay.type.spotPriceAbove15M":"Spotpreis \xfcber dem eingestellten Wert (15 min)","settings.relay.type.spotPriceBelow":"Spotpreis unter dem eingestellten Wert","settings.relay.type.spotPriceBelow15M":"Spotpreis unter dem eingestellten Wert (15 min)","settings.relay.type.spotStopAccumulation":"Speicherung gestoppt, aktiver Verkauf","settings.relay.type.stopAccumulation":"Speicherung gestoppt, aktiver Verkauf","settings.relay.type.thermostat1":"Thermostat 1","settings.relay.type.thermostat2":"Thermostat 2","settings.relay.type.thermostat3":"Thermostat 3","settings.relay.type.thermostat4":"Thermostat 4","settings.relay.user_advanced_control":"Seite mit Informationen f\xfcr den Benutzer anzeigen","settings.relay.user_advanced_control.subtitle":"Wenn aktiviert, erscheint eine Seite in der Navigation","settings.service":"Service","settings.service.connection_type":"Verbindung","settings.service.customer":"Benutzername","settings.service.customer-email":"E-Mail des Benutzers","settings.service.customer-email-subtitle":"Wenn der Benutzer kein Konto unter dieser E-Mail hat, wird automatisch ein Konto erstellt und eine Registrierungs-E-Mail gesendet","settings.service.customer-email.label":"E-Mail","settings.service.customer-subtitle":"Dient zur Identifikation der Installation f\xfcr das Unternehmen und den Kunden","settings.service.customer.label":"Name","settings.service.exit":"Vom Service abmelden","settings.service.exit.button":"Abmelden","settings.service.info":"Installation","settings.service.inverter_type":"Wechselrichtertyp","settings.service.inverter_type.label":"Wechselrichter","settings.service.modbus_tcp":"LAN/WiFi","settings.service.network":"Netzwerk","settings.service.network.help.content":"Die Liste zeigt Ger\xe4te, die aktuell mit dem Infigy-Netzwerk verbunden sind (WiFi oder Kabel), ihre IP-Adressen, MAC-Adressen usw. Wenn ein Ger\xe4t DHCP verwendet, k\xf6nnen Sie auf die Stecknadel klicken, um die IP-Adresse festzulegen, die der DHCP-Server dann immer vergibt \u2013 das ist n\xfctzlich f\xfcr Ger\xe4te wie Wechselrichter, W\xe4rmepumpen usw. Wenn ein Ger\xe4t eine statische IP-Adresse verwendet, wird es m\xf6glicherweise nicht korrekt angezeigt.","settings.service.network.help.title":"Netzwerkeinstellungen","settings.service.network.mac":"MAC-Adresse","settings.service.network.online.internet":"Internetzugang","settings.service.network.online.internet.help":"Ein Internetzugang ist f\xfcr den Fernzugriff, Systemaktualisierungen, Spotpreise und weitere Funktionen erforderlich. F\xfcr die volle Funktionalit\xe4t m\xfcssen alle drei Anzeigen gr\xfcn sein.{br}{br}Die erste Anzeige zeigt die Verf\xfcgbarkeit des Internets (Ping 8.8.8.8).{br}{br}Die zweite Anzeige zeigt die Verf\xfcgbarkeit des Internets einschlie\xdflich DNS (Ping infigy.cz).{br}{br}Die dritte Anzeige zeigt den Zugriff auf die internen Cloud-Dienste von Infigy (VPN-Verf\xfcgbarkeit).{br}{br}Wenn es ein Problem mit der Verbindung gibt, pr\xfcfen Sie bitte das Kabel oder kontaktieren Sie den Netzwerkadministrator, falls das lokale Netzwerk Einschr\xe4nkungen f\xfcr die Kommunikation ins Internet hat.{br}{br}{wikiLink}","settings.service.network.online.internet.help.wikiLink":"Weitere Informationen in unserem Wiki.","settings.service.network.online.portal":"Zugang zum Infigy-Portal","settings.service.network.wan":"WAN-Adresse","settings.service.network.wifi_passphrase":"WLAN-Passwort","settings.service.network_type":"Netzwerk","settings.service.network_type.custom":"Manuelle Adresseinstellung","settings.service.network_type.external":"Lokales Netzwerk (Kunde)","settings.service.network_type.internal":"Internes Infigy-Netzwerk","settings.service.password":"Zugang zum Service","settings.service.password.label":"Passwort","settings.service.relay":"Relais","settings.service.reset":"Fehlerreset","settings.service.reset.button":"Fehlerreset","settings.service.rs485":"RS485","settings.service.service-email":"E-Mail der Servicefirma","settings.service.service-email-subtitle":"Um das Ger\xe4t mit dem Installationskonto zu verkn\xfcpfen, m\xfcssen Sie die E-Mail der Servicefirma eingeben, die im Partnerbereich der Anwendung hinterlegt ist","settings.service.service-email.label":"E-Mail","settings.service.servicer":"Name des Installateurs","settings.service.servicer.label":"Name","settings.service.solidsun_op":"SolidSun OP","settings.service.solidsun_op.label":"SolidSun OP","settings.service.spot":"Spot-Handel","settings.service.tester.label":"Name des Testers","settings.service.thermostat":"Thermostat","settings.service.town":"Standort (Ort)","settings.service.version":"Anwendungsversion","settings.service.wallbox_type":"Wallbox-Typ","settings.service.wallbox_type.label":"Wallbox","settings.spot":"Spot-Handel","settings.spot.battery":"Laden der Batterie gem\xe4\xdf Spot erlaubt","settings.spot.battery.stop_discharge_auto":"Automatische Steuerung des Entladeverbots","settings.spot.battery.stop_discharge_auto.help":"Wenn Sie diese Option w\xe4hlen, steuert das System das Entladen der Batterie automatisch und erlaubt es nur zu den h\xf6chsten t\xe4glichen Spotpreisen.","settings.spot.battery.stop_discharge_auto.subtitle":"Steuerung der Energiespeicherung automatisch zum h\xf6chsten Preis","settings.spot.battery.stop_discharge_hi_price":"Entladen der Batterie bei niedrigen und mittleren Preisen verbieten","settings.spot.battery.stop_discharge_high_price":"Entladen der Batterie bei niedrigem und mittlerem Preis verbieten","settings.spot.battery.stop_discharge_high_price.help":"Wenn Sie diese Option w\xe4hlen, nutzt das System bei niedrigem und mittlerem Spotpreis keine Energie aus der Batterie. Das System entl\xe4dt die Batterie nicht. Sie wird bei h\xf6heren Preisen genutzt.","settings.spot.battery.stop_discharge_low_price":"Entladen der Batterie bei niedrigem Preis verbieten","settings.spot.battery.stop_discharge_low_price.help":"Wenn Sie diese Option w\xe4hlen, nutzt das System bei niedrigem Spotpreis keine Energie aus der Batterie. Das System entl\xe4dt die Batterie nicht. Sie wird bei h\xf6heren Preisen genutzt (mittlerer und hoher Preis).","settings.spot.battery.stop_discharge_low_price.subtitle":"Steuerung der Energiespeicherung bei mittlerem und hohem Preis","settings.spot.battery.stop_discharge_middle_price.subtitle":"Steuerung der Energiespeicherung bei hohem Preis","settings.spot.batteryAllOverflowPrice":"Mindestpreis f\xfcr das Entladen der gesamten Batteriekapazit\xe4t","settings.spot.batteryOverflow":"Entladen der Batterie ins Netz gem\xe4\xdf Spotpreisen erlauben","settings.spot.batteryOverflowPrice":"Mindestpreis f\xfcr das Entladen der Batterie","settings.spot.batterySale":"Entladen der Batterie ins Netz gem\xe4\xdf Spotpreisen erlaubt","settings.spot.battery_all_overflow_price":"Mindestpreis f\xfcr das Entladen der gesamten Batteriekapazit\xe4t","settings.spot.battery_all_overflow_price.help":"Wenn der Spotpreis h\xf6her als dieser Wert ist, wird die Batteriekapazit\xe4t bis zum eingestellten Mindest-SOC ins Netz entladen. Das bedeutet, dass die Energie nicht in der Batterie f\xfcr den Nacht- und Morgenverbrauch gespeichert wird. Nach dem Entladen der Batterie ins Netz wird die Energie f\xfcr den Verbrauch des Objekts aus dem Netz bezogen.","settings.spot.battery_all_overflow_price.subtitle":"Die Energie wird in der Batterie f\xfcr den Tagesverbrauch gespeichert","settings.spot.battery_charge":"Laden der Batterie nach Spot zugelassen","settings.spot.battery_charge.help":"Wenn Sie diese Option w\xe4hlen, plant das System das Laden zu den niedrigsten Preisen. Es ber\xfccksichtigt den aktuellen Ladezustand der Batterie und ihre Kapazit\xe4t. Anhand dieser Parameter w\xe4hlt es die Ladedauer so, dass die Batterie zum niedrigstm\xf6glichen Preis geladen wird.","settings.spot.battery_charge.subtitle":"Die Steuerung der Batterie nach dem Spot erh\xf6ht die Abnutzung der Batterie","settings.spot.battery_max_soc":"End-SOC der Batterie","settings.spot.battery_max_soc.subtitle":"Maximale Ladung der Batterie beim Laden aus dem Netz","settings.spot.battery_overflow":"Entladen der Batterie ins Netz nach Spotpreisen zulassen","settings.spot.battery_overflow.help":"Wenn Sie diese Option w\xe4hlen, plant das System das Entladen der Batterie ins Netz zum h\xf6chsten Tagespreis und entl\xe4dt nur die Energie, die nicht f\xfcr den Tagesverbrauch des Objekts ben\xf6tigt wird. Mit den Parametern unten k\xf6nnen Sie den Preis f\xfcr das Entladen der gesamten Batteriekapazit\xe4t und das Entladen nur des Teils der Batteriekapazit\xe4t festlegen, der nicht f\xfcr den Nachtverbrauch ben\xf6tigt wird.","settings.spot.battery_overflow.subtitle":"Erm\xf6glicht das Entladen der \xfcbersch\xfcssigen Energie in der Batterie ins Netz in der g\xfcnstigsten Stunde","settings.spot.battery_overflow_price":"Mindestpreis f\xfcr das Entladen der Batterie","settings.spot.battery_overflow_price.help":"Wenn der Spotpreis h\xf6her als dieser Wert ist, wird die \xfcbersch\xfcssige Batteriekapazit\xe4t ins Netz entladen. Das bedeutet, dass die Energie in der Batterie f\xfcr den Nacht- und Morgenverbrauch gespeichert wird. Die Energie f\xfcr den Verbrauch des Objekts wird nicht aus dem Netz bezogen.","settings.spot.battery_overflow_price.subtitle":"Die Energie wird in der Batterie f\xfcr den Nachtverbrauch gespeichert","settings.spot.battery_strategy":"Strategie f\xfcr das Spot-Laden der Batterie","settings.spot.battery_strategy.help":"Mit diesem Schieberegler k\xf6nnen Sie einfach die Pr\xe4ferenz f\xfcr die Nutzung der Batterie im Spot-Handel festlegen. Niedrigere Werte (ab 20 %) bedeuten weniger Batteriezyklen und damit selteneres Laden/Entladen nach Spotpreisen. H\xf6here Werte (bis 70 %) bedeuten das Gegenteil.","settings.spot.battery_strategy_service.subtitle":"Mit dieser Option erlauben Sie den Endbenutzern, die Batteriestrategie auf der Registerkarte Spot festzulegen","settings.spot.battery_strategy_user":"Festlegen der Batteriestrategie durch den Benutzer zulassen","settings.spot.battery_strategy_user.subtitle":"Mit dieser Option erlauben Sie den Endbenutzern, die Batteriestrategie auf der Registerkarte Spot festzulegen","settings.spot.install":"Spot-Handel aktiv","settings.spot.latitude":"Breitengrad","settings.spot.latitude.mess":"Breite","settings.spot.longitude":"L\xe4ngengrad","settings.spot.longitude.mess":"L\xe4nge","settings.spot.min_difference_price_charge_from_grid":"Mindestunterschied im Spotpreis f\xfcr das Laden der Batterie aus dem Netz","settings.spot.min_difference_price_charge_from_grid.help":"Mit diesem Parameter k\xf6nnen Sie das Laden der Batterie vom Spot bei einem geringen Unterschied zwischen dem niedrigsten und dem h\xf6chsten Preis steuern. Wenn der Parameter 2 CZK betr\xe4gt und der Unterschied zwischen dem h\xf6chsten Preis (3 CZK) und dem niedrigsten Preis (1 CZK) des Spots geringer ist, wird das Laden der Batterie vom Spot nicht geplant.","settings.spot.min_difference_price_charge_from_grid.subtitle":"Mindestunterschied im Spotpreis w\xe4hrend des Tages, damit die Batterie aus dem Netz geladen wird","settings.spot.overflow":"\xdcberschussoptimierung nach Spotpreisen zulassen","settings.spot.overflow.help":"Wenn Sie diese Option w\xe4hlen, priorisiert das System den \xdcberschuss ins Netz vor dem Laden der Batterie bei h\xf6heren und mittleren Spotpreisen. Das geschieht nur in Jahreszeiten, in denen wir einen Energie\xfcberschuss aus PV erwarten, und in der Regel morgens. Die Optimierung findet bei niedrigen Spotpreisen nicht statt, wenn die Priorit\xe4t das Laden der Batterie aus PV ist.","settings.spot.overflow.subtitle":"Erm\xf6glicht die Priorisierung des \xdcberschusses vor der Speicherung","settings.spot.overflow_offset":"Maximaler \xdcberschuss bei negativem Preis","settings.spot.overflow_offset.help":"Der Wert gibt den \xdcberschuss ins Verteilnetz bei negativem Preis an. Wir empfehlen, diese Funktion im Fall einer Energiegemeinschaft zu nutzen.","settings.spot.overflow_offset.subtitle":"Der Wert kann nicht h\xf6her als der maximale \xdcberschuss eingestellt werden","settings.spot.price.period":"Zeitraum","settings.spot.price_above_price":"Eingestellter Spotpreis","settings.spot.price_below":"Eingestellter Spotpreis","settings.spot.price_distribution_hi":"Preis der Netzenergie im Hochtarif","settings.spot.price_distribution_hi.help":"Preis der Netzenergie im Hochtarif pro kWh. Dieser Preis wird zum Spotpreis addiert, wenn der Hochtarif aktiv ist. Die HDO-Zeiten m\xfcssen f\xfcr die korrekte Berechnung des Preises im Hoch- und Niedertarif eingestellt sein. Diesen Betrag finden Sie auf der Stromrechnung.","settings.spot.price_distribution_low":"Preis der Netzenergie im Niedertarif","settings.spot.price_distribution_low.help":"Preis der Netzenergie im Niedertarif pro kWh. Dieser Preis wird zum Spotpreis addiert, wenn der Niedertarif aktiv ist. Die HDO-Zeiten m\xfcssen f\xfcr die korrekte Berechnung des Preises im Hoch- und Niedertarif eingestellt sein. Diesen Betrag finden Sie auf der Stromrechnung.","settings.spot.price_offset":"Preis f\xfcr das Verbot von \xdcbersch\xfcssen","settings.spot.price_offset.help":"Wir empfehlen, mindestens die Provision/Geb\xfchr des H\xe4ndlers f\xfcr den Verkauf von \xdcbersch\xfcssen ins Netz einzustellen.","settings.spot.price_offset.subtitle":"Mindest-Spotpreis, unter dem \xdcbersch\xfcsse verboten sind. Der Wert wird mit dem Tagesmarkt ohne Netzentgelt verglichen.","settings.spot.region":"Region","settings.thermostat.hp-blocked":"Sperrung der W\xe4rmepumpe","settings.thermostat.hysteresis":"Temperaturhysterese","settings.thermostat.install":"Thermostat aktiv","settings.thermostat.name.label":"Name","settings.thermostat.name1":"Name von Thermostat 1","settings.thermostat.name2":"Name von Thermostat 2","settings.thermostat.name3":"Name von Thermostat 3","settings.thermostat.name4":"Name von Thermostat 4","settings.thermostat.nominal":"Nennleistung der Quelle","settings.thermostat.number-of-thermostat":"Anzahl der Thermostate","settings.utility":"Hausparameter","settings.utility.loadpercent":"Aktuelle Belastung des Sicherungsautomaten","settings.utility.numberofphase":"Dreiphasige Installation","settings.utility.settings.ampers":"Gr\xf6\xdfe des Sicherungsautomaten","settings.utility.settings.loadpercent":"Bei \xdcberschreitung wird der Verbrauch begrenzt","settings.utility.settings.loadpercent_max":"Bei \xdcberschreitung wird der Verbrauch begrenzt","settings.wallbox":"Wallbox","settings.wallbox.install":"Wallbox aktiv","settings.wallbox.name":"Name der Wallbox {number}","settings.wallbox.spot":"Wallbox","settings.wallbox.type":"Wallbox-Typ","shellies.energyMeters":"Energiez\xe4hler","shellies.energyMeters.add":"Hinzuf\xfcgen","shellies.energyMeters.empty":"Keine Energiez\xe4hler konfiguriert","shellies.energyMeters.list":"Konfiguration der Energiez\xe4hler","shellies.energyMeters.name":"Name","shellies.energyMeters.newMeter":"Neuer Z\xe4hler","shellies.energyMeters.shellyId":"Shelly ID","shellies.list":"Shellies","shellies.mqtt_broker_running":"MQTT-Broker-Status","shellies.settings":"Einstellungen","shellies.settings.boiler.active":"Boiler \xfcber Shellies verbunden","shellies.settings.boiler.id":"ID der Shellies","shellies.settings.boiler.id.label":"ID","shellies.title":"Shellies","spot.chartview":"Preis ohne Netzentgelt anzeigen","spot.draft":"Modi f\xfcr heute","spot.draft.actualpricehi":"Der aktuelle Preis ist hoch, senken Sie den Verbrauch","spot.draft.actualpricelow":"Der aktuelle Preis ist niedrig, erh\xf6hen Sie den Verbrauch","spot.draft.hesLevel":"Stufe der HES-Steuerung","spot.draft.hiprice":"Grenzen des reduzierten Verbrauchs","spot.draft.info":"Modi und Empfehlungen f\xfcr heute","spot.draft.lowprice":"Grenze des erh\xf6hten Verbrauchs","spot.draft.todaystatus_HP":"Speicherung der W\xe4rmepumpe","spot.draft.todaystatus_HW":"Speicherung von Warmwasser","spot.draft.todaystatus_bat":"Speicherung der Batterie","spot.draft.todaystatus_em":"\xdcberschuss","spot.explanation":"Erkl\xe4rung der Modi","spot.explanation.battery_discharge_to_grid":"Entladen der Batterie ins Netz","spot.explanation.battery_discharge_to_home":"Entladen der Batterie","spot.explanation.hw":"Laden der Batterie aus dem Netz","spot.explanation.info":"Detaillierte Erkl\xe4rung der Modi f\xfcr heute","spot.flexibility":"Flexibilit\xe4tssch\xe4tzung f\xfcr heute","spot.prediction":"Verbrauchssch\xe4tzung f\xfcr heute","spot.prediction.bat":"Verf\xfcgbare Batteriespeicherung","spot.prediction.battery":"Verf\xfcgbare Batteriespeicherung","spot.prediction.home":"Normaler Verbrauch des Hauses","spot.prediction.hp":"W\xe4rmepumpe","spot.prediction.hw":"Verf\xfcgbare Warmwasserspeicherung","spot.prediction.pv":"Photovoltaik-Erzeugung","spot.prediction.sale":"Energie zum Verkauf","spot.prediction.sale.help":"Verbleibender geplanter t\xe4glicher \xdcberschuss, der als \xdcberschuss ins Netz vor der Batteriespeicherung priorisiert wird.","spot.price.period.15min":"15 min","spot.price.period.60min":"60 min","spot.region.cz":"CZ","spot.region.nl":"NL","spot.region.sk":"SK","spot.status":"Spot-Handel","spot.summary.battery_charge_from_grid":"Laden aus dem Netz","spot.summary.battery_charge_from_grid.help":"Das Laden der Batterie aus dem Netz nach dem Spotpreis kann in den Einstellungen aktiviert oder deaktiviert werden. Das System plant das Laden der Batterie bei niedrigen Preisen und ber\xfccksichtigt den aktuellen Ladezustand der Batterie und ihre Kapazit\xe4t. Anhand dieser Parameter bestimmt es die Ladedauer, um die Batterie zu den niedrigsten Kosten zu laden.","spot.summary.battery_discharge":"Entladen der Batterie","spot.summary.battery_discharge.help":"Das Entladen der Batterie ins Haus nach dem Spotpreis kann in den Einstellungen aktiviert oder deaktiviert werden. Das Entladen ist in der Regel bei niedrigen Preisen deaktiviert, wenn es besser ist, Energie aus dem Netz zu nutzen und die Batterie f\xfcr Zeiten mit h\xf6herem Preis zu schonen.","spot.summary.battery_discharge_to_grid":"Entladen ins Netz","spot.summary.battery_discharge_to_grid.help":"Das Entladen der Batterie ins Netz kann in den Einstellungen aktiviert oder deaktiviert werden. Das System plant das Entladen der Batterie ins Netz zu den h\xf6chsten Tagespreisen und entl\xe4dt nur die Energie, die nicht f\xfcr den normalen Verbrauch des Hauses ben\xf6tigt wird.","spot.summary.boiler":"Boiler","spot.summary.boiler.help":"Das System plant das Aufheizen des Boilers bei niedrigen Preisen und ber\xfccksichtigt die aktuelle Wassertemperatur, die Boilerkapazit\xe4t und die gew\xfcnschte Temperatur. Anhand dieser Parameter bestimmt es die Aufheizdauer, um den Boiler aufzuheizen.","spot.summary.heat_pump":"W\xe4rmepumpe","spot.summary.heat_pump.help":"Die W\xe4rmepumpe kann in drei Modi betrieben werden: erh\xf6hte Leistung, Normalbetrieb und reduzierte Leistung. Erh\xf6hte Leistung wird bei niedrigen Preisen genutzt, Normalbetrieb bei mittleren Preisen und reduzierte Leistung bei hohen Preisen. Die Verz\xf6gerung oder Erh\xf6hung des Verbrauchs kann im Men\xfc der W\xe4rmepumpe aktiviert werden.","spot.summary.heat_pump_level.increase":"Erh\xf6hte Leistung","spot.summary.heat_pump_level.normal":"Normalbetrieb","spot.summary.heat_pump_level.reduction":"Reduzierte Leistung","spot.summary.price":"Preis","spot.summary.price_buy":"Preis mit Netzentgelt","spot.summary.price_distribution":"Netzentgelt","spot.summary.price_level":"Preisniveau","spot.summary.price_level.help":"Infigy sortiert die st\xfcndlichen Spotpreise vom niedrigsten zum h\xf6chsten und teilt sie in drei etwa gleich gro\xdfe Teile. Wenn die Stundenpreise von 3 CZK bis 10 CZK reichen, k\xf6nnte der niedrige Preisbereich 3\u20136 CZK, der mittlere 6\u20137 CZK und der hohe 7\u201310 CZK betragen. Der Bereich \xe4ndert sich t\xe4glich, abh\xe4ngig von der H\xe4ufigkeit der Werte in jedem Preisniveau.","spot.summary.price_level.hi":"Hoher Preis","spot.summary.price_level.low":"Niedriger Preis","spot.summary.price_level.mid":"Mittlerer Preis","spot.summary.price_level_15m":"Preisniveau 15m","spot.summary.price_sell":"Preis ohne Netzentgelt","spot.summary.spotOverflow":"\xdcberschuss ins Netz","spot.summary.spotOverflow.allowed":"Erlaubt","spot.summary.spotOverflow.help":"Beim Zulassen des \xdcberschusses ins Netz im Spot-Handel wird der Spotpreis in der jeweiligen Stunde verglichen. Wenn er niedriger ist als der Preis f\xfcr das Verbot von \xdcbersch\xfcssen aus den Einstellungen, deaktiviert das System den \xdcberschuss in dieser Stunde automatisch.","spot.summary.spotOverflow.restricted":"Eingeschr\xe4nkt","spot.summary.state.active":"Aktiv","spot.summary.state.inactive":"Inaktiv","spot.summary.time":"Zeit","spot.user.parameters":"Parameter des Spot-Handels","spot_wizard.banner.button":"Brauchen Sie Hilfe? Ich kann Ihnen helfen","spot_wizard.banner.subtitle":"Der Assistent hilft Ihnen bei der Einrichtung des Spot-Handels.","spot_wizard.banner.title":"Brauchen Sie Hilfe? Ich kann Ihnen helfen","spot_wizard.battery_discharge.paragraph1":"Diese Einstellung deaktiviert das Entladen der Batterie bei niedrigen Spotpreisen. So behalten Sie die Energie f\xfcr h\xf6here Preise w\xe4hrend des Tages.","spot_wizard.battery_discharge.paragraph2":"Wenn Sie Energie nur am Spot verkaufen, k\xf6nnen Sie das Verbot deaktivieren.","spot_wizard.battery_discharge.title":"Entladen der Batterie in den Eigenverbrauch","spot_wizard.battery_purchase.paragraph1":"Diese Einstellung erm\xf6glicht das Laden der Batterie zum niedrigsten Spotpreis, wenn die Erzeugung gering ist.","spot_wizard.battery_purchase.paragraph2":"Achten Sie auf die Strategieeinstellung. Wenn Sie 20 % einstellen, wartet Infigy \xfcberwiegend auf die Photovoltaik. Wenn Sie dagegen 70 % einstellen, kauft Infigy \xfcberwiegend am Spot. Wir empfehlen, 25 % einzustellen.","spot_wizard.battery_purchase.paragraph3":"Wenn Sie Energie nur am Spot verkaufen, k\xf6nnen Sie das Laden deaktivieren.","spot_wizard.battery_purchase.title":"Energiekauf in die Batterie","spot_wizard.boiler.paragraph1":"Diese Einstellung erm\xf6glicht das Aufheizen des Boilers zu den niedrigsten Preisen des Tages auf die eingestellte Temperatur. Infigy h\xe4lt weiterhin die Grundtemperatur und nutzt die Temperaturerh\xf6hung vom Spot.","spot_wizard.boiler.paragraph2":"Es ist auch m\xf6glich, das Aufheizen bei mittleren oder hohen Preisen zu sperren.","spot_wizard.boiler.paragraph3":"Wenn Sie Energie nur am Spot verkaufen, k\xf6nnen Sie die Temperatur auf 10\xb0C einstellen und die Aufheizsperre deaktivieren.","spot_wizard.boiler.title":"Aufheizen des Boilers","spot_wizard.dialog.finish":"Fertigstellen","spot_wizard.dialog.next":"Weiter","spot_wizard.dialog.prev":"Zur\xfcck","spot_wizard.dialog.step":"Schritt {current} von {total}","spot_wizard.dialog.title":"Assistent zur Einrichtung des Spot-Handels","spot_wizard.distribution_prices.title":"Geben Sie den Preis f\xfcr das Netzentgelt in den niedrigen und hohen Preisbereichen ein","spot_wizard.done.description":"Sie haben die Einstellungen f\xfcr den Spot-Handel abgeschlossen. Alle Parameter k\xf6nnen im unteren Teil der Spot-Seite bearbeitet werden, wo Sie diesen Assistenten auch erneut aufrufen k\xf6nnen.","spot_wizard.done.title":"Fertig","spot_wizard.evening_peak_discharge.paragraph1":"Infigy sch\xe4tzt automatisch den Energieverbrauch in den Morgenstunden. Der \xdcberschuss kann zum h\xf6chsten Preis des Tages verkauft werden.","spot_wizard.evening_peak_discharge.paragraph2":"Wenn Sie Energie nur am Spot kaufen, k\xf6nnen Sie das Entladen deaktivieren.","spot_wizard.evening_peak_discharge.title":"Entladen der Batterie in der Abendspitze","spot_wizard.general_settings.title":"Zuerst allgemeine Einstellungen","spot_wizard.hdo_times.title":"Die Einstellung der HDO-Zeiten bestimmt den Zeitraum mit niedrigem Preis","spot_wizard.heat_pump.paragraph1":"Diese Einstellung erm\xf6glicht es, die Leistung der W\xe4rmepumpe bei niedriger Erzeugung zu erh\xf6hen und bei hohen Preisen zu senken.","spot_wizard.heat_pump.paragraph2":"Wenn Sie Energie nur am Spot verkaufen, k\xf6nnen Sie die Verz\xf6gerung und Erh\xf6hung des Verbrauchs deaktivieren.","spot_wizard.heat_pump.title":"W\xe4rmepumpe","spot_wizard.info.button1":"Warum wird meine Batterie heute nicht vom Spot geladen?","spot_wizard.info.button2":"Warum wird meine Batterie heute nicht in den Spot entladen?","spot_wizard.info.button3":"Ich brauche Hilfe bei der Einrichtung","spot_wizard.info.help1.title":"Warum wird meine Batterie heute nicht vom Spot geladen?","spot_wizard.info.help2.title":"Warum wird meine Batterie heute nicht in den Spot entladen?","spot_wizard.info.title":"Informationen zum Spot-Handel","spot_wizard.overflow_limit.paragraph1":"Wenn Sie den Spot nur zum Energiekauf nutzen, k\xf6nnen Sie -10 CZK einstellen. Der \xdcberschuss ist auf die vom Servicetechniker eingestellte Maximalgr\xf6\xdfe begrenzt.","spot_wizard.overflow_limit.paragraph2":"Wenn Sie den Spot zum Energieverkauf nutzen, ist es vorteilhaft, die Speicherung bei einem Preis zu stoppen, der der Provision Ihres Lieferanten entspricht. Die Provision betr\xe4gt \xfcblicherweise 0.30 - 0.70 CZK/kWh.","spot_wizard.overflow_limit.title":"Begrenzung des \xdcberschusses ins Netz","spot_wizard.preferential_sale.paragraph1":"Diese Funktion stellt den Einspeisevorrang w\xe4hrend der Morgenspitze ein. Energie wird bevorzugt ins Netz verkauft, statt in Batterie, Boiler und W\xe4rmepumpe gespeichert zu werden. Die Speicherung wird bei niedrigen Preisen oder nach dem Verkauf der gesch\xe4tzten \xfcbersch\xfcssigen Energie wieder aktiviert.","spot_wizard.preferential_sale.paragraph2":"Wenn Sie Energie nur am Spot kaufen, k\xf6nnen Sie die Funktion deaktivieren.","spot_wizard.preferential_sale.title":"Vorrangiger Energieverkauf","statistics.battery.statistics":"Ladezustand der Batterie","statistics.boiler.statistics":"Elektrische Boilerheizung","statistics.electrical_grid.statistics":"Bezug aus dem Netz","statistics.electrical_grid.statistics_house_consumption":"Geb\xe4udeverbrauch","statistics.electrical_grid.statistics_overflow":"\xdcberschuss ins Netz","statistics.heatpump.statistics":"Verbrauch der W\xe4rmepumpe","statistics.outdoor_temperature.statistics":"Au\xdfentemperatur","statistics.photovoltaics.statistics":"Photovoltaik-Erzeugung","statistics.plug.statistics":"Verbrauch der Steckdose","statistics.wind.statistics":"Erzeugung der Windkraftanlage","stats_delete.button":"L\xf6schen","stats_delete.cancel":"Abbrechen","stats_delete.confirm":"L\xf6schen","stats_delete.confirm.title":"M\xf6chten Sie wirklich alle Statistiken l\xf6schen?","stats_delete.title":"Alle Statistiken l\xf6schen","stats_export.button":"Exportieren","stats_export.from":"Von","stats_export.metric":"Metrik","stats_export.title":"Statistik exportieren","stats_export.to":"Bis","status.heatWater.flexibility":"Flexibilit\xe4t aktiv, Erw\xe4rmung von Warmwasser","status.heatWater.heating":"Erw\xe4rmung von Warmwasser","status.heatWater.hwError":"Der Boiler ist vollst\xe4ndig aufgeheizt oder nicht verf\xfcgbar","status.heatWater.inverterError":"Vorw\xe4rmen ist inaktiv, der Wechselrichter ist nicht verf\xfcgbar","status.heatWater.legionella":"Wassersanierung, Legionellen","status.heatWater.notConnected":"Verbindung kann nicht hergestellt werden","status.heatWater.notLicensed":"Die Boilersteuerung ist nicht lizenziert","status.heatWater.off":"Aus","status.heatWater.overload":"\xdcberlastung des Netzes, Erw\xe4rmung gestoppt","status.heatWater.pvHeating":"Erw\xe4rmung aus \xdcberschuss","status.heatWater.smartMeterError":"Vorw\xe4rmen des Boilers ist inaktiv, der Stromz\xe4hler ist nicht verf\xfcgbar","status.heatWater.spotHeating":"Erw\xe4rmung von Warmwasser vom Spot","status.heatWater.stop":"Stopp","status.heatWater.stopHDO":"Erw\xe4rmung bei hohem Preis gesperrt","status.heatWater.stopSOC":"Erw\xe4rmung gesperrt, niedriger Batteriestand","status.heatWater.stopSell":"Vorw\xe4rmen gesperrt, Energieverkauf","status.heatWater.tempError":"Temperatursensor ist nicht verf\xfcgbar","status.photovoltaic.dischargeBlockedByComponents":"Entladen der Batterie pausiert wegen des Verbrauchs ausgew\xe4hlter Technologien","status.photovoltaic.dischargeBlockedByHDO":"Entladen der Batterie pausiert, Hochtarif aktiv (HDO)","status.photovoltaic.discharging":"Entladen der Batterie","status.photovoltaic.distributionLimit":"Verteilnetz begrenzt die Leistung","status.photovoltaic.feedInPriority":"Einspeisevorrang","status.photovoltaic.flexibilityBatteryStop":"Flexibilit\xe4t aktiv, Laden und Entladen der Batterie gestoppt","status.photovoltaic.flexibilityCharging":"Flexibilit\xe4t aktiv, Laden der Batterie aus dem Netz","status.photovoltaic.flexibilityDischarging":"Flexibilit\xe4t aktiv, Entladen der Batterie ins Netz","status.photovoltaic.flexibilityDoNotDischarge":"Flexibilit\xe4t aktiv, Verbot des Entladens der Batterie","status.photovoltaic.flexibilityFeedInPriority":"Flexibilit\xe4t aktiv, Vorrang des \xdcberschusses ins Netz","status.photovoltaic.flexibilityOverflowRestricted":"Flexibilit\xe4t aktiv, Verbot des \xdcberschusses ins Netz","status.photovoltaic.forcedOverflow":"Flexibilit\xe4t aktiv, erzwungener \xdcberschuss ins Netz","status.photovoltaic.idle":"Ruhemodus","status.photovoltaic.manualCharging":"Manuelles Laden der Batterie","status.photovoltaic.manualDischarging":"Manuelles Entladen der Batterie","status.photovoltaic.noOverflowLimit":"Kein \xdcberschusslimit","status.photovoltaic.noneInverter":"Wechselrichtertyp nicht eingestellt","status.photovoltaic.notConnected":"Verbindung kann nicht hergestellt werden","status.photovoltaic.notLicensed":"PV-Steuerung ist nicht lizenziert","status.photovoltaic.planCharge":"Geplantes Laden der Batterie","status.photovoltaic.planDischarge":"Geplantes Entladen der Batterie","status.photovoltaic.production":"Energieerzeugung","status.photovoltaic.sellBatteryEnergy":"Verkauf von Energie aus der Batterie","status.photovoltaic.spotCharging":"Laden der Batterie vom Spot","status.photovoltaic.spotStopDischarging":"Entladen gestoppt, niedriger Preis am Spot","status.photovoltaic.standby":"Stand-by-Modus","status.photovoltaic.startUp":"Startmodus","status.plug.batteryControl":"Steckdose aktiv nach Batterie","status.plug.manualControl":"Steckdose aktiv im manuellen Modus","status.plug.notActive":"Steckdose inaktiv","status.plug.notConnected":"Verbindung kann nicht hergestellt werden","status.plug.overflowControl":"Steckdose aktiv nach \xdcberschuss","status.plug.spotControl":"Steckdose aktiv nach Spot","status.plug.stop":"Stopp","status.plug.timeControl":"Steckdose aktiv nach Zeit","status.smartMeter.consumption":"Normaler Verbrauch des Hauses","status.smartMeter.maxLoad":"Maximaler Verbrauch des Hauses","status.smartMeter.none":"","status.smartMeter.overflow":"Energie\xfcberschuss ins Netz","status.smartMeter.overflowLimited":"\xdcberschuss aufgrund eines negativen Preises begrenzt","status.smartMeter.shortage":"Ausfall des Verteilnetzes","status.spotBattery.flexibilityPV":"Flexibilit\xe4t f\xfcr PV genutzt","status.spotBattery.flexibilitySpot":"Flexibilit\xe4t f\xfcr SPOT genutzt","status.spotBattery.noData":"Keine Daten f\xfcr die Steuerung","status.spotBattery.spotNotLicensed":"Spot ist nicht lizenziert","status.spotBatteryChargeFromGrid.batteryChargingNotActive":"Laden aus dem Netz ist nicht aktiv","status.spotBatteryChargeFromGrid.batteryChargingPlanned":"Das heutige Laden ist aktiv","status.spotBatteryChargeFromGrid.enoughPVEnergy":"Heutiger erwarteter Tages\xfcberschuss zum Laden der Batterie","status.spotBatteryChargeFromGrid.priceDifferenceTooLow":"Der heutige Mindestpreisunterschied ist nicht erf\xfcllt","status.spotBatteryChargeFromGrid.spotNotActive":"Spot-Handel ist nicht aktiv","status.spotBatteryDischargeToGrid.batteryDischargingNotActive":"Entladen ins Netz ist nicht aktiv","status.spotBatteryDischargeToGrid.batteryDischargingPlanned":"Das heutige Entladen ist aktiv","status.spotBatteryDischargeToGrid.minPriceNotReached":"Der heutige Mindestpreis f\xfcr den Verkauf wird nicht erreicht","status.spotBatteryDischargeToGrid.notEnoughBatteryEnergy":"Heute wird erwartet, dass die Batterie \xfcber Nacht in den Eigenverbrauch entladen wird","status.spotBatteryDischargeToGrid.spotNotActive":"Spot-Handel ist nicht aktiv","status.spotBatteryDischargeToHome.automaticDischargeMode":"Automatisches Entladen der Batterie gem\xe4\xdf Kapazit\xe4t","status.spotBatteryDischargeToHome.highPriceDischargeMode":"Entladen der Batterie bei hohem Preis","status.spotBatteryDischargeToHome.mediumAndHighPriceDischargeMode":"Entladen der Batterie bei mittlerem und hohem Preis","status.spotBatteryDischargeToHome.notControlled":"Das Entladen der Batterie ist nicht begrenzt","status.spotHeatPump.flexibilityPV":"Flexibilit\xe4t f\xfcr PV genutzt","status.spotHeatPump.flexibilitySpot":"Flexibilit\xe4t f\xfcr SPOT genutzt","status.spotHeatPump.noData":"Keine Daten f\xfcr die Steuerung","status.spotHeatPump.spotNotLicensed":"Spot ist nicht lizenziert","status.spotHeatWater.flexibilityPV":"Flexibilit\xe4t f\xfcr PV genutzt","status.spotHeatWater.flexibilitySpot":"Flexibilit\xe4t f\xfcr SPOT genutzt","status.spotHeatWater.noData":"Keine Daten f\xfcr die Steuerung","status.spotHeatWater.spotNotLicensed":"Spot ist nicht lizenziert","status.spotSmartMeter.noData":"Keine Daten f\xfcr die Steuerung","status.spotSmartMeter.overflowDisabled":"Dauerhafte \xdcberschussbegrenzung","status.spotSmartMeter.overflowFlexibilitySell":"Optimierung des \xdcberschusses f\xfcr den Verkauf","status.spotSmartMeter.overflowLimited":"\xdcberschuss aufgrund negativer Preise begrenzt","status.spotSmartMeter.spotNotLicensed":"Spot ist nicht lizenziert","status.spotSmartMeter.withoutReduction":"Ohne Begrenzung","status.wind.production":"Energieerzeugung","status.wind.stop":"STOP","status.wind.unavailable":"Nicht verf\xfcgbar","subscriptions.fetch":"Abonnement aktualisieren","subscriptions.fetch.button":"Abonnement aktualisieren","subscriptions.last_fetch_at":"Letzte Aktualisierung","subscriptions.premium_active":"Premium aktiv","subscriptions.title":"Abonnement","test-product.app":"Anwendung","test-product.settings":"Einstellungen","test-product.settings.distribution":"Vertrieb","test-product.settings.distribution.Dzd":"DZD","test-product.settings.distribution.Infigy":"Infigy","test-product.settings.distribution.solid_sun":"SolidSun","test-product.settings.license":"Lizenz","test-product.settings.license.HW":"HW","test-product.settings.license.Industrial":"Industrial","test-product.settings.license.Play":"PLAY","test-product.settings.license.Smart":"Smart","test-product.settings.license.basic":"Basic","test-product.test":"Ger\xe4tetest","test-product.test.DC":"Pr\xfcfung des DC-Kreises","test-product.test.DC.subtitle":"Anschlie\xdfen der Klemmen, Kabelquerschnitte","test-product.test.component":"Komponentenpr\xfcfung","test-product.test.component.subtitle":"Sind Sensor, Etiketten, \u2026 vorhanden?","test-product.test.electricmeter":"Pr\xfcfung des Smartmeters","test-product.test.electricmeter.subtitle":"Pr\xfcfung der Installation des Smartmeters f\xfcr den Wechselrichter","test-product.test.internet-connect":"Internetverbindung","test-product.test.inverter-connect":"Anschlie\xdfen des Wechselrichters","test-product.test.license":"Lizenz","test-product.test.license-info":"Lizenz","test-product.test.phase_1":"Test Phase 1","test-product.test.phase_2":"Test Phase 2","test-product.test.phase_3":"Test Phase 3","test-product.test.serialNumber":"Seriennummer des Ger\xe4ts","test-product.test.serialNumber.label":"Seriennummer","test-product.test.serialNumber.subtitle":"Ohne Seriennummer k\xf6nnen der Name des Testers und der Test nicht eingegeben werden","test-product.test.serialNumberSwitchboard":"Produktionsnummer des Schaltschranks","test-product.test.serialNumberSwitchboard.label":"Seriennummer","test-product.test.serialNumberSwitchboard.subtitle":"Ausf\xfcllen, wenn sich das Ger\xe4t im Originalschrank befindet","test-product.test.start":"Wenn das Ger\xe4t angeschlossen ist","test-product.test.start.button":"Test aktivieren","test-product.test.switchboard":"Pr\xfcfung der \xdcbereinstimmung des Schaltschranks","test-product.test.switchboard.subtitle":"Pr\xfcfung des Anschlusses der Klemmen, der Platzierung der Komponenten und der korrekten Kabelquerschnitte","test-product.test.temp":"Temperatursensor","test-product.test.tester":"Ger\xe4t getestet von","test-product.test.tester.subtitle":"Ohne Namen kann der Test nicht aktiviert werden","thermostat.general":"Allgemeine Einstellungen","thermostat.general.cooling":"K\xfchlung aktiv","thermostat.general.cooling.pvstability":"M\xf6gliche Aktivierung der Quelle","thermostat.general.heating":"Heizung aktiv","thermostat.range":"Thermostat","thermostat.range.flexibility-temperature":"Flexible Temperatur","thermostat.range.flexibility-temperature.subtitle":"Temperatur, um die das Haus vorgeheizt oder vorgek\xfchlt werden kann","thermostat.range.flexibility_status":"Flexibilit\xe4tsmodus des Thermostats","thermostat.range.on":"Thermostat aktiv","thermostat.range.on.subtitle":"Grundtemperatur","thermostat.range.pv-flexibility":"Steuerung anhand der Photovoltaik","thermostat.range.set_temperature":"Solltemperatur","thermostat.range.sp-flexibility-down":"Verbrauch gem\xe4\xdf Spot verschieben","thermostat.range.sp-flexibility-up":"Verbrauch gem\xe4\xdf Spot erh\xf6hen","thermostat.range.status":"Flexibilit\xe4tsmodus des Thermostats","thermostat.range.temperature":"Solltemperatur","thermostat.statisticsTemp":"Thermostattemperatur","thermostat.status":"Thermostatmodus","wallbox.3a.on":"Modus 3A","wallbox.3a.on_sub":"Das Laden kann 3A aus dem Verteilnetz beziehen","wallbox.6a.on":"Modus 6A","wallbox.6a.on_sub":"Laden nur aus Photovoltaik","wallbox.NO_CHARGE":"Nicht laden","wallbox.NO_CHARGE.on_sub":"Das Laden ist dauerhaft gesperrt, nur der Zeitplan startet es","wallbox.PV":"Laden gem\xe4\xdf Batterie","wallbox.PV.batteryStart":"Einschalten bei Ladezustand","wallbox.PV.batteryStart.subtitle":"Laden starten, wenn die Batterie geladen wird","wallbox.PV.batteryStop":"Ausschalten bei Ladezustand","wallbox.PV.batteryStop.subtitle":"Laden stoppen, wenn die Batterie geladen wird","wallbox.PV.on":"Aktiv","wallbox.PV.on_sub":"Nach Erreichen der Basisenergie erfolgt das Laden nur bei voll geladener Batterie","wallbox.PV2":"Laden gem\xe4\xdf PV","wallbox.PV2.on":"Aktiv","wallbox.PV2.on_sub":"Ladesteuerung gem\xe4\xdf PV-Leistung","wallbox.PV_FAST":"Vorrangiges Laden gem\xe4\xdf Batterie","wallbox.PV_FAST.batteryMinSoc":"Minimale Batteriereserve","wallbox.PV_FAST.batteryMinSoc.subtitle":"Die Batterie wird wegen des Ladens des Fahrzeugs nicht unter diesen Wert entladen. Solange der Wert nicht \xfcberschritten wird, wartet das Laden","wallbox.PV_FAST.on_sub":"Das Laden des Fahrzeugs hat volle Priorit\xe4t. Es wird nur Energie aus der Batterie oder PV genutzt","wallbox.SPOT":"Laden gem\xe4\xdf Spotpreisen","wallbox.SPOT.hi":"Laden bei hohen Preisen verhindern","wallbox.SPOT.mi":"Laden bei mittleren Preisen verhindern","wallbox.SPOT.on":"Aktiv","wallbox.SPOT.on_sub":"Nach Erreichen der Basisenergie wird bei hohen Spotpreisen blockiert","wallbox.active":"{name}","wallbox.active.subtitle":"Aktiv","wallbox.alfen":"Alfen","wallbox.authorization.status":"Autorisierung","wallbox.authorization.status.authorized":"Autorisiert{cardInfo}","wallbox.authorization.status.denied":"Abgelehnt{cardInfo}","wallbox.authorization.status.pending":"Nicht autorisiert","wallbox.authorization.status.unknown":"Unbekannter Status","wallbox.az_router":"AZ Router","wallbox.common":"Allgemeine Informationen","wallbox.common.power":"Aktueller Verbrauch","wallbox.common.power_today":"Heutiger Verbrauch:","wallbox.common.power_total":"Gesamtverbrauch","wallbox.common.power_year":"Jahresverbrauch:","wallbox.control":"Lademodus","wallbox.ecovolter":"EcoVolter","wallbox.evmate":"EVmate","wallbox.fast-charge":"Schnellladen","wallbox.fast-charge.energy":"Energie f\xfcr Schnellladen","wallbox.fast-charge.energy_actual":"Geladene Energie im aktuellen Zyklus","wallbox.fast-charge.energy_sub":"Energie, die immer so schnell wie m\xf6glich geladen wird. Nach Erreichen dieses Werts wird das Laden von einem der Modi gesteuert.","wallbox.goodwe-ev-charger":"Goodwe","wallbox.inactive.subtitle":"Inaktiv","wallbox.mode.pv.batteryStopConflict.description":"Wenn die Batteriesperre w\xe4hrend des Wallbox-Betriebs aktiviert ist, kann der Modus \u201ELaden gem\xe4\xdf Batterie\u201C nicht aktiviert werden. Um den Modus \u201ELaden gem\xe4\xdf Batterie\u201C zu aktivieren, m\xfcssen Sie zuerst die Batteriesperre auf der Seite \u201EPhotovoltaik\u201C deaktivieren.","wallbox.mode.pv.batteryStopConflict.title":"Modus kann nicht aktiviert werden","wallbox.mybox":"MyBox","wallbox.none":"Keine","wallbox.nonemode":"Regul\xe4res Laden","wallbox.nonemode.amper-auto":"Automatische Steuerung des Ladestroms","wallbox.nonemode.amper-auto.subtitle":"Steuert das Laden so, dass Laden und Entladen der Batterie minimiert werden","wallbox.nonemode.ampers":"Maximaler Ladestrom","wallbox.nonemode.hdo":"Laden nur im Niedertarif","wallbox.nonemode.hdo_sub":"Die HDO-Zeiten m\xfcssen in den allgemeinen Einstellungen festgelegt werden","wallbox.nonemode.on":"Aktiv","wallbox.nonemode.on_sub":"Das Auto l\xe4dt so schnell wie m\xf6glich","wallbox.olife":"Olife","wallbox.other":"Sonstige","wallbox.pv.ampers-auto":"Aktuell gew\xfcnschter Ladestrom","wallbox.schedules.description":"Planen Sie das Laden des Elektrofahrzeugs nach Bedarf.","wallbox.schedules.title":"Ladeplaner","wallbox.settings":"Einstellungen","wallbox.solax":"Solax \u2013 Kommunikation \xfcber Wechselrichter","wallbox.solax-ev-charger":"Solax \u2013 Kommunikation \xfcber Infigy","wallbox.statistics":"Statistik","wallbox.status":"Wallbox-Modus","wallbox.status.car_not_connected":"Auto nicht verbunden","wallbox.status.charging":"Laden","wallbox.status.charging_with_ventilation":"Laden mit Bel\xfcftung","wallbox.status.error":"Fehler","wallbox.status.home":"Wallbox-Modus","wallbox.status.normal":"Normal","wallbox.status.not_connected":"Verbindung kann nicht hergestellt werden","wallbox.status.off":"Wallbox aus","wallbox.status.ready":"Bereit zum Laden","wallbox.sub_status.auto":"gem\xe4\xdf Auto-Modus","wallbox.sub_status.basic_energy":"Basisenergie","wallbox.sub_status.battery":"gem\xe4\xdf Batterie","wallbox.sub_status.battery_fast":"vorrangig gem\xe4\xdf Batterie","wallbox.sub_status.battery_waiting":", Warten auf Batterieladung","wallbox.sub_status.hdo_block":", HDO-Sperre","wallbox.sub_status.no_charging":", Laden ist deaktiviert","wallbox.sub_status.none":"","wallbox.sub_status.photovoltaics":"gem\xe4\xdf PV","wallbox.sub_status.schedule":"gem\xe4\xdf Planer","wallbox.sub_status.spot":"gem\xe4\xdf SPOT","wallbox.sub_status.spot_high":", hoher SPOT-Preis","wallbox.sub_status.spot_mid":", mittlerer SPOT-Preis","wallbox.victron-ev-charger":"Victron EV Charger","wallbox.wallboxes.title":"Wallboxen","wallbox_rfid.add_button":"RFID-Karte hinzuf\xfcgen","wallbox_rfid.delete.cancel":"Abbrechen","wallbox_rfid.delete.confirm":"L\xf6schen","wallbox_rfid.delete.confirm.title":"Karte {name} l\xf6schen?","wallbox_rfid.dialog.already_exists":"Die Karte {id} ist bereits unter dem Namen {name} gespeichert.","wallbox_rfid.dialog.already_exists_hint":"Bitte legen Sie eine andere Karte auf oder schlie\xdfen Sie den Dialog.","wallbox_rfid.dialog.cancel":"Abbrechen","wallbox_rfid.dialog.name_label":"Name der Karte","wallbox_rfid.dialog.save":"Speichern","wallbox_rfid.dialog.scanned_id":"Karten-ID: {id}","wallbox_rfid.dialog.title":"RFID-Karte hinzuf\xfcgen","wallbox_rfid.dialog.waiting":"Bitte legen Sie die Karte an das Leseger\xe4t\u2026","wallbox_rfid.edit.dialog.title":"RFID-Karte bearbeiten","wallbox_wizard.cancel":"Abbrechen","wallbox_wizard.custom_device_ip_address.alert":"Bitte stellen Sie sicher, dass sich die IP-Adresse der Wallbox nicht \xe4ndert (z. B. wenn die Wallbox eine DHCP-Adresse verwendet).","wallbox_wizard.custom_device_ip_address.input":"IP-Adresse der Wallbox","wallbox_wizard.multiple_wallboxes.alert":"F\xfcr die Konfiguration mehrerer Wallboxen wenden Sie sich bitte an die Support-Hotline. Den Kontakt finden Sie im technischen Wiki von Infigy.","wallbox_wizard.multiple_wallboxes.label":"Mehrere Wallboxen","wallbox_wizard.open":"Wallbox konfigurieren","wallbox_wizard.save":"Speichern","wallbox_wizard.title":"Wallbox-Konfiguration","welcome.subtitle":"Anwendungen f\xfcr h\xe4usliche und moderne Energie an einem Ort!","welcome.title":"Willkommen bei Infigy!","wifi_ap_config.interface_block.confirm.confirmation_text":"{blocked, select, true {Sperren} other {Entsperren}}","wifi_ap_config.interface_block.confirm.content":"M\xf6chten Sie WiFi wirklich {blocked, select, true {sperren} other {entsperren}}?","wifi_ap_config.interface_block.confirm.title":"WiFi-Status \xe4ndern","wifi_ap_config.passphrase_change.confirm.passphrase":"Passwort","wifi_ap_config.passphrase_change.confirm.title":"WiFi-Passwort \xe4ndern","wifi_ap_config.wifi_interface_blocked.button":"{blocked, select, true {Entsperren} other {Sperren}}","wifi_ap_config.wifi_interface_blocked.title":"WiFi-Status","wifi_ap_config.wifi_interface_blocked.value":"{blocked, select, true {Gesperrt} other {Aktiv}}","wind.common":"Allgemeine Informationen","wind.common.battery_charged_total":"Gesamtleistung in die Batterie","wind.common.battery_current":"Batteriestrom","wind.common.battery_power":"Batterieleistung","wind.common.battery_voltage":"Batteriespannung","wind.common.load_current":"Laststrom","wind.common.power":"Aktuelle Windleistung","wind.common.power_today":"Heutige Erzeugung:","wind.common.power_total":"Gesamterzeugung","wind.common.power_year":"Jahreserzeugung:","wind.common.resistor_power":"Laststrom","wind.statistics":"Statistik","wind.statistics.battery_charge_power":"Batterieleistung","wind.statistics.load_current":"Laststrom","wind.statistics.power":"Leistung der Windkraftanlage","wind.statistics.wind_speed":"Windgeschwindigkeit","wind.status":"Modus der Windkraftanlage"}');


const $7d8fe761d92a6b3f$export$defe85febe8b728c = {
    cs: (/*@__PURE__*/$parcel$interopDefault($1da81fd262ddec52$exports)),
    en: (/*@__PURE__*/$parcel$interopDefault($20f706d5b1546263$exports)),
    nl: (/*@__PURE__*/$parcel$interopDefault($0634569c145abc64$exports)),
    sk: (/*@__PURE__*/$parcel$interopDefault($01039277edda919c$exports)),
    de: (/*@__PURE__*/$parcel$interopDefault($8706e59c939e4898$exports))
};



var $acw62 = parcelRequire("acw62");
const $dd520a295c128d09$export$86e2cef2561044ac = (schema, key, defaultValue)=>{
    const [stateValue, setStateValue] = (0, $acw62.useState)(()=>{
        const storageValue = localStorage.getItem(key);
        try {
            const objectParsed = storageValue && JSON.parse(storageValue);
            const parsed = schema.safeParse(objectParsed);
            if (parsed.success) return parsed.data;
        } catch (_) {
        //
        }
        return defaultValue;
    });
    const setValue = (value)=>{
        setStateValue(value);
        localStorage.setItem(key, JSON.stringify(value));
    };
    return [
        stateValue,
        setValue
    ];
};



var $f1q41 = parcelRequire("f1q41");
const $9fa8a06396ffe454$var$localeContext = /*#__PURE__*/ (0, $acw62.createContext)({
    setLocale: ()=>{
        console.error('context not mounted');
    }
});
function $9fa8a06396ffe454$var$getDefaultLocale() {
    const browserLocale = (0, $f1q41.first)(navigator.language.split('-')) ?? '';
    if (browserLocale in (0, $7d8fe761d92a6b3f$export$defe85febe8b728c)) return browserLocale;
    return 'cs';
}
const $9fa8a06396ffe454$var$defaultLocale = $9fa8a06396ffe454$var$getDefaultLocale();
const $9fa8a06396ffe454$export$d07e18ad7fac0edc = ({ children: children })=>{
    const [locale, setLocale] = (0, $dd520a295c128d09$export$86e2cef2561044ac)((0, $2zDt6.default).string(), 'locale', $9fa8a06396ffe454$var$defaultLocale);
    const localeMessages = locale in (0, $7d8fe761d92a6b3f$export$defe85febe8b728c) ? (0, $7d8fe761d92a6b3f$export$defe85febe8b728c)[locale] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9fa8a06396ffe454$var$localeContext.Provider, {
        value: {
            setLocale: setLocale
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ezTXF.default), {
            locale: locale,
            messages: localeMessages,
            defaultLocale: $9fa8a06396ffe454$var$defaultLocale,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: children
            })
        })
    });
};
const $9fa8a06396ffe454$export$aa53e71df758134e = ()=>{
    const { locale: locale } = (0, $202BL.default)();
    const { setLocale: setLocale } = (0, $acw62.useContext)($9fa8a06396ffe454$var$localeContext);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
        sx: {
            ml: 'auto'
        },
        value: locale,
        onChange: (e)=>{
            setLocale(e.target.value);
        },
        children: Object.keys((0, $7d8fe761d92a6b3f$export$defe85febe8b728c)).map((l)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                value: l,
                children: l.toUpperCase()
            }, l))
    });
};





var $9iEAl = parcelRequire("9iEAl");




var $gpaJb = parcelRequire("gpaJb");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");


var $2lSXC = parcelRequire("2lSXC");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $2zDt6 = parcelRequire("2zDt6");

var $bwB5b = parcelRequire("bwB5b");


var $7pTac = parcelRequire("7pTac");
const $cbe78ff735f0df2e$export$e917bcd07f9c0c68 = ()=>{
    const [readabilityMode, setReadabilityMode] = (0, $dd520a295c128d09$export$86e2cef2561044ac)((0, $2zDt6.z).nativeEnum((0, $bwB5b.ReadabilityMode)), 'readabilityMode', (0, $bwB5b.ReadabilityMode).Default);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
        sx: {
            ml: 'auto'
        },
        value: readabilityMode,
        onChange: (e)=>{
            const newValue = e.target.value;
            if (newValue !== readabilityMode) {
                setReadabilityMode(newValue);
                setTimeout(()=>{
                    window.location.reload();
                }, 100);
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                value: (0, $bwB5b.ReadabilityMode).Default,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.readability_mode.default",
                    defaultMessage: "V\xfdchoz\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                value: (0, $bwB5b.ReadabilityMode).Large,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.readability_mode.large",
                    defaultMessage: "Velk\xe1"
                })
            })
        ]
    });
};



var $aZOrF = parcelRequire("aZOrF");

var $03kOd = parcelRequire("03kOd");
var $gc70Y = parcelRequire("gc70Y");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");

var $7pTac = parcelRequire("7pTac");



const $15ab72d8453343b9$export$c21d98c0cce5a4d8 = ()=>{
    const weekendHDO = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'HDO_MODE') == 2 && (0, $f1q41.get)(s.variables, 'HDO_WEEKEND'));
    const spotPricePeriod = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'SP_PRICE_PERIOD'));
    const timeStep = spotPricePeriod === '15M' ? 900 : 3600;
    const optionsHDO = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.hdo.regular",
                defaultMessage: "B\u011B\u017En\xfd pracovn\xed den"
            }),
            value: (0, $8ni7a.HDOMode).Regular
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.hdo.weekend",
                defaultMessage: "V\xedkend"
            }),
            value: (0, $8ni7a.HDOMode).Weekend
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.weekend",
                            defaultMessage: "V\xedkendov\xe9 \u010Dasy HDO"
                        }),
                        switchVariableId: 'HDO_WEEKEND',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.type",
                            defaultMessage: "Definovat \u010Dasy pro"
                        }),
                        visibility: {
                            variableId: 'HDO_WEEKEND'
                        },
                        selectVariableId: "HDO_MODE",
                        options: optionsHDO,
                        fullWidth: true
                    })
                ]
            }),
            !weekendHDO && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on1",
                            defaultMessage: "\u010Cas 1"
                        }),
                        switchVariableId: 'HDO_ON[0]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[0]',
                        visibility: {
                            variableId: 'HDO_ON[0]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[0]',
                        visibility: {
                            variableId: 'HDO_ON[0]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on2",
                            defaultMessage: "\u010Cas 2"
                        }),
                        switchVariableId: 'HDO_ON[1]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[1]',
                        visibility: {
                            variableId: 'HDO_ON[1]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[1]',
                        visibility: {
                            variableId: 'HDO_ON[1]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on3",
                            defaultMessage: "\u010Cas 3"
                        }),
                        switchVariableId: 'HDO_ON[2]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[2]',
                        visibility: {
                            variableId: 'HDO_ON[2]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[2]',
                        visibility: {
                            variableId: 'HDO_ON[2]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on4",
                            defaultMessage: "\u010Cas 4"
                        }),
                        switchVariableId: 'HDO_ON[3]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[3]',
                        visibility: {
                            variableId: 'HDO_ON[3]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[3]',
                        visibility: {
                            variableId: 'HDO_ON[3]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on5",
                            defaultMessage: "\u010Cas 5"
                        }),
                        switchVariableId: 'HDO_ON[4]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[4]',
                        visibility: {
                            variableId: 'HDO_ON[4]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[4]',
                        visibility: {
                            variableId: 'HDO_ON[4]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on6",
                            defaultMessage: "\u010Cas 6"
                        }),
                        switchVariableId: 'HDO_ON[5]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START[5]',
                        visibility: {
                            variableId: 'HDO_ON[5]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP[5]',
                        visibility: {
                            variableId: 'HDO_ON[5]'
                        },
                        step: timeStep,
                        track: false
                    })
                ]
            }),
            weekendHDO && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on1",
                            defaultMessage: "\u010Cas 1"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[0]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[0]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[0]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[0]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[0]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on2",
                            defaultMessage: "\u010Cas 2"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[1]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[1]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[1]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[1]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[1]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on3",
                            defaultMessage: "\u010Cas 3"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[2]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[2]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[2]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[2]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[2]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on4",
                            defaultMessage: "\u010Cas 4"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[3]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[3]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[3]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[3]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[3]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on5",
                            defaultMessage: "\u010Cas 5"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[4]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[4]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[4]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[4]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[4]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.on6",
                            defaultMessage: "\u010Cas 6"
                        }),
                        switchVariableId: 'HDO_ON_WEEKEND[5]',
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.start",
                            defaultMessage: "Zapnout"
                        }),
                        variableId: 'HDO_TIME_START_WEEKEND[5]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[5]'
                        },
                        step: timeStep,
                        track: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        type: "time",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo.stop",
                            defaultMessage: "Vypnout"
                        }),
                        variableId: 'HDO_TIME_STOP_WEEKEND[5]',
                        visibility: {
                            variableId: 'HDO_ON_WEEKEND[5]'
                        },
                        step: timeStep,
                        track: false
                    })
                ]
            })
        ]
    });
};


parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $03kOd = parcelRequire("03kOd");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");


var $gpaJb = parcelRequire("gpaJb");




parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $OLlTf = parcelRequire("OLlTf");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $7X4mk = parcelRequire("7X4mk");

var $iH29s = parcelRequire("iH29s");

var $2lSXC = parcelRequire("2lSXC");

var $9iEAl = parcelRequire("9iEAl");

var $i88ph = parcelRequire("i88ph");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $22i8b = parcelRequire("22i8b");

var $2zDt6 = parcelRequire("2zDt6");

var $3s7Tn = parcelRequire("3s7Tn");

var $03kOd = parcelRequire("03kOd");
var $JYcZH = parcelRequire("JYcZH");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $hAiFn = parcelRequire("hAiFn");

var $iH29s = parcelRequire("iH29s");

var $9iEAl = parcelRequire("9iEAl");

var $5R532 = parcelRequire("5R532");


var $e3HVo = parcelRequire("e3HVo");
const $78cfe8c17b8640e1$export$304cfc026b23d498 = ({ getData: getData, canEditStatic: canEditStatic = true })=>{
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const type = getData.data?.static ? 'Static' : 'DHCP';
    const address = getData.data?.static?.address ?? getData.data?.wanAddress ?? '---';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network.wan",
                    defaultMessage: "WAN adresa"
                }),
                control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                    gap: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
                            label: type,
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            children: address
                        }),
                        canEditStatic && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            size: "small",
                            onClick: ()=>setDialogOpen(true),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {})
                        })
                    ]
                }),
                fullWidth: true
            }),
            canEditStatic && Boolean(getData.data) && /*#__PURE__*/ (0, $ayMG0.jsx)($78cfe8c17b8640e1$var$NetworkWanDialog, {
                open: dialogOpen,
                onClose: ()=>setDialogOpen(false),
                getData: getData
            })
        ]
    });
};
const $78cfe8c17b8640e1$var$schema = (0, $2zDt6.z).discriminatedUnion('type', [
    (0, $2zDt6.z).object({
        type: (0, $2zDt6.z).literal('dhcp')
    }),
    (0, $2zDt6.z).object({
        type: (0, $2zDt6.z).literal('static'),
        address: (0, $2zDt6.z).string().ip(),
        netmask: (0, $2zDt6.z).string().ip(),
        gw: (0, $2zDt6.z).string().ip(),
        dns: (0, $2zDt6.z).string().ip()
    })
]);
const $78cfe8c17b8640e1$var$NetworkWanDialog = ({ open: open, onClose: onClose, getData: getData })=>{
    const { mutate: mutate, isLoading: isLoading } = (0, $iH29s.trpc).network.setWan.useMutation({
        onSuccess: ()=>{
            onClose();
        },
        onError: (error)=>{
            alert('Failed to save WAN settings');
        }
    });
    const onSubmit = (data)=>{
        mutate(data);
    };
    const form = (0, $22i8b.useForm)({
        defaultValues: {
            type: getData?.data?.static ? 'static' : 'dhcp',
            address: getData?.data?.static?.address ?? '',
            netmask: getData?.data?.static?.netmask ?? '',
            gw: getData?.data?.static?.gw ?? '',
            dns: getData?.data?.static?.dns ?? ''
        },
        resolver: (0, $3s7Tn.zodResolver)($78cfe8c17b8640e1$var$schema)
    });
    (0, $acw62.useEffect)(()=>{
        if (open) form.reset({
            type: getData?.data?.static ? 'static' : 'dhcp',
            address: getData?.data?.static?.address ?? '',
            netmask: getData?.data?.static?.netmask ?? '',
            gw: getData?.data?.static?.gw ?? '',
            dns: getData?.data?.static?.dns ?? ''
        });
    }, [
        open
    ]);
    const type = form.watch('type');
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        maxWidth: "xs",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                variant: "h3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "network_wan_edit.dialog.title",
                    defaultMessage: "Editace WAN adresy"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22i8b.FormProvider), {
                ...form,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: form.handleSubmit(onSubmit),
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5f8f3fc94b629807$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                                variant: type === 'dhcp' ? 'contained' : 'outlined',
                                                onClick: ()=>form.setValue('type', 'dhcp'),
                                                children: "DHCP"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                                variant: type === 'static' ? 'contained' : 'outlined',
                                                onClick: ()=>form.setValue('type', 'static'),
                                                children: "Static"
                                            })
                                        ]
                                    }),
                                    type === 'static' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3HVo.FormTextField), {
                                                name: "address",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "network_wan_edit.dialog.address",
                                                    defaultMessage: "IP adresa"
                                                }),
                                                size: "small",
                                                disabled: isLoading
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3HVo.FormTextField), {
                                                name: "netmask",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "network_wan_edit.dialog.netmask",
                                                    defaultMessage: "Maska s\xedt\u011B"
                                                }),
                                                size: "small",
                                                disabled: isLoading
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3HVo.FormTextField), {
                                                name: "gw",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "network_wan_edit.dialog.gateway",
                                                    defaultMessage: "V\xfdchoz\xed br\xe1na"
                                                }),
                                                size: "small",
                                                disabled: isLoading
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3HVo.FormTextField), {
                                                name: "dns",
                                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "network_wan_edit.dialog.dns",
                                                    defaultMessage: "DNS server"
                                                }),
                                                size: "small",
                                                disabled: isLoading
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: onClose,
                                    disabled: isLoading,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "network_wan_edit.dialog.close",
                                        defaultMessage: "Zav\u0159\xedt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    variant: "contained",
                                    type: "submit",
                                    disabled: isLoading,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "network_wan_edit.dialog.save",
                                        defaultMessage: "Ulo\u017Eit"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $fNkZ4 = parcelRequire("fNkZ4");

var $iH29s = parcelRequire("iH29s");

var $9iEAl = parcelRequire("9iEAl");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $d3eb87d8c876d989$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2"
}), 'Circle');



var $12gtR = parcelRequire("12gtR");
const $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6 = ({ alive: alive, sx: sx })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: null,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3eb87d8c876d989$export$2e2bcd8739ae039), {
            sx: {
                color: typeof alive === 'boolean' ? alive ? 'success.main' : 'error.main' : 'grey.700',
                ...sx ?? {},
                '@keyframes pulse': {
                    '0%': {
                        opacity: 1
                    },
                    '50%': {
                        opacity: 0.5
                    },
                    '100%': {
                        opacity: 1
                    }
                },
                animation: typeof alive !== 'boolean' ? 'pulse 1.5s infinite' : undefined
            }
        })
    });
};



var $5R532 = parcelRequire("5R532");

var $aZOrF = parcelRequire("aZOrF");
const $9ae5fa085e37ab91$export$b771db10cdacd709 = ()=>{
    const { data: internetStatus } = (0, $iH29s.trpc).network.getOnlineStatus.useQuery({
        target: 'internet'
    }, {
        refetchInterval: 5000
    });
    const { data: cloudStatus } = (0, $iH29s.trpc).network.getOnlineStatus.useQuery({
        target: 'cloud'
    }, {
        refetchInterval: 5000
    });
    const { data: internalCloudStatus } = (0, $iH29s.trpc).network.getOnlineStatus.useQuery({
        target: 'internal-cloud'
    }, {
        refetchInterval: 5000
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network.online.internet",
                    defaultMessage: "P\u0159\xedstup na internet"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                    variant: "dialog",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.service.network.online.internet",
                        defaultMessage: "P\u0159\xedstup na internet"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.network.online.internet.help",
                            defaultMessage: "P\u0159\xedstup na internet je pot\u0159eba pro vzd\xe1len\xfd p\u0159\xedstup, aktualizace syst\xe9mu, spotov\xe9 ceny a dal\u0161\xed funkce. Pro plnou funk\u010Dnost mus\xed b\xfdt v\u0161echny t\u0159i indik\xe1tory zelen\xe9.{br}{br}Prvn\xed indik\xe1tor zobrazuje dostupnost internetu (ping 8.8.8.8).{br}{br}Druh\xfd indik\xe1tor zobrazuje dostupnost internetu v\u010Detn\u011B DNS (ping infigy.cz).{br}{br}T\u0159et\xed indik\xe1tor zobrazuje p\u0159\xedstup k intern\xedm cloudov\xfdm slu\u017Eb\xe1m Infigy (dostupnost VPN).{br}{br}Pokud je s p\u0159ipojen\xedm probl\xe9m, zkontrolujte pros\xedm kabel, nebo kontaktujte spr\xe1vce s\xedt\u011B, jestli nem\xe1 m\xedstn\xed s\xed\u0165 restrikce na komunikaci do internetu.{br}{br}{wikiLink}",
                            values: {
                                br: /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                wikiLink: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fNkZ4.default), {
                                    href: "https://infigy.cz/app-redirect/internet-access",
                                    target: "_blank",
                                    rel: "noopener",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.service.network.online.internet.help.wikiLink",
                                        defaultMessage: "V\xedce informac\xed v na\u0161\xed wiki."
                                    })
                                })
                            }
                        })
                    })
                })
            ]
        }),
        control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
            gap: 0.25,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                    alive: internetStatus
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                    alive: cloudStatus
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                    alive: internalCloudStatus
                })
            ]
        }),
        fullWidth: true
    });
};


const $24a55c5e6e739460$export$f122a8f2c2ae40c1 = ()=>{
    const caps = (0, $2lSXC.useSelector)((s)=>s.variables.NETWORK_CAPABILITIES);
    const deviceMac = (0, $2lSXC.useSelector)((s)=>s.variables.DEVICE_MAC);
    const getData = (0, $iH29s.trpc).network.get.useQuery(undefined, {
        refetchInterval: 5000,
        enabled: Boolean(caps.wanAddress) || caps.managedNetwork
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $i88ph.NetworkHostsTable), {
                getData: getData
            }),
            Boolean(caps.wanAddress) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $78cfe8c17b8640e1$export$304cfc026b23d498), {
                getData: getData,
                canEditStatic: caps.managedNetwork
            }),
            caps.wanMac && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network.mac",
                    defaultMessage: "MAC adresa"
                }),
                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    sx: {
                        mt: 0.5
                    },
                    children: deviceMac
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ae5fa085e37ab91$export$b771db10cdacd709), {})
        ]
    });
};



var $29Lk4 = parcelRequire("29Lk4");

var $9iEAl = parcelRequire("9iEAl");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");




var $gpaJb = parcelRequire("gpaJb");

var $2lSXC = parcelRequire("2lSXC");

const $e4cfe371582f6593$export$d89b70f5e57ee789 = ()=>{
    const thermostatCount = (0, $2lSXC.useSelector)(({ variables: variables })=>Math.min(variables.THERMOSTAT_SETTINGS.length, variables.NUMBER_OF_THERMOSTATS));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.install",
                        defaultMessage: "Termostat aktivn\xed"
                    }),
                    switchVariableId: "THERMOSTAT_INSTALL",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.hp-blocked",
                        defaultMessage: "Blokace tepeln\xe9ho \u010Derpadla"
                    }),
                    visibility: {
                        variableId: 'HP_ENABLED'
                    },
                    switchVariableId: "THERMOSTAT_HP_BLOCKED",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                    type: "row",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.number-of-thermostat",
                        defaultMessage: "Po\u010Det termostat\u016F"
                    }),
                    value: thermostatCount,
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name1",
                        defaultMessage: "Pojmenov\xe1n\xed termostatu 1"
                    }),
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    },
                    inputVariableId: "THERMOSTAT_SETTINGS[0].name",
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name.label",
                        defaultMessage: "N\xe1zev"
                    }),
                    fullWidth: true
                }),
                thermostatCount > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name2",
                        defaultMessage: "Pojmenov\xe1n\xed termostatu 2"
                    }),
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    },
                    inputVariableId: "THERMOSTAT_SETTINGS[1].name",
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name.label",
                        defaultMessage: "N\xe1zev"
                    }),
                    fullWidth: true
                }),
                thermostatCount > 2 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name3",
                        defaultMessage: "Pojmenov\xe1n\xed termostatu 3"
                    }),
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    },
                    inputVariableId: "THERMOSTAT_SETTINGS[2].name",
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name.label",
                        defaultMessage: "N\xe1zev"
                    }),
                    fullWidth: true
                }),
                thermostatCount > 3 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name4",
                        defaultMessage: "Pojmenov\xe1n\xed termostatu 4"
                    }),
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    },
                    inputVariableId: "THERMOSTAT_SETTINGS[4].name",
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.name.label",
                        defaultMessage: "N\xe1zev"
                    }),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.nominal",
                        defaultMessage: "Nomin\xe1ln\xed p\u0159\xedkon zdroje"
                    }),
                    variableId: "THERMOSTAT_HP_CONSUMPTION",
                    visibility: {
                        variableIds: [
                            'THERMOSTAT_INSTALL',
                            {
                                variableId: 'HP_ENABLED',
                                reversed: true
                            }
                        ]
                    },
                    opts: {
                        style: 'unit',
                        unit: 'kilowatt',
                        maximumFractionDigits: 1,
                        minimumFractionDigits: 1
                    },
                    step: 0.1
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.thermostat.hysteresis",
                        defaultMessage: "Hystereze teploty"
                    }),
                    variableId: 'THERMOSTAT_HYSTERESIS',
                    visibility: {
                        variableId: 'THERMOSTAT_INSTALL'
                    },
                    max: 10,
                    min: 0,
                    step: 0.1,
                    opts: {
                        style: 'unit',
                        unit: 'celsius',
                        maximumFractionDigits: 1
                    }
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $7pTac = parcelRequire("7pTac");

parcelRequire("acw62");


var $2lSXC = parcelRequire("2lSXC");

var $f1q41 = parcelRequire("f1q41");


var $aZOrF = parcelRequire("aZOrF");

const $081bcf26156f4356$export$6ec90c1ef5cffa35 = ()=>{
    const infigySmart = (0, $2lSXC.useSelector)((s)=>{
        return s.variables.LICENSE == 3 || s.variables.LICENSE == 4 || s.variables.LICENSE == 5;
    });
    const spotInstaled = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'SP_INSTALL'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: infigySmart && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.spot.install",
                        defaultMessage: "Spotov\xe9 obchodov\xe1n\xed aktivn\xed"
                    }),
                    switchVariableId: "SP_INSTALL",
                    fullWidth: true
                })
            }),
            spotInstaled && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e84bcf1fb32102d8$export$dd088f0d81500b74), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.battery_charge",
                                            defaultMessage: "Povoleno nab\xedjen\xed baterie podle spotu"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                            variant: "dialog",
                                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.battery_charge",
                                                defaultMessage: "Povoleno nab\xedjen\xed baterie podle spotu"
                                            }),
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.battery_charge.help",
                                                defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje nab\xedjen\xed v dob\u011B nejni\u017E\u0161\xedch cen. Bere v potaz aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie a jej\xed kapacitu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nab\xedjen\xed tak, aby do\u0161lo k jej\xedmu nabit\xed za co nejni\u017E\u0161\xed cenu."
                                            })
                                        })
                                    ]
                                }),
                                switchVariableId: "SP_BATTERY_CONTROL_SERVICE",
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.battery_charge.subtitle",
                                    defaultMessage: "\u0158\xedzen\xed baterie podle spotu zv\xfd\u0161\xed amortizaci baterie"
                                }),
                                visibility: {
                                    variableIds: [
                                        'SP_INSTALL',
                                        'PV_BATTERY',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.battery_strategy",
                                            defaultMessage: "Strategie spotov\xe9ho nab\xedjen\xed baterie"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                            variant: "dialog",
                                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.battery_strategy",
                                                defaultMessage: "Strategie spotov\xe9ho nab\xedjen\xed baterie"
                                            }),
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.battery_strategy.help",
                                                defaultMessage: "T\xedmto posuvn\xedkem m\u016F\u017Eete jednodu\u0161e nastavit preferenci vyu\u017Eit\xed baterie p\u0159i spotov\xe9m obchodov\xe1n\xed. Ni\u017E\u0161\xed hodnoty (od 20 %) znamenaj\xed men\u0161\xed cyklov\xe1n\xed baterie a tedy m\xe9n\u011B \u010Dast\xe9 nab\xedjen\xed/vyb\xedjen\xed za spotov\xe9 ceny. Vy\u0161\u0161\xed hodnoty (a\u017E do 70 %) zna\u010D\xed opak."
                                            })
                                        })
                                    ]
                                }),
                                variableId: "SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC",
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.battery_strategy_user.subtitle",
                                    defaultMessage: "20 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro FVE. 70 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro Spot."
                                }),
                                opts: {
                                    style: 'percent',
                                    maximumFractionDigits: 0
                                },
                                min: 20,
                                max: 70,
                                visibility: {
                                    variableIds: [
                                        'SP_INSTALL',
                                        'PV_BATTERY',
                                        'SP_BATTERY_CONTROL_SERVICE',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.battery_strategy_user",
                                    defaultMessage: "Umo\u017Enit nastaven\xed strategie baterie u\u017Eivatelem"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.battery_strategy_service.subtitle",
                                    defaultMessage: "Touto volbou povol\xedte koncov\xfdm u\u017Eivatel\u016Fm nastavit strategii baterie na z\xe1lo\u017Ece Spot"
                                }),
                                switchVariableId: "SP_USER_ADVANCED_CONTROL",
                                visibility: {
                                    variableIds: [
                                        'SP_INSTALL',
                                        'PV_BATTERY',
                                        'SP_BATTERY_CONTROL_SERVICE',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.min_difference_price_charge_from_grid",
                                            defaultMessage: "Minim\xe1ln\xed rozd\xedl ceny na spotu pro nab\xedjen\xed baterie ze s\xedt\u011B"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                            variant: "dialog",
                                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.min_difference_price_charge_from_grid",
                                                defaultMessage: "Minim\xe1ln\xed rozd\xedl ceny na spotu pro nab\xedjen\xed baterie ze s\xedt\u011B"
                                            }),
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.spot.min_difference_price_charge_from_grid.help",
                                                defaultMessage: "T\xedmto parametrem je mo\u017En\xe9 \u0159\xeddit nab\xedjen\xed baterie ze spotu p\u0159i n\xedzk\xe9m rozd\xedlu mezi nejni\u017E\u0161\xed a nejvy\u0161\u0161\xed cenou. Pokud je parametr 2 K\u010D a rozd\xedl mezi nejvy\u0161\u0161\xed cenou (3 K\u010D) a nejni\u017E\u0161\xed cenou (1 K\u010D) spotu je ni\u017E\u0161\xed, tak se ten den nab\xedjen\xed baterie ze s\xedt\u011B nenapl\xe1nuje."
                                            })
                                        })
                                    ]
                                }),
                                variableId: "SP_MIN_SPOT_DIFFERENCE_PRICE",
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.min_difference_price_charge_from_grid.subtitle",
                                    defaultMessage: "Minim\xe1ln\xed rozd\xedl ceny na spotu b\u011Bhem dne, aby mohlo doj\xedt k nab\xedjen\xed baterie ze s\xedt\u011B"
                                }),
                                opts: {
                                    style: 'currency'
                                },
                                min: {
                                    CZK: 1,
                                    EUR: 0.05
                                },
                                max: {
                                    CZK: 5,
                                    EUR: 0.25
                                },
                                visibility: {
                                    variableIds: [
                                        'SP_INSTALL',
                                        'PV_BATTERY',
                                        'SP_BATTERY_CONTROL_SERVICE',
                                        'PV_BATTERY_CONTROL'
                                    ]
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.spot.battery_overflow",
                                        defaultMessage: "Povolit vyb\xedjen\xed baterie do s\xedt\u011B podle spotu"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.battery_overflow",
                                            defaultMessage: "Povolit vyb\xedjen\xed baterie do s\xedt\u011B podle spotu"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.battery_overflow.help",
                                            defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje vyb\xedjen\xed baterie do s\xedt\u011B v dob\u011B nejvy\u0161\u0161\xed denn\xed ceny a vybije jen tu energii, kter\xe1 nebude pot\u0159eba na b\u011B\u017Enou spot\u0159ebu objektu. Parametry n\xed\u017Ee je mo\u017En\xe9 definovat v\xfd\u0161i ceny pro vyb\xedt\xed cel\xe9 kapacity baterie a vyb\xedt\xed jen t\xe9 \u010D\xe1sti kapacity baterie, kter\xe1 nebude pot\u0159eba pro no\u010Dn\xed spot\u0159ebu. "
                                        })
                                    })
                                ]
                            }),
                            switchVariableId: "SP_DISCHARGE_TO_GRID_SER",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_overflow.subtitle",
                                defaultMessage: "Umo\u017En\xed vyb\xedt nadbytek energie z baterie do s\xedt\u011B v nejv\xfdhodn\u011Bj\u0161\xed hodinu"
                            }),
                            visibility: {
                                variableIds: [
                                    'SP_INSTALL',
                                    'PV_BATTERY',
                                    'PV_BATTERY_CONTROL'
                                ]
                            },
                            fullWidth: true
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $iQxou = parcelRequire("iQxou");
var $klPA2 = parcelRequire("klPA2");
var $kZugz = parcelRequire("kZugz");
const $8e51f8b03c60a8d4$export$1a72dabd82538ea2 = [
    {
        town: 'Abertamy',
        townCode: 554979,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36235,
        lat: 50.368855,
        long: 12.818377
    },
    {
        town: 'Adamov',
        townCode: 535826,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 49.000624,
        long: 14.539603
    },
    {
        town: 'Adamov',
        townCode: 581291,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67904,
        lat: 49.295708,
        long: 16.663955
    },
    {
        town: 'Adamov',
        townCode: 531367,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.857917,
        long: 15.409018
    },
    {
        town: "Adr\u0161pach",
        townCode: 547786,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54957,
        lat: 50.624387,
        long: 16.083501
    },
    {
        town: 'Albrechtice',
        townCode: 598925,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73543,
        lat: 49.786552,
        long: 18.524545
    },
    {
        town: 'Albrechtice',
        townCode: 547981,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.927643,
        long: 16.644801
    },
    {
        town: "Albrechtice nad Orlic\xed",
        townCode: 576077,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51722,
        lat: 50.139886,
        long: 16.064472
    },
    {
        town: 'Albrechtice nad Vltavou',
        townCode: 549258,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39816,
        lat: 49.253337,
        long: 14.302929
    },
    {
        town: "Albrechtice v Jizersk\xfdch hor\xe1ch",
        townCode: 563528,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46843,
        lat: 50.7624,
        long: 15.275813
    },
    {
        town: "Albrechti\u010Dky",
        townCode: 568741,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74255,
        lat: 49.70179,
        long: 18.095627
    },
    {
        town: 'Alojzov',
        townCode: 506761,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79804,
        lat: 49.423541,
        long: 17.041589
    },
    {
        town: "And\u011Blsk\xe1 Hora",
        townCode: 538001,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36471,
        lat: 50.20449,
        long: 12.962918
    },
    {
        town: "And\u011Blsk\xe1 Hora",
        townCode: 551929,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79331,
        lat: 50.060911,
        long: 17.389192
    },
    {
        town: "Anensk\xe1 Stud\xe1nka",
        townCode: 573426,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.849856,
        long: 16.54033
    },
    {
        town: 'Archlebov',
        townCode: 586030,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69633,
        lat: 49.043689,
        long: 17.004911
    },
    {
        town: "Arne\u0161tovice",
        townCode: 509388,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.53161,
        long: 15.117873
    },
    {
        town: 'Arnolec',
        townCode: 586854,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.436298,
        long: 15.823702
    },
    {
        town: 'Arnoltice',
        townCode: 562343,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40714,
        lat: 50.837124,
        long: 14.264055
    },
    {
        town: "A\u0161",
        townCode: 554499,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35201,
        lat: 50.223983,
        long: 12.195113
    },
    {
        town: 'Babice',
        townCode: 537241,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.024865,
        long: 14.237677
    },
    {
        town: 'Babice',
        townCode: 590274,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.135413,
        long: 15.770586
    },
    {
        town: 'Babice',
        townCode: 569828,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.192196,
        long: 15.585617
    },
    {
        town: 'Babice',
        townCode: 552356,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.737929,
        long: 17.260966
    },
    {
        town: 'Babice',
        townCode: 538043,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 50.008089,
        long: 14.715907
    },
    {
        town: 'Babice',
        townCode: 592013,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68703,
        lat: 49.123859,
        long: 17.476827
    },
    {
        town: 'Babice nad Svitavou',
        townCode: 582794,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66401,
        lat: 49.283402,
        long: 16.696235
    },
    {
        town: 'Babice u Rosic',
        townCode: 582808,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.173078,
        long: 16.358273
    },
    {
        town: 'Babylon',
        townCode: 553433,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.398761,
        long: 12.862893
    },
    {
        town: "B\xe1covice",
        townCode: 561118,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.455771,
        long: 15.158118
    },
    {
        town: "Ba\u010Dalky",
        townCode: 553701,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.385047,
        long: 15.15353
    },
    {
        town: "Ba\u010Det\xedn",
        townCode: 576085,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.299877,
        long: 16.233416
    },
    {
        town: "Ba\u010Dice",
        townCode: 590282,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.081736,
        long: 16.027802
    },
    {
        town: "Ba\u010Dkov",
        townCode: 546194,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.735384,
        long: 15.462118
    },
    {
        town: "Ba\u010Dkovice",
        townCode: 544833,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.965699,
        long: 15.589
    },
    {
        town: 'Bakov nad Jizerou',
        townCode: 535427,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29401,
        lat: 50.482406,
        long: 14.941596
    },
    {
        town: 'Baliny',
        townCode: 595217,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.332666,
        long: 15.952501
    },
    {
        town: 'Balkova Lhota',
        townCode: 563251,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.452124,
        long: 14.608319
    },
    {
        town: "Ban\xedn",
        townCode: 572560,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.665712,
        long: 16.46203
    },
    {
        town: "B\xe1nov",
        townCode: 592021,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68754,
        lat: 48.988113,
        long: 17.717631
    },
    {
        town: "B\xe1\u0148ovice",
        townCode: 562726,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.011855,
        long: 15.49034
    },
    {
        town: 'Bantice',
        townCode: 593729,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.883187,
        long: 16.182493
    },
    {
        town: 'Barchov',
        townCode: 569836,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.197698,
        long: 15.56774
    },
    {
        town: 'Barchov',
        townCode: 574724,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.999411,
        long: 15.68091
    },
    {
        town: 'Barchovice',
        townCode: 533173,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.944355,
        long: 14.969206
    },
    {
        town: "Barto\u0161ovice",
        townCode: 599212,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74254,
        lat: 49.66894,
        long: 18.054715
    },
    {
        town: "Barto\u0161ovice v Orlick\xfdch hor\xe1ch",
        townCode: 576093,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51761,
        lat: 50.16408,
        long: 16.547862
    },
    {
        town: "Bartou\u0161ov",
        townCode: 548260,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.601128,
        long: 15.618547
    },
    {
        town: "Ba\u0159ice-Velk\xe9 T\u011B\u0161any",
        townCode: 588300,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.245527,
        long: 17.426201
    },
    {
        town: "Ba\u0161ka",
        townCode: 598011,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73901,
        lat: 49.645943,
        long: 18.372443
    },
    {
        town: "Ba\u0161nice",
        townCode: 572667,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.334576,
        long: 15.605129
    },
    {
        town: "Ba\u0161\u0165",
        townCode: 538051,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25065,
        lat: 50.205242,
        long: 14.477405
    },
    {
        town: 'Batelov',
        townCode: 586862,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.290179,
        long: 15.410734
    },
    {
        town: "Bat\u0148ovice",
        townCode: 579041,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54237,
        lat: 50.517692,
        long: 16.03674
    },
    {
        town: 'Bavorov',
        townCode: 550809,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.121951,
        long: 14.079028
    },
    {
        town: 'Bavory',
        townCode: 584304,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69201,
        lat: 48.834789,
        long: 16.622349
    },
    {
        town: "Bavoryn\u011B",
        townCode: 534421,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.895907,
        long: 13.961126
    },
    {
        town: "Bden\u011Bves",
        townCode: 566756,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33032,
        lat: 49.76964,
        long: 13.235291
    },
    {
        town: "Bd\xedn",
        townCode: 565423,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.214245,
        long: 13.858851
    },
    {
        town: "Be\u010Dice",
        townCode: 536156,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.215784,
        long: 14.501318
    },
    {
        town: "Be\u010Dice",
        townCode: 563366,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39175,
        lat: 49.381437,
        long: 14.539787
    },
    {
        town: "Be\u010Dov",
        townCode: 567043,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43526,
        lat: 50.449824,
        long: 13.717955
    },
    {
        town: "Be\u010Dov nad Teplou",
        townCode: 554995,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36464,
        lat: 50.083561,
        long: 12.838429
    },
    {
        town: "Be\u010Dv\xe1ry",
        townCode: 533181,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28143,
        lat: 49.956809,
        long: 15.079916
    },
    {
        town: "Bediho\u0161\u0165",
        townCode: 589268,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79821,
        lat: 49.448359,
        long: 17.166534
    },
    {
        town: "Bedn\xe1rec",
        townCode: 562548,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.195339,
        long: 15.093296
    },
    {
        town: "Bedn\xe1re\u010Dek",
        townCode: 561053,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.210179,
        long: 15.144034
    },
    {
        town: "Bed\u0159ichov",
        townCode: 581313,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.461276,
        long: 16.465422
    },
    {
        town: "Bed\u0159ichov",
        townCode: 563536,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46812,
        lat: 50.791188,
        long: 15.142571
    },
    {
        town: "B\u011Bha\u0159ov",
        townCode: 541842,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.344879,
        long: 13.160291
    },
    {
        town: "B\u011Bha\u0159ovice",
        townCode: 593737,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67139,
        lat: 49.004036,
        long: 16.078723
    },
    {
        town: "B\u011Bchary",
        townCode: 572675,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.31413,
        long: 15.292617
    },
    {
        town: "Bechl\xedn",
        townCode: 564575,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41186,
        lat: 50.416252,
        long: 14.341026
    },
    {
        town: "Bechyn\u011B",
        townCode: 552054,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.295336,
        long: 14.468202
    },
    {
        town: "B\u011Bl\xe1",
        townCode: 573566,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.754546,
        long: 15.240686
    },
    {
        town: "B\u011Bl\xe1",
        townCode: 561126,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.312617,
        long: 15.260715
    },
    {
        town: "B\u011Bl\xe1",
        townCode: 576972,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.534417,
        long: 15.445427
    },
    {
        town: "B\u011Bl\xe1",
        townCode: 512974,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74723,
        lat: 49.972429,
        long: 18.144995
    },
    {
        town: "B\u011Bl\xe1 nad Radbuzou",
        townCode: 553441,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34526,
        lat: 49.591261,
        long: 12.717718
    },
    {
        town: "B\u011Bl\xe1 nad Svitavou",
        townCode: 572586,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56905,
        lat: 49.640287,
        long: 16.482734
    },
    {
        town: "B\u011Bl\xe1 pod Bezd\u011Bzem",
        townCode: 535443,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29421,
        lat: 50.501314,
        long: 14.80429
    },
    {
        town: "B\u011Bl\xe1 pod Prad\u011Bdem",
        townCode: 523917,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79001,
        lat: 50.164036,
        long: 17.196677
    },
    {
        town: "B\u011Bl\xe1 u Jev\xed\u010Dka",
        townCode: 505391,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.639593,
        long: 16.646009
    },
    {
        town: "B\u011Bl\u010Dice",
        townCode: 550817,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38743,
        lat: 49.502517,
        long: 13.875856
    },
    {
        town: "B\u011Ble\u010D",
        townCode: 560448,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.543779,
        long: 14.837357
    },
    {
        town: "B\u011Ble\u010D",
        townCode: 581321,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.434036,
        long: 16.383235
    },
    {
        town: "B\u011Ble\u010D",
        townCode: 535010,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27363,
        lat: 50.056269,
        long: 13.993082
    },
    {
        town: "B\u011Ble\u010D nad Orlic\xed",
        townCode: 569852,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.198081,
        long: 15.942805
    },
    {
        town: "B\u011Blkovice-La\u0161\u0165any",
        townCode: 500526,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78316,
        lat: 49.668757,
        long: 17.317289
    },
    {
        town: "B\u011Bloky",
        townCode: 532070,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27353,
        lat: 50.131539,
        long: 14.220862
    },
    {
        town: "B\u011Blot\xedn",
        townCode: 512231,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75364,
        lat: 49.5913,
        long: 17.806648
    },
    {
        town: "B\u011Blov",
        townCode: 588318,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.21609,
        long: 17.484879
    },
    {
        town: "B\u011Blu\u0161ice",
        townCode: 533190,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.069172,
        long: 15.322001
    },
    {
        town: "B\u011Blu\u0161ice",
        townCode: 567051,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.449262,
        long: 13.762928
    },
    {
        town: "Ben\xe1tky",
        townCode: 569861,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.310292,
        long: 15.736096
    },
    {
        town: "Ben\xe1tky",
        townCode: 577774,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.854287,
        long: 16.326847
    },
    {
        town: "Ben\xe1tky nad Jizerou",
        townCode: 535451,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29471,
        lat: 50.289261,
        long: 14.824612
    },
    {
        town: 'Benecko',
        townCode: 576981,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51237,
        lat: 50.666433,
        long: 15.548272
    },
    {
        town: "Bene\u0161ov",
        townCode: 581330,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67953,
        lat: 49.509531,
        long: 16.770698
    },
    {
        town: "Bene\u0161ov",
        townCode: 529303,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.783882,
        long: 14.68747
    },
    {
        town: "Bene\u0161ov nad \u010Cernou",
        townCode: 545406,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38282,
        lat: 48.729507,
        long: 14.627471
    },
    {
        town: "Bene\u0161ov nad Plou\u010Dnic\xed",
        townCode: 562351,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40722,
        lat: 50.741692,
        long: 14.3125
    },
    {
        town: "Bene\u0161ov u Semil",
        townCode: 576999,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51206,
        lat: 50.603258,
        long: 15.368478
    },
    {
        town: "Bene\u0161ovice",
        townCode: 560723,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.726964,
        long: 12.901799
    },
    {
        town: 'Benetice',
        townCode: 590304,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67506,
        lat: 49.297738,
        long: 15.867436
    },
    {
        town: "Be\u0148ov",
        townCode: 512281,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.41746,
        long: 17.501452
    },
    {
        town: 'Bernardov',
        townCode: 531111,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 50.014231,
        long: 15.398668
    },
    {
        town: 'Bernartice',
        townCode: 549266,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.368999,
        long: 14.381118
    },
    {
        town: 'Bernartice',
        townCode: 579050,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54204,
        lat: 50.644783,
        long: 15.965926
    },
    {
        town: 'Bernartice',
        townCode: 524891,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79057,
        lat: 50.389907,
        long: 17.078379
    },
    {
        town: 'Bernartice',
        townCode: 532568,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.675666,
        long: 15.129249
    },
    {
        town: 'Bernartice nad Odrou',
        townCode: 568481,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74101,
        lat: 49.610207,
        long: 17.947885
    },
    {
        town: 'Beroun',
        townCode: 531057,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 49.967305,
        long: 14.086384
    },
    {
        town: "B\u011Brunice",
        townCode: 537021,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28908,
        lat: 50.185843,
        long: 15.333694
    },
    {
        town: "Be\u0159ovice",
        townCode: 532088,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27371,
        lat: 50.269119,
        long: 14.12366
    },
    {
        town: 'Besednice',
        townCode: 545414,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38281,
        lat: 48.790089,
        long: 14.556987
    },
    {
        town: "B\u011Bstovice",
        townCode: 553760,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.020237,
        long: 16.211026
    },
    {
        town: "B\u011Bstvina",
        townCode: 571181,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53845,
        lat: 49.837134,
        long: 15.595868
    },
    {
        town: "B\u011B\u0161iny",
        townCode: 555797,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.301709,
        long: 13.312677
    },
    {
        town: "B\u011B\u0161t\xedn",
        townCode: 531073,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.807406,
        long: 14.01634
    },
    {
        town: "Bezd\u011B\u010D\xed u Trn\xe1vky",
        townCode: 574309,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.692503,
        long: 16.763539
    },
    {
        town: "Bezd\u011Bdovice",
        townCode: 598895,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.444294,
        long: 13.880068
    },
    {
        town: "Bezd\u011Bkov",
        townCode: 548430,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.732931,
        long: 15.730501
    },
    {
        town: "Bezd\u011Bkov",
        townCode: 574741,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.008869,
        long: 15.644768
    },
    {
        town: "Bezd\u011Bkov",
        townCode: 555801,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.3795,
        long: 13.297971
    },
    {
        town: "Bezd\u011Bkov",
        townCode: 541095,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.824389,
        long: 13.596645
    },
    {
        town: "Bezd\u011Bkov nad Metuj\xed",
        townCode: 573884,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54964,
        lat: 50.509838,
        long: 16.229341
    },
    {
        town: "Bezd\u011Bkov pod T\u0159em\u0161\xednem",
        townCode: 529672,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.577203,
        long: 13.878564
    },
    {
        town: "Bezd\u011Bz",
        townCode: 561398,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.533742,
        long: 14.722084
    },
    {
        town: "Bezdru\u017Eice",
        townCode: 560740,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34953,
        lat: 49.906771,
        long: 12.971351
    },
    {
        town: 'Bezkov',
        townCode: 593745,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.871321,
        long: 15.951352
    },
    {
        town: "Bezm\u011Brov",
        townCode: 588326,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.329903,
        long: 17.334894
    },
    {
        town: 'Bezno',
        townCode: 535478,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29429,
        lat: 50.367388,
        long: 14.795726
    },
    {
        town: 'Bezuchov',
        townCode: 512401,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.462827,
        long: 17.608881
    },
    {
        town: "Bezv\u011Brov",
        townCode: 558656,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33041,
        lat: 49.995118,
        long: 13.059113
    },
    {
        town: "B\xedl\xe1",
        townCode: 563901,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46343,
        lat: 50.664931,
        long: 15.035522
    },
    {
        town: "B\xedl\xe1",
        townCode: 598020,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73915,
        lat: 49.442171,
        long: 18.453037
    },
    {
        town: "B\xedl\xe1 Hl\xedna",
        townCode: 565750,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.532604,
        long: 14.925357
    },
    {
        town: "B\xedl\xe1 Lhota",
        townCode: 500623,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78321,
        lat: 49.709629,
        long: 16.97518
    },
    {
        town: "B\xedl\xe1 T\u0159eme\u0161n\xe1",
        townCode: 579068,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54472,
        lat: 50.444749,
        long: 15.74112
    },
    {
        town: "B\xedl\xe1 Voda",
        townCode: 525227,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79069,
        lat: 50.442133,
        long: 16.916515
    },
    {
        town: "B\xedl\u010Dice",
        townCode: 597198,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79368,
        lat: 49.869715,
        long: 17.565611
    },
    {
        town: "B\xedl\xe9 Podol\xed",
        townCode: 533971,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28572,
        lat: 49.956586,
        long: 15.491127
    },
    {
        town: "B\xedl\xe9 Poli\u010Dany",
        townCode: 579076,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54452,
        lat: 50.390894,
        long: 15.731985
    },
    {
        town: "B\xedlence",
        townCode: 562980,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.424657,
        long: 13.50601
    },
    {
        town: "B\xedlichov",
        townCode: 535125,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.262151,
        long: 13.916459
    },
    {
        town: "B\xedlina",
        townCode: 567451,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41801,
        lat: 50.548647,
        long: 13.775459
    },
    {
        town: "B\xedlkovice",
        townCode: 530743,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.759822,
        long: 14.861056
    },
    {
        town: "B\xedlov",
        townCode: 546984,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74301,
        lat: 49.73417,
        long: 18.001712
    },
    {
        town: "B\xedlov",
        townCode: 530239,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 50.017964,
        long: 13.42495
    },
    {
        town: "B\xedlovec",
        townCode: 599247,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74301,
        lat: 49.756486,
        long: 18.015919
    },
    {
        town: "B\xedlovice",
        townCode: 592030,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.099749,
        long: 17.549716
    },
    {
        town: "B\xedlovice nad Svitavou",
        townCode: 582824,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66401,
        lat: 49.247178,
        long: 16.672575
    },
    {
        town: "B\xedlovice-Lutot\xedn",
        townCode: 589276,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79841,
        lat: 49.511097,
        long: 17.043319
    },
    {
        town: "B\xedlsko",
        townCode: 550833,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.159145,
        long: 14.059108
    },
    {
        town: "B\xedlsko",
        townCode: 552062,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.644661,
        long: 17.019776
    },
    {
        town: "B\xedlsko u Ho\u0159ic",
        townCode: 548901,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.369489,
        long: 15.600604
    },
    {
        town: "B\xedl\xfd K\xe1men",
        townCode: 586889,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58841,
        lat: 49.417417,
        long: 15.560205
    },
    {
        town: "B\xedl\xfd Kostel nad Nisou",
        townCode: 563919,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46331,
        lat: 50.823246,
        long: 14.924507
    },
    {
        town: "B\xedl\xfd Potok",
        townCode: 546631,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46362,
        lat: 50.873842,
        long: 15.222203
    },
    {
        town: "B\xedl\xfd \xdajezd",
        townCode: 576107,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.238541,
        long: 16.22537
    },
    {
        town: "Bi\u0159kov",
        townCode: 578088,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.518156,
        long: 13.230256
    },
    {
        town: 'Biskoupky',
        townCode: 582832,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.097789,
        long: 16.281386
    },
    {
        town: 'Biskupice',
        townCode: 589284,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79812,
        lat: 49.459774,
        long: 17.236699
    },
    {
        town: 'Biskupice',
        townCode: 573949,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.872861,
        long: 15.512907
    },
    {
        town: 'Biskupice',
        townCode: 572519,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.647572,
        long: 16.758148
    },
    {
        town: 'Biskupice',
        townCode: 585076,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76341,
        lat: 49.083208,
        long: 17.710527
    },
    {
        town: 'Biskupice-Pulkov',
        townCode: 590312,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67558,
        lat: 49.038255,
        long: 16.009555
    },
    {
        town: "B\xedtouchov",
        townCode: 535486,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29401,
        lat: 50.475882,
        long: 14.889523
    },
    {
        town: "B\xedtov",
        townCode: 593753,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67110,
        lat: 48.936395,
        long: 15.729075
    },
    {
        town: "B\xedtov",
        townCode: 554936,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74301,
        lat: 49.800422,
        long: 18.047592
    },
    {
        town: "B\xedtovany",
        townCode: 505005,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.897307,
        long: 15.86473
    },
    {
        town: "B\xedtov\u010Dice",
        townCode: 586897,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58822,
        lat: 49.368136,
        long: 15.734153
    },
    {
        town: 'Bitozeves',
        townCode: 565997,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.37326,
        long: 13.640793
    },
    {
        town: "Blann\xe9",
        townCode: 593761,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 48.992037,
        long: 15.883346
    },
    {
        town: 'Blansko',
        townCode: 581283,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67801,
        lat: 49.36495,
        long: 16.647855
    },
    {
        town: 'Blatce',
        townCode: 561401,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.502986,
        long: 14.603251
    },
    {
        town: 'Blatec',
        townCode: 500801,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78375,
        lat: 49.528444,
        long: 17.238673
    },
    {
        town: "Blatn\xe1",
        townCode: 550850,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.424993,
        long: 13.881864
    },
    {
        town: 'Blatnice',
        townCode: 590321,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.070235,
        long: 15.871431
    },
    {
        town: 'Blatnice',
        townCode: 558672,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33025,
        lat: 49.719824,
        long: 13.156096
    },
    {
        town: "Blatnice pod Svat\xfdm Anton\xednkem",
        townCode: 586048,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69671,
        lat: 48.946824,
        long: 17.466069
    },
    {
        town: "Blatni\u010Dka",
        townCode: 586056,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69671,
        lat: 48.935609,
        long: 17.530151
    },
    {
        town: 'Blatno',
        townCode: 562998,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.511799,
        long: 13.358172
    },
    {
        town: 'Blatno',
        townCode: 566004,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43984,
        lat: 50.097026,
        long: 13.389809
    },
    {
        town: 'Blazice',
        townCode: 542318,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.44257,
        long: 17.645401
    },
    {
        town: "Bla\u017Eejov",
        townCode: 561711,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37852,
        lat: 49.142295,
        long: 15.096553
    },
    {
        town: "Bla\u017Eejovice",
        townCode: 532380,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.619897,
        long: 15.200036
    },
    {
        town: "Bla\u017Eim",
        townCode: 566764,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33038,
        lat: 49.916024,
        long: 13.047724
    },
    {
        town: "Bla\u017Eim",
        townCode: 566012,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.40695,
        long: 13.628683
    },
    {
        town: "Bla\u017Ekov",
        townCode: 595241,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.473174,
        long: 16.185267
    },
    {
        town: "Bla\u017Eovice",
        townCode: 582841,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66408,
        lat: 49.165785,
        long: 16.786216
    },
    {
        town: "Ble\u0161no",
        townCode: 569879,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.214011,
        long: 15.930746
    },
    {
        town: 'Blevice',
        townCode: 532100,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27328,
        lat: 50.209825,
        long: 14.236267
    },
    {
        town: "Bl\xedzkov",
        townCode: 595250,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59442,
        lat: 49.400584,
        long: 15.90881
    },
    {
        town: "Bl\xed\u017Eejov",
        townCode: 553450,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34545,
        lat: 49.500115,
        long: 12.989366
    },
    {
        town: "Bl\xed\u017Eevedly",
        townCode: 561410,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47104,
        lat: 50.608503,
        long: 14.396598
    },
    {
        town: "Bl\xed\u017Ekovice",
        townCode: 593770,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67155,
        lat: 48.999862,
        long: 15.834918
    },
    {
        town: 'Blovice',
        townCode: 557587,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.582303,
        long: 13.540199
    },
    {
        town: "Bl\u0161any",
        townCode: 566021,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43988,
        lat: 50.217441,
        long: 13.471313
    },
    {
        town: "Bl\u0161any u Loun",
        townCode: 542547,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.347086,
        long: 13.852757
    },
    {
        town: "Blu\u010Dina",
        townCode: 582859,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66456,
        lat: 49.055066,
        long: 16.644601
    },
    {
        town: 'Bludov',
        townCode: 525588,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78961,
        lat: 49.941116,
        long: 16.928111
    },
    {
        town: 'Bludov',
        townCode: 530964,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.807592,
        long: 15.255286
    },
    {
        town: 'Bobnice',
        townCode: 537039,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28931,
        lat: 50.219681,
        long: 15.053622
    },
    {
        town: "Bobrov\xe1",
        townCode: 595268,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.482402,
        long: 16.118399
    },
    {
        town: "Bobr\u016Fvka",
        townCode: 595276,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.44874,
        long: 16.093912
    },
    {
        town: 'Bocanovice',
        townCode: 511633,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73991,
        lat: 49.569174,
        long: 18.738514
    },
    {
        town: "Boh\xe1\u0148ka",
        townCode: 572705,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.365894,
        long: 15.708485
    },
    {
        town: "Boharyn\u011B",
        townCode: 569887,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50323,
        lat: 50.203911,
        long: 15.630961
    },
    {
        town: "Bohat\xe9 M\xe1lkovice",
        townCode: 592897,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.189126,
        long: 17.014284
    },
    {
        town: 'Bohatice',
        townCode: 561428,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47002,
        lat: 50.669033,
        long: 14.679426
    },
    {
        town: 'Bohdalec',
        townCode: 595284,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.474379,
        long: 16.05987
    },
    {
        town: 'Bohdalice-Pavlovice',
        townCode: 592901,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68341,
        lat: 49.214143,
        long: 17.030228
    },
    {
        town: "Bohdal\xedn",
        townCode: 547549,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39491,
        lat: 49.307781,
        long: 15.015943
    },
    {
        town: 'Bohdalov',
        townCode: 595292,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59213,
        lat: 49.480764,
        long: 15.876542
    },
    {
        town: 'Bohdalovice',
        townCode: 536253,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38101,
        lat: 48.74294,
        long: 14.286864
    },
    {
        town: "Bohdane\u010D",
        townCode: 533980,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28525,
        lat: 49.778273,
        long: 15.222656
    },
    {
        town: "Bohda\u0161\xedn",
        townCode: 576115,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.338561,
        long: 16.225153
    },
    {
        town: "Bohd\xedkov",
        townCode: 525804,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78964,
        lat: 50.010058,
        long: 16.904438
    },
    {
        town: 'Bohostice',
        townCode: 564559,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.602243,
        long: 14.138233
    },
    {
        town: 'Bohumilice',
        townCode: 550116,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.09618,
        long: 13.816441
    },
    {
        town: "Bohum\xedn",
        townCode: 599051,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73581,
        lat: 49.904426,
        long: 18.357074
    },
    {
        town: 'Bohunice',
        townCode: 537527,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.132496,
        long: 13.973287
    },
    {
        town: "Bohu\u0148ov",
        townCode: 595306,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.560508,
        long: 16.202547
    },
    {
        town: "Bohu\u0148ov",
        townCode: 577812,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.599198,
        long: 16.463955
    },
    {
        town: "Bohu\u0148ovice",
        townCode: 500852,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78314,
        lat: 49.663112,
        long: 17.287037
    },
    {
        town: "Bohu\u0148ovice",
        townCode: 577821,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.907982,
        long: 16.262964
    },
    {
        town: 'Bohuslavice',
        townCode: 586901,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.14953,
        long: 15.575917
    },
    {
        town: 'Bohuslavice',
        townCode: 573892,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54906,
        lat: 50.312731,
        long: 16.088688
    },
    {
        town: 'Bohuslavice',
        townCode: 506192,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74719,
        lat: 49.942415,
        long: 18.128764
    },
    {
        town: 'Bohuslavice',
        townCode: 589292,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79856,
        lat: 49.620952,
        long: 16.957654
    },
    {
        town: 'Bohuslavice',
        townCode: 525880,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78972,
        lat: 49.826153,
        long: 16.940636
    },
    {
        town: "Bohuslavice nad Vl\xe1\u0159\xed",
        townCode: 557102,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.090273,
        long: 17.926421
    },
    {
        town: "Bohuslavice u Zl\xedna",
        townCode: 585092,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76351,
        lat: 49.163201,
        long: 17.636864
    },
    {
        town: "Bohusl\xe1vky",
        townCode: 569178,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.555256,
        long: 17.567886
    },
    {
        town: "Bohu\u0161ice",
        townCode: 550400,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.085207,
        long: 15.852226
    },
    {
        town: "Bohu\u0161ov",
        townCode: 597201,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.243389,
        long: 17.713963
    },
    {
        town: "Bohu\u0161ovice nad Oh\u0159\xed",
        townCode: 564591,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41156,
        lat: 50.493264,
        long: 14.150595
    },
    {
        town: 'Bohutice',
        townCode: 593788,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67176,
        lat: 48.991375,
        long: 16.357739
    },
    {
        town: "Bohut\xedn",
        townCode: 525979,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78962,
        lat: 49.953611,
        long: 16.882039
    },
    {
        town: "Bohut\xedn",
        townCode: 539953,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26241,
        lat: 49.65562,
        long: 13.943995
    },
    {
        town: 'Bohy',
        townCode: 566471,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.937892,
        long: 13.575531
    },
    {
        town: "Bocho\u0159",
        townCode: 512532,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.421475,
        long: 17.428459
    },
    {
        town: 'Bochov',
        townCode: 555029,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36471,
        lat: 50.151007,
        long: 13.045282
    },
    {
        town: 'Bochovice',
        townCode: 590347,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.320924,
        long: 15.896424
    },
    {
        town: 'Bojanov',
        townCode: 571202,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53826,
        lat: 49.841414,
        long: 15.704985
    },
    {
        town: 'Bojanovice',
        townCode: 593796,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.968259,
        long: 15.989159
    },
    {
        town: 'Bojanovice',
        townCode: 539104,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25206,
        lat: 49.854542,
        long: 14.352145
    },
    {
        town: "Boji\u0161t\u011B",
        townCode: 568457,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.667888,
        long: 15.286899
    },
    {
        town: 'Bojkovice',
        townCode: 592048,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68771,
        lat: 49.038744,
        long: 17.814983
    },
    {
        town: 'Bolatice',
        townCode: 506214,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74723,
        lat: 49.951819,
        long: 18.08369
    },
    {
        town: "Bolebo\u0159",
        townCode: 563005,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43121,
        lat: 50.540271,
        long: 13.413447
    },
    {
        town: "Boleho\u0161\u0165",
        townCode: 576123,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51731,
        lat: 50.213724,
        long: 16.077076
    },
    {
        town: 'Boleradice',
        townCode: 584321,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69112,
        lat: 48.966776,
        long: 16.814026
    },
    {
        town: "Bole\u0161iny",
        townCode: 555835,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.410002,
        long: 13.361712
    },
    {
        town: "Boletice (vojensk\xfd \xfajezd)",
        townCode: 545422,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38229,
        lat: 48.824975,
        long: 14.217435
    },
    {
        town: 'Bolkov',
        townCode: 540463,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.533675,
        long: 13.223973
    },
    {
        town: "Bo\u0148kov",
        townCode: 573558,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58255,
        lat: 49.54715,
        long: 15.447573
    },
    {
        town: 'Bor',
        townCode: 560758,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34802,
        lat: 49.711706,
        long: 12.775276
    },
    {
        town: "Bor u Skut\u010De",
        townCode: 547867,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.822412,
        long: 16.127052
    },
    {
        town: "Bora\u010D",
        townCode: 595314,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59261,
        lat: 49.400915,
        long: 16.361217
    },
    {
        town: 'Bordovice',
        townCode: 568431,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74401,
        lat: 49.546979,
        long: 18.152729
    },
    {
        town: "Bore\u010D",
        townCode: 535508,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29426,
        lat: 50.407453,
        long: 14.732498
    },
    {
        town: 'Borek',
        townCode: 544272,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37367,
        lat: 49.023491,
        long: 14.500984
    },
    {
        town: 'Borek',
        townCode: 568465,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.791915,
        long: 15.590083
    },
    {
        town: 'Borek',
        townCode: 548979,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.438962,
        long: 15.654346
    },
    {
        town: 'Borek',
        townCode: 574783,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.127301,
        long: 15.856639
    },
    {
        town: 'Borek',
        townCode: 534684,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.222684,
        long: 14.647521
    },
    {
        town: 'Borkovany',
        townCode: 584339,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69175,
        lat: 49.028264,
        long: 16.810211
    },
    {
        town: 'Borkovice',
        townCode: 552097,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.208048,
        long: 14.643532
    },
    {
        town: "Borohr\xe1dek",
        townCode: 576131,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51724,
        lat: 50.09787,
        long: 16.093365
    },
    {
        town: 'Borotice',
        townCode: 593800,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.857391,
        long: 16.242711
    },
    {
        town: 'Borotice',
        townCode: 539970,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26215,
        lat: 49.735072,
        long: 14.279808
    },
    {
        town: "Borot\xedn",
        townCode: 552101,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39135,
        lat: 49.505132,
        long: 14.61307
    },
    {
        town: "Borot\xedn",
        townCode: 581356,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67937,
        lat: 49.581447,
        long: 16.671585
    },
    {
        town: "Borov\xe1",
        townCode: 573906,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54701,
        lat: 50.386091,
        long: 16.253287
    },
    {
        town: "Borov\xe1",
        townCode: 577839,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56982,
        lat: 49.741782,
        long: 16.162337
    },
    {
        town: "Borov\xe1 Lada",
        townCode: 545902,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38492,
        lat: 48.989939,
        long: 13.659961
    },
    {
        town: 'Borovany',
        townCode: 544281,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37312,
        lat: 48.898704,
        long: 14.642367
    },
    {
        town: 'Borovany',
        townCode: 598780,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.343099,
        long: 14.392567
    },
    {
        town: "Borovn\xe1",
        townCode: 587184,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.164698,
        long: 15.394712
    },
    {
        town: 'Borovnice',
        townCode: 535681,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.912174,
        long: 14.519089
    },
    {
        town: 'Borovnice',
        townCode: 595322,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59242,
        lat: 49.667328,
        long: 16.202654
    },
    {
        town: 'Borovnice',
        townCode: 576140,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.063008,
        long: 16.245418
    },
    {
        town: 'Borovnice',
        townCode: 579092,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54477,
        lat: 50.509256,
        long: 15.617294
    },
    {
        town: 'Borovnice',
        townCode: 532096,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.648835,
        long: 15.018438
    },
    {
        town: "Borovni\u010Dka",
        townCode: 548821,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54475,
        lat: 50.500964,
        long: 15.667313
    },
    {
        town: "Borovn\xedk",
        townCode: 595331,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.355656,
        long: 16.229456
    },
    {
        town: 'Borovno',
        townCode: 566705,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33561,
        lat: 49.622087,
        long: 13.690481
    },
    {
        town: 'Borovy',
        townCode: 542156,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.525208,
        long: 13.302442
    },
    {
        town: "Bor\u0161ice",
        townCode: 592064,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68709,
        lat: 49.062643,
        long: 17.350953
    },
    {
        town: "Bor\u0161ice u Blatnice",
        townCode: 592056,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68763,
        lat: 48.934962,
        long: 17.571104
    },
    {
        town: "Bor\u0161ov",
        townCode: 586927,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.404043,
        long: 15.434297
    },
    {
        town: "Bor\u0161ov nad Vltavou",
        townCode: 544299,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37382,
        lat: 48.921882,
        long: 14.434092
    },
    {
        town: "Boru\u0161ov",
        townCode: 572632,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.780652,
        long: 16.740556
    },
    {
        town: 'Bory',
        townCode: 595641,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59461,
        lat: 49.425865,
        long: 16.026282
    },
    {
        town: "Bo\u0159anovice",
        townCode: 538086,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25065,
        lat: 50.178336,
        long: 14.478857
    },
    {
        town: "Bo\u0159enovice",
        townCode: 549690,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.361618,
        long: 17.564472
    },
    {
        town: "Bo\u0159etice",
        townCode: 584347,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69108,
        lat: 48.913124,
        long: 16.853168
    },
    {
        town: "Bo\u0159etice",
        townCode: 561240,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.496166,
        long: 15.11005
    },
    {
        town: "Bo\u0159et\xedn",
        townCode: 562742,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.189321,
        long: 15.211941
    },
    {
        town: "Bo\u0159et\xedn",
        townCode: 509418,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.310234,
        long: 14.947722
    },
    {
        town: "Bo\u0159ice",
        townCode: 571229,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.97695,
        long: 15.925435
    },
    {
        town: "Bo\u0159islav",
        townCode: 567469,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.579462,
        long: 13.929313
    },
    {
        town: "Bo\u0159itov",
        townCode: 581364,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.425135,
        long: 16.591291
    },
    {
        town: "Bose\u0148",
        townCode: 535516,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.504204,
        long: 15.022906
    },
    {
        town: 'Boskovice',
        townCode: 581372,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.487612,
        long: 16.660076
    },
    {
        town: "Boskov\u0161tejn",
        townCode: 593818,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 48.982797,
        long: 15.929654
    },
    {
        town: "Bo\u0161ice",
        townCode: 550124,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.089388,
        long: 13.840431
    },
    {
        town: "Bo\u0161ilec",
        townCode: 535401,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37365,
        lat: 49.149418,
        long: 14.646319
    },
    {
        town: "Bo\u0161\xedn",
        townCode: 548006,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.034233,
        long: 16.203069
    },
    {
        town: "Bo\u0161ovice",
        townCode: 592919,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68354,
        lat: 49.053609,
        long: 16.836868
    },
    {
        town: 'Boudy',
        townCode: 562122,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.448057,
        long: 14.035591
    },
    {
        town: "Bous\xedn",
        townCode: 589306,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79861,
        lat: 49.455207,
        long: 16.889847
    },
    {
        town: 'Bousov',
        townCode: 571237,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.901849,
        long: 15.535529
    },
    {
        town: 'Bouzov',
        townCode: 500861,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78325,
        lat: 49.704361,
        long: 16.892988
    },
    {
        town: 'Bozkov',
        townCode: 577006,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51213,
        lat: 50.640171,
        long: 15.337206
    },
    {
        town: "Bo\u017Eanov",
        townCode: 573914,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54974,
        lat: 50.526878,
        long: 16.365391
    },
    {
        town: "Bo\u017Eejov",
        townCode: 547581,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39461,
        lat: 49.362207,
        long: 15.155899
    },
    {
        town: "Bo\u017Eetice",
        townCode: 549291,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.45123,
        long: 14.444001
    },
    {
        town: "Bo\u017E\xed Dar",
        townCode: 506486,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.409844,
        long: 12.924571
    },
    {
        town: "Bo\u017Eice",
        townCode: 593826,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67164,
        lat: 48.836967,
        long: 16.288856
    },
    {
        town: "Bo\u017Ei\u010Dany",
        townCode: 555045,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36225,
        lat: 50.258843,
        long: 12.769752
    },
    {
        town: "Brad\xe1\u010Dov",
        townCode: 552127,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.490902,
        long: 14.871519
    },
    {
        town: "Brada-Rybn\xed\u010Dek",
        townCode: 549100,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.465297,
        long: 15.337606
    },
    {
        town: 'Bradlec',
        townCode: 570788,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29306,
        lat: 50.451452,
        long: 14.910293
    },
    {
        town: "Bradleck\xe1 Lhota",
        townCode: 577014,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 50713,
        lat: 50.488672,
        long: 15.396332
    },
    {
        town: 'Brambory',
        townCode: 530832,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.97825,
        long: 15.470316
    },
    {
        town: "Bra\u0148any",
        townCode: 567060,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43522,
        lat: 50.543055,
        long: 13.700283
    },
    {
        town: 'Brandov',
        townCode: 567078,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43547,
        lat: 50.63211,
        long: 13.390831
    },
    {
        town: "Brand\xfds nad Labem - Star\xe1 Boleslav",
        townCode: 538094,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25001,
        lat: 50.186426,
        long: 14.659344
    },
    {
        town: "Brand\xfds nad Orlic\xed",
        townCode: 579947,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56112,
        lat: 50.002042,
        long: 16.285384
    },
    {
        town: "Brand\xfdsek",
        townCode: 532118,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27341,
        lat: 50.18933,
        long: 14.162098
    },
    {
        town: 'Branice',
        townCode: 549304,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.402569,
        long: 14.33964
    },
    {
        town: "Bran\xed\u0161kov",
        townCode: 582875,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.294469,
        long: 16.345762
    },
    {
        town: "Brani\u0161ov",
        townCode: 551490,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.978807,
        long: 14.395791
    },
    {
        town: "Brani\u0161ovice",
        townCode: 593834,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67177,
        lat: 48.962911,
        long: 16.431951
    },
    {
        town: 'Branka u Opavy',
        townCode: 554197,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74741,
        lat: 49.888057,
        long: 17.882754
    },
    {
        town: 'Brankovice',
        townCode: 592927,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.156081,
        long: 17.134911
    },
    {
        town: 'Branky',
        townCode: 541648,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75645,
        lat: 49.461056,
        long: 17.89306
    },
    {
        town: "Brann\xe1",
        townCode: 526169,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78825,
        lat: 50.15336,
        long: 17.011954
    },
    {
        town: 'Branov',
        townCode: 541672,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.012981,
        long: 13.843021
    },
    {
        town: 'Bransouze',
        townCode: 590363,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.302776,
        long: 15.751924
    },
    {
        town: 'Brantice',
        townCode: 597210,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79393,
        lat: 50.063603,
        long: 17.629214
    },
    {
        town: "Bran\u017Ee\u017E",
        townCode: 571946,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29402,
        lat: 50.507685,
        long: 15.058005
    },
    {
        town: "Bra\u0161kov",
        townCode: 532126,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.102133,
        long: 14.100859
    },
    {
        town: "Brat\u010Dice",
        townCode: 582883,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66467,
        lat: 49.065247,
        long: 16.523184
    },
    {
        town: "Brat\u010Dice",
        townCode: 531286,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.855317,
        long: 15.430482
    },
    {
        town: 'Bratkovice',
        townCode: 539988,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.740519,
        long: 13.999043
    },
    {
        town: 'Bratronice',
        townCode: 537063,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.365361,
        long: 13.842454
    },
    {
        town: 'Bratronice',
        townCode: 532142,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27363,
        lat: 50.067851,
        long: 14.014265
    },
    {
        town: "Bratru\u0161ov",
        townCode: 569437,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78701,
        lat: 50.009487,
        long: 16.949028
    },
    {
        town: "Brat\u0159ejov",
        townCode: 585106,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.222558,
        long: 17.913427
    },
    {
        town: "Brat\u0159ice",
        townCode: 547603,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.516554,
        long: 15.001328
    },
    {
        town: "Brat\u0159\xedkovice",
        townCode: 553107,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74752,
        lat: 49.932674,
        long: 17.687641
    },
    {
        town: "Brat\u0159\xednov",
        townCode: 571199,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25205,
        lat: 49.842681,
        long: 14.340242
    },
    {
        town: 'Bravantice',
        townCode: 556858,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74281,
        lat: 49.757218,
        long: 18.082863
    },
    {
        town: "Br\xe1zdim",
        townCode: 538108,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.183633,
        long: 14.58829
    },
    {
        town: "Bra\u017Eec",
        townCode: 500101,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36471,
        lat: 50.172681,
        long: 13.046575
    },
    {
        town: "Brdy (vojensk\xfd \xfajezd)",
        townCode: 539996,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.789268,
        long: 13.903243
    },
    {
        town: 'Brloh',
        townCode: 545431,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38206,
        lat: 48.92998,
        long: 14.218667
    },
    {
        town: 'Brloh',
        townCode: 574791,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.000688,
        long: 15.557385
    },
    {
        town: "Br\u0148any",
        townCode: 564613,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.481073,
        long: 14.141967
    },
    {
        town: "Brn\u011Bnec",
        townCode: 577863,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.627449,
        long: 16.522125
    },
    {
        town: "Brn\xed\u010Dko",
        townCode: 530727,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78975,
        lat: 49.894982,
        long: 16.968308
    },
    {
        town: "Brn\xed\u0159ov",
        townCode: 566136,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.382698,
        long: 13.04969
    },
    {
        town: "Brni\u0161t\u011B",
        townCode: 561444,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47129,
        lat: 50.729288,
        long: 14.703495
    },
    {
        town: 'Brno',
        townCode: 582786,
        district: "Brno-m\u011Bsto",
        lau: 'CZ0642',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 60200,
        lat: 49.19516,
        long: 16.606937
    },
    {
        town: "Brod nad Dyj\xed",
        townCode: 584355,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69181,
        lat: 48.875309,
        long: 16.535482
    },
    {
        town: 'Brod nad Tichou',
        townCode: 541605,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.835396,
        long: 12.741203
    },
    {
        town: 'Brodce',
        townCode: 535559,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29473,
        lat: 50.33078,
        long: 14.86928
    },
    {
        town: 'Brodec',
        townCode: 546895,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.295025,
        long: 13.801725
    },
    {
        town: 'Brodek u Konice',
        townCode: 589314,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79846,
        lat: 49.548791,
        long: 16.83297
    },
    {
        town: "Brodek u Prost\u011Bjova",
        townCode: 589322,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79807,
        lat: 49.370064,
        long: 17.090164
    },
    {
        town: "Brodek u P\u0159erova",
        townCode: 512800,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.484289,
        long: 17.338354
    },
    {
        town: 'Brodeslavy',
        townCode: 566489,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.953778,
        long: 13.557097
    },
    {
        town: 'Broumov',
        townCode: 573922,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55001,
        lat: 50.585758,
        long: 16.331915
    },
    {
        town: 'Broumov',
        townCode: 541401,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.889478,
        long: 12.606805
    },
    {
        town: 'Broumy',
        townCode: 531081,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26742,
        lat: 49.955171,
        long: 13.852368
    },
    {
        town: "Brozany nad Oh\u0159\xed",
        townCode: 564621,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41181,
        lat: 50.453763,
        long: 14.145512
    },
    {
        town: 'Brtnice',
        townCode: 586943,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58832,
        lat: 49.307047,
        long: 15.676522
    },
    {
        town: "Brtni\u010Dka",
        townCode: 590371,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67527,
        lat: 49.237281,
        long: 15.624317
    },
    {
        town: "Br\u0165ov-Jene\u010D",
        townCode: 581381,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.413781,
        long: 16.517076
    },
    {
        town: 'Brumov',
        townCode: 581402,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.462484,
        long: 16.425856
    },
    {
        town: 'Brumov-Bylnice',
        townCode: 585114,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76331,
        lat: 49.092465,
        long: 18.022809
    },
    {
        town: 'Brumovice',
        townCode: 584363,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69111,
        lat: 48.960895,
        long: 16.89626
    },
    {
        town: 'Brumovice',
        townCode: 506320,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74771,
        lat: 50.015393,
        long: 17.749685
    },
    {
        town: "Brunt\xe1l",
        townCode: 597180,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.988277,
        long: 17.463794
    },
    {
        town: "Brusn\xe9",
        townCode: 588377,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.36344,
        long: 17.660807
    },
    {
        town: "Bru\u0161perk",
        townCode: 598038,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73944,
        lat: 49.700196,
        long: 18.222205
    },
    {
        town: 'Bruzovice',
        townCode: 598046,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73936,
        lat: 49.717092,
        long: 18.409749
    },
    {
        town: "Brz\xe1nky",
        townCode: 546755,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.461941,
        long: 14.301296
    },
    {
        town: 'Brzice',
        townCode: 573931,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.444489,
        long: 15.958411
    },
    {
        town: 'Brzkov',
        townCode: 586951,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.526068,
        long: 15.72724
    },
    {
        town: "B\u0159asy",
        townCode: 559725,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.837107,
        long: 13.578439
    },
    {
        town: "B\u0159eclav",
        townCode: 584291,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69002,
        lat: 48.75324,
        long: 16.882617
    },
    {
        town: "B\u0159ehov",
        townCode: 536059,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.022388,
        long: 14.330668
    },
    {
        town: "B\u0159ehy",
        townCode: 574805,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.051994,
        long: 15.577582
    },
    {
        town: "B\u0159est",
        townCode: 588385,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76823,
        lat: 49.351167,
        long: 17.440825
    },
    {
        town: "B\u0159estek",
        townCode: 592072,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68708,
        lat: 49.094985,
        long: 17.356023
    },
    {
        town: "B\u0159evnice",
        townCode: 548278,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.631361,
        long: 15.612697
    },
    {
        town: "B\u0159ezejc",
        townCode: 595349,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.346399,
        long: 16.091562
    },
    {
        town: "B\u0159ez\xed",
        townCode: 530018,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 26242,
        lat: 49.507873,
        long: 13.797583
    },
    {
        town: "B\u0159ez\xed",
        townCode: 584371,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69181,
        lat: 48.819377,
        long: 16.567583
    },
    {
        town: "B\u0159ez\xed",
        townCode: 595357,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.343279,
        long: 16.216045
    },
    {
        town: "B\u0159ez\xed",
        townCode: 564869,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 50.014766,
        long: 14.699389
    },
    {
        town: "B\u0159ez\xed nad Oslavou",
        townCode: 595365,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.502993,
        long: 15.935697
    },
    {
        town: "B\u0159ezina",
        townCode: 507733,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.290639,
        long: 14.90976
    },
    {
        town: "B\u0159ezina",
        townCode: 549070,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.434394,
        long: 15.313367
    },
    {
        town: "B\u0159ezina",
        townCode: 577871,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56923,
        lat: 49.651038,
        long: 16.619713
    },
    {
        town: "B\u0159ezina",
        townCode: 559733,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.807642,
        long: 13.596901
    },
    {
        town: "B\u0159ezina",
        townCode: 535567,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29411,
        lat: 50.548647,
        long: 15.032901
    },
    {
        town: "B\u0159ezina",
        townCode: 581429,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67905,
        lat: 49.282167,
        long: 16.755163
    },
    {
        town: "B\u0159ezina",
        townCode: 582891,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.281698,
        long: 16.749623
    },
    {
        town: "B\u0159ezina (vojensk\xfd \xfajezd)",
        townCode: 592935,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 79805,
        lat: 49.368199,
        long: 16.960939
    },
    {
        town: "B\u0159ezinky",
        townCode: 572250,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.662787,
        long: 16.78703
    },
    {
        town: "B\u0159eziny",
        townCode: 577898,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.690726,
        long: 16.118233
    },
    {
        town: "B\u0159eznice",
        townCode: 552135,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39171,
        lat: 49.251874,
        long: 14.514089
    },
    {
        town: "B\u0159eznice",
        townCode: 540013,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.557739,
        long: 13.950734
    },
    {
        town: "B\u0159eznice",
        townCode: 538744,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76001,
        lat: 49.184965,
        long: 17.656742
    },
    {
        town: "B\u0159ezn\xedk",
        townCode: 590380,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67574,
        lat: 49.172155,
        long: 16.194204
    },
    {
        town: "B\u0159ezno",
        townCode: 535583,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.406292,
        long: 15.005584
    },
    {
        town: "B\u0159ezno",
        townCode: 563013,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43145,
        lat: 50.40228,
        long: 13.420942
    },
    {
        town: "B\u0159ezolupy",
        townCode: 592081,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68713,
        lat: 49.121484,
        long: 17.580451
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 537870,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.197494,
        long: 12.870986
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 560294,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.145752,
        long: 12.643488
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 506451,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74744,
        lat: 49.791678,
        long: 17.865664
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 531090,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.904184,
        long: 13.883116
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 592099,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68767,
        lat: 48.922188,
        long: 17.742769
    },
    {
        town: "B\u0159ezov\xe1",
        townCode: 585131,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 48.923332,
        long: 17.741218
    },
    {
        town: "B\u0159ezov\xe1 nad Svitavou",
        townCode: 505145,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56902,
        lat: 49.644277,
        long: 16.518096
    },
    {
        town: "B\u0159ezov\xe1-Ole\u0161ko",
        townCode: 599735,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25245,
        lat: 49.904148,
        long: 14.411028
    },
    {
        town: "B\u0159ezovice",
        townCode: 599514,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29424,
        lat: 50.470818,
        long: 14.733711
    },
    {
        town: "B\u0159ezsk\xe9",
        townCode: 595381,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.330018,
        long: 16.238271
    },
    {
        town: "B\u0159ezsko",
        townCode: 589331,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.608693,
        long: 16.892539
    },
    {
        town: "B\u0159ez\u016Fvky",
        townCode: 585149,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76345,
        lat: 49.153427,
        long: 17.699728
    },
    {
        town: "B\u0159e\u017Eany",
        townCode: 593842,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67165,
        lat: 48.870023,
        long: 16.341852
    },
    {
        town: "B\u0159e\u017Eany",
        townCode: 541923,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.348864,
        long: 13.61746
    },
    {
        town: "B\u0159e\u017Eany",
        townCode: 565041,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27034,
        lat: 50.00696,
        long: 13.582896
    },
    {
        town: "B\u0159e\u017Eany I",
        townCode: 533211,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.035026,
        long: 15.079055
    },
    {
        town: "B\u0159e\u017Eany II",
        townCode: 533220,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.093862,
        long: 14.804403
    },
    {
        town: "B\u0159idli\u010Dn\xe1",
        townCode: 597228,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79351,
        lat: 49.911767,
        long: 17.371179
    },
    {
        town: "B\u0159\xedstv\xed",
        townCode: 537047,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28915,
        lat: 50.134028,
        long: 14.841845
    },
    {
        town: "B\u0159\xed\u0161\u0165any",
        townCode: 548855,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.316342,
        long: 15.620923
    },
    {
        town: "B\u0159\xedza",
        townCode: 564648,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.360615,
        long: 14.216366
    },
    {
        town: "B\u0159vany",
        townCode: 566063,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.401253,
        long: 13.721648
    },
    {
        town: 'Bublava',
        townCode: 560308,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.374494,
        long: 12.505287
    },
    {
        town: 'Bubovice',
        townCode: 531103,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.969761,
        long: 14.166601
    },
    {
        town: "Bu\u010D\xed",
        townCode: 558699,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.885275,
        long: 13.302879
    },
    {
        town: "Bu\u010Dina",
        townCode: 579963,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.896972,
        long: 16.192941
    },
    {
        town: "Bu\u010Dovice",
        townCode: 592943,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.149402,
        long: 17.003981
    },
    {
        town: "Bud\u010Deves",
        townCode: 548952,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.308573,
        long: 15.254641
    },
    {
        town: "Bude\u010D",
        townCode: 546020,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37892,
        lat: 49.087277,
        long: 15.589973
    },
    {
        town: "Bude\u010D",
        townCode: 595390,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.53647,
        long: 15.912421
    },
    {
        town: "Bud\u011Btice",
        townCode: 555894,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.283469,
        long: 13.58477
    },
    {
        town: "Bud\u011Btsko",
        townCode: 589349,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.587129,
        long: 16.92698
    },
    {
        town: "Bud\xedkov",
        townCode: 547638,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.579243,
        long: 15.362705
    },
    {
        town: "Budim\u011B\u0159ice",
        townCode: 537055,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.195426,
        long: 15.098869
    },
    {
        town: 'Budislav',
        townCode: 552143,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.293941,
        long: 14.837518
    },
    {
        town: 'Budislav',
        townCode: 577910,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56965,
        lat: 49.801511,
        long: 16.174739
    },
    {
        town: "Bud\xed\u0161kovice",
        townCode: 546038,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37891,
        lat: 49.076348,
        long: 15.531006
    },
    {
        town: "Budi\u0161ov",
        townCode: 590401,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.271484,
        long: 16.003938
    },
    {
        town: "Budi\u0161ov nad Budi\u0161ovkou",
        townCode: 506460,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74787,
        lat: 49.79521,
        long: 17.629792
    },
    {
        town: "Budi\u0161ovice",
        townCode: 568261,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74764,
        lat: 49.861418,
        long: 18.039719
    },
    {
        town: 'Budkov',
        townCode: 561576,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.070156,
        long: 14.007074
    },
    {
        town: 'Budkov',
        townCode: 590410,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67542,
        lat: 49.054591,
        long: 15.65903
    },
    {
        town: "Budyn\u011B",
        townCode: 560171,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.14606,
        long: 14.071176
    },
    {
        town: "Budyn\u011B nad Oh\u0159\xed",
        townCode: 564656,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41118,
        lat: 50.404377,
        long: 14.126018
    },
    {
        town: 'Buchlovice',
        townCode: 592102,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68708,
        lat: 49.086371,
        long: 17.338628
    },
    {
        town: 'Bujanov',
        townCode: 545449,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38241,
        lat: 48.702429,
        long: 14.429747
    },
    {
        town: 'Bujesily',
        townCode: 559741,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.914681,
        long: 13.574492
    },
    {
        town: 'Buk',
        townCode: 537519,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.038011,
        long: 13.845247
    },
    {
        town: 'Buk',
        townCode: 512826,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75121,
        lat: 49.504545,
        long: 17.468822
    },
    {
        town: 'Bukov',
        townCode: 595403,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.454403,
        long: 16.223666
    },
    {
        town: "Bukov\xe1",
        townCode: 589357,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79848,
        lat: 49.509838,
        long: 16.829233
    },
    {
        town: "Bukov\xe1",
        townCode: 546372,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33452,
        lat: 49.537495,
        long: 13.158861
    },
    {
        town: "Bukov\xe1 u P\u0159\xedbram\u011B",
        townCode: 540021,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.755238,
        long: 14.066683
    },
    {
        town: 'Bukovany',
        townCode: 586072,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69631,
        lat: 49.042267,
        long: 17.100961
    },
    {
        town: 'Bukovany',
        townCode: 560316,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35755,
        lat: 50.166437,
        long: 12.572766
    },
    {
        town: 'Bukovany',
        townCode: 552402,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.60536,
        long: 17.343594
    },
    {
        town: 'Bukovany',
        townCode: 532924,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25741,
        lat: 49.822898,
        long: 14.624388
    },
    {
        town: 'Bukovany',
        townCode: 564664,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.574617,
        long: 14.10264
    },
    {
        town: 'Bukovec',
        townCode: 511935,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73984,
        lat: 49.556686,
        long: 18.821553
    },
    {
        town: 'Bukovec',
        townCode: 553506,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.586461,
        long: 12.995414
    },
    {
        town: 'Bukovice',
        townCode: 581437,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.406829,
        long: 16.489825
    },
    {
        town: 'Bukovice',
        townCode: 547751,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54954,
        lat: 50.549647,
        long: 16.228038
    },
    {
        town: 'Bukovina',
        townCode: 581445,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67905,
        lat: 49.297608,
        long: 16.773268
    },
    {
        town: 'Bukovina nad Labem',
        townCode: 574813,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.12496,
        long: 15.823385
    },
    {
        town: "Bukovina u \u010Cist\xe9",
        townCode: 577031,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.542694,
        long: 15.58394
    },
    {
        town: "Bukovina u P\u0159elou\u010De",
        townCode: 574821,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.948338,
        long: 15.562977
    },
    {
        town: 'Bukovinka',
        townCode: 581453,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67905,
        lat: 49.294279,
        long: 16.805039
    },
    {
        town: 'Bukovka',
        townCode: 574830,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.101131,
        long: 15.625408
    },
    {
        town: "Bukovn\xedk",
        townCode: 530085,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.222588,
        long: 13.661427
    },
    {
        town: 'Bukovno',
        townCode: 535605,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.446863,
        long: 14.840687
    },
    {
        town: 'Bukvice',
        townCode: 573353,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.412586,
        long: 15.294637
    },
    {
        town: 'Bulhary',
        townCode: 584380,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69189,
        lat: 48.831565,
        long: 16.748843
    },
    {
        town: 'Bulovka',
        townCode: 563935,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.971244,
        long: 15.12367
    },
    {
        town: "Bu\u0159enice",
        townCode: 561312,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.552815,
        long: 15.066329
    },
    {
        town: "Bu\u0161",
        townCode: 540048,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25208,
        lat: 49.80341,
        long: 14.384043
    },
    {
        town: "Bu\u0161anovice",
        townCode: 550159,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.115542,
        long: 13.934788
    },
    {
        town: "Bu\u0161\xedn",
        townCode: 532894,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78962,
        lat: 49.976227,
        long: 16.837978
    },
    {
        town: "Bu\u0161ovice",
        townCode: 559750,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.795629,
        long: 13.534766
    },
    {
        town: "Bu\u0161t\u011Bhrad",
        townCode: 532169,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27343,
        lat: 50.156043,
        long: 14.189083
    },
    {
        town: 'Butoves',
        townCode: 549282,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.386551,
        long: 15.427515
    },
    {
        town: 'Buzice',
        townCode: 529966,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.42273,
        long: 13.932715
    },
    {
        town: "B\xfd\u010Dkovice",
        townCode: 546780,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.559879,
        long: 14.213625
    },
    {
        town: "B\xfdchory",
        townCode: 533238,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.067727,
        long: 15.273572
    },
    {
        town: "B\xfdkev",
        townCode: 534714,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27601,
        lat: 50.347271,
        long: 14.418129
    },
    {
        town: "Byko\u0161",
        townCode: 534145,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26701,
        lat: 49.883057,
        long: 14.063765
    },
    {
        town: "B\xfdkovice",
        townCode: 581461,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.430303,
        long: 16.538385
    },
    {
        town: "B\xfdkov-L\xe1ry\u0161ov",
        townCode: 569607,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79401,
        lat: 50.052449,
        long: 17.687486
    },
    {
        town: 'Bylany',
        townCode: 571245,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53801,
        lat: 49.957375,
        long: 15.733261
    },
    {
        town: 'Bynovec',
        townCode: 544647,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.820934,
        long: 14.264287
    },
    {
        town: "Bystr\xe1",
        townCode: 561801,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.50857,
        long: 15.371288
    },
    {
        town: "Bystr\xe1 nad Jizerou",
        townCode: 577049,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.604834,
        long: 15.401976
    },
    {
        town: "Bystr\xe9",
        townCode: 576166,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.321556,
        long: 16.255333
    },
    {
        town: "Bystr\xe9",
        townCode: 577928,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56992,
        lat: 49.628557,
        long: 16.346893
    },
    {
        town: "Bystro\u010Dice",
        townCode: 500879,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.536347,
        long: 17.193626
    },
    {
        town: 'Bystrovany',
        townCode: 547026,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.597116,
        long: 17.323754
    },
    {
        town: "Byst\u0159any",
        townCode: 567477,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41761,
        lat: 50.628776,
        long: 13.8643
    },
    {
        town: "Byst\u0159ec",
        townCode: 579971,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56154,
        lat: 50.011781,
        long: 16.619105
    },
    {
        town: "Byst\u0159ice",
        townCode: 572772,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.392983,
        long: 15.244218
    },
    {
        town: "Byst\u0159ice",
        townCode: 598062,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73995,
        lat: 49.63667,
        long: 18.720488
    },
    {
        town: "Byst\u0159ice",
        townCode: 529451,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25751,
        lat: 49.732235,
        long: 14.667506
    },
    {
        town: "Byst\u0159ice nad Pern\u0161tejnem",
        townCode: 595411,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.523046,
        long: 16.261571
    },
    {
        town: "Byst\u0159ice pod Host\xfdnem",
        townCode: 588393,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.399337,
        long: 17.674121
    },
    {
        town: "Byst\u0159ice pod Lopen\xedkem",
        townCode: 592111,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68755,
        lat: 48.974921,
        long: 17.764159
    },
    {
        town: "Byst\u0159i\u010Dka",
        townCode: 541711,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75624,
        lat: 49.415411,
        long: 17.974099
    },
    {
        town: "By\u0161ice",
        townCode: 534722,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27732,
        lat: 50.310544,
        long: 14.61147
    },
    {
        town: "B\xfd\u0161kovice",
        townCode: 512877,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.467566,
        long: 17.714164
    },
    {
        town: "B\xfd\u0161ovec",
        townCode: 595420,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.475308,
        long: 16.289398
    },
    {
        town: "B\xfd\u0161\u0165",
        townCode: 574848,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53322,
        lat: 50.132532,
        long: 15.911265
    },
    {
        town: 'Byzhradec',
        townCode: 576174,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.215939,
        long: 16.1903
    },
    {
        town: 'Bzenec',
        townCode: 586081,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69681,
        lat: 48.973463,
        long: 17.266959
    },
    {
        town: "Bzov\xe1",
        townCode: 531120,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26743,
        lat: 49.897991,
        long: 13.862507
    },
    {
        town: "B\u017Eany",
        townCode: 567485,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.589151,
        long: 13.879624
    },
    {
        town: 'Cebiv',
        townCode: 560782,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34952,
        lat: 49.829449,
        long: 12.979175
    },
    {
        town: 'Cehnice',
        townCode: 550906,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38752,
        lat: 49.215169,
        long: 14.029493
    },
    {
        town: 'Cejle',
        townCode: 586978,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.3694,
        long: 15.472878
    },
    {
        town: 'Cekov',
        townCode: 559768,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.821968,
        long: 13.763901
    },
    {
        town: 'Cep',
        townCode: 509191,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 48.919602,
        long: 14.807457
    },
    {
        town: "Cerekvice nad Byst\u0159ic\xed",
        townCode: 572781,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50777,
        lat: 50.333348,
        long: 15.723633
    },
    {
        town: "Cerekvice nad Lou\u010Dnou",
        townCode: 577936,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56953,
        lat: 49.898991,
        long: 16.215295
    },
    {
        town: "Cerekvi\u010Dka-Rosice",
        townCode: 586986,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.334875,
        long: 15.587278
    },
    {
        town: 'Cerhenice',
        townCode: 533246,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28102,
        lat: 50.071376,
        long: 15.07214
    },
    {
        town: 'Cerhonice',
        townCode: 549321,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.418097,
        long: 14.055739
    },
    {
        town: 'Cerhovice',
        townCode: 531138,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26761,
        lat: 49.849643,
        long: 13.834934
    },
    {
        town: 'Cetechovice',
        townCode: 588407,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76802,
        lat: 49.172391,
        long: 17.261484
    },
    {
        town: 'Cetenov',
        townCode: 563943,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46348,
        lat: 50.644523,
        long: 14.917705
    },
    {
        town: 'Cetkovice',
        townCode: 581470,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67938,
        lat: 49.578884,
        long: 16.721351
    },
    {
        town: 'Cetoraz',
        townCode: 547662,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39411,
        lat: 49.455335,
        long: 14.957412
    },
    {
        town: "Cetyn\u011B",
        townCode: 564419,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.599728,
        long: 14.121455
    },
    {
        town: 'Cidlina',
        townCode: 590428,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.128295,
        long: 15.735638
    },
    {
        town: "Cikh\xe1j",
        townCode: 588016,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59102,
        lat: 49.644947,
        long: 15.96749
    },
    {
        town: "C\xedrkvice",
        townCode: 599476,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28144,
        lat: 49.909456,
        long: 15.015818
    },
    {
        town: "C\xedrkvice",
        townCode: 533998,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28533,
        lat: 49.945703,
        long: 15.335153
    },
    {
        town: "C\xedsa\u0159ov",
        townCode: 569135,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.466135,
        long: 17.352711
    },
    {
        town: 'Citice',
        townCode: 560324,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.162671,
        long: 12.61344
    },
    {
        town: "C\xedtoliby",
        townCode: 542571,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43902,
        lat: 50.332834,
        long: 13.812247
    },
    {
        town: 'Citonice',
        townCode: 593851,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67101,
        lat: 48.884055,
        long: 15.964567
    },
    {
        town: 'Citov',
        townCode: 512982,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.467819,
        long: 17.325561
    },
    {
        town: "C\xedtov",
        townCode: 534731,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27704,
        lat: 50.372354,
        long: 14.398243
    },
    {
        town: 'Cizkrajov',
        townCode: 546054,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37881,
        lat: 49.03065,
        long: 15.389754
    },
    {
        town: 'Cotkytle',
        townCode: 579980,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56132,
        lat: 49.936282,
        long: 16.72414
    },
    {
        town: 'Crhov',
        townCode: 554162,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.545112,
        long: 16.434827
    },
    {
        town: "Ct\u011Bt\xedn",
        townCode: 571253,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.830355,
        long: 15.839524
    },
    {
        town: "Ctibo\u0159",
        townCode: 579459,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.82733,
        long: 12.61012
    },
    {
        town: "Ctibo\u0159",
        townCode: 532690,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.736767,
        long: 14.904302
    },
    {
        town: "Ctidru\u017Eice",
        townCode: 593869,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 48.982616,
        long: 15.86009
    },
    {
        town: "Ctim\u011B\u0159ice",
        townCode: 570991,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29446,
        lat: 50.377891,
        long: 14.993465
    },
    {
        town: "Ctin\u011Bves",
        townCode: 564672,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.374801,
        long: 14.307223
    },
    {
        town: 'Cvikov',
        townCode: 561479,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47154,
        lat: 50.777293,
        long: 14.633019
    },
    {
        town: "Cvr\u010Dovice",
        townCode: 550272,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69123,
        lat: 48.993768,
        long: 16.514581
    },
    {
        town: "Cvr\u010Dovice",
        townCode: 532185,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27341,
        lat: 50.179896,
        long: 14.154895
    },
    {
        town: "\u010Cachot\xedn",
        townCode: 568490,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.695303,
        long: 15.608696
    },
    {
        town: "\u010Cachovice",
        townCode: 535621,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29443,
        lat: 50.27557,
        long: 14.946032
    },
    {
        town: "\u010Cachrov",
        townCode: 555941,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.265538,
        long: 13.302687
    },
    {
        town: "\u010Cakov",
        townCode: 535541,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.980659,
        long: 14.307773
    },
    {
        town: "\u010Cakov",
        townCode: 529478,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25724,
        lat: 49.825696,
        long: 14.836436
    },
    {
        town: "\u010Cakov\xe1",
        townCode: 552003,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79316,
        lat: 50.051137,
        long: 17.548483
    },
    {
        town: "\u010Cakovi\u010Dky",
        townCode: 598291,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.231701,
        long: 14.531487
    },
    {
        town: "\u010Cankovice",
        townCode: 571270,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.963804,
        long: 15.937395
    },
    {
        town: "\u010C\xe1slav",
        townCode: 534005,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.910995,
        long: 15.390894
    },
    {
        town: "\u010C\xe1slavice",
        townCode: 590436,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67524,
        lat: 49.152316,
        long: 15.772506
    },
    {
        town: "\u010C\xe1slavsko",
        townCode: 547689,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.592512,
        long: 15.00285
    },
    {
        town: "\u010C\xe1stkov",
        townCode: 560804,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34801,
        lat: 49.756077,
        long: 12.673799
    },
    {
        town: "\u010C\xe1stkov",
        townCode: 592137,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.10453,
        long: 17.619917
    },
    {
        town: "\u010Castohostice",
        townCode: 553964,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67602,
        lat: 49.014482,
        long: 15.819302
    },
    {
        town: "\u010Castolovice",
        townCode: 576182,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51750,
        lat: 50.129194,
        long: 16.181387
    },
    {
        town: "\u010Castrov",
        townCode: 547719,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39463,
        lat: 49.307899,
        long: 15.180392
    },
    {
        town: "\u010Casy",
        townCode: 572799,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.069473,
        long: 15.898214
    },
    {
        town: "\u010Cavisov",
        townCode: 569119,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74764,
        lat: 49.829577,
        long: 18.080797
    },
    {
        town: "\u010Ceb\xedn",
        townCode: 582913,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66423,
        lat: 49.313339,
        long: 16.478018
    },
    {
        town: "\u010Ce\u010Delice",
        townCode: 534749,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27732,
        lat: 50.294103,
        long: 14.618687
    },
    {
        town: "\u010Ce\u010Delovice",
        townCode: 510068,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.374116,
        long: 13.794971
    },
    {
        town: "\u010Ce\u010Dkovice",
        townCode: 548375,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.784709,
        long: 15.664069
    },
    {
        town: "\u010Ce\u010Dovice",
        townCode: 566080,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.585171,
        long: 13.021847
    },
    {
        town: "\u010Cehovice",
        townCode: 589365,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79821,
        lat: 49.43255,
        long: 17.175182
    },
    {
        town: "\u010Cecho\u010Dovice",
        townCode: 590444,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.202965,
        long: 15.793702
    },
    {
        town: "\u010Cechtice",
        townCode: 529486,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.624128,
        long: 15.048346
    },
    {
        town: "\u010Cecht\xedn",
        townCode: 590452,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.293149,
        long: 15.819975
    },
    {
        town: "\u010Cechy",
        townCode: 552771,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75115,
        lat: 49.429155,
        long: 17.534434
    },
    {
        town: "\u010Cechy pod Kos\xed\u0159em",
        townCode: 589381,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79858,
        lat: 49.551061,
        long: 17.037775
    },
    {
        town: "\u010Cej\u010D",
        townCode: 586099,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69614,
        lat: 48.946631,
        long: 16.965214
    },
    {
        town: "\u010Cejetice",
        townCode: 550922,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.25292,
        long: 14.020488
    },
    {
        town: "\u010Cejkovice",
        townCode: 544329,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.014436,
        long: 14.383008
    },
    {
        town: "\u010Cejkovice",
        townCode: 586102,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69615,
        lat: 48.906019,
        long: 16.942409
    },
    {
        town: "\u010Cejkovice",
        townCode: 593877,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.877801,
        long: 16.287428
    },
    {
        town: "\u010Cejkovice",
        townCode: 529524,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.791923,
        long: 15.349767
    },
    {
        town: "\u010Cejov",
        townCode: 547735,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.565751,
        long: 15.379353
    },
    {
        town: "\u010Celadn\xe1",
        townCode: 598071,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73912,
        lat: 49.548829,
        long: 18.337697
    },
    {
        town: "\u010Cel\xe1kovice",
        townCode: 538132,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25088,
        lat: 50.162803,
        long: 14.751089
    },
    {
        town: "\u010Cel\u010Dice",
        townCode: 589390,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79823,
        lat: 49.412429,
        long: 17.19374
    },
    {
        town: "\u010Celechovice",
        townCode: 513059,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.510136,
        long: 17.372246
    },
    {
        town: "\u010Celechovice na Han\xe9",
        townCode: 589403,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79816,
        lat: 49.516364,
        long: 17.093902
    },
    {
        town: "\u010Celistn\xe1",
        townCode: 529826,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.360262,
        long: 15.206421
    },
    {
        town: "\u010Celo\u017Enice",
        townCode: 586111,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69651,
        lat: 49.051964,
        long: 17.15476
    },
    {
        town: "\u010Ceminy",
        townCode: 558711,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.80007,
        long: 13.253217
    },
    {
        town: "\u010Cenkov",
        townCode: 540072,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.777803,
        long: 14.00086
    },
    {
        town: "\u010Cenkov u Bechyn\u011B",
        townCode: 598976,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.233538,
        long: 14.500943
    },
    {
        town: "\u010Cenkovice",
        townCode: 579998,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56164,
        lat: 50.011481,
        long: 16.682509
    },
    {
        town: "\u010Ceperka",
        townCode: 574856,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.13312,
        long: 15.773339
    },
    {
        town: "\u010Cep\xed",
        townCode: 574864,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53332,
        lat: 49.985238,
        long: 15.717675
    },
    {
        town: "\u010Cep\u0159ovice",
        townCode: 550949,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38756,
        lat: 49.155339,
        long: 13.975181
    },
    {
        town: "\u010Ceradice",
        townCode: 530581,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.308851,
        long: 13.494015
    },
    {
        town: "\u010Cer\u010Dany",
        townCode: 529516,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25722,
        lat: 49.853032,
        long: 14.703093
    },
    {
        town: "\u010Cerm\xe1kovice",
        townCode: 593885,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67173,
        lat: 49.032153,
        long: 16.195072
    },
    {
        town: "\u010Cermn\xe1",
        townCode: 579106,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54377,
        lat: 50.550083,
        long: 15.769729
    },
    {
        town: "\u010Cermn\xe1",
        townCode: 553514,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.531701,
        long: 13.116707
    },
    {
        town: "\u010Cermn\xe1 nad Orlic\xed",
        townCode: 576191,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51725,
        lat: 50.080411,
        long: 16.144089
    },
    {
        town: "\u010Cermn\xe1 ve Slezsku",
        townCode: 569950,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74901,
        lat: 49.782431,
        long: 17.702213
    },
    {
        town: "\u010Cern\xe1",
        townCode: 595438,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59442,
        lat: 49.426181,
        long: 15.86393
    },
    {
        town: "\u010Cern\xe1 Hora",
        townCode: 581496,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.413707,
        long: 16.581502
    },
    {
        town: "\u010Cern\xe1 u Bohdan\u010De",
        townCode: 572896,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.05613,
        long: 15.671936
    },
    {
        town: "\u010Cern\xe1 v Po\u0161umav\xed",
        townCode: 545457,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38223,
        lat: 48.738072,
        long: 14.110637
    },
    {
        town: "\u010Cern\xe1 Voda",
        townCode: 533491,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79054,
        lat: 50.308312,
        long: 17.1471
    },
    {
        town: "\u010Cernava",
        townCode: 538019,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36221,
        lat: 50.291365,
        long: 12.711084
    },
    {
        town: "\u010Cern\u010Dice",
        townCode: 573957,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.335841,
        long: 16.102688
    },
    {
        town: "\u010Cern\u010Dice",
        townCode: 542628,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43901,
        lat: 50.361485,
        long: 13.845324
    },
    {
        town: "\u010Cern\xe9 Vod\u011Brady",
        townCode: 533254,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.941659,
        long: 14.80689
    },
    {
        town: "\u010Cern\u011Bves",
        townCode: 546852,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.454495,
        long: 14.243217
    },
    {
        town: "\u010Cern\xed\u010D",
        townCode: 587001,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.127972,
        long: 15.45943
    },
    {
        town: "\u010Cern\xedkov",
        townCode: 553531,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.422778,
        long: 13.13013
    },
    {
        town: "\u010Cern\xedkovice",
        townCode: 576204,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51704,
        lat: 50.186688,
        long: 16.207062
    },
    {
        town: "\u010Cern\xedkovice",
        townCode: 566632,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.975551,
        long: 13.56701
    },
    {
        town: "\u010Cern\xedky",
        townCode: 599301,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28915,
        lat: 50.102118,
        long: 14.820104
    },
    {
        town: "\u010Cernilov",
        townCode: 569917,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50343,
        lat: 50.262743,
        long: 15.922644
    },
    {
        town: "\u010Cern\xedn",
        townCode: 593893,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.983053,
        long: 16.021013
    },
    {
        town: "\u010Cern\xedny",
        townCode: 534013,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.840116,
        long: 15.218931
    },
    {
        town: "\u010Cerniv",
        townCode: 564699,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.445046,
        long: 14.059049
    },
    {
        town: "\u010Cernolice",
        townCode: 539121,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.90979,
        long: 14.299358
    },
    {
        town: "\u010Cerno\u0161ice",
        townCode: 539139,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25228,
        lat: 49.960184,
        long: 14.319902
    },
    {
        town: "\u010Cerno\u0161\xedn",
        townCode: 560812,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34958,
        lat: 49.816245,
        long: 12.883925
    },
    {
        town: "\u010Cernot\xedn",
        townCode: 513067,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75368,
        lat: 49.531975,
        long: 17.772231
    },
    {
        town: "\u010Cernou\u010Dek",
        townCode: 542423,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.360924,
        long: 14.307446
    },
    {
        town: "\u010Cernousy",
        townCode: 545996,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46373,
        lat: 51.004564,
        long: 15.050573
    },
    {
        town: "\u010Cernov",
        townCode: 561142,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.344066,
        long: 15.314148
    },
    {
        town: "\u010Cernovice",
        townCode: 581500,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67975,
        lat: 49.48363,
        long: 16.423018
    },
    {
        town: "\u010Cernovice",
        townCode: 547760,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39494,
        lat: 49.372757,
        long: 14.960993
    },
    {
        town: "\u010Cernovice",
        townCode: 566098,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.615661,
        long: 12.99704
    },
    {
        town: "\u010Cernovice",
        townCode: 563021,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.447783,
        long: 13.359354
    },
    {
        town: "\u010Cer\u0148ovice",
        townCode: 530328,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33036,
        lat: 49.813006,
        long: 13.103784
    },
    {
        town: "\u010Cerno\u017Eice",
        townCode: 569925,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50304,
        lat: 50.318732,
        long: 15.874133
    },
    {
        town: "\u010Cernuc",
        townCode: 532207,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27323,
        lat: 50.301245,
        long: 14.202603
    },
    {
        town: "\u010Cernv\xedr",
        townCode: 595446,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59262,
        lat: 49.445413,
        long: 16.346286
    },
    {
        town: "\u010Cern\xfd D\u016Fl",
        townCode: 579114,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54344,
        lat: 50.635059,
        long: 15.710701
    },
    {
        town: "\u010Cern\xfd\u0161ovice",
        townCode: 563722,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.325232,
        long: 14.520546
    },
    {
        town: "\u010Cerven\xe1 Hora",
        townCode: 505099,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54941,
        lat: 50.450166,
        long: 16.058927
    },
    {
        town: "\u010Cerven\xe1 Lhota",
        townCode: 590461,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.284564,
        long: 15.806208
    },
    {
        town: "\u010Cerven\xe1 \u0158e\u010Dice",
        townCode: 547778,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39446,
        lat: 49.511334,
        long: 15.178468
    },
    {
        town: "\u010Cerven\xe1 T\u0159eme\u0161n\xe1",
        townCode: 548995,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.39943,
        long: 15.643602
    },
    {
        town: "\u010Cerven\xe1 Voda",
        townCode: 580015,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56161,
        lat: 50.040389,
        long: 16.742787
    },
    {
        town: "\u010Cerven\xe9 Janovice",
        townCode: 534021,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28542,
        lat: 49.834712,
        long: 15.253438
    },
    {
        town: "\u010Cerven\xe9 Pe\u010Dky",
        townCode: 533262,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28121,
        lat: 49.978318,
        long: 15.208666
    },
    {
        town: "\u010Cerven\xe9 Po\u0159\xed\u010D\xed",
        townCode: 542172,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.501992,
        long: 13.294553
    },
    {
        town: "\u010Cervenka",
        townCode: 552186,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78401,
        lat: 49.718889,
        long: 17.083808
    },
    {
        town: "\u010Cerven\xfd Hr\xe1dek",
        townCode: 509116,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.122981,
        long: 15.539027
    },
    {
        town: "\u010Cerven\xfd Kostelec",
        townCode: 573965,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54941,
        lat: 50.476361,
        long: 16.093
    },
    {
        town: "\u010Cerven\xfd \xdajezd",
        townCode: 529532,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25788,
        lat: 49.555506,
        long: 14.604165
    },
    {
        town: "\u010Cerven\xfd \xdajezd",
        townCode: 532215,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.069809,
        long: 14.166017
    },
    {
        town: "\u010Cesk\xe1",
        townCode: 582921,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66431,
        lat: 49.280178,
        long: 16.56551
    },
    {
        town: "\u010Cesk\xe1 B\u011Bl\xe1",
        townCode: 568503,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58261,
        lat: 49.643015,
        long: 15.691066
    },
    {
        town: "\u010Cesk\xe1 B\u0159\xedza",
        townCode: 558745,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.828513,
        long: 13.429819
    },
    {
        town: "\u010Cesk\xe1 \u010Cermn\xe1",
        townCode: 573973,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54921,
        lat: 50.400822,
        long: 16.229527
    },
    {
        town: "\u010Cesk\xe1 Kamenice",
        townCode: 562394,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40721,
        lat: 50.797908,
        long: 14.417784
    },
    {
        town: "\u010Cesk\xe1 Kubice",
        townCode: 553549,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34532,
        lat: 49.369488,
        long: 12.858904
    },
    {
        town: "\u010Cesk\xe1 L\xedpa",
        townCode: 561380,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47001,
        lat: 50.67862,
        long: 14.539799
    },
    {
        town: "\u010Cesk\xe1 Metuje",
        townCode: 573981,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54956,
        lat: 50.545672,
        long: 16.180328
    },
    {
        town: "\u010Cesk\xe1 Rybn\xe1",
        townCode: 580023,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56185,
        lat: 50.071923,
        long: 16.392345
    },
    {
        town: "\u010Cesk\xe1 Skalice",
        townCode: 573990,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55203,
        lat: 50.394767,
        long: 16.042868
    },
    {
        town: "\u010Cesk\xe1 T\u0159ebov\xe1",
        townCode: 580031,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56002,
        lat: 49.901982,
        long: 16.447385
    },
    {
        town: "\u010Cesk\xe1 Ves",
        townCode: 569356,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79081,
        lat: 50.257454,
        long: 17.228153
    },
    {
        town: "\u010CESK\xc9 BUD\u011AJOVICE",
        townCode: 544256,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.975758,
        long: 14.480355
    },
    {
        town: "\u010Cesk\xe9 He\u0159manice",
        townCode: 580040,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56552,
        lat: 49.931529,
        long: 16.253203
    },
    {
        town: "\u010Cesk\xe9 Lhotice",
        townCode: 571296,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.847036,
        long: 15.777938
    },
    {
        town: "\u010Cesk\xe9 Libchavy",
        townCode: 580058,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56114,
        lat: 50.029927,
        long: 16.371803
    },
    {
        town: "\u010Cesk\xe9 Mezi\u0159\xed\u010D\xed",
        townCode: 576212,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.286898,
        long: 16.044385
    },
    {
        town: "\u010Cesk\xe9 Petrovice",
        townCode: 580066,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.119374,
        long: 16.605474
    },
    {
        town: "\u010Cesk\xe9 Velenice",
        townCode: 546089,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37810,
        lat: 48.768608,
        long: 14.963775
    },
    {
        town: "\u010Cesk\xfd Brod",
        townCode: 533271,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.074304,
        long: 14.860919
    },
    {
        town: "\u010Cesk\xfd Dub",
        townCode: 563960,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46343,
        lat: 50.661116,
        long: 14.996287
    },
    {
        town: "\u010Cesk\xfd Ji\u0159et\xedn",
        townCode: 567108,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43601,
        lat: 50.70759,
        long: 13.547489
    },
    {
        town: "\u010Cesk\xfd Krumlov",
        townCode: 545392,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38101,
        lat: 48.812835,
        long: 14.317566
    },
    {
        town: "\u010Cesk\xfd Rudolec",
        townCode: 546097,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37883,
        lat: 49.068454,
        long: 15.324472
    },
    {
        town: "\u010Cesk\xfd \u0160ternberk",
        townCode: 529541,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.810991,
        long: 14.928256
    },
    {
        town: "\u010Cesk\xfd T\u011B\u0161\xedn",
        townCode: 598933,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73701,
        lat: 49.747144,
        long: 18.623896
    },
    {
        town: "\u010Cestice",
        townCode: 550957,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.167929,
        long: 13.8038
    },
    {
        town: "\u010Cestice",
        townCode: 576221,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.127918,
        long: 16.145832
    },
    {
        town: "\u010Cest\xedn",
        townCode: 534030,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28510,
        lat: 49.807713,
        long: 15.104503
    },
    {
        town: "\u010Cestlice",
        townCode: 538141,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 50.002617,
        long: 14.583719
    },
    {
        town: "\u010Ce\u0161ov",
        townCode: 572811,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.339204,
        long: 15.360429
    },
    {
        town: "\u010C\xed\u010Denice",
        townCode: 550965,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38771,
        lat: 49.153152,
        long: 14.230951
    },
    {
        town: "\u010C\xed\u010Dovice",
        townCode: 539147,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25268,
        lat: 50.156814,
        long: 14.249483
    },
    {
        town: "\u010C\xedhal\xedn",
        townCode: 590479,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.268545,
        long: 15.812163
    },
    {
        town: "\u010C\xedha\u0148",
        townCode: 542024,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.34251,
        long: 13.425893
    },
    {
        town: "\u010C\xedho\u0161\u0165",
        townCode: 568520,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58287,
        lat: 49.741853,
        long: 15.33518
    },
    {
        town: "\u010Cichalov",
        townCode: 506621,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36452,
        lat: 50.12436,
        long: 13.17119
    },
    {
        town: "\u010C\xedchov",
        townCode: 590487,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.284719,
        long: 15.762199
    },
    {
        town: "\u010Cikov",
        townCode: 590495,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67578,
        lat: 49.269605,
        long: 16.141012
    },
    {
        town: "\u010Cil\xe1",
        townCode: 540927,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.961766,
        long: 13.742166
    },
    {
        town: "\u010Cilec",
        townCode: 599671,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28925,
        lat: 50.219494,
        long: 14.981754
    },
    {
        town: "\u010C\xedm",
        townCode: 540081,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.77862,
        long: 14.377907
    },
    {
        town: "\u010Cimelice",
        townCode: 549339,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.465681,
        long: 14.069328
    },
    {
        town: "\u010C\xedm\u011B\u0159",
        townCode: 546101,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37832,
        lat: 49.060706,
        long: 15.073772
    },
    {
        town: "\u010C\xedm\u011B\u0159",
        townCode: 590509,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67501,
        lat: 49.200243,
        long: 15.998557
    },
    {
        town: "\u010C\xedmice",
        townCode: 578495,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.253746,
        long: 13.605991
    },
    {
        town: "\u010Cin\u011Bves",
        townCode: 537080,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28901,
        lat: 50.230096,
        long: 15.213992
    },
    {
        town: "\u010Cisovice",
        townCode: 539155,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25204,
        lat: 49.86348,
        long: 14.314883
    },
    {
        town: "\u010Cist\xe1",
        townCode: 577944,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56956,
        lat: 49.827322,
        long: 16.328783
    },
    {
        town: "\u010Cist\xe1",
        townCode: 535630,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29423,
        lat: 50.472083,
        long: 14.843595
    },
    {
        town: "\u010Cist\xe1",
        townCode: 541699,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27034,
        lat: 50.099047,
        long: 13.733683
    },
    {
        town: "\u010Cist\xe1 u Horek",
        townCode: 577057,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51235,
        lat: 50.5317,
        long: 15.60765
    },
    {
        town: "\u010Cist\u011Bves",
        townCode: 569933,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.28893,
        long: 15.731935
    },
    {
        town: "\u010Ci\u017Eice",
        townCode: 557641,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33209,
        lat: 49.648043,
        long: 13.397992
    },
    {
        town: "\u010C\xed\u017Ekov",
        townCode: 598704,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.440552,
        long: 15.118556
    },
    {
        town: "\u010C\xed\u017Ekov",
        townCode: 557650,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33564,
        lat: 49.540479,
        long: 13.683496
    },
    {
        town: "\u010C\xed\u017Ekovice",
        townCode: 564711,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41112,
        lat: 50.484284,
        long: 14.028506
    },
    {
        town: "\u010C\xed\u017Ekrajice",
        townCode: 551503,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.806592,
        long: 14.636226
    },
    {
        town: "\u010C\xed\u017Eov",
        townCode: 587117,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58601,
        lat: 49.38725,
        long: 15.575048
    },
    {
        town: "\u010C\xed\u017Eov\xe1",
        townCode: 549347,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39831,
        lat: 49.356861,
        long: 14.093158
    },
    {
        town: "\u010Ckyn\u011B",
        townCode: 550167,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.115134,
        long: 13.829161
    },
    {
        town: "\u010Clunek",
        townCode: 561703,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37861,
        lat: 49.111546,
        long: 15.12686
    },
    {
        town: "\u010Cmel\xedny",
        townCode: 578568,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.488923,
        long: 13.654594
    },
    {
        town: "\u010Ctve\u0159\xedn",
        townCode: 544531,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.592605,
        long: 15.100281
    },
    {
        town: "\u010Cty\u0159koly",
        townCode: 529567,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25722,
        lat: 49.868613,
        long: 14.719742
    },
    {
        town: "\u010Cu\u010Dice",
        townCode: 582930,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.137181,
        long: 16.278687
    },
    {
        town: "Da\u010Dice",
        townCode: 546127,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.07992,
        long: 15.434304
    },
    {
        town: "Dale\u010D\xedn",
        townCode: 595454,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59241,
        lat: 49.59137,
        long: 16.240185
    },
    {
        town: "Dalek\xe9 Du\u0161n\xedky",
        townCode: 540099,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.727533,
        long: 14.186636
    },
    {
        town: "Dale\u0161ice",
        townCode: 590517,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67554,
        lat: 49.129105,
        long: 16.08201
    },
    {
        town: "Dale\u0161ice",
        townCode: 530425,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46802,
        lat: 50.681858,
        long: 15.184679
    },
    {
        town: 'Dalovice',
        townCode: 537918,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36263,
        lat: 50.247898,
        long: 12.895923
    },
    {
        town: 'Dalovice',
        townCode: 570818,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.425788,
        long: 14.880041
    },
    {
        town: "Dambo\u0159ice",
        townCode: 586129,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69635,
        lat: 49.038383,
        long: 16.917678
    },
    {
        town: 'Damnice',
        townCode: 593907,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.920412,
        long: 16.374203
    },
    {
        town: "Damn\xedkov",
        townCode: 580074,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56123,
        lat: 49.871344,
        long: 16.560355
    },
    {
        town: "Da\u0148kovice",
        townCode: 595462,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.654082,
        long: 16.148711
    },
    {
        town: 'Darkovice',
        townCode: 568228,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74717,
        lat: 49.936016,
        long: 18.222234
    },
    {
        town: "Daskab\xe1t",
        townCode: 552445,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.578642,
        long: 17.447349
    },
    {
        town: 'Dasnice',
        townCode: 560332,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35709,
        lat: 50.146566,
        long: 12.567344
    },
    {
        town: "Dasn\xfd",
        townCode: 535249,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.019337,
        long: 14.407512
    },
    {
        town: "Da\u0161ice",
        townCode: 574899,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53303,
        lat: 50.028543,
        long: 15.912545
    },
    {
        town: 'Davle',
        townCode: 539163,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25206,
        lat: 49.89228,
        long: 14.400478
    },
    {
        town: "Debl\xedn",
        townCode: 582948,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66475,
        lat: 49.320459,
        long: 16.346542
    },
    {
        town: "D\u011B\u010Dany",
        townCode: 564729,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.438699,
        long: 13.908578
    },
    {
        town: "D\u011A\u010C\xcdN",
        townCode: 562335,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.772656,
        long: 14.212861
    },
    {
        town: "D\u011Bdice",
        townCode: 590525,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67541,
        lat: 49.029803,
        long: 15.727855
    },
    {
        town: "D\u011Bdov\xe1",
        townCode: 571300,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.761203,
        long: 15.986569
    },
    {
        town: "Deht\xe1\u0159e",
        townCode: 561924,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.486202,
        long: 15.275386
    },
    {
        town: "D\u011Bhylov",
        townCode: 568236,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74794,
        lat: 49.869481,
        long: 18.163431
    },
    {
        town: "D\u011Bkanovice",
        townCode: 532746,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.618789,
        long: 15.148645
    },
    {
        town: "D\u011Bkov",
        townCode: 565181,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.171283,
        long: 13.554483
    },
    {
        town: "D\u011Bpoltovice",
        townCode: 538116,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36225,
        lat: 50.294681,
        long: 12.814015
    },
    {
        town: "Desn\xe1",
        townCode: 563552,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46861,
        lat: 50.75481,
        long: 15.313862
    },
    {
        town: "Desn\xe1",
        townCode: 572357,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.807641,
        long: 16.224152
    },
    {
        town: "De\u0161enice",
        townCode: 556041,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34022,
        lat: 49.27441,
        long: 13.171052
    },
    {
        town: "De\u0161n\xe1",
        townCode: 546143,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37873,
        lat: 48.957675,
        long: 15.542926
    },
    {
        town: "De\u0161n\xe1",
        townCode: 585157,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.266709,
        long: 17.846028
    },
    {
        town: "De\u0161ov",
        townCode: 590533,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67533,
        lat: 48.985724,
        long: 15.70151
    },
    {
        town: "De\u0161tn\xe1",
        townCode: 546151,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37825,
        lat: 49.265237,
        long: 14.924058
    },
    {
        town: "De\u0161tn\xe1",
        townCode: 581518,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.612653,
        long: 16.563659
    },
    {
        town: "De\u0161tn\xe9 v Orlick\xfdch hor\xe1ch",
        townCode: 576247,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51791,
        lat: 50.304743,
        long: 16.350751
    },
    {
        town: "De\u0161tnice",
        townCode: 566128,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.230738,
        long: 13.609915
    },
    {
        town: "D\u011Btenice",
        townCode: 572829,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50724,
        lat: 50.36818,
        long: 15.170627
    },
    {
        town: "D\u011Btkovice",
        townCode: 592978,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68323,
        lat: 49.272783,
        long: 17.144316
    },
    {
        town: "D\u011Btkovice",
        townCode: 589420,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79804,
        lat: 49.415458,
        long: 17.082286
    },
    {
        town: "D\u011Btmarovice",
        townCode: 598941,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73571,
        lat: 49.894214,
        long: 18.460901
    },
    {
        town: "D\u011Bt\u0159ichov",
        townCode: 546607,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.892748,
        long: 15.036676
    },
    {
        town: "D\u011Bt\u0159ichov",
        townCode: 577961,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.80007,
        long: 16.532701
    },
    {
        town: "D\u011Bt\u0159ichov nad Byst\u0159ic\xed",
        townCode: 597252,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79303,
        lat: 49.834288,
        long: 17.401831
    },
    {
        town: "D\u011Bt\u0159ichov u Moravsk\xe9 T\u0159ebov\xe9",
        townCode: 572683,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.787241,
        long: 16.710609
    },
    {
        town: "D\xedlce",
        townCode: 549118,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.467293,
        long: 15.359434
    },
    {
        town: "D\xedly",
        townCode: 553557,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.446373,
        long: 12.786498
    },
    {
        town: "D\xedrn\xe1",
        townCode: 552208,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39127,
        lat: 49.242967,
        long: 14.844867
    },
    {
        town: "Div\xe1ky",
        townCode: 584401,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69171,
        lat: 48.988794,
        long: 16.791869
    },
    {
        town: "D\xedv\u010D\xed Hrad",
        townCode: 551864,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.243942,
        long: 17.633923
    },
    {
        town: "D\xedv\u010D\xed Kopy",
        townCode: 529753,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.260383,
        long: 15.046007
    },
    {
        town: "D\xedv\u010Dice",
        townCode: 544361,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37348,
        lat: 49.108733,
        long: 14.309399
    },
    {
        town: 'Divec',
        townCode: 569941,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50003,
        lat: 50.239875,
        long: 15.921759
    },
    {
        town: "Divi\u0161ov",
        townCode: 529621,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.788592,
        long: 14.875895
    },
    {
        town: "Dla\u017Ekovice",
        townCode: 564737,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.465654,
        long: 13.96506
    },
    {
        town: "Dla\u017Eov",
        townCode: 556068,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.365855,
        long: 13.16645
    },
    {
        town: "Dlouh\xe1 Brtnice",
        townCode: 587010,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58834,
        lat: 49.236176,
        long: 15.604269
    },
    {
        town: "Dlouh\xe1 Lhota",
        townCode: 563650,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39155,
        lat: 49.352618,
        long: 14.789052
    },
    {
        town: "Dlouh\xe1 Lhota",
        townCode: 581526,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.428757,
        long: 16.5097
    },
    {
        town: "Dlouh\xe1 Lhota",
        townCode: 535656,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29405,
        lat: 50.420201,
        long: 15.054223
    },
    {
        town: "Dlouh\xe1 Lhota",
        townCode: 513504,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.721224,
        long: 14.120705
    },
    {
        town: "Dlouh\xe1 Lou\u010Dka",
        townCode: 501476,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78386,
        lat: 49.816357,
        long: 17.179781
    },
    {
        town: "Dlouh\xe1 Lou\u010Dka",
        townCode: 577987,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.700947,
        long: 16.641393
    },
    {
        town: "Dlouh\xe1 Str\xe1\u0148",
        townCode: 551708,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.960143,
        long: 17.500561
    },
    {
        town: "Dlouh\xe1 T\u0159ebov\xe1",
        townCode: 548014,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56117,
        lat: 49.940498,
        long: 16.423397
    },
    {
        town: "Dlouh\xe1 Ves",
        townCode: 568538,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.578654,
        long: 15.67485
    },
    {
        town: "Dlouh\xe1 Ves",
        townCode: 556076,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.196383,
        long: 13.50936
    },
    {
        town: "Dlouh\xe9",
        townCode: 595471,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.509081,
        long: 16.123148
    },
    {
        town: 'Dlouhomilov',
        townCode: 533688,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.906997,
        long: 16.991411
    },
    {
        town: "Dlouho\u0148ovice",
        townCode: 548031,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.070296,
        long: 16.441645
    },
    {
        town: 'Dlouhopolsko',
        townCode: 537098,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28903,
        lat: 50.175313,
        long: 15.306231
    },
    {
        town: "Dlouh\xfd Most",
        townCode: 530468,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46312,
        lat: 50.711714,
        long: 15.075978
    },
    {
        town: "Dlouh\xfd \xdajezd",
        townCode: 560839,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.768405,
        long: 12.62858
    },
    {
        town: "Dne\u0161ice",
        townCode: 557668,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33443,
        lat: 49.60493,
        long: 13.264653
    },
    {
        town: 'Dobelice',
        townCode: 593923,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.017342,
        long: 16.27873
    },
    {
        town: 'Dobev',
        townCode: 549363,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.29535,
        long: 14.048531
    },
    {
        town: 'Dobkovice',
        townCode: 562408,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40703,
        lat: 50.714949,
        long: 14.193259
    },
    {
        town: "Dobr\xe1",
        townCode: 598089,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.673927,
        long: 18.414037
    },
    {
        town: "Dobr\xe1 Voda",
        townCode: 561932,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.358246,
        long: 15.270103
    },
    {
        town: "Dobr\xe1 Voda",
        townCode: 595489,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.393997,
        long: 16.065144
    },
    {
        town: "Dobr\xe1 Voda u \u010Cesk\xfdch Bud\u011Bjovic",
        townCode: 535206,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37316,
        lat: 48.968311,
        long: 14.525035
    },
    {
        town: "Dobr\xe1 Voda u Ho\u0159ic",
        townCode: 572837,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50773,
        lat: 50.348096,
        long: 15.602674
    },
    {
        town: "Dobr\xe1 Voda u Pacova",
        townCode: 561762,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.40438,
        long: 15.02781
    },
    {
        town: 'Dobratice',
        townCode: 552542,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.660491,
        long: 18.492374
    },
    {
        town: "Dobr\u010Dice",
        townCode: 513105,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.402129,
        long: 17.480594
    },
    {
        town: "Dobr\xe9",
        townCode: 576263,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51793,
        lat: 50.269855,
        long: 16.263866
    },
    {
        town: "Dobr\xe9 Pole",
        townCode: 584410,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69181,
        lat: 48.824436,
        long: 16.535282
    },
    {
        town: 'Dobrkovice',
        townCode: 585165,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76307,
        lat: 49.094555,
        long: 17.669619
    },
    {
        town: "Dobrn\xe1",
        townCode: 545783,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40741,
        lat: 50.769646,
        long: 14.293376
    },
    {
        town: "Dobro\u010Dkovice",
        townCode: 592986,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.163035,
        long: 17.109099
    },
    {
        town: "Dobro\u010Dovice",
        townCode: 565008,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25082,
        lat: 50.056421,
        long: 14.700015
    },
    {
        town: "Dobroho\u0161\u0165",
        townCode: 562416,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.078488,
        long: 15.488583
    },
    {
        town: 'Dobrochov',
        townCode: 589438,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79807,
        lat: 49.385961,
        long: 17.105673
    },
    {
        town: "Dobrom\u011B\u0159ice",
        townCode: 546861,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.370197,
        long: 13.794844
    },
    {
        town: 'Dobromilice',
        townCode: 589446,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79825,
        lat: 49.35854,
        long: 17.141647
    },
    {
        town: "Dobronice u Bechyn\u011B",
        townCode: 552224,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.343411,
        long: 14.496837
    },
    {
        town: "Dobron\xedn",
        townCode: 587028,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58812,
        lat: 49.478429,
        long: 15.650023
    },
    {
        town: 'Dobroslavice',
        townCode: 569895,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74794,
        lat: 49.880434,
        long: 18.141029
    },
    {
        town: 'Dobroutov',
        townCode: 587036,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.462343,
        long: 15.73659
    },
    {
        town: 'Dobrovice',
        townCode: 535672,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29441,
        lat: 50.369427,
        long: 14.962439
    },
    {
        town: "Dobrov\xedtov",
        townCode: 529559,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.787634,
        long: 15.328817
    },
    {
        town: "Dobrov\xedz",
        townCode: 539171,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25261,
        lat: 50.113163,
        long: 14.217841
    },
    {
        town: "Dobr\u0161\xedn",
        townCode: 530123,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.261401,
        long: 13.561152
    },
    {
        town: "Dobru\u0161ka",
        townCode: 576271,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.292111,
        long: 16.160118
    },
    {
        town: "Dob\u0159any",
        townCode: 576280,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.322221,
        long: 16.285397
    },
    {
        town: "Dob\u0159any",
        townCode: 557676,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33441,
        lat: 49.654933,
        long: 13.293177
    },
    {
        town: "Dob\u0159ejovice",
        townCode: 538167,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.981717,
        long: 14.57837
    },
    {
        town: "Dob\u0159e\u0148",
        townCode: 531570,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.479505,
        long: 14.556812
    },
    {
        town: "Dob\u0159enice",
        townCode: 569968,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50325,
        lat: 50.147821,
        long: 15.641146
    },
    {
        town: "Dob\u0159\xed\u010D",
        townCode: 558770,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33005,
        lat: 49.88466,
        long: 13.468475
    },
    {
        town: "Dob\u0159\xed\u010D",
        townCode: 539180,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25225,
        lat: 50.020021,
        long: 14.259017
    },
    {
        town: "Dob\u0159ichov",
        townCode: 533289,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.079731,
        long: 15.032473
    },
    {
        town: "Dob\u0159ichovice",
        townCode: 539198,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25229,
        lat: 49.927597,
        long: 14.274802
    },
    {
        town: "Dob\u0159\xedkov",
        townCode: 580091,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 50.002605,
        long: 16.133921
    },
    {
        town: "Dob\u0159\xed\u0148",
        townCode: 564745,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.437691,
        long: 14.29389
    },
    {
        town: "Dob\u0159\xednsko",
        townCode: 593931,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.052312,
        long: 16.26177
    },
    {
        town: "Dob\u0159\xed\u0161",
        townCode: 540111,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.781238,
        long: 14.167273
    },
    {
        town: "Dob\u0159\xedv",
        townCode: 559776,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33844,
        lat: 49.715763,
        long: 13.686921
    },
    {
        town: "Dob\u0161ice",
        townCode: 536199,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.216003,
        long: 14.483885
    },
    {
        town: "Dob\u0161ice",
        townCode: 546941,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67182,
        lat: 48.848447,
        long: 16.085512
    },
    {
        town: "Dob\u0161ice",
        townCode: 537101,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28905,
        lat: 50.132535,
        long: 15.268716
    },
    {
        town: "Dob\u0161\xedn",
        townCode: 571989,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.483425,
        long: 15.116761
    },
    {
        town: 'Dohalice',
        townCode: 569976,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50313,
        lat: 50.287371,
        long: 15.694605
    },
    {
        town: 'Doksany',
        townCode: 564753,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41182,
        lat: 50.454991,
        long: 14.16124
    },
    {
        town: 'Doksy',
        townCode: 561495,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.565945,
        long: 14.654377
    },
    {
        town: 'Doksy',
        townCode: 532223,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27364,
        lat: 50.119102,
        long: 14.04793
    },
    {
        town: "Dol\xe1nky nad Oh\u0159\xed",
        townCode: 553646,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.472956,
        long: 14.162716
    },
    {
        town: 'Dolany',
        townCode: 574015,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55201,
        lat: 50.380098,
        long: 15.96138
    },
    {
        town: 'Dolany',
        townCode: 501646,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78316,
        lat: 49.649973,
        long: 17.322508
    },
    {
        town: 'Dolany',
        townCode: 574902,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.113474,
        long: 15.691707
    },
    {
        town: 'Dolany',
        townCode: 556106,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.443368,
        long: 13.248222
    },
    {
        town: 'Dolany',
        townCode: 558788,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.807924,
        long: 13.472466
    },
    {
        town: 'Dolany',
        townCode: 513130,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.115571,
        long: 14.149791
    },
    {
        town: 'Dolany',
        townCode: 539201,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27801,
        lat: 50.22214,
        long: 14.349629
    },
    {
        town: 'Dolce',
        townCode: 539945,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.552967,
        long: 13.393513
    },
    {
        town: 'Dolenice',
        townCode: 593958,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.909233,
        long: 16.365753
    },
    {
        town: "Doln\xed Be\u010Dva",
        townCode: 541800,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75655,
        lat: 49.455076,
        long: 18.194298
    },
    {
        town: "Doln\xed B\u011Bl\xe1",
        townCode: 558796,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.896264,
        long: 13.273369
    },
    {
        town: "Doln\xed Bene\u0161ov",
        townCode: 506702,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74722,
        lat: 49.923215,
        long: 18.101406
    },
    {
        town: "Doln\xed Be\u0159kovice",
        townCode: 534765,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27701,
        lat: 50.393236,
        long: 14.450352
    },
    {
        town: "Doln\xed Bezd\u011Bkov",
        townCode: 505030,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.960537,
        long: 15.883877
    },
    {
        town: "Doln\xed Bojanovice",
        townCode: 586137,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69617,
        lat: 48.858707,
        long: 17.028691
    },
    {
        town: "Doln\xed Bousov",
        townCode: 535702,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.438348,
        long: 15.128232
    },
    {
        town: "Doln\xed Brann\xe1",
        townCode: 579122,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54362,
        lat: 50.593265,
        long: 15.593924
    },
    {
        town: "Doln\xed Brusnice",
        townCode: 554863,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54472,
        lat: 50.458843,
        long: 15.726876
    },
    {
        town: "Doln\xed B\u0159e\u017Eany",
        townCode: 539210,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25241,
        lat: 49.963314,
        long: 14.458611
    },
    {
        town: "Doln\xed Bukovsko",
        townCode: 544388,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37365,
        lat: 49.170963,
        long: 14.58137
    },
    {
        town: "Doln\xed Cerekev",
        townCode: 587044,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58845,
        lat: 49.344588,
        long: 15.456651
    },
    {
        town: "Doln\xed \u010Cermn\xe1",
        townCode: 580112,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56153,
        lat: 49.979635,
        long: 16.564857
    },
    {
        town: "Doln\xed Dobrou\u010D",
        townCode: 580121,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56102,
        lat: 49.992831,
        long: 16.497763
    },
    {
        town: "Doln\xed Domaslavice",
        townCode: 598101,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73938,
        lat: 49.712825,
        long: 18.481063
    },
    {
        town: "Doln\xed Dub\u0148any",
        townCode: 593966,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67173,
        lat: 49.055887,
        long: 16.2268
    },
    {
        town: "Doln\xed Dunajovice",
        townCode: 584428,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69185,
        lat: 48.854571,
        long: 16.592933
    },
    {
        town: "Doln\xed Dvo\u0159i\u0161t\u011B",
        townCode: 545465,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38272,
        lat: 48.656521,
        long: 14.452309
    },
    {
        town: "Doln\xed Dv\u016Fr",
        townCode: 579149,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54342,
        lat: 50.652348,
        long: 15.655683
    },
    {
        town: "Doln\xed Habartice",
        townCode: 545856,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.747281,
        long: 14.333391
    },
    {
        town: "Doln\xed Hbity",
        townCode: 540129,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26262,
        lat: 49.657558,
        long: 14.169935
    },
    {
        town: "Doln\xed He\u0159manice",
        townCode: 595501,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.304851,
        long: 16.060208
    },
    {
        town: "Doln\xed Ho\u0159ice",
        townCode: 552241,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39155,
        lat: 49.435483,
        long: 14.850632
    },
    {
        town: "Doln\xed Hradi\u0161t\u011B",
        townCode: 558800,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.913843,
        long: 13.49632
    },
    {
        town: "Doln\xed Hrachovice",
        townCode: 560529,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.486182,
        long: 14.797204
    },
    {
        town: "Doln\xed Chvatliny",
        townCode: 533297,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28144,
        lat: 49.980602,
        long: 15.06939
    },
    {
        town: "Doln\xed Kaln\xe1",
        townCode: 579157,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54374,
        lat: 50.538973,
        long: 15.6393
    },
    {
        town: "Doln\xed Kounice",
        townCode: 582956,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.070212,
        long: 16.465024
    },
    {
        town: "Doln\xed Kralovice",
        townCode: 529648,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.644223,
        long: 15.177648
    },
    {
        town: "Doln\xed Krup\xe1",
        townCode: 568597,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58271,
        lat: 49.660734,
        long: 15.60314
    },
    {
        town: "Doln\xed Krup\xe1",
        townCode: 535711,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.546419,
        long: 14.86727
    },
    {
        town: "Doln\xed L\xe1nov",
        townCode: 579165,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54341,
        lat: 50.587095,
        long: 15.664426
    },
    {
        town: "Doln\xed La\u017Eany",
        townCode: 587664,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.100034,
        long: 15.822815
    },
    {
        town: "Doln\xed Lhota",
        townCode: 506711,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74766,
        lat: 49.842458,
        long: 18.092517
    },
    {
        town: "Doln\xed Lhota",
        townCode: 585173,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76323,
        lat: 49.137271,
        long: 17.812463
    },
    {
        town: "Doln\xed Libochov\xe1",
        townCode: 595519,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59253,
        lat: 49.408387,
        long: 16.184706
    },
    {
        town: "Doln\xed Lochov",
        townCode: 549088,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.452243,
        long: 15.286389
    },
    {
        town: "Doln\xed Lomn\xe1",
        townCode: 511951,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73991,
        lat: 49.547928,
        long: 18.706198
    },
    {
        town: "Doln\xed Lou\u010Dky",
        townCode: 595527,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.361092,
        long: 16.358812
    },
    {
        town: "Doln\xed Lukavice",
        townCode: 557684,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33444,
        lat: 49.602031,
        long: 13.34434
    },
    {
        town: "Doln\xed Lutyn\u011B",
        townCode: 598968,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73553,
        lat: 49.898856,
        long: 18.428262
    },
    {
        town: "Doln\xed M\u011Bsto",
        townCode: 568601,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58233,
        lat: 49.627806,
        long: 15.382401
    },
    {
        town: "Doln\xed Morava",
        townCode: 580163,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56169,
        lat: 50.122417,
        long: 16.799687
    },
    {
        town: "Doln\xed Moravice",
        townCode: 597287,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79501,
        lat: 49.978038,
        long: 17.32237
    },
    {
        town: "Doln\xed N\u011Bm\u010D\xed",
        townCode: 592145,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68762,
        lat: 48.968468,
        long: 17.585962
    },
    {
        town: "Doln\xed N\u011Bt\u010Dice",
        townCode: 569259,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.476274,
        long: 17.675121
    },
    {
        town: "Doln\xed Nivy",
        townCode: 560341,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.243218,
        long: 12.637158
    },
    {
        town: "Doln\xed Novosedly",
        townCode: 562301,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.329225,
        long: 14.196093
    },
    {
        town: "Doln\xed Ole\u0161nice",
        townCode: 579173,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54375,
        lat: 50.524045,
        long: 15.712271
    },
    {
        town: "Doln\xed P\u011Bna",
        townCode: 562467,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.110604,
        long: 15.022153
    },
    {
        town: "Doln\xed Podlu\u017E\xed",
        townCode: 562432,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40755,
        lat: 50.879988,
        long: 14.595146
    },
    {
        town: "Doln\xed Pohle\u010F",
        townCode: 531260,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.743519,
        long: 15.133625
    },
    {
        town: "Doln\xed Poustevna",
        townCode: 562441,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40782,
        lat: 50.982619,
        long: 14.286956
    },
    {
        town: "Doln\xed P\u0159\xedm",
        townCode: 569984,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50316,
        lat: 50.239725,
        long: 15.708601
    },
    {
        town: "Doln\xed Radechov\xe1",
        townCode: 574023,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54911,
        lat: 50.438436,
        long: 16.151339
    },
    {
        town: "Doln\xed Rove\u0148",
        townCode: 574911,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53371,
        lat: 50.029373,
        long: 15.967844
    },
    {
        town: "Doln\xed Ro\u017E\xednka",
        townCode: 595535,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.47711,
        long: 16.210566
    },
    {
        town: "Doln\xed Rychnov",
        townCode: 538591,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35604,
        lat: 50.164731,
        long: 12.645192
    },
    {
        town: "Doln\xed \u0158asnice",
        townCode: 563994,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.945787,
        long: 15.168786
    },
    {
        town: "Doln\xed \u0158edice",
        townCode: 574929,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53375,
        lat: 50.077906,
        long: 15.924033
    },
    {
        town: "Doln\xed Slivno",
        townCode: 535729,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29478,
        lat: 50.308882,
        long: 14.732843
    },
    {
        town: "Doln\xed Sokolovec",
        townCode: 548448,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.726648,
        long: 15.715276
    },
    {
        town: "Doln\xed Stakory",
        townCode: 570940,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.437396,
        long: 14.972584
    },
    {
        town: "Doln\xed Stud\xe9nky",
        townCode: 553379,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78820,
        lat: 49.93516,
        long: 16.971178
    },
    {
        town: "Doln\xed T\u011B\u0161ice",
        townCode: 552984,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.495466,
        long: 17.806908
    },
    {
        town: "Doln\xed To\u0161anovice",
        townCode: 552607,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73953,
        lat: 49.684257,
        long: 18.488568
    },
    {
        town: "Doln\xed T\u0159ebon\xedn",
        townCode: 545473,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38201,
        lat: 48.855526,
        long: 14.409805
    },
    {
        town: "Doln\xed \xdajezd",
        townCode: 513199,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75123,
        lat: 49.546068,
        long: 17.535582
    },
    {
        town: "Doln\xed \xdajezd",
        townCode: 577995,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56961,
        lat: 49.82572,
        long: 16.25471
    },
    {
        town: "Doln\xed V\u011Bstonice",
        townCode: 584436,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69129,
        lat: 48.888324,
        long: 16.643792
    },
    {
        town: "Doln\xed Vil\xe9movice",
        townCode: 590550,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.153662,
        long: 15.977292
    },
    {
        town: "Doln\xed Vil\xedme\u010D",
        townCode: 587061,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.135989,
        long: 15.520541
    },
    {
        town: "Doln\xed Z\xe1lezly",
        townCode: 567931,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40301,
        lat: 50.597423,
        long: 14.04319
    },
    {
        town: "Doln\xed Zimo\u0159",
        townCode: 531987,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.426717,
        long: 14.501473
    },
    {
        town: "Doln\xed \u017Dandov",
        townCode: 554502,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35493,
        lat: 50.018055,
        long: 12.551125
    },
    {
        town: "Doln\xed \u017D\u010F\xe1r",
        townCode: 562602,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.101227,
        long: 14.988276
    },
    {
        town: "Doln\xed \u017Divotice",
        townCode: 553051,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74756,
        lat: 49.897418,
        long: 17.779797
    },
    {
        town: 'Doloplazy',
        townCode: 568392,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78356,
        lat: 49.567276,
        long: 17.411581
    },
    {
        town: 'Doloplazy',
        townCode: 589454,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79826,
        lat: 49.350312,
        long: 17.160101
    },
    {
        town: 'Domamil',
        townCode: 590568,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67543,
        lat: 49.083336,
        long: 15.695675
    },
    {
        town: "Doman\xedn",
        townCode: 562840,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 48.971783,
        long: 14.739869
    },
    {
        town: "Doman\xedn",
        townCode: 586145,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69683,
        lat: 49.00177,
        long: 17.284869
    },
    {
        town: "Dom\xe1novice",
        townCode: 513181,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.111955,
        long: 15.322621
    },
    {
        town: "Doma\u0161\xedn",
        townCode: 563048,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43151,
        lat: 50.420806,
        long: 13.172313
    },
    {
        town: "Doma\u0161ov",
        townCode: 582964,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.245429,
        long: 16.343924
    },
    {
        town: "Doma\u0161ov nad Byst\u0159ic\xed",
        townCode: 545279,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78306,
        lat: 49.742397,
        long: 17.445404
    },
    {
        town: "Doma\u0161ov u \u0160ternberka",
        townCode: 552313,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.705886,
        long: 17.338
    },
    {
        town: "Doma\u017Eelice",
        townCode: 513211,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75115,
        lat: 49.427781,
        long: 17.545867
    },
    {
        town: "Doma\u017Elice",
        townCode: 553425,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.439803,
        long: 12.931243
    },
    {
        town: 'Domoraz',
        townCode: 578517,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.250731,
        long: 13.662108
    },
    {
        town: 'Domousnice',
        townCode: 535745,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29448,
        lat: 50.394302,
        long: 15.101704
    },
    {
        town: "Domou\u0161ice",
        townCode: 566152,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43968,
        lat: 50.234257,
        long: 13.729627
    },
    {
        town: "Do\u0148ov",
        townCode: 507610,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.21318,
        long: 14.776207
    },
    {
        town: 'Doubek',
        townCode: 564885,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 50.017715,
        long: 14.737871
    },
    {
        town: 'Doubice',
        townCode: 530417,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40747,
        lat: 50.888706,
        long: 14.461724
    },
    {
        town: 'Doubrava',
        townCode: 568864,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73533,
        lat: 49.858829,
        long: 18.480287
    },
    {
        town: "Doubrav\u010Dice",
        townCode: 533301,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.022153,
        long: 14.793181
    },
    {
        town: 'Doubravice',
        townCode: 535664,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37006,
        lat: 48.935899,
        long: 14.510822
    },
    {
        town: 'Doubravice',
        townCode: 550981,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38735,
        lat: 49.352117,
        long: 13.862024
    },
    {
        town: 'Doubravice',
        townCode: 579181,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54451,
        lat: 50.405574,
        long: 15.761986
    },
    {
        town: 'Doubravice nad Svitavou',
        townCode: 581542,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67911,
        lat: 49.436736,
        long: 16.629473
    },
    {
        town: "Doubravi\u010Dka",
        townCode: 571067,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29430,
        lat: 50.395208,
        long: 14.776212
    },
    {
        town: "Doubravn\xedk",
        townCode: 595551,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59261,
        lat: 49.424208,
        long: 16.352799
    },
    {
        town: 'Doubravy',
        townCode: 585181,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76345,
        lat: 49.142547,
        long: 17.668211
    },
    {
        town: 'Doudleby',
        townCode: 544400,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.893631,
        long: 14.501587
    },
    {
        town: "Doudleby nad Orlic\xed",
        townCode: 576301,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51742,
        lat: 50.107644,
        long: 16.261846
    },
    {
        town: "Doup\u011B",
        townCode: 587079,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.236937,
        long: 15.434721
    },
    {
        town: "Doupovsk\xe9 Hradi\u0161t\u011B",
        townCode: 500127,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36272,
        lat: 50.25,
        long: 13
    },
    {
        town: 'Drahanovice',
        townCode: 501751,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78344,
        lat: 49.578656,
        long: 17.077119
    },
    {
        town: 'Drahany',
        townCode: 589462,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79861,
        lat: 49.433359,
        long: 16.897488
    },
    {
        town: "Drahel\u010Dice",
        townCode: 531146,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25219,
        lat: 50.031926,
        long: 14.203056
    },
    {
        town: 'Drahenice',
        townCode: 599298,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26285,
        lat: 49.520949,
        long: 13.95851
    },
    {
        town: 'Drahkov',
        townCode: 540251,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.557261,
        long: 13.47254
    },
    {
        town: "Drahl\xedn",
        townCode: 540145,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.732317,
        long: 13.968974
    },
    {
        town: "Drah\u0148ovice",
        townCode: 532151,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.822575,
        long: 14.90175
    },
    {
        town: 'Drahobudice',
        townCode: 564681,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28144,
        lat: 49.937579,
        long: 15.066361
    },
    {
        town: 'Drahobuz',
        townCode: 564770,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.525222,
        long: 14.320808
    },
    {
        town: 'Drahonice',
        townCode: 551015,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.200853,
        long: 14.074682
    },
    {
        town: "Drahon\xedn",
        townCode: 595560,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59261,
        lat: 49.414161,
        long: 16.277005
    },
    {
        town: "Draho\u0148\u016Fv \xdajezd",
        townCode: 530379,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.877208,
        long: 13.725945
    },
    {
        town: "Drahot\u011B\u0161ice",
        townCode: 535958,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.124437,
        long: 14.546683
    },
    {
        town: "Drahot\xedn",
        townCode: 553573,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.52424,
        long: 12.758259
    },
    {
        town: "Drahou\u0161",
        townCode: 529711,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27033,
        lat: 50.080232,
        long: 13.47577
    },
    {
        town: 'Drahov',
        townCode: 563765,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.175466,
        long: 14.754277
    },
    {
        town: 'Drachkov',
        townCode: 560219,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.242924,
        long: 13.84157
    },
    {
        town: "Dr\xe1chov",
        townCode: 552275,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.226539,
        long: 14.706724
    },
    {
        town: "Dr\xe1sov",
        townCode: 582972,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66424,
        lat: 49.331934,
        long: 16.47809
    },
    {
        town: "Dr\xe1sov",
        townCode: 540153,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.702186,
        long: 14.117807
    },
    {
        town: "Dra\u017Ee\u0148",
        townCode: 578665,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33101,
        lat: 49.926953,
        long: 13.287978
    },
    {
        town: "Dra\u017Eenov",
        townCode: 553581,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.455812,
        long: 12.872799
    },
    {
        town: "Dra\u017Eice",
        townCode: 552283,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.415254,
        long: 14.640682
    },
    {
        town: "Dra\u017E\xed\u010D",
        townCode: 549371,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.305974,
        long: 14.383923
    },
    {
        town: "Dra\u017Ei\u010Dky",
        townCode: 552291,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39175,
        lat: 49.399131,
        long: 14.59882
    },
    {
        town: "Dr\xe1\u017Eov",
        townCode: 551023,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.167415,
        long: 13.740707
    },
    {
        town: "Dra\u017Eovice",
        townCode: 592994,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.194842,
        long: 16.943484
    },
    {
        town: "Dra\u017Eovice",
        townCode: 566683,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.224775,
        long: 13.607113
    },
    {
        town: "Dra\u017E\u016Fvky",
        townCode: 586153,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69633,
        lat: 49.030633,
        long: 17.019078
    },
    {
        town: "Drevn\xedky",
        townCode: 540170,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.72026,
        long: 14.274132
    },
    {
        town: 'Drhovice',
        townCode: 563307,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.432915,
        long: 14.558481
    },
    {
        town: 'Drhovle',
        townCode: 549380,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.333979,
        long: 14.04237
    },
    {
        town: 'Drhovy',
        townCode: 540188,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.739163,
        long: 14.232487
    },
    {
        town: 'Drmoul',
        townCode: 554511,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.93907,
        long: 12.665618
    },
    {
        town: 'Drnek',
        townCode: 512991,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27377,
        lat: 50.195744,
        long: 13.972514
    },
    {
        town: 'Drnholec',
        townCode: 584444,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69183,
        lat: 48.857558,
        long: 16.485962
    },
    {
        town: 'Drnovice',
        townCode: 581551,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67976,
        lat: 49.469406,
        long: 16.542335
    },
    {
        town: 'Drnovice',
        townCode: 593001,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68304,
        lat: 49.276395,
        long: 16.951569
    },
    {
        town: 'Drnovice',
        townCode: 585190,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76325,
        lat: 49.17899,
        long: 17.957414
    },
    {
        town: 'Drobovice',
        townCode: 531341,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.889628,
        long: 15.413523
    },
    {
        town: "Drou\u017Eetice",
        townCode: 560243,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.289184,
        long: 13.89812
    },
    {
        town: "Drou\u017Ekovice",
        townCode: 563056,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43144,
        lat: 50.430887,
        long: 13.429205
    },
    {
        town: 'Drozdov',
        townCode: 570141,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.907835,
        long: 16.78745
    },
    {
        town: 'Drozdov',
        townCode: 531154,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26761,
        lat: 49.863241,
        long: 13.840685
    },
    {
        town: 'Drslavice',
        townCode: 537187,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.025427,
        long: 13.920865
    },
    {
        town: 'Drslavice',
        townCode: 592153,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68733,
        lat: 49.047152,
        long: 17.600184
    },
    {
        town: 'Druhanov',
        townCode: 568619,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.69888,
        long: 15.410323
    },
    {
        town: "Drun\u010De",
        townCode: 560987,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.296949,
        long: 14.936562
    },
    {
        town: "Druztov\xe1",
        townCode: 558834,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33007,
        lat: 49.797516,
        long: 13.448829
    },
    {
        town: "Dru\u017Eec",
        townCode: 532274,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27362,
        lat: 50.103086,
        long: 14.04551
    },
    {
        town: 'Drysice',
        townCode: 593010,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68321,
        lat: 49.334642,
        long: 17.057846
    },
    {
        town: "Dr\u017Ekov",
        townCode: 563561,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46824,
        lat: 50.68764,
        long: 15.303285
    },
    {
        town: "Dr\u017Ekov\xe1",
        townCode: 585203,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76319,
        lat: 49.319242,
        long: 17.78562
    },
    {
        town: "Dr\u017Eovice",
        townCode: 558419,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79607,
        lat: 49.491208,
        long: 17.134108
    },
    {
        town: "D\u0159enice",
        townCode: 504301,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.982634,
        long: 15.745503
    },
    {
        town: "D\u0159e\u0161\xedn",
        townCode: 551040,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.161244,
        long: 13.775775
    },
    {
        town: "D\u0159etovice",
        townCode: 532282,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27342,
        lat: 50.182789,
        long: 14.210368
    },
    {
        town: "D\u0159ev\u010Dice",
        townCode: 538191,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25001,
        lat: 50.167854,
        long: 14.628327
    },
    {
        town: "D\u0159ev\u011Bnice",
        townCode: 573337,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50713,
        lat: 50.45237,
        long: 15.447215
    },
    {
        town: "D\u0159evnovice",
        townCode: 589489,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79826,
        lat: 49.328187,
        long: 17.143364
    },
    {
        town: "D\u0159evohostice",
        townCode: 513229,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.426043,
        long: 17.592153
    },
    {
        town: "D\u0159\xednov",
        townCode: 532291,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27371,
        lat: 50.275664,
        long: 14.069855
    },
    {
        town: "D\u0159\xednov",
        townCode: 534773,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27745,
        lat: 50.273754,
        long: 14.39761
    },
    {
        town: "D\u0159\xednov",
        townCode: 588431,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.292989,
        long: 17.233486
    },
    {
        town: "D\u0159\xedsy",
        townCode: 534781,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.256089,
        long: 14.643653
    },
    {
        town: "D\u0159\xedte\u010D",
        townCode: 574953,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53305,
        lat: 50.105191,
        long: 15.808857
    },
    {
        town: "D\u0159\xedte\u0148",
        townCode: 544426,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37351,
        lat: 49.142904,
        long: 14.346061
    },
    {
        town: 'Dub',
        townCode: 550183,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38425,
        lat: 49.108339,
        long: 14.012153
    },
    {
        town: 'Dub nad Moravou',
        townCode: 501794,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78375,
        lat: 49.482585,
        long: 17.27734
    },
    {
        town: "Dub\xe1",
        townCode: 561533,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47141,
        lat: 50.540444,
        long: 14.540343
    },
    {
        town: 'Dubany',
        townCode: 572977,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.993164,
        long: 15.725091
    },
    {
        town: "Dub\u010Dany",
        townCode: 552071,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.649318,
        long: 17.078926
    },
    {
        town: 'Dubenec',
        townCode: 579190,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54455,
        lat: 50.37772,
        long: 15.795177
    },
    {
        town: 'Dubenec',
        townCode: 598381,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.695809,
        long: 14.07934
    },
    {
        town: "Dub\xed",
        townCode: 567507,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41701,
        lat: 50.681139,
        long: 13.788947
    },
    {
        town: 'Dubicko',
        townCode: 534927,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78972,
        lat: 49.828159,
        long: 16.962769
    },
    {
        town: "Dubi\u010Dn\xe9",
        townCode: 535788,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 48.981174,
        long: 14.538863
    },
    {
        town: 'Dublovice',
        townCode: 540218,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26251,
        lat: 49.671881,
        long: 14.360998
    },
    {
        town: "Dub\u0148any",
        townCode: 586161,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69603,
        lat: 48.917038,
        long: 17.090148
    },
    {
        town: "Dubn\xe9",
        townCode: 544442,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.976295,
        long: 14.360478
    },
    {
        town: 'Dubnice',
        townCode: 561541,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47126,
        lat: 50.726074,
        long: 14.808823
    },
    {
        town: 'Dubno',
        townCode: 564508,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.695958,
        long: 14.051851
    },
    {
        town: 'Dubovice',
        townCode: 551546,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.424582,
        long: 15.216681
    },
    {
        town: "Dud\xedn",
        townCode: 587087,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.451107,
        long: 15.39771
    },
    {
        town: 'Duchcov',
        townCode: 567515,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41901,
        lat: 50.603871,
        long: 13.746322
    },
    {
        town: 'Dukovany',
        townCode: 590576,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67556,
        lat: 49.081352,
        long: 16.192279
    },
    {
        town: "D\u016Fl",
        townCode: 529869,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.452191,
        long: 15.030185
    },
    {
        town: 'Dunajovice',
        townCode: 562815,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.035149,
        long: 14.695348
    },
    {
        town: 'Dunice',
        townCode: 532843,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.603247,
        long: 15.152746
    },
    {
        town: "Du\u0161ejov",
        townCode: 587095,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.408817,
        long: 15.432836
    },
    {
        town: "Du\u0161n\xedky",
        townCode: 564818,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.424637,
        long: 14.190273
    },
    {
        town: "Dvaka\u010Dovice",
        townCode: 504955,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.979022,
        long: 15.894469
    },
    {
        town: 'Dvorce',
        townCode: 506729,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.375465,
        long: 15.490478
    },
    {
        town: 'Dvorce',
        townCode: 597317,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79368,
        lat: 49.833416,
        long: 17.547725
    },
    {
        town: 'Dvory',
        townCode: 537144,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.039499,
        long: 13.946255
    },
    {
        town: 'Dvory',
        townCode: 537110,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.21175,
        long: 14.995558
    },
    {
        town: "Dvory nad Lu\u017Enic\xed",
        townCode: 509141,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37808,
        lat: 48.852822,
        long: 14.900629
    },
    {
        town: "Dv\u016Fr Kr\xe1lov\xe9 nad Labem",
        townCode: 579203,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.43182,
        long: 15.814127
    },
    {
        town: "Dyj\xe1kovice",
        townCode: 593974,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67126,
        lat: 48.771975,
        long: 16.301068
    },
    {
        town: "Dyj\xe1kovi\u010Dky",
        townCode: 593982,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.7824,
        long: 16.095728
    },
    {
        town: 'Dyje',
        townCode: 593991,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.847219,
        long: 16.1166
    },
    {
        town: 'Dyjice',
        townCode: 587109,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.174727,
        long: 15.493972
    },
    {
        town: 'Dymokury',
        townCode: 537128,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28901,
        lat: 50.245776,
        long: 15.202652
    },
    {
        town: "Dyn\xedn",
        townCode: 544451,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37364,
        lat: 49.137304,
        long: 14.631296
    },
    {
        town: "D\xfd\u0161ina",
        townCode: 558851,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33002,
        lat: 49.777455,
        long: 13.491611
    },
    {
        town: 'Dzbel',
        townCode: 589497,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79853,
        lat: 49.612993,
        long: 16.850985
    },
    {
        town: "D\u017Eb\xe1nice",
        townCode: 594008,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67171,
        lat: 49.001361,
        long: 16.211038
    },
    {
        town: "D\u017Eb\xe1nov",
        townCode: 580210,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.916456,
        long: 16.159605
    },
    {
        town: 'Ejpovice',
        townCode: 559792,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.74619,
        long: 13.514367
    },
    {
        town: "Erpu\u017Eice",
        townCode: 560855,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.807058,
        long: 13.036075
    },
    {
        town: "E\u0161",
        townCode: 561754,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.434699,
        long: 15.001399
    },
    {
        town: "Eva\u0148",
        townCode: 564834,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.384155,
        long: 14.028989
    },
    {
        town: 'Felbabka',
        townCode: 531162,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.813487,
        long: 13.942011
    },
    {
        town: "Frahel\u017E",
        townCode: 562637,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.117232,
        long: 14.732029
    },
    {
        town: 'Francova Lhota',
        townCode: 542644,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75614,
        lat: 49.201841,
        long: 18.11186
    },
    {
        town: "Franti\u0161kov nad Plou\u010Dnic\xed",
        townCode: 545899,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40723,
        lat: 50.725809,
        long: 14.327018
    },
    {
        town: "Franti\u0161kovy L\xe1zn\u011B",
        townCode: 554529,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35101,
        lat: 50.120159,
        long: 12.349781
    },
    {
        town: "Fren\u0161t\xe1t pod Radho\u0161t\u011Bm",
        townCode: 599344,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74401,
        lat: 49.548445,
        long: 18.21089
    },
    {
        town: "Fry\u010Dovice",
        townCode: 598135,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73945,
        lat: 49.666867,
        long: 18.223315
    },
    {
        town: "FR\xddDEK-M\xcdSTEK",
        townCode: 598003,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73801,
        lat: 49.682031,
        long: 18.367422
    },
    {
        town: "Fr\xfddlant",
        townCode: 564028,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.921496,
        long: 15.079851
    },
    {
        town: "Fr\xfddlant nad Ostravic\xed",
        townCode: 598143,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73911,
        lat: 49.591902,
        long: 18.358605
    },
    {
        town: "Fr\xfdd\u0161tejn",
        townCode: 563579,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46342,
        lat: 50.652357,
        long: 15.158867
    },
    {
        town: 'Frymburk',
        townCode: 545481,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38279,
        lat: 48.661044,
        long: 14.165732
    },
    {
        town: 'Frymburk',
        townCode: 578525,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.249661,
        long: 13.707375
    },
    {
        town: "Fry\u0161ava pod \u017D\xe1kovou horou",
        townCode: 595578,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59204,
        lat: 49.630512,
        long: 16.044434
    },
    {
        town: "Fry\u0161t\xe1k",
        townCode: 585211,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76316,
        lat: 49.285304,
        long: 17.683572
    },
    {
        town: 'Fulnek',
        townCode: 599352,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74245,
        lat: 49.712474,
        long: 17.903301
    },
    {
        town: "Gol\u010D\u016Fv Jen\xedkov",
        townCode: 568635,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.816361,
        long: 15.476967
    },
    {
        town: "Gre\u0161lov\xe9 M\xfdto",
        townCode: 594016,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67156,
        lat: 48.980854,
        long: 15.886269
    },
    {
        town: 'Gruna',
        townCode: 574325,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.762991,
        long: 16.742872
    },
    {
        town: 'Grunta',
        townCode: 599450,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.974214,
        long: 15.255089
    },
    {
        town: 'Grygov',
        townCode: 501841,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78373,
        lat: 49.537953,
        long: 17.310944
    },
    {
        town: 'Grymov',
        townCode: 569194,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75121,
        lat: 49.481108,
        long: 17.498114
    },
    {
        town: 'Habartice',
        townCode: 564036,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46373,
        lat: 51.019134,
        long: 15.065266
    },
    {
        town: 'Habartov',
        townCode: 560359,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35709,
        lat: 50.183078,
        long: 12.550653
    },
    {
        town: 'Habrovany',
        townCode: 593028,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.232934,
        long: 16.878393
    },
    {
        town: 'Habrovany',
        townCode: 567957,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.598676,
        long: 13.981796
    },
    {
        town: "Habr\u016Fvka",
        townCode: 581569,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67905,
        lat: 49.3036,
        long: 16.72362
    },
    {
        town: 'Habry',
        townCode: 568651,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58281,
        lat: 49.756128,
        long: 15.484963
    },
    {
        town: "Hab\u0159\xed",
        townCode: 535575,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.948248,
        long: 14.334947
    },
    {
        town: "Hab\u0159ina",
        townCode: 569992,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.326035,
        long: 15.826971
    },
    {
        town: "Ha\u010Dky",
        townCode: 549967,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79855,
        lat: 49.622521,
        long: 16.937715
    },
    {
        town: "Hadravova Rosi\u010Dka",
        townCode: 562696,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.250953,
        long: 15.047507
    },
    {
        town: "H\xe1j u Duchcova",
        townCode: 567523,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41722,
        lat: 50.630921,
        long: 13.712691
    },
    {
        town: "H\xe1j ve Slezsku",
        townCode: 506753,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74792,
        lat: 49.899842,
        long: 18.089995
    },
    {
        town: 'Hajany',
        townCode: 551597,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.446654,
        long: 13.835973
    },
    {
        town: 'Hajany',
        townCode: 582999,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66443,
        lat: 49.110916,
        long: 16.55509
    },
    {
        town: "H\xe1je",
        townCode: 598402,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.672735,
        long: 14.047452
    },
    {
        town: "H\xe1je nad Jizerou",
        townCode: 577073,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.613238,
        long: 15.421312
    },
    {
        town: "H\xe1jek",
        townCode: 561690,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.11119,
        long: 14.061257
    },
    {
        town: "H\xe1jek",
        townCode: 538159,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.283247,
        long: 12.919811
    },
    {
        town: 'Hajnice',
        townCode: 579211,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54466,
        lat: 50.487956,
        long: 15.908701
    },
    {
        town: "Hal\xe1mky",
        townCode: 562807,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37806,
        lat: 48.85324,
        long: 14.915223
    },
    {
        town: 'Halenkov',
        townCode: 542679,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75603,
        lat: 49.317501,
        long: 18.1476
    },
    {
        town: 'Halenkovice',
        townCode: 585220,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76363,
        lat: 49.171122,
        long: 17.471664
    },
    {
        town: 'Haluzice',
        townCode: 585238,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76324,
        lat: 49.137973,
        long: 17.897406
    },
    {
        town: "Hal\u017Ee",
        townCode: 560863,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.831133,
        long: 12.579508
    },
    {
        town: 'Hamr',
        townCode: 562386,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37806,
        lat: 48.949506,
        long: 14.913529
    },
    {
        town: "Hamr na Jeze\u0159e",
        townCode: 544337,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47128,
        lat: 50.702975,
        long: 14.838293
    },
    {
        town: 'Hamry',
        townCode: 571377,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.739067,
        long: 15.926515
    },
    {
        town: 'Hamry',
        townCode: 578240,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34022,
        lat: 49.215418,
        long: 13.160547
    },
    {
        town: "Hamry nad S\xe1zavou",
        townCode: 595586,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.566124,
        long: 15.901791
    },
    {
        town: "Ha\u0148ovice",
        townCode: 552178,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78321,
        lat: 49.681155,
        long: 17.045152
    },
    {
        town: "Hanu\u0161ovice",
        townCode: 535532,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78833,
        lat: 50.080583,
        long: 16.936514
    },
    {
        town: 'Harrachov',
        townCode: 577081,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51246,
        lat: 50.772186,
        long: 15.431521
    },
    {
        town: 'Hartinkov',
        townCode: 572284,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.679202,
        long: 16.814035
    },
    {
        town: 'Hartmanice',
        townCode: 536075,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37365,
        lat: 49.208049,
        long: 14.565216
    },
    {
        town: 'Hartmanice',
        townCode: 578037,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56992,
        lat: 49.625328,
        long: 16.373032
    },
    {
        town: 'Hartmanice',
        townCode: 556181,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.169587,
        long: 13.454657
    },
    {
        town: "Hartv\xedkovice",
        townCode: 590584,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67576,
        lat: 49.171199,
        long: 16.090438
    },
    {
        town: "Ha\u0161kovcova Lhota",
        townCode: 563625,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.332597,
        long: 14.466726
    },
    {
        town: "Ha\u0165",
        townCode: 568210,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74716,
        lat: 49.94654,
        long: 18.23942
    },
    {
        town: "Hat\xedn",
        townCode: 546291,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.108751,
        long: 14.911134
    },
    {
        town: "HAV\xcd\u0158OV",
        townCode: 555088,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73601,
        lat: 49.780492,
        long: 18.430725
    },
    {
        town: "Havl\xed\u010Dkova Borov\xe1",
        townCode: 568660,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58223,
        lat: 49.635883,
        long: 15.781671
    },
    {
        town: "Havl\xed\u010Dk\u016Fv Brod",
        townCode: 568414,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.604436,
        long: 15.579755
    },
    {
        town: 'Havlovice',
        townCode: 579220,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54232,
        lat: 50.487625,
        long: 16.029428
    },
    {
        town: "Havra\u0148",
        townCode: 567141,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43501,
        lat: 50.450149,
        long: 13.598881
    },
    {
        town: "Havran\xedky",
        townCode: 594024,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.811525,
        long: 16.008488
    },
    {
        town: 'Hazlov',
        townCode: 554545,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35132,
        lat: 50.156457,
        long: 12.272617
    },
    {
        town: "Hejn\xe1",
        townCode: 541796,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.28948,
        long: 13.6748
    },
    {
        town: 'Hejnice',
        townCode: 564044,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46362,
        lat: 50.877301,
        long: 15.181785
    },
    {
        town: 'Hejnice',
        townCode: 580228,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.055981,
        long: 16.399519
    },
    {
        town: "Hejtm\xe1nkovice",
        townCode: 574031,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55001,
        lat: 50.599352,
        long: 16.299544
    },
    {
        town: "Helv\xedkovice",
        townCode: 548049,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.092319,
        long: 16.43105
    },
    {
        town: "Her\xe1lec",
        townCode: 568678,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58255,
        lat: 49.530935,
        long: 15.457184
    },
    {
        town: "Her\xe1lec",
        townCode: 595594,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59201,
        lat: 49.689015,
        long: 15.994419
    },
    {
        town: 'Heraltice',
        townCode: 590592,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.230933,
        long: 15.730648
    },
    {
        town: 'Herink',
        townCode: 564915,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.966961,
        long: 14.575012
    },
    {
        town: 'Heroltice',
        townCode: 583014,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.311457,
        long: 16.412898
    },
    {
        town: "Her\u0161pice",
        townCode: 550213,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.119869,
        long: 16.913668
    },
    {
        town: "He\u0159ma\u0148",
        townCode: 598593,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.91146,
        long: 14.503761
    },
    {
        town: "He\u0159ma\u0148",
        townCode: 549398,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39811,
        lat: 49.232575,
        long: 14.13555
    },
    {
        town: "He\u0159mane\u010D",
        townCode: 546305,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.129602,
        long: 15.28546
    },
    {
        town: "He\u0159manice",
        townCode: 548596,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.82401,
        long: 15.54733
    },
    {
        town: "He\u0159manice",
        townCode: 574040,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55212,
        lat: 50.379697,
        long: 15.91865
    },
    {
        town: "He\u0159manice",
        townCode: 544353,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.897,
        long: 15.006457
    },
    {
        town: "He\u0159manice u Oder",
        townCode: 568562,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.713775,
        long: 17.805443
    },
    {
        town: "He\u0159mani\u010Dky",
        townCode: 529702,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25789,
        lat: 49.605411,
        long: 14.582592
    },
    {
        town: "He\u0159m\xe1nkovice",
        townCode: 574058,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54984,
        lat: 50.620004,
        long: 16.323954
    },
    {
        town: "He\u0159m\xe1nky",
        townCode: 568571,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.707069,
        long: 17.768413
    },
    {
        town: "He\u0159manov",
        townCode: 595608,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59458,
        lat: 49.379465,
        long: 16.181332
    },
    {
        town: "He\u0159manov",
        townCode: 562483,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.726587,
        long: 14.291315
    },
    {
        town: "He\u0159manova Hu\u0165",
        townCode: 558869,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.709118,
        long: 13.089275
    },
    {
        town: "He\u0159manovice",
        townCode: 597325,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79374,
        lat: 50.193392,
        long: 17.397871
    },
    {
        town: "He\u0159man\u016Fv M\u011Bstec",
        townCode: 571385,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.94717,
        long: 15.665028
    },
    {
        town: "Hevl\xedn",
        townCode: 594032,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67169,
        lat: 48.75219,
        long: 16.381414
    },
    {
        town: "Hladk\xe9 \u017Divotice",
        townCode: 569666,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74247,
        lat: 49.683,
        long: 17.957475
    },
    {
        town: 'Hladov',
        townCode: 587125,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.214727,
        long: 15.611458
    },
    {
        town: 'Hlasivo',
        townCode: 560481,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.498562,
        long: 14.750424
    },
    {
        town: "Hl\xe1sn\xe1 T\u0159eba\u0148",
        townCode: 531171,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.922344,
        long: 14.198762
    },
    {
        town: "Hl\xe1snice",
        townCode: 552330,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.753458,
        long: 17.294675
    },
    {
        town: 'Hlavatce',
        townCode: 535851,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37348,
        lat: 49.067405,
        long: 14.263279
    },
    {
        town: 'Hlavatce',
        townCode: 552321,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39173,
        lat: 49.295598,
        long: 14.621315
    },
    {
        town: "Hlave\u010Dn\xedk",
        townCode: 574961,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53315,
        lat: 50.075555,
        long: 15.426616
    },
    {
        town: 'Hlavenec',
        townCode: 565989,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29474,
        lat: 50.238392,
        long: 14.701862
    },
    {
        town: 'Hlavice',
        townCode: 564052,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46348,
        lat: 50.631998,
        long: 14.926704
    },
    {
        town: 'Hlavnice',
        townCode: 553093,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74752,
        lat: 49.924487,
        long: 17.727963
    },
    {
        town: "Hlav\u0148ovice",
        townCode: 556203,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.237952,
        long: 13.395157
    },
    {
        town: "Hl\xedna",
        townCode: 583022,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.113718,
        long: 16.426268
    },
    {
        town: 'Hlince',
        townCode: 566390,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.948335,
        long: 13.625133
    },
    {
        town: "Hlincov\xe1 Hora",
        townCode: 598607,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 48.983725,
        long: 14.56456
    },
    {
        town: 'Hlinka',
        townCode: 551872,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.280106,
        long: 17.672253
    },
    {
        town: "Hlinn\xe1",
        townCode: 564842,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.572465,
        long: 14.10679
    },
    {
        town: 'Hlinsko',
        townCode: 569267,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.49464,
        long: 17.579251
    },
    {
        town: 'Hlinsko',
        townCode: 571393,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.762231,
        long: 15.907661
    },
    {
        town: "Hl\xedzov",
        townCode: 531197,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28532,
        lat: 49.985096,
        long: 15.295206
    },
    {
        town: "Hlohov\xe1",
        townCode: 553620,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.53414,
        long: 13.074684
    },
    {
        town: "Hlohov\u010Dice",
        townCode: 566641,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.52085,
        long: 13.113875
    },
    {
        town: 'Hlohovec',
        townCode: 584452,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69143,
        lat: 48.774086,
        long: 16.762404
    },
    {
        town: 'Hlohovice',
        townCode: 559806,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.889578,
        long: 13.643448
    },
    {
        town: "Hlubo\u010Dany",
        townCode: 593036,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.230519,
        long: 17.000469
    },
    {
        town: "Hlubo\u010Dec",
        townCode: 568368,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74769,
        lat: 49.840666,
        long: 17.97043
    },
    {
        town: "Hlubo\u010Dky",
        townCode: 502146,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78361,
        lat: 49.627673,
        long: 17.402638
    },
    {
        town: "Hlubok\xe1",
        townCode: 571407,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53973,
        lat: 49.84568,
        long: 16.071649
    },
    {
        town: "Hlubok\xe1 nad Vltavou",
        townCode: 544485,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.052354,
        long: 14.434371
    },
    {
        town: "Hlubok\xe9",
        townCode: 590614,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.226034,
        long: 16.227607
    },
    {
        town: "Hlubok\xe9 Dvory",
        townCode: 581577,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.383241,
        long: 16.514309
    },
    {
        town: "Hlubok\xe9 Ma\u0161\u016Fvky",
        townCode: 594041,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67152,
        lat: 48.923757,
        long: 16.025651
    },
    {
        town: "Hlubo\u0161",
        townCode: 540242,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26222,
        lat: 49.746325,
        long: 14.020299
    },
    {
        town: "Hlubyn\u011B",
        townCode: 564605,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.559767,
        long: 13.923345
    },
    {
        town: "Hlu\u010D\xedn",
        townCode: 507016,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74801,
        lat: 49.896627,
        long: 18.190649
    },
    {
        town: 'Hluchov',
        townCode: 589501,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79841,
        lat: 49.541496,
        long: 16.996747
    },
    {
        town: 'Hluk',
        townCode: 592170,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68725,
        lat: 48.988219,
        long: 17.526788
    },
    {
        town: "Hlup\xedn",
        townCode: 536628,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.334796,
        long: 13.806877
    },
    {
        town: "Hlu\u0161ice",
        townCode: 570001,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50356,
        lat: 50.264697,
        long: 15.403364
    },
    {
        town: "Hlu\u0161ovice",
        townCode: 552020,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78314,
        lat: 49.638193,
        long: 17.277495
    },
    {
        town: "Hna\u010Dov",
        townCode: 542083,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34034,
        lat: 49.361927,
        long: 13.48178
    },
    {
        town: 'Hnanice',
        townCode: 594059,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.798587,
        long: 15.98678
    },
    {
        town: "Hn\xe1tnice",
        townCode: 580261,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56101,
        lat: 50.020435,
        long: 16.438656
    },
    {
        town: "Hn\u011Bv\u010Deves",
        townCode: 570010,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.314969,
        long: 15.71623
    },
    {
        town: "Hn\u011Bvkovice",
        townCode: 568694,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58294,
        lat: 49.685299,
        long: 15.202877
    },
    {
        town: "Hn\u011Bvnice",
        townCode: 530221,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.728607,
        long: 13.103241
    },
    {
        town: "Hn\u011Bvo\u0161ice",
        townCode: 507105,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74735,
        lat: 50.00309,
        long: 18.008393
    },
    {
        town: "Hn\u011Bvot\xedn",
        townCode: 502235,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78347,
        lat: 49.572151,
        long: 17.179642
    },
    {
        town: 'Hnojice',
        townCode: 502405,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.716409,
        long: 17.224227
    },
    {
        town: "Hnojn\xedk",
        townCode: 598160,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73953,
        lat: 49.682383,
        long: 18.541393
    },
    {
        town: "Hob\u0161ovice",
        townCode: 513075,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27321,
        lat: 50.270647,
        long: 14.162268
    },
    {
        town: "Hod\u011Bjice",
        townCode: 593044,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.141595,
        long: 16.913792
    },
    {
        town: "Hod\u011Bt\xedn",
        townCode: 598992,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.252274,
        long: 14.548733
    },
    {
        town: 'Hodice',
        townCode: 587141,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58901,
        lat: 49.270172,
        long: 15.480092
    },
    {
        town: "Hod\xed\u0161kov",
        townCode: 595624,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.503592,
        long: 16.038149
    },
    {
        town: 'Hodkovice nad Mohelkou',
        townCode: 564061,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46342,
        lat: 50.665963,
        long: 15.08996
    },
    {
        town: 'Hodonice',
        townCode: 562904,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.268626,
        long: 14.487466
    },
    {
        town: 'Hodonice',
        townCode: 594067,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67125,
        lat: 48.8369,
        long: 16.163476
    },
    {
        town: "Hodon\xedn",
        townCode: 581593,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.501284,
        long: 16.410379
    },
    {
        town: "Hodon\xedn",
        townCode: 586021,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69501,
        lat: 48.853039,
        long: 17.126102
    },
    {
        town: "Hodon\xedn",
        townCode: 547794,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.837054,
        long: 15.78717
    },
    {
        town: 'Hodov',
        townCode: 590622,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67504,
        lat: 49.29408,
        long: 15.983949
    },
    {
        town: 'Hodslavice',
        townCode: 599409,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74271,
        lat: 49.53866,
        long: 18.023783
    },
    {
        town: 'Hojanovice',
        townCode: 547883,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.597358,
        long: 15.265616
    },
    {
        town: 'Hojkov',
        townCode: 587150,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.389244,
        long: 15.413786
    },
    {
        town: 'Hojovice',
        townCode: 561096,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.32846,
        long: 14.919872
    },
    {
        town: 'Holany',
        townCode: 561584,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47002,
        lat: 50.618099,
        long: 14.493073
    },
    {
        town: 'Holasice',
        townCode: 583031,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.075956,
        long: 16.607667
    },
    {
        town: 'Holasovice',
        townCode: 507113,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74774,
        lat: 49.998525,
        long: 17.808573
    },
    {
        town: "Hol\u010Dovice",
        townCode: 597341,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79371,
        lat: 50.156849,
        long: 17.486079
    },
    {
        town: "Holede\u010D",
        townCode: 566187,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.277534,
        long: 13.563098
    },
    {
        town: 'Holenice',
        townCode: 577111,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 50601,
        lat: 50.520473,
        long: 15.300548
    },
    {
        town: "Hole\u0161ov",
        townCode: 588458,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.33341,
        long: 17.57843
    },
    {
        town: "Holet\xedn",
        townCode: 571440,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53971,
        lat: 49.794858,
        long: 15.923513
    },
    {
        town: 'Holice',
        townCode: 574988,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.06611,
        long: 15.986005
    },
    {
        town: "Hol\xedn",
        townCode: 572900,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.451706,
        long: 15.320807
    },
    {
        town: 'Holohlavy',
        townCode: 570028,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.308038,
        long: 15.860186
    },
    {
        town: "Holot\xedn",
        townCode: 573019,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.945993,
        long: 15.580349
    },
    {
        town: 'Holoubkov',
        townCode: 559814,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33801,
        lat: 49.776089,
        long: 13.692566
    },
    {
        town: 'Holovousy',
        townCode: 572918,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.375381,
        long: 15.577533
    },
    {
        town: 'Holovousy',
        townCode: 566730,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.96798,
        long: 13.614819
    },
    {
        town: "Hol\u0161tejn",
        townCode: 581615,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67913,
        lat: 49.406486,
        long: 16.777804
    },
    {
        town: 'Holubice',
        townCode: 550825,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68351,
        lat: 49.177588,
        long: 16.812243
    },
    {
        town: 'Holubice',
        townCode: 539228,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25265,
        lat: 50.203189,
        long: 14.292949
    },
    {
        town: 'Holubov',
        townCode: 545490,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38203,
        lat: 48.890096,
        long: 14.321188
    },
    {
        town: "Hol\xfd\u0161ov",
        townCode: 553654,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.593721,
        long: 13.101403
    },
    {
        town: 'Homole',
        townCode: 544493,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.939,
        long: 14.429572
    },
    {
        town: 'Homole u Panny',
        townCode: 567973,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.62938,
        long: 14.186494
    },
    {
        town: 'Honbice',
        townCode: 571458,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.933561,
        long: 15.893093
    },
    {
        town: "Hon\u011Btice",
        townCode: 542342,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76813,
        lat: 49.203806,
        long: 17.253216
    },
    {
        town: 'Honezovice',
        townCode: 540668,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.638318,
        long: 13.062664
    },
    {
        town: "Hora Svat\xe9 Kate\u0159iny",
        townCode: 567167,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43546,
        lat: 50.606416,
        long: 13.436834
    },
    {
        town: "Hora Svat\xe9ho \u0160ebesti\xe1na",
        townCode: 563064,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43182,
        lat: 50.510328,
        long: 13.251454
    },
    {
        town: "Hora Svat\xe9ho V\xe1clava",
        townCode: 566276,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.518986,
        long: 12.739958
    },
    {
        town: "Hora\u017E\u010Fovice",
        townCode: 556254,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.320794,
        long: 13.701106
    },
    {
        town: "Hor\u010D\xe1psko",
        townCode: 564257,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.584502,
        long: 13.984557
    },
    {
        town: 'Horka',
        townCode: 571466,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.887322,
        long: 15.916873
    },
    {
        town: 'Horka I',
        townCode: 531430,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.982795,
        long: 15.44004
    },
    {
        town: 'Horka II',
        townCode: 534056,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.732179,
        long: 15.13385
    },
    {
        town: 'Horka nad Moravou',
        townCode: 502545,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78335,
        lat: 49.640186,
        long: 17.210806
    },
    {
        town: "Horka u Star\xe9 Paky",
        townCode: 574201,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51234,
        lat: 50.52618,
        long: 15.57583
    },
    {
        town: 'Horky',
        townCode: 578053,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.920822,
        long: 16.243471
    },
    {
        town: 'Horky',
        townCode: 531359,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.868864,
        long: 15.439898
    },
    {
        town: 'Horky nad Jizerou',
        townCode: 535818,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29473,
        lat: 50.327164,
        long: 14.856169
    },
    {
        town: "Horn\xed Be\u010Dva",
        townCode: 542687,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75657,
        lat: 49.43226,
        long: 18.288701
    },
    {
        town: "Horn\xed B\u011Bl\xe1",
        townCode: 558877,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.889081,
        long: 13.264218
    },
    {
        town: "Horn\xed Bene\u0161ov",
        townCode: 597350,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79312,
        lat: 49.966918,
        long: 17.60273
    },
    {
        town: "Horn\xed Be\u0159kovice",
        townCode: 564851,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41185,
        lat: 50.358792,
        long: 14.346588
    },
    {
        town: "Horn\xed Bezd\u011Bkov",
        townCode: 532312,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.082352,
        long: 14.067597
    },
    {
        town: "Horn\xed Blatn\xe1",
        townCode: 555169,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36235,
        lat: 50.390493,
        long: 12.771048
    },
    {
        town: "Horn\xed Bludovice",
        townCode: 598178,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73937,
        lat: 49.749749,
        long: 18.436881
    },
    {
        town: "Horn\xed Bojanovice",
        townCode: 584461,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.949805,
        long: 16.800252
    },
    {
        town: "Horn\xed Bradlo",
        townCode: 571474,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53953,
        lat: 49.802435,
        long: 15.744393
    },
    {
        town: "Horn\xed Brann\xe1",
        townCode: 577120,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51236,
        lat: 50.608357,
        long: 15.571571
    },
    {
        town: "Horn\xed Brusnice",
        townCode: 579238,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54474,
        lat: 50.473162,
        long: 15.68114
    },
    {
        town: "Horn\xed B\u0159e\u010Dkov",
        townCode: 594075,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.890055,
        long: 15.898559
    },
    {
        town: "Horn\xed B\u0159\xedza",
        townCode: 558885,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33012,
        lat: 49.84023,
        long: 13.355689
    },
    {
        town: "Horn\xed Bukovina",
        townCode: 535834,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.543257,
        long: 14.926231
    },
    {
        town: "Horn\xed Cerekev",
        townCode: 547913,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39403,
        lat: 49.320362,
        long: 15.327794
    },
    {
        town: "Horn\xed \u010Cermn\xe1",
        townCode: 580279,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56156,
        lat: 49.970628,
        long: 16.607822
    },
    {
        town: "Horn\xed Domaslavice",
        townCode: 512192,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.694745,
        long: 18.461438
    },
    {
        town: "Horn\xed Dubenky",
        townCode: 587168,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58852,
        lat: 49.259681,
        long: 15.317105
    },
    {
        town: "Horn\xed Dub\u0148any",
        townCode: 594083,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67173,
        lat: 49.06346,
        long: 16.201379
    },
    {
        town: "Horn\xed Dunajovice",
        townCode: 594091,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67134,
        lat: 48.950344,
        long: 16.161627
    },
    {
        town: "Horn\xed Dvo\u0159i\u0161t\u011B",
        townCode: 545503,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38293,
        lat: 48.603883,
        long: 14.405822
    },
    {
        town: "Horn\xed Habartice",
        townCode: 545929,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.762175,
        long: 14.340721
    },
    {
        town: "Horn\xed He\u0159manice",
        townCode: 590631,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.329454,
        long: 15.920489
    },
    {
        town: "Horn\xed He\u0159manice",
        townCode: 580295,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56133,
        lat: 49.961095,
        long: 16.711296
    },
    {
        town: "Horn\xed Jelen\xed",
        townCode: 574996,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53374,
        lat: 50.049109,
        long: 16.084069
    },
    {
        town: "Horn\xed Ji\u0159et\xedn",
        townCode: 567175,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43543,
        lat: 50.5732,
        long: 13.547284
    },
    {
        town: "Horn\xed Kaln\xe1",
        townCode: 579254,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54371,
        lat: 50.562856,
        long: 15.62487
    },
    {
        town: "Horn\xed Kamenice",
        townCode: 553662,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.569701,
        long: 13.101163
    },
    {
        town: "Horn\xed Kn\u011B\u017Eeklady",
        townCode: 536105,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.193834,
        long: 14.481489
    },
    {
        town: "Horn\xed Kounice",
        townCode: 594105,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 49.026094,
        long: 16.152366
    },
    {
        town: "Horn\xed Kozolupy",
        townCode: 541290,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34952,
        lat: 49.837622,
        long: 12.941751
    },
    {
        town: "Horn\xed Krup\xe1",
        townCode: 568708,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.672094,
        long: 15.588589
    },
    {
        town: "Horn\xed Kruty",
        townCode: 533327,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28146,
        lat: 49.919546,
        long: 14.959813
    },
    {
        town: "Horn\xed Lapa\u010D",
        townCode: 588474,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.301023,
        long: 17.617522
    },
    {
        town: "Horn\xed Lhota",
        townCode: 569500,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74764,
        lat: 49.853142,
        long: 18.068485
    },
    {
        town: "Horn\xed Lhota",
        townCode: 585246,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76323,
        lat: 49.154412,
        long: 17.80455
    },
    {
        town: "Horn\xed Libchava",
        townCode: 561592,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47111,
        lat: 50.712584,
        long: 14.493538
    },
    {
        town: "Horn\xed Libochov\xe1",
        townCode: 595659,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.407729,
        long: 16.148981
    },
    {
        town: "Horn\xed Lide\u010D",
        townCode: 542725,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.181314,
        long: 18.061103
    },
    {
        town: "Horn\xed Lod\u011Bnice",
        townCode: 569798,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78305,
        lat: 49.771108,
        long: 17.37728
    },
    {
        town: "Horn\xed Lomn\xe1",
        townCode: 511986,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73991,
        lat: 49.527977,
        long: 18.637844
    },
    {
        town: "Horn\xed Lou\u010Dky",
        townCode: 595667,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.366906,
        long: 16.341499
    },
    {
        town: "Horn\xed Lukavice",
        townCode: 539821,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.612427,
        long: 13.32708
    },
    {
        town: "Horn\xed Mar\u0161ov",
        townCode: 579262,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54226,
        lat: 50.658659,
        long: 15.819859
    },
    {
        town: "Horn\xed M\u011Bsto",
        townCode: 597368,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79344,
        lat: 49.908546,
        long: 17.211221
    },
    {
        town: "Horn\xed Mezi\u0159\xed\u010Dko",
        townCode: 598658,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.156684,
        long: 15.244609
    },
    {
        town: "Horn\xed Mo\u0161t\u011Bnice",
        townCode: 513491,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75117,
        lat: 49.412225,
        long: 17.4589
    },
    {
        town: "Horn\xed Myslov\xe1",
        townCode: 587206,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.165516,
        long: 15.422663
    },
    {
        town: "Horn\xed N\u011Bm\u010D\xed",
        townCode: 592188,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68764,
        lat: 48.933273,
        long: 17.624276
    },
    {
        town: "Horn\xed N\u011Bm\u010Dice",
        townCode: 562785,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.1579,
        long: 15.27978
    },
    {
        town: "Horn\xed N\u011Bt\u010Dice",
        townCode: 569275,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.470245,
        long: 17.684498
    },
    {
        town: "Horn\xed Ole\u0161nice",
        townCode: 579271,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54371,
        lat: 50.53276,
        long: 15.677502
    },
    {
        town: "Horn\xed Paseka",
        townCode: 548243,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.629757,
        long: 15.293283
    },
    {
        town: "Horn\xed P\u011Bna",
        townCode: 546364,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37831,
        lat: 49.104515,
        long: 15.042397
    },
    {
        town: "Horn\xed Plan\xe1",
        townCode: 545511,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38226,
        lat: 48.767465,
        long: 14.032672
    },
    {
        town: "Horn\xed Po\u010Daply",
        townCode: 534790,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27703,
        lat: 50.424505,
        long: 14.390039
    },
    {
        town: "Horn\xed Podlu\u017E\xed",
        townCode: 562505,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40757,
        lat: 50.881485,
        long: 14.545731
    },
    {
        town: "Horn\xed Police",
        townCode: 561606,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47106,
        lat: 50.704219,
        long: 14.404106
    },
    {
        town: "Horn\xed Po\u0159\xed\u010D\xed",
        townCode: 536881,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.286063,
        long: 13.782924
    },
    {
        town: "Horn\xed Po\u0159\xed\u010D\xed",
        townCode: 581631,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.587696,
        long: 16.477436
    },
    {
        town: "Horn\xed Radechov\xe1",
        townCode: 574066,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54946,
        lat: 50.46743,
        long: 16.144576
    },
    {
        town: "Horn\xed Radou\u0148",
        townCode: 546381,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37843,
        lat: 49.25718,
        long: 15.005828
    },
    {
        town: "Horn\xed Radslavice",
        townCode: 595675,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.338339,
        long: 15.902364
    },
    {
        town: "Horn\xed R\xe1potice",
        townCode: 551589,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.575426,
        long: 15.320586
    },
    {
        town: "Horn\xed Ro\u017E\xednka",
        townCode: 595683,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.5001,
        long: 16.193
    },
    {
        town: "Horn\xed \u0158asnice",
        townCode: 564079,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.965564,
        long: 15.201599
    },
    {
        town: "Horn\xed \u0158edice",
        townCode: 575011,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53375,
        lat: 50.076611,
        long: 15.958886
    },
    {
        town: "Horn\xed \u0158ep\u010Dice",
        townCode: 546763,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.556722,
        long: 14.253325
    },
    {
        town: "Horn\xed Skr\xfdchov",
        townCode: 561061,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.172879,
        long: 15.028473
    },
    {
        town: "Horn\xed Slatina",
        townCode: 562319,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.090577,
        long: 15.568834
    },
    {
        town: "Horn\xed Slavkov",
        townCode: 560367,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35731,
        lat: 50.138742,
        long: 12.807697
    },
    {
        town: "Horn\xed Slivno",
        townCode: 599531,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29479,
        lat: 50.304132,
        long: 14.704984
    },
    {
        town: "Horn\xed Smr\u010Dn\xe9",
        townCode: 550612,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.32869,
        long: 15.756199
    },
    {
        town: "Horn\xed Smr\u017Eov",
        townCode: 513695,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.618358,
        long: 16.577085
    },
    {
        town: "Horn\xed Stropnice",
        townCode: 544515,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37335,
        lat: 48.761347,
        long: 14.735114
    },
    {
        town: "Horn\xed Stud\xe9nky",
        townCode: 535770,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.952757,
        long: 16.811723
    },
    {
        town: "Horn\xed Such\xe1",
        townCode: 552739,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73535,
        lat: 49.797901,
        long: 18.481997
    },
    {
        town: "Horn\xed \u0160t\u011Bp\xe1nov",
        townCode: 589519,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79847,
        lat: 49.549106,
        long: 16.790882
    },
    {
        town: "Horn\xed T\u011B\u0161ice",
        townCode: 552968,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.495759,
        long: 17.786086
    },
    {
        town: "Horn\xed To\u0161anovice",
        townCode: 552631,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73953,
        lat: 49.692472,
        long: 18.505428
    },
    {
        town: "Horn\xed T\u0159e\u0161\u0148ovec",
        townCode: 580333,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.939321,
        long: 16.602641
    },
    {
        town: "Horn\xed \xdajezd",
        townCode: 590649,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.142893,
        long: 15.842256
    },
    {
        town: "Horn\xed \xdajezd",
        townCode: 569542,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.448387,
        long: 17.727285
    },
    {
        town: "Horn\xed \xdajezd",
        townCode: 572365,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.803578,
        long: 16.233042
    },
    {
        town: "Horn\xed Ves",
        townCode: 547930,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.293507,
        long: 15.307554
    },
    {
        town: "Horn\xed V\u011Bstonice",
        townCode: 584479,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69181,
        lat: 48.874651,
        long: 16.62566
    },
    {
        town: "Horn\xed Vil\xe9movice",
        townCode: 590657,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.29166,
        long: 15.880909
    },
    {
        town: "Horn\xed Vltavice",
        townCode: 550205,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38491,
        lat: 48.957149,
        long: 13.758797
    },
    {
        town: "Horn\xed \u017Divotice",
        townCode: 551805,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79312,
        lat: 49.968984,
        long: 17.6409
    },
    {
        town: 'Hornice',
        townCode: 590665,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.995287,
        long: 15.680464
    },
    {
        town: "Hornos\xedn",
        townCode: 536369,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38742,
        lat: 49.482857,
        long: 13.839873
    },
    {
        town: "Horom\u011B\u0159ice",
        townCode: 539236,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25262,
        lat: 50.131831,
        long: 14.338894
    },
    {
        town: 'Horosedly',
        townCode: 561525,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.512896,
        long: 14.054107
    },
    {
        town: "Horou\u0161any",
        townCode: 538221,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25082,
        lat: 50.106504,
        long: 14.74068
    },
    {
        town: "Horsk\xe1 Kvilda",
        townCode: 542091,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 38501,
        lat: 49.057721,
        long: 13.558075
    },
    {
        town: "Hor\u0161ice",
        townCode: 557722,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33455,
        lat: 49.531575,
        long: 13.386298
    },
    {
        town: "Hor\u0161ovsk\xfd T\xfdn",
        townCode: 553671,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.530286,
        long: 12.944527
    },
    {
        town: "Horu\u0161ice",
        townCode: 531481,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28573,
        lat: 49.996584,
        long: 15.429043
    },
    {
        town: 'Hory',
        townCode: 551651,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.213854,
        long: 12.789994
    },
    {
        town: "Ho\u0159any",
        townCode: 534854,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28914,
        lat: 50.09771,
        long: 14.945897
    },
    {
        town: "Ho\u0159\xe1tev",
        townCode: 537152,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28913,
        lat: 50.150278,
        long: 15.039418
    },
    {
        town: "Ho\u0159enice",
        townCode: 547531,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.369279,
        long: 15.910937
    },
    {
        town: "Ho\u0159epn\xedk",
        townCode: 547948,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39421,
        lat: 49.512566,
        long: 15.107097
    },
    {
        town: "Ho\u0159esedly",
        townCode: 541729,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.16239,
        long: 13.602769
    },
    {
        town: "Ho\u0159e\u0161ovice",
        townCode: 532321,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.27169,
        long: 13.966906
    },
    {
        town: "Ho\u0159e\u0161ovi\u010Dky",
        townCode: 535150,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.274989,
        long: 13.95589
    },
    {
        town: "Ho\u0159ice",
        townCode: 547956,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.599362,
        long: 15.185502
    },
    {
        town: "Ho\u0159ice",
        townCode: 572926,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.366189,
        long: 15.63194
    },
    {
        town: "Ho\u0159ice na \u0160umav\u011B",
        townCode: 545520,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38222,
        lat: 48.766018,
        long: 14.178522
    },
    {
        town: "Ho\u0159i\u010Dky",
        townCode: 574074,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.444856,
        long: 15.993634
    },
    {
        town: "Ho\u0159\xedn",
        townCode: 534803,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27601,
        lat: 50.34492,
        long: 14.464285
    },
    {
        town: "Ho\u0159in\u011Bves",
        townCode: 570044,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50306,
        lat: 50.309639,
        long: 15.767421
    },
    {
        town: "Ho\u0159ovice",
        townCode: 531189,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.836078,
        long: 13.902789
    },
    {
        town: "Ho\u0159ovi\u010Dky",
        townCode: 541737,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.155721,
        long: 13.531515
    },
    {
        town: "Hos\xedn",
        townCode: 544523,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.037403,
        long: 14.476024
    },
    {
        town: 'Hoslovice',
        townCode: 551104,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.191286,
        long: 13.763173
    },
    {
        town: "Hospoz\xedn",
        townCode: 532339,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27322,
        lat: 50.306981,
        long: 14.17187
    },
    {
        town: "Hosp\u0159\xedz",
        townCode: 546402,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.128663,
        long: 15.085627
    },
    {
        town: "Hosta\u0161ovice",
        townCode: 568511,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74101,
        lat: 49.534363,
        long: 17.997408
    },
    {
        town: "Host\u011Bjov",
        townCode: 592196,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68741,
        lat: 49.040274,
        long: 17.257265
    },
    {
        town: "Host\u011Bnice",
        townCode: 583057,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66404,
        lat: 49.236641,
        long: 16.776652
    },
    {
        town: "Host\u011Bradice",
        townCode: 594113,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67171,
        lat: 48.950156,
        long: 16.259416
    },
    {
        town: "Host\u011Br\xe1dky-Re\u0161ov",
        townCode: 593052,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68352,
        lat: 49.117751,
        long: 16.784406
    },
    {
        town: "Host\u011Btice",
        townCode: 587192,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.191764,
        long: 15.414157
    },
    {
        town: "Host\u011Bt\xedn",
        townCode: 550736,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68771,
        lat: 49.050017,
        long: 17.879516
    },
    {
        town: 'Hostim',
        townCode: 594121,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 49.018691,
        long: 15.894995
    },
    {
        town: "Host\xedn",
        townCode: 531499,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27732,
        lat: 50.340525,
        long: 14.588998
    },
    {
        town: "Host\xedn u Vojkovic",
        townCode: 531928,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27744,
        lat: 50.297177,
        long: 14.397072
    },
    {
        town: "Hostinn\xe9",
        townCode: 579297,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54371,
        lat: 50.540762,
        long: 15.723442
    },
    {
        town: "Hosti\u0161ov\xe1",
        townCode: 585254,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76301,
        lat: 49.253781,
        long: 17.591153
    },
    {
        town: 'Hostivice',
        townCode: 539244,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25301,
        lat: 50.081679,
        long: 14.25867
    },
    {
        town: 'Hostomice',
        townCode: 531201,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.825363,
        long: 14.045712
    },
    {
        town: 'Hostomice',
        townCode: 567531,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41752,
        lat: 50.587806,
        long: 13.808142
    },
    {
        town: "Hostou\u0148",
        townCode: 553689,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34525,
        lat: 49.559821,
        long: 12.771578
    },
    {
        town: "Hostou\u0148",
        townCode: 532347,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27353,
        lat: 50.11449,
        long: 14.201384
    },
    {
        town: 'Hostovlice',
        townCode: 534064,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28562,
        lat: 49.860355,
        long: 15.466403
    },
    {
        town: 'Hosty',
        townCode: 535524,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.260396,
        long: 14.393359
    },
    {
        town: "Ho\u0161\u0165\xe1lkov\xe1",
        townCode: 542750,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75622,
        lat: 49.354774,
        long: 17.869548
    },
    {
        town: "Ho\u0161\u0165\xe1lkovy",
        townCode: 597392,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79401,
        lat: 50.111701,
        long: 17.599627
    },
    {
        town: "Ho\u0161\u0165alovice",
        townCode: 571482,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.934901,
        long: 15.57603
    },
    {
        town: "Ho\u0161tejn",
        townCode: 535885,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.874482,
        long: 16.774872
    },
    {
        town: "Ho\u0161tice",
        townCode: 551121,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.194319,
        long: 13.909569
    },
    {
        town: "Ho\u0161tice",
        townCode: 588482,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76813,
        lat: 49.208645,
        long: 17.233888
    },
    {
        town: "Ho\u0161tice-Heroltice",
        townCode: 593061,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.287107,
        long: 17.062864
    },
    {
        town: "Ho\u0161tka",
        townCode: 564877,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41172,
        lat: 50.488694,
        long: 14.33511
    },
    {
        town: "Ho\u0161\u0165ka",
        townCode: 560898,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34806,
        lat: 49.696306,
        long: 12.597568
    },
    {
        town: "Hov\u011Bz\xed",
        townCode: 542768,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75601,
        lat: 49.303745,
        long: 18.060734
    },
    {
        town: 'Hovorany',
        townCode: 586170,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69612,
        lat: 48.95503,
        long: 16.993562
    },
    {
        town: "Hovor\u010Dovice",
        townCode: 538230,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25064,
        lat: 50.178764,
        long: 14.517993
    },
    {
        town: "Hrab\u011B\u0161ice",
        townCode: 553387,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78815,
        lat: 49.97673,
        long: 17.079623
    },
    {
        town: "Hrab\u011B\u0161\xedn",
        townCode: 531413,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.852623,
        long: 15.331919
    },
    {
        town: "Hrab\u011Btice",
        townCode: 594130,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67168,
        lat: 48.797751,
        long: 16.393527
    },
    {
        town: "Hrabi\u0161\xedn",
        townCode: 536091,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78804,
        lat: 49.91415,
        long: 17.036459
    },
    {
        town: "Hrabov\xe1",
        townCode: 553221,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.845548,
        long: 16.953951
    },
    {
        town: "Hrab\u016Fvka",
        townCode: 513636,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.578604,
        long: 17.691361
    },
    {
        town: "Hrabyn\u011B",
        townCode: 507261,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74763,
        lat: 49.882583,
        long: 18.054935
    },
    {
        town: 'Hradce',
        townCode: 535460,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.933382,
        long: 14.359977
    },
    {
        town: "Hrad\u010Dany",
        townCode: 583065,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66603,
        lat: 49.327964,
        long: 16.442271
    },
    {
        town: "Hrad\u010Dany",
        townCode: 513733,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.452714,
        long: 17.571737
    },
    {
        town: "Hrad\u010Dany",
        townCode: 537161,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28905,
        lat: 50.158082,
        long: 15.269964
    },
    {
        town: "Hrad\u010Dany-Kobe\u0159ice",
        townCode: 589527,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79807,
        lat: 49.364185,
        long: 17.128429
    },
    {
        town: "Hrad\u010Dovice",
        townCode: 592200,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68733,
        lat: 49.049868,
        long: 17.582201
    },
    {
        town: 'Hradec',
        townCode: 568724,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.707329,
        long: 15.295565
    },
    {
        town: 'Hradec',
        townCode: 557731,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33211,
        lat: 49.635159,
        long: 13.121483
    },
    {
        town: "HRADEC KR\xc1LOV\xc9",
        townCode: 569810,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50002,
        lat: 50.210461,
        long: 15.825311
    },
    {
        town: "Hradec nad Moravic\xed",
        townCode: 507270,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74741,
        lat: 49.871107,
        long: 17.875924
    },
    {
        town: 'Hradec nad Svitavou',
        townCode: 572691,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56901,
        lat: 49.71153,
        long: 16.480687
    },
    {
        town: "Hradec-Nov\xe1 Ves",
        townCode: 553301,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79084,
        lat: 50.283247,
        long: 17.281327
    },
    {
        town: "Hrade\u010Dno",
        townCode: 532355,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27304,
        lat: 50.188435,
        long: 13.991367
    },
    {
        town: "Hr\xe1dek",
        townCode: 594148,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67127,
        lat: 48.772933,
        long: 16.268293
    },
    {
        town: "Hr\xe1dek",
        townCode: 570052,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.218662,
        long: 15.675654
    },
    {
        town: "Hr\xe1dek",
        townCode: 512176,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73997,
        lat: 49.616708,
        long: 18.737315
    },
    {
        town: "Hr\xe1dek",
        townCode: 547972,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 49.968309,
        long: 16.338406
    },
    {
        town: "Hr\xe1dek",
        townCode: 556301,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.261381,
        long: 13.498603
    },
    {
        town: "Hr\xe1dek",
        townCode: 559822,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33842,
        lat: 49.710027,
        long: 13.65421
    },
    {
        town: "Hr\xe1dek nad Nisou",
        townCode: 564095,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46334,
        lat: 50.852892,
        long: 14.844658
    },
    {
        town: "Hrade\u0161ice",
        townCode: 556319,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.323206,
        long: 13.596547
    },
    {
        town: "Hrade\u0161\xedn",
        townCode: 564800,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.038947,
        long: 14.756771
    },
    {
        town: "Hradi\u0161t\u011B",
        townCode: 566179,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.464875,
        long: 13.051832
    },
    {
        town: "Hradi\u0161t\u011B",
        townCode: 557749,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33544,
        lat: 49.439432,
        long: 13.756199
    },
    {
        town: "Hradi\u0161t\u011B",
        townCode: 541001,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.963121,
        long: 13.717739
    },
    {
        town: "Hradi\u0161t\u011B",
        townCode: 532932,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.684271,
        long: 14.848805
    },
    {
        town: "Hradi\u0161t\u011B (vojensk\xfd \xfajezd)",
        townCode: 555177,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36006,
        lat: 50.174549,
        long: 13.046831
    },
    {
        town: "Hradi\u0161tko",
        townCode: 537179,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28912,
        lat: 50.165593,
        long: 14.935157
    },
    {
        town: "Hradi\u0161tko",
        townCode: 539252,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25209,
        lat: 49.870321,
        long: 14.407963
    },
    {
        town: 'Hracholusky',
        townCode: 550221,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.0589,
        long: 14.088637
    },
    {
        town: 'Hracholusky',
        townCode: 565202,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27041,
        lat: 50.003379,
        long: 13.773965
    },
    {
        town: "Hrachovi\u0161t\u011B",
        townCode: 562831,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 48.929471,
        long: 14.77121
    },
    {
        town: 'Hranice',
        townCode: 544540,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.83852,
        long: 14.868392
    },
    {
        town: 'Hranice',
        townCode: 554553,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35124,
        lat: 50.304702,
        long: 12.175894
    },
    {
        town: 'Hranice',
        townCode: 513750,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.549764,
        long: 17.735022
    },
    {
        town: "Hrani\u010Dn\xe9 Petrovice",
        townCode: 546976,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78306,
        lat: 49.740948,
        long: 17.405043
    },
    {
        town: 'Hrazany',
        townCode: 549410,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.52294,
        long: 14.33498
    },
    {
        town: "Hr\u010Dava",
        townCode: 598232,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73998,
        lat: 49.520116,
        long: 18.833235
    },
    {
        town: "Hrd\u011Bjovice",
        townCode: 544558,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37361,
        lat: 49.019035,
        long: 14.478672
    },
    {
        town: "Hrdibo\u0159ice",
        townCode: 589535,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79812,
        lat: 49.478575,
        long: 17.220521
    },
    {
        town: "Hrdl\xedv",
        townCode: 532363,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27306,
        lat: 50.199356,
        long: 14.072592
    },
    {
        town: "Hrdlo\u0159ezy",
        townCode: 535869,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29307,
        lat: 50.451494,
        long: 14.875505
    },
    {
        town: 'Hrejkovice',
        townCode: 549428,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39859,
        lat: 49.474473,
        long: 14.290912
    },
    {
        town: 'Hrob',
        townCode: 567558,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41704,
        lat: 50.659299,
        long: 13.726873
    },
    {
        town: 'Hrobce',
        townCode: 564893,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41183,
        lat: 50.462572,
        long: 14.230906
    },
    {
        town: "Hrob\u010Dice",
        townCode: 567566,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41757,
        lat: 50.517448,
        long: 13.785716
    },
    {
        town: 'Hrobice',
        townCode: 575046,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.103527,
        long: 15.78888
    },
    {
        town: 'Hrobice',
        townCode: 585262,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.277494,
        long: 17.788329
    },
    {
        town: "Hroch\u016Fv T\xfdnec",
        townCode: 571491,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.959563,
        long: 15.910648
    },
    {
        town: 'Hromnice',
        townCode: 558915,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.849175,
        long: 13.44157
    },
    {
        town: 'Hronov',
        townCode: 574082,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54931,
        lat: 50.480164,
        long: 16.181777
    },
    {
        town: 'Hrotovice',
        townCode: 590673,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.1078,
        long: 16.060777
    },
    {
        town: 'Hroubovice',
        townCode: 571504,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53854,
        lat: 49.882632,
        long: 15.990827
    },
    {
        town: "Hroznat\xedn",
        townCode: 550639,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.29784,
        long: 15.908371
    },
    {
        town: "Hrozn\u011Bt\xedn",
        townCode: 555185,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36233,
        lat: 50.309508,
        long: 12.871918
    },
    {
        town: "Hroznov\xe1 Lhota",
        townCode: 586188,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69663,
        lat: 48.90794,
        long: 17.417082
    },
    {
        town: "Hrub\xe1 Sk\xe1la",
        townCode: 577146,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.544906,
        long: 15.200342
    },
    {
        town: "Hrub\xe1 Vrbka",
        townCode: 586196,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69673,
        lat: 48.871977,
        long: 17.477119
    },
    {
        town: "Hrub\u010Dice",
        townCode: 589543,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79821,
        lat: 49.450115,
        long: 17.193197
    },
    {
        town: "Hrub\xfd Jesen\xedk",
        townCode: 599638,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28932,
        lat: 50.251247,
        long: 15.094151
    },
    {
        town: 'Hrusice',
        townCode: 538248,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25166,
        lat: 49.909951,
        long: 14.738162
    },
    {
        town: "Hru\u0161ka",
        townCode: 543543,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79827,
        lat: 49.358882,
        long: 17.22677
    },
    {
        town: "Hru\u0161ky",
        townCode: 584487,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69156,
        lat: 48.792823,
        long: 16.97415
    },
    {
        town: "Hru\u0161ky",
        townCode: 593079,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68352,
        lat: 49.129301,
        long: 16.833583
    },
    {
        town: "Hru\u0161ov",
        townCode: 565733,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29473,
        lat: 50.344973,
        long: 14.846482
    },
    {
        town: "Hru\u0161ov\xe1",
        townCode: 580341,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56555,
        lat: 49.91361,
        long: 16.197832
    },
    {
        town: "Hru\u0161ovany",
        townCode: 563072,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43143,
        lat: 50.387359,
        long: 13.498471
    },
    {
        town: "Hru\u0161ovany u Brna",
        townCode: 583081,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66462,
        lat: 49.038731,
        long: 16.59439
    },
    {
        town: "Hru\u0161ovany nad Jevi\u0161ovkou",
        townCode: 594156,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67167,
        lat: 48.830008,
        long: 16.40281
    },
    {
        town: 'Hrutov',
        townCode: 590681,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67527,
        lat: 49.255545,
        long: 15.680298
    },
    {
        town: "H\u0159ebe\u010D",
        townCode: 532371,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27345,
        lat: 50.136054,
        long: 14.164571
    },
    {
        town: "H\u0159ebe\u010Dn\xedky",
        townCode: 541761,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27041,
        lat: 49.984643,
        long: 13.753332
    },
    {
        town: "H\u0159edle",
        townCode: 531219,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.903899,
        long: 13.920708
    },
    {
        town: "H\u0159edle",
        townCode: 541770,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27008,
        lat: 50.188106,
        long: 13.749524
    },
    {
        town: "H\u0159ensko",
        townCode: 562513,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40717,
        lat: 50.87451,
        long: 14.242617
    },
    {
        town: "H\u0159ibiny-Ledsk\xe1",
        townCode: 548642,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.148079,
        long: 16.175968
    },
    {
        town: "H\u0159ibojedy",
        townCode: 579301,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.392163,
        long: 15.834831
    },
    {
        town: "H\u0159im\u011B\u017Edice",
        townCode: 540285,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26214,
        lat: 49.686956,
        long: 14.275016
    },
    {
        town: "H\u0159\xed\u0161ice",
        townCode: 546445,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.103431,
        long: 15.495538
    },
    {
        town: "H\u0159\xed\u0161kov",
        townCode: 566195,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43904,
        lat: 50.291438,
        long: 13.864363
    },
    {
        town: "H\u0159ivice",
        townCode: 566217,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43965,
        lat: 50.288215,
        long: 13.730349
    },
    {
        town: "H\u0159iv\xedn\u016Fv \xdajezd",
        townCode: 585271,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76307,
        lat: 49.121057,
        long: 17.690424
    },
    {
        town: 'Hubenov',
        townCode: 587222,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.392193,
        long: 15.469125
    },
    {
        town: "Hud\u010Dice",
        townCode: 513580,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.531789,
        long: 13.922614
    },
    {
        town: 'Hudlice',
        townCode: 531227,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26703,
        lat: 49.961069,
        long: 13.970742
    },
    {
        town: 'Hukvaldy',
        townCode: 598691,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73946,
        lat: 49.623907,
        long: 18.221998
    },
    {
        town: 'Hulice',
        townCode: 529737,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25763,
        lat: 49.709703,
        long: 15.087693
    },
    {
        town: "Hul\xedn",
        townCode: 588491,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76824,
        lat: 49.316992,
        long: 17.463848
    },
    {
        town: 'Humburky',
        townCode: 570087,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.226124,
        long: 15.511631
    },
    {
        town: 'Humpolec',
        townCode: 547999,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.541624,
        long: 15.359423
    },
    {
        town: "Hunt\xed\u0159ov",
        townCode: 562521,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.789539,
        long: 14.303537
    },
    {
        town: "H\u016Frky",
        townCode: 559849,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.745983,
        long: 13.683207
    },
    {
        town: 'Hurtova Lhota',
        townCode: 530646,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.596462,
        long: 15.508912
    },
    {
        town: "H\u016Fry",
        townCode: 535753,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 49.006592,
        long: 14.541183
    },
    {
        town: "Hus\xed Lhota",
        townCode: 599522,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.435646,
        long: 15.00482
    },
    {
        town: 'Husinec',
        townCode: 550230,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38421,
        lat: 49.055065,
        long: 13.987074
    },
    {
        town: 'Husinec',
        townCode: 538256,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25068,
        lat: 50.173845,
        long: 14.375186
    },
    {
        town: 'Huslenky',
        townCode: 542784,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75602,
        lat: 49.303274,
        long: 18.090479
    },
    {
        town: "Hustope\u010De",
        townCode: 584495,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.940946,
        long: 16.737726
    },
    {
        town: "Hustope\u010De nad Be\u010Dvou",
        townCode: 513768,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75366,
        lat: 49.530631,
        long: 17.870046
    },
    {
        town: "Hu\u0161t\u011Bnovice",
        townCode: 592218,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68703,
        lat: 49.108271,
        long: 17.464577
    },
    {
        town: 'Hutisko-Solanec',
        townCode: 542814,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75662,
        lat: 49.429584,
        long: 18.217836
    },
    {
        town: "Huzov\xe1",
        townCode: 597414,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79351,
        lat: 49.820063,
        long: 17.298064
    },
    {
        town: "Hv\u011Bzdlice",
        townCode: 593087,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68341,
        lat: 49.193463,
        long: 17.083627
    },
    {
        town: "Hv\u011Bzdonice",
        townCode: 529745,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25724,
        lat: 49.872921,
        long: 14.777379
    },
    {
        town: "Hv\u011Bzdo\u0148ovice",
        townCode: 590690,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.220011,
        long: 15.762318
    },
    {
        town: 'Hvozd',
        townCode: 589560,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79855,
        lat: 49.636303,
        long: 16.910181
    },
    {
        town: 'Hvozd',
        townCode: 558931,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33101,
        lat: 49.939841,
        long: 13.26323
    },
    {
        town: 'Hvozd',
        townCode: 565334,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.051606,
        long: 13.698511
    },
    {
        town: 'Hvozdec',
        townCode: 535613,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37372,
        lat: 48.99242,
        long: 14.62741
    },
    {
        town: 'Hvozdec',
        townCode: 583090,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.247005,
        long: 16.425292
    },
    {
        town: 'Hvozdec',
        townCode: 531235,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.807152,
        long: 13.880406
    },
    {
        town: "Hvozdn\xe1",
        townCode: 585289,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76311,
        lat: 49.248581,
        long: 17.751742
    },
    {
        town: 'Hvozdnice',
        townCode: 573621,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.191374,
        long: 15.711346
    },
    {
        town: 'Hvozdnice',
        townCode: 539261,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25205,
        lat: 49.872607,
        long: 14.3712
    },
    {
        town: "Hvo\u017E\u010Fany",
        townCode: 566331,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.505677,
        long: 12.771387
    },
    {
        town: "Hvo\u017E\u010Fany",
        townCode: 540315,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26244,
        lat: 49.528354,
        long: 13.805216
    },
    {
        town: "Hybr\xe1lec",
        townCode: 550281,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58601,
        lat: 49.409551,
        long: 15.589163
    },
    {
        town: "Hyn\u010Dice",
        townCode: 574163,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54983,
        lat: 50.623831,
        long: 16.285403
    },
    {
        town: "Hyn\u010Dina",
        townCode: 536113,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.848884,
        long: 16.793108
    },
    {
        town: "H\xfdskov",
        townCode: 531243,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26706,
        lat: 49.990829,
        long: 14.050654
    },
    {
        town: "H\xfdsly",
        townCode: 586200,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69650,
        lat: 49.023388,
        long: 17.179934
    },
    {
        town: "Chaba\u0159ovice",
        townCode: 568007,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40317,
        lat: 50.673287,
        long: 13.941955
    },
    {
        town: "Chabe\u0159ice",
        townCode: 534081,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.750246,
        long: 15.073898
    },
    {
        town: 'Chaloupky',
        townCode: 531251,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.791959,
        long: 13.868465
    },
    {
        town: 'Chanovice',
        townCode: 556335,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.405001,
        long: 13.717463
    },
    {
        town: 'Charvatce',
        townCode: 565784,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29445,
        lat: 50.322727,
        long: 14.998718
    },
    {
        town: "Charv\xe1ty",
        townCode: 568872,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78375,
        lat: 49.518462,
        long: 17.254067
    },
    {
        town: "Ch\xe1\u0159ovice",
        townCode: 532886,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25741,
        lat: 49.820354,
        long: 14.577967
    },
    {
        town: 'Chbany',
        townCode: 563081,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43157,
        lat: 50.332881,
        long: 13.430488
    },
    {
        town: 'Cheb',
        townCode: 554481,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.079633,
        long: 12.369964
    },
    {
        town: "Chel\u010Dice",
        townCode: 551139,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.121887,
        long: 14.169215
    },
    {
        town: 'Cheznovice',
        townCode: 559857,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33806,
        lat: 49.779032,
        long: 13.785491
    },
    {
        town: "Chlebi\u010Dov",
        townCode: 512923,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74731,
        lat: 49.959517,
        long: 17.967589
    },
    {
        town: 'Chleby',
        townCode: 532878,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25741,
        lat: 49.827106,
        long: 14.556986
    },
    {
        town: 'Chleby',
        townCode: 599620,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28931,
        lat: 50.222917,
        long: 15.089496
    },
    {
        town: 'Chleny',
        townCode: 576310,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51745,
        lat: 50.077977,
        long: 16.243846
    },
    {
        town: 'Chlistov',
        townCode: 556343,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.320001,
        long: 13.360983
    },
    {
        town: "Chl\xedstov",
        townCode: 590703,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.202158,
        long: 15.743777
    },
    {
        town: "Chl\xedstov",
        townCode: 548791,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.322469,
        long: 16.169563
    },
    {
        town: "Chl\xedstov",
        townCode: 532045,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.801625,
        long: 14.654822
    },
    {
        town: "Chl\xedstovice",
        townCode: 534099,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.885817,
        long: 15.202598
    },
    {
        town: 'Chlum',
        townCode: 529982,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.447303,
        long: 13.851194
    },
    {
        town: 'Chlum',
        townCode: 590711,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.313525,
        long: 15.767159
    },
    {
        town: 'Chlum',
        townCode: 561614,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.578538,
        long: 14.562772
    },
    {
        town: 'Chlum',
        townCode: 557773,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.605305,
        long: 13.479305
    },
    {
        town: 'Chlum',
        townCode: 540803,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.935789,
        long: 13.65979
    },
    {
        town: 'Chlum',
        townCode: 529770,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25763,
        lat: 49.693104,
        long: 14.99586
    },
    {
        town: "Chlum Svat\xe9 Ma\u0159\xed",
        townCode: 560375,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35709,
        lat: 50.149949,
        long: 12.535762
    },
    {
        town: "Chlum u T\u0159ebon\u011B",
        townCode: 546461,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37804,
        lat: 48.96245,
        long: 14.928089
    },
    {
        town: 'Chlumany',
        townCode: 550248,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.06667,
        long: 13.965462
    },
    {
        town: "Chlum\u010Dany",
        townCode: 557781,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33442,
        lat: 49.632666,
        long: 13.313337
    },
    {
        town: "Chlum\u010Dany",
        townCode: 566233,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43903,
        lat: 50.335042,
        long: 13.843328
    },
    {
        town: 'Chlumec',
        townCode: 536229,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.870362,
        long: 14.395976
    },
    {
        town: 'Chlumec',
        townCode: 568015,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40339,
        lat: 50.699825,
        long: 13.939752
    },
    {
        town: 'Chlumec nad Cidlinou',
        townCode: 570109,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.154506,
        long: 15.460363
    },
    {
        town: 'Chlumek',
        townCode: 595713,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59442,
        lat: 49.374585,
        long: 15.854861
    },
    {
        town: "Chlum\u011Bt\xedn",
        townCode: 595721,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59202,
        lat: 49.727586,
        long: 16.003178
    },
    {
        town: "Chlum\xedn",
        townCode: 534820,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27743,
        lat: 50.289218,
        long: 14.449384
    },
    {
        town: 'Chlum-Korouhvice',
        townCode: 595705,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.575317,
        long: 16.320783
    },
    {
        town: 'Chlumy',
        townCode: 540307,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.43786,
        long: 13.638713
    },
    {
        town: 'Chlustina',
        townCode: 534455,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.878043,
        long: 13.919627
    },
    {
        town: "Chmel\xedk",
        townCode: 572730,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.773488,
        long: 16.332883
    },
    {
        town: "Chmeln\xe1",
        townCode: 529788,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.648205,
        long: 14.988457
    },
    {
        town: 'Chobot',
        townCode: 536903,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.462516,
        long: 13.93382
    },
    {
        town: "Choce\u0148",
        townCode: 580350,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.001704,
        long: 16.223131
    },
    {
        town: 'Chocenice',
        townCode: 557803,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.547648,
        long: 13.520152
    },
    {
        town: 'Chocerady',
        townCode: 529796,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25724,
        lat: 49.873005,
        long: 14.802174
    },
    {
        town: "Chocn\u011Bjovice",
        townCode: 535923,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29413,
        lat: 50.577007,
        long: 14.971496
    },
    {
        town: "Chocomy\u0161l",
        townCode: 553727,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.467282,
        long: 13.13077
    },
    {
        town: "Chodou\u0148",
        townCode: 534447,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.898288,
        long: 13.986668
    },
    {
        town: 'Chodouny',
        townCode: 564923,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41171,
        lat: 50.47327,
        long: 14.250171
    },
    {
        town: 'Chodov',
        townCode: 578011,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36464,
        lat: 50.068626,
        long: 12.863016
    },
    {
        town: 'Chodov',
        townCode: 560383,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35735,
        lat: 50.23983,
        long: 12.747709
    },
    {
        town: 'Chodov',
        townCode: 553735,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34533,
        lat: 49.418088,
        long: 12.830346
    },
    {
        town: "Chodov\xe1 Plan\xe1",
        townCode: 560901,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34813,
        lat: 49.893323,
        long: 12.730254
    },
    {
        town: 'Chodovlice',
        townCode: 564931,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.463209,
        long: 13.993372
    },
    {
        town: "Chodsk\xe1 Lhota",
        townCode: 553743,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.358456,
        long: 13.083271
    },
    {
        town: "Chodsk\xfd \xdajezd",
        townCode: 560910,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.864425,
        long: 12.650047
    },
    {
        town: 'Cholenice',
        townCode: 549355,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.324828,
        long: 15.280763
    },
    {
        town: 'Cholina',
        townCode: 502839,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.656198,
        long: 17.054513
    },
    {
        town: 'Choltice',
        townCode: 575054,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53361,
        lat: 49.987822,
        long: 15.619515
    },
    {
        town: 'Chomle',
        townCode: 541141,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.86238,
        long: 13.63461
    },
    {
        town: 'Chomutice',
        townCode: 572969,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50753,
        lat: 50.359371,
        long: 15.496287
    },
    {
        town: 'Chomutov',
        townCode: 562971,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43004,
        lat: 50.463598,
        long: 13.410837
    },
    {
        town: "Chom\xfd\u017E",
        townCode: 588504,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.362473,
        long: 17.645513
    },
    {
        town: 'Choratice',
        townCode: 532606,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.83943,
        long: 14.874791
    },
    {
        town: 'Chornice',
        townCode: 578096,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56942,
        lat: 49.667478,
        long: 16.742731
    },
    {
        town: "Choru\u0161ice",
        townCode: 534838,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27737,
        lat: 50.390682,
        long: 14.670873
    },
    {
        town: "Choryn\u011B",
        townCode: 542831,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75642,
        lat: 49.495846,
        long: 17.898722
    },
    {
        town: "Cho\u0165\xe1nky",
        townCode: 537217,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.138263,
        long: 15.16254
    },
    {
        town: "Chot\u011Bbo\u0159",
        townCode: 568759,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.720714,
        long: 15.671142
    },
    {
        town: "Chot\u011Bbudice",
        townCode: 550477,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.058086,
        long: 15.574099
    },
    {
        town: "Chot\u011Bbuz",
        townCode: 555291,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73561,
        lat: 49.768592,
        long: 18.569232
    },
    {
        town: "Chote\u010D",
        townCode: 549037,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50781,
        lat: 50.432957,
        long: 15.516036
    },
    {
        town: "Chote\u010D",
        townCode: 575062,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53304,
        lat: 50.083128,
        long: 15.880341
    },
    {
        town: "Chote\u010D",
        townCode: 539287,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25226,
        lat: 49.986657,
        long: 14.283022
    },
    {
        town: "Chot\u011Bmice",
        townCode: 552453,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.275324,
        long: 14.877036
    },
    {
        town: "Chot\u011Bnov",
        townCode: 578100,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.823356,
        long: 16.189972
    },
    {
        town: "Chot\u011B\u0161ice",
        townCode: 537225,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28901,
        lat: 50.278663,
        long: 15.273164
    },
    {
        town: "Chot\u011B\u0161ov",
        townCode: 557838,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33214,
        lat: 49.65419,
        long: 13.202822
    },
    {
        town: "Chot\u011B\u0161ov",
        townCode: 564940,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.439891,
        long: 14.085254
    },
    {
        town: "Chot\u011Btov",
        townCode: 535931,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29428,
        lat: 50.337534,
        long: 14.801624
    },
    {
        town: "Chot\u011Bvice",
        townCode: 579319,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54371,
        lat: 50.521498,
        long: 15.766799
    },
    {
        town: "Chot\xedkov",
        townCode: 558940,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33017,
        lat: 49.793052,
        long: 13.317774
    },
    {
        town: 'Chotilsko',
        townCode: 540323,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.770587,
        long: 14.352585
    },
    {
        town: "Chotim\u011B\u0159",
        townCode: 564958,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.548326,
        long: 14.000996
    },
    {
        town: "Chotin\u011Bves",
        townCode: 564966,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.552187,
        long: 14.279353
    },
    {
        town: 'Chotovice',
        townCode: 561622,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47301,
        lat: 50.74039,
        long: 14.559384
    },
    {
        town: 'Chotovice',
        townCode: 578118,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.851152,
        long: 16.171354
    },
    {
        town: "Cho\u0165ovice",
        townCode: 534994,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28905,
        lat: 50.142489,
        long: 15.31978
    },
    {
        town: 'Chotoviny',
        townCode: 552461,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39137,
        lat: 49.478132,
        long: 14.677049
    },
    {
        town: 'Chotusice',
        townCode: 534102,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28576,
        lat: 49.949241,
        long: 15.394385
    },
    {
        town: 'Chotutice',
        townCode: 533343,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28103,
        lat: 50.070077,
        long: 14.989985
    },
    {
        town: "Chot\xfd\u010Dany",
        townCode: 535907,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37362,
        lat: 49.067394,
        long: 14.520691
    },
    {
        town: "Chotyn\u011B",
        townCode: 564109,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46334,
        lat: 50.83632,
        long: 14.869039
    },
    {
        town: "Chot\xfd\u0161any",
        townCode: 529818,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25728,
        lat: 49.744203,
        long: 14.814683
    },
    {
        town: "Choustn\xedk",
        townCode: 552470,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39118,
        lat: 49.333045,
        long: 14.838492
    },
    {
        town: "Choustn\xedkovo Hradi\u0161t\u011B",
        townCode: 579327,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54442,
        lat: 50.426514,
        long: 15.878682
    },
    {
        town: "Cho\u017Eov",
        townCode: 566241,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43922,
        lat: 50.39887,
        long: 13.859103
    },
    {
        town: 'Chraberce',
        townCode: 546429,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.408357,
        long: 13.829608
    },
    {
        town: 'Chrast',
        townCode: 571539,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.902149,
        long: 15.934067
    },
    {
        town: "Chr\xe1st",
        townCode: 558966,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33003,
        lat: 49.793305,
        long: 13.49369
    },
    {
        town: "Chr\xe1st",
        townCode: 537233,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28914,
        lat: 50.119017,
        long: 14.898236
    },
    {
        town: "Chr\xe1st",
        townCode: 564249,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.594513,
        long: 13.956768
    },
    {
        town: 'Chrastava',
        townCode: 564117,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46331,
        lat: 50.817027,
        long: 14.968947
    },
    {
        town: 'Chrastavec',
        townCode: 578126,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.617858,
        long: 16.503245
    },
    {
        town: 'Chrastavice',
        townCode: 553751,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.453663,
        long: 12.956921
    },
    {
        town: "Chr\xe1\u0161\u0165any",
        townCode: 544591,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37304,
        lat: 49.296087,
        long: 14.387621
    },
    {
        town: "Chr\xe1\u0161\u0165any",
        townCode: 532037,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.792155,
        long: 14.582032
    },
    {
        town: "Chr\xe1\u0161\u0165any",
        townCode: 533351,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.065584,
        long: 14.930251
    },
    {
        town: "Chr\xe1\u0161\u0165any",
        townCode: 539295,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25219,
        lat: 50.046148,
        long: 14.261423
    },
    {
        town: "Chr\xe1\u0161\u0165any",
        townCode: 541818,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27001,
        lat: 50.146543,
        long: 13.667388
    },
    {
        town: "Chra\u0161tice",
        townCode: 540358,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.576891,
        long: 14.071933
    },
    {
        town: "Chr\xe1\u0161\u0165ovice",
        townCode: 551155,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.333292,
        long: 13.89714
    },
    {
        town: "Chrbon\xedn",
        townCode: 563145,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39155,
        lat: 49.358766,
        long: 14.864401
    },
    {
        town: 'Chroboly',
        townCode: 550264,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38404,
        lat: 48.956632,
        long: 14.067078
    },
    {
        town: "Chrome\u010D",
        townCode: 569305,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.933846,
        long: 16.893779
    },
    {
        town: "Chropyn\u011B",
        townCode: 588512,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76811,
        lat: 49.35654,
        long: 17.364618
    },
    {
        town: 'Chroustov',
        townCode: 534706,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28902,
        lat: 50.28669,
        long: 15.347273
    },
    {
        town: 'Chroustovice',
        townCode: 571547,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53863,
        lat: 49.955625,
        long: 15.991536
    },
    {
        town: "Chrtn\xed\u010D",
        townCode: 568767,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.767642,
        long: 15.443719
    },
    {
        town: "Chrtn\xedky",
        townCode: 572764,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.9819,
        long: 15.604954
    },
    {
        town: 'Chrudichromy',
        townCode: 581534,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.502996,
        long: 16.628098
    },
    {
        town: 'Chrudim',
        townCode: 571164,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.949824,
        long: 15.795158
    },
    {
        town: 'Chrustenice',
        townCode: 533670,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26712,
        lat: 50.006145,
        long: 14.152325
    },
    {
        town: "Chr\u017E\xedn",
        townCode: 532398,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27324,
        lat: 50.295476,
        long: 14.270238
    },
    {
        town: "Ch\u0159enovice",
        townCode: 573574,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.716741,
        long: 15.216372
    },
    {
        town: "Ch\u0159ibsk\xe1",
        townCode: 562530,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40744,
        lat: 50.863346,
        long: 14.483083
    },
    {
        town: "Ch\u0159\xed\u010D",
        townCode: 558974,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.97192,
        long: 13.646002
    },
    {
        town: "Chud\u010Dice",
        townCode: 583111,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.288591,
        long: 16.458829
    },
    {
        town: 'Chudenice',
        townCode: 556378,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.466785,
        long: 13.17397
    },
    {
        town: "Chuden\xedn",
        townCode: 556386,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34022,
        lat: 49.29315,
        long: 13.100904
    },
    {
        town: 'Chuderov',
        townCode: 568023,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.68875,
        long: 14.046285
    },
    {
        town: "Chude\u0159ice",
        townCode: 570125,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.149139,
        long: 15.550972
    },
    {
        town: "Chud\xed\u0159",
        townCode: 571849,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29445,
        lat: 50.308893,
        long: 15.013907
    },
    {
        town: 'Chudoslavice',
        townCode: 546810,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.583028,
        long: 14.187346
    },
    {
        town: 'Chuchelna',
        townCode: 577154,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.602387,
        long: 15.300449
    },
    {
        town: "Chucheln\xe1",
        townCode: 507334,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74724,
        lat: 49.986735,
        long: 18.116667
    },
    {
        town: 'Chvalatice',
        townCode: 594164,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.947809,
        long: 15.751157
    },
    {
        town: "Chval\u010Dov",
        townCode: 506737,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76872,
        lat: 49.389281,
        long: 17.711595
    },
    {
        town: "Chvale\u010D",
        townCode: 579335,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54211,
        lat: 50.595999,
        long: 16.03941
    },
    {
        town: "Chv\xe1lenice",
        townCode: 557846,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33205,
        lat: 49.643095,
        long: 13.476053
    },
    {
        town: 'Chvaletice',
        townCode: 575071,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53312,
        lat: 50.034532,
        long: 15.418562
    },
    {
        town: "Chval\xedkovice",
        townCode: 569909,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74706,
        lat: 49.885738,
        long: 17.911052
    },
    {
        town: 'Chvalkovice',
        townCode: 593095,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68341,
        lat: 49.187125,
        long: 17.110212
    },
    {
        town: 'Chvalkovice',
        townCode: 574112,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55204,
        lat: 50.414437,
        long: 15.978392
    },
    {
        town: "Chvalnov-L\xedsky",
        townCode: 588547,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76805,
        lat: 49.166079,
        long: 17.231009
    },
    {
        town: 'Chvalovice',
        townCode: 537420,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.01045,
        long: 14.231802
    },
    {
        town: 'Chvalovice',
        townCode: 594172,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.786677,
        long: 16.082449
    },
    {
        town: "Chval\u0161iny",
        townCode: 545546,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38208,
        lat: 48.854119,
        long: 14.211239
    },
    {
        town: "Chvat\u011Bruby",
        townCode: 534846,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27801,
        lat: 50.232842,
        long: 14.342788
    },
    {
        town: 'Chvojenec',
        townCode: 575089,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.109676,
        long: 15.937327
    },
    {
        town: 'Chyjice',
        townCode: 549223,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.387734,
        long: 15.29557
    },
    {
        town: "Chy\u0148ava",
        townCode: 531294,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26707,
        lat: 50.027467,
        long: 14.074092
    },
    {
        town: "Ch\xfdn\u011B",
        townCode: 539309,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25301,
        lat: 50.060826,
        long: 14.227054
    },
    {
        town: "Ch\xfdnice",
        townCode: 513431,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25217,
        lat: 49.995792,
        long: 14.264385
    },
    {
        town: "Ch\xfdnov",
        townCode: 552496,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39155,
        lat: 49.406872,
        long: 14.811319
    },
    {
        town: "Ch\xfdstovice",
        townCode: 561339,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.585781,
        long: 15.079667
    },
    {
        town: "Chy\u0161e",
        townCode: 555207,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36453,
        lat: 50.104736,
        long: 13.249179
    },
    {
        town: "Chy\u0161ky",
        townCode: 549452,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39853,
        lat: 49.52356,
        long: 14.427673
    },
    {
        town: "Chy\u0161n\xe1",
        townCode: 561321,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.586467,
        long: 15.10003
    },
    {
        town: "Ch\xfd\u0161\u0165",
        townCode: 575097,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.128259,
        long: 15.541389
    },
    {
        town: "Iva\u0148",
        townCode: 584517,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69123,
        lat: 48.929811,
        long: 16.575843
    },
    {
        town: "Iva\u0148",
        townCode: 589578,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79823,
        lat: 49.424694,
        long: 17.251454
    },
    {
        town: "Ivan\u010Dice",
        townCode: 583120,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.101545,
        long: 16.377622
    },
    {
        town: "Ivanovice na Han\xe9",
        townCode: 593117,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68323,
        lat: 49.305518,
        long: 17.093537
    },
    {
        town: 'Jabkenice',
        townCode: 535966,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29445,
        lat: 50.324168,
        long: 15.01488
    },
    {
        town: "Jablo\u0148any",
        townCode: 581666,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.465713,
        long: 16.6061
    },
    {
        town: 'Jablonec nad Jizerou',
        townCode: 577162,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51243,
        lat: 50.703569,
        long: 15.429698
    },
    {
        town: 'Jablonec nad Nisou',
        townCode: 563510,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46601,
        lat: 50.722153,
        long: 15.170414
    },
    {
        town: "Jablonn\xe1",
        townCode: 540374,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26263,
        lat: 49.661146,
        long: 14.138547
    },
    {
        town: "Jablonn\xe9 nad Orlic\xed",
        townCode: 580376,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56164,
        lat: 50.029734,
        long: 16.600698
    },
    {
        town: "Jablonn\xe9 v Podje\u0161t\u011Bd\xed",
        townCode: 561631,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47125,
        lat: 50.765382,
        long: 14.760633
    },
    {
        town: "Jablo\u0148ov",
        townCode: 595730,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.324114,
        long: 16.089764
    },
    {
        town: "Jabl\u016Fnka",
        townCode: 542865,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75623,
        lat: 49.383651,
        long: 17.950317
    },
    {
        town: 'Jablunkov',
        townCode: 598259,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73991,
        lat: 49.576815,
        long: 18.764694
    },
    {
        town: 'Jahodov',
        townCode: 548782,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51601,
        lat: 50.150364,
        long: 16.333536
    },
    {
        town: "J\xe1chymov",
        townCode: 555215,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36251,
        lat: 50.358573,
        long: 12.934767
    },
    {
        town: 'Jakartovice',
        townCode: 507377,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74753,
        lat: 49.915196,
        long: 17.684108
    },
    {
        town: "Jakub\u010Dovice nad Odrou",
        townCode: 554065,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74236,
        lat: 49.695138,
        long: 17.787781
    },
    {
        town: "Jakubov u Moravsk\xfdch Bud\u011Bjovic",
        townCode: 590746,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.081114,
        long: 15.761519
    },
    {
        town: 'Jakubovice',
        townCode: 553344,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78991,
        lat: 49.994405,
        long: 16.828875
    },
    {
        town: "Jalub\xed",
        townCode: 592226,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68705,
        lat: 49.116359,
        long: 17.427985
    },
    {
        town: "Jamn\xe9",
        townCode: 587249,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.431232,
        long: 15.723948
    },
    {
        town: "Jamn\xe9 nad Orlic\xed",
        townCode: 580392,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56165,
        lat: 50.039685,
        long: 16.633004
    },
    {
        town: 'Jamolice',
        townCode: 594181,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.072435,
        long: 16.253784
    },
    {
        town: "J\xe1my",
        townCode: 595756,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59232,
        lat: 49.530363,
        long: 16.005752
    },
    {
        town: 'Jankov',
        townCode: 544612,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.966544,
        long: 14.297986
    },
    {
        town: 'Jankov',
        townCode: 561461,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.415196,
        long: 15.38632
    },
    {
        town: 'Jankov',
        townCode: 529842,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25703,
        lat: 49.653039,
        long: 14.730847
    },
    {
        town: 'Jankovice',
        townCode: 575101,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.007735,
        long: 15.529259
    },
    {
        town: 'Jankovice',
        townCode: 588555,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.35638,
        long: 17.618744
    },
    {
        town: 'Jankovice',
        townCode: 592234,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68704,
        lat: 49.154219,
        long: 17.388585
    },
    {
        town: "Janou\u0161ov",
        townCode: 553212,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78991,
        lat: 50.01321,
        long: 16.845209
    },
    {
        town: 'Janov',
        townCode: 576328,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.332407,
        long: 16.25188
    },
    {
        town: 'Janov',
        townCode: 597431,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79384,
        lat: 50.244949,
        long: 17.481294
    },
    {
        town: 'Janov',
        townCode: 578134,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56955,
        lat: 49.840871,
        long: 16.385333
    },
    {
        town: 'Janov',
        townCode: 565270,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27006,
        lat: 50.210508,
        long: 13.639913
    },
    {
        town: 'Janov',
        townCode: 544680,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.860304,
        long: 14.265378
    },
    {
        town: 'Janov nad Nisou',
        townCode: 563595,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46811,
        lat: 50.772141,
        long: 15.169244
    },
    {
        town: "Janov\xe1",
        townCode: 570346,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75501,
        lat: 49.312144,
        long: 18.020158
    },
    {
        town: 'Janovice',
        townCode: 507423,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73911,
        lat: 49.621505,
        long: 18.406126
    },
    {
        town: "Janovice nad \xdahlavou",
        townCode: 556394,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.345257,
        long: 13.218239
    },
    {
        town: "Janovice v Podje\u0161t\u011Bd\xed",
        townCode: 561657,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46353,
        lat: 50.762974,
        long: 14.824344
    },
    {
        town: "Jansk\xe1",
        townCode: 530395,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.80461,
        long: 14.363559
    },
    {
        town: "Jansk\xe9 L\xe1zn\u011B",
        townCode: 579351,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54225,
        lat: 50.631188,
        long: 15.781916
    },
    {
        town: "Jan\u016Fv D\u016Fl",
        townCode: 546658,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46352,
        lat: 50.704656,
        long: 14.940408
    },
    {
        town: "Jan\u016Fvky",
        townCode: 578142,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.671651,
        long: 16.592171
    },
    {
        town: "Jarcov\xe1",
        townCode: 542903,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75701,
        lat: 49.444628,
        long: 17.965972
    },
    {
        town: "Jarohn\u011Bvice",
        townCode: 588563,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76801,
        lat: 49.267176,
        long: 17.377672
    },
    {
        town: "Jarom\u011B\u0159",
        townCode: 574121,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.356904,
        long: 15.924238
    },
    {
        town: "Jarom\u011B\u0159ice",
        townCode: 578151,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56944,
        lat: 49.625661,
        long: 16.751955
    },
    {
        town: "Jarom\u011B\u0159ice nad Rokytnou",
        townCode: 590754,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.094184,
        long: 15.893408
    },
    {
        town: 'Jaroslav',
        townCode: 575119,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.012339,
        long: 16.077983
    },
    {
        town: 'Jaroslavice',
        townCode: 594199,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.756671,
        long: 16.233615
    },
    {
        town: "Jaro\u0161ov",
        townCode: 578169,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56966,
        lat: 49.824915,
        long: 16.16347
    },
    {
        town: "Jaro\u0161ov nad Ne\u017E\xe1rkou",
        townCode: 546500,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37841,
        lat: 49.189995,
        long: 15.06744
    },
    {
        town: 'Jarov',
        townCode: 578541,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.521192,
        long: 13.507696
    },
    {
        town: 'Jarov',
        townCode: 558982,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.872569,
        long: 13.474387
    },
    {
        town: 'Jarpice',
        townCode: 532401,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27372,
        lat: 50.321709,
        long: 14.08533
    },
    {
        town: 'Jasenice',
        townCode: 590762,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.25824,
        long: 16.163698
    },
    {
        town: "Jasenn\xe1",
        townCode: 574139,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55222,
        lat: 50.318379,
        long: 15.99108
    },
    {
        town: "Jasenn\xe1",
        townCode: 585301,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76313,
        lat: 49.253493,
        long: 17.894297
    },
    {
        town: 'Javor',
        townCode: 541869,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.325542,
        long: 13.247541
    },
    {
        town: 'Javorek',
        townCode: 595748,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.65028,
        long: 16.17387
    },
    {
        town: 'Javornice',
        townCode: 576336,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51711,
        lat: 50.171465,
        long: 16.349372
    },
    {
        town: "Javorn\xedk",
        townCode: 586218,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69674,
        lat: 48.862174,
        long: 17.533503
    },
    {
        town: "Javorn\xedk",
        townCode: 536148,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79070,
        lat: 50.390868,
        long: 17.002821
    },
    {
        town: "Javorn\xedk",
        townCode: 572713,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.782812,
        long: 16.427483
    },
    {
        town: "Javorn\xedk",
        townCode: 580406,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.889566,
        long: 16.156118
    },
    {
        town: "Javorn\xedk",
        townCode: 529851,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25763,
        lat: 49.686598,
        long: 15.026636
    },
    {
        town: "Jav\u016Frek",
        townCode: 583154,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.255628,
        long: 16.362283
    },
    {
        town: "Jedl\xe1",
        townCode: 568783,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.73822,
        long: 15.234446
    },
    {
        town: 'Jedlany',
        townCode: 562963,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39137,
        lat: 49.494676,
        long: 14.71654
    },
    {
        town: "Jedl\xed",
        townCode: 536288,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.931312,
        long: 16.794838
    },
    {
        town: "Jedlov\xe1",
        townCode: 578185,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56991,
        lat: 49.661104,
        long: 16.306186
    },
    {
        town: "Jedom\u011Blice",
        townCode: 532410,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27378,
        lat: 50.233057,
        long: 13.972409
    },
    {
        town: 'Jedousov',
        townCode: 575127,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.995451,
        long: 15.610295
    },
    {
        town: 'Jedovnice',
        townCode: 581682,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.344631,
        long: 16.756055
    },
    {
        town: "Jehn\u011Bd\xed",
        townCode: 580414,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 49.971109,
        long: 16.310007
    },
    {
        town: 'Jemnice',
        townCode: 590789,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.019086,
        long: 15.570038
    },
    {
        town: "Jemn\xedky",
        townCode: 532428,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27401,
        lat: 50.207644,
        long: 14.119076
    },
    {
        town: "Jen\u010Dice",
        townCode: 505528,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.483044,
        long: 14.004486
    },
    {
        town: "Jene\u010D",
        townCode: 539317,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25261,
        lat: 50.087404,
        long: 14.214924
    },
    {
        town: "Jen\xedkov",
        townCode: 547816,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.74259,
        long: 15.957449
    },
    {
        town: "Jen\xedkov",
        townCode: 567582,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41724,
        lat: 50.628702,
        long: 13.749019
    },
    {
        town: "Jen\xedkovice",
        townCode: 570133,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.22828,
        long: 16.002737
    },
    {
        town: "Jen\xedkovice",
        townCode: 575135,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.981594,
        long: 15.660618
    },
    {
        town: "Jeni\u0161ov",
        townCode: 537926,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.226649,
        long: 12.800046
    },
    {
        town: "Jeni\u0161ovice",
        townCode: 563609,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46833,
        lat: 50.627796,
        long: 15.136637
    },
    {
        town: "Jeni\u0161ovice",
        townCode: 571563,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53864,
        lat: 49.929644,
        long: 16.03112
    },
    {
        town: "Jen\u0161tejn",
        townCode: 538264,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25073,
        lat: 50.152759,
        long: 14.611909
    },
    {
        town: "Jers\xedn",
        townCode: 587265,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58825,
        lat: 49.421358,
        long: 15.830768
    },
    {
        town: "Je\u0159ice",
        townCode: 572993,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.344654,
        long: 15.680876
    },
    {
        town: "Je\u0159i\u0161no",
        townCode: 568805,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58274,
        lat: 49.792454,
        long: 15.641764
    },
    {
        town: "Je\u0159manice",
        townCode: 530484,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46312,
        lat: 50.699666,
        long: 15.09393
    },
    {
        town: 'Jesenec',
        townCode: 589586,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79853,
        lat: 49.608512,
        long: 16.862184
    },
    {
        town: 'Jesenice',
        townCode: 539325,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25242,
        lat: 49.968246,
        long: 14.513602
    },
    {
        town: 'Jesenice',
        townCode: 540391,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.607849,
        long: 14.47823
    },
    {
        town: 'Jesenice',
        townCode: 541834,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27033,
        lat: 50.097137,
        long: 13.469595
    },
    {
        town: "Jesen\xedk",
        townCode: 536385,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79001,
        lat: 50.224725,
        long: 17.198147
    },
    {
        town: "Jesen\xedk nad Odrou",
        townCode: 599468,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74233,
        lat: 49.61204,
        long: 17.905365
    },
    {
        town: "Jesenn\xfd",
        townCode: 577171,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51212,
        lat: 50.660595,
        long: 15.338516
    },
    {
        town: "Jest\u0159ab\xed",
        townCode: 585319,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76333,
        lat: 49.068135,
        long: 17.955981
    },
    {
        town: "Jest\u0159ab\xed Lhota",
        townCode: 533360,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.089936,
        long: 15.261812
    },
    {
        town: "Jest\u0159ab\xed v Krkono\u0161\xedch",
        townCode: 577189,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.680618,
        long: 15.491835
    },
    {
        town: "Jest\u0159eb\xed",
        townCode: 574147,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.362184,
        long: 16.182163
    },
    {
        town: "Jest\u0159eb\xed",
        townCode: 561665,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47161,
        lat: 50.608694,
        long: 14.584657
    },
    {
        town: "Jest\u0159eb\xed",
        townCode: 536393,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.852199,
        long: 16.868736
    },
    {
        town: "Je\u0161etice",
        townCode: 532134,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25789,
        lat: 49.581263,
        long: 14.610228
    },
    {
        town: "Jet\u011Btice",
        townCode: 549479,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39848,
        lat: 49.386055,
        long: 14.29271
    },
    {
        town: "Jet\u0159ichov",
        townCode: 574155,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54983,
        lat: 50.615071,
        long: 16.266763
    },
    {
        town: "Jet\u0159ichovice",
        townCode: 562556,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40716,
        lat: 50.852494,
        long: 14.394022
    },
    {
        town: 'Jevany',
        townCode: 533378,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28166,
        lat: 49.970671,
        long: 14.810582
    },
    {
        town: "Jev\xed\u010Dko",
        townCode: 578193,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.632295,
        long: 16.71136
    },
    {
        town: "Jevin\u011Bves",
        townCode: 531871,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27705,
        lat: 50.345214,
        long: 14.33821
    },
    {
        town: "Jevi\u0161ovice",
        townCode: 594202,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.987465,
        long: 15.990027
    },
    {
        town: "Jevi\u0161ovka",
        townCode: 584525,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69183,
        lat: 48.82869,
        long: 16.46626
    },
    {
        town: "Jezbo\u0159ice",
        townCode: 575143,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.980674,
        long: 15.694777
    },
    {
        town: 'Jezdkovice',
        townCode: 547191,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74755,
        lat: 49.923129,
        long: 17.774912
    },
    {
        town: 'Jezdovice',
        townCode: 587273,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58901,
        lat: 49.323203,
        long: 15.484258
    },
    {
        town: 'Jezernice',
        townCode: 556998,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.547873,
        long: 17.625008
    },
    {
        town: "Jeze\u0159any-Mar\u0161ovice",
        townCode: 594211,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67175,
        lat: 49.028912,
        long: 16.437429
    },
    {
        town: "Je\u017Een\xe1",
        townCode: 587281,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58841,
        lat: 49.416395,
        long: 15.465658
    },
    {
        town: "Je\u017Ekovice",
        townCode: 593125,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68304,
        lat: 49.298073,
        long: 16.892634
    },
    {
        town: "Je\u017Eov",
        townCode: 586226,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69648,
        lat: 49.027077,
        long: 17.210115
    },
    {
        town: "Je\u017Eov",
        townCode: 548073,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.613127,
        long: 15.23382
    },
    {
        town: "Je\u017Eovy",
        townCode: 541753,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.491162,
        long: 13.228504
    },
    {
        town: 'Jickovice',
        townCode: 562084,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.450736,
        long: 14.215979
    },
    {
        town: "Ji\u010D\xedn",
        townCode: 572659,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.435433,
        long: 15.361144
    },
    {
        town: "Ji\u010D\xedn\u011Bves",
        townCode: 573001,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50731,
        lat: 50.373176,
        long: 15.337392
    },
    {
        town: 'Jihlava',
        townCode: 586846,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58601,
        lat: 49.41586,
        long: 15.595469
    },
    {
        town: "Jihl\xe1vka",
        townCode: 587290,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.261225,
        long: 15.292576
    },
    {
        town: "J\xedkev",
        townCode: 537250,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28932,
        lat: 50.264465,
        long: 15.060123
    },
    {
        town: 'Jilem',
        townCode: 562769,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.17677,
        long: 15.268924
    },
    {
        town: 'Jilem',
        townCode: 548413,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.713475,
        long: 15.58347
    },
    {
        town: 'Jilemnice',
        townCode: 577197,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.608996,
        long: 15.506637
    },
    {
        town: "J\xedlov\xe9",
        townCode: 562564,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40701,
        lat: 50.760925,
        long: 14.103948
    },
    {
        town: "J\xedlov\xe9 u Dr\u017Ekova",
        townCode: 563617,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.670963,
        long: 15.295375
    },
    {
        town: "J\xedlov\xe9 u Prahy",
        townCode: 539333,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25401,
        lat: 49.895549,
        long: 14.493434
    },
    {
        town: "J\xedlovice",
        townCode: 544639,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37332,
        lat: 48.889587,
        long: 14.726899
    },
    {
        town: "J\xedlovice",
        townCode: 576352,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51772,
        lat: 50.250722,
        long: 16.012785
    },
    {
        town: "J\xedlovi\u0161t\u011B",
        townCode: 539341,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25202,
        lat: 49.927626,
        long: 14.342843
    },
    {
        town: "Jiml\xedn",
        townCode: 546011,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.320403,
        long: 13.747256
    },
    {
        town: 'Jimramov',
        townCode: 595772,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59242,
        lat: 49.637288,
        long: 16.226424
    },
    {
        town: "Jina\u010Dovice",
        townCode: 583171,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66434,
        lat: 49.267903,
        long: 16.529591
    },
    {
        town: 'Jince',
        townCode: 540404,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.786343,
        long: 13.978781
    },
    {
        town: "Jind\u0159ichov",
        townCode: 597449,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79383,
        lat: 50.251932,
        long: 17.519131
    },
    {
        town: "Jind\u0159ichov",
        townCode: 513873,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.644693,
        long: 17.748345
    },
    {
        town: "Jind\u0159ichov",
        townCode: 536521,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78823,
        lat: 50.095891,
        long: 16.985006
    },
    {
        town: "Jind\u0159ichovice",
        townCode: 560413,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.28276,
        long: 12.602422
    },
    {
        town: "Jind\u0159ichovice",
        townCode: 587303,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.137705,
        long: 15.638697
    },
    {
        town: "Jind\u0159ichovice pod Smrkem",
        townCode: 564133,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46365,
        lat: 50.960916,
        long: 15.249643
    },
    {
        town: "Jind\u0159ich\u016Fv Hradec",
        townCode: 545881,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.144582,
        long: 15.006239
    },
    {
        town: "Jin\xedn",
        townCode: 551163,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.227879,
        long: 13.982656
    },
    {
        town: "Jino\u010Dany",
        townCode: 539350,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25225,
        lat: 50.032857,
        long: 14.268789
    },
    {
        town: 'Jinolice',
        townCode: 549151,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.478592,
        long: 15.32977
    },
    {
        town: "Jino\u0161ov",
        townCode: 590797,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.231477,
        long: 16.193554
    },
    {
        town: 'Jiratice',
        townCode: 550591,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.983174,
        long: 15.612866
    },
    {
        town: 'Jirkov',
        townCode: 563099,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43111,
        lat: 50.500627,
        long: 13.448885
    },
    {
        town: 'Jirny',
        townCode: 538272,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25090,
        lat: 50.115879,
        long: 14.699337
    },
    {
        town: "Ji\u0159et\xedn pod Bukovou",
        townCode: 546585,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46843,
        lat: 50.755788,
        long: 15.26303
    },
    {
        town: "Ji\u0159et\xedn pod Jedlovou",
        townCode: 562572,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40756,
        lat: 50.874552,
        long: 14.57519
    },
    {
        town: "Ji\u0159ice",
        townCode: 548081,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.55332,
        long: 15.31844
    },
    {
        town: "Ji\u0159ice",
        townCode: 599581,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28922,
        lat: 50.252532,
        long: 14.836959
    },
    {
        town: "Ji\u0159ice u Miroslavi",
        townCode: 594229,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.920914,
        long: 16.39205
    },
    {
        town: "Ji\u0159ice u Moravsk\xfdch Bud\u011Bjovic",
        townCode: 550841,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 48.993974,
        long: 15.925489
    },
    {
        town: "Ji\u0159\xedkov",
        townCode: 597457,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79351,
        lat: 49.854028,
        long: 17.277651
    },
    {
        town: "Ji\u0159\xedkov",
        townCode: 562581,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40753,
        lat: 50.993471,
        long: 14.568449
    },
    {
        town: "Ji\u0159\xedkovice",
        townCode: 583189,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66451,
        lat: 49.166816,
        long: 16.758096
    },
    {
        town: 'Jistebnice',
        townCode: 552534,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39133,
        lat: 49.485634,
        long: 14.527704
    },
    {
        town: "Jistebn\xedk",
        townCode: 599506,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74282,
        lat: 49.754094,
        long: 18.130739
    },
    {
        town: 'Jitkov',
        townCode: 546216,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.662324,
        long: 15.7274
    },
    {
        town: 'Jivina',
        townCode: 531308,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.794246,
        long: 13.836497
    },
    {
        town: 'Jivina',
        townCode: 535974,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29414,
        lat: 50.554218,
        long: 14.947263
    },
    {
        town: "J\xedvka",
        townCode: 579378,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54213,
        lat: 50.535096,
        long: 16.109111
    },
    {
        town: 'Jivno',
        townCode: 535761,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 48.99562,
        long: 14.569321
    },
    {
        town: "J\xedvov\xe1",
        townCode: 503142,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78316,
        lat: 49.70927,
        long: 17.394675
    },
    {
        town: "J\xedvov\xed",
        townCode: 595802,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.40547,
        long: 16.090844
    },
    {
        town: 'Jizbice',
        townCode: 537268,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.257782,
        long: 14.993959
    },
    {
        town: "Jizern\xed Vtelno",
        townCode: 566039,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29431,
        lat: 50.369496,
        long: 14.853294
    },
    {
        town: 'Josefov',
        townCode: 586234,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69621,
        lat: 48.839579,
        long: 17.010146
    },
    {
        town: 'Josefov',
        townCode: 511587,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35709,
        lat: 50.211627,
        long: 12.579546
    },
    {
        town: "Josef\u016Fv D\u016Fl",
        townCode: 563633,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46844,
        lat: 50.782016,
        long: 15.231574
    },
    {
        town: "Josef\u016Fv D\u016Fl",
        townCode: 529613,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29307,
        lat: 50.453507,
        long: 14.893781
    },
    {
        town: "Kac\xe1kova Lhota",
        townCode: 549312,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.409627,
        long: 15.419326
    },
    {
        town: 'Kacanovy',
        townCode: 577201,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.550769,
        long: 15.14538
    },
    {
        town: "Kace\u0159ov",
        townCode: 560421,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35751,
        lat: 50.14885,
        long: 12.504505
    },
    {
        town: "Kace\u0159ov",
        townCode: 558991,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.870714,
        long: 13.512774
    },
    {
        town: "K\xe1cov",
        townCode: 534129,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28509,
        lat: 49.777968,
        long: 15.027994
    },
    {
        town: "Ka\u010Dice",
        townCode: 532444,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27304,
        lat: 50.162716,
        long: 13.98826
    },
    {
        town: "Ka\u010Dlehy",
        townCode: 562491,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.108963,
        long: 15.077166
    },
    {
        town: "Kada\u0148",
        townCode: 563102,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43201,
        lat: 50.376092,
        long: 13.271422
    },
    {
        town: "Kadl\xedn",
        townCode: 531774,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27735,
        lat: 50.399568,
        long: 14.699845
    },
    {
        town: 'Kadolec',
        townCode: 595811,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.374803,
        long: 16.141838
    },
    {
        town: 'Kadov',
        townCode: 551180,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38733,
        lat: 49.402831,
        long: 13.774881
    },
    {
        town: 'Kadov',
        townCode: 594237,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 48.982858,
        long: 16.287457
    },
    {
        town: 'Kadov',
        townCode: 595829,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.632666,
        long: 16.079322
    },
    {
        town: "K\xe1jov",
        townCode: 545554,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38221,
        lat: 48.810921,
        long: 14.258692
    },
    {
        town: 'Kakejcov',
        townCode: 579017,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.667036,
        long: 13.624286
    },
    {
        town: 'Kalek',
        townCode: 563111,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43132,
        lat: 50.577837,
        long: 13.322071
    },
    {
        town: 'Kalenice',
        townCode: 536946,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.271655,
        long: 13.7168
    },
    {
        town: 'Kalhov',
        townCode: 587320,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.481127,
        long: 15.44153
    },
    {
        town: "Kali\u0161t\u011B",
        townCode: 587338,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.241354,
        long: 15.301432
    },
    {
        town: "Kali\u0161t\u011B",
        townCode: 548090,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39451,
        lat: 49.5927,
        long: 15.304162
    },
    {
        town: "Kali\u0161t\u011B",
        townCode: 538281,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25165,
        lat: 49.882761,
        long: 14.774613
    },
    {
        town: 'Kalivody',
        townCode: 565440,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.208527,
        long: 13.841968
    },
    {
        town: 'Kaly',
        townCode: 595837,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.379422,
        long: 16.351706
    },
    {
        town: 'Kamberk',
        townCode: 531031,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25706,
        lat: 49.597236,
        long: 14.840416
    },
    {
        town: "K\xe1men",
        townCode: 568821,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58242,
        lat: 49.711957,
        long: 15.519989
    },
    {
        town: "K\xe1men",
        townCode: 548103,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39413,
        lat: 49.423391,
        long: 15.015964
    },
    {
        town: "K\xe1men",
        townCode: 546453,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40713,
        lat: 50.810319,
        long: 14.268547
    },
    {
        town: 'Kamenec',
        townCode: 566811,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.881166,
        long: 13.596339
    },
    {
        town: "Kamenec u Poli\u010Dky",
        townCode: 578207,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.707979,
        long: 16.233812
    },
    {
        town: 'Kamenice',
        townCode: 587346,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58823,
        lat: 49.366688,
        long: 15.780333
    },
    {
        town: 'Kamenice',
        townCode: 538299,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25168,
        lat: 49.901617,
        long: 14.582527
    },
    {
        town: 'Kamenice nad Lipou',
        townCode: 548111,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.303136,
        long: 15.075292
    },
    {
        town: "Kamenick\xfd \u0160enov",
        townCode: 561681,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47114,
        lat: 50.773693,
        long: 14.472979
    },
    {
        town: "Kameni\u010Dky",
        townCode: 571571,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53941,
        lat: 49.736024,
        long: 15.975128
    },
    {
        town: "Kameni\u010Dn\xe1",
        townCode: 580422,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.120278,
        long: 16.435011
    },
    {
        town: "Kamenn\xe1",
        townCode: 535982,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.779882,
        long: 14.671182
    },
    {
        town: "Kamenn\xe1",
        townCode: 587362,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.51005,
        long: 15.652675
    },
    {
        town: "Kamenn\xe1",
        townCode: 590801,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.272529,
        long: 16.060488
    },
    {
        town: "Kamenn\xe1",
        townCode: 536571,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78974,
        lat: 49.859436,
        long: 17.031142
    },
    {
        town: "Kamenn\xe1 Horka",
        townCode: 578215,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.738007,
        long: 16.52403
    },
    {
        town: "Kamenn\xe1 Lhota",
        townCode: 568848,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58292,
        lat: 49.643905,
        long: 15.275344
    },
    {
        town: "Kamenn\xe9 Zbo\u017E\xed",
        townCode: 537276,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.193015,
        long: 14.99953
    },
    {
        town: "Kamenn\xe9 \u017Dehrovice",
        townCode: 532452,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27301,
        lat: 50.127079,
        long: 14.0182
    },
    {
        town: "Kamenn\xfd Mal\xedkov",
        townCode: 598631,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.211998,
        long: 15.122369
    },
    {
        town: "Kamenn\xfd Most",
        townCode: 513032,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27326,
        lat: 50.241505,
        long: 14.205845
    },
    {
        town: "Kamenn\xfd P\u0159\xedvoz",
        townCode: 539368,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25282,
        lat: 49.863096,
        long: 14.503494
    },
    {
        town: "Kamenn\xfd \xdajezd",
        townCode: 544663,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37381,
        lat: 48.897635,
        long: 14.446481
    },
    {
        town: "Kamenn\xfd \xdajezd",
        townCode: 541150,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.723772,
        long: 13.618864
    },
    {
        town: "Kam\xfdk",
        townCode: 546771,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.558481,
        long: 14.07749
    },
    {
        town: "Kam\xfdk nad Vltavou",
        townCode: 540439,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26263,
        lat: 49.639124,
        long: 14.253549
    },
    {
        town: 'Kanice',
        townCode: 583197,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66401,
        lat: 49.263805,
        long: 16.714624
    },
    {
        town: 'Kanice',
        townCode: 566144,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.475118,
        long: 13.072809
    },
    {
        town: "Kani\u010Dky",
        townCode: 553778,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.474432,
        long: 13.145358
    },
    {
        town: 'Kanina',
        townCode: 531651,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27735,
        lat: 50.424809,
        long: 14.600046
    },
    {
        town: "Ka\u0148ovice",
        townCode: 598275,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73936,
        lat: 49.744405,
        long: 18.39622
    },
    {
        town: "Ka\u0148ovice",
        townCode: 585327,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76341,
        lat: 49.109153,
        long: 17.698856
    },
    {
        town: 'Kaplice',
        townCode: 545562,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38241,
        lat: 48.738589,
        long: 14.496373
    },
    {
        town: "K\xe1ranice",
        townCode: 570150,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50366,
        lat: 50.153056,
        long: 15.557599
    },
    {
        town: "K\xe1ran\xfd",
        townCode: 564974,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25075,
        lat: 50.174869,
        long: 14.7371
    },
    {
        town: "Karda\u0161ova \u0158e\u010Dice",
        townCode: 546542,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.184882,
        long: 14.853256
    },
    {
        town: 'Karle',
        townCode: 572748,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.766089,
        long: 16.364833
    },
    {
        town: "Karl\xedk",
        townCode: 599727,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25229,
        lat: 49.935506,
        long: 14.259616
    },
    {
        town: "Karl\xedn",
        townCode: 586242,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69614,
        lat: 48.975875,
        long: 16.977406
    },
    {
        town: 'Karlov',
        townCode: 595845,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.647105,
        long: 15.914538
    },
    {
        town: "Karlova Stud\xe1nka",
        townCode: 597473,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79324,
        lat: 50.073193,
        long: 17.30696
    },
    {
        town: 'Karlova Ves',
        townCode: 565288,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 49.987386,
        long: 13.862509
    },
    {
        town: 'Karlovice',
        townCode: 577219,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.561843,
        long: 15.20728
    },
    {
        town: 'Karlovice',
        townCode: 597481,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79326,
        lat: 50.105736,
        long: 17.445738
    },
    {
        town: 'Karlovice',
        townCode: 587052,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76302,
        lat: 49.176512,
        long: 17.585926
    },
    {
        town: 'Karlovy Vary',
        townCode: 554961,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.231952,
        long: 12.872062
    },
    {
        town: "Karl\u0161tejn",
        townCode: 531316,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.939604,
        long: 14.188146
    },
    {
        town: "Karol\xedn",
        townCode: 587354,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.230694,
        long: 17.43461
    },
    {
        town: 'Karolinka',
        townCode: 542911,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75605,
        lat: 49.351376,
        long: 18.240174
    },
    {
        town: "KARVIN\xc1",
        townCode: 598917,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73301,
        lat: 49.856752,
        long: 18.543319
    },
    {
        town: "Ka\u0159ez",
        townCode: 559903,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.824356,
        long: 13.781719
    },
    {
        town: "Ka\u0159\xedzek",
        townCode: 530361,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.813466,
        long: 13.799741
    },
    {
        town: 'Kasalice',
        townCode: 575151,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.118105,
        long: 15.609768
    },
    {
        town: 'Kasejovice',
        townCode: 557862,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33544,
        lat: 49.462805,
        long: 13.740706
    },
    {
        town: "Ka\u0161ava",
        townCode: 585343,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76319,
        lat: 49.295509,
        long: 17.785771
    },
    {
        town: "Ka\u0161nice",
        townCode: 550256,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69172,
        lat: 48.996536,
        long: 16.882945
    },
    {
        town: "Ka\u0161persk\xe9 Hory",
        townCode: 556432,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34192,
        lat: 49.143,
        long: 13.556264
    },
    {
        town: "Kate\u0159inice",
        townCode: 568643,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74258,
        lat: 49.669288,
        long: 18.188284
    },
    {
        town: "Kate\u0159inice",
        townCode: 542946,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75621,
        lat: 49.382193,
        long: 17.885865
    },
    {
        town: 'Katov',
        townCode: 530042,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.281817,
        long: 14.828622
    },
    {
        town: 'Katov',
        townCode: 587907,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.332793,
        long: 16.278861
    },
    {
        town: 'Katovice',
        townCode: 551201,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38711,
        lat: 49.273591,
        long: 13.830458
    },
    {
        town: 'Katusice',
        townCode: 536008,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29425,
        lat: 50.445203,
        long: 14.777464
    },
    {
        town: "Kazn\u011Bjov",
        townCode: 559008,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.893239,
        long: 13.383058
    },
    {
        town: 'Kbel',
        townCode: 557871,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.493815,
        long: 13.365703
    },
    {
        town: 'Kbel',
        townCode: 513415,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.988323,
        long: 15.143645
    },
    {
        town: 'Kbelany',
        townCode: 538183,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.732444,
        long: 13.126409
    },
    {
        town: 'Kbelnice',
        townCode: 549169,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.454929,
        long: 15.350713
    },
    {
        town: 'Kdousov',
        townCode: 590819,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.986074,
        long: 15.647401
    },
    {
        town: "Kdyn\u011B",
        townCode: 553786,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.390348,
        long: 13.040638
    },
    {
        town: 'Keblice',
        townCode: 565016,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.480149,
        long: 14.101914
    },
    {
        town: 'Keblov',
        townCode: 529907,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.677749,
        long: 15.071992
    },
    {
        town: 'Kejnice',
        townCode: 541826,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.266995,
        long: 13.694293
    },
    {
        town: "Kej\u017Elice",
        townCode: 548120,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39452,
        lat: 49.590575,
        long: 15.392728
    },
    {
        town: "Kel\u010D",
        townCode: 542989,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75643,
        lat: 49.478541,
        long: 17.815441
    },
    {
        town: "Kel\u010Dany",
        townCode: 586251,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69649,
        lat: 49.005319,
        long: 17.173901
    },
    {
        town: "Keln\xedky",
        townCode: 592251,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76307,
        lat: 49.110985,
        long: 17.644771
    },
    {
        town: "Kest\u0159any",
        townCode: 549487,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39821,
        lat: 49.269153,
        long: 14.072641
    },
    {
        town: 'Ketkovice',
        townCode: 583201,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.159216,
        long: 16.26264
    },
    {
        town: 'Klabava',
        townCode: 559911,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33841,
        lat: 49.753546,
        long: 13.539382
    },
    {
        town: 'Kladeruby',
        townCode: 542997,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75643,
        lat: 49.492821,
        long: 17.865253
    },
    {
        town: 'Kladeruby nad Oslavou',
        townCode: 590827,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67575,
        lat: 49.144911,
        long: 16.17187
    },
    {
        town: 'Kladky',
        townCode: 589594,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79854,
        lat: 49.650182,
        long: 16.841358
    },
    {
        town: "Kladn\xedky",
        townCode: 569283,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.483773,
        long: 17.603034
    },
    {
        town: 'Kladno',
        townCode: 571580,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.772574,
        long: 15.982386
    },
    {
        town: 'Kladno',
        townCode: 532053,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27201,
        lat: 50.141799,
        long: 14.106846
    },
    {
        town: 'Kladruby',
        townCode: 560405,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.268814,
        long: 13.763561
    },
    {
        town: 'Kladruby',
        townCode: 559920,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.912977,
        long: 13.631799
    },
    {
        town: 'Kladruby',
        townCode: 560928,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34961,
        lat: 49.715408,
        long: 12.980021
    },
    {
        town: 'Kladruby',
        townCode: 533084,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.723269,
        long: 14.950154
    },
    {
        town: 'Kladruby',
        townCode: 567604,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.615093,
        long: 13.826385
    },
    {
        town: 'Kladruby nad Labem',
        townCode: 575178,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53314,
        lat: 50.057816,
        long: 15.487192
    },
    {
        town: "Klamo\u0161",
        townCode: 570168,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.125681,
        long: 15.501358
    },
    {
        town: "Klap\xfd",
        townCode: 565024,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41116,
        lat: 50.43154,
        long: 14.006583
    },
    {
        town: "Kl\xe1\u0161ter",
        townCode: 557897,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.50201,
        long: 13.576777
    },
    {
        town: "Kl\xe1\u0161ter Hradi\u0161t\u011B nad Jizerou",
        townCode: 536024,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29415,
        lat: 50.523509,
        long: 14.944829
    },
    {
        town: "Kl\xe1\u0161terec nad Oh\u0159\xed",
        townCode: 563129,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43151,
        lat: 50.384561,
        long: 13.171393
    },
    {
        town: "Kl\xe1\u0161terec nad Orlic\xed",
        townCode: 580431,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56182,
        lat: 50.111702,
        long: 16.554593
    },
    {
        town: "Kl\xe1\u0161tern\xed Skalice",
        townCode: 571687,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 50.023624,
        long: 14.98539
    },
    {
        town: "Kl\xe1\u0161tersk\xe1 Lhota",
        townCode: 579386,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54371,
        lat: 50.559794,
        long: 15.663687
    },
    {
        town: 'Klatovec',
        townCode: 587371,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.222518,
        long: 15.294793
    },
    {
        town: 'Klatovy',
        townCode: 555771,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.395655,
        long: 13.295194
    },
    {
        town: 'Klec',
        townCode: 562688,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.099391,
        long: 14.748496
    },
    {
        town: 'Klecany',
        townCode: 538311,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25067,
        lat: 50.176091,
        long: 14.411589
    },
    {
        town: "Klen\u010D\xed pod \u010Cerchovem",
        townCode: 553794,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34534,
        lat: 49.434948,
        long: 12.814835
    },
    {
        town: "Klene\u010D",
        townCode: 565032,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.392685,
        long: 14.248831
    },
    {
        town: "Klenov\xe1",
        townCode: 541851,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.333543,
        long: 13.233291
    },
    {
        town: 'Klenovice',
        townCode: 563986,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.278877,
        long: 14.715759
    },
    {
        town: "Klenovice na Han\xe9",
        townCode: 589608,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79823,
        lat: 49.403017,
        long: 17.211237
    },
    {
        town: 'Klentnice',
        townCode: 584541,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69201,
        lat: 48.844725,
        long: 16.644789
    },
    {
        town: "Kle\u0161ice",
        townCode: 573787,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.963712,
        long: 15.681376
    },
    {
        town: "Kl\xed\u010Dany",
        townCode: 538329,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25069,
        lat: 50.202124,
        long: 14.434551
    },
    {
        town: 'Klimkovice',
        townCode: 599549,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74283,
        lat: 49.788191,
        long: 18.125961
    },
    {
        town: "Kl\xednec",
        townCode: 571211,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.900957,
        long: 14.343355
    },
    {
        town: "Kl\xedny",
        townCode: 567191,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43601,
        lat: 50.638349,
        long: 13.548232
    },
    {
        town: 'Klobouky u Brna',
        townCode: 584550,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69172,
        lat: 48.995112,
        long: 16.859619
    },
    {
        town: 'Klobuky',
        townCode: 532461,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.294113,
        long: 13.987593
    },
    {
        town: "Kloko\u010D\xed",
        townCode: 577227,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.599761,
        long: 15.221716
    },
    {
        town: "Kloko\u010D\xed",
        townCode: 514047,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75361,
        lat: 49.560292,
        long: 17.682377
    },
    {
        town: "Kloko\u010Dn\xe1",
        townCode: 513628,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25164,
        lat: 49.958513,
        long: 14.718623
    },
    {
        town: "Kloko\u010Dov",
        townCode: 568856,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.801828,
        long: 15.674289
    },
    {
        town: 'Klopina',
        townCode: 536687,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78973,
        lat: 49.818661,
        long: 17.019494
    },
    {
        town: 'Klopotovice',
        townCode: 589616,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79821,
        lat: 49.446217,
        long: 17.250871
    },
    {
        town: "Klu\u010Denice",
        townCode: 540447,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26256,
        lat: 49.553233,
        long: 14.212131
    },
    {
        town: "Klu\u010Dov",
        townCode: 590835,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.167093,
        long: 15.935181
    },
    {
        town: "Klu\u010Dov",
        townCode: 533386,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.095114,
        long: 14.910171
    },
    {
        town: 'Kluky',
        townCode: 549495,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39819,
        lat: 49.316885,
        long: 14.245388
    },
    {
        town: 'Kluky',
        townCode: 534137,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28545,
        lat: 49.907559,
        long: 15.325361
    },
    {
        town: 'Kluky',
        townCode: 571075,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29426,
        lat: 50.440316,
        long: 14.725295
    },
    {
        town: 'Kly',
        townCode: 534897,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27741,
        lat: 50.308894,
        long: 14.501593
    },
    {
        town: "Kmetin\u011Bves",
        townCode: 532479,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27322,
        lat: 50.309285,
        long: 14.157106
    },
    {
        town: "Kn\u011B\u017Edub",
        townCode: 586269,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69664,
        lat: 48.886761,
        long: 17.395572
    },
    {
        town: "Kn\u011B\u017Eeves",
        townCode: 581721,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.587125,
        long: 16.423892
    },
    {
        town: "Kn\u011B\u017Eeves",
        townCode: 595853,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.456579,
        long: 15.980924
    },
    {
        town: "Kn\u011B\u017Eeves",
        townCode: 539384,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25268,
        lat: 50.121321,
        long: 14.259214
    },
    {
        town: "Kn\u011B\u017Eeves",
        townCode: 541877,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27001,
        lat: 50.146689,
        long: 13.637213
    },
    {
        town: "Kn\u011B\u017Eice",
        townCode: 590843,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67529,
        lat: 49.27088,
        long: 15.672268
    },
    {
        town: "Kn\u011B\u017Eice",
        townCode: 574007,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.861905,
        long: 15.527475
    },
    {
        town: "Kn\u011B\u017Eice",
        townCode: 537292,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28902,
        lat: 50.257311,
        long: 15.335464
    },
    {
        town: "Kn\u011B\u017Ei\u010Dky",
        townCode: 551481,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28908,
        lat: 50.173997,
        long: 15.344934
    },
    {
        town: "Kn\u011B\u017Emost",
        townCode: 536041,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29402,
        lat: 50.489274,
        long: 15.038396
    },
    {
        town: "Kn\u011B\u017Enice",
        townCode: 573043,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.493286,
        long: 15.322548
    },
    {
        town: "Kn\u011B\u017Epole",
        townCode: 592269,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.098647,
        long: 17.516817
    },
    {
        town: "Kn\xednice",
        townCode: 587389,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.094109,
        long: 15.604156
    },
    {
        town: "Kn\xednice u Boskovic",
        townCode: 581739,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67934,
        lat: 49.539688,
        long: 16.69513
    },
    {
        town: "K\u0148ovice",
        townCode: 598461,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.688403,
        long: 14.400412
    },
    {
        town: "Knov\xedz",
        townCode: 532487,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27401,
        lat: 50.212665,
        long: 14.137056
    },
    {
        town: 'Knyk',
        townCode: 548286,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.647038,
        long: 15.578739
    },
    {
        town: 'Koberovice',
        townCode: 548146,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.587669,
        long: 15.262965
    },
    {
        town: 'Koberovy',
        townCode: 563641,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.62476,
        long: 15.228332
    },
    {
        town: "Kobe\u0159ice",
        townCode: 507504,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74727,
        lat: 49.98558,
        long: 18.052227
    },
    {
        town: "Kobe\u0159ice u Brna",
        townCode: 593141,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.092284,
        long: 16.885919
    },
    {
        town: "Kobyl\xe1 nad Vidnavkou",
        townCode: 557218,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79065,
        lat: 50.342045,
        long: 17.123713
    },
    {
        town: "Kobyl\xed",
        townCode: 584568,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69110,
        lat: 48.932959,
        long: 16.891691
    },
    {
        town: 'Kobylice',
        townCode: 573710,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.245928,
        long: 15.587203
    },
    {
        town: 'Kobylnice',
        townCode: 583219,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66451,
        lat: 49.138134,
        long: 16.73193
    },
    {
        town: 'Kobylnice',
        townCode: 531405,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 50.006398,
        long: 15.375802
    },
    {
        town: 'Kobylnice',
        townCode: 571172,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29446,
        lat: 50.371738,
        long: 15.053963
    },
    {
        town: 'Kobyly',
        townCode: 564141,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.610271,
        long: 15.004443
    },
    {
        town: "Kocbe\u0159e",
        townCode: 579394,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54464,
        lat: 50.453757,
        long: 15.858823
    },
    {
        town: 'Kocelovice',
        townCode: 536601,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38742,
        lat: 49.465172,
        long: 13.827677
    },
    {
        town: "Kocl\xed\u0159ov",
        townCode: 578231,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56911,
        lat: 49.766393,
        long: 16.539938
    },
    {
        town: "Ko\u010D\xed",
        townCode: 571610,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53861,
        lat: 49.947276,
        long: 15.855614
    },
    {
        town: "Ko\u010D\xedn",
        townCode: 578771,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.930488,
        long: 13.476248
    },
    {
        town: "Ko\u010Dov",
        townCode: 541559,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.808767,
        long: 12.736709
    },
    {
        town: 'Kohoutov',
        townCode: 579408,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.451411,
        long: 15.904893
    },
    {
        town: "Koch\xe1nky",
        townCode: 536067,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29474,
        lat: 50.277131,
        long: 14.780339
    },
    {
        town: "Koch\xe1nov",
        townCode: 548529,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58253,
        lat: 49.534276,
        long: 15.540336
    },
    {
        town: 'Kojatice',
        townCode: 590851,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.998947,
        long: 15.703223
    },
    {
        town: "Kojat\xedn",
        townCode: 510645,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.242707,
        long: 16.010276
    },
    {
        town: "Koj\xe1tky",
        townCode: 593150,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.171903,
        long: 17.026237
    },
    {
        town: "Koj\u010Dice",
        townCode: 598712,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39409,
        lat: 49.476052,
        long: 15.255999
    },
    {
        town: 'Kojetice',
        townCode: 590860,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67523,
        lat: 49.157925,
        long: 15.818142
    },
    {
        town: 'Kojetice',
        townCode: 538345,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25072,
        lat: 50.238202,
        long: 14.508588
    },
    {
        town: "Kojet\xedn",
        townCode: 568881,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.657213,
        long: 15.658186
    },
    {
        town: "Kojet\xedn",
        townCode: 514055,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75201,
        lat: 49.352911,
        long: 17.30366
    },
    {
        town: 'Kojice',
        townCode: 575194,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53312,
        lat: 50.043079,
        long: 15.386682
    },
    {
        town: "Koka\u0161ice",
        townCode: 541494,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34952,
        lat: 49.878396,
        long: 12.947328
    },
    {
        town: 'Kokory',
        townCode: 514152,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75105,
        lat: 49.494915,
        long: 17.375546
    },
    {
        town: "Koko\u0159\xedn",
        townCode: 534901,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27723,
        lat: 50.429981,
        long: 14.567322
    },
    {
        town: 'Kolaje',
        townCode: 537306,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28904,
        lat: 50.155469,
        long: 15.238544
    },
    {
        town: "Kold\xedn",
        townCode: 580465,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.03692,
        long: 16.251721
    },
    {
        town: "Kole\u010D",
        townCode: 532495,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27329,
        lat: 50.198872,
        long: 14.22351
    },
    {
        town: "Kole\u0161ov",
        townCode: 565199,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.157254,
        long: 13.510143
    },
    {
        town: "Kole\u0161ovice",
        townCode: 541893,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27002,
        lat: 50.139748,
        long: 13.610387
    },
    {
        town: "Kol\xedn",
        townCode: 533165,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.027429,
        long: 15.202828
    },
    {
        town: 'Kolinec',
        townCode: 556467,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.299057,
        long: 13.439106
    },
    {
        town: 'Kolomuty',
        townCode: 570974,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.402199,
        long: 14.979095
    },
    {
        town: "Kolov\xe1",
        townCode: 555258,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.187545,
        long: 12.903449
    },
    {
        town: "Kolove\u010D",
        townCode: 553816,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.486895,
        long: 13.108876
    },
    {
        town: "Kol\u0161ov",
        townCode: 536733,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78821,
        lat: 49.903176,
        long: 16.947532
    },
    {
        town: "Kom\xe1rno",
        townCode: 588598,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76871,
        lat: 49.434675,
        long: 17.780479
    },
    {
        town: "Kom\xe1rov",
        townCode: 599280,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.250167,
        long: 14.594124
    },
    {
        town: "Kom\xe1rov",
        townCode: 547123,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.764167,
        long: 17.241052
    },
    {
        town: "Kom\xe1rov",
        townCode: 531324,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.806602,
        long: 13.856467
    },
    {
        town: "Kom\xe1rov",
        townCode: 549436,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76361,
        lat: 49.150786,
        long: 17.568861
    },
    {
        town: "Kom\xe1rovice",
        townCode: 590878,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.070089,
        long: 15.701107
    },
    {
        town: "Koma\u0159ice",
        townCode: 535877,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37314,
        lat: 48.878549,
        long: 14.545763
    },
    {
        town: "Kom\u0148a",
        townCode: 592277,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68771,
        lat: 48.99393,
        long: 17.800925
    },
    {
        town: "Komorn\xed Lhotka",
        townCode: 507237,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73953,
        lat: 49.658204,
        long: 18.527882
    },
    {
        town: 'Komorovice',
        townCode: 548162,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.508793,
        long: 15.345625
    },
    {
        town: "Komo\u0159any",
        townCode: 593168,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.216446,
        long: 16.906888
    },
    {
        town: "Kon\xe1rovice",
        townCode: 533394,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28125,
        lat: 50.041558,
        long: 15.284322
    },
    {
        town: 'Kondrac',
        townCode: 529931,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.667248,
        long: 14.884609
    },
    {
        town: "Konecchlum\xed",
        townCode: 573051,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50705,
        lat: 50.402345,
        long: 15.480335
    },
    {
        town: "Kon\u011Bprusy",
        townCode: 531332,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 49.920996,
        long: 14.065859
    },
    {
        town: "Kon\u011B\u0161\xedn",
        townCode: 590886,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67502,
        lat: 49.190593,
        long: 16.041305
    },
    {
        town: "Kon\u011Btopy",
        townCode: 531553,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.276506,
        long: 14.653932
    },
    {
        town: 'Konice',
        townCode: 589624,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.590395,
        long: 16.889217
    },
    {
        town: 'Konojedy',
        townCode: 564761,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.948677,
        long: 14.851354
    },
    {
        town: "Konstantinovy L\xe1zn\u011B",
        townCode: 560952,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34952,
        lat: 49.881263,
        long: 12.977983
    },
    {
        town: 'Kopidlno',
        townCode: 573060,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.330951,
        long: 15.2704
    },
    {
        town: 'Kopidlo',
        townCode: 559024,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.943303,
        long: 13.464495
    },
    {
        town: "Kop\u0159ivn\xe1",
        townCode: 553247,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78833,
        lat: 50.046475,
        long: 16.946863
    },
    {
        town: "Kop\u0159ivnice",
        townCode: 599565,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74221,
        lat: 49.59957,
        long: 18.14491
    },
    {
        town: "Korkyn\u011B",
        townCode: 599204,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26206,
        lat: 49.780542,
        long: 14.351437
    },
    {
        town: 'Kornatice',
        townCode: 579033,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.659042,
        long: 13.592325
    },
    {
        town: 'Korno',
        townCode: 533793,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.920584,
        long: 14.136968
    },
    {
        town: 'Korolupy',
        townCode: 594253,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.930251,
        long: 15.646296
    },
    {
        town: 'Korouhev',
        townCode: 578258,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56993,
        lat: 49.67142,
        long: 16.245888
    },
    {
        town: "Korou\u017En\xe9",
        townCode: 595861,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.527574,
        long: 16.347737
    },
    {
        town: 'Korozluky',
        townCode: 567221,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.478686,
        long: 13.723088
    },
    {
        town: 'Koruna',
        townCode: 578266,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.846904,
        long: 16.714969
    },
    {
        town: "Kory\u010Dany",
        townCode: 588601,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76805,
        lat: 49.10649,
        long: 17.164435
    },
    {
        town: 'Koryta',
        townCode: 559032,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.900611,
        long: 13.474862
    },
    {
        town: 'Koryta',
        townCode: 599557,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29411,
        lat: 50.572055,
        long: 15.011824
    },
    {
        town: "Korytn\xe1",
        townCode: 592285,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68752,
        lat: 48.94107,
        long: 17.665308
    },
    {
        town: "Ko\u0159enec",
        townCode: 581755,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.530418,
        long: 16.754045
    },
    {
        town: "Ko\u0159enice",
        townCode: 533408,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.977216,
        long: 15.140969
    },
    {
        town: "Ko\u0159enov",
        townCode: 563668,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46849,
        lat: 50.759359,
        long: 15.365424
    },
    {
        town: 'Kosice',
        townCode: 570176,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.179841,
        long: 15.534913
    },
    {
        town: "Kosi\u010Dky",
        townCode: 570184,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50365,
        lat: 50.178703,
        long: 15.555822
    },
    {
        town: 'Kosmonosy',
        townCode: 570826,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29306,
        lat: 50.438608,
        long: 14.929915
    },
    {
        town: "Koso\u0159",
        townCode: 539392,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25226,
        lat: 49.98758,
        long: 14.326682
    },
    {
        town: "Koso\u0159ice",
        townCode: 536121,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29441,
        lat: 50.33348,
        long: 14.96974
    },
    {
        town: "Koso\u0159\xedn",
        townCode: 574449,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 49.979239,
        long: 16.233825
    },
    {
        town: 'Kosov',
        townCode: 536814,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.883233,
        long: 16.79882
    },
    {
        town: 'Kosova Hora',
        townCode: 540498,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26291,
        lat: 49.654247,
        long: 14.471834
    },
    {
        town: 'Kostelany',
        townCode: 588521,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.203174,
        long: 17.382954
    },
    {
        town: 'Kostelany nad Moravou',
        townCode: 592293,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68601,
        lat: 49.045476,
        long: 17.407042
    },
    {
        town: 'Kostelec',
        townCode: 586277,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69651,
        lat: 49.02693,
        long: 17.153306
    },
    {
        town: 'Kostelec',
        townCode: 587401,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58861,
        lat: 49.3614,
        long: 15.490771
    },
    {
        town: 'Kostelec',
        townCode: 548928,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.381344,
        long: 15.327377
    },
    {
        town: 'Kostelec',
        townCode: 503916,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.674415,
        long: 13.026491
    },
    {
        town: "Kostelec na Han\xe9",
        townCode: 589632,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79841,
        lat: 49.514078,
        long: 17.058346
    },
    {
        town: "Kostelec nad \u010Cern\xfdmi Lesy",
        townCode: 533416,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.994137,
        long: 14.859324
    },
    {
        town: 'Kostelec nad Labem',
        townCode: 534935,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27713,
        lat: 50.226634,
        long: 14.585628
    },
    {
        town: "Kostelec nad Orlic\xed",
        townCode: 576361,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.122511,
        long: 16.215084
    },
    {
        town: 'Kostelec nad Vltavou',
        townCode: 549509,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39858,
        lat: 49.49999,
        long: 14.211859
    },
    {
        town: "Kostelec u He\u0159manova M\u011Bstce",
        townCode: 571628,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.923421,
        long: 15.651641
    },
    {
        town: "Kostelec u Hole\u0161ova",
        townCode: 588610,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76843,
        lat: 49.374174,
        long: 17.511445
    },
    {
        town: "Kostelec u K\u0159\xed\u017Ek\u016F",
        townCode: 538370,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25168,
        lat: 49.907123,
        long: 14.557334
    },
    {
        town: "Kosteleck\xe9 Horky",
        townCode: 576387,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.051755,
        long: 16.206964
    },
    {
        town: "Kosteln\xed Hlavno",
        townCode: 536130,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29476,
        lat: 50.257529,
        long: 14.699086
    },
    {
        town: "Kosteln\xed Lhota",
        townCode: 537314,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28912,
        lat: 50.129367,
        long: 15.024308
    },
    {
        town: "Kosteln\xed Myslov\xe1",
        townCode: 587419,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.147908,
        long: 15.42899
    },
    {
        town: "Kosteln\xed Radou\u0148",
        townCode: 509108,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.225517,
        long: 15.008829
    },
    {
        town: "Kosteln\xed Vyd\u0159\xed",
        townCode: 508357,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.106163,
        long: 15.421758
    },
    {
        town: "Kost\u011Bnice",
        townCode: 575232,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.009667,
        long: 15.903791
    },
    {
        town: 'Kostice',
        townCode: 584576,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69152,
        lat: 48.74695,
        long: 16.978794
    },
    {
        town: "Kostn\xedky",
        townCode: 590894,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.974807,
        long: 15.639908
    },
    {
        town: "Kostoml\xe1tky",
        townCode: 529630,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28921,
        lat: 50.171133,
        long: 14.984131
    },
    {
        town: 'Kostomlaty nad Labem',
        townCode: 537331,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28921,
        lat: 50.184587,
        long: 14.954085
    },
    {
        town: "Kostomlaty pod Mile\u0161ovkou",
        townCode: 567612,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41754,
        lat: 50.560217,
        long: 13.873166
    },
    {
        town: "Kostomlaty pod \u0158\xedpem",
        townCode: 565059,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.383135,
        long: 14.333177
    },
    {
        town: "Ko\u0161a\u0159iska",
        townCode: 507458,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73981,
        lat: 49.589496,
        long: 18.69578
    },
    {
        town: "Ko\u0161\xe1tky",
        townCode: 566047,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29479,
        lat: 50.315276,
        long: 14.667096
    },
    {
        town: "Ko\u0161etice",
        townCode: 548171,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39422,
        lat: 49.558467,
        long: 15.116371
    },
    {
        town: "Ko\u0161ice",
        townCode: 552585,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39117,
        lat: 49.325429,
        long: 14.751505
    },
    {
        town: "Ko\u0161ice",
        townCode: 551465,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.895897,
        long: 15.150945
    },
    {
        town: "Ko\u0161\xedk",
        townCode: 537349,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28935,
        lat: 50.318352,
        long: 15.134157
    },
    {
        town: "Ko\u0161\xedky",
        townCode: 592307,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68704,
        lat: 49.157681,
        long: 17.416297
    },
    {
        town: "Ko\u0161\xedn",
        townCode: 562955,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39137,
        lat: 49.456508,
        long: 14.658548
    },
    {
        town: "Ko\u0161\u0165\xe1lov",
        townCode: 577235,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51202,
        lat: 50.571751,
        long: 15.404135
    },
    {
        town: "Ko\u0161\u0165any",
        townCode: 567621,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41723,
        lat: 50.655181,
        long: 13.755656
    },
    {
        town: "Ko\u0161tice",
        townCode: 566284,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43921,
        lat: 50.403319,
        long: 13.944037
    },
    {
        town: "Koten\u010Dice",
        townCode: 513555,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.736397,
        long: 14.093917
    },
    {
        town: 'Kotlasy',
        townCode: 595870,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.492812,
        long: 15.946201
    },
    {
        town: 'Kotopeky',
        townCode: 534072,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.856839,
        long: 13.925264
    },
    {
        town: 'Kotovice',
        townCode: 540633,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.672114,
        long: 13.154585
    },
    {
        town: 'Kotvrdovice',
        townCode: 581763,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67907,
        lat: 49.355206,
        long: 16.784459
    },
    {
        town: 'Kounice',
        townCode: 537357,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28915,
        lat: 50.10777,
        long: 14.856029
    },
    {
        town: 'Kounov',
        townCode: 576395,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51792,
        lat: 50.298871,
        long: 16.258155
    },
    {
        town: 'Kounov',
        townCode: 541907,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27006,
        lat: 50.212979,
        long: 13.675205
    },
    {
        town: "Koup\u011B",
        townCode: 529681,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.514885,
        long: 13.918493
    },
    {
        town: "Kou\u0159im",
        townCode: 533424,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28161,
        lat: 50.003158,
        long: 14.977137
    },
    {
        town: "Kout na \u0160umav\u011B",
        townCode: 553824,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34502,
        lat: 49.402659,
        long: 13.002193
    },
    {
        town: 'Kouty',
        townCode: 548189,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.648891,
        long: 15.293094
    },
    {
        town: 'Kouty',
        townCode: 590908,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67508,
        lat: 49.314835,
        long: 15.792795
    },
    {
        town: 'Kouty',
        townCode: 534943,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.193218,
        long: 15.148855
    },
    {
        town: "Kova\u010D",
        townCode: 548944,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.39615,
        long: 15.470916
    },
    {
        town: 'Kovalovice',
        townCode: 583227,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66406,
        lat: 49.204721,
        long: 16.81914
    },
    {
        town: "Kov\xe1lovice-Os\xed\u010Dany",
        townCode: 589641,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79829,
        lat: 49.284523,
        long: 17.171314
    },
    {
        town: "Kov\xe1\u0148",
        townCode: 571971,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29425,
        lat: 50.423409,
        long: 14.777875
    },
    {
        town: 'Kovanec',
        townCode: 572012,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29426,
        lat: 50.417808,
        long: 14.77674
    },
    {
        town: 'Kovanice',
        townCode: 537373,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.169567,
        long: 15.070901
    },
    {
        town: "Kov\xe1\u0159ov",
        townCode: 549517,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39855,
        lat: 49.517705,
        long: 14.278199
    },
    {
        town: "Kov\xe1\u0159sk\xe1",
        townCode: 563137,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43186,
        lat: 50.438324,
        long: 13.053997
    },
    {
        town: "Kov\u010D\xedn",
        townCode: 578177,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.415936,
        long: 13.606717
    },
    {
        town: "Koz\xe1rov",
        townCode: 581771,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.443935,
        long: 16.458762
    },
    {
        town: "Koz\xe1rovice",
        townCode: 540536,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26284,
        lat: 49.555628,
        long: 14.106587
    },
    {
        town: 'Kozlany',
        townCode: 550108,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68341,
        lat: 49.20417,
        long: 17.035316
    },
    {
        town: 'Kozlany',
        townCode: 590916,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67502,
        lat: 49.179832,
        long: 16.061293
    },
    {
        town: 'Kozlov',
        townCode: 568899,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.734658,
        long: 15.293073
    },
    {
        town: 'Kozlov',
        townCode: 587427,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58821,
        lat: 49.413143,
        long: 15.700567
    },
    {
        town: 'Kozlov',
        townCode: 500135,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77200,
        lat: 49.603626,
        long: 17.535662
    },
    {
        town: 'Kozlov',
        townCode: 595888,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.379245,
        long: 16.078773
    },
    {
        town: 'Kozlovice',
        townCode: 598321,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73947,
        lat: 49.590494,
        long: 18.256672
    },
    {
        town: 'Kozlovice',
        townCode: 540200,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.465098,
        long: 13.582934
    },
    {
        town: 'Kozly',
        townCode: 546232,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47001,
        lat: 50.655449,
        long: 14.45693
    },
    {
        town: 'Kozly',
        townCode: 530557,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.45686,
        long: 13.784625
    },
    {
        town: 'Kozmice',
        townCode: 547182,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74711,
        lat: 49.9129,
        long: 18.15595
    },
    {
        town: 'Kozmice',
        townCode: 529940,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.824883,
        long: 14.796183
    },
    {
        town: 'Kozojedy',
        townCode: 572136,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.316531,
        long: 15.374882
    },
    {
        town: 'Kozojedy',
        townCode: 559041,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.931343,
        long: 13.542516
    },
    {
        town: 'Kozojedy',
        townCode: 533432,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.996652,
        long: 14.814366
    },
    {
        town: 'Kozojedy',
        townCode: 565385,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.255389,
        long: 13.815687
    },
    {
        town: "Kozoj\xeddky",
        townCode: 586285,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69663,
        lat: 48.918744,
        long: 17.399733
    },
    {
        town: 'Kozolupy',
        townCode: 559059,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33032,
        lat: 49.763902,
        long: 13.252214
    },
    {
        town: "Kozom\xedn",
        townCode: 571792,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27745,
        lat: 50.236919,
        long: 14.371215
    },
    {
        town: "Ko\u017Eichovice",
        townCode: 545309,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.199963,
        long: 15.922024
    },
    {
        town: "Ko\u017Elany",
        townCode: 559067,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33144,
        lat: 49.993998,
        long: 13.541176
    },
    {
        town: "Ko\u017El\xed",
        townCode: 561550,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.515875,
        long: 14.146759
    },
    {
        town: "Ko\u017El\xed",
        townCode: 568902,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58293,
        lat: 49.670414,
        long: 15.253313
    },
    {
        town: "Ko\u017Eu\u0161any-T\xe1\u017Ealy",
        townCode: 503304,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78375,
        lat: 49.537792,
        long: 17.253626
    },
    {
        town: "Ko\u017Eu\u0161ice",
        townCode: 593184,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.15519,
        long: 17.18489
    },
    {
        town: "Krab\u010Dice",
        townCode: 565067,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41187,
        lat: 50.405474,
        long: 14.301425
    },
    {
        town: 'Kraborovice',
        townCode: 548618,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.800604,
        long: 15.571977
    },
    {
        town: "Krahul\u010D\xed",
        townCode: 587435,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.181877,
        long: 15.414923
    },
    {
        town: 'Krahulov',
        townCode: 550710,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.223007,
        long: 15.808241
    },
    {
        town: "Krajkov\xe1",
        townCode: 560456,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35709,
        lat: 50.216079,
        long: 12.534192
    },
    {
        town: "Krajn\xed\u010Dko",
        townCode: 536342,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.147647,
        long: 14.028846
    },
    {
        town: 'Krakov',
        townCode: 565351,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.037468,
        long: 13.647573
    },
    {
        town: 'Krakovany',
        townCode: 533441,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28127,
        lat: 50.066166,
        long: 15.36897
    },
    {
        town: 'Krakovec',
        townCode: 565369,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.018944,
        long: 13.638347
    },
    {
        town: "Kralice na Han\xe9",
        townCode: 589659,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79812,
        lat: 49.463062,
        long: 17.180583
    },
    {
        town: 'Kralice nad Oslavou',
        townCode: 590941,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67573,
        lat: 49.199373,
        long: 16.201664
    },
    {
        town: "Kr\xe1l\xedky",
        townCode: 570192,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.259542,
        long: 15.53668
    },
    {
        town: "Kr\xe1l\xedky",
        townCode: 580481,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56169,
        lat: 50.083939,
        long: 16.760646
    },
    {
        town: "Kr\xe1lova Lhota",
        townCode: 549525,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.495809,
        long: 14.110652
    },
    {
        town: "Kr\xe1lova Lhota",
        townCode: 576409,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.294662,
        long: 15.998922
    },
    {
        town: "Kr\xe1lovec",
        townCode: 530808,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54203,
        lat: 50.676859,
        long: 15.97381
    },
    {
        town: 'Kralovice',
        townCode: 559075,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.982024,
        long: 13.487584
    },
    {
        town: "Kr\xe1lovice",
        townCode: 535109,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27401,
        lat: 50.263129,
        long: 14.055907
    },
    {
        town: "Kr\xe1lovsk\xe9 Po\u0159\xed\u010D\xed",
        townCode: 560464,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.19412,
        long: 12.67954
    },
    {
        town: 'Kralupy nad Vltavou',
        townCode: 534951,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27801,
        lat: 50.241745,
        long: 14.310745
    },
    {
        town: "Kr\xe1l\u016Fv Dv\u016Fr",
        townCode: 533203,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26701,
        lat: 49.949911,
        long: 14.034561
    },
    {
        town: "Kramol\xedn",
        townCode: 590959,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67577,
        lat: 49.134304,
        long: 16.132027
    },
    {
        town: "Kramol\xedn",
        townCode: 557943,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.446183,
        long: 13.577065
    },
    {
        town: 'Kramolna',
        townCode: 574546,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54701,
        lat: 50.420798,
        long: 16.13492
    },
    {
        town: 'Kraselov',
        townCode: 551261,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.227936,
        long: 13.804051
    },
    {
        town: "Kr\xe1sensko",
        townCode: 593192,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68304,
        lat: 49.364634,
        long: 16.829977
    },
    {
        town: "Kras\xedkov",
        townCode: 580490,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.855681,
        long: 16.695801
    },
    {
        town: "Kras\xedkovice",
        townCode: 561371,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.461735,
        long: 15.228765
    },
    {
        town: 'Kraslice',
        townCode: 560472,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.323835,
        long: 12.517588
    },
    {
        town: "Kr\xe1sn\xe1",
        townCode: 538795,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35201,
        lat: 50.234889,
        long: 12.168117
    },
    {
        town: "Kr\xe1sn\xe1",
        townCode: 549673,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73904,
        lat: 49.582088,
        long: 18.481485
    },
    {
        town: "Kr\xe1sn\xe1 Hora",
        townCode: 568929,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58234,
        lat: 49.602787,
        long: 15.470441
    },
    {
        town: "Kr\xe1sn\xe1 Hora nad Vltavou",
        townCode: 540552,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26256,
        lat: 49.604711,
        long: 14.277524
    },
    {
        town: "Kr\xe1sn\xe1 L\xedpa",
        townCode: 562611,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40746,
        lat: 50.913136,
        long: 14.510101
    },
    {
        town: "Kr\xe1sn\xe1 Ves",
        townCode: 536164,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29425,
        lat: 50.42478,
        long: 14.792241
    },
    {
        town: "Kr\xe1sn\xe9",
        townCode: 595896,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.677952,
        long: 16.145108
    },
    {
        town: "Kr\xe1sn\xe9",
        townCode: 571652,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.821656,
        long: 15.745623
    },
    {
        town: "Kr\xe1sn\xe9 \xdadol\xed",
        townCode: 555304,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36401,
        lat: 50.072448,
        long: 12.921351
    },
    {
        town: "Kr\xe1sn\u011Bves",
        townCode: 595900,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.44451,
        long: 15.981262
    },
    {
        town: "Kr\xe1sno",
        townCode: 538337,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35731,
        lat: 50.109287,
        long: 12.786342
    },
    {
        town: "Kr\xe1sn\xfd Dv\u016Fr",
        townCode: 566306,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43972,
        lat: 50.254271,
        long: 13.367878
    },
    {
        town: "Kr\xe1sn\xfd Les",
        townCode: 578045,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.344955,
        long: 13.002857
    },
    {
        town: "Kr\xe1sn\xfd Les",
        townCode: 564168,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.940324,
        long: 15.127667
    },
    {
        town: 'Krasonice',
        townCode: 587443,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58864,
        lat: 49.11513,
        long: 15.616146
    },
    {
        town: 'Krasov',
        townCode: 597511,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79401,
        lat: 50.091869,
        long: 17.546206
    },
    {
        town: "Krasov\xe1",
        townCode: 581780,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.361476,
        long: 16.768035
    },
    {
        town: "Kra\u0161lovice",
        townCode: 536806,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.166695,
        long: 14.132576
    },
    {
        town: "Kra\u0161ovice",
        townCode: 559083,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33013,
        lat: 49.872448,
        long: 13.30535
    },
    {
        town: "Kr\xe1tk\xe1 Ves",
        townCode: 568937,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.625837,
        long: 15.684616
    },
    {
        town: 'Kratochvilka',
        townCode: 583235,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.156753,
        long: 16.376457
    },
    {
        town: 'Kratonohy',
        townCode: 570206,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50324,
        lat: 50.169243,
        long: 15.607018
    },
    {
        town: "Kr\xe1to\u0161ice",
        townCode: 560634,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.325991,
        long: 14.786807
    },
    {
        town: "Kratu\u0161\xedn",
        townCode: 537136,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.020356,
        long: 13.928608
    },
    {
        town: "Krava\u0159e",
        townCode: 561720,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47103,
        lat: 50.632503,
        long: 14.392521
    },
    {
        town: "Krava\u0159e",
        townCode: 507580,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74721,
        lat: 49.93213,
        long: 18.004827
    },
    {
        town: 'Kravsko',
        townCode: 594261,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67151,
        lat: 48.921596,
        long: 15.986425
    },
    {
        town: "Kr\u010Dma\u0148",
        townCode: 552437,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.520843,
        long: 17.344253
    },
    {
        town: 'Krejnice',
        townCode: 536954,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.233828,
        long: 13.718584
    },
    {
        town: 'Krhanice',
        townCode: 529958,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25742,
        lat: 49.856112,
        long: 14.557463
    },
    {
        town: 'Krhov',
        townCode: 581798,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.46036,
        long: 16.583923
    },
    {
        town: 'Krhov',
        townCode: 590967,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.100437,
        long: 16.019513
    },
    {
        town: "Krhov\xe1",
        townCode: 500062,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75701,
        lat: 49.465249,
        long: 17.97427
    },
    {
        town: 'Krhovice',
        townCode: 594270,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.815911,
        long: 16.173693
    },
    {
        town: 'Krchleby',
        townCode: 548685,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.079206,
        long: 16.234632
    },
    {
        town: 'Krchleby',
        townCode: 569372,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.820815,
        long: 16.833722
    },
    {
        town: 'Krchleby',
        townCode: 534153,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.888996,
        long: 15.350407
    },
    {
        town: 'Krchleby',
        townCode: 537390,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.239265,
        long: 15.022812
    },
    {
        town: "Krmel\xedn",
        townCode: 598348,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73924,
        lat: 49.729234,
        long: 18.235519
    },
    {
        town: "Kr\u0148any",
        townCode: 529974,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25744,
        lat: 49.844913,
        long: 14.477553
    },
    {
        town: 'Krnov',
        townCode: 597520,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79401,
        lat: 50.090683,
        long: 17.703168
    },
    {
        town: 'Krnsko',
        townCode: 536172,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29431,
        lat: 50.372511,
        long: 14.863152
    },
    {
        town: "Kroko\u010D\xedn",
        townCode: 590975,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.244186,
        long: 16.23308
    },
    {
        town: "Krom\u011B\u0159\xed\u017E",
        townCode: 588296,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.291758,
        long: 17.39948
    },
    {
        town: 'Krompach',
        townCode: 561738,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47157,
        lat: 50.828174,
        long: 14.701621
    },
    {
        town: "Krop\xe1\u010Dova Vrutice",
        townCode: 536181,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29479,
        lat: 50.330635,
        long: 14.717485
    },
    {
        town: "Krou\u010Dov\xe1",
        townCode: 541940,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.206875,
        long: 13.784056
    },
    {
        town: 'Krouna',
        townCode: 571661,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53943,
        lat: 49.772498,
        long: 16.026846
    },
    {
        town: 'Krsy',
        townCode: 559091,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33038,
        lat: 49.926348,
        long: 13.055063
    },
    {
        town: 'Krtov',
        townCode: 563030,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.348553,
        long: 14.832583
    },
    {
        town: 'Krty',
        townCode: 598500,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27033,
        lat: 50.091708,
        long: 13.432026
    },
    {
        town: 'Krty-Hradec',
        townCode: 536555,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.291408,
        long: 13.848107
    },
    {
        town: 'Krucemburk',
        townCode: 568945,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58266,
        lat: 49.688511,
        long: 15.852171
    },
    {
        town: 'Kruh',
        townCode: 577243,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.565638,
        long: 15.480245
    },
    {
        town: "Krums\xedn",
        townCode: 589667,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.446019,
        long: 17.001558
    },
    {
        town: "Krumv\xed\u0159",
        townCode: 584584,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69173,
        lat: 48.989106,
        long: 16.910379
    },
    {
        town: "Krup\xe1",
        townCode: 533459,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 50.017461,
        long: 14.871405
    },
    {
        town: "Krup\xe1",
        townCode: 541966,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27009,
        lat: 50.174955,
        long: 13.731687
    },
    {
        town: 'Krupka',
        townCode: 567639,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41741,
        lat: 50.684596,
        long: 13.858264
    },
    {
        town: "Kru\u0161ovice",
        townCode: 541974,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27053,
        lat: 50.172357,
        long: 13.775232
    },
    {
        town: "Kru\u017Eberk",
        townCode: 568180,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74786,
        lat: 49.831881,
        long: 17.683296
    },
    {
        town: 'Krychnov',
        townCode: 599484,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.006062,
        long: 15.057761
    },
    {
        town: 'Kryry',
        townCode: 566314,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43981,
        lat: 50.174477,
        long: 13.426708
    },
    {
        town: "Kry\u0161tofovo \xdadol\xed",
        townCode: 564176,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46001,
        lat: 50.774549,
        long: 14.933501
    },
    {
        town: "Kry\u0161tofovy Hamry",
        townCode: 563315,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43191,
        lat: 50.499571,
        long: 13.136207
    },
    {
        town: "K\u0159e\u010D",
        townCode: 548201,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39495,
        lat: 49.389356,
        long: 14.917101
    },
    {
        town: "K\u0159e\u010Dho\u0159",
        townCode: 533467,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.025621,
        long: 15.127128
    },
    {
        town: "K\u0159e\u010Dkov",
        townCode: 537403,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.180061,
        long: 15.114377
    },
    {
        town: "K\u0159e\u010Dovice",
        townCode: 529991,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25756,
        lat: 49.721417,
        long: 14.475637
    },
    {
        town: "K\u0159ekov",
        townCode: 586960,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76601,
        lat: 49.129596,
        long: 17.967873
    },
    {
        town: "K\u0159elov-B\u0159uchot\xedn",
        townCode: 554901,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78336,
        lat: 49.614533,
        long: 17.195665
    },
    {
        town: "K\u0159elovice",
        townCode: 548219,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39445,
        lat: 49.536955,
        long: 15.168678
    },
    {
        town: "K\u0159elovice",
        townCode: 559105,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33036,
        lat: 49.874423,
        long: 13.075914
    },
    {
        town: "K\u0159em\u017Ee",
        townCode: 545571,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38203,
        lat: 48.90507,
        long: 14.305777
    },
    {
        town: "K\u0159enek",
        townCode: 534960,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.229642,
        long: 14.629558
    },
    {
        town: "K\u0159enice",
        townCode: 556505,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.502807,
        long: 13.200398
    },
    {
        town: "K\u0159enice",
        townCode: 564991,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25084,
        lat: 50.031104,
        long: 14.668617
    },
    {
        town: "K\u0159enov",
        townCode: 578274,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56922,
        lat: 49.679791,
        long: 16.628932
    },
    {
        town: "K\u0159enovice",
        townCode: 562181,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.367396,
        long: 14.342995
    },
    {
        town: "K\u0159enovice",
        townCode: 593214,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68352,
        lat: 49.142261,
        long: 16.829426
    },
    {
        town: "K\u0159enovice",
        townCode: 569143,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75201,
        lat: 49.330514,
        long: 17.272737
    },
    {
        town: "K\u0159enovy",
        townCode: 553832,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.53926,
        long: 13.021618
    },
    {
        town: "K\u0159epenice",
        townCode: 540579,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.702999,
        long: 14.347666
    },
    {
        town: "K\u0159epice",
        townCode: 584592,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69165,
        lat: 48.999961,
        long: 16.719993
    },
    {
        town: "K\u0159epice",
        townCode: 594288,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 48.98749,
        long: 16.097506
    },
    {
        town: "K\u0159esetice",
        townCode: 534161,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28547,
        lat: 49.907238,
        long: 15.262953
    },
    {
        town: "K\u0159es\xedn",
        townCode: 565075,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.394622,
        long: 13.980842
    },
    {
        town: "K\u0159e\u0161ice",
        townCode: 565083,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41148,
        lat: 50.522692,
        long: 14.21461
    },
    {
        town: "K\u0159e\u0161\xedn",
        townCode: 548227,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39424,
        lat: 49.581824,
        long: 15.043819
    },
    {
        town: "K\u0159e\u0161\xedn",
        townCode: 540587,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.799554,
        long: 13.948174
    },
    {
        town: "K\u0159et\xedn",
        townCode: 581801,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.563204,
        long: 16.504506
    },
    {
        town: "K\u0159i\u010De\u0148",
        townCode: 572861,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.109618,
        long: 15.65169
    },
    {
        town: "K\u0159\xeddla",
        townCode: 587842,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.52733,
        long: 16.122451
    },
    {
        town: "K\u0159\xeddl\u016Fvky",
        townCode: 550086,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.781811,
        long: 16.239054
    },
    {
        town: "K\u0159imov",
        townCode: 563161,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.486132,
        long: 13.301587
    },
    {
        town: "K\u0159inec",
        townCode: 537411,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28933,
        lat: 50.264587,
        long: 15.137929
    },
    {
        town: "K\u0159inice",
        townCode: 574171,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55001,
        lat: 50.571797,
        long: 16.306073
    },
    {
        town: "K\u0159i\u0161\u0165anov",
        townCode: 561673,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 48.909239,
        long: 14.020131
    },
    {
        town: "K\u0159i\u0161\u0165anovice",
        townCode: 597538,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79368,
        lat: 49.850911,
        long: 17.51114
    },
    {
        town: "K\u0159ivokl\xe1t",
        townCode: 541982,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.037956,
        long: 13.870474
    },
    {
        town: "K\u0159ivsoudov",
        townCode: 530000,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25766,
        lat: 49.633077,
        long: 15.087465
    },
    {
        town: "K\u0159i\u017E\xe1nky",
        townCode: 595918,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59202,
        lat: 49.687674,
        long: 16.0644
    },
    {
        town: "K\u0159i\u017Eanov",
        townCode: 509752,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.39884,
        long: 14.378237
    },
    {
        town: "K\u0159i\u017Eanov",
        townCode: 595926,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.388682,
        long: 16.109707
    },
    {
        town: "K\u0159i\u017Eanovice",
        townCode: 593222,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.142428,
        long: 16.939154
    },
    {
        town: "K\u0159i\u017Eanovice",
        townCode: 547824,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.859518,
        long: 15.761796
    },
    {
        town: "K\u0159i\u017Eanovice u Vy\u0161kova",
        townCode: 593231,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.287758,
        long: 17.040305
    },
    {
        town: "K\u0159i\u017Eany",
        townCode: 564184,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46353,
        lat: 50.73858,
        long: 14.901417
    },
    {
        town: "K\u0159i\u017E\xednkov",
        townCode: 595934,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59453,
        lat: 49.32587,
        long: 16.270362
    },
    {
        town: "K\u0159\xed\u017Ekov\xfd \xdajezdec",
        townCode: 538418,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25168,
        lat: 49.930882,
        long: 14.585468
    },
    {
        town: "K\u0159i\u017Eovatka",
        townCode: 554596,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.194269,
        long: 12.393172
    },
    {
        town: "K\u0159ov\xed",
        townCode: 595951,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59454,
        lat: 49.306061,
        long: 16.26435
    },
    {
        town: "K\u0159t\u011Bnov",
        townCode: 581810,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.545085,
        long: 16.419371
    },
    {
        town: "K\u0159tiny",
        townCode: 581828,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67905,
        lat: 49.297155,
        long: 16.744194
    },
    {
        town: "K\u0159tomil",
        townCode: 552780,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.409188,
        long: 17.626333
    },
    {
        town: "K\u0161ely",
        townCode: 571717,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.04352,
        long: 14.902034
    },
    {
        town: "K\u0161ice",
        townCode: 560979,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.80252,
        long: 12.997365
    },
    {
        town: "Kti\u0161",
        townCode: 550329,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38403,
        lat: 48.917082,
        long: 14.132752
    },
    {
        town: "Ktov\xe1",
        townCode: 547484,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51263,
        lat: 50.519937,
        long: 15.246847
    },
    {
        town: 'Kublov',
        townCode: 531375,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26741,
        lat: 49.943803,
        long: 13.876779
    },
    {
        town: "Kubova Hu\u0165",
        townCode: 563978,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38501,
        lat: 48.983333,
        long: 13.771924
    },
    {
        town: "Kub\u0161ice",
        townCode: 594296,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67176,
        lat: 49.000765,
        long: 16.413164
    },
    {
        town: "Ku\u010Derov",
        townCode: 593249,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.218686,
        long: 17.005432
    },
    {
        town: "Ku\u010De\u0159",
        townCode: 549541,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39834,
        lat: 49.434342,
        long: 14.245724
    },
    {
        town: 'Kudlovice',
        townCode: 592323,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68703,
        lat: 49.131767,
        long: 17.457274
    },
    {
        town: "Kucha\u0159ovice",
        townCode: 594300,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.876057,
        long: 16.077071
    },
    {
        town: 'Kujavy',
        townCode: 555312,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74245,
        lat: 49.703412,
        long: 17.972636
    },
    {
        town: 'Kukle',
        townCode: 572594,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.793206,
        long: 16.425709
    },
    {
        town: "Kukl\xedk",
        townCode: 595969,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.630022,
        long: 16.113247
    },
    {
        town: 'Kuks',
        townCode: 579416,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54443,
        lat: 50.401587,
        long: 15.888322
    },
    {
        town: "Kul\xed\u0159ov",
        townCode: 581836,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.379422,
        long: 16.846914
    },
    {
        town: "Kun\u010Dice",
        townCode: 570214,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.217617,
        long: 15.636021
    },
    {
        town: "Kun\u010Dice nad Labem",
        townCode: 579424,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54361,
        lat: 50.581962,
        long: 15.619536
    },
    {
        town: "Kun\u010Dice pod Ond\u0159ejn\xedkem",
        townCode: 598356,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73913,
        lat: 49.550798,
        long: 18.261235
    },
    {
        town: "Kun\u010Dina",
        townCode: 578282,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56924,
        lat: 49.794652,
        long: 16.627737
    },
    {
        town: "Kun\u010Dina Ves",
        townCode: 581844,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.44708,
        long: 16.475366
    },
    {
        town: 'Kundratice',
        townCode: 595977,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.402684,
        long: 16.134262
    },
    {
        town: "Kun\u011Bjovice",
        townCode: 559121,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33035,
        lat: 49.862066,
        long: 13.237025
    },
    {
        town: 'Kunemil',
        townCode: 548570,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.707561,
        long: 15.431616
    },
    {
        town: "Kun\u011Btice",
        townCode: 573515,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53304,
        lat: 50.070734,
        long: 15.827021
    },
    {
        town: 'Kunice',
        townCode: 581852,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.478926,
        long: 16.490834
    },
    {
        town: 'Kunice',
        townCode: 538426,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25163,
        lat: 49.936652,
        long: 14.671607
    },
    {
        town: "Kuni\u010Dky",
        townCode: 581861,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.435026,
        long: 16.681468
    },
    {
        town: "Kun\xedn",
        townCode: 568546,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74253,
        lat: 49.63387,
        long: 17.989756
    },
    {
        town: 'Kunkovice',
        townCode: 588628,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76813,
        lat: 49.182821,
        long: 17.174357
    },
    {
        town: 'Kunovice',
        townCode: 550744,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68604,
        lat: 49.045088,
        long: 17.470215
    },
    {
        town: 'Kunovice',
        townCode: 543021,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75644,
        lat: 49.444343,
        long: 17.809991
    },
    {
        town: "Ku\u0148ovice",
        townCode: 530026,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.658386,
        long: 14.999521
    },
    {
        town: 'Kunratice',
        townCode: 530433,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.921515,
        long: 15.026152
    },
    {
        town: 'Kunratice',
        townCode: 546330,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.818924,
        long: 14.41998
    },
    {
        town: 'Kunratice u Cvikova',
        townCode: 561746,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47155,
        lat: 50.768777,
        long: 14.678722
    },
    {
        town: "Kun\u0161t\xe1t",
        townCode: 581879,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67972,
        lat: 49.506551,
        long: 16.517324
    },
    {
        town: 'Kunvald',
        townCode: 580503,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56181,
        lat: 50.129372,
        long: 16.50007
    },
    {
        town: "Kun\u017Eak",
        townCode: 546615,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37862,
        lat: 49.12129,
        long: 15.190385
    },
    {
        town: "Kupa\u0159ovice",
        townCode: 583243,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.043314,
        long: 16.490816
    },
    {
        town: "Kurd\u011Bjov",
        townCode: 555282,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.957874,
        long: 16.763556
    },
    {
        town: 'Kuroslepy',
        townCode: 550302,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67575,
        lat: 49.154432,
        long: 16.210217
    },
    {
        town: 'Kurovice',
        townCode: 588636,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76852,
        lat: 49.289235,
        long: 17.515668
    },
    {
        town: "Ku\u0159im",
        townCode: 583251,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66434,
        lat: 49.298618,
        long: 16.531546
    },
    {
        town: "Ku\u0159imany",
        townCode: 560391,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.204002,
        long: 13.968229
    },
    {
        town: "Ku\u0159imsk\xe1 Nov\xe1 Ves",
        townCode: 595985,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.345656,
        long: 16.297158
    },
    {
        town: "Ku\u0159imsk\xe9 Jest\u0159ab\xed",
        townCode: 595993,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.346676,
        long: 16.314032
    },
    {
        town: "Kutn\xe1 Hora",
        townCode: 533955,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.952531,
        long: 15.268754
    },
    {
        town: 'Kutrovice',
        townCode: 571512,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27375,
        lat: 50.261654,
        long: 14.018974
    },
    {
        town: "Ku\u017Eelov",
        townCode: 586293,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69673,
        lat: 48.859737,
        long: 17.488933
    },
    {
        town: 'Kvasice',
        townCode: 588644,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.242324,
        long: 17.469853
    },
    {
        town: 'Kvasiny',
        townCode: 576425,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51702,
        lat: 50.212594,
        long: 16.263334
    },
    {
        town: "Kv\xe1skovice",
        townCode: 536750,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.188506,
        long: 14.003793
    },
    {
        town: "Kv\xe1\u0161\u0148ovice",
        townCode: 541931,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.413124,
        long: 13.642076
    },
    {
        town: "Kv\u011Btinov",
        townCode: 568953,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.564751,
        long: 15.50741
    },
    {
        town: "Kv\u011Btn\xe1",
        townCode: 578291,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.736321,
        long: 16.34626
    },
    {
        town: "Kv\u011Btnice",
        townCode: 564982,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25084,
        lat: 50.057363,
        long: 14.684222
    },
    {
        town: "Kv\u011Btov",
        townCode: 598801,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.425542,
        long: 14.275882
    },
    {
        town: "Kv\xed\u010Dovice",
        townCode: 553841,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.590322,
        long: 13.073059
    },
    {
        town: 'Kvilda',
        townCode: 550337,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38493,
        lat: 49.019358,
        long: 13.57968
    },
    {
        town: "Kv\xedlice",
        townCode: 532517,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27375,
        lat: 50.258155,
        long: 14.002429
    },
    {
        town: "Kv\xedtkov",
        townCode: 546259,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47001,
        lat: 50.655024,
        long: 14.486766
    },
    {
        town: "Kv\xedtkovice",
        townCode: 529729,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.957506,
        long: 14.33126
    },
    {
        town: 'Kyje',
        townCode: 572047,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50713,
        lat: 50.494389,
        long: 15.37809
    },
    {
        town: 'Kyjov',
        townCode: 586307,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69701,
        lat: 49.009967,
        long: 17.12261
    },
    {
        town: 'Kyjov',
        townCode: 548308,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.629564,
        long: 15.623325
    },
    {
        town: 'Kyjov',
        townCode: 596001,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.443544,
        long: 15.881657
    },
    {
        town: 'Kyjovice',
        townCode: 594318,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.913818,
        long: 16.166617
    },
    {
        town: 'Kyjovice',
        townCode: 512907,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74768,
        lat: 49.832445,
        long: 18.042227
    },
    {
        town: 'Kynice',
        townCode: 568970,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.739281,
        long: 15.360244
    },
    {
        town: "Kyn\u0161perk nad Oh\u0159\xed",
        townCode: 560499,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35751,
        lat: 50.119038,
        long: 12.530388
    },
    {
        town: 'Kyselka',
        townCode: 555347,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36272,
        lat: 50.262803,
        long: 13.000007
    },
    {
        town: 'Kyselovice',
        townCode: 588652,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76811,
        lat: 49.377252,
        long: 17.402164
    },
    {
        town: "Ky\u0161ice",
        townCode: 559130,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33001,
        lat: 49.753353,
        long: 13.486312
    },
    {
        town: "Ky\u0161ice",
        townCode: 532525,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.091291,
        long: 14.106343
    },
    {
        town: "Ky\u0161kovice",
        townCode: 565091,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.448307,
        long: 14.285987
    },
    {
        town: "Kyt\xedn",
        townCode: 571261,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.850721,
        long: 14.219156
    },
    {
        town: 'Kytlice',
        townCode: 562645,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40745,
        lat: 50.812746,
        long: 14.53547
    },
    {
        town: "Labsk\xe1 Str\xe1\u0148",
        townCode: 544701,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.848754,
        long: 14.231709
    },
    {
        town: "Labsk\xe9 Chr\u010Dice",
        townCode: 575259,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 28126,
        lat: 50.051519,
        long: 15.410279
    },
    {
        town: 'Labuty',
        townCode: 586315,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69648,
        lat: 49.046739,
        long: 17.214588
    },
    {
        town: "La\u010Dnov",
        townCode: 543098,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.178879,
        long: 18.016608
    },
    {
        town: "Ladn\xe1",
        townCode: 558443,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69146,
        lat: 48.805496,
        long: 16.872412
    },
    {
        town: "Laho\u0161\u0165",
        townCode: 567647,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41725,
        lat: 50.618346,
        long: 13.765404
    },
    {
        town: 'Lampertice',
        townCode: 548804,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54101,
        lat: 50.664684,
        long: 15.951068
    },
    {
        town: "Lan\u010Dov",
        townCode: 594326,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.907159,
        long: 15.767901
    },
    {
        town: "L\xe1nov",
        townCode: 579432,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54341,
        lat: 50.620172,
        long: 15.65585
    },
    {
        town: "Lan\u0161kroun",
        townCode: 580511,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.912141,
        long: 16.612597
    },
    {
        town: "L\xe1ny",
        townCode: 548481,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.759535,
        long: 15.712996
    },
    {
        town: "L\xe1ny",
        townCode: 504807,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.94646,
        long: 15.727244
    },
    {
        town: "L\xe1ny",
        townCode: 541991,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27061,
        lat: 50.124811,
        long: 13.950519
    },
    {
        town: "L\xe1ny u Da\u0161ic",
        townCode: 572845,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.043622,
        long: 15.889187
    },
    {
        town: "Lan\u017Ehot",
        townCode: 584622,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69151,
        lat: 48.724531,
        long: 16.967053
    },
    {
        town: "Lan\u017Eov",
        townCode: 579441,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.386918,
        long: 15.760854
    },
    {
        town: "L\xe1senice",
        townCode: 546623,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37801,
        lat: 49.074391,
        long: 14.970283
    },
    {
        town: "La\u0161kov",
        townCode: 589675,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79857,
        lat: 49.584113,
        long: 17.002235
    },
    {
        town: "La\u0161ovice",
        townCode: 542008,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27021,
        lat: 50.05506,
        long: 13.78231
    },
    {
        town: "Lavi\u010Dky",
        townCode: 596019,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.380597,
        long: 15.968444
    },
    {
        town: "Lavi\u010Dn\xe9",
        townCode: 578304,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.643678,
        long: 16.462574
    },
    {
        town: "L\xe1z",
        townCode: 510556,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67541,
        lat: 49.012392,
        long: 15.785165
    },
    {
        town: "L\xe1z",
        townCode: 540625,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26241,
        lat: 49.652138,
        long: 13.916712
    },
    {
        town: 'Lazinov',
        townCode: 581887,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.563913,
        long: 16.523495
    },
    {
        town: "L\xe1zn\u011B B\u011Blohrad",
        townCode: 573094,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50781,
        lat: 50.428843,
        long: 15.582797
    },
    {
        town: "L\xe1zn\u011B Bohdane\u010D",
        townCode: 574767,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.075702,
        long: 15.67989
    },
    {
        town: "L\xe1zn\u011B Kyn\u017Evart",
        townCode: 554600,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35491,
        lat: 50.010693,
        long: 12.624853
    },
    {
        town: "L\xe1zn\u011B Libverda",
        townCode: 564206,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46362,
        lat: 50.890241,
        long: 15.190471
    },
    {
        town: "L\xe1zn\u011B Tou\u0161e\u0148",
        townCode: 538914,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25089,
        lat: 50.16937,
        long: 14.716112
    },
    {
        town: "Lazn\xed\u010Dky",
        townCode: 514446,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75125,
        lat: 49.545565,
        long: 17.460189
    },
    {
        town: "Lazn\xedky",
        townCode: 514471,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75125,
        lat: 49.524536,
        long: 17.462787
    },
    {
        town: 'Lazsko',
        townCode: 564346,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.623599,
        long: 14.003954
    },
    {
        town: "La\u017E\xe1nky",
        townCode: 598950,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.391505,
        long: 13.836837
    },
    {
        town: "La\u017E\xe1nky",
        townCode: 583260,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.279046,
        long: 16.388167
    },
    {
        town: "La\u017Eany",
        townCode: 560197,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.36295,
        long: 13.883237
    },
    {
        town: "La\u017Eany",
        townCode: 581909,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.354468,
        long: 16.550117
    },
    {
        town: "La\u017Eany",
        townCode: 545937,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.601,
        long: 15.109852
    },
    {
        town: "La\u017Ei\u0161t\u011B",
        townCode: 550345,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38432,
        lat: 49.03766,
        long: 13.92781
    },
    {
        town: "L\xe1\u017Eovice",
        townCode: 533939,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.85831,
        long: 14.071383
    },
    {
        town: "L\u010Dovice",
        townCode: 561649,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.114639,
        long: 13.850712
    },
    {
        town: 'Ledce',
        townCode: 583278,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66462,
        lat: 49.051603,
        long: 16.55712
    },
    {
        town: 'Ledce',
        townCode: 576433,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.223913,
        long: 16.04283
    },
    {
        town: 'Ledce',
        townCode: 559148,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33014,
        lat: 49.821738,
        long: 13.328535
    },
    {
        town: 'Ledce',
        townCode: 532533,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27305,
        lat: 50.196529,
        long: 14.005095
    },
    {
        town: 'Ledce',
        townCode: 536202,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29447,
        lat: 50.353466,
        long: 15.084579
    },
    {
        town: "Led\u010Dice",
        townCode: 534978,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27708,
        lat: 50.341051,
        long: 14.294576
    },
    {
        town: "Lede\u010D nad S\xe1zavou",
        townCode: 568988,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.695269,
        long: 15.277827
    },
    {
        town: "Lede\u010Dko",
        townCode: 534170,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.84992,
        long: 14.94898
    },
    {
        town: 'Ledenice',
        townCode: 544736,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37311,
        lat: 48.932311,
        long: 14.618133
    },
    {
        town: 'Lednice',
        townCode: 584631,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69144,
        lat: 48.800018,
        long: 16.803498
    },
    {
        town: 'Ledvice',
        townCode: 567655,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41772,
        lat: 50.585119,
        long: 13.772139
    },
    {
        town: 'Lechotice',
        townCode: 588661,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76852,
        lat: 49.273774,
        long: 17.588001
    },
    {
        town: 'Lechovice',
        townCode: 594334,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67163,
        lat: 48.872953,
        long: 16.221921
    },
    {
        town: "Lej\u0161ovka",
        townCode: 570222,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.297761,
        long: 15.942389
    },
    {
        town: 'Lelekovice',
        townCode: 583286,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66431,
        lat: 49.291537,
        long: 16.578848
    },
    {
        town: "Lene\u0161ice",
        townCode: 566322,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43923,
        lat: 50.375267,
        long: 13.766007
    },
    {
        town: 'Lenora',
        townCode: 550353,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38442,
        lat: 48.922415,
        long: 13.79337
    },
    {
        town: 'Leskovec',
        townCode: 544264,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.284384,
        long: 17.998777
    },
    {
        town: "Leskovec nad Moravic\xed",
        townCode: 597546,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79368,
        lat: 49.905954,
        long: 17.574652
    },
    {
        town: 'Leskovice',
        townCode: 548235,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39414,
        lat: 49.43,
        long: 15.08121
    },
    {
        town: "Lesn\xe1",
        townCode: 594342,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.907277,
        long: 15.868824
    },
    {
        town: "Lesn\xe1",
        townCode: 562041,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.518016,
        long: 15.057662
    },
    {
        town: "Lesn\xe1",
        townCode: 590983,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.171418,
        long: 15.679494
    },
    {
        town: "Lesn\xe1",
        townCode: 561002,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.754286,
        long: 12.537785
    },
    {
        town: "Lesn\xed Hlubok\xe9",
        townCode: 583294,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.268807,
        long: 16.306928
    },
    {
        town: "Lesn\xed Jakubov",
        townCode: 590991,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67573,
        lat: 49.205878,
        long: 16.243465
    },
    {
        town: 'Lesnice',
        townCode: 537284,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.88386,
        long: 16.941325
    },
    {
        town: 'Lesonice',
        townCode: 594351,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.003355,
        long: 16.310735
    },
    {
        town: 'Lesonice',
        townCode: 591009,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.107958,
        long: 15.755986
    },
    {
        town: 'Lestkov',
        townCode: 561011,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34953,
        lat: 49.883163,
        long: 12.871116
    },
    {
        town: "Les\u016F\u0148ky",
        townCode: 573485,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.107167,
        long: 15.84245
    },
    {
        town: "Le\u0161any",
        townCode: 589683,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79842,
        lat: 49.499779,
        long: 17.024171
    },
    {
        town: "Le\u0161any",
        townCode: 530051,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25744,
        lat: 49.844269,
        long: 14.525051
    },
    {
        town: "Le\u0161etice",
        townCode: 513521,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.647301,
        long: 14.02119
    },
    {
        town: "Le\u0161kovice",
        townCode: 568996,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.762995,
        long: 15.537109
    },
    {
        town: "Le\u0161n\xe1",
        townCode: 544302,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75641,
        lat: 49.520653,
        long: 17.930151
    },
    {
        town: "Le\u0161tina",
        townCode: 537713,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78971,
        lat: 49.868883,
        long: 16.927588
    },
    {
        town: "Le\u0161tina",
        townCode: 571695,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.867762,
        long: 16.117895
    },
    {
        town: "Le\u0161tina u Sv\u011Btl\xe9",
        townCode: 569011,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58286,
        lat: 49.761453,
        long: 15.39771
    },
    {
        town: "Le\u0161tinka",
        townCode: 571709,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53973,
        lat: 49.845309,
        long: 15.958993
    },
    {
        town: 'Letiny',
        townCode: 557951,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.540003,
        long: 13.455391
    },
    {
        town: 'Letkov',
        townCode: 540561,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 32600,
        lat: 49.730543,
        long: 13.465091
    },
    {
        town: 'Letohrad',
        townCode: 580538,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56151,
        lat: 50.036122,
        long: 16.500231
    },
    {
        town: 'Letonice',
        townCode: 593257,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68335,
        lat: 49.17736,
        long: 16.959237
    },
    {
        town: 'Letovice',
        townCode: 581917,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.547189,
        long: 16.573678
    },
    {
        town: 'Lety',
        townCode: 549568,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.517034,
        long: 14.087866
    },
    {
        town: 'Lety',
        townCode: 539406,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25229,
        lat: 49.9211,
        long: 14.255311
    },
    {
        town: "Lev\xedn",
        townCode: 565105,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.613935,
        long: 14.284017
    },
    {
        town: "Lev\xednsk\xe1 Ole\u0161nice",
        townCode: 577375,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51401,
        lat: 50.528307,
        long: 15.540814
    },
    {
        town: "Lh\xe1nice",
        townCode: 591025,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67575,
        lat: 49.109192,
        long: 16.223507
    },
    {
        town: 'Lhenice',
        townCode: 550361,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38402,
        lat: 48.994897,
        long: 14.149903
    },
    {
        town: 'Lhota',
        townCode: 514497,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.497745,
        long: 17.614881
    },
    {
        town: 'Lhota',
        townCode: 513041,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27301,
        lat: 50.088744,
        long: 14.011917
    },
    {
        town: 'Lhota',
        townCode: 534986,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.243309,
        long: 14.65652
    },
    {
        town: 'Lhota',
        townCode: 573434,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76302,
        lat: 49.169435,
        long: 17.602533
    },
    {
        town: "Lhota pod Ho\u0159i\u010Dkami",
        townCode: 574180,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.422788,
        long: 16.003204
    },
    {
        town: "Lhota pod Lib\u010Dany",
        townCode: 570231,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.172522,
        long: 15.696345
    },
    {
        town: "Lhota pod Rad\u010Dem",
        townCode: 567001,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.827464,
        long: 13.710816
    },
    {
        town: 'Lhota Rapotina',
        townCode: 581925,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.466146,
        long: 16.624954
    },
    {
        town: 'Lhota u Lysic',
        townCode: 581933,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.469778,
        long: 16.496885
    },
    {
        town: "Lhota u Ole\u0161nice",
        townCode: 581941,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.544909,
        long: 16.390829
    },
    {
        town: "Lhota u P\u0159\xedbram\u011B",
        townCode: 598411,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.714255,
        long: 13.980642
    },
    {
        town: "Lhota u Vset\xedna",
        townCode: 556866,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75501,
        lat: 49.304675,
        long: 17.958094
    },
    {
        town: 'Lhota-Vlasenice',
        townCode: 561282,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.302785,
        long: 15.12482
    },
    {
        town: 'Lhotice',
        townCode: 544876,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.019369,
        long: 15.60716
    },
    {
        town: 'Lhotka',
        townCode: 587451,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.209194,
        long: 15.385751
    },
    {
        town: 'Lhotka',
        townCode: 596035,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.582281,
        long: 16.002978
    },
    {
        town: 'Lhotka',
        townCode: 598364,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73947,
        lat: 49.597285,
        long: 18.298465
    },
    {
        town: 'Lhotka',
        townCode: 514527,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75124,
        lat: 49.499836,
        long: 17.410166
    },
    {
        town: 'Lhotka',
        townCode: 533335,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26723,
        lat: 49.83232,
        long: 13.996335
    },
    {
        town: 'Lhotka',
        townCode: 531898,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27731,
        lat: 50.371468,
        long: 14.548888
    },
    {
        town: 'Lhotka nad Labem',
        townCode: 565113,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.525685,
        long: 14.047429
    },
    {
        town: 'Lhotka u Litultovic',
        townCode: 553115,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74755,
        lat: 49.872905,
        long: 17.730857
    },
    {
        town: 'Lhotka u Radnic',
        townCode: 559946,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.89004,
        long: 13.581715
    },
    {
        town: 'Lhotky',
        townCode: 536211,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.396401,
        long: 15.052956
    },
    {
        town: 'Lhotsko',
        townCode: 549550,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.212296,
        long: 17.883478
    },
    {
        town: "Lhoty u Pot\u0161tejna",
        townCode: 576441,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.055957,
        long: 16.268803
    },
    {
        town: "Lh\u016Fta",
        townCode: 578606,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33201,
        lat: 49.70137,
        long: 13.52891
    },
    {
        town: "Lib\xe1",
        townCode: 554618,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35131,
        lat: 50.128275,
        long: 12.230943
    },
    {
        town: "Lib\xe1\u0148",
        townCode: 573108,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.375516,
        long: 15.21695
    },
    {
        town: "Libav\xe1 (vojensk\xfd \xfajezd)",
        townCode: 503941,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.723088,
        long: 17.523528
    },
    {
        town: "Libavsk\xe9 \xdadol\xed",
        townCode: 560502,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35751,
        lat: 50.128978,
        long: 12.552602
    },
    {
        town: "Lib\u010Dany",
        townCode: 570249,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50322,
        lat: 50.191851,
        long: 15.695007
    },
    {
        town: "Lib\u010Deves",
        townCode: 566349,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43926,
        lat: 50.452574,
        long: 13.838289
    },
    {
        town: "Lib\u010Dice nad Vltavou",
        townCode: 539414,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25266,
        lat: 50.199129,
        long: 14.362784
    },
    {
        town: 'Libecina',
        townCode: 580562,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.882981,
        long: 16.118331
    },
    {
        town: "Lib\u011Bdice",
        townCode: 563188,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.315996,
        long: 13.385678
    },
    {
        town: "Lib\u011Bchov",
        townCode: 535001,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.407939,
        long: 14.446855
    },
    {
        town: "Lib\u011Bjice",
        townCode: 563544,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.376947,
        long: 14.623952
    },
    {
        town: "Lib\u011Bjovice",
        townCode: 551333,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38772,
        lat: 49.114439,
        long: 14.193459
    },
    {
        town: 'Libel',
        townCode: 548651,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.15517,
        long: 16.202418
    },
    {
        town: 'Libenice',
        townCode: 533475,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.984575,
        long: 15.258007
    },
    {
        town: 'Liberec',
        townCode: 563889,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46001,
        lat: 50.76638,
        long: 15.054439
    },
    {
        town: 'Liberk',
        townCode: 576450,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51712,
        lat: 50.199288,
        long: 16.343029
    },
    {
        town: "Libe\u0159",
        townCode: 539422,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25241,
        lat: 49.924257,
        long: 14.480724
    },
    {
        town: "Lib\u011B\u0161ice",
        townCode: 565121,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41146,
        lat: 50.568962,
        long: 14.289175
    },
    {
        town: "Lib\u011B\u0161ice",
        townCode: 566357,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43963,
        lat: 50.293667,
        long: 13.621573
    },
    {
        town: "Lib\u011Btice",
        townCode: 536831,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.219149,
        long: 13.862757
    },
    {
        town: "L\xedbeznice",
        townCode: 538442,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25065,
        lat: 50.192079,
        long: 14.493682
    },
    {
        town: "Libe\u017E",
        townCode: 530069,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.757522,
        long: 14.916873
    },
    {
        town: "Libho\u0161\u0165",
        townCode: 500046,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74257,
        lat: 49.626557,
        long: 18.077075
    },
    {
        town: 'Libchavy',
        townCode: 580147,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56116,
        lat: 50.005575,
        long: 16.38914
    },
    {
        town: "Libchyn\u011B",
        townCode: 547701,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.356657,
        long: 16.190034
    },
    {
        town: 'Libice nad Cidlinou',
        townCode: 537438,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28907,
        lat: 50.126874,
        long: 15.178306
    },
    {
        town: 'Libice nad Doubravou',
        townCode: 569020,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58277,
        lat: 49.745023,
        long: 15.704338
    },
    {
        town: "Lib\xedn",
        townCode: 544744,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37373,
        lat: 48.969727,
        long: 14.683706
    },
    {
        town: 'Libina',
        townCode: 539961,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78805,
        lat: 49.876529,
        long: 17.08282
    },
    {
        town: "Libi\u0161",
        townCode: 571784,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27711,
        lat: 50.274275,
        long: 14.50251
    },
    {
        town: "Libi\u0161any",
        townCode: 575305,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.153387,
        long: 15.756738
    },
    {
        town: 'Libkov',
        townCode: 571725,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.841833,
        long: 15.75641
    },
    {
        town: 'Libkov',
        townCode: 553859,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.366295,
        long: 13.13447
    },
    {
        town: 'Libkova Voda',
        townCode: 598721,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39462,
        lat: 49.376595,
        long: 15.191112
    },
    {
        town: "Libkovice pod \u0158\xedpem",
        townCode: 565148,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.392532,
        long: 14.342424
    },
    {
        town: 'Liblice',
        townCode: 531502,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27732,
        lat: 50.31343,
        long: 14.590516
    },
    {
        town: "Libl\xedn",
        townCode: 559954,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.916919,
        long: 13.544351
    },
    {
        town: "Lib\u0148atov",
        townCode: 579475,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54236,
        lat: 50.481436,
        long: 16.002299
    },
    {
        town: "Libn\xed\u010D",
        townCode: 535800,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 49.019769,
        long: 14.543731
    },
    {
        town: "Libn\xedkovice",
        townCode: 570257,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.244268,
        long: 15.996241
    },
    {
        town: "Libo\u010Dany",
        townCode: 530590,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43975,
        lat: 50.33349,
        long: 13.513599
    },
    {
        town: "Libod\u0159ice",
        townCode: 533483,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.004416,
        long: 15.088387
    },
    {
        town: 'Libochovany',
        townCode: 565156,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41103,
        lat: 50.566669,
        long: 14.039146
    },
    {
        town: 'Libochovice',
        townCode: 565164,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41117,
        lat: 50.406368,
        long: 14.044498
    },
    {
        town: "Libochovi\u010Dky",
        townCode: 564150,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27342,
        lat: 50.172676,
        long: 14.239708
    },
    {
        town: "Libom\u011B\u0159ice",
        townCode: 571733,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.87195,
        long: 15.741396
    },
    {
        town: "Libomy\u0161l",
        townCode: 531448,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26723,
        lat: 49.872637,
        long: 13.998731
    },
    {
        town: "Libo\u0159ice",
        townCode: 566381,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.254811,
        long: 13.515189
    },
    {
        town: "Libo\u0161",
        townCode: 569003,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78313,
        lat: 49.691682,
        long: 17.225136
    },
    {
        town: "Libo\u0161ovice",
        townCode: 573116,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50744,
        lat: 50.490669,
        long: 15.162912
    },
    {
        town: 'Libotenice',
        townCode: 565172,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.477022,
        long: 14.229354
    },
    {
        town: 'Libotov',
        townCode: 579483,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.399472,
        long: 15.811963
    },
    {
        town: 'Libouchec',
        townCode: 568058,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40335,
        lat: 50.75865,
        long: 14.040826
    },
    {
        town: 'Libovice',
        townCode: 571601,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27379,
        lat: 50.235701,
        long: 14.016452
    },
    {
        town: 'Librantice',
        townCode: 570265,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.242363,
        long: 15.95985
    },
    {
        town: "Lib\u0159ice",
        townCode: 570273,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50344,
        lat: 50.287938,
        long: 15.963989
    },
    {
        town: "Lib\u0161t\xe1t",
        townCode: 577294,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51203,
        lat: 50.559503,
        long: 15.416037
    },
    {
        town: "Libu\u0148",
        townCode: 573124,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50715,
        lat: 50.498255,
        long: 15.298603
    },
    {
        town: "Libu\u0161\xedn",
        townCode: 532576,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27306,
        lat: 50.168293,
        long: 14.05469
    },
    {
        town: "Licibo\u0159ice",
        townCode: 547832,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53823,
        lat: 49.877003,
        long: 15.760021
    },
    {
        town: "Li\u010Dno",
        townCode: 576468,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51735,
        lat: 50.177967,
        long: 16.172124
    },
    {
        town: "Lide\u010Dko",
        townCode: 544370,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.20313,
        long: 18.051411
    },
    {
        town: 'Lidice',
        townCode: 532584,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27354,
        lat: 50.143626,
        long: 14.190234
    },
    {
        town: "Lidma\u0148",
        townCode: 561100,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.381938,
        long: 15.036826
    },
    {
        town: 'Lichkov',
        townCode: 580571,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56168,
        lat: 50.097876,
        long: 16.666117
    },
    {
        town: 'Lichnov',
        townCode: 597554,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79315,
        lat: 50.007958,
        long: 17.62651
    },
    {
        town: 'Lichnov',
        townCode: 599603,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74275,
        lat: 49.563651,
        long: 18.170051
    },
    {
        town: 'Lichoceves',
        townCode: 571326,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25264,
        lat: 50.152863,
        long: 14.284353
    },
    {
        town: "L\xedn\u011B",
        townCode: 559164,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33021,
        lat: 49.694828,
        long: 13.257039
    },
    {
        town: 'Linhartice',
        townCode: 578339,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.757429,
        long: 16.695338
    },
    {
        town: "L\xedpa",
        townCode: 569038,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58257,
        lat: 49.554584,
        long: 15.542919
    },
    {
        town: "L\xedpa",
        townCode: 549622,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76311,
        lat: 49.215383,
        long: 17.768842
    },
    {
        town: "L\xedpa nad Orlic\xed",
        townCode: 576476,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51721,
        lat: 50.135714,
        long: 16.098112
    },
    {
        town: 'Lipec',
        townCode: 513270,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28126,
        lat: 50.085084,
        long: 15.364668
    },
    {
        town: "Lip\xed",
        townCode: 544761,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.949581,
        long: 14.352239
    },
    {
        town: 'Lipina',
        townCode: 552305,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.741758,
        long: 17.323633
    },
    {
        town: 'Lipinka',
        townCode: 540005,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78383,
        lat: 49.837875,
        long: 17.050055
    },
    {
        town: "Lipnice nad S\xe1zavou",
        townCode: 569046,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58232,
        lat: 49.613125,
        long: 15.413664
    },
    {
        town: "Lipn\xedk",
        townCode: 591041,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.144357,
        long: 15.950723
    },
    {
        town: "Lipn\xedk",
        townCode: 565563,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29443,
        lat: 50.272647,
        long: 14.912532
    },
    {
        town: "Lipn\xedk nad Be\u010Dvou",
        townCode: 514705,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.526832,
        long: 17.586743
    },
    {
        town: 'Lipno',
        townCode: 566403,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.300702,
        long: 13.680972
    },
    {
        town: 'Lipno nad Vltavou',
        townCode: 545597,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38278,
        lat: 48.639427,
        long: 14.22942
    },
    {
        town: 'Lipoltice',
        townCode: 575313,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53364,
        lat: 49.98787,
        long: 15.568989
    },
    {
        town: 'Lipov',
        townCode: 586323,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69672,
        lat: 48.905046,
        long: 17.46182
    },
    {
        town: "Lipov\xe1",
        townCode: 554626,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.036398,
        long: 12.448928
    },
    {
        town: "Lipov\xe1",
        townCode: 589691,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79845,
        lat: 49.526065,
        long: 16.861891
    },
    {
        town: "Lipov\xe1",
        townCode: 514772,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.409927,
        long: 17.614169
    },
    {
        town: "Lipov\xe1",
        townCode: 562661,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40781,
        lat: 51.011146,
        long: 14.360332
    },
    {
        town: "Lipov\xe1",
        townCode: 586871,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.121999,
        long: 17.879725
    },
    {
        town: "Lipov\xe1-l\xe1zn\u011B",
        townCode: 540030,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79061,
        lat: 50.227866,
        long: 17.14055
    },
    {
        town: 'Lipovec',
        townCode: 581950,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67915,
        lat: 49.38404,
        long: 16.805938
    },
    {
        town: 'Lipovec',
        townCode: 547875,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.916436,
        long: 15.545079
    },
    {
        town: 'Lipovice',
        townCode: 537071,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.100635,
        long: 13.993981
    },
    {
        town: "Lipt\xe1l",
        townCode: 544396,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75501,
        lat: 49.290608,
        long: 17.921879
    },
    {
        town: "Lipta\u0148",
        townCode: 597571,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.222367,
        long: 17.605521
    },
    {
        town: "Lip\u016Fvka",
        townCode: 581968,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.340382,
        long: 16.553004
    },
    {
        town: "L\xedsek",
        townCode: 596051,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.586936,
        long: 16.201244
    },
    {
        town: "L\xedskovice",
        townCode: 573086,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.336986,
        long: 15.554989
    },
    {
        town: "L\xedsk\xfd",
        townCode: 571555,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27376,
        lat: 50.250661,
        long: 13.929036
    },
    {
        town: 'Lisov',
        townCode: 540064,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.638638,
        long: 13.100966
    },
    {
        town: "Li\u0161any",
        townCode: 542016,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27052,
        lat: 50.147452,
        long: 13.742038
    },
    {
        town: "Li\u0161any",
        townCode: 566411,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.344465,
        long: 13.642025
    },
    {
        town: "Li\u0161ice",
        townCode: 570290,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.181052,
        long: 15.408168
    },
    {
        town: "L\xed\u0161ina",
        townCode: 540617,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.603604,
        long: 13.164824
    },
    {
        town: "L\xed\u0161n\xe1",
        townCode: 596060,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.640272,
        long: 16.151155
    },
    {
        town: "L\xed\u0161n\xe1",
        townCode: 514802,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75115,
        lat: 49.411684,
        long: 17.547451
    },
    {
        town: "L\xed\u0161n\xe1",
        townCode: 559962,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.885111,
        long: 13.806522
    },
    {
        town: "Li\u0161nice",
        townCode: 567248,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.454552,
        long: 13.63312
    },
    {
        town: "L\xed\u0161nice",
        townCode: 540161,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78985,
        lat: 49.75594,
        long: 16.876089
    },
    {
        town: "L\xed\u0161nice",
        townCode: 580589,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56184,
        lat: 50.079921,
        long: 16.508318
    },
    {
        town: "L\xed\u0161nice",
        townCode: 539457,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.888884,
        long: 14.319068
    },
    {
        town: "L\xed\u0161n\xfd",
        townCode: 563676,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.64567,
        long: 15.212313
    },
    {
        town: "Li\u0161ov",
        townCode: 544779,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37372,
        lat: 49.016073,
        long: 14.608479
    },
    {
        town: "L\xed\u0161\u0165any",
        townCode: 559172,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33035,
        lat: 49.831183,
        long: 13.181206
    },
    {
        town: "L\xed\u0161\u0165any",
        townCode: 546879,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.312594,
        long: 13.800031
    },
    {
        town: "L\xedt\xe9",
        townCode: 566420,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.913753,
        long: 13.26085
    },
    {
        town: "Lite\u0148",
        townCode: 531456,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.903811,
        long: 14.149092
    },
    {
        town: "Liten\u010Dice",
        townCode: 588695,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76813,
        lat: 49.202303,
        long: 17.208524
    },
    {
        town: "Lit\xed\u010D",
        townCode: 546470,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.375254,
        long: 15.84848
    },
    {
        town: 'Litichovice',
        townCode: 532258,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.783034,
        long: 14.850678
    },
    {
        town: "Litobo\u0159",
        townCode: 573388,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.449962,
        long: 16.015368
    },
    {
        town: "Litobrat\u0159ice",
        townCode: 594369,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.887149,
        long: 16.402604
    },
    {
        town: 'Litohlavy',
        townCode: 553611,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.766543,
        long: 13.56469
    },
    {
        town: "Litoho\u0159",
        townCode: 550507,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.066937,
        long: 15.768521
    },
    {
        town: "Litoho\u0161\u0165",
        townCode: 561266,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.449741,
        long: 15.091095
    },
    {
        town: 'Litochovice',
        townCode: 551341,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.159413,
        long: 13.94153
    },
    {
        town: "Litom\u011B\u0159ice",
        townCode: 564567,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.53852,
        long: 14.130646
    },
    {
        town: "Litomy\u0161l",
        townCode: 578347,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.870623,
        long: 16.311162
    },
    {
        town: 'Litostrov',
        townCode: 583308,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.225246,
        long: 16.330795
    },
    {
        town: "Lito\u0161ice",
        townCode: 575330,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.984932,
        long: 15.514334
    },
    {
        town: 'Litovany',
        townCode: 591068,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67557,
        lat: 49.055056,
        long: 16.044024
    },
    {
        town: 'Litovel',
        townCode: 503444,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78401,
        lat: 49.701309,
        long: 17.076255
    },
    {
        town: 'Litultovice',
        townCode: 507920,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74755,
        lat: 49.90397,
        long: 17.751529
    },
    {
        town: "Litv\xednov",
        townCode: 567256,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43601,
        lat: 50.598526,
        long: 13.610342
    },
    {
        town: "Litv\xednovice",
        townCode: 544795,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.962172,
        long: 14.451559
    },
    {
        town: "Lk\xe1\u0148",
        townCode: 546691,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.443126,
        long: 13.969778
    },
    {
        town: "Ln\xe1\u0159e",
        townCode: 551350,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38742,
        lat: 49.458006,
        long: 13.784168
    },
    {
        town: "Lobe\u010D",
        townCode: 531677,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27736,
        lat: 50.460567,
        long: 14.666882
    },
    {
        town: 'Lobendava',
        townCode: 545708,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40784,
        lat: 51.019574,
        long: 14.314344
    },
    {
        town: 'Lobodice',
        townCode: 515191,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75101,
        lat: 49.395559,
        long: 17.292031
    },
    {
        town: "Lo\u010Denice",
        townCode: 544809,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37322,
        lat: 48.824304,
        long: 14.527609
    },
    {
        town: "Lod\u011Bnice",
        townCode: 594377,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67175,
        lat: 49.011698,
        long: 16.463176
    },
    {
        town: "Lod\u011Bnice",
        townCode: 531464,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26712,
        lat: 49.994962,
        long: 14.157959
    },
    {
        town: "Lodh\xe9\u0159ov",
        townCode: 546666,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37826,
        lat: 49.215189,
        long: 14.960045
    },
    {
        town: "Lod\xedn",
        townCode: 570303,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.270952,
        long: 15.610553
    },
    {
        town: 'Lochenice',
        townCode: 570311,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50302,
        lat: 50.272221,
        long: 15.820017
    },
    {
        town: 'Lochousice',
        townCode: 566462,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.675204,
        long: 13.090555
    },
    {
        town: 'Lochovice',
        townCode: 531472,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26723,
        lat: 49.853286,
        long: 13.981372
    },
    {
        town: 'Loket',
        townCode: 560537,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35733,
        lat: 50.186112,
        long: 12.754163
    },
    {
        town: 'Loket',
        townCode: 530093,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.655592,
        long: 15.116995
    },
    {
        town: 'Lom',
        townCode: 536822,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.410552,
        long: 13.989092
    },
    {
        town: 'Lom',
        townCode: 563587,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.362958,
        long: 14.62841
    },
    {
        town: 'Lom',
        townCode: 567264,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43511,
        lat: 50.593384,
        long: 13.657403
    },
    {
        town: 'Lom u Tachova',
        townCode: 541702,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.818772,
        long: 12.692703
    },
    {
        town: 'Lomec',
        townCode: 578070,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.371502,
        long: 13.267633
    },
    {
        town: 'Lomnice',
        townCode: 581976,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.404719,
        long: 16.413696
    },
    {
        town: 'Lomnice',
        townCode: 560545,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.211851,
        long: 12.632789
    },
    {
        town: 'Lomnice',
        townCode: 597589,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79302,
        lat: 49.871099,
        long: 17.415174
    },
    {
        town: "Lomnice nad Lu\u017Enic\xed",
        townCode: 546674,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37816,
        lat: 49.084786,
        long: 14.717374
    },
    {
        town: 'Lomnice nad Popelkou',
        townCode: 577308,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51251,
        lat: 50.530724,
        long: 15.373517
    },
    {
        town: "Lomni\u010Dka",
        townCode: 583316,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.367091,
        long: 16.431352
    },
    {
        town: 'Lomy',
        townCode: 587605,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.065617,
        long: 15.601184
    },
    {
        town: "Lopen\xedk",
        townCode: 592340,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68767,
        lat: 48.942882,
        long: 17.781225
    },
    {
        town: "Losin\xe1",
        townCode: 558001,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.6693,
        long: 13.448442
    },
    {
        town: "Lo\u0161any",
        townCode: 533505,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.99764,
        long: 15.126048
    },
    {
        town: "Lo\u0161tice",
        townCode: 540196,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78983,
        lat: 49.744796,
        long: 16.929028
    },
    {
        town: "Louck\xe1",
        townCode: 535095,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27324,
        lat: 50.327578,
        long: 14.239126
    },
    {
        town: "Lou\u010Dany",
        townCode: 552232,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78344,
        lat: 49.601996,
        long: 17.082765
    },
    {
        town: "Lou\u010De\u0148",
        townCode: 537446,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28937,
        lat: 50.285812,
        long: 15.02016
    },
    {
        town: "Lou\u010Dim",
        townCode: 553867,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.367168,
        long: 13.112222
    },
    {
        town: "Lou\u010Dka",
        townCode: 552038,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.656944,
        long: 17.011221
    },
    {
        town: "Lou\u010Dka",
        townCode: 544418,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75644,
        lat: 49.438791,
        long: 17.832764
    },
    {
        town: "Lou\u010Dka",
        townCode: 585432,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76325,
        lat: 49.170133,
        long: 17.876186
    },
    {
        town: "Lou\u010Dky",
        townCode: 573400,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.617659,
        long: 15.218593
    },
    {
        town: "Lou\u010Dn\xe1 nad Desnou",
        townCode: 540226,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78811,
        lat: 50.07166,
        long: 17.091064
    },
    {
        town: "Lou\u010Dn\xe1 pod Kl\xednovcem",
        townCode: 546518,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43191,
        lat: 50.420711,
        long: 12.986674
    },
    {
        town: "Lou\u010Dovice",
        townCode: 545601,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38276,
        lat: 48.620292,
        long: 14.257565
    },
    {
        town: 'Louka',
        townCode: 553875,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.529269,
        long: 16.43115
    },
    {
        town: 'Louka',
        townCode: 586331,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69676,
        lat: 48.915266,
        long: 17.489382
    },
    {
        town: "Louka u Litv\xednova",
        townCode: 567272,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43533,
        lat: 50.587967,
        long: 13.636592
    },
    {
        town: 'Loukov',
        townCode: 570770,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29411,
        lat: 50.561381,
        long: 15.035739
    },
    {
        town: 'Loukov',
        townCode: 588709,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76875,
        lat: 49.421886,
        long: 17.721131
    },
    {
        town: 'Loukovec',
        townCode: 536261,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29411,
        lat: 50.562014,
        long: 15.015815
    },
    {
        town: 'Loukovice',
        townCode: 591092,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.137327,
        long: 15.793465
    },
    {
        town: "Lou\u0148ov\xe1",
        townCode: 558010,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.562286,
        long: 13.608016
    },
    {
        town: "Lou\u0148ovice",
        townCode: 538451,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25162,
        lat: 49.982366,
        long: 14.761849
    },
    {
        town: "Lou\u0148ovice pod Blan\xedkem",
        townCode: 530107,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25706,
        lat: 49.637336,
        long: 14.846795
    },
    {
        town: 'Louny',
        townCode: 565971,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.354081,
        long: 13.803455
    },
    {
        town: "Lou\u017Enice",
        townCode: 563684,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.679747,
        long: 15.2678
    },
    {
        town: "Lov\u010Dice",
        townCode: 586340,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69639,
        lat: 49.063682,
        long: 17.05439
    },
    {
        town: "Lov\u010Dice",
        townCode: 570320,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50361,
        lat: 50.165301,
        long: 15.38474
    },
    {
        town: "Lov\u010Di\u010Dky",
        townCode: 593265,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68354,
        lat: 49.068009,
        long: 16.850309
    },
    {
        town: "Lov\u010Dovice",
        townCode: 544957,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 48.981577,
        long: 15.53442
    },
    {
        town: "Love\u010Dkovice",
        townCode: 565211,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.621676,
        long: 14.263257
    },
    {
        town: 'Lovosice',
        townCode: 565229,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.515143,
        long: 14.051142
    },
    {
        town: 'Loza',
        townCode: 566446,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.893909,
        long: 13.290472
    },
    {
        town: 'Lozice',
        townCode: 571750,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53854,
        lat: 49.916576,
        long: 16.023891
    },
    {
        town: "L\u0161t\u011Bn\xed",
        townCode: 532193,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25722,
        lat: 49.864385,
        long: 14.71437
    },
    {
        town: "Lub\u011B",
        townCode: 581992,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.396274,
        long: 16.526068
    },
    {
        town: 'Lubenec',
        townCode: 566438,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43983,
        lat: 50.132182,
        long: 13.313301
    },
    {
        town: "Lub\u011Bnice",
        townCode: 552216,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78346,
        lat: 49.576275,
        long: 17.120578
    },
    {
        town: "Lubn\xe1",
        townCode: 578355,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56963,
        lat: 49.774189,
        long: 16.223798
    },
    {
        town: "Lubn\xe1",
        townCode: 542032,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27036,
        lat: 50.07703,
        long: 13.700847
    },
    {
        town: "Lubn\xe1",
        townCode: 588717,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.220846,
        long: 17.398055
    },
    {
        town: "Lubn\xe9",
        townCode: 596078,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.354268,
        long: 16.275314
    },
    {
        town: 'Lubnice',
        townCode: 594385,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.939563,
        long: 15.613963
    },
    {
        town: "Lubn\xedk",
        townCode: 580619,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.888599,
        long: 16.661647
    },
    {
        town: "Lubom\u011B\u0159",
        townCode: 599646,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.688754,
        long: 17.706584
    },
    {
        town: "Lubom\u011B\u0159 pod Str\xe1\u017Enou",
        townCode: 500151,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75362,
        lat: 49.689117,
        long: 17.663752
    },
    {
        town: 'Luby',
        townCode: 554634,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35137,
        lat: 50.252592,
        long: 12.406065
    },
    {
        town: "Lu\u010Dany nad Nisou",
        townCode: 563692,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46871,
        lat: 50.741456,
        long: 15.220572
    },
    {
        town: "Lu\u010Dice",
        townCode: 569062,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58235,
        lat: 49.662406,
        long: 15.496764
    },
    {
        town: "Lu\u010Dina",
        townCode: 598399,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73939,
        lat: 49.716011,
        long: 18.449769
    },
    {
        town: "Ludge\u0159ovice",
        townCode: 507971,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74714,
        lat: 49.89052,
        long: 18.24019
    },
    {
        town: "Lud\xedkov",
        townCode: 531006,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.455493,
        long: 16.731887
    },
    {
        town: 'Ludkovice',
        townCode: 585441,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76341,
        lat: 49.114836,
        long: 17.72672
    },
    {
        town: "Ludm\xedrov",
        townCode: 589705,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79855,
        lat: 49.641418,
        long: 16.87332
    },
    {
        town: 'Ludslavice',
        townCode: 588725,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76852,
        lat: 49.299616,
        long: 17.540777
    },
    {
        town: "Ludv\xedkov",
        townCode: 551996,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79326,
        lat: 50.107531,
        long: 17.342351
    },
    {
        town: "Ludv\xedkovice",
        townCode: 546496,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40713,
        lat: 50.794169,
        long: 14.256524
    },
    {
        town: "Luha\u010Dovice",
        townCode: 585459,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76326,
        lat: 49.099922,
        long: 17.757583
    },
    {
        town: 'Luka',
        townCode: 514161,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.51251,
        long: 14.664183
    },
    {
        town: "Luk\xe1",
        townCode: 503622,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78324,
        lat: 49.649243,
        long: 16.947383
    },
    {
        town: 'Luka nad Jihlavou',
        townCode: 587478,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58822,
        lat: 49.374132,
        long: 15.702039
    },
    {
        town: 'Lukavec',
        townCode: 548332,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39426,
        lat: 49.565511,
        long: 14.990517
    },
    {
        town: 'Lukavec',
        townCode: 565237,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.501745,
        long: 14.085804
    },
    {
        town: "Lukavec u Ho\u0159ic",
        townCode: 573141,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.395819,
        long: 15.616987
    },
    {
        town: 'Lukavice',
        townCode: 576492,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51603,
        lat: 50.200324,
        long: 16.293747
    },
    {
        town: 'Lukavice',
        townCode: 540234,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.823003,
        long: 16.920503
    },
    {
        town: 'Lukavice',
        townCode: 571768,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.888935,
        long: 15.839045
    },
    {
        town: 'Lukavice',
        townCode: 580627,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56151,
        lat: 50.060386,
        long: 16.482177
    },
    {
        town: 'Lukov',
        townCode: 594393,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.861685,
        long: 15.910794
    },
    {
        town: 'Lukov',
        townCode: 550566,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67602,
        lat: 49.073601,
        long: 15.824336
    },
    {
        town: 'Lukov',
        townCode: 546909,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41804,
        lat: 50.528228,
        long: 13.885519
    },
    {
        town: 'Lukov',
        townCode: 585467,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76317,
        lat: 49.290372,
        long: 17.729695
    },
    {
        town: "Lukov\xe1",
        townCode: 580635,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56123,
        lat: 49.875582,
        long: 16.606774
    },
    {
        town: 'Lukovany',
        townCode: 583324,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.162573,
        long: 16.297954
    },
    {
        town: "Lukove\u010Dek",
        townCode: 557145,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76316,
        lat: 49.30359,
        long: 17.668809
    },
    {
        town: "Lule\u010D",
        townCode: 593273,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68303,
        lat: 49.253592,
        long: 16.928755
    },
    {
        town: 'Lupenice',
        townCode: 576506,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.132992,
        long: 16.273884
    },
    {
        town: "Lu\u0161t\u011Bnice",
        townCode: 536270,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29442,
        lat: 50.323059,
        long: 14.93678
    },
    {
        town: "Lut\xedn",
        townCode: 503657,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78349,
        lat: 49.558552,
        long: 17.135827
    },
    {
        town: 'Lutonina',
        townCode: 585483,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.238638,
        long: 17.882915
    },
    {
        town: 'Lutopecny',
        townCode: 588733,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.301479,
        long: 17.344491
    },
    {
        town: "Lu\u017Eany",
        townCode: 570354,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50305,
        lat: 50.33965,
        long: 15.819476
    },
    {
        town: "Lu\u017Eany",
        townCode: 573159,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50706,
        lat: 50.431154,
        long: 15.470396
    },
    {
        town: "Lu\u017Eany",
        townCode: 558028,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33454,
        lat: 49.546752,
        long: 13.315847
    },
    {
        town: "Lu\u017Ece",
        townCode: 534404,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.98422,
        long: 14.196827
    },
    {
        town: "Lu\u017Ee",
        townCode: 571776,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53854,
        lat: 49.893513,
        long: 16.028604
    },
    {
        town: "Lu\u017Eec nad Cidlinou",
        townCode: 570362,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50362,
        lat: 50.213644,
        long: 15.411967
    },
    {
        town: "Lu\u017Eec nad Vltavou",
        townCode: 535028,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27706,
        lat: 50.321488,
        long: 14.400326
    },
    {
        town: "Lu\u017Eeni\u010Dky",
        townCode: 553891,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.458913,
        long: 12.897685
    },
    {
        town: "Lu\u017Eice",
        townCode: 537322,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.031398,
        long: 14.205036
    },
    {
        town: "Lu\u017Eice",
        townCode: 586358,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69618,
        lat: 48.841077,
        long: 17.071145
    },
    {
        town: "Lu\u017Eice",
        townCode: 569844,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.715844,
        long: 17.259668
    },
    {
        town: "Lu\u017Eice",
        townCode: 567281,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43524,
        lat: 50.491802,
        long: 13.75425
    },
    {
        town: "Lu\u017En\xe1",
        townCode: 542041,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27051,
        lat: 50.123876,
        long: 13.770152
    },
    {
        town: "Lu\u017En\xe1",
        townCode: 544434,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.239886,
        long: 18.019755
    },
    {
        town: "Lu\u017Enice",
        townCode: 508501,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.063083,
        long: 14.756284
    },
    {
        town: "Lys\xe1 nad Labem",
        townCode: 537454,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28922,
        lat: 50.201532,
        long: 14.832919
    },
    {
        town: 'Lysice',
        townCode: 582018,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.451697,
        long: 16.537263
    },
    {
        town: 'Lysovice',
        townCode: 593281,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.21801,
        long: 16.970637
    },
    {
        town: 'Mackovice',
        townCode: 594407,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.883712,
        long: 16.309445
    },
    {
        town: "Ma\u010Dkov",
        townCode: 536466,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.40436,
        long: 13.886196
    },
    {
        town: "Mahou\u0161",
        townCode: 537381,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.047948,
        long: 14.256061
    },
    {
        town: 'Machov',
        townCode: 574210,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54963,
        lat: 50.499363,
        long: 16.277008
    },
    {
        town: "Machov\xe1",
        townCode: 585491,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76301,
        lat: 49.254401,
        long: 17.545053
    },
    {
        town: 'Majdalena',
        townCode: 546712,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37803,
        lat: 48.960809,
        long: 14.86141
    },
    {
        town: "Majet\xedn",
        townCode: 503738,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.498174,
        long: 17.333246
    },
    {
        town: "Makot\u0159asy",
        townCode: 532622,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27354,
        lat: 50.144584,
        long: 14.214806
    },
    {
        town: 'Makov',
        townCode: 582026,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67972,
        lat: 49.519247,
        long: 16.483791
    },
    {
        town: 'Makov',
        townCode: 578363,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.855103,
        long: 16.191233
    },
    {
        town: "Mal\xe1 Byst\u0159ice",
        townCode: 544469,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75627,
        lat: 49.409504,
        long: 18.04863
    },
    {
        town: "Mal\xe1 Hra\u0161tice",
        townCode: 540714,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.807609,
        long: 14.279979
    },
    {
        town: "Mal\xe1 Lhota",
        townCode: 582034,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.39199,
        long: 16.549636
    },
    {
        town: "Mal\xe1 Losenice",
        townCode: 596086,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59211,
        lat: 49.600028,
        long: 15.796704
    },
    {
        town: "Mal\xe1 Morava",
        townCode: 540331,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78833,
        lat: 50.096366,
        long: 16.826768
    },
    {
        town: "Mal\xe1 Mor\xe1vka",
        townCode: 597601,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79336,
        lat: 50.021157,
        long: 17.311666
    },
    {
        town: "Mal\xe1 Roudka",
        townCode: 582042,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67963,
        lat: 49.60178,
        long: 16.644574
    },
    {
        town: "Mal\xe1 Sk\xe1la",
        townCode: 563706,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.646408,
        long: 15.195534
    },
    {
        town: "Mal\xe1 \u0160t\xe1hle",
        townCode: 551902,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79501,
        lat: 49.9515,
        long: 17.341559
    },
    {
        town: "Mal\xe1 \xdapa",
        townCode: 579505,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54227,
        lat: 50.744947,
        long: 15.820639
    },
    {
        town: "Mal\xe1 Vele\u0148",
        townCode: 562700,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.741627,
        long: 14.270704
    },
    {
        town: "Mal\xe1 V\xedska",
        townCode: 533319,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.776121,
        long: 13.875624
    },
    {
        town: "Mal\xe1 Vrbka",
        townCode: 586366,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69673,
        lat: 48.869505,
        long: 17.459307
    },
    {
        town: "Mal\u010D\xedn",
        townCode: 569071,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.688715,
        long: 15.465269
    },
    {
        town: "Mal\xe9 B\u0159ezno",
        townCode: 567299,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.462594,
        long: 13.560308
    },
    {
        town: "Mal\xe9 B\u0159ezno",
        townCode: 568091,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.672709,
        long: 14.172366
    },
    {
        town: "Mal\xe9 Hradisko",
        townCode: 589713,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79849,
        lat: 49.493414,
        long: 16.87669
    },
    {
        town: "Mal\xe9 Ky\u0161ice",
        townCode: 532631,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.061193,
        long: 14.09042
    },
    {
        town: "Mal\xe9 P\u0159\xedto\u010Dno",
        townCode: 513113,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.107798,
        long: 14.135713
    },
    {
        town: "Mal\xe9 Svato\u0148ovice",
        townCode: 579513,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54234,
        lat: 50.534044,
        long: 16.049886
    },
    {
        town: "Mal\xe9 V\xfdkleky",
        townCode: 572802,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.119436,
        long: 15.538618
    },
    {
        town: "Mal\xe9 \u017Dernoseky",
        townCode: 565245,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.534078,
        long: 14.05484
    },
    {
        town: "Male\u010D",
        townCode: 569089,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58276,
        lat: 49.772128,
        long: 15.676917
    },
    {
        town: "Male\u010Dov",
        townCode: 568104,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40327,
        lat: 50.632028,
        long: 14.119558
    },
    {
        town: 'Malenice',
        townCode: 551384,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38706,
        lat: 49.126512,
        long: 13.882929
    },
    {
        town: 'Malenovice',
        townCode: 552593,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73911,
        lat: 49.579287,
        long: 18.398071
    },
    {
        town: "Male\u0161ov",
        townCode: 534188,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28541,
        lat: 49.911117,
        long: 15.224443
    },
    {
        town: "Male\u0161ovice",
        townCode: 583332,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66465,
        lat: 49.023694,
        long: 16.501392
    },
    {
        town: "Malet\xedn",
        townCode: 540366,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.799359,
        long: 16.78743
    },
    {
        town: 'Malhostovice',
        townCode: 583341,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66603,
        lat: 49.333699,
        long: 16.502322
    },
    {
        town: 'Malhotice',
        townCode: 515329,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.490108,
        long: 17.764264
    },
    {
        town: "Mal\xed\u010D",
        townCode: 542491,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.543636,
        long: 14.082115
    },
    {
        town: "Mal\xedkov",
        townCode: 578371,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.731136,
        long: 16.69618
    },
    {
        town: "Mal\xedkovice",
        townCode: 532657,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27377,
        lat: 50.211503,
        long: 13.982657
    },
    {
        town: "Mal\xednky",
        townCode: 593290,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.159408,
        long: 17.160321
    },
    {
        town: "Malinov\xe1",
        townCode: 565377,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.047922,
        long: 13.667032
    },
    {
        town: "M\xe1lkov",
        townCode: 534218,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26701,
        lat: 49.888313,
        long: 14.023652
    },
    {
        town: "M\xe1lkov",
        townCode: 563200,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.446278,
        long: 13.333493
    },
    {
        town: 'Malonty',
        townCode: 545619,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38291,
        lat: 48.686212,
        long: 14.576875
    },
    {
        town: 'Malotice',
        townCode: 533513,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.965299,
        long: 14.977728
    },
    {
        town: 'Malovice',
        townCode: 550418,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.091285,
        long: 14.225863
    },
    {
        town: "Mal\u0161ice",
        townCode: 552666,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39175,
        lat: 49.364014,
        long: 14.578788
    },
    {
        town: "Mal\u0161\xedn",
        townCode: 536296,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38273,
        lat: 48.678126,
        long: 14.287135
    },
    {
        town: "Mal\u0161ovice",
        townCode: 562718,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.735259,
        long: 14.169817
    },
    {
        town: "Mal\xfd Beranov",
        townCode: 587486,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58603,
        lat: 49.396595,
        long: 15.637796
    },
    {
        town: "Mal\xfd Bor",
        townCode: 556629,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.330621,
        long: 13.652357
    },
    {
        town: "Mal\xfd \xdajezd",
        townCode: 535036,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27731,
        lat: 50.33257,
        long: 14.529687
    },
    {
        town: "Man\u011Bt\xedn",
        townCode: 559202,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33162,
        lat: 49.991884,
        long: 13.233304
    },
    {
        town: 'Mankovice',
        townCode: 568589,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.637559,
        long: 17.880249
    },
    {
        town: "Ma\u0148ovice",
        townCode: 578410,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.393065,
        long: 13.653942
    },
    {
        town: "Mari\xe1nsk\xe9 L\xe1zn\u011B",
        townCode: 554642,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.964699,
        long: 12.701298
    },
    {
        town: "Mari\xe1nsk\xe9 Rad\u010Dice",
        townCode: 567302,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43532,
        lat: 50.574142,
        long: 13.665101
    },
    {
        town: 'Markvartice',
        townCode: 587494,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.178289,
        long: 15.617202
    },
    {
        town: 'Markvartice',
        townCode: 591114,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.200958,
        long: 15.767422
    },
    {
        town: 'Markvartice',
        townCode: 573167,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50742,
        lat: 50.430868,
        long: 15.196175
    },
    {
        town: 'Markvartice',
        townCode: 545678,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40742,
        lat: 50.775633,
        long: 14.355383
    },
    {
        town: 'Markvartovice',
        townCode: 508128,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74714,
        lat: 49.906049,
        long: 18.23613
    },
    {
        town: "Mar\u0161ov",
        townCode: 583359,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.28378,
        long: 16.359854
    },
    {
        town: "Mar\u0161ov u \xdapice",
        townCode: 579530,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54232,
        lat: 50.484721,
        long: 15.976044
    },
    {
        town: "Mar\u0161ovice",
        townCode: 563714,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46801,
        lat: 50.696455,
        long: 15.198577
    },
    {
        town: "Mar\u0161ovice",
        townCode: 530115,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25755,
        lat: 49.71367,
        long: 14.564615
    },
    {
        town: "Martin\u011Bves",
        townCode: 565253,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41119,
        lat: 50.372805,
        long: 14.152928
    },
    {
        town: 'Martinice',
        townCode: 596094,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.371786,
        long: 16.038309
    },
    {
        town: 'Martinice',
        townCode: 588741,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.310408,
        long: 17.601188
    },
    {
        town: "Martinice u On\u0161ova",
        townCode: 561347,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.579951,
        long: 15.115482
    },
    {
        town: "Martinice v Krkono\u0161\xedch",
        townCode: 573418,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51232,
        lat: 50.580946,
        long: 15.533412
    },
    {
        town: "Mart\xednkov",
        townCode: 550388,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67544,
        lat: 49.096759,
        long: 15.711505
    },
    {
        town: "Mart\xednkovice",
        townCode: 574228,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54973,
        lat: 50.547626,
        long: 16.342079
    },
    {
        town: "Ma\u0159enice",
        townCode: 561827,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47156,
        lat: 50.807507,
        long: 14.678659
    },
    {
        town: "M\xe1slojedy",
        townCode: 573779,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.297029,
        long: 15.75893
    },
    {
        town: "M\xe1slovice",
        townCode: 538469,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25069,
        lat: 50.208722,
        long: 14.37903
    },
    {
        town: 'Masojedy',
        townCode: 564702,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.026078,
        long: 14.777985
    },
    {
        town: "Mastn\xedk",
        townCode: 591122,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.180293,
        long: 15.827933
    },
    {
        town: "Ma\u0161ovice",
        townCode: 594415,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.857475,
        long: 15.973646
    },
    {
        town: "Ma\u0161\u0165ov",
        townCode: 563218,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43156,
        lat: 50.262382,
        long: 13.280572
    },
    {
        town: "Mat\u011Bjov",
        townCode: 596108,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.528697,
        long: 15.863108
    },
    {
        town: 'Mazelov',
        townCode: 535940,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37363,
        lat: 49.103053,
        long: 14.617886
    },
    {
        town: "Ma\u017Eice",
        townCode: 562866,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.213602,
        long: 14.612918
    },
    {
        town: 'Mcely',
        townCode: 537462,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28936,
        lat: 50.294356,
        long: 15.075984
    },
    {
        town: 'Meclov',
        townCode: 553913,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34521,
        lat: 49.505676,
        long: 12.880927
    },
    {
        town: "Me\u010De\u0159\xed\u017E",
        townCode: 565644,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29477,
        lat: 50.29048,
        long: 14.7369
    },
    {
        town: "Me\u010Dichov",
        townCode: 551392,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38736,
        lat: 49.347873,
        long: 13.812134
    },
    {
        town: "M\u011B\u010D\xedn",
        townCode: 556637,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.480195,
        long: 13.402993
    },
    {
        town: "M\u011Bd\u011Bnec",
        townCode: 563226,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43184,
        lat: 50.421723,
        long: 13.115541
    },
    {
        town: 'Medlice',
        townCode: 594423,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 49.003081,
        long: 16.121404
    },
    {
        town: 'Medlov',
        townCode: 583367,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66466,
        lat: 49.03519,
        long: 16.522482
    },
    {
        town: 'Medlov',
        townCode: 552372,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78391,
        lat: 49.787639,
        long: 17.062716
    },
    {
        town: 'Medlovice',
        townCode: 550141,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.27451,
        long: 17.093049
    },
    {
        town: 'Medlovice',
        townCode: 592366,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68741,
        lat: 49.049125,
        long: 17.27186
    },
    {
        town: 'Medonosy',
        townCode: 529575,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.494256,
        long: 14.487049
    },
    {
        town: "Medov\xfd \xdajezd",
        townCode: 579009,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.773949,
        long: 13.719185
    },
    {
        town: "M\u011Bchenice",
        townCode: 539490,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25206,
        lat: 49.908274,
        long: 14.389375
    },
    {
        town: "M\u011Bcholupy",
        townCode: 539716,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33551,
        lat: 49.519592,
        long: 13.532756
    },
    {
        town: "M\u011Bcholupy",
        townCode: 566454,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43931,
        lat: 50.26677,
        long: 13.537482
    },
    {
        town: "M\u011Bkynec",
        townCode: 536415,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.15838,
        long: 14.029485
    },
    {
        town: "Mel\u010D",
        townCode: 508144,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74784,
        lat: 49.850024,
        long: 17.757906
    },
    {
        town: "M\u011Bl\u010Dany",
        townCode: 583375,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.076242,
        long: 16.4923
    },
    {
        town: "M\u011Blnick\xe9 Vtelno",
        townCode: 535044,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27738,
        lat: 50.352413,
        long: 14.695218
    },
    {
        town: "M\u011Bln\xedk",
        townCode: 534676,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27601,
        lat: 50.354002,
        long: 14.481881
    },
    {
        town: "M\u011B\u0148any",
        townCode: 531529,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.910104,
        long: 14.117791
    },
    {
        town: 'Menhartice',
        townCode: 545031,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 48.990055,
        long: 15.552611
    },
    {
        town: "M\u011Bn\xedk",
        townCode: 570397,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50364,
        lat: 50.215505,
        long: 15.528273
    },
    {
        town: "M\u011Bn\xedn",
        townCode: 583383,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66457,
        lat: 49.082495,
        long: 16.694343
    },
    {
        town: 'Merboltice',
        townCode: 545791,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.684307,
        long: 14.339205
    },
    {
        town: "Merkl\xedn",
        townCode: 555363,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36234,
        lat: 50.32819,
        long: 12.863613
    },
    {
        town: "Merkl\xedn",
        townCode: 558044,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33452,
        lat: 49.560538,
        long: 13.198008
    },
    {
        town: "M\u011Brot\xedn",
        townCode: 568911,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78324,
        lat: 49.692571,
        long: 17.001818
    },
    {
        town: "M\u011Brovice nad Hanou",
        townCode: 552909,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75201,
        lat: 49.34167,
        long: 17.245955
    },
    {
        town: "M\u011Brunice",
        townCode: 567698,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41804,
        lat: 50.480523,
        long: 13.818088
    },
    {
        town: "M\u011B\u0159\xedn",
        townCode: 596116,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59442,
        lat: 49.393312,
        long: 15.883916
    },
    {
        town: "M\u011Bstec Kr\xe1lov\xe9",
        townCode: 537489,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28903,
        lat: 50.207281,
        long: 15.297687
    },
    {
        town: "M\u011Bste\u010Dko",
        townCode: 542067,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.050739,
        long: 13.86367
    },
    {
        town: "M\u011Bste\u010Dko Trn\xe1vka",
        townCode: 578380,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56941,
        lat: 49.709363,
        long: 16.727541
    },
    {
        town: "M\u011Bsto Albrechtice",
        townCode: 597635,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79395,
        lat: 50.163036,
        long: 17.574913
    },
    {
        town: "M\u011Bsto Libav\xe1",
        townCode: 500160,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78307,
        lat: 49.721619,
        long: 17.520135
    },
    {
        town: "M\u011Bsto Tou\u0161kov",
        townCode: 559211,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.77598,
        long: 13.251189
    },
    {
        town: "M\u011B\u0161ice",
        townCode: 538477,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25064,
        lat: 50.198097,
        long: 14.520024
    },
    {
        town: "M\u011B\u0161\xedn",
        townCode: 587508,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58601,
        lat: 49.437406,
        long: 15.657133
    },
    {
        town: "Me\u0161no",
        townCode: 579084,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.655921,
        long: 13.622053
    },
    {
        town: 'Metylovice',
        townCode: 512184,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73949,
        lat: 49.606756,
        long: 18.339222
    },
    {
        town: 'Mezholezy',
        townCode: 553921,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.411826,
        long: 13.103952
    },
    {
        town: 'Mezholezy',
        townCode: 553930,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.624867,
        long: 12.905124
    },
    {
        town: "Mezibo\u0159\xed",
        townCode: 567311,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43513,
        lat: 50.62126,
        long: 13.598813
    },
    {
        town: "Meziho\u0159\xed",
        townCode: 578461,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.488506,
        long: 13.254671
    },
    {
        town: "Mezile\u010D\xed",
        townCode: 574236,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.453464,
        long: 15.983292
    },
    {
        town: "Meziles\xed",
        townCode: 548367,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.541028,
        long: 14.949183
    },
    {
        town: "Meziles\xed",
        townCode: 574244,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54923,
        lat: 50.356207,
        long: 16.217095
    },
    {
        town: "Mezim\u011Bst\xed",
        townCode: 574252,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54981,
        lat: 50.624705,
        long: 16.242178
    },
    {
        town: 'Mezina',
        townCode: 551724,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.958602,
        long: 17.477161
    },
    {
        town: "Mezi\u0159\xed\u010D\xed",
        townCode: 563234,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.436646,
        long: 14.575126
    },
    {
        town: "Mezi\u0159\xed\u010Dko",
        townCode: 591149,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.109422,
        long: 15.660333
    },
    {
        town: "Mezi\u0159\xed\u010Dko",
        townCode: 587516,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.405486,
        long: 15.844614
    },
    {
        town: "Mezn\xe1",
        townCode: 599255,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.258242,
        long: 14.800827
    },
    {
        town: "Mezn\xe1",
        townCode: 529834,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.34713,
        long: 15.211484
    },
    {
        town: 'Mezno',
        townCode: 530158,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25786,
        lat: 49.534622,
        long: 14.64504
    },
    {
        town: "Mezou\u0148",
        townCode: 531537,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 50.004378,
        long: 14.214277
    },
    {
        town: "Mi\u010Dovice",
        townCode: 550426,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 48.983641,
        long: 14.125165
    },
    {
        town: "M\xed\u010Dov-Su\u0161ice",
        townCode: 571822,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.905062,
        long: 15.605872
    },
    {
        town: 'Michalovice',
        townCode: 548316,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.577036,
        long: 15.524426
    },
    {
        town: 'Michalovice',
        townCode: 542521,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.536682,
        long: 14.082042
    },
    {
        town: "M\xedchov",
        townCode: 582069,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.524132,
        long: 16.615857
    },
    {
        town: 'Mikolajice',
        townCode: 568279,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74784,
        lat: 49.877258,
        long: 17.793425
    },
    {
        town: "Mikul\xe1\u0161ovice",
        townCode: 562751,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40779,
        lat: 50.965179,
        long: 14.363794
    },
    {
        town: "Mikul\u010Dice",
        townCode: 586374,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69619,
        lat: 48.816526,
        long: 17.051171
    },
    {
        town: "Mikule\u010D",
        townCode: 578398,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.805919,
        long: 16.422601
    },
    {
        town: 'Mikulov',
        townCode: 584649,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69201,
        lat: 48.805383,
        long: 16.637788
    },
    {
        town: 'Mikulov',
        townCode: 567701,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41901,
        lat: 50.687713,
        long: 13.721712
    },
    {
        town: 'Mikulovice',
        townCode: 594431,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67133,
        lat: 48.956878,
        long: 16.09478
    },
    {
        town: 'Mikulovice',
        townCode: 591157,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.161765,
        long: 15.846693
    },
    {
        town: 'Mikulovice',
        townCode: 540382,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79084,
        lat: 50.298634,
        long: 17.321655
    },
    {
        town: 'Mikulovice',
        townCode: 575372,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.989526,
        long: 15.775487
    },
    {
        town: "Mikul\u016Fvka",
        townCode: 544507,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75624,
        lat: 49.413614,
        long: 17.925167
    },
    {
        town: "Milas\xedn",
        townCode: 549835,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.466338,
        long: 16.228909
    },
    {
        town: "Milav\u010De",
        townCode: 553948,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.467066,
        long: 12.980829
    },
    {
        town: "Mil\u010Dice",
        townCode: 537497,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.10547,
        long: 14.991803
    },
    {
        town: "Mile\u010D",
        townCode: 558052,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.469232,
        long: 13.605014
    },
    {
        town: 'Milejovice',
        townCode: 536539,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.188193,
        long: 13.930185
    },
    {
        town: 'Milenov',
        townCode: 515418,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75361,
        lat: 49.562684,
        long: 17.66712
    },
    {
        town: "Mile\u0161\xedn",
        townCode: 587770,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.368503,
        long: 16.201661
    },
    {
        town: "Mile\u0161ov",
        townCode: 540749,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26256,
        lat: 49.589338,
        long: 14.22151
    },
    {
        town: "Mile\u0161ovice",
        townCode: 593320,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68354,
        lat: 49.082845,
        long: 16.854355
    },
    {
        town: "Milet\xedn",
        townCode: 573175,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.403916,
        long: 15.682367
    },
    {
        town: 'Milevsko',
        townCode: 549576,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.450998,
        long: 14.360109
    },
    {
        town: 'Milhostov',
        townCode: 554651,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.156155,
        long: 12.453308
    },
    {
        town: "Mili\u010D\xedn",
        townCode: 530166,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25786,
        lat: 49.570793,
        long: 14.66151
    },
    {
        town: "Mil\xed\u010Dov",
        townCode: 587524,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.395568,
        long: 15.393119
    },
    {
        town: "Mil\xed\u010Dovice",
        townCode: 594440,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.891673,
        long: 15.932448
    },
    {
        town: "Mil\xedkov",
        townCode: 538906,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.055886,
        long: 12.547716
    },
    {
        town: "Mil\xedkov",
        townCode: 507547,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73981,
        lat: 49.585749,
        long: 18.719541
    },
    {
        town: "Mil\xedn",
        townCode: 540757,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.632028,
        long: 14.046103
    },
    {
        town: "Mil\xednov",
        townCode: 530140,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.643171,
        long: 13.566047
    },
    {
        town: "Mil\xed\u0159e",
        townCode: 541532,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.796407,
        long: 12.5507783
    },
    {
        town: 'Milonice',
        townCode: 582077,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.366571,
        long: 16.568459
    },
    {
        town: 'Milonice',
        townCode: 593338,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.15947,
        long: 17.071226
    },
    {
        town: "Milo\u0148ovice",
        townCode: 551414,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.22067,
        long: 13.958469
    },
    {
        town: "Milost\xedn",
        townCode: 542075,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.193824,
        long: 13.669209
    },
    {
        town: 'Milotice',
        townCode: 586382,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69605,
        lat: 48.955858,
        long: 17.141387
    },
    {
        town: "Milotice nad Be\u010Dvou",
        townCode: 515477,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75367,
        lat: 49.536608,
        long: 17.839864
    },
    {
        town: 'Milotice nad Opavou',
        townCode: 569526,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.995792,
        long: 17.542152
    },
    {
        town: 'Milovice',
        townCode: 584657,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69188,
        lat: 48.852588,
        long: 16.698247
    },
    {
        town: 'Milovice',
        townCode: 537501,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28924,
        lat: 50.226061,
        long: 14.888739
    },
    {
        town: "Milovice u Ho\u0159ic",
        townCode: 548863,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.329866,
        long: 15.63112
    },
    {
        town: "Mil\xfd",
        townCode: 565466,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.232771,
        long: 13.867148
    },
    {
        town: "Mimo\u0148",
        townCode: 561835,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47124,
        lat: 50.655768,
        long: 14.724956
    },
    {
        town: 'Minice',
        townCode: 562149,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.489944,
        long: 14.01224
    },
    {
        town: 'Mirkovice',
        townCode: 545627,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.811076,
        long: 14.391352
    },
    {
        town: 'Miroslav',
        townCode: 594458,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67172,
        lat: 48.94777,
        long: 16.312624
    },
    {
        town: "Miroslavsk\xe9 Kn\xednice",
        townCode: 594466,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67172,
        lat: 48.977901,
        long: 16.32241
    },
    {
        town: "Miro\u0161ov",
        townCode: 587532,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.389533,
        long: 15.463549
    },
    {
        town: "Miro\u0161ov",
        townCode: 596132,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.465697,
        long: 16.155648
    },
    {
        town: "Miro\u0161ov",
        townCode: 559997,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.68793,
        long: 13.658174
    },
    {
        town: "Miro\u0161ovice",
        townCode: 538485,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25166,
        lat: 49.909949,
        long: 14.711306
    },
    {
        town: 'Mirotice',
        townCode: 549584,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39801,
        lat: 49.429185,
        long: 14.037078
    },
    {
        town: "M\xedrov",
        townCode: 569381,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.798197,
        long: 16.84759
    },
    {
        town: "M\xedrov\xe1",
        townCode: 537934,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35735,
        lat: 50.237288,
        long: 12.770109
    },
    {
        town: "M\xedrov\xe1 pod Koz\xe1kovem",
        townCode: 577316,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.591643,
        long: 15.19435
    },
    {
        town: 'Mirovice',
        townCode: 549592,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39806,
        lat: 49.515657,
        long: 14.035924
    },
    {
        town: "Mi\u0159ejovice",
        townCode: 530506,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.553345,
        long: 14.109038
    },
    {
        town: "Mi\u0159etice",
        townCode: 571831,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53955,
        lat: 49.841358,
        long: 15.884829
    },
    {
        town: "Mi\u0159etice",
        townCode: 530174,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.659049,
        long: 14.976635
    },
    {
        town: "M\xed\u0159kov",
        townCode: 553956,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.589255,
        long: 12.881612
    },
    {
        town: 'Miskovice',
        townCode: 534200,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28501,
        lat: 49.946226,
        long: 15.204823
    },
    {
        town: "M\xedsto",
        townCode: 563242,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43158,
        lat: 50.447156,
        long: 13.26742
    },
    {
        town: 'Mistrovice',
        townCode: 580643,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56164,
        lat: 50.02377,
        long: 16.571618
    },
    {
        town: "Mist\u0159ice",
        townCode: 592382,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.086778,
        long: 17.536075
    },
    {
        town: "M\xed\u0161kovice",
        townCode: 588750,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76852,
        lat: 49.276669,
        long: 17.549103
    },
    {
        town: "M\xed\u0161ov",
        townCode: 546399,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33563,
        lat: 49.622664,
        long: 13.725854
    },
    {
        town: "Mi\u0161ovice",
        townCode: 549606,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.495358,
        long: 14.005039
    },
    {
        town: "Mlad\xe1 Boleslav",
        townCode: 535419,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.413525,
        long: 14.908538
    },
    {
        town: "Mlad\xe1 Vo\u017Eice",
        townCode: 552704,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.53323,
        long: 14.808669
    },
    {
        town: "Mlad\xe9 B\u0159\xed\u0161t\u011B",
        townCode: 548383,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39443,
        lat: 49.491565,
        long: 15.335272
    },
    {
        town: "Mlad\xe9 Buky",
        townCode: 579548,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54223,
        lat: 50.606524,
        long: 15.833588
    },
    {
        town: 'Mladecko',
        townCode: 553042,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74754,
        lat: 49.898335,
        long: 17.708278
    },
    {
        town: "Mlade\u010D",
        townCode: 504246,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78321,
        lat: 49.705924,
        long: 17.01963
    },
    {
        town: "Mlad\u011Bjov",
        townCode: 573205,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50745,
        lat: 50.482181,
        long: 15.232724
    },
    {
        town: "Mlad\u011Bjov na Morav\u011B",
        townCode: 578401,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56935,
        lat: 49.822707,
        long: 16.591176
    },
    {
        town: "Mlad\u011Bjovice",
        townCode: 552348,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.752475,
        long: 17.23154
    },
    {
        town: 'Mladkov',
        townCode: 580651,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56167,
        lat: 50.096953,
        long: 16.627025
    },
    {
        town: "Mlado\u0148ovice",
        townCode: 591165,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 49.010221,
        long: 15.64373
    },
    {
        town: "Mlado\u0148ovice",
        townCode: 571857,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.887468,
        long: 15.724015
    },
    {
        town: "Mlado\u0161ovice",
        townCode: 544817,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 48.940569,
        long: 14.69925
    },
    {
        town: 'Mladotice',
        townCode: 559237,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.985347,
        long: 13.364505
    },
    {
        town: "Mlad\xfd Smolivec",
        townCode: 558061,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.506411,
        long: 13.735393
    },
    {
        town: "Ml\xe1zovice",
        townCode: 573213,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50758,
        lat: 50.411963,
        long: 15.521712
    },
    {
        town: "Mle\u010Dice",
        townCode: 560006,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.920399,
        long: 13.696075
    },
    {
        town: "Ml\xe9kojedy",
        townCode: 565296,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.526999,
        long: 14.11933
    },
    {
        town: "Ml\xe9kosrby",
        townCode: 570401,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.191824,
        long: 15.501571
    },
    {
        town: "Ml\xfdnsk\xe9 Struhadlo",
        townCode: 542059,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.432149,
        long: 13.469571
    },
    {
        town: "Ml\xfdny",
        townCode: 552712,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.336335,
        long: 14.877147
    },
    {
        town: "Mnet\u011B\u0161",
        townCode: 565300,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.36565,
        long: 14.281839
    },
    {
        town: 'Mnich',
        townCode: 548391,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39492,
        lat: 49.298466,
        long: 14.965835
    },
    {
        town: 'Mnichov',
        townCode: 536563,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.302187,
        long: 13.830176
    },
    {
        town: 'Mnichov',
        townCode: 554677,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 50.03698,
        long: 12.787043
    },
    {
        town: 'Mnichov',
        townCode: 566292,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.49683,
        long: 12.764531
    },
    {
        town: 'Mnichovice',
        townCode: 530191,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.668707,
        long: 15.039688
    },
    {
        town: 'Mnichovice',
        townCode: 538493,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25164,
        lat: 49.936117,
        long: 14.709175
    },
    {
        town: "Mnichovo Hradi\u0161t\u011B",
        townCode: 536326,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.527029,
        long: 14.972104
    },
    {
        town: "Mn\xed\u0161ek",
        townCode: 564231,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46331,
        lat: 50.831733,
        long: 15.056405
    },
    {
        town: "Mn\xed\u0161ek pod Brdy",
        townCode: 540765,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.866601,
        long: 14.261865
    },
    {
        town: "Mo\u010Derady",
        townCode: 599174,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.518078,
        long: 13.073554
    },
    {
        town: "Mo\u010Dovice",
        townCode: 530999,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.906414,
        long: 15.348298
    },
    {
        town: 'Modlany',
        townCode: 567710,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41713,
        lat: 50.650606,
        long: 13.895449
    },
    {
        town: 'Modletice',
        townCode: 598267,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.97026,
        long: 14.591186
    },
    {
        town: "Modl\xedkov",
        townCode: 569127,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.608287,
        long: 15.770401
    },
    {
        town: "Modr\xe1",
        townCode: 592391,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68706,
        lat: 49.112121,
        long: 17.403508
    },
    {
        town: "Modr\xe1 H\u016Frka",
        townCode: 598615,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.180142,
        long: 14.525766
    },
    {
        town: 'Modrava',
        townCode: 542148,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34192,
        lat: 49.024173,
        long: 13.499417
    },
    {
        town: "Mod\u0159ice",
        townCode: 583391,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66442,
        lat: 49.12799,
        long: 16.614517
    },
    {
        town: "Mod\u0159i\u0161ice",
        townCode: 577324,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.574176,
        long: 15.119437
    },
    {
        town: "Mod\u0159ovice",
        townCode: 599751,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.617462,
        long: 13.956485
    },
    {
        town: 'Mohelnice',
        townCode: 540471,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78985,
        lat: 49.777082,
        long: 16.919567
    },
    {
        town: 'Mohelnice',
        townCode: 558079,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.48089,
        long: 13.641798
    },
    {
        town: 'Mohelnice nad Jizerou',
        townCode: 565822,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29413,
        lat: 50.559891,
        long: 14.977625
    },
    {
        town: 'Mohelno',
        townCode: 591173,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67575,
        lat: 49.114222,
        long: 16.190323
    },
    {
        town: 'Mochov',
        townCode: 538507,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25087,
        lat: 50.141925,
        long: 14.795066
    },
    {
        town: "Mocht\xedn",
        townCode: 556718,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.360477,
        long: 13.357005
    },
    {
        town: "Mojn\xe9",
        townCode: 598623,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.834818,
        long: 14.407373
    },
    {
        town: "Moko\u0161\xedn",
        townCode: 575381,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.014912,
        long: 15.572047
    },
    {
        town: "Mokr\xe1-Hor\xe1kov",
        townCode: 583405,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66404,
        lat: 49.22287,
        long: 16.751677
    },
    {
        town: "Mokr\xe9",
        townCode: 576522,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.259297,
        long: 16.066529
    },
    {
        town: "Mokr\xe9 Lazce",
        townCode: 508373,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74762,
        lat: 49.904714,
        long: 18.029644
    },
    {
        town: 'Mokrosuky',
        townCode: 556726,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.275464,
        long: 13.454904
    },
    {
        town: "Mokrou\u0161e",
        townCode: 540641,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33201,
        lat: 49.715159,
        long: 13.524657
    },
    {
        town: 'Mokrovousy',
        townCode: 570419,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.27513,
        long: 15.68594
    },
    {
        town: 'Mokrovraty',
        townCode: 540781,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.795772,
        long: 14.25023
    },
    {
        town: "Mokr\xfd Lom",
        townCode: 535842,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.844884,
        long: 14.514153
    },
    {
        town: 'Moldava',
        townCode: 567728,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41781,
        lat: 50.720738,
        long: 13.657342
    },
    {
        town: "Mora\u0161ice",
        townCode: 594474,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67171,
        lat: 48.957631,
        long: 16.209004
    },
    {
        town: "Mora\u0161ice",
        townCode: 571873,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53802,
        lat: 49.934791,
        long: 15.709072
    },
    {
        town: "Mora\u0161ice",
        townCode: 573035,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.001981,
        long: 15.486111
    },
    {
        town: "Mora\u0161ice",
        townCode: 578428,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56951,
        lat: 49.867799,
        long: 16.233701
    },
    {
        town: 'Moravany',
        townCode: 583413,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66448,
        lat: 49.14566,
        long: 16.576269
    },
    {
        town: 'Moravany',
        townCode: 586391,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69650,
        lat: 49.040216,
        long: 17.169127
    },
    {
        town: 'Moravany',
        townCode: 575399,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53372,
        lat: 50.00105,
        long: 15.940811
    },
    {
        town: 'Moravec',
        townCode: 596141,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59254,
        lat: 49.440204,
        long: 16.143415
    },
    {
        town: "Moraveck\xe9 Pavlovice",
        townCode: 596159,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59262,
        lat: 49.425534,
        long: 16.256425
    },
    {
        town: "Morave\u010D",
        townCode: 548405,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.409182,
        long: 15.076977
    },
    {
        town: 'Moravice',
        townCode: 569097,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74784,
        lat: 49.857852,
        long: 17.720204
    },
    {
        town: "Moravi\u010Dany",
        townCode: 540480,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78982,
        lat: 49.757034,
        long: 16.960527
    },
    {
        town: "Mor\xe1vka",
        townCode: 598445,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73904,
        lat: 49.596169,
        long: 18.524824
    },
    {
        town: "Moravsk\xe1 Nov\xe1 Ves",
        townCode: 584665,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69155,
        lat: 48.803142,
        long: 17.013814
    },
    {
        town: "Moravsk\xe1 T\u0159ebov\xe1",
        townCode: 578444,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.757697,
        long: 16.663631
    },
    {
        town: "Moravsk\xe9 Br\xe1nice",
        townCode: 583421,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.083374,
        long: 16.436388
    },
    {
        town: "Moravsk\xe9 Bud\u011Bjovice",
        townCode: 591181,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67602,
        lat: 49.05219,
        long: 15.808746
    },
    {
        town: "Moravsk\xe9 Kn\xednice",
        townCode: 583430,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66434,
        lat: 49.293382,
        long: 16.50184
    },
    {
        town: "Moravsk\xe9 M\xe1lkovice",
        townCode: 593346,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.257021,
        long: 17.090766
    },
    {
        town: "Moravskoslezsk\xfd Ko\u010Dov",
        townCode: 551732,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.960503,
        long: 17.441174
    },
    {
        town: "Moravsk\xfd Beroun",
        townCode: 597678,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79305,
        lat: 49.79384,
        long: 17.442222
    },
    {
        town: "Moravsk\xfd Krumlov",
        townCode: 594482,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.049031,
        long: 16.311798
    },
    {
        town: "Moravsk\xfd P\xedsek",
        townCode: 586404,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69685,
        lat: 48.990264,
        long: 17.332795
    },
    {
        town: "Moravsk\xfd \u017Di\u017Ekov",
        townCode: 584673,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69101,
        lat: 48.832952,
        long: 16.931502
    },
    {
        town: "Morkovice-Sl\xed\u017Eany",
        townCode: 588768,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.249941,
        long: 17.209733
    },
    {
        town: "Mork\u016Fvky",
        townCode: 584681,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69172,
        lat: 48.966228,
        long: 16.862319
    },
    {
        town: "Mo\u0159ice",
        townCode: 589721,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79828,
        lat: 49.330574,
        long: 17.196995
    },
    {
        town: "Mo\u0159ina",
        townCode: 531545,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26717,
        lat: 49.95294,
        long: 14.20874
    },
    {
        town: "Mo\u0159inka",
        townCode: 533912,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.939081,
        long: 14.237277
    },
    {
        town: "Mo\u0159kov",
        townCode: 599689,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74272,
        lat: 49.536937,
        long: 18.059792
    },
    {
        town: 'Most',
        townCode: 567027,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.501655,
        long: 13.633012
    },
    {
        town: 'Mostek',
        townCode: 579556,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54475,
        lat: 50.486326,
        long: 15.696323
    },
    {
        town: 'Mostek',
        townCode: 580660,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.009486,
        long: 16.265146
    },
    {
        town: 'Mostkovice',
        townCode: 589730,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79802,
        lat: 49.472246,
        long: 17.052223
    },
    {
        town: 'Mosty u Jablunkova',
        townCode: 598453,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73998,
        lat: 49.527472,
        long: 18.754281
    },
    {
        town: "Mo\u0161nov",
        townCode: 568686,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74251,
        lat: 49.689142,
        long: 18.132574
    },
    {
        town: 'Mouchnice',
        townCode: 593354,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.111822,
        long: 17.135627
    },
    {
        town: "Mou\u0159\xednov",
        townCode: 557048,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.121563,
        long: 16.978594
    },
    {
        town: 'Moutnice',
        townCode: 583448,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66455,
        lat: 49.049337,
        long: 16.73752
    },
    {
        town: "Mra\u010D",
        townCode: 530204,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25721,
        lat: 49.829754,
        long: 14.690616
    },
    {
        town: "Mr\xe1kot\xedn",
        townCode: 587541,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58854,
        lat: 49.189556,
        long: 15.376196
    },
    {
        town: "Mr\xe1kot\xedn",
        townCode: 554847,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.814666,
        long: 15.95683
    },
    {
        town: "Mr\xe1kov",
        townCode: 553981,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34501,
        lat: 49.403252,
        long: 12.951311
    },
    {
        town: "Mrat\xedn",
        townCode: 538515,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.203151,
        long: 14.551084
    },
    {
        town: "Mrl\xednek",
        townCode: 553905,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.428534,
        long: 17.678364
    },
    {
        town: 'Mrsklesy',
        townCode: 554944,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78365,
        lat: 49.602712,
        long: 17.401657
    },
    {
        town: "Mrtn\xedk",
        townCode: 559245,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.895538,
        long: 13.312306
    },
    {
        town: 'Mrzky',
        townCode: 513288,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.044722,
        long: 14.810127
    },
    {
        town: "M\u0159\xed\u010Dn\xe1",
        townCode: 577332,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51204,
        lat: 50.600813,
        long: 15.468897
    },
    {
        town: "M\u0161ec",
        townCode: 542105,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27064,
        lat: 50.205291,
        long: 13.898432
    },
    {
        town: "M\u0161eck\xe9 \u017Dehrovice",
        townCode: 542113,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27064,
        lat: 50.179113,
        long: 13.923232
    },
    {
        town: "M\u0161en\xe9-l\xe1zn\u011B",
        townCode: 565318,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41119,
        lat: 50.362321,
        long: 14.127166
    },
    {
        town: "M\u0161eno",
        townCode: 535052,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27735,
        lat: 50.438194,
        long: 14.632611
    },
    {
        town: "Muka\u0159ov",
        townCode: 571865,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.56925,
        long: 14.925793
    },
    {
        town: "Muka\u0159ov",
        townCode: 538523,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25162,
        lat: 49.991254,
        long: 14.741654
    },
    {
        town: "Mut\u011Bjovice",
        townCode: 542121,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27007,
        lat: 50.194353,
        long: 13.709619
    },
    {
        town: "Mut\u011Bnice",
        townCode: 560278,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.23981,
        long: 13.89664
    },
    {
        town: "Mut\u011Bnice",
        townCode: 586412,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69611,
        lat: 48.904228,
        long: 17.02928
    },
    {
        town: "Mut\u011Bn\xedn",
        townCode: 553999,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34525,
        lat: 49.544857,
        long: 12.74467
    },
    {
        town: 'Mutkov',
        townCode: 547093,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79351,
        lat: 49.801996,
        long: 17.284841
    },
    {
        town: 'Mydlovary',
        townCode: 535281,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37349,
        lat: 49.091233,
        long: 14.35445
    },
    {
        town: 'Myslejovice',
        townCode: 589748,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79805,
        lat: 49.406547,
        long: 17.027659
    },
    {
        town: 'Mysletice',
        townCode: 587559,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.142671,
        long: 15.389524
    },
    {
        town: "Myslet\xedn",
        townCode: 561819,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.476693,
        long: 15.368309
    },
    {
        town: "Myslibo\u0159",
        townCode: 587567,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.209518,
        long: 15.484514
    },
    {
        town: "Myslibo\u0159ice",
        townCode: 591190,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67560,
        lat: 49.102992,
        long: 15.98466
    },
    {
        town: "Mysl\xedn",
        townCode: 549614,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.532189,
        long: 14.02744
    },
    {
        town: 'Myslinka',
        townCode: 566543,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.748125,
        long: 13.219142
    },
    {
        town: "Mysl\xedv",
        townCode: 556734,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.414314,
        long: 13.572532
    },
    {
        town: 'Myslkovice',
        townCode: 552721,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39116,
        lat: 49.299224,
        long: 14.7457
    },
    {
        town: "Myslo\u010Dovice",
        townCode: 585505,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76301,
        lat: 49.256096,
        long: 17.566252
    },
    {
        town: 'Myslovice',
        townCode: 541745,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.406902,
        long: 13.387145
    },
    {
        town: "My\u0161t\u011Bves",
        townCode: 570427,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.297719,
        long: 15.557476
    },
    {
        town: "My\u0161tice",
        townCode: 551473,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.453257,
        long: 13.97019
    },
    {
        town: "M\xfdto",
        townCode: 560014,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33805,
        lat: 49.789152,
        long: 13.734722
    },
    {
        town: "M\u017Eany",
        townCode: 570435,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.296508,
        long: 15.675954
    },
    {
        town: "Nabo\u010Dany",
        townCode: 571890,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.94387,
        long: 15.886976
    },
    {
        town: "Na\u010Deradec",
        townCode: 530212,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25708,
        lat: 49.610286,
        long: 14.906434
    },
    {
        town: "Na\u010De\u0161ice",
        townCode: 571903,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.941391,
        long: 15.628949
    },
    {
        town: "Nad\u011Bjkov",
        townCode: 549631,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39852,
        lat: 49.502815,
        long: 14.479339
    },
    {
        town: "Nad\u011Bjov",
        townCode: 587575,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.422331,
        long: 15.773162
    },
    {
        town: 'Nadryby',
        townCode: 559253,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.820798,
        long: 13.524572
    },
    {
        town: "Naho\u0159any",
        townCode: 574261,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54907,
        lat: 50.351812,
        long: 16.082511
    },
    {
        town: "Naho\u0161ovice",
        townCode: 552810,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.437824,
        long: 17.57822
    },
    {
        town: "N\xe1chod",
        townCode: 573868,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54701,
        lat: 50.414672,
        long: 16.165735
    },
    {
        town: "N\xe1klo",
        townCode: 504441,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78332,
        lat: 49.654721,
        long: 17.129794
    },
    {
        town: "N\xe1k\u0159\xed",
        townCode: 535371,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37348,
        lat: 49.118968,
        long: 14.329443
    },
    {
        town: "Nalou\u010Dany",
        townCode: 550779,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.233146,
        long: 16.135313
    },
    {
        town: "Nal\u017Eovice",
        townCode: 540790,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26293,
        lat: 49.69869,
        long: 14.370852
    },
    {
        town: "Nal\u017Eovsk\xe9 Hory",
        townCode: 556751,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.331486,
        long: 13.546557
    },
    {
        town: "N\xe1m\u011B\u0161\u0165 na Han\xe9",
        townCode: 504505,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78344,
        lat: 49.602226,
        long: 17.065499
    },
    {
        town: "N\xe1m\u011B\u0161\u0165 nad Oslavou",
        townCode: 591211,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.205556,
        long: 16.155845
    },
    {
        town: 'Napajedla',
        townCode: 585513,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76361,
        lat: 49.171658,
        long: 17.512053
    },
    {
        town: "N\xe1rame\u010D",
        townCode: 591220,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.264513,
        long: 15.974825
    },
    {
        town: 'Narysov',
        townCode: 564478,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.640955,
        long: 13.970987
    },
    {
        town: 'Nasavrky',
        townCode: 559016,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.452054,
        long: 14.640664
    },
    {
        town: 'Nasavrky',
        townCode: 571911,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53825,
        lat: 49.844597,
        long: 15.804712
    },
    {
        town: 'Nasavrky',
        townCode: 580678,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.025583,
        long: 16.259185
    },
    {
        town: "N\xe1sedlovice",
        townCode: 586421,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69636,
        lat: 49.012277,
        long: 16.960303
    },
    {
        town: "Na\u0161im\u011B\u0159ice",
        townCode: 594512,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67176,
        lat: 48.968632,
        long: 16.372859
    },
    {
        town: "N\xe1vojn\xe1",
        townCode: 585521,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76332,
        lat: 49.108405,
        long: 18.053057
    },
    {
        town: "N\xe1vs\xed",
        townCode: 554014,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73992,
        lat: 49.5873,
        long: 18.759182
    },
    {
        town: 'Nebahovy',
        townCode: 550434,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38401,
        lat: 49.005858,
        long: 14.052436
    },
    {
        town: 'Nebanice',
        townCode: 554693,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.115352,
        long: 12.472085
    },
    {
        town: "Neb\xedlovy",
        townCode: 540340,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.630199,
        long: 13.429246
    },
    {
        town: 'Nebovidy',
        townCode: 583456,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66448,
        lat: 49.141432,
        long: 16.551476
    },
    {
        town: 'Nebovidy',
        townCode: 533521,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.991627,
        long: 15.219584
    },
    {
        town: "Neb\u0159ehovice",
        townCode: 536644,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.238537,
        long: 13.962118
    },
    {
        town: "Nebu\u017Eely",
        townCode: 535061,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27734,
        lat: 50.390406,
        long: 14.5909
    },
    {
        town: "Ne\u010D\xedn",
        townCode: 540811,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26213,
        lat: 49.698546,
        long: 14.23414
    },
    {
        town: "Ne\u010Dtiny",
        townCode: 559261,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33162,
        lat: 49.974944,
        long: 13.164739
    },
    {
        town: 'Nedabyle',
        townCode: 544825,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37006,
        lat: 48.928509,
        long: 14.515037
    },
    {
        town: 'Nedachlebice',
        townCode: 592404,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.099385,
        long: 17.589225
    },
    {
        town: 'Nedakonice',
        townCode: 592412,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68738,
        lat: 49.031694,
        long: 17.38152
    },
    {
        town: "Neda\u0161ov",
        townCode: 585530,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76332,
        lat: 49.107884,
        long: 18.070468
    },
    {
        town: "Neda\u0161ova Lhota",
        townCode: 585548,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76332,
        lat: 49.121404,
        long: 18.079714
    },
    {
        town: "Ned\u011Bli\u0161t\u011B",
        townCode: 570443,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50312,
        lat: 50.27676,
        long: 15.78561
    },
    {
        town: 'Nedomice',
        townCode: 531863,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.259765,
        long: 14.616064
    },
    {
        town: 'Nedrahovice',
        townCode: 540820,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.609069,
        long: 14.455837
    },
    {
        town: "Nedv\u011Bdice",
        townCode: 596175,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59262,
        lat: 49.457116,
        long: 16.334163
    },
    {
        town: "Nedv\u011Bz\xed",
        townCode: 578452,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56992,
        lat: 49.630695,
        long: 16.301003
    },
    {
        town: 'Nehodiv',
        townCode: 578223,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.410858,
        long: 13.556463
    },
    {
        town: 'Nehvizdy',
        townCode: 538540,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25081,
        lat: 50.130663,
        long: 14.730041
    },
    {
        town: 'Nechanice',
        townCode: 570451,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.237468,
        long: 15.632865
    },
    {
        town: 'Nechvalice',
        townCode: 540846,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.576649,
        long: 14.396667
    },
    {
        town: "Nechval\xedn",
        townCode: 586439,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69631,
        lat: 49.054642,
        long: 17.080689
    },
    {
        town: 'Nejdek',
        townCode: 555380,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36221,
        lat: 50.322529,
        long: 12.729474
    },
    {
        town: "Nejep\xedn",
        townCode: 548197,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.744607,
        long: 15.600679
    },
    {
        town: "Nekm\xed\u0159",
        townCode: 559270,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33152,
        lat: 49.858193,
        long: 13.263246
    },
    {
        town: "Neko\u0159",
        townCode: 580686,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56163,
        lat: 50.055817,
        long: 16.551297
    },
    {
        town: 'Nekvasovy',
        townCode: 558095,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33547,
        lat: 49.434661,
        long: 13.62585
    },
    {
        town: 'Nelahozeves',
        townCode: 535079,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27751,
        lat: 50.261583,
        long: 14.298919
    },
    {
        town: "Nelepe\u010D-\u017Dern\u016Fvka",
        townCode: 583464,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.334089,
        long: 16.386382
    },
    {
        town: "Nele\u0161ovice",
        townCode: 515787,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75103,
        lat: 49.510794,
        long: 17.388256
    },
    {
        town: 'Nemanice',
        townCode: 554006,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.436663,
        long: 12.720642
    },
    {
        town: "N\u011Bm\u010Dany",
        townCode: 593371,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.164452,
        long: 16.919514
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 550396,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.031903,
        long: 14.271361
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 536474,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.192799,
        long: 13.800188
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 582085,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67951,
        lat: 49.450065,
        long: 16.718057
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 572870,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.093029,
        long: 15.805868
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 580694,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56118,
        lat: 49.890679,
        long: 16.343315
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 599166,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.425183,
        long: 13.077609
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 571636,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.084482,
        long: 15.294147
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 536334,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29442,
        lat: 50.346866,
        long: 14.926664
    },
    {
        town: "N\u011Bm\u010Dice",
        townCode: 588784,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76843,
        lat: 49.364766,
        long: 17.497843
    },
    {
        town: "N\u011Bm\u010Dice nad Hanou",
        townCode: 589756,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79827,
        lat: 49.341914,
        long: 17.206072
    },
    {
        town: "N\u011Bm\u010Di\u010Dky",
        townCode: 583472,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66466,
        lat: 49.050477,
        long: 16.5007
    },
    {
        town: "N\u011Bm\u010Di\u010Dky",
        townCode: 584703,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69107,
        lat: 48.93569,
        long: 16.824364
    },
    {
        town: "N\u011Bm\u010Di\u010Dky",
        townCode: 594521,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.942345,
        long: 16.088509
    },
    {
        town: "N\u011Bm\u010Dovice",
        townCode: 566837,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.877038,
        long: 13.574993
    },
    {
        town: "N\u011Bm\u011Btice",
        townCode: 536725,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.194724,
        long: 13.879078
    },
    {
        town: 'Nemile',
        townCode: 553476,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.874866,
        long: 16.847553
    },
    {
        town: 'Nemochovice',
        townCode: 593389,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.18054,
        long: 17.135056
    },
    {
        town: 'Nemojany',
        townCode: 593397,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68303,
        lat: 49.246812,
        long: 16.913617
    },
    {
        town: 'Nemojov',
        townCode: 579564,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54461,
        lat: 50.467018,
        long: 15.753975
    },
    {
        town: 'Nemotice',
        townCode: 593401,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.129699,
        long: 17.124981
    },
    {
        town: "Nemy\u010Deves",
        townCode: 573230,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.384534,
        long: 15.370126
    },
    {
        town: 'Nemyslovice',
        townCode: 571156,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29429,
        lat: 50.358549,
        long: 14.76393
    },
    {
        town: "Nemy\u0161l",
        townCode: 552747,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.513482,
        long: 14.693011
    },
    {
        town: "Nena\u010Dovice",
        townCode: 533602,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 50.019222,
        long: 14.139071
    },
    {
        town: 'Nenkovice',
        townCode: 586447,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69637,
        lat: 49.003151,
        long: 17.01104
    },
    {
        town: 'Neplachov',
        townCode: 535435,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37365,
        lat: 49.130401,
        long: 14.601091
    },
    {
        town: 'Neplachovice',
        townCode: 553158,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74774,
        lat: 49.992379,
        long: 17.809969
    },
    {
        town: 'Nepolisy',
        townCode: 570478,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50363,
        lat: 50.192306,
        long: 15.463452
    },
    {
        town: "Nepom\u011B\u0159ice",
        townCode: 534226,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28511,
        lat: 49.880863,
        long: 15.148908
    },
    {
        town: 'Nepomuk',
        townCode: 558109,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.48627,
        long: 13.582361
    },
    {
        town: 'Nepomuk',
        townCode: 564524,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.642895,
        long: 13.837368
    },
    {
        town: "Nepomy\u0161l",
        townCode: 566501,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43971,
        lat: 50.218181,
        long: 13.313325
    },
    {
        town: 'Neprobylice',
        townCode: 571521,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27375,
        lat: 50.264054,
        long: 14.027719
    },
    {
        town: "Nep\u0159ev\xe1zka",
        townCode: 536351,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.378415,
        long: 14.916429
    },
    {
        town: 'Neratov',
        townCode: 573078,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.079868,
        long: 15.647275
    },
    {
        town: 'Neratovice',
        townCode: 535087,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27711,
        lat: 50.259361,
        long: 14.517703
    },
    {
        town: 'Nerestce',
        townCode: 562157,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.50082,
        long: 14.063758
    },
    {
        town: 'Neslovice',
        townCode: 583481,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.142313,
        long: 16.387883
    },
    {
        town: 'Nesovice',
        townCode: 593419,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.151205,
        long: 17.081054
    },
    {
        town: 'Nespeky',
        townCode: 530263,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25722,
        lat: 49.859411,
        long: 14.659464
    },
    {
        town: "Nestra\u0161ovice",
        townCode: 564222,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.560455,
        long: 14.026157
    },
    {
        town: "Nesuchyn\u011B",
        townCode: 542130,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27007,
        lat: 50.179666,
        long: 13.688009
    },
    {
        town: "Nesva\u010Dilka",
        townCode: 583499,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66454,
        lat: 49.064124,
        long: 16.754104
    },
    {
        town: "Nesva\u010Dily",
        townCode: 534269,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.881363,
        long: 14.124461
    },
    {
        town: "Net\xedn",
        townCode: 596183,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.413112,
        long: 15.950806
    },
    {
        town: 'Netolice',
        townCode: 550442,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.049406,
        long: 14.197098
    },
    {
        town: "Net\u0159ebice",
        townCode: 545643,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.790887,
        long: 14.455665
    },
    {
        town: "Net\u0159ebice",
        townCode: 534919,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.213205,
        long: 15.142899
    },
    {
        town: 'Netunice',
        townCode: 558117,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.616473,
        long: 13.430689
    },
    {
        town: "Netvo\u0159ice",
        townCode: 530298,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25744,
        lat: 49.815795,
        long: 14.518381
    },
    {
        town: 'Neubuz',
        townCode: 585556,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.260516,
        long: 17.825454
    },
    {
        town: "Neum\u011B\u0159",
        townCode: 554022,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.597691,
        long: 13.064248
    },
    {
        town: "Neum\u011B\u0159ice",
        townCode: 532665,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27326,
        lat: 50.241781,
        long: 14.220097
    },
    {
        town: "Neum\u011Btely",
        townCode: 531588,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.852562,
        long: 14.036716
    },
    {
        town: 'Neurazy',
        townCode: 558125,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33555,
        lat: 49.441098,
        long: 13.515683
    },
    {
        town: 'Neustupov',
        townCode: 530301,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25786,
        lat: 49.615106,
        long: 14.698704
    },
    {
        town: 'Nevcehle',
        townCode: 587583,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.225836,
        long: 15.534527
    },
    {
        town: 'Neveklov',
        townCode: 530310,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25756,
        lat: 49.753835,
        long: 14.533011
    },
    {
        town: 'Neveklovice',
        townCode: 571997,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29413,
        lat: 50.570239,
        long: 14.948481
    },
    {
        town: "Nev\u011Bzice",
        townCode: 549657,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.477833,
        long: 14.153463
    },
    {
        town: 'Nevid',
        townCode: 541192,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.685555,
        long: 13.605743
    },
    {
        town: 'Nevojice',
        townCode: 593427,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.135416,
        long: 17.049752
    },
    {
        town: 'Nevolice',
        townCode: 554031,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.420508,
        long: 12.933341
    },
    {
        town: 'Nevratice',
        townCode: 549207,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.347043,
        long: 15.493052
    },
    {
        town: "Nev\u0159e\u0148",
        townCode: 559288,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.822935,
        long: 13.274982
    },
    {
        town: 'Nezabudice',
        townCode: 598585,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.013274,
        long: 13.822228
    },
    {
        town: 'Nezabylice',
        townCode: 546160,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.424293,
        long: 13.478643
    },
    {
        town: 'Nezamyslice',
        townCode: 589764,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79826,
        lat: 49.325526,
        long: 17.173366
    },
    {
        town: 'Nezamyslice',
        townCode: 578533,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.262507,
        long: 13.675029
    },
    {
        town: "Nezbav\u011Btice",
        townCode: 553590,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.655024,
        long: 13.477167
    },
    {
        town: 'Nezdenice',
        townCode: 592421,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68732,
        lat: 49.016782,
        long: 17.752313
    },
    {
        town: 'Nezdice',
        townCode: 542296,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.531654,
        long: 13.316677
    },
    {
        town: "Nezdice na \u0160umav\u011B",
        townCode: 556815,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.172674,
        long: 13.612383
    },
    {
        town: "Nezd\u0159ev",
        townCode: 540102,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33544,
        lat: 49.426677,
        long: 13.728163
    },
    {
        town: "Nezv\u011Bstice",
        townCode: 558141,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.640535,
        long: 13.519727
    },
    {
        town: 'Nicov',
        townCode: 529893,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38473,
        lat: 49.125538,
        long: 13.620561
    },
    {
        town: "Niho\u0161ovice",
        townCode: 551520,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.188367,
        long: 13.861812
    },
    {
        town: "N\xedhov",
        townCode: 596191,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.341792,
        long: 16.257645
    },
    {
        town: "Nikol\u010Dice",
        townCode: 584711,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69171,
        lat: 48.993283,
        long: 16.754291
    },
    {
        town: "Nim\u011B\u0159ice",
        townCode: 571121,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29430,
        lat: 50.39588,
        long: 14.808547
    },
    {
        town: "Nimp\u0161ov",
        townCode: 591238,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67541,
        lat: 49.022725,
        long: 15.747338
    },
    {
        town: "Ni\u0161ovice",
        townCode: 536962,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.15533,
        long: 13.897452
    },
    {
        town: "N\xedtkovice",
        townCode: 588806,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76813,
        lat: 49.203726,
        long: 17.166004
    },
    {
        town: 'Niva',
        townCode: 589772,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79861,
        lat: 49.445315,
        long: 16.851911
    },
    {
        town: 'Nivnice',
        townCode: 592439,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68751,
        lat: 48.974744,
        long: 17.647683
    },
    {
        town: "Ni\u017Ebor",
        townCode: 531596,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26705,
        lat: 49.999065,
        long: 14.001056
    },
    {
        town: "N\xed\u017Ekov",
        townCode: 596205,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.532665,
        long: 15.805946
    },
    {
        town: "N\xed\u017Ekovice",
        townCode: 593435,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.109637,
        long: 16.901793
    },
    {
        town: "Ni\u017En\xed Lhoty",
        townCode: 552526,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.648584,
        long: 18.433859
    },
    {
        town: "Norber\u010Dany",
        townCode: 597686,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79305,
        lat: 49.754048,
        long: 17.506344
    },
    {
        town: "Nos\xe1lov",
        townCode: 531707,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27735,
        lat: 50.473589,
        long: 14.670766
    },
    {
        town: 'Nosislav',
        townCode: 584720,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69164,
        lat: 49.013902,
        long: 16.654416
    },
    {
        town: "No\u0161ovice",
        townCode: 552518,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.660825,
        long: 18.426436
    },
    {
        town: "Nov\xe1 Bukov\xe1",
        townCode: 561177,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.346075,
        long: 15.297103
    },
    {
        town: "Nov\xe1 Byst\u0159ice",
        townCode: 546798,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37833,
        lat: 49.019361,
        long: 15.103258
    },
    {
        town: "Nov\xe1 Cerekev",
        townCode: 548456,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39415,
        lat: 49.417337,
        long: 15.116849
    },
    {
        town: "Nov\xe1 D\u011Bdina",
        townCode: 588814,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.210212,
        long: 17.453821
    },
    {
        town: "Nov\xe1 Hrade\u010Dn\xe1",
        townCode: 552381,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78383,
        lat: 49.834478,
        long: 17.077461
    },
    {
        town: "Nov\xe1 Lhota",
        townCode: 586455,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69674,
        lat: 48.861047,
        long: 17.593418
    },
    {
        town: "Nov\xe1 Ole\u0161n\xe1",
        townCode: 562734,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.175714,
        long: 15.161053
    },
    {
        town: "Nov\xe1 Paka",
        townCode: 573248,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50901,
        lat: 50.494593,
        long: 15.515138
    },
    {
        town: "Nov\xe1 Pec",
        townCode: 550451,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38462,
        lat: 48.778263,
        long: 13.930124
    },
    {
        town: "Nov\xe1 Pl\xe1\u0148",
        townCode: 546950,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.922008,
        long: 17.475201
    },
    {
        town: "Nov\xe1 Role",
        townCode: 555398,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36225,
        lat: 50.271028,
        long: 12.784334
    },
    {
        town: "Nov\xe1 \u0158\xed\u0161e",
        townCode: 587591,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58865,
        lat: 49.13951,
        long: 15.563696
    },
    {
        town: "Nov\xe1 S\xeddla",
        townCode: 572608,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.884023,
        long: 16.237288
    },
    {
        town: "Nov\xe1 Telib",
        townCode: 536377,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.39127,
        long: 15.032963
    },
    {
        town: "Nov\xe1 V\u010Delnice",
        townCode: 546801,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.239453,
        long: 15.072705
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 535648,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37315,
        lat: 48.920709,
        long: 14.52874
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 513661,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38203,
        lat: 48.948418,
        long: 14.24726
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 560201,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.187495,
        long: 13.733768
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 583502,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66491,
        lat: 49.108212,
        long: 16.310943
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 560561,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36464,
        lat: 50.084201,
        long: 12.775287
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 591246,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.248618,
        long: 15.803952
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 596213,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.391108,
        long: 16.196383
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 576549,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51721,
        lat: 50.13079,
        long: 16.050209
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 546593,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46331,
        lat: 50.831607,
        long: 15.001175
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 599131,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.366549,
        long: 13.038868
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 540269,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33441,
        lat: 49.686066,
        long: 13.292789
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 535117,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27752,
        lat: 50.312898,
        long: 14.308286
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 538558,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.219324,
        long: 14.535739
    },
    {
        town: "Nov\xe1 Ves",
        townCode: 542636,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.285958,
        long: 13.842789
    },
    {
        town: "Nov\xe1 Ves I",
        townCode: 533530,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.052246,
        long: 15.144556
    },
    {
        town: "Nov\xe1 Ves nad Lu\u017Enic\xed",
        townCode: 562360,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37809,
        lat: 48.810739,
        long: 14.925675
    },
    {
        town: "Nov\xe1 Ves nad Nisou",
        townCode: 563731,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46827,
        lat: 50.72524,
        long: 15.214758
    },
    {
        town: "Nov\xe1 Ves nad Popelkou",
        townCode: 577341,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51271,
        lat: 50.52041,
        long: 15.411952
    },
    {
        town: "Nov\xe1 Ves pod Ple\u0161\xed",
        townCode: 540889,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26204,
        lat: 49.831865,
        long: 14.275336
    },
    {
        town: "Nov\xe1 Ves u Bakova",
        townCode: 571806,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29401,
        lat: 50.490776,
        long: 14.926496
    },
    {
        town: "Nov\xe1 Ves u Chot\u011Bbo\u0159e",
        townCode: 569160,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58273,
        lat: 49.756205,
        long: 15.648091
    },
    {
        town: "Nov\xe1 Ves u Ch\xfdnova",
        townCode: 552763,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39155,
        lat: 49.392801,
        long: 14.783071
    },
    {
        town: "Nov\xe1 Ves u Jaro\u0161ova",
        townCode: 572438,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.837637,
        long: 16.160009
    },
    {
        town: "Nov\xe1 Ves u Le\u0161tiny",
        townCode: 569151,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.785954,
        long: 15.404017
    },
    {
        town: "Nov\xe1 Ves u Mlad\xe9 Vo\u017Eice",
        townCode: 563455,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.543134,
        long: 14.748066
    },
    {
        town: "Nov\xe1 Ves u Nov\xe9ho M\u011Bsta na Morav\u011B",
        townCode: 596221,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.540029,
        long: 16.084205
    },
    {
        town: "Nov\xe1 Ves u Sv\u011Btl\xe9",
        townCode: 555266,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.648874,
        long: 15.437793
    },
    {
        town: "Nov\xe1 Ves v Hor\xe1ch",
        townCode: 567329,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43545,
        lat: 50.594847,
        long: 13.482558
    },
    {
        town: "Nov\xe9 Br\xe1nice",
        townCode: 583511,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.071249,
        long: 16.441855
    },
    {
        town: "Nov\xe9 Dvory",
        townCode: 587974,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.564483,
        long: 15.808971
    },
    {
        town: "Nov\xe9 Dvory",
        townCode: 534242,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28531,
        lat: 49.970682,
        long: 15.324978
    },
    {
        town: "Nov\xe9 Dvory",
        townCode: 540897,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.803328,
        long: 14.357021
    },
    {
        town: "Nov\xe9 Dvory",
        townCode: 565342,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.447702,
        long: 14.179516
    },
    {
        town: "Nov\xe9 Hamry",
        townCode: 506494,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36221,
        lat: 50.360145,
        long: 12.719531
    },
    {
        town: "Nov\xe9 He\u0159minovy",
        townCode: 569551,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 50.023575,
        long: 17.5283
    },
    {
        town: "Nov\xe9 Hrady",
        townCode: 544868,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37333,
        lat: 48.789733,
        long: 14.778483
    },
    {
        town: "Nov\xe9 Hrady",
        townCode: 571920,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53945,
        lat: 49.851778,
        long: 16.143909
    },
    {
        town: "Nov\xe9 Hut\u011B",
        townCode: 561568,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38501,
        lat: 49.038803,
        long: 13.645759
    },
    {
        town: "Nov\xe9 Lublice",
        townCode: 512893,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74901,
        lat: 49.862875,
        long: 17.678131
    },
    {
        town: "Nov\xe9 M\u011Bsto",
        townCode: 570494,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.147769,
        long: 15.495214
    },
    {
        town: "Nov\xe9 M\u011Bsto na Morav\u011B",
        townCode: 596230,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.561543,
        long: 16.074288
    },
    {
        town: "Nov\xe9 M\u011Bsto nad Metuj\xed",
        townCode: 574279,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.344662,
        long: 16.151571
    },
    {
        town: "Nov\xe9 M\u011Bsto pod Smrkem",
        townCode: 564265,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46365,
        lat: 50.925011,
        long: 15.229539
    },
    {
        town: "Nov\xe9 Mitrovice",
        townCode: 558176,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33563,
        lat: 49.579685,
        long: 13.683735
    },
    {
        town: "Nov\xe9 Sady",
        townCode: 593443,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68308,
        lat: 49.408906,
        long: 16.902045
    },
    {
        town: "Nov\xe9 Sady",
        townCode: 596248,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59501,
        lat: 49.293788,
        long: 16.193421
    },
    {
        town: "Nov\xe9 Sedlice",
        townCode: 555274,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74706,
        lat: 49.902222,
        long: 18.001326
    },
    {
        town: "Nov\xe9 Sedlo",
        townCode: 560570,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35734,
        lat: 50.206578,
        long: 12.738121
    },
    {
        town: "Nov\xe9 Sedlo",
        townCode: 566519,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.339745,
        long: 13.474941
    },
    {
        town: "Nov\xe9 Stra\u0161ec\xed",
        townCode: 542164,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27101,
        lat: 50.152823,
        long: 13.900538
    },
    {
        town: "Nov\xe9 Syrovice",
        townCode: 591254,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67541,
        lat: 49.01773,
        long: 15.773555
    },
    {
        town: "Nov\xe9 Vesel\xed",
        townCode: 596256,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.519866,
        long: 15.90863
    },
    {
        town: 'Noviny pod Ralskem',
        townCode: 561851,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47124,
        lat: 50.692151,
        long: 14.746964
    },
    {
        town: 'Novosedlice',
        townCode: 567752,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41731,
        lat: 50.656439,
        long: 13.823154
    },
    {
        town: 'Novosedly',
        townCode: 551554,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.26277,
        long: 13.797628
    },
    {
        town: 'Novosedly',
        townCode: 584746,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69182,
        lat: 48.83714,
        long: 16.492837
    },
    {
        town: "Novosedly nad Ne\u017E\xe1rkou",
        townCode: 546844,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37817,
        lat: 49.081103,
        long: 14.82226
    },
    {
        town: "Nov\xfd Bor",
        townCode: 561860,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47301,
        lat: 50.757714,
        long: 14.555664
    },
    {
        town: "Nov\xfd Byd\u017Eov",
        townCode: 570508,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.241602,
        long: 15.490926
    },
    {
        town: "Nov\xfd D\u016Fm",
        townCode: 542181,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26901,
        lat: 50.08824,
        long: 13.831001
    },
    {
        town: "Nov\xfd Dv\u016Fr",
        townCode: 599654,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28932,
        lat: 50.238112,
        long: 15.022165
    },
    {
        town: "Nov\xfd Hr\xe1dek",
        townCode: 574287,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54922,
        lat: 50.357375,
        long: 16.244478
    },
    {
        town: "Nov\xfd Hrozenkov",
        townCode: 544566,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75604,
        lat: 49.337068,
        long: 18.198046
    },
    {
        town: "Nov\xfd J\xe1chymov",
        townCode: 531600,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26703,
        lat: 49.980867,
        long: 13.943296
    },
    {
        town: "Nov\xfd Ji\u010D\xedn",
        townCode: 599191,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74101,
        lat: 49.594425,
        long: 18.013636
    },
    {
        town: "Nov\xfd Jimramov",
        townCode: 596264,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59242,
        lat: 49.634722,
        long: 16.187315
    },
    {
        town: "Nov\xfd Kn\xedn",
        townCode: 540901,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26203,
        lat: 49.788108,
        long: 14.293661
    },
    {
        town: "Nov\xfd Kostel",
        townCode: 554707,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.217131,
        long: 12.445362
    },
    {
        town: "Nov\xfd Kramol\xedn",
        townCode: 554057,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.477383,
        long: 12.805087
    },
    {
        town: "Nov\xfd Mal\xedn",
        townCode: 540501,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78803,
        lat: 49.942722,
        long: 17.03201
    },
    {
        town: "Nov\xfd Old\u0159ichov",
        townCode: 561878,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47113,
        lat: 50.765514,
        long: 14.442254
    },
    {
        town: "Nov\xfd Ples",
        townCode: 574295,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.321268,
        long: 15.94929
    },
    {
        town: "Nov\xfd Poddvorov",
        townCode: 586463,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69616,
        lat: 48.868447,
        long: 16.961126
    },
    {
        town: "Nov\xfd P\u0159erov",
        townCode: 584754,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69181,
        lat: 48.809718,
        long: 16.493828
    },
    {
        town: "Nov\xfd Rychnov",
        townCode: 548464,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39404,
        lat: 49.383617,
        long: 15.36629
    },
    {
        town: "Nov\xfd \u0160aldorf-Sedle\u0161ovice",
        townCode: 587729,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67181,
        lat: 48.830248,
        long: 16.060675
    },
    {
        town: "Nov\xfd Tele\u010Dkov",
        townCode: 591262,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.32127,
        long: 15.938454
    },
    {
        town: "Nov\xfd Vestec",
        townCode: 538566,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25075,
        lat: 50.183861,
        long: 14.720401
    },
    {
        town: "Nu\u010Dice",
        townCode: 533548,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.955626,
        long: 14.8845
    },
    {
        town: "Nu\u010Dice",
        townCode: 531618,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25216,
        lat: 50.018581,
        long: 14.230078
    },
    {
        town: 'Nupaky',
        townCode: 564907,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.994052,
        long: 14.602336
    },
    {
        town: "N\xfddek",
        townCode: 507091,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73995,
        lat: 49.656185,
        long: 18.756984
    },
    {
        town: 'Nyklovice',
        townCode: 596272,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.603976,
        long: 16.345044
    },
    {
        town: 'Nymburk',
        townCode: 537004,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.185682,
        long: 15.04376
    },
    {
        town: "N\xfdrov",
        townCode: 582107,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67972,
        lat: 49.528083,
        long: 16.539265
    },
    {
        town: "N\xfdrsko",
        townCode: 556831,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34022,
        lat: 49.293979,
        long: 13.143639
    },
    {
        town: "N\xfd\u0159any",
        townCode: 559300,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.712816,
        long: 13.204705
    },
    {
        town: "Ob\u010Dov",
        townCode: 513571,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.713206,
        long: 14.066994
    },
    {
        town: 'Obecnice',
        townCode: 540935,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26221,
        lat: 49.716261,
        long: 13.947414
    },
    {
        town: "Ob\u011Bdkovice",
        townCode: 589799,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79823,
        lat: 49.394852,
        long: 17.227643
    },
    {
        town: "Ob\u011Bdovice",
        townCode: 548065,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.161163,
        long: 15.582212
    },
    {
        town: 'Obora',
        townCode: 582115,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.452311,
        long: 16.605726
    },
    {
        town: 'Obora',
        townCode: 559318,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.889575,
        long: 13.413718
    },
    {
        town: 'Obora',
        townCode: 541443,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.814715,
        long: 12.5378
    },
    {
        town: 'Obora',
        townCode: 542580,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.373356,
        long: 13.863081
    },
    {
        town: "Oborn\xe1",
        townCode: 569577,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 50.003161,
        long: 17.497004
    },
    {
        town: 'Obory',
        townCode: 540943,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.680504,
        long: 14.216474
    },
    {
        town: "Obo\u0159i\u0161t\u011B",
        townCode: 540951,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26212,
        lat: 49.742352,
        long: 14.151959
    },
    {
        town: "Obrata\u0148",
        townCode: 548472,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39412,
        lat: 49.425159,
        long: 14.943589
    },
    {
        town: 'Obrnice',
        townCode: 567337,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43521,
        lat: 50.505083,
        long: 13.695511
    },
    {
        town: 'Obrubce',
        townCode: 570893,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.447959,
        long: 15.06372
    },
    {
        town: 'Obruby',
        townCode: 536407,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29403,
        lat: 50.460227,
        long: 15.082414
    },
    {
        town: "Ob\u0159\xedstv\xed",
        townCode: 535133,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27742,
        lat: 50.295983,
        long: 14.478492
    },
    {
        town: "Oby\u010Dtov",
        townCode: 596281,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.499959,
        long: 16.001685
    },
    {
        town: 'Obytce',
        townCode: 541915,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.390514,
        long: 13.378436
    },
    {
        town: 'Ocmanice',
        townCode: 510980,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.233244,
        long: 16.125399
    },
    {
        town: "O\u010Delice",
        townCode: 576557,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.239986,
        long: 16.067392
    },
    {
        town: "O\u010Dihov",
        townCode: 566527,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43987,
        lat: 50.19866,
        long: 13.460534
    },
    {
        town: 'Odolena Voda',
        townCode: 538574,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25070,
        lat: 50.233515,
        long: 14.410889
    },
    {
        town: 'Odrava',
        townCode: 539554,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.103171,
        long: 12.48425
    },
    {
        town: 'Odrovice',
        townCode: 583529,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.010907,
        long: 16.509119
    },
    {
        town: 'Odry',
        townCode: 599701,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.662648,
        long: 17.83095
    },
    {
        town: "Od\u0159epsy",
        townCode: 537551,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28907,
        lat: 50.14424,
        long: 15.188842
    },
    {
        town: 'Odunec',
        townCode: 591289,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.120315,
        long: 16.014372
    },
    {
        town: "Oha\u0159e",
        townCode: 533556,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28130,
        lat: 50.097882,
        long: 15.29512
    },
    {
        town: "Oha\u0159ice",
        townCode: 549185,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.454396,
        long: 15.258528
    },
    {
        town: "Ohave\u010D",
        townCode: 548910,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.4497,
        long: 15.30877
    },
    {
        town: "Ohn\xed\u010D",
        townCode: 567761,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41765,
        lat: 50.587135,
        long: 13.844786
    },
    {
        town: "Ohni\u0161ov",
        townCode: 576565,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51784,
        lat: 50.322692,
        long: 16.213912
    },
    {
        town: "Ohni\u0161\u0165any",
        townCode: 570516,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50354,
        lat: 50.32963,
        long: 15.511087
    },
    {
        town: 'Ohrazenice',
        townCode: 577359,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.597745,
        long: 15.126071
    },
    {
        town: 'Ohrazenice',
        townCode: 540960,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26223,
        lat: 49.78714,
        long: 13.959817
    },
    {
        town: 'Ohrobec',
        townCode: 539503,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25245,
        lat: 49.941829,
        long: 14.432139
    },
    {
        town: 'Ohrozim',
        townCode: 589802,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.48656,
        long: 17.02073
    },
    {
        town: 'Ochoz',
        townCode: 589811,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.600231,
        long: 16.915109
    },
    {
        town: 'Ochoz u Brna',
        townCode: 583537,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66402,
        lat: 49.254302,
        long: 16.737338
    },
    {
        town: "Ochoz u Ti\u0161nova",
        townCode: 582123,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.425693,
        long: 16.394338
    },
    {
        town: 'Okarec',
        townCode: 591297,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67502,
        lat: 49.206057,
        long: 16.088033
    },
    {
        town: 'Okna',
        townCode: 561886,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47162,
        lat: 50.527594,
        long: 14.671066
    },
    {
        town: "Oko\u0159",
        townCode: 571334,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25264,
        lat: 50.162011,
        long: 14.258724
    },
    {
        town: 'Okounov',
        townCode: 563269,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43151,
        lat: 50.362327,
        long: 13.106679
    },
    {
        town: "Okrouhl\xe1",
        townCode: 529877,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.413732,
        long: 14.364412
    },
    {
        town: "Okrouhl\xe1",
        townCode: 582131,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.507604,
        long: 16.732103
    },
    {
        town: "Okrouhl\xe1",
        townCode: 538922,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.062566,
        long: 12.487772
    },
    {
        town: "Okrouhl\xe1",
        townCode: 561894,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47301,
        lat: 50.766932,
        long: 14.527685
    },
    {
        town: "Okrouhl\xe1 Radou\u0148",
        townCode: 562475,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.239826,
        long: 15.017172
    },
    {
        town: 'Okrouhlice',
        townCode: 569186,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58231,
        lat: 49.630014,
        long: 15.490933
    },
    {
        town: "Okrouhli\u010Dka",
        townCode: 548588,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58253,
        lat: 49.534541,
        long: 15.556975
    },
    {
        town: 'Okrouhlo',
        townCode: 539511,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25401,
        lat: 49.918924,
        long: 14.447417
    },
    {
        town: "Ok\u0159esane\u010D",
        townCode: 534251,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.852528,
        long: 15.475842
    },
    {
        town: "Ok\u0159e\u0161ice",
        townCode: 546933,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.25948,
        long: 15.852076
    },
    {
        town: "Ok\u0159\xednek",
        townCode: 537560,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.164391,
        long: 15.192429
    },
    {
        town: "Ok\u0159\xed\u0161ky",
        townCode: 591301,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.245493,
        long: 15.769689
    },
    {
        town: 'Olbramice',
        townCode: 554049,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74283,
        lat: 49.78965,
        long: 18.089056
    },
    {
        town: 'Olbramice',
        townCode: 552259,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.613591,
        long: 17.001576
    },
    {
        town: 'Olbramkostel',
        townCode: 594555,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67151,
        lat: 48.921815,
        long: 15.949704
    },
    {
        town: 'Olbramov',
        townCode: 566888,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.843499,
        long: 12.866878
    },
    {
        town: 'Olbramovice',
        townCode: 594563,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67176,
        lat: 48.984904,
        long: 16.402498
    },
    {
        town: 'Olbramovice',
        townCode: 530344,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25901,
        lat: 49.67328,
        long: 14.640953
    },
    {
        town: "Old\u0159ichov",
        townCode: 552798,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.558828,
        long: 14.754364
    },
    {
        town: "Old\u0159ichov",
        townCode: 515825,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.49756,
        long: 17.539328
    },
    {
        town: "Old\u0159ichov v H\xe1j\xedch",
        townCode: 564281,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46331,
        lat: 50.849733,
        long: 15.083777
    },
    {
        town: "Old\u0159ichovice",
        townCode: 549444,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76361,
        lat: 49.181867,
        long: 17.561448
    },
    {
        town: "Old\u0159i\u0161",
        townCode: 578479,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56982,
        lat: 49.727227,
        long: 16.19381
    },
    {
        town: "Old\u0159i\u0161ov",
        townCode: 509574,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74733,
        lat: 49.991395,
        long: 17.960845
    },
    {
        town: 'Oleksovice',
        townCode: 594571,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67162,
        lat: 48.902158,
        long: 16.248504
    },
    {
        town: "Ole\u0161enka",
        townCode: 569208,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.549005,
        long: 15.765938
    },
    {
        town: "Ole\u0161ka",
        townCode: 533564,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28162,
        lat: 49.971695,
        long: 14.916786
    },
    {
        town: "Ole\u0161ko",
        townCode: 542440,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.480652,
        long: 14.196615
    },
    {
        town: "Ole\u0161n\xe1",
        townCode: 562190,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.346255,
        long: 14.310591
    },
    {
        town: "Ole\u0161n\xe1",
        townCode: 569216,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.68167,
        long: 15.547785
    },
    {
        town: "Ole\u0161n\xe1",
        townCode: 561967,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.445848,
        long: 15.263754
    },
    {
        town: "Ole\u0161n\xe1",
        townCode: 531626,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26764,
        lat: 49.780462,
        long: 13.810119
    },
    {
        town: "Ole\u0161n\xe1",
        townCode: 542199,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26901,
        lat: 50.128597,
        long: 13.695961
    },
    {
        town: "Ole\u0161nice",
        townCode: 544884,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37331,
        lat: 48.84133,
        long: 14.704931
    },
    {
        town: "Ole\u0161nice",
        townCode: 582158,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.557654,
        long: 16.421795
    },
    {
        town: "Ole\u0161nice",
        townCode: 570524,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.142363,
        long: 15.445092
    },
    {
        town: "Ole\u0161nice",
        townCode: 576581,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51736,
        lat: 50.14431,
        long: 16.148606
    },
    {
        town: "Ole\u0161nice",
        townCode: 577367,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.545045,
        long: 15.119305
    },
    {
        town: "Ole\u0161nice v Orlick\xfdch hor\xe1ch",
        townCode: 576573,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51783,
        lat: 50.37326,
        long: 16.30998
    },
    {
        town: "Ole\u0161n\xedk",
        townCode: 544892,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37350,
        lat: 49.107235,
        long: 14.363919
    },
    {
        town: 'Olomouc',
        townCode: 500496,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.593878,
        long: 17.250979
    },
    {
        town: "Olomu\u010Dany",
        townCode: 582166,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67903,
        lat: 49.33097,
        long: 16.671791
    },
    {
        town: "Olov\xed",
        townCode: 560588,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35707,
        lat: 50.251243,
        long: 12.558884
    },
    {
        town: 'Olovnice',
        townCode: 532673,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27326,
        lat: 50.234699,
        long: 14.240487
    },
    {
        town: "Ol\u0161any",
        townCode: 550132,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.248136,
        long: 16.86616
    },
    {
        town: "Ol\u0161any",
        townCode: 587613,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.186221,
        long: 15.566091
    },
    {
        town: "Ol\u0161any",
        townCode: 540510,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78962,
        lat: 49.965186,
        long: 16.859046
    },
    {
        town: "Ol\u0161any",
        townCode: 541958,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.400933,
        long: 13.627031
    },
    {
        town: "Ol\u0161any u Prost\u011Bjova",
        townCode: 589829,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79814,
        lat: 49.53655,
        long: 17.16467
    },
    {
        town: "Ol\u0161\xed",
        townCode: 596302,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59261,
        lat: 49.421365,
        long: 16.290327
    },
    {
        town: "Ol\u0161\xed",
        townCode: 587214,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.155548,
        long: 15.373333
    },
    {
        town: "Ol\u0161ovec",
        townCode: 552844,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.590212,
        long: 17.717277
    },
    {
        town: "Ol\u0161ovice",
        townCode: 537365,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38411,
        lat: 49.056923,
        long: 14.235971
    },
    {
        town: 'Omice',
        townCode: 583545,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66441,
        lat: 49.170033,
        long: 16.451834
    },
    {
        town: 'Omlenice',
        townCode: 545660,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38241,
        lat: 48.725918,
        long: 14.443732
    },
    {
        town: 'Ondratice',
        townCode: 589837,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79807,
        lat: 49.363049,
        long: 17.063785
    },
    {
        town: "Ond\u0159ejov",
        townCode: 537691,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.393042,
        long: 15.178062
    },
    {
        town: "Ond\u0159ejov",
        townCode: 538582,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25165,
        lat: 49.904717,
        long: 14.78431
    },
    {
        town: "Onomy\u0161l",
        townCode: 534277,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.89933,
        long: 15.12436
    },
    {
        town: "On\u0161ov",
        townCode: 594580,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.905385,
        long: 15.834328
    },
    {
        town: "On\u0161ov",
        townCode: 548502,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.578327,
        long: 15.136477
    },
    {
        town: "Opa\u0159any",
        townCode: 552801,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39161,
        lat: 49.396884,
        long: 14.481477
    },
    {
        town: 'Opatov',
        townCode: 587621,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58805,
        lat: 49.431128,
        long: 15.394379
    },
    {
        town: 'Opatov',
        townCode: 591319,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67528,
        lat: 49.224435,
        long: 15.661768
    },
    {
        town: 'Opatov',
        townCode: 578487,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56912,
        lat: 49.825097,
        long: 16.504684
    },
    {
        town: 'Opatovec',
        townCode: 572721,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.805398,
        long: 16.480232
    },
    {
        town: 'Opatovice',
        townCode: 583553,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.075131,
        long: 16.641079
    },
    {
        town: 'Opatovice',
        townCode: 516201,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75356,
        lat: 49.49929,
        long: 17.739289
    },
    {
        town: 'Opatovice I',
        townCode: 530956,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.85525,
        long: 15.248583
    },
    {
        town: 'Opatovice nad Labem',
        townCode: 575429,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.145512,
        long: 15.790553
    },
    {
        town: 'Opava',
        townCode: 505927,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74601,
        lat: 49.94076,
        long: 17.894899
    },
    {
        town: 'Oplany',
        townCode: 571679,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.924267,
        long: 14.867406
    },
    {
        town: 'Oplocany',
        townCode: 553000,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75101,
        lat: 49.409663,
        long: 17.260311
    },
    {
        town: 'Oplot',
        townCode: 539783,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.579961,
        long: 13.274335
    },
    {
        town: "Opo\u010Dnice",
        townCode: 537578,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28904,
        lat: 50.172581,
        long: 15.257777
    },
    {
        town: "Opo\u010Dno",
        townCode: 576590,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51773,
        lat: 50.267515,
        long: 16.114902
    },
    {
        town: "Opo\u010Dno",
        townCode: 542555,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.311585,
        long: 13.735342
    },
    {
        town: 'Opolany',
        townCode: 537586,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28907,
        lat: 50.130814,
        long: 15.217103
    },
    {
        town: "Opone\u0161ice",
        townCode: 591327,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 49.037839,
        long: 15.652148
    },
    {
        town: 'Oprostovice',
        townCode: 516350,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.469951,
        long: 17.620402
    },
    {
        town: "Or\xe1\u010Dov",
        townCode: 542202,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27032,
        lat: 50.111647,
        long: 13.549003
    },
    {
        town: 'Orel',
        townCode: 571962,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.919409,
        long: 15.839135
    },
    {
        town: "Orlick\xe9 Podh\u016F\u0159\xed",
        townCode: 580716,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 50.00342,
        long: 16.35071
    },
    {
        town: "Orlick\xe9 Z\xe1ho\u0159\xed",
        townCode: 576603,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51764,
        lat: 50.278761,
        long: 16.475033
    },
    {
        town: "Orli\u010Dky",
        townCode: 580724,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56155,
        lat: 50.031626,
        long: 16.681575
    },
    {
        town: "Orl\xedk nad Vltavou",
        townCode: 549681,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39807,
        lat: 49.509979,
        long: 14.165613
    },
    {
        town: "Orlov\xe1",
        townCode: 599069,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73511,
        lat: 49.870238,
        long: 18.425108
    },
    {
        town: 'Orlovice',
        townCode: 593460,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.239184,
        long: 17.093701
    },
    {
        town: "O\u0159ech",
        townCode: 539520,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25225,
        lat: 50.020209,
        long: 14.296653
    },
    {
        town: "O\u0159echov",
        townCode: 583561,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66444,
        lat: 49.11128,
        long: 16.523392
    },
    {
        town: "O\u0159echov",
        townCode: 587630,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.200027,
        long: 15.532067
    },
    {
        town: "O\u0159echov",
        townCode: 596329,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59452,
        lat: 49.350482,
        long: 16.139044
    },
    {
        town: "O\u0159echov",
        townCode: 592447,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68737,
        lat: 49.030686,
        long: 17.300934
    },
    {
        town: "Ose\u010Dany",
        townCode: 598470,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.697825,
        long: 14.437729
    },
    {
        town: "Ose\u010Dek",
        townCode: 599662,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28941,
        lat: 50.10165,
        long: 15.148691
    },
    {
        town: "Ose\u010Dn\xe1",
        townCode: 564290,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46352,
        lat: 50.69499,
        long: 14.921485
    },
    {
        town: "Ose\u010Dnice",
        townCode: 576611,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51703,
        lat: 50.257266,
        long: 16.307
    },
    {
        town: 'Osek',
        townCode: 598828,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.443367,
        long: 14.299945
    },
    {
        town: 'Osek',
        townCode: 551562,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.318408,
        long: 13.963291
    },
    {
        town: 'Osek',
        townCode: 573264,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50743,
        lat: 50.463947,
        long: 15.159618
    },
    {
        town: 'Osek',
        townCode: 560057,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33821,
        lat: 49.778115,
        long: 13.59104
    },
    {
        town: 'Osek',
        townCode: 531634,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26762,
        lat: 49.819743,
        long: 13.858627
    },
    {
        town: 'Osek',
        townCode: 567779,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41705,
        lat: 50.622637,
        long: 13.691488
    },
    {
        town: "Osek nad Be\u010Dvou",
        townCode: 516619,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75122,
        lat: 49.511313,
        long: 17.528401
    },
    {
        town: 'Oselce',
        townCode: 558184,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33546,
        lat: 49.437309,
        long: 13.672931
    },
    {
        town: 'Osice',
        townCode: 570532,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50326,
        lat: 50.142888,
        long: 15.686098
    },
    {
        town: "Os\xed\u010Dko",
        townCode: 588822,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.431087,
        long: 17.751607
    },
    {
        town: "Osi\u010Dky",
        townCode: 570541,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.143649,
        long: 15.676288
    },
    {
        town: "Os\xedk",
        townCode: 578509,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56967,
        lat: 49.843645,
        long: 16.28477
    },
    {
        town: 'Osiky',
        townCode: 582174,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.456294,
        long: 16.421688
    },
    {
        town: 'Oskava',
        townCode: 540544,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78801,
        lat: 49.895329,
        long: 17.132249
    },
    {
        town: "Osko\u0159\xednek",
        townCode: 537616,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28932,
        lat: 50.240157,
        long: 15.084104
    },
    {
        town: 'Oslavany',
        townCode: 583588,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66412,
        lat: 49.123447,
        long: 16.336633
    },
    {
        town: 'Oslavice',
        townCode: 596337,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.340872,
        long: 15.990807
    },
    {
        town: "Oslavi\u010Dka",
        townCode: 511412,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.315507,
        long: 15.966948
    },
    {
        town: 'Oslnovice',
        townCode: 594598,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.932188,
        long: 15.6875
    },
    {
        town: 'Oslov',
        townCode: 549703,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39835,
        lat: 49.399365,
        long: 14.212059
    },
    {
        town: 'Osoblaha',
        townCode: 597716,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.275267,
        long: 17.715337
    },
    {
        town: 'Osov',
        townCode: 531642,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26725,
        lat: 49.844478,
        long: 14.08402
    },
    {
        town: "Osov\xe1 B\xedt\xfd\u0161ka",
        townCode: 596345,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.325143,
        long: 16.168556
    },
    {
        town: "Osov\xe9",
        townCode: 596353,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.325323,
        long: 16.015528
    },
    {
        town: "Osta\u0161ov",
        townCode: 591335,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.155648,
        long: 15.918092
    },
    {
        town: 'Ostopovice',
        townCode: 583596,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66449,
        lat: 49.161102,
        long: 16.54559
    },
    {
        town: "Ostr\xe1",
        townCode: 537624,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28922,
        lat: 50.180537,
        long: 14.893003
    },
    {
        town: 'Ostrata',
        townCode: 557170,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76311,
        lat: 49.271025,
        long: 17.76694
    },
    {
        town: 'Ostrava',
        townCode: 554821,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 70200,
        lat: 49.821023,
        long: 18.262624
    },
    {
        town: 'Ostravice',
        townCode: 598542,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73914,
        lat: 49.535196,
        long: 18.391751
    },
    {
        town: "Ostrolovsk\xfd \xdajezd",
        townCode: 535231,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.880718,
        long: 14.600707
    },
    {
        town: "Ostrom\u011B\u0159",
        townCode: 573272,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50752,
        lat: 50.372556,
        long: 15.549593
    },
    {
        town: 'Ostrov',
        townCode: 555428,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.306035,
        long: 12.939183
    },
    {
        town: 'Ostrov',
        townCode: 548359,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.693104,
        long: 15.301494
    },
    {
        town: 'Ostrov',
        townCode: 574104,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53863,
        lat: 49.972703,
        long: 16.030432
    },
    {
        town: 'Ostrov',
        townCode: 580732,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56122,
        lat: 49.930345,
        long: 16.540637
    },
    {
        town: 'Ostrov',
        townCode: 599395,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25706,
        lat: 49.665402,
        long: 14.851197
    },
    {
        town: 'Ostrov',
        townCode: 598372,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.611219,
        long: 14.014609
    },
    {
        town: 'Ostrov nad Oslavou',
        townCode: 596361,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59445,
        lat: 49.486919,
        long: 15.990033
    },
    {
        town: "Ostrov u Bezdru\u017Eic",
        townCode: 559326,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33038,
        lat: 49.900238,
        long: 13.042079
    },
    {
        town: 'Ostrov u Macochy',
        townCode: 582182,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67914,
        lat: 49.382462,
        long: 16.762786
    },
    {
        town: "Ostrova\u010Dice",
        townCode: 583600,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66481,
        lat: 49.210924,
        long: 16.409562
    },
    {
        town: "Ostrov\xe1nky",
        townCode: 586471,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69631,
        lat: 49.042793,
        long: 17.080434
    },
    {
        town: 'Ostrovec',
        townCode: 549711,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39833,
        lat: 49.421243,
        long: 14.115581
    },
    {
        town: 'Ostrovec-Lhotka',
        townCode: 566993,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.907578,
        long: 13.728204
    },
    {
        town: "Ostro\u017Esk\xe1 Lhota",
        townCode: 592455,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68723,
        lat: 48.975689,
        long: 17.467622
    },
    {
        town: "Ostro\u017Esk\xe1 Nov\xe1 Ves",
        townCode: 592463,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68722,
        lat: 49.004438,
        long: 17.436427
    },
    {
        town: "Ostru\u017En\xe1",
        townCode: 569330,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78825,
        lat: 50.185253,
        long: 17.051691
    },
    {
        town: "Ostru\u017Eno",
        townCode: 573281,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.443397,
        long: 15.289734
    },
    {
        town: "Ost\u0159edek",
        townCode: 530352,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25724,
        lat: 49.834893,
        long: 14.8324
    },
    {
        town: "Ost\u0159e\u0161any",
        townCode: 575437,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.993525,
        long: 15.805408
    },
    {
        town: "Ost\u0159etice",
        townCode: 578061,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.422439,
        long: 13.347004
    },
    {
        town: "Ost\u0159et\xedn",
        townCode: 575445,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.044716,
        long: 16.030478
    },
    {
        town: "Osv\u011Btimany",
        townCode: 592471,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68742,
        lat: 49.055871,
        long: 17.249789
    },
    {
        town: "Osvra\u010D\xedn",
        townCode: 554073,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.513274,
        long: 13.047035
    },
    {
        town: "O\u0161el\xedn",
        townCode: 541681,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.772115,
        long: 12.856261
    },
    {
        town: 'Otaslavice',
        townCode: 589845,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79806,
        lat: 49.388426,
        long: 17.071186
    },
    {
        town: "Ot\u011B\u0161ice",
        townCode: 540293,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.544137,
        long: 13.220352
    },
    {
        town: 'Otice',
        townCode: 509612,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74781,
        lat: 49.916939,
        long: 17.869927
    },
    {
        town: "Ot\xedn",
        townCode: 587648,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.2666,
        long: 15.569796
    },
    {
        town: "Ot\xedn",
        townCode: 596370,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.362965,
        long: 15.906706
    },
    {
        town: 'Otinoves',
        townCode: 589853,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79861,
        lat: 49.421275,
        long: 16.871783
    },
    {
        town: 'Otmarov',
        townCode: 506699,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66457,
        lat: 49.100613,
        long: 16.672783
    },
    {
        town: "Otm\xed\u010De",
        townCode: 534111,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.869145,
        long: 13.947252
    },
    {
        town: 'Otnice',
        townCode: 593478,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68354,
        lat: 49.086517,
        long: 16.814533
    },
    {
        town: 'Otov',
        townCode: 566209,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.486597,
        long: 12.842602
    },
    {
        town: 'Otovice',
        townCode: 537969,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.25545,
        long: 12.871721
    },
    {
        town: 'Otovice',
        townCode: 574317,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54972,
        lat: 50.557245,
        long: 16.387685
    },
    {
        town: 'Otradov',
        townCode: 554952,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53943,
        lat: 49.793442,
        long: 16.043608
    },
    {
        town: "Otro\u010D\xedn",
        townCode: 555444,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36401,
        lat: 50.032393,
        long: 12.892407
    },
    {
        town: "Otro\u010Din\u011Bves",
        townCode: 531669,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26703,
        lat: 49.980598,
        long: 13.978869
    },
    {
        town: 'Otrokovice',
        townCode: 585599,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76502,
        lat: 49.210016,
        long: 17.530876
    },
    {
        town: 'Otvice',
        townCode: 563277,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43111,
        lat: 50.480923,
        long: 13.45081
    },
    {
        town: 'Otvovice',
        townCode: 532681,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27327,
        lat: 50.211664,
        long: 14.27303
    },
    {
        town: "Oub\u011Bnice",
        townCode: 541010,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.717747,
        long: 14.159939
    },
    {
        town: 'Oucmanice',
        townCode: 580741,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 49.989464,
        long: 16.281865
    },
    {
        town: "Oudole\u0148",
        townCode: 569224,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58224,
        lat: 49.659429,
        long: 15.755752
    },
    {
        town: "Ov\u010D\xe1ry",
        townCode: 533572,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.062882,
        long: 15.239607
    },
    {
        town: "Ov\u010D\xe1ry",
        townCode: 535141,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27714,
        lat: 50.253151,
        long: 14.613962
    },
    {
        town: "Ovesn\xe1 Lhota",
        townCode: 569232,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.722657,
        long: 15.38416
    },
    {
        town: "Ovesn\xe9 Kladruby",
        townCode: 539473,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.953112,
        long: 12.779206
    },
    {
        town: 'Oznice',
        townCode: 544574,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75624,
        lat: 49.432567,
        long: 17.917399
    },
    {
        town: "Pab\u011Bnice",
        townCode: 531278,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28543,
        lat: 49.84174,
        long: 15.302429
    },
    {
        town: "Pace\u0159ice",
        townCode: 545953,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46344,
        lat: 50.619335,
        long: 15.113636
    },
    {
        town: 'Pacetluky',
        townCode: 588831,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76843,
        lat: 49.379562,
        long: 17.56585
    },
    {
        town: 'Pacov',
        townCode: 548511,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.470865,
        long: 15.001783
    },
    {
        town: "Pa\u010Dejov",
        townCode: 556912,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.373007,
        long: 13.632835
    },
    {
        town: "Pa\u010Dlavice",
        townCode: 588849,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76834,
        lat: 49.25977,
        long: 17.169012
    },
    {
        town: "P\xe1le\u010D",
        townCode: 564192,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27371,
        lat: 50.312029,
        long: 14.049685
    },
    {
        town: 'Palkovice',
        townCode: 598551,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73941,
        lat: 49.63477,
        long: 18.315185
    },
    {
        town: "Palon\xedn",
        townCode: 540595,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78983,
        lat: 49.729051,
        long: 16.952733
    },
    {
        town: "P\xe1lovice",
        townCode: 550469,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.00562,
        long: 15.537655
    },
    {
        town: "Pam\u011Btice",
        townCode: 582191,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.549563,
        long: 16.644594
    },
    {
        town: "Panensk\xe1 Rozs\xed\u010Dka",
        townCode: 587656,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58901,
        lat: 49.252661,
        long: 15.515001
    },
    {
        town: "Panensk\xe9 B\u0159e\u017Eany",
        townCode: 538604,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25070,
        lat: 50.213867,
        long: 14.44021
    },
    {
        town: "Panensk\xfd T\xfdnec",
        townCode: 566535,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43905,
        lat: 50.295028,
        long: 13.917056
    },
    {
        town: "Pano\u0161\xed \xdajezd",
        townCode: 542211,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27021,
        lat: 50.036103,
        long: 13.716918
    },
    {
        town: "Pansk\xe9 Dubenky",
        townCode: 587672,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 37853,
        lat: 49.219628,
        long: 15.265918
    },
    {
        town: "Para\u010Dov",
        townCode: 551571,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.201136,
        long: 13.994739
    },
    {
        town: 'Pardubice',
        townCode: 555134,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.034409,
        long: 15.781299
    },
    {
        town: "Par\u0161ovice",
        townCode: 516635,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75355,
        lat: 49.50123,
        long: 17.708077
    },
    {
        town: 'Partutovice',
        townCode: 516686,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.631419,
        long: 17.708201
    },
    {
        town: "Pa\u0159ezov",
        townCode: 599182,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.470477,
        long: 12.83793
    },
    {
        town: "Pase\u010Dnice",
        townCode: 554081,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.395458,
        long: 12.893516
    },
    {
        town: 'Paseka',
        townCode: 504785,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78397,
        lat: 49.796542,
        long: 17.222863
    },
    {
        town: 'Paseky',
        townCode: 562254,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39811,
        lat: 49.25174,
        long: 14.254921
    },
    {
        town: 'Paseky nad Jizerou',
        townCode: 547476,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51247,
        lat: 50.724065,
        long: 15.400555
    },
    {
        town: 'Paskov',
        townCode: 598569,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73921,
        lat: 49.731885,
        long: 18.290478
    },
    {
        town: "Pasohl\xe1vky",
        townCode: 584762,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69122,
        lat: 48.90306,
        long: 16.543748
    },
    {
        town: 'Pastuchovice',
        townCode: 566781,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33165,
        lat: 50.069086,
        long: 13.382322
    },
    {
        town: 'Pastviny',
        townCode: 580759,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.094975,
        long: 16.566309
    },
    {
        town: "Pa\u0161inka",
        townCode: 513423,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.996452,
        long: 15.186297
    },
    {
        town: "Pa\u0161ovice",
        townCode: 592480,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68756,
        lat: 49.07963,
        long: 17.644446
    },
    {
        town: "P\xe1tek",
        townCode: 537632,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.165617,
        long: 15.158562
    },
    {
        town: 'Patokryje',
        townCode: 567345,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.499915,
        long: 13.705297
    },
    {
        town: 'Pavlice',
        townCode: 594601,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67156,
        lat: 48.971577,
        long: 15.899056
    },
    {
        town: "Pavl\xedkov",
        townCode: 544248,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27021,
        lat: 50.056094,
        long: 13.73647
    },
    {
        town: "Pavl\xednov",
        townCode: 596388,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.348216,
        long: 15.878564
    },
    {
        town: 'Pavlov',
        townCode: 584771,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69201,
        lat: 48.874256,
        long: 16.672359
    },
    {
        town: 'Pavlov',
        townCode: 569241,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.699317,
        long: 15.332621
    },
    {
        town: 'Pavlov',
        townCode: 587681,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.242892,
        long: 15.55721
    },
    {
        town: 'Pavlov',
        townCode: 561916,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.398772,
        long: 15.244081
    },
    {
        town: 'Pavlov',
        townCode: 596396,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.450847,
        long: 15.913945
    },
    {
        town: 'Pavlov',
        townCode: 540609,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78985,
        lat: 49.74289,
        long: 16.879352
    },
    {
        town: 'Pavlov',
        townCode: 532711,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.096481,
        long: 14.167154
    },
    {
        town: 'Pavlovice',
        townCode: 533076,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.715216,
        long: 14.933216
    },
    {
        town: "Pavlovice u Kojet\xedna",
        townCode: 557196,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79830,
        lat: 49.302054,
        long: 17.212617
    },
    {
        town: "Pavlovice u P\u0159erova",
        townCode: 516694,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.46952,
        long: 17.547853
    },
    {
        town: 'Pazderna',
        townCode: 552500,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.704374,
        long: 18.434339
    },
    {
        town: 'Pec',
        townCode: 554090,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.398684,
        long: 12.831288
    },
    {
        town: "Pec pod Sn\u011B\u017Ekou",
        townCode: 579581,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54221,
        lat: 50.693981,
        long: 15.733267
    },
    {
        town: 'Pecka',
        townCode: 573299,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50782,
        lat: 50.480435,
        long: 15.608329
    },
    {
        town: "Pe\u010D",
        townCode: 507717,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.057931,
        long: 15.392475
    },
    {
        town: "Pe\u010Dice",
        townCode: 541028,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26232,
        lat: 49.600518,
        long: 14.105591
    },
    {
        town: "P\u011B\u010Dice",
        townCode: 571032,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29446,
        lat: 50.35125,
        long: 15.004099
    },
    {
        town: "P\u011B\u010D\xedn",
        townCode: 576620,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51757,
        lat: 50.153878,
        long: 16.424789
    },
    {
        town: "Pe\u010Dky",
        townCode: 537641,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.090527,
        long: 15.030275
    },
    {
        town: "P\u011B\u010Dnov",
        townCode: 537543,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.053207,
        long: 13.942131
    },
    {
        town: 'Pelechy',
        townCode: 566373,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.389227,
        long: 12.914379
    },
    {
        town: "Pelh\u0159imov",
        townCode: 547492,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.430721,
        long: 15.223083
    },
    {
        town: "P\u011Bn\u010D\xedn",
        townCode: 563749,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46821,
        lat: 50.687791,
        long: 15.236038
    },
    {
        town: "P\u011Bn\u010D\xedn",
        townCode: 564303,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.594968,
        long: 15.076196
    },
    {
        town: "P\u011Bn\u010D\xedn",
        townCode: 589870,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79857,
        lat: 49.567294,
        long: 17.013234
    },
    {
        town: "Per\xe1lec",
        townCode: 572004,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.826885,
        long: 16.079952
    },
    {
        town: "Pern\xe1",
        townCode: 584789,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69186,
        lat: 48.85232,
        long: 16.624527
    },
    {
        town: 'Pernarec',
        townCode: 559334,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33036,
        lat: 49.840507,
        long: 13.102822
    },
    {
        town: 'Pernink',
        townCode: 555452,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36236,
        lat: 50.365797,
        long: 12.783825
    },
    {
        town: "Pern\u0161tejnsk\xe9 Jest\u0159ab\xed",
        townCode: 596400,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59261,
        lat: 49.406417,
        long: 16.32571
    },
    {
        town: "Per\u0161tejn",
        townCode: 563285,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43163,
        lat: 50.381769,
        long: 13.110315
    },
    {
        town: 'Pertoltice',
        townCode: 564311,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46373,
        lat: 50.979084,
        long: 15.076532
    },
    {
        town: 'Pertoltice',
        townCode: 534307,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.75491,
        long: 15.181716
    },
    {
        town: 'Pertoltice pod Ralskem',
        townCode: 514276,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47124,
        lat: 50.680046,
        long: 14.719254
    },
    {
        town: 'Peruc',
        townCode: 566551,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43907,
        lat: 50.342609,
        long: 13.959969
    },
    {
        town: "Pe\u0159imov",
        townCode: 577391,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51204,
        lat: 50.619384,
        long: 15.44404
    },
    {
        town: 'Pesvice',
        townCode: 546062,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43111,
        lat: 50.463315,
        long: 13.484983
    },
    {
        town: "P\u011Btihosty",
        townCode: 529656,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25167,
        lat: 49.886462,
        long: 14.705522
    },
    {
        town: "P\u011Btikozly",
        townCode: 598241,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29430,
        lat: 50.411512,
        long: 14.811952
    },
    {
        town: "P\u011Btipsy",
        townCode: 563293,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43153,
        lat: 50.321219,
        long: 13.349824
    },
    {
        town: 'Petkovy',
        townCode: 536431,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.413286,
        long: 15.076925
    },
    {
        town: "Petr\xe1ve\u010D",
        townCode: 596418,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.327579,
        long: 16.041249
    },
    {
        town: 'Petrohrad',
        townCode: 566560,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43985,
        lat: 50.127625,
        long: 13.446526
    },
    {
        town: 'Petroupim',
        townCode: 530409,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.808356,
        long: 14.752698
    },
    {
        town: 'Petrov',
        townCode: 582204,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.533771,
        long: 16.489694
    },
    {
        town: 'Petrov',
        townCode: 586480,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69665,
        lat: 48.882055,
        long: 17.278203
    },
    {
        town: 'Petrov',
        townCode: 539546,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25281,
        lat: 49.886498,
        long: 14.433839
    },
    {
        town: 'Petrov nad Desnou',
        townCode: 500020,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78816,
        lat: 50.005536,
        long: 17.04438
    },
    {
        town: 'Petrovice',
        townCode: 582212,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.411964,
        long: 16.69985
    },
    {
        town: 'Petrovice',
        townCode: 594610,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.006837,
        long: 16.292563
    },
    {
        town: 'Petrovice',
        townCode: 591360,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.241283,
        long: 15.78769
    },
    {
        town: 'Petrovice',
        townCode: 570567,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50355,
        lat: 50.289854,
        long: 15.598601
    },
    {
        town: 'Petrovice',
        townCode: 551848,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79384,
        lat: 50.239024,
        long: 17.448488
    },
    {
        town: 'Petrovice',
        townCode: 580767,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.988215,
        long: 16.541627
    },
    {
        town: 'Petrovice',
        townCode: 541044,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26255,
        lat: 49.554366,
        long: 14.337472
    },
    {
        town: 'Petrovice',
        townCode: 542229,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.067363,
        long: 13.63928
    },
    {
        town: 'Petrovice',
        townCode: 568147,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40337,
        lat: 50.789131,
        long: 13.976255
    },
    {
        town: 'Petrovice I',
        townCode: 534315,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.811063,
        long: 15.297295
    },
    {
        town: 'Petrovice II',
        townCode: 534323,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.81004,
        long: 15.063514
    },
    {
        town: "Petrovice u Karvin\xe9",
        townCode: 599077,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73572,
        lat: 49.895965,
        long: 18.547898
    },
    {
        town: "Petrovice u Su\u0161ice",
        townCode: 556921,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.218758,
        long: 13.440898
    },
    {
        town: "Petrovi\u010Dky",
        townCode: 548871,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.299084,
        long: 15.607452
    },
    {
        town: "Petr\u016Fvka",
        townCode: 556874,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.105005,
        long: 17.810083
    },
    {
        town: "Petr\u016Fvky",
        townCode: 591378,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.159311,
        long: 15.902416
    },
    {
        town: "Pet\u0159\xedkov",
        townCode: 535699,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.847072,
        long: 14.754708
    },
    {
        town: "Pet\u0159\xedkov",
        townCode: 538612,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25169,
        lat: 49.925301,
        long: 14.617066
    },
    {
        town: "Pet\u0159vald",
        townCode: 599085,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73541,
        lat: 49.831096,
        long: 18.389513
    },
    {
        town: "Pet\u0159vald",
        townCode: 599743,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74260,
        lat: 49.707197,
        long: 18.15153
    },
    {
        town: 'Pchery',
        townCode: 532720,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27308,
        lat: 50.193882,
        long: 14.117927
    },
    {
        town: "Pi\u010D\xedn",
        townCode: 541052,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26225,
        lat: 49.745546,
        long: 14.057909
    },
    {
        town: "Pik\xe1rec",
        townCode: 549916,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59253,
        lat: 49.432505,
        long: 16.122491
    },
    {
        town: 'Pila',
        townCode: 556947,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.179793,
        long: 12.925973
    },
    {
        town: "Piln\xedkov",
        townCode: 579599,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54242,
        lat: 50.532571,
        long: 15.820303
    },
    {
        town: "P\xedsa\u0159ov",
        townCode: 540650,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78991,
        lat: 50.005065,
        long: 16.801608
    },
    {
        town: "P\xedse\u010Dn\xe1",
        townCode: 557226,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73991,
        lat: 49.57477,
        long: 18.787469
    },
    {
        town: "P\xedse\u010Dn\xe1",
        townCode: 540684,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79082,
        lat: 50.273123,
        long: 17.253835
    },
    {
        town: "P\xedse\u010Dn\xe1",
        townCode: 580775,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56170,
        lat: 50.045242,
        long: 16.448156
    },
    {
        town: "P\xedse\u010Dn\xe9",
        townCode: 546917,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37872,
        lat: 48.965043,
        long: 15.462488
    },
    {
        town: "P\xedse\u010Dn\xe9",
        townCode: 596434,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.568007,
        long: 16.23676
    },
    {
        town: "P\xedsek",
        townCode: 549240,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.303554,
        long: 14.158129
    },
    {
        town: "P\xedsek",
        townCode: 570575,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.15553,
        long: 15.501834
    },
    {
        town: "P\xedsek",
        townCode: 512028,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73984,
        lat: 49.55934,
        long: 18.80242
    },
    {
        town: "P\xedskov\xe1 Lhota",
        townCode: 536440,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29431,
        lat: 50.367841,
        long: 14.874736
    },
    {
        town: "P\xedskov\xe1 Lhota",
        townCode: 537659,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.131421,
        long: 15.065865
    },
    {
        town: "P\xedstina",
        townCode: 561070,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.049781,
        long: 14.901411
    },
    {
        town: "P\xedsty",
        townCode: 537667,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28913,
        lat: 50.164646,
        long: 15.001364
    },
    {
        town: "P\xed\u0161\u0165",
        townCode: 548545,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.601839,
        long: 15.203524
    },
    {
        town: "P\xed\u0161\u0165",
        townCode: 509647,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74718,
        lat: 49.978666,
        long: 18.193601
    },
    {
        town: "P\xed\u0161\u0165any",
        townCode: 542539,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41101,
        lat: 50.519327,
        long: 14.069206
    },
    {
        town: "Pi\u0161t\xedn",
        townCode: 535991,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37346,
        lat: 49.045975,
        long: 14.335259
    },
    {
        town: "Pit\xedn",
        townCode: 592498,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68771,
        lat: 49.038403,
        long: 17.850785
    },
    {
        town: "Piv\xedn",
        townCode: 589888,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79824,
        lat: 49.384785,
        long: 17.184933
    },
    {
        town: 'Pivkovice',
        townCode: 598887,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.177594,
        long: 14.069728
    },
    {
        town: "Plan\xe1",
        townCode: 535176,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.943775,
        long: 14.452868
    },
    {
        town: "Plan\xe1",
        townCode: 561134,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.868267,
        long: 12.743897
    },
    {
        town: "Plan\xe1 nad Lu\u017Enic\xed",
        townCode: 552828,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39111,
        lat: 49.354541,
        long: 14.701577
    },
    {
        town: "Pla\u0148any",
        townCode: 533581,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28104,
        lat: 50.050204,
        long: 15.029546
    },
    {
        town: 'Plandry',
        townCode: 587702,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58841,
        lat: 49.42009,
        long: 15.53837
    },
    {
        town: "Pl\xe1n\u011B",
        townCode: 530336,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33101,
        lat: 49.9338,
        long: 13.389711
    },
    {
        town: "Pl\xe1nice",
        townCode: 556955,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34034,
        lat: 49.390036,
        long: 13.471166
    },
    {
        town: 'Plasy',
        townCode: 559351,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33101,
        lat: 49.934598,
        long: 13.390465
    },
    {
        town: 'Plav',
        townCode: 535346,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.901535,
        long: 14.487974
    },
    {
        town: "Plave\u010D",
        townCode: 594628,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67132,
        lat: 48.928863,
        long: 16.080106
    },
    {
        town: 'Plavsko',
        townCode: 509078,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.084695,
        long: 14.904124
    },
    {
        town: 'Plavy',
        townCode: 563757,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46846,
        lat: 50.703338,
        long: 15.317471
    },
    {
        town: 'Plazy',
        townCode: 536458,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.414136,
        long: 14.975134
    },
    {
        town: 'Plenkovice',
        townCode: 550051,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67151,
        lat: 48.919012,
        long: 16.002555
    },
    {
        town: "Plesn\xe1",
        townCode: 554740,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35135,
        lat: 50.220815,
        long: 12.34681
    },
    {
        town: "Ple\u0161e",
        townCode: 507628,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.195629,
        long: 14.821465
    },
    {
        town: "Ple\u0161nice",
        townCode: 559369,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.774084,
        long: 13.17685
    },
    {
        town: "Pleten\xfd \xdajezd",
        townCode: 532738,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.109433,
        long: 14.116178
    },
    {
        town: 'Plch',
        townCode: 572942,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.12887,
        long: 15.70284
    },
    {
        town: 'Plchov',
        townCode: 564125,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27375,
        lat: 50.255276,
        long: 13.986724
    },
    {
        town: 'Plchovice',
        townCode: 580783,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.045181,
        long: 16.181298
    },
    {
        town: "Pl\xedskov",
        townCode: 566861,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.842744,
        long: 13.739921
    },
    {
        town: 'Ploskovice',
        townCode: 565393,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41142,
        lat: 50.56034,
        long: 14.198588
    },
    {
        town: "Pluh\u016Fv \u017D\u010F\xe1r",
        townCode: 546968,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.223995,
        long: 14.892803
    },
    {
        town: 'Plumlov',
        townCode: 589896,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.466236,
        long: 17.015122
    },
    {
        town: "Plu\u017En\xe1",
        townCode: 565580,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29423,
        lat: 50.473807,
        long: 14.804269
    },
    {
        town: "PLZE\u0147",
        townCode: 554791,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 30100,
        lat: 49.738531,
        long: 13.373737
    },
    {
        town: "Pn\u011Btluky",
        townCode: 566578,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.250358,
        long: 13.703895
    },
    {
        town: "P\u0148ovany",
        townCode: 559377,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.778992,
        long: 13.121864
    },
    {
        town: "P\u0148ovice",
        townCode: 552160,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78401,
        lat: 49.721386,
        long: 17.161923
    },
    {
        town: "P\u0148ov-P\u0159edhrad\xed",
        townCode: 537675,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28941,
        lat: 50.086521,
        long: 15.147597
    },
    {
        town: "Pob\u011B\u017Eovice",
        townCode: 554111,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.510406,
        long: 12.802721
    },
    {
        town: "Pob\u011B\u017Eovice u Holic",
        townCode: 575461,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.097655,
        long: 16.000768
    },
    {
        town: "Pob\u011B\u017Eovice u P\u0159elou\u010De",
        townCode: 575470,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.991102,
        long: 15.581991
    },
    {
        town: 'Pocinovice',
        townCode: 554120,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34509,
        lat: 49.343523,
        long: 13.133597
    },
    {
        town: "Po\u010Daply",
        townCode: 564214,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.538772,
        long: 13.983561
    },
    {
        town: "Po\u010D\xe1tky",
        townCode: 548561,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39464,
        lat: 49.260301,
        long: 15.240324
    },
    {
        town: "Po\u010Ded\u011Blice",
        townCode: 566586,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.371926,
        long: 13.887909
    },
    {
        town: "Po\u010Denice-Tet\u011Btice",
        townCode: 588865,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.271262,
        long: 17.228235
    },
    {
        town: "Po\u010Depice",
        townCode: 541087,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26255,
        lat: 49.596115,
        long: 14.380945
    },
    {
        town: "Po\u010D\xedtky",
        townCode: 596442,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.588779,
        long: 15.971975
    },
    {
        town: "Podbo\u0159ansk\xfd Rohozec",
        townCode: 566608,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44101,
        lat: 50.216536,
        long: 13.262884
    },
    {
        town: "Podbo\u0159any",
        townCode: 566616,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44101,
        lat: 50.229475,
        long: 13.41203
    },
    {
        town: 'Podbrdy',
        townCode: 534285,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.863079,
        long: 14.126698
    },
    {
        town: "Podb\u0159ez\xed",
        townCode: 576654,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51803,
        lat: 50.259989,
        long: 16.214851
    },
    {
        town: "Podb\u0159e\u017Eice",
        townCode: 550795,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.212563,
        long: 16.928192
    },
    {
        town: "Pod\u011Bbrady",
        townCode: 537683,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.142525,
        long: 15.118988
    },
    {
        town: "Pod\u011B\u0161\xedn",
        townCode: 596451,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.507768,
        long: 15.800993
    },
    {
        town: "Pod\u011Bvousy",
        townCode: 566365,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.527617,
        long: 13.131214
    },
    {
        town: "Podhorn\xed \xdajezd a Vojice",
        townCode: 573311,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50754,
        lat: 50.390156,
        long: 15.514528
    },
    {
        town: "Podho\u0159any u Ronova",
        townCode: 572039,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53841,
        lat: 49.936237,
        long: 15.536819
    },
    {
        town: "Podhrad\xed",
        townCode: 538817,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35201,
        lat: 50.255461,
        long: 12.201857
    },
    {
        town: "Podhrad\xed",
        townCode: 573329,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.418572,
        long: 15.310632
    },
    {
        town: "Podhrad\xed",
        townCode: 534811,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76326,
        lat: 49.140048,
        long: 17.77407
    },
    {
        town: "Podhrad\xed nad Dyj\xed",
        townCode: 594636,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.900345,
        long: 15.686517
    },
    {
        town: "Podhradn\xed Lhota",
        townCode: 588873,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76871,
        lat: 49.420849,
        long: 17.79516
    },
    {
        town: 'Podivice',
        townCode: 593486,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68321,
        lat: 49.365845,
        long: 17.010822
    },
    {
        town: "Podiv\xedn",
        townCode: 584797,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69145,
        lat: 48.82564,
        long: 16.848324
    },
    {
        town: "Podkopn\xe1 Lhota",
        townCode: 585611,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76318,
        lat: 49.305859,
        long: 17.831511
    },
    {
        town: "Podles\xed",
        townCode: 580805,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 50.020296,
        long: 16.281063
    },
    {
        town: "Podles\xed",
        townCode: 564486,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.690395,
        long: 13.981947
    },
    {
        town: "Podle\u0161\xedn",
        townCode: 532754,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27325,
        lat: 50.221126,
        long: 14.160368
    },
    {
        town: 'Podluhy',
        townCode: 531685,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.815724,
        long: 13.91363
    },
    {
        town: 'Podmoklany',
        townCode: 548634,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58264,
        lat: 49.721628,
        long: 15.767847
    },
    {
        town: 'Podmokly',
        townCode: 551686,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.230189,
        long: 13.578261
    },
    {
        town: 'Podmokly',
        townCode: 560081,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.943339,
        long: 13.704478
    },
    {
        town: 'Podmoky',
        townCode: 548251,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.830381,
        long: 15.439055
    },
    {
        town: 'Podmoky',
        townCode: 599590,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28904,
        lat: 50.191564,
        long: 15.232291
    },
    {
        town: "Podmol\xed",
        townCode: 594644,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.850738,
        long: 15.940168
    },
    {
        town: "Podmy\u010De",
        townCode: 594652,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.887701,
        long: 15.782341
    },
    {
        town: 'Podolanka',
        townCode: 538621,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25073,
        lat: 50.159219,
        long: 14.601033
    },
    {
        town: "Podol\xed",
        townCode: 583634,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66403,
        lat: 49.190524,
        long: 16.72095
    },
    {
        town: "Podol\xed",
        townCode: 596469,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.48436,
        long: 16.080553
    },
    {
        town: "Podol\xed",
        townCode: 516864,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75116,
        lat: 49.445465,
        long: 17.530335
    },
    {
        town: "Podol\xed",
        townCode: 592501,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68604,
        lat: 49.0409,
        long: 17.529564
    },
    {
        town: "Podol\xed",
        townCode: 569496,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75644,
        lat: 49.430358,
        long: 17.857251
    },
    {
        town: "Podol\xed I",
        townCode: 549754,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.361265,
        long: 14.312023
    },
    {
        town: "Podom\xed",
        townCode: 550175,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68304,
        lat: 49.344818,
        long: 16.833319
    },
    {
        town: 'Podsedice',
        townCode: 565415,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.472089,
        long: 13.948396
    },
    {
        town: "Pod\u016Fl\u0161any",
        townCode: 572951,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.128935,
        long: 15.738311
    },
    {
        town: "Pod\u016Fl\u0161\xed",
        townCode: 573345,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.469069,
        long: 15.340577
    },
    {
        town: 'Podveky',
        townCode: 528196,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.825146,
        long: 14.994103
    },
    {
        town: 'Pohled',
        townCode: 569291,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58221,
        lat: 49.606211,
        long: 15.648156
    },
    {
        town: "Pohle\u010F",
        townCode: 573591,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.603572,
        long: 15.648294
    },
    {
        town: 'Pohledy',
        townCode: 578550,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.695006,
        long: 16.560608
    },
    {
        town: "Pohn\xe1nec",
        townCode: 560553,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.473682,
        long: 14.802766
    },
    {
        town: "Pohn\xe1n\xed",
        townCode: 552852,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.477597,
        long: 14.811241
    },
    {
        town: 'Pohorovice',
        townCode: 536911,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.188696,
        long: 14.135183
    },
    {
        town: "Pohorsk\xe1 Ves",
        townCode: 545694,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38283,
        lat: 48.670025,
        long: 14.647748
    },
    {
        town: "Poho\u0159elice",
        townCode: 584801,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69123,
        lat: 48.981287,
        long: 16.524557
    },
    {
        town: "Poho\u0159elice",
        townCode: 549461,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76361,
        lat: 49.176665,
        long: 17.537954
    },
    {
        town: "Poho\u0159\xed",
        townCode: 576662,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.292257,
        long: 16.09906
    },
    {
        town: "Poho\u0159\xed",
        townCode: 539562,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25401,
        lat: 49.900021,
        long: 14.525125
    },
    {
        town: 'Pochvalov',
        townCode: 542237,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27055,
        lat: 50.227542,
        long: 13.794371
    },
    {
        town: 'Pojbuky',
        townCode: 552861,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.495907,
        long: 14.896833
    },
    {
        town: 'Pokojov',
        townCode: 596477,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.481732,
        long: 15.906642
    },
    {
        town: 'Pokojovice',
        townCode: 550370,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.219742,
        long: 15.742458
    },
    {
        town: "Pok\u0159ikov",
        townCode: 572063,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.79687,
        long: 15.988264
    },
    {
        town: "Pol\xe1nka",
        townCode: 553565,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.435798,
        long: 13.555643
    },
    {
        town: "Pole\u0148",
        townCode: 541788,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.425079,
        long: 13.176854
    },
    {
        town: 'Polepy',
        townCode: 533599,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.004771,
        long: 15.206086
    },
    {
        town: 'Polepy',
        townCode: 565431,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41147,
        lat: 50.50573,
        long: 14.264579
    },
    {
        town: 'Polerady',
        townCode: 538639,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.200671,
        long: 14.593492
    },
    {
        town: 'Polerady',
        townCode: 567353,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.444544,
        long: 13.652795
    },
    {
        town: "Poles\xed",
        townCode: 561436,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39468,
        lat: 49.293206,
        long: 15.246599
    },
    {
        town: "Pole\u0161ovice",
        townCode: 592510,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68737,
        lat: 49.033999,
        long: 17.340746
    },
    {
        town: 'Polevsko',
        townCode: 561959,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47116,
        lat: 50.786771,
        long: 14.533028
    },
    {
        town: 'Police',
        townCode: 591394,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67534,
        lat: 49.21454,
        long: 15.883581
    },
    {
        town: 'Police',
        townCode: 540731,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78973,
        lat: 49.814846,
        long: 16.996381
    },
    {
        town: 'Police',
        townCode: 544621,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75644,
        lat: 49.45682,
        long: 17.867653
    },
    {
        town: "Police nad Metuj\xed",
        townCode: 574341,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54954,
        lat: 50.536968,
        long: 16.23361
    },
    {
        town: "Poli\u010Dka",
        townCode: 578576,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.715034,
        long: 16.265977
    },
    {
        town: "Poli\u010Dn\xe1",
        townCode: 500071,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75701,
        lat: 49.467058,
        long: 17.943924
    },
    {
        town: 'Polkovice',
        townCode: 516899,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75144,
        lat: 49.39183,
        long: 17.259275
    },
    {
        town: "Poln\xe1",
        townCode: 587711,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.487099,
        long: 15.718914
    },
    {
        town: "Poln\xe1 na \u0160umav\u011B",
        townCode: 500194,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38226,
        lat: 48.805608,
        long: 14.131502
    },
    {
        town: "Poln\xed Chr\u010Dice",
        townCode: 513237,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.110106,
        long: 15.296802
    },
    {
        town: "Poln\xed Vod\u011Brady",
        townCode: 513148,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 49.992409,
        long: 15.095338
    },
    {
        town: "Polni\u010Dka",
        townCode: 596485,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59102,
        lat: 49.607595,
        long: 15.916439
    },
    {
        town: 'Polom',
        townCode: 548723,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.059088,
        long: 16.305976
    },
    {
        town: 'Polom',
        townCode: 516911,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75364,
        lat: 49.577179,
        long: 17.841791
    },
    {
        town: "Polom\xed",
        townCode: 549983,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79855,
        lat: 49.631541,
        long: 16.949496
    },
    {
        town: "Pol\u0161t\u011B",
        townCode: 562459,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.106486,
        long: 14.927954
    },
    {
        town: "Pomez\xed",
        townCode: 578584,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56971,
        lat: 49.710361,
        long: 16.317396
    },
    {
        town: "Pomez\xed nad Oh\u0159\xed",
        townCode: 538868,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.086208,
        long: 12.279652
    },
    {
        town: "Pon\u011Bdra\u017E",
        townCode: 562670,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.116075,
        long: 14.702066
    },
    {
        town: "Pon\u011Bdr\xe1\u017Eka",
        townCode: 562653,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.136634,
        long: 14.703419
    },
    {
        town: "Pon\u011Btovice",
        townCode: 549738,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66451,
        lat: 49.152257,
        long: 16.742391
    },
    {
        town: "Ponikl\xe1",
        townCode: 577405,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51242,
        lat: 50.661618,
        long: 15.463395
    },
    {
        town: "Popel\xedn",
        townCode: 546992,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37855,
        lat: 49.213683,
        long: 15.184019
    },
    {
        town: 'Popice',
        townCode: 584819,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69127,
        lat: 48.927358,
        long: 16.66701
    },
    {
        town: 'Popovice',
        townCode: 583651,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.107197,
        long: 16.616203
    },
    {
        town: 'Popovice',
        townCode: 532649,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25701,
        lat: 49.695492,
        long: 14.75256
    },
    {
        town: 'Popovice',
        townCode: 592528,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68604,
        lat: 49.052651,
        long: 17.527232
    },
    {
        town: "Popovi\u010Dky",
        townCode: 599221,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.962644,
        long: 14.597904
    },
    {
        town: "Pop\u016Fvky",
        townCode: 583669,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66441,
        lat: 49.177467,
        long: 16.487676
    },
    {
        town: "Pop\u016Fvky",
        townCode: 591408,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67575,
        lat: 49.159171,
        long: 16.127493
    },
    {
        town: "Po\u0159\xed\u010Dany",
        townCode: 537705,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28914,
        lat: 50.108165,
        long: 14.918285
    },
    {
        town: "Po\u0159\xed\u010D\xed nad S\xe1zavou",
        townCode: 530441,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25721,
        lat: 49.839058,
        long: 14.674564
    },
    {
        town: "Po\u0159\xed\u010D\xed u Litomy\u0161le",
        townCode: 572373,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.798443,
        long: 16.193901
    },
    {
        town: 'Postoloprty',
        townCode: 566624,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43942,
        lat: 50.359895,
        long: 13.70302
    },
    {
        town: "Post\u0159ekov",
        townCode: 554138,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34535,
        lat: 49.458386,
        long: 12.806891
    },
    {
        town: "Post\u0159elmov",
        townCode: 540773,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78969,
        lat: 49.907661,
        long: 16.912368
    },
    {
        town: "Post\u0159elm\u016Fvek",
        townCode: 553352,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.922722,
        long: 16.879208
    },
    {
        town: "Post\u0159i\u017E\xedn",
        townCode: 538647,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25070,
        lat: 50.233091,
        long: 14.386813
    },
    {
        town: 'Postupice',
        townCode: 530450,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25701,
        lat: 49.728144,
        long: 14.777499
    },
    {
        town: "Po\u0161n\xe1",
        townCode: 548600,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.458874,
        long: 15.042352
    },
    {
        town: "Po\u0161tovice",
        townCode: 564087,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27372,
        lat: 50.312793,
        long: 14.137949
    },
    {
        town: "Pote\u010D",
        townCode: 549533,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76601,
        lat: 49.154482,
        long: 18.035541
    },
    {
        town: "Pot\u011Bhy",
        townCode: 534331,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28563,
        lat: 49.86946,
        long: 15.4202
    },
    {
        town: "Pot\u0161t\xe1t",
        townCode: 517101,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75362,
        lat: 49.637025,
        long: 17.651843
    },
    {
        town: "Pot\u0161tejn",
        townCode: 576671,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51743,
        lat: 50.082189,
        long: 16.309021
    },
    {
        town: "Pot\u016F\u010Dky",
        townCode: 555479,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36235,
        lat: 50.428273,
        long: 12.736597
    },
    {
        town: 'Potvorov',
        townCode: 530247,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 50.016105,
        long: 13.399461
    },
    {
        town: 'Poustka',
        townCode: 577979,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.140272,
        long: 12.298291
    },
    {
        town: "Pouzd\u0159any",
        townCode: 584835,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69126,
        lat: 48.934526,
        long: 16.624973
    },
    {
        town: 'Povrly',
        townCode: 568155,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40332,
        lat: 50.672866,
        long: 14.160445
    },
    {
        town: "Poz\u010Fat\xedn",
        townCode: 591416,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.235855,
        long: 16.037952
    },
    {
        town: "Pozd\u011Bchov",
        townCode: 544655,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.233333,
        long: 17.955546
    },
    {
        town: "Pozde\u0148",
        townCode: 532762,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27376,
        lat: 50.242157,
        long: 13.943656
    },
    {
        town: 'Pozlovice',
        townCode: 549401,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76326,
        lat: 49.129313,
        long: 17.769364
    },
    {
        town: "Pozo\u0159ice",
        townCode: 583677,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66407,
        lat: 49.209864,
        long: 16.790847
    },
    {
        town: 'Prace',
        townCode: 583685,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66458,
        lat: 49.141161,
        long: 16.765498
    },
    {
        town: 'Pracejovice',
        townCode: 551619,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.257287,
        long: 13.849231
    },
    {
        town: 'Prackovice nad Labem',
        townCode: 565458,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41133,
        lat: 50.569522,
        long: 14.032075
    },
    {
        town: "Pr\xe1\u010De",
        townCode: 594679,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.877137,
        long: 16.201279
    },
    {
        town: "Pr\xe1dlo",
        townCode: 558231,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.503547,
        long: 13.541553
    },
    {
        town: 'Praha',
        townCode: 554782,
        district: 'Praha',
        lau: 'CZ0100',
        region: "Hlavn\xed m\u011Bsto Praha",
        nuts: 'CZ010',
        zip: 11000,
        lat: 50.075638,
        long: 14.4379
    },
    {
        town: 'Prachatice',
        townCode: 550094,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.01101,
        long: 14.0001
    },
    {
        town: 'Prachovice',
        townCode: 572071,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53804,
        lat: 49.893895,
        long: 15.628821
    },
    {
        town: "Prak\u0161ice",
        townCode: 592536,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68756,
        lat: 49.069003,
        long: 17.633144
    },
    {
        town: 'Prameny',
        townCode: 539538,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 50.050184,
        long: 12.732909
    },
    {
        town: 'Prasek',
        townCode: 570648,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.238775,
        long: 15.548695
    },
    {
        town: "Praska\u010Dka",
        townCode: 570656,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50333,
        lat: 50.17297,
        long: 15.742802
    },
    {
        town: 'Prasklice',
        townCode: 587397,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.268795,
        long: 17.186821
    },
    {
        town: 'Praskolesy',
        townCode: 531693,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26754,
        lat: 49.865986,
        long: 13.933537
    },
    {
        town: "Pr\xe1\u0161ily",
        townCode: 556084,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.10524,
        long: 13.378047
    },
    {
        town: "Prav\u010Dice",
        townCode: 588890,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76824,
        lat: 49.324587,
        long: 17.495591
    },
    {
        town: 'Pravice',
        townCode: 594687,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.843456,
        long: 16.361153
    },
    {
        town: 'Pravlov',
        townCode: 583693,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.055779,
        long: 16.487786
    },
    {
        town: "Pravon\xedn",
        townCode: 530476,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25709,
        lat: 49.635687,
        long: 14.943477
    },
    {
        town: 'Pravy',
        townCode: 572853,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.131879,
        long: 15.624255
    },
    {
        town: "Pra\u017Emo",
        townCode: 568813,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73904,
        lat: 49.608863,
        long: 18.48628
    },
    {
        town: 'Prlov',
        townCode: 544671,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.248001,
        long: 17.961456
    },
    {
        town: "Probo\u0161tov",
        townCode: 567787,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41712,
        lat: 50.667833,
        long: 13.836123
    },
    {
        town: 'Probulov',
        townCode: 561509,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.492895,
        long: 14.145234
    },
    {
        town: "Proda\u0161ice",
        townCode: 570753,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.350064,
        long: 15.116768
    },
    {
        town: 'Prokopov',
        townCode: 594695,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67154,
        lat: 48.998438,
        long: 15.896085
    },
    {
        town: 'Proruby',
        townCode: 548758,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.070679,
        long: 16.295451
    },
    {
        town: "Prose\u010D",
        townCode: 537829,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.600804,
        long: 15.329186
    },
    {
        town: "Prose\u010D",
        townCode: 572080,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.805994,
        long: 16.11631
    },
    {
        town: "Prose\u010D pod Je\u0161t\u011Bdem",
        townCode: 544345,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46343,
        lat: 50.701762,
        long: 15.017139
    },
    {
        town: "Prose\u010D pod K\u0159eme\u0161n\xedkem",
        townCode: 561941,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.415347,
        long: 15.295046
    },
    {
        town: "Prose\u010Dn\xe9",
        townCode: 579602,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54373,
        lat: 50.562125,
        long: 15.687438
    },
    {
        town: 'Prosenice',
        townCode: 517151,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75121,
        lat: 49.488904,
        long: 17.484287
    },
    {
        town: "Prosenick\xe1 Lhota",
        townCode: 541133,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.689735,
        long: 14.482797
    },
    {
        town: "Proset\xedn",
        townCode: 596493,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59264,
        lat: 49.526397,
        long: 16.394946
    },
    {
        town: "Proset\xedn",
        townCode: 572098,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53976,
        lat: 49.833121,
        long: 15.957751
    },
    {
        town: "Pros\xed\u010Dka",
        townCode: 569313,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.724592,
        long: 15.323639
    },
    {
        town: "Prosim\u011B\u0159ice",
        townCode: 594709,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.902803,
        long: 16.192067
    },
    {
        town: "PROST\u011AJOV",
        townCode: 589250,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79601,
        lat: 49.472549,
        long: 17.106851
    },
    {
        town: "Prost\u011Bjovi\u010Dky",
        townCode: 589918,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.427632,
        long: 16.997349
    },
    {
        town: "Prostibo\u0159",
        townCode: 541486,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.652373,
        long: 12.89399
    },
    {
        town: "Prost\u0159edn\xed Be\u010Dva",
        townCode: 544698,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75656,
        lat: 49.436192,
        long: 18.252106
    },
    {
        town: "Prost\u0159edn\xed Po\u0159\xed\u010D\xed",
        townCode: 582221,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.572106,
        long: 16.497452
    },
    {
        town: 'Protivanov',
        townCode: 589926,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79848,
        lat: 49.483614,
        long: 16.836047
    },
    {
        town: "Protiv\xedn",
        townCode: 549771,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39811,
        lat: 49.199591,
        long: 14.217277
    },
    {
        town: "Provod\xedn",
        townCode: 561983,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47167,
        lat: 50.617925,
        long: 14.601372
    },
    {
        town: 'Provodov',
        townCode: 585661,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76345,
        lat: 49.160363,
        long: 17.736899
    },
    {
        town: 'Provodovice',
        townCode: 517208,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.451055,
        long: 17.768349
    },
    {
        town: "Provodov-\u0160onov",
        townCode: 574350,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54908,
        lat: 50.382206,
        long: 16.114965
    },
    {
        town: "Pr\u0161tice",
        townCode: 583707,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66446,
        lat: 49.115118,
        long: 16.470866
    },
    {
        town: "Pr\u016Fhonice",
        townCode: 539571,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25243,
        lat: 50.001815,
        long: 14.560406
    },
    {
        town: 'Prusice',
        townCode: 564788,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.968457,
        long: 14.877965
    },
    {
        town: 'Prusinovice',
        townCode: 588903,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76842,
        lat: 49.379083,
        long: 17.587212
    },
    {
        town: "Prusy-Bo\u0161k\u016Fvky",
        townCode: 593494,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.258521,
        long: 17.063799
    },
    {
        town: "Pru\u0161\xe1nky",
        townCode: 586498,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69621,
        lat: 48.828498,
        long: 16.980787
    },
    {
        town: 'Prysk',
        townCode: 561991,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47115,
        lat: 50.796139,
        long: 14.468026
    },
    {
        town: "Pr\u017Eno",
        townCode: 507181,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73911,
        lat: 49.613573,
        long: 18.361716
    },
    {
        town: "Pr\u017Eno",
        townCode: 544728,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75623,
        lat: 49.387569,
        long: 17.942957
    },
    {
        town: "P\u0159\xe1slavice",
        townCode: 552411,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78354,
        lat: 49.587462,
        long: 17.390548
    },
    {
        town: "P\u0159eborov",
        townCode: 561517,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.479579,
        long: 14.357241
    },
    {
        town: "P\u0159ebuz",
        townCode: 560596,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.36589,
        long: 12.620158
    },
    {
        town: "P\u0159eckov",
        townCode: 591424,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.275939,
        long: 15.9164
    },
    {
        town: "P\u0159edboj",
        townCode: 538655,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25072,
        lat: 50.225492,
        long: 14.476835
    },
    {
        town: "P\u0159edenice",
        townCode: 540412,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33209,
        lat: 49.624495,
        long: 13.396669
    },
    {
        town: "P\u0159edhrad\xed",
        townCode: 572101,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53974,
        lat: 49.831724,
        long: 16.038455
    },
    {
        town: "P\u0159ed\xedn",
        townCode: 591432,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67527,
        lat: 49.198388,
        long: 15.673827
    },
    {
        town: "P\u0159edkl\xe1\u0161te\u0159\xed",
        townCode: 549746,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66602,
        lat: 49.35263,
        long: 16.402512
    },
    {
        town: "P\u0159edm\u011B\u0159ice nad Jizerou",
        townCode: 536491,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29474,
        lat: 50.25558,
        long: 14.781377
    },
    {
        town: "P\u0159edm\u011B\u0159ice nad Labem",
        townCode: 570672,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50302,
        lat: 50.256426,
        long: 15.815669
    },
    {
        town: "P\u0159edm\xed\u0159",
        townCode: 551627,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38742,
        lat: 49.489369,
        long: 13.770472
    },
    {
        town: "P\u0159edn\xed V\xfdto\u0148",
        townCode: 545716,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38273,
        lat: 48.631244,
        long: 14.16459
    },
    {
        town: "P\u0159edn\xed Zborovice",
        townCode: 536792,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.218622,
        long: 13.892282
    },
    {
        town: "P\u0159edotice",
        townCode: 509621,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.365038,
        long: 14.053525
    },
    {
        town: "P\u0159edslav",
        townCode: 557005,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.447575,
        long: 13.354485
    },
    {
        town: "P\u0159edslavice",
        townCode: 551635,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.132138,
        long: 13.935156
    },
    {
        town: "P\u0159eho\u0159ov",
        townCode: 552895,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.247699,
        long: 14.756334
    },
    {
        town: "P\u0159ehvozd\xed",
        townCode: 513369,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 50.027508,
        long: 14.840073
    },
    {
        town: "P\u0159eh\xfd\u0161ov",
        townCode: 559393,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.702736,
        long: 13.126957
    },
    {
        town: "P\u0159echovice",
        townCode: 536547,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.179643,
        long: 13.894871
    },
    {
        town: "P\u0159el\xedc",
        townCode: 532771,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27305,
        lat: 50.20572,
        long: 14.045964
    },
    {
        town: "P\u0159elou\u010D",
        townCode: 575500,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.039948,
        long: 15.560413
    },
    {
        town: "P\u0159elovice",
        townCode: 575518,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.072887,
        long: 15.614899
    },
    {
        town: "P\u0159emyslovice",
        townCode: 589934,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79851,
        lat: 49.556472,
        long: 16.955914
    },
    {
        town: "P\u0159epe\u0159e",
        townCode: 577413,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51261,
        lat: 50.583032,
        long: 15.112901
    },
    {
        town: "P\u0159epe\u0159e",
        townCode: 570923,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.467724,
        long: 15.101992
    },
    {
        town: "P\u0159epychy",
        townCode: 576689,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51732,
        lat: 50.235959,
        long: 16.106634
    },
    {
        town: "P\u0159epychy",
        townCode: 575526,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.106455,
        long: 15.519991
    },
    {
        town: "P\u0158EROV",
        townCode: 511382,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.456579,
        long: 17.45033
    },
    {
        town: "P\u0159erov nad Labem",
        townCode: 537721,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28916,
        lat: 50.16037,
        long: 14.825129
    },
    {
        town: "P\u0159erubenice",
        townCode: 598577,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.217271,
        long: 13.841132
    },
    {
        town: "P\u0159eska\u010De",
        townCode: 550078,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 49.01253,
        long: 16.107001
    },
    {
        town: "P\u0159estanov",
        townCode: 530620,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40317,
        lat: 50.686777,
        long: 13.920379
    },
    {
        town: "P\u0159estavlky",
        townCode: 517224,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.390351,
        long: 17.481629
    },
    {
        town: "P\u0159estavlky",
        townCode: 572110,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.938074,
        long: 15.92634
    },
    {
        town: "P\u0159estavlky",
        townCode: 530131,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.59986,
        long: 13.244478
    },
    {
        town: "P\u0159estavlky",
        townCode: 565474,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.403615,
        long: 14.193965
    },
    {
        town: "P\u0159estavlky u \u010Cer\u010Dan",
        townCode: 530492,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25723,
        lat: 49.8531,
        long: 14.74423
    },
    {
        town: "P\u0159e\u0161ovice",
        townCode: 591441,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67557,
        lat: 49.050205,
        long: 16.061445
    },
    {
        town: "P\u0159e\u0161t\u011Bnice",
        townCode: 549797,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.479763,
        long: 14.42045
    },
    {
        town: "P\u0159e\u0161tice",
        townCode: 558249,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.573091,
        long: 13.333607
    },
    {
        town: "P\u0159e\u0161\u0165ovice",
        townCode: 551643,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.277278,
        long: 13.974442
    },
    {
        town: "P\u0159ev\xfd\u0161ov",
        townCode: 570681,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.151634,
        long: 15.410541
    },
    {
        town: "P\u0159ezletice",
        townCode: 538671,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25073,
        lat: 50.155303,
        long: 14.575506
    },
    {
        town: "P\u0159ibice",
        townCode: 584843,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69124,
        lat: 48.961724,
        long: 16.57344
    },
    {
        town: "P\u0159\xedbor",
        townCode: 599808,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74258,
        lat: 49.641036,
        long: 18.145096
    },
    {
        town: "P\u0159\xedbram",
        townCode: 539911,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.685532,
        long: 13.999045
    },
    {
        town: "P\u0159\xedbram na Morav\u011B",
        townCode: 583715,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.195583,
        long: 16.299175
    },
    {
        town: "P\u0159\xedbraz",
        townCode: 561088,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.051469,
        long: 14.937708
    },
    {
        town: "P\u0159ibyslav",
        townCode: 569321,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.576939,
        long: 15.73865
    },
    {
        town: "P\u0159ibyslav",
        townCode: 574368,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.373743,
        long: 16.16869
    },
    {
        town: "P\u0159ibyslavice",
        townCode: 583723,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.278696,
        long: 16.266436
    },
    {
        town: "P\u0159ibyslavice",
        townCode: 591459,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.260738,
        long: 15.778435
    },
    {
        town: "P\u0159\xed\u010Dina",
        townCode: 542253,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.065833,
        long: 13.667379
    },
    {
        town: "P\u0159\xed\u010Dovy",
        townCode: 513547,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.672874,
        long: 14.389683
    },
    {
        town: "P\u0159\xeddol\xed",
        townCode: 545724,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38101,
        lat: 48.781912,
        long: 14.35229
    },
    {
        town: "P\u0159\xedchovice",
        townCode: 558257,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.562138,
        long: 13.33946
    },
    {
        town: "P\u0159\xedkazy",
        townCode: 505013,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78333,
        lat: 49.642471,
        long: 17.148305
    },
    {
        town: "P\u0159\xedkosice",
        townCode: 579131,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.668377,
        long: 13.663557
    },
    {
        town: "P\u0159\xedkr\xfd",
        townCode: 577421,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.625029,
        long: 15.364623
    },
    {
        town: "P\u0159\xedlepy",
        townCode: 565261,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27001,
        lat: 50.123281,
        long: 13.632702
    },
    {
        town: "P\u0159\xedlepy",
        townCode: 549720,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.320079,
        long: 17.616021
    },
    {
        town: "P\u0159\xedluka",
        townCode: 578622,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.864971,
        long: 16.15664
    },
    {
        town: "P\u0159imda",
        townCode: 561151,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34806,
        lat: 49.674989,
        long: 12.673772
    },
    {
        town: "P\u0159\xedse\u010Dn\xe1",
        townCode: 545732,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38101,
        lat: 48.833173,
        long: 14.345507
    },
    {
        town: "P\u0159\xedseka",
        townCode: 569348,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.670936,
        long: 15.425737
    },
    {
        town: "P\u0159\xedsnotice",
        townCode: 583731,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66463,
        lat: 49.00323,
        long: 16.61361
    },
    {
        town: "P\u0159istoupim",
        townCode: 513393,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.054216,
        long: 14.878688
    },
    {
        town: "P\u0159i\u0161imasy",
        townCode: 533611,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.049615,
        long: 14.764
    },
    {
        town: "P\u0159\xed\u0161ov",
        townCode: 567086,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.811806,
        long: 13.304241
    },
    {
        town: "P\u0159\xed\u0161ovice",
        townCode: 564354,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46346,
        lat: 50.578232,
        long: 15.084005
    },
    {
        town: "P\u0159\xed\u0161tpo",
        townCode: 544752,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67551,
        lat: 49.073941,
        long: 15.935004
    },
    {
        town: "P\u0159\xedtluky",
        townCode: 584851,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69104,
        lat: 48.855089,
        long: 16.774055
    },
    {
        town: "P\u0159\xedv\u011Btice",
        townCode: 560111,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.834798,
        long: 13.612239
    },
    {
        town: "P\u0159\xedvrat",
        townCode: 580821,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56002,
        lat: 49.924704,
        long: 16.39707
    },
    {
        town: "Ps\xe1rov",
        townCode: 563374,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.319003,
        long: 14.905589
    },
    {
        town: "Ps\xe1ry",
        townCode: 539597,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25244,
        lat: 49.93632,
        long: 14.512867
    },
    {
        town: "Ps\xe1\u0159e",
        townCode: 530514,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.755783,
        long: 14.96193
    },
    {
        town: "Pstru\u017E\xed",
        townCode: 552577,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73911,
        lat: 49.564927,
        long: 18.347648
    },
    {
        town: "P\u0161\xe1nky",
        townCode: 530671,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.294187,
        long: 15.620991
    },
    {
        town: "P\u0161ov",
        townCode: 555525,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36452,
        lat: 50.051663,
        long: 13.170783
    },
    {
        town: "P\u0161ovlky",
        townCode: 542270,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27031,
        lat: 50.107947,
        long: 13.594013
    },
    {
        town: "Pten\xed",
        townCode: 589942,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79843,
        lat: 49.511729,
        long: 16.961205
    },
    {
        town: "Pten\xedn",
        townCode: 558265,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33452,
        lat: 49.531607,
        long: 13.18506
    },
    {
        town: 'Ptice',
        townCode: 532789,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25218,
        lat: 50.05287,
        long: 14.166076
    },
    {
        town: "Pt\xfdrov",
        townCode: 571938,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.504933,
        long: 14.947236
    },
    {
        town: 'Puclice',
        townCode: 554154,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.553725,
        long: 13.019504
    },
    {
        town: 'Pucov',
        townCode: 591491,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.247148,
        long: 16.174175
    },
    {
        town: 'Puchlovice',
        townCode: 573531,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.185916,
        long: 15.626417
    },
    {
        town: 'Puklice',
        townCode: 587745,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58831,
        lat: 49.374959,
        long: 15.700414
    },
    {
        town: "Pule\u010Dn\xfd",
        townCode: 546577,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46802,
        lat: 50.675488,
        long: 15.167986
    },
    {
        town: "Pust\xe1 Kamenice",
        townCode: 578631,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56982,
        lat: 49.756215,
        long: 16.085881
    },
    {
        town: "Pust\xe1 Polom",
        townCode: 509736,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74769,
        lat: 49.849271,
        long: 17.998005
    },
    {
        town: "Pust\xe1 Rybn\xe1",
        townCode: 578649,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.714822,
        long: 16.1351
    },
    {
        town: "Pust\u011Bjov",
        townCode: 568775,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74243,
        lat: 49.700606,
        long: 18.004007
    },
    {
        town: "Pustim\u011B\u0159",
        townCode: 593508,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68321,
        lat: 49.322614,
        long: 17.02803
    },
    {
        town: 'Pustina',
        townCode: 580830,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.899577,
        long: 16.105003
    },
    {
        town: "Pustov\u011Bty",
        townCode: 542288,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.055708,
        long: 13.814115
    },
    {
        town: 'Putim',
        townCode: 549801,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.264627,
        long: 14.11913
    },
    {
        town: 'Putimov',
        townCode: 598755,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.41393,
        long: 15.268871
    },
    {
        town: "Py\u0161el",
        townCode: 591505,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.250609,
        long: 16.066539
    },
    {
        town: "Py\u0161ely",
        townCode: 538680,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25167,
        lat: 49.876884,
        long: 14.677239
    },
    {
        town: 'Rabakov',
        townCode: 565652,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.38575,
        long: 15.101648
    },
    {
        town: "Rab\xed",
        townCode: 557013,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.280848,
        long: 13.617715
    },
    {
        town: "Rab\u0161tejnsk\xe1 Lhota",
        townCode: 556882,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.915662,
        long: 15.768153
    },
    {
        town: "R\xe1by",
        townCode: 575534,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.07288,
        long: 15.802625
    },
    {
        town: "Rabyn\u011B",
        townCode: 530522,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25208,
        lat: 49.81429,
        long: 14.436202
    },
    {
        town: "Rackov\xe1",
        townCode: 585670,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76001,
        lat: 49.27717,
        long: 17.624991
    },
    {
        town: "R\xe1covice",
        townCode: 511307,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 49.02106,
        long: 15.687019
    },
    {
        town: "Ra\u010Detice",
        townCode: 546071,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.30526,
        long: 13.364964
    },
    {
        town: "Ra\u010Dice",
        townCode: 591521,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.108129,
        long: 16.024703
    },
    {
        town: "Ra\u010Dice",
        townCode: 596507,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.497374,
        long: 16.139354
    },
    {
        town: "Ra\u010Dice",
        townCode: 599760,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27024,
        lat: 50.024833,
        long: 13.923039
    },
    {
        town: "Ra\u010Dice",
        townCode: 565482,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41108,
        lat: 50.461398,
        long: 14.351181
    },
    {
        town: "Ra\u010Dice nad Trotinou",
        townCode: 570702,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.315762,
        long: 15.796171
    },
    {
        town: "Ra\u010Dice-P\xedstovice",
        townCode: 593516,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68305,
        lat: 49.276006,
        long: 16.872942
    },
    {
        town: "Ra\u010D\xedn",
        townCode: 588059,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59211,
        lat: 49.617573,
        long: 15.866964
    },
    {
        town: "Ra\u010Din\u011Bves",
        townCode: 565491,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.373201,
        long: 14.218727
    },
    {
        town: "Rad\u010Dice",
        townCode: 563773,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.672861,
        long: 15.277749
    },
    {
        town: "Rad\u011Bjov",
        townCode: 586501,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69667,
        lat: 48.859476,
        long: 17.34472
    },
    {
        town: "Rad\u011Bjovice",
        townCode: 536423,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38773,
        lat: 49.186371,
        long: 14.026543
    },
    {
        town: "Rad\u011Bjovice",
        townCode: 538698,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25168,
        lat: 49.947328,
        long: 14.564877
    },
    {
        town: 'Radenice',
        townCode: 596515,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.427318,
        long: 16.064675
    },
    {
        town: "Raden\xedn",
        townCode: 552917,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39120,
        lat: 49.369486,
        long: 14.840783
    },
    {
        town: "Rade\u0161\xedn",
        townCode: 596523,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59255,
        lat: 49.470362,
        long: 16.087846
    },
    {
        town: "Rade\u0161\xednsk\xe1 Svratka",
        townCode: 596531,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59233,
        lat: 49.508546,
        long: 16.085143
    },
    {
        town: "Rad\u011Btice",
        townCode: 552925,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.31946,
        long: 14.441364
    },
    {
        town: "Rad\u011Btice",
        townCode: 564389,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.639925,
        long: 14.078828
    },
    {
        town: 'Radhostice',
        townCode: 550485,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.079455,
        long: 13.880611
    },
    {
        town: "Radho\u0161\u0165",
        townCode: 575542,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 49.987647,
        long: 16.076121
    },
    {
        town: "Rad\xed\u010D",
        townCode: 598488,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.714764,
        long: 14.417497
    },
    {
        town: "Rad\xedkov",
        townCode: 517275,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.596189,
        long: 17.672293
    },
    {
        town: "Rad\xedkovice",
        townCode: 570711,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.209432,
        long: 15.693658
    },
    {
        town: 'Radim',
        townCode: 573370,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50712,
        lat: 50.458914,
        long: 15.428693
    },
    {
        town: 'Radim',
        townCode: 533629,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28103,
        lat: 50.070165,
        long: 15.012548
    },
    {
        town: "Radim\u011B\u0159",
        townCode: 578657,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56907,
        lat: 49.699586,
        long: 16.431386
    },
    {
        town: 'Radimovice',
        townCode: 544582,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46344,
        lat: 50.626455,
        long: 15.082181
    },
    {
        town: "Radimovice u T\xe1bora",
        townCode: 563196,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.457417,
        long: 14.639125
    },
    {
        town: "Radimovice u \u017Del\u010De",
        townCode: 552933,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.377371,
        long: 14.647655
    },
    {
        town: 'Radkov',
        townCode: 552941,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.465893,
        long: 14.611257
    },
    {
        town: 'Radkov',
        townCode: 587761,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.145306,
        long: 15.475336
    },
    {
        town: 'Radkov',
        townCode: 549924,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59253,
        lat: 49.423179,
        long: 16.158345
    },
    {
        town: 'Radkov',
        townCode: 568317,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74784,
        lat: 49.825627,
        long: 17.770253
    },
    {
        town: 'Radkov',
        townCode: 574333,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.734468,
        long: 16.741584
    },
    {
        town: 'Radkova Lhota',
        townCode: 517321,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.44185,
        long: 17.620656
    },
    {
        town: 'Radkovice',
        townCode: 540421,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.547925,
        long: 13.368061
    },
    {
        town: "Radkovice u Bud\u010De",
        townCode: 550493,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 38001,
        lat: 49.082593,
        long: 15.621844
    },
    {
        town: 'Radkovice u Hrotovic',
        townCode: 591548,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67559,
        lat: 49.070537,
        long: 16.007196
    },
    {
        town: 'Radkovy',
        townCode: 517437,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.436222,
        long: 17.614936
    },
    {
        town: "R\xe1dlo",
        townCode: 563781,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46803,
        lat: 50.698552,
        long: 15.115859
    },
    {
        town: 'Radnice',
        townCode: 560120,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.856879,
        long: 13.605812
    },
    {
        town: "Rad\u0148oves",
        townCode: 596540,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.388717,
        long: 16.214074
    },
    {
        town: "Rad\u0148ovice",
        townCode: 596558,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.56411,
        long: 16.034964
    },
    {
        town: "Radomy\u0161l",
        townCode: 551660,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38731,
        lat: 49.31645,
        long: 13.930344
    },
    {
        town: 'Radonice',
        townCode: 538701,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25073,
        lat: 50.143163,
        long: 14.610368
    },
    {
        town: 'Radonice',
        townCode: 563323,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43155,
        lat: 50.298139,
        long: 13.284757
    },
    {
        town: "Radon\xedn",
        townCode: 591556,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.279799,
        long: 15.72424
    },
    {
        town: 'Radostice',
        townCode: 583740,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66446,
        lat: 49.133707,
        long: 16.477112
    },
    {
        town: "Radost\xedn",
        townCode: 569364,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.661841,
        long: 15.545004
    },
    {
        town: "Radost\xedn",
        townCode: 596566,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.652815,
        long: 15.875868
    },
    {
        town: "Radost\xedn nad Oslavou",
        townCode: 596574,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.46203,
        long: 15.965213
    },
    {
        town: "Radostn\xe1 pod Koz\xe1kovem",
        townCode: 577430,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51263,
        lat: 50.577589,
        long: 15.245541
    },
    {
        town: 'Radostov',
        townCode: 570729,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.20977,
        long: 15.663736
    },
    {
        town: "Rado\u0161ov",
        townCode: 591564,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.335141,
        long: 15.786546
    },
    {
        town: "Rado\u0161ovice",
        townCode: 544965,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.019699,
        long: 14.273026
    },
    {
        town: "Rado\u0161ovice",
        townCode: 551678,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.233625,
        long: 13.898673
    },
    {
        town: "Rado\u0161ovice",
        townCode: 530531,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.741095,
        long: 14.867658
    },
    {
        town: 'Radotice',
        townCode: 545040,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 48.980111,
        long: 15.590214
    },
    {
        town: "Radot\xedn",
        townCode: 517445,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.47973,
        long: 17.63283
    },
    {
        town: 'Radovesice',
        townCode: 565521,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.41107,
        long: 14.068389
    },
    {
        town: 'Radovesnice I',
        townCode: 533637,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.010493,
        long: 15.151007
    },
    {
        town: 'Radovesnice II',
        townCode: 533645,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28128,
        lat: 50.104165,
        long: 15.367826
    },
    {
        town: 'Radslavice',
        townCode: 593524,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68321,
        lat: 49.323013,
        long: 17.003932
    },
    {
        town: 'Radslavice',
        townCode: 517534,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.478269,
        long: 17.516667
    },
    {
        town: "Radu\u0148",
        townCode: 509841,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74761,
        lat: 49.89297,
        long: 17.943349
    },
    {
        town: 'Radvanec',
        townCode: 530387,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47301,
        lat: 50.753003,
        long: 14.59215
    },
    {
        town: 'Radvanice',
        townCode: 579629,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54212,
        lat: 50.567552,
        long: 16.061824
    },
    {
        town: 'Radvanice',
        townCode: 517569,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75121,
        lat: 49.509905,
        long: 17.477349
    },
    {
        town: "R\xe1jec",
        townCode: 540854,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.856577,
        long: 16.903068
    },
    {
        town: "R\xe1jec-Jest\u0159eb\xed",
        townCode: 582239,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.410419,
        long: 16.640964
    },
    {
        town: "R\xe1je\u010Dko",
        townCode: 582247,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.393418,
        long: 16.641436
    },
    {
        town: 'Rajhrad',
        townCode: 583758,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.090311,
        long: 16.603982
    },
    {
        town: 'Rajhradice',
        townCode: 583766,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.092135,
        long: 16.629436
    },
    {
        town: 'Rajnochovice',
        townCode: 588920,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76871,
        lat: 49.413088,
        long: 17.813268
    },
    {
        town: 'Rakousy',
        townCode: 577448,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.620425,
        long: 15.187647
    },
    {
        town: 'Rakov',
        townCode: 517585,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.491801,
        long: 17.707876
    },
    {
        town: "Rakov\xe1",
        townCode: 566942,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.70043,
        long: 13.582052
    },
    {
        town: "Rakov\xe1 u Konice",
        townCode: 589951,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79857,
        lat: 49.607347,
        long: 16.950931
    },
    {
        town: 'Rakovice',
        townCode: 562068,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.471321,
        long: 14.05466
    },
    {
        town: "Rakovn\xedk",
        townCode: 541656,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26901,
        lat: 50.106223,
        long: 13.739762
    },
    {
        town: "Rak\u016Fvka",
        townCode: 589969,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79857,
        lat: 49.610112,
        long: 16.938064
    },
    {
        town: 'Rakvice',
        townCode: 584860,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69103,
        lat: 48.858211,
        long: 16.813408
    },
    {
        town: 'Ralsko',
        townCode: 562017,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47124,
        lat: 50.58629,
        long: 14.80363
    },
    {
        town: "Ran\xe1",
        townCode: 572152,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53972,
        lat: 49.796504,
        long: 15.96422
    },
    {
        town: "Ran\xe1",
        townCode: 566659,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43924,
        lat: 50.411665,
        long: 13.779373
    },
    {
        town: "Ran\u010D\xed\u0159ov",
        townCode: 587176,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58601,
        lat: 49.362563,
        long: 15.588563
    },
    {
        town: "Rant\xed\u0159ov",
        townCode: 587788,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58841,
        lat: 49.408348,
        long: 15.515264
    },
    {
        town: 'Rapotice',
        townCode: 591581,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67573,
        lat: 49.192313,
        long: 16.25337
    },
    {
        town: "Rapot\xedn",
        townCode: 540862,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78814,
        lat: 50.000846,
        long: 17.019059
    },
    {
        town: "Rap\u0161ach",
        townCode: 547069,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37807,
        lat: 48.879314,
        long: 14.933012
    },
    {
        town: "Raso\u0161ky",
        townCode: 574376,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55221,
        lat: 50.322012,
        long: 15.911774
    },
    {
        town: 'Raspenava',
        townCode: 564371,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.904256,
        long: 15.114757
    },
    {
        town: "Ra\u0161\xedn",
        townCode: 549274,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.333359,
        long: 15.678023
    },
    {
        town: "Ra\u0161kovice",
        townCode: 549665,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73904,
        lat: 49.619845,
        long: 18.472974
    },
    {
        town: "Ra\u0161ov",
        townCode: 582255,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.415645,
        long: 16.45383
    },
    {
        town: "Ra\u0161ovice",
        townCode: 593532,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68501,
        lat: 49.121064,
        long: 16.948329
    },
    {
        town: "Ra\u0161ovice",
        townCode: 534340,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.882642,
        long: 15.102485
    },
    {
        town: 'Rataje',
        townCode: 552976,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.350249,
        long: 14.44584
    },
    {
        town: 'Rataje',
        townCode: 530549,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.704164,
        long: 14.97055
    },
    {
        town: 'Rataje',
        townCode: 588938,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76812,
        lat: 49.2714,
        long: 17.335656
    },
    {
        town: "Rataje nad S\xe1zavou",
        townCode: 534358,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28507,
        lat: 49.841949,
        long: 14.956827
    },
    {
        town: "Ratbo\u0159",
        townCode: 533653,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28141,
        lat: 49.978185,
        long: 15.159345
    },
    {
        town: 'Ratenice',
        townCode: 537748,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.09171,
        long: 15.059361
    },
    {
        town: "Ratibo\u0159",
        townCode: 507784,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.143619,
        long: 14.915123
    },
    {
        town: "Ratibo\u0159",
        townCode: 544787,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75621,
        lat: 49.367793,
        long: 17.915097
    },
    {
        town: "Ratibo\u0159sk\xe9 Hory",
        townCode: 552992,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39142,
        lat: 49.462778,
        long: 14.769911
    },
    {
        town: "Rat\xed\u0161kovice",
        townCode: 586510,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69602,
        lat: 48.920114,
        long: 17.165713
    },
    {
        town: "Ratm\u011B\u0159ice",
        townCode: 532550,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25703,
        lat: 49.643355,
        long: 14.756277
    },
    {
        town: "Razov\xe1",
        townCode: 597724,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.931401,
        long: 17.532102
    },
    {
        town: "Ra\u017Eice",
        townCode: 549827,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39822,
        lat: 49.240999,
        long: 14.101842
    },
    {
        town: "Rebe\u0161ovice",
        townCode: 583774,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66461,
        lat: 49.105224,
        long: 16.635332
    },
    {
        town: 'Rejchartice',
        townCode: 553395,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78701,
        lat: 50.028348,
        long: 16.97802
    },
    {
        town: "Rej\u0161tejn",
        townCode: 557021,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34192,
        lat: 49.14064,
        long: 13.515272
    },
    {
        town: "Re\u0161ice",
        townCode: 594725,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67173,
        lat: 49.053466,
        long: 16.171572
    },
    {
        town: "Robl\xedn",
        townCode: 571318,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25226,
        lat: 49.961936,
        long: 14.248667
    },
    {
        town: "Ro\u010Dov",
        townCode: 566667,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43967,
        lat: 50.253498,
        long: 13.774466
    },
    {
        town: 'Rodinov',
        townCode: 561789,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.282895,
        long: 15.103915
    },
    {
        town: 'Rodkov',
        townCode: 587737,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.503956,
        long: 16.227678
    },
    {
        town: "Rodn\xe1",
        townCode: 560626,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.490264,
        long: 14.8426
    },
    {
        town: "Rodv\xednov",
        townCode: 547085,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.171096,
        long: 15.05709
    },
    {
        town: 'Rohatec',
        townCode: 586528,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69601,
        lat: 48.880497,
        long: 17.183408
    },
    {
        town: 'Rohatsko',
        townCode: 565636,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.440386,
        long: 15.104846
    },
    {
        town: 'Rohenice',
        townCode: 548669,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.309374,
        long: 16.032244
    },
    {
        town: 'Rohle',
        townCode: 540871,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78974,
        lat: 49.860823,
        long: 17.013786
    },
    {
        town: 'Rohov',
        townCode: 568376,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74725,
        lat: 50.015707,
        long: 18.071507
    },
    {
        town: "Rohovl\xe1dova B\u011Bl\xe1",
        townCode: 575551,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53343,
        lat: 50.106311,
        long: 15.606265
    },
    {
        town: 'Rohozec',
        townCode: 582263,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.390415,
        long: 16.482952
    },
    {
        town: 'Rohozec',
        townCode: 526622,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.97612,
        long: 15.384746
    },
    {
        town: "Rohozn\xe1",
        townCode: 587796,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58844,
        lat: 49.350316,
        long: 15.399269
    },
    {
        town: "Rohozn\xe1",
        townCode: 578673,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56972,
        lat: 49.653741,
        long: 16.407989
    },
    {
        town: 'Rohoznice',
        townCode: 573221,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.391682,
        long: 15.699658
    },
    {
        town: 'Rohoznice',
        townCode: 575569,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.127321,
        long: 15.664377
    },
    {
        town: 'Rohy',
        townCode: 591602,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.305639,
        long: 16.005703
    },
    {
        town: 'Rochlov',
        townCode: 559423,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.730821,
        long: 13.146015
    },
    {
        town: 'Rochov',
        townCode: 565547,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.45949,
        long: 14.117546
    },
    {
        town: "Rojet\xedn",
        townCode: 596582,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.366746,
        long: 16.257478
    },
    {
        town: 'Rokle',
        townCode: 563331,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43201,
        lat: 50.35328,
        long: 13.29881
    },
    {
        town: 'Rokycany',
        townCode: 559717,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.738197,
        long: 13.592993
    },
    {
        town: "Rokyt\xe1",
        townCode: 529605,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29501,
        lat: 50.563767,
        long: 14.869309
    },
    {
        town: "Rokyt\u0148any",
        townCode: 548898,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.375876,
        long: 15.137489
    },
    {
        town: 'Rokytnice',
        townCode: 517607,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75104,
        lat: 49.466023,
        long: 17.391308
    },
    {
        town: 'Rokytnice',
        townCode: 556980,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.066239,
        long: 17.91147
    },
    {
        town: 'Rokytnice nad Jizerou',
        townCode: 577456,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51244,
        lat: 50.729228,
        long: 15.448787
    },
    {
        town: 'Rokytnice nad Rokytnou',
        townCode: 591611,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67525,
        lat: 49.184456,
        long: 15.77297
    },
    {
        town: "Rokytnice v Orlick\xfdch hor\xe1ch",
        townCode: 576701,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51761,
        lat: 50.164831,
        long: 16.46578
    },
    {
        town: 'Rokytno',
        townCode: 575577,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53304,
        lat: 50.104773,
        long: 15.889408
    },
    {
        town: 'Rokytovec',
        townCode: 571148,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29430,
        lat: 50.406627,
        long: 14.830785
    },
    {
        town: 'Ronov nad Doubravou',
        townCode: 572161,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53842,
        lat: 49.888353,
        long: 15.531541
    },
    {
        town: 'Ropice',
        townCode: 556971,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73961,
        lat: 49.705458,
        long: 18.61356
    },
    {
        town: 'Roprachtice',
        townCode: 577464,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.647554,
        long: 15.422263
    },
    {
        town: "Rose\u010D",
        townCode: 508004,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37846,
        lat: 49.127862,
        long: 14.910845
    },
    {
        town: 'Rosice',
        townCode: 583782,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66501,
        lat: 49.18242,
        long: 16.387975
    },
    {
        town: 'Rosice',
        townCode: 572179,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53834,
        lat: 49.922359,
        long: 15.951376
    },
    {
        town: "Rosi\u010Dka",
        townCode: 560995,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.279706,
        long: 14.954045
    },
    {
        town: "Rosi\u010Dka",
        townCode: 549941,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.538671,
        long: 15.842695
    },
    {
        town: 'Rosovice',
        townCode: 541206,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26211,
        lat: 49.756754,
        long: 14.109079
    },
    {
        town: "Rost\u011Bnice-Zvonovice",
        townCode: 554898,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.238368,
        long: 16.966061
    },
    {
        town: 'Rostoklaty',
        townCode: 533661,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28171,
        lat: 50.074329,
        long: 14.801559
    },
    {
        town: "Ro\u0161t\u011Bn\xed",
        townCode: 588946,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76843,
        lat: 49.367004,
        long: 17.538595
    },
    {
        town: "Ro\u0161t\xedn",
        townCode: 588954,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76803,
        lat: 49.188888,
        long: 17.286157
    },
    {
        town: 'Rotava',
        townCode: 560600,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35701,
        lat: 50.29638,
        long: 12.573526
    },
    {
        town: 'Roubanina',
        townCode: 513709,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.615509,
        long: 16.594167
    },
    {
        town: "Roudn\xe1",
        townCode: 553018,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.304487,
        long: 14.718671
    },
    {
        town: "Roudn\xe9",
        townCode: 544973,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.934985,
        long: 14.487539
    },
    {
        town: 'Roudnice',
        townCode: 570745,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.176262,
        long: 15.651804
    },
    {
        town: 'Roudnice nad Labem',
        townCode: 565555,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.425305,
        long: 14.260565
    },
    {
        town: 'Roudno',
        townCode: 597741,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.896091,
        long: 17.513637
    },
    {
        town: 'Rouchovany',
        townCode: 591629,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67557,
        lat: 49.070461,
        long: 16.107705
    },
    {
        town: 'Roupov',
        townCode: 558290,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33453,
        lat: 49.538655,
        long: 13.249019
    },
    {
        town: "Rous\xednov",
        townCode: 593559,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.201381,
        long: 16.882252
    },
    {
        town: "Rousk\xe9",
        townCode: 517615,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.471832,
        long: 17.779252
    },
    {
        town: "Rousm\u011Brov",
        townCode: 596604,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.457769,
        long: 16.032622
    },
    {
        town: "Rove\u010Dn\xe9",
        townCode: 596612,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.577723,
        long: 16.362673
    },
    {
        town: 'Rovensko',
        townCode: 540919,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.907785,
        long: 16.876347
    },
    {
        town: 'Rovensko pod Troskami',
        townCode: 577472,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51263,
        lat: 50.535418,
        long: 15.259515
    },
    {
        town: "Rovn\xe1",
        townCode: 536865,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.286443,
        long: 13.954057
    },
    {
        town: "Rovn\xe1",
        townCode: 560618,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.104512,
        long: 12.668852
    },
    {
        town: "Rovn\xe1",
        townCode: 561274,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.510291,
        long: 15.129502
    },
    {
        town: 'Rozdrojovice',
        townCode: 583791,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66434,
        lat: 49.254744,
        long: 16.510033
    },
    {
        town: 'Rozhovice',
        townCode: 547808,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.967283,
        long: 15.713618
    },
    {
        town: "Rozhran\xed",
        townCode: 578681,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56903,
        lat: 49.601761,
        long: 16.533472
    },
    {
        town: "Rozko\u0161",
        townCode: 594733,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 49.028696,
        long: 15.977759
    },
    {
        town: "Rozse\u010D",
        townCode: 587800,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58866,
        lat: 49.155992,
        long: 15.616703
    },
    {
        town: "Rozse\u010D",
        townCode: 596639,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.360238,
        long: 16.219462
    },
    {
        town: "Rozse\u010D nad Kun\u0161t\xe1tem",
        townCode: 582271,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67973,
        lat: 49.524499,
        long: 16.46313
    },
    {
        town: "Rozs\xed\u010Dka",
        townCode: 582280,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.552383,
        long: 16.46709
    },
    {
        town: 'Rozsochatec',
        townCode: 569399,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58272,
        lat: 49.672641,
        long: 15.633903
    },
    {
        town: 'Rozsochy',
        townCode: 596647,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59257,
        lat: 49.520317,
        long: 16.200201
    },
    {
        town: "Rozst\xe1n\xed",
        townCode: 589977,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79862,
        lat: 49.397795,
        long: 16.840456
    },
    {
        town: "Rozst\xe1n\xed",
        townCode: 578690,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.735067,
        long: 16.720164
    },
    {
        town: 'Roztoky',
        townCode: 539627,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25263,
        lat: 50.158516,
        long: 14.397712
    },
    {
        town: 'Roztoky',
        townCode: 598526,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.02682,
        long: 13.867976
    },
    {
        town: 'Roztoky u Jilemnice',
        townCode: 577499,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51231,
        lat: 50.563887,
        long: 15.499852
    },
    {
        town: 'Roztoky u Semil',
        townCode: 577481,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.65855,
        long: 15.371639
    },
    {
        town: 'Rozvadov',
        townCode: 561169,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34806,
        lat: 49.668279,
        long: 12.551998
    },
    {
        town: "Ro\u017E\u010Falovice",
        townCode: 537756,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28934,
        lat: 50.304864,
        long: 15.169724
    },
    {
        town: "Ro\u017Emberk nad Vltavou",
        townCode: 545767,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38218,
        lat: 48.654353,
        long: 14.365259
    },
    {
        town: "Ro\u017Emit\xe1l na \u0160umav\u011B",
        townCode: 545775,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38292,
        lat: 48.701499,
        long: 14.388377
    },
    {
        town: "Ro\u017Emit\xe1l pod T\u0159em\u0161\xednem",
        townCode: 541231,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.601864,
        long: 13.865835
    },
    {
        town: "Ro\u017En\xe1",
        townCode: 596655,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59252,
        lat: 49.477368,
        long: 16.23859
    },
    {
        town: "Ro\u017Enov",
        townCode: 574384,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.338147,
        long: 15.86139
    },
    {
        town: "Ro\u017Enov pod Radho\u0161t\u011Bm",
        townCode: 544841,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75661,
        lat: 49.458626,
        long: 18.143131
    },
    {
        town: 'Rpety',
        townCode: 531715,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.828376,
        long: 13.938596
    },
    {
        town: "Rtyn\u011B nad B\xedlinou",
        townCode: 567809,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41762,
        lat: 50.603629,
        long: 13.908818
    },
    {
        town: "Rtyn\u011B v Podkrkono\u0161\xed",
        townCode: 579637,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54233,
        lat: 50.505329,
        long: 16.071973
    },
    {
        town: 'Ruda',
        townCode: 596663,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.322584,
        long: 16.122796
    },
    {
        town: 'Ruda',
        townCode: 542326,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27101,
        lat: 50.14089,
        long: 13.875801
    },
    {
        town: 'Ruda nad Moravou',
        townCode: 540978,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78963,
        lat: 49.981095,
        long: 16.877925
    },
    {
        town: 'Rudice',
        townCode: 582298,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.337274,
        long: 16.725919
    },
    {
        town: 'Rudice',
        townCode: 592552,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68732,
        lat: 49.056153,
        long: 17.737584
    },
    {
        town: "Rud\xedkov",
        townCode: 591637,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.288117,
        long: 15.94605
    },
    {
        town: 'Rudimov',
        townCode: 586919,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.079796,
        long: 17.828258
    },
    {
        town: 'Rudka',
        townCode: 583804,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.242573,
        long: 16.331102
    },
    {
        town: 'Rudlice',
        townCode: 594741,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.948588,
        long: 16.065799
    },
    {
        town: "Rudn\xe1",
        townCode: 578703,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.659222,
        long: 16.573374
    },
    {
        town: "Rudn\xe1",
        townCode: 531723,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25219,
        lat: 50.035128,
        long: 14.234454
    },
    {
        town: "Rudn\xe1 pod Prad\u011Bdem",
        townCode: 551945,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79331,
        lat: 50.020519,
        long: 17.377529
    },
    {
        town: "Rudn\xedk",
        townCode: 579645,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54372,
        lat: 50.578698,
        long: 15.736956
    },
    {
        town: 'Rudolec',
        townCode: 596671,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59214,
        lat: 49.47692,
        long: 15.830304
    },
    {
        town: 'Rudolfov',
        townCode: 544981,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37371,
        lat: 48.993496,
        long: 14.541889
    },
    {
        town: 'Rudoltice',
        townCode: 580848,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56125,
        lat: 49.898427,
        long: 16.569965
    },
    {
        town: 'Rumburk',
        townCode: 562777,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40801,
        lat: 50.953525,
        long: 14.555255
    },
    {
        town: 'Ruprechtov',
        townCode: 593567,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68304,
        lat: 49.32875,
        long: 16.851494
    },
    {
        town: 'Rusava',
        townCode: 588962,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76841,
        lat: 49.348527,
        long: 17.689193
    },
    {
        town: "Rus\xedn",
        townCode: 597775,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79397,
        lat: 50.209884,
        long: 17.734323
    },
    {
        town: "Ru\u0161inov",
        townCode: 569402,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.791978,
        long: 15.683152
    },
    {
        town: "R\u016F\u017E\u010Fka",
        townCode: 544850,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75625,
        lat: 49.394052,
        long: 17.995701
    },
    {
        town: "R\u016F\u017Een\xe1",
        townCode: 587818,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58901,
        lat: 49.270494,
        long: 15.428507
    },
    {
        town: "R\u016F\u017Eov\xe1",
        townCode: 566900,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.842265,
        long: 14.293898
    },
    {
        town: "Ryb\xed",
        townCode: 568554,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74265,
        lat: 49.600825,
        long: 18.076024
    },
    {
        town: "Rybitv\xed",
        townCode: 575593,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53354,
        lat: 50.060247,
        long: 15.704827
    },
    {
        town: "Rybn\xe1 nad Zdobnic\xed",
        townCode: 576727,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51755,
        lat: 50.10864,
        long: 16.365963
    },
    {
        town: "Rybn\xe9",
        townCode: 587826,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.42295,
        long: 15.736398
    },
    {
        town: 'Rybnice',
        townCode: 559431,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33151,
        lat: 49.908441,
        long: 13.373838
    },
    {
        town: "Rybn\xed\u010Dek",
        townCode: 553972,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.273976,
        long: 17.073903
    },
    {
        town: "Rybn\xed\u010Dek",
        townCode: 569411,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.76947,
        long: 15.509141
    },
    {
        town: "Rybn\xedk",
        townCode: 547905,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56002,
        lat: 49.888725,
        long: 16.474526
    },
    {
        town: "Rybn\xedk",
        townCode: 554189,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34525,
        lat: 49.512872,
        long: 12.676863
    },
    {
        town: "Rybn\xedky",
        townCode: 594750,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67201,
        lat: 49.026365,
        long: 16.27947
    },
    {
        town: "Rybn\xedky",
        townCode: 541257,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.752744,
        long: 14.206005
    },
    {
        town: "Rybni\u0161t\u011B",
        townCode: 562793,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40751,
        lat: 50.880068,
        long: 14.515148
    },
    {
        town: "Rychnov na Morav\u011B",
        townCode: 578711,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56934,
        lat: 49.829244,
        long: 16.640214
    },
    {
        town: "Rychnov nad Kn\u011B\u017Enou",
        townCode: 576069,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51601,
        lat: 50.166065,
        long: 16.277784
    },
    {
        town: 'Rychnov u Jablonce nad Nisou',
        townCode: 563790,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46802,
        lat: 50.683891,
        long: 15.149898
    },
    {
        town: 'Rychnovek',
        townCode: 574406,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55225,
        lat: 50.357467,
        long: 15.970419
    },
    {
        town: 'Rychvald',
        townCode: 599107,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73532,
        lat: 49.86635,
        long: 18.376369
    },
    {
        town: 'Ryjice',
        townCode: 546186,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40331,
        lat: 50.688055,
        long: 14.092111
    },
    {
        town: "R\xfdma\u0159ov",
        townCode: 597783,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79501,
        lat: 49.931927,
        long: 17.271873
    },
    {
        town: 'Rymice',
        townCode: 588971,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.342008,
        long: 17.526316
    },
    {
        town: "Ryn\xe1rec",
        townCode: 562009,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39401,
        lat: 49.389706,
        long: 15.234826
    },
    {
        town: 'Rynholec',
        townCode: 542334,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27062,
        lat: 50.138031,
        long: 13.922328
    },
    {
        town: 'Rynoltice',
        townCode: 564397,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46353,
        lat: 50.789106,
        long: 14.818942
    },
    {
        town: "Ry\u017Eovi\u0161t\u011B",
        townCode: 597791,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79356,
        lat: 49.875695,
        long: 17.358331
    },
    {
        town: "\u0158\xe1sn\xe1",
        townCode: 587834,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.221126,
        long: 15.391382
    },
    {
        town: "\u0158e\u010Dany nad Labem",
        townCode: 575607,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53313,
        lat: 50.03599,
        long: 15.477455
    },
    {
        town: "\u0158e\u010Dice",
        townCode: 548715,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.602983,
        long: 15.371725
    },
    {
        town: "\u0158e\u010Dice",
        townCode: 596680,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59233,
        lat: 49.513093,
        long: 16.063959
    },
    {
        town: "\u0158ehenice",
        townCode: 538710,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25167,
        lat: 49.869849,
        long: 14.650331
    },
    {
        town: "\u0158ehlovice",
        townCode: 568201,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40313,
        lat: 50.607226,
        long: 13.954233
    },
    {
        town: "\u0158eka",
        townCode: 552640,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73955,
        lat: 49.641202,
        long: 18.571511
    },
    {
        town: "\u0158em\xed\u010Dov",
        townCode: 560511,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.515076,
        long: 14.775093
    },
    {
        town: "\u0158en\u010De",
        townCode: 558303,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.579972,
        long: 13.4146
    },
    {
        town: "\u0158end\u011Bjov",
        townCode: 534366,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.767946,
        long: 15.080471
    },
    {
        town: "\u0158epe\u010D",
        townCode: 553034,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39161,
        lat: 49.403544,
        long: 14.51966
    },
    {
        town: "\u0158epice",
        townCode: 536849,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.280612,
        long: 13.933539
    },
    {
        town: "\u0158ep\xedn",
        townCode: 535168,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27733,
        lat: 50.366642,
        long: 14.634675
    },
    {
        town: "\u0158epi\u0161t\u011B",
        townCode: 568830,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73932,
        lat: 49.733473,
        long: 18.317179
    },
    {
        town: "\u0158epn\xedky",
        townCode: 572209,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53865,
        lat: 49.901232,
        long: 16.079849
    },
    {
        town: "\u0158epov",
        townCode: 536580,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.402437,
        long: 14.957103
    },
    {
        town: "\u0158e\u0159ichy",
        townCode: 565504,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.079276,
        long: 13.585937
    },
    {
        town: "\u0158estoky",
        townCode: 572217,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.922503,
        long: 15.916661
    },
    {
        town: "\u0158etov\xe1",
        townCode: 580872,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56141,
        lat: 49.945893,
        long: 16.38133
    },
    {
        town: "\u0158et\u016Fvka",
        townCode: 580881,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56141,
        lat: 49.95587,
        long: 16.356124
    },
    {
        town: "\u0158evnice",
        townCode: 539643,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25230,
        lat: 49.914064,
        long: 14.235875
    },
    {
        town: "\u0158evni\u010Dov",
        townCode: 542351,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.184992,
        long: 13.808344
    },
    {
        town: "\u0158\xedcmanice",
        townCode: 583821,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66401,
        lat: 49.257564,
        long: 16.694045
    },
    {
        town: "\u0158\xed\u010Dany",
        townCode: 583839,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66482,
        lat: 49.215075,
        long: 16.393723
    },
    {
        town: "\u0158\xed\u010Dany",
        townCode: 538728,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.991778,
        long: 14.654376
    },
    {
        town: "\u0158\xed\u010Dky",
        townCode: 549789,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66483,
        lat: 49.233025,
        long: 16.355945
    },
    {
        town: "\u0158\xed\u010Dky v Orlick\xfdch hor\xe1ch",
        townCode: 576735,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51761,
        lat: 50.211092,
        long: 16.45912
    },
    {
        town: "\u0158\xedde\u010D",
        townCode: 554103,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.765829,
        long: 17.25688
    },
    {
        town: "\u0158\xeddelov",
        townCode: 587851,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.234597,
        long: 15.406922
    },
    {
        town: "\u0158\xeddk\xfd",
        townCode: 572233,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.894209,
        long: 16.243209
    },
    {
        town: "\u0158ikon\xedn",
        townCode: 596698,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.364487,
        long: 16.305808
    },
    {
        town: "\u0158\xedkov",
        townCode: 530786,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55203,
        lat: 50.384385,
        long: 16.016933
    },
    {
        town: "\u0158\xedkovice",
        townCode: 517666,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75118,
        lat: 49.381646,
        long: 17.451338
    },
    {
        town: "\u0158\xedmov",
        townCode: 545007,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37324,
        lat: 48.855719,
        long: 14.48694
    },
    {
        town: "\u0158\xedmov",
        townCode: 591645,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.170178,
        long: 15.757671
    },
    {
        town: "\u0158imovice",
        townCode: 532941,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.696448,
        long: 14.943106
    },
    {
        town: "\u0158\xedpec",
        townCode: 599115,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.214291,
        long: 14.736808
    },
    {
        town: "\u0158isuty",
        townCode: 532797,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27378,
        lat: 50.216592,
        long: 14.005087
    },
    {
        town: "\u0158itka",
        townCode: 539651,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25203,
        lat: 49.894619,
        long: 14.299341
    },
    {
        town: "\u0158itonice",
        townCode: 565661,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.408309,
        long: 15.108053
    },
    {
        town: "S\xe1dek",
        townCode: 578720,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.692663,
        long: 16.225728
    },
    {
        town: "S\xe1dek",
        townCode: 541273,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.733317,
        long: 13.98323
    },
    {
        town: 'Sadov',
        townCode: 555533,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.267226,
        long: 12.897194
    },
    {
        town: "Sadov\xe1",
        townCode: 573191,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.297512,
        long: 15.700009
    },
    {
        town: "Sadsk\xe1",
        townCode: 537764,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28912,
        lat: 50.136066,
        long: 14.98644
    },
    {
        town: "Sala\u010Dova Lhota",
        townCode: 548731,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.524136,
        long: 14.980329
    },
    {
        town: "Sala\u0161",
        townCode: 592561,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68706,
        lat: 49.140618,
        long: 17.342876
    },
    {
        town: "Samop\u0161e",
        townCode: 534374,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.861533,
        long: 14.929498
    },
    {
        town: "Samoti\u0161ky",
        townCode: 547077,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 77900,
        lat: 49.630522,
        long: 17.328172
    },
    {
        town: "Sam\u0161\xedn",
        townCode: 548740,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.485662,
        long: 15.061812
    },
    {
        town: "Sam\u0161ina",
        townCode: 573442,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.459432,
        long: 15.23502
    },
    {
        town: "S\xe1ny",
        townCode: 537772,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28906,
        lat: 50.124752,
        long: 15.247746
    },
    {
        town: "S\xe1zava",
        townCode: 596701,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59211,
        lat: 49.565295,
        long: 15.928353
    },
    {
        town: "S\xe1zava",
        townCode: 574392,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.908253,
        long: 16.641003
    },
    {
        town: "S\xe1zava",
        townCode: 534382,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.871745,
        long: 14.896842
    },
    {
        town: "S\xe1zavka",
        townCode: 569429,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58244,
        lat: 49.734505,
        long: 15.411535
    },
    {
        town: "Sazen\xe1",
        townCode: 532801,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27324,
        lat: 50.305277,
        long: 14.287363
    },
    {
        town: "Sazom\xedn",
        townCode: 588237,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.508871,
        long: 15.981076
    },
    {
        town: 'Sazovice',
        townCode: 585726,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76301,
        lat: 49.240997,
        long: 17.568782
    },
    {
        town: "Sb\u011B\u0159",
        townCode: 573451,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.320225,
        long: 15.424479
    },
    {
        town: "Sebe\u010Dice",
        townCode: 560146,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.869965,
        long: 13.692257
    },
    {
        town: 'Sebranice',
        townCode: 582310,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67931,
        lat: 49.497022,
        long: 16.57464
    },
    {
        town: 'Sebranice',
        townCode: 578738,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56962,
        lat: 49.771494,
        long: 16.249278
    },
    {
        town: "Se\u010D",
        townCode: 572225,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53807,
        lat: 49.847037,
        long: 15.65653
    },
    {
        town: "Se\u010D",
        townCode: 580902,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 50.025612,
        long: 16.294907
    },
    {
        town: "Se\u010D",
        townCode: 558311,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.588075,
        long: 13.504999
    },
    {
        town: 'Sedlatice',
        townCode: 587877,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.192397,
        long: 15.613497
    },
    {
        town: "Sedl\u010Dany",
        townCode: 541281,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.660677,
        long: 14.426744
    },
    {
        town: 'Sedlec',
        townCode: 545015,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37347,
        lat: 49.072931,
        long: 14.286606
    },
    {
        town: 'Sedlec',
        townCode: 584878,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69121,
        lat: 48.778993,
        long: 16.693989
    },
    {
        town: 'Sedlec',
        townCode: 511081,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.167674,
        long: 16.134773
    },
    {
        town: 'Sedlec',
        townCode: 530271,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 50.006379,
        long: 13.427287
    },
    {
        town: 'Sedlec',
        townCode: 529591,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29471,
        lat: 50.300839,
        long: 14.79583
    },
    {
        town: 'Sedlec',
        townCode: 598283,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25065,
        lat: 50.186836,
        long: 14.457979
    },
    {
        town: 'Sedlec',
        townCode: 546721,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.450166,
        long: 14.016401
    },
    {
        town: "Sedlec-Pr\u010Dice",
        townCode: 530573,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25791,
        lat: 49.573311,
        long: 14.533106
    },
    {
        town: "Sedle\u010Dko u Sob\u011Bslav\u011B",
        townCode: 599263,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.282784,
        long: 14.742959
    },
    {
        town: 'Sedlejov',
        townCode: 587885,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.22761,
        long: 15.495752
    },
    {
        town: "Sedlet\xedn",
        townCode: 548421,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.708551,
        long: 15.564631
    },
    {
        town: 'Sedlice',
        townCode: 551716,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38732,
        lat: 49.377258,
        long: 13.939059
    },
    {
        town: 'Sedlice',
        townCode: 548766,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.515243,
        long: 15.256443
    },
    {
        town: 'Sedlice',
        townCode: 564630,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.621869,
        long: 13.880889
    },
    {
        town: "Sedli\u0161t\u011B",
        townCode: 548961,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.394226,
        long: 15.219151
    },
    {
        town: "Sedli\u0161t\u011B",
        townCode: 598674,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73936,
        lat: 49.71846,
        long: 18.368797
    },
    {
        town: "Sedli\u0161t\u011B",
        townCode: 578746,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.893977,
        long: 16.274918
    },
    {
        town: "Sedli\u0161t\u011B",
        townCode: 540692,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.52758,
        long: 13.63234
    },
    {
        town: 'Sedlnice',
        townCode: 599832,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74256,
        lat: 49.657799,
        long: 18.08701
    },
    {
        town: "Sedlo\u0148ov",
        townCode: 576743,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51791,
        lat: 50.338401,
        long: 16.315588
    },
    {
        town: 'Sehradice',
        townCode: 585734,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76323,
        lat: 49.144368,
        long: 17.824269
    },
    {
        town: "Sej\u0159ek",
        townCode: 596710,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59262,
        lat: 49.436195,
        long: 16.309362
    },
    {
        town: "Seke\u0159ice",
        townCode: 572144,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.286507,
        long: 15.380794
    },
    {
        town: 'Seletice',
        townCode: 534757,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28934,
        lat: 50.320442,
        long: 15.097101
    },
    {
        town: 'Selmice',
        townCode: 575615,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.050233,
        long: 15.440919
    },
    {
        town: 'Seloutky',
        townCode: 506770,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79804,
        lat: 49.441499,
        long: 17.063403
    },
    {
        town: "Seman\xedn",
        townCode: 555240,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56002,
        lat: 49.869404,
        long: 16.453026
    },
    {
        town: "Sem\u010Dice",
        townCode: 536610,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29446,
        lat: 50.368272,
        long: 15.007012
    },
    {
        town: 'Semechnice',
        townCode: 576751,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.260342,
        long: 16.148495
    },
    {
        town: 'Semice',
        townCode: 537781,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28917,
        lat: 50.164267,
        long: 14.871579
    },
    {
        town: 'Semily',
        townCode: 576964,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.605258,
        long: 15.328241
    },
    {
        town: "Sem\xedn",
        townCode: 575623,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.053188,
        long: 15.519831
    },
    {
        town: "Semn\u011Bvice",
        townCode: 554201,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.597859,
        long: 12.929307
    },
    {
        town: "Semt\u011B\u0161",
        townCode: 530859,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.960036,
        long: 15.514411
    },
    {
        town: "Sendra\u017E",
        townCode: 547727,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.367711,
        long: 16.202186
    },
    {
        town: "Sendra\u017Eice",
        townCode: 570796,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.289952,
        long: 15.796074
    },
    {
        town: 'Senec',
        townCode: 542369,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27036,
        lat: 50.066842,
        long: 13.706979
    },
    {
        town: "Senet\xe1\u0159ov",
        townCode: 582328,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.354781,
        long: 16.80399
    },
    {
        town: 'Senice',
        townCode: 537799,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.184332,
        long: 15.207677
    },
    {
        town: "Senice na Han\xe9",
        townCode: 505081,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78345,
        lat: 49.62411,
        long: 17.085882
    },
    {
        town: "Seni\u010Dka",
        townCode: 552267,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78345,
        lat: 49.632317,
        long: 17.05639
    },
    {
        town: 'Seninka',
        townCode: 544906,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.273311,
        long: 17.96516
    },
    {
        town: 'Senohraby',
        townCode: 538752,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25166,
        lat: 49.895504,
        long: 14.718199
    },
    {
        town: 'Senomaty',
        townCode: 542377,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27031,
        lat: 50.098281,
        long: 13.653828
    },
    {
        town: 'Senorady',
        townCode: 591661,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67575,
        lat: 49.124447,
        long: 16.244551
    },
    {
        town: "Seno\u017Eaty",
        townCode: 548774,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39456,
        lat: 49.569169,
        long: 15.198114
    },
    {
        town: 'Sentice',
        townCode: 583847,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66603,
        lat: 49.310864,
        long: 16.446775
    },
    {
        town: 'Sepekov',
        townCode: 549843,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39851,
        lat: 49.428755,
        long: 14.418256
    },
    {
        town: 'Sezemice',
        townCode: 575640,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53304,
        lat: 50.066605,
        long: 15.852803
    },
    {
        town: 'Sezemice',
        townCode: 599573,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29411,
        lat: 50.58565,
        long: 15.005199
    },
    {
        town: "Sezimovo \xdast\xed",
        townCode: 553069,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39101,
        lat: 49.385291,
        long: 14.684908
    },
    {
        town: "Scho\u0159ov",
        townCode: 531383,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.858229,
        long: 15.380002
    },
    {
        town: "Sib\u0159ina",
        townCode: 538761,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25084,
        lat: 50.056746,
        long: 14.669513
    },
    {
        town: "Sil\u016Fvky",
        townCode: 583855,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66446,
        lat: 49.106075,
        long: 16.46804
    },
    {
        town: "Sir\xe1",
        townCode: 546488,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.821542,
        long: 13.738545
    },
    {
        town: "Sir\xe1kov",
        townCode: 596728,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.504907,
        long: 15.818313
    },
    {
        town: "Si\u0159ejovice",
        townCode: 565598,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.478454,
        long: 14.071012
    },
    {
        town: 'Sivice',
        townCode: 583863,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66407,
        lat: 49.203807,
        long: 16.782647
    },
    {
        town: 'Skalice',
        townCode: 553077,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.303479,
        long: 14.695306
    },
    {
        town: 'Skalice',
        townCode: 594768,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67171,
        lat: 48.964529,
        long: 16.224901
    },
    {
        town: 'Skalice',
        townCode: 570800,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.27647,
        long: 15.872134
    },
    {
        town: 'Skalice nad Svitavou',
        townCode: 582336,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.481246,
        long: 16.603686
    },
    {
        town: "Skalice u \u010Cesk\xe9 L\xedpy",
        townCode: 562025,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47117,
        lat: 50.745217,
        long: 14.53067
    },
    {
        town: "Skali\u010Dka",
        townCode: 545295,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66603,
        lat: 49.357972,
        long: 16.516283
    },
    {
        town: "Skali\u010Dka",
        townCode: 517747,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75352,
        lat: 49.515497,
        long: 17.795975
    },
    {
        town: 'Skalka',
        townCode: 586536,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69648,
        lat: 49.035877,
        long: 17.207332
    },
    {
        town: 'Skalka',
        townCode: 589993,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79824,
        lat: 49.403186,
        long: 17.169915
    },
    {
        town: 'Skalka u Doks',
        townCode: 513890,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.563681,
        long: 14.619672
    },
    {
        town: "Skaln\xe1",
        townCode: 554812,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.170411,
        long: 12.361561
    },
    {
        town: 'Skalsko',
        townCode: 536636,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29426,
        lat: 50.427224,
        long: 14.759137
    },
    {
        town: "Sk\xe1ly",
        townCode: 549851,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39811,
        lat: 49.219961,
        long: 14.160276
    },
    {
        town: "Sk\xe1ly",
        townCode: 598909,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.183483,
        long: 13.99296
    },
    {
        town: 'Skapce',
        townCode: 579467,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.657074,
        long: 12.990454
    },
    {
        town: "Ska\u0161ov",
        townCode: 539937,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.510567,
        long: 13.431498
    },
    {
        town: "Ska\u0161tice",
        townCode: 588989,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.332412,
        long: 17.417495
    },
    {
        town: "Sklen\xe9",
        townCode: 596736,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.609496,
        long: 16.00697
    },
    {
        town: "Sklen\xe9",
        townCode: 578754,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.70686,
        long: 16.530602
    },
    {
        town: "Sklen\xe9 nad Oslavou",
        townCode: 596744,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.438204,
        long: 16.057544
    },
    {
        town: "Sko\u010Dice",
        townCode: 551741,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38775,
        lat: 49.186215,
        long: 14.104365
    },
    {
        town: 'Skomelno',
        townCode: 566845,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.847471,
        long: 13.642262
    },
    {
        town: 'Skopytce',
        townCode: 553085,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.331555,
        long: 14.798253
    },
    {
        town: 'Skorkov',
        townCode: 548324,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58253,
        lat: 49.50855,
        long: 15.476213
    },
    {
        town: 'Skorkov',
        townCode: 557030,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29474,
        lat: 50.231801,
        long: 14.749378
    },
    {
        town: 'Skoronice',
        townCode: 586544,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69641,
        lat: 48.981428,
        long: 17.153534
    },
    {
        town: "Skoro\u0161ice",
        townCode: 553484,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79065,
        lat: 50.308643,
        long: 17.080738
    },
    {
        town: 'Skorotice',
        townCode: 596752,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59262,
        lat: 49.457421,
        long: 16.359248
    },
    {
        town: "Sko\u0159enice",
        townCode: 580929,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.031358,
        long: 16.222061
    },
    {
        town: "Sko\u0159ice",
        townCode: 506664,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.677828,
        long: 13.705369
    },
    {
        town: 'Skotnice',
        townCode: 568716,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74258,
        lat: 49.657664,
        long: 18.134051
    },
    {
        town: "Skrbe\u0148",
        townCode: 552151,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78335,
        lat: 49.641248,
        long: 17.176605
    },
    {
        town: 'Skrchov',
        townCode: 582344,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.57783,
        long: 16.549464
    },
    {
        town: "Skr\u0161\xedn",
        townCode: 567361,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.465729,
        long: 13.754506
    },
    {
        town: "Skr\xfdchov u Mal\u0161ic",
        townCode: 560669,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39175,
        lat: 49.33027,
        long: 14.596666
    },
    {
        town: 'Skryje',
        townCode: 549894,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.393663,
        long: 16.310789
    },
    {
        town: 'Skryje',
        townCode: 569461,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.843818,
        long: 15.487779
    },
    {
        town: 'Skryje',
        townCode: 542385,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27042,
        lat: 49.964953,
        long: 13.764601
    },
    {
        town: "Sk\u0159in\xe1\u0159ov",
        townCode: 596761,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.347147,
        long: 16.1721
    },
    {
        town: "Sk\u0159ipel",
        townCode: 533963,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.842088,
        long: 14.067132
    },
    {
        town: "Sk\u0159ipov",
        townCode: 510131,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74745,
        lat: 49.818845,
        long: 17.910595
    },
    {
        town: "Sk\u0159\xedpov",
        townCode: 590002,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.583631,
        long: 16.82033
    },
    {
        town: "Sk\u0159ivany",
        townCode: 570834,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50352,
        lat: 50.268616,
        long: 15.499348
    },
    {
        town: 'Skuhrov',
        townCode: 569470,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58241,
        lat: 49.684765,
        long: 15.532234
    },
    {
        town: 'Skuhrov',
        townCode: 563803,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.676103,
        long: 15.213411
    },
    {
        town: 'Skuhrov',
        townCode: 531740,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26727,
        lat: 49.87342,
        long: 14.146829
    },
    {
        town: "Skuhrov nad B\u011Blou",
        townCode: 576778,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51703,
        lat: 50.229557,
        long: 16.29241
    },
    {
        town: "Skute\u010D",
        townCode: 572241,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53973,
        lat: 49.843567,
        long: 15.996654
    },
    {
        town: "Skvr\u0148ov",
        townCode: 533696,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28144,
        lat: 49.897204,
        long: 15.001923
    },
    {
        town: 'Slabce',
        townCode: 542415,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27041,
        lat: 50.000175,
        long: 13.714888
    },
    {
        town: "Slab\u010Dice",
        townCode: 549860,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39847,
        lat: 49.326635,
        long: 14.337975
    },
    {
        town: "Slan\xe1",
        townCode: 577529,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51201,
        lat: 50.580911,
        long: 15.329787
    },
    {
        town: "Slan\xedk",
        townCode: 536776,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.268386,
        long: 13.951671
    },
    {
        town: "Slan\xfd",
        townCode: 532819,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27401,
        lat: 50.230562,
        long: 14.087044
    },
    {
        town: 'Slapsko',
        townCode: 599026,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.575208,
        long: 14.762716
    },
    {
        town: 'Slapy',
        townCode: 599042,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39176,
        lat: 49.38703,
        long: 14.616671
    },
    {
        town: 'Slapy',
        townCode: 539660,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25208,
        lat: 49.815412,
        long: 14.396225
    },
    {
        town: 'Slatina',
        townCode: 594776,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 49.019749,
        long: 16.018451
    },
    {
        town: 'Slatina',
        townCode: 568406,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74293,
        lat: 49.790806,
        long: 17.979978
    },
    {
        town: 'Slatina',
        townCode: 578762,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.629744,
        long: 16.607918
    },
    {
        town: 'Slatina',
        townCode: 580945,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.978184,
        long: 16.163803
    },
    {
        town: 'Slatina',
        townCode: 578436,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.38787,
        long: 13.744269
    },
    {
        town: 'Slatina',
        townCode: 566748,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.984635,
        long: 13.634016
    },
    {
        town: 'Slatina',
        townCode: 532827,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27326,
        lat: 50.224262,
        long: 14.220845
    },
    {
        town: 'Slatina',
        townCode: 565601,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.430683,
        long: 14.038155
    },
    {
        town: "Slatina nad \xdapou",
        townCode: 574422,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54947,
        lat: 50.454193,
        long: 16.036726
    },
    {
        town: "Slatina nad Zdobnic\xed",
        townCode: 576786,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51756,
        lat: 50.133907,
        long: 16.397982
    },
    {
        town: "Slati\u0148any",
        townCode: 572268,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53821,
        lat: 49.921196,
        long: 15.813873
    },
    {
        town: 'Slatinice',
        townCode: 505111,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78342,
        lat: 49.561652,
        long: 17.100026
    },
    {
        town: 'Slatinky',
        townCode: 590011,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78342,
        lat: 49.548787,
        long: 17.094088
    },
    {
        town: 'Slatiny',
        townCode: 573469,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.366869,
        long: 15.381502
    },
    {
        town: "Slav\u010De",
        townCode: 545023,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37321,
        lat: 48.797949,
        long: 14.615065
    },
    {
        town: "Slav\u011Btice",
        townCode: 591688,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.1037,
        long: 16.108814
    },
    {
        town: "Slav\u011Bt\xedn",
        townCode: 548553,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58263,
        lat: 49.668672,
        long: 15.772886
    },
    {
        town: "Slav\u011Bt\xedn",
        townCode: 552194,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78324,
        lat: 49.67466,
        long: 16.963636
    },
    {
        town: "Slav\u011Bt\xedn",
        townCode: 566713,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43909,
        lat: 50.350713,
        long: 13.907818
    },
    {
        town: "Slav\u011Bt\xedn nad Metuj\xed",
        townCode: 574431,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.329,
        long: 16.052982
    },
    {
        town: 'Slavhostice',
        townCode: 572187,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.308911,
        long: 15.349485
    },
    {
        town: "Slavi\u010D\xedn",
        townCode: 585751,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.088085,
        long: 17.873599
    },
    {
        town: "Slavi\u010Dky",
        townCode: 591700,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67501,
        lat: 49.17486,
        long: 15.967999
    },
    {
        town: "Slav\xedkov",
        townCode: 569488,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58265,
        lat: 49.742924,
        long: 15.780817
    },
    {
        town: "Slav\xedkovice",
        townCode: 545180,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67531,
        lat: 49.004391,
        long: 15.624453
    },
    {
        town: 'Slavkov',
        townCode: 510289,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74757,
        lat: 49.9219,
        long: 17.836519
    },
    {
        town: 'Slavkov',
        townCode: 592579,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68764,
        lat: 48.946995,
        long: 17.611677
    },
    {
        town: "Slavkov pod Host\xfdnem",
        townCode: 588997,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.377245,
        long: 17.670437
    },
    {
        town: 'Slavkov u Brna',
        townCode: 593583,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.153354,
        long: 16.876598
    },
    {
        town: "Slavn\xed\u010D",
        townCode: 548341,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58255,
        lat: 49.514827,
        long: 15.452365
    },
    {
        town: 'Slavonice',
        townCode: 547166,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37881,
        lat: 48.997636,
        long: 15.351639
    },
    {
        town: "Slavo\u0148ov",
        townCode: 574457,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.343852,
        long: 16.204042
    },
    {
        town: "Slavo\u0161ov",
        townCode: 534391,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.762279,
        long: 15.152072
    },
    {
        town: 'Slepotice',
        townCode: 575658,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.992168,
        long: 15.96145
    },
    {
        town: "Slezsk\xe9 Pavlovice",
        townCode: 551881,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.309757,
        long: 17.700802
    },
    {
        town: "Slezsk\xe9 Rudoltice",
        townCode: 597813,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79397,
        lat: 50.207003,
        long: 17.681129
    },
    {
        town: "Slopn\xe9",
        townCode: 585769,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76323,
        lat: 49.157064,
        long: 17.847218
    },
    {
        town: 'Sloup',
        townCode: 582352,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67913,
        lat: 49.414886,
        long: 16.739636
    },
    {
        town: "Sloup v \u010Cech\xe1ch",
        townCode: 562050,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47152,
        lat: 50.739037,
        long: 14.588922
    },
    {
        town: 'Sloupnice',
        townCode: 580325,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56553,
        lat: 49.920923,
        long: 16.330377
    },
    {
        town: 'Sloupno',
        townCode: 548499,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.73709,
        long: 15.749894
    },
    {
        town: 'Sloupno',
        townCode: 570851,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50353,
        lat: 50.257418,
        long: 15.502075
    },
    {
        town: "Slove\u010D",
        townCode: 537802,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28903,
        lat: 50.229948,
        long: 15.326892
    },
    {
        town: "Slov\u011Bnice",
        townCode: 532231,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.757388,
        long: 14.885194
    },
    {
        town: 'Sluhy',
        townCode: 538779,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.192538,
        long: 14.557782
    },
    {
        town: "Slune\u010Dn\xe1",
        townCode: 546275,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47301,
        lat: 50.735875,
        long: 14.482593
    },
    {
        town: 'Slup',
        townCode: 594784,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.781603,
        long: 16.199287
    },
    {
        town: "Slu\u0161ovice",
        townCode: 585777,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.247918,
        long: 17.801607
    },
    {
        town: "Slu\u0161tice",
        townCode: 538787,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25084,
        lat: 50.039141,
        long: 14.685507
    },
    {
        town: "Slu\u017E\xe1tky",
        townCode: 573604,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.684981,
        long: 15.431488
    },
    {
        town: "Slu\u017Eovice",
        townCode: 510297,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74728,
        lat: 49.988605,
        long: 17.994974
    },
    {
        town: "Sme\u010Dno",
        townCode: 532835,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27305,
        lat: 50.188542,
        long: 14.040474
    },
    {
        town: "Sm\u011Bd\u010Dice",
        townCode: 540722,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.799216,
        long: 13.512935
    },
    {
        town: 'Smetanova Lhota',
        townCode: 549878,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39804,
        lat: 49.447708,
        long: 14.087266
    },
    {
        town: 'Smidary',
        townCode: 570869,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50353,
        lat: 50.291556,
        long: 15.477355
    },
    {
        town: 'Smilkov',
        townCode: 530611,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25789,
        lat: 49.602598,
        long: 14.617508
    },
    {
        town: 'Smilovice',
        townCode: 552658,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73955,
        lat: 49.660869,
        long: 18.571876
    },
    {
        town: 'Smilovice',
        townCode: 536652,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29442,
        lat: 50.306626,
        long: 14.961154
    },
    {
        town: 'Smilovice',
        townCode: 565407,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.247047,
        long: 13.807807
    },
    {
        town: 'Smilovy Hory',
        townCode: 553123,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39152,
        lat: 49.536512,
        long: 14.875956
    },
    {
        town: "Smi\u0159ice",
        townCode: 570877,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.299879,
        long: 15.865181
    },
    {
        town: "Smoln\xe9 Pece",
        townCode: 538027,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36225,
        lat: 50.291579,
        long: 12.765442
    },
    {
        town: 'Smolnice',
        townCode: 566721,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43914,
        lat: 50.308774,
        long: 13.848572
    },
    {
        town: 'Smolotely',
        townCode: 541311,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26263,
        lat: 49.620697,
        long: 14.135669
    },
    {
        town: "Smr\u010Dek",
        townCode: 573817,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.868517,
        long: 15.893381
    },
    {
        town: "Smr\u010Dn\xe1",
        townCode: 550299,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58801,
        lat: 49.471478,
        long: 15.537956
    },
    {
        town: 'Smrk',
        townCode: 591726,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67501,
        lat: 49.22568,
        long: 16.001974
    },
    {
        town: "Smr\u017Eice",
        townCode: 590029,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79817,
        lat: 49.505793,
        long: 17.107084
    },
    {
        town: "Smr\u017Eov",
        townCode: 561045,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.076158,
        long: 14.682477
    },
    {
        town: "Smr\u017Eov",
        townCode: 570885,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.299846,
        long: 15.917943
    },
    {
        town: "Smr\u017Eovka",
        townCode: 563811,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46851,
        lat: 50.738301,
        long: 15.246502
    },
    {
        town: "Sn\u011Bdovice",
        townCode: 565610,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41174,
        lat: 50.503633,
        long: 14.387857
    },
    {
        town: "Sn\u011Bt",
        townCode: 532436,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.626545,
        long: 15.226922
    },
    {
        town: "Sn\u011B\u017En\xe9",
        townCode: 596787,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.645617,
        long: 16.121753
    },
    {
        town: "Sn\u011B\u017En\xe9",
        townCode: 576794,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.340016,
        long: 16.277368
    },
    {
        town: "Snov\xeddky",
        townCode: 593591,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.132902,
        long: 17.106415
    },
    {
        town: "Sob\u010Dice",
        townCode: 573477,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.372376,
        long: 15.514931
    },
    {
        town: "Sob\u011Bhrdy",
        townCode: 530638,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.821122,
        long: 14.734312
    },
    {
        town: "Sob\u011Bchleby",
        townCode: 517844,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.478963,
        long: 17.651641
    },
    {
        town: "Sob\u011Bkury",
        townCode: 558346,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.576294,
        long: 13.239149
    },
    {
        town: "Sob\u011Bnov",
        townCode: 545805,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38241,
        lat: 48.762808,
        long: 14.545827
    },
    {
        town: "Sob\u011Braz",
        townCode: 573361,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50713,
        lat: 50.463465,
        long: 15.402094
    },
    {
        town: "Sob\u011Bslav",
        townCode: 553131,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.260039,
        long: 14.718717
    },
    {
        town: "Sob\u011Bslavice",
        townCode: 564401,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.605,
        long: 15.034217
    },
    {
        town: "Sob\u011Bsuky",
        townCode: 589004,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76802,
        lat: 49.233688,
        long: 17.359592
    },
    {
        town: "Sob\u011B\u0161ice",
        townCode: 557099,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.207905,
        long: 13.684205
    },
    {
        town: "Sob\u011B\u0161\xedn",
        townCode: 534293,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.791162,
        long: 14.955973
    },
    {
        town: "Sob\u011B\u0161ovice",
        townCode: 568791,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73938,
        lat: 49.724989,
        long: 18.4663
    },
    {
        town: "Sob\u011Btuchy",
        townCode: 572276,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.933341,
        long: 15.764066
    },
    {
        town: "Sob\xed\u0148ov",
        townCode: 569518,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58262,
        lat: 49.701095,
        long: 15.766977
    },
    {
        town: "Sob\xed\u0161ky",
        townCode: 517836,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75121,
        lat: 49.503857,
        long: 17.450876
    },
    {
        town: 'Sobkovice',
        townCode: 547964,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56164,
        lat: 50.048008,
        long: 16.595086
    },
    {
        town: "Sobot\xedn",
        townCode: 540986,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78816,
        lat: 50.011797,
        long: 17.090856
    },
    {
        town: 'Sobotka',
        townCode: 573493,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50743,
        lat: 50.467515,
        long: 15.176299
    },
    {
        town: 'Sobotovice',
        townCode: 583880,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66467,
        lat: 49.059999,
        long: 16.557396
    },
    {
        town: "Sob\u016Flky",
        townCode: 586552,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69701,
        lat: 49.01974,
        long: 17.079041
    },
    {
        town: 'Sojovice',
        townCode: 536661,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29475,
        lat: 50.222234,
        long: 14.762139
    },
    {
        town: "Sokole\u010D",
        townCode: 537811,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.098519,
        long: 15.107025
    },
    {
        town: 'Sokolnice',
        townCode: 583898,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66452,
        lat: 49.11402,
        long: 16.721665
    },
    {
        town: 'Sokolov',
        townCode: 560286,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.174629,
        long: 12.659992
    },
    {
        town: 'Solenice',
        townCode: 541320,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26263,
        lat: 49.617671,
        long: 14.195881
    },
    {
        town: 'Solnice',
        townCode: 576808,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51701,
        lat: 50.203755,
        long: 16.237723
    },
    {
        town: 'Sopotnice',
        townCode: 580961,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56115,
        lat: 50.059141,
        long: 16.345368
    },
    {
        town: "Sop\u0159e\u010D",
        townCode: 575666,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.093704,
        long: 15.556821
    },
    {
        town: "Sosnov\xe1",
        townCode: 562076,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47001,
        lat: 50.655151,
        long: 14.532396
    },
    {
        town: "Sosnov\xe1",
        townCode: 597821,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79312,
        lat: 49.998741,
        long: 17.663121
    },
    {
        town: "Sou\u0148ov",
        townCode: 531065,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.880122,
        long: 15.315664
    },
    {
        town: 'Sousedovice',
        townCode: 551759,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.232155,
        long: 13.868628
    },
    {
        town: 'Soutice',
        townCode: 599387,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25771,
        lat: 49.726208,
        long: 15.053023
    },
    {
        town: "Sov\u011Btice",
        townCode: 570907,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.307552,
        long: 15.705857
    },
    {
        town: "Sov\xednky",
        townCode: 565539,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29429,
        lat: 50.373175,
        long: 14.787182
    },
    {
        town: 'Sovolusky',
        townCode: 573027,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.969347,
        long: 15.5373
    },
    {
        town: "Sp\xe1len\xe9 Po\u0159\xed\u010D\xed",
        townCode: 558362,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33561,
        lat: 49.613815,
        long: 13.605669
    },
    {
        town: "Sp\xe1lov",
        townCode: 599867,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74237,
        lat: 49.704203,
        long: 17.722514
    },
    {
        town: "Sp\xe1\u0148ov",
        townCode: 554251,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.414624,
        long: 12.987415
    },
    {
        town: "Sp\u011Blkov",
        townCode: 596795,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59203,
        lat: 49.674861,
        long: 16.161048
    },
    {
        town: "Spe\u0161ov",
        townCode: 556963,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.394891,
        long: 16.629388
    },
    {
        town: 'Spojil',
        townCode: 574198,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.042269,
        long: 15.822517
    },
    {
        town: "Spomy\u0161l",
        townCode: 535192,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27705,
        lat: 50.33553,
        long: 14.360631
    },
    {
        town: "Spo\u0159ice",
        townCode: 563340,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43101,
        lat: 50.44104,
        long: 13.391931
    },
    {
        town: "Spytihn\u011Bv",
        townCode: 585793,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76364,
        lat: 49.141251,
        long: 17.498191
    },
    {
        town: 'Srbce',
        townCode: 590045,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79827,
        lat: 49.30241,
        long: 17.229132
    },
    {
        town: "Srbe\u010D",
        townCode: 542431,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27065,
        lat: 50.224713,
        long: 13.883458
    },
    {
        town: 'Srbice',
        townCode: 554260,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.508409,
        long: 13.118703
    },
    {
        town: 'Srbice',
        townCode: 567833,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.660759,
        long: 13.869399
    },
    {
        town: "Srbsk\xe1 Kamenice",
        townCode: 546348,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40715,
        lat: 50.820458,
        long: 14.352834
    },
    {
        town: 'Srbsko',
        townCode: 531758,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26718,
        lat: 49.937271,
        long: 14.136025
    },
    {
        town: 'Srby',
        townCode: 554278,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.536976,
        long: 12.868429
    },
    {
        town: 'Srby',
        townCode: 540676,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.519054,
        long: 13.603397
    },
    {
        town: 'Srch',
        townCode: 575682,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.084994,
        long: 15.763532
    },
    {
        town: "Srn\xed",
        townCode: 557111,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34192,
        lat: 49.087292,
        long: 13.480548
    },
    {
        town: "Srn\xedn",
        townCode: 536245,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38101,
        lat: 48.845115,
        long: 14.343803
    },
    {
        town: 'Srnojedy',
        townCode: 553719,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.039211,
        long: 15.702721
    },
    {
        town: 'Srubec',
        townCode: 545066,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37006,
        lat: 48.948161,
        long: 14.541407
    },
    {
        town: 'Sruby',
        townCode: 580970,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56544,
        lat: 49.996975,
        long: 16.174354
    },
    {
        town: "St\xe1dlec",
        townCode: 553140,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39162,
        lat: 49.3797,
        long: 14.495169
    },
    {
        town: 'Stachy',
        townCode: 550515,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38473,
        lat: 49.1019,
        long: 13.666687
    },
    {
        town: "St\xe1j",
        townCode: 587915,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.458085,
        long: 15.803502
    },
    {
        town: "St\xe1lky",
        townCode: 594792,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.870226,
        long: 15.684781
    },
    {
        town: "Sta\u0148kov",
        townCode: 562378,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37806,
        lat: 48.979627,
        long: 14.952798
    },
    {
        town: "Sta\u0148kov",
        townCode: 554294,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34561,
        lat: 49.553835,
        long: 13.06931
    },
    {
        town: "Sta\u0148kovice",
        townCode: 534412,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.875486,
        long: 15.015192
    },
    {
        town: "Sta\u0148kovice",
        townCode: 546828,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.589503,
        long: 14.167132
    },
    {
        town: "Sta\u0148kovice",
        townCode: 543128,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43949,
        lat: 50.349927,
        long: 13.571151
    },
    {
        town: 'Stanovice',
        townCode: 555550,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36001,
        lat: 50.165217,
        long: 12.874064
    },
    {
        town: 'Stanovice',
        townCode: 548812,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.400709,
        long: 15.871501
    },
    {
        town: "Stanovi\u0161t\u011B",
        townCode: 583901,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.239197,
        long: 16.253595
    },
    {
        town: "Star\xe1 \u010Cerven\xe1 Voda",
        townCode: 541036,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79053,
        lat: 50.329431,
        long: 17.201256
    },
    {
        town: "Star\xe1 Hu\u0165",
        townCode: 541338,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26202,
        lat: 49.782357,
        long: 14.197461
    },
    {
        town: "Star\xe1 Lys\xe1",
        townCode: 537837,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28926,
        lat: 50.224749,
        long: 14.799247
    },
    {
        town: "Star\xe1 Paka",
        townCode: 573507,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50791,
        lat: 50.510424,
        long: 15.49455
    },
    {
        town: "Star\xe1 \u0158\xed\u0161e",
        townCode: 587923,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58867,
        lat: 49.179652,
        long: 15.594868
    },
    {
        town: "Star\xe1 Ves",
        townCode: 551911,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79501,
        lat: 49.958482,
        long: 17.236572
    },
    {
        town: "Star\xe1 Ves",
        townCode: 517887,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75002,
        lat: 49.378741,
        long: 17.488182
    },
    {
        town: "Star\xe1 Ves nad Ond\u0159ejnic\xed",
        townCode: 598739,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73923,
        lat: 49.727472,
        long: 18.193435
    },
    {
        town: "Star\xe1 Voda",
        townCode: 539112,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.991631,
        long: 12.59591
    },
    {
        town: "Star\xe1 Voda",
        townCode: 570915,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50351,
        lat: 50.150422,
        long: 15.530668
    },
    {
        town: "Star\xe9 B\u0159\xed\u0161t\u011B",
        townCode: 561843,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.490839,
        long: 15.362636
    },
    {
        town: "Star\xe9 Buky",
        townCode: 579661,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54101,
        lat: 50.532161,
        long: 15.859366
    },
    {
        town: "Star\xe9 Hamry",
        townCode: 598747,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73915,
        lat: 49.472486,
        long: 18.44589
    },
    {
        town: "Star\xe9 He\u0159minovy",
        townCode: 551813,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79312,
        lat: 49.933251,
        long: 17.625765
    },
    {
        town: "Star\xe9 Hobz\xed",
        townCode: 547204,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37871,
        lat: 49.010499,
        long: 15.453308
    },
    {
        town: "Star\xe9 Hod\u011Bjovice",
        townCode: 545074,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37008,
        lat: 48.945486,
        long: 14.521073
    },
    {
        town: "Star\xe9 Hradi\u0161t\u011B",
        townCode: 575704,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53352,
        lat: 50.065498,
        long: 15.778951
    },
    {
        town: "Star\xe9 Hrady",
        townCode: 530735,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.386111,
        long: 15.213064
    },
    {
        town: "Star\xe9 Hut\u011B",
        townCode: 592587,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68601,
        lat: 49.129212,
        long: 17.277842
    },
    {
        town: "Star\xe9 Jesen\u010Dany",
        townCode: 575712,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.000581,
        long: 15.754182
    },
    {
        town: "Star\xe9 K\u0159e\u010Dany",
        townCode: 562823,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40761,
        lat: 50.950546,
        long: 14.496283
    },
    {
        town: "Star\xe9 M\u011Bsto",
        townCode: 551767,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 50.003657,
        long: 17.432173
    },
    {
        town: "Star\xe9 M\u011Bsto",
        townCode: 552551,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73801,
        lat: 49.670019,
        long: 18.363604
    },
    {
        town: "Star\xe9 M\u011Bsto",
        townCode: 541079,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78832,
        lat: 50.161832,
        long: 16.947446
    },
    {
        town: "Star\xe9 M\u011Bsto",
        townCode: 578789,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56932,
        lat: 49.794091,
        long: 16.675033
    },
    {
        town: "Star\xe9 M\u011Bsto",
        townCode: 550752,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68603,
        lat: 49.075248,
        long: 17.433488
    },
    {
        town: "Star\xe9 M\u011Bsto pod Land\u0161tejnem",
        townCode: 547212,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37882,
        lat: 49.00345,
        long: 15.254229
    },
    {
        town: "Star\xe9 M\xedsto",
        townCode: 549096,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.40511,
        long: 15.342338
    },
    {
        town: "Star\xe9 Sedli\u0161t\u011B",
        townCode: 561185,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34801,
        lat: 49.744446,
        long: 12.694252
    },
    {
        town: "Star\xe9 Sedlo",
        townCode: 560642,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.181807,
        long: 12.719941
    },
    {
        town: "Star\xe9 Sedlo",
        townCode: 561193,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34802,
        lat: 49.666003,
        long: 12.863729
    },
    {
        town: "Star\xe9 Smrkovice",
        townCode: 573523,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.336688,
        long: 15.494647
    },
    {
        town: "Star\xe9 T\u011Bchanovice",
        townCode: 568198,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74901,
        lat: 49.81838,
        long: 17.692077
    },
    {
        town: "Star\xe9 \u017Dd\xe1nice",
        townCode: 575721,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53344,
        lat: 50.124004,
        long: 15.720737
    },
    {
        town: "Starko\u010D",
        townCode: 530875,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.937353,
        long: 15.507667
    },
    {
        town: "St\xe1rkov",
        townCode: 574465,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54936,
        lat: 50.534022,
        long: 16.158279
    },
    {
        town: "Starosedlsk\xfd Hr\xe1dek",
        townCode: 564583,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.57629,
        long: 14.008329
    },
    {
        town: 'Starovice',
        townCode: 584894,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.951684,
        long: 16.706715
    },
    {
        town: "Starovi\u010Dky",
        townCode: 584908,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.907566,
        long: 16.775476
    },
    {
        town: "Star\xfd Byd\u017Eov",
        townCode: 573132,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50357,
        lat: 50.25854,
        long: 15.452434
    },
    {
        town: "Star\xfd Hrozenkov",
        townCode: 592609,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68774,
        lat: 48.965972,
        long: 17.86312
    },
    {
        town: "Star\xfd Ji\u010D\xedn",
        townCode: 599905,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74231,
        lat: 49.576961,
        long: 17.961801
    },
    {
        town: "Star\xfd Kol\xedn",
        townCode: 533700,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28123,
        lat: 50.009872,
        long: 15.293985
    },
    {
        town: "Star\xfd Mate\u0159ov",
        townCode: 575739,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 50.001737,
        long: 15.71522
    },
    {
        town: "Star\xfd Pet\u0159\xedn",
        townCode: 594806,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.890137,
        long: 15.734188
    },
    {
        town: "Star\xfd Plzenec",
        townCode: 558371,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33202,
        lat: 49.697786,
        long: 13.47361
    },
    {
        town: "Star\xfd Poddvorov",
        townCode: 586561,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69616,
        lat: 48.878704,
        long: 16.981633
    },
    {
        town: "Star\xfd \u0160achov",
        townCode: 545538,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.715168,
        long: 14.360479
    },
    {
        town: "Star\xfd Vestec",
        townCode: 534889,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28916,
        lat: 50.144821,
        long: 14.846456
    },
    {
        town: "Sta\u0159e\u010D",
        townCode: 591742,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67522,
        lat: 49.19793,
        long: 15.828017
    },
    {
        town: "Sta\u0159echovice",
        townCode: 590053,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79841,
        lat: 49.532985,
        long: 17.053825
    },
    {
        town: "Sta\u0159\xed\u010D",
        townCode: 552569,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73943,
        lat: 49.686041,
        long: 18.272916
    },
    {
        town: "Sta\u0161ov",
        townCode: 578801,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.674979,
        long: 16.369023
    },
    {
        town: "Sta\u0161ov",
        townCode: 531766,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.883446,
        long: 13.95763
    },
    {
        town: 'Statenice',
        townCode: 539686,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25262,
        lat: 50.142677,
        long: 14.318642
    },
    {
        town: 'Stavenice',
        townCode: 570281,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78973,
        lat: 49.786942,
        long: 16.973733
    },
    {
        town: "Stav\u011B\u0161ice",
        townCode: 586579,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69638,
        lat: 49.001739,
        long: 17.030565
    },
    {
        town: "St\xe9blov\xe1",
        townCode: 572934,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53345,
        lat: 50.092124,
        long: 15.746276
    },
    {
        town: 'Stebno',
        townCode: 546925,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.615203,
        long: 14.01732
    },
    {
        town: "St\u011Bbo\u0159ice",
        townCode: 510343,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74751,
        lat: 49.937181,
        long: 17.805574
    },
    {
        town: "Stehel\u010Deves",
        townCode: 532851,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27342,
        lat: 50.171748,
        long: 14.190956
    },
    {
        town: 'Stehlovice',
        townCode: 529885,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.393498,
        long: 14.322986
    },
    {
        town: "St\u011B\u017Eery",
        townCode: 570931,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50321,
        lat: 50.215821,
        long: 15.748412
    },
    {
        town: "St\xednava",
        townCode: 590061,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.495308,
        long: 16.934611
    },
    {
        town: 'Stod',
        townCode: 558389,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.639199,
        long: 13.164846
    },
    {
        town: 'Stochov',
        townCode: 532860,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27303,
        lat: 50.146411,
        long: 13.96356
    },
    {
        town: "Stoj\u010D\xedn",
        townCode: 561452,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39468,
        lat: 49.237781,
        long: 15.222001
    },
    {
        town: 'Stojice',
        townCode: 575755,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.956461,
        long: 15.614128
    },
    {
        town: 'Stolany',
        townCode: 547891,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.9279,
        long: 15.745214
    },
    {
        town: "Stona\u0159ov",
        townCode: 587931,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.282212,
        long: 15.585729
    },
    {
        town: 'Stonava',
        townCode: 599140,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73534,
        lat: 49.817011,
        long: 18.525286
    },
    {
        town: "Sto\u0161\xedkovice na Louce",
        townCode: 594814,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.896689,
        long: 16.214975
    },
    {
        town: "Sto\u017Eec",
        townCode: 550523,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38444,
        lat: 48.859471,
        long: 13.821516
    },
    {
        town: "Sto\u017Eice",
        townCode: 530034,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.132595,
        long: 14.150308
    },
    {
        town: "Stra\u010Dov",
        townCode: 570958,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50314,
        lat: 50.301628,
        long: 15.64079
    },
    {
        town: 'Stradonice',
        townCode: 599441,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27371,
        lat: 50.291461,
        long: 14.047036
    },
    {
        town: "Stradou\u0148",
        townCode: 572306,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53863,
        lat: 49.97246,
        long: 16.065657
    },
    {
        town: 'Strahovice',
        townCode: 512869,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74724,
        lat: 50.002181,
        long: 18.087213
    },
    {
        town: "Stracho\u0148ovice",
        townCode: 587940,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.135205,
        long: 15.488129
    },
    {
        town: 'Strachotice',
        townCode: 594822,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67129,
        lat: 48.796236,
        long: 16.1724
    },
    {
        town: "Strachot\xedn",
        townCode: 584916,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69301,
        lat: 48.905517,
        long: 16.651453
    },
    {
        town: 'Strachujov',
        townCode: 596809,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59242,
        lat: 49.613204,
        long: 16.226861
    },
    {
        town: 'Strakonice',
        townCode: 550787,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.260504,
        long: 13.910408
    },
    {
        town: 'Strakov',
        townCode: 578819,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.866605,
        long: 16.366914
    },
    {
        town: 'Straky',
        townCode: 537853,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28925,
        lat: 50.23368,
        long: 14.959345
    },
    {
        town: "Stran\u010Dice",
        townCode: 538809,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25163,
        lat: 49.948217,
        long: 14.677553
    },
    {
        town: "Str\xe1neck\xe1 Zho\u0159",
        townCode: 596817,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59442,
        lat: 49.380122,
        long: 15.927483
    },
    {
        town: "Str\xe1n\xed",
        townCode: 592617,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68765,
        lat: 48.902257,
        long: 17.706822
    },
    {
        town: "Str\xe1nka",
        townCode: 531731,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27735,
        lat: 50.423083,
        long: 14.661242
    },
    {
        town: "Strann\xfd",
        townCode: 599379,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25756,
        lat: 49.753854,
        long: 14.494082
    },
    {
        town: "Stra\u0161ice",
        townCode: 551775,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.202554,
        long: 13.729712
    },
    {
        town: "Stra\u0161ice",
        townCode: 560162,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33845,
        lat: 49.735624,
        long: 13.757656
    },
    {
        town: "Stra\u0161\xedn",
        townCode: 557129,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.179345,
        long: 13.640501
    },
    {
        town: "Stra\u0161kov-Vodochody",
        townCode: 565679,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41184,
        lat: 50.363689,
        long: 14.249643
    },
    {
        town: "Stra\u0161nov",
        townCode: 536709,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29431,
        lat: 50.351613,
        long: 14.889289
    },
    {
        town: "Stra\u0161ov",
        townCode: 575763,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.087564,
        long: 15.522806
    },
    {
        town: 'Stratov',
        townCode: 537861,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28922,
        lat: 50.19305,
        long: 14.90991
    },
    {
        town: "Str\xe1\u017E",
        townCode: 554316,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.414854,
        long: 12.913028
    },
    {
        town: "Str\xe1\u017E",
        townCode: 561207,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34802,
        lat: 49.668894,
        long: 12.775569
    },
    {
        town: "Str\xe1\u017E nad Ne\u017E\xe1rkou",
        townCode: 547221,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.069814,
        long: 14.905614
    },
    {
        town: "Str\xe1\u017E nad Nisou",
        townCode: 544477,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46303,
        lat: 50.791093,
        long: 15.026936
    },
    {
        town: "Str\xe1\u017E nad Oh\u0159\xed",
        townCode: 555584,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.337331,
        long: 13.051067
    },
    {
        town: "Str\xe1\u017E pod Ralskem",
        townCode: 562092,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47127,
        lat: 50.702903,
        long: 14.801127
    },
    {
        town: "Str\xe1\u017Eek",
        townCode: 596825,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59253,
        lat: 49.440836,
        long: 16.193422
    },
    {
        town: "Stra\u017Eisko",
        townCode: 590070,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79844,
        lat: 49.543242,
        long: 16.930233
    },
    {
        town: "Str\xe1\u017Ei\u0161t\u011B",
        townCode: 571881,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29413,
        lat: 50.592452,
        long: 14.929303
    },
    {
        town: "Str\xe1\u017Ekovice",
        townCode: 545082,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.899683,
        long: 14.569486
    },
    {
        town: "Str\xe1\u017En\xe1",
        townCode: 580988,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.911309,
        long: 16.71062
    },
    {
        town: "Str\xe1\u017En\xe9",
        townCode: 579696,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54352,
        lat: 50.663681,
        long: 15.615183
    },
    {
        town: "Str\xe1\u017Enice",
        townCode: 586587,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69662,
        lat: 48.901117,
        long: 17.31691
    },
    {
        town: "Str\xe1\u017En\xfd",
        townCode: 550531,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38443,
        lat: 48.908412,
        long: 13.720476
    },
    {
        town: "Str\xe1\u017Eov",
        townCode: 557137,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.30337,
        long: 13.246341
    },
    {
        town: "Str\xe1\u017Eovice",
        townCode: 586595,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69638,
        lat: 49.009307,
        long: 17.047511
    },
    {
        town: 'Strenice',
        townCode: 536717,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29430,
        lat: 50.392653,
        long: 14.82316
    },
    {
        town: "Strha\u0159e",
        townCode: 582379,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.435714,
        long: 16.436401
    },
    {
        town: 'Strmilov',
        townCode: 547239,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.158567,
        long: 15.199439
    },
    {
        town: 'Strojetice',
        townCode: 599361,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25765,
        lat: 49.651638,
        long: 15.066126
    },
    {
        town: "Strope\u0161\xedn",
        townCode: 587460,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67555,
        lat: 49.154144,
        long: 16.077352
    },
    {
        town: "Struha\u0159ov",
        townCode: 530689,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.765636,
        long: 14.762317
    },
    {
        town: "Struha\u0159ov",
        townCode: 538825,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25164,
        lat: 49.952026,
        long: 14.74454
    },
    {
        town: 'Strukov',
        townCode: 569054,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78401,
        lat: 49.733438,
        long: 17.175596
    },
    {
        town: "Strunkovice nad Blanic\xed",
        townCode: 550540,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38426,
        lat: 49.084131,
        long: 14.055317
    },
    {
        town: "Strunkovice nad Voly\u0148kou",
        townCode: 536784,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.2086,
        long: 13.889431
    },
    {
        town: "Strup\u010Dice",
        townCode: 563358,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43114,
        lat: 50.471126,
        long: 13.530649
    },
    {
        town: "Stru\u017Einec",
        townCode: 577545,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51251,
        lat: 50.550949,
        long: 15.358086
    },
    {
        town: "Stru\u017En\xe1",
        townCode: 555592,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36471,
        lat: 50.183216,
        long: 13.005785
    },
    {
        town: "Stru\u017Enice",
        townCode: 562106,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47002,
        lat: 50.696974,
        long: 14.450096
    },
    {
        town: "Str\xfd\u010Dice1)",
        townCode: 536032,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.011922,
        long: 14.266127
    },
    {
        town: "St\u0159edokluky",
        townCode: 539708,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25268,
        lat: 50.132287,
        long: 14.234301
    },
    {
        town: "St\u0159elice",
        townCode: 583910,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66447,
        lat: 49.152312,
        long: 16.50409
    },
    {
        town: "St\u0159elice",
        townCode: 594831,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.994181,
        long: 15.983267
    },
    {
        town: "St\u0159elice",
        townCode: 540056,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.630615,
        long: 13.134702
    },
    {
        town: "St\u0159eln\xe1",
        townCode: 544914,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.177303,
        long: 18.097917
    },
    {
        town: "St\u0159elsk\xe9 Ho\u0161tice",
        townCode: 551791,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38715,
        lat: 49.297703,
        long: 13.75606
    },
    {
        town: "St\u0159emo\u0161ice",
        townCode: 572314,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53854,
        lat: 49.89166,
        long: 16.072158
    },
    {
        town: "St\u0159emy",
        townCode: 535214,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27734,
        lat: 50.384262,
        long: 14.565624
    },
    {
        town: "St\u0159e\u0148",
        townCode: 547018,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78332,
        lat: 49.69162,
        long: 17.153923
    },
    {
        town: "St\u0159eva\u010D",
        townCode: 573540,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50722,
        lat: 50.404458,
        long: 15.274587
    },
    {
        town: "St\u0159ezetice",
        townCode: 570966,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50312,
        lat: 50.258368,
        long: 15.718242
    },
    {
        town: "St\u0159ezim\xed\u0159",
        townCode: 530701,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25787,
        lat: 49.532109,
        long: 14.611434
    },
    {
        town: "St\u0159\xedbrn\xe1",
        townCode: 560651,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.356766,
        long: 12.526519
    },
    {
        town: "St\u0159\xedbrn\xe1 Skalice",
        townCode: 533718,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28167,
        lat: 49.897765,
        long: 14.846268
    },
    {
        town: "St\u0159\xedbrn\xe9 Hory",
        townCode: 569534,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.601344,
        long: 15.691053
    },
    {
        town: "St\u0159\xedbrnice",
        townCode: 552887,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75201,
        lat: 49.328553,
        long: 17.24617
    },
    {
        town: "St\u0159\xedbrnice",
        townCode: 592625,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68709,
        lat: 49.05671,
        long: 17.307593
    },
    {
        town: "St\u0159\xedbro",
        townCode: 561215,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.753048,
        long: 13.004203
    },
    {
        town: "St\u0159\xedb\u0159ec",
        townCode: 547247,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37818,
        lat: 49.029989,
        long: 14.878351
    },
    {
        town: "St\u0159\xedlky",
        townCode: 589039,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76804,
        lat: 49.142634,
        long: 17.211177
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 551538,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.775738,
        long: 14.434542
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 587958,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58811,
        lat: 49.443643,
        long: 15.598749
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 537594,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.364014,
        long: 15.126619
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 554871,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.191417,
        long: 15.893355
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 549886,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59251,
        lat: 49.440602,
        long: 16.256802
    },
    {
        town: "St\u0159\xedte\u017E",
        townCode: 552674,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73959,
        lat: 49.67941,
        long: 18.569214
    },
    {
        town: "St\u0159\xedte\u017E nad Be\u010Dvou",
        townCode: 544922,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75652,
        lat: 49.458663,
        long: 18.056978
    },
    {
        town: "St\u0159\xedte\u017E nad Ludinou",
        townCode: 517909,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75363,
        lat: 49.609436,
        long: 17.739016
    },
    {
        town: "St\u0159\xedte\u017E pod K\u0159eme\u0161n\xedkem",
        townCode: 561487,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.434133,
        long: 15.320258
    },
    {
        town: "St\u0159\xed\u017Eov",
        townCode: 545091,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.890503,
        long: 14.527777
    },
    {
        town: "St\u0159\xed\u017Eovice",
        townCode: 508152,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.140007,
        long: 15.156956
    },
    {
        town: "St\u0159\xed\u017Eovice",
        townCode: 558401,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33207,
        lat: 49.611889,
        long: 13.458498
    },
    {
        town: "St\u0159\xed\u017Eovice",
        townCode: 589047,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.257184,
        long: 17.449702
    },
    {
        town: "Stud\xe1nka",
        townCode: 561223,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.780682,
        long: 12.603786
    },
    {
        town: "Studen\xe1",
        townCode: 547263,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37856,
        lat: 49.185258,
        long: 15.286981
    },
    {
        town: "Studen\xe1",
        townCode: 553603,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.960729,
        long: 13.643134
    },
    {
        town: "Studen\xe9",
        townCode: 580996,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56164,
        lat: 50.066658,
        long: 16.589294
    },
    {
        town: 'Studenec',
        townCode: 591769,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67502,
        lat: 49.20022,
        long: 16.064912
    },
    {
        town: 'Studenec',
        townCode: 577553,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51233,
        lat: 50.553543,
        long: 15.54947
    },
    {
        town: "Studen\u011Bves",
        townCode: 551457,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27379,
        lat: 50.224222,
        long: 14.044495
    },
    {
        town: "Stud\xe9nka",
        townCode: 599921,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74213,
        lat: 49.723516,
        long: 18.078634
    },
    {
        town: "Studen\xfd",
        townCode: 530719,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.607512,
        long: 15.127817
    },
    {
        town: 'Studnice',
        townCode: 593605,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68308,
        lat: 49.375694,
        long: 16.881134
    },
    {
        town: 'Studnice',
        townCode: 591777,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.291088,
        long: 16.029048
    },
    {
        town: 'Studnice',
        townCode: 574481,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54948,
        lat: 50.421368,
        long: 16.089978
    },
    {
        town: 'Studnice',
        townCode: 572322,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.738058,
        long: 15.90302
    },
    {
        town: 'Stupava',
        townCode: 592633,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68601,
        lat: 49.117266,
        long: 17.248767
    },
    {
        town: "Stvol\xednky",
        townCode: 562114,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47102,
        lat: 50.632379,
        long: 14.428717
    },
    {
        town: "Stvolov\xe1",
        townCode: 582620,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67961,
        lat: 49.589318,
        long: 16.540541
    },
    {
        town: "Sud\u011Bjov",
        townCode: 531391,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.860798,
        long: 15.103948
    },
    {
        town: 'Sudice',
        townCode: 582395,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.53,
        long: 16.668628
    },
    {
        town: 'Sudice',
        townCode: 591785,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67573,
        lat: 49.181993,
        long: 16.238291
    },
    {
        town: 'Sudice',
        townCode: 510378,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74725,
        lat: 50.031637,
        long: 18.068504
    },
    {
        town: "Sudislav nad Orlic\xed",
        townCode: 581003,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 49.989392,
        long: 16.313242
    },
    {
        town: 'Sudkov',
        townCode: 541109,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78821,
        lat: 49.919123,
        long: 16.945268
    },
    {
        town: "Sudom\u011B\u0159",
        townCode: 565920,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29425,
        lat: 50.445088,
        long: 14.739481
    },
    {
        town: "Sudom\u011B\u0159ice",
        townCode: 586609,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69666,
        lat: 48.867328,
        long: 17.256869
    },
    {
        town: "Sudom\u011B\u0159ice u Bechyn\u011B",
        townCode: 553166,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39172,
        lat: 49.289825,
        long: 14.538534
    },
    {
        town: "Sudom\u011B\u0159ice u T\xe1bora",
        townCode: 553174,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39136,
        lat: 49.510295,
        long: 14.658595
    },
    {
        town: 'Sudovo Hlavno',
        townCode: 571954,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29476,
        lat: 50.262851,
        long: 14.685423
    },
    {
        town: 'Sudslava',
        townCode: 581011,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56113,
        lat: 50.040677,
        long: 16.286549
    },
    {
        town: "Such\xe1",
        townCode: 587982,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58833,
        lat: 49.301108,
        long: 15.577541
    },
    {
        town: "Such\xe1 Lhota",
        townCode: 578835,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.877328,
        long: 16.173642
    },
    {
        town: "Such\xe1 Loz",
        townCode: 592641,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68753,
        lat: 48.970109,
        long: 17.713899
    },
    {
        town: 'Suchdol',
        townCode: 590088,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79845,
        lat: 49.547269,
        long: 16.896773
    },
    {
        town: 'Suchdol',
        townCode: 534439,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28502,
        lat: 49.95257,
        long: 15.166616
    },
    {
        town: "Suchdol nad Lu\u017Enic\xed",
        townCode: 547280,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37806,
        lat: 48.893435,
        long: 14.877056
    },
    {
        town: 'Suchdol nad Odrou',
        townCode: 599930,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74201,
        lat: 49.65582,
        long: 17.928263
    },
    {
        town: 'Suchodol',
        townCode: 541371,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.724148,
        long: 14.082522
    },
    {
        town: 'Suchohrdly',
        townCode: 555231,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.866218,
        long: 16.089121
    },
    {
        town: 'Suchohrdly u Miroslavi',
        townCode: 594849,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67172,
        lat: 48.943156,
        long: 16.363302
    },
    {
        town: 'Suchomasty',
        townCode: 531782,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26722,
        lat: 49.895459,
        long: 14.056714
    },
    {
        town: 'Suchonice',
        townCode: 569771,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78357,
        lat: 49.527138,
        long: 17.382014
    },
    {
        town: 'Suchov',
        townCode: 586617,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69671,
        lat: 48.907522,
        long: 17.563562
    },
    {
        town: "Suchovr\u0161ice",
        townCode: 579726,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54232,
        lat: 50.523502,
        long: 15.99831
    },
    {
        town: "Such\xfd",
        townCode: 582409,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.482895,
        long: 16.762483
    },
    {
        town: "Such\xfd D\u016Fl",
        townCode: 574490,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54962,
        lat: 50.540173,
        long: 16.265476
    },
    {
        town: 'Sukorady',
        townCode: 548880,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.325546,
        long: 15.582808
    },
    {
        town: 'Sukorady',
        townCode: 536768,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.426341,
        long: 15.029101
    },
    {
        town: 'Sulejovice',
        townCode: 565695,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41111,
        lat: 50.498891,
        long: 14.037519
    },
    {
        town: 'Sulice',
        townCode: 538833,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25168,
        lat: 49.925727,
        long: 14.556739
    },
    {
        town: "Sul\xedkov",
        townCode: 582417,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.544691,
        long: 16.489716
    },
    {
        town: 'Sulimov',
        townCode: 589055,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.226782,
        long: 17.422982
    },
    {
        town: 'Sulislav',
        townCode: 561231,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.748658,
        long: 13.072824
    },
    {
        town: 'Sulkovec',
        townCode: 596833,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.60943,
        long: 16.309674
    },
    {
        town: "Sup\xedkovice",
        townCode: 541117,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79051,
        lat: 50.297785,
        long: 17.255253
    },
    {
        town: "Su\u0161ice",
        townCode: 518026,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.486027,
        long: 17.537486
    },
    {
        town: "Su\u0161ice",
        townCode: 557153,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.231776,
        long: 13.520509
    },
    {
        town: "Su\u0161ice",
        townCode: 592650,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68704,
        lat: 49.122346,
        long: 17.452331
    },
    {
        town: "Sv\xe1rov",
        townCode: 599433,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.062028,
        long: 14.15064
    },
    {
        town: "Sv\xe1rov",
        townCode: 592668,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.116539,
        long: 17.62464
    },
    {
        town: "Svat\xe1",
        townCode: 531791,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.939239,
        long: 13.961726
    },
    {
        town: "Svat\xe1 Ma\u0159\xed",
        townCode: 550558,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38501,
        lat: 49.064631,
        long: 13.831531
    },
    {
        town: 'Svatava',
        townCode: 538434,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35703,
        lat: 50.192341,
        long: 12.625358
    },
    {
        town: "Svat\xe9 Pole",
        townCode: 541389,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.751419,
        long: 14.169084
    },
    {
        town: "Svatobo\u0159ice-Mist\u0159\xedn",
        townCode: 586625,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69604,
        lat: 48.977127,
        long: 17.089396
    },
    {
        town: "Svatojansk\xfd \xdajezd",
        townCode: 573302,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50781,
        lat: 50.42605,
        long: 15.543039
    },
    {
        town: "Svato\u0148ovice",
        townCode: 547131,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74787,
        lat: 49.793607,
        long: 17.667329
    },
    {
        town: 'Svatoslav',
        townCode: 583928,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.30187,
        long: 16.308896
    },
    {
        town: 'Svatoslav',
        townCode: 591793,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67507,
        lat: 49.31921,
        long: 15.848599
    },
    {
        town: "Svat\xfd Jan",
        townCode: 541397,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26256,
        lat: 49.636938,
        long: 14.311096
    },
    {
        town: "Svat\xfd Jan nad Mal\u0161\xed",
        townCode: 545104,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37323,
        lat: 48.824139,
        long: 14.508621
    },
    {
        town: "Svat\xfd Jan pod Skalou",
        townCode: 531804,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 49.969011,
        long: 14.133272
    },
    {
        town: "Svat\xfd Ji\u0159\xed",
        townCode: 580708,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 49.972104,
        long: 16.270429
    },
    {
        town: "Svat\xfd Mikul\xe1\u0161",
        townCode: 534196,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.991014,
        long: 15.350597
    },
    {
        town: "Sv\xe9bohov",
        townCode: 541125,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.92004,
        long: 16.839277
    },
    {
        town: "Sv\xe9myslice",
        townCode: 598305,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25091,
        lat: 50.146005,
        long: 14.648214
    },
    {
        town: "Sv\xe9pravice",
        townCode: 598763,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.495694,
        long: 15.232792
    },
    {
        town: "Sv\xe9radice",
        townCode: 557161,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.371445,
        long: 13.739694
    },
    {
        town: "Sv\xe9sedlice",
        townCode: 552429,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78354,
        lat: 49.572579,
        long: 17.381252
    },
    {
        town: "Sv\u011Btce",
        townCode: 561029,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.270655,
        long: 14.941505
    },
    {
        town: "Sv\u011Btec",
        townCode: 567841,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41753,
        lat: 50.576236,
        long: 13.811707
    },
    {
        town: "Sv\u011Bt\xed",
        townCode: 548154,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50312,
        lat: 50.257478,
        long: 15.775579
    },
    {
        town: "Sv\u011Btice",
        townCode: 538841,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.970179,
        long: 14.665911
    },
    {
        town: "Sv\u011Btl\xe1",
        townCode: 586064,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67963,
        lat: 49.565958,
        long: 16.718297
    },
    {
        town: "Sv\u011Btl\xe1 Hora",
        townCode: 597872,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79331,
        lat: 50.046192,
        long: 17.399982
    },
    {
        town: "Sv\u011Btl\xe1 nad S\xe1zavou",
        townCode: 569569,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.66811,
        long: 15.404038
    },
    {
        town: "Sv\u011Btl\xe1 pod Je\u0161t\u011Bdem",
        townCode: 564427,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46343,
        lat: 50.711344,
        long: 14.986005
    },
    {
        town: "Sv\u011Btl\xedk",
        townCode: 545813,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38216,
        lat: 48.731761,
        long: 14.21107
    },
    {
        town: "Sv\u011Btnov",
        townCode: 596841,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59102,
        lat: 49.620631,
        long: 15.955318
    },
    {
        town: 'Sviadnov',
        townCode: 569631,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73925,
        lat: 49.689354,
        long: 18.327726
    },
    {
        town: "Sv\xeddnice",
        townCode: 548693,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.086151,
        long: 16.223384
    },
    {
        town: "Sv\xeddnice",
        townCode: 572331,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53824,
        lat: 49.890007,
        long: 15.813804
    },
    {
        town: "Svijansk\xfd \xdajezd",
        townCode: 564435,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46345,
        lat: 50.587332,
        long: 15.043456
    },
    {
        town: 'Svijany',
        townCode: 564443,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46346,
        lat: 50.572684,
        long: 15.063976
    },
    {
        town: "Svina\u0159e",
        townCode: 531812,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26728,
        lat: 49.891728,
        long: 14.1844
    },
    {
        town: "Svina\u0159ov",
        townCode: 532908,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27305,
        lat: 50.181412,
        long: 14.050377
    },
    {
        town: "Svin\u010Dany",
        townCode: 575771,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.976687,
        long: 15.639615
    },
    {
        town: "Svino\u0161ice",
        townCode: 582433,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.334534,
        long: 16.576
    },
    {
        town: 'Sviny',
        townCode: 553182,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.187242,
        long: 14.63601
    },
    {
        town: 'Sviny',
        townCode: 596850,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59451,
        lat: 49.364289,
        long: 16.085112
    },
    {
        town: "Svit\xe1vka",
        townCode: 582441,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67932,
        lat: 49.501876,
        long: 16.598037
    },
    {
        town: 'Svitavy',
        townCode: 577731,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56802,
        lat: 49.755263,
        long: 16.469286
    },
    {
        town: "Svoboda nad \xdapou",
        townCode: 579734,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54224,
        lat: 50.626061,
        long: 15.816588
    },
    {
        town: "Svobodn\xe9 He\u0159manice",
        townCode: 597881,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79313,
        lat: 49.946147,
        long: 17.674365
    },
    {
        town: 'Svojanov',
        townCode: 578843,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56973,
        lat: 49.624723,
        long: 16.410306
    },
    {
        town: 'Svojek',
        townCode: 577561,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 50791,
        lat: 50.553516,
        long: 15.455663
    },
    {
        town: 'Svojetice',
        townCode: 538850,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25162,
        lat: 49.971526,
        long: 14.7386
    },
    {
        town: "Svojet\xedn",
        townCode: 542458,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27004,
        lat: 50.190121,
        long: 13.621021
    },
    {
        town: 'Svojkov',
        townCode: 546283,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47153,
        lat: 50.719575,
        long: 14.599127
    },
    {
        town: 'Svojkovice',
        townCode: 587991,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.166246,
        long: 15.635608
    },
    {
        town: 'Svojkovice',
        townCode: 541176,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33822,
        lat: 49.759974,
        long: 13.648336
    },
    {
        town: "Svoj\u0161ice",
        townCode: 575780,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53362,
        lat: 49.965437,
        long: 15.601078
    },
    {
        town: "Svoj\u0161ice",
        townCode: 533726,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28107,
        lat: 50.003239,
        long: 15.043205
    },
    {
        town: "Svoj\u0161ice",
        townCode: 564273,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.572827,
        long: 14.042977
    },
    {
        town: "Svoj\u0161\xedn",
        townCode: 561258,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.766164,
        long: 12.910779
    },
    {
        town: 'Svor',
        townCode: 562131,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47151,
        lat: 50.7919,
        long: 14.596917
    },
    {
        town: 'Svrabov',
        townCode: 563170,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39131,
        lat: 49.447575,
        long: 14.626643
    },
    {
        town: 'Svratka',
        townCode: 596868,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59202,
        lat: 49.710763,
        long: 16.032241
    },
    {
        town: 'Svratouch',
        townCode: 572349,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53942,
        lat: 49.72454,
        long: 16.034289
    },
    {
        town: "Svrkyn\u011B",
        townCode: 571342,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25264,
        lat: 50.171469,
        long: 14.294955
    },
    {
        town: 'Sychrov',
        townCode: 564451,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46344,
        lat: 50.626916,
        long: 15.088809
    },
    {
        town: "S\xfdko\u0159ice",
        townCode: 542466,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27024,
        lat: 50.034689,
        long: 13.931831
    },
    {
        town: 'Synalov',
        townCode: 582450,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.432831,
        long: 16.413973
    },
    {
        town: 'Synkov-Slemeno',
        townCode: 576816,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51601,
        lat: 50.145372,
        long: 16.219056
    },
    {
        town: 'Syrov',
        townCode: 598771,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.578021,
        long: 15.177802
    },
    {
        town: "Syrov\xe1tka",
        townCode: 571008,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.154859,
        long: 15.662838
    },
    {
        town: 'Syrovice',
        townCode: 583936,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66467,
        lat: 49.079913,
        long: 16.546565
    },
    {
        town: "Syrov\xedn",
        townCode: 586633,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69684,
        lat: 49.025923,
        long: 17.264039
    },
    {
        town: "Sy\u0159enov",
        townCode: 577570,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51251,
        lat: 50.498928,
        long: 15.427821
    },
    {
        town: 'Sytno',
        townCode: 557081,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.739789,
        long: 13.041764
    },
    {
        town: "\u0160abina",
        townCode: 538396,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.135748,
        long: 12.582432
    },
    {
        town: "\u0160afov",
        townCode: 594865,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67106,
        lat: 48.866906,
        long: 15.734756
    },
    {
        town: "\u0160akvice",
        townCode: 584924,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69167,
        lat: 48.897558,
        long: 16.714344
    },
    {
        town: "\u0160anov",
        townCode: 594873,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67168,
        lat: 48.800986,
        long: 16.378684
    },
    {
        town: "\u0160anov",
        townCode: 542474,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27031,
        lat: 50.087735,
        long: 13.631307
    },
    {
        town: "\u0160anov",
        townCode: 585807,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76321,
        lat: 49.045564,
        long: 17.898513
    },
    {
        town: "\u0160aplava",
        townCode: 571016,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50353,
        lat: 50.315142,
        long: 15.542057
    },
    {
        town: "\u0160aratice",
        townCode: 593613,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68352,
        lat: 49.117564,
        long: 16.803613
    },
    {
        town: "\u0160ardice",
        townCode: 586641,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69613,
        lat: 48.964128,
        long: 17.028222
    },
    {
        town: "\u0160\xe1rovcova Lhota",
        townCode: 573256,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50759,
        lat: 50.407609,
        long: 15.562386
    },
    {
        town: "\u0160arovy",
        townCode: 585815,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76351,
        lat: 49.148682,
        long: 17.606966
    },
    {
        town: "\u0160atov",
        townCode: 594881,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67122,
        lat: 48.793274,
        long: 16.010024
    },
    {
        town: "\u0160ebest\u011Bnice",
        townCode: 531421,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.829543,
        long: 15.365413
    },
    {
        town: "\u0160ebetov",
        townCode: 582468,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67935,
        lat: 49.548719,
        long: 16.711728
    },
    {
        town: "\u0160eb\xed\u0159ov",
        townCode: 553204,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.566211,
        long: 14.82603
    },
    {
        town: "\u0160ebkovice",
        townCode: 591807,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67545,
        lat: 49.123204,
        long: 15.813715
    },
    {
        town: "\u0160ebrov-Kate\u0159ina",
        townCode: 582476,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.328598,
        long: 16.602548
    },
    {
        town: "\u0160edivec",
        townCode: 581038,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.04929,
        long: 16.535815
    },
    {
        town: "\u0160ele\u0161ovice",
        townCode: 557188,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76701,
        lat: 49.254875,
        long: 17.36013
    },
    {
        town: "\u0160emnice",
        townCode: 555614,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36272,
        lat: 50.237016,
        long: 12.976213
    },
    {
        town: "\u0160enov",
        townCode: 598798,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73934,
        lat: 49.793249,
        long: 18.376174
    },
    {
        town: "\u0160enov u Nov\xe9ho Ji\u010D\xedna",
        townCode: 554171,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74242,
        lat: 49.604647,
        long: 18.003387
    },
    {
        town: "\u0160erkovice",
        townCode: 583944,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.38568,
        long: 16.430063
    },
    {
        town: "\u0160estajovice",
        townCode: 547654,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.341229,
        long: 16.008082
    },
    {
        town: "\u0160estajovice",
        townCode: 538876,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25092,
        lat: 50.10852,
        long: 14.681812
    },
    {
        town: "\u0160et\u011Bjovice",
        townCode: 532509,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.645276,
        long: 15.222583
    },
    {
        town: "\u0160ev\u011Bt\xedn",
        townCode: 545121,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37363,
        lat: 49.100158,
        long: 14.572298
    },
    {
        town: "\u0160ilhe\u0159ovice",
        townCode: 510432,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74715,
        lat: 49.926122,
        long: 18.270274
    },
    {
        town: "\u0160imanov",
        townCode: 588008,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.458171,
        long: 15.450115
    },
    {
        town: "\u0160imonovice",
        townCode: 564460,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46312,
        lat: 50.706477,
        long: 15.052732
    },
    {
        town: "\u0160indelov\xe1",
        townCode: 560677,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35801,
        lat: 50.318764,
        long: 12.603439
    },
    {
        town: "\u0160\xedpy",
        townCode: 598496,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27034,
        lat: 50.014425,
        long: 13.616563
    },
    {
        town: "\u0160irok\xe1 Niva",
        townCode: 597899,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 50.063922,
        long: 17.480203
    },
    {
        town: "\u0160irok\xfd D\u016Fl",
        townCode: 578851,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57201,
        lat: 49.746139,
        long: 16.220866
    },
    {
        town: "\u0160i\u0161ma",
        townCode: 552950,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75111,
        lat: 49.464011,
        long: 17.588144
    },
    {
        town: "\u0160itbo\u0159ice",
        townCode: 584932,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69176,
        lat: 49.014427,
        long: 16.77986
    },
    {
        town: "\u0160krdlovice",
        townCode: 596876,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.634772,
        long: 15.926038
    },
    {
        town: "\u0160kvorec",
        townCode: 538884,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25083,
        lat: 50.046972,
        long: 14.730519
    },
    {
        town: "\u0160kvo\u0159etice",
        townCode: 551830,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.402515,
        long: 13.949224
    },
    {
        town: "\u0160lapanice",
        townCode: 583952,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66451,
        lat: 49.168729,
        long: 16.727418
    },
    {
        town: "\u0160lapanice",
        townCode: 532916,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27372,
        lat: 50.314773,
        long: 14.111319
    },
    {
        town: "\u0160lapanov",
        townCode: 569585,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58251,
        lat: 49.542525,
        long: 15.657789
    },
    {
        town: "\u0160l\xe9glov",
        townCode: 570117,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78825,
        lat: 50.153075,
        long: 16.982641
    },
    {
        town: "\u0160luknov",
        townCode: 562858,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40777,
        lat: 51.003793,
        long: 14.452699
    },
    {
        town: "\u0160onov",
        townCode: 574511,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54971,
        lat: 50.590932,
        long: 16.401645
    },
    {
        town: "\u0160o\u0161\u016Fvka",
        townCode: 582484,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67913,
        lat: 49.410633,
        long: 16.751985
    },
    {
        town: "\u0160pi\u010Dky",
        townCode: 570061,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75366,
        lat: 49.548258,
        long: 17.807885
    },
    {
        town: "\u0160pindler\u016Fv Ml\xfdn",
        townCode: 579742,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54351,
        lat: 50.72625,
        long: 15.609549
    },
    {
        town: "\u0160t\xe1blovice",
        townCode: 568333,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74782,
        lat: 49.880131,
        long: 17.818639
    },
    {
        town: "\u0160\u0165\xe1hlavy",
        townCode: 558427,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33203,
        lat: 49.675659,
        long: 13.504047
    },
    {
        town: "\u0160tarnov",
        townCode: 552011,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78314,
        lat: 49.686232,
        long: 17.272686
    },
    {
        town: "\u0160t\u011Bdr\xe1",
        townCode: 555622,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36452,
        lat: 50.058313,
        long: 13.114279
    },
    {
        town: "\u0160t\u011Bchov",
        townCode: 582492,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.452359,
        long: 16.506182
    },
    {
        town: "\u0160t\u011Bchovice",
        townCode: 536920,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.255508,
        long: 13.765623
    },
    {
        town: "\u0160t\u011Bchovice",
        townCode: 539732,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25207,
        lat: 49.851197,
        long: 14.405534
    },
    {
        town: "\u0160t\u011Bke\u0148",
        townCode: 551856,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38751,
        lat: 49.267249,
        long: 14.005988
    },
    {
        town: "\u0160t\u011Bm\u011Bchy",
        townCode: 591815,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67527,
        lat: 49.193393,
        long: 15.714768
    },
    {
        town: "\u0160t\u011Bnovice",
        townCode: 558435,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33209,
        lat: 49.670623,
        long: 13.399739
    },
    {
        town: "\u0160t\u011Bnovick\xfd Borek",
        townCode: 539741,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33209,
        lat: 49.649772,
        long: 13.426875
    },
    {
        town: "\u0160t\u011Bp\xe1nkovice",
        townCode: 510483,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74728,
        lat: 49.95748,
        long: 18.037518
    },
    {
        town: "\u0160t\u011Bp\xe1nov",
        townCode: 505161,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78313,
        lat: 49.684136,
        long: 17.220518
    },
    {
        town: "\u0160t\u011Bp\xe1nov nad Svratkou",
        townCode: 596884,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59263,
        lat: 49.504688,
        long: 16.339224
    },
    {
        town: "\u0160t\u011Bp\xe1novice",
        townCode: 545139,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37373,
        lat: 49.00193,
        long: 14.653443
    },
    {
        town: "\u0160t\u011Bp\xe1novice",
        townCode: 583961,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66602,
        lat: 49.373052,
        long: 16.387683
    },
    {
        town: "\u0160t\u011Bpkov",
        townCode: 591823,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.084115,
        long: 15.650302
    },
    {
        town: "\u0160ternberk",
        townCode: 505188,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78501,
        lat: 49.730542,
        long: 17.298995
    },
    {
        town: "\u0160t\u011Bt\xed",
        townCode: 565709,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41108,
        lat: 50.453087,
        long: 14.374322
    },
    {
        town: "\u0160t\u011Btkovice",
        townCode: 541419,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26401,
        lat: 49.670811,
        long: 14.506319
    },
    {
        town: "\u0160t\xedhlice",
        townCode: 571644,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 50.005666,
        long: 14.780051
    },
    {
        town: "\u0160tichov",
        townCode: 566101,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.585019,
        long: 13.048969
    },
    {
        town: "\u0160tichovice",
        townCode: 578797,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.977911,
        long: 13.302933
    },
    {
        town: "\u0160tipoklasy",
        townCode: 530930,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.824707,
        long: 15.213391
    },
    {
        town: "\u0160t\xedtary",
        townCode: 594890,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.935202,
        long: 15.844388
    },
    {
        town: "\u0160t\xedtina",
        townCode: 510491,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74791,
        lat: 49.914966,
        long: 18.012559
    },
    {
        town: "\u0160t\xedtn\xe1 nad Vl\xe1\u0159\xed-Popov",
        townCode: 585831,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76333,
        lat: 49.070718,
        long: 17.972465
    },
    {
        town: "\u0160t\xedtov",
        townCode: 579343,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.666038,
        long: 13.678024
    },
    {
        town: "\u0160t\xedty",
        townCode: 541168,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78991,
        lat: 49.961321,
        long: 16.765863
    },
    {
        town: "\u0160toky",
        townCode: 569593,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58253,
        lat: 49.502586,
        long: 15.588733
    },
    {
        town: "\u0160tramberk",
        townCode: 599948,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74266,
        lat: 49.591905,
        long: 18.117521
    },
    {
        town: "\u0160tudlov",
        townCode: 578860,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.602645,
        long: 16.498432
    },
    {
        town: "\u0160tudlov",
        townCode: 544931,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.162525,
        long: 18.083277
    },
    {
        town: "\u0160ub\xed\u0159ov",
        townCode: 590096,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79852,
        lat: 49.602264,
        long: 16.813444
    },
    {
        town: "\u0160umavsk\xe9 Ho\u0161tice",
        townCode: 550574,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38471,
        lat: 49.039501,
        long: 13.872365
    },
    {
        town: "\u0160umice",
        townCode: 594903,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67175,
        lat: 48.9922,
        long: 16.437469
    },
    {
        town: "\u0160umice",
        townCode: 592676,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68731,
        lat: 49.028682,
        long: 17.72216
    },
    {
        town: "\u0160umn\xe1",
        townCode: 594911,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.922527,
        long: 15.871054
    },
    {
        town: "\u0160umperk",
        townCode: 523704,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78701,
        lat: 49.977941,
        long: 16.971875
    },
    {
        town: "\u0160umvald",
        townCode: 505218,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78385,
        lat: 49.831136,
        long: 17.132851
    },
    {
        town: "\u0160v\xe1benice",
        townCode: 593621,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68323,
        lat: 49.278501,
        long: 17.123499
    },
    {
        town: "\u0160v\xe1bov",
        townCode: 547255,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58851,
        lat: 49.308525,
        long: 15.357131
    },
    {
        town: "\u0160vihov",
        townCode: 557200,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34012,
        lat: 49.481466,
        long: 13.284281
    },
    {
        town: "\u0160vihov",
        townCode: 565326,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27033,
        lat: 50.109935,
        long: 13.5644
    },
    {
        town: "T\xe1bor",
        townCode: 552046,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.413089,
        long: 14.677566
    },
    {
        town: 'Tachlovice',
        townCode: 531821,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25217,
        lat: 50.014555,
        long: 14.240788
    },
    {
        town: 'Tachov',
        townCode: 553638,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.543414,
        long: 14.638554
    },
    {
        town: 'Tachov',
        townCode: 560715,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34701,
        lat: 49.79888,
        long: 12.636292
    },
    {
        town: "T\xe1l\xedn",
        townCode: 549932,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39815,
        lat: 49.247661,
        long: 14.227263
    },
    {
        town: 'Tanvald',
        townCode: 563820,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46841,
        lat: 50.737629,
        long: 15.307982
    },
    {
        town: 'Tasov',
        townCode: 586650,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69663,
        lat: 48.906964,
        long: 17.429767
    },
    {
        town: 'Tasov',
        townCode: 591831,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67579,
        lat: 49.288374,
        long: 16.094889
    },
    {
        town: 'Tasovice',
        townCode: 582506,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.496043,
        long: 16.441633
    },
    {
        town: 'Tasovice',
        townCode: 594920,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67125,
        lat: 48.836196,
        long: 16.155687
    },
    {
        town: "Ta\u0161ov",
        townCode: 568287,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.614624,
        long: 14.135906
    },
    {
        town: 'Tatce',
        townCode: 537888,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.091224,
        long: 14.977345
    },
    {
        town: 'Tatenice',
        townCode: 581046,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56131,
        lat: 49.871076,
        long: 16.697311
    },
    {
        town: "Tatin\xe1",
        townCode: 578983,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.848699,
        long: 13.299824
    },
    {
        town: 'Tatobity',
        townCode: 577596,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51253,
        lat: 50.571343,
        long: 15.273268
    },
    {
        town: 'Tatrovice',
        townCode: 538663,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35735,
        lat: 50.276819,
        long: 12.697409
    },
    {
        town: "Tav\xedkovice",
        townCode: 594938,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 49.033846,
        long: 16.103265
    },
    {
        town: "Te\u010Dovice",
        townCode: 549649,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76302,
        lat: 49.221167,
        long: 17.587443
    },
    {
        town: 'Tehov',
        townCode: 530751,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.735542,
        long: 14.966838
    },
    {
        town: 'Tehov',
        townCode: 538892,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25101,
        lat: 49.97162,
        long: 14.693897
    },
    {
        town: 'Tehovec',
        townCode: 599719,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25162,
        lat: 49.981597,
        long: 14.730399
    },
    {
        town: "T\u011Bcha\u0159ovice",
        townCode: 529664,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.599507,
        long: 14.048897
    },
    {
        town: "T\u011Bchlovice",
        townCode: 571024,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.207992,
        long: 15.711159
    },
    {
        town: "T\u011Bchlovice",
        townCode: 555193,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.696428,
        long: 14.205036
    },
    {
        town: "T\u011Bchobuz",
        townCode: 561355,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.510188,
        long: 14.930738
    },
    {
        town: "T\u011Bchon\xedn",
        townCode: 581054,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56166,
        lat: 50.065031,
        long: 16.618015
    },
    {
        town: "Tel\u010D",
        townCode: 588024,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.183338,
        long: 15.454373
    },
    {
        town: "Telec\xed",
        townCode: 578878,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56994,
        lat: 49.694722,
        long: 16.180806
    },
    {
        town: 'Telnice',
        townCode: 583979,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66459,
        lat: 49.101969,
        long: 16.71785
    },
    {
        town: 'Telnice',
        townCode: 568295,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40338,
        lat: 50.733064,
        long: 13.957891
    },
    {
        town: "Temel\xedn",
        townCode: 545155,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37301,
        lat: 49.19294,
        long: 14.348847
    },
    {
        town: "Teme\u0161v\xe1r",
        townCode: 562271,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.356486,
        long: 14.263631
    },
    {
        town: "T\u011Bmice",
        townCode: 586668,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69684,
        lat: 49.00165,
        long: 17.265026
    },
    {
        town: "T\u011Bmice",
        townCode: 548936,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39496,
        lat: 49.351896,
        long: 15.060549
    },
    {
        town: "T\u011Bn\u011B",
        townCode: 560189,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33845,
        lat: 49.7513,
        long: 13.796268
    },
    {
        town: "Tepl\xe1",
        townCode: 555631,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36461,
        lat: 49.981953,
        long: 12.86316
    },
    {
        town: 'Teplice',
        townCode: 567442,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.644558,
        long: 13.835384
    },
    {
        town: "Teplice nad Be\u010Dvou",
        townCode: 519031,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.528613,
        long: 17.74019
    },
    {
        town: "Teplice nad Metuj\xed",
        townCode: 574538,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54957,
        lat: 50.59443,
        long: 16.170483
    },
    {
        town: "Tepli\u010Dka",
        townCode: 537845,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36464,
        lat: 50.148702,
        long: 12.85168
    },
    {
        town: "Tepl\xfd\u0161ovice",
        townCode: 530760,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.806208,
        long: 14.801688
    },
    {
        town: "Tere\u0161ov",
        townCode: 566802,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.896783,
        long: 13.69985
    },
    {
        town: "Terez\xedn",
        townCode: 586676,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69614,
        lat: 48.955636,
        long: 16.942659
    },
    {
        town: "Terez\xedn",
        townCode: 565717,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41155,
        lat: 50.511102,
        long: 14.150658
    },
    {
        town: "T\u011Brlicko",
        townCode: 599158,
        district: "Karvin\xe1",
        lau: 'CZ0803',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73542,
        lat: 49.752419,
        long: 18.48302
    },
    {
        town: "T\u011B\u0161any",
        townCode: 583995,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66454,
        lat: 49.039658,
        long: 16.770132
    },
    {
        town: "T\u011B\u0161etice",
        townCode: 594946,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.888944,
        long: 16.158304
    },
    {
        town: "T\u011B\u0161etice",
        townCode: 505269,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78346,
        lat: 49.593272,
        long: 17.126175
    },
    {
        town: "T\u011B\u0161kov",
        townCode: 546526,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.802297,
        long: 13.698135
    },
    {
        town: "T\u011B\u0161kovice",
        townCode: 512745,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74764,
        lat: 49.814189,
        long: 18.02101
    },
    {
        town: "T\u011B\u0161ovice",
        townCode: 550582,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.057215,
        long: 14.024005
    },
    {
        town: "T\u011B\u0161ovice",
        townCode: 579360,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35601,
        lat: 50.182307,
        long: 12.676998
    },
    {
        town: "Tet\u010Dice",
        townCode: 583987,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66417,
        lat: 49.170348,
        long: 16.405736
    },
    {
        town: "Tet\xedn",
        townCode: 572756,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.42462,
        long: 15.636457
    },
    {
        town: "Tet\xedn",
        townCode: 531839,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 49.94942,
        long: 14.102357
    },
    {
        town: 'Tetov',
        townCode: 575810,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.080585,
        long: 15.445738
    },
    {
        town: "Tcho\u0159ovice",
        townCode: 536598,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.437148,
        long: 13.809985
    },
    {
        town: "Tich\xe1",
        townCode: 599956,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74274,
        lat: 49.570086,
        long: 18.221589
    },
    {
        town: 'Tichonice',
        townCode: 530778,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25763,
        lat: 49.777164,
        long: 14.992382
    },
    {
        town: 'Tichov',
        townCode: 535184,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76601,
        lat: 49.177486,
        long: 17.982741
    },
    {
        town: 'Tis',
        townCode: 569615,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58243,
        lat: 49.705057,
        long: 15.493338
    },
    {
        town: 'Tis u Blatna',
        townCode: 559482,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33165,
        lat: 50.085845,
        long: 13.347908
    },
    {
        town: "Tis\xe1",
        townCode: 568309,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40336,
        lat: 50.784605,
        long: 14.031415
    },
    {
        town: "T\xedsek",
        townCode: 599964,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74301,
        lat: 49.792766,
        long: 18.014705
    },
    {
        town: 'Tisem',
        townCode: 532592,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25756,
        lat: 49.755736,
        long: 14.608061
    },
    {
        town: 'Tismice',
        townCode: 533734,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.056273,
        long: 14.821163
    },
    {
        town: "Tisov\xe1",
        townCode: 581062,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.936258,
        long: 16.224633
    },
    {
        town: "Tisov\xe1",
        townCode: 541621,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34801,
        lat: 49.765288,
        long: 12.713935
    },
    {
        town: 'Tisovec',
        townCode: 572381,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53973,
        lat: 49.824479,
        long: 15.914659
    },
    {
        town: "Ti\u0161ice",
        townCode: 535222,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27715,
        lat: 50.269904,
        long: 14.554222
    },
    {
        town: "Ti\u0161nov",
        townCode: 584002,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.348818,
        long: 16.424485
    },
    {
        town: "Ti\u0161novsk\xe1 Nov\xe1 Ves",
        townCode: 596892,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.383986,
        long: 16.293684
    },
    {
        town: "Ti\u0161t\xedn",
        townCode: 590100,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79829,
        lat: 49.306988,
        long: 17.165505
    },
    {
        town: "Tlu\u010Dn\xe1",
        townCode: 559491,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33026,
        lat: 49.724362,
        long: 13.235453
    },
    {
        town: "Tluma\u010Dov",
        townCode: 554341,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.40364,
        long: 12.929095
    },
    {
        town: "Tluma\u010Dov",
        townCode: 585858,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76362,
        lat: 49.253605,
        long: 17.495694
    },
    {
        town: 'Tlustice',
        townCode: 531847,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26801,
        lat: 49.850393,
        long: 13.885465
    },
    {
        town: "Tma\u0148",
        townCode: 531855,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26721,
        lat: 49.907174,
        long: 14.033932
    },
    {
        town: "To\u010Dn\xedk",
        townCode: 534463,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.8855,
        long: 13.882878
    },
    {
        town: 'Tochovice',
        townCode: 541427,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26281,
        lat: 49.59559,
        long: 13.992506
    },
    {
        town: 'Tojice',
        townCode: 578614,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.492585,
        long: 13.62662
    },
    {
        town: 'Tomice',
        townCode: 532541,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25768,
        lat: 49.645143,
        long: 15.157197
    },
    {
        town: 'Topolany',
        townCode: 593630,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.277451,
        long: 17.040411
    },
    {
        town: "Topoln\xe1",
        townCode: 592692,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68711,
        lat: 49.121967,
        long: 17.544444
    },
    {
        town: "Tou\u0161ice",
        townCode: 533742,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.987988,
        long: 15.006578
    },
    {
        town: "Tou\u017Eet\xedn",
        townCode: 566829,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.315391,
        long: 13.886229
    },
    {
        town: "Tou\u017Eim",
        townCode: 555657,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36401,
        lat: 50.060604,
        long: 12.985171
    },
    {
        town: "Tova\u010Dov",
        townCode: 519146,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75101,
        lat: 49.429711,
        long: 17.285739
    },
    {
        town: "Tov\xe9\u0159",
        townCode: 552089,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78316,
        lat: 49.640125,
        long: 17.31912
    },
    {
        town: 'Traplice',
        townCode: 592706,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68704,
        lat: 49.130976,
        long: 17.436325
    },
    {
        town: "Trav\u010Dice",
        townCode: 565741,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.503389,
        long: 14.189878
    },
    {
        town: "Trbou\u0161any",
        townCode: 584011,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66464,
        lat: 49.050783,
        long: 16.46295
    },
    {
        town: 'Trhanov',
        townCode: 554359,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34533,
        lat: 49.420341,
        long: 12.845635
    },
    {
        town: "Trhov\xe1 Kamenice",
        townCode: 572390,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53952,
        lat: 49.786894,
        long: 15.816049
    },
    {
        town: "Trhov\xe9 Du\u0161n\xedky",
        townCode: 598429,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26101,
        lat: 49.71355,
        long: 14.012935
    },
    {
        town: "Trhov\xe9 Sviny",
        townCode: 545171,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.842418,
        long: 14.639338
    },
    {
        town: "Trhov\xfd \u0160t\u011Bp\xe1nov",
        townCode: 530816,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25763,
        lat: 49.711576,
        long: 15.013668
    },
    {
        town: 'Trmice',
        townCode: 553697,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40004,
        lat: 50.642967,
        long: 13.994605
    },
    {
        town: 'Trnava',
        townCode: 591840,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.254784,
        long: 15.924247
    },
    {
        town: 'Trnava',
        townCode: 585866,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76318,
        lat: 49.296132,
        long: 17.842017
    },
    {
        town: "Trn\xe1vka",
        townCode: 569755,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74258,
        lat: 49.684846,
        long: 18.178045
    },
    {
        town: "Trn\xe1vka",
        townCode: 530794,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.032844,
        long: 15.461124
    },
    {
        town: 'Trnov',
        townCode: 576824,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51733,
        lat: 50.244775,
        long: 16.164517
    },
    {
        town: "Trnov\xe1",
        townCode: 559504,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33013,
        lat: 49.861152,
        long: 13.323963
    },
    {
        town: "Trnov\xe1",
        townCode: 598313,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.915541,
        long: 14.357824
    },
    {
        town: 'Trnovany',
        townCode: 542407,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.543317,
        long: 14.17905
    },
    {
        town: "Trnov\xe9 Pole",
        townCode: 594954,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.94504,
        long: 16.409578
    },
    {
        town: 'Trojanovice',
        townCode: 599999,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74401,
        lat: 49.520494,
        long: 18.238113
    },
    {
        town: 'Trojovice',
        townCode: 572403,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53833,
        lat: 49.932925,
        long: 15.919674
    },
    {
        town: 'Trokavec',
        townCode: 579246,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.647028,
        long: 13.702351
    },
    {
        town: 'Troskotovice',
        townCode: 594962,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67178,
        lat: 48.919119,
        long: 16.437643
    },
    {
        town: 'Troskovice',
        townCode: 577600,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51263,
        lat: 50.511687,
        long: 15.22242
    },
    {
        town: 'Trotina',
        townCode: 579751,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.409736,
        long: 15.716281
    },
    {
        town: 'Troubelice',
        townCode: 505293,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78383,
        lat: 49.817411,
        long: 17.08111
    },
    {
        town: 'Troubky',
        townCode: 519651,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75102,
        lat: 49.432248,
        long: 17.34925
    },
    {
        town: 'Troubky-Zdislavice',
        townCode: 589080,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76802,
        lat: 49.230501,
        long: 17.268275
    },
    {
        town: 'Troubsko',
        townCode: 584029,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66441,
        lat: 49.169608,
        long: 16.510886
    },
    {
        town: "Trp\xedk",
        townCode: 547921,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.847575,
        long: 16.570003
    },
    {
        town: "Trp\xedn",
        townCode: 578886,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56974,
        lat: 49.593988,
        long: 16.402214
    },
    {
        town: "Trp\xedsty",
        townCode: 561291,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.822747,
        long: 13.058639
    },
    {
        town: "Trpi\u0161ovice",
        townCode: 569623,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.655284,
        long: 15.332281
    },
    {
        town: "Trst\u011Bnice",
        townCode: 594971,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67171,
        lat: 48.986862,
        long: 16.195522
    },
    {
        town: "Trst\u011Bnice",
        townCode: 554855,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.91921,
        long: 12.676134
    },
    {
        town: "Trst\u011Bnice",
        townCode: 578894,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56957,
        lat: 49.794239,
        long: 16.348852
    },
    {
        town: "Tr\u0161ice",
        townCode: 505366,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78357,
        lat: 49.541173,
        long: 17.42708
    },
    {
        town: "Trub\xedn",
        townCode: 533106,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26701,
        lat: 49.94378,
        long: 14.002294
    },
    {
        town: "Trubsk\xe1",
        townCode: 531880,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 49.95498,
        long: 13.993555
    },
    {
        town: 'Truskovice',
        townCode: 536512,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.104163,
        long: 14.161196
    },
    {
        town: 'Trusnov',
        townCode: 575828,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.000215,
        long: 16.044093
    },
    {
        town: 'Trutnov',
        townCode: 579025,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54101,
        lat: 50.565484,
        long: 15.909192
    },
    {
        town: "Tr\u017Eek",
        townCode: 572616,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.886335,
        long: 16.260047
    },
    {
        town: "T\u0159anovice",
        townCode: 552623,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73953,
        lat: 49.712553,
        long: 18.529296
    },
    {
        town: "T\u0159eba\u0159ov",
        townCode: 578908,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56933,
        lat: 49.829794,
        long: 16.702624
    },
    {
        town: "T\u0159eb\u010Dice",
        townCode: 578592,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33501,
        lat: 49.483479,
        long: 13.612175
    },
    {
        town: "T\u0159ebechovice pod Orebem",
        townCode: 571041,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50346,
        lat: 50.201066,
        long: 15.992336
    },
    {
        town: "T\u0159eb\u011Bjice",
        townCode: 563153,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.244526,
        long: 14.81988
    },
    {
        town: "T\u0159ebelovice",
        townCode: 591858,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67532,
        lat: 49.022254,
        long: 15.666335
    },
    {
        town: "T\u0159ebe\u0148",
        townCode: 539023,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.128744,
        long: 12.400268
    },
    {
        town: "T\u0159ebenice",
        townCode: 591866,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.163856,
        long: 16.015873
    },
    {
        town: "T\u0159ebenice",
        townCode: 565768,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41113,
        lat: 50.476429,
        long: 13.990159
    },
    {
        town: "T\u0159ebestovice",
        townCode: 537896,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28912,
        lat: 50.124705,
        long: 14.958358
    },
    {
        town: "T\u0159ebe\u0161ice",
        townCode: 532304,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.775348,
        long: 14.831949
    },
    {
        town: "T\u0159ebe\u0161ice",
        townCode: 530981,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.927948,
        long: 15.337909
    },
    {
        town: "T\u0159ebe\u0161ov",
        townCode: 576832,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51601,
        lat: 50.16845,
        long: 16.204241
    },
    {
        town: "T\u0159eb\u011Btice",
        townCode: 562327,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.047741,
        long: 15.52082
    },
    {
        town: "T\u0159eb\u011Btice",
        townCode: 589098,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.319485,
        long: 17.519351
    },
    {
        town: "T\u0159eb\u011Bt\xedn",
        townCode: 530972,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.77084,
        long: 15.269464
    },
    {
        town: "T\u0159eb\xed\u010D",
        townCode: 590266,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.214887,
        long: 15.879652
    },
    {
        town: "T\u0159ebiho\u0161\u0165",
        townCode: 579769,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.433387,
        long: 15.709795
    },
    {
        town: "T\u0159ebichovice",
        townCode: 532959,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27306,
        lat: 50.190464,
        long: 14.079146
    },
    {
        town: "T\u0159eb\xedvlice",
        townCode: 565776,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41115,
        lat: 50.45817,
        long: 13.899372
    },
    {
        town: "T\u0159eb\xedz",
        townCode: 532967,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27375,
        lat: 50.269721,
        long: 13.990901
    },
    {
        town: "T\u0159ebnou\u0161eves",
        townCode: 573612,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50801,
        lat: 50.339344,
        long: 15.651767
    },
    {
        town: "T\u0159eboc",
        townCode: 542504,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27054,
        lat: 50.214417,
        long: 13.752838
    },
    {
        town: "T\u0159ebohostice",
        townCode: 551899,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38737,
        lat: 49.33264,
        long: 13.861096
    },
    {
        town: "T\u0159ebom",
        townCode: 569101,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74725,
        lat: 50.046244,
        long: 18.025387
    },
    {
        town: "T\u0159ebo\u0148",
        townCode: 547336,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.003615,
        long: 14.764232
    },
    {
        town: "T\u0159ebon\xedn",
        townCode: 571741,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28544,
        lat: 49.869804,
        long: 15.313026
    },
    {
        town: "T\u0159ebosice",
        townCode: 572985,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.997348,
        long: 15.734932
    },
    {
        town: "T\u0159ebotov",
        townCode: 539759,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25226,
        lat: 49.972514,
        long: 14.291274
    },
    {
        town: "T\u0159ebovice",
        townCode: 581071,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56124,
        lat: 49.859351,
        long: 16.502143
    },
    {
        town: "T\u0159ebovle",
        townCode: 533751,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 50.027347,
        long: 14.961866
    },
    {
        town: "T\u0159ebsko",
        townCode: 541451,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.625764,
        long: 13.96765
    },
    {
        town: "T\u0159ebusice",
        townCode: 532975,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27341,
        lat: 50.200879,
        long: 14.180749
    },
    {
        town: "T\u0159ebu\u0161\xedn",
        townCode: 565792,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.599744,
        long: 14.20553
    },
    {
        town: "T\u0159eme\u0161n\xe1",
        townCode: 597911,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79382,
        lat: 50.20503,
        long: 17.57542
    },
    {
        town: "T\u0159eme\u0161n\xe9",
        townCode: 561304,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34806,
        lat: 49.625373,
        long: 12.695768
    },
    {
        town: "T\u0159emo\u0161n\xe1",
        townCode: 559521,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.815946,
        long: 13.395104
    },
    {
        town: "T\u0159emo\u0161nice",
        townCode: 572411,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.869219,
        long: 15.580129
    },
    {
        town: "T\u0159esov",
        townCode: 550311,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67502,
        lat: 49.180335,
        long: 16.082925
    },
    {
        town: "T\u0159esovice",
        townCode: 571059,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50315,
        lat: 50.265178,
        long: 15.688982
    },
    {
        town: "T\u0159e\u0161ovice",
        townCode: 536679,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.211424,
        long: 13.98145
    },
    {
        town: "T\u0159e\u0161\u0165",
        townCode: 588032,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58901,
        lat: 49.290971,
        long: 15.483401
    },
    {
        town: "T\u0159e\u0161tice",
        townCode: 588041,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.245602,
        long: 15.453316
    },
    {
        town: "T\u0159e\u0161tina",
        townCode: 553336,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78973,
        lat: 49.796306,
        long: 16.963987
    },
    {
        town: "T\u0159i Dvory",
        townCode: 533769,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.032056,
        long: 15.256593
    },
    {
        town: "T\u0159i Sekery",
        townCode: 554880,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.942277,
        long: 12.616745
    },
    {
        town: "T\u0159i Studn\u011B",
        townCode: 587753,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59204,
        lat: 49.612941,
        long: 16.036598
    },
    {
        town: "T\u0159ib\u0159ichy",
        townCode: 504921,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.965357,
        long: 15.739289
    },
    {
        town: "T\u0159inec",
        townCode: 598810,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73961,
        lat: 49.677731,
        long: 18.67089
    },
    {
        town: "T\u0159t\u011Bnice",
        townCode: 573639,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50704,
        lat: 50.377493,
        long: 15.469231
    },
    {
        town: "T\u0159tice",
        townCode: 542512,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27101,
        lat: 50.185105,
        long: 13.863591
    },
    {
        town: "Tu\u010Dapy",
        townCode: 553239,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39126,
        lat: 49.291392,
        long: 14.803517
    },
    {
        town: "Tu\u010Dapy",
        townCode: 593648,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.233446,
        long: 16.918474
    },
    {
        town: "Tu\u010Dapy",
        townCode: 592714,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68709,
        lat: 49.048213,
        long: 17.331526
    },
    {
        town: "Tu\u010D\xedn",
        townCode: 520047,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75116,
        lat: 49.45409,
        long: 17.515128
    },
    {
        town: "Tuha\u0148",
        townCode: 546267,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.536579,
        long: 14.467408
    },
    {
        town: "Tuha\u0148",
        townCode: 531561,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27741,
        lat: 50.295483,
        long: 14.517383
    },
    {
        town: 'Tuchlovice',
        townCode: 532983,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27302,
        lat: 50.138132,
        long: 13.991262
    },
    {
        town: "Tuchom\u011B\u0159ice",
        townCode: 539767,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25267,
        lat: 50.135539,
        long: 14.282293
    },
    {
        town: 'Tuchoraz',
        townCode: 533777,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.048724,
        long: 14.849303
    },
    {
        town: "Tucho\u0159ice",
        townCode: 566853,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43969,
        lat: 50.28475,
        long: 13.662622
    },
    {
        town: 'Tuklaty',
        townCode: 533785,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25082,
        lat: 50.084879,
        long: 14.769602
    },
    {
        town: "Tule\u0161ice",
        townCode: 594989,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67173,
        lat: 49.038646,
        long: 16.207235
    },
    {
        town: "Tun\u011Bchody",
        townCode: 572420,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53701,
        lat: 49.978962,
        long: 15.84134
    },
    {
        town: 'Tupadly',
        townCode: 534480,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28563,
        lat: 49.869103,
        long: 15.40356
    },
    {
        town: 'Tupadly',
        townCode: 529583,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.441913,
        long: 14.475036
    },
    {
        town: 'Tupesy',
        townCode: 592722,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68707,
        lat: 49.084369,
        long: 17.369935
    },
    {
        town: 'Turkovice',
        townCode: 575844,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53363,
        lat: 49.952551,
        long: 15.548856
    },
    {
        town: 'Turnov',
        townCode: 577626,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51101,
        lat: 50.587385,
        long: 15.156909
    },
    {
        town: 'Turovec',
        townCode: 551601,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39121,
        lat: 49.378459,
        long: 14.769036
    },
    {
        town: 'Turovice',
        townCode: 552836,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75114,
        lat: 49.423817,
        long: 17.580887
    },
    {
        town: 'Tursko',
        townCode: 539775,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25265,
        lat: 50.19134,
        long: 14.32199
    },
    {
        town: "Tu\u0159",
        townCode: 573647,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.395077,
        long: 15.417033
    },
    {
        town: "Tu\u0159any",
        townCode: 539619,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35002,
        lat: 50.08412,
        long: 12.522102
    },
    {
        town: "Tu\u0159any",
        townCode: 532177,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27379,
        lat: 50.232342,
        long: 14.029138
    },
    {
        town: "Tu\u0159ice",
        townCode: 570982,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29474,
        lat: 50.248907,
        long: 14.769264
    },
    {
        town: "Tu\u0161ovice",
        townCode: 598330,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.575713,
        long: 14.030638
    },
    {
        town: 'Tutleky',
        townCode: 576841,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.134014,
        long: 16.241556
    },
    {
        town: "Tu\u017Eice",
        townCode: 553522,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.335115,
        long: 13.511527
    },
    {
        town: "Tvaro\u017En\xe1",
        townCode: 584037,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66405,
        lat: 49.19187,
        long: 16.771563
    },
    {
        town: "Tvaro\u017En\xe1 Lhota",
        townCode: 586684,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69662,
        lat: 48.877349,
        long: 17.359497
    },
    {
        town: 'Tvorovice',
        townCode: 590118,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79823,
        lat: 49.374487,
        long: 17.22203
    },
    {
        town: "Tvo\u0159ihr\xe1z",
        townCode: 594997,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67134,
        lat: 48.917649,
        long: 16.135878
    },
    {
        town: 'Tvrdkov',
        townCode: 551821,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79344,
        lat: 49.895592,
        long: 17.178202
    },
    {
        town: 'Tvrdonice',
        townCode: 584941,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69153,
        lat: 48.760582,
        long: 16.994567
    },
    {
        town: 'Tvrzice',
        townCode: 550604,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.121841,
        long: 13.967232
    },
    {
        town: "T\xfd\u010Dek",
        townCode: 546534,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.869348,
        long: 13.794421
    },
    {
        town: "Tym\xe1kov",
        townCode: 558460,
        district: "Plze\u0148-m\u011Bsto",
        lau: 'CZ0323',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33201,
        lat: 49.719174,
        long: 13.509931
    },
    {
        town: "T\xfdn nad Be\u010Dvou",
        townCode: 570079,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75131,
        lat: 49.51705,
        long: 17.618164
    },
    {
        town: "T\xfdn nad Vltavou",
        townCode: 545201,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.223502,
        long: 14.42067
    },
    {
        town: "T\xfdnec",
        townCode: 584959,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69154,
        lat: 48.779531,
        long: 17.013324
    },
    {
        town: "T\xfdnec",
        townCode: 541885,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34021,
        lat: 49.347334,
        long: 13.264018
    },
    {
        town: "T\xfdnec nad Labem",
        townCode: 533807,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28126,
        lat: 50.042117,
        long: 15.358462
    },
    {
        town: "T\xfdnec nad S\xe1zavou",
        townCode: 530841,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25741,
        lat: 49.833579,
        long: 14.58994
    },
    {
        town: "T\xfdni\u0161t\u011B",
        townCode: 539929,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.521194,
        long: 13.417703
    },
    {
        town: "T\xfdni\u0161t\u011B nad Orlic\xed",
        townCode: 576859,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51721,
        lat: 50.151203,
        long: 16.078551
    },
    {
        town: "T\xfdni\u0161\u0165ko",
        townCode: 575861,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.999487,
        long: 16.097653
    },
    {
        town: "\xdabislavice",
        townCode: 573655,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50792,
        lat: 50.473031,
        long: 15.47042
    },
    {
        town: 'Ublo',
        townCode: 585874,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.233156,
        long: 17.901231
    },
    {
        town: "\xdabo\u010D",
        townCode: 566161,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.443698,
        long: 13.086983
    },
    {
        town: "Ubu\u0161\xednek",
        townCode: 549959,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.610581,
        long: 16.281794
    },
    {
        town: "\xdadlice",
        townCode: 563382,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43141,
        lat: 50.440706,
        long: 13.457492
    },
    {
        town: "\xdadrnice",
        townCode: 573663,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.374485,
        long: 15.261676
    },
    {
        town: "Uheln\xe1",
        townCode: 541214,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79070,
        lat: 50.365038,
        long: 17.027399
    },
    {
        town: "Uheln\xe1 P\u0159\xedbram",
        townCode: 569640,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58245,
        lat: 49.768087,
        long: 15.585655
    },
    {
        town: "\xdaherce",
        townCode: 546411,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.701479,
        long: 13.213823
    },
    {
        town: "\xdaherce",
        townCode: 546178,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.298161,
        long: 13.949094
    },
    {
        town: "Uher\u010Dice",
        townCode: 584967,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69162,
        lat: 48.967902,
        long: 16.653546
    },
    {
        town: "Uher\u010Dice",
        townCode: 595004,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.913336,
        long: 15.630477
    },
    {
        town: "\xdaher\u010Dice",
        townCode: 530697,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.919564,
        long: 15.677746
    },
    {
        town: "Uhersk\xe9 Hradi\u0161t\u011B",
        townCode: 592005,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68601,
        lat: 49.059897,
        long: 17.49595
    },
    {
        town: 'Uhersko',
        townCode: 575879,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53373,
        lat: 49.992474,
        long: 16.017879
    },
    {
        town: "Uhersk\xfd Brod",
        townCode: 592731,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68801,
        lat: 49.030373,
        long: 17.649938
    },
    {
        town: "Uhersk\xfd Ostroh",
        townCode: 592749,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68724,
        lat: 48.985657,
        long: 17.389953
    },
    {
        town: "\xdahlejov",
        townCode: 573671,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.427287,
        long: 15.687441
    },
    {
        town: "Uhl\xed\u0159ov",
        townCode: 568341,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74784,
        lat: 49.897154,
        long: 17.841402
    },
    {
        town: "Uhl\xed\u0159sk\xe1 Lhota",
        townCode: 533815,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28126,
        lat: 50.079045,
        long: 15.391155
    },
    {
        town: "Uhl\xed\u0159sk\xe9 Janovice",
        townCode: 534498,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.880291,
        long: 15.06492
    },
    {
        town: "\xdaholi\u010Dky",
        townCode: 571351,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25264,
        lat: 50.16146,
        long: 14.335349
    },
    {
        town: "\xdahonice",
        townCode: 532991,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25218,
        lat: 50.043449,
        long: 14.186328
    },
    {
        town: "\xdaho\u0159ilka",
        townCode: 548537,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58253,
        lat: 49.524779,
        long: 15.530975
    },
    {
        town: "\xdah\u0159etice",
        townCode: 572446,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53832,
        lat: 49.979251,
        long: 15.867345
    },
    {
        town: "\xdah\u0159etick\xe1 Lhota",
        townCode: 575887,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53002,
        lat: 49.988669,
        long: 15.872852
    },
    {
        town: "Uh\u0159ice",
        townCode: 582531,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67963,
        lat: 49.595164,
        long: 16.735111
    },
    {
        town: "Uh\u0159ice",
        townCode: 586692,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69634,
        lat: 49.050447,
        long: 16.947682
    },
    {
        town: "Uh\u0159ice",
        townCode: 550191,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68333,
        lat: 49.172448,
        long: 17.078762
    },
    {
        town: "Uh\u0159ice",
        townCode: 589110,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.281835,
        long: 17.201536
    },
    {
        town: "Uh\u0159i\u010Dice",
        townCode: 552879,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75201,
        lat: 49.371673,
        long: 17.290435
    },
    {
        town: "Uh\u0159\xednov",
        townCode: 596906,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59441,
        lat: 49.349931,
        long: 15.938057
    },
    {
        town: 'Uhy',
        townCode: 533009,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27324,
        lat: 50.284336,
        long: 14.273969
    },
    {
        town: "Uj\u010Dov",
        townCode: 596914,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59262,
        lat: 49.488459,
        long: 16.331188
    },
    {
        town: "\xdajezd",
        townCode: 595012,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67140,
        lat: 49.023647,
        long: 16.053361
    },
    {
        town: "\xdajezd",
        townCode: 596922,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59212,
        lat: 49.509261,
        long: 15.870346
    },
    {
        town: "\xdajezd",
        townCode: 505501,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78396,
        lat: 49.764066,
        long: 17.180511
    },
    {
        town: "\xdajezd",
        townCode: 554383,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.435642,
        long: 12.869668
    },
    {
        town: "\xdajezd",
        townCode: 531901,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26761,
        lat: 49.831356,
        long: 13.837576
    },
    {
        town: "\xdajezd",
        townCode: 585882,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76325,
        lat: 49.168187,
        long: 17.906215
    },
    {
        town: "\xdajezd nade M\u017E\xed",
        townCode: 566594,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.788854,
        long: 13.195175
    },
    {
        town: "\xdajezd pod Troskami",
        townCode: 573680,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51263,
        lat: 50.506631,
        long: 15.262655
    },
    {
        town: "\xdajezd u Boskovic",
        townCode: 534692,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.463998,
        long: 16.654269
    },
    {
        town: "\xdajezd u Brna",
        townCode: 584045,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66453,
        lat: 49.104448,
        long: 16.757474
    },
    {
        town: "\xdajezd u \u010Cern\xe9 Hory",
        townCode: 582557,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.370995,
        long: 16.543917
    },
    {
        town: "\xdajezd u Chocn\u011B",
        townCode: 581089,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 50.026995,
        long: 16.164691
    },
    {
        town: "\xdajezd u Pl\xe1nice",
        townCode: 578321,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.417621,
        long: 13.457818
    },
    {
        town: "\xdajezd u P\u0159elou\u010De",
        townCode: 575909,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.102031,
        long: 15.494626
    },
    {
        town: "\xdajezd u Rosic",
        townCode: 584053,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.222512,
        long: 16.253748
    },
    {
        town: "\xdajezd u Sezemic",
        townCode: 572888,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53304,
        lat: 50.114148,
        long: 15.855832
    },
    {
        town: "\xdajezd u Svat\xe9ho K\u0159\xed\u017Ee",
        townCode: 546551,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.859837,
        long: 13.56961
    },
    {
        town: "\xdajezd u Ti\u0161nova",
        townCode: 549908,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59455,
        lat: 49.365622,
        long: 16.32465
    },
    {
        town: "\xdajezdec",
        townCode: 507644,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.207626,
        long: 14.784836
    },
    {
        town: "\xdajezdec",
        townCode: 537535,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.108008,
        long: 13.964075
    },
    {
        town: "\xdajezdec",
        townCode: 578916,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.877862,
        long: 16.206035
    },
    {
        town: "\xdajezdec",
        townCode: 599492,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27745,
        lat: 50.283451,
        long: 14.420989
    },
    {
        town: "\xdajezdec",
        townCode: 592757,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68741,
        lat: 49.036216,
        long: 17.272063
    },
    {
        town: "\xdajezde\u010Dek",
        townCode: 567850,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.645818,
        long: 13.789867
    },
    {
        town: 'Ujkovice',
        townCode: 570761,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.366961,
        long: 15.099546
    },
    {
        town: "\xdalehle",
        townCode: 536695,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.201553,
        long: 13.838465
    },
    {
        town: "\xdalibice",
        townCode: 573698,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50707,
        lat: 50.43413,
        long: 15.437401
    },
    {
        town: "\xdalice",
        townCode: 559555,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33033,
        lat: 49.760902,
        long: 13.148283
    },
    {
        town: "\xdamon\xedn",
        townCode: 534501,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28546,
        lat: 49.888776,
        long: 15.271497
    },
    {
        town: "\xdamyslovice",
        townCode: 537900,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29001,
        lat: 50.203491,
        long: 15.177694
    },
    {
        town: "\xdananov",
        townCode: 595021,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67131,
        lat: 48.900923,
        long: 16.063609
    },
    {
        town: "Un\u010D\xedn",
        townCode: 596931,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59242,
        lat: 49.607762,
        long: 16.245786
    },
    {
        town: "\xdanehle",
        townCode: 541435,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.791701,
        long: 13.015482
    },
    {
        town: "\xdan\u011Bjovice",
        townCode: 554391,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.462139,
        long: 13.118705
    },
    {
        town: "\xdan\u011B\u0161ov",
        townCode: 559563,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33038,
        lat: 49.882689,
        long: 13.149299
    },
    {
        town: "\xdan\u011Btice",
        townCode: 540528,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.584402,
        long: 13.470115
    },
    {
        town: "\xdan\u011Btice",
        townCode: 539805,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25262,
        lat: 50.150214,
        long: 14.354207
    },
    {
        town: "Unho\u0161\u0165",
        townCode: 533017,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.085455,
        long: 14.130183
    },
    {
        town: "\xdanice",
        townCode: 563951,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.312345,
        long: 13.868508
    },
    {
        town: "Uni\u010Dov",
        townCode: 505587,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78391,
        lat: 49.771013,
        long: 17.121542
    },
    {
        town: "Un\xedn",
        townCode: 582565,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67924,
        lat: 49.382277,
        long: 16.491456
    },
    {
        town: 'Unkovice',
        townCode: 584061,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66463,
        lat: 49.019318,
        long: 16.604146
    },
    {
        town: "\xdapice",
        townCode: 579777,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54232,
        lat: 50.512472,
        long: 16.016173
    },
    {
        town: "\xdapohlavy",
        townCode: 565806,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.463202,
        long: 14.035645
    },
    {
        town: 'Urbanice',
        townCode: 513717,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50327,
        lat: 50.18002,
        long: 15.727458
    },
    {
        town: 'Urbanice',
        townCode: 575917,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 49.974044,
        long: 15.567111
    },
    {
        town: 'Urbanov',
        townCode: 588067,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.214457,
        long: 15.514113
    },
    {
        town: "Ur\u010Dice",
        townCode: 590126,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79804,
        lat: 49.430551,
        long: 17.073015
    },
    {
        town: "\xdasiln\xe9",
        townCode: 535494,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37010,
        lat: 49.01349,
        long: 14.507364
    },
    {
        town: "\xdasilov",
        townCode: 554405,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34506,
        lat: 49.396955,
        long: 13.127071
    },
    {
        town: "\xdasob\xed",
        townCode: 569658,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58254,
        lat: 49.5143,
        long: 15.502573
    },
    {
        town: "\xdasobrno",
        townCode: 582573,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67939,
        lat: 49.589023,
        long: 16.762988
    },
    {
        town: "\xdasov",
        townCode: 541222,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78973,
        lat: 49.798406,
        long: 17.010654
    },
    {
        town: "\xdast\xed",
        townCode: 588075,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.47362,
        long: 15.414883
    },
    {
        town: "\xdast\xed",
        townCode: 520306,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.516945,
        long: 17.766477
    },
    {
        town: "\xdast\xed",
        townCode: 570371,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75501,
        lat: 49.308336,
        long: 18.003211
    },
    {
        town: "\xdaST\xcd NAD LABEM",
        townCode: 554804,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40001,
        lat: 50.661216,
        long: 14.053246
    },
    {
        town: "\xdast\xed nad Orlic\xed",
        townCode: 579891,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 49.97228,
        long: 16.399762
    },
    {
        town: "\xdast\xedn",
        townCode: 552364,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78346,
        lat: 49.587135,
        long: 17.157685
    },
    {
        town: "\xdastra\u0161ice",
        townCode: 599123,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.34038,
        long: 14.68458
    },
    {
        town: "\xdastra\u0161\xedn",
        townCode: 537608,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.382588,
        long: 15.16866
    },
    {
        town: "\xdastup",
        townCode: 553883,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67974,
        lat: 49.565027,
        long: 16.463018
    },
    {
        town: "\xdasu\u0161\xed",
        townCode: 584070,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.334845,
        long: 16.356089
    },
    {
        town: "\xda\u0161t\u011Bk",
        townCode: 565814,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41145,
        lat: 50.585804,
        long: 14.34769
    },
    {
        town: "\xdat\u011Bchov",
        townCode: 572624,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.728486,
        long: 16.64466
    },
    {
        town: "\xdat\u011Bchovice",
        townCode: 548987,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.478174,
        long: 15.116486
    },
    {
        town: "\xdat\u011Bchovice pod Stra\u017Ei\u0161t\u011Bm",
        townCode: 562033,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.538607,
        long: 15.0292
    },
    {
        town: "\xdat\u011Bchovi\u010Dky",
        townCode: 537730,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.460685,
        long: 15.099772
    },
    {
        town: "\xdater\xfd",
        townCode: 559571,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33041,
        lat: 49.940181,
        long: 13.00429
    },
    {
        town: "\xdatu\u0161ice",
        townCode: 558486,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33209,
        lat: 49.677894,
        long: 13.382148
    },
    {
        town: "\xdatvina",
        townCode: 555681,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36401,
        lat: 50.070847,
        long: 12.954852
    },
    {
        town: "\xdavalno",
        townCode: 597937,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79391,
        lat: 50.047254,
        long: 17.744838
    },
    {
        town: "\xdavaly",
        townCode: 538957,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25082,
        lat: 50.073837,
        long: 14.730945
    },
    {
        town: 'Uzenice',
        townCode: 551937,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.473354,
        long: 13.959944
    },
    {
        town: "Uzeni\u010Dky",
        townCode: 536890,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38801,
        lat: 49.488972,
        long: 13.952507
    },
    {
        town: "\xda\u017Eice",
        townCode: 534510,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.872126,
        long: 14.9728
    },
    {
        town: "\xda\u017Eice",
        townCode: 535257,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27745,
        lat: 50.253007,
        long: 14.378957
    },
    {
        town: 'Vacenovice',
        townCode: 586706,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69606,
        lat: 48.945204,
        long: 17.174146
    },
    {
        town: "V\xe1clavice",
        townCode: 532061,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25601,
        lat: 49.789406,
        long: 14.61365
    },
    {
        town: "V\xe1clavov u Brunt\xe1lu",
        townCode: 597945,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.979799,
        long: 17.371834
    },
    {
        town: "V\xe1clavovice",
        townCode: 598836,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73934,
        lat: 49.755403,
        long: 18.372312
    },
    {
        town: "V\xe1clavy",
        townCode: 565512,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.063791,
        long: 13.59452
    },
    {
        town: 'Vacov',
        townCode: 550621,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38486,
        lat: 49.13697,
        long: 13.729209
    },
    {
        town: 'Vacovice',
        townCode: 536504,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.140476,
        long: 13.781044
    },
    {
        town: 'Val',
        townCode: 553255,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.146155,
        long: 14.756143
    },
    {
        town: 'Val',
        townCode: 576875,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51801,
        lat: 50.311302,
        long: 16.181692
    },
    {
        town: "Vala\u0161sk\xe1 Byst\u0159ice",
        townCode: 544949,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75627,
        lat: 49.415172,
        long: 18.109885
    },
    {
        town: "Vala\u0161sk\xe1 Polanka",
        townCode: 544990,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75611,
        lat: 49.262249,
        long: 17.996783
    },
    {
        town: "Vala\u0161sk\xe1 Senice",
        townCode: 553026,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75614,
        lat: 49.225377,
        long: 18.11706
    },
    {
        town: "Vala\u0161sk\xe9 Klobouky",
        townCode: 585891,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76601,
        lat: 49.139664,
        long: 18.00857
    },
    {
        town: "Vala\u0161sk\xe9 Mezi\u0159\xed\u010D\xed",
        townCode: 545058,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75701,
        lat: 49.471904,
        long: 17.971237
    },
    {
        town: "Vala\u0161sk\xe9 P\u0159\xedkazy",
        townCode: 545112,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75612,
        lat: 49.165971,
        long: 18.053888
    },
    {
        town: 'Valdice',
        townCode: 573701,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50711,
        lat: 50.455113,
        long: 15.384989
    },
    {
        town: "Vald\xedkov",
        townCode: 587699,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67503,
        lat: 49.247109,
        long: 15.985337
    },
    {
        town: "Vale\u010D",
        townCode: 555690,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36453,
        lat: 50.174239,
        long: 13.254676
    },
    {
        town: "Vale\u010D",
        townCode: 591874,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67553,
        lat: 49.144404,
        long: 16.03579
    },
    {
        town: 'Valchov',
        townCode: 582581,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.470283,
        long: 16.71998
    },
    {
        town: "Valke\u0159ice",
        townCode: 562874,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40724,
        lat: 50.701933,
        long: 14.322006
    },
    {
        town: "Val\u0161ov",
        townCode: 551783,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79201,
        lat: 49.933456,
        long: 17.43824
    },
    {
        town: 'Valtice',
        townCode: 584975,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69142,
        lat: 48.74079,
        long: 16.755094
    },
    {
        town: 'Valtrovice',
        townCode: 595039,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.793826,
        long: 16.221077
    },
    {
        town: 'Valy',
        townCode: 539481,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.976907,
        long: 12.654905
    },
    {
        town: 'Valy',
        townCode: 575925,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.029694,
        long: 15.61687
    },
    {
        town: 'Vamberk',
        townCode: 576883,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51754,
        lat: 50.117657,
        long: 16.290779
    },
    {
        town: 'Vanov',
        townCode: 588083,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.207777,
        long: 15.413736
    },
    {
        town: 'Vanovice',
        townCode: 582590,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67936,
        lat: 49.567378,
        long: 16.666313
    },
    {
        town: "Van\u016Fvek",
        townCode: 588091,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.222589,
        long: 15.422729
    },
    {
        town: "V\xe1penice",
        townCode: 592773,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68774,
        lat: 48.967992,
        long: 17.843216
    },
    {
        town: "V\xe1penn\xe1",
        townCode: 541249,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79064,
        lat: 50.283473,
        long: 17.097722
    },
    {
        town: "V\xe1penn\xfd Podol",
        townCode: 572454,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.889133,
        long: 15.66685
    },
    {
        town: "V\xe1pno",
        townCode: 575933,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.10432,
        long: 15.533003
    },
    {
        town: "V\xe1povice",
        townCode: 588105,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.154876,
        long: 15.580807
    },
    {
        town: 'Varnsdorf',
        townCode: 562882,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40747,
        lat: 50.911648,
        long: 14.618348
    },
    {
        town: "Varva\u017Eov",
        townCode: 562211,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.439009,
        long: 14.142696
    },
    {
        town: "Vat\xedn",
        townCode: 596949,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.525037,
        long: 15.96732
    },
    {
        town: "Vav\u0159inec",
        townCode: 582603,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67913,
        lat: 49.402702,
        long: 16.719949
    },
    {
        town: "Vav\u0159inec",
        townCode: 534528,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.913742,
        long: 15.033253
    },
    {
        town: "V\xe1\u017Eany",
        townCode: 582611,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.53129,
        long: 16.688799
    },
    {
        town: "V\xe1\u017Eany",
        townCode: 593656,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.244453,
        long: 17.050332
    },
    {
        town: "V\xe1\u017Eany",
        townCode: 592781,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68737,
        lat: 49.034552,
        long: 17.312035
    },
    {
        town: "V\xe1\u017Eany nad Litavou",
        townCode: 593664,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68401,
        lat: 49.128919,
        long: 16.857178
    },
    {
        town: "V\u010Del\xe1kov",
        townCode: 572462,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53957,
        lat: 49.817781,
        long: 15.884462
    },
    {
        town: "V\u010Deln\xe1",
        townCode: 545228,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37382,
        lat: 48.923831,
        long: 14.453933
    },
    {
        town: "V\u010Delni\u010Dka",
        townCode: 549002,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.304506,
        long: 15.042508
    },
    {
        town: "V\u011Bcov",
        townCode: 596957,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59244,
        lat: 49.616241,
        long: 16.170047
    },
    {
        town: "V\u011Bdomice",
        townCode: 565831,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.43399,
        long: 14.254008
    },
    {
        town: 'Vedrovice',
        townCode: 595047,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67175,
        lat: 49.020997,
        long: 16.378598
    },
    {
        town: "V\u011Bchnov",
        townCode: 596965,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.499464,
        long: 16.279089
    },
    {
        town: 'Vejprnice',
        townCode: 559580,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33027,
        lat: 49.729991,
        long: 13.276386
    },
    {
        town: 'Vejprty',
        townCode: 563404,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43191,
        lat: 50.492426,
        long: 13.032237
    },
    {
        town: 'Vejvanov',
        townCode: 560227,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33828,
        lat: 49.868769,
        long: 13.652523
    },
    {
        town: 'Vejvanovice',
        townCode: 572471,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53862,
        lat: 49.971029,
        long: 15.880178
    },
    {
        town: 'Velatice',
        townCode: 584096,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66405,
        lat: 49.197473,
        long: 16.753684
    },
    {
        town: "Vele\u010D\xedn",
        townCode: 578924,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33165,
        lat: 50.074416,
        long: 13.401709
    },
    {
        town: 'Velehrad',
        townCode: 592790,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68706,
        lat: 49.105527,
        long: 17.394372
    },
    {
        town: "Velem\xedn",
        townCode: 565849,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41131,
        lat: 50.53909,
        long: 13.976864
    },
    {
        town: "Velemy\u0161leves",
        townCode: 566870,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.402684,
        long: 13.563783
    },
    {
        town: "Vele\u0148",
        townCode: 538965,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25063,
        lat: 50.173318,
        long: 14.554314
    },
    {
        town: 'Velenice',
        townCode: 562173,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47002,
        lat: 50.719064,
        long: 14.664004
    },
    {
        town: 'Velenice',
        townCode: 536083,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28901,
        lat: 50.214463,
        long: 15.226475
    },
    {
        town: 'Velenka',
        townCode: 534871,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28912,
        lat: 50.139824,
        long: 14.895712
    },
    {
        town: 'Velenov',
        townCode: 530824,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68001,
        lat: 49.48694,
        long: 16.73287
    },
    {
        town: "Vele\u0161\xedn",
        townCode: 545821,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.829589,
        long: 14.462614
    },
    {
        town: "Vele\u0161ovice",
        townCode: 593681,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68301,
        lat: 49.179261,
        long: 16.849241
    },
    {
        town: 'Veletiny',
        townCode: 592803,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68733,
        lat: 49.037101,
        long: 17.562531
    },
    {
        town: 'Veletov',
        townCode: 533823,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.028423,
        long: 15.304983
    },
    {
        town: 'Velhartice',
        townCode: 557366,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.265299,
        long: 13.389852
    },
    {
        town: 'Velichov',
        townCode: 555703,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36301,
        lat: 50.284179,
        long: 13.009826
    },
    {
        town: 'Velichovky',
        townCode: 574554,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55211,
        lat: 50.356869,
        long: 15.84179
    },
    {
        town: "Velik\xe1 Ves",
        townCode: 538973,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25070,
        lat: 50.243718,
        long: 14.455186
    },
    {
        town: "Velik\xe1 Ves",
        townCode: 563412,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44101,
        lat: 50.269771,
        long: 13.37473
    },
    {
        town: 'Velim',
        townCode: 533831,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28101,
        lat: 50.059756,
        long: 15.107217
    },
    {
        town: 'Veliny',
        townCode: 575941,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53401,
        lat: 50.071154,
        long: 16.053816
    },
    {
        town: "Veli\u0161",
        townCode: 573728,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50721,
        lat: 50.407596,
        long: 15.317707
    },
    {
        town: "Veli\u0161",
        townCode: 530867,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25706,
        lat: 49.668658,
        long: 14.823244
    },
    {
        town: "Velk\xe1 B\xedte\u0161",
        townCode: 596973,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59501,
        lat: 49.288727,
        long: 16.225957
    },
    {
        town: "Velk\xe1 Bukov\xe1",
        townCode: 542563,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27023,
        lat: 50.03466,
        long: 13.847293
    },
    {
        town: "Velk\xe1 Bukovina",
        townCode: 562891,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40729,
        lat: 50.730538,
        long: 14.396877
    },
    {
        town: "Velk\xe1 Byst\u0159ice",
        townCode: 505609,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78353,
        lat: 49.594326,
        long: 17.364082
    },
    {
        town: "Velk\xe1 Dobr\xe1",
        townCode: 533025,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27361,
        lat: 50.109746,
        long: 14.069904
    },
    {
        town: "Velk\xe1 Hle\u010Fsebe",
        townCode: 539279,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.966767,
        long: 12.666767
    },
    {
        town: "Velk\xe1 Chmeli\u0161tn\xe1",
        townCode: 529699,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27034,
        lat: 50.063738,
        long: 13.551658
    },
    {
        town: "Velk\xe1 Chy\u0161ka",
        townCode: 549011,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39428,
        lat: 49.511858,
        long: 15.037368
    },
    {
        town: "Velk\xe1 Jesenice",
        townCode: 574562,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55224,
        lat: 50.361175,
        long: 16.037736
    },
    {
        town: "Velk\xe1 Kra\u0161",
        townCode: 553468,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79058,
        lat: 50.363176,
        long: 17.146487
    },
    {
        town: "Velk\xe1 Le\u010Dice",
        townCode: 513539,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26205,
        lat: 49.814815,
        long: 14.323587
    },
    {
        town: "Velk\xe1 Lhota",
        townCode: 545147,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75701,
        lat: 49.437895,
        long: 18.035719
    },
    {
        town: "Velk\xe1 Losenice",
        townCode: 596981,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59211,
        lat: 49.580804,
        long: 15.836834
    },
    {
        town: "Velk\xe1 nad Veli\u010Dkou",
        townCode: 586714,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69674,
        lat: 48.882667,
        long: 17.520706
    },
    {
        town: "Velk\xe1 Polom",
        townCode: 510882,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74764,
        lat: 49.863692,
        long: 18.093414
    },
    {
        town: "Velk\xe1 Skrovnice",
        townCode: 581101,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56201,
        lat: 50.030493,
        long: 16.317005
    },
    {
        town: "Velk\xe1 \u0160t\xe1hle",
        townCode: 551694,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79351,
        lat: 49.9298,
        long: 17.35708
    },
    {
        town: "Velk\xe1 Turn\xe1",
        townCode: 536741,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38601,
        lat: 49.340306,
        long: 13.958805
    },
    {
        town: "Velk\xe9 Albrechtice",
        townCode: 568422,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74291,
        lat: 49.750537,
        long: 18.044045
    },
    {
        town: "Velk\xe9 B\xedlovice",
        townCode: 584983,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69102,
        lat: 48.849388,
        long: 16.892379
    },
    {
        town: "Velk\xe9 B\u0159ezno",
        townCode: 568350,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40323,
        lat: 50.662808,
        long: 14.141852
    },
    {
        town: "Velk\xe9 Hamry",
        townCode: 563838,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46845,
        lat: 50.713834,
        long: 15.315498
    },
    {
        town: "Velk\xe9 Heraltice",
        townCode: 510891,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74775,
        lat: 49.975025,
        long: 17.728896
    },
    {
        town: "Velk\xe9 Host\u011Br\xe1dky",
        townCode: 584991,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69174,
        lat: 49.033238,
        long: 16.870336
    },
    {
        town: "Velk\xe9 Ho\u0161tice",
        townCode: 510939,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74731,
        lat: 49.936189,
        long: 17.973904
    },
    {
        town: "Velk\xe9 Hyd\u010Dice",
        townCode: 557374,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.299235,
        long: 13.668052
    },
    {
        town: "Velk\xe9 Chvojno",
        townCode: 555223,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40334,
        lat: 50.731698,
        long: 14.036815
    },
    {
        town: "Velk\xe9 Janovice",
        townCode: 596990,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.587942,
        long: 16.220152
    },
    {
        town: "Velk\xe9 Karlovice",
        townCode: 545163,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75606,
        lat: 49.360736,
        long: 18.283665
    },
    {
        town: "Velk\xe9 Kun\u011Btice",
        townCode: 569453,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79052,
        lat: 50.316673,
        long: 17.266034
    },
    {
        town: "Velk\xe9 Losiny",
        townCode: 541265,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78815,
        lat: 50.03207,
        long: 17.040687
    },
    {
        town: "Velk\xe9 Mezi\u0159\xed\u010D\xed",
        townCode: 597007,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.356189,
        long: 16.013158
    },
    {
        town: "Velk\xe9 N\u011Bm\u010Dice",
        townCode: 585009,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69163,
        lat: 48.991777,
        long: 16.672186
    },
    {
        town: "Velk\xe9 Opatovice",
        townCode: 582646,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67963,
        lat: 49.612471,
        long: 16.679574
    },
    {
        town: "Velk\xe9 Pavlovice",
        townCode: 585017,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69106,
        lat: 48.904792,
        long: 16.816155
    },
    {
        town: "Velk\xe9 Petrovice",
        townCode: 574571,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54954,
        lat: 50.517437,
        long: 16.206593
    },
    {
        town: "Velk\xe9 Popovice",
        townCode: 538981,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25169,
        lat: 49.922621,
        long: 14.63945
    },
    {
        town: "Velk\xe9 Po\u0159\xed\u010D\xed",
        townCode: 547646,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54932,
        lat: 50.46187,
        long: 16.189414
    },
    {
        town: "Velk\xe9 P\u0159\xedlepy",
        townCode: 539813,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25264,
        lat: 50.160605,
        long: 14.314579
    },
    {
        town: "Velk\xe9 P\u0159\xedto\u010Dno",
        townCode: 533033,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27351,
        lat: 50.116572,
        long: 14.128345
    },
    {
        town: "Velk\xe9 Svato\u0148ovice",
        townCode: 579785,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54235,
        lat: 50.531736,
        long: 16.02864
    },
    {
        town: "Velk\xe9 Tresn\xe9",
        townCode: 587893,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.575246,
        long: 16.380585
    },
    {
        town: "Velk\xe9 V\u0161elisy",
        townCode: 536857,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29427,
        lat: 50.379137,
        long: 14.745169
    },
    {
        town: "Velk\xe9 \u017Dernoseky",
        townCode: 565857,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41201,
        lat: 50.539512,
        long: 14.063884
    },
    {
        town: "Velk\xfd Beranov",
        townCode: 588113,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58821,
        lat: 49.405141,
        long: 15.667107
    },
    {
        town: "Velk\xfd Bor",
        townCode: 557382,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34101,
        lat: 49.365032,
        long: 13.701518
    },
    {
        town: "Velk\xfd Borek",
        townCode: 535265,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27731,
        lat: 50.345385,
        long: 14.515362
    },
    {
        town: "Velk\xfd Chlumec",
        townCode: 531910,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.82779,
        long: 14.087127
    },
    {
        town: "Velk\xfd Karlov",
        townCode: 545325,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67128,
        lat: 48.804633,
        long: 16.305563
    },
    {
        town: "Velk\xfd Luh",
        townCode: 578002,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.19907,
        long: 12.372344
    },
    {
        town: "Velk\xfd Malahov",
        townCode: 554413,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.623677,
        long: 12.955437
    },
    {
        town: "Velk\xfd O\u0159echov",
        townCode: 585912,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76307,
        lat: 49.109464,
        long: 17.668544
    },
    {
        town: "Velk\xfd Osek",
        townCode: 533840,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28151,
        lat: 50.098769,
        long: 15.186392
    },
    {
        town: "Velk\xfd Ratm\xedrov",
        townCode: 562599,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37701,
        lat: 49.177749,
        long: 14.937594
    },
    {
        town: "Velk\xfd Rybn\xedk",
        townCode: 549045,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.490331,
        long: 15.308075
    },
    {
        town: "Velk\xfd \u0160enov",
        townCode: 562912,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40778,
        lat: 50.990885,
        long: 14.374393
    },
    {
        town: "Velk\xfd T\u0159ebe\u0161ov",
        townCode: 574589,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55202,
        lat: 50.392984,
        long: 16.006468
    },
    {
        town: "Velk\xfd T\xfdnec",
        townCode: 505650,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78372,
        lat: 49.552072,
        long: 17.33766
    },
    {
        town: "Velk\xfd \xdajezd",
        townCode: 505668,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78355,
        lat: 49.578679,
        long: 17.483576
    },
    {
        town: "Velk\xfd Valtinov",
        townCode: 562203,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47125,
        lat: 50.743566,
        long: 14.735433
    },
    {
        town: "Velk\xfd V\u0159e\u0161\u0165ov",
        townCode: 579793,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54454,
        lat: 50.358583,
        long: 15.751652
    },
    {
        town: "V\u011Blopol\xed",
        townCode: 552615,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73959,
        lat: 49.700533,
        long: 18.571008
    },
    {
        town: "Velt\u011B\u017Ee",
        townCode: 566896,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.353316,
        long: 13.875325
    },
    {
        town: 'Veltruby',
        townCode: 533858,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.070692,
        long: 15.184648
    },
    {
        town: 'Veltrusy',
        townCode: 535273,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27746,
        lat: 50.270563,
        long: 14.328679
    },
    {
        town: 'Velvary',
        townCode: 533041,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27324,
        lat: 50.281619,
        long: 14.236266
    },
    {
        town: "V\xe9myslice",
        townCode: 595055,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67142,
        lat: 49.022141,
        long: 16.256897
    },
    {
        town: "Vendol\xed",
        townCode: 578932,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56914,
        lat: 49.739926,
        long: 16.413371
    },
    {
        town: "Vendryn\u011B",
        townCode: 554928,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73994,
        lat: 49.666714,
        long: 18.713186
    },
    {
        town: "Vep\u0159\xedkov",
        townCode: 569674,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.744231,
        long: 15.571018
    },
    {
        town: "Vep\u0159ov\xe1",
        townCode: 597015,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59211,
        lat: 49.612545,
        long: 15.82748
    },
    {
        town: "Verm\u011B\u0159ovice",
        townCode: 581119,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56152,
        lat: 50.005589,
        long: 16.562656
    },
    {
        town: "Verne\u0159ice",
        townCode: 562921,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40725,
        lat: 50.661245,
        long: 14.301255
    },
    {
        town: "Vern\xe9\u0159ovice",
        townCode: 547743,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54982,
        lat: 50.614973,
        long: 16.221073
    },
    {
        town: "Vern\xed\u0159ovice",
        townCode: 554146,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78815,
        lat: 50.031808,
        long: 17.130104
    },
    {
        town: "V\u011Brovany",
        townCode: 552119,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78375,
        lat: 49.461184,
        long: 17.288054
    },
    {
        town: "Veru\u0161i\u010Dky",
        townCode: 555711,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36452,
        lat: 50.14131,
        long: 13.173868
    },
    {
        town: "Ve\u0159ovice",
        townCode: 500259,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74273,
        lat: 49.539264,
        long: 18.114362
    },
    {
        town: "Ves Tou\u0161kov",
        townCode: 558494,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33301,
        lat: 49.661704,
        long: 13.119336
    },
    {
        town: 'Vesce',
        townCode: 553263,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.249796,
        long: 14.676986
    },
    {
        town: "Vesel\xe1",
        townCode: 549053,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39470,
        lat: 49.319162,
        long: 15.226841
    },
    {
        town: "Vesel\xe1",
        townCode: 577642,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51252,
        lat: 50.546714,
        long: 15.308967
    },
    {
        town: "Vesel\xe1",
        townCode: 560235,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33701,
        lat: 49.695183,
        long: 13.602933
    },
    {
        town: "Vesel\xe1",
        townCode: 585921,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.237591,
        long: 17.775561
    },
    {
        town: "Vesel\xe9",
        townCode: 562939,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40502,
        lat: 50.784784,
        long: 14.37384
    },
    {
        town: "Vesel\xed",
        townCode: 575968,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53501,
        lat: 50.011243,
        long: 15.618926
    },
    {
        town: "Vesel\xed nad Lu\u017Enic\xed",
        townCode: 553271,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.186616,
        long: 14.699294
    },
    {
        town: "Vesel\xed nad Moravou",
        townCode: 586722,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69801,
        lat: 48.952477,
        long: 17.381015
    },
    {
        town: 'Veselice',
        townCode: 565725,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29404,
        lat: 50.396148,
        long: 15.127224
    },
    {
        town: "Vesel\xed\u010Dko",
        townCode: 549975,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39842,
        lat: 49.388105,
        long: 14.35687
    },
    {
        town: "Vesel\xed\u010Dko",
        townCode: 520420,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75125,
        lat: 49.532193,
        long: 17.509241
    },
    {
        town: "Vesel\xfd \u017D\u010F\xe1r",
        townCode: 569682,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.639737,
        long: 15.526155
    },
    {
        town: 'Vestec',
        townCode: 547565,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55205,
        lat: 50.421946,
        long: 16.02139
    },
    {
        town: 'Vestec',
        townCode: 537942,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28933,
        lat: 50.23837,
        long: 15.146101
    },
    {
        town: 'Vestec',
        townCode: 513458,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25242,
        lat: 49.9806,
        long: 14.504981
    },
    {
        town: "V\u011Bst\xedn",
        townCode: 597031,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59265,
        lat: 49.566977,
        long: 16.340016
    },
    {
        town: "V\u011B\u0161\xedn",
        townCode: 541508,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26243,
        lat: 49.615355,
        long: 13.824322
    },
    {
        town: "V\u011Bte\u0159ov",
        townCode: 586731,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69701,
        lat: 49.028625,
        long: 17.056248
    },
    {
        town: "V\u011Btrn\xfd Jen\xedkov",
        townCode: 588121,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.475877,
        long: 15.478957
    },
    {
        town: "V\u011Btru\u0161ice",
        townCode: 538990,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25067,
        lat: 50.190903,
        long: 14.383516
    },
    {
        town: "V\u011Bt\u0159kovice",
        townCode: 570036,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74743,
        lat: 49.780606,
        long: 17.820558
    },
    {
        town: "V\u011Bt\u0159n\xed",
        townCode: 545830,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38211,
        lat: 48.774351,
        long: 14.286258
    },
    {
        town: "Vev\u010Dice",
        townCode: 595063,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67153,
        lat: 48.962305,
        long: 16.044533
    },
    {
        town: "Veversk\xe1 B\xedt\xfd\u0161ka",
        townCode: 584100,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66471,
        lat: 49.276013,
        long: 16.436969
    },
    {
        town: "Veversk\xe9 Kn\xednice",
        townCode: 584118,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66481,
        lat: 49.236997,
        long: 16.401931
    },
    {
        town: "V\u011B\u017E",
        townCode: 569691,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58256,
        lat: 49.563955,
        long: 15.459156
    },
    {
        town: "V\u011B\u017Eky",
        townCode: 552755,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75119,
        lat: 49.405119,
        long: 17.42328
    },
    {
        town: "V\u011B\u017Eky",
        townCode: 589128,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76833,
        lat: 49.28519,
        long: 17.281547
    },
    {
        town: "V\u011B\u017En\xe1",
        townCode: 549061,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.414284,
        long: 14.988823
    },
    {
        town: "V\u011B\u017En\xe1",
        townCode: 597040,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.460826,
        long: 16.271321
    },
    {
        town: "V\u011B\u017Enice",
        townCode: 569704,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58252,
        lat: 49.514522,
        long: 15.695774
    },
    {
        town: "V\u011B\u017Enice",
        townCode: 588130,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58827,
        lat: 49.480083,
        long: 15.695408
    },
    {
        town: "V\u011B\u017Eni\u010Dka",
        townCode: 588148,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.46043,
        long: 15.70555
    },
    {
        town: "V\u011B\u017Eovat\xe1 Pl\xe1n\u011B",
        townCode: 536300,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.77629,
        long: 14.409159
    },
    {
        town: 'Vchynice',
        townCode: 565865,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.510608,
        long: 14.020198
    },
    {
        town: "V\xedcem\u011B\u0159ice",
        townCode: 590134,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79826,
        lat: 49.344156,
        long: 17.171909
    },
    {
        town: "V\xedcemil",
        townCode: 561037,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.263954,
        long: 14.894383
    },
    {
        town: "V\xedcenice",
        townCode: 588342,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67602,
        lat: 49.08913,
        long: 15.812238
    },
    {
        town: "V\xedcenice u N\xe1m\u011B\u0161t\u011B nad Oslavou",
        townCode: 511242,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.202721,
        long: 16.126096
    },
    {
        town: "V\xedcov",
        townCode: 590142,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79803,
        lat: 49.488573,
        long: 16.959663
    },
    {
        town: "Vid\u010De",
        townCode: 545198,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75653,
        lat: 49.441612,
        long: 18.094836
    },
    {
        town: "V\xedde\u0148",
        townCode: 597058,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59401,
        lat: 49.392227,
        long: 16.03173
    },
    {
        town: 'Vidice',
        townCode: 554421,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34601,
        lat: 49.613863,
        long: 12.835622
    },
    {
        town: 'Vidice',
        townCode: 534536,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28401,
        lat: 49.91671,
        long: 15.165597
    },
    {
        town: 'Vidim',
        townCode: 531936,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.467953,
        long: 14.525934
    },
    {
        town: "Vidlat\xe1 Se\u010D",
        townCode: 578941,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57001,
        lat: 49.836139,
        long: 16.205311
    },
    {
        town: 'Vidnava',
        townCode: 541303,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79055,
        lat: 50.372435,
        long: 17.18636
    },
    {
        town: 'Vidochov',
        townCode: 573736,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50901,
        lat: 50.512639,
        long: 15.565907
    },
    {
        town: "Vidon\xedn",
        townCode: 597066,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59457,
        lat: 49.379842,
        long: 16.222546
    },
    {
        town: 'Vidov',
        townCode: 535737,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37007,
        lat: 48.926848,
        long: 14.494749
    },
    {
        town: 'Vigantice',
        townCode: 545210,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75661,
        lat: 49.443885,
        long: 18.184136
    },
    {
        town: "V\xedchov\xe1 nad Jizerou",
        townCode: 577651,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51241,
        lat: 50.630181,
        long: 15.487779
    },
    {
        town: 'Vikantice',
        townCode: 553191,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78825,
        lat: 50.13639,
        long: 16.99307
    },
    {
        town: "Vik\xfd\u0159ovice",
        townCode: 569445,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78813,
        lat: 49.976988,
        long: 17.013562
    },
    {
        town: "V\xedlanec",
        townCode: 588156,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58835,
        lat: 49.334609,
        long: 15.576862
    },
    {
        town: 'Vilantice',
        townCode: 574597,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.365933,
        long: 15.788877
    },
    {
        town: "Vil\xe9mov",
        townCode: 569712,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58283,
        lat: 49.815761,
        long: 15.53594
    },
    {
        town: "Vil\xe9mov",
        townCode: 568961,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78322,
        lat: 49.635568,
        long: 16.99541
    },
    {
        town: "Vil\xe9mov",
        townCode: 562947,
        district: "D\u011B\u010D\xedn",
        lau: 'CZ0421',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40780,
        lat: 50.990647,
        long: 14.335423
    },
    {
        town: "Vil\xe9mov",
        townCode: 563439,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43154,
        lat: 50.301078,
        long: 13.312156
    },
    {
        town: "Vil\xe9movice",
        townCode: 582654,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67906,
        lat: 49.363886,
        long: 16.746834
    },
    {
        town: "Vil\xe9movice",
        townCode: 569721,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58401,
        lat: 49.686513,
        long: 15.321935
    },
    {
        town: 'Vilice',
        townCode: 553280,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.564574,
        long: 14.864415
    },
    {
        town: 'Vimperk',
        townCode: 550647,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38501,
        lat: 49.052562,
        long: 13.774586
    },
    {
        town: 'Vinary',
        townCode: 571083,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50353,
        lat: 50.289608,
        long: 15.428963
    },
    {
        town: 'Vinary',
        townCode: 572489,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53863,
        lat: 49.959207,
        long: 16.060381
    },
    {
        town: "Vina\u0159e",
        townCode: 534544,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.909198,
        long: 15.501395
    },
    {
        town: "Vina\u0159ice",
        townCode: 534234,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26701,
        lat: 49.892649,
        long: 14.098173
    },
    {
        town: "Vina\u0159ice",
        townCode: 533050,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27307,
        lat: 50.175951,
        long: 14.091171
    },
    {
        town: "Vina\u0159ice",
        townCode: 565628,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29441,
        lat: 50.373911,
        long: 14.952383
    },
    {
        town: "Vina\u0159ice",
        townCode: 566918,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43915,
        lat: 50.265764,
        long: 13.822865
    },
    {
        town: 'Vincencov',
        townCode: 544710,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79804,
        lat: 49.405804,
        long: 17.062571
    },
    {
        town: 'Vinec',
        townCode: 570842,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29301,
        lat: 50.394714,
        long: 14.869901
    },
    {
        town: "Vini\u010Dn\xe9 \u0160umice",
        townCode: 584126,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66406,
        lat: 49.213678,
        long: 16.825512
    },
    {
        town: "Vint\xed\u0159ov",
        townCode: 560685,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35735,
        lat: 50.233928,
        long: 12.717598
    },
    {
        town: "V\xedr",
        townCode: 597074,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59266,
        lat: 49.557484,
        long: 16.32369
    },
    {
        town: "V\xedska",
        townCode: 573582,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58301,
        lat: 49.770412,
        long: 15.652667
    },
    {
        town: "V\xedska u Jev\xed\u010Dka",
        townCode: 578959,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.652641,
        long: 16.707835
    },
    {
        town: "V\xedsky",
        townCode: 582662,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67933,
        lat: 49.538535,
        long: 16.625711
    },
    {
        town: "V\xedsky",
        townCode: 579289,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33843,
        lat: 49.651304,
        long: 13.682749
    },
    {
        town: "Vi\u0161\u0148ov\xe1",
        townCode: 507652,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.219107,
        long: 14.841334
    },
    {
        town: "Vi\u0161\u0148ov\xe1",
        townCode: 564494,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46401,
        lat: 50.966732,
        long: 15.02506
    },
    {
        town: "Vi\u0161\u0148ov\xe1",
        townCode: 541516,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26261,
        lat: 49.705897,
        long: 14.145576
    },
    {
        town: "Vi\u0161\u0148ov\xe9",
        townCode: 595071,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67138,
        lat: 48.982515,
        long: 16.150357
    },
    {
        town: "V\xedtanov",
        townCode: 572497,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.749189,
        long: 15.88183
    },
    {
        town: "Vit\u010Dice",
        townCode: 590151,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79827,
        lat: 49.311939,
        long: 17.240961
    },
    {
        town: "V\xedt\u011Bjeves",
        townCode: 578967,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56906,
        lat: 49.615824,
        long: 16.465469
    },
    {
        town: "Vit\u011Bjovice",
        townCode: 550655,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38427,
        lat: 49.046493,
        long: 14.073468
    },
    {
        town: "V\xedt\u011Bzn\xe1",
        townCode: 579815,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54462,
        lat: 50.488959,
        long: 15.802302
    },
    {
        town: 'Vitice',
        townCode: 533866,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28106,
        lat: 50.031106,
        long: 14.914611
    },
    {
        town: "Vit\xedn",
        townCode: 535893,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37363,
        lat: 49.089591,
        long: 14.545974
    },
    {
        town: "Vitin\u011Bves",
        townCode: 573752,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.393404,
        long: 15.378316
    },
    {
        town: "V\xedtkov",
        townCode: 511021,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74901,
        lat: 49.774549,
        long: 17.749517
    },
    {
        town: "V\xedtkovice",
        townCode: 577669,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51238,
        lat: 50.679115,
        long: 15.531308
    },
    {
        town: "V\xedtonice",
        townCode: 595080,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67161,
        lat: 48.919467,
        long: 16.198985
    },
    {
        town: "V\xedtonice",
        townCode: 589136,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76861,
        lat: 49.447233,
        long: 17.693071
    },
    {
        town: 'Vizovice',
        townCode: 585939,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.223073,
        long: 17.854921
    },
    {
        town: "Vi\u017Eina",
        townCode: 534048,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26724,
        lat: 49.857297,
        long: 14.10473
    },
    {
        town: "Vla\u010Dice",
        townCode: 534552,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.943143,
        long: 15.437595
    },
    {
        town: 'Vladislav',
        townCode: 591904,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67501,
        lat: 49.21027,
        long: 15.988403
    },
    {
        town: 'Vlachova Lhota',
        townCode: 586994,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76601,
        lat: 49.149968,
        long: 17.953557
    },
    {
        town: 'Vlachovice',
        townCode: 587869,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.597135,
        long: 16.041266
    },
    {
        town: 'Vlachovice',
        townCode: 585955,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76324,
        lat: 49.123872,
        long: 17.940124
    },
    {
        town: "Vlachovo B\u0159ez\xed",
        townCode: 550663,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38422,
        lat: 49.081457,
        long: 13.958519
    },
    {
        town: 'Vlasatice',
        townCode: 585025,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69130,
        lat: 48.933846,
        long: 16.484529
    },
    {
        town: 'Vlastec',
        townCode: 598844,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.365671,
        long: 14.211797
    },
    {
        town: "Vlast\u011Bjovice",
        townCode: 534561,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28523,
        lat: 49.731406,
        long: 15.174893
    },
    {
        town: "Vlastibo\u0159",
        townCode: 553298,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.258041,
        long: 14.63683
    },
    {
        town: "Vlastibo\u0159",
        townCode: 563846,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.664974,
        long: 15.311826
    },
    {
        town: "Vlastibo\u0159ice",
        townCode: 564516,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46344,
        lat: 50.618816,
        long: 15.052112
    },
    {
        town: 'Vlastislav',
        townCode: 565873,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41114,
        lat: 50.497071,
        long: 13.955542
    },
    {
        town: "Vla\u0161im",
        townCode: 530883,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.706428,
        long: 14.89891
    },
    {
        town: "Vl\u010Dat\xedn",
        townCode: 591912,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67505,
        lat: 49.305945,
        long: 15.949022
    },
    {
        town: "Vl\u010Det\xednec",
        townCode: 598640,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.264592,
        long: 15.054625
    },
    {
        town: "Vl\u010Deves",
        townCode: 563447,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.357129,
        long: 14.900608
    },
    {
        town: "Vl\u010D\xed",
        townCode: 566691,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.511993,
        long: 13.360356
    },
    {
        town: "Vl\u010D\xed Hab\u0159ina",
        townCode: 575984,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.085931,
        long: 15.596053
    },
    {
        town: "Vl\u010Dice",
        townCode: 579823,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54101,
        lat: 50.562693,
        long: 15.821685
    },
    {
        town: "Vl\u010Dice",
        townCode: 541346,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79065,
        lat: 50.345377,
        long: 17.046051
    },
    {
        town: "Vl\u010Dkov",
        townCode: 581127,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56002,
        lat: 49.907677,
        long: 16.350071
    },
    {
        town: "Vl\u010Dkov\xe1",
        townCode: 585963,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76319,
        lat: 49.31062,
        long: 17.763428
    },
    {
        town: "Vl\u010Dkovice v Podkrkono\u0161\xed",
        townCode: 579831,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.411116,
        long: 15.918264
    },
    {
        town: "Vl\u010Dnov",
        townCode: 592820,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68761,
        lat: 49.009996,
        long: 17.581938
    },
    {
        town: "Vl\u010Dtejn",
        townCode: 540706,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.614724,
        long: 13.495764
    },
    {
        town: "Vlkan\u010Dice",
        townCode: 533874,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.901994,
        long: 14.897229
    },
    {
        town: "Vlkane\u010D",
        townCode: 534579,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28564,
        lat: 49.806485,
        long: 15.403224
    },
    {
        town: 'Vlkanov',
        townCode: 569739,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58291,
        lat: 49.715726,
        long: 15.356843
    },
    {
        town: 'Vlkanov',
        townCode: 566250,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34522,
        lat: 49.488639,
        long: 12.80529
    },
    {
        town: 'Vlkava',
        townCode: 565571,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29443,
        lat: 50.271435,
        long: 14.961431
    },
    {
        town: "Vlko\u0161",
        townCode: 586749,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69641,
        lat: 48.989701,
        long: 17.163666
    },
    {
        town: "Vlko\u0161",
        townCode: 547433,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75119,
        lat: 49.395884,
        long: 17.419119
    },
    {
        town: 'Vlkov',
        townCode: 535915,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.113445,
        long: 14.522263
    },
    {
        town: 'Vlkov',
        townCode: 553310,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.151291,
        long: 14.725326
    },
    {
        town: 'Vlkov',
        townCode: 597082,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.324479,
        long: 16.200393
    },
    {
        town: 'Vlkov',
        townCode: 574601,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.312721,
        long: 15.898493
    },
    {
        town: "Vlkov pod O\u0161kobrhem",
        townCode: 537951,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28904,
        lat: 50.156096,
        long: 15.22052
    },
    {
        town: 'Vlkovice',
        townCode: 539376,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.948927,
        long: 12.739122
    },
    {
        town: 'Vlksice',
        townCode: 598852,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.481012,
        long: 14.441291
    },
    {
        town: 'Vnorovy',
        townCode: 586757,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69661,
        lat: 48.931064,
        long: 17.350609
    },
    {
        town: "Vod\u011Brady",
        townCode: 582671,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67901,
        lat: 49.481598,
        long: 16.557996
    },
    {
        town: "Vod\u011Brady",
        townCode: 576891,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51734,
        lat: 50.208788,
        long: 16.153245
    },
    {
        town: "Vod\u011Brady",
        townCode: 581143,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.949695,
        long: 16.285165
    },
    {
        town: 'Vodice',
        townCode: 553328,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39153,
        lat: 49.464414,
        long: 14.909084
    },
    {
        town: "Vod\u0148any",
        townCode: 551953,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38901,
        lat: 49.147997,
        long: 14.175231
    },
    {
        town: 'Vodochody',
        townCode: 539015,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25069,
        lat: 50.206369,
        long: 14.398885
    },
    {
        town: 'Vodranty',
        townCode: 531014,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.890465,
        long: 15.336406
    },
    {
        town: 'Vodslivy',
        townCode: 532614,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25724,
        lat: 49.84965,
        long: 14.837298
    },
    {
        town: "Vohan\u010Dice",
        townCode: 584134,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.321692,
        long: 16.39396
    },
    {
        town: 'Vochov',
        townCode: 559601,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33023,
        lat: 49.757083,
        long: 13.278711
    },
    {
        town: 'Vojkov',
        townCode: 530891,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25753,
        lat: 49.65232,
        long: 14.519906
    },
    {
        town: 'Vojkovice',
        townCode: 584142,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66701,
        lat: 49.05148,
        long: 16.608308
    },
    {
        town: 'Vojkovice',
        townCode: 555738,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36273,
        lat: 50.303424,
        long: 13.016307
    },
    {
        town: 'Vojkovice',
        townCode: 552488,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.68244,
        long: 18.468124
    },
    {
        town: 'Vojkovice',
        townCode: 535290,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27744,
        lat: 50.296287,
        long: 14.375238
    },
    {
        town: "Vojn\xedkov",
        townCode: 562289,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.35378,
        long: 14.177156
    },
    {
        town: "Vojn\u016Fv M\u011Bstec",
        townCode: 597091,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.679555,
        long: 15.878389
    },
    {
        town: 'Vojslavice',
        townCode: 549126,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.593204,
        long: 15.229069
    },
    {
        town: 'Vojtanov',
        townCode: 539074,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35134,
        lat: 50.166294,
        long: 12.317021
    },
    {
        town: "Vojt\u011Bchov",
        townCode: 572501,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.788649,
        long: 15.973606
    },
    {
        town: 'Vokov',
        townCode: 599239,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.395631,
        long: 15.219887
    },
    {
        town: 'Volanice',
        townCode: 573761,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.335635,
        long: 15.398381
    },
    {
        town: "Vol\xe1rna",
        townCode: 533882,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.091878,
        long: 15.240554
    },
    {
        town: 'Volary',
        townCode: 550671,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38451,
        lat: 48.908916,
        long: 13.886674
    },
    {
        town: 'Volduchy',
        townCode: 560251,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33822,
        lat: 49.776171,
        long: 13.623155
    },
    {
        town: "Vole\u010D",
        townCode: 575992,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.117449,
        long: 15.572804
    },
    {
        town: 'Volenice',
        townCode: 551961,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.252497,
        long: 13.747986
    },
    {
        town: 'Volenice',
        townCode: 541524,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.547875,
        long: 13.883773
    },
    {
        town: "Volev\u010Dice",
        townCode: 588164,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.211082,
        long: 15.444727
    },
    {
        town: "Volev\u010Dice",
        townCode: 546437,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.434989,
        long: 13.690498
    },
    {
        town: 'Volfartice',
        townCode: 562220,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47112,
        lat: 50.730204,
        long: 14.453036
    },
    {
        town: "Volf\xed\u0159ov",
        townCode: 547441,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38001,
        lat: 49.106922,
        long: 15.370353
    },
    {
        town: "Volyn\u011B",
        townCode: 551970,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38701,
        lat: 49.165886,
        long: 13.886339
    },
    {
        town: 'Vonoklasy',
        townCode: 539830,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25228,
        lat: 49.950219,
        long: 14.276801
    },
    {
        town: "Vortov\xe1",
        townCode: 572527,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53961,
        lat: 49.713143,
        long: 15.93634
    },
    {
        town: 'Votice',
        townCode: 530905,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25901,
        lat: 49.64023,
        long: 14.63819
    },
    {
        town: 'Voznice',
        townCode: 541541,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.817253,
        long: 14.21665
    },
    {
        town: "Vr\xe1b\u010De",
        townCode: 545261,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.917453,
        long: 14.376014
    },
    {
        town: 'Vraclav',
        townCode: 581151,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56542,
        lat: 49.968138,
        long: 16.090073
    },
    {
        town: 'Vracov',
        townCode: 586765,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69642,
        lat: 48.975328,
        long: 17.211104
    },
    {
        town: 'Vracovice',
        townCode: 550019,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.902225,
        long: 15.898792
    },
    {
        town: 'Vracovice',
        townCode: 530913,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25801,
        lat: 49.662562,
        long: 14.932317
    },
    {
        town: "Vra\u010Dovice-Orlov",
        townCode: 548022,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.952537,
        long: 16.252476
    },
    {
        town: "Vra\u0148any",
        townCode: 535303,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27707,
        lat: 50.317291,
        long: 14.361804
    },
    {
        town: "Vran\u010Dice",
        townCode: 564362,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.610735,
        long: 14.041861
    },
    {
        town: "Vran\xe9 nad Vltavou",
        townCode: 539848,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25246,
        lat: 49.938512,
        long: 14.383447
    },
    {
        town: 'Vranov',
        townCode: 584151,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66432,
        lat: 49.309357,
        long: 16.613878
    },
    {
        town: 'Vranov',
        townCode: 579491,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.764487,
        long: 13.042022
    },
    {
        town: 'Vranov',
        townCode: 530921,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25722,
        lat: 49.853416,
        long: 14.777021
    },
    {
        town: "Vranov nad Dyj\xed",
        townCode: 595098,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67103,
        lat: 48.894799,
        long: 15.812799
    },
    {
        town: "Vranov\xe1",
        townCode: 582689,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67962,
        lat: 49.553154,
        long: 16.525131
    },
    {
        town: "Vranov\xe1 Lhota",
        townCode: 578975,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 57101,
        lat: 49.710743,
        long: 16.825363
    },
    {
        town: 'Vranovice',
        townCode: 585033,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69125,
        lat: 48.966097,
        long: 16.606707
    },
    {
        town: 'Vranovice',
        townCode: 541567,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.622726,
        long: 13.899074
    },
    {
        town: "Vranovice-Kel\u010Dice",
        townCode: 590177,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79808,
        lat: 49.400982,
        long: 17.111366
    },
    {
        town: "Vranovsk\xe1 Ves",
        townCode: 595101,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67151,
        lat: 48.951592,
        long: 15.918586
    },
    {
        town: "Vran\xfd",
        townCode: 533068,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27373,
        lat: 50.327189,
        long: 14.017251
    },
    {
        town: "Vrat\u011Bn\xedn",
        townCode: 595110,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.904186,
        long: 15.595278
    },
    {
        town: 'Vratimov',
        townCode: 598879,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73932,
        lat: 49.77005,
        long: 18.310255
    },
    {
        town: "Vratisl\xe1vka",
        townCode: 597104,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59451,
        lat: 49.386513,
        long: 16.244137
    },
    {
        town: "Vr\xe1tkov",
        townCode: 564826,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28201,
        lat: 50.047055,
        long: 14.834885
    },
    {
        town: "Vr\xe1tno",
        townCode: 572021,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29426,
        lat: 50.432702,
        long: 14.693699
    },
    {
        town: "Vr\xe1to",
        townCode: 535796,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.988054,
        long: 14.527017
    },
    {
        town: "Vr\xe1\u017E",
        townCode: 549991,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39832,
        lat: 49.383148,
        long: 14.12798
    },
    {
        town: "Vr\xe1\u017E",
        townCode: 531944,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26711,
        lat: 49.983443,
        long: 14.12902
    },
    {
        town: "Vra\u017Ekov",
        townCode: 565881,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.373533,
        long: 14.268153
    },
    {
        town: "Vra\u017En\xe9",
        townCode: 554910,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74235,
        lat: 49.628789,
        long: 17.866773
    },
    {
        town: "Vr\xe1\u017En\xe9",
        townCode: 572292,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.675991,
        long: 16.778122
    },
    {
        town: "Vrb\xe1tky",
        townCode: 590185,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79813,
        lat: 49.508146,
        long: 17.200051
    },
    {
        town: "Vrbat\u016Fv Kostelec",
        townCode: 572535,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53956,
        lat: 49.856443,
        long: 15.941145
    },
    {
        town: "Vrb\u010Dany",
        townCode: 533891,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.050307,
        long: 14.992861
    },
    {
        town: 'Vrbice',
        townCode: 529915,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38473,
        lat: 49.141384,
        long: 13.715891
    },
    {
        town: 'Vrbice',
        townCode: 585041,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69109,
        lat: 48.915184,
        long: 16.897893
    },
    {
        town: 'Vrbice',
        townCode: 566675,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36453,
        lat: 50.14965,
        long: 13.233839
    },
    {
        town: 'Vrbice',
        townCode: 572128,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.369139,
        long: 15.428878
    },
    {
        town: 'Vrbice',
        townCode: 548707,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51741,
        lat: 50.08923,
        long: 16.251784
    },
    {
        town: 'Vrbice',
        townCode: 599611,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28904,
        lat: 50.181015,
        long: 15.230617
    },
    {
        town: 'Vrbice',
        townCode: 565890,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41164,
        lat: 50.4833,
        long: 14.286605
    },
    {
        town: "Vrbi\u010Dany",
        townCode: 571431,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.308192,
        long: 13.995897
    },
    {
        town: "Vrbi\u010Dany",
        townCode: 565903,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41121,
        lat: 50.462705,
        long: 14.084782
    },
    {
        town: 'Vrbka',
        townCode: 542393,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76821,
        lat: 49.228329,
        long: 17.413233
    },
    {
        town: 'Vrbno nad Lesy',
        townCode: 566926,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43906,
        lat: 50.32262,
        long: 13.907083
    },
    {
        town: "Vrbno pod Prad\u011Bdem",
        townCode: 597961,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79326,
        lat: 50.121048,
        long: 17.383262
    },
    {
        town: "Vrbov\xe1 Lhota",
        townCode: 537977,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28911,
        lat: 50.112053,
        long: 15.062754
    },
    {
        town: 'Vrbovec',
        townCode: 595128,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67124,
        lat: 48.799878,
        long: 16.100716
    },
    {
        town: 'Vrcovice',
        townCode: 550001,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.344758,
        long: 14.174529
    },
    {
        town: "Vr\u010De\u0148",
        townCode: 558559,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33541,
        lat: 49.508064,
        long: 13.618988
    },
    {
        town: 'Vrdy',
        townCode: 534587,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28571,
        lat: 49.921633,
        long: 15.472535
    },
    {
        town: "Vrhave\u010D",
        townCode: 557455,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33901,
        lat: 49.345613,
        long: 13.29636
    },
    {
        town: "Vrchlab\xed",
        townCode: 579858,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54301,
        lat: 50.617189,
        long: 15.605106
    },
    {
        town: 'Vrchoslavice',
        townCode: 590193,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79827,
        lat: 49.332781,
        long: 17.219343
    },
    {
        town: 'Vrchotovy Janovice',
        townCode: 530948,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25753,
        lat: 49.666919,
        long: 14.577909
    },
    {
        town: 'Vrchovany',
        townCode: 562238,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.55324,
        long: 14.57122
    },
    {
        town: 'Vrchovnice',
        townCode: 548057,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.323032,
        long: 15.757627
    },
    {
        town: 'Vrchy',
        townCode: 569747,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74245,
        lat: 49.75108,
        long: 17.871191
    },
    {
        town: 'Vroutek',
        townCode: 566934,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43982,
        lat: 50.180096,
        long: 13.37997
    },
    {
        town: "Vrskma\u0148",
        townCode: 563463,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43115,
        lat: 50.488266,
        long: 13.495732
    },
    {
        town: "Vr\u0161ce",
        townCode: 573795,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50733,
        lat: 50.323952,
        long: 15.323155
    },
    {
        town: "Vr\u0161ovice",
        townCode: 511161,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74761,
        lat: 49.884925,
        long: 17.93542
    },
    {
        town: "Vr\u0161ovice",
        townCode: 546887,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.368582,
        long: 13.842119
    },
    {
        town: "Vr\u0161ovka",
        townCode: 574627,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54901,
        lat: 50.323287,
        long: 16.120261
    },
    {
        town: 'Vrutice',
        townCode: 565911,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41147,
        lat: 50.502216,
        long: 14.289857
    },
    {
        town: "V\u0159esina",
        townCode: 568244,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74720,
        lat: 49.945634,
        long: 18.190598
    },
    {
        town: "V\u0159esina",
        townCode: 500291,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74285,
        lat: 49.824282,
        long: 18.125802
    },
    {
        town: "V\u0159eskovice",
        townCode: 566055,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33401,
        lat: 49.525544,
        long: 13.271216
    },
    {
        town: "V\u0159esn\xedk",
        townCode: 549029,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50771,
        lat: 50.438105,
        long: 15.628263
    },
    {
        town: "V\u0159esov\xe1",
        townCode: 560707,
        district: 'Sokolov',
        lau: 'CZ0413',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35735,
        lat: 50.259197,
        long: 12.696593
    },
    {
        town: "V\u0159esovice",
        townCode: 586773,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69648,
        lat: 49.059182,
        long: 17.215114
    },
    {
        town: "V\u0159esovice",
        townCode: 590207,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79809,
        lat: 49.401769,
        long: 17.139043
    },
    {
        town: "Vset\xedn",
        townCode: 541630,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75501,
        lat: 49.339025,
        long: 17.993952
    },
    {
        town: "Vsti\u0161",
        townCode: 558567,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33441,
        lat: 49.645645,
        long: 13.249051
    },
    {
        town: "V\u0161ehrdy",
        townCode: 566497,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.963781,
        long: 13.585179
    },
    {
        town: "V\u0161ehrdy",
        townCode: 563471,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43001,
        lat: 50.420047,
        long: 13.461343
    },
    {
        town: "V\u0161echlapy",
        townCode: 532266,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25726,
        lat: 49.779125,
        long: 14.914341
    },
    {
        town: "V\u0161echlapy",
        townCode: 537985,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28802,
        lat: 50.221181,
        long: 15.028509
    },
    {
        town: "V\u0161echovice",
        townCode: 584169,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66603,
        lat: 49.357215,
        long: 16.494182
    },
    {
        town: "V\u0161echovice",
        townCode: 521531,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75353,
        lat: 49.462861,
        long: 17.758247
    },
    {
        town: "V\u0161ejany",
        townCode: 536938,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29443,
        lat: 50.25487,
        long: 14.953611
    },
    {
        town: "V\u0161ekary",
        townCode: 566071,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34562,
        lat: 49.603515,
        long: 13.042559
    },
    {
        town: "V\u0161elibice",
        townCode: 564532,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46348,
        lat: 50.64615,
        long: 14.95149
    },
    {
        town: "V\u0161emina",
        townCode: 585971,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76315,
        lat: 49.2811,
        long: 17.876932
    },
    {
        town: "V\u0161emyslice",
        townCode: 545287,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37501,
        lat: 49.217064,
        long: 14.35799
    },
    {
        town: "V\u0161e\u0148",
        townCode: 577677,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51265,
        lat: 50.557553,
        long: 15.105323
    },
    {
        town: "V\u0161enice",
        townCode: 566799,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33824,
        lat: 49.817992,
        long: 13.560771
    },
    {
        town: "V\u0161enory",
        townCode: 539856,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25231,
        lat: 49.928938,
        long: 14.304031
    },
    {
        town: "V\u0161epadly",
        townCode: 554448,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34543,
        lat: 49.45098,
        long: 13.105384
    },
    {
        town: "V\u0161eradice",
        townCode: 531952,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26726,
        lat: 49.873756,
        long: 14.104868
    },
    {
        town: "V\u0161eradov",
        townCode: 572543,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.747799,
        long: 15.837299
    },
    {
        town: "V\u0161eruby",
        townCode: 554456,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34507,
        lat: 49.340829,
        long: 12.983339
    },
    {
        town: "V\u0161eruby",
        townCode: 559628,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33016,
        lat: 49.841781,
        long: 13.229541
    },
    {
        town: "V\u0161estary",
        townCode: 571091,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50312,
        lat: 50.255417,
        long: 15.760224
    },
    {
        town: "V\u0161estary",
        townCode: 539031,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25163,
        lat: 49.958709,
        long: 14.68537
    },
    {
        town: "V\u0161estudy",
        townCode: 535311,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27746,
        lat: 50.290915,
        long: 14.342686
    },
    {
        town: "V\u0161estudy",
        townCode: 563480,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43111,
        lat: 50.457467,
        long: 13.507709
    },
    {
        town: "V\u0161esulov",
        townCode: 565130,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27034,
        lat: 50.039761,
        long: 13.610986
    },
    {
        town: "V\u0161etaty",
        townCode: 535320,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27716,
        lat: 50.281971,
        long: 14.593081
    },
    {
        town: "V\u0161etaty",
        townCode: 542598,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27021,
        lat: 50.046201,
        long: 13.757751
    },
    {
        town: "V\u0161evily",
        townCode: 598437,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26272,
        lat: 49.565277,
        long: 13.882648
    },
    {
        town: "V\xfd\u010Dapy",
        townCode: 591939,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67401,
        lat: 49.143644,
        long: 15.877648
    },
    {
        town: "Vyd\u0159\xed",
        townCode: 562629,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37802,
        lat: 49.09253,
        long: 14.945728
    },
    {
        town: "Vyk\xe1\u0148",
        townCode: 537993,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28915,
        lat: 50.119966,
        long: 14.816787
    },
    {
        town: 'Vyklantice',
        townCode: 549134,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39427,
        lat: 49.554788,
        long: 15.040579
    },
    {
        town: "V\xfdkleky",
        townCode: 547450,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75125,
        lat: 49.554998,
        long: 17.475728
    },
    {
        town: "V\xfdprachtice",
        townCode: 581178,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56134,
        lat: 49.987302,
        long: 16.663918
    },
    {
        town: "V\xfdrava",
        townCode: 571105,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50303,
        lat: 50.269739,
        long: 15.979052
    },
    {
        town: "V\xfdrov",
        townCode: 566969,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 49.961857,
        long: 13.462671
    },
    {
        town: "V\xfdrovice",
        townCode: 595136,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67134,
        lat: 48.928356,
        long: 16.120391
    },
    {
        town: "Vyske\u0159",
        townCode: 577685,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51264,
        lat: 50.529406,
        long: 15.15805
    },
    {
        town: "Vyskytn\xe1",
        townCode: 549142,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39405,
        lat: 49.428265,
        long: 15.365624
    },
    {
        town: "Vyskytn\xe1 nad Jihlavou",
        townCode: 588172,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58841,
        lat: 49.419455,
        long: 15.508243
    },
    {
        town: "V\xfdslun\xed",
        townCode: 563498,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43183,
        lat: 50.466591,
        long: 13.237511
    },
    {
        town: "Vyso\u010Dany",
        townCode: 582701,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67913,
        lat: 49.432008,
        long: 16.811126
    },
    {
        town: "Vyso\u010Dany",
        townCode: 595144,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.941156,
        long: 15.689792
    },
    {
        town: "Vyso\u010Dina",
        townCode: 572551,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53901,
        lat: 49.76477,
        long: 15.829087
    },
    {
        town: "Vysok\xe1",
        townCode: 530654,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.562373,
        long: 15.622295
    },
    {
        town: "Vysok\xe1",
        townCode: 597970,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79399,
        lat: 50.26149,
        long: 17.590344
    },
    {
        town: "Vysok\xe1",
        townCode: 578991,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56943,
        lat: 49.663714,
        long: 16.810197
    },
    {
        town: "Vysok\xe1",
        townCode: 535338,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27724,
        lat: 50.412655,
        long: 14.538285
    },
    {
        town: "Vysok\xe1 Lhota",
        townCode: 561771,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.416842,
        long: 15.042363
    },
    {
        town: "Vysok\xe1 Libyn\u011B",
        townCode: 530280,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33141,
        lat: 50.021988,
        long: 13.450793
    },
    {
        town: "Vysok\xe1 nad Labem",
        townCode: 571113,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50331,
        lat: 50.153472,
        long: 15.824842
    },
    {
        town: "Vysok\xe1 Pec",
        townCode: 578029,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36221,
        lat: 50.348275,
        long: 12.696743
    },
    {
        town: "Vysok\xe1 Pec",
        townCode: 563501,
        district: 'Chomutov',
        lau: 'CZ0422',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43159,
        lat: 50.520381,
        long: 13.470366
    },
    {
        town: "Vysok\xe1 Srbsk\xe1",
        townCode: 574635,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54931,
        lat: 50.487806,
        long: 16.22766
    },
    {
        town: "Vysok\xe1 u P\u0159\xedbram\u011B",
        townCode: 541583,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26242,
        lat: 49.63432,
        long: 13.948497
    },
    {
        town: "Vysok\xe9",
        townCode: 588334,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.5819,
        long: 15.965315
    },
    {
        town: "Vysok\xe9 Chvojno",
        townCode: 576000,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53321,
        lat: 50.109088,
        long: 15.973593
    },
    {
        town: "Vysok\xe9 M\xfdto",
        townCode: 581186,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.954364,
        long: 16.164268
    },
    {
        town: "Vysok\xe9 nad Jizerou",
        townCode: 577693,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51211,
        lat: 50.685688,
        long: 15.401633
    },
    {
        town: "Vysok\xe9 Pole",
        townCode: 585980,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76325,
        lat: 49.177519,
        long: 17.93744
    },
    {
        town: "Vysok\xe9 Popovice",
        townCode: 584177,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.183126,
        long: 16.284964
    },
    {
        town: "Vysok\xe9 Studnice",
        townCode: 588181,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58821,
        lat: 49.394112,
        long: 15.73023
    },
    {
        town: "Vysok\xe9 Vesel\xed",
        townCode: 573809,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50703,
        lat: 50.331055,
        long: 15.436421
    },
    {
        town: 'Vysokov',
        townCode: 574643,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54912,
        lat: 50.403868,
        long: 16.116742
    },
    {
        town: "Vysok\xfd Chlumec",
        townCode: 541591,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26252,
        lat: 49.617757,
        long: 14.389867
    },
    {
        town: "Vysok\xfd \xdajezd",
        townCode: 548677,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51771,
        lat: 50.24034,
        long: 16.020182
    },
    {
        town: "Vysok\xfd \xdajezd",
        townCode: 513482,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25744,
        lat: 49.813385,
        long: 14.476422
    },
    {
        town: "Vysok\xfd \xdajezd",
        townCode: 531961,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26716,
        lat: 49.992234,
        long: 14.206303
    },
    {
        town: "Vystr\u010Denovice",
        townCode: 588199,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.151246,
        long: 15.53056
    },
    {
        town: 'Vystrkov',
        townCode: 561797,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39601,
        lat: 49.51978,
        long: 15.348901
    },
    {
        town: "Vy\u0161ehn\u011Bvice",
        townCode: 576018,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53341,
        lat: 50.102402,
        long: 15.583741
    },
    {
        town: "Vy\u0161eho\u0159\xed",
        townCode: 570095,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.93371,
        long: 16.87848
    },
    {
        town: "Vy\u0161eho\u0159ovice",
        townCode: 539040,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25087,
        lat: 50.117881,
        long: 14.773799
    },
    {
        town: "Vy\u0161kov",
        townCode: 592889,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68201,
        lat: 49.277552,
        long: 16.996199
    },
    {
        town: "V\xfd\u0161kov",
        townCode: 566951,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.394975,
        long: 13.670442
    },
    {
        town: "Vy\u0161kovec",
        townCode: 592838,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68774,
        lat: 48.94083,
        long: 17.853445
    },
    {
        town: "Vy\u0161n\xed Lhoty",
        townCode: 552682,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73951,
        lat: 49.635907,
        long: 18.457023
    },
    {
        town: "V\xfd\u0161ovice",
        townCode: 590215,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79809,
        lat: 49.416444,
        long: 17.13914
    },
    {
        town: "Vy\u0161\u0161\xed Brod",
        townCode: 545848,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38273,
        lat: 48.616082,
        long: 14.311919
    },
    {
        town: "V\xfd\u017Eerky",
        townCode: 564796,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.945155,
        long: 14.883469
    },
    {
        town: "Vy\u017Eice",
        townCode: 547841,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53803,
        lat: 49.923275,
        long: 15.621171
    },
    {
        town: "Vy\u017Elovka",
        townCode: 533904,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.984752,
        long: 14.789195
    },
    {
        town: 'Xaverov',
        townCode: 571415,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28506,
        lat: 49.842785,
        long: 14.884454
    },
    {
        town: "Z\xe1be\u0161tn\xed Lhota",
        townCode: 547514,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75127,
        lat: 49.511965,
        long: 17.431217
    },
    {
        town: "Z\xe1blat\xed",
        townCode: 508683,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37901,
        lat: 49.107283,
        long: 14.686266
    },
    {
        town: "Z\xe1blat\xed",
        townCode: 550680,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38433,
        lat: 48.998654,
        long: 13.931392
    },
    {
        town: "Z\xe1blat\xed",
        townCode: 597112,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59453,
        lat: 49.320849,
        long: 16.166438
    },
    {
        town: "Z\xe1born\xe1",
        townCode: 588202,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.486751,
        long: 15.756929
    },
    {
        town: "Z\xe1bo\u0159\xed",
        townCode: 545317,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37384,
        lat: 48.990054,
        long: 14.26727
    },
    {
        town: "Z\xe1bo\u0159\xed",
        townCode: 551988,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38734,
        lat: 49.378898,
        long: 13.827052
    },
    {
        town: "Z\xe1bo\u0159\xed nad Labem",
        townCode: 534595,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28574,
        lat: 50.025315,
        long: 15.349976
    },
    {
        town: "Z\xe1brd\xed",
        townCode: 537195,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.028068,
        long: 13.939516
    },
    {
        town: "Z\xe1brod\xed",
        townCode: 574651,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54941,
        lat: 50.459652,
        long: 16.11255
    },
    {
        town: "Zabru\u0161any",
        townCode: 567868,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41771,
        lat: 50.605057,
        long: 13.787596
    },
    {
        town: "Z\xe1b\u0159eh",
        townCode: 541354,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.8827,
        long: 16.872332
    },
    {
        town: "Z\xe1b\u0159ez\xed-\u0158e\u010Dice",
        townCode: 548839,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.411359,
        long: 15.735635
    },
    {
        town: "Zadn\xed Chodov",
        townCode: 541362,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34815,
        lat: 49.890602,
        long: 12.654668
    },
    {
        town: "Zadn\xed St\u0159\xedte\u017E",
        townCode: 563927,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.494184,
        long: 14.916811
    },
    {
        town: "Zadn\xed T\u0159eba\u0148",
        townCode: 531979,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26729,
        lat: 49.918124,
        long: 14.208189
    },
    {
        town: "Zadn\xed Vyd\u0159\xed",
        townCode: 587231,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.134444,
        long: 15.417199
    },
    {
        town: "Zadn\xed Zho\u0159ec",
        townCode: 597121,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.431175,
        long: 15.939309
    },
    {
        town: "Z\xe1dol\xed",
        townCode: 581194,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56601,
        lat: 49.903246,
        long: 16.127162
    },
    {
        town: "Z\xe1dub-Z\xe1vi\u0161\xedn",
        townCode: 539431,
        district: 'Cheb',
        lau: 'CZ0411',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 35301,
        lat: 49.971876,
        long: 12.744072
    },
    {
        town: "Z\xe1dve\u0159ice-Rakov\xe1",
        townCode: 585998,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76312,
        lat: 49.216644,
        long: 17.805635
    },
    {
        town: "Zah\xe1j\xed",
        townCode: 536016,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37348,
        lat: 49.089687,
        long: 14.370905
    },
    {
        town: "Zahna\u0161ovice",
        townCode: 589152,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.304651,
        long: 17.560195
    },
    {
        town: "Zahor\u010Dice",
        townCode: 536482,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38719,
        lat: 49.208759,
        long: 13.817615
    },
    {
        town: "Z\xe1hornice",
        townCode: 534471,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28903,
        lat: 50.247737,
        long: 15.291028
    },
    {
        town: "Z\xe1horovice",
        townCode: 592846,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68771,
        lat: 49.022764,
        long: 17.779332
    },
    {
        town: "Zaho\u0159any",
        townCode: 554464,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.434161,
        long: 13.002035
    },
    {
        town: "Zaho\u0159any",
        townCode: 571288,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25210,
        lat: 49.849446,
        long: 14.295423
    },
    {
        town: "Z\xe1ho\u0159\xed",
        townCode: 507695,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37821,
        lat: 49.212955,
        long: 14.798462
    },
    {
        town: "Z\xe1ho\u0159\xed",
        townCode: 550027,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39818,
        lat: 49.343828,
        long: 14.212649
    },
    {
        town: "Z\xe1ho\u0159\xed",
        townCode: 599000,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39165,
        lat: 49.239696,
        long: 14.513589
    },
    {
        town: "Z\xe1ho\u0159\xed",
        townCode: 577707,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51301,
        lat: 50.61161,
        long: 15.274194
    },
    {
        town: "Zahr\xe1dka",
        townCode: 591947,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67571,
        lat: 49.244522,
        long: 16.098416
    },
    {
        town: "Zahr\xe1dka",
        townCode: 578827,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33035,
        lat: 49.880856,
        long: 13.211746
    },
    {
        town: "Zahr\xe1dky",
        townCode: 547468,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37853,
        lat: 49.20085,
        long: 15.241907
    },
    {
        town: "Zahr\xe1dky",
        townCode: 562246,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47101,
        lat: 50.634208,
        long: 14.524708
    },
    {
        town: "Z\xe1chlum\xed",
        townCode: 581208,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56186,
        lat: 50.095447,
        long: 16.376348
    },
    {
        town: "Z\xe1chlum\xed",
        townCode: 541664,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.80022,
        long: 12.965032
    },
    {
        town: "Zachot\xedn",
        townCode: 549177,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.462434,
        long: 15.347987
    },
    {
        town: "Zachra\u0161\u0165any",
        townCode: 571130,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.211244,
        long: 15.483086
    },
    {
        town: "Zaje\u010D\xed",
        townCode: 585050,
        district: "B\u0159eclav",
        lau: 'CZ0644',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69105,
        lat: 48.87305,
        long: 16.766566
    },
    {
        town: "Zaje\u010Dice",
        townCode: 572578,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53835,
        lat: 49.910081,
        long: 15.884208
    },
    {
        town: "Zaje\u010Dov",
        townCode: 531995,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26763,
        lat: 49.774455,
        long: 13.840825
    },
    {
        town: "Z\xe1jezd",
        townCode: 571598,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27343,
        lat: 50.166081,
        long: 14.220609
    },
    {
        town: "Z\xe1jezdec",
        townCode: 547859,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53851,
        lat: 49.931755,
        long: 15.926941
    },
    {
        town: "Zaj\xed\u010Dkov",
        townCode: 561975,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.378057,
        long: 15.258087
    },
    {
        town: "Z\xe1kolany",
        townCode: 533092,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27328,
        lat: 50.196515,
        long: 14.247943
    },
    {
        town: "Zak\u0159any",
        townCode: 584185,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.170641,
        long: 16.32536
    },
    {
        town: "Z\xe1kupy",
        townCode: 562262,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47123,
        lat: 50.684854,
        long: 14.645335
    },
    {
        town: "Z\xe1les\xed",
        townCode: 595152,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67102,
        lat: 48.954232,
        long: 15.782156
    },
    {
        town: "Z\xe1lesn\xe1 Zho\u0159",
        townCode: 584193,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.250286,
        long: 16.28985
    },
    {
        town: "Zale\u0161any",
        townCode: 513202,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.03578,
        long: 15.007909
    },
    {
        town: "Z\xe1lezlice",
        townCode: 535354,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27745,
        lat: 50.307557,
        long: 14.438251
    },
    {
        town: "Z\xe1lezly",
        townCode: 550698,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38481,
        lat: 49.10755,
        long: 13.894683
    },
    {
        town: "Zalo\u0148ov",
        townCode: 574660,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55101,
        lat: 50.374068,
        long: 15.88795
    },
    {
        town: "Z\xe1l\u0161\xed",
        townCode: 553361,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.218022,
        long: 14.599292
    },
    {
        town: "Z\xe1l\u0161\xed",
        townCode: 581216,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 49.965363,
        long: 16.240831
    },
    {
        town: "Zalu\u017Eany",
        townCode: 541613,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26284,
        lat: 49.542353,
        long: 14.085834
    },
    {
        town: "Z\xe1lu\u017E\xed",
        townCode: 532002,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26761,
        lat: 49.842798,
        long: 13.860599
    },
    {
        town: "Z\xe1lu\u017E\xed",
        townCode: 542482,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41301,
        lat: 50.460172,
        long: 14.32257
    },
    {
        town: "Z\xe1lu\u017Eice",
        townCode: 530603,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.321307,
        long: 13.604272
    },
    {
        town: "Z\xe1m\u011Bl",
        townCode: 576921,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51743,
        lat: 50.096649,
        long: 16.298906
    },
    {
        town: "Z\xe1most\xed-Blata",
        townCode: 549193,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50601,
        lat: 50.470898,
        long: 15.264128
    },
    {
        town: "Z\xe1mrsk",
        townCode: 581224,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56543,
        lat: 49.986276,
        long: 16.128847
    },
    {
        town: "Z\xe1mrsky",
        townCode: 522775,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75301,
        lat: 49.50645,
        long: 17.827929
    },
    {
        town: "Z\xe1py",
        townCode: 505781,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25001,
        lat: 50.1651,
        long: 14.680157
    },
    {
        town: "Z\xe1rubice",
        townCode: 591955,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67552,
        lat: 49.124327,
        long: 15.981536
    },
    {
        town: "Z\xe1ryby",
        townCode: 535362,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27713,
        lat: 50.220678,
        long: 14.625983
    },
    {
        town: "Z\xe1\u0159eck\xe1 Lhota",
        townCode: 581232,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56501,
        lat: 49.993208,
        long: 16.246224
    },
    {
        town: "Z\xe1\u0159\xed\u010D\xed",
        townCode: 589161,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76811,
        lat: 49.382726,
        long: 17.352936
    },
    {
        town: "Z\xe1sada",
        townCode: 563854,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46825,
        lat: 50.697784,
        long: 15.27004
    },
    {
        town: "Z\xe1smuky",
        townCode: 533921,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28144,
        lat: 49.954806,
        long: 15.030686
    },
    {
        town: "Zast\xe1vka",
        townCode: 584207,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.188096,
        long: 16.363201
    },
    {
        town: "Z\xe1st\u0159izly",
        townCode: 587257,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76805,
        lat: 49.149944,
        long: 17.23521
    },
    {
        town: "Za\u0161ov\xe1",
        townCode: 545236,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75651,
        lat: 49.474196,
        long: 18.044471
    },
    {
        town: "Za\u0161ovice",
        townCode: 591963,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67521,
        lat: 49.258337,
        long: 15.72578
    },
    {
        town: "Z\xe1tor",
        townCode: 597988,
        district: "Brunt\xe1l",
        lau: 'CZ0801',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 79316,
        lat: 50.034227,
        long: 17.593061
    },
    {
        town: "Z\xe1vada",
        townCode: 553492,
        district: 'Opava',
        lau: 'CZ0805',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74719,
        lat: 49.954135,
        long: 18.165759
    },
    {
        town: 'Zavidov',
        townCode: 542601,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27035,
        lat: 50.056797,
        long: 13.620408
    },
    {
        town: "Z\xe1vist",
        townCode: 586005,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67922,
        lat: 49.375272,
        long: 16.57215
    },
    {
        town: "Z\xe1vi\u0161ice",
        townCode: 568473,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74221,
        lat: 49.613357,
        long: 18.103114
    },
    {
        town: 'Zavlekov',
        townCode: 557463,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34142,
        lat: 49.337465,
        long: 13.49054
    },
    {
        town: "Z\xe1vraty",
        townCode: 599778,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37001,
        lat: 48.93815,
        long: 14.381608
    },
    {
        town: "Zbe\u010Dno",
        townCode: 542610,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27024,
        lat: 50.0419,
        long: 13.920468
    },
    {
        town: "Zbel\xedtov",
        townCode: 550035,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.456735,
        long: 14.329173
    },
    {
        town: 'Zbenice',
        townCode: 564320,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26231,
        lat: 49.592261,
        long: 14.089159
    },
    {
        town: "Zb\u011B\u0161i\u010Dky",
        townCode: 550043,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39843,
        lat: 49.392605,
        long: 14.426574
    },
    {
        town: 'Zbilidy',
        townCode: 588211,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.443804,
        long: 15.422783
    },
    {
        town: 'Zbinohy',
        townCode: 588229,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58842,
        lat: 49.48738,
        long: 15.480494
    },
    {
        town: 'Zbiroh',
        townCode: 560260,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.860345,
        long: 13.772729
    },
    {
        town: 'Zbizuby',
        townCode: 534609,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28504,
        lat: 49.831085,
        long: 15.047665
    },
    {
        town: 'Zblovice',
        townCode: 595161,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67107,
        lat: 48.957838,
        long: 15.70531
    },
    {
        town: 'Zborov',
        townCode: 570338,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.943754,
        long: 16.835964
    },
    {
        town: 'Zborovice',
        townCode: 589187,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76832,
        lat: 49.248989,
        long: 17.284751
    },
    {
        town: 'Zborovy',
        townCode: 578312,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34034,
        lat: 49.381199,
        long: 13.515763
    },
    {
        town: "Zbo\u017E\xed\u010Dko",
        townCode: 599697,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28925,
        lat: 50.225835,
        long: 14.939922
    },
    {
        town: 'Zbraslav',
        townCode: 584215,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66484,
        lat: 49.221653,
        long: 16.294251
    },
    {
        town: 'Zbraslavec',
        townCode: 582727,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67972,
        lat: 49.483999,
        long: 16.528495
    },
    {
        town: 'Zbraslavice',
        townCode: 534617,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28521,
        lat: 49.811891,
        long: 15.183296
    },
    {
        town: "Zbra\u0161\xedn",
        townCode: 566977,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.299412,
        long: 13.766026
    },
    {
        town: "Zb\u016Fch",
        townCode: 559661,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33022,
        lat: 49.678509,
        long: 13.225754
    },
    {
        town: 'Zbuzany',
        townCode: 539872,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25225,
        lat: 50.024277,
        long: 14.286854
    },
    {
        town: 'Zbyslavice',
        townCode: 568449,
        district: "Ostrava-m\u011Bsto",
        lau: 'CZ0806',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74283,
        lat: 49.805441,
        long: 18.075576
    },
    {
        town: "Zb\xfd\u0161ov",
        townCode: 584223,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66411,
        lat: 49.155344,
        long: 16.349616
    },
    {
        town: "Zb\xfd\u0161ov",
        townCode: 593699,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68352,
        lat: 49.131422,
        long: 16.80578
    },
    {
        town: "Zb\xfd\u0161ov",
        townCode: 534625,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28565,
        lat: 49.811657,
        long: 15.353208
    },
    {
        town: 'Zbytiny',
        townCode: 550701,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38441,
        lat: 48.942727,
        long: 13.978153
    },
    {
        town: "Zd\u011Bchov",
        townCode: 545244,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75607,
        lat: 49.261068,
        long: 18.077943
    },
    {
        town: 'Zdechovice',
        townCode: 573744,
        district: "Hradec Kr\xe1lov\xe9",
        lau: 'CZ0521',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50401,
        lat: 50.224827,
        long: 15.56176
    },
    {
        town: 'Zdechovice',
        townCode: 576026,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53311,
        lat: 50.013006,
        long: 15.46958
    },
    {
        town: 'Zdelov',
        townCode: 576930,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51721,
        lat: 50.100779,
        long: 16.142255
    },
    {
        town: 'Zdemyslice',
        townCode: 558583,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.607059,
        long: 13.519921
    },
    {
        town: "Zde\u0148kov",
        townCode: 588245,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.140036,
        long: 15.62007
    },
    {
        town: 'Zderaz',
        townCode: 573876,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53944,
        lat: 49.828645,
        long: 16.100192
    },
    {
        town: "Zd\u011Bt\xedn",
        townCode: 590223,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79843,
        lat: 49.50595,
        long: 16.988886
    },
    {
        town: "Zd\u011Bt\xedn",
        townCode: 571814,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29471,
        lat: 50.312702,
        long: 14.812523
    },
    {
        town: 'Zdiby',
        townCode: 539058,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25066,
        lat: 50.168096,
        long: 14.451284
    },
    {
        town: 'Zdice',
        townCode: 532011,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26751,
        lat: 49.912178,
        long: 13.977574
    },
    {
        town: "Zd\xedkov",
        townCode: 550728,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38472,
        lat: 49.084672,
        long: 13.697479
    },
    {
        town: 'Zdislava',
        townCode: 564541,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46353,
        lat: 50.765065,
        long: 14.876403
    },
    {
        town: 'Zdislavice',
        townCode: 531022,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25764,
        lat: 49.686587,
        long: 14.974594
    },
    {
        town: "Zdob\xedn",
        townCode: 548847,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54401,
        lat: 50.415397,
        long: 15.704708
    },
    {
        town: 'Zdobnice',
        townCode: 576948,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51601,
        lat: 50.238579,
        long: 16.408683
    },
    {
        town: 'Zdounky',
        townCode: 589195,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76802,
        lat: 49.227808,
        long: 17.319096
    },
    {
        town: 'Zduchovice',
        townCode: 513512,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26263,
        lat: 49.638685,
        long: 14.209044
    },
    {
        town: "Zelen\xe1 Hora",
        townCode: 593702,
        district: "Vy\u0161kov",
        lau: 'CZ0646',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 68321,
        lat: 49.329083,
        long: 17.01382
    },
    {
        town: "Zeleneck\xe1 Lhota",
        townCode: 573183,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50723,
        lat: 50.401703,
        long: 15.178861
    },
    {
        town: "Zelene\u010D",
        townCode: 539066,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25091,
        lat: 50.133721,
        long: 14.660805
    },
    {
        town: "Zem\u011Btice",
        townCode: 558591,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33452,
        lat: 49.578482,
        long: 13.186446
    },
    {
        town: "Zho\u0159",
        townCode: 550060,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39901,
        lat: 49.501316,
        long: 14.382796
    },
    {
        town: "Zho\u0159",
        townCode: 582735,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67923,
        lat: 49.414782,
        long: 16.47899
    },
    {
        town: "Zho\u0159",
        townCode: 588253,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58826,
        lat: 49.4427,
        long: 15.771449
    },
    {
        town: "Zho\u0159",
        townCode: 541460,
        district: 'Tachov',
        lau: 'CZ0327',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34901,
        lat: 49.660005,
        long: 12.969779
    },
    {
        town: "Zho\u0159 u Mlad\xe9 Vo\u017Eice",
        townCode: 599034,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39143,
        lat: 49.5436,
        long: 14.764978
    },
    {
        town: "Zho\u0159 u T\xe1bora",
        townCode: 560430,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39002,
        lat: 49.357623,
        long: 14.657625
    },
    {
        town: "Zho\u0159ec",
        townCode: 561363,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.489741,
        long: 14.962556
    },
    {
        town: 'Zichovec',
        townCode: 571423,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27374,
        lat: 50.271159,
        long: 13.926136
    },
    {
        town: "Zl\xe1manec",
        townCode: 592854,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68712,
        lat: 49.129954,
        long: 17.628309
    },
    {
        town: "Zlat\xe1",
        townCode: 513644,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25083,
        lat: 50.04033,
        long: 14.710148
    },
    {
        town: "Zlat\xe1 Koruna",
        townCode: 545864,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38202,
        lat: 48.854873,
        long: 14.369638
    },
    {
        town: "Zlat\xe1 Ole\u0161nice",
        townCode: 579866,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54101,
        lat: 50.61779,
        long: 15.944887
    },
    {
        town: "Zlat\xe1 Ole\u0161nice",
        townCode: 563862,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46847,
        lat: 50.708647,
        long: 15.353616
    },
    {
        town: "Zlat\xe9 Hory",
        townCode: 597996,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79376,
        lat: 50.263894,
        long: 17.396122
    },
    {
        town: "Zl\xe1tenka",
        townCode: 598666,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39501,
        lat: 49.423554,
        long: 15.058658
    },
    {
        town: "Zlatn\xedky-Hodkovice",
        townCode: 539881,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25241,
        lat: 49.960627,
        long: 14.480805
    },
    {
        town: 'Zlechov',
        townCode: 592862,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68710,
        lat: 49.074059,
        long: 17.379491
    },
    {
        town: "ZL\xcdN",
        townCode: 585068,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76001,
        lat: 49.224537,
        long: 17.662863
    },
    {
        town: 'Zliv',
        townCode: 545341,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37344,
        lat: 49.066188,
        long: 14.366234
    },
    {
        town: 'Zlobice',
        townCode: 589217,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76831,
        lat: 49.301917,
        long: 17.312714
    },
    {
        town: "Zlon\u010Dice",
        townCode: 531511,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27801,
        lat: 50.228883,
        long: 14.35768
    },
    {
        town: 'Zlonice',
        townCode: 533114,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27371,
        lat: 50.287603,
        long: 14.092247
    },
    {
        town: "Zlon\xedn",
        townCode: 539082,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25064,
        lat: 50.215834,
        long: 14.507857
    },
    {
        town: "Zlosy\u0148",
        townCode: 535389,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27744,
        lat: 50.278049,
        long: 14.368713
    },
    {
        town: 'Zlukov',
        townCode: 599271,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.193033,
        long: 14.745188
    },
    {
        town: "Zn\u011Bt\xednek",
        townCode: 597139,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59444,
        lat: 49.469654,
        long: 15.926644
    },
    {
        town: 'Znojmo',
        townCode: 593711,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66902,
        lat: 48.856011,
        long: 16.054368
    },
    {
        town: "Zru\u010D nad S\xe1zavou",
        townCode: 534633,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28522,
        lat: 49.740205,
        long: 15.106164
    },
    {
        town: "Zru\u010D-Senec",
        townCode: 559679,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33008,
        lat: 49.8031,
        long: 13.419093
    },
    {
        town: "Zub\u010Dice",
        townCode: 545872,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.794137,
        long: 14.40728
    },
    {
        town: 'Zubrnice',
        townCode: 568384,
        district: "\xdast\xed nad Labem",
        lau: 'CZ0427',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 40002,
        lat: 50.649558,
        long: 14.220493
    },
    {
        town: "Zub\u0159\xed",
        townCode: 597147,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59231,
        lat: 49.571209,
        long: 16.123791
    },
    {
        town: "Zub\u0159\xed",
        townCode: 545252,
        district: "Vset\xedn",
        lau: 'CZ0723',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 75654,
        lat: 49.466126,
        long: 18.092595
    },
    {
        town: "Zv\xe1novice",
        townCode: 539091,
        district: "Praha-v\xfdchod",
        lau: 'CZ0209',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25165,
        lat: 49.93205,
        long: 14.780336
    },
    {
        town: "Zv\u011Brkovice",
        townCode: 591980,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67602,
        lat: 49.02563,
        long: 15.863268
    },
    {
        town: "Zv\u011Brotice",
        townCode: 553409,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39201,
        lat: 49.272067,
        long: 14.744794
    },
    {
        town: "Zv\u011B\u0159\xednek",
        townCode: 534862,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28913,
        lat: 50.153287,
        long: 15.005845
    },
    {
        town: "Zv\u011Bstov",
        townCode: 531049,
        district: "Bene\u0161ov",
        lau: 'CZ0201',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25706,
        lat: 49.632768,
        long: 14.792228
    },
    {
        town: "Zv\u011Bstovice",
        townCode: 548626,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58282,
        lat: 49.848023,
        long: 15.512694
    },
    {
        town: "Zv\xedkov",
        townCode: 535591,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37372,
        lat: 48.980946,
        long: 14.617022
    },
    {
        town: "Zv\xedkov",
        townCode: 536237,
        district: "\u010Cesk\xfd Krumlov",
        lau: 'CZ0312',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38232,
        lat: 48.802632,
        long: 14.448859
    },
    {
        town: "Zv\xedkovec",
        townCode: 541061,
        district: 'Rokycany',
        lau: 'CZ0326',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33808,
        lat: 49.954183,
        long: 13.688647
    },
    {
        town: "Zv\xedkovsk\xe9 Podhrad\xed",
        townCode: 562165,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39701,
        lat: 49.426678,
        long: 14.200666
    },
    {
        town: 'Zvole',
        townCode: 597155,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59256,
        lat: 49.494545,
        long: 16.174948
    },
    {
        town: 'Zvole',
        townCode: 541478,
        district: "\u0160umperk",
        lau: 'CZ0715',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78901,
        lat: 49.839915,
        long: 16.914445
    },
    {
        town: 'Zvole',
        townCode: 539902,
        district: "Praha-z\xe1pad",
        lau: 'CZ020A',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 25245,
        lat: 49.934765,
        long: 14.417796
    },
    {
        town: "Zvolen\u011Bves",
        townCode: 533122,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27325,
        lat: 50.231256,
        long: 14.182316
    },
    {
        town: 'Zvolenovice',
        townCode: 588261,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58856,
        lat: 49.163385,
        long: 15.505675
    },
    {
        town: 'Zvotoky',
        townCode: 536873,
        district: 'Strakonice',
        lau: 'CZ0316',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38716,
        lat: 49.212476,
        long: 13.757754
    },
    {
        town: "\u017Dab\u010Dice",
        townCode: 584231,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66463,
        lat: 49.011697,
        long: 16.602677
    },
    {
        town: "\u017Dabe\u0148",
        townCode: 552691,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73925,
        lat: 49.708875,
        long: 18.304316
    },
    {
        town: "\u017Dabonosy",
        townCode: 513261,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28002,
        lat: 50.035467,
        long: 15.027312
    },
    {
        town: "\u017Dabov\u0159esky",
        townCode: 545368,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37341,
        lat: 49.002908,
        long: 14.334957
    },
    {
        town: "\u017Dabov\u0159esky nad Oh\u0159\xed",
        townCode: 565938,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41002,
        lat: 50.413264,
        long: 14.091136
    },
    {
        town: "\u017Dacl\xe9\u0159",
        townCode: 579874,
        district: 'Trutnov',
        lau: 'CZ0525',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54201,
        lat: 50.663393,
        long: 15.91074
    },
    {
        town: "\u017D\xe1dovice",
        townCode: 586781,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69649,
        lat: 49.013463,
        long: 17.197031
    },
    {
        town: "\u017D\xe1kava",
        townCode: 530182,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33204,
        lat: 49.630078,
        long: 13.530832
    },
    {
        town: "\u017D\xe1kovice",
        townCode: 523453,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75354,
        lat: 49.454345,
        long: 17.660074
    },
    {
        town: "\u017D\xe1ky",
        townCode: 534641,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28601,
        lat: 49.885374,
        long: 15.3684
    },
    {
        town: "\u017Dalany",
        townCode: 567876,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41763,
        lat: 50.59013,
        long: 13.906447
    },
    {
        town: "\u017Dalhostice",
        townCode: 565946,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41101,
        lat: 50.523199,
        long: 14.091474
    },
    {
        town: "\u017Dalkovice",
        townCode: 589225,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76823,
        lat: 49.372004,
        long: 17.436042
    },
    {
        town: "\u017Damberk",
        townCode: 581259,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.087401,
        long: 16.465301
    },
    {
        town: "\u017Dampach",
        townCode: 581267,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56401,
        lat: 50.038071,
        long: 16.427306
    },
    {
        town: "\u017Dandov",
        townCode: 562297,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47107,
        lat: 50.714039,
        long: 14.396344
    },
    {
        town: "\u017D\xe1r",
        townCode: 545376,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37401,
        lat: 48.806971,
        long: 14.708287
    },
    {
        town: "\u017D\xe1ravice",
        townCode: 576042,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53316,
        lat: 50.105854,
        long: 15.557217
    },
    {
        town: "\u017Daro\u0161ice",
        townCode: 586790,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69634,
        lat: 49.040748,
        long: 16.967239
    },
    {
        town: "\u017D\xe1rovn\xe1",
        townCode: 529923,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.046302,
        long: 13.899419
    },
    {
        town: "\u017Dat\u010Dany",
        townCode: 584240,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66453,
        lat: 49.087986,
        long: 16.733849
    },
    {
        town: "\u017Datec",
        townCode: 588270,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58862,
        lat: 49.206444,
        long: 15.509005
    },
    {
        town: "\u017Datec",
        townCode: 566985,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.327276,
        long: 13.545886
    },
    {
        town: "\u017Dd\xe1nice",
        townCode: 586803,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69632,
        lat: 49.067387,
        long: 17.027619
    },
    {
        town: "\u017Dd\xe1nice",
        townCode: 597163,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59301,
        lat: 49.54756,
        long: 16.262191
    },
    {
        town: "\u017Dd\xe1nice",
        townCode: 513164,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28163,
        lat: 49.969517,
        long: 14.959179
    },
    {
        town: "\u017Dd\xe1nov",
        townCode: 554472,
        district: "Doma\u017Elice",
        lau: 'CZ0321',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34401,
        lat: 49.461029,
        long: 12.854517
    },
    {
        town: "\u017D\u010F\xe1r",
        townCode: 529761,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37842,
        lat: 49.254193,
        long: 15.076662
    },
    {
        town: "\u017D\u010F\xe1r",
        townCode: 598861,
        district: "P\xedsek",
        lau: 'CZ0314',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39811,
        lat: 49.233222,
        long: 14.227928
    },
    {
        town: "\u017D\u010F\xe1r",
        townCode: 582743,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67902,
        lat: 49.421675,
        long: 16.697884
    },
    {
        town: "\u017D\u010F\xe1r",
        townCode: 536971,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29412,
        lat: 50.543762,
        long: 15.080449
    },
    {
        town: "\u017D\u010F\xe1r",
        townCode: 598518,
        district: "Rakovn\xedk",
        lau: 'CZ020C',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27033,
        lat: 50.058554,
        long: 13.459724
    },
    {
        town: "\u017D\u010F\xe1r nad Metuj\xed",
        townCode: 574686,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54955,
        lat: 50.538847,
        long: 16.213389
    },
    {
        town: "\u017D\u010F\xe1r nad Orlic\xed",
        townCode: 576956,
        district: "Rychnov nad Kn\u011B\u017Enou",
        lau: 'CZ0524',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 51723,
        lat: 50.119855,
        long: 16.069446
    },
    {
        town: "\u017D\u010F\xe1r nad S\xe1zavou",
        townCode: 595209,
        district: "\u017D\u010F\xe1r nad S\xe1zavou",
        lau: 'CZ0635',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 59101,
        lat: 49.564288,
        long: 15.939507
    },
    {
        town: "\u017D\u010F\xe1rec",
        townCode: 597171,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 59456,
        lat: 49.379867,
        long: 16.266562
    },
    {
        town: "\u017D\u010F\xe1rek",
        townCode: 544604,
        district: 'Liberec',
        lau: 'CZ0513',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46344,
        lat: 50.640548,
        long: 15.111598
    },
    {
        town: "\u017D\u010F\xe1rky",
        townCode: 574694,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 54937,
        lat: 50.469046,
        long: 16.227922
    },
    {
        town: "\u017D\u010F\xe1rn\xe1",
        townCode: 582751,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67952,
        lat: 49.468738,
        long: 16.758612
    },
    {
        town: "\u017Dd\xedrec",
        townCode: 530662,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58001,
        lat: 49.629262,
        long: 15.642039
    },
    {
        town: "\u017Dd\xedrec",
        townCode: 588288,
        district: 'Jihlava',
        lau: 'CZ0632',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58813,
        lat: 49.454999,
        long: 15.678575
    },
    {
        town: "\u017Dd\xedrec",
        townCode: 514195,
        district: "\u010Cesk\xe1 L\xedpa",
        lau: 'CZ0511',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 47201,
        lat: 50.515564,
        long: 14.624388
    },
    {
        town: "\u017Dd\xedrec",
        townCode: 558605,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33601,
        lat: 49.551092,
        long: 13.572958
    },
    {
        town: "\u017Dd\xedrec nad Doubravou",
        townCode: 569780,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58263,
        lat: 49.696057,
        long: 15.813706
    },
    {
        town: "\u017Debr\xe1k",
        townCode: 532029,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26753,
        lat: 49.875844,
        long: 13.897457
    },
    {
        town: "\u017Dehu\u0148",
        townCode: 538035,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28905,
        lat: 50.135585,
        long: 15.291395
    },
    {
        town: "\u017Dehu\u0161ice",
        townCode: 534650,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28575,
        lat: 49.969555,
        long: 15.407492
    },
    {
        town: "\u017Delatovice",
        townCode: 523640,
        district: "P\u0159erov",
        lau: 'CZ0714',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 75116,
        lat: 49.444143,
        long: 17.506312
    },
    {
        town: "\u017Dele\u010D",
        townCode: 553417,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39174,
        lat: 49.318442,
        long: 14.646734
    },
    {
        town: "\u017Dele\u010D",
        townCode: 590240,
        district: "Prost\u011Bjov",
        lau: 'CZ0713',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79807,
        lat: 49.346065,
        long: 17.097896
    },
    {
        town: "\u017Delechovice",
        townCode: 552399,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78391,
        lat: 49.754196,
        long: 17.144047
    },
    {
        town: "\u017Delechovice nad D\u0159evnic\xed",
        townCode: 500011,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76311,
        lat: 49.218113,
        long: 17.747486
    },
    {
        town: "\u017Delenice",
        townCode: 599425,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27341,
        lat: 50.210487,
        long: 14.164618
    },
    {
        town: "\u017Delenice",
        townCode: 567426,
        district: 'Most',
        lau: 'CZ0425',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43401,
        lat: 50.527718,
        long: 13.726169
    },
    {
        town: "\u017Dele\u0161ice",
        townCode: 584266,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66443,
        lat: 49.116986,
        long: 16.581479
    },
    {
        town: "\u017Deletava",
        townCode: 591998,
        district: "T\u0159eb\xed\u010D",
        lau: 'CZ0634',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 67526,
        lat: 49.141973,
        long: 15.673101
    },
    {
        town: "\u017Deletice",
        townCode: 586811,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69637,
        lat: 49.014333,
        long: 17.008221
    },
    {
        town: "\u017Deletice",
        townCode: 595179,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67134,
        lat: 48.936428,
        long: 16.182913
    },
    {
        town: "\u017Delezn\xe1",
        townCode: 599417,
        district: 'Beroun',
        lau: 'CZ0202',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26601,
        lat: 50.009803,
        long: 14.091043
    },
    {
        town: "\u017Delezn\xe1 Ruda",
        townCode: 557528,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34004,
        lat: 49.137543,
        long: 13.235305
    },
    {
        town: "\u017Delezn\xe9",
        townCode: 584274,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66601,
        lat: 49.359718,
        long: 16.45055
    },
    {
        town: "\u017Deleznice",
        townCode: 573825,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50713,
        lat: 50.472837,
        long: 15.384697
    },
    {
        town: "\u017Delezn\xfd Brod",
        townCode: 563871,
        district: 'Jablonec nad Nisou',
        lau: 'CZ0512',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 46822,
        lat: 50.64284,
        long: 15.254186
    },
    {
        town: "\u017Deliv",
        townCode: 549215,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39444,
        lat: 49.529938,
        long: 15.221912
    },
    {
        town: "\u017Delivsko",
        townCode: 572195,
        district: 'Svitavy',
        lau: 'CZ0533',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56904,
        lat: 49.641253,
        long: 16.570083
    },
    {
        town: "\u017Del\xedzy",
        townCode: 535397,
        district: "M\u011Bln\xedk",
        lau: 'CZ0206',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27721,
        lat: 50.423837,
        long: 14.464874
    },
    {
        town: "\u017Delkovice",
        townCode: 530565,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.464261,
        long: 13.876828
    },
    {
        town: "\u017Delnava",
        townCode: 550761,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38451,
        lat: 48.812147,
        long: 13.965123
    },
    {
        town: "\u017Denklava",
        townCode: 568732,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74267,
        lat: 49.563672,
        long: 18.107297
    },
    {
        town: "\u017Deranovice",
        townCode: 589233,
        district: "Krom\u011B\u0159\xed\u017E",
        lau: 'CZ0721',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76901,
        lat: 49.291574,
        long: 17.604528
    },
    {
        town: "\u017Deravice",
        townCode: 586820,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69647,
        lat: 49.022984,
        long: 17.23737
    },
    {
        town: "\u017Deraviny",
        townCode: 586838,
        district: "Hodon\xedn",
        lau: 'CZ0645',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 69663,
        lat: 48.908328,
        long: 17.391624
    },
    {
        town: "\u017Der\u010Dice",
        townCode: 536989,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29446,
        lat: 50.374263,
        long: 15.036019
    },
    {
        town: "\u017Deretice",
        townCode: 573833,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50702,
        lat: 50.353646,
        long: 15.411844
    },
    {
        town: "\u017Dermanice",
        townCode: 568163,
        district: "Fr\xfddek-M\xedstek",
        lau: 'CZ0802',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 73937,
        lat: 49.738583,
        long: 18.442932
    },
    {
        town: "\u017Dernov",
        townCode: 574708,
        district: "N\xe1chod",
        lau: 'CZ0523',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 55203,
        lat: 50.430501,
        long: 16.05755
    },
    {
        town: "\u017Dernov",
        townCode: 577723,
        district: 'Semily',
        lau: 'CZ0514',
        region: "Libereck\xfd kraj",
        nuts: 'CZ051',
        zip: 51263,
        lat: 50.556845,
        long: 15.26975
    },
    {
        town: "\u017Dernovice",
        townCode: 537209,
        district: 'Prachatice',
        lau: 'CZ0315',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 38301,
        lat: 49.028655,
        long: 14.039648
    },
    {
        town: "\u017Dernovn\xedk",
        townCode: 582760,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67921,
        lat: 49.407034,
        long: 16.545573
    },
    {
        town: "\u017Derotice",
        townCode: 595187,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67134,
        lat: 48.92681,
        long: 16.168847
    },
    {
        town: "\u017Derot\xedn",
        townCode: 505862,
        district: 'Olomouc',
        lau: 'CZ0712',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 78401,
        lat: 49.724632,
        long: 17.186914
    },
    {
        town: "\u017Derot\xedn",
        townCode: 543012,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 44001,
        lat: 50.286331,
        long: 13.912212
    },
    {
        town: "\u017Der\u016Ftky",
        townCode: 582778,
        district: 'Blansko',
        lau: 'CZ0641',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67971,
        lat: 49.440351,
        long: 16.536844
    },
    {
        town: "\u017Der\u016Ftky",
        townCode: 595195,
        district: 'Znojmo',
        lau: 'CZ0647',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 67151,
        lat: 48.906004,
        long: 15.963194
    },
    {
        town: "\u017Didlochovice",
        townCode: 584282,
        district: 'Brno-venkov',
        lau: 'CZ0643',
        region: "Jihomoravsk\xfd kraj",
        nuts: 'CZ064',
        zip: 66701,
        lat: 49.039624,
        long: 16.618911
    },
    {
        town: "\u017Didn\u011Bves",
        townCode: 536997,
        district: "Mlad\xe1 Boleslav",
        lau: 'CZ0207',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 29406,
        lat: 50.41173,
        long: 14.994635
    },
    {
        town: "\u017Didovice",
        townCode: 573841,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50732,
        lat: 50.295469,
        long: 15.32061
    },
    {
        town: "\u017Didovice",
        townCode: 565954,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41183,
        lat: 50.446388,
        long: 14.233166
    },
    {
        town: "\u017Dihle",
        townCode: 559695,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33165,
        lat: 50.04502,
        long: 13.37513
    },
    {
        town: "\u017Dihobce",
        townCode: 557536,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.215645,
        long: 13.631095
    },
    {
        town: "\u017Dichl\xednek",
        townCode: 581275,
        district: "\xdast\xed nad Orlic\xed",
        lau: 'CZ0534',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 56301,
        lat: 49.884005,
        long: 16.636393
    },
    {
        town: "\u017Dichovice",
        townCode: 557544,
        district: 'Klatovy',
        lau: 'CZ0322',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 34201,
        lat: 49.267334,
        long: 13.627949
    },
    {
        town: "\u017Dilina",
        townCode: 533149,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27301,
        lat: 50.099975,
        long: 14.005859
    },
    {
        town: "\u017Dilov",
        townCode: 559709,
        district: "Plze\u0148-sever",
        lau: 'CZ0325',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33011,
        lat: 49.840106,
        long: 13.313289
    },
    {
        town: "\u017Dim",
        townCode: 567884,
        district: 'Teplice',
        lau: 'CZ0426',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41501,
        lat: 50.585066,
        long: 13.965364
    },
    {
        town: "\u017Dimutice",
        townCode: 545384,
        district: "\u010Cesk\xe9 Bud\u011Bjovice",
        lau: 'CZ0311',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37366,
        lat: 49.20382,
        long: 14.510527
    },
    {
        town: "\u017Dinkovy",
        townCode: 558630,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33554,
        lat: 49.483512,
        long: 13.489551
    },
    {
        town: "\u017Dirov",
        townCode: 561908,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39301,
        lat: 49.464349,
        long: 15.323704
    },
    {
        town: "\u017Dirovnice",
        townCode: 549231,
        district: "Pelh\u0159imov",
        lau: 'CZ0633',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 39468,
        lat: 49.253284,
        long: 15.18834
    },
    {
        town: "\u017D\xed\u0161ov",
        townCode: 563897,
        district: "T\xe1bor",
        lau: 'CZ0317',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 39181,
        lat: 49.200048,
        long: 14.69348
    },
    {
        town: "\u017Ditenice",
        townCode: 565962,
        district: "Litom\u011B\u0159ice",
        lau: 'CZ0423',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 41141,
        lat: 50.555387,
        long: 14.156757
    },
    {
        town: "\u017D\xedtkov\xe1",
        townCode: 592871,
        district: "Uhersk\xe9 Hradi\u0161t\u011B",
        lau: 'CZ0722',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 68774,
        lat: 48.980354,
        long: 17.880344
    },
    {
        town: "\u017Ditovlice",
        townCode: 503410,
        district: 'Nymburk',
        lau: 'CZ0208',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28934,
        lat: 50.294076,
        long: 15.137094
    },
    {
        town: "\u017Divanice",
        townCode: 576051,
        district: 'Pardubice',
        lau: 'CZ0532',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53342,
        lat: 50.062251,
        long: 15.644886
    },
    {
        town: "\u017Divotice",
        townCode: 540137,
        district: "Plze\u0148-jih",
        lau: 'CZ0324',
        region: "Plze\u0148sk\xfd kraj",
        nuts: 'CZ032',
        zip: 33544,
        lat: 49.466586,
        long: 13.685301
    },
    {
        town: "\u017Divotice u Nov\xe9ho Ji\u010D\xedna",
        townCode: 547000,
        district: "Nov\xfd Ji\u010D\xedn",
        lau: 'CZ0804',
        region: "Moravskoslezsk\xfd kraj",
        nuts: 'CZ080',
        zip: 74272,
        lat: 49.557223,
        long: 18.047353
    },
    {
        town: "\u017Di\u017Eelice",
        townCode: 533947,
        district: "Kol\xedn",
        lau: 'CZ0204',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28129,
        lat: 50.132019,
        long: 15.393302
    },
    {
        town: "\u017Di\u017Eelice",
        townCode: 567019,
        district: 'Louny',
        lau: 'CZ0424',
        region: "\xdasteck\xfd kraj",
        nuts: 'CZ042',
        zip: 43801,
        lat: 50.367513,
        long: 13.540101
    },
    {
        town: "\u017Di\u017Eice",
        townCode: 533157,
        district: 'Kladno',
        lau: 'CZ0203',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 27401,
        lat: 50.246382,
        long: 14.154001
    },
    {
        town: "\u017Di\u017Ekovo Pole",
        townCode: 569801,
        district: "Havl\xed\u010Dk\u016Fv Brod",
        lau: 'CZ0631',
        region: "Kraj Vyso\u010Dina",
        nuts: 'CZ063',
        zip: 58222,
        lat: 49.610734,
        long: 15.735236
    },
    {
        town: "\u017Dlebsk\xe9 Chvalovice",
        townCode: 574091,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53843,
        lat: 49.892807,
        long: 15.566816
    },
    {
        town: "\u017Dleby",
        townCode: 534668,
        district: "Kutn\xe1 Hora",
        lau: 'CZ0205',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 28561,
        lat: 49.889685,
        long: 15.488634
    },
    {
        town: "\u017Dlunice",
        townCode: 573850,
        district: "Ji\u010D\xedn",
        lau: 'CZ0522',
        region: "Kr\xe1lov\xe9hradeck\xfd kraj",
        nuts: 'CZ052',
        zip: 50734,
        lat: 50.30222,
        long: 15.382081
    },
    {
        town: "\u017Dlutava",
        townCode: 586013,
        district: "Zl\xedn",
        lau: 'CZ0724',
        region: "Zl\xednsk\xfd kraj",
        nuts: 'CZ072',
        zip: 76361,
        lat: 49.199857,
        long: 17.49048
    },
    {
        town: "\u017Dlutice",
        townCode: 555762,
        district: 'Karlovy Vary',
        lau: 'CZ0412',
        region: "Karlovarsk\xfd kraj",
        nuts: 'CZ041',
        zip: 36452,
        lat: 50.092028,
        long: 13.163084
    },
    {
        town: "\u017Dulov\xe1",
        townCode: 541575,
        district: "Jesen\xedk",
        lau: 'CZ0711',
        region: "Olomouck\xfd kraj",
        nuts: 'CZ071',
        zip: 79065,
        lat: 50.30943,
        long: 17.098814
    },
    {
        town: "\u017Dumberk",
        townCode: 572641,
        district: 'Chrudim',
        lau: 'CZ0531',
        region: "Pardubick\xfd kraj",
        nuts: 'CZ053',
        zip: 53836,
        lat: 49.873077,
        long: 15.858205
    },
    {
        town: "\u017Dupanovice",
        townCode: 562424,
        district: "Jind\u0159ich\u016Fv Hradec",
        lau: 'CZ0313',
        region: "Jiho\u010Desk\xfd kraj",
        nuts: 'CZ031',
        zip: 37881,
        lat: 48.957211,
        long: 15.506224
    },
    {
        town: "\u017Dupanovice",
        townCode: 564338,
        district: "P\u0159\xedbram",
        lau: 'CZ020B',
        region: "St\u0159edo\u010Desk\xfd kraj",
        nuts: 'CZ020',
        zip: 26301,
        lat: 49.707893,
        long: 14.298816
    }
];



var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");
const $56aaa28274e34a03$var$defaultValue = (0, $8e51f8b03c60a8d4$export$1a72dabd82538ea2).slice(0, 10);
const $56aaa28274e34a03$export$f185eee3bbd34116 = ()=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const townCode = (0, $2lSXC.useSelector)((s)=>s.variables.TOWN_CODE);
    const [inputValue, setInputValue] = (0, $acw62.useState)('');
    const [options, setOptions] = (0, $acw62.useState)($56aaa28274e34a03$var$defaultValue);
    const value = (0, $acw62.useMemo)(()=>{
        return (0, $8e51f8b03c60a8d4$export$1a72dabd82538ea2).find((option)=>option.townCode === townCode);
    }, [
        townCode
    ]);
    (0, $acw62.useEffect)(()=>{
        if (inputValue.length < 3) setOptions($56aaa28274e34a03$var$defaultValue);
        const searchedOptions = (0, $8e51f8b03c60a8d4$export$1a72dabd82538ea2).filter((option)=>{
            return option.town.toLowerCase().includes(inputValue.toLowerCase());
        }).slice(0, 50);
        setOptions(searchedOptions);
    }, [
        inputValue
    ]);
    const opts = (0, $acw62.useMemo)(()=>{
        const valueIsInOptions = options.some((option)=>option.townCode === townCode);
        if (value && !valueIsInOptions) return [
            value,
            ...options
        ];
        return options;
    }, [
        value,
        options
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iQxou.default), {
        value: value,
        sx: {
            width: 300
        },
        options: opts,
        autoHighlight: true,
        getOptionLabel: (option)=>$56aaa28274e34a03$var$getOptionLabel(option),
        filterOptions: (x)=>x,
        isOptionEqualToValue: (option, value)=>option.townCode === value.townCode,
        renderOption: (props, option)=>{
            const { key: key, ...optionProps } = props;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                component: "li",
                ...optionProps,
                children: $56aaa28274e34a03$var$getOptionLabel(option)
            }, key);
        },
        onInputChange: (event, newInputValue)=>{
            setInputValue(newInputValue);
        },
        renderInput: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                ...params,
                label: "Obec",
                size: "small"
            }),
        onChange: (_, value)=>{
            if (value) dispatch((0, $1Jwr0.variablesChange)({
                TOWN_CODE: value.townCode
            }));
        }
    });
};
function $56aaa28274e34a03$var$getOptionLabel({ town: town, district: district }) {
    return `${town}${town !== district ? ` (okr. ${district})` : ''}`;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $2lSXC = parcelRequire("2lSXC");
const $4878ff3657a4956a$export$e83ffb78b976f69f = ()=>{
    const version = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.VERSION);
    if (!version) return null;
    if (!('date' in version)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.service.version",
            defaultMessage: "Verze aplikace"
        }),
        value: version.date.replace('T', ' ').replace('Z', ''),
        type: "row"
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $7pTac = parcelRequire("7pTac");

var $9iEAl = parcelRequire("9iEAl");



var $gpaJb = parcelRequire("gpaJb");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");
const $1fa014be3c1aec92$export$74ac188a60a539d9 = ({ index: index, morePlugsEnabled: morePlugsEnabled, thermostatInstall: thermostatInstall })=>{
    const spPricePeriod = (0, $2lSXC.useSelector)((s)=>s.variables.SP_PRICE_PERIOD);
    const relayControlTypeOptions = {
        [(0, $8ni7a.RelayControl).None]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.none",
                defaultMessage: "Nen\xed pou\u017Eito, trvale rozepnuto"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Active]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.Active",
                defaultMessage: "Trvale sepnuto"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Plug1]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.plug1",
                defaultMessage: "Z\xe1suvka 1"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Plug2]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.plug2",
                defaultMessage: "Z\xe1suvka 2"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Plug3]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.plug3",
                defaultMessage: "Z\xe1suvka 3"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Plug4]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.plug4",
                defaultMessage: "Z\xe1suvka 4"
            }),
            visible: morePlugsEnabled
        },
        [(0, $8ni7a.RelayControl).SpotHi]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotHi",
                defaultMessage: "Vysok\xe1 cena spotu (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotHi15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotHi15M",
                defaultMessage: "Vysok\xe1 cena spotu (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotMi]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotMi",
                defaultMessage: "St\u0159edn\xed cena spotu (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotMi15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotMi15M",
                defaultMessage: "St\u0159edn\xed cena spotu (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotLow]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotLow",
                defaultMessage: "N\xedzk\xe1 cena spotu (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotLow15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotLow15M",
                defaultMessage: "N\xedzk\xe1 cena spotu (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotNegative]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotNegative",
                defaultMessage: "Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotNegative15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotNegative15M",
                defaultMessage: "Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotPriceBelow]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotPriceBelow",
                defaultMessage: "Cena spotu pod nastavenou hodnotu (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotPriceBelow15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotPriceBelow15M",
                defaultMessage: "Cena spotu pod nastavenou hodnotu (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotPriceAbove]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotPriceAbove",
                defaultMessage: "Cena spotu nad nastavenou hodnotu (60 min)"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotPriceAbove15M]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotPriceAbove15M",
                defaultMessage: "Cena spotu nad nastavenou hodnotu (15 min)"
            }),
            visible: spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']
        },
        [(0, $8ni7a.RelayControl).SpotBatteryDischarge]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotBatteryDischarge",
                defaultMessage: "Vyb\xedjen\xed baterie do s\xedt\u011B"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).SpotStopAccumulation]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.spotStopAccumulation",
                defaultMessage: "Akumulace zastavena, aktivn\xed prodej"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).HDO]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.hdo",
                defaultMessage: "Zrcadlit HDO"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).BatteryLow]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.batteryLow",
                defaultMessage: "Nabit\xed baterie pod nastaven\xe9 minimum"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).BatteryBelowSOC]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.batteryBelowSOC",
                defaultMessage: "Nabit\xed baterie pod nastaven\xe9 SOC"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).BatteryFull]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.batteryFull",
                defaultMessage: "Nabit\xed baterie nad nastaven\xe9 SOC"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).HeatWaterMaxTemp]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.heatWaterMaxTemp",
                defaultMessage: "Bojler je t\xe9m\u011B\u0159 natopen\xfd"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).HeatWaterBelowTemp]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.heatWaterBelowTemp",
                defaultMessage: "Bojler je natopen\xfd pod nastavenou teplotu"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).HeatWaterAboveTemp]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.heatWaterTemp",
                defaultMessage: "Bojler je natopen\xfd nad nastavenou teplotu"
            }),
            visible: true
        },
        [(0, $8ni7a.RelayControl).Thermostat1]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.thermostat1",
                defaultMessage: "Termostat 1"
            }),
            visible: thermostatInstall
        },
        [(0, $8ni7a.RelayControl).Thermostat2]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.thermostat2",
                defaultMessage: "Termostat 2"
            }),
            visible: thermostatInstall
        },
        [(0, $8ni7a.RelayControl).Thermostat3]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.thermostat3",
                defaultMessage: "Termostat 3"
            }),
            visible: thermostatInstall
        },
        [(0, $8ni7a.RelayControl).Thermostat4]: {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.relay.type.thermostat4",
                defaultMessage: "Termostat 4"
            }),
            visible: thermostatInstall
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.relay.option",
            defaultMessage: "Podm\xednka"
        }),
        visibility: {
            variableId: `RELAY_ENABLED[${index}]`
        },
        selectVariableId: `RELAY_CONTROL_TYPE[0][${index}]`,
        options: Object.entries(relayControlTypeOptions).filter(([, controlType])=>controlType.visible).map(([value, controlType])=>({
                label: controlType.label,
                value: value
            })),
        fullWidth: true
    });
};
const $1fa014be3c1aec92$export$bd9aa579047d2095 = {
    [(0, $8ni7a.RelayControl).None]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.none",
        defaultMessage: "Nen\xed pou\u017Eito, trvale rozepnuto"
    }),
    [(0, $8ni7a.RelayControl).Active]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.Active",
        defaultMessage: "Trvale sepnuto"
    }),
    [(0, $8ni7a.RelayControl).Plug1]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.plug1",
        defaultMessage: "Z\xe1suvka 1"
    }),
    [(0, $8ni7a.RelayControl).Plug2]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.plug2",
        defaultMessage: "Z\xe1suvka 2"
    }),
    [(0, $8ni7a.RelayControl).Plug3]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.plug3",
        defaultMessage: "Z\xe1suvka 3"
    }),
    [(0, $8ni7a.RelayControl).Plug4]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.plug4",
        defaultMessage: "Z\xe1suvka 4"
    }),
    [(0, $8ni7a.RelayControl).SpotHi]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotHi",
        defaultMessage: "Vysok\xe1 cena spotu (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotMi]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotMi",
        defaultMessage: "St\u0159edn\xed cena spotu (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotLow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotLow",
        defaultMessage: "N\xedzk\xe1 cena spotu (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotNegative]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotNegative",
        defaultMessage: "Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotPriceBelow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotPriceBelow",
        defaultMessage: "Cena spotu pod nastavenou hodnotu (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotPriceAbove]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotPriceAbove",
        defaultMessage: "Cena spotu nad nastavenou hodnotu (60 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotHi15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotHi15M",
        defaultMessage: "Vysok\xe1 cena spotu (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotMi15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotMi15M",
        defaultMessage: "St\u0159edn\xed cena spotu (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotLow15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotLow15M",
        defaultMessage: "N\xedzk\xe1 cena spotu (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotNegative15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotNegative15M",
        defaultMessage: "Z\xe1kaz p\u0159etok\u016F do s\xedt\u011B (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotPriceBelow15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotPriceBelow15M",
        defaultMessage: "Cena spotu pod nastavenou hodnotu (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotPriceAbove15M]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.spotPriceAbove15M",
        defaultMessage: "Cena spotu nad nastavenou hodnotu (15 min)"
    }),
    [(0, $8ni7a.RelayControl).SpotBatteryDischarge]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.batteryDischarge",
        defaultMessage: "Vyb\xedjen\xed baterie do s\xedt\u011B"
    }),
    [(0, $8ni7a.RelayControl).SpotStopAccumulation]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.stopAccumulation",
        defaultMessage: "Akumulace zastavena, aktivn\xed prodej"
    }),
    [(0, $8ni7a.RelayControl).HDO]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.HDO",
        defaultMessage: "Zrcadlit HDO"
    }),
    [(0, $8ni7a.RelayControl).BatteryLow]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.batteryLow",
        defaultMessage: "Nabit\xed baterie pod nastaven\xe9 minimum"
    }),
    [(0, $8ni7a.RelayControl).BatteryBelowSOC]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.batteryBelowSOC",
        defaultMessage: "Nabit\xed baterie pod nastaven\xe9 SOC"
    }),
    [(0, $8ni7a.RelayControl).BatteryFull]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.batteryFull",
        defaultMessage: "Nabit\xed baterie nad nastaven\xe9 SOC"
    }),
    [(0, $8ni7a.RelayControl).HeatWaterMaxTemp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.bojlerFull",
        defaultMessage: "Bojler je t\xe9m\u011B\u0159 natopen\xfd"
    }),
    [(0, $8ni7a.RelayControl).HeatWaterBelowTemp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.heatWaterBelowTemp",
        defaultMessage: "Bojler je natopen\xfd pod nastavenou teplotu"
    }),
    [(0, $8ni7a.RelayControl).HeatWaterAboveTemp]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.heatWaterAboveTemp",
        defaultMessage: "Bojler je natopen\xfd nad nastavenou teplotu"
    }),
    [(0, $8ni7a.RelayControl).Thermostat1]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.thermostat1",
        defaultMessage: "Termostat 1"
    }),
    [(0, $8ni7a.RelayControl).Thermostat2]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.thermostat2",
        defaultMessage: "Termostat 2"
    }),
    [(0, $8ni7a.RelayControl).Thermostat3]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.thermostat3",
        defaultMessage: "Termostat 3"
    }),
    [(0, $8ni7a.RelayControl).Thermostat4]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "settings.relay.type.thermostat4",
        defaultMessage: "Termostat 4"
    })
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $7pTac = parcelRequire("7pTac");

const $0cc9676de911bc57$export$bf42bece27e30ff1 = ({ index: index })=>{
    const relayControlType = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, `RELAY_CONTROL_TYPE[0][${index}]`));
    const heatWaterAboveTemp = relayControlType === (0, $8ni7a.RelayControl).HeatWaterAboveTemp;
    const heatWaterBelowTemp = relayControlType === (0, $8ni7a.RelayControl).HeatWaterBelowTemp;
    const batteryAboveSOC = relayControlType === (0, $8ni7a.RelayControl).BatteryFull;
    const batteryBelowSOC = relayControlType === (0, $8ni7a.RelayControl).BatteryBelowSOC;
    const spotPriceAbove = relayControlType === (0, $8ni7a.RelayControl).SpotPriceAbove;
    const spotPriceBelow = relayControlType === (0, $8ni7a.RelayControl).SpotPriceBelow;
    const spotPriceAbove15M = relayControlType === (0, $8ni7a.RelayControl).SpotPriceAbove15M;
    const spotPriceBelow15M = relayControlType === (0, $8ni7a.RelayControl).SpotPriceBelow15M;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            heatWaterAboveTemp && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_relay",
                            defaultMessage: "Teplota bojleru pro sepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_above_relay.subtitle",
                            defaultMessage: "P\u0159i teplot\u011B bojleru nad tuto hodnotu dojde k sepnut\xed rel\xe9"
                        }),
                        variableId: `HW_ABOVE_TEMP_RELAY[${index}]`,
                        max: 85,
                        opts: {
                            style: 'unit',
                            unit: 'celsius',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_relay_hyst",
                            defaultMessage: "Hystereze bojleru pro rozepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_above_relay_hyst.subtitle",
                            defaultMessage: "Pokud se teplota bojleru sn\xed\u017E\xed o tuto hodnotu pod nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9"
                        }),
                        variableId: `HW_ABOVE_TEMP_RELAY_HYST[${index}]`,
                        max: 10,
                        opts: {
                            style: 'unit',
                            unit: 'celsius',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    })
                ]
            }),
            heatWaterBelowTemp && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_relay",
                            defaultMessage: "Teplota bojleru pro sepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_below_relay.subtitle",
                            defaultMessage: "P\u0159i teplot\u011B bojleru pod tuto hodnotu dojde k sepnut\xed rel\xe9"
                        }),
                        variableId: `HW_BELOW_TEMP_RELAY[${index}]`,
                        max: 85,
                        opts: {
                            style: 'unit',
                            unit: 'celsius',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_below_relay_hyst",
                            defaultMessage: "Hystereze bojleru pro rozepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.temp_below_relay_hyst.subtitle",
                            defaultMessage: "Pokud se teplota bojleru zv\xfd\u0161\xed o tuto hodnotu nad nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9"
                        }),
                        variableId: `HW_BELOW_TEMP_RELAY_HYST[${index}]`,
                        max: 10,
                        opts: {
                            style: 'unit',
                            unit: 'celsius',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    })
                ]
            }),
            batteryAboveSOC && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.above_soc_relay",
                            defaultMessage: "Nabit\xed baterie pro sepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.above_soc_relay.subtitle",
                            defaultMessage: "P\u0159i nabit\xed baterie nad tuto hodnotu dojde k sepnut\xed rel\xe9"
                        }),
                        variableId: `BAT_ABOVE_SOC_RELAY[${index}]`,
                        max: 100,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.above_soc_relay_hyst",
                            defaultMessage: "Hystereze baterie pro rozepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.above_soc_relay_hyst.subtitle",
                            defaultMessage: "Pokud se nabit\xed baterie sn\xed\u017E\xed o tuto hodnotu pod nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9"
                        }),
                        variableId: `BAT_ABOVE_SOC_RELAY_HYST[${index}]`,
                        max: 60,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    })
                ]
            }),
            batteryBelowSOC && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.below_soc_relay",
                            defaultMessage: "Nabit\xed baterie pro sepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.below_soc_relay.subtitle",
                            defaultMessage: "P\u0159i poklesu nabit\xed baterie pod tuto hodnotu dojde k sepnut\xed rel\xe9"
                        }),
                        variableId: `BAT_BELOW_SOC_RELAY[${index}]`,
                        max: 100,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.below_soc_relay_hyst",
                            defaultMessage: "Hystereze baterie pro rozepnut\xed rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.relay.below_soc_relay_hyst.subtitle",
                            defaultMessage: "Pokud se nabit\xed baterie zv\xfd\u0161\xed o tuto hodnotu nad nastavenou pro sepnut\xed, dojde k rozepnut\xed rel\xe9"
                        }),
                        variableId: `BAT_BELOW_SOC_RELAY_HYST[${index}]`,
                        max: 60,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        },
                        visibility: {
                            variableId: `RELAY_ENABLED[${index}]`
                        }
                    })
                ]
            }),
            spotPriceAbove && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.above_price_relay",
                        defaultMessage: "Cena spotu pro sepnut\xed rel\xe9"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.above_price_relay.subtitle",
                        defaultMessage: "P\u0159i cene spotu nad tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena ni\u017E\u0161\xed, dojde k rozepnut\xed rel\xe9."
                    }),
                    variableId: `SPOT_PRICE_ABOVE_RELAY[${index}]`,
                    max: {
                        CZK: 10,
                        EUR: 0.5
                    },
                    min: {
                        CZK: -10,
                        EUR: -0.5
                    },
                    opts: {
                        style: 'currency'
                    },
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    }
                })
            }),
            spotPriceBelow && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.below_price_relay",
                        defaultMessage: "Cena spotu pro sepnut\xed rel\xe9"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.below_price_relay.subtitle",
                        defaultMessage: "P\u0159i cene spotu pod tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena vy\u0161\u0161\xed, dojde k rozepnut\xed rel\xe9."
                    }),
                    variableId: `SPOT_PRICE_BELOW_RELAY[${index}]`,
                    max: {
                        CZK: 10,
                        EUR: 0.5
                    },
                    min: {
                        CZK: -10,
                        EUR: -0.5
                    },
                    opts: {
                        style: 'currency'
                    },
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    }
                })
            }),
            spotPriceAbove15M && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.above_price_relay_15m",
                        defaultMessage: "Cena spotu pro sepnut\xed rel\xe9 (15 min)"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.above_price_relay_15m.subtitle",
                        defaultMessage: "P\u0159i cene spotu nad tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena ni\u017E\u0161\xed, dojde k rozepnut\xed rel\xe9."
                    }),
                    variableId: `SPOT_PRICE_ABOVE_RELAY_15MIN[${index}]`,
                    max: {
                        CZK: 10,
                        EUR: 0.5
                    },
                    min: {
                        CZK: -10,
                        EUR: -0.5
                    },
                    opts: {
                        style: 'currency'
                    },
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    }
                })
            }),
            spotPriceBelow15M && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.below_price_relay_15m",
                        defaultMessage: "Cena spotu pro sepnut\xed rel\xe9 (15 min)"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.below_price_relay_15m.subtitle",
                        defaultMessage: "P\u0159i cene spotu pod tuto hodnotu dojde k sepnut\xed rel\xe9. Pokud je cena vy\u0161\u0161\xed, dojde k rozepnut\xed rel\xe9."
                    }),
                    variableId: `SPOT_PRICE_BELOW_RELAY_15MIN[${index}]`,
                    max: {
                        CZK: 10,
                        EUR: 0.5
                    },
                    min: {
                        CZK: -10,
                        EUR: -0.5
                    },
                    opts: {
                        style: 'currency'
                    },
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    }
                })
            })
        ]
    });
};


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");
const $8077a1edfb90f10e$export$f5799ab29b788af0 = ()=>{
    const relayInstall = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'RELAY_INSTALL'));
    const board = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'BOARD'));
    const numberOfRelays = board === (0, $8ni7a.Board).SunBerry ? 1 : 4;
    if (!relayInstall) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: Array(numberOfRelays).fill(null).map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)($8077a1edfb90f10e$export$97fbc30f39b9ec6d, {
                index: index
            }, index))
    });
};
const $8077a1edfb90f10e$export$97fbc30f39b9ec6d = ({ index: index })=>{
    const morePlugsEnabled = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'PL_MORE_PLUGS_NUMBER') > 3);
    const thermostatInstall = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'THERMOSTAT_INSTALL'));
    const relayOutputs = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'RELAY_OUTPUT', []));
    const relayIsActive = relayOutputs.map((status, index)=>({
            id: index,
            isActive: status
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.item.enabled",
                        defaultMessage: "Rel\xe9 {index}",
                        values: {
                            index: index + 1
                        }
                    }),
                    switchVariableId: `RELAY_ENABLED[${index}]`,
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.item.name",
                        defaultMessage: "Pojmenov\xe1n\xed rel\xe9"
                    }),
                    inputVariableId: `RELAY_NAME[${index}]`,
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    },
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.relay.item.status",
                        defaultMessage: "Sepnuto"
                    }),
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                        alive: relayIsActive[index].isActive
                    }),
                    fullWidth: true,
                    visibility: {
                        variableId: `RELAY_ENABLED[${index}]`
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fa014be3c1aec92$export$74ac188a60a539d9), {
                    index: index,
                    morePlugsEnabled: morePlugsEnabled,
                    thermostatInstall: thermostatInstall
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cc9676de911bc57$export$bf42bece27e30ff1), {
                    index: index
                })
            ]
        })
    }, index);
};



var $aZOrF = parcelRequire("aZOrF");



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $ngrp2 = parcelRequire("ngrp2");

var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");

var $9iEAl = parcelRequire("9iEAl");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $1sDFO = parcelRequire("1sDFO");
var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");

var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $bJgPp = parcelRequire("bJgPp");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

var $8ni7a = parcelRequire("8ni7a");
const $152494ae8dd9615b$export$562e7711c6408d3 = ({ value: value, onChange: onChange, includeNibe: includeNibe })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                id: "heat-pump-type-label",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatpump.hp_type",
                    defaultMessage: "Typ tepeln\xe9ho \u010Derpadla"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                value: value,
                onChange: (e)=>onChange(e.target.value),
                labelId: "heat-pump-type-label",
                size: "medium",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatpump.hp_type",
                    defaultMessage: "Typ tepeln\xe9ho \u010Derpadla"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.HeatPump).Ecoone,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.ecoone",
                            defaultMessage: "Ecoone"
                        })
                    }, (0, $8ni7a.HeatPump).Ecoone),
                    includeNibe && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.HeatPump).Nibe,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.nibe",
                            defaultMessage: "Nibe"
                        })
                    }, (0, $8ni7a.HeatPump).Nibe),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                        value: (0, $8ni7a.HeatPump).Acond,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.acond",
                            defaultMessage: "Acond"
                        })
                    }, (0, $8ni7a.HeatPump).Acond)
                ]
            })
        ]
    });
};


const $42725ccc42178237$var$defaultHeatPumpIpAddress = '100.100.1.10';
const $42725ccc42178237$export$831f2a5d0126e903 = ({ open: open, onClose: onClose })=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const heatPumpTypeFromStore = (0, $2lSXC.useSelector)((s)=>s.variables.HP_TYPE);
    const heatPumpIpFromStore = (0, $2lSXC.useSelector)((s)=>s.variables.HP_ECOONE_API_IP);
    const showIpAddress = (0, $2lSXC.useSelector)((s)=>s.variables.BOARD === (0, $8ni7a.Board).Play || s.variables.BOARD === (0, $8ni7a.Board).SunBerry);
    const includeNibe = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'OEM_DISTRIBUTION') === (0, $8ni7a.OemDistribution).DZD);
    const [heatPumpType, setHeatPumpType] = (0, $acw62.useState)((0, $8ni7a.HeatPump).Ecoone);
    const [heatPumpIpAddress, setHeatPumpIpAddress] = (0, $acw62.useState)($42725ccc42178237$var$defaultHeatPumpIpAddress);
    const [submitError, setSubmitError] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        if (open) {
            setSubmitError(undefined);
            setHeatPumpType(heatPumpTypeFromStore ?? (0, $8ni7a.HeatPump).Ecoone);
            setHeatPumpIpAddress(heatPumpIpFromStore || $42725ccc42178237$var$defaultHeatPumpIpAddress);
        }
    }, [
        open,
        heatPumpTypeFromStore,
        heatPumpIpFromStore
    ]);
    const handleSubmit = ()=>{
        if (showIpAddress && !heatPumpIpAddress.trim()) {
            setSubmitError("IP adresa je povinn\xe1");
            return;
        }
        const changes = {
            HP_TYPE: heatPumpType
        };
        if (showIpAddress) changes.HP_ECOONE_API_IP = heatPumpIpAddress;
        dispatch((0, $1Jwr0.variablesChange)(changes));
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump_wizard.title",
                    defaultMessage: "Nastaven\xed tepeln\xe9ho \u010Derpadla"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    gap: 2.5,
                    sx: {
                        py: 2
                    },
                    children: [
                        submitError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                            severity: "error",
                            children: submitError
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $152494ae8dd9615b$export$562e7711c6408d3), {
                            value: heatPumpType,
                            onChange: setHeatPumpType,
                            includeNibe: includeNibe
                        }),
                        showIpAddress && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "heat_pump_wizard.ip_address.input",
                                        defaultMessage: "IP adresa tepeln\xe9ho \u010Derpadla"
                                    }),
                                    value: heatPumpIpAddress,
                                    onChange: (e)=>setHeatPumpIpAddress(e.target.value),
                                    fullWidth: true,
                                    required: true,
                                    error: showIpAddress && !heatPumpIpAddress.trim()
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1sDFO.default), {
                                    icon: false,
                                    color: "warning",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "heat_pump_wizard.ip_address.alert",
                                        defaultMessage: "Ujist\u011Bte se pros\xedm, \u017Ee se IP adresa tepeln\xe9ho \u010Derpadla nebude m\u011Bnit (nap\u0159. kdy\u017E T\u010C vyu\u017E\xedv\xe1 adresu z DHCP)."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump_wizard.cancel",
                            defaultMessage: "Zru\u0161it"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        onClick: handleSubmit,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump_wizard.save",
                            defaultMessage: "Ulo\u017Eit"
                        })
                    })
                ]
            })
        ]
    });
};


const $ee8ad514925a8918$export$562e7711c6408d3 = ()=>{
    const [wizardOpen, setWizardOpen] = (0, $acw62.useState)(false);
    const wizardHeatPumpInfo = $ee8ad514925a8918$var$useWizardHeatPumpInfo();
    const wizardBox = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 0.75,
        children: [
            wizardHeatPumpInfo,
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                variant: "outlined",
                size: "small",
                onClick: ()=>setWizardOpen(true),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump_wizard.open",
                    defaultMessage: "Nastavit typ T\u010C"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                control: wizardBox,
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatpump.hp_type",
                    defaultMessage: "Typ tepeln\xe9ho \u010Derpadla"
                }),
                visibility: {
                    variableId: 'HP_ENABLED'
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42725ccc42178237$export$831f2a5d0126e903), {
                open: wizardOpen,
                onClose: ()=>setWizardOpen(false)
            })
        ]
    });
};
const $ee8ad514925a8918$var$useWizardHeatPumpInfo = ()=>{
    const heatPumpType = (0, $2lSXC.useSelector)((s)=>s.variables.HP_TYPE);
    const includeNibe = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'OEM_DISTRIBUTION') === (0, $8ni7a.OemDistribution).DZD);
    const mapped = $ee8ad514925a8918$var$heatPumpMapping(includeNibe)[heatPumpType];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        children: mapped || null
    });
};
const $ee8ad514925a8918$var$heatPumpMapping = (includeNibe)=>({
        [(0, $8ni7a.HeatPump).Ecoone]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "heat_pump.ecoone",
            defaultMessage: "Ecoone"
        }),
        ...includeNibe ? {
            [(0, $8ni7a.HeatPump).Nibe]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "heat_pump.nibe",
                defaultMessage: "Nibe"
            })
        } : {},
        [(0, $8ni7a.HeatPump).Acond]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "heat_pump.acond",
            defaultMessage: "Acond"
        })
    });













const $39c95e32fcc7b0b5$export$1792701c843512d = ()=>{
    const serviceActive = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.SERVICE_ACTIVE);
    const resetErr = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            ERR_RESET: true
        }));
    };
    const dispatch = (0, $2lSXC.useDispatch)();
    const exitService = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            SERVICE_ACTIVE: false,
            SERVICE_PASSWORD: ''
        }));
    };
    const sofarGoodweNext = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SofarSolarRS485 || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).GoodWeNext;
    });
    const ems = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000 || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000PRO;
    });
    const solax = (0, $2lSXC.useSelector)((s)=>{
        const pvInverterType = s.variables.PV_INVERTER_TYPE;
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxNext || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000 || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).SolaxEMS1000PRO || pvInverterType === (0, $8ni7a.Inverter).Solax;
    });
    const fronius = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Fronius || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).FroniusVerto;
    });
    const readonlyInverters = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Hes || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).ThreeMarPLC || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Sermatec;
    });
    const solintegWattsonic = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Solinteg || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Wattsonic;
    });
    const relaySettings = (0, $2lSXC.useSelector)((s)=>((0, $f1q41.get)(s.variables, 'BOARD') === (0, $8ni7a.Board).V2 || (0, $f1q41.get)(s.variables, 'BOARD') === (0, $8ni7a.Board).SunBerry) && ((0, $f1q41.get)(s.variables, 'LICENSE') == 3 || (0, $f1q41.get)(s.variables, 'LICENSE') == 5));
    const networkCaps = (0, $2lSXC.useSelector)((s)=>s.variables.NETWORK_CAPABILITIES);
    const hpNominalFromHp = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'HP_TYPE') == 2 || (0, $f1q41.get)(s.variables, 'HP_TYPE') == 4);
    const unbalancedOutputEnabled = (0, $2lSXC.useSelector)((s)=>s.variables.PV_UNBALANCED_OUTPUT_ENABLED);
    const backupEnabled = (0, $2lSXC.useSelector)((s)=>s.variables.PV_BACKUP_ENABLED);
    const servicePasswordInput = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.service.password",
            defaultMessage: "P\u0159\xedstup do servisu"
        }),
        inputVariableId: "SERVICE_PASSWORD",
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.service.password.label",
            defaultMessage: "Heslo"
        }),
        fullWidth: true
    });
    const content = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.docs",
                    defaultMessage: "N\xe1vody a dal\u0161\xed podklady"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.docs.tech_wiki.title",
                            defaultMessage: "Technick\xe1 wiki"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.docs.tech_wiki.subtitle",
                            defaultMessage: "N\xe1vody, postupy a dal\u0161\xed informace"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "contained",
                            href: "https://infigy.cz/app-redirect/tech-wiki",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.docs.tech_wiki.button",
                                defaultMessage: "P\u0159ej\xedt na wiki"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.utility",
                    defaultMessage: "Parametry domu"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c4cdc7ff1541b41$export$6ebb4e06731ab0d9), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.utility.settings.loadpercent",
                                defaultMessage: "Krizov\xe9 zat\xed\u017Een\xed"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.utility.settings.loadpercent_max",
                                defaultMessage: "P\u0159i p\u0159ekro\u010Den\xed doch\xe1z\xed k omezov\xe1n\xed spot\u0159eby"
                            }),
                            variableId: "EM_LOAD_MAX",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.utility.loadpercent",
                                defaultMessage: "Aktu\xe1ln\xed zat\xed\u017Een\xed jisti\u010De"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "EM_ACTUAL_LOAD_MAX",
                                opts: {
                                    style: 'percent',
                                    maximumFractionDigits: 0
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics",
                    defaultMessage: "Fotovoltaick\xe1 elektr\xe1rna"
                }),
                visibility: {
                    variableId: 'PV_INSTALL_V1'
                },
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.enabled",
                                    defaultMessage: "FVE nainstalov\xe1na"
                                }),
                                switchVariableId: "PV_INSTALL",
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $OLlTf.InverterTypeSelect), {}),
                            !fronius && !readonlyInverters && !ems && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.unbalanced_enabled",
                                    defaultMessage: "Asymetrie st\u0159\xedda\u010De"
                                }),
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                                    alive: unbalancedOutputEnabled
                                }),
                                fullWidth: true,
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.unbalanced_enabled.subtitle",
                                    defaultMessage: "Informace o nastaven\xed re\u017Eimu asymetrie st\u0159\xedda\u010De."
                                })
                            }),
                            !fronius && !readonlyInverters && !solax && !ems && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.backup_enabled",
                                    defaultMessage: "Backup povolen"
                                }),
                                control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                                    alive: backupEnabled
                                }),
                                fullWidth: true,
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.backup_enabled.subtitle",
                                    defaultMessage: "Informace o nastaven\xed re\u017Eimu backup st\u0159\xedda\u010De."
                                })
                            }),
                            solintegWattsonic && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.PV.NominalInverterPower",
                                            defaultMessage: "Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                            variant: "dialog",
                                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.PV.NominalInverterPower",
                                                defaultMessage: "Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De"
                                            }),
                                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "settings.PV.NominalInverterPower.help",
                                                defaultMessage: "Pro Solinteg, Wattsonic a Deye je toto d\u016Fle\u017Eit\xe9 pro spr\xe1vn\xfd v\xfdpo\u010Det p\u0159etok\u016F do s\xedt\u011B."
                                            })
                                        })
                                    ]
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.PV.NominalInverterPower.subtitle",
                                    defaultMessage: "Nomin\xe1ln\xed v\xfdkon st\u0159\xedda\u010De v kW, d\u016Fle\u017Eit\xfd pro v\xfdpo\u010Det % p\u0159etok\u016F do s\xedt\u011B."
                                }),
                                variableId: "INVERTER_POWER",
                                opts: {
                                    maximumFractionDigits: 0,
                                    style: 'unit',
                                    unit: 'kilowatt'
                                },
                                step: 1,
                                min: 1,
                                max: 50
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fba062b26dc2f097$export$7b3f09138ef8bc19), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6aaadd6817fa784e$export$a040df6eb068c6c9), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6342fbb618ee4f49$export$b0c19aa6a430c560), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44aa4714e63a415$export$5f03a5ec016badda), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            sofarGoodweNext && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.batterychargingpower",
                                    defaultMessage: "Nab\xedjec\xed v\xfdkon baterie"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.batterychargingpower_sub",
                                    defaultMessage: "V\xfdkon pro manu\xe1ln\xed nab\xedjen\xed baterie a spotov\xe9 nab\xedjen\xed z distribu\u010Dn\xed s\xedt\u011B"
                                }),
                                variableId: "PV_BATTERY_CHARGING_POWER",
                                visibility: {
                                    variableIds: [
                                        {
                                            variableId: 'PV_ONGRID',
                                            reversed: true
                                        },
                                        'PV_INSTALL',
                                        'PV_BATTERY'
                                    ]
                                },
                                opts: {
                                    style: 'unit',
                                    unit: 'kilowatt',
                                    maximumFractionDigits: 0
                                },
                                step: 1,
                                min: 1,
                                max: 10
                            }),
                            sofarGoodweNext && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.batterydischargingpower",
                                    defaultMessage: "Vyb\xedjec\xed v\xfdkon baterie"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.batterydischargingpower_sub",
                                    defaultMessage: "V\xfdkon pro spotov\xe9 vyb\xedjen\xed baterie do distribu\u010Dn\xed s\xedt\u011B"
                                }),
                                variableId: "PV_BATTERY_DISCHARGING_POWER",
                                visibility: {
                                    variableIds: [
                                        {
                                            variableId: 'PV_ONGRID',
                                            reversed: true
                                        },
                                        'PV_INSTALL',
                                        'PV_BATTERY'
                                    ]
                                },
                                opts: {
                                    style: 'unit',
                                    unit: 'kilowatt',
                                    maximumFractionDigits: 0
                                },
                                step: 1,
                                min: 1,
                                max: 10
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                type: "row",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.inverters-nominal",
                                    defaultMessage: "Nomin\xe1ln\xed v\xfdkon \u0159iditeln\xfdch st\u0159\xedda\u010D\u016F"
                                }),
                                visibility: {
                                    variableId: 'PV_ACTIVE_POWER_CONTROL'
                                },
                                value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "PV_ACTIVE_POWER_NOMINAL",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        minimumFractionDigits: 1,
                                        maximumFractionDigits: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                type: "row",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.photovoltaics.inverters-adjust-power",
                                    defaultMessage: "Aktu\xe1ln\xed v\xfdkon st\u0159\xedda\u010D\u016F"
                                }),
                                visibility: {
                                    variableId: 'PV_ACTIVE_POWER_CONTROL'
                                },
                                value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "PV_ACTIVE_POWER_PERC",
                                    opts: {
                                        style: 'percent',
                                        maximumFractionDigits: 0
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.boiler",
                    defaultMessage: "Bojler"
                }),
                layout: "list",
                visibility: {
                    variableId: 'HW_INSTALL_V1'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da7e8a667ca6e3e6$export$f93868c14f0bb964), {
                            showShelliesControl: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f500361bb014857$export$2cddd0ae366a366c), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatpump",
                    defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                }),
                layout: "list",
                visibility: {
                    variableId: 'HP_ENABLED_V1'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.enabled",
                                defaultMessage: "Tepeln\xe9 \u010Derpadlo nainstalov\xe1no"
                            }),
                            switchVariableId: "HP_ENABLED",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ee8ad514925a8918$export$562e7711c6408d3), {}),
                        !hpNominalFromHp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.nominal",
                                defaultMessage: "Nomin\xe1ln\xed p\u0159\xedkon"
                            }),
                            variableId: "HP_NOMINAL",
                            visibility: {
                                variableId: 'HP_ENABLED'
                            },
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            step: 0.1
                        }),
                        hpNominalFromHp && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.nominal1",
                                defaultMessage: "Nomin\xe1ln\xed p\u0159\xedkon"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HP_NOMINAL",
                                opts: {
                                    style: 'unit',
                                    unit: 'kilowatt',
                                    minimumFractionDigits: 1,
                                    maximumFractionDigits: 1
                                }
                            }),
                            visibility: {
                                variableId: 'HP_ENABLED'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.flexiRoom",
                                defaultMessage: "Flexibilita m\xedstnosti"
                            }),
                            switchVariableId: "HP_FLEXI_ROOM",
                            visibility: {
                                variableId: 'HP_ENABLED'
                            },
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.flexiHw",
                                defaultMessage: "Flexibilita tepl\xe9 vody"
                            }),
                            switchVariableId: "HP_FLEXI_HW",
                            visibility: {
                                variableId: 'HP_ENABLED'
                            },
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.flexiCool",
                                defaultMessage: "Flexibilita chlazen\xed"
                            }),
                            switchVariableId: "HP_FLEXI_COOL",
                            visibility: {
                                variableId: 'HP_ENABLED'
                            },
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.flexiAN",
                                defaultMessage: "Flexibilita AN"
                            }),
                            switchVariableId: "HP_FLEXI_AN",
                            visibility: {
                                variableIds: [
                                    'HP_ECOONE',
                                    'HP_ENABLED'
                                ]
                            },
                            fullWidth: true
                        })
                    ]
                })
            }),
            relaySettings && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.thermostat",
                    defaultMessage: "Termostat"
                }),
                layout: "list",
                visibility: {
                    variableIds: [
                        'THERMOSTAT_INSTALL_V1'
                    ]
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e4cfe371582f6593$export$d89b70f5e57ee789), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.spot",
                    defaultMessage: "Spotov\xe9 obchodov\xe1n\xed"
                }),
                layout: "list",
                visibility: {
                    variableId: 'SP_INSTALL_V1'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $081bcf26156f4356$export$6ec90c1ef5cffa35), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.wallbox.spot",
                    defaultMessage: "Wallbox"
                }),
                layout: "list",
                visibility: {
                    variableId: 'WB_INSTALL_V1'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c912a4a4aecd7f44$export$93dfdc1002311d10), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7153b1eb2fa26705$export$a29d188ae7b63a77), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.plug",
                    defaultMessage: "Z\xe1suvky"
                }),
                layout: "list",
                visibility: {
                    variableId: 'PL_INSTALL_V1'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.enabled",
                                defaultMessage: "Z\xe1suvky nainstalov\xe1ny"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.enabled.subtitle",
                                defaultMessage: "Z\xe1suvky na lok\xe1ln\xed s\xedti "
                            }),
                            switchVariableId: "PL_INSTALL",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip1",
                                defaultMessage: "IP adresa prvn\xed z\xe1suvky"
                            }),
                            inputVariableId: "PL_IP[0]",
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    },
                                    'PL_INSTALL'
                                ]
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip1.label",
                                defaultMessage: "IP 1"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.enabled2",
                                defaultMessage: "Druh\xe1 z\xe1suvka"
                            }),
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    },
                                    'PL_INSTALL'
                                ]
                            },
                            switchVariableId: "PL_INSTALL_I[1]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip2",
                                defaultMessage: "IP adresa druh\xe9 z\xe1suvky"
                            }),
                            inputVariableId: "PL_IP[1]",
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    },
                                    'PL_INSTALL_I[1]',
                                    'PL_INSTALL'
                                ]
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip2.label",
                                defaultMessage: "IP 2"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.enabled3",
                                defaultMessage: "T\u0159et\xed z\xe1suvka"
                            }),
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    },
                                    'PL_INSTALL_I[1]',
                                    'PL_INSTALL'
                                ]
                            },
                            switchVariableId: "PL_INSTALL_I[2]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip3",
                                defaultMessage: "IP adresa t\u0159et\xed z\xe1suvky"
                            }),
                            inputVariableId: "PL_IP[2]",
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    },
                                    'PL_INSTALL_I[1]',
                                    'PL_INSTALL',
                                    'PL_INSTALL_I[2]'
                                ]
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.ip3.label",
                                defaultMessage: "IP 3"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.modulenabled",
                                defaultMessage: "Z\xe1suvky na modulu Shelly PRO 3"
                            }),
                            visibility: {
                                variableIds: [
                                    'PL_INSTALL_V1',
                                    'PL_INSTALL'
                                ]
                            },
                            switchVariableId: "PL_SHELLY_HW_PLUG",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.modulip",
                                defaultMessage: "IP adresa modulu"
                            }),
                            inputVariableId: "PL_IP[0]",
                            visibility: {
                                variableId: 'PL_SHELLY_HW_PLUG'
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.modulip.label",
                                defaultMessage: "IP Modulu"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            }),
            relaySettings && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.relay",
                            defaultMessage: "Rel\xe9"
                        }),
                        layout: "list",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.relay.enabled",
                                        defaultMessage: "Rel\xe9 nainstalov\xe1ny"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.relay.enabled.subtitle",
                                        defaultMessage: "Integrovan\xe1 rel\xe9"
                                    }),
                                    switchVariableId: "RELAY_INSTALL",
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.relay.user_advanced_control",
                                        defaultMessage: "Zobrazit str\xe1nku s informacemi u\u017Eivateli"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.relay.user_advanced_control.subtitle",
                                        defaultMessage: "P\u0159i povolen\xed se objev\xed str\xe1nka v navigaci"
                                    }),
                                    switchVariableId: "RELAY_USER_ADVANCED_CONTROL",
                                    visibility: {
                                        variableId: 'RELAY_INSTALL'
                                    },
                                    fullWidth: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8077a1edfb90f10e$export$f5799ab29b788af0), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.network",
                    defaultMessage: "S\xed\u0165"
                }),
                layout: "list",
                help: {
                    variant: 'dialog',
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.service.network.help.title",
                        defaultMessage: "Nastaven\xed s\xedt\u011B"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.service.network.help.content",
                        defaultMessage: `
                V seznamu je mo\u{17E}n\xe9 vid\u{11B}t aktu\xe1ln\u{11B} p\u{159}ipojen\xe1 za\u{159}\xedzen\xed do s\xedt\u{11B} Infigy (WiFi nebo kabelem), jejich IP adresy, MAC adresy, atd.
                Pokud za\u{159}\xedzen\xed pou\u{17E}\xedv\xe1 DHCP, je mo\u{17E}n\xe9 kliknut\xedm na \u{161}pendl\xedk a zafixovat IP adresu, kterou pak DHCP server v\u{17E}dy bude p\u{159}i\u{159}azovat - toto je vhodn\xe9 nap\u{159}. pro st\u{159}\xedda\u{10D}, tepeln\xe9 \u{10D}erpadlo, apod.
                Pokud za\u{159}\xedzen\xed pou\u{17E}\xedv\xe1 statickou IP adresu, nemus\xed se zobrazovat spr\xe1vn\u{11B}.
              `
                    })
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $24a55c5e6e739460$export$f122a8f2c2ae40c1), {}),
                        networkCaps.managedNetwork && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.service.network.wifi_passphrase",
                                defaultMessage: "Heslo WiFi s\xedt\u011B"
                            }),
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $29Lk4.WifiApPassphraseEdit), {}),
                            fullWidth: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service.info",
                    defaultMessage: "Instalace"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d4101366a11d69ee$export$32b907da6e4e6ad1), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.service.town",
                                defaultMessage: "Lokalita (obec)"
                            }),
                            visibility: {
                                variableId: 'BEZ_DODAVATELE_API_ENABLED'
                            },
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56aaa28274e34a03$export$f185eee3bbd34116), {}),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.service.reset",
                                defaultMessage: "Reset chyb"
                            }),
                            buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.service.reset.button",
                                defaultMessage: "Reset chyb"
                            }),
                            onClick: resetErr,
                            fullWidth: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.app_update",
                    defaultMessage: "Verze aplikace"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22ebae9741c9601a$export$5f7700ebf3ab7ed8), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4878ff3657a4956a$export$e83ffb78b976f69f), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.exit",
                            defaultMessage: "Odhl\xe1sit ze servisu"
                        }),
                        buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.service.exit.button",
                            defaultMessage: "Odhl\xe1sit"
                        }),
                        onClick: exitService,
                        fullWidth: true
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5c36b248b5436f55$export$c57337bf78256d68), {
                variant: "settings",
                sx: {
                    mt: 2,
                    display: serviceActive ? 'block' : 'none'
                }
            }),
            serviceActive ? content : servicePasswordInput
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $jrrQL = parcelRequire("jrrQL");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $9iEAl = parcelRequire("9iEAl");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");

const $71fbce0a0826b319$export$14a0ab54d106a21d = ()=>{
    const { state: state } = (0, $aphAM.useLocation)();
    (0, $acw62.useEffect)(()=>{
        if ((0, $f1q41.get)(state, 'scroll') === 'app-messages-settings') {
            const element = document.getElementById('notifications');
            if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.notification",
                defaultMessage: "Notifikace"
            }),
            layout: "list",
            visibility: {
                variableId: 'PREMIUM'
            },
            id: "notifications",
            collapsible: true,
            plus: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($71fbce0a0826b319$var$WebNotifications, {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.iverter_disconnected",
                                defaultMessage: "V\xfdpadek komunikace st\u0159\xedda\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.iverter_disconnected.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci v\xfdpadku komunikace se st\u0159\xedda\u010Dem"
                            }),
                            switchVariableId: "NOTIF_INVERTER_DISCONNECTED_ENABLE",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.utility_loss",
                                defaultMessage: "V\xfdpadek distribu\u010Dn\xed s\xedt\u011B"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.utility_loss.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci v\xfdpadku distribu\u010Dn\xed s\xedt\u011B"
                            }),
                            switchVariableId: "NOTIF_UTILITY_LOSS_ENABLE",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.pv_production_mwh",
                                defaultMessage: "Miln\xedk ve v\xfdrob\u011B FV energie"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.pv_production_mwh.subtitle",
                                defaultMessage: "Notifikace se vygeneruje pokud FVE vygeneruje MWh energie v dan\xe9m roce"
                            }),
                            switchVariableId: "NOTIF_PV_PRODUCTION_MWH_ENABLE",
                            fullWidth: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_max_soc",
                                defaultMessage: "Maxim\xe1ln\xed SOC baterie"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_max_soc.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i dosa\u017Een\xed nastaven\xe9ho maxim\xe1ln\xedho SOC baterie. Notifikace se vygeneruje pouze 1x denn\u011B."
                            }),
                            switchVariableId: "NOTIF_BATTERY_MAX_SOC_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PV_BATTERY'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_max_soc_value",
                                defaultMessage: "Maxim\xe1ln\xed SOC baterie pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_max_soc_value.subtitle",
                                defaultMessage: "Nastavte SOC baterie, p\u0159i jeho\u017E dosa\u017Een\xed se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_BATTERY_MAX_SOC_VALUE",
                            visibility: {
                                variableIds: [
                                    'NOTIF_BATTERY_MAX_SOC_ENABLE'
                                ]
                            },
                            max: 100,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_min_soc",
                                defaultMessage: "Minim\xe1ln\xed SOC baterie"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_min_soc.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i poklesu SOC baterie na nastavenou minim\xe1ln\xed hodnotu. Notifikace se vygeneruje pouze 1x denn\u011B."
                            }),
                            switchVariableId: "NOTIF_BATTERY_MIN_SOC_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PV_BATTERY'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_min_soc_value",
                                defaultMessage: "Minim\xe1ln\xed SOC baterie pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.battery_min_soc_value.subtitle",
                                defaultMessage: "Nastavte SOC baterie. P\u0159i poklesu na tuto hodnotu se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_BATTERY_MIN_SOC_VALUE",
                            visibility: {
                                variableIds: [
                                    'NOTIF_BATTERY_MIN_SOC_ENABLE'
                                ]
                            },
                            max: 100,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_daily_prediction",
                                defaultMessage: "Denn\xed p\u0159edpov\u011B\u010F"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.daily_prediction.subtitle",
                                defaultMessage: "Notifikace se vygeneruje ka\u017Ed\xfd den v 8:00"
                            }),
                            switchVariableId: "NOTIF_SPOT_DAILY_PREDICTION_ENABLE",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_daily_summary",
                                defaultMessage: "Denn\xed souhrn pl\xe1nu spotu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_daily_summary.subtitle",
                                defaultMessage: "Notifikace se vygeneruje ka\u017Ed\xfd den v 8:00"
                            }),
                            switchVariableId: "NOTIF_SPOT_DAILY_SUMMARY_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'SP_ON',
                                    'SP_INSTALL'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.negative_spot",
                                defaultMessage: "Z\xe1porn\xe1 cena na spotu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.negative_spot.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci z\xe1porn\xe9 ceny na spotu"
                            }),
                            switchVariableId: "NOTIF_SPOT_NEGATIVE_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'SP_ON',
                                    'SP_INSTALL'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_charging_battery",
                                defaultMessage: "Start a konec nab\xedjen\xed baterie dle spotov\xe9 ceny"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_charging_battery.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci nab\xedjen\xed baterie dle spotov\xe9 ceny"
                            }),
                            switchVariableId: "NOTIF_SPOT_CHARGING_BATTERY_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'SP_BATTERY_CONTROL_CUSTOMER',
                                    'SP_ON',
                                    'SP_INSTALL'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_discharging_battery",
                                defaultMessage: "Start a konec vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.spot_discharging_battery.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny"
                            }),
                            switchVariableId: "NOTIF_SPOT_DISCHARGING_BATTERY_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'SP_DISCHARGE_TO_GRID',
                                    'SP_ON',
                                    'SP_INSTALL'
                                ]
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.notification.heat_water_max_temperature",
                            defaultMessage: "Dosa\u017Eena maxim\xe1ln\xed teplota vody v bojleru"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.notification.heat_water_max_temperature.subtitle",
                            defaultMessage: "Notifikace se vygeneruje p\u0159i dosa\u017Een\xed po\u017Eadovan\xe9 maxim\xe1ln\xed teploty vody v bojleru z FV energie"
                        }),
                        switchVariableId: "NOTIF_HEAT_WATER_MAX_TEMP_ENABLE",
                        fullWidth: true,
                        visibility: {
                            variableIds: [
                                'HW_ON',
                                'HW_TEMP_ENABLED'
                            ]
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.notification.wallbox_charging_start_stop",
                            defaultMessage: "Start a konec nab\xedjen\xed elektromobilu"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.notification.wallbox_charging_start_stop.subtitle",
                            defaultMessage: "Notifikace se vygeneruje p\u0159i za\u010D\xe1tku a konci nab\xedjen\xed elektromobilu"
                        }),
                        switchVariableId: "NOTIF_WALLBOX_CHARGING_ENABLE",
                        fullWidth: true,
                        visibility: {
                            variableIds: [
                                'WB_INSTALL'
                            ]
                        }
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.home_consumption_limit_exceeded",
                                defaultMessage: "P\u0159ekro\u010Den\xed limitu spot\u0159eby dom\xe1cnosti"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.home_consumption_limit_exceeded.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu spot\u0159eby dom\xe1cnosti"
                            }),
                            switchVariableId: "NOTIF_LIMIT_HOME_ENABLE",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.home_consumption_limit_value",
                                defaultMessage: "Denn\xed limit spot\u0159eby dom\xe1cnosti pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.home_consumption_limit_value.subtitle",
                                defaultMessage: "Nastavte limit spot\u0159eby dom\xe1cnosti, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_LIMIT_HOME_VALUE",
                            opts: {
                                maximumFractionDigits: 0,
                                style: 'unit',
                                unit: 'kilowatt-hour'
                            },
                            step: 1,
                            min: 1,
                            max: 150,
                            visibility: {
                                variableId: 'NOTIF_LIMIT_HOME_ENABLE'
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_water_limit_exceeded",
                                defaultMessage: "P\u0159ekro\u010Den\xed limitu oh\u0159evu vody"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_water_limit_exceeded.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu oh\u0159evu vody"
                            }),
                            switchVariableId: "NOTIF_LIMIT_HEAT_WATER_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'HW_INSTALL'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_water_limit_value",
                                defaultMessage: "Denn\xed limit oh\u0159evu vody pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_water_limit_value.subtitle",
                                defaultMessage: "Nastavte limit oh\u0159evu vody, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_LIMIT_HEAT_WATER_VALUE",
                            opts: {
                                maximumFractionDigits: 0,
                                style: 'unit',
                                unit: 'kilowatt-hour'
                            },
                            step: 1,
                            min: 1,
                            max: 30,
                            visibility: {
                                variableIds: [
                                    'NOTIF_LIMIT_HEAT_WATER_ENABLE',
                                    'HW_INSTALL'
                                ]
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_pump_limit_exceeded",
                                defaultMessage: "P\u0159ekro\u010Den\xed limitu spot\u0159eby tepeln\xe9ho \u010Derpadla"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_pump_limit_exceeded.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu spot\u0159eby tepeln\xe9ho \u010Derpadla"
                            }),
                            switchVariableId: "NOTIF_LIMIT_HEAT_PUMP_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'HP_ENABLED'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_pump_limit_value",
                                defaultMessage: "Denn\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.heat_pump_limit_value.subtitle",
                                defaultMessage: "Nastavte limit spot\u0159eby tepeln\xe9ho \u010Derpadla, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_LIMIT_HEAT_PUMP_VALUE",
                            opts: {
                                maximumFractionDigits: 0,
                                style: 'unit',
                                unit: 'kilowatt-hour'
                            },
                            step: 1,
                            min: 1,
                            max: 50,
                            visibility: {
                                variableIds: [
                                    'NOTIF_LIMIT_HEAT_PUMP_ENABLE',
                                    'HP_ENABLED'
                                ]
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.wallbox_limit_exceeded",
                                defaultMessage: "P\u0159ekro\u010Den\xed limitu nab\xedjen\xed elektromobilu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.wallbox_limit_exceeded.subtitle",
                                defaultMessage: "Notifikace se vygeneruje p\u0159i p\u0159ekro\u010Den\xed nastaven\xe9ho limitu nab\xedjen\xed elektromobilu"
                            }),
                            switchVariableId: "NOTIF_LIMIT_WALLBOX_ENABLE",
                            fullWidth: true,
                            visibility: {
                                variableId: 'WB_INSTALL'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.wallbox_limit_value",
                                defaultMessage: "Denn\xed limit nab\xedjen\xed elektromobilu pro notifikace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.notification.wallbox_limit_value.subtitle",
                                defaultMessage: "Nastavte limit nab\xedjen\xed elektromobilu, p\u0159i jeho\u017E p\u0159ekro\u010Den\xed se vygeneruje notifikace."
                            }),
                            variableId: "NOTIF_LIMIT_WALLBOX_VALUE",
                            opts: {
                                maximumFractionDigits: 0,
                                style: 'unit',
                                unit: 'kilowatt-hour'
                            },
                            step: 1,
                            min: 1,
                            max: 80,
                            visibility: {
                                variableIds: [
                                    'NOTIF_LIMIT_WALLBOX_ENABLE',
                                    'WB_INSTALL'
                                ]
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const $71fbce0a0826b319$var$WebNotifications = ()=>{
    const deviceId = (0, $2lSXC.useSelector)(({ variables: { DEVICE_ID: DEVICE_ID } })=>DEVICE_ID);
    const [state, setState] = (0, $acw62.useState)('unknown');
    const updateState = ()=>{
        const windowState = $71fbce0a0826b319$var$getStateFromWindow();
        if (!windowState) {
            setState('error-loading');
            return;
        }
        if (!windowState.notificationsSupported && windowState.iosPwaSupported) {
            setState('ios-pwa-supported');
            return;
        }
        if (!windowState.notificationsSupported) {
            setState('not-supported');
            return;
        }
        if (!windowState.hasToken) {
            setState('not-enabled');
            return;
        }
        setState('loading');
        windowState.getSubscription(deviceId).then((result)=>{
            if (result) setState('enabled');
            else setState('not-enabled');
        }).catch(()=>{
            setState('error-loading');
        });
    };
    (0, $acw62.useEffect)(()=>{
        const handleStateChanged = ()=>{
            updateState();
        };
        window.addEventListener('app-web-notifications-state-changed', handleStateChanged);
        setTimeout(()=>{
            updateState();
        }, 500);
        return ()=>{
            window.removeEventListener('app-web-notifications-state-changed', handleStateChanged);
        };
    }, [
        deviceId
    ]);
    // debug
    // useEffect(() => {
    //   console.log('WebNotifications state:', state);
    // }, [state]);
    const handleSwitchChange = async ()=>{
        if ([
            'not-enabled',
            'enabled'
        ].includes(state)) {
            await $71fbce0a0826b319$var$getStateFromWindow()?.setSubscription(state !== 'enabled', deviceId);
            updateState();
        }
        if (state === 'ios-pwa-supported') window.open('https://infigy.cz/app-redirect/wiki-ios-pwa', '_blank', 'noopener,noreferrer');
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.notification.webapp.title",
            defaultMessage: "Webov\xe1 aplikace"
        }),
        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.notification.webapp.subtitle",
            defaultMessage: "Notifikace z Infigy m\u016F\u017Eete dost\xe1vat p\u0159es webovou aplikaci."
        }),
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jrrQL.default), {
            sx: {
                ml: 'auto'
            },
            disabled: [
                'loading',
                'error-loading',
                'not-supported'
            ].includes(state),
            checked: state === 'enabled',
            onChange: ()=>handleSwitchChange()
        }),
        fullWidth: true
    });
};
// Example of a possible window.webNotifications state
/*
  window.webNotifications = {
    hasToken: false,
    notificationsSupported: false,
    iosPwaSupported: false,
    getSubscription: async () => true,
    setSubscription: async () => {},
  };
  window.dispatchEvent(new CustomEvent('app-web-notifications-state-changed'));
 */ // Example of event dispatch
// window.dispatchEvent(new CustomEvent('app-web-notifications-state-changed'));
function $71fbce0a0826b319$var$getStateFromWindow() {
    // eslint-disable-next-line
    // @ts-ignore
    return window.webNotifications;
}



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("cW890");
var $6uJ19 = parcelRequire("6uJ19");
const $d9ab324d1199a267$var$options = [
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.price.period.60min",
            defaultMessage: "60 min"
        }),
        value: (0, $6uJ19.SpotPricePeriod)['60M']
    },
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.price.period.15min",
            defaultMessage: "15 min"
        }),
        value: (0, $6uJ19.SpotPricePeriod)['15M']
    }
];
const $d9ab324d1199a267$export$59ba75a4d6ef29cf = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.spot.price.period",
            defaultMessage: "\u010Casov\xe9 rozli\u0161en\xed"
        }),
        selectVariableId: "SP_PRICE_PERIOD",
        options: $d9ab324d1199a267$var$options,
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("cW890");
var $6uJ19 = parcelRequire("6uJ19");
const $3fc89740a40a9451$var$options = [
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.region.cz",
            defaultMessage: "CZ"
        }),
        value: (0, $6uJ19.SpotRegion).CZ
    },
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.region.nl",
            defaultMessage: "NL"
        }),
        value: (0, $6uJ19.SpotRegion).NL
    },
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.region.sk",
            defaultMessage: "SK"
        }),
        value: (0, $6uJ19.SpotRegion).SK
    }
];
const $3fc89740a40a9451$export$af551370f369b7df = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.spot.region",
            defaultMessage: "Region"
        }),
        selectVariableId: "SP_REGION",
        options: $3fc89740a40a9451$var$options,
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aZOrF = parcelRequire("aZOrF");


const $68f859cf525acf7a$export$cdc95709697474db = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.price_distribution_low",
                            defaultMessage: "Cena za distribuci v n\xedzk\xe9m tarifu"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_distribution_low",
                                defaultMessage: "Cena za distribuci v n\xedzk\xe9m tarifu"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_distribution_low.help",
                                defaultMessage: "Cena za distribuci v n\xedzk\xe9m tarifu v k\u010D/kWh. Tato cena se p\u0159i\u010D\xedt\xe1 k cen\u011B spotu, pokud je aktivn\xed n\xedzk\xfd tarif. Mus\xed b\xfdt nastaveny \u010Dasy HDO pro spr\xe1vn\xfd v\xfdpo\u010Det ceny ve vysok\xe9m a n\xedzk\xe9m tarifu. Tuto \u010D\xe1stku hledejte ve vy\xfa\u010Dtov\xe1n\xed za elekt\u0159inu."
                            })
                        })
                    ]
                }),
                variableId: "PRICE_DISTRIBUTION_LOW",
                opts: {
                    style: 'currency',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                },
                step: {
                    CZK: 0.01,
                    EUR: 0.01
                },
                min: {
                    CZK: 0,
                    EUR: 0
                },
                max: {
                    CZK: 10,
                    EUR: 0.5
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.price_distribution_hi",
                            defaultMessage: "Cena za distribuci ve vysok\xe9m tarifu"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_distribution_hi",
                                defaultMessage: "Cena za distribuci ve vysok\xe9m tarifu"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_distribution_hi.help",
                                defaultMessage: "Cena za distribuci ve vysok\xe9m tarifu v k\u010D/kWh. Tato cena se p\u0159i\u010D\xedt\xe1 k cen\u011B spotu, pokud je aktivn\xed vysok\xfd tarif. Mus\xed b\xfdt nastaveny \u010Dasy HDO pro spr\xe1vn\xfd v\xfdpo\u010Det ceny ve vysok\xe9m a n\xedzk\xe9m tarifu. Tuto \u010D\xe1stku hledejte ve vy\xfa\u010Dtov\xe1n\xed za elekt\u0159inu."
                            })
                        })
                    ]
                }),
                variableId: "PRICE_DISTRIBUTION_HI",
                opts: {
                    style: 'currency',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                },
                step: {
                    CZK: 0.01,
                    EUR: 0.01
                },
                min: {
                    CZK: 0,
                    EUR: 0
                },
                max: {
                    CZK: 10,
                    EUR: 0.5
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aZOrF = parcelRequire("aZOrF");



var $2lSXC = parcelRequire("2lSXC");
const $293abdf0e2299566$export$847b3c781643970a = ()=>{
    const maxOverflow = (0, $2lSXC.useSelector)((s)=>s.variables.PV_OVERFLOW_MAX_VALUE);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.price_offset",
                            defaultMessage: "Cena pro z\xe1kaz p\u0159etok\u016F"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_offset",
                                defaultMessage: "Cena pro z\xe1kaz p\u0159etok\u016F"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.price_offset.help",
                                defaultMessage: "Doporu\u010Dujeme nastavit minim\xe1ln\u011B ve v\xfd\u0161i provize/poplatku obchodn\xedkovi za prodej p\u0159etok\u016F do s\xedt\u011B."
                            })
                        })
                    ]
                }),
                variableId: "SP_PRICE_OFFSET_OVERFLOW",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.price_offset.subtitle",
                    defaultMessage: "Minim\xe1ln\xed cena spotu, pod kterou se zakazuj\xed p\u0159etoky. Hodnota je porovn\xe1v\xe1na s denn\xedm trhem bez distribu\u010Dn\xed sazby."
                }),
                opts: {
                    style: 'currency',
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                },
                min: {
                    CZK: -10,
                    EUR: -0.5
                },
                max: {
                    CZK: 10,
                    EUR: 0.5
                },
                step: {
                    CZK: 0.01,
                    EUR: 0.001
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.overflow_offset",
                            defaultMessage: "Maxim\xe1ln\xed p\u0159etok p\u0159i z\xe1kazu p\u0159etok\u016F"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.overflow_offset",
                                defaultMessage: "Maxim\xe1ln\xed p\u0159etok p\u0159i z\xe1porn\xe9 cen\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.overflow_offset.help",
                                defaultMessage: "Hodnota ud\xe1v\xe1 p\u0159etok do distribu\u010Dn\xed s\xedt\u011B p\u0159i z\xe1porn\xe9 cen\u011B. Tuto funkci doporu\u010Dujeme vyu\u017E\xedvat v p\u0159\xedpad\u011B energetick\xe9 komunity."
                            })
                        })
                    ]
                }),
                variableId: "PV_UTILITY_STOP_OFFSET",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.overflow_offset.subtitle",
                    defaultMessage: "Hodnotu nen\xed mo\u017En\xe9 nastavit vy\u0161\u0161\xed ne\u017E maxim\xe1ln\xed p\u0159etok"
                }),
                opts: {
                    style: 'unit',
                    unit: 'kilowatt',
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                },
                min: 0,
                max: maxOverflow,
                step: 0.1
            })
        ]
    });
};


const $989522737c85febb$export$8d49512b093ffbd9 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "settings.spot",
            defaultMessage: "Spot"
        }),
        layout: "list",
        visibility: {
            variableId: 'SP_INSTALL'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fc89740a40a9451$export$af551370f369b7df), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9ab324d1199a267$export$59ba75a4d6ef29cf), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $293abdf0e2299566$export$847b3c781643970a), {}),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68f859cf525acf7a$export$cdc95709697474db), {})
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aZOrF = parcelRequire("aZOrF");



var $2lSXC = parcelRequire("2lSXC");

var $8ni7a = parcelRequire("8ni7a");
const $ce67e5a088fdb8b5$export$a373c8a9d52b5cbc = ()=>{
    const fronius = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        if (!inverterConfig) return false;
        const inverters = Object.values(inverterConfig);
        return inverters.some((inv)=>inv.type === (0, $8ni7a.Inverter).Fronius);
    });
    const onGrid = (0, $2lSXC.useSelector)((s)=>{
        return s.variables.PV_ONGRID;
    });
    if (fronius || onGrid) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
        type: "row",
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.other.overflow_settings",
                    defaultMessage: "Nastaven\xe1 hodnota p\u0159etok\u016F"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                    variant: "dialog",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.other.overflow_settings",
                        defaultMessage: "Nastaven\xe1 hodnota p\u0159etok\u016F"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.other.overflow_settings.help",
                        defaultMessage: "Jedn\xe1 se o servisn\u011B nastavenou hodnotu maxim\xe1ln\xedho p\u0159etoku. Tato hodnota je stanovena distributorem. P\u0159ekro\u010Den\xed t\xe9to hodnoty m\u016F\u017Ee v\xe9st k finan\u010Dn\xedm postih\u016Fm ze strany distributora."
                    })
                })
            ]
        }),
        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
            variableId: "OVERFLOW_INFO",
            opts: {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1
            }
        })
    });
};




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $bJgPp = parcelRequire("bJgPp");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
parcelRequire("acw62");

var $9dZwz = parcelRequire("9dZwz");

var $acw62 = parcelRequire("acw62");


var $f5O3L = parcelRequire("f5O3L");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $f94b725db0b0ec0d$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $f94b725db0b0ec0d$export$2e2bcd8739ae039 = $f94b725db0b0ec0d$var$ThemeContext;


function $0136601b4ac21f95$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $f94b725db0b0ec0d$export$2e2bcd8739ae039));
    return theme;
}



var $eEJPp = parcelRequire("eEJPp");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




const $475d3505e656b5eb$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $475d3505e656b5eb$export$2e2bcd8739ae039 = $475d3505e656b5eb$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $ayMG0 = parcelRequire("ayMG0");
function $156e2307a6178c64$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $156e2307a6178c64$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $0136601b4ac21f95$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $156e2307a6178c64$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $475d3505e656b5eb$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f94b725db0b0ec0d$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $156e2307a6178c64$export$2e2bcd8739ae039 = $156e2307a6178c64$var$ThemeProvider;



parcelRequire("8zogs");
var $k7M2x = parcelRequire("k7M2x");

var $g6Om4 = parcelRequire("g6Om4");

var $58lXc = parcelRequire("58lXc");

var $aMyfV = parcelRequire("aMyfV");
parcelRequire("acw62");

var $eEJPp = parcelRequire("eEJPp");

var $auC0X = parcelRequire("auC0X");

var $92iK7 = parcelRequire("92iK7");

var $g6Om4 = parcelRequire("g6Om4");

var $ayMG0 = parcelRequire("ayMG0");
function $34de227aaca64f99$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $g6Om4.default)();
    const id = (0, $auC0X.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $eEJPp.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $92iK7.default), {
        styles: layerOrder
    });
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $g6Om4.default)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $0136601b4ac21f95$export$2e2bcd8739ae039)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $34de227aaca64f99$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $156e2307a6178c64$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $k7M2x.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58lXc.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $aMyfV.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;


/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
const $1507b440b55b1cf7$export$ff0fa3047d11164c = 'mode';
const $1507b440b55b1cf7$export$665054ea9d94dab9 = 'color-scheme';
const $1507b440b55b1cf7$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1507b440b55b1cf7$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1507b440b55b1cf7$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1507b440b55b1cf7$export$665054ea9d94dab9, attribute: initialAttribute = $1507b440b55b1cf7$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $acw62 = parcelRequire("acw62");

function $3b1fb882896a7778$var$noop() {}
const $3b1fb882896a7778$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $3b1fb882896a7778$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $3b1fb882896a7778$export$2e2bcd8739ae039 = $3b1fb882896a7778$var$localStorageManager;


'use client';
function $d8b25f9d3c9e642d$var$noop() {}
function $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d8b25f9d3c9e642d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state) {
    return $d8b25f9d3c9e642d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d8b25f9d3c9e642d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $3b1fb882896a7778$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $acw62.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $acw62.useState(noSsr || !isMultiSchemes);
    $acw62.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d8b25f9d3c9e642d$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $8dfeca3d89da820b$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dfeca3d89da820b$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>$acw62.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $0136601b4ac21f95$export$2e2bcd8739ae039)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $acw62.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $acw62.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $d8b25f9d3c9e642d$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $acw62.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $eEJPp.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dfeca3d89da820b$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5O3L.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $1507b440b55b1cf7$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $2rLZY = parcelRequire("2rLZY");

var $b1ZjZ = parcelRequire("b1ZjZ");

var $bXtHQ = parcelRequire("bXtHQ");
parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
const $d5eac692ed332b1c$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $d5eac692ed332b1c$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $d5eac692ed332b1c$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $d5eac692ed332b1c$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $d5eac692ed332b1c$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $d5eac692ed332b1c$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $d5eac692ed332b1c$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1507b440b55b1cf7$export$2e2bcd8739ae039), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $d5eac692ed332b1c$export$2e2bcd8739ae039 = $d5eac692ed332b1c$var$InitColorSchemeScript;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const { CssVarsProvider: $cfa43f235c6b12b8$var$InternalCssVarsProvider, useColorScheme: $cfa43f235c6b12b8$export$6343629ee1b29116, getInitColorSchemeScript: $cfa43f235c6b12b8$var$deprecatedGetInitColorSchemeScript } = (0, $8dfeca3d89da820b$export$2e2bcd8739ae039)({
    themeId: (0, $bXtHQ.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $2rLZY.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $b1ZjZ.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $9dZwz.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $cfa43f235c6b12b8$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $cfa43f235c6b12b8$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($cfa43f235c6b12b8$var$InternalCssVarsProvider, {
        ...props
    });
}
let $cfa43f235c6b12b8$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $cfa43f235c6b12b8$export$f9a57b4a2abf8ed = (params)=>{
    if (!$cfa43f235c6b12b8$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $cfa43f235c6b12b8$var$warnedInitScriptOnce = true;
    }
    return $cfa43f235c6b12b8$var$deprecatedGetInitColorSchemeScript(params);
};
const $cfa43f235c6b12b8$export$50ec01b133c61652 = $cfa43f235c6b12b8$var$InternalCssVarsProvider;


const $d58da9e26a3d9558$export$1b7d54d6dc8d70ad = ()=>{
    const { mode: mode, setMode: setMode } = (0, $cfa43f235c6b12b8$export$6343629ee1b29116)();
    if (!mode) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bJgPp.default), {
        size: "small",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
            value: mode,
            onChange: (event)=>setMode(event.target.value),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                    value: "system",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "dark_mode.system",
                        defaultMessage: "System"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                    value: "light",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "dark_mode.light",
                        defaultMessage: "Sv\u011Btl\xfd"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                    value: "dark",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "dark_mode.dark",
                        defaultMessage: "Tmav\xfd"
                    })
                })
            ]
        })
    });
};


const $1b8a22ea095adc0b$var$Settings = ()=>{
    const { state: state } = (0, $aphAM.useLocation)();
    const snVisibility = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'SERIAL_NUMBER') != '');
    const fronius = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Fronius || inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).FroniusVerto;
    });
    const premium = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'PREMIUM'));
    const multipleWallboxes = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'WB_TYPE') === 'next' && (0, $f1q41.get)(s.variables, 'WB_WALLBOX_CONNECTED_COUNT') > 1);
    const wallboxKeys = (0, $2lSXC.useSelector)((s)=>{
        const config = (0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {};
        return Object.keys(config);
    });
    (0, $acw62.useEffect)(()=>{
        if ((0, $f1q41.get)(state, 'scroll') === 'service') {
            const element = document.getElementById('service');
            if (element) element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f579057103a82b5f$export$6a4327ccdb5e4fea), {
                variant: "settings"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.docs",
                    defaultMessage: "U\u017Eivatelsk\xfd manu\xe1l"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.docs.user_wiki.title",
                            defaultMessage: "U\u017Eivatelsk\xe1 wiki"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.docs.user_wiki.subtitle",
                            defaultMessage: "N\xe1vody, postupy a dal\u0161\xed informace"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "contained",
                            href: "https://infigy.cz/app-redirect/wiki",
                            target: "_blank",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.docs.user_wiki.button",
                                defaultMessage: "P\u0159ej\xedt na wiki"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.photovoltaics.settings",
                    defaultMessage: "Baterie"
                }),
                layout: "list",
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.photovoltaics_auto_settings",
                                defaultMessage: "Automatick\xe9 \u0159\xedzen\xed nabit\xed"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.photovoltaics_auto_settings.subtitle",
                                defaultMessage: "Automatick\xe1 regulace nabit\xed podle ro\u010Dn\xedho obdob\xed"
                            }),
                            switchVariableId: "SOC_AUTO",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.photovoltaics.settings.soc_actual",
                                        defaultMessage: "Vypo\u010Dten\xe9 minim\xe1ln\xed nabit\xed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.soc_actual",
                                            defaultMessage: "Vypo\u010Dten\xe9 minim\xe1ln\xed nabit\xed"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.soc_actual.help",
                                            defaultMessage: "Tato hodnota je automaticky vypo\u010Dtena na z\xe1klad\u011B aktu\xe1ln\xedho stavu. Bu\u010F se \u0159\xedd\xed dle automatick\xe9ho \u0159\xedzen\xed nabit\xed podle ro\u010Dn\xedho obdob\xed, nebo dle manu\xe1ln\xedho nastaven\xed minim\xe1ln\xedho nabit\xed s DS a bez DS. Pokud je zde hodnota 100%, tak je vyb\xedjen\xed baterie zak\xe1zan\xe9, nap\u0159. dle spotov\xe9ho obchodov\xe1n\xed."
                                        })
                                    })
                                ]
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PV_SOC_MIN_FINAL",
                                opts: {
                                    style: 'percent',
                                    maximumFractionDigits: 0
                                }
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.photovoltaics.settings.soc_grid",
                                        defaultMessage: "Minim\xe1ln\xed nabit\xed s DS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.soc_grid",
                                            defaultMessage: "Minim\xe1ln\xed nabit\xed s DS"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.soc_grid.help",
                                            defaultMessage: "Touto hodnotou je mo\u017En\xe9 \u0159\xeddit minim\xe1ln\xed nabit\xed baterie v % SOC p\u0159i dostupn\xe9 distribu\u010Dn\xed s\xedti. U Solax v re\u017Eimu Backup je minim\xe1ln\xed nabit\xed baterie 15%."
                                        })
                                    })
                                ]
                            }),
                            variableId: "PV_SOC_SET_MIN",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: fronius ? 5 : 10
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.photovoltaics.settings.temp_ek",
                                        defaultMessage: "Minim\xe1ln\xed nabit\xed bez DS"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.temp_ek",
                                            defaultMessage: "Minim\xe1ln\xed nabit\xed bez DS"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.photovoltaics.settings.temp_ek.help",
                                            defaultMessage: "Touto hodnotou je mo\u017En\xe9 \u0159\xeddit minim\xe1ln\xed nabit\xed baterie v % SOC p\u0159i v\xfdpadku distribu\u010Dn\xed s\xedt\u011B."
                                        })
                                    })
                                ]
                            }),
                            variableId: "PV_SOC_SET_UTILITY_LOST",
                            visibility: {
                                variableId: 'PV_SOC_SET_UTILITY_LOST_V'
                            },
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: fronius ? 5 : 10,
                            max: 25
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatpump",
                    defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                }),
                layout: "list",
                visibility: {
                    variableId: 'HP_ENABLED'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.priority",
                                defaultMessage: "Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E baterie"
                            }),
                            switchVariableId: "HP_PRIORITY",
                            fullWidth: true,
                            visibility: {
                                variableId: 'HP_ENABLED'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.heatpump.HpBatteryPriority",
                                        defaultMessage: "Procento nab\xedt\xed baterie od kter\xe9ho se zv\xfd\u0161\xed v\xfdkon tepeln\xe9ho \u010Derpadla"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.heatpump.HpBatteryPriority",
                                            defaultMessage: "Procento nab\xedt\xed baterie od kter\xe9ho se zv\xfd\u0161\xed v\xfdkon tepeln\xe9ho \u010Derpadla"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.heatpump.HpBatteryPriority.help",
                                            defaultMessage: "Pokud je nabit\xed baterie ni\u017E\u0161\xed, ne\u017E tato hodnota, priorita akumulace energie je pln\u011B dostupna baterii. Pokud je nabit\xed baterie vy\u0161\u0161\xed, tepeln\xe9 \u010Derpadlo za\u010D\xedn\xe1 p\u0159eb\xedrat prioritu a spou\u0161t\xed oh\u0159ev vody z p\u0159ebyte\u010Dn\xe9 energie FVE - \u010D\xe1st energie jde d\xe1le do baterie do jej\xedho dobit\xed."
                                        })
                                    })
                                ]
                            }),
                            variableId: "PV_OFFSET_SOC_HP_PRIO",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 30,
                            max: 97,
                            visibility: {
                                variableIds: [
                                    {
                                        variableId: 'HP_PRIORITY',
                                        reversed: true
                                    }
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatpump.priority-wb",
                                defaultMessage: "Tepeln\xe9 \u010Derpadlo m\xe1 vy\u0161\u0161\xed prioritu, ne\u017E wallbox"
                            }),
                            switchVariableId: "WB_HP_PRIORITY",
                            fullWidth: true,
                            visibility: {
                                variableId: 'HP_ENABLED'
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.heatwatter",
                    defaultMessage: "Bojler"
                }),
                layout: "list",
                visibility: {
                    variableIds: [
                        'HW_INSTALL'
                    ]
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.boiler.prio",
                                defaultMessage: "Priorita baterie "
                            }),
                            switchVariableId: "HW_BATTERY_PRIO",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.boiler.prio.subtitle",
                                defaultMessage: "Pokud je ON, nejprve se nabij\xed baterie a n\xe1sledn\u011B bojler"
                            }),
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PV_BATTERY',
                                    'PV_BATTERY_CONTROL'
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.boiler.HwBatteryPriority",
                                        defaultMessage: "Procento nab\xedt\xed baterie od kter\xe9ho se za\u010Dne oh\u0159\xedvat bojler"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.boiler.HwBatteryPriority",
                                            defaultMessage: "Procento nab\xedt\xed baterie od kter\xe9ho se za\u010Dne oh\u0159\xedvat bojler"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.boiler.HwBatteryPriority.help",
                                            defaultMessage: "Pokud je nabit\xed baterie ni\u017E\u0161\xed, ne\u017E tato hodnota, priorita akumulace energie je pln\u011B dostupna baterii. Pokud je nabit\xed baterie vy\u0161\u0161\xed, bojler za\u010D\xedn\xe1 p\u0159eb\xedrat prioritu a spou\u0161t\xed oh\u0159ev vody z p\u0159ebyte\u010Dn\xe9 energie FVE - \u010D\xe1st energie jde d\xe1le do baterie do jej\xedho dobit\xed."
                                        })
                                    })
                                ]
                            }),
                            variableId: "PV_OFFSET_SOC_HW_PRIO",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 30,
                            max: 97,
                            visibility: {
                                variableId: 'HW_BATTERY_PRIO'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatwatter.legionella",
                                defaultMessage: "Legionella"
                            }),
                            switchVariableId: "HW_LEGIONELLA_ON",
                            fullWidth: true,
                            visibility: {
                                variableId: 'HW_TEMP_ENABLED'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatwatter.legionella_temp",
                                defaultMessage: "Teplota sanace"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.heatwatter.legionella_temp.subtitle",
                                defaultMessage: "Teplota na kterou se mus\xed minim\xe1ln\u011B 1x za 14 dn\xed bojler nah\u0159\xe1t"
                            }),
                            variableId: "HW_LEGIONELLA_TEMP",
                            visibility: {
                                variableId: 'HW_LEGIONELLA_ON'
                            },
                            max: 85,
                            min: 45,
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 0
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.plug",
                    defaultMessage: "Z\xe1suvky"
                }),
                layout: "list",
                visibility: {
                    variableId: 'PL_INSTALL'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.statusLed",
                                defaultMessage: "Signaliza\u010Dn\xed dioda"
                            }),
                            switchVariableId: "PL_STATUSLED",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PL_INSTALL',
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    }
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.Led",
                                defaultMessage: "Trval\xe9 podsv\xedcen\xed"
                            }),
                            switchVariableId: "PL_LED",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PL_INSTALL',
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    }
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.Led-batt",
                                defaultMessage: "Podsv\xedcen\xed p\u0159i nabit\xe9 baterii"
                            }),
                            switchVariableId: "PL_LED_BAT",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PL_INSTALL',
                                    'PV_BATTERY',
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    }
                                ]
                            },
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.Led-batt.subtitle",
                                defaultMessage: "Podsv\xedcen\xed aktivn\xed, pokud m\xe1 baterie alespo\u0148 95%"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.Led-over",
                                defaultMessage: "Podsv\xedcen\xed p\u0159i p\u0159etoku"
                            }),
                            switchVariableId: "PL_LED_OVER",
                            fullWidth: true,
                            visibility: {
                                variableIds: [
                                    'PL_INSTALL',
                                    {
                                        variableId: 'PL_SHELLY_HW_PLUG',
                                        reversed: true
                                    }
                                ]
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name1",
                                defaultMessage: "N\xe1zev z\xe1suvky 1"
                            }),
                            inputVariableId: "PL_NAME[0]",
                            visibility: {
                                variableId: 'PL_INSTALL'
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name1.label",
                                defaultMessage: "N\xe1zev"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name2",
                                defaultMessage: "N\xe1zev z\xe1suvky 2"
                            }),
                            inputVariableId: "PL_NAME[1]",
                            visibility: {
                                variableId: 'PL_INSTALL_I[1]'
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name2_label",
                                defaultMessage: "N\xe1zev"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name3",
                                defaultMessage: "N\xe1zev z\xe1suvky 3"
                            }),
                            inputVariableId: "PL_NAME[2]",
                            visibility: {
                                variableId: 'PL_INSTALL_I[2]'
                            },
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.plug.name3.label",
                                defaultMessage: "N\xe1zev"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            }),
            multipleWallboxes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.wallbox",
                    defaultMessage: "Wallbox"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: wallboxKeys.map((wallboxKey, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.wallbox.name",
                                defaultMessage: "N\xe1zev wallboxu {number}",
                                values: {
                                    number: index + 1
                                }
                            }),
                            inputVariableId: `WALLBOX_CONFIG.${wallboxKey}.name`,
                            fullWidth: true
                        }, wallboxKey))
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $989522737c85febb$export$8d49512b093ffbd9), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.hdo",
                            defaultMessage: "Nastaven\xed \u010Das\u016F HDO"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.hdo",
                                defaultMessage: "Nastaven\xed \u010Das\u016F HDO"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.hdo.help",
                                defaultMessage: "Nastaven\xed \u010Das\u016F HDO pro v\xfdpo\u010Det cen elekt\u0159iny ve vysok\xe9m a n\xedzk\xe9m tarifu. N\xed\u017Ee je mo\u017En\xe9 zadat \u010Dasy platnosti n\xedzk\xe9ho tarifu."
                            })
                        })
                    ]
                }),
                layout: "list",
                collapsible: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15ab72d8453343b9$export$c21d98c0cce5a4d8), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.device",
                    defaultMessage: "Za\u0159\xedzen\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.device.license",
                                defaultMessage: "Licence za\u0159\xedzen\xed"
                            }),
                            fullWidth: true,
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "LICENSE_STATUS"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.device.id",
                                defaultMessage: "ID za\u0159\xedzen\xed"
                            }),
                            fullWidth: true,
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "DEVICE_ID"
                            })
                        }),
                        snVisibility && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.device.SN",
                                defaultMessage: "S\xe9riov\xe9 \u010D\xedslo"
                            }),
                            fullWidth: true,
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "SERIAL_NUMBER"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.other",
                    defaultMessage: "Ostatn\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.other.languate",
                                defaultMessage: "Jazyk"
                            }),
                            fullWidth: true,
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fa8a06396ffe454$export$aa53e71df758134e), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ean",
                                defaultMessage: "EAN"
                            }),
                            inputVariableId: "EAN_PURCHASE",
                            fullWidth: true,
                            schema: (0, $4c6625c87c7e6d95$export$2308b12144296da2),
                            inputWidth: 250
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.other.readability_mode",
                                defaultMessage: "Velikost p\xedsma"
                            }),
                            fullWidth: true,
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cbe78ff735f0df2e$export$e917bcd07f9c0c68), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.other.dark_mode",
                                defaultMessage: "Tmav\xfd re\u017Eim"
                            }),
                            fullWidth: true,
                            control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d58da9e26a3d9558$export$1b7d54d6dc8d70ad), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce67e5a088fdb8b5$export$a373c8a9d52b5cbc), {}),
                        fronius && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.other.overflow_fronius",
                                defaultMessage: "Maxim\xe1ln\xed p\u0159etok do s\xedt\u011B je omezov\xe1n na stran\u011B Fronius st\u0159\xedda\u010De"
                            }),
                            fullWidth: true,
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.other.overflow_fronius_subtitle",
                                defaultMessage: "Tato hodnota je stanovena distributorem. P\u0159ekro\u010Den\xed t\xe9to hodnoty m\u016F\u017Ee v\xe9st k finan\u010Dn\xedm postih\u016Fm ze strany distributora."
                            })
                        })
                    ]
                })
            }),
            premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $71fbce0a0826b319$export$14a0ab54d106a21d), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.service",
                    defaultMessage: "Servis"
                }),
                layout: "list",
                id: "service",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    sx: {
                        p: 0,
                        bgcolor: (theme)=>theme.palette.mode === 'light' ? theme.palette.text.disabled : '#39393D',
                        '& .group__title': {
                            color: 'common.white'
                        },
                        '& .MuiPaper-root': {
                            boxShadow: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $39c95e32fcc7b0b5$export$1792701c843512d), {})
                })
            })
        ]
    });
};
var $1b8a22ea095adc0b$export$2e2bcd8739ae039 = $1b8a22ea095adc0b$var$Settings;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $aphAM = parcelRequire("aphAM");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");



var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");








var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

const $097ad4ef85a960d6$export$7ba0c1bb76c04981 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi_sp.flexi_reduce_on",
                    defaultMessage: "Odlo\u017Een\xed spot\u0159eby "
                }),
                switchVariableId: "SP_HP_NOW_REDUCE_ON",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi_sp.flexi_reduce_on.subtitle",
                    defaultMessage: "Re\u017Eim umo\u017En\xed odlo\u017Een\xed spot\u0159eby p\u0159i vysok\xe9 cen\u011B energie"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi_sp.flexi_increase_on",
                    defaultMessage: "Zv\xfd\u0161en\xed spot\u0159eby "
                }),
                switchVariableId: "SP_HP_NOW_INCREASE_ON",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi_sp.flexi_increase_on.subtitle",
                    defaultMessage: "Re\u017Eim umo\u017En\xed zv\xfd\u0161en\xed spot\u0159eby p\u0159i n\xedzk\xe9 cen\u011B energie"
                }),
                fullWidth: true
            })
        ]
    });
};


const $5d03d5c33b21fffd$var$HeatPump1 = ()=>{
    const [hpEnabled, ecooneHP] = (0, $2lSXC.useSelector)((s)=>[
            (0, $f1q41.get)(s.variables, 'HP_ENABLED'),
            (0, $f1q41.get)(s.variables, 'HP_TYPE') === 1
        ]);
    const hpAcond = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'HP_TYPE') == 4);
    const hpNibe = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'HP_TYPE') == 2);
    if (!hpEnabled) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "heatpump.status",
                        defaultMessage: "Re\u017Eim tepelka"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0866bf7fb82c359f$export$c8c02a74d96210d1), {}),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heatpump.statistics",
                    defaultMessage: "Statistiky"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "HP_CONSUMED_GRAPH"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.common.temp",
                            defaultMessage: "V\xfdstupn\xed teplota tepeln\xe9ho \u010Derpadla"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HP_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.common.power",
                            defaultMessage: "Aktu\xe1ln\xed odb\u011Br"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HP_ACTUAL_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.common.total",
                            defaultMessage: "Celkov\xe1 spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HP_ENERGY_CONSUMED_TOTAL",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "heat_pump.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_HP_ENERGY_CONSUMED_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "heat_pump.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_HP_ENERGY_CONSUMED_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.room",
                    defaultMessage: "Vyt\xe1p\u011Bn\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        !hpAcond && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.on",
                                defaultMessage: "Vyt\xe1p\u011Bn\xed"
                            }),
                            switchVariableId: "HP_ROOM_ON",
                            fullWidth: true,
                            sx: {
                                mr: 2
                            }
                        }),
                        (ecooneHP || hpAcond) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room_cool.on",
                                defaultMessage: "Chlazen\xed"
                            }),
                            switchVariableId: "HP_ROOM_COOL_ON",
                            visibility: {
                                variableId: 'HP_FLEXI_COOL'
                            },
                            fullWidth: true,
                            sx: {
                                mr: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.temp",
                                defaultMessage: "Aktu\xe1ln\xed teplota m\xedstnosti"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HP_ROOM_TEMP",
                                opts: {
                                    style: 'unit',
                                    unit: 'celsius',
                                    maximumFractionDigits: 1,
                                    minimumFractionDigits: 1
                                }
                            }),
                            visibility: {
                                variableId: 'HP_ROOM_TEMP_V'
                            },
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdd94ff560015fde$export$1027d4534a5ce60b), {})
                        }),
                        !hpAcond && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.tempmin",
                                defaultMessage: "Po\u017Eadovan\xe1 teplota \xfatlum"
                            }),
                            variableId: "HP_ROOM_SET_TEMP_MIN",
                            visibility: {
                                variableId: 'HP_ROOM_TEMP_V'
                            },
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.5,
                            min: 10,
                            max: 35
                        }),
                        !hpAcond && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.tempmax",
                                defaultMessage: "Po\u017Eadovan\xe1 teplota komfort"
                            }),
                            variableId: "HP_ROOM_SET_TEMP_MAX",
                            visibility: {
                                variableId: 'HP_ROOM_TEMP_V'
                            },
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.5,
                            min: 10,
                            max: 35
                        }),
                        hpAcond && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.tem",
                                defaultMessage: "Po\u017Eadovan\xe1 teplota"
                            }),
                            variableId: "HP_ROOM_SET_TEMP_MIN",
                            visibility: {
                                variableId: 'HP_ROOM_TEMP_V'
                            },
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.5,
                            min: 10,
                            max: 35
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.flexitemp",
                                defaultMessage: "Flexibiln\xed teplota"
                            }),
                            variableId: "HP_ROOM_SET_FLEXI_TEMP",
                            visibility: {
                                variableId: 'HP_FLEXI_ROOM'
                            },
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.flexitemp.subtitle",
                                defaultMessage: "Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t nebo p\u0159edchladit d\u016Fm"
                            }),
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.2,
                            min: 0,
                            max: 10
                        }),
                        ecooneHP && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.room.equithermalCorrection",
                                defaultMessage: "Posun topn\xe9 k\u0159ivky"
                            }),
                            variableId: "HP_EQUITHERMAL_CORRECTION",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.5,
                            min: -10,
                            max: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.HW",
                    defaultMessage: "Oh\u0159ev tepl\xe9 vody"
                }),
                visibility: {
                    variableId: 'HP_HW_TEMP_V'
                },
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        !hpAcond && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.on",
                                defaultMessage: "Oh\u0159ev tepl\xe9 vody"
                            }),
                            switchVariableId: "HP_HW_ON",
                            visibility: {
                                variableId: 'HP_HW_TEMP_V'
                            },
                            fullWidth: true,
                            sx: {
                                mr: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.actual_temp",
                                defaultMessage: "Aktu\xe1ln\xed teplota n\xe1dr\u017Ee"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HP_HW_TEMP",
                                opts: {
                                    style: 'unit',
                                    unit: 'celsius',
                                    maximumFractionDigits: 1,
                                    minimumFractionDigits: 1
                                }
                            }),
                            visibility: {
                                variableId: 'HP_HW_TEMP_V'
                            },
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.temp",
                                defaultMessage: "Po\u017Eadovan\xe1 teplota n\xe1dr\u017Ee"
                            }),
                            variableId: "HP_HW_SET_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.5,
                            min: 10,
                            max: 60
                        }),
                        hpNibe && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.hysteresis",
                                defaultMessage: "Hystereze oh\u0159evu tepl\xe9 vody"
                            }),
                            variableId: "HP_HW_TEMP_HYST",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 1,
                            min: 5,
                            max: 15
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.flexitemp",
                                defaultMessage: "Flexibiln\xed teplota"
                            }),
                            variableId: "HP_HW_SET_FLEXI_TEMP",
                            visibility: {
                                variableId: 'HP_FLEXI_HW'
                            },
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "heat_pump.HW.flexitemp.subtitle",
                                defaultMessage: "Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t teplou vodu"
                            }),
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 1
                            },
                            step: 0.2,
                            min: 0,
                            max: 20
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi",
                    defaultMessage: "Flexibilita energie"
                }),
                layout: "list",
                visibility: {
                    variableId: 'PV_INSTALL'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.flexi.flexi_on",
                            defaultMessage: "Re\u017Eim flexibility "
                        }),
                        switchVariableId: "HP_FLEXIBILITY_ON",
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.flexi.flexi_on.subtitle",
                            defaultMessage: "Re\u017Eim aktivuje p\u0159edeh\u0159ev z p\u0159ebytkov\xe9 energie"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        visibility: {
                            variableId: 'HP_FLEXIBILITY_ON'
                        },
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.flexi.pvstability",
                            defaultMessage: "Potenci\xe1l aktivace kompresoru"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "HP_PV_STABILITY",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.flexi_sp",
                    defaultMessage: "Flexibilita spot"
                }),
                layout: "list",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $097ad4ef85a960d6$export$7ba0c1bb76c04981), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "heat_pump.blocked",
                    defaultMessage: "Blokace kompresoru"
                }),
                layout: "list",
                visibility: {
                    variableIds: [
                        'PV_BATTERY',
                        'HP_ECOONE'
                    ]
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.blocked.min_soc",
                            defaultMessage: "Blokace kompresoru p\u0159i nedostupn\xe9 s\xedti"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.blocked.subtitle",
                            defaultMessage: "Nabit\xed baterie, od kter\xe9ho dojde k blokaci kompresoru p\u0159i v\xfdpadku s\xedt\u011B"
                        }),
                        variableId: "HP_SOC_STOP",
                        max: 100,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.blocked.min_soc_utility",
                            defaultMessage: "Blokace kompresoru p\u0159i dostupn\xe9 s\xedti"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "heat_pump.blocked.subtitle",
                            defaultMessage: "Nabit\xed baterie, od kter\xe9ho dojde k blokaci kompresoru p\u0159i dostupn\xe9 s\xedti"
                        }),
                        variableId: "HP_SOC_STOP_UTILITY",
                        max: 100,
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        }
                    })
                ]
            })
        ]
    });
};
var $5d03d5c33b21fffd$export$2e2bcd8739ae039 = $5d03d5c33b21fffd$var$HeatPump1;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $a8gr9 = parcelRequire("a8gr9");
const $7c699509f9e2a76c$export$de01b345748fab4b = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8gr9.ArrowRight), {
        ...props,
        sx: {
            transform: 'rotate(90deg)',
            ...props.sx || {}
        }
    });



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $a8gr9 = parcelRequire("a8gr9");
const $69287d642341bb09$export$dc728e82a0944241 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8gr9.ArrowRight), {
        ...props,
        sx: {
            transform: 'rotate(-90deg)',
            ...props.sx || {}
        }
    });




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $aZOrF = parcelRequire("aZOrF");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");






var $aZOrF = parcelRequire("aZOrF");
const $915bad7549ce262b$export$4066cbe4b7657cb6 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery_charge",
                            defaultMessage: "Povoleno nab\xedjen\xed baterie podle spotu"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_charge",
                                defaultMessage: "Povoleno nab\xedjen\xed baterie podle spotu"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_charge.help",
                                defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje nab\xedjen\xed v dob\u011B nejni\u017E\u0161\xedch cen. Bere v potaz aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie a jej\xed kapacitu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nab\xedjen\xed tak, aby do\u0161lo k jej\xedmu nabit\xed za co nejni\u017E\u0161\xed cenu."
                            })
                        })
                    ]
                }),
                switchVariableId: "SP_BATTERY_CONTROL_CUSTOMER",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_charge.subtitle",
                    defaultMessage: "\u0158\xedzen\xed baterie podle spotu zv\xfd\u0161\xed amortizaci baterie"
                }),
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'SP_BATTERY_CONTROL_SERVICE',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery_strategy",
                            defaultMessage: "Strategie spotov\xe9ho nab\xedjen\xed baterie"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_strategy",
                                defaultMessage: "Strategie spotov\xe9ho nab\xedjen\xed baterie"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_strategy.help",
                                defaultMessage: "T\xedmto posuvn\xedkem m\u016F\u017Eete jednodu\u0161e nastavit preferenci vyu\u017Eit\xed baterie p\u0159i spotov\xe9m obchodov\xe1n\xed. Ni\u017E\u0161\xed hodnoty (od 20 %) znamenaj\xed men\u0161\xed cyklov\xe1n\xed baterie a tedy m\xe9n\u011B \u010Dast\xe9 nab\xedjen\xed/vyb\xedjen\xed za spotov\xe9 ceny. Vy\u0161\u0161\xed hodnoty (a\u017E do 70 %) zna\u010D\xed opak."
                            })
                        })
                    ]
                }),
                variableId: "SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_strategy_user.subtitle",
                    defaultMessage: "20 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro FVE. 70 % = Sp\xed\u0161e vyu\u017E\xedvat baterii pro Spot."
                }),
                opts: {
                    style: 'percent',
                    maximumFractionDigits: 0
                },
                min: 20,
                max: 70,
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'SP_BATTERY_CONTROL_CUSTOMER',
                        'SP_BATTERY_CONTROL_SERVICE',
                        'SP_USER_ADVANCED_CONTROL',
                        'PV_BATTERY_CONTROL'
                    ]
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.spot.battery_max_soc",
                        defaultMessage: "Fin\xe1ln\xed SOC baterie"
                    })
                }),
                variableId: "SP_CHARGE_BATTERY_FINAL_SOC_MAX",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_max_soc.subtitle",
                    defaultMessage: "Maxim\xe1ln\xed nabit\xed baterie p\u0159i nab\xedjen\xed ze s\xedt\u011B"
                }),
                opts: {
                    style: 'percent',
                    maximumFractionDigits: 0
                },
                min: 20,
                max: 100,
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'SP_BATTERY_CONTROL_CUSTOMER',
                        'SP_BATTERY_CONTROL_SERVICE',
                        'PV_BATTERY_CONTROL'
                    ]
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                type: "row",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.min_difference_price_charge_from_grid",
                            defaultMessage: "Minim\xe1ln\xed rozd\xedl ceny na spotu pro nab\xedjen\xed baterie ze s\xedt\u011B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.min_difference_price_charge_from_grid",
                                defaultMessage: "Minim\xe1ln\xed rozd\xedl ceny na spotu pro nab\xedjen\xed baterie ze s\xedt\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.min_difference_price_charge_from_grid.help",
                                defaultMessage: "T\xedmto parametrem je mo\u017En\xe9 \u0159\xeddit nab\xedjen\xed baterie ze spotu p\u0159i n\xedzk\xe9m rozd\xedlu mezi nejni\u017E\u0161\xed a nejvy\u0161\u0161\xed cenou. Pokud je parametr 2 K\u010D a rozd\xedl mezi nejvy\u0161\u0161\xed cenou (3 K\u010D) a nejni\u017E\u0161\xed cenou (1 K\u010D) spotu je ni\u017E\u0161\xed, tak se v tento den nab\xedjen\xed baterie ze s\xedt\u011B nenapl\xe1nuje. Tento parametr je mo\u017En\xe9 editovat jen v servisn\xedm menu."
                            })
                        })
                    ]
                }),
                value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                    variableId: "SP_MIN_SPOT_DIFFERENCE_PRICE",
                    opts: {
                        style: 'currency'
                    }
                }),
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'SP_BATTERY_CONTROL_CUSTOMER',
                        'SP_BATTERY_CONTROL_SERVICE',
                        'PV_BATTERY_CONTROL'
                    ]
                }
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $aZOrF = parcelRequire("aZOrF");
const $dcbef18988b701ff$export$23d480672c585e59 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery.stop_discharge_low_price",
                            defaultMessage: "Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 cen\u011B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery.stop_discharge_low_price",
                                defaultMessage: "Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 cen\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery.stop_discharge_low_price.help",
                                defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak p\u0159i n\xedzk\xe9 cen\u011B spotu se nebude vyu\u017E\xedvat energie z baterie. Syst\xe9m nebude baterii vyb\xedjet ani do spot\u0159eby objektu. Ta se vyu\u017Eije p\u0159i vy\u0161\u0161\xedch cen\xe1ch (st\u0159edn\xed a vysok\xe1 cena)."
                            })
                        })
                    ]
                }),
                switchVariableId: "SP_BATTERY_STOP_DISCHARGE_LOW_PRICE",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery.stop_discharge_low_price.subtitle",
                    defaultMessage: "\u0158\xedzen\xed uschov\xe1 energii na st\u0159edn\xed a vysokou cenu energie"
                }),
                visibility: {
                    variableIds: [
                        {
                            variableId: 'SP_BATTERY_STOP_DISCHARGE_AUTO',
                            reversed: true
                        },
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery.stop_discharge_high_price",
                            defaultMessage: "Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 a st\u0159edn\xed cen\u011B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery.stop_discharge_high_price",
                                defaultMessage: "Z\xe1kaz vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 a st\u0159edn\xed cen\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery.stop_discharge_high_price.help",
                                defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak p\u0159i n\xedzk\xe9 a st\u0159edn\xed cen\u011B spotu se nebude vyu\u017E\xedvat energie z baterie. Syst\xe9m nebude baterii vyb\xedjet ani do spot\u0159eby objektu. Ta se vyu\u017Eije p\u0159i vy\u0161\u0161\xedch cen\xe1ch."
                            })
                        })
                    ]
                }),
                switchVariableId: "SP_BATTERY_STOP_DISCHARGE_MIDDLE_PRICE",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery.stop_discharge_middle_price.subtitle",
                    defaultMessage: "\u0158\xedzen\xed uschov\xe1 energii na vysokou cenu energie"
                }),
                visibility: {
                    variableIds: [
                        {
                            variableId: 'SP_BATTERY_STOP_DISCHARGE_AUTO',
                            reversed: true
                        },
                        'SP_INSTALL',
                        'PV_BATTERY',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                fullWidth: true
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");



var $aZOrF = parcelRequire("aZOrF");
const $f705ec7ee0a95c57$export$6288f0782a550253 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "settings.spot.overflow",
                        defaultMessage: "Povolit optimalizaci p\u0159etoku podle spotu"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                        variant: "dialog",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.overflow",
                            defaultMessage: "Povolit optimalizaci p\u0159etoku podle spotu"
                        }),
                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.overflow.help",
                            defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m up\u0159ednostn\xed p\u0159etok do s\xedt\u011B p\u0159ed nab\xedjen\xedm baterie v dob\u011B vy\u0161\u0161\xedch a st\u0159edn\xedch spotov\xfdch cen. D\u011Bje se pouze v ro\u010Dn\xedch obdob\xedch, ve kter\xfdch p\u0159edpokl\xe1d\xe1me p\u0159ebytek energie z FVE a doch\xe1z\xed k tomu zpravidla r\xe1no. Optimalizace neprob\xedh\xe1 v n\xedzk\xfdch spotov\xfdch cen\xe1ch, kdy je prioritou nab\xedjen\xed baterie z FVE."
                        })
                    })
                ]
            }),
            switchVariableId: "SP_OVERFLOW_OPTIMALIZATION",
            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "settings.spot.overflow.subtitle",
                defaultMessage: "Umo\u017En\xed up\u0159ednostn\u011Bn\xed p\u0159etoku p\u0159ed akumulac\xed"
            }),
            visibility: {
                variableIds: [
                    'SP_INSTALL',
                    'PV_OVERFLOW_CONTROL'
                ]
            },
            fullWidth: true
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");




var $aZOrF = parcelRequire("aZOrF");
const $f03d73cb2c53c177$export$d0848bdd84e94d46 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery_overflow",
                            defaultMessage: "Povolit vyb\xedjen\xed baterie do s\xedt\u011B podle spotu"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_overflow",
                                defaultMessage: "Povolit vyb\xedjen\xed baterie do s\xedt\u011B podle spotu"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_overflow.help",
                                defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m napl\xe1nuje vyb\xedjen\xed baterie do s\xedt\u011B v dob\u011B nejvy\u0161\u0161\xed denn\xed ceny a vybije jen tu energii, kter\xe1 nebude pot\u0159eba na b\u011B\u017Enou spot\u0159ebu objektu. Parametry n\xed\u017Ee je mo\u017En\xe9 definovat v\xfd\u0161i ceny pro vyb\xedt\xed cel\xe9 kapacity baterie a vyb\xedt\xed jen t\xe9 \u010D\xe1sti kapacity baterie, kter\xe1 nebude pot\u0159eba pro no\u010Dn\xed spot\u0159ebu. "
                            })
                        })
                    ]
                }),
                switchVariableId: "SP_DISCHARGE_TO_GRID",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_overflow.subtitle",
                    defaultMessage: "Umo\u017En\xed vyb\xedt nadbytek energie z baterie do s\xedt\u011B v nejv\xfdhodn\u011Bj\u0161\xed hodinu"
                }),
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'SP_DISCHARGE_TO_GRID_SER',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery_overflow_price",
                            defaultMessage: "Minim\xe1ln\xed cena pro vyb\xedjen\xed baterie do s\xedt\u011B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_overflow_price",
                                defaultMessage: "Minim\xe1ln\xed cena pro vyb\xedjen\xed baterie do s\xedt\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_overflow_price.help",
                                defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed pouze p\u0159ebyte\u010Dn\xe9 kapacity baterie do s\xedt\u011B. Znamen\xe1 to tedy, \u017Ee v baterii uchov\xe1v\xe1me energii pro no\u010Dn\xed a rann\xed spot\u0159ebu objektu. Nebude tedy doch\xe1zet k nakupov\xe1n\xed energie ze s\xedt\u011B"
                            })
                        })
                    ]
                }),
                variableId: "SP_DISCHARGE_TO_GRID_MIN_PRICE",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_overflow_price.subtitle",
                    defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed pouze p\u0159ebyte\u010Dn\xe9 kapacity baterie do s\xedt\u011B"
                }),
                opts: {
                    style: 'currency'
                },
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'SP_DISCHARGE_TO_GRID',
                        'SP_DISCHARGE_TO_GRID_SER',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                min: {
                    CZK: 2,
                    EUR: 0.1
                },
                max: {
                    CZK: 20,
                    EUR: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery_all_overflow_price",
                            defaultMessage: "Minim\xe1ln\xed cena pro vyb\xedjen\xed cel\xe9 kapacity baterie do s\xedt\u011B"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_all_overflow_price",
                                defaultMessage: "Minim\xe1ln\xed cena pro vyb\xedjen\xed cel\xe9 kapacity baterie do s\xedt\u011B"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.spot.battery_all_overflow_price.help",
                                defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed kapacity baterie do s\xedt\u011B a\u017E do nastaven\xe9ho minim\xe1ln\xedho SOC. Znamen\xe1 to tedy, \u017Ee v baterii nebude uchov\xe1na energie pro no\u010Dn\xed a rann\xed spot\u0159ebu. Po vybit\xed baterie do s\xedt\u011B se bude pro spot\u0159ebu objektu nakupovat energie ze s\xedt\u011B"
                            })
                        })
                    ]
                }),
                variableId: "SP_DISCHARGE_ALL_TO_GRID_MIN_PRICE",
                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "settings.spot.battery_all_overflow_price.subtitle",
                    defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed ne\u017E tato hodnota, dojde v t\xe9 dob\u011B k vyb\xedjen\xed kapacity baterie do s\xedt\u011B a\u017E do nastaven\xe9ho minim\xe1ln\xedho SOC"
                }),
                opts: {
                    style: 'currency'
                },
                visibility: {
                    variableIds: [
                        'SP_INSTALL',
                        'SP_DISCHARGE_TO_GRID',
                        'SP_DISCHARGE_TO_GRID_SER',
                        'PV_BATTERY_CONTROL'
                    ]
                },
                min: {
                    CZK: 5,
                    EUR: 0.25
                },
                max: {
                    CZK: 20,
                    EUR: 1
                }
            })
        ]
    });
};


const $fd71b4952db748b0$export$9b203cb7511ea22b = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fc89740a40a9451$export$af551370f369b7df), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9ab324d1199a267$export$59ba75a4d6ef29cf), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $915bad7549ce262b$export$4066cbe4b7657cb6), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "settings.spot.battery.stop_discharge_auto",
                                    defaultMessage: "Automatick\xe9 \u0159\xedzen\xed z\xe1kazu vyb\xedjen\xed"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                    variant: "dialog",
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.spot.battery.stop_discharge_auto",
                                        defaultMessage: "Automatick\xe9 \u0159\xedzen\xed z\xe1kazu vyb\xedjen\xed"
                                    }),
                                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "settings.spot.battery.stop_discharge_auto.help",
                                        defaultMessage: "Pokud zvol\xedte tuto mo\u017Enost, tak syst\xe9m automaticky bude \u0159\xeddit vyb\xedjen\xed baterie a povol\xed ho pouze p\u0159i nejvy\u0161\u0161\xedch denn\xedch cen\xe1ch na spotu."
                                    })
                                })
                            ]
                        }),
                        switchVariableId: "SP_BATTERY_STOP_DISCHARGE_AUTO",
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "settings.spot.battery.stop_discharge_auto.subtitle",
                            defaultMessage: "\u0158\xedzen\xed uschov\xe1 energii automaticky na nejdra\u017E\u0161\xed hodiny."
                        }),
                        visibility: {
                            variableIds: [
                                'SP_INSTALL',
                                'PV_BATTERY',
                                'SP_BATTERY_STOP_DISCHARGE_AUTO_DEV',
                                'PV_BATTERY_CONTROL'
                            ]
                        },
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcbef18988b701ff$export$23d480672c585e59), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f705ec7ee0a95c57$export$6288f0782a550253), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f03d73cb2c53c177$export$d0848bdd84e94d46), {})
        ]
    });
};



var $aZOrF = parcelRequire("aZOrF");

var $2lSXC = parcelRequire("2lSXC");

var $f1q41 = parcelRequire("f1q41");

var $8ni7a = parcelRequire("8ni7a");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");
var $50735c891600d15e$exports = {};
Object.defineProperty($50735c891600d15e$exports, "__esModule", {
    value: !0
});

var $acw62 = parcelRequire("acw62");
var $23afc4ba69f19a2b$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $23afc4ba69f19a2b$exports = factory();
})($23afc4ba69f19a2b$exports, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                var Rive = (()=>{
                    var _scriptName = typeof document != 'undefined' ? document.currentScript?.src : undefined;
                    return function(moduleArg = {}) {
                        var moduleRtn;
                        var l = moduleArg, aa, ba, ca = new Promise((a, b)=>{
                            aa = a;
                            ba = b;
                        }), da = "object" == typeof window, ea = "function" == typeof importScripts;
                        function fa() {
                            function a(g) {
                                const k = d;
                                c = b = 0;
                                d = new Map();
                                k.forEach((m)=>{
                                    try {
                                        m(g);
                                    } catch (n) {
                                        console.error(n);
                                    }
                                });
                                this.mb();
                                e && e.Mb();
                            }
                            let b = 0, c = 0, d = new Map(), e = null, f = null;
                            this.requestAnimationFrame = function(g) {
                                b ||= requestAnimationFrame(a.bind(this));
                                const k = ++c;
                                d.set(k, g);
                                return k;
                            };
                            this.cancelAnimationFrame = function(g) {
                                d.delete(g);
                                b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
                            };
                            this.Kb = function(g) {
                                f && (document.body.remove(f), f = null);
                                g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(k) {
                                    f.innerHTML = "RIVE FPS " + k.toFixed(1);
                                }, document.body.appendChild(f));
                                e = new function() {
                                    let k = 0, m = 0;
                                    this.Mb = function() {
                                        var n = performance.now();
                                        m ? (++k, n -= m, 1000 < n && (g(1000 * k / n), k = m = 0)) : (m = n, k = 0);
                                    };
                                }();
                            };
                            this.mb = function() {};
                        }
                        function ha() {
                            console.assert(!0);
                            const a = new Map();
                            let b = -Infinity;
                            this.push = function(c) {
                                c = c + 255 >> 8;
                                a.has(c) && clearTimeout(a.get(c));
                                a.set(c, setTimeout(function() {
                                    a.delete(c);
                                    0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
                                }, 1000));
                                b = Math.max(c, b);
                                return b << 8;
                            };
                        }
                        const ia = l.onRuntimeInitialized;
                        l.onRuntimeInitialized = function() {
                            ia && ia();
                            let a = l.decodeAudio;
                            l.decodeAudio = function(e, f) {
                                e = a(e);
                                f(e);
                            };
                            let b = l.decodeFont;
                            l.decodeFont = function(e, f) {
                                e = b(e);
                                f(e);
                            };
                            const c = l.FileAssetLoader;
                            l.ptrToAsset = (e)=>{
                                let f = l.ptrToFileAsset(e);
                                return f.isImage ? l.ptrToImageAsset(e) : f.isFont ? l.ptrToFontAsset(e) : f.isAudio ? l.ptrToAudioAsset(e) : f;
                            };
                            l.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {
                                __construct: function({ loadContents: e }) {
                                    this.__parent.__construct.call(this);
                                    this.Bb = e;
                                },
                                loadContents: function(e, f) {
                                    e = l.ptrToAsset(e);
                                    return this.Bb(e, f);
                                }
                            });
                            l.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function(e) {
                                    let f = l.ptrToAsset(e);
                                    e = f.cdnUuid;
                                    if ("" === e) return !1;
                                    (function(g, k) {
                                        var m = new XMLHttpRequest();
                                        m.responseType = "arraybuffer";
                                        m.onreadystatechange = function() {
                                            4 == m.readyState && 200 == m.status && k(m);
                                        };
                                        m.open("GET", g, !0);
                                        m.send(null);
                                    })(f.cdnBaseUrl + "/" + e, (g)=>{
                                        f.decode(new Uint8Array(g.response));
                                    });
                                    return !0;
                                }
                            });
                            l.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.ib = [];
                                },
                                addLoader: function(e) {
                                    this.ib.push(e);
                                },
                                loadContents: function(e, f) {
                                    for (let g of this.ib){
                                        if (g.loadContents(e, f)) return !0;
                                    }
                                    return !1;
                                }
                            });
                            let d = l.computeAlignment;
                            l.computeAlignment = function(e, f, g, k, m = 1.0) {
                                return d.call(this, e, f, g, k, m);
                            };
                        };
                        const ja = l.onRuntimeInitialized;
                        l.onRuntimeInitialized = function() {
                            function a(r) {
                                this.G = r;
                                this.Ab = r.getContext("2d");
                                this.Db = d;
                                this.S = [];
                                this.ka = 0;
                                this.clear = function() {
                                    console.assert(0 == this.ka);
                                    this.S = [];
                                    e.delete(this);
                                };
                                this.save = function() {
                                    ++this.ka;
                                    this.S.push(d.save.bind(d));
                                };
                                this.restore = function() {
                                    0 < this.ka && (this.S.push(d.restore.bind(d)), --this.ka);
                                };
                                this.transform = function(u) {
                                    this.S.push(d.transform.bind(d, u));
                                };
                                this.align = function(u, z, A, C, G = 1.0) {
                                    this.S.push(d.align.bind(d, u, z, A, C, G));
                                };
                                this.flush = function() {
                                    console.assert(0 == this.ka);
                                    e.add(this);
                                    d.Ya || c();
                                };
                                this["delete"] = function() {};
                            }
                            function b(r, u = !1) {
                                var z = {
                                    alpha: !0,
                                    depth: u,
                                    stencil: u,
                                    antialias: u,
                                    premultipliedAlpha: !0,
                                    preserveDrawingBuffer: 0,
                                    powerPreference: "high-performance",
                                    failIfMajorPerformanceCaveat: 0,
                                    enableExtensionsByDefault: !1,
                                    explicitSwapControl: 0,
                                    renderViaOffscreenBackBuffer: 0
                                };
                                u = r.getContext("webgl2", z);
                                if (!u) return null;
                                z = ka(u, z);
                                la(z);
                                const A = f(r.width, r.height);
                                A.La = z;
                                A.G = r;
                                A.Ma = r.width;
                                A.Za = r.height;
                                A.T = u;
                                var C = A.delete;
                                A.delete = function() {
                                    C.call(this);
                                    var G = this.La;
                                    q === w[G] && (q = null);
                                    "object" == typeof JSEvents && JSEvents.Kc(w[G].C.canvas);
                                    w[G] && w[G].C.canvas && (w[G].C.canvas.zb = void 0);
                                    this.La = this.G = this.Ma = this.T = w[G] = null;
                                };
                                return A;
                            }
                            function c() {
                                if (d) {
                                    var r = d.Cb, u = 0, z = 0, A = 0, C = Array(e.size), G = 0;
                                    for (var J of e)J.fa = Math.min(J.G.width, r), J.ea = Math.min(J.G.height, r), J.Ja = J.ea * J.fa, u = Math.max(u, J.fa), z = Math.max(z, J.ea), A += J.Ja, C[G++] = J;
                                    e.clear();
                                    if (!(0 >= A)) {
                                        u = 1 << (0 >= u ? 0 : 32 - Math.clz32(u - 1));
                                        for(z = 1 << (0 >= z ? 0 : 32 - Math.clz32(z - 1)); z * u < A;)u <= z ? u *= 2 : z *= 2;
                                        u = Math.min(u, r);
                                        u = Math.min(z, r);
                                        C.sort((Z, nb)=>nb.Ja - Z.Ja);
                                        A = new l.DynamicRectanizer(r);
                                        for(J = 0; J < C.length;){
                                            A.reset(u, z);
                                            for(G = J; G < C.length; ++G){
                                                var K = C[G], I = A.addRect(K.fa, K.ea);
                                                if (0 > I) {
                                                    console.assert(G > J);
                                                    break;
                                                }
                                                K.qa = I & 65535;
                                                K.ra = I >> 16;
                                            }
                                            K = m.push(A.drawWidth());
                                            I = n.push(A.drawHeight());
                                            console.assert(K >= A.drawWidth());
                                            console.assert(I >= A.drawHeight());
                                            console.assert(K <= r);
                                            console.assert(I <= r);
                                            d.G.width != K && (d.G.width = K);
                                            d.G.height != I && (d.G.height = I);
                                            d.clear();
                                            for(K = J; K < G; ++K){
                                                I = C[K];
                                                d.saveClipRect(I.qa, I.ra, I.qa + I.fa, I.ra + I.ea);
                                                let Z = new l.Mat2D();
                                                Z.xx = I.fa / I.G.width;
                                                Z.yy = I.ea / I.G.height;
                                                Z.xy = Z.yx = 0;
                                                Z.tx = I.qa;
                                                Z.ty = I.ra;
                                                d.transform(Z);
                                                for (const nb of I.S)nb();
                                                d.restoreClipRect();
                                                I.S = [];
                                            }
                                            for(d.flush(); J < G; ++J)K = C[J], I = K.Ab, I.globalCompositeOperation = "copy", I.drawImage(d.G, K.qa, K.ra, K.fa, K.ea, 0, 0, K.G.width, K.G.height);
                                            J = G;
                                        }
                                    }
                                }
                            }
                            ja && ja();
                            let d = null;
                            const e = new Set(), f = l.makeRenderer;
                            l.makeRenderer = function(r, u) {
                                if (!d) {
                                    function z(A) {
                                        var C = document.createElement("canvas");
                                        C.width = 1;
                                        C.height = 1;
                                        d = b(C, A);
                                        d.Ya = !!d.T.getExtension("WEBGL_shader_pixel_local_storage");
                                        d.Cb = Math.min(d.T.getParameter(d.T.MAX_RENDERBUFFER_SIZE), d.T.getParameter(d.T.MAX_TEXTURE_SIZE));
                                        d.Ka = !d.Ya;
                                        if (A = d.T.getExtension("WEBGL_debug_renderer_info")) C = d.T.getParameter(A.UNMASKED_RENDERER_WEBGL), d.T.getParameter(A.UNMASKED_VENDOR_WEBGL).includes("Google") && C.includes("ANGLE Metal Renderer") && (d.Ka = !1);
                                        return d;
                                    }
                                    d = z(!0);
                                    d.Ka || (d = z(!1));
                                }
                                return u ? new a(r) : b(r, d.Ka);
                            };
                            const g = l.Artboard.prototype["delete"];
                            l.Artboard.prototype["delete"] = function() {
                                this.Eb = !0;
                                g.call(this);
                            };
                            const k = l.Artboard.prototype.draw;
                            l.Artboard.prototype.draw = function(r) {
                                r.S ? r.S.push(()=>{
                                    this.Eb || k.call(this, r.Db);
                                }) : k.call(this, r);
                            };
                            const m = new ha(), n = new ha(), t = new fa();
                            l.requestAnimationFrame = t.requestAnimationFrame.bind(t);
                            l.cancelAnimationFrame = t.cancelAnimationFrame.bind(t);
                            l.enableFPSCounter = t.Kb.bind(t);
                            t.mb = c;
                            l.resolveAnimationFrame = c;
                            let v = l.load;
                            l.load = function(r, u, z = !0) {
                                const A = new l.FallbackFileAssetLoader();
                                void 0 !== u && A.addLoader(u);
                                z && (u = new l.CDNFileAssetLoader(), A.addLoader(u));
                                return Promise.resolve(v(r, A));
                            };
                            const x = l.WebGL2Renderer.prototype.clear;
                            l.WebGL2Renderer.prototype.clear = function() {
                                la(this.La);
                                const r = this.G;
                                if (this.Ma != r.width || this.Za != r.height) this.resize(r.width, r.height), this.Ma = r.width, this.Za = r.height;
                                x.call(this);
                            };
                            l.decodeImage = function(r, u) {
                                r = l.decodeWebGL2Image(r);
                                u(r);
                            };
                            let p = l.Renderer.prototype.align;
                            l.Renderer.prototype.align = function(r, u, z, A, C = 1.0) {
                                p.call(this, r, u, z, A, C);
                            };
                        };
                        var ma = Object.assign({}, l), na = "./this.program", y = "", oa, pa;
                        if (da || ea) ea ? y = self.location.href : "undefined" != typeof document && document.currentScript && (y = document.currentScript.src), _scriptName && (y = _scriptName), y.startsWith("blob:") ? y = "" : y = y.substr(0, y.replace(/[?#].*/, "").lastIndexOf("/") + 1), ea && (pa = (a)=>{
                            var b = new XMLHttpRequest();
                            b.open("GET", a, !1);
                            b.responseType = "arraybuffer";
                            b.send(null);
                            return new Uint8Array(b.response);
                        }), oa = (a, b, c)=>{
                            if (qa(a)) {
                                var d = new XMLHttpRequest();
                                d.open("GET", a, !0);
                                d.responseType = "arraybuffer";
                                d.onload = ()=>{
                                    200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
                                };
                                d.onerror = c;
                                d.send(null);
                            } else fetch(a, {
                                credentials: "same-origin"
                            }).then((e)=>e.ok ? e.arrayBuffer() : Promise.reject(Error(e.status + " : " + e.url))).then(b, c);
                        };
                        var ra = l.print || console.log.bind(console), sa = l.printErr || console.error.bind(console);
                        Object.assign(l, ma);
                        ma = null;
                        l.thisProgram && (na = l.thisProgram);
                        var ta;
                        l.wasmBinary && (ta = l.wasmBinary);
                        var ua, va = !1, B, D, E, wa, F, H, xa, ya;
                        function za() {
                            var a = ua.buffer;
                            l.HEAP8 = B = new Int8Array(a);
                            l.HEAP16 = E = new Int16Array(a);
                            l.HEAPU8 = D = new Uint8Array(a);
                            l.HEAPU16 = wa = new Uint16Array(a);
                            l.HEAP32 = F = new Int32Array(a);
                            l.HEAPU32 = H = new Uint32Array(a);
                            l.HEAPF32 = xa = new Float32Array(a);
                            l.HEAPF64 = ya = new Float64Array(a);
                        }
                        var Aa = [], Ba = [], Ca = [];
                        function Da() {
                            var a = l.preRun.shift();
                            Aa.unshift(a);
                        }
                        var Ea = 0, Fa = null, Ga = null;
                        function Ha(a) {
                            l.onAbort?.(a);
                            a = "Aborted(" + a + ")";
                            sa(a);
                            va = !0;
                            a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
                            ba(a);
                            throw a;
                        }
                        var Ia = (a)=>a.startsWith("data:application/octet-stream;base64,"), qa = (a)=>a.startsWith("file://"), Ja;
                        function Ka(a) {
                            if (a == Ja && ta) return new Uint8Array(ta);
                            if (pa) return pa(a);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function La(a) {
                            return ta ? Promise.resolve().then(()=>Ka(a)) : new Promise((b, c)=>{
                                oa(a, (d)=>b(new Uint8Array(d)), ()=>{
                                    try {
                                        b(Ka(a));
                                    } catch (d) {
                                        c(d);
                                    }
                                });
                            });
                        }
                        function Ma(a, b, c) {
                            return La(a).then((d)=>WebAssembly.instantiate(d, b)).then(c, (d)=>{
                                sa(`failed to asynchronously prepare wasm: ${d}`);
                                Ha(d);
                            });
                        }
                        function Na(a, b) {
                            var c = Ja;
                            return ta || "function" != typeof WebAssembly.instantiateStreaming || Ia(c) || qa(c) || "function" != typeof fetch ? Ma(c, a, b) : fetch(c, {
                                credentials: "same-origin"
                            }).then((d)=>WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
                                    sa(`wasm streaming compile failed: ${e}`);
                                    sa("falling back to ArrayBuffer instantiation");
                                    return Ma(c, a, b);
                                }));
                        }
                        var Oa, Pa, Ta = {
                            574209: (a, b, c, d, e)=>{
                                if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) return 0;
                                if ("undefined" === typeof window.h) {
                                    window.h = {
                                        Ea: 0
                                    };
                                    window.h.I = {};
                                    window.h.I.Ca = a;
                                    window.h.I.capture = b;
                                    window.h.I.Pa = c;
                                    window.h.ia = {};
                                    window.h.ia.stopped = d;
                                    window.h.ia.ub = e;
                                    let f = window.h;
                                    f.D = [];
                                    f.lc = function(g) {
                                        for(var k = 0; k < f.D.length; ++k){
                                            if (null == f.D[k]) return f.D[k] = g, k;
                                        }
                                        f.D.push(g);
                                        return f.D.length - 1;
                                    };
                                    f.yb = function(g) {
                                        for(f.D[g] = null; 0 < f.D.length;){
                                            if (null == f.D[f.D.length - 1]) f.D.pop();
                                            else break;
                                        }
                                    };
                                    f.Mc = function(g) {
                                        for(var k = 0; k < f.D.length; ++k){
                                            if (f.D[k] == g) return f.yb(k);
                                        }
                                    };
                                    f.ta = function(g) {
                                        return f.D[g];
                                    };
                                    f.Xa = [
                                        "touchend",
                                        "click"
                                    ];
                                    f.unlock = function() {
                                        for(var g = 0; g < f.D.length; ++g){
                                            var k = f.D[g];
                                            null != k && null != k.K && k.state === f.ia.ub && k.K.resume().then(()=>{
                                                Qa(k.nb);
                                            }, (m)=>{
                                                console.error("Failed to resume audiocontext", m);
                                            });
                                        }
                                        f.Xa.map(function(m) {
                                            document.removeEventListener(m, f.unlock, !0);
                                        });
                                    };
                                    f.Xa.map(function(g) {
                                        document.addEventListener(g, f.unlock, !0);
                                    });
                                }
                                window.h.Ea += 1;
                                return 1;
                            },
                            576387: ()=>{
                                "undefined" !== typeof window.h && (window.h.Xa.map(function(a) {
                                    document.removeEventListener(a, window.h.unlock, !0);
                                }), --window.h.Ea, 0 === window.h.Ea && delete window.h);
                            },
                            576691: ()=>void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia,
                            576795: ()=>{
                                try {
                                    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
                                    a.close();
                                    return b;
                                } catch (c) {
                                    return 0;
                                }
                            },
                            576966: (a, b, c, d, e, f)=>{
                                if ("undefined" === typeof window.h) return -1;
                                var g = {}, k = {};
                                a == window.h.I.Ca && 0 != c && (k.sampleRate = c);
                                g.K = new (window.AudioContext || window.webkitAudioContext)(k);
                                g.K.suspend();
                                g.state = window.h.ia.stopped;
                                c = 0;
                                a != window.h.I.Ca && (c = b);
                                g.Y = g.K.createScriptProcessor(d, c, b);
                                g.Y.onaudioprocess = function(m) {
                                    if (null == g.ua || 0 == g.ua.length) g.ua = new Float32Array(xa.buffer, e, d * b);
                                    if (a == window.h.I.capture || a == window.h.I.Pa) {
                                        for(var n = 0; n < b; n += 1)for(var t = m.inputBuffer.getChannelData(n), v = g.ua, x = 0; x < d; x += 1)v[x * b + n] = t[x];
                                        Ra(f, d, e);
                                    }
                                    if (a == window.h.I.Ca || a == window.h.I.Pa) {
                                        for(Sa(f, d, e), n = 0; n < m.outputBuffer.numberOfChannels; ++n)for(t = m.outputBuffer.getChannelData(n), v = g.ua, x = 0; x < d; x += 1)t[x] = v[x * b + n];
                                    } else for(n = 0; n < m.outputBuffer.numberOfChannels; ++n)m.outputBuffer.getChannelData(n).fill(0.0);
                                };
                                a != window.h.I.capture && a != window.h.I.Pa || navigator.mediaDevices.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }).then(function(m) {
                                    g.Fa = g.K.createMediaStreamSource(m);
                                    g.Fa.connect(g.Y);
                                    g.Y.connect(g.K.destination);
                                }).catch(function(m) {
                                    console.log("Failed to get user media: " + m);
                                });
                                a == window.h.I.Ca && g.Y.connect(g.K.destination);
                                g.nb = f;
                                return window.h.lc(g);
                            },
                            579843: (a)=>window.h.ta(a).K.sampleRate,
                            579916: (a)=>{
                                a = window.h.ta(a);
                                void 0 !== a.Y && (a.Y.onaudioprocess = function() {}, a.Y.disconnect(), a.Y = void 0);
                                void 0 !== a.Fa && (a.Fa.disconnect(), a.Fa = void 0);
                                a.K.close();
                                a.K = void 0;
                                a.nb = void 0;
                            },
                            580316: (a)=>{
                                window.h.yb(a);
                            },
                            580366: (a)=>{
                                a = window.h.ta(a);
                                a.K.resume();
                                a.state = window.h.ia.ub;
                            },
                            580505: (a)=>{
                                a = window.h.ta(a);
                                a.K.suspend();
                                a.state = window.h.ia.stopped;
                            }
                        }, Ua = (a)=>{
                            for(; 0 < a.length;)a.shift()(l);
                        };
                        function Va() {
                            var a = F[+Wa >> 2];
                            Wa += 4;
                            return a;
                        }
                        var Xa = (a, b)=>{
                            for(var c = 0, d = a.length - 1; 0 <= d; d--){
                                var e = a[d];
                                "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
                            }
                            if (b) for(; c; c--)a.unshift("..");
                            return a;
                        }, Ya = (a)=>{
                            var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
                            (a = Xa(a.split("/").filter((d)=>!!d), !b).join("/")) || b || (a = ".");
                            a && c && (a += "/");
                            return (b ? "/" : "") + a;
                        }, Za = (a)=>{
                            var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
                            a = b[0];
                            b = b[1];
                            if (!a && !b) return ".";
                            b &&= b.substr(0, b.length - 1);
                            return a + b;
                        }, $a = (a)=>{
                            if ("/" === a) return "/";
                            a = Ya(a);
                            a = a.replace(/\/$/, "");
                            var b = a.lastIndexOf("/");
                            return -1 === b ? a : a.substr(b + 1);
                        }, ab = ()=>{
                            if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) return (a)=>crypto.getRandomValues(a);
                            Ha("initRandomDevice");
                        }, bb = (a)=>(bb = ab())(a), cb = (...a)=>{
                            for(var b = "", c = !1, d = a.length - 1; -1 <= d && !c; d--){
                                c = 0 <= d ? a[d] : "/";
                                if ("string" != typeof c) throw new TypeError("Arguments to path.resolve must be strings");
                                if (!c) return "";
                                b = c + "/" + b;
                                c = "/" === c.charAt(0);
                            }
                            b = Xa(b.split("/").filter((e)=>!!e), !c).join("/");
                            return (c ? "/" : "") + b || ".";
                        }, db = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = (a, b, c)=>{
                            var d = b + c;
                            for(c = b; a[c] && !(c >= d);)++c;
                            if (16 < c - b && a.buffer && db) return db.decode(a.subarray(b, c));
                            for(d = ""; b < c;){
                                var e = a[b++];
                                if (e & 128) {
                                    var f = a[b++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | f);
                                    else {
                                        var g = a[b++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, eb = [], fb = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
                            }
                            return b;
                        }, gb = (a, b, c, d)=>{
                            if (!(0 < d)) return 0;
                            var e = c;
                            d = c + d - 1;
                            for(var f = 0; f < a.length; ++f){
                                var g = a.charCodeAt(f);
                                if (55296 <= g && 57343 >= g) {
                                    var k = a.charCodeAt(++f);
                                    g = 65536 + ((g & 1023) << 10) | k & 1023;
                                }
                                if (127 >= g) {
                                    if (c >= d) break;
                                    b[c++] = g;
                                } else {
                                    if (2047 >= g) {
                                        if (c + 1 >= d) break;
                                        b[c++] = 192 | g >> 6;
                                    } else {
                                        if (65535 >= g) {
                                            if (c + 2 >= d) break;
                                            b[c++] = 224 | g >> 12;
                                        } else {
                                            if (c + 3 >= d) break;
                                            b[c++] = 240 | g >> 18;
                                            b[c++] = 128 | g >> 12 & 63;
                                        }
                                        b[c++] = 128 | g >> 6 & 63;
                                    }
                                    b[c++] = 128 | g & 63;
                                }
                            }
                            b[c] = 0;
                            return c - e;
                        };
                        function hb(a, b) {
                            var c = Array(fb(a) + 1);
                            a = gb(a, c, 0, c.length);
                            b && (c.length = a);
                            return c;
                        }
                        var ib = [];
                        function jb(a, b) {
                            ib[a] = {
                                input: [],
                                H: [],
                                V: b
                            };
                            kb(a, lb);
                        }
                        var lb = {
                            open (a) {
                                var b = ib[a.node.Da];
                                if (!b) throw new M(43);
                                a.s = b;
                                a.seekable = !1;
                            },
                            close (a) {
                                a.s.V.sa(a.s);
                            },
                            sa (a) {
                                a.s.V.sa(a.s);
                            },
                            read (a, b, c, d) {
                                if (!a.s || !a.s.V.hb) throw new M(60);
                                for(var e = 0, f = 0; f < d; f++){
                                    try {
                                        var g = a.s.V.hb(a.s);
                                    } catch (k) {
                                        throw new M(29);
                                    }
                                    if (void 0 === g && 0 === e) throw new M(6);
                                    if (null === g || void 0 === g) break;
                                    e++;
                                    b[c + f] = g;
                                }
                                e && (a.node.timestamp = Date.now());
                                return e;
                            },
                            write (a, b, c, d) {
                                if (!a.s || !a.s.V.Sa) throw new M(60);
                                try {
                                    for(var e = 0; e < d; e++)a.s.V.Sa(a.s, b[c + e]);
                                } catch (f) {
                                    throw new M(29);
                                }
                                d && (a.node.timestamp = Date.now());
                                return e;
                            }
                        }, mb = {
                            hb () {
                                a: {
                                    if (!eb.length) {
                                        var a = null;
                                        "undefined" != typeof window && "function" == typeof window.prompt && (a = window.prompt("Input: "), null !== a && (a += "\n"));
                                        if (!a) {
                                            a = null;
                                            break a;
                                        }
                                        eb = hb(a, !0);
                                    }
                                    a = eb.shift();
                                }
                                return a;
                            },
                            Sa (a, b) {
                                null === b || 10 === b ? (ra(L(a.H, 0)), a.H = []) : 0 != b && a.H.push(b);
                            },
                            sa (a) {
                                a.H && 0 < a.H.length && (ra(L(a.H, 0)), a.H = []);
                            },
                            Vb () {
                                return {
                                    sc: 25856,
                                    uc: 5,
                                    rc: 191,
                                    tc: 35387,
                                    qc: [
                                        3,
                                        28,
                                        127,
                                        21,
                                        4,
                                        0,
                                        1,
                                        0,
                                        17,
                                        19,
                                        26,
                                        0,
                                        18,
                                        15,
                                        23,
                                        22,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ]
                                };
                            },
                            Wb () {
                                return 0;
                            },
                            Xb () {
                                return [
                                    24,
                                    80
                                ];
                            }
                        }, ob = {
                            Sa (a, b) {
                                null === b || 10 === b ? (sa(L(a.H, 0)), a.H = []) : 0 != b && a.H.push(b);
                            },
                            sa (a) {
                                a.H && 0 < a.H.length && (sa(L(a.H, 0)), a.H = []);
                            }
                        };
                        function pb(a, b) {
                            var c = a.l ? a.l.length : 0;
                            c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.l, a.l = new Uint8Array(b), 0 < a.v && a.l.set(c.subarray(0, a.v), 0));
                        }
                        var N = {
                            N: null,
                            U () {
                                return N.createNode(null, "/", 16895, 0);
                            },
                            createNode (a, b, c, d) {
                                if (24576 === (c & 61440) || 4096 === (c & 61440)) throw new M(63);
                                N.N || (N.N = {
                                    dir: {
                                        node: {
                                            X: N.j.X,
                                            P: N.j.P,
                                            la: N.j.la,
                                            Aa: N.j.Aa,
                                            sb: N.j.sb,
                                            xb: N.j.xb,
                                            tb: N.j.tb,
                                            rb: N.j.rb,
                                            Ga: N.j.Ga
                                        },
                                        stream: {
                                            aa: N.m.aa
                                        }
                                    },
                                    file: {
                                        node: {
                                            X: N.j.X,
                                            P: N.j.P
                                        },
                                        stream: {
                                            aa: N.m.aa,
                                            read: N.m.read,
                                            write: N.m.write,
                                            $a: N.m.$a,
                                            jb: N.m.jb,
                                            lb: N.m.lb
                                        }
                                    },
                                    link: {
                                        node: {
                                            X: N.j.X,
                                            P: N.j.P,
                                            ma: N.j.ma
                                        },
                                        stream: {}
                                    },
                                    ab: {
                                        node: {
                                            X: N.j.X,
                                            P: N.j.P
                                        },
                                        stream: qb
                                    }
                                });
                                c = rb(a, b, c, d);
                                16384 === (c.mode & 61440) ? (c.j = N.N.dir.node, c.m = N.N.dir.stream, c.l = {}) : 32768 === (c.mode & 61440) ? (c.j = N.N.file.node, c.m = N.N.file.stream, c.v = 0, c.l = null) : 40960 === (c.mode & 61440) ? (c.j = N.N.link.node, c.m = N.N.link.stream) : 8192 === (c.mode & 61440) && (c.j = N.N.ab.node, c.m = N.N.ab.stream);
                                c.timestamp = Date.now();
                                a && (a.l[b] = c, a.timestamp = c.timestamp);
                                return c;
                            },
                            Ac (a) {
                                return a.l ? a.l.subarray ? a.l.subarray(0, a.v) : new Uint8Array(a.l) : new Uint8Array(0);
                            },
                            j: {
                                X (a) {
                                    var b = {};
                                    b.xc = 8192 === (a.mode & 61440) ? a.id : 1;
                                    b.Cc = a.id;
                                    b.mode = a.mode;
                                    b.Hc = 1;
                                    b.uid = 0;
                                    b.Bc = 0;
                                    b.Da = a.Da;
                                    16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
                                    b.oc = new Date(a.timestamp);
                                    b.Gc = new Date(a.timestamp);
                                    b.vc = new Date(a.timestamp);
                                    b.Fb = 4096;
                                    b.pc = Math.ceil(b.size / b.Fb);
                                    return b;
                                },
                                P (a, b) {
                                    void 0 !== b.mode && (a.mode = b.mode);
                                    void 0 !== b.timestamp && (a.timestamp = b.timestamp);
                                    if (void 0 !== b.size && (b = b.size, a.v != b)) {
                                        if (0 == b) a.l = null, a.v = 0;
                                        else {
                                            var c = a.l;
                                            a.l = new Uint8Array(b);
                                            c && a.l.set(c.subarray(0, Math.min(b, a.v)));
                                            a.v = b;
                                        }
                                    }
                                },
                                la () {
                                    throw sb[44];
                                },
                                Aa (a, b, c, d) {
                                    return N.createNode(a, b, c, d);
                                },
                                sb (a, b, c) {
                                    if (16384 === (a.mode & 61440)) {
                                        try {
                                            var d = tb(b, c);
                                        } catch (f) {}
                                        if (d) {
                                            for(var e in d.l)throw new M(55);
                                        }
                                    }
                                    delete a.parent.l[a.name];
                                    a.parent.timestamp = Date.now();
                                    a.name = c;
                                    b.l[c] = a;
                                    b.timestamp = a.parent.timestamp;
                                },
                                xb (a, b) {
                                    delete a.l[b];
                                    a.timestamp = Date.now();
                                },
                                tb (a, b) {
                                    var c = tb(a, b), d;
                                    for(d in c.l)throw new M(55);
                                    delete a.l[b];
                                    a.timestamp = Date.now();
                                },
                                rb (a) {
                                    var b = [
                                        ".",
                                        ".."
                                    ], c;
                                    for (c of Object.keys(a.l))b.push(c);
                                    return b;
                                },
                                Ga (a, b, c) {
                                    a = N.createNode(a, b, 41471, 0);
                                    a.link = c;
                                    return a;
                                },
                                ma (a) {
                                    if (40960 !== (a.mode & 61440)) throw new M(28);
                                    return a.link;
                                }
                            },
                            m: {
                                read (a, b, c, d, e) {
                                    var f = a.node.l;
                                    if (e >= a.node.v) return 0;
                                    a = Math.min(a.node.v - e, d);
                                    if (8 < a && f.subarray) b.set(f.subarray(e, e + a), c);
                                    else for(d = 0; d < a; d++)b[c + d] = f[e + d];
                                    return a;
                                },
                                write (a, b, c, d, e, f) {
                                    b.buffer === B.buffer && (f = !1);
                                    if (!d) return 0;
                                    a = a.node;
                                    a.timestamp = Date.now();
                                    if (b.subarray && (!a.l || a.l.subarray)) {
                                        if (f) return a.l = b.subarray(c, c + d), a.v = d;
                                        if (0 === a.v && 0 === e) return a.l = b.slice(c, c + d), a.v = d;
                                        if (e + d <= a.v) return a.l.set(b.subarray(c, c + d), e), d;
                                    }
                                    pb(a, e + d);
                                    if (a.l.subarray && b.subarray) a.l.set(b.subarray(c, c + d), e);
                                    else for(f = 0; f < d; f++)a.l[e + f] = b[c + f];
                                    a.v = Math.max(a.v, e + d);
                                    return d;
                                },
                                aa (a, b, c) {
                                    1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
                                    if (0 > b) throw new M(28);
                                    return b;
                                },
                                $a (a, b, c) {
                                    pb(a.node, b + c);
                                    a.node.v = Math.max(a.node.v, b + c);
                                },
                                jb (a, b, c, d, e) {
                                    if (32768 !== (a.node.mode & 61440)) throw new M(43);
                                    a = a.node.l;
                                    if (e & 2 || a.buffer !== B.buffer) {
                                        if (0 < c || c + b < a.length) a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
                                        c = !0;
                                        Ha();
                                        b = void 0;
                                        if (!b) throw new M(48);
                                        B.set(a, b);
                                    } else c = !1, b = a.byteOffset;
                                    return {
                                        o: b,
                                        nc: c
                                    };
                                },
                                lb (a, b, c, d) {
                                    N.m.write(a, b, 0, d, c, !1);
                                    return 0;
                                }
                            }
                        }, ub = (a, b)=>{
                            var c = 0;
                            a && (c |= 365);
                            b && (c |= 146);
                            return c;
                        }, vb = null, wb = {}, xb = [], yb = 1, zb = null, Ab = !0, M = class {
                            constructor(a){
                                this.name = "ErrnoError";
                                this.$ = a;
                            }
                        }, sb = {}, Bb = class {
                            constructor(){
                                this.h = {};
                                this.node = null;
                            }
                            get flags() {
                                return this.h.flags;
                            }
                            set flags(a) {
                                this.h.flags = a;
                            }
                            get position() {
                                return this.h.position;
                            }
                            set position(a) {
                                this.h.position = a;
                            }
                        }, Cb = class {
                            constructor(a, b, c, d){
                                a ||= this;
                                this.parent = a;
                                this.U = a.U;
                                this.Ba = null;
                                this.id = yb++;
                                this.name = b;
                                this.mode = c;
                                this.j = {};
                                this.m = {};
                                this.Da = d;
                            }
                            get read() {
                                return 365 === (this.mode & 365);
                            }
                            set read(a) {
                                a ? this.mode |= 365 : this.mode &= -366;
                            }
                            get write() {
                                return 146 === (this.mode & 146);
                            }
                            set write(a) {
                                a ? this.mode |= 146 : this.mode &= -147;
                            }
                        };
                        function Db(a, b = {}) {
                            a = cb(a);
                            if (!a) return {
                                path: "",
                                node: null
                            };
                            b = Object.assign({
                                gb: !0,
                                Ua: 0
                            }, b);
                            if (8 < b.Ua) throw new M(32);
                            a = a.split("/").filter((g)=>!!g);
                            for(var c = vb, d = "/", e = 0; e < a.length; e++){
                                var f = e === a.length - 1;
                                if (f && b.parent) break;
                                c = tb(c, a[e]);
                                d = Ya(d + "/" + a[e]);
                                c.Ba && (!f || f && b.gb) && (c = c.Ba.root);
                                if (!f || b.fb) for(f = 0; 40960 === (c.mode & 61440);){
                                    if (c = Eb(d), d = cb(Za(d), c), c = Db(d, {
                                        Ua: b.Ua + 1
                                    }).node, 40 < f++) throw new M(32);
                                }
                            }
                            return {
                                path: d,
                                node: c
                            };
                        }
                        function Fb(a) {
                            for(var b;;){
                                if (a === a.parent) return a = a.U.kb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
                                b = b ? `${a.name}/${b}` : a.name;
                                a = a.parent;
                            }
                        }
                        function Gb(a, b) {
                            for(var c = 0, d = 0; d < b.length; d++)c = (c << 5) - c + b.charCodeAt(d) | 0;
                            return (a + c >>> 0) % zb.length;
                        }
                        function tb(a, b) {
                            var c = 16384 === (a.mode & 61440) ? (c = Hb(a, "x")) ? c : a.j.la ? 0 : 2 : 54;
                            if (c) throw new M(c);
                            for(c = zb[Gb(a.id, b)]; c; c = c.$b){
                                var d = c.name;
                                if (c.parent.id === a.id && d === b) return c;
                            }
                            return a.j.la(a, b);
                        }
                        function rb(a, b, c, d) {
                            a = new Cb(a, b, c, d);
                            b = Gb(a.parent.id, a.name);
                            a.$b = zb[b];
                            return zb[b] = a;
                        }
                        function Ib(a) {
                            var b = [
                                "r",
                                "w",
                                "rw"
                            ][a & 3];
                            a & 512 && (b += "w");
                            return b;
                        }
                        function Hb(a, b) {
                            if (Ab) return 0;
                            if (!b.includes("r") || a.mode & 292) {
                                if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) return 2;
                            } else return 2;
                            return 0;
                        }
                        function Jb(a, b) {
                            try {
                                return tb(a, b), 20;
                            } catch (c) {}
                            return Hb(a, "wx");
                        }
                        function Kb(a) {
                            a = xb[a];
                            if (!a) throw new M(8);
                            return a;
                        }
                        function Lb(a, b = -1) {
                            a = Object.assign(new Bb(), a);
                            if (-1 == b) a: {
                                for(b = 0; 4096 >= b; b++){
                                    if (!xb[b]) break a;
                                }
                                throw new M(33);
                            }
                            a.W = b;
                            return xb[b] = a;
                        }
                        function Mb(a, b = -1) {
                            a = Lb(a, b);
                            a.m?.zc?.(a);
                            return a;
                        }
                        var qb = {
                            open (a) {
                                a.m = wb[a.node.Da].m;
                                a.m.open?.(a);
                            },
                            aa () {
                                throw new M(70);
                            }
                        };
                        function kb(a, b) {
                            wb[a] = {
                                m: b
                            };
                        }
                        function Nb(a, b) {
                            var c = "/" === b;
                            if (c && vb) throw new M(10);
                            if (!c && b) {
                                var d = Db(b, {
                                    gb: !1
                                });
                                b = d.path;
                                d = d.node;
                                if (d.Ba) throw new M(10);
                                if (16384 !== (d.mode & 61440)) throw new M(54);
                            }
                            b = {
                                type: a,
                                Jc: {},
                                kb: b,
                                Yb: []
                            };
                            a = a.U(b);
                            a.U = b;
                            b.root = a;
                            c ? vb = a : d && (d.Ba = b, d.U && d.U.Yb.push(b));
                        }
                        function Ob(a, b, c) {
                            var d = Db(a, {
                                parent: !0
                            }).node;
                            a = $a(a);
                            if (!a || "." === a || ".." === a) throw new M(28);
                            var e = Jb(d, a);
                            if (e) throw new M(e);
                            if (!d.j.Aa) throw new M(63);
                            return d.j.Aa(d, a, b, c);
                        }
                        function Pb(a) {
                            return Ob(a, 16895, 0);
                        }
                        function Qb(a, b, c) {
                            "undefined" == typeof c && (c = b, b = 438);
                            Ob(a, b | 8192, c);
                        }
                        function Rb(a, b) {
                            if (!cb(a)) throw new M(44);
                            var c = Db(b, {
                                parent: !0
                            }).node;
                            if (!c) throw new M(44);
                            b = $a(b);
                            var d = Jb(c, b);
                            if (d) throw new M(d);
                            if (!c.j.Ga) throw new M(63);
                            c.j.Ga(c, b, a);
                        }
                        function Eb(a) {
                            a = Db(a).node;
                            if (!a) throw new M(44);
                            if (!a.j.ma) throw new M(28);
                            return cb(Fb(a.parent), a.j.ma(a));
                        }
                        function Sb(a, b, c) {
                            if ("" === a) throw new M(44);
                            if ("string" == typeof b) {
                                var d = {
                                    r: 0,
                                    "r+": 2,
                                    w: 577,
                                    "w+": 578,
                                    a: 1089,
                                    "a+": 1090
                                }[b];
                                if ("undefined" == typeof d) throw Error(`Unknown file open mode: ${b}`);
                                b = d;
                            }
                            c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
                            if ("object" == typeof a) var e = a;
                            else {
                                a = Ya(a);
                                try {
                                    e = Db(a, {
                                        fb: !(b & 131072)
                                    }).node;
                                } catch (f) {}
                            }
                            d = !1;
                            if (b & 64) {
                                if (e) {
                                    if (b & 128) throw new M(20);
                                } else e = Ob(a, c, 0), d = !0;
                            }
                            if (!e) throw new M(44);
                            8192 === (e.mode & 61440) && (b &= -513);
                            if (b & 65536 && 16384 !== (e.mode & 61440)) throw new M(54);
                            if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Ib(b) || b & 512) ? 31 : Hb(e, Ib(b)) : 44)) throw new M(c);
                            if (b & 512 && !d) {
                                c = e;
                                c = "string" == typeof c ? Db(c, {
                                    fb: !0
                                }).node : c;
                                if (!c.j.P) throw new M(63);
                                if (16384 === (c.mode & 61440)) throw new M(31);
                                if (32768 !== (c.mode & 61440)) throw new M(28);
                                if (d = Hb(c, "w")) throw new M(d);
                                c.j.P(c, {
                                    size: 0,
                                    timestamp: Date.now()
                                });
                            }
                            b &= -131713;
                            e = Lb({
                                node: e,
                                path: Fb(e),
                                flags: b,
                                seekable: !0,
                                position: 0,
                                m: e.m,
                                mc: [],
                                error: !1
                            });
                            e.m.open && e.m.open(e);
                            !l.logReadFiles || b & 1 || (Tb ||= {}, a in Tb || (Tb[a] = 1));
                            return e;
                        }
                        function Ub(a, b, c) {
                            if (null === a.W) throw new M(8);
                            if (!a.seekable || !a.m.aa) throw new M(70);
                            if (0 != c && 1 != c && 2 != c) throw new M(28);
                            a.position = a.m.aa(a, b, c);
                            a.mc = [];
                        }
                        var Vb;
                        function Wb(a, b, c) {
                            a = Ya("/dev/" + a);
                            var d = ub(!!b, !!c);
                            Xb ||= 64;
                            var e = Xb++ << 8 | 0;
                            kb(e, {
                                open (f) {
                                    f.seekable = !1;
                                },
                                close () {
                                    c?.buffer?.length && c(10);
                                },
                                read (f, g, k, m) {
                                    for(var n = 0, t = 0; t < m; t++){
                                        try {
                                            var v = b();
                                        } catch (x) {
                                            throw new M(29);
                                        }
                                        if (void 0 === v && 0 === n) throw new M(6);
                                        if (null === v || void 0 === v) break;
                                        n++;
                                        g[k + t] = v;
                                    }
                                    n && (f.node.timestamp = Date.now());
                                    return n;
                                },
                                write (f, g, k, m) {
                                    for(var n = 0; n < m; n++)try {
                                        c(g[k + n]);
                                    } catch (t) {
                                        throw new M(29);
                                    }
                                    m && (f.node.timestamp = Date.now());
                                    return n;
                                }
                            });
                            Qb(a, d, e);
                        }
                        var Xb, Yb = {}, Tb, Wa = void 0, Zb = (a, b)=>Object.defineProperty(b, "name", {
                                value: a
                            }), $b = [], O = [], P, Q = (a)=>{
                            if (!a) throw new P("Cannot use deleted val. handle = " + a);
                            return O[a];
                        }, ac = (a)=>{
                            switch(a){
                                case void 0:
                                    return 2;
                                case null:
                                    return 4;
                                case !0:
                                    return 6;
                                case !1:
                                    return 8;
                                default:
                                    const b = $b.pop() || O.length;
                                    O[b] = a;
                                    O[b + 1] = 1;
                                    return b;
                            }
                        }, bc = (a)=>{
                            var b = Error, c = Zb(a, function(d) {
                                this.name = a;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(b.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
                            };
                            return c;
                        }, cc, dc, R = (a)=>{
                            for(var b = ""; D[a];)b += dc[D[a++]];
                            return b;
                        }, ec = [], fc = ()=>{
                            for(; ec.length;){
                                var a = ec.pop();
                                a.g.ha = !1;
                                a["delete"]();
                            }
                        }, gc, hc = {}, ic = (a, b)=>{
                            if (void 0 === b) throw new P("ptr should not be undefined");
                            for(; a.B;)b = a.oa(b), a = a.B;
                            return b;
                        }, jc = {}, mc = (a)=>{
                            a = kc(a);
                            var b = R(a);
                            lc(a);
                            return b;
                        }, nc = (a, b)=>{
                            var c = jc[a];
                            if (void 0 === c) throw a = `${b} has unknown type ${mc(a)}`, new P(a);
                            return c;
                        }, oc = ()=>{}, pc = !1, qc = (a, b, c)=>{
                            if (b === c) return a;
                            if (void 0 === c.B) return null;
                            a = qc(a, b, c.B);
                            return null === a ? null : c.Ib(a);
                        }, rc = {}, sc = (a, b)=>{
                            b = ic(a, b);
                            return hc[b];
                        }, tc, vc = (a, b)=>{
                            if (!b.u || !b.o) throw new tc("makeClassHandle requires ptr and ptrType");
                            if (!!b.J !== !!b.F) throw new tc("Both smartPtrType and smartPtr must be specified");
                            b.count = {
                                value: 1
                            };
                            return uc(Object.create(a, {
                                g: {
                                    value: b,
                                    writable: !0
                                }
                            }));
                        }, uc = (a)=>{
                            if ("undefined" === typeof FinalizationRegistry) return uc = (b)=>b, a;
                            pc = new FinalizationRegistry((b)=>{
                                b = b.g;
                                --b.count.value;
                                0 === b.count.value && (b.F ? b.J.O(b.F) : b.u.i.O(b.o));
                            });
                            uc = (b)=>{
                                var c = b.g;
                                c.F && pc.register(b, {
                                    g: c
                                }, b);
                                return b;
                            };
                            oc = (b)=>{
                                pc.unregister(b);
                            };
                            return uc(a);
                        }, wc = {}, xc = (a)=>{
                            for(; a.length;){
                                var b = a.pop();
                                a.pop()(b);
                            }
                        };
                        function yc(a) {
                            return this.fromWireType(H[a >> 2]);
                        }
                        var zc = {}, Ac = {}, T = (a, b, c)=>{
                            function d(k) {
                                k = c(k);
                                if (k.length !== a.length) throw new tc("Mismatched type converter count");
                                for(var m = 0; m < a.length; ++m)S(a[m], k[m]);
                            }
                            a.forEach(function(k) {
                                Ac[k] = b;
                            });
                            var e = Array(b.length), f = [], g = 0;
                            b.forEach((k, m)=>{
                                jc.hasOwnProperty(k) ? e[m] = jc[k] : (f.push(k), zc.hasOwnProperty(k) || (zc[k] = []), zc[k].push(()=>{
                                    e[m] = jc[k];
                                    ++g;
                                    g === f.length && d(e);
                                }));
                            });
                            0 === f.length && d(e);
                        };
                        function Bc(a, b, c = {}) {
                            var d = b.name;
                            if (!a) throw new P(`type "${d}" must have a positive integer typeid pointer`);
                            if (jc.hasOwnProperty(a)) {
                                if (c.Sb) return;
                                throw new P(`Cannot register type '${d}' twice`);
                            }
                            jc[a] = b;
                            delete Ac[a];
                            zc.hasOwnProperty(a) && (b = zc[a], delete zc[a], b.forEach((e)=>e()));
                        }
                        function S(a, b, c = {}) {
                            if (!("argPackAdvance" in b)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            return Bc(a, b, c);
                        }
                        var Cc = (a)=>{
                            throw new P(a.g.u.i.name + " instance already deleted");
                        };
                        function Dc() {}
                        var Ec = (a, b, c)=>{
                            if (void 0 === a[b].A) {
                                var d = a[b];
                                a[b] = function(...e) {
                                    if (!a[b].A.hasOwnProperty(e.length)) throw new P(`Function '${c}' called with an invalid number of arguments (${e.length}) - expects one of (${a[b].A})!`);
                                    return a[b].A[e.length].apply(this, e);
                                };
                                a[b].A = [];
                                a[b].A[d.ga] = d;
                            }
                        }, Fc = (a, b, c)=>{
                            if (l.hasOwnProperty(a)) {
                                if (void 0 === c || void 0 !== l[a].A && void 0 !== l[a].A[c]) throw new P(`Cannot register public name '${a}' twice`);
                                Ec(l, a, a);
                                if (l.hasOwnProperty(c)) throw new P(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`);
                                l[a].A[c] = b;
                            } else l[a] = b, void 0 !== c && (l[a].Ic = c);
                        }, Gc = (a)=>{
                            if (void 0 === a) return "_unknown";
                            a = a.replace(/[^a-zA-Z0-9_]/g, "$");
                            var b = a.charCodeAt(0);
                            return 48 <= b && 57 >= b ? `_${a}` : a;
                        };
                        function Hc(a, b, c, d, e, f, g, k) {
                            this.name = a;
                            this.constructor = b;
                            this.M = c;
                            this.O = d;
                            this.B = e;
                            this.Nb = f;
                            this.oa = g;
                            this.Ib = k;
                            this.ob = [];
                        }
                        var Ic = (a, b, c)=>{
                            for(; b !== c;){
                                if (!b.oa) throw new P(`Expected null or instance of ${c.name}, got an instance of ${b.name}`);
                                a = b.oa(a);
                                b = b.B;
                            }
                            return a;
                        };
                        function Jc(a, b) {
                            if (null === b) {
                                if (this.Ra) throw new P(`null is not a valid ${this.name}`);
                                return 0;
                            }
                            if (!b.g) throw new P(`Cannot pass "${Kc(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            return Ic(b.g.o, b.g.u.i, this.i);
                        }
                        function Lc(a, b) {
                            if (null === b) {
                                if (this.Ra) throw new P(`null is not a valid ${this.name}`);
                                if (this.wa) {
                                    var c = this.Ta();
                                    null !== a && a.push(this.O, c);
                                    return c;
                                }
                                return 0;
                            }
                            if (!b || !b.g) throw new P(`Cannot pass "${Kc(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            if (!this.va && b.g.u.va) throw new P(`Cannot convert argument of type ${b.g.J ? b.g.J.name : b.g.u.name} to parameter type ${this.name}`);
                            c = Ic(b.g.o, b.g.u.i, this.i);
                            if (this.wa) {
                                if (void 0 === b.g.F) throw new P("Passing raw pointer to smart pointer is illegal");
                                switch(this.fc){
                                    case 0:
                                        if (b.g.J === this) c = b.g.F;
                                        else throw new P(`Cannot convert argument of type ${b.g.J ? b.g.J.name : b.g.u.name} to parameter type ${this.name}`);
                                        break;
                                    case 1:
                                        c = b.g.F;
                                        break;
                                    case 2:
                                        if (b.g.J === this) c = b.g.F;
                                        else {
                                            var d = b.clone();
                                            c = this.bc(c, ac(()=>d["delete"]()));
                                            null !== a && a.push(this.O, c);
                                        }
                                        break;
                                    default:
                                        throw new P("Unsupporting sharing policy");
                                }
                            }
                            return c;
                        }
                        function Mc(a, b) {
                            if (null === b) {
                                if (this.Ra) throw new P(`null is not a valid ${this.name}`);
                                return 0;
                            }
                            if (!b.g) throw new P(`Cannot pass "${Kc(b)}" as a ${this.name}`);
                            if (!b.g.o) throw new P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            if (b.g.u.va) throw new P(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
                            return Ic(b.g.o, b.g.u.i, this.i);
                        }
                        function Nc(a, b, c, d, e, f, g, k, m, n, t) {
                            this.name = a;
                            this.i = b;
                            this.Ra = c;
                            this.va = d;
                            this.wa = e;
                            this.ac = f;
                            this.fc = g;
                            this.qb = k;
                            this.Ta = m;
                            this.bc = n;
                            this.O = t;
                            e || void 0 !== b.B ? this.toWireType = Lc : (this.toWireType = d ? Jc : Mc, this.L = null);
                        }
                        var Oc = (a, b, c)=>{
                            if (!l.hasOwnProperty(a)) throw new tc("Replacing nonexistent public symbol");
                            void 0 !== l[a].A && void 0 !== c ? l[a].A[c] = b : (l[a] = b, l[a].ga = c);
                        }, Pc = [], Qc, Rc = (a)=>{
                            var b = Pc[a];
                            b || (a >= Pc.length && (Pc.length = a + 1), Pc[a] = b = Qc.get(a));
                            return b;
                        }, Sc = (a, b, c = [])=>{
                            a.includes("j") ? (a = a.replace(/p/g, "i"), b = (0, l["dynCall_" + a])(b, ...c)) : b = Rc(b)(...c);
                            return b;
                        }, Tc = (a, b)=>(...c)=>Sc(a, b, c), U = (a, b)=>{
                            a = R(a);
                            var c = a.includes("j") ? Tc(a, b) : Rc(b);
                            if ("function" != typeof c) throw new P(`unknown function pointer with signature ${a}: ${b}`);
                            return c;
                        }, Uc, Vc = (a, b)=>{
                            function c(f) {
                                e[f] || jc[f] || (Ac[f] ? Ac[f].forEach(c) : (d.push(f), e[f] = !0));
                            }
                            var d = [], e = {};
                            b.forEach(c);
                            throw new Uc(`${a}: ` + d.map(mc).join([
                                ", "
                            ]));
                        };
                        function Wc(a) {
                            for(var b = 1; b < a.length; ++b){
                                if (null !== a[b] && void 0 === a[b].L) return !0;
                            }
                            return !1;
                        }
                        function Xc(a, b, c, d, e) {
                            var f = b.length;
                            if (2 > f) throw new P("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var g = null !== b[1] && null !== c, k = Wc(b), m = "void" !== b[0].name, n = f - 2, t = Array(n), v = [], x = [];
                            return Zb(a, function(...p) {
                                if (p.length !== n) throw new P(`function ${a} called with ${p.length} arguments, expected ${n}`);
                                x.length = 0;
                                v.length = g ? 2 : 1;
                                v[0] = e;
                                if (g) {
                                    var r = b[1].toWireType(x, this);
                                    v[1] = r;
                                }
                                for(var u = 0; u < n; ++u)t[u] = b[u + 2].toWireType(x, p[u]), v.push(t[u]);
                                p = d(...v);
                                if (k) xc(x);
                                else for(u = g ? 1 : 2; u < b.length; u++){
                                    var z = 1 === u ? r : t[u - 2];
                                    null !== b[u].L && b[u].L(z);
                                }
                                r = m ? b[0].fromWireType(p) : void 0;
                                return r;
                            });
                        }
                        var Yc = (a, b)=>{
                            for(var c = [], d = 0; d < a; d++)c.push(H[b + 4 * d >> 2]);
                            return c;
                        }, Zc = (a)=>{
                            a = a.trim();
                            const b = a.indexOf("(");
                            return -1 !== b ? a.substr(0, b) : a;
                        }, $c = (a, b, c)=>{
                            if (!(a instanceof Object)) throw new P(`${c} with invalid "this": ${a}`);
                            if (!(a instanceof b.i.constructor)) throw new P(`${c} incompatible with "this" of type ${a.constructor.name}`);
                            if (!a.g.o) throw new P(`cannot call emscripten binding method ${c} on deleted object`);
                            return Ic(a.g.o, a.g.u.i, b.i);
                        }, ad = (a)=>{
                            9 < a && 0 === --O[a + 1] && (O[a] = void 0, $b.push(a));
                        }, bd = {
                            name: "emscripten::val",
                            fromWireType: (a)=>{
                                var b = Q(a);
                                ad(a);
                                return b;
                            },
                            toWireType: (a, b)=>ac(b),
                            argPackAdvance: 8,
                            readValueFromPointer: yc,
                            L: null
                        }, cd = (a, b, c)=>{
                            switch(b){
                                case 1:
                                    return c ? function(d) {
                                        return this.fromWireType(B[d]);
                                    } : function(d) {
                                        return this.fromWireType(D[d]);
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return this.fromWireType(E[d >> 1]);
                                    } : function(d) {
                                        return this.fromWireType(wa[d >> 1]);
                                    };
                                case 4:
                                    return c ? function(d) {
                                        return this.fromWireType(F[d >> 2]);
                                    } : function(d) {
                                        return this.fromWireType(H[d >> 2]);
                                    };
                                default:
                                    throw new TypeError(`invalid integer width (${b}): ${a}`);
                            }
                        }, Kc = (a)=>{
                            if (null === a) return "null";
                            var b = typeof a;
                            return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
                        }, dd = (a, b)=>{
                            switch(b){
                                case 4:
                                    return function(c) {
                                        return this.fromWireType(xa[c >> 2]);
                                    };
                                case 8:
                                    return function(c) {
                                        return this.fromWireType(ya[c >> 3]);
                                    };
                                default:
                                    throw new TypeError(`invalid float width (${b}): ${a}`);
                            }
                        }, ed = (a, b, c)=>{
                            switch(b){
                                case 1:
                                    return c ? (d)=>B[d] : (d)=>D[d];
                                case 2:
                                    return c ? (d)=>E[d >> 1] : (d)=>wa[d >> 1];
                                case 4:
                                    return c ? (d)=>F[d >> 2] : (d)=>H[d >> 2];
                                default:
                                    throw new TypeError(`invalid integer width (${b}): ${a}`);
                            }
                        }, fd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, gd = (a, b)=>{
                            var c = a >> 1;
                            for(var d = c + b / 2; !(c >= d) && wa[c];)++c;
                            c <<= 1;
                            if (32 < c - a && fd) return fd.decode(D.subarray(a, c));
                            c = "";
                            for(d = 0; !(d >= b / 2); ++d){
                                var e = E[a + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, hd = (a, b, c)=>{
                            c ??= 2147483647;
                            if (2 > c) return 0;
                            c -= 2;
                            var d = b;
                            c = c < 2 * a.length ? c / 2 : a.length;
                            for(var e = 0; e < c; ++e)E[b >> 1] = a.charCodeAt(e), b += 2;
                            E[b >> 1] = 0;
                            return b - d;
                        }, jd = (a)=>2 * a.length, kd = (a, b)=>{
                            for(var c = 0, d = ""; !(c >= b / 4);){
                                var e = F[a + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, ld = (a, b, c)=>{
                            c ??= 2147483647;
                            if (4 > c) return 0;
                            var d = b;
                            c = d + c - 4;
                            for(var e = 0; e < a.length; ++e){
                                var f = a.charCodeAt(e);
                                if (55296 <= f && 57343 >= f) {
                                    var g = a.charCodeAt(++e);
                                    f = 65536 + ((f & 1023) << 10) | g & 1023;
                                }
                                F[b >> 2] = f;
                                b += 4;
                                if (b + 4 > c) break;
                            }
                            F[b >> 2] = 0;
                            return b - d;
                        }, md = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                b += 4;
                            }
                            return b;
                        }, nd = (a, b, c)=>{
                            var d = [];
                            a = a.toWireType(d, c);
                            d.length && (H[b >> 2] = ac(d));
                            return a;
                        }, od = {}, pd = (a)=>{
                            var b = od[a];
                            return void 0 === b ? R(a) : b;
                        }, qd = [], rd = (a)=>{
                            var b = qd.length;
                            qd.push(a);
                            return b;
                        }, sd = (a, b)=>{
                            for(var c = Array(a), d = 0; d < a; ++d)c[d] = nc(H[b + 4 * d >> 2], "parameter " + d);
                            return c;
                        }, td = Reflect.construct, ud = (a)=>0 === a % 4 && (0 !== a % 100 || 0 === a % 400), vd = [
                            0,
                            31,
                            60,
                            91,
                            121,
                            152,
                            182,
                            213,
                            244,
                            274,
                            305,
                            335
                        ], wd = [
                            0,
                            31,
                            59,
                            90,
                            120,
                            151,
                            181,
                            212,
                            243,
                            273,
                            304,
                            334
                        ], xd = [], yd = (a)=>{
                            a.yc = a.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
                        }, zd = (a)=>{
                            a.Fc = a.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
                        }, Ad = (a)=>{
                            var b = "EXT_color_buffer_float EXT_conservative_depth EXT_disjoint_timer_query_webgl2 EXT_texture_norm16 NV_shader_noperspective_interpolation WEBGL_clip_cull_distance EXT_color_buffer_half_float EXT_depth_clamp EXT_float_blend EXT_texture_compression_bptc EXT_texture_compression_rgtc EXT_texture_filter_anisotropic KHR_parallel_shader_compile OES_texture_float_linear WEBGL_blend_func_extended WEBGL_compressed_texture_astc WEBGL_compressed_texture_etc WEBGL_compressed_texture_etc1 WEBGL_compressed_texture_s3tc WEBGL_compressed_texture_s3tc_srgb WEBGL_debug_renderer_info WEBGL_debug_shaders WEBGL_lose_context WEBGL_multi_draw".split(" ");
                            return (a.getSupportedExtensions() || []).filter((c)=>b.includes(c));
                        }, Bd = 1, Cd = [], V = [], Dd = [], Ed = [], Fd = [], Gd = [], Hd = [], w = [], Id = {}, Jd = 4, Kd = 0, Ld = (a)=>{
                            for(var b = Bd++, c = a.length; c < b; c++)a[c] = null;
                            return b;
                        }, Md = (a, b, c, d)=>{
                            for(var e = 0; e < a; e++){
                                var f = W[c](), g = f && Ld(d);
                                f ? (f.name = g, d[g] = f) : X ||= 1282;
                                F[b + 4 * e >> 2] = g;
                            }
                        }, ka = (a, b)=>{
                            var c = Ld(w), d = {
                                handle: c,
                                attributes: b,
                                version: b.Ec,
                                C: a
                            };
                            a.canvas && (a.canvas.zb = d);
                            w[c] = d;
                            ("undefined" == typeof b.Jb || b.Jb) && Nd(d);
                            return c;
                        }, la = (a)=>{
                            q = w[a];
                            l.wc = W = q?.C;
                            return !(a && !W);
                        }, Nd = (a)=>{
                            a ||= q;
                            if (!a.Tb) {
                                a.Tb = !0;
                                var b = a.C;
                                yd(b);
                                zd(b);
                                2 <= a.version && (b.cb = b.getExtension("EXT_disjoint_timer_query_webgl2"));
                                if (2 > a.version || !b.cb) b.cb = b.getExtension("EXT_disjoint_timer_query");
                                b.Zb = b.getExtension("WEBGL_multi_draw");
                                Ad(b).forEach((c)=>{
                                    c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
                                });
                            }
                        }, X, q, Od = {}, Qd = ()=>{
                            if (!Pd) {
                                var a = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: na || "./this.program"
                                }, b;
                                for(b in Od)void 0 === Od[b] ? delete a[b] : a[b] = Od[b];
                                var c = [];
                                for(b in a)c.push(`${b}=${a[b]}`);
                                Pd = c;
                            }
                            return Pd;
                        }, Pd, Rd = [];
                        function Sd() {
                            var a = Ad(W);
                            return a = a.concat(a.map((b)=>"GL_" + b));
                        }
                        var Td = (a, b)=>{
                            if (b) {
                                var c = void 0;
                                switch(a){
                                    case 36346:
                                        c = 1;
                                        break;
                                    case 36344:
                                        return;
                                    case 34814:
                                    case 36345:
                                        c = 0;
                                        break;
                                    case 34466:
                                        var d = W.getParameter(34467);
                                        c = d ? d.length : 0;
                                        break;
                                    case 33309:
                                        if (2 > q.version) {
                                            X ||= 1282;
                                            return;
                                        }
                                        c = Sd().length;
                                        break;
                                    case 33307:
                                    case 33308:
                                        if (2 > q.version) {
                                            X ||= 1280;
                                            return;
                                        }
                                        c = 33307 == a ? 3 : 0;
                                }
                                if (void 0 === c) switch(d = W.getParameter(a), typeof d){
                                    case "number":
                                        c = d;
                                        break;
                                    case "boolean":
                                        c = d ? 1 : 0;
                                        break;
                                    case "string":
                                        X ||= 1280;
                                        return;
                                    case "object":
                                        if (null === d) switch(a){
                                            case 34964:
                                            case 35725:
                                            case 34965:
                                            case 36006:
                                            case 36007:
                                            case 32873:
                                            case 34229:
                                            case 36662:
                                            case 36663:
                                            case 35053:
                                            case 35055:
                                            case 36010:
                                            case 35097:
                                            case 35869:
                                            case 32874:
                                            case 36389:
                                            case 35983:
                                            case 35368:
                                            case 34068:
                                                c = 0;
                                                break;
                                            default:
                                                X ||= 1280;
                                                return;
                                        }
                                        else {
                                            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
                                                for(a = 0; a < d.length; ++a)F[b + 4 * a >> 2] = d[a];
                                                return;
                                            }
                                            try {
                                                c = d.name | 0;
                                            } catch (e) {
                                                X ||= 1280;
                                                sa(`GL_INVALID_ENUM in glGet${0}v: Unknown object returned from WebGL getParameter(${a})! (error: ${e})`);
                                                return;
                                            }
                                        }
                                        break;
                                    default:
                                        X ||= 1280;
                                        sa(`GL_INVALID_ENUM in glGet${0}v: Native code calling glGet${0}v(${a}) and it returns ${d} of type ${typeof d}!`);
                                        return;
                                }
                                F[b >> 2] = c;
                            } else X ||= 1281;
                        }, Vd = (a)=>{
                            var b = fb(a) + 1, c = Ud(b);
                            c && gb(a, D, c, b);
                            return c;
                        }, Wd = (a)=>"]" == a.slice(-1) && a.lastIndexOf("["), Xd = (a)=>{
                            a -= 5120;
                            return 0 == a ? B : 1 == a ? D : 2 == a ? E : 4 == a ? F : 6 == a ? xa : 5 == a || 28922 == a || 28520 == a || 30779 == a || 30782 == a ? H : wa;
                        }, Yd = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Zd = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], $d = (a, b, c, d)=>{
                            function e(p, r, u) {
                                for(p = "number" == typeof p ? p.toString() : p || ""; p.length < r;)p = u[0] + p;
                                return p;
                            }
                            function f(p, r) {
                                return e(p, r, "0");
                            }
                            function g(p, r) {
                                function u(A) {
                                    return 0 > A ? -1 : 0 < A ? 1 : 0;
                                }
                                var z;
                                0 === (z = u(p.getFullYear() - r.getFullYear())) && 0 === (z = u(p.getMonth() - r.getMonth())) && (z = u(p.getDate() - r.getDate()));
                                return z;
                            }
                            function k(p) {
                                switch(p.getDay()){
                                    case 0:
                                        return new Date(p.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return p;
                                    case 2:
                                        return new Date(p.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(p.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(p.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(p.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(p.getFullYear() - 1, 11, 30);
                                }
                            }
                            function m(p) {
                                var r = p.ca;
                                for(p = new Date(new Date(p.da + 1900, 0, 1).getTime()); 0 < r;){
                                    var u = p.getMonth(), z = (ud(p.getFullYear()) ? Yd : Zd)[u];
                                    if (r > z - p.getDate()) r -= z - p.getDate() + 1, p.setDate(1), 11 > u ? p.setMonth(u + 1) : (p.setMonth(0), p.setFullYear(p.getFullYear() + 1));
                                    else {
                                        p.setDate(p.getDate() + r);
                                        break;
                                    }
                                }
                                u = new Date(p.getFullYear() + 1, 0, 4);
                                r = k(new Date(p.getFullYear(), 0, 4));
                                u = k(u);
                                return 0 >= g(r, p) ? 0 >= g(u, p) ? p.getFullYear() + 1 : p.getFullYear() : p.getFullYear() - 1;
                            }
                            var n = H[d + 40 >> 2];
                            d = {
                                jc: F[d >> 2],
                                ic: F[d + 4 >> 2],
                                Ha: F[d + 8 >> 2],
                                Va: F[d + 12 >> 2],
                                Ia: F[d + 16 >> 2],
                                da: F[d + 20 >> 2],
                                R: F[d + 24 >> 2],
                                ca: F[d + 28 >> 2],
                                Lc: F[d + 32 >> 2],
                                hc: F[d + 36 >> 2],
                                kc: n ? n ? L(D, n) : "" : ""
                            };
                            c = c ? L(D, c) : "";
                            n = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var t in n)c = c.replace(new RegExp(t, "g"), n[t]);
                            var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
                            n = {
                                "%a": (p)=>v[p.R].substring(0, 3),
                                "%A": (p)=>v[p.R],
                                "%b": (p)=>x[p.Ia].substring(0, 3),
                                "%B": (p)=>x[p.Ia],
                                "%C": (p)=>f((p.da + 1900) / 100 | 0, 2),
                                "%d": (p)=>f(p.Va, 2),
                                "%e": (p)=>e(p.Va, 2, " "),
                                "%g": (p)=>m(p).toString().substring(2),
                                "%G": m,
                                "%H": (p)=>f(p.Ha, 2),
                                "%I": (p)=>{
                                    p = p.Ha;
                                    0 == p ? p = 12 : 12 < p && (p -= 12);
                                    return f(p, 2);
                                },
                                "%j": (p)=>{
                                    for(var r = 0, u = 0; u <= p.Ia - 1; r += (ud(p.da + 1900) ? Yd : Zd)[u++]);
                                    return f(p.Va + r, 3);
                                },
                                "%m": (p)=>f(p.Ia + 1, 2),
                                "%M": (p)=>f(p.ic, 2),
                                "%n": ()=>"\n",
                                "%p": (p)=>0 <= p.Ha && 12 > p.Ha ? "AM" : "PM",
                                "%S": (p)=>f(p.jc, 2),
                                "%t": ()=>"\t",
                                "%u": (p)=>p.R || 7,
                                "%U": (p)=>f(Math.floor((p.ca + 7 - p.R) / 7), 2),
                                "%V": (p)=>{
                                    var r = Math.floor((p.ca + 7 - (p.R + 6) % 7) / 7);
                                    2 >= (p.R + 371 - p.ca - 2) % 7 && r++;
                                    if (r) 53 == r && (u = (p.R + 371 - p.ca) % 7, 4 == u || 3 == u && ud(p.da) || (r = 1));
                                    else {
                                        r = 52;
                                        var u = (p.R + 7 - p.ca - 1) % 7;
                                        (4 == u || 5 == u && ud(p.da % 400 - 1)) && r++;
                                    }
                                    return f(r, 2);
                                },
                                "%w": (p)=>p.R,
                                "%W": (p)=>f(Math.floor((p.ca + 7 - (p.R + 6) % 7) / 7), 2),
                                "%y": (p)=>(p.da + 1900).toString().substring(2),
                                "%Y": (p)=>p.da + 1900,
                                "%z": (p)=>{
                                    p = p.hc;
                                    var r = 0 <= p;
                                    p = Math.abs(p) / 60;
                                    return (r ? "+" : "-") + String("0000" + (p / 60 * 100 + p % 60)).slice(-4);
                                },
                                "%Z": (p)=>p.kc,
                                "%%": ()=>"%"
                            };
                            c = c.replace(/%%/g, "\x00\x00");
                            for(t in n)c.includes(t) && (c = c.replace(new RegExp(t, "g"), n[t](d)));
                            c = c.replace(/\0\0/g, "%");
                            t = hb(c, !1);
                            if (t.length > b) return 0;
                            B.set(t, a);
                            return t.length - 1;
                        };
                        [
                            44
                        ].forEach((a)=>{
                            sb[a] = new M(a);
                            sb[a].stack = "<generic error, no stack>";
                        });
                        zb = Array(4096);
                        Nb(N, "/");
                        Pb("/tmp");
                        Pb("/home");
                        Pb("/home/web_user");
                        (function() {
                            Pb("/dev");
                            kb(259, {
                                read: ()=>0,
                                write: (d, e, f, g)=>g
                            });
                            Qb("/dev/null", 259);
                            jb(1280, mb);
                            jb(1536, ob);
                            Qb("/dev/tty", 1280);
                            Qb("/dev/tty1", 1536);
                            var a = new Uint8Array(1024), b = 0, c = ()=>{
                                0 === b && (b = bb(a).byteLength);
                                return a[--b];
                            };
                            Wb("random", c);
                            Wb("urandom", c);
                            Pb("/dev/shm");
                            Pb("/dev/shm/tmp");
                        })();
                        (function() {
                            Pb("/proc");
                            var a = Pb("/proc/self");
                            Pb("/proc/self/fd");
                            Nb({
                                U () {
                                    var b = rb(a, "fd", 16895, 73);
                                    b.j = {
                                        la (c, d) {
                                            var e = Kb(+d);
                                            c = {
                                                parent: null,
                                                U: {
                                                    kb: "fake"
                                                },
                                                j: {
                                                    ma: ()=>e.path
                                                }
                                            };
                                            return c.parent = c;
                                        }
                                    };
                                    return b;
                                }
                            }, "/proc/self/fd");
                        })();
                        P = l.BindingError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "BindingError";
                            }
                        };
                        O.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1);
                        l.count_emval_handles = ()=>O.length / 2 - 5 - $b.length;
                        cc = l.PureVirtualError = bc("PureVirtualError");
                        for(var ae = Array(256), be = 0; 256 > be; ++be)ae[be] = String.fromCharCode(be);
                        dc = ae;
                        l.getInheritedInstanceCount = ()=>Object.keys(hc).length;
                        l.getLiveInheritedInstances = ()=>{
                            var a = [], b;
                            for(b in hc)hc.hasOwnProperty(b) && a.push(hc[b]);
                            return a;
                        };
                        l.flushPendingDeletes = fc;
                        l.setDelayFunction = (a)=>{
                            gc = a;
                            ec.length && gc && gc(fc);
                        };
                        tc = l.InternalError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "InternalError";
                            }
                        };
                        Object.assign(Dc.prototype, {
                            isAliasOf: function(a) {
                                if (!(this instanceof Dc && a instanceof Dc)) return !1;
                                var b = this.g.u.i, c = this.g.o;
                                a.g = a.g;
                                var d = a.g.u.i;
                                for(a = a.g.o; b.B;)c = b.oa(c), b = b.B;
                                for(; d.B;)a = d.oa(a), d = d.B;
                                return b === d && c === a;
                            },
                            clone: function() {
                                this.g.o || Cc(this);
                                if (this.g.ja) return this.g.count.value += 1, this;
                                var a = uc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
                                a = a(c.call(b, d, {
                                    g: {
                                        value: {
                                            count: e.count,
                                            ha: e.ha,
                                            ja: e.ja,
                                            o: e.o,
                                            u: e.u,
                                            F: e.F,
                                            J: e.J
                                        }
                                    }
                                }));
                                a.g.count.value += 1;
                                a.g.ha = !1;
                                return a;
                            },
                            ["delete"] () {
                                this.g.o || Cc(this);
                                if (this.g.ha && !this.g.ja) throw new P("Object already scheduled for deletion");
                                oc(this);
                                var a = this.g;
                                --a.count.value;
                                0 === a.count.value && (a.F ? a.J.O(a.F) : a.u.i.O(a.o));
                                this.g.ja || (this.g.F = void 0, this.g.o = void 0);
                            },
                            isDeleted: function() {
                                return !this.g.o;
                            },
                            deleteLater: function() {
                                this.g.o || Cc(this);
                                if (this.g.ha && !this.g.ja) throw new P("Object already scheduled for deletion");
                                ec.push(this);
                                1 === ec.length && gc && gc(fc);
                                this.g.ha = !0;
                                return this;
                            }
                        });
                        Object.assign(Nc.prototype, {
                            Ob (a) {
                                this.qb && (a = this.qb(a));
                                return a;
                            },
                            bb (a) {
                                this.O?.(a);
                            },
                            argPackAdvance: 8,
                            readValueFromPointer: yc,
                            fromWireType: function(a) {
                                function b() {
                                    return this.wa ? vc(this.i.M, {
                                        u: this.ac,
                                        o: c,
                                        J: this,
                                        F: a
                                    }) : vc(this.i.M, {
                                        u: this,
                                        o: a
                                    });
                                }
                                var c = this.Ob(a);
                                if (!c) return this.bb(a), null;
                                var d = sc(this.i, c);
                                if (void 0 !== d) {
                                    if (0 === d.g.count.value) return d.g.o = c, d.g.F = a, d.clone();
                                    d = d.clone();
                                    this.bb(a);
                                    return d;
                                }
                                d = this.i.Nb(c);
                                d = rc[d];
                                if (!d) return b.call(this);
                                d = this.va ? d.Gb : d.pointerType;
                                var e = qc(c, this.i, d.i);
                                return null === e ? b.call(this) : this.wa ? vc(d.i.M, {
                                    u: d,
                                    o: e,
                                    J: this,
                                    F: a
                                }) : vc(d.i.M, {
                                    u: d,
                                    o: e
                                });
                            }
                        });
                        Uc = l.UnboundTypeError = bc("UnboundTypeError");
                        for(var W, ce = 0; 32 > ce; ++ce)Rd.push(Array(ce));
                        var ee = {
                            __syscall_fcntl64: function(a, b, c) {
                                Wa = c;
                                try {
                                    var d = Kb(a);
                                    switch(b){
                                        case 0:
                                            var e = Va();
                                            if (0 > e) break;
                                            for(; xb[e];)e++;
                                            return Mb(d, e).W;
                                        case 1:
                                        case 2:
                                            return 0;
                                        case 3:
                                            return d.flags;
                                        case 4:
                                            return e = Va(), d.flags |= e, 0;
                                        case 12:
                                            return e = Va(), E[e + 0 >> 1] = 2, 0;
                                        case 13:
                                        case 14:
                                            return 0;
                                    }
                                    return -28;
                                } catch (f) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== f.name) throw f;
                                    return -f.$;
                                }
                            },
                            __syscall_ioctl: function(a, b, c) {
                                Wa = c;
                                try {
                                    var d = Kb(a);
                                    switch(b){
                                        case 21509:
                                            return d.s ? 0 : -59;
                                        case 21505:
                                            if (!d.s) return -59;
                                            if (d.s.V.Vb) {
                                                a = [
                                                    3,
                                                    28,
                                                    127,
                                                    21,
                                                    4,
                                                    0,
                                                    1,
                                                    0,
                                                    17,
                                                    19,
                                                    26,
                                                    0,
                                                    18,
                                                    15,
                                                    23,
                                                    22,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                var e = Va();
                                                F[e >> 2] = 25856;
                                                F[e + 4 >> 2] = 5;
                                                F[e + 8 >> 2] = 191;
                                                F[e + 12 >> 2] = 35387;
                                                for(var f = 0; 32 > f; f++)B[e + f + 17] = a[f] || 0;
                                            }
                                            return 0;
                                        case 21510:
                                        case 21511:
                                        case 21512:
                                            return d.s ? 0 : -59;
                                        case 21506:
                                        case 21507:
                                        case 21508:
                                            if (!d.s) return -59;
                                            if (d.s.V.Wb) for(e = Va(), a = [], f = 0; 32 > f; f++)a.push(B[e + f + 17]);
                                            return 0;
                                        case 21519:
                                            if (!d.s) return -59;
                                            e = Va();
                                            return F[e >> 2] = 0;
                                        case 21520:
                                            return d.s ? -28 : -59;
                                        case 21531:
                                            e = Va();
                                            if (!d.m.Ub) throw new M(59);
                                            return d.m.Ub(d, b, e);
                                        case 21523:
                                            if (!d.s) return -59;
                                            d.s.V.Xb && (f = [
                                                24,
                                                80
                                            ], e = Va(), E[e >> 1] = f[0], E[e + 2 >> 1] = f[1]);
                                            return 0;
                                        case 21524:
                                            return d.s ? 0 : -59;
                                        case 21515:
                                            return d.s ? 0 : -59;
                                        default:
                                            return -28;
                                    }
                                } catch (g) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== g.name) throw g;
                                    return -g.$;
                                }
                            },
                            __syscall_openat: function(a, b, c, d) {
                                Wa = d;
                                try {
                                    b = b ? L(D, b) : "";
                                    var e = b;
                                    if ("/" === e.charAt(0)) b = e;
                                    else {
                                        var f = -100 === a ? "/" : Kb(a).path;
                                        if (0 == e.length) throw new M(44);
                                        b = Ya(f + "/" + e);
                                    }
                                    var g = d ? Va() : 0;
                                    return Sb(b, c, g).W;
                                } catch (k) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== k.name) throw k;
                                    return -k.$;
                                }
                            },
                            _abort_js: ()=>{
                                Ha("");
                            },
                            _embind_create_inheriting_constructor: (a, b, c)=>{
                                a = R(a);
                                b = nc(b, "wrapper");
                                c = Q(c);
                                var d = b.i, e = d.M, f = d.B.M, g = d.B.constructor;
                                a = Zb(a, function(...k) {
                                    d.B.ob.forEach((function(m) {
                                        if (this[m] === f[m]) throw new cc(`Pure virtual function ${m} must be implemented in JavaScript`);
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: e
                                    });
                                    this.__construct(...k);
                                });
                                e.__construct = function(...k) {
                                    if (this === e) throw new P("Pass correct 'this' to __construct");
                                    k = g.implement(this, ...k);
                                    oc(k);
                                    var m = k.g;
                                    k.notifyOnDestruction();
                                    m.ja = !0;
                                    Object.defineProperties(this, {
                                        g: {
                                            value: m
                                        }
                                    });
                                    uc(this);
                                    k = m.o;
                                    k = ic(d, k);
                                    if (hc.hasOwnProperty(k)) throw new P(`Tried to register registered instance: ${k}`);
                                    hc[k] = this;
                                };
                                e.__destruct = function() {
                                    if (this === e) throw new P("Pass correct 'this' to __destruct");
                                    oc(this);
                                    var k = this.g.o;
                                    k = ic(d, k);
                                    if (hc.hasOwnProperty(k)) delete hc[k];
                                    else throw new P(`Tried to unregister unregistered instance: ${k}`);
                                };
                                a.prototype = Object.create(e);
                                Object.assign(a.prototype, c);
                                return ac(a);
                            },
                            _embind_finalize_value_object: (a)=>{
                                var b = wc[a];
                                delete wc[a];
                                var c = b.Ta, d = b.O, e = b.eb, f = e.map((g)=>g.Rb).concat(e.map((g)=>g.dc));
                                T([
                                    a
                                ], f, (g)=>{
                                    var k = {};
                                    e.forEach((m, n)=>{
                                        var t = g[n], v = m.Pb, x = m.Qb, p = g[n + e.length], r = m.cc, u = m.ec;
                                        k[m.Lb] = {
                                            read: (z)=>t.fromWireType(v(x, z)),
                                            write: (z, A)=>{
                                                var C = [];
                                                r(u, z, p.toWireType(C, A));
                                                xc(C);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: b.name,
                                            fromWireType: (m)=>{
                                                var n = {}, t;
                                                for(t in k)n[t] = k[t].read(m);
                                                d(m);
                                                return n;
                                            },
                                            toWireType: (m, n)=>{
                                                for(var t in k){
                                                    if (!(t in n)) throw new TypeError(`Missing field: "${t}"`);
                                                }
                                                var v = c();
                                                for(t in k)k[t].write(v, n[t]);
                                                null !== m && m.push(d, v);
                                                return v;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: yc,
                                            L: d
                                        }
                                    ];
                                });
                            },
                            _embind_register_bigint: ()=>{},
                            _embind_register_bool: (a, b, c, d)=>{
                                b = R(b);
                                S(a, {
                                    name: b,
                                    fromWireType: function(e) {
                                        return !!e;
                                    },
                                    toWireType: function(e, f) {
                                        return f ? c : d;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function(e) {
                                        return this.fromWireType(D[e]);
                                    },
                                    L: null
                                });
                            },
                            _embind_register_class: (a, b, c, d, e, f, g, k, m, n, t, v, x)=>{
                                t = R(t);
                                f = U(e, f);
                                k &&= U(g, k);
                                n &&= U(m, n);
                                x = U(v, x);
                                var p = Gc(t);
                                Fc(p, function() {
                                    Vc(`Cannot construct ${t} due to unbound types`, [
                                        d
                                    ]);
                                });
                                T([
                                    a,
                                    b,
                                    c
                                ], d ? [
                                    d
                                ] : [], (r)=>{
                                    r = r[0];
                                    if (d) {
                                        var u = r.i;
                                        var z = u.M;
                                    } else z = Dc.prototype;
                                    r = Zb(t, function(...J) {
                                        if (Object.getPrototypeOf(this) !== A) throw new P("Use 'new' to construct " + t);
                                        if (void 0 === C.Z) throw new P(t + " has no accessible constructor");
                                        var K = C.Z[J.length];
                                        if (void 0 === K) throw new P(`Tried to invoke ctor of ${t} with invalid number of parameters (${J.length}) - expected (${Object.keys(C.Z).toString()}) parameters instead!`);
                                        return K.apply(this, J);
                                    });
                                    var A = Object.create(z, {
                                        constructor: {
                                            value: r
                                        }
                                    });
                                    r.prototype = A;
                                    var C = new Hc(t, r, A, x, u, f, k, n);
                                    if (C.B) {
                                        var G;
                                        (G = C.B).pa ?? (G.pa = []);
                                        C.B.pa.push(C);
                                    }
                                    u = new Nc(t, C, !0, !1, !1);
                                    G = new Nc(t + "*", C, !1, !1, !1);
                                    z = new Nc(t + " const*", C, !1, !0, !1);
                                    rc[a] = {
                                        pointerType: G,
                                        Gb: z
                                    };
                                    Oc(p, r);
                                    return [
                                        u,
                                        G,
                                        z
                                    ];
                                });
                            },
                            _embind_register_class_class_function: (a, b, c, d, e, f, g)=>{
                                var k = Yc(c, d);
                                b = R(b);
                                b = Zc(b);
                                f = U(e, f);
                                T([], [
                                    a
                                ], (m)=>{
                                    function n() {
                                        Vc(`Cannot call ${t} due to unbound types`, k);
                                    }
                                    m = m[0];
                                    var t = `${m.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    var v = m.i.constructor;
                                    void 0 === v[b] ? (n.ga = c - 1, v[b] = n) : (Ec(v, b, t), v[b].A[c - 1] = n);
                                    T([], k, (x)=>{
                                        x = Xc(t, [
                                            x[0],
                                            null
                                        ].concat(x.slice(1)), null, f, g);
                                        void 0 === v[b].A ? (x.ga = c - 1, v[b] = x) : v[b].A[c - 1] = x;
                                        if (m.i.pa) for (const p of m.i.pa)p.constructor.hasOwnProperty(b) || (p.constructor[b] = x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_class_property: (a, b, c, d, e, f, g, k)=>{
                                b = R(b);
                                f = U(e, f);
                                T([], [
                                    a
                                ], (m)=>{
                                    m = m[0];
                                    var n = `${m.name}.${b}`, t = {
                                        get () {
                                            Vc(`Cannot access ${n} due to unbound types`, [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    t.set = k ? ()=>{
                                        Vc(`Cannot access ${n} due to unbound types`, [
                                            c
                                        ]);
                                    } : ()=>{
                                        throw new P(`${n} is a read-only property`);
                                    };
                                    Object.defineProperty(m.i.constructor, b, t);
                                    T([], [
                                        c
                                    ], (v)=>{
                                        v = v[0];
                                        var x = {
                                            get () {
                                                return v.fromWireType(f(d));
                                            },
                                            enumerable: !0
                                        };
                                        k && (k = U(g, k), x.set = (p)=>{
                                            var r = [];
                                            k(d, v.toWireType(r, p));
                                            xc(r);
                                        });
                                        Object.defineProperty(m.i.constructor, b, x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_constructor: (a, b, c, d, e, f)=>{
                                var g = Yc(b, c);
                                e = U(d, e);
                                T([], [
                                    a
                                ], (k)=>{
                                    k = k[0];
                                    var m = `constructor ${k.name}`;
                                    void 0 === k.i.Z && (k.i.Z = []);
                                    if (void 0 !== k.i.Z[b - 1]) throw new P(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${k.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                                    k.i.Z[b - 1] = ()=>{
                                        Vc(`Cannot construct ${k.name} due to unbound types`, g);
                                    };
                                    T([], g, (n)=>{
                                        n.splice(1, 0, null);
                                        k.i.Z[b - 1] = Xc(m, n, null, e, f);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_function: (a, b, c, d, e, f, g, k)=>{
                                var m = Yc(c, d);
                                b = R(b);
                                b = Zc(b);
                                f = U(e, f);
                                T([], [
                                    a
                                ], (n)=>{
                                    function t() {
                                        Vc(`Cannot call ${v} due to unbound types`, m);
                                    }
                                    n = n[0];
                                    var v = `${n.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    k && n.i.ob.push(b);
                                    var x = n.i.M, p = x[b];
                                    void 0 === p || void 0 === p.A && p.className !== n.name && p.ga === c - 2 ? (t.ga = c - 2, t.className = n.name, x[b] = t) : (Ec(x, b, v), x[b].A[c - 2] = t);
                                    T([], m, (r)=>{
                                        r = Xc(v, r, n, f, g);
                                        void 0 === x[b].A ? (r.ga = c - 2, x[b] = r) : x[b].A[c - 2] = r;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_property: (a, b, c, d, e, f, g, k, m, n)=>{
                                b = R(b);
                                e = U(d, e);
                                T([], [
                                    a
                                ], (t)=>{
                                    t = t[0];
                                    var v = `${t.name}.${b}`, x = {
                                        get () {
                                            Vc(`Cannot access ${v} due to unbound types`, [
                                                c,
                                                g
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    x.set = m ? ()=>Vc(`Cannot access ${v} due to unbound types`, [
                                            c,
                                            g
                                        ]) : ()=>{
                                        throw new P(v + " is a read-only property");
                                    };
                                    Object.defineProperty(t.i.M, b, x);
                                    T([], m ? [
                                        c,
                                        g
                                    ] : [
                                        c
                                    ], (p)=>{
                                        var r = p[0], u = {
                                            get () {
                                                var A = $c(this, t, v + " getter");
                                                return r.fromWireType(e(f, A));
                                            },
                                            enumerable: !0
                                        };
                                        if (m) {
                                            m = U(k, m);
                                            var z = p[1];
                                            u.set = function(A) {
                                                var C = $c(this, t, v + " setter"), G = [];
                                                m(n, C, z.toWireType(G, A));
                                                xc(G);
                                            };
                                        }
                                        Object.defineProperty(t.i.M, b, u);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_emval: (a)=>S(a, bd),
                            _embind_register_enum: (a, b, c, d)=>{
                                function e() {}
                                b = R(b);
                                e.values = {};
                                S(a, {
                                    name: b,
                                    constructor: e,
                                    fromWireType: function(f) {
                                        return this.constructor.values[f];
                                    },
                                    toWireType: (f, g)=>g.value,
                                    argPackAdvance: 8,
                                    readValueFromPointer: cd(b, c, d),
                                    L: null
                                });
                                Fc(b, e);
                            },
                            _embind_register_enum_value: (a, b, c)=>{
                                var d = nc(a, "enum");
                                b = R(b);
                                a = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: Zb(`${d.name}_${b}`, function() {})
                                    }
                                });
                                a.values[c] = d;
                                a[b] = d;
                            },
                            _embind_register_float: (a, b, c)=>{
                                b = R(b);
                                S(a, {
                                    name: b,
                                    fromWireType: (d)=>d,
                                    toWireType: (d, e)=>e,
                                    argPackAdvance: 8,
                                    readValueFromPointer: dd(b, c),
                                    L: null
                                });
                            },
                            _embind_register_function: (a, b, c, d, e, f)=>{
                                var g = Yc(b, c);
                                a = R(a);
                                a = Zc(a);
                                e = U(d, e);
                                Fc(a, function() {
                                    Vc(`Cannot call ${a} due to unbound types`, g);
                                }, b - 1);
                                T([], g, (k)=>{
                                    Oc(a, Xc(a, [
                                        k[0],
                                        null
                                    ].concat(k.slice(1)), null, e, f), b - 1);
                                    return [];
                                });
                            },
                            _embind_register_integer: (a, b, c, d, e)=>{
                                b = R(b);
                                -1 === e && (e = 4294967295);
                                e = (k)=>k;
                                if (0 === d) {
                                    var f = 32 - 8 * c;
                                    e = (k)=>k << f >>> f;
                                }
                                var g = b.includes("unsigned") ? function(k, m) {
                                    return m >>> 0;
                                } : function(k, m) {
                                    return m;
                                };
                                S(a, {
                                    name: b,
                                    fromWireType: e,
                                    toWireType: g,
                                    argPackAdvance: 8,
                                    readValueFromPointer: ed(b, c, 0 !== d),
                                    L: null
                                });
                            },
                            _embind_register_memory_view: (a, b, c)=>{
                                function d(f) {
                                    return new e(B.buffer, H[f + 4 >> 2], H[f >> 2]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][b];
                                c = R(c);
                                S(a, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    Sb: !0
                                });
                            },
                            _embind_register_std_string: (a, b)=>{
                                b = R(b);
                                var c = "std::string" === b;
                                S(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        var e = H[d >> 2], f = d + 4;
                                        if (c) for(var g = f, k = 0; k <= e; ++k){
                                            var m = f + k;
                                            if (k == e || 0 == D[m]) {
                                                g = g ? L(D, g, m - g) : "";
                                                if (void 0 === n) var n = g;
                                                else n += String.fromCharCode(0), n += g;
                                                g = m + 1;
                                            }
                                        }
                                        else {
                                            n = Array(e);
                                            for(k = 0; k < e; ++k)n[k] = String.fromCharCode(D[f + k]);
                                            n = n.join("");
                                        }
                                        lc(d);
                                        return n;
                                    },
                                    toWireType: function(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var f = "string" == typeof e;
                                        if (!(f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array)) throw new P("Cannot pass non-string to std::string");
                                        var g = c && f ? fb(e) : e.length;
                                        var k = Ud(4 + g + 1), m = k + 4;
                                        H[k >> 2] = g;
                                        if (c && f) gb(e, D, m, g + 1);
                                        else {
                                            if (f) for(f = 0; f < g; ++f){
                                                var n = e.charCodeAt(f);
                                                if (255 < n) throw lc(m), new P("String has UTF-16 code units that do not fit in 8 bits");
                                                D[m + f] = n;
                                            }
                                            else for(f = 0; f < g; ++f)D[m + f] = e[f];
                                        }
                                        null !== d && d.push(lc, k);
                                        return k;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: yc,
                                    L (d) {
                                        lc(d);
                                    }
                                });
                            },
                            _embind_register_std_wstring: (a, b, c)=>{
                                c = R(c);
                                if (2 === b) {
                                    var d = gd;
                                    var e = hd;
                                    var f = jd;
                                    var g = (k)=>wa[k >> 1];
                                } else 4 === b && (d = kd, e = ld, f = md, g = (k)=>H[k >> 2]);
                                S(a, {
                                    name: c,
                                    fromWireType: (k)=>{
                                        for(var m = H[k >> 2], n, t = k + 4, v = 0; v <= m; ++v){
                                            var x = k + 4 + v * b;
                                            if (v == m || 0 == g(x)) t = d(t, x - t), void 0 === n ? n = t : (n += String.fromCharCode(0), n += t), t = x + b;
                                        }
                                        lc(k);
                                        return n;
                                    },
                                    toWireType: (k, m)=>{
                                        if ("string" != typeof m) throw new P(`Cannot pass non-string to C++ string type ${c}`);
                                        var n = f(m), t = Ud(4 + n + b);
                                        H[t >> 2] = n / b;
                                        e(m, t + 4, n + b);
                                        null !== k && k.push(lc, t);
                                        return t;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: yc,
                                    L (k) {
                                        lc(k);
                                    }
                                });
                            },
                            _embind_register_value_object: (a, b, c, d, e, f)=>{
                                wc[a] = {
                                    name: R(b),
                                    Ta: U(c, d),
                                    O: U(e, f),
                                    eb: []
                                };
                            },
                            _embind_register_value_object_field: (a, b, c, d, e, f, g, k, m, n)=>{
                                wc[a].eb.push({
                                    Lb: R(b),
                                    Rb: c,
                                    Pb: U(d, e),
                                    Qb: f,
                                    dc: g,
                                    cc: U(k, m),
                                    ec: n
                                });
                            },
                            _embind_register_void: (a, b)=>{
                                b = R(b);
                                S(a, {
                                    Dc: !0,
                                    name: b,
                                    argPackAdvance: 0,
                                    fromWireType: ()=>{},
                                    toWireType: ()=>{}
                                });
                            },
                            _emscripten_get_now_is_monotonic: ()=>1,
                            _emscripten_memcpy_js: (a, b, c)=>D.copyWithin(a, b, b + c),
                            _emscripten_throw_longjmp: ()=>{
                                throw Infinity;
                            },
                            _emval_as: (a, b, c)=>{
                                a = Q(a);
                                b = nc(b, "emval::as");
                                return nd(b, c, a);
                            },
                            _emval_call_method: (a, b, c, d, e)=>{
                                a = qd[a];
                                b = Q(b);
                                c = pd(c);
                                return a(b, b[c], d, e);
                            },
                            _emval_decref: ad,
                            _emval_get_method_caller: (a, b, c)=>{
                                var d = sd(a, b), e = d.shift();
                                a--;
                                var f = Array(a);
                                b = `methodCaller<(${d.map((g)=>g.name).join(", ")}) => ${e.name}>`;
                                return rd(Zb(b, (g, k, m, n)=>{
                                    for(var t = 0, v = 0; v < a; ++v)f[v] = d[v].readValueFromPointer(n + t), t += d[v].argPackAdvance;
                                    g = 1 === c ? td(k, f) : k.apply(g, f);
                                    return nd(e, m, g);
                                }));
                            },
                            _emval_get_property: (a, b)=>{
                                a = Q(a);
                                b = Q(b);
                                return ac(a[b]);
                            },
                            _emval_incref: (a)=>{
                                9 < a && (O[a + 1] += 1);
                            },
                            _emval_new_array: ()=>ac([]),
                            _emval_new_cstring: (a)=>ac(pd(a)),
                            _emval_new_object: ()=>ac({}),
                            _emval_run_destructors: (a)=>{
                                var b = Q(a);
                                xc(b);
                                ad(a);
                            },
                            _emval_set_property: (a, b, c)=>{
                                a = Q(a);
                                b = Q(b);
                                c = Q(c);
                                a[b] = c;
                            },
                            _emval_take_value: (a, b)=>{
                                a = nc(a, "_emval_take_value");
                                a = a.readValueFromPointer(b);
                                return ac(a);
                            },
                            _gmtime_js: function(a, b, c) {
                                a = new Date(1000 * (b + 2097152 >>> 0 < 4194305 - !!a ? (a >>> 0) + 4294967296 * b : NaN));
                                F[c >> 2] = a.getUTCSeconds();
                                F[c + 4 >> 2] = a.getUTCMinutes();
                                F[c + 8 >> 2] = a.getUTCHours();
                                F[c + 12 >> 2] = a.getUTCDate();
                                F[c + 16 >> 2] = a.getUTCMonth();
                                F[c + 20 >> 2] = a.getUTCFullYear() - 1900;
                                F[c + 24 >> 2] = a.getUTCDay();
                                F[c + 28 >> 2] = (a.getTime() - Date.UTC(a.getUTCFullYear(), 0, 1, 0, 0, 0, 0)) / 864E5 | 0;
                            },
                            _localtime_js: function(a, b, c) {
                                a = new Date(1000 * (b + 2097152 >>> 0 < 4194305 - !!a ? (a >>> 0) + 4294967296 * b : NaN));
                                F[c >> 2] = a.getSeconds();
                                F[c + 4 >> 2] = a.getMinutes();
                                F[c + 8 >> 2] = a.getHours();
                                F[c + 12 >> 2] = a.getDate();
                                F[c + 16 >> 2] = a.getMonth();
                                F[c + 20 >> 2] = a.getFullYear() - 1900;
                                F[c + 24 >> 2] = a.getDay();
                                F[c + 28 >> 2] = (ud(a.getFullYear()) ? vd : wd)[a.getMonth()] + a.getDate() - 1 | 0;
                                F[c + 36 >> 2] = -(60 * a.getTimezoneOffset());
                                b = new Date(a.getFullYear(), 6, 1).getTimezoneOffset();
                                var d = new Date(a.getFullYear(), 0, 1).getTimezoneOffset();
                                F[c + 32 >> 2] = (b != d && a.getTimezoneOffset() == Math.min(d, b)) | 0;
                            },
                            _tzset_js: (a, b, c, d)=>{
                                var e = new Date().getFullYear(), f = new Date(e, 0, 1), g = new Date(e, 6, 1);
                                e = f.getTimezoneOffset();
                                var k = g.getTimezoneOffset();
                                H[a >> 2] = 60 * Math.max(e, k);
                                F[b >> 2] = Number(e != k);
                                a = (m)=>m.toLocaleTimeString(void 0, {
                                        hour12: !1,
                                        timeZoneName: "short"
                                    }).split(" ")[1];
                                f = a(f);
                                g = a(g);
                                k < e ? (gb(f, D, c, 17), gb(g, D, d, 17)) : (gb(f, D, d, 17), gb(g, D, c, 17));
                            },
                            beginPixelLocalStorageWEBGL: function(a, b, c) {
                                (a = w[a].C.ba) && a.beginPixelLocalStorageWEBGL(l.HEAPU32.subarray(c, c + b));
                            },
                            decode_image: function(a, b, c) {
                                var d = l.images;
                                d || (d = new Map(), l.images = d);
                                var e = new Image();
                                d.set(a, e);
                                b = l.HEAP8.subarray(b, b + c);
                                c = new Uint8Array(c);
                                c.set(b);
                                e.src = URL.createObjectURL(new Blob([
                                    c
                                ], {
                                    type: "image/png"
                                }));
                                e.onload = function() {
                                    l._setWebImage(a, e.width, e.height);
                                };
                            },
                            delete_image: function(a) {
                                var b = l.images;
                                b && b.get(a) && b.delete(a);
                            },
                            emscripten_asm_const_int: (a, b, c)=>{
                                xd.length = 0;
                                for(var d; d = D[b++];){
                                    var e = 105 != d;
                                    e &= 112 != d;
                                    c += e && c % 8 ? 4 : 0;
                                    xd.push(112 == d ? H[c >> 2] : 105 == d ? F[c >> 2] : ya[c >> 3]);
                                    c += e ? 8 : 4;
                                }
                                return Ta[a](...xd);
                            },
                            emscripten_date_now: ()=>Date.now(),
                            emscripten_get_now: ()=>performance.now(),
                            emscripten_resize_heap: (a)=>{
                                var b = D.length;
                                a >>>= 0;
                                if (2147483648 < a) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = b * (1 + 0.2 / c);
                                    d = Math.min(d, a + 100663296);
                                    var e = Math;
                                    d = Math.max(a, d);
                                    a: {
                                        e = (e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - ua.buffer.byteLength + 65535) / 65536;
                                        try {
                                            ua.grow(e);
                                            za();
                                            var f = 1;
                                            break a;
                                        } catch (g) {}
                                        f = void 0;
                                    }
                                    if (f) return !0;
                                }
                                return !1;
                            },
                            emscripten_webgl_enable_extension: (a, b)=>{
                                a = w[a];
                                b = b ? L(D, b) : "";
                                b.startsWith("GL_") && (b = b.substr(3));
                                "WEBGL_draw_instanced_base_vertex_base_instance" == b && yd(W);
                                "WEBGL_multi_draw_instanced_base_vertex_base_instance" == b && zd(W);
                                "WEBGL_multi_draw" == b && (W.Zb = W.getExtension("WEBGL_multi_draw"));
                                return !!a.C.getExtension(b);
                            },
                            emscripten_webgl_get_current_context: ()=>q ? q.handle : 0,
                            emscripten_webgl_make_context_current: (a)=>la(a) ? 0 : -5,
                            enable_WEBGL_provoking_vertex: function(a) {
                                a = w[a].C;
                                a.pb = a.getExtension("WEBGL_provoking_vertex");
                                return !!a.pb;
                            },
                            enable_WEBGL_shader_pixel_local_storage_coherent: function(a) {
                                a = w[a].C;
                                a.ba = a.getExtension("WEBGL_shader_pixel_local_storage");
                                return !(!a.ba || !a.ba.isCoherent());
                            },
                            endPixelLocalStorageWEBGL: function(a, b, c) {
                                (a = w[a].C.ba) && a.endPixelLocalStorageWEBGL(l.HEAPU32.subarray(c, c + b));
                            },
                            environ_get: (a, b)=>{
                                var c = 0;
                                Qd().forEach((d, e)=>{
                                    var f = b + c;
                                    e = H[a + 4 * e >> 2] = f;
                                    for(f = 0; f < d.length; ++f)B[e++] = d.charCodeAt(f);
                                    B[e] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            environ_sizes_get: (a, b)=>{
                                var c = Qd();
                                H[a >> 2] = c.length;
                                var d = 0;
                                c.forEach((e)=>d += e.length + 1);
                                H[b >> 2] = d;
                                return 0;
                            },
                            fd_close: function(a) {
                                try {
                                    var b = Kb(a);
                                    if (null === b.W) throw new M(8);
                                    b.Qa && (b.Qa = null);
                                    try {
                                        b.m.close && b.m.close(b);
                                    } catch (c) {
                                        throw c;
                                    } finally{
                                        xb[b.W] = null;
                                    }
                                    b.W = null;
                                    return 0;
                                } catch (c) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== c.name) throw c;
                                    return c.$;
                                }
                            },
                            fd_read: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Kb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var k = H[a >> 2], m = H[a + 4 >> 2];
                                            a += 8;
                                            var n = e, t = f, v = B;
                                            if (0 > m || 0 > t) throw new M(28);
                                            if (null === n.W) throw new M(8);
                                            if (1 === (n.flags & 2097155)) throw new M(8);
                                            if (16384 === (n.node.mode & 61440)) throw new M(31);
                                            if (!n.m.read) throw new M(28);
                                            var x = "undefined" != typeof t;
                                            if (!x) t = n.position;
                                            else if (!n.seekable) throw new M(70);
                                            var p = n.m.read(n, v, k, m, t);
                                            x || (n.position += p);
                                            var r = p;
                                            if (0 > r) {
                                                var u = -1;
                                                break a;
                                            }
                                            b += r;
                                            if (r < m) break;
                                            "undefined" != typeof f && (f += r);
                                        }
                                        u = b;
                                    }
                                    H[d >> 2] = u;
                                    return 0;
                                } catch (z) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== z.name) throw z;
                                    return z.$;
                                }
                            },
                            fd_seek: function(a, b, c, d, e) {
                                b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
                                try {
                                    if (isNaN(b)) return 61;
                                    var f = Kb(a);
                                    Ub(f, b, d);
                                    Pa = [
                                        f.position >>> 0,
                                        (Oa = f.position, 1.0 <= +Math.abs(Oa) ? 0.0 < Oa ? +Math.floor(Oa / 4294967296.0) >>> 0 : ~~+Math.ceil((Oa - +(~~Oa >>> 0)) / 4294967296.0) >>> 0 : 0)
                                    ];
                                    F[e >> 2] = Pa[0];
                                    F[e + 4 >> 2] = Pa[1];
                                    f.Qa && 0 === b && 0 === d && (f.Qa = null);
                                    return 0;
                                } catch (g) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== g.name) throw g;
                                    return g.$;
                                }
                            },
                            fd_write: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Kb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var k = H[a >> 2], m = H[a + 4 >> 2];
                                            a += 8;
                                            var n = e, t = k, v = m, x = f, p = B;
                                            if (0 > v || 0 > x) throw new M(28);
                                            if (null === n.W) throw new M(8);
                                            if (0 === (n.flags & 2097155)) throw new M(8);
                                            if (16384 === (n.node.mode & 61440)) throw new M(31);
                                            if (!n.m.write) throw new M(28);
                                            n.seekable && n.flags & 1024 && Ub(n, 0, 2);
                                            var r = "undefined" != typeof x;
                                            if (!r) x = n.position;
                                            else if (!n.seekable) throw new M(70);
                                            var u = n.m.write(n, p, t, v, x, void 0);
                                            r || (n.position += u);
                                            var z = u;
                                            if (0 > z) {
                                                var A = -1;
                                                break a;
                                            }
                                            b += z;
                                            "undefined" != typeof f && (f += z);
                                        }
                                        A = b;
                                    }
                                    H[d >> 2] = A;
                                    return 0;
                                } catch (C) {
                                    if ("undefined" == typeof Yb || "ErrnoError" !== C.name) throw C;
                                    return C.$;
                                }
                            },
                            framebufferPixelLocalClearValuefvWEBGL: function(a, b, c, d, e, f) {
                                (a = w[a].C.ba) && a.framebufferPixelLocalClearValuefvWEBGL(b, [
                                    c,
                                    d,
                                    e,
                                    f
                                ]);
                            },
                            framebufferTexturePixelLocalStorageWEBGL: function(a, b, c, d, e) {
                                (a = w[a].C.ba) && a.framebufferTexturePixelLocalStorageWEBGL(b, Fd[c], d, e);
                            },
                            getFramebufferPixelLocalStorageParameterivWEBGL: function(a, b, c) {
                                return (a = w[a].C.ba) ? a.getFramebufferPixelLocalStorageParameterWEBGL(b, c) : 0;
                            },
                            glActiveTexture: (a)=>W.activeTexture(a),
                            glAttachShader: (a, b)=>{
                                W.attachShader(V[a], Gd[b]);
                            },
                            glBindBuffer: (a, b)=>{
                                35051 == a ? W.Na = b : 35052 == a && (W.Oa = b);
                                W.bindBuffer(a, Cd[b]);
                            },
                            glBindBufferRange: (a, b, c, d, e)=>{
                                W.bindBufferRange(a, b, Cd[c], d, e);
                            },
                            glBindFramebuffer: (a, b)=>{
                                W.bindFramebuffer(a, Dd[b]);
                            },
                            glBindRenderbuffer: (a, b)=>{
                                W.bindRenderbuffer(a, Ed[b]);
                            },
                            glBindTexture: (a, b)=>{
                                W.bindTexture(a, Fd[b]);
                            },
                            glBindVertexArray: (a)=>{
                                W.bindVertexArray(Hd[a]);
                            },
                            glBlendEquation: (a)=>W.blendEquation(a),
                            glBlendFunc: (a, b)=>W.blendFunc(a, b),
                            glBlitFramebuffer: (a, b, c, d, e, f, g, k, m, n)=>W.blitFramebuffer(a, b, c, d, e, f, g, k, m, n),
                            glBufferData: (a, b, c, d)=>{
                                c && b ? W.bufferData(a, D, d, c, b) : W.bufferData(a, b, d);
                            },
                            glBufferSubData: (a, b, c, d)=>{
                                c && W.bufferSubData(a, b, D, d, c);
                            },
                            glClear: (a)=>W.clear(a),
                            glClearBufferfv: (a, b, c)=>{
                                W.clearBufferfv(a, b, xa, c >> 2);
                            },
                            glClearBufferuiv: (a, b, c)=>{
                                W.clearBufferuiv(a, b, H, c >> 2);
                            },
                            glClearColor: (a, b, c, d)=>W.clearColor(a, b, c, d),
                            glClearDepthf: (a)=>W.clearDepth(a),
                            glClearStencil: (a)=>W.clearStencil(a),
                            glColorMask: (a, b, c, d)=>{
                                W.colorMask(!!a, !!b, !!c, !!d);
                            },
                            glCompileShader: (a)=>{
                                W.compileShader(Gd[a]);
                            },
                            glCreateProgram: ()=>{
                                var a = Ld(V), b = W.createProgram();
                                b.name = a;
                                b.za = b.xa = b.ya = 0;
                                b.Wa = 1;
                                V[a] = b;
                                return a;
                            },
                            glCreateShader: (a)=>{
                                var b = Ld(Gd);
                                Gd[b] = W.createShader(a);
                                return b;
                            },
                            glCullFace: (a)=>W.cullFace(a),
                            glDeleteBuffers: (a, b)=>{
                                for(var c = 0; c < a; c++){
                                    var d = F[b + 4 * c >> 2], e = Cd[d];
                                    e && (W.deleteBuffer(e), e.name = 0, Cd[d] = null, d == W.Na && (W.Na = 0), d == W.Oa && (W.Oa = 0));
                                }
                            },
                            glDeleteFramebuffers: (a, b)=>{
                                for(var c = 0; c < a; ++c){
                                    var d = F[b + 4 * c >> 2], e = Dd[d];
                                    e && (W.deleteFramebuffer(e), e.name = 0, Dd[d] = null);
                                }
                            },
                            glDeleteProgram: (a)=>{
                                if (a) {
                                    var b = V[a];
                                    b ? (W.deleteProgram(b), b.name = 0, V[a] = null) : X ||= 1281;
                                }
                            },
                            glDeleteRenderbuffers: (a, b)=>{
                                for(var c = 0; c < a; c++){
                                    var d = F[b + 4 * c >> 2], e = Ed[d];
                                    e && (W.deleteRenderbuffer(e), e.name = 0, Ed[d] = null);
                                }
                            },
                            glDeleteShader: (a)=>{
                                if (a) {
                                    var b = Gd[a];
                                    b ? (W.deleteShader(b), Gd[a] = null) : X ||= 1281;
                                }
                            },
                            glDeleteTextures: (a, b)=>{
                                for(var c = 0; c < a; c++){
                                    var d = F[b + 4 * c >> 2], e = Fd[d];
                                    e && (W.deleteTexture(e), e.name = 0, Fd[d] = null);
                                }
                            },
                            glDeleteVertexArrays: (a, b)=>{
                                for(var c = 0; c < a; c++){
                                    var d = F[b + 4 * c >> 2];
                                    W.deleteVertexArray(Hd[d]);
                                    Hd[d] = null;
                                }
                            },
                            glDepthFunc: (a)=>W.depthFunc(a),
                            glDepthMask: (a)=>{
                                W.depthMask(!!a);
                            },
                            glDepthRangef: (a, b)=>W.depthRange(a, b),
                            glDisable: (a)=>W.disable(a),
                            glDrawArrays: (a, b, c)=>{
                                W.drawArrays(a, b, c);
                            },
                            glDrawArraysInstanced: (a, b, c, d)=>{
                                W.drawArraysInstanced(a, b, c, d);
                            },
                            glDrawBuffers: (a, b)=>{
                                for(var c = Rd[a], d = 0; d < a; d++)c[d] = F[b + 4 * d >> 2];
                                W.drawBuffers(c);
                            },
                            glDrawElements: (a, b, c, d)=>{
                                W.drawElements(a, b, c, d);
                            },
                            glDrawElementsInstanced: (a, b, c, d, e)=>{
                                W.drawElementsInstanced(a, b, c, d, e);
                            },
                            glEnable: (a)=>W.enable(a),
                            glEnableVertexAttribArray: (a)=>{
                                W.enableVertexAttribArray(a);
                            },
                            glFlush: ()=>W.flush(),
                            glFramebufferRenderbuffer: (a, b, c, d)=>{
                                W.framebufferRenderbuffer(a, b, c, Ed[d]);
                            },
                            glFramebufferTexture2D: (a, b, c, d, e)=>{
                                W.framebufferTexture2D(a, b, c, Fd[d], e);
                            },
                            glFrontFace: (a)=>W.frontFace(a),
                            glGenBuffers: (a, b)=>{
                                Md(a, b, "createBuffer", Cd);
                            },
                            glGenFramebuffers: (a, b)=>{
                                Md(a, b, "createFramebuffer", Dd);
                            },
                            glGenRenderbuffers: (a, b)=>{
                                Md(a, b, "createRenderbuffer", Ed);
                            },
                            glGenTextures: (a, b)=>{
                                Md(a, b, "createTexture", Fd);
                            },
                            glGenVertexArrays: (a, b)=>{
                                Md(a, b, "createVertexArray", Hd);
                            },
                            glGenerateMipmap: (a)=>W.generateMipmap(a),
                            glGetError: ()=>{
                                var a = W.getError() || X;
                                X = 0;
                                return a;
                            },
                            glGetIntegerv: (a, b)=>Td(a, b),
                            glGetProgramiv: (a, b, c)=>{
                                if (c) {
                                    if (a >= Bd) X ||= 1281;
                                    else {
                                        if (a = V[a], 35716 == b) a = W.getProgramInfoLog(a), null === a && (a = "(unknown error)"), F[c >> 2] = a.length + 1;
                                        else if (35719 == b) {
                                            if (!a.za) for(b = 0; b < W.getProgramParameter(a, 35718); ++b)a.za = Math.max(a.za, W.getActiveUniform(a, b).name.length + 1);
                                            F[c >> 2] = a.za;
                                        } else if (35722 == b) {
                                            if (!a.xa) for(b = 0; b < W.getProgramParameter(a, 35721); ++b)a.xa = Math.max(a.xa, W.getActiveAttrib(a, b).name.length + 1);
                                            F[c >> 2] = a.xa;
                                        } else if (35381 == b) {
                                            if (!a.ya) for(b = 0; b < W.getProgramParameter(a, 35382); ++b)a.ya = Math.max(a.ya, W.getActiveUniformBlockName(a, b).length + 1);
                                            F[c >> 2] = a.ya;
                                        } else F[c >> 2] = W.getProgramParameter(a, b);
                                    }
                                } else X ||= 1281;
                            },
                            glGetString: (a)=>{
                                var b = Id[a];
                                if (!b) {
                                    switch(a){
                                        case 7939:
                                            b = Vd(Sd().join(" "));
                                            break;
                                        case 7936:
                                        case 7937:
                                        case 37445:
                                        case 37446:
                                            (b = W.getParameter(a)) || (X ||= 1280);
                                            b = b ? Vd(b) : 0;
                                            break;
                                        case 7938:
                                            b = Vd(`OpenGL ES 3.0 (${W.getParameter(7938)})`);
                                            break;
                                        case 35724:
                                            b = W.getParameter(35724);
                                            var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
                                            null !== c && (3 == c[1].length && (c[1] += "0"), b = `OpenGL ES GLSL ES ${c[1]} (${b})`);
                                            b = Vd(b);
                                            break;
                                        default:
                                            X ||= 1280;
                                    }
                                    Id[a] = b;
                                }
                                return b;
                            },
                            glGetUniformBlockIndex: (a, b)=>W.getUniformBlockIndex(V[a], b ? L(D, b) : ""),
                            glGetUniformLocation: (a, b)=>{
                                b = b ? L(D, b) : "";
                                if (a = V[a]) {
                                    var c = a, d = c.na, e = c.wb, f;
                                    if (!d) for(c.na = d = {}, c.vb = {}, f = 0; f < W.getProgramParameter(c, 35718); ++f){
                                        var g = W.getActiveUniform(c, f);
                                        var k = g.name;
                                        g = g.size;
                                        var m = Wd(k);
                                        m = 0 < m ? k.slice(0, m) : k;
                                        var n = c.Wa;
                                        c.Wa += g;
                                        e[m] = [
                                            g,
                                            n
                                        ];
                                        for(k = 0; k < g; ++k)d[n] = k, c.vb[n++] = m;
                                    }
                                    c = a.na;
                                    d = 0;
                                    e = b;
                                    f = Wd(b);
                                    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
                                    if ((e = a.wb[e]) && d < e[0] && (d += e[1], c[d] = c[d] || W.getUniformLocation(a, b))) return d;
                                } else X ||= 1281;
                                return -1;
                            },
                            glInvalidateFramebuffer: (a, b, c)=>{
                                for(var d = Rd[b], e = 0; e < b; e++)d[e] = F[c + 4 * e >> 2];
                                W.invalidateFramebuffer(a, d);
                            },
                            glLinkProgram: (a)=>{
                                a = V[a];
                                W.linkProgram(a);
                                a.na = 0;
                                a.wb = {};
                            },
                            glPixelStorei: (a, b)=>{
                                3317 == a ? Jd = b : 3314 == a && (Kd = b);
                                W.pixelStorei(a, b);
                            },
                            glReadPixels: (a, b, c, d, e, f, g)=>{
                                if (W.Na) W.readPixels(a, b, c, d, e, f, g);
                                else {
                                    var k = Xd(f);
                                    g >>>= 31 - Math.clz32(k.BYTES_PER_ELEMENT);
                                    W.readPixels(a, b, c, d, e, f, k, g);
                                }
                            },
                            glRenderbufferStorageMultisample: (a, b, c, d, e)=>W.renderbufferStorageMultisample(a, b, c, d, e),
                            glScissor: (a, b, c, d)=>W.scissor(a, b, c, d),
                            glShaderSource: (a, b, c, d)=>{
                                for(var e = "", f = 0; f < b; ++f){
                                    var g = (g = H[c + 4 * f >> 2]) ? L(D, g, d ? H[d + 4 * f >> 2] : void 0) : "";
                                    e += g;
                                }
                                W.shaderSource(Gd[a], e);
                            },
                            glStencilFunc: (a, b, c)=>W.stencilFunc(a, b, c),
                            glStencilFuncSeparate: (a, b, c, d)=>W.stencilFuncSeparate(a, b, c, d),
                            glStencilMask: (a)=>W.stencilMask(a),
                            glStencilOp: (a, b, c)=>W.stencilOp(a, b, c),
                            glStencilOpSeparate: (a, b, c, d)=>W.stencilOpSeparate(a, b, c, d),
                            glTexParameteri: (a, b, c)=>W.texParameteri(a, b, c),
                            glTexStorage2D: (a, b, c, d, e)=>W.texStorage2D(a, b, c, d, e),
                            glTexStorage3D: (a, b, c, d, e, f)=>W.texStorage3D(a, b, c, d, e, f),
                            glTexSubImage2D: (a, b, c, d, e, f, g, k, m)=>{
                                if (W.Oa) W.texSubImage2D(a, b, c, d, e, f, g, k, m);
                                else if (m) {
                                    var n = Xd(k);
                                    W.texSubImage2D(a, b, c, d, e, f, g, k, n, m >>> 31 - Math.clz32(n.BYTES_PER_ELEMENT));
                                } else {
                                    if (m) {
                                        n = Xd(k);
                                        var t = f * ((Kd || e) * (({
                                            5: 3,
                                            6: 4,
                                            8: 2,
                                            29502: 3,
                                            29504: 4,
                                            26917: 2,
                                            26918: 2,
                                            29846: 3,
                                            29847: 4
                                        })[g - 6402] || 1) * n.BYTES_PER_ELEMENT + Jd - 1 & -Jd);
                                        m = n.subarray(m >>> 31 - Math.clz32(n.BYTES_PER_ELEMENT), m + t >>> 31 - Math.clz32(n.BYTES_PER_ELEMENT));
                                    } else m = null;
                                    W.texSubImage2D(a, b, c, d, e, f, g, k, m);
                                }
                            },
                            glUniform1i: (a, b)=>{
                                var c = W, d = c.uniform1i;
                                var e = W.Hb;
                                if (e) {
                                    var f = e.na[a];
                                    "number" == typeof f && (e.na[a] = f = W.getUniformLocation(e, e.vb[a] + (0 < f ? `[${f}]` : "")));
                                    a = f;
                                } else X ||= 1282, a = void 0;
                                d.call(c, a, b);
                            },
                            glUniformBlockBinding: (a, b, c)=>{
                                a = V[a];
                                W.uniformBlockBinding(a, b, c);
                            },
                            glUseProgram: (a)=>{
                                a = V[a];
                                W.useProgram(a);
                                W.Hb = a;
                            },
                            glVertexAttribDivisor: (a, b)=>{
                                W.vertexAttribDivisor(a, b);
                            },
                            glVertexAttribIPointer: (a, b, c, d, e)=>{
                                W.vertexAttribIPointer(a, b, c, d, e);
                            },
                            glVertexAttribPointer: (a, b, c, d, e, f)=>{
                                W.vertexAttribPointer(a, b, c, !!d, e, f);
                            },
                            glViewport: (a, b, c, d)=>W.viewport(a, b, c, d),
                            invoke_vii: de,
                            isWindowsBrowser: function() {
                                return -1 < navigator.platform.indexOf("Win");
                            },
                            provokingVertexWEBGL: function(a, b) {
                                (a = w[a].C.pb) && a.provokingVertexWEBGL(b);
                            },
                            strftime: $d,
                            strftime_l: (a, b, c, d)=>$d(a, b, c, d),
                            upload_image: function(a, b) {
                                var c = l.images;
                                c && (b = c.get(b)) && (a = w[a].C, a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0), a.texImage2D(a.TEXTURE_2D, 0, a.RGBA, a.RGBA, a.UNSIGNED_BYTE, b), a.pixelStorei(a.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1));
                            }
                        }, Y = function() {
                            function a(c) {
                                Y = c.exports;
                                ua = Y.memory;
                                za();
                                Qc = Y.__indirect_function_table;
                                Ba.unshift(Y.__wasm_call_ctors);
                                Ea--;
                                l.monitorRunDependencies?.(Ea);
                                0 == Ea && (null !== Fa && (clearInterval(Fa), Fa = null), Ga && (c = Ga, Ga = null, c()));
                                return Y;
                            }
                            var b = {
                                env: ee,
                                wasi_snapshot_preview1: ee
                            };
                            Ea++;
                            l.monitorRunDependencies?.(Ea);
                            if (l.instantiateWasm) try {
                                return l.instantiateWasm(b, a);
                            } catch (c) {
                                sa(`Module.instantiateWasm callback failed with error: ${c}`), ba(c);
                            }
                            Ja ||= Ia("webgl2_advanced.wasm") ? "webgl2_advanced.wasm" : l.locateFile ? l.locateFile("webgl2_advanced.wasm", y) : y + "webgl2_advanced.wasm";
                            Na(b, function(c) {
                                a(c.instance);
                            }).catch(ba);
                            return {};
                        }(), lc = (a)=>(lc = Y.free)(a), Ud = (a)=>(Ud = Y.malloc)(a);
                        l._setWebImage = (a, b, c)=>(l._setWebImage = Y.setWebImage)(a, b, c);
                        var kc = (a)=>(kc = Y.__getTypeName)(a), Qa = l._ma_device__on_notification_unlocked = (a)=>(Qa = l._ma_device__on_notification_unlocked = Y.ma_device__on_notification_unlocked)(a);
                        l._ma_malloc_emscripten = (a, b)=>(l._ma_malloc_emscripten = Y.ma_malloc_emscripten)(a, b);
                        l._ma_free_emscripten = (a, b)=>(l._ma_free_emscripten = Y.ma_free_emscripten)(a, b);
                        var Ra = l._ma_device_process_pcm_frames_capture__webaudio = (a, b, c)=>(Ra = l._ma_device_process_pcm_frames_capture__webaudio = Y.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Sa = l._ma_device_process_pcm_frames_playback__webaudio = (a, b, c)=>(Sa = l._ma_device_process_pcm_frames_playback__webaudio = Y.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), fe = (a, b)=>(fe = Y.setThrew)(a, b), ge = (a)=>(ge = Y._emscripten_stack_restore)(a), he = ()=>(he = Y.emscripten_stack_get_current)();
                        l.dynCall_iiiji = (a, b, c, d, e, f)=>(l.dynCall_iiiji = Y.dynCall_iiiji)(a, b, c, d, e, f);
                        l.dynCall_iij = (a, b, c, d)=>(l.dynCall_iij = Y.dynCall_iij)(a, b, c, d);
                        l.dynCall_iiji = (a, b, c, d, e)=>(l.dynCall_iiji = Y.dynCall_iiji)(a, b, c, d, e);
                        l.dynCall_jii = (a, b, c)=>(l.dynCall_jii = Y.dynCall_jii)(a, b, c);
                        l.dynCall_vijj = (a, b, c, d, e, f)=>(l.dynCall_vijj = Y.dynCall_vijj)(a, b, c, d, e, f);
                        l.dynCall_jiji = (a, b, c, d, e)=>(l.dynCall_jiji = Y.dynCall_jiji)(a, b, c, d, e);
                        l.dynCall_viijii = (a, b, c, d, e, f, g)=>(l.dynCall_viijii = Y.dynCall_viijii)(a, b, c, d, e, f, g);
                        l.dynCall_iiiiij = (a, b, c, d, e, f, g)=>(l.dynCall_iiiiij = Y.dynCall_iiiiij)(a, b, c, d, e, f, g);
                        l.dynCall_iiiiijj = (a, b, c, d, e, f, g, k, m)=>(l.dynCall_iiiiijj = Y.dynCall_iiiiijj)(a, b, c, d, e, f, g, k, m);
                        l.dynCall_iiiiiijj = (a, b, c, d, e, f, g, k, m, n)=>(l.dynCall_iiiiiijj = Y.dynCall_iiiiiijj)(a, b, c, d, e, f, g, k, m, n);
                        function de(a, b, c) {
                            var d = he();
                            try {
                                Rc(a)(b, c);
                            } catch (e) {
                                ge(d);
                                if (e !== e + 0) throw e;
                                fe(1, 0);
                            }
                        }
                        var ie;
                        Ga = function je() {
                            ie || ke();
                            ie || (Ga = je);
                        };
                        function ke() {
                            function a() {
                                if (!ie && (ie = !0, l.calledRun = !0, !va)) {
                                    l.noFSInit || Vb || (Vb = !0, l.stdin = l.stdin, l.stdout = l.stdout, l.stderr = l.stderr, l.stdin ? Wb("stdin", l.stdin) : Rb("/dev/tty", "/dev/stdin"), l.stdout ? Wb("stdout", null, l.stdout) : Rb("/dev/tty", "/dev/stdout"), l.stderr ? Wb("stderr", null, l.stderr) : Rb("/dev/tty1", "/dev/stderr"), Sb("/dev/stdin", 0), Sb("/dev/stdout", 1), Sb("/dev/stderr", 1));
                                    Ab = !1;
                                    Ua(Ba);
                                    aa(l);
                                    if (l.onRuntimeInitialized) l.onRuntimeInitialized();
                                    if (l.postRun) for("function" == typeof l.postRun && (l.postRun = [
                                        l.postRun
                                    ]); l.postRun.length;){
                                        var b = l.postRun.shift();
                                        Ca.unshift(b);
                                    }
                                    Ua(Ca);
                                }
                            }
                            if (!(0 < Ea)) {
                                if (l.preRun) for("function" == typeof l.preRun && (l.preRun = [
                                    l.preRun
                                ]); l.preRun.length;)Da();
                                Ua(Aa);
                                0 < Ea || (l.setStatus ? (l.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        l.setStatus("");
                                    }, 1);
                                    a();
                                }, 1)) : a());
                            }
                        }
                        if (l.preInit) for("function" == typeof l.preInit && (l.preInit = [
                            l.preInit
                        ]); 0 < l.preInit.length;)l.preInit.pop()();
                        ke();
                        moduleRtn = ca;
                        return moduleRtn;
                    };
                })();
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ (module1)=>{
                module1.exports = /*#__PURE__*/ JSON.parse('{"name":"@rive-app/webgl2","version":"2.35.2","description":"Rive\'s webgl2 based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)","Chris Dalton <chris@rive.app> (https://rive.app)"],"license":"MIT","files":["rive.js","rive.wasm","rive.js.map","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* reexport safe */ _Animation__WEBPACK_IMPORTED_MODULE_0__.Animation
                });
                /* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* binding */ Animation
                });
                /**
 * Represents an animation that can be played on an Artboard.
 * Wraps animations and instances from the runtime and keeps track of playback state.
 *
 * The `Animation` class manages the state and behavior of a single animation instance,
 * including its current time, loop count, and ability to scrub to a specific time.
 *
 * The class provides methods to advance the animation, apply its interpolated keyframe
 * values to the Artboard, and clean up the underlying animation instance when the
 * animation is no longer needed.
 */ var Animation = /** @class */ function() {
                    /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                        this.animation = animation;
                        this.artboard = artboard;
                        this.playing = playing;
                        this.loopCount = 0;
                        /**
         * The time to which the animation should move to on the next render.
         * If not null, the animation will scrub to this time instead of advancing by the given time.
         */ this.scrubTo = null;
                        this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                    }
                    Object.defineProperty(Animation.prototype, "name", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.animation.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "time", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.instance.time;
                        },
                        /**
         * Sets the animation's current time
         */ set: function(value) {
                            this.instance.time = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "loopValue", {
                        /**
         * Returns the animation's loop type
         */ get: function() {
                            return this.animation.loopValue;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "needsScrub", {
                        /**
         * Indicates whether the animation needs to be scrubbed.
         * @returns `true` if the animation needs to be scrubbed, `false` otherwise.
         */ get: function() {
                            return this.scrubTo !== null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                        if (this.scrubTo === null) this.instance.advance(time);
                        else {
                            this.instance.time = 0;
                            this.instance.advance(this.scrubTo);
                            this.scrubTo = null;
                        }
                    };
                    /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                        this.instance.apply(mix);
                    };
                    /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                        this.instance.delete();
                    };
                    return Animation;
                }();
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AudioAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.AudioAssetWrapper,
                    /* harmony export */ AudioWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.AudioWrapper,
                    /* harmony export */ BLANK_URL: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL,
                    /* harmony export */ CustomFileAssetLoaderWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.CustomFileAssetLoaderWrapper,
                    /* harmony export */ FileAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FileAssetWrapper,
                    /* harmony export */ FileFinalizer: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FileFinalizer,
                    /* harmony export */ FontAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FontAssetWrapper,
                    /* harmony export */ FontWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.FontWrapper,
                    /* harmony export */ ImageAssetWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.ImageAssetWrapper,
                    /* harmony export */ ImageWrapper: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.ImageWrapper,
                    /* harmony export */ createFinalization: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.createFinalization,
                    /* harmony export */ finalizationRegistry: ()=>/* reexport safe */ _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__.finalizationRegistry,
                    /* harmony export */ registerTouchInteractions: ()=>/* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions,
                    /* harmony export */ sanitizeUrl: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
                /* harmony import */ var _finalizationRegistry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: ()=>/* binding */ registerTouchInteractions
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function(event, isTouchScrollEnabled, enableMultiTouch) {
                    var _a, _b;
                    var coordinates = [];
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.changedTouches) === null || _a === void 0 ? void 0 : _a.length)) {
                        // This flag, if false, prevents touch events on the canvas default behavior
                        // which may prevent scrolling if a drag motion on the canvas is performed
                        if (!isTouchScrollEnabled) event.preventDefault();
                        var cnt = 0;
                        var totalTouches = enableMultiTouch ? event.changedTouches.length : 1;
                        while(cnt < totalTouches){
                            var touch = event.changedTouches[cnt];
                            coordinates.push({
                                clientX: touch.clientX,
                                clientY: touch.clientY,
                                identifier: touch.identifier
                            });
                            cnt++;
                        }
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) {
                        var cnt = 0;
                        var totalTouches = enableMultiTouch ? event.changedTouches.length : 1;
                        while(cnt < totalTouches){
                            var touch = event.changedTouches[cnt];
                            coordinates.push({
                                clientX: touch.clientX,
                                clientY: touch.clientY,
                                identifier: touch.identifier
                            });
                            cnt++;
                        }
                    } else coordinates.push({
                        clientX: event.clientX,
                        clientY: event.clientY,
                        identifier: 0
                    });
                    return coordinates;
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment, _c = _a.isTouchScrollEnabled, isTouchScrollEnabled = _c === void 0 ? false : _c, _d = _a.dispatchPointerExit, dispatchPointerExit = _d === void 0 ? true : _d, _e = _a.enableMultiTouch, enableMultiTouch = _e === void 0 ? false : _e, _f = _a.layoutScaleFactor, layoutScaleFactor = _f === void 0 ? 1.0 : _f;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    /**
     * After a touchend event, some browsers may fire synthetic mouse events
     * (mouseover, mousedown, mousemove, mouseup) if the touch interaction did not cause
     * any default action (such as scrolling).
     *
     * This is done to simulate the behavior of a mouse for applications that do not support
     * touch events.
     *
     * We're keeping track of the previous event to not send the synthetic mouse events if the
     * touch event was a click (touchstart -> touchend).
     *
     * This is only needed when `isTouchScrollEnabled` is false
     * When true, `preventDefault()` is called which prevents this behaviour.
     **/ var _prevEventType = null;
                    var _syntheticEventsActive = false;
                    var processEventCallback = function(event) {
                        // Exit early out of all synthetic mouse events
                        // https://stackoverflow.com/questions/9656990/how-to-prevent-simulated-mouse-events-in-mobile-browsers
                        // https://stackoverflow.com/questions/25572070/javascript-touchend-versus-click-dilemma
                        if (_syntheticEventsActive && event instanceof MouseEvent) {
                            // Synthetic event finished
                            if (event.type == "mouseup") _syntheticEventsActive = false;
                            return;
                        }
                        // Test if it's a "touch click". This could cause the browser to send
                        // synthetic mouse events.
                        _syntheticEventsActive = isTouchScrollEnabled && event.type === "touchend" && _prevEventType === "touchstart";
                        _prevEventType = event.type;
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var coordinateSets = getClientCoordinates(event, isTouchScrollEnabled, enableMultiTouch);
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds, layoutScaleFactor);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        coordinateSets.forEach(function(coordinateSet) {
                            var clientX = coordinateSet.clientX;
                            var clientY = coordinateSet.clientY;
                            if (!clientX && !clientY) return;
                            var canvasX = clientX - boundingRect.left;
                            var canvasY = clientY - boundingRect.top;
                            var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                            var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                            var transformedX = transformedVector.x();
                            var transformedY = transformedVector.y();
                            coordinateSet.transformedX = transformedX;
                            coordinateSet.transformedY = transformedY;
                            transformedVector.delete();
                            canvasCoordinatesVector.delete();
                        });
                        invertedMatrix.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             */ case "mouseout":
                                var _loop_1 = function(stateMachine) {
                                    if (dispatchPointerExit) coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerExit(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                    else coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerMove(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    _loop_1(stateMachine);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                var _loop_2 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerMove(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _a = 0, stateMachines_2 = stateMachines; _a < stateMachines_2.length; _a++){
                                    var stateMachine = stateMachines_2[_a];
                                    _loop_2(stateMachine);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                var _loop_3 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerDown(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _b = 0, stateMachines_3 = stateMachines; _b < stateMachines_3.length; _b++){
                                    var stateMachine = stateMachines_3[_b];
                                    _loop_3(stateMachine);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                                var _loop_4 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerUp(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                        stateMachine.pointerExit(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _c = 0, stateMachines_4 = stateMachines; _c < stateMachines_4.length; _c++){
                                    var stateMachine = stateMachines_4[_c];
                                    _loop_4(stateMachine);
                                }
                                break;
                            case "mouseup":
                                var _loop_5 = function(stateMachine) {
                                    coordinateSets.forEach(function(coordinateSet) {
                                        stateMachine.pointerUp(coordinateSet.transformedX, coordinateSet.transformedY, coordinateSet.identifier);
                                    });
                                };
                                for(var _d = 0, stateMachines_5 = stateMachines; _d < stateMachines_5.length; _d++){
                                    var stateMachine = stateMachines_5[_d];
                                    _loop_5(stateMachine);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchstart", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* binding */ BLANK_URL,
                    /* harmony export */ sanitizeUrl: ()=>/* binding */ sanitizeUrl
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
                function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                }
                // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                }
                function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                }
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ AudioAssetWrapper: ()=>/* binding */ AudioAssetWrapper,
                    /* harmony export */ AudioWrapper: ()=>/* binding */ AudioWrapper,
                    /* harmony export */ CustomFileAssetLoaderWrapper: ()=>/* binding */ CustomFileAssetLoaderWrapper,
                    /* harmony export */ FileAssetWrapper: ()=>/* binding */ FileAssetWrapper,
                    /* harmony export */ FileFinalizer: ()=>/* binding */ FileFinalizer,
                    /* harmony export */ FontAssetWrapper: ()=>/* binding */ FontAssetWrapper,
                    /* harmony export */ FontWrapper: ()=>/* binding */ FontWrapper,
                    /* harmony export */ ImageAssetWrapper: ()=>/* binding */ ImageAssetWrapper,
                    /* harmony export */ ImageWrapper: ()=>/* binding */ ImageWrapper,
                    /* harmony export */ createFinalization: ()=>/* binding */ createFinalization,
                    /* harmony export */ finalizationRegistry: ()=>/* binding */ finalizationRegistry
                });
                var __extends = function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var FileFinalizer = /** @class */ function() {
                    function FileFinalizer(file) {
                        this.selfUnref = false;
                        this._file = file;
                    }
                    FileFinalizer.prototype.unref = function() {
                        if (this._file) this._file.unref();
                    };
                    return FileFinalizer;
                }();
                var ObjectFinalizer = /** @class */ function() {
                    function ObjectFinalizer(finalizableObject) {
                        this._finalizableObject = finalizableObject;
                    }
                    ObjectFinalizer.prototype.unref = function() {
                        this._finalizableObject.unref();
                    };
                    return ObjectFinalizer;
                }();
                var AssetWrapper = /** @class */ function() {
                    function AssetWrapper() {
                        this.selfUnref = false;
                    }
                    AssetWrapper.prototype.unref = function() {};
                    return AssetWrapper;
                }();
                var ImageWrapper = /** @class */ function(_super) {
                    __extends(ImageWrapper, _super);
                    function ImageWrapper(image) {
                        var _this = _super.call(this) || this;
                        _this._nativeImage = image;
                        return _this;
                    }
                    Object.defineProperty(ImageWrapper.prototype, "nativeImage", {
                        get: function() {
                            return this._nativeImage;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    ImageWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeImage.unref();
                    };
                    return ImageWrapper;
                }(AssetWrapper);
                var AudioWrapper = /** @class */ function(_super) {
                    __extends(AudioWrapper, _super);
                    function AudioWrapper(audio) {
                        var _this = _super.call(this) || this;
                        _this._nativeAudio = audio;
                        return _this;
                    }
                    Object.defineProperty(AudioWrapper.prototype, "nativeAudio", {
                        get: function() {
                            return this._nativeAudio;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    AudioWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeAudio.unref();
                    };
                    return AudioWrapper;
                }(AssetWrapper);
                var FontWrapper = /** @class */ function(_super) {
                    __extends(FontWrapper, _super);
                    function FontWrapper(font) {
                        var _this = _super.call(this) || this;
                        _this._nativeFont = font;
                        return _this;
                    }
                    Object.defineProperty(FontWrapper.prototype, "nativeFont", {
                        get: function() {
                            return this._nativeFont;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    FontWrapper.prototype.unref = function() {
                        if (this.selfUnref) this._nativeFont.unref();
                    };
                    return FontWrapper;
                }(AssetWrapper);
                var CustomFileAssetLoaderWrapper = /** @class */ function() {
                    function CustomFileAssetLoaderWrapper(runtime, loaderCallback) {
                        this._assetLoaderCallback = loaderCallback;
                        this.assetLoader = new runtime.CustomFileAssetLoader({
                            loadContents: this.loadContents.bind(this)
                        });
                    }
                    CustomFileAssetLoaderWrapper.prototype.loadContents = function(asset, bytes) {
                        var assetWrapper;
                        if (asset.isImage) assetWrapper = new ImageAssetWrapper(asset);
                        else if (asset.isAudio) assetWrapper = new AudioAssetWrapper(asset);
                        else if (asset.isFont) assetWrapper = new FontAssetWrapper(asset);
                        return this._assetLoaderCallback(assetWrapper, bytes);
                    };
                    return CustomFileAssetLoaderWrapper;
                }();
                /**
 * Rive class representing a FileAsset with relevant metadata fields to describe
 * an asset associated wtih the Rive File
 */ var FileAssetWrapper = /** @class */ function() {
                    function FileAssetWrapper(nativeAsset) {
                        this._nativeFileAsset = nativeAsset;
                    }
                    FileAssetWrapper.prototype.decode = function(bytes) {
                        this._nativeFileAsset.decode(bytes);
                    };
                    Object.defineProperty(FileAssetWrapper.prototype, "name", {
                        get: function() {
                            return this._nativeFileAsset.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "fileExtension", {
                        get: function() {
                            return this._nativeFileAsset.fileExtension;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "uniqueFilename", {
                        get: function() {
                            return this._nativeFileAsset.uniqueFilename;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isAudio", {
                        get: function() {
                            return this._nativeFileAsset.isAudio;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isImage", {
                        get: function() {
                            return this._nativeFileAsset.isImage;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "isFont", {
                        get: function() {
                            return this._nativeFileAsset.isFont;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "cdnUuid", {
                        get: function() {
                            return this._nativeFileAsset.cdnUuid;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(FileAssetWrapper.prototype, "nativeFileAsset", {
                        get: function() {
                            return this._nativeFileAsset;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return FileAssetWrapper;
                }();
                /**
 * Rive class extending the FileAsset that exposes a `setRenderImage()` API with a
 * decoded Image (via the `decodeImage()` API) to set a new Image on the Rive FileAsset
 */ var ImageAssetWrapper = /** @class */ function(_super) {
                    __extends(ImageAssetWrapper, _super);
                    function ImageAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    ImageAssetWrapper.prototype.setRenderImage = function(image) {
                        this._nativeFileAsset.setRenderImage(image.nativeImage);
                    };
                    return ImageAssetWrapper;
                }(FileAssetWrapper);
                /**
 * Rive class extending the FileAsset that exposes a `setAudioSource()` API with a
 * decoded Audio (via the `decodeAudio()` API) to set a new Audio on the Rive FileAsset
 */ var AudioAssetWrapper = /** @class */ function(_super) {
                    __extends(AudioAssetWrapper, _super);
                    function AudioAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    AudioAssetWrapper.prototype.setAudioSource = function(audio) {
                        this._nativeFileAsset.setAudioSource(audio.nativeAudio);
                    };
                    return AudioAssetWrapper;
                }(FileAssetWrapper);
                /**
 * Rive class extending the FileAsset that exposes a `setFont()` API with a
 * decoded Font (via the `decodeFont()` API) to set a new Font on the Rive FileAsset
 */ var FontAssetWrapper = /** @class */ function(_super) {
                    __extends(FontAssetWrapper, _super);
                    function FontAssetWrapper() {
                        return _super !== null && _super.apply(this, arguments) || this;
                    }
                    FontAssetWrapper.prototype.setFont = function(font) {
                        this._nativeFileAsset.setFont(font.nativeFont);
                    };
                    return FontAssetWrapper;
                }(FileAssetWrapper);
                var FakeFinalizationRegistry = /** @class */ function() {
                    function FakeFinalizationRegistry(_) {}
                    FakeFinalizationRegistry.prototype.register = function(object) {
                        object.selfUnref = true;
                    };
                    FakeFinalizationRegistry.prototype.unregister = function(_) {};
                    return FakeFinalizationRegistry;
                }();
                var MyFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : FakeFinalizationRegistry;
                var finalizationRegistry = new MyFinalizationRegistry(function(ob) {
                    ob === null || ob === void 0 || ob.unref();
                });
                var createFinalization = function(target, finalizable) {
                    var finalizer = new ObjectFinalizer(finalizable);
                    finalizationRegistry.register(target, finalizer);
                };
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: 'Module'
                });
                /******/ Object.defineProperty(exports, '__esModule', {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
        (()=>{
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: ()=>/* binding */ Alignment,
                /* harmony export */ DataEnum: ()=>/* binding */ DataEnum,
                /* harmony export */ DrawOptimizationOptions: ()=>/* binding */ DrawOptimizationOptions,
                /* harmony export */ EventType: ()=>/* binding */ EventType,
                /* harmony export */ Fit: ()=>/* binding */ Fit,
                /* harmony export */ Layout: ()=>/* binding */ Layout,
                /* harmony export */ LoopType: ()=>/* binding */ LoopType,
                /* harmony export */ Rive: ()=>/* binding */ Rive,
                /* harmony export */ RiveEventType: ()=>/* binding */ RiveEventType,
                /* harmony export */ RiveFile: ()=>/* binding */ RiveFile,
                /* harmony export */ RuntimeLoader: ()=>/* binding */ RuntimeLoader,
                /* harmony export */ StateMachineInput: ()=>/* binding */ StateMachineInput,
                /* harmony export */ StateMachineInputType: ()=>/* binding */ StateMachineInputType,
                /* harmony export */ Testing: ()=>/* binding */ Testing,
                /* harmony export */ ViewModel: ()=>/* binding */ ViewModel,
                /* harmony export */ ViewModelInstance: ()=>/* binding */ ViewModelInstance,
                /* harmony export */ ViewModelInstanceArtboard: ()=>/* binding */ ViewModelInstanceArtboard,
                /* harmony export */ ViewModelInstanceAssetImage: ()=>/* binding */ ViewModelInstanceAssetImage,
                /* harmony export */ ViewModelInstanceBoolean: ()=>/* binding */ ViewModelInstanceBoolean,
                /* harmony export */ ViewModelInstanceColor: ()=>/* binding */ ViewModelInstanceColor,
                /* harmony export */ ViewModelInstanceEnum: ()=>/* binding */ ViewModelInstanceEnum,
                /* harmony export */ ViewModelInstanceList: ()=>/* binding */ ViewModelInstanceList,
                /* harmony export */ ViewModelInstanceNumber: ()=>/* binding */ ViewModelInstanceNumber,
                /* harmony export */ ViewModelInstanceString: ()=>/* binding */ ViewModelInstanceString,
                /* harmony export */ ViewModelInstanceTrigger: ()=>/* binding */ ViewModelInstanceTrigger,
                /* harmony export */ ViewModelInstanceValue: ()=>/* binding */ ViewModelInstanceValue,
                /* harmony export */ decodeAudio: ()=>/* binding */ decodeAudio,
                /* harmony export */ decodeFont: ()=>/* binding */ decodeFont,
                /* harmony export */ decodeImage: ()=>/* binding */ decodeImage
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
                return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var __spreadArray = function(to, from, pack) {
                if (pack || arguments.length === 2) {
                    for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            };
            var RiveError = /** @class */ function(_super) {
                __extends(RiveError, _super);
                function RiveError() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isHandledError = true;
                    return _this;
                }
                return RiveError;
            }(Error);
            // #regions helpers
            var resolveErrorMessage = function(error) {
                return error && error.isHandledError ? error.message : "Problem loading file; may be corrupt!";
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
                Fit["Layout"] = "layout";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Drawing optimization options
            var DrawOptimizationOptions;
            (function(DrawOptimizationOptions) {
                DrawOptimizationOptions["AlwaysDraw"] = "alwaysDraw";
                DrawOptimizationOptions["DrawOnChanged"] = "drawOnChanged";
            })(DrawOptimizationOptions || (DrawOptimizationOptions = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.layoutScaleFactor = (_c = params === null || params === void 0 ? void 0 : params.layoutScaleFactor) !== null && _c !== void 0 ? _c : 1;
                    this.minX = (_d = params === null || params === void 0 ? void 0 : params.minX) !== null && _d !== void 0 ? _d : 0;
                    this.minY = (_e = params === null || params === void 0 ? void 0 : params.minY) !== null && _e !== void 0 ? _e : 0;
                    this.maxX = (_f = params === null || params === void 0 ? void 0 : params.maxX) !== null && _f !== void 0 ? _f : 0;
                    this.maxY = (_g = params === null || params === void 0 ? void 0 : params.maxY) !== null && _g !== void 0 ? _g : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, layoutScaleFactor = _a.layoutScaleFactor, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        layoutScaleFactor: layoutScaleFactor !== null && layoutScaleFactor !== void 0 ? layoutScaleFactor : this.layoutScaleFactor,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else if (this.fit === Fit.Layout) fit = rive.Fit.layout;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function(error) {
                        // Capture specific error details
                        var errorDetails = {
                            message: (error === null || error === void 0 ? void 0 : error.message) || "Unknown error",
                            type: (error === null || error === void 0 ? void 0 : error.name) || "Error",
                            // Some browsers may provide additional WebAssembly-specific details
                            wasmError: error instanceof WebAssembly.CompileError || error instanceof WebAssembly.RuntimeError,
                            originalError: error
                        };
                        // Log detailed error for debugging
                        console.debug("Rive WASM load error details:", errorDetails);
                        // In case unpkg fails, or the wasm was not supported, we try to load the fallback module from jsdelivr.
                        // This `rive_fallback.wasm` is compiled to support older architecture.
                        // TODO: (Gordon): preemptively test browser support and load the correct wasm file. Then use jsdelvr only if unpkg fails.
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive_fallback.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, " (").concat(errorDetails.message, "), trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else {
                            var errorMessage = [
                                "Could not load Rive WASM file from ".concat(RuntimeLoader.wasmURL, " or ").concat(backupJsdelivrUrl, "."),
                                "Possible reasons:",
                                "- Network connection is down",
                                "- WebAssembly is not supported in this environment",
                                "- The WASM file is corrupted or incompatible",
                                "\nError details:",
                                "- Type: ".concat(errorDetails.type),
                                "- Message: ".concat(errorDetails.message),
                                "- WebAssembly-specific error: ".concat(errorDetails.wasmError),
                                "\nTo resolve, you may need to:",
                                "1. Check your network connection",
                                "2. Set a new WASM source via RuntimeLoader.setWasmUrl()",
                                "3. Call RuntimeLoader.loadRuntime() again"
                            ].join("\n");
                            console.error(errorMessage);
                        }
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Gets the current wasm url
                RuntimeLoader.getWasmUrl = function() {
                    return RuntimeLoader.wasmURL;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                /**
     * Deletes the input
     */ StateMachineInput.prototype.delete = function() {
                    this.runtimeInput = null;
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var BaseArtboard = /** @class */ function() {
                function BaseArtboard(_isBindableArtboard) {
                    this.isBindableArtboard = false;
                    this.isBindableArtboard = _isBindableArtboard;
                }
                return BaseArtboard;
            }();
            var Artboard = /** @class */ function(_super) {
                __extends(Artboard, _super);
                function Artboard(artboard, _file) {
                    var _this = _super.call(this, false) || this;
                    _this.nativeArtboard = artboard;
                    _this.file = _file;
                    return _this;
                }
                return Artboard;
            }(BaseArtboard);
            var BindableArtboard = /** @class */ function(_super) {
                __extends(BindableArtboard, _super);
                function BindableArtboard(artboard) {
                    var _this = _super.call(this, true) || this;
                    _this.selfUnref = false;
                    _this.nativeArtboard = artboard;
                    return _this;
                }
                Object.defineProperty(BindableArtboard.prototype, "viewModel", {
                    set: function(value) {
                        this.nativeViewModel = value.nativeInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                BindableArtboard.prototype.destroy = function() {
                    var _a;
                    if (this.selfUnref) {
                        this.nativeArtboard.unref();
                        (_a = this.nativeViewModel) === null || _a === void 0 || _a.unref();
                    }
                };
                return BindableArtboard;
            }(BaseArtboard);
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Advances the state machine instance by a given time and apply changes to artboard.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advanceAndApply = function(time) {
                    this.instance.advanceAndApply(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.inputs.forEach(function(input) {
                        input.delete();
                    });
                    this.inputs.length = 0;
                    this.instance.delete();
                };
                StateMachine.prototype.bindViewModelInstance = function(viewModelInstance) {
                    if (viewModelInstance.runtimeInstance != null) this.instance.bindViewModelInstance(viewModelInstance.runtimeInstance);
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            } else console.error("Animation with name ".concat(animatables[i], " not found."));
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else {
                                console.warn("State Machine with name ".concat(animatables[i], " not found."));
                                // In order to maintain compatibility with current behavior, if a state machine is not found
                                // we look for an animation with the same name
                                this.initLinearAnimations([
                                    animatables[i]
                                ], playing);
                            }
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Advance state machines if they are paused after initialization
     */ Animator.prototype.advanceIfPaused = function() {
                    this.stateMachines.forEach(function(sm) {
                        if (!sm.playing) sm.advanceAndApply(0);
                    });
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
                EventType["AudioStatusChange"] = "audiostatuschange";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            // #endregion
            // #region Audio
            var SystemAudioStatus;
            (function(SystemAudioStatus) {
                SystemAudioStatus[SystemAudioStatus["AVAILABLE"] = 0] = "AVAILABLE";
                SystemAudioStatus[SystemAudioStatus["UNAVAILABLE"] = 1] = "UNAVAILABLE";
            })(SystemAudioStatus || (SystemAudioStatus = {}));
            // Class to handle audio context availability and status changes
            var AudioManager = /** @class */ function(_super) {
                __extends(AudioManager, _super);
                function AudioManager() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this._started = false;
                    _this._enabled = false;
                    _this._status = SystemAudioStatus.UNAVAILABLE;
                    return _this;
                }
                AudioManager.prototype.delay = function(time) {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, time);
                                })
                            ];
                        });
                    });
                };
                AudioManager.prototype.timeout = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(_, reject) {
                                    return setTimeout(reject, 50);
                                })
                            ];
                        });
                    });
                };
                // Alerts animations on status changes and removes the listeners to avoid alerting twice.
                AudioManager.prototype.reportToListeners = function() {
                    this.fire({
                        type: EventType.AudioStatusChange
                    });
                    this.removeAll();
                };
                /**
     * The audio context has been resolved.
     * Alert any listeners that we can now play audio.
     * Rive will now play audio at the configured volume.
     */ AudioManager.prototype.enableAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            if (!this._enabled) {
                                this._enabled = true;
                                this._status = SystemAudioStatus.AVAILABLE;
                                this.reportToListeners();
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                /**
     * Check if we are able to play audio.
     *
     * We currently check the audio context, when resume() returns before a timeout we know that the
     * audio context is running and we can enable audio.
     */ AudioManager.prototype.testAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE && this._audioContext !== null)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            this._audioContext.resume(),
                                            this.timeout()
                                        ])
                                    ];
                                case 2:
                                    _b.sent();
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    _a = _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Establish audio for use with rive.
     * We both test if we can use audio intermittently and listen for user interaction.
     * The aim is to enable audio playback as soon as the browser allows this.
     */ AudioManager.prototype._establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!!this._started) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    this._started = true;
                                    if (!(typeof window == "undefined")) return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 1:
                                    this._audioContext = new AudioContext();
                                    this.listenForUserAction();
                                    _a.label = 2;
                                case 2:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.testAudio()
                                    ];
                                case 3:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.delay(1000)
                                    ];
                                case 4:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                AudioManager.prototype.listenForUserAction = function() {
                    var _this = this;
                    // NOTE: AudioContexts are ready immediately if requested in a ui callback
                    // we *could* re request one in this listener.
                    var _clickListener = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                // note this has "better" results than calling `await this.testAudio()`
                                // as we force audio to be enabled in the current thread, rather than chancing
                                // the thread to be passed over for some other async context
                                this.enableAudio();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    // NOTE: we should test this on mobile/pads
                    document.addEventListener("pointerdown", _clickListener, {
                        once: true
                    });
                };
                /**
     * Establish the audio context for rive, this lets rive know that we can play audio.
     */ AudioManager.prototype.establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            this._establishAudio();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                Object.defineProperty(AudioManager.prototype, "systemVolume", {
                    get: function() {
                        if (this._status === SystemAudioStatus.UNAVAILABLE) {
                            // We do an immediate test to avoid depending on the delay of the running test
                            this.testAudio();
                            return 0;
                        }
                        return 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AudioManager.prototype, "status", {
                    get: function() {
                        return this._status;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AudioManager;
            }(EventManager);
            var audioManager = new AudioManager();
            var FakeResizeObserver = /** @class */ function() {
                function FakeResizeObserver() {}
                FakeResizeObserver.prototype.observe = function() {};
                FakeResizeObserver.prototype.unobserve = function() {};
                FakeResizeObserver.prototype.disconnect = function() {};
                return FakeResizeObserver;
            }();
            var MyResizeObserver = globalThis.ResizeObserver || FakeResizeObserver;
            /**
 * This class takes care of any observers that will be attached to an animation.
 * It should be treated as a singleton because observers are much more performant
 * when used for observing multiple elements by a single instance.
 */ var ObjectObservers = /** @class */ function() {
                function ObjectObservers() {
                    var _this = this;
                    this._elementsMap = new Map();
                    /**
         * Resize observers trigger both when the element changes its size and also when the
         * element is added or removed from the document.
         */ this._onObservedEntry = function(entry) {
                        var observed = _this._elementsMap.get(entry.target);
                        if (observed !== null) observed.onResize(entry.target.clientWidth == 0 || entry.target.clientHeight == 0);
                        else _this._resizeObserver.unobserve(entry.target);
                    };
                    this._onObserved = function(entries) {
                        entries.forEach(_this._onObservedEntry);
                    };
                    this._resizeObserver = new MyResizeObserver(this._onObserved);
                }
                // Adds an observable element
                ObjectObservers.prototype.add = function(element, onResize) {
                    var observed = {
                        onResize: onResize,
                        element: element
                    };
                    this._elementsMap.set(element, observed);
                    this._resizeObserver.observe(element);
                    return observed;
                };
                // Removes an observable element
                ObjectObservers.prototype.remove = function(observed) {
                    this._resizeObserver.unobserve(observed.element);
                    this._elementsMap.delete(observed.element);
                };
                return ObjectObservers;
            }();
            var observers = new ObjectObservers();
            var RiveFile = /** @class */ function() {
                function RiveFile(params) {
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    this.referenceCount = 0;
                    this.destroyed = false;
                    this.selfUnref = false;
                    this.bindableArtboards = [];
                    this.src = params.src;
                    this.buffer = params.buffer;
                    if (params.assetLoader) this.assetLoader = params.assetLoader;
                    this.enableRiveAssetCDN = typeof params.enableRiveAssetCDN == "boolean" ? params.enableRiveAssetCDN : true;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                }
                RiveFile.prototype.releaseFile = function() {
                    var _a;
                    if (this.selfUnref) (_a = this.file) === null || _a === void 0 || _a.unref();
                    this.file = null;
                };
                RiveFile.prototype.releaseBindableArtboards = function() {
                    this.bindableArtboards.forEach(function(bindableArtboard) {
                        return bindableArtboard.destroy();
                    });
                };
                RiveFile.prototype.initData = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, loader, loaderWrapper, _b, fileFinalizer;
                        return __generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _a.buffer = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    if (this.assetLoader) {
                                        loaderWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.CustomFileAssetLoaderWrapper(this.runtime, this.assetLoader);
                                        loader = loaderWrapper.assetLoader;
                                    }
                                    // Load the Rive file
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _b.file = _c.sent();
                                    fileFinalizer = new _utils__WEBPACK_IMPORTED_MODULE_3__.FileFinalizer(this.file);
                                    _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(this, fileFinalizer);
                                    if (this.destroyed) {
                                        this.releaseFile();
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    if (this.file !== null) this.eventManager.fire({
                                        type: EventType.Load,
                                        data: this
                                    });
                                    else this.fireLoadError(RiveFile.fileLoadErrorMessage);
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.init = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, error_1;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    // If no source file url specified, it's a bust
                                    if (!this.src && !this.buffer) {
                                        this.fireLoadError(RiveFile.missingErrorMessage);
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        RuntimeLoader.awaitInstance()
                                    ];
                                case 2:
                                    _a.runtime = _b.sent();
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.initData()
                                    ];
                                case 3:
                                    _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    error_1 = _b.sent();
                                    this.fireLoadError(error_1 instanceof Error ? error_1.message : RiveFile.fileLoadErrorMessage);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.fireLoadError = function(message) {
                    this.eventManager.fire({
                        type: EventType.LoadError,
                        data: message
                    });
                    throw new Error(message);
                };
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ RiveFile.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ RiveFile.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                RiveFile.prototype.cleanup = function() {
                    this.referenceCount -= 1;
                    if (this.referenceCount <= 0) {
                        this.removeAllRiveEventListeners();
                        this.releaseFile();
                        this.releaseBindableArtboards();
                        this.destroyed = true;
                    }
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ RiveFile.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                RiveFile.prototype.getInstance = function() {
                    if (this.file !== null) {
                        this.referenceCount += 1;
                        return this.file;
                    }
                };
                RiveFile.prototype.destroyIfUnused = function() {
                    if (this.referenceCount <= 0) this.cleanup();
                };
                RiveFile.prototype.createBindableArtboard = function(nativeBindableArtboard) {
                    if (nativeBindableArtboard != null) {
                        var bindableArtboard = new BindableArtboard(nativeBindableArtboard);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(bindableArtboard, bindableArtboard.nativeArtboard);
                        this.bindableArtboards.push(bindableArtboard);
                        return bindableArtboard;
                    }
                    return null;
                };
                /**
     * @deprecated This function is deprecated. For better stability and memory management
     * use `getBindableArtboard()` instead.
     * @param {string} name - The name of the artboard.
     * @returns {Artboard} The artboard to bind to.
     */ RiveFile.prototype.getArtboard = function(name) {
                    var nativeArtboard = this.file.artboardByName(name);
                    if (nativeArtboard != null) return new Artboard(nativeArtboard, this);
                };
                RiveFile.prototype.getBindableArtboard = function(name) {
                    var nativeArtboard = this.file.bindableArtboardByName(name);
                    return this.createBindableArtboard(nativeArtboard);
                };
                RiveFile.prototype.getDefaultBindableArtboard = function() {
                    var nativeArtboard = this.file.bindableArtboardDefault();
                    return this.createBindableArtboard(nativeArtboard);
                };
                RiveFile.prototype.internalBindableArtboardFromArtboard = function(artboard) {
                    var nativeBindableArtboard = this.file.internalBindableArtboardFromArtboard(artboard);
                    return this.createBindableArtboard(nativeBindableArtboard);
                };
                RiveFile.prototype.viewModelByName = function(name) {
                    var viewModel = this.file.viewModelByName(name);
                    if (viewModel !== null) return new ViewModel(viewModel);
                    return null;
                };
                // Error message for missing source or buffer
                RiveFile.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for file load error
                RiveFile.fileLoadErrorMessage = "The file failed to load";
                return RiveFile;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _this = this;
                    var _a, _b;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    // Tracks if a Rive file is destroyed
                    this.destroyed = false;
                    // Reference of an object that handles any observers for the animation
                    this._observed = null;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    this.dispatchPointerExit = true;
                    // Allow all pointers to be passed to the runtime
                    this.enableMultiTouch = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Keep a local value of the set volume to update it asynchronously
                    this._volume = 1;
                    // Keep a local value of the set width to update it asynchronously
                    this._artboardWidth = undefined;
                    // Keep a local value of the set height to update it asynchronously
                    this._artboardHeight = undefined;
                    // Keep a local value of the device pixel ratio used in rendering and canvas/artboard resizing
                    this._devicePixelRatioUsed = 1;
                    // Whether the canvas element's size is 0
                    this._hasZeroSize = false;
                    // Whether a draw operation needs to be forced
                    this._needsRedraw = false;
                    // Canvas width and height. Values are lazily updated so they might
                    // not be in sync with current canvas size.
                    this._currentCanvasWidth = 0;
                    this._currentCanvasHeight = 0;
                    // Audio event listener
                    this._audioEventListener = null;
                    // draw method bound to the class
                    this._boundDraw = null;
                    this._viewModelInstance = null;
                    this._dataEnums = null;
                    this.drawOptimization = DrawOptimizationOptions.DrawOnChanged;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    this.isTouchScrollEnabled = false;
                    this.onCanvasResize = function(hasZeroSize) {
                        var toggledDisplay = _this._hasZeroSize !== hasZeroSize;
                        _this._hasZeroSize = hasZeroSize;
                        if (!hasZeroSize) {
                            if (toggledDisplay) _this.resizeDrawingSurfaceToCanvas();
                        } else if (!_this._layout.maxX || !_this._layout.maxY) _this.resizeToCanvas();
                    };
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this._boundDraw = this.draw.bind(this);
                    this.canvas = params.canvas;
                    if (params.canvas.constructor === HTMLCanvasElement) this._observed = observers.add(this.canvas, this.onCanvasResize);
                    this._currentCanvasWidth = this.canvas.width;
                    this._currentCanvasHeight = this.canvas.height;
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.riveFile = params.riveFile;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.isTouchScrollEnabled = !!params.isTouchScrollEnabled;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.dispatchPointerExit = params.dispatchPointerExit === false ? params.dispatchPointerExit : this.dispatchPointerExit;
                    this.enableMultiTouch = !!params.enableMultiTouch;
                    this.drawOptimization = (_b = params.drawingOptions) !== null && _b !== void 0 ? _b : this.drawOptimization;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        riveFile: this.riveFile,
                        autoplay: params.autoplay,
                        autoBind: params.autoBind,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                Object.defineProperty(Rive.prototype, "viewModelCount", {
                    get: function() {
                        return this.file.viewModelCount();
                    },
                    enumerable: false,
                    configurable: true
                });
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Event handler for when audio context becomes available
                Rive.prototype.onSystemAudioChanged = function() {
                    this.volume = this._volume;
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, riveFile = _a.riveFile, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c, _d = _a.autoBind, autoBind = _d === void 0 ? false : _d;
                    if (this.destroyed) return;
                    this.src = src;
                    this.buffer = buffer;
                    this.riveFile = riveFile;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer && !this.riveFile) throw new RiveError(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        if (_this.destroyed) return;
                        _this.runtime = runtime;
                        _this.removeRiveListeners();
                        _this.deleteRiveRenderer();
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay, autoBind).then(function(hasInitialized) {
                            if (hasInitialized) return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                /**
     * Setup Rive Listeners on the canvas
     * @param riveListenerOptions - Enables TouchEvent events on the canvas. Set to true to allow
     * touch scrolling on the canvas element on touch-enabled devices
     * i.e. { isTouchScrollEnabled: true }
     */ Rive.prototype.setupRiveListeners = function(riveListenerOptions) {
                    var _this = this;
                    if (this.eventCleanup) this.eventCleanup();
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        var touchScrollEnabledOption = this.isTouchScrollEnabled;
                        var dispatchPointerExit = this.dispatchPointerExit;
                        var enableMultiTouch = this.enableMultiTouch;
                        if (riveListenerOptions && "isTouchScrollEnabled" in riveListenerOptions) touchScrollEnabledOption = riveListenerOptions.isTouchScrollEnabled;
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime),
                            isTouchScrollEnabled: touchScrollEnabledOption,
                            dispatchPointerExit: dispatchPointerExit,
                            enableMultiTouch: enableMultiTouch,
                            layoutScaleFactor: this._layout.layoutScaleFactor
                        });
                    }
                };
                /**
     * Remove Rive Listeners setup on the canvas
     */ Rive.prototype.removeRiveListeners = function() {
                    if (this.eventCleanup) {
                        this.eventCleanup();
                        this.eventCleanup = null;
                    }
                };
                /**
     * If the instance has audio and the system audio is not ready
     * we hook the instance to the audio manager
     */ Rive.prototype.initializeAudio = function() {
                    var _this = this;
                    var _a;
                    // Initialize audio if needed
                    if (audioManager.status == SystemAudioStatus.UNAVAILABLE) {
                        if (this.file.hasAudio || ((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.hasAudio) && this._audioEventListener === null) {
                            this._audioEventListener = {
                                type: EventType.AudioStatusChange,
                                callback: function() {
                                    return _this.onSystemAudioChanged();
                                }
                            };
                            audioManager.add(this._audioEventListener);
                            audioManager.establishAudio();
                        }
                    }
                };
                Rive.prototype.initArtboardSize = function() {
                    if (!this.artboard) return;
                    // Use preset values if they are not undefined
                    this._artboardWidth = this.artboard.width = this._artboardWidth || this.artboard.width;
                    this._artboardHeight = this.artboard.height = this._artboardHeight || this.artboard.height;
                };
                // Initializes runtime with Rive data and preps for playing.
                // Returns true for successful initialization.
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay, autoBind) {
                    return __awaiter(this, void 0, void 0, function() {
                        var riveFile, error_2, msg;
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _b.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!(this.riveFile == null)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    riveFile = new RiveFile({
                                        src: this.src,
                                        buffer: this.buffer,
                                        enableRiveAssetCDN: this.enableRiveAssetCDN,
                                        assetLoader: this.assetLoader
                                    });
                                    this.riveFile = riveFile;
                                    return [
                                        4 /*yield*/ ,
                                        riveFile.init()
                                    ];
                                case 1:
                                    _b.sent();
                                    if (this.destroyed) {
                                        // In the very unlikely scenario where the rive file created by this Rive is shared by
                                        // another rive file, we only want to destroy it if this file is the only owner.
                                        riveFile.destroyIfUnused();
                                        return [
                                            2 /*return*/ ,
                                            false
                                        ];
                                    }
                                    _b.label = 2;
                                case 2:
                                    this.file = this.riveFile.getInstance();
                                    // Initialize and draw frame
                                    this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay, autoBind);
                                    // Initialize the artboard size
                                    this.initArtboardSize();
                                    // Check for audio
                                    this.initializeAudio();
                                    // Everything's set up, emit a load event
                                    this.loaded = true;
                                    this.eventManager.fire({
                                        type: EventType.Load,
                                        data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                    });
                                    // Only initialize paused state machines after the load event has been fired
                                    // to allow users to initialize inputs and view models before the first advance
                                    this.animator.advanceIfPaused();
                                    // Flag ready for playback commands and clear the task queue; this order
                                    // is important or it may infinitely recurse
                                    this.readyForPlaying = true;
                                    this.taskQueue.process();
                                    this.drawFrame();
                                    return [
                                        2 /*return*/ ,
                                        true
                                    ];
                                case 3:
                                    error_2 = _b.sent();
                                    msg = resolveErrorMessage(error_2);
                                    console.warn(msg);
                                    this.eventManager.fire({
                                        type: EventType.LoadError,
                                        data: msg
                                    });
                                    return [
                                        2 /*return*/ ,
                                        Promise.reject(msg)
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay, autoBind) {
                    if (!this.file) return;
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    rootArtboard.volume = this._volume * audioManager.systemVolume;
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                    if (autoBind) {
                        var viewModel = this.file.defaultArtboardViewModel(rootArtboard);
                        if (viewModel !== null) {
                            var runtimeInstance = viewModel.defaultInstance();
                            if (runtimeInstance !== null) {
                                var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                                (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, viewModelInstance.runtimeInstance);
                                this.bindViewModelInstance(viewModelInstance);
                            }
                        }
                    }
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    var _a, _b;
                    if ((_a = document === null || document === void 0 ? void 0 : document.timeline) === null || _a === void 0 ? void 0 : _a.currentTime) {
                        if (this.loaded && this.artboard && !this.frameRequestId) {
                            this._boundDraw(document.timeline.currentTime);
                            (_b = this.runtime) === null || _b === void 0 || _b.resolveAnimationFrame();
                        }
                    } else this.scheduleRendering();
                };
                Rive.prototype._canvasSizeChanged = function() {
                    var changed = false;
                    if (this.canvas) {
                        if (this.canvas.width !== this._currentCanvasWidth) {
                            this._currentCanvasWidth = this.canvas.width;
                            changed = true;
                        }
                        if (this.canvas.height !== this._currentCanvasHeight) {
                            this._currentCanvasHeight = this.canvas.height;
                            changed = true;
                        }
                    }
                    return changed;
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    var _a;
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    var before = performance.now();
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _b = 0, activeStateMachines_1 = activeStateMachines; _b < activeStateMachines_1.length; _b++){
                        var stateMachine = activeStateMachines_1[_b];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _c = event_1, url = _c.url, target = _c.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_3__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advanceAndApply(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    if (this.animator.stateMachines.length == 0) this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Do not draw on 0 canvas size
                    if (!this._hasZeroSize) // If there was no dirt on this frame, do not clear and draw
                    {
                        if (this.drawOptimization == DrawOptimizationOptions.AlwaysDraw || this.artboard.didChange() || this._needsRedraw || this._canvasSizeChanged()) {
                            // Canvas must be wiped to prevent artifacts
                            renderer.clear();
                            renderer.save();
                            // Update the renderer alignment if necessary
                            this.alignRenderer();
                            this.artboard.draw(renderer);
                            renderer.restore();
                            renderer.flush();
                            this._needsRedraw = false;
                        }
                    }
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    (_a = this._viewModelInstance) === null || _a === void 0 || _a.handleCallbacks();
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.scheduleRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds, this._devicePixelRatioUsed * _layout.layoutScaleFactor);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a, _b;
                    this.destroyed = true;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Remove from observer
                    if (this._observed !== null) observers.remove(this._observed);
                    this.removeRiveListeners();
                    if (this.file) {
                        (_a = this.riveFile) === null || _a === void 0 || _a.cleanup();
                        this.file = null;
                    }
                    this.riveFile = null;
                    this.deleteRiveRenderer();
                    if (this._audioEventListener !== null) {
                        audioManager.remove(this._audioEventListener);
                        this._audioEventListener = null;
                    }
                    (_b = this._viewModelInstance) === null || _b === void 0 || _b.cleanup();
                    this._viewModelInstance = null;
                    this._dataEnums = null;
                };
                /**
     * Cleans up the Renderer object. Only call this API if you no longer
     * need to render Rive content in your session.
     */ Rive.prototype.deleteRiveRenderer = function() {
                    var _a;
                    (_a = this.renderer) === null || _a === void 0 || _a.delete();
                    this.renderer = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    // If there is no artboard, this.animator will be undefined
                    if (this.animator) this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a, _b;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    var autoBind = (_b = params === null || params === void 0 ? void 0 : params.autoBind) !== null && _b !== void 0 ? _b : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay, autoBind);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    this.file = null;
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener.
     *
     * This method will set the {@link devicePixelRatioUsed} property.
     *
     * Optionally, you can provide a {@link customDevicePixelRatio} to provide a
     * custom value.
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.devicePixelRatioUsed = dpr;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this._needsRedraw = true;
                        this.resizeToCanvas();
                        this.drawFrame();
                        if (this.layout.fit === Fit.Layout) {
                            var scaleFactor = this._layout.layoutScaleFactor;
                            this.artboard.width = width / scaleFactor;
                            this.artboard.height = height / scaleFactor;
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                // Returns the input with the provided name at the given path
                Rive.prototype.retrieveInputAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No input name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access input: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var input = this.artboard.inputByPath(name, path);
                    if (!input) {
                        console.warn("Could not access an input with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return input;
                };
                /**
     * Set the boolean input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setBooleanStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Boolean) input.asBool().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a boolean"));
                };
                /**
     * Set the number input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setNumberStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Number) input.asNumber().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a number"));
                };
                /**
     * Fire the trigger with the provided name at the given path
     * @param input the state machine input name
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.fireStateAtPath = function(inputName, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Trigger) input.asTrigger().fire();
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a trigger"));
                };
                // Returns the TextValueRun object for the provided name at the given path
                Rive.prototype.retrieveTextAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No text name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!path) {
                        console.warn("No path provided for text '".concat(name, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var text = this.artboard.textByPath(name, path);
                    if (!text) {
                        console.warn("Could not access text with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return text;
                };
                /**
     * Retrieves the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param path The path to the text run within the artboard
     * @returns The text value of the text run, or undefined if not found
     *
     * @example
     * // Get the text value for a text run named "title" at one nested artboard deep
     * const titleText = riveInstance.getTextRunValueAtPath("title", "artboard1");
     *
     * @example
     * // Get the text value for a text run named "subtitle" within a nested group two artboards deep
     * const subtitleText = riveInstance.getTextRunValueAtPath("subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.getTextRunValueAtPath = function(textName, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not get text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return run.text;
                };
                /**
     * Sets the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param value The new text value to set
     * @param path The path to the text run within the artboard
     * @returns void
     *
     * @example
     * // Set the text value for a text run named "title" at one nested artboard deep
     * riveInstance.setTextRunValueAtPath("title", "New Title", "artboard1");
     *
     * @example
     * // Set the text value for a text run named "subtitle" within a nested group two artboards deep
     * riveInstance.setTextRunValueAtPath("subtitle", "New Subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.setTextRunValueAtPath = function(textName, value, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not set text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    run.text = value;
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function() {
                        var _a, _b;
                        return (_b = (_a = this.animator) === null || _a === void 0 ? void 0 : _a.isStopped) !== null && _b !== void 0 ? _b : true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    this.drawFrame();
                };
                Rive.prototype.scheduleRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this._boundDraw);
                        else this.frameRequestId = requestAnimationFrame(this._boundDraw);
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "volume", {
                    /**
         * Getter / Setter for the volume of the artboard
         */ get: function() {
                        if (this.artboard && this.artboard.volume !== this._volume) this._volume = this.artboard.volume;
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        if (this.artboard) this.artboard.volume = value * audioManager.systemVolume;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardWidth", {
                    /**
         * The width of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * width has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard width is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.width;
                        return (_a = this._artboardWidth) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardWidth = value;
                        if (this.artboard) this.artboard.width = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardHeight", {
                    /**
         * The height of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * height has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard height is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.height;
                        return (_a = this._artboardHeight) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardHeight = value;
                        if (this.artboard) this.artboard.height = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Reset the artboard size to its original values.
     */ Rive.prototype.resetArtboardSize = function() {
                    if (this.artboard) {
                        this.artboard.resetArtboardSize();
                        this._artboardWidth = this.artboard.width;
                        this._artboardHeight = this.artboard.height;
                    } else {
                        // If the artboard isn't loaded, we need to reset the custom width and height
                        this._artboardWidth = undefined;
                        this._artboardHeight = undefined;
                    }
                };
                Object.defineProperty(Rive.prototype, "devicePixelRatioUsed", {
                    /**
         * The device pixel ratio used in rendering and canvas/artboard resizing.
         *
         * This value will be overidden by the device pixel ratio used in
         * {@link resizeDrawingSurfaceToCanvas}. If you use that method, do not set this value.
         */ get: function() {
                        return this._devicePixelRatioUsed;
                    },
                    set: function(value) {
                        this._devicePixelRatioUsed = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Initialize the data context with the view model instance.
     */ Rive.prototype.bindViewModelInstance = function(viewModelInstance) {
                    var _a;
                    if (this.artboard && !this.destroyed) {
                        if (viewModelInstance && viewModelInstance.runtimeInstance) {
                            viewModelInstance.internalIncrementReferenceCount();
                            (_a = this._viewModelInstance) === null || _a === void 0 || _a.cleanup();
                            this._viewModelInstance = viewModelInstance;
                            if (this.animator.stateMachines.length > 0) this.animator.stateMachines.forEach(function(stateMachine) {
                                return stateMachine.bindViewModelInstance(viewModelInstance);
                            });
                            else this.artboard.bindViewModelInstance(viewModelInstance.runtimeInstance);
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "viewModelInstance", {
                    get: function() {
                        return this._viewModelInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                Rive.prototype.viewModelByIndex = function(index) {
                    var viewModel = this.file.viewModelByIndex(index);
                    if (viewModel !== null) return new ViewModel(viewModel);
                    return null;
                };
                Rive.prototype.viewModelByName = function(name) {
                    var _a;
                    return (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.viewModelByName(name);
                };
                Rive.prototype.enums = function() {
                    if (this._dataEnums === null) {
                        var dataEnums = this.file.enums();
                        this._dataEnums = dataEnums.map(function(dataEnum) {
                            return new DataEnum(dataEnum);
                        });
                    }
                    return this._dataEnums;
                };
                Rive.prototype.defaultViewModel = function() {
                    if (this.artboard) {
                        var viewModel = this.file.defaultArtboardViewModel(this.artboard);
                        if (viewModel) return new ViewModel(viewModel);
                    }
                    return null;
                };
                /**
     * @deprecated This function is deprecated. For better stability and memory management
     * use `getBindableArtboard()` instead.
     * @param {string} name - The name of the artboard.
     * @returns {Artboard} The artboard to bind to.
     */ Rive.prototype.getArtboard = function(name) {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getArtboard(name)) !== null && _b !== void 0 ? _b : null;
                };
                Rive.prototype.getBindableArtboard = function(name) {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getBindableArtboard(name)) !== null && _b !== void 0 ? _b : null;
                };
                Rive.prototype.getDefaultBindableArtboard = function() {
                    var _a, _b;
                    return (_b = (_a = this.riveFile) === null || _a === void 0 ? void 0 : _a.getDefaultBindableArtboard()) !== null && _b !== void 0 ? _b : null;
                };
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for removed rive file
                Rive.cleanupErrorMessage = "Attempt to use file after calling cleanup.";
                return Rive;
            }();
            var ViewModel = /** @class */ function() {
                function ViewModel(viewModel) {
                    this._viewModel = viewModel;
                }
                Object.defineProperty(ViewModel.prototype, "instanceCount", {
                    get: function() {
                        return this._viewModel.instanceCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModel.prototype, "name", {
                    get: function() {
                        return this._viewModel.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModel.prototype.instanceByIndex = function(index) {
                    var instance = this._viewModel.instanceByIndex(index);
                    if (instance !== null) {
                        var viewModelInstance = new ViewModelInstance(instance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, instance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.instanceByName = function(name) {
                    var instance = this._viewModel.instanceByName(name);
                    if (instance !== null) {
                        var viewModelInstance = new ViewModelInstance(instance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, instance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.defaultInstance = function() {
                    var runtimeInstance = this._viewModel.defaultInstance();
                    if (runtimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModel.prototype.instance = function() {
                    var runtimeInstance = this._viewModel.instance();
                    if (runtimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, null);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                Object.defineProperty(ViewModel.prototype, "properties", {
                    get: function() {
                        return this._viewModel.getProperties();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModel.prototype, "instanceNames", {
                    get: function() {
                        return this._viewModel.getInstanceNames();
                    },
                    enumerable: false,
                    configurable: true
                });
                return ViewModel;
            }();
            var DataEnum = /** @class */ function() {
                function DataEnum(dataEnum) {
                    this._dataEnum = dataEnum;
                }
                Object.defineProperty(DataEnum.prototype, "name", {
                    get: function() {
                        return this._dataEnum.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DataEnum.prototype, "values", {
                    get: function() {
                        return this._dataEnum.values;
                    },
                    enumerable: false,
                    configurable: true
                });
                return DataEnum;
            }();
            var PropertyType;
            (function(PropertyType) {
                PropertyType["Number"] = "number";
                PropertyType["String"] = "string";
                PropertyType["Boolean"] = "boolean";
                PropertyType["Color"] = "color";
                PropertyType["Trigger"] = "trigger";
                PropertyType["Enum"] = "enum";
                PropertyType["List"] = "list";
                PropertyType["Image"] = "image";
                PropertyType["Artboard"] = "artboard";
            })(PropertyType || (PropertyType = {}));
            var ViewModelInstance = /** @class */ function() {
                function ViewModelInstance(runtimeInstance, parent) {
                    this._parents = [];
                    this._children = [];
                    this._viewModelInstances = new Map();
                    this._propertiesWithCallbacks = [];
                    this._referenceCount = 0;
                    this.selfUnref = false;
                    this._runtimeInstance = runtimeInstance;
                    if (parent !== null) this._parents.push(parent);
                }
                Object.defineProperty(ViewModelInstance.prototype, "runtimeInstance", {
                    get: function() {
                        return this._runtimeInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstance.prototype, "nativeInstance", {
                    get: function() {
                        return this._runtimeInstance;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstance.prototype.handleCallbacks = function() {
                    if (this._propertiesWithCallbacks.length !== 0) {
                        this._propertiesWithCallbacks.forEach(function(property) {
                            property.handleCallbacks();
                        });
                        this._propertiesWithCallbacks.forEach(function(property) {
                            property.clearChanges();
                        });
                    }
                    this._children.forEach(function(child) {
                        return child.handleCallbacks();
                    });
                };
                ViewModelInstance.prototype.addParent = function(parent) {
                    if (!this._parents.includes(parent)) {
                        this._parents.push(parent);
                        if (this._propertiesWithCallbacks.length > 0 || this._children.length > 0) parent.addToViewModelCallbacks(this);
                    }
                };
                ViewModelInstance.prototype.removeParent = function(parent) {
                    var index = this._parents.indexOf(parent);
                    if (index !== -1) {
                        var parent_1 = this._parents[index];
                        parent_1.removeFromViewModelCallbacks(this);
                        this._parents.splice(index, 1);
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.addToPropertyCallbacks = function(property) {
                    var _this = this;
                    if (!this._propertiesWithCallbacks.includes(property)) {
                        this._propertiesWithCallbacks.push(property);
                        if (this._propertiesWithCallbacks.length > 0) this._parents.forEach(function(parent) {
                            parent.addToViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.removeFromPropertyCallbacks = function(property) {
                    var _this = this;
                    if (this._propertiesWithCallbacks.includes(property)) {
                        this._propertiesWithCallbacks = this._propertiesWithCallbacks.filter(function(prop) {
                            return prop !== property;
                        });
                        if (this._children.length === 0 && this._propertiesWithCallbacks.length === 0) this._parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.addToViewModelCallbacks = function(instance) {
                    var _this = this;
                    if (!this._children.includes(instance)) {
                        this._children.push(instance);
                        this._parents.forEach(function(parent) {
                            parent.addToViewModelCallbacks(_this);
                        });
                    }
                };
                /*
     * method for internal use, it shouldn't be called externally
     */ ViewModelInstance.prototype.removeFromViewModelCallbacks = function(instance) {
                    var _this = this;
                    if (this._children.includes(instance)) {
                        this._children = this._children.filter(function(child) {
                            return child !== instance;
                        });
                        if (this._children.length === 0 && this._propertiesWithCallbacks.length === 0) this._parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                ViewModelInstance.prototype.clearCallbacks = function() {
                    this._propertiesWithCallbacks.forEach(function(property) {
                        property.clearCallbacks();
                    });
                };
                ViewModelInstance.prototype.propertyFromPath = function(path, type) {
                    var pathSegments = path.split("/");
                    return this.propertyFromPathSegments(pathSegments, 0, type);
                };
                ViewModelInstance.prototype.viewModelFromPathSegments = function(pathSegments, index) {
                    var viewModelInstance = this.internalViewModelInstance(pathSegments[index]);
                    if (viewModelInstance !== null) {
                        if (index == pathSegments.length - 1) return viewModelInstance;
                        else return viewModelInstance.viewModelFromPathSegments(pathSegments, index++);
                    }
                    return null;
                };
                ViewModelInstance.prototype.propertyFromPathSegments = function(pathSegments, index, type) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                    if (index < pathSegments.length - 1) {
                        var viewModelInstance = this.internalViewModelInstance(pathSegments[index]);
                        if (viewModelInstance !== null) return viewModelInstance.propertyFromPathSegments(pathSegments, index + 1, type);
                        else return null;
                    }
                    var instance = null;
                    switch(type){
                        case PropertyType.Number:
                            instance = (_b = (_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.number(pathSegments[index])) !== null && _b !== void 0 ? _b : null;
                            if (instance !== null) return new ViewModelInstanceNumber(instance, this);
                            break;
                        case PropertyType.String:
                            instance = (_d = (_c = this._runtimeInstance) === null || _c === void 0 ? void 0 : _c.string(pathSegments[index])) !== null && _d !== void 0 ? _d : null;
                            if (instance !== null) return new ViewModelInstanceString(instance, this);
                            break;
                        case PropertyType.Boolean:
                            instance = (_f = (_e = this._runtimeInstance) === null || _e === void 0 ? void 0 : _e.boolean(pathSegments[index])) !== null && _f !== void 0 ? _f : null;
                            if (instance !== null) return new ViewModelInstanceBoolean(instance, this);
                            break;
                        case PropertyType.Color:
                            instance = (_h = (_g = this._runtimeInstance) === null || _g === void 0 ? void 0 : _g.color(pathSegments[index])) !== null && _h !== void 0 ? _h : null;
                            if (instance !== null) return new ViewModelInstanceColor(instance, this);
                            break;
                        case PropertyType.Trigger:
                            instance = (_k = (_j = this._runtimeInstance) === null || _j === void 0 ? void 0 : _j.trigger(pathSegments[index])) !== null && _k !== void 0 ? _k : null;
                            if (instance !== null) return new ViewModelInstanceTrigger(instance, this);
                            break;
                        case PropertyType.Enum:
                            instance = (_m = (_l = this._runtimeInstance) === null || _l === void 0 ? void 0 : _l.enum(pathSegments[index])) !== null && _m !== void 0 ? _m : null;
                            if (instance !== null) return new ViewModelInstanceEnum(instance, this);
                            break;
                        case PropertyType.List:
                            instance = (_p = (_o = this._runtimeInstance) === null || _o === void 0 ? void 0 : _o.list(pathSegments[index])) !== null && _p !== void 0 ? _p : null;
                            if (instance !== null) return new ViewModelInstanceList(instance, this);
                            break;
                        case PropertyType.Image:
                            instance = (_r = (_q = this._runtimeInstance) === null || _q === void 0 ? void 0 : _q.image(pathSegments[index])) !== null && _r !== void 0 ? _r : null;
                            if (instance !== null) return new ViewModelInstanceAssetImage(instance, this);
                            break;
                        case PropertyType.Artboard:
                            instance = (_t = (_s = this._runtimeInstance) === null || _s === void 0 ? void 0 : _s.artboard(pathSegments[index])) !== null && _t !== void 0 ? _t : null;
                            if (instance !== null) return new ViewModelInstanceArtboard(instance, this);
                            break;
                    }
                    return null;
                };
                ViewModelInstance.prototype.internalViewModelInstance = function(name) {
                    var _a;
                    if (this._viewModelInstances.has(name)) return this._viewModelInstances.get(name);
                    var viewModelRuntimeInstance = (_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.viewModel(name);
                    if (viewModelRuntimeInstance !== null) {
                        var viewModelInstance = new ViewModelInstance(viewModelRuntimeInstance, this);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, viewModelRuntimeInstance);
                        viewModelInstance.internalIncrementReferenceCount();
                        this._viewModelInstances.set(name, viewModelInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                /**
     * method to access a property instance of type number belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the number property
     */ ViewModelInstance.prototype.number = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Number);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type string belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the string property
     */ ViewModelInstance.prototype.string = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.String);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type boolean belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the boolean property
     */ ViewModelInstance.prototype.boolean = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Boolean);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type color belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the ttrigger property
     */ ViewModelInstance.prototype.color = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Color);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type trigger belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the trigger property
     */ ViewModelInstance.prototype.trigger = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Trigger);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type enum belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the enum property
     */ ViewModelInstance.prototype.enum = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Enum);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a property instance of type list belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the list property
     */ ViewModelInstance.prototype.list = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.List);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a view model property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the image property
     */ ViewModelInstance.prototype.image = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Image);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access an artboard property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the image property
     */ ViewModelInstance.prototype.artboard = function(path) {
                    var viewmodelInstanceValue = this.propertyFromPath(path, PropertyType.Artboard);
                    return viewmodelInstanceValue;
                };
                /**
     * method to access a view model property instance belonging
     * to the view model instance or to a nested view model instance
     * @param path - path to the view model property
     */ ViewModelInstance.prototype.viewModel = function(path) {
                    var pathSegments = path.split("/");
                    var parentViewModelInstance = pathSegments.length > 1 ? this.viewModelFromPathSegments(pathSegments.slice(0, pathSegments.length - 1), 0) : this;
                    if (parentViewModelInstance != null) return parentViewModelInstance.internalViewModelInstance(pathSegments[pathSegments.length - 1]);
                    return null;
                };
                ViewModelInstance.prototype.internalReplaceViewModel = function(name, value) {
                    var _a;
                    if (value.runtimeInstance !== null) {
                        var result = ((_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.replaceViewModel(name, value.runtimeInstance)) || false;
                        if (result) {
                            value.internalIncrementReferenceCount();
                            var oldInstance_1 = this.internalViewModelInstance(name);
                            if (oldInstance_1 !== null) {
                                oldInstance_1.removeParent(this);
                                if (this._children.includes(oldInstance_1)) this._children = this._children.filter(function(child) {
                                    return child !== oldInstance_1;
                                });
                                oldInstance_1.cleanup();
                            }
                            this._viewModelInstances.set(name, value);
                            value.addParent(this);
                        }
                        return result;
                    }
                    return false;
                };
                /**
     * method to replace a view model property with another view model value
     * @param path - path to the view model property
     * @param value - view model that will replace the original
     */ ViewModelInstance.prototype.replaceViewModel = function(path, value) {
                    var _a;
                    var pathSegments = path.split("/");
                    var viewModelInstance = pathSegments.length > 1 ? this.viewModelFromPathSegments(pathSegments.slice(0, pathSegments.length - 1), 0) : this;
                    return (_a = viewModelInstance === null || viewModelInstance === void 0 ? void 0 : viewModelInstance.internalReplaceViewModel(pathSegments[pathSegments.length - 1], value)) !== null && _a !== void 0 ? _a : false;
                };
                /*
     * method to add one to the reference counter of the instance.
     * Use if the file owning the reference is destroyed but the instance needs to stay around
     */ ViewModelInstance.prototype.incrementReferenceCount = function() {
                    var _a;
                    this._referenceCount++;
                    (_a = this._runtimeInstance) === null || _a === void 0 || _a.incrementReferenceCount();
                };
                /*
     * method to subtract one to the reference counter of the instance.
     * Use if incrementReferenceCount has been called
     */ ViewModelInstance.prototype.decrementReferenceCount = function() {
                    var _a;
                    this._referenceCount--;
                    (_a = this._runtimeInstance) === null || _a === void 0 || _a.decrementReferenceCount();
                };
                Object.defineProperty(ViewModelInstance.prototype, "properties", {
                    get: function() {
                        var _a;
                        return ((_a = this._runtimeInstance) === null || _a === void 0 ? void 0 : _a.getProperties().map(function(prop) {
                            return __assign({}, prop);
                        })) || [];
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstance.prototype.internalIncrementReferenceCount = function() {
                    this._referenceCount++;
                };
                ViewModelInstance.prototype.cleanup = function() {
                    var _this = this;
                    var _a;
                    this._referenceCount--;
                    if (this._referenceCount <= 0) {
                        if (this.selfUnref) (_a = this._runtimeInstance) === null || _a === void 0 || _a.unref();
                        this._runtimeInstance = null;
                        this.clearCallbacks();
                        this._propertiesWithCallbacks = [];
                        this._viewModelInstances.forEach(function(value) {
                            value.cleanup();
                        });
                        this._viewModelInstances.clear();
                        var children = __spreadArray([], this._children, true);
                        this._children.length = 0;
                        var parents = __spreadArray([], this._parents, true);
                        this._parents.length = 0;
                        children.forEach(function(child) {
                            child.removeParent(_this);
                        });
                        parents.forEach(function(parent) {
                            parent.removeFromViewModelCallbacks(_this);
                        });
                    }
                };
                return ViewModelInstance;
            }();
            var ViewModelInstanceValue = /** @class */ function() {
                function ViewModelInstanceValue(instance, parent) {
                    this.callbacks = [];
                    this._viewModelInstanceValue = instance;
                    this._parentViewModel = parent;
                }
                ViewModelInstanceValue.prototype.on = function(callback) {
                    // Since we don't clean the changed flag for properties that don't have listeners,
                    // we clean it the first time we add a listener to it
                    if (this.callbacks.length === 0) this._viewModelInstanceValue.clearChanges();
                    if (!this.callbacks.includes(callback)) {
                        this.callbacks.push(callback);
                        this._parentViewModel.addToPropertyCallbacks(this);
                    }
                };
                ViewModelInstanceValue.prototype.off = function(callback) {
                    if (!callback) this.callbacks.length = 0;
                    else this.callbacks = this.callbacks.filter(function(cb) {
                        return cb !== callback;
                    });
                    if (this.callbacks.length === 0) this._parentViewModel.removeFromPropertyCallbacks(this);
                };
                ViewModelInstanceValue.prototype.internalHandleCallback = function(callback) {};
                ViewModelInstanceValue.prototype.handleCallbacks = function() {
                    var _this = this;
                    if (this._viewModelInstanceValue.hasChanged) this.callbacks.forEach(function(callback) {
                        _this.internalHandleCallback(callback);
                    });
                };
                ViewModelInstanceValue.prototype.clearChanges = function() {
                    this._viewModelInstanceValue.clearChanges();
                };
                ViewModelInstanceValue.prototype.clearCallbacks = function() {
                    this.callbacks.length = 0;
                };
                Object.defineProperty(ViewModelInstanceValue.prototype, "name", {
                    get: function() {
                        return this._viewModelInstanceValue.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                return ViewModelInstanceValue;
            }();
            var ViewModelInstanceString = /** @class */ function(_super) {
                __extends(ViewModelInstanceString, _super);
                function ViewModelInstanceString(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceString.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceString.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceString;
            }(ViewModelInstanceValue);
            var ViewModelInstanceNumber = /** @class */ function(_super) {
                __extends(ViewModelInstanceNumber, _super);
                function ViewModelInstanceNumber(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceNumber.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceNumber.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceNumber;
            }(ViewModelInstanceValue);
            var ViewModelInstanceBoolean = /** @class */ function(_super) {
                __extends(ViewModelInstanceBoolean, _super);
                function ViewModelInstanceBoolean(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceBoolean.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceBoolean.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceBoolean;
            }(ViewModelInstanceValue);
            var ViewModelInstanceTrigger = /** @class */ function(_super) {
                __extends(ViewModelInstanceTrigger, _super);
                function ViewModelInstanceTrigger(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                ViewModelInstanceTrigger.prototype.trigger = function() {
                    return this._viewModelInstanceValue.trigger();
                };
                ViewModelInstanceTrigger.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceTrigger;
            }(ViewModelInstanceValue);
            var ViewModelInstanceEnum = /** @class */ function(_super) {
                __extends(ViewModelInstanceEnum, _super);
                function ViewModelInstanceEnum(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceEnum.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstanceEnum.prototype, "valueIndex", {
                    get: function() {
                        return this._viewModelInstanceValue.valueIndex;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.valueIndex = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ViewModelInstanceEnum.prototype, "values", {
                    get: function() {
                        return this._viewModelInstanceValue.values;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceEnum.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceEnum;
            }(ViewModelInstanceValue);
            var ViewModelInstanceList = /** @class */ function(_super) {
                __extends(ViewModelInstanceList, _super);
                function ViewModelInstanceList(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceList.prototype, "length", {
                    get: function() {
                        return this._viewModelInstanceValue.size;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceList.prototype.addInstance = function(instance) {
                    if (instance.runtimeInstance != null) {
                        this._viewModelInstanceValue.addInstance(instance.runtimeInstance);
                        instance.addParent(this._parentViewModel);
                    }
                };
                ViewModelInstanceList.prototype.addInstanceAt = function(instance, index) {
                    if (instance.runtimeInstance != null) {
                        if (this._viewModelInstanceValue.addInstanceAt(instance.runtimeInstance, index)) {
                            instance.addParent(this._parentViewModel);
                            return true;
                        }
                    }
                    return false;
                };
                ViewModelInstanceList.prototype.removeInstance = function(instance) {
                    if (instance.runtimeInstance != null) {
                        this._viewModelInstanceValue.removeInstance(instance.runtimeInstance);
                        instance.removeParent(this._parentViewModel);
                    }
                };
                ViewModelInstanceList.prototype.removeInstanceAt = function(index) {
                    this._viewModelInstanceValue.removeInstanceAt(index);
                };
                ViewModelInstanceList.prototype.instanceAt = function(index) {
                    var runtimeInstance = this._viewModelInstanceValue.instanceAt(index);
                    if (runtimeInstance != null) {
                        var viewModelInstance = new ViewModelInstance(runtimeInstance, this._parentViewModel);
                        (0, _utils__WEBPACK_IMPORTED_MODULE_3__.createFinalization)(viewModelInstance, runtimeInstance);
                        return viewModelInstance;
                    }
                    return null;
                };
                ViewModelInstanceList.prototype.swap = function(a, b) {
                    this._viewModelInstanceValue.swap(a, b);
                };
                ViewModelInstanceList.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceList;
            }(ViewModelInstanceValue);
            var ViewModelInstanceColor = /** @class */ function(_super) {
                __extends(ViewModelInstanceColor, _super);
                function ViewModelInstanceColor(instance, parent) {
                    return _super.call(this, instance, parent) || this;
                }
                Object.defineProperty(ViewModelInstanceColor.prototype, "value", {
                    get: function() {
                        return this._viewModelInstanceValue.value;
                    },
                    set: function(val) {
                        this._viewModelInstanceValue.value = val;
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceColor.prototype.rgb = function(r, g, b) {
                    this._viewModelInstanceValue.rgb(r, g, b);
                };
                ViewModelInstanceColor.prototype.rgba = function(r, g, b, a) {
                    this._viewModelInstanceValue.argb(a, r, g, b);
                };
                ViewModelInstanceColor.prototype.argb = function(a, r, g, b) {
                    this._viewModelInstanceValue.argb(a, r, g, b);
                };
                // Value 0 to 255
                ViewModelInstanceColor.prototype.alpha = function(a) {
                    this._viewModelInstanceValue.alpha(a);
                };
                // Value 0 to 1
                ViewModelInstanceColor.prototype.opacity = function(o) {
                    this._viewModelInstanceValue.alpha(Math.round(Math.max(0, Math.min(1, o)) * 255));
                };
                ViewModelInstanceColor.prototype.internalHandleCallback = function(callback) {
                    callback(this.value);
                };
                return ViewModelInstanceColor;
            }(ViewModelInstanceValue);
            var ViewModelInstanceAssetImage = /** @class */ function(_super) {
                __extends(ViewModelInstanceAssetImage, _super);
                function ViewModelInstanceAssetImage(instance, root) {
                    return _super.call(this, instance, root) || this;
                }
                Object.defineProperty(ViewModelInstanceAssetImage.prototype, "value", {
                    set: function(image) {
                        var _a;
                        this._viewModelInstanceValue.value((_a = image === null || image === void 0 ? void 0 : image.nativeImage) !== null && _a !== void 0 ? _a : null);
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceAssetImage.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceAssetImage;
            }(ViewModelInstanceValue);
            var ViewModelInstanceArtboard = /** @class */ function(_super) {
                __extends(ViewModelInstanceArtboard, _super);
                function ViewModelInstanceArtboard(instance, root) {
                    return _super.call(this, instance, root) || this;
                }
                Object.defineProperty(ViewModelInstanceArtboard.prototype, "value", {
                    set: function(artboard) {
                        var _a, _b;
                        var bindableArtboard;
                        if (artboard.isBindableArtboard) bindableArtboard = artboard;
                        else bindableArtboard = artboard.file.internalBindableArtboardFromArtboard(artboard.nativeArtboard);
                        this._viewModelInstanceValue.value((_a = bindableArtboard === null || bindableArtboard === void 0 ? void 0 : bindableArtboard.nativeArtboard) !== null && _a !== void 0 ? _a : null);
                        if (bindableArtboard === null || bindableArtboard === void 0 ? void 0 : bindableArtboard.nativeViewModel) this._viewModelInstanceValue.viewModelInstance((_b = bindableArtboard === null || bindableArtboard === void 0 ? void 0 : bindableArtboard.nativeViewModel) !== null && _b !== void 0 ? _b : null);
                    },
                    enumerable: false,
                    configurable: true
                });
                ViewModelInstanceArtboard.prototype.internalHandleCallback = function(callback) {
                    callback();
                };
                return ViewModelInstanceArtboard;
            }(ViewModelInstanceValue);
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an audio asset.
 *
 * Be sure to call `.unref()` on the audio once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeAudio = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, audio, audioWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeAudio(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                audio = _a.sent();
                                audioWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.AudioWrapper(audio);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(audioWrapper, audio);
                                return [
                                    2 /*return*/ ,
                                    audioWrapper
                                ];
                        }
                    });
                });
            };
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.unref()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, image, imageWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeImage(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                image = _a.sent();
                                imageWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.ImageWrapper(image);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(imageWrapper, image);
                                return [
                                    2 /*return*/ ,
                                    imageWrapper
                                ];
                        }
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.unref()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function(bytes) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var decodedPromise, font, fontWrapper;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                decodedPromise = new Promise(function(resolve) {
                                    return RuntimeLoader.getInstance(function(rive) {
                                        rive.decodeFont(bytes, resolve);
                                    });
                                });
                                return [
                                    4 /*yield*/ ,
                                    decodedPromise
                                ];
                            case 1:
                                font = _a.sent();
                                fontWrapper = new _utils__WEBPACK_IMPORTED_MODULE_3__.FontWrapper(font);
                                _utils__WEBPACK_IMPORTED_MODULE_3__.finalizationRegistry.register(fontWrapper, font);
                                return [
                                    2 /*return*/ ,
                                    fontWrapper
                                ];
                        }
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});


function $50735c891600d15e$var$t(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var $50735c891600d15e$var$r = /*#__PURE__*/ $50735c891600d15e$var$t($acw62), $50735c891600d15e$var$u = function() {
    return $50735c891600d15e$var$u = Object.assign || function(e) {
        for(var n, t = 1, r = arguments.length; t < r; t++)for(var u in n = arguments[t])Object.prototype.hasOwnProperty.call(n, u) && (e[u] = n[u]);
        return e;
    }, $50735c891600d15e$var$u.apply(this, arguments);
};
function $50735c891600d15e$var$a(e, n) {
    var t = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var u = 0;
        for(r = Object.getOwnPropertySymbols(e); u < r.length; u++)n.indexOf(r[u]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[u]) && (t[r[u]] = e[r[u]]);
    }
    return t;
}
function $50735c891600d15e$var$i(e, n, t, r) {
    return new (t || (t = Promise))(function(u, a) {
        function i(e) {
            try {
                l(r.next(e));
            } catch (e) {
                a(e);
            }
        }
        function o(e) {
            try {
                l(r.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function l(e) {
            var n;
            e.done ? u(e.value) : (n = e.value, n instanceof t ? n : new t(function(e) {
                e(n);
            })).then(i, o);
        }
        l((r = r.apply(e, n || [])).next());
    });
}
function $50735c891600d15e$var$o(e, n) {
    var t, r, u, a, i = {
        label: 0,
        sent: function() {
            if (1 & u[0]) throw u[1];
            return u[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (t) throw new TypeError("Generator is already executing.");
                for(; i;)try {
                    if (t = 1, r && (u = 2 & a[0] ? r.return : a[0] ? r.throw || ((u = r.return) && u.call(r), 0) : r.next) && !(u = u.call(r, a[1])).done) return u;
                    switch(r = 0, u && (a = [
                        2 & a[0],
                        u.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            u = a;
                            break;
                        case 4:
                            return i.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            i.label++, r = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = i.ops.pop(), i.trys.pop();
                            continue;
                        default:
                            if (!(u = i.trys, (u = u.length > 0 && u[u.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                i = 0;
                                continue;
                            }
                            if (3 === a[0] && (!u || a[1] > u[0] && a[1] < u[3])) {
                                i.label = a[1];
                                break;
                            }
                            if (6 === a[0] && i.label < u[1]) {
                                i.label = u[1], u = a;
                                break;
                            }
                            if (u && i.label < u[2]) {
                                i.label = u[2], i.ops.push(a);
                                break;
                            }
                            u[2] && i.ops.pop(), i.trys.pop();
                            continue;
                    }
                    a = n.call(e, i);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    t = u = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}
function $50735c891600d15e$var$l(n) {
    var t = n || $50735c891600d15e$var$c(), r = $acw62.useState(t), u = r[0], a = r[1];
    return $acw62.useEffect(function() {
        if ("undefined" != typeof window && "matchMedia" in window) {
            var e = function() {
                var e = n || $50735c891600d15e$var$c();
                a(e);
            }, t = window.matchMedia("screen and (resolution: ".concat(u, "dppx)"));
            return t.hasOwnProperty("addEventListener") ? t.addEventListener("change", e) : t.addListener(e), function() {
                t.hasOwnProperty("removeEventListener") ? t.removeEventListener("change", e) : t.removeListener(e);
            };
        }
    }, [
        u,
        n
    ]), u;
}
function $50735c891600d15e$var$c() {
    var e = "undefined" != typeof window && "number" == typeof window.devicePixelRatio ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, e), 3);
}
var $50735c891600d15e$var$s = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}();
var $50735c891600d15e$var$f = globalThis.ResizeObserver || $50735c891600d15e$var$s, $50735c891600d15e$var$d = void 0 !== globalThis.ResizeObserver, $50735c891600d15e$var$v = !$50735c891600d15e$var$d;
function $50735c891600d15e$var$p(n, t) {
    void 0 === t && (t = !0);
    var r = $acw62.useState({
        width: 0,
        height: 0
    }), u = r[0], a = r[1];
    $acw62.useEffect(function() {
        if ("undefined" != typeof window && t) {
            var e = function() {
                a({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return $50735c891600d15e$var$v && (e(), window.addEventListener("resize", e)), function() {
                return window.removeEventListener("resize", e);
            };
        }
    }, []);
    var i, o, l, c = $acw62.useRef(new $50735c891600d15e$var$f((i = function(e) {
        $50735c891600d15e$var$d && a({
            width: e[e.length - 1].contentRect.width,
            height: e[e.length - 1].contentRect.height
        });
    }, o = 0, l = 0, function() {
        for(var e = this, n = [], t = 0; t < arguments.length; t++)n[t] = arguments[t];
        clearTimeout(l), l = window.setTimeout(function() {
            return i.apply(e, n);
        }, o);
    })));
    return $acw62.useEffect(function() {
        var e = c.current;
        if (t) {
            var r = n.current;
            return n.current && $50735c891600d15e$var$d && e.observe(n.current), function() {
                e.disconnect(), r && $50735c891600d15e$var$d && e.unobserve(r);
            };
        }
        e.disconnect();
    }, [
        n,
        c
    ]), u;
}
var $50735c891600d15e$var$h = {
    useDevicePixelRatio: !0,
    fitCanvasToArtboardHeight: !1,
    useOffscreenRenderer: !0,
    shouldResizeCanvasToContainer: !0
};
function $50735c891600d15e$var$b(e) {
    return Object.assign({}, $50735c891600d15e$var$h, e);
}
function $50735c891600d15e$var$g(n) {
    var t = n.riveLoaded, r = void 0 !== t && t, u = n.canvasElem, a = n.containerRef, i = n.options, o = void 0 === i ? {} : i, c = n.onCanvasHasResized, s = n.artboardBounds, f = $50735c891600d15e$var$b(o), d = $acw62.useState({
        height: 0,
        width: 0
    }), v = d[0], h = v.height, g = v.width, y = d[1], w = $acw62.useState({
        height: 0,
        width: 0
    }), m = w[0], C = m.height, R = m.width, E = w[1], V = $acw62.useState(!0), x = V[0], k = V[1], O = f.fitCanvasToArtboardHeight, I = f.shouldResizeCanvasToContainer, P = f.useDevicePixelRatio, M = f.customDevicePixelRatio, T = $50735c891600d15e$var$p(a, I), S = $50735c891600d15e$var$l(M), D = null != s ? s : {}, L = D.maxX, A = D.maxY, z = $acw62.useCallback(function() {
        var e, n, t, r, u = null !== (n = null === (e = a.current) || void 0 === e ? void 0 : e.clientWidth) && void 0 !== n ? n : 0, i = null !== (r = null === (t = a.current) || void 0 === t ? void 0 : t.clientHeight) && void 0 !== r ? r : 0;
        return O && s ? {
            width: u,
            height: u * (s.maxY / s.maxX)
        } : {
            width: u,
            height: i
        };
    }, [
        a,
        O,
        L,
        A
    ]);
    $acw62.useEffect(function() {
        if (I && a.current && r) {
            var e = z(), n = e.width, t = e.height, i = !1;
            if (u) {
                var o = n !== g || t !== h;
                if (f.fitCanvasToArtboardHeight && o && (a.current.style.height = t + "px", i = !0), f.useDevicePixelRatio) {
                    if (o || n * S !== R || t * S !== C) {
                        var l = S * n, s = S * t;
                        u.width = l, u.height = s, u.style.width = n + "px", u.style.height = t + "px", E({
                            width: l,
                            height: s
                        }), i = !0;
                    }
                } else o && (u.width = n, u.height = t, E({
                    width: n,
                    height: t
                }), i = !0);
                y({
                    width: n,
                    height: t
                });
            }
            c && (x || i) && c && c(), x && k(!1);
        }
    }, [
        u,
        a,
        T,
        S,
        z,
        x,
        k,
        C,
        R,
        h,
        g,
        c,
        I,
        O,
        P,
        r
    ]), $acw62.useEffect(function() {
        E({
            width: 0,
            height: 0
        });
    }, [
        u
    ]);
}
var $50735c891600d15e$var$y, $50735c891600d15e$var$w = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}(), $50735c891600d15e$var$m = globalThis.IntersectionObserver || $50735c891600d15e$var$w, $50735c891600d15e$var$C = function() {
    function e() {
        var e = this;
        this.elementsMap = new Map, this.onObserved = function(n) {
            n.forEach(function(n) {
                var t = e.elementsMap.get(n.target);
                t && t(n);
            });
        }, this.observer = new $50735c891600d15e$var$m(this.onObserved);
    }
    return e.prototype.registerCallback = function(e, n) {
        this.observer.observe(e), this.elementsMap.set(e, n);
    }, e.prototype.removeCallback = function(e) {
        this.observer.unobserve(e), this.elementsMap.delete(e);
    }, e;
}(), $50735c891600d15e$var$R = function() {
    return $50735c891600d15e$var$y || ($50735c891600d15e$var$y = new $50735c891600d15e$var$C), $50735c891600d15e$var$y;
};
function $50735c891600d15e$var$E(e) {
    var n = e.setContainerRef, t = e.setCanvasRef, i = e.className, o = void 0 === i ? "" : i, l = e.style, c = e.children, s = $50735c891600d15e$var$a(e, [
        "setContainerRef",
        "setCanvasRef",
        "className",
        "style",
        "children"
    ]), f = $50735c891600d15e$var$u({
        width: "100%",
        height: "100%"
    }, l);
    return $50735c891600d15e$var$r.default.createElement("div", $50735c891600d15e$var$u({
        ref: n,
        className: o
    }, !o && {
        style: f
    }), $50735c891600d15e$var$r.default.createElement("canvas", $50735c891600d15e$var$u({
        ref: t,
        style: {
            verticalAlign: "top",
            width: 0,
            height: 0
        }
    }, s), c));
}
function $50735c891600d15e$var$V(t, i) {
    void 0 === i && (i = {});
    var o = $acw62.useState(null), c = o[0], s = o[1], f = $acw62.useRef(null), d = $acw62.useRef(null), v = $acw62.useState(null), p = v[0], h = v[1], y = Boolean(t), w = $50735c891600d15e$var$b(i), m = $50735c891600d15e$var$l(), C = $acw62.useCallback(function() {
        if (p) {
            if (p.layout && p.layout.fit === $23afc4ba69f19a2b$exports.Fit.Layout && c) {
                var e = m * p.layout.layoutScaleFactor;
                p.devicePixelRatioUsed = m, p.artboardWidth = (null == c ? void 0 : c.width) / e, p.artboardHeight = (null == c ? void 0 : c.height) / e;
            }
            p.startRendering(), p.resizeToCanvas();
        }
    }, [
        p,
        m
    ]);
    $50735c891600d15e$var$g({
        riveLoaded: !!p,
        canvasElem: c,
        containerRef: f,
        options: w,
        onCanvasHasResized: C,
        artboardBounds: null == p ? void 0 : p.bounds
    });
    var V = $acw62.useCallback(function(e) {
        null === e && c && (c.height = 0, c.width = 0), s(e);
    }, []);
    $acw62.useEffect(function() {
        if (c && t) {
            var e, r = null != p;
            if (null == p) {
                var i = w.useOffscreenRenderer, o = t.onRiveReady, l = $50735c891600d15e$var$a(t, [
                    "onRiveReady"
                ]);
                e = new $23afc4ba69f19a2b$exports.Rive($50735c891600d15e$var$u($50735c891600d15e$var$u({
                    useOffscreenRenderer: i
                }, l), {
                    canvas: c
                })), null != d.current && d.current.cleanup(), d.current = e, e.on($23afc4ba69f19a2b$exports.EventType.Load, function() {
                    r = !0, o && o(e), c ? h(e) : e.cleanup();
                });
            }
            return function() {
                r || null == e || e.cleanup();
            };
        }
    }, [
        c,
        y,
        p
    ]);
    var x = $acw62.useCallback(function(e) {
        f.current = e;
    }, []), k = {
        observe: $acw62.useCallback(function(e, n) {
            $50735c891600d15e$var$R().registerCallback(e, n);
        }, []),
        unobserve: $acw62.useCallback(function(e) {
            $50735c891600d15e$var$R().removeCallback(e);
        }, [])
    }, O = k.observe, I = k.unobserve;
    $acw62.useEffect(function() {
        var e, n = !1, t = function() {
            if (c && n) {
                var e = c.getBoundingClientRect();
                e.width > 0 && e.height > 0 && e.top < (window.innerHeight || document.documentElement.clientHeight) && e.bottom > 0 && e.left < (window.innerWidth || document.documentElement.clientWidth) && e.right > 0 && (null == p || p.startRendering(), n = !1);
            }
        };
        return c && !1 !== w.shouldUseIntersectionObserver && O(c, function(r) {
            r.isIntersecting ? p && p.startRendering() : p && p.stopRendering(), n = !r.isIntersecting, clearTimeout(e), r.isIntersecting || 0 !== r.boundingClientRect.width || (e = setTimeout(t, 10));
        }), function() {
            c && I(c);
        };
    }, [
        O,
        I,
        p,
        c,
        w.shouldUseIntersectionObserver
    ]), $acw62.useEffect(function() {
        return function() {
            p && (p.cleanup(), h(null));
        };
    }, [
        p,
        c
    ]), $acw62.useEffect(function() {
        return function() {
            null != d.current && d.current.cleanup();
        };
    }, []);
    var P = null == t ? void 0 : t.animations;
    $acw62.useEffect(function() {
        p && P && (p.isPlaying ? (p.stop(p.animationNames), p.play(P)) : p.isPaused && (p.stop(p.animationNames), p.pause(P)));
    }, [
        P,
        p
    ]);
    var M = $acw62.useCallback(function(e) {
        return $50735c891600d15e$var$r.default.createElement($50735c891600d15e$var$E, $50735c891600d15e$var$u({
            setContainerRef: x,
            setCanvasRef: V
        }, e));
    }, [
        V,
        x
    ]);
    return {
        canvas: c,
        container: f.current,
        setCanvasRef: V,
        setContainerRef: x,
        rive: p,
        RiveComponent: M
    };
}
function $50735c891600d15e$var$x(n, t, r) {
    var a = $acw62.useState(null), i = a[0], o = a[1], l = $acw62.useState(r.defaultValue), c = l[0], s = l[1], f = $acw62.useState(null), d = f[0], v = f[1], p = $acw62.useRef(null), h = $acw62.useRef(n), b = $acw62.useRef(r);
    $acw62.useEffect(function() {
        b.current = r;
    }, [
        r
    ]);
    var g = $acw62.useCallback(function() {
        var e = p.current, n = h.current, t = b.current;
        if (!e || !n) return o(null), s(t.defaultValue), v(null), function() {};
        var r = t.getProperty(e, n);
        if (r) {
            o(r), s(t.getValue(r)), t.getExtendedData && v(t.getExtendedData(r));
            var u = function() {
                s(t.getValue(r)), t.getExtendedData && v(t.getExtendedData(r)), t.onPropertyEvent && t.onPropertyEvent();
            };
            return r.on(u), function() {
                r.off(u);
            };
        }
        return function() {};
    }, []);
    $acw62.useEffect(function() {
        return p.current = t, h.current = n, g();
    }, [
        t,
        n,
        g
    ]);
    var y = $acw62.useCallback(function(e) {
        if (i && p.current === t) try {
            return e(i), void (b.current.getExtendedData && v(b.current.getExtendedData(i)));
        } catch (e) {}
        if (p.current) try {
            var n = b.current.getProperty(p.current, h.current);
            n && (o(n), e(n), b.current.getExtendedData && v(b.current.getExtendedData(n)));
        } catch (e) {}
    }, [
        i,
        t
    ]), w = $acw62.useMemo(function() {
        return b.current.buildPropertyOperations(y);
    }, [
        y
    ]), m = $50735c891600d15e$var$u({
        value: c
    }, w);
    return r.getExtendedData && (m.extendedData = d), m;
}
$50735c891600d15e$exports.default = function(e) {
    var n = e.src, t = e.artboard, i = e.animations, o = e.stateMachines, l = e.layout, c = e.useOffscreenRenderer, s = void 0 === c || c, f = e.shouldDisableRiveListeners, d = void 0 !== f && f, v = e.shouldResizeCanvasToContainer, p = void 0 === v || v, h = e.automaticallyHandleEvents, b = void 0 !== h && h, g = e.children, y = $50735c891600d15e$var$a(e, [
        "src",
        "artboard",
        "animations",
        "stateMachines",
        "layout",
        "useOffscreenRenderer",
        "shouldDisableRiveListeners",
        "shouldResizeCanvasToContainer",
        "automaticallyHandleEvents",
        "children"
    ]), w = $50735c891600d15e$var$V({
        src: n,
        artboard: t,
        animations: i,
        layout: l,
        stateMachines: o,
        autoplay: !0,
        shouldDisableRiveListeners: d,
        automaticallyHandleEvents: b
    }, {
        useOffscreenRenderer: s,
        shouldResizeCanvasToContainer: p
    }).RiveComponent;
    return $50735c891600d15e$var$r.default.createElement(w, $50735c891600d15e$var$u({}, y), g);
}, $50735c891600d15e$exports.useResizeCanvas = $50735c891600d15e$var$g, $50735c891600d15e$exports.useRive = $50735c891600d15e$var$V, $50735c891600d15e$exports.useRiveFile = function(t) {
    var r = this, u = $acw62.useState(null), a = u[0], l = u[1], c = $acw62.useState("idle"), s = c[0], f = c[1];
    return $acw62.useEffect(function() {
        var e = null;
        return $50735c891600d15e$var$i(r, void 0, void 0, function() {
            return $50735c891600d15e$var$o(this, function(r) {
                try {
                    f("loading"), (e = new $23afc4ba69f19a2b$exports.RiveFile(t)).init(), e.on($23afc4ba69f19a2b$exports.EventType.Load, function() {
                        null == e || e.getInstance(), l(e), f("success");
                    }), e.on($23afc4ba69f19a2b$exports.EventType.LoadError, function() {
                        f("failed");
                    }), l(e);
                } catch (e) {
                    console.error(e), f("failed");
                }
                return [
                    2
                ];
            });
        }), function() {
            null == e || e.cleanup();
        };
    }, [
        t.src,
        t.buffer
    ]), {
        riveFile: a,
        status: s
    };
}, $50735c891600d15e$exports.useStateMachineInput = function(t, r, u, a) {
    var i = $acw62.useState(null), o = i[0], l = i[1];
    return $acw62.useEffect(function() {
        function e() {
            if (t && r && u || l(null), t && r && u) {
                var e = t.stateMachineInputs(r);
                if (e) {
                    var n = e.find(function(e) {
                        return e.name === u;
                    });
                    void 0 !== a && n && (n.value = a), l(n || null);
                }
            } else l(null);
        }
        e(), t && t.on($23afc4ba69f19a2b$exports.EventType.Load, function() {
            e();
        });
    }, [
        t
    ]), o;
}, $50735c891600d15e$exports.useViewModel = function(t, r) {
    var u = null != r ? r : {}, a = u.name, i = u.useDefault, o = void 0 !== i && i, l = $acw62.useState(null), c = l[0], s = l[1];
    return $acw62.useEffect(function() {
        function e() {
            var e;
            if (t) {
                var n = null;
                n = null != a ? (null === (e = t.viewModelByName) || void 0 === e ? void 0 : e.call(t, a)) || null : t.defaultViewModel() || null, s(n);
            } else s(null);
        }
        return e(), t && t.on($23afc4ba69f19a2b$exports.EventType.Load, e), function() {
            t && t.off($23afc4ba69f19a2b$exports.EventType.Load, e);
        };
    }, [
        t,
        a,
        o
    ]), c;
}, $50735c891600d15e$exports.useViewModelInstance = function(n, t) {
    var r = null != t ? t : {}, u = r.name, a = r.useDefault, i = void 0 !== a && a, o = r.useNew, l = void 0 !== o && o, c = r.rive, s = $acw62.useState(null), f = s[0], d = s[1];
    return $acw62.useEffect(function() {
        var e, t, r;
        if (n) {
            var a = null;
            a = null != u ? n.instanceByName(u) || null : i ? (null === (e = n.defaultInstance) || void 0 === e ? void 0 : e.call(n)) || null : l ? (null === (t = n.instance) || void 0 === t ? void 0 : t.call(n)) || null : (null === (r = n.defaultInstance) || void 0 === r ? void 0 : r.call(n)) || null, d(a), c && a && c.viewModelInstance !== a && c.bindViewModelInstance(a);
        } else d(null);
    }, [
        n,
        u,
        i,
        l,
        c
    ]), f;
}, $50735c891600d15e$exports.useViewModelInstanceArtboard = function(n, t) {
    return {
        setValue: $50735c891600d15e$var$x(n, t, {
            getProperty: $acw62.useCallback(function(e, n) {
                return e.artboard(n);
            }, []),
            getValue: $acw62.useCallback(function() {}, []),
            defaultValue: null,
            buildPropertyOperations: $acw62.useCallback(function(e) {
                return {
                    setValue: function(n) {
                        e(function(e) {
                            e.value = n;
                        });
                    }
                };
            }, [])
        }).setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceBoolean = function(n, t) {
    var r = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.boolean(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceColor = function(n, t) {
    var r = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.color(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                },
                setRgb: function(n, t, r) {
                    e(function(e) {
                        e.rgb(n, t, r);
                    });
                },
                setRgba: function(n, t, r, u) {
                    e(function(e) {
                        e.rgba(n, t, r, u);
                    });
                },
                setAlpha: function(n) {
                    e(function(e) {
                        e.alpha(n);
                    });
                },
                setOpacity: function(n) {
                    e(function(e) {
                        e.opacity(n);
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue,
        setRgb: r.setRgb,
        setRgba: r.setRgba,
        setAlpha: r.setAlpha,
        setOpacity: r.setOpacity
    };
}, $50735c891600d15e$exports.useViewModelInstanceEnum = function(n, t) {
    var r = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.enum(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        getExtendedData: $acw62.useCallback(function(e) {
            return e.values;
        }, []),
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        values: r.extendedData || [],
        setValue: r.setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceImage = function(n, t) {
    return {
        setValue: $50735c891600d15e$var$x(n, t, {
            getProperty: $acw62.useCallback(function(e, n) {
                return e.image(n);
            }, []),
            getValue: $acw62.useCallback(function() {}, []),
            defaultValue: null,
            buildPropertyOperations: $acw62.useCallback(function(e) {
                return {
                    setValue: function(n) {
                        e(function(e) {
                            e.value = n;
                        });
                    }
                };
            }, [])
        }).setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceList = function(n, t) {
    var r, u = $acw62.useState(0)[1], a = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.list(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.length;
        }, []),
        defaultValue: null,
        onPropertyEvent: function() {
            u(function(e) {
                return e + 1;
            });
        },
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                addInstance: function(n) {
                    e(function(e) {
                        return e.addInstance(n);
                    });
                },
                addInstanceAt: function(n, t) {
                    var r = !1;
                    return e(function(e) {
                        r = e.addInstanceAt(n, t);
                    }), r;
                },
                removeInstance: function(n) {
                    e(function(e) {
                        return e.removeInstance(n);
                    });
                },
                removeInstanceAt: function(n) {
                    e(function(e) {
                        return e.removeInstanceAt(n);
                    });
                },
                getInstanceAt: function(n) {
                    var t = null;
                    return e(function(e) {
                        t = e.instanceAt(n);
                    }), t;
                },
                swap: function(n, t) {
                    e(function(e) {
                        return e.swap(n, t);
                    });
                }
            };
        }, [])
    });
    return {
        length: null !== (r = a.value) && void 0 !== r ? r : 0,
        addInstance: a.addInstance,
        addInstanceAt: a.addInstanceAt,
        removeInstance: a.removeInstance,
        removeInstanceAt: a.removeInstanceAt,
        getInstanceAt: a.getInstanceAt,
        swap: a.swap
    };
}, $50735c891600d15e$exports.useViewModelInstanceNumber = function(n, t) {
    var r = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.number(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceString = function(n, t) {
    var r = $50735c891600d15e$var$x(n, t, {
        getProperty: $acw62.useCallback(function(e, n) {
            return e.string(n);
        }, []),
        getValue: $acw62.useCallback(function(e) {
            return e.value;
        }, []),
        defaultValue: null,
        buildPropertyOperations: $acw62.useCallback(function(e) {
            return {
                setValue: function(n) {
                    e(function(e) {
                        e.value = n;
                    });
                }
            };
        }, [])
    });
    return {
        value: r.value,
        setValue: r.setValue
    };
}, $50735c891600d15e$exports.useViewModelInstanceTrigger = function(n, t, r) {
    var u = (null != r ? r : {}).onTrigger;
    return {
        trigger: $50735c891600d15e$var$x(n, t, {
            getProperty: $acw62.useCallback(function(e, n) {
                return e.trigger(n);
            }, []),
            getValue: $acw62.useCallback(function() {}, []),
            defaultValue: null,
            onPropertyEvent: u,
            buildPropertyOperations: $acw62.useCallback(function(e) {
                return {
                    trigger: function() {
                        e(function(e) {
                            e.trigger();
                        });
                    }
                };
            }, [])
        }).trigger
    };
}, Object.keys($23afc4ba69f19a2b$exports).forEach(function(e) {
    "default" === e || $50735c891600d15e$exports.hasOwnProperty(e) || Object.defineProperty($50735c891600d15e$exports, e, {
        enumerable: !0,
        get: function() {
            return $23afc4ba69f19a2b$exports[e];
        }
    });
});


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $iD7Z3 = parcelRequire("iD7Z3");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $aphAM = parcelRequire("aphAM");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $1DAbm = parcelRequire("1DAbm");
var $4LdGL = parcelRequire("4LdGL");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $26cd3be04bc521db$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');



var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

















var $8afeb26f119c1df0$exports = {};
$8afeb26f119c1df0$exports = import.meta.resolve("kraza");


const $eaf72c139abff674$var$thumbUpOrangeRiv = new URL($8afeb26f119c1df0$exports);
var $c2793bec0a5ab9f4$exports = {};
$c2793bec0a5ab9f4$exports = import.meta.resolve("f0YMz");


const $eaf72c139abff674$var$spotWizardPathImage = new URL($c2793bec0a5ab9f4$exports);
const $eaf72c139abff674$export$1c03320bcc31fd75 = ()=>{
    const location = (0, $aphAM.useLocation)();
    const navigate = (0, $aphAM.useNavigate)();
    const wizardState = location.state?.spotWizard;
    const open = wizardState?.open === true;
    const currentStep = wizardState?.step ?? 0;
    const handleOpen = ()=>{
        navigate(location.pathname + location.search, {
            state: {
                ...location.state,
                spotWizard: {
                    open: true,
                    step: 0
                }
            }
        });
    };
    const handleClose = ()=>{
        const newState = {
            ...location.state
        };
        delete newState.spotWizard;
        navigate(location.pathname + location.search, {
            state: newState
        });
    };
    const setCurrentStep = (step)=>{
        navigate(location.pathname + location.search, {
            state: {
                ...location.state,
                spotWizard: {
                    open: true,
                    step: step
                }
            }
        });
    };
    const dialog = /*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$SpotWizardDialog, {
        open: open,
        onClose: handleClose,
        currentStep: currentStep,
        setCurrentStep: setCurrentStep
    });
    return {
        dialog: dialog,
        open: handleOpen,
        close: handleClose
    };
};
const $eaf72c139abff674$var$SpotWizardDialog = ({ open: open, onClose: onClose, currentStep: currentStep, setCurrentStep: setCurrentStep })=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const location = (0, $aphAM.useLocation)();
    const prevPathnameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(location.pathname);
    (0, $acw62.useEffect)(()=>{
        if (open && location.pathname !== prevPathnameRef.current) onClose();
        prevPathnameRef.current = location.pathname;
    }, [
        location.pathname,
        open,
        onClose
    ]);
    const variables = (0, $2lSXC.useSelector)((s)=>s.variables);
    const activeSteps = $eaf72c139abff674$var$WIZARD_STEPS.filter((step)=>!step.visible || step.visible(variables));
    const currentIndex = Math.max(0, Math.min(currentStep, activeSteps.length - 1));
    const totalActiveSteps = activeSteps.length;
    const isLastStep = currentIndex === totalActiveSteps - 1;
    const handleNext = ()=>{
        if (!isLastStep) setCurrentStep(currentIndex + 1);
        else {
            // Complete wizard
            dispatch((0, $1Jwr0.variablesChange)({
                SPOT_WIZARD_COMPLETED_AT: new Date().toISOString()
            }));
            onClose();
        }
    };
    const handlePrev = ()=>{
        if (currentIndex > 0) setCurrentStep(currentIndex - 1);
        else onClose();
    };
    const progress = (currentIndex + 1) / totalActiveSteps * 100;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
        open: open,
        onClose: onClose,
        fullScreen: true,
        slotProps: {
            paper: {
                sx: {
                    bgcolor: 'secondary.main'
                }
            }
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $6hSWk.default), {
                sx: {
                    textAlign: 'center',
                    pt: 4,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.dialog.title",
                            defaultMessage: "Pr\u016Fvodce nastaven\xedm spotu"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body2",
                        sx: {
                            mt: 1,
                            opacity: 0.7
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.dialog.step",
                            defaultMessage: "Krok {current} z {total}",
                            values: {
                                current: currentIndex + 1,
                                total: totalActiveSteps
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    px: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87e33f68a58c76cf$export$2e2bcd8739ae039), {
                    variant: "determinate",
                    value: progress
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    p: 0,
                    pt: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1DAbm.default), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                flex: 1
                            },
                            children: activeSteps[currentIndex]?.render({
                                handleNext: handleNext
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'space-between',
                                py: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: handlePrev,
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.dialog.prev",
                                        defaultMessage: "Zp\u011Bt"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: handleNext,
                                    variant: "contained",
                                    children: isLastStep ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.dialog.finish",
                                        defaultMessage: "Dokon\u010Dit"
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.dialog.next",
                                        defaultMessage: "Dal\u0161\xed"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $eaf72c139abff674$var$WIZARD_STEPS = [
    {
        render: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step1Info, {
                ...props
            })
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step2GeneralSettings, {})
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step3DistributionPrices, {})
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step4HDOTimes, {})
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step5OverflowLimit, {}),
        visible: (v)=>!!v.PV_OVERFLOW_CONTROL
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step6BatteryPurchase, {}),
        visible: (v)=>!!(v.SP_BATTERY_CONTROL_CUSTOMER && v.SP_BATTERY_CONTROL_SERVICE)
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step7BatteryDischarge, {}),
        visible: (v)=>!!v.PV_BATTERY
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step8PreferentialSale, {}),
        visible: (v)=>!!v.PV_BATTERY
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step9EveningPeakDischarge, {}),
        visible: (v)=>!!v.SP_DISCHARGE_TO_GRID_SER && !!v.PV_BATTERY
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step10Boiler, {}),
        visible: (v)=>!!v.HW_INSTALL
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$Step11HeatPump, {}),
        visible: (v)=>!!v.HP_ENABLED
    },
    {
        render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($eaf72c139abff674$var$StepDone, {})
    }
];
// Step 1: Info with buttons
const $eaf72c139abff674$var$Step1Info = ({ handleNext: handleNext })=>{
    const [view, setView] = (0, $acw62.useState)('buttons');
    const { chargingButtonVisible: chargingButtonVisible, dischargingButtonVisible: dischargingButtonVisible } = (0, $2lSXC.useSelector)(({ variables: { SP_INSTALL: SP_INSTALL, PV_BATTERY: PV_BATTERY, SP_BATTERY_CONTROL_SERVICE: SP_BATTERY_CONTROL_SERVICE, SP_DISCHARGE_TO_GRID_SER: SP_DISCHARGE_TO_GRID_SER } })=>({
            chargingButtonVisible: SP_INSTALL && PV_BATTERY && SP_BATTERY_CONTROL_SERVICE,
            dischargingButtonVisible: SP_INSTALL && PV_BATTERY && SP_DISCHARGE_TO_GRID_SER
        }));
    if (view === 'help1') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: ()=>setView('buttons'),
                        size: "small",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26cd3be04bc521db$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.info.help1.title",
                            defaultMessage: "Pro\u010D se mi dnes nenabila baterie ze spotu?"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotBatteryChargeFromGrid"
                        })
                    })
                })
            })
        ]
    });
    if (view === 'help2') return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: ()=>setView('buttons'),
                        size: "small",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $26cd3be04bc521db$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.info.help2.title",
                            defaultMessage: "Pro\u010D se mi dnes nevyb\xedjela baterie do spotu?"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotBatteryDischargeToGrid"
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.info.title",
                    defaultMessage: "Informace ke spotu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                },
                children: [
                    chargingButtonVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "outlined",
                        fullWidth: true,
                        sx: {
                            py: 2
                        },
                        onClick: ()=>setView('help1'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.info.button1",
                            defaultMessage: "Pro\u010D se mi dnes nenabila baterie ze spotu?"
                        })
                    }),
                    dischargingButtonVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "outlined",
                        fullWidth: true,
                        sx: {
                            py: 2
                        },
                        onClick: ()=>setView('help2'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot_wizard.info.button2",
                            defaultMessage: "Pro\u010D se mi dnes nevyb\xedjela baterie do spotu?"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "outlined",
                        fullWidth: true,
                        sx: {
                            py: 2
                        },
                        onClick: handleNext,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.info.button3",
                                defaultMessage: "Chci pomoc s nastaven\xedm"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
// Step 2: General Settings
const $eaf72c139abff674$var$Step2GeneralSettings = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.general_settings.title",
                    defaultMessage: "Nejprve obecn\xe9 nastaven\xed"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3fc89740a40a9451$export$af551370f369b7df), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9ab324d1199a267$export$59ba75a4d6ef29cf), {})
                ]
            })
        ]
    });
};
// Step 3: Distribution Prices
const $eaf72c139abff674$var$Step3DistributionPrices = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.distribution_prices.title",
                    defaultMessage: "Zadejte cenu za distribuci v n\xedzk\xe9m a vysok\xe9m tarifu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68f859cf525acf7a$export$cdc95709697474db), {})
        ]
    });
};
// Step 4: HDO Times
const $eaf72c139abff674$var$Step4HDOTimes = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.hdo_times.title",
                    defaultMessage: "Nastaven\xed HDO \u010Das\u016F ur\u010D\xed obdob\xed n\xedzk\xe9ho tarifu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $15ab72d8453343b9$export$c21d98c0cce5a4d8), {})
        ]
    });
};
// Step 5: Overflow Limit
const $eaf72c139abff674$var$Step5OverflowLimit = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.overflow_limit.title",
                    defaultMessage: "Omezen\xed p\u0159etoku do s\xedt\u011B"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.overflow_limit.paragraph1",
                                defaultMessage: "Pokud m\xe1te spot pouze pro n\xe1kup energie, m\u016F\u017Eete nastavit -10 K\u010D. P\u0159etok je omezen na maxim\xe1ln\xed velikost nastavenou servisn\xedm technikem."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.overflow_limit.paragraph2",
                                defaultMessage: "Pokud m\xe1te spot i pro prodej energie, je v\xfdhodn\xe9 zastavit akumulaci p\u0159i cen\u011B, kter\xe1 odpov\xedd\xe1 provizi Va\u0161eho dodavatele. Provize b\xfdv\xe1 nej\u010Dast\u011Bji 0.30 - 0.70 K\u010D/kWh. "
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $293abdf0e2299566$export$847b3c781643970a), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce67e5a088fdb8b5$export$a373c8a9d52b5cbc), {})
                ]
            })
        ]
    });
};
// Step 6: Battery Purchase
const $eaf72c139abff674$var$Step6BatteryPurchase = ()=>{
    const SP_USER_ADVANCED_CONTROL = (0, $2lSXC.useSelector)((s)=>s.variables.SP_USER_ADVANCED_CONTROL);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.battery_purchase.title",
                    defaultMessage: "N\xe1kup energie do baterie"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.battery_purchase.paragraph1",
                                defaultMessage: "Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny nab\xedt baterii z n\xedzk\xe9ho spotu."
                            })
                        })
                    }),
                    SP_USER_ADVANCED_CONTROL && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.battery_purchase.paragraph2",
                                defaultMessage: "V\u011Bnujte pozornost nastaven\xed strategie. Pokud nastav\xedte 20%, Infigy bude sp\xed\u0161e \u010Dekat na fotovoltaiku. Naopak p\u0159i nastaven\xed 70% bude sp\xed\u0161e nakupovat na spotu. Doporu\u010Dujeme nastavit 25%."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.battery_purchase.paragraph3",
                                defaultMessage: "Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete nab\xedjen\xed deaktivovat."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $915bad7549ce262b$export$4066cbe4b7657cb6), {})
                ]
            })
        ]
    });
};
// Step 7: Battery Discharge
const $eaf72c139abff674$var$Step7BatteryDischarge = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.battery_discharge.title",
                    defaultMessage: "Vyb\xedjen\xed baterie do vlastn\xed spot\u0159eby"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.battery_discharge.paragraph1",
                                defaultMessage: "Toto nastaven\xed zak\xe1\u017Ee vyb\xedjen\xed baterie p\u0159i n\xedzk\xe9 cen\u011B spotu. D\xedky tomu si uchov\xe1te energii pro vy\u0161\u0161\xed ceny dne."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.battery_discharge.paragraph2",
                                defaultMessage: "Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete z\xe1kaz deaktivovat."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcbef18988b701ff$export$23d480672c585e59), {})
                ]
            })
        ]
    });
};
// Step 8: Preferential Sale
const $eaf72c139abff674$var$Step8PreferentialSale = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.preferential_sale.title",
                    defaultMessage: "P\u0159ednostn\xed prodej energie"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.preferential_sale.paragraph1",
                                defaultMessage: "Tato funkce umo\u017En\xed z\xe1kaz ukl\xe1d\xe1n\xed energie p\u0159i rann\xed \u0161pi\u010Dce. Dojde k deaktivaci nab\xedjen\xed baterie, bojleru a tepeln\xe9ho \u010Derpadla. Akumulace se aktivuje p\u0159i n\xedzk\xe9 cen\u011B nebo p\u0159i prod\xe1n\xed odhadovan\xe9ho p\u0159ebytku energie."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.preferential_sale.paragraph2",
                                defaultMessage: "Pokud m\xe1te pouze n\xe1kup energie na spotu, m\u016F\u017Eete funkci deaktivovat."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f705ec7ee0a95c57$export$6288f0782a550253), {})
                ]
            })
        ]
    });
};
// Step 9: Evening Peak Discharge
const $eaf72c139abff674$var$Step9EveningPeakDischarge = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.evening_peak_discharge.title",
                    defaultMessage: "Vyb\xedjen\xed baterie p\u0159i ve\u010Dern\xed \u0161pi\u010Dce"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.evening_peak_discharge.paragraph1",
                                defaultMessage: "Infigy automaticky odhadne spot\u0159ebu energie do rann\xedch hodin. Nadbytek m\u016F\u017Ee b\xfdt prod\xe1n za nejvy\u0161\u0161\xed cenu dne."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.evening_peak_discharge.paragraph2",
                                defaultMessage: "Pokud m\xe1te pouze n\xe1kup energie na spotu, m\u016F\u017Eete vyb\xedjen\xed deaktivovat."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f03d73cb2c53c177$export$d0848bdd84e94d46), {})
                ]
            })
        ]
    });
};
// Step 10: Boiler
const $eaf72c139abff674$var$Step10Boiler = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.boiler.title",
                    defaultMessage: "Oh\u0159ev bojleru"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.boiler.paragraph1",
                                defaultMessage: "Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny oh\u0159\xe1t bojler z nejlevn\u011Bj\u0161\xedch cen dne do nastaven\xe9 teploty. Infigy st\xe1le udr\u017Euje z\xe1kladn\xed teplotu a vyu\u017E\xedv\xe1 nav\xfd\u0161en\xed teploty na teplotu ze spotu."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.boiler.paragraph2",
                                defaultMessage: "Z\xe1rove\u0148 je mo\u017En\xe9 blokovat oh\u0159ev p\u0159i st\u0159edn\xed a nebo vysok\xe9 cen\u011B."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.boiler.paragraph3",
                                defaultMessage: "Pokud m\xe1te pouze prodej energie na spotu, m\u016F\u017Eete teplotu nastavit na 10\xb0C a deaktivovat blokaci oh\u0159evu."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b9b2f817f448d12b$export$efd0b5fc9ad4ae27), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb0cc1e72fd5624c$export$f50acbe31a497670), {})
                ]
            })
        ]
    });
};
// Step 11: Heat Pump
const $eaf72c139abff674$var$Step11HeatPump = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.heat_pump.title",
                    defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.heat_pump.paragraph1",
                                defaultMessage: "Toto nastaven\xed umo\u017En\xed p\u0159i n\xedzk\xe9 v\xfdrob\u011B elektr\xe1rny navy\u0161ovat v\xfdkon tepeln\xe9ho \u010Derpadla p\u0159i n\xedzk\xe9 cen\u011B a naopak sni\u017Eovat v\xfdkon p\u0159i vysok\xe9 cen\u011B."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body1",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "spot_wizard.heat_pump.paragraph2",
                                defaultMessage: "Pokud m\xe1te pouze prodej energie na spotu, odlo\u017Een\xed i v\xfd\u0161en\xed spot\u0159eby deaktivovat."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $097ad4ef85a960d6$export$7ba0c1bb76c04981), {})
                ]
            })
        ]
    });
};
// Step Done
const $eaf72c139abff674$var$StepDone = ()=>{
    const { RiveComponent: RiveComponent, rive: rive } = (0, $50735c891600d15e$exports.useRive)({
        src: $eaf72c139abff674$var$thumbUpOrangeRiv.href,
        animations: 'Timeline 1',
        autoplay: true
    });
    (0, $acw62.useEffect)(()=>{
        if (!rive) return;
        const timer = setTimeout(()=>{
            rive.pause();
        }, 4000);
        return ()=>clearTimeout(timer);
    }, [
        rive
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
        gap: 2,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h2",
                sx: {
                    textAlign: 'center'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot_wizard.done.title",
                    defaultMessage: "Hotovo"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                overflow: 'hidden',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body1",
                                    sx: {
                                        flex: 1,
                                        maxWidth: 550
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.done.description",
                                        defaultMessage: "Pro\u0161li jste nastaven\xed spotu. Ve\u0161ker\xe9 parametry lze upravit ve spodn\xed \u010D\xe1sti str\xe1nky Spot, kde m\u016F\u017Eete i op\u011Bt vyvolat tohoto pr\u016Fvodce."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                    sx: {
                                        width: 100,
                                        height: 120,
                                        flexShrink: 0,
                                        position: 'relative'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                        sx: {
                                            inset: -20,
                                            position: 'absolute'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(RiveComponent, {})
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            textAlign: 'center',
                            mt: 2,
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            component: "img",
                            src: $eaf72c139abff674$var$spotWizardPathImage.toString(),
                            alt: "",
                            sx: {
                                width: 260,
                                height: 'auto'
                            }
                        })
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dxMBG = parcelRequire("dxMBG");
const $1540cc62293d4258$var$Svg = (0, $dxMBG.default)('svg')({});
const $1540cc62293d4258$export$d8d62e06e04e7f1d = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($1540cc62293d4258$var$Svg, {
        width: "169",
        height: "200",
        viewBox: "0 0 169 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                opacity: "0.15",
                clipPath: "url(#clip0_247_1329)",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.45",
                        d: "M15.2754 156.917L15.2754 142.651L30.5348 142.651L30.5348 156.917L15.2754 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.45",
                        d: "M15.2754 171.183L15.2754 156.916L30.5348 156.916L30.5348 171.183L15.2754 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M30.5312 85.5945L30.5312 71.3281L45.7906 71.3281L45.7906 85.5945L30.5312 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.45",
                        d: "M30.5312 142.652L30.5312 128.385L45.7906 128.385L45.7906 142.652L30.5312 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M45.79 99.8557L45.79 85.5894L61.0494 85.5894L61.0494 99.8557L45.79 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M45.79 128.386L45.79 114.12L61.0494 114.12L61.0494 128.386L45.79 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M45.79 156.917L45.79 142.651L61.0494 142.651L61.0494 156.917L45.79 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M61.0459 99.8557L61.0459 85.5894L76.3053 85.5894L76.3053 99.8557L61.0459 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M61.0459 114.125L61.0459 99.8589L76.3053 99.8589L76.3053 114.125L61.0459 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M61.0459 128.386L61.0459 114.12L76.3053 114.12L76.3053 128.386L61.0459 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M61.0459 171.183L61.0459 156.916L76.3053 156.916L76.3053 171.183L61.0459 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M45.8232 185.378L45.8232 171.112L61.0826 171.112L61.0826 185.378L45.8232 185.378Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M45.8232 199.606L45.8232 185.34L61.0826 185.34L61.0826 199.606L45.8232 199.606Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M30.6045 199.606L30.6045 185.34L45.8638 185.34L45.8638 199.606L30.6045 199.606Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M0.166992 185.481L0.166992 171.214L15.4263 171.214L15.4263 185.481L0.166992 185.481Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M76.3047 71.3291L76.3047 57.0627L91.5641 57.0627L91.5641 71.3291L76.3047 71.3291Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M76.3047 99.8557L76.3047 85.5894L91.5641 85.5894L91.5641 99.8557L76.3047 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M76.3047 114.125L76.3047 99.8589L91.5641 99.8589L91.5641 114.125L76.3047 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M76.3047 142.652L76.3047 128.385L91.5641 128.385L91.5641 142.652L76.3047 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M76.3047 185.448L76.3047 171.182L91.5641 171.182L91.5641 185.448L76.3047 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M76.3047 199.709L76.3047 185.443L91.5641 185.443L91.5641 199.709L76.3047 199.709Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M91.5605 71.3291L91.5605 57.0627L106.82 57.0627L106.82 71.3291L91.5605 71.3291Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M91.5605 85.5945L91.5605 71.3281L106.82 71.3281L106.82 85.5945L91.5605 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M91.5605 99.8557L91.5605 85.5894L106.82 85.5894L106.82 99.8557L91.5605 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M91.5605 114.125L91.5605 99.8589L106.82 99.8589L106.82 114.125L91.5605 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M91.5605 128.386L91.5605 114.12L106.82 114.12L106.82 128.386L91.5605 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M91.5605 156.917L91.5605 142.651L106.82 142.651L106.82 156.917L91.5605 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M91.5605 185.448L91.5605 171.182L106.82 171.182L106.82 185.448L91.5605 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M91.5605 199.709L91.5605 185.443L106.82 185.443L106.82 199.709L91.5605 199.709Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M106.819 57.0638L106.819 42.7974L122.079 42.7974L122.079 57.0638L106.819 57.0638Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M106.819 85.5945L106.819 71.3281L122.079 71.3281L122.079 85.5945L106.819 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M106.82 99.8557L106.82 85.5894L122.08 85.5894L122.08 99.8557L106.82 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M106.82 114.125L106.82 99.8589L122.08 99.8589L122.08 114.125L106.82 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M106.82 128.386L106.82 114.12L122.08 114.12L122.08 128.386L106.82 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M106.82 156.917L106.82 142.651L122.08 142.651L122.08 156.917L106.82 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M106.82 171.183L106.82 156.916L122.08 156.916L122.08 171.183L106.82 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M106.82 185.448L106.82 171.182L122.08 171.182L122.08 185.448L106.82 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M106.82 199.709L106.82 185.443L122.08 185.443L122.08 199.709L106.82 199.709Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M122.079 85.5945L122.079 71.3281L137.338 71.3281L137.338 85.5945L122.079 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M122.079 99.8557L122.079 85.5894L137.338 85.5894L137.338 99.8557L122.079 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M122.079 114.125L122.079 99.8589L137.338 99.8589L137.338 114.125L122.079 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M122.079 142.652L122.079 128.385L137.338 128.385L137.338 142.652L122.079 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M122.079 156.917L122.079 142.651L137.338 142.651L137.338 156.917L122.079 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M122.079 171.183L122.079 156.916L137.338 156.916L137.338 171.183L122.079 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M122.079 185.448L122.079 171.182L137.338 171.182L137.338 185.448L122.079 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M122.079 199.709L122.079 185.443L137.338 185.443L137.338 199.709L122.079 199.709Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M137.334 14.2718L137.334 0.00537109L152.593 0.00537109L152.593 14.2718L137.334 14.2718Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M137.334 42.7984L137.334 28.532L152.593 28.532L152.593 42.7984L137.334 42.7984Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M137.334 57.0638L137.334 42.7974L152.593 42.7974L152.593 57.0638L137.334 57.0638Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M137.334 71.3291L137.334 57.0627L152.593 57.0627L152.593 71.3291L137.334 71.3291Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M137.334 85.5945L137.334 71.3281L152.593 71.3281L152.593 85.5945L137.334 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M137.334 99.8557L137.334 85.5894L152.593 85.5894L152.593 99.8557L137.334 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M137.334 156.917L137.334 142.651L152.593 142.651L152.593 156.917L137.334 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.85",
                        d: "M137.334 185.448L137.334 171.182L152.593 171.182L152.593 185.448L137.334 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M137.334 199.709L137.334 185.443L152.593 185.443L152.593 199.709L137.334 199.709Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M152.594 28.533L152.594 14.2666L167.853 14.2666L167.853 28.533L152.594 28.533Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M152.594 57.0638L152.594 42.7974L167.853 42.7974L167.853 57.0638L152.594 57.0638Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M152.594 71.3291L152.594 57.0627L167.853 57.0627L167.853 71.3291L152.594 71.3291Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M152.594 85.5945L152.594 71.3281L167.853 71.3281L167.853 85.5945L152.594 85.5945Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M152.594 114.125L152.594 99.8589L167.853 99.8589L167.853 114.125L152.594 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M152.594 128.386L152.594 114.12L167.853 114.12L167.853 128.386L152.594 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M30.5312 171.183L30.5312 156.916L45.7906 156.916L45.7906 171.183L30.5312 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M45.79 171.183L45.79 156.916L61.0494 156.916L61.0494 171.183L45.79 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M61.0459 156.917L61.0459 142.651L76.3053 142.651L76.3053 156.917L61.0459 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M76.3047 128.386L76.3047 114.12L91.5641 114.12L91.5641 128.386L76.3047 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.3",
                        d: "M76.3047 156.917L76.3047 142.651L91.5641 142.651L91.5641 156.917L76.3047 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M76.3047 171.183L76.3047 156.916L91.5641 156.916L91.5641 171.183L76.3047 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M91.5605 142.652L91.5605 128.385L106.82 128.385L106.82 142.652L91.5605 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M91.5605 171.183L91.5605 156.916L106.82 156.916L106.82 171.183L91.5605 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.4",
                        d: "M106.82 142.652L106.82 128.385L122.08 128.385L122.08 142.652L106.82 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.8",
                        d: "M122.079 128.386L122.079 114.12L137.338 114.12L137.338 128.386L122.079 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M137.334 114.125L137.334 99.8589L152.593 99.8589L152.593 114.125L137.334 114.125Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M137.334 128.386L137.334 114.12L152.593 114.12L152.593 128.386L137.334 128.386Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.8",
                        d: "M137.334 142.652L137.334 128.385L152.593 128.385L152.593 142.652L137.334 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M137.334 171.183L137.334 156.916L152.593 156.916L152.593 171.183L137.334 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.95",
                        d: "M152.594 99.8557L152.594 85.5894L167.853 85.5894L167.853 99.8557L152.594 99.8557Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.8",
                        d: "M152.594 142.652L152.594 128.385L167.853 128.385L167.853 142.652L152.594 142.652Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.8",
                        d: "M152.594 156.917L152.594 142.651L167.853 142.651L167.853 156.917L152.594 156.917Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.7",
                        d: "M152.594 171.183L152.594 156.916L167.853 156.916L167.853 171.183L152.594 171.183Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.65",
                        d: "M152.594 185.448L152.594 171.182L167.853 171.182L167.853 185.448L152.594 185.448Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        opacity: "0.65",
                        d: "M152.594 199.709L152.594 185.443L167.853 185.443L167.853 199.709L152.594 199.709Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_247_1329",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "200",
                        height: "168.34",
                        fill: "white",
                        transform: "matrix(0 -1 1 0 0 200)"
                    })
                })
            })
        ]
    });
};


var $0f339aead6f2c2e8$exports = {};
$0f339aead6f2c2e8$exports = import.meta.resolve("886gT");


const $23960298a8a935c1$var$whiteRiv = new URL($0f339aead6f2c2e8$exports);
const $23960298a8a935c1$var$animationTimeline = 'Body Moving';
const $23960298a8a935c1$var$animationDuration = 3000;
const $23960298a8a935c1$export$bab14011024b8f09 = ({ sx: sx = {} })=>{
    const { dialog: dialog, open: open } = (0, $eaf72c139abff674$export$1c03320bcc31fd75)();
    const containerRef = (0, $acw62.useRef)(null);
    const { RiveComponent: RiveComponent, rive: rive } = (0, $50735c891600d15e$exports.useRive)({
        src: $23960298a8a935c1$var$whiteRiv.href,
        animations: $23960298a8a935c1$var$animationTimeline,
        autoplay: false
    });
    (0, $acw62.useEffect)(()=>{
        if (!containerRef.current || !rive) return;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                rive.play();
                setTimeout(()=>{
                    rive.pause();
                }, $23960298a8a935c1$var$animationDuration);
                observer.disconnect();
            }
        }, {
            threshold: 0.3
        });
        observer.observe(containerRef.current);
        return ()=>observer.disconnect();
    }, [
        rive
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                sx: {
                    ...sx
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
                    ref: containerRef,
                    sx: {
                        bgcolor: (theme)=>theme.palette.mode === 'light' ? 'text.disabled' : '#343e42',
                        color: (0, $iD7Z3.colors).white,
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                            gap: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "h3",
                                    sx: {
                                        color: 'common.white'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.banner.title",
                                        defaultMessage: "T\xe1pete? Porad\xedm V\xe1m"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body1",
                                    sx: {
                                        maxWidth: 400,
                                        mb: 2,
                                        color: 'common.white'
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot_wizard.banner.subtitle",
                                        defaultMessage: "Pr\u016Fvodce v\xe1m pom\u016F\u017Ee s nastaven\xedm spotov\xe9ho obchodov\xe1n\xed."
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                        variant: "contained",
                                        size: "small",
                                        onClick: open,
                                        sx: {
                                            textTransform: 'none'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "spot_wizard.banner.button",
                                            defaultMessage: "Chci poradit"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                alignSelf: 'stretch',
                                width: 100,
                                position: 'relative',
                                flexShrink: 0
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                sx: {
                                    inset: -35,
                                    top: -28,
                                    position: 'absolute'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)(RiveComponent, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1540cc62293d4258$export$d8d62e06e04e7f1d), {
                            sx: {
                                position: 'absolute',
                                height: '90%',
                                bottom: 0,
                                right: -80
                            }
                        })
                    ]
                })
            }),
            dialog
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $bd9zl = parcelRequire("bd9zl");
var $202BL = parcelRequire("202BL");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $b7Ol4 = parcelRequire("b7Ol4");

var $aSEG4 = parcelRequire("aSEG4");

var $iD7Z3 = parcelRequire("iD7Z3");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");

var $2lSXC = parcelRequire("2lSXC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");
const $35d9e01773d58944$export$e86bc60794f47b8 = ({ pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], periodIndex: periodIndex, value: value, tooltip: tooltip })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
            py: 0.5
        },
        className: `spot-summary-col-${pricePeriod}-${periodIndex}`,
        "data-tooltip": tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: {
                    xs: 18,
                    sm: 26
                },
                bgcolor: value ? 'primary.main' : 'grey.200'
            }
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");

var $iD7Z3 = parcelRequire("iD7Z3");
const $1206c63fb3e45744$export$939a7d371feb5106 = ({ periodIndex: periodIndex, pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], value: value, tooltip: tooltip })=>{
    let bgcolor = 'grey.200';
    if (value === (0, $8ni7a.SpotPriceLevel).Hi) bgcolor = 'error.main';
    else if (value === (0, $8ni7a.SpotPriceLevel).Mid) bgcolor = (0, $iD7Z3.colors).brightOrange;
    else bgcolor = 'success.main';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
            py: 0.5
        },
        className: `spot-summary-col-${pricePeriod}-${periodIndex}`,
        "data-tooltip": tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: {
                    xs: 18,
                    sm: 26
                },
                bgcolor: bgcolor
            }
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");

var $iD7Z3 = parcelRequire("iD7Z3");
const $99c578925c56180f$export$b7ab0af43278a5a4 = ({ periodIndex: periodIndex, pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], value: value, tooltip: tooltip })=>{
    let bgcolor = 'grey.200';
    if (value === (0, $8ni7a.HpLevel).Increase) bgcolor = 'success.main';
    else if (value === (0, $8ni7a.HpLevel).Normal) bgcolor = (0, $iD7Z3.colors).brightOrange;
    else bgcolor = 'error.main';
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4',
            py: 0.5
        },
        className: `spot-summary-col-${pricePeriod}-${periodIndex}`,
        "data-tooltip": tooltip,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: {
                    xs: 18,
                    sm: 26
                },
                bgcolor: bgcolor
            }
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bXANJ = parcelRequire("bXANJ");


var $9Jots = parcelRequire("9Jots");
function $4f67d048ecf287c1$export$adaa4cf7ef1b65be(date, values) {
    let _date = (0, $9Jots.toDate)(date);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $bXANJ.constructFrom)(date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $65e569ba6cad5488$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$4f67d048ecf287c1$export$2e2bcd8739ae039 = $4f67d048ecf287c1$export$adaa4cf7ef1b65be;



var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");
var $4mI0b = parcelRequire("4mI0b");


var $kan35 = parcelRequire("kan35");
var $mjyu0 = parcelRequire("mjyu0");
var $kMGAE = parcelRequire("kMGAE");
var $1dtDd = parcelRequire("1dtDd");

var $iD7Z3 = parcelRequire("iD7Z3");


var $2u93q = parcelRequire("2u93q");


var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $6uJ19 = parcelRequire("6uJ19");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7S0ew = parcelRequire("7S0ew");

var $2zDt6 = parcelRequire("2zDt6");


var $2lSXC = parcelRequire("2lSXC");

var $2PduQ = parcelRequire("2PduQ");
var $cDXfy = parcelRequire("cDXfy");
var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $c8a6748354d71f3f$export$2e2bcd8739ae039 = (0, $42zF9.default)([
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
    }, "0"),
    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
        d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
    }, "1")
], 'KeyboardDoubleArrowRight');



var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $u24M4 = parcelRequire("u24M4");
var $2VxZV = parcelRequire("2VxZV");
var $12gtR = parcelRequire("12gtR");
var $7X4mk = parcelRequire("7X4mk");

var $bd9zl = parcelRequire("bd9zl");
var $202BL = parcelRequire("202BL");

var $5R532 = parcelRequire("5R532");

var $f1q41 = parcelRequire("f1q41");

var $iH29s = parcelRequire("iH29s");

var $bd9zl = parcelRequire("bd9zl");
const $0b8ba5b8bfa54f55$export$defe85febe8b728c = (0, $bd9zl.defineMessages)({
    priceLevelTitle: {
        id: 'spot.summary.price_level',
        defaultMessage: 'Hladina ceny'
    },
    priceLevelHelp: {
        id: 'spot.summary.price_level.help',
        defaultMessage: "Infigy se\u0159ad\xed hodinov\xe9 ceny spotu od nejni\u017E\u0161\xed po nejvy\u0161\u0161\xed a rozd\u011Bl\xed je do t\u0159\xed \u010D\xe1st\xed, p\u0159ibli\u017En\u011B stejn\u011B velk\xfdch. Pokud hodinnov\xe9 ceny za\u010D\xednaj\xed na hodnot\u011B 3 K\u010D a kon\u010D\xed na hodnot\u011B 10 K\u010D, tak n\xedzk\xe1 cena m\u016F\u017Ee m\xedt roztpyl 3-6 K\u010D, st\u0159edn\xed 6-7 K\u010D a vysok\xe1 7-10 K\u010D. Rozptyl bude ka\u017Ed\xfd den jin\xfd, z\xe1le\u017E\xed na \u010Detnosti hodnot v dan\xe9 cenov\xe9 hladin\u011B."
    },
    priceLevel15MTitle: {
        id: 'spot.summary.price_level_15m',
        defaultMessage: 'Hladina ceny 15m'
    },
    spotOverflowTitle: {
        id: 'spot.summary.spotOverflow',
        defaultMessage: "P\u0159etok do s\xedt\u011B"
    },
    spotOverflowHelp: {
        id: 'spot.summary.spotOverflow.help',
        defaultMessage: "Povolen\xed p\u0159etoku do s\xedt\u011B p\u0159i spotov\xe9m obchodov\xe1n\xed porovn\xe1v\xe1 cenu spotu v danou hodinu a pokud je ni\u017E\u0161\xed ne\u017E Cena pro z\xe1kaz p\u0159etok\u016F z nastaven\xed, tak syst\xe9m automaticky v danou hodinu p\u0159etok zak\xe1\u017Ee."
    },
    batteryDischargeTitle: {
        id: 'spot.summary.battery_discharge',
        defaultMessage: "Vyb\xedjen\xed baterie"
    },
    batteryDischargeHelp: {
        id: 'spot.summary.battery_discharge.help',
        defaultMessage: "Vyb\xedjen\xed baterie do objektu na spotu je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Vyb\xedjen\xed baterie se obvykle zakazuje v dob\u011B n\xedzk\xfdch cen, kdy je lep\u0161\xed br\xe1t energii ze s\xedt\u011B a v baterii ji uchovat na dra\u017E\u0161\xed \u010Dasy."
    },
    batteryChargeFromGridTitle: {
        id: 'spot.summary.battery_charge_from_grid',
        defaultMessage: "Nab\xedjen\xed ze s\xedt\u011B"
    },
    batteryChargeFromGridHelp: {
        id: 'spot.summary.battery_charge_from_grid.help',
        defaultMessage: "Nab\xedjen\xed baterie ze s\xedt\u011B dle spotu je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Nab\xedjen\xed baterie syst\xe9m napl\xe1nuje v dob\u011B n\xedzk\xfdch cen a bere v potaz aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie a jej\xed kapacitu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nab\xedjen\xed tak, aby do\u0161lo k jej\xedmu pln\xe9mu nabit\xed za co nejni\u017E\u0161\xed cenu."
    },
    batteryDischargeToGridTitle: {
        id: 'spot.summary.battery_discharge_to_grid',
        defaultMessage: "Vyb\xedjen\xed do s\xedt\u011B"
    },
    batteryDischargeToGridHelp: {
        id: 'spot.summary.battery_discharge_to_grid.help',
        defaultMessage: "Vyb\xedjen\xed baterie do s\xedt\u011B je mo\u017En\xe9 zak\xe1zat \u010Di povolit. Lze tak ud\u011Blat v nastaven\xed. Vyb\xedjen\xed baterie do s\xedt\u011B ur\u010D\xed syst\xe9m v dob\u011B nejvy\u0161\u0161\xed denn\xed ceny a vybije jen tu energii, kter\xe1 nebude pot\u0159eba na b\u011B\u017Enou spot\u0159ebu objektu."
    },
    boilerTitle: {
        id: 'spot.summary.boiler',
        defaultMessage: 'Bojler'
    },
    boilerHelp: {
        id: 'spot.summary.boiler.help',
        defaultMessage: "Nah\u0159\xedv\xe1n\xed bojleru syst\xe9m napl\xe1nuje v dob\u011B n\xedzk\xfdch cen a bere v potaz aktu\xe1ln\xed teplotu vody v bojleru, jeho kapacitu a po\u017Eadovanou teplotu. Na z\xe1klad\u011B t\u011Bchto parametr\u016F zvol\xed d\xe9lku nah\u0159\xedv\xe1n\xed tak, aby do\u0161lo k jeho nah\u0159\xe1t\xed."
    },
    heatPumpTitle: {
        id: 'spot.summary.heat_pump',
        defaultMessage: "Tepeln\xe9 \u010Derpadlo"
    },
    heatPumpHelp: {
        id: 'spot.summary.heat_pump.help',
        defaultMessage: "Tepeln\xe9 \u010Derpadlo m\u016F\u017Ee b\u011B\u017Eet ve t\u0159ech re\u017Eimech: zv\xfd\u0161en\xfd v\xfdkon, b\u011B\u017En\xfd chod a omezen\xfd v\xfdkon. Zv\xfd\u0161en\xfd v\xfdkon se vyu\u017E\xedv\xe1 v dob\u011B n\xedzk\xfdch cen, b\u011B\u017En\xfd chod v dob\u011B st\u0159edn\xedch cen a omezen\xfd v\xfdkon v dob\u011B vysok\xfdch cen. Odlo\u017Een\xed spot\u0159eby \u010Di zv\xfd\u0161en\xed spot\u0159eby lze povolit v menu tepeln\xe9ho \u010Derpadla."
    }
});
const $0b8ba5b8bfa54f55$export$4713da6aa4410043 = (0, $bd9zl.defineMessages)({
    stateActive: {
        id: 'spot.summary.state.active',
        defaultMessage: "Aktivn\xed"
    },
    stateInactive: {
        id: 'spot.summary.state.inactive',
        defaultMessage: "Neaktivn\xed"
    },
    priceBuy: {
        id: 'spot.summary.price_buy',
        defaultMessage: "Cena s distribuc\xed"
    },
    priceSell: {
        id: 'spot.summary.price_sell',
        defaultMessage: 'Cena bez distribuce'
    },
    priceDistribution: {
        id: 'spot.summary.price_distribution',
        defaultMessage: 'Distribuce'
    },
    spotOverflowAllowed: {
        id: 'spot.summary.spotOverflow.allowed',
        defaultMessage: "Povolen\xfd"
    },
    spotOverflowRestricted: {
        id: 'spot.summary.spotOverflow.restricted',
        defaultMessage: "Omezen\xfd"
    },
    priceLevelHi: {
        id: 'spot.summary.price_level.hi',
        defaultMessage: "Vysok\xe1 cena"
    },
    priceLevelMid: {
        id: 'spot.summary.price_level.mid',
        defaultMessage: "St\u0159edn\xed cena"
    },
    priceLevelLow: {
        id: 'spot.summary.price_level.low',
        defaultMessage: "N\xedzk\xe1 cena"
    },
    heatPumpIncrease: {
        id: 'spot.summary.heat_pump_level.increase',
        defaultMessage: "Z\xfd\u0161en\xfd v\xfdkon"
    },
    heatPumpNormal: {
        id: 'spot.summary.heat_pump_level.normal',
        defaultMessage: "B\u011B\u017En\xfd chod"
    },
    heatPumpReduction: {
        id: 'spot.summary.heat_pump_level.reduction',
        defaultMessage: "Omezen\xfd v\xfdkon"
    }
});



var $d06e58c3458bb049$export$4404e626fb92ef2e = /*#__PURE__*/ function(SpotPriceView) {
    SpotPriceView["WithDistribution"] = "with-distribution";
    SpotPriceView["PriceOnly"] = "price-only";
    SpotPriceView["DistributionOnly"] = "distribution-only";
    return SpotPriceView;
}({});
const $d06e58c3458bb049$var$buttonGroupSx = {
    minWidth: {
        xs: '52px !important',
        sm: '60px !important'
    },
    '& svg': {
        xs: {
            fontSize: 18
        }
    }
};
const $d06e58c3458bb049$export$276b2b07e3c8b90b = ()=>{
    const [currentDay, tomorrow] = (0, $2lSXC.useSelector)(({ variables: { SP_HOURS_PRICE_DATE: SP_HOURS_PRICE_DATE } })=>{
        return [
            (0, $b688cddfaeda0d8b$export$ea0a2d2ae29ba628)(SP_HOURS_PRICE_DATE),
            $d06e58c3458bb049$var$getTomorrow()
        ];
    });
    const currentSummary = (0, $2lSXC.useSelector)(({ variables: s })=>{
        return {
            variant: 'today',
            spotPrices: s.SP_HOURS_PRICE,
            spotPrices15M: s.SP_15M_PRICE,
            spotPricesWithDistribution: s.SP_HOURS_PRICE_WITH_DISTRIBUTION,
            spotPrices15MWithDistribution: s.SP_15M_PRICE_WITH_DISTRIBUTION,
            spotPriceLevel: s.SP_PRICE_LEVEL,
            spotPriceLevel15M: s.SP_PRICE_15M_LEVEL,
            batteryDischarge15M: s.SP_BATTERY_DISCHARGE_TABLE_15M,
            batteryDischarge: s.SP_BATTERY_DISCHARGE_TABLE,
            batteryChargeFromGrid: s.SP_BATTERY_GRID_CHARGE_TABLE,
            batteryChargeFromGrid15M: s.SP_BATTERY_GRID_CHARGE_TABLE_15M,
            batteryDischargeToGrid: s.SP_BATTERY_GRID_DISCHARGE_TABLE,
            batteryDischargeToGrid15M: s.SP_BATTERY_GRID_DISCHARGE_TABLE_15M,
            spotOverflow: s.SP_OVERFLOW_TABLE,
            spotOverflow15M: s.SP_OVERFLOW_15M_TABLE,
            morningOverflow: s.SP_MORNING_OVERFLOW_TABLE,
            morningOverflow15M: s.SP_MORNING_OVERFLOW_15M_TABLE,
            hwHeatingFromGrid: s.SP_HW_GRID_HEAT_TABLE,
            hwHeatingFromGrid15M: s.SP_HW_GRID_HEAT_TABLE_15M,
            heatPumpLevel: s.SP_HP_TABLE,
            batteryChargeFromGridEnabled: s.SP_BATTERY_CONTROL_CUSTOMER,
            batteryDischargeToGridEnabled: s.SP_DISCHARGE_TO_GRID,
            batteryControl: s.PV_BATTERY_CONTROL,
            hwInstalled: s.HW_INSTALL,
            hpInstalled: s.HP_ENABLED
        };
    }, (0, $f1q41.isEqual));
    const tomorrowSummary = (0, $2lSXC.useSelector)(({ variables: s })=>{
        const tomorrow = $d06e58c3458bb049$var$getTomorrow();
        const summaryAvailable = s.SP_HOURS_PRICE_TOMORROW_DATE === tomorrow && s.SP_15M_PRICE_TOMORROW_DATE === tomorrow;
        if (!summaryAvailable) return;
        return {
            variant: 'tomorrow',
            spotPrices: s.SP_HOURS_PRICE_TOMORROW,
            spotPrices15M: s.SP_15M_PRICE_TOMORROW,
            spotPricesWithDistribution: s.SP_HOURS_PRICE_WITH_DISTRIBUTION_TOMORROW,
            spotPrices15MWithDistribution: s.SP_15M_PRICE_WITH_DISTRIBUTION_TOMORROW
        };
    });
    const intl = (0, $202BL.default)();
    const [date, setDate] = (0, $acw62.useState)(()=>currentDay);
    const [priceView, setPriceView] = (0, $dd520a295c128d09$export$86e2cef2561044ac)((0, $2zDt6.z).nativeEnum($d06e58c3458bb049$export$4404e626fb92ef2e), 'spotPriceView', "with-distribution");
    const dateIsToday = date === currentDay;
    const dateIsTomorrow = date === tomorrow;
    const onPrev = ()=>{
        setDate((0, $b688cddfaeda0d8b$export$1b417f4da593d319)((0, $7S0ew.addDays)((0, $b688cddfaeda0d8b$export$52508f29c3afdd33)(date), -1)));
    };
    const onNext = ()=>{
        if (dateIsToday) return setDate(tomorrow);
        setDate((0, $b688cddfaeda0d8b$export$1b417f4da593d319)((0, $7S0ew.addDays)((0, $b688cddfaeda0d8b$export$52508f29c3afdd33)(date), 1)));
    };
    const nextEnabled = date < currentDay || tomorrowSummary && dateIsToday;
    const getSummary = (0, $iH29s.trpc).spot.getSummary.useQuery({
        date: date
    });
    const { data: data, isLoading: isLoading, isError: isError } = dateIsToday ? {
        data: currentSummary,
        isLoading: false,
        isError: false
    } : dateIsTomorrow ? {
        data: tomorrowSummary,
        isLoading: false,
        isError: false
    } : {
        data: getSummary.data?.summary ? {
            variant: 'historical',
            ...getSummary.data.summary
        } : undefined,
        isLoading: getSummary.isLoading,
        isError: getSummary.isError
    };
    return {
        row: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
            sx: {
                px: 1
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    sx: {
                        '& svg': {
                            fontSize: 26
                        }
                    },
                    disabled: !getSummary.data?.prevSummary,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2PduQ.default), {
                        onClick: onPrev
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        mx: 0.5
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                        value: date
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    sx: {
                        '& svg': {
                            fontSize: 26
                        }
                    },
                    disabled: !nextEnabled,
                    onClick: onNext,
                    children: (dateIsToday || dateIsTomorrow) && nextEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c8a6748354d71f3f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDXfy.default), {})
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ml: 'auto'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5f8f3fc94b629807$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: intl.formatMessage((0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceBuy),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: ()=>setPriceView("with-distribution"),
                                    variant: priceView === "with-distribution" ? 'contained' : 'outlined',
                                    sx: {
                                        px: 0,
                                        ...$d06e58c3458bb049$var$buttonGroupSx
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                        sx: {
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($d06e58c3458bb049$export$c0b625f57a647728, {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($d06e58c3458bb049$export$891c98057d1a9092, {})
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: intl.formatMessage((0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceSell),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: ()=>setPriceView("price-only"),
                                    variant: priceView === "price-only" ? 'contained' : 'outlined',
                                    sx: $d06e58c3458bb049$var$buttonGroupSx,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($d06e58c3458bb049$export$c0b625f57a647728, {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                                title: intl.formatMessage((0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceDistribution),
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                    onClick: ()=>setPriceView("distribution-only"),
                                    variant: priceView === "distribution-only" ? 'contained' : 'outlined',
                                    sx: $d06e58c3458bb049$var$buttonGroupSx,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($d06e58c3458bb049$export$891c98057d1a9092, {})
                                })
                            })
                        ]
                    })
                })
            ]
        }),
        summary: data,
        summaryLoading: isLoading,
        summaryError: isError,
        priceView: priceView
    };
};
function $d06e58c3458bb049$var$getTomorrow() {
    return (0, $b688cddfaeda0d8b$export$1b417f4da593d319)((0, $7S0ew.addDays)(new Date(), 1));
}
const $d06e58c3458bb049$export$c0b625f57a647728 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 18 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M15.6152 9.93855H12.6997V2.34597C12.6997 0.736344 12.0315 0.235234 11.6367 0.0833823C11.2419 -0.0684693 10.4067 -0.144395 9.34377 1.07042L0.718603 10.88C-0.192506 11.9278 -0.0406548 12.7022 0.126382 13.0819C0.293419 13.4463 0.779343 14.0689 2.16119 14.0689H5.07674V21.6615C5.07674 23.2711 5.74489 23.7722 6.1397 23.9241C6.26118 23.9696 6.41304 24 6.59526 24C7.05081 24 7.6734 23.7874 8.43266 22.9219L17.0578 13.1274C17.9689 12.0948 17.8323 11.3052 17.6652 10.9408C17.4982 10.5611 17.0123 9.93855 15.6152 9.93855ZM16.1467 12.3378L7.52155 22.1322C7.02044 22.7093 6.656 22.8307 6.56489 22.7852C6.47378 22.7548 6.27637 22.4359 6.27637 21.6615V13.4615C6.27637 13.1274 6.00304 12.8541 5.66896 12.8541H2.17638C1.61453 12.8541 1.31082 12.7174 1.25008 12.5656C1.18934 12.4289 1.28045 12.0948 1.6449 11.6697L10.2549 1.87523C10.7104 1.35894 11.0445 1.20708 11.166 1.20708C11.1812 1.20708 11.1964 1.20708 11.1964 1.20708C11.2875 1.23745 11.4849 1.55634 11.4849 2.33078V10.546C11.4849 10.88 11.7582 11.1534 12.0923 11.1534H15.6152C16.1771 11.1534 16.496 11.3052 16.5567 11.4419C16.6175 11.5785 16.5263 11.9126 16.1467 12.3378Z",
            fill: "currentColor"
        })
    });
const $d06e58c3458bb049$export$891c98057d1a9092 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 20 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.1209 23.6443C12.2347 23.9004 12.505 24.0427 12.7753 23.9715C13.0456 23.9004 13.2306 23.6586 13.2021 23.374L12.4055 11.8933H14.9093V12.8322C14.9093 13.1452 15.1654 13.4013 15.4784 13.4013C15.7913 13.4013 16.0474 13.1452 16.0474 12.8322V11.8933H18.0676V12.8322C18.0676 13.1452 18.3236 13.4013 18.6366 13.4013C18.9496 13.4013 19.2057 13.1452 19.2057 12.8322V11.3242C19.2057 11.182 19.1488 11.0682 19.0776 10.9686C19.0776 10.9686 19.0776 10.9544 19.0776 10.9401L16.5596 8.08062C16.4458 7.95258 16.2893 7.88145 16.1328 7.88145H12.1494L11.8506 3.58506H14.1126V4.32484C14.1126 4.63782 14.3687 4.89389 14.6817 4.89389C14.9947 4.89389 15.2507 4.63782 15.2507 4.32484V3.58506H16.8441V4.32484C16.8441 4.63782 17.1002 4.89389 17.4132 4.89389C17.7261 4.89389 17.9822 4.63782 17.9822 4.32484V3.016C17.9822 2.87374 17.9253 2.75993 17.8542 2.66034C17.8542 2.66034 17.8542 2.64612 17.8542 2.63189L15.6491 0.19917C15.5353 0.0711322 15.3788 0 15.2223 0H3.9265C3.77001 0 3.61351 0.0711322 3.4997 0.19917L1.32306 2.66034C1.32306 2.66034 1.32306 2.67457 1.32306 2.6888C1.2377 2.78838 1.19502 2.90219 1.19502 3.04446V4.35329C1.19502 4.66627 1.4511 4.92235 1.76408 4.92235C2.07706 4.92235 2.33314 4.66627 2.33314 4.35329V3.61351H4.12567V4.35329C4.12567 4.66627 4.38174 4.92235 4.69472 4.92235C5.00771 4.92235 5.26378 4.35329 5.26378 4.35329V3.61351H7.32661L7.02786 7.9099H3.07291C2.91642 7.9099 2.75993 7.98103 2.64612 8.10907L0.128038 10.9544C0.128038 10.9544 0.128038 10.9686 0.128038 10.9828C0.0426793 11.0824 0 11.1962 0 11.3385V12.8465C0 13.1595 0.256076 13.4155 0.569057 13.4155C0.882039 13.4155 1.13811 13.1595 1.13811 12.8465V11.9075H3.38589V12.8465C3.38589 13.1595 3.64197 13.4155 3.95495 13.4155C4.26793 13.4155 4.52401 13.1595 4.52401 12.8465V11.9075H6.74333L5.94665 23.3883C5.93242 23.6586 6.10314 23.9146 6.37344 23.9858C6.41612 23.9858 6.4588 24 6.51571 24C6.74333 24 6.9425 23.872 7.04209 23.6586L9.58862 17.84L12.1351 23.6586L12.1209 23.6443ZM10.2004 16.4173L11.3954 13.6858L11.8506 20.1873L10.2004 16.4173ZM8.08061 9.04801H11.0682L11.182 10.7694H7.95258L8.06639 9.04801H8.08061ZM15.8625 9.04801L17.3705 10.7694H12.3201L12.2063 9.04801H15.8625ZM4.18257 1.13811H14.952L16.1328 2.4754H3.00178L4.18257 1.13811ZM8.4505 3.61351H10.6841L10.9828 7.9099H8.15175L8.4505 3.61351ZM3.32899 9.04801H6.92827L6.81446 10.7694H1.82098L3.34321 9.04801H3.32899ZM10.9259 11.9075L9.57439 14.9947L8.22288 11.9075H10.9259ZM7.29816 20.1873L7.75341 13.6858L8.94843 16.4173L7.29816 20.1873Z",
            fill: "currentColor"
        })
    });


// Pick the single value the chart draws for a period, given the active view.
const $0cfa4675ff04c83e$var$resolveValue = (priceView, price, withDistribution)=>{
    if (priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).PriceOnly) return price;
    if (priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).DistributionOnly) return withDistribution - price;
    return withDistribution;
};
// Domain for the price views; default (zero-based) domain for the distribution
// view so its small, flat values aren't exaggerated. For the price views we
// anchor the baseline at 0 whenever every value is positive — a tight dataMin
// baseline would exaggerate the differences and hide that prices sit well above
// zero — and fall back to dataMin only when there are negative prices.
const $0cfa4675ff04c83e$var$getYDomain = (priceView, chartData)=>{
    if (priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).DistributionOnly) return undefined;
    const min = Math.min(...chartData?.map((d)=>d.value) ?? [
        0
    ]);
    return [
        min > 0 ? 0 : 'dataMin',
        'dataMax'
    ];
};
const $0cfa4675ff04c83e$export$5ceb7ad2e8b0bb65 = ({ summary: summary, summaryLoading: isLoading, summaryError: isError, priceView: priceView, sx: sx = {}, hideAxisX: hideAxisX = false })=>{
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('sm'));
    const pricePeriod = (0, $2lSXC.useSelector)(({ variables: { SP_PRICE_PERIOD: SP_PRICE_PERIOD } })=>SP_PRICE_PERIOD);
    const is15M = pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'];
    const basePrices = is15M ? summary?.spotPrices15M : summary?.spotPrices;
    const distributionPrices = is15M ? summary?.spotPrices15MWithDistribution : summary?.spotPricesWithDistribution;
    // Single bar per period: the value depends on the active price view (bare
    // spot price, distribution surcharge alone, or their sum).
    const chartData = basePrices?.map((price, period)=>{
        const at = is15M ? (0, $4f67d048ecf287c1$export$adaa4cf7ef1b65be)(new Date(), {
            hours: Math.floor(period / 4),
            minutes: 0 + period % 4 * 15
        }) : (0, $4f67d048ecf287c1$export$adaa4cf7ef1b65be)(new Date(), {
            hours: period,
            minutes: 0
        });
        const withDistribution = distributionPrices?.[period] ?? price;
        return {
            at: (0, $4d82c4193dc87874$export$d9468344d3651243)(at, 'HH:mm'),
            value: $0cfa4675ff04c83e$var$resolveValue(priceView, price, withDistribution)
        };
    });
    // The distribution surcharge is small and roughly flat; the dataMin–dataMax
    // domain would exaggerate its tiny variations, so fall back to the default
    // (zero-based) domain for that view.
    const yDomain = $0cfa4675ff04c83e$var$getYDomain(priceView, chartData);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            p: 0,
            pt: 1,
            width: '100%',
            ...sx
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                pt: 1,
                pb: 2,
                px: 2,
                height: {
                    xs: 200,
                    sm: 340
                },
                width: '100%',
                position: 'relative'
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $mjyu0.ResponsiveContainer), {
                    width: "100%",
                    height: "100%",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
                        data: chartData,
                        barCategoryGap: pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? 0 : sm ? 4 : 1,
                        barGap: pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? 0 : sm ? 4 : 1,
                        margin: {
                            left: 0,
                            right: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kan35.CartesianGrid), {
                                strokeWidth: 0.25,
                                stroke: (0, $iD7Z3.colors).darkBlue,
                                strokeOpacity: 0.4,
                                vertical: false
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMGAE.XAxis), {
                                dataKey: "at",
                                style: {
                                    fontFamily: $2u93q.fontFamily,
                                    color: (0, $iD7Z3.colors).darkBlue,
                                    top: 20,
                                    transform: 'translateY(8px)'
                                },
                                axisLine: false,
                                tickLine: false,
                                hide: hideAxisX
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                                hide: true,
                                domain: yDomain
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                                dataKey: "value",
                                fill: (0, $iD7Z3.colors).primary
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: isLoading || isError ? 'flex' : 'none',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    children: [
                        isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
                            size: 22,
                            sx: {
                                animationDuration: '850ms',
                                display: 'block'
                            }
                        }),
                        isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0885121e8393a5b8$export$2e2bcd8739ae039), {
                            sx: {
                                fontSize: 22,
                                color: 'warning.main'
                            }
                        })
                    ]
                })
            ]
        })
    });
};
const $0cfa4675ff04c83e$export$7d7b01fecaadfe39 = ({ summary: summary, priceView: priceView })=>{
    const pricePeriod = (0, $2lSXC.useSelector)(({ variables: { SP_PRICE_PERIOD: SP_PRICE_PERIOD } })=>SP_PRICE_PERIOD);
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    // recharts is plain SVG, so resolve the active scheme to color the labels.
    const { mode: mode, systemMode: systemMode } = (0, $cfa43f235c6b12b8$export$6343629ee1b29116)();
    const isDark = (mode === 'system' ? systemMode : mode) === 'dark';
    const axisColor = isDark ? (0, $iD7Z3.colors).white : (0, $iD7Z3.colors).darkBlue;
    // Mirror the main chart's stacked data so the axis domain stays in sync.
    const is15M = pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'];
    const basePrices = is15M ? summary?.spotPrices15M : summary?.spotPrices;
    const distributionPrices = is15M ? summary?.spotPrices15MWithDistribution : summary?.spotPricesWithDistribution;
    const chartData = basePrices?.map((price, period)=>{
        const at = is15M ? (0, $4f67d048ecf287c1$export$adaa4cf7ef1b65be)(new Date(), {
            hours: Math.floor(period / 4),
            minutes: 0 + period % 4 * 15
        }) : (0, $4f67d048ecf287c1$export$adaa4cf7ef1b65be)(new Date(), {
            hours: period,
            minutes: 0
        });
        const withDistribution = distributionPrices?.[period] ?? price;
        return {
            at: (0, $4d82c4193dc87874$export$d9468344d3651243)(at, 'HH:mm'),
            value: $0cfa4675ff04c83e$var$resolveValue(priceView, price, withDistribution)
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $74d07378047db57c$export$94aefc399ef206a9), {
        data: chartData,
        barCategoryGap: 0,
        barGap: 0,
        margin: {
            left: 0,
            right: 0
        },
        width: 70,
        height: 340,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMGAE.XAxis), {
                dataKey: "at",
                hide: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                domain: $0cfa4675ff04c83e$var$getYDomain(priceView, chartData),
                style: {
                    fontFamily: $2u93q.fontFamily,
                    color: axisColor
                },
                axisLine: false,
                tickLine: false,
                tickFormatter: (value)=>formatNumber((0, $f1q41.round)(value, 1), {
                        style: 'currency',
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                    }),
                width: 70,
                mirror: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e752e700473a8894$export$bbc6c6369b38e3d1), {
                dataKey: "value",
                fill: "transparent"
            })
        ]
    });
};




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $5R532 = parcelRequire("5R532");

var $aZOrF = parcelRequire("aZOrF");
const $37da3e5d4f8ebfec$export$e27cefcb2a3f030e = {
    gridColumn: {
        xs: 'span 96',
        lg: 'auto'
    },
    fontSize: {
        xs: 12,
        lg: 14
    },
    lineHeight: {
        xs: '12px',
        lg: '24px'
    },
    mt: {
        xs: 0.75,
        lg: 0
    },
    mb: {
        xs: 0.25,
        lg: 0
    },
    pr: {
        xs: 0,
        lg: 1
    },
    width: 'auto'
};
// CSS-only tooltip: any element carrying a `data-tooltip` attribute shows a
// bubble (time on the first line, price on the second) above it on hover. The
// text comes from the attribute via `content: attr(...)`, so no JS is involved.
// Match the look of the old chart <CustomTooltip>: dark blue-grey bubble,
// white text, rounded corners.
const $37da3e5d4f8ebfec$var$tooltipBg = (theme)=>theme.palette.mode === 'light' ? theme.palette.text.disabled : '#343e42';
const $37da3e5d4f8ebfec$export$ff7df17f378838ad = {
    '& [data-tooltip]': {
        position: 'relative'
    },
    '& [data-tooltip]:hover::after': {
        content: 'attr(data-tooltip)',
        position: 'absolute',
        left: '50%',
        bottom: 'calc(100% + 8px)',
        // Slide the bubble horizontally by its own width as we move across the grid:
        // 0% at the left edge (left edge of bubble sits at the bar), 100% at the
        // right edge (right edge at the bar), 50% in the middle. `--tip-shift` is set
        // per column below, so edge tooltips never overflow the page. The arrow
        // (::before) stays centered on the bar regardless.
        transform: 'translateX(calc(-1 * var(--tip-shift, 50%)))',
        px: {
            xs: 1.5,
            md: 2
        },
        py: 1,
        borderRadius: 2,
        backgroundColor: $37da3e5d4f8ebfec$var$tooltipBg,
        color: 'common.white',
        fontSize: 12,
        fontWeight: 600,
        lineHeight: 1.35,
        textAlign: 'center',
        whiteSpace: 'pre',
        zIndex: 30,
        pointerEvents: 'none'
    },
    '& [data-tooltip]:hover::before': {
        content: '""',
        position: 'absolute',
        left: '50%',
        bottom: 'calc(100% + 3px)',
        transform: 'translateX(-50%)',
        borderWidth: '5px',
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderTopColor: $37da3e5d4f8ebfec$var$tooltipBg,
        zIndex: 30,
        pointerEvents: 'none'
    },
    // Chart columns are full-chart-height boxes, so anchoring the bubble above
    // them floats it far above the bar. Center it vertically inside the column
    // instead (the same `--tip-shift` still slides it horizontally), and drop the
    // downward arrow since there's no longer an element edge for it to point at.
    '& .chart-overlay [data-tooltip]:hover::after': {
        top: '50%',
        bottom: 'auto',
        transform: 'translate(calc(-1 * var(--tip-shift, 50%)), -50%)'
    },
    '& .chart-overlay [data-tooltip]:hover::before': {
        display: 'none'
    }
};
const $37da3e5d4f8ebfec$export$dab0b67e727e6da3 = {};
const $37da3e5d4f8ebfec$export$a53b6aa9338b8182 = {};
const $37da3e5d4f8ebfec$export$9ebb9a0788a2c89e = {};
const $37da3e5d4f8ebfec$var$addTipShifts = (period, count)=>{
    for(let i = 0; i < count; i++)$37da3e5d4f8ebfec$export$9ebb9a0788a2c89e[`& .spot-summary-col-${period}-${i}`] = {
        '--tip-shift': `${i / (count - 1) * 100}%`
    };
};
$37da3e5d4f8ebfec$var$addTipShifts('60M', 24);
$37da3e5d4f8ebfec$var$addTipShifts('15M', 96);
const $37da3e5d4f8ebfec$var$lightDataRows = (trigger, targets)=>{
    $37da3e5d4f8ebfec$export$dab0b67e727e6da3[`&:has(${trigger}:hover) ${targets}`] = {
        opacity: 1
    };
};
// keep the matching chart bar(s) clear (no white veil) while hovered. The veil
// uses background-color (not opacity) so the bars stay at opacity 1 and their
// `data-tooltip` bubbles remain visible even on the revealed/hovered bar.
const $37da3e5d4f8ebfec$var$clearChartBars = (trigger, targets)=>{
    $37da3e5d4f8ebfec$export$a53b6aa9338b8182[`&:has(${trigger}:hover) .chart-overlay ${targets}`] = {
        backgroundColor: 'transparent !important'
    };
};
// 60M trigger: hovering an hour cell (or, in 60M mode, an hour-wide chart bar)
// highlights that hour's 60M cells plus all four 15M bars within the hour.
for(let h = 0; h < 24; h++){
    const trigger = `.spot-summary-col-60M-${h}`;
    const hourTargets = `:is(.spot-summary-col-60M-${h}, .spot-summary-col-15M-${h * 4}, .spot-summary-col-15M-${h * 4 + 1}, .spot-summary-col-15M-${h * 4 + 2}, .spot-summary-col-15M-${h * 4 + 3})`;
    $37da3e5d4f8ebfec$var$lightDataRows(trigger, hourTargets);
    $37da3e5d4f8ebfec$var$clearChartBars(trigger, hourTargets);
}
// 15M trigger: hovering a single 15M bar highlights only that bar and its hour's
// 60M cells (the nearest 60M label/level) — never the sibling 15M bars.
for(let j = 0; j < 96; j++){
    const trigger = `.spot-summary-col-15M-${j}`;
    const segTargets = `:is(.spot-summary-col-15M-${j}, .spot-summary-col-60M-${Math.floor(j / 4)})`;
    $37da3e5d4f8ebfec$var$lightDataRows(trigger, segTargets);
    $37da3e5d4f8ebfec$var$clearChartBars(trigger, segTargets);
}


function $a973e650c965c62f$export$3c5fbebd466f3335({ title: title, help: help, data: data, pricePeriod: pricePeriod, Cell: Cell, getTooltip: getTooltip }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                sx: (0, $37da3e5d4f8ebfec$export$e27cefcb2a3f030e),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        ...title
                    }),
                    help && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                        variant: "dialog",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            ...title
                        }),
                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            ...help
                        })
                    })
                ]
            }),
            data.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)(Cell, {
                    value: value,
                    periodIndex: i,
                    pricePeriod: pricePeriod,
                    tooltip: getTooltip(i, pricePeriod)
                }, i))
        ]
    });
}





const $d0a96727fb5b163e$var$summaryHead = Array.from({
    length: 24
}, (_, i)=>i + 1);
// The dark Paper renders at `elevation1`, which composites a ~5% white overlay
// over `darkColors.paper`. `lighten(color, 0.05)` reproduces that exact surface
// color — the value the inactive-column veil must match to stay invisible over
// the empty space above each bar.
const $d0a96727fb5b163e$var$darkPaperElevated = (0, $aSEG4.lighten)((0, $iD7Z3.darkColors).paper, 0.05);
const $d0a96727fb5b163e$var$getFeatures = (summary, hes)=>{
    const { spotOverflow: spotOverflow60M, spotOverflow15M: spotOverflow15M, batteryDischarge: batteryDischarge, batteryDischarge15M: batteryDischarge15M, batteryChargeFromGrid: batteryChargeFromGrid, batteryChargeFromGrid15M: batteryChargeFromGrid15M, batteryDischargeToGrid: batteryDischargeToGrid, batteryDischargeToGrid15M: batteryDischargeToGrid15M, hwHeatingFromGrid: hwHeatingFromGrid60M, hwHeatingFromGrid15M: hwHeatingFromGrid15M, heatPumpLevel: heatPumpLevel, batteryChargeFromGridEnabled: batteryChargeFromGridEnabled, batteryDischargeToGridEnabled: batteryDischargeToGridEnabled, batteryControl: batteryControl, hwInstalled: hwInstalled, hpInstalled: hpInstalled } = summary;
    return [
        {
            kind: 'bool',
            visible: !hes,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).spotOverflowTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).spotOverflowHelp,
            data60M: spotOverflow60M,
            data15M: spotOverflow15M,
            trueLabel: (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).spotOverflowAllowed,
            falseLabel: (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).spotOverflowRestricted
        },
        {
            kind: 'bool',
            visible: batteryControl,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryDischargeTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryDischargeHelp,
            data60M: batteryDischarge,
            data15M: batteryDischarge15M
        },
        {
            kind: 'bool',
            visible: batteryChargeFromGridEnabled && batteryControl,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryChargeFromGridTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryChargeFromGridHelp,
            data60M: batteryChargeFromGrid,
            data15M: batteryChargeFromGrid15M
        },
        {
            kind: 'bool',
            visible: batteryDischargeToGridEnabled && batteryControl,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryDischargeToGridTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).batteryDischargeToGridHelp,
            data60M: batteryDischargeToGrid,
            data15M: batteryDischargeToGrid15M
        },
        {
            kind: 'bool',
            visible: hwInstalled,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).boilerTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).boilerHelp,
            data60M: hwHeatingFromGrid60M,
            data15M: hwHeatingFromGrid15M
        },
        {
            kind: 'hpLevel',
            visible: hpInstalled,
            title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).heatPumpTitle,
            help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).heatPumpHelp,
            data60M: heatPumpLevel
        }
    ];
};
const $d0a96727fb5b163e$export$d7b595bc0b9de700 = ({ summary: summary, summaryLoading: summaryLoading, summaryError: summaryError, priceView: priceView })=>{
    const theme = (0, $b7Ol4.default)();
    const lg = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('lg'));
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const intl = (0, $202BL.default)();
    const hes = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        return inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Hes;
    });
    const spotPricePeriod = (0, $2lSXC.useSelector)(({ variables: { SP_PRICE_PERIOD: SP_PRICE_PERIOD } })=>SP_PRICE_PERIOD);
    const currency = (0, $2lSXC.useSelector)((s)=>s.variables.CURRENCY);
    // Tomorrow's data only carries prices — none of the feature/component arrays
    // (price levels, battery, heat pump, …). In that case we render a slim
    // variant: chart, time and prices only, skipping every component row.
    const isTomorrow = summary?.variant === 'tomorrow';
    // Precompute every column's aggregate tooltip once — 24 hourly + 96
    // quarter-hour slots. The global store re-renders this component frequently;
    // memoizing keeps the costly intl/number formatting from running on every
    // render and only recomputes when the underlying data actually changes.
    const tooltipsByPeriod = (0, $acw62.useMemo)(()=>{
        const empty = {
            [(0, $6uJ19.SpotPricePeriod)['60M']]: [],
            [(0, $6uJ19.SpotPricePeriod)['15M']]: []
        };
        if (!summary) return empty;
        // Narrow away the tomorrow variant, which carries no feature/level data.
        const detail = summary.variant === 'tomorrow' ? undefined : summary;
        const spotPriceLevel = detail?.spotPriceLevel;
        const spotPriceLevel15M = detail?.spotPriceLevel15M;
        const prices = summary.spotPricesWithDistribution;
        const prices15M = summary.spotPrices15MWithDistribution;
        const basePrices = summary.spotPrices;
        const basePrices15M = summary.spotPrices15M;
        // Resolve every constant label/state string once for the whole grid.
        const priceBuyLabel = intl.formatMessage((0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceBuy);
        const priceSellLabel = intl.formatMessage((0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceSell);
        const priceLevelLabel = intl.formatMessage((0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).priceLevelTitle);
        const levelText = (lvl)=>intl.formatMessage(lvl === (0, $8ni7a.SpotPriceLevel).Hi ? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceLevelHi : lvl === (0, $8ni7a.SpotPriceLevel).Mid ? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceLevelMid : (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).priceLevelLow);
        const hpText = (hp)=>intl.formatMessage(hp === (0, $8ni7a.HpLevel).Increase ? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).heatPumpIncrease : hp === (0, $8ni7a.HpLevel).Normal ? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).heatPumpNormal : (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).heatPumpReduction);
        const features = detail ? $d0a96727fb5b163e$var$getFeatures(detail, hes).filter((f)=>f.visible) : [];
        // Resolve each feature's title and (for booleans) its on/off status text
        // once — a feature may override the generic Active/Inactive wording.
        const resolved = features.map((f)=>({
                label: intl.formatMessage(f.title),
                on: f.kind === 'bool' ? intl.formatMessage(f.trueLabel ?? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).stateActive) : '',
                off: f.kind === 'bool' ? intl.formatMessage(f.falseLabel ?? (0, $0b8ba5b8bfa54f55$export$4713da6aa4410043).stateInactive) : ''
            }));
        const build = (periodIndex, is15M)=>{
            const hour = is15M ? Math.floor(periodIndex / 4) : periodIndex;
            const minute = is15M ? periodIndex % 4 * 15 : 0;
            const time = `${hour}:${String(minute).padStart(2, '0')}`;
            const fmt = (v)=>formatNumber(v, {
                    style: 'currency',
                    fractionDigitsOffset: 1
                });
            // Buy price = spot price + distribution; sell price = bare spot price.
            const buy = (is15M ? prices15M : prices)?.[periodIndex];
            const sell = (is15M ? basePrices15M : basePrices)?.[periodIndex];
            // Header: time on the first line, the price for the active view toggle
            // (bare spot price, distribution surcharge alone, or their sum) on the
            // second, followed by a divider before the detail lines below.
            const headerPrice = priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).PriceOnly ? sell : priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).DistributionOnly ? buy != null && sell != null ? buy - sell : undefined : buy;
            // Short tooltip (chart bars): just the hour and the active-view price.
            const short = headerPrice != null ? `${time}\n${fmt(headerPrice)}` : time;
            const lines = [
                time
            ];
            if (headerPrice != null) lines.push(fmt(headerPrice));
            lines.push("\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500");
            if (buy != null) lines.push(`${priceBuyLabel}: ${fmt(buy)}`);
            if (sell != null) lines.push(`${priceSellLabel}: ${fmt(sell)}`);
            // 15M-granular features read the 15M array at the slot; a feature without
            // a 15M array (e.g. heat pump) falls back to its hourly value.
            const at = (d60, d15)=>is15M ? d15 ? d15[periodIndex] : d60[hour] : d60[periodIndex];
            const priceLevel = is15M ? spotPriceLevel15M?.[periodIndex] : spotPriceLevel?.[hour];
            if (priceLevel != null) lines.push(`${priceLevelLabel}: ${levelText(priceLevel)}`);
            features.forEach((f, fi)=>{
                const r = resolved[fi];
                if (f.kind === 'bool') {
                    const value = at(f.data60M, f.data15M);
                    if (value != null) lines.push(`${r.label}: ${value ? r.on : r.off}`);
                } else {
                    const value = at(f.data60M);
                    if (value != null) lines.push(`${r.label}: ${hpText(value)}`);
                }
            });
            return {
                full: lines.join('\n'),
                short: short
            };
        };
        return {
            [(0, $6uJ19.SpotPricePeriod)['60M']]: Array.from({
                length: 24
            }, (_, i)=>build(i, false)),
            [(0, $6uJ19.SpotPricePeriod)['15M']]: Array.from({
                length: 96
            }, (_, i)=>build(i, true))
        };
    // formatNumber is intentionally excluded from the deps: its identity changes
    // every render, but its output only depends on `intl` + `currency` below.
    }, [
        summary,
        hes,
        intl,
        currency,
        isTomorrow,
        priceView
    ]);
    if (!summary) return null;
    // Narrow away the tomorrow variant, which carries no feature/level data.
    const detail = summary.variant === 'tomorrow' ? undefined : summary;
    const spotPriceLevel = detail?.spotPriceLevel;
    const spotPriceLevel15M = detail?.spotPriceLevel15M;
    // The price row shows whichever value the user picked in the view toggle:
    // bare spot price, distribution surcharge alone, or their sum.
    const prices = summary.spotPrices.map((base, i)=>{
        const withDistribution = summary.spotPricesWithDistribution[i] ?? base;
        if (priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).PriceOnly) return base;
        if (priceView === (0, $d06e58c3458bb049$export$4404e626fb92ef2e).DistributionOnly) return withDistribution - base;
        return withDistribution;
    });
    // Cheap lookup into the memoized tooltips (built above). The summary cells
    // (time/price/feature rows) show the full tooltip; the chart bars pass
    // 'short' to show just the hour and price.
    const getTooltip = (periodIndex, pricePeriod, variant = 'full')=>tooltipsByPeriod[pricePeriod]?.[periodIndex]?.[variant] ?? '';
    // The time/price rows render fewer labels on small screens (cells need width
    // for the text), and the visible labels are spread evenly across the row. So
    // each label visually sits above an equal slice of bars regardless of its
    // hour value. Give every label the hover classes of the bars under it, so
    // hovering any bar highlights the label positioned above it. Time and price
    // share this visibility predicate (time cell i => hour i-1, price cell i => hour i).
    const isLabelVisible = (hour)=>!(!lg && (hour + 1) % 2 === 0 || !sm && (hour + 1) % 3 === 0);
    const labelCoverageClass = {};
    {
        const visibleHours = Array.from({
            length: 24
        }, (_, h)=>h).filter(isLabelVisible);
        const coveredBars = {};
        visibleHours.forEach((hour)=>coveredBars[hour] = []);
        for(let bar = 0; bar < 24; bar++){
            const cell = Math.floor(bar * visibleHours.length / 24);
            coveredBars[visibleHours[cell]].push(bar);
        }
        visibleHours.forEach((hour)=>{
            labelCoverageClass[hour] = coveredBars[hour].map((bar)=>`spot-summary-col-60M-${bar}`).join(' ');
        });
    }
    const is15M = spotPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'];
    const features = detail ? $d0a96727fb5b163e$var$getFeatures(detail, hes) : [];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'repeat(96, 1fr)',
                    lg: 'auto repeat(96, 1fr)'
                },
                '& [class*="spot-summary-col-"]': {
                    // transition: 'opacity 0.15s',
                    opacity: 1
                },
                '&:has([class*="spot-summary-col-"]:hover) [class*="spot-summary-col-"]': {
                    opacity: 0.3
                },
                ...(0, $37da3e5d4f8ebfec$export$dab0b67e727e6da3),
                '& [class*="spot-summary-col-"]:hover': {
                    opacity: '1 !important'
                },
                // chart overlay: kept at full opacity (so the data-tooltip bubbles
                // show) with a transparent background, so the bars show through.
                '& .chart-overlay [class*="spot-summary-col-"]': {
                    opacity: '1 !important',
                    backgroundColor: 'transparent'
                },
                // hovering any column (chart bar OR data cell) veils every bar with the
                // Paper background color (white in light mode, dark grey in dark mode)
                // so the bars fade toward the background rather than getting washed out.
                '&:has([class*="spot-summary-col-"]:hover) .chart-overlay [class*="spot-summary-col-"]': {
                    backgroundColor: `${(0, $aSEG4.alpha)(theme.palette.background.paper, 0.55)} !important`,
                    ...theme.applyStyles('dark', {
                        // `darkColors.paper` (#2c2c2c) lifted by MUI's elevation1
                        // overlay (white ~5%) = the *actual* rendered Paper surface.
                        // Keying the veil to this (not the raw color) keeps it invisible
                        // over the empty space above each bar while still dimming bars.
                        backgroundColor: `${(0, $aSEG4.alpha)($d0a96727fb5b163e$var$darkPaperElevated, 0.55)} !important`
                    })
                },
                // ...except the bar for the hovered column, which stays clear
                ...(0, $37da3e5d4f8ebfec$export$a53b6aa9338b8182),
                ...(0, $37da3e5d4f8ebfec$export$9ebb9a0788a2c89e),
                ...(0, $37da3e5d4f8ebfec$export$ff7df17f378838ad)
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        display: {
                            xs: 'none',
                            lg: 'flex'
                        },
                        justifyContent: 'flex-end',
                        pt: 1
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cfa4675ff04c83e$export$7d7b01fecaadfe39), {
                        summary: summary,
                        priceView: priceView
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        gridColumn: 'span 96',
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cfa4675ff04c83e$export$5ceb7ad2e8b0bb65), {
                            summary: summary,
                            summaryError: summaryError,
                            summaryLoading: summaryLoading,
                            priceView: priceView,
                            hideAxisX: true,
                            sx: {
                                '& > .MuiBox-root': {
                                    p: 0
                                },
                                position: 'relative',
                                zIndex: 1,
                                bgcolor: 'transparent'
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            className: "chart-overlay",
                            sx: {
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'grid',
                                zIndex: 2,
                                gridTemplateColumns: `repeat(${spotPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? 96 : 24}, 1fr)`
                            },
                            children: Array.from({
                                length: spotPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? 96 : 24
                            }, (_, i)=>i).map((i)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                    className: `spot-summary-col-${spotPricePeriod}-${i}`,
                                    "data-tooltip": getTooltip(i, spotPricePeriod, 'short')
                                }, i);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ...(0, $37da3e5d4f8ebfec$export$e27cefcb2a3f030e),
                        mt: {
                            xs: 1.25,
                            lg: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "spot.summary.time",
                        defaultMessage: "\u010Cas"
                    })
                }),
                $d0a96727fb5b163e$var$summaryHead.map((i)=>{
                    if (!lg && i % 2 === 0) return null;
                    if (!sm && i % 3 === 0) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        component: "span",
                        sx: {
                            textAlign: 'left',
                            fontSize: 12,
                            gridColumn: {
                                xs: 'span 12',
                                sm: 'span 8',
                                lg: 'span 4'
                            },
                            py: 0.5,
                            width: 'auto'
                        },
                        className: labelCoverageClass[i - 1],
                        "data-tooltip": getTooltip(i - 1, (0, $6uJ19.SpotPricePeriod)['60M']),
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                            sx: {
                                height: {
                                    xs: 16,
                                    sm: 26
                                }
                            },
                            children: [
                                i - 1,
                                ":00"
                            ]
                        })
                    }, i);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ...(0, $37da3e5d4f8ebfec$export$e27cefcb2a3f030e)
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "spot.summary.price",
                        defaultMessage: "Cena"
                    })
                }),
                prices.map((value, i)=>{
                    if (!lg && (i + 1) % 2 === 0) return null;
                    if (!sm && (i + 1) % 3 === 0) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        component: "span",
                        sx: {
                            fontSize: 12,
                            gridColumn: {
                                xs: 'span 12',
                                sm: 'span 8',
                                lg: 'span 4'
                            },
                            py: 0.5,
                            width: 'auto'
                        },
                        className: labelCoverageClass[i],
                        "data-tooltip": getTooltip(i, (0, $6uJ19.SpotPricePeriod)['60M']),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                height: {
                                    xs: 16,
                                    sm: 26
                                }
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedNumber), {
                                value: value,
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            })
                        })
                    }, i);
                }),
                !isTomorrow && spotPriceLevel && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a973e650c965c62f$export$3c5fbebd466f3335), {
                    title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).priceLevelTitle,
                    help: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).priceLevelHelp,
                    data: spotPriceLevel,
                    pricePeriod: (0, $6uJ19.SpotPricePeriod)['60M'],
                    Cell: (0, $1206c63fb3e45744$export$939a7d371feb5106),
                    getTooltip: getTooltip
                }),
                !isTomorrow && is15M && spotPriceLevel15M && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a973e650c965c62f$export$3c5fbebd466f3335), {
                    title: (0, $0b8ba5b8bfa54f55$export$defe85febe8b728c).priceLevel15MTitle,
                    data: spotPriceLevel15M,
                    pricePeriod: (0, $6uJ19.SpotPricePeriod)['15M'],
                    Cell: (0, $1206c63fb3e45744$export$939a7d371feb5106),
                    getTooltip: getTooltip
                }),
                features.filter((f)=>f.visible).map((f)=>f.kind === 'bool' ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a973e650c965c62f$export$3c5fbebd466f3335), {
                        title: f.title,
                        help: f.help,
                        data: is15M ? f.data15M : f.data60M,
                        pricePeriod: spotPricePeriod,
                        Cell: (0, $35d9e01773d58944$export$e86bc60794f47b8),
                        getTooltip: getTooltip
                    }, f.title.id) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a973e650c965c62f$export$3c5fbebd466f3335), {
                        title: f.title,
                        help: f.help,
                        data: f.data60M,
                        pricePeriod: (0, $6uJ19.SpotPricePeriod)['60M'],
                        Cell: (0, $99c578925c56180f$export$b7ab0af43278a5a4),
                        getTooltip: getTooltip
                    }, f.title.id))
            ]
        })
    });
};



const $5a84e95c0546d571$export$635c3220b9f2d288 = ()=>{
    const { row: row, summary: summary, summaryError: summaryError, summaryLoading: summaryLoading, priceView: priceView } = (0, $d06e58c3458bb049$export$276b2b07e3c8b90b)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            sx: {
                pt: 1
            },
            children: [
                row,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0a96727fb5b163e$export$d7b595bc0b9de700), {
                    summary: summary,
                    summaryError: summaryError,
                    summaryLoading: summaryLoading,
                    priceView: priceView
                })
            ]
        })
    });
};


const $5a0509fee648eadf$var$SpotPage = ()=>{
    const [batteryControl, overflowControl] = (0, $2lSXC.useSelector)((s)=>[
            (0, $f1q41.get)(s.variables, 'PV_BATTERY_CONTROL'),
            (0, $f1q41.get)(s.variables, 'PV_OVERFLOW_CONTROL')
        ]);
    const [hes, hesLevel] = (0, $2lSXC.useSelector)((s)=>{
        const inverterConfig = s.variables.INVERTER_CONFIG;
        const inverterConfigArray = Object.values(inverterConfig ?? {});
        const inverterStatsArray = Object.values(s.variables.INVERTER_STATS ?? {});
        const hesLevel = inverterStatsArray[0]?.hesSpot?.level ?? '';
        return [
            inverterConfigArray[0]?.type === (0, $8ni7a.Inverter).Hes,
            hesLevel
        ];
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.status",
                            defaultMessage: "Spotov\xe9 obchodov\xe1n\xed"
                        }),
                        switchVariableId: "SP_ON",
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a84e95c0546d571$export$635c3220b9f2d288), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot.draft",
                    defaultMessage: "Re\u017Eimy pro dne\u0161ek"
                }),
                help: {
                    variant: 'tooltip',
                    title: undefined,
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "spot.draft.info",
                        defaultMessage: "Re\u017Eimy a doporu\u010Den\xed pro dne\u0161n\xed den"
                    })
                },
                layout: "scrollable",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.todaystatus_HW",
                            defaultMessage: "Akumulace bojleru"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotHeatWater"
                        }),
                        visibility: {
                            variableId: 'HW_INSTALL'
                        },
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.todaystatus_HP",
                            defaultMessage: "Akumulace tepelka"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotHeatPump"
                        }),
                        visibility: {
                            variableId: 'HP_ENABLED'
                        },
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.todaystatus_bat",
                            defaultMessage: "Akumulace baterie"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotBattery"
                        }),
                        visibility: {
                            variableId: 'PV_BATTERY'
                        },
                        sx: {
                            mr: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.todaystatus_em",
                            defaultMessage: "P\u0159etok"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "spotSmartMeter"
                        }),
                        sx: {
                            mr: 2
                        },
                        visibility: {
                            variableId: 'PV_OVERFLOW_CONTROL'
                        }
                    }),
                    hes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.hesLevel",
                            defaultMessage: "\xdarove\u0148 \u0159\xedzen\xed HES"
                        }),
                        subtitle: hesLevel,
                        sx: {
                            mr: 2
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "grid",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.lowprice",
                            defaultMessage: "Hranice zv\xfd\u0161en\xe9ho odb\u011Bru"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_LOW_PRICE",
                            opts: {
                                style: 'currency'
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69287d642341bb09$export$dc728e82a0944241), {}),
                        gridItem: {
                            size: {
                                xs: 12,
                                lg: 6
                            }
                        },
                        type: "row"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.hiprice",
                            defaultMessage: "Hranice sn\xed\u017Een\xe9ho odb\u011Bru"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_HI_PRICE",
                            opts: {
                                style: 'currency'
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c699509f9e2a76c$export$de01b345748fab4b), {}),
                        gridItem: {
                            size: {
                                xs: 12,
                                lg: 6
                            }
                        },
                        type: "row"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.actualpricelow",
                            defaultMessage: "Aktu\xe1ln\xed cena je n\xedzk\xe1, zvy\u0161 spot\u0159ebu"
                        }),
                        visibility: {
                            variableId: 'SP_ACTUAL_PRICE_LOW'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_ACTUAL_PRICE",
                            opts: {
                                style: 'currency'
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $69287d642341bb09$export$dc728e82a0944241), {}),
                        gridItem: {
                            size: {
                                xs: 12,
                                lg: 6
                            }
                        },
                        type: "row"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.draft.actualpricehi",
                            defaultMessage: "Aktu\xe1ln\xed cena je vysok\xe1, sni\u017E spot\u0159ebu"
                        }),
                        visibility: {
                            variableId: 'SP_ACTUAL_PRICE_HI'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_ACTUAL_PRICE",
                            opts: {
                                style: 'currency'
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c699509f9e2a76c$export$de01b345748fab4b), {}),
                        gridItem: {
                            size: {
                                xs: 12,
                                lg: 6
                            }
                        },
                        type: "row"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot.prediction",
                    defaultMessage: "Odhady energi\xed pro dne\u0161ek"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.prediction.pv",
                            defaultMessage: "V\xfdroba elektr\xe1rny"
                        }),
                        visibility: {
                            variableId: 'PV_INSTALL'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_FORECAST_PV",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.prediction.home",
                            defaultMessage: "B\u011B\u017En\xe1 spot\u0159eba objektu"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_FORECAST_HOME_CONSUMPTIN",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fdd94ff560015fde$export$1027d4534a5ce60b), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "spot.prediction.sale",
                                    defaultMessage: "Zb\xfdvaj\xedc\xed energie pro prodej p\u0159ebytk\u016F"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                    variant: "dialog",
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot.prediction.sale",
                                        defaultMessage: "Zb\xfdvaj\xedc\xed energie pro prodej p\u0159ebytk\u016F"
                                    }),
                                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "spot.prediction.sale.help",
                                        defaultMessage: "Zb\xfdvaj\xedc\xed pl\xe1novan\xe1 denn\xed v\xfd\u0161e p\u0159ebytk\u016F, kter\xe1 bude up\u0159ednostn\u011Bna jako p\u0159etok do s\xedt\u011B p\u0159ed akumulac\xed do baterie."
                                    })
                                })
                            ]
                        }),
                        visibility: {
                            variableIds: [
                                'SP_OVERFLOW_OPTIMALIZATION',
                                'PV_OVERFLOW_CONTROL'
                            ]
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_ENERGY_FOR_SALE",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.prediction.hp",
                            defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                        }),
                        visibility: {
                            variableId: 'HP_ENABLED'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_FORECAST_HP_CONSUMPTIN",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot.flexibility",
                    defaultMessage: "Odhad flexibility pro dne\u0161ek"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.prediction.hw",
                            defaultMessage: "Dispozi\u010Dn\xed akumulace bojleru"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_FORECAST_HW_CONSUMPTIN",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        visibility: {
                            variableId: 'HW_INSTALL'
                        },
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "spot.prediction.battery",
                            defaultMessage: "Dispozi\u010Dn\xed akumulace baterie"
                        }),
                        visibility: {
                            variableId: 'PV_BATTERY'
                        },
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "SP_FORECAST_BATTERY_CONSUMPTIN",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23960298a8a935c1$export$bab14011024b8f09), {}),
            batteryControl && overflowControl && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "spot.user.parameters",
                    defaultMessage: "Parametry spotov\xe9ho obchodov\xe1n\xed"
                }),
                layout: "list",
                collapsible: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd71b4952db748b0$export$9b203cb7511ea22b), {})
            })
        ]
    });
};
var $5a0509fee648eadf$export$2e2bcd8739ae039 = $5a0509fee648eadf$var$SpotPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $7X4mk = parcelRequire("7X4mk");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");







var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");

var $aZOrF = parcelRequire("aZOrF");
parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $bd9zl = parcelRequire("bd9zl");


var $g04kv = parcelRequire("g04kv");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $12gtR = parcelRequire("12gtR");
var $b7Ol4 = parcelRequire("b7Ol4");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");

var $5R532 = parcelRequire("5R532");

var $2lSXC = parcelRequire("2lSXC");
const $d7f800ff940ae688$var$summaryHead = Array.from({
    length: 24
}, (_, i)=>i + 1);
const $d7f800ff940ae688$export$aaa48721fae9890 = ({ plugIndex: plugIndex })=>{
    const theme = (0, $b7Ol4.default)();
    const lg = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('lg'));
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const headSx = {
        gridColumn: {
            xs: 'span 96',
            lg: 'auto'
        },
        fontSize: {
            xs: 12,
            lg: 14
        },
        lineHeight: {
            xs: '12px',
            lg: '24px'
        },
        mt: {
            xs: 1.25,
            lg: 0
        },
        mb: {
            xs: 0.5,
            lg: 0
        },
        pr: {
            xs: 0,
            lg: 1
        },
        width: 'auto'
    };
    const [prices, priceLevels, spotEnabled, spotLow, spotMid, spotHi, spotNeg, spotBelow, spotAbove, priceBelowValue, priceAboveValue, plugPricePeriod, spPricePeriod, spotEm, spotOverflow] = (0, $2lSXC.useSelector)(({ variables: { SP_HOURS_PRICE: SP_HOURS_PRICE, SP_PRICE_LEVEL: SP_PRICE_LEVEL, PL_SPOT: PL_SPOT, PL_SPOT_LOW: PL_SPOT_LOW, PL_SPOT_MI: PL_SPOT_MI, PL_SPOT_HI: PL_SPOT_HI, PL_SPOT_NEG: PL_SPOT_NEG, PL_SPOT_BELOW_PLUG: PL_SPOT_BELOW_PLUG, PL_SPOT_ABOVE_PLUG: PL_SPOT_ABOVE_PLUG, SP_PRICE_BELOW_PLUG_VALUE: SP_PRICE_BELOW_PLUG_VALUE, SP_PRICE_ABOVE_PLUG_VALUE: SP_PRICE_ABOVE_PLUG_VALUE, PL_SP_PRICE_PERIOD: PL_SP_PRICE_PERIOD, SP_PRICE_PERIOD: SP_PRICE_PERIOD, SP_EM: SP_EM, SP_OVERFLOW_TABLE: SP_OVERFLOW_TABLE } })=>[
            SP_HOURS_PRICE,
            SP_PRICE_LEVEL,
            PL_SPOT,
            PL_SPOT_LOW,
            PL_SPOT_MI,
            PL_SPOT_HI,
            PL_SPOT_NEG,
            PL_SPOT_BELOW_PLUG,
            PL_SPOT_ABOVE_PLUG,
            SP_PRICE_BELOW_PLUG_VALUE,
            SP_PRICE_ABOVE_PLUG_VALUE,
            PL_SP_PRICE_PERIOD[plugIndex],
            SP_PRICE_PERIOD,
            SP_EM,
            SP_OVERFLOW_TABLE
        ]);
    // Simple plan for 60M spot control for selected plug
    const schedule = (0, $acw62.useMemo)(()=>{
        const result = [];
        const isSpotOn = spotEnabled[plugIndex];
        for(let hour = 0; hour < 24; hour++){
            let on = false;
            if (!isSpotOn) {
                result.push(false);
                continue;
            }
            const level = priceLevels[hour];
            const price = prices[hour];
            if (spotLow[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Low) on = true;
            if (spotMid[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Mid) on = true;
            if (spotHi[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Hi) on = true;
            // Custom below / above price
            if (spotBelow[plugIndex] && priceBelowValue[plugIndex] != null && price <= priceBelowValue[plugIndex]) on = true;
            if (spotAbove[plugIndex] && priceAboveValue[plugIndex] != null && price >= priceAboveValue[plugIndex]) on = true;
            // Negative price – follow overflow 60m table across the day
            if (spotNeg[plugIndex] && Array.isArray(spotOverflow) && !spotOverflow[hour]) on = true;
            result.push(on);
        }
        return result;
    }, [
        plugIndex,
        prices,
        priceLevels,
        spotEnabled,
        spotLow,
        spotMid,
        spotHi,
        spotNeg,
        spotBelow,
        spotAbove,
        priceBelowValue,
        priceAboveValue,
        spotEm,
        spotOverflow
    ]);
    if (!prices || prices.length !== 24) return null;
    if (plugPricePeriod !== (0, $6uJ19.SpotPricePeriod)['60M'] && spPricePeriod !== (0, $6uJ19.SpotPricePeriod)['60M']) return null;
    if (!spotEnabled[plugIndex]) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            mb: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'repeat(96, 1fr)',
                    lg: 'auto repeat(96, 1fr)'
                },
                rowGap: {
                    lg: 1
                }
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ...headSx
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.time",
                        defaultMessage: "\u010Cas"
                    })
                }),
                $d7f800ff940ae688$var$summaryHead.map((i)=>{
                    if (!lg && i % 2 === 0) return null;
                    if (!sm && i % 3 === 0) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        component: "span",
                        sx: {
                            textAlign: 'left',
                            fontSize: 12,
                            gridColumn: {
                                xs: 'span 12',
                                sm: 'span 8',
                                lg: 'span 4'
                            },
                            width: 'auto'
                        },
                        children: [
                            i - 1,
                            ":00"
                        ]
                    }, i);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ...headSx
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.price",
                        defaultMessage: "Cena"
                    })
                }),
                prices.map((value, i)=>{
                    if (!lg && (i + 1) % 2 === 0) return null;
                    if (!sm && (i + 1) % 3 === 0) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        component: "span",
                        sx: {
                            fontSize: 12,
                            gridColumn: {
                                xs: 'span 12',
                                sm: 'span 8',
                                lg: 'span 4'
                            },
                            width: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedNumber), {
                            value: value,
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })
                    }, i);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$RowHead, {
                    sx: headSx,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.price_level",
                        defaultMessage: "Hladina ceny"
                    })
                }),
                priceLevels.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$ColPriceLevel, {
                        value: value,
                        periodIndex: i
                    }, i)),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$RowHead, {
                    sx: headSx,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.switch",
                        defaultMessage: "Sepnut\xed z\xe1suvky"
                    })
                }),
                schedule.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$ColBoolean, {
                        value: value,
                        periodIndex: i,
                        pricePeriod: (0, $6uJ19.SpotPricePeriod)['60M']
                    }, i))
            ]
        })
    });
};
const $d7f800ff940ae688$var$RowHead = ({ children: children, sx: sx })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            ...sx
        },
        children: children
    });
const $d7f800ff940ae688$var$ColBoolean = ({ pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], periodIndex: periodIndex, value: value })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$FormattedPriceIndex, {
            index: periodIndex,
            pricePeriod: pricePeriod
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: 26,
                bgcolor: value ? 'primary.main' : 'grey.200',
                gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4'
            }
        })
    });
};
const $d7f800ff940ae688$var$ColPriceLevel = ({ periodIndex: periodIndex, pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], value: value })=>{
    let title = null;
    let bgcolor = 'grey.200';
    if (value === (0, $8ni7a.SpotPriceLevel).Hi) {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.hi",
            defaultMessage: "Vysok\xe1 cena"
        });
        bgcolor = 'error.main';
    } else if (value === (0, $8ni7a.SpotPriceLevel).Mid) {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.mid",
            defaultMessage: "St\u0159edn\xed cena"
        });
        bgcolor = '#ff9800';
    } else {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.low",
            defaultMessage: "N\xedzk\xe1 cena"
        });
        bgcolor = 'success.main';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                title,
                " (",
                /*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$FormattedPriceIndex, {
                    index: periodIndex,
                    pricePeriod: pricePeriod
                }),
                ")"
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: 26,
                bgcolor: bgcolor,
                gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4'
            }
        })
    });
};
const $d7f800ff940ae688$var$FormattedPriceIndex = ({ index: index, pricePeriod: pricePeriod })=>{
    const time = (0, $acw62.useMemo)(()=>{
        return (0, $4d82c4193dc87874$export$2e2bcd8739ae039)((0, $3652e7106c1f3d0e$export$2287e3d29250119e)((0, $g04kv.startOfDay)(new Date()), pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? index * 15 : index * 60), 'HH:mm');
    }, [
        index,
        pricePeriod
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: time
    });
};
const $d7f800ff940ae688$export$a234accf971d303a = ({ plugIndex: plugIndex })=>{
    const theme = (0, $b7Ol4.default)();
    const lg = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('lg'));
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const headSx = {
        gridColumn: {
            xs: 'span 96',
            lg: 'auto'
        },
        fontSize: {
            xs: 12,
            lg: 14
        },
        lineHeight: {
            xs: '12px',
            lg: '24px'
        },
        mt: {
            xs: 1.25,
            lg: 0
        },
        mb: {
            xs: 0.5,
            lg: 0
        },
        pr: {
            xs: 0,
            lg: 1
        },
        width: 'auto'
    };
    const [prices, priceLevels15M, spotEnabled, spotLow15M, spotMid15M, spotHi15M, spotNeg15M, spotBelow15M, spotAbove15M, priceBelowValue15M, priceAboveValue15M, plugPricePeriod, spPricePeriod, spotEm, spotOverflow15M] = (0, $2lSXC.useSelector)(({ variables: { SP_15M_PRICE: SP_15M_PRICE, SP_PRICE_15M_LEVEL: SP_PRICE_15M_LEVEL, PL_SPOT: PL_SPOT, PL_SPOT_LOW_15MIN: PL_SPOT_LOW_15MIN, PL_SPOT_MI_15MIN: PL_SPOT_MI_15MIN, PL_SPOT_HI_15MIN: PL_SPOT_HI_15MIN, PL_SPOT_NEG_15MIN: PL_SPOT_NEG_15MIN, PL_SPOT_BELOW_PLUG_15MIN: PL_SPOT_BELOW_PLUG_15MIN, PL_SPOT_ABOVE_PLUG_15MIN: PL_SPOT_ABOVE_PLUG_15MIN, SP_PRICE_BELOW_PLUG_15MIN_VALUE: SP_PRICE_BELOW_PLUG_15MIN_VALUE, SP_PRICE_ABOVE_PLUG_15MIN_VALUE: SP_PRICE_ABOVE_PLUG_15MIN_VALUE, PL_SP_PRICE_PERIOD: PL_SP_PRICE_PERIOD, SP_PRICE_PERIOD: SP_PRICE_PERIOD, SP_EM: SP_EM, SP_OVERFLOW_15M_TABLE: SP_OVERFLOW_15M_TABLE } })=>[
            SP_15M_PRICE,
            SP_PRICE_15M_LEVEL,
            PL_SPOT,
            PL_SPOT_LOW_15MIN,
            PL_SPOT_MI_15MIN,
            PL_SPOT_HI_15MIN,
            PL_SPOT_NEG_15MIN,
            PL_SPOT_BELOW_PLUG_15MIN,
            PL_SPOT_ABOVE_PLUG_15MIN,
            SP_PRICE_BELOW_PLUG_15MIN_VALUE,
            SP_PRICE_ABOVE_PLUG_15MIN_VALUE,
            PL_SP_PRICE_PERIOD[plugIndex],
            SP_PRICE_PERIOD,
            SP_EM,
            SP_OVERFLOW_15M_TABLE
        ]);
    // Simple plan for 15M spot control for selected plug
    const schedule15M = (0, $acw62.useMemo)(()=>{
        const result = [];
        const isSpotOn = spotEnabled[plugIndex];
        for(let index = 0; index < 96; index++){
            let on = false;
            if (!isSpotOn) {
                result.push(false);
                continue;
            }
            const level = priceLevels15M[index];
            const price = prices[index];
            if (spotLow15M[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Low) on = true;
            if (spotMid15M[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Mid) on = true;
            if (spotHi15M[plugIndex] && level === (0, $8ni7a.SpotPriceLevel).Hi) on = true;
            // Custom below / above price
            if (spotBelow15M[plugIndex] && priceBelowValue15M[plugIndex] != null && price <= priceBelowValue15M[plugIndex]) on = true;
            if (spotAbove15M[plugIndex] && priceAboveValue15M[plugIndex] != null && price >= priceAboveValue15M[plugIndex]) on = true;
            // Negative price – follow overflow 15m table across the day
            if (spotNeg15M[plugIndex] && Array.isArray(spotOverflow15M) && !spotOverflow15M[index]) on = true;
            result.push(on);
        }
        return result;
    }, [
        plugIndex,
        prices,
        priceLevels15M,
        spotEnabled,
        spotLow15M,
        spotMid15M,
        spotHi15M,
        spotNeg15M,
        spotBelow15M,
        spotAbove15M,
        priceBelowValue15M,
        priceAboveValue15M,
        spotEm,
        spotOverflow15M
    ]);
    if (plugPricePeriod !== (0, $6uJ19.SpotPricePeriod)['15M'] && spPricePeriod !== (0, $6uJ19.SpotPricePeriod)['15M']) return null;
    if (!spotEnabled[plugIndex]) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            mb: 2
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
            sx: {
                display: 'grid',
                gridTemplateColumns: {
                    xs: 'repeat(96, 1fr)',
                    lg: 'auto repeat(96, 1fr)'
                },
                rowGap: {
                    lg: 1
                }
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        ...headSx
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.time",
                        defaultMessage: "\u010Cas"
                    })
                }),
                $d7f800ff940ae688$var$summaryHead.map((i)=>{
                    if (!lg && i % 2 === 0) return null;
                    if (!sm && i % 3 === 0) return null;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        component: "span",
                        sx: {
                            textAlign: 'left',
                            fontSize: 12,
                            gridColumn: {
                                xs: 'span 12',
                                sm: 'span 8',
                                lg: 'span 4'
                            },
                            width: 'auto'
                        },
                        children: [
                            i - 1,
                            ":00"
                        ]
                    }, i);
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                    sx: {
                        ...headSx
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.price_level_15m",
                        defaultMessage: "Hladina ceny 15m"
                    })
                }),
                priceLevels15M.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$ColPriceLevel, {
                        value: value,
                        periodIndex: i,
                        pricePeriod: (0, $6uJ19.SpotPricePeriod)['15M']
                    }, i)),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$RowHead, {
                    sx: headSx,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "plug.summary.switch",
                        defaultMessage: "Sepnut\xed z\xe1suvky"
                    })
                }),
                schedule15M.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7f800ff940ae688$var$ColBoolean, {
                        value: value,
                        periodIndex: i,
                        pricePeriod: (0, $6uJ19.SpotPricePeriod)['15M']
                    }, i))
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("cW890");
var $6uJ19 = parcelRequire("6uJ19");

var $2lSXC = parcelRequire("2lSXC");
const $74384efd605a77b8$var$periods = [
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.price.period.60min",
            defaultMessage: "60 min"
        }),
        value: (0, $6uJ19.SpotPricePeriod)['60M']
    },
    {
        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.price.period.15min",
            defaultMessage: "15 min"
        }),
        value: (0, $6uJ19.SpotPricePeriod)['15M']
    }
];
const $74384efd605a77b8$export$a2e6a77805bd272 = ({ plugIndex: plugIndex })=>{
    const spPricePeriod = (0, $2lSXC.useSelector)((state)=>state.variables.SP_PRICE_PERIOD);
    const options = (0, $acw62.useMemo)(()=>{
        // 60M always available
        const period60M = $74384efd605a77b8$var$periods.filter((option)=>option.value === (0, $6uJ19.SpotPricePeriod)['60M']);
        // 15M is only visible if the global period is 15M
        if (spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']) return $74384efd605a77b8$var$periods;
        return period60M;
    }, [
        spPricePeriod
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "plug.spot.price.period",
            defaultMessage: "\u010Casov\xe9 rozli\u0161en\xed z\xe1suvky"
        }),
        selectVariableId: `PL_SP_PRICE_PERIOD[${plugIndex}]`,
        options: options,
        fullWidth: true
    });
};


const $3628c8357915c99a$var$PlugPage = ()=>{
    const [plugIndex, setPlugIndex] = (0, $acw62.useState)(0);
    const plugsCount = (0, $2lSXC.useSelector)((s)=>s.variables.PL_NUMBER);
    const plugNames = (0, $2lSXC.useSelector)((s)=>s.variables.PL_NAME);
    const overflow = (0, $2lSXC.useSelector)((s)=>{
        return s.variables.PV_OVERFLOW_MAX_VALUE > 0 || s.variables.PV_OVERFLOW;
    });
    const plugSpotPricePeriod15M = (0, $2lSXC.useSelector)((s)=>s.variables.PL_SP_PRICE_PERIOD[plugIndex] === (0, $6uJ19.SpotPricePeriod)['15M'] && s.variables.SP_PRICE_PERIOD === (0, $6uJ19.SpotPricePeriod)['15M']);
    const spPricePeriod = (0, $2lSXC.useSelector)((s)=>s.variables.SP_PRICE_PERIOD);
    const plugSpotEnabled = (0, $2lSXC.useSelector)((s)=>s.variables.PL_SPOT[plugIndex]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                children: [
                    plugsCount > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.plug",
                            defaultMessage: "Z\xe1suvka"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                            value: plugIndex,
                            onChange: (e)=>setPlugIndex(e.target.value),
                            children: Array(plugsCount).fill(null).map((_, i)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                    value: i,
                                    children: plugNames[i]
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.plug",
                            defaultMessage: "Z\xe1suvka"
                        }),
                        switchVariableId: `PL_ON[${plugIndex}]`,
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                            type: "plug",
                            index: plugIndex
                        }),
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "plug.main.stat",
                    defaultMessage: "Statistiky"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "PL_POWER_GRAPH",
                    variableSuffix: plugIndex === 0 ? undefined : String(plugIndex)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "plug.main",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.main.consumption",
                            defaultMessage: "Aktu\xe1ln\xed spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `PL_CONSUMPTIN[${plugIndex}]`,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.main.power",
                            defaultMessage: "Celkov\xe1 spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `NEW_PL_ENERGY_PRODUCED_TOTAL[${plugIndex}]`,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "plug.main.power_today",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `PL_ENERGY_CONSUMPTIN_TODAY[${plugIndex}]`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "plug.main.power_year",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `PL_ENERGY_CONSUMPTIN_YEAR[${plugIndex}]`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.time",
                            defaultMessage: "\u0158\xedzen\xed podle \u010Dasu"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.time",
                                defaultMessage: "\u0158\xedzen\xed podle \u010Dasu"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.time.help",
                                defaultMessage: "Sp\xedn\xe1n\xed p\u0159i definovan\xe9m \u010Dase. Lze kombinovat s ostatn\xedmi podm\xednkami dle baterie (mus\xed b\xfdt nainstalov\xe1na baterie), spotov\xe9 ceny (mus\xed b\xfdt povoleno spotov\xe9 obchodov\xe1n\xed) a p\u0159etoku (mus\xed b\xfdt povolen p\u0159etok do DS). P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed."
                            })
                        })
                    ]
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.time.on",
                                defaultMessage: "Aktivn\xed"
                            }),
                            switchVariableId: `PL_TIME[${plugIndex}]`,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            type: "time",
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.turn_on",
                                        defaultMessage: "Zapnout"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.time.turn_on",
                                            defaultMessage: "Zapnout v \u010Dase"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.time.turn_on.help",
                                            defaultMessage: "\u010Cas, ve kter\xe9m se z\xe1suvka zapne. Pokud je nastaveno na 12:00, tak se z\xe1suvka zapne p\u0159esn\u011B v nastaven\xfd \u010Das 12:00."
                                        })
                                    })
                                ]
                            }),
                            variableId: `PL_TIME_START[${plugIndex}]`,
                            visibility: {
                                variableId: `PL_TIME[${plugIndex}]`
                            },
                            track: false
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            type: "time",
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.turn_off",
                                        defaultMessage: "Vypnout"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.time.turn_off",
                                            defaultMessage: "Vypnout v \u010Dase"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.time.turn_off.help",
                                            defaultMessage: "\u010Cas, ve kter\xe9m se z\xe1suvka vypne. Pokud je nastaveno na 12:00, tak se z\xe1suvka vypne p\u0159esn\u011B v nastaven\xfd \u010Das 12:00."
                                        })
                                    })
                                ]
                            }),
                            variableId: `PL_TIME_STOP[${plugIndex}]`,
                            visibility: {
                                variableId: `PL_TIME[${plugIndex}]`
                            },
                            track: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.bat",
                            defaultMessage: "\u0158\xedzen\xed podle baterie"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.bat",
                                defaultMessage: "\u0158\xedzen\xed podle baterie"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.bat.help",
                                defaultMessage: "Sp\xedn\xe1n\xed p\u0159i definovan\xe9 \xfarovni nabit\xed baterie. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed."
                            })
                        })
                    ]
                }),
                layout: "list",
                visibility: {
                    variableId: 'PV_BATTERY'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.bat.on",
                                defaultMessage: "Aktivn\xed"
                            }),
                            switchVariableId: `PL_BAT[${plugIndex}]`,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.bat.batterySart",
                                        defaultMessage: "Zapnout p\u0159i nabit\xed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.bat.batterySart",
                                            defaultMessage: "Zapnout p\u0159i nabit\xed"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.bat.batterySart.help",
                                            defaultMessage: "\xdarove\u0148 nabit\xed baterie, p\u0159i kter\xe9m se z\xe1suvka zapne. Aby k zapnut\xed do\u0161lo, mus\xed doj\xedt k p\u0159echodu nabit\xed baterie z nastaven\xe9ho stavu na vy\u0161\u0161\xed stav. Pokud je hodnota nastavena na 80%, tak z\xe1suvka sepne p\u0159i nabit\xed baterie ze 80% na 81%."
                                        })
                                    })
                                ]
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.bat.batterySart.subtitle",
                                defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se aktivuje z\xe1suvka"
                            }),
                            visibility: {
                                variableId: `PL_BAT[${plugIndex}]`
                            },
                            variableId: `PL_BAT_START[${plugIndex}]`,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 20,
                            max: 99
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.bat.batteryStop",
                                        defaultMessage: "Vypnout p\u0159i nabit\xed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.bat.batteryStop",
                                            defaultMessage: "Vypnout p\u0159i nabit\xed"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.bat.batteryStop.help",
                                            defaultMessage: "\xdarove\u0148 nabit\xed baterie, p\u0159i kter\xe9m se z\xe1suvka vypne. Aby k vypnut\xed do\u0161lo, mus\xed doj\xedt k p\u0159echodu nabit\xed baterie z nastaven\xe9ho na ni\u017E\u0161\xed stav. Pokud je hodnota nastavena na 80%, tak z\xe1suvka vypne p\u0159i vybit\xed baterie ze 80% na 79%."
                                        })
                                    })
                                ]
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.bat.batteryStop.subtitle",
                                defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se vypne z\xe1suvka"
                            }),
                            visibility: {
                                variableId: `PL_BAT[${plugIndex}]`
                            },
                            variableId: `PL_BAT_STOP[${plugIndex}]`,
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 20
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.spot",
                            defaultMessage: "\u0158\xedzen\xed podle spotov\xe9 ceny"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.spot",
                                defaultMessage: "\u0158\xedzen\xed podle spotov\xe9 ceny"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.spot.help",
                                defaultMessage: "Sp\xedn\xe1n\xed p\u0159i definovan\xe9 spotov\xe9 cen\u011B. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed."
                            })
                        })
                    ]
                }),
                layout: "list",
                visibility: {
                    variableId: 'SP_INSTALL'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "plug.spot.on",
                                    defaultMessage: "Aktivn\xed"
                                }),
                                visibility: {
                                    variableId: 'SP_INSTALL'
                                },
                                switchVariableId: `PL_SPOT[${plugIndex}]`,
                                fullWidth: true
                            }),
                            plugSpotEnabled && spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74384efd605a77b8$export$a2e6a77805bd272), {
                                plugIndex: plugIndex
                            })
                        ]
                    }),
                    !plugSpotPricePeriod15M && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.period",
                                        defaultMessage: "Perioda spotov\xe9 ceny"
                                    }),
                                    fullWidth: true,
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.period.subtitle",
                                        defaultMessage: "60 minutov\xe9 intervaly"
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7f800ff940ae688$export$aaa48721fae9890), {
                                    plugIndex: plugIndex
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotLow",
                                                defaultMessage: "Aktivovat p\u0159i n\xedzk\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotLow",
                                                    defaultMessage: "Aktivovat p\u0159i n\xedzk\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotLow.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na n\xedzk\xe9 \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_LOW[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotMi",
                                                defaultMessage: "Aktivovat p\u0159i st\u0159edn\xed cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotMi",
                                                    defaultMessage: "Aktivovat p\u0159i st\u0159edn\xed cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotMi.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na st\u0159edn\xed \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_MI[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotHi",
                                                defaultMessage: "Aktivovat p\u0159i vysok\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotHi",
                                                    defaultMessage: "Aktivovat p\u0159i vysok\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotHi.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na vysok\xe9 \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_HI[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_neg",
                                                defaultMessage: "Aktivovat p\u0159i z\xe1kazu p\u0159etok\u016F do s\xedt\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_neg",
                                                    defaultMessage: "Aktivovat p\u0159i z\xe1kazu p\u0159etok\u016F do s\xedt\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_neg.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je zak\xe1z\xe1n p\u0159etok do s\xedt\u011B viz pl\xe1n spotov\xe9ho obchodov\xe1n\xed."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_NEG[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_below_price",
                                                defaultMessage: "Aktivovat p\u0159i ni\u017E\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_below_price",
                                                    defaultMessage: "Aktivovat p\u0159i ni\u017E\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_below_price.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je cena spotu ni\u017E\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_BELOW_PLUG[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.price_below",
                                            defaultMessage: "Nastaven\xe1 cena spotu"
                                        })
                                    }),
                                    variableId: `SP_PRICE_BELOW_PLUG_VALUE[${plugIndex}]`,
                                    visibility: {
                                        variableIds: [
                                            `PL_SPOT_BELOW_PLUG[${plugIndex}]`,
                                            `PL_SPOT[${plugIndex}]`
                                        ]
                                    },
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.spot_below_price.subtitle",
                                        defaultMessage: "Pokud je cena spotu ni\u017E\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je vy\u0161\u0161\xed, dojde k rozepnut\xed."
                                    }),
                                    opts: {
                                        style: 'currency'
                                    },
                                    min: {
                                        CZK: -10,
                                        EUR: -0.5
                                    },
                                    max: {
                                        CZK: 10,
                                        EUR: 0.5
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_above_price",
                                                defaultMessage: "Aktivovat p\u0159i vy\u0161\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_above_price",
                                                    defaultMessage: "Aktivovat p\u0159i vy\u0161\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_above_price.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je cena spotu vy\u0161\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_ABOVE_PLUG[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.price_above_price",
                                            defaultMessage: "Nastaven\xe1 cena spotu"
                                        })
                                    }),
                                    variableId: `SP_PRICE_ABOVE_PLUG_VALUE[${plugIndex}]`,
                                    visibility: {
                                        variableIds: [
                                            `PL_SPOT_ABOVE_PLUG[${plugIndex}]`,
                                            `PL_SPOT[${plugIndex}]`
                                        ]
                                    },
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.spot_above_price.subtitle",
                                        defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je ni\u017E\u0161\xed, dojde k rozepnut\xed."
                                    }),
                                    opts: {
                                        style: 'currency'
                                    },
                                    min: {
                                        CZK: -10,
                                        EUR: -0.5
                                    },
                                    max: {
                                        CZK: 10,
                                        EUR: 0.5
                                    }
                                })
                            ]
                        })
                    }),
                    plugSpotPricePeriod15M && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.15m.period",
                                        defaultMessage: "Perioda spotov\xe9 ceny"
                                    }),
                                    fullWidth: true,
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.15m.period.subtitle",
                                        defaultMessage: "15 minutov\xe9 intervaly"
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7f800ff940ae688$export$a234accf971d303a), {
                                    plugIndex: plugIndex
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotLow",
                                                defaultMessage: "Aktivovat p\u0159i n\xedzk\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotLow",
                                                    defaultMessage: "Aktivovat p\u0159i n\xedzk\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotLow.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na n\xedzk\xe9 \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_LOW_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotMi",
                                                defaultMessage: "Aktivovat p\u0159i st\u0159edn\xed cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotMi",
                                                    defaultMessage: "Aktivovat p\u0159i st\u0159edn\xed cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotMi.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na st\u0159edn\xed \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_MI_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spotHi",
                                                defaultMessage: "Aktivovat p\u0159i vysok\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotHi",
                                                    defaultMessage: "Aktivovat p\u0159i vysok\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spotHi.help",
                                                    defaultMessage: "Z\xe1suvka se zapne, pokud je cena spotu na vysok\xe9 \xfarovni viz z\xe1lo\u017Eka Spot."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_HI_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_neg",
                                                defaultMessage: "Aktivovat p\u0159i z\xe1kazu p\u0159etok\u016F do s\xedt\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_neg",
                                                    defaultMessage: "Aktivovat p\u0159i z\xe1kazu p\u0159etok\u016F do s\xedt\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_neg.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je zak\xe1z\xe1n p\u0159etok do s\xedt\u011B viz pl\xe1n spotov\xe9ho obchodov\xe1n\xed."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_NEG_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_below_price",
                                                defaultMessage: "Aktivovat p\u0159i ni\u017E\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_below_price",
                                                    defaultMessage: "Aktivovat p\u0159i ni\u017E\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_below_price.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je cena spotu ni\u017E\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_BELOW_PLUG_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.price_below",
                                            defaultMessage: "Nastaven\xe1 cena spotu"
                                        })
                                    }),
                                    variableId: `SP_PRICE_BELOW_PLUG_15MIN_VALUE[${plugIndex}]`,
                                    visibility: {
                                        variableIds: [
                                            `PL_SPOT_BELOW_PLUG_15MIN[${plugIndex}]`,
                                            `PL_SPOT[${plugIndex}]`
                                        ]
                                    },
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.spot_below_price.subtitle",
                                        defaultMessage: "Pokud je cena spotu ni\u017E\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je vy\u0161\u0161\xed, dojde k rozepnut\xed."
                                    }),
                                    opts: {
                                        style: 'currency'
                                    },
                                    min: {
                                        CZK: -10,
                                        EUR: -0.5
                                    },
                                    max: {
                                        CZK: 10,
                                        EUR: 0.5
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "plug.spot.spot_above_price",
                                                defaultMessage: "Aktivovat p\u0159i vy\u0161\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                                variant: "dialog",
                                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_above_price",
                                                    defaultMessage: "Aktivovat p\u0159i vy\u0161\u0161\xed ne\u017E nastaven\xe9 cen\u011B"
                                                }),
                                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "plug.spot.spot_above_price.help",
                                                    defaultMessage: "Z\xe1suvka se aktivuje, pokud je cena spotu vy\u0161\u0161\xed nebo rovna nastaven\xe9 cen\u011B spotu."
                                                })
                                            })
                                        ]
                                    }),
                                    visibility: {
                                        variableId: `PL_SPOT[${plugIndex}]`
                                    },
                                    switchVariableId: `PL_SPOT_ABOVE_PLUG_15MIN[${plugIndex}]`,
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "settings.spot.price_above_price",
                                            defaultMessage: "Nastaven\xe1 cena spotu"
                                        })
                                    }),
                                    variableId: `SP_PRICE_ABOVE_PLUG_15MIN_VALUE[${plugIndex}]`,
                                    visibility: {
                                        variableIds: [
                                            `PL_SPOT_ABOVE_PLUG_15MIN[${plugIndex}]`,
                                            `PL_SPOT[${plugIndex}]`
                                        ]
                                    },
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.spot.spot_above_price.subtitle",
                                        defaultMessage: "Pokud je cena spotu vy\u0161\u0161\xed nebo rovna t\xe9to hodnot\u011B, dojde k sepnut\xed. Pokud je ni\u017E\u0161\xed, dojde k rozepnut\xed."
                                    }),
                                    opts: {
                                        style: 'currency'
                                    },
                                    min: {
                                        CZK: -10,
                                        EUR: -0.5
                                    },
                                    max: {
                                        CZK: 10,
                                        EUR: 0.5
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            overflow && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "plug.overflow",
                            defaultMessage: "\u0158\xedzen\xed podle p\u0159etoku"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                            variant: "dialog",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow",
                                defaultMessage: "\u0158\xedzen\xed podle p\u0159etoku"
                            }),
                            content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow.help",
                                defaultMessage: "Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B. Lze kombinovat s podm\xednkou \u010Dasu. P\u0159i kombinaci podm\xednek se z\xe1suvka zapne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro zapnut\xed a vypne, pokud je spln\u011Bna alespo\u0148 jedna z podm\xednek pro vypnut\xed."
                            })
                        })
                    ]
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow.on",
                                defaultMessage: "Aktivn\xed"
                            }),
                            switchVariableId: `PL_OVERFLOW[${plugIndex}]`,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow.consumption",
                                defaultMessage: "Nastaven\xed odpov\xedd\xe1 spot\u0159ebi\u010Di s p\u0159\xedkonem"
                            }),
                            visibility: {
                                variableId: `PL_OVERFLOW[${plugIndex}]`
                            },
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: `PL_OVERFLOW_CONSUMPTION[${plugIndex}]`,
                                opts: {
                                    style: 'unit',
                                    unit: 'kilowatt',
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                }
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.overflow.startPower",
                                        defaultMessage: "Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.startPower",
                                            defaultMessage: "Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.startPower.help",
                                            defaultMessage: "Z\xe1suvka se zapne, pokud je p\u0159etok v nastaven\xe9 v\xfd\u0161i po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na - 1500W a zpo\u017Ed\u011Bn\xed zapnut\xed je 5 minut, tak z\xe1suvka sepne p\u0159i p\u0159etoku do s\xedt\u011B ve v\xfd\u0161i alespo\u0148 1500W po dobu 5 minut."
                                        })
                                    })
                                ]
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow.startPower.subtitle",
                                defaultMessage: "Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br"
                            }),
                            variableId: `PL_OVERFLOW_START_POWER[${plugIndex}]`,
                            visibility: {
                                variableId: `PL_OVERFLOW[${plugIndex}]`
                            },
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1
                            },
                            step: 0.1,
                            min: -15,
                            max: 0
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.overflow.stopPower",
                                        defaultMessage: "Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.stopPower",
                                            defaultMessage: "Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.stopPower.help",
                                            defaultMessage: "Z\xe1suvka se vypne, pokud je odb\u011Br vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na 100W a zpo\u017Ed\u011Bn\xed vypnut\xed je 5 minut, tak z\xe1suvka vypne p\u0159i odb\u011Bru ze s\xedt\u011B ve v\xfd\u0161i minim\xe1ln\u011B 100W po dobu 5 minut."
                                        })
                                    })
                                ]
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.overflow.stopPower.subtitle",
                                defaultMessage: "Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br"
                            }),
                            variableId: `PL_OVERFLOW_STOP_POWER[${plugIndex}]`,
                            visibility: {
                                variableId: `PL_OVERFLOW[${plugIndex}]`
                            },
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1
                            },
                            step: 0.1,
                            min: -10,
                            max: 5
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            type: "time",
                            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "plug.overflow.time",
                                        defaultMessage: "Zpo\u017Ed\u011Bn\xed zapnut\xed a vypnut\xed"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                        variant: "dialog",
                                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.time",
                                            defaultMessage: "Zpo\u017Ed\u011Bn\xed zapnut\xed a vypnut\xed"
                                        }),
                                        content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "plug.overflow.time.help",
                                            defaultMessage: "Tento parametr slou\u017E\xed pro definici zpo\u017Ed\u011Bn\xed zapnut\xed a vypnut\xed z\xe1suvky p\u0159i definovan\xfdch p\u0159etoc\xedch/odb\u011Brech. Vhodn\xe9 pro nastaven\xed priority a eliminace \u010Dast\xe9ho sp\xedn\xe1n\xed z\xe1suvky. Zad\xe1vejte ve form\xe1tu HH:MM."
                                        })
                                    })
                                ]
                            }),
                            variableId: `PL_OVERFLOW_TON[${plugIndex}]`,
                            visibility: {
                                variableId: `PL_OVERFLOW[${plugIndex}]`
                            },
                            track: false,
                            max: 3600,
                            step: 60
                        })
                    ]
                })
            })
        ]
    });
};
var $3628c8357915c99a$export$2e2bcd8739ae039 = $3628c8357915c99a$var$PlugPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");


var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");


var $f1q41 = parcelRequire("f1q41");




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $bd9zl = parcelRequire("bd9zl");

var $f1q41 = parcelRequire("f1q41");


var $g04kv = parcelRequire("g04kv");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $12gtR = parcelRequire("12gtR");
var $b7Ol4 = parcelRequire("b7Ol4");

var $8ni7a = parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");

var $9iEAl = parcelRequire("9iEAl");

const $d7d06adb509b1b1d$var$summaryHead = Array.from({
    length: 24
}, (_, i)=>i + 1);
const $d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_60M = [
    (0, $8ni7a.RelayControl).SpotHi,
    (0, $8ni7a.RelayControl).SpotMi,
    (0, $8ni7a.RelayControl).SpotLow,
    (0, $8ni7a.RelayControl).SpotNegative,
    (0, $8ni7a.RelayControl).SpotPriceBelow,
    (0, $8ni7a.RelayControl).SpotPriceAbove
];
const $d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_15M = [
    (0, $8ni7a.RelayControl).SpotHi15M,
    (0, $8ni7a.RelayControl).SpotMi15M,
    (0, $8ni7a.RelayControl).SpotLow15M,
    (0, $8ni7a.RelayControl).SpotNegative15M,
    (0, $8ni7a.RelayControl).SpotPriceBelow15M,
    (0, $8ni7a.RelayControl).SpotPriceAbove15M
];
const $d7d06adb509b1b1d$var$RowHead = ({ children: children, sx: sx })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            ...sx
        },
        children: children
    });
const $d7d06adb509b1b1d$var$ColBoolean = ({ pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], periodIndex: periodIndex, value: value })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$FormattedPriceIndex, {
            index: periodIndex,
            pricePeriod: pricePeriod
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: 26,
                bgcolor: value ? 'primary.main' : 'grey.200',
                gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4'
            }
        })
    });
};
const $d7d06adb509b1b1d$var$ColPriceLevel = ({ periodIndex: periodIndex, pricePeriod: pricePeriod = (0, $6uJ19.SpotPricePeriod)['60M'], value: value })=>{
    let title = null;
    let bgcolor = 'grey.200';
    if (value === (0, $8ni7a.SpotPriceLevel).Hi) {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.hi",
            defaultMessage: "Vysok\xe1 cena"
        });
        bgcolor = 'error.main';
    } else if (value === (0, $8ni7a.SpotPriceLevel).Mid) {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.mid",
            defaultMessage: "St\u0159edn\xed cena"
        });
        bgcolor = '#ff9800';
    } else {
        title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "spot.summary.price_level.low",
            defaultMessage: "N\xedzk\xe1 cena"
        });
        bgcolor = 'success.main';
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                title,
                " (",
                /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$FormattedPriceIndex, {
                    index: periodIndex,
                    pricePeriod: pricePeriod
                }),
                ")"
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
            sx: {
                width: 'auto',
                height: 26,
                bgcolor: bgcolor,
                gridColumn: pricePeriod === '15M' ? 'span 1' : 'span 4'
            }
        })
    });
};
const $d7d06adb509b1b1d$var$FormattedPriceIndex = ({ index: index, pricePeriod: pricePeriod })=>{
    const time = (0, $acw62.useMemo)(()=>{
        return (0, $4d82c4193dc87874$export$2e2bcd8739ae039)((0, $3652e7106c1f3d0e$export$2287e3d29250119e)((0, $g04kv.startOfDay)(new Date()), pricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] ? index * 15 : index * 60), 'HH:mm');
    }, [
        index,
        pricePeriod
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: time
    });
};
const $d7d06adb509b1b1d$export$bd6e092cbb694634 = ({ relayIndex: relayIndex })=>{
    const theme = (0, $b7Ol4.default)();
    const lg = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('lg'));
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const headSx = {
        gridColumn: {
            xs: 'span 96',
            lg: 'auto'
        },
        fontSize: {
            xs: 12,
            lg: 14
        },
        lineHeight: {
            xs: '12px',
            lg: '24px'
        },
        mt: {
            xs: 1.25,
            lg: 0
        },
        mb: {
            xs: 0.5,
            lg: 0
        },
        pr: {
            xs: 0,
            lg: 1
        },
        width: 'auto'
    };
    const [prices, priceLevels, controlType, priceBelowRelay, priceAboveRelay, spotOverflow] = (0, $2lSXC.useSelector)((state)=>{
        const { variables: variables } = state;
        return [
            variables.SP_HOURS_PRICE,
            variables.SP_PRICE_LEVEL,
            (0, $f1q41.get)(variables, `RELAY_CONTROL_TYPE[0][${relayIndex}]`),
            variables.SPOT_PRICE_BELOW_RELAY?.[relayIndex],
            variables.SPOT_PRICE_ABOVE_RELAY?.[relayIndex],
            variables.SP_OVERFLOW_TABLE
        ];
    });
    const schedule = (0, $acw62.useMemo)(()=>{
        const result = [];
        if (!$d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_60M.includes(controlType)) return result;
        const type = controlType;
        for(let hour = 0; hour < 24; hour++){
            let on = false;
            const level = priceLevels?.[hour];
            const price = prices?.[hour];
            if (type === (0, $8ni7a.RelayControl).SpotHi && level === (0, $8ni7a.SpotPriceLevel).Hi) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotMi && level === (0, $8ni7a.SpotPriceLevel).Mid) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotLow && level === (0, $8ni7a.SpotPriceLevel).Low) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotPriceBelow && priceBelowRelay != null && price != null && price <= priceBelowRelay) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotPriceAbove && priceAboveRelay != null && price != null && price >= priceAboveRelay) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotNegative && Array.isArray(spotOverflow) && !spotOverflow[hour]) on = true;
            result.push(on);
        }
        return result;
    }, [
        controlType,
        prices,
        priceLevels,
        priceBelowRelay,
        priceAboveRelay,
        spotOverflow
    ]);
    if (!prices || prices.length !== 24) return null;
    if (!$d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_60M.includes(controlType)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "relay.spot.diagram",
                    defaultMessage: "Sp\xedn\xe1n\xed podle spotov\xe9 ceny"
                }),
                fullWidth: true,
                visibility: {
                    variableId: `RELAY_ENABLED[${relayIndex}]`
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(96, 1fr)',
                            lg: 'auto repeat(96, 1fr)'
                        },
                        rowGap: {
                            lg: 1
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                ...headSx
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.summary.time",
                                defaultMessage: "\u010Cas"
                            })
                        }),
                        $d7d06adb509b1b1d$var$summaryHead.map((i)=>{
                            if (!lg && i % 2 === 0) return null;
                            if (!sm && i % 3 === 0) return null;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                component: "span",
                                sx: {
                                    textAlign: 'left',
                                    fontSize: 12,
                                    gridColumn: {
                                        xs: 'span 12',
                                        sm: 'span 8',
                                        lg: 'span 4'
                                    },
                                    width: 'auto'
                                },
                                children: [
                                    i - 1,
                                    ":00"
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                ...headSx
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.summary.price",
                                defaultMessage: "Cena"
                            })
                        }),
                        prices.map((value, i)=>{
                            if (!lg && (i + 1) % 2 === 0) return null;
                            if (!sm && (i + 1) % 3 === 0) return null;
                            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                component: "span",
                                sx: {
                                    fontSize: 12,
                                    gridColumn: {
                                        xs: 'span 12',
                                        sm: 'span 8',
                                        lg: 'span 4'
                                    },
                                    width: 'auto'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedNumber), {
                                    value: value,
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                })
                            }, i);
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$RowHead, {
                            sx: headSx,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.summary.price_level",
                                defaultMessage: "Hladina ceny"
                            })
                        }),
                        priceLevels?.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$ColPriceLevel, {
                                value: value,
                                periodIndex: i
                            }, i)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$RowHead, {
                            sx: headSx,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "relay.summary.switch",
                                defaultMessage: "Sepnut\xed rel\xe9"
                            })
                        }),
                        schedule.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$ColBoolean, {
                                value: value,
                                periodIndex: i,
                                pricePeriod: (0, $6uJ19.SpotPricePeriod)['60M']
                            }, i))
                    ]
                })
            })
        ]
    });
};
const $d7d06adb509b1b1d$export$738a6c37288aa783 = ({ relayIndex: relayIndex })=>{
    const theme = (0, $b7Ol4.default)();
    const lg = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('lg'));
    const sm = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(theme.breakpoints.up('sm'));
    const headSx = {
        gridColumn: {
            xs: 'span 96',
            lg: 'auto'
        },
        fontSize: {
            xs: 12,
            lg: 14
        },
        lineHeight: {
            xs: '12px',
            lg: '24px'
        },
        mt: {
            xs: 1.25,
            lg: 0
        },
        mb: {
            xs: 0.5,
            lg: 0
        },
        pr: {
            xs: 0,
            lg: 1
        },
        width: 'auto'
    };
    const [prices, priceLevels15M, controlType, priceBelowRelay15M, priceAboveRelay15M, spotOverflow15M] = (0, $2lSXC.useSelector)((state)=>{
        const { variables: variables } = state;
        return [
            variables.SP_15M_PRICE,
            variables.SP_PRICE_15M_LEVEL,
            (0, $f1q41.get)(variables, `RELAY_CONTROL_TYPE[0][${relayIndex}]`),
            variables.SPOT_PRICE_BELOW_RELAY_15MIN?.[relayIndex],
            variables.SPOT_PRICE_ABOVE_RELAY_15MIN?.[relayIndex],
            variables.SP_OVERFLOW_15M_TABLE
        ];
    });
    const schedule15M = (0, $acw62.useMemo)(()=>{
        const result = [];
        if (!$d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_15M.includes(controlType)) return result;
        const type = controlType;
        for(let index = 0; index < 96; index++){
            let on = false;
            const level = priceLevels15M?.[index];
            const price = prices?.[index];
            if (type === (0, $8ni7a.RelayControl).SpotHi15M && level === (0, $8ni7a.SpotPriceLevel).Hi) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotMi15M && level === (0, $8ni7a.SpotPriceLevel).Mid) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotLow15M && level === (0, $8ni7a.SpotPriceLevel).Low) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotPriceBelow15M && priceBelowRelay15M != null && price != null && price <= priceBelowRelay15M) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotPriceAbove15M && priceAboveRelay15M != null && price != null && price >= priceAboveRelay15M) on = true;
            if (type === (0, $8ni7a.RelayControl).SpotNegative15M && Array.isArray(spotOverflow15M) && !spotOverflow15M[index]) on = true;
            result.push(on);
        }
        return result;
    }, [
        controlType,
        prices,
        priceLevels15M,
        priceBelowRelay15M,
        priceAboveRelay15M,
        spotOverflow15M
    ]);
    if (!prices || prices.length !== 96) return null;
    if (!$d7d06adb509b1b1d$var$RELAY_SPOT_TYPES_15M.includes(controlType)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "relay.spot.diagram",
                    defaultMessage: "Sp\xedn\xe1n\xed podle spotov\xe9 ceny"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(96, 1fr)',
                            lg: 'auto repeat(96, 1fr)'
                        },
                        rowGap: {
                            lg: 1
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                ...headSx
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.summary.time",
                                defaultMessage: "\u010Cas"
                            })
                        }),
                        $d7d06adb509b1b1d$var$summaryHead.map((i)=>{
                            if (!lg && i % 2 === 0) return null;
                            if (!sm && i % 3 === 0) return null;
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                                component: "span",
                                sx: {
                                    textAlign: 'left',
                                    fontSize: 12,
                                    gridColumn: {
                                        xs: 'span 12',
                                        sm: 'span 8',
                                        lg: 'span 4'
                                    },
                                    width: 'auto'
                                },
                                children: [
                                    i - 1,
                                    ":00"
                                ]
                            }, i);
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$RowHead, {
                            sx: headSx,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "plug.summary.price_level_15m",
                                defaultMessage: "Hladina ceny 15m"
                            })
                        }),
                        priceLevels15M?.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$ColPriceLevel, {
                                value: value,
                                periodIndex: i,
                                pricePeriod: (0, $6uJ19.SpotPricePeriod)['15M']
                            }, i)),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$RowHead, {
                            sx: headSx,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "relay.summary.switch",
                                defaultMessage: "Sepnut\xed rel\xe9"
                            })
                        }),
                        schedule15M.map((value, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)($d7d06adb509b1b1d$var$ColBoolean, {
                                value: value,
                                periodIndex: i,
                                pricePeriod: (0, $6uJ19.SpotPricePeriod)['15M']
                            }, i))
                    ]
                })
            })
        ]
    });
};


parcelRequire("8ni7a");
var $6uJ19 = parcelRequire("6uJ19");
const $356aebd82075892d$var$RelayPage = ()=>{
    const [relayIndex, setRelayIndex] = (0, $acw62.useState)(0);
    const spPricePeriod = (0, $2lSXC.useSelector)((s)=>s.variables.SP_PRICE_PERIOD);
    const [relayOutputs, relayNames, relayControlTypes, relayEnabled, morePlugsEnabled, thermostatInstall] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.RELAY_OUTPUT,
            variables.RELAY_NAME,
            (0, $f1q41.get)(variables, 'RELAY_CONTROL_TYPE[0]'),
            variables.RELAY_ENABLED,
            (0, $f1q41.get)(variables, 'PL_MORE_PLUGS_NUMBER') > 3,
            variables.THERMOSTAT_INSTALL
        ]);
    const relayIsActive = relayOutputs.map((status, index)=>({
            id: index,
            isActive: status
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "relay.title",
                            defaultMessage: "Rel\xe9"
                        }),
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                            value: relayIndex,
                            onChange: (e)=>setRelayIndex(e.target.value),
                            children: Array(4).fill(null).map((_, i)=>{
                                return relayEnabled[i] ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                    value: i,
                                    children: relayNames[i]
                                }, i) : null;
                            }).filter(Boolean)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "relay.status",
                            defaultMessage: "Sepnuto"
                        }),
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcb2bdf4fe09c462$export$eaa9dcd62e0d5ec6), {
                            alive: relayIsActive[relayIndex].isActive
                        }),
                        fullWidth: true,
                        visibility: {
                            variableId: `RELAY_ENABLED[${relayIndex}]`
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "relay.main",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "relay.name",
                            defaultMessage: "N\xe1zev rel\xe9"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `RELAY_NAME[${relayIndex}]`
                        }),
                        fullWidth: true
                    }),
                    (spPricePeriod === (0, $6uJ19.SpotPricePeriod)['60M'] || spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M']) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7d06adb509b1b1d$export$bd6e092cbb694634), {
                        relayIndex: relayIndex
                    }),
                    spPricePeriod === (0, $6uJ19.SpotPricePeriod)['15M'] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d7d06adb509b1b1d$export$738a6c37288aa783), {
                        relayIndex: relayIndex
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "relay.condition",
                                    defaultMessage: "Podm\xednka sp\xedn\xe1n\xed"
                                }),
                                subtitle: (0, $1fa014be3c1aec92$export$bd9aa579047d2095)[relayControlTypes[relayIndex]],
                                fullWidth: true,
                                visibility: {
                                    variableId: `RELAY_ENABLED[${relayIndex}]`
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cc9676de911bc57$export$bf42bece27e30ff1), {
                                index: relayIndex
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $356aebd82075892d$export$2e2bcd8739ae039 = $356aebd82075892d$var$RelayPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $7X4mk = parcelRequire("7X4mk");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");



var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");

const $037c80b621eab427$var$EnergyMetersPage = ()=>{
    const metersConfig = (0, $2lSXC.useSelector)((s)=>s.variables.EM_METERS_CONFIG);
    const meterIds = (0, $acw62.useMemo)(()=>Object.keys(metersConfig), [
        metersConfig
    ]);
    const [selectedMeterId, setSelectedMeterId] = (0, $acw62.useState)(meterIds[0] || '');
    // Auto-select first meter if current selection is invalid
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (meterIds.length > 0 && !meterIds.includes(selectedMeterId)) setSelectedMeterId(meterIds[0]);
    }, [
        meterIds,
        selectedMeterId
    ]);
    if (meterIds.length === 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
            layout: "list",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                sx: {
                    p: 2
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "energyMeters.notConfigured",
                    defaultMessage: "Elektrom\u011Bry nejsou nakonfigurov\xe1ny. Pro nastaven\xed p\u0159ejd\u011Bte do servisn\xedho menu."
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: meterIds.length > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "energyMeters.meter",
                        defaultMessage: "Elektrom\u011Br"
                    }),
                    fullWidth: true,
                    control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                        value: selectedMeterId,
                        onChange: (e)=>setSelectedMeterId(e.target.value),
                        children: meterIds.map((meterId)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: meterId,
                                children: metersConfig[meterId]?.name || meterId
                            }, meterId))
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "energyMeters.statistics",
                    defaultMessage: "Statistiky"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "EM_METER_POWER_GRAPH",
                    variableSuffix: selectedMeterId
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "energyMeters.general",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "energyMeters.actualPower",
                            defaultMessage: "Aktu\xe1ln\xed v\xfdkon"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `EM_METERS_DATA["${selectedMeterId}"].actualPower`,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energyMeters.phase1",
                                    defaultMessage: "F\xe1ze 1:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `EM_METERS_DATA["${selectedMeterId}"].phase1Power`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energyMeters.phase2",
                                    defaultMessage: "F\xe1ze 2:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `EM_METERS_DATA["${selectedMeterId}"].phase2Power`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energyMeters.phase3",
                                    defaultMessage: "F\xe1ze 3:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `EM_METERS_DATA["${selectedMeterId}"].phase3Power`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt',
                                        maximumFractionDigits: 2,
                                        minimumFractionDigits: 2
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "energyMeters.totalEnergy",
                            defaultMessage: "Celkov\xe1 spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `STATS_EM_METERS_ENERGY_TOTAL["${selectedMeterId}"]`,
                            fallbackValue: 0,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energyMeters.todayEnergy",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `STATS_EM_METERS_ENERGY_TODAY["${selectedMeterId}"]`,
                                    fallbackValue: 0,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energyMeters.yearEnergy",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `STATS_EM_METERS_ENERGY_YEAR["${selectedMeterId}"]`,
                                    fallbackValue: 0,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $037c80b621eab427$export$2e2bcd8739ae039 = $037c80b621eab427$var$EnergyMetersPage;



var $ayMG0 = parcelRequire("ayMG0");

var $7X4mk = parcelRequire("7X4mk");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");




parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");




const $dfbcb6923a026c91$var$Wind = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "wind.status",
                        defaultMessage: "Re\u017Eim v\u011Btrn\xe9 elektr\xe1rny"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                        type: "wind"
                    }),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wind.statistics",
                    defaultMessage: "Statistiky"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.statistics.power",
                            defaultMessage: "V\xfdkon v\u011Btrn\xe9 elektr\xe1rny"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                        variableId: "WIND_POWER_GRAPH"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        sx: {
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.statistics.wind_speed",
                            defaultMessage: "Rychlost v\u011Btru"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                        variableId: "WIND_SPEED_GRAPH"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wind.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.common.power",
                            defaultMessage: "Aktu\xe1ln\xed v\xfdkon"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WIND_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.statistics.wind_speed",
                            defaultMessage: "Rychlost v\u011Btru"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WIND_SPEED",
                            opts: {
                                style: 'unit',
                                unit: 'meter-per-second',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.common.battery_power",
                            defaultMessage: "V\xfdkon do baterie"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WIND_BATTERY_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.common.resistor_power",
                            defaultMessage: "V\xfdkon do odporu"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WIND_RESISTOR_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf30d0b933cf609b$export$891c98057d1a9092), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wind.common.power_total",
                            defaultMessage: "Celkov\xe1 v\xfdroba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WIND_PRODUCED_TOTAL",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c9756d985d035402$export$de16a60c2b9aa29e), {}),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wind.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed v\xfdroba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "WIND_PRODUCED_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wind.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed v\xfdroba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "WIND_PRODUCED_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wind.common.battery_charged_total",
                                    defaultMessage: "Celkem do baterie:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "WIND_BATTERY_CHARGE_TOTAL",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $dfbcb6923a026c91$export$2e2bcd8739ae039 = $dfbcb6923a026c91$var$Wind;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");








var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $12gtR = parcelRequire("12gtR");

var $5tslE = parcelRequire("5tslE");

var $2lSXC = parcelRequire("2lSXC");

var $5R532 = parcelRequire("5R532");

const $1e206a5ddfd900ec$export$e4289ca992c1c257 = ({ title: title })=>{
    const [devicesStatus] = (0, $2lSXC.useSelector)((s)=>{
        return [
            Object.values(s.variables.MQTT_CLOUD_DEVICES_STATUS).filter(({ type: type })=>type === 'shelly-plus-plug-s' || type === 'shelly-plus-plug-s-gen3' || type === 'shelly-plug-m-gen3' || type === 'shelly-1pm-gen3' || type === 'shelly-1pm-gen4' || type === 'shelly-pro-1pm' || type === 'shelly-pro-1pm-gen3')
        ];
    }, (0, $f1q41.isEqual));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
        title: title,
        rows: [
            [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.list.id",
                    defaultMessage: "ID"
                }, 0),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.list.online",
                    defaultMessage: "Online"
                }, 1),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.list.led_mode",
                    defaultMessage: "LED signalizace"
                }, 2),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.list.relay",
                    defaultMessage: "Rel\xe9"
                }, 3)
            ],
            ...devicesStatus.map(({ plugId: plugId, status: status, lastMessageAt: lastMessageAt, ledMode: ledMode, ledColors: ledColors, ...plug })=>{
                return [
                    plugId,
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                        title: String(lastMessageAt),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: status
                        })
                    }, 1),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e206a5ddfd900ec$var$CloudPlugsLedModeStatus, {
                        ledMode: ledMode,
                        ledColors: ledColors
                    }, 2),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1e206a5ddfd900ec$var$CloudPlugsSwitchStatus, {
                        switch: plug.switch
                    }, 3)
                ];
            })
        ],
        firstLineBold: true
    });
};
const $1e206a5ddfd900ec$var$CloudPlugsSwitchStatus = (plug)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: typeof plug.switch === 'boolean' ? String(plug.switch) : '---'
        })
    });
};
const $1e206a5ddfd900ec$var$CloudPlugsLedModeStatus = ({ ledMode: ledMode, ledColors: ledColors })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
        gap: 0.25,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "cloud_plugs.led_mode.mode",
                defaultMessage: "{mode, select, unknown {---} off {Vypnuto} switch {} power {Podle p\u0159\xedkonu} other {Nezn\xe1m\xfd}}",
                values: {
                    mode: ledMode
                }
            }),
            typeof ledColors === 'object' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3eb87d8c876d989$export$2e2bcd8739ae039), {
                        sx: {
                            color: `rgb(${ledColors.on.rgb.join()})`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d3eb87d8c876d989$export$2e2bcd8739ae039), {
                        sx: {
                            color: `rgb(${ledColors.off.rgb.join()})`
                        }
                    })
                ]
            })
        ]
    }, 2);
};



var $aZOrF = parcelRequire("aZOrF");

const $fc5b3be5a496799d$var$CloudPlugs = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.title",
                    defaultMessage: "Z\xe1suvky"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e206a5ddfd900ec$export$e4289ca992c1c257), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsBattery, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsControlCondition, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsTime, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsOverflow, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsPVPower, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fc5b3be5a496799d$var$CloudPlugsLedMode, {})
        ]
    });
};
const $fc5b3be5a496799d$var$CloudPlugsBattery = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "cloud_plugs.bat",
            defaultMessage: "\u0158\xedzen\xed podle baterie"
        }),
        layout: "list",
        visibility: {
            variableId: 'PV_BATTERY'
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery.on",
                        defaultMessage: "Aktivn\xed"
                    }),
                    switchVariableId: "CLOUD_PLUGS_BATTERY_CONTROLLED",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery.battery_start",
                        defaultMessage: "Zapnout p\u0159i nabit\xed"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery.battery_start.subtitle",
                        defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se aktivuje z\xe1suvka"
                    }),
                    visibility: {
                        variableId: 'CLOUD_PLUGS_BATTERY_CONTROLLED'
                    },
                    variableId: "CLOUD_PLUGS_BATTERY_START",
                    opts: {
                        style: 'percent',
                        maximumFractionDigits: 0
                    },
                    min: 20,
                    max: 99
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery.battery_stop",
                        defaultMessage: "Vypnout p\u0159i nabit\xed"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery.battery_stop.subtitle",
                        defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se vypne z\xe1suvka"
                    }),
                    visibility: {
                        variableId: 'CLOUD_PLUGS_BATTERY_CONTROLLED'
                    },
                    variableId: "CLOUD_PLUGS_BATTERY_STOP",
                    opts: {
                        style: 'percent',
                        maximumFractionDigits: 0
                    },
                    min: 20
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                    type: "row",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.battery_charged",
                        defaultMessage: "Nabit\xed baterie"
                    }),
                    value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                        variableId: "PV_ACTUAL_SOC",
                        opts: {
                            style: 'percent',
                            maximumFractionDigits: 0
                        }
                    }),
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                    visibility: {
                        variableIds: [
                            'PV_BATTERY',
                            'CLOUD_PLUGS_BATTERY_CONTROLLED'
                        ]
                    }
                })
            ]
        })
    });
};
const $fc5b3be5a496799d$var$CloudPlugsControlCondition = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        visibility: {
            variableIds: [
                'CLOUD_PLUGS_BATTERY_CONTROLLED',
                'CLOUD_PLUGS_TIME_CONTROLLED',
                'CLOUD_PLUGS_OVERFLOW_CONTROLLED'
            ]
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "cloud_plugs.condition",
                defaultMessage: "Podm\xednka"
            }),
            selectVariableId: "CLOUD_PLUGS_CONTROL_CONDITION",
            options: [
                {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.condition.and",
                        defaultMessage: "A"
                    }),
                    value: 'and'
                },
                {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.condition.or",
                        defaultMessage: "Nebo"
                    }),
                    value: 'or'
                }
            ],
            fullWidth: true
        })
    });
};
const $fc5b3be5a496799d$var$CloudPlugsTime = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "cloud_plugs.time",
            defaultMessage: "\u0158\xedzen\xed podle \u010Dasu"
        }),
        layout: "list",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.time.on",
                        defaultMessage: "Aktivn\xed"
                    }),
                    switchVariableId: "CLOUD_PLUGS_TIME_CONTROLLED",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    type: "time",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.turn_on",
                        defaultMessage: "Zapnout"
                    }),
                    variableId: "CLOUD_PLUGS_TIME_START",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_TIME_CONTROLLED'
                    },
                    track: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    type: "time",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.turn_off",
                        defaultMessage: "Vypnout"
                    }),
                    variableId: "CLOUD_PLUGS_TIME_STOP",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_TIME_CONTROLLED'
                    },
                    track: false
                })
            ]
        })
    });
};
const $fc5b3be5a496799d$var$CloudPlugsOverflow = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.overflow",
                    defaultMessage: "\u0158\xedzen\xed podle p\u0159etoku"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                    variant: "dialog",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.overflow",
                        defaultMessage: "\u0158\xedzen\xed podle p\u0159etoku"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.overflow.help",
                        defaultMessage: "Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m p\u0159etoku do distribu\u010Dn\xed s\xedt\u011B."
                    })
                })
            ]
        }),
        layout: "list",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.overflow.on",
                        defaultMessage: "Aktivn\xed"
                    }),
                    switchVariableId: "CLOUD_PLUGS_OVERFLOW_CONTROLLED",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "cloud_plugs.overflow.startPower",
                                defaultMessage: "Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                variant: "dialog",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.overflow.startPower",
                                    defaultMessage: "Zapnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                }),
                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.overflow.startPower.help",
                                    defaultMessage: "Z\xe1suvka se zapne, pokud je p\u0159etok v nastaven\xe9 v\xfd\u0161i po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na - 1500W a zpo\u017Ed\u011Bn\xed zapnut\xed je 5 minut, tak z\xe1suvka sepne p\u0159i p\u0159etoku do s\xedt\u011B ve v\xfd\u0161i alespo\u0148 1500W po dobu 5 minut."
                                })
                            })
                        ]
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.overflow.startPower.subtitle",
                        defaultMessage: "Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br"
                    }),
                    variableId: "CLOUD_PLUGS_OVERFLOW_START_POWER",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_OVERFLOW_CONTROLLED'
                    },
                    opts: {
                        style: 'unit',
                        unit: 'kilowatt',
                        maximumFractionDigits: 1
                    },
                    step: 0.1,
                    min: -15,
                    max: 0,
                    track: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "cloud_plugs.overflow.stopPower",
                                defaultMessage: "Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                variant: "dialog",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.overflow.stopPower",
                                    defaultMessage: "Vypnout p\u0159i odb\u011Bru ze s\xedt\u011B"
                                }),
                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.overflow.stopPower.help",
                                    defaultMessage: "Z\xe1suvka se vypne, pokud je odb\u011Br vy\u0161\u0161\xed ne\u017E nastaven\xfd po definovan\xfd interval zpo\u017Ed\u011Bn\xed. Pokud je hodnota nastavena na 100W a zpo\u017Ed\u011Bn\xed vypnut\xed je 5 minut, tak z\xe1suvka vypne p\u0159i odb\u011Bru ze s\xedt\u011B ve v\xfd\u0161i minim\xe1ln\u011B 100W po dobu 5 minut."
                                })
                            })
                        ]
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.overflow.stopPower.subtitle",
                        defaultMessage: "Z\xe1porn\xe1 hodnota je p\u0159etok, kladn\xe1 hodnota je odb\u011Br"
                    }),
                    variableId: "CLOUD_PLUGS_OVERFLOW_STOP_POWER",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_OVERFLOW_CONTROLLED'
                    },
                    opts: {
                        style: 'unit',
                        unit: 'kilowatt',
                        maximumFractionDigits: 1
                    },
                    step: 0.1,
                    min: -10,
                    max: 5,
                    track: false
                })
            ]
        })
    });
};
const $fc5b3be5a496799d$var$CloudPlugsPVPower = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.pv_power",
                    defaultMessage: "\u0158\xedzen\xed podle v\xfdkonu FVE"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                    variant: "dialog",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.pv_power",
                        defaultMessage: "\u0158\xedzen\xed podle v\xfdkonu FVE"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.pv_power.help",
                        defaultMessage: "Zap\xedn\xe1n\xed z\xe1suvky p\u0159i definovan\xe9m v\xfdkonu FVE."
                    })
                })
            ]
        }),
        layout: "list",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.pv_power.on",
                        defaultMessage: "Aktivn\xed"
                    }),
                    switchVariableId: "CLOUD_PLUGS_PV_POWER_CONTROLLED",
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "cloud_plugs.pv_power.startPower",
                                defaultMessage: "Zapnout p\u0159i v\xfdrob\u011B FVE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                variant: "dialog",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.pv_power.startPower",
                                    defaultMessage: "Zapnout p\u0159i v\xfdrob\u011B FVE"
                                }),
                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.pv_power.startPower.help",
                                    defaultMessage: "Z\xe1suvka se zapne, pokud je v\xfdkon FVE v\u011Bt\u0161\xed ne\u017E nastaven\xe1 hodnota. Pokud je hodnota nastavena na 1000W, tak se z\xe1suvka sepne p\u0159i v\xfdrob\u011B FVE ve v\xfd\u0161i alespo\u0148 1000W."
                                })
                            })
                        ]
                    }),
                    variableId: "CLOUD_PLUGS_PV_POWER_START_POWER",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_PV_POWER_CONTROLLED'
                    },
                    opts: {
                        style: 'unit',
                        unit: 'kilowatt',
                        maximumFractionDigits: 1
                    },
                    step: 0.1,
                    min: 0,
                    max: 50,
                    track: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "cloud_plugs.pv_power.stopPower",
                                defaultMessage: "Vypnout p\u0159i v\xfdrob\u011B FVE"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aZOrF.HelpButton), {
                                variant: "dialog",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.pv_power.stopPower",
                                    defaultMessage: "Vypnout p\u0159i v\xfdrob\u011B FVE"
                                }),
                                content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "cloud_plugs.pv_power.stopPower.help",
                                    defaultMessage: "Z\xe1suvka se vypne, pokud je v\xfdkon FVE men\u0161\xed ne\u017E nastaven\xe1 hodnota. Pokud je hodnota nastavena na 500W, tak se z\xe1suvka vypne p\u0159i v\xfdrob\u011B FVE ni\u017E\u0161\xed ne\u017E 500W."
                                })
                            })
                        ]
                    }),
                    variableId: "CLOUD_PLUGS_PV_POWER_STOP_POWER",
                    visibility: {
                        variableId: 'CLOUD_PLUGS_PV_POWER_CONTROLLED'
                    },
                    opts: {
                        style: 'unit',
                        unit: 'kilowatt',
                        maximumFractionDigits: 1
                    },
                    step: 0.1,
                    min: 0,
                    max: 50,
                    track: false
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "photovoltaics.common.power",
                        defaultMessage: "Aktu\xe1ln\xed v\xfdkon"
                    }),
                    value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                        variableId: "PV_ACTUAL_POWER",
                        opts: {
                            style: 'unit',
                            unit: 'kilowatt',
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        }
                    }),
                    visibility: {
                        variableId: 'CLOUD_PLUGS_PV_POWER_CONTROLLED'
                    },
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {}),
                    type: "row"
                })
            ]
        })
    });
};
const $fc5b3be5a496799d$var$CloudPlugsLedMode = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "cloud_plugs.led_mode.title",
            defaultMessage: "LED signalizace"
        }),
        layout: "list",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.battery.switch.title",
                        defaultMessage: "Podsv\xedcen\xed p\u0159i sepnut\xe9 z\xe1suvce"
                    }),
                    switchVariableId: "CLOUD_PLUGS_LED_MODE_SWITCH",
                    fullWidth: true,
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.switch.subtitle",
                        defaultMessage: "Podsv\xedcen\xed aktivn\xed, pokud je z\xe1suvka sepnut\xe1"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.battery.title",
                        defaultMessage: "Podsv\xedcen\xed p\u0159i nabit\xe9 baterii"
                    }),
                    switchVariableId: "CLOUD_PLUGS_LED_MODE_BATTERY",
                    visibility: {
                        variableIds: [
                            {
                                variableId: 'CLOUD_PLUGS_LED_MODE_SWITCH',
                                reversed: true
                            },
                            {
                                variableId: 'PV_BATTERY'
                            }
                        ]
                    },
                    fullWidth: true,
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.battery.subtitle",
                        defaultMessage: "Podsv\xedcen\xed aktivn\xed, pokud m\xe1 baterie alespo\u0148 95%"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.overflow.title",
                        defaultMessage: "Podsv\xedcen\xed p\u0159i p\u0159etoku"
                    }),
                    switchVariableId: "CLOUD_PLUGS_LED_MODE_OVERFLOW",
                    visibility: {
                        variableIds: [
                            {
                                variableId: 'CLOUD_PLUGS_LED_MODE_SWITCH',
                                reversed: true
                            }
                        ]
                    },
                    fullWidth: true,
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "cloud_plugs.led_mode.overflow.subtitle",
                        defaultMessage: "Podsv\xedcen\xed aktivn\xed, pokud dojde ke stabiln\xedmu p\u0159etoku"
                    })
                })
            ]
        })
    });
};
var $fc5b3be5a496799d$export$2e2bcd8739ae039 = $fc5b3be5a496799d$var$CloudPlugs;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $4WLS9 = parcelRequire("4WLS9");
var $7X4mk = parcelRequire("7X4mk");

var $cDXfy = parcelRequire("cDXfy");

var $iH29s = parcelRequire("iH29s");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $5R532 = parcelRequire("5R532");

var $2lSXC = parcelRequire("2lSXC");

var $aphAM = parcelRequire("aphAM");parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $8GoiI = parcelRequire("8GoiI");
var $ngrp2 = parcelRequire("ngrp2");
var $12gtR = parcelRequire("12gtR");
var $7X4mk = parcelRequire("7X4mk");

var $7pTac = parcelRequire("7pTac");
function $38cdb197accefc7f$var$changeJpegDpi(uint8Array, dpi) {
    uint8Array[13] = 1;
    uint8Array[14] = dpi >> 8;
    uint8Array[15] = dpi & 255;
    uint8Array[16] = dpi >> 8;
    uint8Array[17] = dpi & 255;
    return uint8Array;
}
const $38cdb197accefc7f$var$_P = "p".charCodeAt(0);
const $38cdb197accefc7f$var$_H = "H".charCodeAt(0);
const $38cdb197accefc7f$var$_Y = "Y".charCodeAt(0);
const $38cdb197accefc7f$var$_S = "s".charCodeAt(0);
let $38cdb197accefc7f$var$pngDataTable;
function $38cdb197accefc7f$var$createPngDataTable() {
    const crcTable = new Int32Array(256);
    for(let n = 0; n < 256; n++){
        let c = n;
        for(let k = 0; k < 8; k++)c = c & 1 ? 3988292384 ^ c >>> 1 : c >>> 1;
        crcTable[n] = c;
    }
    return crcTable;
}
function $38cdb197accefc7f$var$calcCrc(uint8Array) {
    let c = -1;
    if (!$38cdb197accefc7f$var$pngDataTable) $38cdb197accefc7f$var$pngDataTable = $38cdb197accefc7f$var$createPngDataTable();
    for(let n = 0; n < uint8Array.length; n++)c = $38cdb197accefc7f$var$pngDataTable[(c ^ uint8Array[n]) & 255] ^ c >>> 8;
    return c ^ -1;
}
function $38cdb197accefc7f$var$searchStartOfPhys(uint8Array) {
    const length = uint8Array.length - 1;
    for(let i = length; i >= 4; i--){
        if (uint8Array[i - 4] === 9 && uint8Array[i - 3] === $38cdb197accefc7f$var$_P && uint8Array[i - 2] === $38cdb197accefc7f$var$_H && uint8Array[i - 1] === $38cdb197accefc7f$var$_Y && uint8Array[i] === $38cdb197accefc7f$var$_S) return i - 3;
    }
    return 0;
}
function $38cdb197accefc7f$var$changePngDpi(uint8Array, dpi, overwritepHYs = false) {
    const physChunk = new Uint8Array(13);
    dpi *= 39.3701;
    physChunk[0] = $38cdb197accefc7f$var$_P;
    physChunk[1] = $38cdb197accefc7f$var$_H;
    physChunk[2] = $38cdb197accefc7f$var$_Y;
    physChunk[3] = $38cdb197accefc7f$var$_S;
    physChunk[4] = dpi >>> 24;
    physChunk[5] = dpi >>> 16;
    physChunk[6] = dpi >>> 8;
    physChunk[7] = dpi & 255;
    physChunk[8] = physChunk[4];
    physChunk[9] = physChunk[5];
    physChunk[10] = physChunk[6];
    physChunk[11] = physChunk[7];
    physChunk[12] = 1;
    const crc = $38cdb197accefc7f$var$calcCrc(physChunk);
    const crcChunk = new Uint8Array(4);
    crcChunk[0] = crc >>> 24;
    crcChunk[1] = crc >>> 16;
    crcChunk[2] = crc >>> 8;
    crcChunk[3] = crc & 255;
    if (overwritepHYs) {
        const startingIndex = $38cdb197accefc7f$var$searchStartOfPhys(uint8Array);
        uint8Array.set(physChunk, startingIndex);
        uint8Array.set(crcChunk, startingIndex + 13);
        return uint8Array;
    } else {
        const chunkLength = new Uint8Array(4);
        chunkLength[0] = 0;
        chunkLength[1] = 0;
        chunkLength[2] = 0;
        chunkLength[3] = 9;
        const finalHeader = new Uint8Array(54);
        finalHeader.set(uint8Array, 0);
        finalHeader.set(chunkLength, 33);
        finalHeader.set(physChunk, 37);
        finalHeader.set(crcChunk, 50);
        return finalHeader;
    }
}
const $38cdb197accefc7f$var$b64PhysSignature1 = "AAlwSFlz";
const $38cdb197accefc7f$var$b64PhysSignature2 = "AAAJcEhZ";
const $38cdb197accefc7f$var$b64PhysSignature3 = "AAAACXBI";
function $38cdb197accefc7f$var$detectPhysChunkFromDataUrl(dataUrl) {
    let b64index = dataUrl.indexOf($38cdb197accefc7f$var$b64PhysSignature1);
    if (b64index === -1) b64index = dataUrl.indexOf($38cdb197accefc7f$var$b64PhysSignature2);
    if (b64index === -1) b64index = dataUrl.indexOf($38cdb197accefc7f$var$b64PhysSignature3);
    return b64index;
}
const $38cdb197accefc7f$var$PREFIX = "[modern-screenshot]";
const $38cdb197accefc7f$var$IN_BROWSER = typeof window !== "undefined";
const $38cdb197accefc7f$var$SUPPORT_WEB_WORKER = $38cdb197accefc7f$var$IN_BROWSER && "Worker" in window;
const $38cdb197accefc7f$var$SUPPORT_ATOB = $38cdb197accefc7f$var$IN_BROWSER && "atob" in window;
const $38cdb197accefc7f$var$SUPPORT_BTOA = $38cdb197accefc7f$var$IN_BROWSER && "btoa" in window;
const $38cdb197accefc7f$var$USER_AGENT = $38cdb197accefc7f$var$IN_BROWSER ? window.navigator?.userAgent : "";
const $38cdb197accefc7f$var$IN_CHROME = $38cdb197accefc7f$var$USER_AGENT.includes("Chrome");
const $38cdb197accefc7f$var$IN_SAFARI = $38cdb197accefc7f$var$USER_AGENT.includes("AppleWebKit") && !$38cdb197accefc7f$var$IN_CHROME;
const $38cdb197accefc7f$var$IN_FIREFOX = $38cdb197accefc7f$var$USER_AGENT.includes("Firefox");
const $38cdb197accefc7f$var$isContext = (value)=>value && "__CONTEXT__" in value;
const $38cdb197accefc7f$var$isCssFontFaceRule = (rule)=>rule.constructor.name === "CSSFontFaceRule";
const $38cdb197accefc7f$var$isCSSImportRule = (rule)=>rule.constructor.name === "CSSImportRule";
const $38cdb197accefc7f$var$isElementNode = (node)=>node.nodeType === 1;
const $38cdb197accefc7f$var$isSVGElementNode = (node)=>typeof node.className === "object";
const $38cdb197accefc7f$var$isSVGImageElementNode = (node)=>node.tagName === "image";
const $38cdb197accefc7f$var$isSVGUseElementNode = (node)=>node.tagName === "use";
const $38cdb197accefc7f$var$isHTMLElementNode = (node)=>$38cdb197accefc7f$var$isElementNode(node) && typeof node.style !== "undefined" && !$38cdb197accefc7f$var$isSVGElementNode(node);
const $38cdb197accefc7f$var$isCommentNode = (node)=>node.nodeType === 8;
const $38cdb197accefc7f$var$isTextNode = (node)=>node.nodeType === 3;
const $38cdb197accefc7f$var$isImageElement = (node)=>node.tagName === "IMG";
const $38cdb197accefc7f$var$isVideoElement = (node)=>node.tagName === "VIDEO";
const $38cdb197accefc7f$var$isCanvasElement = (node)=>node.tagName === "CANVAS";
const $38cdb197accefc7f$var$isTextareaElement = (node)=>node.tagName === "TEXTAREA";
const $38cdb197accefc7f$var$isInputElement = (node)=>node.tagName === "INPUT";
const $38cdb197accefc7f$var$isStyleElement = (node)=>node.tagName === "STYLE";
const $38cdb197accefc7f$var$isScriptElement = (node)=>node.tagName === "SCRIPT";
const $38cdb197accefc7f$var$isSelectElement = (node)=>node.tagName === "SELECT";
const $38cdb197accefc7f$var$isSlotElement = (node)=>node.tagName === "SLOT";
const $38cdb197accefc7f$var$isIFrameElement = (node)=>node.tagName === "IFRAME";
const $38cdb197accefc7f$var$consoleWarn = (...args)=>console.warn($38cdb197accefc7f$var$PREFIX, ...args);
function $38cdb197accefc7f$var$supportWebp(ownerDocument) {
    const canvas = ownerDocument?.createElement?.("canvas");
    if (canvas) canvas.height = canvas.width = 1;
    return Boolean(canvas) && "toDataURL" in canvas && Boolean(canvas.toDataURL("image/webp").includes("image/webp"));
}
const $38cdb197accefc7f$var$isDataUrl = (url)=>url.startsWith("data:");
function $38cdb197accefc7f$var$resolveUrl(url, baseUrl) {
    if (url.match(/^[a-z]+:\/\//i)) return url;
    if ($38cdb197accefc7f$var$IN_BROWSER && url.match(/^\/\//)) return window.location.protocol + url;
    if (url.match(/^[a-z]+:/i)) return url;
    if (!$38cdb197accefc7f$var$IN_BROWSER) return url;
    const doc = $38cdb197accefc7f$var$getDocument().implementation.createHTMLDocument();
    const base = doc.createElement("base");
    const a = doc.createElement("a");
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) base.href = baseUrl;
    a.href = url;
    return a.href;
}
function $38cdb197accefc7f$var$getDocument(target) {
    return (target && $38cdb197accefc7f$var$isElementNode(target) ? target?.ownerDocument : target) ?? window.document;
}
const $38cdb197accefc7f$var$XMLNS = "http://www.w3.org/2000/svg";
function $38cdb197accefc7f$var$createSvg(width, height, ownerDocument) {
    const svg = $38cdb197accefc7f$var$getDocument(ownerDocument).createElementNS($38cdb197accefc7f$var$XMLNS, "svg");
    svg.setAttributeNS(null, "width", width.toString());
    svg.setAttributeNS(null, "height", height.toString());
    svg.setAttributeNS(null, "viewBox", `0 0 ${width} ${height}`);
    return svg;
}
function $38cdb197accefc7f$var$svgToDataUrl(svg, removeControlCharacter) {
    let xhtml = new XMLSerializer().serializeToString(svg);
    if (removeControlCharacter) xhtml = xhtml.replace(/[\u0000-\u0008\v\f\u000E-\u001F\uD800-\uDFFF\uFFFE\uFFFF]/gu, "");
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xhtml)}`;
}
async function $38cdb197accefc7f$var$canvasToBlob(canvas, type = "image/png", quality = 1) {
    try {
        return await new Promise((resolve, reject)=>{
            canvas.toBlob((blob)=>{
                if (blob) resolve(blob);
                else reject(new Error("Blob is null"));
            }, type, quality);
        });
    } catch (error) {
        if ($38cdb197accefc7f$var$SUPPORT_ATOB) return $38cdb197accefc7f$var$dataUrlToBlob(canvas.toDataURL(type, quality));
        throw error;
    }
}
function $38cdb197accefc7f$var$dataUrlToBlob(dataUrl) {
    const [header, base64] = dataUrl.split(",");
    const type = header.match(/data:(.+);/)?.[1] ?? void 0;
    const decoded = window.atob(base64);
    const length = decoded.length;
    const buffer = new Uint8Array(length);
    for(let i = 0; i < length; i += 1)buffer[i] = decoded.charCodeAt(i);
    return new Blob([
        buffer
    ], {
        type: type
    });
}
function $38cdb197accefc7f$var$readBlob(blob, type) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = ()=>reject(reader.error);
        reader.onabort = ()=>reject(new Error(`Failed read blob to ${type}`));
        if (type === "dataUrl") reader.readAsDataURL(blob);
        else if (type === "arrayBuffer") reader.readAsArrayBuffer(blob);
    });
}
const $38cdb197accefc7f$var$blobToDataUrl = (blob)=>$38cdb197accefc7f$var$readBlob(blob, "dataUrl");
const $38cdb197accefc7f$var$blobToArrayBuffer = (blob)=>$38cdb197accefc7f$var$readBlob(blob, "arrayBuffer");
function $38cdb197accefc7f$var$createImage(url, ownerDocument) {
    const img = $38cdb197accefc7f$var$getDocument(ownerDocument).createElement("img");
    img.decoding = "sync";
    img.loading = "eager";
    img.src = url;
    return img;
}
function $38cdb197accefc7f$export$f120279a1eb30021(media, options) {
    return new Promise((resolve)=>{
        const { timeout: timeout, ownerDocument: ownerDocument, onError: userOnError, onWarn: onWarn } = options ?? {};
        const node = typeof media === "string" ? $38cdb197accefc7f$var$createImage(media, $38cdb197accefc7f$var$getDocument(ownerDocument)) : media;
        let timer = null;
        let removeEventListeners = null;
        function onResolve() {
            resolve(node);
            timer && clearTimeout(timer);
            removeEventListeners?.();
        }
        if (timeout) timer = setTimeout(onResolve, timeout);
        if ($38cdb197accefc7f$var$isVideoElement(node)) {
            const currentSrc = node.currentSrc || node.src;
            if (!currentSrc) {
                if (node.poster) return $38cdb197accefc7f$export$f120279a1eb30021(node.poster, options).then(resolve);
                return onResolve();
            }
            if (node.readyState >= 2) return onResolve();
            const onLoadeddata = onResolve;
            const onError = (error)=>{
                onWarn?.("Failed video load", currentSrc, error);
                userOnError?.(error);
                onResolve();
            };
            removeEventListeners = ()=>{
                node.removeEventListener("loadeddata", onLoadeddata);
                node.removeEventListener("error", onError);
            };
            node.addEventListener("loadeddata", onLoadeddata, {
                once: true
            });
            node.addEventListener("error", onError, {
                once: true
            });
        } else {
            const currentSrc = $38cdb197accefc7f$var$isSVGImageElementNode(node) ? node.href.baseVal : node.currentSrc || node.src;
            if (!currentSrc) return onResolve();
            const onLoad = async ()=>{
                if ($38cdb197accefc7f$var$isImageElement(node) && "decode" in node) try {
                    await node.decode();
                } catch (error) {
                    onWarn?.("Failed to decode image, trying to render anyway", node.dataset.originalSrc || currentSrc, error);
                }
                onResolve();
            };
            const onError = (error)=>{
                onWarn?.("Failed image load", node.dataset.originalSrc || currentSrc, error);
                onResolve();
            };
            if ($38cdb197accefc7f$var$isImageElement(node) && node.complete) return onLoad();
            removeEventListeners = ()=>{
                node.removeEventListener("load", onLoad);
                node.removeEventListener("error", onError);
            };
            node.addEventListener("load", onLoad, {
                once: true
            });
            node.addEventListener("error", onError, {
                once: true
            });
        }
    });
}
async function $38cdb197accefc7f$export$db7a0793f0443e46(node, options) {
    if ($38cdb197accefc7f$var$isHTMLElementNode(node)) {
        if ($38cdb197accefc7f$var$isImageElement(node) || $38cdb197accefc7f$var$isVideoElement(node)) await $38cdb197accefc7f$export$f120279a1eb30021(node, options);
        else await Promise.all([
            "img",
            "video"
        ].flatMap((selectors)=>{
            return Array.from(node.querySelectorAll(selectors)).map((el)=>$38cdb197accefc7f$export$f120279a1eb30021(el, options));
        }));
    }
}
const $38cdb197accefc7f$var$uuid = /* @__PURE__ */ function uuid2() {
    let counter = 0;
    const random = ()=>`0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4);
    return ()=>{
        counter += 1;
        return `u${random()}${counter}`;
    };
}();
function $38cdb197accefc7f$var$splitFontFamily(fontFamily) {
    return fontFamily?.split(",").map((val)=>val.trim().replace(/"|'/g, "").toLowerCase()).filter(Boolean);
}
let $38cdb197accefc7f$var$uid = 0;
function $38cdb197accefc7f$var$createLogger(debug) {
    const prefix = `${$38cdb197accefc7f$var$PREFIX}[#${$38cdb197accefc7f$var$uid}]`;
    $38cdb197accefc7f$var$uid++;
    return {
        // eslint-disable-next-line no-console
        time: (label)=>debug && console.time(`${prefix} ${label}`),
        // eslint-disable-next-line no-console
        timeEnd: (label)=>debug && console.timeEnd(`${prefix} ${label}`),
        warn: (...args)=>debug && $38cdb197accefc7f$var$consoleWarn(...args)
    };
}
function $38cdb197accefc7f$var$getDefaultRequestInit(bypassingCache) {
    return {
        cache: bypassingCache ? "no-cache" : "force-cache"
    };
}
async function $38cdb197accefc7f$var$orCreateContext(node, options) {
    return $38cdb197accefc7f$var$isContext(node) ? node : $38cdb197accefc7f$export$fd42f52fd3ae1109(node, {
        ...options,
        autoDestruct: true
    });
}
async function $38cdb197accefc7f$export$fd42f52fd3ae1109(node, options) {
    const { scale: scale = 1, workerUrl: workerUrl, workerNumber: workerNumber = 1 } = options || {};
    const debug = Boolean(options?.debug);
    const features = options?.features ?? true;
    const ownerDocument = node.ownerDocument ?? ($38cdb197accefc7f$var$IN_BROWSER ? window.document : void 0);
    const ownerWindow = node.ownerDocument?.defaultView ?? ($38cdb197accefc7f$var$IN_BROWSER ? window : void 0);
    const requests = /* @__PURE__ */ new Map();
    const context = {
        // Options
        width: 0,
        height: 0,
        quality: 1,
        type: "image/png",
        scale: scale,
        backgroundColor: null,
        style: null,
        filter: null,
        maximumCanvasSize: 0,
        timeout: 3e4,
        progress: null,
        debug: debug,
        fetch: {
            requestInit: $38cdb197accefc7f$var$getDefaultRequestInit(options?.fetch?.bypassingCache),
            placeholderImage: "data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
            bypassingCache: false,
            ...options?.fetch
        },
        fetchFn: null,
        font: {},
        drawImageInterval: 100,
        workerUrl: null,
        workerNumber: workerNumber,
        onCloneEachNode: null,
        onCloneNode: null,
        onEmbedNode: null,
        onCreateForeignObjectSvg: null,
        includeStyleProperties: null,
        autoDestruct: false,
        ...options,
        // InternalContext
        __CONTEXT__: true,
        log: $38cdb197accefc7f$var$createLogger(debug),
        node: node,
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        dpi: scale === 1 ? null : 96 * scale,
        svgStyleElement: $38cdb197accefc7f$var$createStyleElement(ownerDocument),
        svgDefsElement: ownerDocument?.createElementNS($38cdb197accefc7f$var$XMLNS, "defs"),
        svgStyles: /* @__PURE__ */ new Map(),
        defaultComputedStyles: /* @__PURE__ */ new Map(),
        workers: [
            ...Array.from({
                length: $38cdb197accefc7f$var$SUPPORT_WEB_WORKER && workerUrl && workerNumber ? workerNumber : 0
            })
        ].map(()=>{
            try {
                const worker = new Worker(workerUrl);
                worker.onmessage = async (event)=>{
                    const { url: url, result: result } = event.data;
                    if (result) requests.get(url)?.resolve?.(result);
                    else requests.get(url)?.reject?.(new Error(`Error receiving message from worker: ${url}`));
                };
                worker.onmessageerror = (event)=>{
                    const { url: url } = event.data;
                    requests.get(url)?.reject?.(new Error(`Error receiving message from worker: ${url}`));
                };
                return worker;
            } catch (error) {
                context.log.warn("Failed to new Worker", error);
                return null;
            }
        }).filter(Boolean),
        fontFamilies: /* @__PURE__ */ new Map(),
        fontCssTexts: /* @__PURE__ */ new Map(),
        acceptOfImage: `${[
            $38cdb197accefc7f$var$supportWebp(ownerDocument) && "image/webp",
            "image/svg+xml",
            "image/*",
            "*/*"
        ].filter(Boolean).join(",")};q=0.8`,
        requests: requests,
        drawImageCount: 0,
        tasks: [],
        features: features,
        isEnable: (key)=>{
            if (key === "restoreScrollPosition") return typeof features === "boolean" ? false : features[key] ?? false;
            if (typeof features === "boolean") return features;
            return features[key] ?? true;
        },
        shadowRoots: []
    };
    context.log.time("wait until load");
    await $38cdb197accefc7f$export$db7a0793f0443e46(node, {
        timeout: context.timeout,
        onWarn: context.log.warn
    });
    context.log.timeEnd("wait until load");
    const { width: width, height: height } = $38cdb197accefc7f$var$resolveBoundingBox(node, context);
    context.width = width;
    context.height = height;
    return context;
}
function $38cdb197accefc7f$var$createStyleElement(ownerDocument) {
    if (!ownerDocument) return void 0;
    const style = ownerDocument.createElement("style");
    const cssText = style.ownerDocument.createTextNode(`
.______background-clip--text {
  background-clip: text;
  -webkit-background-clip: text;
}
`);
    style.appendChild(cssText);
    return style;
}
function $38cdb197accefc7f$var$resolveBoundingBox(node, context) {
    let { width: width, height: height } = context;
    if ($38cdb197accefc7f$var$isElementNode(node) && (!width || !height)) {
        const box = node.getBoundingClientRect();
        width = width || box.width || Number(node.getAttribute("width")) || 0;
        height = height || box.height || Number(node.getAttribute("height")) || 0;
    }
    return {
        width: width,
        height: height
    };
}
async function $38cdb197accefc7f$var$imageToCanvas(image, context) {
    const { log: log, timeout: timeout, drawImageCount: drawImageCount, drawImageInterval: drawImageInterval } = context;
    log.time("image to canvas");
    const loaded = await $38cdb197accefc7f$export$f120279a1eb30021(image, {
        timeout: timeout,
        onWarn: context.log.warn
    });
    const { canvas: canvas, context2d: context2d } = $38cdb197accefc7f$var$createCanvas(image.ownerDocument, context);
    const drawImage = ()=>{
        try {
            context2d?.drawImage(loaded, 0, 0, canvas.width, canvas.height);
        } catch (error) {
            context.log.warn("Failed to drawImage", error);
        }
    };
    drawImage();
    if (context.isEnable("fixSvgXmlDecode")) for(let i = 0; i < drawImageCount; i++)await new Promise((resolve)=>{
        setTimeout(()=>{
            context2d?.clearRect(0, 0, canvas.width, canvas.height);
            drawImage();
            resolve();
        }, i + drawImageInterval);
    });
    context.drawImageCount = 0;
    log.timeEnd("image to canvas");
    return canvas;
}
function $38cdb197accefc7f$var$createCanvas(ownerDocument, context) {
    const { width: width, height: height, scale: scale, backgroundColor: backgroundColor, maximumCanvasSize: max } = context;
    const canvas = ownerDocument.createElement("canvas");
    canvas.width = Math.floor(width * scale);
    canvas.height = Math.floor(height * scale);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    if (max) {
        if (canvas.width > max || canvas.height > max) {
            if (canvas.width > max && canvas.height > max) {
                if (canvas.width > canvas.height) {
                    canvas.height *= max / canvas.width;
                    canvas.width = max;
                } else {
                    canvas.width *= max / canvas.height;
                    canvas.height = max;
                }
            } else if (canvas.width > max) {
                canvas.height *= max / canvas.width;
                canvas.width = max;
            } else {
                canvas.width *= max / canvas.height;
                canvas.height = max;
            }
        }
    }
    const context2d = canvas.getContext("2d");
    if (context2d && backgroundColor) {
        context2d.fillStyle = backgroundColor;
        context2d.fillRect(0, 0, canvas.width, canvas.height);
    }
    return {
        canvas: canvas,
        context2d: context2d
    };
}
function $38cdb197accefc7f$var$cloneCanvas(canvas, context) {
    if (canvas.ownerDocument) try {
        const dataURL = canvas.toDataURL();
        if (dataURL !== "data:,") return $38cdb197accefc7f$var$createImage(dataURL, canvas.ownerDocument);
    } catch (error) {
        context.log.warn("Failed to clone canvas", error);
    }
    const cloned = canvas.cloneNode(false);
    const ctx = canvas.getContext("2d");
    const clonedCtx = cloned.getContext("2d");
    try {
        if (ctx && clonedCtx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
        return cloned;
    } catch (error) {
        context.log.warn("Failed to clone canvas", error);
    }
    return cloned;
}
function $38cdb197accefc7f$var$cloneIframe(iframe, context) {
    try {
        if (iframe?.contentDocument?.body) return $38cdb197accefc7f$var$cloneNode(iframe.contentDocument.body, context);
    } catch (error) {
        context.log.warn("Failed to clone iframe", error);
    }
    return iframe.cloneNode(false);
}
function $38cdb197accefc7f$var$cloneImage(image) {
    const cloned = image.cloneNode(false);
    if (image.currentSrc && image.currentSrc !== image.src) {
        cloned.src = image.currentSrc;
        cloned.srcset = "";
    }
    if (cloned.loading === "lazy") cloned.loading = "eager";
    return cloned;
}
async function $38cdb197accefc7f$var$cloneVideo(video, context) {
    if (video.ownerDocument && !video.currentSrc && video.poster) return $38cdb197accefc7f$var$createImage(video.poster, video.ownerDocument);
    const cloned = video.cloneNode(false);
    cloned.crossOrigin = "anonymous";
    if (video.currentSrc && video.currentSrc !== video.src) cloned.src = video.currentSrc;
    const ownerDocument = cloned.ownerDocument;
    if (ownerDocument) {
        let canPlay = true;
        await $38cdb197accefc7f$export$f120279a1eb30021(cloned, {
            onError: ()=>canPlay = false,
            onWarn: context.log.warn
        });
        if (!canPlay) {
            if (video.poster) return $38cdb197accefc7f$var$createImage(video.poster, video.ownerDocument);
            return cloned;
        }
        cloned.currentTime = video.currentTime;
        await new Promise((resolve)=>{
            cloned.addEventListener("seeked", resolve, {
                once: true
            });
        });
        const canvas = ownerDocument.createElement("canvas");
        canvas.width = video.offsetWidth;
        canvas.height = video.offsetHeight;
        try {
            const ctx = canvas.getContext("2d");
            if (ctx) ctx.drawImage(cloned, 0, 0, canvas.width, canvas.height);
        } catch (error) {
            context.log.warn("Failed to clone video", error);
            if (video.poster) return $38cdb197accefc7f$var$createImage(video.poster, video.ownerDocument);
            return cloned;
        }
        return $38cdb197accefc7f$var$cloneCanvas(canvas, context);
    }
    return cloned;
}
function $38cdb197accefc7f$var$cloneElement(node, context) {
    if ($38cdb197accefc7f$var$isCanvasElement(node)) return $38cdb197accefc7f$var$cloneCanvas(node, context);
    if ($38cdb197accefc7f$var$isIFrameElement(node)) return $38cdb197accefc7f$var$cloneIframe(node, context);
    if ($38cdb197accefc7f$var$isImageElement(node)) return $38cdb197accefc7f$var$cloneImage(node);
    if ($38cdb197accefc7f$var$isVideoElement(node)) return $38cdb197accefc7f$var$cloneVideo(node, context);
    return node.cloneNode(false);
}
function $38cdb197accefc7f$var$getSandBox(context) {
    let sandbox = context.sandbox;
    if (!sandbox) {
        const { ownerDocument: ownerDocument } = context;
        try {
            if (ownerDocument) {
                sandbox = ownerDocument.createElement("iframe");
                sandbox.id = `__SANDBOX__${$38cdb197accefc7f$var$uuid()}`;
                sandbox.width = "0";
                sandbox.height = "0";
                sandbox.style.visibility = "hidden";
                sandbox.style.position = "fixed";
                ownerDocument.body.appendChild(sandbox);
                sandbox.srcdoc = '<!DOCTYPE html><meta charset="UTF-8"><title></title><body>';
                context.sandbox = sandbox;
            }
        } catch (error) {
            context.log.warn("Failed to getSandBox", error);
        }
    }
    return sandbox;
}
const $38cdb197accefc7f$var$ignoredStyles = [
    "width",
    "height",
    "-webkit-text-fill-color"
];
const $38cdb197accefc7f$var$includedAttributes = [
    "stroke",
    "fill"
];
function $38cdb197accefc7f$var$getDefaultStyle(node, pseudoElement, context) {
    const { defaultComputedStyles: defaultComputedStyles } = context;
    const nodeName = node.nodeName.toLowerCase();
    const isSvgNode = $38cdb197accefc7f$var$isSVGElementNode(node) && nodeName !== "svg";
    const attributes = isSvgNode ? $38cdb197accefc7f$var$includedAttributes.map((name)=>[
            name,
            node.getAttribute(name)
        ]).filter(([, value])=>value !== null) : [];
    const key = [
        isSvgNode && "svg",
        nodeName,
        attributes.map((name, value)=>`${name}=${value}`).join(","),
        pseudoElement
    ].filter(Boolean).join(":");
    if (defaultComputedStyles.has(key)) return defaultComputedStyles.get(key);
    const sandbox = $38cdb197accefc7f$var$getSandBox(context);
    const sandboxWindow = sandbox?.contentWindow;
    if (!sandboxWindow) return /* @__PURE__ */ new Map();
    const sandboxDocument = sandboxWindow?.document;
    let root;
    let el;
    if (isSvgNode) {
        root = sandboxDocument.createElementNS($38cdb197accefc7f$var$XMLNS, "svg");
        el = root.ownerDocument.createElementNS(root.namespaceURI, nodeName);
        attributes.forEach(([name, value])=>{
            el.setAttributeNS(null, name, value);
        });
        root.appendChild(el);
    } else root = el = sandboxDocument.createElement(nodeName);
    el.textContent = " ";
    sandboxDocument.body.appendChild(root);
    const computedStyle = sandboxWindow.getComputedStyle(el, pseudoElement);
    const styles = /* @__PURE__ */ new Map();
    for(let len = computedStyle.length, i = 0; i < len; i++){
        const name = computedStyle.item(i);
        if ($38cdb197accefc7f$var$ignoredStyles.includes(name)) continue;
        styles.set(name, computedStyle.getPropertyValue(name));
    }
    sandboxDocument.body.removeChild(root);
    defaultComputedStyles.set(key, styles);
    return styles;
}
function $38cdb197accefc7f$var$getDiffStyle(style, defaultStyle, includeStyleProperties) {
    const diffStyle = /* @__PURE__ */ new Map();
    const prefixs = [];
    const prefixTree = /* @__PURE__ */ new Map();
    if (includeStyleProperties) for (const name of includeStyleProperties)applyTo(name);
    else for(let len = style.length, i = 0; i < len; i++){
        const name = style.item(i);
        applyTo(name);
    }
    for(let len = prefixs.length, i = 0; i < len; i++)prefixTree.get(prefixs[i])?.forEach((value, name)=>diffStyle.set(name, value));
    function applyTo(name) {
        const value = style.getPropertyValue(name);
        const priority = style.getPropertyPriority(name);
        const subIndex = name.lastIndexOf("-");
        const prefix = subIndex > -1 ? name.substring(0, subIndex) : void 0;
        if (prefix) {
            let map = prefixTree.get(prefix);
            if (!map) {
                map = /* @__PURE__ */ new Map();
                prefixTree.set(prefix, map);
            }
            map.set(name, [
                value,
                priority
            ]);
        }
        if (defaultStyle.get(name) === value && !priority) return;
        if (prefix) prefixs.push(prefix);
        else diffStyle.set(name, [
            value,
            priority
        ]);
    }
    return diffStyle;
}
function $38cdb197accefc7f$var$copyCssStyles(node, cloned, isRoot, context) {
    const { ownerWindow: ownerWindow, includeStyleProperties: includeStyleProperties, currentParentNodeStyle: currentParentNodeStyle } = context;
    const clonedStyle = cloned.style;
    const computedStyle = ownerWindow.getComputedStyle(node);
    const defaultStyle = $38cdb197accefc7f$var$getDefaultStyle(node, null, context);
    currentParentNodeStyle?.forEach((_, key)=>{
        defaultStyle.delete(key);
    });
    const style = $38cdb197accefc7f$var$getDiffStyle(computedStyle, defaultStyle, includeStyleProperties);
    style.delete("transition-property");
    style.delete("all");
    style.delete("d");
    style.delete("content");
    if (isRoot) {
        style.delete("margin-top");
        style.delete("margin-right");
        style.delete("margin-bottom");
        style.delete("margin-left");
        style.delete("margin-block-start");
        style.delete("margin-block-end");
        style.delete("margin-inline-start");
        style.delete("margin-inline-end");
        style.set("box-sizing", [
            "border-box",
            ""
        ]);
    }
    if (style.get("background-clip")?.[0] === "text") cloned.classList.add("______background-clip--text");
    if ($38cdb197accefc7f$var$IN_CHROME) {
        if (!style.has("font-kerning")) style.set("font-kerning", [
            "normal",
            ""
        ]);
        if ((style.get("overflow-x")?.[0] === "hidden" || style.get("overflow-y")?.[0] === "hidden") && style.get("text-overflow")?.[0] === "ellipsis" && node.scrollWidth === node.clientWidth) style.set("text-overflow", [
            "clip",
            ""
        ]);
    }
    for(let len = clonedStyle.length, i = 0; i < len; i++)clonedStyle.removeProperty(clonedStyle.item(i));
    style.forEach(([value, priority], name)=>{
        clonedStyle.setProperty(name, value, priority);
    });
    return style;
}
function $38cdb197accefc7f$var$copyInputValue(node, cloned) {
    if ($38cdb197accefc7f$var$isTextareaElement(node) || $38cdb197accefc7f$var$isInputElement(node) || $38cdb197accefc7f$var$isSelectElement(node)) cloned.setAttribute("value", node.value);
}
const $38cdb197accefc7f$var$pseudoClasses = [
    ":before",
    ":after"
];
const $38cdb197accefc7f$var$scrollbarPseudoClasses = [
    ":-webkit-scrollbar",
    ":-webkit-scrollbar-button",
    // ':-webkit-scrollbar:horizontal', TODO
    ":-webkit-scrollbar-thumb",
    ":-webkit-scrollbar-track",
    ":-webkit-scrollbar-track-piece",
    // ':-webkit-scrollbar:vertical', TODO
    ":-webkit-scrollbar-corner",
    ":-webkit-resizer"
];
function $38cdb197accefc7f$var$copyPseudoClass(node, cloned, copyScrollbar, context, addWordToFontFamilies) {
    const { ownerWindow: ownerWindow, svgStyleElement: svgStyleElement, svgStyles: svgStyles, currentNodeStyle: currentNodeStyle } = context;
    if (!svgStyleElement || !ownerWindow) return;
    function copyBy(pseudoClass) {
        const computedStyle = ownerWindow.getComputedStyle(node, pseudoClass);
        let content = computedStyle.getPropertyValue("content");
        if (!content || content === "none") return;
        addWordToFontFamilies?.(content);
        content = content.replace(/(')|(")|(counter\(.+\))/g, "");
        const klasses = [
            $38cdb197accefc7f$var$uuid()
        ];
        const defaultStyle = $38cdb197accefc7f$var$getDefaultStyle(node, pseudoClass, context);
        currentNodeStyle?.forEach((_, key)=>{
            defaultStyle.delete(key);
        });
        const style = $38cdb197accefc7f$var$getDiffStyle(computedStyle, defaultStyle, context.includeStyleProperties);
        style.delete("content");
        style.delete("-webkit-locale");
        if (style.get("background-clip")?.[0] === "text") cloned.classList.add("______background-clip--text");
        const cloneStyle = [
            `content: '${content}';`
        ];
        style.forEach(([value, priority], name)=>{
            cloneStyle.push(`${name}: ${value}${priority ? " !important" : ""};`);
        });
        if (cloneStyle.length === 1) return;
        try {
            cloned.className = [
                cloned.className,
                ...klasses
            ].join(" ");
        } catch (err) {
            context.log.warn("Failed to copyPseudoClass", err);
            return;
        }
        const cssText = cloneStyle.join("\n  ");
        let allClasses = svgStyles.get(cssText);
        if (!allClasses) {
            allClasses = [];
            svgStyles.set(cssText, allClasses);
        }
        allClasses.push(`.${klasses[0]}:${pseudoClass}`);
    }
    $38cdb197accefc7f$var$pseudoClasses.forEach(copyBy);
    if (copyScrollbar) $38cdb197accefc7f$var$scrollbarPseudoClasses.forEach(copyBy);
}
const $38cdb197accefc7f$var$excludeParentNodes = /* @__PURE__ */ new Set([
    "symbol"
]);
async function $38cdb197accefc7f$var$appendChildNode(node, cloned, child, context, addWordToFontFamilies) {
    if ($38cdb197accefc7f$var$isElementNode(child) && ($38cdb197accefc7f$var$isStyleElement(child) || $38cdb197accefc7f$var$isScriptElement(child))) return;
    if (context.filter && !context.filter(child)) return;
    if ($38cdb197accefc7f$var$excludeParentNodes.has(cloned.nodeName) || $38cdb197accefc7f$var$excludeParentNodes.has(child.nodeName)) context.currentParentNodeStyle = void 0;
    else context.currentParentNodeStyle = context.currentNodeStyle;
    const childCloned = await $38cdb197accefc7f$var$cloneNode(child, context, false, addWordToFontFamilies);
    if (context.isEnable("restoreScrollPosition")) $38cdb197accefc7f$var$restoreScrollPosition(node, childCloned);
    cloned.appendChild(childCloned);
}
async function $38cdb197accefc7f$var$cloneChildNodes(node, cloned, context, addWordToFontFamilies) {
    let firstChild = node.firstChild;
    if ($38cdb197accefc7f$var$isElementNode(node)) {
        if (node.shadowRoot) {
            firstChild = node.shadowRoot?.firstChild;
            context.shadowRoots.push(node.shadowRoot);
        }
    }
    for(let child = firstChild; child; child = child.nextSibling){
        if ($38cdb197accefc7f$var$isCommentNode(child)) continue;
        if ($38cdb197accefc7f$var$isElementNode(child) && $38cdb197accefc7f$var$isSlotElement(child) && typeof child.assignedNodes === "function") {
            const nodes = child.assignedNodes();
            for(let i = 0; i < nodes.length; i++)await $38cdb197accefc7f$var$appendChildNode(node, cloned, nodes[i], context, addWordToFontFamilies);
        } else await $38cdb197accefc7f$var$appendChildNode(node, cloned, child, context, addWordToFontFamilies);
    }
}
function $38cdb197accefc7f$var$restoreScrollPosition(node, chlidCloned) {
    if (!$38cdb197accefc7f$var$isHTMLElementNode(node) || !$38cdb197accefc7f$var$isHTMLElementNode(chlidCloned)) return;
    const { scrollTop: scrollTop, scrollLeft: scrollLeft } = node;
    if (!scrollTop && !scrollLeft) return;
    const { transform: transform } = chlidCloned.style;
    const matrix = new DOMMatrix(transform);
    const { a: a, b: b, c: c, d: d } = matrix;
    matrix.a = 1;
    matrix.b = 0;
    matrix.c = 0;
    matrix.d = 1;
    matrix.translateSelf(-scrollLeft, -scrollTop);
    matrix.a = a;
    matrix.b = b;
    matrix.c = c;
    matrix.d = d;
    chlidCloned.style.transform = matrix.toString();
}
function $38cdb197accefc7f$var$applyCssStyleWithOptions(cloned, context) {
    const { backgroundColor: backgroundColor, width: width, height: height, style: styles } = context;
    const clonedStyle = cloned.style;
    if (backgroundColor) clonedStyle.setProperty("background-color", backgroundColor, "important");
    if (width) clonedStyle.setProperty("width", `${width}px`, "important");
    if (height) clonedStyle.setProperty("height", `${height}px`, "important");
    if (styles) for(const name in styles)clonedStyle[name] = styles[name];
}
const $38cdb197accefc7f$var$NORMAL_ATTRIBUTE_RE = /^[\w-:]+$/;
async function $38cdb197accefc7f$var$cloneNode(node, context, isRoot = false, addWordToFontFamilies) {
    const { ownerDocument: ownerDocument, ownerWindow: ownerWindow, fontFamilies: fontFamilies, onCloneEachNode: onCloneEachNode } = context;
    if (ownerDocument && $38cdb197accefc7f$var$isTextNode(node)) {
        if (addWordToFontFamilies && /\S/.test(node.data)) addWordToFontFamilies(node.data);
        return ownerDocument.createTextNode(node.data);
    }
    if (ownerDocument && ownerWindow && $38cdb197accefc7f$var$isElementNode(node) && ($38cdb197accefc7f$var$isHTMLElementNode(node) || $38cdb197accefc7f$var$isSVGElementNode(node))) {
        const cloned2 = await $38cdb197accefc7f$var$cloneElement(node, context);
        if (context.isEnable("removeAbnormalAttributes")) {
            const names = cloned2.getAttributeNames();
            for(let len = names.length, i = 0; i < len; i++){
                const name = names[i];
                if (!$38cdb197accefc7f$var$NORMAL_ATTRIBUTE_RE.test(name)) cloned2.removeAttribute(name);
            }
        }
        const style = context.currentNodeStyle = $38cdb197accefc7f$var$copyCssStyles(node, cloned2, isRoot, context);
        if (isRoot) $38cdb197accefc7f$var$applyCssStyleWithOptions(cloned2, context);
        let copyScrollbar = false;
        if (context.isEnable("copyScrollbar")) {
            const overflow = [
                style.get("overflow-x")?.[0],
                style.get("overflow-y")?.[0]
            ];
            copyScrollbar = overflow.includes("scroll") || (overflow.includes("auto") || overflow.includes("overlay")) && (node.scrollHeight > node.clientHeight || node.scrollWidth > node.clientWidth);
        }
        const textTransform = style.get("text-transform")?.[0];
        const families = $38cdb197accefc7f$var$splitFontFamily(style.get("font-family")?.[0]);
        const addWordToFontFamilies2 = families ? (word)=>{
            if (textTransform === "uppercase") word = word.toUpperCase();
            else if (textTransform === "lowercase") word = word.toLowerCase();
            else if (textTransform === "capitalize") word = word[0].toUpperCase() + word.substring(1);
            families.forEach((family)=>{
                let fontFamily = fontFamilies.get(family);
                if (!fontFamily) fontFamilies.set(family, fontFamily = /* @__PURE__ */ new Set());
                word.split("").forEach((text)=>fontFamily.add(text));
            });
        } : void 0;
        $38cdb197accefc7f$var$copyPseudoClass(node, cloned2, copyScrollbar, context, addWordToFontFamilies2);
        $38cdb197accefc7f$var$copyInputValue(node, cloned2);
        if (!$38cdb197accefc7f$var$isVideoElement(node)) await $38cdb197accefc7f$var$cloneChildNodes(node, cloned2, context, addWordToFontFamilies2);
        await onCloneEachNode?.(cloned2);
        return cloned2;
    }
    const cloned = node.cloneNode(false);
    await $38cdb197accefc7f$var$cloneChildNodes(node, cloned, context);
    await onCloneEachNode?.(cloned);
    return cloned;
}
function $38cdb197accefc7f$export$348a8a43acd47b6b(context) {
    context.ownerDocument = void 0;
    context.ownerWindow = void 0;
    context.svgStyleElement = void 0;
    context.svgDefsElement = void 0;
    context.svgStyles.clear();
    context.defaultComputedStyles.clear();
    if (context.sandbox) {
        try {
            context.sandbox.remove();
        } catch (err) {
            context.log.warn("Failed to destroyContext", err);
        }
        context.sandbox = void 0;
    }
    context.workers = [];
    context.fontFamilies.clear();
    context.fontCssTexts.clear();
    context.requests.clear();
    context.tasks = [];
    context.shadowRoots = [];
}
function $38cdb197accefc7f$var$baseFetch(options) {
    const { url: url, timeout: timeout, responseType: responseType, ...requestInit } = options;
    const controller = new AbortController();
    const timer = timeout ? setTimeout(()=>controller.abort(), timeout) : void 0;
    return fetch(url, {
        signal: controller.signal,
        ...requestInit
    }).then((response)=>{
        if (!response.ok) throw new Error("Failed fetch, not 2xx response", {
            cause: response
        });
        switch(responseType){
            case "arrayBuffer":
                return response.arrayBuffer();
            case "dataUrl":
                return response.blob().then($38cdb197accefc7f$var$blobToDataUrl);
            case "text":
            default:
                return response.text();
        }
    }).finally(()=>clearTimeout(timer));
}
function $38cdb197accefc7f$var$contextFetch(context, options) {
    const { url: rawUrl, requestType: requestType = "text", responseType: responseType = "text", imageDom: imageDom } = options;
    let url = rawUrl;
    const { timeout: timeout, acceptOfImage: acceptOfImage, requests: requests, fetchFn: fetchFn, fetch: { requestInit: requestInit, bypassingCache: bypassingCache, placeholderImage: placeholderImage }, font: font, workers: workers, fontFamilies: fontFamilies } = context;
    if (requestType === "image" && ($38cdb197accefc7f$var$IN_SAFARI || $38cdb197accefc7f$var$IN_FIREFOX)) context.drawImageCount++;
    let request = requests.get(rawUrl);
    if (!request) {
        if (bypassingCache) {
            if (bypassingCache instanceof RegExp && bypassingCache.test(url)) url += (/\?/.test(url) ? "&" : "?") + /* @__PURE__ */ new Date().getTime();
        }
        const canFontMinify = requestType.startsWith("font") && font && font.minify;
        const fontTexts = /* @__PURE__ */ new Set();
        if (canFontMinify) {
            const families = requestType.split(";")[1].split(",");
            families.forEach((family)=>{
                if (!fontFamilies.has(family)) return;
                fontFamilies.get(family).forEach((text)=>fontTexts.add(text));
            });
        }
        const needFontMinify = canFontMinify && fontTexts.size;
        const baseFetchOptions = {
            url: url,
            timeout: timeout,
            responseType: needFontMinify ? "arrayBuffer" : responseType,
            headers: requestType === "image" ? {
                accept: acceptOfImage
            } : void 0,
            ...requestInit
        };
        request = {
            type: requestType,
            resolve: void 0,
            reject: void 0,
            response: null
        };
        request.response = (async ()=>{
            if (fetchFn && requestType === "image") {
                const result = await fetchFn(rawUrl);
                if (result) return result;
            }
            if (!$38cdb197accefc7f$var$IN_SAFARI && rawUrl.startsWith("http") && workers.length) return new Promise((resolve, reject)=>{
                const worker = workers[requests.size & workers.length - 1];
                worker.postMessage({
                    rawUrl: rawUrl,
                    ...baseFetchOptions
                });
                request.resolve = resolve;
                request.reject = reject;
            });
            return $38cdb197accefc7f$var$baseFetch(baseFetchOptions);
        })().catch((error)=>{
            requests.delete(rawUrl);
            if (requestType === "image" && placeholderImage) {
                context.log.warn("Failed to fetch image base64, trying to use placeholder image", url);
                return typeof placeholderImage === "string" ? placeholderImage : placeholderImage(imageDom);
            }
            throw error;
        });
        requests.set(rawUrl, request);
    }
    return request.response;
}
async function $38cdb197accefc7f$var$replaceCssUrlToDataUrl(cssText, baseUrl, context, isImage) {
    if (!$38cdb197accefc7f$var$hasCssUrl(cssText)) return cssText;
    for (const [rawUrl, url] of $38cdb197accefc7f$var$parseCssUrls(cssText, baseUrl))try {
        const dataUrl = await $38cdb197accefc7f$var$contextFetch(context, {
            url: url,
            requestType: isImage ? "image" : "text",
            responseType: "dataUrl"
        });
        cssText = cssText.replace($38cdb197accefc7f$var$toRE(rawUrl), `$1${dataUrl}$3`);
    } catch (error) {
        context.log.warn("Failed to fetch css data url", rawUrl, error);
    }
    return cssText;
}
function $38cdb197accefc7f$var$hasCssUrl(cssText) {
    return /url\((['"]?)([^'"]+?)\1\)/.test(cssText);
}
const $38cdb197accefc7f$var$URL_RE = /url\((['"]?)([^'"]+?)\1\)/g;
function $38cdb197accefc7f$var$parseCssUrls(cssText, baseUrl) {
    const result = [];
    cssText.replace($38cdb197accefc7f$var$URL_RE, (raw, quotation, url)=>{
        result.push([
            url,
            $38cdb197accefc7f$var$resolveUrl(url, baseUrl)
        ]);
        return raw;
    });
    return result.filter(([url])=>!$38cdb197accefc7f$var$isDataUrl(url));
}
function $38cdb197accefc7f$var$toRE(url) {
    const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
    return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, "g");
}
const $38cdb197accefc7f$var$properties = [
    "background-image",
    "border-image-source",
    "-webkit-border-image",
    "-webkit-mask-image",
    "list-style-image"
];
function $38cdb197accefc7f$var$embedCssStyleImage(style, context) {
    return $38cdb197accefc7f$var$properties.map((property)=>{
        const value = style.getPropertyValue(property);
        if (!value || value === "none") return null;
        if ($38cdb197accefc7f$var$IN_SAFARI || $38cdb197accefc7f$var$IN_FIREFOX) context.drawImageCount++;
        return $38cdb197accefc7f$var$replaceCssUrlToDataUrl(value, null, context, true).then((newValue)=>{
            if (!newValue || value === newValue) return;
            style.setProperty(property, newValue, style.getPropertyPriority(property));
        });
    }).filter(Boolean);
}
function $38cdb197accefc7f$var$embedImageElement(cloned, context) {
    if ($38cdb197accefc7f$var$isImageElement(cloned)) {
        const originalSrc = cloned.currentSrc || cloned.src;
        if (!$38cdb197accefc7f$var$isDataUrl(originalSrc)) return [
            $38cdb197accefc7f$var$contextFetch(context, {
                url: originalSrc,
                imageDom: cloned,
                requestType: "image",
                responseType: "dataUrl"
            }).then((url)=>{
                if (!url) return;
                cloned.srcset = "";
                cloned.dataset.originalSrc = originalSrc;
                cloned.src = url || "";
            })
        ];
        if ($38cdb197accefc7f$var$IN_SAFARI || $38cdb197accefc7f$var$IN_FIREFOX) context.drawImageCount++;
    } else if ($38cdb197accefc7f$var$isSVGElementNode(cloned) && !$38cdb197accefc7f$var$isDataUrl(cloned.href.baseVal)) {
        const originalSrc = cloned.href.baseVal;
        return [
            $38cdb197accefc7f$var$contextFetch(context, {
                url: originalSrc,
                imageDom: cloned,
                requestType: "image",
                responseType: "dataUrl"
            }).then((url)=>{
                if (!url) return;
                cloned.dataset.originalSrc = originalSrc;
                cloned.href.baseVal = url || "";
            })
        ];
    }
    return [];
}
function $38cdb197accefc7f$var$embedSvgUse(cloned, context) {
    const { ownerDocument: ownerDocument, svgDefsElement: svgDefsElement } = context;
    const href = cloned.getAttribute("href") ?? cloned.getAttribute("xlink:href");
    if (!href) return [];
    const [svgUrl, id] = href.split("#");
    if (id) {
        const query = `#${id}`;
        const definition = context.shadowRoots.reduce((res, root)=>{
            return res ?? root.querySelector(`svg ${query}`);
        }, ownerDocument?.querySelector(`svg ${query}`));
        if (svgUrl) cloned.setAttribute("href", query);
        if (svgDefsElement?.querySelector(query)) return [];
        if (definition) {
            svgDefsElement?.appendChild(definition.cloneNode(true));
            return [];
        } else if (svgUrl) return [
            $38cdb197accefc7f$var$contextFetch(context, {
                url: svgUrl,
                responseType: "text"
            }).then((svgData)=>{
                svgDefsElement?.insertAdjacentHTML("beforeend", svgData);
            })
        ];
    }
    return [];
}
function $38cdb197accefc7f$var$embedNode(cloned, context) {
    const { tasks: tasks } = context;
    if ($38cdb197accefc7f$var$isElementNode(cloned)) {
        if ($38cdb197accefc7f$var$isImageElement(cloned) || $38cdb197accefc7f$var$isSVGImageElementNode(cloned)) tasks.push(...$38cdb197accefc7f$var$embedImageElement(cloned, context));
        if ($38cdb197accefc7f$var$isSVGUseElementNode(cloned)) tasks.push(...$38cdb197accefc7f$var$embedSvgUse(cloned, context));
    }
    if ($38cdb197accefc7f$var$isHTMLElementNode(cloned)) tasks.push(...$38cdb197accefc7f$var$embedCssStyleImage(cloned.style, context));
    cloned.childNodes.forEach((child)=>{
        $38cdb197accefc7f$var$embedNode(child, context);
    });
}
async function $38cdb197accefc7f$var$embedWebFont(clone, context) {
    const { ownerDocument: ownerDocument, svgStyleElement: svgStyleElement, fontFamilies: fontFamilies, fontCssTexts: fontCssTexts, tasks: tasks, font: font } = context;
    if (!ownerDocument || !svgStyleElement || !fontFamilies.size) return;
    if (font && font.cssText) {
        const cssText = $38cdb197accefc7f$var$filterPreferredFormat(font.cssText, context);
        svgStyleElement.appendChild(ownerDocument.createTextNode(`${cssText}
`));
    } else {
        const styleSheets = Array.from(ownerDocument.styleSheets).filter((styleSheet)=>{
            try {
                return "cssRules" in styleSheet && Boolean(styleSheet.cssRules.length);
            } catch (error) {
                context.log.warn(`Error while reading CSS rules from ${styleSheet.href}`, error);
                return false;
            }
        });
        await Promise.all(styleSheets.flatMap((styleSheet)=>{
            return Array.from(styleSheet.cssRules).map(async (cssRule, index)=>{
                if ($38cdb197accefc7f$var$isCSSImportRule(cssRule)) {
                    let importIndex = index + 1;
                    const baseUrl = cssRule.href;
                    let cssText = "";
                    try {
                        cssText = await $38cdb197accefc7f$var$contextFetch(context, {
                            url: baseUrl,
                            requestType: "text",
                            responseType: "text"
                        });
                    } catch (error) {
                        context.log.warn(`Error fetch remote css import from ${baseUrl}`, error);
                    }
                    const replacedCssText = cssText.replace($38cdb197accefc7f$var$URL_RE, (raw, quotation, url)=>raw.replace(url, $38cdb197accefc7f$var$resolveUrl(url, baseUrl)));
                    for (const rule of $38cdb197accefc7f$var$parseCss(replacedCssText))try {
                        styleSheet.insertRule(rule, rule.startsWith("@import") ? importIndex += 1 : styleSheet.cssRules.length);
                    } catch (error) {
                        context.log.warn("Error inserting rule from remote css import", {
                            rule: rule,
                            error: error
                        });
                    }
                }
            });
        }));
        const cssRules = styleSheets.flatMap((styleSheet)=>Array.from(styleSheet.cssRules));
        cssRules.filter((cssRule)=>$38cdb197accefc7f$var$isCssFontFaceRule(cssRule) && $38cdb197accefc7f$var$hasCssUrl(cssRule.style.getPropertyValue("src")) && $38cdb197accefc7f$var$splitFontFamily(cssRule.style.getPropertyValue("font-family"))?.some((val)=>fontFamilies.has(val))).forEach((value)=>{
            const rule = value;
            const cssText = fontCssTexts.get(rule.cssText);
            if (cssText) svgStyleElement.appendChild(ownerDocument.createTextNode(`${cssText}
`));
            else tasks.push($38cdb197accefc7f$var$replaceCssUrlToDataUrl(rule.cssText, rule.parentStyleSheet ? rule.parentStyleSheet.href : null, context).then((cssText2)=>{
                cssText2 = $38cdb197accefc7f$var$filterPreferredFormat(cssText2, context);
                fontCssTexts.set(rule.cssText, cssText2);
                svgStyleElement.appendChild(ownerDocument.createTextNode(`${cssText2}
`));
            }));
        });
    }
}
const $38cdb197accefc7f$var$COMMENTS_RE = /(\/\*[\s\S]*?\*\/)/g;
const $38cdb197accefc7f$var$KEYFRAMES_RE = /((@.*?keyframes [\s\S]*?){([\s\S]*?}\s*?)})/gi;
function $38cdb197accefc7f$var$parseCss(source) {
    if (source == null) return [];
    const result = [];
    let cssText = source.replace($38cdb197accefc7f$var$COMMENTS_RE, "");
    while(true){
        const matches = $38cdb197accefc7f$var$KEYFRAMES_RE.exec(cssText);
        if (!matches) break;
        result.push(matches[0]);
    }
    cssText = cssText.replace($38cdb197accefc7f$var$KEYFRAMES_RE, "");
    const IMPORT_RE = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    const UNIFIED_RE = new RegExp(// eslint-disable-next-line
    "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", "gi");
    while(true){
        let matches = IMPORT_RE.exec(cssText);
        if (!matches) {
            matches = UNIFIED_RE.exec(cssText);
            if (!matches) break;
            else IMPORT_RE.lastIndex = UNIFIED_RE.lastIndex;
        } else UNIFIED_RE.lastIndex = IMPORT_RE.lastIndex;
        result.push(matches[0]);
    }
    return result;
}
const $38cdb197accefc7f$var$URL_WITH_FORMAT_RE = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
const $38cdb197accefc7f$var$FONT_SRC_RE = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function $38cdb197accefc7f$var$filterPreferredFormat(str, context) {
    const { font: font } = context;
    const preferredFormat = font ? font?.preferredFormat : void 0;
    return preferredFormat ? str.replace($38cdb197accefc7f$var$FONT_SRC_RE, (match)=>{
        while(true){
            const [src, , format] = $38cdb197accefc7f$var$URL_WITH_FORMAT_RE.exec(match) || [];
            if (!format) return "";
            if (format === preferredFormat) return `src: ${src};`;
        }
    }) : str;
}
async function $38cdb197accefc7f$export$d8480a58b7a3de57(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    if ($38cdb197accefc7f$var$isElementNode(context.node) && $38cdb197accefc7f$var$isSVGElementNode(context.node)) return context.node;
    const { ownerDocument: ownerDocument, log: log, tasks: tasks, svgStyleElement: svgStyleElement, svgDefsElement: svgDefsElement, svgStyles: svgStyles, font: font, progress: progress, autoDestruct: autoDestruct, onCloneNode: onCloneNode, onEmbedNode: onEmbedNode, onCreateForeignObjectSvg: onCreateForeignObjectSvg } = context;
    log.time("clone node");
    const clone = await $38cdb197accefc7f$var$cloneNode(context.node, context, true);
    if (svgStyleElement && ownerDocument) {
        let allCssText = "";
        svgStyles.forEach((klasses, cssText)=>{
            allCssText += `${klasses.join(",\n")} {
  ${cssText}
}
`;
        });
        svgStyleElement.appendChild(ownerDocument.createTextNode(allCssText));
    }
    log.timeEnd("clone node");
    await onCloneNode?.(clone);
    if (font !== false && $38cdb197accefc7f$var$isElementNode(clone)) {
        log.time("embed web font");
        await $38cdb197accefc7f$var$embedWebFont(clone, context);
        log.timeEnd("embed web font");
    }
    log.time("embed node");
    $38cdb197accefc7f$var$embedNode(clone, context);
    const count = tasks.length;
    let current = 0;
    const runTask = async ()=>{
        while(true){
            const task = tasks.pop();
            if (!task) break;
            try {
                await task;
            } catch (error) {
                context.log.warn("Failed to run task", error);
            }
            progress?.(++current, count);
        }
    };
    progress?.(current, count);
    await Promise.all([
        ...Array.from({
            length: 4
        })
    ].map(runTask));
    log.timeEnd("embed node");
    await onEmbedNode?.(clone);
    const svg = $38cdb197accefc7f$var$createForeignObjectSvg(clone, context);
    svgDefsElement && svg.insertBefore(svgDefsElement, svg.children[0]);
    svgStyleElement && svg.insertBefore(svgStyleElement, svg.children[0]);
    autoDestruct && $38cdb197accefc7f$export$348a8a43acd47b6b(context);
    await onCreateForeignObjectSvg?.(svg);
    return svg;
}
function $38cdb197accefc7f$var$createForeignObjectSvg(clone, context) {
    const { width: width, height: height } = context;
    const svg = $38cdb197accefc7f$var$createSvg(width, height, clone.ownerDocument);
    const foreignObject = svg.ownerDocument.createElementNS(svg.namespaceURI, "foreignObject");
    foreignObject.setAttributeNS(null, "x", "0%");
    foreignObject.setAttributeNS(null, "y", "0%");
    foreignObject.setAttributeNS(null, "width", "100%");
    foreignObject.setAttributeNS(null, "height", "100%");
    foreignObject.append(clone);
    svg.appendChild(foreignObject);
    return svg;
}
async function $38cdb197accefc7f$export$902dcdea336e7540(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const svg = await $38cdb197accefc7f$export$d8480a58b7a3de57(context);
    const dataUrl = $38cdb197accefc7f$var$svgToDataUrl(svg, context.isEnable("removeControlCharacter"));
    if (!context.autoDestruct) {
        context.svgStyleElement = $38cdb197accefc7f$var$createStyleElement(context.ownerDocument);
        context.svgDefsElement = context.ownerDocument?.createElementNS($38cdb197accefc7f$var$XMLNS, "defs");
        context.svgStyles.clear();
    }
    const image = $38cdb197accefc7f$var$createImage(dataUrl, svg.ownerDocument);
    return await $38cdb197accefc7f$var$imageToCanvas(image, context);
}
async function $38cdb197accefc7f$export$cd700a8b3d0bd528(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const { log: log, type: type, quality: quality, dpi: dpi } = context;
    const canvas = await $38cdb197accefc7f$export$902dcdea336e7540(context);
    log.time("canvas to blob");
    const blob = await $38cdb197accefc7f$var$canvasToBlob(canvas, type, quality);
    if ([
        "image/png",
        "image/jpeg"
    ].includes(type) && dpi) {
        const arrayBuffer = await $38cdb197accefc7f$var$blobToArrayBuffer(blob.slice(0, 33));
        let uint8Array = new Uint8Array(arrayBuffer);
        if (type === "image/png") uint8Array = $38cdb197accefc7f$var$changePngDpi(uint8Array, dpi);
        else if (type === "image/jpeg") uint8Array = $38cdb197accefc7f$var$changeJpegDpi(uint8Array, dpi);
        log.timeEnd("canvas to blob");
        return new Blob([
            uint8Array,
            blob.slice(33)
        ], {
            type: type
        });
    }
    log.timeEnd("canvas to blob");
    return blob;
}
async function $38cdb197accefc7f$export$c10272d243ca22b0(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const { log: log, quality: quality, type: type, dpi: dpi } = context;
    const canvas = await $38cdb197accefc7f$export$902dcdea336e7540(context);
    log.time("canvas to data url");
    let dataUrl = canvas.toDataURL(type, quality);
    if ([
        "image/png",
        "image/jpeg"
    ].includes(type) && dpi && $38cdb197accefc7f$var$SUPPORT_ATOB && $38cdb197accefc7f$var$SUPPORT_BTOA) {
        const [format, body] = dataUrl.split(",");
        let headerLength = 0;
        let overwritepHYs = false;
        if (type === "image/png") {
            const b64Index = $38cdb197accefc7f$var$detectPhysChunkFromDataUrl(body);
            if (b64Index >= 0) {
                headerLength = Math.ceil((b64Index + 28) / 3) * 4;
                overwritepHYs = true;
            } else headerLength = 44;
        } else if (type === "image/jpeg") headerLength = 24;
        const stringHeader = body.substring(0, headerLength);
        const restOfData = body.substring(headerLength);
        const headerBytes = window.atob(stringHeader);
        const uint8Array = new Uint8Array(headerBytes.length);
        for(let i = 0; i < uint8Array.length; i++)uint8Array[i] = headerBytes.charCodeAt(i);
        const finalArray = type === "image/png" ? $38cdb197accefc7f$var$changePngDpi(uint8Array, dpi, overwritepHYs) : $38cdb197accefc7f$var$changeJpegDpi(uint8Array, dpi);
        const base64Header = window.btoa(String.fromCharCode(...finalArray));
        dataUrl = [
            format,
            ",",
            base64Header,
            restOfData
        ].join("");
    }
    log.timeEnd("canvas to data url");
    return dataUrl;
}
async function $38cdb197accefc7f$export$cd250c71e7601320(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const { width: width, height: height, ownerDocument: ownerDocument } = context;
    const dataUrl = await $38cdb197accefc7f$export$c10272d243ca22b0(context);
    const svg = $38cdb197accefc7f$var$createSvg(width, height, ownerDocument);
    const svgImage = svg.ownerDocument.createElementNS(svg.namespaceURI, "image");
    svgImage.setAttributeNS(null, "href", dataUrl);
    svgImage.setAttributeNS(null, "height", "100%");
    svgImage.setAttributeNS(null, "width", "100%");
    svg.appendChild(svgImage);
    return $38cdb197accefc7f$var$svgToDataUrl(svg, context.isEnable("removeControlCharacter"));
}
async function $38cdb197accefc7f$export$ca8e50d6594a1924(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const { ownerDocument: ownerDocument, width: width, height: height, scale: scale, type: type } = context;
    const url = type === "image/svg+xml" ? await $38cdb197accefc7f$export$cd250c71e7601320(context) : await $38cdb197accefc7f$export$c10272d243ca22b0(context);
    const image = $38cdb197accefc7f$var$createImage(url, ownerDocument);
    image.width = Math.floor(width * scale);
    image.height = Math.floor(height * scale);
    image.style.width = `${width}px`;
    image.style.height = `${height}px`;
    return image;
}
async function $38cdb197accefc7f$export$65ab556d2690f7af(node, options) {
    return $38cdb197accefc7f$export$c10272d243ca22b0(await $38cdb197accefc7f$var$orCreateContext(node, {
        ...options,
        type: "image/jpeg"
    }));
}
async function $38cdb197accefc7f$export$ac685bc5849d256d(node, options) {
    const context = await $38cdb197accefc7f$var$orCreateContext(node, options);
    const canvas = await $38cdb197accefc7f$export$902dcdea336e7540(context);
    return canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height).data;
}
async function $38cdb197accefc7f$export$1b1f83de2125eb4c(node, options) {
    return $38cdb197accefc7f$export$c10272d243ca22b0(await $38cdb197accefc7f$var$orCreateContext(node, {
        ...options,
        type: "image/png"
    }));
}
async function $38cdb197accefc7f$export$90711b6dcb4fafbb(node, options) {
    return $38cdb197accefc7f$export$c10272d243ca22b0(await $38cdb197accefc7f$var$orCreateContext(node, {
        ...options,
        type: "image/webp"
    }));
}



var $jDfxe = parcelRequire("jDfxe");

var $5R532 = parcelRequire("5R532");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $7X4mk = parcelRequire("7X4mk");

var $5R532 = parcelRequire("5R532");
const $e16f5e4fd9293f6d$export$81d25ce4f8051170 = ({ label: label, value: value, color: color, colorShape: colorShape = 'rectangle', disableLineBreak: disableLineBreak = false })=>{
    const lg = disableLineBreak || (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('lg'));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
        sx: {
            gap: 1,
            px: 1,
            py: 0.5,
            borderRadius: 1,
            bgcolor: ({ palette: palette })=>palette.mode === 'dark' ? 'background.paper' : '#F5F5F5'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    width: colorShape === 'rectangle' ? 12 : 12,
                    height: colorShape === 'rectangle' ? 12 : 2,
                    backgroundColor: color,
                    borderRadius: 1
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "body1",
                children: lg ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        label,
                        typeof value !== 'undefined' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                ": ",
                                value
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        label,
                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                        value
                    ]
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $2fbb4c0b471bc91f$export$c9915453de10000b = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 17 19",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M5.40833 10.3417L11.1 13.6583M11.0917 4.50833L5.40833 7.825M15.75 3.25C15.75 4.63071 14.6307 5.75 13.25 5.75C11.8693 5.75 10.75 4.63071 10.75 3.25C10.75 1.86929 11.8693 0.75 13.25 0.75C14.6307 0.75 15.75 1.86929 15.75 3.25ZM5.75 9.08333C5.75 10.464 4.63071 11.5833 3.25 11.5833C1.86929 11.5833 0.75 10.464 0.75 9.08333C0.75 7.70262 1.86929 6.58333 3.25 6.58333C4.63071 6.58333 5.75 7.70262 5.75 9.08333ZM15.75 14.9167C15.75 16.2974 14.6307 17.4167 13.25 17.4167C11.8693 17.4167 10.75 16.2974 10.75 14.9167C10.75 13.536 11.8693 12.4167 13.25 12.4167C14.6307 12.4167 15.75 13.536 15.75 14.9167Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
$2fbb4c0b471bc91f$export$c9915453de10000b.displayName = 'Share';



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $bff506feb6afd749$export$63a9dbd0460b69ca = ({ sx: sx = {} })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 57 19",
        sx: {
            fill: 'none',
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M35.1917 3.85136V13.4514H33.207V3.85136H35.1917ZM35.1917 0.622314V2.60703H33.207V0.622314H35.1917Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M15.3031 3.85124V13.4513H13.3184V3.85124H15.3031ZM15.3031 0.622192V2.60691H13.3184V0.622192H15.3031Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M23.871 4.16218C24.4683 4.47327 24.9349 4.93989 25.2709 5.55584C25.6069 6.17178 25.7749 6.91216 25.7749 7.78319V13.4449H23.8088V8.08183C23.8088 7.22324 23.5911 6.56375 23.1618 6.10334C22.7325 5.64294 22.1476 5.41274 21.401 5.41274C20.6544 5.41274 20.0696 5.64294 19.6341 6.10334C19.1986 6.56375 18.9808 7.22324 18.9808 8.08183V13.4449H16.9961V3.8511H18.9808V4.94611C19.3043 4.55415 19.7212 4.24306 20.2251 4.0253C20.7291 3.80755 21.2704 3.69556 21.8366 3.69556C22.5894 3.69556 23.2675 3.8511 23.8648 4.1684L23.871 4.16218Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M31.6046 5.46885H29.8252V13.445H27.8218V5.46885H26.6895V3.85121H27.8218V3.17305C27.8218 2.07182 28.1142 1.263 28.6991 0.759044C29.2839 0.255089 30.2047 0 31.4615 0V1.65496C30.858 1.65496 30.4349 1.76695 30.1923 1.99716C29.9496 2.22114 29.8252 2.6131 29.8252 3.17305V3.85121H31.6046V5.46885Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M42.9656 4.13741C43.538 4.43605 43.9922 4.80312 44.3157 5.24486V3.85121H46.3191V13.6068C46.3191 14.4903 46.1325 15.2742 45.7592 15.9648C45.3859 16.6554 44.8508 17.1967 44.1477 17.5949C43.4447 17.9931 42.6048 18.1859 41.628 18.1859C40.3276 18.1859 39.2451 17.8811 38.3865 17.2714C37.5279 16.6616 37.0364 15.8341 36.9244 14.7889H38.8904C39.0397 15.2866 39.3633 15.691 39.8548 16.0021C40.3463 16.3132 40.9374 16.4625 41.6217 16.4625C42.4243 16.4625 43.0714 16.2199 43.5629 15.7284C44.0544 15.2431 44.3033 14.5338 44.3033 13.6006V11.9954C43.9673 12.4496 43.5131 12.8291 42.9345 13.1339C42.3621 13.4388 41.7088 13.5943 40.9747 13.5943C40.141 13.5943 39.3757 13.3828 38.6851 12.9597C37.9945 12.5367 37.447 11.9456 37.0488 11.1803C36.6506 10.4151 36.4453 9.55648 36.4453 8.59212C36.4453 7.62776 36.6444 6.77539 37.0488 6.02879C37.447 5.28841 37.9945 4.7098 38.6851 4.29295C39.3757 3.88232 40.141 3.677 40.9747 3.677C41.7151 3.677 42.3746 3.82632 42.9532 4.11874L42.9656 4.13741ZM43.9051 6.91849C43.6313 6.4332 43.2767 6.0599 42.835 5.80481C42.3932 5.54972 41.9142 5.41907 41.404 5.41907C40.8938 5.41907 40.4147 5.5435 39.973 5.79237C39.5313 6.04124 39.1766 6.40832 38.9029 6.88738C38.6291 7.36645 38.4922 7.93885 38.4922 8.60457C38.4922 9.27028 38.6291 9.8489 38.9029 10.3466C39.1766 10.8444 39.5375 11.2239 39.9854 11.4852C40.4334 11.7465 40.9063 11.8772 41.404 11.8772C41.9017 11.8772 42.3932 11.7465 42.835 11.4914C43.2767 11.2363 43.6313 10.863 43.9051 10.3653C44.1788 9.87379 44.3157 9.29517 44.3157 8.62945C44.3157 7.96373 44.1788 7.39134 43.9051 6.90605V6.91849Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M56.9946 3.85132L51.1089 17.9621H49.0557L51.0093 13.2958L47.2266 3.85132H49.4415L52.1417 11.168L54.9477 3.85132H57.0008H56.9946Z",
                fill: "#071326"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M4.89184 0.679688H2.44531V3.12622H4.89184V0.679688Z",
                fill: "#FF9B3D"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M2.44629 3.1261V11.0089H4.89551V3.1261H7.3418V13.4562H0V3.1261H2.44629Z",
                fill: "#071326"
            })
        ]
    });
};



var $bCDrB = parcelRequire("bCDrB");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $iqxMM = parcelRequire("iqxMM");

var $9QePP = parcelRequire("9QePP");

var $b0nKR = parcelRequire("b0nKR");


var $i2WC7 = parcelRequire("i2WC7");

var $lnFga = parcelRequire("lnFga");

var $hBeJX = parcelRequire("hBeJX");

var $b0nKR = parcelRequire("b0nKR");

var $i2WC7 = parcelRequire("i2WC7");

var $99P3O = parcelRequire("99P3O");

var $jHn5r = parcelRequire("jHn5r");

var $hBeJX = parcelRequire("hBeJX");

var $fU6gH = parcelRequire("fU6gH");

var $8VTts = parcelRequire("8VTts");

var $iYis8 = parcelRequire("iYis8");

var $9hA9H = parcelRequire("9hA9H");
var $1b281b2ad410f0b8$export$1d9b78e3a3685311 = (state)=>state.graphicalItems.polarItems;
var $1b281b2ad410f0b8$var$selectAxisPredicate = (0, $b0nKR.createSelector)([
    (0, $fU6gH.pickAxisType),
    (0, $8VTts.pickAxisId)
], (0, $99P3O.itemAxisPredicate));
var $1b281b2ad410f0b8$export$cf006504ac494d1 = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$1d9b78e3a3685311,
    (0, $99P3O.selectBaseAxis),
    $1b281b2ad410f0b8$var$selectAxisPredicate
], (0, $99P3O.combineGraphicalItemsSettings));
var $1b281b2ad410f0b8$var$selectPolarGraphicalItemsData = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$cf006504ac494d1
], (0, $99P3O.combineGraphicalItemsData));
var $1b281b2ad410f0b8$export$2a78a128a7055193 = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$var$selectPolarGraphicalItemsData,
    (0, $i2WC7.selectChartDataAndAlwaysIgnoreIndexes)
], (0, $99P3O.combineDisplayedData));
var $1b281b2ad410f0b8$export$9adf998427b6c073 = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$2a78a128a7055193,
    (0, $99P3O.selectBaseAxis),
    $1b281b2ad410f0b8$export$cf006504ac494d1
], (0, $99P3O.combineAppliedValues));
var $1b281b2ad410f0b8$export$a41fa0a103b05ea = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$2a78a128a7055193,
    (0, $99P3O.selectBaseAxis),
    $1b281b2ad410f0b8$export$cf006504ac494d1
], (data, axisSettings, items)=>{
    if (items.length > 0) return data.flatMap((entry)=>{
        return items.flatMap((item)=>{
            var _axisSettings$dataKey;
            var valueByDataKey = (0, $hBeJX.getValueByDataKey)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            return {
                value: valueByDataKey,
                errorDomain: [] // polar charts do not have error bars
            };
        });
    }).filter(Boolean);
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, $hBeJX.getValueByDataKey)(item, axisSettings.dataKey),
            errorDomain: []
        }));
    return data.map((entry)=>({
            value: entry,
            errorDomain: []
        }));
});
var $1b281b2ad410f0b8$var$unsupportedInPolarChart = ()=>undefined;
var $1b281b2ad410f0b8$var$selectDomainOfAllPolarAppliedNumericalValues = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$2a78a128a7055193,
    (0, $99P3O.selectBaseAxis),
    $1b281b2ad410f0b8$export$cf006504ac494d1,
    (0, $99P3O.selectAllErrorBarSettings),
    (0, $fU6gH.pickAxisType),
    (0, $i2WC7.selectChartDataSliceIgnoringIndexes)
], (0, $99P3O.combineDomainOfAllAppliedNumericalValuesIncludingErrorValues));
var $1b281b2ad410f0b8$var$selectPolarNumericalDomain = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectBaseAxis),
    (0, $99P3O.selectDomainDefinition),
    (0, $99P3O.selectDomainFromUserPreference),
    $1b281b2ad410f0b8$var$unsupportedInPolarChart,
    $1b281b2ad410f0b8$var$selectDomainOfAllPolarAppliedNumericalValues,
    $1b281b2ad410f0b8$var$unsupportedInPolarChart,
    (0, $jHn5r.selectChartLayout),
    (0, $fU6gH.pickAxisType)
], (0, $99P3O.combineNumericalDomain));
var $1b281b2ad410f0b8$export$853e8eb91c358168 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectBaseAxis),
    (0, $jHn5r.selectChartLayout),
    $1b281b2ad410f0b8$export$2a78a128a7055193,
    $1b281b2ad410f0b8$export$9adf998427b6c073,
    (0, $iYis8.selectStackOffsetType),
    (0, $fU6gH.pickAxisType),
    $1b281b2ad410f0b8$var$selectPolarNumericalDomain
], (0, $99P3O.combineAxisDomain));
var $1b281b2ad410f0b8$export$e2d1beea1ea428fd = (0, $b0nKR.createSelector)([
    $1b281b2ad410f0b8$export$853e8eb91c358168,
    (0, $99P3O.selectRenderableAxisSettings),
    (0, $99P3O.selectRealScaleType)
], (0, $99P3O.combineNiceTicks));
var $1b281b2ad410f0b8$export$5dd396e660cc1d86 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectBaseAxis),
    $1b281b2ad410f0b8$export$853e8eb91c358168,
    $1b281b2ad410f0b8$export$e2d1beea1ea428fd,
    (0, $fU6gH.pickAxisType)
], (0, $99P3O.combineAxisDomainWithNiceTicks));
var $1b281b2ad410f0b8$export$8667a1028ac2a3c5 = (0, $b0nKR.createSelector)([
    (0, $99P3O.selectRealScaleType),
    $1b281b2ad410f0b8$export$5dd396e660cc1d86
], (0, $9hA9H.combineCheckedDomain));


function $6b78564e8d7321c1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b78564e8d7321c1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b78564e8d7321c1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6b78564e8d7321c1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b78564e8d7321c1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6b78564e8d7321c1$var$_defineProperty(e, r, t) {
    return (r = $6b78564e8d7321c1$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6b78564e8d7321c1$var$_toPropertyKey(t) {
    var i = $6b78564e8d7321c1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $6b78564e8d7321c1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6b78564e8d7321c1$var$pickId = (_state, id)=>id;
var $6b78564e8d7321c1$var$selectSynchronisedPieSettings = (0, $b0nKR.createSelector)([
    (0, $1b281b2ad410f0b8$export$1d9b78e3a3685311),
    $6b78564e8d7321c1$var$pickId
], (graphicalItems, id)=>graphicalItems.filter((item)=>item.type === 'pie').find((item)=>item.id === id));
// Keep stable reference to an empty array to prevent re-renders
var $6b78564e8d7321c1$var$emptyArray = [];
var $6b78564e8d7321c1$var$pickCells = (_state, _id, cells)=>{
    if ((cells === null || cells === void 0 ? void 0 : cells.length) === 0) return $6b78564e8d7321c1$var$emptyArray;
    return cells;
};
var $6b78564e8d7321c1$export$6099ba314905f0c4 = (0, $b0nKR.createSelector)([
    (0, $i2WC7.selectChartDataAndAlwaysIgnoreIndexes),
    $6b78564e8d7321c1$var$selectSynchronisedPieSettings,
    $6b78564e8d7321c1$var$pickCells
], (_ref, pieSettings, cells)=>{
    var chartData = _ref.chartData;
    if (pieSettings == null) return undefined;
    var displayedData;
    if ((pieSettings === null || pieSettings === void 0 ? void 0 : pieSettings.data) != null && pieSettings.data.length > 0) displayedData = pieSettings.data;
    else displayedData = chartData;
    if ((!displayedData || !displayedData.length) && cells != null) displayedData = cells.map((cell)=>$6b78564e8d7321c1$var$_objectSpread($6b78564e8d7321c1$var$_objectSpread({}, pieSettings.presentationProps), cell.props));
    if (displayedData == null) return undefined;
    return displayedData;
});
var $6b78564e8d7321c1$export$3b28bf469d4906d8 = (0, $b0nKR.createSelector)([
    $6b78564e8d7321c1$export$6099ba314905f0c4,
    $6b78564e8d7321c1$var$selectSynchronisedPieSettings,
    $6b78564e8d7321c1$var$pickCells
], (displayedData, pieSettings, cells)=>{
    if (displayedData == null || pieSettings == null) return undefined;
    return displayedData.map((entry, i)=>{
        var _cells$i;
        var name = (0, $hBeJX.getValueByDataKey)(entry, pieSettings.nameKey, pieSettings.name);
        var color;
        if (cells !== null && cells !== void 0 && (_cells$i = cells[i]) !== null && _cells$i !== void 0 && (_cells$i = _cells$i.props) !== null && _cells$i !== void 0 && _cells$i.fill) color = cells[i].props.fill;
        else if (typeof entry === 'object' && entry != null && 'fill' in entry) color = entry.fill;
        else color = pieSettings.fill;
        return {
            value: (0, $hBeJX.getTooltipNameProp)(name, pieSettings.dataKey),
            dataKey: pieSettings.dataKey,
            color: color,
            // @ts-expect-error Legend payload.payload says it wants objects but our data can be unknown
            payload: entry,
            type: pieSettings.legendType
        };
    });
});
var $6b78564e8d7321c1$export$c6af8a90408f4a64 = (0, $b0nKR.createSelector)([
    $6b78564e8d7321c1$export$6099ba314905f0c4,
    $6b78564e8d7321c1$var$selectSynchronisedPieSettings,
    $6b78564e8d7321c1$var$pickCells,
    (0, $lnFga.selectChartOffsetInternal)
], (displayedData, pieSettings, cells, offset)=>{
    if (pieSettings == null || displayedData == null) return undefined;
    return (0, $ced1080254a2467c$export$c404972144c91fdf)({
        offset: offset,
        pieSettings: pieSettings,
        displayedData: displayedData,
        cells: cells
    });
});



var $bqlEl = parcelRequire("bqlEl");

var $lIF05 = parcelRequire("lIF05");

var $f2bYI = parcelRequire("f2bYI");

var $4zntx = parcelRequire("4zntx");

var $cU1wp = parcelRequire("cU1wp");


var $02Ymo = parcelRequire("02Ymo");

var $1l5bp = parcelRequire("1l5bp");

var $3FiDp = parcelRequire("3FiDp");

var $hBeJX = parcelRequire("hBeJX");

var $cpMpC = parcelRequire("cpMpC");

var $63Kel = parcelRequire("63Kel");


var $2C2Dz = parcelRequire("2C2Dz");

var $71i43 = parcelRequire("71i43");

var $ckb0X = parcelRequire("ckb0X");

var $lcI2N = parcelRequire("lcI2N");

var $eHwNv = parcelRequire("eHwNv");

var $dujP6 = parcelRequire("dujP6");

var $cd9rh = parcelRequire("cd9rh");

var $jhZFb = parcelRequire("jhZFb");

var $aPPc1 = parcelRequire("aPPc1");

var $4M6vj = parcelRequire("4M6vj");

var $bJtQU = parcelRequire("bJtQU");

var $ahoy0 = parcelRequire("ahoy0");

var $cbiWq = parcelRequire("cbiWq");

var $gKNgz = parcelRequire("gKNgz");

var $1RPR5 = parcelRequire("1RPR5");

var $jHn5r = parcelRequire("jHn5r");
var $ced1080254a2467c$var$_excluded = [
    "key"
], $ced1080254a2467c$var$_excluded2 = [
    "onMouseEnter",
    "onClick",
    "onMouseLeave"
], $ced1080254a2467c$var$_excluded3 = [
    "id"
], $ced1080254a2467c$var$_excluded4 = [
    "id"
];
function $ced1080254a2467c$var$_extends() {
    return $ced1080254a2467c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ced1080254a2467c$var$_extends.apply(null, arguments);
}
function $ced1080254a2467c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ced1080254a2467c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ced1080254a2467c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $ced1080254a2467c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ced1080254a2467c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ced1080254a2467c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ced1080254a2467c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ced1080254a2467c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ced1080254a2467c$var$_defineProperty(e, r, t) {
    return (r = $ced1080254a2467c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ced1080254a2467c$var$_toPropertyKey(t) {
    var i = $ced1080254a2467c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ced1080254a2467c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * The `label` prop in Pie accepts a variety of alternatives.
 */ /**
 * We spread the data object into the sector data item,
 * so we can't really know what is going to be inside.
 *
 * This type represents our best effort, but it all depends on the input data
 * and what is inside of it.
 *
 * https://github.com/recharts/recharts/issues/6380
 * https://github.com/recharts/recharts/discussions/6375
 */ /**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ var $ced1080254a2467c$var$defaultPieSectorShape = (0, $4zntx.Sector);
function $ced1080254a2467c$var$SetPiePayloadLegend(props) {
    var cells = (0, $acw62.useMemo)(()=>(0, $02Ymo.findAllByType)(props.children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var legendPayload = (0, $bqlEl.useAppSelector)((state)=>(0, $6b78564e8d7321c1$export$3b28bf469d4906d8)(state, props.id, cells));
    if (legendPayload == null) return null;
    return /*#__PURE__*/ $acw62.createElement((0, $ckb0X.SetPolarLegendPayload), {
        legendPayload: legendPayload
    });
}
function $ced1080254a2467c$var$getActiveShapeFill(activeShape) {
    // activeShape can be boolean/function/element/object; only element/object can carry a static fill value.
    if (activeShape == null || typeof activeShape === 'boolean' || typeof activeShape === 'function') return undefined;
    if (/*#__PURE__*/ $acw62.isValidElement(activeShape)) {
        var _activeShape$props;
        // React element form: <Sector fill="..."/> or custom element with fill prop.
        var _fill = (_activeShape$props = activeShape.props) === null || _activeShape$props === void 0 ? void 0 : _activeShape$props.fill;
        return typeof _fill === 'string' ? _fill : undefined;
    }
    var fill = activeShape.fill;
    return typeof fill === 'string' ? fill : undefined;
}
var $ced1080254a2467c$var$SetPieTooltipEntrySettings = /*#__PURE__*/ $acw62.memo((_ref)=>{
    var dataKey = _ref.dataKey, nameKey = _ref.nameKey, sectors = _ref.sectors, stroke = _ref.stroke, strokeWidth = _ref.strokeWidth, fill = _ref.fill, name = _ref.name, hide = _ref.hide, tooltipType = _ref.tooltipType, formatter = _ref.formatter, id = _ref.id, activeShape = _ref.activeShape;
    var activeShapeFill = $ced1080254a2467c$var$getActiveShapeFill(activeShape);
    var tooltipDataDefinedOnItem = sectors.map((sector)=>{
        var sectorTooltipPayload = sector.tooltipPayload;
        if (activeShapeFill == null || sectorTooltipPayload == null) return sectorTooltipPayload;
        return sectorTooltipPayload.map((item)=>$ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, item), {}, {
                color: activeShapeFill,
                fill: activeShapeFill
            }));
    });
    var tooltipEntrySettings = {
        dataDefinedOnItem: tooltipDataDefinedOnItem,
        getPosition: (index)=>{
            var _sectors$Number;
            return (_sectors$Number = sectors[Number(index)]) === null || _sectors$Number === void 0 ? void 0 : _sectors$Number.tooltipPosition;
        },
        settings: {
            stroke: stroke,
            strokeWidth: strokeWidth,
            fill: fill,
            dataKey: dataKey,
            nameKey: nameKey,
            name: (0, $hBeJX.getTooltipNameProp)(name, dataKey),
            hide: hide,
            type: tooltipType,
            color: fill,
            unit: '',
            formatter: // why doesn't Pie support unit?
            formatter,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ $acw62.createElement((0, $2C2Dz.SetTooltipEntrySettings), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var $ced1080254a2467c$var$getTextAnchor = (x, cx)=>{
    if (x > cx) return 'start';
    if (x < cx) return 'end';
    return 'middle';
};
var $ced1080254a2467c$var$getOuterRadius = (dataPoint, outerRadius, maxPieRadius)=>{
    if (typeof outerRadius === 'function') return (0, $3FiDp.getPercentValue)(outerRadius(dataPoint), maxPieRadius, maxPieRadius * 0.8);
    return (0, $3FiDp.getPercentValue)(outerRadius, maxPieRadius, maxPieRadius * 0.8);
};
var $ced1080254a2467c$var$parseCoordinateOfPie = (pieSettings, offset, dataPoint)=>{
    var top = offset.top, left = offset.left, width = offset.width, height = offset.height;
    var maxPieRadius = (0, $1l5bp.getMaxRadius)(width, height);
    var cx = left + (0, $3FiDp.getPercentValue)(pieSettings.cx, width, width / 2);
    var cy = top + (0, $3FiDp.getPercentValue)(pieSettings.cy, height, height / 2);
    var innerRadius = (0, $3FiDp.getPercentValue)(pieSettings.innerRadius, maxPieRadius, 0);
    var outerRadius = $ced1080254a2467c$var$getOuterRadius(dataPoint, pieSettings.outerRadius, maxPieRadius);
    var maxRadius = pieSettings.maxRadius || Math.sqrt(width * width + height * height) / 2;
    return {
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        maxRadius: maxRadius
    };
};
var $ced1080254a2467c$var$parseDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, $3FiDp.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $ced1080254a2467c$var$renderLabelLineItem = (option, props)=>{
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error we can't know if the type of props matches the element
    return /*#__PURE__*/ $acw62.cloneElement(option, props);
    if (typeof option === 'function') return option(props);
    var className = (0, $9QePP.clsx)('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
    // React doesn't like it when we spread a key property onto an element
    var key = props.key, otherProps = $ced1080254a2467c$var$_objectWithoutProperties(props, $ced1080254a2467c$var$_excluded);
    return /*#__PURE__*/ $acw62.createElement((0, $f2bYI.Curve), $ced1080254a2467c$var$_extends({}, otherProps, {
        type: "linear",
        className: className
    }));
};
var $ced1080254a2467c$var$renderLabelItem = (option, props, value)=>{
    if (/*#__PURE__*/ $acw62.isValidElement(option)) // @ts-expect-error element cloning is not typed
    return /*#__PURE__*/ $acw62.cloneElement(option, props);
    var label = value;
    if (typeof option === 'function') {
        label = option(props);
        if (/*#__PURE__*/ $acw62.isValidElement(label)) return label;
    }
    var className = (0, $9QePP.clsx)('recharts-pie-label-text', (0, $1RPR5.getClassNameFromUnknown)(option));
    return /*#__PURE__*/ $acw62.createElement((0, $cU1wp.Text), $ced1080254a2467c$var$_extends({}, props, {
        alignmentBaseline: "middle",
        className: className
    }), label);
};
function $ced1080254a2467c$var$PieLabels(_ref2) {
    var sectors = _ref2.sectors, props = _ref2.props, showLabels = _ref2.showLabels;
    var label = props.label, labelLine = props.labelLine, dataKey = props.dataKey;
    if (!showLabels || !label || !sectors) return null;
    var pieProps = (0, $4M6vj.svgPropertiesNoEvents)(props);
    var customLabelProps = (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(label);
    var customLabelLineProps = (0, $4M6vj.svgPropertiesNoEventsFromUnknown)(labelLine);
    var offsetRadius = typeof label === 'object' && 'offsetRadius' in label && typeof label.offsetRadius === 'number' && label.offsetRadius || 20;
    var labels = sectors.map((entry, i)=>{
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = (0, $1l5bp.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelProps is contributing unknown props
            stroke: 'none'
        }, customLabelProps), {}, {
            index: i,
            textAnchor: $ced1080254a2467c$var$getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, pieProps), entry), {}, {
            // @ts-expect-error customLabelLineProps is contributing unknown props
            fill: 'none',
            // @ts-expect-error customLabelLineProps is contributing unknown props
            stroke: entry.fill
        }, customLabelLineProps), {}, {
            index: i,
            points: [
                (0, $1l5bp.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle),
                endPoint
            ],
            key: 'line'
        });
        return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
            zIndex: (0, $gKNgz.DefaultZIndexes).label,
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
        }, /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), null, labelLine && $ced1080254a2467c$var$renderLabelLineItem(labelLine, lineProps), $ced1080254a2467c$var$renderLabelItem(label, labelProps, (0, $hBeJX.getValueByDataKey)(entry, dataKey))));
    });
    return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        className: "recharts-pie-labels"
    }, labels);
}
function $ced1080254a2467c$var$PieLabelList(_ref3) {
    var sectors = _ref3.sectors, props = _ref3.props, showLabels = _ref3.showLabels;
    var label = props.label;
    if (typeof label === 'object' && label != null && 'position' in label) return /*#__PURE__*/ $acw62.createElement((0, $bJtQU.LabelListFromLabelProp), {
        label: label
    });
    return /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$PieLabels, {
        sectors: sectors,
        props: props,
        showLabels: showLabels
    });
}
function $ced1080254a2467c$var$PieSectors(props) {
    var sectors = props.sectors, activeShape = props.activeShape, inactiveShapeProp = props.inactiveShape, allOtherPieProps = props.allOtherPieProps, shape = props.shape, id = props.id, animationElapsedTime = props.animationElapsedTime, isAnimating = props.isAnimating, isEntrance = props.isEntrance;
    var activeIndex = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipIndex));
    var activeDataKey = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipDataKey));
    var activeGraphicalItemId = (0, $bqlEl.useAppSelector)((0, $71i43.selectActiveTooltipGraphicalItemId));
    var onMouseEnterFromProps = allOtherPieProps.onMouseEnter, onItemClickFromProps = allOtherPieProps.onClick, onMouseLeaveFromProps = allOtherPieProps.onMouseLeave, restOfAllOtherProps = $ced1080254a2467c$var$_objectWithoutProperties(allOtherPieProps, $ced1080254a2467c$var$_excluded2);
    var onMouseEnterFromContext = (0, $1d6cbb89ea2b356d$export$6162f642d41f88ea)(onMouseEnterFromProps, allOtherPieProps.dataKey, id);
    var onMouseLeaveFromContext = (0, $1d6cbb89ea2b356d$export$27cbf444bf0be2d0)(onMouseLeaveFromProps);
    var onClickFromContext = (0, $1d6cbb89ea2b356d$export$c9154937ad8393fc)(onItemClickFromProps, allOtherPieProps.dataKey, id);
    if (sectors == null || sectors.length === 0) return null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, sectors.map((entry, i)=>{
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        // For Pie charts, when multiple Pies share the same dataKey, we need to ensure only the hovered Pie's sector is active.
        // We do this by checking if the active graphical item ID matches this Pie's ID.
        var graphicalItemMatches = activeGraphicalItemId == null || activeGraphicalItemId === id;
        var isActive = String(i) === activeIndex && (activeDataKey == null || allOtherPieProps.dataKey === activeDataKey) && graphicalItemMatches;
        var inactiveShape = activeIndex ? inactiveShapeProp : null;
        var sectorOptions = activeShape && isActive ? activeShape : inactiveShape;
        var sectorProps = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, entry), {}, {
            stroke: entry.stroke,
            tabIndex: -1,
            index: i,
            isActive: isActive,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating,
            isEntrance: isEntrance,
            [(0, $lcI2N.DATA_ITEM_INDEX_ATTRIBUTE_NAME)]: i,
            [(0, $lcI2N.DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME)]: id
        });
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), $ced1080254a2467c$var$_extends({
            key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i),
            tabIndex: -1,
            className: "recharts-pie-sector"
        }, (0, $cpMpC.adaptEventsOfChild)(restOfAllOtherProps, entry, i), {
            onMouseEnter: onMouseEnterFromContext(entry, i),
            onMouseLeave: onMouseLeaveFromContext(entry, i),
            onClick: onClickFromContext(entry, i)
        }), /*#__PURE__*/ $acw62.createElement((0, $63Kel.Shape), {
            option: sectorOptions !== null && sectorOptions !== void 0 ? sectorOptions : shape,
            DefaultShape: $ced1080254a2467c$var$defaultPieSectorShape,
            shapeProps: sectorProps
        }));
    }));
}
function $ced1080254a2467c$export$c404972144c91fdf(_ref4) {
    var _pieSettings$paddingA;
    var pieSettings = _ref4.pieSettings, displayedData = _ref4.displayedData, cells = _ref4.cells, offset = _ref4.offset;
    var cornerRadius = pieSettings.cornerRadius, startAngle = pieSettings.startAngle, endAngle = pieSettings.endAngle, dataKey = pieSettings.dataKey, nameKey = pieSettings.nameKey, tooltipType = pieSettings.tooltipType;
    var minAngle = Math.abs(pieSettings.minAngle);
    var deltaAngle = $ced1080254a2467c$var$parseDeltaAngle(startAngle, endAngle);
    var absDeltaAngle = Math.abs(deltaAngle);
    var paddingAngle = displayedData.length <= 1 ? 0 : (_pieSettings$paddingA = pieSettings.paddingAngle) !== null && _pieSettings$paddingA !== void 0 ? _pieSettings$paddingA : 0;
    var notZeroItemCount = displayedData.filter((entry)=>(0, $hBeJX.getValueByDataKey)(entry, dataKey, 0) !== 0).length;
    var totalPaddingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
    var sum = displayedData.reduce((result, entry)=>{
        var val = (0, $hBeJX.getValueByDataKey)(entry, dataKey, 0);
        return result + ((0, $3FiDp.isNumber)(val) ? val : 0);
    }, 0);
    // Only apply minAngle redistribution when at least one non-zero segment's
    // natural angle falls below the minAngle threshold. Otherwise, minAngle
    // unnecessarily shifts all segments even when none need the boost.
    // See: https://github.com/recharts/recharts/issues/6814
    var needsMinAngleAdjustment = minAngle > 0 && sum > 0 && displayedData.some((entry)=>{
        var val = (0, $hBeJX.getValueByDataKey)(entry, dataKey, 0);
        var percent = ((0, $3FiDp.isNumber)(val) ? val : 0) / sum;
        return val !== 0 && percent * absDeltaAngle < minAngle;
    });
    var effectiveMinAngle = needsMinAngleAdjustment ? minAngle : 0;
    var realTotalAngle = absDeltaAngle - notZeroItemCount * effectiveMinAngle - totalPaddingAngle;
    var sectors;
    if (sum > 0) {
        var prev;
        sectors = displayedData.map((entry, i)=>{
            var val = (0, $hBeJX.getValueByDataKey)(entry, dataKey, 0);
            var name = (0, $hBeJX.getValueByDataKey)(entry, nameKey, i);
            var coordinate = $ced1080254a2467c$var$parseCoordinateOfPie(pieSettings, offset, entry);
            var percent = ((0, $3FiDp.isNumber)(val) ? val : 0) / sum;
            var tempStartAngle;
            // @ts-expect-error can't spread unknown
            var entryWithCellInfo = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, entry), cells && cells[i] && cells[i].props);
            var sectorColor = entryWithCellInfo != null && 'fill' in entryWithCellInfo && typeof entryWithCellInfo.fill === 'string' ? entryWithCellInfo.fill : pieSettings.fill;
            if (i) tempStartAngle = prev.endAngle + (0, $3FiDp.mathSign)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
            else tempStartAngle = startAngle;
            var tempEndAngle = tempStartAngle + (0, $3FiDp.mathSign)(deltaAngle) * ((val !== 0 ? effectiveMinAngle : 0) + percent * realTotalAngle);
            var midAngle = (tempStartAngle + tempEndAngle) / 2;
            var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
            var tooltipPayload = [
                {
                    name: name,
                    value: val,
                    payload: entryWithCellInfo,
                    dataKey: dataKey,
                    type: tooltipType,
                    color: sectorColor,
                    fill: sectorColor,
                    graphicalItemId: pieSettings.id
                }
            ];
            var tooltipPosition = (0, $1l5bp.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
            prev = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, pieSettings.presentationProps), {}, {
                percent: percent,
                cornerRadius: typeof cornerRadius === 'string' ? parseFloat(cornerRadius) : cornerRadius,
                name: name,
                tooltipPayload: tooltipPayload,
                midAngle: midAngle,
                middleRadius: middleRadius,
                tooltipPosition: tooltipPosition
            }, entryWithCellInfo), coordinate), {}, {
                value: val,
                dataKey: dataKey,
                startAngle: tempStartAngle,
                endAngle: tempEndAngle,
                payload: entryWithCellInfo,
                paddingAngle: val !== 0 ? (0, $3FiDp.mathSign)(deltaAngle) * paddingAngle : 0
            });
            return prev;
        });
    }
    return sectors;
}
function $ced1080254a2467c$var$PieLabelListProvider(_ref5) {
    var showLabels = _ref5.showLabels, sectors = _ref5.sectors, children = _ref5.children;
    var labelListEntries = (0, $acw62.useMemo)(()=>{
        if (!showLabels || !sectors) return [];
        return sectors.map((entry)=>({
                value: entry.value,
                payload: entry.payload,
                clockWise: false,
                parentViewBox: undefined,
                viewBox: {
                    cx: entry.cx,
                    cy: entry.cy,
                    innerRadius: entry.innerRadius,
                    outerRadius: entry.outerRadius,
                    startAngle: entry.startAngle,
                    endAngle: entry.endAngle,
                    clockWise: false
                },
                fill: entry.fill
            }));
    }, [
        sectors,
        showLabels
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $bJtQU.PolarLabelListContextProvider), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
var $ced1080254a2467c$var$defaultPieAnimateItems = (items, animationElapsedTime)=>{
    if (items == null) return [];
    var stepData = [];
    var firstNonRemoved = items.find((item)=>item.status !== 'removed');
    var curAngle = firstNonRemoved ? firstNonRemoved.next.startAngle : 0;
    items.forEach((item, index)=>{
        if (item.status === 'removed') return;
        var paddingAngle = index > 0 ? (0, $iqxMM.get)(item.next, 'paddingAngle', 0) : 0;
        if (item.status === 'matched') {
            var angle = (0, $3FiDp.interpolate)(item.prev.endAngle - item.prev.startAngle, item.next.endAngle - item.next.startAngle, animationElapsedTime);
            var latest = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, item.next), {}, {
                startAngle: curAngle + paddingAngle,
                endAngle: curAngle + angle + paddingAngle
            });
            stepData.push(latest);
            curAngle = latest.endAngle;
        } else {
            // added
            var deltaAngle = (0, $3FiDp.interpolate)(0, item.next.endAngle - item.next.startAngle, animationElapsedTime);
            var _latest = $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, item.next), {}, {
                startAngle: curAngle + paddingAngle,
                endAngle: curAngle + deltaAngle + paddingAngle
            });
            stepData.push(_latest);
            curAngle = _latest.endAngle;
        }
    });
    return stepData;
};
function $ced1080254a2467c$var$SectorsWithAnimation(_ref6) {
    var _firstSector$cx, _firstSector$cy, _firstSector$innerRad, _firstSector$outerRad;
    var props = _ref6.props, previousSectorsRef = _ref6.previousSectorsRef, id = _ref6.id;
    var sectors = props.sectors, activeShape = props.activeShape, inactiveShape = props.inactiveShape, animationInterpolateFn = props.animationInterpolateFn;
    var _useAnimationCallback = (0, $eHwNv.useAnimationCallbacks)(props.onAnimationStart, props.onAnimationEnd), isAnimating = _useAnimationCallback.isAnimating, handleAnimationStart = _useAnimationCallback.handleAnimationStart, handleAnimationEnd = _useAnimationCallback.handleAnimationEnd;
    var layout = (0, $jHn5r.usePolarChartLayout)();
    if (layout == null) return null;
    var firstSector = sectors[0];
    return /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$PieLabelListProvider, {
        showLabels: !isAnimating,
        sectors: sectors
    }, /*#__PURE__*/ $acw62.createElement((0, $eHwNv.AnimatedItems), {
        animationInput: props,
        animationIdPrefix: "recharts-pie-",
        items: sectors,
        previousItemsRef: previousSectorsRef,
        isAnimationActive: props.isAnimationActive,
        animationBegin: props.animationBegin,
        animationDuration: props.animationDuration,
        animationEasing: props.animationEasing,
        onAnimationStart: handleAnimationStart,
        onAnimationEnd: handleAnimationEnd,
        animationInterpolateFn: animationInterpolateFn,
        animationMatchBy: props.animationMatchBy,
        layout: layout
    }, (stepData, animationElapsedTime, isEntrance)=>/*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), null, /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$PieSectors, {
            sectors: stepData,
            activeShape: activeShape,
            inactiveShape: inactiveShape,
            allOtherPieProps: props,
            shape: props.shape,
            id: id,
            animationElapsedTime: animationElapsedTime,
            isAnimating: isAnimating || animationElapsedTime < 1,
            isEntrance: isEntrance
        }))), /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$PieLabelList, {
        showLabels: !isAnimating,
        sectors: sectors,
        props: props
    }), /*#__PURE__*/ $acw62.createElement((0, $ahoy0.PolarLabelContextProvider), {
        cx: (_firstSector$cx = firstSector === null || firstSector === void 0 ? void 0 : firstSector.cx) !== null && _firstSector$cx !== void 0 ? _firstSector$cx : 0,
        cy: (_firstSector$cy = firstSector === null || firstSector === void 0 ? void 0 : firstSector.cy) !== null && _firstSector$cy !== void 0 ? _firstSector$cy : 0,
        innerRadius: (_firstSector$innerRad = firstSector === null || firstSector === void 0 ? void 0 : firstSector.innerRadius) !== null && _firstSector$innerRad !== void 0 ? _firstSector$innerRad : 0,
        outerRadius: (_firstSector$outerRad = firstSector === null || firstSector === void 0 ? void 0 : firstSector.outerRadius) !== null && _firstSector$outerRad !== void 0 ? _firstSector$outerRad : 0,
        startAngle: props.startAngle,
        endAngle: props.endAngle,
        clockWise: false
    }, props.children));
}
var $ced1080254a2467c$export$822a6bceb86ebb81 = {
    animationBegin: 400,
    animationDuration: 1500,
    animationEasing: 'ease',
    animationInterpolateFn: $ced1080254a2467c$var$defaultPieAnimateItems,
    animationMatchBy: (0, $dujP6.matchAppend),
    cx: '50%',
    cy: '50%',
    dataKey: 'value',
    endAngle: 360,
    fill: '#808080',
    hide: false,
    innerRadius: 0,
    isAnimationActive: 'auto',
    label: false,
    labelLine: true,
    legendType: 'rect',
    minAngle: 0,
    nameKey: 'name',
    outerRadius: '80%',
    paddingAngle: 0,
    rootTabIndex: 0,
    shape: $ced1080254a2467c$var$defaultPieSectorShape,
    startAngle: 0,
    stroke: '#fff',
    zIndex: (0, $gKNgz.DefaultZIndexes).area
};
function $ced1080254a2467c$var$PieImpl(props) {
    var id = props.id, propsWithoutId = $ced1080254a2467c$var$_objectWithoutProperties(props, $ced1080254a2467c$var$_excluded3);
    var hide = props.hide, className = props.className, rootTabIndex = props.rootTabIndex;
    var cells = (0, $acw62.useMemo)(()=>(0, $02Ymo.findAllByType)(props.children, (0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea)), [
        props.children
    ]);
    var sectors = (0, $bqlEl.useAppSelector)((state)=>(0, $6b78564e8d7321c1$export$c6af8a90408f4a64)(state, id, cells));
    var previousSectorsRef = (0, $acw62.useRef)(null);
    var layerClass = (0, $9QePP.clsx)('recharts-pie', className);
    if (hide || sectors == null) {
        previousSectorsRef.current = null;
        return /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
            tabIndex: rootTabIndex,
            className: layerClass
        });
    }
    return /*#__PURE__*/ $acw62.createElement((0, $cbiWq.ZIndexLayer), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$SetPieTooltipEntrySettings, {
        dataKey: props.dataKey,
        nameKey: props.nameKey,
        sectors: sectors,
        stroke: props.stroke,
        strokeWidth: props.strokeWidth,
        fill: props.fill,
        name: props.name,
        hide: props.hide,
        tooltipType: props.tooltipType,
        formatter: props.formatter,
        id: id,
        activeShape: props.activeShape
    }), /*#__PURE__*/ $acw62.createElement((0, $lIF05.Layer), {
        tabIndex: rootTabIndex,
        className: layerClass
    }, /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$SectorsWithAnimation, {
        props: $ced1080254a2467c$var$_objectSpread($ced1080254a2467c$var$_objectSpread({}, propsWithoutId), {}, {
            sectors: sectors
        }),
        previousSectorsRef: previousSectorsRef,
        id: id
    })));
}
/**
 * @consumes PolarChartContext
 * @provides LabelListContext
 * @provides CellReader
 */ function $ced1080254a2467c$var$PieFn(outsideProps) {
    var props = (0, $cd9rh.resolveDefaultProps)(outsideProps, $ced1080254a2467c$export$822a6bceb86ebb81);
    var externalId = props.id, propsWithoutId = $ced1080254a2467c$var$_objectWithoutProperties(props, $ced1080254a2467c$var$_excluded4);
    var presentationProps = (0, $4M6vj.svgPropertiesNoEvents)(propsWithoutId);
    return /*#__PURE__*/ $acw62.createElement((0, $jhZFb.RegisterGraphicalItemId), {
        id: externalId,
        type: "pie"
    }, (id)=>/*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $aPPc1.SetPolarGraphicalItem), {
            type: "pie",
            id: id,
            data: propsWithoutId.data,
            dataKey: propsWithoutId.dataKey,
            hide: propsWithoutId.hide,
            angleAxisId: 0,
            radiusAxisId: 0,
            name: propsWithoutId.name,
            nameKey: propsWithoutId.nameKey,
            tooltipType: propsWithoutId.tooltipType,
            legendType: propsWithoutId.legendType,
            fill: propsWithoutId.fill,
            cx: propsWithoutId.cx,
            cy: propsWithoutId.cy,
            startAngle: propsWithoutId.startAngle,
            endAngle: propsWithoutId.endAngle,
            paddingAngle: propsWithoutId.paddingAngle,
            minAngle: propsWithoutId.minAngle,
            innerRadius: propsWithoutId.innerRadius,
            outerRadius: propsWithoutId.outerRadius,
            cornerRadius: propsWithoutId.cornerRadius,
            presentationProps: presentationProps,
            maxRadius: props.maxRadius
        }), /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$SetPiePayloadLegend, $ced1080254a2467c$var$_extends({}, propsWithoutId, {
            id: id
        })), /*#__PURE__*/ $acw62.createElement($ced1080254a2467c$var$PieImpl, $ced1080254a2467c$var$_extends({}, propsWithoutId, {
            id: id
        }))));
}
var $ced1080254a2467c$export$2ae8800cf67c848c = $ced1080254a2467c$var$PieFn;
// @ts-expect-error we need to set the displayName for debugging purposes
$ced1080254a2467c$export$2ae8800cf67c848c.displayName = 'Pie';


var $acw62 = parcelRequire("acw62");

var $bIbT7 = parcelRequire("bIbT7");

var $acw62 = parcelRequire("acw62");

var $idHPp = parcelRequire("idHPp");

var $1SwgK = parcelRequire("1SwgK");

var $f5A9j = parcelRequire("f5A9j");

var $iWBQe = parcelRequire("iWBQe");

var $bHRfD = parcelRequire("bHRfD");

var $acw62 = parcelRequire("acw62");

var $bqlEl = parcelRequire("bqlEl");

var $i8m83 = parcelRequire("i8m83");
function $6637cd3614ceca2f$export$babaff6c249d1f4b(props) {
    var dispatch = (0, $bqlEl.useAppDispatch)();
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $i8m83.updatePolarOptions)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}



var $iz2Aq = parcelRequire("iz2Aq");

var $cd9rh = parcelRequire("cd9rh");

var $j6mdh = parcelRequire("j6mdh");
var $c432dfc9cee3a701$var$_excluded = [
    "layout"
];
function $c432dfc9cee3a701$var$_extends() {
    return $c432dfc9cee3a701$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c432dfc9cee3a701$var$_extends.apply(null, arguments);
}
function $c432dfc9cee3a701$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c432dfc9cee3a701$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c432dfc9cee3a701$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $c432dfc9cee3a701$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c432dfc9cee3a701$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c432dfc9cee3a701$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c432dfc9cee3a701$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c432dfc9cee3a701$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c432dfc9cee3a701$var$_defineProperty(e, r, t) {
    return (r = $c432dfc9cee3a701$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $c432dfc9cee3a701$var$_toPropertyKey(t) {
    var i = $c432dfc9cee3a701$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $c432dfc9cee3a701$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c432dfc9cee3a701$var$defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var $c432dfc9cee3a701$export$20a5c0f1a1e0268d = $c432dfc9cee3a701$var$_objectSpread({
    accessibilityLayer: true,
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: $c432dfc9cee3a701$var$defaultMargin,
    reverseStackOrder: false,
    syncMethod: 'index',
    layout: 'radial',
    responsive: false,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
}, (0, $j6mdh.initialEventSettingsState));
var $c432dfc9cee3a701$export$8de722e497513838 = /*#__PURE__*/ (0, $acw62.forwardRef)(function PolarChart(props, ref) {
    var _polarChartProps$id;
    var polarChartProps = (0, $cd9rh.resolveDefaultProps)(props.categoricalChartProps, $c432dfc9cee3a701$export$20a5c0f1a1e0268d);
    var layout = polarChartProps.layout, otherCategoricalProps = $c432dfc9cee3a701$var$_objectWithoutProperties(polarChartProps, $c432dfc9cee3a701$var$_excluded);
    var chartName = props.chartName, defaultTooltipEventType = props.defaultTooltipEventType, validateTooltipEventTypes = props.validateTooltipEventTypes, tooltipPayloadSearcher = props.tooltipPayloadSearcher;
    var options = {
        chartName: chartName,
        defaultTooltipEventType: defaultTooltipEventType,
        validateTooltipEventTypes: validateTooltipEventTypes,
        tooltipPayloadSearcher: tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ $acw62.createElement((0, $idHPp.RechartsStoreProvider), {
        preloadedState: {
            options: options
        },
        reduxStoreName: (_polarChartProps$id = polarChartProps.id) !== null && _polarChartProps$id !== void 0 ? _polarChartProps$id : chartName
    }, /*#__PURE__*/ $acw62.createElement((0, $1SwgK.ChartDataContextProvider), {
        chartData: polarChartProps.data
    }), /*#__PURE__*/ $acw62.createElement((0, $f5A9j.ReportMainChartProps), {
        layout: layout,
        margin: polarChartProps.margin
    }), /*#__PURE__*/ $acw62.createElement((0, $bHRfD.ReportEventSettings), {
        throttleDelay: polarChartProps.throttleDelay,
        throttledEvents: polarChartProps.throttledEvents
    }), /*#__PURE__*/ $acw62.createElement((0, $iWBQe.ReportChartProps), {
        baseValue: undefined,
        accessibilityLayer: polarChartProps.accessibilityLayer,
        barCategoryGap: polarChartProps.barCategoryGap,
        maxBarSize: polarChartProps.maxBarSize,
        stackOffset: polarChartProps.stackOffset,
        barGap: polarChartProps.barGap,
        barSize: polarChartProps.barSize,
        syncId: polarChartProps.syncId,
        syncMethod: polarChartProps.syncMethod,
        className: polarChartProps.className,
        reverseStackOrder: polarChartProps.reverseStackOrder
    }), /*#__PURE__*/ $acw62.createElement((0, $6637cd3614ceca2f$export$babaff6c249d1f4b), {
        cx: polarChartProps.cx,
        cy: polarChartProps.cy,
        startAngle: polarChartProps.startAngle,
        endAngle: polarChartProps.endAngle,
        innerRadius: polarChartProps.innerRadius,
        outerRadius: polarChartProps.outerRadius
    }), /*#__PURE__*/ $acw62.createElement((0, $iz2Aq.CategoricalChart), $c432dfc9cee3a701$var$_extends({}, otherCategoricalProps, {
        ref: ref
    })));
});



var $cd9rh = parcelRequire("cd9rh");
function $7b34d738dd6aa7f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b34d738dd6aa7f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b34d738dd6aa7f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7b34d738dd6aa7f6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b34d738dd6aa7f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7b34d738dd6aa7f6$var$_defineProperty(e, r, t) {
    return (r = $7b34d738dd6aa7f6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7b34d738dd6aa7f6$var$_toPropertyKey(t) {
    var i = $7b34d738dd6aa7f6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7b34d738dd6aa7f6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7b34d738dd6aa7f6$var$allowedTooltipTypes = [
    'item'
];
var $7b34d738dd6aa7f6$export$3c2b6064ceeac6d0 = $7b34d738dd6aa7f6$var$_objectSpread($7b34d738dd6aa7f6$var$_objectSpread({}, (0, $c432dfc9cee3a701$export$20a5c0f1a1e0268d)), {}, {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360
});
var $7b34d738dd6aa7f6$export$b99d3348f709c998 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var propsWithDefaults = (0, $cd9rh.resolveDefaultProps)(props, $7b34d738dd6aa7f6$export$3c2b6064ceeac6d0);
    return /*#__PURE__*/ $acw62.createElement((0, $c432dfc9cee3a701$export$8de722e497513838), {
        chartName: "PieChart",
        defaultTooltipEventType: "item",
        validateTooltipEventTypes: $7b34d738dd6aa7f6$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $bIbT7.arrayTooltipSearcher),
        categoricalChartProps: propsWithDefaults,
        ref: ref
    });
});


var $mjyu0 = parcelRequire("mjyu0");
const $67f1f36998452577$export$96319003795acece = ({ data: data, disableAnimation: disableAnimation, size: size = 'default' })=>{
    const sm = size === 'default' && (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('sm'));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $mjyu0.ResponsiveContainer), {
        width: "100%",
        height: "100%",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7b34d738dd6aa7f6$export$b99d3348f709c998), {
            margin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ced1080254a2467c$export$2ae8800cf67c848c), {
                dataKey: "value",
                data: data,
                innerRadius: sm ? 75 : 50,
                outerRadius: sm ? 100 : 70,
                isAnimationActive: disableAnimation ? false : true,
                children: data.map((entry, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b43ffe30f81b14f2$export$f6f0c3fe4ec306ea), {
                        fill: entry.color
                    }, `cell-${index}`))
            })
        })
    });
};


const $ae44eaa5e1f441cd$export$f73d0f25083035c = {
    unit: 'kilowatt-hour',
    style: 'unit',
    maximumFractionDigits: 1
};
const $ae44eaa5e1f441cd$export$60332b2344f7fe41 = ({ title: title, icon: icon, pieChart: pieChart, lines: lines, content: content, visibility: visibility })=>{
    const { share: share } = $ae44eaa5e1f441cd$export$bce337001974ee9c({
        title: title,
        pieChart: pieChart
    });
    if (!(0, $bCDrB.useVisibility)(visibility)) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            p: {
                xs: 0,
                md: 1
            },
            pb: {
                xs: 2,
                md: 0
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
            sx: {},
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                    sx: {
                        gap: 1
                    },
                    children: [
                        icon && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                color: '#989898',
                                '& svg': {
                                    fontSize: '1.5rem'
                                },
                                display: 'flex',
                                alignItems: 'center'
                            },
                            children: icon
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "h3",
                            children: title
                        }),
                        share
                    ]
                }),
                pieChart && /*#__PURE__*/ (0, $ayMG0.jsx)($ae44eaa5e1f441cd$export$8c8eb0ede37e8dc5, {
                    data: pieChart,
                    sx: {
                        mt: 2,
                        mb: 5
                    }
                }),
                lines && lines.map(([label, value], index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                        sx: {
                            justifyContent: 'space-between',
                            mt: 1,
                            borderBottom: index !== lines.length - 1 ? '1px solid #ECECEC' : 'none',
                            pt: 0.5,
                            pb: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                color: "textSecondary",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "body2",
                                children: value
                            })
                        ]
                    }, index)),
                content && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        mt: 2
                    },
                    children: content
                })
            ]
        })
    });
};
const $ae44eaa5e1f441cd$export$8c8eb0ede37e8dc5 = ({ data: data, sx: sx = {}, disableAnimation: disableAnimation, size: size = 'default', legendX: legendX })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
        sx: {
            justifyContent: 'space-between',
            gap: 1,
            ...sx
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                sx: {
                    gap: 1
                },
                children: [
                    legendX,
                    data.filter(({ label: label, labelValue: labelValue })=>label && typeof labelValue !== 'undefined').map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $e16f5e4fd9293f6d$export$81d25ce4f8051170), {
                            label: item.label,
                            value: item.labelValue,
                            color: item.color,
                            disableLineBreak: size === 'small'
                        }, index))
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    width: size === 'default' ? {
                        xs: 140,
                        sm: 200
                    } : 140,
                    height: size === 'default' ? {
                        xs: 140,
                        sm: 200
                    } : 140
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $67f1f36998452577$export$96319003795acece), {
                    data: data,
                    disableAnimation: disableAnimation,
                    size: size
                })
            })
        ]
    });
};
const $ae44eaa5e1f441cd$export$bce337001974ee9c = ({ title: title, pieChart: pieChart })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const [contentMounted, setContentMounted] = (0, $acw62.useState)(false);
    const contentRef = (0, $acw62.useRef)(null);
    const onShare = async ()=>{
        setContentMounted(true);
        const startTime = Date.now();
        while(!contentRef.current){
            if (Date.now() - startTime > 1000) return;
            await new Promise((resolve)=>setTimeout(resolve, 50));
        }
        const dataUrl = await (0, $38cdb197accefc7f$export$1b1f83de2125eb4c)(contentRef.current, {
            quality: 1,
            scale: 3
        });
        setContentMounted(false);
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "reports.share.title",
                defaultMessage: "Sd\xedlet report"
            }),
            titleProps: {
                variant: 'h2',
                sx: {
                    textAlign: 'center'
                }
            },
            description: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            textAlign: 'center',
                            mb: 2
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "reports.share.description",
                            defaultMessage: "Vybran\xfd sn\xedmek m\u016F\u017Eete sd\xedlet s ostatn\xedmi."
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        component: "img",
                        src: dataUrl,
                        sx: {
                            width: '100%',
                            height: 'auto'
                        }
                    })
                ]
            }),
            ...(0, $bf83a6995bdb44c9$export$1cd011aac104c991),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "reports.share.share",
                defaultMessage: "Sd\xedlet report"
            }),
            confirmationButtonProps: {
                fullWidth: true,
                variant: 'contained',
                startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fbb4c0b471bc91f$export$c9915453de10000b), {})
            },
            hideCancelButton: true
        }).then(async ()=>{
            if ('share' in navigator) {
                const base64Response = await fetch(dataUrl);
                const blob = await base64Response.blob();
                const file = new File([
                    blob
                ], 'statistics.png', {
                    type: 'image/png'
                });
                await navigator.share({
                    files: [
                        file
                    ]
                });
            } else {
                const link = document.createElement('a');
                link.download = 'statistics.png';
                link.href = dataUrl;
                link.click();
            }
        }, ()=>{
        // noop
        });
    };
    return {
        share: pieChart ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.share_report",
                        defaultMessage: "Sd\xedlet report"
                    }),
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        sx: {
                            marginLeft: 'auto'
                        },
                        size: "small",
                        onClick: onShare,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fbb4c0b471bc91f$export$c9915453de10000b), {})
                    })
                }),
                contentMounted && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8GoiI.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                        ref: contentRef,
                        sx: {
                            width: 420,
                            p: 2,
                            pb: 1,
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            borderColor: 'primary.main',
                            borderWidth: 1,
                            borderStyle: 'solid',
                            overflow: 'hidden'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                variant: "h3",
                                sx: {
                                    textTransform: 'capitalize'
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($ae44eaa5e1f441cd$export$8c8eb0ede37e8dc5, {
                                data: pieChart,
                                disableAnimation: true,
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bff506feb6afd749$export$63a9dbd0460b69ca), {
                                sx: {
                                    height: '30px !important',
                                    width: '70px !important',
                                    display: 'block',
                                    mx: 'auto'
                                }
                            })
                        ]
                    })
                })
            ]
        }) : null
    };
};




var $iD7Z3 = parcelRequire("iD7Z3");
const $aa15e1223001d2e7$var$Reports = ()=>{
    const premium = (0, $2lSXC.useSelector)(({ variables: { PREMIUM: PREMIUM } })=>PREMIUM);
    const { data: data, isLoading: isLoading, isError: isError } = (0, $iH29s.trpc).reports.list.useQuery();
    if (!premium) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
            layout: "list",
            children: [
                isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    color: "error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "error",
                        defaultMessage: "Chyba p\u0159i na\u010D\xedt\xe1n\xed reportu."
                    })
                }),
                isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '1fr 1fr'
                        },
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 150
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '1fr 1fr'
                        },
                        gap: 2
                    },
                    children: data && data.map((report)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($aa15e1223001d2e7$var$ReportCard, {
                            report: report
                        }, report.month);
                    })
                })
            ]
        })
    });
};
const $aa15e1223001d2e7$var$pieChartDataPlaceholder = [
    {
        value: 50,
        label: '',
        color: '#989898'
    },
    {
        value: 50,
        label: '',
        color: '#606060'
    }
];
const $aa15e1223001d2e7$var$ReportCard = ({ report: report })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const navigate = (0, $aphAM.useNavigate)();
    const { month: month } = report;
    const title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
        value: new Date(month),
        day: undefined,
        month: "long",
        year: "numeric"
    });
    const pieChart = report.status === 'generated' ? [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "reports.pv_consumption",
                defaultMessage: "Spot\u0159eba z FVE"
            }, 0),
            labelValue: formatNumber(report.payload.pvProduction - report.payload.emOverflow, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
            value: report.payload.pvProduction - report.payload.emOverflow,
            color: (0, $iD7Z3.colors).primary
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "reports.grid_consumption",
                defaultMessage: "Odb\u011Br ze s\xedt\u011B"
            }, 0),
            labelValue: formatNumber(report.payload.emConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
            value: report.payload.emConsumed,
            color: (0, $iD7Z3.colors).darkBlue
        }
    ] : undefined;
    const { share: share } = (0, $ae44eaa5e1f441cd$export$bce337001974ee9c)({
        title: title,
        pieChart: pieChart
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        sx: {
            cursor: 'pointer',
            '&:hover': {
                bgcolor: 'action.hover'
            }
        },
        onClick: ()=>navigate(`/reporty/${month}`),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                sx: {
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "h3",
                        sx: {
                            textTransform: 'capitalize'
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            color: '#989898',
                            '& svg': {
                                fontSize: '1.5rem'
                            },
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDXfy.default), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        onClick: (e)=>e.stopPropagation(),
                        sx: {
                            ml: 'auto'
                        },
                        children: share
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$8c8eb0ede37e8dc5), {
                data: pieChart || $aa15e1223001d2e7$var$pieChartDataPlaceholder,
                disableAnimation: true,
                legendX: pieChart ? undefined : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "body1",
                    sx: {
                        textAlign: 'center'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "report.not_generated",
                        defaultMessage: "Vytvo\u0159it report kliknut\xedm"
                    })
                })
            })
        ]
    }, month);
};
var $aa15e1223001d2e7$export$2e2bcd8739ae039 = $aa15e1223001d2e7$var$Reports;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $u24M4 = parcelRequire("u24M4");
var $4WLS9 = parcelRequire("4WLS9");
var $7X4mk = parcelRequire("7X4mk");

var $8Indx = parcelRequire("8Indx");

var $1u0KT = parcelRequire("1u0KT");

var $1Ikg4 = parcelRequire("1Ikg4");

var $7kpn1 = parcelRequire("7kpn1");
var $82aMg = parcelRequire("82aMg");

var $3qSdM = parcelRequire("3qSdM");

var $eEJPp = parcelRequire("eEJPp");

var $3z1Ay = parcelRequire("3z1Ay");

var $9QePP = parcelRequire("9QePP");


var $acw62 = parcelRequire("acw62");

var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $f294fcfa4ab0ec9b$export$13091bac7ca2fdc3(slot) {
    return (0, $4Cod0.default)('MuiMasonry', slot);
}
const $f294fcfa4ab0ec9b$var$masonryClasses = (0, $beCSm.default)('MuiMasonry', [
    'root'
]);
var $f294fcfa4ab0ec9b$export$2e2bcd8739ae039 = $f294fcfa4ab0ec9b$var$masonryClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $388fd205d718e5e5$export$efe1b1f313878622 = (val)=>{
    return Number(val.replace('px', ''));
};
const $388fd205d718e5e5$var$lineBreakStyle = {
    flexBasis: '100%',
    width: 0,
    margin: 0,
    padding: 0
};
const $388fd205d718e5e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $f294fcfa4ab0ec9b$export$13091bac7ca2fdc3), classes);
};
const $388fd205d718e5e5$export$3d2f074408bd1b82 = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        width: '100%',
        display: 'flex',
        flexFlow: 'column wrap',
        alignContent: 'flex-start',
        boxSizing: 'border-box',
        '& > *': {
            boxSizing: 'border-box'
        }
    };
    const stylesSSR = {};
    // Only applicable for Server-Side Rendering
    if (ownerState.isSSR) {
        const orderStyleSSR = {};
        const defaultSpacing = $388fd205d718e5e5$export$efe1b1f313878622(theme.spacing(ownerState.defaultSpacing));
        for(let i = 1; i <= ownerState.defaultColumns; i += 1)orderStyleSSR[`&:nth-of-type(${ownerState.defaultColumns}n+${i % ownerState.defaultColumns})`] = {
            order: i
        };
        stylesSSR.height = ownerState.defaultHeight;
        stylesSSR.margin = -(defaultSpacing / 2);
        stylesSSR['& > *'] = {
            ...styles['& > *'],
            ...orderStyleSSR,
            margin: defaultSpacing / 2,
            width: `calc(${(100 / ownerState.defaultColumns).toFixed(2)}% - ${defaultSpacing}px)`
        };
        return {
            ...styles,
            ...stylesSSR
        };
    }
    const spacingValues = (0, $82aMg.resolveBreakpointValues)({
        values: ownerState.spacing,
        breakpoints: theme.breakpoints.values
    });
    const transformer = (0, $7kpn1.createUnarySpacing)(theme);
    const spacingStyleFromPropValue = (propValue)=>{
        let spacing;
        // in case of string/number value
        if (typeof propValue === 'string' && !Number.isNaN(Number(propValue)) || typeof propValue === 'number') {
            const themeSpacingValue = Number(propValue);
            spacing = (0, $7kpn1.getValue)(transformer, themeSpacingValue);
        } else spacing = propValue;
        return {
            margin: `calc(0px - (${spacing} / 2))`,
            '& > *': {
                margin: `calc(${spacing} / 2)`
            },
            ...ownerState.maxColumnHeight && {
                height: typeof spacing === 'number' ? Math.ceil(ownerState.maxColumnHeight + $388fd205d718e5e5$export$efe1b1f313878622(spacing)) : `calc(${ownerState.maxColumnHeight}px + ${spacing})`
            }
        };
    };
    styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, spacingValues, spacingStyleFromPropValue));
    const columnValues = (0, $82aMg.resolveBreakpointValues)({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
    });
    const columnStyleFromPropValue = (propValue)=>{
        const columnValue = Number(propValue);
        const width = `${(100 / columnValue).toFixed(2)}%`;
        const spacing = typeof spacingValues === 'string' && !Number.isNaN(Number(spacingValues)) || typeof spacingValues === 'number' ? (0, $7kpn1.getValue)(transformer, Number(spacingValues)) : '0px';
        return {
            '& > *': {
                width: `calc(${width} - ${spacing})`
            }
        };
    };
    styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, columnValues, columnStyleFromPropValue));
    // configure width for responsive spacing values
    if (typeof spacingValues === 'object') styles = (0, $3z1Ay.default)(styles, (0, $82aMg.handleBreakpoints)({
        theme: theme
    }, spacingValues, (propValue, breakpoint)=>{
        if (breakpoint) {
            const themeSpacingValue = Number(propValue);
            const lastBreakpoint = Object.keys(columnValues).pop();
            const spacing = (0, $7kpn1.getValue)(transformer, themeSpacingValue);
            const column = typeof columnValues === 'object' ? columnValues[breakpoint] || columnValues[lastBreakpoint] : columnValues;
            const width = `${(100 / column).toFixed(2)}%`;
            return {
                '& > *': {
                    width: `calc(${width} - ${spacing})`
                }
            };
        }
        return null;
    }));
    return styles;
};
const $388fd205d718e5e5$var$MasonryRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiMasonry',
    slot: 'Root'
})($388fd205d718e5e5$export$3d2f074408bd1b82);
const $388fd205d718e5e5$var$Masonry = /*#__PURE__*/ $acw62.forwardRef(function Masonry(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiMasonry'
    });
    const { children: children, className: className, component: component = 'div', columns: columns = 4, spacing: spacing = 1, sequential: sequential = false, defaultColumns: defaultColumns, defaultHeight: defaultHeight, defaultSpacing: defaultSpacing, ...other } = props;
    const masonryRef = $acw62.useRef();
    const [maxColumnHeight, setMaxColumnHeight] = $acw62.useState();
    const isSSR = !maxColumnHeight && defaultHeight && defaultColumns !== undefined && defaultSpacing !== undefined;
    const [numberOfLineBreaks, setNumberOfLineBreaks] = $acw62.useState(isSSR ? defaultColumns - 1 : 0);
    const ownerState = {
        ...props,
        spacing: spacing,
        columns: columns,
        maxColumnHeight: maxColumnHeight,
        defaultColumns: defaultColumns,
        defaultHeight: defaultHeight,
        defaultSpacing: defaultSpacing,
        isSSR: isSSR
    };
    const classes = $388fd205d718e5e5$var$useUtilityClasses(ownerState);
    const handleResize = $acw62.useCallback((masonryChildren)=>{
        if (!masonryRef.current || !masonryChildren || masonryChildren.length === 0) return;
        const masonry = masonryRef.current;
        const masonryFirstChild = masonryRef.current.firstChild;
        const parentWidth = masonry.clientWidth;
        const firstChildWidth = masonryFirstChild.clientWidth;
        if (parentWidth === 0 || firstChildWidth === 0) return;
        const firstChildComputedStyle = window.getComputedStyle(masonryFirstChild);
        const firstChildMarginLeft = $388fd205d718e5e5$export$efe1b1f313878622(firstChildComputedStyle.marginLeft);
        const firstChildMarginRight = $388fd205d718e5e5$export$efe1b1f313878622(firstChildComputedStyle.marginRight);
        const currentNumberOfColumns = Math.round(parentWidth / (firstChildWidth + firstChildMarginLeft + firstChildMarginRight));
        const columnHeights = new Array(currentNumberOfColumns).fill(0);
        let skip = false;
        let nextOrder = 1;
        masonry.childNodes.forEach((child)=>{
            if (child.nodeType !== Node.ELEMENT_NODE || child.dataset.class === 'line-break' || skip) return;
            const childComputedStyle = window.getComputedStyle(child);
            const childMarginTop = $388fd205d718e5e5$export$efe1b1f313878622(childComputedStyle.marginTop);
            const childMarginBottom = $388fd205d718e5e5$export$efe1b1f313878622(childComputedStyle.marginBottom);
            // if any one of children isn't rendered yet, masonry's height shouldn't be computed yet
            const childHeight = $388fd205d718e5e5$export$efe1b1f313878622(childComputedStyle.height) ? Math.ceil($388fd205d718e5e5$export$efe1b1f313878622(childComputedStyle.height)) + childMarginTop + childMarginBottom : 0;
            if (childHeight === 0) {
                skip = true;
                return;
            }
            // if there is a nested image that isn't rendered yet, masonry's height shouldn't be computed yet
            for(let i = 0; i < child.childNodes.length; i += 1){
                const nestedChild = child.childNodes[i];
                if (nestedChild.tagName === 'IMG' && nestedChild.clientHeight === 0) {
                    skip = true;
                    break;
                }
            }
            if (!skip) {
                if (sequential) {
                    columnHeights[nextOrder - 1] += childHeight;
                    child.style.order = nextOrder;
                    nextOrder += 1;
                    if (nextOrder > currentNumberOfColumns) nextOrder = 1;
                } else {
                    // find the current shortest column (where the current item will be placed)
                    const currentMinColumnIndex = columnHeights.indexOf(Math.min(...columnHeights));
                    columnHeights[currentMinColumnIndex] += childHeight;
                    const order = currentMinColumnIndex + 1;
                    child.style.order = order;
                }
            }
        });
        if (!skip) // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $1u0KT.flushSync(()=>{
            setMaxColumnHeight(Math.max(...columnHeights));
            setNumberOfLineBreaks(currentNumberOfColumns > 0 ? currentNumberOfColumns - 1 : 0);
        });
    }, [
        sequential
    ]);
    (0, $eEJPp.default)(()=>{
        // IE and old browsers are not supported
        if (typeof ResizeObserver === 'undefined') return undefined;
        let animationFrame;
        const resizeObserver = new ResizeObserver(()=>{
            // see https://github.com/mui/material-ui/issues/36909
            animationFrame = requestAnimationFrame(handleResize);
        });
        if (masonryRef.current) masonryRef.current.childNodes.forEach((childNode)=>{
            resizeObserver.observe(childNode);
        });
        return ()=>{
            if (animationFrame) cancelAnimationFrame(animationFrame);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        columns,
        spacing,
        children,
        handleResize
    ]);
    const handleRef = (0, $3qSdM.default)(ref, masonryRef);
    //  columns are likely to have different heights and hence can start to merge;
    //  a line break at the end of each column prevents columns from merging
    const lineBreaks = new Array(numberOfLineBreaks).fill('').map((_, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            "data-class": "line-break",
            style: {
                ...$388fd205d718e5e5$var$lineBreakStyle,
                order: index + 1
            }
        }, index));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($388fd205d718e5e5$var$MasonryRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        ref: handleRef,
        ownerState: ownerState,
        ...other,
        children: [
            children,
            lineBreaks
        ]
    });
});
var $388fd205d718e5e5$export$2e2bcd8739ae039 = $388fd205d718e5e5$var$Masonry;



var $iH29s = parcelRequire("iH29s");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $5R532 = parcelRequire("5R532");

var $2lSXC = parcelRequire("2lSXC");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");


var $bd9zl = parcelRequire("bd9zl");
var $7pTac = parcelRequire("7pTac");

var $5R532 = parcelRequire("5R532");







var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $073bc38baf314d0e$export$7a00c9d79990c3e2 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2VxZV.default), {
        viewBox: "0 0 48 49",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                clipPath: "url(#clip0_614_2767)",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                    d: "M35.5078 21.4571H30.5081V8.43722C30.5081 5.677 29.3624 4.81769 28.6853 4.55729C28.0083 4.29689 26.5761 4.1667 24.7533 6.24988L9.96274 23.0716C8.40036 24.8683 8.66075 26.1963 8.94719 26.8473C9.23363 27.4723 10.0669 28.5399 12.4365 28.5399H17.4362V41.5598C17.4362 44.32 18.5819 45.1793 19.2589 45.4397C19.4673 45.5179 19.7277 45.5699 20.0401 45.5699C20.8213 45.5699 21.889 45.2054 23.1909 43.7211L37.9815 26.9255C39.5439 25.1548 39.3096 23.8007 39.0231 23.1757C38.7367 22.5247 37.9034 21.4571 35.5078 21.4571ZM36.4192 25.5714L21.6286 42.367C20.7692 43.3566 20.1443 43.5649 19.9881 43.4868C19.8318 43.4347 19.4933 42.8878 19.4933 41.5598V27.4983C19.4933 26.9255 19.0246 26.4567 18.4517 26.4567H12.4626C11.4991 26.4567 10.9783 26.2224 10.8741 25.962C10.77 25.7276 10.9262 25.1548 11.5512 24.4256L26.3157 7.62999C27.0969 6.74463 27.6698 6.48424 27.8781 6.48424C27.9041 6.48424 27.9302 6.48424 27.9302 6.48424C28.0864 6.53632 28.4249 7.08315 28.4249 8.41118V22.4987C28.4249 23.0716 28.8937 23.5403 29.4665 23.5403H35.5078C36.4712 23.5403 37.0181 23.8007 37.1222 24.035C37.2264 24.2694 37.0701 24.8423 36.4192 25.5714Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("clipPath", {
                    id: "clip0_614_2767",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                        width: "30.5186",
                        height: "41.1428",
                        fill: "currentColor",
                        transform: "translate(8.74023 4.427)"
                    })
                })
            })
        ]
    });




var $iD7Z3 = parcelRequire("iD7Z3");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $klPA2 = parcelRequire("klPA2");

var $kan35 = parcelRequire("kan35");
var $acw62 = parcelRequire("acw62");

var $bIbT7 = parcelRequire("bIbT7");

var $fC5w9 = parcelRequire("fC5w9");
var $669260e8074ac2f0$var$allowedTooltipTypes = [
    'axis'
];
var $669260e8074ac2f0$export$f881f4f9e4007a57 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ $acw62.createElement((0, $fC5w9.CartesianChart), {
        chartName: "ComposedChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: $669260e8074ac2f0$var$allowedTooltipTypes,
        tooltipPayloadSearcher: (0, $bIbT7.arrayTooltipSearcher),
        categoricalChartProps: props,
        ref: ref
    });
});


var $lluj3 = parcelRequire("lluj3");
var $mjyu0 = parcelRequire("mjyu0");
var $kMGAE = parcelRequire("kMGAE");
var $1dtDd = parcelRequire("1dtDd");

var $2u93q = parcelRequire("2u93q");

var $iD7Z3 = parcelRequire("iD7Z3");


var $5R532 = parcelRequire("5R532");
const $6a051d58ddf9d1bb$export$5ccc11eb6ce7e3bb = ({ data: data })=>{
    const formattedData = (0, $acw62.useMemo)(()=>{
        return (0, $f1q41.chain)(data).orderBy([
            'time'
        ], [
            'asc'
        ]).map((d)=>{
            return {
                ...d
            };
        }).value();
    }, [
        data
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    width: '100%',
                    height: {
                        xs: 180,
                        sm: 250
                    }
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $mjyu0.ResponsiveContainer), {
                    width: "100%",
                    height: "100%",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $669260e8074ac2f0$export$f881f4f9e4007a57), {
                        data: formattedData,
                        margin: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("defs", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "colorPvProduction",
                                        x1: "0",
                                        y1: "0",
                                        x2: "0",
                                        y2: "1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "5%",
                                                stopColor: (0, $iD7Z3.colors).primary,
                                                stopOpacity: 0.3
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "95%",
                                                stopColor: (0, $iD7Z3.colors).primary,
                                                stopOpacity: 0.1
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "colorGrid",
                                        x1: "0",
                                        y1: "0",
                                        x2: "0",
                                        y2: "1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "5%",
                                                stopColor: (0, $iD7Z3.colors).darkBlue,
                                                stopOpacity: 0.4
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "95%",
                                                stopColor: (0, $iD7Z3.colors).darkBlue,
                                                stopOpacity: 0.2
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("linearGradient", {
                                        id: "colorConsumption",
                                        x1: "0",
                                        y1: "0",
                                        x2: "0",
                                        y2: "1",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "5%",
                                                stopColor: (0, $iD7Z3.colors).dodgerBlue,
                                                stopOpacity: 0.4
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("stop", {
                                                offset: "95%",
                                                stopColor: (0, $iD7Z3.colors).dodgerBlue,
                                                stopOpacity: 0.1
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kan35.CartesianGrid), {
                                strokeDasharray: "0",
                                stroke: "#e0e0e0",
                                vertical: false
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                                yAxisId: "left",
                                axisLine: false,
                                tickLine: false,
                                width: 20,
                                tickFormatter: (value)=>`${value}`,
                                style: {
                                    fontFamily: $2u93q.fontFamily,
                                    color: (0, $iD7Z3.colors).darkBlue
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1dtDd.YAxis), {
                                yAxisId: "right",
                                orientation: "right",
                                domain: [
                                    0,
                                    100
                                ],
                                ticks: [
                                    0,
                                    25,
                                    50,
                                    75,
                                    100
                                ],
                                tickFormatter: (value)=>`${value}%`,
                                axisLine: false,
                                tickLine: false,
                                width: 40,
                                style: {
                                    fontFamily: $2u93q.fontFamily,
                                    color: (0, $iD7Z3.colors).darkBlue
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kMGAE.XAxis), {
                                dataKey: "time",
                                axisLine: false,
                                tickLine: false,
                                ticks: [
                                    3,
                                    6,
                                    9,
                                    12,
                                    15,
                                    18,
                                    21
                                ],
                                width: 40
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                yAxisId: "left",
                                type: "monotone",
                                dataKey: "pvProduction",
                                stroke: (0, $iD7Z3.colors).primary,
                                strokeWidth: 3,
                                fill: "url(#colorPvProduction)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                yAxisId: "left",
                                type: "monotone",
                                dataKey: "grid",
                                stroke: (0, $iD7Z3.colors).darkBlue,
                                strokeWidth: 3,
                                fill: "url(#colorGrid)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $551fcf7b84a33486$export$ea1a111407f37557), {
                                yAxisId: "left",
                                type: "monotone",
                                dataKey: "consumption",
                                stroke: (0, $iD7Z3.colors).dodgerBlue,
                                strokeWidth: 3,
                                fill: "url(#colorConsumption)"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lluj3.Line), {
                                yAxisId: "right",
                                type: "monotone",
                                dataKey: "batterySoc",
                                stroke: (0, $iD7Z3.colors).richBlack,
                                strokeWidth: 3,
                                dot: false,
                                fill: "none"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                sx: {
                    gap: 1,
                    mt: 2,
                    flexWrap: 'wrap'
                },
                children: [
                    {
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "report.avg_day_chart.pv_production",
                            defaultMessage: "V\xfdroba FVE"
                        }),
                        color: (0, $iD7Z3.colors).primary
                    },
                    {
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "report.avg_day_chart.consumption",
                            defaultMessage: "Spot\u0159eba"
                        }),
                        color: (0, $iD7Z3.colors).dodgerBlue
                    },
                    {
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "report.avg_day_chart.grid",
                            defaultMessage: "Distribu\u010Dn\xed s\xed\u0165"
                        }),
                        color: (0, $iD7Z3.colors).darkBlue
                    },
                    {
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "report.avg_day_chart.battery_soc",
                            defaultMessage: "Nabit\xed baterie"
                        }),
                        color: (0, $iD7Z3.colors).richBlack,
                        colorShape: 'line'
                    }
                ].map((item, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e16f5e4fd9293f6d$export$81d25ce4f8051170), {
                            ...item
                        })
                    }, index))
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $340bed7c0ce7e904$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m19 8-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4z"
}), 'Cached');



var $u24M4 = parcelRequire("u24M4");
var $12gtR = parcelRequire("12gtR");

var $jDfxe = parcelRequire("jDfxe");

var $7pTac = parcelRequire("7pTac");

var $iH29s = parcelRequire("iH29s");

const $2bc7f0e57349642e$export$e04dc0fbfd7b5bfe = ({ month: month })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const utils = (0, $iH29s.trpc).useContext();
    const { mutate: mutate } = (0, $iH29s.trpc).reports.generate.useMutation({
        onSuccess: ()=>{
            utils.reports.get.invalidate({
                month: month
            });
        }
    });
    const generate = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "reports.regenerate_report_confirm_title",
                defaultMessage: "Znovu vygenerovat report?"
            }),
            ...(0, $bf83a6995bdb44c9$export$1cd011aac104c991)
        }).then(()=>{
            mutate({
                month: month
            });
        }, ()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "reports.regenerate_report",
            defaultMessage: "Znovu vygenerovat report"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
            size: "small",
            onClick: generate,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $340bed7c0ce7e904$export$2e2bcd8739ae039), {})
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $ea8f9fce582fedc8$export$e5d44a4194605db9 = (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 24 24",
        ...props,
        sx: {
            fill: 'none',
            ...props.sx || {}
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M16.2426 7.75738C18.5858 10.1005 18.5858 13.8995 16.2426 16.2427M7.75736 16.2426C5.41421 13.8995 5.41421 10.1005 7.75736 7.75735M4.92893 19.0711C1.02369 15.1658 1.02369 8.8342 4.92893 4.92896M19.0711 4.929C22.9763 8.83424 22.9763 15.1659 19.0711 19.0711M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8955 10.8954 10 12 10C13.1046 10 14 10.8955 14 12Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });



var $2lSXC = parcelRequire("2lSXC");


const $3c41b2f5980aec24$export$e222a9442244111a = ({ consumptionByCard: consumptionByCard })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const rfidCards = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_CARDS);
    const entries = Object.entries(rfidCards ?? {});
    if (entries.length === 0) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "reports.rfid_cards",
            defaultMessage: "RFID karty"
        }),
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea8f9fce582fedc8$export$e5d44a4194605db9), {}),
        visibility: {
            variableIds: [
                'WB_INSTALL',
                'RFID_VISIBLE'
            ]
        },
        lines: entries.map(([id, { name: name }])=>[
                name,
                formatNumber(consumptionByCard?.[id] ?? 0, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
            ])
    });
};




var $2lSXC = parcelRequire("2lSXC");

var $fK5g3 = parcelRequire("fK5g3");
// Drops conditionally-omitted (null) rows while keeping each surviving entry
// typed as a fixed [label, value] tuple — a plain inline .filter() widens the
// tuples to arrays and breaks assignment to Card's `lines` prop.
const $ce138121e3f589bd$var$cardLines = (lines)=>lines.filter((0, $fK5g3.notNullish));
const $ce138121e3f589bd$export$da3a8dcfa7f18510 = ({ report: report, month: month })=>{
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const [pvBattery, hwInstalled, hpEnabled, wbInstalled] = (0, $2lSXC.useSelector)(({ variables: { PV_BATTERY: PV_BATTERY, HW_INSTALL: HW_INSTALL, HP_ENABLED: HP_ENABLED, WB_INSTALL: WB_INSTALL } })=>[
            PV_BATTERY,
            HW_INSTALL,
            HP_ENABLED,
            WB_INSTALL
        ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
        sx: {
            mx: {
                xs: 0,
                md: '-8px !important'
            }
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $388fd205d718e5e5$export$2e2bcd8739ae039), {
            columns: {
                xs: 1,
                md: 2
            },
            spacing: 0,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.info",
                        defaultMessage: "Obecn\xe9 info"
                    }),
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $073bc38baf314d0e$export$7a00c9d79990c3e2), {}),
                    pieChart: [
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_consumption",
                                defaultMessage: "Spot\u0159eba z FVE"
                            }, 0),
                            labelValue: formatNumber(report.pvProduction - report.emOverflow, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.pvProduction - report.emOverflow,
                            color: (0, $iD7Z3.colors).primary
                        },
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption",
                                defaultMessage: "Odb\u011Br ze s\xedt\u011B"
                            }, 0),
                            labelValue: formatNumber(report.emConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.emConsumed,
                            color: (0, $iD7Z3.colors).darkBlue
                        }
                    ],
                    lines: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_production",
                                defaultMessage: "V\xfdroba FVE"
                            }, 0),
                            formatNumber(report.pvProduction, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.total_overflow_to_grid",
                                defaultMessage: "Celkov\xfd p\u0159etok do s\xedt\u011B"
                            }, 0),
                            formatNumber(report.emOverflow, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.total_purchase_from_grid",
                                defaultMessage: "Celkov\xfd n\xe1kup ze s\xedt\u011B"
                            }, 0),
                            formatNumber(report.emConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.building_consumption",
                                defaultMessage: "Spot\u0159eba objektu"
                            }, 0),
                            formatNumber(report.homeConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.self_consumption",
                                defaultMessage: "Vlastn\xed vyu\u017Eit\xed energie"
                            }, 0),
                            formatNumber(report.pvUsed * 100, {
                                style: 'percent',
                                maximumFractionDigits: 0
                            })
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.self_sufficiency",
                                defaultMessage: "Sob\u011Bsta\u010Dnost"
                            }, 0),
                            formatNumber(report.selfSufficiency * 100, {
                                style: 'percent',
                                maximumFractionDigits: 0
                            })
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption",
                                defaultMessage: "Odb\u011Br ze s\xedt\u011B"
                            }, 0),
                            formatNumber(report.fromGrid * 100, {
                                style: 'percent',
                                maximumFractionDigits: 0
                            })
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.self_sufficient_days",
                                defaultMessage: "Po\u010Det sob\u011Bsta\u010Dn\xedch dn\xed"
                            }, 0),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    report.selfSufficiencyDays,
                                    " / ",
                                    report.selfSufficiencyDaysTotal
                                ]
                            })
                        ]
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.avg_day",
                        defaultMessage: "Pr\u016Fmern\xfd den"
                    }),
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a051d58ddf9d1bb$export$5ccc11eb6ce7e3bb), {
                        data: report.avgDayChart
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.pv",
                        defaultMessage: "Fotovoltaick\xe1 elektr\xe1rna"
                    }),
                    visibility: {
                        variableId: 'PV_INSTALL'
                    },
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9982445a7b6402af$export$ffbcb0c0cfcdbf71), {}),
                    lines: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.monthly_production",
                                defaultMessage: "M\u011Bs\xed\u010Dn\xed v\xfdroba"
                            }, 0),
                            formatNumber(report.pvProduction, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.maximum_power",
                                defaultMessage: "Maxim\xe1ln\xed v\xfdkon"
                            }, 0),
                            formatNumber(report.pvMaxPower, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ]
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.boiler",
                        defaultMessage: "Bojler"
                    }),
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a15bdaf959620886$export$62b5013c502ceb63), {}),
                    visibility: {
                        variableId: 'HW_INSTALL'
                    },
                    pieChart: [
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_consumption",
                                defaultMessage: "Spot\u0159eba z FVE"
                            }, 0),
                            labelValue: formatNumber(report.hwConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.hwConsumedFromPv,
                            color: (0, $iD7Z3.colors).primary
                        },
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption_hw",
                                defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                            }, 0),
                            labelValue: formatNumber(report.hwConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.hwConsumedFromGrid,
                            color: (0, $iD7Z3.colors).darkBlue
                        }
                    ],
                    lines: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.monthly_consumption",
                                defaultMessage: "M\u011Bs\xed\u010Dn\xed spot\u0159eba"
                            }, 0),
                            formatNumber(report.hwConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_consumption",
                                defaultMessage: "Spot\u0159eba z FVE"
                            }, 1),
                            formatNumber(report.hwConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption_hw",
                                defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                            }, 2),
                            formatNumber(report.hwConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.average_water_temperature",
                                defaultMessage: "Pr\u016Fm\u011Brn\xe1 teplota vody"
                            }, 3),
                            formatNumber(report.hwAvgTemp, {
                                unit: 'celsius',
                                style: 'unit',
                                maximumFractionDigits: 0
                            })
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.estimated_water_amount",
                                defaultMessage: "Odhadovan\xe9 mno\u017Estv\xed vody"
                            }, 4),
                            formatNumber(report.estimateTankVolume, {
                                unit: 'litre',
                                style: 'unit',
                                maximumFractionDigits: 0
                            })
                        ]
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.heat_pump",
                        defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                    }),
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2496ca0e50773979$export$9cdbc5cab505edcf), {}),
                    visibility: {
                        variableId: 'HP_ENABLED'
                    },
                    pieChart: [
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_consumption",
                                defaultMessage: "Spot\u0159eba z FVE"
                            }, 0),
                            labelValue: formatNumber(report.hpConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.hpConsumedFromPv,
                            color: (0, $iD7Z3.colors).primary
                        },
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption_hp",
                                defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                            }, 0),
                            labelValue: formatNumber(report.hpConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                            value: report.hpConsumedFromGrid,
                            color: (0, $iD7Z3.colors).darkBlue
                        }
                    ],
                    lines: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.monthly_consumption",
                                defaultMessage: "M\u011Bs\xed\u010Dn\xed spot\u0159eba"
                            }, 0),
                            formatNumber(report.hpConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.pv_consumption",
                                defaultMessage: "Spot\u0159eba z FVE"
                            }, 1),
                            formatNumber(report.hpConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.grid_consumption_hp",
                                defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                            }, 2),
                            formatNumber(report.hpConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ]
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.wallbox",
                                defaultMessage: "Wallbox"
                            }),
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {}),
                            visibility: {
                                variableId: 'WB_INSTALL'
                            },
                            pieChart: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.pv_consumption",
                                        defaultMessage: "Spot\u0159eba z FVE"
                                    }, 0),
                                    labelValue: formatNumber(report.wbConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                                    value: report.wbConsumedFromPv,
                                    color: (0, $iD7Z3.colors).primary
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.grid_consumption_wallbox",
                                        defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                                    }, 0),
                                    labelValue: formatNumber(report.wbConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c)),
                                    value: report.wbConsumedFromGrid,
                                    color: (0, $iD7Z3.colors).darkBlue
                                }
                            ],
                            lines: [
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.monthly_consumption",
                                        defaultMessage: "M\u011Bs\xed\u010Dn\xed spot\u0159eba"
                                    }, 0),
                                    formatNumber(report.wbConsumed, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                                ],
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.pv_consumption",
                                        defaultMessage: "Spot\u0159eba z FVE"
                                    }, 1),
                                    formatNumber(report.wbConsumedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                                ],
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.grid_consumption_wallbox",
                                        defaultMessage: "Spot\u0159eba ze s\xedt\u011B"
                                    }, 2),
                                    formatNumber(report.wbConsumedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                                ],
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.kilometers_driven",
                                        defaultMessage: "Po\u010Det ujet\xfdch km"
                                    }, 3),
                                    formatNumber(report.wbKm, {
                                        unit: 'kilometer',
                                        style: 'unit',
                                        maximumFractionDigits: 0
                                    })
                                ],
                                [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.kilometers_driven_from_sun",
                                        defaultMessage: "Po\u010Det ujet\xfdch km ze slunce"
                                    }, 4),
                                    formatNumber(report.wbKmFromPv, {
                                        unit: 'kilometer',
                                        style: 'unit',
                                        maximumFractionDigits: 0
                                    })
                                ]
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c41b2f5980aec24$export$e222a9442244111a), {
                            consumptionByCard: report.wbConsumedByCard
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.battery",
                        defaultMessage: "Baterie"
                    }),
                    visibility: {
                        variableId: 'PV_BATTERY'
                    },
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f777c82437ec2b10$export$bd72f6a61c5669d6), {}),
                    lines: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_from_pv",
                                defaultMessage: "Ulo\u017Een\xe1 energie z FVE"
                            }, 0),
                            formatNumber(report.chargedFromPv, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_from_grid",
                                defaultMessage: "Ulo\u017Een\xe1 energie ze s\xedt\u011B"
                            }, 1),
                            formatNumber(report.chargedFromGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.household_consumption",
                                defaultMessage: "Spot\u0159eba dom\xe1cnosti"
                            }, 2),
                            formatNumber(report.dischargedToHome, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.sold_to_distribution_grid",
                                defaultMessage: "Prod\xe1no do distribu\u010Dn\xed s\xedt\u011B"
                            }, 3),
                            formatNumber(report.dischargedToGrid, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ]
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ae44eaa5e1f441cd$export$60332b2344f7fe41), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "reports.energy_estimate",
                        defaultMessage: "Odhad energi\xed bez \u0159\xedzen\xed"
                    }),
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e906332a228bb47a$export$bac3506438e44f8d), {}),
                    lines: $ce138121e3f589bd$var$cardLines([
                        pvBattery ? [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_to_battery",
                                defaultMessage: "Ulo\u017Een\xe1 energie do baterie"
                            }, 0),
                            formatNumber(report.withoutControlBatteryAccumulation, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ] : null,
                        hwInstalled ? [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_to_boiler",
                                defaultMessage: "Ulo\u017Een\xe1 energie do bojleru"
                            }, 1),
                            formatNumber(report.withoutControlBoilerAccumulation, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ] : null,
                        hpEnabled ? [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_to_heat_pump",
                                defaultMessage: "Ulo\u017Een\xe1 energie do T\u010C"
                            }, 2),
                            formatNumber(report.withoutControlHeatPumpAccumulation, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ] : null,
                        wbInstalled ? [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.stored_energy_to_wallbox",
                                defaultMessage: "Ulo\u017Een\xe1 energie do wallboxu"
                            }, 3),
                            formatNumber(report.withoutControlWallboxAccumulation, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ] : null,
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.total_without_control",
                                defaultMessage: "Celkem bez \u0159\xedzen\xed"
                            }, 4),
                            formatNumber(report.withoutControlTotal, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.total_with_control",
                                defaultMessage: "Celkem s \u0159\xedzen\xedm"
                            }, 5),
                            formatNumber(report.withControlTotal, (0, $ae44eaa5e1f441cd$export$f73d0f25083035c))
                        ],
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "reports.accumulation_increased",
                                defaultMessage: "Zv\xfd\u0161en\xed akumulace"
                            }, 6),
                            formatNumber((report.accumulationIncreased - 1) * 100, {
                                style: 'percent',
                                maximumFractionDigits: 0
                            })
                        ]
                    ])
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        p: {
                            xs: 0,
                            md: 1
                        },
                        pb: {
                            xs: 2,
                            md: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                            sx: {
                                gap: 0.5
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "reports.updated_at",
                                        defaultMessage: "Vygenerov\xe1no {date}",
                                        values: {
                                            date: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                                                        value: report.at
                                                    }),
                                                    ' ',
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedTime), {
                                                        value: report.at
                                                    })
                                                ]
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2bc7f0e57349642e$export$e04dc0fbfd7b5bfe), {
                                    month: month
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                    sx: {
                        p: {
                            xs: 0,
                            md: 1
                        },
                        pb: {
                            xs: 2,
                            md: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5R532.Row), {
                            sx: {
                                gap: 0.5,
                                opacity: 0.7
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "reports.disclaimer",
                                    defaultMessage: "Uveden\xe9 hodnoty maj\xed pouze informativn\xed charakter a mohou se li\u0161it od ofici\xe1ln\xedch ode\u010Dt\u016F distributora."
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};




var $dHW62 = parcelRequire("dHW62");
const $f8adc2fa851fc061$var$ReportDetailPage = ()=>{
    const { month: month } = (0, $aphAM.useParams)();
    if (!month) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    const premium = (0, $2lSXC.useSelector)(({ variables: { PREMIUM: PREMIUM } })=>PREMIUM);
    const { data: data, isLoading: isLoading, isError: isError } = (0, $iH29s.trpc).reports.get.useQuery({
        month: month
    });
    if (!premium) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
            layout: "list",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                    gap: 0.5,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                            to: (0, $dHW62.links).reports,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1a04729d5f79d9a6$export$e4c291d45fea4cd0), {
                                    sx: {
                                        fontSize: '24px'
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "h2",
                            sx: {
                                textTransform: 'capitalize'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bd9zl.FormattedDate), {
                                value: new Date(month),
                                month: "long",
                                year: "numeric"
                            })
                        })
                    ]
                }),
                isError && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    color: "error",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "error",
                        defaultMessage: "Chyba p\u0159i na\u010D\xedt\xe1n\xed reportu."
                    })
                }),
                isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $388fd205d718e5e5$export$2e2bcd8739ae039), {
                    columns: {
                        xs: 1,
                        md: 2
                    },
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 280
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 180
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 220
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 200
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                            variant: "rounded",
                            height: 200
                        })
                    ]
                }),
                data && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce138121e3f589bd$export$da3a8dcfa7f18510), {
                    month: month,
                    report: data
                })
            ]
        })
    });
};
var $f8adc2fa851fc061$export$2e2bcd8739ae039 = $f8adc2fa851fc061$var$ReportDetailPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $2lSXC = parcelRequire("2lSXC");

var $gpaJb = parcelRequire("gpaJb");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $8ni7a = parcelRequire("8ni7a");

parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

var $2lSXC = parcelRequire("2lSXC");
const $c182c2d649af0a4a$export$4e22d8508a022545 = ()=>{
    const board = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.BOARD);
    let options = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "test-product.settings.license.basic",
                defaultMessage: "Basic"
            }),
            value: (0, $8ni7a.License).Basic
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "test-product.settings.license.HW",
                defaultMessage: "HW"
            }),
            value: (0, $8ni7a.License).HW
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "test-product.settings.license.Smart",
                defaultMessage: "Smart"
            }),
            value: (0, $8ni7a.License).SMART
        },
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "test-product.settings.license.Industrial",
                defaultMessage: "Industrial"
            }),
            value: (0, $8ni7a.License).INDUSTRIAL
        }
    ];
    if (board === (0, $8ni7a.Board).Play) options = [
        {
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "test-product.settings.license.Play",
                defaultMessage: "PLAY"
            }),
            value: (0, $8ni7a.License).PLAY
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "test-product.settings.license",
            defaultMessage: "Licence"
        }),
        selectVariableId: "LICENSE",
        options: options,
        fullWidth: true
    });
};




const $929cce75c3654d38$var$ProductTest = ()=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const startTest = ()=>{
        dispatch((0, $1Jwr0.variablesChange)({
            PRODUCT_TEST: true
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "test-product.app",
                    defaultMessage: "Aplikace"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $22ebae9741c9601a$export$5f7700ebf3ab7ed8), {
                            autoCheck: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4878ff3657a4956a$export$e83ffb78b976f69f), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "test-product.settings",
                    defaultMessage: "Nastaven\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.settings.distribution",
                                defaultMessage: "Distribuce"
                            }),
                            selectVariableId: "OEM_DISTRIBUTION",
                            options: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "test-product.settings.distribution.Infigy",
                                        defaultMessage: "Infigy"
                                    }),
                                    value: (0, $8ni7a.OemDistribution).Infigy
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "test-product.settings.distribution.Dzd",
                                        defaultMessage: "DZD"
                                    }),
                                    value: (0, $8ni7a.OemDistribution).DZD
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "test-product.settings.distribution.solid_sun",
                                        defaultMessage: "SolidSun"
                                    }),
                                    value: (0, $8ni7a.OemDistribution).Solidsun
                                }
                            ],
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c182c2d649af0a4a$export$4e22d8508a022545), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "test-product.test",
                    defaultMessage: "Test za\u0159\xedzen\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumber",
                                defaultMessage: "V\xfdrobn\xed \u010D\xedslo jednotky"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumber.subtitle",
                                defaultMessage: "Bez v\xfdrobn\xedho \u010D\xedsla nelze zadat jm\xe9no testera a aktivovat test"
                            }),
                            inputVariableId: "SERIAL_NUMBER",
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumber.label",
                                defaultMessage: "S\xe9riov\xe9 \u010D\xedslo"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumberSwitchboard",
                                defaultMessage: "V\xfdrobn\xed \u010D\xedslo rozvad\u011B\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumberSwitchboard.subtitle",
                                defaultMessage: "Vyplnit v p\u0159\xedpad\u011B, \u017Ee je za\u0159\xedzen\xed v origin\xe1ln\xedm rozvad\u011B\u010Di"
                            }),
                            inputVariableId: "SERIAL_NUMBER_SWITCHBOARD",
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.serialNumberSwitchboard.label",
                                defaultMessage: "S\xe9riov\xe9 \u010D\xedslo"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.tester",
                                defaultMessage: "Za\u0159\xedzen\xed otestoval"
                            }),
                            visibility: {
                                variableId: 'SERIAL_NUMBER'
                            },
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.tester.subtitle",
                                defaultMessage: "Bez jm\xe9na nelze aktivovat test"
                            }),
                            inputVariableId: "PRODUCT_TESTER",
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "settings.service.tester.label",
                                defaultMessage: "Jm\xe9no testera"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.start",
                                defaultMessage: "Pokud je za\u0159\xedzen\xed p\u0159ipojeno"
                            }),
                            visibility: {
                                variableIds: [
                                    'PRODUCT_TESTER',
                                    'SERIAL_NUMBER'
                                ]
                            },
                            buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.start.button",
                                defaultMessage: "Aktivovat test"
                            }),
                            onClick: startTest,
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.inverter-connect",
                                defaultMessage: "P\u0159ipojen\xed st\u0159\xedda\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[0]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.internet-connect",
                                defaultMessage: "P\u0159ipojen\xed k internetu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[1]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.phase_1",
                                defaultMessage: "Test 1. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[2]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.phase_2",
                                defaultMessage: "Test 2. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[3]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.phase_3",
                                defaultMessage: "Test 3. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[4]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.temp",
                                defaultMessage: "Teplotn\xed \u010Didlo"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[5]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.switchboard",
                                defaultMessage: "Kontrola shody rozvad\u011B\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.switchboard.subtitle",
                                defaultMessage: "Kontrola dota\u017Een\xed svorek, um\xedst\u011Bn\xed komponent\u016F, spr\xe1vn\xe9 dimenze kabel\u016F"
                            }),
                            switchVariableId: "TEST_INFO[6]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.electricmeter",
                                defaultMessage: "Kontrola elektrom\u011Bru"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.electricmeter.subtitle",
                                defaultMessage: "Kontrola osazen\xed elektrom\u011Bru pro st\u0159\xedda\u010D"
                            }),
                            switchVariableId: "TEST_INFO[7]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.DC",
                                defaultMessage: "Kontrola DC obvodu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.DC.subtitle",
                                defaultMessage: "Dota\u017Een\xed svorek, dimenze kabel\u016F"
                            }),
                            switchVariableId: "TEST_INFO[8]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.component",
                                defaultMessage: "Kontrola komponent\u016F"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.component.subtitle",
                                defaultMessage: "Je p\u0159ibaleno \u010Didlo, \u0161t\xedtky, ...?"
                            }),
                            switchVariableId: "TEST_INFO[9]",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.license-info",
                                defaultMessage: "Test skon\u010D\xed za:"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[11]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "test-product.test.license",
                                defaultMessage: "Licence"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[10]"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            })
        ]
    });
};
var $929cce75c3654d38$export$2e2bcd8739ae039 = $929cce75c3654d38$var$ProductTest;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");



parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");





var $2lSXC = parcelRequire("2lSXC");

var $9iEAl = parcelRequire("9iEAl");

const $bb1ccfa0245b6b03$var$Thermostat = ()=>{
    const [thermostatIndex, setThermostatIndex] = (0, $acw62.useState)(0);
    const [thermostatCount, thermostatNames] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            Math.min(variables.THERMOSTAT_SETTINGS.length, variables.NUMBER_OF_THERMOSTATS),
            variables.THERMOSTAT_SETTINGS
        ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "thermostat.status",
                        defaultMessage: "Re\u017Eim termostatu"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                        type: "thermostat"
                    }),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "thermostat.general",
                    defaultMessage: "Spole\u010Dn\xe9 nastaven\xed"
                }),
                visibility: {
                    variableIds: [
                        {
                            variableId: 'HP_ENABLED',
                            reversed: true
                        }
                    ]
                },
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "thermostat.general.heating",
                                defaultMessage: "Vyt\xe1p\u011Bn\xed aktivn\xed"
                            }),
                            switchVariableId: 'HP_ROOM_ON',
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "thermostat.general.cooling",
                                defaultMessage: "Chlazen\xed aktivn\xed"
                            }),
                            switchVariableId: 'HP_ROOM_COOL_ON',
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "thermostat.general.cooling.pvstability",
                                defaultMessage: "Potenci\xe1l aktivace zdroje"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "THERMOSTAT_PV_FLEXIBILITY_PERC",
                                opts: {
                                    style: 'percent',
                                    maximumFractionDigits: 0
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "thermostat.range",
                    defaultMessage: "Termostat"
                }),
                layout: "list",
                children: [
                    thermostatCount > 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                        title: "Termostat",
                        fullWidth: true,
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                            value: thermostatIndex,
                            onChange: (e)=>setThermostatIndex(e.target.value),
                            children: Array(thermostatCount).fill(null).map((_, i)=>{
                                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                    value: i,
                                    children: thermostatNames[i].name
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                            variableId: "THERMOSTAT_TEMP_GRAPH",
                            variableSuffix: thermostatIndex === 0 ? undefined : String(thermostatIndex)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                type: "row",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.temperature",
                                    defaultMessage: "Aktu\xe1ln\xed teplota"
                                }),
                                value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `THERMOSTAT_INFO[${thermostatIndex}].actualTemp`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'celsius',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9748beca3fc4505a$export$a72d32054f236c4), {})
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.on",
                                    defaultMessage: "Termostat aktivn\xed"
                                }),
                                switchVariableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`,
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.status",
                                    defaultMessage: "Re\u017Eim termostatu"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                                    type: "thermostat",
                                    index: thermostatIndex
                                }),
                                visibility: {
                                    variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.flexibility_status",
                                    defaultMessage: "Re\u017Eim flexibility termostatu"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7df3f57d707c8835$export$d8342fcb5c7ece7a), {
                                    type: "thermostatFlexibility",
                                    index: thermostatIndex
                                }),
                                visibility: {
                                    variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`
                                },
                                fullWidth: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.set_temperature",
                                    defaultMessage: "Nastaven\xe1 teplota"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.on.subtitle",
                                    defaultMessage: "Z\xe1kladn\xed teplota"
                                }),
                                variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].setTemp`,
                                visibility: {
                                    variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`
                                },
                                max: 80,
                                min: 10,
                                step: 0.5,
                                opts: {
                                    style: 'unit',
                                    unit: 'celsius',
                                    maximumFractionDigits: 1
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.flexibility-temperature",
                                    defaultMessage: "Flexibiln\xed teplota"
                                }),
                                subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.flexibility-temperature.subtitle",
                                    defaultMessage: "Teplota o kterou je mo\u017En\xe9 p\u0159edeh\u0159\xe1t nebo p\u0159edchladit d\u016Fm"
                                }),
                                variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].flexibilityTemp`,
                                visibility: {
                                    variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`
                                },
                                max: 50,
                                min: 0,
                                step: 0.1,
                                opts: {
                                    style: 'unit',
                                    unit: 'celsius',
                                    maximumFractionDigits: 1
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.pv-flexibility",
                                    defaultMessage: "\u0158\xedzen\xed podle fotovoltaiky"
                                }),
                                switchVariableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].pvFlexibilityActiveSet`,
                                visibility: {
                                    variableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].on`
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.sp-flexibility-up",
                                    defaultMessage: "Zv\xfd\u0161en\xed spot\u0159eby podle spotu"
                                }),
                                switchVariableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].spFlexibilityActiveUpSet`,
                                visibility: {
                                    variableIds: [
                                        `THERMOSTAT_SETTINGS[${thermostatIndex}].on`,
                                        'SP_ON',
                                        'SP_INSTALL'
                                    ]
                                },
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "thermostat.range.sp-flexibility-down",
                                    defaultMessage: "Odlo\u017Een\xed spot\u0159eby podle spotu"
                                }),
                                switchVariableId: `THERMOSTAT_SETTINGS[${thermostatIndex}].spFlexibilityActiveDownSet`,
                                visibility: {
                                    variableIds: [
                                        `THERMOSTAT_SETTINGS[${thermostatIndex}].on`,
                                        'SP_ON',
                                        'SP_INSTALL'
                                    ]
                                },
                                fullWidth: true
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $bb1ccfa0245b6b03$export$2e2bcd8739ae039 = $bb1ccfa0245b6b03$var$Thermostat;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

const $8a7b8cecc9ec520f$var$ProductTestProtocol = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "protocol.settings",
                    defaultMessage: "Nastaven\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.settings.distribution",
                                defaultMessage: "Distribuce"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "OEM_DISTRIBUTION"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.settings.Licence",
                                defaultMessage: "Licence"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "LICENSE_STATUS"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "protocol.test",
                    defaultMessage: "Test za\u0159\xedzen\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.tester",
                                defaultMessage: "Za\u0159\xedzen\xed otestoval"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PRODUCT_TESTER"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.inverter-connect",
                                defaultMessage: "P\u0159ipojen\xed st\u0159\xedda\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[0]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.internet-connect",
                                defaultMessage: "P\u0159ipojen\xed k internetu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[1]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.phase_1",
                                defaultMessage: "Test 1. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[2]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.phase_2",
                                defaultMessage: "Test 2. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[3]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "protocol.test.phase_3",
                                defaultMessage: "Test 3. f\xe1ze"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEST_INFO_LABEL[4]"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            })
        ]
    });
};
var $8a7b8cecc9ec520f$export$2e2bcd8739ae039 = $8a7b8cecc9ec520f$var$ProductTestProtocol;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $lzNIT = parcelRequire("lzNIT");

var $03kOd = parcelRequire("03kOd");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");


var $gpaJb = parcelRequire("gpaJb");


var $2lSXC = parcelRequire("2lSXC");

var $5tslE = parcelRequire("5tslE");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $jDfxe = parcelRequire("jDfxe");


var $iH29s = parcelRequire("iH29s");
const $f6920114f5eb806b$export$4cd26ae9a8f318a5 = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const deleteStats = (0, $iH29s.trpc).deleteStats.useMutation();
    const handleClick = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "stats_delete.confirm.title",
                defaultMessage: "Opravdu chcete smazat v\u0161echny statistiky?"
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "stats_delete.confirm",
                defaultMessage: "Smazat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "stats_delete.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            return deleteStats.mutateAsync();
        }).catch(()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "stats_delete.title",
            defaultMessage: "Smazat v\u0161echny statistiky"
        }),
        buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "stats_delete.button",
            defaultMessage: "Smazat"
        }),
        onClick: handleClick,
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f4Eh3 = parcelRequire("f4Eh3");

var $03kOd = parcelRequire("03kOd");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $ngrp2 = parcelRequire("ngrp2");



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8bslU = parcelRequire("8bslU");




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");

var $9QePP = parcelRequire("9QePP");


var $7X4mk = parcelRequire("7X4mk");

var $1Ikg4 = parcelRequire("1Ikg4");

var $8Indx = parcelRequire("8Indx");



var $4Cod0 = parcelRequire("4Cod0");

var $beCSm = parcelRequire("beCSm");
function $283658a86bbff667$export$a1c3879af2c3b694(slot) {
    return (0, $4Cod0.default)('MuiDatePickerToolbar', slot);
}
const $283658a86bbff667$export$2e35fa7d24ef4179 = (0, $beCSm.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e99b23969f5ded13$var$_excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const $e99b23969f5ded13$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $283658a86bbff667$export$a1c3879af2c3b694), classes);
};
const $e99b23969f5ded13$var$DatePickerToolbarRoot = (0, $1Ikg4.default)((0, $f3ba643fb3747006$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const $e99b23969f5ded13$var$DatePickerToolbarTitle = (0, $1Ikg4.default)((0, $7X4mk.default), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const $e99b23969f5ded13$export$21b7f8ea763109eb = /*#__PURE__*/ $acw62.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", className: className, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e99b23969f5ded13$var$_excluded);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { value: value, views: views, orientation: orientation } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const ownerState = (0, $7488814d8bbee125$export$52d82af37dec73b2)();
    const classes = $e99b23969f5ded13$var$useUtilityClasses(classesProp);
    const dateText = $acw62.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, {
            format: toolbarFormat,
            views: views
        }, true);
        return adapter.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter,
        views
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99b23969f5ded13$var$DatePickerToolbarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, $9QePP.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($e99b23969f5ded13$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



function $039011ab24769564$export$a552c17ed3587731(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    const localeText = $acw62.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        localeText: localeText
    }, (0, $38ae9feef3ab2fb0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            toolbar: (0, $e99b23969f5ded13$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}







var $acw62 = parcelRequire("acw62");





'use client';
const $f117aff76d53d0eb$export$5591b0b878c1a989 = (props)=>{
    const manager = (0, $53fd543f3597ad7b$export$6b73f8c5013b806e)(props);
    return (0, $84499ee97b37b33a$export$294aa081a6c6f55d)({
        manager: manager,
        props: props
    });
};





var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e0ec0b3c450466b8$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $e0ec0b3c450466b8$export$d9781c7894a82487 = /*#__PURE__*/ $acw62.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(themeProps, $e0ec0b3c450466b8$var$_excluded);
    const textFieldProps = (0, $d2d3640b21a65392$export$fa1adc26aa0d007a)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $f117aff76d53d0eb$export$5591b0b878c1a989)(textFieldProps);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2d3640b21a65392$export$5a824d9f5f1d0778), {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d2d3640b21a65392$export$f83254b974f9d6d3), {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: (0, $ef8448afaa732d42$export$5fda1783bb83f57b)
        })
    });
});




'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $b4ee73b378d7ff2f$export$5a73641f0156e1e4 = /*#__PURE__*/ $acw62.forwardRef(function DesktopDatePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $039011ab24769564$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        closeOnSelect: defaultizedProps.closeOnSelect ?? true,
        viewRenderers: viewRenderers,
        format: (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $e0ec0b3c450466b8$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $921f50d8d6fdef68$export$b1b70bc56ac5be0e)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});
$b4ee73b378d7ff2f$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};




var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8bslU = parcelRequire("8bslU");









'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $c796e8df31479cec$export$97b476d7a92fee62 = /*#__PURE__*/ $acw62.forwardRef(function MobileDatePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $039011ab24769564$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $e0ec0b3c450466b8$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $8bslU.default)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $9c54f8e6b9d53c05$export$5ca0153a626a7dd7)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});
$c796e8df31479cec$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        3,
        4
    ])
};




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $41015e883ddba84d$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $41015e883ddba84d$export$5109c6dd95d8fb00 = /*#__PURE__*/ $acw62.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $7c44784990d74e44$export$9ae5b19305db48ce) } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $41015e883ddba84d$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4ee73b378d7ff2f$export$5a73641f0156e1e4), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c796e8df31479cec$export$97b476d7a92fee62), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});



var $8ni7a = parcelRequire("8ni7a");


var $iH29s = parcelRequire("iH29s");

var $9iEAl = parcelRequire("9iEAl");

var $2lSXC = parcelRequire("2lSXC");
const $9675c99aee366fdb$var$defaultFrom = (0, $f4Eh3.add)(new Date(), {
    months: -1
});
const $9675c99aee366fdb$var$defaultTo = new Date();
const $9675c99aee366fdb$export$8efcf546ed9e970d = ()=>{
    const deviceId = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.DEVICE_ID);
    const [metric, setMetric] = (0, $acw62.useState)((0, $8ni7a.StatsMetric).PV_POWER_GRAPH);
    const [from, setFrom] = (0, $acw62.useState)($9675c99aee366fdb$var$defaultFrom);
    const [to, setTo] = (0, $acw62.useState)($9675c99aee366fdb$var$defaultTo);
    const exportStats = (0, $iH29s.trpc).exportStats.useMutation();
    const handleSubmit = ()=>{
        exportStats.mutateAsync({
            metric: metric,
            from: from ? (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(from) : undefined,
            to: to ? (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(to) : undefined
        }).then((data)=>{
            const generateCSV = ()=>{
                if (data.length === 0) return '';
                const headers = Object.keys(data[0]);
                const rows = data.map((item)=>Object.values(item));
                const csvContent = headers.join(',') + '\n' + rows.map((row)=>row.join(',')).join('\n');
                return csvContent;
            };
            const csvContent = generateCSV();
            const blob = new Blob([
                csvContent
            ], {
                type: 'text/csv;charset=utf-8;'
            });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', `${deviceId}-${metric}.csv`);
            link.click();
        }, ()=>{
            alert("P\u0159i exportu do\u0161lo k chyb\u011B");
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "stats_export.title",
            defaultMessage: "Exportovat statistiky"
        }),
        fullWidth: true,
        control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
            direction: "row",
            gap: 1,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "stats_export.metric",
                        defaultMessage: "Metrika"
                    }),
                    value: metric,
                    onChange: (e)=>setMetric(e.target.value),
                    children: Object.values((0, $8ni7a.StatsMetric)).map((item)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                            value: item,
                            children: item
                        }, item);
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "stats_export.from",
                        defaultMessage: "Od"
                    }),
                    // eslint-disable-next-line
                    // @ts-ignore
                    value: from,
                    onChange: (value)=>setFrom(value),
                    slotProps: {
                        field: {
                            clearable: true
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "stats_export.to",
                        defaultMessage: "Od"
                    }),
                    // eslint-disable-next-line
                    // @ts-ignore
                    value: to,
                    onChange: (value)=>setTo(value),
                    slotProps: {
                        field: {
                            clearable: true
                        }
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    onClick: handleSubmit,
                    disabled: exportStats.isLoading,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "stats_export.button",
                        defaultMessage: "Export"
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $jDfxe = parcelRequire("jDfxe");


var $iH29s = parcelRequire("iH29s");
const $3bf1f2a278f7faea$export$d43eca13207fd18 = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const deleteAppMessages = (0, $iH29s.trpc).deleteAppMessages.useMutation();
    const handleClick = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "app_messages.confirm.title",
                defaultMessage: "Opravdu chcete smazat v\u0161echny zpr\xe1vy?"
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "app_messages.confirm",
                defaultMessage: "Smazat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "app_messages.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            return deleteAppMessages.mutateAsync();
        }).catch(()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "app_messages.title",
            defaultMessage: "Smazat v\u0161echny zpr\xe1vy"
        }),
        buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "app_messages.button",
            defaultMessage: "Smazat"
        }),
        onClick: handleClick,
        fullWidth: true
    });
};



var $dHW62 = parcelRequire("dHW62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $jDfxe = parcelRequire("jDfxe");


var $iH29s = parcelRequire("iH29s");
const $65bcd347de731db5$export$ec19d0471de95d7f = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const deleteAuditLog = (0, $iH29s.trpc).auditLog.clear.useMutation();
    const handleClick = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "audit_log_delete.confirm.title",
                defaultMessage: "Opravdu chcete smazat v\u0161echny z\xe1znamy v audit logu?"
            }),
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "audit_log_delete.confirm",
                defaultMessage: "Smazat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "audit_log_delete.cancel",
                defaultMessage: "Zru\u0161it"
            })
        }).then(()=>{
            return deleteAuditLog.mutateAsync();
        }).catch(()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "audit_log_delete.title",
            defaultMessage: "Smazat audit log"
        }),
        buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "audit_log_delete.button",
            defaultMessage: "Smazat"
        }),
        onClick: handleClick,
        fullWidth: true
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


var $iH29s = parcelRequire("iH29s");


var $gpaJb = parcelRequire("gpaJb");

var $2lSXC = parcelRequire("2lSXC");

var $jDfxe = parcelRequire("jDfxe");
const $d47655c59028d73d$export$af9a8cad466ea5d = ()=>{
    const generateReport = (0, $iH29s.trpc).reports.generate.useMutation();
    const confirm = (0, $jDfxe.useConfirm)();
    const month = (0, $2lSXC.useSelector)(// eslint-disable-next-line
    // @ts-ignore
    ({ variables: { REPORT_TEST_MONTH: REPORT_TEST_MONTH } })=>REPORT_TEST_MONTH || '');
    const handleClick = async ()=>{
        try {
            const result = await generateReport.mutateAsync({
                month: month
            });
            confirm({
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.generated",
                    defaultMessage: "Report vygenerov\xe1n"
                }),
                description: /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                    style: {
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-all'
                    },
                    children: JSON.stringify(result, null, 2)
                }),
                confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.ok",
                    defaultMessage: "OK"
                }),
                hideCancelButton: true
            });
        } catch (e) {
            alert("Chyba p\u0159i generov\xe1n\xed reportu");
            return;
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.date",
                    defaultMessage: "M\u011Bs\xedc (nap\u0159. 2025-09)"
                }),
                inputVariableId: "REPORT_TEST_MONTH",
                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.date",
                    defaultMessage: "M\u011Bs\xedc (nap\u0159. 2025-09)"
                }),
                fullWidth: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.test",
                    defaultMessage: "Test"
                }),
                buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "report_test.button",
                    defaultMessage: "Test"
                }),
                onClick: handleClick,
                fullWidth: true
            })
        ]
    });
};




parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

const $07c08421b84dda4f$var$ExpertService = ()=>{
    const [serviceActive, serviceLoginList, errorList] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.LOGIN_LIST,
            variables.ERR_LIST
        ]);
    const hwProportional = (0, $2lSXC.useSelector)((s)=>{
        return s.variables.HW_CONTROL_TYPE === (0, $8ni7a.HeatWater).Proportional;
    });
    const goodwe = (0, $2lSXC.useSelector)((s)=>{
        return s.variables.PV_INVERTER_TYPE === (0, $8ni7a.Inverter).GoodWe;
    });
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "expert_service.title",
            defaultMessage: "Service"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "expertService.password",
                defaultMessage: "P\u0159\xedstup do servisu"
            }),
            inputVariableId: "SERVICE_PASSWORD",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "expertService.password.label",
                defaultMessage: "Heslo"
            }),
            fullWidth: true
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.general",
                    defaultMessage: "Obecn\xe9 nastaven\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "expertService.general.largeInstallation",
                            defaultMessage: "Velk\xe1 instalace"
                        }),
                        subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "expertService.general.largeInstallation.subtitle",
                            defaultMessage: "Roz\u0161\xed\u0159\xed rozsahy hodnot pro velk\xe9 instalace"
                        }),
                        switchVariableId: "LARGE_INSTALLATION",
                        fullWidth: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.PV",
                    defaultMessage: "Fotovoltaika"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.IpAdr",
                                defaultMessage: "IP adresa st\u0159\xedda\u010De"
                            }),
                            inputVariableId: "MODBUS_TEST_ADDRESS",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.CntComOk",
                                defaultMessage: "\u010C\xedta\u010D validn\xedch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PV_cnt_com_ok"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.CntComErr",
                                defaultMessage: "\u010C\xedta\u010D chybn\xfdch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PV_cnt_com_err"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.Versions",
                                defaultMessage: "Verze"
                            }),
                            value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PV_INVERTER_VERSIONS"
                            })
                        }),
                        goodwe && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            variableId: "PV_BATTERY_POWER_PERCENT",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.BatteryPowerPercent",
                                defaultMessage: "V\xfdkon nab\xedjen\xed baterie v procentech"
                            }),
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 0,
                            max: 100
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.StringNumber",
                                defaultMessage: "Po\u010Det sting\u016F st\u0159\xedda\u010De"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.StringNumber.subtitle",
                                defaultMessage: "Po\u010Det sting\u016F st\u0159\xedda\u010De zobrazovan\xfd v aplikaci na z\xe1lo\u017Ece FVE"
                            }),
                            variableId: "PV_STRING_NUMBER",
                            opts: {
                                maximumFractionDigits: 0
                            },
                            min: 1,
                            max: 6
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.ExternalPv",
                                defaultMessage: "Extern\xed FVE p\u0159ipojen\xe1 skrze SOLAX Meter 2"
                            }),
                            switchVariableId: "PV_SOLAX_EXTERNAL_PV",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.ExternalPvSofar",
                                defaultMessage: "Extern\xed FVE p\u0159ipojen\xe1 skrze SOFAR Meter 2"
                            }),
                            switchVariableId: "PV_SOFAR_EXTERNAL_PV",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.PowerControlType",
                                defaultMessage: "Typ \u0159\xedzen\xed v\xfdkonu s\xed\u0165ov\xfdch st\u0159\xedda\u010D\u016F"
                            }),
                            selectVariableId: "PV_POWER_CONTROL_TYPE",
                            options: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.PowerControlType.proportional",
                                        defaultMessage: "Plynul\xe9"
                                    }),
                                    value: (0, $8ni7a.InverterPowerControl).Proportional
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.PowerControlType.fixed",
                                        defaultMessage: "Fixn\xed"
                                    }),
                                    value: (0, $8ni7a.InverterPowerControl).Fixed
                                }
                            ],
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.MeteringMode",
                                defaultMessage: "Zp\u016Fsob m\u011B\u0159en\xed distribuce"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.MeteringMode.subtitle",
                                defaultMessage: "F\xe1zov\xe9 m\u011B\u0159en\xed (\u010CR) po\u010D\xedt\xe1 n\xe1kup i p\u0159etok na ka\u017Ed\xe9 f\xe1zi zvl\xe1\u0161\u0165. Sou\u010Dtov\xe9 m\u011B\u0159en\xed pracuje s v\xfdslednou bilanc\xed v\u0161ech f\xe1z\xed."
                            }),
                            selectVariableId: "EM_METERING_MODE",
                            options: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.MeteringMode.perPhase",
                                        defaultMessage: "F\xe1zov\xe9"
                                    }),
                                    value: (0, $8ni7a.GridMeteringMode).PerPhase
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.MeteringMode.sum",
                                        defaultMessage: "Sou\u010Dtov\xe9"
                                    }),
                                    value: (0, $8ni7a.GridMeteringMode).Sum
                                }
                            ],
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.ControlMeteringMode",
                                defaultMessage: "Zp\u016Fsob \u0159\xedzen\xed p\u0159ebytk\u016F"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.PV.ControlMeteringMode.subtitle",
                                defaultMessage: "F\xe1zov\xe9 \u0159\xedzen\xed po\u010D\xedt\xe1 p\u0159ebytek pro \u0159\xedzen\xed technologi\xed z jednotliv\xfdch f\xe1z\xed. Sou\u010Dtov\xe9 \u0159\xedzen\xed pracuje se sou\u010Dtem v\u0161ech f\xe1z\xed."
                            }),
                            selectVariableId: "PV_CONTROL_METERING_MODE",
                            options: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.ControlMeteringMode.perPhase",
                                        defaultMessage: "F\xe1zov\xe9"
                                    }),
                                    value: (0, $8ni7a.GridMeteringMode).PerPhase
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.PV.ControlMeteringMode.sum",
                                        defaultMessage: "Sou\u010Dtov\xe9"
                                    }),
                                    value: (0, $8ni7a.GridMeteringMode).Sum
                                }
                            ],
                            fullWidth: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.HW",
                    defaultMessage: "Bojler"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.control",
                                defaultMessage: "Typ \u0159\xedzen\xed bojleru"
                            }),
                            selectVariableId: "HW_CONTROL_TYPE",
                            options: [
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.HW.control.proportional",
                                        defaultMessage: "Plynul\xe9"
                                    }),
                                    value: (0, $8ni7a.HeatWater).Proportional
                                },
                                {
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "expertService.HW.control.onoff",
                                        defaultMessage: "On/Off"
                                    }),
                                    value: (0, $8ni7a.HeatWater).Digital
                                }
                            ],
                            fullWidth: true
                        }),
                        hwProportional && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.maxPower",
                                defaultMessage: "Maxim\xe1ln\xed v\xfdkon bojleru v procentech"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.maxPower.subtitle",
                                defaultMessage: "Toto nastaven\xed je pouze pro plynul\xe9 \u0159\xedzen\xed bojleru a omezuje maxim\xe1ln\xed v\xfdkon patrony v procentech."
                            }),
                            variableId: "HW_EK_POWER_PERC_LIMIT",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 20,
                            max: 100
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.hysterezis",
                                defaultMessage: "Hystereze bojleru"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.hysterezis.subtitle",
                                defaultMessage: "Hystereze je pouze pro b\u011B\u017En\xfd oh\u0159ev"
                            }),
                            variableId: "HW_HYST",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 0
                            },
                            min: 1,
                            max: 10
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.HwBatteryPriority",
                                defaultMessage: "Procento nab\xedt\xed od kter\xe9ho m\xe1 v\u017Edy prioritu bojler"
                            }),
                            variableId: "PV_OFFSET_SOC_HW_PRIO",
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 30,
                            max: 97
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.disabled-overflow",
                                defaultMessage: "Offset pro \u0159\xedzen\xed bojleru se zak\xe1zan\xfdm p\u0159etokem na f\xe1zi [W]"
                            }),
                            variableId: "OFFSET_FOR_NOT_OVERFLOW",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.disabled-overflow.subtitle",
                                defaultMessage: "Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B p\u0159i omezen\xe9m st\u0159\xedda\u010Di"
                            }),
                            opts: {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            min: -1000,
                            max: 9000,
                            step: 5
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.enabled-overflow",
                                defaultMessage: "Offset pro \u0159\xedzen\xed bojleru s povolen\xfdm p\u0159etokem na f\xe1zi [W]"
                            }),
                            variableId: "OFFSET_FOR_OVERFLOW",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.enabled-overflow.subtitle",
                                defaultMessage: "Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B."
                            }),
                            opts: {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            min: -1000,
                            max: 9000,
                            step: 5
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.ongrid",
                                defaultMessage: "Offset pro \u0159\xedzen\xed bojleru pro s\xed\u0165ov\xe9 elektr\xe1rny [W]"
                            }),
                            variableId: "OFFSET_ON_GRID",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset.ongrid.subtitle",
                                defaultMessage: "Vy\u0161\u0161\xed \u010D\xedslo umo\u017En\xed bojleru odeb\xedrat v\xedce energie ze s\xedt\u011B."
                            }),
                            opts: {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            min: -1000,
                            max: 9000,
                            step: 5
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.offset",
                                defaultMessage: "Offset na f\xe1zi [W]"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "PV_EM_OFFSET_REAL"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.TempId",
                                defaultMessage: "ID teplotn\xedho \u010Didla"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "TEMP_IDS[0]"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.HwErrEnabled",
                                defaultMessage: "Vyhodnocovat dostupnost bojleru"
                            }),
                            switchVariableId: "HW_ERR_POWER_ENABLED",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            type: "minutes",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.HwResetErrorTime",
                                defaultMessage: "Prodleva pro reset chyby termostatu"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.HwResetErrorTime.subtitle",
                                defaultMessage: "\u010Cas v minut\xe1ch po kter\xe9m se chyba termostatu resetuje a op\u011Bt se spust\xed oh\u0159ev vody"
                            }),
                            opts: {
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0
                            },
                            min: 300,
                            max: 5400,
                            step: 300,
                            variableId: "HW_ERR_RESET_TIME"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HW.LegionellaLastTime",
                                defaultMessage: "Posledn\xed dosa\u017Een\xed teploty legionelly"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HW_LEGIONELLA_LAST_TIME"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7f500361bb014857$export$2cddd0ae366a366c), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.HP",
                    defaultMessage: "Tepeln\xe9 \u010Derpadlo"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HP.IpAdr",
                                defaultMessage: "IP adresa tepeln\xe9ho \u010Derpadla"
                            }),
                            inputVariableId: "HP_ECOONE_API_IP",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HP.CntComOk",
                                defaultMessage: "\u010C\xedta\u010D validn\xedch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HP_cnt_com_ok"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HP.CntComErr",
                                defaultMessage: "\u010C\xedta\u010D chybn\xfdch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "HP_cnt_com_err"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HP.maxTempHW",
                                defaultMessage: "Maxim\xe1ln\xed teplota tepl\xe9 vody pro T\u010C"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.HP.maxTempHW.subtitle",
                                defaultMessage: "Sou\u010Det flexibiln\xed + nastaven\xe9 teploty"
                            }),
                            variableId: "HP_HW_MAX_SET_TEMP",
                            opts: {
                                style: 'unit',
                                unit: 'celsius',
                                maximumFractionDigits: 0
                            },
                            min: 40,
                            max: 70
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.SP",
                    defaultMessage: "Spot"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.minDifferenceBatterychargeFromGrid",
                                defaultMessage: "Minim\xe1ln\xed odhadovan\xe9 zv\xfd\u0161en\xed SOC pro vy\u010Dk\xe1n\xed baterie na FVE"
                            }),
                            variableId: "SP_MIN_SPOT_DIFFERENCE_BATTERY_SOC",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.minDifferenceBatterychargeFromGrid.subtitle",
                                defaultMessage: "Pokud je odhad nabit\xed baterie pod touto hodnotou, m\u016F\u017Ee doj\xedt k nabit\xed baterie ze s\xedt\u011B."
                            }),
                            opts: {
                                style: 'percent',
                                maximumFractionDigits: 0
                            },
                            min: 5,
                            max: 70
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.HwCoefficient",
                                defaultMessage: "Koeficiet odhadu energie do bojleru"
                            }),
                            variableId: "SP_HW_K",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.HwCoefficient.subtitle",
                                defaultMessage: "Koeficient odhadu mno\u017Estv\xed energie pro nabit\xed bojleru."
                            }),
                            opts: {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            min: 0.5,
                            max: 2.5,
                            step: 0.1
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.batteryCoefficient",
                                defaultMessage: "Koeficiet odhadu \u010Dasu nab\xedjen\xed baterie"
                            }),
                            variableId: "SP_BATTERY_K",
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.SP.batteryCoefficient.subtitle",
                                defaultMessage: "Koeficient odhadu \u010Dasu pro nab\xedjen\xed a vyb\xedjen\xed baterie"
                            }),
                            opts: {
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            },
                            min: 0.7,
                            max: 3.0,
                            step: 0.1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expertService.WB",
                    defaultMessage: "Wallbox"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.WB.IpAdr",
                                defaultMessage: "IP adresa wallboxu"
                            }),
                            inputVariableId: "WB_IP_ADRESS",
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.WB.CntComOk",
                                defaultMessage: "\u010C\xedta\u010D validn\xedch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "WB_cnt_com_ok"
                            }),
                            fullWidth: true
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "expertService.WB.CntComErr",
                                defaultMessage: "\u010C\xedta\u010D chybn\xfdch zpr\xe1v"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                variableId: "WB_cnt_com_err"
                            }),
                            fullWidth: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.network",
                    defaultMessage: "S\xed\u0165"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.Link), {
                    to: (0, $dHW62.links).exportServiceNetwork,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "expert_service.network.button",
                            defaultMessage: "P\u0159ej\xedt do nastaven\xed s\xedt\u011B"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.xyz",
                    defaultMessage: "Servis"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                    rows: [
                        [
                            'Login',
                            ''
                        ],
                        ...[
                            ...serviceLoginList
                        ].reverse().filter((row)=>row).map((row)=>{
                            return [
                                row,
                                ''
                            ];
                        })
                    ],
                    firstLineBold: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.stats",
                    defaultMessage: "Statistiky"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6920114f5eb806b$export$4cd26ae9a8f318a5), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9675c99aee366fdb$export$8efcf546ed9e970d), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.app_messages",
                    defaultMessage: "Zpr\xe1vy"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3bf1f2a278f7faea$export$d43eca13207fd18), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.audit_log",
                    defaultMessage: "Audit log"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65bcd347de731db5$export$ec19d0471de95d7f), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.reports",
                    defaultMessage: "Reporty"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d47655c59028d73d$export$af9a8cad466ea5d), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "expert_service.error_list",
                    defaultMessage: "Seznam chyb"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                    rows: [
                        [
                            'Chyba',
                            ''
                        ],
                        ...[
                            ...errorList
                        ].reverse().map((row)=>{
                            return [
                                row,
                                ''
                            ];
                        })
                    ],
                    firstLineBold: true
                })
            })
        ]
    });
};
var $07c08421b84dda4f$export$2e2bcd8739ae039 = $07c08421b84dda4f$var$ExpertService;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $gpaJb = parcelRequire("gpaJb");


var $2lSXC = parcelRequire("2lSXC");

var $2NSFW = parcelRequire("2NSFW");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $2lSXC = parcelRequire("2lSXC");

var $9iE6L = parcelRequire("9iE6L");

var $5tslE = parcelRequire("5tslE");
const $ac18b1cf1efeef72$export$11a7c0eecfe66def = ({ title: title = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
    id: "shellies.list",
    defaultMessage: "Shellies"
}) })=>{
    const shellies = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.MQTT_BROKER_SHELLIES);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
        title: title,
        rows: [
            [
                'ID',
                'Model',
                'Stav',
                "Posledn\xed zpr\xe1va"
            ],
            ...Object.entries(shellies).map(([key, value])=>{
                return [
                    key,
                    value.model,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            (value.model === 'shellypro3em' || value.model === 'shelly3em') && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "L1: ",
                                    value.phase1ActualPower,
                                    "W, L2: ",
                                    value.phase2ActualPower,
                                    "W, L3: ",
                                    value.phase3ActualPower,
                                    "W"
                                ]
                            }),
                            value.model === 'shellyproem50' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    "EM0: ",
                                    value.em0ActualPower,
                                    "W, EM1: ",
                                    value.em1ActualPower,
                                    "W"
                                ]
                            }),
                            (value.model === 'shelly1pmg3' || value.model === 'shelly1pmg4' || value.model === 'shellypro1pm' || value.model === 'shellyplusplugs') && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    value.switch ? 'Zapnuto' : 'Vypnuto',
                                    ", ",
                                    value.temperature,
                                    "\xb0C,",
                                    ' ',
                                    value.power,
                                    "W"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                        value: value.lastMessageAt
                    }, 0)
                ];
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $03kOd = parcelRequire("03kOd");
var $bJgPp = parcelRequire("bJgPp");
var $u24M4 = parcelRequire("u24M4");
var $6jNiK = parcelRequire("6jNiK");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");

var $ko6Bk = parcelRequire("ko6Bk");
var $8YLZH = parcelRequire("8YLZH");

var $9iEAl = parcelRequire("9iEAl");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");
const $3dc3df7832e62d63$export$762e4704b3dfbcf6 = ()=>{
    const [metersConfig, metersData, azRouterConfig] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.EM_METERS_CONFIG,
            variables.EM_METERS_DATA,
            variables.AZ_ROUTER_CONFIG
        ]);
    const dispatch = (0, $2lSXC.useDispatch)();
    const [newMeterName, setNewMeterName] = (0, $acw62.useState)('');
    const [editingShellyIds, setEditingShellyIds] = (0, $acw62.useState)({});
    const meterIds = Object.keys(metersConfig || {}).filter((id)=>metersConfig[id] != null);
    const azRouterIds = Object.keys(azRouterConfig || {});
    const handleAdd = ()=>{
        if (!newMeterName.trim()) return;
        const meterId = Math.random().toString(36).substring(2, 12);
        dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: {
                ...metersConfig,
                [meterId]: {
                    name: newMeterName.trim(),
                    source: 'shelly',
                    shellyId: ''
                }
            }
        }));
        setNewMeterName('');
    };
    const handleRemove = (meterId)=>{
        const remainingConfig = {
            ...metersConfig
        };
        delete remainingConfig[meterId];
        const remainingData = {
            ...metersData
        };
        delete remainingData[meterId];
        dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: remainingConfig,
            EM_METERS_DATA: remainingData
        }));
    };
    const handleSourceChange = (meterId, source)=>{
        const config = metersConfig[meterId];
        if (!config) return;
        const updated = {
            ...config,
            source: source
        };
        if (source === 'plc' && !updated.plcMetric) updated.plcMetric = 'grid';
        if (source !== 'plc') delete updated.plcMetric;
        if (source === 'az-router' && !updated.azRouterId) updated.azRouterId = azRouterIds[0] || '';
        if (source !== 'az-router') delete updated.azRouterId;
        dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: {
                ...metersConfig,
                [meterId]: updated
            }
        }));
    };
    const handleShellyIdChange = (meterId, shellyId)=>{
        setEditingShellyIds((prev)=>({
                ...prev,
                [meterId]: shellyId
            }));
    };
    const handleShellyIdBlur = (meterId)=>{
        const newValue = editingShellyIds[meterId];
        const config = metersConfig?.[meterId];
        if (!config) return;
        if (newValue !== undefined && newValue !== config.shellyId) dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: {
                ...metersConfig,
                [meterId]: {
                    ...config,
                    shellyId: newValue
                }
            }
        }));
        setEditingShellyIds((prev)=>{
            const next = {
                ...prev
            };
            delete next[meterId];
            return next;
        });
    };
    const handleShellyIdKeyPress = (meterId, e)=>{
        if (e.key === 'Enter') e.target.blur();
    };
    const handlePlcMetricChange = (meterId, plcMetric)=>{
        const config = metersConfig[meterId];
        if (!config) return;
        dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: {
                ...metersConfig,
                [meterId]: {
                    ...config,
                    plcMetric: plcMetric
                }
            }
        }));
    };
    const handleAzRouterIdChange = (meterId, azRouterId)=>{
        const config = metersConfig[meterId];
        if (!config) return;
        dispatch((0, $1Jwr0.variablesChange)({
            EM_METERS_CONFIG: {
                ...metersConfig,
                [meterId]: {
                    ...config,
                    azRouterId: azRouterId
                }
            }
        }));
    };
    const getShellyIdValue = (meterId)=>{
        if (editingShellyIds[meterId] !== undefined) return editingShellyIds[meterId];
        return metersConfig?.[meterId]?.shellyId || '';
    };
    const getSourceValue = (meterId)=>metersConfig[meterId]?.source || 'shelly';
    const getPlcMetricValue = (meterId)=>metersConfig[meterId]?.plcMetric || 'grid';
    const getAzRouterIdValue = (meterId)=>metersConfig[meterId]?.azRouterId || '';
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "emsService.energyMeters",
            defaultMessage: "Elektrom\u011Bry (Shelly EM / PLC)"
        }),
        layout: "list",
        children: [
            meterIds.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                type: "row",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "emsService.energyMeters.empty",
                    defaultMessage: "Nejsou nakonfigurov\xe1ny \u017E\xe1dn\xe9 elektrom\u011Bry"
                }),
                value: ""
            }),
            meterIds.map((meterId)=>{
                const config = metersConfig?.[meterId];
                if (!config) return null;
                const source = getSourceValue(meterId);
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                    title: config.name || '',
                    fullWidth: true,
                    control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                        direction: "row",
                        spacing: 1,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
                                size: "small",
                                sx: {
                                    width: 150
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.source",
                                            defaultMessage: "Zdroj"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                                        value: source,
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.source",
                                            defaultMessage: "Zdroj"
                                        }),
                                        onChange: (e)=>handleSourceChange(meterId, e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "shelly",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.source.shelly",
                                                    defaultMessage: "Shelly"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "plc",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.source.plc",
                                                    defaultMessage: "PLC"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "az-router",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.source.azRouter",
                                                    defaultMessage: "AZ router"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            source === 'shelly' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.energyMeters.shellyId",
                                    defaultMessage: "Shelly ID"
                                }),
                                size: "small",
                                value: getShellyIdValue(meterId),
                                onChange: (e)=>handleShellyIdChange(meterId, e.target.value),
                                onBlur: ()=>handleShellyIdBlur(meterId),
                                onKeyPress: (e)=>handleShellyIdKeyPress(meterId, e),
                                sx: {
                                    width: 250
                                }
                            }),
                            source === 'plc' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
                                size: "small",
                                sx: {
                                    width: 250
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.plcMetric",
                                            defaultMessage: "PLC Metrika"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                                        value: getPlcMetricValue(meterId),
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.plcMetric",
                                            defaultMessage: "PLC Metrika"
                                        }),
                                        onChange: (e)=>handlePlcMetricChange(meterId, e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "grid",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.plcMetric.grid",
                                                    defaultMessage: "Grid"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "kgj",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.plcMetric.kgj",
                                                    defaultMessage: "KGJ"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "pv",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.plcMetric.pv",
                                                    defaultMessage: "FVE"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            source === 'az-router' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $bJgPp.default), {
                                size: "small",
                                sx: {
                                    width: 250
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6jNiK.default), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.azRouter",
                                            defaultMessage: "AZ router"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $1GEFm.default), {
                                        value: getAzRouterIdValue(meterId),
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.energyMeters.azRouter",
                                            defaultMessage: "AZ router"
                                        }),
                                        onChange: (e)=>handleAzRouterIdChange(meterId, e.target.value),
                                        children: [
                                            azRouterIds.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                value: "",
                                                disabled: true,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                    id: "emsService.energyMeters.azRouter.empty",
                                                    defaultMessage: "\u017D\xe1dn\xe9 AZ routery"
                                                })
                                            }),
                                            azRouterIds.map((id)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                                    value: id,
                                                    children: azRouterConfig?.[id]?.name || id
                                                }, id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                color: "error",
                                onClick: ()=>handleRemove(meterId),
                                size: "small",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {})
                            })
                        ]
                    })
                }, meterId);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "emsService.energyMeters.add",
                    defaultMessage: "P\u0159idat nov\xfd elektrom\u011Br"
                }),
                fullWidth: true,
                control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "emsService.energyMeters.newMeter",
                                defaultMessage: "N\xe1zev"
                            }),
                            size: "small",
                            value: newMeterName,
                            onChange: (e)=>setNewMeterName(e.target.value),
                            onKeyPress: (e)=>{
                                if (e.key === 'Enter') handleAdd();
                            },
                            sx: {
                                width: 250
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "contained",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ko6Bk.default), {}),
                            onClick: handleAdd,
                            disabled: !newMeterName.trim(),
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "emsService.energyMeters.addButton",
                                defaultMessage: "P\u0159idat"
                            })
                        })
                    ]
                })
            })
        ]
    });
};


const $a492be7a61cb3b6d$var$EmsService = ()=>{
    const [ems, serviceActive, mqttBrokerRunning, shellies, plcStatus, distributionMetricsSource] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.EMS,
            variables.SERVICE_ACTIVE,
            variables.MQTT_BROKER_RUNNING,
            variables.MQTT_BROKER_SHELLIES,
            variables.PLC_STATUS,
            variables.DISTRIBUTION_METRICS_SOURCE
        ]);
    // EMS feature must be enabled
    if (!ems) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "ems_service.title",
            defaultMessage: "EMS Service"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "emsService.notAvailable",
                defaultMessage: "Funkce EMS nen\xed k dispozici"
            })
        })
    });
    // Service password verification
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "ems_service.title",
            defaultMessage: "EMS Service"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "expertService.password",
                defaultMessage: "P\u0159\xedstup do servisu"
            }),
            inputVariableId: "SERVICE_PASSWORD",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "expertService.password.label",
                defaultMessage: "Heslo"
            }),
            fullWidth: true
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2NSFW.Breadcrumbs), {
                    items: [
                        {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "ems_service.link",
                                defaultMessage: "EMS Service"
                            })
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "emsService.basicSettings",
                    defaultMessage: "Komunikace s RTU"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.enabled",
                                    defaultMessage: "PLC Povoleno"
                                }),
                                switchVariableId: "PLC_CONFIG.enabled"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                type: "row",
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.plcStatus",
                                    defaultMessage: "Stav PLC komunikace"
                                }),
                                value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                    children: plcStatus?.connected ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            color: 'green'
                                        },
                                        children: [
                                            "\u2713 P\u0159ipojeno (\xfasp\u011B\u0161n\xfdch: ",
                                            plcStatus.communicationSuccess,
                                            ", chyb: ",
                                            plcStatus.communicationErrors,
                                            ")"
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        style: {
                                            color: 'red'
                                        },
                                        children: [
                                            "\u2717 Nep\u0159ipojeno",
                                            ' ',
                                            plcStatus?.communicationErrors ? `(chyb: ${plcStatus.communicationErrors})` : ''
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.ipAddress",
                                    defaultMessage: "IP Adresa"
                                }),
                                inputVariableId: "PLC_CONFIG.ipAddress",
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.ipAddress",
                                    defaultMessage: "IP Adresa"
                                }),
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.username",
                                    defaultMessage: "U\u017Eivatelsk\xe9 jm\xe9no"
                                }),
                                inputVariableId: "PLC_CONFIG.username",
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.username",
                                    defaultMessage: "U\u017Eivatelsk\xe9 jm\xe9no"
                                }),
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.password",
                                    defaultMessage: "Heslo"
                                }),
                                inputVariableId: "PLC_CONFIG.password",
                                label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.password",
                                    defaultMessage: "Heslo"
                                }),
                                type: "password",
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.pollInterval",
                                    defaultMessage: "Interval dotazov\xe1n\xed (ms)"
                                }),
                                variableId: "PLC_CONFIG.pollInterval",
                                min: 100,
                                max: 60000,
                                step: 100
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.gridMetrics.enabled",
                                    defaultMessage: "Povoleno \u010Dten\xed paty objektu"
                                }),
                                switchVariableId: "PLC_CONFIG.gridMetrics.enabled"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.metricsDirection",
                                    defaultMessage: "Sm\u011Br"
                                }),
                                selectVariableId: "PLC_CONFIG.gridMetrics.direction",
                                options: [
                                    {
                                        value: 'disabled',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.disabled",
                                            defaultMessage: "Zak\xe1z\xe1no"
                                        })
                                    },
                                    {
                                        value: 'read',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.read",
                                            defaultMessage: "\u010Cten\xed"
                                        })
                                    },
                                    {
                                        value: 'write',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.write",
                                            defaultMessage: "Z\xe1pis"
                                        })
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.pvMetrics.enabled",
                                    defaultMessage: "Povoleno \u010Dten\xed z FVE"
                                }),
                                switchVariableId: "PLC_CONFIG.pvMetrics.enabled"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.metricsDirection",
                                    defaultMessage: "Sm\u011Br"
                                }),
                                selectVariableId: "PLC_CONFIG.pvMetrics.direction",
                                options: [
                                    {
                                        value: 'disabled',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.disabled",
                                            defaultMessage: "Zak\xe1z\xe1no"
                                        })
                                    },
                                    {
                                        value: 'read',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.read",
                                            defaultMessage: "\u010Cten\xed"
                                        })
                                    },
                                    {
                                        value: 'write',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.write",
                                            defaultMessage: "Z\xe1pis"
                                        })
                                    }
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.kgjMetrics.enabled",
                                    defaultMessage: "Povoleno \u010Dten\xed z KGJ"
                                }),
                                switchVariableId: "PLC_CONFIG.kgjMetrics.enabled"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "emsService.metricsDirection",
                                    defaultMessage: "Sm\u011Br"
                                }),
                                selectVariableId: "PLC_CONFIG.kgjMetrics.direction",
                                options: [
                                    {
                                        value: 'disabled',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.disabled",
                                            defaultMessage: "Zak\xe1z\xe1no"
                                        })
                                    },
                                    {
                                        value: 'read',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.read",
                                            defaultMessage: "\u010Cten\xed"
                                        })
                                    },
                                    {
                                        value: 'write',
                                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "emsService.direction.write",
                                            defaultMessage: "Z\xe1pis"
                                        })
                                    }
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "emsService.distributionMetrics",
                    defaultMessage: "Distribu\u010Dn\xed pokyny"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "emsService.distributionMetrics.source",
                                defaultMessage: "Zdroj distribu\u010Dn\xedch pokyn\u016F"
                            }),
                            selectVariableId: "DISTRIBUTION_METRICS_SOURCE",
                            options: [
                                {
                                    value: 'plc',
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "emsService.distributionMetrics.source.plc",
                                        defaultMessage: "Extern\xed PLC"
                                    })
                                },
                                {
                                    value: 'digital-inputs',
                                    label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "emsService.distributionMetrics.source.digitalInputs",
                                        defaultMessage: "Digit\xe1ln\xed vstupy"
                                    })
                                }
                            ]
                        }),
                        distributionMetricsSource === 'digital-inputs' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                            type: "row",
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "emsService.distributionMetrics.diMapping",
                                defaultMessage: "Mapov\xe1n\xed vstup\u016F"
                            }),
                            value: "DI1 = 0%, DI2 = 30%, DI3 = 60%"
                        }),
                        distributionMetricsSource === 'plc' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "emsService.distributionMetrics.enabled",
                                        defaultMessage: "Povoleno \u010Dten\xed distribu\u010Dn\xedch pokyn\u016F"
                                    }),
                                    switchVariableId: "PLC_CONFIG.distributionMetrics.enabled"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7026d47a00410215$export$ebde6d4e7862fe9d), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "emsService.metricsDirection",
                                        defaultMessage: "Sm\u011Br"
                                    }),
                                    selectVariableId: "PLC_CONFIG.distributionMetrics.direction",
                                    options: [
                                        {
                                            value: 'disabled',
                                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "emsService.direction.disabled",
                                                defaultMessage: "Zak\xe1z\xe1no"
                                            })
                                        },
                                        {
                                            value: 'read',
                                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                                id: "emsService.direction.read",
                                                defaultMessage: "\u010Cten\xed"
                                            })
                                        }
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "emsService.mqttBroker",
                    defaultMessage: "MQTT Broker (Shellies)"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "emsService.mqttBrokerEnabled",
                                defaultMessage: "MQTT Broker povolen"
                            }),
                            switchVariableId: "MQTT_BROKER_ENABLED"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "emsService.mqttBrokerStatus",
                            defaultMessage: "Stav MQTT Brokeru"
                        }),
                        value: mqttBrokerRunning ? "Aktivn\xed" : "Neaktivn\xed"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac18b1cf1efeef72$export$11a7c0eecfe66def), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "emsService.shelliesList",
                            defaultMessage: "P\u0159ipojen\xe1 Shelly za\u0159\xedzen\xed"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3dc3df7832e62d63$export$762e4704b3dfbcf6), {})
        ]
    });
};
var $a492be7a61cb3b6d$export$2e2bcd8739ae039 = $a492be7a61cb3b6d$var$EmsService;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $jDfxe = parcelRequire("jDfxe");

var $bJgPp = parcelRequire("bJgPp");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $54112a2ab124f669$export$d72d4cbdc30b331f(slot) {
    return (0, $4Cod0.default)('MuiFormGroup', slot);
}
const $54112a2ab124f669$var$formGroupClasses = (0, $beCSm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $54112a2ab124f669$export$2e2bcd8739ae039 = $54112a2ab124f669$var$formGroupClasses;



var $4tNJx = parcelRequire("4tNJx");

var $35nZB = parcelRequire("35nZB");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a3c16f3270115bea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $54112a2ab124f669$export$d72d4cbdc30b331f), classes);
};
const $a3c16f3270115bea$var$FormGroupRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $a3c16f3270115bea$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    const fcs = (0, $35nZB.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $a3c16f3270115bea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a3c16f3270115bea$var$FormGroupRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $a3c16f3270115bea$export$2e2bcd8739ae039 = $a3c16f3270115bea$var$FormGroup;



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $d922d8aa2c06f7e4$export$c4cff3a43f7cabb6(slot) {
    return (0, $4Cod0.default)('MuiRadioGroup', slot);
}
const $d922d8aa2c06f7e4$var$radioGroupClasses = (0, $beCSm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $d922d8aa2c06f7e4$export$2e2bcd8739ae039 = $d922d8aa2c06f7e4$var$radioGroupClasses;



var $Uq4Et = parcelRequire("Uq4Et");

var $5csPv = parcelRequire("5csPv");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $3049db72b7690206$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $3049db72b7690206$export$2e2bcd8739ae039 = $3049db72b7690206$var$RadioGroupContext;



var $70SAr = parcelRequire("70SAr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $851ed26fd4271995$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $d922d8aa2c06f7e4$export$c4cff3a43f7cabb6), classes);
};
const $851ed26fd4271995$var$RadioGroup = /*#__PURE__*/ $acw62.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp, ...other } = props;
    const rootRef = $acw62.useRef(null);
    const classes = $851ed26fd4271995$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $5csPv.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $acw62.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $Uq4Et.default)(ref, rootRef);
    const name = (0, $70SAr.default)(nameProp);
    const contextValue = $acw62.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3049db72b7690206$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
            role: "radiogroup",
            ref: handleRef,
            className: (0, $9QePP.default)(classes.root, className),
            ...other,
            children: children
        })
    });
});
var $851ed26fd4271995$export$2e2bcd8739ae039 = $851ed26fd4271995$var$RadioGroup;


var $7X4mk = parcelRequire("7X4mk");





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");


var $8Indx = parcelRequire("8Indx");

var $iN2NM = parcelRequire("iN2NM");
parcelRequire("acw62");

parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $1cb10b5ba3096930$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
var $59248c5edcc630d3$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');



var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $30a65a873f527c35$var$RadioButtonIconRoot = (0, $1Ikg4.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $aXkRG.default)
})({
    position: 'relative',
    display: 'flex'
});
const $30a65a873f527c35$var$RadioButtonIconBackground = (0, $1Ikg4.default)((0, $1cb10b5ba3096930$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $30a65a873f527c35$var$RadioButtonIconDot = (0, $1Ikg4.default)((0, $59248c5edcc630d3$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $lwQO9.default)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $30a65a873f527c35$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($30a65a873f527c35$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($30a65a873f527c35$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($30a65a873f527c35$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $30a65a873f527c35$export$2e2bcd8739ae039 = $30a65a873f527c35$var$RadioButtonIcon;



var $3AM7p = parcelRequire("3AM7p");

var $hPGQj = parcelRequire("hPGQj");
var $71dd6ce5929449ce$export$2e2bcd8739ae039 = (0, $hPGQj.default);



var $4tNJx = parcelRequire("4tNJx");

var $acw62 = parcelRequire("acw62");

'use client';
function $ee6a752b51430a78$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $3049db72b7690206$export$2e2bcd8739ae039));
}



var $beCSm = parcelRequire("beCSm");

var $4Cod0 = parcelRequire("4Cod0");
function $17730288e1c01674$export$192f7b2363c77155(slot) {
    return (0, $4Cod0.default)('MuiRadio', slot);
}
const $17730288e1c01674$var$radioClasses = (0, $beCSm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $17730288e1c01674$export$2e2bcd8739ae039 = $17730288e1c01674$var$radioClasses;



var $aXkRG = parcelRequire("aXkRG");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $dn5bM = parcelRequire("dn5bM");

var $3fDLr = parcelRequire("3fDLr");

var $2nO41 = parcelRequire("2nO41");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a588c4a0dc9c5bcb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $3AM7p.default)(color)}`,
            size !== 'medium' && `size${(0, $3AM7p.default)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $8Indx.default)(slots, (0, $17730288e1c01674$export$192f7b2363c77155), classes)
    };
};
const $a588c4a0dc9c5bcb$var$RadioRoot = (0, $1Ikg4.default)((0, $iN2NM.default), {
    shouldForwardProp: (prop)=>(0, $aXkRG.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $3AM7p.default)(ownerState.size)}`],
            styles[`color${(0, $3AM7p.default)(ownerState.color)}`]
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $dn5bM.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $a588c4a0dc9c5bcb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $a588c4a0dc9c5bcb$var$defaultCheckedIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {
    checked: true
});
const $a588c4a0dc9c5bcb$var$defaultIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {});
const $a588c4a0dc9c5bcb$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $a588c4a0dc9c5bcb$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $a588c4a0dc9c5bcb$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $4tNJx.default)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $a588c4a0dc9c5bcb$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $ee6a752b51430a78$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $71dd6ce5929449ce$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $a588c4a0dc9c5bcb$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        ref: ref,
        elementType: $a588c4a0dc9c5bcb$var$RadioRoot,
        className: (0, $9QePP.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $a588c4a0dc9c5bcb$export$2e2bcd8739ae039 = $a588c4a0dc9c5bcb$var$Radio;



var $9iEAl = parcelRequire("9iEAl");
const $5410406682200075$export$4b06f0d23bfef3cd = ({ value: value, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
        component: "label",
        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a588c4a0dc9c5bcb$export$2e2bcd8739ae039), {
            value: value
        }),
        ...props
    });
};


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");


var $2lSXC = parcelRequire("2lSXC");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cDXfy = parcelRequire("cDXfy");

var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");

var $5R532 = parcelRequire("5R532");

var $iD7Z3 = parcelRequire("iD7Z3");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
const $433506374a8dac7c$export$805d95ba9e806026 = ({ label: label, icon: icon, to: to })=>{
    const navigate = (0, $aphAM.useNavigate)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            '& svg:first-child': {
                fontSize: '1.5rem',
                color: 'primary.main'
            },
            '& svg:last-child': {
                fontSize: '0.85rem',
                color: 'text.main'
            },
            cursor: to ? 'pointer' : 'default'
        },
        onClick: to ? ()=>{
            navigate(to);
        } : undefined,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
            children: [
                icon,
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "h3",
                    sx: {
                        display: 'inline',
                        ml: 1,
                        mr: 'auto'
                    },
                    children: label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cDXfy.default), {})
            ]
        })
    });
};
const $433506374a8dac7c$export$7e80161600370b7 = ({ children: children, sx: sx })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
        sx: {
            p: 0,
            '& .MuiPaper-root': {
                boxShadow: 0,
                '&:not(:last-child)': {
                    pb: 0
                },
                '&:not(:last-child):after': {
                    content: '""',
                    display: 'block',
                    borderBottomStyle: 'solid',
                    borderBottomWidth: {
                        xs: 0.25,
                        md: 1
                    },
                    borderBottomColor: (0, $iD7Z3.colors).darkBlue,
                    opacity: {
                        xs: 0.4,
                        md: 0.2
                    },
                    mt: 1.5,
                    mb: 0
                }
            },
            ...sx ?? {}
        },
        children: children
    });
};




var $dHW62 = parcelRequire("dHW62");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");


const $044a381363c1342d$var$WallboxPage = ()=>{
    const dispatch = (0, $2lSXC.useDispatch)();
    const confirm = (0, $jDfxe.useConfirm)();
    const solaxWallbox = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'WB_TYPE') === 1);
    const multipleWallboxes = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'WB_TYPE') === 'next' && Object.keys((0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {}).length > 1);
    const wallboxConfig = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {});
    const wallboxKeys = (0, $2lSXC.useSelector)((s)=>{
        const config = (0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {};
        return Object.keys(config);
    });
    const rfidVisible = (0, $2lSXC.useSelector)((s)=>Boolean((0, $f1q41.get)(s.variables, 'RFID_VISIBLE')));
    const premium = (0, $2lSXC.useSelector)((s)=>Boolean((0, $f1q41.get)(s.variables, 'PREMIUM')));
    const mode = (0, $2lSXC.useSelector)((s)=>{
        if (s.variables.WB_MODE_NONE) return 'none';
        else if (s.variables.WB_MODE_SPOT) return 'spot';
        else if (s.variables.WB_MODE_PV) return 'pv';
        else if (s.variables.WB_MODE_PV_FAST) return 'pvFast';
        else if (s.variables.WB_MODE_PV2) return 'pv2';
        else if (s.variables.WB_MODE_NO_CHARGE) return 'noCharge';
    });
    const batteryStopWb = (0, $2lSXC.useSelector)((s)=>Boolean((0, $f1q41.get)(s.variables, 'PV_BATTERY_STOP_WB')));
    const onModeChange = (newMode)=>{
        if ((newMode === 'pv' || newMode === 'pvFast') && batteryStopWb) {
            confirm({
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.mode.pv.batteryStopConflict.title",
                    defaultMessage: "Re\u017Eim nelze zapnout"
                }),
                description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.mode.pv.batteryStopConflict.description",
                    defaultMessage: "Pokud je zapnut\xe1 blokace baterie p\u0159i provozu wallboxu, nelze zapnout re\u017Eim \u201ENab\xedjen\xed podle baterie\u201C. Pro zapnut\xed re\u017Eimu \u201ENab\xedjen\xed podle baterie\u201C je nutn\xe9 nejprve vypnout blokaci baterie na str\xe1nce \u201EFotovoltaika\u201C."
                }),
                confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "close",
                    defaultMessage: "Zav\u0159\xedt"
                }),
                hideCancelButton: true
            }).catch(()=>{
            // noop
            });
            return;
        }
        dispatch((0, $1Jwr0.variablesChange)({
            WB_MODE_NONE: newMode === 'none',
            WB_MODE_SPOT: newMode === 'spot',
            WB_MODE_PV: newMode === 'pv',
            WB_MODE_PV2: newMode === 'pv2',
            WB_MODE_PV_FAST: newMode === 'pvFast',
            WB_MODE_NO_CHARGE: newMode === 'noCharge'
        }));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "wallbox.status",
                        defaultMessage: "Re\u017Eim Wallboxu"
                    }),
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86275d5209b32b69$export$d39b7d88aba30ea1), {}),
                    switchVariableId: "WB_ON",
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.statistics",
                    defaultMessage: "Statistiky"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e060f302d532f11$export$2d8b3daa6660c458), {
                    variableId: "WB_CONSUMED_GRAPH",
                    getSubStatsLabel: (key)=>(0, $f1q41.get)(wallboxConfig, [
                            key,
                            'name'
                        ]) || key
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.common",
                    defaultMessage: "Obecn\xe9 informace"
                }),
                layout: "list",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.common.power",
                            defaultMessage: "Aktu\xe1ln\xed spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: "WB_ACTUAL_POWER",
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {
                            sx: {
                                width: 20
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.common.power_total",
                            defaultMessage: "Celkov\xe1 spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: !solaxWallbox ? 'NEW_WB_ENERGY_CONSUMPTION_TOTAL' : 'STATS_WB_ENERGY_CONSUMPTION_TOTAL',
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {
                            sx: {
                                width: 20
                            }
                        }),
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox.fast-charge.energy_actual",
                                    defaultMessage: "Aktu\xe1ln\xed cyklus:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "WB_ENERGY_CONSUMPTION_NOW",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_WB_ENERGY_CONSUMPTION_TODAY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: "STATS_WB_ENERGY_CONSUMPTION_YEAR",
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.control",
                    defaultMessage: "Re\u017Eim nab\xedjen\xed"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bJgPp.default), {
                        sx: {
                            width: '100%'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $851ed26fd4271995$export$2e2bcd8739ae039), {
                            "aria-labelledby": "wallbox-mode-label",
                            name: "wallbox-mode",
                            value: mode,
                            onChange: (_e, v)=>onModeChange(v),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode",
                                        defaultMessage: "B\u011B\u017En\xe9 nab\xedjen\xed"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.on_sub",
                                        defaultMessage: "Auto se nab\xedj\xed co nejrychleji"
                                    }),
                                    fullWidth: true,
                                    value: "none"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.SPOT",
                                        defaultMessage: "Nab\xedjen\xed podle spotu"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.SPOT.on_sub",
                                        defaultMessage: "Po dosa\u017Een\xed z\xe1kladn\xed energie dojde k blokov\xe1n\xed p\u0159i vysok\xe9 cen\u011B spotu"
                                    }),
                                    visibility: {
                                        variableId: 'SP_INSTALL'
                                    },
                                    fullWidth: true,
                                    value: "spot"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV",
                                        defaultMessage: "Nab\xedjen\xed podle baterie"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV.on_sub",
                                        defaultMessage: "Po dosa\u017Een\xed z\xe1kladn\xed energie dojde k nab\xedjen\xed pouze p\u0159i nabit\xe9 baterii"
                                    }),
                                    fullWidth: true,
                                    visibility: {
                                        variableIds: [
                                            'PV_INSTALL',
                                            'PV_BATTERY'
                                        ]
                                    },
                                    value: "pv"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV_FAST",
                                        defaultMessage: "P\u0159ednostn\xed nab\xedjen\xed podle baterie"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV_FAST.on_sub",
                                        defaultMessage: "Nab\xedjen\xed automobilu bude zcela prioritn\xed. Bude vyu\u017E\xedv\xe1na pouze energie z baterie nebo FVE"
                                    }),
                                    fullWidth: true,
                                    visibility: {
                                        variableIds: [
                                            'PV_INSTALL',
                                            'PV_BATTERY'
                                        ]
                                    },
                                    value: "pvFast"
                                }),
                                solaxWallbox && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV2",
                                        defaultMessage: "Nab\xedjen\xed podle FVE"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV2.on_sub",
                                        defaultMessage: "\u0158\xedzen\xed nab\xedjen\xed podle v\xfdkonu FVE"
                                    }),
                                    fullWidth: true,
                                    value: "pv2"
                                }),
                                premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5410406682200075$export$4b06f0d23bfef3cd), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.NO_CHARGE",
                                        defaultMessage: "Nenab\xedjej"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.NO_CHARGE.on_sub",
                                        defaultMessage: "Nab\xedjen\xed je trvale blokov\xe1no, spust\xed jej pouze \u010Dasov\xfd pl\xe1n"
                                    }),
                                    fullWidth: true,
                                    value: "noCharge"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.settings",
                    defaultMessage: "Nastaven\xed"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                    children: [
                        mode === 'none' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.ampers",
                                        defaultMessage: "Maxim\xe1ln\xed nab\xedjec\xed proud"
                                    }),
                                    visibility: {
                                        variableId: 'WB_MODE_NONE'
                                    },
                                    variableId: "WB_MAX_CURRENT_NONE_MODE",
                                    opts: {
                                        style: 'unit',
                                        unit: 'ampere',
                                        maximumFractionDigits: 0
                                    },
                                    min: 6,
                                    max: 32
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.hdo",
                                        defaultMessage: "Nab\xedjen\xed pouze p\u0159i n\xedzk\xe9m tarifu"
                                    }),
                                    switchVariableId: "WB_MODE_NONE_HDO",
                                    visibility: {
                                        variableId: 'WB_MODE_NONE'
                                    },
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.hdo_sub",
                                        defaultMessage: "\u010Casy pro HDO mus\xed b\xfdt nastaveny v obecn\xe9m nastaven\xed"
                                    }),
                                    fullWidth: true
                                })
                            ]
                        }),
                        mode === 'spot' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.ampers",
                                        defaultMessage: "Maxim\xe1ln\xed nab\xedjec\xed proud"
                                    }),
                                    visibility: {
                                        variableId: 'WB_MODE_SPOT'
                                    },
                                    variableId: "WB_MAX_CURRENT_SPOT",
                                    min: 6,
                                    max: 32,
                                    opts: {
                                        style: 'unit',
                                        unit: 'ampere',
                                        maximumFractionDigits: 0
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.SPOT.mi",
                                        defaultMessage: "Blokovat nab\xedjen\xed p\u0159i st\u0159edn\xed cen\u011B"
                                    }),
                                    switchVariableId: "WB_SPOT_MI_STOP",
                                    visibility: {
                                        variableId: 'WB_MODE_SPOT'
                                    },
                                    fullWidth: true
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.SPOT.hi",
                                        defaultMessage: "Blokovat nab\xedjen\xed p\u0159i vysok\xe9 cen\u011B"
                                    }),
                                    switchVariableId: "WB_SPOT_HI_STOP",
                                    visibility: {
                                        variableId: 'WB_MODE_SPOT'
                                    },
                                    fullWidth: true
                                })
                            ]
                        }),
                        mode === 'pv' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.amper-auto",
                                        defaultMessage: "Automatick\xe9 \u0159\xedzen\xed nab\xedjec\xedho proudu"
                                    }),
                                    switchVariableId: "WB_MAX_CURRENT_BATTERY_AUTO",
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.amper-auto.subtitle",
                                        defaultMessage: "\u0158\xedd\xed nab\xedjen\xed aby se minimalizovalo nab\xedjen\xed a vyb\xedjen\xed baterie"
                                    }),
                                    fullWidth: true,
                                    visibility: {
                                        variableId: 'WB_MODE_PV'
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                    type: "row",
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "wallbox.pv.ampers-auto",
                                            defaultMessage: "Aktu\xe1ln\xed po\u017Eadovan\xfd nab\xedjec\xed proud"
                                        })
                                    }),
                                    value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                        variableId: "WB_MAX_CURRENT",
                                        opts: {
                                            style: 'unit',
                                            unit: 'ampere',
                                            maximumFractionDigits: 0
                                        }
                                    }),
                                    visibility: {
                                        variableIds: [
                                            'WB_MAX_CURRENT_BATTERY_AUTO',
                                            'PV_BATTERY',
                                            'WB_MODE_PV'
                                        ]
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.ampers",
                                        defaultMessage: "Maxim\xe1ln\xed nab\xedjec\xed proud"
                                    }),
                                    visibility: {
                                        variableIds: [
                                            'PV_BATTERY',
                                            'WB_MODE_PV'
                                        ]
                                    },
                                    variableId: "WB_MAX_CURRENT_BATTERY",
                                    opts: {
                                        style: 'unit',
                                        unit: 'ampere',
                                        maximumFractionDigits: 0
                                    },
                                    min: 6,
                                    max: 32
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV.batteryStart",
                                        defaultMessage: "Zapnout p\u0159i nabit\xed"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV.batteryStart.subtitle",
                                        defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se aktivuje nab\xedjen\xed"
                                    }),
                                    visibility: {
                                        variableId: 'WB_MODE_PV'
                                    },
                                    variableId: 'WB_BAT_START',
                                    opts: {
                                        style: 'percent',
                                        maximumFractionDigits: 0
                                    },
                                    min: 20
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV.batteryStop",
                                        defaultMessage: "Vypnout p\u0159i nabit\xed"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV.batteryStop.subtitle",
                                        defaultMessage: "Nabit\xed baterie p\u0159i kter\xe9m se vypne nab\xedjen\xed"
                                    }),
                                    visibility: {
                                        variableId: 'WB_MODE_PV'
                                    },
                                    variableId: 'WB_BAT_STOP',
                                    opts: {
                                        style: 'percent',
                                        maximumFractionDigits: 0
                                    },
                                    min: 20
                                })
                            ]
                        }),
                        mode === 'pvFast' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                                    type: "row",
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.pv.ampers-auto",
                                        defaultMessage: "Aktu\xe1ln\xed po\u017Eadovan\xfd nab\xedjec\xed proud"
                                    }),
                                    value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                        variableId: "WB_MAX_CURRENT",
                                        opts: {
                                            style: 'unit',
                                            unit: 'ampere',
                                            maximumFractionDigits: 0
                                        }
                                    }),
                                    visibility: {
                                        variableIds: [
                                            'PV_BATTERY',
                                            'WB_MODE_PV_FAST'
                                        ]
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.nonemode.ampers",
                                        defaultMessage: "Maxim\xe1ln\xed nab\xedjec\xed proud"
                                    }),
                                    visibility: {
                                        variableIds: [
                                            'PV_BATTERY',
                                            'WB_MODE_PV_FAST'
                                        ]
                                    },
                                    variableId: "WB_MAX_CURRENT_BATTERY_FAST",
                                    opts: {
                                        style: 'unit',
                                        unit: 'ampere',
                                        maximumFractionDigits: 0
                                    },
                                    min: 6,
                                    max: 32
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV_FAST.batteryMinSoc",
                                        defaultMessage: "Minim\xe1ln\xed rezerva baterie"
                                    }),
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.PV_FAST.batteryMinSoc.subtitle",
                                        defaultMessage: "Baterie se kv\u016Fli nab\xedjen\xed automobilu nevybije pod tuto hodnotu. Dokud nen\xed hodnota p\u0159ekro\u010Dena, nab\xedjen\xed \u010Dek\xe1"
                                    }),
                                    visibility: {
                                        variableIds: [
                                            'PV_BATTERY',
                                            'WB_MODE_PV_FAST'
                                        ]
                                    },
                                    variableId: "WB_BAT_FAST_MIN_SOC",
                                    opts: {
                                        style: 'percent',
                                        maximumFractionDigits: 0
                                    },
                                    min: 10,
                                    max: 90
                                })
                            ]
                        }),
                        mode === 'pv2' && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.3a.on",
                                        defaultMessage: "M\xf3d 3A"
                                    }),
                                    switchVariableId: "WB_MODE_PV2_3A",
                                    visibility: {
                                        variableId: 'WB_MODE_PV2'
                                    },
                                    fullWidth: true,
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.3a.on_sub",
                                        defaultMessage: "Nab\xedjen\xed m\u016F\u017Ee br\xe1t 3A z distribu\u010Dn\xed s\xedt\u011B"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.6a.on",
                                        defaultMessage: "M\xf3d 6A"
                                    }),
                                    switchVariableId: "WB_MODE_PV2_6A",
                                    visibility: {
                                        variableId: 'WB_MODE_PV2'
                                    },
                                    fullWidth: true,
                                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox.6a.on_sub",
                                        defaultMessage: "Nab\xedjen\xed lze pouze z FVE"
                                    })
                                })
                            ]
                        }),
                        mode !== 'none' && mode !== 'pvFast' && mode !== 'noCharge' && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea1a6557faa30a5b$export$14401a347825b9d1), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "wallbox.fast-charge.energy",
                                defaultMessage: "Energie pro rychl\xe9 nabit\xed"
                            }),
                            subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "wallbox.fast-charge.energy_sub",
                                defaultMessage: "Energie, kter\xe1 je v\u017Edy co nejrychleji nabita. Po dosa\u017Een\xed t\xe9to hodnoty je nabit\xed \u0159\xedzeno jedn\xedm z re\u017Eim\u016F"
                            }),
                            variableId: "WB_MIN_CHARGE_ENERGY",
                            min: 0,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt-hour',
                                maximumFractionDigits: 0
                            }
                        })
                    ]
                })
            }),
            (rfidVisible || multipleWallboxes) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.other",
                    defaultMessage: "Ostatn\xed"
                }),
                layout: "list",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $433506374a8dac7c$export$7e80161600370b7), {
                    children: [
                        multipleWallboxes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $433506374a8dac7c$export$805d95ba9e806026), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ca13d7071bdc09b$export$3c4a512d8d27eaad), {}),
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "wallbox.wallboxes.title",
                                defaultMessage: "Wallboxy"
                            }),
                            to: (0, $dHW62.links).wallboxList
                        }),
                        rfidVisible && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $433506374a8dac7c$export$805d95ba9e806026), {
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ea8f9fce582fedc8$export$e5d44a4194605db9), {}),
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.title",
                                defaultMessage: "RFID karty"
                            }),
                            to: (0, $dHW62.links).rfidCards
                        })
                    ]
                })
            }),
            premium && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ddbf1ea2b354a30a$export$4d8c8cd2c300d546), {
                types: (0, $1e5a62547c9ca153$export$bb0c8ebce24804d6),
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.schedules.title",
                    defaultMessage: "Pl\xe1nova\u010D nab\xedjen\xed"
                }),
                description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox.schedules.description",
                    defaultMessage: "Napl\xe1nujte si nab\xedjen\xed elektromobilu podle pot\u0159eby."
                })
            })
        ]
    });
};
var $044a381363c1342d$export$2e2bcd8739ae039 = $044a381363c1342d$var$WallboxPage;



var $ayMG0 = parcelRequire("ayMG0");

var $1DAbm = parcelRequire("1DAbm");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");

var $2lSXC = parcelRequire("2lSXC");
const $0c33a724b40957e5$var$CustomPage = ()=>{
    const { tabUrl: tabUrl } = (0, $aphAM.useParams)();
    const customTabs = (0, $2lSXC.useSelector)(({ variables: variables })=>variables.APP_UI_CUSTOM_TABS || []);
    const tab = customTabs.find((t)=>t.url === tabUrl);
    if (!tab) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aphAM.Navigate), {
        to: "/"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
        sx: {
            display: 'flex',
            justifyContent: 'center',
            p: 0
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
            src: tab.iframeSrc,
            title: tab.label,
            style: {
                width: '100%',
                height: '70vh',
                border: 'none'
            }
        })
    });
};
var $0c33a724b40957e5$export$2e2bcd8739ae039 = $0c33a724b40957e5$var$CustomPage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");
const $0a7bb694e3e3bc56$export$d1a121333e17a5bb = ({ variableIds: variableIds })=>{
    const { connected: connected, variables: store } = (0, $2lSXC.useSelector)((s)=>s);
    const dispatch = (0, $2lSXC.useDispatch)();
    const [beforeEditing, setBeforeEditing] = (0, $acw62.useState)();
    const [invalid, setInvalid] = (0, $acw62.useState)(false);
    const textarea = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!textarea.current) return;
        const focused = textarea.current.matches(':focus');
        if (focused) return;
        const storeForInspect = variableIds ? (0, $f1q41.pick)(store, ...variableIds) : store;
        textarea.current.value = JSON.stringify(storeForInspect, null, 2);
    }, [
        store
    ]);
    const onBlur = (0, $acw62.useCallback)((e)=>{
        setInvalid(false);
        let newVal;
        try {
            newVal = JSON.parse(e.target.value);
        } catch (err) {
            setInvalid(true);
            return;
        }
        if (!newVal || !beforeEditing) return;
        const diff = Object.entries(newVal).reduce((acc, [key, value])=>{
            if (JSON.stringify(value) === JSON.stringify(beforeEditing[key])) return acc;
            return {
                ...acc,
                [key]: value
            };
        }, {});
        setBeforeEditing(undefined);
        dispatch((0, $1Jwr0.variablesChange)(diff));
    }, [
        beforeEditing
    ]);
    if (!connected) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
        ref: textarea,
        onFocus: (e)=>setBeforeEditing(JSON.parse(e.target.value)),
        onBlur: onBlur,
        style: {
            width: 800,
            height: 800,
            resize: 'none',
            border: invalid ? 'solid 2px red' : ''
        }
    });
};




const $905c51792f4bf561$export$d1a121333e17a5bb = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {})
        ]
    });
};
var $905c51792f4bf561$export$2e2bcd8739ae039 = $905c51792f4bf561$export$d1a121333e17a5bb;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $d984f8ed5a827fae$export$b08c0cf1d0dd8a38 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Inverter"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'PV_INVERTER_TYPE',
                    'MODBUS_TEST_ADDRESS',
                    'MODBUS_TEST_PORT',
                    'PV_cnt_com_ok',
                    'PV_cnt_com_err',
                    'PV_cnt_com_write',
                    'INVERTER_STATUS',
                    'INVERTER_CONFIG',
                    'INVERTER_STATS',
                    'INVERTER_STATS_PERSISTED'
                ]
            })
        ]
    });
};
var $d984f8ed5a827fae$export$2e2bcd8739ae039 = $d984f8ed5a827fae$export$b08c0cf1d0dd8a38;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $df15c1cd94646d32$var$InspectWallbox = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Wallbox"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'WB_TYPE',
                    'WB_IP_ADRESS',
                    'WB_IP_PORT',
                    'WB_CLIENT_ID',
                    'WB_INSTALL',
                    'WB_ON',
                    'WB_com_ok',
                    'WB_cnt_com_ok',
                    'WB_cnt_com_err',
                    'WB_cnt_com_write',
                    'WB_STATE',
                    'WB_ACTUAL_POWER',
                    'WB_MAX_DYNAMIC_CURRENT',
                    'WB_MAX_CURRENT',
                    'WB_WALLBOX_READY_COUNT',
                    'WB_WALLBOX_CONNECTED_COUNT',
                    'WB_WAIT',
                    'WALLBOX_CONFIG',
                    'WALLBOX_STATS',
                    'WALLBOX_STATS_PERSISTED',
                    'WB_ACTUAL_POWER_TOTAL',
                    'WB_ENERGY_CONSUMPTION_TOTAL',
                    'STATS_WB_ENERGY_CONSUMPTION_YEAR',
                    'STATS_WB_ENERGY_CONSUMPTION_TODAY',
                    'NEW_WB_ENERGY_CONSUMPTION_TOTAL',
                    'WB_MODE_PV',
                    'WB_MODE_SPOT',
                    'WB_MODE_AUTO',
                    'WB_MIN_CHARGE_ENERGY',
                    'WB_MODE_NONE',
                    'WB_SPOT_MI_STOP',
                    'WB_SPOT_HI_STOP',
                    'WB_TIME_OF_DISCONNECT',
                    'WB_INFO',
                    'WALLBOX_WAIT',
                    'RFID_READER_STATS',
                    'WALLBOX_AUTHORIZATION'
                ]
            })
        ]
    });
};
var $df15c1cd94646d32$export$2e2bcd8739ae039 = $df15c1cd94646d32$var$InspectWallbox;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $74e24002ff3c9c68$var$InspectHeatPump = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Heat Pump"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'HP_ENABLED',
                    'HP_TYPE',
                    'HP_ECOONE_API_IP',
                    'HP_MODBUS_PORT',
                    'HP_NOMINAL',
                    'HP_TYPE_NIBE',
                    'HP_TYPE_COMPRESSOR',
                    'HP_com_ok',
                    'HP_com_wite_ok',
                    'HP_cnt_com_ok',
                    'HP_cnt_com_err',
                    'HP_cnt_com_write',
                    'HP_cnt_com_write_ok',
                    'HP_cnt_com_write_err',
                    'HP_ON',
                    'HP_INFO_Status',
                    'HP_INFO',
                    'HP_ACTUAL_POWER',
                    'HP_ACTUAL_POWER_SET',
                    'HP_TEMP',
                    'HP_IN',
                    'HP_FLEXIBILITY_POWER',
                    'HP_FLEXIBILITY_ON',
                    'HP_FLEXIBILITY',
                    'HP_PV_FLEXIBILITY',
                    'HP_PV_STABILITY',
                    'HP_FLEXI_ROOM',
                    'HP_FLEXI_HW',
                    'HP_FLEXI_COOL',
                    'HP_FLEXI_AN',
                    'HP_ROOM_ON',
                    'HP_ROOM_TEMP',
                    'HP_HW_ON',
                    'HP_HW_TEMP',
                    'HP_HW_SET_TEMP',
                    'HP_ENERGY_CONSUMED_TOTAL',
                    'HP_ENERGY_CONSUMED_TOTAL_R',
                    'HP_SOC_STOP',
                    'HP_SOC_STOP_UTILITY',
                    'HP_PRIORITY',
                    'HP_BATTERY_BLOCK',
                    'SP_HP_STATUS',
                    'SP_HP_NOW_REDUCE_ON',
                    'SP_HP_NOW_INCREASE_ON'
                ]
            })
        ]
    });
};
var $74e24002ff3c9c68$export$2e2bcd8739ae039 = $74e24002ff3c9c68$var$InspectHeatPump;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $77cdb5e3720e2cb5$var$InspectSpot = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Spot"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'SP_TEST_MODE',
                    'SP_TEST_MODE_PRICE_SET',
                    'SP_FORECAST_PV',
                    'SP_FORECAST_HOME_CONSUMPTIN',
                    'SP_FORECAST_HOME_CONSUMPTIN_PV',
                    'SP_PV_TOTAL_CONSUMPTION',
                    'SP_FORECAST_HP_CONSUMPTIN',
                    'SP_FORECAST_PV_DEBREEFING',
                    'SP_FORECAST_BATTERY_CONSUMPTIN',
                    'SP_HOURS_PRICE_DATE',
                    'SP_ACTUAL_PRICE',
                    'SP_PV_RADIATION_DATE',
                    'SP_LOW_PRICE',
                    'SP_HI_PRICE',
                    'SP_PRICE_HYSTERESIS',
                    'SP_BATTERY_CHARGE',
                    'SP_BATTERY_DISCHARGE',
                    'SP_PRICE_PERIOD',
                    'SP_DISCHARGE_TO_GRID_FINAL_SOC',
                    'SP_NIGHT_BATTERY_CONSUMPTION',
                    //table
                    'SP_BATTERY_GRID_CHARGE_TABLE_15M',
                    'SP_BATTERY_GRID_DISCHARGE_TABLE_15M'
                ]
            })
        ]
    });
};
var $77cdb5e3720e2cb5$export$2e2bcd8739ae039 = $77cdb5e3720e2cb5$var$InspectSpot;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $337d3741ac3df784$var$InspectMqtt = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Mqtt"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'MQTT_CLOUD_ENABLED',
                    'MQTT_CLOUD_CONNECTED',
                    'MQTT_CLOUD_LAST_MESSAGE_AT',
                    'DELTA_GREEN_API_ENABLED',
                    'DELTA_GREEN_API_CONNECTED',
                    'DELTA_GREEN_API_LAST_MESSAGES'
                ]
            })
        ]
    });
};
var $337d3741ac3df784$export$2e2bcd8739ae039 = $337d3741ac3df784$var$InspectMqtt;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $f6Tww = parcelRequire("f6Tww");

var $5R532 = parcelRequire("5R532");
const $d708a045b589926d$export$19f89d0bc186046e = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect Plugs"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    'MQTT_CLOUD_INSTALL',
                    'MQTT_CLOUD_ADDRESS',
                    'MQTT_CLOUD_LAST_MESSAGE_AT',
                    'MQTT_CLOUD_CONNECTED',
                    'MQTT_CLOUD_DEVICES',
                    'MQTT_CLOUD_DEVICES_STATUS',
                    'CLOUD_PLUGS_INSTALL'
                ]
            })
        ]
    });
};
var $d708a045b589926d$export$2e2bcd8739ae039 = $d708a045b589926d$export$19f89d0bc186046e;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $5R532 = parcelRequire("5R532");

var $f6Tww = parcelRequire("f6Tww");

const $9b2b4a001fc3be02$var$InspectPlc = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                children: "Inspect PLC (Dispatching Control)"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/inverter",
                        children: "Inverter"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/wallbox",
                        children: "Wallbox"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/heat-pump",
                        children: "Heat pump"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/mqtt",
                        children: "MQTT"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plugs",
                        children: "Plugs"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/spot",
                        children: "Spot"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f6Tww.LinkComponent), {
                        to: "/inspect/plc",
                        children: "PLC"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a7bb694e3e3bc56$export$d1a121333e17a5bb), {
                variableIds: [
                    // Configuration
                    'PLC_CONFIG',
                    // Status
                    'PLC_STATUS',
                    // Grid Metrics
                    'PLC_GRID_METRICS',
                    // PV Metrics
                    'PLC_PV_METRICS',
                    // KGJ Metrics
                    'PLC_KGJ_METRICS',
                    'PLC_DISTRIBUTION_METRICS'
                ]
            })
        ]
    });
};
var $9b2b4a001fc3be02$export$2e2bcd8739ae039 = $9b2b4a001fc3be02$var$InspectPlc;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $bc79313bef060bae$var$NotFound = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
        style: {
            textAlign: 'center'
        },
        children: "Not found"
    });
var $bc79313bef060bae$export$2e2bcd8739ae039 = $bc79313bef060bae$var$NotFound;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $2zDt6 = parcelRequire("2zDt6");

var $gc70Y = parcelRequire("gc70Y");

var $kwTO3 = parcelRequire("kwTO3");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");



var $f1q41 = parcelRequire("f1q41");

var $5tslE = parcelRequire("5tslE");

var $9iE6L = parcelRequire("9iE6L");

var $gpaJb = parcelRequire("gpaJb");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $03kOd = parcelRequire("03kOd");
var $5WsCn = parcelRequire("5WsCn");
var $gc70Y = parcelRequire("gc70Y");
var $1GEFm = parcelRequire("1GEFm");
var $kZugz = parcelRequire("kZugz");
var $7X4mk = parcelRequire("7X4mk");

var $iH29s = parcelRequire("iH29s");

var $5R532 = parcelRequire("5R532");

var $8ni7a = parcelRequire("8ni7a");
const $505c4dce7abb9b45$export$354ff7f6266cc820 = ({ type: type })=>{
    const [battery, setBattery] = (0, $acw62.useState)((0, $8ni7a.FlexibilityCommandBattery).Default);
    const [pv, setPv] = (0, $acw62.useState)((0, $8ni7a.FlexibilityCommandPv).Unrestricted);
    const [ttl, setTtl] = (0, $acw62.useState)(600);
    const [targetSoc, setTargetSoc] = (0, $acw62.useState)(0.8);
    const { mutate: mutate } = (0, $iH29s.trpc).flexibility.commandTest.useMutation();
    const submit = ()=>{
        mutate({
            type: type,
            payload: {
                battery: battery,
                pv: pv,
                target_soc_percentage: targetSoc,
                ttl_seconds: ttl
            }
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                sx: {
                    mb: 2
                },
                children: "Command Test"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                        label: "Battery",
                        value: battery,
                        onChange: (e)=>{
                            setBattery(e.target.value);
                        },
                        children: Object.values((0, $8ni7a.FlexibilityCommandBattery)).map((command)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: command,
                                children: command
                            }, command))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                        label: "PV",
                        value: pv,
                        onChange: (e)=>{
                            setPv(e.target.value);
                        },
                        children: Object.values((0, $8ni7a.FlexibilityCommandPv)).map((command)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: command,
                                children: command
                            }, command))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: targetSoc,
                        onChange: (e)=>setTargetSoc(Number(e.target.value)),
                        label: "Target SOC",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: ttl,
                        onChange: (e)=>setTtl(Number(e.target.value)),
                        label: "TTL in seconds",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        size: "small",
                        onClick: submit,
                        children: "Odeslat"
                    })
                ]
            })
        ]
    });
};


parcelRequire("cW890");
var $dKB2I = parcelRequire("dKB2I");
const $5d0789d73fcb1a17$var$numericSchema = (0, $4c6625c87c7e6d95$export$37c8851fa259e26)((0, $2zDt6.z).number().gte(0));
const $5d0789d73fcb1a17$var$DeltaGreen = ()=>{
    const [serviceActive, connected, lastMessages, activeCommand] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.DELTA_GREEN_API_CONNECTED,
            variables.DELTA_GREEN_API_LAST_MESSAGES,
            variables.FLEXIBILITY_ACTIVE_COMMAND
        ]);
    const lastMessagesReversed = (0, $acw62.useMemo)(()=>{
        return (0, $f1q41.reverse)(lastMessages ? [
            ...lastMessages
        ] : []);
    }, [
        lastMessages
    ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "delta_green.title",
            defaultMessage: "Delta Green"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "delta_green.title",
                    defaultMessage: "Delta Green"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        switchVariableId: "DELTA_GREEN_API_ENABLED",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.enabled",
                            defaultMessage: "Integrace zapnuta"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.connected",
                            defaultMessage: "Stav"
                        }),
                        value: connected ? 'Online' : "Nep\u0159ipojeno"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.battery_max_power_in",
                            defaultMessage: "Maxim\xe1ln\xed v\xfdkon baterie IN (W)"
                        }),
                        inputVariableId: "DELTA_GREEN_BATTERY_MAX_POWER_IN",
                        fullWidth: true,
                        schema: $5d0789d73fcb1a17$var$numericSchema
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.battery_max_power_out",
                            defaultMessage: "Maxim\xe1ln\xed v\xfdkon baterie OUT (W)"
                        }),
                        inputVariableId: "DELTA_GREEN_BATTERY_MAX_POWER_OUT",
                        fullWidth: true,
                        schema: $5d0789d73fcb1a17$var$numericSchema
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.pv_orientation",
                            defaultMessage: "Orientace fotovoltaiky"
                        }),
                        inputVariableId: "DELTA_GREEN_PV_ORIENTATION",
                        fullWidth: true,
                        schema: $5d0789d73fcb1a17$var$numericSchema
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "delta_green.last_messages",
                            defaultMessage: "Posledn\xed zpr\xe1vy"
                        }),
                        rows: [
                            [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "delta_green.last_messages.date",
                                    defaultMessage: "\u010Cas"
                                }, 0),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "delta_green.last_messages.topic",
                                    defaultMessage: "Topic"
                                }, 1),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "delta_green.last_messages.payload",
                                    defaultMessage: "Zpr\xe1va"
                                }, 2)
                            ],
                            ...lastMessagesReversed.map(({ date: date, payload: payload, topic: topic })=>{
                                return [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                                        value: date
                                    }, 0),
                                    JSON.stringify(topic),
                                    JSON.stringify(payload)
                                ];
                            })
                        ],
                        lastColBold: false,
                        firstColBold: false,
                        firstLineBold: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "delta_green.business_flexibility.title",
                    defaultMessage: "Obchodn\xed flexibilita"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $505c4dce7abb9b45$export$354ff7f6266cc820), {
                        type: (0, $dKB2I.FlexibilityCommandType).DeltaGreenBusinessFlexibility
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: JSON.stringify(activeCommand)
                    })
                ]
            })
        ]
    });
};
var $5d0789d73fcb1a17$export$2e2bcd8739ae039 = $5d0789d73fcb1a17$var$DeltaGreen;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $gc70Y = parcelRequire("gc70Y");

var $kwTO3 = parcelRequire("kwTO3");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");



var $f1q41 = parcelRequire("f1q41");

var $5tslE = parcelRequire("5tslE");

var $9iE6L = parcelRequire("9iE6L");

parcelRequire("cW890");
var $dKB2I = parcelRequire("dKB2I");
const $d756029411c6ede9$var$Electree = ()=>{
    const [serviceActive, connected, lastMessages, activeCommand] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.ELECTREE_API_CONNECTED,
            variables.ELECTREE_API_LAST_MESSAGES,
            variables.FLEXIBILITY_ACTIVE_COMMAND
        ]);
    const lastMessagesReversed = (0, $acw62.useMemo)(()=>{
        return (0, $f1q41.reverse)(lastMessages ? [
            ...lastMessages
        ] : []);
    }, [
        lastMessages
    ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "electree.title",
            defaultMessage: "Electree"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "electree.title",
                    defaultMessage: "Electree"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        switchVariableId: "ELECTREE_API_ENABLED",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electree.enabled",
                            defaultMessage: "Integrace zapnuta"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electree.connected",
                            defaultMessage: "Stav"
                        }),
                        value: connected ? 'Online' : "Nep\u0159ipojeno"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "electree.last_messages",
                            defaultMessage: "Posledn\xed zpr\xe1vy"
                        }),
                        rows: [
                            [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electree.last_messages.date",
                                    defaultMessage: "\u010Cas"
                                }, 0),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electree.last_messages.topic",
                                    defaultMessage: "Topic"
                                }, 1),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "electree.last_messages.payload",
                                    defaultMessage: "Zpr\xe1va"
                                }, 2)
                            ],
                            ...lastMessagesReversed.map(({ date: date, payload: payload, topic: topic })=>{
                                return [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                                        value: date
                                    }, 0),
                                    JSON.stringify(topic),
                                    JSON.stringify(payload)
                                ];
                            })
                        ],
                        lastColBold: false,
                        firstColBold: false,
                        firstLineBold: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "electree.business_flexibility.title",
                    defaultMessage: "Obchodn\xed flexibilita"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $505c4dce7abb9b45$export$354ff7f6266cc820), {
                        type: (0, $dKB2I.FlexibilityCommandType).Electree
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: JSON.stringify(activeCommand)
                    })
                ]
            })
        ]
    });
};
var $d756029411c6ede9$export$2e2bcd8739ae039 = $d756029411c6ede9$var$Electree;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $03kOd = parcelRequire("03kOd");
var $jzib7 = parcelRequire("jzib7");
var $js9Z9 = parcelRequire("js9Z9");
var $5WsCn = parcelRequire("5WsCn");
var $gc70Y = parcelRequire("gc70Y");
var $1GEFm = parcelRequire("1GEFm");
var $kZugz = parcelRequire("kZugz");
var $7X4mk = parcelRequire("7X4mk");

var $kwTO3 = parcelRequire("kwTO3");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $2lSXC = parcelRequire("2lSXC");



var $f1q41 = parcelRequire("f1q41");

var $5tslE = parcelRequire("5tslE");

var $9iE6L = parcelRequire("9iE6L");

var $iH29s = parcelRequire("iH29s");

var $5R532 = parcelRequire("5R532");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");
var $dKB2I = parcelRequire("dKB2I");
const $2989e93503d9fb01$var$EnergomachineCommandTest = ()=>{
    const [batteryMode, setBatteryMode] = (0, $acw62.useState)((0, $8ni7a.EnergomachineBatteryMode).ManualOut);
    const [durationSec, setDurationSec] = (0, $acw62.useState)(600);
    const [minCharge, setMinCharge] = (0, $acw62.useState)(20);
    const [maxCharge, setMaxCharge] = (0, $acw62.useState)(80);
    const [allowExcess, setAllowExcess] = (0, $acw62.useState)(true);
    const [flowLimitKwh, setFlowLimitKwh] = (0, $acw62.useState)(5);
    const { mutate: mutate } = (0, $iH29s.trpc).flexibility.commandTest.useMutation();
    const submit = ()=>{
        mutate({
            type: (0, $dKB2I.FlexibilityCommandType).Energomachine,
            payload: {
                battery_mode: batteryMode,
                execution_duration_sec: durationSec,
                min_charge: minCharge,
                max_charge: maxCharge,
                allow_excess: allowExcess,
                battery_flow_limit_kwh: flowLimitKwh
            }
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                variant: "h3",
                sx: {
                    mb: 2
                },
                children: "Command Test"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 1,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
                        label: "Battery mode",
                        value: batteryMode,
                        onChange: (e)=>{
                            setBatteryMode(e.target.value);
                        },
                        children: Object.values((0, $8ni7a.EnergomachineBatteryMode)).map((mode)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                                value: mode,
                                children: mode
                            }, mode))
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: durationSec,
                        onChange: (e)=>setDurationSec(Number(e.target.value)),
                        label: "Duration in seconds",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: minCharge,
                        onChange: (e)=>setMinCharge(Number(e.target.value)),
                        label: "Min charge %",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: maxCharge,
                        onChange: (e)=>setMaxCharge(Number(e.target.value)),
                        label: "Max charge %",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                        value: flowLimitKwh,
                        onChange: (e)=>setFlowLimitKwh(Number(e.target.value)),
                        label: "Flow limit kWh",
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $js9Z9.default), {
                        control: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jzib7.default), {
                            checked: allowExcess,
                            onChange: (e)=>setAllowExcess(e.target.checked)
                        }),
                        label: "Allow excess"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        variant: "contained",
                        size: "small",
                        onClick: submit,
                        children: "Odeslat"
                    })
                ]
            })
        ]
    });
};
const $2989e93503d9fb01$var$Energomachine = ()=>{
    const [serviceActive, connected, lastMessages, activeCommand] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.ENERGOMACHINE_API_CONNECTED,
            variables.ENERGOMACHINE_API_LAST_MESSAGES,
            variables.FLEXIBILITY_ACTIVE_COMMAND
        ]);
    const lastMessagesReversed = (0, $acw62.useMemo)(()=>{
        return (0, $f1q41.reverse)(lastMessages ? [
            ...lastMessages
        ] : []);
    }, [
        lastMessages
    ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "energomachine.title",
            defaultMessage: "Energomachine"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "energomachine.title",
                    defaultMessage: "Energomachine"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        switchVariableId: "ENERGOMACHINE_API_ENABLED",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "energomachine.enabled",
                            defaultMessage: "Integrace zapnuta"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "energomachine.connected",
                            defaultMessage: "Stav"
                        }),
                        value: connected ? 'Online' : "Nep\u0159ipojeno"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "energomachine.last_messages",
                            defaultMessage: "Posledn\xed zpr\xe1vy"
                        }),
                        rows: [
                            [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energomachine.last_messages.date",
                                    defaultMessage: "\u010Cas"
                                }, 0),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energomachine.last_messages.topic",
                                    defaultMessage: "Topic"
                                }, 1),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "energomachine.last_messages.payload",
                                    defaultMessage: "Zpr\xe1va"
                                }, 2)
                            ],
                            ...lastMessagesReversed.map(({ date: date, payload: payload, topic: topic })=>{
                                return [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                                        value: date
                                    }, 0),
                                    JSON.stringify(topic),
                                    JSON.stringify(payload)
                                ];
                            })
                        ],
                        lastColBold: false,
                        firstColBold: false,
                        firstLineBold: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "energomachine.business_flexibility.title",
                    defaultMessage: "Obchodn\xed flexibilita"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2989e93503d9fb01$var$EnergomachineCommandTest, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: JSON.stringify(activeCommand)
                    })
                ]
            })
        ]
    });
};
var $2989e93503d9fb01$export$2e2bcd8739ae039 = $2989e93503d9fb01$var$Energomachine;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
const $14d32f0fb40007ed$var$MqttCloud = ()=>{
    const [serviceActive, connected] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.MQTT_CLOUD_CONNECTED
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "mqtt_cloud.title",
            defaultMessage: "MQTT Cloud"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
            layout: "list",
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "mqtt_cloud.title",
                defaultMessage: "MQTT Cloud"
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    switchVariableId: "MQTT_CLOUD_ENABLED",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_cloud.enabled",
                        defaultMessage: "Integrace zapnuta"
                    }),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                    type: "row",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_cloud.connected",
                        defaultMessage: "Stav"
                    }),
                    value: connected ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_cloud.connected.online",
                        defaultMessage: "Online"
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_cloud.connected.offline",
                        defaultMessage: "Offline"
                    })
                })
            ]
        })
    });
};
var $14d32f0fb40007ed$export$2e2bcd8739ae039 = $14d32f0fb40007ed$var$MqttCloud;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $5tslE = parcelRequire("5tslE");

var $2lSXC = parcelRequire("2lSXC");

var $iH29s = parcelRequire("iH29s");
const $d11846483bfc7257$var$MqttBroker = ()=>{
    const [serviceActive, running] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.MQTT_BROKER_RUNNING
        ]);
    const { data: data } = (0, $iH29s.trpc).listMqttBrokerClients.useQuery(undefined, {
        refetchInterval: 1000
    });
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "mqtt_broker.title",
            defaultMessage: "MQTT Broker"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
            layout: "list",
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "mqtt_broker.title",
                defaultMessage: "MQTT Broker"
            }),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    switchVariableId: "MQTT_BROKER_ENABLED",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_broker.enabled",
                        defaultMessage: "Zapnuto"
                    }),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                    type: "row",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_broker.running",
                        defaultMessage: "Stav"
                    }),
                    value: running ? "Aktivn\xed" : "Neaktivn\xed"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "mqtt_broker.connected_clients.title",
                        defaultMessage: "Clients"
                    }),
                    rows: [
                        [
                            'ID',
                            ''
                        ],
                        ...(data || []).map(({ id: id })=>[
                                id,
                                ''
                            ])
                    ]
                })
            ]
        })
    });
};
var $d11846483bfc7257$export$2e2bcd8739ae039 = $d11846483bfc7257$var$MqttBroker;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");


var $2lSXC = parcelRequire("2lSXC");


var $gpaJb = parcelRequire("gpaJb");

const $b72b84016321a592$var$Shellies = ()=>{
    const [serviceActive, running, shellies] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.MQTT_BROKER_RUNNING,
            variables.MQTT_BROKER_SHELLIES
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "shellies.title",
            defaultMessage: "Shellies"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "shellies.title",
                    defaultMessage: "Shellies"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "shellies.mqtt_broker_running",
                            defaultMessage: "Stav MQTT Brokerka"
                        }),
                        value: running ? "Aktivn\xed" : "Neaktivn\xed"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ac18b1cf1efeef72$export$11a7c0eecfe66def), {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "shellies.settings",
                    defaultMessage: "Nastaven\xed"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "shellies.settings.boiler.active",
                            defaultMessage: "Bojler p\u0159ipojen\xfd p\u0159es Shellies"
                        }),
                        switchVariableId: "HW_SHELLIES",
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "shellies.settings.boiler.id",
                            defaultMessage: "ID shellies"
                        }),
                        inputVariableId: "HW_SHELLIES_ID",
                        visibility: {
                            variableId: 'HW_SHELLIES'
                        },
                        label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "shellies.settings.boiler.id.label",
                            defaultMessage: "ID"
                        }),
                        fullWidth: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3dc3df7832e62d63$export$762e4704b3dfbcf6), {})
        ]
    });
};
var $b72b84016321a592$export$2e2bcd8739ae039 = $b72b84016321a592$var$Shellies;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $JYcZH = parcelRequire("JYcZH");
var $91vj1 = parcelRequire("91vj1");
var $u24M4 = parcelRequire("u24M4");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");
var $7X4mk = parcelRequire("7X4mk");

var $ko6Bk = parcelRequire("ko6Bk");
var $8YLZH = parcelRequire("8YLZH");
var $5uhCp = parcelRequire("5uhCp");
var $NDEo7 = parcelRequire("NDEo7");

var $9iEAl = parcelRequire("9iEAl");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

var $8ni7a = parcelRequire("8ni7a");
const $d69b5a3ace52d70a$var$DevAzRouters = ()=>{
    const [serviceActive, config, stats] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.AZ_ROUTER_CONFIG,
            variables.AZ_ROUTER_STATS
        ]);
    const dispatch = (0, $2lSXC.useDispatch)();
    const [newName, setNewName] = (0, $acw62.useState)('');
    const [newClientId, setNewClientId] = (0, $acw62.useState)('');
    const [expandedIds, setExpandedIds] = (0, $acw62.useState)({});
    const toggleExpanded = (id)=>setExpandedIds((prev)=>({
                ...prev,
                [id]: !prev[id]
            }));
    const routerIds = Object.keys(config || {}).filter((id)=>config[id] != null);
    const clientIdValid = newClientId.trim() !== '' && Number.isInteger(Number(newClientId)) && Number(newClientId) > 0;
    const handleAdd = ()=>{
        if (!newName.trim() || !clientIdValid) return;
        const id = Math.random().toString(36).substring(2, 12);
        dispatch((0, $1Jwr0.variablesChange)({
            AZ_ROUTER_CONFIG: {
                ...config,
                [id]: {
                    type: (0, $8ni7a.AzRouter).V1,
                    name: newName.trim(),
                    clientId: Number(newClientId)
                }
            }
        }));
        setNewName('');
        setNewClientId('');
    };
    const handleRemove = (id)=>{
        const remainingConfig = {
            ...config
        };
        delete remainingConfig[id];
        const remainingStats = {
            ...stats
        };
        delete remainingStats[id];
        dispatch((0, $1Jwr0.variablesChange)({
            AZ_ROUTER_CONFIG: remainingConfig,
            AZ_ROUTER_STATS: remainingStats
        }));
    };
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "azRouters.title",
            defaultMessage: "AZ routery"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    const renderStatusChip = (id)=>{
        const routerStats = stats?.[id];
        const status = routerStats?.communicationStatus;
        if (!routerStats || status === 'starting') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
            size: "small",
            color: "default",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "azRouters.status.starting",
                defaultMessage: "Spou\u0161t\xed se"
            })
        });
        if (routerStats.communicationOk || status === 'ok') return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
            size: "small",
            color: "success",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "azRouters.status.ok",
                defaultMessage: "OK"
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $JYcZH.default), {
            size: "small",
            color: "error",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "azRouters.status.error",
                defaultMessage: "Chyba"
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "azRouters.title",
            defaultMessage: "AZ routery"
        }),
        children: [
            routerIds.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                type: "row",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "azRouters.empty",
                    defaultMessage: "Nejsou nakonfigurov\xe1ny \u017E\xe1dn\xe9 AZ routery"
                }),
                value: ""
            }),
            routerIds.map((id)=>{
                const routerConfig = config[id];
                if (!routerConfig) return null;
                const routerStats = stats?.[id];
                const isExpanded = Boolean(expandedIds[id]);
                return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                            title: routerConfig.name || id,
                            fullWidth: true,
                            control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                                direction: "row",
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    renderStatusChip(id),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                        variant: "body2",
                                        sx: {
                                            color: 'text.secondary'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "azRouters.clientId.value",
                                            defaultMessage: "Modbus ID: {id}",
                                            values: {
                                                id: routerConfig.clientId
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                        variant: "body2",
                                        sx: {
                                            color: 'text.secondary'
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                            id: "azRouters.counts",
                                            defaultMessage: "OK {ok} / Chyb {err}",
                                            values: {
                                                ok: routerStats?.communicationSuccess ?? 0,
                                                err: routerStats?.communicationErrors ?? 0
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                        onClick: ()=>toggleExpanded(id),
                                        size: "small",
                                        "aria-label": "toggle details",
                                        children: isExpanded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5uhCp.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $NDEo7.default), {})
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                        color: "error",
                                        onClick: ()=>handleRemove(id),
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {})
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $91vj1.default), {
                            in: isExpanded,
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                                component: "pre",
                                sx: {
                                    m: 0,
                                    p: 2,
                                    fontFamily: 'monospace',
                                    fontSize: 12,
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word',
                                    bgcolor: 'action.hover',
                                    borderRadius: 1,
                                    overflow: 'auto',
                                    maxHeight: 400
                                },
                                children: JSON.stringify(routerStats ?? {}, null, 2)
                            })
                        })
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "azRouters.add",
                    defaultMessage: "P\u0159idat nov\xfd AZ router"
                }),
                fullWidth: true,
                control: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    direction: "row",
                    spacing: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "azRouters.name",
                                defaultMessage: "N\xe1zev"
                            }),
                            size: "small",
                            value: newName,
                            onChange: (e)=>setNewName(e.target.value),
                            onKeyPress: (e)=>{
                                if (e.key === 'Enter') handleAdd();
                            },
                            sx: {
                                width: 220
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "azRouters.clientId",
                                defaultMessage: "Modbus ID"
                            }),
                            size: "small",
                            type: "number",
                            value: newClientId,
                            onChange: (e)=>setNewClientId(e.target.value),
                            onKeyPress: (e)=>{
                                if (e.key === 'Enter') handleAdd();
                            },
                            sx: {
                                width: 120
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                            variant: "contained",
                            startIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ko6Bk.default), {}),
                            onClick: handleAdd,
                            disabled: !newName.trim() || !clientIdValid,
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "azRouters.addButton",
                                defaultMessage: "P\u0159idat"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $d69b5a3ace52d70a$export$2e2bcd8739ae039 = $d69b5a3ace52d70a$var$DevAzRouters;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $gJm6V = parcelRequire("gJm6V");
var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $1Ikg4 = parcelRequire("1Ikg4");

var $lwQO9 = parcelRequire("lwQO9");

var $2nO41 = parcelRequire("2nO41");

var $bwxl4 = parcelRequire("bwxl4");

var $hAwwT = parcelRequire("hAwwT");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $ab586b5c8bd0ab7a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $bwxl4.getListItemIconUtilityClass), classes);
};
const $ab586b5c8bd0ab7a$var$ListItemIconRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $lwQO9.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $ab586b5c8bd0ab7a$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $hAwwT.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $ab586b5c8bd0ab7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ab586b5c8bd0ab7a$var$ListItemIconRoot, {
        className: (0, $9QePP.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ab586b5c8bd0ab7a$export$2e2bcd8739ae039 = $ab586b5c8bd0ab7a$var$ListItemIcon;


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");

var $8Indx = parcelRequire("8Indx");

var $7X4mk = parcelRequire("7X4mk");
var $9uy85 = parcelRequire("9uy85");

var $hAwwT = parcelRequire("hAwwT");

var $1Ikg4 = parcelRequire("1Ikg4");

var $2nO41 = parcelRequire("2nO41");

var $cmqCd = parcelRequire("cmqCd");

var $3fDLr = parcelRequire("3fDLr");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $a7cd8ac1360c47a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $8Indx.default)(slots, (0, $cmqCd.getListItemTextUtilityClass), classes);
};
const $a7cd8ac1360c47a2$var$ListItemTextRoot = (0, $1Ikg4.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cmqCd.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $cmqCd.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $9uy85.default).root}:where(& .${(0, $cmqCd.default).primary})`]: {
        display: 'block'
    },
    [`.${(0, $9uy85.default).root}:where(& .${(0, $cmqCd.default).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $a7cd8ac1360c47a2$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $acw62.useContext((0, $hAwwT.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $a7cd8ac1360c47a2$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $3fDLr.default)('root', {
        className: (0, $9QePP.default)(classes.root, className),
        elementType: $a7cd8ac1360c47a2$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $3fDLr.default)('primary', {
        className: classes.primary,
        elementType: (0, $7X4mk.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $3fDLr.default)('secondary', {
        className: classes.secondary,
        elementType: (0, $7X4mk.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $7X4mk.default) && !disableTypography) primary = /*#__PURE__*/ (0, $ayMG0.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $7X4mk.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $ayMG0.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $a7cd8ac1360c47a2$export$2e2bcd8739ae039 = $a7cd8ac1360c47a2$var$ListItemText;


var $5WsCn = parcelRequire("5WsCn");
var $aGlmr = parcelRequire("aGlmr");
var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1c8e932fc1c1c13f$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96"
}), 'Cloud');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $fae69c25cafe4d8a$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6z"
}), 'Code');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $33c0d249b0710b0c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M8.4 18.2c.38.5.6 1.12.6 1.8 0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3c.44 0 .85.09 1.23.26l1.41-1.77c-.92-1.03-1.29-2.39-1.09-3.69l-2.03-.68c-.54.83-1.46 1.38-2.52 1.38-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3c0 .07 0 .14-.01.21l2.03.68c.64-1.21 1.82-2.09 3.22-2.32V5.91C9.96 5.57 9 4.4 9 3c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.4-.96 2.57-2.25 2.91v2.16c1.4.23 2.58 1.11 3.22 2.32L18 9.71V9.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3c-1.06 0-1.98-.55-2.52-1.37l-2.03.68c.2 1.29-.16 2.65-1.09 3.69l1.41 1.77Q17.34 17 18 17c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3c0-.68.22-1.3.6-1.8l-1.41-1.77c-1.35.75-3.01.76-4.37 0z"
}), 'Hub');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $7e5dd760b04d484c$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9 12c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1m5 6h-4v-2c0-1.1.9-2 2-2s2 .9 2 2zm2-7c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1z"
}), 'Outlet');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $68a32cd381f863f9$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "m20.2 5.9.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7m-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2M8 18H6v-2h2zm3.5 0h-2v-2h2zm3.5 0h-2v-2h2z"
}), 'Router');


var $ayNNK = parcelRequire("ayNNK");
var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $8a45c8c0643f3e53$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M20 8H4V6h16zm-2-6H6v2h12zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2m-6 4-6-3.27v6.53z"
}), 'Subscriptions');


var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $921de51bffa84ddf$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2"
}), 'Timeline');



var $7pTac = parcelRequire("7pTac");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
const $9a2f7aafe111834f$var$items = [
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68a32cd381f863f9$export$2e2bcd8739ae039), {}),
        label: 'Network',
        to: '/dev/network'
    },
    {
        divider: true
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1c8e932fc1c1c13f$export$2e2bcd8739ae039), {}),
        label: 'MQTT Cloud',
        subLabel: "Z\xe1suvky pro BD, komunity",
        to: '/dev/mqtt-cloud'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $33c0d249b0710b0c$export$2e2bcd8739ae039), {}),
        label: 'MQTT Broker',
        subLabel: "Lok\xe1ln\xed MQTT (nap\u0159. elektrom\u011Bry)",
        to: '/dev/mqtt-broker'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e5dd760b04d484c$export$2e2bcd8739ae039), {}),
        label: 'Shellies',
        subLabel: "Lok\xe1ln\xed Shelly (nap\u0159. elektrom\u011Bry)",
        to: '/dev/shellies'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $68a32cd381f863f9$export$2e2bcd8739ae039), {}),
        label: 'AZ routery',
        to: '/dev/az-routers'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e5dd760b04d484c$export$2e2bcd8739ae039), {}),
        label: "Cloudov\xe9 z\xe1suvky",
        subLabel: '',
        to: '/dev/zasuvky-cloud'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayNNK.default), {}),
        label: "Konfigurace st\u0159\xedda\u010D\u016F",
        subLabel: "V\xedce st\u0159\xedda\u010D\u016F, INVERTER_CONFIG",
        to: '/dev/konfigurace-stridacu'
    },
    {
        divider: true
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fae69c25cafe4d8a$export$2e2bcd8739ae039), {}),
        label: 'Scripty',
        to: '/dev/scripts'
    },
    {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $921de51bffa84ddf$export$2e2bcd8739ae039), {}),
        label: 'Status log',
        subLabel: "Historie stav\u016F (control mode, PV status)",
        to: '/dev/status-log'
    },
    {
        divider: true
    },
    {
        label: 'Delta Green',
        to: '/dev/delta-green'
    },
    {
        label: 'Electree',
        to: '/dev/electree'
    },
    {
        label: 'Energomachine',
        to: '/dev/energomachine'
    },
    {
        label: 'bezDodavatele',
        to: '/dev/bez-dodavatele'
    },
    {
        label: 'PRE Flexibilita',
        to: '/dev/pre-flexibility'
    },
    {
        label: 'Enerco',
        subLabel: 'Predikce komunity (EAN)',
        to: '/dev/enerco'
    },
    {
        divider: true
    },
    {
        label: "P\u0159edplatn\xe9",
        to: '/dev/predplatne',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a45c8c0643f3e53$export$2e2bcd8739ae039), {})
    },
    {
        label: 'Notifikace',
        to: '/dev/zpravy'
    },
    {
        divider: true
    },
    {
        label: 'EMS',
        to: '/ems-service'
    }
];
const $9a2f7aafe111834f$var$DevHomepage = ()=>{
    const [serviceActive] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE
        ]);
    const navigate = (0, $aphAM.useNavigate)();
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    width: 600
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aGlmr.default), {
                    children: $9a2f7aafe111834f$var$items.map((item, i)=>{
                        if ('divider' in item) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gJm6V.default), {}, i);
                        const { icon: icon, label: label, subLabel: subLabel } = item;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5WsCn.default), {
                            onClick: ()=>navigate(item.to),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
                                    children: icon
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                    children: label
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body2",
                                    sx: {
                                        color: 'text.secondary'
                                    },
                                    children: subLabel
                                })
                            ]
                        }, i);
                    })
                })
            })
        })
    });
};
var $9a2f7aafe111834f$export$2e2bcd8739ae039 = $9a2f7aafe111834f$var$DevHomepage;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $gc70Y = parcelRequire("gc70Y");

var $7pTac = parcelRequire("7pTac");



parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $dKB2I = parcelRequire("dKB2I");
const $1f4c067f79c93795$var$DevBezDodavatele = ()=>{
    const [serviceActive, regionNuts, activeCommand] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.REGION_NUTS,
            variables.FLEXIBILITY_ACTIVE_COMMAND
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "bez_dodavatele.title",
                    defaultMessage: "bezDodavatele"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        switchVariableId: "BEZ_DODAVATELE_API_ENABLED",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "bez_dodavatele.enabled",
                            defaultMessage: "Integrace zapnuta"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "bez_dodavatele.region",
                            defaultMessage: "K\xf3d kraje"
                        }),
                        value: regionNuts
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "bez_dodavatele.business_flexibility.title",
                    defaultMessage: "Obchodn\xed flexibilita"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $505c4dce7abb9b45$export$354ff7f6266cc820), {
                        type: (0, $dKB2I.FlexibilityCommandType).BezDodavatele
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: JSON.stringify(activeCommand)
                    })
                ]
            })
        ]
    });
};
var $1f4c067f79c93795$export$2e2bcd8739ae039 = $1f4c067f79c93795$var$DevBezDodavatele;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $gc70Y = parcelRequire("gc70Y");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cW890");
var $dKB2I = parcelRequire("dKB2I");
const $efa05dea94851e15$var$DevPreFlexibility = ()=>{
    const [serviceActive, activeCommand] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.FLEXIBILITY_ACTIVE_COMMAND
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "pre_flexibility.title",
                    defaultMessage: "PRE Flexibilita"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                    switchVariableId: "PRE_FLEXIBILITY_API_ENABLED",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "pre_flexibility.enabled",
                        defaultMessage: "Integrace zapnuta"
                    }),
                    fullWidth: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "pre_flexibility.business_flexibility.title",
                    defaultMessage: "Obchodn\xed flexibilita"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $505c4dce7abb9b45$export$354ff7f6266cc820), {
                        type: (0, $dKB2I.FlexibilityCommandType).PreFlexibility
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                        children: JSON.stringify(activeCommand)
                    })
                ]
            })
        ]
    });
};
var $efa05dea94851e15$export$2e2bcd8739ae039 = $efa05dea94851e15$var$DevPreFlexibility;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $klPA2 = parcelRequire("klPA2");
var $gc70Y = parcelRequire("gc70Y");
var $7X4mk = parcelRequire("7X4mk");


var $gpaJb = parcelRequire("gpaJb");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");
const $7900a0be9d6e654a$var$DevEnerco = ()=>{
    const [serviceActive, enabled, sharingGroupName, predictionDate, consumption, production, lastFetch] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.ENERCO_INTEGRATION_ENABLED,
            variables.ENERCO_SHARING_GROUP_NAME,
            variables.ENERCO_PREDICTION_DATE,
            variables.ENERCO_CONSUMPTION_PREDICTION,
            variables.ENERCO_PRODUCTION_PREDICTION,
            variables.ENERCO_PREDICTION_LAST_FETCH
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "enerco.title",
                    defaultMessage: "Enerco"
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        switchVariableId: "ENERCO_INTEGRATION_ENABLED",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "enerco.enabled",
                            defaultMessage: "Integrace zapnuta"
                        }),
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gpaJb.InputBox), {
                        inputVariableId: "ENERCO_EAN",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "enerco.ean",
                            defaultMessage: "EAN"
                        }),
                        placeholder: "859182400000000000"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
                layout: "list",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "enerco.prediction.title",
                    defaultMessage: "Predikce"
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gc70Y.default), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            p: 2
                        },
                        children: !enabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "body2",
                            sx: {
                                color: 'text.secondary'
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "enerco.prediction.disabled",
                                defaultMessage: "Integrace je vypnut\xe1."
                            })
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                                    variant: "body2",
                                    children: [
                                        "Sd\xedlec\xed skupina: ",
                                        sharingGroupName || "\u2014"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                                    variant: "body2",
                                    children: [
                                        "Datum: ",
                                        predictionDate || "\u2014"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                                    variant: "body2",
                                    children: [
                                        "Posledn\xed aktualizace:",
                                        ' ',
                                        lastFetch ? new Date(lastFetch).toLocaleString() : "\u2014"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body2",
                                    sx: {
                                        mt: 1
                                    },
                                    children: "Spot\u0159eba (komunita):"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "caption",
                                    sx: {
                                        wordBreak: 'break-all'
                                    },
                                    children: JSON.stringify(consumption)
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body2",
                                    sx: {
                                        mt: 1
                                    },
                                    children: "V\xfdroba (EAN):"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "caption",
                                    sx: {
                                        wordBreak: 'break-all'
                                    },
                                    children: JSON.stringify(production)
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var $7900a0be9d6e654a$export$2e2bcd8739ae039 = $7900a0be9d6e654a$var$DevEnerco;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $7pTac = parcelRequire("7pTac");

var $ko6Bk = parcelRequire("ko6Bk");
var $eJaQo = parcelRequire("eJaQo");
var $8YLZH = parcelRequire("8YLZH");
var $hAiFn = parcelRequire("hAiFn");

parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");

var $5R532 = parcelRequire("5R532");

var $5tslE = parcelRequire("5tslE");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $u24M4 = parcelRequire("u24M4");
var $5WsCn = parcelRequire("5WsCn");
var $1GEFm = parcelRequire("1GEFm");
var $kZugz = parcelRequire("kZugz");
var $12gtR = parcelRequire("12gtR");

var $jDfxe = parcelRequire("jDfxe");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");
parcelRequire("cW890");
var $8ni7a = parcelRequire("8ni7a");

const $ffa0910f7303c25c$var$DevCloudPlugs = ()=>{
    const [serviceActive, connected] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE,
            variables.MQTT_CLOUD_CONNECTED
        ]);
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev.cloud_plugs.title",
            defaultMessage: "Cloudov\xe9 z\xe1suvky"
        }),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                type: "row",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "dev.cloud_plugs.mqtt_cloud.connected",
                    defaultMessage: "Stav MQTT Cloud p\u0159ipojen\xed"
                }),
                value: connected ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "mqtt_cloud.connected.online",
                    defaultMessage: "Online"
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "mqtt_cloud.connected.offline",
                    defaultMessage: "Offline"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($ffa0910f7303c25c$var$CloudPlugsConfig, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1e206a5ddfd900ec$export$e4289ca992c1c257), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "cloud_plugs.list.title",
                    defaultMessage: "Status"
                })
            })
        ]
    });
};
var $ffa0910f7303c25c$export$2e2bcd8739ae039 = $ffa0910f7303c25c$var$DevCloudPlugs;
const $ffa0910f7303c25c$var$CloudPlugsConfig = ()=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const dispatch = (0, $2lSXC.useDispatch)();
    const [editMode, setEditMode] = (0, $acw62.useState)(false);
    const [newValue, setNewValue] = (0, $acw62.useState)([]);
    const [cloudDevices] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.MQTT_CLOUD_DEVICES
        ]);
    const changes = (0, $acw62.useMemo)(()=>!(0, $f1q41.isEqual)(newValue, cloudDevices), [
        newValue,
        cloudDevices
    ]);
    const deleteDevice = (index)=>{
        setNewValue((prev)=>prev.filter((_, i)=>i !== index));
    };
    const addDevice = ()=>{
        setNewValue((prev)=>[
                ...prev,
                {
                    id: '',
                    type: (0, $8ni7a.MqttCloudDeviceType).ShellyPlusPlugSGen3,
                    plugId: ''
                }
            ]);
    };
    const saveChanges = ()=>{
        confirm({
            title: "Opravdu chcete ulo\u017Eit zm\u011Bny?"
        }).then(()=>{
            dispatch((0, $1Jwr0.variablesChange)({
                MQTT_CLOUD_DEVICES: newValue
            }));
            setEditMode(false);
        }, ()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
            title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                gap: 0.5,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: "Konfigurace"
                    }),
                    editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                        title: "Zru\u0161it zm\u011Bny",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            onClick: ()=>{
                                setNewValue(cloudDevices);
                                setEditMode(false);
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eJaQo.default), {})
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                        title: "Upravit",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            onClick: ()=>{
                                setNewValue(cloudDevices);
                                setEditMode(true);
                            },
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {})
                        })
                    }),
                    editMode && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                        onClick: ()=>addDevice(),
                        size: "small",
                        sx: {
                            mt: 'auto'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ko6Bk.default), {})
                    }, 2)
                ]
            }),
            rows: [
                [
                    'Typ',
                    'ID',
                    ''
                ],
                ...(editMode ? newValue : cloudDevices).map(({ id: id, type: type }, index)=>{
                    return [
                        editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)($ffa0910f7303c25c$var$MqttDeviceTypeSelect, {
                            value: type,
                            onChange: (value)=>{
                                setNewValue((prev)=>{
                                    const copy = [
                                        ...prev
                                    ];
                                    copy[index] = {
                                        ...copy[index],
                                        type: value
                                    };
                                    return copy;
                                });
                            }
                        }) : type,
                        editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                            value: id,
                            size: "small",
                            onChange: (e)=>{
                                const value = e.target.value;
                                setNewValue((prev)=>{
                                    const copy = [
                                        ...prev
                                    ];
                                    copy[index] = {
                                        ...copy[index],
                                        id: value,
                                        plugId: value
                                    };
                                    return copy;
                                });
                            }
                        }) : id,
                        editMode ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            onClick: ()=>deleteDevice(index),
                            size: "small",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {})
                        }, 2) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                    ];
                })
            ],
            firstLineBold: true,
            footer: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                children: editMode && changes && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                    variant: "contained",
                    size: "small",
                    onClick: saveChanges,
                    sx: {
                        mt: 3
                    },
                    children: "Ulo\u017Eit zm\u011Bny"
                })
            }),
            sx: editMode ? {
                borderColor: 'primary.main',
                borderWidth: 2,
                borderStyle: 'solid'
            } : {}
        })
    });
};
const $ffa0910f7303c25c$var$MqttDeviceTypeSelect = ({ value: value, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1GEFm.default), {
        value: value,
        onChange: (e)=>onChange(e.target.value),
        children: Object.entries((0, $8ni7a.MqttCloudDeviceType)).map(([key, value])=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5WsCn.default), {
                value: value,
                children: key
            }, key);
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $iH29s = parcelRequire("iH29s");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");


var $9iEAl = parcelRequire("9iEAl");


const $e2c7bbd9d20cb3be$var$DevSubscriptions = ()=>{
    const [serviceActive, premium] = (0, $2lSXC.useSelector)(({ variables: { SERVICE_ACTIVE: SERVICE_ACTIVE, PREMIUM: PREMIUM } })=>[
            SERVICE_ACTIVE,
            PREMIUM
        ]);
    const { mutate: fetchSubscriptions } = (0, $iH29s.trpc).subscriptions.triggerFetch.useMutation();
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.title",
            defaultMessage: "V\xfdvojov\xe9 menu"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "subscriptions.title",
            defaultMessage: "P\u0159edplatn\xe9"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "subscriptions.last_fetch_at",
                        defaultMessage: "Posledn\xed aktualizace"
                    }),
                    fullWidth: true,
                    subtitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                        variableId: "SUBSCRIPTIONS_LAST_CHECK_AT"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "subscriptions.fetch",
                        defaultMessage: "Aktualizovat p\u0159edplatn\xe9"
                    }),
                    buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "subscriptions.fetch.button",
                        defaultMessage: "Aktualizovat p\u0159edplatn\xe9"
                    }),
                    onClick: ()=>fetchSubscriptions(),
                    fullWidth: true
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iEAl.ControlBox), {
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "subscriptions.premium_active",
                        defaultMessage: "Premium aktivn\xed"
                    }),
                    fullWidth: true,
                    subtitle: premium ? 'Ano' : 'Ne'
                })
            ]
        })
    });
};
var $e2c7bbd9d20cb3be$export$2e2bcd8739ae039 = $e2c7bbd9d20cb3be$var$DevSubscriptions;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $4WLS9 = parcelRequire("4WLS9");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $04a2e1e03e6f00fb$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');



var $7pTac = parcelRequire("7pTac");

var $iH29s = parcelRequire("iH29s");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2VxZV = parcelRequire("2VxZV");
const $8a0f7f1c5ca1e97c$export$f69c19e57285b83a = /*#__PURE__*/ (0, $acw62.forwardRef)(({ sx: sx, ...props }, ref)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2VxZV.default), {
        viewBox: "0 0 22 18",
        ...props,
        sx: {
            fill: 'none',
            ...sx || {}
        },
        ref: ref,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M1 4.42857L9.76667 10.44C10.1318 10.6906 10.561 10.8243 11 10.8243C11.439 10.8243 11.8682 10.6906 12.2333 10.44L21 4.42857M3.22222 17H18.7778C19.3671 17 19.9324 16.7592 20.3491 16.3305C20.7659 15.9019 21 15.3205 21 14.7143V3.28571C21 2.67951 20.7659 2.09812 20.3491 1.66947C19.9324 1.24082 19.3671 1 18.7778 1H3.22222C2.63285 1 2.06762 1.24082 1.65087 1.66947C1.23413 2.09812 1 2.67951 1 3.28571V14.7143C1 15.3205 1.23413 15.9019 1.65087 16.3305C2.06762 16.7592 2.63285 17 3.22222 17Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
$8a0f7f1c5ca1e97c$export$f69c19e57285b83a.displayName = 'Message';



var $9iE6L = parcelRequire("9iE6L");

var $bd9zl = parcelRequire("bd9zl");
parcelRequire("8ni7a");
var $8z3TB = parcelRequire("8z3TB");
const $2ba4ccfaf91ed5d9$export$5aa70dd80e8018a7 = {
    [(0, $8z3TB.AppMessageType).Test]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.test',
            defaultMessage: "Testovac\xed notifikace"
        })
    },
    [(0, $8z3TB.AppMessageType).SpotNegativePriceStart]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_negative_price_start',
            defaultMessage: "Cena spotu je z\xe1porn\xe1"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.spot_negative_price_start',
            defaultMessage: "Aktu\xe1ln\xed cena na spotu je po ode\u010Dten\xed provize z\xe1porn\xe1. Provize nastaven\xe1 v Infigy je ve v\xfd\u0161i {spotOffsetPrice, number, ::.##} K\u010D. Aktu\xe1ln\xed cena spotu je {spotNegativePrice, number, ::.##} K\u010D."
        })
    },
    [(0, $8z3TB.AppMessageType).SpotNegativePriceStop]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_negative_price_stop',
            defaultMessage: "Cena spotu ji\u017E nen\xed z\xe1porn\xe1"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.spot_negative_price_stop',
            defaultMessage: "Aktu\xe1ln\xed cena na spotu ji\u017E nen\xed z\xe1porn\xe1 a je ve v\xfd\u0161i {spotNegativePrice, number, ::.##} K\u010D. Provize je v Infigy nastaven\xe1 ve v\xfd\u0161i {spotOffsetPrice, number, ::.##} K\u010D"
        })
    },
    [(0, $8z3TB.AppMessageType).UtilityLossStart]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.utility_loss_start',
            defaultMessage: "Zaznamenali jsme v\xfdpadek distribu\u010Dn\xed s\xedt\u011B"
        })
    },
    [(0, $8z3TB.AppMessageType).UtilityLossStop]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.utility_loss_stop',
            defaultMessage: "V\xfdpadek distribu\u010Dn\xed s\xedt\u011B byl odstran\u011Bn"
        })
    },
    [(0, $8z3TB.AppMessageType).InverterProductionMWH]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.inverter_production_mwh',
            defaultMessage: "Miln\xedk ve v\xfdrob\u011B FVE"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.inverter_production_mwh',
            defaultMessage: "Letos v\xe1m va\u0161e fotovoltaick\xe1 elektr\xe1rna ji\u017E vyrobila {inverterProductionValue, number, ::.##} MWh."
        })
    },
    [(0, $8z3TB.AppMessageType).InverterDisconnected]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.inverter_disconnected',
            defaultMessage: "Ztr\xe1ta komunikace se st\u0159\xedda\u010Dem"
        })
    },
    [(0, $8z3TB.AppMessageType).InverterConnected]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.inverter_connected',
            defaultMessage: "Nav\xe1z\xe1n\xed komunikace se st\u0159\xedda\u010Dem"
        })
    },
    [(0, $8z3TB.AppMessageType).HeatWaterMaxTemperature]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.heat_water_max_temperature',
            defaultMessage: "Dosa\u017Eena po\u017Eadovan\xe1 maxim\xe1ln\xed teplota vody"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.heat_water_max_temperature',
            defaultMessage: "Dnes ji\u017E do\u0161lo k nah\u0159\xe1t\xed bojleru na po\u017Eadovanou maxim\xe1ln\xed teplotu {maxTemperature, number, ::.##}\xb0C."
        })
    },
    [(0, $8z3TB.AppMessageType).WallboxStartCharging]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.wallbox_start_charging',
            defaultMessage: "Za\u010Dalo nab\xedjen\xed elektromobilu"
        })
    },
    [(0, $8z3TB.AppMessageType).WallboxStopCharging]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.wallbox_stop_charging',
            defaultMessage: "Nab\xedjen\xed elektromobilu bylo ukon\u010Deno"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.wallbox_stop_charging',
            defaultMessage: "V tomto cyklu bylo dod\xe1no {wallboxConsumptionCycleValue, number, ::.##} kWh energie."
        })
    },
    [(0, $8z3TB.AppMessageType).WallboxLimitExceeded]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.wallbox_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit nab\xedjen\xed elektromobilu"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.wallbox_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit nab\xedjen\xed elektromobilu. Limit je {value, number, ::.##} kWh."
        })
    },
    [(0, $8z3TB.AppMessageType).HeatWaterLimitExceeded]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.heat_water_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit oh\u0159evu vody"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.heat_water_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit oh\u0159evu vody. Limit je {value, number, ::.##} kWh."
        })
    },
    [(0, $8z3TB.AppMessageType).HeatPumpLimitExceeded]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.heat_pump_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.heat_pump_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby tepeln\xe9ho \u010Derpadla. Limit je {value, number, ::.##} kWh."
        })
    },
    [(0, $8z3TB.AppMessageType).HomeLimitExceeded]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.home_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby dom\xe1cnosti"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.home_limit_exceeded',
            defaultMessage: "Byl p\u0159ekro\u010Den dne\u0161n\xed limit spot\u0159eby dom\xe1cnosti. Limit je {value, number, ::.##} kWh."
        })
    },
    [(0, $8z3TB.AppMessageType).SpotStartDischargingBattery]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_start_discharging_battery',
            defaultMessage: "Za\u010Dalo vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny"
        })
    },
    [(0, $8z3TB.AppMessageType).SpotStopDischargingBattery]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_stop_discharging_battery',
            defaultMessage: "Vyb\xedjen\xed baterie do s\xedt\u011B dle spotov\xe9 ceny bylo ukon\u010Deno"
        })
    },
    [(0, $8z3TB.AppMessageType).SpotStartChargingBattery]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_start_charging_battery',
            defaultMessage: "Za\u010Dalo nab\xedjen\xed baterie dle spotov\xe9 ceny"
        })
    },
    [(0, $8z3TB.AppMessageType).SpotStopChargingBattery]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_stop_charging_battery',
            defaultMessage: "Nab\xedjen\xed baterie dle spotov\xe9 ceny bylo ukon\u010Deno"
        })
    },
    [(0, $8z3TB.AppMessageType).SpotDailySummary]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_daily_summary',
            defaultMessage: "Denn\xed souhrn pl\xe1nu spotu"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.spot_daily_summary',
            defaultMessage: `Dnes na spotu:
        {nothingToReport, select,
          true {Nen\xed nic v pl\xe1nu.}
          other {
            {energyForSale, select,
              true {V pl\xe1nu je rann\xed prodej do s\xedt\u{11B}. }
              other {}
            }
            {negativeIntervals, select,
              false {}
              other {Z\xe1porn\xe1 cena ({negativeIntervals}), p\u{159}i kter\xe9 se omez\xed p\u{159}etok. }
            }
            {chargingIntervals, select,
              false {}
              other {Pl\xe1n nab\xedjen\xed baterie ({chargingIntervals}). }
            }
            {dischargingIntervals, select,
              false {}
              other {Pl\xe1n vyb\xedjen\xed baterie do s\xedt\u{11B} ({dischargingIntervals}). }
            }
          }
        }`
        })
    },
    [(0, $8z3TB.AppMessageType).SpotDailyPrediction]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.spot_daily_prediction',
            defaultMessage: "Denn\xed p\u0159edpov\u011B\u010F"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.spot_daily_prediction',
            defaultMessage: `Denn\xed p\u{159}edpov\u{11B}\u{10F}:
        {pvPrediction, select,
          true {V\xfdroba elektr\xe1rny: {pvPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {homePrediction, select,
          true {B\u{11B}\u{17E}n\xe1 spot\u{159}eba domu: {homePredictionValue, number, ::.##} kWh. }
          other {}
        }
        {batteryPrediction, select,
          true {Dispozi\u{10D}n\xed akumulace baterie: {batteryPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {hwPrediction, select,
          true {Dispozi\u{10D}n\xed akumulace bojleru: {hwPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {hpPrediction, select,
          true {Tepeln\xe9 \u{10D}erpadlo je {hpPredictionValue, number, ::.##} kWh. }
          other {}
        }
        {salePrediction, select,
          true {Zb\xfdvaj\xedc\xed energie pro prodej p\u{159}ebytk\u{16F} je {salePredictionValue, number, ::.##} kWh. }
          other {}
        }
      `
        })
    },
    [(0, $8z3TB.AppMessageType).BatteryMaxSOC]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.battery_max_soc',
            defaultMessage: "Nabit\xed baterie na nastaven\xe9 maxim\xe1ln\xed SOC {maxSoc, number, ::.##}%"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.battery_max_soc',
            defaultMessage: "Aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie je {currentSoc, number, ::.##}%."
        })
    },
    [(0, $8z3TB.AppMessageType).BatteryMinSOC]: {
        title: (0, $bd9zl.defineMessage)({
            id: 'app_messages.battery_min_soc',
            defaultMessage: "Vybit\xed baterie na nastaven\xe9 minim\xe1ln\xed SOC {minSoc, number, ::.##}%"
        }),
        body: (0, $bd9zl.defineMessage)({
            id: 'app_messages.body.battery_min_soc',
            defaultMessage: "Aktu\xe1ln\xed \xfarove\u0148 nabit\xed baterie je {currentSoc, number, ::.##}%."
        })
    }
};



var $f1q41 = parcelRequire("f1q41");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");

var $exNvH = parcelRequire("exNvH");

var $dHW62 = parcelRequire("dHW62");

var $jDfxe = parcelRequire("jDfxe");
const $db25423c2a5379bb$var$AppMessages = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const { isLoading: isLoading, data: data, hasNextPage: hasNextPage, fetchNextPage: fetchNextPage } = (0, $iH29s.trpc).listAppMessages.useInfiniteQuery({
        limit: 10
    }, {
        refetchInterval: 10000,
        getNextPageParam: (lastPage)=>lastPage.next
    });
    const list = (0, $f1q41.flatten)((0, $f1q41.flatten)(data?.pages || []).map(({ data: data })=>data));
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
        layout: "list",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                height: 72
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                height: 72
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4WLS9.default), {
                height: 72
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hDcyd.Group), {
        layout: "list",
        children: [
            list.map((message)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)($db25423c2a5379bb$var$MessageItem, {
                    message: message
                }, message.id);
            }),
            !list.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    py: 3
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    variant: "h5",
                    sx: {
                        textAlign: 'center'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "app_messages.no_messages",
                        defaultMessage: "Zat\xedm zde nejsou \u017E\xe1dn\xe9 notifikace"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $klPA2.default), {
                sx: {
                    pt: 1,
                    pb: 2,
                    display: 'grid',
                    gridTemplateColumns: '1fr auto 1fr'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                        onClick: ()=>fetchNextPage(),
                        disabled: !hasNextPage || isLoading,
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "app_messages.load_more",
                            defaultMessage: "Na\u010D\xedst v\xedce"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'flex-end'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                            onClick: ()=>navigate(`${(0, $dHW62.links).settings}`, {
                                    state: {
                                        scroll: 'app-messages-settings'
                                    }
                                }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04a2e1e03e6f00fb$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            })
        ]
    });
};
const $db25423c2a5379bb$var$MessageItem = ({ message: message })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const mapping = (0, $2ba4ccfaf91ed5d9$export$5aa70dd80e8018a7)[message.type];
    if (!mapping) return null;
    const { title: title, body: body } = mapping;
    const unread = false;
    const titleComponent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        ...title,
        values: message.payload
    });
    const atComponent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
        value: message.createdAt
    });
    const bodyComponent = body ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        ...body,
        values: message.payload
    }) : null;
    const onOpen = ()=>{
        confirm({
            title: titleComponent,
            titleProps: {
                variant: 'h3'
            },
            content: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            color: 'text.disabled'
                        },
                        children: atComponent
                    }),
                    bodyComponent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            mt: 2
                        },
                        children: bodyComponent
                    })
                ]
            }),
            dialogProps: {
                slotProps: {
                    paper: {
                        sx: {
                            bgcolor: 'secondary.main'
                        }
                    }
                }
            },
            hideCancelButton: true,
            confirmationButtonProps: {
                fullWidth: true,
                variant: 'contained'
            },
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "app_messages.detail_dialog.close",
                defaultMessage: "P\u0159e\u010Dteno"
            }),
            dialogActionsProps: {
                sx: {
                    px: 3,
                    pb: 3
                }
            }
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
        sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch'
        },
        onClick: onOpen,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    pr: 1.5
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f18835d59a9187d7$export$2e2bcd8739ae039), {
                    color: unread ? 'primary' : undefined,
                    variant: "dot",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a0f7f1c5ca1e97c$export$f69c19e57285b83a), {
                        sx: {
                            color: 'text.disabled',
                            fontSize: {
                                xs: '1.25rem',
                                sm: '1.5rem'
                            }
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                gap: 0.5,
                sx: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            color: 'text.disabled'
                        },
                        children: atComponent
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        variant: "body2",
                        children: titleComponent
                    }),
                    bodyComponent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                        sx: {
                            color: 'text.disabled'
                        },
                        children: bodyComponent
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                sx: {
                    textAlign: 'right'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $exNvH.ChevronRight), {
                        sx: {
                            color: 'primary.main',
                            fontSize: '0.75rem'
                        }
                    })
                })
            })
        ]
    }, message.id);
};
var $db25423c2a5379bb$export$2e2bcd8739ae039 = $db25423c2a5379bb$var$AppMessages;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $kwTO3 = parcelRequire("kwTO3");

var $2lSXC = parcelRequire("2lSXC");

var $iH29s = parcelRequire("iH29s");

var $dHW62 = parcelRequire("dHW62");
const $021ceee005f3b72d$var$DevAppMessages = ()=>{
    const navigate = (0, $aphAM.useNavigate)();
    const [serviceActive] = (0, $2lSXC.useSelector)(({ variables: variables })=>[
            variables.SERVICE_ACTIVE
        ]);
    const { mutate: mutate } = (0, $iH29s.trpc).testAppMessage.useMutation({
        onSuccess: ()=>{
            navigate((0, $dHW62.links).appMessages);
        }
    });
    if (!serviceActive) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.app_messages.title",
            defaultMessage: "Notifikace"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kwTO3.ServiceAccessInput), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "dev_homepage.app_messages.title",
            defaultMessage: "Notifikace"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f71ef2d47abf280a$export$5e37f977ae0514c2), {
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "dev_app_messages.test_send",
                    defaultMessage: "Testovac\xed notifikace"
                }),
                buttonLabel: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "dev_app_messages.test_send.button",
                    defaultMessage: "Odeslat"
                }),
                onClick: ()=>mutate(),
                fullWidth: true
            })
        })
    });
};
var $021ceee005f3b72d$export$2e2bcd8739ae039 = $021ceee005f3b72d$var$DevAppMessages;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f4Eh3 = parcelRequire("f4Eh3");

var $u24M4 = parcelRequire("u24M4");
var $gc70Y = parcelRequire("gc70Y");
var $ngrp2 = parcelRequire("ngrp2");
var $12gtR = parcelRequire("12gtR");
var $7X4mk = parcelRequire("7X4mk");

var $42zF9 = parcelRequire("42zF9");

var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $bae8d0b4be16a32a$export$2e2bcd8739ae039 = (0, $42zF9.default)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');




var $5tslE = parcelRequire("5tslE");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");

var $9iE6L = parcelRequire("9iE6L");



var $iH29s = parcelRequire("iH29s");

var $5R532 = parcelRequire("5R532");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $202BL = parcelRequire("202BL");

var $03kOd = parcelRequire("03kOd");
var $4mI0b = parcelRequire("4mI0b");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $ngrp2 = parcelRequire("ngrp2");
var $kZugz = parcelRequire("kZugz");
var $7X4mk = parcelRequire("7X4mk");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

const $42d48f2d6f948355$export$a407fca6bef2ef7b = ({ sx: sx = {} })=>{
    const intl = (0, $202BL.default)();
    const dispatch = (0, $2lSXC.useDispatch)();
    const rfidCards = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_CARDS);
    const rfidLastCard = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_LAST_CARD);
    const rfidLastCardAt = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_LAST_CARD_AT);
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const [scannedId, setScannedId] = (0, $acw62.useState)(null);
    const [cardName, setCardName] = (0, $acw62.useState)('');
    // Snapshot of RFID_LAST_CARD_AT at the moment the dialog was opened
    const lastCardAtOnOpen = (0, $acw62.useRef)(undefined);
    const handleOpenDialog = ()=>{
        lastCardAtOnOpen.current = rfidLastCardAt;
        setScannedId(null);
        setCardName('');
        setDialogOpen(true);
    };
    const handleCloseDialog = ()=>{
        setDialogOpen(false);
        setScannedId(null);
        setCardName('');
    };
    // Watch for a new card scan while the dialog is open
    (0, $acw62.useEffect)(()=>{
        if (!dialogOpen) return;
        if (!rfidLastCardAt) return;
        if (rfidLastCardAt === lastCardAtOnOpen.current) return;
        setScannedId(rfidLastCard ?? null);
    }, [
        dialogOpen,
        rfidLastCard,
        rfidLastCardAt
    ]);
    const handleSave = ()=>{
        if (!scannedId) return;
        dispatch((0, $1Jwr0.variablesChange)({
            RFID_CARDS: {
                ...rfidCards,
                [scannedId]: {
                    name: cardName.trim(),
                    createdAt: new Date().toISOString()
                }
            }
        }));
        handleCloseDialog();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                variant: "contained",
                onClick: handleOpenDialog,
                sx: sx,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                    id: "wallbox_rfid.add_button",
                    defaultMessage: "P\u0159idat RFID kartu"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
                open: dialogOpen,
                onClose: handleCloseDialog,
                fullWidth: true,
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox_rfid.dialog.title",
                            defaultMessage: "P\u0159idat RFID kartu"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                        onClose: handleCloseDialog
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                        children: scannedId === null ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                            alignItems: "center",
                            gap: 2,
                            py: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_rfid.dialog.waiting",
                                        defaultMessage: "P\u0159ilo\u017Ete kartu ke \u010Dte\u010Dce\u2026"
                                    })
                                })
                            ]
                        }) : rfidCards?.[scannedId] ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                            alignItems: "center",
                            gap: 2,
                            py: 2,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    color: "warning.main",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_rfid.dialog.already_exists",
                                        defaultMessage: "Karta {id} je ji\u017E ulo\u017Eena pod n\xe1zvem {name}.",
                                        values: {
                                            id: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: scannedId
                                            }),
                                            name: rfidCards[scannedId].name
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_rfid.dialog.already_exists_hint",
                                        defaultMessage: "P\u0159ilo\u017Ete jinou kartu nebo zav\u0159ete dialog."
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                            gap: 2,
                            pt: 1,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                                    variant: "body2",
                                    color: "text.secondary",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                        id: "wallbox_rfid.dialog.scanned_id",
                                        defaultMessage: "ID karty: {id}",
                                        values: {
                                            id: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                children: scannedId
                                            })
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                                    label: intl.formatMessage({
                                        id: 'wallbox_rfid.dialog.name_label',
                                        defaultMessage: "N\xe1zev karty"
                                    }),
                                    value: cardName,
                                    onChange: (e)=>setCardName(e.target.value),
                                    autoFocus: true,
                                    fullWidth: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: handleCloseDialog,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox_rfid.dialog.cancel",
                                    defaultMessage: "Zru\u0161it"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                variant: "contained",
                                disabled: scannedId === null || !!rfidCards?.[scannedId] || cardName.trim() === '',
                                onClick: handleSave,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox_rfid.dialog.save",
                                    defaultMessage: "Ulo\u017Eit"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $u24M4 = parcelRequire("u24M4");

var $8YLZH = parcelRequire("8YLZH");

var $jDfxe = parcelRequire("jDfxe");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

const $1b74dbb000541d17$export$452dd2633b0f36a2 = ({ id: id, name: name })=>{
    const confirm = (0, $jDfxe.useConfirm)();
    const dispatch = (0, $2lSXC.useDispatch)();
    const rfidCards = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_CARDS);
    const handleDelete = ()=>{
        confirm({
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox_rfid.delete.confirm.title",
                defaultMessage: "Smazat kartu {name}?",
                values: {
                    name: name
                }
            }),
            titleProps: {
                variant: 'h3',
                textAlign: 'center',
                lineHeight: 2
            },
            confirmationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox_rfid.delete.confirm",
                defaultMessage: "Smazat"
            }),
            cancellationText: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox_rfid.delete.cancel",
                defaultMessage: "Zru\u0161it"
            }),
            ...(0, $bf83a6995bdb44c9$export$1cd011aac104c991)
        }).then(()=>{
            const { [id]: _, ...rest } = rfidCards ?? {};
            dispatch((0, $1Jwr0.variablesChange)({
                RFID_CARDS: rest
            }));
        }).catch(()=>{
        // noop
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
        size: "small",
        onClick: handleDelete,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8YLZH.default), {
            fontSize: "small"
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");
var $202BL = parcelRequire("202BL");

var $03kOd = parcelRequire("03kOd");
var $4LdGL = parcelRequire("4LdGL");
var $hHAIz = parcelRequire("hHAIz");
var $23H42 = parcelRequire("23H42");
var $6hSWk = parcelRequire("6hSWk");
var $u24M4 = parcelRequire("u24M4");
var $kZugz = parcelRequire("kZugz");

var $hAiFn = parcelRequire("hAiFn");

var $2lSXC = parcelRequire("2lSXC");
parcelRequire("cdz9f");
var $1Jwr0 = parcelRequire("1Jwr0");

const $7e56a53de8e01ab1$export$2f65dd0d88e11d3 = ({ id: id, name: name })=>{
    const intl = (0, $202BL.default)();
    const dispatch = (0, $2lSXC.useDispatch)();
    const rfidCards = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_CARDS);
    const [dialogOpen, setDialogOpen] = (0, $acw62.useState)(false);
    const [cardName, setCardName] = (0, $acw62.useState)('');
    const handleOpen = ()=>{
        setCardName(name);
        setDialogOpen(true);
    };
    const handleClose = ()=>{
        setDialogOpen(false);
    };
    const handleSave = ()=>{
        const existing = rfidCards?.[id];
        if (!existing) return;
        dispatch((0, $1Jwr0.variablesChange)({
            RFID_CARDS: {
                ...rfidCards,
                [id]: {
                    ...existing,
                    name: cardName.trim()
                }
            }
        }));
        handleClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                size: "small",
                onClick: handleOpen,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hAiFn.default), {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4LdGL.default), {
                open: dialogOpen,
                onClose: handleClose,
                fullWidth: true,
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6hSWk.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox_rfid.edit.dialog.title",
                            defaultMessage: "Upravit RFID kartu"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c106e9fba1393da0$export$fba2fb7cd781b7ac), {
                        onClose: handleClose
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $23H42.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kZugz.default), {
                            label: intl.formatMessage({
                                id: 'wallbox_rfid.dialog.name_label',
                                defaultMessage: "N\xe1zev karty"
                            }),
                            value: cardName,
                            onChange: (e)=>setCardName(e.target.value),
                            autoFocus: true,
                            fullWidth: true,
                            sx: {
                                mt: 1
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $hHAIz.default), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox_rfid.dialog.cancel",
                                    defaultMessage: "Zru\u0161it"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                variant: "contained",
                                disabled: cardName.trim() === '',
                                onClick: handleSave,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox_rfid.dialog.save",
                                    defaultMessage: "Ulo\u017Eit"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $c2be55d2c1667962$var$defaultFrom = (0, $f4Eh3.add)(new Date(), {
    months: -1
});
const $c2be55d2c1667962$var$defaultTo = new Date();
const $c2be55d2c1667962$export$26e08ac7141009d8 = ()=>{
    const rfidCards = (0, $2lSXC.useSelector)((state)=>state.variables.RFID_CARDS);
    const formatNumber = (0, $0bb96e10f84c2def$export$5bd252c535c873db)();
    const [from, setFrom] = (0, $acw62.useState)($c2be55d2c1667962$var$defaultFrom);
    const [to, setTo] = (0, $acw62.useState)($c2be55d2c1667962$var$defaultTo);
    const { data: consumptionByCard, isLoading: isLoading } = (0, $iH29s.trpc).wallbox.consumptionByCard.useQuery({
        from: (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(from ?? $c2be55d2c1667962$var$defaultFrom),
        to: (0, $b688cddfaeda0d8b$export$1b417f4da593d319)(to ?? $c2be55d2c1667962$var$defaultTo)
    }, {
        enabled: Boolean(from && to),
        networkMode: 'always'
    });
    const entries = Object.entries(rfidCards ?? {});
    const formatKwh = (value)=>formatNumber(value, {
            style: 'unit',
            unit: 'kilowatt-hour',
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        });
    const handleExport = ()=>{
        const escape = (value)=>`"${value.replace(/"/g, '""')}"`;
        const csv = [
            [
                'ID',
                'Name',
                'Consumption (kWh)'
            ],
            ...entries.map(([id, { name: name }])=>[
                    id,
                    name,
                    String(consumptionByCard?.[id] ?? 0)
                ])
        ].map((row)=>row.map(escape).join(',')).join('\n');
        const blob = new Blob([
            csv
        ], {
            type: 'text/csv;charset=utf-8;'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `rfid-consumption_${(from ?? $c2be55d2c1667962$var$defaultFrom).toISOString().slice(0, 10)}_${(to ?? $c2be55d2c1667962$var$defaultTo).toISOString().slice(0, 10)}.csv`);
        link.click();
        URL.revokeObjectURL(url);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
            id: "rfid_cards.title",
            defaultMessage: "RFID karty"
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $gc70Y.default), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    direction: "row",
                    gap: 1,
                    sx: {
                        px: 2,
                        pt: 2,
                        pb: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.from",
                                defaultMessage: "Od"
                            }),
                            // eslint-disable-next-line
                            // @ts-ignore
                            value: from,
                            onChange: (value)=>setFrom(value),
                            maxDate: to ?? undefined,
                            slotProps: {
                                textField: {
                                    size: 'small'
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                            label: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.to",
                                defaultMessage: "Do"
                            }),
                            // eslint-disable-next-line
                            // @ts-ignore
                            value: to,
                            onChange: (value)=>setTo(value),
                            minDate: from ?? undefined,
                            slotProps: {
                                textField: {
                                    size: 'small'
                                }
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $12gtR.default), {
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.export",
                                defaultMessage: "Exportovat CSV"
                            }),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                style: {
                                    marginLeft: 'auto'
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $u24M4.default), {
                                    onClick: handleExport,
                                    disabled: entries.length === 0,
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {})
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5tslE.SimpleTable), {
                    firstLineBold: true,
                    rows: [
                        [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.col.id",
                                defaultMessage: "ID karty"
                            }, 0),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.col.name",
                                defaultMessage: "N\xe1zev"
                            }, 1),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.col.consumption",
                                defaultMessage: "Spot\u0159eba"
                            }, 2),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                id: "rfid_cards.col.created_at",
                                defaultMessage: "P\u0159id\xe1no"
                            }, 3),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                        ],
                        ...entries.map(([id, { name: name, createdAt: createdAt }])=>[
                                id,
                                name,
                                isLoading ? '-' : formatKwh(consumptionByCard?.[id] ?? 0),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9iE6L.FormattedDateTime), {
                                    value: createdAt
                                }, "createdAt"),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5R532.Row), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e56a53de8e01ab1$export$2f65dd0d88e11d3), {
                                            id: id,
                                            name: name
                                        }, "edit"),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b74dbb000541d17$export$452dd2633b0f36a2), {
                                            id: id,
                                            name: name
                                        }, "delete")
                                    ]
                                }, "actions")
                            ])
                    ],
                    noPaper: true
                }),
                entries.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                    sx: {
                        textAlign: 'center',
                        p: 2
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                        id: "rfid_cards.no_cards",
                        defaultMessage: "\u017D\xe1dn\xe9 karty nebyly p\u0159id\xe1ny"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42d48f2d6f948355$export$a407fca6bef2ef7b), {
                    sx: {
                        mx: 'auto'
                    }
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $7X4mk = parcelRequire("7X4mk");


parcelRequire("8cmfY");
var $hDcyd = parcelRequire("hDcyd");


var $2lSXC = parcelRequire("2lSXC");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7pTac = parcelRequire("7pTac");

var $f1q41 = parcelRequire("f1q41");

var $2lSXC = parcelRequire("2lSXC");

var $8ni7a = parcelRequire("8ni7a");
const $8ca047e008455671$var$statusMapping = {
    [(0, $8ni7a.WallboxStatus).NotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.not_connected",
        defaultMessage: "Nelze nav\xe1zat spojen\xed"
    }),
    [(0, $8ni7a.WallboxStatus).Off]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.off",
        defaultMessage: "Wallbox vypnut\xfd"
    }),
    [(0, $8ni7a.WallboxStatus).Normal]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.normal",
        defaultMessage: "B\u011B\u017En\xfd re\u017Eim"
    }),
    [(0, $8ni7a.WallboxStatus).CarNotConnected]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.car_not_connected",
        defaultMessage: "Auto nen\xed p\u0159ipojeno"
    }),
    [(0, $8ni7a.WallboxStatus).Ready]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.ready",
        defaultMessage: "P\u0159ipraveno k nab\xedjen\xed"
    }),
    [(0, $8ni7a.WallboxStatus).Charging]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.charging",
        defaultMessage: "Nab\xedjen\xed"
    }),
    [(0, $8ni7a.WallboxStatus).ChargingWithVentilation]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.charging_with_ventilation",
        defaultMessage: "Nab\xedjen\xed auta s ventil\xe1torem"
    }),
    [(0, $8ni7a.WallboxStatus).Error]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
        id: "wallbox.status.error",
        defaultMessage: "Chyba nab\xedjen\xed"
    })
};
const $8ca047e008455671$export$73175d886a64f587 = ({ wallboxKey: wallboxKey })=>{
    const status = (0, $2lSXC.useSelector)((s)=>{
        const stats = (0, $f1q41.get)(s.variables, 'WALLBOX_STATS') || {};
        const statItem = (0, $f1q41.get)(stats, wallboxKey);
        return statItem && typeof statItem === 'object' && 'status' in statItem ? statItem.status : undefined;
    });
    if (!status || !(status in $8ca047e008455671$var$statusMapping)) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: status || '-'
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: $8ca047e008455671$var$statusMapping[status]
    });
};


const $e3bdd7ff0f63424e$export$96421fed944ccb7a = ()=>{
    const wallboxConfig = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {});
    const wallboxKeys = (0, $2lSXC.useSelector)((s)=>{
        const config = (0, $f1q41.get)(s.variables, 'WALLBOX_CONFIG') || {};
        return Object.keys(config);
    });
    const wallboxIsActive = (0, $2lSXC.useSelector)((s)=>(wallboxKey)=>{
            return Boolean((0, $f1q41.get)(s.variables, `WALLBOX_CONFIG.${wallboxKey}.active`));
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hDcyd.Group), {
        layout: "list",
        children: wallboxKeys.map((wallboxKey)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $e99fd02064b63115$export$76fdec35fc38e508), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d1de006908a8306$export$777b2856a792333e), {
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.active",
                            defaultMessage: "{name}",
                            values: {
                                name: (0, $f1q41.get)(wallboxConfig, [
                                    wallboxKey,
                                    'name'
                                ]) ?? "\u2013"
                            }
                        }),
                        subtitle: wallboxIsActive(wallboxKey) ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.active.subtitle",
                            defaultMessage: "Aktivn\xed"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.inactive.subtitle",
                            defaultMessage: "Neaktivn\xed"
                        }),
                        switchVariableId: `WALLBOX_CONFIG.${wallboxKey}.active`,
                        fullWidth: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.status",
                            defaultMessage: "Re\u017Eim Wallboxu"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8ca047e008455671$export$73175d886a64f587), {
                            wallboxKey: wallboxKey
                        }),
                        visibility: {
                            variableId: `WALLBOX_CONFIG.${wallboxKey}.active`
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.common.power",
                            defaultMessage: "Aktu\xe1ln\xed spot\u0159eba"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                            variableId: `WALLBOX_STATS.${wallboxKey}.actualPower`,
                            opts: {
                                style: 'unit',
                                unit: 'kilowatt',
                                maximumFractionDigits: 1,
                                minimumFractionDigits: 1
                            }
                        }),
                        visibility: {
                            variableId: `WALLBOX_CONFIG.${wallboxKey}.active`
                        },
                        expanded: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7X4mk.default), {
                            variant: "body1",
                            sx: {
                                color: 'text.disabled',
                                mt: 1
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox.common.power_today",
                                    defaultMessage: "Dne\u0161n\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `STATS_WB_ENERGY_CONSUMPTION_TODAY_CHARGERS.${wallboxKey}`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                                    id: "wallbox.common.power_year",
                                    defaultMessage: "Ro\u010Dn\xed spot\u0159eba:"
                                }),
                                "\xa0",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f7735bd41a453015$export$b7fe9082061cdb76), {
                                    variableId: `STATS_WB_ENERGY_CONSUMPTION_YEAR_CHARGERS.${wallboxKey}`,
                                    opts: {
                                        style: 'unit',
                                        unit: 'kilowatt-hour',
                                        maximumFractionDigits: 1,
                                        minimumFractionDigits: 1
                                    }
                                })
                            ]
                        })
                    }),
                    Boolean(wallboxConfig[wallboxKey]?.rfidReaderId) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa47be3f785df5ae$export$dd3ff450a300a06e), {
                        type: "row",
                        title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                            id: "wallbox.authorization.status",
                            defaultMessage: "Autorizace"
                        }),
                        value: /*#__PURE__*/ (0, $ayMG0.jsx)($e3bdd7ff0f63424e$var$AuthorizationStatus, {
                            wallboxKey: wallboxKey
                        }),
                        visibility: {
                            variableId: `WALLBOX_CONFIG.${wallboxKey}.active`
                        }
                    })
                ]
            }, wallboxKey))
    });
};
const $e3bdd7ff0f63424e$var$AuthorizationStatus = ({ wallboxKey: wallboxKey })=>{
    const authState = (0, $2lSXC.useSelector)((s)=>(0, $f1q41.get)(s.variables, `WALLBOX_AUTHORIZATION.${wallboxKey}`));
    if (!authState) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: "-"
    });
    const { status: status, cardName: cardName, cardUid: cardUid } = authState;
    const cardInfo = cardName || cardUid || '';
    let statusMessage;
    switch(status){
        case 'pending':
            statusMessage = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox.authorization.status.pending",
                defaultMessage: "Nen\xed autorizov\xe1no"
            });
            break;
        case 'authorized':
            statusMessage = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox.authorization.status.authorized",
                defaultMessage: "Autorizov\xe1no{cardInfo}",
                values: {
                    cardInfo: cardInfo ? `, ${cardInfo}` : ''
                }
            });
            break;
        case 'denied':
            statusMessage = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox.authorization.status.denied",
                defaultMessage: "Zam\xedtnuto{cardInfo}",
                values: {
                    cardInfo: cardInfo ? `, ${cardInfo}` : ''
                }
            });
            break;
        default:
            statusMessage = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "wallbox.authorization.status.unknown",
                defaultMessage: "Nezn\xe1m\xfd stav"
            });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: statusMessage
    });
};



const $043f87f23fd0da03$var$DevNetwork = (0, $f60f9ecdaa9a9208$export$3d2a8d7c47985b16)(/*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("1Qxqo"))));

const $043f87f23fd0da03$var$DevScripts = (0, $f60f9ecdaa9a9208$export$3d2a8d7c47985b16)(/*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("48lZm"))));

const $043f87f23fd0da03$var$DevInverterConfig = (0, $f60f9ecdaa9a9208$export$3d2a8d7c47985b16)(/*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("GJmNl"))));

const $043f87f23fd0da03$var$DevStatusLog = (0, $f60f9ecdaa9a9208$export$3d2a8d7c47985b16)(/*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("iUHwh"))));

const $043f87f23fd0da03$var$AuditLog = (0, $f60f9ecdaa9a9208$export$3d2a8d7c47985b16)(/*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("l2unc"))));
const $043f87f23fd0da03$var$routes = [
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {}),
        children: [
            {
                path: '',
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a0b46b89485c073d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.photovoltaics",
                defaultMessage: "Fotovoltaika"
            }),
            icon: "solar-panel"
        }),
        children: [
            {
                path: (0, $dHW62.paths).photovoltaics,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a8a9338216d46d9$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.ems",
                defaultMessage: "EMS"
            }),
            icon: "solar-panel"
        }),
        children: [
            {
                path: (0, $dHW62.paths).ems,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a8d457b7c4fee4a3$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.boiler",
                defaultMessage: "Bojler"
            }),
            icon: "boiler"
        }),
        children: [
            {
                path: (0, $dHW62.paths).boiler,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d492b63d6b61041$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.grid",
                defaultMessage: "Distribu\u010Dn\xed s\xed\u0165"
            }),
            icon: "electrical-grid"
        }),
        children: [
            {
                path: (0, $dHW62.paths).grid,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1292f41821d95ba0$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.plug",
                defaultMessage: "Z\xe1suvka"
            }),
            icon: "electrical-grid"
        }),
        children: [
            {
                path: (0, $dHW62.paths).plug,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3628c8357915c99a$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.relay",
                defaultMessage: "Rel\xe9"
            }),
            icon: "electrical-grid"
        }),
        children: [
            {
                path: (0, $dHW62.paths).relay,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $356aebd82075892d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.energyMeters",
                defaultMessage: "Elektrom\u011Bry"
            }),
            icon: "electrical-grid"
        }),
        children: [
            {
                path: (0, $dHW62.paths).energyMeters,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $037c80b621eab427$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.spot",
                defaultMessage: "Spot"
            }),
            icon: "statistics"
        }),
        children: [
            {
                path: (0, $dHW62.paths).spot,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5a0509fee648eadf$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.statistics",
                defaultMessage: "Statistiky"
            }),
            icon: "statistics"
        }),
        children: [
            {
                path: (0, $dHW62.paths).statistics,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $66dcc2aa39db9b35$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.settings",
                defaultMessage: "Nastaven\xed"
            }),
            icon: "settings"
        }),
        children: [
            {
                path: (0, $dHW62.paths).settings,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1b8a22ea095adc0b$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.heat_pump",
                defaultMessage: "Tepeln\xe9 \u010Derpadlo"
            }),
            icon: "heat-pump"
        }),
        children: [
            {
                path: (0, $dHW62.paths).heatPump,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d03d5c33b21fffd$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.wind",
                defaultMessage: "V\u011Btrn\xe1 elektr\xe1rna"
            }),
            icon: "wind"
        }),
        children: [
            {
                path: (0, $dHW62.paths).wind,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dfbcb6923a026c91$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev_homepage",
                defaultMessage: "V\xfdvojov\xe9 menu"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devHomepage,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a2f7aafe111834f$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.cloud_plugs",
                defaultMessage: "Z\xe1suvky"
            }),
            icon: "electrical-grid"
        }),
        children: [
            {
                path: (0, $dHW62.paths).cloudPlugs,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fc5b3be5a496799d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.app_messages",
                defaultMessage: "Zpr\xe1vy"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).appMessages,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db25423c2a5379bb$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.audit_log",
                defaultMessage: "Audit Log"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).auditLog,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$AuditLog, {})
            }
        ]
    },
    // --- dev ---
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev",
                defaultMessage: "Nastaven\xed s\xedt\u011B"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).network,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$DevNetwork, {
                    variant: "dev"
                })
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.delta_green",
                defaultMessage: "Delta Green"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).deltaGreen,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5d0789d73fcb1a17$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.electree",
                defaultMessage: "Electree"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).electree,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d756029411c6ede9$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.energomachine",
                defaultMessage: "Energomachine"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).energomachine,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2989e93503d9fb01$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.mqtt_cloud",
                defaultMessage: "MQTT Cloud"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).mqttCloud,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $14d32f0fb40007ed$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.mqtt_broker",
                defaultMessage: "MQTT Broker"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).mqttBroker,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d11846483bfc7257$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.cloud_plugs",
                defaultMessage: "Cloudov\xe9 z\xe1suvky"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devCloudPlugs,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffa0910f7303c25c$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.inverter_config",
                defaultMessage: "Konfigurace st\u0159\xedda\u010D\u016F"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devInverterConfig,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$DevInverterConfig, {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.subscriptions",
                defaultMessage: "P\u0159edplatn\xe9"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devSubscriptions,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e2c7bbd9d20cb3be$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.shellies",
                defaultMessage: "Shellies"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).shellies,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b72b84016321a592$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.az_routers",
                defaultMessage: "AZ routery"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).azRouters,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d69b5a3ace52d70a$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.scripts",
                defaultMessage: "Scripty"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).scripts,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$DevScripts, {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.bez_dodavatele",
                defaultMessage: "bezDodavatele"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).bezDodavatele,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1f4c067f79c93795$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.pre_flexibility",
                defaultMessage: "PRE Flexibilita"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).preFlexibility,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efa05dea94851e15$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.enerco",
                defaultMessage: "Enerco"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).enerco,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7900a0be9d6e654a$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.app_messages",
                defaultMessage: "Notifikace"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devAppMessages,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $021ceee005f3b72d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.dev.status_log",
                defaultMessage: "Status log"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).devStatusLog,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$DevStatusLog, {})
            }
        ]
    },
    // --- other ---
    {
        path: '/product-test',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $929cce75c3654d38$export$2e2bcd8739ae039), {})
    },
    {
        path: '/protokol',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a7b8cecc9ec520f$export$2e2bcd8739ae039), {})
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.thermostat",
                defaultMessage: "Termostat"
            }),
            icon: "thermostat"
        }),
        children: [
            {
                path: (0, $dHW62.paths).thermostat,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb1ccfa0245b6b03$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.expert_service",
                defaultMessage: "Expert Service"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).expertService,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $07c08421b84dda4f$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.ems_service",
                defaultMessage: "EMS Service"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).emsService,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a492be7a61cb3b6d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.expert_service.network",
                defaultMessage: "Nastaven\xed s\xedt\u011B"
            })
        }),
        children: [
            {
                path: (0, $dHW62.paths).expertServiceNetwork,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)($043f87f23fd0da03$var$DevNetwork, {
                    variant: "expert-service"
                })
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.wallbox",
                defaultMessage: "Wallbox"
            }),
            icon: "wallbox"
        }),
        children: [
            {
                path: (0, $dHW62.paths).wallbox,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $044a381363c1342d$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.rfid_cards",
                defaultMessage: "RFID karty"
            }),
            variant: "subpage",
            goBack: -1
        }),
        children: [
            {
                path: (0, $dHW62.paths).rfidCards,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c2be55d2c1667962$export$26e08ac7141009d8), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.wallbox_list",
                defaultMessage: "Wallboxy"
            }),
            variant: "subpage",
            goBack: -1
        }),
        children: [
            {
                path: (0, $dHW62.paths).wallboxList,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3bdd7ff0f63424e$export$96421fed944ccb7a), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.reports",
                defaultMessage: "Reporty"
            }),
            icon: "reports"
        }),
        children: [
            {
                path: (0, $dHW62.paths).reports,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aa15e1223001d2e7$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {
            title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7pTac.default), {
                id: "header.title.reports",
                defaultMessage: "Reporty"
            }),
            icon: "reports"
        }),
        children: [
            {
                path: (0, $dHW62.paths).reportDetail,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8adc2fa851fc061$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d9d25b1220fd88c5$export$93af822566053b3e), {}),
        children: [
            {
                path: (0, $dHW62.paths).customPage,
                element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c33a724b40957e5$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: '/inspect',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $905c51792f4bf561$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/inverter',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d984f8ed5a827fae$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/wallbox',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $df15c1cd94646d32$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/heat-pump',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74e24002ff3c9c68$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/spot',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77cdb5e3720e2cb5$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/mqtt',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $337d3741ac3df784$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/plugs',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d708a045b589926d$export$2e2bcd8739ae039), {})
    },
    {
        path: '/inspect/plc',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b2b4a001fc3be02$export$2e2bcd8739ae039), {})
    },
    {
        path: '/*',
        element: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bc79313bef060bae$export$2e2bcd8739ae039), {})
    }
];
const $043f87f23fd0da03$export$55185c17a0fcbe46 = ()=>(0, $aphAM.useRoutes)($043f87f23fd0da03$var$routes);



var $2rLZY = parcelRequire("2rLZY");

var $2u93q = parcelRequire("2u93q");

var $iD7Z3 = parcelRequire("iD7Z3");
const $b911f7f44adb450d$var$getTheme = ()=>{
    const baseTheme = (0, $2rLZY.default)({
        colorSchemes: {
            light: {
                palette: {
                    primary: {
                        main: (0, $iD7Z3.colors).primary,
                        contrastText: (0, $iD7Z3.colors).white
                    },
                    secondary: {
                        main: (0, $iD7Z3.colors).lightBlue
                    },
                    background: {
                        default: (0, $iD7Z3.colors).white,
                        paper: (0, $iD7Z3.colors).white
                    },
                    text: {
                        primary: (0, $iD7Z3.colors).richBlack,
                        disabled: (0, $iD7Z3.colors).darkBlue
                    }
                }
            },
            dark: {
                palette: {
                    primary: {
                        main: (0, $iD7Z3.colors).primary,
                        contrastText: (0, $iD7Z3.colors).white
                    },
                    secondary: {
                        main: (0, $iD7Z3.darkColors).lightBlue
                    },
                    background: {
                        default: (0, $iD7Z3.darkColors).background,
                        paper: (0, $iD7Z3.darkColors).paper
                    },
                    text: {
                        primary: (0, $iD7Z3.darkColors).richBlack,
                        disabled: (0, $iD7Z3.darkColors).darkBlue
                    }
                }
            }
        }
    });
    const theme = (0, $2rLZY.default)({
        ...baseTheme,
        typography: (0, $2u93q.getTypography)(baseTheme),
        components: {
            /**
       * MuiButtonBase
       */ MuiButtonBase: {
                defaultProps: {
                    disableRipple: true
                }
            },
            /**
       * MuiPaper
       */ MuiPaper: {
                styleOverrides: {
                    root: {
                        padding: 16,
                        borderRadius: 8
                    },
                    elevation1: {
                        boxShadow: '0px 2px 48px rgba(0, 0, 0, 0.04)'
                    }
                }
            },
            /**
       * MuiSwitch
       */ MuiSwitch: {
                styleOverrides: {
                    root: {
                        width: 40,
                        height: 20,
                        padding: 0
                    },
                    switchBase: {
                        padding: 0,
                        margin: 2,
                        transitionDuration: '300ms',
                        '&.Mui-checked': {
                            transform: 'translateX(20px)',
                            color: '#fff',
                            '& + .MuiSwitch-track': {
                                backgroundColor: baseTheme.palette.primary.main,
                                opacity: 1,
                                border: 0
                            },
                            '&.Mui-disabled + .MuiSwitch-track': {
                                opacity: 0.5
                            }
                        },
                        '&.Mui-focusVisible .MuiSwitch-thumb': {
                            color: '#33cf4d',
                            border: '6px solid #fff'
                        },
                        '&.Mui-disabled .MuiSwitch-thumb': ({ theme: theme })=>theme.applyStyles('light', {
                                color: baseTheme.palette.grey[100]
                            }) || {
                                color: baseTheme.palette.grey[600]
                            },
                        '&.Mui-disabled + .MuiSwitch-track': ({ theme: theme })=>theme.applyStyles('light', {
                                opacity: 0.7
                            }) || {
                                opacity: 0.3
                            }
                    },
                    thumb: {
                        boxSizing: 'border-box',
                        width: 16,
                        height: 16,
                        boxShadow: 'none'
                    },
                    track: ({ theme: theme })=>({
                            borderRadius: 13,
                            ...theme.applyStyles('light', {
                                backgroundColor: '#E9E9EA'
                            }),
                            ...theme.applyStyles('dark', {
                                backgroundColor: '#39393D'
                            }),
                            opacity: 1,
                            transition: baseTheme.transitions.create([
                                'background-color'
                            ], {
                                duration: 500
                            })
                        })
                }
            },
            MuiLink: {
                defaultProps: {
                    underline: 'none'
                }
            },
            MuiSelect: {
                styleOverrides: {
                    select: ({ theme: theme })=>theme.applyStyles('light', {
                            backgroundColor: 'white'
                        })
                },
                defaultProps: {
                    size: 'small'
                }
            },
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        padding: 0
                    }
                }
            },
            MuiButtonGroup: {
                defaultProps: {
                    disableElevation: true
                }
            },
            MuiBackdrop: {
                styleOverrides: {
                    root: ({ theme: theme })=>({
                            backgroundColor: (0, $iD7Z3.colors).richBlack + '99',
                            ...theme.applyStyles('dark', {
                                backgroundColor: "#00000099"
                            })
                        })
                }
            },
            MuiRadio: {
                defaultProps: {
                    disableRipple: true,
                    size: 'medium'
                },
                styleOverrides: {
                    root: ()=>({
                            padding: 0,
                            '& .MuiSvgIcon-root': {
                                fontSize: 22
                            }
                        })
                }
            }
        }
    });
    return theme;
};
const $b911f7f44adb450d$export$bca14c5b3b88a9c9 = $b911f7f44adb450d$var$getTheme();



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");


var $bXtHQ = parcelRequire("bXtHQ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $05516f934f879d28$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $bXtHQ.default) in themeInput ? themeInput[0, $bXtHQ.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $bXtHQ.default) : undefined,
        theme: scopedTheme || themeInput
    });
}




var $bXtHQ = parcelRequire("bXtHQ");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $cc8cea264685552f$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $acw62.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $bXtHQ.default) in theme ? theme[0, $bXtHQ.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05516f934f879d28$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cfa43f235c6b12b8$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}




var $acw62 = parcelRequire("acw62");


var $acXqa = parcelRequire("acXqa");

var $2nO41 = parcelRequire("2nO41");

var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $888b8a9d3c5d3650$var$isDynamicSupport = typeof (0, $acXqa.globalCss)({}) === 'function';
const $888b8a9d3c5d3650$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $888b8a9d3c5d3650$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $888b8a9d3c5d3650$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $888b8a9d3c5d3650$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$888b8a9d3c5d3650$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $888b8a9d3c5d3650$var$SELECTOR = 'mui-ecs';
const $888b8a9d3c5d3650$var$staticStyles = (theme)=>{
    const result = $888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$888b8a9d3c5d3650$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $888b8a9d3c5d3650$var$GlobalStyles = (0, $acXqa.globalCss)($888b8a9d3c5d3650$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$888b8a9d3c5d3650$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $888b8a9d3c5d3650$var$CssBaseline(inProps) {
    const props = (0, $2nO41.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            $888b8a9d3c5d3650$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($888b8a9d3c5d3650$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$888b8a9d3c5d3650$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $888b8a9d3c5d3650$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $888b8a9d3c5d3650$export$2e2bcd8739ae039 = $888b8a9d3c5d3650$var$CssBaseline;


const $072c976f5b4c17c2$export$d8964aec282183a3 = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $cc8cea264685552f$export$2e2bcd8739ae039), {
        theme: (0, $b911f7f44adb450d$export$bca14c5b3b88a9c9),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $888b8a9d3c5d3650$export$2e2bcd8739ae039), {}),
            children
        ]
    });





var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("jHTLJ");
var $4hUQH = parcelRequire("4hUQH");

var $3OncY = parcelRequire("3OncY");

var $a1McR = parcelRequire("a1McR");

var $cMZil = parcelRequire("cMZil");

var $1Jwr0 = parcelRequire("1Jwr0");
const $01ad0b73f9df3fa4$export$6f57813fe9f31bf9 = (0, $a1McR.configureStore)({
    reducer: {
        connected: (0, $cMZil.connectedSlice).reducer,
        variables: (0, $1Jwr0.variablesSlice).reducer
    },
    devTools: true
});



var $ayMG0 = parcelRequire("ayMG0");

var $4mI0b = parcelRequire("4mI0b");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $24LEk = parcelRequire("24LEk");
parcelRequire("cdz9f");
var $cMZil = parcelRequire("cMZil");
var $1Jwr0 = parcelRequire("1Jwr0");

var $2lSXC = parcelRequire("2lSXC");
const $a02d18e75df479ce$export$288dc404b8791d6b = ({ children: children })=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    const isReady = (0, $2lSXC.useSelector)(({ variables: variables })=>Boolean(Object.keys(variables).length));
    (0, $acw62.useEffect)(()=>{
        const connect = ()=>dispatch((0, $cMZil.connectedSet)(true));
        const disconnect = ()=>dispatch((0, $cMZil.connectedSet)(false));
        const onStoreSnapshot = ({ store: store })=>dispatch((0, $1Jwr0.variablesSnapshot)(store));
        const onStoreChange = ({ payload: payload })=>{
            dispatch((0, $1Jwr0.variablesSet)(payload));
        };
        (0, $24LEk.socket).on('connect', connect);
        (0, $24LEk.socket).on('disconnect', disconnect);
        (0, $24LEk.socket).on('store:snapshot', onStoreSnapshot);
        (0, $24LEk.socket).on('store:change', onStoreChange);
        return ()=>{
            (0, $24LEk.socket).off('connect', connect);
            (0, $24LEk.socket).on('disconnect', disconnect);
            (0, $24LEk.socket).off('store:snapshot', onStoreSnapshot);
            (0, $24LEk.socket).off('store:change', onStoreChange);
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: isReady ? children : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4mI0b.default), {
            sx: {
                display: 'block',
                mx: 'auto',
                mt: 4
            }
        })
    });
};


const $41b4449239fbb1e6$export$3b5c74f3f11c675d = ({ children: children })=>{
    if (0, $3OncY.IS_DEMO) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4hUQH.default), {
        store: (0, $01ad0b73f9df3fa4$export$6f57813fe9f31bf9),
        children: children
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4hUQH.default), {
        store: (0, $01ad0b73f9df3fa4$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a02d18e75df479ce$export$288dc404b8791d6b), {
            children: children
        })
    });
};



var $iH29s = parcelRequire("iH29s");


var $ayMG0 = parcelRequire("ayMG0");

var $klPA2 = parcelRequire("klPA2");
var $03kOd = parcelRequire("03kOd");
var $1DAbm = parcelRequire("1DAbm");
var $ngrp2 = parcelRequire("ngrp2");
var $7X4mk = parcelRequire("7X4mk");

var $acw62 = parcelRequire("acw62");
class $a07dc17db895a23c$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error boundary caught an error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: this.props.fallback
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1DAbm.default), {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ngrp2.default), {
                    className: "error-boundary",
                    sx: {
                        pt: 4,
                        maxWidth: 'sm',
                        mx: 'auto',
                        textAlign: 'center',
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "h1",
                            children: "Na str\xe1nce do\u0161lo k chyb\u011B."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7X4mk.default), {
                            variant: "h4",
                            children: "Zkuste str\xe1nku obnovit."
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $klPA2.default), {
                            sx: {
                                mt: 2
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03kOd.default), {
                                variant: "contained",
                                onClick: ()=>window.location.href = '/',
                                children: "Obnovit str\xe1nku"
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: this.props.children
        });
    }
}



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
const $cee6656972e1ba4f$export$a6660e0e456ad69b = (targetOrigin = '*')=>{
    (0, $acw62.useEffect)(()=>{
        const isInIframe = window.self !== window.top;
        if (!isInIframe) return;
        if (!('ResizeObserver' in window)) {
            console.warn('ResizeObserver is not supported in this browser.');
            return;
        }
        const resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const payload = {
                    type: 'IFRAME_RESIZE',
                    height: entry.contentRect.height,
                    width: entry.contentRect.width,
                    timestamp: Date.now()
                };
                window.parent.postMessage(payload, targetOrigin);
            }
        });
        resizeObserver.observe(document.body);
        return ()=>resizeObserver.disconnect();
    }, [
        targetOrigin
    ]);
};
const $cee6656972e1ba4f$export$feeaa539b82e2377 = ({ children: children })=>{
    $cee6656972e1ba4f$export$a6660e0e456ad69b();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children
    });
};



const $9f00c30217b4412f$var$devMode = false;
// const scriptUrl = 'http://localhost:8080/app-web-notifications.js';
const $9f00c30217b4412f$var$scriptUrl = 'https://app.infigy.cz/portal-assets/app-web-notifications.js';
const $9f00c30217b4412f$var$shouldLoadScript = window.location.href.includes('app.infigy.cz') || $9f00c30217b4412f$var$devMode;
if ($9f00c30217b4412f$var$shouldLoadScript) {
    const script = document.createElement('script');
    script.src = $9f00c30217b4412f$var$scriptUrl;
    script.async = true;
    document.head.appendChild(script);
}


/**
 * Loads the portal-tools bundle: a cloud-hosted script that renders portal-only
 * features (currently the Figgy AI chat bubble) inside the portal-proxied device
 * UI. This is a dumb, contract-free loader — it only injects the script and never
 * needs to change again; all feature logic lives in the cloud bundle
 * (app-portal-tools.js), which self-mounts and self-gates. Mirrors
 * ./web-notifications. Reuse this same wire for future portal↔cloud FE features.
 */ const $ed7b4e2d9563aa11$var$devMode = false;
const $ed7b4e2d9563aa11$var$cacheBust = `?t=${Date.now()}`;
const $ed7b4e2d9563aa11$var$scriptUrl = `/portal-assets/app-portal-tools.js${$ed7b4e2d9563aa11$var$cacheBust}`;
const $ed7b4e2d9563aa11$var$shouldLoadScript = window.location.href.includes('app.infigy.cz') || $ed7b4e2d9563aa11$var$devMode;
if ($ed7b4e2d9563aa11$var$shouldLoadScript) {
    const script = document.createElement('script');
    script.src = $ed7b4e2d9563aa11$var$scriptUrl;
    script.async = true;
    document.head.appendChild(script);
}


const $a88ea9323d3a23c8$export$861edd1ccea2f746 = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $072c976f5b4c17c2$export$d8964aec282183a3), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a07dc17db895a23c$export$e926676385687eaf), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41b4449239fbb1e6$export$3b5c74f3f11c675d), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9fa8a06396ffe454$export$d07e18ad7fac0edc), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iH29s.TrpcProvider), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                            adapterLocale: (0, $de8c05b32292e2b0$export$2e2bcd8739ae039),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jDfxe.ConfirmProvider), {
                                useLegacyReturn: true,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cee6656972e1ba4f$export$feeaa539b82e2377), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lzNIT.BrowserRouter), {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $043f87f23fd0da03$export$55185c17a0fcbe46), {})
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};


const $6840e8b44f75a905$var$container = document.getElementById('app');
if (!$6840e8b44f75a905$var$container) throw new Error('Root container #app not found');
const $6840e8b44f75a905$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($6840e8b44f75a905$var$container);
$6840e8b44f75a905$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $a88ea9323d3a23c8$export$861edd1ccea2f746), {}));


//# sourceMappingURL=client.e50d7d5c.js.map
